import * as React from "react";

import { IconSvgProps } from "@/types";

export const PathwayFullLogo: React.FC<IconSvgProps> = ({ size, width, height, ...props }) => {
  return (
    <svg
      data-name="Layer 1"
      height={200}
      id="Layer_1"
      viewBox="0 0 1920 1080"
      width={450}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <style>
          {
            "\n      .cls-1 {\n        font-family: Poppins-ExtraBold, Poppins;\n        font-size: 168.31px;\n        font-weight: 700;\n      }\n    "
          }
        </style>
      </defs>
      <g fill="#FF6B36">
        <path d="M490.63,324.28c-117.51,0-212.74,95.24-212.74,212.74,0,117.51,95.24,212.74,212.74,212.74,117.51,0,212.74-95.24,212.74-212.74,0-117.5-95.24-212.74-212.74-212.74ZM490.63,717.22c-99.56,0-180.27-80.7-180.27-180.2,0-99.56,80.7-180.26,180.27-180.26,99.56,0,180.26,80.7,180.26,180.26,0,99.5-80.7,180.2-180.26,180.2Z" />
        <path d="M608.56,639.22l-107.15-255.58c-1.84-4.32-6.1-7.16-10.78-7.16-4.68,0-8.94,2.84-10.78,7.16l-107.15,255.58c-1.99,4.82-.64,10.35,3.4,13.62,4.04,3.26,9.72,3.47,13.97.5l76.66-53.04v-58.79c0-1.7.21-3.47.64-5.25,1.99-8.65,8.72-15.03,16.81-17.16,3.48-.85,12.99-.12,13.55,0,5.44,1.17,15.74,7.09,15.74,15.74v64.74s77.72,53.75,77.72,53.75c4.25,2.98,9.93,2.76,13.97-.5.28-.28.64-.57.92-.85,3.26-3.33,4.33-8.37,2.48-12.76ZM489.99,513.06c-12.91-.07-23.33-10.57-23.26-23.47.07-12.91,10.57-23.33,23.47-23.26,12.91.07,23.33,10.56,23.26,23.47-.07,12.91-10.57,23.33-23.47,23.26Z" />
      </g>
      <text className="cls-1" fill="currentColor" transform="translate(786.58 493.14)">
        <tspan x={0} y={0}>
          {"Pathway"}
        </tspan>
        <tspan x={0} y={158.9}>
          {"Platform"}
        </tspan>
      </text>
    </svg>
  );
};

export const IconLoading: React.FC<IconSvgProps> = ({ size, width, height, ...props }) => {
  return (
    <svg
      className="animate-spin h-10 w-10 text-violet-600"
      fill="none"
      height={size || height}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="#d3d3d3" strokeWidth="4" />
      <path className="opacity-75" d="M4 12a8 8 0 018-8v8H4z" fill="#d3d3d3" />
    </svg>
  );
};

export const DataHubIcon: React.FC<IconSvgProps> = ({ size, width, height, ...props }) => {
  return (
    <svg
      height={size || height}
      viewBox="0 0 1419.1 425.5"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="M588.3,185l-37.2-52v52h-33v-118.7h33v51.2l36.9-51.2h38l-43.6,57.6,45.8,61.1h-39.9Z"
          fill="currentColor"
        />
        <path
          d="M719.6,100.6c6.4,7.2,9.6,17,9.6,29.4v55h-33v-50.7c0-5.4-1.4-9.6-4.2-12.7-2.8-3.1-6.6-4.6-11.3-4.6s-8.8,1.5-11.6,4.6c-2.8,3.1-4.2,7.3-4.2,12.7v50.7h-33v-94.4h33v13.5c2.9-4.3,6.8-7.7,11.8-10.4,4.9-2.6,10.6-4,17-4,10.9,0,19.5,3.6,25.9,10.9Z"
          fill="currentColor"
        />
        <path
          d="M757.5,180.3c-7.5-3.9-13.3-9.5-17.6-16.8-4.3-7.3-6.4-15.9-6.4-25.8s2.2-18.3,6.5-25.6c4.3-7.3,10.2-12.9,17.7-16.8,7.5-3.9,15.9-5.9,25.3-5.9s17.9,2,25.3,5.9c7.5,3.9,13.4,9.5,17.7,16.8,4.3,7.3,6.5,15.8,6.5,25.6s-2.2,18.3-6.5,25.7c-4.3,7.4-10.2,13-17.8,16.9-7.5,3.9-16,5.9-25.4,5.9s-17.9-2-25.3-5.9ZM794.4,152.4c3.1-3.4,4.6-8.3,4.6-14.7s-1.5-11.3-4.6-14.6c-3.1-3.4-6.9-5-11.4-5s-8.2,1.7-11.3,5c-3,3.4-4.5,8.2-4.5,14.6s1.5,11.4,4.4,14.8c2.9,3.4,6.7,5,11.3,5s8.4-1.7,11.5-5.1Z"
          fill="currentColor"
        />
        <path
          d="M977.1,90.6l-24.1,94.4h-37l-13.1-57.2-13.6,57.2h-36.9l-23.9-94.4h32.8l10.6,62.6,14-62.6h35.3l14.5,62.8,10.4-62.8h31Z"
          fill="currentColor"
        />
        <path d="M1011.1,60.4v124.6h-33V60.4h33Z" fill="currentColor" />
        <path
          d="M1111.2,144.4h-62.4c.3,5.2,1.8,9,4.3,11.5,2.5,2.5,5.7,3.8,9.7,3.8s9.4-2.5,11.8-7.4h35.2c-1.5,6.5-4.3,12.3-8.5,17.4-4.2,5.1-9.5,9.1-15.9,12-6.4,2.9-13.5,4.4-21.2,4.4s-17.6-2-24.8-5.9c-7.2-3.9-12.9-9.5-17-16.8-4.1-7.3-6.1-15.9-6.1-25.8s2-18.4,6.1-25.7c4-7.2,9.7-12.8,16.9-16.7,7.2-3.9,15.6-5.9,25-5.9s17.6,1.9,24.7,5.7c7.2,3.8,12.8,9.3,16.8,16.4,4,7.1,6.1,15.5,6.1,25.2s-.2,5.2-.5,7.7ZM1078.1,128.4c0-4-1.3-7.2-4-9.5-2.7-2.3-6.1-3.5-10.1-3.5s-7.4,1.1-9.9,3.3c-2.6,2.2-4.3,5.4-5,9.7h29.1Z"
          fill="currentColor"
        />
        <path
          d="M1116.7,112.1c3.5-7.3,8.4-12.9,14.6-16.8,6.2-3.9,13-5.9,20.5-5.9s11.5,1.3,16.2,3.8c4.8,2.5,8.5,6,11.2,10.4v-43.1h33.2v124.6h-33.2v-13.1c-2.6,4.4-6.2,7.9-10.9,10.4-4.7,2.6-10.3,3.9-16.7,3.9s-14.3-2-20.4-5.9c-6.1-3.9-10.9-9.6-14.5-16.9-3.5-7.3-5.3-15.9-5.3-25.7s1.8-18.3,5.3-25.6ZM1174.4,123.4c-3.3-3.5-7.4-5.2-12.2-5.2s-9,1.7-12.3,5.1c-3.3,3.4-4.9,8.2-4.9,14.4s1.6,10.9,4.9,14.4c3.3,3.5,7.3,5.3,12.3,5.3s8.9-1.7,12.2-5.2c3.3-3.5,5-8.3,5-14.5s-1.7-10.8-5-14.3Z"
          fill="currentColor"
        />
        <path
          d="M1274.4,93.3c4.8,2.6,8.4,6.1,11,10.4v-13.1h33v93.4c0,8.9-1.7,16.9-5,24-3.4,7.1-8.6,12.8-15.7,17.1-7.1,4.3-16.1,6.4-27,6.4s-26.3-3.4-35-10.3c-8.8-6.8-13.7-16.2-15-27.9h32.5c.7,3,2.4,5.4,5,7.1,2.7,1.7,6.2,2.5,10.4,2.5,11.2,0,16.8-6.3,16.8-18.9v-12.1c-2.6,4.4-6.3,7.9-11,10.4-4.8,2.6-10.4,3.9-16.7,3.9s-14.3-2-20.4-5.9c-6.1-3.9-10.9-9.6-14.5-16.9-3.5-7.3-5.3-15.9-5.3-25.7s1.8-18.3,5.3-25.6c3.5-7.3,8.4-12.9,14.5-16.8,6.1-3.9,12.9-5.9,20.4-5.9s12,1.3,16.7,3.9ZM1280.5,123.4c-3.3-3.5-7.4-5.2-12.2-5.2s-9,1.7-12.3,5.1c-3.3,3.4-4.9,8.2-4.9,14.4s1.6,10.9,4.9,14.4c3.3,3.5,7.3,5.3,12.3,5.3s8.9-1.7,12.2-5.2c3.3-3.5,5-8.3,5-14.5s-1.7-10.8-5-14.3Z"
          fill="currentColor"
        />
        <path
          d="M1418.6,144.4h-62.4c.3,5.2,1.8,9,4.3,11.5,2.5,2.5,5.7,3.8,9.7,3.8s9.4-2.5,11.8-7.4h35.2c-1.5,6.5-4.3,12.3-8.5,17.4-4.2,5.1-9.5,9.1-15.9,12-6.4,2.9-13.5,4.4-21.2,4.4s-17.6-2-24.8-5.9c-7.2-3.9-12.9-9.5-17-16.8-4.1-7.3-6.1-15.9-6.1-25.8s2-18.4,6.1-25.7c4-7.2,9.7-12.8,16.9-16.7,7.2-3.9,15.6-5.9,25-5.9s17.6,1.9,24.7,5.7c7.2,3.8,12.8,9.3,16.8,16.4,4,7.1,6.1,15.5,6.1,25.2s-.2,5.2-.5,7.7ZM1385.4,128.4c0-4-1.3-7.2-4-9.5-2.7-2.3-6.1-3.5-10.1-3.5s-7.4,1.1-9.9,3.3c-2.6,2.2-4.3,5.4-5,9.7h29.1Z"
          fill="currentColor"
        />
        <path
          d="M624.3,245.2v118.7h-33v-47.6h-40.2v47.6h-33v-118.7h33v44.6h40.2v-44.6h33Z"
          fill="currentColor"
        />
        <path
          d="M731.4,269.5v94.4h-33.2v-13.5c-2.8,4.3-6.7,7.7-11.6,10.4-4.9,2.6-10.6,4-17,4-11,0-19.7-3.6-26-10.9-6.3-7.2-9.5-17.1-9.5-29.5v-54.9h32.8v50.7c0,5.4,1.4,9.6,4.3,12.7,2.9,3.1,6.6,4.6,11.4,4.6s8.6-1.5,11.4-4.6c2.8-3.1,4.2-7.3,4.2-12.7v-50.7h33.2Z"
          fill="currentColor"
        />
        <path
          d="M785.7,272.1c4.7-2.5,10.3-3.8,16.7-3.8s14.3,2,20.5,5.9c6.1,3.9,10.9,9.5,14.5,16.8,3.5,7.3,5.3,15.8,5.3,25.6s-1.8,18.3-5.3,25.7c-3.5,7.4-8.4,13-14.5,16.9-6.1,3.9-12.9,5.9-20.5,5.9s-12-1.3-16.7-3.8c-4.7-2.5-8.4-6-10.9-10.5v13.1h-33v-124.6h33v43.3c2.6-4.5,6.2-8,10.9-10.5ZM804.2,302.2c-3.3-3.4-7.4-5.1-12.2-5.1s-8.9,1.7-12.2,5.2c-3.3,3.5-5,8.2-5,14.3s1.7,11,5,14.5c3.3,3.5,7.4,5.2,12.2,5.2s8.9-1.8,12.2-5.3c3.3-3.5,5-8.3,5-14.4s-1.7-11-5-14.4Z"
          fill="currentColor"
        />
        <path
          d="M212.8,0C95.4,0,0,95.4,0,212.7s95.4,212.8,212.8,212.8,212.7-95.4,212.7-212.8S330.1,0,212.8,0ZM282.9,379c-21.5,9.1-45.2,14.1-70.1,14.1-99.7,0-180.5-80.8-180.5-180.5S82.8,66.9,153.3,42.4h0c18.6-6.5,38.6-10.1,59.4-10.1,99.6,0,180.4,80.8,180.4,180.4s-45.5,138.9-110.3,166.3Z"
          fill="currentColor"
        />
        <path
          d="M307,114.3l-85.7,81.5s91.9,103.2,92.3,103.2c24.8-35.3,35.4-63.3,35.4-86.3,0-38.7-16.1-73.6-42.1-98.3Z"
          fill="currentColor"
        />
        <path
          d="M162.9,174c3.4-2.6,8.9-7.8,12.3-10.8,22.6-20.8,43.9-43.2,67.2-63.3h46.8c-20.1-13.8-44.3-22.3-70.3-23.5h-.9c-10.6,0-21.1,1.4-32.5,2.7h0c-17.6-14.7-26.6-21.2-26.6-21.2v118.1c2.4.6,2.8-1,4.1-2Z"
          fill="currentColor"
        />
        <path
          d="M99.6,136.7c-14.5,21.6-23.1,47.8-23.1,75.9s9.5,57.3,25.8,79.7c.2.3.5.5.7.7v-160.5c-1.1,1.3-2.2,2.7-3.2,4,0,0,0,.2-.2.2Z"
          fill="currentColor"
        />
        <path
          d="M162.2,227c-2.1.9-3.4,2.9-3.4,5.2v133.3c0,2.5,1.7,4.7,4.1,5.4,2.4.7,5-.3,6.3-2.4l31.6-49.6,57.6,12.2c2.4.5,4.9-.6,6.1-2.8,0-.2.2-.4.2-.5.9-2.1.4-4.5-1.3-6.1l-95.1-93.4c-1.6-1.6-4-2-6.1-1.2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const DataHubFullIcon: React.FC<IconSvgProps> = ({ size, width, height, ...props }) => {
  return (
    <svg
      height={size || height}
      viewBox="150.19 139.23 685.63 744.14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="M540.03,139.23c-102.07,0-185.05,82.98-185.05,184.98s82.98,185.05,185.05,185.05,184.98-82.98,184.98-185.05-82.98-184.98-184.98-184.98ZM600.99,468.86c-18.72,7.89-39.29,12.3-60.96,12.3-86.71,0-156.95-70.23-156.95-156.95,0-68.53,43.94-126.78,105.2-148.13h.08c16.17-5.65,33.57-8.74,51.67-8.74,86.63,0,156.87,70.23,156.87,156.87,0,65.05-39.53,120.82-95.91,144.65Z"
          fill="currentColor"
        />
        <g>
          <path
            d="M621.96,238.6l-74.49,70.84s79.88,89.72,80.31,89.72c21.58-30.67,30.77-55.07,30.77-75.05,0-33.63-14.04-64.03-36.58-85.51Z"
            fill="currentColor"
          />
          <path
            d="M496.64,290.55c2.95-2.25,7.72-6.74,10.68-9.41,19.65-18.11,38.19-37.56,58.48-55.04h40.73c-17.48-12.01-38.54-19.38-61.15-20.43h-.78c-9.2.07-18.39,1.19-28.29,2.32h-.07c-15.3-12.78-23.17-18.39-23.17-18.39v102.71c2.11.56,2.39-.84,3.58-1.75Z"
            fill="currentColor"
          />
          <path
            d="M441.61,258.12c-12.64,18.82-20.08,41.56-20.08,66,0,25.91,8.28,49.85,22.4,69.29.21.28.42.42.63.63v-139.57c-.98,1.12-1.9,2.32-2.81,3.44,0,.07-.07.14-.13.21Z"
            fill="currentColor"
          />
        </g>
        <path
          d="M496.04,336.69c-1.82.76-2.99,2.54-2.99,4.5l.03,115.94c0,2.17,1.43,4.07,3.52,4.68,2.08.61,4.31-.23,5.48-2.06l27.52-43.13,50.06,10.57c2.12.45,4.28-.55,5.31-2.46.08-.15.15-.31.21-.46.74-1.82.33-3.93-1.1-5.33l-82.72-81.24c-1.4-1.37-3.49-1.77-5.3-1.01Z"
          fill="currentColor"
        />
      </g>
      <text
        fill="currentColor"
        style={{
          fontFamily: "Poppins",
          fontSize: "168.31px",
          fontWeight: "300",
        }}
        transform="translate(150.19 687.35)"
      >
        <tspan x="0" y="0">
          Knowledge
        </tspan>
        <tspan x="245.67" y="165.02">
          Hub
        </tspan>
      </text>
    </svg>
  );
};

export const NavigatorIcon: React.FC<IconSvgProps> = ({ size, width, height, ...props }) => {
  return (
    <svg
      height={size || height}
      viewBox="0 0 1679.8 425.5"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="M628,169.3h-33l-43.9-66.3v66.3h-33V50.7h33l43.9,67.2V50.7h33v118.7Z"
          fill="currentColor"
        />
        <path
          d="M638.4,96.4c3.5-7.3,8.4-12.9,14.5-16.8,6.1-3.9,12.9-5.9,20.4-5.9s12.1,1.3,16.8,3.9c4.7,2.6,8.4,6.1,10.9,10.4v-13.1h33v94.4h-33v-13.1c-2.6,4.4-6.3,7.9-11,10.4-4.8,2.6-10.4,3.9-16.7,3.9s-14.3-2-20.4-5.9c-6.1-3.9-10.9-9.6-14.5-16.9-3.5-7.3-5.3-15.9-5.3-25.7s1.8-18.3,5.3-25.6ZM696.1,107.7c-3.3-3.5-7.4-5.2-12.2-5.2s-9,1.7-12.3,5.1c-3.3,3.4-4.9,8.2-4.9,14.4s1.6,10.9,4.9,14.4c3.3,3.5,7.3,5.3,12.3,5.3s8.9-1.7,12.2-5.2c3.3-3.5,5-8.3,5-14.5s-1.7-10.8-5-14.3Z"
          fill="currentColor"
        />
        <path
          d="M789.8,138.2l17.7-63.3h35.2l-32.5,94.4h-41.1l-32.5-94.4h35.2l18,63.3Z"
          fill="currentColor"
        />
        <path
          d="M847.9,61.4c-3.5-3.2-5.3-7.2-5.3-12s1.8-9,5.3-12.3c3.5-3.3,8.2-4.9,14.1-4.9s10.4,1.6,13.9,4.9c3.5,3.3,5.3,7.4,5.3,12.3s-1.8,8.8-5.3,12c-3.5,3.2-8.2,4.8-13.9,4.8s-10.5-1.6-14.1-4.8ZM878.3,74.9v94.4h-33v-94.4h33Z"
          fill="currentColor"
        />
        <path
          d="M940.3,77.6c4.8,2.6,8.4,6.1,11,10.4v-13.1h33v93.4c0,8.9-1.7,16.9-5,24-3.4,7.1-8.6,12.8-15.7,17.1-7.1,4.3-16.1,6.4-27,6.4s-26.3-3.4-35-10.3c-8.8-6.8-13.7-16.2-15-27.9h32.5c.7,3,2.4,5.4,5,7.1,2.7,1.7,6.2,2.5,10.4,2.5,11.2,0,16.8-6.3,16.8-18.9v-12.1c-2.6,4.4-6.3,7.9-11,10.4-4.8,2.6-10.4,3.9-16.7,3.9s-14.3-2-20.4-5.9c-6.1-3.9-10.9-9.6-14.5-16.9-3.5-7.3-5.3-15.9-5.3-25.7s1.8-18.3,5.3-25.6c3.5-7.3,8.4-12.9,14.5-16.8,6.1-3.9,12.9-5.9,20.4-5.9s12,1.3,16.7,3.9ZM946.4,107.7c-3.3-3.5-7.4-5.2-12.2-5.2s-9,1.7-12.3,5.1c-3.3,3.4-4.9,8.2-4.9,14.4s1.6,10.9,4.9,14.4c3.3,3.5,7.3,5.3,12.3,5.3s8.9-1.7,12.2-5.2c3.3-3.5,5-8.3,5-14.5s-1.7-10.8-5-14.3Z"
          fill="currentColor"
        />
        <path
          d="M994.7,96.4c3.5-7.3,8.4-12.9,14.5-16.8,6.1-3.9,12.9-5.9,20.4-5.9s12.1,1.3,16.8,3.9c4.7,2.6,8.4,6.1,10.9,10.4v-13.1h33v94.4h-33v-13.1c-2.6,4.4-6.3,7.9-11,10.4-4.8,2.6-10.4,3.9-16.7,3.9s-14.3-2-20.4-5.9c-6.1-3.9-10.9-9.6-14.5-16.9-3.5-7.3-5.3-15.9-5.3-25.7s1.8-18.3,5.3-25.6ZM1052.4,107.7c-3.3-3.5-7.4-5.2-12.2-5.2s-9,1.7-12.3,5.1c-3.3,3.4-4.9,8.2-4.9,14.4s1.6,10.9,4.9,14.4c3.3,3.5,7.3,5.3,12.3,5.3s8.9-1.7,12.2-5.2c3.3-3.5,5-8.3,5-14.5s-1.7-10.8-5-14.3Z"
          fill="currentColor"
        />
        <path
          d="M1156.5,141.2v28.1h-14.3c-24.1,0-36.2-12-36.2-35.9v-31.1h-11.6v-27.4h11.6v-22.9h33.2v22.9h17.2v27.4h-17.2v31.6c0,2.6.6,4.4,1.8,5.6,1.2,1.1,3.2,1.7,6,1.7h9.6Z"
          fill="currentColor"
        />
        <path
          d="M1181.9,164.6c-7.5-3.9-13.3-9.5-17.6-16.8-4.3-7.3-6.4-15.9-6.4-25.8s2.2-18.3,6.5-25.6c4.3-7.3,10.2-12.9,17.7-16.8,7.5-3.9,15.9-5.9,25.3-5.9s17.9,2,25.3,5.9c7.5,3.9,13.4,9.5,17.7,16.8,4.3,7.3,6.5,15.8,6.5,25.6s-2.2,18.3-6.5,25.7c-4.3,7.4-10.2,13-17.8,16.9-7.5,3.9-16,5.9-25.4,5.9s-17.9-2-25.3-5.9ZM1218.7,136.8c3.1-3.4,4.6-8.3,4.6-14.7s-1.5-11.3-4.6-14.6c-3.1-3.4-6.9-5-11.4-5s-8.2,1.7-11.3,5c-3,3.4-4.5,8.2-4.5,14.6s1.5,11.4,4.4,14.8c2.9,3.4,6.7,5,11.3,5s8.4-1.7,11.5-5.1Z"
          fill="currentColor"
        />
        <path
          d="M1308.3,78.8c5.3-3.1,10.9-4.7,17-4.7v35.2h-9.3c-7.2,0-12.5,1.4-16,4.2-3.5,2.8-5.2,7.7-5.2,14.6v41.2h-33v-94.4h33v16.7c3.7-5.4,8.2-9.6,13.5-12.8Z"
          fill="currentColor"
        />
        <path
          d="M606.9,288.7c-3.3,5.9-8.3,10.6-15,14.1-6.7,3.5-14.8,5.3-24.5,5.3h-16.3v40.1h-33v-118.7h49.3c9.5,0,17.6,1.7,24.3,5,6.7,3.4,11.7,8,15.1,14,3.4,5.9,5,12.8,5,20.5s-1.7,13.7-5,19.6ZM578.2,269.1c0-8.6-4.7-13-14-13h-13.1v25.8h13.1c9.3,0,14-4.3,14-12.8Z"
          fill="currentColor"
        />
        <path
          d="M663.2,257.7c5.3-3.1,10.9-4.7,17-4.7v35.2h-9.3c-7.2,0-12.5,1.4-16,4.2-3.5,2.8-5.2,7.7-5.2,14.6v41.2h-33v-94.4h33v16.7c3.7-5.4,8.2-9.6,13.5-12.8Z"
          fill="currentColor"
        />
        <path
          d="M702.2,343.5c-7.5-3.9-13.3-9.5-17.6-16.8-4.3-7.3-6.4-15.9-6.4-25.8s2.2-18.3,6.5-25.6c4.3-7.3,10.2-12.9,17.7-16.8,7.5-3.9,15.9-5.9,25.3-5.9s17.9,2,25.3,5.9c7.5,3.9,13.4,9.5,17.7,16.8,4.3,7.3,6.5,15.8,6.5,25.6s-2.2,18.3-6.5,25.7c-4.3,7.4-10.2,13-17.8,16.9-7.5,3.9-16,5.9-25.4,5.9s-17.9-2-25.3-5.9ZM739,315.7c3.1-3.4,4.6-8.3,4.6-14.7s-1.5-11.3-4.6-14.6c-3.1-3.4-6.9-5-11.4-5s-8.2,1.7-11.3,5c-3,3.4-4.5,8.2-4.5,14.6s1.5,11.4,4.4,14.8c2.9,3.4,6.7,5,11.3,5s8.4-1.7,11.5-5.1Z"
          fill="currentColor"
        />
        <path
          d="M933.6,263.7c6.8,7.2,10.2,17,10.2,29.5v55h-33v-50.7c0-5-1.4-9-4.2-11.8-2.8-2.8-6.6-4.2-11.4-4.2s-8.6,1.4-11.4,4.2c-2.8,2.8-4.2,6.7-4.2,11.8v50.7h-33v-50.7c0-5-1.4-9-4.1-11.8-2.8-2.8-6.5-4.2-11.4-4.2s-8.8,1.4-11.6,4.2c-2.8,2.8-4.2,6.7-4.2,11.8v50.7h-33v-94.4h33v12.5c2.9-4,6.7-7.3,11.4-9.7,4.7-2.4,10-3.6,16.1-3.6s13.2,1.5,18.6,4.5c5.4,3,9.7,7.3,12.9,12.8,3.4-5.2,7.8-9.3,13.3-12.5,5.5-3.2,11.6-4.8,18.2-4.8,11.9,0,21.2,3.6,28,10.8Z"
          fill="currentColor"
        />
        <path
          d="M997.3,256.5c4.7-2.6,10.3-3.9,16.7-3.9s14.3,2,20.5,5.9c6.1,3.9,10.9,9.5,14.5,16.8,3.5,7.3,5.3,15.8,5.3,25.6s-1.8,18.3-5.3,25.7c-3.5,7.4-8.4,13-14.5,16.9-6.1,3.9-12.9,5.9-20.5,5.9s-11.9-1.3-16.6-3.9c-4.7-2.6-8.3-6.1-11-10.4v58.2h-33v-139.5h33v13.1c2.6-4.4,6.2-7.9,10.9-10.4ZM1015.7,286.5c-3.3-3.4-7.4-5.1-12.2-5.1s-8.9,1.7-12.2,5.2c-3.3,3.5-5,8.2-5,14.3s1.7,11,5,14.5c3.3,3.5,7.4,5.2,12.2,5.2s8.9-1.8,12.2-5.3c3.3-3.5,5-8.3,5-14.4s-1.7-11-5-14.4Z"
          fill="currentColor"
        />
        <path
          d="M1115.1,320.1v28.1h-14.3c-24.1,0-36.2-12-36.2-35.9v-31.1h-11.6v-27.4h11.6v-22.9h33.2v22.9h17.2v27.4h-17.2v31.6c0,2.6.6,4.4,1.8,5.6,1.2,1.1,3.2,1.7,6,1.7h9.6Z"
          fill="currentColor"
        />
        <path d="M1178.6,223.7v124.6h-33v-124.6h33Z" fill="currentColor" />
        <path
          d="M1191.6,240.3c-3.5-3.2-5.3-7.2-5.3-12s1.8-9,5.3-12.3c3.5-3.3,8.2-4.9,14.1-4.9s10.4,1.6,13.9,4.9c3.5,3.3,5.3,7.4,5.3,12.3s-1.8,8.8-5.3,12c-3.5,3.2-8.2,4.8-13.9,4.8s-10.5-1.6-14.1-4.8ZM1222,253.8v94.4h-33v-94.4h33Z"
          fill="currentColor"
        />
        <path
          d="M1276.4,256.4c4.7-2.5,10.3-3.8,16.7-3.8s14.3,2,20.5,5.9c6.1,3.9,10.9,9.5,14.5,16.8,3.5,7.3,5.3,15.8,5.3,25.6s-1.8,18.3-5.3,25.7c-3.5,7.4-8.4,13-14.5,16.9-6.1,3.9-12.9,5.9-20.5,5.9s-12-1.3-16.7-3.8c-4.7-2.5-8.4-6-10.9-10.5v13.1h-33v-124.6h33v43.3c2.6-4.5,6.2-8,10.9-10.5ZM1294.8,286.5c-3.3-3.4-7.4-5.1-12.2-5.1s-8.9,1.7-12.2,5.2c-3.3,3.5-5,8.2-5,14.3s1.7,11,5,14.5c3.3,3.5,7.4,5.2,12.2,5.2s8.9-1.8,12.2-5.3c3.3-3.5,5-8.3,5-14.4s-1.7-11-5-14.4Z"
          fill="currentColor"
        />
        <path
          d="M1384.9,257.7c5.3-3.1,10.9-4.7,17-4.7v35.2h-9.3c-7.2,0-12.5,1.4-16,4.2-3.5,2.8-5.2,7.7-5.2,14.6v41.2h-33v-94.4h33v16.7c3.7-5.4,8.2-9.6,13.5-12.8Z"
          fill="currentColor"
        />
        <path
          d="M1405.2,275.3c3.5-7.3,8.4-12.9,14.5-16.8,6.1-3.9,12.9-5.9,20.4-5.9s12.1,1.3,16.8,3.9c4.7,2.6,8.4,6.1,10.9,10.4v-13.1h33v94.4h-33v-13.1c-2.6,4.4-6.3,7.9-11,10.4-4.8,2.6-10.4,3.9-16.7,3.9s-14.3-2-20.4-5.9c-6.1-3.9-10.9-9.6-14.5-16.9-3.5-7.3-5.3-15.9-5.3-25.7s1.8-18.3,5.3-25.6ZM1462.9,286.6c-3.3-3.5-7.4-5.2-12.2-5.2s-9,1.7-12.3,5.1c-3.3,3.4-4.9,8.2-4.9,14.4s1.6,10.9,4.9,14.4c3.3,3.5,7.3,5.3,12.3,5.3s8.9-1.7,12.2-5.2c3.3-3.5,5-8.3,5-14.5s-1.7-10.8-5-14.3Z"
          fill="currentColor"
        />
        <path
          d="M1557.8,257.7c5.3-3.1,10.9-4.7,17-4.7v35.2h-9.3c-7.2,0-12.5,1.4-16,4.2-3.5,2.8-5.2,7.7-5.2,14.6v41.2h-33v-94.4h33v16.7c3.7-5.4,8.2-9.6,13.5-12.8Z"
          fill="currentColor"
        />
        <path
          d="M1679.8,253.8l-59.9,139.4h-35.9l22.6-49-38.7-90.4h36.7l19.9,53.5,19.2-53.5h36.2Z"
          fill="currentColor"
        />
        <path
          d="M424.8,212.8h.7c0,0-.7-.2-.7-.2C424.7,95.6,329.9.8,212.9.7V0c0,0-.2.8-.2.8C95.6.8.8,95.6.7,212.7H0c0,0,.7.2.7.2,0,117,94.9,211.9,211.9,211.9v.7c0,0,.2-.7.2-.7,117,0,211.9-94.9,211.9-211.9ZM216.9,392.6l12.7-101.8-16.9-11.7-16.9,11.7,12.8,101.8c-96.1-2.2-173.6-79.6-175.8-175.8l92.7,11.6,13.9-33.2-106.6,13.3c2.2-96.1,79.6-173.6,175.8-175.8l-5.3,42.2c3-.9,6.2-1.4,9.4-1.4h0c3.2,0,6.4.5,9.4,1.4l-5.3-42.2c96.1,2.2,173.6,79.6,175.8,175.8l-106.6-13.3,13.9,33.2,92.7-11.6c-2.2,96.1-79.6,173.6-175.8,175.8Z"
          fill="currentColor"
        />
        <path
          d="M220.5,104c-.6-1.5-1.7-2.8-3-3.7-1.4-.9-3-1.5-4.7-1.5h0c-3.2,0-6.1,1.9-7.5,4.8,0,.1-.2.3-.3.4l-36.8,87.6h0l-16.8,40.1h0l-23.9,57c-1.4,3.5-.4,7.4,2.5,9.8,2.9,2.4,7,2.5,10.1.4l52.3-36.2h0s20.4-14.1,20.4-14.1l14.3,9.9,58.3,40.4c3.1,2.1,7.2,2,10.1-.4.2-.2.4-.4.6-.6,2.4-2.4,3.1-6,1.8-9.2l-77.5-184.7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const AgentStudioLogo: React.FC<IconSvgProps> = ({ size, width, height, ...props }) => {
  return (
    <svg
      height={size || height}
      viewBox="0 0 1026.6 425.5"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="M593.2,162.7h-42.1l-6.4,19.4h-34.7l43.3-118.7h38l43.1,118.7h-34.8l-6.4-19.4ZM584.9,137.4l-12.8-38.4-12.6,38.4h25.4Z"
          fill="currentColor"
        />
        <path
          d="M688.4,90.3c4.8,2.6,8.4,6.1,11,10.4v-13.1h33v93.4c0,8.9-1.7,16.9-5,24-3.4,7.1-8.6,12.8-15.7,17.1-7.1,4.3-16.1,6.4-27,6.4s-26.3-3.4-35-10.3c-8.8-6.8-13.7-16.2-15-27.9h32.5c.7,3,2.4,5.4,5,7.1,2.7,1.7,6.2,2.5,10.4,2.5,11.2,0,16.8-6.3,16.8-18.9v-12.1c-2.6,4.4-6.3,7.9-11,10.4-4.8,2.6-10.4,3.9-16.7,3.9s-14.3-2-20.4-5.9c-6.1-3.9-10.9-9.6-14.5-16.9-3.5-7.3-5.3-15.9-5.3-25.7s1.8-18.3,5.3-25.6c3.5-7.3,8.4-12.9,14.5-16.8,6.1-3.9,12.9-5.9,20.4-5.9s12,1.3,16.7,3.9ZM694.4,120.4c-3.3-3.5-7.4-5.2-12.2-5.2s-9,1.7-12.3,5.1c-3.3,3.4-4.9,8.2-4.9,14.4s1.6,10.9,4.9,14.4c3.3,3.5,7.3,5.3,12.3,5.3s8.9-1.7,12.2-5.2c3.3-3.5,5-8.3,5-14.5s-1.7-10.8-5-14.3Z"
          fill="currentColor"
        />
        <path
          d="M832.5,141.5h-62.4c.3,5.2,1.8,9,4.3,11.5,2.5,2.5,5.7,3.8,9.7,3.8s9.4-2.5,11.8-7.4h35.2c-1.5,6.5-4.3,12.3-8.5,17.4-4.2,5.1-9.5,9.1-15.9,12-6.4,2.9-13.5,4.4-21.2,4.4s-17.6-2-24.8-5.9c-7.2-3.9-12.9-9.5-17-16.8-4.1-7.3-6.1-15.9-6.1-25.8s2-18.4,6.1-25.7c4-7.2,9.7-12.8,16.9-16.7,7.2-3.9,15.6-5.9,25-5.9s17.6,1.9,24.7,5.7c7.2,3.8,12.8,9.3,16.8,16.4,4,7.1,6.1,15.5,6.1,25.2s-.2,5.2-.5,7.7ZM799.4,125.5c0-4-1.3-7.2-4-9.5-2.7-2.3-6.1-3.5-10.1-3.5s-7.4,1.1-9.9,3.3c-2.6,2.2-4.3,5.4-5,9.7h29.1Z"
          fill="currentColor"
        />
        <path
          d="M925.8,97.6c6.4,7.2,9.6,17,9.6,29.4v55h-33v-50.7c0-5.4-1.4-9.6-4.2-12.7-2.8-3.1-6.6-4.6-11.3-4.6s-8.8,1.5-11.6,4.6c-2.8,3.1-4.2,7.3-4.2,12.7v50.7h-33v-94.4h33v13.5c2.9-4.3,6.8-7.7,11.8-10.4,4.9-2.6,10.6-4,17-4,10.9,0,19.5,3.6,25.9,10.9Z"
          fill="currentColor"
        />
        <path
          d="M1000.8,153.9v28.1h-14.3c-24.1,0-36.2-12-36.2-35.9v-31.1h-11.6v-27.4h11.6v-22.9h33.2v22.9h17.2v27.4h-17.2v31.6c0,2.6.6,4.4,1.8,5.6,1.2,1.1,3.2,1.7,6,1.7h9.6Z"
          fill="currentColor"
        />
        <path
          d="M528.9,352.3c-8.9-6.6-13.6-16-14.3-28.2h35.2c.3,4.2,1.6,7.2,3.7,9.1,2.1,1.9,4.9,2.9,8.2,2.9s5.5-.8,7.5-2.3c2-1.5,2.9-3.6,2.9-6.3s-1.6-6.2-4.9-8.1c-3.3-1.9-8.5-4-15.8-6.4-7.7-2.6-14-5.1-18.8-7.5-4.8-2.4-8.9-5.9-12.5-10.6-3.5-4.7-5.3-10.7-5.3-18.3s1.9-14.2,5.7-19.6c3.8-5.4,9.1-9.6,15.8-12.4,6.7-2.8,14.4-4.2,22.9-4.2,13.8,0,24.8,3.2,33.1,9.7,8.2,6.5,12.6,15.5,13.2,27.2h-35.9c-.1-3.6-1.2-6.3-3.3-8.1-2.1-1.8-4.7-2.7-8-2.7s-4.5.7-6.1,2.2c-1.6,1.5-2.4,3.5-2.4,6.2s.9,4.2,2.6,5.8c1.7,1.6,3.9,3,6.5,4.2,2.6,1.2,6.4,2.7,11.4,4.5,7.5,2.6,13.7,5.1,18.6,7.7,4.9,2.5,9.1,6.1,12.6,10.6,3.5,4.5,5.3,10.3,5.3,17.3s-1.8,13.4-5.3,19c-3.5,5.6-8.6,10-15.3,13.3-6.7,3.3-14.6,4.9-23.6,4.9-13.8,0-25.1-3.3-34-9.8Z"
          fill="currentColor"
        />
        <path
          d="M669.8,332.8v28.1h-14.3c-24.1,0-36.2-12-36.2-35.9v-31.1h-11.6v-27.4h11.6v-22.9h33.2v22.9h17.2v27.4h-17.2v31.6c0,2.6.6,4.4,1.8,5.6,1.2,1.1,3.2,1.7,6,1.7h9.6Z"
          fill="currentColor"
        />
        <path
          d="M773.1,266.5v94.4h-33.2v-13.5c-2.8,4.3-6.7,7.7-11.6,10.4-4.9,2.6-10.6,4-17,4-11,0-19.7-3.6-26-10.9-6.3-7.2-9.5-17.1-9.5-29.5v-54.9h32.8v50.7c0,5.4,1.4,9.6,4.3,12.7,2.9,3.1,6.6,4.6,11.4,4.6s8.6-1.5,11.4-4.6c2.8-3.1,4.2-7.3,4.2-12.7v-50.7h33.2Z"
          fill="currentColor"
        />
        <path
          d="M783.5,288.1c3.5-7.3,8.4-12.9,14.6-16.8,6.2-3.9,13-5.9,20.5-5.9s11.5,1.3,16.2,3.8c4.8,2.5,8.5,6,11.2,10.4v-43.1h33.2v124.6h-33.2v-13.1c-2.6,4.4-6.2,7.9-10.9,10.4-4.7,2.6-10.3,3.9-16.7,3.9s-14.3-2-20.4-5.9c-6.1-3.9-10.9-9.6-14.5-16.9-3.5-7.3-5.3-15.9-5.3-25.7s1.8-18.3,5.3-25.6ZM841.2,299.3c-3.3-3.5-7.4-5.2-12.2-5.2s-9,1.7-12.3,5.1c-3.3,3.4-4.9,8.2-4.9,14.4s1.6,10.9,4.9,14.4c3.3,3.5,7.3,5.3,12.3,5.3s8.9-1.7,12.2-5.2c3.3-3.5,5-8.3,5-14.5s-1.7-10.8-5-14.3Z"
          fill="currentColor"
        />
        <path
          d="M892.2,253c-3.5-3.2-5.3-7.2-5.3-12s1.8-9,5.3-12.3c3.5-3.3,8.2-4.9,14.1-4.9s10.4,1.6,13.9,4.9c3.5,3.3,5.3,7.4,5.3,12.3s-1.8,8.8-5.3,12c-3.5,3.2-8.2,4.8-13.9,4.8s-10.5-1.6-14.1-4.8ZM922.6,266.5v94.4h-33v-94.4h33Z"
          fill="currentColor"
        />
        <path
          d="M951.6,356.2c-7.5-3.9-13.3-9.5-17.6-16.8-4.3-7.3-6.4-15.9-6.4-25.8s2.2-18.3,6.5-25.6c4.3-7.3,10.2-12.9,17.7-16.8,7.5-3.9,15.9-5.9,25.3-5.9s17.9,2,25.3,5.9c7.5,3.9,13.4,9.5,17.7,16.8,4.3,7.3,6.5,15.8,6.5,25.6s-2.2,18.3-6.5,25.7c-4.3,7.4-10.2,13-17.8,16.9-7.5,3.9-16,5.9-25.4,5.9s-17.9-2-25.3-5.9ZM988.5,328.4c3.1-3.4,4.6-8.3,4.6-14.7s-1.5-11.3-4.6-14.6c-3.1-3.4-6.9-5-11.4-5s-8.2,1.7-11.3,5c-3,3.4-4.5,8.2-4.5,14.6s1.5,11.4,4.4,14.8c2.9,3.4,6.7,5,11.3,5s8.4-1.7,11.5-5.1Z"
          fill="currentColor"
        />
        <path
          d="M212.7,0C95.3,0,0,95.2,0,212.7c0,117.5,95.3,212.7,212.7,212.7,117.5,0,212.7-95.3,212.7-212.7C425.5,95.2,330.2,0,212.7,0ZM212.7,393c-99.5,0-180.3-80.7-180.3-180.2,0-99.5,80.7-180.2,180.3-180.2,99.5,0,180.2,80.7,180.2,180.2,0,99.5-80.7,180.2-180.2,180.2Z"
          fill="currentColor"
        />
        <path
          d="M121.3,212.1c0,50.5,40.9,91.3,91.3,91.3,50.4,0,91.3-40.9,91.3-91.3,0-50.4-40.9-91.3-91.3-91.3-50.5,0-91.3,40.9-91.3,91.3ZM217.8,157.9l41.7,99.5c.7,1.7.3,3.7-1,5-.1.1-.2.2-.4.3-1.6,1.3-3.8,1.3-5.4.2l-39.1-27.1-39.1,27.1c-1.7,1.1-3.9,1.1-5.4-.2-1.6-1.3-2.1-3.4-1.3-5.3l41.7-99.5c.7-1.7,2.4-2.8,4.2-2.8,1.8,0,3.5,1.1,4.2,2.8Z"
          fill="currentColor"
        />
        <path
          d="M82.7,227.4c-.6-5-.9-10.2-.9-15.4,0-60.2,40.9-111.1,96.3-126.2-1.7-4.3-2.5-8.9-2.5-13.8s0-3,.2-4.5c-64.4,16.4-112.3,75-112.3,144.4,0,6.8.4,13.5,1.4,20.1,5.3-2.8,11.3-4.6,17.8-4.7Z"
          fill="currentColor"
        />
        <path
          d="M338.2,175.2c4.5-1.8,9.3-2.7,14.4-2.7,1.3,0,2.5,0,3.8.2-13.6-49.7-52.4-89.1-101.7-103.6,0,1,.1,2,.1,3,0,5.3-1.1,10.4-3,15.1,41.5,13,74.1,46.2,86.4,88Z"
          fill="currentColor"
        />
        <path
          d="M338.2,249c-15.9,54.3-66.2,94-125.5,94-40.6,0-77.1-18.7-101-47.8-4.4,4.3-9.7,7.6-15.7,9.5,27.4,34.4,69.6,56.4,116.8,56.4,68.5,0,126.4-46.5,143.7-109.6-1.2.1-2.5.2-3.8.2-5.1,0-10-1-14.4-2.7Z"
          fill="currentColor"
        />
        <path
          d="M111.1,267c0-15.1-12.3-27.4-27.4-27.4-15.1,0-27.4,12.3-27.4,27.4,0,15.1,12.3,27.4,27.4,27.4,15.1,0,27.4-12.3,27.4-27.4Z"
          fill="currentColor"
        />
        <path
          d="M352.6,184.7c-15.1,0-27.4,12.3-27.4,27.4,0,15.1,12.3,27.4,27.4,27.4,15.1,0,27.4-12.3,27.4-27.4,0-15.1-12.3-27.4-27.4-27.4Z"
          fill="currentColor"
        />
        <path
          d="M215.2,99.5c15.1,0,27.4-12.3,27.4-27.4,0-15.1-12.3-27.4-27.4-27.4-15.1,0-27.4,12.3-27.4,27.4,0,15.1,12.3,27.4,27.4,27.4Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const PathfinderIcon: React.FC<IconSvgProps> = ({ size, width, height, ...props }) => {
  return (
    <svg
      height={size || height}
      viewBox="0 0 1364.2 425.5"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M551.3,241v39.9h-33.2v-119.2h49.5c14.4,0,25.3,3.6,32.9,10.9s11.4,16.9,11.4,29-1.7,14.3-5,20.2c-3.4,5.9-8.4,10.6-15.1,14.1-6.7,3.4-14.7,5.1-24.2,5.1h-16.3ZM578.4,201.6c0-8.8-4.8-13.1-14.5-13.1h-12.6v26.4h12.6c9.6,0,14.5-4.4,14.5-13.3Z"
        fill="currentColor"
      />
      <path
        d="M668.7,189.6c4.9,2.9,8.5,6.8,10.9,11.9v-15h33v94.4h-33v-15c-2.4,5-6,9-10.9,11.9s-10.6,4.3-17.3,4.3-14.3-1.9-20.4-5.8c-6.1-3.9-10.8-9.5-14.3-16.8-3.5-7.3-5.2-16-5.2-25.8s1.7-18.5,5.2-25.8c3.5-7.3,8.2-12.9,14.3-16.7,6.1-3.9,12.8-5.8,20.4-5.8s12.4,1.4,17.3,4.3ZM649.8,219.4c-3.2,3.4-4.8,8.2-4.8,14.2s1.6,11,4.8,14.4c3.2,3.4,7.4,5.1,12.5,5.1s9-1.7,12.3-5.2c3.3-3.5,4.9-8.2,4.9-14.3s-1.6-10.7-4.9-14.1c-3.3-3.5-7.4-5.2-12.3-5.2s-9.3,1.7-12.5,5.1Z"
        fill="currentColor"
      />
      <path
        d="M778.5,252.6v28.3h-13.6c-11.6,0-20.6-2.9-27.1-8.6-6.5-5.7-9.8-15.2-9.8-28.4v-29.8h-12.1v-27.6h12.1v-22.9h33.2v22.9h17v27.6h-17v30.5c0,2.9.6,5,1.9,6.2,1.3,1.2,3.5,1.9,6.5,1.9h8.9Z"
        fill="currentColor"
      />
      <path
        d="M873.9,196.5c6.2,7.2,9.3,17.1,9.3,29.5v54.9h-32.8v-50.7c0-5.5-1.4-9.8-4.3-12.9-2.9-3.1-6.7-4.6-11.5-4.6s-8.9,1.6-11.8,4.8c-2.9,3.2-4.4,7.6-4.4,13.2v50.2h-33.2v-124.6h33.2v45.9c2.7-5,6.6-9.1,11.8-12.1,5.2-3,11.2-4.5,18.2-4.5,10.9,0,19.4,3.6,25.6,10.9Z"
        fill="currentColor"
      />
      <path
        d="M941.1,176.6c-3.9,0-6.8.8-8.6,2.3-1.8,1.5-2.9,4.1-3.2,7.7h15.3v27.6h-15.5v66.8h-33.2v-66.8h-10.8v-27.6h10.8c0-12.1,3.6-21.5,10.8-28.2,7.2-6.7,17.5-10,31-10s3.8.1,6.9.3v28.1c-.8-.1-2-.2-3.5-.2Z"
        fill="currentColor"
      />
      <path
        d="M950.2,148.2c3.6-3.2,8.3-4.8,14.1-4.8s10.5,1.6,14,4.8c3.5,3.2,5.2,7.3,5.2,12.2s-1.8,8.6-5.3,11.8c-3.5,3.1-8.2,4.7-13.9,4.7s-10.5-1.6-14.1-4.7c-3.6-3.1-5.4-7.1-5.4-11.8s1.8-9,5.4-12.2ZM980.6,186.5v94.4h-33.2v-94.4h33.2Z"
        fill="currentColor"
      />
      <path
        d="M1079.3,196.5c6.2,7.2,9.3,17.1,9.3,29.5v54.9h-32.8v-50.7c0-5.5-1.4-9.8-4.3-12.9-2.9-3.1-6.7-4.6-11.5-4.6s-8.9,1.6-11.8,4.8c-2.9,3.2-4.4,7.6-4.4,13.2v50.2h-33.2v-94.4h33.2v15.8c2.7-5,6.6-9.1,11.8-12.1,5.2-3,11.2-4.5,18.2-4.5,10.9,0,19.4,3.6,25.6,10.9Z"
        fill="currentColor"
      />
      <path
        d="M1150,189.6c4.8,2.9,8.4,6.8,10.8,11.9v-45.1h33.2v124.6h-33.2v-15c-2.4,5-5.9,9-10.8,11.9-4.8,2.9-10.5,4.3-17.2,4.3s-14.3-1.9-20.4-5.8c-6.1-3.9-10.8-9.5-14.3-16.8-3.5-7.3-5.2-16-5.2-25.8s1.7-18.5,5.2-25.8c3.5-7.3,8.2-12.9,14.3-16.7,6.1-3.9,12.8-5.8,20.4-5.8s12.3,1.4,17.2,4.3ZM1131.2,219.4c-3.2,3.4-4.8,8.2-4.8,14.2s1.6,11,4.8,14.4c3.2,3.4,7.4,5.1,12.5,5.1s9-1.7,12.3-5.2c3.3-3.5,4.9-8.2,4.9-14.3s-1.6-10.7-4.9-14.1c-3.3-3.5-7.4-5.2-12.3-5.2s-9.3,1.7-12.5,5.1Z"
        fill="currentColor"
      />
      <path
        d="M1293.5,239.7h-62.4c.6,10.7,5.2,16,14,16s5.9-.8,8.1-2.4c2.1-1.6,3.6-3.6,4.4-6.2h35c-1.2,6.6-4,12.6-8.2,17.9-4.3,5.3-9.7,9.5-16.2,12.5-6.5,3-13.6,4.5-21.4,4.5s-17.8-1.9-25-5.8c-7.2-3.9-12.9-9.5-16.9-16.8-4-7.3-6.1-16-6.1-25.8s2-18.5,6.1-25.8c4-7.3,9.7-12.9,17-16.7,7.3-3.9,15.6-5.8,24.9-5.8s17.7,1.9,24.9,5.7c7.2,3.8,12.8,9.3,16.7,16.3,4,7.1,6,15.3,6,24.6s-.3,4.9-.8,7.7ZM1256.8,214.9c-2.7-2.5-6.1-3.7-10.1-3.7s-7.9,1.2-10.7,3.7c-2.8,2.5-4.4,6.1-4.8,10.9h29.5c.1-4.8-1.2-8.5-3.9-10.9Z"
        fill="currentColor"
      />
      <path
        d="M1346.4,190.7c5.6-3.4,11.6-5,17.8-5v35.3h-9.6c-7.4,0-13,1.4-16.7,4.3s-5.6,7.8-5.6,14.9v40.7h-33.2v-94.4h33.2v17.7c3.7-5.6,8.4-10.1,14-13.5Z"
        fill="currentColor"
      />
      <path
        d="M420.8,168.3c-11.9-55.6-44.7-103.2-92.3-134.1C280.8,3.4,223.9-7.1,168.4,4.7c-55.6,11.9-103.2,44.7-134.1,92.3C3.4,144.7-7.1,201.6,4.8,257.2c11.9,55.6,44.7,103.2,92.3,134.1,34.9,22.6,74.7,34.3,115.2,34.3,14.9,0,29.9-1.6,44.8-4.8,114.7-24.5,188.1-137.7,163.6-252.4ZM263,376.7c-.1.1-.3.2-.4.4-1.8,1.4-4.2,1.5-6.1.2l-43.7-30.3-43.7,30.3c-1.9,1.3-4.3,1.2-6.1-.2-1.8-1.4-2.4-3.8-1.5-5.9l46.6-111.2c.8-1.9,2.6-3.1,4.7-3.1,2,0,3.9,1.2,4.7,3.1l46.6,111.2c.8,1.9.4,4.1-1.1,5.6ZM354.8,323.5c-1.2-2.3-2.4-4.3-3.5-5.9-23.6-36.5-57-42.2-113.4-77-69.3-42.8,49.8-70.1,80.7-89.1,65.9-41.2-85.7-27.4-104.4-30.4-10.1-.4-21-1.8-22.3-6.6-3.2-12.2,59.5-33.3,56.6-46.4-1.8-8.1-25.7-10.6-40.9-9-8.5.9-17.1,3.3-17,4.8,0,.8,3.1,1.1,14.9,3.1,10.3,1.7,11.7,2.1,12,3.1,1.1,3.8-13.4,11.2-20,14.6-38.4,19.9-65.2,33.7-64.5,41.9.5,6.1,16.4,13.4,87.9,18.3,20.7,3.6,1.5,12.1-7,16-225.8,76.9-86.6,103.7-89.7,142-1.2,15.1-19.1,26.5-41,35-22.8-23.5-39.5-53.4-46.9-87.7C15.8,153.2,77.9,57.2,175.1,36.5c12.6-2.7,25.2-4,37.7-4,83.2,0,158.2,58.1,176.2,142.6,11.6,54.1-2.6,107.9-34.2,148.4Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const PathwayLogo: React.FC<IconSvgProps> = ({ size, width, height, ...props }) => {
  return (
    <svg
      height={size || height}
      viewBox="0 0 500 500"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <clipPath id="b">
          <circle cx="250" cy="250" fill="none" r="245" />
        </clipPath>
        <linearGradient
          gradientTransform="translate(379.5 -1160.8) scale(.2)"
          gradientUnits="userSpaceOnUse"
          id="c"
          x1="-343.3"
          x2="-10.1"
          y1="6010.7"
          y2="6242.8"
        >
          <stop offset="0" stopColor="#02092e" />
          <stop offset=".9" stopColor="#050503" />
          <stop offset="1" stopColor="#00074f" />
        </linearGradient>
        <linearGradient
          gradientTransform="translate(379.5 -1160.8) scale(.2)"
          gradientUnits="userSpaceOnUse"
          id="d"
          x1="-277.6"
          x2="-385.7"
          y1="5070"
          y2="6114.5"
        >
          <stop offset="0" stopColor="#e9fdf8" />
          <stop offset=".2" stopColor="#90fbfd" />
          <stop offset=".4" stopColor="#17bcfe" />
          <stop offset=".8" stopColor="#0038fa" />
          <stop offset="1" stopColor="#0021cb" />
        </linearGradient>
        <linearGradient
          gradientTransform="translate(379.5 -1160.8) scale(.2)"
          gradientUnits="userSpaceOnUse"
          id="e"
          x1="-579"
          x2="-916.6"
          y1="5386.1"
          y2="6194.4"
        >
          <stop offset="0" stopColor="#4ee6fc" />
          <stop offset=".3" stopColor="#05a3fe" />
          <stop offset=".6" stopColor="#003efa" />
          <stop offset="1" stopColor="#011dd5" />
        </linearGradient>
      </defs>
      <g clipPath="url(#b)">
        <path
          d="M380.1,204.3c.2,0,1-.6,1.5-.5v2c1.4-1.2,1.6-1.1,2.5.5.4.1.4.3,0,.5l.5.5c.4.2.4.3,0,.5-.4.3-1.7-.7-.5,1.5l-2-.5c-.7,1.6.2,3-1.5,3,0-.7,0-1.3,0-2l-1,1c-1.4,1-2-.6-.3-2s-.7.8-1.2.5c0-.6-.8-3.2-.5-3.5.9,1.1,1.7.4,2,.5.6-.2.7-.7.5-1.5,0-.2,0-.3,0-.5Z"
          fill="#055bf6"
        />
        <path
          d="M380.6,211.8c0,.7-.5,1.6,0,2.5.9.2.3-.9.6-1.3s2.8-2,2.4-.4-2.4,1.9-2.7,2.2c-.4.5.5,1.3-.3,1.5-.3.2-.2.5.5,1,1.1.6,1.2.6,2,1.5-1.2.3-2.5.4-4,.3-1,1.3-2.4,1.5-3.8,1.3-.5,1.5-4.2.9-4.2-1-.8-.2-.9-.8,0-1,.7-.2,1.1-.5,1.5-1,.8-.7,1.1-.4.5.5.7.6,1.2.8,1.5.5-1,.9-1.8.6-1-.5-.7-.7-.4-1,.5-.5,1.1-.9,1.7.6.5,1-.1-1.2.2-2.1,1-2.5-1.6,0-1.8-.7-.5-1.5-.6-4.6,4.5-1.2,1,0,.5,0,.5.3,0,1l1.1-.4c-.2-1,.4-1.7,1.7-2,0-1.2.2-1.8.8-1.6.1.5.6.5,1,.5Z"
          fill="#055bf6"
        />
        <path
          d="M496.1,351.7c-.8,1.3-1.7.3-2.3-.9-.9-4.2-2-3.3-3.5,2.9l-4,4.3c-.5,2.3-1.4,3.8-3.9,4.1.3,2-.7,4-2.9,5.8,2.2,2,.7,3.6-2,2.9-1.5,4.6-3.2,9.1-4.9,13.6,1.4,1.8.9,3.4-.9,4.7-1.7,4.2-3.7,7.8-7.2,10.7,0,3.4-1.1,4.4-3.2,3.1-1.3,2.1-3.2,3.7-5.8,5l-4.9,5.7c.3,2.4-.2,4.2-3,3.3-.9,1.7-2.1,3.2-3.9,4.4,1.8,2.3-1.6,5.9-3.4,7.6l-5.2,3.3c-6.6,7.2-13.6,14.9-22.2,19.4l-2.9.4c.4.7.3,1.3-.6,1.7-.2.3-.3.3-.5,0,0,1.2-1.2,2-3.6,2.4-1.2,2.1-3.1,3-4.4.4-1.7,4-4.2,8.7-9,9.9l-.9-.8-2.6,1.5c-1.9-1.8-3-.9-3.5,2.8-.9,1.4-2.3,2-4.3,1.7-1.5,1.5-3.1,2.2-4.9,2.2-.5,2.4-1.2,3.6-3.8,4-2,1.7-7.7,5.4-9.1,1.5s.2-.9.6-1.1v-1.1c13.6-8.7-7.2-.4-10.5,1.1l-1.5-.5.5-1c11.1-5.3,21.8-11.5,32-17.5l.5-.5c.2-.4.3-.4.5,0l1.5-1c2.6-2.6,6.2-5.5,9.5-7,13.8-11,26.7-22.8,39-35.5,6-7.8,12-15.7,18-23.5,3.3-6,7.1-11.9,11-17.5,3.1-6.4,6.5-12.7,10-19,.3-2.4,1.5-5.1,3-7,1-4.3,2.7-8.7,5-12.5.1-1.5.8-2.7,1.5-4-.4-.1-.4-.3,0-.5l.5-1c-.4-.2-.4-.3,0-.5l.5-1c-.4-.1-.4-.3,0-.5l.5-1.5c-.2-.2-.4-.4-.3-.6.9-3.7,2.2-8.4,3.3-12.1s.3-.3.5-.4c.2-1.9.5-4.4,2-5.5l1.8-9.1c.5-1.3,2.2-3.5,3.7-2.9v55.5Z"
          fill="#fdfdfd"
        />
        <path
          d="M363.6,478.2c.3.8,0,1.5-1.2,2.2l-1.3,2.6c-.4,2.1-1.9,2.2-4.7.4-1.5,2.4-4.3,5.7-7.3,5.1l-1.9,1.5c-3.2.7-5.9,2.1-8.1,3.9,4.1.4,1.6,9.9-1.2,6,.4-4.4-6.5-4.6-2.4.1l-.4,2.5,27.9,1.7.5,1h-201.9c-.1-1.4,1.4-1.9,4.5-1.5-2.9-.9-5.4-7.3-1.4-8-1-2-2.6-3.1-4.7-3.1-2.1-.7-4.4-5.8-4.2-7.8s.4-3.1,2.3-2.1l.7-.5c4.9,1.9,9.8,3.6,14.8,5,.3-.2.6-.4.9-.4.8-.1,10.1,2.8,11.9,3.3s.5.3.7.6c2.5.2,6.6.5,8,2.5,3.1,1,6.3,1.8,9.5,2.5l24.3,2.9c3.2.8,6.1.9,8.8.4,8.2,1.2,18.4,1.6,25.5,0,3.2.6,7.2.5,10.2-.7,7.3-.7,14.7-1.6,21.9-2.8,11.3-2.4,25.2-6,37.1-10.4.4-1.4,3-1.9,4.5-2,4.7-2.3,9.4-4.4,14.5-5.5,3.1-1.2,5.9-2,8.8-3.5s10.3-4.3,8.5,0c-.8,1.9-3.5,2.9-5.3,4Z"
          fill="#fff"
        />
        <path
          d="M205.2-7.1c0,1.1-.7,1.5-1.5,2,.3,1.3-2.9,1.7-4.1,1.8-4.2-.6-8.2-.3-12.1.7-3.5-.7-6.9,0-10.2,2.4l-1.1-.3c-6.5.9-12.7.7-18.7-.4-5.1,1.7-10.5,1.8-16.2.4-2.6,1.6-4.9,1.6-6.8,0-2.2,1.6-4.4,1.9-6.3.9-1.4,2.6-5.1,2.5-4.8-1-.7-3.9-16.3-2.9-17.5-2-1.3,2.3-2.4,3-4.6,1.2-.7.2-1.6,0-2.7-.8-4.1-.4-8-1.2-11.7-2.5-3.4,2.3-6.2,2.6-8.7.9-3.6,1.6-6.7.9-10.3-.2-3.6.2-7.1,1.1-10.6,2.6l-1.2-.5c-1.3-3.4-5.4-2.3-7,.7l-1.9.3c-.8-1.3-1.8-1-2.6,0l-.8,1c-4.1-.3-8.2-.1-12.2.5l-.8.9-4.7.2c-3.6,3.5-6,3.3-7.6-1.6C12.1,0,5.4-.9-1.3-2.6l-2.3-1.5c-.9,1.4-3.1.6-3-1-.7.6-1.7.4-3-.7-1.9.2-2.5-.3-2-1.3h216.9Z"
          fill="#fbfbfb"
        />
        <path
          d="M465.1,107.9c-2.1-1.5,1.7-2.6,3.2-2.5,3.3.3,3.1,2,2.3,4.6,1.9-1.1,3.8-2.4,5.6-3.8,2.3,1.1,12.2-3.6,12.3-5.3-1.7-2.8.4-6.3,3.5-5s4.5,9.4,4,11.5v47c-.2,2.1-4.1-.8-4.3-1.1s-1.5-3-1.6-3.2c-.4-1.9,2.2-6.2-3.1-4.6l-4.5-10.1c-3.5-2.3-4.6-6.4-6.3-9.8s-2.1-2.7-2.5-3.6.2-2,0-2.5c-.4-.9-3.3-1.5-2.8-4l-1,1,.5-2-1.5.5.5-2-2.5,1c1.4-3.6-.8-.8-1.5-1.5.9-1.7-.6-2.7-.5-4.5Z"
          fill="#fcfbf9"
        />
        <path
          d="M460.6,93.4c6.3,0,2.7-2.5,3.1-4.1s3.8-5.6,2.8-7.3-1.2-.6-1.7-1.1c-.7-.7-1-3-2.7-.7s1,2.3.7,3.2c-.4,1.6-2.1,1.2-2.3,1.8-.7,1.8-.1,3.5.5,5.2-.3.3-2.5-.9-3.3-.8s-3.3,3.3-4.5.8,2-3.3,3.2-4.3c2.8-2.2,1.9-4.2,2.8-6.2s4.6-4.1,4-6-1.5-1.4-1.3-2.5c1.3.7,4.5,1.2,5.5,1.7s1.9,5.3,3.7,2.2,0-2.2,2-3,4,1,6.2.5c1-.9-.2-3.6,0-3.9s2.5-.4,3.1-.6c1.2-.5,1.1-1.7,2.9-1.2,2.5.8.7,1.6.6,2.6s.6,2.1.4,3.2c2.1.9,1.9-2.8,3.2-2.5l1.5,3.5c1.5-.6-.6-6.4,4.7-3v2c-.2.4-.1.6,0,1v6c-.1,5.2-2,5.7-6.4,3.6-1.5.2-3.1.4-4.7.4-1.8,1.5-4.1,2.3-6.9,2.6-1,2.9-2.7,4.7-4.9,5.4l-.5,1.2c3.9,1.8-2.4,5.4-5,4.8-1.8-2.1-3.9,1.4-2.7,3.4,5.6-3.4,6,4.7,0,3.2-.6,1.4-1.2,2-2.4.9-.8.1-2.4.1-3.1-.1-2.5-.8-.6-4.1.6-2.9s-.2,2.9,1.2,2.5,1.3-3.2.7-3.9-2.9-1.1-3.2-1.1c-1.5-.1-3.1,1.3-4.7,1,0-4.1,5.5-3.7,6.5-7.5Z"
          fill="#fcfbf9"
        />
        <path
          d="M486.1,181.3l1-4.5.7,1c.5-1.5,4.6-.5,4.2-2.2s-3.6-.7-4.5-.8c2.1-5.7-2.6-3.1-3.8-5s-.6-6.7-.2-7c3.7,5.3,5.3-1,7.7-2s.9,1.6,1.3,1.9,2.6,0,3.4,0v49c-.2.8-.7,2.3-1.7,1.6-1-3.6-1.9-7.3-2.8-11.1-.1.4-.3.4-.5,0-.4,0-.4-.3,0-.5v-.5c-.2-.5-.4-1-.5-1.5-.4-.1-.4-.3,0-.5-.3-.3-.3-.7,0-1-.3-.2-.5-.5-.5-1l-.5-1.5c-.4-.1-.4-.3,0-.5l-.5-1.5c-.3-.1-.2-.3,0-.5-1.1-2.1-2-5-2-7.5-.9-.8-1.5-3.4-1-4.5Z"
          fill="#fdfdfd"
        />
        <path
          d="M491.6,202.3c.7,2.7,2.9,4.5,2,7.5l1-1v4s1.5-1,1.5-1v10c-.2,1.1-.5,1.4-1,1-.2-.1-.4-.4-.5-1-.7-.2-.7-.7,0-1l-.5-2c-.6-.8-.6-1.3,0-1.5l-.5-2c-.3-.1-.3-.3,0-.5-.3-.1-.3-.3,0-.5-.3-.4-.4-1-.5-2-.7-.3-.7-.7,0-1l-.5-1.5c-.9-1.3-1.4-4-1-5.5-.4-.6-.4-1.4,0-2Z"
          fill="#f4f5f5"
        />
        <path d="M496.1,283.3l-1-2.5c-.6-1.1-.6-4,.5-4.5.1-.4.3-.4.5,0v7Z" fill="#d0d0d3" />
        <path
          d="M496.1,226.3c-.1.4-.3.4-.5,0-.2-.1-.4-.5-.5-1-.6-.4-.7-1.2,0-1.5-.3-.3-.3-.7,0-1l1-1v4.5Z"
          fill="#d7dae5"
        />
        <path
          d="M496.1,233.3v1.5l-.5,1h-.5c-.7-.5-.7-1,0-1.5-.6-.8-.6-1.3,0-1.5.1-.4.3-.4.5,0,.2-.3.4-.1.5.5Z"
          fill="#323a85"
        />
        <path d="M496.1,239.3c-.1.4-.3.4-.5,0,0-1.2,0-2.3,0-3.5s0-.9.5-1v4.5Z" fill="#171e5d" />
        <path d="M496.1,245.3c-.9-.8-.5-2.7-.5-4,.1-.4.3-.4.5,0v4Z" fill="#3f4b97" />
        <path d="M496.1,269.8c-.1.4-.3.4-.5,0v-.5c-.8-.3-.4-1.8,0-2.5h.5v3Z" fill="#616686" />
        <path d="M496.1,233.3l-.5-.5c-.4-.3-.4-1.5,0-2,.1-.4.3-.4.5,0v2.5Z" fill="#6470a8" />
        <path d="M496.1,276.3h-.5c-.9-.4-.8-2.1,0-2.5.1-.4.3-.4.5,0v2.5Z" fill="#c1c6cd" />
        <path d="M496.1,241.3h-.5c0-.7,0-1.3,0-2h.5v2Z" fill="#273379" />
        <path
          d="M496.1,228.3c-.1.4-.3.4-.5,0-.3-.1-.2-.3,0-.5-.4,0-.4-.3,0-.5-.4-.2-.3-.6,0-1h.5v2Z"
          fill="#c9d4dc"
        />
        <path d="M496.1,273.8h-.5c-.7-.4-.6-1.5,0-2,.1-.4.3-.4.5,0v2Z" fill="#9fa7ad" />
        <path d="M496.1,271.8h-.5c-.5-.6-.4-1.3,0-2h.5v2Z" fill="#828693" />
        <path d="M496.1,230.8h-.5c-.4-.1-.4-1.2,0-1.5.1-.4.3-.4.5,0v1.5Z" fill="#7f90bf" />
        <path d="M496.1,229.3h-.5c-.4-.3-.4-.7,0-1h.5v1Z" fill="#a1afdc" />
        <polygon fill="#fdfbfa" points="496.1 73.9 495.7 73.3 496.1 72.9 496.1 73.9" />
        <path
          d="M391.1,48.9c-.7-1.8-.4-2.1-2.5-3.2.7-1.2,2.1-.5,3.1-.9s1.1-1.2,1.7-1.3c2.5-.5,2.2,2.1,3.3,2.6,2.7,1.2,7.4,1.6,10.4,1.8,1.4,1.6,4.1,2.7,6.5,4,1.2,1,1.8,4.1,2.6,4.9s2.2.9,3.1,1.6,1.2,1.8,1.7,2.2,3.1,0,3.9.4,2.3,2.7,2.3,2.9c.2.6-.5,1.4.2,2.3,1.2,1.5,4.7.3,4.1,2.5s-1,.2-1,.6c-.2,1.3,1.7,4.9-.3,5.6s-5.2.2-5.8,0-.5-1.9-1.8-1.5l-.3,2c-1.6-1,0-2.6-.3-3.7s-3.8-1.3-2.4-2.8l-3,2c-.4.7-1,.3-1-.5-.7-1.2-1.6-2.3-2.7-3.2v-.7c-3.4-1.5-8-5.5-8.6-9.3-1.8-.5-2.6-3-2.3-4.8-1.3-3.5-5.8-6.6-5.7-1h-1.1c0,.2,0,.5-.1.7s-2.7-1.2-2.9-1.7c.6,0,0-.5,0-.5l-1-1Z"
          fill="#fdfdfd"
        />
        <path
          d="M319.2-7.1h176.9v78c-.6.5-1.6.5-2.7,0-.3,3.5-2.2,5.6-3.8,1.4-3.1,4.5-5.2-.8-3.8-3.9l-1-.3c-1.1,1.3-2.4,1.5-4,1.7,1.2,4.9-2,4.7-5.8,3.5-1.9-.1-2.3.6-2.6,2.4-2.1,3.7-4,1.1-5.3-1.5l-2.8-.8c.1,2.5-1.1,4.8-3.9,7-.7,3.8-1.7,6.8-5.7,8-2.1,3.3,1.3,1.8,2.9.4l2,.2c-.6-2.7-.4-4.4,2.3-5.5-2.8-3.3,1.5-7.4,3.6-3.1,2.9,1.6,2.6,4.7-.9,9.3,2.2,3.5-1.7,6.5-4,3.9-.8,1-2,1.2-3.7.6-1.6,1.8-4.3,3.7-5.8.6-1.7-.5-2.5-1.4-2.5-2.8-3.1-.5-2.8-3.1-1.6-5.4-3.4-.5-4.3-1.8-2.7-3.8-2.9-.9-3.1-2.6-2.6-5.4-.7-1.4-1.1-2.4-.6-3.9-3.3-2.6-3.9-4.5-2.4-8.4l-.2-1.2c-1.1,1-2.2,1-3.2,0-.2-3.5-1.9-4-5.3-4,.3,1,0,1.6-.9,2.1s-6.8-2.8-7.5-3.2c-3.4-1.8-5.5-3.8-7.9-6.7-1.6.9-7.3-2-6.5-4-2.4-1.3-4.6-2.1-7.1-2.9l-.6-.9c-1.4.9-2.4,0-3.1-1.2-6.3,0-8.3-2.1-5.8-6.3l-1.3-1.9c-1,2-3.3,1.4-3.9-.5l-5-3.2c-1.6-1.4-1.6-2.9.3-4,0-.2-1.4-.8-1.8-.7-2.7,2.7-4.5,1.5-4-2.1-2-1.5-3.8-3.2-5.4-4.8-.2-1.8-2.8-3-3.7-1l-2.4.2c-2,1.3-4.2,2.3-6.4.7-2.5,1.6-4.7.2-6.5-1.7-3.8.5-6.9-2.9-6.7-6.6-5.6-.9-7.6-3-6.1-6.4-3.4.7-6.6.5-9.5-.6-.6-2-1.8-3.3-3.8-3.9-.4-1.7-1.9-2.5-4.4-2.6-2.7-.7-3.9-3.9-.6-4.5Z"
          fill="#fdfbfa"
        />
        <path d="M359.6-2.1c0,3.6-2.5,3.5-2.5,0h2.5Z" fill="#fdfdfb" />
        <path
          d="M496.1,354.7v8c-.6,1.1-.4,2.3,0,3.5v1c-.4.9-.4,2,0,3v1c-.2.4-.1.6,0,1v7.5c-.2.4-.1.6,0,1v14c-1.5,3.3-1.5,6.2,0,8.5v2.5c-.2.4-.2.7,0,1v1c-.3.7-.3,1.3,0,2v1.5c-.2.4-.1.6,0,1v.5c-.2.4-.2.7,0,1v.5l-1.1,1.2c-.7,3.3-2.5,2.7-4.6.9-1.6.2-3.2.7-4.7,1.3-1.2-2-5-1.8-4.8.7-1.9,2.4.8,2.2,2.5,1.6l1.2,1.5c1.9-1.8,4-2.5,6.3-.8,2.7-2.5,6-1.4,4.5,2.6l.7,1.9v68c-.4,1.3-1.9,1.5-4.3.6-.7,3-3.3,3.6-7.7,1.5-.7,3.3-2.5,3.9-5.6,2.9-1.4,0-2.7,1.8-2,3.1,3.1,4.5-4.6,3.9-6.4,1.1-3.5,3.1-13.9,4-10.6-3-3-1.7-6.2-1.1-9.6,1.6-3.1-1.2-8.1-1.6-11.5-1.3-2.9,1-5,1.7-7-1.2-.9,1.8-2.8,2-5.6.5-7.1,1-14.1,1.4-21,1l-1.2.5c1.7-1.9,5.7,0,4.8,2.2s-8.2.4-4.8-2.2c-.4.3-.4.8-.2,1.3-5,2.9-13.1,4.2-18.7,2.4s-.5-.7-.6-1.2c-1.9-.6-.8-2,.5-2.8-1.5-1.5-2.6-1.7-3.5-.4-1.8,0-3.7-.5-5.6-1.3l-.7.4c-.6,3-5.2,1.3-2.2-1.4-6.6-1.2-3.4-13.3.4-3.6l.6.5c-.7-2.3-.8-7.7,3.1-3.2l-.4-1.4c-6.9-5.7-.5-11.4,6.5-10.6.2-2.5,2.3-3.8,6.4-3.9.3-1.5,1.1-2.3,2.3-2.5.7-1.6,1.4-2.4,3.2-2.8.3-2.5,2.8-3.7,5.1-3.3-.3-2.5,1.4-3.5,5-3.1.2-2.1.6-5.2,3.4-3.6-.5-3.7-.3-4.8,3.8-4.2,2-.7,3.7-2.2,5.2-4.6,2-1.5,5.3-3.6,6.2,0l1.8-.4c-.9-1.7,2.3-5.7,4.1-6.1,0-1.2.4-2.3,1.1-3.2-1.8-2.3,0-3.8,2.5-3.4,1.1-4.4,2.2-7.2,7.5-7.6,1.3-2.3,7.9-7.2,10-6.2s.7.8.8,1.3c1.8-2,3.7-3.3,4.7,0-.3-.8-.4-1.6.3-2.3-2.1-1.6-1.3-2.9,2.4-3.9l.6-1.1c-2.2-2.2.3-7.2,2.8-4.1l.2-.6c-4.7-2.9-2.8-4.3,1.6-5.3,1.1-2.4,2.1-4,4.7-5.1,1-2.7,2.6-3.7,4.7-3,.8-2.9,3.7-5.4,6.5-3.4,1.1-2.8,3.5-3.1,5.8-1.4l2-.2c-.2-3.4,2.5-3.5,3.7-.6-.2-2-2.1-5.4-2.9-2-.7,1.1-4,.6-4.6-.2s-.1-6.6,2.2-6.4c-3.8-.6-8-2.1-3.4-5.8,1.2.5,2.5-1.6,2.1-2.8l.9-1.8c-4.5-3.8-.9-6.8,2.4-9.6-.5-3.2.7-4.9,3.8-5.1.2-1.5.6-2.5,2-3.4-.9-1.9.2-5.2,2.1-3.1Z"
          fill="#fcfbf9"
        />
        <path
          d="M496.1,425.2c-2.1-1.8-1.4-2.4-.5-4.5-.9.3-2.1-.4-2.8-.3s-1,1.3-2,1.3-1.3-1.2-3-1-2.5,1.9-3.3,1.8-1.3-1.7-1.7-1.8c-.8-.2-1,1.6-2.7.2s-1-1.4-1.6-1.9c-1.2-1-2.9-1.1-3-3.1l3-2.2-1,3c2.2,1.6,3,3,2-1,1.5.5,4.1-.8,5.2-.5s.6,1.4,1.1,1.5,1.1-.8,1.6-.9,3.1-.6,3.3-.6c.5,0,1.9,2.2,2.8,1.4s.1-3.1,2.5-2.5v11Z"
          fill="#fdfbfa"
        />
        <path d="M496.1,403.2c-3.8-.2-2-6.5,0-8.5v8.5Z" fill="#fdfbfa" />
        <path d="M496.1,366.2c-.8-1-1.3-2.7,0-3.5v3.5Z" fill="#fdfbfa" />
        <path d="M496.1,370.2c-.8-.5-.8-2.5,0-3v3Z" fill="#fdfbfa" />
        <path d="M496.1,409.7c-.7-.6-.7-1.4,0-2v2Z" fill="#fdfbfa" />
        <polygon fill="#fdfbfa" points="496.1 413.7 495.7 413.3 496.1 412.7 496.1 413.7" />
        <polygon fill="#fdfbfa" points="496.1 412.2 495.7 411.6 496.1 411.2 496.1 412.2" />
        <polygon fill="#fdfbfa" points="496.1 406.7 495.7 406.3 496.1 405.7 496.1 406.7" />
        <polygon fill="#fdfbfa" points="496.1 380.7 495.7 380.1 496.1 379.7 496.1 380.7" />
        <polygon fill="#fdfbfa" points="496.1 372.2 495.7 371.6 496.1 371.2 496.1 372.2" />
        <path
          d="M465.6,420.7c0,0-.8-.1-.9,0-.4.5.5,1.4.7,1.4.6,0,1.2-2,1.6-2,1.4-.2,3.8,1.6,5.1,1.9,2.3.6,4.1-1.1,4.4,2.6s-.8,2-2.2,2c1.1-4.9-2.9-2.2-4.7-2.1s-5.5-.6-5.8-.7c-.8-.4-1.4-2.3-1-2.7s2.1.9,1.5-2c.4,0,1.7,1.3,1.5,1.5Z"
          fill="#fdfbfa"
        />
        <path d="M470.6,408.7l.2-1.5c.9.7.8,1.1-.2,1.5Z" fill="#fdfbfa" />
        <path
          d="M318.7,15.9c.2,0,.3,0,.5,0,.4.1.4.3,0,.5,1,.2,1.4.5,1,1-2.2,0-4-.4-5.5-1.5l-.5-.5c0,1-.8,1-1,0-.6-.6-.3-.8.5-.5,1.6-.6,3.3-.3,5,1Z"
          fill="#4761bf"
        />
        <path
          d="M266.7,6.9h4.5c-.3,1-2.4.8-3.5.5-1,1-5.7.9-6.5-.5,1.6-.4,3.8-.4,5.5,0Z"
          fill="#3150ba"
        />
        <path
          d="M308.2,13.4c.8-.4,2-.2,3.5.5.2,0,.3,0,.5,0v.5c-.5.4-1.4.3-2,0-1,1-2.4.8-3-.5-.8-.7.2-1,1-.5Z"
          fill="#4a4eb3"
        />
        <path
          d="M272.7,7.4c-.1.3-.3.3-.5,0l-.5.5c-.7.8-4.2.8-4-.5,1.6,0,2.2-.3,3.5-.5s1.4-.1,1.5.5Z"
          fill="#3058cf"
        />
        <path
          d="M331.7,20.4c.2,0,.3,0,.5,0l1,.5c.4.1.8.4,1,.5.1.3-.2.4-.5.5-.8.7-2.8,0-3-1v-.5c.2,0,.3,0,.5,0,.1-.2.3-.2.5,0Z"
          fill="#4253c3"
        />
        <path
          d="M281.2,8.4c.5,0,1,0,1.5,0,.4.1.4.3,0,.5-.7.7-4,.7-4-.5.8,0,1.7,0,2.5,0Z"
          fill="#3848bb"
        />
        <path
          d="M285.2,8.9c.3,0,.7,0,1,0l-.5.5c-.8.4-3.1.5-3-.5.7-.5,1.7-.4,2.5,0Z"
          fill="#3b48b9"
        />
        <path d="M358.2,31.4c-.1.4-.3.4-.5,0-.4-.1-.4-.3,0-.5.2,0,.4.3.5.5Z" fill="#486cc4" />
        <path
          d="M355.7,30.4c.3,0,.7,0,1,0v.5l1,.5c.4.1.4.3,0,.5-1,.6-2.9-.3-3-1.5.2-.5.5-.3,1,0Z"
          fill="#486cc4"
        />
        <path
          d="M305.7,12.4c.2,0,.3,0,.5,0v.5c-.4.2-.9.4-1.5.5-.5,1-1.2.6-1-.5-.1-.3.2-.4.5-.5.5,0,1,0,1.5,0Z"
          fill="#5956bb"
        />
        <path
          d="M274.2,7.4l-.5.5c-.2.9-1,.7-1.5,0-.3-.2-.2-.3,0-.5.1,0,.3,0,.5,0,.5,0,1,0,1.5,0Z"
          fill="#3a36b6"
        />
        <path
          d="M342.2,24.4c.2,0,.3,0,.5,0,.3.4,0,.6-.5.5-.4.9-1.3.5-1-.5.3,0,.7,0,1,0Z"
          fill="#3643a7"
        />
        <path
          d="M26.9,504.7c-.8-1.7-9.1.4-8.5-2.7s2.9-.2,4-.4,2.3-1.7,3.2-1.8,2.2.8,3.2.5c.1-4.1-4.2-1.9-6.1-2.3s-1.7-1.3-3.2-1.5-3.1.2-3.2.3c-.3.3.4,2.7-.5,3.3s-1.8.1-2.7.3-1.4,1.2-1.9.9-.2-1.3-1-1.8-1.5.2-2,0-1-1.3-1.8-1.6-3.9-1.5-4.1-1.7-.8-2.6-1.1-3.2c-.8-2.1-1.5-4.3-2.3-6.7s-1.8-1.2-.7-3.5c-6,1.2-2.6-4.5-3-5s-2,0-2.4-1.4,1.3-1.8,1.9-3.4c-.8-1-2.2-.4-3-1.5s-.2-3.2-.6-4.4-1.8-1.1-2.2-1.8.3-1.4.2-2.1c-.2-1.6-2.7-2.1-.4-4.1s1.5-.7,1.5-.7c.9-1.3-4-2.2-2.2-5s3.3-2.9,3.6-2.9c.8-.1,1.8,1.1,2.9,1s.4-1.1,1.2-1.4,4.2-.5,4.2-1.4c-1.5-2.3-3-.5-5-.3,1.1-3.7-1.1-2.6-1.5-3s.6-1.7.4-2.6c-.2-1.3-1.9-2.2-1.9-3.1s.9-1.4,1.1-2.5c.2-1.9-1.1-3.1-1-4s1.2-1.4.9-2.4-2.6-1.3-3-3.1c-.7-3.2,1.6-4.6,1.5-.7,4.6-.6,2.2-2,2.5-4.2s1.3-1.4,1.5-2.5c.8-4.2-2.5-7.8-2-12.5s1.7-3.8,1.8-5-1.3-2.9-1.2-3.4c.2-1.1,3.9-3.1.9-5.8.8,0,2.1.2,2.5-.8s0-4.4,0-4.9c-.3-2.9-2.2-4.6-3.4-7.1s-.5-2.9-1.4-3.2-1.8,1-2.4,0c-1.7-2.6.4-2.7.7-3.1s-.3-1.2-.2-1.6.9-1.2.8-2-4.1-2.7-4.5-5c.5-4.2-.5-8.9,0-13s1-1.8,1-2.5-.8-1.6-1-2.5c-.9-6.2,3.7-5.2,4.7-8.2s-.7-1.2-1-2c-1-2.2,1.3-1.6,1.7-2.1s-.1-2.7,1.3-2.4.3,3.1,1.2,3.8,1.4.2,2,.5,1.7,1.4,2.4,1.6c1.2.3,2.7-.2,3.6.4,1.5.8.1,5.7,4.5,4.8-1.2,1.4-1.1,2.7-1,4.5,1.6.4,1.6-3.4,3.2-3s.9,2.4,1.2,3.2.9.3.9.4c.2.3-.4.8-.4.9.9.5,1.4,1.7,1.5,3.6,3.5,2.5,4.9,5.6,5.2,9.9,1.7,1.1,2.5,2.9,2.4,5.6l1.7,2.5c-.7,1.6-.8,3.1-.3,4.6-1.9,1.6-1.3,2.5,2,2.7,2.4-.6,3.3.6,2.6,3.6,3.8-.1,5.1.9,3.4,4.6,2.9.7,3.8,2.9,2.5,6.8,2.4.5,3.2,1.8,2,4.1l.9,1.1c3.5-2.5,4.4-.3,4.9,3.2,1.9.4,3.2.8,3.2,3.1,3.1.9,4.5,3.5,4.3,7.8,1.9,1.2,3,2.7,3.4,4.5,3.7,2.6,6.8,6.3,9,11.2.9,3,6,7.2,9.1,6.3,3.2,2.1,6,4.8,8.5,8.1,2.9,1.6,4.1,2.9,4.3,6.3,2-.2,3.7.7,2.9,2.9,2-1,3.4-.6,4.2,1.3,1.7.6,2.5,1.5,2.6,2.7,1.8,1.3,3.3,2.9,4.5,3.7s1.8.5,2.7,1.3,1.1,2,1.2,2c.3.2.9-1,1.7-.9,1.2.1,4.3,3.1,5.2,3.4s2-1,2.7-.7.7,1.3,1.2,1.6c1.2.9,3.7,1.7,4.8,2.9s1.9,5,3.6,6.6,4,2,4.6,2.6,0,1.1.3,1.7c1.8,2.7,7.1,4.9,9.5,6.6s.5,1.5,1,2c1,1.1,4.4,3.7,5.8,3.7s1.7-1.1,2.2-.7,4,5.9,4,6.5c-3.9.5-1.2,4.4-3,5.5s-7.2,1-7.5.7c-.4-1.6,2.2-1.4,2.5-2.3.5-1.6-1.5-2.1-2.7-1.8s.5,2.1-1.8,1.5v-1.5c-.8-.2-.2.9-.8,1-2.4.6-3.5-1.4-4.8-1.4s-4.2,2.8-5.8,3.1-3.9-1.4-5.8-1.2-2.6,2.4-3.1,2.5c-2.3.6-7.2-1.3-9.4-1s-1.3,1-1.9.9c-4.5-.8-8.7-1.2-13.3-2.7s-3.8-2.2-6.9-2.1-1.4,3.9-3.4,3.9-1.2-.9-1.8-1.3-1.5-.1-1.9-.4-.1-1.1-.6-1.6c-1.9-2.1-2.3.7-3.6,1.4s-5.1,1.7-5.4,1.4v-2c9.5.4.8-3.4-1.7-1.6s-.2,1.4-.3,1.6c-.2.2-1.8-.7-2-.5s-.6,1.9.3,2,2-.7,2.2-.5c.5.4.8,2.2-.7,2.5-3.6.7-11.1.2-14.4-1.6s-1.3-1.5-1.8-1.7c-.8-.3-1.5.5-2.5,0s-1.1-1.6-1.8-1.7-4.8,2.9-6.6,3.3-3.4-.1-4.9.1-.5,1.4-4.7,1.5Z"
          fill="#fcfbf9"
        />
        <path
          d="M-16.1,311.8l.5-3.9h1.4c.6-.8.9-13.6-.4-15.1,1.1,1.7,1.5,7.1,0,8.5-.8,1.3-1.4.6-1-.7-.4-6.2-.4-13.4,0-19.7.2-1.3.6-1.3,1,0,.9,3,.9,5.6,0,8,1-2.5.9-5.3-.2-8.4.8-.9,4-3.4,4.9-3.1,1.5.5,1.2,1,.3,2,3.2.6,4.4,1.9,4.7,5.4l.6,6.6c2.5,0,3.4,2,2.7,5.9-.3,1.9.6,2.9,2.5,2.9,1.3,1.2.1,9.5-1.5,11.1v5.1c1.5-.6,2.5-.4,3,.7l1.2,6.6c3,.6,4.2,3.3,3.4,7.9,2.7.4,3.9,2.5,1.9,4.5,2.3,2.3,3.5,5.4,3.6,9.5,1.8,1.8,1.9,6-1.1,4.3-.8-.3-1.5-1.4-2.1-3.3-1.7,4.4-4.9,2.9-3.6-1.6-1.8-.8-2.9-2.4-3.2-5-3.4.2-6.2-1.7-8.7-3.4.3-1.5-.4-1.5-2.2.1,1.9,1.7,1.6,3.4-.3,5-3.3,1.6-4.4,4.3-2.4,7.6-1.2,4.4-1,8.7-.7,13.4-.5,2.9.9,5.5,4.2,7.6-.2,1.6-.5,3.2-.8,4.8-1.1.4-1.2,1-.5,1.7,2.2-.9,3.5.3,3.9,3.4,2.7,3.9,5.7,10.4,1.9,14.2.7,1.9-.6,3.5-1.8,4.8,1.3,2.5,1,5.5-.7,8.8l.2,2.7c2.3,4.7,2.4,8.6.3,11.9.9,3.4-.1,5.7-4,4.8,2.9,1.9,3.6,3.8,2,5.7,1.1,2.3,1.6,4.4,0,6.5l1.8,2.4c0,1.8.5,3.4,1.7,4.8,5.7-1.4,5.6,4-.2,4-.8,1.7-2.3,2-4.3.7-.3,0-3.6,2.5-3,3.4,3.2,2.7,3.2,3.1,0,5.7,1.1,1.4,1.8,2.6,1.1,4.4,2,.8,2.9,2.8,2.6,5.8,2.9,1.3,4.7,2.2,1.3,4.9v.5c2.2.7,2.8,2.5,2,5.5,2.6.1,3.7,1.1,3.2,2.8,1.8,3.5,3.2,7.1,4.2,11,2.2.6,4.1,1.6,5.4,3.1,1.4-.5,2.7,0,3.3,1.4,1-.6,2.1-.8,3.3-.7-.7-5,4.7-4.3,7.7-2.2,3.3-.6,8.4-.5,6,4-3-.3-3.7-.3-6.4,1.5-5.3-.2-4,0,3.8.7.7.2.7.8.4,1.5-10,.4-19.9.3-29.7-.5-1.6-2-2.7-1.9-3.1.3-2.7.3-5.4.5-8.2.6h-2v-1.5l.3-21.2c.9-1.2,2.1-.4,1.2,1,.2,0,.5,0,.7,0,.8.3.1,15-.7,16.7.3-.6.5-1.1.6-1.7.1-1.1.2-2.2.2-3.2,0-7.2,0-14.6-.4-21.9-.7.6-1.2.3-1.5-.6-.4-3.3-.4-7.4,0-10.7l-.5-3.2v-146.9Z"
          fill="#fdfdfb"
        />
        <path d="M.9,493.7l-1,1c-.1-1,0-1.1,1-1Z" fill="#fcfbf9" />
        <path
          d="M384.1,458.7v.5c-3.2,3.1-12.8,8.2-17.2,10.6s-10.5,4.8-15.3,7.9c-4.8,1.8-9.7,3.6-14.5,5.5-.6.2-.8.1-.5-.5l.2-.6c6.4-2.4,12.2-5.3,18-8.8l1.2.4c8.1-4.3,16.1-8.8,24-13.5,0-1.5,2.3-2.5,3.5-1.5h.5Z"
          fill="#120f1d"
        />
        <path
          d="M435.1,415.2c-12,13.6-24.5,24.8-39,35.5-.7.5-1,.3-.5-.5,4.2-3.5,8.4-7,12.5-10.5,2.1-2.4,4.5-4.4,7.3-6.1,1.8-3,4.2-5.3,7.2-6.9,1.3-2.8,3.2-4.8,5.8-6.2,1.9-2.2,4-4.1,6.2-5.8.7-.7,1-.4.5.5Z"
          fill="#100f1e"
        />
        <path
          d="M453.1,391.7c-5.9,8.7-11,15.6-18,23.5l-.5-.5c.3-1.6,1.9-4.1,3.5-4.5,3.5-5.8,7.7-11.5,11.9-16.9s1.7-1.5,2.6-2c.7-.7,1-.4.5.5Z"
          fill="#14131e"
        />
        <path
          d="M474.1,355.2c-3.3,7.1-6.2,12.4-10,19-.7.7-.9.4-.5-.5,0-.4-.1-.8,0-1.2,0-1.5,5.7-11.3,7-13.7,1-1.4,2-2.8,3.1-4.1-.4-.2-.4-.3,0-.5.6-.5.7-.2.5,1Z"
          fill="#161823"
        />
        <path
          d="M464.1,374.2c-3.7,6.4-6.8,11.4-11,17.5l-.5-.5c-.2-2.3,1.3-4.7,3.5-5.5,1.2-4.4,3.9-9.1,7.5-12l.5.5Z"
          fill="#151621"
        />
        <path
          d="M488.6,313.8c0,4-2.3,9.2-3.5,13l-.5,1.5c0,.2,0,.3,0,.5l-.5,1c0,.2,0,.4,0,.5l-.5,1c0,.2,0,.3,0,.5-.4,1-.9,1.8-1.5,2.5-.1.4-.3.4-.5,0-.6-1,.9-4.3,2-5-1.3,0-1.2-.5,0-1l.5-.5c-1.1,0-.9-.4,0-1-1-2.2-.2-4,1.5-5.5-.6-3.1.3-6.6,2.5-9,1.1-1,.8.5.5,1.5Z"
          fill="#1d1e27"
        />
        <path
          d="M482.1,335.7c-1.5,4.3-3.2,8.3-5,12.5-.5.5-.7.2-.5-1,0-1.4.5-3,1.5-4,0-1.3,1.9-7.3,2.6-7.9s.5-.2.9-.1c.2,0,.4.1.5.5Z"
          fill="#1e2032"
        />
        <path
          d="M492.6,296.3c0,.2,0,.3,0,.5l-.5,2c-.2,3.3-1.4,6.2-1.5,9.5-.6,1.8-1.3,3.7-2,5.5,0-.6.1-1.2-.5-1.5-1.3-.7-.5-3.3.8-3.4l.7-3.1c-.6-.7-.3-1,.5-.5v-1c-1.1-1.8.5-6.7,2-8,.1-.4.3-.4.5,0Z"
          fill="#1e202d"
        />
        <path
          d="M396.1,450.7c-3.1,2.3-6,5-9.5,7l-1.5,1c-.1,0-.4,0-.5,0h-.5c-.1,0-.4,0-.5,0,2.3-3.8,7.4-6.9,11.5-8.5h.5l.5.5Z"
          fill="#171824"
        />
        <path d="M477.1,348.2c-1,2.3-1.9,4.6-3,7l-.5-1c-.5-2.8.9-5.1,3-7l.5,1Z" fill="#1e2028" />
        <path
          d="M482.1,335.7c-.4-.4-.4-1.2,0-1.5.2-.7,1-2,1.5-2.5-.5,1.5-1,2.6-1.5,4Z"
          fill="#292c37"
        />
        <path d="M484.6,328.2c0-.5-.1-1.1.5-1.5-.1.4.2,1.2-.5,1.5Z" fill="#292c37" />
        <path d="M386.6,457.7c-.5.3-.8.7-1.5,1,.2-.7.8-1,1.5-1Z" fill="#2b2845" />
        <path d="M484.1,329.7c0-.4,0-.8.5-1,0,.4,0,.8-.5,1Z" fill="#292c37" />
        <path d="M483.6,331.2l.5-1c-.2.7-.5.9-.5,1Z" fill="#292c37" />
        <path d="M384.1,459.2v-.5c.1,0,.4,0,.5,0-.2.2-.3.3-.5.5Z" fill="#2b2845" />
        <path
          d="M332.7,485.2c-6.1,2.4-12.1,4.5-18.5,6.2s-7,2-10.5,2.3l.5,1-2.5-.5.5,1c-2.3-.7-4.9,1.4-6.8,1.5s-.6-1-1-1c-.7,0-6,.8-6.8,1s-.4.9-.7,1c-.8,0-1.8-.7-2.8-.5s-.8,1.4-3.1,1.5-2.7-.6-3.4-.5-.2,1.8-1.3,1,0-1-.3-1c-1,0-2.4,1.3-3.5,1.5s-4.9.6-6,.6c-1.6,0-2.2-1.1-3-1.1s-.2,1-.6,1c-2.4.5-18.3.4-20.9,0s-1.9-.9-3.4-1.1-1.9-.3-1.8.5l2,.5h-8.5s1.5-1,1.5-1c-.9,0-1.8.1-2.7,0-7.6-1.6-15.6-2-23.4-2.6-3.4-.2-5.2-2.3-8.2-2s-1.1-1.4-2.2-1.4l1.3-.4c6.2.9,12.2,2.1,18.2,3.4,6.2.3,12.6.6,18.5,2l7.5.5c.6-.7,1.4-.7,2,0,4.9.6,10.6.6,15.5,0h1c.2-.8.9-.4,1.5,0,2.3,0,4.6-.3,7-.5.3-.7.7-.7,1,0,1.4-.1,2.9-.3,4.5-.5,19.2-2.5,38.9-6.3,57.6-12.6h1.9Z"
          fill="#f8faf9"
        />
        <path
          d="M336.7,482.7l.5.5c-1.5.6-3,1.4-4.5,2-15.5,4.8-31.1,9.4-47.3,11.4-4,.5-8.2,1-12.2,1.1-1.5.4-3,.4-4.5,0-.4-.1-.4-.3,0-.5,1-.6,2.1-1.1,3.3-1.3,6.6-1,13.4-1.7,20-2.3,1.5-1.2,3.3-.9,5.1-.4l1.1-.9c9.2-.9,18.1-3.8,26.7-6.8,1.8-1.1,3.6-1.9,5.7-1.3,2.2-1,4.2-1.5,6-1.5Z"
          fill="#120d1b"
        />
        <path
          d="M188.3,490.2c.6-1.4,3.6-1,4,.5l9.5,1.9c.7-.9,1.5-.4,2,.6,2.7,0,5.2.4,7.5,1.3,2.2-.4,4.1.3,6,1.2,0,.7-.9.8-2.5.5-6.4-.9-13.1-1.5-19.5-3s-5.5-1.8-8-2.5c-.4-.4,0-.6,1-.5Z"
          fill="#11111b"
        />
        <path
          d="M169.8,484.2c6.2.9,13.1,2.6,18.5,6l-1,.5c-4.3-1.1-9.3-2.2-13.5-3.5s-4-2-5.5-2.5c-.7-.5-.5-.6.5-.5.2-1.3.6-1.3,1,0Z"
          fill="#14141e"
        />
        <path
          d="M484.6,177.8c.3.1.5.5.5,1,.3.9.8,1.8,1,2.5.4,1.4.6,3.1,1,4.5.2,1,0,1.5-.5,1.5-1.5-2.5-3.2-6.6-2.5-9.5-.3-.8-.3-.9.5-.5,0,.2,0,.3,0,.5Z"
          fill="#3d4171"
        />
        <path
          d="M415.6,70.4c.4.3.9.4,1,.5s0,.4,0,.5c.3.2.1.4-.5.5-1.3.8-3.1-.6-2.5-2-1.1-.5-1.8-1.2-2-2-.3-.4,0-.6.5-.5,1.2,0,3.5,1.7,3.5,3Z"
          fill="#484f90"
        />
        <path
          d="M429.6,84.4c.1.2.4.3.5.5,0,.3-.1.5-.5.5-1.1.9-1.6.3-1-1,.4-.3.6-.2,1,0Z"
          fill="#24306d"
        />
        <path d="M434.1,89.4l-.5.5c-.4.1-.5,0-.5-.5l.5-.5c.2.2.3.3.5.5Z" fill="#3a448d" />
        <path
          d="M496.1,351.7v1c-.3.5-.3,1,0,1.5v.5c-2.9,0-.6,3.1-1.1,3.9s-1.1.3-1.5.8c-.6.8-.3,2-1,2.6s-2.8.5-3.3,1.2.4,2,0,3c-1,3.1-6.5,3.2-4,8s2.8-.2.2,4l1.5.7c-2.1,1.3-3.1.9-2,3.8l-2.5-1.5c-3,5.7,3.7,2.2,4.5,4.8s-2.1,1.5-2.4,2.5.4,1.3.4,1.9-.5,1.6-.4,1.7,2.6.5,2.7.4c1.1-.3.4-2.8,2.3-2.2s3.4,4.9,2.5,5.8c-1.4,1.3-1.9-2.5-2.7-2.5-1.4,0-.1,3.3-.3,3.5-1.3-1.3-2.5-.4-3.6-.6s-1-.7-1.7-.9c-3.1-.6-1.9,1.4-4,3-1.4-3.4-6.2,0-5.2,3-5.4-1.2-3.1-.2-5,2.2s-2.2,1-3.2,2.3-.5,3-3.1,3.8-2.3-.5-2.7.9,2.1,1,2.4,1.3c.5.5-1.1,2.2,2.6.9v1.5c-4.1-1.5-1.6,1.2-4.2,2.5l-.3-3c-1.6-.2-1.8,2-1.5,3.2s1,.3,1,.6c0,.7-1.6,2.2-1,2.7s2.1-.5,2,.5c-1.5.9-2.8-.6-3.7-.5s0,1.8-1.8.5c-.5,1.2,2,1.8,2,2.2s-1.3.6-1.4.8,1.1,3-.3,2.9-2.4-1.5-1.3-2.5c-2-.2-2.9,1.9-4.3,3l-.7-2.5c-.4-.4-6,3-7,3.8s-1.1,2-2.3,2.7-2.6.3-3.7.8c-2.2,1-3,5.1-3,7.2-2.4-1.1-5.3,0-2,1.7-1.5,1.2-2.5,3.2-1,4.7-3.5-.8-2.4,0-3.8,2s-2.2.1-.7,3.5l-3.7,1-1-2.5c-1.5.5-2.7.9-4,2-3.3,2.8-2.2,5.8-8.8,4.5-.5.5,1.4,5.7-1.5,5.5-.1-.1.4-2.1-.7-1.5s-.6,3.1-1.4,3.9-5-.7-4.8,1.8,1.6,2.1.2,2.3-1-.7-1.5-.8c-2-.2-4.7,1.5-3.3,3.8-3.7-.7-2.7.9-4,2.2s-1.1.2-1.4.5c-.4.4-.2,1.7-1.1,2.1s-5.6.6-5.9,2,.6,1.5.4,1.8c-.5.6-4,.2-4.9.3-1.9.3-5.2,2.9-5.1,4.9s4.1,3.4,3.5,6.8c-2.5,1.2-1.6-1.5-3.5-1.5-.8,1.9,2.6,5.3-.7,5s-1.9-5.8-3.8-4,.8,4.3,1.5,4.7,2.5-.2,2.5,2-1.7.5-1,1.8c1.5.4.7-1,1.5-1.7,1.9-1.9,4.4.8,6.3.8s.4-1.9,3.2-.8,2,1.4,2,1.5c.3,1.8-2.1,1.3-1.5,3.2-1,1.6-3.4.4-4.5-.8-2,2.5-4.7.9-6.9-.5-2.5,1.1-5.4.7-8.7-1-5,.3-6.5-.8-4.6-3.5-.3-2.2.2-3.8,1.6-4.9,5.2-2.9,8.1-8.1,10.9-13.1,4.4-2.5,8.5-5.3,12.5-8.3.8-1.6,1.6-3.1,2.3-4.6,1.7.7,2.8.5,4.4-.6,4-1.2,4.6-1.9,6.7-5.3s.9-.4,1-.7c.6-1.1.2-3,1.7-4,2.2-1.5,1.3.3,1.7.9,1.2,1.7,2.1-.9,2.6-1.2s3.3-1.1,4.4-1.6c.2.2.4.2.5,0,.2-.9-1.5-1.5-.5-2.2s3.2-.5,4.5-1,4.7-3.4,6-4.5c5-3.9,9.9-8.7,14-13.5s4.5-2.9,6.2-4.3,3.5-4.1,3.6-4.5c.5-1.5-.8-1.9-.6-2.5.5-1.3,2.4-2.1,3.1-3s1.8-4.6,2.5-2c2.7.1.9-1.6,1.5-3s5-6.1,5.5-6.5c1.1-.9,3.1-1.5,4-2.5,1.8-2,0-3.3,4.2-1.5-1.3-3.6,1.4-4.4,3-6.2s3-5.1,4.3-7.7,1.5-1.1,1.7-1.9-.8-1.7-.8-2.4.9-1.5,1.1-2.2c.9-4,0-2.5,2.1-6.3s.1-7.5,4.6-5.7c.6-1.6-1.2-1.3-1-2.2.4-1.9,3-3.4,3-3.6.2-.8-.3-2.7,0-3.1s2.2-.2,3-1.3.4-1.8.9-2.5c.8-1.1,3.9-3.8,4.3-4.7.7-1.5,0-4.2,2.3-5.2s1.6,3.6,4,4.3Z"
          fill="#fdfbfa"
        />
        <path d="M496.1,354.2c-.6-.5-.6-1,0-1.5v1.5Z" fill="#fdfdfd" />
        <path d="M409.1,453.7c.1,0,.5,0,.5,0l-.2.5-.2-.5Z" fill="#fcfbf9" />
        <path d="M374.1,490.2c-.5.5-2-1-1.5-1.5s2,1,1.5,1.5Z" fill="#fcfbf9" />
        <path d="M412.1,455.7c-.3-.6.8-1.7,1-1.5.3.6-.8,1.7-1,1.5Z" fill="#fcfbf9" />
        <path d="M429.6,441.7c-1.1-.4-1.2-.8-.2-1.5l.2,1.5Z" fill="#fcfbf9" />
        <path d="M420.1,449.7c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#fcfbf9" />
        <path d="M402.1,462.7c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#fcfbf9" />
        <path
          d="M91.8,456.2c3-2.7,5.5-.4,7.5,2.4,1.9-1.5,4-.8,6.2,2.2l1.4.7c1.1-3.8,2.8-4.9,5-3.3,1.2-.4,1.3,0,.5,1,.6.3.9.6,1,1l.5.5c3.3,0,5.6,1.2,6.7,3.4,4,1.2,8.2,2.8,10.8,6.4h1.5c8.4,4,17,7.9,25.5,11.5v.7c-1.4-.6-1.5,2.8-1.4,3.2s2.4,5.1,2.6,5.3c.9.8,3.2.5,4.4,1.5s.5,1.6,1.2,2,3.9.2,2.6,2-3.3,0-4,0c-.1.2.6,4.2.7,4.5.6,1.2,3.3.9,2.8,2.7s-4.5,0-5.5,1.3H-14.1c1.8-1.3,4.8,0,6.7-.6s1.4-2.8,2.6-3.4c1-.2,1.1,1.4,1.8,1.7,3.8,2.2,9.5,1.5,13.7,1.3s10.6.6,16.3.5l.5-1c3.3-1.1,5.8-1.8,9.3-1.7,3.9-3.2,6.8-3.7,8.6-1.3,2.1-.6,3,.2,4.4,1.7,4.3,1.7,9.7,2.3,14.1,1.2-5.4.2-3.4-3.3.4-5s6.7-.3,6.8,2.3c1.8-2.8,4.2-2.6,5.4.5,1.2,0,2,.7,2.7,1.5.7-6.2,6.6-3.7,10.3-1.8,4.4,1.3,8.9,2.1,13.5,2.6l1.5-.8c3,.4,6.1.7,9.1,1.1,1.8-2.8,4.9-3.3,9.2-1.3,3.4-3.1,6.7-3.6,9.9-1.6.8-.9,1.5-1.3,2.5-.4,2.2-2.3,6.3.3,4.1,3.1l4.3-.6c-.2-2.4.4-4.2,2-5.4l-2.9-4.6c-3.4,1.8-8.2-2.3-9.4-5.4-3.7-1.8-6.9-4-9.6-6.8-.2-1.7-1.4-2.8-3.7-3.4-2-2.3-3.7-4.9-5.2-7.8-2.1-.9-3.8-2.1-5.1-3.6-2.2.9-4.7,0-7.4-2.7-1.3,1.2-2.5.7-3.5-1.3-2.5-1-4.7-2.5-6.6-4.5v-1.3Z"
          fill="#fdfdfc"
        />
        <path
          d="M168.3,484.7c1.5-.1,5.2,1,5.5,2.5-2.7.3-4.9-.4-7.4-1.4s-5-2.1-8.1-3.1-3-2.3-4.9-2.7c-4.5-.8-10-3.4-14.5-5.5s-4.1-2.8-5-3-2.2.5-3.2-.1-2.6-3.9-4.8-4.7-1.2.2-1.6,0c-1.8-.6-2.2-2-4.9-.9,1.4-4.7-4.1-2.9-6-4.3s-.4-.6,0-1.2l-1-1c-.1-.2-.3-.7-.5-1-.4-.7-1.3-1.2-.5-2l1.8.6c17.3,11.3,35.9,20.5,55.2,27.9Z"
          fill="#fcfbf9"
        />
        <path d="M112.3,459.2l1.5.5c.1.4-.4.4-.5.5-.6-.2-.7-.6-1-1Z" fill="#fdfdfd" />
        <path
          d="M391.1,465.7l-2.8,2.5-1.2-1.5c-.4,1.1-.6,2.7-1.1,3.6s-5.7,5-7.1,5.9c-4.3,2.8-6.3,1.7-8.3,7.6s-5.1,6.5-6.4,7.6-2.6,1.5-3.2,2.3c-1.2,1.6.7,3.9-1.8,5.2,1.2,1.3,3.3.5,5.1.9s4.5,1.7,5.7,1.9,2.2-1,2.9-.9,2.7,2,4.6,1.9,1.5-1.6,2.4-1.4,1,1.1,1.7,1.4,2,.4,2.6.6c3.6,1.4,7.1,2.3,11.2,1.5s1.5-1.2,2.4-1.6c2-.9,3.9-1.1,5.9-2.4-1.2,1.8,3.1,2.2,4.5,1.5l-3-1.7c-.3,0-1.5.2-1.5.2,1.1-.7.8-2.1,3.7-1.5s2.1,0,5,0,3.8.8,7.5-.5,5.1-.5,6-.5c1.6,0,2.6,1.3,4,1.1s.3-1.8,1-2,2.1,2.3,3.5,2.5,2.8-.8,4.1-.9,8.8.3,9.8.5.9.9,1.5.8c1,0,2.6-1.9,3.7-2.3,1.8-.6,5.9-.7,6.9,1.4s-1,2.1-.7,3.2,2.4,2,2.9,2.1c2,.4,6.9-2.2,7.8-4.2-.7,2.4,5.9,5.3,6.1,2.8-2.1-1.9-1.2-4.4,1.1-5.5s3.1.9,4.5,0,.9-3.1,1.7-3.2c1,.2,5.6,1.5,6,1.5.6,0,1.1-2.8,1.3-3s4,1,5,.5v12h-132.4l-28.1-1.6c-2.7-.2-.6-2.2-.9-3.5s-2.4-1.2-1-3.6,4.1-.3,5,1.1-1.1,2.6,1.5,2.2c-.2-1,.3-3.8,0-4.4s-2.8.2-1.7-2.1,6.2-3.2,8.4-4.1,1.3-1.3,2-1.5,1.6.3,2.3,0,2.8-2.5,3.3-2.9.9-1.7,1.6-2.1,3.4,1.9,4,1.2-.1-.8,0-1.1c1.7-2.6.3-2.4,3.4-4.4,1.5,4.4,5.8.2,8-1.2s1.7-.3,2.2-.8c.9-.7.5-2.3,1.4-3.1s1.4,0,2.1-.3c1.1-.5,2.4-1.8,3-2,1-.3,2.4.2,3.2-.3,1.2-.8.7-5.7,3-5s.8,1.4,4.4.3Z"
          fill="#fefdfb"
        />
        <path
          d="M-3.6-4.1C-1.5-3.4-.4-2.1-.5,0c3.8-1.2,4.9.4,6.6,3.6,4.9,4.7-2,4.7-5.2,2.2,2.1,1.3,3.3,3.8.4,4.7.6,2,.9,3.6-1.8,3.6-.4.3-.5,1.3-.5,1.8,3.2,1.7,3,4.5-.7,8.6h-.5c-1.2.7-2,2.2-2.4,4.4h-1.1c-1.4.9-2,1.9-1.8,3.1l-.7.9c0,1.6-.4,3-1,4,.9.9.3,1.6-2,2,.3.7.4,1.3,0,2,0,0-.5.6-.3,1.1.4,1.5,1.5,2.6,1.3,4.6s-1.6,2.9-1.5,4.5,1.5,1.9,1.5,3.5-1.2.5-1.1,1.4,1.1,2.6,1.3,2.8c.9,1,2.3.2,2.3,2.3s-1.7,1.8-2.8.3c-2.6,1.8,2.8,2.4,3.5,3.5s-.7,2.4-.3,3,2.3.3,2.7,1,.1,1.9.2,2c.2.2,4.5-.8,5.5-.8,1.6,0,.2,4.9,0,5.9-.4,1.5-1.8,4.4-2.2,6.4s-.1,3,0,3.2c.4,1.5,2.2,1.2,2.4,1.3.4.4-1.1,1.9.3,2.4s2.7-.9,2.2,1.6c-2.2-1.2-3,.7-5,1.2.9,1.9,3.5.8,4.5,1.5s.7,1.6.5,1.8c-.4.4-3.8-1-3.4,1.6s5.7.4,7.9.4c.4,1.6-1.6,1.3-1.9,1.6s0,2.9-.7,3.3-1.9,0-3.1.6c-2.6,1.3-2.8,4.5-3.7,6.8-1.7,4-3.7,7.4-5.5,11.5s-1.4,1.4-1.6,2c-.3,1,.9,1.6,1,2.4s-1.3,1.7-1.5,3c-.9,5.8,1.8,11,2.4,16.5s-.3,1.2-.3,1.9.8.9.8,1.6-3.2,8.6-3.4,9-1.2.1-1.6.6c-1.9,2.4,2.6,4.1,3.3,5.7s-.3,2.6,0,3,3.3,2.5,3.5,2.5c1.1-.2.8-2.8.3-3.5,3.9,1.4,3-1.5,4.3-3s1.3-.3,1.8-.8,7.4-14,7.7-15.1,0-2.7.3-3.7c.5-1.6,4.4-1.2.9-5.6.5-1,1.8-.3,2-.5.5-.4.4-1.3.7-1.8s1.2-.4,1.5-.7c2.9-2.9,3.4-5,5-8.3s4.2-3.6,4.7-5.8c-.4-.5-2.2.9-2.5-.5s1-.9,1.3-1.4.6-2.8,1.4-1.4,0,2,1,1.5.4-3.1,1.3-4c3.4,2.4,1.8-1.8,2-2s2.9-.1,3.7-1.5-1.1-5.3,2.8-4.5c-.8-2.4,0-2.7,1-4.5,3.7-2.1,5.9,2.5,1.5,3.6.5,2.2,0,3.5-1.4,4,.3,2-.9,2.4-2.6,2.6l-1.9,3c1.4,2.2,1,4.5-1.3,7.1-.2,2.5-1.3,3.4-3.7,3.3.3,3.6-1,5.4-4,5.6-.7,2.2-2.3,5.3-5,4.4l-1.1,1.6c-1,4.9-1.7,9.7-1.9,14.7-2.6,2.7-3.2,3.8-3.1,7.6-2.4.7-3.3,2-2.9,4.1,1.3,3.6.9,6.4-1.1,8.4,0,3.2-.3,6.2-1.1,9.1-2.2,1-3.1,2.7-2.5,5.2-6.7,7.3-8.9,16.6-9.4,26.3l-.9,1.3c1.7,4.8-3.8,5-5.8,1.8-1-7.3-3.4-1.2-2.6,2.9-.7,1.2-1.5,1.2-1.9,0,0-2,0-4,0-6,.4-.8.4-1.7,0-2.5,0-.3,0-.7,0-1v-1.5c0-.2,0-.3,0-.5l.7-1.6c3.1.2,6.1-4.5,1.8-1.8-.6-.9-1.5-1.2-2.5-1.1,0-4.7,0-9.3,0-14v-2c0-6,0-12,0-18,1.9.2,1.8,2,2.5,3.3s-.3.9,1,.7c0-3.1,1.8-5.9.9-9.2s-1.4-.3-1.7-.7c-.8-1.5.4-5.7-.2-7.7,4.9-2.1,1.2-4.9.9-7.5s1.4-3.6,1-5.5-2.1-1.3-2.8-2.3-.6-1.3-1.4-2.5c-1.9-2.7,3-3,4.1-3.8s.7-3.9.3-4.8-3.8-.7-2-3.5,1.8-1.8,2.1-4.3-1.5-4.8-1.4-6.4.9-1.8,1.1-3c.4-2.5-.5-5.3-.5-7.5s1.6-3.7,1.5-6-.4-5.2-.5-5.4c0-.5-1-.5-1.3-.8-1.6-2.4,3.5-7.9,1.3-10.8s-1.8-.2-2.1-.4c-1.3-1,.2-3.8,0-5.3l-3,1c.1-1.5-.2-3.2,0-4.7s1-1.4,1-2.5-1-.4-1.1-1.4-.1-4.7,0-5.4,1-.3,1-.6c.1-.9-.9-1.8-1.1-2.9s-.2-8.1.5-8.5,1-.2,1.5-.2c-.7-1-1.2-1.7-1-3l1.3.5c1-2.5-.7-.8-1.3-1.2-1-.7-2.1-8.4.5-8.3,0,.9.5,1.8.5,2.7s-1.1,5,.5,3.3.6-4.7.2-5.6c-.7-1.7-2-.8-1.7-3.1s2.4-2,3.4-3.6.9-5.3.5-6.4-2.5.3-2-3,1.5-.1,2-.5.8-8.5,0-9c-1.2-.9-3.1.4-2.5-3.2,3.6,1,2.4-1.9,3.1-2.4s2.5,1.2,1.9-2c-3.2.5-1.6-.9-2.1-3.2s-3.1-3.7-.1-4.3,2.9.1,3.7-2.5c1,.4,1.9.8,3,1Z"
          fill="#fdfdfb"
        />
        <path
          d="M18.9,135.8l.7,1c-.9,5.1-1.6,10.2-1.9,15.4-.5,1.4-1.4,2.7-2.7,3.8.5,3.3-.5,5.3-3.1,6.1-.2,2.5,0,5,.5,7.6-1.5,1.8-2,3.6-1.5,5.4l-1,3.5c.8,3,.6,4-2.6,4.6-.5.6-.6,1.6-.2,2.9-6.1,6.5-8.5,14.6-10.1,23.2-.7,1.3-.3,1.6-.5,2.5.3.9.2,1.9-.2,3,.7,1.6.5,4.7-1.8,4-.5,0-1.2.5-1.5.5-1,0-2.8-.7-4,.2s.1,3.2-1.7,3.2c-3.1,0-2.7-1.8-2.8-4,1.5.3,1-.8,1-1.7s-.3-3,0-3.9,1.7-.9,1.9-1.6c.4-1.2-1.8-1.7-.2-2.7l2.5,4.5c-.1,3.9,1.2,3.6,4.7,3.5.3-1-.7-2.4-.5-3.2s1.1-.6,1.5-1.1c1-1.4,0-2.9,0-4.5.1-2.9,1.2-9,2.5-11.4s1.2-2.9,2.3-5.3,3.5-2.7,4-5-.5-2,0-3,2.8-2.2,3.2-3.4c.7-2.2.1-6.7.7-8.3s1.8-.8,1.9-2.1c.2-2.1-2.2-7.8-.2-9.2s2-.4,2.2-.6c.2-.3-.1-3.3.3-4.5.5-1.7,2.5-1.9,3.1-3.4s0-4.3.3-6.2,1.1-6.5,1.6-7.9,1.2-1.3,1.9-1.9Z"
          fill="#fdfdfb"
        />
        <path
          d="M496.1,107.4l-.5-1.2c1-3.2-1.2-3.3-2-5s-.8-6.3-4.3-3.8,1.5,3-.5,5-7.7,4.4-9.2,4.7-1.8-.4-3.1,0-6.2,5.9-6.9,3,1.2-2.6,0-3.5-3.2.5-4.5.3c0,.3,0,.7,0,1-1.4.3-1.3-1.8-2.5-2.5,2-.3,1.4-1.9,1.5-2,.2-.2,1.9.5,2.6.4,1.9-.3,2.1-2.2,1-2.4-1.6-.4-2.5,1.9-3.7.3s0-2.3,0-3.5-1.6-2.7.1-2.1.7,1,1.5.7,3-4.6,3.3-5.4l1.7,1.5-1.5.7-1.5,3.3c2.3.8,4-1.3,6-2.2l-3-1.2c1.5,0,1.3-1.6,2-2.2s2.2-.7,2.8-1.4.6-2.2,1.2-3c1.5-2.3,4.2-1.4,6.2-2.3s1.2-1.5,1.5-1.6c.7-.1,1.6.5,2.3.4s.9-.8,1.6-.8c3.4-.4,6.2,4.5,7.7-2.5v27.5Z"
          fill="#fdfbfa"
        />
        <path d="M485.6,97.4c.4-.8-1.2-4.9.2-5,2,0,3.6,5.3-.2,5Z" fill="#fcfbf9" />
        <path d="M486.1,90.4c-.3.3-1.7-.1-2-.8-.7-1.7,3-.2,2,.8Z" fill="#fcfbf9" />
        <path d="M488.6,90.9c-.2-.2-.3-1.9.7-1.5,1.5.6-.3,2-.7,1.5Z" fill="#fcfbf9" />
        <path d="M465.6,98.9c-.6.6-1.6-.2-.2-1,.4,0,.3,1,.2,1Z" fill="#fcfbf9" />
        <path d="M467.1,97.4c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#fcfbf9" />
        <path
          d="M489.6,195.3c0,.2,0,.3,0,.5l.5,1.5c.2.4.2.7,0,1l.5,1c0,.2,0,.3,0,.5.3.4.4,1.1,0,1.5l.5.5c0,.2,0,.3,0,.5.2.6.3,1.3.5,2,.3,1.9.8,3.4,1,5.5l.5,1.5c0,.3,0,.7,0,1,.4.7.4,1.9-.5,2-1.1,0-1.1-1.2,0-1.5l-.5-1c-1.6-2.1-1.9-5.9-1.5-8.5l-.5-.5c-.6-.4-.8-1.2-.5-2.5-1.1-.8-1.7-4.4-1-5.5.1-.4.3-.4.5,0,.2-.3.4,0,.5.5Z"
          fill="#353b65"
        />
        <path
          d="M489.1,193.3l-.5,1c-1.5-1.6-2.1-4.8-2-7l.5-1.5c.7,2.5,1.8,4.8,2,7.5Z"
          fill="#4b4a78"
        />
        <path d="M491.6,204.3c-.8-.4-.5-1.3-.5-2h.5c0,.6-.1,1.4,0,2Z" fill="#3b3c63" />
        <path d="M491.1,201.3c-.2.3-.3.3-.5,0,0-.5,0-1,0-1.5.7.3.5,1,.5,1.5Z" fill="#3b3c63" />
        <path d="M490.1,197.3c0-.2-.8-.8-.5-1.5,0,.3.3.7.5,1.5Z" fill="#3a3d60" />
        <path d="M489.6,195.3l-.5-.5c-.4-.3-.4-.7,0-1,.7.3.4,1,.5,1.5Z" fill="#3a3d60" />
        <path
          d="M489.1,193.8c0,.3,0,.7,0,1h-.5c-.4-.2-.4-.3,0-.5,0-.4,0-.8.5-1,0,.2,0,.3,0,.5Z"
          fill="#222a55"
        />
        <path d="M490.6,198.3c-.1.4-.3.4-.5,0,0-.3,0-.7,0-1,0,0,.4.4.5,1Z" fill="#748ccc" />
        <path d="M490.6,199.3c-.5-.1-.4-.6-.5-1h.5c0,.3,0,.7,0,1Z" fill="#3a3d60" />
        <path d="M491.1,201.8c-.2,0-.5-.3-.5-.5h.5c0,.2,0,.3,0,.5Z" fill="#3a3d60" />
        <path
          d="M493.6,215.3l.5,2c0,.5,0,1,0,1.5l.5,2c0,.3,0,.7,0,1l.5,2c0,.5,0,1,0,1.5.3.6.4,1.5,0,2,.3.4,0,.6-.5.5-.9-.2-.8-1.2,0-1.5l-.5-2c-.9-.2-.9-1.7,0-2l-.5-1c-.8-.5-.9-1.6,0-2-.3-.4-.3-.7,0-1l-.5-.5c-1-.6-1.1-2,0-2.5-.2-.1-.2-.3,0-.5.2-.2.3-.2.5,0,0,.2,0,.3,0,.5Z"
          fill="#212c58"
        />
        <path d="M495.1,222.8c0,.3,0,.7,0,1-.8-.3-.5-1.3-.5-2,.5.1.5.6.5,1Z" fill="#29376f" />
        <path d="M494.6,220.8l-.5-2c0,.2.4,1.1.5,2Z" fill="#313b62" />
        <path d="M494.1,217.3c-.8-.3-.5-1.3-.5-2,.8.4.4,1.4.5,2Z" fill="#283460" />
        <path
          d="M493.6,214.3l-.5.5c0,.2,0,.3,0,.5-.9,1.3-1.8-.4-.5-1,.1-.6.5-.8.5-2,.8.3.5,1.3.5,2Z"
          fill="#38406a"
        />
        <path d="M493.1,211.3c0,0-.4-.5-.5-1.5l.5,1.5Z" fill="#38406a" />
        <path d="M493.6,214.8h-.5c0-.2.3-.4.5-.5,0,.2,0,.3,0,.5Z" fill="#283460" />
        <path
          d="M494.6,282.3c-.1,1.1,0,2.4,0,3.5,0,.2,0,.3,0,.5l-.5,3c0,.2,0,.3,0,.5l-.5,3c0,.2-.4.5-.5,1l-.5,2c0,.2,0,.3,0,.5h-.5c-1.5-1-.4-4.1.5-5.5-1.2-2.9-.2-6.9,1.5-9.5-.3-.7-.3-1.2,0-1.5.9-.2,1.1.6.5,2.5Z"
          fill="#181b30"
        />
        <path
          d="M496.1,292.3v4c-.4.9-3.2,2.9-3.4,3.1-.3.5-1.6,7.2-2.1,8.9-.3-.2-.5-.3-.6-.5-.2-.9,1.3-7,1.7-8.5s.2-.3.3-.5l.5-2c-.4-.1-.4-.3,0-.5-.3-.1-.3-.3,0-.5l.5-2c-.6-.5-.3-1.3.5-1l.5-3c-.4-.2-.4-.3,0-.5l.5-3c-.4-.1-.4-.3,0-.5,1-6.2,1.5-.4,1,2.7l.5,3.8Z"
          fill="#f6f4f2"
        />
        <path
          d="M496.1,283.3v9l-.9-3.8.4-5.2c-.4,0-1,2.2-1,2.5-.9-.5-.6-2.7,0-3.5,0-.6.2-1.1.5-1.5.6.1.9,1,1,2.5Z"
          fill="#ebebeb"
        />
        <path d="M494.1,289.3c0-.9-.4-2.4.5-3-.1.9.4,2.4-.5,3Z" fill="#ebebeb" />
        <path d="M493.6,292.8c0-.9-.4-2.4.5-3-.1,1.4,0,1.6-.5,3Z" fill="#ebebeb" />
        <path d="M492.1,298.8c0-.7-.3-1.6.5-2,0,.7.3,1.7-.5,2Z" fill="#231e49" />
        <path d="M492.6,295.8c.1-1,.3-1.2.5-2l-.5,2Z" fill="#231e49" />
        <rect fill="#ebebeb" height="2" width=".5" x="494.6" y="289.8" />
        <path
          d="M495.6,269.8c0,.7,0,1.3,0,2s0,1.3,0,2,0,1.7,0,2.5c0,1.3-.3,3.1-.5,4.5s-.5,1.4-.5,1.5c0-.8.3-2.1-.5-2.5-1.2-1.7-.6-4.3.5-6,.1-1.4.2-3.3,1-4.5,0,.2,0,.3,0,.5Z"
          fill="#1b1f3b"
        />
        <path d="M495.6,226.3c0,.3,0,.7,0,1-.1.4-.3.4-.5,0v-2c.5.1.5.6.5,1Z" fill="#29376f" />
        <path
          d="M495.6,228.3c0,.3,0,.7,0,1v3.5h-.5c0-1,0-2,0-3-.4-.8-.5-2.2.5-2,0,.2,0,.3,0,.5Z"
          fill="#0e1556"
        />
        <path
          d="M495.6,227.8c-.7.3-.5,1.3-.5,2-.8-.4-.4-1.4-.5-2l.5-.5h.5c0,.2,0,.3,0,.5Z"
          fill="#202c6f"
        />
        <path
          d="M121.3,42.9c.6.7-.2,1.2-1,1-.5.6-1,1.2-1.5.5-.4-.1-.4-.3,0-.5.3-.2.7-.3,1-.5.3-.4.6-.6,1-.5h.5Z"
          fill="#2b3068"
        />
        <path
          d="M242.7,6.9c-4.3.6-8.6,1.1-13,1.5l-1-.5c-.9-.2-1.7-.3-2.5-.5,1.5-.9,4.1-.5,6-.5,2.5-.4,5-.5,7.5-.5.2,0,.3,0,.5,0,.9.2,1.7.3,2.5.5Z"
          fill="#4451bc"
        />
        <path
          d="M199.7,12.4c-.7.3-1.8.8-2,0v-.5c.2,0,.3,0,.5,0,.6,0,1.2-.1,1.5.5Z"
          fill="#2f27ab"
        />
        <path
          d="M183.3,16.4c0,1.2-.6,1.2-1,0l-.5-.5c.2,0,.3,0,.5,0,.4,0,.8,0,1,.5Z"
          fill="#3736aa"
        />
        <path d="M159.3,24.4c-.2.4-.3.4-.5,0l-.5-.5c.1,0,.4,0,.5,0,.2,0,.4.3.5.5Z" fill="#2a1c77" />
        <path d="M357.7,30.9v.5c-.4-.1-.9.1-1-.5.3,0,.7,0,1,0Z" fill="#5152a9" />
        <path
          d="M362.6,33.9c.3.1.3.3,0,.5-2,0-3.9-.9-5-2.5v-.5c.2,0,.4,0,.5,0,2.3.8,3,1.7,4.5,2.5Z"
          fill="#5152a9"
        />
        <path
          d="M368.6,36.9c0,.3-.4.3-1,0-1.7.4-4.3-1-5-2.5v-.5c2.1,1.1,3.8,1.7,6,3Z"
          fill="#524f9f"
        />
        <path
          d="M375.6,40.4v.5c.5.2.9.4,1,1-1.2.9-4.5-1.1-4.5-2.5-.6-.2-1-.6-1-1,1.6.4,3.1,1.2,4.5,2Z"
          fill="#52549c"
        />
        <path
          d="M380.6,43.9c0,.3-.3.3-1,0-.7.8-3-.5-2.5-1.5-.7-.7-.4-1,.5-.5,1.1.6,2,1.4,3,2Z"
          fill="#5551a1"
        />
        <path d="M368.6,36.9c.9.5,1.5.9,2.5,1.5s.6.7,1,1c-.9,1-4.6-1.3-4.5-2.5h1Z" fill="#4e53a1" />
        <path
          d="M377.6,41.9l-.5.5c-.7.7-1,.4-.5-.5-.3-.3-.7-.6-1-1h.5c.6.3,1,.7,1.5,1Z"
          fill="#545399"
        />
        <path d="M376.1,40.9h-.5v-.5c.2.1.3.4.5.5Z" fill="#7cc7f0" />
        <path
          d="M403.1,59.4c.7.5,1.7,1.9,2.5,2.5l-.5.5c-1.1.4-4.4-1.8-4-3-.7-.3-.8-.6-.5-1-.3-.2-.3-.3,0-.5.8.6,1.9,1,2.5,1.5Z"
          fill="#4a599b"
        />
        <path
          d="M393.1,51.9c.4.3.5.6.5,1,.3.1.3.3,0,.5-.7-.1-1.6-.6-2.5-1.5-.5.1-.6,0-.5-.5-.7-.7-.4-1,.5-.5.6.4,1.4.6,2,1Z"
          fill="#3f4a8d"
        />
        <path d="M400.6,57.9l-.5.5c-.9.2-2.5-1.1-2-2v-.5c.9.7,1.7,1.3,2.5,2Z" fill="#535793" />
        <path
          d="M391.1,50.9l-.5.5c-.8.8-2,0-1.5-1-.9-.5-1.2-1.6,0-1,.8.5,1.4,1.1,2,1.5Z"
          fill="#595c9d"
        />
        <path
          d="M397.1,55.4c.3.1.3.3,0,.5-.7.5-2.1-.7-2-1.5-.7-.7-.4-1,.5-.5.7.6,1.1,1.2,1.5,1.5Z"
          fill="#4d4c88"
        />
        <path
          d="M395.6,53.9l-.5.5c-.6.3-1.4-.4-1-1-.3-.1-.3-.3,0-.5.5.4,1,.6,1.5,1Z"
          fill="#3e3479"
        />
        <path d="M398.1,55.9h-.5c-.1.4-.3.4-.5,0v-.5c.2.1.6.2,1,.5Z" fill="#392b69" />
        <path d="M394.1,52.9c-.1.3-.3.3-.5,0l-.5-1c.5.4.8.8,1,1Z" fill="#8abce3" />
        <path
          d="M386.1,47.4c.6.6.4.7-.5.5-.7.2-2.3-.7-2-1.5-.7-.6-.4-.8.5-.5.7.5,1.4,1.1,2,1.5Z"
          fill="#585a9e"
        />
        <path d="M380.6,43.9c.5.3,1,.7,1.5,1,.6.4.8.7.5,1-1.3.2-2.8-.7-3-2h1Z" fill="#4955af" />
        <path d="M384.1,45.9l-.5.5c-.6.6-1,.3-1-.5l-.5-1c.5.3,1.3.5,2,1Z" fill="#584694" />
        <path
          d="M389.1,49.4l-.5.2c.2.2.3.6.5.8-.1.4-.3.4-.5,0-.8-.5-1.2-1-1-1.5-.4-.2-.4-.3,0-.5.5.3,1,.7,1.5,1Z"
          fill="#5a5fa2"
        />
        <path d="M387.1,47.9v.5h-.5c-.6.4-.9.2-1-.5l.5-.5c.3.2.7.3,1,.5Z" fill="#2b3381" />
        <path d="M387.6,48.4c-.2.3-.3.3-.5,0v-.5c.2.1.3.4.5.5Z" fill="#7cc7f0" />
        <path
          d="M313.7,14.9l-.5.5c-.6-.2-1.1-.4-1.5-.5-.1-.3.2-.5,1-.5.5,0,.9.5,1,.5Z"
          fill="#4964c6"
        />
        <path d="M314.7,15.9c-.3,0-.4-.5-.5-.5l.5.5Z" fill="#4964c6" />
        <path d="M290.7,9.9v.5c-.7,0-1.3,0-2,0,.3-.8,1.3-.5,2-.5Z" fill="#275cbb" />
        <path
          d="M319.2-7.1c-3.4,4,3.4,3.7,5,4.7s.4,1.5,1,2,1.9.4,2.4.9.3,2.1,1.1,2.6c2.4,1.7,8.6-.1,9.5.5,1.1.9-.3,2-.3,3,0,2.9,5.6,2.3,6.6,3.7s0,2,.5,3,2.4,2.9,2.6,2.9c.9.3,2.1,0,3.2.3s1.5,2.3,4.3,2.3,1.6-.8,1.9-.8.9.7,1.5.8c2.8.4,2.9-.8,4.6-1.4s2.4,0,2.6-.2-.2-1.4.3-1.5c1.5-.3,3,1.8,4.8,1.5-1,3,.5,1.8,1.3,2.7s.7,1.3,1.4,1.9,2.3,1.5,2.5,1.9-.8,2.7.5,3,1-2.8,4.4-1c2.5,1.3-.6,2.6-.6,2.7-.1,1.6,2.4,2.6,3.3,3.2,1.5,1.1,1.2.8,2.6,1.6s.6,2.1,2.1,1.3.3-2,1.6-1.2,2,2.7,2,3c0,.8-1.9,2.7-.9,4.2s5,.7,6.1,1.2.8,2.3,2.3,1.1c.2-.5-.6-1.6-.5-1.7,1.9-1.4,1.4,2.2,2.1,2.9s2.4.4,3.4.9,2.5,2.1,3,2.7l-.8.9c-3.7-.4-7.3-1.2-10.7-2.4-.8-2.3-1.8-2.5-3.1-.9l-1.7.4c.8,1,1.6,2.1.3,3,.8.2,1.1.5,1,1,.8-.8,1.3.8,0,.5-.2.2-.4.3-.5.3-1-.4-1.8-1.1-2.6-1.7-2-1.5-5-4-6.2-6-2.7,1.5-4.2-.5-4.3-3.2-1.8.4-4.2-.8-5.3-2-2,.2-3.3-.4-4-1.8-4.2-1.8-8.4-3.6-12.6-5.5-.1.7-.6.5-1,0l-2-1c-.8-.1-1.5-.3-2-1-2.6-.7-4.9-1.7-7-3l-.5-.5c-.2.4-.3.4-.5,0-.6,0-.9-.2-1-.5h-.5c-.5,0-.8-.2-1-.5l-.5-.5c0,.6-.7.5-1,0-.5.3-1,.1-1-.5l-.5-.5c-.9.6-2.7-.2-3.5-1h-.5c-.4.3-1,0-1-.5l-1-.5c-.1.4-.3.4-.5,0l-.5-.5c-1.1.3-2.8-.2-3.5-1h-.5c-1.1.1-2.1-.3-3-1-1.8,0-2.8-.6-3-1.5-.7-.2-1.4-.3-2-.5-.1.4-.3.4-.5,0-2.1-.9-4.3-1.6-6.5-2-.2.3-.3.3-.5,0-1.8-.7-3.6-1.2-5.5-1.5-.1.3-.3.3-.5,0-1.4-.3-2.7-.6-4-1-1.7.3-3.3.1-5-.5-.9-.2-1.7-.3-2.5-.5-.7.2-1.6.3-2-.5h-1c-2.1,0-3.8-.3-5-1-.4.2-.7.4-1,0-.9-.2-1.7-.3-2.5-.5-.5.4-1,.4-1.5,0-1-.2-2-.3-3-.5l-3.5-.5c0,.4-.3.4-.5,0-.5.3-1,.4-1.5,0-.8,0-1.3-.2-1.5-.5-1.6.3-3.1.3-4.5,0-.4,0-.6-.2-.5-.5l-1.9-.7c-10.2.3-20.4.2-30.6-.2l-5.5-1.2c-1.8,1.8-3.6,2.4-5.3,1.8-8.3,2.3-16.8,3.7-25.5,4.2l-1.1-.9c-2.6.1-2.5-4.2-.3-5.4l3.6-1.9c-1.9-4.8-.8-5.8,3.8-6.3-.4,0-.3-.3.4-1-.4-1.1.5-1.8,1.5-2h113.9Z"
          fill="#fdfdfb"
        />
        <path
          d="M356.7,30.4c.5-.1,1.7-1.5,2.5-1s-.4.7-.4.9c.4,1.2,4.4,2.1,5.3,2.5s4.2,2.9,3.1.9c1.4-1,.7,1,.9,1.2s1.4-.2,1.9.1.5,1.9.6,1.9c.1,0,1.4-1,3.2,0s.3,1,.6.9c.4,0,1.3-.7,1.8-.4s-1.2,2.3,3.5,1v2.5s2.5,0,2.5,0l-3,1.5c1.7,0,2.8,1.3,2.7-1l2.3,1c-1,1.2,2,2.8,2.8,3.4,1.8,1.5,1.2,3.2,5.2,4.5s1.8-.5,2.3,1h.7c1.3.1,2.4.6,3.3,1.4,1.6-1.2,3.2.3,1.8,1.9,1.4.8,2.2,1.7,2.4,2.7,1,.2,1.3.5,1,1,.4.1.4.3,0,.5l-.5.5c-.7.9-2-.5-2.5-1.5-1.1,0-1.9-1-2.5-2-.5,0-.8-.2-1-.5-.7-.1-1.5-.8-1.5-1.5-.6.3-1.2-.4-1.5-1l-1-1c-.5.6-1.9-.2-2-1-.8.1-1.9-.7-2-1.5-.7.3-1.1-.3-1.5-1l-.5-.5c-.4.4-1,0-1-.5-.7.2-1.9-.8-2-1.5-.7.4-1.5-.4-2-1-.6.1-1.3-.4-1.5-1-1.1-.4-2.5-.9-3-2-.6.1-1.2-.4-1.5-1l-.5-.5c-1.5-.1-3-.8-4.5-2-.8,0-2.1-.7-2.5-1.5-2-.8-4.3-1.7-6-3-1.5-.5-3.4-1.4-4.5-2.5l-.5-.5c-.3.4-.7.3-1,0-.4-.1-.4-.3,0-.5Z"
          fill="#fdfbfa"
        />
        <path
          d="M343.7,24.9c.2,0,.4,0,.5,0l.5.5c2.9.9,4.4,1.8,7,3,0,.2-.4.2-1,0-.2.2-.5.3-.7.3-.3,0-1.2-.3-1.6-.5-1.9-.8-4.1-1.9-5.7-2.8-.5-.6.5-.9,1-.5Z"
          fill="#4b5fbb"
        />
        <path
          d="M338.2,22.4l.5.5c.4.2.7.4,1,.5.5.4.4.6-.5.5-1.3.6-4.5-.7-5-2-.1-.3.2-.4.5-.5,1.1.3,2.4.6,3.5,1Z"
          fill="#5855ae"
        />
        <path
          d="M291.2,9.9c-.1.3-.3.3-.5,0-.6.2-1.3.3-2,.5-.7.6-2.5.2-3-.5-.4-.1-.4-.3,0-.5-.3-.2-.1-.4.5-.5,1.5,0,3.6.3,5,1Z"
          fill="#4564c5"
        />
        <path
          d="M278.2,7.9c.9,0,2.4-.4,3,.5-.7.5-1.7.3-2.5,0-1.1.7-4.2.5-5-.5-.3-.2-.1-.4.5-.5.2,0,.3,0,.5,0l3.5.5Z"
          fill="#4645b4"
        />
        <path
          d="M312.2,13.9c1.3.1,3.6-.1,4.2,0s.3,1,.5,1,.8-.6,1.3-.4-.9,1.2.5,1.5c-1.7-.3-3.3-.7-5-1-.4.4-1,0-1-.5h-.5c-.4-.1-.4-.3,0-.5Z"
          fill="#f6f4f2"
        />
        <path
          d="M321.2,16.4c.6.2,2.3,1.3,3,1.5-.2.4-.6.2-1,0-.2.4-.7.4-1.5,0,0,.4-.3.4-.5,0l-1-.5c-.4-.2-.7-.7-1-1,.6-.4,1.4-.4,2,0Z"
          fill="#5251ab"
        />
        <path
          d="M331.2,19.9v.5c-.1.4-.3.4-.5,0-.1.2-.3.2-.5,0-.7,1.2-2.8.3-3-1-.1-.3.2-.4.5-.5,1.1.4,2.4.6,3.5,1Z"
          fill="#5456b2"
        />
        <path
          d="M327.2,18.9c.1.3-.2.4-.5.5-.5.9-2.5-.1-2.5-1-.4-.1-.4-.3,0-.5,1,.3,2,.7,3,1Z"
          fill="#415fbe"
        />
        <path
          d="M305.7,12.4c-.6.4-1.2.8-1.5,0h-.5c-.6.3-1.6,0-2-.5-.4-.1-.4-.3,0-.5,1.3.2,3-.2,4,1Z"
          fill="#f6f4f2"
        />
        <path
          d="M294.2,10.4c0,.3-.2.4-1,.5-.5.8-2,.5-2-.5,0-.3.3-.4,1-.5,1.1,0,1.5.4,2,.5Z"
          fill="#6a69c3"
        />
        <path d="M351.7,28.4c.7.3,1.3.7,2,1,0,.6-.7.4-1,0-.7.2-2-.1-2-1h1Z" fill="#3960bc" />
        <path
          d="M294.2,10.4c.8.1,2.1-.4,2.5.5-.2.3-.3.3-.5,0-.6.4-1.4.4-2,0-.3.9-.7.9-1,0l1-.5Z"
          fill="#6b53b9"
        />
        <path
          d="M340.7,23.4l.5.5c.3.1.8,0,1,.5-.1.3-.5.3-1,0-.6.9-1.9.5-2-.5l.5-.5c.2,0,.7,0,1,0Z"
          fill="#4c42a2"
        />
        <path d="M278.2,7.9c-1.1,0-2.8.4-3.5-.5,1.1,0,2.8-.4,3.5.5Z" fill="#6947aa" />
        <path
          d="M301.7,11.4v.5c-.1.4-.3.4-.5,0-.6.2-1.3.2-2,0l-2.5-.5c0,.4-.3.4-.5,0-.4-.1-.4-.3,0-.5.2,0,.3,0,.5,0,1.7.1,3.3.3,5,.5Z"
          fill="#6058cb"
        />
        <path
          d="M311.7,13.9c-1.2,0-2.3-.5-3.5-.5-.8,0-1.3-.2-1.5-.5h-.5c-.4-.1-.4-.3,0-.5,0,0,.3-.4.7-.4,1,.1,3.7,1.3,4.8,1.9Z"
          fill="#f6f4f2"
        />
        <path d="M285.2,8.9c-.8,0-1.7,0-2.5,0v-.5c.8,0,2.1-.3,2.5.5Z" fill="#6d52ad" />
        <path d="M391.1,48.9h1.5c.2.1-.4.7-.5,1-.5-.2-.8-.5-1-1Z" fill="#fdfbfa" />
        <path d="M321.2,16.4c-.5-.1-1.4,0-2,0v-.5c.6,0,1.6-.3,2,.5Z" fill="#f6f4f2" />
        <path
          d="M292.2,9.9l-1,.5c-.2.4-.3.4-.5,0-.4-.1-.4-.3,0-.5.2,0,.3,0,.5,0,.3,0,.7,0,1,0Z"
          fill="#544cab"
        />
        <path d="M364.1,29.9c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#fdfbfa" />
        <path d="M355.7,30.4c-.3,0-.7,0-1,0-.7-.2-1.1-.5-1-1,.6.3,1.6.1,2,1Z" fill="#684fa9" />
        <path d="M327.7,18.9l-.5.5c-.1.4-.3.4-.5,0l.5-.5c.2,0,.3,0,.5,0Z" fill="#3933a2" />
        <path
          d="M343.7,24.9c-.4,0-.8,0-1,.5-.7.6-.9.3-.5-.5l.5-.5c.4,0,.8,0,1,.5Z"
          fill="#5f68c0"
        />
        <path d="M333.2,20.9l-1-.5c.5.1.8.5,1,.5Z" fill="#5465c4" />
        <path d="M334.7,21.4l-.5.5c-.2.4-.3.4-.5,0l.5-.5c.2,0,.3,0,.5,0Z" fill="#3632a3" />
        <path d="M338.7,22.9l-.5-.5c.3,0,.4.5.5.5Z" fill="#73c2f3" />
        <path d="M341.2,23.9l-.5-.5c.4.1.5.5.5.5Z" fill="#73c2f3" />
        <path d="M383.9,40.9c.3.2.3.3,0,.5v-.5Z" fill="#fdfbfa" />
        <path d="M331.7,20.4c-.2,0-.3,0-.5,0v-.5c.2,0,.4.3.5.5Z" fill="#5465c4" />
        <path d="M344.7,25.4l-.5-.5c.4,0,.5.5.5.5Z" fill="#5f68c0" />
        <path d="M366.4,32.9c.3.2.3.3,0,.5v-.5Z" fill="#fdfbfa" />
        <path d="M387.9,44.9c.3.2.3.3,0,.5v-.5Z" fill="#fdfbfa" />
        <path d="M324.2,17.9v.5c-.3-.1-.8,0-1-.5.3,0,.7,0,1,0Z" fill="#395ebe" />
        <path
          d="M312.2,14.4c.2,0,.3,0,.5,0l-1,.5c-.5-.1-1.1,0-1.5-.5.6.1,1.4-.1,2,0Z"
          fill="#374bba"
        />
        <path
          d="M308.2,13.4c-.4,0-.9,0-1,.5-.5,0-.8-.5-1-.5-.3-.2-.1-.4.5-.5.6,0,1.2-.2,1.5.5Z"
          fill="#5956bb"
        />
        <path d="M330.7,20.9c-.2,0-.4-.3-.5-.5.2,0,.3,0,.5,0v.5Z" fill="#5465c4" />
        <path d="M272.2,7.9c-.2,0-.3,0-.5,0,0-.2.3-.4.5-.5v.5Z" fill="#3150ba" />
        <path
          d="M303.7,12.4c.1.3-.2.4-.5.5-.7-.1-1.3-.4-2-.5-.4-.1-.4-.3,0-.5.2,0,.3,0,.5,0,.9.1,1.8.5,2,.5Z"
          fill="#4e4bc1"
        />
        <path d="M304.2,12.4l-.5.5c-.2,0-.3,0-.5,0l.5-.5c.2,0,.3,0,.5,0Z" fill="#4c4cba" />
        <path d="M353.7,29.4c.3.1.7.8,1,1,0,1.1-2,.5-2-.5v-.5c.2.1.8-.1,1,0Z" fill="#375fc0" />
        <path d="M296.2,10.9v.5c-.6-.1-1.6.3-2-.5.7,0,1.3,0,2,0Z" fill="#5266cd" />
        <path d="M299.2,11.9c-.8-.2-1.8-.4-2.5-.5,1-.5,2.1.4,2.5.5Z" fill="#5266cd" />
        <path
          d="M306.2,12.9c.2,0,.3,0,.5,0l-.5.5c-.5,0-1,0-1.5,0,.3-.6.9-.5,1.5-.5Z"
          fill="#4c4cba"
        />
        <path d="M301.2,11.9v.5c-.7-.2-1.5-.4-2-.5.6,0,1.4,0,2,0Z" fill="#2b74d7" />
        <path
          d="M15.9,180.8c0,3.9-1.5,8.8-3,12.5l-1.3,8.1-.7.4-.5,1c1,.6.4,3.4-.5,4-.2.2-.3.2-.5,0-.1.4-.3.4-.5,0,0-.2,0-.3,0-.5l.5-1.5c0-.2,0-.3,0-.5l.5-2c0-.8-.1-1.8,0-2.5.2-.6,0-1.2-.4-1.7-.2-1.2,2.6-10.2,3.2-12.3s.4-.5.9-.6c-.6-1.8,0-3.7,1.8-5.4.4-.3.6,0,.5,1Z"
          fill="#32305b"
        />
        <path
          d="M23.9,346.2l.5.5v.5c3.1,4,5.7,10,6.5,15l-.5.5c0-.1,0-.4,0-.5l-.5-.5c-1.1-2.2-2.4-4.3-3.5-6.5-1.8-3.9-3.3-7.9-4.5-12,0-.3,0-.7,0-1,1.7-1,3.2,2.7,2,4Z"
          fill="#16151f"
        />
        <path
          d="M9.4,207.3c1.2.3.8,4.2-.5,3.5,0-.5.2-1.3-.5-1.5.2-.8.3-1.7.5-2.5h.5c.3.2.2.3,0,.5Z"
          fill="#312f5b"
        />
        <path
          d="M10.9,189.3c.4,0,.4.3,0,.5-.8.3-1.2,1.1-1.3,2.4-1.2,1.4-1.2,2.6-.2,3.6.6,1.1.6,2.6.5,4,1,.1.7,1.9,0,2.5l-.5,2c.4.1.4.3,0,.5l-.5,1.5c.4.2.4.3,0,.5.3.9.4,2-.5,2.5.2,3.5-.5,7.3-1.5,10.5l-.5,3.5c.7.4.6.9,0,1.5,0,2.9-.3,5.6-1,8,.4.8.4,1.5,0,2l-.5,6.5c.7.6.7,1.4,0,2,.4,5,.3,10,0,15,.7.5.7,1,0,1.5l.5,7.5c.7.7.7,1.4,0,2l.5,5.5c.7.5.7,1,0,1.5v.5c.2,1.1.3,2.2.5,3.5.7.5.7,1,0,1.5l.5,3c.6.3.6.7,0,1l.5,3c.5,0,.4.2,0,.5l.5,2.5c.4.1.4.3,0,.5l.5,2c.2.1.2.3,0,.5.6,1,1,2.5.5,3.5l.5,2c.3.4.4,1,.5,2,3.2,13.8,7,27.5,11.5,41,1.7,3.9,3.4,7.9,5,12,1.7,1.4,2.9,4.3,3.5,6.5l.5.5v.5c2.8,3.9,5.6,8.4,7,13l.5.5c.4.1.4.3,0,.5l.5.5c.4.1.4.3,0,.5l1.5,2c.4.1.4.3,0,.5,1.3.9,2,1.9,2,3l.5.5c.4.1.4.3,0,.5,1.4,1.4,3.2,3.1,3.5,5,18,24.9,38.8,47.6,64.1,65.3l1.4,1.6c.6.7.7,1.4.5,2-4.7.4-2.7,2-3.7,3.5-1.8,2.6-5.4-2.7-6.1-3-1.8-.7-1.7.9-1.9,1-2,.3-3.5-3.4-4.1-3.5-1.1-.3-2.9.2-4.1,0-1-.7-2.6-1.4-3.3-2s-1.1-2-1.5-2-.6.7-1.1.8c-3.2.6-1.6-1.6-1.7-2.1-.3-1.2-2.5-.5-2.9-.9s-.7-3.7-1.2-4.3-2.3-1.4-3.1-2.2c-1.5-1.5-6.1-7.2-7.3-7.8s-1.9.4-3,0-6.2-4.2-6.5-4.6c-.7-.8-.6-1.7-1.1-2.4-1.9-2.7-3.4-5.2-5.1-8.1s-3.3-2.3-3.8-2.9-.4-1.6-.8-2.2c-.7-1.1-2.8-1.2-3.2-3.8s.4-1.5.3-2-1.7-3.5-1.9-3.6c-.4-.3-1.4,0-1.9-.3s-.3-1.8-.7-2.3-1.8-.3-2.5-1-.4-3.7-1.5-4-2.1,1.7-3,1.5-.7-1.3-1.3-1.7-2.3-.1-1.4-1.3,2-.1,1.5-1.8-2.3-.6-2.5-.8c-.6-.6,1.4-5.1-.1-6.4s-2.1-.4-2.3-.7c-.7-.9,1.4-3.2.4-4.4-4.2.2-4.2-.2-3.4-4-1.7.9-5.8,0-6.5-1.8s1.2-.8,1.5-1.5c.5-1.3-.8-1.2-.9-1.3-.5-1,1.5-1.9,1.3-3.1s-1.3-1.4-1.7-2.3-.3-3.2-.6-3.9-1.6-1-1.8-1.7c-.7-2.1-.2-4.5-2.2-6.8-3-3.6-3.4-1.3-3.6-7,3-.7.4-3.1.1-3.9-1.1-3.5-.3-10.3-5.6-9.1-.2-2.1,2.5-.4,2.9-2.3s-2-1.4-2.7-2.2,0-5.1-.3-6.2c-.5-1.7-2.5-1-3-1.6s-1.4-6.5-1.4-7.7l-2.5,1c-.6-.4-.7-5.7-.5-6.7s1.1-1.6,1.4-2.6.9-7.4.6-7.6-1.3,0-2-.3c-1.7-1-.8-6.4-1-8.2l-2.5.5c-.7-3.7-.3-7.6-1.6-11.2s-2.4,0-2.9-2.3c1.5-1.1,3.4-1.2,3.9-3.4s-.1-2.5.2-3,2.8-2.1,3.1-3.1c1.1,2.7-1,7.8,2.7,9,1.6-2.5.1-2.9,0-4.7-.3-3.1-.3-6.8.5-9.8-2.2,1.4-2.8,2.1-4.2-.5-2.3,1.5-.4,2-.4,3.1s-1.2,3.6-2.1,3.8c-2,.4-.4-1.8-.4-2.3.2-1.9,0-1.5.5-3.6s0-2,.4-2.6c1-1.7,1.7.9,1.8,1s2.2-.8,2.9-.4c.5-.4-2.5-4.3-2.5-5.3s.8-1.5.8-2c0-3.6.7-9.1.2-12.4s-.8-1.2-.9-2.1c-.2-3.3,2.2-.9,2.8-.8,2.4.4-.6-6.5,1.2-7.7s1.5,0,2.1-.5c1.1-1.1,1.6-9.5.9-10.2-1.1-1.1-2.2,1-2.4,1-.8.4-1.7-.2-2.1.8-.6,2.3,2.4,2.2,1.5,3.2s-4.6.8-5,2.3c1,1.7,2.1-1.2,3.2.3s.7,3.1-.2,3.8-2.7-1.2-3-1.5c-.6-.7-.4-1.7-.5-1.7-.1-.1-2.5,1.4-2.4-.7s1.5-1.4,1.5-1.6c0-1.2-1.9-2.3-1.5-3.5s3.3-1,2-2.3-3.2,1-2-2.5c-.5-1.4.7-1.7,1.5-.5,2.3.8,2.2-2.2,1.8-4,.3-1,.4-2,.2-3-.5-.6-.7-2.7.5-2.5,1.5-8.8,4.1-16.7,10.1-23.4l-.3-2.2c.3-.6,4.1-2.3,5-1.5s-.4,5.5-.5,6.6-.1.3-.3.5Z"
          fill="#fdfdfd"
        />
        <path
          d="M48.3,391.2c2.1.4,2.7,2,3,4l1.9.9c4.6,6.1,9.2,12,14,18v1.1c.1,0,1.9.8,1.9.8,3.1,3.1,5.8,6.5,8.2,10.2,1.2-.8,1.9-.4,1.5,1l2.4.9c3.1,2.6,7.2,6.3,10,9.3s.9,1.5,1.1,2.3c1.6,1.7,3.5,3.2,5.5,4.5,2.6.6,4.4,2,5.5,4.5,4.6,3.1,9.3,6.1,14.2,8.8l.3,1.2c1.2.9,2.5,1.5,4,1.7v.8s1.8.3,1.8.3c13.6,8.3,27.6,14.4,42.2,20.5,1.1.5,2,1.3,2.9,2.1l-.5.5c-20.7-7.2-38.9-16-57-28.5-26.5-18.2-47.7-40.3-65.5-67-.4-.8-.3-1,.5-.5,1.2-.2,1.9,1.4,2,2.5Z"
          fill="#0d0c17"
        />
        <path
          d="M10.4,301.8c.6.6.8,1.1.5,1.5.3.4.3.7,0,1,1.9,3.8,3.2,8,3.9,12.6,1.3,3.2,2,6.3,2,9.4,3,4.7,4.8,10.4,5,16,.4.5.4.9,0,1-.1.4-.3.4-.5,0-3.6-10-11.4-31-11.5-41-.4-.7-.4-1.9.5-1.5,1.4.2,1.2.5,0,1Z"
          fill="#181526"
        />
        <path
          d="M34.8,368.7c2,.3,3.9,4.6,3.5,6.5.4.6.6,1.1.5,1.5l.5.5c1.9,1.1,2.4,2.1,1.5,3,.5,1.5.2,1.5-1,0,0-.1,0-.4,0-.5l-1.5-2c0-.1,0-.4,0-.5l-.5-.5c0-.1,0-.4,0-.5l-.5-.5c-2.6-4.4-4.7-8.5-7-13-.3-.8-.1-1,.5-.5,2.6.7,3.5,4,4,6.5Z"
          fill="#171927"
        />
        <path
          d="M8.9,210.8c1.1.4,1,2.6,0,3l-.3,6.2-.7.3c-.2,1.2-.4,2.4-.5,3.5l-.5,2c.8.5.7,1.5,0,2-.9,0-1-.9-.5-3,0-.5,0-1,0-1.5l.5-3.5c.2-3.7.8-6.9,1.5-10.5,1-.7.9.7.5,1.5Z"
          fill="#222445"
        />
        <path
          d="M9.4,195.8c-4-1-.6-2.9-.3-4.4s-.9-2.6.8-3.1l1,1.5c0,1.7-1.1,4-1.5,6Z"
          fill="#fdfdfd"
        />
        <path
          d="M6.9,227.8c.2,0,.4.1.4.2-.2,3-.8,6.5-1.4,9.3,0-1.4.4-3.5-.5-4.5.1-2.6.2-5.7,1-8,0,1-.3,2.1.5,3Z"
          fill="#262749"
        />
        <path
          d="M43.3,384.7c1-.2,1.8.8,2.5,3,.8.4.9.7.5,1l-.5.5c-1.1-1.7-2.4-3.2-3.5-5,.3-.5.7-.3,1,.5Z"
          fill="#1d202d"
        />
        <path
          d="M40.8,380.2c1.7-.7,3.9,3.6,2.5,4.5-.3-.2-.7-.3-1-.5,0-.1,0-.4,0-.5l-.5-.5c-.6-1-1.4-1.8-2-3l.8.5.2-.5Z"
          fill="#191d2a"
        />
        <path d="M5.4,267.3c-.9-2.1-.5-5.1-.5-7.5.9,2.1.5,5.1.5,7.5Z" fill="#1e1734" />
        <path d="M2.4,245.8c-1.5.1-1.6-1.3-1.5-2.5,1.5-.1,1.6,1.3,1.5,2.5Z" fill="#fefefd" />
        <path d="M4.9,241.3c0-2.1-.4-4.8.5-6.5,0,2.1.4,4.8-.5,6.5Z" fill="#3a324e" />
        <path d="M5.9,274.8c-.9-1.3-.5-3.8-.5-5.5.9,1.3.5,3.8.5,5.5Z" fill="#1e1734" />
        <path d="M3.4,240.8c.1.1.3,1.9-.7,1.5-1.8-.7-.1-2.4.7-1.5Z" fill="#fefefd" />
        <path
          d="M6.4,280.3c-.9-.7-.5-2.4-.5-3.5.2-.3.3-.3.5,0,.1,1.1,0,2.4,0,3.5Z"
          fill="#232037"
        />
        <path d="M6.4,223.3c0-1.1-.4-2.8.5-3.5,0,1.1.4,2.8-.5,3.5Z" fill="#363448" />
        <path d="M7.4,288.8c-.8-.5-.5-2.1-.5-3,.9.6.5,2.1.5,3Z" fill="#221f30" />
        <path d="M26.4,355.2c-2-4.1-3.4-7.7-5-12h.5c1.2,4.2,3.4,7.8,4.5,12Z" fill="#eeebec" />
        <path d="M6.9,284.8c-.8-.5-.5-2.1-.5-3,.8.5.5,2.1.5,3Z" fill="#232037" />
        <path d="M7.9,291.8c0-.5-.4-1.3-.5-2.5.8.4.5,1.7.5,2.5Z" fill="#221f30" />
        <path d="M9.4,300.3c-.1-.6-.3-1.1-.5-2l.5,2Z" fill="#282353" />
        <path d="M8.4,294.3c0-.3-.4-1.1-.5-2l.5,2Z" fill="#221f30" />
        <path d="M9.4,204.3c0-.7-.3-1.6.5-2,0,.7.3,1.7-.5,2Z" fill="#3c3662" />
        <path d="M8.9,206.3l.5-1.5c-.1.9-.5,1.4-.5,1.5Z" fill="#4c456d" />
        <path d="M39.8,379.7c-.9-.4-1.1-1.2-1.5-2,.9.4,1.1,1.2,1.5,2Z" fill="#191d2a" />
        <path d="M5.4,212.8c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#fefefd" />
        <path d="M30.4,362.2c0-.1-.4-.3-.5-.5l.5.5Z" fill="#171927" />
        <path d="M37.8,376.2c0-.2-.4-.3-.5-.5l.5.5Z" fill="#191d2a" />
        <path d="M38.3,377.2c0,0-.3-.2-.5-.5l.5.5Z" fill="#191d2a" />
        <path d="M42.3,383.7c-.1-.2-.4-.3-.5-.5l.5.5Z" fill="#1d202d" />
        <path d="M6.4,276.8h-.5c0-.2,0-.3,0-.5.2,0,.5.3.5.5Z" fill="#1e1734" />
        <path d="M4.1,217.8c.3.2.3.3,0,.5v-.5Z" fill="#fefefd" />
        <path d="M5.4,258.3h-.5c0-5,0-10,0-15,1.1,4.8.2,10.1.5,15Z" fill="#0d091c" />
        <path
          d="M10.4,300.8c-.6.2-.5.9-.5,1.5-.8-.4-.4-1.4-.5-2l-.5-2c-.2-1.2-.3-2.3-.5-3.5l.5-.5c1.6.8,2.9,5.2,1.5,6.5Z"
          fill="#221f30"
        />
        <path d="M482.1,335.7c-.5,0-.4-.2-.5-.5s0-.8,0-1h.5c-.1.4,0,1,0,1.5Z" fill="#0d0e28" />
        <path d="M490.1,305.3c0,0-.3,0,0-1v1Z" fill="#27234c" />
        <path
          d="M224.2,496.2h7.9c.7.1,1.2.4,1.6,1l3.5.5c2-1.2,4-1.2,6,0,5.3.2,10.6.5,16,1h-1c-5.2.4-10.3.4-15.5,0-.7,0-1.3,0-2,0l-7.5-.5c-6.4-.2-12.3-1.1-18.5-2,.8,0,2.1.3,2.5-.5,2.3-.2,4.8,0,7,.5Z"
          fill="#15121e"
        />
        <path
          d="M258.2,498.7c-.5.8-1.9.5-2.7.5-3.3,0-6.7,0-10,0s-2.2.3-2.7-.5c5.2,0,10.3,0,15.5,0Z"
          fill="#1d242b"
        />
        <path
          d="M268.7,497.7c.4.1.4.3,0,.5-.3,0-.7,0-1,0-2.3.3-4.8.7-7,0-.4,0-.9,0-1-.5,1.3-1.4,3.7-1.4,5,0,1.1-.4,2.3-.5,3.5-.5.2-.4.3-.4.5,0v.5Z"
          fill="#15121e"
        />
        <path d="M240.7,498.7c-2.4,0-5.4.4-7.5-.5,2.4,0,5.4-.5,7.5.5Z" fill="#1d242b" />
        <path d="M267.7,498.2c-1.8.8-4.9.6-7,.5v-.5c2.2.2,4.7,0,7,0Z" fill="#26243a" />
        <path d="M273.2,497.7c-1,.9-3.1.5-4.5.5v-.5c1.5,0,3,0,4.5,0Z" fill="#26243a" />
        <path d="M418.1,73.9c0-.3.2-.4.5-.5,0,.4-.1.5-.5.5Z" fill="#2b3091" />
        <path d="M440.1,97.4l.5-.5-.5.5Z" fill="#333468" />
        <path
          d="M413.6,51.9c3.3,1.8,4.1,3.3,7.1,5.1s3.7,1.7,5.4,2.2,2.5,2.2,3,1.7l-.5-2.5c2.1.6,5.4,0,6.7,2s.7,2.9.8,3c1.2,1,1.4-1.6,2.5-.8,2.3,1.6,0,4.5.1,6.5s3,3,3.3,4.2-.4,1.3-.3,1.8c.1.7.7,1.3.8,2.1s-.5,2.2-.2,3.1c.4,1.2,3.7,1.8,3.7,2.4s-2.5,1.2-1.5,2.2,2.6.4,2.7.4c.8-.1,1.2-1.7,2.3-1.4,0,1.3-1.2,1.8-1.7,3-2.2,5.1,1.3,3.4,1.7,4.1s-.2,1.3.1,1.8,1.5.7,2,1.1c.8.6.7,2,2.4,1.5-1.6-3,1.5-.6,2-1l-.5-1.5c1.6,0,3.4.5,5,.5l.5,1.3c-1.8,1.8-3.8,3.5-5.8,5,4.6-2,10,.2,7.2,5.6,1.3-.4,2.1.4,2.5,2.5,1,.4,1.6,1.4,1.7,3,2.7,1.2,4.5,2.6,5.4,5.7,2.1,1.2,2.9,2.8,2.6,4.9l2.2,3c1.4,4.1,3.6,7.5,6.5,10.3l4.2,9.3c2-.5,3.7.2,3.8,2.4-1.1,3.6.8,7.3,4.6,7.8v8.5c-.7,1.9-4.3,1.4-4.9-.7-2.1,3.3-4.3,4.3-6.7,3.1l.3,4.1c3.3.3,4.8,1.7,4.3,4.4,7.3.6,3.3,4.1-1.4,4.8,0,1.6-.6,2.6-1.6,2.7-.9-.3-1.3-1.6-1-2.5-.2-.5-.2-.8,0-1q.7-.7,0,0c-.1.4-.3.4-.5,0v-.5c-.8-.3-1.2-1.6-1-2.5-1-1-1.7-3.4-1.5-5-.7-.3-.8-.7,0-1q.3-.7,0,0l-.6.2c-2.7-6.4-5.5-13.1-7.9-19.2-.3-.2-.3-.3,0-.5-1.8-1.7-2.8-4.6-3.5-7-.6-.1-.8-1-.5-1.5-1.4-.8-2.2-2.9-2.5-4.5-2.3-3.2-4.6-6.8-6-10.5-.5-.6-1-1.3-1.5-2-.4-.1-.4-.3,0-.5l-.5-.5c-1.5-1-3.3-3.6-3.5-5.5-.9-.2-1.8-1.6-1.5-2.5-.8.2-1.5-1.2-1.5-2-1.1-.5-2-1.8-2-3-1,0-1.5-1.1-1.5-2-.9-.4-1.4-1-1.5-2-.7,0-1.4-.8-1-1.5-1.1-.2-1.9-1.4-2-2.5-.9-.2-1.8-1-1.5-2-.2.3-.4,0-.5-.5-.8-.1-1.5-1.2-1.5-2-.5.3-.7,0-.5-.5-1.4-.2-2.2-1.7-2.5-3-1.3-.7-3-2.6-3.5-4-.4.2-.6,0-.5-.5-.4.2-.6,0-.5-.5-1.2-.4-2.2-1.4-3-3-.3,0-.5-.2-.5-.5v-.5c-.4.4-.6,0-.5-.5-.3,0-.5-.2-.5-.5-.5.3-.7,0-.5-.5-.5.1-.6,0-.5-.5-.5.1-.6,0-.5-.5-1.6-.6-2.9-1.9-3.5-3.5-.7,0-1.3-.8-1.5-1.5-1.9-1.2-3.1-2.5-3.5-4,.6-.8.9-1.5-.2-2.2,1,.4,1.3,2.3.2,2.2-.1.4-.3.4-.5,0-.5.1-1.1-.5-1-1-.5.3-.7,0-.5-.5l-.5-.5c-.4-.1-.4-.3,0-.5-.3-2.1,3.1-3.4,3.7-1.6.5-.7,4.4,4,4.6,4.7h5.1c-.2-2.1-.2-4,.1-5.8-2.4-.2-4.4-1.2-3.7-3.9l-1.9-2.4c-2.8.2-4.3,0-5.8-2.7-3.2-.9-5.5-4.1-5.1-7.2Z"
          fill="#fdfdfb"
        />
        <path
          d="M482.1,168.8c0,.3,0,.7,0,1,0,.7,0,1.1-.5,1-2.8-4.9-4.7-10.6-6.5-16-1.7.2-3.1-3.3-2-4.5,0-.3.1-.5.5-.5.5,1.1,1.5,2.3,2.1,3.7s5.8,15.9,6.4,15.3Z"
          fill="#4c5281"
        />
        <path
          d="M467.1,136.3c.3.8.3,1-.5.5-2.7-1.6-5.5-6.4-5.5-9.5-.3-.5-.5-1-.5-1.5.1-.4.3-.4.5,0,2.2,3.5,4,6.9,6,10.5Z"
          fill="#4e598a"
        />
        <path
          d="M459.1,122.9l.5.5c0,.1,0,.4,0,.5.5.5,1,1.2,1,2,.3.5.3,1.2.5,1.5-.4.3-.7.3-.9,0l-4.6-7.9c-1.4-.2-1.6-.6-.5-1.5-.7-.7-.4-1,.5-.5,1.3,2,2.3,3.2,3.5,5.5Z"
          fill="#475499"
        />
        <path
          d="M473.6,149.3l-.5.5c-.2.3-.6,0-1-1l-.8-.3c-1-1.8-1.6-3.7-1.7-5.7-.2-.6-.1-.8.5-.5,1.2,2.4,2.4,4.6,3.5,7Z"
          fill="#535a8b"
        />
        <path
          d="M483.6,174.8c.2.9,0,1.2-.5,1-1.2-.7-2.1-3.8-1.5-5l.5-1c0,.8,1.2,3.8,1.5,5Z"
          fill="#454974"
        />
        <path
          d="M438.1,93.9l-.5.5c-1.3-.5-2.9-2.6-3.5-4l.5-.5c1.4,1.4,2.2,2.5,3.5,4Z"
          fill="#566097"
        />
        <path
          d="M469.6,140.8c.1.5,0,.7-.5.5-.1.4-.3.4-.5,0-1.5.1-3.2-3.5-2-4.5l.5-.5c.8,1.5,1.7,3,2.5,4.5Z"
          fill="#515390"
        />
        <path
          d="M422.6,77.4c-.2.2-.3.2-.5,0-1.3-.2-3.9-2.2-4-3.5l.5-.5c.1,0,.3,0,.5,0,0,.3,2.9,3.4,3.5,4Z"
          fill="#4b4f8b"
        />
        <path
          d="M427.6,82.4c.3.4,0,.6-.5.5-1.3.7-3-.5-2.5-2-.6-.6-.8-1.1-.5-1.5-.3-.1-.3-.3,0-.5,1.1,1.2,2.4,2.3,3.5,3.5Z"
          fill="#4e578d"
        />
        <path
          d="M440.6,96.9l-.5.5c-.3.1-.7,0-1-.5-.8-.3-1.6-1.6-1.5-2.5l.5-.5c.9,1,1.7,2,2.5,3Z"
          fill="#565f89"
        />
        <path
          d="M455.6,117.4l-.5.5c-1.3.9-3.3-1.8-1.5-2.5-.6-.7-.3-1,.5-.5.6.9,1,1.7,1.5,2.5Z"
          fill="#474880"
        />
        <path
          d="M433.6,88.9c.3.4,0,.6-.5.5-.2.3-.3.3-.5,0-1.6.3-3.2-2-2.5-3.5h.5c1.4,1.1,1.9,1.9,3,3Z"
          fill="#484f87"
        />
        <path
          d="M452.6,112.9c.5.7.3,1-.5.5-1.1,0-2.1-1.9-2-3-.7-.7-.4-1,.5-.5.7,1,1.3,2,2,3Z"
          fill="#42467a"
        />
        <path
          d="M446.6,104.4c.4.8.3,1-.5.5-1-.3-2.3-1.5-2-2.5l.5-.5c.6.8,1.3,1.6,2,2.5Z"
          fill="#4d5185"
        />
        <path
          d="M454.1,114.9c-.2,0-.4.5-.5.5,0,.5-.3.4-.5,0-.8-.7-1.1-1.3-1-2l.5-.5c.4.6,1,1.2,1.5,2Z"
          fill="#5a5686"
        />
        <path
          d="M450.6,109.9l-.5.5c-.1.4-.3.4-.5,0-.9,0-1.8-1.3-1-2l.5-.5c.5.7,1,1.3,1.5,2Z"
          fill="#53598b"
        />
        <path
          d="M444.6,101.9l-.5.5c-.7.5-1.3-.7-1.5-1.5-.5,0-.4-.2,0-.5l.5-.5c.5.7,1,1.3,1.5,2Z"
          fill="#525789"
        />
        <path d="M427.6,78.4c0,.1.3,1.4-.2,1.5-.7-.6-2-.8-1.7-2,.4.4,1.9.5,2,.5Z" fill="#fdfdfd" />
        <path d="M484.6,177.3l-.5.5c-1,.5-1.7-1.3-1-2l.5-1c.2.6.7,1.5,1,2.5Z" fill="#54547f" />
        <path
          d="M442.6,99.4c0,.3-.1.5-.5.5-.8,0-1.5-1.2-1.5-2-.3-.4,0-.6.5-.5.5.7,1,1.4,1.5,2Z"
          fill="#5a5581"
        />
        <path
          d="M447.6,105.9c.5.7.3,1-.5.5-.7.5-1.3-.3-1-1v-.5l.5-.5c.4.5.7,1.1,1,1.5Z"
          fill="#43407c"
        />
        <path d="M449.1,107.9l-.5.5c-1,.5-2.2-1.2-1.5-2l.5-.5c.5.7,1,1.3,1.5,2Z" fill="#484981" />
        <path d="M424.1,78.9v.5c-.6.5-2.4-1.2-2-2h.5c.5.5,1,1,1.5,1.5Z" fill="#425896" />
        <path d="M470.1,142.3l-.5.5c-.5-.1-.7-1-.5-1.5l.5-.5c.3.5.3,1.1.5,1.5Z" fill="#30346c" />
        <path
          d="M419.1,73.4c0-.4.6-1.3.5-1.4-.2-.3-1.9-.2-1.5-1.6,2.2.4,1.2,2,2.5,3.3-.4.3-.9-.2-1.5-.3Z"
          fill="#fdfdfd"
        />
        <path d="M418.6,73.4l-.5.5c-1.3.6-1.7.3-1-1-.3-.4,0-.6.5-.5.2.2.9.3,1,1Z" fill="#313c9b" />
        <path d="M485.1,177.8c-.3-1.9,1.7-.9,1,0s-.9-.1-1,0Z" fill="#fdfdfd" />
        <path d="M424.1,76.9c-.6.3-1.7-.8-1.5-1,.6-.3,1.7.8,1.5,1Z" fill="#fdfdfd" />
        <path d="M417.6,72.4l-.5.5c-.4.2-.6,0-.5-.5-.3-.2-.1-.4.5-.5.2.2.4.3.5.5Z" fill="#2f3995" />
        <path d="M441.1,97.4l-.5.5c-.4,0-.6,0-.5-.5l.5-.5c.1.2.4.3.5.5Z" fill="#3e3865" />
        <path d="M434.6,89.9l-.5.5c-.4,0-.6,0-.5-.5-.3-.4,0-.6.5-.5.2.2.3.3.5.5Z" fill="#36418e" />
        <path
          d="M429.1,83.9c.3.2.1.4-.5.5-.4.2-.6,0-.5-.5-.3-.4,0-.6.5-.5.2.2.4.3.5.5Z"
          fill="#273a74"
        />
        <path d="M428.6,83.4l-.5.5c-.4.2-.6,0-.5-.5-.3-.4,0-.6.5-.5.2.2.3.3.5.5Z" fill="#28417b" />
        <path d="M428.1,82.9l-.5.5c-.4.2-.6,0-.5-.5l.5-.5c.2.2.3.3.5.5Z" fill="#28497f" />
        <path d="M429.6,84.4h-1l.5-.5c.1.2.4.3.5.5Z" fill="#253467" />
        <path d="M430.1,85.4v.5c-.7.6-1,.4-.5-.5l.5-.5c0,.1,0,.3,0,.5Z" fill="#282b64" />
        <path d="M485.1,178.8c0,0-.3-.4-.5-1h.5c0,0,0,.7,0,1Z" fill="#54547f" />
        <path d="M482.1,168.8c0,0,0-.7,0-1,1.2,0,0,.9,0,1Z" fill="#fdfdfd" />
        <path d="M443.1,99.9c0,.3-.2.6-.5.5-.3-.3-.2-.6,0-1,.1.2.4.3.5.5Z" fill="#332d61" />
        <path d="M417.1,71.9c-.4.3-.6.2-1,0l.5-.5c.2.2.3.3.5.5Z" fill="#312d81" />
        <path d="M483.1,167.3c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#fdfdfd" />
        <path
          d="M473.6,149.8l-.5.5c-.4-.2-.4-.3,0-.5,0-.3.2-.5.5-.5,0,.1,0,.4,0,.5Z"
          fill="#384171"
        />
        <path d="M461.1,125.9h-.5c-.4-.7-.7-1.3-1-2,1,.3,1.1,1.3,1.5,2Z" fill="#545a8c" />
        <path d="M459.6,123.4l-.5-.5c0,0,.4.2.5.5Z" fill="#545a8c" />
        <path d="M430.6,85.9h-.5c0-.2,0-.4,0-.5.2.1.3.4.5.5Z" fill="#2c265b" />
        <path d="M437.6,94.4l.5-.5-.5.5Z" fill="#303579" />
        <path d="M434.1,90.4l.5-.5-.5.5Z" fill="#23287c" />
        <path d="M444.1,102.4l.5-.5-.5.5Z" fill="#1f215c" />
        <path d="M448.6,108.4l.5-.5-.5.5Z" fill="#1a1f5a" />
        <path d="M442.6,100.4c-.5-.2-.4-.4-.5-.5l.5-.5c0,.3,0,.7,0,1Z" fill="#2c306b" />
        <path d="M417.1,71.9l-.5.5c-.2-.2-.3-.3-.5-.5h1Z" fill="#2a3188" />
        <path
          d="M101.3-1.6c3.2,1.1,3.4-1.9,3.8-2,3.1-1,12.7-1.1,15.8-.4s4.1,2.5,3.4,4.9c1.9.1,3.1.2,3-2,1.4.1,2.1,1.2,3.7,1s2.1-1.5,3.5-1.6,2,1.6,3,1.6,1.8-1.4,3.5-1.5,3.2.7,4.7.7,7.2.2,8.3.1,2.2-1.3,3.6-1.3,2.4.9,4,1c3.7,0,8.8-.3,12.6-.5s1.8-.2,2.2,1c-.3.4-.2,2.2-1.3,2.4s-1.5-.5-2.4-.4c-2.4.3-2.3,3.4-5.8,0h-.5c-.6.6-2.4,2.2-2.4,2.3-.3.9,1.1,2.5.2,3.7s-3.2,1.1-2.3,2,5.6-.9,8-.2.3,2.7-1,3-2-.4-2.7-.3c-1.3.2,0,2.2-.3,2.5s-5.2-1.4-5.5-1.7c-.9-.9-.3-2.6-.5-2.8s-2.7.4-3.5-.2,0-2.8-1.2-2.3c-2.6,1.1-1.4,4.4-2,5.5s-1.6.7-2.1,1.2-.8,1.7-1.5,1.8c-1.6.4-1.3-4.1-3.6-.7s-.5,1.6-.6,1.7c-.2.2-1.8-1.2-3-.8s-2.6,3.9-3.9,4.2-1.8-1.2-2.8-.9-1.3,1.8-2.1,2.5c-2.5,2.1-5.3,1.6-8.3,1l.5,2.5-3-3c-.4,1-1.7,3.9-2.5,4.3-1.6.8-4.6-2.5-4,3.2-2.3.8-1.4-2-2-2.5s-2.8.3-3,.5c-1.2,1.3,2.6.7,1.5,2s-1,.2-1.5.7c-1.8,2-1.4,2.1-4,3.5s-2.1,1.3-2.3,1.3c-.8.2-1.9-.2-2.8,0s-1.1,1.8-1.6,1.9-1.7-1.4-2.7-1c1.2,1.5-.4,2.2-.5,3.2s.8,1.5.2,2.8-5,1.9-5.9,2.5-1.6,3.2-3.3,2.3-.4-2.6-1.7-2.3.5,3.1-2.3,2.3-.6-1-1.2-2.3c-.4,1.1-2.6.9-2.7,1-.3.3.4,2.2-.5,2.8s-1.3-.3-2,0c-1.2.4-3,2.2-3.8,2.2-1.5.1-3.8-1.9-3.2,1,4.1-.2,1.2,1.4.8,2.5-.7,1.9-.4,3.5-2,5.5s-2.5,1.4-3.5,2.5-3.1,3-3.3,3.2c-.6.7-.3,2-1.2,2.8s-4.2,1.4-4.5,2-.1,1.4-.5,2-3.5,4.3-3.6,4.6c-.2.5.4,1.1.4,1.6s-.8.3-1.2.9c-.6,1.1-.5,2.8-.8,3.1-1,1.3-1.9,0-2.7.3-1.5.3,0,2.2-.5,3-.8,1.1-3.7,0-3.3,2.2s1.5,1.3,0,3.1-1.4-.1-2.8-.2c-6-.6-2.7,2-6.7,4,0,1,1.2.2,1.9.6s.3,1,.8,1.4c.8.6,2.4.4,2.3,2-.1,1.3-1.5,3.6-3,3.5.5.7.4,1.5-.3,2.5,0,2.4,0,2.6-2.2,3.2,0,2.7-1.1,4.9-3.9,5.7,0,2.1-.4,3-2.7,2.8-.1,2.2-.9,4.2-3.2,2.7,1,.8,1.5,1.5.9,2.7-3.2,3.5-5.8,7.3-7.9,11.7-1.8,1.6-3.4,3.2-4.8,4.9,1.4,2.3.3,3.8-1.8,5l-.2,3.1c-2.4,5.7-5.1,11.6-8.7,16.5l-1.3.5c-.5,2.2-1.5,3.4-3.3,3.6-.5,6-7.4,1.2-6.3-3-4.5-3.3-5-5.8-1.5-7.5.8-1,3.8-8.5,2.4-9.5-.2-4.6-.9-9.2-2.2-13.9-.2-2.7-.3-5.6,1.6-7.6-1.7-1.7-1-3.2.6-4.7,2.8-5.5,5.4-11.1,7.5-16.8,1.1-1.9,3-2.8,5.2-2.8l.2-1.9c-4,1.6-8.7-2.7-4.1-5.1s1.2,1.1-1.5-.3-1.2-3,1.1-4.2c-.5-1.5-1.3-2.7-2.6-3.7-.4-3.5.3-7,2.1-10.5l.8-4.5c-4.1,1.1-6.2.5-6.3-1.9-2.6-.5-3.5-1.3-2.5-4-4.3-.7-6.4-6-.8-3.9v-1c-2.5-.5-4.6-4.3-2.5-6.2-1.8-2.3-1.8-5.1,0-8.2l-.2-1.1c-.6-1.3-1.7-4.2.2-4.2,1.4-1.8,4.8-1.2,6.7-.1-.4-3.7.9-5.4,3.9-5v-1.9c-5,1-4.5-7.9-1.5-9.5.1-.4.3-.4.5,0,2-.4,2.7,2.1,2.9,3.7l2.2,1.2c2.6-1.3,5.8-2.6,8.2-.4-.2-6.4,4.9-7.2,5.8-.7,2.9-.6,5.5-.2,7.8,1.2,2.3,2.2,2.3-6.3,2.1-6.7-3.2-.6-3.8-1.8-3.8-5-4.8-4.1,1.9-9.8,2.6-1.8,2.4-.2,4.7-.2,6.9,0,.5,2.4.9,4.9,1.2,7.4,3.2-2.2,5.4-3.2,8.2-.1-1.9-2.2,1.8-7.9,4.1-7.1.6,1.1,1.6,1.1,3.1,0,3.5,1.6,3.8-2.7.5-2.2-4.4.9-6.3,1-6.5-3.9l-6.2-.3c1,5.9-4.9,6-3.5,0-3.2-.7-3.5-3.8-.4-5,.3-1.4.2-2.8-1.4-3.2l-.2-1.1c.3-1,1.3-1,2.1-1.2,4.6-.9,6.7-.2,10.9-.3.9-1.5,3-1.3,3.2.5,1.5-.9,3.3-1,5.2,0,2.3-.5,3.4-.6,5.6.5,3.8,3.3,7.5,6,9.5-.2,1.1-1.2,2.5-1.1,3.7-.2,3.3,3.9,6.2,4.1,10.8,3.7,7.3,1.2,9,5.4,9.6,12.3,1.6-.2,3.2-.3,4.8-.3,0-4.2,2.4-6.4,6-8,2.1.3,4.9,0,1.4-1.4-.9-2.3-2.1-4.3-3.5-6.3l.2-1.2Z"
          fill="#fdfbfa"
        />
        <path
          d="M-2.1,24.4c-1.2.5-.8.6-.9,1.6s-.4,6.7-.1,6.9,2.6-.5,3.3.5.4,2.5,0,3.1c-.6.9-3,.2-3.3.5s0,6-1.3,6c-1.4-3-4-1.8-6.7-2-.2-.6-2,0,0-2,1.8-.4,2.4-1,2-2-.4-.6-.7-4.7,1-4,.5-.7,1.3-.6,2.5.1-1-1.3-2-3.9,0-4.1.1-.6,1.6-2.7,1.6-3.9l1.9-.6Z"
          fill="#fdfbfc"
        />
        <path d="M118.8,23.9c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#fdfdfb" />
        <path d="M96.3,40.9c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#fdfdfb" />
        <path
          d="M-3.6-4.1C2.9-2.7,10-1.4,16.7-.8s2.4-1,3.4.7.2,2.8,2,3,2.4-2,4.1-2.4,4.4-.3,5.6-.1c2.5.4,3.1,2.3,2.5,4.6s-2,.7-2,2.1,2.2,1.4,2.5,1.8c.4.6-.6,3.5,0,3.9,2.5,1.5,1.3-3.7,1.5-3.9.4-.6,7.6-.1,8,.2,1,.7-.2,3.8,1.3,4.2s8.6-2.7,7.4,2.6-2.2.9-3.4,1-1.7,1.4-2.6,1.4-.4-1.3-1-1.5c-1.6-.5-1.4,1.1-1.9,1.8s-1.1.3-1.4,1.4c-.3,1.8.7,2.3,1,3.8-2.8.7-2.7-.7-3.9-1.5-1.9-1.3-5.4,2.2-6.4,2s-1-6.7-1.3-8c-.3-.3-6.8,1.7-7.4-.3s.6-3.5-1.8-3.2-.4,2.3-.3,2.8c.2,1.2,1.4,1,1.5,1.6.7,2.8-.9,4.3,4,4.2l-.5,8.8c-2.6,1.5-4.6-1.1-6.3-1.3s-4.6,1.4-5.4-.6.5-3.6-2.1-3.4-1,2.8-1.4,4.2c-.7,2.5-1.7.4-2.4.1-3.3-1.5-6.2,1.5-7.1,1.2s-2.6-1.5-2.7-1.6c-.4-.4-.3-1.8-.7-2.5s-1.1-1.2-1.4-1.9c-1.2-2.7,2.6-3.3,1.9-6.3s-2.7-.6-2.2-3.2,2.4-1.6,2.8-2-1-2.9-.5-3.5,1.3.3,1.5-.3C2.7,6.9-.7,7.3-.1,4.9c3.1-1.2,3.3,2.5,6.7,1.5,1.2-1.5-.7-1.5-1.2-2.2S3.6,1,2.9.6C1.8,0,0,1.5-1.2.7s-.4-2.7-.9-3.5-1.9.2-1.5-1.3Z"
          fill="#fdfbfc"
        />
        <path
          d="M42.2,17c.3.5.5,2.9-.6,2.4s-2.8-2.2-4.2-2.8-4.3,0-3-1.2,2.5-.3,3.1-.6c1-.5,1.2-2.1,2.1-1.9,1,.8.7,2.2,1.3,3.2s1.2.7,1.3.9Z"
          fill="#fdfbfa"
        />
        <path d="M12.4,17.4c1.2-1.2,3.3,2.3,1.2,3.5-1.1-.4-1.7-3-1.2-3.5Z" fill="#fdfbfa" />
        <path d="M20.4,7.9c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#fdfbfa" />
        <path
          d="M44.8-1.1c.2-2.6,2.2-.4,4-1.2s1.3-2.5,2.8-2.8,4.4.5,4.8.8c.7.5.2,1.8.7,1.8.7,0,1.2-.7,1.7-.7,3.1-.4,2.2-.5,4.7-1.4,5-1.7,6.6.6,10.6.7s3.3-1.1,4.4-1,1.9,1.3,2.7,1.3,4.9-2.3,5.8-2.3,2.3,1,3.2,1.2c2.8.6,7.1.6,9.7,1.7s.9,1,1.4,1.5c3.4,3,2.4,4.6,4,6.7s2.3.2,1.9,2-2.9.8-4.2,1.2-1.8,1.5-2.7,2.3-1,.2-1.3.4c-.6.5,0,4.3-1.2,5.4-2.3-.9-4,.8-6.5,0,0-.7.3-1.3.2-2s-2.1-7-2.5-7.4-3.7-2.1-4.2-2.2c-3.5-1.2-5.6.5-9.1-.9S71.7-.3,70.1-.1s-1.6,3-2.8,3.8C62.7,6.8,59.8.5,56.5,0s-2.1.5-3.3.4-2.2-.8-3.1-.8-1.6,1-2.4.8-.7-1.9-.8-2c-.4-.4-1.7.5-2,.5Z"
          fill="#fdfdfb"
        />
        <path d="M76.3,0c.2.2.2,2.9-1,3l-.5-3c.4,0,1.4-.1,1.5,0Z" fill="#fdfbfa" />
        <path d="M492.6,212.8l-.5-1c0,0,.3.2.5,1Z" fill="#38406a" />
        <path d="M490.6,203.3c-.2,0-.5-.3-.5-.5.2,0,.5.3.5.5Z" fill="#3b3c63" />
        <path d="M494.6,226.3c0-.2-.4-1.1-.5-2l.5,2Z" fill="#29376f" />
        <path d="M494.1,222.3c0,0-.4-.1-.5-1l.5,1Z" fill="#283460" />
        <path d="M493.6,219.3c-.5-.2-.5-.6-.5-1,.2-.2.3-.2.5,0,0,.3,0,.7,0,1Z" fill="#313b62" />
        <path d="M493.6,218.3h-.5c0-.2,0-.3,0-.5.2,0,.5.3.5.5Z" fill="#283460" />
        <path
          d="M26.9,151.3c-.4,2.2-1.3,5.3-3,6.5-.4.8-.6.6-.5-.5-.4-1.2.1-4.2,1.5-4.5.2-.6.6-1.1,1-2h.5l.5.5Z"
          fill="#33365f"
        />
        <path d="M18.4,170.3c0-.2,0-.3,0-.5s0-.3,0-.5h.5c.6.5.3,1.4-.5,1Z" fill="#343657" />
        <path d="M22.4,159.8c0-.2,0-.3,0-.5s0-.3,0-.5h.5c.4.5.2,1.2-.5,1Z" fill="#33365f" />
        <path
          d="M40.3,98.9c.8-.1,3.9.2,4,0s-.2-1.8,0-2,1.9.3,2.4,0,0-2.6.5-3.6,3.8-4,4-4.1c1.2.2,8.7,0,9-.2s-.1-3.3,0-4c2,.2,5.5-.6,6.5,1.5-3.6.3-2,.7-2.2,2.2s-2.7,2.9-4.3,2.3c.8,3.8-1,3.1-2.5,5.3l1,1-1.7,1.3.2-2c-3.1.3-.5,2.6-.5,2.7,0,.4-1.4.9-1.8,1.2-.6.7-.5,1.3-.9,1.9-.7,1-1.5-.3-.8,2.2.4.2.4.3,0,.5l-1,1c.4.1.4.3,0,.5l-.5.5c.2.8-.7,1.9-1.5,2,.1.8-.8,1.5-1.5,2-.5,1.4-1.2,3.2-2.5,4-.3,1-1,1.8-2,2.5.2.9-.6,2.3-1.5,2.5.3.6.2,1-.5,1l-.5.5c.4.2.4.3,0,.5-.5,1.1-1.2,2.1-2,3,0,1.1-.5,1.9-1.5,2.5,0,.9-.6,2.6-1.5,3,0,1-1.2,2.6-2,3-.9,2.7-2.3,5.3-4,7.5.3.6.1.9-.5,1-.3,2.7-2,5.3-3.5,7.5l-.5.5c.4.1.4.3,0,.5l-.5.5c.6.8,0,2.2-1,2-1.1,1.2-2,3.2-2.5,6,.3.2.3.3,0,.5-1.5,3.3-2.8,6.7-4,10,.3.1.3.3,0,.5-1.6,3.6-2.9,7.3-3.7,11-1.1,1.2-1.4,2.3-.9,3.2-.8,1.8-1.3,3.1-1.9,5.2s-.5.4-1,0c0-.2-.5-.7-.5-1.3,0-1.8.9-3.8.5-5.7-.6.9-3.4,1.3-3.5,1.5s.8,1.2.3,2.5-1.5,1.3-2,2.1c-1.2,1.8-4.9,7.8-5.5,9.5-1.5,4.1-.8,6.9-3.3,11.5,0-1,0-2.1.1-3.1.8-4.7,2.9-10.8,5.2-14.8s3.6-4.1,4-5.1-.6-2,0-3,3-.8,3.2-1.8-.5-2-.5-3c0-1.6.9-2.4,1.1-3.5s-.4-1.7-.4-2.4c.1-1.2,1.8-1.9,1.8-3,.1-2-1.7-6.8-.2-8.3s2.1-.6,2.5-1.5,0-2.9.3-4.2,2-1.7,2.6-3.4,0-4.4.4-6.6.8-1.6.9-2.6c.3-2.4-.2-4.8,1-7.2.9-.7,2.3-1.2,3-2.2s.7-2.5,1.5-3,2.2-.3,2.9-.9,0-3.9,1.1-4.7,2.2,0,2.8-.7.2-1.7.6-2.4c1.6-3,3.5-3.9.1-7.1,2.4.3,2.1-2.6,3.5-3.3s1.8-.1,1.9-.3,0-1.3.3-1.9,1.1-.4,1.2-.9c.2-.9-.4-2.3.2-3.2s1.9-.1,2.3-1.7-2.6,0-3-1.2c.7-1.3,1.7-3.3,3-3.5Z"
          fill="#fdfdfd"
        />
        <path
          d="M18.4,170.3c.4,0,.4.3,0,.5.2.9-.2,2.1-1,2.5.3.6,0,1.6-.5,2,.1,1.3-.2,2.2-1,2.5.3.6.1,1.7-.5,2-1.8,6.3-4.5,13.6-5.5,20v-1.5s-1,.5-1,.5c-.1-1.1.3-2,.5-3l-.8-.9c.1-1,1.5-4.8,2.3-5.1,0-.2,0-.3,0-.5,1.5-.9.6-3,1.2-4s1.2.1,1.3,0c.7-1.1-1-1-1-1.3-.1-2.2,1.5-2.6,2-3.3s-.5-1.2-.5-1.6,2.5-3.7,2.7-4.9c.4-1.9-.8-3.2,1.8-4.4.3,0,.2.3,0,.5Z"
          fill="#fdfdfb"
        />
        <path
          d="M24.9,152.8c-.5,1.2-1,3.1-1.5,4.5v.5l-.5.5c.4.1.4.3,0,.5-.1.4-.3.4-.5,0,.4-1.7.3-3.1.6-4.6s.9-2.6,1.9-1.4Z"
          fill="#fdfdfb"
        />
        <path
          d="M49.3,110.9c1.2.6-1.5,4.4-2.2,4.8s-.4,0-.8-.3v-.5c.9-1.3,1.6-2.7,2.5-4,.2-.2.3-.2.5,0Z"
          fill="#322c51"
        />
        <path
          d="M22.4,159.3c.2.2.2.3,0,.5-.4,3.1-2,6.8-3.5,9.5-.1.4-.3.4-.5,0-.1-.5-1.1-2.4-1-2.5h2c-1.3-2.5,1.5-2,1.2-5l1.8-2.5Z"
          fill="#fdfdfb"
        />
        <path
          d="M52.3,106.9v1c.6.8-.6,2-1.5,1.5-.7.7-1,.4-.5-.5.6-.8.5-1.1,1.5-2h.5Z"
          fill="#2f244f"
        />
        <path d="M50.8,109.4c.5,1.1-.4,2.1-1.5,1.5h-.5c.5-.7,1-1.3,1.5-2l.5.5Z" fill="#473765" />
        <path d="M46.3,115.4c1.1.6,0,2.2-1,1.5l-1,.5c.6-1,1.5-1.8,2-2.5v.5Z" fill="#453c5f" />
        <path d="M31.4,141.3c1.1.4.6,1.5-.5,1.5l-.5-1c.2-.3.3-.7.5-1l.5.5Z" fill="#0e0d30" />
        <path d="M20.9,157.3c-.1-.9,0-1.7,1-2,.1.9,0,1.7-1,2Z" fill="#fdfdfb" />
        <rect fill="#fdfdfb" height=".5" width="2" x="61.3" y="88.9" />
        <path d="M18.4,164.8c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#fdfdfb" />
        <path d="M41.8,121.4c.2-.3.5-.5.5-.5l-.5.5Z" fill="#5472bc" />
        <path d="M26.4,149.8c.1-.4.5-.5.5-.5l-.5.5Z" fill="#4f6ebf" />
        <path d="M26.4,150.8h-.5c0-.2.3-.4.5-.5v.5Z" fill="#4f6ebf" />
        <path d="M52.3,106.9h-.5c.2-.2.3-.3.5-.5,0,.1,0,.3,0,.5Z" fill="#483b66" />
        <path d="M53.3,105.4c-.3.2-.7.3-1,.5.2-.5.5-.8,1-1,.2.2.2.3,0,.5Z" fill="#483b66" />
        <path
          d="M35.3,133.8c.3.3.5.5.4.6-.4.9-3.3,6.9-3.7,6.9s-.5,0-.7,0c-.6.6-.7.3-.5-.5,1.3-2.5,2.6-5,4-7.5.7-.7,1-.4.5.5Z"
          fill="#282748"
        />
        <path
          d="M30.9,142.8c.8.9.1,2.4-1,2.5-.9,2.2-1.9,4.2-3,6-.7.7-1,.4-.5-.5-.2-.2-.2-.3,0-.5,0-.2,0-.4,0-.5l.5-.5c1.1-2.6,2.2-5,3.5-7.5.5-.4.6,0,.5,1Z"
          fill="#282c53"
        />
        <path
          d="M37.3,130.8c.6.8-1,3.3-2,3l-.5-.5c.7-1.2,1.5-2.2,2-3,.6-.7.8-.4.5.5Z"
          fill="#313053"
        />
        <path
          d="M38.8,127.9c1,.7-.4,3-1.5,3l-.5-.5c.5-.8.9-1.9,1.5-3,.7-.7,1-.4.5.5Z"
          fill="#2b213a"
        />
        <path
          d="M43.3,120.4c-.7.7-.7.4-.5-.5.5-.9,1-1.6,1.5-2.5.3-.5.7-.6,1-.5.7,1-.8,3.5-2,3.5Z"
          fill="#3a3a63"
        />
        <path
          d="M41.8,122.4c1.2.9-.4,2.4-1.5,2.5-.1.4-.3.4-.5,0,.6-1,1-2.2,2-3,.2.2.2.3,0,.5Z"
          fill="#393964"
        />
        <path
          d="M40.3,125.9c.8,1-.3,2.2-1.5,2l-.5-.5c.5-.8,1-1.7,1.5-2.5h.5c.6,0,.6.3,0,1Z"
          fill="#323150"
        />
        <path
          d="M43.3,120.4c.4.1.4.3,0,.5.1.7-.6,2.4-1.5,1.5,0-.1,0-.4,0-.5s0-.4,0-.5l.5-.5c.2-.3.3-.7.5-1l.5.5Z"
          fill="#2a2b4d"
        />
        <path d="M53.3,105.4v-.5h.5c-.2.2-.3.4-.5.5Z" fill="#16184e" />
        <path d="M66.3,89.4v-.5l.5.2c0,.3-.5.2-.5.2Z" fill="#0d1240" />
        <path d="M137.3,34.4l.5-.5c-.2,0-.3.4-.5.5Z" fill="#3d50a4" />
        <path d="M127.3,39.9c.2-.5.5-.8,1-1-.2.5-.6.7-1,1Z" fill="#3c3c89" />
        <path d="M83.3,71.9v-.5h.5c-.2.1-.3.4-.5.5Z" fill="#0f1d69" />
        <path
          d="M203.7-5.1c1.7,2.9-3.3,1-3.9,2.8s1.1,3.9.7,4.7c-1.1,2.3-7.7,1.5-4.3,7,.5,1.3,0,1.5-1,.5-1.2,0-2.2,0-3,0,.5.4.6.7.5,1,.4.1.4.3,0,.5-1.8,2-5.2,2.2-7.7,1.1-1.3-.2-2.3.5-3.1,1.9l-.7-1c-.7.2-1.6.6-2.5,1,.7.7.4,1-.5.5-.3.9-.7.9-1,0-1.3,3.1-5.4,4.1-6.6,0-.3-.2-6.2,2.9-5.4,3.9-2.1-.4,2-2.5,2.2-2.4,2.5,1.7-1,4.5-2.2,2.4,4,1.2-4.4,3.1-6,3.4l-.9,1.3c-4.4,1-8.6,2.8-12.6,5.3,0,.4-.4.7-1,1-1.4,1.1-3.2,2.1-5,2.5-.4.8-1.2,1.3-2,1-2.7,2-5.5,3.3-8.5,4l-.5.5c-.1.4-.3.4-.5,0l-.5.5c-1.1,1.5-3.3,2.6-5,3-.1.7-1.4,1.2-2,1l-1,1c0,.6-.5.7-1,.5l-2,1.5c-.3.3-.6.6-1,.5-.6.6-1.2,1.1-2,1.5-.2.4-.5.7-1,.5,0,.6-.9,1.2-1.5,1-.3.9-1.1,1.3-2,1.5-1.1,1.2-2.5,2.2-4,3,0,.7-.4.6-1,.5-.2.9-1.5,2.1-2.5,2-.5.8-1.1,1.6-2,1.5,0,.3-.2.5-.5.5-.3,1.1-1.4,1.8-2.5,2-.6,1.1-1.7,2.4-3,2.5-.6,1.2-1.5,1.9-2.5,2-.7,1.3-2.1,2.5-3.5,3,0,.6-.5,1.1-1.5,1.5-.7,1.1-1.8,2-3,2.5l-.5.5c-.6,1.3-1.5,2.1-2.5,2.5-2.1,3-4.6,5.5-7.5,7.5-.5.8-1,1.7-2,2-.2,1.7-2.9,4.6-4.5,5-1.4,2.4-3.3,4.5-5.5,6.5-.3,1.4-2.1,4.1-3.5,4.5l-1.5,1.5c.4.2.4.3,0,.5-.7,1.2-1.6,2-2.5,2.5-1.2-.2-1.3-.6-1.1-1.7s2.7-3.5,3.2-3.7c-1.2-1.8-.3-3.4,1.8-3.6,2-1.8,2.4-2.3,2.5-4.9,3.5-.6,3.8-1.3,4.3-4.5-2.2-.7-3.2.4-3.1,3.5-3,.8-6.1,1.1-9.3.7l-3.5,3.6c.3,3-.7,4.4-2.8,4.2.2,2.5-4.3,2.8-5.1,1-1.7-.3-3-1.2-3.7-2.5-3-.2-2.4-2.1-.3-3.5,1.1-3.5,4.7-3.8,7.6-2.3l.7-.8c-1.9-2.6-.4-4.4,2.6-4.5-.7-3.1.7-3.7,3.3-3.3,0-1.6.5-2.9,1.5-3.9.2-2.2,1.4-4.4,3.6-6.4.4-2.1,2.1-3.5,5.2-4.2,1-3.5,4.1-6.1,7.2-7.8,1.4-1.9,2.5-4.2,3.2-6.9-3.5-2.2-.7-4.6,2.6-3.1,1.7-1.6,3.5-2.3,5.4-2.2-.9-3.1,4.8-4.6,5-1.6h.7c.2-3.1,3.3-2.9,3.8.2,2.3-2.4,4.6-3.2,8-4.4-.4-2.4.2-8.4,3.6-5.8.8-1.9,2.5-1.9,4.3-1.7,2.5-1.3,4.6-2.6,6.4-4.9-2.4-2.6,2.5-4.1,4.2-2.4.8-1.6,2.4-2,4.6-1.3,1.5-3.6,3-4.6,4.6-3.2l1.1-.5c3.6.6,7,.9,8.9-2.9,1-1,2.3-.9,3.9.2,1.8-3.4,3.9-4.7,6.4-3.9,1.1-2.6,3.1-3.4,4.7-.7.5-1.1,1.5-1.9,2.8-2.2-.8-3.9,3.4-9.3,4.7-3.6,2.9-.5,4.2.5,4.1,3.1,1.2.4,2.4.8,3.6,1.2,0-2.4,1.8-2.4,3.6-1.8,3.3-1.4,1.2-1.7-6.1-.9-2.6-1.3-.6-3.1,1.3-3.7-1-2.6,0-5.8,3-5.3.1-.3.3-.3.5,0,.7-.4,1.6-.2,2.7.6,1.7-1.4,3.2-2,5.4-1.2.2-.9.3-1.5,1.5-1.4.8-1.1,6.4-3.3,7.8-3.5s2.3.5,3.4.5,2.2-1,3.5-1c2.6,0,2.4.3,5.5,0s4.7,1.1,7.2-.5Z"
          fill="#fdfdfb"
        />
        <path
          d="M137.8,33.4c.8-.3.9-.2.5.5-.1.4-.3.3-.5,0l-.5.5c-.1.5-.3.4-.5,0l-.5.5c-.1.4-.3.4-.5,0l-1,1c-.1.4-.3.4-.5,0l-.5.5c-.1.4-.3.4-.5,0l-.5.5c-.8,1.2-2.5,2.3-4,2-.9.2-1.1,0-.5-.5v-.5c.1,0,.4,0,.5,0l.5-.5c2.8-1.5,5.7-2.6,8.5-4Z"
          fill="#3c3c89"
        />
        <path
          d="M66.3,89.4c0,.3,0,.7,0,1-.7,1.9-2,3.6-4,4-.4.4-1.1.6-1.5,1,1.4-2.5,3.6-4.4,5.5-6.5.3.1.3.3,0,.5Z"
          fill="#2b2a55"
        />
        <path
          d="M128.3,38.4c.2,0,.4.3.5.5-.1.4-.3.4-.5,0l-1,1c-.7,1-2.9,2.4-4,2-.8.3-.9.2-.5-.5,1.4-.8,3.6-2.6,5-3h.5Z"
          fill="#3d307d"
        />
        <path
          d="M109.8,50.4c-.1.9-1,1.8-2.5,2.5.1.9-1.1,1.4-1.5.5-.2.3-.3.3-.5,0,.8-1.6,2.7-2.1,4-3h.5Z"
          fill="#3c3b7e"
        />
        <path
          d="M91.3,64.9c.4.1.4.3,0,.5-.4.9-1.9,2.3-3,2.5-.8.4-1,.3-.5-.5,1.2-1,2.3-2,3.5-3,.3.1.3.3,0,.5Z"
          fill="#3b3e7d"
        />
        <path d="M180.3-.6c.9.9-1.1,2.7-2,1.5s1.4-2.1,2-1.5Z" fill="#fdfdfb" />
        <path
          d="M86.8,68.9c0,.9-1.1,1.9-2,2-.3.4-.7.6-1,.5h-.5c1.1-1,2-1.6,3-2.5h.5Z"
          fill="#32387a"
        />
        <path d="M99.8,58.4c-.2.9-1.6,2.4-2.5,2l-.5-.5c.8-.7,1.6-1.3,2.5-2l.5.5Z" fill="#483b7a" />
        <path d="M87.3,47.9v1.5s-2,0-2,0v-.7c.5-.8,1.1-.9,2-.8Z" fill="#fdfbfa" />
        <path d="M93.8,62.9c.6.7-1.2,2.3-2,2l-.5-.5c.8-.7,1.7-1.3,2.5-2v.5Z" fill="#443676" />
        <path
          d="M82.8,72.4l.3.5-3.3,3.5c.1.5,0,.6-.5.5-.2.2-.3.2-.5,0,.6-.7,1.1-1.6,1.5-2.5.8-.8,1.6-1.7,2.5-2.5.3.1.3.3,0,.5Z"
          fill="#2e3b80"
        />
        <path d="M72.3,83.4c-1.8,1.5-1.2.4-1.5.5.3-1,1.4-1.4,2-2l-.5,1.5Z" fill="#2a2443" />
        <path d="M190.3,8.4c.9.8-2.2,2.5-2,0,.5,0,1.8-.1,2,0Z" fill="#fdfdfb" />
        <path
          d="M139.8,32.4c.4-.2.7-.2,1,0,.8,1.2-1,2.4-2,1.5h-.5l-.5-.5c.7-.3,1.3-.7,2-1Z"
          fill="#3d50a4"
        />
        <path
          d="M123.3,41.9c.2,1-1.4,1.8-2,1h-.5c-.3-.1-.3-.3,0-.5.6-.4,1.4-.6,2-1l.5.5Z"
          fill="#41418a"
        />
        <path
          d="M144.8,29.9c.4.2.4.3,0,.5l-.5.5c-.3.2-.7.3-1,0l-.5.5-.5.5c-.1.4-.3.4-.5,0l-.5.5c-.2.4-.3.4-.5,0-.3,0-.7,0-1,0,1.7-.8,3.3-1.7,5-2.5Z"
          fill="#47428c"
        />
        <path d="M118.8,44.4c.2.7-.9,1.4-1.5,1h-.5c.4-.9,1.3-1.1,2-1.5v.5Z" fill="#4d497c" />
        <path
          d="M111.3,49.4c.1.3,0,.6-.5,1-.1.4-.3.4-.5,0-.2.4-.3.4-.5,0h-.5c.6-.4,1.2-.9,2-1.5.4.1.4.3,0,.5Z"
          fill="#4d468b"
        />
        <path
          d="M113.3,48.4c-.1.7-.8,1.2-1.5,1h-.5v-.5c.5-.3.9-.7,1.5-1,.6-.4.9-.2.5.5Z"
          fill="#46397c"
        />
        <path
          d="M115.8,46.4c0,.9-.6,1.3-1.5,1h-.5c.4-.9,1.2-1.1,2-1.5.3.2.3.3,0,.5Z"
          fill="#483376"
        />
        <path d="M88.3,67.9c0,.7-.9,1.3-1.5,1h-.5c.5-.4.9-1,1.5-1.5l.5.5Z" fill="#28285b" />
        <path d="M113.8,47.4h.5c.5.6-.3,1.2-1,1l-.5-.5c.3-.2.5-.5,1-.5Z" fill="#3e2978" />
        <path d="M116.8,45.4h.5c.2.7-.9,1.4-1.5,1v-.5c.3-.2.5-.6,1-.5Z" fill="#38377b" />
        <path d="M100.3,57.9c-.1.4-.3.4-.5,0-.1.3-.3.3-.5,0,.2-.1.3-.4.5-.5l.5.5Z" fill="#2e1a60" />
        <path d="M146.8,28.9c-.2.6-1.3,1.1-2,1,.3-.4.7-.6,1-1h1Z" fill="#424693" />
        <path d="M83.3,71.9c.4.1.4.3,0,.5-.1.4-.3.4-.5,0v-.5c.2-.2.3-.3.5-.5v.5Z" fill="#13266f" />
        <path d="M120.8,42.9c-.3.2-.7.3-1,.5.2-.6.6-.7,1-1v.5Z" fill="#5f93d8" />
        <path d="M128.3,38.4c-.2,0-.4,0-.5,0,.2-.1.3-.4.5-.5v.5Z" fill="#c1e9f7" />
        <path d="M128.8,37.9c.1,0,.3-.4.5-.5l-.5.5Z" fill="#c1e9f7" />
        <path d="M166.8,1.4h-.5c0,0,0-.4.2-.5.3,0,.2.5.2.5Z" fill="#fdfdfb" />
        <path d="M53.8,104.9h-.5c0-.2,0-.3,0-.5l2.5-2.5c-.7.9-1.3,2.2-2,3Z" fill="#302c55" />
        <path d="M55.8,101.4c.6-.8,1.2-1.1,1.5-1.5l-1.5,1.5Z" fill="#302c55" />
        <path d="M136.3,34.9c.1,0,.2-.4.5-.5l-.5.5Z" fill="#3d50a4" />
        <path d="M134.8,35.9c0,0,.4-.7,1-1l-1,1Z" fill="#3d50a4" />
        <path d="M91.8,64.9h-.5c0-.2,0-.5,0-.5.2-.1.6.2.5.5Z" fill="#121c5c" />
        <path d="M97.3,60.4l-.5-.5.5.5Z" fill="#201f61" />
        <path d="M102.3,56.4c-.1,0-.4,0-.5,0v-.5l.5.5Z" fill="#190e4c" />
        <path d="M143.3,31.4c-.1,0-.3,0-.5,0,.1,0,.3-.4.5-.5.4.1.4.3,0,.5Z" fill="#424693" />
        <path d="M142.3,31.9c0-.2.3-.4.5-.5-.1,0-.3.4-.5.5Z" fill="#3d50a4" />
        <path
          d="M58.3,100.4l-1.1,1.3c-.8,2.5-1.9,3.9-3.4,4.2l-1,1c.4.2.4.3,0,.5h-.5c-.4-.1-.4-.3,0-.5-.2-.1-.2-.3,0-.5,0-.2,0-.4,0-.5.3-.5.6-.6,1-.5,0-.3.2-.5.5-.5.3-1,1-2,2-3,0-.1,0-.4,0-.5l1.5-1.5c1.2-1.6,1.9-2.9,3.5-4.5.5-.7,1-1.1,1.5-1,1.1,1.7-2.7,5-4,6Z"
          fill="#282958"
        />
        <path
          d="M69.3,87.9l-.5.5c-.1.4-.3.4-.5,0-.2,1-1,1.9-2,2-1,.2-.7-.5,0-1,.2-.2.2-.3,0-.5,1-1.2,3.1-4.7,4.5-5,.5-.4,1-.6,1.5-.5.3-.7.6-.8,1-.5-.9,1.8-2.3,3.5-4,5Z"
          fill="#3b4f8c"
        />
        <path
          d="M78.8,76.9c-1.2,2.4-3.3,4.6-5.5,6-.3.2-.7.3-1,.5-.5-.1-.4-.6.5-1.5,2.5-2.5,4.9-5,7.5-7.5.3.9-.7,2-1.5,2.5Z"
          fill="#212663"
        />
        <path
          d="M97.3,60.4c0,.9-1.6,2.3-2.5,2.5-.5.6-.8.9-1,0-.2-.2-.2-.3,0-.5,1-.8,2-1.7,3-2.5l.5.5Z"
          fill="#393076"
        />
        <path
          d="M104.3,54.9c.4.7-.3,1.4-1,1l-1,.5c-.3,0-.5-.2-.5-.5.8-.6,1.4-1.4,2.5-2,1.2-.4,1.2,0,0,1Z"
          fill="#46366b"
        />
        <path
          d="M101.8,56.4c.1.6-.8,1.5-1.5,1.5-.3,0-.5-.1-.5-.5.7-.5,1.3-1,2-1.5v.5Z"
          fill="#4c3068"
        />
        <path
          d="M105.3,53.4c.1,0,.4,0,.5,0,1.2.5-.6,1.9-1.5,1.5l.5-.8-.5-.2c.4-.2.6-.3,1-.5Z"
          fill="#3a3b80"
        />
        <path d="M99.8,58.4c-.3,0-.6-.3-.5-.5s.3,0,.5,0v.5Z" fill="#211b66" />
        <path d="M141.3,32.4c.1-.2.3-.4.5-.5,0,.2-.3.4-.5.5Z" fill="#3d50a4" />
        <path d="M144.3,30.9c-.5.4-.5.3-1,.5v-.5c.2-.1.8.1,1,0Z" fill="#3d50a4" />
        <path d="M144.3,30.9c.2,0,.3-.4.5-.5-.2.2-.3.3-.5.5Z" fill="#424693" />
        <path d="M173.8,19.4c-.4.1-1.1-.1-1.5,0v-.5h1.2s.3.5.3.5Z" fill="#2344b4" />
        <path
          d="M266.2,6.4c-2.4.4-5.1.4-7.5,0-4.9.3-10.1.2-15,0-1,.4-2.4.4-3.5,0,0,.4-.3.4-.5,0-2.5,0-5,.1-7.5.5-1.8.4-3.8.5-6,.5-.1.3-.3.3-.5,0-2.8.7-5.6,1-8.5,1-.9.2-1.9.3-3,.5-1.5.7-3.4,1.1-5.5,1-.1.3-.3.3-.5,0-.8.5-2.1.8-3,.5-.8.4-1.6.5-2.5.5-.2.4-.3.4-.5,0-.5.4-1.2.5-2,.5-.4.3-1.1.4-2,.5-.1.3-.3.3-.5,0-1.3.5-3,1.2-4.5,1-1.2.9-3.4,1.4-5,1.5-.3.4-.6.3-1,0,0,.7-.9.8-1.5.5-.9.7-2.3.9-3.5,1,0,.3-.3.2-.5,0-.6.9-1.9,1.1-3,1-.9.4-1.9.7-3,1-1,.8-2.2,1.1-3.5,1-.7.6-2.1,1.3-3,1-.9.7-2.4,1.2-3.5,1-.4.7-1.2,1.3-2,1-1.1,1.1-3.4,1.7-5,2h-.5c-.9.8-2,1.3-3.5,1.5-.5.8-2.1,1.7-3,1.5-1.1,1-3.5,1.9-5,2-.4.2-.8.2-1,0,2.8-3.5,3.2-2.7,7.5-4.3s2.7-2.4,5-1.3c0-2.4-1.1-.3-2-2,1.8,0,4.1,0,5.9-.4s2.1-1.8,3.4-.7c.3-.4-.2-.9-.3-1.5.8,0,2.3-.6,2.5-1.5-1.3.3-2.6,0-2.5,1.5-.9,0-1.6-.4-1.5-1.5,3.6.4,1.8-.5,2.5-1.2s3.4-1.3,4.3-2.8h.7c.5,2.5,1.5,4.3,4.2,2.9s.3-1.2,1.8-1.4c.3.4.6.4,1,0,.2-.2.3-.3.5-.5.9-.4,1.7-.7,2.5-1,.2,0,.7.2.9,0s-1-1.7,2.5-1.8,2.8,1,4.4.9,1.9-.9,3.7-1.1c1.8-.3,1.8-.4,0-.5-.3-.2-.6-.6-.5-1,.9,0,1.9,0,3,0,.5,0,.9-.5,1-.5,5.4-.3,8.3-.5,13.8-1.5s2.5.2,3.4,0,.3-1.8,1.3-1-.4,1.9,2.2.5,2.9-1.5,4.2-1.9c2.2-.8,3.1.2,4.3,0s.7-3.1,4.9-1.8c9.7,3.1,21.4,1,31.7,1.8s2.2-1.4,4.2,1Z"
          fill="#fdfbfa"
        />
        <path
          d="M266.2,6.4c.2.2.4.3.5.5h-5.5c0,.9-2.2.8-2.5,0-.4-.1-.4-.3,0-.5,2.5,0,5,0,7.5,0Z"
          fill="#4442af"
        />
        <path d="M195.2,9.9c-.7,0-1.6.9-3,0,.3-1.9,1.7.3,3,0Z" fill="#fdfdfb" />
        <path d="M178.3,14.9c0,0,.5,1.4-1.2,1.5l.2-1.5c.3,0,.7,0,1,0Z" fill="#fdfdfb" />
        <path d="M181.3,13.4c-.8.4-1.4,1.2-2.5,1,.7-.6,1.6-.8,2.3-1.5l.2.5Z" fill="#fdfdfb" />
        <path d="M192.8,10.9c2.2,0,2.1.3,0,.5v-.5Z" fill="#fdfdfb" />
        <path
          d="M258.7,6.4v.5c-4.8.8-10.1.4-15,0-.4-.1-.4-.3,0-.5,5.4-.2,9.6-.2,15,0Z"
          fill="#244bb7"
        />
        <path
          d="M151.8,26.9c.8-.3,1-.3.5.5-1.5,1.8-5.1,3.6-7.5,3,0,0,0-.4,0-.5.7-.3,1.4-.7,2-1,2-.9,3-1.3,5-2Z"
          fill="#3e4593"
        />
        <path
          d="M214.2,8.9c.9-.4,2.1-.4,3,0,.2-.3.3-.3.5,0-.9,1.9-5.8,2.5-7.5,1.5l-1.5-.5c1.6-.8,3.8-.9,5.5-1Z"
          fill="#3754ca"
        />
        <path
          d="M225.7,7.4c.4.1.4.3,0,.5-.7,1.1-5.2,2.2-6,1-.9-.1-1.7-.3-2.5-.5,3-.4,5.4-1,8.5-1Z"
          fill="#4a52ad"
        />
        <path
          d="M163.8,21.9c.8-.3.9-.3.5.5-.3.8-1.3,1.3-3,1.5-.1.9-1.4,1.3-2,.5l-.5-.5c1.2-1.4,3.5-1.4,5-2Z"
          fill="#4e45a3"
        />
        <path
          d="M193.3,12.9c.5,0,.7,0,.5.5-1.1.9-2.6,1.4-4.5,1.5l-1-.5c1.4-.9,3.4-1.1,5-1.5Z"
          fill="#454bba"
        />
        <path
          d="M197.7,11.9c.4.1.4.3,0,.5-.8,1-2.8,1.4-4,1l-.5-.5c1.7-.4,2.6-.9,4.5-1Z"
          fill="#4844b5"
        />
        <path d="M239.7,6.4c-2.4.1-4.9.5-7.5.5,2.1-1.1,5.1-.2,7.5-.5Z" fill="#585db9" />
        <path
          d="M154.8,25.4c.4-.3.8-.3,1,0,.5,1.2-2.6,2.3-3.5,2l-.5-.5c.8-.3,1.6-1.1,3-1.5Z"
          fill="#3d479b"
        />
        <path
          d="M169.3,19.9v.5c0,1.2-2.2,1.9-3,1-.8.2-.9.2-.5-.5,1.3-.5,2.4-.6,3.5-1Z"
          fill="#4d439d"
        />
        <path
          d="M175.8,17.9c.4-.3.7-.4,1,0,.1,1.2-2,1.9-3,1.5l-1.5-.5c1.3-.4,1.9-.9,3.5-1Z"
          fill="#4250b2"
        />
        <path
          d="M185.8,14.9c.4.1.4.3,0,.5.7,1.1-1.8,2-2.5,1l-1-.5c.9-.9,2.4-.8,3.5-1Z"
          fill="#4143b6"
        />
        <path
          d="M158.3,23.9c.3,0,.5.1.5.5.6,1-1.4,2-2,1-.4.8-.9.9-1,0-.3,0-.7,0-1,0,1-.7,2.3-1.3,3.5-1.5Z"
          fill="#554f93"
        />
        <path
          d="M172.3,18.9c.4.1.4.3,0,.5.2,1.1-1.9,2.1-2.5,1-.3,0-.5-.2-.5-.5,1-.3,1.8-.7,3-1Z"
          fill="#2c4cb8"
        />
        <path
          d="M181.8,15.9c.3,0,.5.1.5.5,0,1.4-1,1.9-2,1h-.5l-1-.5c1-.3,1.8-.8,3-1Z"
          fill="#4950b2"
        />
        <path
          d="M208.2,9.9c.4.1.4.3,0,.5-.8.4-1.6.5-2.5.5.3,1.2-1.4,1.4-2,.5-.5.4-1,.6-1.5.5-.4-.1-.4-.3,0-.5-.4-.1-.4-.3,0-.5.2,0,.3,0,.5,0,.9,0,1.7-.2,2.5-.5,1-.1,1.7-.4,3-.5Z"
          fill="#4c51c1"
        />
        <path
          d="M178.8,16.9c.4.1.4.3,0,.5-.2.7-1.6,1.4-2,.5-.3,0-.7,0-1,0,.8-1,2.1-.7,3-1Z"
          fill="#464eb5"
        />
        <path d="M166.3,21.4c.4,1-1.2,1.7-2,1l-.5-.5c.6-.2,1.2-.7,2-1l.5.5Z" fill="#4e51ae" />
        <path
          d="M243.7,6.4v.5c-.2.6-.6.5-1,0-.8,0-2.1.3-2.5-.5,1.2,0,2.3,0,3.5,0Z"
          fill="#3944af"
        />
        <path
          d="M228.7,7.9c-1.4.7-2.4.7-3,0v-.5c.2,0,.3,0,.5,0,.9,0,2.4-.3,2.5.5Z"
          fill="#2b37bd"
        />
        <path d="M217.2,8.4c.4.1.4.3,0,.5-1,0-2,0-3,0,.6-.9,2.1-.4,3-.5Z" fill="#543bab" />
        <path
          d="M187.3,14.4c.4,0,.5.2.5.5.4.1.4.3,0,.5,0,1.2-1.6,1.2-2,0v-.5c.4,0,.9-.4,1.5-.5Z"
          fill="#2a3eba"
        />
        <path
          d="M200.2,11.4c.4.1.4.3,0,.5.4.5,0,.6-.5.5l-1.5-.5c.4-.8,1.4-.4,2-.5Z"
          fill="#5b45a8"
        />
        <path d="M205.2,10.4c-.4.8-1.7.5-2.5.5.8-.1,1.6-.4,2.5-.5Z" fill="#584eb8" />
        <path
          d="M210.2,10.4c-.4,1.1-1.6,1.1-2,0v-.5c.2,0,.3,0,.5,0,.6,0,1.2-.2,1.5.5Z"
          fill="#1f3aba"
        />
        <path d="M202.2,10.9v.5c-.3.5-1.5.3-2,0,.6-.1,1.2-.3,2-.5Z" fill="#584eb8" />
        <path
          d="M188.3,14.4c.4,0,.9,0,1,.5-.5.3-1.1.4-1.5,0-.2,0-.4-.3-.5-.5.3,0,.7,0,1,0Z"
          fill="#2a38b3"
        />
        <path d="M182.8,13.9v.5c-2.1.2-2.1-.7,0-.5Z" fill="#fdfdfb" />
        <path d="M181.3,14.9c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#fdfdfb" />
        <path d="M170.3,16.9c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#fdfdfb" />
        <path d="M172,17.4c.3.2.3.3,0,.5v-.5Z" fill="#fdfdfb" />
        <path d="M219.7,8.9c-.7,0-1.3,0-2,0s-.3,0-.5,0v-.5h2.2c0,0,.3.5.3.5Z" fill="#4747b6" />
        <path d="M169.8,20.4c-.1,0-.4,0-.5,0v-.5l.5.5Z" fill="#2539a5" />
        <path d="M179.8,17.4c-.3,0-.7,0-1,0v-.5h.7s.3.5.3.5Z" fill="#2832a1" />
        <path d="M208.2,10.4c-.3.8-1.7.5-2.5.5.8-.1,1.5-.3,2.5-.5Z" fill="#2255d7" />
        <path d="M202.2,11.4v.5c-.6.1-1.4-.1-2,0v-.5h2Z" fill="#283ab4" />
        <path d="M400.6,58.4h-.5c0-.3.3-.6.5-.5s0,.4,0,.5Z" fill="#213589" />
        <path d="M394.1,53.4h-.5v-.5h.5c0,.2,0,.4,0,.5Z" fill="#221f71" />
        <path d="M398.1,56.4c-.1-.2-.4-.3-.5-.5.1,0,.3,0,.5,0v.5Z" fill="#293176" />
        <path d="M387.6,48.4c0,0,0,.4,0,.5-.5,0-.7-.3-1-.5h.5c.2,0,.4,0,.5,0Z" fill="#2d428d" />
        <path
          d="M16.4,178.3c-.2.5-.2,1.6-.5,2.5l-.5-1c.2-.6.3-1.3.5-2,.7-.7.9-.4.5.5Z"
          fill="#1c1e42"
        />
        <path d="M39.3,377.2c0-.1-.4-.3-.5-.5l.5.5Z" fill="#191d2a" />
        <path
          d="M395.1,51.4c0-.2.6-.9.5-1-.3-.3-2.5,0-2.5-1,2.7.6,2.6-1.5,3.8-1.9,2.6-.8,5.2,2.5,6,4.8s-.3,1.1,0,2c1,2.7,5.9,9.4,8.1,10.9s3.4.4,4,1.1.6,1.5.5,1.7c-1,1.1-.9-2-2-.7.5.5.9,1,1.5,1.4s1.9-1,.5,1.8c-1.1-1-2.4-2-3.5-3-.5.1-.6,0-.5-.5-1.2-.4-2.6-1.3-3-2.5-1.4-.2-2.4-1.2-3-2.5-1.1-.2-2.9-1.4-2.5-2.5l.5-.5c0-.1,0-.3,0-.5-.2-.5-.5-.8-1-1-1.5-.4-2.6-1.9-4-2.5.2-.7,1.6-.9,1.3-2-2.3,2.1-2.2,0-2.6,0-1.7-.4-2.3,1-2.2-1.5Z"
          fill="#fdfdfb"
        />
        <path d="M402.6,57.4c.4.1,1,0,1.5,0,.2.1-.4.7-.5,1l-1-1Z" fill="#fdfdfd" />
        <path d="M403.1,59.4l.5-.5c0,.2,0,.6-.5.5Z" fill="#fdfdfd" />
        <path d="M412.1,67.4l-.5.5c-.2-.2-.3-.3-.5-.5l.5-.5c.2.2.3.3.5.5Z" fill="#223074" />
        <path d="M400.1,52.4c-.2.2-1.6,0-2-.2-1.9-1.1-.2-3.3,1.5-2s.6,2.1.5,2.3Z" fill="#fdfbfa" />
        <path d="M408.6,64.4l-.5.5c-.6.8-3.4-1.5-3-2.5l.5-.5c1,.8,2,1.7,3,2.5Z" fill="#4f5f94" />
        <path
          d="M411.6,66.9l-.5.5c-.9-.8-1.8-1.8-3-2-.5-.1-.5-.3,0-.5l.5-.5c1,.8,2,1.6,3,2.5Z"
          fill="#4b568f"
        />
        <path d="M404.9,59.9c.3.2.3.3,0,.5v-.5Z" fill="#fdfdfd" />
        <path d="M405.1,62.4l.5-.5-.5.5Z" fill="#263d7c" />
        <path d="M411.1,67.4l.5-.5-.5.5Z" fill="#252e69" />
        <path d="M408.1,64.9c0-.3.2-.6.5-.5,0,.4-.1.5-.5.5Z" fill="#233a79" />
        <path
          d="M17.4,176.3c.8.3.6.8-.5,1.5-.1,0-.5.4-.5.5l-.5-.5c.3-1,.8-1.8,1-2.5l.5,1Z"
          fill="#2d3462"
        />
        <path d="M22.9,158.3c.1-.4.5-.5.5-.5l-.5.5Z" fill="#33365f" />
        <path
          d="M18.9,171.8c.8.9.3,2.3-1,2-.4.5-.5.3-.5-.5.2-.8.9-2.2,1-2.5l.5,1Z"
          fill="#343657"
        />
        <path
          d="M17.9,173.8c.9.8.7,1.4-.5,1.5-.1.4-.3.4-.5,0,.2-.6.3-1.3.5-2l.5.5Z"
          fill="#2f2f52"
        />
        <path d="M17.4,176.3l-.5-.3v-.7s.5,0,.5,0c0,.3,0,.7,0,1Z" fill="#1c2252" />
        <path
          d="M496.1,250.8v5l-1.2,5.8c-.9,2.2-2,2-2.3-.3-1.1-.6-1.1-1.4,0-2-1.3-.4-1.3-.6,0-1-1.4-1.3-1.4-2.1,0-2.5.1-.4.3-.4.5,0l.7.5c-.4-2.2,0-3.9,1.3-5-.7-1.7.6-2.5,1-.5Z"
          fill="#4855b4"
        />
        <path
          d="M496.1,266.8c-.1.4-.3.4-.5,0l-.5-1c-.4,1.2-1.9,3.2-2.5,1.5-.6.6-.7.3-.5-.5-.7.6-.8.4-.5-.5-2.3,0,.3-3.8,1-1.5,1.7-1.8,2.6-3.5,2.9-6.1h.6v8.1Z"
          fill="#3b4396"
        />
        <path
          d="M496.1,258.8c-.9.7-.3,2.1-.6,3.1s-1,1.7-1.3,2.7-.4.2-1.5.2c-1.3-.2-1.1-1.6,0-2-1.3-.5-1.4-1,0-1.5,2.3,3.5,1.9-4.3,3.5-5.5v3Z"
          fill="#424ca5"
        />
        <path
          d="M495.6,239.3c.4.7.4,1.3,0,2,.1,1.3.3,2.6.5,4v5.5l-1-.5c0,.3,0,.7,0,1-.1.4-.3.4-.5,0-1.1-1.5-1.2-3.9.1-5.2l.4-4.3c-.8-1.7-.7-4.2,0-6,.1-.4.3-.4.5,0,.4,1.1.4,2.4,0,3.5Z"
          fill="#5967bb"
        />
        <path
          d="M480.1,270.3c1.5-3.6,2.9-8.2,2.8-12.3,1.9-1.2,3-3.3,3.2-6.2.8-1.1,6.5-4.4,6-.9,1.6,1,2.1,3.4,1,5h-.5c-.5.6-1.3.5-2.2,0-1.9,3.2-3.9,6.4-5.8,9.6-1.3,3.8-2.8,7.4-4.5,11-.4.3-.6,0-.5-1-1.4-.6-1-4.8.5-5Z"
          fill="#4355c8"
        />
        <path
          d="M492.6,258.3v1c-1.2,2.7-2.8,4.9-4.8,6.6-2.1,4.8-4,9.7-5.5,14.8h-.7c.4,1.1-.5,1.8-1.5,1.6-1.1,0-.5-1.2,0-2-.8-1.2,2.7-10.8,3.2-11.2s.5-.2.8-.3c1-5,3.2-10.3,8.1-12.2l.4,1.7Z"
          fill="#3a48bb"
        />
        <path
          d="M492.6,259.3c0,.7,0,1.3,0,2s0,1,0,1.5c-3.9,4.5-7,11.4-8.9,18.3l-1.1.7-.5.5c-1.4.5-1.4-.7-.5-1.5.8-1.4,1.9-5.7,2.6-7.6s2.5-7.7,2.8-8.1,1.1-.2,1.4-.4,2.2-3.9,2.6-4.7.3-1.7,1.5-.7Z"
          fill="#3745b4"
        />
        <path
          d="M492.6,255.8v2.5c-.6-.5-.3-1.6-1.3-.5-1.9,2.1-5,4.4-6,7.4s.2,2.7-1.2,3.6c-1-.7-.3-2.6.5-3.5,1.2-4.7,1.4-4.3,4-7.9s.6-4.1,4-1.6Z"
          fill="#3e4ebe"
        />
        <path
          d="M494.6,251.3h.5c-.2,2.5-.3,4.5-1,7-1.3-.4-.8-1.7-1-2.5-.3-1.6-.7-3.4-1-5-1.3-1-1.3-1.7,0-2,.1-.4.3-.4.5,0,.9.2,1.6,1.1,2,2.5Z"
          fill="#4f64c3"
        />
        <path
          d="M492.6,262.8c0,.5.1,1.8,0,2s-.6-.1-.9.1c-.4.4,0,1.2-.1,1.4-2.3,6.1-4.8,12.1-7.6,18l-.9.5c-.1.4-.3.4-.5,0-.8-.6-.8-1.6,0-3,.7-4.1,3.3-9.6,4.8-13.5s2.9-3.6,3.6-4.5-.2-1.5,1.7-1.1Z"
          fill="#343fab"
        />
        <path
          d="M492.1,266.8c-1.3,4.9-2.8,10.8-5.5,15l-.5,1c.4.1.4.3,0,.5-.4,2.4-1.3,3.6-2.5,3.5-2.1.1.4-2.6.5-2s-1.2,1.2-1,0c-.3-1.3.9-1.9,1.3-2.7,2.3-6.5,3.8-9.5,7.2-15.7.2.1.3.3.5.5Z"
          fill="#3139a3"
        />
        <path
          d="M492.6,267.3c1.1.7,0,2.8-1,3.5.8,1.1.6,2.4-.6,3.8-.3,2-.9,3.5-1.9,4.7-.9,2.7-1.9,5.4-2.9,8.1h-.6c-.9-.8-.7-2.2.5-4.1,0-.2,0-.3,0-.5l.5-1c1-4,2.5-7.9,4.2-11.5s.5-2.4,1.3-3.4c.2.1.5.2.5.5Z"
          fill="#303696"
        />
        <path
          d="M495.6,266.8c0,.8,0,1.7,0,2.5-.1,1.7-.5,3.2-1,4.5l-.6,1.1c0,2.9-.8,4.4-2.4,4.4-1.4-.9.2-4.8,1.5-6-.9-1-.7-2.1.6-3.4l1.4-3.1c-.3,0-.3-.3,0-1,.7,0,.4.5.5,1Z"
          fill="#2d306b"
        />
        <path
          d="M495.1,266.8l-2.1,4.5c-.5.6-1,.2-1.4-.5.2-.7.7-3.3,1-3.5.5-.3,1.6.2,2.5-1.5,0,.3,0,.7,0,1Z"
          fill="#353d8d"
        />
        <path
          d="M495.1,234.3c0,.5,0,1,0,1.5,0,2,0,4,0,6l-.5,5.1c-.5,1.4-1.9,1.1-2-.5l-.4-4.6c-1.8-1-1.6-3.5-.5-5,1.1-.2,1.3.7,1.6,1.7.2-1.8.5-3.6.9-5.2.4-.8.7-.4,1,1Z"
          fill="#6b7fcc"
        />
        <path
          d="M492.1,241.8c0,.1.4.4.5.8.2.8-.3,4.2.8,4.2,2.3,0,.5-3.8,1.8-5,0,3.2,0,6.3-.5,9.5-1.9-.1-1.7-1.2-2-2.5-.5-1.9-1-3.9-1.5-6l1-1Z"
          fill="#5e73cb"
        />
        <path
          d="M490.1,202.8l.5.5c.5,2.8.9,5.7,1.5,8.5l.5,1c0,.4,0,1,0,1.5,0,.4,0,1,.5,1,0,.8,0,1.7,0,2.5v.5l.5,1c0,.7,0,1.3,0,2l.5,1c0,.6,0,1.3,0,2l.5,2c0,.5,0,1,0,1.5.2.5.3,1.2.5,2,.4,1,.4,2,0,3,0,.5,0,1,0,1.5l-1-1c-.7-2.8-1-5.8-1-9-1.2-2.7-4.2-11.9-3.5-14.4s.3-.7.5-1.1c-1.3-.1-1.2-.5,0-1-.3-.3-.3-.7,0-1-.6-1.3-1.6-5-1.1-6.5s.3,0,.6,0c.2.9.4,1.4.5,2.5Z"
          fill="#6778bc"
        />
        <path
          d="M323.2,17.9c.5,0,.8.2,1,.5.9.4,1.6.7,2.5,1s.3,0,.5,0c1,.3,1.7.7,3,1l.5.5c.9.4,2,.6,3,1s.4,0,.5,0c1.6.6,3.3,1.5,5,2s1.3.4,2,.5c.3.3.7.3,1,.5s.3.4.5.5c2.5,1.2,5.6,1.9,8,3s1.3.7,2,1c.4.1.4.3,0,.5-1.1.6-2.5.3-4-1-.1.4-.3.4-.5,0-1.6-1.1-3.5-2-5.5-2.5l-1,.3-14-5.3c-.6.4-2.3-.2-2-1-2.2-.3-3.5-1.2-4-2.5.5,0,1,0,1.5,0Z"
          fill="#73c2f3"
        />
        <path
          d="M285.7,9.9c1.1,0,2.1.4,3,.5.6-.3,1.4-.4,2,0,.2,0,.3,0,.5,0,.2,0,1.1.4,2,.5s.7,0,1,0c.7.2,1.4.3,2,.5.2,0,.3,0,.5,0l2.5.5c.8,0,1.5.2,2,.5.6-.4,1.6-.1,2,.5h.5c.1,0,.5.4,1,.5.5-.3,1.1-.5,1.5,0,.5-.4,1.1-.2,1,.5,1,.2,2,.3,3,.5.6,0,1.1.3,1.5.5.7-.2,1.3-.3,1.5.5.3,0,.7,0,1,0l.5.5c1.8.5,3.7.9,5.5,1.5.2.1.8,0,1,.5-.6.7-1.1.6-1.9.4-12.1-2.8-23.5-5.1-35.6-7.4s-.6-.3-.9-.5c-.3,1-2.7.6-3.5,0-1-.2-1.3-.5-1-1,2.5-.5,5,0,7.5.5Z"
          fill="#79cef6"
        />
        <path
          d="M243.7,6.9c5-.2,10,0,15,0h2.5c1.6.9,4.5.6,6.5.5.9.9,2.7.4,4,.5h.5c.5,0,1,0,1.5,0,1.4,0,3.2.4,5,.5.8.9,2.7.5,4,.5.5.9,2.1.4,3,.5v.5c-2.5-.2-5-.3-7.5-.5l-1.6.3c-16.4-1.5-33.4-2.2-49.4-.4l-.4-.4c.2-.5.9-.8,2-1,4.6-.3,9.6-.8,14-1s.7,0,1,0Z"
          fill="#6bbcf1"
        />
        <path
          d="M321.2,17.9c.2,0,.3,0,.5,0,1.2.9,2.7,1.7,4,2.5-1.5.9-5.1-.5-6.5-1.5l-12-3.1c-2.4-.3-4.7-.8-7-1.6l-16.7-2.7c-.9-.2-1.6-.4-.8-1.2,12.9,1.3,26.7,6.6,38.5,7.5Z"
          fill="#8edaf7"
        />
        <path
          d="M352.7,29.9c.6,0,1.5.5,2,.5,1,.5,2,1,3,1.5,1.7.8,3.3,1.6,5,2.5s3.4,1.6,5,2.5,2.8,2.1,4.5,2.5c1.4,1,2.9,1.9,4.5,2.5.2.2.3.4.5.5.9.7,1.7,1,2.5,1.5s2,1.4,3,2,.7.3,1,.5c.6.4,1.3,1,2,1.5s.7.3,1,.5c.5,0,.8.2,1,.5.4.5.6,1,1,1.5-1.1,0-2.2-.2-3.2-.8-12-7.4-24.6-14.5-37.1-20.1l.3-.6c2.1.7,1.9.7,4,1Z"
          fill="#7cc7f0"
        />
        <path
          d="M5.9,258.3c1.1.8,1.1,2.7,0,3.5.8,2.6,1,5.1.5,7.5,1.3,4.2,1.6,8.4,1,12.5.6,3.7,1.2,7.4,2,11l-.5,1.5c0,.4,0,.6-.5.5,0-.2,0-.3,0-.5l-.5-2c0-.2,0-.3,0-.5l-.5-2.5c0-.2,0-.3,0-.5l-.5-3c0-.3,0-.7,0-1l-.5-3c0-.5,0-1,0-1.5-.4-1.1-.4-2.5,0-3.5l-.5-.5c0-.5,0-1,0-1.5l-.5-5.5c0-.7,0-1.3,0-2l-.5-7.5c0-.5,0-1,0-1.5.1-.4.3-.4.5,0,.1-.4.3-.4.5,0Z"
          fill="#191434"
        />
        <path
          d="M5.9,237.3c.4,1,.4,2,0,3,1.1,5.5,1.1,10.9,0,16,.5.7.8,1.5,0,2h-.5c-.2-5-.3-10-.5-15,0-.7,0-1.3,0-2l.5-6.5c0-.7,0-1.3,0-2h.6c.2,1.4.1,3,0,4.5Z"
          fill="#281e39"
        />
        <path
          d="M406.1,437.2c.9-.8,2.3-1.5,2.8-.2.9,2.6-11.5,11.5-13.8,13.2-3.7,3-7.7,5.6-11.5,8.5-1.2.4-2.1,1.2-3.5,1.5-.8.5-1.3.5-1.5,0-.5-.5-.6-1.7-.3-2.3s10-8.1,10.9-8.4,1-.2,1.7.4c2.5-3.5,5.8-6.4,9.8-8.6,1-1.6,2.2-2.3,3.6-2.2.3-.9.7-2.1,1.8-1.9Z"
          fill="#2b2845"
        />
        <path
          d="M353.2,471.7c2-.8,6-2.1,3.5,1,.3.3.1.6-.5,1-4.5,3-14.2,7-19.5,9s-4.3.9-6,1.5v-1.1c5.5-2.1,10.8-4.6,16.2-7,1-1.5,3.8-3.5,5.7-3.9-.6-.7-.3-1,.5-.5Z"
          fill="#322b48"
        />
        <path
          d="M380.1,460.2c-7.3,5.6-15.7,9.7-24,13.5.2-.1.3-.9.5-1,.3-1.4,1.4-2.5,3.2-3.1,2.7-1.6,6.9-3.9,9.8-3.9,2.8-1.6,5.6-3.3,8.5-5-.6-.7-.4-1,.5-.5.5,0,1.1,0,1.5,0Z"
          fill="#292442"
        />
        <path
          d="M441.1,401.2c.7,1.5-.9,3.3-2.5,3-.9,7.3-6.1,13-11.9,17.4-1.7-.8-2.5.8-1.8,2.3-.3.7-1.5,2-2.3,2.3-2.8,2.1-5.2,4.6-7.2,7.5-2.8,1.6-5.2,3.6-7.3,6-3.5,4.2-8.3,7-12.5,10.5h-.5c2.2-1.7,10.8-8.6,12-10.2s1.8-3.3-1-2.7l-.2-.5c5.4-4.4,10.7-9.1,15.7-14v-1.5s6.1-7.3,6.1-7.3l1.4-.3,1-1,9.7-12.2c.5-.7.9-.8,1.3-.3.4,0,.4.3,0,1Z"
          fill="#252443"
        />
        <path
          d="M438.6,404.2c2.9,1.7,1,4.2-.5,6-1.1,1.6-2.2,3-3.5,4.5-3.7,4.3-8,8-12,12-.2-.2-.2-.3,0-.5,2.8-2.3.5-2.3.5-3.7s.7-.2.8-.5c.5-.8,0-1.5,1.5-1.6s1.3.5,2.2,0,8.1-8.5,8.4-9.7c.9-3.5-.2-2.8,2.6-6.6Z"
          fill="#211f3a"
        />
        <path
          d="M422.6,426.7c-2.5,2.5-4.8,5.4-7.5,7.8l-7,5.2c.7-.8.9-2,1.5-2.7,1.3-1.5,4.6-2.5,5.8-3.9s1.4-3.3,2.2-4.1,3.6-1.7,5-2.8v.5Z"
          fill="#21203a"
        />
        <path
          d="M455.1,384.2c.6,0,.9.6,1,1.5-1.2,1.8-2.3,3.7-3.5,5.5-4.5,6.6-9.2,13-14.5,19,.2-.4,1.1-1.4,1-1.5s-1.2.4-1-.5c3-.5,0-2,.5-4,.8-1.1,1.7-1.9,2.5-3,.1-.4.3-.9.5-1.2,3.2-4.6,6.5-9.3,9.6-13.8s4.2-5.7,3.9-2Z"
          fill="#252035"
        />
        <path
          d="M473.6,354.7c-2.8,6.4-6.6,13.1-10,19s-5,8-7.5,12c-1.6.3-.7-.9-1-1.5-.4-1.1.4-3.1.9-4.3,1.3-3,2.8-6,4.5-8.7-.1-.5,0-.8.5-1l2.5-3.5v-.5l.5-.5c-.2-.2-.2-.3,0-.5-.1-.5,0-.6.5-.5,1.8-2.2,3.3-4.6,4.6-7.2h1c.4-2,1.5-5,3.4-2.7Z"
          fill="#221f36"
        />
        <path
          d="M476.6,347.2c-1,2.4-2,4.7-3,7s0,.4,0,.5c-2.9,0-1.6,2.2-2.7,3.5s-1.5-.3-2.3.7-1.1,3.3-2,4.4-1.4.8-2,1.4c-.2-.4-.3-.8-.2-1,2.8-5.6,6.3-12.5,10.6-16.6.7-1.4,1.4-2.5,2.1-3.4.4-.7.7-.9,1-.5-.5,1.3-1,2.7-1.5,4Z"
          fill="#26233d"
        />
        <path
          d="M484.1,326.7c0,.3,0,.7,0,1l-.5.5c0,.3,0,.7,0,1-2.1,3.4-3.9,7.5-5.3,12.4l-.7.6c-1.6,3.6-2.7,5-5.5,7.7s-.3.2-.5.3c-.1-4.2,2.4-9.6,5.5-12.5l3.8-9.7.7-.3c.8-1.8,1.6-2.1,2.5-1Z"
          fill="#2b284c"
        />
        <path
          d="M488.1,312.3c-.8,3-1.7,6-2.5,9-2.2,3.6-2.8.4-1.5-2.4v-1.1c-.3,0-.6-.1-.6-.2,0-.4,2-7.6,2.4-8.6s.3-.2.7-.2c.2-1.8.7-2.6,1.5-2.5.2,3.1.4,3,.7-.4h.8c.1,2.2-1,4.3-1.5,6.4Z"
          fill="#27234c"
        />
        <path
          d="M484.1,317.8c0,0,.4.3.4.7,0,1.1-.7,2.5-.4,3.8l1.5-1c-.5,1.8-1,3.7-1.5,5.5l-2.5,1c-.7-1,0-2.9.5-4-.5-1.4.5-5.3,2-6Z"
          fill="#2c2953"
        />
        <path
          d="M483.6,329.2c-.5,1.5-1.8,3.6-2,5,.4,0,.3.7,0,1-1.6,2.5-2.5,5.3-3.5,8l-1,.5c-.7-.6-.2-1.1.5-1.5,1.3-3.7,2.7-8.1,4.4-11.8s-.5-1.5,1.6-1.2Z"
          fill="#2a2443"
        />
        <path d="M483.6,328.2c0-.2.3-.4.5-.5,0,.2-.3.4-.5.5Z" fill="#292c37" />
        <path
          d="M492.1,296.3c-.4,2.4-1.3,5.6-2,8v1c0,.3-.5.4-.5.5-.4.9-1,1.9-1,3h-.5c0-.8,0-1.7,0-2.5-.3-.1-.5-.3-.6-.4-.2-.9,2.8-14.5,3.4-15s1-.7,1.7,0c-.3,1.7-.2,4-.5,5.5Z"
          fill="#231e49"
        />
        <path
          d="M352.7,472.2c-1.7,1-3.3,3.5-5,3.5l.5,1-17.5,7.5c-11.7,4.1-21.2,6.7-33.5,9,1.5-3.7,2-1,2.3-1,.7,0,1-.8,1.5-.8,3.3-.3,9.4-1.1,12.5-2.2s2-1.8,2.6-1.9c.9-.2,2.7.5,4.4-.3s.6-1,.8-1.2c1.3-.7,2.5.1,4.4-1.6-1.5-.9,0-2.4,1.5-2-2,1.2-2.5,0-.5-1s2.2-.1.5,1l.6-1c3.6-1.2,7.3-2.2,11-2.9.4-1.2,2-2.2,3.3-2.1,1.8.2-.6,1.1,0-.5.1-.4.3-.4.5,0l.5-.5c.2-.8,1.4-.9,1.5,0l.5-.5c0-.3,0-.5.1-.6.7-.4,6.6-2.8,7-2.9s.5.4.4,1Z"
          fill="#302c4c"
        />
        <path
          d="M160.3,476.2c3.4.5,7,1.8,10,3.5,2.1.4,4.1,1,6,2,7.8,1.8,15.4,4,23,6.5,1.1.2,2.1.5,3,1,.2,1.2.3,2.3.3,3.4-3.5-.5-6.9-1.1-10.3-1.9-1.1-.3-2.9-.2-4-.5-6.2-1.6-12.4-3.9-18.5-6,.3-.7,1-1.1,2.2-.9l-9.1-3.5c-1.3.8-2.6,0-2.6-1.4-2.7-.4-3.9-1.3-3.5-2.7.9-.2,2,0,3.5.5Z"
          fill="#383d66"
        />
        <path
          d="M220.7,492.2v1.1c1.1,0,5.3,1.3,3.8,2.7-7-.7-13.9-1.6-20.8-2.7-4.1,0-7.7-1.6-11.5-2.5l9.7,1.5c-.2-1.7-2.5-2.2.2-3,6.3.6,12.4,1.6,18.5,3Z"
          fill="#343962"
        />
        <path
          d="M223.7,492.2l1.5.5c.2-.6,1-.5,1.5,0,.4.4.9.6,1.5.5.3-.7.7-.7,1,0l6.5.5c6.8-.5,14.2-.2,21,.5,1.7-.2,3,0,4,.5-.1.9,1.2,1.3-.2,1.5-2.2.2-6-1-8.5-1h-7.7l1,1c-2.7,1.9-2.6-.4-3.9-.8-2.3-.6-7.3-1-9.3.2l-7.7.5c-2.3-.2-4.6-.2-7-.5-4.4-.6-9.3-1.2-13.5-2.5,2.5,0,3.9-.9,6.6,0s.4.9.7,1c.8,0,1.9-.6,2.9-.6s.7.9,1.1,1c2.7.7,6.3,1,9.1,1-1.3-1.9-4.6-.5-5-3,.6,0,1.1-.5,1.5-.5.4-.7,2.1-.4,3,0Z"
          fill="#33355b"
        />
        <path
          d="M121.8,461.2c.3-2.5,3.5-1.2,5.3-.4,9.1,4.4,18,8.9,26.7,13.4l.5.5c.1-.4.3-.4.5,0l.5.5c.4-.6,1.5-.2,1.5.5.8,1.4,3.3,1.3,4.2,1.9s-.7,2.1,2,1.2l10.3,3.9-.5,2-3-.5c-.3,0-.7,0-1,0-17.1-5.9-31.6-13.6-47-23Z"
          fill="#394064"
        />
        <path
          d="M481.6,170.8c.5,1.5,1,3.4,1.5,5s.8,1.5,1,2c.9,2.9,1.7,6.5,2.5,9.5s1.2,4.7,2,7c0,.2,0,.3,0,.5.2,1.6.7,3.8,1,5.5-1.1,2.2.1,4.3.5,6.5-.1.4-.3.4-.5,0-1.5-1.1-1.8-3.9-1.5-5.5-.9-5.5-2.1-11-3.5-16.4-.5-.3-.8-1-1-2-1.7-5.1-3.5-10.3-5.4-15.5l.4-1c-1.6-2.9-3-5.8-4.3-8.9-.6-1.5-.3-2.4.8-2.6,2.2,5.3,4.6,10.6,6.5,16Z"
          fill="#748ccc"
        />
        <path
          d="M469.1,146.8c1.6-1.2,3.2,4.2,3,3.9s-.7-1.9,0-1.9l1,1c0,.2,0,.4,0,.5.3,1.1,1.4,3.2,2,4.5-.7,3.9,3.6,7.6,3.5,11.5h-.7c0,0-2.3-3.5-2.3-3.5-.4.2-.6,0-.5-.5l-2.1-4.3c-1.4-.9-1.7-1.8-.9-2.7l-1.3-1.9c-1.1,0-2.1-2.2-1.2-3.1-.8-1.2-1-2.1-.5-2.5-.3-.5-.3-.8,0-1Z"
          fill="#96afe6"
        />
        <path
          d="M461.1,127.4c1.7,3.2,4,6.5,5.5,9.5s1.5,3.2,2,4.5c.4.7,2,4.3,1.9,4.6-.4,1.2-2.1-1.1-2.4-1.6l-.7.2c-.6-2.1-1.6-3.8-2.8-5.2-1.4.4-2.1-1.9-1.5-3-2.3-2.1-3-3.6-2-4.5l-5.9-10.9.4-1.6,5.5,8Z"
          fill="#d8ebf5"
        />
        <path
          d="M433.6,89.9c.2.2.4.3.5.5,1,1.1,2.8,3,3.5,4s.9,1.7,1.5,2.5c1.5,1.3,2.9,3.1,3.5,5,.9.2,1.7,1.1,1.5,2,2.2,2.5,4.2,5.1,6,8,.5.1.4.3,0,.5l.5.5c.9.4,1.8,1.2,2.5,2.5.1,0,.4,0,.5,0,0,1.1,1.2,1.9,1.5,2.5s.3,1,.5,1.5c1.9,4.1,4.4,8.5,5.5,12.5l-1.5-.4c-2.3-4.9-5.1-9.4-8.5-13.6-1.8-1.2-3.9-4-4.5-6-1.1-.8-1.6-1.6-1.5-2.5-2.1-2.1-3.6-4.5-4.5-7,.2-.8,1.6.8,1.5.7-1.1-1.1-9.8-12.1-9.7-12.9s.1-.6.2-.8h.5c.2.2.3.3.5.5Z"
          fill="#eff7f8"
        />
        <path
          d="M469.6,142.8c.9,1.9,1.9,4,2.5,6s.8,2,.3,2.5l-3.3-4.5c-.6-.1-.7-.9-.5-1.5-1,.1-1.2-.3-.5-1l2,1.5c-.5-1.5-.9-3.1-1.5-4.5h.5c0,.6.3,1,.5,1.5Z"
          fill="#c2daf3"
        />
        <path
          d="M409.1,66.9c1.5.6,3,1.6,4.5,3,.8.7,1.7,1.3,2.5,2l.5.5c.2.2.3.3.5.5.3.3.6.7,1,1,1.4,1.4,2.5,2.2,4,3.5s1,1.7,2,2l.5,1.5c-.3.3-.6.5-1,.4l-3.7-3.4-.3,1h-.9c-4.2-4.1-8.6-7.9-13.1-11.5-2.4-1.4-4.7-2.9-7.2-4.3l-.3-1.2c-.4-.1-.4-.3,0-.5-3.1-2.2-5.9-4.5-8.5-7,0-.3.1-.5.3-.6.8-.8,17.9,10.8,19.2,13.1Z"
          fill="#e9f8fa"
        />
        <path
          d="M424.6,80.9c.8.7,1.7,1.3,2.5,2s.3.3.5.5.3.3.5.5.3.3.5.5c.3.3.8.7,1,1s.4.3.5.5c1,1.2,1.7,2.3,2.5,3.5,1.8,2.6,3.4,4.3,5,6.4s3,5.2,4.5,7.4l-1.5-.7c-.6.6-.9.3-.5-.5-.3-.8-.8-1.5-1.5-2-.4-.2-.4-.3,0-.5l-1.5-1.5c-.9.4-1.2-.4-.5-1-1-.8-1.8-1.9-2.5-3l-2-1.3c-3.7-4.5-7.7-8.6-12-12.5l-.4-1.2c-.3-.3-4.6-5-2.3-4s5.8,4.8,7.3,6Z"
          fill="#f3f9fa"
        />
        <path
          d="M411.1,67.4c.5-.1.6,0,.5.5.7.7,1.4,1.4,2,2-1.7-.5-3.1-1.9-4.5-3-.7-.5-1-1-1-1.5.9-.7,2.7,1,3,2Z"
          fill="#c1e4f2"
        />
        <path
          d="M440.1,97.4c.2.1.4.3.5.5.5.6.8,1.3,1.5,2,.2-.1.4,0,.5.5,0,.2,0,.3,0,.5.4.6.4.9,0,1-1.2-1.6-2.3-3.4-3.5-5,.3.2.7.3,1,.5Z"
          fill="#bed9e8"
        />
        <path
          d="M452.1,113.4c.4.6.9,1.2,1,2-.9-.3-1.9-1.7-2.5-2.5l-.5-.5c0-.1,0-.3,0-.5-.7-.6-.9-1.1-.5-1.5h.5c.4,1.2,1.3,2,2,3Z"
          fill="#bbd5e6"
        />
        <path
          d="M444.1,102.4c.7.8,1,2,2,2.5v.5c-.6,0-1.3-.5-2-1.5-.5-.7-1-1.3-1.5-2v-1c.3.6,1.1,1,1.5,1.5Z"
          fill="#a5cce8"
        />
        <path
          d="M446.1,105.4c.3.3.7.6,1,1s1.2,1.5,1.5,2,.7,1.3,1,2,.3,1,.5,1.5c-2.8-1.8-4.2-5.4-6-8,.6.5,1.5,1,2,1.5Z"
          fill="#d8eaef"
        />
        <path
          d="M494.1,281.3c-.4,3.2-1,6.3-1.5,9.5-2.6,1.4-1.9,4.6-2.6,7.2s-1.9,4.8-1.9,8.3c-.5.5-1.3,1.8-1.5,2.5-.7-1-.6-2.4.5-4-.4-.7-.6-1.5-.4-2.3.7-4.7,1.6-10.3,3.9-14.2,0-2.8,2.2-13.4,3.5-7Z"
          fill="#212257"
        />
        <path
          d="M494.6,273.8c-.2,2-.3,4-.5,6s0,1,0,1.5l-1-2c-.5,3.1-1.7,6-2.5,9-1.3-.3-1.3-1.8,0-4.5-1.5-.6-.5-4.4,1-4.5,0-.2.6-.7.9-1.3.6-1.4.7-4.5,2.1-4.2Z"
          fill="#272a65"
        />
        <path
          d="M491.1,244.3c.9,1.2,1.2,2.7,1,4.5.1.6-.1,1.4,0,2-.6-2.1-4,1-5.2,1.5-.4,1.5-.5,3-1.1,4.4s-2.4,1.9-2.6,2.5c-.2.8.4,1.6.3,2.3-.3,1.5-1.6,4.1-2,5.9s1.1,2.4-1.3,2.9l-.6-.6c1-4.6,1.8-9.1,2.5-13.6,1.9-.7,2.2-2.2,2.2-4.2l.4-.6c-1-.9-.8-1.2.5-1,0-.6,0-1.2.5-2-1.5-1.2.8-5.2,2.6-4.2,1-1.4,1.9-1.2,2.9.2Z"
          fill="#465cd0"
        />
        <path
          d="M484.6,251.3c.5.9-.6,4.6-.9,5.2s-1.4.2-1.6.3.6,1.2.5,2.2c-.3,3.1-1.8,7.9-2.5,11.3s-.2,3.6-.5,5c.1,2.2-3.5,13.3-4.7,14.2s-.5.3-.8.3c-.8,0-.8-.5,0-1.5.9-3.3,1.8-6.7,2.5-10,.5-7.1,2.4-14.2,4.5-21-.1-1,2.5-6.6,2.9-6.4s.4.3.6.4Z"
          fill="#475cda"
        />
        <path
          d="M480.1,276.3c.2,1.5-.1,3.1-1,5,.4.1.5.3.4.6-2.8,7.4-5.2,14.5-6.8,22.2-.4,1.4-.9,2.7-2.6,2.6-1.1-.9.7-8.2,1.3-8.6s.5-.3.7-.4l.8-4.8c-.9-1-.3-3,1.2-3.2,1.7-4.7,4.4-9,5.5-14.5l.5,1Z"
          fill="#3e4fd4"
        />
        <path
          d="M484.1,268.8c-1,3.9-3.4,7.6-4,11.5-.2,1.1-.5,1.4-1,1-.3-1.8.6-3.4,1-5,.8-3.3,1.8-6.3,3-9.2s.3-1.5,1.5-1.8c-.3,1.1-.3,2.5-.5,3.5Z"
          fill="#404dc4"
        />
        <path
          d="M481.6,280.8l.5,1.5c-2,12.3-7.6,25-12.9,36.4l-1.1-.5c-.2-.2-.4-.4-.5-.7-.2-.6,2.8-8.5,3.5-9.6s.9-.9,1.5-1.2c-.2-.2-.4-.5-.4-.8-.2-.6,2.6-10.5,3.1-12s3.4-11,4-11.4.5-.2.8-.2c.7-1.6,1.4-1.4,1.5-1.5Z"
          fill="#363dbb"
        />
        <path
          d="M480.1,282.3c-1.5,3.3-2.8,7.8-3.9,11.4-1.4,4.8-1.9,8-3.6,13.1-.8,1.1-1.6,2.1-2.5.5-.4-.1-.4-.3,0-.5,3.1-3.2,2.9-7.8,3.9-11.8s4.2-12.1,5.1-13.7.7-.7,1-1c0,.6,0,1.4,0,2Z"
          fill="#3a44c8"
        />
        <path
          d="M482.6,284.8c.2,3.8-.6,7.6-2.3,11.4l-9.5,22.2c.3.9,0,1.5-.9,1.9-.3,1.7-.9,3.2-1.7,4.5-.9.8-1.4,2-1.7,3.6l-4.1,5.4c-.2,1.9-.9,2.9-2.2,3-1-1.4-.5-3.1,1.5-5,0-2,.9-6.3,3-7,.6-2.9,1.8-5,3.5-6.5,2.3-1.5,2.3-3.9,3.3-6,3.1-7,5.6-14.7,8.1-21.9s.9-5.3,2.6-8.1.3-.3.5-.5c-.2.9.2,2.1,0,3Z"
          fill="#3436b1"
        />
        <path
          d="M491.1,234.3c.2.8.3,1.6.5,2.5.1,1.7.2,3.3.5,5,0,2.3,0,4.8.5,7h-.5c-.2-1.3-.6-3.4-1-4.5-1.4-.6-3.2-1.7-2.5-3.5-.4-.9-.2-2.1.8-3.4,0-1.7.3-2.9,1.2-3.6.1-.4.3-.4.5,0,.3.1.3.3,0,.5Z"
          fill="#546cd4"
        />
        <path
          d="M483.1,284.8h1c-1.2,1-.5,1.6-.5,2l.6.8c-2.7,10.8-6.7,21.1-12,31.1.4,1-.2,2.6-1.3,2.8.1,1.8-.9,5.3-2.8,3.3.3-3.4.5-2.1,1.1-3.6,4.5-11.5,10.9-24.5,13.3-36.4h.5Z"
          fill="#3234a8"
        />
        <path
          d="M485.6,287.3c-.8,7.2-3.3,14.6-6.9,21-1.5,4-3.1,7.9-4.7,11.8s-2.9,6.8-3.2,7-.7-.4-.7-.9l-1.3,2.2c-.7,2.8-1.5,3.4-2.1,1.8-.2-.4,0-.9.5-1.5-1-.7,0-3.7,1-4,2.4-.1,1.5-3.6,2-4.5s1.1.7,1.5-.3c-1.1-2.4.3-2.1.5-2.6,3.2-9.8,10.4-20.3,11.5-30.6l2.5-3.5c-.3,1-.1,2.7-.5,4Z"
          fill="#31309e"
        />
        <path d="M486.1,282.8c.2-.7.5-.9.5-1l-.5,1Z" fill="#31309e" />
        <path
          d="M489.1,279.8c-3.2,18.7-11.1,36-19.9,53.3-.7,2.7-1.9,4.7-3.6,6.1,0,2.7-1.4,5.8-3.1,7.9-1,2.1-1,2.4-.4,4.6-3.7,4.9-5.8-.5-2-4-.3-.3-.6-.7-.4-1,1.2-3.6,3.9-10.5,5.8-13.4,1.9-2,3.4-4.3,4.7-7,.1-.1.7.3,1-.3.4-1,.7-4.1,1.3-5.5s1-.6,1-.7c4.2-9.9,9-21.4,12.1-32.4,1.4-.9.7-2.6,1.1-3.7s2-3.1,2.4-4.3c.4.1.4.3,0,.5Z"
          fill="#2f2d93"
        />
        <path
          d="M493.1,273.3c-1.4,1.8-2.2,4-2.5,6.6-.3.2-.7.2-1,0-.1.4-.3.4-.5,0v-.5c.9-2.6,1.6-5.8,2.5-8.5,2.2-.2,1.9-3,3.5-4-.4,2.3-1.3,4.3-2,6.5Z"
          fill="#303585"
        />
        <path
          d="M493.1,273.3c-.6,1.8-1.9,3.7-1.5,6-.6,1.7-.7,2.7-1,4.5-1.3,6.4-2.8,12.9-4.3,19.5l-.7.5c-1.5,6-3.9,11.5-7.1,16.5,0,1.4-.5,2.3-1.4,2.5l-.5,2.5c-4.3,7.6-7.3,15.4-9,23.5-.9.7-1.7,1-2.5,1-3.4-.4-1-6.3.5-8,.7-.8,1.1-1.6.6-2.6,5.9-11.6,11.5-23.5,16.7-35.7,2.2-7.9,4.4-15.8,6.7-23.6,0-.1.6-.5.8-1,.4-1.6.7-5.3,2.7-5.5Z"
          fill="#2c297c"
        />
        <path
          d="M494.1,233.3c.1,3.2.2,6.9-.5,10l-2-6.5c-.3-.6-.4-1.4,0-2l.7-.5-.2-9.2,1-.7c.4,2.8.9,6.1,1,9Z"
          fill="#788cd4"
        />
        <path
          d="M487.1,202.8c1.2,1.1,1.9,3,2.1,5.5l.9.5c.9,5.1,2.3,10.2,3,15.5v12.5s-1.5-2-1.5-2c-.3-.2-.3-.3,0-.5-.5-1.2-.7-2.9-.5-4.2-.2-2.5-.4-5.1-.7-7.7l.7-.3c-1.5-.6-2-2.9-2-4.2-1.2,0-1.7-1.2-1.5-3.5-.8-1.4-1.7-11-1.2-11.3s.5-.2.7-.2Z"
          fill="#7f95d9"
        />
        <path
          d="M489.6,206.8l.5,1c0,.3,0,.7,0,1l-1.5,1.5c-.6-2.3-.9-5.3-1.5-7.5-1,.3-1.3-.4-.5-1l.5-.9c-.9-3.6-1.6-7.3-2-11.1-1.5,0-1.3-1.2,0-1.5-.7-1.3-.9-2.5-.5-3.5,2.7,6.2,3.7,15.2,5,22Z"
          fill="#8b9fd7"
        />
        <path d="M490.1,207.8c-.5-.1-.4-.6-.5-1h.5c0,.3,0,.7,0,1Z" fill="#7f95d9" />
        <path
          d="M55.8,105.4c.2.6-.7,2-1.5,2-3.1,4.5-6.2,9-9.3,13.5h-.7c-.3.5-.9.8-1,0v-.5c1.1-.9,1.4-2.4,2-3.5s1.2-.6,1-1.5c1.7-.8,2.3-3.5,3-4.5s1-.8,1.5-1.5,1-.9,1.5-1.5c0-.3.2-.5.5-.5,0-.1,0-.4,0-.5l1-1c.5-.6,1.2-.9,1.5-1.4.9-1.2,1.1-3.4,3-4.1-.2,1.6-1,3.3-2.5,5Z"
          fill="#4c70be"
        />
        <path
          d="M68.3,89.4c-1.5,2.9-3.5,5.6-6,8-1.9,2.9-4.1,5.5-6.5,8,.8-1.3,1.6-3.6,2.5-5,1.3-2.2,3.2-3.6,4-6,1.4-1.3,2.7-2.7,4-4s1.3-1.3,2-2c.5,0,.5.3,0,1Z"
          fill="#5980bc"
        />
        <path
          d="M79.3,76.9c-.2,1.3-1.1,2.5-2.5,3.5-2.2,3.2-5.3,6.8-8.5,9v-1c0,0,.4,0,.5,0l.5-.5c1-1.1,2.7-3.5,4-5s3.8-3.9,5.5-6h.5Z"
          fill="#4f86ca"
        />
        <path d="M68.8,88.4l.5-.5c-.2.2-.3.3-.5.5Z" fill="#5980bc" />
        <path
          d="M138.8,33.9v.8c-2.5,1.5-5,2.9-7.5,4.2,0,.2-.1.5-.3.6-.3.4-7,4.1-8,4.6s-.4,0-.7-.3c-1,1.2-1.8,1.5-2.5,1-.5-.2-.3-.6.5-1,.1-.1.9-1,1-1,.2-.2,1.3-.6,2-1,1.3-.8,2.7-1.2,4-2l1-1c.1,0,.4,0,.5,0,1.3-.7,2.7-1.3,4-2l.5-.5c.1,0,.4,0,.5,0l.5-.5c.1,0,.4,0,.5,0l1-1c.1,0,.4,0,.5,0l.5-.5c.1,0,.4,0,.5,0l.5-.5c.1,0,.3,0,.5,0h.5Z"
          fill="#5f93d8"
        />
        <path d="M132.8,36.9c0,0,.2-.4.5-.5l-.5.5Z" fill="#3d50a4" />
        <path d="M133.8,36.4c0,0,.2-.4.5-.5l-.5.5Z" fill="#3d50a4" />
        <path
          d="M104.3,56.4c-1.3,1.6-3.6,3.7-5.5,4,.8-1.8,2.3-3.3,4.5-4.5.3-.3.7-.7,1-1s1.3-.7,1.5-1.5c.4-.2,1-.3,1.5-.5,1.1-1.1,2.1-1.6,3-1.5l.5.5c-2,1.8-4.2,3.3-6.5,4.5Z"
          fill="#4f94de"
        />
        <path
          d="M110.3,51.4c-1.2.7-1.8,1-3,1.5l2.5-2.5c.2,0,.3,0,.5,0,.8.2.7.6,0,1Z"
          fill="#3c67bc"
        />
        <path
          d="M92.3,65.4c-2.1,2.6-5,5.6-8,7-1.4,1.6-2.9,2.9-4.5,4l3-4h.5l1.5-1.5c.7-.6,1.4-1.5,2-2s1-.6,1.5-1c.8-.7,2.3-2.2,3-2.5.2-.4.8-.4,1,0Z"
          fill="#4474be"
        />
        <path
          d="M94.8,62.9c.3.5,0,.8-.5,1-.5.7-1.2,1.5-2,1.5-.3,0-.8,0-1,0v-.5c.1-.3.3-.3.5,0,1-.2,1.5-1.7,2-2s.7,0,1,0Z"
          fill="#3a61bc"
        />
        <path
          d="M98.8,60.4c-.5,1.5-2.4,3.2-4,3.5h-.5c.2-.3.3-.7.5-1,.8-1.2,1.5-1.6,2.5-2.5s1.8-1.2,2.5-2c-.3-.1-.3-.3,0-.5.2,0,.4,0,.5,0,.9-.5,1.1-1.2,1.5-1.5.1-.2.3-.2.5,0,.3-.2.7-.3,1-.5-1.6,1.4-3.3,2.7-4.5,4.5Z"
          fill="#5186d5"
        />
        <path
          d="M83.3,72.4v-.5c0-.3.1-.5.5-.5.3-.2.7-.3,1-.5-.4.4-.7,1.3-1.5,1.5Z"
          fill="#2e3b80"
        />
        <path
          d="M156.8,25.4c.5.3.8.7.4.9l-4.9,2.6c-.2.3-.3.3-.5,0-.4.4-.9.7-1.5,1-3.5,2.3-7.9,4.8-12,6-1.5.8-3,1.6-4.5,2.5-.1.4-.3.4-.5,0l-.5.5c-.1.4-.3.4-.5,0-.4.6-.8.8-1,0,2.3-2,5.1-3.1,7.5-5s1.4-.9,2-1.5c.2,0,.4,0,.5,0l.5-.5c.1,0,.4,0,.5,0l.5-.5h.5c.2-.3.5-.5,1-.5l.5-.5c2.4-1,5-1.9,7.5-3s2.6-1.1,3.5-2c.3,0,.7,0,1,0Z"
          fill="#69a8ec"
        />
        <path
          d="M119.8,44.9c0,.4,0,.7-.2.9-2,1.6-5.1,3.9-7.3,4.1l-1.5,1.5c-.1.4-.3.4-.5,0,0-.3,0-.7,0-1,.2,0,.4,0,.5,0,.3-.5.6-.8,1-1,.5-.3,1-.7,1.5-1s.8-.9,1-1c.5-.3,1-.7,1.5-1s1-.7,1.5-1,1.2-.8,1.5-1,1.1-.2,1.5-.5c-.2.2-.3.7-.5,1Z"
          fill="#417bd3"
        />
        <path d="M110.8,50.4l.5-1h.5c-.2.1-.3.7-1,1Z" fill="#3c67bc" />
        <path
          d="M228.7,7.9c0,.4-1.5.8-2,1-8.1,2.1-16.5,3.6-25.2,4.6-.8.4-1.4.4-1.8,0-.6.3-1.1.3-1.5,0v-.6c2-.2,3.8-.7,5.5-1.4.8-.1,1.6-.4,2-.5.9,0,1.7-.1,2.5-.5.6,0,1.4,0,2,0,2.4-.4,5.2-.7,7.5-1.5.5-.4,1.4-.3,2,0,1.7-.1,4.3-.9,6-1s2,0,3,0Z"
          fill="#58b5f6"
        />
        <path
          d="M179.8,17.4h.5c.2.8-.4,1.4-1.9,1.9l-6.6,2.1c-2.3,1.2-5.5,2.4-8,2.5-1.2.4-2,.4-2.5,0,.9-.7,2-1.1,3-1.5s1.5-.8,2-1c.9-.3,2-.7,3-1h.5c.9-.3,1.8-.8,2.5-1,.3-.4,1-.3,1.5,0,1-.3,2.2-1.2,3-1.5s1.6-.4,2-.5c.3-.4.7-.3,1,0Z"
          fill="#559eed"
        />
        <path
          d="M161.3,23.9c.8,0,1.7,0,2.5,0-3.4,2-7.7,4.1-11.5,5,.9-2,4.3-1.1,4.5-3.5.7-.2,1.6-.9,2-1s.3,0,.5,0c.6-.2,1.4-.4,2-.5Z"
          fill="#6bb6f3"
        />
        <path
          d="M203.7,11.4c-1.3,1.6-3.9.7-5.5,2-3.5,1.7-7,2.3-10.5,2v-.5c.4,0,1.1,0,1.5,0,1.4-.2,3.2-1.2,4.5-1.5s2.7-.7,4-1,1.4.1,2,0,.4-.5.5-.5c.5-.4,1.5-.4,2,0,.4,0,.9-.4,1.5-.5Z"
          fill="#4d9ff0"
        />
        <path
          d="M198.2,13.4c.5,0,1,0,1.5,0-1.4,1-3.2,1.7-5.5,2-.2.3-.5.4-1,.5-4.9,1-9.7,2.4-14.5,4-.1.3-.3.3-.5,0,0,.3-.4.4-1,.5-1.5.6-3,1-4.5,1-.4.5-.7.5-1,0,1.2-1.4,3.3-1.2,4.8-1.9s2.6-1.7,3.7-2.1,1.3-.8,2-1,.7,0,1,0c.7-.2,2.4-1,2.5-1,.6,0,1.4.1,2,0,3.4-.7,7-1.4,10.5-2Z"
          fill="#62aff1"
        />
        <path
          d="M395.6,55.9c1.8.8,3.7,2,5.5,3.5,1.1,1.1,2.8,2,4,3s1.9,2.4,3,2.5c0,.1,0,.4,0,.5.1.5.8,1,1,1.5-3.2-2.4-16.5-12.3-19.5-12.5,2.8,2.7,6.2,3.8,8.5,7-2.5-.4-6.1-1.8-6.5-4.5-1.5-.6-2.5-1.4-3-2.5.1-.4.4-.4,1,0-1.3-.5-4.2-2.3-2-3,.6-.3,1.1-.3,1.6,0l6.4,4.5Z"
          fill="#d3f3f9"
        />
        <path
          d="M393.6,53.4c.1-.3.3-.3.5,0,.4.6.6.6,1,1,.6.6,1.2,1.1,2,1.5s.3,0,.5,0c.3,0,.5.2.5.5.6.8,1,1.6,2,2,.1-.3.3-.3.5,0,.2.3.3.8.5,1-1.9-.5-3.9-2.2-5.5-3.5l-4.6-3.3v-.7c.1,0,2.6,1.5,2.6,1.5Z"
          fill="#8abce3"
        />
        <path
          d="M342.7,26.4c2,.5,3.8,1.3,5.5,2.5.1,0,.3,0,.5,0,1.4,2,4.2,2.1,6.2,3.1,11.6,5.4,22.6,12.5,33.8,18.4h.5c.3.4,1.1.6,1.5,1s.3.3.5.5c1.4,1.2,3.1,2.9,4.5,4-2.8-1.3-5.3-3-8-4.5-.7,1.2-3.6-.3-3.5-1.5-9.3-6.5-20.2-12.3-30.8-17.2-2.7.2-4.9-1.4-6.7-3.3-2.9-1-5.8-2.1-8.5-3.5-.2.4-.3.4-.5,0-3.6-1.1-6.9-2.6-10-4.5,5.2,1.2,10,3.4,15,5Z"
          fill="#a0dcf2"
        />
        <path
          d="M319.2,18.9c2,.4,4.2,1.5,6.5,1.5.6.3,1.4.7,2,1,3.2,1.6,6.7,3.1,10,4.5-.4.4-.9.6-1.4.6s-11.4-3.8-12.6-4.4l-1-1.2c-6-.9-12.1-1.8-18.3-2.6l-1.2-.9c-.3-.9.4-2.2,1.5-2.1,4.9,1,9.7,2.2,14.5,3.6Z"
          fill="#adeff7"
        />
        <path
          d="M342.7,26.4c.3.1,1,0,1.6.1,1,.3,4.3,1.5,3.9,2.4-1.8-.6-4-1.3-5.5-2.5Z"
          fill="#7cc7f0"
        />
        <path
          d="M278.2,9.4l1,1c-2.2,0-4.3,0-6.5-.5l-1.7.5c-21-1.7-42.3-1-62.7,3.2l-4.5.2c-.1.4-.3.4-.5,0l-2.5.5c-.4.4-1.1.4-1.5,0-.2.2-.5.4-1,.5-.2.4-.6.3-1,0-.1.2-.5.4-1,.5-.1.3-.3.3-.5,0-.1.3-.3.3-.5,0-.1.4-.7.4-1,0,2-1,3.6-1.1,5.5-2,7.7-1.3,20.1-2.3,27-4.5,3.5.5,6.9-.8,10.2-1,14-.8,27.4.4,41.2,1.5Z"
          fill="#93defa"
        />
        <path
          d="M279.2,10.4c.7,0,2.1-.1,3.5,0,.4,1.2,1.3.9,2.2,1,8.3.9,17.6,2.7,25.8,4.7,2.8.7,5.9,1.3,8.5,2.8-.7-.1-1.7,0-2.6-.1-4.1-.9-8.1-2.7-12.4-2.9,1,1.5-.2.7-1,1.5-.1.4-.3.4-.5,0-2-1.5-4.2-2.3-6.8-2.4l-1.2-1.1c-7-.5-14.6-1.6-21.5-3.1s-.4-.5-.4-.9c2.2.2,4.3.3,6.5.5Z"
          fill="#a4e8f7"
        />
        <path
          d="M87.3,430.7l.5-.3,2.5,2.3c.8.3,2.1,1.1,2,2l3,2.5c.9-.5,1.3.3.5,1,4.5,3.7,9.2,7.2,14,10.5.2-.4.7-.2,1.5.5.4.1.4.3,0,.5-.5,1-1.1-.2-1-.2,1.9,1.4,4,2.9,5.5,4.7.8-.4,1.6.1,1,1,.8,2.3-4.2,0-5.1-.6-2.6-2.2-5.3-4.2-8.3-5.9-1.8-1.5-3.7-3-5.5-4.5-2-1.3-3.9-2.8-5.5-4.5-4.8-4.1-9-8.1-13.5-12.5-.3-.9,2.9-1.1,3.3-1l5.2,4.5Z"
          fill="#384571"
        />
        <path
          d="M54.3,394.2c4.1,5.2,8.1,10.5,12,16,1,1.9,2.4,3.6,4,5.2-.6,1.1-1.6,1.1-3-.2-6.3-7-10.5-12.5-16-20-.7-2.2-1.5-4.3-2.5-6.4-3-2.5-4.4-6.5-5-10.1.4.2.9.3,1.2.6,1.8,1.1,7.6,10.9,9.1,13.6s.2.8.1,1.3Z"
          fill="#2e345b"
        />
        <path
          d="M115.8,452.7l1.5,1c3.7.5,7.3,2.5,9.5,5.5,1.6,1.2,3.2,2.2,5,3l1.9.4c8.7,4.8,17.6,9.3,26.5,13.6-.2,0-2.3-.2-3.5-.5s-1-.3-1.5-.5l-.5-.5c-.1,0-.4,0-.5,0l-.5-.5c-2.6-1.4-6.1-2.5-8.9-3.9-6-3-12.2-7.2-18.7-8.7s-2.3-1.6-4.4-.4c-1.1-.7-3.3-.9-4-2.5l1-.7c5.1,1.8-.3-.8-2.1-1.7v-1.1s-.8-.9-.9-1c-1.4-.9-1.6-1.4-.5-1.5.1-.4.3-.4.5,0Z"
          fill="#313b6a"
        />
        <path
          d="M103.3,448.7c2.2-.2,3.6,2.5,5.1,3.1s1.1-.1,2.9,1,1.4-.8.5,1.3c2-1.4,3.1,2,5,1,1.9,1.3,4.5,1.6,6,3.7-1.2,1.6-3.5.4-5-.2-4.4-1.8-10.7-6.9-14.5-10Z"
          fill="#364169"
        />
        <path
          d="M71.8,416.2c1.9,1.3,3.7,3.1,5.2,5-1.3,1.6-1.4,2.4.3,4,1,.3,1,.7,0,1-3.7-3.7-6.6-7.2-10-11l2.5.2c-1.4-1.5-3.4-3-3.5-5.2,2.1,1.7,3.9,3.7,5.5,6Z"
          fill="#323d6b"
        />
        <path
          d="M40.3,371.7c.9-.4,1.2.2,1,1.8l1,1.7c1.6.1,2.5,2.2,1.5,3.5.7,1.7,1.6,4.1,2.6,5.7,1.9,3.2,6,6.3,4.9,10.8-1-1.3-2-2.6-3-4-.3-1.5-1.1-2.6-2.5-3.5-1.4-2.4-2.4-4.9-3.2-7.5l.7-1c-2.1-2.2-5.2-6.1-4.5-9,.6-.3,1.1.2,1.5,1.5Z"
          fill="#2c3050"
        />
        <path
          d="M84.3,427.2c1.5,0,2.9,2.1,3,3.5-2.1-1.3-3.8-1.3-5.3-4l-.5,1-2.8-.5c-.3-.3-1-.5-1.5-1,0-.3,0-.7,0-1-2.1-2-2.1-2.7,1-3l.7-.2c1.7,1.8,3.3,3.7,5.3,5.2Z"
          fill="#39477a"
        />
        <path d="M97.8,444.2c-2.1-.9-4.2-2.7-5.5-4.5,1.6,1.4,3.8,3.1,5.5,4.5Z" fill="#323f67" />
        <path d="M48.3,391.2c-.5-.8-1.4-1.6-2-2.5s-.3-.7-.5-1c.2.2,3.4.3,2.5,3.5Z" fill="#282841" />
        <path
          d="M16.9,326.2c.6-.2,1.3-.2,2,0,.5-.1.8.4,1,1.5,1.4,1.7,2.2,3.8,2.5,6h.7s1.3,4,1.3,4l.8.3c1.3,5.3,3.3,10.6,5.7,15.7,2,3.4,4.1,7.2,5,11-.1.4-.3.4-.5,0-1.4.6-2.7-1.6-1.5-2.5l-.5-.5c-.4-.2-.4-.3,0-.5l-.5-.5c-.4-.2-.4-.3,0-.5-.7-.3-1-.9-1-2l-1.4-.7c-1.7-3.4-3.3-6.9-4.7-10.4-.3.4-.9.3-1.4,0,0-.1,0-.4,0-.5l-.5-.5c-.6-1.4-.8-2.9-2-4-1.7-5.2-3.4-10.6-5-16Z"
          fill="#2b2b49"
        />
        <path
          d="M18.9,326.2l-.5,1.5-1.5-1.5c-2.3-7.5-4.4-14.3-6-22,.2-.3.1-.6,0-1,0-.2-.4-.7-.5-1.5,1.1-.8,1.8-.2,2.3,1.7,1.5,7.6,3.6,14.9,6.5,22l-.2.8Z"
          fill="#262248"
        />
        <path
          d="M9.9,291.8l.7.3c3.1,11.9,6.2,23.6,9.6,35.3l-.3.4c-.2-.5-.8-1-1-1.5-3.5-8-3.7-11.5-5.6-19.6s-1.8-4.4-2.9-4.9c0-.3,0-.7,0-1-.4-2-1.2-4.5-1.5-6.5-.6-4.1-1.1-8.3-1.5-12.5h.8c.5,3.4,1.1,6.7,1.7,10Z"
          fill="#282353"
        />
        <path d="M10.9,304.3c0-.3,0-.7,0-1l.5.7-.5.3Z" fill="#282353" />
        <path
          d="M12.9,196.3c.4.1.3.6,0,1,.4.1.4.3,0,.5-.9,6.8-1.9,13.6-2.9,20.3l-.6.2c-.9-1-1-2.5-.5-4.5,0-1,0-2,0-3,.9-.7.4-2.4.5-3.5l.5-.5c.2-1.2.3-2.8.5-4l.5-1c.6-2.8.8-5.8,2-8.5.8.6.4,2.1,0,3Z"
          fill="#5264b4"
        />
        <path
          d="M13.4,196.3c-.1.4-.3.4-.5,0,.1-.9-.1-2.1,0-3,.6-4.2,1.8-8.4,3-12.5-.2-.9-.2-2.1.5-2.5-.4-.6-.1-.8.5-.5.6-1.2,1.1-1.3,1.5-.5l.3,1.3c-1.4,6.1-3.2,11.9-5.3,17.6Z"
          fill="#536bb8"
        />
        <path d="M10.4,202.8c.2-.8.5-.9.5-1l-.5,1Z" fill="#3c3662" />
        <path d="M9.4,207.3v-.5h.5c0,.2-.3.4-.5.5Z" fill="#4c456d" />
        <path
          d="M9.4,276.3c.7.2.9.9.5,1.5l2.5,15.6-.5.4-.8-.6c-.8-2.9-1.4-5.9-1.7-8.9l-.7-.6c-.6-4.9-1.4-9.7-2.3-14.4-.1-2.5-.4-5-.5-7.5h.7c.9,4.7,1.8,9.6,2.8,14.5Z"
          fill="#24286e"
        />
        <path
          d="M9.4,284.3l1.1,7-.6.5c-1.9-2.9-1-6.9-2.5-10-.5-4.2-.8-8.3-1-12.5,1.1,1.5,1.5,4.5,1.9,6.4.5,2.9.6,5.8,1.1,8.6Z"
          fill="#212057"
        />
        <path
          d="M6.9,257.8l.7.5c.7,5.9,1.4,11.7,2.3,17.6l-.5.3c-.5-2.4-1.4-4.9-1.9-7.3s-.2-5.2-1.6-7.2c0-1.2,0-2.3,0-3.5s0-1.3,0-2c1.3-1.4,2.4.7,1,1.5Z"
          fill="#2a2f76"
        />
        <path
          d="M24.4,347.2l2-2.5c1,4.8,3.5,9.1,5.5,13.5,0,1,.3,1.7,1,2,0,.1,0,.4,0,.5l.5.5c0,.1,0,.4,0,.5l.5.5c.4.9,1.5,2.4,1.5,2.5.9,1,.9,3.4-.5,4-1.2-2.2-2.9-4.3-4-6.5-2.4-4.8-4.7-10-6.5-15Z"
          fill="#272540"
        />
        <path
          d="M38.8,370.2c1.4,2.9,3.4,6.3,4.5,9-1.9.5-3.6-.8-5-4-1.5-2-2.3-4.4-3.5-6.5-.5-1.1.6-3.4.5-4h.5c1.5.7,3.1,3.8,3,5.5Z"
          fill="#272b49"
        />
        <path
          d="M38.3,375.2c0,.1,1.7,2.1,2,2.3.8.7,2.2.9,3,1.7.6,1.5,2.2,8.2,2.5,8.5-.8-1-1.5-2.2-2.5-3-.3-1.8-1.6-3-2.5-4.5s-.9-2.1-1.5-3l-.5-.5c-.3-.5-.4-1-.5-1.5Z"
          fill="#25273e"
        />
        <path d="M24.4,346.7c-.2-.1-.4-.3-.5-.5.2.1.4.3.5.5Z" fill="#272540" />
        <path
          d="M9.4,218.3c.8.7.2,2.9-.5,3.5,0,2.1-.3,4-1,5.5-.6-2.2-.6-4.5,0-7,0-2.1,0-4.6,1-6.5.1,1.5.6,2.7.5,4.5Z"
          fill="#4155a3"
        />
        <path
          d="M7.9,227.3c0,3.5,0,8.8-.8,12.3s-.3.5-.7.7c-.1.4-.3.4-.5,0,0-1,0-2,0-3l1-9.5c0-.7,0-1.3,0-2l.5-2c.1-1.1-.5-2.8.5-3.5,0,2.3,0,4.7,0,7Z"
          fill="#364381"
        />
        <path d="M6.9,225.8c0-1.1.5-1.8.5-2l-.5,2Z" fill="#262749" />
        <path
          d="M7.9,250.3c1.3.7,1.1,2.2,0,3,1.4.7,2,3.7.5,4.5.2.4.4.7,0,1-.5.2-1-.2-1.5-1-.1-.1,0-1.4-1-1.5-.1-5.3,0-10.7,0-16h.5l.7.3c.2,3.3.5,6.5.8,9.7Z"
          fill="#373f89"
        />
        <path
          d="M421.6,422.7c-.6.7-1.6,2.4-2.5,3.3-3.2,3.3-10.8,8.1-13,11.2s-.8,2.7-1,2.8c-.9.5-1.8-.4-2.5,0s-.9,1.5-1.5,2c-1,.8-1.9-.6-1,1.8-2-1.1-3.9,1.3-5.3,2.7s-1.5,1.4-1.7,1.6-2.6,5.5-3,3.3-1.1,0-1.8.9l-.5-1.5c-2.3,1-3.3,3.4-5,5s-3.5,2.1-3.7,2.6c-.4.9.9.3-.6,1.9s-.3.4-.5.5c-2.9,1.7-5.7,3.3-8.5,5-4.1,2.5-8.9,4.1-13,7,.9-2-2.1-1.4-3.5-1,0-.3,0-.6.1-.7,1.5-1,4.3-2.5,6-3.3s.3,0,.4,0c7-4.1,14-8.3,21-12.5.5-1.2,1.6-2.2,3.5-3,1.3-2.1,2.8-3.1,4.5-3l13-9.9c3.2-3.4,6.7-6.2,10.5-8.6,2.8-2.6,5.6-5.4,8.2-8.4l1.3.4Z"
          fill="#2c2a4a"
        />
        <path
          d="M359.6,467.2c.3.1.3.3,0,.5-2.6,1.4-3.7,3.2-6.5,4,0,0-.3.4-.5.5-1.6-1.3-2.5.8-3.5,1.2s-2.7.8-4,1.3l-.5.5c-.4.1-1.1-.1-1.5,0l-.5.5c-.2,0-.3,0-.5,0-.6.7-2,1.4-2.5.5-.5-.8,1.6-1.8,2.5-1.5,5.5-2.3,10.9-4.8,16.2-7.5h1.3Z"
          fill="#2d315d"
        />
        <path
          d="M378.1,460.7c-1.7,1.3-4.6,3.3-6.4,4.4s-.9.9-2.1.6c2.9-1.7,5.1-4.6,8.5-5Z"
          fill="#2b2845"
        />
        <path
          d="M433.6,406.7c-1.3,2.4-2.9,4.8-4.5,7-1.9,2.9-5.1,6.3-7.5,9-3.1,1.7-5.1,4.7-7.8,7s-1.4.7-1.7,1c-.2-.2-.2-.3,0-.5v-.8c3.1-3.5,6.1-7.2,8.7-11.1h.8c3.1-3.7,6.1-7.6,8.8-11.5h1.2c.9-1.1,1.5-1.7,2,0Z"
          fill="#465ea0"
        />
        <path
          d="M450.6,384.7c.8,0,.5.5,0,1,.2.1.4.3.6.5.5.7-8.4,12.8-10.1,14-.2.2-.9.5-1.3,1-3.1,3.9-6,8.2-9.7,11.5,2.2-4.2,5.1-8.2,8.5-11.5,1-3.9,4.1-7.8,7.5-10,.9-2.3,2-4.5,3.3-6.5h1.2Z"
          fill="#48568c"
        />
        <path
          d="M430.1,412.7c-.3.5-.5.8-1,1,1.5-2.2,2.8-4.7,4.5-7l-.4-1.1c.1-.7,4.5-5.9,5.4-4.4-2.7,3.6-6.4,7.6-8.5,11.5Z"
          fill="#465c97"
        />
        <path
          d="M460.6,371.2c-1.5,2.9-3,6.6-3.8,9.5s-.8,3-1.7,3.5c-1.1-2.7-4.2,4.4-4.5,4.8-3,4.1-6.4,8.1-9.5,12.2v-1c1.7-2.3,9.2-12.5,9.5-14.5,2.9-4.8,5.7-9.6,8.7-14.4h.8c.2-.4.3-.4.5-.1Z"
          fill="#26243f"
        />
        <path
          d="M477.1,343.7c-.6,2-1,3.6-2.7,5s-1.2,0-1.7.7c-1.8,3-3.9,7.4-5.5,10.6s-1.7,3.1-2.6,4.7c-.2.2-.3.3-.5.5l-.5.5v.5c0,.3-.2.5-.5.5.2.2.2.3,0,.5l-1,1c.1.7-.2,1.4-1,2-.2.3-.3.7-.5,1h-.5l-.3-.9c1.7-3.3,3.5-6.5,5.3-9.6.2-1.1,1.4-3.7,2.5-4,1.4-1.9,2.3-4.1,2.8-6.4h1.2c1-1.7,3.2-3.6,3.9-4.9s0-2.9,2.1-3.2c-.2.5-.3,1-.5,1.5Z"
          fill="#272546"
        />
        <path
          d="M461.1,370.2c.3-.7.6-1.4,1-2l1-1c0-.1,0-.4,0-.5h.5c-.7,1.3-1,2.9-2.5,3.5Z"
          fill="#26233d"
        />
        <path d="M464.1,365.7h-.5c0-.2.4-.3.5-.5v.5Z" fill="#26243f" />
        <path d="M463.6,366.2c0-.1,0-.4,0-.5h.5c-.1.2-.4.3-.5.5Z" fill="#26233d" />
        <path d="M463.6,366.7h-.5c.1-.2.4-.3.5-.5,0,.1,0,.4,0,.5Z" fill="#26243f" />
        <path
          d="M481.1,324.7c.5.8.5,1.8-.1,3.1l-3.9,9.9c-1.9,4.1-3.9,8.2-5.5,12.5-1.5,2.3-1.9,4.8-4,6.5-.1-1,.2-2.3.8-3.7-.3-2,0-3.1,1.2-3.3-.4-.1-.4-.3,0-.5-.3-.2-.4-.5-.6-.8-.3-.6,3.5-11.1,4.2-12.5,2.4-3.7,4.5-7.6,6.3-11.7.9-.7,1.3-.6,1.6.6Z"
          fill="#2b2b63"
        />
        <path
          d="M481.6,327.7c-1.3,4.4-2.7,6.3-4.5,10,.6-4.4,3.4-8.6,4-13,.2-.9.6-1.2,1-1-.2,2.1.2,1.5-.5,4Z"
          fill="#302d5d"
        />
        <path
          d="M486.6,308.8c-.7,1.9-2.4,7.3-2.5,9-.7,1.5-1.9,4.5-2,6-.3.3-.6.8-1,1-.9-1.1-.9-2.5-.2-4.2l4.7-13.7c.2-1.6.7-2.3,1.5-2-.2,1.3-.4,2.7-.5,4Z"
          fill="#2a2660"
        />
        <path
          d="M326.2,481.2c.3.8-.7,1.8-1.4,2-3,.4-6.6,1.5-9.1,3.4-.3,0-.7,0-1,0l-1,.5c-.3,0-.7,0-1,0-.7.7-1.8.7-2.5,0-.3,0-.7,0-1,0-1.2.8-2.8,1.1-4.6.7-.9.6-2.1.9-3.4.8-.3,0-.7,0-1,0l-1,.5c-.2,0-.3,0-.5,0l-1,.5c-.2,0-.3,0-.5,0-1.6.4-3.1.9-4.5,1.5-.2,0-.3,0-.5,0-.7,2.3-3.3-.5,0-1-.4-.1-.4-.3,0-.5,0-.2,0-.4.5-.5,6.5-1.5,13-3,19.5-4.5,0-.1,0-.2.1-.3,4-.9,8-2.1,12.1-3.3s1.2-.3,1.8,0Z"
          fill="#33365d"
        />
        <path
          d="M342.2,475.7l.7,1c-2.6-.6-3,2.1-3.2,2.3-2.5,1.6-9.2,1.3-12.5,3.3,0,0,.5-1,.5-1-.7-.2-1,.2-1.5.7,0,.4.9.3,1,.2-1,.6-1.4,1.9-1.5,2-1,0-2.2-.7-3.2-.5s-.3.9-.9,1.2c-1.2.5-4.5,1.4-5.9,1.8,1.2-3.3,4.7-2.7,7.5-3.8s2.6-1.5,3-1.7c4-2.3,8.9-4.5,13.5-5,.7-.2,1.7-.2,2.5-.5Z"
          fill="#31335a"
        />
        <path
          d="M270.2,493.2c-2.8.3-5.9,1.7-8,1.5s-1,0-1.5,0c-1.3,0-3.2.2-4-.5,0-.3,0-.5,0-.5.2-.1,1-.2,1.3-.2,4-.3,8.2-.4,12.1-.2Z"
          fill="#33365d"
        />
        <path
          d="M325.7,484.2l.2.7c-5,2-10.2,3.8-15.5,5.3-4.6.7-9,1.7-13.2,3-9.6,1.8-18.7,3.2-28.5,4-.2,0-.3,0-.5,0-1.2,0-2.4.1-3.5.5-1.7,0-3.3,0-5,0-5.5.1-11,0-16.5,0s-4,0-6,0l-3.5-.5c-3.2-.1-6.4-.7-9.5-1l.5-1c5.8-.8,11.5-1,17.3-.5,1.2,1.4,1.9,1.6,2.2.5,0-.3.1-.6.2-.6,2.2-.1,5.8-.1,7.5.6l.3-.5c2.6.2,5.1.4,7.6.7l.8-.8c.2-.9,1.1-.8,1.5,0,1.3.7,1.9.7,2,0,2.8-.8,5.3-.8,7.5,0-2.6-.8-1.4-1.3,3.5-1.5,3.4-.5,6.8-.9,10.2-1.5l.2.5h3.1c1.1-.2,2.5-.4,3.4-1,0-.4.3-.4.5,0,1.4-.6,2.9-1.1,4.5-1.5.2-.4.3-.4.5,0l1-.5c.1-.4.3-.4.5,0l1-.5c.2-.6.6-.5,1,0,2.7-.4,5.4-.9,8-1.5.3-1,.7-1,1,0,1,.6,1.5.6,2.5,0,.3-1,.7-1,1,0l1-.5c.1-1.3.6-1.3,1,0,.9-1.2,8.3-3.9,9.1-3.6s.7.5.9,1.1Z"
          fill="#333153"
        />
        <path
          d="M259.7,497.7l1,.5c.4.1.4.3,0,.5-.5,0-1,0-1.5,0-4.3-.2-8.8-.4-13.2-.5s-2.2.3-2.7-.5c5.2-1.5,11.3-1.4,16.5,0Z"
          fill="#1d242b"
        />
        <path d="M237.2,497.7c-1.1,0-2.8.4-3.5-.5,1.1,0,2.8-.4,3.5.5Z" fill="#1d242b" />
        <path d="M268.2,497.2c-.8,0-2.1.4-3.5.5.7-.9,2.4-.4,3.5-.5Z" fill="#26243a" />
        <path
          d="M288.7,490.7c.8.2,1.7.7,1,1.4h-4c-.2.2-.7,0-1,.1l.5,1c-3.7,0-6.4-.5-10,0-1.1.3-2.1.3-3,0v-.4c5.5-.7,11-1.4,16.5-2.1Z"
          fill="#33365d"
        />
        <path
          d="M272.2,493.2c1,0,2,0,3,0-1.2.2-2.9.9-4.5.5-.2,1,1.2,0,1,1h-7.5l2,1c-1.7,0-3.1,1.1-4-1l.3-.6,7.7-.9c.4-.6,1.7-.7,2,0Z"
          fill="#33355b"
        />
        <path
          d="M292.2,490.2l-1,.7c0,.4.7.2,1,.2v2c-2.2-.7-4.2-.8-6.5-1,1.2-.4,2-.8,3.5-.5l-.5-1c.4-.3,1.2-.4,1.5,0l.5-.5c.5-.2,1.1-.3,1.5,0Z"
          fill="#31335a"
        />
        <path
          d="M309.2,487.2c-1.1.2-.7,1.4-.7,1.5-.9.3-3.4-.5-4-.5s-.2,1-.6,1c-.6,0-1.8-.5-2.7-.5,2.5-1.3,5.3-1.2,8-1.5Z"
          fill="#31335a"
        />
        <path d="M297.2,489.7c-.7,1.4-3.1,1.4-4.5,1.5-.3-1.9,3.3-1.2,4.5-1.5Z" fill="#31335a" />
        <path d="M312.7,487.2c-.7,1.5-1.9,1.4-2.5,0,1.3-.2,2,0,2.5,0Z" fill="#31335a" />
        <path d="M314.7,486.7l-1,.5c0,0,.2-.3,1-.5Z" fill="#31335a" />
        <path d="M300.2,488.7l-1,.5c0,0,.1-.5,1-.5Z" fill="#31335a" />
        <path d="M298.7,489.2l-1,.5c0,0,.2-.4,1-.5Z" fill="#31335a" />
        <path d="M300.2,490.2c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#31335a" />
        <path d="M344.7,475.2c0,0,.3-.4.5-.5l-.5.5Z" fill="#31335a" />
        <path d="M342.7,475.7s0-.4.5-.5l-.5.5Z" fill="#31335a" />
        <path
          d="M107.3,444.7c-.9-.7-1.1-1.7.1-2s5.1,3.8,6,5.2l1.9.8c1.3-.7,3.9,1.6,3.5,3,.5-.1.9,0,1,.5.7-.8,1.6-.4,2.4,0l12.2,8.9c2.5.5,4.4,1.5,5.8,3.1,7.4,4.3,15.1,8.4,22.9,11.6l.7,1c1.1-.2,2.2-.2,3.4,0,9.1,3.2,18.1,6.2,27.4,8.5.3,0,.5.4.8.8,6.8.8,13.6,2.1,20.2,3.7,4.1-.5,7.8,0,11.2,1.5.5.2,1,.3,1.5.3,6.1-.2,12-.3,18.2.5,13.4-.4,26.8-1.4,40.2-2.7l1.6.5,1-.5c.5-.9,2.6-1.1,3,0h.5c0,.3-.2.4-.5.5-29.7,6.1-62.6,4.8-92.9-1.5-7.6-2.2-15.4-4.2-23-6.5-1.9-1-3.9-1.6-6-2-3.4-1.1-6.6-2.5-10-3.5-9.9-4-19.2-8.8-28.5-14-1.8-.8-3.4-1.8-5-3-3.2-1.8-6.4-3.6-9.5-5.5l-1.5-1h-.5c-1.2.2-3.8-1.9-4-3v-.5c-.7-.4-4.2-3.5-4.2-3.8s0-.5.2-.7Z"
          fill="#4889e4"
        />
        <path
          d="M292.2,489.7v.5c-.5,0-1.1-.1-1.5,0l-.5.5c-.5,0-1,0-1.5,0l-16.5,2.5c-.7,0-1.3,0-2,0-3.9.3-7.8.3-11.8.5s-1.4.5-1.7.5c-6.9.2-14-.5-21-.5l-6.5-.5c-.3,0-.7,0-1,0-.5.3-1.1-.1-1.5-.5-.5,0-1,0-1.5,0l-1.5-.5c-.9,0-2.2-.1-3,0-6.1-1.2-12.4-1.7-18.5-3s-2.1-.7-3-1c26.2,4.8,52.6,6.6,79.2,3.5,4.1-.5,9.9-1.1,13.7-2Z"
          fill="#353e71"
        />
        <path d="M176.3,481.7c-2-.6-4-1.4-6-2,2,0,4.5.7,6,2Z" fill="#436dc7" />
        <path d="M154.3,474.7c-.2,0-.4-.3-.5-.5.2.1.4.3.5.5Z" fill="#383d66" />
        <path d="M155.3,475.2l-.5-.5c.3.1.4.5.5.5Z" fill="#383d66" />
        <path
          d="M478.6,166.3c1.4,3.1,4.6,13.1,5,16.5.3.4.5.7,0,1-.1.4-.3.4-.5,0-3-3.4-3.9-9.2-4.5-13.5-2-1.1-4.1-5.4-3-7.5,1.3,1.4,1.8.8,3,3.5Z"
          fill="#a6b7e3"
        />
        <path
          d="M484.6,184.8c0,1.2.3,2.4.5,3.5-1.5.6-1.8-.3-1-2.5-.3-.1-.5-.5-.5-1v-1c0-.3,0-.7,0-1,.9.4.7,1.4,1,2Z"
          fill="#93a9e9"
        />
        <path
          d="M475.1,162.3c.2.2.3.3.5.5.7,2.6,2,5,3,7.5,1.9,5.3-1.4,4.2-2,0-.8-1.2-6.2-12.3-5.5-13.3s1-.4,1.3,0l2.7,5.3Z"
          fill="#c4cfef"
        />
        <path
          d="M464.6,139.3c.3,0,.7-.1.9,0s2.3,4.3,2.6,4.9.4.7.5,1c0,.8,0,1.7.5,2.5.2.7.8,1.5.5,2.5-.5.1-.6,0-.5-.5-2.1.6-5.4-4.6-5-6.5l1-.4c-.9-1.4-1.1-2.5-.5-3.6Z"
          fill="#96bdf4"
        />
        <path
          d="M469.6,150.3c1,1.3,1.6,3.5,2.5,5l-.9.5c.1,1.4.3,2.9.4,4.5-1.8.1-4-5.6-4.3-7.4s-.5-4.4,1.8-3.1c.2.2.4.3.5.5Z"
          fill="#aacaf3"
        />
        <path
          d="M472.1,155.3c1.1,1.8,2.2,4.9,3,7-1.2-1.3-1.8-3.6-3-4.8s.2,3.2.4,3.6c1.2,3,2.8,6.1,4.1,9.2-.1.4-.3.4-.5,0-.5-.1-.4-.3,0-.5l-.5-.5c-2-.3-2.2-2.9-2-4.5l-.5-.5c-.3-.1-.3-.3,0-.5-.6-1-1.2-1.9-2-2.8l.5-.7c-.7-1.9-2.1-5.4-1.3-7,.3.7,1.5,1.5,1.8,2Z"
          fill="#bacef1"
        />
        <path d="M469.1,146.8c0,.3,0,.7,0,1-.6-.5-1.4-2.1-.5-2.5.2.5.4,1,.5,1.5Z" fill="#93b8f2" />
        <path
          d="M461.1,131.8c.5,1.8,1.6,2.7,2,4.5-1.5-.1-1.6.6-.4,2.2l-.6,1.3-1.1.2c-.8-.9-5.3-7.6-4.9-8.1s.3-.4.5-.5c-.7-.4-.8-1.3-.3-2.8l-2.4-4.7c-1.8-2-2.8-4-2.9-6,4.2,4,6.5,9.5,10,14Z"
          fill="#9dc1f4"
        />
        <path
          d="M463.1,136.3c1.1,1.3.9,1.8,1.5,3,1,2,2,4.3,2.5,6.5l-3-2.5c-.7-.6-1.4-1.6-2-3-.4-.1-.4-.3,0-.5-.7-1.9-2-3.1-1.5-5.5.6.5,2,1.4,2.5,2Z"
          fill="#93b8f2"
        />
        <path
          d="M451.1,117.9c1.2,1.8,2.8,4,3.7,5.5s2.4,4.7,2.5,5c.3,1.2-.7,2.2-.7,3-1.1,3.4-2.5,1.9-4.2-.7s-.9-1.5-1.3-2.3c-1.4-1.1-2.4-2.7-3-5-1.7.1-3.4-3.3-2-4.5.3-.3.6-.4,1-.3,3.9,5.3,1.5-2.5-1.1-4.4v-1.3c-.4-.6-.4-.9.1-1,.1-.3.3-.3.5,0,1.4,2.1,3.1,3.9,4.5,6Z"
          fill="#94c6fa"
        />
        <path
          d="M419.6,78.9c4.8,5,10,9.6,14.5,15,.7,1.1,1.5,2.2,2.5,3,.1.2.2.6.5,1l1.5,1.5c0,.1,0,.4,0,.5.7.5,1.2,1.2,1.5,2,.1.2.4.3.5.5,1.6,2.2,3,4.7,4.5,7,0,.6-.4.4-1-.5-1.9-1.7-4.2-4.2-5-6.5l-.5-1c-.6-.1-.9-.6-.5-1l-1.5-1.5c-.5.1-.6,0-.5-.5l-.5-.5c-.4-.2-.4-.3,0-.5l-1-1c-.8.2-1.2-.4-.5-1-.9-1-1.9-1.8-3-2.5-.4-.2-.4-.3,0-.5l-1.5-1.5c-.7.2-1.2-.5-.5-1l-4.5-5c-.3,0-.5-.1-.5-.5l-2.5-2.5c-.1.4-.3.4-.5,0l-1.5-1.5c-.8,0-2.1-1.2-2-2l-2-2c-.2.4-.3.4-.5,0-3.3-2.9-6.5-5.9-9.5-9,5.3,2.9,9.4,7.6,14,11.5Z"
          fill="#bfe0f8"
        />
        <path
          d="M445.1,109.4c.6.8,1,1.8,1.5,2.5h-.5c-.7,0-1.7-.8-1.5-1.5-.4-.5-.6-1-.5-1.5l1,.5Z"
          fill="#afd4f6"
        />
        <path d="M450.6,112.9c-.1-.2-.4-.3-.5-.5.2.2.4.3.5.5Z" fill="#d8eaef" />
        <path
          d="M398.1,61.9c3.8,1.5,4.7,3,7.5,5.5,3.2,2.8,6.4,6.2,9.5,9-3.9-2.5-7.8-5.4-11.7-8.7.3.6-.2,1-.8,1.2-1.7,1.1-6.1-2.6-5.5-4.5l-2.9-2.8c-.3-1.9,3.1-.7,3.9.3Z"
          fill="#b3e1f3"
        />
        <path
          d="M391.6,56.9c2.2,1.5,4.1,3.3,6.5,4.5v.5c-4.3-1.7-3.3,0-1,2.5-.3.3-.7.7-1,.5-1.7-1-8.9-6-10-7.3v-1.2c-1.1-.7-4.5-4.2-1.9-4.5l7.4,5Z"
          fill="#bde9f6"
        />
        <path d="M436.6,96.9c-1.2-.6-2-1.8-2.5-3,.9,1,1.7,1.9,2.5,3Z" fill="#eff7f8" />
        <path d="M440.1,101.9c-.5-.7-1-1.3-1.5-2,.9.4,1.5,1,1.5,2Z" fill="#eff7f8" />
        <path d="M438.6,99.4c-.2-.3-1-.8-1.5-1.5l1.5,1.5Z" fill="#eff7f8" />
        <path
          d="M490.6,288.3c-1.3,5.2-2.5,11.2-3.5,16.5l-1.5,2v-.5c-.5-.6-.5-1.4,0-2.5.5-4.4,2.2-10,3.1-14.6s.8-4.1,1.9-5.4c-.2,1.4-.8,3.4,0,4.5Z"
          fill="#242468"
        />
        <path
          d="M483.1,244.3c.4-.8.8-1.7,1.4-2.6-.3-3.7,3.8-4.1,4.1-.9.7.6,2.2,2.7,2.5,3.5-1.6-.8-1.7.3-2.8.8s-.9-.4-1.1-.2-1.5,3-1.6,3.4c-.3.7-.5,1.4-.5,2,0,0-.4.8-.5,1s-.7.2-.9.8,0,2.4,0,2.7-1.7-1.1-2.5,2.5l-.6-.4c.9-4.3,1.8-8.5,2.6-12.6Z"
          fill="#4b66da"
        />
        <path d="M485.6,248.3c0,.4.5.3-.5,2l-1-.2,1.5-1.8Z" fill="#475cda" />
        <path
          d="M481.1,257.3c-1.5,7-3,14-4.5,21-.2.9-.5,1.4-1,1.5-1.8-2.1-.4-5.1,1-7l-.7-1.4c2.2-6.9,3.7-14,4.6-21.4l.7-.7c-.3-2.5.2-4.2,1.5-5,.1-.4.3-.4.5,0-.5,1.3.2,6.1,0,7.1s-2.7,3.5-1.9,5.9Z"
          fill="#4c66e5"
        />
        <path
          d="M474.1,288.3v-.5c-1.1-1.1-.7-5,1-5.5l.5-1.5c-1-.1-1-.6,0-1l1-1.5c-.7,3.1-.2,7.2-2.5,10Z"
          fill="#4a61e6"
        />
        <path
          d="M468.6,268.3c1.2-3.1,3.2.5,2.7,2.7,1.4,2.2,2,4.6,1.8,7.4.9.4,1.2.8,1.4,1.8s-1,7-1.3,8.1,0-.3.2-.3.4-.2.7-.2c0,.2,0,.3,0,.5,0,.5,0,1,0,1.5-.9,2.5-1,5.5-2,8-.7-.6-.9-1.8-.4-3.5l-.6-.5c-1.3,1.6-1.4-3.6-1.3-4.8l.9-.4c-2-1.9-2.4-3.4-1.2-4.5-1.3-1.1-1.7-7.5-.9-8.1s0,2.1-1,.7c-1.4-1.8-.5-6.9,1-8.5Z"
          fill="#4b69ed"
        />
        <path
          d="M472.1,297.8c-.4,2.7-1.3,6.2-2,9s0,.3,0,.5l.6,1.6c-.7,2.6-2.4,6.7-4.1,8.4-.3.7-.6,1.1-1,1-.5-.9-.2-2.2.5-3-.4-.2-.4-.3,0-.5,1.4-7.2,2.9-14,4.3-20.6l.7-.3,1.5-1c-.5,1.6-.3,3.4-.5,5Z"
          fill="#516cee"
        />
        <path
          d="M472.6,306.8c-1.3,3.9-3.6,7.6-4.5,11.5s-.5,1.4-1.9,2.6-.7,3.2-1.6,3.9l-.7-1.2c.5-2.3,1.4-4.4,2.7-6.3,1-3.3,2.6-6.6,3.5-10l2.5-.5Z"
          fill="#3c40c0"
        />
        <path
          d="M461.1,329.7l.5.6c-.7,1.5-.7,2,0,1.4-.6,1.6-1.3,3.3-1.5,5,.4.2.7.5.5.8-2.6,4.7-5.1,9.5-7.3,14.5l-.7.2c-.1.4-.3.4-.5,0-.7.4-1,.9-1,1.5,1.7.6.2,4.5-1.5,3-.3-.3-.3-1,0-2-.3-1.3.3-2.7,1.5-4.4.3-1.9,1-3.5,2.1-4.6-.5-1.1-.2-1.4.9-2,0-.8.2-1.7,1-1.5.4-1.7,1.1-3,2-4,1-3.2,2.3-6,4-8.5Z"
          fill="#4c62da"
        />
        <path
          d="M468.1,324.7c-.1,1.2-.6,2.8-1,4-2.4,2.5-3.8,5.1-4.2,7.9-3.2,5.2-5.9,10.6-8.1,16.5-1.2,1-1.5,1-2.1-.4-.3-.1-.3-.3,0-.5.1-1.7,6.2-13.2,7.5-15.5s3.9-5.6,5.4-8.4.9-3.8,1.8-4,.6.4.8.4Z"
          fill="#3133a8"
        />
        <path
          d="M464.6,324.7c-.8,2.2-2.1,4.7-3,7l-.5,1h-.5c-.2-1.1.3-2,.5-3-.4-.2-.4-.3,0-.5l.5-1.5c-1.2-1.1-.3-4.8,1.5-5l1.3-4.3.7-.2c.1-.4.3-.4.5,0l1-1c-.7,2.3-1.2,5.3-2,7.5Z"
          fill="#4f65e4"
        />
        <path
          d="M490.6,233.8c.2,3.3,0,4.4-2,7-.2-.2-1.9-1-2.3-1.5-.4,0-1.7,3.3-2,4s-1.2,1-1.2,1h-.5c-.7-.8-.6-1.8.4-3.1-.6-1.4-.5-2.5.1-3.4-.2-1.1.5-1.9,2.1-2.7,1.3-2.7,3.7-4.7,5.4-1.3Z"
          fill="#506edc"
        />
        <path
          d="M487.1,217.8c.6-.9,1.3-.7,1.5.2s-.8.2.5-.2c1.1,1.2,2,2.2,2,4.2v8c0,.7.4,3,.5,4.2-.1.4-.3.4-.5,0,0-.2,0-.3,0-.5-.2-1.3-.6-2.3-1.3-3,0-2.7,0-5.4-.7-8-1.8,0-3.2-3.5-2-5Z"
          fill="#718bde"
        />
        <path
          d="M489.1,222.8c.1.1.9-.3,1,.3.6,2.9.5,7.5,1,10.7h-.5c-1.4-1.2-2.3-2.4-2.9-3.7l1.4-.8c-1.4-.2-2-3-.5-3.5-2-1.4-2.3-2.4-1-3,.3-.5.8-.5,1.5,0Z"
          fill="#617fe1"
        />
        <path
          d="M491.6,234.8c0,.7,0,1.3,0,2-.9-.7-.4-1.7-.5-2.5h.5c0,.2,0,.3,0,.5Z"
          fill="#617fe1"
        />
        <path
          d="M466.6,330.2c.4.1.4.3,0,.5h-.5c.7.9.1,2.3-1.7,4.2-2.1,6.5-5.1,12.8-8.3,18.9l-.4,2.4c1.2.7-.9,4.4-2,4.5-.5,1-.7,1.2-.8.5.3,2.7-2.1,6.3-4.7,6-1.3,0-2-1.9-.5-2.5-.5-.1-.8-.5-.6-.8,1.5-2.5,3-5,4.6-7.4.3-1.4.7-2.6,1-3.8,1.5.2,1.2,0,1.7-1,2-3.7,3.4-7.7,5.2-11.3s3.1-3.8,3.1-4c.1-.7-.4-1.4-.2-2.2.3-1,3.6-4.6,4.7-5.5-.2.5-.4,1-.5,1.5Z"
          fill="#2d31a2"
        />
        <path
          d="M470.1,326.2c-.5,1.7-1.3,4.5-2.3,5.9s-2.1,1.5-2.8,2.7-1.4,4.6-1.8,5.8c-1.1,3-1.6,4.3-3.1,7.1-1.5,2.5-2.6,5.3-3.3,8.2l-1.2.3c-1.3-2.3,1.4-4.5,1.9-5.9,1.1-3.3,2.9-8.3,4.4-11.1s.8,0,1.9-4.1,1.8-3.4,2.4-4.4h.5c0-.1,0-.3,0-.5,1.4.4.9-1.2,1.6-2.2s1.2-1.2,1.9-1.8Z"
          fill="#2c2e9b"
        />
        <path
          d="M489.6,279.8c-2.9,11.4-4,20.2-9.2,31-3.5,7.2-5.9,14-10,21.5s-2,5.6-2.6,6.4-1.1.4-1.2.6.9,1.5-1,2.4c0-.8,0-1.6,0-2.5,1.4-3.9,3.7-7.8,5.6-11.6,2.7-5.5,5.4-11.7,7.5-17s.3-1.6.3-2.4l1,.5c-.7-2.4,1.2-2.9,1.9-4.4,2-4.4,3.3-12.2,4.8-17.2s2.5-4.5,2.4-7.4h.5Z"
          fill="#2e2b88"
        />
        <path
          d="M460.1,347.7c-.6,1.2-2.2,3.3-1.4,4.4s3,.7,3.4-.4c.1-.4.3-.4.5,0l.4.5-2.9,3.5c.1.8-.4,1.8-1.5,3v1.3c-2.2,3.4-4.3,7-6.1,10.8l-1.4.4-.5.5c.4,1.3-.2,2.2-1.5,2.5l-.5.5c.4.1.4.3,0,.5-2.1,3-2.5,1.6-1.4-4.2,1.9-2.6,3.7-5.2,5.4-7.8,0-1.4.3-2.2,1-2.5.7-3.2,1-2.5,2-4.5s2.2-6.5,4.5-8.5Z"
          fill="#2d3196"
        />
        <path
          d="M465.6,341.7c-.6,2.7-2,5.5-.5,8,.4.8-1.7,2.6-2.5,2h-.5c-2.6-1.2-1.4-4.1,0-5.8,2.5-3,2.1-2.8,3.5-6.7.9.4.2,1.7,0,2.5Z"
          fill="#2b2c88"
        />
        <path
          d="M477.1,324.7l.9,1c-.9,3.8-2.7,7.4-4.9,10.5-1,3.9-2.4,7.8-4,11.5.4,0,.6.6.6,1.5,0,.2,0,.3,0,.5-.1.4-.3.4-.5,0l-1.5-1c-1.4-3.8,1.2-8.9,2.9-12.4s2.9-6.6,4.4-9.6,2.3-2.1,2.3-4c1.2,0,.9,1.5,0,2Z"
          fill="#2c2a74"
        />
        <path
          d="M485.6,306.3c-1.8,6.4-4,12.8-6.7,18.9-.8.8-1.3.7-1.8-.4,0-1,0-1.6,0-2,.2-4.8,1-2.5,2.4-4.8s2.7-6.2,3.7-8.3,1.3-4.1,2.4-5.8c0,.8,0,1.7,0,2.5Z"
          fill="#2c2873"
        />
        <path
          d="M467.6,348.7c.8,0,1.3.2,1.5,1-1.2.5-2.6,1-4,1.5,0,2.3-2.9,4.3-5,4.5.5-.9,1.9-3.3,2.5-4s1.9-1.6,2.5-2c.9-.6,1.3-1.1,2.5-1Z"
          fill="#353f84"
        />
        <path
          d="M486.6,201.8c.1.3.4.7.5,1-1.2,3.4.7,7.8,1.4,11.3s-.4,2.6.5,3.7c.3,1.9-.8.4-2,0-1.3-2.7-2.3-5.5-3-8.3l1-.7c.5-1.8.3-3.7-.5-5.7-.4-1.5-.2-3.4,1.5-3.3,1.1,0,1.4,1.4.5,2Z"
          fill="#7e9ae7"
        />
        <path
          d="M481.1,182.8l.5,1c.4.1.4.3,0,.5,1.1,2,2,4,2.7,6l.8-.6c.7,3.2,2,6.3,2.4,9.8s.6,2.5-.9,2.2c-.2-.6-.2-1.2-.5-2-1.1.7-1.5.2-1-1-1.7-.3-2.5-2.1-1.5-3.5-1.9-1-3-5.3-2-7-.6-1.8-1.2-3.6-1.5-5.4l.5-.6c.7-.7,1-.4.5.5Z"
          fill="#93a9e9"
        />
        <path
          d="M481.6,184.3c1.3-1.6,1.8,3,1.7,2.8-.2-.4-.1-1.1.3-1.3.1-.4.3-.4.5,0,.3.8.2,1.9,1,2.5,0,.5,0,1.1,0,1.5l.5,5c-.1.2-.6-.3-.7-.5-1-1.5-2.7-7.9-3.2-10Z"
          fill="#adb9e5"
        />
        <path
          d="M44.3,121.4c.5.2.6,1.1.6,1.6,0,1.2-3.5,7-5.1,6.4-.2,1.7-5.3,11.7-6.1,12.2s-.5.2-.9.3v1.6c-2.7,6.4-5.3,13-7.5,19.4.7,2.2-.5,5.8-2.5,7-.3.6-.6,1-1,1v-.5l-.7-1.6c2.1-8.1,5.3-15.9,8.7-23.4.3-.9.6-1.6,1-2.5s.3-1.1.5-1.5c.9-2,2.8-5.5,4-7.5s1.4-2,2-3,1-2.3,1.5-3,1-1.5,1.5-2c1.1-1.7,2.3-3.2,3.5-4.7l.5.2Z"
          fill="#6786d1"
        />
        <path
          d="M21.9,170.3l-2,6.3c-.4.9-.7,1.4-1.5.7l-.5-.5c.7-2,1.2-4,1.5-6-.4,0-.4-.3,0-.5l.5-1c-.2-.2-.4-.3-.4-.5.1-1.6,2.4-7,3.2-8.8s.4-.5.7-.6l.5-.5c-.8,0-.7-.7,0-1,.9-2.2,2-4.4,3-6.5s1.5-4.3,3-6c-2.7,7.4-6.8,17.4-8,25Z"
          fill="#4f6ebf"
        />
        <path
          d="M23.9,157.8c0,.2,0,.8,0,1l-.5.5c-1.1,2.9-2.9,7.1-3.5,10l-.5,1c0,.2,0,.3,0,.5,0,.7,0,1-.5,1-.5.5-.7.2-.5-1,0-.2,0-.3,0-.5.5-.2.4-.6.5-1,.9-3.3,2.7-6.5,3.5-9.5.5-.2.4-.6.5-1s0-.4,0-.5l.5-.5c0-.2,0-.4,0-.5l.5.5Z"
          fill="#242e5c"
        />
        <path d="M52.3,107.9v-.5h.5c-.2.2-.4.3-.5.5Z" fill="#483b66" />
        <path
          d="M44.3,120.9c.4.1.4.3,0,.5-1.2.3-1,2-1.5,2.7s-1.7.9-2.5,1.8c0-.3,0-.8,0-1,.4-.8.9-1,1.5-2.5.7-.3,1-1.2,1.5-1.5s.7,0,1,0Z"
          fill="#5472bc"
        />
        <path d="M52.8,106.9c.4-.5.8-.8,1-1l-1,1Z" fill="#483b66" />
        <path
          d="M54.3,107.9v.5l-1.5,1.5c.4.1.4.3,0,.5l-.5.5c.4.1.4.3,0,.5l-1,1c.7,1-.4,2.5-1.5,2.5.2.8-.1,1.6-1,1.5,0,.7,0,1,.5,1-.2-.8.1-1.7,1-1.5-.2-.9.6-2.1,1.5-1.5,2.4-2.5,3.5-2.5,3.3-.2-2.5,3.3-5.3,6.3-8.3,9.2l-3.5,6,.3.7-4.3,6.3c-.1.4-.3.4-.5,0-.2-.5-.2-1.2,0-2-.7-.7-.4-1.7.7-3.3l.3-1.7c2.3-3.3,3.7-4.2,4.5-8s0-.4,0-.5c.6-1.5,8.4-11.8,10-13.5.4.1.4.3,0,.5Z"
          fill="#668cdf"
        />
        <path
          d="M62.8,97.4c-.8,3.2-3.9,6.5-6.5,8.5l-.5.5c.7.5.4,1.1-.5,1l-1,.5v-.5c.8-.9.9-1,1.5-2,1.9-2,3.3-4.5,5-6.7s1.3-.9,1.5-1.2h.5Z"
          fill="#b7cee8"
        />
        <path
          d="M78.3,79.9c-.2,1-.5,2-1.2,2.8-3.8,4.4-7.7,8.8-11.7,13s-1.6,1.2-2.6,1.6h-.5c2-2.6,3.8-5.5,6-8s5.6-6.2,8.5-9c.6-.7,1.3-1.2,2-1.5.2.2,0,.5-.5,1Z"
          fill="#a0ccea"
        />
        <path
          d="M79.8,77.4c.3.7-.3,1.3-1,1.5-.6.5-1.5,1-2,1.5,1.1-.8,1.9-2.9,2.5-3.5s.3-.3.5-.5c1.2-1.3,3.2-2.8,4.5-4-.8,1.9-2.3,3.6-4.5,5Z"
          fill="#6397d1"
        />
        <path
          d="M122.3,43.9c1.1.4-.2,1.2-1,1.5-.8,1-2.2,2-3.5,2.5-2.9,2.4-6.2,4.5-9.5,6.5-.4.5-.9.9-1.5,1-.1.5-.6.7-1,.5-.4.5-.9,1-1.5.5,1-1.4,5.6-3.5,6-5,.1,0,.4,0,.5,0l1.5-1.5c2.5-1.5,5.1-3.6,7.5-5s1.9-.6,2.5-1Z"
          fill="#68b5f0"
        />
        <path
          d="M132.3,38.9c.5.1.3.5-.5,1h-.5l-.5.5h-.5c0,.3-.2.5-.5.5h-.5c-.6.6-1.2,1.1-2,1.5-.1.3-.3.3-.5,0l-1,1h-.5c-.9.8-1.9,1.4-3,2h-.5c-.1.3-.3.3-.5,0l1-1.5c3.2-1.8,5.2-3.7,9-5s.7,0,1,0Z"
          fill="#80caf6"
        />
        <path
          d="M105.3,56.9h-.5c-1.6,1.7-3.5,3.2-5.5,4.5-.4,2-2,3.3-4,3.5-1.4,1-2.7,2-4,3-.1.4-.3.4-.5,0,.8-1.6,2.1-2.9,4-4,1.3-1.2,2.6-2.4,4-3.5s3.7-2.7,5.5-4,1-.2,1.5-.5c.2.2,0,.6-.5,1Z"
          fill="#9ccdf0"
        />
        <path
          d="M94.8,63.9c-1.3,1.1-2.8,2.9-4,4,0,.6-.5.8-1,1-2.8,3.4-6.2,6.3-9.6,8.9l-.4-.4c1.4-1.8,3.1-3.2,4.5-5,2.5-2.3,5.3-4.8,8-7s1.3-1,2-1.5h.5Z"
          fill="#6ba7e2"
        />
        <path
          d="M171.8,21.4c.3,0,.7,0,1,0,.4.1.4.3,0,.5l-.7,1.2c-5.9,1.8-11.8,3.9-17.4,6.7l-1.4-.4c-.7.3-1.2.3-1.5,0-.4-.1-.4-.3,0-.5.1,0,.4,0,.5,0,3.8-1.4,7.9-3.6,11.5-5s5.5-1.9,8-2.5Z"
          fill="#78c7f2"
        />
        <path
          d="M153.3,29.4c.4,1.4-1.4,2.3-2.5,1.5-.1.4-.3.4-.5,0l-.5.5c0,.9-.8.9-1,0l-.5.5c-.2.4-.3.4-.5,0l-.5.5c-.2.4-.3.4-.5,0l-.5.5c-.1.4-.3.4-.5,0l-.5.5c-.1.4-.3.4-.5,0l-.5.5c-.1.4-.3.4-.5,0l-.5.5c-.2.4-.3.4-.5,0l-.5.5c-.2.4-.3.4-.5,0l-.5.5c-.2.4-.3.4-.5,0l-.5.5c-.2.4-.3.4-.5,0l-.5.5c-.2.4-.3.4-.5,0l-.5.5c-.2.4-.3.4-.5,0-.6-.1-.4-.4.5-1,4.1-1.8,7.9-4.4,12-6,.5-.5,1-.6,1.5-.5.4,0,1,0,1.5,0Z"
          fill="#c1e9f7"
        />
        <path
          d="M138.3,35.9c-.2.3-.3.8-.5,1h-.5c-.8.4-1.6.9-2.5,1.5-.1.4-.3.4-.5,0h-.5c.9-1.5,3-1.8,4.5-2.5Z"
          fill="#80caf6"
        />
        <path d="M151.8,29.4c-.2,0-1.3.4-1.5.5.4-.5.9-.8,1.5-1v.5Z" fill="#6bb6f3" />
        <path
          d="M134.3,38.4c.9,1.3-1.5,2.5-2.5,1.5.2-.2.3-.7.5-1,.2,0,.3,0,.5,0l.5-.5c.2,0,.3,0,.5,0s.3,0,.5,0Z"
          fill="#c1e9f7"
        />
        <path d="M132.8,38.9l.5-.5c-.1,0-.3.4-.5.5Z" fill="#80caf6" />
        <path d="M110.8,51.4c.2-.1.7-1,1.5-1.5l-1.5,1.5Z" fill="#4f94de" />
        <path
          d="M177.3,20.4h.5c0,.2,0,.4,0,.6-.2.5-5.2,2.2-5,.9v-.5c1.6-.4,2.7-1,4.5-1Z"
          fill="#c3f0f7"
        />
        <path
          d="M194.3,15.4h1c.3.1.3.3,0,.5-.2.9-.5.9-1,0-.3,0-.7,0-1,0,.2-.4.7-.4,1-.5Z"
          fill="#a8ebf8"
        />
        <path
          d="M384.1,49.9c.7.4,2.5.9,3.5,1.5-.4,1.3,1,2,2,3-.3,0-.7,0-1,0-1.8-1.1-3.5-1.8-5.2-2.1-4.4-2.1-9.6-5.1-13.9-7.6s-2.2-1.5-1.8-2.8c-3.6-.5-6.8-1.9-9.7-4-1.8.1-9.2-4.7-6-5.6s28.4,14.8,32.2,17.7Z"
          fill="#d2f8fc"
        />
        <path
          d="M322.7,20.9c5.2.8,9.9,3.8,15,5,.1,0,.4,0,.5,0,2.7,1.4,5.6,2.5,8.5,3.5,12.5,5.5,24.8,11.6,36.3,19,.6.4,1.5.4,1.2,1.5-9.5-5.2-18.5-11.3-28.3-15.9-.7-.3-3.2-1.4-3.7-1.1,1.4,3.3,3.4,2.7,5.8,3.9s3.8,2.6,5.5,3.5,3.1.4,4.1,1.6c-.2,1.2-1.2.9-2.1.4l-.4.6c-.8.2-1.7.2-2.5,0-12.3-6.6-24.8-12.6-38-16.4l-.5-1.1c-.6-.1-1.1-.3-1.5-.5l-.5-.5c-1.2.9-2.4.5-2.5-1h-3.4c-8-1.9-16-3.9-23.9-6l-1.2-1,1-.3c10.2,1.9,20.3,3.5,30.4,4.8Z"
          fill="#c8f4f9"
        />
        <path d="M346.7,29.4c-2.9-.8-6-1.9-8.5-3.5,2.8,1.2,5.7,2.3,8.5,3.5Z" fill="#adeff7" />
        <path
          d="M278.7,13.9l1.5.5c.2-.7,1-.6,1.5,0,.8.3,1.6.5,2.5.5.1-.7,1.1-.6,1.5,0l1,.5c.6-1,3-.4,4,0,4-.9,8.5-.2,12,2,.2,0,.3,0,.5,0,3.5.6,6.9,1,10.2,1.5s6.3.7,9.3,2c-3.4-.5-7.8-.2-11.1-.6-6.9-.9-13.2-2.9-20.4-3.9-.7,1.3-1.8,1.4-2.5,0-3-.3-6-.7-8.9-1.3-2.3.6-4,.2-5.1-1.2h.5c.7-.8,2.6-.5,3.5,0Z"
          fill="#c3f3f6"
        />
        <path
          d="M272.7,9.9l22,4c-.2,1-1,1.2-2.5.5-9.4-1-18.8-2.1-28.3-3.3-12.8-1.1-25,.2-37.6,1.6-4.8.6-9.8,1-14.6,1.2-.9,1.2-3.8,1.9-4.5.5-1.4.3-2.4.1-3-.5,0,.5-.2.4-.5,0,6.8-1.4,13.9-3.2,20.8-3.9,16.5-1.8,31.7-1.3,48.2,0Z"
          fill="#a7edfb"
        />
        <path
          d="M204.2,13.9c.5,0,1.1.5,1,.6-.8.7-3.2,2.3-3.5.9-.6.3-1.3-.5-1.5-.5.1-.2.5-.4,1-.5.5-.4,1.2-.5,2-.5.2,0,.3,0,.5,0s.3,0,.5,0Z"
          fill="#c3f0f7"
        />
        <path d="M203.2,13.9c-.3,0-1.5.4-2,.5h-.5c.4-.8,1.7-.5,2.5-.5Z" fill="#a8ebf8" />
        <path d="M199.2,14.4v.5c-.3.3-.7.3-1,0,0-.6.6-.4,1-.5Z" fill="#a8ebf8" />
        <path
          d="M294.7,13.9c2.9.3,5.7.6,8.5,1.5l-2,.5,1.5,1.5c-4-.6-7.9-1.5-12-2-.4-.1-.4-.3,0-.5,2.2-.2,2.7-.4,1.5-.5.1,0,1.2-.6,2.5-.5Z"
          fill="#adeff7"
        />
        <path
          d="M63.3,391.2c1.5-.4,3.3,1.6,2.5,3,1.9,1.7,3.6,3.6,4.8,5.8l-.3,1.2c-.3-.1.4,2.6.7,3.1.6,1,2.7,3.4,3.9,3.5.8,2.9,2.5,5.6,5,8.2,1.5,2.3,2.9,4.6,3.8,7.4,1.7.7,2.2,1.7,1.6,2.8,2.2,1.6,3.9,3.8,5,6.5-1.4-.1-1.9-1.3-3-2-.9-1.2-2-2.4-3-3.5-7.3-6.7-13.5-15-18.6-23.4-.5-3.3-1.8-6.3-3.8-8.8l.4-1.3c-1.6-1.9-1.2-5.1,1-2.5Z"
          fill="#4f7cd1"
        />
        <path
          d="M89.3,427.7h1.2c1.6,2.7,3.8,5.3,6.6,6.8-.4,1.3.2,2.2,1.7,2.7,1.6-1.1,5.6,2,5.2,4.1l3.4,2.3v1.2c1.8,1.4,2.4,2.6,3.9,4.5-.5,0-1-.3-1.5-.5-3-1.9-6.1-4-8.5-6.5v-.5c-2.7-1.9-5.1-4.1-7.2-6.7-2.8-1.2-4.5-3-5.8-5.8s.2-.3.5-.5c-.4-1.1-.2-1.4.5-1Z"
          fill="#4884de"
        />
        <path
          d="M85.3,426.2c1-1.8,3.7.9,3.5,2.5,1,1.8,1.1,3.2,3,4.7s1.5.2,1.9.6c2.5,2.1,5,5.5,7.5,7.7-1.9-.4-3.7-1.6-5.5-3.5-.2-.2-.3-.7-.5-1l-3-2.5c-.8-.7-1.2-1.1-2-2-1.8-2-3.6-4.4-5-6.5Z"
          fill="#497fda"
        />
        <path
          d="M101.3,441.7l8.5,7c-2-.8-3.8-2.1-5.6-3.2s-2.2-2.7-3.9-1.8c-.3-.9,1.2-.2,1-.7-.3-.9-1.7-1-2.3-1.4-1.1-.9-2.3-2.2-3.2-3.3l5.5,3.5Z"
          fill="#33447e"
        />
        <path
          d="M111.3,449.7c1.4.6,3.1,1.7,4,3s-.4.4.5,1.5c-.8-.4-1.7-.7-2.5-1.3s-3.9-3.2-3.5-3.7c.5.3,1,.3,1.5.5Z"
          fill="#364169"
        />
        <path d="M95.3,437.2c-1.4-.6-2.1-1.6-3-2.5,1.5.1,2.2,1.5,3,2.5Z" fill="#4775ca" />
        <path
          d="M42.3,372.2h1.2s2.3,4.5,2.3,4.5c.7-.1,1.3.1,1.7.7,2.6,5.7,5.5,10.9,9.1,16,.7,1.3.8,2.4.2,3.3-1,.4-2.1-1.5-2.5-2.5-3.7-5-6.8-10.5-10.5-15.5-.5-1.1-1.1-2.4-1.5-3.5-1-1.1-2.1-4.4,0-3Z"
          fill="#4862a5"
        />
        <path
          d="M56.8,396.7c1.4,1.2,2.5,2.9,3.5,4.5l1.2.4c3.6,4.6,7,9.3,10.3,14.1v.5c-1.8-2-3.7-3.9-5.5-6-3.5-4-6.4-7.8-9.5-12.1s-2.5-1.8-2.5-3.9c.5.7,2,1.9,2.5,2.5Z"
          fill="#313c6f"
        />
        <path d="M131.8,462.2c-1.9-.4-3.5-1.8-5-3,1.6.9,3.5,2.1,5,3Z" fill="#4471ca" />
        <path d="M117.3,453.7c-.7,0-1.3-.3-1.5-1,.7,0,1.1.7,1.5,1Z" fill="#364169" />
        <path
          d="M75.8,419.2c1-.5,3,2.1,2.5,3v1.5s-2-.5-2-.5c0,0,.9,1.5,1,2-4.6-2.6-.9-4-1-4.2-.2-.5-3.7-3.9-4.5-4.8v-.5c1.4.7,2.7,1.8,4,3.5Z"
          fill="#334271"
        />
        <path
          d="M62.3,393.7c.8,1.3,2.5,3.5,2.9,4.4,1,2.1.6,4.2,2.2,6.8,4.4,7.1,11.3,16,16.9,22.3-2.1-1-4.3-3.3-6-5s-1.7-2.2-2.5-3c-4.1-3.8-17.9-20.5-16.9-25.6l.9-.8c0-2.4,2.5-1.3,2.5,1Z"
          fill="#4a74c6"
        />
        <path
          d="M29.4,340.2c1.6,0,4.9-.1,4.5,2.5-.2,1.3-.9,2.5-2.4,2.5.9,2.9,1.4,5.8,1.5,8.8,1.9,4.8,4.3,9.4,7,13.8.9,1.6,1,2.9.3,3.8-.3-.5-1-1.1-1.5-1.5-.9-2-2.2-3.7-3-5.5-1.7-3.6-3.3-7.4-5-11-2.2-5-4.3-10.1-5.9-15.4.6-2.6,4,.2,4.4,1.9Z"
          fill="#4c5992"
        />
        <path
          d="M11.9,293.8c2,5,3.4,10.7,4,16l2.1,6.8c1.5,3,2.7,5.8,2.4,9.2l1.2,3.1c1.3,1.3,3.1,4.3.8,4.9-.9-2-1.6-4-2.5-6,0-3.6-2.4-6.6-3.4-9.8-1.9-6.2-2.7-13.1-4.2-19.3s-1.9-4.2-2.4-6.9-.5-5.2-.5-7.5c.7,3.2,1.8,6.3,2.5,9.5Z"
          fill="#292764"
        />
        <path
          d="M29.9,340.2h-.5c-1.2-.6-2.6-2.5-4-1.7l5.5,15.2c-2.3-4.4-5.5-11.1-6.5-16-1.7-3.3-1.6-5.2.5-6h1.1c1.3,1.4,4.3,6.8,3.8,8.5Z"
          fill="#3a3e7b"
        />
        <path
          d="M20.4,325.7c.9-.4,1.7.4,2.4,2.3,1.6,1.1,2.3,2.3,2.1,3.7-.3,1.9-1,1.5-1,1.8s.4,3.6.5,4.2c-.9-1.1-1.4-2.7-2-4,.6-2.4-1.1-4-1.8-6s-.1-1.5-.2-2Z"
          fill="#333770"
        />
        <path d="M32.8,360.2c-1.5.3-.9-.7-1-2,.3.7.7,1.3,1,2Z" fill="#272b49" />
        <path d="M33.3,361.2l-.5-.5c0,0,.4.2.5.5Z" fill="#272b49" />
        <path d="M33.8,362.2l-.5-.5c0,.1.4.3.5.5Z" fill="#272b49" />
        <path
          d="M21.9,170.8c.2.5.2,1,0,1.5.2.3.3.6.4.9.1.6-3,9.6-3.5,11s-.4.4-.8.6l-1.6,5.7c.9.9.7,2.8-.7,3-.5,2.3-1.2,4.4-2.2,6.3-.4-.4-.6-1.1-.5-2,0-.2,0-.3,0-.5.1-.4.3-.8.5-1,1.2-6.5,3.2-12.8,5-19,2.8-1.9,1.2-4.8,3.5-7,0,.2,0,.3,0,.5Z"
          fill="#667dca"
        />
        <path
          d="M13.4,199.8c.2,1.3,0,2.8-.5,4.5.5,3,0,5.5-1.5,7.5l-.5,2.5c.9.2.8,1.1,0,1.5,0,.8.2,1.4.7,1.8-.8,2.4-1.5,4.8-2.2,7.1-.1.4-.3.4-.5,0-.2-1-.2-2,0-3,.2-1.2.5-2.3.5-3.5,1.1-2.6.7-6,1.1-8.7.5-3.9,1.8-7.9,2.4-11.8.4.6.5,1.3.5,2Z"
          fill="#6173c2"
        />
        <path d="M12.9,197.3c0-.3,0-.7,0-1h.5c0,.4,0,.8-.5,1Z" fill="#6173c2" />
        <path
          d="M18.4,177.3c-.5.3-1.2.3-1.5.5,0-.5.4-1,.5-1.5-.3-.4-.4-.7,0-1,.1-.4.3-1,.5-1.5s.7-1.3,1-2,0-.8.5-1c0,.2.7,1.2.5,2.7s-1.1,2.4-1.5,3.8Z"
          fill="#4b63b0"
        />
        <path
          d="M9.9,277.8c2,12.4,5.4,24.2,10.2,35.5l-.8,1c1,.4,1.8,1.4,2.2,3.1,2.9,3.6,5.4,7.5,6.6,12.1s0,.9-.3,1.3c-.5,1.4-1.5,1.4-2,0-3.6-2-5.5-6.3-5.8-10.6-1.9-3-3.2-6.5-4.2-10.4-1.4-5.3-2.8-10.7-4-16l-2-16Z"
          fill="#323180"
        />
        <path
          d="M6.9,257.8c0,0,1.3,0,1.5,1,1.2,3.6,1.5,7.1,1,10.5.6.7.8,1.5,1,2.4.8,8.7,2.3,17.6,5.8,25.6s0,.7-.3,1c2.4,5,4.4,10,6.2,15.2l-.7.3c.3,1.5-1.3,1.8-2,.5-.6-2.6-2.7-5.5-3.6-8.7-2.6-9.1-3.8-18.6-5.9-27.8s-.4-.9-.5-1.5c.8-4.1-1.5-7.5-1.9-11.3s.3-4.9-.6-7.2Z"
          fill="#2e338a"
        />
        <path
          d="M8.9,224.8c.2.3.5.6.6.9s.3.6.3.9c-.2,2.8-.8,5.5-1.4,8.2.8.3.8.7,0,1l-.3,5.2c1.1.9.4,4-.2,5.3,1.4,1.3,1.3,2.7,0,4-1.6-1.4-.5-3.3-.7-4.7s-.8-3.3-.8-5.3c0-4.2.9-8.8,1.5-13s.8-3.8,1-5.5c0,1,0,2,0,3Z"
          fill="#4d5ba3"
        />
        <path
          d="M9.4,261.3c1.3,1.6,2.1,3.6,2.4,5.9l1,2.8c2.1,1,2.6,3.1,1.6,6.1,1.5,1,2,2.1,1.5,3.1.5,1.5.9,3,1,4.5.4,1.4-.7,1.7-1.5.5-.7,1.2-1.6.7-2.2-.4l-1.8-8.6-.6-.4c0-2.1-.4-3.9-1.4-5.6-.5-3.5-.7-7-1-10.5s0-.7,0-1c1.8-1,2.7,2.8,1,3.5Z"
          fill="#303ba6"
        />
        <path
          d="M8.4,253.3c1.8-1.4,2.6.5,3,2.1l2.5,2.7c1.4,1.4,1.5,2.5.5,3.2.5,2.9,1.3,5.9,2.5,8.9l-1,.6c-1,.5-1.6-.1-2-1.8l-1.2-4.6c-1.8-.7-2.9-1.7-3.3-3.1-.2-1.2,0-2.6-1-3.5,0-1.4-.4-2.8-.5-4.5.1-.4.3-.4.5,0Z"
          fill="#3244b7"
        />
        <path
          d="M9.9,244.8c.9.3.9.7,0,1,1.2.8,1.6,3.1,0,3.5,1.7,1.3.7,4.8-1.5,4h-.5c0-1,0-2,0-3s0-2.7,0-4c.2-.5.6-1,1-1.5.4-1.1.7-1.1,1,0Z"
          fill="#3b51c1"
        />
        <path
          d="M407.6,429.7l-.3,1.9c-4.2,4.8-8.8,9.1-13.7,13.1-1.1,1.6-2.8,3.1-5,4.5-1.5,1-2.9,2-4.5,3-1.3,1.2-2.5,1.7-3.5,1.5l-.5-1c3-2.3,6-4.7,8.9-7.1-.3-.9.3-1.7,1.7-2.2l1.8-2.9c4.8-2.1,6.8-4.6,8.5-9.5l1.1-.3c.1-.4.3-.4.5,0,1.1-1.9,2.8-3.1,5-3.5-.4-1.3-.3-1.6,1-1-.5-1.4,1.1-3.3,2.5-2.5-.4-1.7,1.9-3.7,3.5-3v1.5c-1,2.2-4.7,6.8-7,7.4Z"
          fill="#466cc3"
        />
        <path
          d="M412.1,430.7c-7.6,6.6-15,13.1-23.5,18.5l5-4.5c4.9-3.9,9.5-8.3,13.6-13h1.3c1.3-1.2,2.4-1.7,3.5-1.5v.5Z"
          fill="#4361ab"
        />
        <path
          d="M380.6,455.2c-6.6,5.1-13.7,8.6-21,12.5v-.5c1.7-1.7,4.2-3.1,6.5-4,4.6-2.8,9.2-5.6,13.9-8.4l.6.4Z"
          fill="#2c315c"
        />
        <path
          d="M384.1,452.2c-1.1,1-2.3,2.1-3.5,3l-14.5,8c1.7-2,4.1-3.5,6.5-4.5-.7-.7-.4-1,.5-.5,1.9-1.4,3.9-2.7,6.1-3.8,0-1.2.5-1.5,1.4-.7.9-.5,2.7-1,3.5-1.5Z"
          fill="#3f6cc2"
        />
        <path
          d="M342.2,474.2c.4.1.4.3,0,.5-.7.3-1.9.9-2.5,1.5-4.6,1.6-9,3.2-13.5,5-4,.9-7.9,2.3-11.9,3.4s-1.6,0-2.1.1c-.4-.1-.4-.3,0-.5.1-.4.3-.4.5,0,.1-.2.3-.2.5,0l.5-.5h.5c.3-.3.7-.3,1,0l.5-.5c.1-.4.3-.4.5,0h.5l.5-.5c.3-.5,1.3-.7,1.5,0l.5-.5c.9-.4,1.9-.7,3-1,.3-1,.7-1,1,0l.5-.5c.1-1.3.6-1.3,1,0,0-.7.9-.8,1.5-.5l.5-.5h.5l1-.5c.1-.4.3-.4.5,0l.5-.5c.2-.9,1.3-.9,1.5,0l.5-.5c.2-.4.3-.4.5,0l.5-.5c.2-.4.3-.4.5,0l1-.5c.1-.4.3-.4.5,0l1.5-1c.1-.4.3-.4.5,0l.5-.5c.1-.4.3-.4.5,0l1.5-.5c.1-.4.3-.4.5,0l2-1c0-.9.9-.9,1,0Z"
          fill="#477cdb"
        />
        <path
          d="M372.6,458.7c-2.1,1.5-4.4,3.1-6.5,4.5s-4.3,2.8-6.5,4c-5.5,3-11.6,5.3-17.5,7.5v-.5c.1-.3.3-.3.5,0,.4-.5.9-.9,1.5-1,.1-.5.3-.4.5,0,4.5-2.2,9-4.4,13.5-6.5.2-.4.3-.4.5,0l10.8-8.1c1.6-1.1,2.7-1.1,3.2,0Z"
          fill="#4473c9"
        />
        <path
          d="M429.6,403.2c3.7,1.7-1.1,6-3.2,7.8-1.1,2.7-2.7,5.1-4.8,7.2-2,4.1-6,9-9.5,12s-2.8,2.1-3.5,1.5c-.2-.4,0-.9.5-1.5v-1.1c3.1-3.4,6.2-6.8,9.3-10.2,1.3-1.5,1.9-2.9,1.7-4.2-.4-1,.3-1.9,2-2.5l3.5-4.5,1.5-1.5c-.2-1.8.7-2.9,2.5-3Z"
          fill="#4e68b1"
        />
        <path
          d="M434.1,397.2l.6-.4c2,2,1.5,4.3-1.6,6.9,1,1.3,0,2.8-1.5,3-1.4,2.6-4.6,6.4-6.6,8.7s-2.2,2.6-3.4,2.8c.7-1.5,1.8-2.6,2.2-4.1s-.3-1.8-.2-1.9c.2-.1,1,.2,1.4-.1s.2-1.2.6-1.6c1.7-2,5.5-4,4-7.2-.3-1.3,0-2.4,1.4-2.4.8-1.8,1.8-3,3.1-3.6Z"
          fill="#5067aa"
        />
        <path
          d="M447.6,384.7c2.5,0,1.2,2.1-.2,3.2l-1.3,3.3c-2.4,3.4-5,6.7-7.5,10-2.5,1.3-3.4,3.4-5,5.5h-2c.5-.9,1-2,1.5-3,.5-.9,1.3-1.9,2.4-2.8,1.3-3.2,2.9-6.1,5.3-8.6s2.3-1.9,2.8-2.1l2.7-5.2,1.3-.3Z"
          fill="#4f609c"
        />
        <path
          d="M464.1,361.2c.4.1.4.3,0,.5l-.5.5c.4.1.4.3,0,.5l-.5.5c.4.1.4.3,0,.5l-.5.5c.4.1.4.3,0,.5l-1,1.5c-1.4,3.6-3.5,7.1-6.2,10.4-.3,2.9-2.7,6.5-4.8,8.1-1.1,1.7-3,4.4-4.5,6.5.6-1.1.2-2.7.6-3.7s2.5-.6.9-2.8c-.8-.7-.6-1.7.7-2.9,1.2-4.2,3-8.3,5.4-11.9,2,1.1,9.6-13.5,8.8-13.2l-2.9,2.3-1.1-.3c.3-1.1.9-2.1,1.5-3,1.8-1.4,3.3-3,5-4.5,7-3.8,1.4,7.8-1,10Z"
          fill="#4c5b96"
        />
        <path
          d="M460.1,371.2c-2.2,3.8-5.4,9.3-7.9,12.9s-.8,1.3-1.6,1.6c0-.3,0-.7,0-1,.9-1.3,3.2-4.6,3.6-5.7s-.2-2.1.3-3c1.8-2.9,4.9-6.1,7-9.9l1-1.5c0-.1,0-.4,0-.5l.5-.5c0-.1,0-.4,0-.5l.5-.5c0-.1,0-.4,0-.5l.5-.5c0-.1,0-.4,0-.5.4-.6.7-.7,1-.5-1.7,3.3-3.2,7.3-5,10.5Z"
          fill="#445085"
        />
        <path
          d="M469.1,349.7h.5c-.5,3.5-.4,3.7-2,7s-2,3-2.5,4l-1,.5c1-2.2,7.3-12.2,1-10,1.3-1.1,1.6-2.6,4-1.5Z"
          fill="#485587"
        />
        <path d="M462.1,368.2c.4-.7.9-.8,1-1l-1,1Z" fill="#26243f" />
        <path
          d="M485.6,306.8c-.7,6-3.7,11.7-4.5,18-.2.1-.9-.1-1,0s.1.2-.5,1.3c-1.2,2.2-2.9,6.7-4.1,8.3s-1.6,1.1-1.9,1.7c-.7,1.2-.5,3.8-1.1,5.2-1.6,3.5-2.1,3.2-2.9,7.9-2.8-1.4-.7-2.2-.3-3.5,1.4-4.5,2.1-7,4.1-11.4s3.4-6.3,3.7-9.6c1.4,0,1.2-.8,1.6-1.7,1.2-3,2.6-6.2,3.8-9.1s1.8-5.2,3.1-7.7c0,.2,0,.3,0,.5Z"
          fill="#2b286b"
        />
        <path d="M235.7,493.7c-2.1,0-4.8.4-6.5-.5,2.1.2,4.8-.5,6.5.5Z" fill="#343962" />
        <path d="M228.2,493.2c-.5.8-1.2.3-1.5-.5,1,0,1.4.5,1.5.5Z" fill="#343962" />
        <path d="M225.2,492.7l-1.5-.5c1.1,0,1.4.5,1.5.5Z" fill="#343962" />
        <path
          d="M312.2,484.2v.5c-6.7,1.8-12.3,3.9-19.5,4.5-.2-.2-.2-.3,0-.5,0-1.1,2.4-1.2,3-.5l1-.5c.1-.4.3-.4.5,0,1-.6,2.3-.9,4-1,.2-1.2,1-1.1,1.5,0l.5-.5c0-.7,1.5-.6,2,0,.1-.7.3-.8,1-.5.1-.4.3-.4.5,0l.5-.5c.2-.4.3-.4.5,0l1.5-.5c.4-1.3,2.2-1.7,3-.5Z"
          fill="#4885e7"
        />
        <path d="M290.2,490.7l.5-.5c-.1,0-.4.5-.5.5Z" fill="#33365d" />
        <path
          d="M131.8,455.7c.7-1,3.2-.2,3.1.9h2.4c5.5,4.4,11.7,7.7,18.1,10.3,2,2.1,5.5,3.5,8.3,4.6,4.2.4,7.6,2.5,11,4.7,2.8-.4,5.1.7,6.8,3.2l9.1,2.7v.5c1.9-1.5,4.6-.3,5.6,1.9,1.6-.4,3.5-.2,4.8,1,1.5-1.1,3.1-1.3,4.5,0l4.3,1.1c2.9-.7,5-.3,6.5,1.2,2.9-.7,5.8-.5,8.9.4,3.1-.1,6.2-.4,9.4-.9,1.3-.2,2,.2,2.1,1.2,1.9-.3,2.9,0,3,1-.5.3-1.1.4-2,.5-.1.3-.3.5-.5.7-.6.5-9,.6-10.5.3-13.3-.2-35.1-5-47.9-9.4-5.1-1.8-10-3.4-15.1-5.1l-.6-.9c-2.2-.9-4.7-1.9-7.3-3.1-1.5-2-2-2.3-4.6-2.5-6.3-4.4-12.7-8.5-19.3-12.2l.3-1.3c-.9-.2-1.2-.4-.5-1Z"
          fill="#4b98f3"
        />
        <path
          d="M108.8,440.7c1-.8,2.7.4,2.9,1.7,6.8,4.8,13.7,9.6,20.6,14.3,1.4,2.1,1.9,1.2,3,1.8,3.8,2.2,7.4,4.9,10.9,7.1s4.5,3.3,5,3.5c1.1.5,2.6.3,3.6.8s1.2,2.1,2,2.5,1.9,0,2.7.2,0,1.2.6,1.6c1,.6,5.5.3,3.7,2.5-7.7-2.6-15.5-6.8-22.5-10.7s-1.4-1.1-2.8-2.3-3.8-1.2-4.6-1.7c-3.9-2.5-7.9-6.2-12.1-8.9s-1.6-.1-1.9-.8l-1-.5c-1.4-1-2.3-1.8-3.5-3-1.3,0-7.6-6.5-7.4-7s.5-.8.9-1Z"
          fill="#4a90ec"
        />
        <path
          d="M93.8,413.2c.7,3.9,1.2,7.4.2,11.3.9,2.9,2.5,6.7,5.8,6.7,1.1,2.5,2.9,4.5,5.5,5.8v1.2c.9,1.4,1.6,1.8,3.3,1.9l.2.6c-.2,2.2,2.1,2.8,3.2,4s2.3,2.9,3.3,4c-1.4.9-2.5,0-3.3-1.2s.9-1.6-2.1-.8c.7-3.2-.4-1.9-.9-2.1s-1.4-2.5-1.6.1c-.9-.6-3.8-2.3-4.3-3s.3-1.1-.2-1.7-3.3-2.4-4-2.8c-1.2-.5-2-1.6-2.4-3.2-2-.8-3.1-2.1-3.6-4.2-1.6-.3-2.4-1.5-2.6-3.6-2.6-2.2-2.6-4.4,1.2-4.5,0-.8.2-1.7,1-2.7-1.2-3-1.1-5.2.5-6.8.6-.5,1.5.3,1,1Z"
          fill="#4d8dec"
        />
        <path
          d="M297.2,486.7c1.3.2,1.3.6,0,1-.2,0-.3,0-.5,0l-1,.5c-1,.2-2.1.3-3,.5l-.5.5c-1,0-2,0-3,0l-1,.5c-13.6.9-26.1,2.7-39.7,2.5-6.3,0-12.7-.4-19-.5s-1.9.2-2.7-.5c3.6,0,7.6-1,11-1,6.5.6,13,.5,19.6-.3h2.2c8.8.1,20.8-1.3,30.5-2.5,2.3-1.4,4-1.5,5.1-.3.4-.9,1.4-1.6,2-.5Z"
          fill="#498eec"
        />
        <path d="M119.8,452.2c-.5,0-.7-.3-1-.5l1-.5c0,.3,0,.8,0,1Z" fill="#4d8dec" />
        <path d="M289.2,489.2c-.1.5-.6.5-1,.5.1-.5.6-.5,1-.5Z" fill="#4a8ced" />
        <path d="M292.7,489.2c-.2,0-.3,0-.5,0,0-.2.3-.4.5-.5v.5Z" fill="#4a8ced" />
        <path
          d="M476.6,170.3c.4,1,1,2.8,2.2,3l-.2-3c1.9,4.7,2.9,8.8,4.5,13.5.3.1.5.5.5,1v1c0,.5,0,1,0,1.5-.4.7-1.2-2.7-2-3,0-.2,0-.3,0-.5l-.5-1c-.1-.2-.3-.3-.5-.5-1.6-1.9-3-6-3.8-8.7s0-.5.3-.8l-.5-.5c-.4-.1-.4-.3,0-.5l-.5-.5c-.4-.2-.4-.3,0-.5-.2-.2-.2-.3,0-.5h.5Z"
          fill="#b3bee6"
        />
        <path d="M483.6,184.8c0-.2-.3-.5-.5-1h.5c0,.3,0,.7,0,1Z" fill="#adb9e5" />
        <path d="M484.1,185.8h-.5c0-.3,0-.7,0-1,0,.2.3.6.5,1Z" fill="#a6b7e3" />
        <path
          d="M464.1,143.3c2,3.9,2.6,3.6,5,6.5-1.3.4-1.1,1.6-.9,2.6.4,2.1,2.3,5.8,3.4,7.9.4,1.2,1,2.3,1.5,3.5-.1.4-.3.4-.5,0l-.6.3c-1.2-1-2.4-2.1-3.7-3.2-1.8-3.4-3.5-6.7-5.1-10l.4-.5c-.5-.3-.7-.6-.5-1,.4-1,.8-.8,1.6-.5-1.6-2.1-4-6.4-2.6-8.5,1.1.9,1.4,1.9,2,3Z"
          fill="#99c6fb"
        />
        <path
          d="M451.1,128.4c1.2,1.7,1.7,1.8,3,2.8s.5,1.1.5,1.2c1.4,1.2.4-2.6,2-1,0,.5,4.7,7.4,5.5,8.5,0,.1,0,.4,0,.5.6,1.8,1.4,4.5,2,6.1s2.3,1.7,1.5,3.9l-2.5-1c-.5.2-.9,0-1.2-.3l-1.9-4.6c-.5,1.5-1.3,1.3-2.4-.6-1.2.8-1.7.3-1-1v-.5c.3-.2.5-.4.4-.6-.6-2-2.6-5.6-3.9-7.4.3-.4.3-.9,0-1.5-1.6.5-3.6-3.5-2-4.5Z"
          fill="#9ecdfd"
        />
        <path
          d="M324.2,25.4c2.9,0,17.9,6.2,21.5,7.8,6.6,2.9,12.9,6.8,19.5,9.7,2.2,0,6.5,2.3,7,4.5.6.2,1.1.5,1.5,1,4.9.9,9.2,4.4,12.5,8l11,8c1.5,1.6,3.6,3.4,5.5,4.5,2.3.4,4.7,2.8,5.4,4.8,3.1,2.4,5.9,5,8.4,8,1-.2,1.4.2,1.1,1.2,3.1,1.5,5.6,3.9,7.2,7l5.3,6c2.5.5,3.8,3.3,4.7,5.5l3.3,4.5c1.8-.3,4,4,4.2,5.5l2.3,4.5c.4.2.4.3,0,.5l1,2c.7-.7,1-.4.5.5.4,1.6,1.2,3.1,2,4.5l2.6,5.8c-.7,1.6-2.8-1.3-3.1-2.3-1.3-.6-3-2-3-3.5-1.9-2.9-4.1-5.6-6.6-8v-.9c0,0-3-4.1-3-4.1-1.3.2-1.7-.2-1-1.4-.5-.4-.9-.8-1-1.5-.2,0-.3,0-.4,0-.5-.5-3.1-2.9-3.3-3.2s0-.4.2-.7l-2.3-2.6c-2.4-1.2-3.6-2.7-3.7-4.4-2-2.3-4-4.5-6-6.5-2.2-2.3-4.7-4.4-7.5-6.2v-1.3c-.9-.7-1.6-1.3-2-2-7.9-6.7-16.1-13-24.6-18.9l-.9-1.6c-12.5-8.3-25.8-15.6-39.9-21.8l-1.1-1.2-18.3-6.6-.7-.9-1-.6c-7.7-1.1-2.9-5.5,2.5-3.4Z"
          fill="#fdfdfd"
        />
        <path
          d="M446.1,112.9c1.9,1.7,3,4.1,4.5,6.2-.7.5-.7,3.7-1.7,3.3s-2.3-2.9-2.8-3.5-.4-.3-.5-.5l-1-2c0-.1,0-.4,0-.5l-2.7-5.1c1-2,3.6.6,4.2,2.1Z"
          fill="#81c2f4"
        />
        <path
          d="M444.6,110.4c.4.5,1.1.6,1.5,1.5s0,.7,0,1c-.6-.6-2.7-2.6-3.5-2,.7,1.6,1.3,3.3,2,5l-6.5-10c-.7,0-5.6-8.6-3.4-7.1,3.8,3.3,7.1,7.3,9.9,11.6Z"
          fill="#8ac0f3"
        />
        <path
          d="M451.1,128.4c.6,1.8.8,3.1,2,4.5,1.5,3.2-.9,2.3-2,0-1.5-1-3.8-4.1-3.5-6,.3.3,2.1,2.4,2.5,2s-2.4-4.4-2-5.5c.8,1.5,2,3.5,3,5Z"
          fill="#ccf0fd"
        />
        <path
          d="M417.6,82.9c-3.1-3.6-6.5-6.9-10.2-9.8,0-.9.7-1.2,1.5-1.1s5.8,4.4,6.3,4.8c3.2,2.8,6.4,5.6,9.4,8.6,1.7,1.3,3.2,2.8,4.5,4.5.2.3.3.7.5,1l1.5,1.5c0,.1,0,.4,0,.5,1.1.7,2.1,1.5,3,2.5.2.3.3.7.5,1l1,1c0,.1,0,.4,0,.5l.5.5c.1.2.4.3.5.5l1.5,1.5c.2.3.3.7.5,1v.5c-1.4-1-2.8-1.9-4.2-2.7l-4.3-5c.5.5.3,1.1,0,1.7-4.3-4.2-8.4-8.6-12.5-13Z"
          fill="#a4d1f4"
        />
        <path
          d="M415.1,76.4c0,0,.4,0,.5,0l2,2c.8.7,1.4,1.5,2,2l1.5,1.5c0,0,.4,0,.5,0l2.5,2.5c.2.2.3.3.5.5v.5c-4.1-3.5-8.8-7.4-13-10.8s-3.1-2.7-3.5-1.2c3.2,1.1,4.8,4.4,7,6.8s1.7,1.8,2.5,2.7c-4.5-4.9-10.7-9.1-15-14,0,0,.1-.5-.1-.8-.5-.7-2.1-1.4-2.4-2.6l4.2,1.6,10.8,9.4Z"
          fill="#acdbf7"
        />
        <path
          d="M438.6,101.9l.5.5c1.6,2.2,3.6,4.4,5,6.5s.4,1,.5,1.5c-3.3-3.6-6-7.8-9.7-11-.3,2.5,3.1,4.1,3.3,6.5-3-3-5.4-6.6-8-10s-3.4-5-5.5-6.8c-.3-1.9,3.3,1.3,3.8,1.7,3.2,3.1,6.7,8.3,10.2,11Z"
          fill="#97c6f4"
        />
        <path d="M429.1,89.9c-1.7-1.4-2.8-3-4.5-4.5v-.5c1.9,1.9,2.9,2.6,4.5,5Z" fill="#b3e1f3" />
        <path d="M434.1,95.4c-.9-.8-2.2-1.6-3-2.5,1.5.1,2.2,1.5,3,2.5Z" fill="#b3e1f3" />
        <path d="M439.1,102.4c-.3,0-.4-.4-.5-.5v-.5c.3.4.4.8.5,1Z" fill="#b3e1f3" />
        <path d="M438.1,100.4l-1.5-1.5c.3.3,1,.8,1.5,1.5Z" fill="#b3e1f3" />
        <path d="M436.1,98.4l-.5-.5c.1.2.4.3.5.5Z" fill="#b3e1f3" />
        <path d="M435.6,97.4l-1-1c.2.2.6.5,1,1Z" fill="#b3e1f3" />
        <path d="M431.1,92.4c-.8-.3-1.1-.9-1.5-1.5.8.3,1.1.9,1.5,1.5Z" fill="#b3e1f3" />
        <path d="M424.1,84.4l-2.5-2.5c1,.9,1.7,1.7,2.5,2.5Z" fill="#b3e1f3" />
        <path d="M421.1,81.9c-.6-.5-1.1-1.1-1.5-1.5l1.5,1.5Z" fill="#b3e1f3" />
        <path d="M417.6,78.4c-.7-.6-1.6-1-2-2,.7.6,1.6,1,2,2Z" fill="#b3e1f3" />
        <path
          d="M367.6,41.9c.9.4,1.5,1.5,2.3,1.9,6.2,3.1,12.9,6.7,18.7,10.6s2,1.7,3,2.5c-.3-.2-1.1-.2-1.7-.6-1.8-1.1-3.5-3-5.6-3.9-.6,1.4,1,2.9,1.8,4-4.1-2.8-8.3-5.3-12.5-8-.4-.5-.9-.8-1.5-1-2.3-1.5-4.9-2.7-7-4.5s-1.5-1.1-1.5-1.5c.4-.2,3.4.3,4,.5Z"
          fill="#c4edf7"
        />
        <path
          d="M468.6,265.8c.3-3.5,2.4-3.1,3.9-.4l1.9,2.2c-1,1.8.5,4.4,2.2,5.2-.4,2.3-.9,4.7-1,7s0,.7,0,1l-.5,1.5c-.4,1.9-.8,3.5-1,5.5-.3,1.8-1.5,1.8-2,.2,1.7-.4.4-.8.5-2s1.3-2-.5-2.5c.8-.5,1.5-2.9,1.4-3.5s-1.1-.5-1.2-.8c-.4-.7.2-2.5-1.1-3.1,2.3-.5-.3-3.3-.8-4.7s.5-4.2-1.7-3c-1-.2-.6-1.9,0-2.5Z"
          fill="#4d6ff0"
        />
        <path
          d="M481.1,249.3c-.7,3-.9,6-1.3,9.1-.7,5.4-2.3,9.1-3.2,14.4-.8,0-1,1.6-1.2,1.5-2-.8.4-3.1-2.3-2.5,1.2-1.4-.5-2.5-.4-3.2s1.1-1,.9-1.3-1.8-1.2-2-.5c1-1.5-1.5-3-2.5-2.5s.7,1.3-.5,1.5c-.3,0-.3-.4,0-1-1.4-.5-1.4-1.5,0-2,1.5-3.1,3.8-1.8,6.9,3.8l1.1-3.2c.2-3.8,1-7.1,2.4-10.1l.5-1.5c-.4-.2-.4-.3,0-.5,0-1.5,0-4.2,1-5,.7.1.9,1.1.5,3Z"
          fill="#5273f1"
        />
        <path
          d="M483.1,237.8c.1.4,1,3.5.9,3.7s-1,1.5-1.4,2.8-1.2,3.4-1.5,5l-.5-3c-.7-2.2-.1-6.5.5-9.1l1-.4c1-1,1.7-.3,1,1Z"
          fill="#4e70e7"
        />
        <path d="M475.1,282.3c0-.5-.2-1.2.5-1.5,0,.5.2,1.3-.5,1.5Z" fill="#4c66e5" />
        <path
          d="M467.6,276.8l1-.7c-.2,1.4.3,1.4,1.5,1.2.5,1.6-.8,1.4-.9,1.6s.4,3.6.5,4.1.9.2.9.5c0,1-.5,1.9-1.5,1.5.5.8,2.5,2.7,2.5,3.5,0,1.3-1.4,1.1-1.5,1.3-.3.3,1.4,1.3,1.4,1.7s-.8.8-.9,1.5.5.7.5.8c-.1,2.9-1,4.7-1.6,7.2-1,4.6-1.6,9.5-3.4,13.8-1.2-1.8-1-3.5.5-5,1.1-3.9,1.3-8.3,1.2-11.9.1-1.5.4-2.8.8-4l-.8-1.8c1.1-2,.3-5.7-2.2-4.9-1-3,0-7.9,2-10.5Z"
          fill="#4863e9"
        />
        <path
          d="M468.6,265.8c0,.8,0,1.7,0,2.5-.2,2.5-.6,6-1,8.5s-1.4,7-2,10.5c1.1.6,0,3.3-1,4-.2,1.3-.6,1.3-1,0-.3-.8-.3-1.8,0-3l-.9-1c-.2-2.2,1-11.1,1.9-12.6s.7-.3.8-.3c.2,0,.1.5-.3-.6-1.3,0,1.8-8.3,2.1-8.7s.9-.4,1.4-.3c0,.3,0,.7,0,1Z"
          fill="#5874ed"
        />
        <path
          d="M464.6,293.3c.9-5.2,2.1-6.5,3.4-3.9-.9,2.7-.8,4.9.3,6.8-.3,4.4-.8,8.9-1.7,13.6-.2,1.7-.3,3.3-.5,5s0,.3,0,.5c-.5.9-.9,1.9-1,3-.3,1.2-1.6,3.4-2,4.5l-.7-1.1c.4-1,.8-12.6.2-12.4-1.4,3.3-2.8,6.3-4.3,9.5h-.8c-.5-.6-.3-1.6.5-3l-.4-.7c2.6-7,4.7-14.1,6.2-21.4l.7-.4Z"
          fill="#4358dd"
        />
        <path d="M465.6,318.3h-.5c.2-.9-.5-2.6,1-3,0,.9-.7,2-.5,3Z" fill="#4863e9" />
        <path
          d="M457.6,318.8c2.1-3,2.4-7.3,4.4-10.4s1.9,1.2,2,2.2-.4,1.7-.4,2.4c.2,3.5.8,6.3-.5,9.7-.5,1.6-1.2,3.3-1.5,5l-.5,1.5c0,.2,0,.3,0,.5-1.3,2.9-2.6,5.7-4,8.5,1.3-6.3,2.2-12.8,2.9-19.3-.5,1.3-1.2,2.7-2.4,1.3-.4-.1-.2-.6,0-1-.4-.1-.4-.3,0-.5Z"
          fill="#3d4ed2"
        />
        <path
          d="M457.6,320.3c2,.1,1.9-6.6,4-5s-.5,1.1-.5,1.7c0,3.6-.4,6.5-1,10-.7,4-1.5,7.5-3,11.3-.7,1.5-.8,2.4-2,4l-.5-.3,1.9-5.8c-.5-.5-.5-1.3,0-2.5,0-1.7-.4-3.3-.8-4.9l-.4-.6,1.9-5.9c-.9-.3-.9-.7,0-1,0-.4.3-.8.5-1Z"
          fill="#3a48ca"
        />
        <path
          d="M449.6,356.7c1.6,1.9-2.2,6.8-4,8,0,1.8-.4,3-1.5,3.6-1.2,3.5-3.2,6.1-6,7.9-.2,1.9-2.2,4.9-4,5-.8.5-.9.2-.5-1-.4-.1-.4-.3,0-.5l-.3-.9c4-5.6,7.9-11.3,11.8-17.1-.2-.2-.4-.5-.3-.6.8-1.6,2.8-5,3.8-6.4s.6-.1,1,0c.6.6.2,1.3,0,2Z"
          fill="#4f69d2"
        />
        <path
          d="M455.1,342.2c-.3.4-.3,1.2-1,1.5-1,.2-1.5-.2-1.3-1.3l2.1-5.8-2.2-1.4c-.3-1.5,1.6-5.8,3-6.5,4.3,3.4,0,9.2-.5,13.5Z"
          fill="#3746c2"
        />
        <path
          d="M454.1,343.7c-.6,2.5-3.3,8.7-4.5,11s-3.2,5.2-4.5,7c-.8,1.5-1.8,3-3,4.3s-.7.1-1-.3c1.4-3.1,3.3-6.9,5.2-9.8s.4-.2.8-.2c2.1-4,3.7-8,4.8-12.4.9-.6,1.7-.6,2.2.4Z"
          fill="#3a49bf"
        />
        <path
          d="M452.6,352.7c0,.3.5,1,.5,1.7,0,3.7-5.3,7.7-5.5,10.2-.5,1.1-1.3.9-2,0,1.3-2.2,3.4-5.7,4-8,1.3-.5,1.1-2.1,1.5-3-.3-.5.5-1.2,1-1.5h.5c0,.2,0,.3,0,.5Z"
          fill="#3135ab"
        />
        <path d="M452.1,352.2c.2.9-.9,1.3-1,1.5l-.5-.3c0-.8,1.2-2.1,1.5-1.2Z" fill="#4f69d2" />
        <path d="M461.1,329.2c0-.5,0-1.1.5-1.5,0,.5.2,1.2-.5,1.5Z" fill="#4c62da" />
        <path
          d="M489.1,229.3c0,.2-.8,1.2-.5,1.5.7.6,1.7-1.2,2,3-4.2-1.8-2.7-.1-4.7,2s-2,1.1-2.8,2c0-.3-.8-.7-1-1-1.5,0-1.9-2.5-.5-3,1.3-3.1,3.9-6.6,7.5-4.5Z"
          fill="#5474e3"
        />
        <path
          d="M484.6,214.8c1-.9,1.8,0,2.5,3,.7,1.5,1,4.2,2,5l-.3.5c-.5,0-.8-.3-1.2-.5-1.2,3.1-4.8-.5-2.5-2-1.4,0-2.4-4-1.5-5,.2-.6.5-.9,1-1Z"
          fill="#678cec"
        />
        <path
          d="M485.1,220.8c.3,1,0,1.8,1.3,2.5.5,0,.1-.8.3-.9s.6.3.9.4c-.2,1.2,1.5,2.2,1.5,2.3,0,.4-.5.6-.5.7l-.7.8c-1.9,0-5.6,1-5.7,3.2l-1.1.5c.3,2.4-.2,4.1-1.5,5-1-.7-.9-1.1-.2-2-.3-2.9-.5-5.7-.1-8.6.1-.4,5.2-7.6,5.9-3.9Z"
          fill="#5c83ec"
        />
        <path
          d="M488.6,225.8c0,1.2.5,2.4.5,3.5-1.1.2-3.6.7-4.5,1.3-1.5,1-.8,3.8-3,3.2-.8-.4-.9-1.6-.5-3.5.2-.5,0-1.2.4-1.9.8-1.4,5.3-3.7,7.1-2.6Z"
          fill="#587ce9"
        />
        <path
          d="M447.6,364.7c0,.9.5,1.8.5,2.5,1,.6.7,1.9-.8,3.9-1.9,2.8-4.8,7.1-3.7,10.6l-2.4,3.4h1v.6c.3,2.5-2.5,6.6-5,7l-.5.5c-.5.8-1,1.1-1.5,1-3.5,2-3-5.2.2-5.1-.4-3.3,1.7-5.7,3.7-8.1,0-4,1-7.1,4.1-9.7.2-2.3,1-3.5,2.4-3.8-.9-.6-.9-1.6,0-2.9.2-.5,1.5-.3,2,0Z"
          fill="#2a35a3"
        />
        <path
          d="M453.6,360.7c-.4,1.7-.5,2.8-.8,4.5s-3.9,3.5-4.5,5.4-.2,4.1-1.2,6l1.5-1.5c1.1,1.1.5,2.1-1,2,.4,1.8-1,4.4-3,4.5l-2.5,3.5-2.8,3.5c-.4-.7.5-3,1-3.8s2.2-2.3,2.2-2.5c.2-.8-.8-2-.2-3.7s2.5-5.8,2.9-6.6c.9-1.7,2.9-2.6,2.9-4.9.9-1,3.1-2.6,3.7-3.5,1.4-1.8-.9-3.4,1.8-3Z"
          fill="#2b339c"
        />
        <path d="M466.1,330.7h.5c-.2.4-.2.3-.5,0Z" fill="#31309e" />
        <path
          d="M458.6,358.7c1.4-1.4,3.4-3.4,5.5-3.5.2.2-1.6,4.5-2,5.1-1.3,2.4-4.5,8.2-6.5,10s-.9,0-1.3.3c-.9.8-5.5,11.8-6.7,14s-2.2,4.8-4,5.5c-1.5-1.7.4-6.4,1.8-8.3,1.7-.6,2.5-2.1,2.2-4.7.4-.6.6-1.4,1-2s0-.4,0-.5l.5-.5c.5-.8,1-1.7,1.5-2.5l.5-.5c2.3-3.8,4.5-9.3,7.5-12.5Z"
          fill="#4f5f9e"
        />
        <path d="M450.6,371.7c.1-.2.4-.4.5-.5l-.5.5Z" fill="#2b339c" />
        <path d="M448.6,374.7c.2-.3.4-.4.5-.5l-.5.5Z" fill="#2b339c" />
        <path
          d="M485.1,208.8c.1.5,0,1.4.1,2.1.7,2.3,1.5,4.6,1.9,6.9-.4-1-1.4-3.3-2.5-3-.8-.5-1.3-1.5-1.4-3-2.2-1.3-3-2.6-2.6-4-2.5-1.1.7-3.7,2.5-4,1.5-.2,3.2,4,2,5Z"
          fill="#7096f2"
        />
        <path
          d="M480.6,194.8c1.4.6,2.4,2,3.2,4.2l1.3-.2c0,0,.8.4,1,1-2.3,2.4,2.6,8.1-1,9-.4-1.5-1.6-3.6-2-5-.4-.1-.4-.3,0-.5l-1.4-4.1c-2.1-1.9-2.4-3.4-1.1-4.4Z"
          fill="#81a3ef"
        />
        <path
          d="M476.1,170.8c0,.2,0,.3,0,.5l.5.5c0,.1,0,.4,0,.5l.5.5c1.8,3.2,2.7,6,3.5,9.5s1,4,1,6c-.5.3-.9-.2-1-1.5-.4-.1-.4-.3,0-.5l-.5-.5-1.5-1.5c-1.1-2.6-4.8-12.6-4-14.4s1.4.1,1.5.9Z"
          fill="#8ba8ef"
        />
        <path
          d="M481.6,188.3c.9,2.3,1.2,5,2,7-.9,2.5-3-.8-3.5-2.5-1.4-.3-2.5-1.9-1-3-.3-1.2.6-2.3,1.5-3,.3.5.8,1,1,1.5Z"
          fill="#93b2f4"
        />
        <path
          d="M483.6,195.3c.4,1.2,1,2.3,1.5,3.5-1.7,4.5-3.4-2.4-4.5-4-1.4.2-1.4,0-.5-1-.7,0-.7-.8,0-1,.7,1.1,2,2.7,3.5,2.5Z"
          fill="#89adf3"
        />
        <path
          d="M28.9,160.3c.2.4.4.7.3,1-.7,2.1-4.5,12.2-5.4,13s-.6.4-.9.6l-5.6,17.1c-2.2,2.1,0-6.5.6-7.1,1.2-4.6,2.4-8.1,4-12.5,0-1,.4-1.7,1-2.5.9-2.3,1.5-4.7,2.5-7,.2-1,2.4-7.1,2.8-7.2s.5,0,.7.2c3.1-3.9,1.2,2.6,0,4.5Z"
          fill="#aab8e1"
        />
        <path
          d="M38.8,134.3c-.9,3.3-3,7.4-5.5,9.5-.8.2-.9-.4-.5-2,2.2-4.9,4-8.1,7-12.5,1.4,1.4-.3,3.6-1,5Z"
          fill="#799be0"
        />
        <path
          d="M33.3,143.8l.5.6-2,3.7.5.3c-.8,2.4-2,4.7-3.5,7,.2.2.2.3,0,.5-1,1-2.8,5.4-3.5,7,0-.9.2-1.8.5-2.7,2.1-6.1,4.3-12.3,7-18.3l.5,2Z"
          fill="#708edd"
        />
        <path d="M21.9,172.3c0-.5,0-1,0-1.5l1-1c-.3.8-.7,1.7-1,2.5Z" fill="#7f97db" />
        <path d="M19.4,170.3l.5-1c-.2.7-.5.9-.5,1Z" fill="#4b63b0" />
        <path d="M23.4,159.3l.5-.5c-.2.4-.5.5-.5.5Z" fill="#33365f" />
        <path
          d="M74.8,89.4c2.1-2.5,5.6-1.7,1.9,0s1.1-.5.1.5c.5.4.1.9-.5,1l-.5.5c-2.1,1.4-4,3-5.5,5,.4.1.4.3,0,.5,0,.3-.2.5-.5.5.5.5.2,1.1-.5,1l-.5.5c.2.8-.2,1.2-1,1-.5,1-1.3,1.6-2.5,2,.4.1.4.3,0,.5.2.3.3.7.1,1-3.5,6.3-8.5,12.2-13.8,17.2l-1.8.3c.3,1.4-.7,2.2-3,2.5.8-2.4,3.5-3.8,5-5.7s1.6-3.4,3-4.5l-3,1.3c-.6-.9-.1-1.7,1-1.5l.5-.5c-.4-.1-.4-.3,0-.5.7-1.1,1.6-1.9,2.5-2.5,5.7-7.5,12-14.2,19-20Z"
          fill="#6b99e9"
        />
        <path
          d="M43.3,129.4c.5-1.5,4.9-9,6.6-6.6s-1.2,6.2-2.8,7.2l-2,5-1.3.3c.7.9-.7,3.6-2,3-.2.3-.3.3-.5,0-.5-1-.4-2.2.4-3.4-.7,1.3-1.5,1.7-2.4,1.4.8-2.5,2.6-4.8,4-7Z"
          fill="#7daaf1"
        />
        <path
          d="M38.8,136.3c1,1.2.3,2.5-2,4-1.1,3-2.6,5.7-4.5,8l-1.8,2c0-1.9,1.7-4.5,2.8-6.5,1.7-3.2,3.9-6.3,5.5-9.5l.4.3c0,.6-.2,1.1-.4,1.7Z"
          fill="#6a85d9"
        />
        <path
          d="M53.8,109.4c0,1,0,1.4.5,1,0,.5-.4,1-1,1.5,0,.1,0,.3,0,.5l-.5.5c-.4.5-.6,1-1,1.5s-1,.9-1.5,1.5c-1,.6-.8-.1-.5-1,.5-.8,1-1.7,1.5-2.5l1-1c0-.1,0-.4,0-.5l.5-.5c0-.2,0-.4,0-.5.3-.4.7-.6,1-.5Z"
          fill="#bedef8"
        />
        <path
          d="M49.3,117.4c-1.3,1.8-2.1,4.1-4,5.5.4-2.5,2.2-4.5,3.5-6.5,1-.6.8.1.5,1Z"
          fill="#98bbf2"
        />
        <path
          d="M54.3,122.9c0,.4-.2.6-.5.5-1.2,2.7-2.7,5.2-4.5,7.5-1,1.8-2,3.5-3,5-1.9,2.8-3,6.1-3.8,9.2l-1.2.3c-.1.4-.3.4-.5,0,0-.6-.2-1.2-.5-1.7l3.8-7.5-.3-.8c.8-1.4,1.3-4,2.4-5.8s3.4-3.1,3.1-6.1c-3.6-.4-3.7,3.2-5.1,5.2s-.8.7-.9.8c.5-2.4,1.9-4.3,3.5-6s2.2-1.7,3-2.5c1.7-1.3,2.2-.2,2,1.6,2.3-3.8,4.9-7.3,7.9-10.5l.6.4c-1.6,3.7-3.6,7.2-6,10.5Z"
          fill="#74a4f3"
        />
        <path d="M50.3,115.9c-.3.5-.6,1-1,1.5l-.5-1c.3-.5.7-1,1-1.5l.5,1Z" fill="#aecdf6" />
        <path d="M51.3,112.4c.4-.6.8-.8,1-1l-1,1Z" fill="#b7cee8" />
        <path d="M52.3,110.9c.1-.2.3-.4.5-.5,0,.2-.3.4-.5.5Z" fill="#b7cee8" />
        <path d="M53.8,109.4l-1,.5c.6-.9,1.1-1,1.5-1.5.6.5.2,1.1-.5,1Z" fill="#b7cee8" />
        <path d="M54.3,108.4c0-.2,0-.3,0-.5l1-.5c.6.6-.3,1.3-1,1Z" fill="#bedef8" />
        <path
          d="M88.3,72.4c-3.6,3.9-7.2,7.7-11,11.5-.6,1.8-2.4,3.3-4,4.5-2.4,3.5-5.3,6.6-8.5,9.5l-8.5,10c-.4.6-.9,1.1-1.5,1.5.2.4,0,.9-.5,1-1.7,1-.9.2-.5-1s.4-.7.5-1c.2-.3.6-.5,1-1s.3-.7.5-1l.5-.5c2.2-2.8,4.3-5.8,6.5-8.5,5-6,10.4-11.6,15.5-17.5,2.8-2.9,6.2-6.1,9.5-8,.7-.7,1-.4.5.5Z"
          fill="#eff7f9"
        />
        <path d="M55.8,106.4l.5-.5c-.1.2-.4.3-.5.5Z" fill="#bedef8" />
        <path
          d="M90.3,68.9c.6,1-1.5,2.6-2.5,3l-9.5,8c.2-.3.3-.7.5-1,.4-.5.6-1,1-1.5,1,0,1.4-.7,2-1.2,2.6-2.4,5.4-4.8,8-7.3h.5Z"
          fill="#cbe8f4"
        />
        <path
          d="M117.8,48.4c0,1.3-2.7,2.9-4,3h-.5l-.5.5c-.2.5-.5.8-1,.5l-.5.5c-.2.4-.3.4-.5,0l-1,1c.2.9-.5,1.3-1,.5h-.5c3.3-2.2,6-4.4,9.5-6.5v.5Z"
          fill="#c2eff9"
        />
        <path
          d="M108.8,54.4c0,1.2-.9,1.9-2,1.5-.4-.1-.4-.3,0-.5.5-.3,1-.7,1.5-1h.5Z"
          fill="#d1f3f9"
        />
        <path
          d="M121.8,45.4v.5c-.1.4-.3.4-.5,0l-.5.5c.4,1-.3,1.3-1,.5l-.5.5c.3,1-.4,1.3-1,.5h-.5c1.1-.7,2.2-1.8,3.5-2.5s.4,0,.5,0Z"
          fill="#c1e9f7"
        />
        <path d="M106.8,55.9c.5,1-.7,1.8-1.5,1,.2-.2.3-.7.5-1,.3-.2.7-.3,1-.5v.5Z" fill="#bce9f7" />
        <path d="M125.3,43.9c-.2,1.1-2,2.1-3,1.5.9-.6,1.7-1.3,3-2v.5Z" fill="#c1e9f7" />
        <path
          d="M129.3,41.4l-.5.5c-.2.4-.3.4-.5,0l-.5.5h-.5c.3-.9,1.3-1.1,2-1.5v.5Z"
          fill="#c1e9f7"
        />
        <path d="M129.3,41.4v-.5c.1,0,.4,0,.5,0,.1.5,0,.6-.5.5Z" fill="#c5f1f9" />
        <path d="M126.8,42.9l-.5.5c-.2.4-.3.4-.5,0,0,0,.4-.6,1-1,.3.1.3.3,0,.5Z" fill="#c1e9f7" />
        <path d="M127.3,42.9c-.1.4-.3.4-.5,0v-.5c.1,0,.4,0,.5,0,.2.2.2.3,0,.5Z" fill="#c5f1f9" />
        <path d="M130.3,40.9v-.5c.1,0,.4,0,.5,0,.7.7.4,1-.5.5Z" fill="#c5f1f9" />
        <path d="M130.3,40.9c-.1.4-.3.4-.5,0,.1-.1.3-.4.5-.5v.5Z" fill="#c1e9f7" />
        <path d="M131.3,40.4v-.5c.1,0,.4,0,.5,0,.7.7.4,1-.5.5Z" fill="#cbf3f8" />
        <path d="M131.3,40.4c-.2.4-.3.4-.5,0,.1,0,.3-.4.5-.5v.5Z" fill="#c1e9f7" />
        <path d="M125.3,43.9v-.5c.1,0,.4,0,.5,0,.7.6.4.9-.5.5Z" fill="#c5f1f9" />
        <path d="M121.8,45.9v-.5c.1,0,.4,0,.5,0,.7.7.4,1-.5.5Z" fill="#c5f1f9" />
        <path
          d="M100.3,62.9c.4.9-1.7,2.4-2.5,2l-1.5,1.5c0,.6-.5.8-1,.5-2,2.1-4.4,4.2-7,5.5l-.5-.5c.7-.8,1.7-2.3,2.5-3,0-.5.6-.8,1-.5,1.2-1.4,2.5-2.6,4-3.5,1.3-1.2,2.6-2.4,4-3.5.8-.6,1.7-1.1,2.5-1.5l.5-.5c.2-.5.9-1.1,1.5-1,.4-.7.9-1.2,1.5-1.5.5-.4,1-.6,1.5-1s1.3-1,2-1.5.7-.3,1-.5l1-1c.1,0,.4,0,.5,0l.5-.5c.3-.2.7-.3,1-.5l.5-.5h.5c-2.7,4.1-7.6,7.3-12,10l-1.5,1.5Z"
          fill="#daf6fa"
        />
        <path
          d="M103.8,58.4c-.5.4-1,.6-1.5,1l-.5.5c-.8.6-1.5,1.4-2.5,1.5,1.8-1.5,3.6-3.1,5.5-4.5l-1,1.5Z"
          fill="#bce9f7"
        />
        <path
          d="M95.3,64.9c-1.3,1.2-2.7,2.3-4,3.5-.4-.1-.4-.3,0-.5,1.5-.8,2.2-2.8,4-3Z"
          fill="#cbe8f4"
        />
        <path d="M103.8,58.4c.4-.4.6-1.1,1-1.5s.4,0,.5,0c-.3.3-.8,1-1.5,1.5Z" fill="#d1f3f9" />
        <path d="M91.3,67.9v.5c-.2.2-.8.3-1,.5h-.5c.3-.3.6-.6,1-1h.5Z" fill="#b9e4f4" />
        <path
          d="M178.3,20.9c.3.1.3.3,0,.5-1,.5-1.7,1.1-2.4,1.4s-1.7,0-2.1.2,0,.9,0,.9c.2.6.3,1.1-.2,1.3l-6.9,2.1c-1.6,1.6-3.1,2.2-4.5,1.6-6.1,2.5-12.3,5.2-18.6,8.1h-1.7s-.3-.6-.3-.6c3.2-1.8,6.3-3.6,9.3-5.4,0-.3,1.9-1.2,2.5-1.5,5.1-2.8,13.8-5.9,19.5-7.5,1.6-.4,3.6-.5,5-1.5.2,0,.5.2.5.5Z"
          fill="#cbf3f8"
        />
        <path
          d="M141.8,36.9c-.2.4-.3.4-.5,0-2.7,1.7-5.5,3.2-8.5,4.5-.1.4-.3.4-.5,0-1.6,2-4.1,2.8-6.5,3.5-3.4,2.6-7,5.3-11,7l.3.6-9.3,6.9c-1,1.6-3.7,3.5-5.5,3.5,1.1-2.5,3.8-3.1,5.5-4.3,3.5-2.5,5.3-4.5,8-7.2s2.6-2,4-3c0-.3.2-.5.5-.5.3-.2.7-.3,1-.5l.5-.5c.3-.2.7-.3,1-.5l.5-.5c.1,0,.4,0,.5,0,.2-.1.4-.4.5-.5,1-.5,2-1,3-1.5s.3-.4.5-.5c.1,0,.4,0,.5,0l.5-.5c.1,0,.4,0,.5,0,0-.3.2-.5.5-.5l.5-.5c.1,0,.4,0,.5,0l.5-.5c.2-.2.3-.4.5-.5.1,0,.4,0,.5,0,.2-.1.4-.4.5-.5.1,0,.4,0,.5,0,.3-.2.3-.3.5-.5.9-.5,1.9-.7,2.5-1.5.2,0,.3,0,.5,0,.5-.6,1-.8,1.5-.5l.5-.5c.2-.3.3-.3.5,0,0-.3.2-.5.5-.5.1,0,.4,0,.5,0l.5-.5c.1,0,.4,0,.5,0l.5-.5c.1,0,.4,0,.5,0l.5-.5c.1,0,.4,0,.5,0l.5-.5c.1,0,.4,0,.5,0l.5-.5c.1,0,.4,0,.5,0l.5-.5c.1,0,.4,0,.5,0l.5-.5c.1,0,.4,0,.5,0l.5-.5c.1,0,.4,0,.5,0l.5-.5c.1,0,.4,0,.5,0l.5-.5c.1,0,.4,0,.5,0l.5-.5c.2,0,.7,0,1,0l.5-.5h.5s.6,0,.5.2c-.4,1.2-8.2,4.5-9.5,5.7Z"
          fill="#d1f3f9"
        />
        <path d="M149.8,31.4l.5-.5c-.2.1-.3.4-.5.5Z" fill="#cbf3f8" />
        <path d="M148.3,31.9s.1-.4.5-.5l-.5.5Z" fill="#cbf3f8" />
        <path d="M147.3,32.4c0,0,.2-.4.5-.5l-.5.5Z" fill="#cbf3f8" />
        <path d="M146.3,32.9c0,0,.2-.4.5-.5l-.5.5Z" fill="#cbf3f8" />
        <path d="M145.3,33.4c0,0,.2-.4.5-.5l-.5.5Z" fill="#cbf3f8" />
        <path d="M144.3,33.9c0,0,.2-.4.5-.5l-.5.5Z" fill="#cbf3f8" />
        <path d="M143.3,34.4c0,0,.2-.4.5-.5l-.5.5Z" fill="#cbf3f8" />
        <path
          d="M137.3,36.9c.2.2.2.3,0,.5-.1,0-.3,0-.5,0l-.5.5c-.4.2-1.1.4-1.5.5.5-1.2,1.5-1.2,2.5-1.5Z"
          fill="#c1e9f7"
        />
        <path d="M137.3,37.4v-.5c.1,0,.4,0,.5,0-.2.2-.3.3-.5.5Z" fill="#c5f1f9" />
        <path d="M142.3,34.9c0,0,.2-.4.5-.5l-.5.5Z" fill="#cbf3f8" />
        <path d="M141.3,35.4c0,0,.2-.4.5-.5l-.5.5Z" fill="#cbf3f8" />
        <path d="M138.3,36.9c0,0,.2-.4.5-.5l-.5.5Z" fill="#cbf3f8" />
        <path d="M139.3,36.4c0,0,.2-.4.5-.5l-.5.5Z" fill="#cbf3f8" />
        <path d="M140.3,35.9c0,0,.2-.4.5-.5l-.5.5Z" fill="#cbf3f8" />
        <path
          d="M224.7,19.4c-4.6-1.4.9-2.4,3.4-2.1.2-1.8,1.3-2,2.8-2.3l.5-.8c14.2-1.3,28.6-.7,42.5.2,1.1,0,1.9.2,2.5,1.1,3.9-.3,8,0,12.2.9.8,0,1.7-.1,2.5,0,9.3,2.4,18.8,4,28,7h.5c.8.3,1.7.7,2.5,1l.5.5c.4.2,1.2-.2,1.5.5-1.1,0-5.1.3-5.5,1.3-.8,1.7,2.1,1.4,3.1,1.9s.8.9.8.9l-1.4.2c-31-10-63.9-12.6-96.6-10.2Z"
          fill="#fdfcfb"
        />
        <path d="M319.2,23.4h.5s0,.1-.5,0Z" fill="#fdfdfd" />
        <path d="M322.7,24.9c-.3-.1-.5-.5-.5-.5l.5.5Z" fill="#fdfdfd" />
        <path
          d="M288.2,14.4l2,.5c.2-.4.3-.4.5,0v.5c-1.2-.2-2.7.1-4,0l-1-.5c-.5,0-1,0-1.5,0l-2.5-.5c-.5,0-1,0-1.5,0l-1.5-.5c-1.2,0-2.3,0-3.5,0l-4.5-1.5c5.8,0,11.7.7,17.5,2Z"
          fill="#bcf0f7"
        />
        <path d="M284.2,14.9c-.8,0-2.1.3-2.5-.5,1,0,2.1.5,2.5.5Z" fill="#c2f1f7" />
        <path d="M280.2,14.4l-1.5-.5c1,0,1.4.5,1.5.5Z" fill="#c2f1f7" />
        <path d="M286.7,15.4l-1-.5c.9,0,.9.5,1,.5Z" fill="#c2f1f7" />
        <path
          d="M292.2,14.4c2.3.3.2.7-1.5.5s-.3,0-.5,0l-2-.5c-5.8-.6-11.6-1.4-17.5-2s-6.8-1-9.2-1h-24c-1,0-3.9.8-5.2,1-.5.9-.7,1-1,0l-1,.5c-.2.9-1.7.9-2,0l-1.5.5c-1,.8-3.7,1.2-4.5,0l-11.3,1.8c-.9-.4-.6-.8.8-1.3,16.5-2.1,30.2-4.1,47.3-3.5s22,2.7,33.2,4Z"
          fill="#a4e8f7"
        />
        <path
          d="M173.8,23.9c2.2-.3-.8,1.8,1.5,1.5-.2,0-.5.6-1,.7-4.3,1.6-8.6,3.5-13,4.8-.1-.3-.2-.6-.1-.6,1.2-.8,1.8,0-.9.3-6.1,3.2-12.6,6.2-19.1,9.1s-1.6.5-2.4.2c0-.7.5-1.4,1.5-2,.1-.4.5-.8,1-1,.1,0,.4,0,.5,0,4.8-2,9.5-3.8,14.3-5.9s4-2.7,5.6-3,1.8.5,2.3.4.5-1.1,1.1-1.4c2.7-1.8,6.7-1.5,8.7-3.1Z"
          fill="#c3f0f7"
        />
        <path
          d="M200.2,14.9c.9-.2,1.4,0,1.5.5.2,1.1-.8,1.3-1.5.5-.3.2-.3.3,0,.5.6-.4,1.1,0,1.5.5,2.6.5.7,1.3-1,1.5,0,.4-.3.4-.5,0l-.5.5c-.3,1-.7,1-1,0l-.5.5c-.6,1.4-1,1.3-1.5,0-1.9-.3-3.7.2-5.5,1.5-.1,1-.6,1-1,0-1.1-.3-1.4,0-1,.5,0,1.4-.5,1.3-1,0-.6-.3-.7-.1-.5.5-.1,1.3-.6,1.3-1,0l-1,.5c-.1.4-.3.4-.5,0l-.5.5c-.1.4-.3.4-.5,0-1.1-.4-2.1-.2-2.9.6-2,.5-3.9,1.1-5.6,1.9-.2.4-.3.4-.5,0-1.8.9-2,.3-1.5-1.5-.7.2-1.3-.2-.9-.9s4.9-1.8,5.4-1.6c.2-.2.2-.4,0-.5-.7.5-1,.2-.5-.5-.1,0-.3,0-.5,0,.2-.5.6-.4,1-.5.3.2.6.1,1,0,.3,0,.7,0,1,0l.5-.5c4.3-1.5,9.2-1.9,13.5-3.5.3,0,.7,0,1,0,.1-.3.3-.3.5,0q.8.3,0,0c-.3-.1-.3-.3,0-.5.2,0,.3,0,.5,0,.3-.3.7-.3,1,0,.1-.4.7-.3,1,0,.2-.2.5-.4,1-.5.2-.4.8-.4,1,0Z"
          fill="#c3f0f6"
        />
        <path
          d="M193.3,15.9c.3-.2.7-.2,1,0-1.2,1.7-3.2,2.5-5.9,2.3-2.7,1.2-5.3,1.5-7.6,1.2l-.5.5c-.2,1.3-.6,1.3-1,0h-.5c4.1-2,9.9-3.7,14.5-4Z"
          fill="#b3e8f5"
        />
        <path d="M179.3,19.9l-.7.5-.3-.5c.2,0,.3,0,.5,0s.3,0,.5,0Z" fill="#c3f0f7" />
        <path
          d="M200.7,14.4h.5c0,0-.5.7-1,.5-.3,0-.7,0-1,0-.4-.1-.4-.3,0-.5.4,0,1,0,1.5,0Z"
          fill="#b3e8f5"
        />
        <path
          d="M198.2,14.9c.4.1.4.3,0,.5-.3,0-.7,0-1,0-.4-.1-.4-.3,0-.5.3,0,.7,0,1,0Z"
          fill="#b3e8f5"
        />
        <path d="M197.2,14.9v.5c-.3,0-.7,0-1,0,.1-.5.6-.5,1-.5Z" fill="#a8ebf8" />
        <path d="M195.7,15.9c-.2,0-.3,0-.5,0v-.5h.5v.5Z" fill="#b3e8f5" />
        <path d="M180.3,19.9c.1-.2.3-.4.5-.5,0,.2-.3.5-.5.5Z" fill="#c3f0f7" />
        <path
          d="M191.3,20.9c.9-1.3.5-1.1-.8-1s-2.9.5-4.5.5-1.9.3-1.8-.5c1.8.5,3.2-1,4.7-1s2.2.6,3.4.5,3.4-2.1,4.3,0c-1.7.4-3.7,1.4-5.5,1.5Z"
          fill="#c3f0f7"
        />
        <path
          d="M184.3,22.9c-2.7.9-5.9,1.6-8.5,2.5,1.3-1.4-.7-.8-.5-1.2.8-1.5,2,.6,3.5.2l-1.5-2c.4-.4,2.7,1.2,3.7,1s.8-2.9,3.3-.5Z"
          fill="#c3f0f7"
        />
        <path d="M193.3,17.4c.6.4-2.5,1.6-3,.2l3-.2Z" fill="#c3f0f7" />
        <path d="M190.3,20.9c-.3.1-.7.5-1,.5-1.2-2,.5-.6,1-.5Z" fill="#c3f0f7" />
        <rect fill="#c3f0f7" height=".5" width="2" x="194.3" y="16.9" />
        <path d="M188.3,21.4c0,.2-.3.4-.5.5-1.2-2,.3-.5.5-.5Z" fill="#c3f0f7" />
        <path d="M199.2,14.9c0,.6-.6.4-1,.5v-.5c.3,0,.7,0,1,0Z" fill="#c3f0f7" />
        <path d="M195.7,15.9c.7,0,1.2-.2,1,.5-.4.2-.9-.5-1-.5Z" fill="#c3f0f7" />
        <path d="M200.2,15.9v.5c-.2-.1-1,.3-1-.2,0-.5.6-.1,1-.2Z" fill="#c3f0f7" />
        <path d="M186.8,21.9c0,0-.4.3-1,.5l1-.5Z" fill="#c3f0f7" />
        <path d="M184.5,21.4c.3.2.3.3,0,.5v-.5Z" fill="#c3f0f7" />
        <path d="M184.8,22.9l.5-.5s-.2.4-.5.5Z" fill="#c3f0f7" />
        <path d="M178.3,21.4v-.5l.5.2c0,.3-.4.2-.5.2Z" fill="#c3f0f7" />
        <path d="M198.2,19.4l.5-.5s0,.4-.5.5Z" fill="#c3f0f7" />
        <path d="M199.7,18.9c0-.2.3-.4.5-.5,0,.2-.3.5-.5.5Z" fill="#c3f0f7" />
        <path d="M198.5,15.9c.3.2.3.3,0,.5v-.5Z" fill="#c3f0f7" />
        <path
          d="M70.3,401.2c.9-1.1,2-.4,1.5,1,1.9.8,2.8,1.8,2.5,3l2.7,3.1c2.1,1.1,3.8,2.4,3.8,4.9,1.1.9,1.9,1.9,2.5,3-2.1.1-2,.7.2,1.6.4,2.1,1.5,3.9,3.3,5.4l.5,2c1.4-.7,3,1.3,2,2.5l-.5,1c-1.1-2-1.4-1.8-3.5-2.5-1.4-2.1-1.6-1.4-2.4-2.1s-1.2-3.8-1.9-4.8c-1.2-1.9-2.6-3.5-4-5.5s-3.8-3.4-2.7-5.5c-2.7.5-1.6-.7-2.5-1.8s-1.5-1.2-1.8-1.8-.2-1.5-.3-2.2-1-1.5.6-1.3Z"
          fill="#5081d9"
        />
        <path
          d="M51.8,373.2c3.4,2.7,6.6,7.3,7.5,11.5,2,.9,3.9,2.5,3.5,5,1.2.5,1.4,1,.5,1.5l-1-.5v3c-1.4-2.2-2-.8-2.5-1-.7.5-1,.3-.5-.5-4.7-4.2-7.1-9.2-8.7-15.3l.7-1.2c-2.3-1.2-1.7-5.1.5-2.5Z"
          fill="#5375c6"
        />
        <path
          d="M75.8,393.7l-.3.6c1.4,1,3.1,6.4,1.1,7,.2,3.9-2.7,3-4.8,1-.3-.4-1.2-.7-1.5-1-1.5-1.9-3.1-5-4.5-7l1.2-.3c3.7,3.1,4.7.3,4.4-3.4l.9-.8c1.3-.2,3.7,2.8,3.5,4Z"
          fill="#2c53cb"
        />
        <path
          d="M72.3,389.7c.8,5.8-1.6,8.8-6.5,4.5-.8-1.1-1.7-1.9-2.5-3s-.3-1.3-.5-1.5c1.2-.5,2.3-1.2,3.3-2.2,1.4-.2,2.3-1,2.7-2.3.1-.4.3-.4.5,0,1.2.2,3.5,3.4,3,4.5Z"
          fill="#294cc4"
        />
        <path
          d="M91.3,421.7c-1.1,1-2.4.7-1.9,2.2s1.3,1.1,1.6,1.9.4,2.1.7,2.7,1.4.2,1.8.8c.8,1.1.3,2.5,2.5,4s2.3-.4,1.3,2.5l1.5,1.5c-.4-.2-1.3-.1-1.7-.4-.7-.5-.4-1.9-1-2.4s-1.3-.4-1.9-.8c-2.7-2-3.1-3.4-4.9-5.8s-1.1-1.6-2-2.5c-.6-1.4-1.6-4.2,0-5,1.5.4,2.8.9,4,1.5Z"
          fill="#4f88e4"
        />
        <path
          d="M33.8,342.7c.8,0,1.7.7,2.5,2.5.9.3.9.7,0,1-2.3-.3-3.1.7-2.5,3,.5,2.8,1.4,5.5,2.7,8,1.5,1.8,3.5,4.9,4.4,7.1s2.4,6.1,1.4,7.9c-1.4.4-.4,1.8,0,3-1.3-.8-1.4-2.5-2-3.5-1.2-5.7-7.4-12.3-8.4-17.9s0-3-.1-4.4-1.5-2.4-1.4-3.9,1.2-1.1,1.7-1.5.6-1.5,1.7-1.3Z"
          fill="#4d619d"
        />
        <path
          d="M45.3,374.7c.8-1.5,2.9,1.5,3.5,2.5,1.1.7,2.7,3.3,3.5,4.7s.5,1.8.5,2.8c1.4.5,3.2,3.5,3,4.9,2.3,2.1,3.3,4.6,3.1,7.6,1.8,1.7,2.2,3,1.4,3.9-1.2-1.5-2.3-3-3.5-4.5-.8-3.5-3.6-6.3-5.4-9.3s-3.6-7.8-5.6-10.6c-.5-.7-.7-1.4-.5-2Z"
          fill="#4b68b1"
        />
        <path
          d="M33.8,349.2l1.2.2c1.7,4.4,3.8,8.7,6.3,12.8l1.4,1.2c.7,1.6,3.3,9.4,3.1,10.3s-.3.6-.4.9c.2.7.3,1.3.5,2-.6-.9-3.1-3.7-3.5-4.5-1.3-2.7-1-6-3-8.8s-1-2-2.1-4.4-1.2-.7-1.5-1.5c-1-2-1.8-6.1-1.8-8.4Z"
          fill="#5166a6"
        />
        <path
          d="M55.8,389.7c1.1-.4,2.3.5,3.5,2.5.4.1.5.5.5.5,0,4,3.2,7.1,3.8,11l12.2,15.5c-1.1-1.1-3-2.4-4-3.5-4.1-4.5-7.7-9.7-11.5-14.5-.1-1.5-2-2.5-2.4-3.9s0-2.5-.2-3.8-2.1-2.1-1.9-3.8Z"
          fill="#486dbb"
        />
        <path
          d="M32.3,336.7c1.2,0,1.6,1.8,1.5,3,1.8,0,3.8,4.2,2.5,5.5-1.1-.6-1.5-1.6-2.5-2.5-1.4-1.3-2.7-1.6-4.5-2.5h.5c-.3-2.3.2-3.6,1.5-4,.6-1,.9-.5,1,.5Z"
          fill="#374092"
        />
        <path
          d="M15.9,309.8c1.6,2.5,1.7,5.9,3.3,8.5s1.4.8,1.7,1.4c.6,1,.3,4.3,1.3,6.1s3.1,3.2,3.7,5c-.1.7-.3,1.3-1,1-.9-1.9-1.9-2.3-2.8-3.1s-.6-2.4-1.7-2.9c-1.6-5.4-3.1-10.6-4.5-16Z"
          fill="#343179"
        />
        <path
          d="M25.9,330.7c.7,0,1.3,0,2,0,1.5.3,4.5,4.1,3.5,5.5,0,.8-1,2.8-.5,4h-1s-5-8.5-5-8.5c.2-1-.4-.9,1-1Z"
          fill="#353a82"
        />
        <path
          d="M18.4,191.3c.4.2.4.3,0,.5l-.5.5c.9,0,.7,1.1,0,1.5l-.5.5c.2.5.3.9.2,1.4-1.7,7.2-3.7,14.8-5.9,21.7-.6.2-.9-.3-.8-1.6,0-.5,0-1,0-1.5l.5-2.5c.3-2.6,1.1-5,1.5-7.5q.7,0,0,0c.2-1.3.5-3.3.5-4.5l4.5-15c-.4,1.6-1.1,3.3-1.4,4.9s-.5,1.8.4,1.6c2.3-5.4,3.5-11.4,6-16.5l.8.7c-1.4,5.2-3.4,10.6-5.3,15.7Z"
          fill="#98a3d9"
        />
        <path
          d="M12.4,218.3c-1,2.2-1.5,4.6-1.9,7-.5,1.2-1.5.7-1.1-.5.1-3,1.1-6,1.5-9l.5,1.2c.2-.6.5-1.2.6-1.9,1.9-6.9,3.2-14.1,5.4-20.9l.5-.5c.1-.4-.1-1.1,0-1.5l.5-.5c0-.1,0-.4,0-.5.5-2.2,1.3-3.8,2.5-5v2.1c-2.8,10-5.7,19.9-8.5,29.8Z"
          fill="#838ed3"
        />
        <path
          d="M12.4,219.3c.4.2.4.3,0,.5l-.5.5c.3.2.5.4.5.6-.5,4-1.7,10-3.2,13.7s-.4.2-.8.2c0-3.4.5-6.7.5-10h.5l.5.5c.8-2.2.8-5.3,2.5-7,.2.3.2.6,0,1Z"
          fill="#6b7ac7"
        />
        <path d="M10.9,214.3c0-.8-.3-2.1.5-2.5,0,.8.3,2.1-.5,2.5Z" fill="#838ed3" />
        <path
          d="M21.4,313.8h.6c1,2.7,2.2,5.1,3.3,7,2.5,1.5,3.9,4.1,4.3,7.8l1,2.2c1.8,1.1,3.2,4.5,1.7,5.9-.3-.4-.5-.5-1-.5,0-1.4-2.6-4.1-3.5-5.5-1.7-2.9-2.2-6.2-3.9-9.3s-3.4-2.1-4.6-7.2l2-.5Z"
          fill="#34348b"
        />
        <path
          d="M11.4,275.3c.4,4.8,1.9,9,4.5,12.7.6,4.4,1.6,8.7,3.1,12.8l-.6.5c-1.4.5-2.3-1.7-2.5-3-.3-.5-1.1-1.8-1.5-2.4-1.9-3-4.4-21.9-5-26.6,2.3,1.1,1.7,3.8,2,6Z"
          fill="#303696"
        />
        <path
          d="M12.9,222.3l-2.4,13.1c-.3,2.1-.9,3.6-2.1,4.4-.3-1.2-.3-2.6,0-4,0-.3,0-.7,0-1,2.4-4.4,2.6-9.8,3.5-14.5l.5-.5c0-.2,0-.3,0-.5,0-1,.4-1.7,1-2,1.4.8,1.1,4.6-.5,5Z"
          fill="#5a70cd"
        />
        <path
          d="M8.4,239.8c.3,0,.5,0,.6.2.2.4-.8,1.3.4-1.1s.6-.2,1,0c.7,2,.2,4-1.5,6-.2.9.6,1.8-1,1.5,0-3.4-.4-7.3.5-10.5,0,1.3,0,2.7,0,4Z"
          fill="#4861c5"
        />
        <path
          d="M16.9,283.8c1.8.2,2.1,2.2,1.9,3.7,1.3,3.8,3,7.4,5.1,10.8,1.5,0,1.9,2.5.5,3l.5.7c-.2,2.7.3,5.1,1.6,7.1,0,2.8,1.3,5.3,2.8,7.7,1.3,1.8,2.1,4.1,2.5,6.7,1.7.7,4.5,8.3,3.7,9s-.4.2-.7.3c-.9-.7-2.3-3.2-3-4.5s-1.8-4.1-2.1-6c-3.4-4.1-6.2-9.2-7-14.5-4-5.6-6.1-12.6-6.9-19.5-1-1.6-1.2-2.9-.6-4l1.5-.5Z"
          fill="#3136a7"
        />
        <path
          d="M9.4,261.3c.9,1.9,2.8.8,4,2.4s1.1,5.6,2.5,7.1c.8.3,1.3,1.1,1.3,2.4,1.2,1.6,5,10.7,4.7,12.1s-.3.4-.5.5c-.5.2-1.1-.2-2-1-2,.3-3.2-1.6-2.8-3.5l-.7-2c-.5-.8-2.4-2.7-2.4-2.8-.2-.7.6-3.4.3-4.3s-1.4-1-1.7-1.5c-.9-1.4-2.3-7.5-2.6-9.4Z"
          fill="#303eb2"
        />
        <path
          d="M11.4,275.3c.4,1.7,1.3,3.3,1.9,4.9s0,2,.5,3,1.6.9,1.7,1.1c1.7,3.2,2.1,9.2,3.5,13.3s2.8,6.8,4,10.2c.3,2.3,1.1,4.7,2.2,7.1l-.7.9c-.2.2-.4.3-.6.4-1,.4-3.5-7.3-3.1-8.8-1.1-.6-1.3-1.3-.8-2.1,0-.7-.3-1.2-1-1.5-.4-.1-.4-.3,0-.5l-.5-.5c-1,0-1.1-1.3,0-1.5-.4-3-1.8-4.3-2.4-6.4s-.3-4.7-.8-6.7-2.2-2.4-2.6-3.8c-.9-2.9-.8-6.1-1.2-9.1Z"
          fill="#2f359c"
        />
        <path
          d="M15.9,279.3c.3.5,1.5,1.7,1.5,1.9,0,.5-.5,2.2,0,2.6s1.5-.2,1.9,0,0,.8,0,.9c.9-.2,1.4,1.2,1.4,2.1.9,3.2,2.2,7,3.6,10.5s-.1.6-.5.9c-2.2.1-1.7-2.5-2.1-2.9-1-1-.4.3-1.9-2.2-2.4-3.9-1.2-6.1-3-9.3s-.9-.4-1-.9c-.2-1.1.1-2.5,0-3.6Z"
          fill="#3239ad"
        />
        <path
          d="M15.4,263.8c0,1.3.6,2,1.5,2.1,2.2,4.5,3.6,9.3,4.7,14.1,1.3,1.3,1.7,2.4,1.2,3.3,1.4,2.2,2.1,6.9,1.5,9.5-1,.6-1.3-.5-1.5-1.5-1-.6-3-4.6-1.5-5.5l-2.6-7.9h-1.4c1.6-2.8-.1-2.6-.7-3.6-1-1.5-.7-1.9-.8-3.5s0-2.5-.3-3.5c-.4-1.8-2.9-4.7-1.2-6,1.4-.2,1.9,1.6,1,2.5Z"
          fill="#3141bb"
        />
        <path
          d="M9.9,249.3l1.2-.6c2,.3,8.2,14.1,6.3,16.6.1,2.6-1.9.2-2-1.5-.6-1-.7-1.4-1-2.5-.8-3.2-2-2.7-3.9-5.4s0-2.2-2.1-2.6c1.5-.8,1.4-2.5,1.5-4Z"
          fill="#344ac0"
        />
        <path
          d="M9.9,244.8c-.9-4.6,3.4-4,5-.5,1.2-.8,3.3,2.6,3.7,3.6s.2,4.3-.2,4.9l.7.6c1.9,6.8,3.5,13.6,4.8,20.4l-.5.5h-1.1c-.3-.5-4-7.6-3.8-8s.3-.3.4-.5c-1.1-1.2-1.6-3.1-1.4-5.5-1-1.3-1.5-3-1.4-5.1l-3.4-5.3c-1.2-1-2.1-2.4-2.7-4,0-.3,0-.7,0-1Z"
          fill="#3753ce"
        />
        <path
          d="M9.9,245.8c1.9-.2,1.8,2.3,2.5,2.8s1.3-.5,1.5-.3-.5,1-.2,1.5c.6,1.1,3,3.9,3.5,5.5s-.2,2.1,0,3.1,1.1.8,1.2,1.3c.4,1.9-.2,3.7.5,6.1-.2,1.3-.6,1.3-1,0-.6.3-.9.1-.5-.5-.7-1.1-.3-2.4-.6-3.6-.5-1.8-3.8-9.5-4.9-11.1s-1.1-1-1.9-1.3c.1-1.1,0-2.3,0-3.5Z"
          fill="#354dc7"
        />
        <path
          d="M11.4,235.3c1.1-2.3,3.4.9,1,1.5,3.2,2.9,4.1,5.4,2.5,7.5,0,0-.5,0-.8-.2-1.8-1.5-3.7-3.1-4.2.7h-1c.5-2,1-4,1.5-6-1-1-.4-3.3,1-3.5Z"
          fill="#3a5cce"
        />
        <path
          d="M402.1,430.7c.1,1-2.9,6.7-3.7,7.5-1.4,1.5-3.8,1.6-5.3,3.2s-1,3.5-3.5,3.3l1,1c-1,.8-2.9,1.7-3.8,2.5s-1.1,1.7-1.8,2.2c-1.3,1-3.5,1.7-4.5,3.3-2.6,1.5-4.6,3.7-7.5,4.5-1.1-.3-1.2-.9-.4-1.7l5.3-2.8-.3-1c.9-1.2,2-2.2,3.4-3,.6-.3,1.1-.6,1.5-1-.1-.5,0-.6.5-.5.3-.6.7-.8,1-.5,0-1.6.9-2.9,2.5-3v-1.5c4.9-4.1,9.1-8.8,12.6-14l1.4-.6c1.5-1.3,2.2.7,1.5,2Z"
          fill="#4773d1"
        />
        <path
          d="M418.1,401.7c.6.9.3,2.3-.8,4.1,1.6,1.4,1.4,3.2-.6,5.4l.3,3.8c-1.1,1.4-1.2,2.4-.4,3.2.9,1.3-.6,3-2,2.5-1.1.9-2.5,2-3.5,3-1.1.8-2-.9-2.1-1.9,1.9-4.7,3.2-9.6,3.6-14.6,1.2-1.9,3.7-4.4,5.5-5.5Z"
          fill="#2e4dc1"
        />
        <path
          d="M420.1,414.7c1.5-.2,1.1.6.8,1.5-1.4,4.2-4.4,6.1-7,8.9s-2.1,4.1-4.7,5c-.3,1.7-2.7,1.5-1.5-.5,2.2-2.7,5-6.2,7-9s1.4-1.6,2-2.5c.2-.4.3-.4.5,0l2-2c-1-1-.4-1.8,1-1.5Z"
          fill="#516ebb"
        />
        <path
          d="M412.6,407.2c1.5,1.4.3,2.4.1,3.9s.3,1.4.1,2.1c-.6,3.4-2.2,5.3-3.3,8.2s.4.4.7.4c.6-.1,0,1.7.7,1.9-.9.8-1.5,1.6-2.5,2.5-1.3.4-1.5-.4-1.6-1.7,1.3-4.6,2.6-9.6,2.4-14.1l-.3-.7c-.2-1,1.4-2.9,2.5-2.5.5-.4.9-.4,1,0Z"
          fill="#3252c6"
        />
        <path
          d="M409.1,409.7h1.5c-.9,2.7-.6,6.1-1,8.7s-2.8,5.1-1,7.8c-.3.3-.6.6-1,1-4.5,2.9-3.2-1.3-1.6-4.3.8-3.1,1.8-7.4,2.2-10.6s-.3,0-.6,0c-.4,1.2-.9,1.7-1.5,1.5-.3.7-.8,1.2-1.5,1.5,0,.8-1.3,2.2-2,1.5-.7-.5.4-1.2,1-1.5s-1.3,1.5-1.5.5c.3-2.3,2.9-3.8,5-4.5.1-.9,1.1-1.8,2-1.5Z"
          fill="#3658cc"
        />
        <path
          d="M407.6,412.2c.3-.3.7-1.7,1.5-.7-1.5,4.9-1.3,10.3-3.9,14.9.4,2,.9,1.2,2.4.8-1.6,1.3-2.8,2.7-5,3.5l-.6-1.4c2-5.1,3.5-10.2,4.6-15.5l.9-1.6Z"
          fill="#3c61ce"
        />
        <path
          d="M402.6,430.7h-.5c0-.6-.8-1.7-1.5-2l-.6-1.1c2.5-4.5,4.5-9.1,6.1-13.8.5-.5.9-.9,1.5-1.5l-2.2,10.6c-1.3,2.4-2.3,5.1-2.8,7.8Z"
          fill="#436bd7"
        />
        <path
          d="M409.1,430.2c.9,1.1,0,.9-.5,1.5-2,2.2-4.5,4.6-6,6.2s-6.8,5-9,6.8c.8-1.2,1.9-2.3,3-3.3,4.3-3.8,7.5-7.5,11-11.7.6,1.4.7.8,1.5.5Z"
          fill="#4868bb"
        />
        <path
          d="M373.1,449.2c1.6,0,1.1,1.1-1.5,3,2.1,2.1-3.4,3.7-5,4-3.5,1.3-6.1,4.3-8.3,7.2-1.7-.3-3.3.7-4.8,2.9-4.6,1.1-8.5,3.8-11.7,7.2-2.5.3-4.5,1.4-6.8,2.7-.1.4-.3.4-.5,0-2.7,1.1-5.3,2.2-8,3.5h-.5c-.6.2-1.1.5-1.5,1-.2,0-.7,0-1,0l-.5.5c-.3,0-.7,0-1,0-2.2.4-4.2,1.1-6,2-.2,0-.3,0-.5,0-.1.2-.3.2-.5,0l-1,.5c-.2,0-.3,0-.5,0-.6-.8-.1-1.5,1.5-2l.7-1.3c4.5-1.5,8.7-3.6,12.8-6.2l10.8-4.3c2.4-2,4.8-3.8,7.6-5,1.3-1.2,2.8-2.1,4.5-2.9,3.4-.5,5-2.4,7-5l12.5-7.3c.5-.7,1.7-1.5,2-.5Z"
          fill="#4a8ced"
        />
        <path
          d="M366.6,456.2v1.1c-1.5,1.4-3.2,2.7-5,3.9,1.1.2-2.4,4.3-2.6,4.4-5.3,1.9-10.5,4.8-15.4,7.6-.1.4-.3.4-.5,0l-1,1c-.3,0-.7,0-1,0l-2,1c-.2,0-.3,0-.5,0l-1.5.5c-.2,0-.3,0-.5,0l-.5.5c-.2,0-.3,0-.5,0-.1.3-.3.3-.5,0,.6-1.3,1.9-1.6,3-2.3s.4-1,.6-1.1c.9-.5,2.1.7,2.9.2s.7-1.2,1.3-1.7c1.3-1,4.3-3.7,5-4.1,1.1-.7,3.8-1,5.1-1.8s2.2-2.6,3.1-3,1.7.3,2,0,.5-1.4,1.3-2.2c1.2-1.2,5.5-4.5,7.2-4.1Z"
          fill="#4885e7"
        />
        <path
          d="M303.7,484.7l1.5.5c.7.3.6.5,0,1-.6.1-1.4,0-2,0l-.5.5c-.5,0-1,0-1.5,0-.8.3-1.5.3-2,0-.8-.1-1.8-.8-1.1-1.3s5.7-2.3,5.6-.7Z"
          fill="#498eec"
        />
        <path
          d="M315.2,481.7c-.5.6-1,1.6-1.5,2h-.5l-.5.5c-.2,0-.3,0-.5,0-1,.2-2,.3-3,.5l-1.5.5c-.2,0-.4,0-.5,0l-.5.5c-.2,0-.3,0-.5,0-.5.1-.9,0-1-.5-.7,0-.9,0-.5-.5l.2-1.1c3.1-.9,6.1-1.8,9.2-2.7l1.1.8Z"
          fill="#498eec"
        />
        <path
          d="M334.7,476.2c.6.2.4.5-.5,1-.1,0-.3,0-.5,0l-1,.5c-.2,0-.4,0-.5,0l-.5.5c-.1,0-.4,0-.5,0l-.5.5c-.4.1-1.1-.1-1.5,0l-.5.5c-.2,0-.4,0-.5,0l-1,.5c-.2,0-.3,0-.5,0,2.4-2.6,4.1-2.4,8-3.5Z"
          fill="#4885e7"
        />
        <path
          d="M322.2,481.2c-.8,1-2,.7-3,1l-.5.5c-.5,0-1,0-1.5,0l-.5.5c-.2,0-.3,0-.5,0,1.2-1.9,4.3-1.6,6-2Z"
          fill="#4885e7"
        />
        <path d="M326.2,479.7c.2.2.2.3,0,.5-.1,0-1.1.4-1.5.5-.2-1.5.4-.9,1.5-1Z" fill="#4885e7" />
        <path d="M335.7,476.2c-.2.9-.8.8-1.5,1l.5-1c.2,0,.3,0,.5,0s.3,0,.5,0Z" fill="#467fdf" />
        <path d="M338.7,475.2l-1.5.5c.3,0,.9-.3,1.5-.5Z" fill="#467fdf" />
        <path d="M341.2,474.2c-.3,0-1,.7-2,1l2-1Z" fill="#467fdf" />
        <path d="M333.7,477.2c-.2.5-.6.4-1,.5.2-.5.6-.4,1-.5Z" fill="#467fdf" />
        <path d="M328.2,479.2c-.2.5-.6.5-1,.5.2-.5.6-.4,1-.5Z" fill="#467fdf" />
        <path d="M315.2,483.2c.2.2.2.3,0,.5-.3,0-.7,0-1,0,.2-.5.6-.4,1-.5Z" fill="#4885e7" />
        <path d="M336.2,476.2s.1-.4.5-.5l-.5.5Z" fill="#467fdf" />
        <path d="M331.7,478.2l.5-.5c0,0-.2.4-.5.5Z" fill="#467fdf" />
        <path d="M330.7,478.7l.5-.5s0,.4-.5.5Z" fill="#467fdf" />
        <path d="M328.7,479.2l.5-.5s-.2.4-.5.5Z" fill="#467fdf" />
        <path d="M326.2,480.2v-.5c.2,0,.3,0,.5,0-.2.2-.2.3-.5.5Z" fill="#467fdf" />
        <path d="M323.2,481.2s.1-.4.5-.5l-.5.5Z" fill="#4885e7" />
        <path d="M318.7,482.7c0-.2.3-.4.5-.5,0,.2-.3.5-.5.5Z" fill="#467fdf" />
        <path d="M316.7,483.2c0-.2.3-.5.5-.5,0,.2-.3.4-.5.5Z" fill="#467fdf" />
        <path d="M315.2,483.7v-.5c.2,0,.3,0,.5,0,0,.2-.3.5-.5.5Z" fill="#467fdf" />
        <path d="M313.2,484.2c-.1,0-.3,0-.5,0,0-.2.3-.4.5-.5.2.2.2.3,0,.5Z" fill="#4885e7" />
        <path d="M313.2,484.2v-.5c.1,0,.3,0,.5,0-.2.1-.2.4-.5.5Z" fill="#467fdf" />
        <path
          d="M385.1,443.2c1,0,1.2.6,1.5,1.5-1.1,1.2-.3,1.2-2.5,3-.4,0-.7,0-1,.5-.2.2-.3.3-.5.5-.2.5-.7.8-1.5,1-.2.4.2,1.1-.5,1.8s-2,.7-2,.8.8,1.5.5,2-4.9,2.3-5.7,3-.3,1-.3,1c-.2.1-.3.4-.5.5-3.1,0-4.9,2.7-7.5,4.3s-4.8,3-6.5,3.7c-1-1-.6-1.2.7-1.4.8-1.9,3-3.6,4.8-4.6-.3-.9.1-1.5.9-2.1,7.4-4.3,13.8-8.7,18.9-15.5h1.2Z"
          fill="#477cdb"
        />
        <path
          d="M364.1,460.7c-.7.7-1.2,1.9-1.5,2.3-.8,1.1-3.4,2.2-4,3.7-.1,0-.4,0-.5,0-4.5,2.1-9,4.3-13.5,6.5-.1,0-.3,0-.5,0h-.5c.3-1.9,1.7-1.4,3.1-2.1s3.6-2.4,5.8-3.3,4.4-1.4,4.6-1.5-.7-1.3-.5-1.5c.4-.3,2.3.7,2.5.5s-.1-1.2.1-1.9,2-1.6,2.4-2.1c1.2-1.2,2.1-1.4,2.5-.5Z"
          fill="#467fdf"
        />
        <path
          d="M358.2,466.7c-4.3,2.5-8.8,4.8-13.5,6.5l11.5-6.2c.5-.5,1.6-.1,2-.3Z"
          fill="#477cdb"
        />
        <path
          d="M344.2,473.2c-.4.5-.9.8-1.5,1-.2-.2,0-.6.5-1,.1,0,.3,0,.5,0s.4,0,.5,0Z"
          fill="#477cdb"
        />
        <path d="M342.7,474.2c-.2,0-.4,0-.5,0,.2-.5.5-.8,1-1l-.5,1Z" fill="#467fdf" />
        <path
          d="M424.6,394.2c1.3-.2,1.4.7.5,1.5l.2,1.1c-4.1,1.4-3.4,9.5-2.9,13.1l1.2-.2c.6-1.3,1.3-2,2-2-1.9,2.5-3.4,4.6-5.5,7s-.6,1-1,1.5l-2,2c-.1,0-.3,0-.5,0-3.7.3-.7-2.7-.6-3.3s-.6-2.2-.3-3.8,1.9-2.5,1.9-3.6-1.5-.4-1.3-2,1.4-2.7,1.8-3.8c-.2-.3,0-.8.5-1.5.9-2.6,3.6-5.2,6-6.5v.5Z"
          fill="#2c47b9"
        />
        <path
          d="M434.1,397.2c-1.5,2.1-2.9,4-4.5,6s-1.6,2-2.5,3l-1.5,1.5c-.6.7-1.1,1.6-2,2-.8-1.1,0-5.6.6-6.9s1.9-3,2.9-3.6c-.2-1.6.8-1.9,1.5-.5.4-.6,1-.5,1.7.3.9-1.8,2.2-3.3,3.5-4.8h1.3c.3-.4,1.2-.6,1.5-1,1.1,1.3-.8,4.3-2.5,4Z"
          fill="#293fac"
        />
        <path d="M425.6,407.7c.5-.6,1.1-1.1,1.5-1.5-.1.8-1.2,1.1-1.5,1.5Z" fill="#2942b3" />
        <path
          d="M447.6,377.2c1.8-.2.6.6.7,1.4,0,5.2-1.9,3-2.9,4.6s-1.4,5.9-1.7,7c-1.2,3.7-.8,1.5-2.8,3.5s-3.9,8.6-7.7,10c0,0-.6-.6-.2-1s2.2-2.1,2.2-2.3c0-.3-.1-3.1-1-3.2,1-1.4,1.8-2.5,2.5-4l.5-.5c1.9-2.2,3.4-4.6,5-7,.6-1.5,1.3-2.9,2.5-4,1-1.5,2.1-3.1,3-4.5Z"
          fill="#5163a4"
        />
        <path d="M461.6,366.2c.4-.6.9-1.2,1-1.5l-1,1.5Z" fill="#485587" />
        <path d="M463.6,362.2c.1-.3.5-.4.5-.5l-.5.5Z" fill="#485587" />
        <path d="M463.1,363.2c.1-.3.5-.4.5-.5l-.5.5Z" fill="#485587" />
        <path d="M462.6,364.2c.2-.3.5-.4.5-.5l-.5.5Z" fill="#485587" />
        <path
          d="M301.2,486.7c-1.3.6-2.6.8-4,1v-1c.4-1.4,1.1-1,2,0,.8-.1,1.6,0,2,0Z"
          fill="#4a8ced"
        />
        <path d="M306.2,485.7c-.3,0-.7.4-1,.5,0-.3,0-.8,0-1,.4,0,.7.2,1,.5Z" fill="#4a8ced" />
        <path d="M304.7,484.7c.4.2.3.2.5.5-1.1,0-1.7,1.3-1.5-.5,0-1.3.6-1.3,1,0Z" fill="#4a8ced" />
        <path d="M309.2,484.7l-1.5.5c.6-.2.6-.3,1.5-.5Z" fill="#4a8ced" />
        <path d="M296.7,487.7c-.2.5-.6.4-1,.5.2-.5.6-.4,1-.5Z" fill="#4a8ced" />
        <path d="M306.7,485.7c0-.3.3-.4.5-.5,0,.4-.2.4-.5.5Z" fill="#4a8ced" />
        <path d="M302.7,486.7s.1-.4.5-.5l-.5.5Z" fill="#4a8ced" />
        <path
          d="M123.8,449.7c.2-1.5,1.3-1.4,3.5.5.2-.5.5-.6.9-.4,2.6,1.3,5.1,2.8,7.1,4.9.7.6,1.1.5,1.8,0,1.2.2,5.4,3.1,5.7,4.2,4.5,2.5,9.1,4.7,13.8,6.7l1.4,1.4c5.9,2.3,11.7,4.8,17.3,7.5,3.1,0,6.5,1.7,8.9,3.8,1.9,0,5.6,1.6,6.6,3.2v1c-2.5-.6-7.6-1.4-9.5-2.2-3.1-1.4-1.8-3.1-2-3.2-.4-.2-3.5.5-5.6-.5s-4.5-3-6-3.8-3.1-.2-4.2-.5-3.8-3.1-4.6-2.5.2,1.2-.8.9c-2.4-3.9-6.6-4.5-10.1-6.4s-7.2-4.4-10.3-6.5-4.4-1.2-5.9-2.1c-1,.4-7.7-4.7-7.9-5.1s-.1-.6-.1-.9Z"
          fill="#4e9cf7"
        />
        <path
          d="M305.7,479.7c2-.4,4-.7,6.1-.8,5.2-3,10.7-5.6,16.4-7.6,4.4-2.8,8.9-5.2,13.7-7.2.5.3.9.7,1.3,1.1.5.2.7.5.9.9.8,1.8-25.1,12.3-27,12.8-3,2.3-6.2,3.4-9.5,3.2-1.6,1.3-3.2,1.7-5,1.2-1.1,1.2-2.2,1.7-3.3,1.3l-2.9.2c-4.3,2.7-9.3,3.7-14.4,2.9-8.1,1.5-16.6,3-25,2.2-4.6.8-9,.7-13.1-.2-.5-.3-1-.3-1.5,0-.4,1.2-1.8.8-2.5,0-.7-.4-2.2-.8-3-1,3.8-1.1,8.4.6,12.2.5s11.2-1.3,16-1.5,4,.6,5.4.5.3-.9.6-1c4.1-.9,9.9-2.6,13.9-2.8,6.3-.2,11-.5,17.2-3.2.8-1,2.3-2.3,3.5-1.5Z"
          fill="#4d99f6"
        />
        <path
          d="M299.2,484.7c-.2.8-1,1.3-2.6,1.4l-1.4,1.1c-1,.2-1.7,0-2.5.2-9.3,2-19.3,2.7-29,3s-2.9.9-4.3.8-.7-1-1-1.1c-3.8-.2-10.4,1.8-15.5,1.6s-2.7-1.5-5.2-1.5c.6-.6,1.3-.5,2-.5s1.7,0,2.5,0c.5-.3,1-.3,1.5,0,8,0,16.1,0,23.9-.3s6.7-1.3,9.7-1.9c4.7-.9,4.8-1.3,9.2,0s8.7-5,12.7-2.8Z"
          fill="#4b94f1"
        />
        <path
          d="M110.8,440.2c.3-.3.6-.8.9-.7,3.1,1,6.6,3.1,7.3,6.5,1.3-.4,2.3.2,2.5,1.6,1.6.3,2.4,1.1,2.3,2.2,3,1.9,5.5,4.4,8,6,.2.3.3.7.5,1-2.6.5-4.5-2.8-6.2-3.8s-2.8-.9-5.1-2.7-7.8-4.9-10.1-7.2,0-1.7-2.1-2.3-2.9.9-3.5-2.5c1.7-1.1,4.1.8,5.5,2Z"
          fill="#4c95f3"
        />
        <path
          d="M93.8,413.2c1.3.4,1.8,1.5,1.5,3.3l.7,4.9.7,3.8.3,1.2c3.2,3.9,7.3,7.2,11.9,9.8,1.9,1.7,2.5,3,1.8,4-1.5-.3-3.8-.9-5.5-2s-4.5-3.3-4.7-3.5c-.7-.7-.6-2.4-1.2-2.8s-1.9,0-2.5-.5-3.2-4.8-3.3-5.1c-1.2-2.8.8-4.2.9-6.9s-1.4-4-.5-6.2Z"
          fill="#5294f3"
        />
        <path
          d="M93.8,411.7c1.1-.6,3.1,1.8,2.5,3,.6.8.5.9-.5,1,.4,2.4,1.2,4.6,2.5,6.4,4,4.2,8.4,8,13.1,11.6l.4,1.5c1.1,1,1.1,1.9-.5,2-.8.7-1.8,0-3.2-1.8l-5.2-3.1c-2.1-1.7-5.4-4.8-6.1-7.1-1.2-1.4-1.4-.4-1.5-.5-.7-1,.5-8.3-1.5-11.5s-.7-.7-1-1c-.4-.1-.4-.3,0-.5,0-1.2.4-.9,1,0Z"
          fill="#599ef7"
        />
        <path
          d="M92.8,411.7c0,.1,0,.3,0,.5.1,1.2-.5,2.6-.4,3.8.4,2.9,2.2,2.7-1.1,5.6-1.7.2-2.7-.6-4-1.5-1.4,1.2-4.6-2.5-4-4-.8-1-1.7-2-2.5-3,1.5-.8,5.5,2.9,5,4.5,1.4.7,2.8,1.4,4.2,2-.3-2.6-.3-5.2-.2-7.7-2-1.9-2.5-3.3-1.5-4.3,1.4-.2,4.4,2.6,4.5,4Z"
          fill="#4279e3"
        />
        <path
          d="M371.1,449.2c.3.1.3.3,0,.5-3.1,3.3-8,5.9-11.9,8.1s-2.7,3.3-3.4,3.8c-1.3.8-3.3.8-4.4,1.6s-.7,1.3-.9,1.4c-.4.2-1.2-.6-1.9-.2s-.4,1-.9,1.3c-1.1.7-2.9,1.2-3.9,2s-2.5,2.3-3.5,2.9c-3.5,2.1-8.6,2.7-11.6,4.5-4.9,3.1-7.6,4.7-13.6,6.5s-2.2.2-3.2.6l-7.3,2.4c-.2,0-.7,0-1,0-1.8-.1-3.2,1.3-5.2,1l.7,1c-.6,0-1.4,0-2,0s-1.4.4-2,.5c.1-2.5,2.7-1.9,4-2.5s2.5-2.1,3-2.2c.6-.2,1.6.4,2.6.1s1.4-1.3,2.7-1.4,2.1.6,2.9.4,5.1-3.1,6.4-3.6c4.8-2,10.3-3.9,14.8-5.9s6.4-3.1,10.1-5.1,1.6-.5,1.5-1.7c.2-.8.9-1.1,1.9-1,5-4.4,13.2-10,19.3-12.6s1.8-.5,2.7-.4c1.3-2,2.6-2.6,4-2Z"
          fill="#4c92f3"
        />
        <path d="M481.6,183.8l-.5-1c.3.4.3.4.5,1Z" fill="#adb9e5" />
        <path
          d="M473.1,164.3l.5.5c.9,1.4,1.4,3,2,4.5l.5.5c0,.1,0,.3,0,.5s0,.3,0,.5l-1-.7c1.3,5.4,3.5,10.4,5,15.7l.5.5c0,.2,0,.3,0,.5.2,2-.3,1.7-1.5,3-2-.8-3.8-6-3-8-2.7-3-4-6.4-4-10-1.9-1.4-2.6-2.9-2-4.5,1.7-.6,2.2-1.5,1.7-2.7l.8-.8h.5c0,.1,0,.4,0,.5Z"
          fill="#93b8fa"
        />
        <path d="M476.6,171.8c-.2,0-.4-.3-.5-.5.2.1.4.3.5.5Z" fill="#93b8fa" />
        <path d="M477.1,172.8c0,0-.3-.2-.5-.5l.5.5Z" fill="#93b8fa" />
        <path d="M473.6,164.8c-.2-.1-.4-.3-.5-.5.2.2.4.3.5.5Z" fill="#99c6fb" />
        <path d="M476.1,169.8l-.5-.5s.4.1.5.5Z" fill="#b3bee6" />
        <path
          d="M463.6,150.3c1.4,2.7,4.6,8.9,6.3,11s1.5,0,1.6.2,1.1,2.2,1.1,2.3c0,.2.5,2.6.5,2.7s-1.5.6-1,1.8l-2-1c-.4-.1-.4-.3,0-.5l-.5-1c-1.3.7-2.5-1.5-1.5-2.5l-1.2-1.7c-1.8-1.2-2.2-2.3-1.3-3.3-.1-.6-.4-1-1-1.1-.4-2.7-1.6-4.3-4-5.4l.5-1c.9-1.6,1.4-2.2,2.5-.5Z"
          fill="#92c2fd"
        />
        <path
          d="M463.1,149.3c.2.3.3.7.5,1l-1-.5v2s-1.5-1-1.5-1c-.4-.1-.4-.3,0-.5l-.5-.5c-2-.1-4.1-4.4-3-6,.3.2,1.4,1.1,1.5,1l-.5-2.5c3,.7,3.3,4.5,4.5,7Z"
          fill="#93c9fe"
        />
        <path
          d="M456.6,142.8c.3.2.5.6,1,1,.8,1.9,1.9,4.2,3,6l.5.5c0,.1,0,.4,0,.5,1.4,2.2,2.3,1.9,3,2.8s1,3.5,1.5,4.7c-1.8.6-3.2-.8-4.1-4.1-2,1.5-6.2-1.8-7.9-3.5s-4.3-4.3-2.5-5.9c-1.5-1.3-.8-1.8,2-1.5-.9-3.3,2-3.4,3.5-.5Z"
          fill="#86bcfe"
        />
        <path
          d="M448.1,130.3c.5-.4.6-.2.9.2l3.1,4.8,1.3.2c1.3,1.7,3.2,4.9,3.2,6.8v.5c-3.4-2.7-1.8-1.1-3.5.5-2.5.8-3.1-.3-4.2-2.4-2.6-.4-2.5-3.6-1.5-5.6-1.4-.9-2.6-2-3.7-3.3-2.3-.2-3.6-3.8-2.2-5.3,1.8-1.3,5.4,1.6,6.5,3.5Z"
          fill="#8ac6fe"
        />
        <path
          d="M451.1,132.8l2,1.5v-1.5c3,3.3,2.4,3,3.7,7s1.8,2.4,1,3.5c-.2-.5-1-.7-1.3-1-1-1.3-3.5-5.3-4.5-7-1-.9-1.4-1.7-1-2.5Z"
          fill="#a1d7fd"
        />
        <path
          d="M218.2,20.9c41.9-6.4,84.6.4,123.4,16,11,4.8,22.7,10.5,32.7,17s5.8,3.8,8.2,6c-1.3,1-4-.4-4-2l-3.5-1.7c-.4-1.4-1.2-1.6-2.6-1.2l-11.9-6.7c-3.5.2-6.4-.6-8.8-2.4-1.8.2-3.2-.7-4.1-2.8-4.4-2.1-9-3.6-13.6-4.6-1.5,0-4.8-1-6-2.3-2.1.2-4.8-.7-6-2.2-4.8-1.2-9.4-2.7-14-4.6h-2.2c-2.4-1.9-3.8-2.4-6.8-1.5-3.5-.8-7.1-1-10.6-.7-4.9-.7-9.7-1.8-14.4-3.1-1.5.7-3.2.5-4.4-.5l-3.8.4c-7.9-.8-15.8-1.2-23.8-.7l-1.9-.9c-4.8-.3-9.7.3-14.3,1.4-8.8,1.9-17.9,2.3-26.7.6,1.5-.8,3.4-1.2,5-1.5,3.1-2.3,8.3-3.1,12-2,.6,0,1.4,0,2,0Z"
          fill="#e5fbfa"
        />
        <path
          d="M278.7,29.4c.5-.5,1.2-.8,1.9-.9l8.9.9c3-1,7.4-1.3,10.4.4,1.9-1.2,3.8-1.2,5,.9l.9-.5c3.6,1,7,2.2,10.4,3.5,3.4,2,7.8,3.7,11.7,3.3l.3.5c2.5-.4,4.9,1,7.1,2.4l6.6,1.5c1.4.3,2,.8,1.8,1.6,2.7,1,4.2,2.2,5.8,4.5,1.8.1,3.4.8,4.9,1.7,8.1,1.7,15,5.4,21.1,10.9l.5-.3c3,1.4,5.7,3.1,8.2,5,1.3,0,1.8,0,2.4,1.2l1-.4c7.1,4.6,14,9.6,20.5,14.9.7.6,1.6,1,2,2-2.6.3-7.3-2.2-8.5-4.5-1.6,0-4-1.9-5.5-3.1-1.4-.1-2.3-.3-2.6-1.9-3.1-1.3-5.8-3.1-8-5.4-4.3-2.4-8.8-4.1-13.5-5.2l-.8-.7c-.4-2.2-1.9-3.5-4.7-4.1-1.2-2.8-2.6-3.9-4.7-1l-2.3-.7c-1.5.9-3,.2-4.5-2l-.9.6c-7-4.1-14.4-7.5-22-10.1l-.6-1.1h-1.5c-7.9-2.9-15.9-5.3-24-7.4-.7-.8-1.5-1.4-2.5-1.6-2.2,1.1-7.2-.4-9-2-2.2-.6-4.4-.5-6.7-.3-1.6-.9-3.6-1.5-5.8-1.7-.6,1.5-3.8.6-3.5-1Z"
          fill="#d0f9fd"
        />
        <path
          d="M322.7,29.4c6,2.8,12.7,4.7,19,7.5-8.1-2.2-16.1-5.5-24.3-8-32.7-9.7-64.8-12.1-99.2-8l6.5-1.5c26-2.6,52.5-1.1,78.1,4.6,6.7,1.5,13.2,3.8,19.9,5.4Z"
          fill="#f0faf9"
        />
        <path
          d="M371.6,56.4c-.7-3,3.1-1.9,4.1,0l2.9,1.4c1.1.5,3,1.5,4,2,8.8,4.6,18.1,13.8,25.5,20.5-2.3-.8-3.9-3.1-5.8-4.4-2.9-2-6.6-3.6-9.8-5.6s-5.2-3.4-5.8-4.4c-3-1.8-6-3.7-9-5.6-2.3-.3-4.6-2-6-3.9Z"
          fill="#daf9fa"
        />
        <path
          d="M444.6,123.4c1,1.2,2,2.3,3,3.5.6,2.3,2.3,4,3.5,6s.6,1.9,1,2.5c-2.3-1.3-1.8-3.3-4-5l-3.7-4.1c-3.7-1.7-6.6-4-8.8-6.8-1.7,2-2.5,1.2-4-.6-.5.1-.6,0-.5-.5l-.5-1c2.1-5.4,7.1-3.4,10,.6l4,5.4Z"
          fill="#92d0fd"
        />
        <path
          d="M421.1,106.4c2.1.5,4.3,1.5,6.5,2.9,1.5,2,3.7,2.1,6.6.3,1.5,1.4,2.8,2.9,3.9,4.7,2.4,2.7,4.8,5.7,6.5,9-2.6-2.9-5.2-7.1-9.1-8.2s-2.3,1.6-4.9,2.2c-1.5-2.4-3.3-4.6-5.5-6.5-1.9.5-4.8-2.7-4-4.5Z"
          fill="#98d7fc"
        />
        <path
          d="M406.1,90.4c0-.3.2-.5.3-.5,1.2,0,3.6,2.3,4.5,3.1,1.9-1,5.7-.2,7.2,1.5,3,3.5,5.7,6.1,10,7.8.5-.2,1,.2,1.5,1,1.3,1,2.4,2.7,3.5,4v.5c-1.5-.2-3-1-4.6-2.4l-6-2.3c-3.3-1.4-6.1-2.9-7-6.4-1.7.7-2.6.3-3.9-.9-.9.6-2.1,0-1.8-1l-2.2-2.5c-1.5.4-2.3-.7-1.5-2Z"
          fill="#a8e6fb"
        />
        <path
          d="M433.1,108.4c.3-.2.6,0,1,.5,1.3,1.6,3.5,3.2,4,5.5-1-1.2-3-1.9-3-4-.3-.2-4.4,1.9-5.4,1.7-1.4-.3-1.9-1.5-3-2.1-2.4-1.2-3.4-1.6-5.6-3.6-1.6-.9-3.5-2.2-4-4-1.4.8-2.7-1.2-2-2.5.5-.6,1.1-.9,1.7-.4,3.4,5.2,8.3,6.8,14.3,7.7l2,1.2Z"
          fill="#9eddfc"
        />
        <path
          d="M401.6,77.9c2.5,1.6,6.1,2.8,8.5,4.5s4.2,3.9,6.2,5.6,1.4.8,1.3,1.9c-.2,0-.5,0-.7,0-1.7-.9-8.9-4.5-9.6-5.6s-.2-.5-.2-.8l-2-1c-.2.4-.3.4-.5,0-2.3-.9-3.4-2.1-3.5-3.5-1.1-.9-.9-1.2.5-1Z"
          fill="#c9f3fc"
        />
        <path
          d="M404.6,82.4c.1,0,.4,0,.5,0l2,1c3.5,1.5,7.4,4.1,10.5,6.5s4.9,4.1,6,6.5c-1.4-.7-2.7-1.7-4-2.9-2.5-2.5-4-3.2-7.4-3.7s-.6-.5-.6-.9c-2.9-1.3-6.1-3.5-8.6-5.8v-1.2c.6-.2,1.1,0,1.6.5Z"
          fill="#bfeffd"
        />
        <path
          d="M423.6,96.4c2.1,2,4.7,4.4,6,7-.4-.3-1.1-.8-1.5-1-1.7-1-3.4-1.9-5.2-2.7-1.1-2.2-2.6-3.9-4.7-5.1l-1.9-1.7c-1,.4-2.4.2-2.2-1-3-.8-3.9-1.7-2.5-2.5-.4-.1-.4-.3,0-.5.2.1,2-.1,2.7,0,2.6.6,7.2,5.4,9.3,7.5Z"
          fill="#bbebfc"
        />
        <path
          d="M434.1,108.9c-.3,0-.7-.5-1-.5-.4-.1-.4-.3,0-.5v-.5c.6.7.7,1.2,1,1.5Z"
          fill="#bfe0f8"
        />
        <path d="M445.6,118.4c-.7-1-.6-1-1-2l1,2Z" fill="#bedff5" />
        <path d="M373.6,48.4c-.5-.3-1-.7-1.5-1,.7,0,1.3.3,1.5,1Z" fill="#dbf1f6" />
        <path
          d="M479.6,251.3c0,.2,0,.3,0,.5l-.5,1.5c-1.1,4.3-.8,6.9-1.6,10.7s-1.4,3.1-1.5,4.8l-2.2-2.5c-.7-.8-1.1-2.4-1.7-3.1s-2.1.4-1-1.3l-2.5,1c-1.5-.3-1.5-4.1,0-4.5-.3-.6-.6-2.4.1-2.7s5.6-.7,6-.6c1.5,1.8,2.5.4,2.9-4.1.3-.7.9-.5,1.5,0,.3-.5.5-.3.5.5Z"
          fill="#567af7"
        />
        <path
          d="M468.6,258.3c-.1,1.2,0,3.1,0,4.5s0,1.3,0,2c-1.2,1.4-1.4,4.2-2,5.6s-2.3,1.1-1.5,3.4c.3,2.4-1.8,1.6-1-1-1.4-1.8-1-6.4.5-8l.4-4.7c-1.7-2.6.1-5.5,2.6-3.3.8-.3,1.1.2,1,1.5Z"
          fill="#5c80f5"
        />
        <path
          d="M481.6,233.8c0,.6.5,2.8.5,3-.2,2.3-1.2,6.9-1.5,9.5s-.7,3.4-1,5l-.5-.5-.8-.9c.2-2.8.6-5.4,1.3-8.1-1.4-.7-1.5-2.4,0-3-.2-.1-.2-.3,0-.5-.8-.4-.5-2.4,0-3,.2-1.9.9-3.4,1.5-5,.8,1.1.4,2.3.5,3.5Z"
          fill="#557aef"
        />
        <path d="M479.1,253.3l.5-1.5c-.2,1-.4,1.1-.5,1.5Z" fill="#557aef" />
        <path
          d="M465.6,287.3l2-3c-.3,1.7,2.2,5.6,2,6.7s-1.1.3-1,.5c0,.5,1,1.6,1,2.5s-1.1,1.5-1,1.7,1-.2,1,.3-1.3,2.6-1.5,4.1c-.4,2.8-.1,4.8-.9,7.3s0,1.9-.7,2.4c.3-2.3,1.2-7.4,1.1-9.3s-1-.6-1.1-.7c-.2-.3,1-.9,1-1.7s-1.5-.6-.9-1.5,1.1,0,.9-.7c-2.2-.1-.6-5.2-.5-7-1.5-.3-.8.4-1.1,1.2-.4,1.1-.4,2.5-1.4,3.3-1-.2-.8-1.6,0-2,.2-1.3.7-2.5,1-4Z"
          fill="#435de5"
        />
        <path
          d="M464.6,291.3c-.1.6.1,1.4,0,2-.7,3.6-1.4,8.5-2.3,11.9s-3.2,6.9-4.2,10.6c-.9,2.2-1.6,4.4-2.3,6.6l-1.2.4c-.2.6-.6,1-1,1-1.2-.2-.3-1.5.5-2-.5-1-.1-5.1,1.5-4.5,2-7.5,4.5-15.1,7-22.5-.2-.9.2-1.9,1-3-.4-.1-.4-.3,0-.5h1Z"
          fill="#596adf"
        />
        <path
          d="M464.1,272.8v1.5c.6.2.9-.5,1-.5,2.1-.6.2,1.4.1,1.8-.3,1.6-.8,3.5-1.1,5.4s0,4.5-.5,7.2c-.1,2-.4,3.8-1.5,5.5.5.3.5.6,0,1-.8,4.2-2.2,9.7-4.1,13.5s-.5.4-.9.4l-.4-.4c1.8-4.9,3.1-9.9,3.9-15.1,0-4.7.7-9.2,2-13.5l.5-2.5c-.9-.1-.8-.5,0-1-.3-2.2,0-3.3,1-3.5Z"
          fill="#637ff0"
        />
        <path
          d="M463.6,291.3c0,.2,0,.3,0,.5-.3,1.1-.8,1.7-1.5,2,.4-1.8,1.2-3.8,1.5-5.5,0,1,0,2,0,3Z"
          fill="#5f73e7"
        />
        <path
          d="M457.6,318.8c0,.2,0,.3,0,.5l-.5,2c0,.3,0,.7,0,1-2.4,7.9-5.9,15.7-10.5,22.5-.5.8-1,1.1-1.5,1l-.3-.9c4.1-7,7-14.4,9.8-22.1.8-2.2,2.2-5,3.5-7-.2.7-.4,2.2-.5,3Z"
          fill="#5260d1"
        />
        <path d="M457.6,320.3c0,.4,0,.9-.5,1,0-.7-.3-1.7.5-2,0,.3,0,.7,0,1Z" fill="#4358dd" />
        <path
          d="M455.6,328.7c-.6,1.7-2.1,4.6-3,6.5.2,3.4-2.9,8.2-5,11.1s-.6.4-1,.4c.7.6.4,1.2-.5,1-.7,1.2-1.4,1.7-2,1.5,0-1.6.8-3.1,2.5-4.5,3.8-7.4,7.2-14.8,10.5-22.5-.2,2-.8,4.5-1.5,6.5Z"
          fill="#434fc4"
        />
        <path
          d="M445.6,364.7c-.7,1.7.8,2.1.9,2.3.9,2.7-1.5,1.4-1.9,1.7s0,1.9-.4,2.9-1.7,1.7-2.4,2.7c-2.3,3.2-1.3,3.7-1.9,7.2s-2.3,2.8-2.7,3.5c-.9,1.8-1.3,3.4-.7,5.3-.8.8-2.5-2-2.9,2.9s.8.6,1.4,1.1c-1.8,2-3.5,3.9-4.5,6.5-.8,0-1.8-1.9-2-2-1.7-2.1.2-4.6,1.8-6.3-.5-2.9,0-5.4,1.8-7.4,2.5-2.7,4.5-5.7,5.8-8.8,2.5-3.6,5.3-7.7,7.5-11.5Z"
          fill="#2a38ab"
        />
        <path
          d="M438.1,376.2c.3,1,.6,1.3,0,2.2-1.2,2.3-6.2,7.3-6.8,9.3s.5,3.6,0,5-1.7,1.8-2,2.5c-.5,1.1,0,2.4-.8,3.5-.4-.1-1.1.3-1.5.5-2,.6-2.3-2-2-3.5-.3-.3-.4-1.1-.5-1.5.5-.9,1.2-1.9,2-2.5-.7-.8.5-2.4,1.5-2,.3-.8.8-1.5,1.5-2,.2-2.5,2.5-4.9,4.5-6.5,1.2-1.7,2.9-3.4,4-5Z"
          fill="#2c3bb3"
        />
        <path
          d="M433.6,379.7c-.8.5-1.8,1.6-2.8,3.2l-.7-.2c-.2.2-.3.2-.5,0-.3-1.1.3-2.1,1.7-3l2.3-3.5c2.5-3.6,5-7.1,7.5-10.5,1.5-.3,3-2.7,4-4-.7,2.4-10.4,17.8-11.5,18Z"
          fill="#3f55c2"
        />
        <path
          d="M434.1,381.2c-1.5,2.2-3.1,4.4-4.5,6.5-.7.5-1.2,1.2-1.5,2-.8.9-.9,1.3-1.5,2h-.5c-1,.6-1.2.2-.5-1-.4-.9.3-2.1,2-3.5-.4-1.2.8-2.4,2-2,.4-1.8,2.3-4.4,4-5l.5,1Z"
          fill="#5b75d6"
        />
        <path
          d="M433.6,379.7v.5c-1.1,1.8-2.6,3.4-4,5-2.1.2-.6-1.7.5-2.5.3-.5,2.2-3.1,2.5-3.3.5-.4.9.3,1,.3Z"
          fill="#4a61c8"
        />
        <path
          d="M452.6,335.2c1.8-1.3,1.7,0,2.2.3s1.2.1,1.3.2c.3.3-2.1,5.7-2.3,6.8s.4,1.1.4,1.2c-1.1.6-3-.3-1,2-2.3-.5-1.7,2.5-2.4,4.4s-2.9,3.7-3.6,5.6l-.5-.5,2.5-5.5-.7-1.1c.9-1.8.8-2.4-.3-1.9-.9,1-1.4,1-1.5,0,2.1-4,4.1-7.4,6-11.5Z"
          fill="#3742ba"
        />
        <path
          d="M447.1,355.7c-1.4,3.2-4,6.9-6,10-2.5,4-4.4,7-7.5,10.5l-.5-1.3c5.3-8,10.2-16.2,14.5-24.9l1.5-.3c-.6,1.8-1.3,4.4-2,6Z"
          fill="#3441b5"
        />
        <path
          d="M483.6,215.8c1.1,1.9.9,2.9,1.5,5-2.5-.5-2.8,2-4,3.6s-2,.9-1.4,1.8,1.3-.2,1,1.3-.9,0-1,1c-.3,2.1.3,4.6,0,6.8-.1,1,0,2,0,3,0,.3-.2.5-.5.5-1.5,1-1.3.4-.5-1-1.3-.5-.7-2.2,0-3-1.7.6-2.1-1.2-.5-2-.6-2.8-1.2-5.2.5-7.5-.4,0-.4-.3,0-.5-.2-2.7-.2-5.6,0-8.4l1.6-.2c0-3.6,5-3.8,3.4-.3Z"
          fill="#608af3"
        />
        <path
          d="M480.6,207.8c2.1,3.6,4.3,1.9,4,7s0,1.2-1,1c-.2-.4-.1-1.7-1.2-1.5-2,.4,0,4.3-3.3,2.5.2,2.7-.5,5.3-.5,8-.1.4-.3.4-.5,0-.7-1.7-1-4.1,0-5.5-1.6-3.7-2.8-11.3,2.5-11.5Z"
          fill="#6993f5"
        />
        <path d="M436.6,393.2c.2-.2.3-.3.5-.5-.1.2-.4.4-.5.5Z" fill="#2a38ab" />
        <path d="M442.1,385.7v-.5c.7-1.3,1.1-2.9,2.5-3.5-.9,1.4-1.6,2.6-2.5,4Z" fill="#394da2" />
        <path
          d="M475.1,210.3l.7-.9c-.2-1.4-1.2-9.3-.5-10h1.6c2.7-3.6,4.7-2.2,6.2,3.9,0,.2,0,.3,0,.5.2,1.5-1.7,1.5-2.3,2.5s-.1,1.3-.2,1.5c-.6.9-2.9,2.5-3,2.9-.4,1.9.4,6.2.5,8.6-.9.9-1.8-.8-2.2-1.7,0-2.5-.4-5-.8-7.3Z"
          fill="#6d9bf9"
        />
        <path
          d="M474.1,204.3c.4-.9.4-2.1-.2-3.7-1.5-5-.6-7.5,2.7-7.6,1.5-2,2.6-2,3.2.1l.3.6c.2.3.3.7.5,1,0,2.2,1.8,4.4,2.4,6.4s0,1.7.1,2.1c-1.4-.6-1.2-3.7-2.1-4.4-2.4-1.7-3,1-3.5,1.3s-1.7,0-1.9.1c-1.2,1,1.4,8.7,1.1,9.3s-.8,1.4-1.6.6c-1.6-1.2-2.3-4.5-1-6Z"
          fill="#71a0fa"
        />
        <path d="M480.6,186.3s-.4-.2-.5-.5l.5.5Z" fill="#93b2f4" />
        <path
          d="M476.1,181.8c1.1,2.2,1.9,5.4,3,8s.3,1.8,1,3v1c0,0-.6.2-.9-.1-.4-.4.4-1.7-.8-1.4-.8,2.5-3.3,1.7-3.7,2-1.3,1,.3,4,.3,4.8s-.4,1.2-.3,1.9c.1,1.6.8,3.1.4,4.8l-1-1.5c-2.1-2.2-3.1-6.6-2.5-9.5v-.5c.6-.9.6-.1.5-.2-1.1-5.7-1.9-9.7.8-15.3,1.3-.3,2.4.7,3.1,3Z"
          fill="#74a5fd"
        />
        <path
          d="M29.4,162.3c.4.5.5,1,.3,1.6-1.6,4.3-3.4,8.8-5.3,12.9-.9,3.4-2.1,6.6-3.5,9.5-.8,1.3-2,3.6-2.5,5,1.1-4.3,2.5-8.6,3.9-12.9s.2-2.4.6-3.6c1.6-5,4.3-9.5,6-14.5,1.2-1.8,1.4-3.7,1.5-5.7s.6-.4,1-.3c.5-.9,1-1.2,1.5-1-.8,3.1-2,6.1-3.5,9Z"
          fill="#90a5df"
        />
        <path
          d="M30.9,152.3c2.7-2.7,2.7.3.5,2-.8,2-1.2,4.4-2.5,6,.6-1.7,1.5-3.9,1.3-5.5-.3.5-.9.7-1.3,1v-.5c.5-1.2,1.2-2.2,2-3Z"
          fill="#a0b2e3"
        />
        <path
          d="M36.8,140.8c.2,4-2.7,9.2-6,11.5-.6,1-1.2,2.1-2,3,.9-2.5,2.3-4.7,3.5-7s3.2-5.5,4.5-8v.5Z"
          fill="#84a1e7"
        />
        <path
          d="M96.8,69.4c0-.2,8.4-6.5,7.7-4.8-2.3,2.2-4.7,4.4-7.2,6.3-.6,1.6-1.6,2.7-3.1,3.4-3.2,4.3-6.6,8.6-11.4,11.1.2,1.1-.4,2-1.5,1.5-6.5,8.1-13.2,16.1-20,24-.2-.3-.4-.5-.3-.7.8-1.6,2.9-5.1,4.3-5.3l.5-.5c-.9-1.1-.2-1.6,1-2-.3-.5.4-.9,1-1l1-1c1.4-2.9,3.4-5.6,6-8l1-1,.5-.5c.1-.3.5-.8.5-1l2.2-3.1h.8c0,0,1-1.4,1-1.4-.1-1.1,1.8-2.6,3-2.5,0-.4-.4-.6-1-.5.2.9-.7,1.5-1.5,1-5.8,4.7-11.3,9.7-16.5,15v-.5c2.8-3.2,5.6-6.4,8.5-9.5,6.7-7.2,14.1-13.6,22.2-19h1.2Z"
          fill="#7bb9f4"
        />
        <path
          d="M66.8,102.4c-.4.6-.6,1.5-1,2l-.5.5c-1.5,2.1-2.8,3.6-4,6,.3,0,.3.4,0,1-.3.4-.7.6-1,.5-.3.3-1,.5-1.2,1l-8.3,12.5c-2,.4-.2-2,0-3.3s.5-2-1-1.7c4.2-3.9,9-8.4,12.3-13.2s2-4.7,3.2-5.3c.3-.3,1.1-.3,1.5,0Z"
          fill="#6fa3f4"
        />
        <path
          d="M82.8,82.4c.9-.4,1.2-.6,1,.5-1.1,1.1-2.3,1.8-3,2.5l-1,1.5c-.9,1-1.7,2.4-3,3,0-.2-.5-.6-.5-.8s1.7.2,1.5-.7c-1.2-.3-2.1.4-3,1,1.9-2.1,4-4.1,6.5-6,.6-.5,1.1-.7,1.5-1Z"
          fill="#6fa3f4"
        />
        <path
          d="M81.3,83.4l-6.5,6c-7.3,4.5-12.3,14.4-19,20-.4-.1-.4-.3,0-.5l.5-1c2.7-3.3,5.4-6.6,8.5-9.5,5.5-5.8,10.1-10.2,16.5-15Z"
          fill="#74a5f0"
        />
        <path d="M74.8,92.4l-3.8,4.2-.7-.2c.4-2.9,3.6-3.8,5.5-5-.4.4-.7.7-1,1Z" fill="#6fa3f4" />
        <path
          d="M68.8,100.4l-1,.5c-.7.2-.7-.2,0-1,.3-.3.7-.7,1-1l.5-.5c.2-.3.3-.7.5-1,.7-.1.9-.3.5-.5,0-.1,0-.4,0-.5,1.3-.7,3.3-2.7,4.5-4-2.1,2.6-4,5.3-6,8Z"
          fill="#74a5f0"
        />
        <path
          d="M67.8,101.4c-.4.5-.8.8-1,1-.5.5-1.4,0-1.5,0v-.5c.9-.6,1.7-.9,2.5-1v.5Z"
          fill="#74a5f0"
        />
        <path d="M67.8,100.9c-.8.5-1.4,1.2-2.5,1,.7-.8,1.8-1.3,2.5-2v1Z" fill="#6fa3f4" />
        <path d="M67.8,101.4v-.5c.3-.2.7-.3,1-.5-.4.5-.8.8-1,1Z" fill="#6fa3f4" />
        <path d="M70.3,96.9c0,0,.6.1.5.5h-1c.1-.2.3-.3.5-.5Z" fill="#6fa3f4" />
        <path
          d="M55.8,109.4c-1,.9-1.4,1.9-2.5,2.5.3-.5.7-1,1-1.5s.3-.8.5-1c.3-.4.7-.5,1-.5v.5Z"
          fill="#b7cee8"
        />
        <path d="M52.8,112.9c.1-.2.3-.3.5-.5,0,.2-.3.4-.5.5Z" fill="#b7cee8" />
        <path d="M68.8,98.9c.2-.2.4-.3.5-.5l-.5.5Z" fill="#6fa3f4" />
        <path d="M75.8,91.4c.2-.1.3-.4.5-.5,0,.2-.4.3-.5.5Z" fill="#74a5f0" />
        <path
          d="M41.3,138.3c-.4,1.4-1.6,4.3-3,4.5-.9-.1-1.2-.7-.8-1.7l-.7-.3v-.5c.7-1.3,1.6-2.7,2-4h.5l5-6c-.6,2.8-1.8,5.5-3,8Z"
          fill="#85aaee"
        />
        <path
          d="M43.8,135.3c1.5-.2,1.1.5.8,1.5-.9,2.9-2.9,5.5-3.8,8.5.3.1.3.3,0,.5l-.5,1c.5,1.9,0,4.4-2,5-.1.4-.3.4-.5,0-.4-.5-.2-1.2.5-2l-.7-.9c1.4-1.9,1.8-3.6,1.2-5.1.6-1.9,1.6-3.8,3-5.5.5-1,1.5-2.1,2-3Z"
          fill="#6c9bf5"
        />
        <path
          d="M41.8,138.3c-1,1.8-2,3.7-3,5.5.3,2.8-1.6,5.4-3.4,7.5l-5.6,11c-.1.4-.3.4-.5,0,1.2-3.2,1.9-5.7,3.5-9l-.3-1.7c1.7-2.7,3.2-5.5,4.5-8.4l1.2-.4c1.2-1.1,2.3-3,3-4.5h.5Z"
          fill="#7e9de8"
        />
        <path
          d="M109.8,58.4c.4.1.4.3,0,.5.4.8-.1,1.3-1.4,1.5l-3.6,2.5c.1.9-.3,1.4-1.2,1.5l-6.8,5c-8.2,4.7-14.8,11.2-21.5,17.8s-1.1,1.2-2,1.2c1.4-1.5,2.6-3,4-4.5,5-5.9,10.4-10.9,16.5-15,4.8-4.2,10.2-7.9,15.6-11.4s.7.2.4.9Z"
          fill="#a1dcf8"
        />
        <path d="M64.8,98.4c-2.9,3.1-5.6,6.4-8.5,9.5,2.3-3.7,5.7-6.7,8.5-10v.5Z" fill="#b7cee8" />
        <path
          d="M93.8,68.9c-1.7,1.7-3.8,2.7-5.5,4.2-3.8,3.4-7.1,7.4-11,10.8,3.6-3.9,7-8,11-11.5s4.9-3.8,7-5.5c-.1.8-.6,1.4-1.5,2Z"
          fill="#cbe8f4"
        />
        <path d="M55.8,108.9l-1,.5c.6-.7,1-1,1.5-1.5-.2.3-.3.7-.5,1Z" fill="#bedef8" />
        <path d="M109.8,53.9c.2-.1.4-.6,1-1l-1,1Z" fill="#d1f3f9" />
        <path d="M111.3,52.9c.2-.1.3-.4.5-.5l-.5.5Z" fill="#d1f3f9" />
        <path d="M112.8,51.9l.5-.5c-.2.1-.3.4-.5.5Z" fill="#d1f3f9" />
        <path d="M117.8,48.4v-.5h.5c-.2.1-.3.4-.5.5Z" fill="#c5f1f9" />
        <path d="M119.3,47.4l.5-.5c-.2.1-.3.4-.5.5Z" fill="#c5f1f9" />
        <path d="M120.8,46.4l.5-.5c-.1,0-.3.4-.5.5Z" fill="#c5f1f9" />
        <path d="M128.8,41.9c.2-.2.3-.3.5-.5-.2.2-.3.4-.5.5Z" fill="#cbf3f8" />
        <path d="M127.8,42.4c.2,0,.3-.4.5-.5-.2.2-.3.3-.5.5Z" fill="#c5f1f9" />
        <path d="M127.3,42.9v-.5c.1,0,.4,0,.5,0-.2.2-.3.4-.5.5Z" fill="#cbf3f8" />
        <path d="M126.3,43.4l.5-.5s0,.3-.5.5Z" fill="#cbf3f8" />
        <path
          d="M117.3,51.9c.4.5-.1,1-1.5,1.5-.6,2-3.3,4-5.5,4.5.3.1.3.3,0,.5-.1.3-.3.2-.5,0,0,0-.2-.5-.5-.3l-15.5,10.8c.5-.5,1-1.4,1.5-2,.3-.2.7-.3,1-.5l1.5-1.5c.8-.6,1.8-1.5,2.5-2,1.7-1.2,3.8-2.3,5.5-3.5,3.6-3.2,7.4-5.7,11.5-7.5Z"
          fill="#bce9f7"
        />
        <path d="M96.3,66.4c.4-.3.8-.9,1.5-1.5l-1.5,1.5Z" fill="#cbe8f4" />
        <path d="M101.8,59.9c.2-.2.3-.4.5-.5-.2.2-.3.4-.5.5Z" fill="#d1f3f9" />
        <path
          d="M131.8,43.9c.4.1.4.3,0,.5-.7,1.3-2.2,2-4.4,2.4-3.3,2.1-6.6,3.8-10,5.1-3.8,2.3-7.7,4.9-11.5,7.5l9-7.5,3.1-1.5c4.4-3.2,8.7-5.9,13.9-6.5Z"
          fill="#c2eff9"
        />
        <path
          d="M140.3,37.9c-.5.6-1,1.3-1.5,2-1.9,1.5-4.6,3-7,4-1.6.9-4.2,1-5.9,1.8-3.5,1.5-7,5.5-11,6.2,3.6-2.1,7.3-4.9,11-7,2.4-.7,4.8-1.5,6.5-3.5.1,0,.4,0,.5,0,2.5-1.3,5-2.5,7.5-3.5Z"
          fill="#c5f1f9"
        />
        <path d="M125.8,44.9c1.9-1.1,4.6-2.6,6.5-3.5-.9,2.9-3.9,3.4-6.5,3.5Z" fill="#cbf3f8" />
        <path
          d="M141.3,36.9c-.3.3-.7.6-1,1-2.4,1.7-5,2.3-7.5,3.5,2.8-1.6,5.6-3.2,8.5-4.5Z"
          fill="#cbf3f8"
        />
        <path d="M136.3,37.9c.1-.2.3-.4.5-.5-.1.2-.3.4-.5.5Z" fill="#cbf3f8" />
        <path
          d="M240.2,22.4l-1,.8c-5,.6-10,1.2-15,1.7-4.1,2.6-12.6,2.8-17.7,2.5s-4.5-.3-5.3-1.5c-2.3,0-4.5,1-6.7,2.9-1.5-.3-2.9,0-4.2.8-2.1,0-4.2.9-6.4,2.6-9.9,1.4-19.2,4.2-27.8,9-1.5.5-4.7,1.2-5.4-.4,2.4-1.5,5.2-2.8,7.9-3.9,10.9-4.5,29.2-11.2,40.6-12.6s5.1,0,7.2-.3c3.1-.4.9,0,2,.2,5.1.8,9.9-.4,14.7-1.3s1.8.4,3.1,0,1-1.3,1.2-1.3c.7,0,1.6.8,2.5.8s2.6-.8,4-.8,4.7,0,6.2.5Z"
          fill="#defafa"
        />
        <path
          d="M201.2,25.9v.7c-3,1.9-6.5,3.3-10.5,4.3-.1.2-.3.4-.5.5-.9.5-4.7,2.2-5.2,2s-.5-.3-.8-.5c-3.5,1.2-7.3,2.3-11.4,3.1-8.1,2.6-16.1,6-23.9,10-10,3.5-19.5,7.8-28.6,12.9-.7,1.5-2,2.6-4,3.4l-11.2,9.1c-1,.6-2.2,1.3-3.3,1,2.7-3.4,6.8-6.6,10.5-9.2,6.4-4.5,12.8-8.8,19.5-12.8,4.1-2.3,15.1-8.8,19-9.5s3.9,0,5.2,0,.2-.9.6-1c4.6-.9,6.5-3.8,9.5-4.4s1.3.4,1.8.3c1-.2,2.5-2.1,5.6-2.3s6.2-.7,9.9-1.7,3.6-3,5.2-3.2.8.9,3-.7,2,.6,2.9.5.2-1.9.3-2c.2-.2,1.2.5,1.7.4,1.2-.2,2.5-3.4,4.8-.9Z"
          fill="#dbf9fb"
        />
        <path
          d="M115.8,53.4l9.4-5.5c1.9-1.5,7.5-3.1,3.7-.4l-1.6,1.4c-2.2,1.8-4.6,3-7,5h-1c-.7-.6,1.6-1.7,1.5-1.7-2.8,2.2-5.6,4-8.4,5.7-.1.4-.3.4-.5,0-.4.3-.7.5-1,0-.1.3-.3.3-.5,0,2.1-1.3,3.7-2.9,5.5-4.5Z"
          fill="#a3e1f8"
        />
        <path
          d="M131.8,44.4c2.2-1.1,4.1-2.4,6.4-3.4s1.4,0,.6.9c-3.9,2.1-7.8,4.6-11.5,7,.6-.5,1.1-2.1,2.5-2,0-1-1.9-.2-2.3,0-3.6,1.7-7.5,5.5-11.7,6.5.5-.5,1.1-.9,1.5-1.5,5.1-3.1,9.3-4.9,14.5-7.5Z"
          fill="#b3e8f5"
        />
        <path d="M290.2,14.9l-2-.5c.9,0,1.9.5,2,.5Z" fill="#adeff7" />
        <path d="M228.2,12.9c-.2.7-1,.5-1.5.5.2-.7,1-.5,1.5-.5Z" fill="#c2f1f7" />
        <path d="M231.2,12.4c-.1,0-.5.4-1,.5l1-.5Z" fill="#c2f1f7" />
        <path
          d="M222.2,13.4c0,.4-.2.7-.4.8-2,.9-7.6,1.6-9.9,1.8s-.5-.2-.7-.6l-1,.5c-.1.9-.6.8-1,0-.3.3-.7.3-1,0-1,.1-2,.3-3,.5-.1.4-.3.4-.5,0-2.9.2-2.9-.4-.1-1.9h2.6c1.8,0,2.9-.4,4.5-.6-.8,1.2-.7,1.1.6.9,3.4-.5,6.4-1.2,9.9-1.4Z"
          fill="#a8ebf8"
        />
        <path
          d="M207.2,14.4l-4,1c-.2.7.9.6,1.5,1-.1,1.2-2.3,1.4-3,.5-.1,0-.4.4-.8.3s-.6-.7-.7-.8c-.4-.1-.4-.3,0-.5.6-.2,1-.3,1.5-.5,1-.3,2.8.1,2.5-1.5,1.3,0,2.6.5,3,.5Z"
          fill="#b3e8f5"
        />
        <path d="M208.2,15.9c.4.1.4.3,0,.5-1,0-2-.1-3,0,.6-.9,2.1-.5,3-.5Z" fill="#b3e8f5" />
        <rect fill="#a7edfb" height=".5" width="2" x="207.7" y="14.9" />
        <path d="M211.2,15.4c-.1.5-.6.5-1,.5.1-.5.6-.4,1-.5Z" fill="#b3e8f5" />
        <path d="M209.2,15.9c-.1.5-.6.5-1,.5v-.5c.3,0,.7,0,1,0Z" fill="#c2f1f7" />
        <path
          d="M82.3,400.7c.6.5,1,1,1,1.5,2.3,2.7,4.1,6.9,3.8,10.4,4.4,1.3,1.6,7.6-1.3,5.1l-5-4.5c-2.3-2.6-4.4-5.4-6.5-8,.7-1.1,1.3-.6,2,.3,2.1,4.1,6.2,2.6,3.6-1.9l.2-2.2c-1.8-1.4-4.1-3.4-2.8-5.7,1.6.2,4.2,3.3,5,5Z"
          fill="#2f5dd6"
        />
        <path
          d="M75.8,393.7c1-.2,2,1.1,1.5,2,.5.8.8,2.4,1.5,3.3s2,1.1,2.3,2.2-.3,2.3-.2,2.5c.4,1.1,1.1-.8.6,2.8s.5,1.4.3,1.7-3.4.7-4.2.5-1.9-3.1-3.3-3.4c-.8-1-1.7-2-2.5-3,6,2.6,3.2-1.7,3.5-2s1.3.1,1.5,0c.5-.5-.7-1.8-.8-2.2,0-.7.5-1.6.2-2.4-.4-1.2-2.6,0-2-2.3l1.5.5Z"
          fill="#2b57d0"
        />
        <path
          d="M83.3,416.2c1.1,1.1,2.7,3.1,4,4,.2,1.8.6,3.2,0,5-1.5-1.6-3-3-4.2-5s-.1-1.5-.4-1.9c-.5-.8-3.1.4-1.4-3.6.1,0,1.7,1.2,2,1.5Z"
          fill="#5387de"
        />
        <path
          d="M55.8,366.2c1.1-.4,1.4.3.5,1,1.5,2.3,2.8,4.6,4,7,1.3,2.4,2.1,4.8,2.3,7.4-.2,1.7-2,5.4-3.3,3.1-2.5-3.8-5.1-7.5-7.5-11.5-1.6-.5-1.9-1.2-1-2,3.6-.3,4.2-2.6,1.8-7l.7-1c1,.5,1.8,1.5,2.5,3Z"
          fill="#2d45b7"
        />
        <path
          d="M64.8,379.7c1.5,0,4.7,4,4,5.5,1.2,3.6-.2,2-2.2,3.1s-1.7,2.7-3.8,1.4c-1.2-1.7-2.4-3.2-3.5-5,1.6,1.1.7,0,1.1-.6,1.3-2,1.6-3,.8-5.6s-.9-.3-1-.7c-.1-.7.4-2.6,0-3.7,1.6,1.6,3.1,3.5,4.5,5.5Z"
          fill="#2b48be"
        />
        <path
          d="M45.8,362.2l1.8,2.9c1.9,1.5,3.4,3.5,3.2,6.1.3.5.6,1.3,1,2l-1-.5c-.1.2.4,2.5.5,3-.3,1.6-2.9,0-2.1-.4s.5.2-.4.4c-.5,1-2-.5-2.6-1.3s-3.6-10.8-3.5-11.5c.2-1.5.6-2.8,2-1.6,1.3-.6,1.6-.3,1,1Z"
          fill="#5671b7"
        />
        <path
          d="M51.3,375.7c.6,2.3,2.8,8.2,3.8,10.5s3.9,3.6,4.2,6c-.8-.3-2.8-1.9-3.5-2.5-1.9-1.7-1.5-2.6-2.3-3.5s-1.5-.4-1.7-.6c-.3-.3,0-1.8-.2-2.6-.5-1.8-2.5-2.5-2.9-5.9-.9-.9-.9-1.4,0-1.5,0-.3,0-.7,0-1l2.5,1Z"
          fill="#516fbb"
        />
        <path
          d="M83.8,401.2c.7,2-.6.6-1.5-.5-1.1-1.4-3.7-3.5-5-5-.5-.7-1-1.3-1.5-2-1.2-1.8-2.4-2.7-3.5-4s-1.9-3.3-3-4.5c-.7-.6-.5-1.3.5-1,2.4,1.4,4.4,3.4,5.3,6,3.1,3.6,6,7.2,8.7,11Z"
          fill="#6d89e2"
        />
        <path
          d="M50.8,354.7c1.3-.4,2.2.8,1.5,2,3.2,3.4,6.4,8.5,7.5,13,.5.2.9.5,1.3.8,1.5,1.1,7.9,10.4,8.4,12.2s.2,1,.3,1.5l-.5,1h-.5c-.7-2.2-2.6-3.8-4-5.5-3.1-4-6-8.1-8.5-12.5-.2-.3-.3-.6-.5-1-1.6-2.2-2.9-4.5-4-7-1.5.6-2.6-2.1-1.5-3-1.3-2-1.3-4.7.5-1.5Z"
          fill="#677fe0"
        />
        <path
          d="M22.9,307.8c2.3,6.4,3.1,7.2,6.7,12.5s4.1,9.9,5.3,12.5c1.2,0,2.5,3.1,1.5,4,2.1,1.7,3.2,4.3,3.2,7.6,1.5,2.1,3.9,6.4,3.1,9.1s-.4.8-1.2.8c-1.4.6-2.2-.7-1.5-2h-1.2c-.7-.9-2.6-5-2.3-6,0-.3,0-.7,0-1-.3-1.3-1.8-4.1-2.5-5.5.2-1.1-.4-2.1-.9-3.1,0-2.6-.3-6.4-3-7.2-.5-3.8-2-6.7-4.6-8.6-1.1-.9-2.7-4.2-1-5-.3-1.3-.5-3.1-.8-4.1s-2.2-2.1-.7-3.9Z"
          fill="#30369e"
        />
        <path
          d="M36.3,346.2c1.8,1.4,2.4,4.2,3.5,6-.5,2.9.2,4.7,2.1,7.4.5,1.1.9,2.2-.6,2.6l-5.7-8c-.5-1.8-.9-3.3-1.8-5s-.9-.4-1-.9c-.5-2.7,1.2-3.9,3.5-2.1Z"
          fill="#566aa8"
        />
        <path
          d="M41.3,354.2c2.1.5,4.2,5,3.5,7-1.1.3-1.1,1.3-1,2.2s3.3,10.5,3.7,11.3.6.7,1.3,1c0,.4,0,1.1,0,1.5l-3.5-2.5c-1.1-4.2-2.9-8.2-4-12.5s.1-1-.1-1.6c-.7-2.1-4.6-5.7-1.4-8.4.4.6,1.1,1.4,1.5,2Z"
          fill="#556bad"
        />
        <path
          d="M25.4,320.8c.7,0,1.6-.2,2.2,0s-.2,2.2,1.8,1.5c-.6,1.4.4,4.7,1,6.2s1.2,0,1.6.6,1.8,3.8,1.9,4.1c.2,1.1-.4,1.9-.4,2.8s1.6,2.7.5,3.8c-.5-1-.7-2.2-1.5-3,.6-1-.9-3.4-1.4-4.4s-1-.7-1.1-1c-1.2-2.4-1-4.2-1.6-6.3s-1.9-1.5-2.9-4.3Z"
          fill="#2f3394"
        />
        <path d="M12.9,204.3l3-11c.4,4.7-1.7,9-2.5,13.5-.8.1-.6-2.1-.5-2.5Z" fill="#a7acd7" />
        <path d="M17.9,192.3c.1-.4.5-.5.5-.5l-.5.5Z" fill="#90a5df" />
        <path d="M17.4,194.3c.1-.4.5-.5.5-.5l-.5.5Z" fill="#90a5df" />
        <path
          d="M23.9,180.8l-.5.5.4,1.8-2.9,11.7c-.9.3-1.4,1-1.6,2,0,.6-.2,1.1-.5,1.5l-.5.5.6,1.6c-1.7,5.2-3.1,10.5-4.4,15.9l-1.2,1.1-1,2c0-.3,0-.7,0-1,2.3-10.8,5.4-21.3,8.5-32,.9-3.1,1.8-6.7,3.5-9.5.3,1.1,0,2.9-.5,4Z"
          fill="#6482df"
        />
        <path d="M11.9,220.3l.5-.5c0,.4-.5.5-.5.5Z" fill="#6482df" />
        <path
          d="M18.4,301.3c0,.5,0,1,0,1.5l.5.5c0,.2,0,.3,0,.5.7,0,1.4.7,1,1.5.4.4,2,1.7,2,1.8,0,.7-.5,1.4-.4,2.3s1.9,5.6,2.9,6.4c.4,1.6.3,3,1,5-.3,0-.6.1-.9,0s-1.7-2.7-1.8-2.9-1.3-3.8-1.3-4c0-3.9-1.2-3.4-2.7-6.1s-.8-3.2-1.2-4.4-2.3-2.8-1.7-5c.7,1,1.7,2,2.5,3Z"
          fill="#303493"
        />
        <path
          d="M12.9,223.3c1.2,2.1.7,4.8-1,6.5,1.4.7,1.2,5.2-.5,5.5-.2.8-.7,2.3-1,3.5l-1.8,2.5c-.5-.1-.2-1-.2-1.5l4.5-17.5c0,.3,0,.7,0,1Z"
          fill="#4c69d0"
        />
        <path
          d="M21.4,285.8c.5,1.4.9,3.8,1.5,5.5,2.4,3.8,4.2,7.8,5.5,12-.4,3.4,1.6,7,3.6,9.7,1.6,6.4,3.6,13,6.3,18.8.3,0,.5,0,.8.2.4.2,4.2,7.9,3.2,8.8,1.9,3.6,3.6,7.2,5,11,.4.7-2-.1-2.1-.2-2.3-4.2-4.4-8.5-6.3-12.9-2.5-3.3-4-7.2-4.5-11.6l-2.7-3.7c-.5-2.9-1.3-5.1-2.5-6.7-2.7-4.7-3.9-10.2-5-15.5,0-.4-.4-2.5-.5-3-.5-2.2-2.2-7-3.1-9.1s-1.3-1.3-1.3-1.7c-.2-1,1.4-.3,0-2.7l.5-1h.5c-.2.9.9,1.6,1,2Z"
          fill="#3439b4"
        />
        <path
          d="M24.4,301.3c2.2,0,1.2,5,1.5,6.2s.9.4,1.1.9c.9,2.2,1.6,6.1,2.3,8.4.2,0,.6-.2.9.1s0,.8.3,1.2.6.3.7.6c.5,1.6.2,3.5.6,4.7s2.6,2.3,3.1,3.5.5,3.8,1.2,5.4c2.3,5.1,6.2,12.4,8.9,17.4s1,2.1,2.2,2.1c.2.2.2.3,0,.5.6.4,1.1,1.3,1,2l-1,.7c-1-1.4-2.3-2.3-3.9-2.6-.9-3.3-2.1-5.4-4-8.1.1-3.3-.9-5.8-3.1-7.5-.6-1.3-1-2.9-1.5-4,.1-1.8,0-4.2-1-5.7-2.7-4.4-3-5.2-4.5-10.2-2.8-1.4-1.3-1-2.1-3.2s-1.2-.6-1.4-1.2c-.4-1,0-2.8,0-3.3s-.8-1-1.4-3.1c-.9-3.8-.1-1.9-.1-4.7Z"
          fill="#3137ab"
        />
        <path d="M18.9,303.8c1.4,0,1.7-.3,1.5,1.2l-.5.3c-.6-.8-.6-.2-1-1.5Z" fill="#303696" />
        <path d="M18.9,303.3c-.2,0-.5-.3-.5-.5.2,0,.4.3.5.5Z" fill="#303696" />
        <path
          d="M24.4,292.8c.5-.5,2.6,1.8,2.9,2.3l2.1,8.2c1.4,1.7,2.2,3.7,2.5,6.2,2.1,5,3.6,10.1,4.5,15.3,1.3,1.2,2.8,5.4,2,7-1.4.3-.9-.8-1.1-1.6-1.1-3.3-2.4-4.8-3.5-7.4s-.5-6.4-1.9-9.6-1.2-.4-2-1.2-1.2-3.2-1.6-4.3-.9-.3-.9-.7c-.2-1.4.3-4.1-.1-5.8s-3.6-5.9-4.3-7.7,0-2,0-2.1c.6.4,1.1.9,1.5,1.5Z"
          fill="#343cbc"
        />
        <path
          d="M17.4,265.3c.5,0,.4.2.5.5,2.8,3.8,4.6,8.2,5.2,13.2,1.9,1.6,2.3,2.8,1.3,3.8.1,1.4-.7,1.7-1.5.5,0-.2-1.4-1.6-1.7-2.5-1.5-4.6-2.8-10.4-5-14.5s-1-1.3-.7-2.5c.2.5.8,1.6,1,1.8.3.3.9-.3,1-.3Z"
          fill="#3244c2"
        />
        <path
          d="M27.4,294.8c.1-.4.3-.4.5,0,.6.3.8.8,0,1l.5,1c1.3.7,2.4,5.4,1,6.5-1-1.2-2.4-7.9-3-8.5s-.9.5-.9.5c0-1-.5-1.7-1-2.5-.4-2.8-1.1-5.6-1.8-8.3s.4-1.1.3-1.2l1.5-.5.7.2c.3,4,1.1,8,2.3,11.8Z"
          fill="#3643c2"
        />
        <path
          d="M19.9,253.3c.4,0,.9,0,1.1.3,1.9,4.6,2.6,9.1,2.9,14.1,1.3,1.5,2.4,8.9,2,10.6s-.5,1-1,1.4c-1.7-.6-2.5-4.1-1.5-5.5-.1-1.2-.5-3.3-.8-4.4-2.1-5.8-2.9-10.1-4.1-17.1.6-1.5,1.1-.8,1.5.5Z"
          fill="#3a54d7"
        />
        <path
          d="M12.4,236.8c1.3-2.7,5.2,3.4,5.8,5s.2.7.2,1l1.3.5c.8,1.8,1.7,8.6.2,10l-1.5-.5c-.2-.9-.9-1.5-.9-2.2s.5-1.2.4-1.9-2.6-4.1-2.9-4.3c-.7-1,.1-2.4,0-3.1s-2-1.8-2.6-3,.1-1.2.1-1.3Z"
          fill="#395bd6"
        />
        <path
          d="M18.9,265.8c.8,2.6,3.6,6.2,4.5,8.5s1.1,3.7,1.5,5.5c1.6,0,2.1,3.2,1,4,.4.1.7.3.8.5.3,1.4,1.6,9.2,1.3,9.8s-.3.5-.5.7c-2-.9-2.7-9.8-3-12s.2-1.6,0-1.9-1,0-1.4-.4c-1.5-1.1-1.4-6.5-2.1-8.3s-2.3-4.1-2.9-5.2,0-.9-.1-1.1h1Z"
          fill="#3548c9"
        />
        <path
          d="M14.9,228.3c1.9-1.1,2.3,1.2,1.7,2.8,1.3,1.3,2.3,4.3.8,5.7,1.3,1.9,1.9,3.8,1.8,5.7l-.8.3c-.7-1.6-2.7-2-1.5-3.5-2.9.8-1.9-2.7-4.5-2.5,0-1.2.3-1.7-1-1.5.4-2.2.2-3.6.5-5.5.6-1.4,1.6-2.8,3-1.5Z"
          fill="#3b64d8"
        />
        <path
          d="M400.6,428.7c-4.1,8.2-8.6,9.9-14,16h-1.5s0-1.5,0-1.5c-.2-.4-.4-1,0-1.3,2.2-2.6,4.5-4.7,7.6-6.2l-.3-1.2c3.5-4.7,7-9.4,10.2-14.3.5-1.4,1.4-2.9,2.5-4.5.4-.6.2-.8-.5-.5.5-.4,1-1,1.5-1.5l-1.6,7.1c-2,2.4-2.4,5.1-3.9,7.9Z"
          fill="#4a78dc"
        />
        <path d="M384.1,447.7c-.4.3-.9.4-1,.5l.8-2,.2,1.5Z" fill="#4a78dc" />
        <path d="M382.6,448.7c-.2.2.6,1.4-1.5,1,.3-.7.6-1,1.5-1Z" fill="#4a78dc" />
        <path
          d="M418.1,401.7c-1.6.4-1.7,2.5-2.5,3.2s-.9,0-1.3.2c-.7.6-.8,1.6-1.7,2s-.7,0-1,0c1.2-2.7,4.2-5.8,7-7,0,.5-.3,1-.5,1.5Z"
          fill="#374ec0"
        />
        <path d="M417.1,418.2l2-2c-.6.7-1,1.7-2,2Z" fill="#466cc3" />
        <path
          d="M426.1,391.7c-.2.8-.8,1.6-1.5,2-1.9,2.2-4,4.4-6,6.5s-4.7,4.8-7,7-1.7,1.8-2.5,2.5-1.4,1-2,1.5c-.7.4-1.8.9-1.8,0s4.8-4.8,5.8-5.5c.3-1.4,1.3-2.4,3-3,0-.4,0-.8.2-1.1.5-1,9.5-10.3,10.2-10.6s.7-.2,1.1-.3l.5,1Z"
          fill="#6180d8"
        />
        <path
          d="M411.1,405.7c-1.8,1.9-3.1,4-5.2,5.5h1.3c-1.7,1.5-3.3,3.1-5,4.5-.5,1.9-2.7,3.4-4.5,3.6l-3.5,2.9c0,1.4-1.7,2.8-3,2-.5.4-1,.5-1.5.5-1.6.5-1.4,0,.5-1.5,0-2.4,2.9-3.9,5-4.5,1.1-2.8,3.5-4.8,6.5-5.5,2-1.4,3.9-3,5.5-5l3.5-2.8.5.3Z"
          fill="#5e7fcf"
        />
        <path
          d="M405.1,415.7c-3.9,5.3-8.1,10.3-12.4,15.2l-1.1-.2c-1,1.7-2.1,2.7-3.5,3-.5-.6-.2-.9.5-1,2.1-4.5,5.4-8.3,10.1-11.5v-.5c0-1.8,2.4-3.6,3.9-4,.6-.5,1.4-1,2-1.5,1.8-1,.8-.2.5.5Z"
          fill="#5a93ef"
        />
        <path
          d="M402.1,415.7l1.5-.5c.1,0-.8,1.2-1,1.5-.9,1.1-2.9,3-4,4,0,1-1.6,2.4-2.5,1.5-1.1.4-1.8.4-2,0,2.3-2.6,5.3-4.3,8-6.5Z"
          fill="#324ebe"
        />
        <path
          d="M392.6,435.7c-2.2,2.4-5.6,5-7.5,7.5s-6,6.8-7.8,8.5c-3.4,3.2-9.6,5.5-13.1,9l-2.5.5c2.3-3,1.9-2.8,5-5s.6-1,1.3-1.4c1.7-1.1,2.8-.1,3.7-2.6,4.6-4.3,10-9.5,14.7-14.4s1.1-.6,1.7-.6c2-1.9,3.5-2.4,4.5-1.5Z"
          fill="#4982e6"
        />
        <path
          d="M388.1,437.2c-3.3,3.8-7.5,7.9-11.2,11.3s-3.1,2.6-5.3,3.7c.1-.3-.2-1.2,0-1.4.5-.4,1.9.7,1.4-1.6-.1-.3-.2-.6,0-.7,2-2.6,5-5.5,7.8-7.2.6-2.1,1.6-3.1,3-3,.4-1,1-2,2.2-1.5,1.4-1,2.7-1.7,4-2,1.3.5.6,1.4-2,2.5Z"
          fill="#4e89ec"
        />
        <path
          d="M391.6,430.7c.3.3.6.6.6,1-.2,1.2-4.7,4.4-6.1,5-1,.9-1.4,2.4-1.6,2.4-.5.3-1.7-.1-1.9,0s.2,2.2-2.1,3.7-2.1.6-2.7,1c-1.6,1.2-1.1,3.5-4.6,5.3s-1.5,0-2,.5v-1.9c3.9-2.9,7.2-6.1,9.9-9.8,1.7-1.7,5.1-3.7,7.1-4.3,1.4-1.1,2.2-1.8,3.5-3Z"
          fill="#538ff0"
        />
        <path
          d="M425.1,395.7c.1,0,.8-.2,1,0s-.3,1-.2,1.5c.3.8,1.1,1.4,1.2,1.9s-.2,1.9-.2,2c-.2.4-1,.3-1.5,1.5-.9,2-.5,4.4-1.7,7s-1.3,2.9-3,3c-.3-1,.8-2,.8-2.7,0-3-.3-4.9,0-8.4s-.5-1.4-.1-2.3c.7-1.5,2.4-2.6,3.7-3.5Z"
          fill="#2942b3"
        />
        <path d="M424.6,394.2v-.5c.5-.6,1-1.3,1.5-2h.5c-.6.8-1.2,1.8-2,2.5Z" fill="#2942b3" />
        <path
          d="M126.8,449.2c.1-.4.3-.9.7-1.1.6-.2,11.2,4.4,7.8,6.6.6-3.9,5.9-.3,7.4,1.6,2.7,1,4.9,2.5,6.6,4.4,2.4,1.7,4.4,2.6,7.3,3.4,6,3,12.1,5.8,18.3,8.4,4,.5,7.3,1.8,10,4h1.7c3.7,2.7,8.8,3.4,13.3,4,6.2,2,12.6,3.3,19.3,3.7l1,.9c1.7,0,2.2.5,1.5,1.5-1.4,0-4.3.3-5.7,0s-.3-.9-.7-1c-1.4-.3-4.6.7-6.9,0s-2.1-1.3-2.5-1.3c-2.9-.5-6.5-.2-9.4-1.4s-2.1-1.7-3.2-1.9-2.1.6-2.7.5c-1.9-.2-5.4-2.2-7.1-3.1s-4.3-1.8-4.9-2.2-.3-.9-.6-1.1c-.4-.3-2.4.5-3.1.3s-1.3-1.3-2.2-1.7c-4.3-2-10.8-3.2-15-5.5s-1.5-1.9-1.7-2-2.2-.8-3.4-1.4c-1.7-.9-9.8-4.4-10.7-5.2s-.5-1.5-1-1.9-2.2-.8-3-1.2-.4-.9-.7-1c-.8,0-1.8.7-2.7.5.1-.5.5-.9.5-1.5-2.7.1-5.9-4.5-8-4.5-.9.4-1.2-.4-.5-1Z"
          fill="#4fa0f9"
        />
        <path
          d="M302.2,481.2c-1.8,2.3-7.5,3.4-10.7,3.9-7.1,0-13.9,1.1-20.4,3.4-11.5,1-23,1.1-34.4.3-4-.9-5,0-8.7,1l.2-1c-3.7,1.9-7-.9-10.3-.4s-1.6,1.2-2.7.9c.5-2.9-3.9-1.4-5.6-1.6s-3.9-.8-4.5-1-1.2-1.3-1.6-1.3-1.9,1.5-3,1.4-.5-1.3-2.7-1.4-2.4.5-2.6.4,0-1-.3-1.4c-1.4-2.1-2.1-1-4.2-1.6-1.2-.4-1.3-.6,0-1,0-1.2.9-1.6,2.8-1.1,7.4,2.8,15.2,3.9,22.9,4.9,1.8.2,3.5.6,5.3,1.1,0-.4.3-.4.5,0,1-.6,2-.6,3,0l1-.7c8.1-.3,16.1,0,24,1,4.4-.8,8.7-1.2,12.8-1.4l.6.5,5-1.3c10.3-.6,20.5-2.3,30.6-4.5,1.7-.4,2.6-.1,2.9.7Z"
          fill="#4e9cf7"
        />
        <path
          d="M307.7,478.2c1,.7.3,1.2-2,1.5-1.2.5-2.3,1-3.5,1.5-.8-.6-1.5-.2-2.3,0-3.6.7-8.7,2.4-12.1,2.8s-5.2-.1-9,.7-6.2.8-9.7,1.2-4.4,1.2-5.7,1.3-.6-1-1-1c-.9-.1-1.9.8-3,.9s-2.6-.5-3.9-.3c-6.8,1-6.1.6-12.8.1-5.5-.4-11.7-.3-17.5-.2-1.1-.6-1.9-.6-3,0-.2,0-.3,0-.5,0l-1.5-1.5c1.9-1.4,4.4-1.6,7.5-.5l1-1c4.7.2,9.5.5,14,1.5,2.2.3,4.9.5,8.2.7,4.2-1.1,8.5-2.1,12.8-1.8,2.5-1.3,5.2-1.5,8.2-.7,9.3-1.6,18.4-3,27.4-4.3l.3.7,2.9-.4c1.2-.9,4.8-3.4,5.1-1.1Z"
          fill="#52a1fb"
        />
        <path d="M225.2,486.7c-1,0-2,0-3,0,.9-1.2,2.2-1.2,3,0Z" fill="#4fa0f9" />
        <path d="M202.2,485.2v.5c-2.1.2-2.1-.7,0-.5Z" fill="#4b98f3" />
        <path d="M196,484.7c.3.2.3.3,0,.5v-.5Z" fill="#4b98f3" />
        <path
          d="M96.8,425.2c1.6,1.8,3.2,3.3,4.7,4.8,2.3,2.2,5.9,3.1,8.1,5.4s-.3.8,1.7,1.8l1-.5c1.9,1.7,3.5,2.8,6.1,3.3,1.6,1.5,3,3.4,4.3,5.6,3.2.7,4.6,1.9,4.1,3.6.2.3.3.7.5,1,0,0-.6.6-1.2.5s-.7-1.8-2.3-1c-1.2-.7-3.3-1.4-3.4-1.6s.5-.9,0-1.2-1.3.3-1.8-.2c-.9-.8-.8-2.8-2.2-3.8s-5.2-2.7-5.5-2.8c-.3-.8-1.9-2.8-2.5-3.3-1.3-1.2-4.3-2.6-5.4-3.4s-3.5-4.6-3.8-4.7c-.5-.1-1.1.4-1.4.2-.5-.4-1.9-3.1-1-3.8Z"
          fill="#539bf7"
        />
        <path
          d="M368.1,448.7c1.6,0,1.2.9-1,2.5-6,3.2-12.5,7-18.3,10.6s-3,3.1-3.3,3.2c-.8.3-1.6,0-2.4.1s-.7,1.2-1.2-.5c-1,2.1-3.7,1.4-4.2,1.6-3.1,1.3-6.8,4.6-10.6,6.1-2.8,1.1-6.4,3.1-9.6,4.4s-5.5,2.8-6.7,3.1-3.8-.6-5.2-.2c.7-.3,1.7-.8,2-1.5.4-1.5,3.1-.9,4,0-.3-.8.8-1.4,1.5-1l.2-1.2c4.2-2.1,8.4-4.1,12.6-6.2h1.5c1.8-1.7,3.6-2.7,6.3-2.8,2.3-1.7,5.1-3,7.9-3.3,6.9-4.7,14.4-9.6,22.2-13.5s1.2-.4,1.8-.5c0-.9,1.9-1.9,2.5-1Z"
          fill="#519bf8"
        />
        <path d="M243.7,489.7c-.4,0-1.4,0-1.5,0,.5-.6,1-.6,1.5,0Z" fill="#4b98f3" />
        <path
          d="M111.8,435.2c.2-.3.6-.7.9-.6,2.4,1.1,5.9,3.6,7.6,5.6,1.7.5,3.4,1.6,4.9,3.4,2.8.9,5.2,2.7,7.3,5.3l5.9,2.3c2.4.7,3.7,1.9,3.9,3.4,3.2,1.3,6,3,8.6,5l-.6,1c-.2.8-.5.6-1,0-2.1-.5-3.6-1.7-4.7-3.5l-1.2,1c.4-2.5-.9-.9-2.5-1.5l1-1c-1.3.2-3.5-2.1-4.6-1.9s-1,.9-1.8.9c0-1-1.7-3.3-2.5-3.7s-1.1.1-1.5,0c-1.3-.6-3.2-2.2-4.5-1.7-1.6-2.3-3.1-2-4.4-2.6s-2.8-4.8-4.1-5.5-2.3-.6-3.4-1.1-2.1-2-3.5-2.7l.5-2Z"
          fill="#56a3fa"
        />
        <path
          d="M95.8,415.7c1.5,0,2.3,1.3,2.5,3.9,2.3,2.8,5.3,4.7,9,5.6,1.5-.5,4,1.4,4,3,1,.5,1.3,1,1,1.5.5,2.2,2.1,3.9,4.6,5l4.1,3.9-.2,1.1c.7.7.4.7-.5.5,0,0-.8.8-1,.5s.2-1.2-.5-1.8-2.1-.6-2.9-1.1-3.4-2.1-4.1-2.6c-1.8-1.3-3.8-2.9-5.5-4.3s-7.4-6.8-8.5-8.5-2.1-3.9-2-6.7Z"
          fill="#5fa6f9"
        />
        <path
          d="M99.8,417.7c1.9.4,4.8,3.1,5.5,5,1.5.7,2.1,1.6,2,2.5-1,.6-3.6-.3-4.6-.7-1.4-.6-4.8-3.5-5.4-4.7s0-3.3-1.5-4.1c0-.4,0-.9.5-1,1.1,0,2.3,1,3.5,3Z"
          fill="#64aaf9"
        />
        <path
          d="M83.8,401.2c.4,0,.8.2,1,.4,2.6,2.4,5.7,5.5,8.1,8.1s.3.6.4,1c.8.2,1.2.4.5,1-.3-.2-.7-.3-1,0-.2-.4-3.8-3.2-4.5-4-1.8.4-2.9-1.7-3.3-3.3l-1.7-2.2c-.3-.5-.6-1-1-1.5l1.3,1,.2-.5Z"
          fill="#6088ea"
        />
        <path
          d="M94.3,410.7c.3-.3.9-.7,1.1-.5,1.1.8,4.9,4.7,5.9,5.8v1.2c-.5.2-1,.4-1.5.5-1.1-.9-2.6-2-3.5-3s-1.3-2.2-2.5-3c-.2-.3-.3-.8-.5-1,.2-.8.5-.6,1,0Z"
          fill="#3952c3"
        />
        <path
          d="M88.3,407.7c0,1.5,2.2,2.9,2.4,3.9s-.5,1.9-.4,2.8c.1,1.7,1.2,2.9.8,4.9-.5,3.1-4.4.2-5.4-1.6l2,.2c-.7-1.5,1-1.8,1-2,0-1.9-2.5-2.4-2.5-2.6-.7-2.1,1.1-4.2-2-5.4l1-.5c-1.2-.8-.4-2.1-.6-2.9s-1.2-2-1.4-2.4c2,1.5,3.3,3.7,5,5.5Z"
          fill="#3466db"
        />
        <path
          d="M388.6,432.7c-.2.3-.3.7-.5,1-1.5,1.1-4.3,2.5-5.5,3.7-3.4,3.3-7.6,9-11.5,11.8s-2.9,1.4-4,2v-.7c.9-.5,1.2-.7,1-1.8l-.2-.7c3.7-2.7,7.2-5.5,10.7-8.5.7-2.8,5.2-5.5,7.9-7.1l1.1.2c.7-.7,1-.7,1,0Z"
          fill="#5596f2"
        />
        <path
          d="M472.1,171.8c1.4,3.3,2.6,6.7,4,10-.2-.5-1.8-3.1-2.5-2.5.2,1.7-1.1,3.5-1.4,4.9-.6,3.2.4,6.3.4,9.4s.3,1.7-1,.8c-.4-1.9-1.1-3.1-2.2-3.6l-4-12.9.7-1c.9-.7,1.4,1.5,1,.8-1.1-2-.7-6.4,1.5-7.3,1.3-1.8,2.6,0,3.5,1.5Z"
          fill="#75acfe"
        />
        <path
          d="M468.1,163.3c.3.3,1.2,2,1.5,2.5l.5,1c0,.1,0,.4,0,.5.7,1.5,1.4,3,2,4.5-1.1-1.4-2.3-1.1-3.5-1.5-.8,1.9-5.9-3.8-6-4.3-.2-1.6,2.2-4.7,4-4.2.6,0,1.1.6,1.5,1.5Z"
          fill="#7eb1fd"
        />
        <path
          d="M451.1,144.8c.2.4.6,2.8,1.1,3.4s2.6,2.2,3.1,2.7,4.3,2.9,4.5,3c1,.4.4-1.3,1.5-1,2,.8,2.2,4.4,2.8,5s1.1-.9,1.5.5c.6,1.5,1.9,3.4,2.5,5-.2-.3-1.3-1.4-1.5-1.5-1.8.7-3.4.6-4.8-.3-2,.8-3.6-.6-4.6-4l-1-1.1c-2.8-2.7-5.7-5.7-7.1-9.5l.2-1c-1.3-.2-2.8-2.4-1.5-3.5,1.4-.7,3.6,1,3.5,2.5Z"
          fill="#7db9fe"
        />
        <path d="M470.1,166.8l-.5-1c.2.4.3.7.5,1Z" fill="#93b8fa" />
        <path d="M461.1,150.3c0-.1-.4-.3-.5-.5l.5.5Z" fill="#92c2fd" />
        <path
          d="M441.6,126.9c.4.8.7,3.5,1.1,3.9s1.2.2,1.6.6c.9.9,1.8,2,2.8,2.7s1.4.2,1.4.3c.4.4-.7,2.1-.7,2.7-.4,3.8,1.5,2.7,1.6,2.9.8,1.1,1.3,3.4,3.6,3.4-1,.9-2.4,0-2,1.5-.1-.2-3-1.8-3.5-2.5-.5-.3-1-.7-1.4-1-2-1.7-9.3-12.7-10.1-15.2s-.3-1.1-.4-1.7c1.6-.8,5.7.6,6,2.5Z"
          fill="#84c6fe"
        />
        <path
          d="M431.6,118.9c2.2,2.3,2.8-.2,3.8-.4,1.7-.4,2,2,2.7,2.6,3,3,6.4,2.7,8.7,6.3s1,2,1.3,2.9c-1.1-.8-5.1-2.8-6.5-3.5s-4.1-1.5-6-2.5c-2-.2-4.4-3.5-4-5.5Z"
          fill="#8bcdfe"
        />
        <path
          d="M240.2,22.4c9.6-.8,16.6,0,25.7.5s3.1-.5,4-.4,1.5,1.1,2.1,1.2,2-1,2.9-.8.3,1,.6,1c5,.2,7.8,2,11.7,2.3s3.4-.4,5.3-.3,6.1,1.4,7.6,1.4,1.2-1,2.3-.8c1.6.2,3.4,3,3.7,3,1,0,1.5-.9,2.2-.8s3.7,1.5,4.6,1.8c2.8,1.1,6.5,2.4,9.4,3.4l-.2.8c-2,0-3.9-.7-5.8-1.8-.2.4-.3.4-.5,0l-.5-.5c0,.4-.3.4-.5,0-1-.1-1.8-.5-2.5-1l-.5.5c-3.1-.9-6.1-1.9-9.2-2.9-3,.2-6,0-9.1-.5-2.7,1.2-5.4.8-8.2-1.1-3.9,1-7.4.6-10.3-1.2-5.2,0-10.4-.3-15.5-.7l-.7-.8c-8,0-16.1.5-24,1.3l-8.8-.3-1.3-1h-.5c1.2-.6,3.1-1,4.4-1.2,3.7-.6,7.7-.9,11.6-1.3Z"
          fill="#dcfbfb"
        />
        <path
          d="M334.2,38.4c1.2.8,3.4-.4,3.7-.4s1.1,1.1,2,1.4c2.3.8,2.3.9,4,1.8s4.2.9,4.7,1.3.2,1.4.8,1.9,1.9.3,2.8.7,1.1,1.2,2,1.5c2.3.8,5.1,0,6.8.7s6.4,3.8,8.6,5c3.1,1.7,6.4,3,9.1,5.5-.8-.4-3.6-.8-4-1s.6-3.8-3-.5c-2.8-1.5-5.7-3.1-8.7-4.7-4.1-.9-7.9-2.3-11.3-4.2-2.3.8-4.3-1.6-4-3.6-4.4-2-8.9-3.6-13.6-4.7v-.8Z"
          fill="#defcfa"
        />
        <path
          d="M322.2,33.9c2,.7,4,1.3,5.8,1.9,3.6,1.1,2.6,0,6.1,2.6s9.5,1.5,13.5,5.5c-.6.8-1.9.4-4-1-3.5-2.7-5.8-1.6-9.1-2.6s-1-1-1.7-1.3c-1.4-.5-4-.1-4.6-1.6-4.3-.5-8.4-1.6-12.4-3.4l.4-1.1c0,0,.2-.5,1-.3,1.7.5,2.4,2.5,5,1.3Z"
          fill="#dafafc"
        />
        <path
          d="M224.7,24.9c4.9-.2,8.8.6,13.8,0,3.1-.4,4.8-1.1,8.5-.8s8-.4,12-.3.5,1,1.4,1.1c4.8.6,10.3-.5,14.9.5s.9,1.2,3.1,1.5,5.6-.5,6.9-.4c1.8.2,3.9,2.3,5.2,2.5s.6-.8,1.1-1c3.1-.9,3.3.2,5.4.5s4.1-.4,5.5-.3,8,2.7,9.7,3.3c.7.5,1.5.8,2.5,1,.2,0,.3,0,.5,0l.5.5c.2,0,.3,0,.5,0,1.8,2.6,5.1,2.1,7.5,2.7s1.2,1,1.9,1.2c1.3.3,2.5-.5,2.6-.4s0,.8,0,1c-2.1-.2-4.5.3-6.6-.2s-3.8-2.5-4.8-2.7-2.9,1.3-2.1-1.1c-2.1.5-6.6-2.4-8.2-2.3s-1.3.9-1.9.8-.8-1.7-1.6-1.9-2.2.8-3,.9-1.3-1.3-2.9-1.5-4.4.9-6.8,0l1,1c-4.2,0-8.3-.8-12.5-1-.7,1.4-3.3,1.5-4,0-9.1-.9-18.7-1.8-28.3-1.3s-1.2.4-1.7.8c-6.5,0-12.9,0-19.4,0-2.7.5-5.5.8-8.3,1-.2-.8-1-1.1-2.4-.9l-.7-1.1v-.7c4.1.3,7.7-.5,11-2.3Z"
          fill="#d5fafb"
        />
        <path
          d="M274.7,29.4c-1.5.6-3.1,1-4.7.7,2,.7,6.7,1.1,9,1.2s4.2.2,3.2-.9c4.1.6,8.5.7,12.5,2-.3.9-1.2,1.2-2.6.8l6.4,1.5.7,1.1c.4.1.4.3,0,.5-3.8.2-7.6-.3-11.5-1.4-3.5-.3-6.8-1-10-2.1-12.5-1.4-26.3-2.5-39-1.5-.3.4-.6.6-.9.7-4.5.6-9.9,1-14.5,1.2s-.7-.2-1.1-.4l-2.9.2c-.2.6-.4.4-.6-.2l.7-1.3,9-1.4c-1.1,0-2.2-.3-3.2-.8-.4-.1-.4-.3,0-.5,13-.8,25.8-1.6,38.7-1l10.7,1.5Z"
          fill="#6293f7"
        />
        <path
          d="M359.6,55.9c2,1,3.3-2.4,3.7-2.5s2.6,1.1,2.7,1.2c.8.6.7,1.9,1.1,2.1.8.5,2.9.5,4.1,2.1s.7,2.2.9,2.4c.4.3,4.6.8,5.5,1.2s1.2,1.3,1.9,1.6c1.6.8,4.7,1.5,6.5,2.5s.9,2.1,1.5,2.5,1-.2,1.5,0,1.1,1.3,1.9,1.7,4,1.4,4.2,1.6-.7,1.3-.5,1.5c2.8-.7,2.3.8,3.2,1.5s2.9,1.9,3.8,2.5l-.5,1-1,.5c-2.8-1.8-5.8-3.4-8.9-4.8-.7-1.4-1.7-2.3-3.1-2.6-3.8-2.9-7.7-5.6-12.5-6.1-.6,1.2-1.5.9-1.5-.5-4.2-2.7-8.6-5.2-13-7.5l-1.5-2Z"
          fill="#c9f7fb"
        />
        <path
          d="M331.7,43.4c4.4.2,18.8,8,23.5,10.5,4.6,3.6,1.4,4.5-2.5,2-.2.2-.3.4-.5.5-.7.5-13.3-5.8-15.3-6.8s-.2-.3-.2-.7c-.7-.3-1.4-.2-1.9.1l-19.9-7.5-.2-1.1,1.6-.6c5.1,1.5,10.2,2.7,15.4,3.6Z"
          fill="#6595f2"
        />
        <path
          d="M331.7,43.4c0,0-.4.5-.8.4-5.6-.2-10.8-2.1-16.2-3.4-1.5.9-3.1.5-4-1-3.8-1.1-7.6-2.1-11.5-3v-.5c1-.9,2.4-1.1,4.3-.6l.2-.9c9.5,2.2,19.1,4.9,28,9Z"
          fill="#6192f2"
        />
        <path
          d="M274.7,29.4c1.3,0,2.7,0,4,0,.8.4,2.7.9,3.5,1l5.5,1.5c-2.8-.5-6.2.5-8.7.5-4.6-.1-10.6-1.9-15.6-1.9-4.5-.6-11.7.3-16-.5s-2-.8-1.5-1.5c9.6-.2,19.1.5,28.7,1Z"
          fill="#5b8ff5"
        />
        <path
          d="M347.7,43.9c.6.6,1.6,2.5,2,2.8.6.4,1.4-.4,2.1-.2s1.9,1.8,2.9,2.1c2.5,1,6.2,1.3,9,2.5s5.4,3.7,8,5.2,3.9,2.3,5.9,3.4,4.1,2.7,6.6,3.2c-.2,2.6,1.5.3,2.1.9s.1,1.3.5,2c-2.5.3-8.8-5.8-10.2-5.5s-.2.9-.3,1c-.9.6-1.5-1.3-2.2-1.9-7-6.3-12.5-7.6-20.8-10.2s-4.6-1.2-5.3-1.9.3-.8,0-1.2-3.4-2.7-4.1-3.2l4,1Z"
          fill="#d6fbfb"
        />
        <path
          d="M359.6,55.9c5,2.8,9.9,6.2,14.5,9.5-.4.9-1,.9-1.8.5l-4.5-3c-1.5-1.1-2.3-1-2.2.5-.2.3-.6.8-.9.6-1.7-.8-11.1-6-12-6.9v-1.2c.7.3,3.4,1.4,3.9,1l-1.5-3c1.2.7,3.3,1.3,4.5,2Z"
          fill="#6a9cf1"
        />
        <path
          d="M294.7,32.4c3.1.2,6,1.3,9,2l2.5,1.5c-2.4.6-4.6.3-7,0s-7-2-10.5-2c0-2.2,4.4-1.6,6-1.5Z"
          fill="#5b8ff5"
        />
        <path
          d="M421.1,106.4c1.1,1.8,2.5,3.1,4,4.5,2.5,2.1,4.5,4.6,6,7.5.1.2.4.3.5.5,1.3,1.7,2.7,3.7,4,5.5,4.2,5.7,8.2,12,12,18s.8,2.4,1.5,3.5c.7,4.7-4.4-1.6-5.6-3.2-1.6-2.9-3.4-5.7-5.4-8.3-1.7-2-3.2-4.2-4.5-6.5-2.8-.7-4.5-4.1-5.3-6.6l-3.7-4.9c-3.8-2.6-8.2-7.6-9.5-12,.2-.9.9-1.6,2-2,1.4,1.5,2.4,2.6,4,4Z"
          fill="#6aa0fb"
        />
        <path
          d="M425.1,110.9c1.3,1.1,4,2.6,4.5,3s.2,1.9,1,3.5.3.7.5,1c-1.9-2.4-4.7-4.6-6-7.5Z"
          fill="#90cefd"
        />
        <path
          d="M391.6,78.4c1.2-1,2.7,0,2.5,1.5,2.4.7,5.6,2.4,6,5l4.3,3.8-.3.7c-1.4-.1-1,.4,1.2,1.7,1.3,2.1,2.1,2.5,2.3,1.3,1.2,1.4,2.8,2.3,4,3.5,2.6.8,3.7,2.1,3.5,4,.7.7,1.3,1.8,2,2.5-.7,2.8,1.1,1.4,1.3,2s-.3.8-.2.9c.3.3,1.3.1,1.9.8,1.4,1.6-.5,2.5-1,2.1-.8-.6-2.4-3-3.1-3.7s-.8,0-.9-.1l-1.9-.4c-2.9-4.3-6.5-8.5-10.6-11.6l-1.4-.5c-5.2-4.6-10.4-9.3-15.5-14.1l-.6-1.4,1-.6,5,3.3.5-.7Z"
          fill="#6a9ef5"
        />
        <path
          d="M411.6,95.9c1.4,1.1,2.8-.2,4.1,0s1.5,2.7,1.8,3.3c.5.8,3.9,2.5,5,3,2.1,1,5.2,1.6,7.5,3s1.8,2,3.1,2.7v.5c-3.6-.2-10.2-1.8-13.3-4s-2.4-4.2-4.7-4.5c-1.2-1.3-2.4-2.9-3.5-4Z"
          fill="#a1e2fb"
        />
        <path
          d="M400.1,84.9l1.4-.2c3.8,3,8,5.4,12.6,7.2.5,0,1.2,1.2,2.3-.5,1.2,1.5,3.2,3.4,5.2,3.5l-.5,1.5h2c-1.6,4.3,3.5,3,5,6-2.5-1-3.9-.8-6.5-2.8s-4.7-5.1-5.7-5.6-3.7-.7-4-.7-.3.9-.4.9c-.9.6-3.2-2.8-4.2-3.4s-1-.3-1.3-.5c-.9,1.1-2,.3-2-1l-4-4.5Z"
          fill="#aeeafc"
        />
        <path
          d="M404.1,89.4c.6.4,1.4.6,2,1,.5.7,1,1.4,1.5,2l2,3c-2.9-.4-4-2.7-5.7-4.3s-4-1.7-3.1-4.2c.9,1,2.1,1.8,3.3,2.5Z"
          fill="#6396f6"
        />
        <path
          d="M375.6,65.9c.7,0,1.3-.9,2-.7,4.8,1,7.3,3.3,11.1,5.9s1.7.4,2.2.7.1,1.2.4,1.4c.9.9,7.4,3.3,9.9,5.6s2.4,2.4,3.5,3.5c-.4-.2-1-.3-1.5-.5-.3.3-.7.4-.9.4-4.8-1.7-10.3-5.1-14.6-7.9-.4,0-.9,0-1.5-.5h-1.5c-2.8-2.3-5.6-4.6-8.7-6.6l-.3-1.4Z"
          fill="#c0f6fc"
        />
        <path d="M407.1,83.4l-2-1c.8.4,1.5.8,2,1Z" fill="#c0f6fc" />
        <path
          d="M403.1,81.9l5.7,5c2,.1,2.6,1.9,2.8,2v.5c-.3.4-.6.9-1,.8s-7-3.7-7.6-4.2c-2.1-3.2-5.3-4.7-8.9-6.1-.8-.6-1.9-1.1-2.5-1.5-1.6-1.2-2.9-2.5-4-4,5.6,1.9,10.5,5.5,15.5,7.5Z"
          fill="#b8f1fc"
        />
        <path
          d="M479.1,250.8c0,0-.6.2-.7.7-.3,1.2-.8,5.6-1.5,5.8s-2-1.8-3.4-1.5-.3,1-.6,1.1c-.5,0-1.3-.6-1.9-.6s0,1.3-.8,1l-1-1.5c0,.9-.4,1.7-.5,2.5-.2-.4-1-1.2-1-1.5-1.2-.3-1.2-1.4,0-3.2v-5.1c0-2.2,1.3-3.5,3.3-2.1,1.7-2,3-2.5,4.1-1.3l2.6-.3c0-2.6.6-3.6,2-3-.1,2.7.2,6.4-.5,9Z"
          fill="#5a81f9"
        />
        <path
          d="M466.6,234.3c1.2-.9,1.8-.2,1.9,1.2-1.4,4.8,2.4,4.8,6.2,3.7.4-1.6,1.8-2,3.9-1.4,0,.5,0,1,.5,1h.5c0,1,0,2,0,3-1.4.7-.6,3-1.5,3.8s-3.1.6-3.3.5c-.6,0-.8-1.1-1.7-.8l.5,1.5c-2.1-1.1-1.8,1.1-2.7,1.5s-.6-2-1.7-1.5c-1.3,2.3-.4,4.7-.6,6.6s-1.1,2.1-.9,3.4l-2.5.5c.7,2.3.2,5.2-.5,7.5l-.9-.6c0,3.1-.4,6.2-1,9.2h-1.2c-.9-3.5-.8-7,.5-10.6l.5-8.4c.3-4,.4-8,.5-12,.1-1.3,1.2-1.3,1.5,0,1.2,1.8,1.4,3.4,1.4,5.6.5-4.4.6-8.8.3-13.3l.3-.3Z"
          fill="#5e87fb"
        />
        <path
          d="M461.6,273.3c0,0,.4-.3.5-.8.3-1.9,1-12.7,1.6-13.2.7-.7.9,0,1,.7.2,1.4,0,3.3,0,4.8,0,2.5-.2,5.6-.5,8s-.6,2.8-1,3.5l-.6.2c-.2,2.4-.8,4.2-1.9,5.3-1.6-2.1-.9-6.8,1-8.5Z"
          fill="#618ef5"
        />
        <path d="M479.6,238.8h-.5l.5-.5c0,.2,0,.3,0,.5Z" fill="#5a81f9" />
        <path
          d="M454.6,322.7c-1.6,4.5-2.7,9.7-4.9,14.3-.8,1.6-1.7,2.3-2.5,4s-1.5,3.1-2.1,4.7c.1.2.2.4,0,.6-2.1,4.3-7.1,14.6-10.4,17.6s-.4,0-.7-.2c-.3-.2-.3-.6,0-1-.5-.3-.3-1,.5-2,1.3-3.4,3.5-7.4,5.6-10.6s.5-.3.9-.4c3.5-6.4,6.7-13.1,9.5-19.9l1-.6.5-1c-1-1.1.7-3.6,1.5-4.5.1-.3.8-.7,1-1Z"
          fill="#596bd2"
        />
        <path
          d="M453.6,323.7c-.7,1.4-.9,3.1-1.5,4.5l-.5,1c-3.1,7.7-6.3,13.4-10.5,20.5-1.1-.3,0-1.8.5-2.5,3.4-6.9,6.4-13.9,9.2-21l.8-.5,1.3-3.5c.4-.9.8-1,1.2-.5-.2.6-1.4,1.2-.5,2Z"
          fill="#6171db"
        />
        <path
          d="M462.6,294.8c-1.3,6.3-2.7,10.1-4.9,16.4s0,4.9-2.1,6.1l-.6-.3,1.6-5.7c-.8-.5-.3-2.2.5-2.5,1.9-4.9,3.8-8.8,5-14,.1-.4.3-.4.5,0Z"
          fill="#5f73e7"
        />
        <path
          d="M455.6,317.3c-1.1,1.3-1,2.8-1.5,4.5-1.8.5-1.2,2.1-1.6,3.1s-.8.8-.9.9l-.5-.3c1-2.5,1.8-5.1,2.5-7.7-.4-.1-.4-.3,0-.5,1.1-1.9,1.8-3.8,2.4-5.9h.6c0,0-1,5.9-1,5.9Z"
          fill="#6478e6"
        />
        <path d="M462.6,294.8h-.5c0-.3,0-.7,0-1l1.5-2c-.2,1.1-.8,1.9-1,3Z" fill="#5874ed" />
        <path
          d="M457.1,308.8c-.3.8-.3,1.9-.5,2.5-.8,2.1-1.1,4.6-3,6-.2-.4-.4-.8-.3-1.1,1.2-5,2.9-10.3,4.8-14.9l.5-1.5c-.5,0-.4-.2,0-.5l.5-2,.5-.5c-.4,0-.3-.7,0-1l.5-1.5c-1-.3-1-.7,0-1,.1-.4.3-.4.5,0-.4,2.8-.4,7-1.1,9.6s-2.1,3.7-2.4,5.9Z"
          fill="#6f87f0"
        />
        <path
          d="M463.1,276.3c0,.3,0,.7,0,1l-.5,2.5c-.6,4.5-1.3,9-2,13.5h-.5c-.3-.3-.6-.6-.6-1,.4-6.1,2.1-6.7.2-1s-.3,0-.7,0c-1.6-2.2-.5-7.7,1.5-9.5.6-2.6,1.6-5.2,1.5-8,1.3.4.9,1.6,1,2.5Z"
          fill="#719bf8"
        />
        <path d="M462.6,279.8c0-.8-.3-2.1.5-2.5,0,1.3-.4,1.8-.5,2.5Z" fill="#618ef5" />
        <path
          d="M444.1,349.2c.4.1.4.3,0,.5l-.5,1c-1.6,4.1-3.7,7.9-6.5,11.5-.5.9-3.4,5.6-3.8,5.7s-.5,0-.7-.2c-1.1-1.2.5-3.1,1.5-4,.6-.9,2.5-2.6,2.9-3.3,2.4-3.8,4.8-11.5,8.1-14.7s1.1-.6,1.5-1c-.8,1.5-1.7,3-2.5,4.5Z"
          fill="#5162c8"
        />
        <path
          d="M448.1,346.7l-.5,2.7c-3.9,6.3-7.8,12.6-11.6,18.9-1,4.7-3.4,7.3-6.9,10.3l-7.3,10.1-1.6.4c-.4,3.1-4.5,7-7.5,7.5v-1c2.7-3.2,5.3-6.3,8-9.5,5.1-7.2,10.3-14.4,15.5-21.5,3.1-5.8,6.5-11.4,10-17,.2-.3.3-.7.5-1h1.5Z"
          fill="#3945b2"
        />
        <path
          d="M436.1,364.7c-.2-.7.2-1.5,1-2.5,2.2-3.8,4.5-7.6,6.5-11.5l.5-1c0-.1,0-.4,0-.5l2-1.5c-.9,1.6-1.7,3.2-2.4,4.8l-7.6,12.1Z"
          fill="#4250b7"
        />
        <path d="M428.1,389.7c0-1,.6-1.6,1.5-2-.7,1-.6,1-1.5,2Z" fill="#354abd" />
        <path
          d="M433.6,376.2c-1.1,2.3-2.4,4.4-4,6.5-.8,2.8-3,4.5-5.3,6.2l-2.2,3.3c-1,3-4.5,6.6-7.5,7.5-.7,1.2-1.8,2.1-3,2.8-4.4,5.2-4.9.9-1.5-2.8-.3-1.5,1.1-3,2.5-3,2.6-2.3,5.3-4.8,7.5-7.5h1.2c2.1-2.5,4.2-5,6.3-7.6,0-1.4.8-2.3,2.5-2.7,1-1.8,2.1-2.7,3.4-2.7Z"
          fill="#3042b0"
        />
        <path
          d="M425.6,390.7c-3.4,4.2-7.7,8-11.5,12-1,.8-1.6,1-2,.5l-.3-.6c1.1-.8,2-1.8,2.8-2.9,2.6-2.3,5-5,7.5-7.5,1.2-2,2.7-4.4,4.9-5.3s.4.1.6.3c-.3,1.2-1.2,2.5-2,3.5Z"
          fill="#4762c6"
        />
        <path
          d="M430.1,382.7c-.6.9-1.4,1.4-.5,2.5-.8.8-1.1,1.2-2,2-2.2,2-2.3,1.2-2.9,1.6s-1.7,2.5-2.6,3.4c1.5-3.8,5-6.4,7.5-9.5h.5Z"
          fill="#4057c2"
        />
        <path
          d="M448.1,346.7c.6-.9.9-2,1.7-3.1s0-1.2,1.3-.9c-.1,2.5-1.2,4.7-2,7-1.8,2.4-3.1,5.5-4.5,8.1-2.6,4.6-5.2,9.8-8.3,14.3s-1.6,1.6-2.7,4c-.9,1.1-2,2.7-2.8,3.5s-1.7.6-2,1,.3,1.3.2,1.4-1,.3-1.4.8c-1,1.2-4.7,6.5-5.5,7s-1.7.2-2-.8c2.8-3.4,5.6-8.2,8.6-11.7s3.6-2.8,4.3-4.1c1.4-2.6,1.5-5.3,3.7-8.5,4.1-5.8,7.3-11.8,11.3-18.1Z"
          fill="#323cad"
        />
        <path
          d="M464.1,205.8c1.2.6,1.8,3.2,2.1,4.7-.3,1.2,2,11.4,3.4,10.3-.2-1.5.6-2.9,2.2-2.8l.2-2.4c-1-.9-1.5-2.3-.5-3.3-1.3,0-1.2-.7,0-1-1-.8-.8-1.6.2-2.3,3.6-2.8,4.2,6.2,4.1,8.4,1.2,2.1,2,4.6,2.2,7.4h.5c0,.2,0,.3,0,.5-.1.9-.4,1.5-.9,2-1.7-1.6-3.8-.7-5.6.2-2.1,4.6-3.3.4-3.5-2.6-2.3-.4-2.9-3.2-2.9-5.2-1.4-4.1-2.2-8.4-2.4-12.9l.9-1.1Z"
          fill="#6798fd"
        />
        <path
          d="M465.6,219.8c.2,1,1.3,2.9,2,3.7s1.1.2,1.6.6c1.1,1.2.5,3.2,1,4.7,1-.1.7-1.4,1.1-1.9.8-.8,6.3-2.8,6.4-.2l1-1.5c0,1.2,0,2.9,0,4.2s1,3.3.4,4.1-.8,0-.8.1c-.5.7.5.9.5,1,.1,2.6-2.5,1.8-3.2-.2-.4-.3-3.6,1.6-2.4,2.5-2.7,4.9-3.9-1.8-4.2-4.5-1.5-1.7-2.4-3.9-2.6-6.4-1.1-1.1-1.5-5-1-6.5.1-.4.3-.4.5,0Z"
          fill="#6091fc"
        />
        <path
          d="M466.1,226.3l1.5,1c-1.2-.1-1.1.4-1,1.5,2.3-.5,1.2,1.1,1.8,2.4s.9.6,1.1,1c.8,1.8.3,4.5,1.8,6.1,1.5-2.1-.3-2.1-.3-2.2,0-1.5,1.7-1.1,2.1-1.3.6-.3,1-1.9,2.8-.9s.9,2.7,2.6.9c.8,1.8.1,1.5,0,3-.4,1.3-1.8.9-2.8.5-.5.3.5,1.2.3,1.5s-4.3.9-4.5,1c-.3.3.4,2.8-1,3l-.5-3.5c-.3-.2-1.4.6-1.5.5s-1.4-2.7-1.4-2.9c-.3-1.3,1.3-2.9-.6-3.6-.6-2.4-1.3-5.8-.5-8Z"
          fill="#5d8bfb"
        />
        <path
          d="M471.6,194.8c1.1,3.1,1.8,6.3,2.5,9.5s.6,4.1,1,6,.8,1.3,1,2.3c.5,2.3-.6,4.8,2,6.7,0,1.8,0,3.7,0,5.5-1.6-.6-.8-2.6-1.1-4.1s-1.6-2.4-1.7-3.2c-.3-1.9.5-4.1-.5-6.5s-2.8-1.8-3.1.4c-1.8.8-3.3-2.4-2.1-3.9v-2.5c-2.4-2.9-2.1-5.6-.9-9.1.3-4.6.9-8.4,3-.9Z"
          fill="#6a9bfc"
        />
        <path
          d="M457.6,159.8h.7c2.8,5.3,5.6,10.5,8.2,15.9l-.5,1.1,5.5,17.5v.5c-.4-1.2-.9-3.3-2-4,1.4,3.4-1.5,6.4-1.3,9.2s1.7,3.2,2,5.3-2.1,4.1,1.3,6.1c0,.3,0,.7,0,1-.2.8-.5,1.6-.7,2.5h-.7c-1.2.5-1.6-.3-1.2-2.4-1.7-2.6-2.1-4.8-.3-7.2q.2-.2,0,0c-1.4.7-3-3.8-2.9-4.7,1.6-2.9,1.7-6.8.4-9.8l-1.1-.9-2.4-12.6-1.7-1.8c-1.8-7.2-4.8-14.1-8.7-20.6.5-3.4,2.3-.5,3.3,1.2l2.1,3.8Z"
          fill="#6a9ffe"
        />
        <path
          d="M37.3,150.8c0,2.3-1.2,6.6-3,8-.9-.2-.6-1.3,0-1.4-3.6,7.4-6.7,15.1-9.3,23.1l-.7.3c-.1.4-.3.4-.5,0,.2-1.3.2-2.7.5-4,1.1-4.6,3.3-10,5-14.5h.5l5.7-11.3c.6-1.1,1-1.4,1.7-.2Z"
          fill="#5a8aee"
        />
        <path
          d="M38.3,142.8c-1,3.3-3.9,7.2-5.5,10.5l-1.5,1c.5-1.3,2.4-3.4-.5-2,2.3-3.7,4.4-7.4,6-11.5.5-.3,2.4-3.1,2.5-1.3s-.8,1-.9,1.6,0,1.3-.1,1.6Z"
          fill="#91afea"
        />
        <path
          d="M82.8,85.4l1,.5c-1.5,1.4-.5,2.1-.5,3.5.2.4,0,.9-.5,1.5.2.8-.5,1.3-1,.5-4.4,5.4-9,10.6-13.9,15.6-.6.4-1.1.4-1.5-.2l2.9-4.4c2.8-5.3,7.7-10.7,12-15.5.5-.5,1-1,1.5-1.5Z"
          fill="#f8fcf4"
        />
        <path
          d="M69.3,102.4c-1.8,3.4-4,6.4-6.6,9.3l-1.4.2c.1-.2-.1-.8,0-1,5.8-5.9,10.1-13.5,15.5-19.7s3.2-2.8,4.5-4.3l-12,15.5Z"
          fill="#d5f6f7"
        />
        <path
          d="M82.8,82.4c2.2-1.6,2.4-3.1,4.3-4.5s1.3-1.1,2.2-1c.8.7-4.9,5.4-5.5,6l-1-.5Z"
          fill="#74a5f0"
        />
        <path
          d="M104.8,62.9c4.7-4.1,6.9-3.3,1,1,0,0,0,.4,0,.5l-2,1.5c-2.1,1.7-4.3,3.4-6.5,5,2.3-2.2,4.7-4.3,7-6.5l-7.5,5c2.4-2.2,5.4-4.6,8-6.5Z"
          fill="#85baf2"
        />
        <path d="M79.8,86.9l1-1.5c0,0-.3.8-1,1.5Z" fill="#74a5f0" />
        <path
          d="M54.3,123.4v-.5c2.1-3.4,3.7-7.2,6-10.5.2-.2.9-.4,1-.5l.3,1.4c-1.8,3.4-3.9,6.6-6.1,9.8s-.7.5-1.2.3Z"
          fill="#d6edf8"
        />
        <path d="M65.3,104.9l.5-.5c-.1.2-.4.3-.5.5Z" fill="#74a5f0" />
        <path
          d="M46.3,135.8c-.3,1.9-.8,3.7-1.5,5.6l.5.4c.5.3,0,1.2-.5,1.5-1.1,4.4-6.4,9.4-3.5,2,.6-1.9,2.6-5.6,3.6-7.7s.6-1.5,1.4-1.8Z"
          fill="#8cc2fc"
        />
        <path
          d="M53.8,123.9c.2.1.2.3,0,.5l-.5.5c.2.2.2.3,0,.5l-1,1c.4.1.4.3,0,.5l-.5.5c.4.1.4.3,0,.5l-.5.5c.4.1.4.3,0,.5l-.5.5c.4.1.4.3,0,.5,0,.9,1,.2,1.5-.5-.4-.2-.4-.3,0-.5.3-.4.7-.6,1-.5.6-.2.6.3,0,1.5.6,1.7-2.2,5.3-4,5.5-.5,1.3-1.1,2.1-2,2.5-.4.5-2,2.3-2.2,1.3s3.5-7.2,4.2-8.3c1.5-2.9,3-4.9,4.5-7.5.3.1.3.3,0,.5Z"
          fill="#afddfa"
        />
        <path
          d="M49.3,130.8c-1.4,2.7-2.2,5.7-4,8.3l2-1.3c.5,1.1-1,3.4-2,4l-2,1.3c1.1-2.4,1.9-4.9,3-7.3s1.6-3.9,3-5Z"
          fill="#9acffa"
        />
        <path
          d="M45.3,143.3c.2,1.8-.5,3.1-2,4l-3.3,6c-1,1.1-2.7-.3-1.7-1.5.6-1.7,1.5-3.3,2-5l.5-1c0-.2,0-.4,0-.5h.5c-.3.8-.7,2.7-.3,3.5,1.5-1.6,2.7-3.6,3.8-5.5.1-.4.3-.4.5,0Z"
          fill="#7db2fb"
        />
        <path d="M54.3,123.4c.4.1.4.3,0,.5h-.5v-.5c.1-.2.4-.3.5-.5v.5Z" fill="#caedfb" />
        <path
          d="M38.8,143.8c1.3,0,1.7-.4,1.5,1.2s-1.4,3.2-2,4.8c-.2.8-.6,1.1-1,1-.3.2-1.2,0-1.4.8l-6.1,10.7c2.3-6.4,5.8-12.5,9-18.5Z"
          fill="#6591f0"
        />
        <path d="M40.3,146.8c.1-.4,0-.8.5-1,0,.4,0,.8-.5,1Z" fill="#74a4f3" />
        <path
          d="M112.3,58.9c-2.2,1.6-4.1,3.7-6.5,5,1.2-1.2,2.5-2.2,3.5-3.5-1.4.5-3.3,1.6-4.5,2.5,1.5-1.2,3.4-3.1,5-4l2-1c.2,0,.4,0,.5,0,1.5-.6,1.5-.2,0,1Z"
          fill="#88c7f4"
        />
        <path
          d="M111.8,57.9c-.4.9-1.5.7-2,1v-.5c.1,0,.3,0,.5,0l.5-.5c.3,0,.7,0,1,0Z"
          fill="#90d2f5"
        />
        <path d="M110.3,58.4v-.5h.5c0,.4-.2.5-.5.5Z" fill="#a1dcf8" />
        <path
          d="M224.2,24.9c.2,0,.3,0,.5,0-2.9,3.7-7.3,1.7-11,3l-.7.9c-3.6.8-7,1-10.3.5l-1.6.9c-3.5.2-7,.4-10.3.6,1.3-1.2,3.6-1.4,5.1-2.1s4-2.5,5.4-2.9,4,.6,5.8.5c4.1,0,6,0,10,.2s4.7-1.6,7.3-1.8Z"
          fill="#d6faf9"
        />
        <path
          d="M213.7,27.9c1.3.1,2.7.2,4,.5l-.5,1c2.7,0,5.3-.3,8-.5v.5c-3.5,1.6-9.3,2.6-13.3,2.6-1.2.3-2.2,0-3.2-.6-6.4.6-12.8,1.2-19.2,1.7-3,2.9-6.4,4.3-10.1,4.2-2,1.7-5.2,2.2-7.9,2.2l-9.4,2.4-.8-1c0-1.1,2.8-2.2,4.1-2.6,2.3-.2,4-.6,5.8-2.1,4.4-.7,9.1-1.8,13-3.2,2.1-.5,4.3-1.4,6.5-2s3.5-.9,5.4-1.4,2,0,2.8-.1.3-1,.3-1c1.1-.8,1,1,1.2,1,.8,0,1.1-.9,2-1s2.3.6,3.5.6c2.8-.1,3.5-1.5,7.7-1Z"
          fill="#cff9fa"
        />
        <path
          d="M136.3,51.9c.4.5,0,1-1.5,1.5-1.1,2.2-3.4,3.7-6.8,4.6-1.7,1.7-3.5,2.9-5.6,3.7-.3,1.4-1.5,1.9-3.6,1.4l-8.5,6.8-1-.4c-.8,2.6-1.4,3.1-4.2,3.4-8.1,4.7-15.4,10.8-21.7,18.2h-.6c0-.6.5-1.3.5-1.6,6.3-5.1,11.6-12.8,18.5-17s12-10.4,18.5-13.5l12.2-6.3c1.8-1.7,3-2,3.7-.7Z"
          fill="#cff8fd"
        />
        <path
          d="M184.3,32.9c.3,1.8-1.5.6-2.5,1.3-2.6,1.7-4.9,1.9-8.5,2.5s-1.6-.4-1.9-.2c-.4.3-.7,1.7-2.6,2.2s-2.5-.2-3.3,0-3.8,2-4.2,2.3l-.3,1.3c-3.7,1.5-7.2,3.3-10.5,5.4-2.7.1-5.3,1.2-7.6,3.1l-.6-.4-.7-.6c-1.4.8-2.8,1.5-4.3,2.1,0,.8-.8.8-1,0-2.6-.3-1.9.9-3.6,1.6-3.8,1.6-8.4,3.5-12.4,5.4l14.3-8.4c15.1-4.9,28.6-13,44-16.9,1.2-.3,3.7-.2,5.7-.7Z"
          fill="#d3f9fb"
        />
        <path
          d="M274.7,13.9l14,2.5c-2.9.7-7.3-1.2-9.7-1s-1.5,1.1-2.5,1-1-1.4-1.6-1.6c-1.2-.3-3.4.2-4.9,0-8.6-.9-16-1.2-24.5-1s-9.2.3-13.7.5c1,1.8-1.4,1.4-2.2,2s-.1,1.2-.6,1.6c-1.2.9-3.8.3-5.2.2l1,1.3c-1.9.8-4,1.3-6.5,1.5-.3,1.5-1.3,1.3-2,0-.5-1.7.5-3.3,2.4-3.4-5.5,0-11.6.6-16.3,3.6,1.1.4,1.7,1,1.9,1.8l-.2.7-4.8.8-2.6,1.3c-14.3,3.2-28.6,7.9-41.9,14.1l-3.9,1-.2,1.1c-6.2,2.6-12.3,5.6-18.2,8.9l-.6-.4c-14.5,8.5-27.8,18.7-40.1,30.1-.5,0-1.6-1.1-1.5-1.3.4-2,8.3-8.7,10.5-10,6.1-5.6,12.6-10.7,19.6-15.3,1.2-2.3,4.2-5.1,7-5,3.2-3.1,7.2-6,11.5-7,.3-.8.8-1.4,1.5-1.8,5.3-2.5,10.6-5,16-7.3,1.6-1.2,3.3-1.9,5-1.9.8,0,1.3-.6,1.4-1.4,3.8-1.3,7.6-2.8,11.4-4.3.4.4.8.5,1.2.3.1,0,.4,0,.5,0,.2-1,1-1.3,2.5-.9,0-.9,1-1.2,2.6-.9,1-.9,2-1.4,3.3-.7.2,0,.3,0,.5,0l.5-.5c.2,0,.3,0,.5,0l1-.5c.3,0,.7,0,1,0-.2-.6,0-.8.5-.5.3,0,.7,0,1,0-.4-.5-.1-.7,1-.5.3,0,.7,0,1,0,1-1,4.1-2.2,5.5-1.5.4-.1,1.1.1,1.5,0l.5-.5c.3,0,.7,0,1,0l.5-.5c.2,0,.3,0,.5,0,11.1-2.9,22.9-4.2,34.3-5.5h6.1s1.3-.7,1.3-.7c10.8-.6,21.6,0,32.2,1.7Z"
          fill="#fcfafa"
        />
        <path
          d="M270.7,12.4c2,.2,3.5.7,4.5,1.5-.2,0-.3,0-.5,0-10.7-.6-22.8-1.5-33.5-1h-6.2c-1.6.6-5.5,1.1-2.8-.5,1-1,3.7-1.2,5.2-1,7.5-.5,15.9-1,23.6-.5s.2.2.3.5c2.4-.7,7-.1,9.2,1Z"
          fill="#c2f1f7"
        />
        <path
          d="M232.2,12.4c-1.4,2.2,2.2,0,2.8,0,1.6-.1,4.3,1,6.2.5-13.8.7-26.9,3.7-40.5,5.5l1.5-.5-.5-1c1.5,0,2.1-.4,3-.5s.3,0,.5,0c.9-.4,2.2-.4,3,0,.1-.2.5-.4,1-.5.3,0,.7,0,1,0l1-.5c3.6-.5,7.6-.8,11-2,1.5,0,3,0,4.5,0l1.5-.5c.6,0,1.4,0,2,0l1-.5c.3,0,.7,0,1,0Z"
          fill="#c3f0f7"
        />
        <path
          d="M204.2,22.9c-.9.3-4.2-1.8-3.5-2.5s1,0,1.4-.3c2.6-1.7,3.4-1.9,6.5-2.6,4.4-1,9.2-1.5,13.6-.6-.7,1.7-3.7,1.3-4.7,2s-.2,1.8-1.3,2c-4,.5-8.1,1.2-12,2Z"
          fill="#fdfcfb"
        />
        <path
          d="M131.8,50.4c-6.8,4.6-13.9,8.8-20.4,13.8s-6.7,5.5-9.5,8.2c-6.1,5.7-12.3,11.4-18.5,17-1.5-.4-1.7-1.7-.5-4,4.7-5,9.5-9.8,14.5-14.5,2-1.9,4.2-3.6,6.5-5l2-1.5c-.4-.1-.4-.3,0-.5l3.3-2.8c.5-1.4,1.6-2.3,3.2-2.2,1.9-1.9,4.4-4.6,7-5,.6-.4.9-.4,1,0-2,1.7-3.9,2.7-6,4.3s-2.6,3.2-3,3.4-1.9-.5-2,.8l1,1c-3.7-.8-2.9,1.3-3.1,1.4-.4.3-2.1.7-2.9,1.8s-.4,1.7-.5,1.8c-.2.2-1.1-.4-1.5-.2s-.7,1.3-1.1,1.6c-1.4,1-2.8,1-4.1,2.6s-.4,1.7-.9,2-1.4-.2-1.7,0-2.7,3.8-2.1,4.4l-1.5-.5,1.2,1.5c12.1-11.3,25.3-21.4,39.7-29.5Z"
          fill="#f8fcfa"
        />
        <path
          d="M138.8,39.9c5.6-2.5,10.9-5.2,17.1-7.6,2-.8,3.8-3.2,6.9-2.4,0,.7-.9.6-1.5,1-6.9,4-15.3,7.1-22.5,11,.2-.7-.5-.6-1.9.4l-4.3,2.5-.8-.3v-.5c2.5-1.4,3.8-2.6,7-4Z"
          fill="#bcebf6"
        />
        <path d="M114.5,59.9c.3.2.3.3,0,.5v-.5Z" fill="#f8fcfa" />
        <path d="M116,58.9c.3.2.3.3,0,.5v-.5Z" fill="#f8fcfa" />
        <path d="M105.8,64.4c-.9,1-1.3.9-2,1.5.4-.9,1-1.5,2-1.5Z" fill="#e2f3fa" />
        <path
          d="M112.3,57.9c1-.5,3.6-3.2,5.1-4.2s2.7-1.5,3.9-1.8c-.6.7-1.3,1.4-2,2-2.2,1.9-4.7,3.3-7,5l.5-.8-.5-.2Z"
          fill="#90d2f5"
        />
        <path
          d="M50.3,356.2c.4,1.2.9,1.9,1.5,3,.8,1.5,1.3,2.8,1.5,4,.5,1.4,2.1,5.4,1.8,6.5s-3.1,3.1-4.3,1.5c-1.7-2.9-3.3-6-5-9,.9-.9,1.7-.3,2.5,1.6,1.3-.1-.4-7.6-.8-8.8l.8-.8c-.2-.6-.7-1.3-1-2,.1-.4.3-.4.5,0,1.2.3,2,1.6,2.5,4Z"
          fill="#303eaf"
        />
        <path d="M64.8,379.7c-1.6-1.9-3-3.4-4.5-5.5s-2.5-4.4-4-7l8.5,12.5Z" fill="#364cc3" />
        <path
          d="M55.8,366.2c-.4-.7-2-2.1-2.5-3-.5-1.3-1.4-2.5-1.5-4,1.2,2.4,3.1,4.4,4,7Z"
          fill="#3a46c0"
        />
        <path
          d="M36.3,336.7c1.5-.3,1.2,0,1.8,1,1.9,3,1.3,5.1,2.1,6.9s1.7,1.3,2.2,2c.7,1,1.6,5.5,2.2,5.5s1.2-.6,1.7-.3,1,2.4,2.1,2.5c.4,1.3,1.4,6.1,1.5,7.3s-.6,2.7-.5,4.2c-2.1,0-1.9-2.7-3.5-3.5-.2-.3-.8-.7-1-1-1.2-2.1-2.2-4.8-3.5-7,.6-.9.1-3.6-.1-4.6-.6-2.2-2.4-4.7-2.7-6.4s.4-1.9.2-2.6-1.9-2.8-2.4-3.9Z"
          fill="#2d37a6"
        />
        <path
          d="M61.3,368.7c.3-.2.6,0,1,.5,1.3.8,2.3,2.6,3,4h.7c4.3,5.3,8.4,11,12.4,16.9v1.1c0,0-.8.3-.8.3,1.6,2.3,3.3,4.6,5.2,6.7.3,0,.6,0,.8.1,1.9,1.8,3.8,4.1,5.5,6.2s0,.5-.2,1l4.8,4.3c1-.3,1.2.2.5,1-.3,0-.7,0-1,0-3.2-3.2-6.4-6.1-9.5-9.5-4.9-5.4-9.6-11.1-14-17s-6.8-9.4-10-14.5c-.7-1.7.3-2.5,1.5-1Z"
          fill="#4f65c4"
        />
        <path
          d="M37.3,324.2l.9.7,7.1,17.8c1.5,1.2,2.5,3,2.9,5.6,2,2.2,2.9,4.4,2.6,6.4-.4-.5-.4-1.1-1-1,0,.9.2,1.7.5,2.5-.8-1.2-1.9-2.8-2.5-4l-5.5-11.5c-1.2-2.9-3-6.4-4-9s-1.3-4.9-2-7c-.5-1.9,0-2.4,1-.5Z"
          fill="#5d6fe1"
        />
        <path
          d="M47.8,343.7l1.1.6c-.3,2.4.3,4.4,1.9,5.9l1.3.4c1,1.5,2.8,5,2.2,6.6-.2,1-.8.8-2-.5-.4-.6-1-1.4-1.5-2-1.7-4.2-4.1-7.6-5.5-12-.6-1.2-.9-2.4-1-3.5-.2-.9-.4-1.8-1-2.5-.4-.1-.4-.3,0-.5l-.5-1c-1-.4-1.9-2.3-1-3h.5l1.4.7c1.5,3.6,2.9,7.2,4.1,10.8Z"
          fill="#4552c5"
        />
        <path
          d="M54.3,357.2l1.1.6c2.2,3.6,4.1,7.2,5.9,10.9-.8-.2-1.1.4-1.5,1-2.7-4.2-5-8.7-7.5-13l2,.5Z"
          fill="#4d5cc1"
        />
        <path
          d="M23.4,196.3l.6.8c.4,4.3.2,8.7-.6,13,.8.8.3,1.4-.5,2.2-.1.4-.3.4-.5,0l-.7-1c-.1-5.2-.7-10.1-1.5-14.5h-.7c1.4-4.9,2.2-10.6,4-15.5l.5-.5h.5c.4,0,.7.1.7.3.6,3.3-.4,8-1.3,11.1,1,1.4.5,2.8-.3,4.2Z"
          fill="#5282ed"
        />
        <path d="M23.4,181.3c0-.2.5-.4.5-.5,0,.2-.5.4-.5.5Z" fill="#5688f1" />
        <path
          d="M17.9,218.3c.8.2.9,1.1.5,2.6.9,3.2,2.2,6.1,3.8,8.6-.1,2.3.4,3.9,1.5,4.8l-.3,8.5c1.4,1.1,1.4,2.9,0,4,.8,4.5,1.4,8.6,1.4,13.2s-.1.7-.3,1.1-.4.8-.6,1.1c-1.5-3.8-2.3-8.1-2.4-12.8-1.6-3-2.2-6.4-1.7-10.2-1-1.6-1-2.8.1-3.4l-1-.4-1.4-7.5c.6-.4.7-.9.5-1.5-1.6.7-2.9-2-1.5-3,.9-1.8-1.2-4.9,1.5-5Z"
          fill="#446ce8"
        />
        <path
          d="M19.9,206.3c1.5.4,1.5,3,1.4,4.6-.6,2.8-.4,5.2.2,7.9-.4,2.3-.5,4.5-.2,6.7,2.2,1.5,3.1,3.1,2.6,4.8.6,1.8.7,3.9.3,6.3.8,1.5,1,5.6-.8,6.2,0-1.5-.4-2.6-.4-3.8s.6-4,.4-4.2-1.1.3-1.6-.3-.5-5-1.1-6.3-3.1-5.3-3.4-7.2.5-2.1.5-2.7c0-1.3-.5-4.3-.3-5.8s2.2-2.2-.3-5l2.5-1.3Z"
          fill="#4775eb"
        />
        <path
          d="M19.4,196.8c0-.3,1.1-2,1.2-2,1,0,.3,1.8.4,1.9,0,.1.9,0,.9.3,0,.7-.8,1.1-.8,1.5s.7,1.7.8,2.5c.3,3.8.3,7.5.5,11.2.4.2.4.3,0,.5v1c.6.3.7.7,0,1-.4,2.3.3,5.3,1,7.4l-.4,1.8c3.2-1.5,2.5,5.4.9,6.3,0-2-.5-2.3-2-1,1-2.1-1.5-3-1.5-3.3-.6-2.5.7-7.2.5-9.4s-.9-.2-1-.6c-.3-1.5.7-5.3.6-6.9s-1.1-.7-1.1-1c.2-.7.5-.4.5-1.8s.6-6.2.5-6.7-1.6-.2-1-2.8Z"
          fill="#4b7aee"
        />
        <path
          d="M12.9,223.3c1.5,0,1.3-1.8,2.2-1.5.1.6,1.2,1.4,1.3,1.5.8,1.8.1,1.1,1.5,3,.8,2-.2,2.6-3,2-1.1.5-2,1-3,1.5.3-2.2.7-4.3,1-6.5Z"
          fill="#446bdb"
        />
        <path
          d="M19.4,196.8c2,2,2.6,7.5.5,9.5-1,1.1-1.1,2.3-.4,3.6-1.1,2.6-1,4.8-.6,7.5l-1,.9c-1,1.2-1.3,2.8-.7,4.9h-.8c-1,.1-1.9.4-2.6.9l-.9-.8v-1c.2-1.5.2-3.5.5-5,1-5.5,3.4-12.9,5-18.5l.5-.5c.2-.6.4-1.1.5-1.5Z"
          fill="#4974e3"
        />
        <path d="M18.4,198.8c0-.3.5-.5.5-.5l-.5.5Z" fill="#4b7aee" />
        <path d="M15.4,221.3s-1.1.2-1-.2c.8-1.4,1.6-.3,1,.2Z" fill="#446bdb" />
        <path
          d="M47.8,352.2h-.5c0-.1,0-.4,0-.5-1.5-3.7-3.5-7.3-5-11,2.5,3.5,3.6,7.7,5.5,11.5Z"
          fill="#3740ba"
        />
        <path
          d="M29.4,295.8l.8.2c1.2,5.9,2.6,11.6,4.2,17.3,1.4,3.3,2.9,7.5,3,11-1-.6-1.1-.8-1,.5-2.5-7-5.2-14.3-7-21.5s-.6-4.6-1-6.5l-.5-1c0-.3,0-.7,0-1-.7-2.5,1.2-.7,1.5,1Z"
          fill="#576ae5"
        />
        <path
          d="M27.4,283.8l1.1,1.2c.4,3.1.7,6.2.9,9.3,1,.5,1,1,0,1.5,0-.2-1.2-.7-1-1.5-.4,0-.4.5-.5.5-.1,0-.4,0-.5,0-.7-3.5-.8-7.6-1.5-11,0-1.4,1.2-1.4,1.5,0Z"
          fill="#506be9"
        />
        <path d="M28.4,296.8c0,0-.3-.2-.5-1l.5,1Z" fill="#506be9" />
        <path
          d="M23.9,262.8c3-2.7,4-.4,4.5,3,.5,2.1.9,4.3,1,6.4,1.2,1.2,1.3,3.1-.5,3.1.3.9-.4,2.8-1.5,3,1.4.6,1.3,4.9,0,5.5h-1.5c-.2-1.2-.7-2.7-1-4,0-4-.8-8-1-12-.5-1.8-.5-3.5,0-5Z"
          fill="#4a6eed"
        />
        <path
          d="M19.9,235.8c0,2.4.7,2.1.9,3.3.4,3-1.2,6.6,1.6,10l1.5,13.2c.4,0,.4.3,0,.5,0,1.7,0,3.3,0,5-1.4-2.6,0-6.4-2.5-8.2l1-.5c-1.3-.9-2.3-4.2-2.5-5.7-.5-3.2,0-6.8-1.5-10.5.7-1.9-1.1-3.2-1.4-4.4s.4-1.5.4-1.6c-.2-1.4,1.6-2.2,2.5-1Z"
          fill="#4062e0"
        />
        <path
          d="M19.9,235.8l-2.5,1c-.2-1.7-.6-3.4-1-5l-1,.5c-.4-.6,1.6-3.4-.5-4,0,0,.2-.8.8-.9.9-.2,2.1,1,2.2-1.1.7,1,2,8,2,9.5Z"
          fill="#3d68df"
        />
        <path
          d="M402.6,420.2c-.6,4.1-4.3,6.6-6,10.2s-2,3.1-4,5.3l-4.5,1.5c.8-.9,2-1.3,2-2.5,1.2-2.1,3-4.6,4.8-6.7s5.1-6.1,7.7-7.8Z"
          fill="#5182e7"
        />
        <path
          d="M402.6,420.2c-2,2.4-5.8,6.1-7.5,8.4s-1.2,3.6-5,6.1-2.6,2-4,2c2-1.9,4.5-3.2,5.5-6,.8-.7.8-.9,1.2-1.3,4.4-4.3,8.4-9,12.3-13.7-.9,2.2-1,2.7-2.5,4.5Z"
          fill="#558aeb"
        />
        <path
          d="M411.1,405.7c-1.3.6-2.8,1.7-4,2.5,0-2.6,2.8-4.3,5-5l2-.5c-1,1-2.1,2-3,3Z"
          fill="#5172cd"
        />
        <path
          d="M410.1,399.7c.3,1.7-2.2,2.9-1.2,4.5.9.1,2-2.2,2.3-2.4,1.8-.8,1.3-.3,3.4-2.1-.2,1.2-1.6,2.6-2.5,3.5-1.7,1.7-3.4,3.2-5,5-1.6,2-3.5,3.6-5.5,5-2.1,1.9-4.3,3.7-6.5,5.5-2.9,2.1-3.9,0-2.2-2.8s6.7-6.5,9.2-8.2l-.5-1c.1-.5,6.4-6.3,7.4-7s.7,0,1.1,0Z"
          fill="#2e4ab5"
        />
        <path
          d="M402.1,407.7c-2.1,3-3.8,3-6,5.4s-3.3,4.2-3,5.9l2-.2c-1.6,1.4-3.4,3.2-5,4.5-.4.6-.9.9-1.5,1-.3.4-.7.5-1,.5-.6-.8-1.2-1.7-1.8-2.5-.7,1.9-2,4.8-3.7,2-.9-.8.6-2.1,1.5-2.5,5.6-4.8,11.3-9.8,17.3-14.9.7-.3,1,.1,1.2.9Z"
          fill="#3053b8"
        />
        <path
          d="M390.1,423.2l-1,1.3.5.2c-.8,1.4-2.4,2.7-4,3.5-4.4,5.7-11.8,9.8-18.3,13-1.2,1.3-2.9,2.3-5.2,3-.4,1.1-1.1,1.3-2,.5,0-.5,0-1,0-1.5,1-2.4,4.9-5.2,7.5-5l.5-1.5,7.5-4.4c1.8-1.6,3.6-2.6,5.4-3.1.3-.9.8-.9,1,0,1.8-1.2,3.5-2.5,5-4,.2-.4.3-.4.5,0l1-1c.6-.5,1.2-.8,1.5-1Z"
          fill="#537fd4"
        />
        <path
          d="M394.1,422.2c.2-.1.8-.1,1.3-.5,1-.7,1.7-2.3,3-2.5.8,1.4-2,1.7-2.2,3,.5,1.4-3.2,4.9-4.5,4-1.1,1.1-3.3,3-4.5,1.5.8-1.4,2.4-2.7,4-3.5,1-.7,2-1.3,3-2Z"
          fill="#2a49b9"
        />
        <path d="M407.1,408.2c-1.7,1.8-2.6,4.4-5.5,5,2.1-1.8,3.1-3.3,5.5-5Z" fill="#4f70c8" />
        <path
          d="M391.1,424.2c-1.3,1-2.6,2.5-4,3.5.4,1.4-.7,1.7-1.5.5,1.2-1,2.9-2.7,4-3.5s1-.4,1.5-.5Z"
          fill="#527bd3"
        />
        <path
          d="M398.6,420.7c1.7-.1.9.3.3,1-2.8,3.2-8.5,7.3-10.2,11h-1l-.5-1,3.5-4c-.1-.5.2-1,1-1.5,2.3-1.3,2.9-2.7,4.5-4s1.7-.8,2.5-1.5Z"
          fill="#609aef"
        />
        <path
          d="M150.3,460.7c.9-1.3,2-.8,2.5.6,11.3,4.6,22.6,8.9,34.1,13,4.7,3.4,9.2,4.2,14.6,5l.6,1c5.8.7,11.7,1.3,17.5,1.8l.9.7c2.1-.5,6.6-.6,7.3,1.9-2.9,0-4.7,0-7.5.5s-14.1-2.6-18.4-3.4-9.2-2-14.3-3.2-1.5-2.5-3.4-.5c.6-1.3-2-2.7-3.1-3.1-1.7-.7-4.4-.8-6-1.4-2.5-.9-6.8-3.4-9.8-4.4-4.6-1.6-4.8-2.2-8.7-4.2s-6.4-1.8-7.4-4.3c.3,0,.7,0,1,0Z"
          fill="#51a5fc"
        />
        <path
          d="M149.8,457.7c1.8.2,3.6,1.1,5.4,2.6,16.2,6.9,33.4,13.8,50.4,18.1,3.7-.2,7.1.4,10.1,1.7,1-.1,2.5-.3,3,.6,1.2-.6,2.5-.3,4,1,1.1-1.2,5.2-1.7,5.5.5l3,.5c.6-1.8,4.6-1,5.5,0,2.8.4,5.5,1,8,2,.1,1.1-1.4,1.3-2,.5-4.1.4-10.5-.4-15-.5-1.4-.5-3.9-1.5-5.3-1.5s-1.7.9-1.9.9-.9-1.1-2-1.4c-4.9-1-11.8.4-16.8-1.5s-.6-1.3-1.2-1.4c-1.1-.3-4.1.1-6.7-.8-4.2-1.4-7.8-4.6-12.1-5.8s-2.9-.6-5.9-2.1-6.5-2.7-7.2-2.8c-3.6-.4-2.9-.7-6.2-2.3s-3.3-1.6-5-2.5-5.2-1.2-5.4-1.4c-.6-.6,1.2-1-1.5-1.4-1.3-3.3-5.5-3.1-7.5-4.8s-.5-1.2-.5-1.2c.2-.4.5-.7,1-.9.7-.3,5.8,3,6.5,3.9Z"
          fill="#56a9fc"
        />
        <path
          d="M314.2,473.7c.2.4.1.7,0,1.1s-8,3.2-9.2,2.9c-1.7,1.2-3,2.1-5.3,2-1.3,0-5.6.8-7.7,1.1-6.4.9-10.8,1.7-17.1,3.2s-5.7-.4-7.8-.2-2.1,1.1-3.2,1.3-1.5-.4-1.8-.4-.2,1-.5,1c-.8,0-1.4-1.2-3-1.1s-7.1,2.1-8,2.1c-2-.1-3.4-.6-6.1-.6s-1.9.7-1.7-.9c1,0,1.7-.5,2-.5.2-.6,1.1-.5,1.5,0l.5.5c0-1,.9-1.3,1.5-.5,1.9.4,3.8.2,5.5-.5.2-.4.3-.4.5,0,.5.3,1,.2,1.5,0l.9-1.1c3.6-.3,6.8-.7,9.9-2.1,8.9-.5,17.7-1.3,26.5-2.4,2.4-1.1,4.8-2.2,7.5-1.4,3.6-2.1,7.4-4,11.5-4.5s.4.2.6.5c.8-.1,1.3,0,1.5.5Z"
          fill="#54a6fd"
        />
        <path
          d="M341.7,463.7c-2,1-3.7,1.4-5.1,2s-1.5,1.9-2.4,2.2-2.4-.2-3.6.3-1.4,2.3-2.9,2.7-1.2-.3-1.7-.2c-1.2.2-10.5,5.3-12.8,6.5-.9,0-1.4.3-1.5,1-1.3.5-2.4.2-4,0s-1.1-.7-2.5-.3-1.2,2-2.8,2.2-1.8-.4-2.6-.4l14.5-6c1-.6,2.3-1.1,3.7-1.4,6.7-4.3,14.7-7.9,22.8-9.1,1-.2,1.3,0,1,.5Z"
          fill="#53a1fa"
        />
        <path
          d="M387.6,432.7c-1.8,2.4-6,3.6-7.7,5.5s-.1,1.4-.4,1.9-9.9,7.7-11.4,8.6-1.9.6-2.5,1c-1.1.4-1.4.2-1-.5v-1.2c2.5-1.3,4.5-3,5.9-5,1.9-.8,3.3-1.6,5-2.9s3.6-3.1,2.6-2.9l.4-1.4c3.1-2.9,8.1-7.2,12.1-8.1-.6,1.2-1.9,3.6-3,5Z"
          fill="#5a9ef5"
        />
        <path
          d="M364.6,449.2l1,.5c-5.2,3.2-10.4,6.3-15.8,9.7s-5.2,2.8-8.2,4.3l-1-.5c.4-1,1.5-1.8,3.2-2.3,0-.6.5-1,1.8-1.2.4-1.3,1.7-2.2,3.9-2.6,2.9-3.8,9.2-6.5,13.8-8.3l1.3.4Z"
          fill="#58a0f7"
        />
        <path d="M313.2,477.2c-.5.3-1,.8-1.5,1-.9-1,0-1.7,1.2-1.5l.3.5Z" fill="#52a1fb" />
        <path
          d="M120.8,439.7l1.3-.3c3.6,1.8,9.4,4.7,11.2,8.2,1.9-.1,3.1.3,3.5,1.2.6.2,1.1.2,1.5-.5,2.1.9,11.5,7.1,11.6,8.2s0,.5-.1.8c.4.1.4.3,0,.5-2.4-1.3-4.6-2.8-7.5-3-3.7-3-7.6-3.3-11.3-6s-4.1-3.9-4.7-4.3-1.1.4-1.4.2c-1-.6-3-4.2-4.6-4.4l.5-.5Z"
          fill="#5babfb"
        />
        <path
          d="M112.3,429.7c2,.4,6.2,2.3,6.5,4.5,4,2.7,8.1,5.2,12.3,7.6l1.7,1.9c1.1-1.1,4.1,1.1,3.5,2.5,3.1,2.3,3.3,3.1.5,2.5-1.1-.3-3.1.3-4.2-.5s-.1-1.1-.6-1.6c-3-2.5-8-4.8-11.2-7s-3.9-3.8-5.4-5-2.2-.8-2.5-1.1c-.8-.8,0-3.1-2.6-2.9l2-1Z"
          fill="#60aff9"
        />
        <path
          d="M109.3,424.2c2.2-.4,4.3.9,5,3,.5,0,1,0,1.4.1,4.7,2.4,9.9,6.7,13.6,10.4,2.7.3,5.9,2,7,4.5,0,.4-.2.8-.6,1s-3.1-.3-3.4-.5c-3.5-2-7-4.3-10.5-7-1.2-.6-2-1.5-2.3-2.6-2.9-1.3-5.6-3-8.2-4.9-1.2-.6-3-2.1-4-3s-1.4-1.8-2-2.5c1.2-.4,2.6.1,4,1.5Z"
          fill="#2353bf"
        />
        <path
          d="M111.3,428.2c1.9.9,3.2,1.2,5.2,2.3s4.1,2,4.3,2.2-.6,2,1,3c-1-.1-2-.6-3-1.5-2.1-1.2-4.7-2.9-6.5-4.5s-.6-1.1-1-1.5Z"
          fill="#1d53ca"
        />
        <path
          d="M101.3,417.2c1.4-.8,3.8,1.5,3.5,3l3.4,2.2c1.2-.2,1.4.6,1.1,1.8-.9-.5-2.8-.9-4-1.5-2.2-1.2-3.9-3-5.5-5s-1.1-1.3-1.5-2c.2-.1,2.5,1.2,3,1.5Z"
          fill="#2b4cbf"
        />
        <path
          d="M93.3,407.2c1.3-.7,1.7-.4,1.5,1,1.7.1,2.2.6,3.2,2,.5,1.8,1.9,3,3.3,4,2.1.2,5.6,3.3,5.5,5.5,4.7,4,1.2,3.1-2,.5-1.2-1-2.2-2.1-3.5-3-1.9-1-5.4-6-7-6.5-.2-.3-.3-.7-.5-1l-5.2-4.7c.3-.4.6-.5,1.1-.5l3.6,2.7Z"
          fill="#5b7dcc"
        />
        <path
          d="M456.1,156.3c2,0,2.7,3.9,3.6,4.4s2-.5,2.6-.4.2,1,.6,1c1.3.2,1.5-1,3.7.5l-3,3.3c-.2,1.7,1.5,2,2.5,3s.4,1.5,2.5,2.2c-.7,2.9-1.6,4.9-1,8-.6-.2-1.1-1-1.5-1.5-2.5-3.5-5.9-12.3-8.5-17-.9-1.1-1.4-2.3-1.5-3.5Z"
          fill="#79b5fe"
        />
        <path
          d="M438.1,134.3c4.2,2.2,4.3,6.3,7.2,9.5s1.1.6,1.5,1,2.2,3.7,2.2,1c2.1,3.5,5,7,7,10.5s1,2.6,1.5,3.5c-1.4-1.6-2.2-3.5-3.6-5.2s-1-1.6-.9,0c4.1,7.4,6.8,14.7,9.5,22.8.3.8.3,1.5,0,2-1.4,0-2.4-1.2-3-2.4-1.2-7-4.5-13.5-8.4-19.7-2-4.4-4.3-8.5-7-12.4-1.7-1.1-3.1-3.9-4-6-1.6-.3-2.9-2.5-2-4v-.5Z"
          fill="#73acfd"
        />
        <path d="M314.7,32.4c-.8-.2-2.1.4-2.5-1,.8.3,1.8.4,2.5,1Z" fill="#dafafc" />
        <path d="M315.7,32.9l-.5-.5c.4,0,.5.5.5.5Z" fill="#dafafc" />
        <path
          d="M225.2,29.4c2.7-.2,5.5-.4,8.2-.5s2.8-.3,2.8.5c-1.6.6-3.7.2-5.1.6s-1.7,1-2.7,1.3c-3.2.6-6.5.5-9.6,1.6-2,1.4-5.9,1.9-8.5,2l-6,1.5c-.2.4-.3.4-.5,0-.8.4-1.6.5-2.5.5l-1.1.9c-9,2.1-17.7,4.9-26.4,8.1h-1.5c0,0-6.4,2.7-6.4,2.7-1.9,1.4-4.2,3-6.6,2.2h-.5c-.4-1,0-1.6.8-2.3l7.8-3.1c-.8.3-1.2,0-1.6-.7v-1.1c4.2-1.8,8.5-3.3,13-4.4.7-.6,1.4-1.3,2.3-1.6,8.9-2.9,18.4-5.5,27.7-6.4,5.6-.5,10.8-1.6,16.5-2Z"
          fill="#5487f2"
        />
        <path
          d="M277.7,32.9c7.3.7,14.3,2,21.5,3.5,3.9.9,7.7,1.9,11.5,3,1.3.3,2.7.7,4,1l22,8.5-.3.5c-2.4-.6,3.5.2,2.8,2-5.1-1.1-10.2-3.3-15-5.5-13-4.4-26.4-8.1-40.1-10.2l-1.4-.8-13-1.5c0,.4-.3.4-.5,0-6.5-.5-13-.9-19.4-1.2l-.7-1.1c9.5-.1,19.2.7,28.6,1.8Z"
          fill="#a9cdfd"
        />
        <path
          d="M277.7,32.9c-1.4-.1-2.8.1-4.2,0-8.1-.7-16.1-2-24.2-1.5l6.2,1c4.6,0,9.3,0,13.7,1,0,.3-.2.6-.3.6-1.6.1-5.2-.3-6.4-1.1l-.2.5c-8-.2-16-.2-24,.1l-.3-.6c-.4.6-1.3.8-2.5.5l-9.7,1-.5-.5h-1v-.7c7.5-.9,15.1-1.3,22.5-1.5.4,0-7.4.7-8-.3.5-.8,1.9-.5,2.7-.5,10.5-.1,21,0,31.5,1s3.5.4,4.8,1Z"
          fill="#a4c5fc"
        />
        <path
          d="M238.7,31.4c2.6,0,5.2-.1,7.8,0s1.9-.4,1.7.5l-24,2c-1.2.4-2.2.4-3,0-4.8.2-2-.9,1-1,5.4-1.1,11.1-1.4,16.5-1.5Z"
          fill="#a9cdfd"
        />
        <path
          d="M222.2,32.9c-.7.1-1.7,1-3,.5-.2.9,1.1.4,2,.5-4.4,1.2-9.9,2.4-14.5,2.5-.4-.1-.4-.3,0-.5l3.5-1c2.8-.6,5.7-1.6,8.5-2s2.4.1,3.5,0Z"
          fill="#a4c5fc"
        />
        <path
          d="M374.1,65.4c.3.2,1,.2,1.5.5,3.4,2,7.5,5.4,10.5,8,2,1.3,3.8,2.8,5.5,4.5.5.8,1.7,2.1-.2,1.9s-5.2-3.3-6.3-3.9c-.8,1.1-2.3.2-2-1-3.7-2.7-7.6-4.9-11.6-7.1-1-1.4-2.5-2.5-4.4-3.4-.9.8-2.4-.4-1.5-1.5-.3-.3-1.6-1.9-1.5-2,2.9-1.4,5.7,1.9,8.3,3.4s1.3.4,1.6.6Z"
          fill="#6396f0"
        />
        <path
          d="M336.7,48.9c4,.2,11.8,5.4,16,7l13,7.5c.4.4,1.1,1.1,1.5,1.5l5.1,3.3c0,1.6-3.4-.8-4.1-1.3l-1.1.2c-9.1-5-18.2-10-27.4-14.9l-.5-.8c-.9-.5-3.8-1.9-4-2s0-.3,0-.5c.5,0,1,0,1.5,0Z"
          fill="#afd0fc"
        />
        <path d="M310.7,39.4c-3.8-.9-8-1.5-11.5-3,3.8.8,8,1,11.5,3Z" fill="#7eabf8" />
        <path
          d="M415.1,104.4c3,4.1,6.5,7.8,9.5,12l3.3,4.3c3.2,5.4-2,1.2-3.3-1.5l-1-.8h-1c-6.4-8.5-13.7-16.3-21.1-24l-.5-1.5c.4-.2.7-.3.9-.1,4,2.9,6.4,6.5.8.7l-.2-1.1c1,0,1.4.7,2,1.2,3.7,3.4,6.6,7.3,10.5,10.8Z"
          fill="#a3d1fc"
        />
        <path
          d="M433.6,127.9l4.5,7c.7,1.3,1.3,2.7,2,4,1,2.2,2.2,4.3,3.7,6.2.9,1.3.5,2.9-1,1.9l-8.2-13.1h-.9c-2.8-4.7-5.9-9.2-9.1-13.5-.9,0-1.6-1.3-1-2,0,0,.8,0,1.3.5,1.4,1.3,2.1,3,3.7,4-.3-2.2-2.5-3.8-3.7-5.5s-.2-.8-.3-1c3.4,3.5,6,7.7,9,11.5Z"
          fill="#9ccefe"
        />
        <path
          d="M438.1,134.3c0,.1,0,.4,0,.5-1.8-1.9-3.7-4.5-4.5-7,2.2,2.8,2.7,3.1,4.5,6.5Z"
          fill="#77aefd"
        />
        <path
          d="M383.1,75.4c.7.4,1.4.7,2,1,6.2,5.3,11.8,10.2,17.5,16s4.7,4.6,6.8,7,2.3,2.7,2.7,4c-2.1-1.2-3.1-3.4-4.7-5s-4.2-3.8-6.3-5.5c-1.3-.5-2.7-1.5-4-3-.5.2-.9,0-1.3-.2-5-4.5-10-9.2-14.7-13.7-.9-.5-7.1-5-6.8-5.4s.3-.3.6-.4l8.2,5.3Z"
          fill="#abd5fc"
        />
        <path
          d="M394.1,79.9c1.6-.6,6.3,1.8,7.5,2.8s.7,1.6,1.2,2.1c1.6,1.6,3.7,1.8,5.5,2.8s1.4,1.9,3.3,1.9c-.1,1.6,1.7,1.5,2.5,2.5-6-.7-9.5-3.6-14-7s-4-3.5-6-5Z"
          fill="#b2eefd"
        />
        <path
          d="M387.6,74.4c1.2,1.6,2.8,2.2,4,4-2.4-1.7-3.4-2.7-5.5-4.5.6,0,1,.3,1.5.5Z"
          fill="#73a1f6"
        />
        <path
          d="M462.6,254.3c-.1,6.4-.5,12.6-1,19-.4,2.8-.9,5.6-1,8.5-.7,3.1-1.4,6.3-1.5,9.5.9.8.4,2.9-1,3-.4,1.3-.6,1.3-1,0-.6-1.2-.6-2.7,0-4.5-.5-2.3-.9-4.9.5-7l.5-2c-.6-.6-.4-1.8,0-2.5l.3-1.7c-.3-1.5-.3-4.2.7-5.3,0-5.9.3-11.9,1-18-.3-.4-.4-.7,0-1,.1-.4.3-.4.5,0,.8.5.8,1,0,1.5.8,5.7,1,5.9.8.8.6-2.1.9-4.3.7-6.8-.6-.5-.5-1.8,0-2.5.1-.4.3-.4.5,0,.6,3,.4,6,0,9Z"
          fill="#1f45d6"
        />
        <path
          d="M462.6,220.3c.4,0,.4.3,0,.5l.5.5c1.3,4.5,2,9.2,2.1,14l-.6,1.5c.4,1.8.4,3.8,0,5.5-1.2-.3-1.1.6-1.2,1.5-.5,3.4.3,7.2-.8,10.5,0-3,0-6,0-9-.2-6.4-.6-12.8-1.4-19.2l.4-1.3c.5-1,.5-2.6-.1-4.6l.6-.3c.1-.4.3-.4.5,0,.3.1.3.3,0,.5Z"
          fill="#6185f1"
        />
        <path
          d="M465.1,219.8c.3,1.9.8,4.7,1,6.5s.3,5.5.5,8,.9,19.1,0,20-1.1,0-1.5,0c.4-4-.3-8-.5-12s.1-3.7,0-5.5h.8c0-.1-1.9-16.6-1.9-16.6l.6-.9c-1.1-.5-1.1-1,0-1.5-.2-.4-.4-.8,0-1,.9.5,1.3,2.1,1,3Z"
          fill="#5a80f6"
        />
        <path
          d="M434.1,363.7c-.2,1.1-1,3-1.5,4,.9.8-.9,3.4-2,3-6.3,10-13.7,19.7-22.5,27.5h-.5c.1-.8.6-1.5,1.5-2,.2-1.2.9-2.1,1.6-3.1,4.9-6.2,9.8-12.4,14.9-18.4,2-4.3,4.9-8.4,7.8-12.1h.7c0,.4,0,.8,0,1.1Z"
          fill="#5b70cf"
        />
        <path
          d="M441.6,347.2c-.2.8-.5,1.6-.5,2.5-2.1,3.6-4.1,7.6-6.5,11-.5,1.5-1.1,2.1-2,2-1-.7,1-3.7,2-4,0-.4,0-.7,0-1,.9-1.8,5-9.9,5.9-10.6s.7-.3,1.1-.4v.5Z"
          fill="#6f83e1"
        />
        <path
          d="M434.1,362.7c-.6.9-2,2.2-2.5,2.9-2.1,3-3.9,6.1-6,9.1-.4,0-.4-.3,0-1-1.1-.4-.5-1.5.5-1.5,1.5-3.3,3.3-6.3,5.5-9.2l1-.3c.4-.5,1.6-1.5,2-2-.1.7-.4,1.3-.5,2Z"
          fill="#667cdb"
        />
        <path d="M451.6,329.2c.2-.4.4-.7.5-1l-.5,1Z" fill="#596adf" />
        <path
          d="M451.6,325.7c-3.3,7.1-5.2,15.2-10,21.5,0-.2,0-.3,0-.5-.3-.3-.5-.5-.5-.7.2-2.1,2.7-6.1,4-7.7,1.3-4.1,2.8-8.2,4.5-12.3l1-.7.5-.5c-1,.2-.8-.7,0-1,.2-2.1.7-5,2.5-6-.2.6.1,1.7-.1,2.6-.4,1.5-2,3.3-1.9,5.4Z"
          fill="#6e81e5"
        />
        <path
          d="M459.1,296.8c.3.1.2.3,0,.5l-.5,2c0,.2,0,.3,0,.5l-.5,1.5c-1.1,5.5-3.1,10.6-4.5,16s0,.3,0,.5c-.9,1.9-1.8,4-2.5,6h-1c.7-3.9,1.9-7.7,3.4-11.5.3-4.4,1.5-8.2,3.6-11.5l1.3-6.8c1.4-1.1,1.2,1.8.7,2.8Z"
          fill="#8eb7f9"
        />
        <path
          d="M460.1,293.3c0,.3,0,.7,0,1l-.5,1.5c0,.3,0,.7,0,1h-.5c0-.6.4-2.5-.5-2.5.3,2.3-.9,4.4-1.5,6.5-1.1-1.2.1-5.3,1-6.5.2-.9.8-2.2,1-3s.5-.9.7-1.5c.5-2.2.2-5.4,1.8-7-.7,3.5-1.1,7-1.5,10.5Z"
          fill="#81a6f8"
        />
        <path d="M458.6,299.3c.1-1.1.3-1.3.5-2,0,.7.3,1.7-.5,2Z" fill="#81a6f8" />
        <path d="M458.1,301.3c.1-.5-.2-1.2.5-1.5,0,.6.2,1.2-.5,1.5Z" fill="#81a6f8" />
        <path d="M459.6,295.8c0-.5-.2-1.2.5-1.5,0,.5.2,1.3-.5,1.5Z" fill="#719bf8" />
        <path d="M459.1,297.3c0-.2,0-.3,0-.5h.5c0,.2-.5.4-.5.5Z" fill="#719bf8" />
        <path
          d="M436.1,364.7c-4.6,8-9.8,14.2-15.5,21.5h-.5v-.9c4-4.6,7.5-9.5,10.5-14.6.6-.9,1.5-2.1,2-3l4.5-5.5c-.4.7-.6,1.8-1,2.5Z"
          fill="#4957bd"
        />
        <path d="M443.6,350.7c.2-.3.3-.7.5-1l-.5,1Z" fill="#434fc4" />
        <path
          d="M420.6,386.2c-2.6,3.3-5.3,7.3-8,10.5s-1.7,2-2.5,3c-2.2,2.6-6.5,5.9-8,8-3.4-.2-5.1,4.2-6.6,5.3s-11.5,8-11.8,8.6c-.5.7-.9,1-1,0,4.1-3.9,8.6-7.8,13-11.5,3.2-3.6,6.9-7.1,11-9.5,4.2-4.6,8.4-9.3,12.5-14.1l1-.4h.5Z"
          fill="#3a52b9"
        />
        <path
          d="M459.1,186.8c.4.1.4.3,0,.5.2.2.4.5.5,1,2,4.8,4,9.5,6,14.2v2.4c1.5,3.4,2.8,6.8,3.8,10.1l.7-.2c.8-1.1-.1-2.9,1.5-2.5.1,2,1.5,2.7,1.5,2.8,0,.5-.2,3.8-.5,3.9s-1.4-.5-1.8.2c-.9,1.4,1.2,3.6-1.2,3.5-.1-1.4-1.6-1.5-2.2-2.6-1.4-2.7-2.1-6.6-1.9-9.6l-1.5-4.8c-1.1-1-1.7-2.5-1.9-4.6l-5.4-15.8.4-.6c.6-.4,1.2.3,2,2Z"
          fill="#6a9bfc"
        />
        <path
          d="M457.1,184.8c1.4,6.4,6.7,14.7,7,21s.3,8.5,1.5,14h-.5c-.2-1.2-.7-2-1-3-.3-.1-.5-.6-.5-1.5l-1.2-1.4c-.4-3.1-1-6.2-1.7-9.2-1.7-7.6-3.6-14.9-5.7-22.3l-.5-1c-.3-.1-.3-.3,0-.5-.5-.8-1.3-2.4-.5-3,.2,0,.5-.2.7-.1.4,0,3,6.5,2.3,7.1Z"
          fill="#6795f8"
        />
        <path
          d="M24.4,180.8c0-4.2,3.9-11.1,5.5-15.2s1.7-4.2,2.9-6.6,2.5-3.8,1.6-.1c.4.1.4.3,0,.5l-.5,1c.5.5.2,1.5-.5,1.5,0,.7-.5,1.1-1,1.5.8.2.6,1.2,0,1.5l-1,1.5c.4.1.4.3,0,.5-1.2,2.1-1.9,4.4-1.9,6.7-.3,0-.5.1-.5.2-1.6,5.2-2.1,7.9-2.6,13.3s-.5.5-1,.7c.2.5,0,.8-.5,1,1.9,0,1.9,2.8,0,2.5-.4.5-.4,1,0,1.5,2.1-.4,1.4,3.3-.5,2.5-.1,1.3-.4,1.6-1,1-.3-6.2.9-6.8,1.5-11.8s-.5-2.6-.5-3.7Z"
          fill="#5688f1"
        />
        <path
          d="M66.8,109.4c-.2.5-.5,1-1,1.5-.6,1.5-1.7,2.9-3.5,4,0,1.1-1.3,3.5-2.5,3.5-1.7,3.2-3.8,5.9-6.4,8.3v-.8c-.3-.2-.3-.3-.1-.5l.5-.5c-.2-.2-.2-.3,0-.5l.5-.5c0-.1,0-.3,0-.5,3-3.2,4.5-8,7-11.5,2.1-3,5.8-6.3,8-9.5l-2.5,4.5c5.7-4.4,9.8-10.5,15-15.5.2.3.4.5.4.6-4.2,6.1-9.7,12.4-15.4,17.4Z"
          fill="#edfaf6"
        />
        <path
          d="M108.8,71.9c1.3,1.4-1.4,2.3-2.9,2.1-1.1,2.4-3.6,3.9-7.2,4.5-4.1,4-8.4,7.5-12.9,10.9,0,.3,0,.6,0,.9-.2.8-9.1,11.6-10.5,13.2-2.1,2.4-5.7,4.9-8.4,5.9,2.4-2.8,5.1-5.4,7.5-8.3l7.5-9.7c.2-.2.8-.3,1-.5,4.4-4.3,14.6-15,19.2-17.5s5-1.2,6-1.9.5-1.2,1.3-2c1.3.3,1.1,1.1-.5,2.5Z"
          fill="#c7f5fd"
        />
        <path
          d="M47.8,139.3c1.1,1.2-1,4.1-2.5,4h-.5c.2-.3.2-1,.5-1.5.7-1.2,1.3-2.9,2-4s1.5-1.7,2-2.5c.2,1.1-.5,3-1.5,4Z"
          fill="#83b0fa"
        />
        <path
          d="M57.3,122.9c.7,1.1-1.3,3.2-2.5,3-.6,1.2-1.4,2.2-2.5,3,0,.1,0,.4,0,.5-1,1.3-1.5,1.5-1.5.5v-.5l.5-.5c0-.1,0-.4,0-.5l.5-.5c0-.1,0-.4,0-.5l.5-.5c0-.1,0-.4,0-.5.3-.4.6-.6,1-.5,0,0,.2.5.7,0,1.5-1.3,4.3-5.7,5.8-7.6-.2,1.6-1.1,3.1-2.5,4.5Z"
          fill="#d6edf8"
        />
        <path
          d="M52.3,129.4c-1,1.5-1.9,3.2-3.3,4.5-.3-1.2.8-3.5,1.8-4s.9.4,1.5-.5Z"
          fill="#caedfb"
        />
        <path d="M50.8,129.4l.5-.5c-.1.2-.3.4-.5.5Z" fill="#caedfb" />
        <path d="M51.3,128.4l.5-.5c-.1.3-.5.4-.5.5Z" fill="#caedfb" />
        <path d="M51.8,127.4l.5-.5c-.2.3-.4.4-.5.5Z" fill="#caedfb" />
        <path d="M53.3,125.9c-.3,0-.7.4-1,.5.4-.6.9-.9,1-1v.5Z" fill="#caedfb" />
        <path d="M53.3,125.4c0-.2,0-.4,0-.5h.5c-.1.3-.4.4-.5.5Z" fill="#d6edf8" />
        <path d="M53.8,124.9h-.5c.1-.2.4-.4.5-.5,0,.2,0,.4,0,.5Z" fill="#caedfb" />
        <path d="M53.8,124.4c0-.2,0-.3,0-.5h.5c0,.2-.4.4-.5.5Z" fill="#d6edf8" />
        <path
          d="M37.8,151.8c.8.8.6,1.3-.5,1.5.3,3.1-.5,5.4-2.5,7l-.5,1c.4.2.4.3,0,.5,0,1.2-.3,1.6-1,1-.4,0-.4-.3,0-1,.2-.5.3-1,.5-1.5l.5-1c0-.2,0-.3,0-.5,1.7-2.1,2.2-5.4,3-8,.4-.2.7-.7,1-1-.2.6-.3,1.4-.5,2Z"
          fill="#6498f7"
        />
        <path
          d="M208.7,31.4c-10.1,1.9-20,5.7-30,8-7.1,1.7-14.1,3.8-21,6.2l-.5,1.5c-4.9,1.3-9.7,2.9-14.4,4.9l-.6-.6c-1.7,1.7-5.3,2.7-7.5,2,.5-.4.9-1.1,1.5-1.5.3,0,.7,0,1,0,1.4-.7,2.8-1.4,4.2-2l.8.5c2.7-.4,2.3-2.5,4.5-3.2s2.8.2,3.5,0,3.1-2.5,4-3c2.1-1.1,4.7-1.8,7-3.3,3.3.2,6.6-1.6,9.9-2.4s2.3,0,3.4-.1,2.6-1.4,4.3-1l-1-1c1.7-.2,4.6-.1,6.1-.6s5.2-3.8,5.7-3.9c5.5-1.2,12.9,0,19.1-.5Z"
          fill="#c9f8fc"
        />
        <path
          d="M142.3,51.4c2.3.5-1.1,2.6-2.5,2.9-2.4,0-4.4.8-6,2.1-1.6,2.2-4.1,3.8-7.6,4.8l-.9,1.7c-5.2,2.5-10.1,5.5-14.7,9.1-.6.3-1.2.3-1.8-.2l.5-2.5c1.2-1.2,2.4-1.3,3.5-2.2,2.9-2.4,3.7-6.4,8.5-4.8v-2c1.7.9,3.3-.8,4.9-1.8s.7-1.1,1.1-1.4c2.8-1.8,4.2-.9,7.4-3.8,1.4-.4,3.5-.4,4.8-.9s1.1-1.5,1.5-1.6,1,.5,1.2.5Z"
          fill="#c5f7fe"
        />
        <path
          d="M142.3,50.4c-.1,0-.4-.5-1-.2s-1.8,1.9-2.9,2.2-1-.4-1.1-.4c.4-2.2,1.4-1.3,3.1-1.6s1.1-1.7,1.9.1Z"
          fill="#cff8fd"
        />
        <path
          d="M65.3,373.2c-6-7.9-4.3-11.9,2.5-3,4.6,7.2,9.7,14.1,15.3,20.8l-.4.7c-1.1.6-1.1,1.5,0,2.5l-.5,1c-1.8-.3-4.1-2-4-4-3.6-5.8-8.6-10.7-12.4-16.3s-.4-1.4-.6-1.7Z"
          fill="#3247ab"
        />
        <path
          d="M55.3,349.7c.4.1.8.3,1.1.5.9.8,8,13.1,9.4,15.6s0,.5,0,.9c0,.3,0,.5,0,.7-.8,1.3-8.8-10.1-9.3-11.9,2.3,4.5,4.3,9.1,5.8,13.7-.2-.2-.9-.3-1-.5-2.3-3.7-4.9-7.7-7-11.5s-2.5-4.8-3.5-7c-.8-.4-2.2-3.1-2-3.7s2.6-2.4,3.1-2.3c1.3,1.7,2.4,3.6,3.4,5.5Z"
          fill="#3a47b2"
        />
        <path
          d="M84.3,398.2c4,1.7,7.3,5,9,9l-4.5-2.3c1.3,1.4,4.1,3.2,5,4.8-4.5-2.7-7.8-7.4-11-11.5-5-4.3-2.5-5.6,1.5,0Z"
          fill="#5d77c7"
        />
        <path
          d="M78.3,391.2c1.5,1.4,2.6,2.6,4,4,1.5-.8,3.5,1.9,2,3-1.3-1.2-2.6-2.4-4-3.5-.5.5,2,2.9,2.5,3.5-3.3-2.4-5.5-6.1-8-9.2,1-.4,2.7,1.5,3.5,2.3Z"
          fill="#546cc8"
        />
        <path
          d="M62.3,369.2c-2.7-4.6-5.7-10.5-7.5-15.2s-1-2.5-1-3.8c1.4-.3.9.4,1.2,1,3.4,5.2,6,10.5,9.9,15.4s.8,0,.9.1l1.1.5c3.8,5.2,7.7,10.4,10.9,16,2.4,1.7,5,4.8,6,7.5.6.9.7,1.2-.5,1-.1.4-.3.4-.5,0-1.7-3.6-5.2-6.4-7.5-9.4s-1.2-2.9-2-3.9-3.2-2.5-3.5-3.1c-1.1-1.8-1.5-4.1-3.2-6.2s-3.8-4-4.3-3.5c-.6,3.2,2.6,4.5,3,7.5-.9-1.3-1.9-2.2-3-4Z"
          fill="#3947ae"
        />
        <path
          d="M33.3,297.8c1.7,1.7,2.9,5,1.5,7-.7.8-.5-.2-.5-.1.5,1.4,1,3.3,1.2,4.8s-.1.7-.4,1.1c1.6,7.3,3.8,14.4,6.7,21.2v.5c.2.7.7,2,1,3l.5,1c0,.1,0,.3,0,.5.6.7.8,1.6,1,2.5.9,1.9.6,2.2,1,3.5-3.1-5.7-5.9-12.3-8-18.5-1.2-3.7-2.1-7.2-3-11-.6-2.1-4.6-17-4.1-17.8,1.1-1.9,4.6.4,3.1,2.3Z"
          fill="#4653d1"
        />
        <path
          d="M39.8,324.7c-1-2-2.2-6.1,1.1-4l1.9,6.5c2.4-.9,4.4,2.1,5.2,4.1.5,2.2,1.3,4.3,2.2,6.4,1.3,0,1.2.6,0,1-.1.4-.3.4-.5,0,.2,1.3-.4,2.4-1.6,2.9.6,1,.5,1.7-.4,2.1-2.5-3.5-3.7-7.6-5.5-11.5l-.5-.5v-1l-1-3c-.4-.1-.4-.3,0-.5-.2-.7-.5-1.4-1-2-.4-.2-.4-.3,0-.5Z"
          fill="#3c4abd"
        />
        <path
          d="M49.8,338.7c2.4,3.2,4.4,6.6,6,10.5l-.5.5c0-.1-.7-.3-1-.7s-2.1-4.8-3-3.8v2s-2-1-2-1c-.1.2,1.2,3.4,1.5,4-2.7-.6-2.6-4.5-3-6.5s-1.1-2.9-1-3,.9.1,1.3-.1.7-1.7,1.7-1.9Z"
          fill="#3f49b8"
        />
        <path
          d="M25.4,210.3c1.4.8,1,4-.5,4.5-1.4,2.9-2.7-.6-2-2.5-.3-5.1.8-10.3.5-16,.3-.3.8-.6,1-1l1,.6c.7,4.1.6,8.2-.2,12.2-.6,1-.6,1.7.1,2.1Z"
          fill="#5588f3"
        />
        <path
          d="M30.9,187.8c1.1-3.7,3.8-2.9,3.4.7-.5,4.7-1.9,10-3.1,14.6-1.3,8.2-2.3,16.2-3.2,24.2l-.5.5c.4,0,.4.3,0,.5.4.6.4,1.4,0,2,.4,0,.4.3,0,.5l-.5,2.5c.6,5.7,1.1,11.7.5,17.5-1.8.7-2.2-1.1-2.3-2.7.3-2.4.1-4.5-.5-6.8,0-3.5-.1-7.1-.2-10.7,1-2.4,1-4.6.1-6.5,1-1.3,1.2-2.5.6-3.6.8-1.6.8-2.8,0-3.5.2-1,.1-1.7-.3-2.1,1.1.4,0,7-.6,7.3s-.6.3-.9.2c-.7-.2-1.5-6.2-1-7.5,0-.3,0-.7,0-1v-1c0-.2,0-.3,0-.5h.5c0,.1.4,2.4.5,2.5s1.1,0,1.5,0c.2-1.4.3-3.1.5-4.5-.4-.1-.4-.3,0-.5l.5-1c-1,0-1-.6,0-1l.5-2c-.7-2.2-.5-4.7,1.2-6.3l1.3-3.6c-1.4-2,0-6.9,2-8Z"
          fill="#5181f7"
        />
        <path
          d="M22.4,214.8c.2,2.1.9,4.9,1.2,7,.5,0,.1-2,.3-2.7.3-1.4.7-1.8,1-4.3,1.9.1.5.5,1,1.6s.8.4.9.7c.3,1-.8,3-.8,3.4s.9,1,.8,2-.8.3-1,.6c-1,1.4.3,1.8.3,2.7s-1,2.1-1.1,3c-.3,2.4,0,5.4-.6,7.9,2.3.6.9,1.5.9,2.8s.7,3.5.9,5.1-1,4.8,1.1,6.1c1.6,2,2,6.4.5,8.5l-1.1-.3c-1.5-4.1-2.7-8.1-3.4-12.2,0-1.3,0-2.7,0-4,1.1-3.9.3-8.4.5-12.5s.7-1.1.7-1.9c0-1.2-.5-2.8-.2-4.1l-2,1.5c.6-1.3-1.1-1.6-1-1.7.2-.4.8-.6,1-1.5.3-1.6-1.2-1.1-1-1.5s.6-.4.6-.7c.7-3-.6-2.6-.7-2.8,0-.5.6-2.2,1-2.7Z"
          fill="#4e7df5"
        />
        <path
          d="M23.4,246.8c-.7,2.9,2.5,5.1,2.9,6.9s1.2,4,1.6,5.6c.9.3.9.7,0,1,1.3.2,1.3.6,0,1,1.4,1.4,1.6,2.8.5,4.5-.6-1.6-1.4-4.7-2.8-2.5l-1.7-.5c0-.2,0-.3,0-.5-.2-5.2-.4-10.6-.5-15.5Z"
          fill="#4f76f2"
        />
        <path d="M22.4,213.8v-1c0,.5,0,.9,0,1Z" fill="#5282ed" />
        <path
          d="M30.9,286.8c.4,0,.8,0,1.2.1s1.9,6.9,1.8,7.2-.3.4-.4.6c1.8-.4,2.6,3.1.5,3-.1.4-.3.4-.5,0-.1-.5.2-1.3-.5-1.8s-2.5-.5-2,.5c1.2,2.4,2.5,12.7,3.5,16.8-.7-1.1-1.4-2.7-1.8-4-1.1-4-1.7-9.9-3.2-13.5,0-.5,0-1,0-1.5-.4-2.4-.8-5,.4-7.3l1.1-.2Z"
          fill="#4a5ddd"
        />
        <path
          d="M31.4,284.3c1.3.9,1,2.2-.5,2.5-1.1,3.2-1.5,3.7-1.5,7.5-1.2-3.3-1.7-7-2-10.5s-.2-3.3,0-5.5c2-3.3,4.9,3.9,4,6Z"
          fill="#4964e4"
        />
        <path
          d="M28.9,275.3c1.5-.1,2.9-.2,4.3-.2.4,1.4.9,2.6,1.7,3.7.9.9,1.8,4.7.5,5.5.2,1.6.3,4.8-1.5,2.5-1.4.3-1.7-1.4-1.8-2.5h-.7s-2.4-5.8-2.4-5.8h-1.6c.3-3.9.5-1.7,1.5-3.1Z"
          fill="#516ce8"
        />
        <path
          d="M387.6,424.7c.2.2.2.3,0,.5-.1,0-.4,0-.5,0-1.5,1.5-3.2,2.8-5,4-.2,0-.7,0-1,0s-.5.7-1.3,0c-1.7-1.4,1.2-3.6,2.3-5,2.9.7,1.8-1.4,2.6-2.4,1.5-1.8,3.6.9,2.9,2.9Z"
          fill="#2a51b4"
        />
        <path d="M387.6,425.2v-.5l1-.5c-.2.2-.5.6-1,1Z" fill="#527bd3" />
        <path
          d="M367.6,438.2c-2.5,1.6-4.9,3.5-7.5,5-1.9,2.5-5.4,4.2-8.5,4.5-.9.8-1.8,1.1-2.5,1l-5.3,2c-1.5,0-4-1.6-2.7-3l.2-.7,10.8-5.8c.5-.9,2.5-2.2,3.5-1.5,2.3-1,1.7.6,3.1.4,2.5-.4.5-1.6,1.1-1.9,3.2-.2,4.3-2.2,7.8,0Z"
          fill="#2c5abc"
        />
        <path
          d="M376.1,438.2c1.2.7-.3,1.8-1.2,2.4-8.7,5.8-17.8,11.2-27.2,15.5-.5-.4-1.2-.5-2.1-.4-1.5,1-4.1,1.5-4.5-.8l4-2.2c-.7-.7-.4-1,.5-.5l6-3c0-.3,0-.6.1-.8.2-.4,6.6-3.5,7.6-3.9s.5,0,.8.2c.7-.2,1.3-.3,2-.5,1.5-.9,2.9-1.4,4.3-1.6,1.1-1.7,6.6-4.3,8.6-4.9l1.1.5Z"
          fill="#1f52c5"
        />
        <path
          d="M391.6,426.2c-.3.5-.7,1-1,1.5-4.3,2.4-8.4,7-12.5,9.5,0,1-1.1,1.8-2,1-1,.6-4.8,2.6-5.5,2.8s-2.6-.4-3.2.7.6,1.6-1,2.5.4-1.3-1-1-2,.7-3.2,1c7.9-5.3,16-10.1,23.5-16,.5,0,1.1-.4,1.5-.5,2.3-.3,2.4-.3,4.5-1.5Z"
          fill="#224fc2"
        />
        <path
          d="M360.1,443.2c2.1.1,1,.7,0,1.5-2.5,2-5.7,3.1-8.5,4.5l-3.5,1.5c-.4-.1-.4-.3,0-.5.8-1,2-1.8,3.5-2.5,2.9-1.4,5.7-2.9,8.5-4.5Z"
          fill="#5384d8"
        />
        <path d="M382.1,429.2c1.2-1.7,3.3-2.8,5-4-1.4,1.9-2.7,3.4-5,4Z" fill="#527bd3" />
        <path
          d="M149.8,457.2c0-.2,0-.5,0-.7.4-1.8,6.9,2.4,7.5,3.7,2.4.3,4.4,1.1,6,2.4.7-.3,1.5-.4,2.2-.3l16.3,6.5c11.1,4,21.9,6.8,33.2,9.1,1.1-.6,3.5.2,3.7,1.6,1.3.2,1.3.6,0,1-1.1,0-2.7.4-3.3.3s-.8-.9-1.5-1.1c-1.3-.4-6.5-.2-8.5-.5-4.6-.8-7.9-1.9-12.1-3.6-11.2-4.4-22.9-8-33.7-12.2-3.7-1.4-6.6-4.1-9.8-5.8v-.5Z"
          fill="#5cb0fc"
        />
        <path
          d="M318.2,471.2c-.8,1.7-2.6,2.4-5.5,2-1.9.6-4,.7-5.5,1.3s-5.5,3.6-6.3,3.7-2.2-.5-3.3-.3c-1.8.3-3.1,1.6-4.7,1.8-3.2.6-6.2.4-9.5,1-5.3.9-14.4.6-18.3,1.7-3.5,1-5.9,1.5-9.3,1.8-.5.3-1.1.4-1.5,0-.2,0-.3,0-.5,0-1.7.9-3.7.7-5.5.5-.3,0-.8.5-1.5.5l-.5-.5c-.5,0-1,0-1.5,0-1.3.3-8-.7-8-2,1.5-1.7,3.6-1.6,6.2.3,6.7-.4,13.3-1.1,20-2.1,1.9-2.9,8.1-2.1,11.2-1.1,4-2.3,9.9-2.8,14.6-3.1l.9.6c9.3-2.1,18.5-4.3,27.8-6.6l.7.6Z"
          fill="#5aabfc"
        />
        <path
          d="M223.7,479.7c.5.5.8.6,1.5.5,0-1.5,2-1.9,2.5-.5,1.5.9,3.1,1,5,.5.9-1,1.3-.8,1,.5.7,0,1.6,0,2.5,0,.1-1,.6-1,1,0,1.9.3,1.7,1-.5,2-2,0-3.5-.1-5.5,0l-3-.5c-.8-.2-2.6-.8-2.8-.8-.9,0-2,1.2-2.7.3-2.8-1.2-2.9-1.9-.5-2,.5-1.2,1-1.2,1.5,0Z"
          fill="#5cb0fc"
        />
        <path
          d="M222.2,479.7l-1,.5v.5c2-.4,1.3.8,1.5,1-1.5,0-2.4-.9-4-1v-1c.2-1.5,3.3-1.5,3.5,0Z"
          fill="#5daffd"
        />
        <path d="M231.2,482.7c-2.5.1-1.8-.2-3-.5.9,0,2.4-.4,3,.5Z" fill="#5daffd" />
        <path
          d="M345.7,459.7c-1.6,1-2.3,2.4-5,3.5-6.2,2.5-12.4,4.7-18.5,7.2-3.3,1.4-2.8,3.7-8,3.3s-1-.2-1.5-.5c2-.6,3.4-1,5.5-2,0-.3,0-.5,0-.8.2-.6,8.9-5.4,10.3-6,3-1.4,9.4-3.4,12.6-3.9l1,.8c.3-1.5,2.9-3.1,3.5-1.5Z"
          fill="#59a7fb"
        />
        <path d="M253.7,484.2c-1.4,1.6-3.7,1-5.5.5,1.7-.1,3.6-.3,5.5-.5Z" fill="#56a9fc" />
        <path d="M255.7,484.2c-.4.6-1.3.8-1.5,0,.8,0,1.4,0,1.5,0Z" fill="#56a9fc" />
        <path d="M246.7,485.2l-.5-.5c.3,0,.5.5.5.5Z" fill="#56a9fc" />
        <path
          d="M378.1,437.2c1.8,0,.8.3.2,1-1.1,1.5-3,3.5-4.6,4.4s-2.3.4-2.6.7.4.7,0,1.2c-.8,1-5.2,3.9-6.5,4.7-3.5,2.1-8.9,4-12.2,6.1s-1.7,2.2-2.4,2.6-3.3,1-4.5,1.8h-2.5s1,1,1,1c-.7,0-1.4.3-2,.5-2.9-1.2,1.1-3.1,2.7-3.8l-.2-.7c-.6-.2-.3-.6,1-1,3.6-.9,12.2-5.9,15.8-7.9,4.4-2.5,8.8-5.2,13-8s1.3-.7,1.7-1.6c.6-.3,1.3-.6,2-1Z"
          fill="#5da7f7"
        />
        <path
          d="M141.8,448.7c2.1.5,4.3,1.4,5.9,3,1.8.1,3,.8,3.6,2.5-.2.5-1.5,1.1-1.5.5,0-.8,8.8,2.3,8.3,4.6,2.2,0,7.2.7,5.2,3.4-3.1-1.1-6.9-2.4-9.6-4s0-1.3-1.9-.7v-1s-2,.3-2,.3c-2.3-1.9-10.5-7.9-13-8.5.8,0,1.2.2,1-.7-.3-.7-2.3-.9-1.5-1.8,1.4-.9,5.6.7,5.5,2.5Z"
          fill="#5db1fc"
        />
        <path
          d="M136.3,442.2l.7-.4c3.4,1.5,6.5,3.5,9.3,5.9l.5.5c.2-.3.3-.3.5,0,.3,0,.5.2.5.5.1-.4.3-.4.5,0l.5.5c.2-.4.3-.4.5,0,2,1.3.4,3.9-1.9,2.4-1.4-1.5-3.3-2.4-5.6-2.9-1.6-.9-3.8-1.5-5.5-2.5s-2.4-1.8-3.5-2.5c-.5-.3-.6-.6-.5-1,1.2,0,.4-1.4.5-1.5.6-.4,1.3.7,1.9.9s1.3,0,1.6.1Z"
          fill="#1c54c1"
        />
        <path
          d="M121.8,435.7c3.2,1.9,6.5,3.7,9.8,5.5.6.4.5,1,.7,1.5s.4.7.5,1c-4.8-2.9-9.8-5.7-14-9.5.8.5,2.2,1,3,1.5Z"
          fill="#235bca"
        />
        <path
          d="M115.3,426.2c.6-.8,1.4-.7,2.6.4,1.5.8,5.3,3.1,4.9,4.6,3.1.6,6.7,2.7,8,6-.7,0-1.2.3-1.5.5-5.1-3.3-10-7.2-15-10.5-2-1.7-.7-2.5,1-1Z"
          fill="#4876cf"
        />
        <path
          d="M130.8,437.2c.8-1.2,1.4-1,1.5.5,1.9,1.4,3.8,2.1,5.7,2.2,2.4,1.2,8.1,4.6,10.2,6.2s.9,1,1.1,1.6l-1.5.5c-.2.2-.3.2-.5,0-.2,0-.4,0-.5,0l-.5-.5c-3.2-1.6-6.8-4.3-10-5.5-2.3-1.6-4.7-3-7-4.5l-1-1.5c1,0,1.7.6,2.5,1Z"
          fill="#4a81d7"
        />
        <path
          d="M115.3,425.7c.4.1.4.3,0,.5-.4,0-1,0-1.5,0l.5,1c-1.6-1.1-3.3-2.1-5-3-1.3-1.5-3-2.8-4.5-4l4,2c.1-.1-1.7-2.2-2-2.5.3-.3.7-.7.9-.6.7.4,7.3,5,7.5,5.3v1.2Z"
          fill="#5070c7"
        />
        <path
          d="M101.3,408.7c.8.3,1.6.9,2.3,2,2.5.7,4,1.3,5.2,3.7l1.5.9c1.6-.2,5.3,2.8,5,4.5.7,0,2.3.6,1.5,1.5,1.1.6,2.3,1.8,1.5,3-1.2,1.6-2.2,2.1-3,1.5l-8.5-6c-1.8-1.9-3.8-3.4-5.5-5.5-3.6-1.9-5-6.8,0-5.5Z"
          fill="#314aa9"
        />
        <path
          d="M98.3,401.7c0-.7.4-.6,1,.5,1-.2,5.3,4.2,5.3,4.8s-.1.5-.3.7c-1.2.7-2.2,1-3,1-.4.2-2.5,1.1-2.5,1.3-.2,1.6,1.5,3,2.5,4.2-2.7-.9-4.5-4.3-6.5-6,.3-2.3-1-4.2-4-5.8-2.5-3.3-5.1-6.5-7.8-9.6l.4-1.1.5-1,.8-.2c4,4.7,8.5,8.4,13.7,11.1Z"
          fill="#334cb2"
        />
        <path
          d="M82.8,391.7c.2,0,.4,0,.5,0,.4.2,1.2,1.9,1.7,2.3,3.2,3,3.6,3.6,6,7s4.1,1.7,5.1,6.1,0,1-1.3,1c-.5-.4-1-.6-1.5-1-2.9-3.1-5.9-6.1-9-9-.2-1.3-1.3-2-2-3s-2.6-3.4-2-4c.7.2,1.9.3,2.5.5Z"
          fill="#2c48ad"
        />
        <path
          d="M460.1,187.8l1,2c1,2.5,2.2,4.8,3.5,6.8.2-1.9.5-3.7.8-5.5l.6-.3c1.8,1.3,2.1,4.6,1.7,6.5s-1.2,2-1.2,3.2,1.7,4,1.9,4.7c1,3.1-.5,2.5-.5,2.8,0,1,1.5,3.2,1.8,4.2s-.6,1.8.2,2.5l-.7,4c-1.2-.9-.9-2.4-1.3-3.6-.9-3-1.2-7.1-3.3-10s.1-2.4-.3-3.5c-1.5-4.7-4-8.6-4.9-13.4-.3-.3-.3-.7,0-1,.1-.4.3-.4.5,0,.4.1.4.3,0,.5Z"
          fill="#70a3fd"
        />
        <path
          d="M466.1,190.8c.2,3.3-.1,2.4-.5,4.8s.7,3.4-.3,4.7c-2-3.2-2.7-7.1-4.2-10.5.3-.6.8-.9,1.2-.4-.3-3.1-.5-6.3-.7-9.5l1-.6c0-.7,0-1.3,0-2,1.8,5.2,3.1,7.6,3.5,13.5Z"
          fill="#73aafe"
        />
        <path d="M468.6,205.3c-.2-.2.5-.8.5-.2s-.4.4-.5.2Z" fill="#6a9bfc" />
        <path
          d="M444.1,144.8c1.9,2.4,3.5,3.4,4.7,6.1,2.8,7,7.8,11.9,10.2,19.3s0,1.9.2,2.8,1.3,1.2,1.3,1.6-1.1.9-.9,1.9,2.7,1,3,2.8c0,2,0,5,.2,6.7.3,3.1,1.8,6.1,1.3,9.3-1.3-1.1-1.5-3.3-2.3-5s-.7-.5-.7-.5l-1-2c0-.1,0-.3,0-.5-.9-.6-1.9-3.6-.5-4,1-.5,1.4,2.7,1.4,2.6-1.1-5.7-3.7-11-6.2-16.3l.3-1.7c-3-3.6-5.3-8.3-6-13-2.8-2.2-5.1-6.5-5-10Z"
          fill="#78b2fe"
        />
        <path
          d="M434.6,133.8c3.1,3.7,5.8,8.1,8,12.5.5.1,1.3.1,1-.7-.7-1.8-3.3-4.4-3.5-6.8.9,1.7,2.8,4.5,4,6,1.5,3.4,3.3,6.7,5,10,1.4,6.1-2.3.9-3.5-2h-.8c-1.8-4-3.9-7.8-6.2-11.5-1.8-1.6-4-5.1-4-7.5Z"
          fill="#92c9fd"
        />
        <path
          d="M172.3,45.9v.7c-2.2,1.1-4.4,2.1-6.5,3.2-.3,1.4-3.1,2.4-4.5,2.5-10.2,5.3-20.2,11.1-30,17.1l-1.5.4c-4.3,2.9-8.5,6.1-12.5,9.5h-1c-.9.6-1.4.6-1.5,0v-.8c1.9-1.8,3.9-3.5,6-5.2.4-.6.7-1.1,1.2-1.6s.9-1,1.4-1.4c7.1-4.8,13.9-8.9,21.1-12.8s.3,0,.6.2c3.8-2.3,7.7-4.2,11.8-5.9.2-.4.3-.4.5,0l2-1c4.3-1.7,8.6-3.6,13-5Z"
          fill="#97c3fc"
        />
        <path
          d="M178.8,39.4l-13,5.5-.6,1.2c-3.9,1.3-7.8,2.9-11.5,4.8l-1.3-.5c-1.8-.4-2.9.1-3.4,1.5l-5.4,1.6c-2.6,1.7-6.9,4.1-9.8,2.9.5-.4.8-1.7,1.1-1.9.8-.4,4.3-.5,6.3-1.5s1.4.2,1.1-1.6c1.5-.1,3.4-1.8,4.9-2.3s9.3-2.3,9.5-2.7-.3-1.1.4-1.5,3.6-1.5,4.6-1.8c5.6-2.1,11.2-2.3,17.1-3.6Z"
          fill="#c3f7fd"
        />
        <path
          d="M165.8,44.9c1.7-.4,4.1-.8,5.8-.9s1.8-.5,1.7.4l-13.1,5c-.5.5-.8,1-1.4,1.5l-1.5,1c-.1,0-.4,0-.5,0-3.6,1.3-7,3-10.3,5.2-2.6,1.9-4.8.2-2.2-2.2-.4-.1-.4-.3,0-.5.7-1.3,2.2-2,4.3-2.3.5-1.6,2.1-2.3,3.7-1.7,4-1.8,9.5-4.6,13.5-5.5Z"
          fill="#5285ef"
        />
        <path
          d="M206.7,36.4c-1.7.9-3.7,1.6-6,2-1.3,1.2-3.2,1.7-5,1.5l-5.5,1.5c-5.5,2.1-11.2,4.1-17,6-2.2,1.2-4.5,2.2-6.8,3l-.7-.5-.4-.6c2.5-.6,4.7-2.4,6.9-3.4,9.2-4.2,19.1-6.8,29-9,.9,0,1.7-.1,2.5-.5.2,0,.3,0,.5,0l2.5-.5v.5Z"
          fill="#9fc2fb"
        />
        <path d="M203.7,36.4c-.4.8-1.7.5-2.5.5.8-.2,1.7-.3,2.5-.5Z" fill="#9cbbfa" />
        <path d="M210.2,34.9c-.9.2-2.2.7-3.5,1s-1.7.3-2.5.5l6-1.5Z" fill="#9cbbfa" />
        <path d="M159.3,50.9c-.5.2-1.1.7-2,1,.3-.6,1.1-.7,1.5-1h.5Z" fill="#6da6f5" />
        <path
          d="M269.2,33.4c.2,0,.3,0,.5,0l13,1.5c14,2.5,28.3,5.6,41.5,11h-.5c0,.7-1,.5-1.5,0l-.5-.5c-.1.4-.3.4-.5,0l-.5-.5c-2.9-.4-5.8-1.3-8.5-2.5,0,1.1-.7,1.1-1,0l-1.5-.5c-.2.4-.3.4-.5,0-.2.3-.6.1-1-.5-.2.4-.3.4-.5,0l-.5-.5c-.2.5-.9.5-2,0-1.7-.5-3.4-1-5-1.5-.3.4-.7.4-1,0-1.2-.2-2.2-.5-3-1-.3.7-.7.6-1,0-2.2-.2-4.2-.7-6-1.5-.1,1.2-1.2,1.1-1.5,0l-.5-.5c-.4,1.3-2.5,1.3-3,0l-3-.5c-.2,1-.5.9-1,0-1.7,0-3.4-.4-5-1-.2.4-.3.4-.5,0-.2.3-.5.3-1,0-.6,1.4-1.9,1.4-2.5,0h-1.5c0,.4-.3.4-.5,0l-4-.5c0,.4-.3.4-.5,0-.7.2-1.4,0-2-.5-.5,1.4-2,1.4-2.5,0-.3-.2-.6-.1-1,0-.2,1-.5.9-1,0-4.8-.4-9.8,0-14.5.5-.2.7-.6.6-1,0-6.8,0-13.7.3-20.5,1-.3.8-1.3.9-1.5,0l-1.5.5c-9.9,2.1-19.6,4.5-29.4,7.2l-1.6-.2c-4.6,2.1-9.5,4.2-14.5,4.5h-.5c5.4-2.7,11.3-4.2,17-6l5.5-1.5c1.7-.5,3.3-1,5-1.5,8-2.2,16.2-3.8,24.5-4.5,3.7-.3,9.3-1,12.7-1h24.5c1.6,0,4.7.4,6.7.5Z"
          fill="#7a7ae0"
        />
        <path
          d="M339.2,51.4c8.5,4.9,20.2,11.3,29,15.5,1.1,1,2.2,1.5,3.4,1.4,2.9,2.1,5.5,4.6,8.1,7.1,1.3.7,5.9,4.1,6.1,5.1s0,.6,0,.9c-.2.3-.3.6-.5.6-.6,0-7.4-6.5-8.5-7.6-.6.6-1.1.4-1.8.2-1-.3-5.9-3.6-7.1-4.5s-.1-.4-.1-.7c-3.7-3-7.7-5.5-12-7.5-.1.4-.3.4-.5,0-10.1-5.5-20.4-10.7-31.1-15.3l-.3-.7c.2,0,.3,0,.5,0,5.1,1.7,9.9,3.8,15,5.5Z"
          fill="#6a7cdf"
        />
        <path d="M282.7,34.9l-13-1.5c4.8.3,8.3.7,13,1.5Z" fill="#a4c5fc" />
        <path
          d="M224.2,33.9c.3,0,.7,0,1,0l-24.5,4.5c1.8-.5,4.2-1.6,6-2,3.9-.9,10.5-2.1,14.5-2.5s2,0,3,0Z"
          fill="#9cbbfa"
        />
        <path
          d="M383.1,75.4l-8.5-5,6.5,5.5c-.5,0-1-.1-1.5-.5-3.7-3.1-7.8-5.5-11.5-8.5,1,.5,2.5,1.6,3.5,1.3-1.4-1.2-3.1-2-4.5-3.3,5.8,2.5,10.9,6.7,16,10.5Z"
          fill="#a1c8fb"
        />
        <path
          d="M401.1,92.9c4.5,5.3,9.6,10.2,14.2,15.5s5.2,6.9,8.2,10c.6.6.7,1.3,1,2,2.3,2.7,4.1,5.5,5.5,8.5-.1.3-.5.2-1-.5l-.9-.2c-5-6.6-10.2-13.2-15.5-19.6v-1.7c0,0-1.6-1.5-1.6-1.5l-2-2-2.5-2.5c-.4-.2-.4-.3,0-.5l-1-1c-1.1.7-2.5-1.5-3-2.5-1.9-2.2-3.8-4.3-5.8-6.3l.3-.7c1.5.8,2.7,2,4,3Z"
          fill="#6e87e8"
        />
        <path
          d="M434.6,133.8c1.2,2.6,2.7,5,4,7.5,3,4.6,5.4,9.6,7.6,14.7v1.3c-.1,0-1.6-1.4-1.6-1.4-4.7-9.1-9.6-18.1-14.6-27.1-1.7-2.8-4.2-5.6-5.5-8.5,4.2,3.8,6.4,9.2,10,13.5Z"
          fill="#7091ed"
        />
        <path
          d="M381.1,75.9c5.1,3.3,11.9,9.5,16,14s5.3,6.3,5.5,7c-.5-.2-1.1-.5-1.5-.8-4.6-3.9-9.1-7.9-13.7-11.9s-1.5-1.7-1.8-2.8c-2-1.9-3.7-4.1-6-6,.5,0,1,.2,1.5.5Z"
          fill="#7081e2"
        />
        <path
          d="M458.1,294.3c-.4,1.8-.6,4.6-1,6.5-2.2,7.8-4.3,15.4-7,23,.4.2.4.3,0,.5l-.5.5c.2.4,0,.6-.5.5l-.8-.9c1.6-5.1,3.2-10.3,4.8-15.4l-.5-.2c-.2-.1-.2-.3,0-.5-.8-.2-.6-1,0-1.5-.3-2.1.2-3.3,1.5-3.5,1-2.8,1.8-5.7,2.3-8.6l.7-.4h1Z"
          fill="#2353e6"
        />
        <path
          d="M461.6,224.8c.8,6.7.9,13.8,1,20.5h-.5c-.4,0-.4-.3,0-.5-.3-7.2-.9-14.4-2-21.5-.6-1.5-.7-3.4-.5-5-.5-.3-.4-1.2,0-1.5,2.3.2,2.6,6.2,2,8Z"
          fill="#627de2"
        />
        <path
          d="M462.1,247.8c.1,3.6.2,7.7,0,11.3s-.3,6.1-1.5,7.2c0-4.2,0-8.3,0-12.5,1-1.2.7-3.8.5-5.4l1-.6Z"
          fill="#2243c4"
        />
        <path
          d="M460.1,253.3c-.1,5.1-.4,10.1-.5,15.2s.3,2.2-.5,2.7l-.5-.3c.3-2.1.3-4.1,0-6.2-1.1-.3-1.1-2.3,0-2.5,0-3.4.2-6.7.5-10,.1-.4.3-.4.5,0,.2.1.4.5.5,1Z"
          fill="#467ff1"
        />
        <path
          d="M458.1,278.3c0,.8,0,1.7,0,2.5l-.5,2c-.2,2.3-.3,4.7-.5,7-.1.4-.3.4-.5,0-.6.1-.3-2.1-.2-2.2s0,2.2-.8,2.2c-1.3-.3-.9-2.8.1-3.2,0-1.5.2-2.8.9-3.8l.9-7.2c1.3-1.3,1,1.6.6,2.7Z"
          fill="#5fa6f3"
        />
        <path
          d="M457.1,294.3c-.4,3.4-1.8,6.2-3,9-1-.3-1-.7,0-1l.5-1c-1-2.4.4-6.2,1.5-8.5l.5-2c-.7-.3-.7-.7,0-1h.5c-.2,1.4.2,3.1,0,4.5Z"
          fill="#1855f2"
        />
        <path
          d="M459.1,271.3c0,2.3,0,4.9-1,7,0-.6.4-2.5-.5-2.5,0,2.3,0,4.9-1,7-.3-.8-.3-1.8,0-3-.6-2.6-.1-6.8,1.5-9,0-1.5.1-3,.5-4.5-1.1-.1-1-1.1,0-1.5.9,1.6.6,4.5.5,6.5Z"
          fill="#538aee"
        />
        <path
          d="M462.1,244.8c0,.2,0,.3,0,.5,0,.8,0,1.7,0,2.5l-.5,6.7-1-.7c0-.5,0-1,0-1.5-.1-1.3-.3-2.6-.5-4-.4-.8-.4-1.7,0-2.5h.7c-.6-4.7-.8-9.4-.9-14.1s.1-1.1.7-1.4c.6.4.8,1.1.8,2.1l.7,12.4Z"
          fill="#1e35b5"
        />
        <path
          d="M460.1,245.8c0,.8,0,1.7,0,2.5.4,1.3.5,2.7,0,4,0,.3,0,.7,0,1-.5-.1-.5-.6-.5-1-.5-2.4-.5-5.1,0-7.5.1-.4.3-.4.5,0,.9.3.9.7,0,1Z"
          fill="#305bdf"
        />
        <path d="M460.6,252.3h-.5c0-1.3,0-2.7,0-4,.9.8.5,2.7.5,4Z" fill="#2243c4" />
        <path d="M457.6,282.8l.5-2c0,1-.5,1.9-.5,2Z" fill="#538aee" />
        <path
          d="M454.6,181.3l.5,1c3.6,9.5,7.5,22.9,8.5,33l.5,2.5c0,.5,0,1,0,1.5-.1,1.6-.6,1.9-1.5,1,0-.2,0-.3,0-.5-.2-.5-.4-1-.5-1.5-1-.3-1-.7,0-1l-.5-2-1.2-1.2c-1-5.4-2-10.8-3.7-16l.4-.8-.5-.5c-.7,0-.9-.9,0-1l-.5-1.5c-1.3-1-1.8-3.4-1.5-5l-.5-.5c-.5-.1-.4-.3,0-.5-.4-.7-.8-1.6,0-2l.7-.2c-.7-1.9-.9-3.7-.7-5.3.1-.4.3-.4.5,0,0,.2,0,.3,0,.5Z"
          fill="#5b77e8"
        />
        <path
          d="M454.1,188.3c0,.2,0,.4,0,.5l.5.5c.5,1.6,1,3.3,1.5,5l.5,1.5c0,.3,0,.7,0,1l.5.5c2,6.7,3.5,10.8,4.5,18l.5,2c0,.3,0,.7,0,1,.3.4.4,1.1,0,1.5.1,1.7,1.3,5.5-.5,5-.3-2.5-.9-5.8-2-8-1.4-5.8-2.4-11.6-3-17.5l-.5-1c-.4-.1-.4-.3,0-.5l-.5-.5c-.5,0-.6-.8,0-1l-.5-.5c-.5-.4-.7-1.2,0-1.5l-.5-.5c-.7-.3-.7-.7,0-1l-.5-.5c-.8-.4-.9-1.4,0-1.5-.8-1.1-1.1-2.1-1-3,.1-.4.3-.4.5,0,.2-.2.4,0,.5.5Z"
          fill="#6e89eb"
        />
        <path
          d="M464.1,219.3c.7,8,2.7,15.9,2,24-.6.8-.9,0-1-.7-.2-1.8.6-4.2-.5-5.8-.3-5.2-1.1-10.3-1.5-15.5l-.5-.5c0-.2,0-.3,0-.5l1.5-1Z"
          fill="#5777ee"
        />
        <path d="M462.6,219.8h-.5c0-.5,0-1,0-1.5.7.3.4,1,.5,1.5Z" fill="#627de2" />
        <path d="M463.1,221.3c-.2,0-.5-.3-.5-.5.2,0,.5.3.5.5Z" fill="#5b77e8" />
        <path d="M464.1,216.8v1c-.8-.4-.4-1.7-.5-2.5l.5,1.5Z" fill="#5777ee" />
        <path
          d="M420.1,386.2c-3.9,5-8.9,10.2-13.5,14.5-2.5.8.5-1.8,1.5-2.5,7.9-8.4,16-17.9,22.5-27.5-.5,2.1-2.3,4.4-3.6,6.2-2.2,3-4.7,6.4-6.9,9.3Z"
          fill="#5063c7"
        />
        <path
          d="M425.6,374.7c-5.2,7.4-10.5,14.7-16.5,21.5l-5.1,5.2c-.6.6-1.1.7-1.4.3l-.4-.5c7.7-9,15.2-18.1,22.4-27.5h1c0,.3,0,.7,0,1Z"
          fill="#6d81da"
        />
        <path
          d="M407.6,398.2c-3.7,4.2-7.9,8.2-12.5,12,0,.5-.6.7-1,.5h-.5c.1-2.1,3.3-5,5-6.5s.5-.1,1,0c-.1-1.2,1.9-2.8,3-2.5.1-.1.8,0,1.3-.5,1.9-1.7,3-3.9,5.2-5-.5.6-1,1.4-1.5,2Z"
          fill="#6375cb"
        />
        <path
          d="M445.1,338.2c-1.2,2.8-2.7,5.5-3.5,8.5-2.6,3.8-4.6,8-7,12-.7.5-.9.2-.5-1,0-3.4,2.4-7.4,5-9.5-1-1,.6-4.3,2-4.5.3-3.1,1.5-5.3,3.5-6.5.6-.5.7-.2.5,1Z"
          fill="#a9d2f6"
        />
        <path
          d="M434.6,358.7c-.8,1.3-1.7,2.5-2,4-2.2,3.2-4.1,6.5-6.5,9.5-.1-.5-.1-1.2,0-2-1.2-.9.2-3.3,1.5-3,1.5-3.1,3-6,4.9-8.8l1.6-.7.5,1Z"
          fill="#bcdff7"
        />
        <path
          d="M426.1,372.2c-.2.5-.4.9-.5,1.5l-23,28c-.9.8-2.1,1.6-3,2.5-.8.7-.9.5-1-.5-1-1.5,0-1.9,1.5-1.5-.2-1.7,2.4-4.1,4-4,1.1-1,1.5-2,1.4-3,2-1.3,3.7-3,5.1-5l5.5-7c-.3-1.4,2-4.4,3.5-4.5l1.7-2.5c.3-2,2.8-5.7,4.8-6l1-.2c-.3.8-.7,1.4-1,2.2Z"
          fill="#d8ecf8"
        />
        <path
          d="M451.1,323.7c0,.2,0,.7,0,1l-.5.5c-1.8,4.6-3.6,8.5-5.5,13l-.5-1c-.5-1.6.2-3.4,2-5.5-.5-1.5.9-6,2.5-6.5.2-.2.3-.3.5-.5l.5-.5c0-.1,0-.4,0-.5.6-1.1,1.1-1.7,1,0Z"
          fill="#9abff5"
        />
        <path d="M450.6,325.2c0-.2.3-.4.5-.5,0,.2-.3.4-.5.5Z" fill="#8eb7f9" />
        <path
          d="M408.1,398.2c-.6.6-.8,1.5-2,1.5l.5.9c-3.5,3.3-7.4,6.3-11,9.5h-.5c3.5-4.6,8.6-7.8,12.5-12h.5Z"
          fill="#5165c6"
        />
        <path
          d="M395.6,410.2c-4.4,3.9-8.2,7.9-13,11.5s-3.4,2.3-5,3.5v-.9c3.7-3.5,7.8-6.5,12-9.1,1.5-1.6,3-3.1,4.5-4.5.2-.2.7-.3,1-.5h.5Z"
          fill="#4960c2"
        />
        <path
          d="M450.6,162.3l3.1,7.3c.5.2.9.4,1.1.8,1.7,3.3,3.3,6.9,4.8,10.4s.2.8.2,1.2,0,.9-.1,1.3c-.1,1.4.1,2.7.5,4h-.5c-.1.4-.3.4-.5,0,0-.2,0-.4,0-.5-3.2-5.9-6-12.5-7.5-19-2.1-2.8-3.5-7-4-10.5,1.9-.4,4.1,3.6,3,5Z"
          fill="#77abfd"
        />
        <path
          d="M451.6,167.8c2.6,6.4,5.2,12.4,7.5,19l-2-2-3-7c-1.6-1.7-3.3-5.6-3-8-.3-1.3-.2-2,.5-2Z"
          fill="#6e9ff9"
        />
        <path d="M459.6,188.3c-.5-.2-.4-.6-.5-1h.5c0,.3,0,.7,0,1Z" fill="#6e9ff9" />
        <path
          d="M451.1,169.8c1,2.6,2.3,5.3,3,8s.3,2,.5,3h-.5c-1.5-.7-2.1-2.2-2-4.5-2.8-3.9-4.9-8.8-5.5-13.5-.8-1.2-1.1-2.3-1-3.5-.4-1.5,0-2,1-1.5.3,0,.6,0,.6,0,1.8,3,3.3,8.6,3.9,12Z"
          fill="#6589ec"
        />
        <path d="M455.1,182.3c-.5-.2-.4-.6-.5-1,.5.2.4.7.5,1Z" fill="#6589ec" />
        <path d="M31.4,166.3c.2-.7.1-1.3,1-1.5-.2.7-.1,1.3-1,1.5Z" fill="#5a8aee" />
        <path d="M33.3,162.8c-.3.2-.7.3-1,.5.2-.7.9-1.2,1-1.5v1Z" fill="#5a8aee" />
        <path d="M33.8,160.3l.5-1c-.2.7-.4.9-.5,1Z" fill="#5a8aee" />
        <path
          d="M65.8,112.9l.2.7c-1.8,1.3-3.4,2.9-4.7,4.8-.4.6-.9,1.3-1.5,2,.5,1.6-.9,3.3-2.5,2.5.8-1.1,1.6-3.3,2.5-4.5.9-1.1,1.6-2.5,2.5-3.5l3.4-3.2.6.2c.9.5.4.7-.5,1Z"
          fill="#a7d3fb"
        />
        <path
          d="M78.8,106.4c-1.7,2.4-4.4,3.7-8.2,3.9-1.6,0-3.6,0-4.3,1.6-1.2,1.1-2.5,2.6-4,3,1-1.1,2.4-3.1,3.5-4,.8-1.1,2.8-2.6,4-2.5,2.8-1,5.3-2.4,7.5-4.2,1.5,0,2.4.9,1.5,2.2Z"
          fill="#ace7fc"
        />
        <path
          d="M88.3,87.9c1.2,1.3-.3,3.3-1.8,3.8-.3,1.6-1.2,3-2.7,4.2.2.2.4.3.5.5.8,1.7-11.2,11.9-14.4,12-.8.4-3.3,1.9-4,2.5-.1-1,.7-1.1,1-1.5,1.6-.8,3.7-2.5,5-3.7,5.1-4.8,8.9-12.2,14-16.2.9-1.4,1.7-1.9,2.5-1.5Z"
          fill="#bdf0fd"
        />
        <path
          d="M133.8,56.4c2-1,5.5-1.1,7.4-1.8s.9-1.6,2.1-2,3.8-.1,5.5-.7c-1.6-1.6,2.5-3.7,3.5-1.5-2.7,1.2-5.3,2.8-8,4-2.5,1.4-5.1,2.8-7.8,4.3-1.3,0-2.4.4-3.1,1.1l-15.3,10.5c-1.8.4-3.5,1.7-4.9,3.8-2.2-.5-3.6,0-4.1,1.6-6.1,3.5-11.8,7.5-17.1,11.9-1.1.6-2.7,1-3.7.3-.7.5-2.1,1.2-2.5,1.5.9-2.6,3.6-3.6,5.4-5.3s5.6-6.1,7.9-7.1,3.2-.4,4.3-1.2,1.1-2.3,1.8-2.7,1.9,0,2.7-.3.8-.9.8-.9c3.3-1.6,5.2-3.8,8.1-5.7s6.7-3,7.4-3.6.5-1.5,1.3-2.2c1.6-1.3,5.5-1.8,8.2-4Z"
          fill="#bef5fe"
        />
        <path
          d="M43.3,147.3c1.3,1.3-1.6,7.1-2.9,8.2-3.1,2.6-4.2,1.3-3.1-2.2.2-.5.3-1,.5-1.5h.5l1,1.3,4-5.8Z"
          fill="#72a7fc"
        />
        <path
          d="M47.8,139.3c1.4-4.2,3.5-5.7,6.4-4.4,1.4,4.7-.5,8.6-2.9,12.4.4.2.4.3,0,.5l-1,1.5c1.2.7.9,1.2-.5,1.5l-.5.5c.4.2.4.3,0,.5l-.5,1c1,.1.9.6,0,1-.2,1.4-.9,3-2.5,3-1.2-1.2-3.3,1.8-4.1,3.4l-3.4,6.1c-1.7,4.7-4.5,3.8-3.6-1.1-1.2-1.3-1.5-2.4-.9-3.4,0-.2,0-.3,0-.5l.5-1c.8-2.3,1.7-4.7,2.5-7,0,1.8-.4,3.5,1.8,2s3-5.6,4.2-8,1.3-2.7,2-4,1.8-2.7,2.5-4Z"
          fill="#6ba1fb"
        />
        <path
          d="M55.8,126.9c5.7-3.7,7,3.7,3.1,7.3-.3,5-3.4,9.3-6.5,13.1h-1.1c.6-2.3.9-1.7,1.1-2.5,1.1-3.2,1.6-6.6.8-9.9-.9,1.3-2.8.5-3.3.9-1,.8-.5,3-2.2,3.6.5-1,1.1-2.9,1.5-4,1.4-2.2,2.4-3.5,4-5.5.3-1.3,1.2-2.9,2.5-3Z"
          fill="#73a8fd"
        />
        <path
          d="M53.3,128.4c-.2.2-.7.3-1,.5.8-1.1,1.9-2.2,2.5-3,1.3.3-.5,2.6-1.5,2.5Z"
          fill="#caedfb"
        />
        <path
          d="M59.8,120.4c.8-1.1,2-2,3.4-2.7,3-3.9,5.4-2.2,5.6,1.7.3.1.3.3,0,.5.4.1.4.3,0,.5.1,3.8-3.5,4.6-5.7,1.2-1.8,2.6-4.5,4-7.3,5.3-.9,1-1.7,1.9-2.5,3v-1.5c.6-.6,1.4-1.6,1.5-2.5.7-1.1,1.7-1.9,2.5-3,1.1-.6,1.5-1.6,2.5-2.5Z"
          fill="#79b8fe"
        />
        <path
          d="M50.3,338.7c.1-.4.4-.7.8-.7,4.9,9,10.1,18.1,15.6,27.4l3.6,5.2c.4.2.7.4.9.6,2,2.6,4.6,5.9,5.6,8.9.9,1.2,1.2,2.2,1,3-4.3-5.4-7.8-11.4-12-16.5-1.2-1.8-2.3-3.8-3.5-5.6-2.4-3.7-4.5-7.6-7-11.4-.5-1.7-1.5-3.9-2.3-5.5s-1.3-2-2.3-4.1-1.2-.4-1-1.4h.5Z"
          fill="#4554b8"
        />
        <path
          d="M34.8,304.8c.2.7.7,2.7,1.3,3,.6-.8.9-2.2,2.2-2-1.2,2.5.5,2,1.3,3s.5,3.4.7,4.2c.8,2.4,2.4,5.2,3.5,7.8-1,.4-2.1-.3-3.2-2.4-.1,0-2.1.3-2.2.3-.2.2,1.1,5.2,1.4,6,0,.2,0,.3,0,.5.5.5.8,1.3,1,2,0,.2,0,.3,0,.5l1,3c0,.3,0,.7,0,1-3.9-8.6-6.8-16.8-7.9-26.4-.1-1.3-.4-1.4.9-.6Z"
          fill="#4652cd"
        />
        <path d="M44.3,339.2c-.5-1.1-.6-1.3-1-2.5.9.5,1,1.6,1,2.5Z" fill="#4652cd" />
        <path d="M43.3,336.2c0,0-.3-.4-.5-1l.5,1Z" fill="#4652cd" />
        <path d="M42.3,332.2h-.5c0-.2,0-.3,0-.5,0,.2.4.3.5.5Z" fill="#4350c5" />
        <path
          d="M39.8,324.7c-2.8-4.6-3.3-10.1-4.5-15,1.4-.3.8.3,1.1,1.1.5,1.3,1.6,6.3,2.4,6.9s.8-1.5,1.7-1l3.3,4c1.4,3.3,3.9,7.3,5,10,1,1.6,2.3,5.2,1.5,7-3.1-2.8-2.1-7.8-6.8-10-.2,0-.4,2-1.2,1s-1.6-6.9-2.5-8c-1.1.3-.2,3.1,0,4Z"
          fill="#4350c5"
        />
        <path
          d="M49.8,331.2c.4.2.4.3,0,.5.7,1.3,1.3,2.9,1.5,4.5.4.1.7.3.9.5,1.8,3.1,4.1,7.7,5.6,10.9s0,.6,0,1c4.5,7.1,8.7,14.5,12.5,22-2.2-2.5-4.4-5.7-6.2-8.5-3.4-5.2-6.1-10.7-9.1-16.3s-2.1-1.6-1.6-3.6c-1.3,1.2-1.8-1.7-2.3-2.9s-.7-.5-.7-.6c0-.3,0-.7,0-1-.5-1.8-.8-5.3-1.5-7l1,.5Z"
          fill="#4a58c0"
        />
        <path d="M40.8,327.2c0-.3-.7-.8-1-2,.9.3,1.1,1.1,1,2Z" fill="#4350c5" />
        <path d="M41.8,330.7c-1-.8-.7-2.1-1-3,.9.8.8,2,1,3Z" fill="#4350c5" />
        <path
          d="M27.9,241.3c.2.4.5.7,1,.8,0,1-.2,7.4.3,7.8.8,0,1.2,0,1.9.6s1.9,8.6,1.9,9.9-.3.3-.7.4c-.5.2-1.1,0-1.7-.8-.8.7-2.5,1.5-2.8.3,0-.3,0-.7,0-1,0-2.8-.4-5.7-.5-8.5s.2-7.5,0-11.2-2.2-6.2,0-8.7c1.3,2.8,2.2,7.7.5,10.5Z"
          fill="#5b83f8"
        />
        <path
          d="M32.3,270.3c0-.1-.5-.2-.7-.5-.3-.5-.5-2.7-.8-3-1.8-1.7.6,3.3-2,2s0-1.5-.5-3c-.1-1.5-.3-3-.5-4.5,2.5-2.2,4-1.1,4.8,2.1s.9,6.1-.3,6.9Z"
          fill="#5779f1"
        />
        <path
          d="M27.9,260.3c1.5,1.1,1.1-1.3,2.7-1.3s1.3.9,1.8,1.8c.8.1,1.2,1,1,2.5.9,1.9,2.8,6.7,1.5,8.5.6,0,.8.6.6,1.8.9.9.9,4.1.4,5.2-.4,1-.7.3-1-.5-.2-1.1-.3-2.9-.5-3.7s-1-.3-1-.3c-.2-.3.9-.9.9-1.2s-1.4-1.8-1.9-2.7c-.7-3.5,1.5-10.8-4.5-9,0-.3,0-.7,0-1Z"
          fill="#5e7cf1"
        />
        <path
          d="M31.4,284.3c.3-.9,1-2.5,1.8-1s-.3.9-.2,1.2.6,1.2.9,2.3c1.7,0,3.5,5.1,1.5,5.5,0,0-.6.1-.7.5-.4,1.2.2,2.3-1.3,2-.4-1-.9-1.1-1-1.4-.6-1.7-.5-4.7-1.5-6.6.3-.8.3-1.8.5-2.5Z"
          fill="#4f66e1"
        />
        <path
          d="M35.8,278.8l.9.9c1.2,5,2.4,10,3.6,15.1.6,1,1.1,2.4,1.5,4,.7,1.7,1,3.6,1,5.5-.8,1.7-1.4.8-1.8-2.7l-.7-.8c-1.3-2.6-2.9-5.9-3.8-8.8s-1.7-5.1-1.2-7.7c-.3-1.6-.2-3.8-.5-5.5s0-.3,0-.5l1,.5Z"
          fill="#6377e8"
        />
        <path
          d="M35.3,284.3c1,5.3,3.6,10.9,5,16.5.8.4,1.2,2,.5,2.5-.6,0-.9-.5-1-1.5-1.3-3.1-2.4-6.9-4.5-9.5.5-1.5-1-3.9-1.5-5.5,1.4.3,1.4-1.4,1.5-2.5Z"
          fill="#576ae1"
        />
        <path
          d="M28.4,265.8c1.2,0,2.3.1,3.2.4,0,1.5.3,2.8.8,4.1,2.7-.4,2.9,6,2.5,8,.3.1.3.3,0,.5-2.3.2-1.8-2.8-2-3s-3.4,1.6-4-.5c0,0,.4-1.7.4-1.8,0-.3-.8-.2-.8-.5-.3-1.5,0-5.3-.1-7.3Z"
          fill="#5574ed"
        />
        <path d="M33.1,272.8c.3.2.3.3,0,.5v-.5Z" fill="#5e7cf1" />
        <path
          d="M392.6,411.7c-.6,1.3-1.9,2.5-3,3.5-3.8,3.6-8.6,6-12,10-2.4,1.7-5.1,3.3-7.5,5-.8.2-.8-.1,0-1l-.2-1c7.4-5.4,14.6-11,21.7-16.8l1.1.4Z"
          fill="#6074c5"
        />
        <path
          d="M356.2,438.2c.5,0,1,0,1.5,0-.6.3-1.4,1.2-2,1.5-.9.5-2.4.9-3.5,1.5h-.5c-.4-.1-.4-.3,0-.5-.3-1.6,3.5-4.4,4.5-2.5Z"
          fill="#5d75ce"
        />
        <path
          d="M383.6,421.7c-.6,1.3-.1.8-1.5,2.5l.3,1.1c-2.2,1.8-2.6,3.1-1.3,3.9-3.9,3.9-8.9,6.1-13.5,9-2.2-.1-4.4.2-6.6.9-.6,3.1-3.5,2-5.4.6-.2-.8.5-1.3,2-1.5.6-1.1,3.7-3.2,4.5-2,.8,0,1.3-.3,1.5-1,.9-2.2,4.2-4.2,6.5-5,1.9-2.1,4.8-4.5,7.5-5,1.5-1.6,3.2-2.8,5-3.5h1Z"
          fill="#2f59b8"
        />
        <path
          d="M370.1,430.2c-2.2,1.5-4.3,3.5-6.5,5,.2.8-.8,1.2-1.5,1-1.1,0-3.4,1.4-4.5,2-.8.5-1.3.5-1.5,0-.2-.4-.2-.8,0-1.2.3-.7,11.3-7.4,12.9-8.3l1.2.4v1Z"
          fill="#6272c9"
        />
        <path
          d="M363.6,435.2c1,.1.3,1.3-.3,1.5-1.2.4-1.2-.5-1.2-.5.2-.9,1.2-.8,1.5-1Z"
          fill="#2c5abc"
        />
        <path d="M365.9,434.2c.5.4-.8,1.3-.7.7l.7-.7Z" fill="#2c5abc" />
        <path
          d="M341.2,447.7c2.4,3.7,4.5,1.1,8,1-1.5,1.2-3.3,2.2-5.5,3,0,.7-.3.9-.9,1.2-7.3,3.3-14.1,6-21.7,8.4s-1-.1-1.4-.6c-3.8,1.7-4.9,1.1-3.7-2.9,5-.6,9-2.5,13.2-5.1,3.6-2,8-4.1,12-5Z"
          fill="#285fc1"
        />
        <path
          d="M352.2,441.2c-3.3,1.8-7.6,4.8-11,6.5s-8.1,3.4-12,5c-3.7,2.5-7.7,4.1-11.9,4.7v-.7c0,0,0-.7,0-.7l7.4-2.8c.3-.3.8-.4,1,0l1-.5c.1-.4.3-.4.5,0l1-.5c7.8-3.6,15.6-7.3,23.5-11h.5Z"
          fill="#406cc9"
        />
        <path
          d="M351.7,447.7c-.9.8-2.5,2-3.5,2.5-1.5,1.4-3,1.9-4.5,1.5,1.7-1.2,3.7-2.1,5.5-3s1.8-.7,2.5-1Z"
          fill="#4d7fd5"
        />
        <path
          d="M348.2,450.2v.5l-2.5,1.5c-.2.1-.3.4-.5.5l-3.6,2c-1.4,1.9-4,2.7-6.4,2.5-.3.4-.6.8-1,1.1-1.7,1.5-15.7,6.2-18,6.1s-1-.1-1.5-.2v-.7c1.5-.5,2.7-1.1,3.5-1.8-.3-.4.2-.7,1.5-1,7.2-1.4,17-6,24-9s3.4-1,4.5-1.5Z"
          fill="#528bdc"
        />
        <path
          d="M345.2,452.7l-3.5,2.5c1.9.5,2,1,4,.5l-1,1c-1.8,2.2-6.7,4.4-9.5,3.5.5-1.3.5-2.3,0-3,3.4-1.3,6.6-3.3,10-4.5Z"
          fill="#2159cb"
        />
        <path d="M351.7,449.2l-6,3c.9-.6,1.5-1,2.5-1.5s2.5-1,3.5-1.5Z" fill="#4d7fd5" />
        <path
          d="M151.3,454.2c.4-.4.9-.5,1.4-.5,1.1,0,10.1,4.5,11.9,5.4s.3.4.4.8c1.3-.3,1.9,0,1.7,1,3,.6,5.7,1.5,8,2.8.9.2,1.4.5,1.5,1,.5.9.8.7.4.6s0,.3.4.4c12.6,4,25.1,7.9,37.8,11,2.5-2.4,6.8-.6,9.6.8,1.1-1,2-1.4,3.5-1.2,4.3,1.1,8.6,1.9,13,2.3,1.8,0,5.7.2,3.2,2.1-.9,1-2.3,1-4,0-.2,1.2-2.6,1.2-3,0-.3,0-.7,0-1,0-.8.1-1.8.2-2.5,0-.3-.1-.8-.5-1-.5-1.8.5-3.5.4-5-.5-.1,0-2,.4-2.5.5-.6.2-1.1,0-1.5-.5-.5,0-1,0-1.5,0-1.1-.1-3.3,0-3.5,0-2.9-.5-5.8-2.3-9.2-2.5-7.7-.4-15.9-3.2-23.4-5.6s-15.4-6.3-22.9-8.9c-.4-3.2-4.8-1.9-5.9-2.6s-.5-1.6-1.1-2.2c-1.4-1.5-5-2.9-7-2.7l.5-1-2-1c1.1.5,2.5.7,3.5,1Z"
          fill="#61b5fc"
        />
        <path
          d="M324.7,464.7c.8-.4,2-.1,1.7.8s-7.6,4.6-8.5,4.9c-9.4,2.5-18.7,4.7-28.1,6.8-5,.5-10.3,1.9-15.5,2.5-3.4-1-7.2-1.6-10.4.2-5.8,2.2-11.9,2.6-17.9,2.6-1.9.9-5.6.3-5.7-1.8,1.4,0,2.6,0,4,0,1.3-1.6,3.5-1.9,6.6-.9.6-.8,1.5-1.4,2.6-1.7-4.6.3-9.2.3-13.8-.1l-.4-1.2c3.2-.7,6.5-.7,10,0,1-.4,2.1-.9,3.2-.9,14.5-.5,28.5-1.3,42.7-3.6l1.7-1.2c9-2.1,18-4.4,26.8-6.8l1,.5Z"
          fill="#62b4fb"
        />
        <path
          d="M344.7,456.7c.9-.3,2.2-1.1,3-.8-1.3,1.4-2.9,2.4-4.5,3.5s-1.3.2-1,1.8c-3.4.9-9.1,2.6-12.4,3.8s-8.1,4.6-11.5,6.2c-3.7.3-8,1-11.5,2.3-6.7,2.3-10,3.1-17,3.7,2.2-.3,4.3-1.3,6.3-1.8,5.9-1.6,14.4-3.2,20.6-5.4s4.5-1.6,5-2c1.6-1.1,1.6-3,4.5-2.7l-1.5-.5c0-.4,0-1,.3-1.3s7.9-3.3,9-3.6l1.2.4c3.3-.9,6.3-2.4,9.5-3.5Z"
          fill="#5faefa"
        />
        <path
          d="M274.2,479.7c-.8,0-1.9.2-2.7.2-2,.2-5.1-.1-7,.2s0,1.5-.5,1.6c-2.2.4-6-.2-7.9.2-4.4,1-1.3,1.4-6.6.8s-3.3,1.2-3.9,1.2c-1.1,0-5.3-1.7-6.5-1.8s-1.3.5-2.2.5c0-.6,1.4-1.1.5-2,.8,0,2.1,0,3,0l2.9,1.9c3.1-2.2,6.4-.5,9.4-.7,4.8-.2,9.2-2.5,13.4-3.8s6.6-.5,8.3,1.6Z"
          fill="#5daffd"
        />
        <path
          d="M232.7,480.2c-.8,0-2,.8-3.8.5s-1.2-1-1.2-1l.2-.5c1.2,1.5,3.1.9,4.8,1Z"
          fill="#5daffd"
        />
        <path d="M236.2,480.7c-2.5,1.4-1.6.4-2.5,0,.7-1.3,2.2,0,2.5,0Z" fill="#5daffd" />
        <path d="M225.2,480.2c-.3,0-.9,1.2-1.5-.5.5,0,1,.2,1.5.5Z" fill="#5daffd" />
        <path
          d="M141.8,448.7c.9-.6,4,.2,4.7.6,1.3.7,0,2.6,2.8,1.9-1.2-1.5,1.2-.5,0-2,.5,0,1-.1,1.4,0,1.4.1,14.4,5.9,15.6,7s.6.7.9,1.1c1.5-.2,4.1.3,4,2-3.2.8-2.8,1.2,1.1,1.4,1.8.3,4.3,1.7,2.4,3.1-7.2-1.2-16.4-7.1-23.5-9.5-2.8-1.6-5.8-3-8.7-4.6s-.7-.8-.8-.9Z"
          fill="#1d59c9"
        />
        <path
          d="M149.3,447.7c.6-1.3,1.9-1,2,.5,4.7.6,9.5,2.7,13,6,.9-1.4,5,1,4.5,2.5,0,.5-.5.6-1.5.5-6.3-2.6-11.9-5.1-18-8s-.4,0-.5,0l-.5-.5c-.1,0-.4,0-.5,0v-.5l-4.5-3c2,.7,4,1.6,6,2.5Z"
          fill="#4a8bdf"
        />
        <path d="M146.8,448.2l-.5-.5c.2.1.4.4.5.5Z" fill="#1d59c9" />
        <path d="M147.8,448.7c-.2-.1-.4-.3-.5-.5h.5v.5Z" fill="#1d59c9" />
        <path d="M148.8,449.2c-.3-.1-.4-.5-.5-.5l.5.5Z" fill="#1d59c9" />
        <path
          d="M116.8,421.2l.6-.6c4.8,4.4,10.3,8.4,15.4,12.1,1.3.8,8.2,6.8,4.8,7.9l-5.3-2.9c-.5-.3-1.1-.3-1.5-.5-2.6-2.1-5.3-4.1-8-6,.8.2.6-1.8.4-2l-4.9-3.8v-1.2c-.9-.7-1.1-2.4-1.5-3Z"
          fill="#2f57b3"
        />
        <path
          d="M118.3,424.2c.8.3,5.5,4.1,5.8,4.5.4.6.6,4.4-1.3,2.5-1.1-.7-7.1-4.9-7.5-5v-.5c2-1,.6-2.5,3-1.5Z"
          fill="#2b4eac"
        />
        <path
          d="M133.8,432.7c2.1.4,4.9,2.5,6.5,4,3.6,2.2,7.3,4.2,11.1,6.1l.4.9c.4.5.8,1,1,1.5,2.9,2.2,2.2,4.3-1.5,3-.6-.3-1.4-.3-2-.5-6-2.7-11.3-7-17-10l5,2.5c.6-2.8-.6-2.2-1.5-3.2s-2.8-3.6-3-4.3c0-.4.3-.4,1,0Z"
          fill="#2f5fba"
        />
        <path
          d="M104.3,407.7c.6-.8,1-.6,1,.5,1.3-.7,1.7-.4,1.5,1-.2.2-.2.3,0,.5.5-.2.6,0,.5.5,1.8,1.6,2.8,3.3,3,5-2.5.7-2.2-1.8-4.1-2.6s-4.3-.5-4.9-3.9.4,0,.4-.2c-.2-.9-.4-1.8-.4-2.8,1,1,1.9,1.4,3,2Z"
          fill="#3848ad"
        />
        <path
          d="M108.3,410.7c1,.6,2.2,1.4,2.5,2.5.5-.1.6,0,.5.5,1.1.2,2.7,1.4,3,2.5,1.7.8,3.9,2.1,4,4-.6.6-1.6.4-3-.5-1.9-1.6-3.2-2.4-5-4.5s-2.2-3.3-3-5c.1-.4.3-.4.5,0,.3,0,.5.2.5.5Z"
          fill="#4857b0"
        />
        <path
          d="M118.3,420.2c3.2,2.3,6.2,4.8,9,7.5,2.6,1.3,4.8,3,6.5,5h-1c-.1-.5-7.3-4-8.1-4.5-1.6-.9-4.2-4.7-5.6-6s-1.3-1-2.2-1c-.6-.9-.8-.9-1.5-1.5l.2-.5c.8.8,1.9.6,2.8,1Z"
          fill="#405cb7"
        />
        <path
          d="M90.8,395.7c1.7.6,3.4,1.8,5,3.5.3-.3.7-.3,1,0,1.3-.8,2.5,1.6,1.5,2.5-.5.9-1.6.4-2.4.1-2.4-1.1-10-8.8-12.1-11.1-2.2-2.4-4-5-6-7.5l-1-3h.9c4.1,5.5,8.4,10.6,13.1,15.5Z"
          fill="#455abf"
        />
        <path
          d="M107.8,406.2c-.5.5-.9.4-1.5,0,1.5,1,.7,2.9-1,1.9-.3-.2-.7-.3-1-.5-1.8-2.1-3.7-2.8-5-5.5-2.2-1.6-.3-2.5,1.6-2.6l3.4,2.8c1.2.1,3.7,2.7,3.5,3.8Z"
          fill="#0720cc"
        />
        <path
          d="M98.3,396.7c1.4.3,2.2,1,2.5,2,2,1.7,3.4,2.6,4,2.5.9-.4,2,.6,1.5,1.5,1.8,1.4,3.1,2.9,4,4.5-.7.4-1.5,0-2.5-1-1.1-1.3-5.1-5.2-6.5-5.8s-2.4.7-2.5.8c-.1.1.4.7.5,1-.3-.2-.8-.3-1-.5-.3-.4-1.2-1.9-1.5-2.5-.4-.1-.4-.3,0-.5l-.5-.5c-.3-.2-.3-.3,0-.5-1-1.1-1.3-2.3.5-2,1.1-.3,1.7-.2,1.5,1Z"
          fill="#0e30db"
        />
        <path d="M461.1,189.8c-.2-.4-1.2-1-1-2,0,.1.7,1.2,1,2Z" fill="#77abfd" />
        <path
          d="M450.6,162.3c1.6,1,2.9,2.9,3.8,5.5h.7c1.6,3.7,4.3,8.8,5.4,12.4s.7,4.7,1.1,6.6c-1.4.2-.8-.3-1.1-1.1s-.4-1.5-.9-2.4c-3.2-6.9-6.7-13.8-9-21Z"
          fill="#80bafe"
        />
        <path
          d="M445.6,152.8l3.3,4.5.2-2.5c2.1,4.3,4.1,8.7,6,13l-1,2c-.8-2.7-2.2-5.1-3.5-7.5s-1.7-3.8-3-5c-1.2,0-2.9-3.7-2-4.5Z"
          fill="#84c2fe"
        />
        <path
          d="M445.6,152.8c.3,1.7,1.4,3,2,4.5,1.4,3.4,2.6,7,4,10.5l-.5,2c-1.2-3.2-3.3-9.5-4.5-12-.7.6-1,.4-.5-.5-2.1-5.4-4.9-10.7-7.5-16,3.1,3.2,4.6,7.8,7,11.5Z"
          fill="#719cf3"
        />
        <path
          d="M156.8,51.9l-20.1,11.1c-5.4,3.3-10.7,6.8-15.8,10.4-1.4,1.5-2.9,2.5-4.5,3-2.9,1.5-6.1,1.2-2.5-1.5-.8-1,1-2.5,1.8-3.1,6.4-4.5,13.2-9,20-13,2.9-1.3,5.8-2.6,8.7-3.8-1.3,5.4,4,0,5.9-.9s4.7-1.4,6.6-2.1Z"
          fill="#568af4"
        />
        <path
          d="M161.3,52.4c.6.1.4.5-.5,1-.2.4-.3.4-.5,0l-.5.5c-.1.4-.3.4-.5,0l-1.5,1c-.2.9-1,1.2-1.5.5l-1,.5c-.1.4-.3.4-.5,0l-.5.5c-.1.4-.3.4-.5,0-.9.9-1.9,1.7-3,2.5-.6.8-1.6,1.5-3,2,0,.4.1.7,0,.8-2.2,1.7-5.9,3.9-8.5,4.2-4.5,3.1-9.2,5.9-13.9,8.6l-.5-.6c1.2-1.5,2.9-2.9,5-4,9.6-7.1,20.5-12.7,31.5-17.5Z"
          fill="#6e77e0"
        />
        <path
          d="M129.8,69.9c-1.5,1.1-3.6,2.8-5,4l-.2,1c-4.3,3.9-8.7,7.8-13.2,11.5h-1.1s-4.7,4.1-4.7,4.1h-.8c2-4.6,7.4-8.4,11.5-11.1,4.1-3.4,8.8-7,13.5-9.5Z"
          fill="#727fe3"
        />
        <path
          d="M116.3,79.4c-4,3.4-7.9,7.2-11.5,11-.8.8-1.6,1.5-2.5,2-2.5,1.8-3.2,1.8-2,0-1-1,.2-2.5,1.5-2,3.2-4,7.6-7.6,11.9-10.9h1.1c0-.1,1.5-.1,1.5-.1Z"
          fill="#8eb5f7"
        />
        <path
          d="M120.8,73.4c-1.9,1.9-4.1,4.2-6,6-4.2,3.8-9.1,7.3-13,11-3.3,1.1-.1-2.1,1.7-2.8l1.8-2.2c2.1-3.9,6.7-7.6,11-9,1.4-1.1,3.1-2,4.5-3Z"
          fill="#7baffa"
        />
        <path
          d="M173.3,47.4c.1,0,.4,0,.5,0,.2.3.3.6.2.7-3.7,2.6-9,4.5-13.2,5.3l.5-1c1.3-.6,3.3-2,4.5-2.5,2.2-.9,5.2-1.7,7.5-2.5Z"
          fill="#6f76dc"
        />
        <path
          d="M144.3,54.4v.5c-9.3,4.8-18.3,10.2-26.6,16.6-1.5,1.2-2.6,1.8-3.8,3.4-.8,1.3-1.9,2.3-3.3,3l-1.2-.5-4.8,3.2c-2.9,3-6,6-9.1,8.8-1.7-.6-3.5.3-5.4,2.6l-1.9.8c.3,2.1-2.7,4.3-4.3,3.1.3-.4.3-1.3.7-2,1.3-2,3-3.8,3.8-6,1.7-1.2,1.4-.3,2.8-.9s3.6-3.7,5.8-4.8c3.3-1.6,8.4-4.6,11.3-6.9s.8-1.7,1.7-2.1,1.9.5,3,0,2.2-2.9,2.9-3.3,1.7,0,2.1-.3c4.9-2.6,10.9-7.6,15.5-11s.5-1.1.5-1.2c.6-.4,1.5,1.2,2.6.9s4.9-3,6.4-3.7,1.2-.2,1.5-.3Z"
          fill="#b5f3fd"
        />
        <path d="M195.7,39.9c-1.8.6-3.5,1.7-5.5,1.5,1.8-.6,3.5-1.6,5.5-1.5Z" fill="#878ae9" />
        <path
          d="M258.2,33.9c.3,0,.7,0,1,0,.3-.2.7-.3,1,0,.8,0,1.7,0,2.5,0,.6.5,1.2.6,2,.5.2,0,.3,0,.5,0l4,.5c.2,0,.3,0,.5,0h1.5c.8,0,1.7,0,2.5,0,.4.2.8.2,1,0,.2,0,.3,0,.5,0,1.6.6,3.3.9,5,1,.3,0,.7,0,1,0l3,.5c1,0,2.1,0,3,0l.5.5c.5,0,1,0,1.5,0,1.8.8,3.8,1.3,6,1.5.3,0,.7,0,1,0,1,.3,1.2.7.5,1-1.6.6-3.4,0-5-.5l-1.8.4c-26.3-3.6-53.1-4.5-79.3-.6l-1.8-.3c-4.3,2.1-8.8,3.6-13.5,4.5,0,.8-.8.9-1,0-.7.5-1.5.9-2.5,1-.1.4-.3.4-.5,0-1.9.8-4,1.2-6,1l-.3-.6c1.2-.4,2.3-.9,3.3-1.4,10.4-3,20.1-5.5,31-7l1.5-.5c.5,0,1,0,1.5,0,6.8-.7,13.6-1.1,20.5-1,.3,0,.7,0,1,0,4.7-.5,9.7-.9,14.5-.5Z"
          fill="#6d6dd1"
        />
        <path
          d="M320.7,44.9l.5.5c.2,0,.3,0,.5,0l.5.5c.4.1,1.1-.1,1.5,0,4.4,2.7,9.6,3.8,14.3,5.9s3.2,2.1,4.7,2.8c4.3,2.1,9.5,3.1,12.4,7.3-.5,1.1-2.3.3-3-.5-5.5-2.5-11.2-5.3-16.7-8.1s-.5-.4-.3-.9c-6.5-2.9-13.1-5.5-19.8-8-3.2-.4-4.3-1.1-3.2-2,2.9.8,5.7,1.6,8.5,2.5Z"
          fill="#6c71d6"
        />
        <path
          d="M188.3,42.9c-.4,1.4-2.6.6-3,2,.4.1.4.3,0,.5l-.5.8c-5.4,1.5-10.6,3.5-15.6,5.9l-.9-.2c-6.7,2.9-13.2,6-19.7,9.4l-.8-.4c1-.7,1.7-1.2,3-2,1.1-.8,2.1-1.6,3-2.5.1,0,.4,0,.5,0l.5-.5c.1,0,.4,0,.5,0l1-.5c.4-.2,1-.3,1.5-.5l1.5-1c.1,0,.4,0,.5,0l.5-.5c.1,0,.4,0,.5,0,2.5-.9,4.9-2.1,7.5-2.8l5.5-3.2c4.7-1.6,9.7-3.1,14.5-4.5Z"
          fill="#6b71d6"
        />
        <path
          d="M296.7,39.4c.3-.7.7-.6,1,0,.9.2,1.7.3,2.5.5.1-.4.6-.3,1,0l.5.5c.8-.5,2.2-.1,3,.5,1.4.2,2.9.5,4,1.5-.1-.5,0-.7.5-.5.2,0,.3,0,.5,0l1.5.5c.3,0,.7,0,1,0-.2,1.7,2.1.8,3.4,1.3,5.8,2.3,14.5,5.5,19.6,8.7l-.7.5c-12-4.8-24.6-9.4-37.3-12.5-1.4.4-5.3,0-5.5-1.5,1.6.2,3.3.3,5,.5Z"
          fill="#6d6ad0"
        />
        <path
          d="M258.2,33.9c-4.8.2-9.7.3-14.5.5,1.3-1.6,2.9-.4,4.2-.5,3.2-.2,7.1-1.3,10.2,0Z"
          fill="#6c71d6"
        />
        <path d="M242.7,34.4c-6.7.3-13.8,1-20.5,1l13.2-1.5,7.3.5Z" fill="#6c71d6" />
        <path d="M295.2,38.4c-2-.2-4.8.7-6-1.5,1.9.3,4.3.5,6,1.5Z" fill="#6c71d6" />
        <path d="M280.2,35.9c-1.7,0-3.8.5-5-1,1.5.1,3.6.4,5,1Z" fill="#6c71d6" />
        <path
          d="M299.2,39.4c-.3.5-1,.3-1.5,0-.3,0-.7,0-1,0l-.5-1c1.1,0,2.2.2,3,1Z"
          fill="#6c71d6"
        />
        <path d="M269.2,34.9c-1.2,0-3.2.4-4-.5,1.2,0,3.2-.4,4,.5Z" fill="#6c71d6" />
        <path d="M284.2,36.4c-.9,0-2.5.3-3-.5.9,0,2.5-.3,3,.5Z" fill="#6c71d6" />
        <path
          d="M299.2,39.4c.3,0,.7,0,1,0,.4.1.4.3,0,.5-.8,0-2.1.3-2.5-.5.5,0,1,0,1.5,0Z"
          fill="#6d6dd1"
        />
        <path
          d="M307.2,40.9l.5.5c.2,0,.3,0,.5,0,.6.4.8.7.5,1-1.1-.2-2.8-1.1-4-1.5h.5c.6,0,1.4-.1,2,0Z"
          fill="#6d6dd1"
        />
        <path
          d="M305.2,40.9h-.5c-1.1-.3-2-.3-3-.5l-.5-.5c-.3,0-.7,0-1,0v-.5c1.6.2,3.7.5,5,1.5Z"
          fill="#6c71d6"
        />
        <path d="M309.2,41.9c0,.3-.3.5-.5.5l-.5-1c.5.1.8.5,1,.5Z" fill="#6c71d6" />
        <path d="M220.7,35.4l-1.5.5c0,0,.4-.4,1.5-.5Z" fill="#6c71d6" />
        <path d="M271.2,34.9h-1.5c.5,0,.8,0,1.5,0Z" fill="#6c71d6" />
        <path d="M311.2,42.4l-1.5-.5c.7.2,1.2.4,1.5.5Z" fill="#6c71d6" />
        <path d="M264.7,34.4c-.3,0-1.2,1-2-.5.6,0,1.3.4,2,.5Z" fill="#6c71d6" />
        <path d="M260.2,33.9c-.3,0-.7,0-1,0l.7-.5.3.5Z" fill="#6c71d6" />
        <path d="M274.7,34.9l-.3.5-.7-.5c.3,0,.7,0,1,0Z" fill="#6c71d6" />
        <path d="M307.7,41.4l-.5-.5c.4,0,.5.5.5.5Z" fill="#6c71d6" />
        <path d="M287.7,36.9l-.5-.5c.4,0,.5.5.5.5Z" fill="#6c71d6" />
        <path d="M321.2,45.4l-.5-.5c.3.1.5.5.5.5Z" fill="#6a7cdf" />
        <path d="M322.2,45.9l-.5-.5c.3,0,.4.5.5.5Z" fill="#6a7cdf" />
        <path
          d="M355.2,61.9c.2,0,.4,0,.5,0,4.3,2,8.3,4.5,12,7.5,3.3,1.9,5.3,3.2,9,5,1.9,2.1,4,4,6.1,5.7v.8c0,0-.7.5-.7.5-1.3-1.1-2.6-2-3.9-3h-.9c-5.1-3.6-10.3-7.2-15.6-10.5-3.2-.3-6.6-3.3-9-5.5-.5.1-.6,0-.5-.5-.2-.2-.2-.3,0-.5,1,.4,2.3.3,3,.5Z"
          fill="#5a6bd4"
        />
        <path
          d="M376.6,74.4c2.4,1.2,2,1.9,3.4,3s2.9,1.1,3.8,2,.1,1.9,1.8,2c5.5,5.3,11.4,10.2,17,15.5.6.7.6,1,0,1l-2.3-.6c-2.7-2.9-5.6-5.6-8.7-8.4-1.1,0-1.9-.5-2.3-1.5-2.7-1.9-5-4.1-6.7-6.5-2.1-2-4.5-4-6-6.5Z"
          fill="#6074d8"
        />
        <path d="M355.7,61.9c4.1,1.4,9.9,3.5,12,7.5-4-2.3-8.6-4.4-12-7.5Z" fill="#6c71d6" />
        <path
          d="M408.6,103.4h.5l2,2,1.5,1.5c5,6.2,12.4,14.9,16.5,21.5,6.2,9.6,11.8,19.6,16.7,30l-.2,1c.5,1,.7,2.7,1,3.5h-.9c-.5-2-1.4-4-2.6-6-1.9-1.6-3.7-5-4-7.5-5.2-10.6-11.9-20.4-19-30-.7,0-1-.5-.5-1l-.5-.5c-3.7-3.3-7.8-7.5-10.1-12-1.5-.8-4-2.5-1.9-3.5.5,0,1,.4,1.5,1Z"
          fill="#6178dc"
        />
        <path
          d="M430.1,128.9c5.7,9.3,10.7,19.1,16,28.5s.4.3.5.5l-1,1.5c-4.1-9.4-11.1-22.3-16.5-31l1,.5Z"
          fill="#6987e7"
        />
        <path
          d="M405.6,99.4l1,1c0,0,0,.4,0,.5.9.7,1.6,1.5,2,2.5-.5-.4-1-.6-1.5-1-1.4.6-2.6-.5-2.5-2-1.2,1-2.8-1.3-2-2.5,0-.3,0-.7,0-1,.9.8,2.2,1.7,3,2.5Z"
          fill="#687bdd"
        />
        <path d="M412.6,106.9c-.8-.3-1-.9-1.5-1.5.4.5.9.8,1.5,1.5Z" fill="#7081e2" />
        <path d="M411.1,105.4c-.5-.6-1.3-1.3-2-2,1,.8,1.2,1.1,2,2Z" fill="#687bdd" />
        <path
          d="M409.1,103.4c-.1,0-.4,0-.5,0-.6-.9-1.3-1.6-2-2.5,1.2.5,1.7,1.7,2.5,2.5Z"
          fill="#7081e2"
        />
        <path d="M406.6,100.4l-1-1c.3.3.6.5,1,1Z" fill="#7081e2" />
        <path
          d="M449.1,325.2c-.7,2.5-1,4.2-2.5,6.5-2.3,4.7-3.6,3.6-1.5-1-.9-.9,0-2.7,1-3.5.2-2.7,1.5-6.3,3-8.5l.5-1c-.4,0-.4-.3,0-.5l.5-1c-.4-.2-.4-.3,0-.5l.5-1c-.3-1.4.3-4.1,1.5-5l.5-1,1-2c.8,5.4-2.3,9.4-3.6,14.1-.4,1.4-.5,3-.9,4.4Z"
          fill="#1b4dea"
        />
        <path
          d="M456.6,289.8c0,.3,0,.7,0,1l-.5,2c-.3,2.8-1,5.7-1.5,8.5l-.5,1c0,.3,0,.7,0,1-.4.9-1.3,2.8-1.5,3.5l-.2-.5c0,1.4-.4,2.5-1.2,3l-.6-.4c.7-3.1,1.5-6.1,2.6-9.1-.5-2.4,0-5.3,2-7l.5-2.5c-.4-.1-.4-.3,0-.5.2-.8.7-1.6.7-2.5.5,0,.2,1.9.2,2.5Z"
          fill="#6fadf1"
        />
        <path d="M449.6,324.7c.1-.1.5-.4.5-.5l-.5.5Z" fill="#8eb7f9" />
        <path
          d="M454.1,190.8c0,.4,0,1,0,1.5l.5.5c0,.3,0,.7,0,1l.5.5c.1.4-.1,1.1,0,1.5l.5.5c0,.3,0,.7,0,1l.5.5c0,.2,0,.3,0,.5l.5,1c1.3,5.7,2.2,11.7,3,17.5s0,1,0,1.5c-.1.4-.3.4-.5,0l-.8-.8c-1.4-9.6-3.5-19-6.2-28.2-1.4-.5-1.4-1,0-1.5.9.6,1.5,1.6,2,3Z"
          fill="#5b77e8"
        />
        <path
          d="M462.1,244.8c-1.2-4.5-.4-9.9-1.5-14.5-.6-.2-.4-1,0-1.5l-.5-1.5c-.2-1.3-.4-2.8,0-4,.3,2.5,1.2,5.2,1.5,7.8.5,4.4.5,9.3.5,13.7Z"
          fill="#2243c4"
        />
        <path
          d="M460.1,223.3c0,1.3-.1,2.7,0,4l.5,1.5c0,.5,0,1,0,1.5.2,3.5-.2,7.4,0,10.8,0,2.3,1.9,5.7,0,7.2l-.5-2.5c0-.3,0-.7,0-1-.1-1.4-.3-2.9-.5-4.5-.6-2.2-1.2-5.3-.5-7.5l-.5-2c-.3-.4-.3-.9,0-1.5-.5,0-.4-.2,0-.5h.7c0-.1-1-9.6-1-9.6,0-.4.4-.7.8-.9h.5c.2,1.5.3,3.4.5,5Z"
          fill="#1b2ca8"
        />
        <path
          d="M450.1,192.3c.4.2.4.3,0,.5l.5,1.5c1.3,1.9,1.9,4.2,2,7,.5,0,.4.2,0,.5l.5,1.5c1,1.9,1.5,4.2,1.5,7l.6.5c0,2.4.4,4.7.9,7,.4.2.4.3,0,.5.3.8.5,1.6.5,2.5l.6.7c.5,4.1.8,8.2.9,12.3.8.3.8.7,0,1l.5,6c.4,7.2.4,14.3,0,21.5,0,.8,0,1.7,0,2.5s0,1,0,1.5c-.4,1.5-.5,3-.5,4.5-.4,3-1,6.2-1.5,9l-.9,7.1c-1.1,1.2-1.2-3.2-.6-4.1-.6-2.4-.6-4.9-.2-7.4.8-.4,1.2-1.2,1.2-2.6-1.3-.7-.9-3.8.5-4,1-15.3,0-31.9-3-47l.5-1c-2.4-8.9-4.6-17.8-6.4-26.7-1.8-2.7-2.5-5.5-2.1-8.3.4-.9.3-2-.3-3.3l.8-.7c.3,0,.6-.1.6,0,1,2.5,2.3,6.2,3,8.8s.3,1.2.4,1.8Z"
          fill="#02011f"
        />
        <path
          d="M458.6,230.8l.5,2c.1,2.5.4,5,.5,7.5.3,1,.5,2.1,0,3-.2,3-.4,6-.5,9,0,3.4-.3,6.8-.5,10,0-7.2,0-14.3,0-21.5l-.5-6c0-.3,0-.7,0-1,0-.7-.6-4.3-.2-4.5s.5,0,.7,0c0,.5,0,1,0,1.5Z"
          fill="#365ece"
        />
        <path
          d="M459.6,244.8c0,2.5-.1,5,0,7.5h-.5c0-2.9-.4-6.3.5-9,.4.5.4,1,0,1.5Z"
          fill="#4375f3"
        />
        <path
          d="M456.6,282.8c-.3,2.3-1.2,4.6-1,7,0,.2,0,.3,0,.5l-.5,2.5c-.6,2.3-1.2,4.7-2,7-.8,3.4-1.3,4.4-1.5,3-1.2,0-1-1.2,0-1.5-.3-2-.7-6.1,1-7.5l.5-1.5c-.4-.2-.4-.3,0-.5,0-1.7.1-3.4.6-5.1,0-1.5.3-2.8.9-3.9.1-.4.3-.4.5,0,0,.9-.4,3.5.5,4-.4-2.4.6-4.7,1-7,0,1,.1,2,0,3Z"
          fill="#030430"
        />
        <path d="M456.1,292.8c0-.6-.3-1.6.5-2,0,.7.3,1.7-.5,2Z" fill="#5fa6f3" />
        <path d="M454.1,302.3c0-.9.5-.9.5-1l-.5,1Z" fill="#2353e6" />
        <path d="M458.1,270.8c.2-1.4-.5-3.5.5-4.5-.1,1.5-.3,3.1-.5,4.5Z" fill="#467ff1" />
        <path d="M460.1,244.8h-.5c0-.5,0-1,0-1.5,0-1,0-2,0-3,.9,1,.5,3.1.5,4.5Z" fill="#1e35b5" />
        <path
          d="M454.1,180.8c1.5,4.5,2.4,9.3,4,13.7-.8,1-.8.2-1.1-.4-1-2.5-1-5.7-3-7.8-.4,0-.4-.3,0-.5l-.5-1.5c-.3-.1-.3-.3,0-.5l-.5-1c-.9-1.1-1.6-3.1-1.5-4.5-.6-.7-.4-1.7.5-2,.5,1.4,1.4,2.8,2,4.5Z"
          fill="#5168da"
        />
        <path
          d="M453.6,184.3l.5,1.5c0,.2,0,.3,0,.5,0,.6,0,1.4,0,2l-.5-.5c-.8-.9-1.6-3.3-.5-4,.1-.4.3-.4.5,0,0,.1,0,.3,0,.5Z"
          fill="#6982df"
        />
        <path d="M462.1,217.3l-.5-2c0,.3.4,1.1.5,2Z" fill="#627de2" />
        <path d="M456.6,195.8l-.5-1.5c.1.4.3.9.5,1.5Z" fill="#6982df" />
        <path d="M454.6,189.3l-.5-.5c0,.1.4.3.5.5Z" fill="#6982df" />
        <path d="M457.1,197.3l-.5-.5c0,0,.4.2.5.5Z" fill="#6982df" />
        <path
          d="M451.1,178.3c.6,1.6,1.3,3.3,2,5,.3.1.2.3,0,.5,0,1.3-.2,2.8.5,4h-.5c-3-5.8-5.5-12.2-7.5-18.5.5-.8.2-2.1-.7-3.8-1.1-1.2-1.3-2.3-.8-3.2.4.1.7.3,1,.5,1.9,1.3,6.1,12.6,5.9,15.5Z"
          fill="#7287e1"
        />
        <path
          d="M442.6,163.3l.5.5c.4.2.4.3,0,.5.8,1.1,1.5,2.2,2,3.5.4.2.4.3,0,.5l.5.5c.4.2.4.3,0,.5,2.5,6.2,5.4,12.2,7.5,18.5.3,1,.8,2,1,3-.6-.8-1.6-2.1-2-3-2.4-1-3.5-6-3.7-8.4l-.8-2.6-1-.3c-1.2-3.7-2.7-7.3-4.6-10.7l.6-1c-.3,0-.5-.2-.5-.5l-4.8-9.5c-.3-.4-.2-.7.3-1,1.9-.2,5.6,7.8,5.4,8.7s-.2.5-.4.8Z"
          fill="#6982df"
        />
        <path d="M456.6,199.3c0,0-.3-.3-.5-1l.5,1Z" fill="#6982df" />
        <path d="M454.6,192.8c-.2,0-.5-.3-.5-.5.2,0,.5.3.5.5Z" fill="#6982df" />
        <path d="M455.1,194.3s-.4-.1-.5-.5l.5.5Z" fill="#6982df" />
        <path d="M455.6,196.3s-.4,0-.5-.5l.5.5Z" fill="#6982df" />
        <path d="M456.1,197.8s-.4-.1-.5-.5l.5.5Z" fill="#6982df" />
        <path
          d="M437.6,347.2c.5.3,1,.6,1.5,1-1.5,3.2-3.2,6.5-5,9.5s-4.1,6.7-6.5,9.5c-.3-1.3,0-2.8,1-4.5.1-2.8,2.7-6.2,4.5-8.5.8-2.1,2.3-4.8,3.7-6.8s.5-.2.8-.2Z"
          fill="#205ef3"
        />
        <path
          d="M445.1,330.7c-.3,1.2-.6,2.3-1,3.5.9-.5,1.9-1.6,2.5-2.5-.5,1.9-1.2,3.8-2,5.5s-2.2,4.5-3.5,6.5c-.9-.2-.5-1.9-.2-1.6s-.3.4-.8,0c-.3-.2-.5-.3-.5-.5,0-.6,4.2-10.8,4.8-11s.5,0,.7,0Z"
          fill="#255cf3"
        />
        <path
          d="M441.1,343.7c-.4,1.7-1.3,3-2,4.5-1.4,1-1.7.6-1.5-1-.4-.1-.4-.3,0-.5l.5-.5c-.7-.8.7-4.5,2-4,.5-.6.7-1.6,1.3-.5s0,1.3-.3,2Z"
          fill="#2151ee"
        />
        <path
          d="M427.6,367.2c-.4.9-1,2.2-1.5,3-1.6,2.7-4.5,6-6.5,8.5-.9-.5.8-3,1-3s-.3,1-1,.5c-.2-.4-.3-.8-.2-1.1.3-.9,7.5-11.7,8.1-12.1s.6-.3,1-.4l.4.2c-.9,1.2-1,3.2-1.4,4.3Z"
          fill="#2056eb"
        />
        <path
          d="M399.6,404.2c-2.1,2-4,4.5-6,6.5-.2.5-.5.9-1,1l-22.5,17.5-14,9c-2,.4-3,1.7-4.5,2.5-8.8,5-18,9.3-27.5,12.5-12.2,5.1-25.4,8.7-38.5,10.5-.7.5-2.2.8-3,.5-25,4.4-49.8,2.5-74.7-1.7-1.2-.2-2.3-.4-3.3-1.3-.4-.1-.4-.3,0-.5.4-.9,2.5-.2,3,.5l1.5.5c0-.4.3-.4.5,0,1,.1,1.9,0,2.9-.3,7.9,1.4,15.8,2.7,23.8,3s.8,0,.4-.8c.6-.5,1.7-.3,2.5,0,.5-.5,1.2-.5,2,0,5.1-1,10.4-1,15.5,0,3-.1,5.9-.3,9-.5.6-.8,1.4-.8,2,0l4-.5.9-.7c8.6-.5,17.1-2.1,25.5-4.2l1.1.4,3-1c.1-.3.3-.3.5,0,5.2-1.5,10.3-3,15.5-4.5,1.5-1.7,5.2-3,7.5-3l6.5-2.5c.7-1.5,3.3-2.5,5-2,.2-.4.3-.4.5,0l.5-.5c.2-.4.3-.4.5,0l1.5-1c.1-.4.3-.4.5,0l.5-.5c1-1.7,4.5-3.2,6.5-3l7-4c2.1-1,4.1-2.1,6-3.5,0-.3-.1-.6,0-.8.5-.9,4.9-3.8,6-3.2l3.6-2.2c.9-2.3,4-3.9,6.4-4.8,0-1.3,3-3.6,4-2.5.8-2.2,3.7-4.9,6-5-.8-1,1.1-1.8,2-2,0-.5.3-.4.5,0,.7-1.8,2.2-3.3,4-4-.4-1.8,3.3-4.1,5-4.5.2-.4.3-.4.5,0,.4,0,.8,0,1,.5Z"
          fill="#f6fafb"
        />
        <path
          d="M419.6,378.7c-1,1.9-2.1,3-3.5,4.5l-5.5,7c-.4.7-3.3,4.2-3.6,4.2-1.7,0-.6-2.1.6-2.7,1-1.7,2.5-3.6,4-5-.8-.8,0-1.9,1-1.5l.5-.5c.8-2.5,3.3-6.4,5.4-8.2s.6-.3,1.1-.3c.3-.3.5-.6.5-1,.2-.1,1,.6,1,.7,0,.2-1.2,2.2-1.5,2.7Z"
          fill="#1f4def"
        />
        <path
          d="M403.1,396.7c.2-1,2.5-2.5,3-1.3l-2,2.8c-1.1,1.6-2.5,2.7-4,4-1.7,1.1-1.8.9-1.8-.9s3.7-5.1,4.8-4.6Z"
          fill="#0e56eb"
        />
        <path
          d="M403.1,396.7c-.8.5-3.2,2.7-3.6,3.6s-1,2.2.6,1.9c-.5.5-1.1.9-1.5,1.5-.2,0-.4,0-.5,0-1.6,1.6-3.9,0-2-1.5,1.8-2.5,3.9-4.8,6.3-6.8l.7.3c1,0,.7.4,0,1Z"
          fill="#186bf5"
        />
        <path
          d="M404.1,398.2c.5-.8.9-1.8,1.5-2.5-.2-.1-2.2.8-2.5,1v-1c-.5-1,0-1.1,1-1l-.3-.7c.9-.5,1.8-1.1,2.8-1.8-.2-.4,0-.6.5-.5.2-.3.3-.3.5,0-.5.8-1.4,1.2-.2,2,.8-1.6,2.2-2.4,3.2-3.5-.1.2-.1.8-.5,1.3-1.4,2.1-4.3,4.7-6,6.7Z"
          fill="#1c5ee6"
        />
        <path d="M410.6,390.2c2.3-3.2,2.8-4,5.5-7-1.3,2.7-3.5,4.9-5.5,7Z" fill="#215af3" />
        <path
          d="M394.1,410.7c-1.4,1.3-2.7,3.5-4.5,4.5,1-.9,2-2.5,3-3.5s.7-.7,1-1h.5Z"
          fill="#5165c6"
        />
        <path
          d="M446.6,162.8c1.9,4.5,3.8,8.9,5.5,13.5.4.7-.5,1.9-.5,2-.1.4-.3.4-.5,0-1.9-5.3-4.2-11.1-7-16-1.5-.1-2-1.4-1-2.5l.5-.4c-.7-1-.9-1.9-.5-2.6,2.1,1.3,1.7,4.4,3.5,6Z"
          fill="#5562d1"
        />
        <path
          d="M31.4,166.8c-.5,2.4-.6,4.7-.2,7-2.7,6-3.2,12.1-3.2,18.7l-.6,3.5c.3-.6.9-.5,1.5-.2-.9,3.3-1.8,6.6-2.5,10l-.5,2c0,.3,0,.7,0,1l-.5,1c0,.2,0,.3,0,.5-2.9,1.1-.6-2.4-.7-2.7-.3-3,.4-2.8.5-5.1s-.8-5-.8-7.2c.3-.5.9-1.1.9-1.2,0-.3-.5-.9-.4-1.3-.6-.5-.6-1,0-1.5,0-.6.8-.5,0-2.5l.5-1c0-.2,0-3.6.1-4.2.2-4.8,2.2-6.9,3.4-11,.2-.7-.1-1.6.1-2.4s2.2-2.2,2.4-3.3Z"
          fill="#598ef5"
        />
        <path
          d="M33.3,163.8l.5,1.5c-1.7,2.8-2.2,5.3-1.5,7.5l.6,1.3-2.1,6.6c-1.4,4.4-1.3,6.1.5,5.1.3.6,0,1.3-.5,2-1.1,2.1-1.3,5.6-2,8-1,.6-1.6,4.5-2.2,4.5-1.7,0,.2-5.8.2-6.3.5-4,.2-9.4,1.1-13.4s2.4-4.2,1.5-6.8l1,.5c-.3-2.7.3-5,1-7.5s0-.3,0-.5l1-1.5c0-.4-.1-1.1,0-1.5.3-.5.7-.7,1-.5,1,0,1,.7,0,1Z"
          fill="#5f94f8"
        />
        <path d="M25.4,187.8c.9.7.6,1.2-.5,1-.5-1.2.4-.6.5-1Z" fill="#5588f3" />
        <path d="M24.9,192.8c-1.2-.5-1.2-1,0-1.5,0,.5,0,1,0,1.5Z" fill="#5588f3" />
        <path d="M26.9,200.8l-.5,1.5h-.5c0-1.2-.3-1.7,1-1.5Z" fill="#5f94f8" />
        <path d="M25.9,207.8c.2-.9.4-1.4.5-2l-.5,2Z" fill="#5588f3" />
        <path d="M25.3,206.8c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#5f94f8" />
        <path d="M25.4,209.8c.1-.8.5-.9.5-1l-.5,1Z" fill="#5588f3" />
        <path d="M25.6,203.8c.3.2.3.3,0,.5v-.5Z" fill="#5f94f8" />
        <path d="M34.3,161.3l.5-1c-.2.5-.5.9-.5,1Z" fill="#659dfb" />
        <path
          d="M34.3,161.8c0,1.7,1.4,2.7,1.5,2.9.3,1.1-.1,2.5,0,3.6,1.6.3,2.1-1,3-2,2.2,1-.6,4.4-1.7,5.8-1.4,2.2-2.5,4.6-3.2,7.2.9,1.5-.9,5.8-2.5,6.5l-1.5,3c-.6,0-.9-2.5-.8-2.9,0-4,2.1-9,3.4-13.1-1.2-2,.2-4.8,1.4-6.7-.2-.8-.3-1.5-.4-2.3,0-.3,0-.7,0-1,.4-.3.6-.7,1-1Z"
          fill="#659dfb"
        />
        <path
          d="M33.3,163.8c3.1,2.4.1,3.9-.4,5.4s-.2,2.4-.6,3.6c-1.6.5-1.1-3.1-1-3.7.3-1.7,1.6-3.5,2-5.3Z"
          fill="#6498f7"
        />
        <path
          d="M65.8,112.9c1.9-1.8,5.4-1.5,5,1.7.4.4.9.5,1.5.3,1,1.2-.9,4.6-2.5,3.5,0,.4-1.3.8-1.5.7.6-6.2-3.6-3.3-6.4-.6h-.6c.9-2.4,2.8-4,4.5-5.6Z"
          fill="#8acefe"
        />
        <path
          d="M61.3,118.4c.9-.8,3.9-3.9,4.7-4,3-.2,3.7,1.5,2.8,4.2l1-.2c.4,0,.4.3,0,.5-.3.5-.6.6-1,.5-.4.2-.6.5-1,.5-.6-.9,1.6-3.9-2.8-3.3s-.9,1.4-1.4,1.7c-1.1.7-2.1.6-3.9,2.1,0-1.2.9-1.4,1.5-2Z"
          fill="#80c4fe"
        />
        <path
          d="M77.3,109.4c-1,2-2.3,3.3-4,4,0,.6-2,2.1-2.3,2,.2-3-1.4-4.1-4.7-3.5,0,0-.2-.6.3-1,2.9-2.3,8.7-1.5,12.2-4.5.2-.4.3-.4.5,0,.5.9-1.1,2.6-2,3Z"
          fill="#a3e3fd"
        />
        <path
          d="M109.3,77.4c-1.8,3.7-5.2,6.9-9,8.5-3.8,3.7-7.6,7.4-11.5,11-1.9,2.5-4,5.1-6.5,7-.5,1-1.5,2.4-2.5,2l-.5.5c-.1,0-.4,0-.5,0-1.4-2.6-1.5-.6-3.1.1s-4.5,1.3-5.8,1.9c.5-1.2,1.8-.9,2.8-1.5,2.6-1.7,9.8-8.6,11.2-11,.7-.4,3-1.5,3.3-2s-.5-1.8-.3-2,1.3,0,2-.3c1.7-.7,3.1-3.3,5.5-3.5s1.2,1,1.5.8,1.6-2.8,1.8-3c.6-.6,1.8-.6,2.8-1.2,1.5-1,1.7-2.7,2.7-3.8,2.1-2.3,3.9-2.3,6.3-3.5Z"
          fill="#b2edfd"
        />
        <path
          d="M55.8,126.9c2.5-3,1.4-1.6,4.3-3.5s2-2.5,2.7-2.8c1.3-.6,2.1,2.5,3.7,2.2s1.3-2.1,2.3-2.4c3.8,0-.4,5.5-2,7l.2,1.7c-1.9,3.2-4,6.3-6.1,9.3l-1.6.5c-1.8,3.2-3.7,6.4-5.8,9.4,0,1.8-.6,2.9-1.7,3.1l-.5.5c1,.3,1,.7,0,1l-.5.5c.4.1.4.3,0,.5,1.4.7-.1,2.9-1.3,3s-1.8-2.2-.7-3c0-.3,0-.7,0-1l.5-1c0-.2,0-.4,0-.5l.5-.5c.2-.5.3-1.1.5-1.5l1-1.5c0-.2,0-.3,0-.5.2-1.1,1.8-1.9,2-2.3.5-.9,3.8-6.6,3.9-7,.3-1.2,0-2.7.7-4.2s3.1-2.7,2.1-5.4-2.6-2-4.3-1.5Z"
          fill="#74aefe"
        />
        <path
          d="M53.8,152.3l.4,1.3c-2.4,3.3-4.3,6.8-5.9,10.5l1.1.2c.2,1.3-.7,2.9-1.5,4,.4.2.4.3,0,.5-1.2,1.6-2.2,3.4-2.5,5.5.2,3-1.3,6.9-3.5,9-2.7,5.5-4.2.8-3-3-.4-.1-.4-.3,0-.5,1.9-6.3,4.1-12.6,6.5-19-.4-1.1-.4-4.2,1-4,.5-1.1,1.4-2.4,2.5-3,0,.5,0,2,.7,2,1.5,0,1.1-1.5,1.3-2l.9-.6c.2-1.3.9-1.6,2.1-.9Z"
          fill="#75a9fe"
        />
        <path
          d="M38.8,166.3c2.2-5.1,3.2-6.6,6.2-11s1.9-4.2,3.3-6c.7,0,1.2-.2.9.7-.7,2.5-2.6,4.3-2.9,6.8-.3.8-.7,2.9-1,4l-3,8.8-1,.7-.8-1.1c3.5-9.3,3.4-10.2-.4-2.9h-1.3Z"
          fill="#679bfd"
        />
        <path d="M48.8,152.8l.5-1c-.2.7-.5.9-.5,1Z" fill="#75a9fe" />
        <path d="M50.3,149.3l1-1.5c-.3,1.4-1,1.4-1,1.5Z" fill="#73a8fd" />
        <path d="M49.3,151.3l.5-.5c0,.2-.5.4-.5.5Z" fill="#75a9fe" />
        <path
          d="M76.3,111.4c.4.2.4.3,0,.5-1.8,3.1-2.1,3.9-.7,2.2l1.2.3c.5.7-.1,1.9-2,3.5.1.2.2.4.1.6-.8,1.2-6.2,9.1-6.7,9.4s-1-.1-1.4-.4c.7-1.2,3.5-4.8,2.9-5.9s-.7.3-.9-1.1,0-.3,0-.5l1-1c0-.2,0-.3,0-.5,1.2-.9,1.7-2.4,2.5-3.5.3-.5.6-1,1-1.5,1.5-1.2,2.7-2.6,4-4,.1.6-.2,1.3-1,2Z"
          fill="#6da5fc"
        />
        <path d="M68.8,119.9v-.5c.3-.1.7-.3,1-.5-.1.6-.5.8-1,1Z" fill="#74aefe" />
        <path
          d="M58.8,349.2c5.5,9.2,11.2,18.2,17,27,5.1,6.3,10.1,12.6,15,19,.4.1.4.3,0,.5-4.9-4.1-10.1-10.4-14-15.5s-4.5-6.3-6.5-9.5c-4.5-7.2-8.7-14.6-12.5-22,.3-.9.8-.3,1,.5Z"
          fill="#5768c8"
        />
        <path
          d="M33.8,297.8c1.1-.4,2.2-.4,3.3,0s2.8,8,3.2,9.5l.8.5c2.6,7.7,5.6,15.2,9.1,22.6l-.4.9c-.1.7-.4.5-1-.5l-1.1-.3c-.7-1-4.4-8-4.4-8.5s.3-.9.5-1.2c-3-3.5-4.7-7.3-5.2-11.5l-1.4-1.1c-2.1,1.3-3.1-1.8-2.4-3.3-.6-2.2-.8-4.6-1.5-7h.5Z"
          fill="#4c58d1"
        />
        <path
          d="M35.3,292.3c.5-.2.9,0,1.3.1s3.4,8.2,3.2,9.4c.6,1.6,1.3,4.2.5,5.5-1.3-2.1-1.8-5.1-2.9-7.3s-1.4-1-1.1-2.2l-1,1.5-1.5-1.5c.7-.9-.1-2-.5-3,0-2.7.7-3.5,2-2.5Z"
          fill="#505ed8"
        />
        <path
          d="M40.8,303.3c.5-.5.7-.2.5.5l-.5.5,1.1.3c.5,2.6,1.1,5.3,2.4,7.7.3.2.3.3,0,.5,1,3.1,2.2,6.3,3.5,9.5.3.3.4.8,0,1l.5.5c.5.9,3.5,7.2,3.3,7.6s-.2.3-.3.4c-.2,1.3-.6,1.3-1,0-.1.4-.3.4-.5,0,0-.1,0-.4,0-.5-2.8-7.2-8-16.2-9.5-24-.3-1.6-.4-3.8-.5-5.5.2.5.8,1,1,1.5Z"
          fill="#5666d8"
        />
        <path d="M34.6,299.8c.3.2.3.3,0,.5v-.5Z" fill="#505ed8" />
        <path
          d="M52.3,335.2l.7.3c1.5,4.4,3.6,8.5,5.8,12.7.3.3.5.8,0,1l-1-.5c-2.1-4.1-4.7-8.2-6.5-12.5-.2-.6-.2-1.1,0-1.5.1-.8.5-.6,1,.5Z"
          fill="#586ad2"
        />
        <path
          d="M51.3,334.2c.4.1.4.3,0,.5v1.5c-.7-1.7-1-3.1-1.5-4.5h.5c.5.6.8,1.4,1,2.5Z"
          fill="#4c58d1"
        />
        <path
          d="M33.8,179.3c.3-1.8,4.4-11.6,6.6-8.6-2.9,8.3-5.2,16.8-7.1,25.6,1.3,1,1,3.4-.5,4l-.5.5c-1,4.7-1.6,9.6-2,14.5.7.8.3,1.1-.5.5,0,1.9-.3,3.8-.6,5.8.9.8.9,3.1-.4,3.6,1,1.1.5,2.2-1,2.2.1-1.9,0-5.4.2-7.5,1.1-9.8,4.1-20.2,5-30.1s.7-.8.8-1.2-.8-2.1-.9-2.1c-.5-.5-1.9,1.3-2,1.5.2-.7.3-1.3.5-2,.6-2.6,1.4-4.1,2.5-6.5Z"
          fill="#578afa"
        />
        <path
          d="M29.9,215.8c2.1-.1,2,2.5.6,3.7,1,2,1.5,4,1.5,5.9-1.8,2.7-3.3,6.2-.3,8.6.2.3-.4,7.2-.7,7.5s-.4.3-.6.4c1.2-2.7,2.2,2.5.5,1.5-1.6.2-2-.7-.5-1.5-.2,1.9-2.4,1.6-2.5-.5,0-3.5-.4-7.2-.5-10.5s0-.3,0-.5c.4-.6.4-1.4,0-2,0-.2,0-.3,0-.5l.5-.5c1.4-1.9.9-8.2,2-11.5Z"
          fill="#608dfc"
        />
        <path d="M27.4,230.3c0-.7,0-1.3,0-2,.7.2.8,1.8,0,2Z" fill="#5b83f8" />
        <path d="M27.4,227.8c0-.1.5-.4.5-.5-.1.2-.3.3-.5.5Z" fill="#5b83f8" />
        <path
          d="M30.4,241.8c0,.6,0,1.1.5,1.5.3.2.5.3.6.6.7,2.5,3.1,16,2.9,18.1s-.2.2-.5.3c.9.6.5,1.3-.5,1-.9-.6-.7-1.8-1-2.5,0-3.5-.5-5.3-1.9-8.4s0-1.5-.1-1.6c-.1-.2-1.1.5-1.5.3-1.5-.8-.9-7.8-1-9.8.9,1.1,1.5.5,2.5.5Z"
          fill="#6087fa"
        />
        <path
          d="M36.3,271.3c.5,0,.4.2,0,.5-.3,1.3-.1,1.8.5,1.5.9.2.8,1.6,0,2,0,1.4.1,2.7.5,4,.4.6.8,1.5,1,2.5.4.1.4.3,0,.5.4,1.1.5,2.3.5,3.5,1,2.6,1.6,6.1,1.5,9-1.9-5.4-3.2-10.5-4.5-16s-.5-4.3-1-7c-.2-1.4.7-1.7,1.5-.5Z"
          fill="#6e81ed"
        />
        <path
          d="M38.3,273.3c.2.8.3,1.6.5,2.5.3.1.3.3,0,.5.3.1.3.3,0,.5.3.1.3.3,0,.5.2.6.3,1.3.5,2,.4.7.5,1.6.5,2.5l.7.3c.2,2.1.5,4.1.8,6.2,1.5,0,1.4,2.2,0,2.5-.6-.9-.7-.3-.3,1.9,1,2.2,1.2,4.2.8,6.1-.9-1.1-1-2.6-1.5-4-.3-3-1.1-6-1.5-9,0-1.2-.1-2.4-.5-3.5,0-.2,0-.3,0-.5-.6-2.1-1.6-7-.8-8.9s.4-.1.8-.1c.3.2.3.3,0,.5Z"
          fill="#a6bbfa"
        />
        <path
          d="M40.3,300.8c2.1-.5.3,3.9,2.5,3.5.3.2.3.3,0,.5.8,2.4,1.5,4.9,1.5,7.5-2-1.6-2.9-5.5-3.5-8l.5-.5c0-.4-.5-.4-.5-.5.2-1-.3-1.7-.5-2.5Z"
          fill="#6373dd"
        />
        <path
          d="M41.3,290.8c.4.2.4.3,0,.5l.5,2c2.1,3.6,2.7,8,3,12-.4-.1-.8.4-1,1.5-.5-.3-.8-1-1-2,0-.2,0-.3,0-.5-.3-1.8-.7-3.6-1-5.5-.6-3.7-1.6-7.5-2-11.3s-.2-1.8.5-1c-.2,1.5.7,3,1,4.2Z"
          fill="#bcdafb"
        />
        <path
          d="M34.8,262.3c1.5.7,1.2,2.9,1.1,4.3.6.9.7,1.3.2,1.4l.2,1.3c.8.3.7,1.7,0,2l-1.5.5c-.6-3.1-1.8-4.9-1.5-8.5s.4-.6.5-1c.2-1.3.6-1.3,1,0Z"
          fill="#6d86f1"
        />
        <path
          d="M351.7,440.7v.5c-7.7,3.8-15.3,8.2-23.5,11l-1,.5c-.1,0-.3,0-.5,0l-1,.5c-.3,0-.7,0-1,0h-.5c5.1-2.4,10.5-4.3,15.6-6.6,4-1.8,8-3.9,11.9-5.9Z"
          fill="#6874cd"
        />
        <path d="M328.2,452.2l-1,.5c0,0,.5-.3,1-.5Z" fill="#5576d1" />
        <path
          d="M335.2,457.2c3,0,1.9,1.7,0,3-3.1,2.1-7.3,2.4-10.5,4.5-9.8,2.1-19.4,6.7-29.5,7.5l-5.5.8c-2.2.6-4.7-1.3-2-2.3.2-.4.3-.4.5,0l2-.5c.3-.9.7-.9,1,0l2-.5c.2-.4.3-.4.5,0l2-.5c.2-.6.7-1,1.3-1.1,5.3-1.4,10.6-2.8,15.9-4.1s1.2-.1,1.7.3c6.7-2.2,13.9-4.4,20.5-7Z"
          fill="#1b57c8"
        />
        <path
          d="M176.3,464.7c.2-.4.3-.4.5,0l1,.5c0-.4.3-.4.5,0l1,.5c.1-.4.3-.4.5,0l6.5,2c3.9-.6,7.8.3,11,2.5,1.8.4,3.7.9,5.5,1.5,0-.4.3-.4.5,0,12.1,1.4,24,3,36,5,1.9,1.3,14.9,0,15.5.5,1.4,1.3-2.2,2.3-2.6,2.5s-.3.9-.7,1c-1.6.4-3-.5-4.4-.5s-1.8.5-2.7.5c.3-1.5-.8-1-1.7-1-2.6-.1-6.8-.7-9.5-1.3s-3.6-1.6-4.6-1.7c-2.4-.4-3.2,2-3.4,2-1-.1-4.8-2.3-5.5-2.3s-3.2.2-3.4.3c-.4,0,0,1.1-1,1s-2.5-1-3.8-1.3c-3.4-.7-6.1-.6-9.4-2.1s-3.7-1.1-7.5-2c-5.5-1.3-10.1-4.2-15.1-5.8s-2.7.3-3.5-1.2l.4-.6Z"
          fill="#66bbfc"
        />
        <path
          d="M174.8,463.7l1.1-.9c3.2.3,6.2.6,8.9.9.8-.5,1.6-.3,2.4-.1,6.5,1.7,12.9,3.4,19.5,4.9s1.5.5,2.1,1.2c1.3.2,5.6,1.9,3,2.8l-8.5-.8c-.2,0-.3,0-.5,0-1.9-.7-3.7-1.2-5.5-1.5-3.7-.8-7.3-1.6-11-2.5l-6.5-2c-.2,0-.3,0-.5,0l-1-.5c-.1,0-.3,0-.5,0l-1-.5c-.2,0-.4,0-.5,0-.4-.2-1.1-.7-1.5-1Z"
          fill="#1c5acf"
        />
        <path
          d="M287.7,470.7c-1.2.9,1,1.8,1.4,1.9.8.1,4.9-.3,6.1-.4-5,1.2-10.2,2.3-15.3,2.9-10.1,1.3-20.5,2-30.7,1.6-2.2,0-3.9-.3-5.2-1,0,.3,0,.5-.2.5-2,.5-7,0-8.8-.5-1.5.5-11.5-.3-10.4-3.1,3.3,0,6.7.1,10.2.6,1.4-1,3.9-.7,5.5,0,7.2.2,14.4,0,21.5-.4l1,.4c7.9-1.2,15.9-2.2,24-2.9l1,.4Z"
          fill="#1c5ece"
        />
        <path
          d="M216.2,470.7c5.8.2,12.6.5,18.2,1.8s.2.3.2.7c-2.8,0-5.1,0-7.9-.4s-1.7-.6-1.6.4c.8-.2.9.9,1.4,1,1.5.4,7,1.5,8.4,1.5h9c1,0,4.2,1,5.2,1-3.3,0-6.7.1-10,0-12-.5-24.3-2.4-36-5,2.9,0,5.9-.5,9,0l-3.5-2c1.8-1,5.7,0,7.5,1Z"
          fill="#1c63d7"
        />
        <path
          d="M168.8,456.7l.7-.9c7.2,2,14.2,4.5,21,7.3l.3.6c4.8.7,9.5,1.5,14.3,2.6l2.2,1.4,2.5.5c0-.4.3-.4.5,0,2.5.3,5,.6,7.6.8l.4.7c0-1.8,2.6-1.1,1.5.5-1.2,0-2.4.2-3.5.5-2.5,0-5-.6-7.5-1-7.8-1.4-16.4-3.8-24-6-4.5-.1-10-1.6-13.5-4.5-1.3-.7-2.7-1.5-4-2,.3-.6.9-.5,1.5-.5Z"
          fill="#4f99e4"
        />
        <path
          d="M165.8,452.2c1-1,2.4-.7,4,.9,2.6,0,16.4,4.6,17.3,6s.1.4.1.6c1,.6,2.1,1.2,3.4,1.7,3.1-.9,4-.3,4.2,3.1l-4.1-.8c-6.4-1.2-17.2-6.8-22-7-1.3-.7-3.2-1.9-4.5-2.5-.1-.4-.6-.8-1.4-1.3.2-1.4,1-1.9,1.5-.6h1.4Z"
          fill="#2762c5"
        />
        <path
          d="M152.8,445.2h.8c4,1.9,8,3.8,12.1,5.6v1.4c0,0-2.4.5-2.4.5l1.4.9-.4.6c-4.4-1.9-8.7-4.1-13-6,.9,0,1.9.1,2.5-.7l-1-2.3Z"
          fill="#2b63c1"
        />
        <path
          d="M157.3,446.2c2.3.2,5.2,1.5,7,3l2,1c.1-.4.3-.4.5,0,3.2.8,6.2,2,9,3.5,4.1.7,7.7,2,11,4,1.5.6,2.9,1.2,4,2,.3,2.4-2.4,1.3-3.5,0-1.3,0-.8-.7-1.4-1-2-.7-14.5-5.3-15.3-5s-.1,1.2-.6,1c-1.2-1.4-2.5-2-4.2-2.5s-1,0-1.5,0l1-1c-1.9-.6-4.1-1.5-5.9-2.4s-4.3-2.6-6.6-3.6-1.1-.7-2-.5v-.5s1-.5,1-.5c1.9-.6,4.1,1.2,5.5,2.5Z"
          fill="#3067c8"
        />
        <path
          d="M143.3,437.7l4,2.5c2.3-.8,7.7,2,9.6,3.7s0,.9-.1,1.3c.7.3.8.6.5,1-1.8-.8-3.7-1.6-5.5-2.5-4-2-8.1-4.1-11.5-7,.9-.1,1.9.2,3,1Z"
          fill="#4d6fc9"
        />
        <path
          d="M143.3,437.7c-.9-.4-2.1-.6-3-1-2.7-1.2-4.1-2.4-6.5-4s-4.4-3.5-6.5-5c-.2-.2-.2-.3,0-.5,5.7,2,12.1,5.9,16,10.5Z"
          fill="#586fc3"
        />
        <path
          d="M107.8,406.2c1.1.6,1.8,1.2,2,2,.4.2.4.3,0,.5,0,.8,0,1.4-1,1.5-.1.3-.3.3-.5,0-.7-.1-1.2-.5-1.5-1-.5-.3-.9-.7-1.5-1l1.3-1c-1.4-.5-1.4-1-1.2-2.5.8.5,1.6,1.1,2.5,1.5Z"
          fill="#0517c5"
        />
        <path
          d="M108.3,410.2h-1c0-.1-.3-.3-.5-.5-.3-.1-.3-.3,0-.5.5.3,1.2.4,1.5,1Z"
          fill="#577ccf"
        />
        <path d="M106.8,409.7l-.5-.2c.1-.2.3-.3.5-.2s0,.4,0,.5Z" fill="#4857b0" />
        <path
          d="M119.3,418.7c1.3-1,2.1.1,1.5,1.5l-1,.5c-.3.2-.8,0-1.5-.5-1.3-1.3-2.7-2.7-4-4-.7-.7-.4-1,.5-.5,1.4-.2,3.6,1.8,4.5,3Z"
          fill="#d5e7f1"
        />
        <path
          d="M114.8,415.7l-.5.5c-.9-.8-2.1-1.6-3-2.5l.5-.5c1.2-.8,3.3,1.4,3,2.5Z"
          fill="#bad6e4"
        />
        <path
          d="M111.3,412.7c.3.4,0,.6-.5.5-1-.9-1.6-1.3-2.5-2.5.1-.3.3-.3.5,0,1-1.2,3.1.7,2.5,2Z"
          fill="#92bfd7"
        />
        <path d="M111.8,413.2l-.5.5c-.2-.2-.3-.3-.5-.5l.5-.5c.5-.1.6,0,.5.5Z" fill="#c3eef2" />
        <path d="M108.8,410.2c.4.1.4.3,0,.5h-.5c-.1-.2-.4-.3-.5-.5h1Z" fill="#6ea7d8" />
        <path
          d="M119.8,420.7c.2-.1.4-.2.6-.2,1.3.4,7.2,5,6.9,6.7v.5c-4.1-3-5.3-4-9-7.5.4.2,1,.2,1.5.5Z"
          fill="#5868c2"
        />
        <path
          d="M91.8,395.2c.3-.9,1-.4,1,.5,1.2.3,2.2,1.3,3,3,.4.1.4.3,0,.5-2.2-1-3.2-2-5-3.5v-.5c.1-.5.4-.5,1,0Z"
          fill="#646ed1"
        />
        <path
          d="M96.3,398.2l.5.5c0,.1,0,.4,0,.5l-.2.5c-.3-.1-.5-.4-.8-.5v-.5c-.5-.5-.8-.9,0-1,.1-.4.3-.4.5,0,0,.2,0,.4,0,.5Z"
          fill="#a9c2ee"
        />
        <path
          d="M99.8,394.2h1.4c1.4,1.5,2.4,3.2,3.1,5,1.4-.3,4.2,2,4,3.5,1.3-.9,2.3.8,1.5,2,.3.6,0,.9-.5.5-1.1-.6-2.1-1.4-3-2.5-.5-.5-1-1-1.5-1.5-1.3.1-3-1.8-3.5-3-.8,0-1.7-.7-1.5-1.5-1.3-.3-2.1-1.3-2.5-3-.5,0-.4-.3,0-.5-.8-.7-.5-1.1.5-.5,1.1-.9,2,.3,2,1.5Z"
          fill="#02052d"
        />
        <path
          d="M95.3,393.7c1.2,0,1.7,0,1.5,1.5.4.2.4.3,0,.5-.6.9-.5,1-.5,2h-.5c-.8.1-2-1.3-1.5-2-2.3-1.9-1.8-4.7,1-2Z"
          fill="#3069f3"
        />
        <path
          d="M104.8,401.2l-.2,1c-1.6-.8-2.6-2.5-3.8-3.5-.7-.7-.4-1,.5-.5,1,1,2.5,2,3.5,3Z"
          fill="#204ae1"
        />
        <path
          d="M99.8,396.7c.7,1.1.2,1.1-1.5,0-.4-.4-1-.6-1.5-1,0-.1,0-.4,0-.5-.2-.8,0-1.3.5-1.5.9.9,1.7,2.1,2.5,3Z"
          fill="#3a6ff2"
        />
        <path
          d="M99.8,396.7c.5.5,1,1,1.5,1.5l-.5.5c-.8-.7-1.6-1.3-2.5-2l1.3.4.2-.4Z"
          fill="#3364eb"
        />
        <path
          d="M109.3,405.2c.8-.3,2.6,1.8,2,2.5-.6.8-1,.5-1-.5,1.2.9.9,1.4-.5,1-1-.4-1.4-1.3-2-2,.7.4,1.8.6,2.5,1-.2-1.1-3.5-3.2-4-4.5.9.8,2.2,1.7,3,2.5Z"
          fill="#112cd8"
        />
        <path d="M96.8,398.7c-.2,0-.4-.3-.5-.5.2.1.4.3.5.5Z" fill="#455abf" />
        <path
          d="M113.8,74.9c0,0,1,.7-1,1v.5s3.5,0,3.5,0c-3.8,2.8-7.4,6-11,9-1.2,1.7-2.7,3.1-4.5,4.1-1,2.5-3.4,4.1-6,4.9l-9.3,9.2c-1.1.7-2.2,1.4-1.7-.2-.4-.5.4-1.2,1-1l3-3.5c-.1-.5,0-.6.5-.5l.5-.5c-.4-.2-.4-.3,0-.5,3.7-4,7.5-7.8,11.5-11.5,2.9-2.9,5.9-5.7,9-8.5,1.7-.8,2.9-1.8,4.5-2.5Z"
          fill="#568cf9"
        />
        <path
          d="M139.3,65.9c-.1.6-.6,1.1-1.5,1.5l-.2.8c-8.6,4.8-16.4,10.5-23.3,17.2.1.5,0,.6-.5.5-.7.6-1.4.9-2,1-1.3,1.5-2.5,2.2-3.5,2,.2-.8.8-1.7,2-2.5,5.5-4.2,9.3-8.1,14.5-12.5,2,0,2.8-1.4,4.1-2.2,3.9-2.3,6.3-4.1,10.4-5.8Z"
          fill="#656ed8"
        />
        <path
          d="M168.3,51.9v.8s-7,2.7-7,2.7c-.5,2.1-4,3.8-6,3.5l-4,2.2c-.2.8-.8.7-1.5.3,0,.4,0,.7-.1.8-1.4.9-4.6,2.5-6.2,3.3s-.4,0-.6,0l-4.5,2.4-.5-.4c.5-.4.9-1.2,1.5-1.5,3.5-1.5,5.4-2.9,8.5-5,7-2.4,13-7.8,20.5-9Z"
          fill="#5c64cf"
        />
        <path d="M153.8,56.4c.2,1.1-1.9,1.8-3,2.5.6-1.1,1.9-1.9,3-2.5Z" fill="#6f76dc" />
        <path d="M156.3,55.4c-.2,0-.7.3-1,.5l1-.5Z" fill="#6f76dc" />
        <path d="M157.8,54.9l1.5-1c-.6.4-.4.5-1.5,1Z" fill="#6f76dc" />
        <path d="M154.3,56.4l.5-.5c0,0-.2.4-.5.5Z" fill="#6f76dc" />
        <path d="M159.8,53.9c.1-.2.3-.4.5-.5-.1.2-.3.4-.5.5Z" fill="#6f76dc" />
        <path
          d="M108.3,88.9v.8c-1.5,1.2-2.6,2.7-3.2,4.6-4.6,5.8-9.7,11.2-15.3,16.1-1-1,.4-2.1,1.5-2.5-.4-.2-.4-.3,0-.5l.5-.5c-.7-.7.8-1.4,1.5-1l2-3c-.4-.2-.4-.3,0-.5l.5-.5c-.2-.1-.4-.2-.6-.4-.9-1.1,8-9.7,9.6-11.1,1.7-1.3,3.8-2.7,5.5-4l-2,2.5Z"
          fill="#6b77d7"
        />
        <path
          d="M105.3,85.4c-.8.7-.6,2.1-1.4,2.8s-4.5,1-2.1,2.2c-.5.5-1,1.5-1.5,2,0,.4,0,.8-.1,1-2.5,2.8-6.2,6.6-9,9l-1.8.4c-1.8,1.1-4,3.1-6.5,6h-1v-.5c.8-1.8,2.2-3.3,4-4.5l-.2-.4,9.2-9.1c3.5-3.1,6.9-6.1,10.5-9Z"
          fill="#73a6fb"
        />
        <path
          d="M100.3,92.4c-.2,2,.6,0,2,0l-9.7,11.4c-.7.9-1.6,1.5-2.7,1.6-2.7,3.9-5.9,7.5-9.5,10.5.1-1.6-.2-2.1-1-1.5,0-.4,0-.8.1-1.2.3-.7.6-1.2,1-1.8,2.1-2.9,6.1-6.3,8.8-8.5,3.3-3.4,7.5-7.1,11-10.5Z"
          fill="#86aef9"
        />
        <path
          d="M104.8,90.4c-2.2,2.4-8.4,8.9-9,11.5l-.5.5c0,.1,0,.4,0,.5-.5.9-1,1.5-1.5,2l-2.3,1.5c-.6,1.4-3.1,2.5-4.2,3,.6-1.2,1.4-2.6,2.5-4,4-4.4,7.9-9.1,12.5-13s1.7-1.3,2.5-2Z"
          fill="#7382e3"
        />
        <path
          d="M291.7,38.9c1.2,1.2,3.7,1.2,5.5,1.5.9.4,1.1.7.5,1l-1.6.2c-5.3-1.2-10.6-2.3-15.9-3.2l-1.7.5c-4.2-.7-8.5-1.2-12.8-1.5l-10-.5c-.4.3-.8.5-1.3.5-6.7.2-13.7.4-20.4.5-.4,0-.9-.2-1.3-.5-1.1,0-2.1.1-3,.5-.2.2-.3.2-.5,0-1,1.1-4.6,1.2-5.5,0-6,.6-12,1.4-18,2.5.6-.8,1.6-1.4,3-2,28.3-5.2,54.6-2.8,82.9.5Z"
          fill="#5f60c9"
        />
        <path
          d="M335.2,52.4c4,2.4,12.9,7.2,17,9v.5l-1,.4c-7-3.6-14.1-6.8-21.4-9.7v-.6c-.1,0-5.3-2-5.3-2-2.5,0-4.4-.6-5.8-1.9-1.5.1-4.3-.3-4.5-2-5.2-1.5-10.5-2.8-15.8-3.8l-.7-.7-.5-1c8.4,1.5,17.4,4.3,25.5,7.3s8.1,4,12.5,4.7Z"
          fill="#655ec8"
        />
        <path
          d="M223.7,37.9l-1,1.1c-6.2.4-12.2,1.3-18,2.9l-.4.7-4.1.3c0,.2-.2.5-.3.7-.3.4-8,1.8-9.2,1.8-5.4,2.7-11.1,4.5-17,5.5-.4,1.3-3.3,2.8-4.5,2l-1,.5c-.2.4-.3.4-.5,0-1.7,1.4-4.3,3.1-6.5,2,2.6-1.5,4.6-2,7-3.5,5.8-3.6,10.3-5,17-6.5,2-.4,4-.9,6-1.5.2,0,.3,0,.5,0,.9-.1,1.8-.5,2.5-1,.3,0,.7,0,1,0,3.6-1.1,7.1-1.9,10.5-2.5,5.9-1.5,11.9-2.4,18-2.5Z"
          fill="#5c5ecb"
        />
        <path d="M208.7,38.4c-.5.7-2.3,1.7-3,2-3.2,1.3-7.1,1.9-10.5,2.5l13.5-4.5Z" fill="#645ecb" />
        <path d="M191.3,43.9c-1.6,1.6-4.3,1.1-6,1.5v-.5c2-.3,4-.7,6-1Z" fill="#645ecb" />
        <path d="M191.8,43.9c.6-.5,1.8-.9,2.5-1-.4,1.3-1.5.9-2.5,1Z" fill="#645ecb" />
        <path d="M301.7,40.4c-.2,0-.4-.3-.5-.5.2,0,.4.3.5.5Z" fill="#6d6dd1" />
        <path
          d="M378.1,78.4c4.1,2.9,8.1,6.2,11.9,9.6-.4.9-1.2.8-2.4-.1-.8.7-1.6,0-1-1-1-.5-1.8-1.2-2.5-2-2.3-1.1-4.5-2.6-6.5-4.5-4.5-1.7-9.2-5.3-12.5-9v-.6c-1.9-.7-3-1.7-3.5-2.9,1.2,0,2.2.5,3.2,1.1,4.3,2.5,9.4,6.3,13.3,9.4Z"
          fill="#3f49b2"
        />
        <path
          d="M329.7,51.9c5.2,1.8,18.4,7,22.5,10s.3.3.5.5c1.9,1.1,2.6,2.6,0,1.5-1.4,1-5.2-1-5.5-2.5l-.5-.5c-2,.7-5.6-1.5-7-3-4.7-1.5-9.3-3.2-13.9-5l-.6-1c-.9-.2-1.4-.5-1.5-1-3.7-1.9.4-1.5,2.5-.5l3.5,1.5Z"
          fill="#3a40ac"
        />
        <path
          d="M382.6,80.9c2.9,2.8,6,5.3,9,8,2.5,2.6,5.3,5,8.2,7.2,2.2,2.3-1.3,2.7-2.8.6h-.8c-1.1.6-2.9-1.2-3-2.3-2-.3-2.9-1.1-2.5-2.5-.5-1.2-1.5-2.2-3-3.1v-.9s2,.2,2,.2c-2.8-2.7-6.2-4.8-9.1-7.3s-1.7-2-2.4-2.5c2,0,2.6,2.2,4.5,2.5Z"
          fill="#4b5cc0"
        />
        <path
          d="M361.6,67.9c1.2.9,2.4,1.7,3.7,2.6s1.4,1-.2.9c-1-.2-2-.7-3-1.5l-6-3.5c-1.1.3-3.7-1.1-3.5-2.5,1.6.3.8-.7,0-1.5,3.1,1.3,6.2,3.6,9,5.5Z"
          fill="#4247a9"
        />
        <path
          d="M391.6,88.9c3.5,3.1,7.4,5.9,11,9s1.4,2,2,2.5c.7,1.3,1.4,2.6,2,3.9l-.5.6-.6.4c-1.5-1.8-3.1-3.2-4.9-4.4-.1.4-.3.4-.5,0-1,.1-4.4-2.8-4-4l.2-1.5c.9.7,2.5,2.3,3.7,1.7-2.6-2.8-6.5-5-8.5-8.2Z"
          fill="#5161ca"
        />
        <path
          d="M407.1,102.4c-.4,2.2,1.7,1.8,2.5,2.7s.6,1.9,1.2,2.8c2.3,3.2,5.6,6.7,8.2,10l.5.5c.2.3.3.7.5,1v.5c-.2.3-.5.1-1-.5-.4,0-.8,0-1-.2-2.7-2.4-5.8-6.3-7.5-9.3-1.7-.9-4.1-3.1-4.5-5-.4-2-2.8-2.2-1.5-4.5.8.7,1.7,1.3,2.5,2Z"
          fill="#5869ce"
        />
        <path
          d="M439.1,149.3c-1,.2-2.1-1.9-2-3-6-8.6-11.6-17.4-17-26.5v-.5c4.1,5.3,8.1,10.2,11.7,16,2.7,4.3,5.8,9.1,7.3,14Z"
          fill="#586bd5"
        />
        <path
          d="M439.1,149.3c1.4,2.5,2.8,4.9,4,7.5s1.5,3.5,2,5.2l-2-2.2-1.5-.8-5.3-10.1.2-1.6c-.4-1.1-.2-1.4.5-1,.5.9,1.5,2.1,2,3Z"
          fill="#505ec6"
        />
        <path d="M419.6,118.4c-.1-.2-.3-.3-.5-.5l.5.5Z" fill="#586bd5" />
        <path
          d="M446.1,327.2c-.4,1.1-.7,2.3-1,3.5l-5,11.5c-1.2,1.6-1.2,2.6-2,4l-.5.5c0,.1,0,.4,0,.5-1.3,2.4-3.2,4.7-4.5,7-.7.7-.9.4-.5-.5,2.2-4.8,4.5-9.7,7-14.5l-.4-.7c1.6-2.1,3.1-4.5,3.9-7.3-.5-1.2.9-4.8,2.5-5,.5-.5.7-.2.5,1Z"
          fill="#b8d2f2"
        />
        <path
          d="M449.1,318.8c-.3,3.2-2,5.7-3,8.5l-.5-1c-.4,0-.4-.3,0-.5,0-2.8.7-4.9,2-6.5.1-.4.3-.4.5,0l.5-1.5c.2-.4.3-.4.5,0,.4.2.3.6,0,1Z"
          fill="#8fb5ec"
        />
        <path
          d="M452.6,306.8c-.1.4,0,1,0,1.5l-.5,1.5c-.4,1.7-1,3.3-1.5,5l-.5,1c0,.1,0,.4,0,.5l-.5,1c0,.1,0,.3,0,.5-.1.4-.3.4-.5,0-.2,0-.4,0-.5,0-.4-.2-.4-.3,0-.5l.5-1c-.4-.2-.4-.3,0-.5l.5-1c-.4,0-.4-.3,0-.5l.5-1c-1.2-.7-.6-4.1,1-4,.5-1.4,1.6-5.1,1.5-2.5Z"
          fill="#79b7f1"
        />
        <path d="M452.6,308.8c0,.4,0,.8-.5,1,.1-.5-.2-1.2.5-1.5,0,.2,0,.3,0,.5Z" fill="#6fadf1" />
        <path d="M450.1,315.8c.2-.4.4-.8.5-1l-.5,1Z" fill="#77b7ed" />
        <path d="M449.6,317.3c.2-.7.5-.9.5-1l-.5,1Z" fill="#77b7ed" />
        <path d="M449.1,318.8c0-.3,0-.7,0-1h.5c0,.4,0,.8-.5,1Z" fill="#77b7ed" />
        <path
          d="M451.1,309.3c-.6,1.6-.6,2.5-1,4l-.5,1c0,.1,0,.3,0,.5-.1.4-.3.4-.5,0-.2.9-.5,1.8-1,2.5-.7.7-.7.4-.5-.5-.9-1.4-.4-6.4,1.5-7-.4-2.2.4-6.2,2.5-7l.5.5c-.1-1.3.6-2.4,1-3.5l-2,9.5Z"
          fill="#040946"
        />
        <path d="M455.1,292.8c.2-.8.2-1.5.5-2.5l-.5,2.5Z" fill="#5fa6f3" />
        <path
          d="M459.1,218.3c.4,3.2.9,8.1.8,11.2s-.3,1.3-.6,1.3l-.7-2c-.4-.2-.7-.5-.7-.8-.6-3.5-.9-7.4-.8-10.7l-.5-1.5c-.7,0-.6-.7,0-1l-.5-1c-.2-.2-.2-.5,0-1-1.2-1.5-1.3-3.2-1-5-1-.1-1.2-1.4-.5-2l.4-.8c-.9-4.9-2.2-9.7-3.8-14.5l.9-1.2c.9,2.3,2.1,5.1,2.8,7.5,1.8,6.5,3.5,14.8,4.2,21.5Z"
          fill="#19289b"
        />
        <path
          d="M452.1,187.8c0,.5,0,1,0,1.5.3,4.4,2.5,9.5,3.3,14s-.4,2,.7,2.8l-1.4-.3c-.9,0-.9-1.4,0-1.5l-.5-1c-.9-.4-1.3-1.8-.5-2.5l-.5-1c-.2-.1-.2-.3,0-.5l-.8-.5-2.2-8c-.7-1.6-3.8-8.8-3.5-10.1s.2-.3.5-.4c-.2-.2-.2-.3,0-.5-.2-1.4,0-2.4.5-3,2.1,3.4,2.8,7.5,4.5,11Z"
          fill="#162490"
        />
        <path d="M460.6,228.8c0,0-.4-.5-.5-1.5l.5,1.5Z" fill="#1e35b5" />
        <path
          d="M450.6,240.8c-1.5-6.1,3.5-4.7,3.6.2-.5,2.3,0,3.7,1.6,4,.5,3.9.8,7.8.8,11.8.5,3.9.5,8.1,0,12,0,1.5,0,2.5-.5,4-.2,2-1.2,4.1-2,1.2-1,.6-3.7,1.9-3.8,0,.4-5.7.7-11.4.9-17.1-1.1-1.1-1.1-2.9,0-4,.4-3.1.3-6.2-.5-9.5-1.1-.6-1.1-2,0-2.5Z"
          fill="#000457"
        />
        <path
          d="M451.1,256.8c0,5.7.2,11.4-.5,17,1.5.9,3.6-1.9,4.5-1s-.5,2.1.5,2c-.3-.9.4-1.6.5-2-.1,3.4-.9,6.6-1,10h-.5c-.4-1.7-.6-.7-.7,3.1-.5,5.9-4.9,4.3-4.3-.8l-1-.8c-.3-.4-.5-.7-.5-1.1.5-6.6,1.2-13.8,1.9-20.4s.3-2,.5-3c-.8-.5-.8-3.8.5-3Z"
          fill="#000251"
        />
        <path
          d="M441.1,169.3c.1-.4.3-.4.5,0,1.8,3.2,3.4,6.6,4.8,10.2l-.3.8c.8,0,.9,1.4,0,1.5.4,1.5.2,3.4,1,5l-1.5-1c-1.2-3.5-3.2-7.3-4.5-11l-3.8-9.8c.1-.6.5-1,1.2-.9l2.7,5.2Z"
          fill="#030216"
        />
        <path
          d="M456.1,213.8l.5,1c0,.3,0,.7,0,1l.5,1.5c.6,3.7,1.2,7.8,1.5,11.5s0,.3,0,.5c-.9,1-.5,3.1-.5,4.5-1-4.2-1-8.7-1.5-13,0-.9-.2-1.7-.5-2.5,0-.2,0-.3,0-.5-.4-1.5-.7-3-.8-4.5s.1-.6.8-.5c0,.3,0,.7,0,1Z"
          fill="#2d58c4"
        />
        <path
          d="M447.1,180.3c0,1.2,2.5,8.3,3,10.5.4.7.4,1.2,0,1.5l-4-10.5c-.1-.4.1-1.1,0-1.5-.4-1.8.4-1.4,1,0Z"
          fill="#1b3a98"
        />
        <path
          d="M453.1,199.3c0,.9-.2,1.6-.5,2-1.1-2.1-1.5-4.7-2-7l-.5-1.5c0-.2,0-.3,0-.5,0-.4.1-1.1,0-1.5,1.5,2.6,2.4,5.5,3,8.5Z"
          fill="#183bab"
        />
        <path
          d="M453.1,199.8l.5,1c.2.8.3,1.7.5,2.5l.5,1c0,.4,0,1.1,0,1.5.1.7.4,1.3.5,2,0,1.1-.2,1.9-.5,2.5-.9-2.1-1.1-4.8-1.5-7l-.5-1.5c0-.2,0-.3,0-.5,0-.7-.2-1.7.5-2,0,.2,0,.3,0,.5Z"
          fill="#1c43b5"
        />
        <path
          d="M456.1,212.8c-.9,1.1-.2,3.4,0,5-.9-2.3-1.4-5.1-1.5-7.5s-.3-2.1.5-2.5c.3,1.7.7,3.3,1,5Z"
          fill="#2451ba"
        />
        <path d="M458.6,240.8c-.9-1.5-.5-4.1-.5-6,.9,1.5.5,4.1.5,6Z" fill="#2d58c4" />
        <path d="M456.6,220.8c0-.4-.4-1.5-.5-2.5.8.4.5,1.7.5,2.5Z" fill="#2451ba" />
        <path d="M453.1,203.3c0,0-.4-.5-.5-1.5l.5,1.5Z" fill="#183bab" />
        <path d="M450.6,194.3c0-.1-.4-.8-.5-1.5l.5,1.5Z" fill="#1b3a98" />
        <path d="M459.1,232.8c-.8-.3-.5-1.3-.5-2,.8.3.5,1.3.5,2Z" fill="#2d58c4" />
        <path
          d="M450.6,300.8c.7-3.2-1.4-9.7,2.5-11,0,.7,0,1.3,0,2s0,.3,0,.5l-.5,1.5c-.3,2.8-.4,4.8-1,7.5l-1-.5Z"
          fill="#01055f"
        />
        <path d="M452.6,293.8l.5-1.5c0,1-.5,1.4-.5,1.5Z" fill="#010557" />
        <path d="M453.1,182.8v.5c-1.3-1.2-1.4-3.4-2-5h.5c0,1.2,1.1,3.2,1.5,4.5Z" fill="#6982df" />
        <path d="M454.1,185.8c-.7-.3-.4-1-.5-1.5.7.3.5.9.5,1.5Z" fill="#5b77e8" />
        <path d="M453.6,183.8h-.5c0-.2,0-.3,0-.5v-.5c0,.2.4.5.5,1Z" fill="#5b77e8" />
        <path
          d="M436.6,147.3c2.1,3.8,4.7,8.6,6.5,12.5s.6,1.7,1,2.5c.8,1.9,2.5,5.6,2.9,7.4s.5,1.8-.4,1.6l-1-2c0-.1,0-.4,0-.5l-.5-.5c0-.1,0-.4,0-.5l-2-3.5c0-.1,0-.4,0-.5l-.5-.5c-1.7-3.7-3-6.1-5-9.5-.4,0-.7,0-.8-.1-1.2-1.8-2.4-4.5-3.2-6.4l-1.5-2.5c-1.5-.9-2.2-2.2-2-4,.8-.3,1.4-.5,2-.5,2.1,1.2,3.9,4.6,4.5,7Z"
          fill="#7e91e0"
        />
        <path
          d="M433.1,354.2c-1.5,2.6-2.8,5.8-4.5,8.5-2.9,4.6-6.4,8.7-9,13.5-2.4,2.7-4.3,5.6-6.5,8.5l-.5.5c-.4.5-.6,1-1,1.5-.3.4-.6.5-1,.5l-.5.5c.4.3,0,.8-.5,1l-2,2c-.1.3-.3.3-.5,0-.3-.1-.3-.3,0-.5-.4-.1-.4-.3,0-.5l2.5-2.5c-.4-.1-.4-.3,0-.5l.5-.5c-.4-.1-.4-.3,0-.5,0-.8,1.1-2.5,2-2.5,1.3-1.4,2.5-2.8,3.5-4.5l.2-1.3c3.6-4.7,6.9-9.6,10.1-14.6l1.2-.6c1.5-3.1,3.4-5.9,5.5-8.5l.5.5Z"
          fill="#dee4f0"
        />
        <path d="M437.6,346.7c.2-.3.5-.5.5-.5l-.5.5Z" fill="#205ef3" />
        <path
          d="M228.7,462.7l3.5.5c1.3-.6,2.7-.5,4,0,.4,0,.6.2.5.5l14.2,1c8.3-.9,16.9-.3,25.2-1.5.2.9-.4,1.3-1.2,1.5-1.4.2-3.9.4-5.5.5-13.3,1.2-28.7.9-41.9-.6s-12-1.7-17.8-2.9v-1.5c.3-.2.7-.4,1-.5,1.1-.3,14.5,1.9,17,2.3s.6.4.9.7Z"
          fill="#f8fbfc"
        />
        <path
          d="M204.7,461.2c27.4,5.7,50.1,6.2,78,3,.4.1.4.3,0,.5-.7.4-1.7.3-2.5,0l-.5.5c0,.4-.3.4-.5,0-.6.4-1.4.3-2,0l-.5.5c-.3.6-.7.6-1,0-.6.3-1.4.4-2,0-.4.2-.9.4-1.5.5-.3.7-.7.7-1,0l-5,.5c-.3,1-1.2,1-1.5,0-1.8.4-3.6.5-5.5.5l-1.5.6c-12.5.3-24.8-.5-37-2.6-2.9-.3-5.7-.8-8.5-1.5-.4,1.1-1.6,1.1-2,0l-2-.5c-.2.4-.3.4-.5,0l-2-.5c-.2.4-.3.4-.5,0l-.5-.5c-.2.4-.3.4-.5,0l-1.5-.5c-.2.9-.7.8-1,0l-1.5-.5c-.2.4-.3.4-.5,0-1.1-.2-2.1-.5-3-1,0,.4-.3.4-.5,0-.4-.1-.4-.3,0-.5,2.8.2,5.7.8,8.5,1.5Z"
          fill="#597bda"
        />
        <path
          d="M301.2,456.7c.2-.4.3-.4.5,0,.4-.2.7-.2,1,0,.4.1.4.3,0,.5-.2,0-.3,0-.5,0l-3,1c-8.6,2.3-18.6,4.4-27.5,4.5l-4,.5c-.7,0-1.3,0-2,0-3,.4-6,.5-9,0-.8.5-1.3.3-1.1-.7,2.9.1,5.7,0,8.6-.3,0-.4.3-.4.5,0,2-.3,4-.4,6-.5,0-1.1,1.5-1.3,2-.5,1.5-.1,3-.3,4.5-.5.3-.8.8-.8,1,0l2.5-.5c.2-.4.3-.4.5,0l2.5-.5c1.7-1.5,5.5-2.2,7.5-1,3-.8,6-1.5,9-2,.1-.4.6-.3,1,0Z"
          fill="#2f5ef8"
        />
        <path
          d="M230.7,461.7c3.5.3,7,.7,10.5,1.1v.9c-.6,0-1.3,0-2,0-1-.2-2-.3-3-.5-1.3,0-2.7,0-4,0l-3.5-.5c-6.4-.3-12.7-1.7-19-2.5-.1.4-.3.4-.5,0-1.4-.2-2.7-.5-4-1-.1.4-.3.4-.5,0-.9-.2-1.5-.5-2-1,1.8-.1,2.2-.3,1-.5-.4-.1-.4-.3,0-.5l1.6-.3,12.7,2.2c4.6,0,8.8.9,12.7,2.6Z"
          fill="#3563f9"
        />
        <path
          d="M324.2,453.2c.2,0,.3,0,.5,0-1.9,1.5-5.2,2.9-7.5,3.5s-.3,0-.5,0l-1.5.5c-.2,0-.3,0-.5,0l-2.5,1c-4.9,1.5-10,3-15,4l-4,1c-.2,0-.3,0-.5,0-1.9.7-4,1.2-6,1-.5,0-.8-.2-1-.5,13.1-2.6,25.8-6.4,38.5-10.5Z"
          fill="#5576d1"
        />
        <path
          d="M396.1,401.7c.3.1.3.3,0,.5.2,1.9.9,1.2,2,1.5-1.2,2-3.3,3-5,4.5-1.9.8-3.1,2.1-4,4-.2,0-.3,0-.5,0-6.8,2.8-3.9-1,0-4-.4-.2-.4-.3,0-.5,1.8-1.9,3.7-3.8,5.5-5.6s.9-.6,1.5-.4h.5Z"
          fill="#3084f8"
        />
        <path
          d="M264.2,462.2c-2.3,1.1-5.5.2-8,.5l.5.5c.4.1.4.3,0,.5-5.2,0-10.3,0-15.5,0-1.9-1.8-5.7-.9-8-1.2s-2-.7-2.5-.8c5.5-.8,11-.9,16.7-.3,5.7-.3,11.2,0,16.7.8Z"
          fill="#405bf8"
        />
        <path
          d="M367.1,426.7c2.6-1.9,3.7-2,3.3-.3l-3.8,2.3c-2.2,1.8-3.6,2.6-6,4-1.9,1.4-3.9,2.5-6,3.5-1.1.8-2.1,1.1-3,1-1,.4-1.2.3-.5-.5.1-.3.3-.3.5,0l.5-.5h.5c2.2-1.7,4.5-3.2,7-4.5-.7-.8.6-1.8,1.5-1.5.8-1.3,4.5-4,6-3.5Z"
          fill="#1a3dee"
        />
        <path
          d="M379.6,415.7c2.3,0,2.5,2,1,3.5-1.4,1-2.2,1.9-4,2.5-2,1.4-3,1.4-3,0-.9-.5-.4-.8.5-1-.4-.1-.4-.3,0-.5,0-2.1,2.9-5.3,5.5-4.5Z"
          fill="#0422db"
        />
        <path
          d="M384.1,412.2l.3.7c1.9,0,2.7.5,2.2,1.3-2,1.9-3.7,3.4-6,5,0-1.4.4-2.3-1-2.8v-.7c-.6-1.4,1.8-3.1,3-3,.7-.8,1.2-1,1.5-.5Z"
          fill="#0f3fec"
        />
        <path
          d="M351.7,437.2c-.8,1.3-2.1,2.3-4,3-2.1,1.1-4.4,1.9-6.5,3l-.5.5c-.1,0-.4,0-.5,0l-1.5,1c-.1,0-.4,0-.5,0l-.5.5c-.1,0-.4,0-.5,0-1.5.3-2,0-1.5-1,.2-.4.3-.4.5,0l1-.5c.2-.4.3-.4.5,0l.5-.5c.2-.4.3-.4.5,0l.5-.5c.2-.4.3-.4.5,0l1.5-1c.8-1.8,4.6-3.6,6.5-3l1-1c.1-.5.3-.4.5,0l.5-.5c.2-.4.3-.4.5,0l.5-.5c.1-.4.3-.4.5,0,0,.4.1.5.5.5Z"
          fill="#2544e7"
        />
        <path
          d="M330.2,447.2c.4.1.4.3,0,.5-1.3.9-2.8,1.6-4.5,2-2.6,1.1-4.8,2-7.5,3-3.7,1.2-7.3,2.2-11,3-.5,0-.8-.2-1-.5-.4-.1-.4-.3,0-.5.3-1,.7-1,1,0,.2-.2.3-.2.5,0,2-.6,3.9-1.3,6-2,.1-.4.3-.4.5,0l1.5-.5c2.7-2.5,7.3-4.4,11-4l.5-.5c.1-.4.3-.4.5,0l1-.5c.1-.4.3-.4.5,0,.4-.3.8-.5,1,0Z"
          fill="#2d54f4"
        />
        <path
          d="M376.6,421.7c-2.9,2.6-6.3,5.6-10,7,1-.8,2-2.2,3.5-2.5,0-1.2-2.5.3-3,.5,0-1.6,3.8-4.1,5.5-4.5-.2-.8.4-1.3,1-.5.8,0,1,.6,3,0Z"
          fill="#1c51e4"
        />
        <path
          d="M337.2,445.2c-1.7.7-3.2,1.3-5,2-.7.5-1.4.6-2,.5v-.5c-.2-.4.1-.7,1-1,.2-.4.3-.4.5,0l.5-.5c.8-1.4,2-1.9,3.5-1.5l1.5,1Z"
          fill="#2b55ec"
        />
        <path
          d="M388.6,408.2c-.5,1.2-4.2,3.8-4,4,1.6.9,2.3-.2,3.3-.4s.6.4.7.4c-.4,1-1.4,1.4-2,2-.8-.9-2.8-.4-3.8,0,0-.6.9-1.5,1.3-2,.2-1.6,2.9-3.4,4.5-4Z"
          fill="#276df3"
        />
        <path d="M393.1,408.2c-1,.9-3.1,3.8-4,4-.4-2.3,1.8-4,4-4Z" fill="#66abf8" />
        <path d="M265.7,463.2c-2.7.9-6.1.5-9,.5v-.5c3,0,6,0,9,0Z" fill="#385cf0" />
        <path d="M347.7,440.2c1.3-.7,2.5-2.3,4-3s2-.5,3-1c-2.1,1.3-4.2,3.6-7,4Z" fill="#2b59e6" />
        <path
          d="M318.2,452.7c-5.2,1.9-10.1,3.5-15.5,4.5v-.5c1.3-.9,3-1.2,4.5-1,3.8-.9,7.2-2.7,11-3Z"
          fill="#3260f2"
        />
        <path
          d="M285.7,463.7c.4,0,.9,0,1,.5-1.4.5-2.7.6-4,.5v-.5c.9-.1,1.4-.6,3-.5Z"
          fill="#5076da"
        />
        <path d="M271.7,462.7c-.8.9-2.7.5-4,.5.8-.9,2.7-.5,4-.5Z" fill="#385cf0" />
        <path d="M354.7,436.2c2-1.3,4-2.3,6-3.5-1.5,1.9-4,2.5-6,3.5Z" fill="#2945e3" />
        <path d="M239.2,463.7c-.8,0-1.7,0-2.5,0s-.4-.3-.5-.5c.9,0,2.5-.3,3,.5Z" fill="#405bf8" />
        <path
          d="M332.2,447.2c-1.7,1.3-4.4,2-6.5,2.5,1.5-.6,2.8-1.4,4.5-2s1.4-.3,2-.5Z"
          fill="#355cf1"
        />
        <path d="M302.2,457.2c-.8,1-2,.7-3,1,.8-.9,1.9-.8,3-1Z" fill="#3260f2" />
        <path d="M340.2,443.7c-.3.2-.8.7-1.5,1,.2-.7.8-1,1.5-1Z" fill="#2b55ec" />
        <path d="M340.7,443.7l.5-.5s-.2.3-.5.5Z" fill="#2b55ec" />
        <path d="M337.7,445.2l.5-.5c-.1,0-.3.4-.5.5Z" fill="#2b55ec" />
        <path
          d="M407.6,391.7h-.5c-.2-.4,0-.8.5-1l2-2c.2-.2.3-.7.5-1l.5-.5c.2-.2.7-.3,1-.5-1.3,1.7-2.8,3.3-4,5Z"
          fill="#215af3"
        />
        <path d="M412.6,385.2c.1-.2.4-.3.5-.5l-.5.5Z" fill="#215af3" />
        <path
          d="M404.1,394.7c-.3.3-.7.7-1,1-.6.6-1.8,1-2.5,1.7-1.5,1.4-2.5,3.8-4.5,4.8,0-.1,0-.4,0-.5-.1-.2,0-.6.5-1,.7-2.6,3.6-5.4,6-6.5,1.1-.9,1.6-.7,1.5.5Z"
          fill="#2d7eec"
        />
        <path
          d="M405.1,392.2c-.6,1-.6,1.2,0,.5.1-.7.4-1,1-.5.2-.2.3-.2.5,0-.9,1.1-1.5,1.6-2.5,2.5l-1.5-.5c-.2-1,1.5-3.1,2.5-2.5.4.2.4.3,0,.5Z"
          fill="#3679ea"
        />
        <path
          d="M41.3,170.3c0,2.6-.7,5.1-2.5,7.5-1.7,5.8-3.2,11.7-4.6,17.6l-.9.9c.9-4.5,1.4-9.7,2.6-14.1.5-1.7,2.7-7.6,3.4-8.7,1.2-2,.3-3.1-1.5-1.4s-3.2,5.6-4,7.3c.5-3.8,3.1-7.6,4.6-11.1s.2-1.5.4-1.8c2.5-2.9,3.3-6.5,6-9,0,4.4-2.8,8.6-3.5,13Z"
          fill="#5d90fc"
        />
        <path
          d="M66.3,111.9c2.5-2.4,6.6-.4,5,3,0,0,1.7-1.3,2-1.5.2,1-.8,1.2-1,1.5l-2,1.5c0-4.1-.8-3.7-4.5-3.5.2-.2.3-.8.5-1Z"
          fill="#97d8fe"
        />
        <path
          d="M100.3,85.9c0,0,.1.6-.1.9l-11.4,10.6v-.5c3.6-3.7,7.2-8.2,11.5-11Z"
          fill="#5a91f6"
        />
        <path
          d="M88.8,97.4c0,.2,0,.4,0,.5l-.5.5c-.2.2-.3.3-.5.5l-3,3.5c-.4.3-.7.8-1,1,.2,1.1-.6,1.6-1.5,1-.2-.2-.2-.3,0-.5,2.2-2.3,4.3-4.7,6.5-7v.5Z"
          fill="#6199f8"
        />
        <path
          d="M82.3,104.4c.7.7.5,1.1-.5,1l-1.6,2.1c.1,1.3-2.3,4.5-3.9,3.9.3-.6,1-1.2,1-2,.8-.8,1.6-2.6,2-3l.5-.5c.6-.6,1.9-1.4,2.5-2v.5Z"
          fill="#699ef9"
        />
        <path d="M79.3,106.4c.2-.2.3-.3.5-.5-.2.2-.3.4-.5.5Z" fill="#ace7fc" />
        <path
          d="M74.8,119.9c.8.8.7,1.2-.5,1-4,7.6-8.7,15.2-14.2,22.7l-2.3,1.8-2.6,3.9c-2.3,3.2-3.1.6-1.4-1.8,2.1-2.8,3.9-5.7,5.5-8.7,2.8-4.2,5.1-7.1,7.5-11.5,2.3-.7,3.1-4,4.5-5.7s2.4-2.6,3.5-3.7c.8-1.7,1.7-2.4,2.5-2l-2.5,4Z"
          fill="#689afc"
        />
        <path
          d="M59.3,138.8c-.4,3.6-5.1,7.4-6,10.3s.1,1,.7.7c1.6-.7,2.4-3.6,3.8-4.5.3,2.5-1.7,6-4,7-1.6.6-1.1,3-3,1.5,0-.2,0-.3,0-.5l.5-.5c0-.3,0-.7,0-1l.5-.5c1.9-4.7,4.7-8.3,7.5-12.5Z"
          fill="#6da1fd"
        />
        <path d="M51.3,151.8c0-.2.3-.4.5-.5,0,.2-.3.4-.5.5Z" fill="#75a9fe" />
        <path d="M50.8,153.3c.1-.4.5-.5.5-.5l-.5.5Z" fill="#75a9fe" />
        <path
          d="M47.8,168.3c1.8-4.3,3-5.3,3.6-3.1-3.8,8.4-7,17.3-10.1,26.1,1,2.4.4,6.2-1.5,8-5.4,16.8-7.3,35.6-5,53,.2,1.8-.1,3-1,3.5-.3,0-.4,0-.5,0-.8-3.3-1.9-9-2-12.2,0-6.2.2-12.7.8-19.4-.7-4.4-1-8.7-.9-12.9-.4-3.4-.2-7.3,1-10.5.2-.1.3-.4.5-.5l.9.9c-1.1,5.4,1.6,5.9,1.3.8l1-1.3c.4-2.9,1.4-5,2.9-7.4-.7-3,1.1-7.6,3-10,1.1-3.1,2.3-6,3.5-9,.2-2.1,1.2-3.9,2.5-5.5,0-.1,0-.4,0-.5Z"
          fill="#6c98fd"
        />
        <path
          d="M74.3,120.9c.3.1.6.3.6.4,0,.4-.4,1.3-.6,1.7s-.2-1.1.5,0c.9,1.1-.7,3.6-2,3.5l-3.7,6.7-1.3.3c-2.6,5.3-5.4,10.5-8.5,15.6l-2,1.4v2s-6.3,10.8-6.3,10.8l-1.7,1.2c-.2.8-3,2.6-2.5.8s2.9-6.2,3.9-8.1,2.1-3,3.1-4.7,2.7-4.8,4-7c3.9-6.4,8-12,12.2-18s2.3-4.8,4.3-6.5Z"
          fill="#7baefe"
        />
        <path
          d="M57.3,150.3c1.2,0,1.7.5,1.5,1.5l-.2,1.5c-5.9,11.6-10.9,23.6-15.1,35.8-.3,1.1-1.1,1.8-2.1,2.2,1.7-7.8,5.3-15.3,8-22.8s1.4-1.8,1.5-3-.8-1-1-.7-.8,3.1-2,3.5c.5-1.2,1-2.8,1.5-4,2.2-4.9,5.4-9.4,8-14Z"
          fill="#72a1fa"
        />
        <path
          d="M38.8,179.8c0,.2,0,.3,0,.5,0,2.8-.5,5.6-1.3,8.3-1.5.2-1.6,7.8,0,5l1.2-.2-2,8.1c-1.7.7-.4,1.2-.6,2.5s-2.6,4.2-2.9,3.9c-1-2.4-.8-4.9-.5-7.5s.2-2.7.5-4c1.3-6.1,3.5-12.5,5.5-18.5.2.5.2,1.2,0,2Z"
          fill="#6c9efe"
        />
        <path
          d="M38.8,180.3c.2,1.3.9,2.8.5,4.5,2.4.6.6-1.5,2.5-1.5-1,2.9-1.6,7-3,10s-1.2,1.8-3.5,2c.3-1.9.1-4.9.5-6.7s1-.3,1.3-1.3c.6-2.2-.2-5.2,1.7-7.1Z"
          fill="#70a3fe"
        />
        <path
          d="M38.8,179.8c0-.6,0-1.3,0-2,.9-2.5,1.6-5,2.5-7.5s2.6-6.4,4-9.5c-1.3,4.5-2.1,8.8-3.8,13s-2.4,3.6-2.7,6Z"
          fill="#70a3fe"
        />
        <path d="M45.3,174.3c-.3-2.1.8-4.2,2.5-5.5-.8,1.8-1.8,3.7-2.5,5.5Z" fill="#72a1fa" />
        <path
          d="M89.3,102.9c-3.4,3.5-6.8,7.7-10,11.5-.1,2.3-2.2,5-4.5,5.5.6-1.5,1.1-2.4,2-3.7-.8-.2-1.5,1.2-2,1.7l2-3.5c-.8-.5.8-1.3,1.5-1.5l.5-.5c-.2-.2,0-.5.5-1-.4-.2-.4-.3,0-.5l2.5-2c2.1-1.7,3.8-3.7,5.7-5.5s1.3-1.7,1.8-.5Z"
          fill="#6f9efa"
        />
        <path
          d="M85.8,103.9c-1.3,1.6-2.7,3-4,4.5-.7.9-1.5,1.8-2.5,2.5,0,0,0,.4,0,.5-1.5,2.5-6,4.2-3,.5,0-.2,0-.4,0-.5l5.5-6,.5.4c.7-1.3,2.4-2.1,3.5-1.9Z"
          fill="#6199f8"
        />
        <path
          d="M78.8,112.4l-.5.5c-.2.3-1.2,1.2-1.5,1.5-.4.4-3.1,2.9-3.5,2.5-.3-2.2,1.3-3.9,3-5-.2.5-.7.8-.5,1.5,1.4,0,2.3-1.3,3.5-2-.2.2-.3.8-.5,1Z"
          fill="#699ef9"
        />
        <path
          d="M81.8,382.7c3.7,3.1,7.4,7.7,10.3,11.9s0,.3-.3.6c-.3,0-.7,0-1,0-5.3-6-11.1-12.2-15-19-.2-.2-.2-.3,0-.5h1.3c1.2,1.4,3.7,4.8,4.8,6.3s0,.4-.1.7Z"
          fill="#7483d9"
        />
        <path
          d="M64.8,357.7l1.1.6c3,5.1,6.2,10.1,9.4,15l.4,2.3v.5c-.9-.5-1.6-1.2-2.2-2.1-5.4-7.9-9.8-16.7-14.8-24.9v-1.5c2.2,3.1,4.2,6.4,6,10Z"
          fill="#707ed5"
        />
        <path
          d="M52.3,331.7c.6.2,1.1.5,1.3,1,2,4.9,3.7,10.1,5.2,14.9v.5c-2.6-3.6-5-8.8-6.5-13-.5-.6-.8-1.5-1-2.5-.7-.3-.7-.7,0-1-.5-2.1-2.2-5.4-3-8l-.5-.5c0-.3,0-.7,0-1v-.5c1.6-.5,2.4,2.5,2.2,3.8l2.3,6.2Z"
          fill="#6575dd"
        />
        <path
          d="M45.8,314.3c1.7,1.9,2.8,4.9,2,7.5,0,.2,0,.3,0,.5-1-1.2-2.4-3.5-2.8-4.9s-.3-3.2-.7-4.6c.1-.4.3-.4.5,0,.5-.1.8.4,1,1.5Z"
          fill="#6373dd"
        />
        <path
          d="M43.8,306.8c.4.2.4.3,0,.5l.5,1.5c.3,0,.6,0,.7.1s0,3.3-.2,3.9h-.5c0-.2,0-.3,0-.5-.6-2.6-1.1-5-1.5-7.5l1,2Z"
          fill="#6377e8"
        />
        <path d="M51.3,331.7c0,.3,0,.7,0,1,.3.6.6,1.1,0,1.5-.9-.5-1-1.6-1-2.5h1Z" fill="#586ad2" />
        <path d="M48.3,323.7s-.4-.1-.5-.5l.5.5Z" fill="#6373dd" />
        <path d="M40.8,304.3l.5-.5c0,.6-.5.5-.5.5Z" fill="#576ae1" />
        <path d="M52.3,335.2l-1-.5v-.5c0-.5,0-1,0-1.5.8.6.7,1.7,1,2.5Z" fill="#5666d8" />
        <path
          d="M31.4,211.3c0,2.5,1.5,7.1,1.7,10.2.4,6.8-.8,13.2-1.2,20-.1,1.9,1.6,11.9,2,14.2l.7.3.3,5.7c.4,0,.4.3,0,.5h-1c.1-.8-1.9-13.1-2.4-14.8s-.9-1.1-.6-4.2.8,0,.5-1.2c-.2-.4-.6-.3-1-.3-.1-.8-.4-2.2-.4-2.7.1-2.7,2.7-5.7-1.6-6,1.2-1.6.4-3,.8-4.6s1-1.4,1.2-1.9c.4-.9-2.1-.8-1-1.7s1.5,0,2,0c.2-.9-.7-1.1-.8-1.8s1.3-1.4-1.2-1.2c.9-1,0-2,0-2.7s2.2-1,.5-3.3c0-.1.4-.3.5-.5-.3-1.7,0-3.1,1-4Z"
          fill="#6691fc"
        />
        <path
          d="M31.4,211.3c-.9,1.3-.2,2.3-1,4-1-1.7.2-2.9.4-4.4.4-2.8.1-6.1.6-8.9s.4-.8,1-1.2c-.5,3.4-1,7.1-1,10.5Z"
          fill="#608dfc"
        />
        <path
          d="M37.3,244.3c.4,0,.4.3,0,.5-.4,3.1-.5,6.4,0,9.5.5.3.5,1.2,0,1.5-.6,3.2-.3,6.6.4,9.9l-.5.5c1.4,1.4,1.3,4.7,1.1,6.6-1.1,2.6-.3,6.2,0,9-.8-.6-.7-1.7-1-2.5-.4-1.3-.5-2.6-.5-4,0-.7,0-1.4,0-2-.4,0-.4-.3,0-.5v-3.7s-.5.2-.5.2c-.7-1.9-1.5-5-1.5-7s0-.3,0-.5c-.2-4.5-.2-9-.1-13.5l1.1-1.5c-.8-1-1-5,1-5,.3.7.5,1.5.5,2.5Z"
          fill="#7b95f0"
        />
        <path
          d="M36.8,272.8c-.8.7-.7-.2-.5-1,0-.2,0-.3,0-.5,0-.7,0-1.3,0-2s0-1,0-1.5c1.4.6,1.1,3.4.5,5Z"
          fill="#7c94ed"
        />
        <path d="M37.3,279.3c-1-2.7-.5-1.6-.5-4l.5,4Z" fill="#6d86f1" />
        <path d="M38.8,285.8c-.2-1.1-.4-2.3-.5-3.5.9.7.4,2.4.5,3.5Z" fill="#7c94ed" />
        <path d="M36.8,272.8c0,.2,0,.3,0,.5l-1,.5c-.4-.8.5-1.7.5-2,0,.4.5.8.5,1Z" fill="#6d86f1" />
        <path
          d="M38.3,239.8c1.2,3,1,6.9,0,10l.7.6c.3,4.1.4,8.3.3,12.4-.4.8-.4,1.7,0,2.5.4,0,.3.2,0,.5l.5,1c.4.6.4,1.4,0,2,.2.3.3.3.5,0,.1-.4.3-.4.5,0,.4,0,.4.3,0,.5.7,2.8.8,5.7.5,8.5,1.1,3.7,1.1,7.2,0,10.5-.9-1.9-1.2-4.4-1.5-6.5l-.5-3.5c-.4-.2-.3-.6,0-1-.3-.1-.3-.3,0-.5-.3-.1-.3-.3,0-.5l-.5-1c-.4-.6-.4-1.4,0-2-.4-1.7-.6-3.4-.7-5.2-1.3-1.5-.9-4.4-.3-6.3-.2-8.2-.3-16.5,0-24.7s.2-.2.5-.3c.6.7.6,1.7,0,3Z"
          fill="#4062e6"
        />
        <path
          d="M37.3,255.8c.4,1.9.6,3.9.5,6,.3,3.8.8,7.7,1,11.5-.1.4-.3.4-.5,0,0-.2,0-.3,0-.5,0-.8-.4-5.3-.6-5.5s-1.4.2-1.5-.3c-.4-2,1-1.8,1-2,0-.6-1-1.6-1-3s.4-2.9.4-4.9-1.1-1.6.7-1.4Z"
          fill="#7c94ed"
        />
        <path
          d="M39.8,281.8c-.1-.7-.4-1.4-.5-2.5-.3-.4-.4-.7,0-1,.9.7.4,2.4.5,3.5Z"
          fill="#7c94ed"
        />
        <path d="M38.8,275.3v.5c-.8-.4-.5-1.7-.5-2.5h.5c0,.7,0,1.3,0,2Z" fill="#7b95f0" />
        <path
          d="M39.3,278.3c0,.3,0,.7,0,1-.8-.4-.5-1.3-.5-2,.1-.3.3-.3.5,0,0,.3,0,.7,0,1Z"
          fill="#7b95f0"
        />
        <path
          d="M39.3,276.3c-.1.3-.3.3-.5,0,0-.2,0-.3,0-.5s0-.3,0-.5c.5.2.4.6.5,1Z"
          fill="#7c94ed"
        />
        <path d="M39.3,277.3h-.5c0-.2,0-.3,0-.5.1-.3.3-.3.5,0,0,.2,0,.3,0,.5Z" fill="#7c94ed" />
        <path d="M39.3,276.8h-.5c0-.2,0-.3,0-.5h.5c0,.2,0,.3,0,.5Z" fill="#7b95f0" />
        <path
          d="M42.3,278.3c.6.4.7.8,0,1l.5,3c.3.7.4,1.7.5,3,.7.2.6.6,0,1l.5,2c.8.6,1,2,0,2.5l.5,2c1,0,1,.8,0,1l1,4.5c1.2,0,2.3,3.7,1,4-.8.5-.8-1.4-.7-1.3.3.8.6,2.1-.3,2.3-1.1,0-1.9-3.5-.5-3.5.5.4.5,0,0-1l-1-.4-2-6.6c-.3,0-.5-.2-.5-.5,0-.2,0-.3,0-.5v-2.5c0-3.5,0-7,0-10.5.1-.4.3-.4.5,0,.2-.2.4,0,.5.5Z"
          fill="#2b69f2"
        />
        <path
          d="M44.8,305.3c.4.1.4.3,0,.5l.5,1.5c.4.6.8,1.5,1,2.5,1.5.4,1.8,2.1.5,3-.4.4-.7.9-1,1.5,0-.3-.9-1.1-1-1.5-.3-1.1-.2-2.9-.5-4l-.5-1.5c0-.2,0-.3,0-.5-.6-2.8-1.3-5.6-1.5-8.5l2.5,7Z"
          fill="#c0dcf9"
        />
        <path
          d="M44.8,298.8c.3.5.3.8,0,1-.5,1.4-.8,2.1.5,3.5,1.3,1.2,2.4,5.1,1,6.5-.6-.7-.7-1.7-1-2.5l-.5-1.5c0-.1,0-.3,0-.5-.8-4-2.2-8-3-12-.3-.4-.4-1.1,0-1.5.9,1.2,2,5,3,7Z"
          fill="#3c6ef1"
        />
        <path d="M41.8,291.8c0,.5,0,1.1,0,1.5-.8-.4-.4-1.4-.5-2,.2.2.4.3.5.5Z" fill="#a6bbfa" />
        <path d="M326.7,452.7l-1,.5c0,0,.4-.3,1-.5Z" fill="#5576d1" />
        <path
          d="M283.2,466.2c.9.5,1.6,1.5,1.5,2.5-.8,0-1.7-.3-1.5.5l1,.5c-.2,1-1.3,1-1.5,0l-.5.5c-.6.9-3.5,1.2-4,0l-4.5.5c-1.8-5.2,2.1-3,1.8-3-.5,0-1-.6-.3-1,.8-.9,2.4-.8,3.5-.5,1-1,3.8-1.2,4.5,0Z"
          fill="#2468cb"
        />
        <path
          d="M284.2,469.7c.7,0,1.3,0,2,0,1.1,0,2.4.5,2.5.5.3.2.1.4-.5.5-.2,0-.3,0-.5,0-8.3.7-16.6,2.6-25,2.5,0-.3,0-.5,0-.5,2.1-.8,3.3.1.8,0s-.2-.2-.3-.4l1-1.2c4.8-.5,9.5-.7,14-.8,1.3-.1,2.7.1,4,0l.5-.5c.5,0,1,0,1.5,0Z"
          fill="#589be4"
        />
        <path
          d="M280.2,465.2c1.1,0,2.4.1,3.5,0l-.5,1c-1.9-1.1-2.8-.2-4.5,0-.4-.1-.4-.3,0-.5-.3-.2-.1-.4.5-.5.2,0,.3,0,.5,0h.5Z"
          fill="#276cd0"
        />
        <path
          d="M329.2,452.7c-.7,1.5-2.6,1.3-3.7,2.1s-.9,1.6-1.6,1.9-6.6.9-7.1,1.7,0,2.1-.6,2.9c1.1-.2,2.4-.3,3.5-.5l-1.5,1c-.1.4-.3.4-.5,0l-1,.5-1.3,1c-9.6,3.2-19.3,5.4-29.2,6.5-.5.9-1.6.9-2,0-2,0-2.7-.4-.9-1.9-.2-.5-.3-1-.1-1.6-.9-.4-.8-.7.5-1,2.8-.7,5.8-1.4,9-2,.1-.4.3-.4.5,0l4-1c4.6-1.9,10.1-3.5,15-4l2.5-1c.2-.4.3-.4.5,0l1.5-.5c.1-.4.3-.4.5,0,.9.6,3.2-.3,4.1-.7,2.6-1,5.3-2.3,7.9-3.3Z"
          fill="#2b67c6"
        />
        <path
          d="M318.2,461.7c.5,0,1.7-.3,1.5.5-1.8,0-3.7,1.5-5,2-5.6,2.1-13.1,3.7-19,5l-2,.5c-.2,0-.3,0-.5,0l-2,.5c-.3,0-.7,0-1,0-.5.3-1.1.4-1.5,0-.8.2-2.3.4-2.5-.5,10.3-1.9,20.3-5.2,30.5-7.5l1-.5c.2,0,.3,0,.5,0Z"
          fill="#5894e2"
        />
        <path
          d="M292.7,463.2c-2.4,1.5-5.3,1.2-7.8,1.5s-1.1.5-1.2.5c-.8.7-2.6.3-3.5,0-.3-.2-.3-.3,0-.5.8,0,1.7,0,2.5,0,1.3-.2,2.7-.3,4-.5,2-.3,4-.7,6-1Z"
          fill="#4774d4"
        />
        <path d="M297.2,462.2c-1.1,1-2.7.8-4,1,1.1-1,2.7-.7,4-1Z" fill="#4774d4" />
        <path d="M314.7,457.2c-.6,1.1-1.7.8-2.5,1,.7-.7,1.6-.8,2.5-1Z" fill="#406cc9" />
        <path d="M316.7,456.7c-.3.7-1,.4-1.5.5.2-.7,1-.4,1.5-.5Z" fill="#406cc9" />
        <path d="M317.7,461.7c-.1,0-.5.4-1,.5l1-.5Z" fill="#528bdc" />
        <path d="M322.9,455.7c.3.2.3.3,0,.5v-.5Z" fill="#285fc1" />
        <path d="M290.2,470.2c-.3.8-1.3.5-2,.5l.5-.5c.5,0,1,0,1.5,0Z" fill="#2b67c6" />
        <path d="M293.2,469.7c-.5,0-.8.5-2,.5l2-.5Z" fill="#2b67c6" />
        <path d="M295.7,469.2c-.6.1-1.2.3-2,.5l2-.5Z" fill="#2b67c6" />
        <path
          d="M197.2,470.2c2.3-.9,1.9.3,2.4.5,1.1.3,2.3.2,3.1,1-2.5-.1-3.7-1.1-5.5-1.5Z"
          fill="#1c63d7"
        />
        <path d="M186.3,467.7c-2.1-.5-4.6-.6-6.5-2,2.2.6,4.5.9,6.5,2Z" fill="#61b5fc" />
        <path d="M177.8,465.2c-.4,0-.8,0-1-.5.4.1.8,0,1,.5Z" fill="#61b5fc" />
        <path d="M179.3,465.7l-1-.5c.7.2.9.5,1,.5Z" fill="#61b5fc" />
        <path
          d="M260.2,472.2c.3.2.3.3,0,.5-6.6.5-13.3.7-20,.5-1.8,0-3.7,0-5.5,0l-18.5-2.5c1.1-.3,2.3-.5,3.5-.5.6-.7,1.3-1.1,2.2-1,12.2,1.9,24.5,2.3,37,2.3l1.3.7Z"
          fill="#4e9de9"
        />
        <path
          d="M263.2,472.2c.9,0,3.2-.4,3.5.5-1.5-.5-3,.4-4,.5-7.7,1-14.9.2-22.5,0,.5-.8,1.9-.5,2.7-.5,5.5,0,12,.5,17.2,0l.5-.5c.9-1.3,1.6-1.3,2.5,0Z"
          fill="#5ea9eb"
        />
        <path
          d="M275.2,466.7l.7,1h-2.2c-.2.9,1,.2,1,.8s-.7,1.6-.6,1.7h4c-1.1.1-3,.8-4.3.9-3.5.4-7.3.2-10.7,1.1-.8,0-1.7,0-2.5,0h-.5c-7,0-14.3.3-21.3,0s-13.2-2.1-19.2-2c0-.8-.9-.4-1.5-.5-1.3-.6-2.8-1-4.6-1.2v-.8c.8-.6,1.8-1.1,3.1-1.5l.4-.6c19,1.7,38.8,3.1,58.1,1.1Z"
          fill="#276cd0"
        />
        <path
          d="M187.3,459.7c.2,0,.8-.6,1.2-.5s.2,1.8,2.3.5c.7-.4,1-.2.5.5.4.3.6.3,1,0,5,.7,9.9,1.8,14.9,3.5,3.4.5,6.6,1.3,9.6,2.5,0,2.1-1.8,1.3-3,1.5-.4.9-1.5,1-3.5.5-.2,0-.3,0-.5,0l-2.5-.5c-5.6-.9-11.2-2.2-16.5-4,1.3.2,2.7.4,4,.5l-1.5-.5c1.5-3.6-2.4-1-3.2-1s-.6-1.9-2.8-1v-2Z"
          fill="#2866ca"
        />
        <path
          d="M213.7,467.7c1.3,1.4,2.9.5,4.5.5v1.5c-2.6-.3-5.5-.5-8-1.5,1.6,0,2.1-.2,3.5-.5Z"
          fill="#306dcf"
        />
        <path d="M219.7,470.2c-.6,0-2.1.5-3.5.5l.3-.5h3.2Z" fill="#62adee" />
        <path d="M209.7,468.2c-1.3,0-1.7-.4-2.5-.5.8,0,2.1-.3,2.5.5Z" fill="#306dcf" />
        <path
          d="M171.3,459.2c4.6,1.3,9,3.2,13.5,4.5l.7,1c-3.4-.9-7.4-.5-10.7-1,0,0,0-.8-.5-1.2-1.5-1.5-5.4-.8-7.5-1.8,1-1.4,2,.6,1-2l-3,1c1.4-3.1,3.9-1.2,6.5-.5Z"
          fill="#1c55c8"
        />
        <path d="M170.8,460.2v.5c-2.1.2-2.1-.7,0-.5Z" fill="#1d59c9" />
        <path
          d="M196.2,460.2c.2,0,.3,0,.5,0l3,1c.2,0,.3,0,.5,0l1.5.5c.3,0,.7,0,1,0l1.5.5c.2,0,.3,0,.5,0l.5.5c.2,0,.3,0,.5,0l2,.5c.2,0,.3,0,.5,0l2,.5c.6,0,1.4,0,2,0,2.8.7,5.6,1.2,8.5,1.5,13.4,1.4,25,2.4,38.5,2,1.9,0,3.7-.1,5.5-.5.5,0,1,0,1.5,0l5-.5c.3,0,.7,0,1,0,.5-.3,1.1-.4,1.5,0,.6-.2,1.3-.3,2-.5.3,0,.7,0,1,0,.2-.2.3-.2.5,0,.5-.4,1-.4,1.5,0v.5c-1.2.1-2.3.4-3.5.5-3.1.4-6.8,1.1-9.9,1.4-8.2.7-17-.3-25.3-.4s-8.8.7-13.7-.8c-2.9-.9-6.7-.3-9.6-.7-8.4-.9-16.4-4.4-24.5-6-.3.4-.7.4-1,0-.2-.1-.3-.4-.5-.5-1.4-.7-2.9-.8-4-2,3.2.2,6.3,1,9.5,2.5Z"
          fill="#306dcf"
        />
        <path
          d="M177.3,453.7l.7-.9c4.7,1.2,9.3,2.7,13.8,4.3l.4,1.1c1.4.4,2.7.9,4,1.5v.5c-3.2-.6-6.4-1.5-9.5-2.5s-7.3-2.7-11-4c.2-.4.7-.4,1.5,0Z"
          fill="#4a71d3"
        />
        <path
          d="M167.8,450.2c-.3.2-.6.2-1,0-.2,0-.3,0-.5,0l-2-1c-2.5-.9-4.6-1.9-7-3-.2-.3-.3-.7-.5-1,3.4-.7,9.2,2.1,11,5Z"
          fill="#5576d0"
        />
        <path
          d="M167.8,450.2c2.7-1.1,8.1.9,9.5,3.5-.5,0-1,0-1.5,0-3-1.1-6.3-1.8-9-3.5.3,0,.7,0,1,0Z"
          fill="#4b71d1"
        />
        <path d="M166.3,450.2c-.8-.1-1.5-.3-2-1,.7.3,1.5.1,2,1Z" fill="#4b71d1" />
        <path
          d="M120.8,420.2c1-1,1.3-.9,1.5.5,1.8,1,3.7,2.2,5,3.5l.5.5c.1-.4.3-.4.5,0,.3-.2.5-.3.6-.2,1.9,1.1,5.6,3.5,6.4,5.2,2,1,3.8,2.1,5.5,3.5.4-.1.7-.2,1,0,2.8,1.3,6.6,3.5,8.5,5.6,2.1.9,4.1,1.9,6,3,.9-.4,3.2.4,3,1.5,2,.1,4.7,1,6,2.5l4,2c.2-.4.3-.4.5,0,.5,0,.8.2,1,.5,2.7,0,5.6,1.2,7.5,3,6.9,1.6,14.1,3.4,20.5,6.5,2,.4,4,.9,6,1.5.2,0,.3,0,.5,0,1.3.5,2.6.8,4,1,.2,0,.3,0,.5,0l2.5.7c0,.5-2,.7-2.5.7s-.3,0-.5,0l-1.5-.5c-1.1-.1-2-.3-3-.5-.1.4-.6.2-1,0-.2-.4-.3-.4-.5,0-3.7-.5-7.5-1.2-11-2.5-4.2-1-11.5-4.1-15-4.5-3-1.6-6.2-2.8-9.5-3.5-3.5-1.9-7.2-3.8-11-5-1.3-1.9-7.2-3.9-9.5-5l-4-2.5c-5.3-3.6-10.8-6.8-16-10.5-2.4-1.7-5.2-4.9-7.5-6.5-1-1.7-.1-.9,1-.5Z"
          fill="#f8fbfb"
        />
        <path d="M147.3,440.2c-2-1-2.3-1.3-4-2.5,1.4.6,3.1,1.2,4,2.5Z" fill="#6279d3" />
        <path
          d="M111.3,407.7c.3-.2.7-.3.8-.2,1.3.7,8.5,6.6,8.7,7.3s0,.6,0,.9c.9,1,.9,1.5,0,1.5-.4.9-1.5.5-3.3-1.2l-3.2-2.8c-.9,1-4.8-3.2-4.8-3.8s.1-.5.3-.7c0,0,0-.4,0-.5s.6-.5.5-1c.3.2.7.3,1,.5Z"
          fill="#0e2bf2"
        />
        <path
          d="M109.8,408.7c.2.4,3.7,3.6,4.5,4.5l3.4,3c2.9,1.6,3.5,2.5,1.6,2.5-1.4-1-3.2-2-4.5-3s-2-1.7-3-2.5-.3-.4-.5-.5c-.8-.6-1.6-1.5-2.5-2v-2s1,0,1,0Z"
          fill="#0b18d2"
        />
        <path
          d="M114.3,413.2c1.6.6,2.6,2.1,4.2,3.1s1.9.6,2.3.9c.6-.5,1.3-.2,2,1,.5-.4.7-.1.5.5,1.5,1,2.8,2.2,4,3.5.7-.7,1-.4.5.5.2.2.2.3,0,.5,0,1.6-2.2.1-2.8-.9l-2.7-1.6c-.5-.2-1-.3-1.5-.5-.4-.6-.9-1.1-1.5-1.5,1-.2-.5-1.3-.8-1.5-2.4-1.8-2.4-2-4.2-4Z"
          fill="#0e16d9"
        />
        <path d="M111.3,413.7l.5-.5-.5.5Z" fill="#d4f5f1" />
        <path
          d="M87.3,387.2c2.8,1.4,5.6,4.7,6,8,.7.7.4,1-.5.5-.2-.1-.8-.4-1-.5l-10-12.5c.5-.7,1.2.4,1.5,1s-1.5-1.3-.5-1.5c1.9,0,4.8,3.1,4.5,5Z"
          fill="#e7f3f9"
        />
        <path
          d="M94.3,395.7c.4.6,1.3,1.5,1.5,2s0,.7,0,1c-1.3-.5-2.1-2.3-3-3l.5-.5c.2-.3.6-.2,1,.5Z"
          fill="#d0ebf6"
        />
        <path
          d="M93.8,391.7l.5-.2c1.6,1.8,2.1,2,1.5.7.4.4,1.1.6,1.5,1,0,.2,0,.3,0,.5,0,.4.5,1.4.5,1.5-.2.2-.9,0-1,0-.8-.3-1-.9-1.5-1.5-1.6-.2-2.1-.9-1.5-2Z"
          fill="#5197f4"
        />
        <path
          d="M90.8,388.2c.3.8.8,1.4,1.5,2,.9,0,1.8.5,1.5,1.5.5.7,1,1.4,1.5,2-2.4-1.1-1.9.3-1,2-.1-.2-.8-.3-1-.5-2-2.5-4-5.4-6-8,.5-.2.8-.4,1.5-.5.7-1.1,2.3.6,2,1.5Z"
          fill="#3d81f9"
        />
        <path
          d="M85.8,103.9c-2.2.6-3.5,3.1-5.2,4.5-.5-1.1.7-1.9,1.3-3s.3-.7.5-1c.5-.4,1-.6,1.5-1,.4,1.2,1.4-.1,1.8-.5,3.1-2.9,6.1-5.7,9.2-8.5l-9,9.5Z"
          fill="#5a91f6"
        />
        <path d="M87.8,98.9c-.2,1.3-2,2.6-3,3.5.4-1.7,2-2.4,3-3.5Z" fill="#5a91f6" />
        <path d="M88.3,98.4l.5-.5c0,.2-.4.3-.5.5Z" fill="#5a91f6" />
        <path
          d="M111.8,86.9c-1.1,1.9-2.5,4-4.1,5.6l.4.9c-1.8,1.3-3.5,2.8-4.9,4.5,0,.8-.7,1.5-1.5,1.5,0,.8-1.2,2-2,2,0,.8-.7,1.6-1.5,1.5,0,.6-.6,1-1,.5l-.5.5c0,.4,0,.7,0,.8-1.1,1.3-7.4,8.6-8,8.7s-.6,0-.9,0c.1-1.3.6-2.9,2-3,1.8-2.3,4.1-4.1,6-6.2s2.1-3,3-4,2.3-1.3,3-2.2c2.5-3.2,2-5.6,6.5-9.1s2.6-1.4,3.5-2Z"
          fill="#646dcd"
        />
        <path
          d="M142.8,65.4c-1.6,1.6-3.6,3-6,4-.6,1.8-2.6,3.1-4.5,3-2.5,3-5.3,4.8-8.5,5.5-2.5,2.8-5.2,5.3-8.2,7.7l-1.3-.2,7.5-7.7c4.7-4,11.4-6.4,16-10.3l5-2Z"
          fill="#555eca"
        />
        <path
          d="M123.8,77.9c.4.9-.3,1.9-2.2,3.1l.2.4c1,.7.7,1.1-.5,1-1,1.8-2.1,2.8-3.5,3-1,1.8-2.5,2.9-4.5,3.5-.2,1.1-1.4,2.1-2.5,2-.2,1.3-1.6,2.2-2.1.4s4.1-5.2,5.1-5.4c.2-.2.3-.3.5-.5,2.6-2.3,6.8-5.5,9.5-7.5Z"
          fill="#4c53bd"
        />
        <path
          d="M113.8,85.9c-1.4,1.3-4.5,4.4-4.2,6,.3-.4.8-.7,1.3-1,.7-.5,1-.3.5.5,1.2.9-.3,2.4-1.5,1.5-1.9,2.1-4.1,3.7-6.5,5-.2-1.9,3.7-3.6,4-4s-1.2-1.7-1-2,.9-.2,1.5-.7c1.4-1.3,2.8-2.7,4-4.3.6-.4,1.2-1,2-1Z"
          fill="#5a62c2"
        />
        <path
          d="M167.8,53.4c0,.5.6.5,1.6,0l.4.5c.4.1.4.3,0,.5-1.3.4-2.6,1-3.8,1.5-2.3,1-3.4,1.8-5.2,3s-1.4.4-2,0c-1.4,1-2.9,1.8-4.5,2.5-.1.4-.3.4-.5,0-.2.2-.3.2-.5,0-.8,1.1-3.3.8-2.2-.2l4.2-2.3c2.2-1.1,4-2.3,6-3.5,2.1-.5,4.4-1.2,6.5-2Z"
          fill="#3e49b5"
        />
        <path
          d="M149.8,61.4c1-.2,1.7-.2,1.5,1,.2.3,0,.6-.5,1-.2.4-.3.4-.5,0-4.4,1.8-8.6,3.9-12.8,6.4l-.7-.4c1.9-1.2,4-2.7,6-4s4.3-2.6,7-4Z"
          fill="#5056c4"
        />
        <path
          d="M155.3,58.9l-4,2.8c.4.7,1.4-.2,2-.3.2.2.2.3,0,.5-.2.4-.3.4-.5,0l-.5.5c-.2.5-.3.5-.5,0-.1.3-.3.3-.5,0-.6-.1-1.1-.5-1.5-1,1.7-.9,3.8-1.6,5.5-2.5Z"
          fill="#4c54ba"
        />
        <path
          d="M93.3,105.9c-.7-.4-.1-.7.5-1,.4-.7.5-1.7,1.5-2-.4,1.2-.7,2.5-2,3Z"
          fill="#6a79d9"
        />
        <path d="M95.3,102.4c0-.2.3-.4.5-.5,0,.2-.3.4-.5.5Z" fill="#6a79d9" />
        <path
          d="M87.3,109.4c.4.6.2,1.2-.4,1.9l-4.6,5.1c-.2,3.1-1.5,5.7-3.5,7.9.1.4,0,.9-.5,1.5,0,1.8-2.4,6-4.5,5.5-.4-.1-.4-.3,0-.5l-.6-1c1.7-3.9,3.6-7.7,5.6-11.5-1.3-.8,0-2.8,1.5-2.5,3.1-3.6,6.4-7,9.5-10.5-.2,1.7-1.5,2.8-2.5,4Z"
          fill="#7589e7"
        />
        <path
          d="M79.3,114.4c1.2-1.3,2.6-2.7,3.8-4s.7-1.3,1.7-1c-1.6,2.4-3,4-4.5,6.5s-1.2,1.8-1.5,2.5l-2.9,4.6h-1.1c0-.1-1,.4-1,.4,0-.9.3-1.7.5-2.5s.4-.7.5-1c1.5-1.9,2.9-3.7,4.5-5.5Z"
          fill="#89b8fd"
        />
        <path
          d="M93.8,104.9c-.2.3-.3.7-.5,1s-1.2.7-1.5,1l-.5.5c0,.1,0,.4,0,.5l-1.9,1.5c-1.5,3.3-3.6,6.4-6.1,9-.6,1.6-1.3,3.2-2.3,4.7.2,1-1.4,1.2-2.2,1.3.6-1.4,1.5-2.3,1.8-3.4s.4-4.2.8-5,4.6-5,5.9-6.6c.6-1,3.1-1.9,3.4-2.2s0-1,.3-1.2,2.3-1.3,2.9-1.1Z"
          fill="#6e7fe1"
        />
        <path
          d="M255.7,36.9l10,.5c4.3.5,8.6.9,13,1.2l.2.9c-2.8.3-5.7,0-8.6-.6-.4.4-1.1.4-1.5,0-1.2-.2-2.4-.4-3.5-.5-.1.3-.3.3-.5,0l-1.5-.5c-2.8.4-5.7.4-8.5,0-2.3.4-4.7.4-7,0-2.6.1-5.3.3-8,.5-.8,1.1-3.1,1.1-4,0-1.7.4-3.4.4-5,0-.6.5-2,.4-1.5-.5.2,0,.3,0,.5,0,1-.4,2-.5,3-.5,8-.6,15-.7,23-.5Z"
          fill="#393ab8"
        />
        <path
          d="M229.2,37.9c.2.6,1,.5,1.5.5.4.1.4.3,0,.5-.8.1-1.6.3-2.5.5-.1,1-.6,1-1,0-1.1,0-2.1.1-3,.5-1.5,1.7-5.5,2-7.5,1h-1c-3.5.2-7,.7-10.5,1.6l-.5-.6c.7-1,1.9-1,3-1.3,4.6-1.1,11.3-2.2,16-2.7s3.7.2,5.5,0Z"
          fill="#3544be"
        />
        <path
          d="M280.2,38.4c3.2.5,6.4,1.1,9.5,1.9l-.5.6c-.6.3-.2.4,1.4.4v.6c-1.3,1.6-6.2.5-7.4-1h-.5l-3-.5c-1.4.2-4,.4-5-.5l-3.5-.5c-.3,1-.7,1-1,0-.4-.1-.4-.3,0-.5,2.3,0,4.1.4,6.2.5s1.9.3,1.8-.5l-11.7-1c-.4,0-.7-.5-.8-.5,4.8.1,9.7.5,14.5,1Z"
          fill="#3840bd"
        />
        <path
          d="M297.7,41.4c5.5,1.2,11.3,2.3,16.5,4.5l-1.1.7c-2.4-.3-6.2-1.3-8.5-2s-.3-.3-.3-.7c-4,.1-8.3-1-12-2.5l-1-.5c-.2.9-1.3.4-2,0,0-.2,0-.4-.3-.5l-8.7-2c5.9.6,11.7,1.8,17.5,3Z"
          fill="#524fc3"
        />
        <path d="M265.7,37.4c-3.2,0-7,.5-10-.5,3.5,0,6.6,0,10,.5Z" fill="#434ab9" />
        <path d="M232.7,37.4c-.6,0-1.9.4-3,.5.6-.9,2.1-.4,3-.5Z" fill="#3544be" />
        <path
          d="M304.2,43.9c3,.7,7.1,1.2,10,2s3.2,1.6,4.5,2c.4,1.1-.6,1-1.5.5l-.4.6c-2.9-.3-5.6-1.1-8.1-2.6-.2.4-.3.4-.5,0l-1.5-.5c-1.3-.2-2.4-.6-3.5-1-2-1-.8-1.4,1-1Z"
          fill="#363db6"
        />
        <path
          d="M329.7,51.9c-1.4-.5-5.1-1.8-6.3-2s-.8-.2-.7.5c.4,0,.7.3,1,.5-1.8,1.5-4.9-.7-6-2-.7.5-1,.3-.5-.5.6,0,1.1,0,1.5-.5,3.7,1.2,7.7,1.7,11,4Z"
          fill="#3f49ba"
        />
        <path
          d="M190.8,45.4c1-.2,1.5,0,1.5.5l-.8,1.3c-1.8.8-10.5,4.2-11.9,4.1s-.5-.2-.8-.4c-1.2.8-2.4,1.1-3.5,1-1.5.2-2,0-1.5-1,5.6-2,11.2-3.9,17-5.5Z"
          fill="#3842b9"
        />
        <path
          d="M200.2,42.9c1-.3,2.5-.7,2.5.5.4.1.4.3,0,.5-.2.4-.3.4-.5,0l-1.5.5c-1.5,1.5-6.6,2.8-8.5,1.5l-1.5-.5c2.9-.8,6.6-2.5,9.5-2.5Z"
          fill="#353bb1"
        />
        <path
          d="M215.7,40.9l-3.2,1c-1,1.4-4.3,1.8-5.8,1-1.2.5-2.8,1-4,.5-.2,0-1.4-.5-2.5-.5,1.2-1.1,3-.8,4.5-1,3.5-.5,7.7-1.9,11-1Z"
          fill="#303eba"
        />
        <path
          d="M173.8,50.9l1.5,1c-1.3.9-2.8,1.5-4.5,2-.3.9-.7.9-1,0-1,.1-2,.4-3,.5v-.5s1-.5,1-.5c.1,0,.4,0,.5,0l1-.5c1.4-.5,2.9-1.4,4.5-2Z"
          fill="#3f46ad"
        />
        <path d="M169.3,52.9l-1,.5c.2,0,.6-.3,1-.5Z" fill="#3e49b5" />
        <path
          d="M365.1,71.4c4.4,2.8,8.5,5.7,12.5,9,1.8,1,2.9,2.2,3.5,3.5.2.2.2.3,0,.5-.3.1-.7,0-1-.5-1.9-.9-3.7-2-5.5-3.5-1.9.4-5.3-2.3-6-4-1.8-.8-3.8-1.7-5.9-2.8v-1.2c-.1,0-1.6-1-1.6-1-.4-.1-.4-.3,0-.5,0-.9,5.8,2.6,5.5,2.5-1.4-.5-4.6-2.2-4.5-3.5.8.5,2.1.9,3,1.5Z"
          fill="#8aa2e8"
        />
        <path
          d="M384.6,85.9c.7.1,1.4.4,2,1,.3.2.6.7,1,1,1.4,1.3,2.8,2.8,4.2,4h-1.3c-1.2.5-2.9-.7-2.5-2h-.5l-.5-.5c-1.6.5-4.1-1.3-4-3-.8-.6-1.5-1.3-2-2v-.5c1.1-.1,2.3.5,3.5,2Z"
          fill="#7b99e5"
        />
        <path
          d="M384.1,84.9c.4.3.6.7.5,1-.9-.5-2.7-1.4-3.5-2-1.2-.9-2.5-2.7-3.5-3.5,2.2,1.1,4.6,2.9,6.5,4.5Z"
          fill="#7893e1"
        />
        <path d="M386.6,86.9c-.7-.4-1.4-.6-2-1l-.5-1c.9.7,1.6,1.2,2.5,2Z" fill="#4b5cc0" />
        <path
          d="M339.7,57.9c2.5.7,4.6,1.9,7,3l.5.5c1.7.8,4,1.6,5.5,2.5s2.6,2,3.5,2.5l6,3.5,4.5,3.5c-2-.1-3.6-1.6-5.5-2.5-2.2-1.2-4.4-2.6-6.5-4-1.7,1.1-3.5-.7-4.5-2-1.4.8-4.6-.9-5-2.5-3.5-1.2-6.6-2.7-9.5-4.5-.4-.1-.4-.3,0-.5l.3-.6,3.7,1.1Z"
          fill="#8ea6e4"
        />
        <path
          d="M325.2,51.9c4.3.4,10.5,4.1,14.5,6-1.7-.5-2.9-.4-4-.5-.6,1.2-3.6,1.2-3.5-.5l-1.5-1c-.1.4-.3.4-.5,0l-.5-.5c-.1.4-.3.4-.5,0-1.5.8-2.4.5-2.5-1-1.2-.3-2.2-.8-3-1.5-3.5-1.3-.8-2.2,1.5-1Z"
          fill="#89a1e4"
        />
        <path
          d="M323.7,50.9c.5.3,1.2.4,1.5,1-.8,0-1.7,0-2.5,0v.5s1,.5,1,.5c-2.2,0-4.6-.9-6.5-2-.9,1.4-3.9.1-3.5-1.5.6-1.3,3.8-.4,4.8.2s-1.1,0-.8-.7l6,2Z"
          fill="#809ae4"
        />
        <path d="M347.2,61.4l-.5-.5c.2.1.4.4.5.5Z" fill="#6c71d6" />
        <path
          d="M390.6,91.9c.8.7,1.7,1.8,2.5,2.5l-.3.3,3.1,3-.2.7c-.3.2-.6.3-.8.2-1.1-.3-7-5.9-7.7-7.2-1.4-1.3-.8-2.2,1-1.5,1.2.6,1.6,1.3,2.5,2Z"
          fill="#528ff2"
        />
        <path
          d="M393.1,94.4c.9.8,2.1,1.6,3,2.5s3.8,3.3,4,4c.6.6,1.2,1.8.5,2.5-.7.7-1,.4-1-.5-1.2-1.4-2.6-2.6-4.1-3.7v-.8c-.7-.9-2.7-2.7-3.2-3.5-.8-1.2,0-1.1.8-.5Z"
          fill="#6093ed"
        />
        <path d="M362.1,69.9c-1.9-1.2-4-2.4-6-3.5l6,3.5Z" fill="#8497e0" />
        <path
          d="M400.6,100.9c.4,0,.7.2.9.4,2.9,2.6,6.5,5.9,8.1,9.1,1.5.5,4.4,3.4,4,5,2.2,2.2,1.3,3.7-1,1.5-1.5-1-2.7-2.2-3.5-3.5-3-3.1-5.9-6.2-8.8-9.4l.3-.6c-.8-1.4-.5-2.4-.5-2.5h.5Z"
          fill="#7999e8"
        />
        <path
          d="M406.1,104.9c1.8,1.5,3.1,3.4,4.5,5-.2.4-.6.5-1,.5-2.9-3.3-6.2-6.2-9-9.5,1.8-.9,3.6,3.3,5.5,4Z"
          fill="#4c5bc3"
        />
        <path
          d="M420.1,119.9c6.5,8.3,11.8,17.3,17,26.5l-.5,1c-1.3-2.4-3-4.7-4.5-7-2.5-1-4.6-4.9-5-7.5l-4-6c-1-2.3-2.5-4.6-4.4-6.9l.4-.6,1,.5Z"
          fill="#4a55c0"
        />
        <path
          d="M410.6,109.9c2.8,3.2,5.9,6.1,8.5,9.5l5.5,8.2-1.5-.7-.5-.5c-.3,0-.5-.2-.5-.5-.4-.1-.4-.3,0-.5l-.5-.5-.9-.2c-2.7-2.9-5.3-5.9-7.1-9.3-1-1.9-2.6-3.4-4-5,0-1.3,0-1.1,1-.5Z"
          fill="#474eb4"
        />
        <path
          d="M439.6,339.2c-1.5,4-3.5,7.5-6,10.5-.1.4-.3.4-.5,0-.4-.2-.4-.3,0-.5l1-1.5c-.4-.2-.4-.3,0-.5l.5-.5c-.4-.2-.4-.3,0-.5l.5-.5c-.4-.1-.4-.3,0-.5l.5-.5c-.2-.2-.2-.3,0-.5-.4-.1-.4-.3,0-.5.2-2,1.9-5.9,3.5-7,.1-.3.3-.3.5,0,1.1-1.7,2.1-3.5,2.9-5.5h.6c-.4,2.9-2.2,5.4-3.5,8Z"
          fill="#060b4e"
        />
        <path
          d="M445.6,325.7c0,.2,0,.3,0,.5-.2,1.3-1.9,3.8-2.5,5s-2.9,5.9-3.3,6-.2-.3-.2-.5c-.3-.1-.3-.3,0-.5l.5-1c-.2-.1-.2-.3,0-.5,0-.3.2-.5.5-.5-.4-.1-.4-.3,0-.5l.5-.5c-1.1-.4-.6-1.5.5-1.5l.5-1c-.6-1.5.6-5.3,2-6.5-.2-1.2,0-1.5.5-1l.5-.5c-.4-.1-.4-.3,0-.5l.5-.5c-.4-.1-.4-.3,0-.5l.7.2-.7,4.3Z"
          fill="#080e47"
        />
        <path
          d="M432.6,353.7c-1.7,3-3.7,5.7-5.5,8.5l-.4-.9c2.2-4,4.5-7.9,6.9-11.6,1.9-3.4,4.1-6.9,6-10.5-1.6,5-4.4,9.9-7,14.5Z"
          fill="#060e5f"
        />
        <path
          d="M448.1,317.3c.3.5-.1,1.6-.5,2-.6,2.2-1.2,4.4-2,6.5,0-.3,0-4.1,0-4.5-1.1-.6.8-4.4,2-4.5l.5.5Z"
          fill="#04084c"
        />
        <path d="M448.1,319.3c-.4-.5-.1-1.5.5-1.5-.1.5.2,1.2-.5,1.5Z" fill="#77b7ed" />
        <path
          d="M449.1,315.8c0,.2,0,.3,0,.5l-.5,1c0,.2,0,.3,0,.5-.4.4-.5.9-.5,1.5h-.5c.2-.6.3-1.3.5-2s.2-1.9,1-2.5c.4.2.2.6,0,1Z"
          fill="#020e6e"
        />
        <path d="M449.6,314.3c.2-.7.5-.9.5-1l-.5,1Z" fill="#77b7ed" />
        <path d="M449.1,315.8c0-.3,0-.7,0-1h.5c0,.4,0,.8-.5,1Z" fill="#77b7ed" />
        <path d="M448.6,317.3c0-.4,0-.8.5-1,0,.4,0,.8-.5,1Z" fill="#77b7ed" />
        <path d="M457.1,217.3l-.5-1.5c0,0,.4.7.5,1.5Z" fill="#2451ba" />
        <path d="M456.6,214.8l-.5-1c0,0,.4.2.5,1Z" fill="#2451ba" />
        <path
          d="M442.1,164.8c.2-.2.3-.2.5,0,1.6,2.8,4.4,9,5,12s.6,2.9.5,3c-.2.2-.8,0-1,0-2.6-3.6-4.4-8.1-5.5-12.5-1.6-.9-2.3-3.2-2.5-5-.4-1.4-.4-2.4,0-3,1.4,1.4,2.4,3.2,3,5.5Z"
          fill="#151d7b"
        />
        <path
          d="M447.1,179.8s0,.3,0,.5l-.8-.5-.2.5c-.7-3-3.6-7.3-4.5-11-.8-.8-1.5-2.7,0-2,1.9,4.1,3.5,8.4,5.5,12.5Z"
          fill="#0f2c96"
        />
        <path d="M453.6,200.8c-.5-.2-.4-.6-.5-1,.5.2.4.6.5,1Z" fill="#183bab" />
        <path d="M454.6,204.3l-.5-1c0,0,.3.2.5,1Z" fill="#19289b" />
        <path
          d="M433.6,147.3c1.7,1.9,2.7,4.3,4,6.5,1,3.7,3.9,6.8,4.5,10.5v.5c-1.3-1.7-2-3.7-3-5.5-3-3.5-5.4-8-6.5-12.5v-.5c.4-.1.8.2,1,1Z"
          fill="#192691"
        />
        <path d="M445.1,167.8c-.9-.9-1.5-2.3-2-3.5,1.4.7,1.5,2.3,2,3.5Z" fill="#7287e1" />
        <path d="M443.1,163.8l-.5-.5c0,0,.4.2.5.5Z" fill="#7287e1" />
        <path d="M442.6,164.8h-.5v-.5c.2.2.4.3.5.5Z" fill="#7287e1" />
        <path d="M445.6,168.8l-.5-.5s.4.2.5.5Z" fill="#7287e1" />
        <path
          d="M405.1,120.9c2.7.3,5.8,2.5,6.8,5.3,1.1.8,1.9,1.7,2.7,2.7,2.5,2.8,4.6,5.9,6.3,9.3l-.3,1.2c-2.8-.6-7.6-5-8.2-7.7s.4-1.2.1-1.6-.8-.3-1.1-.6c-.8-1.1,0-1.5-1.8-2,0,1.3-.6,1.3-1,0l-1-.5c-1-.3-1.7-1.7-1.3-2.8-1.7-1-4.2-4.7-1.2-3.2Z"
          fill="#000133"
        />
        <path
          d="M426.6,145.3l1-.3c1.1,1.9,2.4,3.7,3.9,5.3l.9.4c2.1,3.2,3.8,6.6,5.1,10.1,1.7,2.3,3.2,5.6,3.5,8.5-.6-.2-2.5-5.2-3-4.5,0,2.3,1.6,4.2,2.3,6.4s.4,2.8.6,3.6c-.7-.5-.9-1.3-1.2-2-3.4-7.8-6.8-15.4-10.8-23-1.4-1-2.7-2.9-2.5-4.5Z"
          fill="#01021e"
        />
        <path
          d="M426.6,145.3c.8,1.4,1.7,3.1,2.5,4.5-.8,0-1.6-.6-2-1.2-.9-1.3-1.9-5-2.9-6.4s-3.2-2.5-3.5-2.8c-2.5-3-2.9-7.4-6-10.5v-.5l1.8.6c1.9,2,10.3,13.5,10.3,15.4s0,.7-.1,1.1Z"
          fill="#010128"
        />
        <path
          d="M450.6,243.3c.9.5.3,1.9.5,2.7s.4-.5.5,2.6c0,1.5,1.2,3-.5,4.2,0-3.2-.5-6.2-.5-9.5Z"
          fill="#000251"
        />
        <path
          d="M439.1,162.3c.8,1.7,1.7,3.3,2.5,5l-.4.3c0,.6.2,1.1.4,1.7h-.5c-1.3-2.6-2.3-6-3.5-8.5-.3-.8-.2-.9.5-.5,1,.3,1.2,1,1,2Z"
          fill="#162f85"
        />
        <path
          d="M427.1,132.8c1.9,2.5,3.3,4.9,5,7.5.3,1.5-.9,1.1-2,.5-1,.2-1.8-1.6-1.5-2.5l-5.5-8.5c-.5-.3-1.1-1-1-1.5-.5-1-.5-1.7,0-2h.5l4.5,6.5Z"
          fill="#7f90e4"
        />
        <path
          d="M421.1,127.9c.9.5,1.6,1.6,2,2.5,1.9,2.6,3.8,5.2,5.5,8,.5.8,1.2,1.9,1.5,2.5.7,1.3,1.3,2.7,2,4,.7.6.8,1.1.5,1.5,0,.1,0,.4,0,.5-1.3.6-2.7-1.7-2.5-3-.7,0-1.1-.5-.5-1l-3-5.5c-1.3.3-2.1-.9-1.5-2-.8-.7-1.5-1.6-2-2.5v-.5c-.5-.3-.8-.6-1-1l-.5-.5c-.4-.2-.4-.3,0-.5l-1-1c-.4-.2-.4-.3,0-.5l-1-1c-.4-.2-.4-.3,0-.5-1.7-1.6-3.3-3.4-4.7-5.2l.2-.8v-.5c2.5,1.6,4.5,4.5,6,7Z"
          fill="#162792"
        />
        <path
          d="M433.6,147.3c-.3-.4-.7-.7-1-1-.2-.4-.2-1-.5-1.5,1,.4,1.4,1.5,1.5,2.5Z"
          fill="#3b47b0"
        />
        <path
          d="M410.1,385.7s0,.4,0,.5l-.5.5c0,.2,0,.4,0,.5l-2.5,2.5c-.1.4-.3.4-.5,0,0-.9,0-1.3-.5-1-.6-1.3.6-2.8,2-2.5-.2-.8.3-1.7,1-1,.1.5.9.4,1,.5Z"
          fill="#05096a"
        />
        <path d="M412.1,383.2c1.4-2.2,2.1-2.7,3.5-4.5-.6,1.7-2,3.5-3.5,4.5Z" fill="#182ea3" />
        <path
          d="M407.1,390.7c.2.5-.4,1.2-1,1.5-.3.2-.7.3-1,.5v-.5c0-.2,0-.4,0-.5.6-.9,1.2-1.4,2-1.5,0,.1,0,.3,0,.5Z"
          fill="#bbd0e9"
        />
        <path d="M409.6,386.7l.5-.5c0,.2-.4.4-.5.5Z" fill="#bbd0e9" />
        <path d="M407.1,389.7c.6-1,1.5-1.9,2.5-2.5-.8,1.3-1.6,1.6-2.5,2.5Z" fill="#bbd0e9" />
        <path d="M410.1,387.7c.1-.2.3-.3.5-.5l-.5.5Z" fill="#bbd0e9" />
        <path d="M407.6,390.7c.6-.8,1-1.6,2-2-.6.7-1,1.6-2,2Z" fill="#bbd0e9" />
        <path
          d="M407.1,390.2c-.7.5-1.4,1-2,1.5-.7-.7.6-2.2,1.5-2,0,0,.4,0,.5,0,0,.1,0,.4,0,.5Z"
          fill="#8eb9e6"
        />
        <path
          d="M407.1,391.7c-.1.2-.3.3-.5.5h-.5c.3-.5.8-1,1-1.5h.5c-.2.3-.3.7-.5,1Z"
          fill="#8eb9e6"
        />
        <path d="M232.2,463.2c-1.1,0-2.8.4-3.5-.5,1.1,0,2.8-.4,3.5.5Z" fill="#405bf8" />
        <path d="M220.7,465.2c-2.7-.3-6,.3-8.5-1.5,2.8.3,5.8.6,8.5,1.5Z" fill="#4a71d3" />
        <path
          d="M203.2,460.7c.2-.4.3-.4.5,0,.3,0,.7,0,1,0v.5c-2.8-.6-5.7-.8-8.5-1.5s-3-.7-4-1.5c3.5.9,7.4,1.8,11,2.5Z"
          fill="#e7e9f2"
        />
        <path d="M264.7,466.7c-1.4,1.1-3.8.3-5.5.5,1.4,0,3.6-.4,5.5-.5Z" fill="#5076da" />
        <path d="M271.2,466.2c-1.1.9-3.4.5-5,.5,1.2-.9,3.4-.5,5-.5Z" fill="#5076da" />
        <path d="M275.7,465.7c-.3.8-1.3.5-2,.5-.4-.1-.4-.3,0-.5.7,0,1.3,0,2,0Z" fill="#4774d4" />
        <path d="M279.2,465.2l-.5.5h-1.5c-.3-.2-.3-.3,0-.5.6,0,1.3,0,2,0Z" fill="#4774d4" />
        <path d="M210.2,463.7c-.9-.1-1.6-.4-2-.5l2,.5Z" fill="#4a71d3" />
        <path d="M207.7,463.2c-.8-.1-1.5-.4-2-.5l2,.5Z" fill="#4a71d3" />
        <path d="M199.7,461.2c-1-.2-2.3.2-3-1,1,.2,2.3.3,3,1Z" fill="#4a71d3" />
        <path d="M273.7,465.7v.5c-.5,0-1,0-1.5,0,.2-.7,1-.5,1.5-.5Z" fill="#5076da" />
        <path d="M204.2,462.2c-.7-.2-1.2-.4-1.5-.5l1.5.5Z" fill="#4a71d3" />
        <path d="M201.7,461.7c-.6-.2-1.3-.5-1.5-.5l1.5.5Z" fill="#4a71d3" />
        <path d="M205.2,462.7c-.4,0-.5-.5-.5-.5l.5.5Z" fill="#4a71d3" />
        <path d="M280.2,465.2c-.2,0-.3,0-.5,0,0-.2.3-.5.5-.5v.5Z" fill="#5076da" />
        <path d="M277.2,465.7h-.5c0-.2.3-.5.5-.5v.5Z" fill="#5076da" />
        <path
          d="M149.8,435.2c0-1,.7-.9,1,0,20.5,9.6,42.5,19,65.4,21.9l.5.6c1.5,0,2.7.2,3.5.5h.5l2.5.5c14.6,1.4,29.2,1.7,43.8.9l1.7.6c1.6-.2,3.3-.2,4.9-.1v.6c0,.3-.4.4-.9.5-.7.1-1.3.4-2,.5-2,0-4,.2-6,.5-.2,0-.3,0-.5,0-11.1.3-22.4,0-33.5-.5-9.2-1.3-17.9-2.4-27-4.5-8.5-.6-17.3-3.3-25-7-1.6.5-5.2-1.4-6.5-2.5l-.5-.5c-.1.3-.3.3-.5,0l-4.5-2c-2,0-4.7-1-6-2.5-1.2.1-2.7-.3-3-1.5l-1-.5c-.1.4-.3.4-.5,0-1.4-.7-2.7-1.5-4-2.5-.2.4-.3.4-.5,0l-.5-.5c-.9.8-1.6,0-1-1-3-1-4.5-3.8-.5-1.5Z"
          fill="#f4f7f8"
        />
        <path
          d="M361.1,430.2c-.4.2-.9,1.1-1.5,1.5-2.3,1.5-4.6,2.8-7,4l-.5.5h-.5l-.5.5c-.1,0-.4,0-.5,0l-.5.5c-.1,0-.4,0-.5,0l-.5.5c-.2,0-.4,0-.5,0l-1,1c-1.9,1-4.4,2-6.5,3l-1.5,1c-.1,0-.4,0-.5,0l-.5.5c-.1,0-.4,0-.5,0l-.5.5c-.1,0-.4,0-.5,0l-1,.5c-.1,0-.4,0-.5,0-1.2.5-2.3,1-3.5,1.5l-.5.5c-.1,0-.4,0-.5,0l-2,1c-.2,0-.3,0-.5,0l-1,.5c-.2,0-.3,0-.5,0l-.5.5c-3.6,1.3-7.3,2.8-11,4l-1.5.5c-.2,0-.3,0-.5,0-1.9.8-4,1.5-6,1.5l-.5.5c-.3,0-.7,0-1,0-.7.4-1.5.8-2.5,1-.9.4-1.7.6-2.5.5-.6.2-1.3.3-2,.5l-8,2c-2.5.4-5,.8-7.5,1l-2.5.5c-.2,0-.3,0-.5,0l-2.5.5c-.3,0-.7,0-1,0-1.1.4-2.5.4-3.5,0-1.2-1.1-3.4-.3-5-.5.6-1.2,3.9-1.2,5-.5h2c.8-.2,1.6-.3,2.5-.5,0-.4.3-.4.5,0l3-.5c0-.3.2-.5.5-.5,0-.4.3-.4.5,0l2.5-.5c1.9-1.3,5.7-1.7,8-1.5l1.5-.5c.2-.2.3-.2.5,0,1.1-.9,2.6-1.4,4-1l2-.5c.3-.7.7-.7,1,0h.5l.5-.5c0-.4.3-.4.5,0l1.5-.5c0-.5.3-.4.5,0l1.5-.5c4.7-2,10-3.9,15-5l1.4-1c12.1-4.4,23.7-10.2,34.9-16.7l1.8-.3c1.1-.4,1.4-.2,1,.5Z"
          fill="#f2f6f5"
        />
        <path
          d="M299.2,456.7c.4-.3.7-.4,1,0-3.3.6-5.2,1.5-9,2,2.5-.7,5.5-1.8,8-2Z"
          fill="#3952f4"
        />
        <path
          d="M306.2,455.2c.4,0,1,0,1,.5-1.5.4-3,.7-4.5,1s-.7,0-1,0c.4-.5,1-.9,2-1,.9-.5,1.8-.6,2.5-.5Z"
          fill="#1834fd"
        />
        <path d="M270.7,461.7c-2.4.5-3.6.4-6,.5,1.5-1.1,4.1-.3,6-.5Z" fill="#385cf0" />
        <path d="M273.7,460.7c1.1-.2,2.4.1,3.5,0-1,1-3.1.3-4.5.5,0,0,.5-.4,1-.5Z" fill="#e2e2ee" />
        <path d="M283.7,459.7c-.4.8-1.7.5-2.5.5.4-.8,1.7-.4,2.5-.5Z" fill="#e2e2ee" />
        <path d="M280.7,460.2c-.4.8-1.7.5-2.5.5.3,0,1.5-.4,2.5-.5Z" fill="#e2e2ee" />
        <path
          d="M301.2,456.2c.4.1.4.3,0,.5-.3,0-.7,0-1,0-.3,0-.7,0-1,0,.4-.8,1.4-.4,2-.5Z"
          fill="#5d3fe4"
        />
        <path
          d="M303.7,455.7c-.7.3-1.4.6-2,1-.2,0-.3,0-.5,0v-.5c.9-.2,1.5-.4,2.5-.5Z"
          fill="#3b41ee"
        />
        <path
          d="M203.7,457.7c.8.1,2.8,0,3,1l-4-.5c-.3.4-.6.3-1,0-2.7-1.6.4-1.6,2-.5Z"
          fill="#0e5bfa"
        />
        <path d="M209.2,460.2c-1.4-.1-3.1.4-4-1,1.3.2,3,.2,4,1Z" fill="#f8fbfc" />
        <path
          d="M201.7,458.2c.3,0,.7,0,1,0,.5.1,1.5.7,2,1-2.5-.4-3.8-.9-6-1.5,1-1.1,2.2-.5,3,.5Z"
          fill="#e7e9f2"
        />
        <path
          d="M406.6,389.7c-.4.4-1.3,1.5-1.5,2-1.1.9-1.6,1.6-2.5,2.5-2.1,2.1-3.9,4.4-6,6.5l-1,1c-2.1,2.1-4.5,4.3-7,6v-.5c-.1-.7.4-.8,1-1,0-.6.4-1.1,1-1.5-.7-1.6,2.8-5.1,4.5-5,3.1-3.7,6.4-7.3,9.8-10.6l1.2-.4c1.3-1,1.3-.2.5,1Z"
          fill="#020350"
        />
        <path
          d="M388.6,407.7c0,.2,0,.4,0,.5-1.7,1.3-3.1,2.4-4.5,4l-1.5.5c-.5-.6.3-1.4,1-1.5,1.4-1.9,3.1-3.2,5-4v.5Z"
          fill="#03033e"
        />
        <path d="M396.1,401.7h-.5c.3-.3.7-.7,1-1-.1.3-.4.7-.5,1Z" fill="#186bf5" />
        <path
          d="M372.6,422.2l-5.5,4.5c-1.7.9-4.4,2.5-6,3.5l-1-.5c2.9-3.3,7.4-6.1,11.5-8,0-.5.2-.4.5,0,.8-.8,1.1-.5.5.5Z"
          fill="#dbe4f1"
        />
        <path d="M359.6,431.7c-2.3,1.5-4.5,3.2-7,4.5v-.5c2.3-1.4,4.5-3,7-4Z" fill="#2945e3" />
        <path d="M352.7,436.2c-.1,0-.3,0-.5,0,.2-.1.3-.4.5-.5v.5Z" fill="#2b59e6" />
        <path d="M351.7,436.7c-.1,0-.4,0-.5,0,0-.6.2-.4.5-.5v.5Z" fill="#2b59e6" />
        <path d="M351.7,436.7v-.5c.1,0,.4,0,.5,0-.1,0-.3.4-.5.5Z" fill="#2945e3" />
        <path
          d="M374.1,420.7c-.1.3-.4.7-.5,1-.2,0-.7.4-1,.5,0-.3-.2-.5-.5-.5-.7-.7-.5-1.2.5-1,.2-.3.3-.3.5,0,.2-.4.8-.4,1,0Z"
          fill="#b4cddf"
        />
        <path d="M374.1,420.2c0,.1,0,.3,0,.5-.3,0-.7,0-1,0-.4-.1-.4-.3,0-.5h1Z" fill="#508ebd" />
        <path d="M337.2,443.7l-1,.5c.2,0,.6-.3,1-.5Z" fill="#2b55ec" />
        <path d="M339.7,442.7c.3-.1.8-.7,1.5-1-.2.7-.8,1-1.5,1Z" fill="#2b55ec" />
        <path d="M350.2,437.2l.5-.5c-.2,0-.3.4-.5.5Z" fill="#2b59e6" />
        <path d="M349.2,437.7c.1-.2.3-.4.5-.5-.1.2-.3.4-.5.5Z" fill="#2b59e6" />
        <path d="M347.7,438.7c0,0,.4-.6,1-1l-1,1Z" fill="#2b59e6" />
        <path d="M338.7,443.2s.2-.3.5-.5l-.5.5Z" fill="#2b55ec" />
        <path d="M337.7,443.7c0,0,.2-.4.5-.5l-.5.5Z" fill="#2b55ec" />
        <path d="M315.7,452.2l-1.5.5c.5-.1,1-.3,1.5-.5Z" fill="#3850ee" />
        <path d="M328.7,447.2c-.2,0-.6.4-1,.5l1-.5Z" fill="#355cf1" />
        <path d="M331.2,446.2c-.3.2-.7.9-1,1s-.7,0-1,0c.5-.9,1.3-.7,2-1Z" fill="#355cf1" />
        <path d="M326.7,448.2s.2-.4.5-.5l-.5.5Z" fill="#355cf1" />
        <path d="M331.7,446.2c.1,0,.3-.4.5-.5l-.5.5Z" fill="#355cf1" />
        <path d="M405.1,392.7c0,0-1.1,1.7-1,.7l1-1.2v.5Z" fill="#8eb9e6" />
        <path
          d="M62.8,144.8c.7-1.2,2.1-.6,1.8.2-1.6,3.6-4.7,8.9-6.7,12.4s-.6.6-1,.8l-.5.5c1,0,.9.7,0,1-1.9,4.1-3.8,8.2-5.5,12.5.4.2.4.3,0,.5l-.5.5c.4.2.4.3,0,.5l-.5.5c.4.1.4.3,0,.5l-.5.5c.9,0,.9.7,0,1l-.5.5c.4.1.4.3,0,.5-.6,1.8-1.1,3.6-1.5,5.5-.2,2.8-1,6.1-2.5,8.5-3,10.5-5.2,21.1-6.5,32l-1,7c-.2,2.9-.4,5.7-.5,8.5.4.3.4.7,0,1,.4.2.3.6,0,1,.4.2.3.6,0,1-.6,1.3-.9,3.6-1,5-.2.9-.9,1.3-1.5.6s-.6-7.8-.6-9.1c.2-13,2.1-26.6,6.1-39,.5-2.6.9-5.4,1.5-8,2.6-5.1,4.3-10.6,6.4-15.8,3.3-8.2,6.7-15.8,11.1-23.6-.5-2.4,1.8-6.1,4-7Z"
          fill="#7ea6fc"
        />
        <path
          d="M39.8,199.3c-2.8,13.5-7.3,32.1-5,45.8s-.6,2,1,1.7c-.3,4.8-1,10.4-1,15,0-2.1-.7-4.1-1-6,1.2-3.3-.3-7.4-.5-10.7-.6-12.3,1.4-30.8,4.9-42.6.3-1.1.5-2.6,1.6-3.1Z"
          fill="#759ffe"
        />
        <path
          d="M67.8,133.3c.5.4,1.3.4,2.5,0,.2.4.3.8.1,1.1-1.9,3.5-4.6,8.2-7.6,10.4-1.4,2.3-2.8,4.8-4,7-.7-.6-1.8-.3-1.5-1.5.9-1.6,1.9-3.2,2.9-4.8,2.5-4.1,4.5-8.5,7.6-12.1Z"
          fill="#739cf5"
        />
        <path
          d="M73.8,130.8c-.1.4-.3.4-.5,0-.9.7-1.6,1.6-2.2,2.6h-.8c0-.1-.6-1.2-.6-1.2l3.1-6c.4-1.4,1.2-2.3,2-3.5s2.7-3.3,4-4.5c-1.1,2.6-2.1,5.8-2.8,8.4s-1.5,2.6-2.2,4.1Z"
          fill="#7990ef"
        />
        <path
          d="M70.3,133.3c-1.6,1.6-2.9,3.4-4.5,5l2-5c1.2-2.4,2.9-5.2,5-7-1,3.3-.5,3.5-2.5,7Z"
          fill="#7292f5"
        />
        <path d="M78.3,112.9l.5-.5c-.2.2-.4.3-.5.5Z" fill="#6da5fc" />
        <path d="M81.8,108.9c-.8.7-1.6,1.4-2.5,2,.9-1,1.8-1.7,2.5-2.5v.5Z" fill="#699ef9" />
        <path
          d="M61.8,349.2c.3.2.3.3,0,.5,1,1.6,2,3.3,3,5,1.1-.7,1.4-.2,1,1l1,1.6c.7.2,1.2,1.2,1.5,2.9.7,1.4,1.5,2.8,2.5,4,1-.3,2,1,1.3,1.8l2.2,3.7c1.2,0,2.1,1.4,1.5,2.5l1.5,1.5c.4.2.4.3,0,.5,2.6,1.6,5.2,4.9,5.5,8l.5,1.5c0,.1-1.2-.8-1.5-1-1.6-1.2-4.7-5.3-6-7-4-5.5-7.6-12.1-11-18-3.1-5.2-5.8-10.6-8.2-16.2l.7-.5c1.5,2.7,3,5.4,4.5,8.2Z"
          fill="#f1f9fb"
        />
        <path
          d="M51.8,326.7c.4.1.4.3,0,.5l1.5,3c1.3-.2,1.8.5,1,1.5,1.2,3.2,2.6,6.3,4.2,9.3l-.2.7c1.3,2.1,2.5,4.4,3.5,7,.3.2.3.3,0,.5-1.9-1.6-2.5-4.5-3.6-6.6s-.9-1.6-.9-.1l7.5,15.3c-1.8-3.2-4.3-6.6-6-10s-4.8-10.9-6.5-16c-1.4-2.9-3.9-11-.5-5Z"
          fill="#e6f5fb"
        />
        <path
          d="M46.8,312.8c.4.2.4.3,0,.5l.5,1c1.4,0,1.5.7.5,1.5,1.5,0,2.8,2.4,1.5,3.5,1.1.1,1.1.8,0,1,1.5,0,2,.8,1,2,1.6,1.8,2.1,3.3,1.5,4.5,0-.2-1.7-3.2-1.5-1.3.8,2,1.3,4.2,2,6.3l-4.5-10c-.7-2.5-1.4-5-2-7.5l-.5-4.5,1.5,3Z"
          fill="#d5eafb"
        />
        <path d="M44.3,308.8l-.5-1.5c0,.1.4.9.5,1.5Z" fill="#bcdafb" />
        <path
          d="M42.3,201.3c-.6,5.3-1.4,10.7-2.5,16,0,.4.2.8.2,1.3-.2,5.3-.4,10.6-.7,15.8s-.5,1.7-1,2.4l-.5,25c-.1-1.9-.4-3.9-.5-6s0-1,0-1.5c-.5-3.1-.4-6.3,0-9.5,0-.2,0-.3,0-.5-.3-1.3-.3-2.5,0-3.5-.4-.1-.3-.8,0-1-.4-.1-.3-.8,0-1-.4-1.4-.5-3.1,0-4.5.1-3.7.4-7.3,1-11,1.2-10.9,2.5-21.7,6.5-32,0,3.1-1.1,7.1-2.5,10Z"
          fill="#7585e5"
        />
        <path d="M37.3,254.3c-.8-2.7-.8-6.8,0-9.5,0,3.2-.1,6.3,0,9.5Z" fill="#7c94ed" />
        <path d="M37.3,244.3c0-.2-.5-1.4-.5-2.5s0-.7,0-1c.1-.4.3-.4.5,0v3.5Z" fill="#7c94ed" />
        <path
          d="M41.3,213.3c1.3.7.5,4.7-1,4.7.4,0,.9.2,1,.4.1,2.6-.4,6.7-1,9.1.6,1.7.3,4.4,0,6.2,0,1.7,0,6.2-2,6,0-1,0-2,0-3,.2-6.5.4-13,1.5-19.5.1-2.2.6-4.2,1.5-6,.3.5.3,1.2,0,2Z"
          fill="#3e47c5"
        />
        <path
          d="M40.3,241.8c-.2,2.4-.4,4.7-.5,7,0,.8-.7,1.3-1.5,1,0-3.3,0-6.7,0-10,1-1.7,1.8-4.1,2-6,.1-.4.3-.4.5,0,.8,2.3.6,4.9-.5,8Z"
          fill="#374fd5"
        />
        <path
          d="M39.8,248.8c.4,5.7.4,11.3,0,17-.1.4-.3.4-.5,0,0-.2,0-.3,0-.5-.4-.8-.4-1.7,0-2.5-.5-4.7-.9-8.1-1-13,.4-.6.7-1.2,1.5-1Z"
          fill="#334ee0"
        />
        <path
          d="M40.3,242.3c.8.8.8,2.2,0,3,.4,1.6.4,3.1,0,4.5.6,4.5.6,9,0,13.5.4,1.8.4,3.7,0,5.5-.1.4-.3.4-.5,0,0-.7,0-1.3,0-2-.3-.4-.3-.7,0-1,0-5.7,0-11.3,0-17s-.4-5.1.5-7v.5Z"
          fill="#3160e8"
        />
        <path
          d="M41.3,260.3c.2,1.4.3,2.9.5,4.5.2-.3.4-.1.5.5.7.3.7.7,0,1,.4,1.5.4,3,0,4.5.3.1.3.3,0,.5l-.5,1.5c-.6-.6-.9-1.8-1-3.5,0-.2,0-.3,0-.5-.4-1.8-.4-3.7,0-5.5-.3-1.2-.6-5.4,0-6.5s.3,0,.6,0c.4,1.1.4,2.5,0,3.5Z"
          fill="#63aef7"
        />
        <path d="M41.8,272.8c.9,1.6.5,3.3,0,5h-.5c0-2.8-.4-5.6-.5-8.5l1,3.5Z" fill="#3d7ff3" />
        <path
          d="M40.8,268.8h-.5c0-1.8,0-3.7,0-5.5.1-.4.3-.4.5,0,0,1.8,0,3.7,0,5.5Z"
          fill="#3d7ff3"
        />
        <path d="M40.3,268.8c0,.7.2,3.5-.2,3.5-.5-1-.2-2.4-.2-3.5h.5Z" fill="#374fd5" />
        <path d="M39.3,265.3c-.8-.3-.8-2.2,0-2.5,0,.8,0,1.7,0,2.5Z" fill="#374fd5" />
        <path d="M39.8,266.8c-.5-.2-.5-.6-.5-1h.5c0,.3,0,.7,0,1Z" fill="#374fd5" />
        <path
          d="M46.3,302.3c1.3-.2,1.7,2.1,1,3l.5,1.5c.4.1.4.3,0,.5l.5,1.5c.4.1.4.3,0,.5.8,1.9,1.1,3.5,1,5,.7,2.1.2,3.6-1.5,1.5-.2-.5-.3-1-.5-1.5l-.5-1c0-.1,0-.4,0-.5-.1-1-.4-2-.5-3-.3-2.2-.9-4.4-1-6.5s0-1.7,0-2.5h.5c0,.6.3,1,.5,1.5Z"
          fill="#2868f2"
        />
        <path
          d="M48.3,303.3c.8.4,1,1.3,0,1.5l.5,1.5c.4.2.4.3,0,.5l.5,1.5c.4.2.4.3,0,.5l.5,1.5c.4.2.4.3,0,.5.5.8.8,1.6.5,2.5.4.1.3.7,0,1-1-1.1-1.6-2.8-2-5,0-.2,0-.3,0-.5l-.5-1.5c0-.2,0-.3,0-.5l-.5-1.5c-.4-1.1-.5-1.8-1-3,.4-1.4-.8-3-1-4-.4-.8-.4-1.5,0-2,0-.4.3-.6.5-.5.1-.4.3-.4.5,0l.7.4c.5,2.4.9,4.7,1.3,7.1Z"
          fill="#acdff5"
        />
        <path
          d="M43.8,283.8l.5,2c1,0,1.2.8.5,1.5.7,2.1,1.2,4.3,1.6,6.5l-.6.5v.5l-.5,1c-.5-.1-.8-.8-1-2,0-.3,0-.7,0-1l-.5-2c0-.8,0-1.7,0-2.5l-.5-2c0-.3,0-.7,0-1-.4-.9-.6-2.3.5-2,.4.1.4.3,0,.5Z"
          fill="#a0d6f3"
        />
        <path
          d="M42.8,276.3c.2.8.3,1.6.5,2.5,1,.5,1,1,0,1.5l.5,2c1,.1.9.6,0,1-.7.3-.5,1.3-.5,2-.9-.6-.5-2.1-.5-3l-.5-3c0-.3,0-.7,0-1-.4-.8-.6-2.7.5-2.5.3.1.3.3,0,.5Z"
          fill="#87cef2"
        />
        <path
          d="M42.8,273.8c.4.6.4,1.3,0,2-.8.4-.5,1.7-.5,2.5l-.5-.5c0-1.7,0-3.3,0-5s-.1-1.3.5-1.5c.2.8.3,1.6.5,2.5Z"
          fill="#6cbdf2"
        />
        <path d="M42.8,282.3c-.8-.5-.5-2.1-.5-3,.9.6.5,2.1.5,3Z" fill="#6cbdf2" />
        <path
          d="M45.3,295.8c.3.1.3.3,0,.5,0,.6,0,1.4,0,2-.9-1.2-.8-3.1-1-4.5l1,2Z"
          fill="#3c6ef1"
        />
        <path d="M44.3,292.8c0-.3-.4-1.1-.5-2l.5,2Z" fill="#3c6ef1" />
        <path d="M43.8,288.3c0-.1-.4-1-.5-2l.5,2Z" fill="#87cef2" />
        <path d="M44.8,298.8c.2.4.8.6.5,1.5l-.5-.5c0-.3,0-.7,0-1Z" fill="#2868f2" />
        <path d="M45.3,307.3l-.5-1.5c.2.5.3.9.5,1.5Z" fill="#bcdafb" />
        <path d="M282.2,470.2l.5-.5c-.1,0-.4.5-.5.5Z" fill="#2b67c6" />
        <path d="M260.2,472.7v-.5c.2,0,.3,0,.5,0,0,.2-.3.5-.5.5Z" fill="#589be4" />
        <path d="M192.3,460.2l-.3.5c-.6.3-.6-.4-.7-.5.3,0,.7,0,1,0Z" fill="#3067c8" />
        <path
          d="M203.7,457.2v.5c-.8-.1-1.7-.4-2.5-.5l.5,1c-1-.2-2-.3-3-.5-7-1.8-13.8-4-20.5-6.5-1.2-.7-.8-1.3.5-1,8.1,2.7,16.7,5.1,25,7Z"
          fill="#2c53f7"
        />
        <path
          d="M142.3,432.7c1.6-1,4.6,1.3,5.4,2.6l2.6,1.4c.4.3.7.8,1,1l.5.5c.1,0,.4,0,.5,0,1.3.7,2.3,1.6,3,2.5-1.7-.4-3.4-1.1-5-2-3.3-1.5-6.4-3.6-9.5-5.5-.7-.4-1.2-.9-1.5-1.5-.2-.2-.2-.3,0-.5,1,.2,2,.7,3,1.5Z"
          fill="#2644e5"
        />
        <path
          d="M137.3,429.2l1,1c.2-.4.3-.4.5,0,.5.4.7.7.5,1v.5c-1.4-.5-2.7-1.2-4-2-1.9-1.2-5.8-3.2-7-5-.7-.4-1.3-1.1-.5-1.5v-.5c3.7,1.1,7.2,3.3,9.5,6.5Z"
          fill="#2634e6"
        />
        <path
          d="M166.8,445.2l4.5,2c.1,0,.3,0,.5,0,.2.2.2.3,0,.5,0,.7-.6.5-1,0-.1.4-.6.2-1,0-.2,0-.3,0-.5,0l-4-2c-2.1-.8-4-1.5-6-2.5-.4-.8,0-.9,1.5-.5,2,.9,4,1.6,6,2.5Z"
          fill="#344af2"
        />
        <path
          d="M171.8,447.7c.2-.2.3-.2.5,0,3.1.6,4.3,1.8,6.5,2.5l-.5,1c-2.5-.9-5-1.9-7.5-3-.4-.1-.4-.3,0-.5.3,0,.7,0,1,0Z"
          fill="#2e50f1"
        />
        <path
          d="M156.3,440.7c.2,0,.3,0,.5,0l1,.5c1.6.4,2,1.1,3,1.5l-1.5.5c-1.1-.5-1.9-.8-3-1.5-.5-.2-.9-.6-1-1,.1-.4.5-.4,1,0Z"
          fill="#3148e3"
        />
        <path
          d="M122.3,420.7c.7.3,3.4,1.1,3.5,1.2.4.3-.5,2.3,2,1.3.3.4.3,1.2.5,1.5h-.5l-.5-.5c-1.8-.9-3.7-1.8-5-3.5Z"
          fill="#1322d3"
        />
        <path d="M139.3,431.7c.6.4,1.2,1.3,1.5,1.5l-5.5-3.5c.9.6,2.8,1.2,4,2Z" fill="#3053e5" />
        <path d="M209.2,461.7c-1.1,0-1.4-.5-1.5-.5l1.5.5Z" fill="#f8fbfc" />
        <path d="M170.8,447.7v.5c-.3-.1-.8,0-1-.5.3,0,.7,0,1,0Z" fill="#3851e6" />
        <path d="M169.3,447.7c-1.4-.3-2.9-1-4-2,1.4.5,2.9.8,4,2Z" fill="#3851e6" />
        <path d="M203.7,460.7c-.2,0-.3,0-.5,0-.2-1.4.7-1.4.5,0Z" fill="#f8fbfc" />
        <path
          d="M156.3,440.7c-.3,0-.7,0-1,0,.3.2.5.7,1,1l-6-3c1.5.7,3.5,1.6,5,2-1-.8-2.1-1.5-3-2.5,1.3.8,3,1.2,4,2.5Z"
          fill="#374fed"
        />
        <path d="M127.8,424.7c-.3,0-.4-.5-.5-.5l.5.5Z" fill="#2634e6" />
        <path
          d="M122.8,417.2c.2.4.2.7,0,1-.2-.2-1.3-.6-2-1v-1.5c.6.5,1.3.9,2,1.5Z"
          fill="#1e39e4"
        />
        <path
          d="M128.3,421.2l.5.5c4.8,2.5,10.2,6.6,15,9.5,2,.4,5.6,2.1,6,4-.5-.2-1.7-.9-2-.3,1,.5,1.6,1.1,2.5,1.8-2.9-.7-5.3-2.6-8-4-1.3-.7-2.5-1.5-3.5-2.5-.1,0-.4,0-.5,0l-1-1c-3.2-2.1-6.3-4.3-9.5-6.5s-.3-.4-.5-.5c-.2-.2-.2-.3,0-.5-.8-.8-.5-1.1.5-.5,0,0,.4,0,.5,0Z"
          fill="#eff1f4"
        />
        <path
          d="M125.3,419.2c.7.7.4,1-.5.5l-1.5-1c-.2-.1-.3-.3-.5-.5l-.5-.8.5-.2c.8.6,1.7,1.4,2.5,2Z"
          fill="#3e69d9"
        />
        <path
          d="M124.8,419.7c1,0,2.5.9,2.5,2v.5c-1.7-1.2-2.8-2.6-4-3.5.5.3,1,.6,1.5,1Z"
          fill="#1322d3"
        />
        <path
          d="M84.3,380.7c1.6,0,4.3,3.6,4,5l.5.5c.4.1.4.3,0,.5-.1,0,.4,1.9-1.5.5-1.4-1.7-3.2-3.3-4.5-5-1.9-2.5-3.7-5.3-5.5-8,.2-.8-.3-2-1.5-3.4l.5-.6c3.2,3,5.9,6.5,8,10.5Z"
          fill="#2b68f6"
        />
        <path
          d="M127.8,421.2c-.3,0-.5,0-.5.5-.9-.6-1.6-1.3-2.5-2l.5-.5c.8.6,2.1.7,2.5,2Z"
          fill="#7389d2"
        />
        <path d="M128.8,421.7l-.5-.5c.4.1.5.5.5.5Z" fill="#7389d2" />
        <path
          d="M66.8,348.2c.4.1.4.3,0,.5,1,.6,1.3,1.1,1,1.5l1,1.5c.4.2.4.3,0,.5l.5.5c.4.1.4.3,0,.5l.5.5c.4.1.4.3,0,.5l.5.5c1.8,1.7,3.2,4.2,4,6.5,2.4,2.2,4.4,5.4,5.5,8.5,3.1,2.3,5.8,5.9,7,9.5l.5.5c.4.1.4.3,0,.5,0,0-.5.2-1.5-.5-.1.4-.3.4-.5,0-1.6-1.6-3.1-3.2-4.6-4.8,0-1.3-.7-2.5-1.9-3.7-.4-.1-.4-.3,0-.5l-1-1c-.4-.1-.4-.3,0-.5l-.5-.5c-.4,0-.7-.2-1-.4-1.3-.8-9.1-14.3-10.1-16.6s0-.6,0-1c-.4-.1-.4-.3,0-.5l-.5-.5c-.4-.2-.4-.3,0-.5-.2-.1-.2-.3,0-.5-.3-.2-.3-.3,0-.5-.7-.8-.4-1.1.5-.5l.5.5Z"
          fill="#090a46"
        />
        <path
          d="M85.3,379.7c.1,0,.4,0,.5,0,1.7,2.5,3.6,5.2,5.5,7.5l2,2.5c1,1.4.3,1.5-1,.5-.7-.5-1.2-1.2-1.5-2-.3-.3-1.9-1.6-2-1.5v-.5l-.5-.5c-1.2-1.6-3-3.4-4-5-2.8-4.1-2.1-5.2,1-1Z"
          fill="#dceef7"
        />
        <path
          d="M95.8,392.2c.3.4.9,1.2.3,1.5-.6-.8-1.5-1.3-2.3-2s-1-1-1.5-1.5c.5.2,1,0,1-.5.7.7,1.7,1.8,2.5,2.5Z"
          fill="#7bb7f3"
        />
        <path d="M93.3,389.7c-1-1-1.3-1.6-2-2.5.7.3,2,1.9,2,2.5Z" fill="#b5d6f5" />
        <path d="M92.3,390.2c-.6-.6-1.6-.7-1.5-2,.5.5,1.4,1.9,1.5,2Z" fill="#b5d6f5" />
        <path
          d="M97.3,104.9c-.7,2-2.6,5.4-5,5.5,0,.3.1.6,0,.9-.1.6-6.3,8.1-7.3,9.3s-.4.2-.7.3c-.1,1.1-1.5,3-2.5,3-.4.4-1.3.1-1.2,0,.7-1.6,2.2-4,3.2-5.5.9-1.8,2.5-3.9,4-5,3.4-2.8,5.9-6.4,9-9.5l.5-.5c.2-.2.8-.3,1-.5,1.6-.4-.1,1.2-1,2Z"
          fill="#313ca9"
        />
        <path
          d="M109.8,92.9c1.1.7.7,1.4-.5,1-.8,2.2-3.9,4.4-6.1,5.9s-.6.2-.9.1c-.7.7-1,.4-.5-.5.5-.4.9-.9,1.5-1.5,2.2-1.9,4.2-3.4,6.5-5Z"
          fill="#384bb2"
        />
        <path
          d="M91.3,107.9c-.6.8-1,1.8-1.5,2.5s-1.3,2-2,3c-1.2,1.8-3,3.4-4,5-.2.2-.3.2-.5,0,1.3-1.9,2.9-3.7,4-5.7s.6-4.8,4-4.7Z"
          fill="#6a79d9"
        />
        <path
          d="M102.3,99.9c.2.9-1.1,2.2-2,2-.7.7-1,.4-.5-.5.7-.6,1.2-1.3,2-2l.5.5Z"
          fill="#2b39a5"
        />
        <path
          d="M100.3,101.9c0,1.2-1.8,3.3-3,3,.5-.6.9-1.3,1.5-1.8l-.5-.2c.5-.5,1-1,1.5-1.5l.5.5Z"
          fill="#3248b1"
        />
        <path d="M96.8,103.9c.2-.2.3-.3.5-.5l-.5.5Z" fill="#3248b1" />
        <path
          d="M150.3,63.4l-.5.5c-.1.4-.3.4-.5,0l-.5.5c-.1.4-.3.4-.5,0l-.5.5c-.1.4-.3.4-.5,0l-.5.5c-.1.4-.3.4-.5,0l-3.5,2.5c-.1.4-.3.4-.5,0l-.5.5-.5.5c-.1.4-.3.4-.5,0l-.5.5h-.5c0,.3-.1.5-.5.5h-.5l-.5.5h-.5l-2.5,2c-.1.4-.3.4-.5,0l-1,1c-.1.4-.3.4-.5,0-.3.3-.6.6-1,.5l-1,1h-.5c-.1.3-.3.3-.5,0,.1-.9.8-1.7,2-2.5,1.5-1,3-2,4.5-3,4.5-1.5,7.9-5,12.5-6.3s.9.3,1,.3Z"
          fill="#414ab1"
        />
        <path
          d="M132.3,72.4c-.6.9-1.3,1.7-2,2.5.3.3,0,.9-.5,1l-1,1c-.2.4-.3.4-.5,0l-.5.5c-.4,1.7-4.2,4.1-6,4-2.9,1.2,1.3-2.3,2-3.5,2.7-2,5.7-3.6,8.5-5.5Z"
          fill="#4549b1"
        />
        <path
          d="M137.8,71.9c-.6.7-1.2,1.4-2,2-.2.4-.3.4-.5,0l-.5.5h-.5c-2,1.8-4.2,3.5-6.5,5h-.5c-1.4,1.2-2.9,2.4-4.5,3.5l-.5.5c-.1.5-.3.4-.5,0-2.2,2.1-2.7.7-.5-1,.2-.3.3-.8.5-1,1.2-1.3,4.5-2.9,6-4l.5-.5c.1,0,.4,0,.5,0l1-1c.2-.3.3-.3.5,0,.3-.5.6-.8,1-1l1-.5,1-1c.1,0,.4,0,.5,0l1-1c.1,0,.4,0,.5,0l2.5-2c.1,0,.4,0,.5,0,.5.2.3.7-.5,1.5Z"
          fill="#6b86df"
        />
        <path
          d="M118.8,85.9c.4,1.7-3,4.3-4.5,3.5-.8.3-1.3.5-1-.5,1.5-1.2,3-2.3,4.5-3.5.9-.5,1.2-.6,1,.5Z"
          fill="#6f85dc"
        />
        <path
          d="M121.3,82.4c-.2.3-1.1,1.4-1,1.5.7.2,1-.3,1.5-.5,1.1,1.5-1.6,3.5-3,2.5l-1-.5c1.1-.9,2.2-2.2,3.5-3Z"
          fill="#657cd9"
        />
        <path
          d="M114.3,89.4c.3,1.6-1,2.4-2.5,2-.2.4-.3.4-.5,0l-.5-.5c.8-.6,1.7-1.3,2.5-2l1,.5Z"
          fill="#6578d6"
        />
        <path
          d="M111.8,91.4c2-1,2.8,0,1,1.5.7,1,.1,1.5-1,1-1.4,1.1-4.3,2.8-2.5,0,.3-.3.5-.5.5-1,.7-.5,1.4-1.4,1.5-1.5s.3,0,.5,0Z"
          fill="#3769df"
        />
        <path
          d="M169.8,54.4l.2.6-8.6,3.6c-.5.2,7.8-3.7,8-2.8-1.7,1.6-4.7,3-7,3.5-.7.7-2.3,1.7-3,1l-2.5,1.5c-.2.4-.3.4-.5,0l-2,1.5c-.2.4-.3.4-.5,0-3.4,2-6.9,3.8-10.5,5.5l-.5.5h-.5l-.5.5h-.5l-.5.5c-.2.4-.6.6-1,.5,0,.3-.1.5-.5.5h-.5l-.5.5c-.2.2-.3.2-.5,0l-.5-.2c.5-.3.7-.9,1-1.3h.5l.5-.5h.5c0-.3.2-.5.5-.5l.5-.5c.1,0,.4,0,.5,0l.5-.5.5-.5c.1,0,.4,0,.5,0l3.5-2.5c.1,0,.4,0,.5,0l.5-.5c.1,0,.4,0,.5,0l.5-.5c.1,0,.4,0,.5,0l.5-.5c.1,0,.4,0,.5,0l.5-.5c.2,0,.3,0,.5,0l1-1c.2,0,.4,0,.5,0l.5-.5c.1,0,.4,0,.5,0l.5-.5c.2,0,.4,0,.5,0,1.6-.7,3.1-1.5,4.5-2.5,3.5-1.7,7.2-3.8,11-4.5Z"
          fill="#7793e1"
        />
        <path d="M154.3,61.4c1.3-1.1,3-1.7,4.5-2.5-.9,1.4-2.9,2-4.5,2.5Z" fill="#6082df" />
        <path d="M153.3,61.9v-.5c.2,0,.3,0,.5,0-.1.2-.3.4-.5.5Z" fill="#6082df" />
        <path d="M150.8,63.4l.5-1c.2,0,.3,0,.5,0-.2.5-.5.9-1,1Z" fill="#6082df" />
        <path d="M152.3,62.4c.1-.2.3-.4.5-.5,0,.2-.3.4-.5.5Z" fill="#6082df" />
        <path
          d="M78.3,125.9c1.6-3.4,4.8-2.5,1.5.5.3.1.3.3,0,.5l-2,2.5c0,1.2-.6,2.6-2,4,.4,1.4-.4,1.9-1.5,1-.2.2-.3.2-.5,0-.9.5-1.2.6-1-.5-.6-.6.3-2.1,1-2.5,1.8-1.6,2.8-3.8,4.5-5.5Z"
          fill="#393eac"
        />
        <path
          d="M73.8,131.3c-.4.7-.6,1.8-1,2.5.6.5.3.8-.5.5l-.5.5c-1.1,3.2-3,6.3-5.5,8.5-.2.3-.3.3-.5,0,1-4.5,4.5-8.9,7.5-12.5h.5c0,.1,0,.4,0,.5Z"
          fill="#798ce2"
        />
        <path
          d="M81.8,123.9c.6.6-.4,1.6-1,2,.1.5,0,.7-.5.5-.1.4-.3.4-.5,0,.4-.7,1.2-1.1,1-2-1.5,0-1.5.5-2.5,1.5,0-.6.3-1,.5-1.5,2.1-1.5,3.1-4,4.5-6h.5c-1,1.5-1.4,3.7-2.5,5.3l.5.2Z"
          fill="#3d47b6"
        />
        <path d="M91.3,107.4l.5-.5c-.1.2-.4.3-.5.5Z" fill="#6a79d9" />
        <path
          d="M239.7,38.4c2.6-.4,5.4-.5,8,0,2.3-.4,4.7-.4,7,0,1.5-.4,3-.4,4.5,0,2,.2,4,.4,6,.5.1-.3.3-.3.5,0,1,.7.6,1-1,1-.4.6-1,.5-1.5,0h-1.5c-1.3.5-3.1.4-4.5,0-1.2-.5-2.3-.7-3.5-.5-.5.7-1,.7-1.5,0-.1.2-.3.2-.5,0-2.4.5-4.9.5-7.5,0l-2.5.5c-2.5.5-5.7.8-8,0-.5,0-.6-.2-.5-.5-.4-.1-.4-.3,0-.5.7-.3,1.5-.5,2.5-.5,1.3,0,2.7,0,4,0Z"
          fill="#a5baed"
        />
        <path
          d="M263.2,37.9c.4.1.4.3,0,.5-1.3.5-2.7.3-4,0-1.5,0-3,0-4.5,0-.4-.1-.4-.3,0-.5,2.8,0,5.7,0,8.5,0Z"
          fill="#434ab9"
        />
        <path d="M247.7,37.9c.4.1.4.3,0,.5-2.7,0-5.3,0-8,0,2.2-.9,5.5-.5,8-.5Z" fill="#5f60c9" />
        <path d="M254.7,37.9v.5c-2.3,0-4.7,0-7,0v-.5c2.3,0,4.7,0,7,0Z" fill="#9fb1ea" />
        <path
          d="M263.2,38.4c.5-.4,1-.3,1.5,0,.2,0,.3,0,.5,0,.4.1.4.3,0,.5-1.9,0-4.5.4-6-.5,1.3,0,2.7,0,4,0Z"
          fill="#9fb1ea"
        />
        <path
          d="M235.7,38.4c-.3,0-1.5.4-2.5.5-.7.4-1.8.3-2.5,0v-.5c1.7,0,3.3,0,5,0Z"
          fill="#5f60c9"
        />
        <path
          d="M268.7,38.9c.5,0,1,0,1.5,0v.5c0,1.1-4.4.9-4-.5.8-.5,1.7-.3,2.5,0Z"
          fill="#9fb1ea"
        />
        <path
          d="M268.7,38.9c-.8,0-1.7,0-2.5,0,0,.4-.3.4-.5,0-.2,0-.3,0-.5,0v-.5c1.1,0,2.8-.4,3.5.5Z"
          fill="#3840bd"
        />
        <path d="M264.7,38.4c-.5,0-1,0-1.5,0v-.5c.5,0,1.3-.1,1.5.5Z" fill="#3840bd" />
        <path
          d="M228.2,39.4c1.5-.5,3.6-.5,5,0,.2,0,.4.3.5.5l-.2.5-4.8.5c-2.3,1.1-5.8,1.6-8.5,1.5-1,.4-2.8.7-3.5,0-1,.3-5.4,1.3-4.9-.4l4.9-1.1c2.5-.6,4.9-.7,7.5-1,.9-.4,1.9-.5,3-.5.3,0,.7,0,1,0Z"
          fill="#aabeee"
        />
        <path
          d="M230.7,38.9c.8,0,1.7,0,2.5,0v.5c-1.5-.1-3.5,0-5,0,.4-.8,1.7-.5,2.5-.5Z"
          fill="#9fafec"
        />
        <path d="M227.2,39.4c-.6,0-2,.4-3,.5.6-.9,2.1-.4,3-.5Z" fill="#9fafec" />
        <path
          d="M215.7,40.9c.3,0,.7,0,1,0-1.4.3-2.9,1.3-4.5,1.2,0,.4,3.8.3,4.5.2-1.3,1.6-5,2-7,1.5-2.3.7-4.5.9-6.5.5-.4-.1-.4-.3,0-.5,1.1-.3,2.3-.7,3.5-1,3-.5,6-1.5,9-2Z"
          fill="#90a1e1"
        />
        <path
          d="M283.2,40.9c2.5,0,5,.9,7.5,1,1.9-.1,4.6.3,6,1.5,3.3,1,6.6,1.9,10,2.5l1.5.5c.2,0,.3,0,.5,0,.5.1,5.7,2.3,4,2.4s-5.4-1.3-7-1.9c-3.3-.5-6.7-1.2-10-2-1.4.6-5.1,0-6.5-.8-6.5-.9-12.8-1.9-19-3.2,4.2-.6,8.6-.6,13,0Z"
          fill="#98aee2"
        />
        <path
          d="M270.2,39.4c.3,0,.7,0,1,0l3.5.5c2,0,3.1.2,5,.5l3,.5h.5c-4.2,0-8.6,0-13,0,0,.4-.3.4-.5,0-1.2-.2-2.4-.4-3.5-.5l-1-.5c-.2.4-.3.4-.5,0l1-1c.2,0,.3,0,.5,0,.8.9,2.7.5,4,.5Z"
          fill="#a4bbe8"
        />
        <path
          d="M291.2,40.9l1,.5c4.1.8,8,1.6,12,2.5-1.1-.1-1.1,0-1,1-2.2,0-4.4-.7-6.5-1.5-2-.5-4-.9-6-1.5s-1.1-.8-2-.5c0-.2.5-.4.5-.5.7,0,1.3,0,2,0Z"
          fill="#363ebc"
        />
        <path d="M274.7,39.9c-1.1,0-2.8.4-3.5-.5,1.1,0,2.8-.4,3.5.5Z" fill="#9fb1ea" />
        <path d="M282.7,40.9c-1.2.5-2.3-.4-3-.5.9,0,2.4-.4,3,.5Z" fill="#98aee2" />
        <path d="M292.2,41.4c-.4,0-.8,0-1-.5.4,0,.9,0,1,.5Z" fill="#3840bd" />
        <path
          d="M317.2,48.4c.2.2.3.4.5.5.3.2,1.4.8,1,1-1.6-.5-3.4-.3-5-.5-1.7,1.4-6.9-.2-8-2-.4-.1-.4-.3,0-.5,2.1.5,4.2,1.7,6.5,1.5.1-1-1.1-.2-1.6-.5s-1-1.3-1.9-1.5c2.5.5,6.2,1.9,8.5,2Z"
          fill="#8daae2"
        />
        <path
          d="M303.2,44.9c1.3.3,2.2.6,3.5,1-3.3-.7-7-.7-10-2.5,2.2.5,4.3,1,6.5,1.5Z"
          fill="#889dde"
        />
        <path d="M308.2,46.4c-.7-.2-1.2-.4-1.5-.5.4.1,1.3-.2,1.5.5Z" fill="#8daae2" />
        <path
          d="M203.2,43.9v.5c-.3.7-1.3,1.2-3,1.5-.6.7-1.8,1.2-3.5,1.5-5,1.3-10.1,2.7-15,4.5-.9.8-1.4.8-1.5,0-.9.3-1.7.4-2.5.5-.7.2-.8.2-.5-.5.3-.5.8-.8,1.5-1,4.1-1.6,9.4-3.9,13.5-5s6-1,8.5-1.5l1.5-.5c.2,0,.3,0,.5,0,.2-.3.3-.3.5,0Z"
          fill="#8aa1e3"
        />
        <path
          d="M178.8,50.9c-.3.1-.8.7-1.5,1-1.6,1.2-4.7,3.2-6.5,2,1.3-.9,3-1.5,4.5-2s2.3-.7,3.5-1Z"
          fill="#7c96dd"
        />
        <path d="M206.7,42.9c-.9.9-2.4.8-3.5,1s-.3,0-.5,0v-.5c1.2,0,2.7-.3,4-.5Z" fill="#8296de" />
        <path d="M202.2,43.9c-.2,0-.8.4-1.5.5l1.5-.5Z" fill="#8296de" />
        <path
          d="M177.8,52.4c-.7.6-1.5,1.1-2.5,1.5-.1.4-.3.4-.5,0l-1,.5c.7.7.4,1-.5.5-1,.6-2.9,1.4-4,1l-8,2.8,8.5-4.3v-.5c.3,0,.7,0,1,0,2.3-.4,4.4-1.1,6.5-2l.5.5Z"
          fill="#859bdf"
        />
        <path
          d="M361.1,70.9c0,0,0,.4,0,.5l1.5,1c2.1,1.1,4.6,1.9,6,4l-.3.3c1.6,1.1,1.2,2-.7,1.2-4.2-1.2-9-4.2-12-7.5-.2-.7.7-.3.6-.3-2.1-.8-2.2-2.6-.1-1.7,1.7.5,3.4,1.3,5,2.5Z"
          fill="#325dde"
        />
        <path
          d="M368.6,76.4c2.4.9,4,2.4,6,4l5.3,3.6c1.9,2.5,2,3.5.2,2.9-.9.8-1.9,0-1.5-1l-1-1c-.5.1-.6,0-.5-.5-1.1-.5-2.1-1.2-3-2-2.5-.2-5.4-2.2-6.5-4.5l1-.2-1.5-1.7c.7-.2,1,.3,1.5.5Z"
          fill="#2c59de"
        />
        <path
          d="M380.1,83.9l3,2.5c.7.5.7,1.4,0,2.5-.7,1.6-3.5-.6-3-2,1.4-1-.8-2-.9-2.1,0-.2.4-.8.3-.8,0-.1-2.2-.8-2.9-1.3s-1.5-1.8-2-2.2c1.9.5,3.9,2.2,5.5,3.5Z"
          fill="#2e5bdb"
        />
        <path d="M381.1,84.4c.5.4,2,1.5,2,2-1.1-.7-2.4-1.2-3-2.5.3.2.7.3,1,.5Z" fill="#7893e1" />
        <path
          d="M387.1,89.4l.5.5c.1,0,.4,0,.5,0-.6.4-1.2.7-1,1.5-.8,0-1.8-.6-3-1.5-1.1.8-1.7.2-1-1-1.5-2.3,0-1.5,0-2.5,1.4,1,2.7,1.8,4,3Z"
          fill="#386fe8"
        />
        <path d="M387.6,89.9c-.2,0-.4-.3-.5-.5.2.2.3.3.5.5Z" fill="#4b5cc0" />
        <path
          d="M338.2,61.4c-1.6-.5-4.6-1.9-1.7-2.5l8.7,3.5c2.1.5,3.2,1.7,5,2.5,2.8,2.4,3,3.2.5,2.5l-1.2.5c-1.7-.6-4.7-2.1-5.3-3.5l-1.5-1c-.1.4-.3.4-.5,0l-.5-.5c0,.7-.3.7-1,0-.9.7-2.7-.2-2.5-1.5Z"
          fill="#3867e8"
        />
        <path
          d="M354.7,66.9c.7.4,1.2.9,1.5,1.5l-.5.3c-.5,1.7,2.4,1.5,0,1.7-1.6.7-5-1.2-5-3,2.2.3,0-1.7-1.5-1.5v-.5s1-.5,1-.5c1.5.7,3.1,1.2,4.5,2Z"
          fill="#3b65de"
        />
        <path
          d="M345.2,62.4c-3.2-.7-4.6-1.4-7.1-2.2s-3.7-1.7-1.9.2,1.3.5,2,1c-.4,1.4-3.9-.2-3.5-1.5-2-1.4-.9-1.6,1-2,3.3,1.1,6.6,2.5,9.5,4.5Z"
          fill="#3664e2"
        />
        <path
          d="M329.2,55.4c.1,0,.4,0,.5,0l.5.5c.2,0,.4,0,.5,0l1.5,1c1,.3,2.4.4,3.5.5v.5l.5,1h-2s.5,1,.5,1c-1.1.8-6-1.3-6.9-2.2s-.2-.5-.1-.8c.5-1.1,3.4.7,3.1.8-.5,0-5.5-2.9-1.6-2.3Z"
          fill="#2b58e5"
        />
        <path
          d="M361.1,70.9c-1.6-.8-3.5-1.5-5-2.5s-1.1-.9-1.5-1.5c2.3,1.3,4.5,2.2,6.5,4Z"
          fill="#8497e0"
        />
        <path
          d="M318.2,51.9c2.9.4,5.7,1.2,8.5,2.5.9.4,1.5.5,2.5,1-2.9,0,2.4,1.4,2,2.5-1.1-.4-2.4-.7-3.5-1-2.8.6-7.5-1.4-9.5-3.5-2.4-.7-2.6-2.9,0-1.5Z"
          fill="#2e62e4"
        />
        <path
          d="M323.7,52.9c1.2.4,2.1,1.1,3,1.5-2.6-.9-6.1-1.4-8.5-2.5-1.4.3-1.7,0-1-1,2.1.7,4.4,1.2,6.5,2Z"
          fill="#3e56d5"
        />
        <path d="M332.2,56.9c-.7,0-1.3-.3-1.5-1,1.2.4,1.4,1,1.5,1Z" fill="#2e62e4" />
        <path d="M330.2,55.9c-.2,0-.4-.3-.5-.5.2.1.4.2.5.5Z" fill="#2e62e4" />
        <path
          d="M304.2,47.4c0-.7,1.1-.4,1.5,0,2.5.4,5.1,1.6,8,2,1,.7,2.3,1.1,3.5,1.5.3.3.7.9,1,1-1.6-.2-1.3.9,0,1.5-.4.4-.8.6-1.4.4-5.5-1.4-11.1-3-16.6-4.5s-.9-.4-1-1c-1.1-.2-1.3-.6-.5-1,.1-.2.3-.2.5,0,0-.2.1-.5.2-.7.2-.3,3.9.4,4.8.7Z"
          fill="#1d52e7"
        />
        <path
          d="M387.1,91.4c3.1,2.2,5.3,5.1,8.5,7,1.4,1.4,3.5,2.5,4,4.5-1,0-2-.6-3-2h-1.4c0,.1-7-7-7-7-1.4-.2-4.5-2.4-4-4,1.2.1,2.1.9,3,1.5Z"
          fill="#2a5ee4"
        />
        <path
          d="M421.6,124.9l.5.5c0,.1,0,.3,0,.5v.5c-.6.8-.8.4-1-.5-.9-.2-1.7-.9-2.5-2-1.3-1-2.8-2.5-3.5-4-1.1-.2-2-1.4-2.5-2.5v-.5l2,.5c-.5-.6-.7-1.4-1-2,3.1,2.8,5.5,6.2,8,9.5Z"
          fill="#7c92df"
        />
        <path
          d="M399.6,102.9c.3.2.7.3,1,.5,1.1,1.8,6.6,7.9,8.5,10-.2.3-.3.3-.5,0l-1.8-.6-9.2-10.4c-1.1.3-1.9-.6-1-1.5.7.5,2.2,1.5,3,2Z"
          fill="#2446cb"
        />
        <path
          d="M412.6,116.9v.5c-1.2-.5-2.2-1.5-3-2.5-1.2.6-1.8-.5-1-1.5h.5c.9,1.1,2.8,2,3.5,3.5Z"
          fill="#2334b2"
        />
        <path
          d="M423.1,126.9c1.4,1.9,2.9,3.9,4,6-1-1.4-3.9-5.9-4.5-6.5.2.2.4.3.5.5Z"
          fill="#7b8fe1"
        />
        <path d="M422.6,126.4c0,0-.4,0-.5,0,0-.2,0-.3,0-.5.2.2.3.3.5.5Z" fill="#7283dd" />
        <path d="M422.1,125.4c-.2-.2-.4-.3-.5-.5.1.2.4.3.5.5Z" fill="#7283dd" />
        <path d="M439.6,336.7h-.5c0-.2,0-.3,0-.5.2-.2.3-.2.5,0v.5Z" fill="#010557" />
        <path d="M439.6,336.2c-.3-.1-.3-.3,0-.5,0-.2,0-.4,0-.5h.5c0,.4.1.9-.5,1Z" fill="#060b4e" />
        <path d="M440.1,335.2h-.5c.1-.2.4-.4.5-.5,0,.2,0,.3,0,.5Z" fill="#020e7d" />
        <path d="M440.1,334.7v-.5h.5c0,.2-.4.3-.5.5Z" fill="#060b4e" />
        <path d="M440.6,333.7l.5-.5c-.1.3-.5.4-.5.5Z" fill="#060b4e" />
        <path d="M444.6,323.2c0-.2.4-.4.5-.5l-.5.5Z" fill="#04084c" />
        <path d="M445.1,322.2c.1-.2.3-.4.5-.5l-.5.5Z" fill="#04084c" />
        <path
          d="M432.6,146.8c2.1,4.2,4.2,8.4,6.5,12.5,0,1,1,2.5,0,3-.3-.7-.7-1.3-1-2-2.8-4.5-5.5-9.2-8-14-.5-.4-.9-1-.5-1.5-.4-1.1-.2-1.4.5-1,.5.9,1.9,2.1,2.5,3Z"
          fill="#0b1873"
        />
        <path
          d="M409.1,121.4l1.3-.3c1.1.5,5.1,5.9,4.2,7.2v.5c-.9-.9-3.1-1.9-3.4-2.1s-.1-1.2-.6-1.6c-1-.7-2,.7-1-1.7-1.4.3-3.8-1.3-4.5-2.5-1.6-2.9-1.1-.9-2.8-1.9s-1.6-2.1-2.2-3.1l-4.6-5.5c-2.9-1.8-5-4.1-6.9-7,0-1.2,2.7,0,3.5.6,5.7,5.8,11.4,11.6,17,17.4Z"
          fill="#00012c"
        />
        <path
          d="M412.1,121.4c.6-.3,1.4.4,1,1,4.6,5.1,8.7,10.9,12,17,1.9,2.2,3.8,4.8,5,7.5.8.8,2,2.4,1.5,3.5l-1,.6c.3-1.3-1-1.2-1.5-1.8-.9-1.2-1.3-2.8-2.5-3.8-3.8-6.6-7.1-11.5-12-17-2.1-2.4-2.6-4.7-5.5-7-.6-.6-.6-1,0-1,.4-.5.9-.5,1.5-.5.7-.4,1.5.7,1.5,1.5Z"
          fill="#010213"
        />
        <path
          d="M438.1,160.3l-.5.5c-1.7-3.6-4.2-7-6-10.5s-1-2.5-1.5-3.5v-.5c3.3,4.1,5.6,9.3,8,14Z"
          fill="#0c3384"
        />
        <path
          d="M400.6,391.7c1-.5,1.7,0,1.1,1-2.5,2.1-4.7,4.4-6.6,7-.1.5-3.7,4.1-4.5,5-.3.4-.6.8-1,.5-.3.5-.6.8-1,1l-.5.5c0,.7-.5,1-1,.5-.3.3-.7.3-1.1.2s2.3-3.3,2.6-3.7c1.5-1.4,2.6-2.6,4-4,2.7-2.6,5.4-5.3,8-8Z"
          fill="#01036b"
        />
        <path
          d="M388.6,403.7l-2,3.3.5.2c-.7,1.5-2.1,2.9-4,4-.2,0-.4,0-.5,0-1.2.9-1-.2,0-1,.2-.2.3-.3.5-.5,2.2-2.5,3-3.7,5.5-6Z"
          fill="#03033e"
        />
        <path d="M439.6,336.2h-.5c0-.2.3-.4.5-.5,0,.2,0,.3,0,.5Z" fill="#020e7d" />
        <path d="M428.6,138.3c-2.3-2.3-3.6-5.4-5.5-8v-.5c2.5,3.1,3.6,5,5.5,8.5Z" fill="#7b8fe1" />
        <path
          d="M422.1,126.4c0,.5.6,1.8,0,2-.5-.1-.8-.5-1-1-.4-.1-.4-.3,0-.5-.5-.6-.5-.9,0-1,.3.2.8.3,1,.5Z"
          fill="#7b8fe1"
        />
        <path
          d="M422.1,128.4c.4.5.6,1,1,1.5v.5c-.6-.8-1.4-1.6-2-2.5v-.5c.3.3.7.6,1,1Z"
          fill="#7283dd"
        />
        <path
          d="M425.1,135.3c.5.5,1,1.4,1.5,2l3,5.5c.2.3.3.7.5,1l-.5,1c-1.6-1.2-3.1-3.6-4-5.5-1.1-1.2-2.5-3-2.5-4.5-.2-.8-.1-1,.5-.5.6,0,1.1.3,1.5,1Z"
          fill="#09186d"
        />
        <path d="M429.6,142.8c-1.6-1.5-2.3-3.6-3-5.5,2.1,2.6,1.8,3.2,3,5.5Z" fill="#122482" />
        <path
          d="M154.8,436.2c.8-.3,3.1.3,3,1.5,2,.2,4.2,1.1,5.5,2.5.5-.9,2.1,0,2,1,.2-.2.3-.2.5,0l.5.5h1.3c6.9,2.7,13.8,5.4,20.6,8h.5l.5.5c2-.3,4.3.3,6,1.5l1,.5c.2-.4.3-.4.5,0l1.5.5c3.7,0,8,1.3,11.5,2.5,3.3.3,6.6.7,9.8,1.3l.2.7c-.3.9-2,.8-3,.5-13,0-40.9-10.4-53.3-15.9s-8.9-5.1-12.7-6.6l.5-.5c1-.5,2.8.7,3.5,1.5Z"
          fill="#0b0719"
        />
        <path
          d="M222.2,457.7c.5-1,1-1,1.5,0l2.5.5c2.7-.9,6.6-.3,9.5.5l3,.5c.4-.8,1.6-.8,2,0,1.1-.6,4.2-.6,4.7.5,0-.4.1-.7.2-.7,1.3,0,11-.4,11.4,0s.3.4.3.7c-.3-.7,0-1,1.1-1h7.6c1.6-.6,4.8-1.2,6,0,.9,0,1.7-.2,2.5-.5,0-1,.8-1,1,0,2,.3,1.1.7-.5,1-.4.2-.9.4-1.5.5-1.8,0-3.6.4-5,.5-15.8.8-29.8.6-45.5-1.5l-2.5-.5c-.2,0-.3,0-.5,0-.6-1,1.1-.9,2-.5Z"
          fill="#08081b"
        />
        <path
          d="M222.2,457.7c-.7,0-1.7-.3-2,.5-1.1-.1-2.8.5-3.5-.5,1.5,0,2.1-.4,3-.5.3-1.3,3.1-1,2.5.5Z"
          fill="#0b0b3c"
        />
        <path d="M223.2,458.7c-1-.1-1.9-.4-2.5-.5l2.5.5Z" fill="#0b0b3c" />
        <path d="M171.3,447.2c-1.8-.6-2.9-1.3-4.5-2,1.6.4,3.4.8,4.5,2Z" fill="#3851e6" />
        <path d="M157.8,441.2c-.4-.1-.8,0-1-.5.4,0,.7.2,1,.5Z" fill="#374fed" />
        <path d="M151.8,438.2c-.2-.1-.3-.4-.5-.5l.5.5Z" fill="#374fed" />
        <path d="M172.3,447.7c-.2,0-.3,0-.5,0v-.5c.2,0,.4.3.5.5Z" fill="#3851e6" />
        <path
          d="M371.6,421.7c-3.8,2.7-7.6,5.6-11.5,8-12.2,7.5-24.5,13.1-38,18-1.1.3-1.6,0-1.5-.5l.9-1.1c9.1-3.1,17.9-6.9,26.2-11.8h1.4c0-.1,1.5-1.1,1.5-1.1.2-.4.3-.4.5,0,1.5-1.5,3.3-2.7,5.4-3.5,2.2-1.9,4.6-3.3,7.1-4,1.3-1.9,3.3-3.2,6-4,0-.5.3-.4.5,0l.5-.5c-.1-.5,0-.6.5-.5.8-.6,1.2.4.5,1Z"
          fill="#090623"
        />
        <path
          d="M322.2,447.7c-4.9,1.8-9.8,4.2-15,5l-1.5.5c-.2,0-.3,0-.5,0l-1.5.5c-.2,0-.3,0-.5,0h-.5l-.5.5c-.3,0-.7,0-1,0-.4.3-.7.4-1,0-.4-.1-.4-.3,0-.5.1-.3.3-.3.5,0l.5-.5c.1-.4.7-.3,1,0,.2-.3.5-.5,1-.5.6-.2,1.1-.2,1.5,0l.5-.5c.3-1,1.2-1,1.5,0l.5-.5c1.2-.8,2.7-1.3,4.5-1.5,1.2-1,3.5-2,5-1.5l1-.5h.5c0-1.4,1.6-1.9,2.5-1l1.5.5Z"
          fill="#120d25"
        />
        <path
          d="M293.7,455.2c.8-.4,1.9-.5,1.5.5-.2,0-.3,0-.5,0l-1.5.5c-2.8.6-5.1,1.1-8,1.5l-2.5.5c-.2,0-.3,0-.5,0-5.2,1-4.2-.6-.5-1,2.1-1.7,6.9-2.4,9.5-1.5l1.5-.5c.3-1,.7-1,1,0Z"
          fill="#0d0e2b"
        />
        <path
          d="M280.7,457.2c.3-1,.7-1,1,0-.7.2-1.4.9-2.5.5v.5c1,0,2,0,3,0-.2.2-.3.4-.5.5l-3,.5c-.2,0-.3,0-.5,0-.9.4-2.1.4-3,0,.6-.5,1.6-.6.5-1,1-1.1,2.7-1.4,5-1Z"
          fill="#0a0b48"
        />
        <path
          d="M300.2,453.7v.5c-.1.2-.5.4-1,.5-1.3.3-2.7.7-4,1-.2-.6-1-.5-1.5-.5-.7-1.1,1.2-1.6,1.5-.5l1.5-.5c.1-.4.3-.4.5,0,.9-.5,2-.8,3-.5Z"
          fill="#100d35"
        />
        <path
          d="M275.2,459.2c1,0,2,0,3,0-.4.8-1.7.4-2.5.5h-1.5c-.2,0-.3,0-.5,0,.2-.7,1-.5,1.5-.5Z"
          fill="#e2e2ee"
        />
        <path d="M281.7,458.7c-1.1.8-1.8.4-3,.5.6-.9,2.1-.4,3-.5Z" fill="#e2e2ee" />
        <path d="M285.2,457.7c-.7,0-1.3.4-2.5.5.4-.8,1.7-.5,2.5-.5Z" fill="#0a0b48" />
        <path d="M300.2,454.2c.3,0,.7,0,1,0-.4.8-1.4.4-2,.5.1-.5.6-.5,1-.5Z" fill="#17112c" />
        <path d="M275.7,459.7c-1.1.1-1,0-1.5,0h1.5Z" fill="#f4f7f8" />
        <path d="M294.7,455.7c-.2,0-.8.3-1.5.5l1.5-.5Z" fill="#100d35" />
        <path d="M306.2,454.7v.5c-.8,0-1.6.4-2.5.5,1-.5,1.3-.7,2.5-1Z" fill="#3260f2" />
        <path
          d="M313.7,452.7c-1.8,1.2-4,1.5-6,2-.2-.2-.2-.3,0-.5,2-.5,4.1-.9,6-1.5Z"
          fill="#3850ee"
        />
        <path d="M305.2,453.2c-.2,0-.7.4-1.5.5l1.5-.5Z" fill="#17112c" />
        <path d="M307.2,452.7c-.3.7-1,.4-1.5.5.2-.7,1-.4,1.5-.5Z" fill="#17112c" />
        <path d="M302.7,454.2c-.1,0-.3,0-.5,0,0-.2.3-.5.5-.5.3.2.2.3,0,.5Z" fill="#17112c" />
        <path d="M302.7,454.2v-.5c.2,0,.3,0,.5,0,0,.2-.3.4-.5.5Z" fill="#100d35" />
        <path d="M307.7,454.7c-.2,0-.3,0-.5,0,0-.2.3-.4.5-.5v.5Z" fill="#3260f2" />
        <path
          d="M389.6,406.2c-.3.3-.7.7-1,1-1.5,1.5-3.7,2.8-5,4h-.5c1.3-1,2.7-3,4-4s.7-.3,1-.5l.5-.5c.2-.2.3-.2.5,0,.1-.3.3-.3.5,0Z"
          fill="#010236"
        />
        <path d="M389.6,406.2h-.5c-.1-.2,0-.6.5-1,.3-.2.7-.3,1-.5,0,0,.2.3-1,1.5Z" fill="#03033e" />
        <path d="M382.6,411.2c-.2.1-.4.7-1,1-1-1.2.4-1.4,1-2l-.5.8.5.2Z" fill="#010236" />
        <path d="M373.1,420.2v.5c-.2,0-.4,0-.5,0-.4-.3-.2-.3,0-.5h.5Z" fill="#090623" />
        <path
          d="M73.3,130.8c-2.4,4.3-5.1,8.3-7.5,12.5-2.2,4.6-4.5,9.1-7,13.5-1.7,4.4-3.5,8.7-5.5,13-.4,3.5-2.4,7.6-4.5,10.5-.1.4-.3.4-.5,0-.5-.8,0-2.1.5-3,0-.2,0-.3,0-.5l.5-.5c0-.3,0-.7,0-1l.5-.5c0-.1,0-.4,0-.5l.5-.5c0-.1,0-.4,0-.5l.5-.5c0-.1,0-.4,0-.5,1.8-4.1,3.6-8.3,5.5-12.5.1-.2-.1-.8,0-1l.5-.5c2.1-4.7,4.6-9.1,7.5-13.3l-1.5-.2c2.3-3.8,5.2-7.4,7.5-11.5,1-1,1.7-2.4,3-2.5Z"
          fill="#7f9aea"
        />
        <path
          d="M45.8,191.3c.5,1-1.4,8.9-1.7,9.2s-.5.2-.8.3c-.4.8-.7,1-1,.5.6-3,1.7-6.9,2.5-10s1.7-5.7,2.5-8.5c.1-1.1.4-1.9,1-2.5h.5c-.1,3.7-1.1,7.3-3,11Z"
          fill="#707cd5"
        />
        <path d="M37.3,234.3c0,1.5,0,3,0,4.5-.1.4-.3.4-.5,0,0-2.7-.4-6.1.5-8.5v4Z" fill="#7b95f0" />
        <path d="M37.3,234.3c0-1.3,0-2.7,0-4,.1-2.5.7-4.6,1-7l-1,11Z" fill="#7c94ed" />
        <path
          d="M50.8,172.3c1.1-2.9,2.1-5.8,3.4-8.8s1.2-2.7,2.1-3.7c-1.5,3.4-2.7,7.1-4.2,10.5s-.4,1.7-1.3,2Z"
          fill="#859ff1"
        />
        <path
          d="M48.3,180.3c-.3.9-.8,1.9-1,2.5.2-1.8.2-4.3,1.5-5.5-.3,1-.3,2.2-.5,3Z"
          fill="#859ff1"
        />
        <path d="M37.3,239.8c-.1.4-.3.4-.5,0,0-.3,0-.7,0-1h.5v1Z" fill="#7c94ed" />
        <path d="M37.3,240.8h-.5c0-.3,0-.7,0-1h.5v1Z" fill="#7b95f0" />
        <path d="M56.3,158.8l.5-.5c0,.2-.4.4-.5.5Z" fill="#859ff1" />
        <path d="M50.3,173.3l.5-.5c0,.3-.5.4-.5.5Z" fill="#859ff1" />
        <path d="M49.8,174.3l.5-.5c0,.3-.5.4-.5.5Z" fill="#859ff1" />
        <path d="M49.3,175.3l.5-.5c0,.3-.5.4-.5.5Z" fill="#859ff1" />
        <path d="M48.8,176.8l.5-.5c-.1.4-.5.5-.5.5Z" fill="#859ff1" />
        <path
          d="M50.3,322.2c.7-1.4,1.3-.9,1.9,1.5h.5c1.6,1.6,4.7,7.9,4.8,10.1s-.1.6-.3,1l.5,1c.4.2.4.3,0,.5l1.5,3,1,2c1.1,2,1.8,4,2,6,.9.7,1.3,2.1,0,2.5-.1.4-.3.4-.5,0,0-.1,0-.4,0-.5s0-.4,0-.5c-1.4-2.3-2.3-4.7-2.5-7-2.1-3-3.8-6.3-5-10-.2-.4-.7-.9-1-1.5l-1.5-3c0-.1,0-.4,0-.5-.6-1.4-1-3.1-1.5-4.5Z"
          fill="#2b69f6"
        />
        <path
          d="M63.3,347.7c.5-.2.6,0,.5.5.9,1.3,1.5,2.6,2,4,1.1.1,2.7,3.1,2,4,.6,3-1.2,1.5-2-.5-.3-.3-.7-.7-1-1-1.2-1.6-2-3.3-2.5-5-.2-.7.2-1.9,0-2.5.2-.5.5-.4,1,.5Z"
          fill="#2967f4"
        />
        <path
          d="M70.3,360.7c.6.3.8.9,1,1.5,1.5,0,4.2,4.3,4.4,5.8s-.2.5-.4.7c-.5.1-.9.5-1,1-1.8-1.4-2.4-3.7-3.5-5.5-1-1.2-1.8-2.6-2.5-4-2.3-4.5.9-2.9,2,.5Z"
          fill="#3771f5"
        />
        <path
          d="M75.3,368.7c.1-.4.3-.4.5,0,.4.5.6,1,.5,1.5.7,1.7,1.5,3.1,3,4.2l-2-.2c0-.1,0-.4,0-.5l-1.5-1.5c-.5-.8-1-1.6-1.5-2.5-.7-1.3-1.2-2.7-2-4,.7-.7,2.5,2.5,3,3Z"
          fill="#2455eb"
        />
        <path
          d="M65.8,355.7c1,.9,1.9,2.9,2,.5,1.2,0,3.1,2.9,2.5,4v.5c-.6-.9-1.5-1.7-1.5-3-1.4.4-.8,1.5-.5,2.5-.9-1.4-2.2-2.7-2.5-4.5Z"
          fill="#3778f7"
        />
        <path d="M64.8,354.7c-1.3-1.7-2.1-3-3-5h.5c.4,1.6,2.1,3.3,2.5,5Z" fill="#e6f5fb" />
        <path d="M70.8,364.2c-1.1-.8-2.1-2.7-2.5-4,.9,1.4,1.7,2.6,2.5,4Z" fill="#4778f3" />
        <path d="M77.3,373.7c-.2-.3-1-.7-1.5-1.5l1.5,1.5Z" fill="#2b68f6" />
        <path
          d="M54.3,331.7c1.7,3.2,3.8,7.1,5,10,0,1.1-.4.8-1,0-1.5-3.2-3.4-6.4-4-10Z"
          fill="#3c76f6"
        />
        <path d="M53.3,330.2c-.5-1-1-2-1.5-3l1.5,3Z" fill="#d5eafb" />
        <path d="M47.3,314.3l-.5-1c0,.2.3.5.5,1Z" fill="#c0dcf9" />
        <path
          d="M42.3,206.8c1.3.9-.2,3.5-1,4.5-.5,1.9-1.2,4.1-1.5,6,.5-5.4,1.4-10.7,2.5-16l1-.5.5.5c-.8,1.8-1.4,3.6-1.5,5.5Z"
          fill="#6772de"
        />
        <path
          d="M47.3,196.8c1,.5.4,3.2-.5,3.5-.9,1.6-1.4,3.5-1.5,5.5.4.2.4.3,0,.5-1.9,6.5-3,13.3-4,20,.9.8,1.1,2.3,0,2.9l-.5,4.6h-.5c.2-2,0-4.4,0-6.2v-9.5c0-.6.8-3.5,1-4.7,1.1-4.2,2.3-8.3,3.5-12.5-1.1-.6-.2-4.4,1-4.5.6-1.4,1.3-.9,1.5.5Z"
          fill="#1932c3"
        />
        <path
          d="M41.3,213.3c0-.6,0-1.4,0-2,.3-1.8.5-2.8,1-4.5-.1-1,1.3-6,1.7-6.1s.5,0,.8.1c-.3,1.8,0,4.1-.7,6.1s-2.3,4.1-2.8,6.4Z"
          fill="#232eb9"
        />
        <path
          d="M42.3,232.8c.4,1.1.4,2.4,0,3.5.7.5.7,1,0,1.5-.2,1.8-.3,3.6-.5,5.5.4.5.3,1,0,1.5.4,4.3.4,8.6,0,13,.4.5.4,1.9,0,2.5-.1.4-.3.4-.5,0,0-1.2,0-2.3,0-3.5-.8-.7-.8-2.3,0-3-.4-1.7-.4-3,0-4-.4-2.5-.6-5.1-.5-7.6h-.5s0-.2,0-.4c.1-2.8,0-5.1.5-8l.6-5.4c1.5-1.1,1.5,3.5.9,4.4Z"
          fill="#1b64f2"
        />
        <path
          d="M41.3,253.8c0,1,0,2,0,3-.9,1.7-.5,4.4-.5,6.5h-.5c0-4.5,0-9,0-13.5h.5c0,0,.5,4,.5,4Z"
          fill="#4da4f8"
        />
        <path d="M41.3,249.8h-.5c0,0-.5-4.5-.5-4.5,0-1,0-2,0-3l1-4v11.5Z" fill="#2f84fa" />
        <path d="M41.3,249.8v4l-1-4c0-1.5,0-3,0-4.5l1,4.5Z" fill="#3d9cf9" />
        <path
          d="M42.8,261.8c.1,1.2.3,2.3.5,3.5.8,1,.9,2,0,3l.5,3.5c.9.5,1,2.1,0,2.5.2.6.5,1.5,0,2-.1.4-.3.4-.5,0-.1-1.1-.3-2.2-.5-3.5-.4-.6-.4-1.3,0-2-.1-1.4-.3-2.9-.5-4.5,0-.3,0-.7,0-1-.4-2.5-.4-5,0-7.5-.3-1.2-.5-8.9-.1-9.2s.3,0,.6.2c1,4.2.7,8.7,0,13Z"
          fill="#010656"
        />
        <path
          d="M42.3,265.3c-.2-.2-.4-.3-.5-.5-.3-1.4-.5-3.2,0-4.5v-2.5c.1-.4.3-.4.5,0,0,2.5,0,5,0,7.5Z"
          fill="#060b58"
        />
        <path d="M42.8,270.8c-.1.4-.3.4-.5,0,0-1.5,0-3,0-4.5.9,1,.5,3.1.5,4.5Z" fill="#060b58" />
        <path d="M41.8,264.8c-.9-1.5-.5-2.8-.5-4.5h.5v4.5Z" fill="#4da4f8" />
        <path
          d="M42.8,272.8c.2.4.3.7,0,1-.8-.4-.5-1.7-.5-2.5s0-.3,0-.5h.5c0,.7,0,1.3,0,2Z"
          fill="#3d7ff3"
        />
        <path
          d="M50.3,314.3c.6.2.7.8,0,1l.5.5c.9,1.2,1.1,2.2.5,3-.4-1.3-1.6-3.2-2-4.5s-.6-3.5-1-5l2,5Z"
          fill="#a5d8f3"
        />
        <path d="M48.3,308.8l-.5-1.5c0,.3.3.9.5,1.5Z" fill="#add5f2" />
        <path d="M47.8,306.8l-.5-1.5c.1.5.3.8.5,1.5Z" fill="#add5f2" />
        <path
          d="M50.8,313.8l.5,1c.4,0,.4.3,0,.5.3.3.3.7,0,1l.5.5c2.7,3.5,3.9,8.2,5,12.5.4,0,.4.2,0,.5l.5.5c.4.1.4.3,0,.5l.5,1c.4.2.8.5,1,.8,1.3,2.6,5.6,11.3,6,13.4s0,.8,0,1.3v.5c.3,0,.5.2.5.5.3.1.3.3,0,.5l.5.5c0,.2,0,.4,0,.5l.5.5c0,.1,0,.4,0,.5-.1.4-.3.4-.5,0-.8-.3-1.5-1.1-2-2.5-.2-.2-.3-.4-.5-.5-1.2-2.1-2.2-4.2-3-6.5l-1-2-1.5-3c0-.1,0-.4,0-.5l-.5-1c-1.5-3.5-3.2-7.5-4.5-11s-1-3.4-1.5-5c-.2-1-.3-2-.5-3l-.5-.5c0-.3,0-.7,0-1s0-.7,0-1c.1-.4.3-.4.5,0,.4.1.3.3,0,.5Z"
          fill="#cdecf9"
        />
        <path
          d="M44.8,287.3c.3,0,.5,0,.5,0,.6,1,0,1.8.2.8s.2-.2.3-.3c1.5,1.1,1.9,4.7,1.5,6.5l.5,1.5c.7.3.7.7,0,1,1.1,1.8,1.4,3.5,1,5,0,.7-.2,1.2-.5,1.5-1-2.3-1.6-5-2-7.5-.2-.3-.3-.8-.5-1.5-.2-2.4-1-4.6-1-7Z"
          fill="#0c155f"
        />
        <path
          d="M49.8,304.3c.8.2.8.6,0,1l.5,1.5c1.2,1.4,2.1,4.2,1.5,6,.2.6,0,1-.5,1-.1.4-.3.4-.5,0,0-.2,0-.3,0-.5-.3-.8-.6-1.6-1-2.5,0-.2,0-.3,0-.5l-.5-1.5c0-.2,0-.3,0-.5l-.5-1.5c0-.2,0-.3,0-.5l-.5-1.5c0-.5,0-1,0-1.5s-.2-1.3.5-1.5c.7.2,1,1.1,1,2.5Z"
          fill="#0e145b"
        />
        <path d="M50.8,313.3h-.5c-.2-.8-.3-1.7-.5-2.5,1,.6.8,1.6,1,2.5Z" fill="#a5d8f3" />
        <path d="M49.8,310.3c0-.1-.4-.8-.5-1.5l.5,1.5Z" fill="#a5d8f3" />
        <path d="M49.3,308.3c0,0-.4-.7-.5-1.5l.5,1.5Z" fill="#add5f2" />
        <path d="M48.8,306.3c0,0-.4-.5-.5-1.5l.5,1.5Z" fill="#add5f2" />
        <path d="M46.3,295.8h-.5c-.4-.2-.3-.7,0-1,0-.2,0-.3,0-.5.7.2.4,1,.5,1.5Z" fill="#3c6ef1" />
        <path
          d="M45.8,295.8c0,.2-.3.4-.5.5,0-.2,0-.3,0-.5,0-.4,0-.8.5-1,0,.3,0,.7,0,1Z"
          fill="#c6edfc"
        />
        <path
          d="M44.3,278.3c.2,0,.4.4.5,1,.9,1.4,1.3,4.4,1,6,.7,1.3.7,2.2,0,2.5,0,.8.3,1.7-.5,1.5.2-.9-.2-1.4-.5-2s-.4-.9-.5-1.5l-.5-2c0-.2,0-.3,0-.5,0-.3,0-.7,0-1l-.5-2c0-.5,0-1,0-1.5-.4-.8-.4-1.7,0-2.5h.5c.3.5.4,1.2.5,2Z"
          fill="#091453"
        />
        <path d="M44.3,285.8c-.2-.7-.4-1-.5-2l.5,2Z" fill="#87cef2" />
        <path
          d="M43.3,276.3c-.1.4-.3.4-.5,0,0-.2,0-.3,0-.5,0-.7,0-1.3,0-2s0-.7,0-1c.9.7.5,2.4.5,3.5Z"
          fill="#060b58"
        />
        <path d="M43.3,278.8c-.8-.4-.5-1.7-.5-2.5h.5c0,.8,0,1.7,0,2.5Z" fill="#6cbdf2" />
        <path d="M43.8,282.3c-.8-.3-.5-1.3-.5-2,.8.3.5,1.3.5,2Z" fill="#6cbdf2" />
        <path d="M142.3,432.7c-1-.5-2.1-.9-3-1.5l-.5-1c1.2.8,2.5,1.5,3.5,2.5Z" fill="#3053e5" />
        <path d="M138.3,430.2l-1-1c.6.4.8.9,1,1Z" fill="#3053e5" />
        <path
          d="M75.8,368.7h.9c1.7,2.8,2.4,3.6,2.1,2.5l6.5,8.5c-.9-.7-1.3-2.1-2.5-2.5.4.9,1.1,2.8,1.5,3.5l-8-10.5c-.2-.5-.5-.9-.5-1.5Z"
          fill="#c7e3f7"
        />
        <path d="M88.8,386.2c-.2-.2-.4-.3-.5-.5l.5.5Z" fill="#3d81f9" />
        <path
          d="M77.3,368.7l.5.5c0,.2,0,.4,0,.5l1,1c0,.1,0,.4,0,.5.6,1,2.1,2.3,1.8,3.5-1.7-2-3-4.1-4.7-6s-.4,0-.5,0c-.9-2.4-2.6-4.4-4-6.5l-1-2c-.9-1.6-1.7-2.6-2.5-4s-1.3-2.8-2-4c-.4-.8-.4-1.3,0-1.5h.5c2.9,5.8,7.6,12.2,11,18Z"
          fill="#e0edf9"
        />
        <path
          d="M60.3,334.2c.4.2.4.3,0,.5l.5.5c.4.2.4.3,0,.5l.5,1c.4.2.4.3,0,.5l.5.5c1.6,1.1,2.5,4.1,2.5,6l.5.5c.8,0,1,1,.5,1.5l.5.5c.4.1.4.3,0,.5l.5.5c.4.1.4.3,0,.5-.3,0-.4.2-.5.5-.1.3-.3.3-.5,0v-.5l-.5-.5c-2.5-5.1-5-10.2-7-15.5l-.5-1c0-.1,0-.3,0-.5l-.5-.5c0-.2,0-.3,0-.5-.2-.8,0-1.1.5-1,1.9.5,3.4,4.3,3,6Z"
          fill="#0c0e4c"
        />
        <path
          d="M63.3,338.2c.5,1,.6,1.6,1,2.5l1.5,3c.5.6.9,1.4.5,2l.5.5c.5,0,.8.5.5,1,1.3,2.7,1.1,3.2-.5,1.5,0-.1,0-.4,0-.5l-.5-.5c0-.2,0-.3,0-.5l-.5-.5c0-.1,0-.4,0-.5l-.5-.5c-.3-.5-.3-1.1-.5-1.5l-.5-.5c-.9-1.9-1.6-4.1-2.5-6l-.5-.5c0-.1,0-.4,0-.5l-.5-1c0-.1,0-.4,0-.5l-.5-.5c0-.1,0-.4,0-.5-.4-1,0-1.5.8-.8l2.2,4.8Z"
          fill="#0c35b2"
        />
        <path d="M68.8,351.7c-1-.2-.8-1.1-1-1.5.5.4.7.9,1,1.5Z" fill="#02219f" />
        <path d="M70.3,354.7c0,0-.3-.2-.5-.5l.5.5Z" fill="#02219f" />
        <path d="M69.8,353.7c0,0-.4-.1-.5-.5l.5.5Z" fill="#02219f" />
        <path d="M66.3,350.2s-.4-.2-.5-.5l.5.5Z" fill="#a0cbf6" />
        <path d="M65.8,349.2c-.2,0-.4-.3-.5-.5.1-.3.3-.3.5,0,0,.1,0,.3,0,.5Z" fill="#a0cbf6" />
        <path d="M65.8,348.7h-.5c0-.2,0-.3,0-.5h.5c0,.1,0,.3,0,.5Z" fill="#092eae" />
        <path d="M66.8,348.2c-.5,0-.4-.2-.5-.5.6,0,.4.3.5.5Z" fill="#092eae" />
        <path d="M77.8,369.2c-.2-.2-.4-.3-.5-.5.2.1.4.3.5.5Z" fill="#c7e3f7" />
        <path d="M78.8,370.7c-.6-.2-.7-.5-1-1,.5.2.8.5,1,1Z" fill="#c7e3f7" />
        <path
          d="M109.3,93.9l-.2,1,2.7-1c.7,1.1-2,3.6-3,3-4.8,3.3-9.4,7.8-13,12.5.9.9-.4,2.3-1.5,2-1.3,2.9-3.2,4.9-5.5,6-.8,1.1-1.6,1.8-2.5,2,1.7-2.9,3.7-5.6,6.2-8.3l-.2-.7c1.6-1.9,3.4-3.6,5-5.5,1.3-.6,2.1-2.1,3-3s1.4-1.4,2-2c2.2-2.1,4.7-3.9,7-6Z"
          fill="#2e60d4"
        />
        <path
          d="M92.3,110.4c1.5-.1,1.1.3.5,1.3-1.5,2.6-4.9,5.1-6.5,7.7.3.7-.3,1.5-1,1.5l-.5.5c-1,.6-1.2.4-.5-.5,2.7-3.9,4.8-6.8,8-10.5Z"
          fill="#4563cf"
        />
        <path
          d="M84.8,121.4c.4.6-.3,1.6-1,1.5l-.5.5c.6.5.2,1.1-.5,1l-1,1c.6.6.3.9-.5.5-.1.3-.3.3-.5,0,.4-.6.6-1.4,1-2,.7-1.2,1.9-2.1,2.5-3,0,.4.1.5.5.5Z"
          fill="#385cd1"
        />
        <path d="M135.3,72.4l2.5-2c-.5.3-1.2,1.3-2.5,2Z" fill="#6082df" />
        <path d="M142.8,67.9c.8-1.2,2.3-1.8,3.5-2.5-.8,1.3-2.3,1.8-3.5,2.5Z" fill="#6082df" />
        <path d="M130.3,75.9c-.3-.3,0-.9.5-1,.2,0,.3,0,.5,0-.2.1-.5.6-1,1Z" fill="#6082df" />
        <path d="M130.3,75.9c-.1,0-.4,0-.5,0,.2-.2.3-.7.5-1h.5l-.5,1Z" fill="#555eca" />
        <path d="M132.3,74.4c-.3.2-.7.4-1,.5.2-.1.5-.6,1-1,.3.1.3.3,0,.5Z" fill="#555eca" />
        <path d="M132.3,74.4v-.5c.3-.2.7-.3,1-.5-.2.5-.5.7-1,1Z" fill="#6082df" />
        <path d="M133.8,73.4c.2-.5.5-.8,1-1-.2.5-.5.8-1,1Z" fill="#6082df" />
        <path d="M138.8,70.4c-.2-.2-.2-.3,0-.5.1,0,.4,0,.5,0-.1,0-.3.4-.5.5Z" fill="#6b86df" />
        <path d="M138.8,70.4c-.1,0-.4,0-.5,0,.2-.2.3-.3.5-.5v.5Z" fill="#6082df" />
        <path d="M139.8,69.9v-.5c.1,0,.4,0,.5,0-.1,0-.3.3-.5.5Z" fill="#6b86df" />
        <path d="M139.8,69.9c-.1,0-.4,0-.5,0,.2,0,.3-.4.5-.5v.5Z" fill="#6082df" />
        <path d="M140.3,69.4c.2,0,.3-.4.5-.5-.2.1-.3.4-.5.5Z" fill="#6082df" />
        <path d="M141.3,68.9c.2-.2.3-.3.5-.5-.1,0-.3.4-.5.5Z" fill="#6b86df" />
        <path d="M141.8,68.4c.2-.2.3-.4.5-.5-.2.1-.3.4-.5.5Z" fill="#6082df" />
        <path d="M146.8,65.4l.5-.5c0,0-.2.4-.5.5Z" fill="#6082df" />
        <path d="M147.8,64.9l.5-.5c0,0-.2.4-.5.5Z" fill="#6082df" />
        <path d="M148.8,64.4l.5-.5c0,0-.2.4-.5.5Z" fill="#6082df" />
        <path d="M149.8,63.9l.5-.5c0,.6-.4.4-.5.5Z" fill="#6082df" />
        <path d="M127.8,77.4l.5-.5c-.1,0-.3.3-.5.5Z" fill="#6082df" />
        <path d="M128.8,76.9c.2-.5.5-.8,1-1-.4.5-.4.6-1,1Z" fill="#6082df" />
        <path
          d="M137.8,74.9l-.2.9c-6.9,4.8-13.7,9.7-20.4,15h-.9c-1.2,1.1-2.4,1.8-3.5,2.1l.5-1c-.5.1-1.2-.5-1.5-.5.8-.7,1.6-1.4,2.5-2,1.7-1.2,2.9-2.2,4.5-3.5s2.4-1.2,3-2.5c.2,0,.4,0,.5,0l.5-.5,3-2c3.7-1.8,7.3-4.1,10.8-6.9h1.2c.3,0,.3.4,0,.9Z"
          fill="#2f56d3"
        />
        <path
          d="M162.3,59.4c.5.1.3.5-.5,1l-.6,1.1c-7.5,4-14.9,8-22.3,11.9l-.5.5c-.1.4-.3.4-.5,0-3,1.9-5.9,3.9-8.9,5.9s-2.6,2-3.1,1.1c.2-.5.9-1,1.5-1,0-.3.2-.5.5-.5l1-.5.5-.5c.2-.3.6-.6,1-.5l.5-.5c1-1,2.2-2,3.5-2.5,0-.3.2-.5.5-.5l.5-.5c.1,0,.4,0,.5,0,1-1.1,2.2-1.9,3.5-2.5h.5c.5-.6,1.3-1.2,2-1.5h.5l.5-.5h.5c3.4-2.1,6.9-4.1,10.5-6,.1,0,.4,0,.5,0l2-1.5c.1,0,.4,0,.5,0l2.5-1.5c.9-.4,2.1-.6,3-1Z"
          fill="#3051d1"
        />
        <path
          d="M127.3,79.9c-.5.4-1,.6-1.5,1-.9.7-2,1.3-3,2,1.6-1.2,2.6-2.2,4.5-3.5v.5Z"
          fill="#6082df"
        />
        <path
          d="M134.3,74.9c-1.1.9-2.3,1.7-3.5,2.5l-.5.5c-.3.2-.7.3-1,.5l-.5.5c-.3.2-.7.3-1,.5,2.2-1.7,4.1-3.4,6.5-5v.5Z"
          fill="#6082df"
        />
        <path
          d="M135.8,73.9c.4-.8,1.3-1.6,2-2s.4,0,.5,0l.5-.5c.1,0,.4,0,.5,0-1,.6-2.4,1.8-3.5,2.5Z"
          fill="#6082df"
        />
        <path d="M122.3,83.4c.2-.2.3-.4.5-.5-.2.1-.3.4-.5.5Z" fill="#657cd9" />
        <path d="M127.3,79.9v-.5c.1,0,.4,0,.5,0-.2.1-.3.4-.5.5Z" fill="#2f56d3" />
        <path d="M134.3,74.9v-.5c.1,0,.4,0,.5,0-.2.2-.3.4-.5.5Z" fill="#2f56d3" />
        <path d="M134.8,74.4c.2-.1.3-.4.5-.5-.2.2-.3.3-.5.5Z" fill="#6082df" />
        <path
          d="M116.3,90.9c-.9,1.3-1.1,1.8-.5,1.5-2.2,3.4-6,6.3-9.5,8.5l-1.5,1.5c-.1.4-.3.4-.5,0,0-.8.5-1.6,1.5-2.5,0-1.2,1.1-2.2,3-3,.9-.9,2.1-2.2,3-3s.7-.8,1-1c.6-.5,2.7-1.6,3.5-2Z"
          fill="#030436"
        />
        <path
          d="M173.3,54.9c.4.1.4.3,0,.5,0,.2,0,.5,0,.7-.1.6-10.3,4.9-10.9,4.8s-.4-.2-.6-.4l.5-1c2.3-1,4.8-2.6,7-3.5s2.8-.6,4-1Z"
          fill="#2952db"
        />
        <path d="M143.3,69.4v-.5c3.5-2.1,6.7-3.9,10.5-5.5-3.1,2.3-7,4.2-10.5,6Z" fill="#6082df" />
        <path d="M156.8,61.9c.6-.7,1.6-1.1,2.5-1.5-.4,1.2-1.6,1.1-2.5,1.5Z" fill="#6082df" />
        <path
          d="M139.8,71.4v-.5c.3-.2.7-.3,1-.5l.5-.5c.1,0,.4,0,.5,0-.3.2-1.1,1-2,1.5Z"
          fill="#6082df"
        />
        <path d="M154.3,63.4c.4-.8,1.2-1.2,2-1.5-.4.9-1.2,1.1-2,1.5Z" fill="#6082df" />
        <path d="M138.3,71.9l.5-.5c-.2,0-.3.4-.5.5Z" fill="#6b86df" />
        <path d="M139.8,71.4c-.1,0-.4,0-.5,0,.2-.1.3-.4.5-.5v.5Z" fill="#6b86df" />
        <path d="M140.8,70.4l.5-.5c-.2.1-.3.4-.5.5Z" fill="#6b86df" />
        <path d="M142.3,69.9c-.2-.2-.2-.3,0-.5.1,0,.4,0,.5,0-.1,0-.3.4-.5.5Z" fill="#6082df" />
        <path d="M142.3,69.9c-.1,0-.4,0-.5,0,.1,0,.2-.4.5-.5v.5Z" fill="#6b86df" />
        <path d="M143.3,69.4c-.1,0-.4,0-.5,0,.2-.1.3-.4.5-.5v.5Z" fill="#6b86df" />
        <path
          d="M73.8,134.3c-1.2,1.5-2,3.2-2.3,5-.5,0-.9.5-1.2,1.5.3.5,0,.8-.5.5h-1c.5,1.1.4,1.7-1,1.5l-.5.5.5,1c-1.3,2.3-2.5,4.6-3.5,7,.2.3.3.6.2.8-1.7,3.7-3.9,8.4-5.8,11.9l-1.3.8c-2.1,6.8-4.5,13.4-7.4,20l-1.1,1-.6-.5c1.7-6.1,3.9-12.1,6.6-18,.8-3.6,2.6-7.3,4.5-10.5,1.8-4.7,4.2-9.3,7-13.5,1.6-2.9,3.8-5.6,5.5-8.5l.5-.5c.1-.2.4-.3.5-.5l1,.5Z"
          fill="#373cb3"
        />
        <path
          d="M80.3,129.4c.5.3.1,1-.5,1l-1,1c.4.2.4.3,0,.5l-1,1c.4.2.4.3,0,.5l-1,1c.6.4.2,1-.5,1l-1,1c.4.2.4.3,0,.5l-1,1c.5.5.3,1.1-.6,1.8-.5,1.8-2,5.5-3.9,5.6l-.5.5c-.1.4-.3.4-.5,0-1.1-1.3.3-4.1,2-4.5-.5-.9-.4-2.3.7-2,.1-2,1.3-3.8,2.8-5,.2-.3,1.1-.6,1.5-1,1.1-2,2.5-3.6,4-5,.4-1,.9-1.8,1.5-2.5.1-.2.4-.3.5-.5l1-1c.2-.3.3-.7.5-1l.5-.5c.4-.5.6-1,1-1.5l.5-.5c.4-.4.6-1.1,1-1.5.6-.6,1.9-1.4,2.5-2,.2.2.4.3.5.5.3.7-7.7,10.3-9,11.5Z"
          fill="#2254cf"
        />
        <path
          d="M70.8,141.3c-.7.7-.9.4-.5-.5-.6-1.1-.9-2,.5-2.5l.5,1c-.5-2.9.7-3.3,2.5-5h.5c-.8,1-2.6,5.3-3.5,7Z"
          fill="#333db6"
        />
        <path
          d="M79.8,128.4c-1.5,2.9-1.9,2.8-4,5,.6-1.3,1.3-2.8,2-4l2-2.5c0-.1,0-.4,0-.5h.5c.6.3,0,1.4-.5,2Z"
          fill="#385cd1"
        />
        <path d="M77.8,129.4c.6-1,.8-2,2-2.5-.5.9-1.1,2-2,2.5Z" fill="#3d47b6" />
        <path d="M71.8,134.8c.1-.2.4-.3.5-.5l-.5.5Z" fill="#393eac" />
        <path
          d="M251.7,39.4c.2.2.4.2.5,0,.5,0,1,0,1.5,0,1.2-.1,2.3,0,3.5.5,1.5,0,3,0,4.5,0h1.5c.5,0,1,0,1.5,0s.3,0,.5,0l1,.5c1.1.1,2.8-.5,3.5.5-1.3.2-2.7.2-4,0l-.9.6c-4.9.1-9.8-.2-14.5-1.1,0,.4-.3.4-.5,0-1.8-.4-3.7-.5-5.5,0-2.9.9-6.4.7-9.5.5-1.9.4-4.2.3-6,0,1.3-.6,3.6-.9,5-1,2.6-.2,5.3.1,8,0l2.5-.5c2.5,0,5,0,7.5,0Z"
          fill="#9fafec"
        />
        <path d="M257.2,39.9c-1.3,0-2.6-.5-3.5-.5.6-.7,2.8,0,3.5.5Z" fill="#9fb1ea" />
        <path d="M244.2,39.4c-.2,0-1.4.5-2.5.5.4-.8,1.7-.5,2.5-.5Z" fill="#9fb1ea" />
        <path d="M263.2,39.9h-1.5c.2,0,.9,0,1.5,0Z" fill="#9fb1ea" />
        <path d="M251.7,39.4c.2,0,.3,0,.5,0l-.2.5-.2-.5Z" fill="#9fb1ea" />
        <path
          d="M234.7,40.9c.4.1.4.3,0,.5-.6,1-1.4,1-2,0-1.3.3-2.6.4-4,.5-.1,1-.6,1-1,0l-2,.5c-.2.4-.3.4-.5,0-1.9.7-3.5.9-5,.5-.4-.1-.4-.3,0-.5,2.5-.2,5.9-1.3,8.5-1.5s4,.1,6,0Z"
          fill="#1d49e3"
        />
        <path
          d="M220.2,42.4v.5c0,.8-.8.7-1,0-1.8.7-3.6,1.2-5.5,1.5-.3,1-1.1,1-1.5,0-1.6.5-3.4.9-5,.5.3-.6,1.1-.9,2.5-1,2.3-.3,5-.3,7-1.5,1.2,0,2.4,0,3.5,0Z"
          fill="#2a43d6"
        />
        <path
          d="M269.7,40.9c.2,0,.3,0,.5,0l25.5,4c.4.1.4.3,0,.5.4.1.4.3,0,.5-2.1.8-6.2.2-8-1-6.9-1.1-13.8-2.2-20.8-3.2l-1.2-.8c1.3,0,2.7,0,4,0Z"
          fill="#1c4fe3"
        />
        <path
          d="M305.7,46.9v.5c-.5,0-1,0-1.5,0-3-.3-5.8-1-8.5-2v-.5c3.4.2,6.7,1.2,10,2Z"
          fill="#889dde"
        />
        <path d="M266.2,40.4l-1-.5c.9,0,.9.5,1,.5Z" fill="#9fb1ea" />
        <path
          d="M196.7,47.4h1c0,.9-1.6,1.1-2.5,1-.1,1-.6,1-1,0l-1,.5c0,.3-.2.5-.3.7-.3.4-8.3,2.7-9.4,2.9s-.9-.3-1.2-.6h-.5c4.5-1.8,10.2-4.3,15-4.5Z"
          fill="#2045e4"
        />
        <path
          d="M181.8,51.9c.2,0,.3,0,.5,0v1c-1.8,1-3.6,1.7-5.5,2-1.2,1.3-2.2,2-3.5.5v-.5c.2,0,.4-.4.5-.5l1-.5c.1,0,.3,0,.5,0,1.6-.9,3.2-1.7,5-2,.4-.1,1.1.1,1.5,0Z"
          fill="#1b49dd"
        />
        <path
          d="M206.7,44.9c.4.1.4.3,0,.5-.3.3-.7.3-1,0l-.5.5-1.5.5c-.2.4-.3.4-.5,0-2,.9-3.8,1.2-5.5,1-.3,0-.7,0-1,0,.8-.5,2.6-1.3,3.5-1.5,2.4-1.1,4.5-1.5,6.5-1Z"
          fill="#2843d5"
        />
        <path
          d="M209.7,43.9l-2.5,1c-.1.3-.3.3-.5,0-1.9.3-4.7.6-6.5,1,.8-.2,2.6-1.4,3-1.5,2.1-.6,4.4-.2,6.5-.5Z"
          fill="#8296de"
        />
        <path
          d="M180.3,51.9c-1.3.4-3.3,1.4-5,2,.6-.6,1.8-1.2,2.5-1.5s1.7-.4,2.5-.5Z"
          fill="#7c96dd"
        />
        <path d="M174.8,53.9l-1,.5c.2,0,.5-.3,1-.5Z" fill="#7c96dd" />
        <path
          d="M341.7,62.9l.5.5c.2,0,.4,0,.5,0l1.5,1c2.1,1.1,4.6,2,6.5,3s3.4,2,5,3c4,2.3,8.1,5,12,7.5s4.3,3,6.5,4.5c.9.8,1.9,1.5,3,2,.2.2.3.3.5.5l1,1c.5.4,1,.6,1.5,1,1,.7,1.7,1.9,3,2,.4.6.7.7,1,1,1.4,1.4,2.6,2.4,4,4,1.3.9,1.8,1.7,1.5,2.5-.2.9-.7.9-1,0-2-1.3-3.7-2.8-5-4.5-3.8-2.4-7.7-5.4-11-8.5-1.9-.7-3.7-2-5-3.5-3-1.4-6-3.3-8.5-5.5-1.6-.3-3.4-1.3-4.5-2.5-2.3-.6-4.6-2-6.5-3.5-2-.5-4.6-2-6.4-3.2s-.1-.4,0-.8c-1.2-.6-1.5-1.1-1-1.5.3,0,.7,0,1,0Z"
          fill="#02041d"
        />
        <path d="M362.6,72.4c-.8-.4-.6,0-1.5-1,.7,0,1.3.3,1.5,1Z" fill="#4a6de4" />
        <path d="M377.1,84.4c-1.6,0-2-1.1-3-2,1.2.8,1.6.8,3,2Z" fill="#2149c0" />
        <path d="M378.6,85.9c-.4-.3-.8-.5-1-1,.3.3.9.4,1,1Z" fill="#2e5bdb" />
        <path
          d="M297.2,48.4c.4-.8,1.5-.7,2,0,5.5.9,13.5,3.3,19,5s6.3,2.5,9.5,3.5c2.2,1.3,4.7,2,7,3s2.2,1.3,3.5,1.5c.8.6,1.7.8,2.5,1.5s.6,1.1,1,1.5c-.8.8-2.8-.2-3.5-1-3.5-.8-7.1-2.4-10-4.5-1.5.2-3.7-.4-4.5-1.5l-.5-.5c.1.9-.6.7-1,0l-.5-.5c0,.8-.6.7-1,0l-.5-.5c-.2.4-.3.4-.5,0-2-.2-4.2-1-6-2-5.7-1.1-11.4-2.8-17-4.5h-.5l-1-.5c-.3.6-1.2.5-1.5,0l-1-.5c-.2.4-.3.4-.5,0-.3-.9,0-.9.8-.9l4.2.9Z"
          fill="#020318"
        />
        <path d="M344.2,64.4l-1.5-1c1.3.4,1.2.8,1.5,1Z" fill="#083eb3" />
        <path d="M342.2,63.4c-.2,0-.4-.3-.5-.5.2,0,.4.3.5.5Z" fill="#083eb3" />
        <path
          d="M304.2,47.4c-2.2-.3-3,0-5,0-.5-.2-.9-.4-.5,0l.5,1c-.6,0-1.4,0-2,0-1.4-.5-2.9-.7-4.4-.8v-.7c.6-.8,4.1-.6,3.8-.5-.6.2-.9.3-.9-.5v-.5c2.8.1,5.9.9,8.5,2Z"
          fill="#2d51d8"
        />
        <path d="M299.2,47.4c-.2,0-.3,0-.5,0h-2s0-.5,0-.5c.8,0,2.1-.3,2.5.5Z" fill="#1c4fe3" />
        <path
          d="M396.6,100.9c.3.5.6,1,1,1.5l4.5,5v1c-1,.7-3-1.9-3-3-.8-.5-1.4-1.2-2-2-.7.6-2-.8-2.5-1.5-1.7-1.4-3.8-3.1-5.3-4.8s0-.4.3-.7c-.1-.1-.7-1.6-1.5-2.5,3.1,1.8,5.6,4.8,8.5,7Z"
          fill="#030c35"
        />
        <path
          d="M412.6,117.4c.9.8,1.7,1.6,2.5,2.5.4.6.4.9,0,1v.5c-1,.4-1.5,0-1.4-1.1l-3.6-4.3c-1,.3-1.4-.4-.5-1,1,.8,2.1,1.6,3,2.5Z"
          fill="#16268f"
        />
        <path
          d="M418.6,123.9c1,.9,1.9,1.9,2.5,3v1c-1.8-2.4-3.8-4.9-6-7v-1c1.4,1.4,2.3,2.4,3.5,4Z"
          fill="#6880d7"
        />
        <path d="M421.1,125.9v1c-1-.7-1.7-2-2.5-3,.9.6,1.6,1.4,2.5,2Z" fill="#7283dd" />
        <path
          d="M397.6,102.4c3.7,3.5,7.8,6.9,11,11s.6,1,1,1.5.2.6.5,1l4.2,5.2c0,1.3-1.7.9-1.7-.2-1-.3-2-1.4-2-2.5-1.9-1.3-4-3.4-5-5.5-1.5-1-3.3-2.7-3.5-4.5-1.5-1.9-3-4-4.5-6Z"
          fill="#040e45"
        />
        <path
          d="M429.6,144.8c.3.5.3,1.2.5,1.5s0,.4,0,.5c-1.9-2.3-3.3-5-5-7.5.1-.3.3-.3.5,0,1,1.7,3,3.5,4,5.5Z"
          fill="#0a2c75"
        />
        <path
          d="M361.6,83.4c1.2-.3,1.9.2,2,1.5,2.7,2,5.1,4.4,7.7,6.5,4,3.1,9.5,5.1,11.7,10,.3.1.3.3,0,.5-.6-.5-.9-1.3-1.5-1.7-2.2-.7-5.6-5-7.3-5.7s-1.4-.1-1.2.9c1.7.9,3.9,1.9,5,3.5-1.6-.2-3.1-1.2-4.5-2-1,1.2-2.7-.1-2-1.5-1.7-1.1-2.4-2.2-2-3.2-6.2-5.4-13-10.4-20.5-13.7l-.7-1c-2.6-.4-7.2-2.4-7.8-5l-.5-.5c-.2.4-.3.4-.5,0l-4.1-1.8v-.7c.2-.2.4-.3.6-.3,2.9,0,20.9,11.1,24,13s1.1.8,1.5,1.3Z"
          fill="#02034a"
        />
        <path
          d="M349.7,74.4c1.9.2,3.7.9,5.5,2.2,6.5,4.1,12.9,8.2,19.4,12.3,1.3.9,2.9,2.2,3.6,3.5,1.5,1.4,3.1,2.6,5,3.5,0,.6-.4.7-1,.5-.2.4-.3.4-.5,0-3.5-2.2-7.7-4.4-11-6.8s-4.1-4.5-7-4.7c-.7-.5-1.3-1-2-1.5-4.2-2.6-8.2-5.3-12.1-8.2v-.8Z"
          fill="#03022b"
        />
        <path
          d="M380.1,93.4c.9-1.1,1.3-.9,1,.5l.5.5c1.9-.5,4.2,1.6,5.6,3,.2,2.3,3.1,4.5,5.4,5.5l1.3.3c4.5,4.1,8.6,8.7,12.2,13.6,1.5,1.1,2.5,2.3,3,3.6v1c-6.4-5-10.2-10-16-15.2s-3-2.7-4.5-2.7c-1.9-2-4.1-5.4-6.5-7l.3-.6c-1.7-.7-4-1.3-4.3-3.4.5-.6.8-.6.6.2l1.4.8Z"
          fill="#000120"
        />
        <path
          d="M363.6,84.9l.7-.8c5.8,3.8,11.7,8,17.2,12.3,3.6,3.9,7.1,7.7,10.6,11.7,3,2,5.7,4.6,7.9,7.8,1,0,1.8.7,2.5,2,2.5.6,3.3,1.6,2.5,3-.7.6-1.6.4-.4,1.1s2.1,1,2.9,2.2c.3.9-2,.5,0,2.7l1,.5c.3,0,.7,0,1,0,1.6,2,2.2,2.9,1.5,5.5-2.4-2.7-5-6.9-6.8-9.9s-3.3-3.2-5.1-5.1-3.7-6.1-5.3-7.3-1.8-.5-2.6-1.1-2.8-4-4-5-2.9-1.4-4.3-2.5c.2-.2.2-.4,0-.5-3.2-3.3-6.7-6.8-11-8.2,0-.3,0-.6,0-.7-2.9-2.3-6-4.9-8.5-7.6Z"
          fill="#00013b"
        />
        <path d="M408.6,127.4c-.5-.1-.5,0-1-.5l1,.5Z" fill="#000339" />
        <path
          d="M388.6,103.4c4.3,4.4,8.1,7.4,11.5,12.5-2-1.1-3.7-4.7-5.2-5.8s-2.8-.9-3.2-1.3-1.4-3.1-2.6-4.1c-2.7-2.4-4-2.3-6.5-6s-.9-1.4-1-2.3c.1,0,.4,0,.5,0,.3-.2.5-.4.7-.3,2.2,1.2,5.7,5,5.8,7.3Z"
          fill="#00022e"
        />
        <path d="M383.1,101.9c0,0,0-.4,0-.5l.5.2-.5.2Z" fill="#00022e" />
        <path d="M410.1,128.9c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#000339" />
        <path
          d="M388.1,96.9h1.1s5.4,5.5,5.4,5.5c.4-.1.5,0,.5.5l.5.5c1.3,0,2.2,1.3,2.5,2.5,2.9,1.7,5.3,4.6,7,7.5,2,1.4,3.8,3.4,5,5.5.6-.1,1,.6.5,1,.2,1.6-.4,1-1.5.5-4.3-2.1-5.6-6-8.3-9s-7.4-6.1-8.2-8.5c-2.2-.3-8.6-7.1-4.5-6Z"
          fill="#02010e"
        />
        <path
          d="M416.1,124.9c.6,0,.9.6.5,1l.5.5c.9-.1,1.3.5.5,1l.5.5c2,.6,3.5,3.4,4,5.5l.5.5c.6-.2.8.4.5,1,1,1.5,1.6,3,2.5,4.5h-.5c-3.9-5.7-8-11.3-12-17,0-2.5,3.6,1,3,2.5Z"
          fill="#052c85"
        />
        <path
          d="M415.1,121.4c1.5,2,2.8,4.2,4.5,6-1.1,0-2.2-.8-3.5-2.5-.6-.8-2.7-3.5-3-2.5-.5-.2-.7-.7-1-1-.6-.7-.3-1,.5-.5.4,0,1.2,1.3,1-.2-1.5-1.3-2.4-3.2-3.5-4.8,2,1.4,3.5,3.6,5,5.5Z"
          fill="#0a1b71"
        />
        <path
          d="M412.6,120.9s-.3.4-.5.5c-.6-.6-1-1-1.5-1.5s-.3-.8-.5-1c-.7-.7-.4-1,.5-.5.7.8,1.4,1.6,2,2.5Z"
          fill="#083583"
        />
        <path d="M389.1,406.2c-.2,0-.4,0-.5,0,.4-.5.5-.6,1-1l-.5,1Z" fill="#020350" />
        <path d="M388.1,406.7c.1-.2.4-.3.5-.5-.1,0-.3.4-.5.5Z" fill="#03033e" />
        <path
          d="M419.6,127.4c0,0,0,.4,0,.5l1,1c0,.1,0,.4,0,.5l1,1c0,.1,0,.4,0,.5l.5.5v.5c.5.3.8.6,1,1v.5l.5.5c.5.2.5.3,0,.5,0,.3-.2.4-.5.5-.2-.3-.3-.7-.5-1l-.5-.5c-1.3-1.9-2.6-3.7-4-5.5l-.5-.5c-.2-.3-.3-.7-.5-1l-.5-.5c-.2-.3-.3-.7-.5-1l.2-.5c.8,1.1,2.4,2.1,3.3,3Z"
          fill="#020d4f"
        />
        <path
          d="M425.1,135.3c-.4-.4-1.1-.6-1.5-1,0-.1,0-.4,0-.5l-.5-.5c0-.2,0-.4,0-.5.7.8,1.6,1.4,2,2.5Z"
          fill="#0a1b71"
        />
        <path d="M423.1,132.3c0,.1,0,.3,0,.5-.3-.3-.6-.4-1-1,.3-.1.6,0,1,.5Z" fill="#09186d" />
        <path d="M423.1,132.3l-1-.5c0-.1,0-.3,0-.5,0,.1.6.4,1,1Z" fill="#0a1b71" />
        <path d="M422.1,131.3c0-.2-.4-.3-.5-.5.1.2.4.3.5.5Z" fill="#09186d" />
        <path d="M421.6,130.3l-1-1c.2.2.6.4,1,1Z" fill="#0a1b71" />
        <path d="M420.6,128.9l-1-1c.2.3.6.5,1,1Z" fill="#0a1b71" />
        <path
          d="M213.2,455.2l1.4-.5c5.9.4,11.7.9,17.5,1.5.4.4,1.1.7,2.1.7v.8c-3.1.4-6.1.3-9.3-.5l-.3.5c-.2.4-.6.2-1,0-.5,0-1,0-1.5,0-.4-.7-1.8-.6-2.5-.5l-10-2c.9-.4,2.1-.4,3.5,0Z"
          fill="#0b2791"
        />
        <path
          d="M201.2,452.2c0-.2.2-.5.4-.6.5-.4,10.2,2.5,11.4,2.9s.2.3.2.7c-1.1-.1-2.4.1-3.5,0-4.3-.4-7.4-1.4-11.5-2.5-.4-.1-.5-.3-.5-.5-.4-.1-.4-.3,0-.5.9-.7,2-.6,3.5.5Z"
          fill="#14318d"
        />
        <path
          d="M189.8,449.2l1,.5c.2-1,1-.8,1.5,0,2.6,0,4.4.6,5.5,2v.5c-.3.3-.7.3-1,0-.2,0-.3,0-.5,0l-1-.5c-2-.5-4-.9-6-1.5l-.5-.5c-.2,0-.3,0-.5,0l.5-.5c0-1,.7-.9,1,0Z"
          fill="#1f388c"
        />
        <path d="M197.7,452.2c.2,0,.4.3.5.5-.5-.1-1.2.2-1.5-.5.3,0,.7,0,1,0Z" fill="#15337f" />
        <path d="M196.2,452.2c-.8-.2-.9-.5-1-.5l1,.5Z" fill="#15337f" />
        <path d="M189.3,450.2c-.2,0-.4-.5-.5-.5l.5.5Z" fill="#183489" />
        <path
          d="M262.7,458.2c1.3,0,2.5,0,3.5.5-2.1,1-4.9.4-7.3.5s-1.3.5-1.5.5h-12c-1,0-3.2-.4-4.7-.5-.3-.4-.4-.7-.5-1,.8-.5,1.7-.8,2.6-.8h18.5c0,.1,1.3.8,1.3.8Z"
          fill="#143292"
        />
        <path
          d="M280.7,457.2c-1.7.2-3.5.8-5,1s-.7,0-1,0c-.8.4-1.6.5-2.5.5-1.9.1-4.1,0-6,0s-3-.5-3.5-.5l.7-.6c3-.2,5.9-.4,8.8-.4,1.3-.4,7.5-1.3,8.4-.7s.1.4,0,.7Z"
          fill="#0e36a4"
        />
        <path
          d="M234.2,457.7c1.7-1,4.5-.8,6,.5,1.3,0,1.1,0,.5,1-.7,0-1.3,0-2,0l-3-.5c-3.2,0-6.3-.4-9.5-.5-.6-.1-1.1-.3-1.5-.5-.8-1.3-.7-1,.6-.9,3,.3,5.8.7,8.9.9Z"
          fill="#1436a1"
        />
        <path d="M238.7,459.2c-.9,0-2.5.3-3-.5.9,0,2.5-.3,3,.5Z" fill="#143292" />
        <path d="M224.7,457.7c.5,0,1.3-.2,1.5.5-.8,0-2.1.3-2.5-.5.3,0,.7,0,1,0Z" fill="#0b0b3c" />
        <path d="M274.7,458.2c-.4.8-1.7.5-2.5.5.2,0,1.6-.4,2.5-.5Z" fill="#0a0b48" />
        <path
          d="M346.7,434.2c1.5-1.3,7.4-3.9,4.5-1-.1,0-.4,0-.5,0l-1.5,1c-9.4,5.5-18.3,9.2-28.5,13s-1.6.7-2.5,1c-3.3.8-6.7,1.3-10.2,1.6l-.3-.6v-.6c2.5-.2,4.8-.6,7-1.4,2.8-1.6,7.4-3.8,10.5-3,6.6-3.2,13.2-6.2,20-9-.4-.8.9-1.6,1.5-1Z"
          fill="#092379"
        />
        <path d="M349.2,434.2c.4-.5.9-.8,1.5-1-.2,1-1.1.8-1.5,1Z" fill="#0a1968" />
        <path
          d="M318.2,448.2c-.1,0-.4,0-.5,0l-1,.5c-1.6.6-3.3,1-5,1.5-3.2.7-6.4,1.4-9.7,2.1l.2.4c.4.1.4.3,0,.5-.3,0-.7,0-1,0-.2.2-.3.2-.5,0-1.1.3-2.3.6-3.5,1-.2,0-.3,0-.5,0-1.2.2-1.4-.2-.5-1,.4-1.3,1.7-1.8,4-1.5.6-2.1,5.7-3.2,7.5-2.5,1.4-.2,3.1.2,4.6-.1s4-2.4,5.9-.9Z"
          fill="#0f2b80"
        />
        <path
          d="M311.7,450.2c-1.5.5-3,1.1-4.5,1.5l-.5.5c-.4.1-1.1-.1-1.5,0-.1.2-.3.2-.5,0-.3.3-.8.5-1.5.5-.3.2-.7.3-1,0-.6,0-1.6.4-1.5-.5l4.5-1.3,6.5-.7Z"
          fill="#193288"
        />
        <path
          d="M300.7,453.2c.3.2.2.3,0,.5-.2,0-.3,0-.5,0-1,.2-2,.3-3,.5.9-1.1,2.3-.8,3.5-1Z"
          fill="#031c75"
        />
        <path d="M304.7,452.2c.3.2.3.3,0,.5-.4,0-1,0-1.5,0,.2,0,.9-.3,1.5-.5Z" fill="#0f2b80" />
        <path d="M303.2,452.7c0,0-.4.4-1,.5v-.5c.3,0,.7,0,1,0Z" fill="#17112c" />
        <path d="M317.7,448.2c-.1,0-.5.3-1,.5l1-.5Z" fill="#092379" />
        <path d="M306.7,452.2l.5-.5s0,.4-.5.5Z" fill="#17112c" />
        <path d="M304.7,452.7v-.5c.2,0,.3,0,.5,0,0,.2-.3.5-.5.5Z" fill="#17112c" />
        <path d="M300.7,453.7v-.5c.2,0,.3,0,.5,0,0,.2-.3.4-.5.5Z" fill="#100d35" />
        <path
          d="M296.2,453.2c.1.3.5.6.5,1l-1.5.5c-.5.1-1.1-.2-1.5.5-.3,0-.7,0-1,0l-1.5.5c-3.2.4-6.4.7-9.5,1.5-.3,0-.7,0-1,0-2.4-1-5.9-.3-8.5,0-.4-.1-.4-.3,0-.5l.8-.7c7.1-1,14.1-2.2,21.2-3.4l2,.6Z"
          fill="#092195"
        />
        <path d="M292.7,455.2c0,0-.8.4-1.5.5l1.5-.5Z" fill="#100d35" />
        <path d="M296.7,454.2c0,.9-.9.4-1.5.5.4-.5.9-.4,1.5-.5Z" fill="#031c75" />
        <path
          d="M48.8,185.8c.4.2.4.3,0,.5-.8,2-1.8,3.7-3,5,1-3.6,1.8-7.4,3-11s2.8-6.9,4.5-10.5c.3-1.1.8-1.9,1.5-2.5-.5,2-1,5-1.9,6.9-2.6,5.7-2.9,4.8-4.1,11.6Z"
          fill="#4843b0"
        />
        <path
          d="M59.3,156.8c-.1.3-.3.3-.5,0,2.2-4.6,4.4-9,7-13.5h.5c-2.5,4.3-4.8,9-7,13.5Z"
          fill="#7279d5"
        />
        <path
          d="M54.8,167.3c-.4.8-1.2,1.8-1.5,2.5,1.2-4.4,3.5-8.8,5.5-13h.5c-1.6,3.2-2.9,7-4.5,10.5Z"
          fill="#524eb8"
        />
        <path
          d="M46.8,191.8v1c.3,1.4.2,2.6-1,3.5-.5,1.8-.7,2.6-1,4.5-1.3,1.6-1.9,4-2.5,6-.4-2.2.5-4,1-6,.7-2.9,1.5-6.9,2.5-9.5s1.8-3.7,3-5c1.1,1-.4,5.4-2,5.5Z"
          fill="#2c3ab8"
        />
        <path d="M59.3,341.7c.8,2,1.6,4.8,2.5,7-1.7-2-2.4-4.6-3.5-7h1Z" fill="#4683f6" />
        <path
          d="M63.3,347.7c-.3-.2-.7-.3-1-.5-.5-1.9-1.3-4.2-2-6,1.1,2.1,2.2,4.2,3,6.5Z"
          fill="#4683f6"
        />
        <path d="M57.8,335.7l-.5-1c.1.3.3.6.5,1Z" fill="#3c76f6" />
        <path d="M59.3,339.2c-.5-1-1-1.8-1.5-3,1,.7,1.1,2,1.5,3Z" fill="#3c76f6" />
        <path d="M60.3,341.2c-.2-.5-.7-1.1-1-2,.3.6.7,1.4,1,2Z" fill="#2d71f3" />
        <path
          d="M65.8,350.7c.1.3,0,1.1,0,1.5-.7-1.3-1.9-2.4-2-4,.4.4,1.8,2.1,2,2.5Z"
          fill="#a0cbf6"
        />
        <path d="M71.3,362.2c-.3-.5-.7-1-1-1.5v-.5c.3.6,1.1,1,1,2Z" fill="#4778f3" />
        <path
          d="M51.3,318.8c1.2.6,2.4,3.9,1.5,5-.9,3.5-.7-1.9-2.5-1.5-.2-.6-.7-1.2-1-2,.1-.5.7-.6,1.2-.6s-1.2.3-1.2-.4c-.4-1.1-1.1-2.3-1.5-3.5,1.6.1,1.6.1,1.5-1.5,1,1.2,1.7,2.7,2,4.5Z"
          fill="#276aef"
        />
        <path d="M49.3,319.3c2.3-.2,2.2,1,0,1,0-.3,0-.7,0-1Z" fill="#2868f2" />
        <path d="M49.1,316.8c.3.2.3.3,0,.5v-.5Z" fill="#2868f2" />
        <path
          d="M57.3,164.8c3-2.8,1.4.7,0,2.5.8.6.6,1.6-.5,3,0,2.1-1.6,5.5-3,7-.5,2.4-1.4,4.3-2.5,6.5,0,2.3-.5,6.7-2.5,8-.8,1.4-1.3,2.9-1.5,4.5.4.1.4.3,0,.5l-1.5-.5c.3-1.2.7-2.3,1-3.5v-1c.4-2.2,1.5-3.1,2-5.5s0-.3,0-.5c2.9-7,5.3-14.2,8.5-21Z"
          fill="#1c2fb5"
        />
        <path
          d="M46.8,204.3c-.2,1.5-.4,3.1-1,4.5.4.1.4.3,0,.5l-1,5c.9,1.4.5,4.1-.5,5.5,0,4.4-.5,8.8-1.5,13-.1.4-.3.4-.5,0,0-1,.5-3.5-.5-4,0,1.6-.8,3.5-1,5-.2-2.7,0-4.9.5-7.5.9-6.7,2.1-13.5,4-20,0-.2,0-.3,0-.5,0-1.5.4-2.8,1-4,.8-.1,1,.7.5,2.5Z"
          fill="#124be6"
        />
        <path d="M41.3,226.3c.6-6.6,1.5-13.9,4-20-1.3,6.6-2.7,13.4-4,20Z" fill="#0f41dd" />
        <path
          d="M48.8,196.3c1,2.1-.7,6.1-2,8,0-.8.3-2.1-.5-2.5-.2-.5,0-1,.5-1.5.2-1,.2-2.4.5-3.5s0-.3,0-.5c0-1.1.4-2,1-2.5l.5-1c-.4-.1-.4-.3,0-.5.3,0,.5-.1.8,0,.4.1-.6,3.5-.8,4Z"
          fill="#154bd5"
        />
        <path
          d="M46.3,201.8c-.3,1.4-.8,2.9-1,4,.2-1.7,0-4.6,1.5-5.5,0,.4-.4.9-.5,1.5Z"
          fill="#0f41dd"
        />
        <path
          d="M42.8,240.8c1.4,2.2,1.1,5.7,0,8-.8.4-.5,1-.5,1.7-.1,2.3,0,4.9,0,7.3h-.5c0-4.3,0-8.7,0-13l.5-1.5c-.4-1.8-.4-3.8,0-5.5,1.2-.4.8,2,.5,3Z"
          fill="#020750"
        />
        <path
          d="M43.3,236.8l.9.7c0,.4-.5,4.5-1.4,3.3,0-.9.3-3-.5-3,0-.5,0-1,0-1.5.1-.4.3-.4.5,0,.3-.3.4-.2.5.5Z"
          fill="#010656"
        />
        <path
          d="M42.3,243.3c-.1.4-.3.4-.5,0,0-1.7,0-3.5,0-5.2l.5-.3c0,1.8,0,3.7,0,5.5Z"
          fill="#03107a"
        />
        <path d="M42.8,236.3h-.5c0-1.2,0-2.3,0-3.5h.5c.6,1.1.5,2.3,0,3.5Z" fill="#03107a" />
        <path d="M41.8,244.8c0-.5,0-1,0-1.5h.5c0,.5.2,1.3-.5,1.5Z" fill="#010656" />
        <path
          d="M44.3,263.3c1.7,3.4,2.1,8.4,1,12,0,1.6-.2,2.9-.5,4-.4-.2-.4-.7-.5-1l-.5-4c0-.8,0-1.7,0-2.5l-.5-3.5c0-1,0-2,0-3-.4-1-.4-2,0-3,.1-.4.3-.4.5,0,.2.2.4.5.5,1Z"
          fill="#071e92"
        />
        <path
          d="M42.8,248.8c.9-2.9,2,3.3,1.3,4.5,0,3-.2,6-.3,9h-.5c-.2.3-.4.1-.5-.5,0-4.3,0-8.7,0-13Z"
          fill="#031193"
        />
        <path d="M44.3,278.3c-.5-1-.4-.9-.5-2s0-1.3,0-2c1,.9.3,2.7.5,4Z" fill="#060b58" />
        <path d="M43.3,262.3c0,1,0,2,0,3-.9-.7-.5-2.4-.5-3.5l.5.5Z" fill="#060b58" />
        <path d="M43.8,271.8c-.9-.7-.5-2.4-.5-3.5.9.7.5,2.4.5,3.5Z" fill="#060b58" />
        <path
          d="M52.3,313.8c1.8,1.6,2.5,4.6,2.5,7,1.9,1.1,3.3,5.5,2.5,7.5,0,.4-.5.9-.5,1-1.8-4.1-3.4-8.3-5-12.5-.2-.1-.2-.3,0-.5l-.5-1c0-.2,0-.3,0-.5-.3-.3-.3-.7,0-1,0-.4,0-.9.5-1,.7-.2.8.4.5,1Z"
          fill="#0e1149"
        />
        <path d="M51.3,314.8c-.5-.2-.4-.6-.5-1h.5c0,.3,0,.7,0,1Z" fill="#a5d8f3" />
        <path d="M51.8,316.3c-.2.3-.3.2-.5,0,0-.3,0-.7,0-1,.5.2.4.6.5,1Z" fill="#a5d8f3" />
        <path d="M57.8,331.7c0-.3-.4-.5-.5-1l.5,1Z" fill="#072bad" />
        <path d="M65.3,348.2l-.5-.5c.2-.2.3-.2.5,0,0,.1,0,.3,0,.5Z" fill="#a0cbf6" />
        <path d="M65.3,347.7h-.5v-.5s.3.1.5.5Z" fill="#092eae" />
        <path d="M57.3,330.2s-.4.1-.5-.5l.5.5Z" fill="#072bad" />
        <path d="M51.8,316.8c-.2,0-.5-.3-.5-.5h.5c0,.2,0,.4,0,.5Z" fill="#acdff5" />
        <path d="M50.8,315.8s-.4-.1-.5-.5l.5.5Z" fill="#acdff5" />
        <path
          d="M47.3,287.8c1.1-.4,2,5.4,1.9,5.7l-.9.8.5,2c.4.2.4.3,0,.5.5,3-.4,2.6-1,0,0-.3,0-.7,0-1l-.5-1.5c-.4-2.1-1.2-4.4-1.5-6.5s0-1.7,0-2.5c.7.3,1.2,1.2,1.5,2.5Z"
          fill="#0e2aaf"
        />
        <path
          d="M47.8,296.8c.7,1.6,1.1,2.5,1,0,1.6,1.5,2.2,3.9,1.5,6,0,.7-.2,1.2-.5,1.5-.7-.6-.8-1.6-1-2.5-.4-1.6-.8-3.3-1-5Z"
          fill="#0827a9"
        />
        <path d="M47.8,295.8c-.7-.3-.4-1-.5-1.5.7.2.5,1,.5,1.5Z" fill="#0827a9" />
        <path
          d="M50.3,303.3l.5,1c1.9,1.3,2.9,4.9,2,7,.6,2,.4,2.8-.5,2.5-.1-.3-.4-.7-.5-1-.6-2-1.1-3.9-1.5-6l-.5-1.5c0-.3,0-.7,0-1,0-.5-.1-1.3.5-1.5.4.1.4.3,0,.5Z"
          fill="#032ab4"
        />
        <path d="M50.3,306.8c0-.1-.4-.5-.5-1.5l.5,1.5Z" fill="#0827a9" />
        <path
          d="M47.3,287.8c-.3-.7-1.3-2-1.5-2.5-.8-2.1-.9-3.7-1-6s-.3-3.2.5-4c2,3.3,2.6,8.7,2,12.5Z"
          fill="#0421a8"
        />
        <path
          d="M56.3,320.8c.3-.3.5-.2.5.5.2,0,.5-.1.7,0,.5,0,2.3,5.1,1.3,5.6,1.6,3.8,2.8,7.7,4.5,11.5-.6-1.3-2-2.8-2.4-4.4l-.6.4c-.9-2-2.2-4-3-6s-1.6-5.2-2.5-7.5c-.8-3.2.4-2.4,1.5,0Z"
          fill="#072bad"
        />
        <path d="M61.3,336.7c-.1-.3-.3-.6-.5-1l.5,1Z" fill="#072bad" />
        <path d="M66.3,347.2c-.2-.1-.4-.3-.5-.5.4,0,.4.2.5.5Z" fill="#092eae" />
        <path d="M65.8,346.2c0-.1-.4-.3-.5-.5l.5.5Z" fill="#092eae" />
        <path d="M64.8,344.2c0,0-.4-.2-.5-.5l.5.5Z" fill="#092eae" />
        <path d="M61.8,337.7s-.3-.2-.5-.5l.5.5Z" fill="#072bad" />
        <path d="M60.8,335.2c0-.1-.4-.3-.5-.5l.5.5Z" fill="#072bad" />
        <path d="M66.8,346.2c-.2-.1-.4-.3-.5-.5.2.2.4.3.5.5Z" fill="#092eae" />
        <path
          d="M94.3,111.4c.5.2.3,1.1-.5,2.5-.7,1.9-2.3,3.9-4,5-2.4,3.8-5.3,7.4-8.5,10.5-.4.2-.7.2-1,0l8.5-12c1.9-2,3.6-4,5.5-6Z"
          fill="#081779"
        />
        <path
          d="M104.3,102.4c.5.7-.7,2-1.5,2-2,2.9-4.8,5.7-7.5,8,.2.6-.8,1.7-1.5,1.5-2.5,1.2.3-1.2.5-2.5.6-.7,1-1.5,1.5-2,.1-.3.3-.7.5-1,1.3-1.7,6.8-7.6,8.3-8.3s.8-.2,1.2-.2c-.8.9-1.4,2.4-1.5,2.5Z"
          fill="#020341"
        />
        <path
          d="M108.8,96.9c-1.1,1.1-2,1.8-3,3-3.3,3.2-6.9,6.2-10,9.5,0-1,.5-1.5,1.1-2.2,1.5-1.9,6.5-7.1,8.4-8.6s2.1-1.5,3.5-1.7Z"
          fill="#1b57d0"
        />
        <path d="M84.8,121.4c.1-.2.4-.3.5-.5-.1.3-.1.5-.5.5Z" fill="#2e60d4" />
        <path
          d="M81.3,125.9c-.4.6-.5,2-1.5,2.5.4-.7.5-1.9.5-2,.1-.2.4-.3.5-.5h.5Z"
          fill="#2e60d4"
        />
        <path d="M81.8,125.4l1-1c-.4.5-.9.8-1,1Z" fill="#2e60d4" />
        <path d="M83.3,123.4c.1-.2.3-.3.5-.5-.1.2-.3.3-.5.5Z" fill="#2e60d4" />
        <path
          d="M158.3,64.4c.1-.3.3-.3.5,0,.1-.4.3-.4.5,0,.2.2.2.3,0,.5-.2.4-.3.4-.5,0l-.5.5c-5,3-11,6.6-16.5,9-.3.8-1.2,1.7-2,1.5-5.4,4-11.3,7.9-17,11.5-1.2,1.8-3.5,3.5-5.5,4l-1,1c-.1.4-.3.4-.5,0-.7.5-1.7,1.9-2.5,1.3,1-1,2-1.8,3-2.8,5.8-5.4,14.7-11.7,21.5-16,5.2-3.9,11.5-7.5,17.6-10.3s1,0,1.4.3l.5-.5c.1-.4.3-.4.5,0,.2-.2.3-.2.5,0Z"
          fill="#02032c"
        />
        <path
          d="M174.3,56.9c.6.7.3,1-.5.5-2.2,1.2-4.6,2.3-6.9,3.4l-.6-.4c-1.6.4-3.1,1.1-4.5,2l-3,1.5c-.1.3-.3.3-.5,0l-.5.5c-.2,0-.3,0-.5,0l-.5.5c-5.9,2.1-13.6,6.6-19,10l-.5-.2.5-.8c.1,0,.4,0,.5,0l.5-.5c7.2-4.4,15.5-9.4,23-13s9.5-4.7,11.5-5c1.2.6,1.6,1.1,1,1.5Z"
          fill="#215ae3"
        />
        <path d="M128.8,78.9l.5-.5c-.2,0-.3.4-.5.5Z" fill="#2f56d3" />
        <path d="M130.3,77.9l.5-.5c-.2.1-.3.4-.5.5Z" fill="#2f56d3" />
        <path d="M138.3,73.9l.5-.5c0,0-.2.3-.5.5Z" fill="#2f56d3" />
        <path
          d="M123.3,87.9c.6.8-.6,1.8-1.5,1.5.5,1.5-.2,1.6-1.5,1-.7,1.6-2.1,2.9-4.1,3.8-1.4,1.9-3.1,3.9-5.4,4.5-1.9,2.5-4.3,5.2-7.5,6.3-.7.7-1,.4-.5-.5.5-.6,1-1.4,1.5-2h.5l1.5-1.5c3.3-2.7,6.5-5.6,9.5-8.5.1,0,.4,0,.5,0l1-1c1.8-1.4,3.7-2.6,5.5-4,.7-.5,1-.3.5.5Z"
          fill="#083cbb"
        />
        <path d="M104.8,102.4c.3-.8.9-1,1.5-1.5l-1.5,1.5Z" fill="#020341" />
        <path
          d="M70.8,141.3c-.8,1.5-1.3,3.2-2,4.5-.1,1.1-1,2.7-2,3-.8,1.2-1.7,2-2.5,2.5,0-2.6,1.7-5.8,3-8l.5-.5c.3-.4.4-1.4,1-1.5.2-.1.6-.1,1,0,.2-.1.3-.4.5-.5,0,.2.4.3.5.5Z"
          fill="#2a38b6"
        />
        <path
          d="M66.8,148.8c-1,3.9-3,8.4-5.5,11.5-.2,2-2,7.1-4,7,.4-1.2.9-2,1.5-3l-1.5.5c2-4.2,4.7-9.5,7-13.5s1.7-2.8,2.5-2.5Z"
          fill="#1c35b7"
        />
        <path d="M69.8,141.3c-1,.6-.7,0-1,0l.2-.5.8.5Z" fill="#333db6" />
        <path d="M67.3,143.3c.1-.2.4-.3.5-.5l-.5.5Z" fill="#333db6" />
        <path
          d="M81.3,129.4c.1.9-.8,2-1.5,2.5,0,.3,0,.4-.5.5.3.1.3.3,0,.5-1.3,1.8-2.5,3.6-3.5,5.5.1.5,0,.6-.5.5-.7.7-1,1.4-1,2l.2,1.4c-1.7,2.1-3.3,4.3-4.7,6.6.3.2.5.4.4.5-.4.8-4.7,8.3-5.2,8.5s-.5,0-.7,0c-.1.4-.3.4-.5,0,.5-3.5,2.4-7.1,4.5-10l.5-.5c-.4-.2-.4-.3,0-.5l.5-.5c-.4-.2-.4-.3,0-.5l.5-.5c1.6-1.9,3.1-5.3,4.5-7.5l1-1c0-.1,0-.4,0-.5l1-1c.2-.3.3-.7.5-1l1-1c0-.1,0-.4,0-.5l1-1c0-.1,0-.4,0-.5l1-1c.2-.3.3-.7.5-1l.8-.5.2.5Z"
          fill="#030973"
        />
        <path
          d="M69.3,145.8c0,.1,0,.4,0,.5l-.5.5c0,.1,0,.4,0,.5l-.5.5c-1.5,3.3-2.9,6.7-4.5,10,0,.9-.6,2.5-1.5,2.5-.9,1.3-1.3,1.8-1,0,1.9-4.1,3.4-7.5,5.5-11.5s1.5-2.1,2-3h.5Z"
          fill="#0d4acb"
        />
        <path d="M76.8,134.3c.4-.6.9-.8,1-1l-1,1Z" fill="#081779" />
        <path d="M77.8,132.8c.4-.6.9-.9,1-1l-1,1Z" fill="#081779" />
        <path d="M78.8,131.3c.4-.6.9-.8,1-1l-1,1Z" fill="#081779" />
        <path d="M75.3,136.3c.4-.6.9-.9,1-1l-1,1Z" fill="#081779" />
        <path d="M74.3,137.8c.4-.6.9-.9,1-1l-1,1Z" fill="#081779" />
        <path d="M69.3,145.8c0-.3.4-.4.5-.5,0,.2-.4.4-.5.5Z" fill="#2a38b6" />
        <path
          d="M265.7,40.9c5.9.8,11.9,1.9,17.7,2.5s3.8,1,5.8,1l-1,1c2.7-.2,4.9,0,7.5.5s.8.2,1.5,0c-.7,2-2.7,1-4.5,1,0,.4-.3.4-.5,0-.7-.2-1.4-.3-2-.5,0,.3-.2.3-.5,0l-4.5-1c-.2.4-.3.4-.5,0l-14.5-2c-1.8.5-3.8.5-6,0-.5.4-1,.3-1.5,0-.7.7-1.8.8-2.5,0-2.5-.2-5-.4-7.5-.5-.4-.1-.4-.3,0-.5.6-.4,2.9-.2,2.8-.2-3.9,0-7.9,0-11.8-.3-.4-.1-.4-.3,0-.5,2.7-.7,5.9-.9,8.5,0s-2.5-.3-2-1c5.3,0,10.2-.2,15.5.5Z"
          fill="#1756ed"
        />
        <path
          d="M244.2,40.4c1.8-.5,3.7-.4,5.5,0,.2,0,.3,0,.5,0l2,1c-2.8,0-5.7,0-8.5,0-3,1.2-6,1.2-9,0v-.5c3.1-.2,6.3-.4,9.5-.5Z"
          fill="#124deb"
        />
        <path d="M249.7,40.4c-1.8,0-3.7,0-5.5,0,1.2-.8,4.2-.9,5.5,0Z" fill="#1756ed" />
        <path
          d="M234.7,41.4c3,0,6,0,9,0v.5c3,.1,6,.3,9,.5v.5c-4,0-8,.3-12,.5-4.7,1.1-9.4,1.3-14,.5-1.8.3-3.7.6-5.5.5-.5,0-.7-.1-.5-.5,1.1-.8,2.6-1.3,4.5-1.5.2,0,.3,0,.5,0l2-.5c.3,0,.7,0,1,0,1.4,0,2.7-.2,4-.5.7,0,1.3,0,2,0Z"
          fill="#0f56eb"
        />
        <path
          d="M225.2,42.4c-1.1.5-3.4,1.3-4.5,1.5-.6.8-2.1.9-2.5,0-.5-.3-.2-.6,1-1,.3,0,.7,0,1,0,1.6-.2,3.4-.3,5-.5Z"
          fill="#124deb"
        />
        <path d="M232.7,41.4c-.5,1.3-2.5.4-4,.5.8-.9,2.7-.5,4-.5Z" fill="#124deb" />
        <path d="M227.7,41.9l-2,.5c.1,0,1-.4,2-.5Z" fill="#124deb" />
        <path
          d="M218.2,43.9c.8,0,1.7.1,2.5,0l.5.5-1,.5c-1.9,1.3-4.8,1.8-7,1-.7.3-1.2.3-1.5,0-1.3.2-1.5-.2-.5-1l1-.5c.5,0,1,0,1.5,0,1.5-.6,3-.8,4.5-.5Z"
          fill="#1b51df"
        />
        <path d="M219.2,42.9l-1,1c-1.5.2-3,.3-4.5.5,1.6-.9,3.7-1.2,5.5-1.5Z" fill="#1d49e3" />
        <path
          d="M212.2,44.4c-.1.5-.6.4-1,.5,0,.9-1.3,1-2,.5-.2.4-.3.4-.5,0h-2v-.5c.2,0,.3,0,.5,0,1.6-.2,3.4-.3,5-.5Z"
          fill="#1b4adc"
        />
        <path
          d="M209.2,46.4c-1,.5-2.1.9-3.5,1l-8.5,2c-4.5,2.5-9.9,4-15,4.5l-4.5,1.5c.2,1.2-2.6,2.2-3.5,1.5l-1-1.5c.4,0,1.3.6,1.7.4.6-.2.6-1.2.9-1.4s.8.5.9.4q.2.2,0,0c.2,0,1.1-1.2,1.9-1.4s1.3.4,1.5.3,1.1-1.7,2.1-1.9c3.4-1,7.7-2.6,11-3l1-.5c.3,0,.7,0,1,0,2.7-.4,5.3-1.1,8-2,.2,0,.3,0,.5,0l1.5-.5h.5c.9-.4,1.9-.5,3-.5.2,0,.3,0,.5,0,1.3.2,1.2.6,0,1Z"
          fill="#1851e9"
        />
        <path
          d="M203.2,46.4c-1.9,1-4.9,2-7,2.3s-.9-.3-1-.3c.7-.3,1.8-.8,2.5-1,1.7-.4,3.8-.7,5.5-1Z"
          fill="#174ee6"
        />
        <path d="M194.3,48.4c-.1.5-.6.4-1,.5.1-.5.6-.5,1-.5Z" fill="#174ee6" />
        <path d="M206.7,45.4c.7,0,1.3,0,2,0-.9.2-2,.3-3,.5v-.5c.3,0,.7,0,1,0Z" fill="#174ee6" />
        <path d="M205.2,45.9c-.4.2-.7.7-1.5.5.1,0,.7-.4,1.5-.5Z" fill="#174ee6" />
        <path d="M205.7,45.9c-.2,0-.3,0-.5,0,.2,0,.3-.5.5-.5v.5Z" fill="#1b4adc" />
        <path
          d="M383.6,91.9l-.5.5c-4.4-1.3-8-5.2-11-8.5-.7-.7-.4-1,.5-.5,4,2.9,7.2,5.3,11,8.5Z"
          fill="#0a48b1"
        />
        <path
          d="M341.7,64.4c2.1,1,4.5,2.9,6.5,4,.8.4.6.6-.5.5-2,.7-4.6-1.2-5.9-2.4-1.7.2-3.4-1-4.1-2.6-.7-.7-.4-.7.5-.5.9.4,2.6.6,3.5,1Z"
          fill="#083eb3"
        />
        <path
          d="M367.6,79.9c.7.7.4,1-.5.5-3.2-.3-6.9-2.7-8.5-5.5-.7-.7-.4-.9.5-.5,2.9,1.8,5.7,3.6,8.5,5.5Z"
          fill="#0942af"
        />
        <path
          d="M389.6,96.4c1.4,1.7,3.4,4,5,5.5.2.2.2.3,0,.5-2.1-1.9-4.4-3.7-6.5-5.5-.4-.1-.4-.3,0-.5.1-.3.3-.3.5,0,.3,0,.7,0,1,0Z"
          fill="#0b51a9"
        />
        <path
          d="M354.7,71.9c.7.7.4.8-.5.5-1.8.7-4.2-.6-4.5-2.5l-.5-.5c-.2.4-.3.4-.5,0l-.5-.5c-.1.4-.3.4-.5,0l.5-.5c2.3,1.2,4.2,2.2,6.5,3.5Z"
          fill="#0a4eb0"
        />
        <path
          d="M372.6,83.4l-.5.5c-2.2.2-4.4-1.3-5-3.5l.5-.5c1.7,1.2,3.3,2.3,5,3.5Z"
          fill="#083abb"
        />
        <path
          d="M388.6,96.4c-.2,0-.4,0-.5,0-1.2,1.5-5.7-2.5-5-4l.5-.5c1.7,1.4,3.8,2.5,5,4.5Z"
          fill="#0a4aae"
        />
        <path
          d="M359.1,74.4l-.5.5c-1.8.7-4.2-.6-4.5-2.5l.5-.5c1.5.9,3,1.6,4.5,2.5Z"
          fill="#0a4dc2"
        />
        <path
          d="M240.7,43.4c6.5-.5,13-.5,19.5,0,.8,0,1.7,0,2.5,0l1.5.5c1.1-.4,3-.5,4,0l.5.5.5-.5,9,1c4,.6,8,1.3,12,2,.5-.4,1.4-.3,2,0,.2,0,.3,0,.5,0l4.5,1.5c-1.6-.2-3.9-1-5,0-.2.4-.5.4-1,0-2.1,0-3.9-.3-5.5-1l-1-.5c-.4.7-1,.7-1.5,0l-1.5-.5c-.3.4-.6.3-1,0h-.5l-1.5-.5c-.4.4-1.1.3-1.5,0,0,.4-.3.4-.5,0l-.5-.5c-.6.3-1.4.4-2,0-.9.6-2.4.8-3,0l-2-.5c-.4.9-2.5.8-3,0l-2-.5c-.7,1-2.3.9-3,0h-3c-5.7-.6-12.3-.7-18,0-1.2.5-2,.5-2.5,0l-2.5.5c-.4.2-.9.2-1.5,0-.7.6-2.5.7-3.5.5-1.4.4-2.9.5-4.5.5-.6.4-1.7.3-2.5,0-3.6,1.4-8,1.8-12,2,0,.3-.3.5-1,.5-.4.6-1.2.7-1.5,0l-1,.5c-.4.7-1.2.9-2.5.5-5.1,1.7-10.7,3.1-16,4-.1.4-.6.2-1,0-1.8,1.3-3.9,2.2-6.5,2.5-2,1.3-5.1,2.1-7.5,2.5-.2.4-.3.4-.5,0-2.4.7-2.1-.5,0-1,.2-.1.3-.4.5-.5.9-.5,2.5-1.1,3.5-1.5l4.5-1.5c4.9-1.6,10-3.1,15-4.5l8.5-2,7.5-1.5c2.3-.4,4.7-.7,7-1,2.1-.4,4.3-.7,6.5-1,4.7-.3,9.3-.4,14-.5Z"
          fill="#01021f"
        />
        <path
          d="M313.7,53.9c.8.3,1.1.6,1,1-2,.3-4.1-.1-6.2-1.3-.4.1-.8.2-1.2.2-3.1-.7-6.3-1.6-9.3-2.5s-.6-.3-.9-.6-.6-.6-.8-.9c-.6-.3-.4-.5.5-.5,5.9,1.3,11.2,2.8,17,4.5Z"
          fill="#072cb9"
        />
        <path
          d="M338.2,63.4l-.5.5c-.6.7-1.4.3-1.5-.5h-.5l-.5-.5c-.2.4-.3.4-.5,0l-1-.5c-1.1.8-2.7.5-2.5-1l-3.6-1.3c-.5.2-.6,0-.4-.7-.5-.5-.1-.7,1-.5,3.4,1.4,6.7,3,10,4.5Z"
          fill="#0a3eb2"
        />
        <path
          d="M319.7,55.9c.2,0,.4,0,.5,0l.5.5c.3,0,.7,0,1,0l.5.5c.3,0,.7,0,1,0l.5.5c1.6.5,2.8.8,4.5,1.5l-1,.5c-.2.4-.3.4-.5,0-1.5.5-3.3,0-4-1.5l-.5-.5c-.2,1.3-.6,1.3-1,0l-.5-.5c-.2,1.3-.6,1.3-1,0l-.5-.5c-.1.4-.3.4-.5,0-1-.9,0-.9,1-.5Z"
          fill="#083dba"
        />
        <path
          d="M291.2,48.4c.3,0,.7,0,1,0s.3,0,.5,0l1,.5c.5,0,1,0,1.5,0l1,.5c.2,0,.3,0,.5,0l-.5.5c-.5,1.3-3.8.7-4-.5l-.5-.5c-.3,1.3-1.5,1.2-2,0-.5-.8,0-1,1.5-.5Z"
          fill="#0918c9"
        />
        <path
          d="M319.7,55.9c-.4,0-.8,0-1,.5-1.3,1.3-3.3-.4-4-1.5l-1-1c2,.6,4.3.8,6,2Z"
          fill="#093bb0"
        />
        <path d="M296.2,49.4l-1-.5c.8.2.9.5,1,.5Z" fill="#072cb9" />
        <path d="M293.7,48.9l-1-.5c.9,0,.9.5,1,.5Z" fill="#0834af" />
        <path d="M323.7,57.4l-.5-.5c.4.1.5.5.5.5Z" fill="#093bb0" />
        <path d="M322.2,56.9l-.5-.5c.4.1.5.5.5.5Z" fill="#093bb0" />
        <path d="M320.7,56.4c-.2,0-.4-.3-.5-.5.2,0,.4.3.5.5Z" fill="#093bb0" />
        <path
          d="M402.1,108.4c1.2,1.5,2.3,3,3.5,4.5.7.7.4,1-.5.5-2.3-2.5-4.6-5.1-7-7.5-.7-.7-.4-1,.5-.5h.5c.9,1,1.7,2.3,3,3Z"
          fill="#093e8d"
        />
        <path
          d="M397.1,103.4c.7.6,1.2,1.3,1.5,2l-.5.5c-.8-.8-1.6-1.7-2.5-2.5l-.5-.5c-.2-.2-.3-.3-.5-.5v-.5c.5.5,1.8.9,2.5,1.5Z"
          fill="#0944b2"
        />
        <path d="M399.1,105.4h-.5l-1.5-2c.8.7,1.3,1.2,2,2Z" fill="#040e45" />
        <path
          d="M410.6,118.4l-.5.5c-1.7-1.8-3.3-3.7-5-5.5l.5-.5c1.6,1.9,3.4,3.6,5,5.5Z"
          fill="#082e6b"
        />
        <path
          d="M308.7,58.4c.5-.2,1-.3,1.5-.1,7,2.4,14.4,5.1,21.1,8.2s2.4,1.1,3.5,1.9.7.6,1,1l4,2.5c-.5.7-1.2.8-2.2.3.3,1.2-.4,1.5-2.3.7-.9,1.2-4.2,0-4-1.5-1-.1-1.8-.4-2.5-1-1.9.8-5.4-.7-6.2-2.4l-2.3-1.1c-.2.4-.3.4-.5,0l-1-.5c-1.8,1-5.1-.2-6-2-6.6-2-13.3-3.8-20-5.5-.7.7-1,.4-.5-.5-1.2,0-5.8-1.3-3.5-2.4s7.2.6,7.5,1.9c.9-.6.6-1.2,0-2,2.7-1.1,6.6.6,9.3,1.9l3.2.6Z"
          fill="#070352"
        />
        <path
          d="M303.7,55.9c0-.8.4-.8,1.1-.6,2.4.4,4.8,1,7.1,1.8,4.5,1.6,9.8,3.5,14.1,5.5s1.9,1.4,2.8,2.2c.7,0,1.1.5,1.5,1,.2-.7,1.2-.6,1.5,0l.5.5c0-.8.8-.7,1,0l1,1c.2-.4.3-.4.5,0,.9.5,1.7,1,2.5,1.5.2-1.3.4-1.2,1,0,2,.7,3.8,1.7,5.5,3,.6-.9,1.9,0,1.5,1l4,1.5c.2-.4.3-.4.5,0,3,3.4,7.5,5.2,11,7.8s.8,1,1,1.2c-3.1-1.9-6.3-3.5-9.5-5.3-2.4-1.4-3.6-2-6.2-3.3s-6.3-4.8-10.4-5.4c-8.5-4.4-17.9-7.5-27-11-1.1-.1-5-.8-5.3-1.7s0-.5.3-.8Z"
          fill="#08022f"
        />
        <path d="M340.7,72.4l-.5-.5c.3.2.5.5.5.5Z" fill="#070352" />
        <path
          d="M339.2,67.4c.2-.4.3-.4.5,0l.5.5c.2-.4.4-.2.5.5.1-.4.3-.4.5,0,.2-.3.3-.2.5,0l.5.5c.1-.4.3-.4.5,0,.5-.3,1.2.2,2,1.4l6,3.6c.6-1.2,3.4-.2,3.8,1,4.8,1.9,9.1,4.5,13,8,5.3,2,10.1,4.9,12.8,9.4v1.1c-.7-.3-1.4-.6-2.1-1-7.9-4.8-20.5-14.8-28.5-18s-.4,0-.5,0l-4-1.5c-.3-.2-.9-.7-1.5-1-1.7-1.3-3.5-2.3-5.5-3-.3,0-.7,0-1,0-.8-.4-1.6-.9-2.5-1.5-.1,0-.4,0-.5,0l-1-1c-.3,0-.8,0-1,0l-.5-.5c-.3-.1-1.2.1-1.5,0-.5-.3-.7-.7-.5-1,0-.3,0-.5.2-.7.7-.7,8.5,1.5,9.3,3.2Z"
          fill="#04001d"
        />
        <path
          d="M337.7,63.9c3.4,1.5,6.6,3.5,10,5s.3,0,.5,0l.5.5c.1,0,.4,0,.5,0l.5.5c1.5.9,3,1.6,4.5,2.5s3.1,1.6,4.5,2.5c2.8,1.7,5.7,3.6,8.5,5.5s3.4,2.3,5,3.5c3.7,2.7,7.4,5.7,11,8.5s3.3,3.4,5,4v.5l-1,.7c.8.8,5.4,4.9,5.5,5.3-3.6.4-4.7-3.5-6.7-5.5s-3.2-1.7-4.3-3l-.5-.5c-.4-.4-.7-.3-1-.5l-1.5-1,.5-1-2.5-1,.5-1.3c-2.9-.1-1.5-.8-1.8-1.2-1.6-2.3-6.5-2.5-9.2-4.7-4-3.2-5.9-4.5-10.5-7s-2.4.1-2.2-1.8c-.9.6-1.4-.1-2.8-.5-2.8-1.5-5.4-3.2-8-5-.1,0-.4,0-.5,0l-.5-.5c-.1,0-.4,0-.5,0,0-.8-.2-.8-.5,0-.2-.1-.4-.5-.5-.5l-.5-.5c-.1,0-.4,0-.5,0-1.3-1-2.6-1.9-4.2-2.4l-.3-1.1c-.4-.6.1-.7,1.5-.5.4.2,1,.3,1.5.5Z"
          fill="#040113"
        />
        <path d="M381.6,94.4c-.1-.2-.4-.3-.5-.5.2.1.3.3.5.5Z" fill="#04001d" />
        <path d="M395.6,103.4c-.2-.2-.3-.3-.5-.5l.5.5Z" fill="#0b51a9" />
        <path d="M422.6,133.8c-.1-.2-.4-.3-.5-.5l.5.5Z" fill="#09186d" />
        <path d="M418.1,127.9c-.1-.2-.4-.3-.5-.5l.5.5Z" fill="#0a1b71" />
        <path d="M417.1,126.4c-.2-.2-.4-.3-.5-.5.2.2.4.3.5.5Z" fill="#0a1b71" />
        <path d="M423.6,133.8c-.2,0-.5-.3-.5-.5.3,0,.4.2.5.5Z" fill="#09186d" />
        <path
          d="M201.2,450.7c3.2-.8,8.3,1,11,3,1.4-.9,2-.9,2,0l2,.5c8.7-.1,17.4.5,26,1.5,1.8-.3,5.7-.5,6.5,1-5.3,1.3-11.3.9-16.5-.5-6.3-.2-12.4-.4-19-1l-12-3c-1.5-.3-2-.8-1.5-1.5.3-.3.8-.3,1.5,0Z"
          fill="#06247b"
        />
        <path
          d="M248.7,456.7l1.2-.6c7,.5,14,.4,21,0l1.3.6v.5c-3.1.3-6.3.9-9.5,1-7.6,0-15.1.4-22.5,0s-4-.4-6-.5c-.8-1-2.4.2-2-1.5,5.5.2,11,.4,16.5.5Z"
          fill="#0c2f88"
        />
        <path d="M190.8,449.7c-.4,0-.9,0-1-.5.4,0,.9,0,1,.5Z" fill="#183489" />
        <path
          d="M312.2,447.7c1-.7,1.8-.9,2.5-.5-1.7,1.8-4.9.9-7,2-2.3.4-5.2,1.8-7.5,2.5-1.9.5-3.2.3-4-.5-.3-1.4,2-1.9,3-1.5h1c-.6-.5-.3-.7.5-.5.3-.2.8-.4,1.5-.5.1-.3.3-.3.5,0,3.4-.5,6.2-.7,9.5-1Z"
          fill="#08216a"
        />
        <path
          d="M296.2,451.2c1.3-.1,3-.3,4,.5-1.2.4-2.1,1.1-4,1.5-7.4,1.4-16.5,2.9-24,3.5-7.8.6-15.7,0-23.5,0-1.8-.7-4.5-.9-6.5-1-.4-.1-.4-.3,0-.5.7-1.1,2.8-1.2,3.5,0l17,.5c.3-.8.7-.8,1,0,.8-.4,1.7-.4,2.5,0l1.1-.7c8.6-1.1,17.2-2.2,25.9-3.3.3-1.3,2.4-1.7,3-.5Z"
          fill="#031c75"
        />
        <path d="M302.7,448.2v.5c-.2,0-.3,0-.5,0-.3.3-.7.3-1,0,.3-.7,1-.4,1.5-.5Z" fill="#01074c" />
        <path d="M302.2,448.7c-.3.7-1.2.3-1.5.5v-.5c.2,0,.3,0,.5,0,.3,0,.7,0,1,0Z" fill="#021055" />
        <path d="M46.8,192.8l-.4-.2.4-.8c0,0,.4-.4,0,1Z" fill="#1932c3" />
        <path
          d="M57.8,170.3c.3.2.3.5,0,1,.3.2.5.4.4.4-.3,1-3.3,8.4-3.7,8.5s-.5,0-.7,0c-.9-.4-.9-1.4,0-3,.5-2.5,1.5-5,3-7,.2-1,.5-1.4,1-1,.4.1.2.6,0,1Z"
          fill="#0f45cb"
        />
        <path
          d="M53.3,181.8c-.4,1.4-.9,2.8-1.5,4,.3.3.3.7,0,1,.1,3-1,7.4-3,9.5.2-1.3.8-3.2,0-4v-.5c1-2.6,1.5-5.6,2.5-8,.5-1.9,1.2-2.9,2-3,.4.3.4.7,0,1Z"
          fill="#0e42ce"
        />
        <path
          d="M62.3,160.3c-.6,3.2-2,6.4-4,9-.1.4-.3.4-.5,0-.4.3-.7.6-1,1,0-1,.2-2,.5-3,1.8-1.6,3-4.8,4-7l.2.5.8-.5Z"
          fill="#113dce"
        />
        <path
          d="M48.8,192.3c0,.2,0,.3,0,.5l-.5,1c-.3,1-.9,2-1,2.5,0-1,0-2,.3-2.9s1.1-1.5,1.2-1.6v.5Z"
          fill="#1932c3"
        />
        <path
          d="M53.8,180.3c.5,0,.4.2,0,.5-.1.4-.3.4-.5,0-.7.5-1.7,2.3-2,3,1-2.1.9-4.8,2.5-6.5-.3,1.7,0,1.9,0,3Z"
          fill="#143ac8"
        />
        <path
          d="M64.3,160.8c.7.7.5,1.1-.5,1l.2,1.9-5.1,10.5-1.5,1.1c.2.3.4.6.4.9-.1,2.7-2.5,7.5-3.8,9.8-.8,3.9-1.7,7.8-2.8,11.7l-1.2,1.1v.5l-.5.5c-.7,6.2-1.6,12.6-2.8,18.9l-1.2,1.1c.4,1.3.3,2.5-.5,3.5h-.6c0,0,.1-3.5.1-3.5.2-1.8.3-3.7.5-5.5l1-5c0-.2,0-.3,0-.5.6-1.4.8-3,1-4.5.6-2.7,1.6-5.2,2-8,1.3-3.1,2.2-6.3,3-9.5.1-.5.3-.8.5-1-.2-1.1.4-2.5,1-3.5l.5-1.5c0-.2,0-.3,0-.5l4-9c1.8-4.3,3.8-8.3,6-12,.7-.4.9,0,.5,1.5Z"
          fill="#02023f"
        />
        <path
          d="M44.8,223.3c.5,4.4.3,9.4-1.5,13.5l-.5-.5c0-1.2,0-2.3,0-3.5,0-4.5.9-8.6,1.5-13,.1,1.1-.4,2.8.5,3.5Z"
          fill="#020750"
        />
        <path d="M45.8,208.8c.3-1.6.7-3,1-4.5,0,1.5,0,3.3-1,4.5Z" fill="#0f41dd" />
        <path d="M44.8,214.3c.2-1.6,0-3.6,1-5-.2,1.6,0,3.6-1,5Z" fill="#0f41dd" />
        <path d="M48.3,193.8c.1-.4,0-.8.5-1,0,.4,0,.8-.5,1Z" fill="#0e42ce" />
        <path
          d="M45.3,219.8c.7-1.1,1.4-.6,1.7.6-.3,5.9-.7,11.7-1.1,17.6-2.2,1.6-1.2,5.8-.6,7.8-1.5,2.1-1.3,4.3.2,6.2s0,.6-.2.8c-.4,3.1-.4,6.3,0,9.6l-1,.9c-.5-.1-.5-.6-.5-1-.2-4,.5-8.9,0-12.8s-.1-1.2-1-.7c0-2.7,0-5.3,0-8,1-.9.4-2.7.5-4,.4-4.5.9-9,1.5-13.5s.3-2.3.5-3.5Z"
          fill="#03107a"
        />
        <path
          d="M45.3,246.3c.6,1.4,1.5,2.7,2.7,3.8.2,1.9.1,4.3-1.7,5.3.4.5.4,1.1,0,1.6,1.4.7,1.5,6.5,0,7.5.9-.7,1.1-.3,1.2.6l.3,7.6c0,3.7.4,6.4,1,10,.7,7.1,2,14.9,4.5,21.5,1.1,4.6,2.5,9.1,4,13.5l-.5,3.5c0-.1-.4-.3-.5-.5-2.1-2.8-3.3-6-3.5-9.5-.7-2.2-1.4-4.7-2-7l-.5-1c0-.2,0-.3,0-.5-.5-2-1-4-1.5-6s0-.3,0-.5l-.5-2c-.4-1.9-.4-4.6-1-6.5-1-4.1-1.5-8.3-2-12.5s-.8-8-1-12-.4-8.5,0-10.2.8-.2,1-.3c.4-.5.1-1.1-.7-1.8-.3-1.2-.5-4.7.7-4.7Z"
          fill="#010960"
        />
        <path
          d="M56.3,320.8c-.3-.5-.9-1.3-1.5-1.5v1.5c-.9-2.4-1.8-4.6-2.5-7,.8-.4.5-1.7.5-2.5,1,3.2,2.4,6.3,3.5,9.5Z"
          fill="#0a2aa3"
        />
        <path d="M48.8,296.3l-.5-2c.1.6.3,1.3.5,2Z" fill="#0827a9" />
        <path d="M50.8,304.3l-.5-1c0,0,.3.4.5,1Z" fill="#0827a9" />
        <path
          d="M48.8,248.8l-1,7.8c.8,5.3,0,11,0,16.2-.5-2-.2-4.2-.5-6.2s-1-1.9-1-2v-7.5c0-.1-1.3-.8-1-1.9s2.5-.9,2.3-3.5-3.5-2.2-2.3-5.3c.2-1.2,1.4-1.5,3.5-1,0,1.2,0,2.3,0,3.5Z"
          fill="#010552"
        />
        <path
          d="M90.3,119.4c-2.6,4.5-6,9.2-10,12.5h-.5c.5-.8.9-1.7,1.5-2.5,2.7-3.6,5.7-7,8.5-10.5.7-.7,1-.4.5.5Z"
          fill="#04188c"
        />
        <path
          d="M95.8,112.9c-.9,2.2-2.9,4.8-5,6,0,.6-.1.7-.5.5l-.5-.5c1.3-1.6,2.6-3.4,4-5s1.1-1.1,1.5-1.5c.7-.7,1-.4.5.5Z"
          fill="#051aa1"
        />
        <path
          d="M103.3,104.9c-2,2.9-4.6,6-7.5,8l-.5-.5c2.4-2.8,5.2-5.4,7.5-8l.5.5Z"
          fill="#072cb0"
        />
        <path
          d="M139.8,75.9c.7-.5,1-.3.5.5-1,1.6-2.2,2.8-4,3.2-4.1,3.2-8.4,6-13,8.3l-.5-.5c5.9-4.4,10.8-7.6,17-11.5Z"
          fill="#0849c4"
        />
        <path
          d="M158.8,65.4c.8-.8,1.1-.5.5.5-1.1,2.7-5.7,4-8.5,4.5,0,.3-.2.5-.5.5-.1.4-.3.4-.5,0l-.5.5c-.4,1.8-5.3,4.2-7,3.5-.7.5-1,.3-.5-.5,4.2-2.5,12.2-7.8,16.5-9,.2-.2.3-.2.5,0Z"
          fill="#0947c5"
        />
        <path
          d="M173.8,57.4c-.9.6-1.9,1,0,1-1.6,1.5-4.2,2.8-6.5,3,0,.8-.8.8-1,0l-.5.5c-.1.4-.3.4-.5,0l-.5.5c-.2.4-.3.4-.5,0l-.5.5c-.1.5-.3.4-.5,0l-.5.5c-.2.4-.3.4-.5,0l-.5.5c-.2.4-.3.4-.5,0l-1,.5c-.2.4-.3.4-.5,0h-.5c-.2,0-.3,0-.5,0-.3-.1-.3-.3,0-.5l3-1.5c1.4-.9,2.9-1.6,4.5-2,2.3-1.1,4.6-3,7.5-3Z"
          fill="#020439"
        />
        <path
          d="M163.3,63.9c-.5,1.8-2.3,2.6-4,2,0-.3-.2-.5-.5-.5-.2-.2-.2-.3,0-.5.1,0,.4,0,.5,0l.5-.5c.2,0,.3,0,.5,0l1-.5c.2,0,.3,0,.5,0l.5-.5c.1,0,.4,0,.5,0,.8-.4,1-.3.5.5Z"
          fill="#093bb4"
        />
        <path d="M142.3,74.9c.6,1.2-1,2.2-2,1.5l-.5-.5c.5-.3,1.1-1,2-1.5l.5.5Z" fill="#0738a7" />
        <path d="M116.3,92.4c.1-.6.6-.7,1-1-.2.5-.5.8-1,1Z" fill="#030436" />
        <path d="M158.8,65.4c-.2,0-.4,0-.5,0,.1-.2.3-.4.5-.5v.5Z" fill="#040748" />
        <path d="M159.3,64.9v-.5c.2,0,.3,0,.5,0-.1.2-.3.4-.5.5Z" fill="#040748" />
        <path d="M156.8,64.9l.5-.5c-.1,0-.3.4-.5.5Z" fill="#040748" />
        <path d="M158.8,64.4c-.2,0-.3,0-.5,0-.2-.2-.2-.3,0-.5.2,0,.3,0,.5,0v.5Z" fill="#03073e" />
        <path d="M158.3,64.4c-.2,0-.3,0-.5,0,0-.2.3-.4.5-.5v.5Z" fill="#040748" />
        <path d="M166.3,60.4c-1.5.7-3,1.4-4.5,2,1.2-.6,2.6-2.2,4.5-2Z" fill="#03073e" />
        <path d="M161.8,62.4c-1.2.6-1.4,1-3,1.5.7-1.1,2-1.1,3-1.5Z" fill="#040748" />
        <path
          d="M185.3,59.4l-.5.7c-24.1,8-45.8,22.4-66.5,36.3-1,.9-1.5.7-2-.5-3.1-.3,1.6-3,3.2-3.7.5-.4,1.1-1.2.8-1.8.5-.4,1.1-.7,1.5-1l.8-.4c6.7-4.9,14-9.6,21.7-14.1,1.4,1.1,3.6-1,4.8-2.1-.1-1.1,1.1-1.6,2.1-1.9.7-1,2.4-1.8,3.3-.5,2.1-.4,4-1.2,4.3-3.4,3.5-1.6,6.9-3.2,10.2-4.9,1.7-.5,3.5-.6,5.4-.2.9-.9,1.7-1.1,2.4-.5,1.7-1.6,7.9-5,8.5-2Z"
          fill="#000025"
        />
        <path
          d="M120.3,90.4c2.4-.2-.2,1.8,0,2s1.2-.4,1,.5c-1.4.1-4.5.8-5.2,2s.2.9.2,1l-.5.5c-.9,1-1.5,2.2-1.9,3.6-1.3,1.8-3.9,2.3-2.6-.1q.9-.5,0,0c-.2,1.3-.6.1-.6.2,1.6.4-1.3,2.9-2.4,2.8l.3,1.1-5.2,3.5c-4.2,4.3-8.3,8.7-12.3,13-1.1,0-.9-.8-.3-1.6,1.7-2,3.3-4,5-6s4.9-5.5,7.5-8c5.2-5.1,11.2-10,17-14.5Z"
          fill="#02021e"
        />
        <path
          d="M150.8,70.9c.2-.4.3-.4.5,0l-1.5,1.5,2,.5c-2.2,0-4.6,3.2-6.3,4s.4-1.4-1-1c-2.1.7-4,2.6-6.2,3l.5,1c-1.8-.9-3.3,1.4-4.6,2.1-4.3,2.5-6.2,4.8-10.4,7.1s-1.4,1.5-2,.2c.6-.4,1.1-1.2,1.5-1.5,5.4-4.1,11.2-8,17-11.5s1.6-1.2,2-1.5c1.9-1.1,4.9-2.7,7-3.5l.5-.5c.1,0,.3,0,.5,0h.5Z"
          fill="#010218"
        />
        <path
          d="M114.8,100.9c1.7.8,0,3.1-1.5,2-4.4,3-8.4,6.9-12.2,10.6h-.8c-2.1.6-2.9,1.6-2.4,2.8-2.5.5-4.5,3.2-5.6,5.5-2.1,1-3.8,2.6-5.1,4.7-1.8.9-2.4,2-3.1,3.8h-.8c.3.2.3.4,0,.6.4.2.2.5-.5,1,1,.9.8,1.2-.5,1,.4,1.8-2.7,5-4.5,5-.7,1.9-1.5,3.8-2.2,5.8-2,.7-2.9,1.7-3.7,3.7-.7,1.4-1.3,1.9-2,1.5,1-2.9,2.9-5.5,4.5-8,0-.6.3-1.3,1-2,.2-.2.3-.3.5-.5.9-2,2.3-4,4-5.5-.3-.2-.3-.3,0-.5,0-.3.2-.5.5-.5,3.2-4.2,6.6-8.4,10-12.5s.3-.3.5-.5c.2,2.9,2.2-1.4,2.6-1.9,3.1-3.2,5.9-6.9,9-10s4.4-2.6,5.9-4.1c2-.7,3.9-1.6,5.5-2.9l1,.4c.4,0,.4.3,0,.5Z"
          fill="#01012a"
        />
        <path
          d="M64.3,157.8c-.2.4-.2,1-.5,1.5-2,3.9-3.3,8.6-6,12,0-.2,0-.7,0-1,0-.5.2-.8.5-1,1.3-3,2.6-6,4-9s1.2-1.8,1.5-2.5h.5Z"
          fill="#000152"
        />
        <path
          d="M79.8,132.8c-1.4,1.8-2.5,3.8-4,5.5-1-.2.3-1.4.5-1.7.9-1.3,1.8-2.8,3-3.8.1-.3.3-.3.5,0Z"
          fill="#081779"
        />
        <path d="M74.3,140.8c-1.4-.7.6-1.5,1-2,0,.8-.6,1.4-1,2Z" fill="#081779" />
        <path d="M80.3,131.8c-.1.2-.4.3-.5.5-.1.3-.3.3-.5,0,.1-.2.4-.3.5-.5h.5Z" fill="#081779" />
        <path d="M79.8,132.8h-.5v-.5h.5c0,.1,0,.4,0,.5Z" fill="#04188c" />
        <path d="M68.8,146.8c0-.2.3-.4.5-.5,0,.2-.3.4-.5.5Z" fill="#2a38b6" />
        <path d="M68.3,147.8l.5-.5c-.1.3-.5.4-.5.5Z" fill="#2a38b6" />
        <path
          d="M243.7,41.9c8.8-.3,17.7.4,26.5.5.1.9-1.1.5-1.7.5-3.4.1-6.4-.4-9.5-.5s-4.2,0-6.3,0c-3.7,0-7.3,0-11,0-.1-.9,1.4-.5,2-.5Z"
          fill="#1766f9"
        />
        <path
          d="M252.7,42.9c2.4,0,5.4-.4,7.5.5-6.5,0-13-.1-19.5,0,3.7-.9,8.1-.5,12-.5Z"
          fill="#030828"
        />
        <path
          d="M270.2,43.4c3.1,0,5.9.6,8.5,1.5h-.5c-2.9-.2-6.7,0-9.5-.5l-.5-.5c-1.2-.2-2.7,0-4,0-.4-.1-.4-.3,0-.5,2,0,4,0,6,0Z"
          fill="#050b3b"
        />
        <path
          d="M284.7,45.4c.2,0,.3,0,.5,0l4.5,1c.2,0,.3,0,.5,0,.4.1.4.3,0,.5-4-.3-8.1-.8-12-2,.2,0,.3,0,.5,0,2-.3,4-.1,6,.5Z"
          fill="#02072c"
        />
        <path d="M284.7,45.4c-2-.2-4-.4-6-.5l-8.5-1.5c5,.2,9.7.4,14.5,2Z" fill="#1c4fe3" />
        <path d="M289.7,46.4c-1.4-.2-3.3-.2-4.5-1,1.5.2,3.3,0,4.5,1Z" fill="#1c4fe3" />
        <path d="M292.2,46.9c-.7,0-1.3,0-2,0v-.5c.7,0,1.6-.3,2,.5Z" fill="#1c4fe3" />
        <path d="M264.2,43.4v.5c-.5,0-1.3.1-1.5-.5.5,0,1,0,1.5,0Z" fill="#030828" />
        <path
          d="M226.7,43.9c-1.8.8-4.4.7-6.5,1,.2-.5.6-.4,1-.5,2-.4,3.5-.4,5.5-.5Z"
          fill="#1d49e3"
        />
        <path
          d="M211.7,45.9c.5,0,1,0,1.5,0-2.2,1.4-5.1,1.1-7.5,1.5,1.2-.3,2.3-.8,3.5-1,.4-.9,1.9-1.2,2.5-.5Z"
          fill="#1b4adc"
        />
        <path d="M211.2,44.9l.5,1c-.9.1-1.7.3-2.5.5v-1c.6-.1,1.2-.4,2-.5Z" fill="#174ee6" />
        <path d="M205.7,47.4c-2.8.7-5.5,2.1-8.5,2,3.1-.9,5.2-1.5,8.5-2Z" fill="#174ee6" />
        <path d="M182.3,53.9l-4.5,1.5c1.7-.7,2.8-1,4.5-1.5Z" fill="#1b49dd" />
        <path d="M176.8,54.9c.2-.2.8.5.2.5s-.4-.4-.2-.5Z" fill="#215ae3" />
        <path d="M383.1,92.4c.1-.1.5-.5.5-.5s-.4.4-.5.5Z" fill="#0a52ca" />
        <path d="M349.7,69.9c-.2-.1-.3-.3-.5-.5.2,0,.4.3.5.5Z" fill="#083eb3" />
        <path d="M348.7,69.4c-.2,0-.4-.3-.5-.5.2,0,.4.3.5.5Z" fill="#083eb3" />
        <path
          d="M264.2,44.4l2,.5c1,0,2,0,3,0l2,.5c1,0,2,0,3,0,.4.1.4.3,0,.5-.1.2-.5.4-1,.5-.9.4-2,.8-3,.6-4.7-.9-9.8-1-14.5-.6-2.1.1-4.1-.2-5.9-1-.3,1-1.2,1-1.5,0-1.4.6-4,1-5,0-1.5.4-3,.4-4.5,0-.3-.2-.3-.3,0-.5,7.4-.6,14.9-.8,22.5-.5,1,0,2,0,3,0Z"
          fill="#0622a8"
        />
        <path
          d="M205.2,49.4c.7,0,1,0,1,.5l-.4.7c-5.1,1.5-10.3,2.8-15.6,3.9l-.6-.6c-.4,0-.5-.2-.5-.5,5.1-2.2,10.6-3,16-4Z"
          fill="#0630bd"
        />
        <path
          d="M240.2,44.4c5.9-.5,12-.4,18,0h3c-5.8,0-17.2-.3-22.5.5l-.5.5c-.5,1.4-1.5,1.4-2,0-.8.2-2.2.2-2.5-.5.5,0,1,0,1.5,0l2.5-.5c.8,0,1.7,0,2.5,0Z"
          fill="#0635af"
        />
        <path
          d="M223.2,45.9l1,.5-.8,1.3c-3.4.2-6.7.6-10.1,1.3l-.6-.6c-1,.2-1.5,0-1.5-.5,3.8-.7,8.1-1.7,12-2Z"
          fill="#0937b6"
        />
        <path
          d="M258.2,44.4c-6,0-12-.2-18,0,.5-.8,1.9-.5,2.7-.5,4.2,0,8.3,0,12.5,0s2.2-.3,2.7.5Z"
          fill="#030828"
        />
        <path
          d="M181.8,55.9c.7-.4,1.2-.4,1.5,0-.9,1.9-6.5,4.1-8.5,3-.6.1-.8.1-.5-.5,2.7-1.1,4.6-1.8,7.5-2.5Z"
          fill="#0941b3"
        />
        <path
          d="M281.7,46.9c.4-.5,1-.3,1.5,0,.5,0,1,0,1.5,0l1,.5c1.7.2,3.9,0,5.5,1-.5,0-1.3-.2-1.5.5-.2.2-.3.5-.6.6-.4.3-5.7-1-6.4-1.6-.5-.3-1.3-.5-1.7.2l-.3-.7c-.5-.5.5-1,1-.5Z"
          fill="#0834af"
        />
        <path
          d="M188.3,53.4l1,.5c-.2,1.4-1.7,2.1-4.5,2-.4.6-1.5,1-1.5,0-.4,0-1.1-.1-1.5,0,1.9-1,4.4-2.2,6.5-2.5Z"
          fill="#0736b9"
        />
        <path
          d="M174.8,58.9c-.6,2.2-4.4,3.3-6.5,3-.6,0-.9,0-1-.5,2.2-.9,4.3-2.1,6.5-3s.4,0,.5,0l.5.5Z"
          fill="#0733b5"
        />
        <path
          d="M233.7,44.9c.4,0,1.6,1,2.5.5-.6,1.6-4.6,1.9-5.5.5-.4,0-.6,0-.5-.5.8,0,1.9-.7,3.5-.5Z"
          fill="#0627ac"
        />
        <path
          d="M210.2,48.4c.6-.4,1.4-.3,1,.5-.1,1.2-.5,1.1-1,0l-1,.5c.4.8,0,1-1.5.5-.3.8-1.3.9-1.5,0l-1-.5c.8-.2,1.5-.3,2.5-.5l1-.5c.5,0,1,0,1.5,0Z"
          fill="#1137ae"
        />
        <path
          d="M274.2,45.9c.5-.4,1.5-.4,2,0,.1-.3.3-.3.5,0,.2,0,.3,0,.5,0,.5.1,1,.3,1.5.5.4-.4,1.1-.3,1.5,0,.2,0,.3,0,.5,0,.3.9-.8.9-1.5.5-.1,1.1-1.8.6-2.5,0-.5-.4-1.2-.5-2-.5-.2,1-1.1.9-1.5,0,.1-.5.6-.5,1-.5Z"
          fill="#0845b7"
        />
        <path
          d="M230.2,45.4l.5.5c-.3,1.5-2.9,2-3.5.5-.6-.1-1.1-.3-1.5-.5,1-1,3.1-.4,4.5-.5Z"
          fill="#0440c4"
        />
        <path
          d="M225.7,45.9c.5,0,1.3-.2,1.5.5-.4,1.5-2.6,1.5-3,0-.4,0-.9,0-1-.5.8,0,1.7,0,2.5,0Z"
          fill="#093bcb"
        />
        <path d="M237.7,44.4c-.5,0-1.2.5-2.5.5.4-.8,1.7-.5,2.5-.5Z" fill="#0627ac" />
        <path d="M276.2,45.4c.2.2.2.3,0,.5-.7,0-1.3,0-2,0v-.5c.7,0,1.3,0,2,0Z" fill="#04103e" />
        <path d="M271.2,45.4l-2-.5c1,0,1.9.5,2,.5Z" fill="#050b3b" />
        <path d="M266.2,44.9l-2-.5c1.1,0,1.9.5,2,.5Z" fill="#030828" />
        <path d="M278.7,45.9c.4.1.4.3,0,.5-.5,0-1.3.2-1.5-.5.5,0,1,0,1.5,0Z" fill="#07399a" />
        <path d="M280.2,46.4c-.5,0-1,0-1.5,0v-.5c.5,0,1.3-.2,1.5.5Z" fill="#02072c" />
        <path d="M283.2,46.9c-.5,0-1,0-1.5,0-.4-.1-.4-.3,0-.5.5,0,1.3-.2,1.5.5Z" fill="#02072c" />
        <path
          d="M189.3,53.4c.2,0,.4.3.5.5,0,.5-.3.4-.5,0-.4,0-.8,0-1-.5.3,0,.7,0,1,0Z"
          fill="#074dd7"
        />
        <path d="M208.7,48.4c-.1,0-.5.4-1,.5l1-.5Z" fill="#0d2ba0" />
        <path
          d="M211.2,47.9l1.5.5c.5,1.1-.9,1.5-1.5.5-.1-.5-.6-.5-1-.5.2-.5.6-.4,1-.5Z"
          fill="#0d2ba0"
        />
        <path d="M285.7,47.4l-1-.5c.9,0,.9.5,1,.5Z" fill="#02072c" />
        <path
          d="M281.7,46.4v.5c-.4,0-.9,0-1,.5-.2,1.2-2.1.6-1.5-.5.5,0,1.3.2,1.5-.5.3,0,.7,0,1,0Z"
          fill="#07399a"
        />
        <path d="M268.7,44.4c-.2,0-.4-.3-.5-.5.2,0,.4.3.5.5Z" fill="#030828" />
        <path d="M276.7,45.9c-.2,0-.3,0-.5,0v-.5c.2,0,.4.3.5.5Z" fill="#02072c" />
        <path
          d="M282.7,47.9c2.5,0,4.6.7,7,1s1.4,0,2,0l.5.5c1.2.2,2.8.2,4,.5,5.9,1.4,12.7,3.2,18.5,5s2.7,1.1,4,1.5.4,0,.5,0l.5.5c.3,0,.7,0,1,0l.5.5c.3,0,.7,0,1,0l.5.5c1.3.5,2.7,1,4,1.5,1.9,2.7-4.1,1.7-5.7,1.3-2.8-.7-4.5-1.4-6.4-3.5-2.2-.2-4.1-.8-5.7-1.9-.1,1.5-2.9.8-3.1-.3l-2-.5c-.3.6-1.1.6-2.5,0-3.4-1.9-7.3-2.6-10.9-3.2-1.2,0-10-2.2-9.9-3.1s1.8-.7,2.3-.2Z"
          fill="#03010e"
        />
        <path
          d="M303.7,54.4l2,.5c.7.2,1.5.8,2.5.5l-1-1c2-.9,3.1.9,3.4,1,1.3.4,3.5.4,4.7,1s1.9,2.6,3.7,3,3.7.3,5.8.7,1.5.6,2-.7c.1,0,.4,0,.5,0,1.2.5,2.8,1.3,4,2-.3.7-1.5,2.3-2,1.6-.6-.9,5.4-.6,5.5.9,2.1.6,3.4,1.5,4.5,3.5-2-.8-7.5-2.5-9.5-2.5-.2.3-.5.3-1,0-7.9-3.3-15.6-6.5-23.4-9-.5-.2-1.1,0-1.6,0-.1.4-.3.4-.5,0-.4-.1-.4-.3,0-.5-1.2,0-2.1-.4-2.5-1h.5c.8,0,1.7,0,2.5,0Z"
          fill="#050117"
        />
        <path
          d="M331.2,61.4c1,.3,1.7.7,2.5,1l1,.5c.1,0,.4,0,.5,0l.5.5c.1,0,.4,0,.5,0l-1.5.5c-1.8-.5-4.1-.5-6-.5l1-1.5-2.5-1.5c1.2.4,2.9.7,4,1Z"
          fill="#03010d"
        />
        <path d="M334.7,62.9l-1-.5c.5.2.8.4,1,.5Z" fill="#050117" />
        <path d="M335.7,63.4l-.5-.5c.4.1.5.5.5.5Z" fill="#050117" />
        <path d="M322.7,57.9c-.3,0-.4-.5-.5-.5l.5.5Z" fill="#093bb0" />
        <path d="M321.2,57.4c-.4-.1-.5-.5-.5-.5l.5.5Z" fill="#093bb0" />
        <path d="M319.7,56.9c-.4-.1-.5-.5-.5-.5l.5.5Z" fill="#093bb0" />
        <path d="M292.2,49.4c-.2,0-.4-.3-.5-.5.2,0,.4.3.5.5Z" fill="#0834af" />
        <path
          d="M285.2,51.9c.9.4,1.9.6,3,.5.2-.4.3-.4.5,0,1.1.6,2.2.9,3.5,1,.1-.4.3-.4.5,0,2.4.9,4.9,1.5,7.5,2,.1-.8.5-.7,1,0,.7.2,1.4.3,2,.5.2,0,.3,0,.5,0,.9,1.7,3.2,1.8,5,2.5-4.6.4-7.9-3-12.5-2.5-7.6-1.3-15.1-2.8-22.5-4.5-18.9-2-39.2-.3-58.5,1.5-.4-.4,0-.7,1.5-1,1.4-1.3,3.4-2,5.9-2,7-.6,14.1-1.1,21.1-1.5.2-.4.3-.4.5,0,13.2,0,26.3.9,39.3,2.6l1.7.9Z"
          fill="#060231"
        />
        <path
          d="M273.7,51.4c7.4.5,15.5,2.4,22.5,4.5s3.4.8,5,1.3,4,1.8,4,2c0,.9-1.5.6-2.1.6-2.4-.1-4.6-1.4-6.9-1.9-2.2-1.4-5-2-8.2-1.8-.5-.2-1.2-.5-1.3-1.2-.3.3-.5.4-.8.4-4.8-.6-10.3-1.4-15-2.3l-1.2-1.1c-.4-.1-.4-.3,0-.5,1.2-.4,2.5-.4,4,0Z"
          fill="#040553"
        />
        <path
          d="M262.7,55.4l.2.8c2.6.5,5.2,1.1,7.8,1.7,0-.4.3-.4.5,0,1.8.2,3.5.1,5.1-.2v-.8c-.1,0,.2-.5.2-.5,1.8.6,3.5.8,5.1.5.3-1.2,2.7-1,3,0,1.4.4,2.4.3,3.1-.3,1,1,2.5,1.6,4.4,1.8.2.1.4.4.5.5,1.6.2,2.9.7,4,1.5-1.7,1.3-5.3,1-7.1-.3-3.3-.5-6.8-.5-10.3,0-14.1-1.8-29-1.8-43.5-1.3l-2-.5-2,.5c-.5.6-2,.7-2.5,0,1-2.1,4.5-3.3,7-3.5,3.3-.5,6.7-.4,10.2.2,5.2-.7,10.5-1,15.8-.7s.4.2.6.5Z"
          fill="#8f97d5"
        />
        <path
          d="M286.7,54.9c2.7.4,4.7,0,7.7,1s3.4,1.1,1.8,2c-2.4-.5-5.5-.6-8-1l4,1.5c-2.4.1-5.3-1.3-7.5-1.5.2-.7,1.1-.8,2.8-.2,0,0-1.8,0-1.3-.8-1.2-.7-.8-1,.5-1Z"
          fill="#0a0759"
        />
        <path d="M338.2,68.9c2.8.5,3.6.6,5.5,3-1.5-.8-3.4-1.6-5-2.3s-.4-.4-.5-.7Z" fill="#03022b" />
        <path d="M334.7,67.4c1.3.5,2.9.1,2.5,1.5-1.2-.2-1.9-.1-2.5-1.5Z" fill="#03022b" />
        <path d="M349.2,74.4c-1.6-.6-2.2-.6-4-1.5l4,1.5Z" fill="#03022b" />
        <path d="M329.7,64.9l.5,1c-.7-.3-1.2-.9-1.5-1,.3,0,.7,0,1,0Z" fill="#03022b" />
        <path d="M334.2,67.4c-.7-.3-.9-1-1-1l1,1Z" fill="#03022b" />
        <path d="M332.2,66.4c-.4-.2-.5-.5-.5-.5l.5.5Z" fill="#03022b" />
        <path
          d="M342.7,68.9l.7-1c1.7,3.3,5.1,3.5,7.3,6-1.3-.4-2.6-1.1-4-1,1.2-1.4-1.3-1.4-2.3-2.2s-.9-1.3-1.7-1.8Z"
          fill="#050117"
        />
        <path d="M342.2,68.9l-.5-.5c.3.2.4.5.5.5Z" fill="#050117" />
        <path d="M340.7,68.4c-.1-2.5,1.8-1.9.5,0-.1,0-.4,0-.5,0Z" fill="#050117" />
        <path d="M340.2,67.9l-.5-.5c.2,0,.4.4.5.5Z" fill="#050117" />
        <path
          d="M213.7,452.2c.6,0,1.2.4,2,1,.2,0,.3,0,.5,0,1.6.4,3.4.4,5,0,3.4.3,6.6.9,10,1,.8-.7,2.1-.6,3,0l7.2.2c.5,0,.7.3.8.8v.5c-8.7-.4-17.3-.3-26-1.5l-2-.5c-.6-.1-1.4.1-2,0l1-.5v-.5c-1.2,0-2.5-.3-3-1.5,1.3.3,2.2.5,3.5,1Z"
          fill="#031466"
        />
        <path d="M216.2,454.2c-.9-.1-1.6-.4-2-.5l2,.5Z" fill="#09195f" />
        <path d="M300.2,449.7c-1.1.4-.9,0-1,0h1Z" fill="#031c75" />
        <path
          d="M293.2,451.7c-8.7,1.2-17.5,3.5-27,4-.8-.4-1.7-.4-2.5,0-.3,0-.7,0-1,0-2,.2-3.9,0-5.5-.5,0-.5,0-.8.5-.8l8.5-.2c.6-.7,1.3-.7,2,0l4-.5c3.7-1.1,8.7-2.3,12.5-1.5l2-.5c.2-.4.3-.4.5,0,2.1-.2,3.8-.2,6,0Z"
          fill="#011160"
        />
        <path
          d="M256.7,453.7c3.2,0,6.4.2,9.5.5l-9,1c-3.8.3-7.6.3-11.5,0-1.2,0-2.3,0-3.5,0-2.4,0-5.8-.5-8-1,1.9-.4,3.9-.6,6-.5,5.4-.5,11-.4,16.5,0Z"
          fill="#010328"
        />
        <path
          d="M257.2,455.2c1.8,0,3.8-.3,5.5.5-.1,0-1.4,1-2.3.5l-14.7-1c3.8,0,7.7,0,11.5,0Z"
          fill="#031466"
        />
        <path d="M266.2,455.7c-.8,0-1.7,0-2.5,0,.3-.8,2.2-.8,2.5,0Z" fill="#031466" />
        <path d="M57.8,170.3v-1h.5c-.1.3,0,.8-.5,1Z" fill="#1c2fb5" />
        <path d="M53.3,182.3v-.5c0-.3,0-.7,0-1h.5c0,.5.1,1.3-.5,1.5Z" fill="#1c2fb5" />
        <path
          d="M53.3,182.3c-.2,1.2-.7,2.4-1,3.5-.1.4-.3.4-.5,0,.3-1.3.7-2.9,1.5-4,0,.2,0,.3,0,.5Z"
          fill="#143ac8"
        />
        <path d="M51.8,186.8c0-.3,0-.7,0-1h.5c-.1.4,0,.8-.5,1Z" fill="#1c2fb5" />
        <path d="M49.3,199.8c0-.2.3-.4.5-.5,0,.2-.3.4-.5.5Z" fill="#00045c" />
        <path
          d="M184.8,55.9c.4.1.4.3,0,.5.4.9,0,1.3-.7,1.7-2.6.7-5.3,1.4-7.3,3.3-.8.4-1.3,1.4-2.3,1.5-1.4.2-3.7-.7-5.4-.3s-2.1,1.4-3.3,1.3l1,1c-2.3.7-4.4,1.6-6.5,2.5l1,1-2-1c-.2.2.6,1.3.5,1.5s-2.6,1.8-2.8,1.9c-.6.3-4.7,1.5-3.1-.4-.9-.1-1.7.4-2.5.5s-.3,0-.5,0c-.2-.2-.2-.3,0-.5,2.4-1.5,5.9-3.2,8.5-4.5s2.7-1.4,4-2c1.1-1.2,3.3-2.2,5-2,2.1-.9,4.5-2.2,6.5-3s6-1.5,8.5-3c.4,0,1.1,0,1.5,0Z"
          fill="#010115"
        />
        <path d="M149.3,71.4l.5-.5c-.2,0-.3.4-.5.5Z" fill="#000025" />
        <path d="M150.8,70.9c-.2,0-.4,0-.5,0,.2-.2.3-.4.5-.5v.5Z" fill="#000025" />
        <path
          d="M167.3,61.4c.4,0,.9,0,1,.5-1.6.7-3.4,1.3-5,2-.6,0-.5-.5-.5-.5l.5-.5c.1,0,.3,0,.5,0l.5-.5c.1,0,.4,0,.5,0l.5-.5c.1,0,.3,0,.5,0l.5-.5c.3,0,.7,0,1,0Z"
          fill="#0b4fcf"
        />
        <path d="M161.3,63.9l-1,.5c0,0,.3-.3,1-.5Z" fill="#03073e" />
        <path d="M161.8,63.9l.5-.5c-.1,0-.3.5-.5.5Z" fill="#040748" />
        <path d="M162.8,63.4c0-.5.3-.4.5-.5l-.5.5Z" fill="#03073e" />
        <path d="M163.8,62.9c.1-.2.3-.4.5-.5,0,.2-.3.4-.5.5Z" fill="#03073e" />
        <path d="M164.8,62.4c.1,0,.2-.4.5-.5l-.5.5Z" fill="#03073e" />
        <path d="M165.8,61.9l.5-.5c-.1,0-.3.4-.5.5Z" fill="#03073e" />
        <path
          d="M186.3,59.4l.4.6c-1.8.8-3.6,1.6-5.4,2.4-.1.4-.3.4-.5,0-.8.7-1.8,1-3,1-.8.8-1.7,1.6-2.8,2.1-16.1,7.4-31,15-45.4,25.4l-1.8.4c-1.3,1-3.1,1.8-4.5,2.8-2.7,2-5.3,5-8.5,6.7,0-.2,0-.3,0-.5-1.3-.1-1.2-.5,0-1,.5-.8,3.2-3.3,3.1-2.1l.4-.9c-.2-2.2.9-1.2,2.4-2.4,3.4-2.5,4.2-3.3,8-5.4s7.3-5,11-7.4c5.6-3.5,13.2-8.1,19.6-11s3.3-.8,4.1-1.3.2-1.3.3-1.5.8.5,1.5.3c1.5-.4,3.6-2.3,4.9-2.7,5.6-1.5,9.2-4.1,15.1-5.6.1-.4.3-.4.5,0h.5Z"
          fill="#00002d"
        />
        <path
          d="M118.3,96.4c0,.2.6.7.5.9-.2.3-3.3,1.8-4,2-1.2-.9.4-2.4,1.5-3-.2-.2-.2-.3,0-.5.7,0,1.4.1,2,.5Z"
          fill="#01012a"
        />
        <path
          d="M115.8,96.4c.2-.2.3-.2.5,0-.1,1.5-1.1.7-1.5,3s0,.7,0,1c-1.9,1.5-4,3.3-6.5,2.5.8-.9.7-2.4,2.5-2l-.5-1c.3,0,.7,0,1,0-.2-.3-.6-.8-.3-1l1.3.5v.5c-.3,0-.7,0-1,0,.4.7.5,1.3,1.3.5,1.1-1.1,1.3-3.8,3.2-4Z"
          fill="#000025"
        />
        <path d="M116.3,96.4h-.5c0-.2.3-.5.5-.5,0,.2,0,.3,0,.5Z" fill="#00002d" />
        <path
          d="M238.2,45.4h.5c1.5,0,3,0,4.5,0,.8,1.1,3.7.6,5,0,.5,0,1,0,1.5,0,1.4,0,1.4,1.2,0,1.5-.2.8-1.2.7-1.5,0-1.4.8-3,1.2-5,1l-.5.5c-6.7.5-13.4,1-20,1.5-3.3-.7-6.6-.3-9.9,1.2l-7.5,1.3c-2.5,1.3-3.9,1.3-4,0l.2-.7c2.1-.7,4.3-1.2,6.5-1.4l-.2-.4c.3,0,.8-.4,1.5-.5l1-.5c.3,0,.7,0,1,0,.7-.1,1.3-.5,1.5-.5,3.8-.7,7.8-.7,11.5-2,.9,0,2.1,0,3,0s2.2-.4,3.5-.5c1.8-.1,3.9-.4,5.5-.5s1.3,0,2,0Z"
          fill="#020117"
        />
        <path
          d="M273.2,46.4c.5,0,1,0,1.5,0,.8,0,1.4.1,2,.5v.5c-6.2,1.1-12.4,1-18.6-.1,0,.5-.4.7-.9.6-2.4,0-5.4-.2-7.5-1v-1.5c8-.2,15.5.3,23.5,1Z"
          fill="#010211"
        />
        <path
          d="M248.2,45.4c-.4,1.2-1.4.9-2.2,1-1.8.3-4.7.5-6.5.5s-1.5.3-1.3-1c1.2-.1,2.6.2,3.8,0s1.1-.5,1.2-.5c1.6-.1,3.3,0,5,0Z"
          fill="#010211"
        />
        <path d="M238.7,45.4c-.2,0-.3,0-.5,0,0-.2.3-.5.5-.5v.5Z" fill="#0627ac" />
        <path
          d="M206.2,49.9c.4,0,1.1,0,1.5,0,1.6-.3,1.1.6.1.9-2.3.6-4.3.6-6.6,1.6.1,1.1-.3,1.8-1.3,2-2.8,0-5.6.4-8.4,1.5-1.9.9-5.1,2-6.8.4v-.5c.9-.2,3.4-1.5,4.5-2,.2,0,.3,0,.5,0,4.7-.4,11.5-2.9,16.5-4Z"
          fill="#020212"
        />
        <path
          d="M249.7,46.9c2.7,0,5.2.6,7.2.5s0-1,1-1.1c1.8-.2,3.5,1,5.1,1s4.6-1,6.7-.5l-2.5,1c2.4-.1,5.2,0,7.5-.2s1.6-.7,2-.8c.8-.1,1.7,0,2.5,0,.2.7,1,.4,1.5.5s1.6-.3,2,.5c-.5,0-1.6-.3-1.5.5.8.3,1.9.3,2.6.6,4.1,1.7,9.6,1.8,14.1,3.4s2.4,1.3,3.3,2h-.5c-1.4,0-2.9-.2-4.7-1-4.8-.8-9.7-1.8-14.7-3-1.2-.7-2.5-1.2-3.8-1.5-4.3.7-8.4.7-12.3,0-.5,0-1-.1-1.5-.5-1.4.9-3.5.8-5,0-.5.4-1,.4-1.5,0-1.1.6-2.3.5-3.5,0-1.5-.3-3.1-.4-4.7-.2-1.6,0-2.3-.3-.8-1.3.5,0,1,0,1.5,0Z"
          fill="#050117"
        />
        <path d="M210.2,48.9c0,0-.2.3-1,.5l1-.5Z" fill="#0d2ba0" />
        <path d="M276.7,46.9l-2-.5c.8,0,1.9-.3,2,.5Z" fill="#07399a" />
        <path d="M305.7,54.9l-2-.5c1.1.1,1.4.4,2,.5Z" fill="#050117" />
        <path
          d="M265.2,48.9c3.8,0,6.6-.3,10.3-1s7,3.1,12,3.5,1.9.2,3.1.5,3.4-1.1,2.2,1c2.8-.7,5.4.5,8,1.5s1.8.5,2.5,1c-.6.4-1.3.4-2,0-.3,0-.7,0-1,0-2.6-.5-5.1-1.1-7.5-2-.2,0-.3,0-.5,0-1.3-.1-2.5-.4-3.5-1-.2,0-.3,0-.5,0-1.1,0-2.1-.1-3-.5-13.7-2.1-27.3-2.5-41-3.5v-.6c3.2,0,6.3.2,9.5.6,1.2,0,2.3,0,3.5,0,.5.4,1,.4,1.5,0,1.7,0,3.3,0,5,0l1.5.5Z"
          fill="#06021f"
        />
        <path d="M303.2,55.4v.5c-.7,0-1.6.3-2-.5.7,0,1.3,0,2,0Z" fill="#08022f" />
        <path
          d="M205.2,52.4c4.1-.9,10.8-4,14.3-4s2.3.6,3.5.5c2.4-.1,5.6-.6,8-1v1c.9-.7,2.1-.7,3,0l.2-1.5c1.9,2.5.9.7,3.2.5s3.6.4,5.3.5c.1-.8.6-.8,1,0-5.8,1.6-12.2,1.3-18.2,2-2.9.3-5.9,1.2-8.7,1.5-1.2.4-10.7,1.5-11.1,1.1s-.3-.4-.3-.6Z"
          fill="#06001e"
        />
        <path
          d="M273.7,51.4c-1.3,0-2.7,0-4,0-1.2.6-1.8.6-2,0-.9-.4-2-.4-3,0-.5,1.4-1,1.4-1.5,0l-.5-.5c-6.2,1.4-13.5,1.3-19.9,1.1s-1-.3-1.6-.6c-6.9,1.3-13.9,2-21.1,2-6.2,1.6-12.5,2.8-18.9,3.5l-.8,1.2-11.8,3-1.3-.7c-1.2,1.8-4,3-6,2,1.2-1.9,4-1.1,5-3,2.1-1.4,3.9-1.9,5.5-1.5,3.1-1.2,7.1-2.4,10.5-3s.6.2,1,.5c3.6-1.4,7.5-2.2,11.5-2.5.1-.4.3-.4.5,0,18.1-2.3,33.9-3.4,52.2-2.5s4.5.5,6.2,1Z"
          fill="#060140"
        />
        <path
          d="M248.2,46.9c-.3,2.3,4.1,0,5.5,1.5h-9.5c-.2,0-.3,0-.5,0-.3,0-.7,0-1,0l-.5-1c2-.2,4-.4,6-.5Z"
          fill="#06011d"
        />
        <path d="M300.2,55.4c-2.6-.2-5.3-.5-7.5-2,2.5.4,5.1,1,7.5,2Z" fill="#08022f" />
        <path d="M292.2,53.4c-1.2-.1-3,.5-3.5-1,1,.1,2.7.4,3.5,1Z" fill="#08022f" />
        <path d="M288.2,52.4c-.4,0-2.2.7-3-.5,1,.2,2,0,3,.5Z" fill="#08022f" />
        <path
          d="M278.7,60.4c.2.7,1,.5,1.5.5.4.1.4.3,0,.5-.8,1.4-3.1,1-3.5-.5-4.1.5-8.3.8-12.4,0-6.8.3-13.7.2-20.6-.4-7,.6-13.6,1.1-20.4.9l-.8,1c-6.3-.6-12.3.6-18.2,2.5-1.6,1.9-6.2,3-8.5,2-3.6,2.2-7.7,3.7-12,3.5-3,1.5-6.2,2.7-9.5,3.5-.1.3-.3.3-.5,0-.4.5-.7.5-1,0,0-.9,1-1.4,3-1.5.2-.3.3-.3.5,0,.2-.3.5-.4,1-.5h.5c.1-.3.5-.5,1-.5.6-.6,1.2-1.1,2-1.5l.5-.8c3-.9,6-1.6,9-2.2,30.1-8.7,57.3-8.8,88.4-6.5Z"
          fill="#7684db"
        />
        <path
          d="M262.7,50.9l.5.5c.5,0,1,0,1.5,0,.9-.4,2.1-.4,3,0,.7,0,1.3,0,2,0v.5c-1.3,1.9-1.2,0-.6.2s.5,1.6-.4,1.8l-1.5.4c-8.1-1-16.3-1.2-24.5-.9l-1.5-.6c-1.4,0-1.4-1.2,0-1.5,7.1-.3,14.3-.7,21.5-.5Z"
          fill="#090555"
        />
        <path
          d="M269.7,51.9c5.3.1,11.3,2.1,17,3l-.5,1c-2.8.7-7.5.2-10-1-2.4.2-5.5.3-7.5-1l-.5-2c.5,0,1,0,1.5,0Z"
          fill="#05065a"
        />
        <path
          d="M286.2,55.9c.3,0,.9.7,1.5.5v.5s-3,0-3,0c-.9,0-2,0-3,0h-.5l-2.5-.5c-.9-.2-1.6-.4-2.5-.5-.4-.1-.4-.3,0-.5-.4-.1-.4-.3,0-.5,2.7.3,6.8.4,10,1Z"
          fill="#040553"
        />
        <path
          d="M276.2,56.9c1.2.3,2.7,1.6,4.5,1l-.9.9-8.6-.9c1.3,0,2.7,0,4,0l-.5-1c.5,0,1.1-.1,1.5,0Z"
          fill="#939dd8"
        />
        <path d="M221.2,453.2c-1.2,1-3.7.6-5,0,1.1.1,3.5-.1,5,0Z" fill="#09195f" />
        <path
          d="M187.3,60.4c3.1,1.7,3.5,2.9,1,3.5.4.1.4.3,0,.5l-.6,1.2c-2.1.9-6.4,2.1-8.7,2.7s-.4-.1-.7-.4l-4.8,1.8c-1.9,1.8-5.3,4.2-8.2,3.7-.6,1.4-2,2.4-4.3,3-1.3,1-2.5,1.3-3.7,1-3.6,3.3-8.2,5.9-12.6,8.4s-.9.3-1.3.5-1,.2-1.5.2l-5.6,4.1v.8c-5.3,2.9-9.2,6-13.4,10.1s-.6.3-1,0c-.5.4-1,.7-1.5,1-1.3,2.2-4.2,4.4-6.5,5,3.1-3.3,6.6-6.8,9.5-9.7s3.4-1.3,4-1.8c.5-1.2-.9-.9-1-1.3-.6-2.1,1.4-1.5,1.5-3.2,15.4-11.2,32-21.4,50-28,1.2,0,2.2-.3,3-1,.1,0,.3,0,.5,0,2-.6,4-1.4,6-2Z"
          fill="#000156"
        />
        <path
          d="M48.3,244.8c-1.6.4-2.3-2.1-2.7,0-1.3-.4-.6-5.2,0-6s1.5-.1,1.9-1.1c1.2-2.7-.6-7.3-.4-9.6s1.5-3.3,1.2-4.7l1.5,1.5c-.3,2.8-.9,3.7-1.1,6.2-.4,4.7-1,9-.4,13.7Z"
          fill="#00065c"
        />
        <path
          d="M201.2,52.4c1.5.8,2.5.3,4,0,0,.4,0,.7,0,.8-2.7,2.4-9.6,3.6-13,3.7-2.1.9-4.2,1.7-6.5,2.5-.2,0-.3,0-.5,0-1.1-.4-1.9-.6-3.1-.4s-4,1.7-5.4,2.4c.8-2,3.7-2.5,5.4-3.3s2-1.5,2.6-1.7c1.5-.6,3-.3,4.5,0l-.5-1c2.4,1,1.7,0,2.1-.4s.9.3,1.4,0c2.8-1.2,3.1-1.8,6.7-1.7s1.2.6,1.3.5-.2-1,0-1.4.7,0,.9-.1Z"
          fill="#06001d"
        />
        <path d="M180.8,62.4c-.4,1.3-1.9,1-3,1,1-.4,2-.7,3-1Z" fill="#060140" />
        <path
          d="M192.3,56.9c.8.1.6.5-.5,1-1.6.4-3.6,1-5.5,1.5s-.3,0-.5,0c1.4-.6,3.1-1.9,4.4-2.4s1.8,0,2.1-.1Z"
          fill="#000025"
        />
        <path d="M265.2,48.9c-.5.6-1.1,0-1.5-.5,1.2,0,1.4.5,1.5.5Z" fill="#06011d" />
        <path d="M258.7,48.4c0,.8-1.4.8-1.5,0,.5,0,1,0,1.5,0Z" fill="#06011d" />
        <path
          d="M216.7,51.9l-1.5,1c-.2,0-.3,0-.5,0-4,.3-7.8,1.1-11.5,2.5-3.7.8-7.9,1.6-11.5,2.5l.5-1c6.3-1.3,7.7-1.4,13-4.5s9.5-.3,11.5-.5Z"
          fill="#060127"
        />
        <path
          d="M241.2,51.4v2.1c0,0-11,.9-11,.9,6.4-.6,12.7-1,19.1-1.1l.4.6c-4.6.1-9.8.7-14.5,1-1.6.1-3.3.3-5,.5-2.8,1.6-7.9,2.4-11,1.5-1.3.4-2.3.4-3,0l-.5.5c-.2.6-1.2.6-1.5,0l-1,.5c-.5.6-2,.6-2.5,0-2.1-.3-4.3-.3-6.6-.1l-.9-.9c-.8.3-1.5.3-2,0l18.8-4.5c7.1-.5,14.1-.7,21.2-1Z"
          fill="#040356"
        />
        <path d="M214.7,52.9c-3.8,1-7.7,1.6-11.5,2.5,2.9-2.7,7.8-2,11.5-2.5Z" fill="#060231" />
        <path d="M267.7,51.4c-1,0-2,0-3,0,.5-.8,2.5-.8,3,0Z" fill="#040553" />
        <path d="M263.2,51.4l-.5-.5c.4,0,.5.5.5.5Z" fill="#040553" />
        <path
          d="M229.2,58.9c-3.8.3-7.7.8-11.5,1-1.9,0-3.7.4-5.5,1-.2,0-.3,0-.5,0l-3,.5c-.5,0-1,0-1.5,0-.6.2-.9.4-1,1-.2.2-5.1.8-6,1h-.5c-.7.1-2-.2-2.5,0-2.7-.4-1.4-1.6.5-2,.1-1.6,3.6-3,4.5-1.5.5-.8.8-1,1,0,4.3-1.1,8.6-1.8,13-2,2.2.7,3.7.6,6-.4,2.1,0,5.8,0,7,1.4Z"
          fill="#8d94d6"
        />
        <path
          d="M197.7,61.4c-1.8.7-2.4,1.1,0,1l-.5,1c-1.4.5-3.2,1.7-5.5,2.5.8-.4.5-1.8.6-1.9,1-1,2.9.5,3.4-.6-2.4-1-4.9.4-7.5,1v-.5c2.9-1.8,6.1-2.6,9.5-2.5Z"
          fill="#8991d8"
        />
        <path d="M217.7,59.9l-.3.4c-1.7,0-3.4.5-5.2.6,1.3-1.6,3.7-.9,5.5-1Z" fill="#8991d8" />
        <path d="M211.7,60.9c-.6.9-2.1.4-3,.5.6-.9,2.1-.4,3-.5Z" fill="#8991d8" />
        <path d="M233.7,58.4c-.3.8-1.3.5-2,.5.3-.7,1.3-.5,2-.5Z" fill="#8d94d6" />
        <path d="M207.2,61.4l-1,1c.3-.2-.9-.8,1-1Z" fill="#8991d8" />
        <path d="M200.2,63.4h-.5c.3,0,.5,0,.5,0Z" fill="#8991d8" />
        <path
          d="M276.7,60.9l.3,1.4c-1.2-.1-2.8-.9-4-.8s-1.6.8-2.5,1c-3.1.5-4.7-1.4-7.7-1l1.5.5c.1.8-.9.5-1.5.5-6.2.1-12.9.2-19.4-.5l-8.9,1.2c-.3-.4-.6-.6-1.2-.6-2.6,1.2-7.7.6-10-1l14.2-1.5c12.8.6,26.6,0,39.2,1Z"
          fill="#687fdb"
        />
        <path
          d="M223.2,61.4c3.6-.1,6.7,1,10,1,2.9.5,2.2,1-2,1.5-1.1,1.5-4.6,1.8-6,.5l-.5-1c-3.3.3-6.5-.9-9.8-.5-3.1.4-7.4,1.4-10.7,2,2.1-.8,5.3-2,7.4-2.4,3.2-.6,8.4-1,11.6-1.1Z"
          fill="#637ce1"
        />
        <path
          d="M268.7,53.9c2.5.2,5,.7,7.5,1v.5c-1,.4-2,.4-3,0-3.6,0-7-.7-10.5-1l-11-.5c-.7,0-1.3,0-2,0l-19.5.5,11-1.5c9.2-.5,18.3.1,27.5,1Z"
          fill="#08094a"
        />
        <path
          d="M230.2,55.4c1.6-.4,3.4-.5,5,0h1c-2.7.3-3.8,3-7,3.5s-4.5-.6-6.2-.5-4.9,2.6-6.8-.5c.4-.7,1.4-1,3-1,3.8-.8,7.1-1.3,11-1.5Z"
          fill="#929dd5"
        />
        <path d="M235.2,54.9v.5c-1.7,0-3.3,0-5,0,1.2-1,3.4-.4,5-.5Z" fill="#8f97d5" />
        <path
          d="M251.7,53.9l11,.5c3.1-.6,7.4,0,10.5,1,1.1.2,2.1.3,3,.5.6-.7,2.5-.5,2.5.5l2.5.5c.1-.4.3-.4.5,0,0,0-.8.5-1.7.6-1.3,0-2.5-.4-3.8-.6-.5,1.3-2.2,1.6-5,1-.2,0-.3,0-.5,0-2.3-.9-4.8-1.3-7.3-1.5l-.7-1c-2.5.2-5.3-.2-7.8,0s-6.2,1.4-9.5,1.2c-3.1-.1-5.1-1.7-9.2-1.2h-1c-.4-.1-.4-.3,0-.5,4.8-.6,9.6-1,14.5-1,.5-.9,1.5-.9,2,0Z"
          fill="#94a1db"
        />
        <path
          d="M270.7,57.9c-1.6,0-5.4.2-6.6-.1s-2.2-1.8-3.8-1.4c0-.4,2.4-1,2.5-1,2,0,7,.5,8,2.5Z"
          fill="#939dd8"
        />
        <path d="M262.7,54.4c-3.5-.3-7.6.6-11-.5,3.8,0,7.4.2,11,.5Z" fill="#040356" />
        <path d="M276.2,55.4v.5c-.9-.1-2.4.4-3-.5,1,0,2,0,3,0Z" fill="#05065a" />
        <path d="M281.2,56.9c-1,.4-1.9-.4-2.5-.5.8,0,2.1-.3,2.5.5Z" fill="#8f97d5" />
        <path d="M272.2,56.4v.5c-2.1.2-2.1-.7,0-.5Z" fill="#939dd8" />
        <path
          d="M201.2,56.9c.6,0,1.4,0,2,0,.6,2,.2,3-1,3-1.2.1-3.3,1.2-4.5,1.5-3.2.8-6.3,1.7-9.5,2.5l1-.7c-.6-.8-1.4-1.3-2.5-1.3l.5-1.5c4.1-1.2,9.9-2.9,14-3.5Z"
          fill="#070259"
        />
        <path
          d="M203.2,56.9c2.2-.2,4.3-.7,6.5-.5l-1.5,1.2,2.5.2c-.8.9-2.8,1.1-4,1l-.5.5h-1.5l-.5.5h-1c-.3,0-.7,0-1,0l.5-1.3-2-.7,2.5-1Z"
          fill="#070662"
        />
        <path
          d="M219.2,56.9c-.8.2-2.1.8-3,1-4.4.9-9,1.3-13,2,.3,0,.8,0,1,0l.5-.5c.4-.1,1.1.1,1.5,0l.5-.5c1.2-.3,2.9-.8,4-1s1.8.1,2.5,0l1-.5c.5,0,1,0,1.5,0l.5-.5c.9-.1,2,0,3,0Z"
          fill="#8998da"
        />
        <path d="M214.2,57.4l-1,.5c0,0,.2-.4,1-.5Z" fill="#8d94d6" />
        <path d="M215.7,57.4l.5-.5c-.1,0-.3.5-.5.5Z" fill="#8d94d6" />
        <path d="M204.2,59.9s.1-.4.5-.5l-.5.5Z" fill="#8d94d6" />
        <path d="M206.2,59.4s.1-.4.5-.5l-.5.5Z" fill="#8d94d6" />
        <path
          d="M409.6,127.4c-.1-1.9,3.4,1.6,3.6,2,.7,3.9,3.1,7.2,7.4,10,.9-.7,2,0,3.3,2.1,1.5,3.1,3.2,5.8,5.2,8.4l1.4,1.2c4.4,7.6,7.9,15.5,10.6,23.8,2.6,2.3,4.7,7.5,4.5,11,.9,2.6,1.8,5.4,2.6,8.1,2.6,8.8,4.1,17.9,5.9,26.9-1.6,2.9-2.1-1.1-1.9-3.1-2-5.7-3.9-11-4.7-17.1.8-2.1-.1-3.8-2.8-5.1,1.3-1.4,1.3-2.3,0-2.7l-.8-.2c-1.3-4.7-2.8-9.3-4.6-13.8-1.8-.7-2.7-2.3-2.8-5-1.9-.9-2.5-2.7-2-5.4l-1-.7c-.6-3.1-2.5-6.4-4.8-8.6l-.6-1.9c-1.1-1-1.6-1.6-1.9-3-2,.4-2.7-3.6-2.8-5.4-.7-.1-1.1-.8-1.2-1.9-2.8-3.2-5.4-6.7-7.1-10.7-1.4.9-4.7-2-4-3.5-.4-1.6-1-3.1-2-4.4l.5-1.1Z"
          fill="#000339"
        />
        <path
          d="M444.6,192.8c.8,0,2.2.6,2.5,1.3.7,1.4-2.7.1-2,1.5s3-.3,3,3,.7,4.1,1.4,7.6,1.1,3.9,2.4,7.6,1.1,6.7,1.3,7,.8,0,.9,0c.5.3.8,2.9.9,3.8,1.8,14.1,2.2,27.2,2.1,41.4,0,.8.3,2.2-.5,2.7.2-3.7.2-8.3,0-12-.3-7.7-1.2-15.3-2.7-22.8l.7-1.2-1.6-5c-3-3.1-3.7-6.1-2-9.2-1.4-3.2-2.9-6.3-4.6-9.4l.7-.9.6-.4c-1.5-3-1.9-6-1.2-9-2.5-2.1-3.1-4.1-1.9-6.1Z"
          fill="#000240"
        />
        <path
          d="M448.6,284.3c3.8-1.4.4,3.8,3.2,4.5,1.6-.4,2-7.5,1.8-9,1.6-.5,1,2,1,3,0,3.1-.3,6.1-1.5,9-.7-.4-.9-.9-.5-1.6-.9,3.1-1.3,6.6-1.4,10.2l-.6.3c1.1,1.8-.4,3.2-2.3,3.2l-2.2,8.8c-.2,1.2-.2,2.3,0,3.5.4.1.4.3,0,.5-.6.4-1.1.6-1.7.3-.5,3.1-1.3,6.2-2.3,9.2.3.2.5.3.5.5-.4,3.1-2.3,6.2-4,8.5.2,1.2-1,4.4-2.5,4.5-.9,2.7-2.4,4.5-4.4,5.5.5,1.6-.3,3.1-2.2,4.4,0,2-.6,3.2-2,3.5,1.1,1.2-.9,4.8-2.4,5.7-2.3,0-3.1-.6-2.5-2-.8-.3-.2-1.3.5-1.5l.3-1.5c11.4-18.5,17.9-38.2,22.5-59.3.2-1,.5-1.9,1.2-2.7,0-2.4.1-5.6,1.5-7.5Z"
          fill="#010557"
        />
        <path
          d="M451.6,301.3c0,.4.1,1.1,0,1.5-.5,2-1.8,4.7-2.5,7h-.8c-.3,1.8-1,2.8-2.2,3,0-1-.1-2.1,0-3.2s1.2-6.6,1.4-6.8,2.3,1.2,3-2c.7-1.2,1.1-.8,1,.5Z"
          fill="#010f5f"
        />
        <path
          d="M110.3,404.7c.7-.2,4.2,2.3,4.6,2.9s0,.7,0,1.1c3.2.8,6.1,3,7.5,6,2.1-.4,4.8,2.5,5,4.5,1.4-.6,2.4,0,3,2,1.3-1,3.2.9,3.1,2l.9.5c.3-.1.6-.2.7-.1,1.3.7,9.4,5.8,9.7,6.3s.1.5,0,.8c.5.7.2.9-1,.5-.3,0-.7.2-1,.2-.8,0-13.2-8-13.7-8.8s-.3-.6-.3-.9l-.5-.5c-.2.4-.3.4-.5,0-.8-.3-2.3-1.1-2.5-2-1,0-2.3-1-2.5-2-1,.4-1.8-.5-2-1.5-3.1-2.5-5.9-5.9-9.5-8-.6-.8-1.3-1.8-2-2.5,0-.4.1-.5.5-.5.2-.4.3-.4.5,0Z"
          fill="#060516"
        />
        <path
          d="M99.3,387.2c.6-.2,1.1,0,1.5.3,2.6,2.7,4.8,5.3,6.4,8.7,1.9,1.9,3.1,3.9,3.6,5.9,1.4,1.1,1.6,3.3-.5,2.5-.2,0-.3,0-.5,0-.5-.6-1-1.5-1.5-2-.5-1.3-1.4-2.5-2.8-3.6-1.1-4-4.4-7.5-7.2-10.4-.8-1.1-1.9-2.7-.5-3.5.6,0,1.1.6,1.5,2Z"
          fill="#050840"
        />
        <path
          d="M98.3,388.7c2.2-.5,1.5,1.4,2,1.7,1.5.9,2,1.7,3.2,3.3s3,5.3,4.3,6.6,2.9-.2.5,2.3c-1.3-1.2-2.6-2.1-4-3.5-1.7-3.1-3.5-6.1-5.5-9-.8.3-1.2-.5-.5-1v-.5Z"
          fill="#050c4e"
        />
        <path
          d="M87.3,380.2c.4-.2,1-.5,1.3-.3,1.8,1.8,4.8,5.9,6.3,8.1s0,.4-.1.7c.8-.5,1.5.8,1,1.5,1.6.9,2.3,1.7,2,2.5-.2,0-.5.3-.5.5-.3.5-.8.2-1.5-1-.9.1-2.9-1.6-2.5-2.5l-2-2.5c-2.5-1.2-5.3-4.7-5.5-7.5.5-.6,1.1,0,1.5.5Z"
          fill="#060853"
        />
        <path
          d="M98.8,390.2c.5.9,2.2,1.7,2.5,2.2,1,1.4,2.4,4.1,3.3,5.7s1.5,1.1-.3,1c-1.8-1.8-2.9-3.3-4.5-5l-1.5-3c-.4-.8-.5-1.3.5-1Z"
          fill="#030e64"
        />
        <path
          d="M96.3,388.7c1.1-.3,2.2,1.4,2,2.5,0,0,.6-.2,1,.3s1.4,2.6.5,2.7c-.5-.5-1.5-1-2-1.5-.7-.8-1.3-1.7-2-2.5,0-.6.3-1.1.5-1.5Z"
          fill="#04148a"
        />
        <path
          d="M449.1,309.8c-.6,2-.9,5.1-1.5,7s-1.7,2-2,4.5v.5l-.5.5c0,.1,0,.4,0,.5l-.5.5c-.2.4-.4.7-.5,1-.7,0-.2-.5-.2-.4-.1.3-.5,1.2-.7,1.4s-.3.1-.6,0c-.2-.2-.3-.4-.3-.5.5-2.2,1.8-7.3,3.8-8,0-.1,0-.3,0-.5-.2-1.1-.2-2.3,0-3.5,0-1.2,2.4-3.8,2-5.5l1,2.5Z"
          fill="#020e6e"
        />
        <path
          d="M428.1,157.3c.6.9,2.8,2.4,3,2.8.8,1.3,1.9,5.4,2.7,6.6s1.2.6,1.5,1,0,3.8.2,4.7,1,0,1.5.6c.7.9.8,3.6,1.2,4.2s1.4.3,1.7.6,1.1,3.5,1.4,4.3c2,4.5,1.7,6.4,3.2,10.6s1.1,1.3,1,1.5c-4.1,1,1.7,3.4,2,4.3s-1,1.6-.9,2.3c.2,1.4.4,3.3.6,4.4s3.1,4.7-.2,3c-.8.1-1.2-.6-1.1-2.1l-1.4-.8c-.2-2.2-.3-4.5-.4-6.9.6-.5.4-1.1-.6-1.8-1.4-.2-1.2-.5,0-1-.6-.6-1-1.5-1-2.8-1.2-.7-2.1-3.6-1.2-4.7l-.3-2c-2,.4-2-2.4-2-3.9-1.3-.7-2.3-1.6-3-2.6-1.5-3.6-2.9-7.2-4.2-10.9.4-3.1-.6-4-2.8-5.9-1.2-1.6-2.9-3.9-1.4-5.7.1-.3.3-.3.5,0Z"
          fill="#000346"
        />
        <path
          d="M415.1,136.3c3.3,3.3,3.2,4.7,5.3,7.9s2.2,1.7,2.5,2.2c.5.8,1.9,6.6,2.3,6.8,2.8,1.8,1.5,1.8,2.9,4.1h-.5c-.6.1-1.2,0-1.9-.2-3.4-6.3-7.2-12.4-11.2-18.4-.3-1-.5-1.8.6-2.3Z"
          fill="#000143"
        />
        <path
          d="M449.6,228.8l-.2-2.1c1.8-3.4,5.3,4.1,5.2,6.1.9,2.7,1.8,11.5,2,14.7s-.1,6.2,0,9.2c0,0-.5-.6-.5-1.2,0-1.8.6-9.8-1.3-10.2s-1.5.6-1.7.4c-.3-.3,1.5-8.9-2.5-8,0,1,0,2,0,3-.3.4-.8.5-.9.2-.3-.7-1.1-11.3-.7-11.8s.4-.3.6-.4Z"
          fill="#00034f"
        />
        <path
          d="M449.6,228.8c-.4,3.2.7,6,.5,9.2s-.4,2.2.5,2.7c0,.8,0,1.7,0,2.5.7,3.3.9,6.4.5,9.5,0,1.3,0,2.7,0,4-.8.5-.5,2.1-.5,3,0,1.4-.4,2.4-1,3-.1-6.9-.4-13.6-.9-20.5-.8-3.1-1.2-6.5,0-9.5l-.8-8c1.8,0,2.5,1.3,1.8,4Z"
          fill="#000146"
        />
        <path
          d="M443.6,196.8c2.4-.6,1.4,2.7,1.5,4.2s.8,1.2.8,1.5c0,.5-.8,1.3-.8,2s1.4.5,1.8,1.3,0,2,.2,2.5c1.1,2.8,4.5,7.7,4.9,10.3s-2.1,3.2-.4,5.4,2.2,2.3,2.8,4.7.3,2.7.2,4c-.2-.5-3.5-5.8-3.8-6-.7-.4-1.2,1.8-1.2,2l-1.5-4c.3,2.7.4,5.3.5,8-.5-.2-1-.5-1.1-1-.6-4.6-1.3-9.6-1.4-14-1.4-4.7-2.6-9.4-3.5-14.2l.5-.8-1.1-4.3c.1-.6.6-1.1,1.6-1.7Z"
          fill="#000249"
        />
        <path
          d="M448.6,284.3c-.4,2.5-1,5-1.5,7.5-.5.2-.6-.3-.5-1.5l-.6-2.3c.3-5.2,1.1-11.4,1.9-16.6s.4-.7.8-1c0-2.6.3-5.1,1-7.5.1-.7.6-2.3,1-3-.1,8.9-.6,15.7-2,24.5Z"
          fill="#01023d"
        />
        <path
          d="M423.1,355.2c-.2.3-.2,1-.5,1.5,0,.5,0,.9,0,1.4-.5,3.1-10.4,16.2-13.1,19.3l-2.3,1.3c1,1,.4,2-1,1.5-1.7,4-4.4,7.6-8.1,10.8.7.4,1.3,1.1.8,1.8-2.6,2.2-4.6,4.5-6.1,6.9.5,1.7-2.3,4.5-4,4-1.5,2.1-3.1,4.1-4.8,6.1h-.7c0-2.2.9-4.8,1.9-6.9-.6-1.2.2-2.5,2.3-3.9,1.4-.9,2.7-1.8,2.8-2.7-1.1-1-.3-1.9,1-1.5-.8-1.1.8-2.5,1.9-2l2.1-2c-.3-1.8,1.7-3.6,3.5-3.5.9-3.3,4-6.8,7-8.5-.7-1.3.7-2.9,2-2.5.7-2.6,1.9-4.3,3.5-5,1.1-2,2.2-3.9,3.3-5.9h1.2c1.2-2.3,2.4-4.3,3.5-6.2l.5-.5c-1.1-1.6,1.7-3.5,3-4,.7-.7.9-.4.5.5Z"
          fill="#010236"
        />
        <path
          d="M447.1,291.8c-4.7,24.3-11.6,42.2-24,63.5l-.5-.5c-.8-.1,0-1.1.5-1.5,1.1-2.6,2.4-5.1,4-7.5,2.2-5.8,4.7-11.6,7.4-17.6l2.5-7.5,1.1-.5c.6-1.3.7-2.5.4-3.6,2.4-7.1,4.4-14.2,5.9-21.4l.7-.4.6-3.4c-.5-.7,0-.9.9-1.1l.5,1.5Z"
          fill="#020241"
        />
        <path
          d="M434.1,344.7c.4,1.3-1.3,4.9-2.5,5.5.1.1.2.3.2.4,0,.6-6.4,10.5-7,10.9s-.4,0-.7-.3c0-.3,0-.7,0-1l.5-.5c.2-.3.3-.7.5-1,.5-.8,2.6-4.1,2.4-4.4s-1.5.1-.9-1.8,1.4-.3,1.4-.3c.3-.4.3-2.3.6-3s2.1-1.7,2.3-2.7-.5-1.3-.3-1.6c.8-1.2,4.8-.7,3.5-4.6,1.2.6,1.3.8,2-.5.5,1.5-.2,3.2-2,5Z"
          fill="#000861"
        />
        <path
          d="M444.1,324.2c-.7,1.9-1.5,4.5-2,6.5l-.5,1c-.2.5-.3,1.1-.5,1.5l-.5.5c0,.1,0,.4,0,.5h-.5c-.6.6-1.1,1-1.5,1,.7-2.4,2-4.5,3-6.7s.3-1.8.5-2.3c0-.5,0-.9.5-1,.5-1.2,1.7-3.2,1.5-1Z"
          fill="#020e7d"
        />
        <path
          d="M440.1,334.2v.5l-.5.5c.3.2.3.3,0,.5l-.5.5c.3.1.3.3,0,.5-.6,2.2-2,5.3-3.5,7-.5.6-1,.9-1.5,1,.6-1.5,1.3-3.6,2-5s1.8-3.5,2.5-4.5,1.3-2,1.5-1Z"
          fill="#02167f"
        />
        <path
          d="M446.1,316.8c-.9,2.8-2.9,5.6-3.5,8.5-.2.4-.4.7-.5,1-.8-1.7.6-2.7,1-4.3.5-2.4-1-7.7,3-5.2Z"
          fill="#00075f"
        />
        <path d="M446.1,316.3c-1.3-1.2,0-2.8,0-3.5,0,1.2.6,1.1,0,3.5Z" fill="#00075f" />
        <path
          d="M427.1,362.2c-3.7,5.8-7.2,11.2-11.5,16.5-1,1.6-2.2,3.1-3.5,4.5-.6.9-.8,2-2,2.5-.5,1.4-1.6.9-1-.5-.1-.2-.2-.5-.3-.7,0-.5,5.1-7.1,6.3-7.3.4-.6.9-1.1,1.5-1.5-.4-.2-.4-.3,0-.5l1-1c.6-3.4,3.5-7.1,6-9.5,1.1-3.5,3.3-7,6-9.5l.5-.5c-.9-.6-.6-1.2.5-1l.5-.5c-.9-.5-.5-1.2.5-1l.5-.5c-.4-.1-.4-.3,0-.5l.5-.5c-.4-.2-.4-.3,0-.5l.5-.5h.5c-.1.2,0,.9-.3,1.4-2,3.7-4.7,7.1-6.2,11.1Z"
          fill="#04074a"
        />
        <path
          d="M383.6,411.2c-.4.3-.6,1.2-1,1.5-1,.9-1.8,2-3,3-1.8,1.4-4,1.8-5.5,4.5-.1.4-.7.3-1,0-.1.3-.3.3-.5,0,0-1.2-.8-1.7-2.5-1.5-.4-.1-.4-.3,0-.5-1.1-.8,0-2.2.9-2.9s6.6-3.6,8-4.1l1.1.6c.6,0,1.1.2,1.5.5-.2-.6.3-1.3,1-1,.1-.5.3-.4.5,0h.5Z"
          fill="#00011d"
        />
        <path
          d="M124.8,413.7c.3-.2.5-.3.7-.3,3.2,1.3,7,3.8,9.8,5.8.4-.1.7.2,1,.5.1-.4.3-.4.5,0,2.3,1.8,4.6,3.5,7,5,.1-.4.3-.4.5,0l.5.5c.7-.3,1.5.3,1,1l-.8.5c-4.1-1.4-7.7-4-11.2-6.5-2.2-.7-4.4-1-6.5-1-1.8-1.4-3.3-3.2-5-4.5-2.5-2.4.4-2.3,2.5-1Z"
          fill="#0a1437"
        />
        <path
          d="M136.8,423.7c4.8,2.6,9.4,5.4,13.9,8.4v1.1c.4.3.4.7,0,1-2.1,0-4.6-1.9-6-3.5-3.3-2-7.7-4.5-10.5-7-3.8-2.2.9-2.6,2.5,0Z"
          fill="#14327a"
        />
        <path
          d="M115.8,407.2c.3,0,.6-.2.9-.1.5,0,6.9,5,7.8,5.8s.2.5.2.8c-1.1-.5-1.9-.3-3,0l.5,1c-2.5-2-5-3.9-7.5-6-.6-1,.8-1.7.8-.9s-.9.2.2-.6Z"
          fill="#0a112b"
        />
        <path
          d="M110.8,402.2c.4-.5.7-.5,1,0l2.5,3.5c1.3-.7,2.2.2,1.5,1.5l.5,1-1.5.5c-1.5-1.3-3.4-2.2-4.5-4,.9-.6,1.2-1.6.5-2.5Z"
          fill="#070d37"
        />
        <path
          d="M133.8,420.7c1.6.5,4.4,2,5,3.5-.5.3-1.1.2-2-.5-1.1-.4-2.1-1-3.2-1-1,0,.5.8.7,1-1.6-.3-2.7-1.6-4-2.5-3.1-3.1,1.8-1.9,3.5-.5Z"
          fill="#122b5e"
        />
        <path
          d="M150.8,434.2c.7-.5.9-.2.5.5.7.5.5.7-.5.5-.2,0-.7,0-1,0-1.7-1.5-4-2.8-6-4l1-.5c2,1.2,4,2.3,6,3.5Z"
          fill="#171131"
        />
        <path
          d="M133.8,420.2c.3.1.3.3,0,.5-1.2-.6-2.7-.7-4-1l.5,1.5c-1-.7-2.1-1.3-3-2l.2-1.4c2.2.6,4.3,1.4,6.3,2.4Z"
          fill="#0f2253"
        />
        <path
          d="M100.3,385.7c2.4,1,3.8,2.5,4,4.5l1,.5c.4.1.4.3,0,.5,1.4.7,1.9,1.4,1.5,2,1.1,2.2,2.6,3.7,4.4,4.5,1.2,2.6,2.5,4.9,3.8,7l-.8,1c-.6-.4-1.9-.4-2-.5s.6-.8.3-1.5-1.4-1.1-1.8-1.5c-4.3-5-7-10.9-11.5-15-.6-.7-.7-1.4-.5-2,.1-.4.3-.4.5,0,.7-.7,1.1-.5,1,.5Z"
          fill="#04062f"
        />
        <path
          d="M83.8,368.7c1.3,1,2.5,2.3,3.5,4,.7-.6.9-.3.5.5,1.7.5,2.9,2,3.6,4.5,2.1.6,3.7,2.4,4.9,5.3,1.3.9,1.8,1.7,1.5,2.2,0,1.1.2,2.5.5,3.5s0,.4,0,.5h-.8c-2.6-3.4-5.4-6.7-8.2-10-2.5-3.8-5.1-7.4-7.9-10.9l.9-.6c.5-.4,1-.1,1.5,1Z"
          fill="#020653"
        />
        <path
          d="M92.8,376.7c.8-.7,1.6.1,1,1,1.9.4,3.6,2.5,3,4.5,1.2.9,1.8,1.9,2,3,.2.6.3,1.4.5,2-.7-.7-1.2-2-1.5-2s-.9.7-1,.5l.5-1.3c-2.2.3-3-4.7-4.6-5.6s-1.6,0-1.8-.1-1.7-3.9-3-5.5c-.9-2.2-2-4.3-3.4-6.3l.4-.7,1,.3c2.5,3.4,4.8,6.8,7,10.2Z"
          fill="#04033b"
        />
        <path
          d="M89.3,379.2c1.5,1.5,3.2,2.5,4.5,3.8,1.8,1.8,2.8,4.3,4.5,6.2.1.3.3.7.5,1l-.5,1c-.7-.8-1.2-1.6-2-2.5-.7.7-1.2-.2-1-1-1.4-.3-6.5-6.9-6.4-7.7s.2-.5.4-.8Z"
          fill="#020c65"
        />
        <path
          d="M78.8,366.2c1.8.2,2.9,1.5,3.4,3.7,2.8,2.8,5.1,5.9,7.1,9.3,1.4,3.2,3.8,5.8,6,8.5.6.8.6,1.3-.5,1-1.7-2-5.8-7.4-7.5-8.5v-.5l-.5-.5c-2.4-3.1-4.7-6.3-7-9.5-.7-1.4-1-2.5-1-3.5Z"
          fill="#062eb6"
        />
        <path d="M96.3,388.7l1,2.5-1.5-1c-.5-.5-.7-1.2-1-1.5l.5-1c.2.3.6.6,1,1Z" fill="#0214a4" />
        <path
          d="M435.6,343.7v.5l-.5.5c.3.1.2.3,0,.5,0,.2,0,.4,0,.5l-.5.5c0,.1,0,.4,0,.5l-.5.5c0,.1,0,.4,0,.5l-1,1.5c0,.1,0,.4,0,.5l-.5.5c0,.1,0,.4,0,.5h-.5c-.7.7-1,.4-.5-.5.9-1.4,1.4-3.9,2.5-5.5s1.4-.9,1.5-1Z"
          fill="#03228c"
        />
        <path d="M433.1,349.2l1-1.5c-.5,1-.6,1-1,1.5Z" fill="#060e5f" />
        <path d="M434.1,347.2l.5-.5c-.1.3-.5.4-.5.5Z" fill="#060e5f" />
        <path d="M434.6,346.2l.5-.5c-.1.4-.5.5-.5.5Z" fill="#060e5f" />
        <path d="M435.1,345.2c0-.2,0-.3,0-.5.2-.2.3-.2.5,0,0,.2-.3.4-.5.5Z" fill="#060e5f" />
        <path d="M435.6,344.7h-.5c0-.2.3-.4.5-.5,0,.2,0,.3,0,.5Z" fill="#02167f" />
        <path d="M441.6,331.7c.1-.3,0-.8.5-1-.1.4,0,.8-.5,1Z" fill="#060b4e" />
        <path
          d="M373.6,96.9l.3-.5c-1.4-.3-2.5-2.6-.8-3s9.6,6.6,9.9,8.5c3.5,0,6.5,3.9,8.2,7l3.4,1.7c2.7,4.1,5.8,7.6,9.5,10.6l-.3.6c1.8,1.3,2.7,2.9,2.8,4.6,2.4,1.8,3.8,4,4.4,6.7,1.2,1.4,3,2.5,4,3.5.1,1,.3,2.1.6,3.1.8,2.3,4.1,4.8,5.6,7.9s.3,1.3.3,2l1.5-.5c-.9,1.9,1.1,5.6,2.5,7l.5-1.5c-.6,4.5,1.5.6,1.5,3,.8,1,.2,2.3.6,3.4s4.3,4.2,4.3,4.5c.8,3.1-.9,7.2,3,8.9.4.9-.9.7-1,1-.4,1.4.8,1.1,1,1.6s.3,2.1.5,3.1c.4.1.4.3,0,.5-3.1-4.9-5.5-10.5-7.5-16-1.1-.9-1.9-2.6-2-4-.9-.4-1.3-1.1-1.7-1.9-6.3-11-12.5-21.2-21-30.7l-.3-1.4c-2.7-.9-5-3.9-6-6.5-.9.5-1.8-.6-1.5-1.5-1.3,0-2.2-1.3-2.5-2.5-1.3.2-1.9-.8-2-2-1.3,0-2.1-.1-1.5-1.4l-.9-1.1h-1.1c-3.1-3.1-6.1-6.2-8.9-9.5-1.9.5-6.2-3-5.5-5Z"
          fill="#010352"
        />
        <path
          d="M446.1,217.8c1.6,4.9,1.1,10.1,2.5,15,.5,10,1.3,20,1,30-.5,2.4-.7,5.2-1,7.5-.3-6.8-.3-13.7,0-20.7l-.5,1.7c-1,.5-1.2-.3-.5-1-.6-1.1-.6-1.6,0-1.5-.6-1-.9-3.4,0-4,0-1.6-.5-3-1.3-4.1-.4-7.5-1-15-2.2-22.4l.5-2.9c.2-2.7,1.3.9,1.5,2.5Z"
          fill="#0a24b9"
        />
        <path
          d="M440.6,195.8c.9,2.3,1.5,4.7,2.5,7,.7,5,2.6,9.9,3,15-.4-1-.5-2.2-1.3-3l-.2.5-1.4-1.7c-1.4-5.4-2.7-10.8-4.1-16.2l.4-1.1-.5-1.5c-.6-.2-.7-.9,0-1l-.5-1c-1-.3-1-.7,0-1-.3-1-.3-1.3.6-.9l1.4,4.9Z"
          fill="#1224b5"
        />
        <path
          d="M448.6,270.3c-.7,6.6-.9,13.4-2,20s-.9,3.4-1.5,4.5c-.4-.5-.7-1-1-1.5-.7-.6-.6-1.3-.5-2.1,1-6.3,1.8-12.6,2.6-19s.3-1.4.9-2c.4-1.4.8-3.4-.5-4.1l1-.9c-.8-3.8-.5-8.8-.2-12.8s.3-.8.7-1.2c0-3.2,0-6.3,0-9.5l1,6.2c.2,7.5-.3,14.9-.5,22.3Z"
          fill="#0624c3"
        />
        <path
          d="M406.1,380.2c4.1,1.3.9,5.2-1.8,6.6l-3.7,4.9c-2.1,3-4.9,6.2-8,8-.7-1.4-.3-1.1.3-1.9.8-1.2,5.2-4.6,5.2-5.4s-1-1-1.5-.7-1.5,2.6-3,2.2c4.5-4.3,8.6-8.9,12.5-13.7Z"
          fill="#01014e"
        />
        <path
          d="M390.1,396.2c0,0,.7.4.4.9-.3.7-4.8,3.5-5.4,4.9,1,.4,3.8-3.7,4-1.5-1.4.3-1.4,1.9-1.6,2.1s-.9,0-1.4.5c-1.1,1.4-1.5,5.1-3,6.6.2.4,0,.6-.5.5-.5.6-.8,1.2-1,2-.7.5-1.7.7-2.5,1.5-.4-1.5.5-1.4,1-2,0-1.3.6-2.6,1.6-4.1-1.4,1.3-2.6,1.7-3.6,1.1-1.2-.4,1.2-1.8,1.1-1.7-1.7,1.7-2.6,1.9-2.6.7-.2-1.6,2.6-3.8,4.1-3.6l1.4-1.4c-.4-.7.3-1.3,1-1,.1-.4.3-.4.5,0l.5-.5c-.3-1.3.6-2.1,1.8-1.9l1.2-1.1c.1-.4.3-.4.5,0l1-1c-.3-1.3.3-1.8,1.5-1Z"
          fill="#020221"
        />
        <path
          d="M415.6,374.7c-1.4,3.2-4.3,7.5-7.5,9-1.3,3.2-4.1,7.2-7.5,8,0-.3,2.9-5,3.1-5.3.6-.8,2.2-.8,2.8-1.5,1.5-1.8.2-2.8-.5-4.6.4-.5.6-1,1-1.5,2.6-1.2,2.1,0,2.6.4s3-2,3.5-2.6c1.8-2.6,2.8-3.7,5-6.3,1,1.3-1.1,4.3-2.5,4.5Z"
          fill="#000360"
        />
        <path
          d="M405.6,378.7c-2.2,3-4.5,5.7-7,8.5-1,.5-1.8.7-2-.5.4-1.9,4.6-7.5,6.4-8.5s.3.2.6.5c.5-1.1,1.3-.8,2,0Z"
          fill="#0943d9"
        />
        <path
          d="M417.1,359.2c2.3-1.6,1.4,1.2.6,2.7l-2.1,3.3c-.8,2-2.8,4.5-4.5,6-.4-.2-.6-.6-.5-.9,1.6-3.2,1.6-1.8.6-1s-.4,0-.6-.1c-.2-.2-.4-.5-.4-.6.3-.8,3.4-5.1,4.1-6s.4,0,.8,0l2-3c-.4-.1-.4-.3,0-.5Z"
          fill="#0c3dd1"
        />
        <path
          d="M398.6,387.2c-1.1,1.3-2.4,2.3-3.5,3.5-1.5,1.8-4.2,3.5-2,0-.6-.5.3-1.4,1-1.5-.1-1,1.5-2.7,2.5-2.5,0,0,.9.3,1.5-.5l.5,1Z"
          fill="#0d48d1"
        />
        <path
          d="M407.6,376.2c-.6,1.1-1.4,1.7-2,2.5-.6.7-1.9,0-2,0-.4-.1-.4-.3,0-.5l.5-.5c-.3-1.4,1.3-2.9,2.5-3.5-.1-.5,0-.6.5-.5,2.7-2.5,2.1.7.5,2.5Z"
          fill="#0f44e3"
        />
        <path
          d="M411.1,371.2c-.8,1.9-2.1,3.4-3.5,5,.5-1.1,1-1.8.5-3l-1,.5c.3-1.7,1.9-4.2,3.5-4.5.5-.5.8-1.3,1.5-1.5-.1,1.1-.5,2.5-1,3.5Z"
          fill="#1648d7"
        />
        <path
          d="M423.1,353.2c-.3.4-.3,1.1-.5,1.5-.7,1.2-2.2,2.8-3,4-1.1,2-1.7.8-1.5-.5-.5-1.4,1.5-5.1,3-5,.9.2-.8,2-.7,1.9.5-.8,1.1-1.6,1.7-2.4s.6-.3,1,0v.5Z"
          fill="#073cd5"
        />
        <path
          d="M391.1,394.7c-.3.3-.9,1.2-1,1.5-.5.3-1,.6-1.5,1l-1,1c-.1,0-.4,0-.5,0-4,3.7-2.6-.5.5-2-.8-1.2-.4-1.8,1-1.5-.6-1.4.4-1.9,1.5-1,1.2-.8,1.7-.3,1,1Z"
          fill="#1d4bbf"
        />
        <path
          d="M395.1,390.7c-1.2,1.3-3,2.8-4,4-.2-.3-.9-.8-1-1-.5-.1-.5-.3,0-.5-.7-1.4,1.7-2.4,3-2.5l-.2,2,2.2-2Z"
          fill="#1245ca"
        />
        <path
          d="M419.6,358.7c-1.2,2-2.1,4.8-4,6.5.4-.9.5-2,.5-3,1,.9,1.4-.1,1.7-1.2s.9-3.2-.7-1.8c-.7-.7.2-1.6,1-1,.4.9.7,1.2,1.5.5Z"
          fill="#0f3bc6"
        />
        <path
          d="M438.1,320.3c-1.2,6.1-7.5,20.2-11,25.5l-.6-.4c.5-1.1.6-2.1.6-3.1-.5-1.8,1.3-5,2.5-6.5.5-2.5,1.2-5.2,3-7,.5-3.6,2.2-7.8,4.5-10.5,1.4-4.4,2.3-.8,1,2Z"
          fill="#0b36d5"
        />
        <path
          d="M445.1,294.8c-.2,3.3-1.4,7.7-2.2,11-1.2,4.8-2.8,10-4.8,14.5.2-1.1.8-3.3-.5-3.5,0,.6-.3,1-.5,1.5-.5-2.6,1-6.9,2.5-9,0-.5.2-.8.5-1-.4-.1-.4-.3,0-.5l.5-1.5c-.4-.1-.4-.3,0-.5l.5-1.5c0-2.8,1-7.5,2.1-10.2s.5-.6.9-.8c.2-.7.9-1.4.5-2.5h.5c0,1.3,0,2.7,0,4Z"
          fill="#072ecd"
        />
        <path
          d="M423.1,353.2v-.5c-.9-.9.6-3.4,1.5-4-.1-1.1,1.2-3.7,2.5-3-.9,2.7-2.4,5.1-4,7.5Z"
          fill="#0b39cd"
        />
        <path
          d="M432.1,350.7c.2.2.2.3,0,.5,0,.2,0,.3,0,.5l-.5.5c-.2.3-.3.7-.5,1l-.5.5c-.2.3-.3.7-.5,1l-.5.5c-2,3.2-4,6.4-6,9.5-.8,1.2-1.2.9-1-.5.7-1.2,1.1-1.5,1.5-3,2.2-1.7,3-4.8,4.3-6.9s2.5-2.9,3.2-4.1l.5.5Z"
          fill="#031e95"
        />
        <path
          d="M422.6,356.7c-.2,1.9,1.2-.5,2.5,2,.4.6.2.9-.5,1l-.5.5c.5.1.5.5,0,1,1.1.6-.4,3-1.5,3-.2,2-2.4,5.7-4.5,6-1,1.7-6.7,9.9-8.1,9.9-1-.5-1.9-.9-2.9-1.4,5.9-7.4,10.7-14,15.5-22Z"
          fill="#010156"
        />
        <path
          d="M423.6,364.7c-2,3.1-3.8,6.5-6,9.5l-1,1c0,.1,0,.4,0,.5h-.5c-1.1.5-.9,0-.5-1,.8-1.1,1.9-3.2,2.5-4.5,1.6-1.9,3.2-3.8,4.5-6l1,.5Z"
          fill="#021d98"
        />
        <path d="M411.6,376.7s-1.1.2-1-.2c.8-1.4,1.6-.3,1,.2Z" fill="#000360" />
        <path d="M424.1,360.2c0-.2.3-.4.5-.5-.1.2-.3.3-.5.5Z" fill="#010557" />
        <path
          d="M416.1,375.7c0,.4-.4.9-1,1.5-1.8,2.4-4.2,5.8-6,8s-.6.6-1,1c-1.4.7-1.4-.1,0-2.5,2.5-2.9,5.3-5.9,7.5-9l.5,1Z"
          fill="#02199d"
        />
        <path d="M429.6,355.2l.5-.5c-.1.2-.4.4-.5.5Z" fill="#0b104e" />
        <path d="M430.6,353.7l.5-.5c-.1.2-.4.3-.5.5Z" fill="#0b104e" />
        <path d="M431.6,352.2c.1-.2.3-.3.5-.5,0,.2-.3.4-.5.5Z" fill="#0b104e" />
        <path d="M432.1,351.2v-.5h.5c0,.2-.3.3-.5.5Z" fill="#060e5f" />
        <path d="M432.6,350.2c.1-.2.4-.3.5-.5,0,.2-.4.3-.5.5Z" fill="#060e5f" />
        <path d="M416.6,375.2l1-1c-.4.5-.9.8-1,1Z" fill="#010156" />
        <path d="M415.1,377.2l1-1.5h.5c-.6.8-1.2,1.2-1.5,1.5Z" fill="#010156" />
        <path
          d="M408.1,386.2c-.7.8-1.3,1.7-2,2.5-3.4,3.9-7.2,7.5-11,11,1.1-4.2,5-5.1,5.9-7.1s-.4-.8-.4-.9c2.6-2.7,5-5,7.5-8l-.4,2.2.4.3Z"
          fill="#01087e"
        />
        <path
          d="M372.6,420.2c.3.1.3.3,0,.5-.1,0-.3.8-.5,1-.2,0-.3,0-.5,0l-.5-1-.4-.5c-8.5,3.9-17.1,8.1-25.7,12.6l-2.3.3-.2-.6c7.1-4.3,14.2-8.3,21.6-12l1.2.2c.2-.9.3-1.2,1-.5.4-.9,2.8-1.9,4-1.5,1.5-.6,3.1-1.2,4.8-1.5-.3,1.1-1.5,1.9-2.3,3Z"
          fill="#01032a"
        />
        <path
          d="M378.1,408.7l4.5-3c.6,3.2-.8,3.9-2.5,6l-8.8,4.5-1.2,2c-1.4.4-2.7,1.1-4,2-.3.1-.7.3-1,.5-3.3-.5-1-2.1,1-3,1.8-2.9,4.8-5.2,8-6.5.3-1.6,2.4-3.2,4-2.5Z"
          fill="#01000b"
        />
        <path d="M370.1,418.2v.5c-1,.4-3.2,1.1-4,1.5v-1.5c1.7,1.2,1.5-1.3,4-.5Z" fill="#01021c" />
        <path
          d="M143.8,423.2c.5-1.2,1.9,0,2.4,1l6.1,3.4v.7c1.6-.4,3.3.6,4,2,1.8-.2,3.1.5,4,2l.5.5c.1-.4.3-.4.5,0l.5.5c.1-.4.3-.4.5,0l1.5.5c.2-.4.3-.4.5,0l.5.5c.2-.4.3-.4.5,0l1,1c.2-.4.3-.4.5,0l.5.5c.2-.4.3-.4.5,0l.5.5c.2-.4.3-.4.5,0l.5.5c.1-.4.3-.4.5,0,.6.3,1.1.6,1.5,1,.2-.4.8-.4,1,0l.5.5c0-.8.8-.7,1,0l.5.5c.4-.7,1.5-.3,1.5.5l.5.5c.6-.9,2-.6,2,.5l.5.5c.1-.4.3-.4.5,0l.5.5c.3-1,.7-1,1,0l1.5.5c.3-.7.7-.7,1,0l.5.5c.1-.4.3-.4.5,0l1,.5c.1-.4.3-.4.5,0l.5.5c.1-.4.3-.4.5,0l1,.5c-.1-.9.7-.8,1,0l.5.5c-.1-.9.7-.8,1,0l.5.5c.2-.9,1.1-.7,1.5,0l.5.5c.2-.4.3-.4.5,0l.5.5c0-.9.7-.8,1,0l.5.5c.8-.6,2.3-.6,2.5.5,1,1.1-.6,1.2-1.5.5-.1.4-.7.3-1,0l-1-.5c-1.1.5-3.5.1-4-1l-3-1c-1.2.8-2.9.3-3.5-1l-1-.5c-.1.3-.3.3-.5,0l-1-.5c-.2.4-.3.4-.5,0l-2-1c-.2.4-.3.4-.5,0l-2-1c-.1.4-.3.4-.5,0l-3.5-1.5c-.1.4-.3.4-.5,0-1-.3-1.8-.8-2.5-1.5-.2.4-.3.4-.5,0l-4-2c-.2.4-.3.4-.5,0l-.5-.5c-.2.4-.3.4-.5,0l-.5-.5c-.2.4-.3.4-.5,0l-2-1c-.2.4-.3.4-.5,0l-.5-.5c-.2.4-.3.4-.5,0l-.5-.5c-.1.4-.3.4-.5,0l-.5-.5c-3.8,0-9.2-3-11.5-6-.2,0-.5-.7-1-1l-.5-.5c-.1,0-.4,0-.5,0-.4-.4-.6-.6,0-1-.4-.2-.4-.3,0-.5Z"
          fill="#020218"
        />
        <path
          d="M107.8,393.7c1.8.3,4.1,1.5,4,3.5,1.8.1,2.5.8,2,2,1.2-.5,2,.3,1.5,1.5,2.1.4,2.9,1.3,2.5,2.5-.9,2.8,3.5,5.7,5.8,7.3,2.9,1.2,5.3,2.8,7.2,4.7l2,1.5c1.1,0,2.4.8,2.5,2,.2.2.2.3,0,.5-4.4-2.1-6.3-2.7-10.5-5.5s-5.8-4-9-6.5-1.3-1.4-1.5-1.5c-.5-2.1-2-3.6-3.1-5.6s-.8-.4-.8-.5c-.1-.4.6-1.1.4-1.4s-.7.6-1.5-.2-3.5-4.1-2.5-4.8c.8-1.1,1.2-.8,1,.5Z"
          fill="#060820"
        />
        <path
          d="M130.8,415.2c-4.6-2.1-8.9-3.8-12.5-7.7s-1.6-3.1-3.5-4l1-.7h-1.5s.3-1.5.3-1.5c.7.2,1.6,1.7,1.9,1.9.5.3,1.2,0,1.3.1,1.1-1,1.8-.3,1,1l1.5,1.5c.2-.3.3-.3.5,0l1,1c.9-1,1.2-.8,1,.5l2,2c.7-1.1,1.1-.8,1,.5l1.5,1.5c.8-1.1,1.1-.8,1,.5l1,1c.2-.4.3-.4.5,0,1,.9,2,1.7,3,2.5.6-.3,1.3.4,1,1l.5.5c.5-.6,1.1-.3,1,.5l.5.5c.5-.6,1.1-.3,1,.5l.5.5c.4-.7,1-.2,1,.5l.5.5c.8-.3,2.3.6,2.5,1.5l.5.5c.6-.5,1-.3,1,.5l1,1c0,.1,0,.3,0,.5-2.5-.4-4.8-1.8-7-4-.1,0-.4,0-.5,0l-1-1c-.9-.6-1.7-1.4-2.5-2l-2-1.5Z"
          fill="#080413"
        />
        <path
          d="M145.8,426.2c3.9,2.4,7.6,4.1,11.5,6l.5.5c.1,0,.4,0,.5,0l.5.5c.1,0,.4,0,.5,0l.5.5c.1,0,.4,0,.5,0l2,1c.1,0,.4,0,.5,0l.5.5c.1,0,.4,0,.5,0l.5.5c.1,0,.4,0,.5,0l4,2c.1,0,.4,0,.5,0,.6.4.8.7.5,1-.2.2-.4.4-.7.5-.7.2-5.8-2.5-6.8-3-5.2,0-11.2-3.6-15.5-6.9-3.2-1.3-5.8-3-7.9-5.1-1.6-.9-3.4-2.8-5-3.5v-.5c4,2,7.6,4.8,12,6Z"
          fill="#08194b"
        />
        <path
          d="M143.8,423.7c0,.3,0,.7,0,1-2.4-1.5-5.3-2.5-7-5,2.3,1.2,4.3,3.5,7,4Z"
          fill="#040618"
        />
        <path d="M136.3,419.7c-.3-.2-.7-.3-1-.5v-.5c.4.3.9.4,1,1Z" fill="#040618" />
        <path d="M144.8,425.2c-.2-.1-.3-.4-.5-.5l.5.5Z" fill="#040618" />
        <path
          d="M138.8,424.2c5.6,3.2,18.1,10.9,23.5,12,1.6.5,2.4,1.2,2.5,2,1.2.7.8,1.3-.5,1-.7.2-1.4-.3-1.5-1-.5-.7-1.4-1.2-2.5-1.5-2.4.7-4.7-.4-6.5-2-.6.7-2.2-.1-2-1l-.5-.5c-.2.4-.3.4-.5,0-2.8-1.3-2.8-2.4-4.4-3.5s-2.2-.7-3.1-1.3c-2.2-1.4-4.6-3-6.6-4.7.6.2,1.3.3,2,.5Z"
          fill="#0d296a"
        />
        <path
          d="M151.3,433.2l.5.5c.7.3,1.4.7,2,1,1.9.9,2.2,1.4,1,1.5-1.2-.3-2.4-.9-3.5-1.5s-.3-.4-.5-.5l-.5-.8.5-.2c.1,0,.4,0,.5,0Z"
          fill="#1b397f"
        />
        <path
          d="M98.8,380.7c1.7,1.4,4.3,4,4.5,6-.5.8-1.5.4-3-1-.3-.1-.7-.4-1-.5l-2.5-3c-1-1.5-1.9-3.1-3-4.5-.9-.9-.2-1.8,1-1,.2-.1.4-.2.7-.3s3.5,3.6,3.3,4.2Z"
          fill="#0c44d4"
        />
        <path
          d="M103.3,386.7c1-.7,3.6,1.9,3,3,2.9,2.4,2,4.4-1,1.5,0,0,0-.4,0-.5l-1-.5c-1.3-1.5-2.7-3-4-4.5.6.2,2.7.8,3,1Z"
          fill="#0936cc"
        />
        <path
          d="M108.8,392.2c2.3,1.9,1.6,2.9-1,1.5-.2-.2-.8-.3-1-.5-.5-.5-1-1.5-1.5-2,3.1,1.4,2.7.8,1-1.5,1-.8,3,1.4,2.5,2.5Z"
          fill="#0726b7"
        />
        <path d="M105.3,390.7s-.5,0-1-.5l1,.5Z" fill="#0726b7" />
        <path d="M99.3,385.2h-.5c-.5-1.2-1.3-1.9-2-3,1.2.6,2,1.8,2.5,3Z" fill="#050840" />
        <path
          d="M55.3,300.3c1.5,2.9,2.5,6.1,3,9.5,1.8.9,2.4,3.3,1.5,5,2.2,5.6,4.4,11.3,6.5,17l.6.3c.9,2.8,2,5.5,3.4,8.2,1.5,0,3.2,3.8,2.5,5l2.5,4.5c1.2.3,3.3,3.4,2.5,4.5l7.1,11.1v.9c1.3,2.2,2.3,4.8,4.4,6.8l-1.5.2c-.1-.2-.4-.3-.5-.5-1.8-2.1-3.3-4.5-4.5-7-1.2-.3-2.2-1.4-3-3.2-2.4-3.7-5-8.1-7.1-11.9s0-.5.2-.9c-6-10.2-10.7-21.2-14.9-32.3-1.2-3.2-3.2-8.6-3.6-11.8s.2-.6.5-.9c-.4-1.1-.7-2.3-1-3.5-.4,0-.4-.3,0-.5-1-5.6.5-5.2,1.5-.5Z"
          fill="#020130"
        />
        <path
          d="M58.8,326.7c.8-1,1.7,0,1.7,1l1.3,1c.6,0,.9.3,1,.8,2.6,5.9,5.2,11.5,8.1,17.1s.3.7-.1,1c4,6.5,7.9,13,11.8,19.4l-.4.6c.1.3-.2,1.1,0,1.6.3.9,3.7,3.5,4.8,4.8s1.1,2.6,2.2,5c-4-4-6.8-8.7-10.5-13-.8.2-1.2-.4-.5-1-4.6-7-9-14.3-12.5-22-.5-.7-1-1.5-1.5-2.5-1,.1-1.6-1.7-1-2.5l-2.1-4.3c-1.4-2.1-3.1-4.7-2.4-7.2Z"
          fill="#010a62"
        />
        <path
          d="M72.8,349.7c3.7,4.9,5.8,11.5,10,16,.7,1.1,1.1,2.1,1,3-.4-.4-1.1-.6-1.5-1-.7-1.4-2.8-4.8-3.8-6.4-3.1-5.3-5.7-7.8-7.7-13.5.8,0,1.4.7,2,2Z"
          fill="#01074e"
        />
        <path d="M82.8,365.7l4.5,7c-.8-1-2.7-3.2-3.5-4l-1-3Z" fill="#04033b" />
        <path
          d="M89.3,368.7c.6-.3,1.2.4,1,1,1.6,1.4,3.7,4.3,4.8,6.3s-.1.4-.3.7l-1,1c-.2-.2-.6-.5-1-1-1.5-2.4-3.1-4.8-4.9-7l.4-.5c-.5-.2-.5-.8,0-1,.2-.2.5,0,1,.5Z"
          fill="#154dd6"
        />
        <path
          d="M77.8,354.2c.4,0,.7.1,1.1.3.7.4,7.9,11.1,8.9,12.8,0,.9.2,1.6.5,1.9,0,.1.9,2.1.9,2.2.4.5,1.1.1,1.4.4.6.4.1,1.6.3,1.8.7.8,2.2.7,1.9,3.1-2.6-3.5-5.6-6.8-8-10.5-2.4-3.9-5.2-7.7-7-12Z"
          fill="#1346ca"
        />
        <path
          d="M78.3,365.2c.3.4.3.7.5,1,.4.7,1.6,3.1,1,3.5-2.1-3-3.6-5.4-5.5-8.5-.4-.8-.3-1,.5-.5,1.3,1,2.5,2.5,3.5,4.5Z"
          fill="#0a3cbb"
        />
        <path
          d="M69.8,352.2c2.2,2.2,4.1,5.5,5,8.5l-.5.5c-1.3-2.1-2.7-4.3-4-6.5l-.5-.5c0-.1,0-.4,0-.5l-.5-.5c0-.1,0-.3,0-.5v-.5c.1-.3.3-.3.5,0Z"
          fill="#0731b2"
        />
        <path
          d="M69.8,352.2h-.5c-.2.2-.3.2-.5,0,0-.2,0-.4,0-.5l-1-1.5c-.2-.4-.7-.9-1-1.5l1,.5-.5-2c1.2,1,2.6,3.5,2.5,5Z"
          fill="#092eae"
        />
        <path d="M69.3,352.7c-.2-.1-.4-.3-.5-.5h.5v.5Z" fill="#02219f" />
        <path d="M87.3,379.7c-.2-.2-.4-.3-.5-.5l.5.5Z" fill="#060853" />
        <path
          d="M426.6,160.3c-.1.4-.3.4-.5,0-.1.4-.3.4-.5,0l-1-1c-1.7-1-3-4-3.5-6v-.5c-.7.7-1.2-.1-1-1-1.5,0-3.2-3.2-2.5-4.5.2-.3,0-.6-.5-1-.7.7-1,.4-.5-.5q.2-.2,0,0c-.1.4-.3.4-.5,0-.3-.2-.3-.3,0-.5l-.5-.5c-.4,0-.4-.3,0-.5.2-.2.2-.4,0-.5-.1.3-.3.3-.5,0-.4-.2-.4-.3,0-.5q.2-.2,0,0c-2.1-1.3-4.2-4-5.8-6.1-1.9-2.5-3.6-5.2-5.2-7.9h-.5c-1.3.2-1.5,0-.5-1-.9-1.4-.8-2.1.5-2,9.5,11,16.3,21.1,23,34Z"
          fill="#1221ac"
        />
        <path
          d="M371.6,95.4c.6.4.8.8,2,1.5,1.5,2,3.6,3.4,5.5,5,1.9,2.2,3.8,4.3,5.8,6.4l-.3.6c.8,1.5-.7,1.5-1,0-5.1-4.1-10.5-8.1-16.1-12.1l-.8-1.4c.5-.7.9-1.6,1-2.5,1.3-.4,2.6.5,4,2.5Z"
          fill="#7c93df"
        />
        <path
          d="M389.1,111.4c1.7,1.6,2,2.3,0,2.5-.2.4-.3.4-.5,0-1.4-.7-4.1-3.4-4-5-.7-.7-1.1-1.7-1.8-2.4-1.3-1.5-3.1-2-3.7-4.5,3.7,3.2,6.6,6.2,10,9.5Z"
          fill="#6679cd"
        />
        <path
          d="M436.1,180.3c.4,1.3.6,2.7,1,4-.4,1-.8.3-1-.5-1.8-.4-2.4-2.5-1.5-4-.9,0-.9-.4-.5-1v-.5c-1.1-.6-2.6-3.3-2-4.5v-.5c-.7.6-1,.3-.5-.5v-.5c-.7.6-1,.3-.5-.5-1.4-2.3-2.4-4.6-3-7-.2-.8-.2-1,.5-.5,2.6,5.3,5,10.6,7.5,16Z"
          fill="#2325a5"
        />
        <path
          d="M403.6,126.4l-.5,2c-1.4.4-2.2-.4-2.5-2.5-.9.6-2-.6-1.2-1.4l-1.3-1.6c-1,.3-1.2-.2-.5-1-.7-.8-1.4-2.2,0-2,2,2.2,4.1,4.3,6,6.5Z"
          fill="#2632a7"
        />
        <path
          d="M391.6,113.9c.6,1.1.8,1.9.5,2.5-.7,1.5-2.1.3-2-1-.4.2-.6,0-.5-.5-1,.2-1.3-.4-.5-1v-.7s1-.6,1-.6l-1-1.3c.9.8,1.7,1.7,2.5,2.5Z"
          fill="#5a6fcb"
        />
        <path
          d="M393.6,115.9c.7,1,.7,1.5,0,1.5-.6,1.5-2.3.5-1.5-1-.5-.7-1.1-1.8-.5-2.5.7.7,1.3,1.3,2,2Z"
          fill="#4f64be"
        />
        <path
          d="M428.6,164.3c0,.2-.3.4-.5.5-1.2-.7-2.5-3.3-2-4.5h.5c.7,1.4,1.3,2.6,2,4Z"
          fill="#2f2daa"
        />
        <path
          d="M396.1,118.4c.7,1,.8,1.2-.5,1-1.2.8-2.9-.8-2-2v-1.5c.8.8,1.7,1.6,2.5,2.5Z"
          fill="#4457b4"
        />
        <path
          d="M397.6,119.9c-.4.6-.2,1.4,0,2-.9,1.1-3-1.5-2-2.5l.5-1c.5.5,1,1,1.5,1.5Z"
          fill="#364cac"
        />
        <path
          d="M436.1,179.8c1.2,0,3.3,1.1,3.9,2.1s0,1.8.2,2.5.7,1.3.9,1.9l.4,3.1c-1.3.1-.4,3.1.8,2.9.2,1.4.6,2.6,1.2,3.5,0,.3,0,.7,0,1s.2.9.5,1.3c-.3.9-1.4.2-1.5.2-.1.2.4,3.9.5,4.5-1.9-1.2-2.7-4.8-2.5-7-1.1-3.6-2.4-7.3-3.9-10.8l.4-.7c-.9-1-1.7-2.9-1-4,0-.2,0-.3,0-.5Z"
          fill="#010451"
        />
        <path
          d="M443.6,195.8c-1.6,1.4-.9-2.1-1.5-3-.5-.4-.5,2-1.2.5s-1.4-4.3-1.2-4.5c.4-.4,2.1,1.1,1.5-2.5.8,2.9,1.9,6.7,2.5,9.5Z"
          fill="#000249"
        />
        <path
          d="M437.1,184.3c1.1,3.8,3.2,7.5,3.5,11.5-.5-1.5-1.4-2.9-1.5-4.5l-.5.5c-.9-.7-2.2-3.3-2.7-4.5s-.4-1.4.2-2.5c-1.3,0-1.3-.6,0-1l1,.5Z"
          fill="#1626ac"
        />
        <path d="M442.3,196.8c.3.2.3.3,0,.5v-.5Z" fill="#000249" />
        <path
          d="M434.1,188.8c.2-3,2.3-2.6,2.9.1l2.1,6.9c.3,0,.5.1.5.5,1.4,6.2,3.8,12.8,5,19,1.8,9.6,2.3,19.8,3,29.5-.7,0-1-.4-1-1.3l-.5.3c-.4,0-.7.2-.7.1-1-2.4-2.2-6.4-1-8.8-1.4-2.1-1.7-3.2-.8-5.8.1-2.9.1-5.6-2-8,.5-1.6.6-3.3,0-5,0-3.3-.8-6.5-2.2-9.6,0-1.5,0-3-.3-4.4-1.3-4.1-3-8.2-5-12.5-.4-.3-.4-.7,0-1Z"
          fill="#010286"
        />
        <path
          d="M447.6,248.8v1.5c-.6.4-.6-.1-.6-.7.5,5,.5,10,0,15.1l.6.6c0,1.6.5,3.8-.5,5h-.7c-.6,7.2-1.6,14.4-3.1,21.5h-.8c-1,.3-1.3-.5-1.4-1.4,1.7-6.6,2.6-13.4,2.5-20.3.7-1.8,1-3.6.8-5.5l.7-10.1c-.5-2.9-.8-5.8,0-9s.5-.6.9-.6c.9,0,1.3.9,1.1,2.8l.4,1.2Z"
          fill="#010189"
        />
        <path
          d="M447.6,250.3c.1.3,0,.8.5,1,0,4.8-.2,9.2-.5,14-.7.6-1.3.5-1.3-.5,0-5.1.9-10.3.3-15.5.5-.1.8.6,1,1Z"
          fill="#010176"
        />
        <path
          d="M447.6,244.8c.1,1.2,0,2.7,0,4-1.7-.6-.4-2.8-1.5-4-1.1,0-1-.7,0-1,.1-.9-.3-2.2,1-2.5-.5,1.3.4,2.8.5,3.5Z"
          fill="#010278"
        />
        <path
          d="M438.6,191.8c0,.3,0,.7,0,1l.5,1c0,.3,0,.7,0,1,.3.3.4.8,0,1-.2-.3-1.9-3.1-2-3.4-.6-1.6-.5-6.9-3-3.6-.5-.8-.8-1.8-1-3-.4-.1-.4-.3,0-.5.6-.6,1.6-.8,3-.5.8,2.3,1.9,4.7,2.5,7Z"
          fill="#010491"
        />
        <path d="M439.6,196.3c-.2-.2-.3-.3-.5-.5v-1c.7.3.4,1,.5,1.5Z" fill="#1626ac" />
        <path d="M439.1,193.8c0,0-.3-.3-.5-1l.5,1Z" fill="#1626ac" />
        <path
          d="M447.1,270.3c-.3,7.7-2.3,15.3-3,23-1.1,3.6-1.9,7.4-3,11l-.5,1.5c0,.2,0,.3,0,.5l-.5,1.5c0,.2,0,.3,0,.5-.1.4-.3.4-.5,0-.2.8-.4,1.3-1,.5-1.1-1.1-.4-3.3.9-4.1l1.1-4.4c.7-2.8,1.4-5.7,2-8.5,1.8-2.3,2.3-17,3-21.2s1.6-2.5,1-4.3c.9.5.5,3.1.5,4Z"
          fill="#010275"
        />
        <path
          d="M382.1,401.2c0,.5,0,1,0,1.5-1.7,2.2-3.6,3.1-5.5,5,.5,1.2-1.1,1.9-2,1-2.1,2.2-2.4,0,0-1-.6-1.8,2.7-4.9,4.5-4.5-.9-1.7,1.5-2.9,3-2Z"
          fill="#1c307e"
        />
        <path
          d="M376.6,407.7s.2.3.5.2c.8-.3,1.4-1.4,2.5-1.2,0,0-1.3,1.8-1.5,2-.8.7-2.9,1.6-4,2.5-1.2.5-1.2,0,0-1.5-.8,0-.6-.4.5-1,.3-.3,1.5-.7,2-1Z"
          fill="#0f0822"
        />
        <path
          d="M387.6,396.2c-.7.7-3,2.5-2.5,3,.9.2,1.3-.6,2-1-.7,1.3-1.8,2.1-3,3l-.5.5h-.5c-1.2-.1-.2-1.3.5-2-1-.9-.9-1.1.5-1-1-1.3,1.3-2.9,2.5-2-.4-1.3,0-1.4,1-.5Z"
          fill="#1f45ad"
        />
        <path
          d="M383.1,401.7c-.4.7-.8.7-1,1l-1.8,1.5-.3-.3c0-.7,1.4-2.1,2-2.7-.4-.2-.4-.3,0-.5-.4-1.5.3-1.8,1.5-1-.7,1.2-.4,1.9-.5,2Z"
          fill="#1d3b9a"
        />
        <path d="M387.6,398.2c.1-.5.6-.7,1-1-.2.5-.5.7-1,1Z" fill="#1f45ad" />
        <path d="M383.6,401.7c.2-.2.3-.4.5-.5l-.5.5Z" fill="#1d3b9a" />
        <path
          d="M406.6,374.2c-.9,1.1-1.6,2.4-2.5,3.5l-.5.5v.5c-1.6.5-5.4,6.7-7,8-1.3.7-1.6,1.6-2.5,2.5-.7.7-1,.4-.5-.5-.4-.1-.4-.3,0-.5-.1-.6.3-1.2,1.2-1.8.4-2,1.4-3.1,2.8-3.2v-.9c1.8-2.8,4-5,6.5-6.6-.7-1.4.6-2.6,2-2,.7-.7,1-.4.5.5Z"
          fill="#020469"
        />
        <path
          d="M429.6,335.7c-.9,2-1.5,4.5-2.5,6.5.6,1-.6,3.9-2,3.5l-2,4c.5,1.1-.7,3.6-2,3.5-1.6,1-2.2,3.5-3,5s-.7.5-1,1,0,.4,0,.5l-2,3c-1.4,2.1-3.6,4.1-4.5,6.5-1.3,1.4-2.3,3-3.5,4.5s-.4.3-.5.5l-.5-.5c-1-1.1,0-2.8,1.5-2.5,0-.7,0-1.4.3-2,1-2,3.8-5.1,5.4-6.9s.5-.4.8-.6l.5-.5c-.4-.1-.4-.3,0-.5l.4-2.3c3.4-4.8,6.1-10,8.7-15.3l1.8-1.5c-.2-2.1.8-4.1,3-6-.4-.2-.4-.3,0-.5l.5-.5c.6-.5.7-.2.5,1Z"
          fill="#01035d"
        />
        <path d="M415.1,362.7l2-3c-.7,1-1.3,2-2,3Z" fill="#0f3bc6" />
        <path
          d="M388.1,389.2c.9.4,1.8.8,2.7,1,.9-1.3,1.8-1.8,2.8-1.5l.5.5c-.4.4-.6,1.1-1,1.5s-2.8,2.1-3,2.5c-2.9,1.1-4.7-2.8-3-4.5.1-.4.5-.3,1,.5Z"
          fill="#010875"
        />
        <path d="M403.6,378.2l.5-.5c-.1.2-.3.3-.5.5Z" fill="#0943d9" />
        <path
          d="M424.6,348.7c-.6,1.3-.7,2.7-1.5,4s-2.1,2.1-2.8,3c-.6-.7.5-1.8.8-2.5.7-1.7,1.3-2.2,2-3.5l1-1.5c.7-.7,1-.4.5.5Z"
          fill="#1242dc"
        />
        <path
          d="M439.6,309.3c-.9,3-2.1,5.9-2.5,9-1.7,3.3-3,7-4.5,10.5-1,1.3-1.4.2-.5-1-.5-1.3,0-3,1.6-5l-.2-1.5c1.7-3.8,3.1-7.8,4.3-12l.8-.5,1-.5c.3,0,.3.4,0,1Z"
          fill="#020362"
        />
        <path
          d="M427.1,345.7c-.5.8-1.7,1.4-2.5,3l-.5-.5,1-2.5c.6-1.3,1.6-2.7,2-3.5,1.7.5.4,2.1,0,3.5Z"
          fill="#1242d6"
        />
        <path
          d="M432.6,328.7c-1,2.3-2,4.7-3,7l-.5-1c.2-.6,0-1-.5-1.2,0-.3,1.8-6.5,3-5.8.1-.4.3-.4.5,0,0,.3,0,1.1.5,1Z"
          fill="#020576"
        />
        <path d="M440.1,307.8c.2-.6.4-1.1.5-1.5l-.5,1.5Z" fill="#010296" />
        <path d="M440.6,305.8c.2-.6.4-1.1.5-1.5l-.5,1.5Z" fill="#010296" />
        <path d="M439.6,309.3v-1h.5c-.2.6-.5.9-.5,1Z" fill="#010296" />
        <path
          d="M166.3,440.7c0-.5.3-.4.5,0,2.4.5,4.9,1.1,7,2.5,4.7,2,9.7,3.6,14.7,5.2s.5.3.3.8c.8.4.6.6-.5.5-7.7-2.4-14.5-4.8-22-8l-.5-.5c-.1,0-.4,0-.5,0-1.1-1.3-.3-1.2,1-.5Z"
          fill="#183489"
        />
        <path
          d="M160.3,436.7c1.1.3,2,.8,2.5,1.5.5.3,1,.7,1.5,1,1-.5,2.4.3,2,1.5-.4,0-.8,0-1,.5-.8-.4-1.4-.7-2-1-.5-1-3.4-2.3-5.5-2.5-.7-.4-2.8-.6-3-1.5s.8-.2-1-1.5c2.1.9,4.3,1.4,6.5,2Z"
          fill="#14337c"
        />
        <path
          d="M163.3,440.2c-1.9-.8-3.6-1.6-5.5-2.5.9-1,3.6.6,4.6,1.1s1.9,1,.9,1.4Z"
          fill="#253c89"
        />
        <path d="M166.3,441.7c-.2,0-.4-.4-.5-.5l.5.5Z" fill="#14337c" />
        <path
          d="M342.7,433.2c6.8-3.1,13.3-6.4,20.1-9.6s5.6-3.4,8.6-4.4.8-.1.7.2c-.4.3-.7.8-1,1.3s-.3.4-.5.5l-.5.5c-.2,0-.3,0-.5,0-4.7,1.8-9.2,3.9-13.5,6.5-.1.4-.3.4-.5,0l-1.5,1c0,.3,0,.5,0,.6-6.9,3.9-15,7.6-22.4,9.9-3.5,1.6-7,2.6-10.5,3v-.8c6.9-2.7,13.7-5.7,20.6-8.9l.9.2Z"
          fill="#010941"
        />
        <path
          d="M358.6,427.2c.7-1.7,7.9-4.7,5-1.5-4.1,2.7-8,5.5-12.5,7.5l.5-1c-.4-.3-4.2,1.6-5,2v-.6c4-2.1,8-4.2,12-6.4Z"
          fill="#0a1968"
        />
        <path
          d="M369.6,421.7c-1.9,1.4-4,2.7-6,4,.6-.9.9-1.3-.6-.8s-3,1.7-4.4,2.3c-.9.9-1.8,1.2-2.5,1,1.2-1.6,3.1-2.5,4.9-3.4,2.7-1.3,6-2.7,8.6-3.1Z"
          fill="#040f4c"
        />
        <path d="M370.1,421.7l.5-.5s.1.4-.5.5Z" fill="#01032a" />
        <path
          d="M366.1,417.7c-1.1.9-3,1.8-1,2.3v.7c-7.2,3.2-13.6,8-20.7,11-.7.3-1.5.7-1.8,1.4-3.4,1.6-7.3,3.7-10.6,5.1s-7.7,2-10.8,4.4c-5.6,3-12,5.2-18.5,5.5-.3.2-.8.4-1.5.5-.1.3-.3.3-.5,0-2.1,1.2-4,1.5-6,1-.4-.1-.4-.3,0-.5-.3-.1-.3-.3,0-.5,0-.5.6-.2,1,0-.4-.9,0-1,1-.5.7-.6,1.6-1.2,2.5-.5-.2-1,1-1.3,1.5-.5,1.2-.6,2.4-.7,3.5-.5.4-1.5,4.1-2.1,5.5-2-.6,0-.6-.4,0-.5-.4-.1-.4-.3,0-.5-.2-.2,0-.4.5-.5.8-.5,1.7-.6,2.5-.5,1.1-.4,2.2-.5,3.5-.3l.5-1.2c.5-1.3,3.4-2.5,4.5-1.5.9.4-.2,1.1-.9,1.3s3.3-2.5,3.9-1.3c1.2-1.1,2.8-1.7,4.9-1.9,3.3-2.1,7-3.6,11.1-4.6,1.8-1.4,3.8-2.6,6-3.5l4-2.5c2.7-1.9,5.5-3.5,8.5-5-.4-1.3,6.6-5.2,7-5s.4.3.5.5Z"
          fill="#01021c"
        />
        <path
          d="M374.1,411.2c-2.7,2.1-5.4,4.3-8,6.5l-3.1,1.2c-1.6.8-3.1,2.4-4.4,3.3-1.8,1.2-3.6,2-5.5,2.5-.3-.1-.3-.3,0-.5.3-1.3,1.2-1.8,2.5-1.5l1-1c.1-.4.3-.4.5,0,.2-1.4,2.2-2.5,3.5-2.5l.5-.5c.1-.5.3-.4.5,0,.4-1,1.4-2,2.5-1.5.9-1.6,1.7-2.3,2.5-2l1-1c.1-.4.3-.4.5,0,1.2-2,2.7-3.4,4.9-4.8s.7,0,1.1.3c0,0,.5.7-.5,1.3l.5.2Z"
          fill="#050413"
        />
        <path
          d="M162.3,436.2c2.7.5,4.6,1.7,7.5,2.5.6-.2,1.3,0,2,.5.2,0,.3,0,.5,0l3.5,1.5c.2,0,.3,0,.5,0l2,1c.1,0,.4,0,.5,0l2,1c.1,0,.4,0,.5,0l.5.5c.5,0,.8.2,1,.5.1-.3.3-.3.5,0,1.8.4,2.7,1.5.5,1.5-1,.9-2.5-.1-3.5-1-.6.7-2.7-.2-3-1l-.5-.5c-.3.1-.6.2-.8.2-1.6-.5-10.4-3.4-11-3.9s-.2-.5-.3-.8c-.7-.3-1.8-1.5-2.5-2Z"
          fill="#06195a"
        />
        <path
          d="M136.3,416.7c2.2.5,4.2,1.8,6,4l.8-.2c2.7,1.6,5.3,3.3,7.7,5.2.9-.5,2.4.4,2,1.5,1.2.7.8,1.3-.5,1-1.5-.8-6.1-2.8-7-3.8s0-1.2,0-1.2c-.2-.2-1.1.1-1.5,0l-1-1c-.3-.2-.7-.3-1-.5l-.5-.5c-.8-.5-1.7-1-2.5-1.5l-.5-.5c-.3-.2-.7-.3-1-.5l-.5-.5c-.3-.2-.7-.3-1-.5l-.5-.5c-.3-.2-.7-.3-1-.5l-.5-.5c-.5-.4-.7-.7-1-1-.2-.2-.2-.3,0-.5.2-.4.3-.4.5,0,1.4-.3,2.4.8,3,2Z"
          fill="#07093a"
        />
        <path
          d="M158.3,429.7c3,.7,6.4,1.8,8.5,4l.5.5c.2-.4.3-.4.5,0l1,.5c.2-.4.3-.4.5,0l.5.5c.2-.4.3-.4.5,0l.5.5c.2-.4.3-.4.5,0l1,.5c.6.2,1,.5,1,1-.4.5-1.1.5-2,0-.4.2-.9,0-1.5-.5-.2,0-.3,0-.5,0l-.5-.5c-.2,0-.4,0-.5,0l-.5-.5c-.1,0-.4,0-.5,0l-.5-.5c-.1,0-.4,0-.5,0l-1-1c-.1,0-.4,0-.5,0l-.5-.5c-.1,0-.4,0-.5,0l-1.5-.5c-.1,0-.4,0-.5,0l-.5-.5c-.1,0-.4,0-.5,0l-.5-.5c-1.3-.7-2.7-1.3-4-2-.3-.4-.5-.9-.5-1.5.8-.7,2.2,0,2.5,1Z"
          fill="#10156f"
        />
        <path
          d="M196.7,445.2c.3.9-.8.9-1.5.5-.1.3-.3.3-.5,0-.3,0-.7,0-1,0l-.5-.5c-.2,0-.3,0-.5,0l-.5-.5c-.4-.1-1.1.1-1.5,0l-.5-.5c-.3,0-.7,0-1,0l-.5-.5c-.3,0-.7,0-1,0l-1-.5c-.2,0-.3,0-.5,0l-.5-.5c-.1,0-.4,0-.5,0l-1-.5c-.1,0-.3,0-.5,0l-.5-.5c-.3,0-.7,0-1,0l-1-.5c-1.3-.1-1.2-.6,0-1,.5-.4,1.1-.5,1.7-.3,4.2,1.3,8.5,2.6,12.7,4s.9.8,1.1,1.3Z"
          fill="#0c0d76"
        />
        <path
          d="M187.3,444.7l3,1c1.4.4,2.6.7,4,1l1,.5c.3,0,.7,0,1,0,.4.1.4.3,0,.5-1.2.4-2.7.2-4.5-.5-2.6.4-5.9-.4-8-2,.8-1.1.4-.8-.5-1.5.1-.2.3-.2.5,0,1.2.3,2.3.7,3.5,1Z"
          fill="#0e1352"
        />
        <path
          d="M196.7,445.2c.5-1.3,2.8-.4,3.5.5,1.5-.3,2.3,0,2.5,1,1.2.7.8,1.3-.5,1-1.4.7-3.7.3-4.5-1-.8-.2-1.7-.3-2.5-.5-.2-.2-.2-.3,0-.5.4,0,1-.5,1.5-.5Z"
          fill="#0b0d5c"
        />
        <path
          d="M178.8,438.7c1.6.2,2.5.7,2.5,1.5v1c-.1.2-.3.2-.5,0-.3,0-.7,0-1,0l-.5-.5c-.2,0-.4,0-.5,0l-.5-.5c-.6-.2-1.4-.3-2-.5v-.5c-.6-.3-1.1-.5-.5-1,.8-1.2,2.5-.7,3,.5Z"
          fill="#0c0e52"
        />
        <path
          d="M202.2,447.7c.5-.8,1.6-.5,1,.5-.3.3-.8.5-1.5.5-.4.2-.9.2-1.5,0-.9,1-3.4,0-4-1v-.5c.5,0,1.3.1,1.5-.5,1.5.3,3,.6,4.5,1Z"
          fill="#03021c"
        />
        <path
          d="M155.3,428.2c.7-.3.9-.2.5.5.8.7,1.4.3.5,1.5-1.3-.7-2.7-1.3-4-2l.5-1c.6-1,2.3,0,2.5,1Z"
          fill="#0d115c"
        />
        <path
          d="M173.3,437.2c1.3-.4,2.8-.9,2.5,1l.5,1c-.2.2-.3.2-.5,0-.4-.3-1-.3-1.5-.5l-.5-.5c-.3,0-.7,0-1,0l-.5-.5c-.3,0-.7,0-1,0-.3-.1-.3-.3,0-.5,0,0,1.1-.2,2,0Z"
          fill="#07053c"
        />
        <path d="M182.3,441.7c-.5,0-1.2.2-1.5-.5.2,0,.3,0,.5,0,.4,0,.8,0,1,.5Z" fill="#04051c" />
        <path d="M175.8,440.7c-1.2-.4-2.6-.4-3.5-1.5,1.2.3,2.7.5,3.5,1.5Z" fill="#04051c" />
        <path d="M190.3,445.7c-1-.3-2.2,0-3-1,1,.3,2.2,0,3,1Z" fill="#04051c" />
        <path d="M163.8,433.7c-.3-.1-.8-.1-1.5-.5l1.5.5Z" fill="#04051c" />
        <path d="M195.2,447.2l-1-.5c.8.2.9.5,1,.5Z" fill="#04051c" />
        <path d="M162.3,434.7c-.8-.3-1.5-.8-2-1l2,1Z" fill="#04051c" />
        <path d="M168.8,437.7c-1.4-.5-2.9-.8-4-2,1.4.6,2.9.8,4,2Z" fill="#04051c" />
        <path d="M171.3,437.2v.5c-.6-.2-1.1-.5-1.5-1,.6.1,1,.4,1.5.5Z" fill="#04051c" />
        <path d="M171.8,439.2c-.7-.2-1.3-.3-2-.5l-.5-1c.9.3,1.9.8,2.5,1.5Z" fill="#04051c" />
        <path d="M178.3,441.7l-2-1c1,.3,1.7.9,2,1Z" fill="#04051c" />
        <path d="M180.8,442.7l-2-1c1,.4,1.4.8,2,1Z" fill="#04051c" />
        <path d="M187.8,443.7c-.6-.2-.9-.5-1-.5l1,.5Z" fill="#04051c" />
        <path
          d="M183.8,443.7c-.2,0-.3,0-.5,0s-.3,0-.5,0c-.4-.1-.4-.3,0-.5.4,0,.8,0,1,.5Z"
          fill="#04051c"
        />
        <path d="M182.8,443.2v.5c-.6-.1-.6-.1-1-.5.2-.2.3-.2.5,0,.2,0,.3,0,.5,0Z" fill="#0e1352" />
        <path d="M185.3,442.7c-.5-.2-.9-.5-1-.5l1,.5Z" fill="#04051c" />
        <path d="M182.3,443.2h-.5c-.2-.2-.3-.3-.5-.5.3.1.9,0,1,.5Z" fill="#04051c" />
        <path d="M157.8,432.7c-.3-.1-.4-.5-.5-.5l.5.5Z" fill="#04051c" />
        <path d="M160.8,432.7c-.3-.1-.4-.5-.5-.5l.5.5Z" fill="#04051c" />
        <path d="M158.8,433.2c-.3-.1-.4-.5-.5-.5l.5.5Z" fill="#04051c" />
        <path d="M161.8,433.2c-.4-.2-.5-.5-.5-.5l.5.5Z" fill="#04051c" />
        <path d="M159.8,433.7c-.3-.2-.5-.5-.5-.5l.5.5Z" fill="#04051c" />
        <path d="M164.8,434.2c-.3-.1-.4-.5-.5-.5l.5.5Z" fill="#04051c" />
        <path d="M166.3,435.2c-.7-.3-.9-1-1-1l1,1Z" fill="#04051c" />
        <path d="M163.3,435.2c-.3-.1-.4-.5-.5-.5l.5.5Z" fill="#04051c" />
        <path d="M164.3,435.7c-.3-.1-.5-.5-.5-.5l.5.5Z" fill="#04051c" />
        <path d="M167.3,435.7c-.3-.1-.4-.5-.5-.5l.5.5Z" fill="#04051c" />
        <path d="M168.3,436.2c-.3-.1-.4-.5-.5-.5l.5.5Z" fill="#04051c" />
        <path d="M169.3,436.7c-.3,0-.5-.5-.5-.5l.5.5Z" fill="#04051c" />
        <path d="M172.8,438.2c-.4-.1-.5-.5-.5-.5l.5.5Z" fill="#04051c" />
        <path d="M174.3,438.7c-.3,0-.4-.5-.5-.5l.5.5Z" fill="#04051c" />
        <path d="M176.3,439.7c-.2,0-.4-.3-.5-.5h.5v.5Z" fill="#04051c" />
        <path d="M178.8,440.7c-.3,0-.4-.5-.5-.5l.5.5Z" fill="#04051c" />
        <path d="M179.8,441.2c-.4-.1-.5-.5-.5-.5l.5.5Z" fill="#04051c" />
        <path d="M183.8,442.2c-.4-.1-.5-.5-.5-.5l.5.5Z" fill="#04051c" />
        <path d="M186.3,443.2c-.4-.1-.5-.5-.5-.5l.5.5Z" fill="#04051c" />
        <path d="M189.3,444.2c-.4-.1-.5-.5-.5-.5l.5.5Z" fill="#04051c" />
        <path d="M190.8,444.7c-.4-.1-.5-.5-.5-.5l.5.5Z" fill="#04051c" />
        <path d="M192.8,445.2c-.3,0-.4-.5-.5-.5l.5.5Z" fill="#04051c" />
        <path d="M193.8,445.7c-.4,0-.5-.5-.5-.5l.5.5Z" fill="#04051c" />
        <path d="M195.2,446.2c-.2,0-.4-.3-.5-.5.2,0,.3,0,.5,0v.5Z" fill="#04051c" />
        <path
          d="M121.3,403.7c1.8,1.3,1,2.8-1,1.5-.4,0-.9-.3-1.5-1-.3-.3-.3-.6-1-1-1.1-.6-1.7-1.7-2.5-2.5.4-.4.8-.9,1-1.5l1.2-.3c1.6,1.3,2.9,2.9,3.8,4.8Z"
          fill="#050a4a"
        />
        <path
          d="M110.8,393.7c1.2.4,2.8,1,2,2.5,1.9,1.8,1,2.8-1,1-1.3-1.2-2.5-2.1-4-3.5h2s-1-1.5-1-1.5c.7-.4,2.2.8,2,1.5Z"
          fill="#051c9e"
        />
        <path
          d="M115.8,398.7c.4,0,.6,0,.5.5.9,1.6.8,2.8-1,1.5-.5-.5-1-1-1.5-1.5-1.1-.9-.1-1.7,1-1,.7-1.1,1.1-.8,1,.5Z"
          fill="#070978"
        />
        <path
          d="M114.3,397.2c1.3-.4,1.4,0,.5,1l-1,1c-.7-.7-1.4-1.4-2-2,1,.9,1.8,0,1-1,1.2-.8,1.8-.4,1.5,1Z"
          fill="#061489"
        />
        <path d="M132.8,416.7l-2-1.5c1.6.7,1.2.9,2,1.5Z" fill="#040618" />
        <path
          d="M129.3,409.7c.5-.1.6,0,.5.5l1,1c.7-.7,1-.4.5.5-.2.5-.7.8-1.5,1-.1,0-.4,0-.5,0l-1-1c-.3-.2-.7-.3-1-.5l-1.5-1.5c-.3-.2-.8-.3-1-.5l-2-2c-1.4-1.2.1-2,1.5-1,1.7-.5,5.1,1.7,5,3.5Z"
          fill="#071140"
        />
        <path
          d="M121.8,403.7c1.3-.7,2.9,1.1,2.5,2.5-.4.3-1.5.4-1.5,1-.3-.2-.7-.3-1-.5l-1-1c-.1,0-.4,0-.5,0v-.5c1.1,0,1.7-.5,1-1.5.2-.2.3-.2.5,0Z"
          fill="#060a35"
        />
        <path d="M132.8,414.7v.5c-.8-.7-2.6-1.1-3-2.5,1.5-.4,2.8.4,3,2Z" fill="#040618" />
        <path d="M120.3,405.2v.5c-.8-.6-1-1-1.5-1.5l1.5,1Z" fill="#040618" />
        <path d="M121.8,406.7c-.4-.3-.8-.4-1-1,.5.3.8.5,1,1Z" fill="#040618" />
        <path d="M124.8,409.2c-.5-.4-2-1.3-2-2,.8.6,1.6,1,2,2Z" fill="#040618" />
        <path d="M127.3,411.2c-.9-.6-1-1.1-1.5-1.5l1.5,1.5Z" fill="#040618" />
        <path d="M129.3,412.7c-.6-.4-.9-.9-1-1l1,1Z" fill="#040618" />
        <path d="M134.3,416.7c-.2-.1-.3-.4-.5-.5l.5.5Z" fill="#040618" />
        <path d="M135.8,417.7c-.2-.1-.3-.4-.5-.5l.5.5Z" fill="#040618" />
        <path d="M137.3,418.7c-.2-.1-.3-.4-.5-.5l.5.5Z" fill="#040618" />
        <path d="M138.8,419.7c-.2-.1-.3-.4-.5-.5l.5.5Z" fill="#040618" />
        <path d="M141.8,421.7c-.2-.1-.3-.4-.5-.5l.5.5Z" fill="#040618" />
        <path d="M143.8,423.2c-.7-.3-.8-.9-1-1,.5.2.8.5,1,1Z" fill="#040618" />
        <path
          d="M164.8,438.2c3.5,1.7,8,2.6,12,4.5l.5.5c.9.5,2,.7,3,1,1.2.5,1.6,1,1,1.5-3.2-.6-6.4-2-9.5-4-1.6-.1-3.2-.5-5-1-.2,0-.3,0-.5,0-.6-.5-1.3-1-2-1.5l.5-1Z"
          fill="#0c266c"
        />
        <path d="M160.3,436.7c1,.3,2.8,0,2.5,1.5-.8-.5-1.9-.7-2.5-1.5Z" fill="#0c266c" />
        <path d="M151.8,433.7c-.2,0-.4-.3-.5-.5.2,0,.4.3.5.5Z" fill="#14327a" />
        <path
          d="M101.8,383.2l.5.5c1.8-.3,3.6,1.7,3.5,3.5,1.8-.2,2.7.7,2.5,2.5,1.4-.7,1.8,0,1.5,1.5,1.4.5,1.7.2.9-.8.5-2.1,2.1-3.7,3.6-5.2h.5l.5-.4c1,.9,2.2,1.5,3.5,1.9.1-.4.3-.4.5,0,.8.4,1.3.9,1.5,1.5,1,0,.9.2.2.9,2.4,2.4.3,2.2-1.7.7l-.7.3c-2.9-2.4-3.5-.5-3.9,2.6-.4,2.4-1.7,2.7-3.9,1-.5-.5-1.5-1-2-1.5-.8-.7-1.3-2-2.5-2.5-.9-1.2-1.7-2.2-3-3-1.4-1.9-3-4.2-4.5-6-.7-.7-.4-1,.5-.5,1.3.2,2.5,1.8,2.5,3Z"
          fill="#030741"
        />
        <path
          d="M91.8,370.2c.5,0,1,.6.5,1l1,1c.4.2.4.3,0,.5.3,0,.5.2.5.5,1.8,1,3.2,3.1,4,5,1.4-.5,2.3.7,1.5,2l-.5.5c-1.2-1.4-3.1-2.9-4-4-1.4-1.8-3-5-4.5-7-.7-1-.4-1.3.5-.5l1,1Z"
          fill="#030653"
        />
        <path
          d="M50.3,284.8c1,.3,1,.7,0,1,2.5,5.1,3.5,9.5,3.5,15,0,.2,0,.3,0,.5l1,3.5c1.1,4.5,2.7,9.6,4.3,14,3.7,10.7,9.1,20.7,13.7,31-.4-.6-1.4-1.5-2-2-1.3-3.6-3.1-5.6-4.6-8.6s-2.5-7-4.4-10.4c-2.6-2.4-4.1-6.1-4.5-11-2.9-3.6-4.5-8.9-4-13.5-2.5-6.7-3.8-14.4-4.5-21.5-2-1.8-2.7-7.9-1-10-.4-6.1-.6-12.2-.8-18.3,1-1.4,1.2-3.1.7-5.1l1.1-.6c.9,11,1.1,22.4,1,33.3l.5,2.7Z"
          fill="#020448"
        />
        <path
          d="M55.3,289.3c2.3,7.6,4.4,15.4,6.4,23.3l-.4,1.2.5,1c.4.1.4.3,0,.5l.5,1c.4.1.4.3,0,.5.3.7.3,1.2,0,1.5l-.6.4-1.9-3.9c-.6-1.7-1-3.3-1.5-5-1.7-6.6-3.2-13.3-4.5-20l.5-.5c-.6-.2-.7-1.2,0-1.5.1-.4.3-.4.5,0l.5,1.5Z"
          fill="#133dd2"
        />
        <path
          d="M85.8,363.2c1.2.8,2,2.7,2.5,4,.4.2.4.3,0,.5v.5c0,.3,0,.7,0,1-.7,1.3-.6-1.4-1-1.8-3.7-4.2-6-8.6-9.5-13.2s-2.3-2.7-2.5-4.5c-.4-.5-.4-.8,0-1-.6-.7-.3-1,.5-.5.1-.4.3-.4.5,0,3.7,4.6,6.8,9.6,9.5,15Z"
          fill="#144bd5"
        />
        <path
          d="M66.8,328.2c.4.2.4.3,0,.5l1,2c.4.1.4.3,0,.5l.5.5c.4.1.4.3,0,.5l.5.5c.4,0,.4.2,0,.5l.5.5c.4.1.4.3,0,.5l.5,1c.6-.6.7-.3.5.5,2,2.9,4,6.5,4.5,10,.7.6,1.3,1.6,1,2.5,0,.3-.5.4-.5.5-1.2-.7-2-1.9-2.5-3.5-1.2-1.9-1.7-2.9-2.5-5-1.7-3.8-3.3-7.7-4.7-11.6-.7-2.1.2-2.3,1.2-.4Z"
          fill="#1949d2"
        />
        <path
          d="M52.8,284.8c1,5,2,10,3.1,15.1l-.6.4-1.5-3.5c0,1.3,0,2.7,0,4-.9-.9-.4-2.4-.6-3.6-.8-4-2.4-6.9-2.9-11.4l.9-.3c-.3-1.4-.1-2.4.6-3.2,1.6,0,2,1.4,1,2.5Z"
          fill="#03043e"
        />
        <path
          d="M54.3,287.8c0,.2,0,1.2,0,1.5l-.5.5c.2,2.5,1.4,5.1,2.3,7.5l2.2,12.5c-1-3.2-2-6.3-3-9.5l-2.5-15.5c1.1-.5,1.7,2,1.5,3Z"
          fill="#0f33c4"
        />
        <path d="M62.3,318.3c2,4.2,3.3,9,4,13.5-3.1-5.2-4.6-11.3-6.5-17l2.5,3.5Z" fill="#0d36c0" />
        <path
          d="M66.8,328.2l-1-.7c0,1.8,1.2,3.2,1.8,4.7,1,2.5,1.8,5.6,2.7,8-1.9-2.5-2.9-5.6-4-8.5s-3.2-9.2-4-13.5,0-1,0-1.5c.4.2.8.4,1.1.8.6.7,3,7.8,3.6,9.5s0,.8-.1,1.3Z"
          fill="#1544cd"
        />
        <path d="M54.8,304.8c-1.2-.8-.9-2.3-1-3.5,1.1.9.7,2.4,1,3.5Z" fill="#03043e" />
        <path
          d="M75.3,348.7c0,.2,0,.7,0,1-1.2-1.2-2.2-2.8-2.5-4.5.8,1.2,1.5,2.4,2.5,3.5Z"
          fill="#1841c7"
        />
        <path
          d="M57.3,317.8c.1.4,1,1.1,1.3,2,.6,2,.6,4.4,1.7,6.5l1-.5c-1.1,2.5.2,1.7.5,2.3s0,.6,0,.7c-1.8.5-1.6-1.4-3-2-.7-1.6-1.4-4.2-2-5.5-.8-2-.6-3.1.5-3.5Z"
          fill="#010655"
        />
        <path
          d="M78.3,365.2c-.7-1.2-2.7-3.2-3.5-4.5-1.7-2.7-3.4-5.7-5-8.5s-1.3-3.2-2.5-5-.3-.7-.5-1l-.5-.5c-.2-.6-.3-1.4-.5-2v-.5c4,7.4,8.5,14.6,12.5,22Z"
          fill="#02219f"
        />
        <path d="M65.8,343.2v.5c-1.1-.7-1.1-2-1.5-3,1.1.4,1,1.6,1.5,2.5Z" fill="#092eae" />
        <path
          d="M90.8,369.2c-.4,0-.5.1-.5.5-.1-.2-.7-.6-1-1l-1-1c0-.2,0-.4,0-.5-.6-.7-.3-1,.5-.5,1.3-.4,2.1,1.2,2,2.5Z"
          fill="#03096a"
        />
        <path d="M89.3,368.7l-1-.5c0-.2,0-.3,0-.5.6.1.7.7,1,1Z" fill="#1346ca" />
        <path
          d="M339.7,71.9c.1,0,.4,0,.5,0l.5.5c2.2,1.1,4.2,3.1,6.9,3.9s1.9,0,2.1.1-.7.6.3,1.4,2.8.9,3.9,1.6c2.7,1.6,8.5,5.6,11,7.4s5,4.2,7.3,6.3c-.8,1.6-1.8-.6-2-.2-.5.7,1.3,1.9,1.5,2.5-1.3-.8-2.7-1.6-4-2.5-3.9-.6-7.8-3.8-10-7-.8-.4-1.7-.9-2.5-1.5h-1.5c-3.3-2.2-6.8-4.3-10.4-6.1,0-.6,0-1.1-.6-1.4-2.7.2-6.2-1.6-7.5-4h1.8s-1.8-2-1.8-2c1.6-.2,3.1.4,4.5,1Z"
          fill="#060455"
        />
        <path
          d="M409.1,137.8l.8-.3c2.1,2.8,4.2,5.5,6.2,8.3.1,0,.4,0,.5,0s.3.3.5.5c.5.3.6.7.5,1,1.1,1.4,1.7,3,2.5,4.5.6,1.4,1.1,2.8,1.5,4,.6,3-2.6,2-3.2-.4-1.2-4.9-4.1-9.8-8.3-12.6-.6,0-1.6-.8-1.5-1.5-.2-1.2,0-2.4.5-3.5Z"
          fill="#1e1fab"
        />
        <path
          d="M404.1,129.4c3.8,4.7,7.6,9,11,14s0,.4,0,.5l.5.5c0,.2,0,.3,0,.5l.5.5v.5c-2.2-1.1-1.2-1.6-2.1-2.4s-1.1,0-1.4-.4c-.9-1.3-1.5-4.3-3.5-5.2-.1.4-.3.4-.5,0-1.2-.8-3.1-3.4-3-5-1.2,0-2.3-1.9-1.5-3v-.5Z"
          fill="#2529a8"
        />
        <path
          d="M403.1,128.4c.2.3.3.7.5,1,.3,0,.5.2.5.5.6.8,1,2.2,1.5,3,.9,2.9-.9.9-2-.5-1.8-1.3-4.1-3.9-4.5-6,.2-.3.3-.5.5-.5,1.7.3.8,1.5.7.6s.1-.4.3-.6c.6.7,1.9,1.7,2.5,2.5Z"
          fill="#4d63ce"
        />
        <path
          d="M421.1,152.8v.5c1.1,2,2.5,4,3.5,6l.5,1c1.1.8,2,3.3,2,4.5.3,2.8-2.5-2.1-3-3.5-1.8-.1-3.4-4-2.5-5.5-.7-1.4-2.6-2.9-1.5-4,.3.6.9.9,1,1Z"
          fill="#2b29a8"
        />
        <path
          d="M426.1,160.3c.3,1.6,1.3,3,2,4.5-.2.4-.3.4-.5,0-.1.5-.3.4-.5,0-.9-1.3-1.3-3.1-2-4.5h1Z"
          fill="#211e8b"
        />
        <path d="M404.1,129.8c-.1-.2-.4-.3-.5-.5h.5v.5Z" fill="#2a3dca" />
        <path d="M415.1,143.3c-.2-.2.5-.8.5-.2s-.4.4-.5.2Z" fill="#010352" />
        <path d="M415.6,144.3c-.6,0-.4-.4-.5-.5h.5c.3.2.3.3,0,.5Z" fill="#1e1fab" />
        <path d="M415.6,144.3v-.5c1,.2,0,.4,0,.5Z" fill="#010352" />
        <path d="M416.1,145.3l-.5-.5s.5.2.5.5Z" fill="#1e1fab" />
        <path d="M416.6,145.8c-.2-.2.5-.8.5-.2s-.4.4-.5.2Z" fill="#010352" />
        <path d="M417.6,147.3l-.5-1c.4.3,1.6.7.5,1Z" fill="#010352" />
        <path d="M421.1,153.3v-.5c.4.6,0,.5,0,.5Z" fill="#010352" />
        <path d="M425.6,160.3h-.5c-.2-.3-.3-.7-.5-1l1,1Z" fill="#010352" />
        <path
          d="M356.7,86.4c1-.4,2.4.4,2.2,1.5l7.9,6.3v1.2c4.7,3.8,9.7,7.2,14.6,11s1.7,1.6,2.2,2.5c-.1.4-.5.4-1,0-1.3.7-3.8-1-3.5-2.5-2.2-2.1-4.5-3.5-6.8-4.2-4-2.7-8-5.7-11.8-8.8s-1.1-1.5-1.4-2.4c-2.9-2.1-6-3.9-9.3-5.2l.4-.8c2.1-.9,5.1-.6,6.5,1.5Z"
          fill="#7889dd"
        />
        <path
          d="M357.7,85.9c3.4,2.2,6.7,4.7,10,7,1.3,1.6,1,2.5-1,2.5-.8-.6-9.9-7.5-9.5-8s1.2.4,1-.5c-.5,0-1.1-.2-1.5-.5-.2-.2-.2-.3,0-.5,0-.4.3-.4,1,0Z"
          fill="#8293db"
        />
        <path
          d="M383.6,108.9c.2,0,.4.4.8.4l.2-.4c1.4,1.6,3.2,3,4,5,.8,1.3.1,1.5-1,.5-2,.2-5.2-3.6-5-5.5.3,0,.7,0,1,0Z"
          fill="#7688db"
        />
        <path
          d="M389.6,114.9c0,.4,0,.6.5.5.6.5,1.3.8,2,1,.7.9,1.4.9,1.5,1,.6.7,1.5,1.4,2,2s.9,2,2,2.5c.1.3.3.7.5,1,2.1,1.7,2.1,4.1-.6,1.8-1.4-1.5-2.8-3-4.4-4.3-1.3.7-2.2-.2-1.5-1.5-2.3-1.3-3.6-2.8-4-4.5.4,0,.9-.5,1-.5.2,0,.4,0,.5,0s.3.8.5,1Z"
          fill="#728ade"
        />
        <path
          d="M424.1,161.8c4.1,5.3,7.1,11.1,9.2,17.4l1.3.6c.5,1.3,1.1,2.7,1.5,4s0,.7,0,1c-.6,1.5-1.7,1-3,.5-.8,1.1-1.1.8-1-.5-1.7-2.2-2.6-4.5-2.7-7-1.8-.4-3.2-1.6-2.3-3.6-1.4-1.2-2.1-2.6-2.4-4.4-1.4.1-2-1.5-1-2.5-1.1-2-1.2-3.6-.5-5-.6-1.3,0-1.5,1-.5Z"
          fill="#030798"
        />
        <path
          d="M427.1,164.8c.2,0,.4,0,.5,0,1.1,2.3,2.3,4.6,3.5,7,0,.1.4.3.5.5v.5c0,.2.4.3.5.5v.5c.6,1.3,1.9,3.1,2,4.5-.3.5-.3.7,0,.5.7-.2.4.7.5,1l-.9,1.2c-2.4-6.8-6.4-12.8-9.6-19.2-.4-.1-.4-.3,0-.5.3.5,2.3,3.7,2.5,3.8.4.3.5-.3.5-.3Z"
          fill="#1819a0"
        />
        <path
          d="M431.1,171.8c-1.2-2.2-3.2-4.3-3.5-7,.2,0,.3,0,.5,0,1.1,2.3,2.1,4.6,3,7Z"
          fill="#141292"
        />
        <path d="M434.1,178.8s-.6,1-.5.2.5-.7.5-.7v.5Z" fill="#030798" />
        <path d="M431.6,172.8c-.3-.5,0-.5,0-.5v.5Z" fill="#141292" />
        <path d="M432.1,173.8c-.2-.5,0-.5,0-.5v.5Z" fill="#141292" />
        <path
          d="M393.1,120.4c2.1.2,3.8,3.9,5.3,4.5s-.1-1.7-.3-2c1.5.5,1.8,2.1,2.5,3,1.4,2.1,0,1.4-1.5.5l-.5.3-3.5-3.8c-1.6.4-2.6-1.1-2-2.5Z"
          fill="#6078de"
        />
        <path d="M390.1,115.4c-.5.7-1.2-.2-.5-.5.2.2.3.3.5.5Z" fill="#7688db" />
        <path
          d="M443.6,229.3c.1.3.9.5.9.5.1.4-1.2,3.2-.9,3.4s2.2-1,1.5,2.2-1.2,1.7-1,2.9.8.3,1,.7c.5,1.5.2,3.4,1,4.6,0,.3,0,.7,0,1-.2,1.6-1.1,5.6-1,6.7s.9.2,1,.6c.5,2.8-.5,9.5-.8,12.5s.4,2.9.3,3.4-1.3.6-1.4,1.1c-1,3.7,0,11.5-.8,15.7s-1.1,2.4-1.2,3.2.9.5,1,1c.2,1.2-1,.5-1,1s.5,1.2.5,1.7c-.3,1.7-.8,3.1-1.5,4-1-.5-1.4-1.6-1-3.5-2.2-.2-1.5-3.5.5-3,0-1.6.3-2.8.9-3.9-.1-1.9.1-3.8.9-5.6l-.3-3.7c.5-9.7,1.1-19.3,2.1-28.8-.4,0-.4-.3,0-.5-.4-1.5-.6-3.2-.4-5.1-.8-1.7-1-3.1-.6-4.4-.4,0-.4-.3,0-.5-.2-1.7-.6-3.6-1-5.5-1,0-1.6-3-.7-3.9-.6-1.8-.3-3.2.7-4.1,1.9-.2,1.6,4.5,1.5,6Z"
          fill="#000296"
        />
        <path
          d="M434.1,189.8c1,.2,1.1.4,1.6,1.2,2.7,4.3,2.7,6.7,3.4,11.3.5.7.3,1-.5.5-.5.4-.9-.1-1.3-1.8-1.6-1.3-2.1-2.2-1.5-2.6-.9-.9-1.2-2.2-1-3.8-1.4-1.4-1.6-2.5-.8-3.3v-1.5Z"
          fill="#010491"
        />
        <path
          d="M439.1,202.3c0,.6,1.2,1.2,1.4,1.8s-.7,2.2-.4,3.3.9.3.9.4c.2.5-.4.9-.3,1.3s1,0,1.2,2.1.2,3.9-.3,5c-.8-1-1-2.7-1-4-1.5-.3-3-4.7-3.2-6.4l.7-1.1c-.2-1.1,0-1.8.5-2,0-.2.3-.4.5-.5Z"
          fill="#000290"
        />
        <path
          d="M441.6,216.3c0,.1.8.4.9.9.3,1,1.1,4.1-.4,3.6-.2.8.7.3,1,.8s1.5,6,1.5,6.3-1.4.3-1,1.3c-1.5-2.7.2-4.3-1.5-6-1.2.7-1.7.2-1-1-.3-1.6-.5-3.4-.5-5.3-.7-.4-.8-.9-.3-1.7-1.4-1.4-1.3-2.4.2-3,.9,1.8.6,2.7,1,4Z"
          fill="#000291"
        />
        <path
          d="M434.1,188.8c0,.3,0,.7,0,1,0,.5,0,1,0,1.5-1,.3-1.9-5-1.7-5.2s.4-.2.7-.3c.9.8.9,1.9,1,3Z"
          fill="#030798"
        />
        <path
          d="M433.1,185.3v.5c-.2,2.1.6,3.8,1,5.5s1.7,7.1,3,8.8,1.4.6,1.5.8-1,1.7,0,2c-.2.6,0,1.4-.5,2-1.1-.2-1.9-1.5-2.4-3.9h-1.1c-.3,1.2-.7,1.2-1-.1-.8-1,.1-1.7,1.1-2.1v-.9c-.3.4-.4.4-.6,0l-.9-.5c1.5-1.6,1.6-2.4-.1-4-.2.3-.4.1-.5-.5-.9-1.5-1.2-3.4-1.4-5.1-1.1-.9-1.1-1.9.4-1.9-.2-.8,0-1.1.5-1,.4.1.7.4,1,.5Z"
          fill="#0004a4"
        />
        <path
          d="M440.6,300.3c0,3.2-1.2,5.6-2,8.5-.8,3-1.8,6.6-2.8,9.5s-3.3,6.6-3.7,9.5h-.5c-1.5,0-2.2-.6-1.3-2.1,2.1-1.8,2.5-3.3,1.4-4.7,1.8-4.2,3.4-8.6,4.7-13.1h.7c-2.1-1.1-.9-5.2,1-3.1.5-1.3,1.1-3.1,1.6-5.6l.9-.4c.4.4.4.9,0,1.5Z"
          fill="#010296"
        />
        <path
          d="M440.6,300.3c0-.5,0-1,0-1.5-1-.4-.6-2.9.5-3,0-1.9.4-2.6,1.5-4,0,2.6-.4,6.4-2,8.5Z"
          fill="#01028c"
        />
        <path
          d="M373.1,396.7c3.9-7,8.1.2,4.5,4.6,1.1.4,1.6,1.1,1.5,1.9-1.4,1.3-3.3,3.1-4.5,4.5l-1,.6c.1,1.2-1.5,2.3-2.5,1.4-.4-.1-.4-.3,0-.5-.6-1.2-.2-1.4,1-1,.3-1.9.9-3.5,1.7-4.9,1.2-1.8-4.4-3.3-5.2-2.6-.4,2-3,3.8-5,3.5-1,.8-1.3.6-1-.5,2.3-1.6,3.7-3.5,5.5-5l.5-.5c.5-.4,2.2-.4,2.8-1.5l.5,1.5c.6-.3.9-1.2,1.2-1.5Z"
          fill="#070715"
        />
        <path
          d="M377.1,391.2c.8.6,1.4.6,1.7,0,1.7-.8,3.3,8.4,3.3,9.5,0,.1,0,.4,0,.5-1.1.2-2.2,1.3-3,2-4.9-1.7-1.3-2.7-1-4.8s-.9-3.6-1.1-3.7c-.8-.7-3.3,1.4-4,2-.9-.1.6-1.7.8-1.9.5-.6,3-3.5,3.2-3.5Z"
          fill="#060a22"
        />
        <path
          d="M374.6,407.7c-.3.3-.9.3-1,.8-.2,1.1.3.7,1,.2-.1.1-.4.7-.5,1l-6,4.5c-.5-.5-1.2-.3-2.4.9l-.6-.4c-.7-.6-.2-1.1,1.5-1.5,0-1.4,1.1-2.6,2.4-2.5.6-1.1,1.2-1.4,2.1-1,.7-.6,2.6-1.6,3.5-2Z"
          fill="#1e2f6b"
        />
        <path
          d="M380.1,389.2c2.5,3.1,3.8,5.5,4,9.5-.2.2-.3.7-.5,1-.4.4-1.2.7-1.5,1l-2-.5c-.3-.9.8-1.2.8-1.7s-1.3-4.3-1.5-5.2.3-1,.2-1c-.5-.2-2.2.4-2.5-1,.3,0,1.1.2,1.4,0,.6-.6-.5-1.1,1.6-1.9Z"
          fill="#060a2d"
        />
        <path
          d="M423.1,334.7c0,.7.2,1.4.5,2,1.1-3.2,3.5.2,1,.5-.2.4-.2.8,0,1,.1-.4.3-.4.5,0,.6.8.8,2,.5,3.5-3.3,6.7-6.5,13.1-11,19-1.7,2.4-3.7,4.5-5.9,6.4-3-.2-2.4,1.3-.7,3l-.4,1.2c-.6.8-1,1.8-1.5,2.5s-1.5,1.4-2,2c-.8.3-1.9,1.3-3.2,3.1-1.3-.3-2,.3-2,1.5l-1.2.3c-1.3.6-2.1-.2-1.5-1.5l.2-.7c-.7-1.2-.2-4.1,1.3-3.8-.8-.7-.5-1.6,1-2.6-.9-.9-.6-1.3,1-1.4.5-2.9,2.9-6.9,6-8.5l3-4c-.4-.1-.4-.3,0-.5.9-1.9,1.8-3.8,2.8-5.8l1.2-.2c.3-.6.8-1.1,1.5-1.5-.7-1.2,1-5.1,2.5-5.5.8-2.3,1.7-4.5,2.8-6.7l1.2-.3c.9,0,1.8.2,2.5.5v-.5c-.6.5-1.8.3-2-.5-2.2-1.4.2-4.4,2-2.5Z"
          fill="#0009ac"
        />
        <path
          d="M393.6,376.7l.8.7c1-.4,2,.6,1.7,1.8.6.4,1.1.9,1.5,1.5.7.3.7.8-.3,1.7l.3.8c-1.1,1.3-2.1,3.9-4,5-1.2,1.5-2.5-.8-1.5-2.1,2.7-.8,1.9-1.5-2.3-2.1-1.5-.5-3.3-1.2-2.2-2.8.2-1.3.8-1.6,1.8-.7,1.2-.4,2.1-1.3,2.7-2.8.1-.4.3-.4.5,0l.5-.5c-.7-.7-.4-1,.5-.5Z"
          fill="#0108a6"
        />
        <path
          d="M387.6,381.2c.9,2.4,6.2,2.1,6.8,3s-.4,3.1-1.8,2.5c-.4,1.1.8,1.2,1,1.5s0,.4,0,.5c-.4.8-2.8,2.5-3.7,2.5s-1.3-1.6-1.8-2c-1.6-1-1.5-2,.4-3.1-2.3-.7-3.1-1.7-2.4-2.9.2-.3.3-.7.5-1-.2-.9,0-2,1-1.5.4.2.4.3,0,.5Z"
          fill="#010898"
        />
        <path
          d="M404.1,375.7c-2.2,2.9-4.3,4.9-6.5,7.5h-1.5c-.2-.1,1.3-2,1.5-2.5,1.1-2.3.3-3.6,3.2-2.5,1.3-.5.2-1.9.3-2,.3-.2,1.2.6,1.5.5s.6-2.5,1.5-1Z"
          fill="#010bb7"
        />
        <path
          d="M431.6,312.8c3.5-.9,3.7,3.1,1,4.6-.3,2.1-.5,4.2-.8,6.2-.7.9-5.6,11.4-5,11.3s.2-.2.2-.2c1.5-3.2,3.4-1.9,1.5.7,0,.2,0,.4,0,.5-.6,1.8-1.7,2.4-3.5,2.5h-.5c-.2-.3-.2-.6,0-1,0,0,.9-.6.5-1s-1.2.5-1.5.5c-.5,0-.7-.7-.5-2-1.2-1.2-2-4.7.5-4.5-.1-.5,0-.6.5-.5.2-.5.5-1,1-1.5,1-2.7,2-5.4,3-8-.5,0-.4-.2,0-.5-.3-.9,0-1.3,1-1.5-.4-.1-.4-.3,0-.5.6-1.5,1-3,1.4-4.6l1.1-.3Z"
          fill="#0106aa"
        />
        <path
          d="M414.6,360.7c0,.1,0,.4,0,.5l-.5.5c-1.9,3.4-4.2,6.3-6.5,9.5l-3-3.8c1.7,0,2-1.2,1.5-2.7h2.5c.2.9-.8.3-1,.5s-.3,1.2.7,1,4.4-3.7,4.6-4c.7-1.2-1.7-2.9,1.7-1.5Z"
          fill="#010bb2"
        />
        <path
          d="M425.6,341.7l-2,.5,1.5-1.5c0-1-1.3,0-1-1.2s.5,0,1-1.3c1.1-2.7,2,.2,3.5-2.5-.7,2.7-1.9,3.8-3,6Z"
          fill="#0106a3"
        />
        <path d="M424.1,348.2c-.3.6-.8,1.1-1,1.5l2-4c-.3.7-.5,1.6-1,2.5Z" fill="#0b39cd" />
        <path d="M414.1,361.7c.1-.2.3-.3.5-.5-.1.2-.3.3-.5.5Z" fill="#0009ac" />
        <path
          d="M386.1,383.2c-.1,1.8,2.5.9,3.3,2.5s-.1,1-.3,1.5c2.6-.3,2.1.2,2,2.5-.5.6-3-2.2-3.7-2l.7,1.5c-.2-.2-.8-.3-1-.5-.8-.7-2.5-2.2-2.5-3,.5-1,1-1.6,1.5-2.5Z"
          fill="#010484"
        />
        <path
          d="M296.2,355.7c1.5-.1,2.1-.6,1.9-1.4.6-.4,3.8,1.1,3.2,2.2,2.2,2,4.9,3.9,7.5,5.5v.8c.6.6,1.6,1.4,2.4,2l.5.5c.2.1.3,1.2,2,2,1.3.7,1.8,1.6,1.5,2.5.9.5,1.2,1,1,1.5,2.2-.7,5.2,5,2.5,5.5-.5.9-1.4.4-2.8-1.4l-1.2-.6c-1.7.6-2.4-1.6-1.3-2.9l-.3-.5c-2.3-.5-3.3-1.4-2.9-2.6-.5-1.1-.9-1.7-2.4-2.2-.5-1.9-1.9-3-4.2-3.1l-.4-1.2c-.2.2-.4.4-.6.5-.5.2-3.8-2.1-4-2.8-.2-.9-.8-1.6-1.9-2.2-.6.3-.8.1-.5-.5-.4,0-.5-.3-.5-.5-1.2-.7-.8-1.3.5-1Z"
          fill="#021553"
        />
        <path
          d="M317.7,370.7c1.4.3,2.7,1.4,3.9,3.3,1.5.2,4.5,2.4,3.8,4,1.7.2,3.7,2.4,2.6,3.8.8.6,1.6,1.1,2.7,1.4-.7,1-.9,1.7.5,1.5v.5c-.3,0-.8.3-1,.5-.5.9-.2,1.3,1.1,1.2v.8c-.2.4-.4.4-.6,0-1,2.4-5.3,1.6-3.4-1.2-2.5.8-4.5-1.4-4.4-3.9-1.7-.1-2.4-1.4-2-3-1-.7-1.7-1.6-2.2-2.9.5-1.2-.3-3.7-1-4.7s-1.2-.4-1.5-.8q.2-.2,0,0c-.8-.8-.8-1.2-1-1.5.8-1,1.6-.6,2.5,1Z"
          fill="#02154b"
        />
        <path
          d="M330.2,385.7c-.3,2,1.6.2,2.7.5s.3,1.3.4,1.4c.8.9,3.7,1,4.9.6.4,2.5.6,5.1.7,7.6l-.7.4c-1.5.9-2.2.9-2.2-.2-1.3,0-2-2.3-1.8-3.7l-1.3-2.2c-2.2-.6-2.7-1.4-1.7-2.4-.6-.8-2.6-.1-1-2Z"
          fill="#041545"
        />
        <path
          d="M387.6,380.7c-.4.5-.7,1-1,1.5l-.5-1c-.8-.3-.2-1.7.5-2-.3-1.2-.1-2,.5-2.5-.4-1.1-.2-2.5.5-3.5-.6-.6-.5-1.7.5-1,1,.5,2,2.8.9,3.8,1.1.8,0,4.2-1.4,4.7Z"
          fill="#081775"
        />
        <path
          d="M342.7,389.7c.2,2-2.6,1.8-1.5-.5-1-.2-2-.6-3-1-.3-1-1-1.9-1-3,1.1,1.2,2.8.4,3.8.9s1.2,2.3,1.7,3.6Z"
          fill="#050e30"
        />
        <path
          d="M359.6,405.7c2.3-1.3,1.8.4,0,1.5-.7,1.3-1.4,1.8-2,1.5-.1.4-.3.4-.5,0-.6.4-1,.4-1-.5v-.5c.9.2,1.2-.8,1.5-1l2-1Z"
          fill="#0b1640"
        />
        <path
          d="M181.3,445.7c.4-.2.7-.4,1.1-.3,4,.8,8.8,2.1,12.4,3.8,0,1-.8,1.2-2.5.5-.5,0-1,0-1.5,0l-1-.5c-.3,0-.7,0-1,0-3.6-1.1-12.4-4-15-6-.9-.4-1.6-.9-2-1.5,3.4,1,6,2.8,9.5,4Z"
          fill="#0f2c7c"
        />
        <path d="M171.8,441.7c.9.3,1.4,1,2,1.5l-7-2.5c2.1,0,3.1.4,5,1Z" fill="#14337c" />
        <path
          d="M199.7,450.7l1.5,1.5c-1.2,0-2.4-.2-3.5-.5-1.7-.4-4-1.2-5.5-2,.9,0,1.7,0,2.5-.5,1.5-.3,3.6.7,5,1.5Z"
          fill="#15337f"
        />
        <path
          d="M331.7,439.7c.4.1.4.3,0,.5h-.5c-1.2.7-2.4,1.2-3.5,1.5l-.4.6c-5,1.9-10.1,3.7-15.1,5.4-2.6.6-5.3,1.2-8,1.6s-1.1-.2-1.5-.6c-.4-.1-.4-.3,0-.5,6.2-1.2,12.5-3.6,18.5-5.5s6.4-2.1,10.5-3Z"
          fill="#021055"
        />
        <path
          d="M358.6,427.2c-3,3.6-8.7,3.8-12,7-.5.3-1,.7-1.5,1l-11.4,4.9c-.7.3-1.4.4-2.1,0v-.5c4.6-1,17.4-8.1,22.5-10.5l1.5-1c.1,0,.4,0,.5,0,.8-.4,1.7-.6,2.5-1Z"
          fill="#01165d"
        />
        <path d="M355.7,428.2c-.2.7-.8,1-1.5,1,0,0,.7-.6,1.5-1Z" fill="#040f4c" />
        <path
          d="M345.2,435.2c-6.2,3.5-13.2,7-20,9-.5-1.2,1.9-2,3-2,.1-.4.3-.4.5,0,.6-.4,1.1-.9,1.5-1.5.3-.3.8-.3,1,0l.5-.5c4.4-2.1,8.9-3.5,13.5-5Z"
          fill="#051f6c"
        />
        <path
          d="M328.2,442.2c-1,.5-2.1,1.3-3,2-3.2.9-7.4,2.3-10.5,3s-1.6.4-2.5.5c1.1-1.4,3.1-1.4,4.6-2s.4-.7.8-.9c3.3-1.4,6.8-1.6,10.1-3,.8-.3.9-.3.5.5Z"
          fill="#031965"
        />
        <path
          d="M309.7,443.7c0,.1,0,.4,0,.5-.4.2-.4.3,0,.5-1.1.9-4,1.6-5.5,2-1.1-.2-2.3,0-3.5.5-.5.2-1,.3-1.5.5-.9,0-1.6,0-1-1-.3-.2-.1-.4.5-.5.4-.6.6-.7,1,0h.5l1-.5c.2-.4.3-.4.5,0l1-.5c.8-1.1,3.2-1.4,4.5-1l1-.5c.2-.4.3-.4.5,0,.3-.3.7-.4,1,0Z"
          fill="#090c68"
        />
        <path
          d="M300.7,448.7c.4.1.4.3,0,.5-.2,0-.4.5-.5.5h-1c-.9.3-2.2.9-3,1.5-1,0-2,.4-3,.5-2.2.3-4.2.3-6,0-.2-1.5,3.5-1.6,5-1.5.6-.8,1.7-.8,2.5-.5,2-.4,4-.7,6-1Z"
          fill="#01074c"
        />
        <path
          d="M324.2,437.2c.8-.5,1.9-.7,1.5.5.1,1.3-1.5,1.6-2.5,1,.2.9-1.3,1.7-2,1-1.1.4-3.4,1.3-4.5,1.5h-.5c-.3.4-.7.4-1,0-3.3.3.2-1.1,2-1.5-.4-.2-.4-.3,0-.5l3-1c.6-1.3,2.7-1.9,4-1Z"
          fill="#5293dd"
        />
        <path
          d="M340.2,432.7c.4.1.4.3,0,.5-5.1,2.5-10.6,4.7-16,6.5-1.4.3-1.7,0-1-1,.8-.3,1.7-.4,2.5-1,0-.4.3-.4.5,0,.6.1,4.2-.5,3-1-.5-1.4,3.2-3,4-2,2.4-1.1,4.7-1.8,7-2Z"
          fill="#04095d"
        />
        <path
          d="M296.2,447.2c.4,0,.4.3,0,.5.5.1.7.3.5.5-.2,0-.5.4-1,.5-.8-.3-1.6-.3-2.5,0-.3.3-.8.4-1.5.5,0,.3-.2.5-.5.5h-1c-.1.4-.3.4-.5,0-1,.3-1.6,0-1-1l1-.5c0-.5.8-.5,1,0l1.5-.5c.3-.8,1.8-1,2,0l1-.5c0-.8.7-.7,1,0Z"
          fill="#0a0d6d"
        />
        <path
          d="M316.2,441.2h.5c.6.3,1.6.4,1.5,1-1.2-.1-2.3.8-3.4.9s-1.7-.4-2.1-.4c-.4-.1-.4-.3,0-.5.1-.4.3-.4.5,0l.5-.5c.2-.2.3-.2.5,0,.3-.4.7-.4,1,0q.7.3,0,0c-.4-.1-.4-.3,0-.5.3,0,.7,0,1,0Z"
          fill="#03158d"
        />
        <path
          d="M358.6,422.2c-3.2,2.2-5.1,3.2-8.5,5-.3-1,1.9-2.1,3-2.5,1.2-.8,4-1.8,5.5-2.5Z"
          fill="#050a44"
        />
        <path
          d="M324.2,439.7c-1.5.5-2.7,1.3-4.2,1.5l1.2-1.5c.4-.1,1.3-.7,2-1l1,1Z"
          fill="#0e1aa8"
        />
        <path
          d="M346.2,429.7c-2.1,1.3-3.7,2.4-6,3.5v-.5c-.5-.5.3-1,1-1,1.2-.8,3-2,4.4-2.4s.4.2.6.4Z"
          fill="#040e46"
        />
        <path
          d="M293.7,449.2c.2-.2.3-.2.5,0,.1-.3.3-.3.5,0v.5c-.8.2-1.7.3-2.5.5-1.1.2-1.8,0-2-.5.3,0,.7,0,1,0l1.5-.5c.1-.3.3-.3.5,0,.1-.4.3-.4.5,0Z"
          fill="#020205"
        />
        <path
          d="M297.7,446.7c.1-.3.3-.3.5,0,.2,0,.7.8,1,1-1,.3-1.7.3-2.5.5-.4,0-.5-.1-.5-.5,1.8-.2,1.8-.3,0-.5-.5-.8.9-.9,1.5-.5Z"
          fill="#0d157e"
        />
        <path d="M304.2,446.7c-1.1.3-2.3.4-3.5.5.9-.3,2.5-1.9,3.5-.5Z" fill="#061576" />
        <path
          d="M295.7,448.7c-.3,0-.7,0-1,0-.2.3-.3.3-.5,0l-.5.5h-.5c-.4-.1-.4-.3,0-.5.6-.2,1.8-1.3,2.5,0Z"
          fill="#0d157e"
        />
        <path d="M350.2,427.2c-1.7,1.2-2.1,1.5-4,2.5-.3-1.3,3-3.2,4-2.5Z" fill="#04093d" />
        <path d="M312.7,442.2v.5c-.7,0-1.7.4-2.5.5-.4-.9,1.8-1.6,2.5-1Z" fill="#4083d6" />
        <path d="M310.2,443.2c0,0-.5.5-.5.5-.3,0-.7,0-1,0-.8-.8,1.3-1.5,1.5-.5Z" fill="#3c73d3" />
        <path d="M309.7,444.2c0,0,.6,0,0,.5-1.4.2-1.4-.7,0-.5Z" fill="#0d1fb7" />
        <path d="M294.7,449.2h-.5c-.2-.2-.2-.3,0-.5.2,0,.3,0,.5,0v.5Z" fill="#01074c" />
        <path
          d="M353.2,424.7c-.8.5-2.2,2-3,2.5-1.8.9-2.5,1.6-4,2.5-1.5.7-3.5,1.3-5,2-.4-.1-.4-.3,0-.5.4-1.9,3.7-3.3,5.5-3.5l1.5-1c.1-.4.3-.4.5,0l.5-.5c.1-.4.3-.4.5,0,.4-1.6,1.9-2.5,3.5-2v.5Z"
          fill="#060628"
        />
        <path
          d="M355.2,421.7c1.2-1.6,4.2-2.2,2,0-.1,0-.4,0-.5,0l-1,1c-.8.5-1.7,1-2.5,1.5s-2.3,1.3-3.5,2l-.4-.4c-1.3.9-2.5,1.3-3.6,1.4-1-.9-.8-1.2.5-1-.3-1.3,1.5-2.7,2.3-1.5l1.2-.5c-.3-1.6,2.9-3.1,4-2l1-.5c.2-.4.3-.4.5,0Z"
          fill="#3262c0"
        />
        <path
          d="M359.6,418.7c1.2-1.5,4.1-2,2,0-.1,0-.3,0-.5,0l-.5.5c-1.1,1.4-2.1,1.6-3.5,2.5l.2-1c-.8,0-1.5.7-2.2,1-.8-.4-.6-.7.5-1-.7-1.6,2.8-3,4-2Z"
          fill="#1f4da8"
        />
        <path
          d="M365.1,414.7c1.1-.6,3.1-2,4-1.8-.5.3-.7.9-1,1.3s-.4,0-.5,0l-1,1c-.8.7-1.6,1.4-2.5,2l-.6-.3c-.9.8-1.5.9-1.9.3.1-.6.6-1.1,1.5-1.5-.1-1.4.9-1.8,2-1Z"
          fill="#192c74"
        />
        <path
          d="M361.6,417.2c1.3-.4,2-1.2,3.2-1.5l.3.3-1,1.3c-.8.6-1.6,1.1-2.5,1.5l.2-1c-.8,0-1.5.7-2.2,1-1.2-.5-1-.8.5-1,0-.5,1-.7,1.5-.5Z"
          fill="#1f3b91"
        />
        <path d="M366.6,415.2l1-1c-.3.3-.5.6-1,1Z" fill="#1e2f6b" />
        <path d="M360.6,419.2c.1-.2.3-.4.5-.5-.1.2-.4.3-.5.5Z" fill="#1f3b91" />
        <path d="M355.7,422.7l1-1c-.1,0-.4.6-1,1Z" fill="#1f4da8" />
        <path
          d="M183.8,445.2c2.7.7,5.3,1.4,8,2,3.1.7,6.1,1.5,9.1,2.5s.4.6.4,1c-.4-.1-1.1.1-1.5,0-1.7-.4-3.3-1-5-1.5-4.5-1.2-9.1-2-13.5-3.5l-1-1.5c1.3.3,2.4.7,3.5,1Z"
          fill="#0f256c"
        />
        <path d="M177.3,443.2c-.2-.1-.4-.3-.5-.5.2,0,.4.3.5.5Z" fill="#0f256c" />
        <path
          d="M141.8,419.2c.3-.8,1.5-.3,1.5.5l.5.5c.1-.3.3-.3.5,0,.2-.1.3-.2.4-.2,1.3.6,5.5,3,6.7,3.9s0,.4-.1.8l-.5,1c-2.8-1.3-6.1-3-8.5-5-1.9-.9-3.3-3.2-.5-1.5Z"
          fill="#4086d1"
        />
        <path
          d="M151.3,424.7c1.2-.8,4.9,1.6,5,3,.6.8-.3.8-1,.5-.8-.5-2-.7-2.5-1-.7-.4-1.4-1-2-1.5s-1.3-.9-1.5-1.5c.7,0,1.4.3,2,.5Z"
          fill="#528cd4"
        />
        <path
          d="M136.8,415.7l.5.5c.2-.4.3-.4.5,0l1,.5c.4-.6.9-.1,1,.5.9-.2,2.1,1,2,2-2.2-1-.7.5.5,1.5-2.2-.9-4.1-2.7-6-4-1-.8-1.5-1.5,0-1,.2-.4.3-.4.5,0Z"
          fill="#3162ac"
        />
        <path
          d="M131.3,411.7c1-1.3,3.4.5,3,2v.5c.1.6-.2.7-1,.5-.1,0-.4,0-.5,0-1-.6-2-1.3-3-2-.1-.4,0-1,0-1.5.4.3,1.1.3,1.5.5Z"
          fill="#133b7f"
        />
        <path
          d="M134.3,414.2c.1-.2.3-.2.5,0l.5.5c.5-.1,1.1.5,1,1l-.5.2.5.8c-1-.7-2-1.3-3-2,.2-.5.6-.4,1-.5Z"
          fill="#2555a1"
        />
        <path
          d="M166.8,432.2c.6-.3,1.6.3,1.5,1l2,1c.2-.4.3-.4.5,0,.9.5,1.7,1,2.5,1.5,3.9,0,2.1,2.8-1,.5l-1-.5c-.1,0-.4,0-.5,0l-.5-.5c-.1,0-.4,0-.5,0l-.5-.5c-.1,0-.4,0-.5,0l-1-.5c-.1,0-.4,0-.5,0l-.5-.5c-2.9-1.3-5.7-2.6-8.5-4-.6-.6-.2-.8,1-.5,2.1-.4,5.6,1.7,7.5,3Z"
          fill="#488dd4"
        />
        <path
          d="M156.3,427.7c1.3-.5,2.6.1,3,1.5l-1,.5c-.8-.4-1.6-.9-2.5-1-.2-.2-.3-.4-.5-.5l1-.5Z"
          fill="#63a7e2"
        />
        <path d="M168.8,434.7c-.4-.2-.8-.4-1-.5l1,.5Z" fill="#427fcd" />
        <path d="M172.3,436.2c-.6-.2-.9-.5-1-.5.5,0,.7.2,1,.5Z" fill="#427fcd" />
        <path
          d="M175.3,435.7c1.8.1,5.8,1.2,6,3-.4.7-1.2.7-2.5,0-1-.1-2-.3-3-.5s-1.2-.7-2.5-1c-.3-.3-.6-.7-1-1,.8.2,1.6.6,2.5.5,0-.9-1-.8-1.5-1-.4-.1-.4-.3,0-.5.6-.8,1.6-.2,2,.5Z"
          fill="#3a75d8"
        />
        <path d="M167.3,434.2c-.3-.2-.5-.5-.5-.5l.5.5Z" fill="#427fcd" />
        <path d="M169.8,435.2c-.3-.1-.4-.5-.5-.5l.5.5Z" fill="#427fcd" />
        <path d="M170.8,435.7c-.3-.1-.5-.5-.5-.5l.5.5Z" fill="#427fcd" />
        <path
          d="M181.3,438.7c.1-.3.2-.5.4-.6.6-.3,9.3,2.5,10,3.6,1.3-.2,1.8,0,1.5.5,1.9,0,5.2.2,6,2l2.7.8c1.3,1.4-.4,1.1-1.7.7-1-.2-2.4-.2-3.5-.5-4.8-1.3-10.7-3.4-15.5-5s-1.9-.9-2.5-1.5c.2,0,1.5-.2,2.5,0Z"
          fill="#4683d8"
        />
        <path
          d="M196.2,447.7c1.4.3,2.6.7,4,1,3.5.4,6.8,1.2,10,2.5l1.1.7c2.2.4,3.9,1.5.9,1.8-3.5-.7-7.5-2.2-11-3l-9.5-3.5c1.7.3,3.2.2,4.5.5Z"
          fill="#09195f"
        />
        <path
          d="M205.2,445.7l6.7,1.3c1.2,1.4-1.6,1.2-2.7.7-.1.3-.3.3-.5,0l-2-.5c-.6,1-3.6.6-4-.5-.8-.2-1.8-.8-2.5-1,.8,0,1.7.3,1.5-.5-1.2.3-1.9-.7-2.5-1,1.1-1.2,5.4,0,6,1.5Z"
          fill="#3e76dd"
        />
        <path
          d="M206.7,447.2c.3,0,.5.2.5.5.8,0,1.4.3,2,.5.4-.3,1-.3,1.5,0,.4.1.4.3,0,.5.4.1.4.3,0,.5.4.1.4.3,0,.5-.7.6-1.6.3-1-.5,0-.2-.1-.2-.5,0-1.4.6-4.5-.3-6-1-.2-.5-.6-.4-1-.5l.5-1c1.2.2,2.7.4,4,.5Z"
          fill="#090a6b"
        />
        <path
          d="M203.2,448.2c2.3,0,4.1.9,6,1h.5c0,.2,0,.4.3.5.2,0,.5,0,.7,0,.4-.3,1.1-.3,1.5,0,.6-.7,1.1-.4,1,.5.7-.3,1.4-.4,2,0,.7-.4.9-.4,1,.5h.5c.5,1-1.2.9-2,.5-4.4-.2-8.7-1.1-13-2.5.2-.6.9-.5,1.5-.5Z"
          fill="#01020e"
        />
        <path
          d="M201.7,448.7c4.3.8,8.7,1.7,13,2.5,5.6.4,11.1,1.4,16.5,3-2.9.8-7.4.6-10-1-1.6.4-3.4.4-5,0-.2.4-.3.4-.5,0-.7-.6-1.4-.9-2-1-1.1.4-2.6-.3-3.5-1-3.2-.8-6.7-1.7-10-2.5.5,0,1,0,1.5,0Z"
          fill="#040d4e"
        />
        <path
          d="M122.3,388.7c.3-.5,1-.3,1.5,0,.2-.4.3-.4.5,0,.4.1.4.3,0,.5.1.4,0,.6-.3.5s3.8-.8,2.9,2.7c.6,1.7,3,4.7,4.5,5.8,1.3-.7,2.8.6,2.5,2,.3.1.3.3,0,.5-.5.1-1.2.1-2,0l-1.2.3c-2.8-2.6-5.8-4.9-9-6.8.7,1.8,1,3.2-1.3,3.9l.2,1.5c1,.6,1.6,2.9,1.2,4h-.5c-1.3-1.8-3.3-3-5-4.5s-.3-.3-.5-.5c0-.9.5-1.4,1.6-1.5-.5-1.7,1.7-6.1,3.1-6.1l1.8,1c.3-.4-1-2.6-1.1-2.7-2.2.1-.1-1.6,1.1-.8Z"
          fill="#040514"
        />
        <path
          d="M110.8,393.7c.5-1.3,1.7.7,2,.5.9-.7,2-4.7,1-6,2.5.9,1.8-.2,2.1-.4,1.2-.6,5.2,3.1,5.4,2.9l-.5-2.5c0-.4.3-.4,1,0,.1-.4.3-.4.5,0,.4.1.4.3,0,.5-.6,0-1.6-.4-1.5.5,2.5,0,1.7,1.4,2.5,2.7s.8.1,1,.6c.6,1.4-1.7,0-2-.3-1.4-.9-2.8-1.1-3.5.6l-2.3,1.3c.4,1.9,0,4.8-2.2,3.1-.4-.4-1.1-.6-1.5-1-.7-.6-1.3-1.9-2-2.5Z"
          fill="#030530"
        />
        <path
          d="M122.3,392.2c-.6,0-1.6-.9-2-.2s-1.8,3.4-1.9,3.6c-.5,2,1.7,2.2-2.6,3.1-.2-.2-.8-.3-1-.5s-.3-.8-.5-1c2.6-.5.6-2.3,1.2-3.5s2.3-1.1,3.1-2.2.1-1.3.2-1.3c.8-.8,2.8,1.6,3.5,2Z"
          fill="#030421"
        />
        <path
          d="M139.3,406.7c1.6,1.5.5,3.3-3.5,5.4,2.4,2.1,2.6,5.4-.5,2.1h-.5l-.5-.5c-.8-.6-2.2-1.6-3-2-.2-.2-.3-.4-.5-.5l-1-1c-.2-.1-.3-.4-.5-.5.2-3.1,1.6-1.7,2.8-2.4s3-3.6,2.7-4-1.8-.2-1.5-1.5c2.4.4,5,2.7,6,5Z"
          fill="#060814"
        />
        <path d="M130.8,411.2c-.5-.4-.8-.8-1-1l1,1Z" fill="#040618" />
        <path
          d="M109.3,381.2c.8-1.2,1.4-.9,1.5.5,1.7.6,2.2.4,2.7-1.4l.8.9c.8-.2,1.5,1.2,1.5,2,1,0,2,1.2,1.5,2l1,1c.5-.1.6,0,.5.5-.4,0-1.1.5-1.7.4s-1.6-1.4-2.3-1.9c-1.2,0-2.3-.1-3.5-.2l-.7,1.1c-.4,2.1-1.1,3.3-2.3,3.6-.8-.8-1.7-1.7-2.5-2.5-1.6-2.7.2-7.1,3.5-6Z"
          fill="#02097a"
        />
        <path
          d="M87.8,361.7c2.1-1.3,4.4,2.3,4.6,4.6,2-.1,3.2,1.4,3.6,4.5,1.4.7,2.7,1.7,3.8,3,2.2,0,2.9,4.6,2.2,6.6.9.8,1.1,1.6.8,2.4,1.7.4,1,1.9-.5,1l-.5-.5c-.9-1-1.7-2-2.5-3s-1-1.4-1.5-2c-.6-1.5-1.8-3.3-3.5-5.2v-.8c-.7-.3-2.2-2-3.4-3.7s-3.6-5.8-3.5-6.2.2-.5.4-.7Z"
          fill="#010fad"
        />
        <path
          d="M102.8,382.7c-.8-2.3-.3-3.2,1.5-2.8.7-2.8,2.5-1.8,3.5.3,1.1-1,2-.4,1.5,1-.5,0-2.8,2-2.9,2.1s0,3.4-.6,3.9c-1.2-1.2-2.4-2.2-3.5-3.5.7,0,.4-.6.5-1Z"
          fill="#010d94"
        />
        <path
          d="M114.8,385.2h-.5c-2,1.6-3.1,3.4-3.2,5.5l-1.3.5c-.4-.4-1-1-1.5-1.5,1.6-4.1,1.5-7.9,6.5-4.5Z"
          fill="#01095e"
        />
        <path
          d="M114.3,385.2c-.3,1-1.5,2-1.8,2.6s.3.7.2.8c-.3.3-1.3.4-1.4.9s2.5,2.4-.7,3.2c-.6-.1-.6-1.3-.8-1.5.8-2.1,2.3-5.4,4.5-6Z"
          fill="#040b4c"
        />
        <path d="M102.3,383.7c-.4,0-.5-.1-.5-.5.2.2.3.3.5.5Z" fill="#0008a1" />
        <path
          d="M83.3,355.7c1.9.2,4.5,4.1,4.5,6,.8,2,3.2,3,2,5l1.3-.5c-.6,3.1,1.4,2.2,1.7,2.5s-.7,1-.5,1.4,2.1,1.4,2.3,1.7-.4.4-.4.4c.4.7.3,1-.5.5h-.5c0-.1,0-.4,0-.5l-1-1c-.2-.3-.3-.8-.5-1l-1-1c-.6-.9-1.5-1.8-2-2.5-1.3-.4-2.3-2.7-2.5-4-2.1-2.3-4.5-5.5-5-8.5l-.5-.5c-.4-.1-.4-.3,0-.5l-.5-.5c-.4-.1-.4-.3,0-.5l-.5-.5c-.4-.1-.4-.3,0-.5,1.7.5,2.9,2,3.5,4.5Z"
          fill="#0215b9"
        />
        <path
          d="M94.3,372.2c1,1.4,2,2.7,3,4.2s1.7,1.3.5,1.8c-1.3-1.7-2.7-3.3-4-5v-.5l.5-.5Z"
          fill="#0219bb"
        />
        <path d="M91.8,370.2c-.5-.2-.7-.6-1-1,.7.1.7.6,1,1Z" fill="#010fad" />
        <path d="M93.3,372.2l-1-1c.2.2.6.5,1,1Z" fill="#010fad" />
        <path d="M93.8,373.2c-.1-.2-.4-.3-.5-.5h.5v.5Z" fill="#010fad" />
        <path
          d="M50.8,233.8c-.6,11.7-.6,23.2,0,34.5,1.6,4.2,2.1,9.1,1,13.5h-.7c.1,1.2-.1,2.3-.8,3-.6-.9-.9-2.7-1-3.8-.7-10.5-.6-21.6-.5-32.2-1.3-1.2-1.3-2.3,0-3.5-.4,0-.4-.3,0-.5-.5-1.7-.6-3.8,0-5.5.5-2.6.8-5.1.9-7.8.6-5.4,2-.5,1.1,2.3Z"
          fill="#02023d"
        />
        <path
          d="M53.3,304.3c-.9-.5-1.5-2.1-1.8-3-.7-2.6-.9-5.5-1.4-8.1s-2.3-6.6-1.4-10.4c1.1,7,2.8,14.8,4.5,21.5Z"
          fill="#020855"
        />
        <path
          d="M51.8,281.8c.4.1.4.3,0,.5.3,2.3.6,4.7.5,7l-2-3.5c0-.3,0-.7,0-1-.3-2.9-.2-6.1-.5-9,1.2,1.1,1.7,4.4,2,6Z"
          fill="#020230"
        />
        <path
          d="M54.3,273.8c.4.1.4.3,0,.5.3,1.1.5,2.3.5,3.5.7,3.1,1.2,6.2,1.4,9.4,1.6,4,2.8,8.1,3.6,12.4-.6.5-.8,1-.6,1.7l1.1.9c.7,4.3,2,8.4,3.8,12.4-.4.9-.4,2,.2,3.2,1.1.9,1.4,1.7,1,2.5,1.6,2.3,2.6,5,3,8,1.2.1,2.1,2.7,1,3.5.3,1.2.2,1.5-.5,1l-.5-.5c0-.1,0-.3,0-.5l-.5-.5c0-.2,0-.4,0-.5l-1-2c0-.1,0-.4,0-.5-1.5-3.8-2.8-7.7-4.5-11.5,0-.2,0-.3,0-.5l-.5-1c0-.2,0-.3,0-.5l-.5-1c-1.4-7.9-4.4-16.2-6-24.5l-.5-2c-.4-.1-.4-.3,0-.5,0-.9-.1-1.7-.5-2.5-1.6-1.3-2.3-7.3-2-9.4l1-1.1c-.5-1.7-.3-2.5.5-2.5.3.7.5,1.6.5,2.5Z"
          fill="#01045b"
        />
        <path
          d="M52.3,267.3c.9,1.8,1.2,3.9,1,6.5,0,3.2.5,7.3,1,10.5.4.8.5,1.6.5,2.5,0,.2,0,.3,0,.5v.5h-.5c0-.2-1.2-2-1.5-3s-.5-1.8-1-2.5c0-.2,0-.3,0-.5-.5-4.5-.8-9-1-13.5-.3-2.4-.3-4.7,0-7,.1-.4.3-.4.5,0,.7,1.8,1.1,3.8,1,6Z"
          fill="#1132d0"
        />
        <path d="M55.3,289.3c0-.2-.4-.7-.5-1.5s0-.3,0-.5l.5,2Z" fill="#0f33c4" />
        <path d="M61.8,314.8c-.5-.1-.4-.6-.5-1,.5.2.4.6.5,1Z" fill="#0d36c0" />
        <path d="M62.3,316.3l-.5-1c0,0,.4.2.5,1Z" fill="#0d36c0" />
        <path d="M53.8,289.8c0-.2.2-.6.5-.5,0,.2-.3.4-.5.5Z" fill="#1132d0" />
        <path
          d="M79.8,351.2v.5l.5.5c0,.1,0,.4,0,.5l.5.5c0,.1,0,.4,0,.5l.5.5c1.6,2.9,3.2,5.7,5,8.5.4.8.3,1-.5.5-3.3-4.9-6.6-9.8-9.5-15-.4-.9-.9-1.7-1.5-2.5-1.4-3.4-3-6.7-4.5-10-.4-.8-.4-1.3.5-1l1.2.2c2.2,5.1,4.8,10.7,8,15.3s.1.6-.2,1Z"
          fill="#02055b"
        />
        <path
          d="M88.8,366.7c0,.2-.5.4-.5.5-1.3-1-1.7-2.9-2.5-4l.5-.5c.8,1.2,1.7,2.9,2.5,4Z"
          fill="#020751"
        />
        <path d="M76.3,348.2h-.5c0-.9-.7-1.7-1-2.5,1.3.4,1.1,1.8,1.5,2.5Z" fill="#1841c7" />
        <path
          d="M70.8,334.7l-.5,1c0-.2-.4-.3-.5-.5l-.5-1c0-.1,0-.3,0-.5l-.5-.5c0-.2,0-.3,0-.5s.6-.6.5-1c.8,0,2.7,2.5,1.5,3Z"
          fill="#020676"
        />
        <path d="M67.8,330.7l-1-2c.2.5.7.9,1,2Z" fill="#1544cd" />
        <path d="M69.8,335.2c-.1-.3-.3-.6-.5-1l.5,1Z" fill="#1544cd" />
        <path d="M69.3,333.7s-.4.1-.5-.5l.5.5Z" fill="#1544cd" />
        <path d="M68.8,332.7c-.6,0-.4-.3-.5-.5l.5.5Z" fill="#1544cd" />
        <path d="M68.3,331.7c-.2,0-.4-.3-.5-.5.2,0,.4.3.5.5Z" fill="#1544cd" />
        <path
          d="M71.8,147.3c.6,1.6-1.2,4.7-3,5,.9.8.4,1.8-1.5,3,.9,1.4-1.3,5.4-3,5.5l-.5-1.5c-.4-.5,0-1.2.5-1.5.9-1.8,4.3-7.8,5.5-9s1.2-.7,2-1.5Z"
          fill="#010238"
        />
        <path
          d="M329.7,71.4c.3-.3.8-.3,1.5,0,1.2.5,2.8,1,4,1.5,2.5,1.2,5,2.7,7.5,4,2,1.2.7,1.9-1.1,1.8s-9.7-3.1-11.4-4.8c-.6-.6-1.2-1.1-2-1.5-.5.6-1.1.3-1-.5.6-.5,1.7-.4,2.5-.5Z"
          fill="#8192d9"
        />
        <path
          d="M233.7,58.4c12.6-.2,24.9-.5,37.5.3s5.4,1.2,7.7,1.3c4.7,0,6.1-2.6,11.4-.5s.4,1,.7,1c1.2.1,3.9-.7,5.7,0,5.4.8,10.7,2.1,16,4,2.1.6,4,1.3,6,2l1,.5c.1,0,.4,0,.5,0l2.5,1.5c-.9,0-1.8.5-2.7.5s-7.8-2.3-8.9-2.6c-1.6-.6-7.2-3.8-7.7-3.9-.9,0-.6.9-1,1-4.4,1.1-9.3-1.7-13.4-2.5s-6.8-.3-10.2-.5c-29.2-1.3-58.4-2.2-86.6,6.7l-1.8-.2c-.4-.1-.4-.3,0-.5,0-1.4.6-1.6,1.5-.5.9-1.2,2.2-1.9,4-2.1-.3-1.3.8-1.4,1.5-.4.7-1.4,2-1.5,2.5,0h.5c-.4-1.4,3.9-1.8,5.1-1.8l.9.8c0-.6.5-.8,1-1,.3-1.4.9-1.2,1.5,0l3-.5c0-.5.2-.4.5,0,1.8-.6,3.6-.9,5.5-1,3.8-.8,7.6-1.2,11.5-1,.8,0,1.7,0,2.5,0l2-.5Z"
          fill="#8790d6"
        />
        <path
          d="M312.7,64.4c-5.2-1.5-10.8-2.4-16-4s-2.7-1-4-1.5c6.8,1,13.6,2.9,20,5.5Z"
          fill="#8193dc"
        />
        <path d="M319.7,66.9l-1-.5c.5.2.8.4,1,.5Z" fill="#818dd7" />
        <path
          d="M327.2,71.9c.4.2.7.4,1,.5.9.4,1.5.9,2,1.5,2.8,1.6,3,1,5.5,1.7s2.3,2.3,6.5,2.1,1.4.8.5-.8c4,2.1,9.1,4.7,12.5,7.5.7.3,1.6.7,1.5,1.5v.5c-3.5-2.1-3.3,0-6.5-1.5-.3.5-.6.5-1.1.2-5.1-3.8-10.4-6.1-16.6-7.9l-.3-.8c-4.1-2.6-8.5-4.2-13.3-5l-.2-.5c-4.7-.9-9.2-2.7-13.5-5-.1.4-.3.4-.5,0-1.1-.5-2.3-.8-3.5-1,0,.5-.2.4-.5,0-.4-.1-.4-.3,0-.5,0,0,.3-.4.7-.4,4.3.2,6.3,2.3,10.4,3.6s10.5,2.5,15.4,4.3Z"
          fill="#7c8bda"
        />
        <path d="M357.7,85.9h-1c-.3-.7-1-1.1-1.5-1.5,1.2,0,1.7,1,2.5,1.5Z" fill="#7889dd" />
        <path
          d="M410.1,142.8c1.2-.2,1.6,0,2.4.8,1.4,1.4,4.2,5.8,5.3,7.7s2.1,7.7,3.8,4.4c.9,1.7,1.7,4,2.5,5.5v.5l-1,.5c-1.3.3-2.2-.5-2.5-2.5-1.8.6-4.7-2.7-3-4-1-.5-2.2-3.2-1-4l-1-2c-2-.4-3.5-3-4-5-1,.4-1.4,0-1-1-.4-.3-.6-.6-.5-1Z"
          fill="#0e11a8"
        />
        <path
          d="M399.1,126.4c1.3,2.1,3,4,4.5,6,1.9,1.6,3.4,3.5,4.5,5.7l.5-.2h.5c-.2,1.4,1.2,2.9-.5,3.5-.8,0-2.1-.8-1.5-1.5-1.6-2.5-3.4-4.9-5.2-7.3l.2-.7-4.1-4.6c-1.4-.6-3.8-2.8-2.9-4.4,1,1,2.8,2.8,4,3.5Z"
          fill="#2a3dca"
        />
        <path
          d="M403.6,132.3l1.8,1.5.2-1c1,1.6,2.7,3,3,5s0,1,0,1.5c-.3.3-4.5-6.3-5-7Z"
          fill="#3a49c8"
        />
        <path
          d="M332.2,77.9c.3-.6.6-.6,1-.4,6.6,2.2,12.5,4.4,17.8,9,3.1.9,5.6,2.3,8.1,4.4,3.6,3.1,7.4,6.1,11.3,8.9s6.6,3.3,8.7,6.6c-.6,1.4-2.4.3-3.5-.4-1.6-2.5-2.9-3-3.9-1.5l-1.6-1.1c-2.5-1.3-4.4-2.8-5.5-4.8-3.7-2.5-7.4-5-11-7.4v-.8c-.7.4-1.1.2-1.2-.6-1.8.6-5-1.6-5.8-3-4.9-3-9.8-5.6-15.4-7.3-.8-1.1-.4-1.6.9-1.6Z"
          fill="#6a7fdf"
        />
        <path
          d="M370.1,103.4c2.3.8,1.1,0,1.8-.5,2.2-1.3,3.2,1.6,4.5,2.5s2.1.7,2.6,1c1.3.8,2.4,1.5,3.5,2.5,1.6,1.5,3.4,3.8,5,5.5s2.8,3.2,4,4.5l-1,.6c-2.4-1.9-5-3.8-7.5-5.6-1.9.9-3-1.1-3.5-2.5l-1.1.4-8.6-7.2.2-1.2Z"
          fill="#647fe1"
        />
        <path
          d="M332.2,76.4c4.9,2,10.9,3.3,15.1,6s1.4,1.8,2.9,2.5c1,2.4,3.4,1.6,5,2.3s3.2,3,4,3.7l-12.1-6c-3.7-2.9-10.1-6-14.8-7-.7,1.1-2.6,1.4-3,0-1.1-1.2-1.8-2.4-2-3.5,1.6,0,3.3.7,5,2Z"
          fill="#7083dd"
        />
        <path
          d="M424.6,169.8c.6.8,3.3,3.8,3.4,4.1.2.5-.5,1.2-.2,1.9s2.2.9,2.6,1.5-.3,1.5-.2,2.1c.4,2.2,2.2,3.7,1.9,5.4s-.5.9-.5,1c-1.2.4-1.9-.9-1.3-1.7-1.1-1.5-2.3-3.1-3.7-4.8-.6-.3-2.5-3.4-2.7-4.2-.3-1.2-.7-3,.7-3.3-1-.5-1.2-1.7,0-2Z"
          fill="#0105a7"
        />
        <path
          d="M420.1,162.8c2.2-.3,3.2,2.6,3.5,4.5.6.8.7,2.1,1,2.5,0,.7,0,1.3,0,2-1.4,1.6-2.5.2-2-1.6,0,.7-.2.6-.5-.4-1.6-.3-2.3-1.2-2.1-2.6-1.3-2-3.7-6.1,0-4.4Z"
          fill="#0206af"
        />
        <path
          d="M420.6,159.8c.8.7,2.1,1.7,2.5,2.5.6,1.3.8,3.6.5,5-.9-1.3-2.4-3-3.5-4.5-.7-1.4-.6-2.4.5-3Z"
          fill="#0206a2"
        />
        <path
          d="M391.6,118.9c.5.5,1.1,1,1.5,1.5.7.7,1.3,1.9,2,2.5l7,9-1.1.2-3.5-3.5-.9.3c3,3.9-2.5,3.7-1.5.5-.3-.8-.9-1.7-1.8-2.6l-7.6-6.5c-.3-.4-.4-.9-.1-1.4.9-1,.1-2.2-2.4-3.6v-1.4c0,0,8.4,5,8.4,5Z"
          fill="#102fd0"
        />
        <path
          d="M440.1,275.3c.9-.5,1.8-.2,2.5.5-.5,4.7-1.2,9.6-2,13.5-.9,1.5-1.1,1.1-.5,3,.7,4.2-.7,8.8-2,12.5-1.9.3-.7,1.1-1,3l-2-.8.5,1.3c-3.2-.7,0,2.7-1.8,3.5s.4-3.5-1.7-3c-.4-.1-.4-.3,0-.5l-.5-.6c.9-.8,1.2-1.4.5-2.5,1.3-3,2.4-6,3.5-9-.7-.6-.7-1.5.1-2.6-.4-2.8,0-4.9,1.2-7.6-.4-2.6.2-4,1.7-4.3-2.1.2-1.2-5.2-.5-5.9s1.4-.6,1.9-.6Z"
          fill="#0107ac"
        />
        <path
          d="M440.6,289.3c-.3-1.2-1.3-2.7.5-2.5.2-1-1.2,0-1-1,1.9.2.7-1.7.7-2.8s1.1-1.9-.7-2.4c.3-.8,1.9-.7,2-.8.2-.2-.5-1.3-.5-1.8s.5-1.6.5-1.7-.8.3-2-1c-1.4.2-2.3-1.2-.5-2.1l-.6-.7c1-3.3,1.2-6.8.6-10.4l.8-1.5c-.9-.8,0-3.5,1.2-3.8,1.5-2.6,1.2-4.9.8-8,.5-1.9,1-2.4,1.7-1.4-.2,11.2-.4,22.9-1.7,34.3s-.8,5.9-1.8,7.6Z"
          fill="#0004a6"
        />
        <path
          d="M440.1,218.8c.8-.1,1,.8.6,2.7l.4.8c0,0,.8.8,1,1-.2,2.4-.4,4.9-.3,7.4s.3.6.3.6l.4,2.8c.8.8,1.3,1.7.6,2.7,0,.2,0,.3,0,.5l-.3,1.3c.7,2.7,1.2,5.4,1.3,8.2,0,.2,0,.3,0,.5-1.4.7-.7.6-.7,1.4,0,2.5,1.3,7.3-1.8,8.1-1.2,0-1.6-.9-.7-2-.3-.9-.2-1.9.2-3-1.4-.2-1.4-1-.2-2.3-.3-2-.7-4.1-1.2-6.2-.2-1.2-.1-2.4.3-3.4-1.1-1.9-1-5.3,0-7.1.3-1.6-.2-3.1-1.4-4.6,1.5-1.3,1.9-2.1,1.2-2.5-2.4-.2-2.2-1.4-1.5-3.3-1-1.9-.6-5,1.8-3.6Z"
          fill="#0105ab"
        />
        <path
          d="M441.1,295.8c0,1-.3,2-.5,3s-1.4,5.7-1.5,6-.7,0-1,0c-.9-2.5,1.1-5.3,1.3-7.8s0-2,0-3-1.8-.2-.9-1.2,1.8,1.5,1.5-.5c.3.8,1,2.3,1,3.5Z"
          fill="#0108a0"
        />
        <path
          d="M444.1,246.8c-2.3-1.3-.9-3.5-1-5.2s-1.6-3.6,0-4.2c-.1,2.8,1.1,3.3,1.5,5.3s-.5,3.1-.5,4.2Z"
          fill="#0004a6"
        />
        <path
          d="M443.1,236.8c.6-1.5-1.5-1.9-1.5-2.3s.5-2.1.5-3.2c.3,1.1,1.4,2.9,1.5,3.8s-.5,1.6-.5,1.7Z"
          fill="#0004a6"
        />
        <path
          d="M434.6,200.8c.1,0,.3-.8.8-1,1.3-.5,2.3,3.9,2.7,5,.9,2.5,1.6,5.7,2.5,7.5-1,1.9.4,2.8.5,4.2s-.2,3.9,0,5.8c-.2-.1-.8.1-1,0s.6-1.4.5-2.3-.5-1.1-.6-1.2c-2.8-1.3-2.8-3.3-2.6-6.4-.8-1-1.2-2.1-1.3-3.3-1.8-2.9-2.4-5.7-1.7-8.3Z"
          fill="#0004a8"
        />
        <path
          d="M431.6,185.8c-.6,1.8.1.3.6,1.7s.4,4.3.4,5.3c-2.1.9-3.1-2.7-3.4-4.5-1.4-1.5-2.3-3.7-1.7-5.7-1.2-.8-2.4-2.2-.9-3.3,3.2.6,3.8,3.9,5,6.5Z"
          fill="#0106b2"
        />
        <path
          d="M433.1,193.3c1,.8,2.3.2,1.5,3.2s-1.6,0-.5,1.3c-2,1.8-1.9-1-1-2.6-.2-.7-.2-1.3,0-1.9Z"
          fill="#0004a8"
        />
        <path
          d="M433.1,193.3l1,2.2c-.3.4-1.7,1.5-1.5,1.7s1,.3,1.5.5.4,0,.5,0l.4.8c-1.1.4-1.5.7-1.9,1.7-2.3,2-2.8-3.6-1.3-4.7-.4-1.4,0-2.3.8-2.7.2.2.3.4.5.5Z"
          fill="#0106b4"
        />
        <path
          d="M368.6,400.7c1.7-1.1,2.7,0,3,3.6,1.4.8,1.6,2.1.5,3.9-.3.4-.5.8-1,1l-1.3.7c-1.3,2.4-9,2.5-9.4-.7s.3-2.5,1.2-3c.5-.4,1.2-1.4,2-2,1.6-1.2,3.3-2.4,5-3.5Z"
          fill="#060309"
        />
        <path
          d="M361.6,406.2c-1.5,1.7,1.7.4,1,1.7s-1.6.7-1.5,1,2.7,1.9,3,2c.8.2,3.7-.8,4.2-1.7v1.5c1.5-.9.2-3.2,2.7-1.5v.5c-1.5,1.2-2.9,2.4-4.5,3.5-2.2,1.5-4.3,1.7-6.7.5s-2.4-4.8-.3-6.5c.5-.4,1.5-.6,2-1Z"
          fill="#070610"
        />
        <path
          d="M372.1,408.2l.5-2.5c-2.2.4-2.2-2.2-2.5-3.8s.6-1.4-1.5-1.2c.3-.2.2-1.1,1.7-1s3.2,1,3.4,1.1c2.9,1.5.1,4-.7,5.5s-.1.7-.9,1.9Z"
          fill="#070610"
        />
        <path
          d="M413.6,331.7c1,0,1.3-.5.8-1.4l.6-.5c2,.5,3.4.3,3.9-2,1.6-2,3.6.8,2.7,2s-.8-1.1.4,0c.9-1,1.3-.7,1.5.5-1.2,1.1-1.3,1.7.5,2-.9.8-.7,1.8-1,2.5-3.2.8-1.3.9-2,2.5.7.7.4,1-.5.5-1.1,2.3-2.2,5.2-4,7l-.8-.6c-.4,2.3-1.4,5.1-3.2,6.6,0-1.2.6-1.3,1.5-.5-.4.7-.8,1.2-1.5,1.5-1.3-.2-1.2-.4,0-1,0,.7-.4,1-1.3,1.1-.7,3.3-3.4,4.7-5.4,1.4l-1.8.8c-1.4,2.7-4.5,0-2-1.4,1-1.1,1-2.5,0-4.2.3-1.2.2-2.3-.1-3.3s.1-1.8,1.2-2.2.7.3.9.6c1.5.9,3,1.7,4.5,2.5,1.5,2.3.8,3.8-2,4.5.8,1,1.2,1.2,1,.5-.8-.5-.2-1.2,1.9-2l-.5-2.4c2-.7,2.2-1.6.5-2.7-2.1-.7-2.7-1-1.3-3-.8-.3-.7-1,.2-2.3l-.2-.2c1,1.1-.7,2.9-1.7,1.4s.9-3.4,1.7-1.4c-1.9-.9.5-3,2-2,.2-1.3,1-2.4,2.3-3.3-1.8-2.8.3-4.7,1.2-1.7Z"
          fill="#010ec1"
        />
        <path
          d="M404.1,343.7c0-1.4.7-1.3,1,0,.2-.2.4-.4.6-.4s3.6,2.1,3.4,2.4c.6.7.4.9-.5.5-.2,0-.8-.2-1.1,0-.6.3,0,1.4-1.3,1v-2c-3.4,1-1.9-.2-2-1.5-.5,0-1.3.7-2,.5,1.2,1.2,2.7,1.8.5,2.7.7,1.9,2.7,6.1-.5,5.7.1.4-.3,2.4,1,1.5s-.1-.5.4-.9.9,0,1.3-.6.2-2.4,1.2-1.5.5,1.8,1.2,2.3c2.5,2.2,2.9-2.3,3.4-2.8s1.4,0,1.9,0c0,.3,0,.7,0,1s-2.5,5.3-2.8,5.5c-.4.5-.7.4-1.2.5-1.7.2-2.6-1.2-2.7,2l-1.2-2c-1.1-.1,0-2.1.1-2,.7,2.5-3.5,2.1-4.1.5.1-.2.6-.9.5-1s-1-.3-1.5-.5c-1-.4-1.2-1.1,0-1-.1-2.5.9-2.9,2.5-1-1-.4-1.9-1.1-2.7-2-.9.2-1.3-1.3-.3-1.6s2.3-2,1.3-3.3c-1.2.4-2.4-1.1-1.8-2.1-.4-.2-.4-.3,0-.5.4-.9,1.4-1.1,2.9-.7,1.3-2.5,4.1-1,2.6,1.2Z"
          fill="#0115c7"
        />
        <path
          d="M416.6,344.7c-.5,1.7-1.6,4-2.5,5.5-.5.3-1,.4-1.5.5,0-.5-.2-1.1,0-1.7s1-.3,1-.6-1.2-1.6-1-1.8,1.8.9,2-.5l-1.5-.3,2-1.3-1.5-1.5c1.5.2,2.4-.1,3.5-1,0,.9-.3,1.7-.5,2.5Z"
          fill="#0113c9"
        />
        <path
          d="M423.6,336.7c-.5,0-1,0-1.5,0-.2-.9.7-1.3,1-2,.3,0,.9-.7,1-.5l-.5,2.5Z"
          fill="#0106a3"
        />
        <path
          d="M423.1,337.7c.3.1.3.3,0,.5-1.1.4-3,1-2.5-.5,0-.2.4-.4.5-.5.9-.1,1.3-.1,2,.5Z"
          fill="#0106a3"
        />
        <path d="M424.6,338.2l-.5-.3.5-.7c0,.3,0,.7,0,1Z" fill="#0106a3" />
        <path d="M423.1,338.2v-.5c0,0,.4,0,.5.2,0,.3-.3.2-.5.2Z" fill="#0106aa" />
        <path
          d="M388.1,371.7c1.5-2.6,3.8,1.4,3.2,3.7l.3,1.3c.6.4.3.5.5,1,.7,2.1-.4,3.2-2.5,3.7s-1.2-1-2-.2c0-.1,0-.3,0-.5,0-1.3,1-3.1,1-4.7s-.3-2.4-.5-3.8c-.4-.2-.4-.3,0-.5Z"
          fill="#0110a9"
        />
        <path
          d="M408.6,328.2c0-1.3.9-1.8,2.9-1.8-1.6-2.6-.5-7,1.9-3.4l.4-.2c-2.9-3.5-.7-6.4,1.4-2.1,1.4.2,1.4.4.5,1.4h.5c1,.4,2.2,1.3,3.5,1.4s1.1-1,2-.8c0,2.8.8,1.4,2,0l2,2c.8.2.5,1,0,1.5-.7,1.1-1.2,2.3-1.5,3.5-.2.2-.3.3-.5.5-.6.3-1.4-.5-1.5-.5-1.2-3-2.9-4.1-4.9-.4-1.7,0-2.7.9-2.9,2.5l-.8-.2c-.4-.3-1.2-.9-1.5-.3.5,1.4,1,1,1.6,1.3,1.8.9-2.4,2.2-2.7,2.5s-.5,1.2-.9,1.5c-1.5-.4-1.3-1.4,0-2,.3-.5.6-.6,1-.5-.1-.9-.3-1-.5-.5.3.3.1.7-.5,1-.3,2.2-3.3,1.9-3.5-.3-1.4,0-2.2-.3-2.5-1.2-2.5-1.4-2.5-1.9,0-3.5,1.4-.2,2.4-.8,3.3-1.8l1.2.3Z"
          fill="#0110c5"
        />
        <path
          d="M425.1,328.2c-.5,2.5-.3.9-1,1.5.2-1.4-.1-2.9,1.5-3.5-.2.7-.4,1.2-.5,2Z"
          fill="#010ac1"
        />
        <path
          d="M314.7,374.7l2-.5c-.3,2.3.2,2.1,2,2.5s1.1-.2,1.4,0,0,1.5.8,1.9,0-1.9,1-.5c.2.7-.4,2.6,0,3,.8.9,2.5-.3,1.8,3l1.5-.5-.5,2c.3.2,5.4-1.3,3.8,1.4s-1.3-.2-.8,1.1l3-.5c.9,1.9.8,3.6-.5,5.5,2.8.7,1.4,3.9,0,1.5-1.7.3-5.6-.9-5.7-2.8-1.2-.3-1.6-.9-1.1-1.8-1.1-1.5-1.3-2.2-.6-3.8-3.9,1.1-5.5-.8-4.3-4.5-.8-1.2-1-2.3-.8-3.1.3-.4.3-.5,0-.5-.1.4-.3.4-.5,0-2.3-1.1-3.1-2.2-2.5-3.5Z"
          fill="#021b5a"
        />
        <path
          d="M296.7,357.7c3.3-.8,2.7,2.7,3,3s2.1-.3,2.4,0-.8.8,1,1.4c.2.9-.9,1.7-1,2-.9,0-1.9-.5-3-1.5-1.2,0-1.9-.8-.7-1.3l-.8-1.2c-2,1.4-3.8-2-1-2.5Z"
          fill="#011b65"
        />
        <path
          d="M295.7,356.7c.2,0,.5.3.5.5-.9,0-2.3,0-2.5,1-.6,1.1-1.2.9-2-.5-1.2.4-3-1.4-2-2.5l1.5-1.5c1.6.4,3.1,1.4,4.5,3Z"
          fill="#021c7a"
        />
        <path
          d="M293.7,354.7c.8-1.2,2.1-1,2,.5.2,0,.3.4.5.5l-.5,1c-3.5-.5-1.5-.6-2.5-1.7s-1.8-1.3-2-1.3c-.4,0-.4-.3,0-.5.8-1.1,3.2,0,2.5,1.5Z"
          fill="#021b6d"
        />
        <path
          d="M341.2,389.2c0,.3.8,1.4,1.2,1l.3-.5c0,0,1,.3.5,1s-1.1-.2-1,2c.5.1,1.7-.2,2,0s-1.2,1.6,1.5,1.5c-.7,1,1.5,2.4,1.8,4.3s-1.5,4.6,2.2,4.7l-2,1.5c2.4-.6,1.9.9,2,1-.4,1.4-1.1,1.4-1.5,0-1.4,1.6-2.8-.2-2.2-1.9-1.3-.7-1.9-1.6-1.8-2.8-2.1-.2-2.3-4.3-1.6-5.9-.9.2-3.3-1.1-3.6-1.8-.5-1.2.6-4.8,2.2-4Z"
          fill="#051032"
        />
        <path
          d="M349.7,405.7c.1.1.9,0,1.3.5s0,1.7.5,2.1,2.7.4,3.7.4c0,.5-.6,1-2,1.5-.1.4-.3.4-.5,0-.4.5-2.3,1.1-2.7.9s-2.7-3.6-2.7-3.9c0-.7.1-1.1.9-1.5.4,0,1,0,1.5,0Z"
          fill="#041031"
        />
        <path
          d="M357.2,408.7c-.1,1-1.7,1.8-2.5,2-.6,0-1.1-.2-1.5-.5.6-.4,1.4-1.2,2-1.5s.9-.5,1-.5c.3,0,1.1,0,1,.5Z"
          fill="#0c2158"
        />
        <path d="M316.2,371.2c-.2-.2.5-.8.5-.2s-.4.4-.5.2Z" fill="#031348" />
        <path
          d="M280.2,327.2c.8-.7,1.1-.4.5.5,0,.1-.7.4-.4.9s4.5,3.9,4.9,4.1l.8.9c0,3,.4,6,1.2,9.1l1.1-.2c1.4,2.1,2.9,4.2,4.6,6.3,1.8.5,3.1,2.3,3.9,4.4,0,0,.4,0,.5,0l.5,1.5-2,.5c-.7-.3-1.8-.4-2-.5-.3-1.1-1-1.7-1.9-1.8,0-1.4-1-2.8-2.6-4.2-.4-.1-.4-.3,0-.5-2.7-2-5.3-6.1-6-10-1.1.3-1.7-1.3-1.6-2-2-1.7-2.2-3.1-1.4-5.5-1.9,0-2.2-5.2,0-3.5Z"
          fill="#010d53"
        />
        <path
          d="M288.7,334.7c2.6,2.9.6,2.1-.5,5.5l.7-1c2.4.6.2,1.2.2,2.2,2.5.2,1.3,1.3,1,3.3,2.9-.9,3.4.7,3.8,3.3s-1.2,1.1,1,1.3l1.6,3.9c-.7-.6-.4-1.4-.5-1.5s-1.3.7-1.5.5.8-1.3-.2-2-1.8-.3-2.2-.6-4.8-6.3-5.1-6.9c-.6-2.3-.7-7,1.5-8Z"
          fill="#020a40"
        />
        <path d="M285.2,332.7c1.4.7,1.3-.4,3.5,2l-1.5,8c-1.7-3-3.3-6.5-2-10Z" fill="#020848" />
        <path
          d="M338.2,388.2c2-2,1.2-1,2.5.1s.9,0,.9,0c0,.2-.4.6-.4.8-.6.2-1.6,3.3-1.5,3.5s2.2,1.4,2.3,1.4c.5,0,1.5-.6,1.7-.4s-.8,1.9,1,3c-.7-.1-1.7-.7-2,.3s1,0,1,.5-.8,1.9-.5,2.2,1.7.2,1.9.6-.1,1.3.2,1.8,1.2.4,1.5,1.3-1.1,1.9,1.3,2.4c0,2.2.7,2.7,3,3l-1,.5c0,1.9,1.2,1.1,2.5,1,1.3,1.1-1.4,2.4-2.5,1.5-1.4.8-2.7.8-4-.2s-2.3-3.4-2.6-3.9,0-.5,0-.8c-1.9-.1-2.9-.6-1.3-2.7,0-.6-1.6-5.4-2.6-5.2l-1.4-2.3v-.5c.3-2-1.2-5.6-1-7.2s.7-.6,1-.8Z"
          fill="#041139"
        />
        <path
          d="M387.6,370.7l.5.5c.4.1.4.3,0,.5,0,.2,0,.3,0,.5-.5.1-.5.6-.5,1-.1.4-.3.4-.5,0-.6,0-.7-.6-.5-1.5-.4-.1-.4-.3,0-.5l-.5-1c-.4-.1-.4-.3,0-.5l-.5-1c-.3,0-.5,0-.7-.1s-1.6-5.2-1.7-5.9c-.6-1.1-.6-1.6,0-1.5-.4-1-.4-1.1.5-.5l1.1,1c1.6,2.7,2.7,5.9,2.9,9Z"
          fill="#092192"
        />
        <path
          d="M386.6,374.2c.3.6.5,1.4.5,2.5-.2.9-.2,1.5-.5,2.5l-.5-1c-.8-.7-.7-2.6,0-3.5-.6-.5-.8-.7,0-1,.7-.7.9-.4.5.5Z"
          fill="#2586da"
        />
        <path
          d="M387.1,376.7c-.8-.4-.4-1.7-.5-2.5-.3-.4,0-1,.5-1h.5c-.1,1.3-.3,2.2-.5,3.5Z"
          fill="#49b0ec"
        />
        <path
          d="M359.6,407.2c-1.9,3.5,0,3,0,3.2s-.5.9-.5,1.4c0,1.1,2.6,1.2,3.5.8l-.2,1,4.2-.5c-.6.4-1.1.9-1.5,1.5-.6.4-1.5.6-2,1-1.7,1.7-4.9,2.6-5.5-.3-3.2-3.1-3.9-4.2,0-6.7.6-.5,1.4-1,2-1.5Z"
          fill="#070716"
        />
        <path
          d="M292.7,335.7c.2-.4.3-.4.5,0,3.6,1.6,7.1,3.4,9.5,6.5l1-.2c5.1,3.9,10.4,7.5,15.9,11v1.2c6.6,2.8,12.7,6.8,17.5,12,6.1,2.3,12.2,6.6,16.5,11.5,1.8-.5,5.2,2.1,5,4,.6,0,.9.2,1,.5,1.1.3,2.1,1,3,2,.1-.4.3-.4.5,0,.7-.6,1-.3.5.5,2.3,1.1,4.6,2.1,6.9,3.2,2.7.5,5.3.6,8.1.3.2-.5.8-.6,1,0l1.5-1c-.4-.7.8-1.6,1.5-1.5.4-1.3,1.4-2.7,2.5-3.5-.2-.6.3-1.4,1-1,.7-.5.9-.2.5,1,.7.7.5,1.1-.5,1,.8,1.2,0,2.7-1.5,2.5.3.8.3,1.4-.1,1.8,1.4.9,3.2,2.3,1.7,3.8,1.6,1.2,2.4,2.3,2.5,3.4-.4.4-.6,1.1-1,1.5-.3.2-.7.3-1,.5-2.3-.2-3.9-2.3-4.6-6.3l-1.9-1.2-.8,1.1c.6,1.7-1.1,1.8-2.2.9l.4,1c-1.6,1.4-3.1,2.9-4.4,4.5.8.5.2,2.1-.5,2.1s-3.4,0-4-.6l-.5.5c.1.3.2.5.1.7-.1.8-4.6,4.4-5.6,4.2,0,1.3-1.8,2.5-3,1.5-.4.7-1.1,1.2-2,1.5,1,1-.5,1.8-1.5,1-3.4,1.4-6.5-3.3-6-6.6-2.2-.3-2.5-.9-2.2-3.3-1-1.6-1.8-3.4-1.9-5.3-1.4.5-3.3-.7-2.2-2-1.5-4.1-1.9-5.2-6.6-5.3,1.5,1,1.9,2,1,3-1.9,2.2-4.4,1.2-5.9-1-1.1.5-2.9-.4-2.1-1.5-.6-1.1.3-1.5.2-.8-.4,1.5-1.6-.9.3-1.7,1.6-.5-.3-.4-1.5.1-.3-2-1.2-3.6-2.7-4.8l-.2-1.7c-3.3-1.7-6.3-4.3-8.6-7.1-.5,1-3.2-1.6-4-2.5-1.2,1.3-3.3-.7-2-2l-.5-.5c-1.1,1-3.1-.9-2.5-2-1.5-1.9-2.8-3.2-5-4-1.1-1.7-2.5-3.2-4-4.5-3.2-2.5-5-4.2-4.6-8.6.6-1.6-.8-2.3-4.3-2.2l.2-1.3c-1.1-.8-.5-3.4.7-4.2-1-1.6-1.2-3.1,1.1-2.2Z"
          fill="url(#c)"
        />
        <path
          d="M384.6,385.7c1.4-.2,3,1.7,2.5,3,0,1.1.6,3.6,1.8,3.9s1.4-1.1,1.2.6c0,0,0,.4,0,.5-.4.4-1.2.6-1.5,1-.9-.6-3.3-2.3-3.5-3.3s1.2-1.4,1-1.7-2.3-1.9-2.5-1c-.7-1.8.7-2.4,1-3Z"
          fill="#01075b"
        />
        <path
          d="M380.1,389.2c3.6-1.4,3.2,3.7,4.5,5.7s1.8.8,2,1.8c-.6.4-2.1,1.6-2.5,2-2.3-1.1-1.2-2.9-1.5-4.6s-4-3.4-2.5-4.8Z"
          fill="#040b3c"
        />
        <path
          d="M337.2,385.2c0-.3.7-1.4.5-2,.9-.2.3.9.6,1.4.9,1.4,4.3,0,4.4.1s-.2,1.1,0,1.6c.3.8.5,1.3.8,2.3s1.2.5,1.2.9c0,.6-1.1,1.8.3,2.2s1.3-.7,1.9,0,0,3.8,1.3,5.2,3,.5,1.5,2.1-2.3-.5-1,.7,2.3.3,2.5.5-.4,2.6.5,4.1,1.3.2,1.5.3c1.2.9-1.3.9-1,1.5,2.1-.4,2.2,1.8,4,1.5.4.1.4.3,0,.5.2.8-.4,1.2-1,.5-3.4,1.8-4.7.2-5.5-3-.5-.4-1.3-.6-2.1-.6-.8-2.1-1.2-4.2-1-6.2-.7-2-2.1-4.3-3.5-5.3-2.7-.7-2.1-2.5-.3-3.9h-.6c-.6-2.1-1.6-3.6-4-3l-1-1.5Z"
          fill="#070e2a"
        />
        <path
          d="M281.2,327.7l.5.5c.2-.4.3-.4.5,0l1,1c.2-.4.3-.4.5,0l1,1c1.7-.3,6.3,2.9,7.8,4.3v1.2c-1.8-.3.3,1.4.2,2.7s-1,.3-1.3,1.3-.2,2-.2,3.1c2-.6,3.6.7,6,0-2.4,2.6.1,5.6-1.5,8l1.9-.5,2.1,4c-.9,1-1.7.7-2.5-1-.1.4-.3.4-.5,0-.8-1.1-1.4-2.2-2-3.5l-1.5-.3c.1-3-1-4.4-3.5-4.3,0-1.7-.3-3-1.3-3.9.8-1,.6-1.3-.5-.9,1-1.9,1.3-3.8.8-5.6-1,.4-3.6-.8-3.5-2-1.4,1.8-6.4-4.1-5.1-5.2s.4,0,.6.2c.1-.4.3-.4.5,0Z"
          fill="#030838"
        />
        <path
          d="M317.7,369.7l2.7,1.6c1.3,1.2,2.2,1.9,3.1,2.9,1.4,1.4,3.8,1.8,3.9,2,.3.4-.3,1.1-.2,1.6.4,1.2,2.2,2.8,2.3,3,.3.7,0,1.7.1,1.9s3.4-.9,2.3,1c-.3-.3-.8-.5-1.3-.5-2,0-.8,1.5-2,2,0-2.9-2.3-2.4-3.5-4.7l2.5.7c.1-3.4-4.5-1-3.8-3.5l1.3-.3c-1.1-.3-1.9-2.3-2.5-2.5s-1.1.3-1.4.1c-1-.6-2.7-3.8-3.6-4.4-.8-.5-1-.8,0-1Z"
          fill="#03113f"
        />
        <path
          d="M299.7,354.2c.8.3,1.4.8,2.5.5l-.5,1.5c1.9-1.7,2.3,2,3,2.5s.9-.6,1.4-.4,2.1,3.4,2.3,3.4,1.3-1.5,2.2-1l-2,2c-2.4-1.8-4.5-2.1-6.8-4.5s-1.7-3.3-3-3.5.2,2-2.7,1c-.7.7-1,.4-.5-.5-.1-.8.4-1.4,1.5-2,.9.5,1.6.7,2.5,1Z"
          fill="#040f40"
        />
        <path
          d="M313.7,367.2c1,.5,2.9.6,3,.7.8.7,0,1.5,0,1.7s.8,0,.9,0,0,.7,0,1c-.6-.4-1.8-.6-2.5-1-.7-.9-1.9-1.1-1.5-2.5Z"
          fill="#031348"
        />
        <path
          d="M363.6,404.2c.4,1.4-.6,2.7-2,2-.3,1.7-1,2-2,1,.6-1.1,1.9-1.7,0-1.5-.3-.1-.3-.3,0-.5,1.2-.6,1.7-.6,3-1.5l1,.5Z"
          fill="#0c0c25"
        />
        <path d="M359.6,405.7c-.4.9-1.5.7-2,1,.6-.6,1.3-1.1,2-1.5v.5Z" fill="#07091b" />
        <path d="M379.6,388.2l1.5-1c-.7.5-.4.5-1.5,1Z" fill="#060732" />
        <path d="M311.7,365.2l-.5-.5c.2.2.3.4.5.5Z" fill="#031348" />
        <path d="M325.9,374.7c.3.2.3.3,0,.5v-.5Z" fill="#050e30" />
        <path d="M368.1,398.7c.2-.1.3-.3.5-.5l-.5.5Z" fill="#08070b" />
        <path
          d="M308.7,343.7c2.7.8,5.3,2.8,7,5,3.3.5,7,3.5,8.5,6.5l-.8.6c-1.4-.8-2.6-1.3-3.7-1.6-2.1-1.4-17-11-17-12-2.3-1.6-2.7-2.6-1-3,2.8-.2,5.8,2.1,7,4.5Z"
          fill="#2a7af4"
        />
        <path
          d="M339.7,364.7l.8-.2c4.2,3.2,8.5,6.5,12.7,9.7,1.8.2,3,1.3,3.5,3-.5.7-1.5.9-3,.5-5.5-3.8-11.1-7.7-16.5-11.5l-.4-1.1c-1.6-.5-3.3-1.8-1.1-2.4h.5c1.2-1,2.9.8,3.5,2Z"
          fill="#2d79f2"
        />
        <path
          d="M324.2,355.2l.9-.7c4.4,2.2,7.5,5,10.6,8.2.1.2-.2,1.2,0,1.4s4.3.1,1.4,2.1c-5.8-4-11.7-7.9-17.5-12l.2-.4c1.3.8,3,.9,4.3,1.4Z"
          fill="#2f7af5"
        />
        <path
          d="M363.6,384.7l.2-.8c1.2.4,2.4.8,3.8,1.3,0-.5.3-.5,1,0,.4-1.1,2.3-.9,2.5.5,1.2.6,3.2.8,6,.5,0-.4.6-.9.9-.8,2.9,1.4-1.9,2.6-3.5,2.6-.2,0,4.4-1.2,4.1-.4.4.1.4.3,0,.5-5.3,1.7-11,.6-15-3.5Z"
          fill="#3678e2"
        />
        <path
          d="M356.7,377.2c1.3-.8,1.8.3,2,1.5.2-.4.3-.4.5,0l1,1c.4-.2.6,0,.5.5,1.2.8,3.7,2.7,2.5,4h-.5l-3-2.5c0,.3-.4.3-1,0-1.6-1.1-3.3-2.8-5-4,.5-1.5,1.8-.6,3-.5Z"
          fill="#377ff1"
        />
        <path
          d="M297.7,336.7c1.4.6,2.7,1.1,4.1,1.4v1.1c-.8,2.6,1.4,2.1,1.4,2.2s-.5.6-.5.8c-3.4-1.7-6.5-4.1-9.5-6.5,1.6.7,3.5.6,4.5,1Z"
          fill="#356ff3"
        />
        <path
          d="M382.6,385.7c-.5.5-.9,1-1.5,1.5l-1.5,1c-.2,0-.7,0-1,0v-.5c-.5-1.5.7-1.6,2-1.5-.5-1.3.3-1.8,1.5-1l.5.5Z"
          fill="#3e74d0"
        />
        <path
          d="M385.1,382.2c-1,1.6-1.2,2.1-2.5,3.5l-.5-.5c-.5-.8,1.5-2.6,2.5-3,.1-.4.3-.4.5,0Z"
          fill="#477dd0"
        />
        <path
          d="M362.6,384.2c-1-.7-2-1.3-3-2-.3-.1-.3-.3,0-.5,1,.4,2.5,1.5,3,2.5Z"
          fill="#3177eb"
        />
        <path d="M359.6,381.7v.5c-.1-.1-.6-.2-1-.5.3,0,.8,0,1,0Z" fill="#07091b" />
        <path d="M382.6,385.7l-.5-.5.5.5Z" fill="#4890e9" />
        <path
          d="M429.1,298.8c.6,1.5,2.2,1.9,4,1.4,1,1.4.2,3.2-1.4,3.9,1,.9,1.1,2.3.4,4.3,0,.2,0,.3,0,.5-.2.9-.3,1.7-.5,2.5l-2-1v2s-3,0-3,0c-.1-.1-.9.1-1,0-.2-.2,1-.9,1-1.7s-2.1-2.4-2.5-.3c-.2,1-2.8-2-2.9-2.3-.2-1.4.4-2.2,1.8-2.1-.3-1.7-.3-3.1.3-4.3-2.4-2.1,0-3.2,2.3-1.9.1-1.1,1.3-1.4,3.5-.9Z"
          fill="#010ebf"
        />
        <path
          d="M437.1,307.8c-.2,1.2-3.3,11.3-3.8,12.4s-.6.7-1.1.6c3.4,2-.2,3.4-1.5,5.7,0,.2,1.4.3,1,1.2-.8,2.1-1.3,5.2-2.5,7s-.3.3-.5.5c0-.5.2-.9.5-1.3-1.2-1-.8.5-1.2,1.1s-1.9,2-2.2.5c-.4-2.3,2.9-4.5,1.8-7.3l1,.5c1.1-2.3-.6-.7-.5-2.5l1.5.5c-.7-1.7.8-1.9.9-2.3.8-2.2.7-5.7,1.1-7.4s1.6-.8,1.8-1.6c.8-2.4-1.1-1.1-1.9-2.7-1.3-.4-1.4-1.1,0-1.5-1.2-1.1-1-2,.5-2.5,2.9-2.9,4.6-3.2,5-1Z"
          fill="#0106a3"
        />
        <path d="M429.6,329.2l-.2,1.5c-.5-.5-.9-.8-.7-1.5h1Z" fill="#0106aa" />
        <path
          d="M331.2,440.2c.2.2.2.3,0,.5-.2.1-.8-.1-1,0-.3.6-.8,1.1-1.5,1.5-.1,0-.4,0-.5,0l-.5-.5c1.4-.6,1.4-1.1,3.5-1.5Z"
          fill="#01165d"
        />
        <path d="M331.2,440.7v-.5c.2,0,.3,0,.5,0,0,0,0,.3-.5.5Z" fill="#031965" />
        <path d="M330.2,440.7c.3,1.2-.7,1.1-1.5,1.5.3-.7.8-1.1,1.5-1.5Z" fill="#031965" />
        <path
          d="M314.2,441.7c-.2,0-.4,0-.5,0l-.5.5c-.2,0-.3,0-.5,0-1,.3-1.6.3-2.5,1-.5,0-1.3-.2-1.5.5-.2,0-.4,0-.5,0l-1,.5c-1.6.5-3,.7-4.5,1l-1,.5c-.2,0-.3,0-.5,0-.3.3-.7.3-1,0l-.5.5c-.3,0-.7,0-1,0-.4.2-.7.4-1,0-.4.4-.7.4-1,0-.3-1,1.6-1.3,2-.5l.5-.5c1-.6,2.2-.9,3.5-1,.2-1.4.5-1.5,1.5-.5,1.2-.3,2.4-.5,3.5-.5l.5-.5,1-.5c.1-.4.3-.4.5,0l3-1c1-.4,1.5-.3,1.5.5Z"
          fill="#4f90e3"
        />
        <path
          d="M298.7,446.2l-.5.5c-.1,0-.3,0-.5,0-.4-.1-.4-.3,0-.5.3,0,.7,0,1,0Z"
          fill="#3a80e1"
        />
        <path d="M301.2,445.7c-.2.5-.6.5-1,.5-.3-.2-.2-.3,0-.5.3,0,.7,0,1,0Z" fill="#3a80e1" />
        <path d="M302.7,445.2l-1,.5c0,0,.2-.3,1-.5Z" fill="#3a80e1" />
        <path d="M308.2,443.7c-.2,0-.6.4-1,.5l1-.5Z" fill="#3c73d3" />
        <path d="M300.2,446.2c-.2,0-.3,0-.5,0,0-.2.3-.5.5-.5v.5Z" fill="#4b85e6" />
        <path
          d="M292.2,450.2c-1.7.3-3.6.5-5,1.5-.2,0-.3,0-.5,0l-2,.5c-4.2.5-8.3,1.3-12.5,1.5l-4,.5c-.7,0-1.3,0-2,0-3.2,0-6.5-.4-9.5-.5.1-.4,1-.2,1.5,0,1.3-.5,2.7-.3,4,0,1.3-.1,2.6-.3,4-.5h.5l.2-.6c1.1.3,2.3.3,3.3.1,1.7-.6,3.3-.7,5-.5,2.9-1.9,7.4-2,11-2,.6-.9,2.1-1.1,2.5,0l1-.5c.2,0,.3,0,.5,0l2,.5Z"
          fill="#02021d"
        />
        <path
          d="M305.2,436.2c-.5-2.4,7.4-5.3,8.8-4.8,1,1.3,2.8,1.7,5.2,1.3l1,1c1,0,1.2.3.5,1,4.2-.9,1.5,4.1-1.5,2.5-.4-.1-.4-.3,0-.5.4-.7-.1-.6-.9-.3v-.7c-.6-.1-.6-.3-.1-.5l-.5-.5c0,1.9-3,2.5-3.1,0-.2-.2-5.7.3-5.9.5-.8.7-.7,5.9,2.7,3.1-.2-1.7,1.2-3.4,2.3-1.7,1.2.8,2.4,1,3.7.8l.8,1.2-1,.5c0,0,0,.4,0,.5-1.5.5-3,1-4.5,1.5l-3,1c-.2,0-.3,0-.5,0-1.6.8-3.3,1.2-5,1.5-.5.2-1,.3-1.5.5-.8.3-1.5.3-2,0-2.1.4-3.1-.8-1-1.8v-1.3c1.5-.7,2.7-1.7,3.6-2.9-.5-1.8.4-3.2,1.9-2Z"
          fill="#010f74"
        />
        <path
          d="M320.7,434.7c-.5-1.9,1.9-2.5,2.9-1,5.5-1.5,3.8,1.9-.4,2.7s1.1-.6,1,.3c.4.1.4.3,0,.5-1.1,0-2.8.7-4,1l-2,.5c-.7-.2-2.7-.5-3.2-.5s-.6,1.7-1.8,1,1.7-1.6.5-2.5c.2-1.4,1.4-1.1,2.2-.4.8-.3,1.6-.5,2.3-.6.1.1.9,0,1.3.5s-.2.4-.3.5q-.2-.2,0,0c0,.2,0,.4,0,.5q-.8.3,0,0c.8-.2,2.7-.5,3-1.3.3-1.1-.8-.7-1.5-1.2Z"
          fill="#011275"
        />
        <path
          d="M336.2,433.2c-.2.4-.3.4-.5,0l-.5.5c-.5.5-1.2.8-2,1-1.7.5-2.7,1.4-4,2-.2.9-2,1.1-3,1-.2,0-.3,0-.5,0s-.5-.5-1.5-.5v-.5c0-.4.3-.4.5,0l1-.5c.1-1,2.1-2.7,3-1.5.2-.4.3-.4.5,0l1-.5c.2-1.5,2.5-2.3,3.5-1l1-.5c.1-.5.3-.4.5,0,1-.6,1.6-.6,1,.5Z"
          fill="#4b8dda"
        />
        <path
          d="M317.2,439.7c-1,.7-1.8,1-3,1v.5c.3,0,.7,0,1,0v.5c-.3,0-.7,0-1,0-.2-.6-1-.5-1.5-.5,1.4-.5,2.8-1.6,4.5-1.5Z"
          fill="#3d7bdb"
        />
        <path d="M320.2,438.2l-3,1c.5-.3.5-.3,1-.5.8-.3,1.3-.3,2-.5Z" fill="#01107a" />
        <path d="M316.7,441.2c-.2,0-.3,0-.5,0,0-.6.3,0,.5,0Z" fill="#3d7bdb" />
        <path
          d="M341.2,431.2v.5c-.3.1-.7.9-1,1-2.8,1.3-4.8,1.4-7,2,.7-.3,1.3-.7,2-1l.5-.5c.1,0,.4,0,.5,0,.4-1.2,3.8-3.1,5-2Z"
          fill="#060638"
        />
        <path
          d="M329.2,436.7c2.5-.1-.6,1.2-1.9,1.4s-1-.4-1.1-.4c.9-.6,2.2-.6,3-1Z"
          fill="#06053b"
        />
        <path
          d="M294.7,446.2c1-.5,1.7-.5,2,0,.3,0,.7,0,1,0v.5c-.9,0-1.2.5-1.5.5s-.7,0-1,0l-1,.5c-.6,0-1.4-.1-2,0l-1.5.5c-.3,0-.7,0-1,0l-1,.5c0,1.1-.6,1-1,0l-1.5.5c-.3.6-1.4.4-2,0-.4.4-1.1.4-1.5,0-.8.5-1.1.3-.5-.5.5-.4,1.5-.4,2,0,.1-.2.5-.4,1-.5l8.5-2c.3-1,.7-1,1,0Z"
          fill="#4b85e6"
        />
        <path
          d="M288.7,448.7l1,1-1,.5c-.8.1-1.7-.1-2.5,0-.9,0-1.6-.1-2-.5-.4-.1-.4-.3,0-.5.6,0,1.4,0,2,0l1.5-.5c.3,0,.7,0,1,0Z"
          fill="#0f148d"
        />
        <path d="M296.2,447.2l1.5.2-1.5.2c0-.2,0-.3,0-.5Z" fill="#03015e" />
        <path d="M292.2,447.7l-1.5.5c.1,0,.7-.4,1.5-.5Z" fill="#3d79de" />
        <path d="M293.2,448.7v.5h-.5c-.4.3-.8.4-1,0,.7-.6.9-.3,1.5-.5Z" fill="#0a1e91" />
        <path d="M292.7,449.2c-.2.7-1,.5-1.5.5.2-.2.3-.4.5-.5h1Z" fill="#01074c" />
        <path d="M289.7,448.2c-.1.5-.6.4-1,.5,0-.7.6-.4,1-.5Z" fill="#3d79de" />
        <path d="M295.2,447.2c-.1,0-.5.4-1,.5l1-.5Z" fill="#0d157e" />
        <path d="M315.2,441.7c.7,0,1.2-.2,1,.5-.4.2-.9-.5-1-.5Z" fill="#01021c" />
        <path d="M313.2,442.2c0-.2.3-.4.5-.5,0,.2-.3.4-.5.5Z" fill="#3d7bdb" />
        <path d="M294.2,449.2h-.5c0-.2.3-.5.5-.5v.5Z" fill="#0a0d6d" />
        <path
          d="M345.7,427.2c1.3-.6,5.6-3.3,4-1-.1,0-.4,0-.5,0l-.5.5c-.1,0-.4,0-.5,0l-1.5,1c-1.8,1-3.6,2.5-5.5,3.5s-3.5,1.3-5,2c-.1-.5-.6-.5-1-.5,0-2.7,4.5-4,7-4,.2-1.7,2.1-2.5,3.5-1.5Z"
          fill="#407bd2"
        />
        <path d="M346.7,427.7l1.5-1c-.3.2-.8.6-1.5,1Z" fill="#3262c0" />
        <path d="M348.7,426.7l.5-.5c0,0-.2.3-.5.5Z" fill="#3262c0" />
        <path
          d="M360.1,417.7l-.5,1c-1,.5-3.2,1.4-4,2-1.6.4-3-.6-4-1.7s-.3-1.4-.6-1.7-1.7.3-1.9,0,.4-.5.4-.7c0-.4-1.7-.1-.4-1.8,0-.5.6-.9,1-1,1.3-1.9,2.8-2.9,4.5-3-.2.4-.7.7-.8,1.3-.8,3.3,3.4,5.9,6.3,5.7Z"
          fill="#040c2e"
        />
        <path
          d="M127.8,91.4c1.6.6.4,1.7-.6,2.4.7.4,1,.8,1,1.4-5,3.7-9.7,7.7-14.3,12.2,0,.3,0,.6,0,.7-1.3,1.7-3.8,4.6-5.4,5.3-1.9,2.8-4,5.1-6.5,7-.8,2.2-3.1,4.2-5,5.5-1.1,2.3-3,4.4-5,6-3.3,5.5-6.9,10.7-11,15.5-1.7,4.5-4.5,9.3-7.5,13-.5,3.2-1.8,5.7-4,7.5-.1.9-.5,1.3-1,1-1.5,5.6-5.2.2-2.3-2.8,1.4-.6,2.2-1.3,1.3-2.7-1.8.9-3.5.8-3.6-1.4.2-.3.3-.7.5-1,1.1-2.2,1.8-3.4,3-5.5l1.4-1.7c1.3,0,2.4-.7,3.1-2.3-1.3,0-1.3-.6,0-1,1.6-1.7,3.4-3.4,5.6-4.1l.9-2.9c-1.3,0-1.2-.6,0-1l.5-1.5c-.4-1.2.4-2.2,2.4-3.1l2.9-4c1,0,1.9-.9,2.6-2.5,0-2.7,2.9-5.6,5-7,2.1-1.5,3.9-3.6,5.4-6.1,1.4-.6,1.9-1.2,1.5-1.9,4.2-5.1,9.2-9.6,14.6-13.5.8-.8,1.2-.4,1.5-2,.9-1.2,2.2-2.3,3.9-3.1,1-2.2,5.5-5.8,7.9-6.8l1.2.4Z"
          fill="#000152"
        />
        <path
          d="M63.8,161.8c1.2-.3.7,1.1,1.7,1s1.8-1,2.8-1.5c-.8,1.2,1.1,3.4,1,3.5-.3.3-1.5-.7-.5,1.5-3.2-.6-3.9,3.2-1.5,4.5l1-2c0,1.8-.8,3.6-2,5.5,1.2.6,0,4-1.5,3-1.3-1.3-2.6,1.9-2.8,3.4,0,3-.6,5.4-2.2,7.2,0,1.6-.5,4.9-2.5,3.4-1.2-.5-2.5-1.4-3.4-2.3s0-5.7,2-3.9c.8-3.3,1.3-6.6,1.4-9.7,1.8-4.4,4.4-9.2,6.5-13.5Z"
          fill="#000557"
        />
        <path
          d="M52.3,210.8c.4.2.4.3,0,.5-.7,4.1-1.6,8.1-2.5,12,.6.4.5,1.1,0,1.5-1.1.4-1.5,2.2-1.8,3.4.4,3.8.1,7.4-.7,11-2.3.8-2.2,4.3.5,4.7l.4,1c.1-.4.3-.4.5,0,0,.2,0,.3,0,.5-.9.8-2.7.7-3.5,1s-.7,3.4-.5,4.3,2.2,1.4.5,2.2c.3-1.1-.9-.7-1-1.7-.4-2.9.5-7.4.3-10.5s-.8-.9-.8-1.5,1.3-.3,1.4-2.1c.3-5,.6-10.2.7-15.3s.7-1.4-.6-1.8c.9-6,2.1-14.4,4-20l.5-.5c0-.2,0-.3,0-.5l1.1.3v5.2c1.1,2.2,1.5,4.4,1.4,6.5Z"
          fill="#000564"
        />
        <path
          d="M57.3,175.3c1.4-.3,1.1.8,1,1.7-.3,3.2-1.4,6.5-1.5,9.8-1.8.5-1.4-.9-1.5-1-1.9-1.3,0,3.1-.5,3.5l2-.5c-.3.8.5,2,.5,2.5l1,1c-1.9,6.1-3.5,12.2-4.8,18.4-.4.2-.8.3-1.2.2-.3-2.5-2-3.7-2.4-6.4s.4-3.8-.1-5.6c1.4-7.1,4.7-16.7,7.5-23.5Z"
          fill="#00045c"
        />
        <path
          d="M146.3,410.7c.4.1.4.3,0,.5,1.1,2-2.4,4.6-4.6,4.7.4,1,.9,1.9,1.6,2.8.9-.6,1.2-.1,1,1.5h-.5l-.5-.5c-.4-.2-1-.2-1.5-.5s-1.5-1.7-2-2c-1.3-1-2.3-2.1-3.2-3.2,0-.2,2.6-2.8,3.6-2.5-.2-3.1,1.9-2.3,3.7-1.1s-1.7-.3-.7-1.1h.5c.4-.8,2.7.6,2.5,1.5Z"
          fill="#050a2d"
        />
        <path
          d="M151.8,414.7c3.5,1.3,2.3,4.1-1,2.5-1,1.4-2.2,2.2-3.8,2.4.7.3,1,.7.8,1.5,2-.4,6,1.4,6.5,3.5,1-1.1,1.6-.4,1.5,1,.4-.2.7-.3,1-.2,3.4,1,8.3,3.9,10.5,6.2.7.7.4,1-.5.5-2.3-1-5.4-2-7.5-3s-2-1-3-1.5c-1.5-.8-3-2.2-5-3-1.4-1.5-6.3-3-7-4.5s-1-1.4-1-1.5c-2.1-2-1.6-2.9.9-3.8,1.6.5,4-.6,4.6-2.2,1.2-.7,3.6.7,3,2Z"
          fill="#050d48"
        />
        <path d="M143.8,420.2l-.5-.5c.2,0,.4.3.5.5Z" fill="#050d48" />
        <path
          d="M143.3,409.2c.2.3,1.1,1.4,1,1.5l-3.5-.5c-.2.6,2.5,1.2,1.5,2s-4.6-.1-3.3,1.5l.8.3-2.5.2c.2.8,1.2,1,1.7,1.5s1.8,1.3.8,1.5c-.2-.2-.6-.3-1-.5l-1-.5c-.1,0-.4,0-.5,0l-.5-.5c-.1,0-.4,0-.5,0-.2-.1-.5-.7-1-1v-.5c.7.2,1,1.3,2,1-.6-1.3-3.2-1.9-2.4-3.7s5.3-2,4.4-4.8c.2-.2.3-.2.5,0,1.1-.8,3.3,1.1,3.5,2.5Z"
          fill="#070922"
        />
        <path d="M138.8,416.7l-1-.5c.2.1.6.2,1,.5Z" fill="#050a2d" />
        <path d="M137.3,416.2l-.5-.5c.2.1.3.4.5.5Z" fill="#2555a1" />
        <path d="M134.8,414.2c-.1,0-.4,0-.5,0v-.5c.2.1.3.4.5.5Z" fill="#070922" />
        <path d="M135.3,414.7c-.2-.1-.3-.4-.5-.5.2,0,.4,0,.5,0v.5Z" fill="#133b7f" />
        <path
          d="M172.3,433.7c.4-1.2.9-1.1,1.5.5.1-.4.3-.4.5,0,.6-.3.8,0,.5.5.8-1.2,1.3-.9,1.5.5.5.6.2.7-1,.5-.6-.2-1.4-.3-2-.5-.9,0-1.8-.4-2.5-1-.1,0-.4,0-.5,0l-2-1c-.7-.3-1.1-.8-1.5-1l.5-.5c.2-.3.3-.4.5-.4.6.1,4,1.8,4.5,2.4Z"
          fill="#040e63"
        />
        <path d="M173.3,435.2v.5c-.9-.4-2.1-.5-2.5-1.5.8.4,1.7.7,2.5,1Z" fill="#427fcd" />
        <path d="M170.3,434.2c-.8-.4-1.4-.7-2-1l2,1Z" fill="#427fcd" />
        <path
          d="M194.3,441.7c.6-1.5,3.3-1.1,3.5.5.8,0,1.5-.1,2.2-.5,5.6,1.3,11,2.9,16.3,4.5,3.3.4,2.3,2-1,1-1.2.2-3.4.6-3.7-.2l-6.3-1.3c-2-.5-3.9-1.3-6-1.5-1.9-.9-4-1.4-6-2,0-.5.6-.5,1-.5Z"
          fill="#030e71"
        />
        <path
          d="M215.2,447.2c.4.1.4.3,0,.5-.7.3-1.2.6-1.5,1-.1.3-.3.3-.5,0,0,.4-.3.4-.5,0-.1.4-.8.3-1,0l-1-.5c-.5,0-1,0-1.5,0-.4-.1-.4-.3,0-.5.6,0,2.5.4,2.5-.5-2.2-.2-4.3-.9-6.5-1.5,3.5,0,6.4,1.5,10,1.5Z"
          fill="#3676dd"
        />
        <path d="M208.7,447.7c.2,0,.3,0,.5,0v.5c-1-.1-.9.1-2-.5.1-.5,1-.3,1.5,0Z" fill="#09096f" />
        <path d="M208.7,447.7h-1.5c-.2-.1-.3-.3-.5-.5.6,0,1.6-.3,2,.5Z" fill="#3676dd" />
        <path
          d="M212.7,449.2c.5.6.3.8-.5.5-.3,0-1.1,0-1.5,0v-.5c.3-.4,1.5-.4,2,0Z"
          fill="#09096f"
        />
        <path d="M211.7,448.7h1c.4.1.4.3,0,.5h-2v-.5c.1-.4.6-.3,1,0Z" fill="#010243" />
        <path d="M209.2,449.2c0,0,.3-.6.7-.5l.3.3c0,.1-.5.1-.5.2h-.5Z" fill="#09096f" />
        <path d="M211.7,448.7h-1v-.5c.4,0,.9,0,1,.5Z" fill="#09096f" />
        <path
          d="M217.7,450.7c.4.1.4.3,0,.5.6.4,1.4.3,2,0,.3-.7,1.2-.7,1.5,0,.6-.7,1.2-.4,1,.5,3.1-.4,6.5-.4,9,1.5,3.1-.4,6.1-.2,9,.5-1.5,0-4,.5-6,.5s-2,0-3,0c-5.2-1.1-10.5-1.6-15.7-2.5s-.7-.5-.8-.5c.8.4,1.6-.4,2-.5.3-.4.7-.4,1,0Z"
          fill="#020211"
        />
        <path
          d="M214.7,449.2c.6-.4,1.4-.3,2,0,.2-.6.6-.5,1,0,.5,0,.9.2,1,.5-.1.6-1,.9-2.5,1-.5,0-1.1,0-1-.5-.3-.5-1.4-.2-2,0-.4,0-.7-.3-1-.5.2,0,.4-.3.5-.5v-.5c.2,0,.3,0,.5,0l1.5.5Z"
          fill="#060569"
        />
        <path
          d="M221.2,450.2c-.2.7-.6.6-1,0l-1,.5c-.3.4-1.1.3-1.5,0-.3,0-.7,0-1,0h-.5c.5-.3,2.1-.9,2.5-1,.2-.2.3-.2.5,0,.1-1,2.9-.7,2,.5Z"
          fill="#081586"
        />
        <path d="M213.2,450.2c.4-.8,1.7-.4,2.5-.5,0,.3-.5.4-.5.5-.7,0-1.3,0-2,0Z" fill="#09096f" />
        <path
          d="M139.8,387.2q-.6,0,0,0c1.4-3.5,4.8.4,5.5,2.4l-.3,1.8c1,1.4.6,2.4-.7,3.4,1.7,1.7.1,6.4-3.1,5.6-1.1,1-2.6,1.8-4.5,2.2-.9.7-3-1-3-2v-.5c1.6-1.3,3.2-2.3,5.4-2.7-.8-1,.5-3.1.6-3,.6.2-1.1.9-1.7.7s-5.5-3.7-2.8-4c-.9.2-1.5-.2-1.9-1.1-1.8,1.7-5.1-.2-2.6-1.4-.2-1,3.5-2.8,4-2,1.8-1.3,4.6-1.8,5,.5Z"
          fill="#08060e"
        />
        <path
          d="M135.3,391.2c0,.1-.2.6,0,.9.3.4,1.5.2,1.8.7.8,1.1-.9,1.9,3.1.9,1,2.2-.5,2.1-.5,2.3,0,.5.9,1.8.5,2.2s-3.2.9-4,1.3.1,2-2.5.7-1.9-1.4-2.5-2c-.8-.5-2.8-2.1-2.8-2.9s5.7-6.7,6.8-4.1Z"
          fill="#050505"
        />
        <path
          d="M130.8,388.7v1c2.5.4,1.8-.8,2-.9.8-.6,2.1,1.7,2.5,2.4-1.2-.7-5.5,3.4-5.8,4-.5,1.1,1.1,2.3,1.8,3-1.7-.5-5-3.8-5.4-5.4s0-2.5-.1-2.6-2.1.2-2.5-.8l1-.2c1.7-.6,5-1.4,6.5-.5Z"
          fill="#04030d"
        />
        <path
          d="M133.8,400.7c.9.6,2,1.4,3,2,1.2-.8,1.8-.4,1.5,1,2-.2,2.8.5,2.5,2l-1,1c-.1,0-.4,0-.5,0-2-1.5-3.9-3.4-6-5s-1-.6-1.5-1c-.5-1.6,1-.6,2,0Z"
          fill="#060f26"
        />
        <path
          d="M131.8,400.7c.7-.5,1.8.2,1.5,1,3.3,2.6,1.9,4.3-1.1,6.6-1.1,0-2.1.5-2.9,1.4-1.5-1.1-3.5-2.2-5-3.5s-1.9-1.7-2.5-2.5-1.4-1.5-1.4-1.6c-.2-.4.5-1,.4-1.3s-.8,0-1.1-.7-.4-2.8-.3-2.9,1.2,0,1.8-.5-1.7-3.2,0-3.5,8.8,6,10.7,7.5Z"
          fill="#03050c"
        />
        <path d="M122,401.7c.3.2.3.3,0,.5v-.5Z" fill="#040514" />
        <path
          d="M70.8,325.7c.7-.5,1.3-.1,1.7,1.2,1.1-.7,1.3-.5,1.9.6l.5,3.7c1.1.8,5.4,9.9,5.1,10.4s-1.1-2.4.2-2c.9-.6,1.5.2,2,2.5.5.1.4.3,0,.5q-.6.9,0,0c1.5-.2,4,3.6,2.5,4.5l-1,.3c-1.1-1.5-1.5-1.1-1.5.5,1.7,1,3.2,2.1,4.5,3.1,1.3-.6,2.2.2,1.5,1.5,1.8.7,2.3,1.5,1.5,2.5.3,0,.7.1,1,.3,1.1.6,7.5,10.6,7.5,12.7v1.1c2,1.8,2.5,3.2,1.5,4.4-2.7.8-2.3-2.9-4.5-1.5,0-.7-1.3-4.8-1.5-5s-1.3.2-1.8-.1c-.8-.4-1-3.1-1.2-3.3s-2.5-1.7-2.9-2.1c-2-1.9-3.1-3.8-4.5-6l-1.4-3.1c-2.4-2.2-3.6-4.5-3.7-7-1.5-1.2-2.5-2.4-2.2-4.5-2-.6-4.5-4-1.7-4.4q.2-.2,0,0c-1.4.4-3.1-2.5-2-3.5-.9-1.9-1.7-4.1-2.2-6.5l.7-1Z"
          fill="#0009a5"
        />
        <path
          d="M98.3,368.2h1.2c1.3,1,3.6,3.9,4.6,5.3s0,.4-.3.7c1.5.5,2,1.2,1.5,2-.6,2.1,2.5,1.8,2.5,4-.8-.5-1-1.8-1.7-1.5-1,.5,0,2.9-3.3,2,.8,1.2.3,1.3,0,2,.3-1.6-1.2-.5-1.7-1.6s.4-2.4.2-3.5-1.2-2.9-1.5-3.8c-.6-1.7-1.3-4.8-3.5-4.5l2-1Z"
          fill="#0008a1"
        />
        <path
          d="M68.3,328.2c-2.3-4.8,1.3-3.7,2.5.3,0,1.9.6,3.5,1.5,4.7.3.8,1.9,2.8,2,3.5s-.6,1.3-.4,1.9,3.2,2,3.4,2.2-.5,1-.3,2,1.8,1.8,2.1,2.5c.5,1.1-.2,1.9,0,2.5s2.7,3.3,3.3,4.6.9,2.2.9,3.3c-1.6-2.5-1.8-2.7-3.5-4.5-3-3.1-7.1-12.2-9-16.5s-1.2-2.1-1.5-3-.7-2.4-1-3.5Z"
          fill="#0112b2"
        />
        <path d="M74.3,336.7c-.2-.2.5-.8.5-.2s-.4.4-.5.2Z" fill="#0112b2" />
        <path d="M81.3,354.2c0,0-.4-.2-.5-.5l.5.5Z" fill="#0112b2" />
        <path d="M80.8,353.2c0,0-.4-.2-.5-.5l.5.5Z" fill="#0112b2" />
        <path d="M80.3,352.2c0,0-.5-.2-.5-.5l.5.5Z" fill="#0112b2" />
        <path
          d="M57.3,191.3c2.1-.7,1.1-2.9,1.8-4s1.1-.3,1.3-.8c.8-3.3-.1-5.8,2-9.3s1-.5,1.2-.9c.7-1.2.8-3.5,2.8-3.5-.8,1.4-1.1,3-1.5,4.5.3.7.5,1.4.4,2.1l-5.6,15.4c-1.8,6.5-3.6,13-5.3,19.5.2.4.4.8.4,1.2-.7,5.4-1.6,12-2.6,17.3s-.4.7-.7,1c-.1.4-.3.4-.5,0l-.5-4.5c-1.1,3.3.2,6.9-1.5,10-.5-5.7.8-11.8,2-17.5-.6-.4-.4-1.9,0-2.5l.5-1c0-2.3.4-4.6,1-7,0-.2,0-.3,0-.5.9-1.8.8-4.1,1.2-6,1-4.3,3.8-9.1,3.8-13.5Z"
          fill="#01004e"
        />
        <path
          d="M50.8,261.3c0,2.3-.1,4.7,0,7l-1-11.2c-.1-7.8.8-15.5,1-23.3h.5c.3,0,.5.1.6.3s-.2,5.5-1.1,5.5c.3,0,.5.1.5.2.2,2.9.3,8.6,0,11.4s-.2.2-.5.3c.6,3.1.6,6.4,0,9.7Z"
          fill="#0a24bd"
        />
        <path
          d="M48.8,239.3c0,1.8,0,3.7,0,5.5h-.5c-2.2-2.2-1.2-5.8-.3-8.3v-8.2c.2-1.1.6-3.3,1.8-3.5,0-.5,0-1,0-1.5.2-1,.5-1.5,1-1.5-.6,6.2-1.8,10.9-2,17.5Z"
          fill="#010552"
        />
        <path
          d="M60.3,277.3c2-3.2,3.3,1.9,1.1,3.7-.2.9.9,6.5,2.2,6.9-.6,1.7-.4,2.9.4,3.7,1.3,5.5,2.7,11.2,4.2,16.7l-.4,1.4c.5-.3,1,0,1.4,1.1.4,2.4,1.4,4.2,2.9,5.2,0,3.4.4,6.3,2.6,9.3l-.5,1c.4.1.4.3,0,.5l.5.5c1.4.4,1.5,1,.5,2,.1.8.5,1.4,1,2,1.4,0,1.7.7.5,1.5l.5,1c1.5.1,1.7.6.5,1.5l1,1c.4.1.4.3,0,.5l.5.5c1.3.3,1.3.6,0,1l.5.5c1-.1,1.2.3.5,1l-.2,2c-.5-.9-2-2.4-2.4-3.1s-.1-2.7-1.3-1.9.7,1.5-1.5.5c0-.6,2-1.5,2-1.7-.3-2.4-2.2-2.9-2.6-3.9s.3-3.2-.4-4.4l-1.5,1.5-1.5-3c-.9.2-1.4-.2-1.7-1.4-1.3.2-1.9-.6-2-2.4-2.1.3-3-4.8-1.9-5.7-.9-1.4-1.6-2.9-2-4.6.4-.8.2-1.6-.6-2.5l-.9-4.8c-2.8-2.6.1-3.1,0-2.6s-2.7-.3-2.2-1,.9.2-.2.5c-1.9-7.1-4.3-16.1-4.5-23.5l1.2.6c.5,3.3,1.6,3,3.1-1.1h1.2Z"
          fill="#0107a3"
        />
        <path
          d="M59.3,301.3c0-.5,0-1,0-1.5.9-.2.3.8.5,1,.3.2,1.2-1.4,2-1-1,2.2.3,1.3.5,1.5.5.6-.2,1.3-1,1v.5c2.1.3,1.7,4.2,2.4,6.3s1.1.7,1.1,1c0,.6-.7,1.5-.5,2.4s1,.3,1,.6c0,1-.2,1.6,0,3.2-.4.3-.7.8-1,1.5-1.8-4.8-4.8-11.4-5-16.5Z"
          fill="#010da4"
        />
        <path
          d="M64.3,317.8c-.4-1.9-.8-4,1-1.5.2,1.3-.6,2.8,1.5,3,.3.6-2.1.6-1,1.5s2.7-1,2.5,3l1.5-1.5c-.1,1.3.6,2.4,1,3.5.9,2.8.5,4.9,1.5,7.5-2.3-.4-1.2-1.9-1.7-3.5s-1.9-2.5-2.3-4c-1,0-.1,2,0,2.5-1.9-3.2-3.3-6.9-4-10.5Z"
          fill="#010eab"
        />
        <path
          d="M53.3,260.8c0,.2,0,.3,0,.5-.2.6-.2,1.2,0,2,0,.8,0,1.7,0,2.5l.5,3c0,.8,0,1.7,0,2.5-.8.4-.5,1.7-.5,2.5-.6-1.8-.7-4.3-1-6.5-.5-3.5-.7-7-.5-10.5-.8-2.4-.8-5.6,0-8,0-1.4.2-2.7.5-4l.6-.3c.5,5.4.7,10.8.4,16.3Z"
          fill="#010369"
        />
        <path d="M54.8,277.8c-.3-1.5-.3-2.2-.5-3.5h.5c1.4,0,1.4,3.2,0,3.5Z" fill="#010497" />
        <path d="M54.8,286.8c-.1-.7-.4-1.6-.5-2.5.8.4.5,1.7.5,2.5Z" fill="#0f33c4" />
        <path
          d="M55.8,213.3c.9,3.3,0,8.3-1.6,11.3l-.9,4.7c.5,2.9.3,6.9-1,9.5-.2,3.3-.4,6.6-.5,10,0,2.6,0,5.4,0,8,0,1.6-.3,3.1-.5,4.5h-.5c0-3.3,0-6.6,0-9.7v-12c0-1.2.4-4.1.5-5.7.5-6.6,1.2-13.1,3-19.5l1.2-5.9c2.1-1.7,1,3.8.3,4.9Z"
          fill="#0a26cb"
        />
        <path d="M52.3,267.3c-.2-1.8-.9-4.1-1-6s-.3-3.6.5-4.5c0,3.5.9,7,.5,10.5Z" fill="#0a24bd" />
        <path
          d="M78.8,140.8l-.5,1.5c0,.3,0,.7,0,1-.6,2.8-.9,4.1-4.1,3.7-.4,1.4-1.2,2.5-2.4,3.3,0,.3,0,.7,0,1-.8,1.7-2.8,3.9-3,1,1.8-2.8,1.7-1.3,3-5,.7-1.9,1.9-3.1,3.5-3.5.8-2,1.7-4,2.5-6,1.5-2,2.9-3.2,4.5-5,.4-.8,1.4-.6,2.2-.3.5-1,1.1-1.8,2.3-1.2-.9,1.8-3.6,6-5,7.3s-2.2.8-3,2.2Z"
          fill="#000047"
        />
        <path
          d="M100.3,113.4c.1.8-1,3.2-1.5,3.8s-1.4,1.4-2.5,1.2c-.8,2.8-2.4,4.8-4.6,6.1l-1.6,1.2c-.8,1.7-2,3-4,3.1-.3,1.8-1.5,5.1-3.4,3.2,0-.4.3-.7.5-1,.2-.2.2-.4,0-.5,1.7-2,3-4.5,4.7-6.5s2.9-1.2,1.8-3l2.5.5-1-.7c.5-1.2,3.3-2.7,4-3.5s.5-1.7.5-1.7c0,0,1.3.7,1.5.5s-.2-1,.1-1.4,2.3-.8,2.9-1.1Z"
          fill="#000032"
        />
        <path
          d="M91.8,124.4c-1.6,2.3-3.3,4.8-5,7s-1.6,1.1-1.5,2.5l-3-1c.1-.1.2-.7.5-1s1-.2,1.3-.6c.9-1.2,1-3.3,1.2-3.3.5-.3,2.5-.3,3.5-1.4s.4-2.1.5-2.1c.3-.2,1.8.1,2.5,0Z"
          fill="#00003b"
        />
        <path
          d="M77.8,137.8c1.2,1.4-.5,2-1,3,2.7.2-.1,1.2-.4,1.6s0,1.4-.4,1.9-1.7,0-2.4.4-1.1,1.8-1.9,2.5c1.4-3.9,2.9-3.5,3.9-5.1s-.4-1,0-1.8,1.9-2.2,2.2-2.6Z"
          fill="#00013b"
        />
        <path d="M83.3,130.8v-.5l.5.3c-.1.2-.4.1-.5.2Z" fill="#00003b" />
        <path
          d="M71.8,151.3c-.2.7-.4,2.9-.5,3-.2.2-3.3-.3-4,1,.6-.9.9-2.1,1.5-3,1.9,1.5,1.2-1,3-1Z"
          fill="#00014a"
        />
        <path
          d="M278.7,60.4c5.3-1.1,9.7-.7,14.6.7,3.5,1.3,6.7,1.8,10.3,1.2,5.4,2.2,10.9,4,16.4,5.6l.2-1c3.1,1.1,5.5,2.2,8.5,3.5.6.3,1,.6,1,1-.3.7-1.1.9-2.5.5-8.4-1.5-16.4-4-24.2-7.4-.9-.2-1.4-.2-2.2-.1-6.9-.8-13.7-1.9-20.5-3.5-.5.4-1.7.3-1.5-.5Z"
          fill="#818dd7"
        />
        <path d="M331.2,71.4c-.5,0-1,0-1.5,0l-1-1c.8.3,1.6.6,2.5,1Z" fill="#7c8bda" />
        <path
          d="M300.7,64.4v.5c-4.8-.2-9.9-1-14.5-2.5-.9,1.4-5.6.6-6-1v-.5c7.2.4,13.8,3,20.5,3.5Z"
          fill="#7684db"
        />
        <path d="M326.7,70.4c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#7c8bda" />
        <path d="M328.2,72.4c.9.4,2.3,0,2,1.5-.7-.4-1.7-.3-2-1.5Z" fill="#818dd7" />
        <path
          d="M300.7,64.9c.2,0,.3,0,.5,0,1.2.1,2.3.5,3.5,1,.2,0,.4,0,.5,0,4.3,2.2,8.8,4.1,13.5,5,2.2.7,5.3.9,7.5,1.8s4.4,2.4,6,3.7c-1.6-.7-3.3-1.2-5-2l-1.5.4c-4.4-1.8-8.6-3.3-13.5-2.9-3,.9-5.2-1.5-7.2-3.7-5.6-2.2-11.7-3-17.6-3.7-1.1-.4-1.9-1-1.1-2.1,4.9.8,9.6,2,14.5,2.5Z"
          fill="#7383db"
        />
        <path
          d="M415.6,149.8l1,2c.7,1.7.6,3,1,4-.3,1.1-1,1.5-1.7.5l-3.1-6.4c-1.4-1.3-3.4-3.9-1.2-5.1,1.5,1.7,2.7,2.7,4,5Z"
          fill="#0106a3"
        />
        <path
          d="M407.1,139.8c.5.5,1,1,1.5,1.5s1.1,1,1.5,1.5.3.8.5,1c-.9.7-1.9.3-3-1.3l-1,.3c-1.6.3-3.2-2.1-2.8-3.5-1.1-1.2-2.1-2.5-2.7-4-.4-.2-.4-.3,0-.5l-.5-.5v-.5c-.8-1.2-.1-2.2,1.3-1.1,2,2.2,3.7,4.6,5.2,7.1Z"
          fill="#010fba"
        />
        <path
          d="M410.6,143.8c.3.4.7.6,1,1,0,1.1-.1,2.4.4,3.4s1.3.9,1.5,1.2c.8,1.6,1.4,3.5,2.5,5.3s0,1.4,1.7,1.1c.7,2.1,1.8,2.8,3,4-.1,1,.4,2.5-.5,3-3.6,0-5.3-5.8-5.9-8.7-2.6-3.3-5-6.9-7.1-10.8-.5.1-.6,0-.5-.5l.2-2,3.8,3Z"
          fill="#0209ad"
        />
        <path d="M416.6,151.8l-1-2c.5.9.5.8,1,2Z" fill="#0209ad" />
        <path
          d="M402.1,131.8c1.9,2.2,4,5.3,5,8-2.1-2.3-4-4.8-6.2-7l-.2,1h-.5c-1.9-.9-3.1-2.6-3.5-5,0-.6-.3-1.9.7-1.5s4.1,3.7,4.8,4.5Z"
          fill="#071cbe"
        />
        <path
          d="M353.7,90.4c1.2,1.1,3.8,2.6,5.5,2.5l-.5,1c2-.2,2.3,1.2,3.3,1.9,1.6,1.1,4.7,2.1,3.7,4.1.3.2,1.8-.7,2-.5,1.1.9-1.5,1-1,1.5.9.8,2.3.5,2.8.6s.1,1.1.7,1.9c-1.2.8-2.6.4-4.4-1.2l-13.5-9.5v-1.2c.7.2,1-.4,1.4-1Z"
          fill="#607be7"
        />
        <path
          d="M319.2,75.9c8.9,2,24.9,10.6,33,15.5,4.8,2.9,13.3,10.4,18,12,1.7,2.1,7,6,9.5,8,2.8,2.7-.4,3.2-2,1-3.4-2.8-6.9-5.4-10.5-8-3.7-.8-6.9-3.9-9.5-6.5-.4.2-.7.3-1,.2-4.1-2.3-8.4-5.1-12-8.2-.7.8-1.9,0-1.5-1-8.1-3.7-16.2-7.3-24.4-10.7l-.5-.8-1-.5c0,1.1-.7,1.1-1,0-.8-.2-1.3-.6-1.5-1,0-1.7,3.3-.7,4.5,0Z"
          fill="#081ebb"
        />
        <path
          d="M383.1,113.9c1.3,1.1,2.8,2.1,3.9,3.1s.5,2.2,2.6,2.6c-.2,2.1-2.8-1.4-4-.8-1.9-.1-3.5-1.9-4.5-3.5-1.3,1-3.8-1.1-3.5-2.5v-.5c1.5,1.1,3.3,1.1,2-1,.9.8,2.1,1.3,3.5,2.5Z"
          fill="#0c2acb"
        />
        <path
          d="M422.1,169.8c0,0,.6-.1.8,0s-.2,1.8,1.7,1.9c0,.8,0,2.8.3,3.4,1.1,2.2,1.1-.1,1.7,4.1s2.3,3.4,1.5,5c.2.2,1.2-.7,1.5-.5.9.8-.9,1-1,1.3-.4,1.9,1.2,1.8,1.4,2.5.8,2.5,0,2.8,2.6,5.2,0,1.3-.4,2.7,0,4l-1.5.2c.7.8,1.9.4,1.5,1.8l-1-.3c.8,1.3-1,2.1,1.5,1.8.3.1.3.3,0,.5-.2.5-.5.9-1,1l-.8.8c-1.7-1.3-2.3-3.4-1.9-6.4-2.7-.1-2.2-2.6.3-2.1l-2-2.9c-.5-2.6-1.2-3.9-2.9-5.8,1.1-1,.7-2.2-1.2-3.6-1.5,1.3-1.9-.5-1-2-.7-1.1-.9-2.6-.5-4.5-1.6-1.6-1.8-2.9-.6-3.8-.5-1-.4-1.2.6-1.7Z"
          fill="#0109bf"
        />
        <path
          d="M407.1,143.3c3.6,4.8,5.1,6.3,7.7,12,.9,2,1.9,6.2,4.2,5l-1,1c1.1,0,1.4.8,2,1.5-.2,0-.5-.1-.6,0-1.1.9-1,2.2.6,1.5-1.2,2.5.3,1.7.7,2.6s-.3,1.8-.2,1.9c.4.3.4,0,1.5,1-.1.4-.3.4-.5,0-.3-.2-.6-.2-1,0-1.6.9-2.2-1.6-2.5-3.1-1-.8-1.5-1.5-1.4-2.2-1.8-3.4-3.3-6.8-4.6-10.1-1.7-1-2.4-2.3-2.2-3.8l-2.4-3.7.5-1c-.9-.3-1.8-.6-1-1.5-1.3-.2-1.3-.6,0-1Z"
          fill="#010bb9"
        />
        <path
          d="M391.1,125.9l3.5,3.5c.1-.4.3-.4.5,0,0,.1,1.5,2,2,1.5s-.4-1.5-.5-2l3.3,4.2c.2.2,0,.7.2.8l.5.5v.5c-.7.5-1.2,1.2-1.5,2q-.8.8,0,0c1.8-3.5,2.4,4.5.5,3.5-1.4.8-3.7.9-3.5-1.1l-1.2-1.3c.9-1.7.4-3.4-1.6-5.1,0-1.4-1-2.7-2.8-3.9-1.6-2.4-1.6-3.6,0-3.5.7-.7,1-.4.5.5Z"
          fill="#031ed0"
        />
        <path
          d="M385.6,118.9c1.6,1.3,9.8,8.4,10,9.7s-.5.7-.5.8h-.5c-1-1.3-2.2-2.2-3.5-2.9v-.6c-.2-.1-.3-.4-.5-.5-.7.2-1.2.7-1.5,1.5-.1.4-.3.4-.5,0-1.5-.3-3.3-2.1-2.5-3.5-1.5-1.9-3.5-4.1-5.9-6.7-.3-.7.2-1.1.9-1.3,1.5,1.2,3,2.3,4.5,3.5Z"
          fill="#1430d7"
        />
        <path
          d="M428.1,278.3c1.1-.2,1.2.3,1.3,1.2.9-1.5,2.4-1.6,3.6-.4,1.9-.9,2.8-.7,2.6.7,1.5.3,2.5,1,3,2-1.1,1.5-.4,3.3-.7,4.5s-1.6,3.5-1.8,4.8.7,1,1,.7-.4-1.2.5-1c.5,3.6-.8,1.8-1.3,2.5.3,1.5-.3,1.9-.7,3-.1,1.9-.6,2.7-1.5,2.5-1-.2-1.3-1.2-1-2.8-2.3.9-4,.7-5.1-.3-3.3,1.6-2.1-3.5,0-3.9.6.9.7.7.3-.7l1.2-.8c.8-1.9,2.4-.4,1.6,1.4,1.9.9,2.9.6,3-.7-2-.4-2.7-1.4-2.3-3.5-1.6-.9-1.5-3.8-.9-5.3-1.9,1.6-3.1,1.1-3.4-1.4-.2.4-.3.4-.5,0l-.5-.5c-.4-.2-.4-.3,0-.5.6-.3,1-.8,1-1.5.1-.4.3-.4.5,0Z"
          fill="#010bbc"
        />
        <path
          d="M432.1,308.3l-1.5-1c4-.2-.2-2.4-.5-4,1.6,0,2.8-.8,2.5-2.5h-2s.5,2,.5,2h-3c-.2-.9.9-.3,1.4-.6s.6-1.3,1.1-1.6c-1-.6-2.3-.2-1.5-1.7.7-1,1.4-.5,2.1.3,1.1-.8,2.1-.9,2.9-.3.9-.6,1-1.4,1.5-2.5.2,4.2-2.5,8.2-3.5,12Z"
          fill="#010bb7"
        />
        <path
          d="M441.1,251.8c.2,2.9.7,1.6,1,2s-.8.8-.9,1.4c-.2.8.4,1.5.4,1.6-.2,1.5-.9,3.7-1,5.3-.2,4,1.4,8.5-1.5,12,1,0,.9,1.1,1,1.2-.5.9-.1,2-1.5,1,.4.8-.7,4.8-.5,5s3.1,0,.5.5l-3.5-1c0-.4.4-.7.5-1-.9-1.4-.4-2.7,1.5-4-1.1-.5-.7-1.3-.2-2.2-.7-1.7-.7-2.9.6-4.3-1.1-1.5-1-2.5,0-3-.4-.2-.4-.3,0-.5,0-.9,0-1.7-.4-2.4.8-1.5.8-2.7-.1-3.6-.4-1.5-.2-2.5.6-3.1,1-1.5.3.7-1.2.3-3.5-.9,2.2-4.6,4-4.6-.6-.9-.4-1.1.5-.5Z"
          fill="#0108b7"
        />
        <path
          d="M433.1,200.8c.5.3.3,1.4,0,2,.2-.7.3-1.4.5-2,.3,0,.8,0,1,0,1,.9.3,2.4.6,3.6s1.6,2.8,2,4.5-.2,1.3-.1,1.4c.8.5,2.2-1,1,1.8l1.5.3c0,.8-2.4,1.1-1.5,2s1.4-.6,2,1.3-2.2-1.3-1.5,1,1.3,0,1.5.3-.1,1.1,0,2l-1.5,1c.5,1.7.6,3.9,0,5.5,2.6-.5,1.9.7,2.5,2.7l-1.5-.2c0,1.6,1.1.7,1.4,2.8s.6,2.6-1,2.2c-1.1.7-1.5.3-1-1-1.1,1.3-3.4.3-1.5-1,.8-.7.5-2.2-1-1.6v-1.2c-2.1-1.6-2.3-2.5-.9-2.8,0-1.3.3-2.2.8-2.8-1.4-.9-2.2-2.1-.8-3.3-1-1.2-1.5-2.1,0-3.1l.2-1.4c-1,1.4-1.8.3-2.3-.9s-.1-2-.1-2.4c-1.3-1.4-2.7-3-.2-3.9-.6-.4-1.1-1.1-.7-1.8-1.4,0-1.4-1.7,0-2-.4-.2-.2-.3.5-.5-2.1,1.3-3.5-1.1-1-1-.1-1.1,0-1.1,1-1Z"
          fill="#0106b4"
        />
        <path
          d="M434.6,197.8c2.4,1.3-.5,1.2-.9,1.6s0,1,0,1.4c-.1,1.1.4,1.2-.5,2,0,0,0-1.5,0-2s0-.3,0-.5c.3-1.3.6-1.1,1.5-1.8v-.7Z"
          fill="#0004a8"
        />
        <path
          d="M402.6,335.2c0,2.8-2.5,4-2.3.6-2.9,1.9-2.3-4.6-1.6-5.1,1.8-1.2,2.9,2.2,2.7,2.6,1.4.7,1.8,1.4,1.2,1.9v-.8c-3.1-2.2-.8-3.8,1.5-1.2,1,.1,2.6,0,3.2.5s-.9,2.4,2.8,1c0-.5.5-.9.5-1,.6-.7.8-.4.5.5-.4.5-.6.3-1,.5,0,.7,0,1.3,0,2-1.3,1.3-1.8.6-2,2-.3,0-.7,0-1,0-.1,1,0,1.1,1,1,0-.3,0-.7,0-1,.2,0,.3,0,.5,0,.2,1-.1,1.6-.5,2.5-.5.9-.8,1.7-1,2.5-.4,1-1.2.3-1.5-.5s.2.5-.5.5c-.2,0-.7,0-1,0-.1-2.1-2.3-2-1.5,0l-4-.5c-1.1-1.3.6-4.2,1.8-5.3,1.5-.2,2.1-1.1,2.2-2.7Z"
          fill="#0118cd"
        />
        <path
          d="M413.6,331.7c1.6-1.5-.9-1.7-.5-2,.9-.7,2.8-1.2,4-1l-1-1h2s-2.5-1.8-2.5-1.8l2.7-1.7c-.3,4.1.4.5,3.1.6s1.1.6,1.6,1.1c-.5,1-2.2-1.7-2.5,0s1.8,1.1,2,1.3-.3,2-.5,2.5c-.2,0-.9.7-1,.5,0-4.7-3.4-1.1.5.7-1.1,1.1-2.6,1.6-3,3.2l2,1c-.8,0-4.5,1.1-2,1.8-.9,1.2-1.7,2.3-3.2,2.8-1.9,0,.6-.9.7-1.1.2-.3-.4-1-.2-1.4s1.6-1.1,1.7-2.2l-2-.8c.3-3.1,1.2-1.4,2.5-1.8,2-.5,2.6-2.7.3-2.2s-.5,1.4-1,1.5-1.6-1.5-2.2-1,.5,1-.5,2c-.4.2-.8-.9-1-1Z"
          fill="#0108bb"
        />
        <path
          d="M408.1,341.2l-.5,1.7c1.2,1,2.3.3,3.5,1.7l-1-3,2-.5c-.2,1.5.1,2.4,1,3.5h-1.5c.8,2.5-1,1.6-1,1.7,0,.2.8,1.2-.3,1.8l-.7-1.5c0,1.7,1,3.9-1.5,3.5l-.5,1c-.4.2-.7,0-1-.5,0-1.8,2-1,2.5-1.5s-1.9-1.6-.5-3c0,0,.4-.4.5-.5-.4-.7-.6-1-1.9-1.3v-.7c-.8-1.5.7-2.2.9-2.5Z"
          fill="#010bb9"
        />
        <path
          d="M407.6,351.2c.5.4,1,.8,1.5,1.3-.9.9-2.5-.7-2.5-1.8.5,0,.7.3,1,.5Z"
          fill="#0115c7"
        />
        <path
          d="M392.1,362.2c-1-1.7-.8-4.7-.7-6.5-1.2-1.4,2-5.7,3.2-5.9.8,1.5,1.7,2.9,3.5,3.4.6.2,1.1.7,1.5,1.5,1.7-1.9,3.7,1.4,1,1.5-.4.4,2.8,1.8,3,1.9l1-.4c2-1.5,3.3-1.5,4,0v.5l-3,4c-2,3.3-4.1,5.7-6,8.5-.9,1.5-1.8.9-2-.5-.7.9-1,.9-1,0-1.2,1.2-3.7,1-2.9-1-2-.3-2.2-2.7-2.4-4.6-.9-1.3-.5-2.7.6-1.8l.2-.5Z"
          fill="#0114cb"
        />
        <path d="M405.6,362.2c.8-1.4,1.2-3.6,3-4-.3,1.5-1.9,2.9-3,4Z" fill="#0115c7" />
        <path
          d="M402,358.9c.2.2,0,.7.2.9.4.5,1.9.7.4,1.6s-2.9.7-4.2-.2l-1.8,1.5v-2.3s1,0,1,0l-1-2.7c1.2-.6,2.3,1.4,2.7,1.4s1.4-1.6,2.6-.2Z"
          fill="#010dc4"
        />
        <path
          d="M400.6,356.2l3.5.5-.5-1,2-.5c0,1-.7,1.4-1,2.5s.2,3-.7,2.5-.9-1.5-1.5-2-2.5-.6-2.3-1.7.4-.1.5-.3Z"
          fill="#010ebf"
        />
        <path
          d="M396.6,365.7c1.7,3.6-3.2,1-3-.2.9-1.3,2.5-2.9,3.5-.8l-2.5,1c2.7-.4,3-.3,3.7-3,1.9,2.4,1.3,3.3-1.7,3Z"
          fill="#0111c5"
        />
        <path d="M402.6,362.7c.5.3-1.9,1.7-2.5.2l2.5-.2Z" fill="#010dc4" />
        <path
          d="M389.6,358.2c.2-1.6,2.2-1.6,1.8.8.3,1,.6,2.1.7,3.2,0,0,.6.1.5.5l-1.5.5c4.1.9,1,1.6,1,1.8-.2,1.3.9,5.1,1.8,2.2l.5,2.5c1.1,1.4.6-.7,1-.5s.7.8,1.3,1c.3.3.6.2,1,0,0-.1-.5-.5-.4-.8s.8-.2.8-.5c.4-1.4-1.4-1.7,1.4-2.7.4.3,1.1,1.1.7,1.5s-1.7-1.3-1.5.2c2.9,1.8-.5,1.8-.5,2,0,.9.7,1.5,1.5.7-.6.9-1.5,2.9-2,4l-1.3,1c0,3-1.2,2.6-2.7,1-.1.2-.3.3-.5.5l-.5.5h-.5c-1.1,0-1.2-.2-.5-1-.9-.3-.8-.9-.4-1.7s.5-1.4.3-2.3c-.9-1.4-1.3-2.3,0-3l-1-.4c.3-2.6.2-3.5-2-5.1-.4-.1-.4-.3,0-.5-1.9-1.2-1.1-3.7.5-4.5.9,0,1,0,.5-.5-.4-.1-.4-.3,0-.5Z"
          fill="#0111c5"
        />
        <path
          d="M393.6,376.7c0-.1,0-.7,0-1l1,1.5c2.1-.4.6-3,1.7-3.5s.2,1.5,1.2,1c-.2.4-.8.8-.9,1.3-.1,1.3,1.4,3.6-.6,3.2-1.1-.9-2-1.1-2.5-2.5Z"
          fill="#0109b7"
        />
        <path d="M392.6,377.7c.1-.2.4-.3.5-.5l-.5.5Z" fill="#0110a9" />
        <path d="M397.6,370.2c0,.3-.7.9-.5,1.5l1.5.2-2.5,1.3.5-3c.3,0,.7,0,1,0Z" fill="#021bcf" />
        <path d="M391.1,363.7s.2,1.1-.2,1c-1.4-.8-.3-1.6.2-1Z" fill="#011bc3" />
        <path d="M389.6,358.7l.5.5h-1c0-.3.5-.5.5-.5Z" fill="#011cd0" />
        <path
          d="M398.1,323.7c-.2-.7-.2-1.6.1-2.8-.8-1.4-1-2.6-.6-3.5-2-4,3.5-4,2.4-.7.5.1.5.3,0,.5l.5,1c-.4-.9.3-1.2,1-.5,0,.9,0,1.3.5,1,.4.2.4.3,0,.5-.4.9,0,1.8,1,2.5,1.2-.2,2,0,2.5.5.4.1.4.3,0,.5l-1,1h-.5c.3.7.2,1.6-.5,2.5.4.1.4.3,0,.5.1.9-.4,1.3-1.6,1.5l1.6,1c.4,0,.6.2.5.5v.7c-1.5.6-1.5,1.5,0,2.2v.7c-.8,0-1.6-.6-2.5-.5.4.8,2.1,2,3,1.5.3,1.8-.9.4-2,1-.7-2-1-.8-1.9-1.6s-.5-2.2-1.6-2.4c.4,1.8.2,2.4-.5,4l3-1-.5,3c1.2-.3.5-1.5,1.5-2,1.1,2.9-1.2,1.3,0,3.5-3.1-.3-2.3,1.2-3.1,2.6s-1.2.2-.9,1.9,0,.3,0,.5l-.3.5c-3.2-.3-.2-1.1-.2-1.2-.1-.5-1-1.7-1-2.3l.4-.4c-1,.7-3.7.4-2.9-1.1-.7-.7-.3-1.5,1.2-2.6-1.1-1.1-2.5-3.7-1.2-4.9-.1-.5,0-1,.6-1-1-.4-1.4-1.8-.6-2.5-.8-.8-.8-1.1,0-1-.9-.3-.9-.9,0-1h.7c1.3,1.2,2.2.7,2.8-1.5-.6,0-.6-.4,0-1Z"
          fill="#011dd4"
        />
        <path
          d="M413.1,316.8c0,0-.7.6-.5.9s2,1.3,2.7,2.1,1.4,1.1-.2,1c-.1-.2-1.5-2-2-1.5s4,5.3.5,4.5l1,2.5c-1.5,1.1-2.3-2.5-2.3-3.5.5-.9-.7,0-.7.3,0,.8.5,2.3.8,3.1s1.5.2,1.1,1.6c-1.6-.5-3.5-.3-5,.5-2.2,1.4-2.8-.6-1.7-2.5,0-.9-.2-1.7-.8-2.4-.1.4-.3.4-.5,0v-1c0-2.6,1.2-3.6,3.5-3,.5.3.6.9,0,1,.4.7,1.2.9,1,0-1.3-.4-1.1-1.2.4-2.4-.8-4.7,3.7-5.7,2.5-1.1Z"
          fill="#0113cc"
        />
        <path
          d="M406.1,323.2c.6,0,.2.4,2-.2s-.1,1.5-.2,1.7c-.1.4,0,.8,0,1.2-.5,1.6-1.8,1.4.7,2.3-1.2.7-1.8,3.1-4.5,1.5s-.4-.1-.5-.5q.4-.6,0,0c-1,.4-2.2,3.9-1.7-.5l-1.3.7c.2-2.5,1-2.1,3-2.7,1.2-.5,2.7-1.8,1.6-2.9l.9-.6Z"
          fill="#0118d0"
        />
        <path d="M410.6,333.7c0-.4-1.3-2,1-2,0,1.1.2,1.7-.5,2.5l-.5-.5Z" fill="#010ec1" />
        <path d="M317.7,378.7c0,0,0-.4,0-.5l.2-.5c.5,0,.4,1-.2,1Z" fill="#021c63" />
        <path
          d="M308.7,375.7c.1.5,0,1.1-.4,1.2,1.7-.5,3.5-.6,3.9,1.8.1,0,.3,0,.5,0l1,.5v.5c1.5,2.4.1,3.4-4,3,.6.7.3.9-.5.5l-1-.5h-1.1c-.3-.9-.7-1.1-1.7-1.2-1.6,1.5-3.7,0-2.3-1.8-2,.7-1.8-2,.5-1.5-.4-.9-.7-2.2.5-2.5,1.6-.6,2.9-.6,4.5,0Z"
          fill="#02277b"
        />
        <path d="M309.7,376.2l-.2.5c-.5,0-.4-1,.2-1v.5Z" fill="#02277b" />
        <path
          d="M297.7,360.2c.4.1,1.4-.1,1.5,0s-.9.9,0,2.5.9,1.3,1,1.5c-2.4,1,1.2,1.8,1.5,2s.4.8.5,1c-.2,1.4-.6,2.5-2,1.5-.5,0-.6-.5-.5-1-.7.9-1,.9-1,0l-.7-1c-.8,0-3.7-.7-2.6-2.9-.9-.2-1.8-1.3-1.3-2.1,1.5-2.3,5.1,1.9,3.5-1.5Z"
          fill="#02227a"
        />
        <path
          d="M293.7,358.2c0,0-.5.1-.5.3,0,.2.9.2,1,.6.2.8-.6,1.6,0,2.7s1.6,1,3,1c.8.6-3.4,3,.3,3v-1c1.5,1.2,2.2.8,1.3,3,0,.8-1.8.7-2,0-.9,0-1.9-.9-2.5-1.5-.4-.1-.4-.3,0-.5-.8-.5-2.4-1.8-2-2.5-.4-.1-.4-.3,0-.5l.2-.7c-1.4-.7-1.4-1.8-.2-3.3-1.2.5-1.3,0-.5-1,.9.8,1.2-.2,2-.5,0,.3,0,.7,0,1Z"
          fill="#022784"
        />
        <path
          d="M296.2,357.2c.4,0,.5,0,.5.5,0,1.4-1.6,1.7,1,2.5,2,1.7,1.1,2.3-2.6,1.8l-.9-.3c-1.4,0-2-4.3-.5-3.5-.2-1.5.6-1.8,2.5-1Z"
          fill="#021b6d"
        />
        <path d="M294.9,359.7c.3.2.3.3,0,.5v-.5Z" fill="#022784" />
        <path
          d="M289.2,348.7c.4-.2,1.8-.7,2-.5-1.1,1.9.5,1.5,1,2.4.9,1.6-1.4,2.5,2.5,2.1l-1,2c-.7-.4-1-2-2.5-1.5-1.6,0-2.7-.8-3.1-2.3l-.9-.7c-1-1.7.5-2.3,2-1.5Z"
          fill="#011268"
        />
        <path
          d="M353.2,410.2c.7-.1,1.3-.6,2-.5.1,0-.4.8-.5,1-1.5,1-3,2.1-4.5,3h-.5c-.2-.2-.7-.4-1.5-.5-.2-.7.4-1.2,2-1.5.7-.4,2.1-.2,2.5-1.5.2,0,.3,0,.5,0Z"
          fill="#0d2973"
        />
        <path
          d="M338.2,396.7c2.6-.4,1.2,2.9,4,2-.6,2.1.3,4.3,1.5,6l-1.5.7c.4.9,2.8,1.7,2.9,1.8s.3,1.2.9,2.1-.2,1.6,2.7,1.3l-.5,1.3,2-.3c-.6.3-1.4,1-2,1.5.1,1-.3,1.2-1,.5-.4.2-.8.2-1,0-3.5.8-5.3-.3-5.9-4.1,1,.1.7,0-.7-.6.1-2.7,0-5.5-.5-8.2-.8.4-1.6.5-2.4.5,0-.3-.5-.8-.5-1,0-1.6,0-3.2,2-3.5Z"
          fill="#031549"
        />
        <path
          d="M331.2,387.7c.1.2-.1.9,0,1,.2.2,1.1-.5,1.4-.4s1.2,1.3,1.3,1.4c.6,1.2.6,1.2,1.2,2.1s0,1.4.1,2.1,1.9-.4,0,1.8l3,.5c.4.1.4.3,0,.5-.4,1.4-1.1,2.6-2,3.5-1.8,1.1-3.8-1.8-1.9-3.4-1.6-1.2-2.9-2.4-4.1-3.6-.7-.2-1.3-.5-2-.7.3-.8,1.5-.2,1.8-.7.5-1,.1-2.9.7-4h.5Z"
          fill="#02184d"
        />
        <path d="M332.4,390.2c.3.2.3.3,0,.5v-.5Z" fill="#041545" />
        <path
          d="M277.7,325.7c.9.4,1.8.7,2.5,1.5-1.5-.8-.4,2.3,0,3.5-.6.7-.3,1.8-1.5,1.5-.9.4-1.1-.1-.5-1.5-1-.3-1.4-1.3-1.3-3-1.6-.7-.3-4,.8-2Z"
          fill="#020d7b"
        />
        <path
          d="M277.7,325.2c0,.2,0,.5,0,.5-.2,0-.7,0-1,0-.4,1.3.6.8,1,1.4.6,1,.2,2.4.5,3.6.7,2.3-.6,2.4-1.5.5-1.4,2.9-2.6-1.4-1.6-2.4-.7-2.3-.3-3.7,1.1-4.1-.2-1.3,0-1.4,1-.5,0,.4,0,.9.5,1Z"
          fill="#0219a9"
        />
        <path
          d="M377.6,346.2c.2.4,0,1.5,1,1.5.6.4.7,1.3.5,2,.5,1.8,1.3,3.3,2,5s1.6,4,2.5,6c-.5,0-.4.2-.5.5-3.1-5.5-5.1-11.6-7.5-17.5-.2-.2-.2-.3,0-.5,1.4-1.3,3.3,1.7,2,3Z"
          fill="#0824b3"
        />
        <path
          d="M387.1,373.2c0,.4,0,.9-.5,1,0-.2-.3-.5-.5-.5-1.3-.1-1.3-.5,0-1,0-.2.5-.6.5-1,0,.4.4.6.5,1.5Z"
          fill="#76c4ed"
        />
        <path d="M386.6,371.2l-.5-1c0,0,.3.4.5,1Z" fill="#a4ddf4" />
        <path d="M386.1,369.7l-.5-1c0,.1.3.4.5,1Z" fill="#a4ddf4" />
        <path d="M213.7,452.2c1.1-1.3,1,.5,2,1-1.3-.1-1.6-.8-2-1Z" fill="#09195f" />
        <path d="M272.2,453.7c-.8.9-2.7.5-4,.5.9-.9,2.7-.4,4-.5Z" fill="#010328" />
        <path d="M286.7,451.7l-2,.5c.2,0,1-.4,2-.5Z" fill="#01074c" />
        <path
          d="M237.2,452.7c3.3-.3,6.7,0,10,.5,3.2-.4,6.3-.3,9.5,0,.4-1,2.1-.8,1.5.5h-1.5c-5.5-.1-11,0-16.5,0-2.8,0-6.2-.1-9-.5-.4-.1-.4-.3,0-.5,1.7-.5,4.1-.3,6,0Z"
          fill="#030c86"
        />
        <path
          d="M302.7,444.2c-1.5.6-1.7.7-3.5,1l-.5.5c-.6,0-1.6-.3-2,.5-.7,0-1.3,0-2,0-.5-1,.2-1.3,2-1,.6-1.4,1.9-1.7,4-1,.6-.1,1.4,0,2,0Z"
          fill="#3a80e1"
        />
        <path
          d="M309.2,442.2c-.2.4-.7.4-1,.5l-.5.5c-1,.3-2.4.4-3.5.5,1.7-.5,3.3-1,5-1.5Z"
          fill="#3c73d3"
        />
        <path d="M312.7,441.2c-1.1.4-1.9.7-3,1,.8-.8,1.9-.9,3-1Z" fill="#4083d6" />
        <path d="M307.7,443.2c.1-.2.3-.4.5-.5,0,.2-.3.4-.5.5Z" fill="#4083d6" />
        <path d="M298.7,445.7c0-.2.3-.5.5-.5,0,.2-.3.5-.5.5Z" fill="#4b85e6" />
        <path
          d="M282.7,449.7c.4-.4,1.1-.4,1.5,0,.7,0,1.4,0,2,.5-3.7.6-7.2,1.6-11,2-1.4-.1-2.7-.1-4,0-.9-.2-1.7-.3-2.5-.5-.4-.1-.4-.3,0-.5.6-.8,2.4-.8,3,0l2.5-.5c2.7-.3,5.3-.8,7.8-1.5l.7.5Z"
          fill="#070779"
        />
        <path
          d="M265.2,451.7c.5-.2,1.1-.5,1.5,0,.6.1,1.1.3,1.5.5.7,0,1.4.2,2,.5-.7.9-2.4.5-3.5.5-1.8-.4-3.3-.4-4.5,0,.4.1.4.3,0,.5-1.3,0-2.7,0-4,0-.3-.7-1-.4-1.5-.5-2.2,0-4.4-.3-6.5-.5-.4-.1-.4-.3,0-.5,4.5-1.2,10.3-1.1,15-.5Z"
          fill="#06076d"
        />
        <path
          d="M275.2,452.2c-1.8.2-3.1.6-5,.5s-1.2-.3-2-.5c.8-.5,2.1-.3,3,0,1.2-.1,3-1.2,4,0Z"
          fill="#051088"
        />
        <path
          d="M266.7,453.2c-.2,0-.3,0-.5,0-1.3.4-2.7.5-4,0-.7,0-2.9.4-3-.5,2.4.3,5.3-.6,7.5.5Z"
          fill="#030c86"
        />
        <path d="M266.2,453.2c-.8.9-2.7.5-4,.5v-.5c1.3,0,2.7,0,4,0Z" fill="#010328" />
        <path d="M289.7,449.7c-.1,0-.5.4-1,.5l1-.5Z" fill="#01074c" />
        <path
          d="M333.7,422.7c1.8,2.1.3,4.6-2.9,3.1-.3.2-1.3,3.8-1.3,4,3.4,1.9,2.1,3.6-.8,4.9-.7.3-1.6,1.1-3,1.5l-1,.5c-.2,0-.3,0-.5,0-.4,0-1.7.3-1.5-.5l4-2c-1.2-.3-2.6.7-3.7.5s-.4-2.3-2.3,0c-.5-.4-.4-.4-.5-1-.5-.1-.4-.3,0-.5-.9-.5-.3-1.1.5-1l.6-.2c-.8-2,.4-3.7,3.4-5.3.6-1.7,3.3-2.7,5-2.5l.5-.5c.1-.4.3-.4.5,0l.5-.5c.2-.4.3-.4.5,0l.5-.5c.2-.4.3-.4.5,0,.4-.3.8-.3,1,0Z"
          fill="#01116c"
        />
        <path
          d="M313.7,436.7c-2.1,0-.8,1.7-1.6,2.4s-4.7,1.5-5.9,1.6l2-2h-3c0-4.4,1.6-.9,1.7-1,1-.5,0-3.1,1.6-3.5s6-.6,6.3-.5c.8.3.8,1.2.8,2,1,.3,1.3-1,2-1l.5.5c0,0,0,.4,0,.5-1.5,2-2.9.9-4.5,1Z"
          fill="#01107a"
        />
        <path
          d="M316.2,430.2c0,1.2.9,1.6,2.6,1.1,1.3-2.9,4.3-.6,1.9.9-.1.3-.4.4-.5,1-.5.7-1.1.3-1-.5-1.7-.1-1.4.7-2.8,1.5-.4-.3.3-.8.2-.9s-4.1-1.9-4.4-1.6l.5,1.5h-1.5s-.2-1-.2-1c-.8.6-3.6,1.4-4,2-.9,1.4,1,1.8-1.7,2l.5-1c-1.3-.1-2.9.4-4-.5.5-.8,1.2-1.2,2.1-1.5,3.1-1,6.2-2.1,9.3-3s1.7-.4,2.6,0c.1-.3.3-.3.5,0Z"
          fill="#01107a"
        />
        <path d="M320.2,433.2c0,.1,0,.4,0,.5-1,.9-1.8,0-1-1,.3,0,.7.4,1,.5Z" fill="#011275" />
        <path d="M318.2,435.2l-.5-.5c.5,0,.3.4.5.5Z" fill="#011275" />
        <path d="M319.2,437.2c-.4.4-.5.7-1.5.5v-.5c.5,0,1.1,0,1.5,0Z" fill="#01107a" />
        <path d="M319.2,436.7c-.2.2-.8-.5-.2-.5s.4.4.2.5Z" fill="#01107a" />
        <path d="M325.7,436.2l-1,.5c0,0,.5-.3,1-.5Z" fill="#011275" />
        <path d="M335.2,433.7l.5-.5c-.1,0-.3.4-.5.5Z" fill="#407bd2" />
        <path
          d="M292.2,444.2c2.6-.6,2.6.9,4.5,1-.5.1-1.5.7-2,1-.3,0-.7,0-1,0-.6.3-1.1.3-1.5,0-1.1.2-2.1.2-3,0v-.5c-.2-1.5,1.9-2.5,3-1.5Z"
          fill="#03167f"
        />
        <path
          d="M293.7,446.2c-2.5,1.4-5.7,1.9-8.5,2h-.5c1.8-1.3,5-1.8,7.5-2,.5,0,1,0,1.5,0Z"
          fill="#3d79de"
        />
        <path
          d="M282.2,448.7c0,.3.2.4.5.5.4.1.4.3,0,.5-2.7.1-5.7.7-8.5,1,2.2-.8,4.5-1.5,7-2,.2-.7.6-.6,1,0Z"
          fill="#3f7be6"
        />
        <path
          d="M284.2,448.2c.4.1.4.3,0,.5-.7,0-1.3,0-2,0-.4-.1-.4-.3,0-.5.2-1.4,1.6-1.4,2,0Z"
          fill="#3d79de"
        />
        <path d="M287.7,448.7c-.3,0-.6.4-1.5.5l1.5-.5Z" fill="#3d79de" />
        <path d="M284.2,449.2v.5c-.5,0-1,0-1.5,0v-.5c.4,0,1,0,1.5,0Z" fill="#3d79de" />
        <path d="M285.2,448.2c-.1.5-.6.5-1,.5v-.5c0-.4.3-.4.5,0,.2,0,.3,0,.5,0Z" fill="#3f7be6" />
        <path
          d="M341.7,418.7l.7,1.5c-3.5.3.8,1.6,1.1,2s-.4,1.2-.3,1.7,1,.4,1.3.8-.3,1-.2,1c.5.4,2.2-1.6,2,.5-.2.1-.3.8-.5,1-1.1.5-2.4,1-3.5,1.5-1.3-.2-4.3-.7-3-2-4.5,0-2.3-.2-3.1-2.3s-1.8-.4-.9-1.2,2.1,1.4,2-.3-.9-.6-1.5-1.2c0-1.7,3.5-2.9,5-3,.1-1,.8-1,1,0Z"
          fill="#010f54"
        />
        <path
          d="M348.2,413.2c.8-.4,2.1-.8,3-1-.2.6-1,1-1.5,1.5,0,.5-.5.9-1,1-.6.4-1.2.8-1.5,1-1.7,1-3.7,2.1-5.5,3s-.8-.1-1,0c-.6.2-.9,0-.5-.5-1.2-.7-.8-1.3.5-1,.1-.4.3-.4.5,0l.5-.5c.1-1.2.3-1.7,1.1-.8,1.4-1,2.9-1.7,4.4-2.2.3-.2.7-.3,1-.5Z"
          fill="#0e3d9f"
        />
        <path
          d="M348.7,414.7h.5c.6,1.1,1.3,1.7,2.3,1.8.9,1.9,2.3,3.3,4.2,4.2-.2.1-.3.8-.5,1-.1,0-.4,0-.5,0l-1,.5c-1.1.5-3,1.4-4,2-1.5,1.1-2.8.6-3.9-1.6-3.4.7-1.3-5.1.7-5.4,0-.6,0-1.1.7-1.5-.7-1.1.5-1.7,1.5-1Z"
          fill="#030c3c"
        />
        <path
          d="M347.2,415.7c.5.6.5,1.7,0,2.2s-3.5.3-.5,1.5c-1.1.7-2.1,1.2-2,2.7l2-1.5v2c1.7-.4,1.9-1.7,3,.5-2.2-.5-2.3,2.3,0,1-1,.6-2.6,1.5-3.5,2-2.1,1-4.3-1.2-3.8-3.5-2.4-.9-2.9-2.2-.7-4,.6-1.8,3.7-3.5,5.5-3Z"
          fill="#020d47"
        />
        <path d="M354.7,421.7l-1,.5c.3-.2.6-.3,1-.5Z" fill="#1f4da8" />
        <path d="M350.2,420.7c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#020d47" />
        <path d="M349.2,414.7c-.1,0-.4,0-.5,0,.3-.3.6-.7,1-1h.5c-.2,0-.4.6-1,1Z" fill="#031549" />
        <path
          d="M357.7,408.7c0,0,.2.7-.3,1s-1.5.3-1.6.5c-.8,1.1,2.1,3.9,2.8,4.7s.1,1,.3,1.1c1.9,1.9,2.6.3,4.4-.3-.4.3-.9,1.2-1.5,1.5-.5.2-.9.4-1.5.5-3.9,2.6-10.3-3.9-5.5-7,.9-.6,1.7-1.3,2.5-2h.5Z"
          fill="#060a21"
        />
        <path d="M354.9,411.7c.3.2.3.3,0,.5v-.5Z" fill="#040c2e" />
        <path
          d="M92.3,132.3v1.6c-1.7,2.4-3.4,4.8-5.5,6.9-.5,2.4-3.4,6.2-5.5,7.5-.7.5-.9.2-.5-1,3.7-5.9,6.7-10.1,11-15.5.7-.7,1-.4.5.5Z"
          fill="#3855bd"
        />
        <path
          d="M113.3,102.9c-3.3,3.4-6.9,6-10,9.2s-6.6,9.1-9.5,11.5-1.2.6-2,.8c1-1.4,1.1-.8,1.5-1.4.6-.8,1.8-5.1,2.6-5.5s1.6,0,2.4-.3c1.1-.6-.5-1.1-.5-1.5s1.9-1.7,2.4-2.2c3-2.9,7.4-7,10.7-9.5s1.3-.9,2.2-1Z"
          fill="#00003d"
        />
        <path
          d="M81.3,148.3c.4.6,0,1.3-1,2-1.1,3.8-3.4,8.9-6.5,11.5-1.7,2.3-1.3.2-.5-1.5,2.5-4.7,4.7-8.5,7.5-13l.5,1Z"
          fill="#2f48bc"
        />
        <path
          d="M119.8,104.4c-2,1.8-4.1,3.5-6.3,5.2l.3.3c.4.1.4.3,0,.5.2.2.3.4.3.6,0,.5-6.6,6-7.3,5.4-.4-.7.1-1.7,1.5-3,1.6-2.1,3.7-4.1,5.5-6,2.3-1.4,4.3-3.3,6.5-5,.4,1,.6,1.7-.5,2Z"
          fill="#5b6fcf"
        />
        <path
          d="M71.8,150.3c.2-.8,1.3-3.7,1.7-4.1.7-.6,3.6.2,3.8,0,.3-.2.2-2.5,1-3-.1.5,0,1.2-.2,2-.6,1.7-4.3,4.9-6.3,5Z"
          fill="#00014a"
        />
        <path
          d="M73.3,160.3l-.5,2,1-.5c.8.6.4,1.2-.5,1.5,1.2.9-.2,3.4-1.5,3.5-.6,1.4-1.2,2.4-2,3-.6.6-.7.2-.5-1-.6.2-.6-.2,0-1,1.3-2.6,2.7-5,4-7.5Z"
          fill="#1d36b5"
        />
        <path
          d="M106.8,116.4c.5.7,0,1.3-1.5,2,.9,1.3-1.7,3.1-3,2.5-.7.7-1,.4-.5-.5.4-.4.6-1.3,1.2-2,1.6-1.7,3.4-3.5,5.3-5-.4.6-1.4,2.8-1.5,3Z"
          fill="#506dcc"
        />
        <path
          d="M97.3,126.4c.5,1.5-.4,2.7-2,2.5-.2,1.3-1.5,4.1-3,3.5l-.5-.5c1.6-2.1,3.3-4,5-6,.6-.4.8-.1.5.5Z"
          fill="#3448b4"
        />
        <path
          d="M102.3,120.9c.8,1.2.4,1.8-1,1.5-.8,1.6-2.1,3-4,4-.2,0-.6-.2-.5-.5,1.8-2,3.2-3.5,5-5.5l.5.5Z"
          fill="#3d58bd"
        />
        <path
          d="M69.3,168.8c-.1,1.8-1.3,5.2-3,5.5,1-1.6,1.2-3.8,2-5.5s.8-.7,1-1c0,.3,0,.8,0,1Z"
          fill="#04088a"
        />
        <path d="M78.3,142.3l.5-1.5c0,0-.5,1.3-.5,1.5Z" fill="#00014a" />
        <path
          d="M51.3,218.3l-.5,1c0,.8,0,1.7,0,2.5l-1,1.5c.3-3.1.7-4.8,1.3-7.5s.1-3.4,1.2-4.5c.2,2.9-.3,4.3-1,7Z"
          fill="#00045c"
        />
        <path
          d="M148.8,412.7l1,1.2c-.7.9-1.9,1.2-3,1.3l.5,1.5c-.5.4-3.4-2.1-4.5.3s.9.6.9,1-.5.7-.4.8c-.7-.7-2.3-.7-1.6-1.8l-.9.3c-.5-3.3,1.6-2,3-2.8s1.8-2.5,2.5-3.2c.7-1.1,3.1.3,2.5,1.5Z"
          fill="#070c3b"
        />
        <path
          d="M147.3,410.2c.2-.5.3-.4.5,0l2,.9c.6-.3.7-.1.5.6,1,.2,1.5.5,1.5,1,.4,0,.6.2.5.5.9.2,1.2.5,1,1,.2.4.2.8,0,1-.5,0-1-.1-1.5-.5-1-1-1.9-1.3-3-2s-1.3-1.5-2.5-1.5c0,0,0-.4,0-.5-.5-1.1.1-1.1,1-.5Z"
          fill="#0c398f"
        />
        <path
          d="M143.8,407.7c.3,0,.5.2.5.5,2.4,0,3.4.6,3,2-.9,0-.6.1-1,.5l-2.5-1.5c-.8-.4-1.7-1.4-.5-1.5.1-.4.3-.4.5,0Z"
          fill="#0f2f76"
        />
        <path
          d="M140.8,405.7c1.1.1,1.6.5,1.5,1,.6.2.9.6,1,1,0,0-.3,1,.5,1.5h-.5c-1.3-1.5-2.3-1.6-3.5-2.5l-1-1.5c.7-.2,1.3.4,2,.5Z"
          fill="#122357"
        />
        <path
          d="M173.8,425.7c2.2,1.6-2.4,3.7-4,3.7-3-1.3-3.2-.8-.6,1.4,1.7,0,5.3,1.2,3.1,2.9-1.4-.5-3.6-1.4-5-2-3.8-1.6-7.8-4-11.5-6-1.5-2.6,1.9-2.8,3.6-.9l2,.4c.3-1.6,1.5-4.2,3.3-2.9v-.6c1-1.2,8.7,2.8,8.9,3.2s.2.5.2.8Z"
          fill="#01106b"
        />
        <path
          d="M164.8,421.7c.6.4,1.8.9,2,1.5-.8.3-3.2-.8-3.5-.5s.1.8-.2,1.3-1.6.2-.6,1.2,2.3-.1,1.8,2c-1.6-1.3-3.5-.8-5.3-1.5s-2.4-3.1-3.2,0c-.6-.3-1.1-.8-1.5-1-1.5-.9-.4-2.1,1-2.5-.6-.5-.9-1-.6-1.8s3.2-2.2,3.6-2.3c2.1,0,5.7,1.5,6.5,3.5Z"
          fill="#011060"
        />
        <path
          d="M156.3,416.7c.9,0,2.2.6,2,1.5-.6,1.4-1.3,2.6-3,2.5.6,1.2,2,.7,1.5,2.5-1.6-.1-2.2,0-2.5,1.5-2.2-1.2-4.2-2.1-6.5-3.5,0-1.4.9-2.7,2.2-3.5,2.1,1.1,3.2.2,3.8-2,.2-.2.3-.2.5,0,.5-.4,1.8.3,2,1Z"
          fill="#010d57"
        />
        <path
          d="M153.3,415.2c.2-.4.3-.4.5,0v.5l2.5,3c-1.1.1-1.5-1.2-2.7-1s1.2,2.6-.5,2.5-2.7-1.9-3.7-1.5v2s-1.5.5-1.5.5c-1-.6-2.8-1-3.5-2.5,1.2,0,3.6.1,4.7-.5s1.1-3.6,3.6-1c1.6-1.2.2-1.6-.8-2.5.5,0,1,.3,1.5.5Z"
          fill="#030e4f"
        />
        <path
          d="M162.3,418.7c1.7-.1,3.7,0,4.6,1.6,1.6.3,3,1.1,4,2.4,1.1-1.2,1.9-.4,2.3,1,2.4,0,7.2,1.5,9.2,2.8l.8,1.2c1.4.3,2.2.8,2.5,1.5.6.6.2.7-1,.5-2.7-1.1-5.7-1.9-8.5-3s-1.7-.7-2.5-1c-3-1.3-5.8-3.2-9-4-2.1-1.4-4.3-2.3-6.5-3.5s-1.4-1.1-2-1.5c-.7-.7-.4-.9.5-.5,1.4-.9,5.4.7,5.5,2.5Z"
          fill="#1858c5"
        />
        <path
          d="M197.2,436.2c.4.6.4,1.4.2,2.4,3.7,2.5,3.8,3.7.3,3.6-.8-.2-2.7-.4-3.5-.5-2.3-1,.8-1.5.5-3h-2c-.2-1.4.1-.9,1-1s.8.2,1,0c.6-.9-1.2-1.7,2.5-1.4Z"
          fill="#01178d"
        />
        <path
          d="M184.8,429.7c1.2-.1,3.1.2,3,1.5,3.2,1,2.1,1.5-.3,2.4l-.6.7c1.6-1.9,9.6-.7,6.9,3.4l-.2.5c2.6-.5,2.8.7.7,3.5,0,.3-.4.5-1,.5-.5-.2-1-.3-1.5-.5l.2-.4c-5.5-1.5-10.7-3.5-15.7-6.1-.5-.2-.9-.3-1.5-.5l-.5-.5c-.2,0-.3,0-.5,0-2.3-1.6-.8-2.9,1.6-2.5.1-1.7.4-3.3.9-5,2.6-.2,6.5,1.2,8.5,3Z"
          fill="#010f7f"
        />
        <path
          d="M176.3,435.2c5,1.7,10.8,3.6,15.6,5.6s1.4,1.1-.1.9c-2.9-.9-7.7-2.5-10.5-3-1.7-.9-4.2-2.3-6-3l1-.5Z"
          fill="#030e71"
        />
        <path d="M174.8,434.7c-.2,0-.4-.3-.5-.5.3,0,.7-.8,1-.3l-.5.8Z" fill="#010f74" />
        <path d="M186.3,432.2c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#011387" />
        <path
          d="M203.2,435.2c3.7.4,8.7,1,11.5,3l.9.6c2.3,0,3.3,2.3,2.3,4.9-1.6.5-2.1.7-1.7,2.5-7-.4-12-2.7-18.5-4l2-.7c-2.2-1.5-4.7-2.1-2.5-5.2.2,0,.5.5.8.5s.2-1,.5-1c.6,0,1.3.5,1.9.4s.7-.9.8-.9c.3,0,1.6,0,2,0Z"
          fill="#000e89"
        />
        <path
          d="M216.2,446.2c.6-1.5,3-1.4,3.7,0,7.7.7,15.3,1.6,22.9,2.5,2.2,1.3,0,2.4-1.7,1.5-1.9.5-4,.4-6,0-.3.8-1.1.8-1.5,0l-8.5-1c0,.4-.3.4-.5,0l-3-.5c0,.4-.3.4-.5,0l-6-1v-.5c.8,0,1.7,0,2.5,0v-.5c-.6,0-1-.3-1.5-.5Z"
          fill="#02107c"
        />
        <path
          d="M215.2,447.7l6,1c.2,0,.3,0,.5,0l3,.5c.2,0,.3,0,.5,0l7.5,1c1.1.2,1.4.5,1,1-1.9.3-3.9.1-6-.5-.3,1.3-1.7,1.2-2,0-2,.4-3.5.2-4.5-.5-.4-.8-1.2-.5-2-.5l-1.5-.5c-.3,0-.7,0-1,0-.7-.2-1.4-.3-2-.5-.3.4-.7.4-1,0-.5-.7-1.7-.2-1.5-1,1,0,2,0,3,0Z"
          fill="#4181e2"
        />
        <path
          d="M214.7,448.7c.4.1.4.3,0,.5-.5,0-1.3.2-1.5-.5.2,0,.3,0,.5,0,.3,0,.7,0,1,0Z"
          fill="#09096f"
        />
        <path
          d="M227.7,450.7c1.3,0,2.3.4,3,1,.2.2.3.6.5,1v.5c-2.8-.4-5.9-1.1-9-1.5,0-.9,1.1-1.3,3.5-1,.6,0,1.3,0,2,0Z"
          fill="#080d7d"
        />
        <path
          d="M225.7,450.7c-.7,0-2.8.6-3.5,1-.5,0-.9-.5-1-.5-1.3-.3-1.3-.6,0-1,1.6,0,2.9.2,4.5.5Z"
          fill="#060569"
        />
        <path
          d="M221.2,450.2c0,.2,0,.7,0,1-.5,0-1,0-1.5,0-.7.4-1.4.4-2,0v-.5c.5,0,1,0,1.5,0l1-.5c.3,0,.7,0,1,0Z"
          fill="#040d4e"
        />
        <path d="M219.7,451.2c-.2.7-1.9.8-2,0,.7,0,1.3,0,2,0Z" fill="#01020e" />
        <path d="M216.7,449.2c-.7,0-1.3,0-2,0v-.5c.7,0,1.6-.3,2,.5Z" fill="#3a75e0" />
        <path d="M219.2,449.7c-.2,0-.3,0-.5,0l-1-.5c.5,0,1.3-.2,1.5.5Z" fill="#3a75e0" />
        <path d="M220.2,450.2c0,0-.5.4-1,.5l1-.5Z" fill="#060569" />
        <path
          d="M166.3,364.7c3.4-1.8,4.9.3,1.4,2.5l.6,1c2.1,1.3,0,5.7-2.6,3.1-1.6,1.1-1.3,1.5.9,1.2,1,.2,1.2.9,1,1.8s-5.5,3.2-6.6,2.7c.1,2.2-.5,3.2-2,3.1-.9,2.2-2.9,3.8-4.2,1.1-1.5,0-1.9.4-1.4,1.3,3.6.9,3.3,3.2,1,5.2-1.5,2.4-2.8,4.9-4,7.7l-1.9,1.1c.1,2.6-.3,5-2.9,6.2-.8,2.5-2.1,4.6-4.7,3-.8-.7-1.6-1.4-2.5-2l1.5-.2-.5-1.3c.8-.5,2.1.1,2.6,0s2.2-1.2,2.3-1.3c1.2-.9,3.4-3.3,1-4,2.4-2.2,2.7-3.6,3.3-6.8s-.2-1.5-.2-1.7,2.1-.4-.6-2l2.5-.8c-.6-1.8-3.9-.2-4.5-1.7s.9-1.2,1-1.6c.8-3-1.7-.7-3.5-1.7,1.2-1.6,2.8-3,5-4,0-.3,0-.5,0-.8,0-.4,5.5-4,6.2-4.4s.4,0,.8.2h.5l.5-.5c2.8-3,6-5.2,9.5-6.5.2-.2.3-.2.5,0Z"
          fill="#04091b"
        />
        <path
          d="M114.3,356.7c-.9-1.2,0-2,1.2-2.5,0-1.5.7-2.5,2-3.2-.3-3.6,1.9-3.8,3.3-1.3.2.1.2.3,0,.5l.8.8c-.9,1.8-1.9,3.5-2.9,5-1.2-.4-2-.3-2.4.2-.4,0-.8.6-2,.5-.8,1.5-1.5,2.9-2.8,4l-.2-2.2c1.8.7,1.1-1.2-.5-1.3-1.2-.1-1.1-1.1,0-1.5.2-.9.5-.9,1,0,0-2.6,2.5-.8,2.5,1Z"
          fill="#0112b2"
        />
        <path
          d="M108.8,341.2c2.1,0,2.6,5.9,0,3.5-1.2,0-1.7-.4-1.5-1l.5-.5c-2.5-2.2-1.8-4.4,1-2Z"
          fill="#0118c2"
        />
        <path d="M98.8,339.7c2.5.9-2.3,2.7-2,.5-.4-.1-.4-.3,0-.5,0-1.3.7-1.3,2,0Z" fill="#0118c2" />
        <path
          d="M100.3,337.7c.2-1,3.2-1.2,3.5-.8-.3,1.2.3,1.5,1.5,1.3.7-.6.9-.3.5.5,1.2.7,1.3,1.7.6,2.7.6.6.9,1.2.9,1.8.2.2.2.3,0,.5-.2.6.3.9,1.5,1,1.1-.3,1.7.3,1.9,1.8l1.4.2c.6,1.9,2.2,1,1.7-.2-3.7-1.7.6-5.8,2.4-2.5,1.5-1.2,3.5-2.1,4,.2.6,1.9-.3,3.6-2.7,5.1l-.3,1.5c-1.6.4-2.2,1.3-1.8,2.9-1.7.5-2.9,1.2-3.7,2.1-.3,0-.7,0-1,0,0,.4,0,1.2,0,1.5s-1.6,1.7-2,2c.1-1.4.4-2.6.5-4,.5.1.9.5,1.5.5,0-.5,0-1,0-1.5-.5.2-2.4.4-2.5.5l-1-2.5c0-.2-1.8,2-2.5.2s1.7-1,2-1.3-.5-.6-.3-.9,1.7-.6,1.1-1.6c-2.3-1.6-1.1,3.4-4.3,1.5l1,1.2c-.6.8-1.5-.5-2-1,0-.3,4.9-2,3-3.7s-1.1,2.9-2.7,2.5-.8-.7-.8-1l1.5-.3-3-1.3.7-2c.8.2,1.2,1.9,1.3,2,.3.3,1.3.1,1-.7s-1.2.2-1-.7c2-1.1,1.3,1,3.5,1,.2-.9-.7-1.1-.8-1.8s.9-2.5-1.1-1,.1.9-.3.9c-1-2.5-1.1-.3-1.4-.1s-3.3,1.2-3.9,1.6c-.4-.1-.4-.3,0-.5-2.2.4-3.1-3.3-1.1-4.2,1.3.3,2.5,0,1.6-1.3-4.5-1.3.7-3.9,1.4-2.4s-1,2.5-.6.2l.7.2Z"
          fill="#0118c2"
        />
        <path
          d="M113.3,371.2l-.5,5c-.6,0-.5-.5-.5-.5,0-.3,0-.7,0-1-.5-1.1,0-2.5.5-3.5.2,0,.3,0,.5,0Z"
          fill="#02097a"
        />
        <path
          d="M112.3,374.7c-.5,0-.5-.6-.5-1,0-.7.4-2.1,1-2.5-.2,1.2-.5,2.3-.5,3.5Z"
          fill="#06077d"
        />
        <path
          d="M96.3,360.7c1.1,1.4,3,4.4,2.5,6,2.8-.5,1.6.7,2.6,2.2s1.9,2.3,2.9,3.8,1.6,1.9,1.5,2l-2-.5c-1.5-1.8-4.2-4.3-5.5-6-2.9-3.8-5.8-8.9-8.5-13-.8-1.5.7-2.4,2.1-1.6,1.6,2.4,3.1,4.7,4.4,7.1Z"
          fill="#0218d0"
        />
        <path
          d="M76.3,324.7c1,.3,1,.7,0,1,1.6,1.1,2.9,2.4,3.7,4.1,1.5.5,1.7,4.7,1.3,6.4,1.6.8,3.8,1.8,3,4,.4.9.6,1.3-.5,1l-1.5,1c-.6-.6-1.6-1.8-2-2.5s-.3-.7-.5-1l-.5-.5c-.1-.2.1-.8,0-1l-.5-.5c0-.1,0-.4,0-.5l-1-1c-.1-.3-.2-.9-.5-1.5l-.5-1c-.2-.5-.3-1-.5-1.5-.6-.5-.8-1.3-1-2-.2-.7-.4-1.3-.5-2l-.5-.5c0-.1,0-.4,0-.5-1-1.7.8-3,2-1.5Z"
          fill="#020bbc"
        />
        <path
          d="M88.8,349.7c.3-.2.7-.6,1-.4,3.5,2.1,5.4,4.9,7,8.4.2,0,.5.3.5.5.8.7,1.2,2.1-.8,2s.8-.8-.2.5c0,0-1-.1-1.5-.7-1.1-1.3-2.3-4.6-4-6l-1,1.2c-.6-.9-1-1.8-1.5-2.5,0-1.2.1-2.2.5-3Z"
          fill="#010ebf"
        />
        <path
          d="M83.8,341.2c2.1.7,2.8,3.6,3.2,5.8,1.1.7,1.4,1.2.8,1.7l.5.5c.7-.7,1-.4.5.5l1.5,3.5-2-.5c-.2-.4-1.1-.9-1.5-1.5-1.5.2-2.9-2.9-2-4-.4-1.7-1.9-3-2.5-4.5s0-.3,0-.5c-.2-.7-.6-1.3-.5-2,0,0,1.9.9,2,1Z"
          fill="#0215c9"
        />
        <path
          d="M84.8,347.2c1.4,1.7,1.3,2.9,2,4l-3,.5c.9-2.7-2-1.9-2.4-3.3s.6-2.3.9-3.7c.1,0,2.3,2.2,2.5,2.5Z"
          fill="#0106a0"
        />
        <rect
          fill="#0106a0"
          height="1"
          transform="translate(-261.8 424.7) rotate(-89.9)"
          width="1.5"
          x="81.1"
          y="343"
        />
        <path
          d="M69.8,169.8c0,2.5-1,6.3-3,8v.5l-1,2c.4.2.4.3,0,.5l-1,2c.4.2.4.3,0,.5l-.5.5c.3.1.2.3,0,.5.4.1.4.3,0,.5l-.5.5c.4.2.4.3,0,.5-1.3,5.9-2.8,12.1-5.5,17.5.9.6.8,1.2-.3,1.9l-.7,2.6c1,0,.9,1.3,0,1.5l-.5,1.5c.4,0,.4.3,0,.5,0,1.7-.3,2.3-1,2,.1-.9.4-2,.4-2.8s.5-1.8-.4-1.7c.3,2-1,3.9-1.5,5.5,1-13.1,6.9-24.8,10.5-37,1.1-.7,1-2.2,1.5-3,.9-1.8,2.3-3.5,3-5.5l.5,1Z"
          fill="#0f24bd"
        />
        <path d="M50.8,219.3c0-.4,0-.9.5-1-.1.4,0,.8-.5,1Z" fill="#010552" />
        <path
          d="M58.8,272.3c0,0,0,.4,0,.5-.5,1.5-.1,2.4,1,3.5,0,.6-.3.8.5,1-.8,1.2-1.8,2-1,3.5-2.6-.7-1.1,3.6-2,5.5l2.5-3c-.1.6-.4,3.4-.5,3.5-.4.3-2.3-.6-2,1-1.8-.8-.6-3.7-.7-4.7s-1.4-3.8-1.7-5.2c0-.6-.1-3.4,0-3.5s2.3.4,0-1.8l1-.3c-1.8-1.5-.8-2.9,1-2.2s1.5,1.7,2,2.2Z"
          fill="#010aaa"
        />
        <path d="M76.3,331.2c-1.5-.4-1-1.8-1-2,.6.6.7,1.3,1,2Z" fill="#0009a5" />
        <path d="M77.3,333.7c-.1-.3-.3-.6-.5-1l.5,1Z" fill="#0009a5" />
        <path d="M79.8,338.7s-.3-.2-.5-.5l.5.5Z" fill="#0009a5" />
        <path d="M79.3,337.2c0,0-.4-.2-.5-.5l.5.5Z" fill="#0009a5" />
        <path d="M78.8,336.2c0,0-.7-.3-1-1l1,1Z" fill="#0009a5" />
        <path d="M74.8,327.2s-.4,0-.5-.5l.5.5Z" fill="#0107b0" />
        <path
          d="M56.8,211.3l1,.5c-1,5.9-1.5,11.7-2.2,17.6l-2.3,19.3c-1-6.7-.2-13.5.7-20.2,0,.4-.2.7-.7.7.5-5.4,1.8-10.6,2.5-16l1-2Z"
          fill="#01028a"
        />
        <path
          d="M53.3,248.8c0,3.4.9,6.7,1,9.3s-.8.1-.9.4.5,1.6,0,2.3c-.2-4.3-.4-8.8-.5-13.3s.3-2.2-.5-2.7c-.5-1.9-.4-4,0-6,.3-3.1.5-6.4,1-9.5s.7-2.6,1-3.8.5-1.3.5,0c-.9,7.7-1.6,15.5-1.5,23.2Z"
          fill="#01037b"
        />
        <path d="M53.3,263.3l-.4-1.7.4-.3c0,.8,0,1.6,0,2Z" fill="#01037b" />
        <path
          d="M52.3,244.8c0,1.4-.5,3.2-.5,4,.2-2.9-.2-6,0-8.8s.5-1.1.5-1.2c0,2,0,4,0,6Z"
          fill="#0a24bd"
        />
        <path
          d="M188.3,64.4c2.3-1.9,12.4-2.4,5.2,0l-1.7,1.5c-.5.2-1,.4-1.5.5-5.7,1.8-11.4,3.5-17,5.3-3.7-.8,3.5-3.4,5-3.8,3.9-1.8,5.8-2.5,10-3.5Z"
          fill="#8c95d6"
        />
        <path
          d="M190.3,66.9c-3,.9-6.3,2.1-9.5,3l-2.5,1.5c-.1.3-.3.3-.5,0,0,.3-.2.5-.5.5-.4.3-.8.3-1,0-.7.2-1.6.3-2.5.5-.1.4-.3.4-.5,0-.6.2-.8.4-1,1-.1.5-.3.4-.5,0l-.5.5c-.2.4-.7.4-1,0l-.5.5c-.2.4-.3.4-.5,0-3.4,1.5-4.8,1.2-4-1,4.2-2,8.4-4.5,13-5.5-1.4.7-3.9,1.5-5,2.2s-.7,1,.3.8,3.3-1.6,4.6-1.8c4-.9,8-1.4,12.2-2.7v.5Z"
          fill="#8991d8"
        />
        <path
          d="M204.2,64.9c4.2-1.4,8.5-2.3,12.9-2.6s10.4-.5,8.1,2.1c-1.8,1.8-6.3,1.7-9,1.5l-.3.6c-7.3,1.4-14.6,3-21.7,5l-.5-.5c-4.6-.5-.3-3.1,2-4,2.7-.7,5.8-1.5,8.5-2Z"
          fill="#5c78e2"
        />
        <path
          d="M195.7,66.9l-3.3,3,1.3,1c-.6,1.7-5,3.1-6.5,2-1.4-1.5-3.4-1.1-6,1.1-2,.7-6.1,2-7.4.4-.4-.1-.4-.3,0-.5.2,0,.3,0,.5,0,3.3-.8,6.5-2,9.5-3.5,3.9-1.3,8-2.5,12-3.5Z"
          fill="#627ce4"
        />
        <path
          d="M173.8,73.9v.5c-.2,1.4-1.4,2.1-2.5,1l-1.7,1.8c-3.4,1-6.4,2.4-8.8,5-2.6.5-5,1.4-7.2,2.4-1.2,1.4-3.5,3.5-5.2,2.7-.2.4-.3.4-.5,0-.9.8-1.5,1-2,.5-.2-.3-.3-.6-.3-.6,1.2-1.1,3.3-2.2,4.8-2.9l.4-1.3c7-3.5,14.3-6.6,21.6-9.4l.5.2c.3,0,.7,0,1,0Z"
          fill="#6880df"
        />
        <path
          d="M175.8,72.4c-.8.9-2.6,0-3,1.5-6,1.4-16.5,7.6-22.5,10.5-4.5,2.7-9.1,5.1-13.9,7.3-.6-.2-.7-.7-.3-1.2l5.7-4.2c5-3.2,10.1-6.3,15.5-9-.1.8-1.7,1.7-1.2,1.2,1.2-1.2,2.2-1.2,3.6-.8l6.2-2.9c1.1.3,2.2,0,3.4-.5.2,0,.3,0,.5,0l.5-.5c.3,0,.7,0,1,0l.5-.5c.2,0,.4,0,.5,0,.1-.6.4-.9,1-1,.1,0,.3,0,.5,0,.6-.3,1.5-.4,2,0Z"
          fill="#7b8dd8"
        />
        <path d="M183.8,70.4c-2.7,2.3-6.3,2.6-9.5,3.5,3.2-1.2,6.3-2.4,9.5-3.5Z" fill="#6880df" />
        <path
          d="M176.3,71.9c.4.1.4.3,0,.5-.2,0-.3,0-.5,0-.6.1-1.4-.1-2,0,.4-.8,1.7-.5,2.5-.5Z"
          fill="#8191d6"
        />
        <path d="M180.8,69.9c-.4.9-1.2,1.1-2,1.5h-.5c.7-.9,1.4-1.2,2.5-1.5Z" fill="#8191d6" />
        <path d="M177.3,71.9c-.2,0-.3.4-1,.5v-.5c.3,0,.7,0,1,0Z" fill="#7b8dd8" />
        <path d="M178.8,71.4c-.3.1-.4.4-1,.5v-.5c.1,0,.3,0,.5,0h.5Z" fill="#7b8dd8" />
        <path d="M177.8,71.9c-.2,0-.3,0-.5,0,.1,0,.3-.4.5-.5v.5Z" fill="#8191d6" />
        <path d="M318.7,70.9c-4.5-.2-10-2.1-13.5-5,4.5,1.4,9.1,3.5,13.5,5Z" fill="#7684db" />
        <path
          d="M304.7,65.9c-1.1-.3-2.6,0-3.5-1,0,0,.3-.4.6-.4.8,0,2.2.9,2.8,1.4Z"
          fill="#7684db"
        />
        <path
          d="M400.6,134.8h.5c0,.1,0,.4,0,.5l1.5,2.7c1.2,1,1.6,2.3,1.2,3.9,1.1.9,2.5,2.2,1.3,3.4,3.8,2.8,5.9,6.9,5.9,11.8,1.2.8,2.4,1.5,3.4,2.1.2,1.8.9,3.3,2.2,4.4,1.4,2.1,1.6,3.5.5,4.2.4,2.3-.2,3.9-2.5,3-1.2,1.5-2.5,0-1.5-1.6-.9-.8-1.2-1.6-1-2.4-.2.4-.3.4-.5,0-.6-1.3-1.7-2.1-3.5-2.5-1.5-.7-2.7-2.1-1-3h-.5c-.4-.8-.4-2,0-2.9-1.2-.7-1.4-1.5-.3-2.5l-.6-1.1c-2.4-.5-1.9-1.9-.7-3.8-.2-.5-.5-1.1-.8-1.6-1.2.6-2.8,0-2-1.1-.1.3-.3.3-.5,0,.2,1.1-.6,1.2-1.5.5-.3-.4.4-.9.3-.9-1.5,1.1-1.8-.5-1.4-1.9-.8-.7-1.1-1.4-.9-2.2-.8.4-1.6-.1-1.5-1-1.5-1.5-.5-2.3,3-2.5,0,0,.6,0,.5-.5-2.3,0,0-1.7,0-2.7s-1-.2-1-.3c.8.8-1.5,2.1-1.5.7s1.2-1,1.5-.7c-.3-.4-1-1.6-1.5-2.2-.8-1-2-.5-1.5-2.8,1.7.8,2.4,3.2,4.5,3Z"
          fill="#0114ce"
        />
        <path d="M400.6,134.3c0-.1-.4-.3-.5-.5h.5v.5Z" fill="#0114ce" />
        <path d="M401.1,134.8h-.5v-.5c0,.1.4.3.5.5Z" fill="#071cbe" />
        <path
          d="M262.7,62.4c-1,0-2,0-3,0v.5c.7.3,2.9-.6,3.5.5-3-.2-6,0-9,0-.2.3-.5.5-.8.6-.8.3-10,0-11.9-.2s-.5-.2-.8-.5c-3.4,1.4-6.5,1.6-9.5.5.5-1,2.3-.2,3-.5v-.5s-1-.5-1-.5c4.4,0,7-2,12.2-1.5s8.9.9,14.5,1,2.2-.3,2.7.5Z"
          fill="#5e79da"
        />
        <path
          d="M280.2,61.4c1.7.2,4.2.7,6,1,1.6,2.2,3.9,1.2,6.1,1.6s4.6,1,7.5,1.5,4.5,1.3,5.4,1.7c1.6.7,3.1,3.3,3.7,3.6s1.6,0,2,.1.2.6,1.4,1c3.2-.2,6.4.4,9.6,1.1l.4.9c3.5.2,5.8,1.6,7,4,1,0,1.4-.4,3,0-.8,1-.2,1.2.7,1.5,1.8.6,4.6.9,6.3,1.7s3.8,2.7,5.4,3.6,3.5,1.4,3.7,1.6-.7,1.2-.5,1.5c1.5-.4,2.6,1.4,2.7,1.4.6,0,1.4-.7,2.4-.5s.5,1.3.8,1.5c.9,1.7,0,1.8-1.5,1l-1.4.3c-9.7-6.1-20.2-10.7-30.8-14.7s-.7-.6-.8-1.1c-1.1-.7-2.5-.9-3.8-.8l-.2-.7-3-1h-1.8c-15-4.3-30.1-7.5-45.6-9.2l-1.6-.8c-4-.1-6.4-1.7-.5-1-.2-.7-.2-1.2,0-1.6,4.4.4,8.7.6,13.1.6l.9-.5c1,0,2.3.4,3.5.5Z"
          fill="#6580e3"
        />
        <path
          d="M327.2,74.4c1.3.8,1.8,2,2,3.5-1.9,0-1-1.4-1.1-1.4-.4-.3-6.9-1.4-7.4-2.1l.5-1c-2.8-.7-6.5-.6-9-1.5,1-.9,3-.6,4.2-.4,4,.5,7.2,1.4,10.8,2.9Z"
          fill="#6a7fdc"
        />
        <path
          d="M263.2,63.4c16.7,1,33.1,4.9,49,10l3,1c1.3.4,3.1.2,4,1.5-1.2-.3-3.5-.7-4.5,0-2.5,0-5.6-1.3-8-2.5-1.2,0-3.3,0-4-1-15.4-3.4-31.1-6.4-47-7-.1.3-.3.3-.5,0-.4-.1-.4-.3,0-.5-.7-.5-1.1-1-1-1.5l.7-.7c2.8-.2,5.5,0,8.2.7Z"
          fill="#0d1bbd"
        />
        <path d="M315.2,74.4c-1.2-.3-2-.7-3-1l3,1Z" fill="#1d2dc9" />
        <path d="M352.4,90.4c.3.2.3.3,0,.5v-.5Z" fill="#6a7fdf" />
        <path
          d="M316.2,76.9c.3,0,.7,0,1,0l1,.5c8.2,2.2,17.6,7.4,25,11.5-.6.6-1.7.5-3.5-.5-3.6-.9-7.1-2.3-10.6-4.3-4.9-1.7-9.5-3.8-13.9-6.2-.7.7-3.1-.4-2.5-1.5.7-.6,1.9-.5,3.5.5Z"
          fill="#223ad0"
        />
        <path
          d="M367.1,104.4c1.6,1,3.8,2.3,5.1,3.7s0,.4,0,.8l4.9,4.3-.4.7c-.8,1.1-1.3.7-1.5-.5-2.2-.7-3.9-2.1-5-4-1.5.3-3.4-1.7-3.8-3l-5.7-4.5c-.4-.1-.4-.3,0-.5l-4.1-3c.1-.5.5-.6,1.1-.5,3.2,2.2,6.4,4.1,9.5,6.5Z"
          fill="#2537d3"
        />
        <path
          d="M357.7,97.9c-1.3,1.6,2.4,2,3,3.5-.9.8-1.7.6-1.4-.6l-2.6-1.9c-2.2.3-5.9-2.3-7.9-3.7-1.6-.7-2.3-1.6-2.1-2.8-1.6-.8-2.3-1.6-2-2.5,4.9,2.8,8.4,4.9,13,8Z"
          fill="#2539d5"
        />
        <path
          d="M377.6,112.4v.5h-.9c0,.1-4.6-4-4.6-4-2-1.5-3.2-3.1-5-4.5,1.8.4,3.5,1.7,5,2.8s3.9,4,5.5,5.2Z"
          fill="#102bce"
        />
        <path
          d="M306.7,73.4c3.6.7,4.8.7,8,2.5s1.2.4,1.5,1c-1.2-.2-2.5-.3-3.5-.5-.8,1-3.7.3-3.5-1-.9-.4-1.8-.9-2.5-1.5-.4-.1-.4-.3,0-.5Z"
          fill="#1d2dc9"
        />
        <path
          d="M343.2,88.9c.5.3,1,.7,1.5,1,.6.7,1.4,2,2,2.5-1.8,1.1-6.6-2.1-7-4l3.5.5Z"
          fill="#334cdc"
        />
        <path d="M318.2,77.4c-.4-.1-.8,0-1-.5.4,0,.9,0,1,.5Z" fill="#1d2dc9" />
        <path
          d="M377.6,112.9c1.1.9,2.5,1.8,3.5,2.5-.3,1.4.6,1.6,1.1,2.2.9,1.2,2.5,2,2.7,2.3.4.4-.3,1.3-.2,1.7.2.8,2.7,1.4,1.4,1.8-.9.7-1.8,0-1.5-1-2.6-.6-4.4-2.8-5.5-5.5l-.6.3c-.3-1.1-1-2-1.9-2.8-.4-.1-.4-.3,0-.5-1-1.8-2.8-3.5-4.5-5,1.7,1.3,3.7,2.6,5.5,4Z"
          fill="#1c36d8"
        />
        <path
          d="M406.6,145.8c.6.3,1.1.3,1.5,0,.6.9,3,4.5,3,4.8s-.5.9-.4,1.1,1.7,1.6,2,1.8c.6.5,2.2,0,1.2,1.3l-1.3.5c3,.3,1.4,1.1,1.8,2,1.1,2.6,2.5,5.1,2.9,8,1.5,1.4.2-.9.3-1,1.9-1.3,1,4.6,3,5.5.4-.2.8-.2,1,0,.2,0,.5,0,.5,0,.6,1.2-1,2.5-1,3.2s1.4.4,1,2.3c-.1,0-.6.1-.9,0s-1.1-2.2-1.1-2.4c-.4-.2-.4-.3,0-.5-1.3-.2-1.3-.6,0-1,.6,0,.6-.3,0-.5-.2.9-3.3,0-3.5-.3.2-.9.4-1.8.5-2.7-.7-1.7.9-2.9-1.5-2.5l1-1c-1.3-.4-1.8-1.8-3.5-1.5,1.2-1.3.8-1.9.5-3.5-2.1,1-1.2,0-2-.7s-1.1-.2-1.3-.4-.8-3.1.4-3.4h-1.5c.8-2.6-.5-6.1-3.5-6l1.5-.7c-.5-.8-1.9-1.5-2.2-2.3s.3-.5.2-.5c.7-.3,1.1.4,1.5.5Z"
          fill="#010dc5"
        />
        <path d="M421.6,169.8c-.3,0-.8,0-1,0l.7-.4.3.4Z" fill="#0109bf" />
        <path
          d="M390.6,128.9c.4,0,.8.7,1.3.8s1.1-.4,1.2-.3c0,0,.2,1.4.6,2.2,1.4,2.5,4.2,3.6,1.9,6.8h2c.2.9-.8.3-1,.5-.4.5,2.1,2.1,3,1.5-1.2,1.2-3,.8-3,2.5-.1.4-.3.4-.5,0-.7.4-.9.2-.5-.5-.9.7-2.6,1.8-2.5,0-.9-.9-.9-1.5,0-2q2.4-1.5,0,0c-.1,1.1-1,1.1-2,1-.4-.1-.4-.3,0-.5.9-.4-.4-.5-1.3-.2,0-1.4.3-2.8.8-4.3-2.4.6-1.6-3.9.5-2,1.1-1.8.5-3-1.1-4.2l.6-1.3Z"
          fill="#0226d6"
        />
        <path
          d="M390.6,125.4c-2.1,1.9.1,1.6.5,2.1s-.5,1.2-.5,1.4c-.2.4-.3.4-.5,0-1.1-.2-2.1-1-1-2-.1-.6,0-1.4,0-2,1-.3,1.2.3,1.5.5Z"
          fill="#102fd0"
        />
        <path d="M394.6,129.4c-1.5-.8-2.1-2.7-4-2.5l.5-1c1.3,1,2.6,2.1,3.5,3.5Z" fill="#102fd0" />
        <path
          d="M385.1,124.9c1.1.4,2.3,1,3.5,2h.5c.1.5,1.1,1.2,1,2,1.1,1.3.7,2.1-.8,1.2-1.1.5-3.5.8-3.7-.7-1.6.1-1.8-.7-1-2-1.5-.4-2.2-4.4.5-2.5Z"
          fill="#0c3ddb"
        />
        <path
          d="M386.1,123.4l2.5,3.5c-3.1,0-1.9-.2-3.5-2-1-.2-1.3-.6-1-1-1.1-.2-.6-1.7.5-1.5.4.4,1.1.6,1.5,1Z"
          fill="#173fdd"
        />
        <path
          d="M427.6,280.8c.4.4,1,1.4,1.2,1.5,1,.1,2-2.8,2.8-2s-.1.8.2,1.3,1.6-.4-.7,2.2l2.5,1-2,.5c-.2,1.3,1.1,1.5,2,1.5-1.7,2.5-1,3.2,2,3-.3,1.6-1.3,2.3-.5,4-1.1-.8-4.7-.6-4.9-1.8s1.4-2-.6-1.7c-.6,2.2-3.2.8-3.1-1.1-4.5,0-4.3-3-.6-4.8-.3-1.2.3-2.4,1.7-3.5Z"
          fill="#010ec2"
        />
        <path
          d="M428.1,291.8l-1.5,4,1.7-2c.5.2.6,1.9.8,2,.2.2,4.1-1.1,5-1v4c-.8.5-2,.8-2.7,1.5-.9-.2-.9-.9-2.2-1.5s-3.3-.9-5-1.5-1.9-.4-2-.5.4-.8.3-1.2-1.1-1.4-.8-1.8,2.7-1.1,3.5-1.5c0-.5.4-.9,1.5-1,.2-1.6,1.8-.6,1.5.5Z"
          fill="#010fc4"
        />
        <path
          d="M437.1,259.8l3,.5c-.4,1-1.6.8-2.1,2.1s0,1.9,1.1,1.9v.5c-1.6-.3-.5.8-.6.9s-.8,0-.9,0c-.4,0-.3.3,0,.5,0,1,1.1,3.3,1,4.8l-1.5-.3.5,2,2,.2c-2.1.9-1.8.9-2.5,2.8l-1-.5v1.5c-.4.4-2.3-.8-2.5-1.5.2-.7.5-1.4,1-2l-.9-.7c.4-2.6,1.1-5.2,1.9-7.8l1-1.5c-.9-.6-.4-.8.5-1l-1-1.5c-2.8,1.1-.6-4,1-1Z"
          fill="#0109bd"
        />
        <path
          d="M434.6,237.3c.2.4.8.6,1.2,1.1.9,1.6-.7,2.3,2.3,1.4-1,1.8,1.2,2.4-.5,4,2.5-1.2,2.3,1.3.4,1.4s-2.2-1.2-1.9.6c1.9.1,3.1-.8,3.2,1.5l.7-1.5c.2.7-.5,1.7-.5,2.2s2.6,1.6.2,2.2-2.8-1.2-3.2,0c1.4,1.1,2.5,1.1,4,2,0,.4.2,1.3,0,1.5s-3.5.2-4,1.8c0,1.7,0,.5.5.2,1.1-.8,2.1-1.4,3.4-1.4.3,1.4-1.1,1.2-1.5,1.5-.5.5,2.1.6,1,1.5s-2.4-.3-2.5,1l1.5.3c-.5.4-1.4,1-2,1.3s-1.3-.1-1.5,0c-.3.2.5.9.5,1,.5.1.9.6,1,1.5-.1.5-.5.9-.5,1-1.8.6-2.1,1.1-1,1.5.2,1.1-.2,2.6,0,3.7s1.9.4,1,1.3-1.9-.1-2,1l2,1.5-2-1c.3.7,0,1.5,0,2,0,1.9-2,2-3.5,1.8-.6-2.6-.7-5.2-.5-7.8.4-.9,0-.9-1,0,3.4,2.8-2.1,4.5-1.5.5-.7.3-1-.5-.5-1l-.5-.5c-.7-.6-1-1.3,0-1.5,0-.5.2-.4.5,0,.7-1.3,1.7-3,3.1-2.1,1.2-1,1.3-2.2.3-3.6-2.4,0-2.7-1.9-.5-2.7.2-.3-.2-.5-.3-.5-3.2-.1-4.3-1.7-.2-2.3-.7-1-1.2-4.1-.6-4.6.9-.7,2.1-.2,1.5.9.5,0,1-.3,1.5-1,.9-1,.4-1.7-1.6-2-1.4-1.5-.8-2.8.5-4-.7-1.8-.4-2.8,1-3,0-2,.2-4.2,2.1-2.6Z"
          fill="#010dc4"
        />
        <path d="M437.6,265.8s0,.3,0,.5c-2-.3-2-1.8,0-.5Z" fill="#010dc4" />
        <path
          d="M431.1,230.8l.8-.6c0-2.9,2.5-3.5,2.2-.4.1,0,.3,0,.5,0,.8,1.8.8,3.3,0,4.5,0,0-1,1.4-1,1.7s.9.3,1.2.7-.2.5-.2.5c-2.7.3.3,1,0,1.7s-1.5,0-1.5.5l1.5.5c-.5.8-1.5.6-2.1.9-2.4,1.1-.2,1.2.6,1.8s0,.6,0,.6c.2,0,2-2,3,.5-2.7-1.3-1.7,1.4-4,1,1-2.1-.3-2.4-1.5-.7,1.7,0,.2,1.5.5,1.7.5.4,3.2.5,3.5,2.3-.4.9-1.8.6-2,.7s-.1,1.3-.8,1.5-.6-.4-.7-.5c-1.5-1.2.3-1.8,1.5-1-.8,0-2.4,0-4.1-.4-1.4-2.3-2.8-6.1,1.5-5.6.8-.2.6-.9-.7-2,.8-1.7.7-2.9-.2-3.5-1,.1-.9-.6,0-1l-.6-.4c-.9.7-1.4.7-1.3-.1-.5-.1-.4-.3,0-.5-.4-.1-.4-.3,0-.5-1.6-1.6,1-2.5,2.6-2.7l.4-1.3h.5c.1,0,.3,0,.5,0Z"
          fill="#0110ca"
        />
        <path
          d="M440.1,232.8c1.1,2.6-1.2,5.3,1.5,7.2.2.4-.8,0-1,.6s.3,6.4.5,6.7c4-1.3,0,1.6,0,1.9-.2.6,0,1.9,0,2.6-.2,0-.5.3-.5.5-4,1.7-7.6-4.8-1.2-3-.6-.7-1-1.6-1.1-2.6-3.2.7-4.7-2.2-1.1-2.8.3-1.7.1-2.7-1.7-3.3-.3-1.2-.6-2.3-.9-3.4-2.5-.2-2.7-3.1,0-3,1.1-2.4,2.6-2.4,3.6-2.2l.9-.3c.2,0,.9.8,1,1Z"
          fill="#010abc"
        />
        <path
          d="M434.6,229.8c1.1,0,2-.3,3-.5,0,.5,0,1.1,0,1.5.4,1.9.4.6,1.5,1,.3,1.8-2.2.8-2.9,1.6s.3.8.2.9c-.6.9-1.3-.1-1.8,0-.2-2-1.3-2.6,0-4.5Z"
          fill="#010cc2"
        />
        <path d="M438.9,240.8c.3.2.3.3,0,.5v-.5Z" fill="#010dc4" />
        <path
          d="M405.1,343.7c0-1.3-.5-2.3,1-2-.2,2.4,0,1.6,1,2s3.1.8,2,2c-.6-.7-1.6-.4-2.5-.8s-.9-1-1.5-1.2Z"
          fill="#010ec1"
        />
        <path
          d="M390.6,337.7c2.6-2.5,5.4-2.2,3.1,1.9s0-1.1.9-.4c.2,0,1.8,1.6,3,1,0,.4-.5.5-.5.5-.3,0-.8.5-1,.5-.4.5-.4,1.1,0,2-.1.8.1,1.8-1,2-.2-.5-.3-.9-.5-1-.8.2-1-.2-2,.5l.5,1c.2,0,.3-.5.5-.5.2-.3.3-.3.5,0,0,.3,0,.7,0,1-.3.6,0,.4,1-.5h.5c-.2.3-.4,1.9-.5,2-.4.3-2.4-1.6-2.2,1-.8-1.1-2-1.1-3.3-1,.3-.2.5-1,1-1.3-1.5-.4-6.3,3.3-2,2.2l-.8,1.1.8,1.4c.7,0,.7.7,0,1-.5,0-1.3-.6-1.5-1-.6-.7-1.3-1.3-2.1-1.7v-.8c.7-.6.1-1.2.1-1.5-1.2-.8-1.2-1.3,0-1.5.1-1.3-.2-2.6-1.1-3.9.3-2,2-1.6,3-.1l.8-.8c-.2-2.1.4-4.7,2.7-3.2Z"
          fill="#0121d7"
        />
        <path
          d="M375.1,341.7c-.7-3.3,1.1-3.6,5.4-.8,3.2-.6,3.5.2,2.6,3,1.2.3,1.8.9,2,1.8,0,0,0,1.2,0,1.5l-3-1.5,1,3-1.5-1-.5,1.5c-.4-.6-.4-2.9-.5-3-.3-.3-2.3.7-3,0-.5-1-.9-2.4-2-3-.2.2-.3.2-.5,0,0-.2,0-.3,0-.5v-.5c-.4,0-.4-.3,0-.5Z"
          fill="#0129d5"
        />
        <path
          d="M383.6,360.7c.6,0,.2,1,.7,1,.7-2.6,2.2.5,2.7,1.8s.4.2,1.6.2v.5c1.4.6,3.6,4.2,1.3,4.3s-2.7-2.2,0,0,0,.3,0,.5c.8-.3,1.3-.2,1.7.7.6,0,1-.4,1.5-.5.4,1.9-1.9.2-1.5,1.7s.7.1.9.3-.4,1-.3,1.6c.2.9.9,1.9.9,2.6s-2-.4-1.5,1.3c-.7-.5-1.7-.5-2.5-.5l1.5-1-1-2,1.5-.5h-2.3s.5-1,.5-1h-1.3c0-.2,0-.4,0-.5l-.5-.5c-1.4-3.3-2.6-6.7-4-10Z"
          fill="#0114b3"
        />
        <path
          d="M391.6,369.7c-2.1.3-4,1.1-2.5-1.3,0-.9-2.1.3-1.5-1,.9-1.9,2.1.8,3,0-2.1-4.9-1.7.7-4-2.2.8.3,1.8-1,2-1,2.3-.5,2.9,4,3,5.5Z"
          fill="#011bc3"
        />
        <path d="M388.1,371.2c-.2-.1-.4-.3-.5-.5.2,0,.4.3.5.5Z" fill="#0110a9" />
        <path d="M390.9,371.7c.3.2.3.3,0,.5v-.5Z" fill="#0111c5" />
        <path
          d="M396.1,341.2v.5c.3.3.4.7,0,1,0,.2,0,.3,0,.5l-1.5-2.2c.3-.7,1.2.2,1.5.2Z"
          fill="#011dd4"
        />
        <path d="M393.1,345.7c-2.1.8-2,0-.5-1l.5,1Z" fill="#011cd0" />
        <path
          d="M397.6,346.7c-.2,1.1-.5,2.1-1,3,.4.5.4,1.2,0,1.2-1.6,0,.4-1.9.9.8,1.4,0,1.8.6.7,1.5-.3-1.3,0-1.3,1-.5,1-.8,1.2-.5.5,1-.1.4-.4.5,0,1-.3-.2-.9,0-1.3-.5s-.1-.8-.2-1c-1.2.3-2.3.4-3.5,0l1-.7-2-2.3,1,1.2-2.5,2.2,2.5.5-3,.7c.5,2.6,3.2.3,3,2.3-1.7-.5-3.6,1.1-2.5,2.7s1.1.3,1,.6-.9,1.2-1,1.8c-1.3.3-2.3-2.3-.5-2-.5-.9-1.3-1.3-.7-2.5l-1.2.5c-1.6,1.7-2.1-1.6,0-2.4l-.5-.7c-.7,1.8-2.4,2.5-4.2,2.4-1.1,3.2-3-.7-3.4-2.6l-.4-.2c-1.2-.8-2.4-3.6-2-5,.1-.9,0-2.5-.5-2-.8,1.1-1.7-.8-1-1.5.6-1.1,2.9-1.4,3.8-.4.8-1,3.5.2,3.7,1.4,1.7-.2,1.6,1.5,0,1.5-1.1.2-.8.6,1,1.4v.6s.5.5.5.5c.1-.4.3-.4.5,0,.6-.7,1.2.3,1.5,1,1.3-1.6,1.5-3,.6-4.1l.4-.4c-.1,1-.7.1-.7.2,1.5,1.7,2,2.6-.3,3.3-.9.2-2.5-2.8-2.4-3.5.4-2.3,8.2-3,3.4,0,.8-.9,2.5-1.2,3.8-1.3.5,1,1.3.7,2.2-.7.4-2,3.1-1.8,2.3-.5l-.3,1.5Z"
          fill="#011cd0"
        />
        <path
          d="M381.1,354.7l3-1c.2.9-1,.2-1,.8s.6,1.1.5,1.7c-.6,0-1-1.9-2-1s1.4,3.2,2.5,3c-1.4-2.6,1.3-1.2,2.8-2,3-1.7-.1-4,2.7-3.5-.8,1.7,1.4,2.3,1.5,3.3s-1.9,1.2-1.9,1.3c-.4.8.4.9.4.9,0,.2,0,.3,0,.5.2.2,0,.4-.5.5,0,.5,0,2.2,0,2.3-.2.5-1.1-.1-.9.7l1.5.3-1,1.3c-1.3,1.6-2.4,1.1-3.4-1.7-.5.5-1.1,0-1.6-1.3-1.4-1.7-2.5-3.9-2.5-6Z"
          fill="#0218c3"
        />
        <path
          d="M385.1,348.7c.9.9,1.8,1,1.9,1.1.3.4,0,1.2,0,1.4h-.5l-.5-.5c-1.1-.5-3-.7-2.5-2.2s1.1-.2,1.5.2Z"
          fill="#0129d5"
        />
        <path
          d="M389.6,347.7c-.2,1.4,1.8,1.7,1.5,3-2.4-.6-.7,1.8-2.5,1.5,0-.3,0-.8,0-1,.2-.5,1-.8,1-1.7s-1.2-1.5-1-1.7.8.1,1,0Z"
          fill="#0129db"
        />
        <path
          d="M386.6,352.2c0,0,1,2.1.9,2.3,0,.6-2.4,1.8-2.4.2,3.2.6.3-2.3.5-2.5s.9,0,1,0Z"
          fill="#0218c3"
        />
        <path d="M379.1,349.7c-.2-.7-.3-1.3-.5-2,0,0,.2-.5.5-.5l.4,2.2-.4.3Z" fill="#0129d5" />
        <path d="M386.6,351.2l-.5-.5c.2,0,.4.3.5.5Z" fill="#0121d7" />
        <path d="M395.1,345.7c-.4.7-.7,1.2-1.5,1-.1-.5.5-.5.5-.5l1-.5Z" fill="#011cd0" />
        <path
          d="M397.1,340.7c1.5,0,1.8,1,1,3h.5c0,.1,1.3.5.5,1.5l2.5-1c-1,2.2,1.5,2.9-.7,4.8s-1.7.2-1.8,1.2c1.6.1,2.6,1.2,3,2.5-1.9-.2-1.6-1.4-2.5,1,0-.3-.5-.9-.5-1-1.6-.7-2.1-1.4-2.5-3l-.5-3c.5,0,1.2.1,1.5,0,.9-.3.9-.8.7-1.6.6,1.7.4,2.3-.7,1.6-.1-.5.1-1.4,0-2,0,0-1.9.9-2,1-.1.4-.3.4-.5,0-.3.5-.7.6-1,.5-.9,0-.7-.6,0-1-.2-.2-.4-.2-.5,0,.4.6.2.8-.5.5-1,.3-1.2-.3-.5-1-.4-1.7,1.5-2.1,2-.5l.5,1c.3-1,.6-1.7,1-2v-.5c.1-.4.3-.4.5,0v-.5c-.2.2-.4,0-.5-.5-.4-.1-.4-.3,0-.5-.3-.9.3-.8,1-.5Z"
          fill="#0118cd"
        />
        <path
          d="M396.6,349.7c.3-.3.5-1.1.7-1,.4.2.9,1,1.2,1.3.1,1.6-1.4-.7-1,1.2h2c.1.6-.5,1.2-.5,1.5-.3.1-.7.4-1,.5-.7-1.6-.2-.5-1.5-1.3s0-.9-.2-1.1-.8,0-.8-.1c-.3-.4.8-.8,1-1Z"
          fill="#0115c7"
        />
        <path
          d="M397.6,346.7c1-.4,0-2.1,1-2-.2.9.8,1.7.9,2.4.3,1.8-1.5,2.1-1.3,1.4.5-2.2-.3-1.1-.5-1.8Z"
          fill="#0115c7"
        />
        <path d="M401.1,347.7c-.2.2-1.3-.9-1-1.5.2-.2,1.3.9,1,1.5Z" fill="#0115c7" />
        <path d="M395.1,345.2l-.5-.3v-.7s0-.6.5-.5v1.5Z" fill="#011cd0" />
        <path d="M396.6,342.2c.3.1.3.3,0,.5h-.5c0-.3,0-.7,0-1,.2.1.4.3.5.5Z" fill="#0121d7" />
        <path d="M394.1,345.2c-.2,0-.3,0-.5,0l.2-.5.2.5Z" fill="#011cd0" />
        <path d="M396.6,342.7v-.5s.5,0,.5.2l-.5.2Z" fill="#011dd4" />
        <path
          d="M411.1,308.3c.3-.4.6-.2,1,0,.1-.4.3-.4.5,0,.9.7,1.9,1.8,2,3-1.7,1.7-2.8-1.8-3.5-1s.9,1.6,1,1.9c.4,1.6-.7,2.2,2,1.1.2.3-.8,1.7,0,2.2l-1,1.3c0-.3-.5-2.6-1-2.5-.8,1.8-1.6,3.1-.5,5h-2c-.1,0,.4.7.5,1,.3,1-.5.7-1,0,0-.3,0-.7,0-1-1.8-.3-3.7.3-2.4,2.3-2,.7-3.3.4-4.1-.8-.8.6-1.1-.7-.5-1.5,0-.1,0-.4,0-.5-.5-.7,1.3-2.6,1.3-1.4l.2-.6-.5-1c-3.1,1-3.2-.2-1.5-2.5-.4,2.1-3,.3-1.7-1.6s4,.8,1.7,1.6c.4-2.5,5.1,1.3,5.2,3,.9,0,1.6,0,1.8,1,1.7-.5.3-2.6-1-3-2,.9-2.7,0-2.2-2.5-1.2-1.2-1.3-1.9-.3-2l1.1-.4c-.1-2,1.4-1.9,3.6-1.4.4-1.2.8-.8,1.4.3Z"
          fill="#011cd5"
        />
        <path d="M403.1,316.3c-.1.4-.3.4-.5,0-.5-.6-.2-.8.5-.5v.5Z" fill="#011cd5" />
        <path
          d="M424.1,310.3c.4-3.5,5.2-.6,2.5,2,.8-.1,1.2.2,1.3,1.1,2.3,1.3,2.7,2.8,1.2,4.4,0,.2,0,.4,0,.5-.5.4-.8.8-1,1.5,0,.2,0,.3,0,.5-.4,2.5-1.3,4-2.5,4.5-.5.7-1.2.6-1.9-.5-.7,1-2.3.6-3.1-.1-.9.6-3.7-.1-4.2-.7l-.3-1.2c-1.1-.7.5-2.8,1-1,.4.1.4.3,0,.5,2.6.7,1.2-3-.2-4.7.2-1.2,1-3.5,2.1-4.4-3.4,1.7-5.3-3.6-1.3-2.9,3.4-1.3,4.9-1,6.9,1.4.4-.2.4-.3,0-.5-.7.5-.9.2-.5-.5Z"
          fill="#010ac1"
        />
        <path
          d="M431.6,311.3c0,.5,0,1,0,1.5-.4,2.2-.7,3.5-2.5,5,.7-2.9-.3-1.8-2-3.9s-.4-1.5-.5-1.6c-.1-.9.5-1.2,2-1.1,0-2.4,3.2-2.1,3,0Z"
          fill="#0109b8"
        />
        <path
          d="M425.1,328.2c-.7-.5,0-1.4.5-2,.1-.4-.1-1.1,0-1.5.3-.9,1.3-.9,1.4-1.1s-.9-2.6,1.1-3.4c0,1.1-.1,2.1-.6,3.1l-2.4,4.8Z"
          fill="#0109b8"
        />
        <path d="M429.1,318.3c-.2.6-.5,1.1-1,1.5,0-.3-.7-.9-.5-1.5h1.5Z" fill="#0109b8" />
        <path
          d="M428.1,315.8v1.9c-.7.1-.5-.9-.9-1.3s-1.4.4-2,.3c-.6-1.6,2.8-1.3,2.9-.9Z"
          fill="#0109b8"
        />
        <path d="M417.1,321.2c.1-.1-.1-.9,0-1,1.1-.9,1.8,2,0,1.5v-.5Z" fill="#0113cc" />
        <path d="M424.6,310.8c.2.1,1-.3,1,.2,0,.5-.6.1-1,.2v-.5Z" fill="#010ebf" />
        <path d="M421.6,308.8v1s-2,0-2,0c.3-1,1.1-1.1,2-1Z" fill="#010ac1" />
        <path
          d="M429.1,298.8l-.5,2c-1.7.4-.7-1.2-1-1.5-1.1-1.2-.9,1.4-1,1.5-.9.8-3.3-1.8-3.5-.2s.8,1.2,1.5,1.3c.2.8-.5.4-.6.5-1.6,2.2,1.5,1.7,2.6.5,1,1.9-.7,1.1-.5,3l-.5-1.5h-1.5c0,.7-.2,1.4.2,2s4.4.8-.2,2l.5-1c-3.8-1.6-3.1,1.2,0,1.5l-1,.5c-.3.9.3.8.5,1s.4.4.5.5c.4.1.4.3,0,.5-2.1.6-.5-.8-2.3-1s-4.7,0-4.5,1.1c-3.5-2.4-1,1.1,0,1s.4-2.7,1.7-.7-.8,1.9-.9,3.4,1.7,2-1,1.5l1.7,2.2.7-1.5c-.1,1.1.3,2,1.5,2,0,1.1-1.9.2-2.5.5s1.1,4.2-2,2c.4-.5.4-.7,0-.5,0,0-1.4-.2-1,1,0,0-.2.5-.5.5-.2-.6-.3-1.6-.5-2,1,0-.5-1.4-1.3-1.8-1.8.9-3-2.8-.6-2.2.6-1.5,0-2.4-1.7-2.8-2.1-3.7-1.4-6.6,2.2-2.7h1.1c0-1.4-.3-2.7-1-3.9l1.1-1c3.4,0,3.7-.3,2.8-3.8.9-.8,1.2-1.7,1.1-2.8l1.5-.9,1-.6c.6-.7,1.6-1,3-.9,1.1-1.2,4.9-.3,5,1.5Z"
          fill="#0110c8"
        />
        <path d="M417.1,308.3c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#0217d2" />
        <path
          d="M394.6,328.2c.3,2.3.3.9,1.7,2.1,3.1,2.7-.5,3.2-.7,2.9s.2-1-.1-1.4-.8,0-.9-.1c.2.1,1,3.4,1.5,4l2-.7c0,1.2-1.8,1.5-1.5,2.7l1,.5-1.2,1-.8-1.5-1,1.5c-.3,0-.5.7-.5,1-1.6-.5-.4-1.7,0-3-2.5-.6-.9,2.6-3.5,2l1-1.5c-.3,0-.8,0-1,0-.8.3-.9.2-.5-.5v-.5c-.6-.8-.3-1,.5-.5l-.5-1c-1.3,2.6-2.1-1.4,0-2l.7-.6c-.9-1.9,2.3-4.4,2.6-1.7l1.1.7c-1-.3-1.9-1.3-1.8-2.4h-.7c-.6-.3-.9-.6-1-1.1-.4-.1-.4-.3,0-.5,1.3-1.3,2.4-1.2,3.5.5Z"
          fill="#0127dc"
        />
        <path
          d="M409.1,319.3c-.4.2-2.4.9-2.5,1-1.1,1.3,2.7.7,1.5,2s-2.2,0-2.5,0c-1.3,0-2.4,1.1-2.5,1-.1-.2.1-1.1,0-1.5-.4-.3-.6-.7-.5-1l3.5.5-1-2c.6-.7,3.7-.8,4,0Z"
          fill="#0118d0"
        />
        <path
          d="M395.6,323.2c.4.5.2,1.1-.5,1,.6,1.2,1.6,1.3,3,.5,0,1.1.2,2,.5,3-2.5.3-2.5,0-4-1.5,0,0,0,.7,0,1-3.1,1-2.3-3.3,0-1-2-.4-2.8-2.9-.5-2-1.4-1.1.9-2.8,1.5-1Z"
          fill="#0223dc"
        />
        <path
          d="M406.1,323.2l-.5,5c0,0-1.7-1.3-2-1.5s0-.4,0-.5l.5-2.5c.1,0,.4,0,.5,0,.3-.4.7-.5,1-.5.2,0,.3,0,.5,0Z"
          fill="#010fc5"
        />
        <path
          d="M403.6,316.8s.7.1.5.5-1.5.9-2,1.5c-1.3,1-1.3.2-.5-1-.7-.6-.3-.8.5-1,.2-.2.4-.3.5-.5h.5l.5.5Z"
          fill="#0228dc"
        />
        <path d="M404.1,323.7l1.5.7-2,1.8c-.3-.2-1.2.4-1-.5,2,.1-.2-1,1.5-2Z" fill="#0118d0" />
        <path
          d="M402.1,319.3c.6.4,1.7.3,1.5,1h-1.5c0,.6.5.5.5.5.2.3.4.7.5,1l-2-1.3c-.4-.8.7-.8,1-1.2Z"
          fill="#0228dc"
        />
        <path
          d="M394.1,324.2c-.2.1-1-.3-1,.2.7.4,1,1.2,1.5,1.8,0,0-1.5-.5-1.5-.2,0,.9.8,1.2,1.5,1.2,0,.3,0,.7,0,1-1.1-1.2-2.1-.6-3.5-.5-.9-.1-1-.9,0-1,.6-1.1.7-1.8.3-2.3.5-1.4,3.6-2,2.7-.2Z"
          fill="#022bde"
        />
        <path d="M400.6,318.3c-1.9.3-.5-.7-.5-1l.5,1Z" fill="#0223dc" />
        <path d="M405.6,323.2c-.3,0-.7.4-1,.5l1-1v.5Z" fill="#0118d0" />
        <path d="M410.1,320.3s.5,0,.5.2c-.1.8-1.1.9-1.5-.2l.8.5.2-.5Z" fill="#0118d0" />
        <path d="M403.6,329.2c0-.2-.2-1,.2-1l.8,1c-.3,0-.8,0-1,0Z" fill="#0110c5" />
        <path
          d="M332.7,400.7c0,.1.7.4.7.9s-.4,1.4-.2,1.6,2-1.2,2.5.3-.7,0-.9.5-.7,2.6-.6,2.7c.1.2,2-1.1,2.5.3s-3.9,1.3.5,3.2c1.2-1.5,2.7-.2,2,1.7l1.4.2c1.4,1.5,3.2,2,5.6,1.6.3,0,.7,0,1,0-1.9,1-3.4,2.2-5.5,3l-.5.5c-.2,0-.5,0-.5,0-2.8.5-4.9-.1-6.3-2-4,2.7-4.2-1-3.1-4,0-.1,0-.3,0-.5.2-.1.2-.3,0-.5-.2-.9-.2-1.9-.5-2.8l1.2,1.8c1.4-1.3-.9-2.3,1.8-2v-1.5c-2.1,1.8-1.5.2-2.5-1.2s-1-.3-1-.3c-.7-1.1.8-.9,1.5-1.5s.3-.7.5-1c-.2-.5-.1-1,.5-1Z"
          fill="#011d5e"
        />
        <path
          d="M336.7,401.2c.6-1.3,2.5-2,3.5-1-.5,2.9,1.4,5.9,0,8.5.6.7,2.4-2.6,3-2,.9.9-.9,1-1,1.3s.5.8.2,1.2-3.3,1.4-.3,1.2c-.5,2.7.7,2.9,3,2.3-.8,1.6.3.3,1,1-1.1.3-2.4,1.2-3.3,2-1.6.3,0-1.3-.2-1.5-1.3-.9-1.3,1.5-2.5,1v-2.5c-1-.2-.3,1.2-.5,1.4s-1.4,0-2,0l1-1-1-2,1.5-.5c-.7,0-1.3-.2-2-.5-1.3-1.5.7-2,1.5-2.7-2.9-1.2-3.4-3,0-2.5-.5-.7-1.9-1.6-2.2-2.2s.3-1.2.2-1.5Z"
          fill="#021850"
        />
        <path
          d="M330.2,393.2c.2,0,.7-.1,1.1,0s2,1.9,2.1,1.9c.3,0,.9-.6,1.3-.4s-1.1,1.7,1.5,1.5l-2,2.3,2,1.7c1.2-.4,1.4-.1.5,1,1.3,1.1,2.1,2.5,2.4,4.2l-1,.7c1.7.8,1.4,2.2-.8,4.2-1.1,1.4-2.6-.6-3-1.7s-.2-2-.2-2.7c-.6-.2-.7-.8-.3-1.8-1-.4-1.3-1.5-1-3.4-.4-.6-.5-.3-.5,1,.9.6.5,1.3-.5,1-1.3-.7-1.9.2-3-1.3,0-1.2,1.7-1.2,2-2.1s-1-4-.4-4.7,1,.3,1-.2l-1-1.3Z"
          fill="#021a56"
        />
        <path d="M332.2,401.7c-1-.6,0-3.3,1-2.5,0,.5-.6,1-.5,1.5,0,.4-.3.7-.5,1Z" fill="#022066" />
        <path d="M331.2,401.7c-.6.3-1.7-.8-1.5-1,.6-.3,1.7.8,1.5,1Z" fill="#022066" />
        <path d="M301.2,364.7s.3,0,.5.2l-.3.3c-.9,0-.7-.4-.7-.5.1-.3.3-.3.5,0Z" fill="#02227a" />
        <path d="M301.2,364.7h-.5c-.3-.2-.3-.3-.5-.5.9-.4.9.5,1,.5Z" fill="#011b65" />
        <path
          d="M302.2,364.7c1.4-.4,4.9-1.5,4.4,1.2,1.3,0,3.3,1.4,3.6,2.8.2,0,.7,0,1,0l-.5,1h2.5s-1,1-1,1c1.8-1,1.4.5,3,1.3,0,.9-2.7-.3-.5,2.7s1.9,2.3,3,2l-.5,1.5c.8,1.7-2.7,2.1-3.5,1l-1-.5c-.1.4-.3.4-.5,0-.5-1.3-1.3-2.1-2.5-2.5-.3-.1-.3-.3,0-.5-.4-.1-.4-.3,0-.5-1.7-.9-2.4-2.3-1.9-4.4-3.4-.3-4.9-1.4-4.7-3.3-.9-1.2-1.2-2.1-.9-2.7Z"
          fill="#021c63"
        />
        <path
          d="M303.2,362.2c1.1.4,2.7.6,3.6,1.1s.8,1.8,2.4,1.4l-1,1.5c1.4.6,3.1.7,2,2.5-2.3-.9-1.4-2.7-4.5-1.5-.5-1.3-.3-1.5.5-2.5-1.7.7-2.2,1.1-4,0-.5-.1-.5-.3,0-.5-1.1-.8-.1-1.8,1-2Z"
          fill="#01175a"
        />
        <path
          d="M299.2,362.7l.3-.5c1.1,0,1.1,1.8,2.7,2,0,.1,0,.4,0,.5.1.7,1.5,1.8,1.8,2.5s-.3,1.4-.3,1.5c.2.2,5.3,1.2,5.5,1.5s-.6.9-.5,1h1.5c.1,1.9,0,1.7-1.5,1v1.5s1.5-.5,1.5-.5c.3.8-.4,1.5-.5,2-.1.4-.7.6-1,.5-1.8.6-3.3.6-4.5,0-1.8-.4-1.4-2.2-1.1-3.6-1.4-1.5-2.5-3.1-.9-4.9-1.3.1-1.4,0-.5-1q.2-.2,0,0c-1.6,2.6-4.8-3.5-1.5-2,.4,0,.6.1.5.5.4.3.6.3.5,0l-1-.5c-1.3.7-2-.4-1-1.5Z"
          fill="#022171"
        />
        <path
          d="M309.7,375.2c0,.2,0,.3,0,.5-.3.4-.5.8,0,.5,2.1-1.3,3,.7,2.5,2.5-1.5-.6-2.1-1.5-2.2-1.5-.7.2-1.9,1.5-3.3,0s1.3-1,2-1.5.5-.6,1-.5Z"
          fill="#022474"
        />
        <path d="M307.7,368.7h-1.5s0-1,0-1c.7-.2,1.3.3,1.5,1Z" fill="#022171" />
        <path d="M314.2,376.2v.5c-2.1.2-2.1-.7,0-.5Z" fill="#022474" />
        <path d="M313.7,379.2c-.4-.1-.8,0-1-.5.3.1.9-.1,1,.5Z" fill="#022474" />
        <path d="M313.4,377.7c.3.2.3.3,0,.5v-.5Z" fill="#022474" />
        <path d="M301.7,366.2c-.2-.2.5-.8.5-.2s-.4.4-.5.2Z" fill="#021c63" />
        <path
          d="M301.7,377.7c.7,0,1.4,0,2,.5-.2.2-.8.4-.9.6-.1.3.3.6.4.9v1.2c-.5,1.3-.2,3.1,1,5.3h.5c2,1.5-.5,3.1-2,1.5-1.1.3-2.1.3-3,0-.7,1.8-2.1,2.4-2.6.1s.1-3.7.6-2.2-.7.4-1-.4c-1.5-.2-1.6-1,0-1,.7-2.1,1.4-2.6,2-1.5,1.5.2,1.4-1.3,0-1,0,.8-1.5.9-1.5,0-1.2,1-2-.3-2.4-1.7,2.3-1.1,2.9-2,1.8-2.7,1.2-2.1,2.9-1.9,5.1.4Z"
          fill="#022b8a"
        />
        <path
          d="M303.2,379.7c1.3,3.4,1.3.5,3-.5-1,2.4,0,1,1,1.8s.9,1.7,1,1.7c.2,1.4-.1,2.2-1,2.4-.4,1-1.4,1.3-3,1-2.7-1.4-1.4-1-1.8-2.5-.5-2.2-1.6-2.2.8-4Z"
          fill="#023290"
        />
        <path
          d="M309.7,384.7c1.5-.7,3.3-.9,5.5-.5,1.1,1.8,1.9,4.1-1,4-1.8.6-1.8.8,0,.5,2-.3-.5,1.3,1.5,1,0,.6,0,2.4-.4,2.7s-3.3.4-4.1.3c-1.1-1.2.2-.5-.1-.4-.7.1-2.9.2-2.9-.6-.5.6-1.7-1.5-1.7-1.7s2-3.1,2.2-2.3c.2-.2.5-.4,1-.5-.6-.2-.7-1-.5-1.5-.6-.3-.4-.6.5-1Z"
          fill="#022b80"
        />
        <path
          d="M309.2,383.2c.5,0,.3-.2.5-.5,1.4.5,3.7,0,5,.5.4.7-1.7,2.1-1.8,1-1.8-.3-2.9-.2-3.2.5-.9,1-1.5,1.2-2,.5.3.9-.1,5-.7,5.1s-1.5,0-1.6,0c-.1,0-1.2-2.8,0-2.6-.5-.2-.7-.7-.7-1.5-.1,0-.4,0-.5,0l3.5-1.7c0-.9-4,.8-3.5-1.2,1.7.9,2.7-.3,4-.5.5-.2.9,0,1,.5Z"
          fill="#022b80"
        />
        <path d="M309.2,383.2c-.5,0-.9-.5-1-.5.2,0,1.3-1.3,1,.5Z" fill="#022474" />
        <path
          d="M289.2,361.7c1.8,0,1.3.4,2.5,1.5,1,.7,1.8,1.5,2.5,2.5v.5c-.1.8.2,1.6.8,2.3l-.3.7.5,1c0,0,.7.3.5,1l-1.5.5c.6.4,2.9-.1,3,0,.5.8-1,1.4-1.5,2-.9-.2-1,.3-1.5.5.5,1.7,0,2.4-1.9,2.3-.2,2.9-2.1,2.9-2.6.2-3.1-1.1-.9-4.7,1-5.5.5.3,1.5,1,1,1.5q-.7.8,0,0c-1.1-2.8-2.8-5.1-5.1-6.9-.8-1-1.6-3.1,0-3.1h.7c-1-.6.7-2.2,1.8-1Z"
          fill="#02309e"
        />
        <path
          d="M296.7,374.7c.4.4,0,.8-.5,1-1.4.7-2-.4-1-1.5.2-.2.4-.3.5-.5.6.1.7.6,1,1Z"
          fill="#02309e"
        />
        <path
          d="M294.2,366.2c1.6-.3,2.1,0,2.5,1.5-.1,0-.3.4-.5.5,0,.4-.4.8-1,1-.1.4-.3.4-.5,0,0-.5-1.9-1.5-2.5-1.5-.3-.4,1.5-1.4,2-1.5Z"
          fill="#022d93"
        />
        <path
          d="M292.2,363.2l1,1c-.3-.8.5-1.5,1-1s-1.3,1.4.5,1.8l-.5.7-2.5,1,1-2.5-2.5.7c1.1-.2,1.3-1.6,1.5-1.7s.3,0,.5,0Z"
          fill="#022d93"
        />
        <path
          d="M288.2,356.7c-.4,1.2,0,1.9-.5,3h2s-.5,1.5-.5,1.5c-1.1-.1-1.7.1-1.8.7l-.7-.2c-.5,1.5-1.4,1.3-2,0,0-.1.3-.4.3-.7-.1-.9-1.1-.8-.3-2.3s1.4-.2.5-1.5l1.5.5,1.5-1Z"
          fill="#02309e"
        />
        <path
          d="M289.2,361.2v.5c-.5,0-1,0-1.5,0l.5,1-1.3.5-.2-.5c-1.1,0-1.1-.7,0-1,.3-.1.8-1.7,2.5-.5Z"
          fill="#02278f"
        />
        <path
          d="M281.2,341.2c.2-.2.3-.4.5-.5,1-.7,3.1,3.9,3.4,5,1.4,1.6,2.1,3.1,2,4.5l1.6.7c0,1.5.4,2.9.9,4.3-1.8-.6.3-3.5,1.5-1.5-.3,1.5.2,1,.5,2.5-.7-.5-1.1-.7-2-1,.2.6,1.3,1,2,2.5s.5.7.5,1c-.7,1.3-1.2,2.5.2,3.3l-.2.7v.5c-.2.4-.3.4-.5,0-1.2.8-2-.6-2.5-1.5-.4-.1-.4-.3,0-.5-2.4-1.4-3.2-2.3-1-4.5-.7-.6.3-.6.2-.5-1.7.6-3.5-1.5-3.4-3.2-.9-1.1-2.1-2.8-1.8-4.3-.4-.1-.4-.3,0-.5l-1-.5c-2.3.8-2.6-1.4-.5-2-2-1.2-2.4-3-.5-4.5Z"
          fill="#02208a"
        />
        <path d="M292.2,358.7c.1.7-.5,1.7-.4,1.9s3.2,1.9.4,2.1l-2-1.8,2-2.2Z" fill="#043095" />
        <path
          d="M280.2,339.2c1,.1.6,1.9-.5,2,.7-1.3,1-1.5,1.5,0,0,1.1.1,2-.5,3l2-.5-1,1c1.1,0,1.3,1.1,2,1.8l-2.5.3c-.1.5.6.7,1,1-1.3,0-.8,1.8-3,.5-2-.9.4-2.3.1-1.2s-.7.2-.1-.8c-1.7-1.4-2.6-5.4-.2-4.7l.7-.3c-1.2,1.2-3.3-.7-1.5-2,.8-1.2,1.4-1.2,2,0Z"
          fill="#0226a1"
        />
        <path
          d="M287.2,350.2c.5.1,2.9.4,3,.5,1,1-1.3.8-1,1.5l2.5-.5c.2.7-.4,1.1-.5,1.5s0,.3,0,.5c-.7,0-1.8.6-1.5,1.5-.4-.1-1.3.1-1.5,0s1.2-3.7-1.5-2c.3-2.3,2.6-.5.5-3Z"
          fill="#011b7b"
        />
        <path d="M290.7,359.2c-.9.2-1.7-.5-1.5-1.5l1.5,1.5Z" fill="#02309e" />
        <path
          d="M279.7,337.2c0,.3,0,.7,0,1s.5.7.5,1c-1.6-1.3-.4,1.3-2,0-1.6,0-1.7-2.1,0-2,.1-1,.9-.6,1.5,0Z"
          fill="#011b9a"
        />
        <path
          d="M280.2,330.7c.5,1.7,1.7,1.8,0,2.2,1.4,1.5,2,3.5,3,5.3.8,3.9,3.1,7.7,6,10v.5c-.7.3-1.8.7-2,1.5-.9-1.1-2.6-3.8-3.1-5.1s.2-1.3,0-1.7-2.4-2-2.9-2.1l-.6-.3c.5-1.4.2-2.3-.9-2.7-.9-.3-.9-.7,0-1,.2-.5.2-1,0-1.5-1,0-2-3.1-1-3.5.1-1.2.6-1.7,1.5-1.5Z"
          fill="#011475"
        />
        <path
          d="M283.2,338.2c.6,1.1,4.1,7.8,4.5,8.2.6.7,2-.3,1.5,1.8-1.9,0-3.2-2.4-4.2-4.1s-2.6-4-1.8-5.9Z"
          fill="#011268"
        />
        <path
          d="M278.7,332.2c.3,1.2.4,2.4,1,3.5,1.8,1.6-.9,1.3-1.5.5-1.3-.8-1.7-3-1.5-4.5-.4-.1-.4-.3,0-.5,1.2.3,1.7,1.1,1.5-.5,0,.4.3.8.5,1.5Z"
          fill="#011b9a"
        />
        <path
          d="M281.2,341.2c-.3,0-1.4,0-1.5,0,.3-.2.5-1.5.5-2-1.1-.5-1.3-.9-.5-1l1.5-1c.3,1.5,0,2.8,0,4Z"
          fill="#011a87"
        />
        <path
          d="M278.2,336.2l.2-.5,1.2,1v-1c2,.5,1.9,1.1,0,1.5s-1,0-1.5,0c-.4-.2-.4-.3,0-.5v-.5Z"
          fill="#011a87"
        />
        <path d="M286.9,348.7c.3.2.3.3,0,.5v-.5Z" fill="#011268" />
        <path
          d="M274.7,274.3c.4,0,.4.3,0,.5l.6.5c-.4.4-.4,1.1,0,2,.7-.7,1.3-1.3,2-2-.3-.8-.4-1.7,0-2.5.1-.4.3-.4.5,0,0,4,0,8,0,12,0,.7,0,1.3,0,2h-.5l-.7-.8c.4,3.5.2,6.8-1.2,9.8,1.3,1,1.9,3.1-.1,2.5-1.3,1.4-3.1.8-2-1-.4-.8-1-1.5-1.9-1.9.4-2,.5-3.7,0-5.8,2-.9,2.3-1.3,1-1.3-.4-.3-.3-.5-.1-.8-1,1.4-2.2,1.1-1.9-.7l.2-.8c2.1-.7,1.6-3.7,1-5.5.5-.9.8-1.8.9-2.8-1.1,0-1-.8,0-1v-2.1c-1-.6-1.1-1.3,0-1.9.2-.8.5-1.1,1-1,1.7-1.1,2.4,1.4,1.5,2.5Z"
          fill="#021bc2"
        />
        <path
          d="M277.2,286.8c0,6.3,0,12.7,0,19-1,.3-1.9-.4-2.5-2.3-1.3-.2-.9-4,.5-4.7-.4-.2-.4-.3,0-.5,0,0,.6-.4.5-.7-.2-.6-1.4-.6-1.5-1.1s.8-1.7,0-2.4c2.5.7-.1-2.1,0-2.2h2c-.4-.6,0-2.4,0-2.5-.1-.2-1.6,1.1-2,.3.4-.8,1.7-.6,2-.8s-.4-1.9,0-2.4l-2,.5,1.5-2-2.5-1c2.4-.2,2-1,3.5,1l.5-2c0,1.3,0,2.7,0,4Z"
          fill="#0312bb"
        />
        <path
          d="M275.2,310.3c0-.5.7-1.1,1.1-.9.8.3.3,7.6,0,9.1-.2.7.2,2.1.8,2.8,0,1,0,2,0,3-.2.2-.9.4-1,.5-.8.9-1.3.7-1.5-.5-.9-.4-.3-.7.5-1-.4-.1-.4-.3,0-.5l-.5-.5c-.6-.3-.7-.9-.5-1.5-1.6.2-2.3-3.2-1-4-1.3.1,0-6.3.2-6.6.4-.6,1.6-.6,1.8.1Z"
          fill="#021db9"
        />
        <path
          d="M275.2,298.8c0,.2.5.6.5.8,0,.3-1.5-.4-1.5.7l2.5.8-2.5,1.2,1.2.5,1.8,3c0,1.2,0,2.3,0,3.5-.4.6-1.1.6-2,0-.3,1-1.5.5-1.5-.5-.5.9-1.8,1.3-2,0-1.5-.5-.5-1.9.8-2.5-1.8-1-1.2-3.6.7-3.5-.6-3.2,0-4.6,2-4Z"
          fill="#021bc2"
        />
        <path
          d="M277.2,309.3c0,4,0,8,0,12-2.2,1.2-.9-1.4-1-1.5-1.4,1-.9-.4-2-1.3,2.2,0,1.9-2.5,2-4.2-.9-.3-.2,1.2-.7,1-2.9-1.2,4.1-2.9-.3-3l1-.5v-2c-.1-.2-.7.4-1,.5-1.3-.1-1.2-.6,0-1,.3,0,1.3-.7,2,0Z"
          fill="#0211b3"
        />
        <path
          d="M275.2,323.2c0,.3-.4.7-.5,1,.6,0,1.1,0,1.5.5-.6,1,0,1.4-.2,1.9s-.7,0-.8.4c-.2.9.7,3,0,4.2.5,0,1.1,0,1.5,0v.5c.8,2,.2,7.2-2,3.5l-.5.5c.1-2-.2-4.1-1.9-6.5.1-.8.6-1.3,1.4-1.3-1-2.2-.7-3.4,1.1-3.6-.9.9-1.4.9-1.5,0-1.4-1.6,1.3-2.9,2-1Z"
          fill="#0126c1"
        />
        <path
          d="M368.1,322.7c1.3.6,3.2,4.4,2,5.5,2.4,2,4.1,6.2,4,9.5,1.4.2,1.7,1.5,1,4,0,.2,0,.3,0,.5-.2.2-.3.2-.5,0-1.7-4.3-3.2-8.7-5-13l-.5-.5c0-.1,0-.4,0-.5l-.5-.5c-.6-1.4-1-3.1-1.5-4.5-.2-.7-.2-.9.5-.5.2-.5.3-.4.5,0Z"
          fill="#0b28b7"
        />
        <path
          d="M364.1,312.3c3-.2,3.6,2.4,1,3,1.1.7,1.6,1.8,1.5,3.5,1.4.2,1.5.5.6,1.5,1,.6,1.1,1.4.4,2.5-.2,0-.4.3-.5.5-.9-2.4-2.8-5.3-3.5-7.5-1.2,0-1.7-1.9-.5-2.5v-.5c.3-.8.6-.9,1-.5Z"
          fill="#092dc6"
        />
        <path d="M375.6,343.7c-.2,0-.4-.3-.5-.5h.5v.5Z" fill="#022bde" />
        <path d="M375.1,342.7c-.2-.1-.4-.3-.5-.5h.5c0,.2,0,.3,0,.5Z" fill="#022bde" />
        <path d="M369.6,329.2c0,0-.4-.2-.5-.5l.5.5Z" fill="#0230dc" />
        <path d="M369.1,328.2c0,0-.4-.2-.5-.5l.5.5Z" fill="#0230dc" />
        <path
          d="M247.2,452.7c.4.1.4.3,0,.5-3.5,0-6.7-.3-10-.5,0-.3.3-.4,1-.5,2.9-.5,6.1-.1,9,.5Z"
          fill="#020127"
        />
        <path
          d="M250.2,452.7c2.5.1,3.9-.1,6.5.5-3.2,0-6.3,0-9.5,0v-.5c.8-.5,2.2-.4,3,0Z"
          fill="#01013c"
        />
        <path
          d="M231.7,451.7l4.5.5c.6-.6,1.3-.6,2,0l-1,.5c-2-.1-4,0-6,0l-1-.7.5-.3c.3-.5.7-.5,1,0Z"
          fill="#050415"
        />
        <path
          d="M281.2,448.7c-1.3,1.3-4.9,1.6-7,2l-2.5.5c-1,0-2,0-3,0-1.1.1-2.3.3-3.5.5-5.1.2-9.8.6-15,.5-5.5.3-11.1-.1-16.5-1l-1-1h1c.5,0,1,0,1.5,0,2.1.2,4.1.4,6,.5,7.1-.9,14.3-.9,21.5,0,1.1-.4,2.4-.4,3.5,0,.8-.2,1.6-.3,2.5-.5.3-.4.6-.3,1,0,2.1-.3,4.3-.6,6.5-1,.4-1.4.8-1.2,1.5,0l2.5-.5c.3-1,.7-1,1,0Z"
          fill="#3c80e3"
        />
        <path
          d="M268.7,451.7c.8,0,2.1-.3,2.5.5-1,.1-2,0-3,0-.4-.1-1.2.2-1.5-.5.6-.4,1.3-.4,2,0Z"
          fill="#010152"
        />
        <path d="M268.7,451.2v.5c-.7,0-1.3,0-2,0s-1,0-1.5,0c.7-.9,2.4-.5,3.5-.5Z" fill="#3e79dc" />
        <path d="M274.2,450.7c-.5,0-1.3.4-2.5.5.4-.9,1.8-.4,2.5-.5Z" fill="#3b7ce1" />
        <path
          d="M233.7,451.2c5.4.2,11.1.9,16.5,1v.5c-1,0-2,0-3,0-3-.1-5.9-.5-9-.5s-1.3,0-2,0l-4.5-.5c-.3,0-.7,0-1,0s-2.5-.7-3-1c2.1,0,3.9.4,6,.5Z"
          fill="#3170e2"
        />
        <path
          d="M276.2,440.2c.8,0,2.7,1,4,.5-1,3,0,3.6,2,1l.5,1.8c.1,1.1-.1.6-.8.7-1,.2-2,.4-3,.5-1.6.2.6-1.2-.9-.9s-2.2.3-1.8,1.4c1.6-.9,2.7.8,4.5.5l-.5,1,1.8.5c.6-2.2,1.2-.7,3.2-1.5l-.5,1.5c1.7.2,3.3-.8,4.5-1s2.1.1,3,0c-2.1.3-5.3,1.5-7.5,2-.2,0-.3,0-.5,0-.6,0-1.5.1-2,0-1.6-.2-3.3-.4-5-.7-.5,1.5-9.8,1.8-10,1.2.2-.8-.3-1.5-1.5-2.1-.8-.2-1.3-.9-1.5-2-.1-.3-.8-3.2-.6-3.2.7-.2,2.9,0,3.5.3,1,.7-1.3,1.4,0,.4s.5-.6.7-1c0-.2,0-.4.5-.5,0-.4.3-.4.5,0,2.7-1.2,5.2-1.4,7.5-.5Z"
          fill="#010e87"
        />
        <path
          d="M314.7,429.2c2.1-.7,3.2-.3,1,1-4.7,1.4-9.3,3.2-14,4.5s-3.3,1.2-4.5,1.5-4,.8-5.5,1c-1.2-.4-2.5-.4-4,0-.5.7-2.2.8-2.5,0,0-1.2.6-1.8,1.3-.8,4-.9,8-2,12-3.1,1.3,0,2.5-.1,3.7-.6,1.9-1.7,3.4-2,4.5-1,2.2-2,4.5-2.8,7-2.5.3-1.3.6-1.3,1,0Z"
          fill="#1355ca"
        />
        <path
          d="M287.7,437.2h.5c.4.1.4.3,0,.5l-1.5.5c-.3,0-.7,0-1,0l-2,.5c-1.3.2-2.6.3-4,.5l-2.5.5c-.3,0-.7,0-1,0-.8.6-3.4.3-2.3-.8l5.8-.7c.4-1.5,1.6-1.8,2.5-.5.8-.4,1.6-.5,2.5-.5.2-.4.3-.4.5,0,.8,0,1.7,0,2.5,0Z"
          fill="#1655d4"
        />
        <path
          d="M279.7,438.2c-1.8.4-3.6,1-5.5,1-.1.9,1.4.5,2,.5v.5c-2.5-.1-5,.4-7.5.5,0-.3,0-.5,0-.5.5-.2,1.7-.3,2.3-.3s-2.6.6-2.4-.1c2.4-2.4,8.1-3.2,11-1.5Z"
          fill="#074dcb"
        />
        <path
          d="M287.7,437.2l4.2-1-.2,1c-.3,0-.7,0-1,0-.7.4-1.8.4-2.5,0-.2,0-.3,0-.5,0Z"
          fill="#1553ce"
        />
        <path
          d="M324.7,426.7v2.5c-.6.4-2.9-1.6-1.5.5-2.1-.1-1.2,0-1.3,1.5s-.4,2.6-1.2,1c.1-.3.6-.9.5-1l-1.3-.5-.2,1.5c-2.2.2-3.5.6-5.5-.5l2-1.5c0-.4,0-.7,0-.8.8-.7,6.3-2.7,7.7-3.1s.4.2.7.4Z"
          fill="#011275"
        />
        <path
          d="M332.7,421.7c2.4-1.4,2.3.5,0,1-.1,0-.3,0-.5,0l-.5.5c-.1,0-.4,0-.5,0l-.5.5c-.1,0-.4,0-.5,0l-.5.5c-1.6.9-3.3,1.8-5,2.5-2.7,1.2-5.9,1.9-8.5,3.5h-.5l.5-1c-.5,0-1,0-1.5,0,3.3-2.6,7.1-4.2,11.5-5,.6-.2,1.4-.3,2-.5l1-.5c.1,0,.4,0,.5,0l.5-.5c.1,0,.4,0,.5,0l.5-.5c.1,0,.4,0,.5,0l.5-.5c.1,0,.3,0,.5,0Z"
          fill="#114cba"
        />
        <path
          d="M340.2,418.2c.2,0,.6.2.5.5-1.5.8-3.5,2.3-5,3s-1.5.8-2,1-.7,0-1,0l1-.7c0-.4-.7-.3-1-.2.6-.4,1.4-1.2,2-1.5-.3-1.7,4.6-3.5,5.5-2Z"
          fill="#1248b0"
        />
        <path d="M331.7,423.2l.5-.5c-.1,0-.3.4-.5.5Z" fill="#1248b0" />
        <path d="M330.7,423.7c.1-.2.3-.4.5-.5-.1.2-.3.4-.5.5Z" fill="#1248b0" />
        <path d="M329.7,424.2c0,0,.2-.3.5-.5l-.5.5Z" fill="#1248b0" />
        <path
          d="M335.7,421.7c2-.5,2.8,0,2.3,2.1-1.6,1.5-.6,2,1.3,2.1.7,1.2,1.1,1.6,2.5,1.7l.4,1.1c-2.3,1.1-5.2,2.4-7,4-.2,0-.3,0-.5,0l-1,.5c-1,.3-2.6.7-3.5,1l-1,.5c-.1,0-.4,0-.5,0l-.4-.6c1.1.2,2.3-1.2,2.2-2.1s-2.2-1.4-2.3-2,.7-1,.8-1.6,0-1.6.1-2.3,1.4,0,.5-1.3c1.4.1,2.4,0,3.5,1l.5-3c-.2-1.2,1.1-1.9,2-1Z"
          fill="#010f61"
        />
        <path d="M334.7,432.7c-.1,0-.6.4-1,.5l1-.5Z" fill="#407bd2" />
        <path d="M330.2,434.2l-1,.5c0,0,.5-.3,1-.5Z" fill="#01116c" />
        <path
          d="M333.1,428.6c0,0-.6,0-.7.2-.3.6.2,1.5-.7,1.3l.5-3c.6.1,1.2.7.9,1.4Z"
          fill="#01116c"
        />
        <path d="M332.4,426.2c.3.2.3.3,0,.5v-.5Z" fill="#01116c" />
        <path
          d="M265.7,446.7c.4-.2.8-.5,1.2-.5.8.2.5,1.9,1.1,2,2.1.6,5.9-.6,8.2-.5,0-2.2-2.9.4-3-2.8-.3-1.5.9,0,1.4-.3s-.2-1.4,1.1-.9c.1.6-.2,2.2,0,2.5s3.8.7,4.8,1,1.5,1,1.7,1v.5c-.3,0-.7,0-1,0s-.7,0-1,0l-2.5.5c-.5,0-1,0-1.5,0-2.1.5-4.4.9-6.5.5-1.9.5-4.1.3-6,0-2-1.3-.3-1.8,1.5-1.8v-.7c-.7-.7-.4-1,.5-.5Z"
          fill="#010e81"
        />
        <path d="M341.2,417.2c.1-.2.3-.4.5-.5,0,.4-.1.5-.5.5Z" fill="#011c64" />
        <path
          d="M150.3,84.4l-4.5,3.5c-.2.4-.3.4-.5,0l-.5.5c-.2,1-1.4,1.4-2,.5l-.5.5-.3.7c-7,3.3-13.5,7.9-19.2,12.8-2.7,2.2-3.4,0-1-1.5,3.2-4.4,15-11.8,20-15l-5.5,4.5c.7.6,10.9-5.4,12.5-6.2s1.2-.2,1.5-.3Z"
          fill="#7085d6"
        />
        <path
          d="M147.8,87.4c.7.8.2,1.2-.6,1.6-7.1,2.7-12.9,6.8-18.9,11.6l-5.5,2.8c.5,1.3-2.5,2.7-3.5,2,0-.3.2-.6.5-1,.1-.7.3-1.3.5-2,.4-.3.5-1.2,1.5-1-.3.5-1.5,1.5-.8,2,2.4-.8,3.4-3.2,5-4.5,4.3-3.6,11.3-6.7,16.2-9.5l.5-.5c.6-.2,1.4-.3,2-.5l.5-.5c.2,0,.4,0,.5,0,.7-.3,1.6-.3,2-.5Z"
          fill="#667bd8"
        />
        <path
          d="M165.3,73.4l1.3,1.5c.9-.2,1.8-.4,2.7-.5l-9.4,4.4h-2.1c0,.1.3-.9.3-.9l-2.3,1c.2-.6,1-1.1,1.5-1.5,2.4-1.9,5.3-2.7,8-4Z"
          fill="#8191d6"
        />
        <path
          d="M95.3,128.9c3.4-.3.1,3.2-.5,3.5,1.6,1.2-1.8,5.6-3.5,5-.7,2.1-1.9,3.1-3.5,3-.3.8-.5,1.3-1,.5,1.3-3.1,3.5-5.8,5.5-8.5s2.1-2.4,3-3.5Z"
          fill="#15169c"
        />
        <path
          d="M87.8,140.3c.5,0,1.1.5,1,.8-.3.9-6.2,9-6.8,9s-.5-.1-.7-.3c-.2.7-.4,1.1-1,.5.4-.6.6-1.4,1-2,1.5-2.3,3.6-5.5,5.5-7.5s.8-.3,1-.5Z"
          fill="#13149a"
        />
        <path
          d="M79.3,156.3c.8,1.4-.5,2.7-2,2.5-.2,1.9-2.4,6.7-4,4.5.2-.4.3-1,.5-1.5,1.8-3.8,4.3-7.9,6.5-11.5.3-.2.7-.3,1-.5l.7.2c-.9,2-1.8,4.1-2.7,6.3Z"
          fill="#0a0c8f"
        />
        <path
          d="M115.8,109.9c1.3-.6,1.5.1.5,1,0,.4,0,.8-.3,1.1-1.1,1.2-8.5,7-9.7,7.1l-1-.8c.5-.6,1-1.4,1.5-2l7-6c.4-.6,1.6-1.3,2-.5Z"
          fill="#3347c9"
        />
        <path
          d="M119.8,104.4c-.1.5,1-.5-.5,1-1,1.7-3.4,4.1-5.5,4.5-1,.7-1.9,2-3,2.2,2-3.3,5.8-5.6,9-7.7Z"
          fill="#6f83d0"
        />
        <path
          d="M77.3,161.3l.4,1c-2.2,2.9-4.2,6.3-5.4,9.7s-.7,2.6-.5,3.5.2.9-.6.5c-.2,1.3-1.5.7-.8.1s0,.8-.8.6c-1.8,4.1-3.4,8.3-5,12.5.4.1.4.3,0,.5-.4.8-.7,1-1,.5-.9-.8-.9-2.3,0-4.5,0-.2,0-.3,0-.5l.5-.5c0-.2,0-.4,0-.5l.5-.5c-.3-.1-.2-.3,0-.5,0-.1,0-.4,0-.5l1-2c0-.1,0-.4,0-.5l1-2c0-.1,0-.4,0-.5l.9-.3c1.2-3.7,2.6-7.2,4.1-10.7.5-1.4,1-2.3,1.5-3.5,2.4.2,2.9-2.9,4-4.5,1.2,0,1.2.8,0,2.5Z"
          fill="#01038c"
        />
        <path
          d="M71.8,166.8c-1.3,3.7-1.7,7.9-3.8,11.5s-.8-.1-1.2-.5c1-2.7,1.8-5.4,3-8s.9-2.4,2-3Z"
          fill="#04088a"
        />
        <path
          d="M118.8,110.4c.5,1.5-1.5,3.6-3,3l-.7,1.9c-3.6,3-7.2,5.7-10.8,8.1-.5,1.3-2.2,1.9-2,0v-.5c-.2,1.3-.6,1.2-1,0v-.5c.4-.4.6-1.1,1-1.5.7-.8,2.3-1.7,3-2.5,4.3-.9,6.6-5.9,11-7.5-.2-1.2,1.9-1.6,2.5-.5Z"
          fill="#2033c7"
        />
        <path
          d="M98.8,125.9c1.3.7,1.2,2.3.5,3.5.6.1.6.4,0,1,.5,1.4-.2,1.7-1.5,1-.8,1.6-2.9,3.9-3,1,0,0-.5-.4-.5-.7s1.9-1.1,1.4-2.5l-.4-.3c.7-.8,1.3-1.7,2-2.5.6-.6,1.1-.7,1.5-.5Z"
          fill="#1319a9"
        />
        <path
          d="M101.3,122.9c2.5,1.3-.9,3.3-2.5,3-.1,0-1.3.5-1.5.5,1.3-1.5,2.8-2.7,4-4v.5Z"
          fill="#222bac"
        />
        <path
          d="M175.3,377.2c.8-.7,1.3-.3,1.5,1,.5,1.1-.4.7-.3.7,1.7-1.3.7,3.4-1.7,3.8-.8.9-1.4,2-1.7,3.3-1.7-.8-3.2,1.4-2,2.4l-.7,1.3c-1.5-.3-2.9,2-2.2,3.4-1.6,1.3-1.5-1.1-.6.2s.4.9,0,1.7c2.4,3.1-.5,4.8-3.5,3.5l-1.5,2.1c2.4,2,.2,3.7-1.3,1.6-.2.4-.2,1.2,0,2.3-1.2.8-1.5,1.2-1,1.2.4.1.4.3,0,.5,0,.6-.2,1.1-.8,1.1-.3,2.2-1.7,4.6-3.6,5,0,1.3-2.9.7-4.1.4-.6-.4-1.1-.8-1.5-1,.4-1.1.7-2.2.8-3.3l1.4-.6c-.6-2,.3-3.6,2.3-4.3.2-.7,1.5-3.1,1.9-3.3.7-.5,1.4-.4,2.1,0l1.4-7,1.1-.4c-1.3-2-.5-3,2.3-3.1.8-2.2,2.1-4.8,4.8-5.7-.5-1.5-.9-3,1.1-3.3-.9-.9,3-4.2,3.4-4.4.6.8,1.5.9,2.4.9Z"
          fill="#031645"
        />
        <path
          d="M161.3,385.7c1.9.3,2,4.4-.3,4.4.1,1.4-2.5,3.7-3.7,3.1.6,1.5.8,3,.6,4.3-3.2.7-3.7,1.6-1.8,4.3-1.3,1.5-2.8,2.9-4.4,4.2.2,1.2-.2,2.3-1.2,3.3.9,2,0,2.2-2.7.7-.1,0-.3,0-.5,0-.8-1-2-1.4-3-2v-.5c1.4-.8,2.4-2,3-3.5,1-.3,1.5-1.2,1.8-2.6,2.2-1,3-3,2.4-6l1-1c0-1.8.8-2.1,2.3-2.6-1.8-2.4.2-2.7,2.2-2.9.6-1.6,2.5-4.5,4.2-3.3Z"
          fill="#041230"
        />
        <path
          d="M161.3,392.7c-.6,1.7-.9,7.6-2.1,8.5s-1.7-.7-1.9-.5.1,1.3-.5,1.8-1-.3-1-.3c-.2.3.2,1.4,0,1.9s-1.8.4-1.9.6.5.6.3.9-.8,0-.9.4c-.1.6.6,1.5,0,2.3s-2,.7-2.1.8,1.1,2,1,2.7l-2-.3c-.4-.3-2.4-1.4-2.5-1.5l2.5.8-1.5-2.2c2.3.2,1-.3,1.1-.7s.8-.2.8-.6c.1-.5-.3-1.9,0-2.7,2.5,1.2.8-.1,1.5-.7s3-1.2,3-2-1.7-1.6-1.5-3,1.6,0,.5-2.3l3,.5c-.2-1.5-1.2-2.7,0-4h1.1c1-1.5,2.4-2.6,2.9-.5Z"
          fill="#03143b"
        />
        <path
          d="M160.3,406.2c3.3-1.5,3,1.5.4,3l.3.4c4,1.1,0,5.7-2.7,3.6l-.9,1.9c-1.6-.3-3.3-.9-5.1-1.9-.2-.1-.3-.4-.5-.5.8.3,4.2-.8,4.4-1.1.4-.4,0-1.6,0-1.9s.9.7,1.5-.2c1.3-1.8-.3-3.3,2.5-3.3Z"
          fill="#02174d"
        />
        <path
          d="M158.3,413.2l.6-.3c.7,1.1,1.5,1.3,2.3.8,2.5,2.5,2.1-1.7,1.8-3.9.3-3.3,4.4-.7,2.8,1.5,1-.1,2.1.3,3.3,1.2.6-2.2,3.9-.7,4,.9s-4.6,5.2-5.8,3.8c-.6.4-1.3.4-2.3,0-.2,1.9-.9,1.9-2.7,1.5-1.6-.8-3.9-1.6-5.5-2.5-.9.2-2.4-.6-2.5-1.5l-.5-.5c-.1.4-.3.4-.5,0-.4-.2-.7-.8-1-1,2,0,3.1.4,4.7,1.5l-1.2-2c2-.8,1.2,0,1.7.3s.8.2.8.2Z"
          fill="#021b5b"
        />
        <path
          d="M153.8,414.2l.5.5c.9.5,1.8,1.1,2.5,1.5l-.5.5c-.5-.3-1.5-.4-2-1l-.5-.5c-.1,0-.4,0-.5,0l-.5-.8.5-.2c.1,0,.4,0,.5,0Z"
          fill="#0d4aaf"
        />
        <path
          d="M170.3,373.7c.7-1.3,1.3-2.5,1.9-3.8,2.9-.6,2.6-1.5.7-3.5.6-3.1,2-2,3.4-.2.1-2.2,3.8-1.1,2.5,1,1.5.9.1,2.1-1.1,2.8.7,1.1-.3,1.7-1.4,2.2.6,1.2-.8,1.9-1.9,1.5-.7.3-1.6.6-1.6,1.5.9-.1,1.1,2.5-.5,1.8-1.7.8-4.4,4.2-4.9,6.4l-1.9.7c-.4,1.3-1.8,1.9-4.2,1.7-.4.4-1.8.9-2.3,1.7-1.3,1.8-.2,3-4.2,2.8,2.6,3.2,1.3,2.2-2,3.5l1,2h-2c.3,1.5,1,5-.5,5.8s-1.8.2-2,.3.7,1.6,0,2.7-1.3.2-1.5.4c-.5.6.9,2.5-1.6,2l.5,1.5c-.9.1-1.7-.3-2.5-.5-.1.2-.3.2-.5,0h-.5c-.3-.4-.7-.7-1-1,3.2-2.5,5.8-5.5,7.7-9.1-.1-1.6.2-2.6,1.4-3.7.6-3,1.6-5.9,4.9-6.7v-1.3c1.7-.9,2.9-2.2,3.6-3.8,1.8-3.4,3.3-4.4,7.1-4.7-.3-2.7.4-4.2,3.3-3.7Z"
          fill="#060e2a"
        />
        <path d="M144.3,408.2c-.2-.1-.3-.3-.5-.5.2,0,.3,0,.5,0v.5Z" fill="#122357" />
        <path d="M154.3,415.7h-.5v-.5c.2,0,.4.3.5.5Z" fill="#0c398f" />
        <path
          d="M176.3,426.7c2.6,2.1,1,1,.6,1.7s-.5,4.1-.6,4.3c-.5.6-4.1-1.3-2.5,1.5-.3,0-1.1-.4-1.5-.5.2-1.8-2.7-1.6-3.6-2s-.5-.9-.9-1.2-1.3-.2-1.4-.3.2-1.9.2-2c1.1-1.4,2.5.4,3.2.2s4.2-1.4,4-2.7c1-.8,2.3-.3,2.5,1Z"
          fill="#010f74"
        />
        <path d="M176,427.7c.3.2.3.3,0,.5v-.5Z" fill="#010f7f" />
        <path
          d="M199.2,434.7c-.2.3,0,.3.5,0,.4-1,1.5-.6,1.5.5.9.5.8,1,0,1.6s-5.4,1.1-4-.6c-1.7,2.1-2.9,2.6-3.5,1.5.2-1,.1-2-1.3-1.5s0,1.2-.7,1l1.5-2.5c-2,.5-3.3-1-5.5,0l.5,2.7c-.2,1.5-2.5-2.5-2.4-2.9.1-1.4,2-2.7,3.4-2.3,0-.6-.9-.7-1.5-1,0-.3.2-.6.3-.6.6,0,10.8,2.8,11,3.4s.1.5.1.7Z"
          fill="#011387"
        />
        <path
          d="M185.8,429.2c.6-1.1,4.7-.7,4.5,1,4.2.8,8.4,1.8,12.5,2.9l2,1.6c.2.4-.3.6-1.5.5-.3,1.4-1.5,1.2-2,0-.5-.3-1-.5-1.5-.5h-.5l-11.5-3.5c-1-.5-2-1.1-3-1.5l1-.5Z"
          fill="#1660d0"
        />
        <path d="M197.2,435.2v.5c-1.2,0-1.7.3-1.5-1l1.5.5Z" fill="#000e89" />
        <path d="M199.2,434.7c.2,0,.3,0,.5,0-.9,1.2-2.7,0-.5,0Z" fill="#000e89" />
        <path
          d="M219.2,437.7c2.7.1,3.9,1.5.5,1-.2,1.3-.6,1.3-1,0l-2-.5c0,1.2-1.8,1.1-2,0-3.7-.7-7.9-2.4-11.5-3l1.5-.5c4.7,1.2,9.8,1.5,14.5,3Z"
          fill="#155ed2"
        />
        <path d="M233.7,450.2c-.3,0-.7,0-1,0-2.4,0-5.2.1-7.5-1,2.7,0,5.9.2,8.5,1Z" fill="#3170e2" />
        <path d="M221.2,448.7c-1.9,0-4.3,0-6-1,1.9,0,4.3.1,6,1Z" fill="#3a75e0" />
        <path d="M241.2,450.2v.5c-1.9,0-4.5.4-6-.5,2,0,4,0,6,0Z" fill="#3170e2" />
        <path d="M224.7,449.2c-.9,0-2.5.3-3-.5.9,0,2.5-.3,3,.5Z" fill="#3a75e0" />
        <path
          d="M143.3,380.7c3.1-1.5,6.5-.5,3.4,2.9,2.4,0,6.1.7,3.2,3.3-.2,3.8-.8,6.8-3.2,9.8.7,3.1-3,6.8-5.9,6.5-.4,1.1-1.3,1.3-2.5.6-.5-.3-1-.7-1.5-1,1-3.3.4-1.2,2.5-1.7s.9-1.2,1.6-1.5,1.5.3,2.2-.3,1.3-2.7,1.2-3.3-1-.3-1-.5c-.2-1.4,1.3-1.9,1.4-2.5s-.6-.9-.6-1.5.6-2.3.2-2.7-1,.1-1.3-.1-.1-1.7-.9-1.9-1.6.7-2.2.5c.5.5-.4,1.6-1,1s.5-1.5,1-1c-1.4-.5-3.2-.8-5-.5.6-.3,1.1-1.2,1.5-1.5,1.7-2,4-3.5,7-4.5Z"
          fill="#060914"
        />
        <path d="M137,385.7c.3.2.3.3,0,.5v-.5Z" fill="#08060e" />
        <path d="M138.5,402.7c.3.2.3.3,0,.5v-.5Z" fill="#08060e" />
        <path
          d="M156.3,387.2c-2.5,2-3.1,1.2-3.1,4.3s-.8.2-.9.5.4,1.3,0,2.3c-.7,1.6-1.2-.2-1.2,3.1s-4.7,6.9-6.5,8.2,0,2.1-2.2,1c-.2-.2-1-.6-1.5-1,.8,0,1.7,0,2.5,0l-1-1c2.4.3,1.7-1.5,2.5-2.7s1.4-.7,2-1.6c1-1.6.5-4.3.8-4.7s1.6-.5,2.3-1.2c1.7-1.7,1.5-5.4,4.5-6.8s1.2-.6,2-.5Z"
          fill="#060b22"
        />
        <path
          d="M86.8,329.2c2.5-1.1,5.7.3,4.7,3.7,2-.6,3.9-.6,2.8,1.8,1.1,1.4,2,3,2.5,5v.5c-1.6,1.1-1.2,2.9-.3,4.4.9-.3,1.1-.2,1.8.6v.5s.1.6-.2.8c-.5.4-1.5,0-1.8,1.4l2.5-.2-1.5,5c1.7-1.3,2.8-4.7,3.5-.5-.2.2-1.8-.7-2-.5s.1.8,0,1.1-1.8.6-1,1.4,1.8-1.6,2.5-.8l-3.5,4.3c-.4,0-1.1.2-1.4,0s-1.4-3.3-1.7-3.8c-.7-.7-4.1-3.2-4.9-4.1s-.3-.3-.5-.5l-.5-.5c-1.2-1.7-3-6.3-4-7.5l.5-1c1.6,0,3,1.3,4.1,3.7-.6-2.2-.6-4.2,0-6-1.7-.3-2.6-1.1-2.6-2.2l1.5-2.5c-2-.3,0,2.6-2.5,1.2.1-3,2.3-2.4,2.5-2.7s-.4-2.2-.5-2.5Z"
          fill="#010bb3"
        />
        <path
          d="M98.3,345.7v-1.1c1.5-1.2,8.9-4.4,7.4-.3,1.1,1,1.2,1.6,1,3.2,2.5.3,2.2,2.1.8,3.8.9,1,2.1,2.5.8,3.4,1.1.9.1,4.1-1,5,.7-2.3,2,.7,1.3,1.7s-3.7-.9-1.3-1.7c-.6,1-.6,2,0,3,0,1.6-.9,3.7-1.5,5-.3.1-.3,1.3-.5,1.7-.5.8-2.1-.4-1.5,1.8l2.5-1.5-.2,1.5,1.7,1.5h-3c-.2.2-.3.2-.5,0-1.8-.3-3.9-3.1-4.4-5-1.4,0-2.2-1.1-2.5-3.2-1.1-1.4-1.5-2.7-1.1-3.8,1.2-.7,1.5-1.6,1-2.5-.7.5-.9.2-.5-.5-.6-.8-.3-1.7.9-2.7-1.9-1.3-1-4.1-.3-6.2-3.6-.7-1.5-2.5.9-3.1Z"
          fill="#010ebb"
        />
        <path
          d="M108.3,354.7c.1-2.3,4.2-1.5,2.5,1-.7,1.1-1.4,2.2-2,3.5,0,1.1.4,3.4.4,3.6-.1,1.1-1.8,2.6-1.9,2.7-.2.6.2,1.8,0,2.1s-1.2-.1-1.5,0c-1.3-3.1,2.6-4.1-.9-6.5s-1.2,0-1.4,0-.2-.9-.5-.9-3.7,1.2-2.2-.5,3.7.5,4.8-.5c.3,1.8,1.6.3,1.7.4s0,.7,0,1c2.9-.6,0-.9,0-1s0-1.8,0-2.2c.1-.6,1.2,0,1-.8l-1.5-1c1.6.9,1.3-.8,1.5-1Z"
          fill="#010bb6"
        />
        <path
          d="M97.3,358.2c.1-.3.5-1.1,1-1,1.1,1.8-.6,1.4-.5,1.7.2.8,2.4,0,2,1.7-.6-.4-3.3,0-3.5,0s-.5-1-.5-1c2.3.4,1.2-.8,1.5-1.5Z"
          fill="#010bb3"
        />
        <path d="M98.8,357.2c-.8-.7,1.7-2.6,2.5.3-.5-.1-2.4-.2-2.5-.3Z" fill="#010bb3" />
        <path d="M100.8,358.7c-1,.1-1.1,0-1-1l1,1Z" fill="#010bb3" />
        <path
          d="M124.3,346.2c-1.5,4.7-3.7,9.7-6,14,0-.3,0-.7,0-1,0-.7-.1-2,.5-3-.8,0-1.7,0-2.5,0-.4-2,1.5,0,2-1.3s-1.2.1-1-.7c2.2-.5,3.1-1.9,3.5-4l1.4-4.2,1.1-.3c-1.5-.9,1.6-6.1,2.9-5.1s-1.4,4.7-1.9,5.6Z"
          fill="#0412a0"
        />
        <path
          d="M85.8,335.7c1,.6,4,1.5,4,1.8,0,.6-1,1.3-1,2s1,2.6.5,4.9-2.4,1,0,2.3c.2-.6.8-3.4,1.7-3s-.7,1.2,1.4,1.5.6,1.8-.8,1.9-4.1.2-4.3,0c-.5-.4,0-2.5-.3-3.4s-2-2.5-2.8-3.5-2.1-2.7-3-4c1.1-1.5.7,1,2.2.5s.2-.7.4-.8.5.3.8.2c.4-.2-.4-1.3,1.1-.3Z"
          fill="#0109ab"
        />
        <path d="M88.3,349.2l-.5-.5c.1.2.3.3.5.5Z" fill="#010ebf" />
        <path
          d="M63.8,190.3c.7,2.5.3,4.3-1,5.5,0,1.1-.3,2.1-.9,2.8.2,1.1-3.2,7.4-3.7,5.5s0-.5.1-.8c1.4-6,2.7-12,5.5-17.5,0,.8.2,3.1,0,4.5Z"
          fill="#010284"
        />
        <path
          d="M63.3,197.3c-.4.2-.4.3,0,.5.2.2.2.3,0,.5-.8,3.1-1.7,6-2.9,8.7.7.1.7.6.2,1.4,1.4,1.5.2,2.5-1.3,2.4l-1.5.5-.5-.4c1-2.5,1-3.6,0-3.1-.2-1.6.7-3.1,1-4.5.3,1.2.9-.5,1-.7,1-2.2,2.7-4.5,3.5-6.8.4,0,.5,1,.5,1.5Z"
          fill="#01028a"
        />
        <path
          d="M57.8,211.3c0,.2,0,.3,0,.5l-.5,1h-.5c0-.5,0-1,0-1.5s0-.3,0-.5l.5-1.5c0-.5-.1-1.1,0-1.5.2-.6.8-2.8,1.5-3,.7,2.6-.6,4.5-1,6.5Z"
          fill="#010284"
        />
        <path d="M56.8,210.8c0-1,.5-1.4.5-1.5l-.5,1.5Z" fill="#01028a" />
        <path d="M64.8,182.8l1-2c-.4,1-.8,1.5-1,2Z" fill="#04088a" />
        <path d="M65.8,180.3l1-2c-.3.9-.9,1.7-1,2Z" fill="#04088a" />
        <path d="M64.8,183.8c-.2.2-.3.2-.5,0,0-.2.3-.4.5-.5,0,.1,0,.3,0,.5Z" fill="#010292" />
        <path d="M64.3,184.3c0-.2,0-.3,0-.5h.5c0,.2-.3.4-.5.5Z" fill="#04088a" />
        <path d="M63.8,185.3l.5-.5c0,.3-.5.5-.5.5Z" fill="#010292" />
        <path
          d="M61.8,269.3c1.6-.2,3.1,0,4.5.5.2-1.5,2.2-1.4,2.5,0,.4.1.4.3,0,.5.5.7.7,1.3.5,2,1.2.1,1.1,1.6-.2,2.1,3.1,1.8,1.3,4.3-1.6,4.7.4,1.1,1.1,1.8,2,2.4,3.5-4.3,2.9,1,2.2,3.3.1-.4.3-.4.5,0,.2-.2.3-.2.5,0,.4.2.4.3,0,.5,1.5.4,1.7.9.5,1.5,1.2.8,1.2,1.8,0,3,1,.8.9,2.3-.2,4.6.7.7,1.3,1.3,1.7,1.9.4.1.4.3,0,.5-.8,1.7-.7,2.2.4,1.5,2.3.5,2.1,2.8.6,3-.1.3-.3.3-.5,0-.8.3.1.6.8.3l.2.7c0,2,.1,3.2,2.8,3.4,3.4,2.1-.8,3.5-2.8,4.1,0,.8-.2,1.1-.9,1.1,1,4.1-5,5.4-3,.4-2.3.6-3.6.1-3.8-1.5h-.9c-1.9-5.2-2.3-8.8-4-14.3s.7-2.1-1.5-3l1-.3c.2-.8-.9-.2-1-.8-.3-1.3.6-3.5.4-3.6s-1.1-.1-1.4-.9,0-1.7,0-2.4c-.5-2-2.1-4,.5-5-2.6-1,.1-.7,0-2.2-.5,0-1.1.1-1.5,0-1.1,1.3-2.1-.2-.5-1-1.3-.9-1.4-2-1-3.5-.4-.1-.4-.3,0-.5l2-2.8c-.1-.5-1.1,0-1.4-.3s0-.7,0-1c.9-1.4,2.7-.7,2.5,1Z"
          fill="#0105ac"
        />
        <path
          d="M68.8,270.3c.7.3,2.2,1.1,2.5,1.8.5,1.2-1.2.3-1,1.2h2.5s-1,2-1,2h2c-1.7,2.4-.3,5.6-1,8.1s-1.3.4-1,1.4c0,0-.4,0-.5-.3l.5-3.7c-2.4,0-.2,3.3-3,2.5,1-1.1-.7-1.3-1.3-2.2-2.8-4.4-.6-2.6.6-3.1,3.9-1.8,0-2.4-.3-3.4s2-.8,1.5-2.2q.2-.2,0,0c0-.2-1.7-.7-.5-2Z"
          fill="#0106b4"
        />
        <path
          d="M58.8,272.8c0,0,.8-.1,1,0s-.5,1.1-.5,1.7.4.9.5,1.8c-.4.2-1.8-1-1.8-1.1s-.6-3,.8-2.4Z"
          fill="#0104a3"
        />
        <path d="M68.3,275.8v1s-2,0-2,0c.3-1,1.1-1.1,2-1Z" fill="#0106b4" />
        <path d="M70.6,284.8c.3.5,1.7.8,1.7,1.2,0,1.4-2,.1-1.7-1.2Z" fill="#0106b4" />
        <polygon fill="#0107a3" points="66.3 292.3 66.3 292.8 64.3 292.8 64.3 291.8 66.3 292.3" />
        <path d="M75.3,301.3c.1,0,.4,0,.5,0l-.2.5-.2-.5Z" fill="#010ebb" />
        <path
          d="M67.8,309.8l1.5-2c-1,1.5,1.3.5,0,2.5.8.6,3.9-.2,4,0s.4,2,.5,2.3-1.5,0-.9,1.2c1-.3,1.7-.8,2-1.8.5-.9-1.1-.6-1-1,.8-1.2,1.3-1.1,2.5-1.3,1.7-.9,2.6-1.1,4.9,0,1.6-1.1,2.5-.6,3.1,1.1,1.1-.6,1.6-.3,1.6,1,.4.1.4.3,0,.5,1.7,1-1,3.5-2.6,3.7v1.9c4.4-1.5,3.7.6,2.7,3.4h-1.1c.7.6.4.9-.5.4-.2.6,0,1.1.5,1.5,1.4.7,1.8,1.6,1.5,3.2,1.2,1.1,1.3,2.1.5,2.8,1.5,1.4,1.7,2.5.7,3.4.9,1.2-.2,3.5-1.7,3.1-1.6,2.3-2.9,2.4-3.9.5.4.5.2.5-.6,0-1.2-1.7-.6-1.7-1-3.2s-1.7-.3-1-1.3,2,0,1-1-2.6,1.1-3.5-.8c.5-.5,2.4.6,2.5-.7-2,.4-1.2-.8-1.8-1.5s-1.5-1-1.6-1.1c-.1-.3.3-.7.4-.9.4-.3.9-.6,1.5-1q.5-1,0,0c-.2.9-1.2.9-1.5,0-.9.2-1.7.5-2,1.5-1.3-1.7-2.8-4.7-3-6.8s1.4-1.4-1-2.5l1.5-.7c-.6,0-1.3,0-1.7-.5s-1.8-4.9-2.3-6Z"
          fill="#0107b0"
        />
        <path
          d="M77.8,324.7c0-1-1.2-.2-1.4-.5s.2-2,0-2.5-1.1.7-1.5-.2c2.4-3.6.6-1.6-1.5-.8,1-2.2,2.9-1.8,1-4.2,1.2.2,1.6-1.2,2.7-1.7.5,1.7.9,3.5-1.3,3,1.2,1.5.3,3.6,2.5,3-1.1-2.6.9-4.4,3.5-4,.2,2.2-1.9.9-2,1-.4.5.3,3.6.5,4.5h-2c0,0,.5,1.2.6,1.4.3.3,3.2.1,1.9,1.1s-2.3,0-3,0c0,1.2-.6,1.8-1.5,1,0-.3,0-.7,0-1,.4,0,1,0,1.5,0Z"
          fill="#0104a9"
        />
        <path d="M86.3,330.2c.9.9-1.7,1.8-2,1.5-.9-.9,1.7-1.8,2-1.5Z" fill="#010bb3" />
        <path d="M80.8,329.7c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#020bbc" />
        <path
          d="M59.3,229.3c1.7.4.3-1.2,1.1-1.9s3.8-.9,2.9-2.1-1.7.4-.5-1.3c-4-1.3,0-.9.3-1.2.9-.7,1.4-4.8-.3-5.5.8-.4,2,1.6,2.5,1,1.4-1.6-2.2-1.8-2.8-2-2.1-.6,0-.9.7-1.4s.5-2,1.3.4c1.5-2.2,2.5,0,3.5,0s.2-.9.3-1c1.2-1.4,3.9,1.3,2.5,2.5-.1,1.4-.9,1.3-2.2,1.3.8.5,1.4,1.3,1.7,2.4,1.9,1.2.6,2.1-1,2.9h-.5c-.7.4-1.5-1-1.3-1,.5,0,1.8,2.4.3,2.7,1.5.5,1.4,2.5-.2,3v.7c.5,1.3-.4,1.3-1.5,1.1.9,2.1,1,3.6,0,4.4h-1c-.8-1.2-.8-1,0,.5-.4,1.4-2.6.6-3.7.8s-.9,1-1.7.7c-.3-2,2.8-.8,2-2.7s-2.1-1.6-2.5-2.3c0-.7,0-1.3,0-2Z"
          fill="#0104b4"
        />
        <path
          d="M59.3,213.8c1.6.8,2.6,2.2,2,4,.2-.2.3-.2.5,0,1.1.1.8,1.2-.9,3.2-.3,3-.9,5.8-1.6,8.3,1,.6,1,1.4,0,2,1.2,1.9,1.3,2.9.1,4.7,1,.5.7,1.4-.5,1.2.3,1.3,0,2.6-.7,3.9.7,1.9.8,4.1.3,6.6.8.9.1,1.3-2.2,1.2,3.9-1.5,6.6,4.3,2.2,6.7,1.5,1.2,2,3,1.3,5.3,1.1,1.6.5,5.9-.5,7.5,2.8,1,2.6,3.7-.5,4-.7.2-1.7-.3-2.8-1.4,1.1,1.8.8,5.9-1.2,3.4-.1.4-.3.4-.5,0,0-.2,0-.3,0-.5-.5-5-.4-9.9.3-14.8,1.1-2,2.9-.7,1.9-.4s-3.2-8.9-2.3-9.4c1,.5,1.4.3,2-.4-.2.5-1.6,1.1-1.9,1.1-.5,0,0-9.5,1.2-9.4-.4-6.3-.2-14,1.9-20.1-.5-4.4,0-5.7,1.4-4q.8,1,0,0c-1.7-.4-1.3-5.4.5-2.5Z"
          fill="#0104a3"
        />
        <path
          d="M59.3,210.8c.7.2.4,1,0,1.5,3.5-.9,1.7,4.2,0,1.5-.4,0-1,0-1.5,0v.5c1.1-.4,1,1,1,2-.5,0-1,0-1.5,0,.3,1.1.9,3.3.9,4.3s-1.9,1.8-2,4c-.2,4.2-.5,8.7-.5,13,0,1.1.9,2.5.9,3,0,.9-2.5,1.4-1.8,1.7s1-.2,1,.3c.2,1.5-2,2.5,0,4.2-1.5-.2-.9,1.3-1,2.5.5-.1.9-.5,1.5-.5-.3,1.9-1,.6-1.5,1s1.1,5.6,1.5,6.6,1.6,0,.5,1.9l2-.2c-.8,1.7-2.9.6-3,.7-1.1,1.2-1.5,12.8-1.5,15,0-.6-.4-1.3-.5-2.5-.9-.5-1-2.1,0-2.5l-.5-3c-.7-.6-.7-1.9,0-2.5-.2-.7-.2-1.4,0-2-.4,0-.4-.3,0-.5.2-3.7.2-7.7,0-12,.7-11.8,1.9-23.7,3.6-35.7l.9-1.2c-.4-.2-.4-.3,0-.5.6-1.2,1.1-1.4,1.5-.5Z"
          fill="#010497"
        />
        <path d="M58.3,260.3v1s-1.5,0-1.5,0c.2-.7.8-1.1,1.5-1Z" fill="#010497" />
        <path d="M53.8,268.8c-.8-.5-.5-2.1-.5-3,.8.5.5,2.1.5,3Z" fill="#01037b" />
        <path
          d="M58.8,216.3c.3,0,.8-.1.9,0,.6.7.3,3.8-1.4,3.4-.2-1.1.5-2.6.5-3.5Z"
          fill="#0104ad"
        />
        <path d="M173.3,72.4c0,0-.5.7-1,1-.1-1.1,0-1.1,1-1Z" fill="#8191d6" />
        <path d="M169.8,74.4c0-.2.3-.5.5-.5,0,.2-.3.4-.5.5Z" fill="#8191d6" />
        <path d="M171.3,73.9c.1-.2.3-.4.5-.5,0,.2-.3.5-.5.5Z" fill="#8191d6" />
        <path
          d="M216.2,65.9c1.5,0,2.9.2,4,.5-8.4,2.1-16.9,4.1-25.5,6,0,1.1-1.9,1.8-2.5,1-3.8,1.7-7.8,3.1-12,4-.4.9-5.7,2.4-6.1,2.3-1.6-.7-1.3-.9.1-1.8,3.1-2.7,8.9-5.4,13-5,2-.6,4.5-1.4,6.5-2,5.3-1.5,17.5-4.8,22.5-5Z"
          fill="#0a1bc2"
        />
        <path
          d="M240.7,63.4c.4.6-3.1,1.1-3,1,1.3-.8,14.2-.6,15.9-.2s1.1.4,1.6.7v.5c-4.1,1-7.8.6-12,0-3.3.1-6.6.3-10,.5-.6.8-3,.9-3.5,0-3.3.5-6.4.7-9.5.5-1.1.5-3.7-.5-4-.5,3.1,0,6-1.1,9-1.5s4.1-.3,6-.5c3.2-.3,6.3-.4,9.5-.5Z"
          fill="#0a1cbf"
        />
        <path
          d="M173.8,74.4c4.2-.9,4.6.3,8.6-2.2s4.2-2.8,4.9.7c-4.4,1.4-8.6,3.5-13,5-.5,2.1-2.6,2.1-4.5,1.5-.5.4-.9.4-1,0-.5-1.5,1.1-2.9,2.5-4,.9-.3,1.4-.8,2.5-1Z"
          fill="#5b77e6"
        />
        <path
          d="M148.8,88.9c-2.9,2.1-6.3,3.8-10,5,0,.5,0,1-.2,1.3-2.8,2.2-7.1,5.1-10.2,6.2-1.3,1-4.1,3.1-5.5,2,2.3-1.7,4.7-3.1,7-4.8,3.4-2.6,6.9-5.8,10.9-7.6s5.4-1.1,7.1-3.6c.1,0,.4,0,.5,0,1.4-.4,1.7.7.5,1.5Z"
          fill="#5c75dd"
        />
        <path
          d="M171.3,75.4c-.3,1.1-1.6,2.2-1.2,2.9l-1.3,1.1c-.2.4-.3.4-.5,0-.4-.7-2.9.1-3.5,1,.1.5,0,.7-.5.5l-2,1.5c-4.5,1.8-8.8,4-13,6.7l-.5-.2-.5-1.5c1.6-.7,4.7-3.3,6.6-4.1s3.9-.7,5-1.4.7-1.4,1.7-2,8.1-3.9,9.7-4.6Z"
          fill="#5d7ce2"
        />
        <path
          d="M412.1,166.8c.8.6,2.4,2,2,3l-1,.5c.6,0,1.1.4,1.5.5.4.1.4.3,0,.5.3.3.6.3,1,0,1.2-2,4.2-.1,2,1-.1.1-.5,1.8-1.5,1.7l1.5,1.2-3.5,1c-.3-.1-.3-.3,0-.5-1.4,1.2-1.9-.1-1.7-1.7-.8-1.7-1.6-3-1.7-.4l-1,.5c0,1.5-2.2,1.4-2.5,0-1.4-1-1.9-2-1.5-3-.5-.1-.4-.4.5-1-1.9-.3-.9-1.9,1-1.6,1.5.3,2.8.3,4-.4-.4-1.2-.2-1.3,1-1.5Z"
          fill="#0116d8"
        />
        <path
          d="M401.6,154.3c.3,0,2.6.2,2.7.3,1.3,1.1-1.1,2.4,0,.7s.4,0,.7,0c0-.4.3-.6.5-.5.5-.4.9-.6,1.5-.5-.6,1.9,1.6,1.5-1,2.7,2.6,1.1.8,2.1.5,4.2-.8,0-2.1-.7-1.5-1.5.6-.4.5-.4-.5,0,1.1.9.9,1.1-.5,1-2.1,1.4-3.1,1.2-3-.5-3.4,1.8-6-1-2.2-2.7-.6-1.6-.4-2.5.7-2.8-.3-.6.4-1.6,1-1,.7-.9,1-.6,1,.5Z"
          fill="#0220dd"
        />
        <path
          d="M407.1,161.3c.2,0,.5,0,.5.3-1.6,2.8,1.9,0,2,.2.5,1.3-2.2,1.3-1.5,2.5,2.4.2,3.5,1,3.5,2.5.1,0,.4,0,.5,0,.2,1-.8,1.2-1,1.5-.1.3-.3.3-.5,0,0-.5-.4-.6-1.6-.3-1.3-2.4-2.5-3.1-3.4-2.2-1.2,2.2-2.1,1.9-3-.5,0,1-.6.8-1,0-.1.5-.3.4-.5,0-.3.4-.6.6-1,.5l-.5-.5c-.4-.2-.4-.3,0-.5l-.5-1c-.5-1.6,1.1-2.1,2.3-.7,0-1.2,1-1.9,2.7-2.3.4-.6,1.1-.4,2.3.5h.7Z"
          fill="#011cdc"
        />
        <path
          d="M402.1,148.3s0-.7.4-.4c0,1.9,1.5.1,2,.5s1.6,2.7,1.6,3.2-2.4,1-.5,3.3c-.1,0-.4.4-.5.5q-.3-.5,0,0c-.9,1.5.4,2.5-3,2,.8-1.3,2.6.6,2-2-2.6,1-1.5,0-2.5-1-.4-.2-.6-.7-.5-1.5-.5-.4-.5-1.4,0-3-.3.7-.8.8-1,0-.1.4-.3.4-.5,0,0,.5-.3.4-.5,0-.6,0-.8,0-.5-.5-.2-.4,0-.6.5-.5.2-.9.6-.8,1,0,.6-.1,1-.4,1.5-.5.2.2.4.2.5,0Z"
          fill="#011ad5"
        />
        <path
          d="M396.1,142.8c.6.8,1.2,1.1,2,1,1.8,1.3,2.5,1.6,1.5,4,.6.3.6-2.1,1.5-1s-.2,1.8-1,2c-.3,0-.7,0-1,0-1.4-.7-2.4-.7-3.2,0l-.5-1.2c1-1.3.6-1.8-1.3-1.7-.5-.8-.9-1.4-1-2,.7-.6,1.5-1.1,2.5-1.5.4,0,.3.2.5.5Z"
          fill="#0222dd"
        />
        <path
          d="M417.1,167.8c.3.6,2,.4,0,2.5,1.9-.5,1.7-.3,3,.5.4.1.4.3,0,.5,0,.3,0,.7,0,1-.2.6-.9.7-1,0-.4,0-1.4,0-1.5,0,.3-1.4-.7-1-2-1-.4.2-.7.4-1,0v-.5c.9.2,1.9-.3,2-1.3s-2.8-1.5-2-2.2,2.1,1.5,2.5.5Z"
          fill="#010fcb"
        />
        <path
          d="M408.1,164.3c2.6,1.4,2.6-2.9,4.5,0l-1.5,1h1.5s-1,1.5-1,1.5c-1.4-.9-1.6-1.7-3-1l1-1c-.6,0-1.2.1-1.5-.5Z"
          fill="#0116d8"
        />
        <path d="M398.1,143.8l-.3.5c-1.7.3-1.3-.8-1.7-1.5h.5c.5.3,1,.6,1.5,1Z" fill="#0335e5" />
        <path
          d="M406.6,161.3h.5c0,0-.2.5-1,.3s-1.5-.7-2-.8c.3-.3.5-1,.5-1,.2-.3.3-.3.5,0l1.5,1.5Z"
          fill="#032ee5"
        />
        <path d="M401.6,148.3c.2,0,.3,0,.5,0l-.2.5-.2-.5Z" fill="#0220dd" />
        <path d="M408.1,145.8c-.4,1.3-1.2.1-1.5,0h1.5Z" fill="#0114ce" />
        <path
          d="M406.6,142.8c.1.2.4.3.5.5,0,.3,0,.8,0,1q-.5.3,0,0c.1.2.7,1.1,1,1.5-.4.4-.9.4-1.5,0-.4.8-1.1.1-1.5-.5-.7-1.3-1.1-2.7-3-3-.2-.9,1-.2,1-.7s-1.1-.1-1.5-.3l2-1.7c-2.3-1.2-1.8-2.8-2.5-4.2,2.3,2.1,3.6,5.1,5.5,7.5Z"
          fill="#000fc5"
        />
        <path d="M407.1,144.3c.3.2-.5.7-1,.5s.6-.9,1-.5Z" fill="#0114ce" />
        <path d="M404.6,141.8c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#0114ce" />
        <path
          d="M302.7,72.4c-.7.8-2,.3-3,0-.2.4-.3.4-.5,0l-1.5-.5-1.3.4c-4.9-.8-9.6-1.9-14.2-3.4l-12.3-1.7c-2.5.3-4.5,0-6.2-.8l-4.4-.3c-.4,1.3-2.9.8-3.6-.2-.4-.1-.4-.3,0-.5,9.3.2,20,1.1,29.2,2.6s11.9,3.1,17.8,4.4Z"
          fill="#2440d3"
        />
        <path
          d="M254.2,63.4c1.7,1.2,4.1.8,6,.5-.8,1.4-3.6,1-5,1-2.1,0-4.2-.1-6.3-.2-3.7,0-7.4-.6-11.2-.3l3-1c4.8-.2,8.7-.1,13.5,0Z"
          fill="#090fb0"
        />
        <path
          d="M255.2,65.4c.2,0,.3,0,.5,0v.5c0,.4-.3.4-.5,0l-1,1c.4.1.4.3,0,.5-1.5.5-3.4.5-5.5,0-.4.7-2.5,1.2-3,.5-1-.4-.4-.8.5-1-1-.3-2-.7-3-1-.4-.1-.4-.3,0-.5,4,0,8,0,12,0Z"
          fill="#53a9f2"
        />
        <path
          d="M302.7,72.4c1.5.3,2.6.7,4,1v.5c-1.1,0-2.3,0-3.5-.5-.7,1.3-3.8.6-3.5-1,.9.2,2.1-.2,3,0Z"
          fill="#2540d6"
        />
        <path
          d="M305.2,75.9c3.3-.6,7.7,1.4,10.9,2.9s-1.2-.3-.9-.9c8.4,3.2,16.5,6.2,24.5,10.5,2.3,1.3,4.4,3.1,7,4,2.6,2.2,7,4.3,10,6.5l2.9,2.1c.2,1.4-.6,1.3-2.4-.1-.1.4-.3.4-.5,0l-2-1c-.3.2-.7.3-.9.2-2-.9-14.6-8.4-15.3-9.4s-.3-.5-.3-.9c-9.9-5.3-20.8-9-31.9-12l-1.1-1c-1-.4-1-.7,0-1Z"
          fill="#8a9aeb"
        />
        <path
          d="M282.2,68.9c5.3.8,10.3,2,15.5,3l1.5.5c.2,0,.3,0,.5,0,.9.8,2.3.8,3.5,1,2.1.3,4.1,1,6,2,1.3.6,2.1.7,3.5,1,.6.6,1.8,1.2,2.5,1.5l2.5,1-1.6.4c-3.5-1.5-7.2-2.3-10.9-3.4-7.1-1.4-14.5-3.1-21.7-4.7-.9-.2-1.6-.6-2.3-1.3-1.4-.4-3-.9-4.5-.5-.1.4-.3.4-.5,0l-9.4-1.3c-.4-.2-.6-.5-.6-1,5.4.2,10.7.8,16,1.8Z"
          fill="#9ba8e7"
        />
        <path
          d="M352.7,102.9l.5-.6c2.6,1.3,5.3,2.5,8,3.6,2.5,1,4.9,2.5,7,4.5,2.4.6,4.7,1.8,7,3,.5,0,1.1.2,1.5.5,0,.1,0,.4,0,.5,1.6,1.4,3.4,4.4,0,3.2-3.7-2.4-7.6-4.5-11.6-6.4l-1.2-1.6c-2.6-.2-3.9-.9-4-2.2-.1.3-.3.3-.5,0-1.7-.3-2.5-.9-2.5-2-1.3,1-5.1-.8-4-2.5Z"
          fill="#416de6"
        />
        <path
          d="M370.1,109.4c3.4,2.8-.2,2.4-2,.5-2.4-1.4-5.3-3.1-7.6-4.9s0-.3.1-.6c-.9-.5-1.2-1-1-1.5,1.1,0,1.4-.4,1-1,3,2.1,7.4,4.6,9.5,7.5Z"
          fill="#718ced"
        />
        <path
          d="M375.1,113.4c-3.4,0-4.1-1.2-7-3-.2-.2-.2-.3,0-.5.3.2,2.9,1.1,3,1-.2-.5-.7-1-1-1.5,1.8.7,3.7,2.6,5,4Z"
          fill="#567be9"
        />
        <path
          d="M360.6,101.4c0,0,0,.4,0,.5,1.9,1.5,3.9,3.2,5.5,5-2.4-.9-4.3-2.7-6.5-4-.1.4-.3.4-.5,0-1.1-.6-1.8-1.3-2-2,.6.1,1.7.9,2,.3l-2.5-2.3c1.2.9,3,1.7,4,2.5Z"
          fill="#7b92ec"
        />
        <path d="M306.7,73.9c1.5.4,2,1.3,2.5,1.5l-6-2c1.1.2,2.5.3,3.5.5Z" fill="#2d4fe0" />
        <path
          d="M359.1,107.4c.2.2.3.2.5,0,1,1.1,4.6,1,5.5,1.5s-.5.8,0,1.2,2.8,1.3,3.7,1.8c1.6.9,1.8,1,3.6,1.9s3.5,3,5,3.5-.5-2.6-.8-3c1.2.5,1.7,1.7,2.5,2.5.4.5.6,1,.5,1.5-.1.4-.9.9-1.3.9-1.7.2-5.7-1.7-6.7-3.4-.5.8-2.6.4-3-.6l-2.5-1.4c-.1.4-.3.4-.5,0-.9.5-1.9.1-1.5-1-1.2-.2-2.1-.9-2.7-2.2-2.8,0-2.7-2.5-1.8-2.1s-.5,1.4-1,.3c-1.3-.4-1.3-.6,0-1-.4-.3-.9-.5-1.5-.5,0,.4-.3.4-.5,0-.4.3-.6,0-.5-.5-1.9.4-1.7-2.3.5-1.5,1.4.9,1.3.5,2.5,2Z"
          fill="#2c64e5"
        />
        <path
          d="M379.1,116.9c1.8,1.8,3.7,3.8,5.5,5.5l-.5,1.5c-.4.9-.8.9-1,0-.6.3-.9,0-.5-.5-1.5-.7-2.7-1.7-3.5-2.7l.5-1.3c-1.1-.4-1-.5,0-1-.1-.5-.5-.9-.5-1.5Z"
          fill="#1e4ee1"
        />
        <path d="M419.6,198.3h-.5c-.4-.7-.2-.9.5-.5.4.1.4.3,0,.5Z" fill="#021bdb" />
        <path d="M418.6,197.3c-2.2-2.4,3.7-5.8,3-1v.5c-.3,1.2-1.3,1.3-3,.5Z" fill="#021bdb" />
        <path
          d="M414.1,190.8c-.5-1.1.4-1.3,2.5-.8,2.1-1.5,3-.5,2.5,3l.5,1.4c-1.7,1.2-2.1,2.1-1,2.9.9,0,1.2.2.5,1,.2.1.2.3,0,.5.5.2.8.7,1,1.5.1-.4.3-.4.5,0-.2.4-.9,1.8-.8,2,.8,1.2,1.8.8,2.8,1,0,.3,0,.9,0,1,.7,2.2.5,3.2-.5,3.1-1.5,2.9-2.7,2.7-4.5,0-.7-.6-.8-1.1-.5-1.5,1.4-.5,2.1-3.1,1-2,0,.2-.2.4-.4.5-.6.3-5.3-2.1-1.6-3.5-.4-.2-.4-.3,0-.5-1.3-.4-1.8-1.1-1.5-2-2.1,0-1.3-2.4-.7-3.5-.8-.2-1.4-.5-1.8-1-1.4.6-2-1.1-1-2,1.4-2.2,2.2-1.4,3.3.5s-1-1.3-.3-1.5Z"
          fill="#021bdb"
        />
        <path d="M419.1,198.8c0-.2,0-.3,0-.5h.5c.6.7.3,1-.5.5Z" fill="#0114d6" />
        <path
          d="M421.6,196.8c.6,0,1,1.1,1.5,1.2,1,.4,1.8-1.3,1.5,1.3-2.6.7-2.4-.9-2.5-1-1.5-1.1-.6.9-.6,1.2,0,.6-.8.7-.9.8h-.5l-.6-.2c.5-1.1.6-1.8.1-2.3-.3,0-.5,0-.5.5,0,0-.6-.5-.5-1,1.1,0,2.5-.6,3-.5Z"
          fill="#0114d6"
        />
        <path
          d="M418.1,188.3c.4-.8.9-1.1,1.5-1,.2,2.6,1.8,4.4,4.5,4-1.8,1.8-.5,3.3-.5,5.5l-1-2-1,1.5c-.8-.3-1.2-2.3-2-1.5s-1,2.4-1,2.5c-1.4,0-1.9-.6-2.5-1.8l3-1-2-.7,1-.5v-3.5s-4,1-4,1c-1.3.4-1.4-.5-1-1.5-.2-.2-.2-.3,0-.5-.3-.5-.3-.8,0-1,.1-.5.3-.5.5,0l1.2-.4c.6,2.1,1.7,2.4,3.3.9-2.3,2.7-4.9-1.1-1-1.5-.6-.4-.1-.7.5-1,1.8-1,2.1,1.6.5,2.5Z"
          fill="#0114d6"
        />
        <path
          d="M413.6,177.8c.4,0,1.2-.2,1.5,0s.2,1.7.8,2l1.2-2.5,1.5,4.5c-2.2-.3-2.5-2.3-3,1h2c-1.6,3.1,1,1.7,1.9,2.6s0,1.6.1,1.9c-.2.9-1.4.9-1.5,1,0,0,.5-1.5.4-1.7-.2-.4-.4-.8-.9-.8-.5.3-.7.6-.5,1-.1.3.7.8-1.5,1.2.3.9,2.1.6,2.5.3-.5.4-.3,2.3-2.7,1.4s-1.1-1.7-1.8-1.9c1-.6.7-.8-.9-.4-.4.8-.8.2-1.1-.6-1.4-.9-.4-4.3.2-5.2,2-1,1.6-1.4-1.2-1l-.5-1.9c-1.2.5-2.1-.9-.5-1.5.7-2.8,2-2.6,4,.5Z"
          fill="#011adb"
        />
        <path
          d="M409.6,174.3c0-1.5.7-2.3-.5-3.5,2.6.1,3.3.9,4.2,3.1s-.1,1,0,1.3.7.4.8.6c-.6.5-.7,1-.5,1.5v.5s-.1.4-.5.3c-1.2-.5-1.3-3-3.5-.8-1-1-1-2,0-3Z"
          fill="#0220df"
        />
        <path
          d="M419.1,172.3c.8.1.6.7,0,1-.3.4-.6.7-1,1,1.5.2,2.4,1,2.4,3.2,1,.5,1.9,1.2,2.1,2.3.4,0,1.2.5,1.3.5.5,0-.2-1.2.7-1l-1.5,1.5c-.3.9.4.9.5,1,.4.1.4.3,0,.5-.4.4-1,2.3,0,3,1.6.4,3,2,2.3,3.7,1.7.1,2,1.2,1,3.1,1.6.8,1.3,1.8.9,3.2,2.7,1.4,3.1,1.9,0,2.9.2,1.2.1,2.4-.2,3.6,1.4,1.7-2.8,1.9-1.5,0-.7.3-1.4.6-2,1-.7,0-.7.1,0,.5,1.2,1.5-1,1.7-1.5,0-2.2,2.8-5.6-2.3-2-3,0-1.3.4-2.5,1-3.5-.4-.1-.4-.3,0-.5-.8-.9-.4-1.6.6-2.2v-1.9c-2.2-.7-4.3-3-2.6-4.9-.4,0-.6-.6-.7-1.4-2.1-.5-2.9-1-3.5-3,0-1.8-.6-3.5-1.8-5.1-.4-.1-.4-.3,0-.5-.5-.4-.1-1,.5-1-.3-.9.2-1.4,1.5-1.5-.2-1.2.8-2.8,2-2.5.3-1.5,1-1.4,1.5,0Z"
          fill="#0112cf"
        />
        <path
          d="M420.1,172.8l.6-.2c.4,1.2.8,2.1,1.4,2.7.9.6,1,.6.5,1.7l1-.2-1,3c-2.2-.5-1-.5-2-1.2s-.9.2-1,.2c-.2-.3-.1-2.3-.6-3.1s-1.7-.3-1-1.4c.2-.4.5-.7,1-1,0-.6.5-.8,1-.5Z"
          fill="#010fcb"
        />
        <path
          d="M426.1,201.8c-.3.9-1.1,1.1-2,1,0-.3-.7-.9-.5-1,.7.1,1.9-.2,2.5,0Z"
          fill="#0106ae"
        />
        <path
          d="M420.1,172.3c0,.2,0,.4,0,.5-.2.3-.9.4-1,.5s0,.5-.2.8-.8.1-.8.2c-.4-1.3.9-.9,1-1s0-.7,0-1h1Z"
          fill="#0116d8"
        />
        <path d="M424.1,202.8c0,.1,0,.4,0,.5-.5.1-1.8-.7-1.5-1,.5-.4,1.3.5,1.5.5Z" fill="#021bdb" />
        <path d="M414.1,176.3c0,.1-.6.6-.5,1-1.1-.3-.3-1.3.5-1.5,0,.1,0,.4,0,.5Z" fill="#011adb" />
        <path d="M415.9,176.8c.3.2.3.3,0,.5v-.5Z" fill="#011adb" />
        <path
          d="M423.6,181.8l3.5,1c.1.8-.8.3-1.2,1.1-1,2.2,1.3,2.5,1.6,3s.4,2.7,1.1,4,2.8,2.8,2.5,4.9c0,.1-2.4-1.1-2.5-1-.9,1,1.4,1.2,1.8,2s.2,3.6.3,4.2,1.3.7,1.4.8-.6.9-.5,1c.4,0,1.4.1,1.5,0-.2.1-.3.4-.5.5.2,1.8-3.1,1.2-3.8.7s-1.7-1.6-1.2-2.2c-.6-.3-1.8-.6-2-1.5,3,.6-.3-2.1,2.1-3.3s1.9.3,1.9-.7h-3c.3-.6.8-2.6.5-3-1-1.2-.8,2-1.7.5s.9-.5.8-1.5l-1-1,2-1-3-.8c-.4-.9,1-.7,1-1,.3-1.7-1.1-1.9-2.5-1.8l1.5-.5c.2-.2-.5-.8-.5-1q1.3-.9,0,0c-1,.1-2.7.8-3-.5,2.1,1,1.6-3.8,3-2.5q.3.7,0,0c0-.1,0-.4,0-.5Z"
          fill="#010bc6"
        />
        <path d="M423.6,185.3c0-1.7,1.6-2.5,1.5,0-.5,0-1,0-1.5,0Z" fill="#0109bf" />
        <path d="M423.1,184.8c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#0109bf" />
        <path d="M423.6,182.3c0,.1,1.3,1,0,1,0-.3,0-.9,0-1Z" fill="#0109bf" />
        <path d="M428.1,191.8c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#0109bf" />
        <path d="M420.1,170.8c.3.2.8-.3,1,.3.4,1-.3.8-1,.2v-.5Z" fill="#0109bf" />
        <path
          d="M385.6,129.4c.1.1,1.6.5,2,1v-2s2.3,1.5,2.3,1.5l.2-1c.2,0,.3,0,.5,0,0,1,.9,1.8,2,1.5l-1,1c.4,0,1.4-.1,1.5,0s-.9,3.4-1.3,3.5-.6-.5-.7-.5l-.5-.4c-1,.6-3,.6-3.5-.6-.1.4-.3.4-.5,0l-.4-1c1.3-1.2-.1-.6-1.1,0-.1.4-.3.4-.5,0,0-.7-.1-1.4-.5-2-1-.6-.4-1.9.5-1l.5.5c-.3-.6,0-.8.5-.5Z"
          fill="#0534d9"
        />
        <path
          d="M390.6,136.3c.7,1.2,4,1.2,3,2.5s-2-1.6-3-1l2,1.3c.2,1.6-1.7,0-2,.2-.9.9,1.1,1.1,1,1.2s-.5.2-.5.3c-.6.8.1,1.8,2,3,1,.5,1.2.9,1,2-2.6.8-8.3-1.2-6.5-4.7.8-.1,1.1-.9,1-2.3-.6-1.3.7-2.3,2-2.5Z"
          fill="#022cde"
        />
        <path
          d="M387.1,133.3c1.5,1.7,2-1.3,2.5-1s-.1.6.2.8,2.5.7,1.3,1.2c-1.4-.2-1.1,1-.5,2,.1,1.4-1.4,1.4-2,2.5-.1.4-.3.4-.5,0l-.7-.4c.2-1.3.1-2.7-.3-4.1-.5-.3-.5-.6,0-1Z"
          fill="#0339e0"
        />
        <path
          d="M391.1,140.8c0,.2,0,.3,0,.5,1.5-.4,2.1,0,2,1,1.2,1,1.5,0,2.5,0-2,1.4.9,1.3-2.5,1.5s-1.2.7-2.4-.8-1.7-3.3.4-2.2Z"
          fill="#0335e5"
        />
        <path
          d="M393.1,140.3c.1-.1,1.8-3.3,2.5-1.2s-2.3,1.1-2.5,1.2,0,1.5,0,2c-.3-.2-.5-.9-.6-.9-.4-.1-1.4.9-1.4-.1.3,0,1.9-.9,2-1Z"
          fill="#022cde"
        />
        <path
          d="M377.1,123.4c0-2.5,4.4-2.1,5.5,0,.4,0,.5.1.5.5l.6.3c-.9,1-.1,2.6.9,3.2.1.2.9,1.9,1,2,0,.3-.2.6-.5.5l-.5-.5c-.6,0-.7.5-.5,1-.7.1-1.3.5-2,1-.3.4-.8.5-1.5.5-.6-.5-1.3-3.7-1.1-4.3.5-1.7,1.3-.9.7-.9s-.4-.1-.6-.3c-1.2.8-3.5-1.8-2.5-3Z"
          fill="#0645e2"
        />
        <path
          d="M381.6,133.3l-.5,1c0,.6-.5.9-1,.5-.4-.4,0-1.1.5-1.5-1.1-.4-1.1-1.1,0-1.5,1.1-.9,2.6,1.6,1,1.5Z"
          fill="#0645e2"
        />
        <path
          d="M384.1,123.9c.6.2.7.6,1,1-2.4-.4-1.3.9-.5,2.5l-.3.5h-.7c.1-1.1-.7-1.9-.9-2.8s.4-1,.4-1.2c.3,0,.7,0,1,0Z"
          fill="#114ee1"
        />
        <path
          d="M419.1,255.8c.2-1.3.6-2.5,1.2-3.8l1.8.3c.1-.4.3-.4.5,0,1-.9,2.2.1,2,1.5,1.1-2.6,2.3-1.9,3.8,1.9l-1.3.6c1.7.9,4,6.5.5,4.5-2.1-.4-2.5.6-2,2.5.9-.4,4.2.4,2,1.5-.2,0-.3,0-.5,0-.7.2-.7.7,0,1.5l.5.5c.2.3.3.7.5,1,.7,2-2.2,1.7-1.5-.5-1.5-1-1.9-.4-2-.5-.3-.5.6-1.8.4-2.6s-2-2.2-2.4-2.9c-1,.4-1.1-1.5-.5-2-.5-.4-.9-.9-1-1.5l-2-1.5c-.4-.1-.4-.3,0-.5Z"
          fill="#021bd9"
        />
        <path
          d="M426.6,267.3c.5.4.3,1.5,1.5.5l2,2-.5-2.5c.4-.8.9-1,1,0,1.3.7.6,2.4.7,3.3s1.9,2.4-.2,2.2c-.2.9.8.3,1,.5s-1.6,3.4,2.5,0c0,.4.6,1.1.3,1.5s-1.1.3-1.3.5c-.3.2-.3.8-.8,1l-.2-1c-3.6-.6-2.4,2.3-2.5,2.5-.8.9-2-2.3-2.1-2.4-.2-.2-.8,0-.9,0-.5-.5-.3-.7-.5-1,1.2-.7,1.8-1.7,1.8-3,1.5-1,.4,1.7-.3-.5-2.3-.8-2.7-1.4-1.5-3.5Z"
          fill="#0111ca"
        />
        <path
          d="M422.1,259.3c0,.2.4,1.9.5,2,0,1.7-.8.7-1.5,1s.3.7.1,1c-.2.4-.7.4-.7.5.6-.7,0-1.1,0-1.5,0-1.3.2-2.3.5-3,0-1,.8-1,1,0Z"
          fill="#021ddf"
        />
        <path d="M426.6,291.3c.4,1.7-.9.7-1.5,1v-.5c-.2-1.8.6-.8,1.5-.5Z" fill="#0106ac" />
        <path
          d="M427.1,275.3c.1-.8,1.8-.8,2.1.2.8-1,2.4-2,3-.4.4-.2,1.2-.3,1.2,0,.2,1.5-.8.5-.5.2s.4,0,.7.1c1.2,0,2.3-.2,3.5-.6v1.1c-.5,1.3-.9,2.7-1.5,4-.5-.8-1.9.4-2.8.3s-1.1-1-2-.8-.7,1.3-.9,1.4c-1.5.9-1.5-1-1.9-2.4s.6-.9-.8-1.5-.3,1.2-1.2,1c-1.3-2.7,1.1-.4,1-2.5Z"
          fill="#010dc4"
        />
        <path d="M432.1,277.8c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#010bbc" />
        <path
          d="M436.6,263.3c0,.2.7,1.3.5,1.5s-1.2-.1-1.5,0c-1.1.4-.6,2.6-2,3l.5-5.5,2.5,1Z"
          fill="#0108b7"
        />
        <path d="M436.1,260.8h1.5c.2.6-.4,1.1-.5,1.5h-1.5c-.1-.1.5-1,.5-1.5Z" fill="#0108b7" />
        <path
          d="M430.6,256.3c-.4.7-.6,1.2-.5,2,.1.2,1.3-.7,1.5-.5s1.5,3.6,1.5,3.8-2.8,2.1-1.5,3.2c-2.3.6-1.1-1.3-1.8-1.5-1.3-.5-.5,1.7-.7,2-.5-.2-.9-.4-1.5-.5.3-1.4-.8-.8-2-1.5-1.3-1.5,0-2.7,1.6-1.4l.4-1.1,1.5-.7c-1.7-.7-1.7-2-2-3.8,1.1-.7,2,1,3.5,0Z"
          fill="#0111cb"
        />
        <path d="M429.6,267.3c.3-2.7,3.7-1.5,1,0-.2,0-.7,0-1,0Z" fill="#021cd1" />
        <path d="M427.1,264.8c-.6.6-.3.9,0,1.5-.5-.3-1.2-.5-1-1.2,0-.4.6-.3,1-.3Z" fill="#0111cb" />
        <path d="M427.6,266.8c-.2-.1-.3-.4-.5-.5,0,.1.4.3.5.5Z" fill="#0111ca" />
        <path
          d="M413.1,205.8c.5-.2.7,0,.5.5,2-.8,3.3-.5,4,1,.7.2,1.1.9,1.3,2,2.1-.9,3.4-.7,3.7.5,1,2.4,1.7,1.2,2,1.5.4.4,0,1.9-1,1.5l2,1c2.2,1.1.7,2.2-.5,3,1.7-.3,1.6,1.1,0,1-.3,0-.7-.4-1-.5-1.1,1.2.4,3,1,2,.1,0,.7,0,1,0,3.3,2-4.7,6.6-5,2l-1-.6c-2.2-1.1-3.6-3.3-2.3-5.6-1.9,0-2.8-.4-2.7-1.3l-1-.8c.4-.5-.3-1.1-2.1-1.8.7-1.3.7-2.6.2-3.9-.4-.1-.4-.3,0-.5l-.5-.5c-.4-.6-.1-.8.5-1,.1-.4.3-.4.5,0l.5.5Z"
          fill="#021cdb"
        />
        <path
          d="M424.1,217.3l1,2c-.2.1-.6,1.3-1,1s.1-.6-.2-.8c-1.2-.7-1.7.4-1.3-2.7.5.3,1,.3,1.5.5Z"
          fill="#0214d2"
        />
        <path
          d="M426.1,201.8c.5.2.4,2.1,1.5,0,.6.3.2,1.4,2,.5-1.3,1.6,1.7,1.4,3,1v2c-.3,2.2,0,3.7.6,4.5-.4.7-.1,1.5.8,2.2-.4,1.3-.6,2.8,1.3,2.4.7,1.2,0,2.2-1.1,3,.6,1.7.7,3.4.4,5,1.6.4,1.9,1.1,1.1,1.9l-.5.5c.2.7-.3.9-1.5.5l1,1c.4.1.4.3,0,.5l-.4,1c-1.6-.3-2.4,1.5-2.3,3h-.8c-.1.4-.3.4-.5,0h-.5c-2.9,2.2-3.4.8-2.5-2-1.1.7-1.4,0-.9-2-2.8,0-.6-2.7,1.4-3,.6-.7-.2-5.3-.9-4l-1-.4c-.2,1.2-.6,1.2-1,0-1.1.1-2.2-1.1-1-2,.5-.4,1-.1,1,.5,2.3-.9,3-1.7,1.9-2.3.1-1.7-.4-2.2-1.4-1.7-1.5,1.4-3.9-2.3-3-4-.2-.2-.2-.3,0-.5,0-.8.3-.9.8-.3l2.2-1.2c-.6-.4-1.1-.8-1-1.5-1.3.2-2.5-.7-2-2-1.4-.1-1.3-.6,0-1,.3,0,.8.6,1.2.5.3,0,.2-.4.3-.5-.4-.2-.4-.3,0-.5.4-.4,1.1-.7,2-1Z"
          fill="#010eca"
        />
        <path
          d="M435.6,224.3c0-.9-2.4-.9-2.5-1s.8-1.5.8-2.3-.6-3.3-.7-3.5c-.2-.7-1.8-1.1-1.1-2.2s2.3,2,2.5.2-1-1.1-1.2-1.7.3-1.3.2-1.5c-.2-.3-2.4-.4-2.5-.5-.9-.9.9-1,1-1.3.4-1.6,0-1.9-1.5-1.7l-.5,1.5c0-.8,0-1.6.4-2.3s1.6-.4,1.5-1.2c-1.3-.7-3.2.7-2.5-1.3s1.6.2,1.7.2c.3,0,.9-.5,1.3-.4s2,1.6,2,1.7c-.2,1.7-2.3.6-2,2s1.8.8,2.5.8c-.5.8-1.5,3.9-1,4.5.7.9,1.8-2.6,3-1.5s-.4,3.3-.5,3.6c-.2.7-2.9.4,1,2.1l-2,2c3.8,2.2,1,2.8,1,3-.2,2.3,4.4,2,3,3.2s-4-2.1-4.5,0l2.5.5-1,1.5c1.1-.8,3.3,2.1,1,2-1.4,0-2.4-.3-3-1-.2.3-.3.3-.5,0-1-1.2-.8-1.8.6-1.9v-1.1c0,0,0-.5,0-.5l-1-1s-.6,0-.5-.5c.6,0,1.4.1,2,0l.5-.5Z"
          fill="#0108bf"
        />
        <path
          d="M426.1,219.3c.2-.2,2.1-1.5,2.3-1.5,1.8,0-1.2,4.3,1.7,2.5-.9,1.7-1.2,2.8,0,4.5-2-.3-2.7,0-4,1.3.4.9,3.4,1.5,2-.2.9,0,3.5.5,2.5,2s-3.3-.7-3.5-.5c-.3.7.4,1.1.5,1.5.3,3-1.7,5.9-2.9,1.8-.6,0-1-.5-1.1-1.3.7-.4.2-1.1-1.4-2,1.1-2.3,1-3.3,0-3-.9,1.8-4.4,1.8-4.1-.2s2.4-3.1,3.1-2.7c1.2-.4,1.3,1.9,2.2,1.5s1-1.1.8-1.5-1.2.4-1-.5c.7-.2,2.1.7,2.4.5.7-.5.5-1.9.6-2Z"
          fill="#0214d2"
        />
        <path
          d="M425.6,213.8c.2-1,.1-2.9,1.5-2.5-.6,1.6.8,2,.9,2.3s-.4,1.3,0,1.9,2.3,0,2.6,1.3c-2.1.2-3.6,1.5-5.5,1,.6-.1,0-1,0-1q.8-.3,0,0c-1.7,0-1.6-1-2.1-1.3s-1.4.3-1.4-.4.8-1.8,1.5-1.2-.7,1.5,1.5.5c0,0,0,2.9,1,1.5s0-1.5,0-2Z"
          fill="#0113d0"
        />
        <path
          d="M434.6,226.8c1.1.2,2.3,1.7,1.5,2.5s-2.5-1.5-2,.5c-.3-.1-.4-1.3-1.2-1s0,2.2-.3,2.5c-.5.5-1.4-.5-1.5-.5.6-.6.8-3.8,1-4s2.4,0,2.5,0Z"
          fill="#010cc2"
        />
        <path d="M432.1,212.8c.6.6-.2,1.6-1,.2,0-.4,1-.3,1-.2Z" fill="#0108bf" />
        <path d="M435.1,224.8c.1,0,.3-.4.5-.5l-.5.5Z" fill="#010cc2" />
        <path d="M434.6,226.3c-.5-.2-.7-.6-1-1l1,1Z" fill="#010cc2" />
        <path d="M430.6,230.8h-.5s0-.2.5,0Z" fill="#010cc2" />
        <path
          d="M427.1,235.8h.7c1.1-1.7,2.2-1.9,1.3.5,0,.6-.9,1.1-1.5,1,0-.1-.7-.2-.8-.7s.3-.6.3-.8Z"
          fill="#0114d3"
        />
        <path
          d="M383.6,333.7c1.1-1.2-1.2-2.5-1.7-.3-4.5-1.3-.9-9.6,1.2-3.4,3.4.5,4.4,1.5,2.9,3.1,1.3.7.9,1.6-.4,2.2q-1.6.4,0,0c.8-2.3,3.1-1,1.5.5q-.9.8,0,0h.6c-.9-1.6,1-3.5,2.4-2.5-.2.8-1.1,1.9-1,2,.1.1.8-.1,1,0,.8.2,1.2.4.5,1-.1.2-.4.3-.5.5v.5c0,.3.3.4.5.5l-2,1,1,1-1.5,1.5c1-.6,3.6-1.9,4.5-.5-1.8.4-4.9,0-5,2.5l1.5,1c-3.6,1.5-1.7-2.6-4.5-3,.8.9,1.7,2.4,1.5,3.7s-.9.6-1,.8c-.6.2-3.4-1.3-3.5-1.5s1.4-2.2,1-3c-2.3,2.2-4.6-1.1-7-1.5l-.5,2c-.3-1.1-.6-3-1-4-.5-1.7-.3-2.1.8-1.2l1.7-.3c-2-.9,0-1.4,1.4-1.8.4-2.4,3.4-1.8,2.2,1,.6-.1,1.1-.1,1.6,0,0-1.5.7-2.1,1.8-1.8-1,1.9-2.6-.1-2.1-.9.9-1.2,3.4-.4,2.1.9Z"
          fill="#022bde"
        />
        <path d="M412.1,308.3c-.3,0-.7,0-1,0v-.5h.5l.5.5Z" fill="#0217d2" />
        <path
          d="M409.6,302.3c.1-2.7,4.8-3.3,3,0,.7,1.8.7,3.1,0,4,0,.8-.2,1.5-1,1-1.6.9-2.3-3.6-2-5Z"
          fill="#0217d2"
        />
        <path
          d="M417.6,296.8c.8,0,1.4.3,2,.5.6.3,1,0,1,0,.3.4-.4,1.2-.5,1.5s.1.8,0,1.2c-.2.6-1.2,0-1,.8l1.5.5.3-1.5c0,.6,3.1,1.7,2.2,2.5s-5.4-2.6-4.5,1.5l3-1.5-.5,3c-3-2.6-1.9.6-2.6,1.4s-3.6.6-4.4.6c1.7.9,1.9,2.6.5,4-1.4-.5-2.2-1.4-2-3-.9-.4-.2-1.6.5-2,.3-.9.2-1.7-.3-2.5-.3-.6,1-1.7,1.2-1.5s-1.4,1.7-1.4,0c-.8-2,1.2-2,2.7-1.6,0-1.2.4-2.1,1.3-2.9l-.5-.5c0,.4-.3.4-.5,0-.4-.2-.4-.3,0-.5-.8-1.1-.1-1.4,1-1h.5c.7-1.1,1,.2.5,1Z"
          fill="#0217d2"
        />
        <path d="M419.6,297.3l-2,.5c0-.3,0-.7,0-1h.5c1.1-1,1.2.3,1.5.5Z" fill="#0110c8" />
        <path
          d="M413.1,306.3c-.1.6-.5,1.8-.5,2h-.5c-.3,0-.5-.1-.5-.5-.2-.2-.2-.3,0-.5.3-.4.6-.7,1-1h.5Z"
          fill="#0106b7"
        />
        <path d="M416.6,305.8l-1,1c-.1-1,0-1.1,1-1Z" fill="#0110c8" />
        <path d="M416.1,297.3c.3,0,.7,0,1,0,.1.4-.5.4-.5.5l-.5-.5Z" fill="#0226dd" />
        <path
          d="M388.6,300.3c0,.1.4.5.3,1-.2.7-1.3,1.4-1,2s3.8,3.1,4.8,3c1,0,.9.6,0,1-.6.5-.6.9,0,1.5-.5.1-1.9.4-2,.5-.1.1.2,2.7.8,3,1.3.2,0-1.9.8-2.5s1.6,0,3-.5c0,.3,0,.7,0,1-.3.2-1.9.6-2,1.5,1.1-.1,2.1,1.2,2.8,1.4s2.2-1,2.2.1c-.8-.1-2.2,2.2-3,1.5s.9-1.3,0-1.8-.8.3-1.2.3-.5-1.9-1.3-1,.6,1.9-1,1.5c-1.2-.3-2.4-.1-3.5.5.7-1.5,2.9-1,2.4.7s-4.7.8-2.4-.7c-.3,3.1-4.1-.5-2.3-2.6l-.6-.6c-1.6.8-2.8.2-3.7-1.8,0-.4.2-.8.7-1.3-.8-2.3-.3-3.3,1.8-1.7.2-1.4,1.4,0,1.3.5s-1.1-.9-.3-1c.1-1.4.4-1.1,1,0,1,.6,2,1.1,3,1.5,0-.4-.1-.8-.5-1-.9,1-1.7,1.1-2.5-.5-.8-.4-.5-.7,1-1-.5-.3-.8-.6-1-1-1,0-1.2-.3-.5-1-.2-1.4,1.2-2.1,2.5-2-.4-.7-.2-.9.5-.5Z"
          fill="#022ce5"
        />
        <path
          d="M396.1,311.3c-.1.2.1.9,0,1s-1.4-.4-1.5-.5.5-1,.5-1.5c.1,0,.4,0,.5,0l.5,1Z"
          fill="#022ce5"
        />
        <path
          d="M381.6,309.3c1.5,0,1.2,1.1,1.6,1.4s2.3.2,2.4.1c.7-.8-.2-2-1.5-1.5,1.9-4.3,1.6,1.7,3,2.8-1.4-.2-1,2.4-.5,2.7s1.2-.5,1.5-.5c0,2.2,2.2.7,1.5,0-.5,0-1,0-1.5,0,0-1.1,0-3.1,1.5-2.3l-1,1.2,1-1c.5-.5,1.9,1.2,2,1.5s0,.3,0,.5c1.3,2.8-1.3,3-3.5,2-2.1.8-3.3.4-3.7-1.3l-.8-.2c-.8.4-1.7-1.3-.5-1.5-.1-.4,0-.7.6-.8-1.1.7-1.8.5-2.1-.7-.4-.1-.4-.3,0-.5-.4-.3-.7-.6-1-1-.2.4-.3.4-.5,0-.4-.1-.4-.3,0-.5-.1-.7,1.2-1.2,1.5-.5Z"
          fill="#0126e1"
        />
        <path
          d="M388.1,316.3h1c3.2.7,3.9,1.5,2,2.5,0,1.3-.5,2.7-.5,4,1.4,1.4-2.6,1.6-4.2,1,.8,2-1.6,2.8-2.9,1.4s-1.1-6.5,1.2-6.4v-.6c-.1,0-.6.5-.6.5,0,.3-.2.5-.5.5l-.5.5c.5.5-2,.4-2.3.2-2.1-1.2.6-4.4,1.8-1.7.8-1.7,3-2.4,4-.5,1.3-.6,1.4-.9.5-1-.2-.8.3-.7,1-.5Z"
          fill="#0126e1"
        />
        <path
          d="M392.1,329.2c.4-.5,1.2-2,1.8-1-.4,1.7-.3,2.2.7,3.5-.1,0-.9.1-1.5-.3s-.7-2.1-1.9-.6,2.1,1.5,1.9,2.7c-.5,2.3-2.8-.2-3-.2-1.3-.2-1.3-.6,0-1-1.2-1.5-.5-2.5,2-3Z"
          fill="#0121d7"
        />
        <path d="M390.1,335.2h1.5c0,.6-.8.7-1,1-.2-.2-.3-.9-.5-1Z" fill="#0121d7" />
        <path d="M390.1,337.2l-.5-.3.5-.2s.5,0,.5.2-.5.2-.5.2Z" fill="#0121d7" />
        <path
          d="M395.1,321.7c0,.4.4.7.5,1s0,.3,0,.5l-1-.5c0,.6,0,1.1-.5,1.5-1.3-1.5-3.5.3-1,.5-1,.6-.4,1.9-.5,2-.2.2-1.3-.1-1.5,0-3.8.4-1-4.3,2-4,0,0,.2.5.5.3.4-.4.4-1.2.5-1.3.5-.3.8-.3,1,0Z"
          fill="#0126e1"
        />
        <path
          d="M316.2,390.2c.9.1.7.6,0,1,.5,2.1.1-.2,2.5,0-1.5,1.5-.3,1.4-.1,2.4.5,2.8,1.1,2.1,1.5,3.4s-.1,2.6-.9,3.2c-.2,1.3-1.1,4.2-2.5,3.2-.9,1.8-3-.6-1.5-1.7q1.9.5,0,0c.4,4.3-4.5,2.6-3.6,1.4s.4-.3.6-.4c-.2-1.8-.3-3.5-.4-5.6-1.3-1.5-.2-2.6,1.6-2.1l.2-.9c-.6-.1-1.3-.3-2-.5-.8,1.1-1.1.8-1-.5-.4-.1-.4-.3,0-.5.1-.4.3-.4.5,0,.8-.2,1.6-1.5,2.3-2,.5.7,0,1.3,1.2,1,0-.5.7-1.8,1-2s.4,0,.5,0c0,.2,0,.3,0,.5Z"
          fill="#022878"
        />
        <path d="M323.2,408.2c-.8,1-1.4.9-1.5,1,0,0,1-1.4,1-1.5.7-.7.9-.4.5.5Z" fill="#012c7d" />
        <path d="M321.7,409.2c-.2.2.5,1.3-.7,1s-.2-.5-.3-.5c.3-.2.8-.3,1-.5Z" fill="#012c7d" />
        <path
          d="M319.2,400.2v.7c.1.2.3.3.5.3,2.4,0,.2,2.7-1.1,3.1-.2,1.6.6,1.8,2.1,1.4.2-.1.3-.4.5-.5,1.3-.6,1.5,0,.5,1-2.1,1.1-2,1.6-1,3.5-.5,0-1,0-1.5,0,.2,1.2,1,2.1-.3,3l-.2-1.5-1,1.5c-1.2-1.5-1.6-2.8.7-2.6s1.4-2.2-.7-1.7-.6,1.3-1.4,1.3c-.7-1.5,1.3-1.4,1-2.2s-1.3-1.6-1.7-2.3l.2,3c-.5-.1-.9-.4-1.5-.5-2.2-.5-2.6-.7-3.5-2.5-.5,0-.7-.3-1-.5-2,1.8-3.5-1.9-.4-2.2.6-2.5,4.3-2.7,2.9.2.2,1.8.2.2,2,1l-.5-2c.5,0,1,0,1.5,0,0-.3-.7-.6-.3-1l1.8,1.5c-.6,0-1-.4-1.5-.5.3,1,.3,1.7,1.7,1.4s.9-2.4,1.4-2.8.8,0,.9,0Z"
          fill="#012c7d"
        />
        <path
          d="M319.7,401.2c.1,0,.5-.7.9-.5s1.5,1.6,1.5,1.7c0,.2-1.1,2.3-2,2.3-.3.3-.3.7,0,1h.5c-1.2.8-2,1.9-3.5,1.5-.2-.2.8-.8.8-1.2.2-1.1-2.2-1.4-1.3-2.3s1,1.3,1.5.8c.7-.5.3-1.8.6-2.2s2.2.6.9-1.1Z"
          fill="#022976"
        />
        <path d="M320.2,404.7v1c-.7,0-1.6-.4-1.5-1.2.2-.5,1,.2,1.5.2Z" fill="#011e61" />
        <path
          d="M317.7,378.7c4,3.6,0,4.7,1.8,7l4.2-.5c.8,1.5-.4,2.1-.5,3.5l2-1c.6,2-1.6,1.3-1.5,3,1.8,0,1.3,1.5,3.5.5l-2,1.5c1.9.3,3.6.6,5,2,1.7,1.4,2,5.5-.3,6.6,1.4,0,2,.5,1.8,1.4.4,1.8.6,2.5,2.4,2.9-.3.8-.1,1.3.6,1.6-1.1,1.4-2,2.3-3.4,3.1-1.4,1.8-4.6,1.6-5.4-1.1,1-1.9,2.7-6-.5-5.3.2-1.1.2-2.1,0-3.1.6.6,0,4-.5,3.8-2.3-.6-2-6.2.5-3.8-.9.2-1.5-.2-1.9-1.2-2.5,1.7-3.1,0-3-2.5.8,0,3.6-1.6,3.5-1.8-.2-.8-1.2-1.9-2.1-2,0-1.3-.6-1.8-1.9-1.5-.5-1.4-1.7-2.1-3.6-2-1.9-.6-.2-2.1,1.3-2.2-.9-2-1.7-3.9-2.3-5.9-.9-.1-1.6-1-1.4-1.9-.4-.1-.4-.3,0-.5,1.8.6,2.3-.7,3.5-1s.5,0,.5,0c.3.1.3.3,0,.5Z"
          fill="#022066"
        />
        <path d="M329.7,397.2c-1.1-.3-1.1-1.6-1-2.5h.5s.5,2.5.5,2.5Z" fill="#021a56" />
        <path d="M327.2,405.2s-1.1.2-1-.2c.8-1.4,1.6-.3,1,.2Z" fill="#022066" />
        <path d="M325.9,408.2c.3.2.3.3,0,.5v-.5Z" fill="#022066" />
        <path
          d="M331.2,410.2c.9,0,1.7,1.8,1.2-1,1.1.9,2.7-.3,2.3,1.8s-2.2.6-3.5-.3c0-.2,0-.3,0-.5Z"
          fill="#011c64"
        />
        <path d="M321.7,418.2l-2.1.5c-3.9-5.6-.3-5.5,2.1-1,.2.2.2.3,0,.5Z" fill="#01236f" />
        <path
          d="M323.2,405.7c.7.5.3,1.8-.5,2,.2.6-.2,1.1-1,1.5-.1.7-.4.9-1,.5-2.6-1-1.4-3.6,1-3.5-.2-1,1.1-1.6,1.5-.5Z"
          fill="#01236f"
        />
        <path
          d="M316.2,389.7c.2,0,2.9-1.1,3-1l.5,1.5c0-.4-.8-2.5.3-2.5s.1,3,.3,3.5c1,.2,0-1.4,1.2-1s0,1.2.5,1l1.2-1.5-1,3c2.8-.4,1.1,3,3.2,1.5.9.2-.9,2-1.3,2.4s-.7-.4-.8-.3c-.8.6-.3,2.6-2.6,1.1,1,3.9,2,.2,3,.8s1.3,2.1,1.5,2.5c0,0-.7,0-1,0v3s.5,0,.5,0c-.2-.7.6-2.9.5-3,0,.1.7.2.8.7s-.5,1.5-.3,2.3l.5-1.7c.8-1.2,1.7,1.6,1.9,2.4s-.4,2.6-.3,3.1,1.2,0,1.5.2c1.8,1.4-3.1.2-2.5,1.7.5,1,1.5.1,1.9.4s.1.9.4.9,1.3-.5,2.2-.5c.4.1.3.3,0,.5.2.2.2.3,0,.5l-.5.6c.5,1.5.5,4.3-1.5,4.2-1.2,2.3,1.5,2.3,3.5,2.3.8.6,1.4,1.3,2,2,.3,1.5-.8,1.7-2,1.5,0,.4-.3.4-.5,0l-.5.5c-.2.4-.3.4-.5,0l-.5.5c-.2.4-.3.4-.5,0l-.5.5c-.2.4-.3.4-.5,0l-1,.5c-.2,1.1-1.4,1.4-2,.5l-2.3.8c-2,.5-3.3.3-5-1.1-6.1,3.4-4.6-6.4-.9-8.1,1,2.2,2.2,2.9,3.8,2.3.2-.2.2-.4,0-.5-.9-1-1.6-2-2.3-3.2-1.1.7-2.3-.6-1.7-1.8-.2-.4-.4-1.2-.1-1.6.9-1.3,2.5-3.4,3.1-1.4.4.2.7,0,1-.5.5-.5,1-.9,1.5-1,.3-.9.3-1.7,0-2.5-.7-.2-1.3-.4-2-.5.2.7.2.9-.5.5h-.5c-.8-.3-1-.9,0-1,.8-1.8.6-2.9-.5-3.5-1.2,1-1.6-.4-.5-1l-.5-.9c1.2-1-1.3-6.1-1.8-6.5-1.4,0-1.9-.8-.7-1.6.2-.3.2-.7,0-1-.4-.1-.4-.3,0-.5Z"
          fill="#01236f"
        />
        <path
          d="M331.2,411.2c.5,1.6,3.2,2.5,0,2.5.5,1.8.9,2,2.5.7s.7-1.6,1.5-1.7c-.5,4.7,2.7,3.1,5.3,3.6s.1.8.2.9l-.5,1c-.9,0-4.5,1.5-5.5,2h-2.3s.3-1,.3-1c-1.6-.7-1.3,1.3-2.2,1s.1-1.3-.5-1.5c-1.6-.6.8,2.1-1.2,1.5.4-2.9-.5-1.7-2.6-2.1s-1.8-.4-2.4-1.1c.8-.8,3.8,1,4,.8l1-3.5-2,.3,2.5-1.3.3,2c1.6-.6-.8-5.5,1.8-4Z"
          fill="#011c64"
        />
        <path d="M323.2,408.2l-.5-.5c.4-.8.3-1.5.5-2,1.4.2.7,1.6,0,2.5Z" fill="#022976" />
        <path
          d="M321.2,405.2c1.3-.9,1.7-1.7,3-1,.2.8-.8.3-1,.8s0,.5,0,.7c-.4,0-1.1.3-1.5.5l-.5-1Z"
          fill="#022976"
        />
        <path d="M327.2,407.2c0,0,0,.3,0,.5h-2s0-1,0-1c.1-.1,1.9.4,2,.5Z" fill="#022066" />
        <path d="M316.2,390.2c2.4-.1,1.7.5,0,1-.2-.8,0-.8,0-1Z" fill="#022b80" />
        <path d="M322.2,414.2s.2,1.1-.2,1c-1.4-.8-.3-1.6.2-1Z" fill="#012779" />
        <path d="M329.2,423.2l-1,.5c.2,0,.6-.3,1-.5Z" fill="#1248b0" />
        <path d="M331.7,422.2l.5-.5c-.1,0-.3.4-.5.5Z" fill="#1248b0" />
        <path d="M330.7,422.7c0,0,.2-.4.5-.5l-.5.5Z" fill="#1248b0" />
        <path d="M329.7,423.2c0,0,.2-.4.5-.5l-.5.5Z" fill="#1248b0" />
        <path
          d="M309.7,384.7c-.2.3-.4.7-.5,1,.3.4,0,1-.5,1l.5.5c.1-.4.3-.4.5,0,0,0,.6,0,.5.5-.4.1-1.2-.1-1.5,0-.9.4-1.3-1.7-1-2.5.3-.2,1.5-.4,2-.5Z"
          fill="#022277"
        />
        <path
          d="M315.2,384.2c-2.8.8-.8,1.2-.5,3-2.5.1-1.4-2.4-1.5-2.5-.5-.5-2.7-.1-3.5,0,0-.2-.2-.8,0-1,.8-.6,4,1,5-.5.6.2.4.8.5,1Z"
          fill="#022277"
        />
        <path d="M314.2,388.7c-2.1,2.7-3.3-.9-3-3,2.1-.3.9,1.9,1,2s1.9.5,2,.5v.5Z" fill="#012174" />
        <path
          d="M309.7,382.7c.3-.4.4-1,.5-1.5.9-.1,0,1,1.2,1s1.7,0,2.3-.8c-1.5-1.9-.6.9-1.7.2s-2.3-2.4-1.8-3,1.1.9,1.7,1.1,1.6-.1,1.8-.1c.4,0,.9.7,1.3,1l1.2-1c.1,2-.9,4.7,2,4.5l-1,1,1.5.8-1,.7c3.6,1.3,0,2-2,2-.2.1.5.7.5,1-.1.4-.3.4-.5,0-1.3,1.5-1.6.8-1.5-1-.4-.1-.4-.3,0-.5,1.3-.9,1.5-1.9.6-3l.4-1c-1.2,0-1.1,0-.5-1-1.5.4-3.9.5-5-.5Z"
          fill="#022474"
        />
        <path d="M315.7,381.7c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#022066" />
        <path
          d="M297.2,375.7c.3-.3,1.4-1,1.4-1.1.2-.4-.6-1.1,0-1.6,2.1-1.5,2.7,1.6,2,3.3l1.5-.3-.5,1.8c0,0-.3.5-1,.3s-2.3-1.9-3-1.3c-1.1,1,1.5.8,1,1.7s-2.8.3-3,2,1.4,1.2,1.5,1.2c1.2,0,1.1.6,0,1-.7,0-.9.2-.5.5,1,0,1,.8,0,1,0,0-.6.5,0,1-.1.3-.3.6-.5.7-1,.5-.2-1.1.7,0,1.5,1.9-1.2,4.8-3.1,2.5l-1.2.3c-1.5-.1-3.4-.4-1-2.5v-.5c.4-1,1.2-2.3,2.4-1.9l1.1-1.1c-1.1.3-1.3-.2-.5-1-1.5-1.3-2.2-2.3,0-3l-.5-.5c-3.7,1.4-1.3-4.6,1-1.5.2-.3.3-.3.5,0,0-.5,0-.8.5-1,.4-.4.6-.2,1,0Z"
          fill="#023196"
        />
        <path
          d="M297.2,375.7c0,0,0,.5-.2.5-.2-.3-.5-.3-.8-.5,0-.4,0-1,.5-1,.2.3.5.5.5,1Z"
          fill="#021a6f"
        />
        <path d="M295.2,369.2c0,.3,0,.7,0,1-2,.2-.5-.7-.5-1h.5Z" fill="#031771" />
        <path
          d="M295.7,373.7c.2.5,0,.6-.5.5,0,1.3-.5,1.2-1,0,0-1.1,1.1-2.1,1.5-.5Z"
          fill="#022885"
        />
        <path
          d="M304.2,375.7c0,.3,0,.7,0,1l1-.5c.3,1-.6,1.2-1.5,2-1.1.9-1.8.7-2-.5-1.3-.6-2-2-2-4.2-.2,1.5-.6,3.2-2.5,2.2-.6,0-.8-.5-.5-1-.7.4-1-.3-1-1l-.3-.9c-2-.5-1.8-1.6-.2-2.6-.8,0-.6-.6,0-1,.3-.3.6-.7,1-1-.7-.7-.4-1,.5-.5.5,0,1.5,0,2,0s.8,0,1,0c.3.6.2,1.2-.5,1v.5c-.2.3-.6.1-1-.5,0,.8-.7.7-1,0l-.5.5c.1.2.2.3.2.4-.3.8-.6-.2.6-.4s.9,0,1.2.5c.1-.4.3-.4.5,0,.1-.4.3-.4.5,0-.2-.5,0-.9.5-1l2-1.5c.2.7,0,1.7.3,2.5s1.5,1.8,1.5,2.2c0,1.7-.5.9.2,3.8Z"
          fill="#022885"
        />
        <path
          d="M300.2,368.7c0,.7.1.7-.5,1-.3-.2-.5-.5-.5-1,0-.3.4-.7.5-1,.7.2.5.4.5,1Z"
          fill="#022784"
        />
        <path d="M302.2,370.7c-2,.4-2.1-.8-.7-2l.7,2Z" fill="#02227a" />
        <path
          d="M298.2,368.7c.6.4.7.7.5,1-.7.1-1.6-.2-2.3.5-.4-.2.1-.8.3-1l.5-.5c.2,0,.7,0,1,0Z"
          fill="#02227a"
        />
        <path d="M296.2,368.2c.1,1.1,0,1.1-1,1,0-1.6.3-.7,1-1Z" fill="#02227a" />
        <path
          d="M299.7,369.7c-.1,0-.3,0-.5,0-.4-.1-.4-.3,0-.5,0-.2,0-.3,0-.5l.5,1Z"
          fill="#02227a"
        />
        <path d="M296.7,369.2l.5-.5s-.4.4-.5.5Z" fill="#022784" />
        <path d="M299.2,369.2v.5c-.2,0-.3,0-.5,0l-.5-1c.3,0,.7.4,1,.5Z" fill="#022784" />
        <path
          d="M298.7,381.7c.4-1.3,1.5-2.5,3-2.2-1.7,1.9-.9,3.4-1.5,5.7l-1.5-2.5c-.4-.3-.4-.6,0-1Z"
          fill="#033598"
        />
        <path
          d="M298.7,381.7c0,.2.9.8,0,1s-.9-.1-1,0c-.2.2.7,1.3.5,1.5h-1.5c0-.3,0-1,0-1-.3-.5,0-.6.5-.5,0-.3,0-.7,0-1,.4.1,1.1,0,1.5,0Z"
          fill="#0240a5"
        />
        <path
          d="M286.7,361.7c0,.3,0,.8,0,1-.6,1.8,0,.5.3,1.1s-.3.6-.2.8c1.1,1.5,4,2.6,3.8,5.1l1.5-1.5c1.2,1.9-1,1.7-1,2.3-.2,2.5,2.3,1,3,1.7s-1,1.1-1.3,1.5c.8-1.8-.6-1.7-1.2-1s.1.9,0,1c-.9.8-1.9-1.4,0-1,0,0-.8-1.3-1-1.5-3.3-2.9-.9,1.5-2.2,1.5s.4-2.3-1.8-1.5l.5-.5c.4-.4.4-.6,0-.5-.5,0-1.6-1-2.5,0-.7.5-2.4-2.8-2.5-3.3l.5-1.2-.5-.5c-.9-.1-1-.8,0-1,.4-.5,1.3-.2,1.5.5,0,.2,0,.3,0,.5.4.9.7.6,1-1,0-.1,1.4-1.1-.5-1v-.5c1.7.1.5-.5.5-1,.6-.1,1.5.2,2,0Z"
          fill="#0238a8"
        />
        <path
          d="M272.2,345.2c.9-.9,2.3-1.1,2,.9,0-.5,0-.8.5-.9.9-1,2.7.7,1,1.5-.1.7,0,1.2.5,1.5,1.7.2,3.7,1.2,2,2.5-.2.1-.3.3-.5.5-1.2.4-2.3,1.7-.8,2.3l-.9,3.2c-1.2-.6-2.3-1-3.3-1.4-.8,3.5-3.7,1.8-2-2-.9-.2-1.4-.4-.5-1-.4,0-.4-.3,0-.5-2.3-.8-2-2.3,1-4.5.4-.6.7-1.3,1-2Z"
          fill="#0243ce"
        />
        <path
          d="M275.2,343.7c1.9,0,3.4.4,4,2.5,1.9,2-.2,0,0,2s.7,1.2,1,2c-1.9-.8-1.2-.2-2,.5.3-1.9-1.1-.4-2.5-.5,1.3-1.1.5-1.9.5-2-.2-.5-.4-1-.5-1.5,0-.7-.3-1.3-1-1.5-1.4.2-1-2.8.5-1.5Z"
          fill="#033abf"
        />
        <path
          d="M282.2,347.7l1,.5c0,0,0,.4,0,.5.5.7.4,1.6-.2,2.4,1.7,1.5,1.8,2.4,1.3,4.6,1.4.3,1.5,1.3.4,2.9,1.6,1.8,1.6,2.8,0,3,1.9.4,1.7,3.3,0,2.5.3.9,0,1.5-1,1-.4-.1-.4-.3,0-.5-.4-.5-.9-.8-1.5-1-.2.9-.5.9-1,0-.3,0-.5-.2-.5-.5-.3-.1-.3-.3,0-.5-.4-1.7.4-2.8,2.1-3.3s0,.5-.2.4c-1.5-.5-3.3-1.5-4-2.6-.4-.9-.9-1.7-1.4-2.4l.3-1.3c-2.1,1.4-1.9-2,.2-2.2-.2-.5,0-.7.5-.5-.1-1.2.2-2.1,1-2.5,1.1-.9,2.1-1.1,3-.5Z"
          fill="#0233b0"
        />
        <path d="M283.2,348.2c-.5,0-.7-.3-1-.5.7,0,.6,0,1,.5Z" fill="#02289f" />
        <path
          d="M278.7,357.2c.7-1.7,1,.3,1.1.3s2.1.5,2.5.7c3,1.8.4,2,.4,2.2l1,.7-2.5-.5c1.7,2.1.6,1.3-.5,2s-1,.4-1,1c.3,0,.7,0,1,0,0,.3,0,.8,0,1-.1.4-.3.4-.5,0,0-.2-.8-.5-1-.9-.3-.7-.3-1.5-.5-2.1-1.2,0-1-.4-1.5-1.5,1.3-.2,1.2.7,1.5,1.5.6,0,2-1.1,2-1.3.3-1.4-4.6-.9-3.3-2.7l1.3.5c0-.3,0-.8,0-1Z"
          fill="#0239b7"
        />
        <path d="M281.2,363.7c-.2,0-.3,0-.5,0,0-.2,0-.3,0-.5l.5.5Z" fill="#0239b7" />
        <path d="M284.7,364.2c0,.3.7,1.2.5,1.5s-1.4.6-1.5.5,0-.7,0-1l1-1Z" fill="#0239b7" />
        <path d="M282.2,363.7c1.2,0,1.2-.7,1.5,1l-1.5-.5v-.5Z" fill="#0239b7" />
        <path d="M282.7,354.7c-.6.3-1.7-.8-1.5-1,.6-.3,1.7.8,1.5,1Z" fill="#02289f" />
        <path
          d="M283.2,348.7c1.6,1.5,1.2,1.5,2.1,3.1s1.5,0,.5,2.4l1.5-.5c-.2,3,1.1,1.6,1.5,2s-.5.9-.5,1c-.5,1.6-2,2.8-3.5,2v-2c-.7,0-2.6.9-3,.5s.1-.9-.2-1.3-1.7-.2-.6-1.2l1.3,2c1.6-.7,1.1-2.6,1.5-4l-1.5.5.5-1.5-1.5.2c-.2-1.2.7-.6.9-.8s-.9-1.1.6-.9v-.5s-.7,0-.7,0l1.2-1Z"
          fill="#02289f"
        />
        <path d="M285.4,356.2c.3.2.3.3,0,.5v-.5Z" fill="#02309e" />
        <path
          d="M278.2,336.7c0,.2,0,.3,0,.5,0,.3-.4.3,0,2s.4,1.3.5,2c.3,0,.9,0,1,0-.2.2.7,1.5-1.5.5l1,4.5c-1.9-2-2.5-.4-4-2.5-.6-1.2,1-1.6,1.7-1s-2.1.4-1.2-1c.3-.8-.8-2-1.6-2.6-.5-1.2-.2-1.9,1.1-1.4-.6-1.7,3.1-3.3,3-1Z"
          fill="#022eba"
        />
        <path
          d="M278.2,261.8c.4,0,.4.3,0,.5,0,1.2,0,2.3,0,3.5h-.5c-.2,1.4-.4,2.7-.5,4-1.1,0-1.8-2.1-1.2-3.2-1.2-2.4-1.3-3-1.5-5.6s-.2-.3-.5-.4c.4,0,.6-.2.6-.2,0-1-.4-3.3-1.4-3-.6,0-1-.5-1-1.5-.4-.2-.4-.3,0-.5-.4-.1-.4-.3,0-.5,1.7,0,1.7-.3,0-.5-.6.7-.9-.3-1-1-.1-1.8,1.8-.6,2.5.5l.6-.4c1.1,1.3,2.1.6,2.9-2.1.1-.4.3-.4.5,0,0,3.4-.4,7.3.5,10.5Z"
          fill="#020d94"
        />
        <path
          d="M277.7,272.8h-.5c-.3-1-.5-2,0-3,0-1.3-.4-3.2.5-4,0,2.3,0,4.7,0,7Z"
          fill="#0312b1"
        />
        <path
          d="M270.7,264.3c2-.2,3.1,2.8,1.5,4,1.5,1.2,1.5,2.7,0,4.5,0,1.9,1.5.5,1.5,1.3-.8.7-.5,2.5-.6,2.6-.2.2-.8,0-.9.1-.1.4-.3.4-.5,0-.5-.2-.8-.2-1,0-1.1,2.1-3.3-2.8-3.2-3.5,1-.3,1.1-1,.5-1.9l.7-.6c-.4-.1-.4-.3,0-.5-1.1-.9-.8-1.9.6-1.2-.6-.1-.9-.4-1.1-.8-.5.9-.8.9-1,0-1.6-1.1,0-2.3,1.6-1.8.4-2.2,1.1-2.9,1.9-2.2Z"
          fill="#022ddd"
        />
        <path
          d="M272.2,255.8c1.7-.4.7,1,1,1.5,1.6.6,2,2.5,1.2,5.8,1.7,1.9,2,3.7.8,5.2l.2,1.4c.9,1.5.9,2.3-.2,2.6.5,0,.8.2,1,.5.5,1.1-.4,1.9-1.5,1.5,0-1.4-.4-1.7-1.5-2.5-.3-.8,0-2.2,1-2.5-.8-.4-2.3-4.4-2.3-4.7l1.3-.8c-2.3-.3-3.8-4.8-2-6.5-.7-1-.2-2.2,1-1.5Z"
          fill="#0119b7"
        />
        <path
          d="M273.2,257.3c3.3-.4,1.3,3.9,1.6,5.6s1.7,1,1.9,1.7c.4,1.3-.8,3.9.5,5.2,0,1,0,2,0,3s0,1.7,0,2.5c-.1.4-.3.4-.5,0-.4-.1-.4-.3,0-.5-1.1-.4-1.1-1.2-.5-2-.1-.1-.8.2-1-.5.6-.9.6-2.2,0-4-.1-.2-.9-.4-1-.8s.7-.1.9-.3c.6-1-.8-2.7-1-4s1.4-2.8-1.8-2.4c.2-1.4,1.9-.3,2-.5.9-1-.9-.9-1-1.3-.3-1.2.7-.5,1-.8v-.5c-.3,0-.8-.2-1-.5Z"
          fill="#0110a5"
        />
        <path
          d="M275.2,298.3c0,.2,0,.3,0,.5-1.9.7-.8,1.8-1.2,3s-.7.7-.8,1c-1.7.2-2.8-2.4-1.5-3.5.3-.8,1.1-1.4,1.5-2,.3.9,1.1,1.1,2,1Z"
          fill="#0225d1"
        />
        <path
          d="M274.2,269.3c0,1.5-.2,1.7-1,2.5s-.7.7-1,1c0-.8.6-1.8.5-2.2s-.4,0-.5-2.3c.6-1.1,1.2-.7,2,1Z"
          fill="#0127cf"
        />
        <path d="M276.7,274.8h-2c0-.2,0-.3,0-.5l1.5-1.5c.7.6.6,1.1.5,2Z" fill="#0312b1" />
        <path
          d="M272.2,311.3c.7-.3,1.2,0,1.2.7-1.2,2-.9,2.9-.2,4.8.1.2.6,2.9,1,4,1,1.9-2.1,2.2-3,1-2.1,3.5-5.3.9-2.1-1.8-3.3-.8-3.3-4.4.2-4.1-1.2-1-1.1-1.7,0-2.6,0-1.1.3-.8,1,0,.2-.3.2-1,0-2-1.4-2.3,3-2.5,2,0Z"
          fill="#0230da"
        />
        <path
          d="M274.7,322.2l.5.5c0,.2,0,.3,0,.5-.9,0-1.7,0-2,1-.6,1-1.9,0-2.5-1-1.5.3-1.3-.2.5-1.5,1-.3,2.2,0,3-1,0,.1.6.2.7.5.2.5-.3.9-.2,1Z"
          fill="#022bcf"
        />
        <path
          d="M275.2,309.3v1c-.6.2-.8.3-1.5,0,1.8,2.9-1.2,2.1-1,4.5l1.5-.2-1,2.2c0,0-1.3,0-1.4-.7-.2-1.1,1.5-3.1.4-4.8-1.2-.8-.7-1.7,1.5-2.5.6,0,1.2.5,1.5.5Z"
          fill="#0222c7"
        />
        <path d="M275.2,322.7l-.5-.5s.5.1.5.5Z" fill="#0126c1" />
        <path
          d="M269.2,308.3c1-.3,1.8.4,2.5.5,1.1.2,1.5,0,2,0,.1,1.1-.9,1.2-1.5,1.8v.7c-.7-1-1.6-1.3-2,0-.3.3-.6,0-1-.5-3.3-.1-1.3-5.1,0-2.5Z"
          fill="#0336e3"
        />
        <path
          d="M270.7,323.2l1.5-.5c.4.6-.9,1.2,1,1.5s1,0,1.5,0c-.1.4-.8.8-.8,1.2s1.3,2.7.8,3.8c-2.3-1.1-2.1.6,0,.7-1.4,1.6,1.8,4.6-.4,4.9-.2.3.4.3.4.4,0,.5,0,1,0,1.5,0,2.4-3.1,1.6-1.5-1,.2-.9-.2-1.6-1-1.3v-.7c-.4-.3-.3-.8.5-1.5-1.4.4-3.3-.8-2-2-.2-.2-.2-.3,0-.5l.5-.5c-.5-.4-1.1-.8-1.7-1.2-.5-2.6-.1-4.2,1.2-4.8Z"
          fill="#0233d6"
        />
        <path
          d="M361.6,305.3c1,1.3,3,5.6,0,5-.4-.9-.7-1.9-1.5-2.5,0-.5,0-1,0-1.5.2-1.5.2-.9,1.5-1Z"
          fill="#072fce"
        />
        <path
          d="M368.6,313.3c1,.2,1,1,0,2.5.1.4.5.6,1,.5.2-2.5,3.7-.6,1.5.5,0-1.4,1.2-1.4,1.5,0,.9-1,1.1-.9,1,.5.4.1.4.3,0,.5-.8,2-4.1,1.3-2.5-1,.4,1.3,0,2.1-1.4,2.4.7.8,1.7,1.2,2.9,1.1.2.2.3.2.5,0,1.8-2.3,2.8,1.5,0,2.5l.2.3c2.4-1.1,1.7,6.2-.9,3.8l-.2.4c-.6,1.4-1.3,1.7-2,1-.7-1.8-1.9-3.7-2-5.5q1.2-.7,0,0c-.2,0-.4,0-.5,0-.6-1.3-.5-2.6-1-4q.7-1.3,0,0c-.3-.9-1.7-1.5-1.5-3.5,1.4-.7,1.7-1.4,1.2-2,.9-1.7,1.6-1.8,2.3,0Z"
          fill="#0230dc"
        />
        <path
          d="M372.6,320.3c-1.3.2-1.4-1.1-.2-1.7,1.9-.9,3,2.1.7,1.7-.1.4-.3.4-.5,0Z"
          fill="#0230dc"
        />
        <path
          d="M372.1,327.2c.6,2.1,2.5,3.3,3.3.8l1.2.2c1.8-.5,2.2,5.6,1.8,6.1-1.6.2-2.1.9-1.8,1.9-1.4,2-2.7-.7-2.5,1.5-1.1-3-2.8-6.3-4-9.5.5-.3,1.4-1.1,2-1Z"
          fill="#022ad8"
        />
        <path d="M236.2,452.2c-1.4,0-3.5.4-4.5-.5,1.4.1,3.5-.5,4.5.5Z" fill="#080d7d" />
        <path d="M276.2,449.2c-1.9,1.2-4.4.9-6.5,1v-.5c2.2-.1,4.3-.4,6.5-.5Z" fill="#3b7ce1" />
        <path d="M280.2,448.7c-.4,0-1.4.4-2.5.5.4-.8,1.7-.5,2.5-.5Z" fill="#3d79de" />
        <path
          d="M301.7,434.7h1.4c2-.5,4.6-.3,2.1,1.5-2,.1-.6,1-1,2.7s-1.7,0-.5,1.8l-3.5.5,1.5,1.5-2.8,1,1.8.5c-1.3.3-2.7.7-4,1-1.6.4-3.4.3-4.5-1-1.2-.1-2.3-.7-3.3-1.7v1.3c-1.1.8-1,1.4.3,1.8.4.1.4.3,0,.5-1.7,1.2-4.3,2-6.1.7l-.6.8c-1.7-.7-3.4-1.4-5.1-2-2.8,0-1.5-3.9,1.4-2.8v-1.1c-1.5,0-2.4-.6-2.6-1.7-.4-.1-.4-.3,0-.5.3-.6.7-.6,1,0l2.5-.5c1-.9,2.9-1.3,4-.5l2-.5c0-.8.7-.7,1,0l1.5-.5c.7-.2,1.5-.3,2.5-.5.3-.6.7-.6,1,0,.6-1.2,4.6-2,5.5-1q1,1.2,0,0c0-1.2,3.7-2.3,4.5-1.5Z"
          fill="#010d81"
        />
        <path
          d="M289.2,445.7c-1.4.4-2.1.6-3.5,0l2.4-2.3-.9-3.5,2,.3-.5,1.5c2.8-.5,1.6.9,2.1,1.4s1.8-.4,1.4,1.1c-.6.1-2.1,1.3-3,1.5Z"
          fill="#010e87"
        />
        <path d="M290.7,437.2c-.4.9-1.8.4-2.5.5v-.5c.8,0,1.7,0,2.5,0Z" fill="#1355ca" />
        <path d="M279.7,439.2c-.6,0-1.3.4-2.5.5.4-.8,1.7-.5,2.5-.5Z" fill="#074dcb" />
        <path d="M285.7,438.2c-.4,0-1.1.4-2,.5l2-.5Z" fill="#1553ce" />
        <path d="M288.2,437.7c0,0-.7.4-1.5.5l1.5-.5Z" fill="#1553ce" />
        <path d="M296.4,444.2c.3.2.3.3,0,.5v-.5Z" fill="#03167f" />
        <path
          d="M297.2,436.2c3.9-.4,3.6,4.9.7,5s-.6-.7-.9-.8c-.5-.3-1.3-.1-1.3-.2-1.3-1.1,1.4-.9,1.5-1s-.7-2.2,0-3Z"
          fill="#010b78"
        />
        <path d="M298.7,437.2l-1,1c-.1-1,0-1.1,1-1Z" fill="#010d81" />
        <path d="M142.3,89.4c.1-.2.3-.4.5-.5-.1.2-.3.4-.5.5Z" fill="#6880df" />
        <path d="M144.8,88.4c0,0,.2-.4.5-.5l-.5.5Z" fill="#6880df" />
        <path
          d="M128.3,101.4c.5.1.4.4-.5,1l.2.5-11.7,6.5c.6.7.4,1-.5.5-.5.3-1.4.3-2,.5v-.5c1.9-1.5,3.8-2.8,5.5-4.5,1.4-.2,2.3-1.4,3.5-2s4.5-1.4,5.5-2Z"
          fill="#5167d9"
        />
        <path
          d="M91.3,137.3c1.3-.6,1.5.1.5,1,0,1.2-.9,2.8-2,3-1,3-2.4,5-4.9,7.3-1.2,2.4-2.6,4.8-4.1,7s-1,.7-1.6.8c-.9-2,2.2-4.3,2-6.5,1.1-.9,4.2-4.8,5.1-6.1s1.4-2,1.3-3.4c1.1-1.1,2.9-2.4,3.5-3Z"
          fill="#090a99"
        />
        <path
          d="M97.8,131.3c2,1.4-2.5,7.8-4.5,6.5,0,1.5-.9,2.1-1.5.5l-.5-1c.7-.7,3.4-4,3.5-5,1.2,1,1.7-.2,3-1Z"
          fill="#0d10a4"
        />
        <path
          d="M89.8,141.3c.2,0,.4,0,.6-.1s.2,0,.2-.1c0-.4,1.1-2.7,2.1-1.3s-3.9,6.8-4.6,7.5c-1.4,1.9-2.5,4-3.4,6.4-2.4,1.4-3.6,3.9-3.6,7.4l-1.7.5c-.2-.5-.8-.5-2-.1v-2.5c.6-.9,1.6-1.8,2-2.5,1.9-2.9,3.4-5.8,5.5-8.7s2.2-1.8,2.7-2.8.1-3.2,2.3-3.5Z"
          fill="#010293"
        />
        <path
          d="M123.3,106.9c0,2-2.6,3.9-4.5,3.5-.7.4-1.9.3-2.5.5l-.5-1c.2,0,.3-.4.5-.5,1.7-1.4,5.2-4,7-2.5Z"
          fill="#2d4ad7"
        />
        <path
          d="M89.8,146.3c.4.1.4.3,0,.5l-.5.5c0,2-1.7,4.3-3.1,5.9-.3,2.3-1.2,3.4-2.7,3.1-.3,2.4-1,4.4-2.2,6-1.6,0-2.5,1.7-2.5,5l-1,.6c-1.2,1.9-2.1,4-2.8,6.4-1.2.4-1.6,1.3-1.2,2.6-1.8,1.4-2.9,3.9-3,6.3l-1,.7c-.4,1.2-1,2-2,1-1.3-.1-1.4-1.1-.4-3,1.2-1.6,2-3.2,2.4-5,.2-.5,0-.9,0-.9.4-.2,1.3,0,1.4,0,.2-.2-.3-1.9-.2-2.6.3-2.9,4.1-9.6,6.2-11.9s1.2-1.8,2.3-1.5,0,1.6,1.2,1c-.2-1.7,1-6,2-7.2s1.6-.7,1.8-.9c.3-.4.3-2.9.9-3.9s3-2.8,3.7-3.7.4-1.6.8-2.2,1.9-1.1,2.2-2.3c-1.2-1.1-1.1,1.1-1.7,1.3s-.7-.5-.7-.5c1.3-1.6,0-2.4,2-3s.4.3,1.5-.5c1.2.1,1.4.5,1.2,1.6s-3.2,5-3.8,5.9-.6.7-.9,1Z"
          fill="#0004a0"
        />
        <path
          d="M69.8,184.8l.7,1.1c-.4.7-.3,1.7.4,3-1.6,1.4-2.7,3.3-3.3,5.8,2.4,1.3,2.1,3.6-.7,3.3.4,2.4-1.6,3.7-3.6,2.8.4.7,0,1.4-1,2,.4.1.4.3,0,.5,0,1.1.6,2.1,1.5,3,.1-.4.3-.4.5,0l1,.4c-.7.8-.4,1.5,1,2.1,5.4.5,3.4,5-1.5,2-.9.3-4.4-.2-4.5,0,0,.6,0,1.2-.5,1.5h-.5c0-.2,0-1.3,0-1.5,0-.2,1.1-.5,1-.8,0-.6-.9-1.1-1-1.6s.7-1,.8-1.5c.1-.8-.6-1.9-.4-2.9s1.2,0,1.4-.3.9-4.3,1.1-5.1.9-.3,1-.3c-.3-1.8,0-3,.7-3.6-.3-1.9,0-3.6.8-4.9,0-.2,0-.3,0-.5l1.7-4.4c.4-.3.8-.3,1.3-.1.4-.4,1.5-.6,2-1,1,.3,1,.7,0,1Z"
          fill="#0003a5"
        />
        <path
          d="M67.8,184.8c-1.1,1.1-1.4,3.6-3,4.5.2-1.5.4-3.4.9-4.9.8-2.7,3-5.2,4.1-7.6,1,3.1-3.2,4.3-2,8Z"
          fill="#010292"
        />
        <path
          d="M64.8,189.8c0,.7-.5,1.4-.5,2.3s.7,2.3.5,2.9-1.3.6-1.4.9c-.3.4,1.1,2,0,2.4,0,0,0-.3,0-.5-.4-.1-.4-.3,0-.5,0-.4-.5-1-.5-1.5.6-1.8.8-3.7,1-5.5l1-.5Z"
          fill="#010292"
        />
        <path
          d="M140.3,97.4c-.5.8-1,1.1-1.5,1-.7-.1-1.4.2-2,1-.8,1.6-2.4,2.9-4.7,4-4.2,4.5-9.5,8.9-14.8,11.5-1.9,1.8-3.5.3-1.5-1.5.9-.7,2.1-2.3,3-3,1.4-1.2,3.1-2.4,4.5-3.5.1-1.6,3.5-3.3,5-3.5,3.8-2.8,7.8-5.7,12-7.5,1.7-.5,1.2.6,0,1.5Z"
          fill="#081dc7"
        />
        <path
          d="M115.8,113.4c-1,.7.8,2.5,1.5,1.5-.2.8-.9,1.4-2,2,.2.6,0,1.4-.8,2.3-2.5,2.4-4.6,5-6.2,7.7.5.1.4.3,0,.5,0,.7-.5,1.1-1.5,1-.5,3.6-4.6,3.4-2.5-.5v-1.4c1.9-1.6,4.8-5.8,1.2-1.9l-1.2-.2c-1.4-.2-1.2-.5,0-1,.7-.3,4.5-3.8,5.5-4.7,2-1.7,3.9-3.5,6-5.3Z"
          fill="#091ccb"
        />
        <path
          d="M102.3,122.9v.5c.2.5,1.4.3,2,0v1l-.3,1.6c-1.6.7-3.2,1.8-4.7,3.4-.1-1.5-1.1-2.5-.5-3.5.3-.1.6-.8,1.1-1.2.7-.6,1.9,0,1.4-1.8.3,0,.7,0,1,0Z"
          fill="#1822b6"
        />
        <path d="M102.3,123.4v-.5c.7.1,0,.5,0,.5Z" fill="#222bac" />
        <path
          d="M104.3,127.9c-.4,2-1.1,5-3.5,5l-1.3,4.2c-.6,1.6-3.1,4-4.7,3.3.3,1.8-2,6.8-4,5.5-.3.8-.7,1-1,.5.2-.7.5-1.8.8-2.4.9-1.7,3.9-3.9,2.7-6,2-1.3,4-4.1,4.5-6.5.5-.3,1-.7,1.5-1,.9-2.4,6.9-7.7,5-2.5Z"
          fill="#0109ae"
        />
        <path
          d="M104.3,124.4c1.5-1.3,3.7-3.8,5.5-4.3s1.2-.6,1,.5c-2,1.4-3.2,3.8-4.7,5.8s-1.4,1.1-1.8,1.5c-.4-3.2-1.6-1.2-3.4.8s0,.6-1.6,1.7c0-.3,0-.7,0-1,1.5-1.9,3.2-3.4,5-5Z"
          fill="#0812bf"
        />
        <path
          d="M175.8,374.7c0,.8-.2,1.7-.5,2.5-.9.9-2.9-.1-3,0s0,1.1-.2,1.5c-.5.7-1.6.4-1.8.5-.3.3.6,1.6.3,2-.5.6-1.7.4-1.8.5s1,2,.4,2.9-3.2.2-1.9,2.6c-1.3-.5-1.8-1.1-1.2.5-2.3.1-.6.4-1,1.5-.9,2.4-3.1,1.3-3.2,1.5-1.1,1,1.3.8,1,1.5-.5,0-1.1.5-1.5.5-.9,0-1.6-.5-1.8-.5s-1,4.6-2.2,1c1.3-1.4,3.3-.9,2.5-4.5l2,.5-.5-3.5c.5-.4,0-1.2.7-1.4s2.5.5,2.8.4l-1-1.5c.8-.1,3.1-.2,3.4-1.1s-.6-1-.4-1.3,2.3-1.7,3-2.4.3-1.4.6-1.6c.5-.4,2.2.1,2.4,0s-.1-1.2,0-1.5c-.3-1.6,3-2.4,3-.5Z"
          fill="#041235"
        />
        <path
          d="M182.3,369.7c.8.8.3,1.3-1.3,1.6l.5,1c-1.6,1.1-2.9,2.6-4.2,4.4,1.2.8,1,1.5-.5,1.5-1,.3-1.1-.7-1.5-1-.7-.5-1.7-.6-2-1.5,1.2.1,1.7-.4,2.5-1,0-1.1.7-2.1,2-3-.3-1.3,1.3-2.4,2.5-2,1.1-1,1.7-1,2,0Z"
          fill="#021240"
        />
        <path
          d="M184.8,374.2c.6,1.3,0,2-1.9,2.2-.2,1.5-2.6,2.9-2.7,1.4l-.4-.6c1.7.8,1.2,1.5-.2,2.9v1.2c-.6,3.1-2.1,3.5-4.8,1.4.2-.5.9-1.4.9-1.8,0-.5-1.7-1.5-1.4-1.7.9-.4,1.5,1,1.7,1s.9-.8.8-1-1.2.4-1-.5c.3,0,.9-.3,1-.5s.5-1.3.5-1.5c.7-1.3,2.1-.9,2.5.5-3.7-1.9,2.3-7,5-5,.9.7,1.3,1.4,0,2Z"
          fill="#011952"
        />
        <path d="M154.3,414.7l-.5-.5c.2.1.4.4.5.5Z" fill="#0c398f" />
        <path
          d="M189.3,348.7c3.7-1.7,4,0,3.8,3.6,2.9,1.9,3.6,3.1-.2,3.9-.4-1,.4.1-.2.5s-1.9.6-2.7.3c1.2,1.5.4,2.5-1.2,3.1.3.2.7.6.6.9-1,2.3-3.1,3.9-5.1,5.1-.2,1.8-4,2-5.5,1-.9-1.7-1.5-1-2.5-1,.4-1.2-1.3-1.1-1.4-1.7s.6-2.7,1.1-2.8,4,1.2,4.2,1.3c1.5.8,2,5,3.5-.8-2.1.5-1.2-1.1-1.8-1.6s-2.6,0-2.7-.9c1.6.6,1.7-1.3,2.3-1.5,1.2-.4,2.9,1.8,3.7-.8-.6-.9-1.2.5-1.7.6s-1.3-1-2.2-.3l.5-1.5c-1.2.7-3,0-3.5,0,.2-.2.3-.4.5-.5.6-2,7.8-6.9,9.5-7.1s.7,0,1,0Z"
          fill="#03092a"
        />
        <path
          d="M184.3,366.2c3.1.1,0,2.5-2.2,2.2-.1.8-.7,1.2-1.8,1.3-1.1,1.4-1.2,1.2-2.5,2-.2.9-1,1.4-1.5.5,1.7-1-.1-2.3,0-2.5s1.5.4.5-1c1.8.3,1.4-.6,2-1.5s.5-1,.8-1c2.6,1.8,2.1,1.3,4.7,0Z"
          fill="#030f31"
        />
        <path
          d="M177.8,371.7c.5.9-1.2,2.5-2,3-1.1-.3-2.5-.8-3,.5l-1.2-.5c2.2,0,1.6-1.8,1.7-2s1,.5,1.6.4,1-.8,1.4-.9,1-.2,1.5-.5Z"
          fill="#051235"
        />
        <path
          d="M212.2,431.7c.4,1.1.3.6,1,1.5-1.5-.3-2.5.3-3.7,1l.2-2c0,.1.9.6,1,.5.2-.2.2-.4,0-.5,0-.2,0-.4,0-.5-.3-.9.3-1,1-.5.7-.7,1-.4.5.5Z"
          fill="#011e73"
        />
        <path
          d="M194.3,420.2c-.5-1.3.4-1.3,2.9,0l1.1-1.2c.5-2,6.1-.9,6.2.6-1.2,1.9-.9,3.3.9,4.2.6,2.5,1.2,3.3,1.8,2.4.1-.4.3-.4.5,0l1,1c.3.2.4.5.5,1,.4.2.4.3,0,.5.4.3.7.9,1,1.8,1.1-.2,1.3.2.5,1.2.5.1.5.3,0,.5.3.2.3.3,0,.5-.8,1-.9.6-1-.5-.7.2-1-.6-.9-.5,1.7.9-2.2,1.1-3,.2-.4,2.5-3.3,2.7-3.7.3-1.5-.2-2.9-.8-4.3-2q-1.1-.6,0,0c2.6.9-.3,2.5-2.5,1.3-1.6-.7-3.2-1.2-5-1.3-1.3-.4-3.3-.6-4.5-1s-1.9-1-2.5-1.5c.9-.6,1.5-1.5,1.7-2.8,1.3,0,2.2-.6,2.5-1.9,1-.3,1.9-.7,2.7-1.3,1.5-.6,2.1-1.1,2.3-2.6l1.2-.4c1.3-.1,1.6.7.5,1.5q0,.5,0,0Z"
          fill="#012479"
        />
        <path
          d="M190.3,430.2h3s-2.5-1.3-2.5-1.3l1-.7c-2.1-.4-1.3-2.5.5-.5l-.5-2h2.2c1,.6-.7,1.5-.7,1.7,0,.5,3.1.7,2,1.7s-2.3-1.3-2,.2c1,1.4,2.4,2.2,4.2,1.8s.2-.9.3-1l-2.5.5c-.9-1.1,3-2.7,2.5-.5.4-.4,1.3-.7,1.5-1.3s-1.6,0-.8-.7c2.7-1.5,1.2,0,1.3,1.2.2,2.8,2.3,1.1,4.5,2.3.4,1.7-1,.4-1,.5-.9,1.6,2,1.2,1.6-1.4l3.4-2.1v2s-2,.5-2,.5c.7.6,3.3,0,3.5,0,.2.2,0,.9,0,1,.6,1,1.4.9,2.5-.5-.3-1.4,1.9-4.1,2.6-2.4-.5,2.5.3,4,1.9,5.4,3.2-1.1,6.9-2.1,5.5,3-.3.6-1.3.6-3,0-4.7,0-10.1-1.2-14.5-3-4.9-1.2-9.7-3-14.5-4.5Z"
          fill="#012882"
        />
        <path d="M199.7,424.2c0,0,.6,2.4.6,2.4l-3.5-2c-.2-.6,2.8-.6,2.9-.4Z" fill="#012c80" />
        <path
          d="M210.2,428.7c2.8-.1,3.7,1,1.5,2.5-.2.2-.7.3-1,.5-.5-1-1.3-.9-1.5-3,.3,0,.9,0,1,0Z"
          fill="#012882"
        />
        <path d="M202.7,421.7c-.2.7-.8,1.1-1.5,1v-1s1.5,0,1.5,0Z" fill="#012c80" />
        <path d="M201.2,423.7c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#012c80" />
        <path d="M193.7,422.2c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#022b7a" />
        <path d="M194.3,420.2c0,.1.8.7.3,1-1-.7-.2-.9-.3-1Z" fill="#022b7a" />
        <path d="M196.5,427.7c.3.2.3.3,0,.5v-.5Z" fill="#012882" />
        <path d="M210.7,432.7s0-.3,0-.5l.5.2-.5.2Z" fill="#012882" />
        <path
          d="M174.8,398.2c.3.5.6.7,1,.5,1.3-.5,1.5,0,.5,1,0,.7-.3,1.2-1,1.5q-.4.6,0,0c0-1.1.7-1,1,0,1.3-.2,1.5.2.5,1q-.8.5,0,0c0-.9,1-1.1,1,0,.4,0,.8,0,1,.3v4.4c1.6.9,2.4,2.3,2.5,4.1,1.8-1.1,5.2,1.7,3,3.9-3.2.7,0,1.9,2,1.8,1.3,0,1,1,0,1.5,0,.3.8,1.2.5,1.5-.8,1-1-.8-1.2-1-1.3.6,0,4.1-3.2,2.5l1,2c-2.2-.9-3.4.6-5.5.5,1.6-1.6.9-2.4-1-3-.2-1.6,2.8-1.3.4-.7s-4.4-3.1-3.5-5.6c-.9-1.1-2.2-3.2-.4-3.7-.1-.5-.5-1-1-1.5-1.9-1.1-.1-2.6,1.6-1.9v-1.3c-3.6,2.7-4.4-2.7-1.1-4.3-.2-.2,0-.4.5-.5v-.5c-.8-.9-.5-3.2,1-3,.7-.7,1-.4.5.5Z"
          fill="#01216b"
        />
        <path
          d="M189.8,417.2c2.6.4,3.2,3.7.5,4.5-.2,2,.3,2.7,1,4.5-.3.2-1.8-.5-2-.8-.4-.5.4-3-1-1.7s-1,3.5-.5,4.5c-1.6-.8,0-3.2-2.5-2.5l1,2.5c-1-.4-2.1-.3-3-.5-3.5-.7-6.7-2.6-10-4-.2-1.5.2-2.1,1.3-1.7.6-1.2,1.4-1.6,2.2-1.3l1.1-.6c2,2.5,3.3,2.8,3.9.9,1.4,0,2.4-.8,2.9-2.7,1.2.6,1.8.6,1.6,0,0-1.4.6-1.3,1.5-.5.6-.7,1.4-1.4,2-.5Z"
          fill="#012072"
        />
        <path
          d="M191.8,417.2c.6-.8,1.4-.7,2.5.5,0,.5-.4.7-.5,1-.7,1.3-.4,2.4-1.6,3.3s-.6-.3-.8-.2,0,2-1.1-.1c0-.6,1.1-2.9,1-3l-3.5.5c0-1.3,3.6-.1,2-2-.3-1.1,2.5-1.9,2,0Z"
          fill="#022b7a"
        />
        <path d="M189.8,420.2l-1,3v-2.5c-.9-.2-.3.8-.5,1-1.2,1.2-1.7-2.2,1.5-1.5Z" fill="#012479" />
        <path
          d="M173.3,400.7c0,0,.4,0,.5.2,0,.3-.5.2-.5.3-.7.1-.8.3-.5.5,1.1,1.9-2.7,1.8-.5,4.5.8.2.3-.7.9-1s2.4-.7,2.6-.5c.1,1.6-.9,1.4-1,1.5-.7,1.1,3.1,1.8.2,3s-3-2.7-2.7,0c.6.3,1.1.9,1,1.5.1,2.9,1.5,3.1,1.5,3.3s-1,4.8.7,1.5-.8-1,.8-.7c-1.1,2.2.7,1.6,1,2s-.6,1-1.3,1,.2-1.3-1-1,1.6,4.1,3.2,2.5c-.2.6-1,1-1.5,1.5-1.1.6-1-1.9-2-1s.1,3.4-1,2,.7-2-1.5-1.5l.5-2-.7,1c-1.9-1.5-2.1,2.2.2,1.5-.6.8-1.1.6-1.2,2-1.3-1-1.2-1.5-1-3-.9.3-2.6.7-3.3-.3l1.5-.5c0-.5-.7-1.4-1-1.7.7-.3,5-3.4,5-3.7s-1.7-1.4-2.2-1.3c-.7.2.4.8.5,1,.7,1.7-1.3.3-1.6.2s-.9.3-1.1.2-.2-.8-.6-1.1c-1.1-.8-.6.1-1.4-1.3l1-1h2.5s0-4.5,0-4.5l-1,.2-.5,1.3c0-1.6-1.2-3.5,1.3-2.6-.5-1,.8-.9.7-1.2-.7-2-1.9.6-3,.7-.3-2.7,4.2-2.6,6-4,.5-.8.7-.6.5.5Z"
          fill="#011e60"
        />
        <path
          d="M167.3,417.2c1.3-.7,1.8.5,1.9,1.7,1.9-1.4,3.6-2,4.7.4,1-1.2,2.6.2,2.9,1.3-.9.8-1,1.9-3,1.5l1.5,1-2,.5c-4.1-1.7-7.1-3-11-5l1.7-.5-.7-2c1.6-.1,2.8-.1,4,1Z"
          fill="#022169"
        />
        <path d="M164.5,417.2c.3.2.3.3,0,.5v-.5Z" fill="#021b5b" />
        <path
          d="M213.7,428.2c0,0,0-.3,0-.5,2.1-2,2.2.9,2,2.9s-.2-1.3.5-1.4c.4,0,1.2.1,1.5,0v.5c.3.6-.4,1.1-1,1,0,.8,2.4,3,0,4-.3-.2-1.6.2-2.2-1s-.1-3.7-.3-4.5l-2,2.5c0-.1-.4-.3-.5-.5.5-.4.3-1.4.5-2-.8-.2-.4.7-.6.9-1.8,1.3-1.3-1.2-1.4-1.4.7-.6,0-1.3,0-2,.6,1,2.6,3.2,3.5,1.5Z"
          fill="#012174"
        />
        <path
          d="M222.2,437.7c1.3.3,2.7.4,4.2.3,1.2-1,2.6-.4,2.3,1.2-2.2-.2-5-1.2-7,0-.9-.1-1.6-.5-2-.5.8,0,1.7.3,1.5-.5-.9.3-1.4-.3-2-.5,1,0,2.1-.1,3,0Z"
          fill="#0e51c8"
        />
        <path
          d="M216.7,438.2l2,.5c.3,0,.7,0,1,0,1.3,0,1.9,0,2,.5h.5l4,.5c.2-.4.3-.4.5,0l1.5.5c.5-.7,1.5-.7,2,0,.9.4,1.9.5,3,.5,5.3-.3,10.7-.1,16.1.4,4.7-.2,9.3-.2,13.8.1,1.4-.3,3.2-.5,4.5,0l1.5,2c-.7-.6-2.9.1-3,0-.3-.4.9-2.1-2-1.5,1.7,2.2,1,1.7,0,3,.5,0,1,0,1.5,0v2c-.2.1-.3.3-.5.5.1.3.2.6.1.7-2.8,1.9-5.1-2.8-1.1-3.2-.8.8-1.7,1.1-2.6,1-.3,2.1-2.7,2.7-4.6,2.2-2.3,1.9,5.3,1.2,5.8.9l.9.9c2,0,4,0,6,0,.4.1.4.3,0,.5-.3,0-.7,0-1,0-.8.4-1.7.4-2.5,0-1.1.1-2.2.3-3.5.5-7.2,0-14.3,0-21.5,0-.4-.1-.4-.3,0-.5.6,0,2.1.4,2-.5-1.7-.1-3.3-.5-4.9-.7-4.9-.6-10.8-.8-16.2-1.4s-2.2-.6-3.3-.4l.5-1c-1,0-2,0-3,0-1.9-.9-3-.5-3-2.5.8-.4,1.7,1.2,2,1,.9-.9-.9-1-1-1.3,0-.1.9-1.7,1-1.7,1.5-1,.4,2.2,2,1.5,0-.9.3-2.4-.2-3-.7-1-2.9.5-2.3-2,.6.1,1.4-.1,2,0Z"
          fill="#01118d"
        />
        <path
          d="M266.2,450.2c.4.1.4.3,0,.5-1.2,0-2.3,0-3.5,0,.7-.9,2.4-.5,3.5-.5Z"
          fill="#3e79dc"
        />
        <path d="M268.7,450.2c-.4.8-1.7.5-2.5.5v-.5c.8,0,1.7,0,2.5,0Z" fill="#3b7ce1" />
        <path
          d="M228.7,439.2c.5-1.2,1-1.2,1.5,0l3,.5c3.2-1.4,7.9-1.2,11,.5,4.6.4,9.5.6,14,0,.1-.4.3-.4.5,0,.5.4,1,.4,1.5,0,0-1.3.4-1.3,1,0,.4.2.6.2,1,0,.4-.4,1-.3,1.5,0,1.1-.2,2.2-.3,3.5-.5.3-1,1.1-.9,1.5,0,.6,0,2.5-.2,2.5.2l-2.5.7c-.2,0-.3,0-.5,0-1.6.2-3.3.3-5,.5-10.5,0-19.4.5-30-.5-1,0-2-.1-3-.5-.7,0-1.3,0-2,0l-1.5-.5c-.2,0-.3,0-.5,0l-4-.5c-.2,0-.3,0-.5,0,0-.3-.2-.5,0-.7.2-.3,6.3,0,7.1.7Z"
          fill="#0b52cf"
        />
        <path
          d="M268.2,440.7c0,.2-.3.5-.5.5-1.3.2-3.1,0-4.5,0,1.2-.9,3.4-.4,5-.5Z"
          fill="#074dcb"
        />
        <path
          d="M263.7,449.7c-1.7,0-5.3.8-6.6.5s-.6-1.5-1.8-1l1-.7c-1.4-1.8-4.2-2.9-3.5.5,0,.4-.9.3-1,.2-.2-.2-2.1-4.2-2-5l2.5,2.5c-1.3-3.2.7-1.4,1.5-2.8s-3.4-1.8,1-1.7c-.6,1,0,1.6.5,2.5-1.1,0-1.8-.4-1.5,1,1.9.6,4.9,2.4,6.8.5s-1.3.2-.8-1.5c1.5,0,3,0,4.5,0-.6.7-1.5.6-.9,2.2s1.8.3,1.9.3c.4,0,1.9.9,2,1.5-1.4.2-3.9-.8-3.5,1Z"
          fill="#010f89"
        />
        <path d="M218.7,438.7l-2-.5c.8.1,1.7.5,2,.5Z" fill="#0e51c8" />
        <path d="M226.2,439.7c-1.3-.1-3.1.5-4-.5,1.3,0,3.1-.4,4,.5Z" fill="#0e51c8" />
        <path d="M233.2,440.7c-.9,0-2.4.4-3-.5,1.1.1,2.3.4,3,.5Z" fill="#0e51c8" />
        <path d="M228.2,440.2c-1,0-1.4-.5-1.5-.5l1.5.5Z" fill="#0e51c8" />
        <path d="M256.2,442.2c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#010f89" />
        <path
          d="M178.3,356.2c2.3-1.1,3.3-.9,5.2.7,4.5-1.8,2.9,4.5-1.4,2.3,2.2,2.2,4.2,6-.5,6.6-.8-1.7-5.3-4.5-5.6-1.8,1.2.6,1.7,1.4.3,2.1-1.7,0-.3-1.2-2-1l-.5,1.8,1.5-.3c.3,2.8-.2,4-3,4l1.5,1.5c-1.8-.3-2.1.7-3.5,1.5-.4-.1-.4-.3,0-.5v-1l-1-.7c.4-1.8,0-2.9-1-3.3-1,0-1.8.2-2.5-.7l3.5-2.7-2,.5.3-1c-.3.4-.8.4-1.3.5v-1.2c1.2-1.1,10.8-7.8,11.5-7.6s.3.2.5.3Z"
          fill="#030925"
        />
        <path
          d="M178.8,355.7c.4.3.2.5-.5.5-1.6.1-10,7.1-12,8.5-.2,0-.4,0-.5,0,.6-.8.8-1.5-.5-.8s-3.5,2-4.5,2.8h-.5c0-1,.9-1.8,2.5-2.5,2.2-2.1,5.2-4.4,8-5.5,2.3-.4,4.2-1.9,5.9-3.5,1.3-.8,2.7-1.4,2.1.5Z"
          fill="#205af0"
        />
        <path d="M174.3,368.2s.2,1.1-.2,1c-1.4-.8-.3-1.6.2-1Z" fill="#060e2a" />
        <path
          d="M170.3,372.2v1.5c-.6.3-1,.9-1.5,1.2s-1-.2-1-.2c0,.2.7,2.5-.1,3.4s-3.6.6-4.6,1.2-.8,1.6-1.8,1.5l1.5,1c-1.7-.1-2.9,1.4-2.5,3-1.4-1-.8.1-1.5.7s-1.9,1.3-2.5,1.8c-.8.4-1.4.6-2,.5l-1.5-1c2.3,1,1,.2,1.7-.8s1.6-.2-.2-2-3.1.5-2-2.2c-1.6,1.5-2.9,1-3.5-1,2.6-.1,5-.1,7.5-1l-.5,1.7c0,1.1,3.2-1.3,1.5-2.7l2.5.5c-.3-5.2,1.8-2.5,2.5-3l-.2-1c2.2,1.3,1.8-.6,2.3-.9s1.9,1.7,2.4-1c-1.7.5-3.1.7-3.5-1.5,1.1,0,1.2-1.4,2.3-1.4s1.2,1.2,2.2.9l.5-3c.1,0,1-1.2,1.8,0s.2,2.9.2,4Z"
          fill="#070b20"
        />
        <path d="M170.3,373.2l-.5-.2.5-.8c0,.1.8.5,0,1Z" fill="#060e2a" />
        <path d="M160.5,377.7c.3.2.3.3,0,.5v-.5Z" fill="#04091b" />
        <path
          d="M100.8,312.3c3.2-.2,1.7,3.9.6,5.6l.9,1.4c2.2-.6,2.4,3,1,4,.9-1,1-1.4.6-2.9,3.8-.9,4,3.8.9,4.1-1,2.3-2.3,1.1-1.5-1.1.9,1.6,1.2,3.2.9,4.8.3-1.5.2-1.7-.4-2.8s3-2.7,3.3,0c0,2,.4,3.8,1.4,5.5-1.3,0-2.2.3-2.7,1-.1.7-.8,1.3-2,2,.2.2.4.2.5,0,.1-.4.3-.4.5,0l.7.2c-.7,1.1-.7,1.7-.2,1.8v-.5c-.4-.2-.4-.3,0-.5.7-.5,1.4-.4,1,.5.4.1.4.3,0,.5,1.1.6,1,1.1-.5,1.5,0,.9-.5.8-1,0-.2-.2-.4-.2-.5,0,.4.2.7.6,1,1l-1.5,2-.5-3-1,1.5c-.9-.4-.5-1.4-2-1l.5-1c-3.8-.4-.5-.9-.1-1.1.6-.4.4-1.9.7-2.5s1.1-.2,1-.6c-.5-1.5-1.4.3-2.2.3-.3-1.8-1.4-.2-1.8-.5s.1-1.3,0-1.5c.7-.5-.2-2.8,0-3,.9-1,1,1.1,1.2,1l.7-2c-3.9.8-2.3-1.1-2.6-2.6s-2.9-3.5-.1-4.9.4,1.2,1.2,1c1.1-2.7-4.6-4.6.5-6.2l-.5-1.8c-.5-.1-1.8,3.3-2.5,1.2s1.4-.8,1.5-1.7c-1.1,0-1.4-.5-1.5-1.5,1.3-.5,2.5,0,3.7,1.3.9-.1,1.2,0,.8.7Z"
          fill="#021dca"
        />
        <path d="M107.3,343.7c0,.3,1.2.7,1.5,1-2.1.6-3.5-1.2-1.5-1Z" fill="#011dca" />
        <path d="M107.3,343.7v-.5c.1-.4.3-.4.5,0,0,.3-.5.5-.5.5Z" fill="#011dca" />
        <path
          d="M106.3,335.7l.7-.7c.4-2.1,2.4-1.2,2.8.7.1-.4.3-.4.5,0,.6,1,1.5,1.3,1.7,0l2.3,1c.6.4,1,2.4.2,2.8.2,1.7.7,2.1,1.2.2,1.1-1.2,2.2-.9,2.4.6.3-1.6,2.1-2.6,2.1-.6.6.8.9,1.3,0,2,1.1.2,1.1,1.3,0,1.5.8.5,1,.8,0,1-3.8-1.3-2,.5-2.5,1-.7-.6-2.9,0-3,0-.2-.1,1-1.8-.5-2,.3,1-.9,1-1,1-.6,1,.6,1,1.2,1.5s-.3,1.6,1.8,0c.9,3.5-3.2.9-3,4.5l-2-1.5,1-1c-.6,0-2.8-.3-3-.5s.8-.9-.5-2.5c.4-.1,1,.3,1-.3-.6-.9-.7-2.6-1-3.2.2-1.4-1.6-2.9-2.8-3.1s-.4-.5-.2-.9c.3-.5.3-1,.5-1.5Z"
          fill="#011dca"
        />
        <path
          d="M105.8,337.2c.2,0,.8.6,1,.5s-.3-1.2.5-1c.4,1.4,1.2,3.2,3,3-.5,1-.3,1.6-1.5,1.5l-1.6-.8c-.3,0-.8-.5-1.4-1.7,0,0-.3-.4-.5-.5-.4-.1-1.7.2-1-1,.1-.3.3-.3.5,0,.3,0,.7,0,1,0Z"
          fill="#0113c1"
        />
        <path
          d="M108.8,341.2c-.5,0-1.8-.7-2-.5-.3,1.3.3,1,1.5,1-.3.5-.4.9-.5,1.5h-.5c-2.6-1.5-.4-2.4-1.5-4.5.1,0,.9-.6,1-.5s0,1,.3,1.5,1.3.7,1.7,1.5Z"
          fill="#021dca"
        />
        <path
          d="M126.8,332.2c-.3,0-.8-1.4-.8-1.5,0-.1,2.3-1.5,2.7-1.4,1.4.5,1.8,1.6,1.1,2.9.3,2.1-.3,6.6-2.5,7.5,0,2-.7,4-2.5,6,0,.2,0,.3,0,.5h-.5c.6-1.8,1.2-3.7,1.5-5.5l-2.5,5c-.5,1.5-1.7,1-1.5-.5-.9-.3-1.4-1-1.5-1,0-.2,0-.7,0-1,.4-.6.6-1,0-1.5,0-.3-1-1.1,0-2,.8-1,1.7-2,2.8-3.1-.2-1.3,0-1.9.8-3-.6-.8-.3-1.7.9-2.9,1.5-.8,2-.2,1.5,2l.5-.5Z"
          fill="#021fc1"
        />
        <path
          d="M116.3,356.2c3.4-1.6,3.7,0,2,3l-1.2,3.7c-1.2,2.5-3.5,1.5-2.5-1.2-.3-2.5-.8-1.1-1.5,4.2l-.9.9c2.8,3.3,2.7,4.6-.3,4.1-.4.8-.4,1.7,0,2.8.2.2.4.5.5,1,.4.3.4.7,0,1l1.2,5.2c-.7,1.3-1.4,1.3-2.7.8-.5-.2-1-.2-1.5-.5s-1.3-.9-1.5-1l-1.1-1.5c-1.9.5-3.5-1.6-1.4-2.5.7-.4.9-1.4.5-3l-.5-.5c-.1.4-.3.4-.5,0,.6-1.1.4-1.4-.6-.8-2.6-2-.3-3.4,1.6-4.2.5-1.8,1.3-3.4,2.4-4.9-.5-1.1-.3-2,.4-2.7-.8-.4-.7-.7.1-.9.4-1.7,1.1-2.4,2-2l.4-.6c1,.3,2,.4,3.1.1.9-.8,1.5-1,2-.5Z"
          fill="#0109ab"
        />
        <path
          d="M113.8,371.7c.4.8.3,1.8-.5,3,.3.2.3.3,0,.5.6.4.6,1.3,0,2.5.9.3,1.5,2.7,1,3.5h-.7c-.8,1.8-1.5,1-2.8.5,4.6,1.3-.4-5.9,1.5-6,.2-1,.5-2.5,1-4.5.6-.8.7-.6.5.5Z"
          fill="#06077d"
        />
        <path
          d="M111.8,373.7l-2.5-1.8,2-1.2c-4.3-.8-2.8-1.4.4-2,.3.9.8,2.1,2.1,1.9-1.3-2.3-4.7-3.7-1-5.7l-2-.3,2-1c-1.6-3,0-1.8.4-2.6s-.5-.9-.2-1.4c1.2-2.2,3.8,2.3,1.8,3.5,2.5.6,1.6-3,3.5-4,.3.1.3.4,0,1,1.2.5.8,2.5-.5,2.5.3.2.5.4.4.5-.5,1.8-2.7,6.6-3.7,8.3s-.4.1-.7.1c0-.2-.2-.5-.5-.5,0,.4-.3.4-.5,0-.3.9-.6,1.8-1,2.5Z"
          fill="#030ba3"
        />
        <path
          d="M105.3,372.7l.5.5c.6.7,2,3.2,2.1,3.4.4.4,1.9-.5,1.4,1.4s-1.4,1.3-1.5,1.2c0-.1-.3-1-.7-1.5s-1.3-1-1.8-1.5c-.8-.9-1-1.5-1.5-2l.5-1.5h.5c.2,0,.4,0,.5,0Z"
          fill="#010dc6"
        />
        <path d="M105.8,373.2l-.5-.5c.3.2.3.3.5.5Z" fill="#010ebb" />
        <path d="M117.3,357.2c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#0412a0" />
        <path
          d="M120.3,344.2c.6-.6,1.9,0,1.5,1,.3,1.3,0,3.6-1,4.5-1.6.6-1.4-1-1.5-1-.8-.3-1.8,2.2,0,2.2-.7.8-2,1.2-2.6,2s0,1.6-.2,1.8c-.6.7-1.2-.1-2.3,2-1.6-.1-1-1.2-1.7-1.4s-.6.4-.8.4l-.5-2.5c1.3.4,2.2.5,3.5,0,.1-.2-1.2-1.9.6-2.8s.8.4.8.3c0-.1.3-1.9,1-2.6s4.3-1.6,1.5-2.6c.4-.5,1.3-.7,1.5-1.3Z"
          fill="#0115ba"
        />
        <path
          d="M123.3,345.7c-.5,1.9-.9,3.3-2.5,4.5,0-.2,0-.3,0-.5.2-1.1-.6-3.9,1-4.5.5.2.9.5,1.5.5Z"
          fill="#020fab"
        />
        <path d="M115.3,353.7c0,.6-1.9,1.6-2,1.5-.7-.8,1.1-1.6,2-1.5Z" fill="#0112b2" />
        <path d="M63.3,197.3c0,.1,0,.4,0,.5-1.4.2-1.4-.7,0-.5Z" fill="#010284" />
        <path
          d="M82.3,282.3c.2-.1.5-.2.7-.2s1.2,2.2,1.2,2.1c-3.1-3.9,2.7-4.2,2.7-.2,1.6.3,1.7.7.4,1.3.6.9.7,1.2-.5,1.5q-.2,1.4,0,0c.5-1.4,3.6-1.2,3,.6,1.1,1.1,1.2,1.9.5,2.4.4,1.6.9,3.1,1.5,4.5.2.3.3.5.3.8.3,4.1.3,4.5-4.3,5.7-.3.1-1-.3-1,.5l.5.5c.5.4.1.7-1,1-.4,1,0,.8,0,1,.4.1.4.3,0,.5,0,.3,0,.8,0,1l-1.5,1c.3-.9-.1-3.1,0-3.7s2-1.7,2-3.5-1.7-1-1.5-1.8c3,1.1,1.9-1.7-.5-1.5l-1,2c0-2.3-.4-2.8-3-2.5l1-.7c-.8-.7-1.5-1.9-2.5-2.3,0-.8-.2-1.3-.5-2,4.6.2.9-2.1.6-2.8-.5-1.2,0-3.3-.6-4.7,1.3-.4.7.7,1.4,1s1.6-.4,1.1,1.3-1.2,0-1,.5c.7,1.7,2.4-.3,2.4-.5,0-.6-.8-1.8-.4-2.8Z"
          fill="#0112c7"
        />
        <path
          d="M75.3,256.3c-2.2.4.5-3,1.7-3.4,2.2-.7,2.4,1.5,1.8,3.1,3-2,6.5,2,6.5,4.8.8,0,.9.8,0,1l-.5.5h.5c0-1.6,2.1-.7,2.9,0,.7-.4,1.2-.4,1.5,0,.4.1.4.3,0,.5v.5c.4.1.4.3,0,.5l-.5.5c.4.1.4.3,0,.5,1.3,1.6-1.4,2.3-2.8,1.6-.5.7-.9.9-1.7.4,0-2.3-1.2.8-2-1.8,2.8-1.1-1.7-1.2,0-3.7-2.8,1.1-.7,3.9-2.7,5.5l-1.7-1.5c-1.6-2.3-.4-2-.6-3.3s-1.6-.2-1.9-.2c-.7.6-.9.3-.5-.5-.5-.3-.1-1.1.5-1-.5-.7-.2-1.2,1-1.5-.2-1.2-.7-2.1-1.5-2.5Z"
          fill="#0112ca"
        />
        <path
          d="M68.3,252.3c1.7,0,3,.8,3.4,3.2,1.8,0,1.7.6.3,1.4.3-.4.6-.2.7.4l.6.5c-.3,1.9.4,3.8,2.4,4,2.4-3.7,3.4,1.3,2.5,3.5.5.5,1,.6,1.5-.2,1,2.6-2.6,4.5-5.3,3.7.6.2.9.7.8,1.4q.7.8,0,0c-.5-1.6,2.7-1.7,3-1.4,1,.9,2.2,3.1,1.8,4.4,1.5,1.5.8,3-2.1,4.5l1.1,1.5c-.2,1.6-.6,2.1-1.4,1.5q-.9-.9,0,0c.9.2.2.9.3.9.8-1.6,2.9-.9,2.2,1.1,1.2-1.2,1.8-1.4,2-.5l.9,2.4c1,1.4-1.4,2.9-2.9,2.4,2.8,2.4,1.8,3.4-1,5.3-1.3,1.9-6.1.2-4.5-2.2-.5.3-1,.1-1.5-.3l-.5-.2,1-1.5c-1.9-.6-.5-1-.5-1.3.6-.3.5-.8-.5-1.5,0-.2,0-.3,0-.5.4-.5.3-.5-.5,0-.2,0-.4,0-.5,0,.3-.8.5-7.9.4-8.3-.3-.8-1.5-2.4-2.4-2.8l.2-2.2c-.7.2-1.4-.4-1.2-1.1v-.5c.4-.1.9-.6,1.5-.5.2-.9-.8-.3-1-.5s.7-1.3.5-1.5l-3,.5c.5-.6,0-2,0-2,.3-.1.9.4,1.3.4.6-.1.6-1,.8-1.2s1.7,0,1.9-.2c.6-.8-.9-1.3-1-1.5v1s-1.5,0-1.5,0c.2-.7.8-1.1,1.5-1-.5-.9.1-1.6,0-1.9s-1.1.2-.9-.6l2.5.8c-.8-2.6-3.7-1.5-3-4.3l1.5-.2c-.6-1.4-2.4-.2-2.5-.3s0-1.1,0-1.5c.9.1,1.6.4,2.5.5-.9-1.7-3.4-1.6-2-4,.9-.4,1.1-.3.5.5Z"
          fill="#010abc"
        />
        <path d="M72.8,285.3c2.3.4,3.3-.6,2.5,2.5l-2-1c0-.6-.5-1.2-.5-1.5Z" fill="#0106b4" />
        <path d="M72.3,284.8c.1-.7,1.2-.6,1-.2-.1.2-.5.2-.5.2h-.5Z" fill="#0106b4" />
        <path d="M73.3,270.3c-.3,1.9-1,3.1-2,.7.5-.8,1.1-.9,2-.7Z" fill="#0106b4" />
        <rect
          fill="#00028e"
          height="1"
          transform="translate(-202.9 356.6) rotate(-89.9)"
          width="1.5"
          x="76.6"
          y="279.5"
        />
        <path d="M75.3,272.8l-1,1c-.1-1,0-1.1,1-1Z" fill="#010fc6" />
        <path d="M69.3,272.3c-.2-.2.5-.8.5-.2s-.4.4-.5.2Z" fill="#010abc" />
        <path
          d="M89.3,301.3c.2-1.8,2.7-3.2,4-1,4.9-.6,1.9,3.2-1.5,3.3.6,1.3,1.3,2.5,2,3.7.5.2.1.9.1.9.7-1.3,2.3-1,2.3.6v1c.4.1.4.3,0,.5l.8,1c3.3.8,4.5,2.8,1,4.5,1.7,2.6,3.4,5.4-.8,5.2,1,1.7,1.4,3.4,1.3,5,1.8-.2,2.1-.2,2.5,1.6s-2,3.7-2.8,3.2c-.5,1.5-2.4.7-2.6-.7-3.2-.4-3.9-4.2-3.7-7.1-3.7-.5-3.7-3.4-.2-2.1.3-.3.1-.4-.5-.5-.6.6-.9.3-.5-.5-2.7-.4-2-1.5-.4-3-1.1-1.2-1.6-2.9-1.8-4.5-1,1-2.7,2.6-2.8,0,0-.1,0-.3,0-.5.7-3.2-.3-1.7-1-2.5s1-1.1,1.3-1.4-.5-1.3-.3-1.5,1.5.8,2-.3c.1-.5-1.1,0-1.5-.7-1,0-1-.9,0-1,.4-.2.4-.3,0-.5-1.2.1-1.2-1.1,0-1,1.7-.6,2-.9,1-1l-.5-.5c-.4-1.3.4-2.1,1-.5,1-.3,1.4-.1,1,.5.2.3.3.3.5,0Z"
          fill="#0215c6"
        />
        <path
          d="M95.8,305.3c.7.5,1.2.9.5,1.5,0,1-2.2,1.2-2.5.5-2.6-3.9,1.5-5.9,2-2Z"
          fill="#0215c6"
        />
        <path d="M91.5,312.1c.8.6,1.7-.5,1.3,2.2h-2s0-3,0-3c.8-.2.3.6.7.8Z" fill="#010ebb" />
        <path d="M95.8,323.3c.2,2.5-2.9.8-2,0s1.5,0,2,0Z" fill="#010baf" />
        <path d="M87.3,301.8c.2,0,.7,0,1,0-.2.9-1.2,1-2,1,0-.2.8-.5,1-1Z" fill="#010ebb" />
        <path d="M89.3,301.3c0,0-.2,2.4-.5,0h.5Z" fill="#010ebb" />
        <path d="M86.3,303.8c1.4-.2,1.4.7,0,.5,0-.1,0-.3,0-.5Z" fill="#010ebb" />
        <path d="M92.6,309.3c.3.2.3.3,0,.5v-.5Z" fill="#010ebb" />
        <path d="M88.6,302.8c.3.2.3.3,0,.5v-.5Z" fill="#010ebb" />
        <path
          d="M79.3,292.3c1.2-.6,2.3,0,3.5,2l1.4.8c4-1,3.9,1.6,3.6,4.8-2.3,2-2.7,3.8-1.4,5.4,3.3-1.6,2.3,1.8.1,3.5.9,1.1.6,2.5-.6,3-.8-.9-1.5.5-1.7.5-.7,0-1.2-2.6-1.5-2.5l-1,2.5c-1-2.8-1.1-1.6-3.7-2l1-1c-.8-.2-1.3.8-1.8.9s-.6-.4-.6-.4c1-1.7,4-1.4,2.8-4l-1.7,2v-2.5s-1.8,1.5-1.8,1.5c-2.2-2.2-.6-1,.1-2.1s.1-1.7.6-2.4c.7-.8,1,.2.5,1,1.4,2,4,.1,1.5-1l-.5-.5c-.1.4-.3.4-.5,0-1.2.8-1.3-1.4-.9-2.1s2.6,0,2.8.1q1.8.1,0,0c-.7-.5-.5-1.2.6-2.1l-.6-.4c-.8-.3-1.6-.8-2.3-1.6-5.8,1-4.2-4,.6-2.1.3-.8.6-1.5,1.7-1.3Z"
          fill="#010ebb"
        />
        <path
          d="M79.3,297.3c1.2,1.9-2.9,4.1-3.1.6-.7,0-1.1-.4-1.4-1.1v-.5c1.1-1.2,2.6-.9,4.5,1Z"
          fill="#010ebb"
        />
        <path
          d="M73.3,289.8c.8-.7,2.8-1.2,3.5-.5s-2.1,1.3-1.5,2.5l2-1-.5,1.5c.7-.3,1.9-.3,2.5,0,0,.2-1.1,2.5-1.2,2.5-.9,0-4.3-2.3-3.8,1,1.4-1.4,2.7-.3,4.5-.5-.8,1.6-.5,1,.5,2-1.3.5-2-1.2-2.7-1.3s-1.3.4-1.8.3c-4.7-1.2-1.7-3.1-2-4.7s-1.3,0-1-.8c1.9.4,1.4-.9,1.5-1Z"
          fill="#0108b6"
        />
        <path
          d="M79.3,297.3c.2-.1,4-2.5,3.5-.8-.1.4-2.7,1.9-3.2,2.3s-.2.9-.3,1c1-.5,2.6-.1,3,1l-3-1c-.8.7-1.5,1.1-2.5.5-.3.8.5,1.3.5,1.5,1.6.7,1.1,2.4-.5,1.5,0-.6.2-.8-.5-1s-2.9-.6-2.2-1.5c.8,0,1.1.5,1.2.5.2.3.4.3.5,0,.9-.4.2-2.8-1.4-1.8s0,.7-.4.8c-1.4.4-1.6-3.2.7-3.5s2.2,1.7,2.5,2c1.3,1.1,1.8-1.3,2-1.5Z"
          fill="#0108b6"
        />
        <path
          d="M78.3,302.3c.3,0,1-.7,1.4-.4s1.1,2.3,3.1,2c-1.1,3.1-1.4.8-1.6.6-.7-.4-1.6,0-2.4-.1l2,1.5c-2.4-.5-3.8.4-4-2.5.6,0,.6-1,.5-1.5h.5l.5.5Z"
          fill="#0106b4"
        />
        <path d="M78.3,302.3l-.5-.5c.3,0,.5.5.5.5Z" fill="#0108b6" />
        <path d="M85.1,298.3c.3.2.3.3,0,.5v-.5Z" fill="#0112c7" />
        <path d="M87.3,301.8c-.1,0-.5-.4-.5-.5.1.1.5.5.5.5Z" fill="#0218ce" />
        <path
          d="M96.8,340.2c.4.1,1.9.6,2,.5,0-.3,0-.7,0-1,.3,0,3.3-.2,2,1s-6,0-2.5,4.5l-3.5,1c1.2-1.6.7-1.9,0-3.5l-1,1c-.3-1.8.1-2,1.5-2.7-1-.5-1.2-.4-1-1.7.9.9,1.5.7,2.5,1Z"
          fill="#0212bc"
        />
        <path
          d="M90.8,319.8c.2.2.4.4.5.5.4,0,.6.2.5.5-1.2.8-1.9-.6-2,.5,1.3.4,2.2.8,3.5,0,.1,1.6-1.5,3.2.5,3.7l-1,1.2,1.5.5-1.5,1.5c3.1-2.8.5,1,3,1-.9-1.5,2.6-3.4,1-.5l1.5.5-2,1c.4.1,1.9.4,2,.5l2.4.5c2.6-.6,2.8,1.1.6,5.1.6,1.2.3,1.6-1,1.4l-.7,1c.5-1.8-.5-.7-1.7-.5-.2.2.9,1,1,1.5-.9-.1-1.9,0-2,0-3.2-.5-.7-4-3.3-4s.8,1.6.7,1.7c-.1.4-1.4,2.3-2,1.8-.1-1.4-1.1-1.2.5-1.7l-1.5-1,3-3.3c-1,.6-2.2.5-3.2,1s0,1.2-.8,1c-.9-1.7,1.2-2.9,0-4.6s-2-1.3-1.5.2l-2-1.5c-.3-1-1.3-3.1-2.5-2.5l1.5-1.8-1.5-.2.5-1.5,1.2-.9c-.3-.9.2-1.1,1.3-.6-.4-.7.1-1.4,1.5-2,0-.9.6-.9,2,0Z"
          fill="#0212bc"
        />
        <path d="M91.3,320.3c.2,0,.7,0,1,0,0,.6-.4.4-.5.5l-.5-.5Z" fill="#010ebb" />
        <path d="M98.8,336.7c-1.1.4-2.3-2.6-1.2-3s.9,2.6,1.2,3Z" fill="#021dca" />
        <path d="M92.8,331.7c.2.2-.9,1.3-1.5,1-.2-.2.9-1.3,1.5-1Z" fill="#010bb3" />
        <path d="M93.8,332.7c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#010bb3" />
        <path
          d="M85.8,312.3c2.7,1.6.2-1.3,2.3-2-.6,2.8,3.1-1.2,3.2-1l.5,1.5c-4.4-1.4-.9,5.8-.5,5.5s.2-2.4,2.5-.2l-2-.2c-.1.7-.6,1.6-1,2.1s-1.9.2,0,1.9c-.6.5-1.1,0-2,0-1.2.6-1.7,1.3-1.5,2-.7.7-1.1,1.5-2.5,1.5h-1.5c-.3-1.1.7-1.1,1-1.5.7.3.9.2.5-.5.5-.8.9-1.7,1.5-2.5-2.5-1.2-2.6.5-2.7.5-1.7,0-1.2-2-1.4-3.1s-1.7-2.1.1-1.6.4.6,1,.5c.9-.2,2.2-1.9,2.5-2.8Z"
          fill="#010ebb"
        />
        <path d="M84.8,321.2c2.6-.2-.7,3.1-.5.5.1-.2.4-.3.5-.5Z" fill="#0212bc" />
        <path d="M88.8,319.8c.2.8-.8,1.4-1.5,2-2.1-.3-1-2.1,1.5-2Z" fill="#0107b0" />
        <path d="M84.8,316.7c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#0107b0" />
        <path
          d="M67.3,255.3c-1-.6-1.7-.6-2.1.2-1-1-2.1-1.5-3.3-1.7-.8-2.4-2-4.2-3.8-5.5,1-2.7,1.1-5.6.2-8.6l.8-.5c-.9-.8,0-3.7.7-2.5,3,0,5.9,2.7,4.1,5.6l1,.6c3.8,1.6,3.6,3.8.9,6.7,1.1-.4,1.8-.2,2.2.6h.5c1.4-.1,1.1,2-.5,1.5,0,1.2.5,2.1,1.7,2.6,2.2,2.6-1.4,2.2-2.2.9l1.2.7c2.5-.4,2.9,1,.7,2.3,2.9,1.5,3.8,2.9.6,5q-.8.9,0,0c2.3-1.7,3.1,2.8-.3,2.7,1.7,1.6,2.5,5.4-.7,3.8-.1,0-2.1,0-2.5,0-1.6-.5-3.1-.7-4.5-.5-.5-.5-1.8-.8-2.5-1-.3-2.3-.2-4.3.1-6s0-1.3.4-1.5c.2-.4.3-.4.5,0l.5-1c0-1,1.1-1.8,3.5-2.2-.5-2.2,1.6-4.2,3-2.3Z"
          fill="#0106b1"
        />
        <path
          d="M59.3,231.3c1.7-.7,3.5,1.6,3.7,3.3l2.3.2c-.3-.2-.3-.3,0-.5.2-1.3.6-1.2,1,0,1.5.5,1,1.7-.5,1.5l-.6,1.2c.8,1.9,1.3,5.6-.9,5.3-.1.4-.3.4-.5,0-.1-.6.2-1.6-.8-2s-.4,2.7-1.7,1.5-.3-1.4-.5-1.7c.7-1.3,3,.6,2.5-1.3-1.2.5-1.6-1-1.8-1-.3,0-.7.4-.9.4s-.4-1.5-1.7-.9l1.5,1.7c-.2,1.1-1.9,1.6-2,1.8-.2.3,1.2,1.1,1.4,1.8.4,1.4-.9,4.8-.8,5.4s1.6.6,1.9.8-.1,1.3.2,1.8,1.1.3,1.3.9-1.2.9.8,1.7c1.4-3.1,1.4,1.2,2,1.5s1.5-3,2.2.5c-3.2-.5-1.5,3.1-2,3.5s-1.1-.1-1.6,0-.4,1-.7,1c-.9,0-1.1-1-2.2,0,.2.5.1,1-.5,1,0,0-.3,0-.5,0-2.5-1.8-.6-.9-.5-3.5h-1.5s.5-1,.5-1c-3.9.2.9-2.3,1.4-3.1s.2-2.4.2-2.6c0-.5-2.7-1.9-3.5-1.8.3-2,.4-.4,1.3-.6s.2-1.5.2-2.2c0-1.9.6-3.8,0-5.9s-1-.3-1-.3c-.9-1.3,1.2-.7,1.5-1.3,1-1.8,1-5.1,1-7.2Z"
          fill="#0102ab"
        />
        <path
          d="M61.8,269.3c-.4-1.6,1.6-.7,2-1.8.6-1.7-1.8-2.9,2-3.7-.4,1.5-.3,3-1.5,4.2l2,1.7c-1.5.2-2.3.7-3.3,1s-.2-.7-.3-.9-.7.4-.8.3c-.2-.2,0-.8,0-.9Z"
          fill="#0104a3"
        />
        <path d="M60.8,259.8c.6,1,.8,1.1-.5,1,0,0,0-.5.5-1Z" fill="#0104a3" />
        <path d="M65.8,246.3v1c-.7.2-1-.2-1.5-.7l1.5-.2Z" fill="#0107ba" />
        <path
          d="M69.3,206.3c.9-2.1,1.4-4.3,1.5-6.5-3.2-.7-2.4-5.1.4-3,1.7-.4,2.8,0,3.1,1,1.6.1.5.5.6.2.4-1.7,2.9.1,1.4,2.1,1.6.4,1.5,1.5-.4,3.4l.4.8c-.7.7-1.1,1.8-1.1,3.4-3.2-1.6-2.4-.1.3.3l.4,1.3c.2,0,1.4.6,1.4.7-.4,1.5-2.4,2.5-1.9.3-1,.1-2.4,1.3-1.1,1.9,0,2.1-1,6.1-3.4,4.6-.2-.9-2.4-2.6-2.5-2.5l.5-2c-.9-.7-3.5,3-4-1.5.3,0,.5-1.1.7-1,.4.1,2.6,2.4,3.3.7s-1.3-.4-1.8-.7-.6-1-.7-1c-1.3-.2-1.3-.6,0-1,1.1-.6,2.1-1.1,3-1.5Z"
          fill="#0105bb"
        />
        <path
          d="M64.8,210.8c.8.2,1.2.6,1.4,1.3,2.8-1.7,5.3.8,2.1,2.2,1.9,2.1-.8,2.3-2.4,1l-.9.6c2.9,1.4,1,3.4-.9,4.8,1.1,1,.5,2.3-1,2.4,1.3,3.2,1.4,4.4-2.1,5.2.3,1.7-1.1,2.9-1.8,1.1,0-2.7-.2-6.9,1.1-9.6s1.7-.5,1.4-1.8c-.1-.2-.3-.2-.5,0-1.2-.4-.7-1-.5-2-1.9.3-1.6-.3-1.5-2,.3,0,.7,0,1,0,.5-1.1-.9-1.1-1-1.5.1-.4.3-.4.5,0,.5-.4.5-.9.5-1.5.2-1.6,4-1.3,4.5,0Z"
          fill="#0104ad"
        />
        <path d="M61.8,217.8h-.5l.3-.4c.3,0,.2.2.2.4Z" fill="#0104b4" />
        <path d="M59.8,212.3l.5-1.5c0,0,.8,1.3-.5,1.5Z" fill="#1c28bc" />
        <path d="M61.6,214.3c.3.2.3.3,0,.5v-.5Z" fill="#0104b4" />
        <path d="M65.3,234.8c-1-.3-1.1-1-1-2h1c0,.5,0,1,0,1.5s0,.4,0,.5Z" fill="#0107ba" />
        <path
          d="M233.2,65.9c1.4-.3,2.7-.3,4,0-1.2.5-2.7.9-4.5,1-1,.6-2,1-3.2,1.2-11.8,1.7-23.5,3.5-35,6.5l-1.8-.2c-.4.3-.7.5-1,0-.7-.1-.5-.5.5-1,1-.3,1.8-.8,2.5-1,11.5-3.1,23.1-5.3,35-6.5,1.1-.1,2.4,0,3.5,0Z"
          fill="#2039d6"
        />
        <path
          d="M229.7,65.9c-5.6.6-13,2-18.6,3.1s-10.8,3.5-16.4,3.4c7.8-2.2,17.3-5,25.5-6,2.9-.3,6.5,0,9.5-.5Z"
          fill="#102bcc"
        />
        <path
          d="M180.3,77.4c.4.1.4.3,0,.5-.3,1-1.4,1.6-3.5,2-.6.5-1.4,1-2,.5-1.4.7-2.6.9-3.5.5l-.9-.3c.9-.4-1.1.9-1.6-.2-.7-.4-.4-.7,1-1,1.7-.4,2.9-1,4.5-1.5-.6,1.1-.9,1.2.6.8s3.8-.8,5.4-1.3Z"
          fill="#0e25cf"
        />
        <path
          d="M192.3,73.4l-.5,1c-.1.4-.3.4-.5,0l-.5.5c-.3.5-.7.6-1,0l-1,.5c-2.5,1.1-5.9,2.3-8.5,2.5v-.5c4.1-1.3,7.4-2.7,12-4Z"
          fill="#152dcd"
        />
        <path
          d="M243.2,65.4v.5c-1.9.6-3.9.6-6,0-1.3,0-2.7,0-4,0,3-.9,6.8-.5,10-.5Z"
          fill="#102bcc"
        />
        <path
          d="M169.8,79.4l-1,1c0,.5-.3.9-.8,1.1-5.5,2.5-10.9,4.9-16.2,7.6-1.3,1.1-3.4,2.7-5,1.8l-6.6,3.6c-.6.3-1.1,0-1.4-.6,2.8-1.8,6.8-3.3,10-5s3.7-1.6,4.2-2,.3-1.4,1.1-2c1.8-1.2,6.1-1.5,8.2-2.5l2-1.5c.1-.2.3-.3.5-.5.7-.8,2.6-1.7,3.5-1,.2,0,.3,0,.5,0,.3,0,.7,0,1,0Z"
          fill="#5573e6"
        />
        <path
          d="M146.8,90.9c.3,1.8-4.8,5.2-6.5,4.5-3.2,2.3-6.6,4.3-10,6-1,1-1.8,1.3-2.5,1l.5-1c3.1-1.8,7.2-5.4,10.5-7.5,2.9-.3,5.4-1.7,8-3Z"
          fill="#4e6ae3"
        />
        <path d="M164.8,80.4s-.7-.4,0-.7c1-.5,4.3-2,3.5-.3-.9.2-2.5.8-3.5,1Z" fill="#5b77e6" />
        <path d="M162.3,82.4l2-1.5c-.8.9-.9,1-2,1.5Z" fill="#5b77e6" />
        <path
          d="M402.6,165.3c.4-.2,2.1-3,1,1,.8,0,1.2-.4,2-.5.8-1.5,3.2.4,1.5,1q-1.2,1.3,0,0l.6-.4c.9,1,1.8,1.6,2.9,1.9h.5c-.3.4-.4,1.4-.5,1.5-.4.2-1.2-.3-1.7-.2s-.9.8-1.4.7-1.1-1.2-1.3-.9.1.9,0,1c-1.4,1.1-2,1.6-1.3,3.5,0,1.8-.2,1.8-1.7,1,0,1-4.1.2-3.5-1-1.4-1.6-.5-2.7,1.5-3.3-1.6-.8-2.2-1.9-1.5-3.2-1-.8-.9-1.2.5-1,.2-.3.5-.7,1-1,.2,0,.4,0,.5,0,.7.6,1.1.6,1,0Z"
          fill="#0223e3"
        />
        <path
          d="M406.1,170.3c-.2.3-.3.8-.5,1,0,1.2.3,2.1,1.1,2.7-.2,2.9-.1,3,.4.3h2.5c0,1,0,2,0,3,0,1.8.5,1.3.5,1.5v.5c0,1.3-.6,1.3-1,0l-.5.7c1.3,4.7-3.2,2.6-4-.2l-.9,1c.7,1.2,1.1,3-.1,4-1,.5-2.1.8-3.4,1.1-2,2.4-3.3-4-1-4.1s2.2,1.6,2.2,1.7c-.2.3-3.2-4.4-.2-4.7-1.1-.5-1.6-1.1-1.6-2-.4-.1-.4-.3,0-.5-.8-1.9.9-1.9,2.6-1.1l.9-.4c3.1-.4.3-3.2.5-3.5s2.4-.9,2.5-1Z"
          fill="#0228e8"
        />
        <path
          d="M407.1,174.3c0,.1.3,1.7-.5,2.5l-.5-2.5-1,1c.4-1.1-.4-2.5-.4-3.3s.7-.5.9-.7l1.3,1.5c1.1.3.7-.9,1-1.5s1.2-.1,1.3.3c.2.8-1.6,1.7-2,2.7Z"
          fill="#0223e3"
        />
        <path d="M415.6,171.3c0,0-.8,1.1-1,0h1Z" fill="#0114ce" />
        <path
          d="M401.1,152.8c.4,0,1.6-.8,2-.5,1.3,1.2-2.2.6-1.5,2-.1-.1-.8-.1-1-.5-.5-.7-.3-1.1.5-1Z"
          fill="#020fc7"
        />
        <path d="M404.6,159.8c.9-2.4,2.6,1.5.5,0-.2,0-.4,0-.5,0Z" fill="#0114ce" />
        <path
          d="M405.6,165.8c0-2.8,2.9,0,3.3.7s.1,1.2.2,1.3c0,.1,3-1.5,1.5.5-.9.7-2.7-.8-3.5-1.5,0,0,0,1.1,0,1.5-4.2-.9-.7-2.2,0-1.5-.2-.1.7-1.3-1.5-1Z"
          fill="#0116d8"
        />
        <path
          d="M399.6,164.8c0,.2,0,.4,0,.5l.5.5c.3,0,.7-.5,1-.5-.1.6-.8.7-1,1-1.1,1.6-3.3-.9-1.5-2h.5c.2-.1.4,0,.5.5Z"
          fill="#0232ec"
        />
        <path d="M402.6,165.3c1.5,2.1-.8,2.1-1,0,.3,0,.8,0,1,0Z" fill="#0232ec" />
        <path d="M399.6,164.8l-.5-.5v-.5c.5.2.4.6.5,1Z" fill="#022be7" />
        <path d="M400.1,165.8c-.6,0-.4-.2-.5-.5l.5.5Z" fill="#0125e1" />
        <path
          d="M394.1,145.8c.6-.4,1.4-.6,2-1l1.5,1-1.5,2,3,1c-.1,0-.3.4-.5.5-1-.1-2,.2-3,1-2,1.2-3.3,1.3-4,.5,0-1.1,0-2.7-1.5-2.8-.5-2.2.8-3,4-2.2Z"
          fill="#022ae3"
        />
        <path
          d="M395.6,150.3c.9-1.3-.2-2.6,2.1-2s.6.7.9,1,.3.3.5.5c-.2,0-.9.4-1.5.5-.3.8-2,1.2-2.5.5-.1-.5,0-.6.5-.5Z"
          fill="#0222dd"
        />
        <path
          d="M401.1,149.8c.8.3,1.6,1.1,2.5,1.3.2,1.5-1.9.3-2.5.8s0,.8,0,1c-.3,0-1,0-1-.5,0-.1,0-.4,0-.5-.7-.5.4-1.6,1-2Z"
          fill="#0220dd"
        />
        <path
          d="M401.1,149.8c0,.8-.8,1.4-1,2-.6,0-.7-.2-1-.5-.3-.1-.3-.3,0-.5.1,0,.4,0,.5,0l.5-1c.3,0,.1-.3,1,0Z"
          fill="#0114ce"
        />
        <path d="M400.1,149.8c0,.6,0,.7-.5,1v-1c.5,0,.3,0,.5,0Z" fill="#0222dd" />
        <path d="M405.1,155.3c-.2.3-.7-.5-.5-1s.9.6.5,1Z" fill="#0114ce" />
        <path
          d="M263.7,66.4c6.2.1,12.5,1.2,18.5,2.5-5.3-.8-10.7-1.3-16-1.5l10,2c-.3.2-.6.2-1,0-3.7,1.3-8.9.3-12.5-1-5.2-1-5-3.1,1-2Z"
          fill="#949edf"
        />
        <path
          d="M263.7,66.4c-1.5,0-3,0-4.5,0l3.5,2c-.8.7-2.1.7-4,0-.8.5-2.8-.6-3-1.5-.9-.2-1.3-.4-.5-1,.2,0,.3,0,.5,0,2.5,0,5.8-.4,8,.5Z"
          fill="#828ee0"
        />
        <path d="M299.2,72.4l-1.5-.5c.8.1,1.4.5,1.5.5Z" fill="#2540d6" />
        <path
          d="M243.2,65.9c1.7,0,3.3,0,5,0v.5c-.8-.3-1.6.5-2,.5-.5.7-1.2.9-1.5,0-1.4,1.1-2.4,1.1-3,0l-8.2.8c-.4,0-.7-.4-.8-.8l4.5-1c2,0,4,0,6,0Z"
          fill="#7daced"
        />
        <path
          d="M255.2,65.9l.5,1c-.4-.1-1.1.1-1.5,0-.8-.2-1.4-.8-2.5-.5v-.5c1.2,0,2.3,0,3.5,0Z"
          fill="#71aef5"
        />
        <path
          d="M305.2,76.9c8.7,2.5,17.5,5.2,25.8,8.9,2.3,1,5.2,2.5,7.1,4.1-1.2.4-3.6-.6-4.5-1.5-12.9-4.8-26-9-39.2-12.8l-.3-.7c0,.3-.1.5-.2.5-2.7.1-9.7-.3-12-1s-.8-.3-1-.8c-1.1-.1-1.7-.5-1.7-1.2-1-.8-.7-1.1,1-1,.6-.4,1.2-.6,1.9-.5,7.7,1.4,15.9,3,23,6Z"
          fill="#778ae7"
        />
        <path
          d="M333.7,88.4c1.4.4,3.1.9,4.5,1.5,5.5,2.5,11.1,7.5,16.5,10,.7.2,1,.6,1,1,1.3.3,2.5,1,3.5,2,.1,0,.4,0,.5,0,.4.4.6,1.2,1,1.5-7.5-2.7-14.6-7-21.3-11.3l-.7-1.2c-2.4-1.1-4.8-2.2-7.2-3.3l.2-.7c.6,0,1.3.1,2,.5Z"
          fill="#6581e6"
        />
        <path
          d="M276.2,69.4c.2,0,.3,0,.5,0,1.5-.4,3.1,0,4.5.5,8.2,1.2,16.1,3.7,24,6v1c-9.1-2.7-16.1-3.5-25-5.5-1.5.5-5.2,0-5-2,.3,0,.7,0,1,0Z"
          fill="#8491e6"
        />
        <path
          d="M356.7,100.9c.2,0,.3,0,.5,0l2,2c-1.1-.7-2.5-1.2-3.5-2,.2-.5.5-.3,1,0Z"
          fill="#718ced"
        />
        <path d="M356.7,100.9c-.3,0-.7,0-1,0-.4-.3-.7-.7-1-1,.6.3,1.6.1,2,1Z" fill="#7b92ec" />
        <path d="M281.2,69.9c-1.3-.2-3-.3-4.5-.5.9-1,3.4-.1,4.5.5Z" fill="#949edf" />
        <path
          d="M337.7,94.9c-.3-1.5,0-2.1,1.1-1.8,7.3,4.2,14.8,8.3,22.3,12.3v.6c-.2-.1-1,.2-1.5,0-2.1-1-4-2.6-6.9-3-.6,1.2-.9,1.2-1.5,0-2.7-1-5.5-1.7-8.5-2.3l-.5-1.2c-1.3-1.4-2.8-2.7-4.5-3.8v-.7Z"
          fill="#4973e7"
        />
        <path
          d="M351.2,102.9c.4,0,1.1,0,1.5,0,1,1.3,2.7,1.7,4,2.5-1.5.8-.7.7-.5,1.5,0,.5.2.6.5.5.2,0,.3,0,.5,0l1.5.5c0,0,0,.7,0,1,.7,1.1-4-.3-4.2-.4s.1-.3.3-.5c-1.1-.5-2.1-1-3.1-1.5-1,.2-1.7-.6-2-2.5-.1,1.2-1.2.6-1-.5.2-1.1,1-1.3,2.5-.5Z"
          fill="#2b68ea"
        />
        <path
          d="M315.2,83.4c-.3.3-.5.6-.5,1,.8-1.4,2.2-1.3,4,.1l8.3,2.8c1.1,1.2,2.6,1.6,4.7,1.4l7.1,3.3c4.4,3,9,5.5,13.6,8.1s5.6,3,8.3,4.4c1.2,1.1,6.2,4.7,7.5,5.5v.5c-2.3-1.4-4.5-3.3-7-4.5l-22.7-12c-.3-.1-.6,1.1-.7,1-1.2-.3-1.9-1-2-2-.1.4-.3.4-.5,0-1.9,0-5.5-1-7.4-1.7-2.6-.5-4.5-1.5-5.7-3-2.2-.3-4.2-.9-5.9-1.6-1.2.8-2.3,0-3.4-2.2-1.2.5-2.6-1.2-.5-1,.2-.4.3-.4.5,0,.4.3.8.3,1,0-.7-1.2,1.8-1,1.5,0Z"
          fill="#5578e5"
        />
        <path d="M359.1,107.4h.5l-.3.5c-.3,0-.2-.4-.2-.5Z" fill="#2b68ea" />
        <path
          d="M366.1,113.9c1.3.4,2.5,1.1,3.5,2.1,1.9,0,2.1,1.5.5,1.9,1.4.4,1.3,1.4,0,2-.1.4-.3.4-.5,0l-1-.5c-1.3.8-2.6-.5-3.5-2,0,2.2-.6,3.3-1.8,3.3,0-.1-.9-2.6-.7-2.8-.6-.4-.7-.9-.7-1.6-1.6-1-.9-1.4.7-1.9.6-.7,2.2-.9,3-.5.2,0,.4,0,.5,0Z"
          fill="#0855e6"
        />
        <path
          d="M371.6,115.9c.9.4,3.4,1.8,3.9,1.9,1.2.4,2.8.5,4.1.6.3,1,0,.9,0,1,.2,1.4-2.1,3.3-2.8,1.7-2.6.1-5.3-1.2-5.2-4.2-1.3-.2-1.3-.6,0-1Z"
          fill="#1d58e2"
        />
        <path
          d="M366.1,113.9c3-1,1.5.1,2.5.7s2.1.8,3,1.3c0,.3,0,.9,0,1,1.8,1.3-.8,3.3-1.5,1,0-.3.7-.9.5-1-.9-.4-1.5,1-1.7,1-.9,0-.3-1.8-.5-2-.5-.7-2.5-.3-2.3-2Z"
          fill="#1959e3"
        />
        <path d="M358.6,107.9c0,0-1.4-.5-1.5-.5h1.2c0,0,.3.5.3.5Z" fill="#1a62e8" />
        <path d="M356.7,107.4c0,0-.1,1-.8,0s.3-.5.3-.5l.5.5Z" fill="#1a62e8" />
        <path
          d="M371.6,116.9c0,0,.7-.2.9.1s.4,2.2,1.1,2.9c.8.2.3-.7.6-.9,1.4-1,1.7.6,1.4,1.9l1.2-1.5c.7,3.5,1,0,2.7,0,.7,1.7,1.5,2.8,3.5,2.5l-.5,1.5c-.3,0-1,.6-1.5.5-.1-3.3-1-1-1.8.5l-.2-1.8-2,.8c-.9,0-1.8-.5-2.5-1.5l-.7-.8c-.9.7-3.3,0-3.8-1.2,0-.6,0-1.4,0-2,1.2,0,1.7.3,1.5-1Z"
          fill="#114ee1"
        />
        <path
          d="M401.6,199.8l-.7-.9c.7-.4.9-1.1.4-1.9,1.4-1.5.9-2.6-1.5-3.3,1.7-.9,2.1-1.9,1.2-2.9,0-1.4,3.4-1.5,3,.7-.3,1.3.1,4.2,1.3,4.6h1.6c.1-.3,0-.5-.5-.4-.6.7-2,.6-1.5-.5-.2-1.1.7-1.9,1.7-1.4-.7-2.9,5.2-5,4.3-2.1l1,2c0,1.3-.7,1.2-.2.5s1.5,2-1.3,1.5c.9.7,1.6,1.4,2,2,1.1.8.8,1.4-.5,1.5.4.2.4.3,0,.5-.5.8-2.6.5-3.5,0-3.1-1.2-3.6-1.2-2.5,2.7-1,1.1-3.4,3.2-3,.8l-.5-.5c-.3-.9-.6-1.9-1-3Z"
          fill="#0226e7"
        />
        <path
          d="M413.1,189.3c1,.7.6.6,1,1.5s.5,1.3.5,2c-1.6-2.3-1.4-.8-3.5-1s-.2-.8-1-.5l.3,1.5-1.7-1.5v2s-1.5-1-1.5-1c1,1.3-.6,2.6-2,3-2-1.4-2.1-2.4-.5-3,1.1-1.6,2.6-2.7,4.6-3.2.3-3,3.3-1.9,3.9.2Z"
          fill="#011ee2"
        />
        <path
          d="M412.1,193.8c.8-.2,2-.6,2.6.3s.2,2.5-1.1,1.9c.3.7.7,1.5,1,2.2,0,.9.4,1.6,1.5,2,0,.1,0,.3,0,.5-1.2,1.8-2.5,1.3-4-1.5,0-.7.3-1,.5-1.5-.8-.7-1.5-1.4-2-2,.2-.2.8-.4.9-.6.3-1-1.5-.9.6-1.4Z"
          fill="#0120e2"
        />
        <path
          d="M412.1,199.3c2.2-.7,1.8,3.1,4,1.5,0,1.5-1.2.8-1,1.2.8.9,1.7,1.6,3,1.8.5.1.5.3,0,.5l-.5.5c-.2,1-2.6,0-2-1-2.2,1.7-2.6,1.8-4.5-.5-.6.7-1,.4-.5-.5l.8-3.2c.5.9.8,1,.7.2,0-.2,0-.3,0-.5Z"
          fill="#0227e6"
        />
        <path
          d="M417.1,205.8c-.3.5-2.1.3-2-.5-2.2.5-1.4-2.2.5-1.5.6.3,1.2,1.1,2,1l.5-.5c0,0,0-.4,0-.5-.1-.4-1.6-.6-1-2,2.4.7,2.5,2.4,1,4.3-.4.4-.7-.2-1-.3Z"
          fill="#0112d5"
        />
        <path
          d="M415.1,205.3c.3,0,1.6.4,2,.5.3.5.4,1,.5,1.5-.4,0-1.4-1.4-2-1s-.2,1.9-1.5,1.5c0-.5-.2-1.1-.5-1.5-.8-1-.8-1.6.4-1.2,0-1.1.5-.8,1.1.2Z"
          fill="#032eeb"
        />
        <path d="M419.6,197.8c1.6-.3.6,1.2.5,2.5h-1.5c0,0,.5-1,.5-1.5l.5-.5v-.5Z" fill="#0209c0" />
        <path d="M414.6,198.3c.4.7,1.5,1.9,1.5,2-1.6-.4-2.7-.3-1.5-2Z" fill="#0227e6" />
        <path
          d="M406.1,184.8c1.7,1,3.2,1.1,5.1.9l.4,1.1c1.6.2,5,.2,2,1,0,0-.4,0-.5,0-.2.3-.2.6,0,1v.5c-.3-.2-2.9-1.6-3-1.5,1.4,3.9-5.5,1.5-3.5,6l-2-1.5c-.9-2.3-1.9-2.8-2.9-1.4-1.6.3.2-4.6.9-5.1-.4-.6.4-.8,1-.5.3-.3.8-.3,1.5,0-.3-1.3,0-1.4,1-.5Z"
          fill="#0229e7"
        />
        <path
          d="M410.1,178.8c.7,1.9,2,.5,2.8.6s.8.7,1.7,1.1c1.4.7-1.3.6,0,2.3-1.4-1.7-3.1-.8-1.5.3s2.6-.7,3,.5-3.4.3-1.5,2.7c-1.4.6-2-3.6-3-2.5s.7,2.3,0,3c-.8,0-1.7-.2-2.7-.5-.8.5-.3.8-.3,1.3,0,1.2-4.3-1.6-.4-1l-2-1.8.8-.9c.9,1.2,2.8,1.8,3.2-.1-.5,0-.4-.2,0-.5-.6-.8-.8-3.3,0-4,0-.2,0-.3,0-.5Z"
          fill="#0120e3"
        />
        <path d="M417.6,185.8c-.1.3-.4.7-.5,1l-1-.2c.4-.5.8-.8,1.5-.8Z" fill="#0112cf" />
        <path
          d="M382.1,131.3c-.5-2,2.5-1,2.5.1s-.7,1.6-.4,1.2.2-.2.4-.3h.5c1.9-1,1.1,1,.5,2.3s.3-1.9,1-1.3h.5c0,.3,0,.7,0,1,.7,0,.7.7.1,1.8.8-.6,1.2,3.7-.6,2.2-.6,1.1-1.5-1.6-1.3-1.6s.8,1.7.7,1.9c-.2.6-2.5,2.3-3.2,1.9-2.1-1-1.1-3,.3-4.2-.3-.4-.6-.6-1,0,1.3,2.6-4.7,3.2-3.5.5.8-.3,1.7-.8,2.5-1.5-.7,0-.6-.6,0-1,0-.4.2-.7.5-1,.3-.3.5-1,.5-2Z"
          fill="#023fe7"
        />
        <path
          d="M385.1,132.3c.9-4.2,3.1.6,3.7-2l1.8,1c0,1-1.4.3-2.1.5s-1.8,1.4-1.9,1.5c-.3.3-.6,2.5-1.5,1.5s.4-1.2.4-1.7-.4-.7-.4-.7Z"
          fill="#0339e0"
        />
        <path
          d="M388.6,138.8c1.7,1.2-.5,2.8-.5,3.7s.8.2.9.4-.4.8-.3.9c.1.1,2.6,1,3.1,1.2,1.1.4,1.5-.6,2.4.8-1.8,1.2-.1,1.6-.5,2-.9,1-1.3-2.2-2.5-1.5-.6,3.1,1.5,1.6,3,3.2l-2.5,1.2c-1.7.9-2.4-1.2-1.2-2.2l-.8.2c-1.3.6-1.6.3-1-1-.4-.9-1-1.6-2-2-1.9,0-2.2-1.8,0-1.8s-1.5,1.2-1-.7c-.1-.5,0-.6.5-.5,0-1.2,0-2,.5-2.5.3-.8.6-1.4,1.5-1.5h.5Z"
          fill="#0239ea"
        />
        <path
          d="M387.1,134.3c3-.2.7,1,.7,1.8s.4,1.4.3,2.7-.4,1.2,0,2l-1.5-.5c-2.1.8-2.4-1.7,0-2,.4-.5,1.6-.5.9-1.4s-.8,0-.9-.4c-.2-.6.4-1.6.5-2.2Z"
          fill="#022cde"
        />
        <path
          d="M374.6,121.9c.5,0,1.8-.7,2-.5s0,1.1.5,2,1.9,2.1,2.5,3c.5,1-.6,2.5-1.5,3-.3,3.2-3,1.7-3.6-1-1.2.6-4.6,0-3.8-1.4-.6-.5-1.3-1.2-1-2.1.2-1.7,4.2-5,5-3Z"
          fill="#034ae6"
        />
        <path d="M385.1,129.8l-.5-.5c.6,0,.5.5.5.5Z" fill="#0c3ddb" />
        <path d="M420.1,280.8c.6.6.6.9,0,1-.4.7-1.3.1-1.5-.5-.9-1.4.5-1.9,1.5-.5Z" fill="#0117d3" />
        <path
          d="M422.6,261.3c.6-1.1,3.4,3,3.4,3.3-.7.4-.5,1.3.6,2.7.5.6.6,1.2.3,1.8,1,.4,1.4.9,1.2,1.7.5,1.5.3,3-1.5,3.5,1,.3,1.2.7.5,1,.7.7,2.5,2.9,1,3h-.5c0,1.4-1.5,1.8-1.5.5-.7.2-1.3.8-.5,1,.2-.3.3-.3.5,0l.7.9-3,4.5c-1.1,2.2-2.3,5.1.9,5.4l.4,1.2c.4.1.4.3,0,.5l-.2,1.2c-2.1.2-2.4,1.4-.8,3.8.3,2-1.1.3-1.5.5-.5.3,0,2.2-2.5,1-.5-.2-.7-.7-.5-1.5-.5,0-1-.2-1.5-.5-.4-.1-.4-.8,0-1,.4-.4.4-.8,0-1-.4.1-.7.4-1,1-.1.4-.3.4-.5,0-2-1.6-2.8-3,.5-3.6l.5.6q.7.6,0,0c-.9-.5-1.3-.7-1.9-1.5-1.2-1.5-2.2-2.9-.4-4.9l-.6-1.4c0-.4,2.7-5.9,3.9-3.7.4.7.9.9,1.5.5.2-.3.2-.7,0-1-1.5,0-1.6-.3-1.9-1.7s-.5-2.1-.8-3c.6-1.2.9-2.1.7-2.8-.4-.1-.4-.3,0-.5l.5-.5c-.5-.2-.5-.3,0-.5-1.2-.8-.8-1.9.5-2.3-1.1-.5-1.2-1.4,0-1.7-.6-.3-.6-1.1,0-1.5-1.3-.2-1.3-.5,0-1,.2-1,.7-1.1,1.5-.5v-.5c-.4-.1-.4-.3,0-.5.5-1.7,1.1-2.6,2-2.5Z"
          fill="#0117d3"
        />
        <path
          d="M426.6,280.3l.5.5c.1,0,.4,0,.5,0,1.6,1.6-1.8,2.1-1,3s1.8-1,2,.5c-1.8,1.1-4.5.9-4.5,4,0,0,1.6-.9,1.7-1,.7-.8-.1-1.7,1.1-1.5,2.9.5.4,1.9-1.2,2.2l3,.3c0,.9-1.6.1-1,1.7s1.5.3,2,.3c-.3.9-.4,3.4-1.5,2.5s.1-.8,0-1c-.5-.8-1-.3-1.5-.5-.6.2-1.1.4-1.5.5-1.9-.4-2.7-1.5-4.5,0v-2s2-.5,2-.5c-.7.2-3.3-.9-3-1.5l1.2-1,1.2,1c-.2-3.4,2.9-5.1,4-8,.1-.4.3-.4.5,0,0,0,0,.4,0,.5Z"
          fill="#0112cb"
        />
        <path
          d="M427.6,278.3c.4,1.9-.7,1.3-1,1.5h-.5c-.2,0-.4,0-.5,0-.6-.3-.1-1.2.5-1,.3.1.7.6,1,.5s.2-.8.5-1Z"
          fill="#010dc4"
        />
        <path d="M427.1,280.8c-.2-.2-.4,0-.5-.5l.5.5Z" fill="#010dc4" />
        <path
          d="M428.1,270.8c.3.1,1,0,1.5,0-1.8,1.1.4,2.5,0,3s-2.5,1-3,.5c0,0-.5,0-.5-.3,1.5-.5.8-2.2,2-3.2Z"
          fill="#010dc4"
        />
        <path
          d="M425.6,279.8c-2,.8-3.2,2.3-2.5-1.5,1.4-.5.9.9,1,1,1.1.7.9-1,1.2-1,.8,0,.6.5.7.5l-.5,1Z"
          fill="#0112cb"
        />
        <path
          d="M418.1,294.8c1,0,.9.7,0,1v1c-.1.4-.3.4-.5,0,0-.4.2-1-.5-1v-1.5c.5-.2.9.5,1,.5Z"
          fill="#021ddc"
        />
        <path d="M419.1,266.3c.2.6.5.9,0,1.5-.2-.2-.7-.3-1-.5-.1-1.1,0-1.1,1-1Z" fill="#0221e2" />
        <path d="M418.1,295.8v-1c.1,0,.5-.4.7-.4,1.2.2.5,1.5-.7,1.4Z" fill="#0110c8" />
        <path d="M426.1,272.3c.1,0-.7,1-.5,1.5l-1.5-1v-.5c.5,0,1.8-.2,2,0Z" fill="#010cc0" />
        <path d="M418.6,272.3c0,0,.6,0,.5.5h-1c0,0-.6,0-.5-.5h1Z" fill="#021ddc" />
        <path d="M422.1,267.8c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#0117d3" />
        <path d="M420.1,280.8c.1.2,1.3.7,1,1s-.9-.1-1,0c0-.3,0-.9,0-1Z" fill="#021ddc" />
        <path d="M417.6,292.8c1.1,0,2.1,0,2,1.5-1.4-1.2-2,.1-2-1.5Z" fill="#021ddc" />
        <path d="M420.1,281.8c0,0,.2.8-.2,1-.5-.4-2-.7-1.3-1.5s1.3.7,1.5.5Z" fill="#021ddc" />
        <path
          d="M412.6,302.3c.4.1,1,0,1.5,0-1.5,1.4-.1,1.6-.2,2.5s-.7,1.2-.8,1.4c-.1.4-.3.4-.5,0,1.4-1.9-1.6-1.1,0-4Z"
          fill="#021ddc"
        />
        <path
          d="M419.1,267.8c.2.2-.4,1.5.5.8l2.2-3.7c1.9,1.3,1,2.6.7,4.5l-2-.5c-.2.9.8.3,1,.5s-1.1,2.3-1.5,2c.1-1.9-1.4-1-1.5.5-1.4,0-1.7,2.3-.5,1.5,2.3,1.2,2.7.7,5,0-1.1,1.8-3.4,2.6-5,1v2.5s3-1,3-1c.3,1.7-1.3,1-1.4,1.1-1.1,1.2-.5,2.8.4,3.9-.5-.5-1.2.4-1.5.5-2.3,1-1.2,1.1-2,2.6s-.8.2-1,.6c-.3,1,1.4.7,1.4.6.6-.5,0-2.3,1.6-1.9-.2,1.5.4,3-1.7,3s0-1.3-.8-1c.8,1.9-.9,2.6-.9,2.7s.2,2.4.9,2.2l2-2.5c.1,1.2-1.6,2.1-1.5,3.2s1,.4,1.3.8-.3.8-.3,1c-.8,0-2.4,1.4-1.9,2s1.8,0,.9,1c-1,.3-1.3.6-1,1,0,.1,0,.3,0,.5-.5.3-1,.7-1.5,1l.3.5c-.9.6-.5.3,1.2-1-.5-.1-.4-.3,0-.5.2,0,.3,0,.5,0,.3,0,.5.1.5.5-.1.3-.5,2.1-.5,2.2.2,1.4,2.3-.6,2,1-1.7,2.1-4.3-.8-5.5,1.3-.7-.2-.2-1.3-.8-1.5-1.3-.6,0,2.8-.5,3-1.4-3.2-.9-1.4-1.8-1.5-2.8-.4-2.2-1.4-.7-3.5l.8,2,1.5-1.2c.3-2.4-1-.4-1.5-.8l.5-5c-1.2.4-.9,2.5-1,3.5l-.5-1.2-2,.2c-1.7.5-4.7.8-4-2-.8-2.1.4-3.1,2.5-2.5-.5-.9.4-1.3,1-.5,1.5,1.5,2.3,1.4,2.2-.2.9-.2,1.5-.8,1.8-1.8l.7-1.2c-.9-1.8,0-2.5,1.2-3.4l-.4-2.9c-1.9.7-2-2.1-.8-3-.2-.9-.2-1.7,0-2.6-2.4-.8-3.1-1.6-2.2-3.9-.8-.8-.8-1.1,0-1-.3-.1-.3-.3,0-.5.5-.8,1.7.2,2,1,1.3-.6,1.8.5,1,1.5.8.8,1.3,1,1.5.5-.2-2.7,1.3-6.7,4.5-6.5.1-.4.3-.4.5,0,.4-.9,1-.5,1,.5Z"
          fill="#021ddc"
        />
        <path
          d="M418.6,271.8c0,.1,0,.4,0,.5-.6.2-.8.3-.5.5,0,.2,0,.3,0,.5,0,.5-.7,1.3-.5,2-.7.3-.5-2.1-1.5-1s.7,1.4.5,2c-1.2-.2-1.7-2.9-.9-3.4s.9,0,1.3-.2-.5-2.5,1.6-.9Z"
          fill="#022ae5"
        />
        <path
          d="M415.6,296.8c-.7,0-1.3-.8-2-.8-2,.2-1.4,1.9-3,1.8-.2-.2,1.4-6,3-4.2-.3.3-1.7,1.5-1.5,1.7,1,.9,1.7-1,1.7-1,1.2-.2,2.4,1.9,2.7,1.5,0,.5-.9.9-1,1Z"
          fill="#0226dd"
        />
        <path
          d="M402.6,294.3c.7,2.7,1.2.8,2.7,1,.2.8,1.2.9,1.3,1s-.1.9,0,1c-.9.4-1.5,1.1-2,2,.3.9.3,1-.5.5-.5.4-.7.1-.5-.5-.8-1.4-2-3.7-1-5Z"
          fill="#022de5"
        />
        <path
          d="M411.6,281.8c0,0,1.5.2,1.5.8s-.7.5-.7,1,.3,1,.3,1.4-2.2,2-1.5,2.8,1.3-2.1,2.5-1.5c-.2.7-1,.8-1,1.7s1.6,0,1,1.2l-1.5.5,3,.5c-1-.2-2.2.4-3.1.2s-.7-1.6-1.9-1.2c-.4-.3-.9-.5-1.5-.5-.4-.1-.4-.3,0-.5l-.7-.2c.1-1.3.2-2.5.2-3.8-.4-.7-.2-.9.5-.5.2-.2.2-.3,0-.5-.4-.1-.4-.3,0-.5-.3-.4,0-.7.5-.5,1.6-.5,1.5-.3.5,1,.6,0,1.1-.1,1.5-.5-.8-.8-.6-1.1.5-1Z"
          fill="#0227e3"
        />
        <path
          d="M408.6,272.3c.5.2.8.7,1.5.5l-1.5,2c2.4,0,4.1,1.4,6.5.5-.3,1.2-2.7.7-3.3,1.5s.4,2.3.2,2.5c-.3.4-2.6.4-.5,2.5,0,.4-.5.9-.5,1-.4.4-.9.5-1.5.5,0-.4,0-.9-.5-1-.6-1.5-1.1-2.9-1.4-4.3,1.3-.3,1.2-3.2,0-2.2-.1.1-.8.5-1,.5l-.5-.5c0-.1,0-.4,0-.5.1-.2,1.1-.4,1-1-1.7,0-2.3.5-2-1.5,2.5,1.4,2-.6,2.5-1s.7.4,1,.5Z"
          fill="#0225e2"
        />
        <path
          d="M410.1,289.3c0,1.5,1.5,1.4-1.5,2-.2.7,1.9.4,1,1.5s-3.3,0-2,3c-1.5.2-.8-.4-1-1.2s-.5-2.3-.5-3.2c.3-.5.6-1,.7-1.7,1.2-.1,2.3-.2,3.3-.3Z"
          fill="#0228e2"
        />
        <polygon fill="#0225e2" points="414.6 279.3 412.1 277.8 414.6 276.8 414.6 279.3" />
        <path d="M415.1,282.8c.6.5-1.5,1.7-1.2,2.5-1.3-.5,0-3.6,1.2-2.5Z" fill="#032ee3" />
        <path
          d="M415.6,297.8c0,.3.7.8.5,1l-2.5.5c-.2-.2.5-.6.5-1-.4-.6.8-.6,1.5-.5Z"
          fill="#0217d2"
        />
        <path
          d="M415.6,297.3c0,.2,0,.3,0,.5l-1.5.5c0-.3-.8-.7-.3-1,.6.8,1.4,0,1.8,0Z"
          fill="#0226dd"
        />
        <path d="M408.6,271.3h-.5c0-.3.2-.5.5-.5v.5Z" fill="#0225e2" />
        <path
          d="M408.1,245.3c.4-.5.9-.9,1,0-.3,1.1-.4,2.1-.5,3,.6-.7,1.1-.8,1.5-.5.9-.7,1.1-.4.5.5,1.4,1.1,2.2,2.3,1.5,4.4.3.3.6.6.6,1,.2.7-1.1,2.2-1.8,1.4-1,.6-1.8.7-2.4.2-.2.4-.3.4-.5,0q-.2-1.2,0,0c.8.4.8.8,0,1,0,.3-.7.9,0,2l-2.5-2,.5,2c-.5,0-1.1,0-1.5,0,.6,1,.9,1.8-.5,1.5-.5.2-1.4-.4-1-1-.4-1.4.5-1.1,1.5-.5-2.2.4-3.8-3-2-4l1-1c.2-.2.3-.2.5,0,.9-1.1,1-1.6.5-1.5-.9.6-1.2-.3-.5-1-.1-.7.4-.9,1-1,0-.5.1-.9.5-1,.3-.3.3-.7,0-1-.1.4-.3.4-.5,0l-.5-1.5c-1-.3-1.2-.8-.4-1.5,1.2.7,2.5.9,3.9.5Z"
          fill="#0225e5"
        />
        <path
          d="M410.6,248.3c1.9-2.5,5.3-3.3,3.5.5-.2.2-.4.6-.5,1,1,.5,1.9,1.1,1.6,2.3.9.6,1.5,1.5,1.9,2.7,1.1.2,1.4.5,1,1-1,.2-.7.4,1,.5.8-.1,1.6-.6,2.5-.5l-.5,2c-.2.4-.3.4-.5,0,.2,2.6-1.7,2.4-2.5.5-1.9-.9-2.3-1.1-3.4-2.9s0-1,0-1.1c-.2-.2-1.9.7-2.5.5.8.6,1.3,3.3-.5,2h-.6c-.5,3.5-2.5.6-2.4-1.5,1.7-.7,1.4-1.4,1.5-1.5.3-.2,1.3,1.3,1.5,1,1.4-1.8-2.6-1.7-3-2.8l3,.2c-.1-1.1-3-.6-2-2s1.2,1.8,2,.2c-1.5-1.1-1-1.1-1-2.2Z"
          fill="#021ddf"
        />
        <path
          d="M402.1,258.3l.5.5c0-.4.3-.4.5,0,.4.3.7.8,1,1,1.2.8,1.7.6,2,2.5-.2,0-.8,1.6-2,1v-.5c2.3-.1.4-.9,0-1.5-1,.5-1.3,0-1-1.5-.3.8-1.8.8-2,0-1.8-.6-.3-3.7,1-1.5Z"
          fill="#0118d7"
        />
        <path
          d="M411.6,256.8c.9-.5.7-1.1-.1-1.6,1.6-2.5,2.3-2.2,4.1-.2s1.9,2.3,2.5,3.3c1.3.7.9,1.5-.5,1.5-1.9-.1,1.5.8,2,.5,1.3-2.2,1.5.6,1,2,.8-.6.7,1,0,1.5,0,.2,0,.4,0,.5v.5c-.4.7-.7.5-1.5.5-1.4,1.3-2,.4-2-1.5-.7.8-1,.4-.5-.5-.3-.2-.1-.4.5-.5-.3-1-.9-.7-1.5,0-.5.8-.5,1.5,0,2,.4.1.4.3,0,.5-.4.4-.4.5,0,.5.6-1.2,2.2,0,2,1.5-.9.2.4,1.4-.3,1.5-1.4.2-.2-1.1-1.2-1l1,3c-2.6-3.6-2.4.3-3.2,2.4s-.7.4-.8.6c-.5.1-1,0-1.5-.5-.5-.7-.6-.7-1-1.5l-.6-.8c-3.1-.7-1.9-3.4-.6-5.6-2.2,1.1-3.5.8-3.9-.7-3-.2,1.6-2.5,3.1-1.4l2.5-1.1c.6-1.1,2-1.7,2-.4.4.1.4.3,0,.5q0,.2,0,0c1.7-1.3.7-2.7-.5-1.5-1,1.2-2.3,2-4,2.5-.9,0-1.7-.3-2.5-1-.7-.5-1.9-1.6-2-2.5,0-.6.2-1.1.5-1.5-.1-2.1,1-2.7,3.5-2l.7-.2c.6,2.5,1.4,3,2.8.7Z"
          fill="#0221e2"
        />
        <path
          d="M417.1,263.8c.2,0,.7,0,1,0-1.2,1.5.6.9,1,1.5s0,.7,0,1c0,.6-.4.8-1,1-.1,0-.4,0-.5,0-1.2-.6-1.8-.3-1.1-1.4-.1-.1-.7,0-.9,0-.4-.1-.4-.3,0-.5,0-.2,0-.3,0-.5.3-.5.8-.9,1.5-1Z"
          fill="#021ddf"
        />
        <path d="M420.6,264.8v-.5c0,.1,0,.4,0,.5Z" fill="#021ddf" />
        <path
          d="M411.6,273.3l.3-.5c.9-.3.7.4,1.2,1-.2.3.5,1.3-.7,1-.7-.3-.6-1.2-.8-1.5Z"
          fill="#0336e5"
        />
        <path
          d="M419.6,260.3c-1.1.6.6,2.9.5,3-3.1,0-1.4-.4-2-3l-3,.5c-.9-1.4,2.8-.8,1.5-2s-1.7,0-2-.8c1.7-1.1,2.8,1.7,3,1.8.4-1.1,1.8-.6,2,.5Z"
          fill="#021ddf"
        />
        <path
          d="M421.1,259.3c.3,1.2.6,2.1-.5,3,0,0-.4-.2-.5-.7s.5-1.2.5-1.3-.8,0-1,0c-.9-.3-1.6-.4-2-.5l.5-1.5c3.5,1.6,1.1.3,2.5-.5.9.3,1.5.9.5,1.5Z"
          fill="#021bd9"
        />
        <path
          d="M412.6,260.8c1.2-1.6,2.3,1,.5,1-.5-1.3-1.4,1.3-1.6,1.4s-2.8.1-2.9.1c.8-.5,2.5-2.4,3-2.7s1,.2,1,.2Z"
          fill="#022ae9"
        />
        <path
          d="M408.6,255.3c2,1-.8,1.9,2,2.5l-.2-2.5c.8.8,1.3,0,1.3,1.5s-.2,1.3-.5,2l2.5.5c-.9-.2-4.5-.1-4.8-.5s.3-1.9-.7-2.5c0-.3,0-.7,0-1,.2,0,.4,0,.5,0Z"
          fill="#022deb"
        />
        <path
          d="M415.6,262.8c.1-.5.3-.4.5,0,.4.1.4.3,0,.5.7.5.4,1.4-.5,1.5-.5,0-1.5.2-1.5-.3,0-1.4.5-1.6,1.5-1.7Z"
          fill="#022ae9"
        />
        <path
          d="M417.1,262.8c-.4.3-.7.4-1,0-.2,0-.3,0-.5,0l-.5-1.5c.5.5,1.8.1,2,.2,1.2.9,0,1.2,0,1.3Z"
          fill="#0214da"
        />
        <path
          d="M412.6,260.8c0,0-.2-.9.3-1,1.6-.5,2,1.5,1.1,2.4s-.7,0-.9,0c0,0,0-.4,0-.5,0-.3,1.5-1.2-.5-1Z"
          fill="#0214da"
        />
        <path
          d="M417.1,263.8c-.2,2.1-.7,1.1-1.5,1,0-.5.2-1,.5-1.5.1-.3.3-.3.5,0,.2.1.3.4.5.5Z"
          fill="#0214da"
        />
        <path d="M415.6,265.3v.5s0,.5-.2.5c-.6,0-1.3-1.4.2-1Z" fill="#0214da" />
        <path d="M413.1,262.3c.2.4.6.5,1,.5,0,1.2-2.1,0-1-.5Z" fill="#022ae9" />
        <path d="M417.1,262.8c-.1.2-.3.3-.5.5h-.5v-.5c.3,0,.7,0,1,0Z" fill="#021ddf" />
        <path d="M419.4,263.8c.3.2.3.3,0,.5v-.5Z" fill="#021ddf" />
        <path
          d="M425.6,263.3c-2.7-1.6-.2-2.4-.5-2.9s-1.6-1-2-1.1c-.2-.9.8-.3,1-.5s-.7-1.3-.5-1.5c.4-.3,5.3,1.1,2.5,1.7.5.6,1,1.2,1.5,1.8s1.6,1.9,1.5,2c-.8-.1-1.6.5-2.2.5s-1-2.8-1.3,0Z"
          fill="#0114d2"
        />
        <path
          d="M421.1,257.8c2.3.4,1,1.2,1,1.5h-1c-.1-.5-.5-1-.5-1.5,0,0,.4,0,.5,0Z"
          fill="#0209c2"
        />
        <path d="M418.1,255.8c.2,0,.7,0,1,0v.5c-1.8.3-3-.2-1-.5Z" fill="#010ecf" />
        <path
          d="M412.1,207.3c.7,0,2,1.7,3,1.8.1.3-3.8,1.4-2,2s2.1-1.3,2.2-1.3,1.2,1.1,1.3,1.3-1.9,1.1-1.5,2.7c-.6,0-1.7.1-2,.2s-.4.7-.5.8c-1.8,1.2-2.9.9-3.5-1-.6,1.4-1.9.9-2-.5-.4-.1-.4-.3,0-.5v-.9c-3.2-.2-3.9-2.7-1-3.1,1,0,2,0,3,0-.4-.2-.4-.3,0-.5,1.4-1.1,2.4-1.5,3-1Z"
          fill="#032ae9"
        />
        <path
          d="M411.1,203.3l2.8,1.5-.7-1.5c1.5-.6,1.1-.1,2.5.5-.9.7-1.3.4-.5,1.5-.9,0-1,0-1.5,1-.1-.2-.3-.4-.5-.5l-.5-.5c-.1,0-.3,0-.5,0-1.6-.7-1.9-1.4-1-2Z"
          fill="#0120e2"
        />
        <path
          d="M412.1,205.3c0,.2-.5.8-.5,1l.5.5v.5c-.6,0-1.9,1.3-3,1-.4-.1-.4-.3,0-.5-.2-1,.6-1.4,1.5-1.5l.5-.5c-.4-.1-.4-.3,0-.5,0-1,.4-.8,1,0Z"
          fill="#053df0"
        />
        <path d="M413.1,205.8l-.5-.5c.2.1.3.4.5.5Z" fill="#032eeb" />
        <path d="M412.1,206.8c-.3,0-.5-.2-.5-.5l.5.5Z" fill="#032ae9" />
        <path
          d="M422.6,204.3c.2.3,1.6,1.2,2,1.5-.5-3.1,1.8-2.3,4-2.5.5,1.3-1.4,1.4-1.5,1.5s1.5,1.6.5,2.5c-1.4,1.2-1-2.6-2-2.5,0,1,0,2,0,3l-.2.6c-1-.2-2.3.4-2.8.9,0,.2,0,.4,0,.5-1.8-1.3-.6,1-1.2,2s-1.7,1.1-1.7,1c.3-2,2.8-2,0-3.5l-.5,2c-.3-1.4-1.1-2.6-1.5-4,1,.1.8-1.5,1.7,2,.6-1.7,2.7-1.3,2.7-3.3s-2.7-.5.5-1.7Z"
          fill="#0112cf"
        />
        <path
          d="M422.6,209.3c-.6-2-.3-2.6.7-.5.6-.7,1.3-1.1,2.3-1,0,1,0,2,0,3-1,.1-.2-1.7-.5-2s-1.9.6-2.5.5Z"
          fill="#021cdb"
        />
        <path d="M424.9,206.8c.3.2.3.3,0,.5v-.5Z" fill="#021cdb" />
        <path
          d="M423.6,229.3c.6.2,1.9.4,2,.5.3.3-.5,2.1.5,2l1.5-3c.3,1,0,1.8.8,2.5l.2-1.5c1.1-.5,1,.8,1.5,1,2.9,3.8-2.2,1-3,4-1.8,1.2-5.4-.8-2.5-2l-.6-.7c-1.9.9-2.6.4-1.9-1.4-2.2-1.9,1.1-4.2,1.5-1.3Z"
          fill="#0119d8"
        />
        <path
          d="M424.6,232.8c0,.4-.7.9-.5,1.5l3,.5c0,.2,0,.3,0,.5-1.2,0-2.3.9-3.3,0s-1.4-4.3.8-2.6Z"
          fill="#0114d3"
        />
        <path d="M430.1,232.8h-2s0-1,0-1c.9-.1,1.7,0,2,1Z" fill="#010eca" />
        <path d="M425.1,216.8c0,0,.6-.7,1-.5.2.9-.8.3-1,.5Z" fill="#010eca" />
        <path
          d="M407.1,229.8c1.2-.6,3.3.2,2.9,2,1.9-2.2,3.1-2.6,3.6-1,.4.1.4.3,0,.5l-2.5,3.5c1.2-.5,1.7,1,1.8,1,.4,0,.6-.5.7-.5,0-.4.5-.6,1.5-.5.5-.3.8-1.1,1.3-1.5l-.3,1.5,2-.5c0,0,.6.1.5.4-1,.3-2.8,2.2-2,3.1-.2,0-.8,1.5-1.5,1.5,0-.5.1-1.1,0-1.5-2.3-.8-3.7-.8-5.5,1,0,.3,0,.7,0,1l.5.5c.6.5,1.2.5,1,1.5l-2-.5c-.7.6-1,.3-.5-.5-1.4.8-2.3-1.3-2.4-2.5l-.6-.5c-.5-1.3-.3-4.7,1.4-4.4.2-.8.2-1.7,0-2.6-1.3,0-1.2-.6,0-1Z"
          fill="#022de9"
        />
        <path
          d="M429.1,237.3c1-.6,3.4-1.4,3,.5l-1.5-.5c.2,1.7,2.1,1.9-.5,2.5-.3,1.3,1.5,1,1.3,2.8s-3.2,1.1-3.3,1.2c-.4.7.5,2.7,1.5,2.7l-1.5.7c.5.3,5.1.5,4.5,1.5s-1.3.1-1.5,1c-.2-.1-.9-.6-1-.5-.1,2,1,3.8,2,5.5-1.4-.2-2.6-.6-4,0l3,1c0,.5-.5.5-.5.5-.9,2-2.4,1.5-3.5,0,0-.1.5-.5.5-.8s-1.8-.7-1-2.7c-1.5.5-.5,2.8-1.8,3.5s-1.1-1.6-.7-2c-1.5,0-1.7,1.9-2.5,0l2-.5c.2-.9-.3-1.1-1-1.5-1.3-1-.9-1.6.5-2-.4,0-.4-.3,0-.5-.5-1.4,2-1.8,2.5-.5.7-.6,1-.3.5.5-.1.4-.1.7,0,1q.7.6,0,0c-.6-.5-.2-.7.5-.5l1-1c.2-.2-.9-1.6-1.5-1,.3.6.1.9-.5.5-.7.3-2.7-.9-3.4-1.4s-.4-1.8.4-2.1l1.1-1.7c-.2-1.8,1-4,1.9-1.8.2.4.3.4.5,0-.4-.1-.4-.3,0-.5-.3-.2-.2-.3,0-.5.2-.4.3-.4.5,0,.1-.1.9-1.3,1-1.3s-.5,1.3-1,.3c0,.5-.3.4-.5,0-.5-.4-1-.2-1.5,0,1.1,1.2-1,2.1-1.9,1.1-1.9-2,3.3-5.8,4.9-2.6.1-.6.8-1.3,1.5-1Z"
          fill="#0114d3"
        />
        <path
          d="M429.1,236.3c0,.2,0,.7,0,1-.7.4,0,1.1-1.5,1,0-.3,0-.8,0-1,.2-.7.8-1,1.5-1Z"
          fill="#010bc5"
        />
        <path
          d="M427.6,249.3c.5.4,1.3.9,1.5,1.5-.9.1-1.7,0-2.5-.5-.7.6-1,.3-.5-.5-.1-.1-.5-.5-.5-.5,0-.1,0-.4,0-.5,0-.3,0-.6.5-.5.4-.7,1.4.4,1.5,1Z"
          fill="#010cc3"
        />
        <path
          d="M426.1,249.8c.1.1.4.4.5.5-.2.1-.3.4-.5.5-1.2.6-2.1,1.4-2.5,0l2.5-1Z"
          fill="#011dde"
        />
        <path d="M426.1,250.8c.5-.5,1.6.4,1,1s-1.5-.5-1-1Z" fill="#011dde" />
        <path d="M430.6,242.8h-2c0-2,2-2,2,0Z" fill="#0110ca" />
        <path
          d="M427.6,249.3c-.4-.3-1.2-1-1.5-1-.3-.4-.9-1.2-.3-1.5l2.2,2.2-.5.2Z"
          fill="#011dde"
        />
        <path d="M426.6,245.3c-1.4.2-2.6-.5-1.2-1.5l1.2,1.5Z" fill="#011dde" />
        <path d="M426.6,239.8c.3,0,.8-.8,1.5-.5-.5,1-.3,1.6-1.5,1.5v-1Z" fill="#021edd" />
        <path d="M424.6,239.8c-.4-1.6,1.9-1.5,1.5,0-.4,0-1,0-1.5,0Z" fill="#021edd" />
        <path d="M428.6,251.8c.5-1.2,1.7,0,1.5,1.2s-1.1.5-1.5-.2c.3-.3.3-.7,0-1Z" fill="#010dc4" />
        <path d="M428.6,251.8c1.6-.3,1.5,1.3,0,1,0,0,0-.9,0-1Z" fill="#000299" />
        <path d="M426.1,241.8c.2,1.4-.7,1.4-.5,0h.5Z" fill="#021edd" />
        <path d="M424.9,240.8c.3.2.3.3,0,.5v-.5Z" fill="#0114d3" />
        <path
          d="M387.1,335.7c-.3,1.5-1.3,3.5-3,1.7-.2-1.5.8,0,1.5-.4s0-1.7,1.5-1.3Z"
          fill="#0239e5"
        />
        <path d="M385.6,335.2c-.2.7-.8,1.2-1.5,1l-.5-1.5c.7-.2,1.4.5,2,.5Z" fill="#0239e5" />
        <path
          d="M399.1,291.3c1.3,2.5-1.6,2.5-1.9,4.4s.4,1.5.4,1.6-.9.2-1.5.5c0,.4.1.8.5,1,.2.9,1.6,1.9,1,2.5s-1.7-1.3-1.7.5c-.5-.4-.8-1.1-1.3-1.5-2.4-2.3-1.1,0-2.1.9s-5.9-2.1-.9-.9l1-3.5c-1.4.4-3.7.2-4.5-1.3s.8-.7,1-1.1c.4-.9.3-2,.5-2.6-.5-.7-.3-.9.5-.5,1,.3,1.9,1.3,2.5,3l-.2,1.4c-.9,0-.8-.4.2-1.4-.5-.6-.2-.7,1-.5,0-.5.7-.9,2.2-1.2.9-1.8,1.6-2.4,1.8,0s-1.1-1.9.5-1.2c0,0,1,0,1,0Z"
          fill="#022ee6"
        />
        <path
          d="M394.6,300.3c-1.2,1.6.4,2.8.4,3.3s-1.2,1-1.3,1.6.4,1.6.5,1.7c-.3,0-.5.2-.5.5-.3,1-.7,1-1,0,0-.3,0-.8,0-1,.6-1.6.1-1.1,0-2.3s.9-.1,1-.6c.1-.7-1-3.5,1-3.2Z"
          fill="#022ee6"
        />
        <path
          d="M383.6,296.3c-.8,0-1.1-.2-.9-.9.4-2.3,1.4-5.8,4.2-4.2,0,1.2,1,1.3,1.8.6.4-.8.8-.9,1,0,.6.9.7,2.7,0,3.8l1.9.8c1.6-.1,2.4.1,1.8,1.8,1.2.3,1.3,1.1,1.4,2.1-.9.6-1.1,1.7-.4,3.4,0,.2-1.3,2.8-1.6,2.6-.5.9-2.3.4-2.4-.8-3,0-3.5-1.8-1.6-5.2l-.5-.2c.5-1.5.3-2.4-.5-2.8-.7,0-1.2-1.1-1-1,1.8,1.1-.2,3.2-1,1.5-1.5.6-2.4.5-2.5-.5-.2-.2-.2-.3,0-.5l.5-.5Z"
          fill="#0225e1"
        />
        <path
          d="M403.6,286.3c.4.1.4.3,0,.5,2.1-.2,3.1,5.8.5,3.5q-1.3-1,0,0c1.2,0,1.3.5,1,1.5-.4.2-.4,1.5-2,.5.9,2,0,1.2-.5,2,.7,1.7,1,3.4,1,5,.2.5.3,1.1,0,1.5.4.3.3.7,0,1,0,1-.3,1.2-1,.5-1.9,1.6-2.7-1.7,0-1.5-1-.4-1.1-.6,0-1-.9-1.2-1.2-1.4-1-.5v.6c-1.3-.2-1.6-.1-1,.4,1,1.4.2,2.8-2.5,4.3l1,.2c-.2,1.4.2.5,1.5,1-.4.5-.9,1-1.5,1.5.4.4,1.1.4,1,1-2,0-3.1,1.3-4,3-.9.6-1-.2-.5-1,.3-.2,2.5-2.4,2.5-2.8-.1-1.5-1.9.4-2.2.8s.2.9.2,1c-.1.2-.7,0-1,0,0-1.6-.5-1.1-1-2.5-1.3-.4-1.3-1.6,0-3.6-.6-1.4-.4-2.4.5-2.9,1.1,0,1.8-.4,2-1.5-1,0-1.2-.3-.5-1l-.2-.7c.5-2.1,1.6-4,3.2-5.8-1.1-2.5-.8-4.2,2.1-4.5,1.5-1.6,2.3-1.8,2.4-.5Z"
          fill="#0225e1"
        />
        <path
          d="M400.6,305.8c.8,0,.7.7,0,1-.5.1-1,.5-1.5.5-.9-.7,1.1-1.8,1.5-1.5Z"
          fill="#0215cd"
        />
        <path
          d="M400.6,296.8c0,0-1.1.1-1.5.5,1-2.6.2-.9-1.5-1.2l2.5-1.8c-.3.7.6,2.4.5,2.5Z"
          fill="#0334e7"
        />
        <path d="M396.6,298.8l-2,.5c-.3-1.3.6-1,1.5-1.5.5.1.4.6.5,1Z" fill="#0116d6" />
        <path
          d="M401.6,299.3c-2.4-1.6-.8-1.2,1-1.5,0,.7,0,1.3,0,2-.3,0-.7-.5-1-.5Z"
          fill="#022de5"
        />
        <path
          d="M404.1,299.8c.9.2,1,.8,0,1-.1.4-.3.4-.5,0-.1-.5-.7-.9,0-1.5,0,.1.4.3.5.5Z"
          fill="#021ddc"
        />
        <path d="M404.1,301.8c-.2,0-.3,0-.5,0,0-.3,0-.7,0-1h.5c1.3,0,1.3.4,0,1Z" fill="#022de5" />
        <path
          d="M380.1,309.8c-.9,1.3-1.7.4-1.2-1-1.2-.7-1.2-2-.9-3.3-2.2-.7,1.6-3.1,2.8-3.7,1.8.3,2.3-.3,1.4-1.6-1.3-3,2.1-3.2,2.2-.8s-.8-.6.2,0c.2-1,.6-.9,1,0,1.4,1,.9,2.6,0,3.5,0,0,.6.3.5,1l1,1c-.3.3-1,.7-1,1-.3,0-.9,0-1,0-1-.4-1.3-.3-1,.5-2.8-.6-.3,2.1-2.5,3-.5,0-1.1.3-1.5.5Z"
          fill="#0233ea"
        />
        <path
          d="M388.1,300.8c-.6.8-1,1.5-1,2.5h-.5c0-.8.2-1.2-.7-1l-.3.5c-.4-1.5-.2-1.8,0-3.5-.4-.2-.4-.3,0-.5.5-.3,1.3-.8,2-.5.7-1.5,2.7,0,.7.4l-.3,2.1Z"
          fill="#0225e1"
        />
        <path
          d="M387.6,297.3l3,.5c.4,1.8-1.4.7-2,1s0,.9,0,1.5c-.2.2-.4.3-.5.5-1.1-.7-.3-2.1.5-2.8-.2-.4-.6,0-1,.3-.9,0-.9-.3,0-1Z"
          fill="#022ee6"
        />
        <path
          d="M392.6,307.3c.3,0,.7,0,1,0,0,.5.6,1.4.5,1.5-.5,0-1.1,0-1.5,0-3.3-.2-3.8-2,0-1.5Z"
          fill="#0225e1"
        />
        <path
          d="M388.6,306.3c.9-.6,1.3.3.5,1,0,.2,0,.7,0,1-.7.3-.5-2.1-1.5-1s.7,1.9-1,1.5c.7-1.1-.6-2.1-.5-3,.5.1,2.1.5,2.5.5Z"
          fill="#0225e1"
        />
        <path
          d="M384.1,306.3c-1.8-.8-1.3-2,.7-1.5s.3,1,.3,1l.3,1c-.3-.5-.9-.3-1.3-.5Z"
          fill="#0225e1"
        />
        <path d="M387.1,304.8h-1.5c-.2-.5.5-.9.5-1,1.1.1,1.7.3,1,1Z" fill="#0225e1" />
        <path d="M388.6,306.3c.2,0,.9-.7,1.5-.5.4,1.1-.8,1.1-1,1.5l-.5-1Z" fill="#021bd9" />
        <path
          d="M381.6,311.8c.9-1.5,1,.3,1.1.4.7.6,1.9-1.2,2.9-.9-.4.9-1.7,1.6-2.5,2,.2,1.1-.5,1.3-2,.5-.5.1-1,.3-1.5.5l.5-2.5c.8.2,1.3.2,1.5,0Z"
          fill="#022ce5"
        />
        <path
          d="M380.6,310.3c.6,0,.9.4,1,1v.5c-.3.4.6,1.9-1.5,0s-.5-.5-.5-1c-.2-.5,0-.7.5-.5.1,0,.3,0,.5,0Z"
          fill="#021cdd"
        />
        <path d="M380.6,310.3c.5-.2.8-.7,1.5-.5l-.5,1.5c-1.1.1-1.1,0-1-1Z" fill="#022ce5" />
        <path
          d="M378.1,296.3c0-.9.6-1,2-.3,1.4-1.3,3.3-.8,3,1.3.4.1,2,.4,2.5.5.4.1.4.3,0,.5-.3.4-.7.7-1,1-.1,0-.1.6-.4.4s-.6-1.5-1.6-1.4l1.5,4.5c-.5-.1-3.4-.1-3.5,0s.7,1.2.5,1.5l-1.2-1c0,1.2-2.7.8-1.7,2s1-.2,1,.3-1,2,.2,2.2,1.2-.8,1.7-1.2c-2-.4-1.6-2.7-.5-1.7s.9,2.7,1.5,3.3l-2.8,1.2.8.5v.5c-.2.1-.3.3-.5.5-.5.6-.4,1.5-.5,1.5-.2.2-1.2-.6-1.4-.4s0,.9,0,.9c.1,1.6-1.8.9-1.5-.5l.3-.6c-.9,1.5-1.8.9-2.8-.4-.5.4-1.1.2-1-.5-.9.9-.5,1.4,1.3,1.4.9,1.5-4.8,3.1-5.3,1.1,0-.5-.4-1-.5-1.5.7-.6,3.4,2.1,1-1.5-.6-.8-.8-1.5-.5-2,0-.1,0-.4,0-.5.1-.4.3-.4.5,0,1.2-.2,2.4-.5,3.8-.8-1.1-1.1,0-2,1.2-1.7l.4-1.5c-1.3-1.4.5-3.4,2.1-3.9,0-.6-.3-.6-1,0-.1.4-.3.4-.5,0-.9.5-1,.4-.5-.5,0-1.4,0-3.8,1.5-2.5.5-.2.8-.2,1,0l1-.5Z"
          fill="#022ce5"
        />
        <path
          d="M383.6,314.8c3-2.6,1.5.2,1.7.5.5.6,1.8.2,2.8,1-.6.2-.5.2-1,.5.6.5.1.7-.5,1-2.4,0-1.9-.3-4,.5-2.1-1.4-1.1-3,1-2.5-.6-.2-.7-.8,0-1Z"
          fill="#022ce5"
        />
        <path
          d="M391.6,314.3c1.6.5,1.3,4,2.6,4.4s2.8-1.2,2.9.1c-1.7,0-1.9,1.2-3,2-.2-2.2-1.5-1.5-3-2,.1-2.7-.4-.9-1.7-1.1s-1-1.1-1.3-1.4c1-.3,2.4-.4,3.5-.5.3-.2-2.3-1.8,0-1.5Z"
          fill="#022ce5"
        />
        <path d="M391.9,317.8c.3.2.3.3,0,.5v-.5Z" fill="#0126e1" />
        <path
          d="M402.6,300.8c-.2.4-1.1.4-1,.8s.9.6,1,.7c2.5,0,1.3,3.4-.5,2-.2,0-.2,0,0,.5.4.1.4.3,0,.5-1.8.3-.5-2.5-3-.5s-.5,1-.5,1c-.1,0-2.8-1-3-1.5,2.2-1,4.6-1.2,5-4,.5-.8,1.8-.4,2,.5Z"
          fill="#022de5"
        />
        <path
          d="M401.6,299.3c.5-1,.8-.5,1,.5,0,.3,0,.8,0,1-.7-.2-1.3-.3-2-.5s-.9.1-1,0c-.8-1,1.2-1.1,2-1Z"
          fill="#021ddc"
        />
        <path d="M402.1,303.3l-2-.2c.8-1.1,1.5-1,2,.2Z" fill="#0118da" />
        <path d="M402.1,304.3v.5c-1.2-1.7,0-.5,0-.5Z" fill="#0223dc" />
        <path
          d="M404.6,299.3c.2,1.2,1.9.9,2,1s-.3.4,0,1.5c.5,1.6,1.2,1.2,1.5,1.8.5,1.1-.9.7-1,.7-1.7-.3-2.7-1.4-2-3-.1-.2-.7.4-1,.5,0-.3,0-.7,0-1,.1-.8,0-.7,0-1s.5-.3.5-.5Z"
          fill="#0223dc"
        />
        <path
          d="M296.2,424.7l-.7-1.5c2.5.2,1.7-1.3,3.2-2.5-.5,2.2-.8,2.7.5,4.5l.5.5c.2,0,.7-.4,1-.5-.2,3.7,1.6.5,1.7.5.4,0,.1.5.5.8s.8.2.8.2c.1.2-2.5,3.2,1,1-.6-1.6,1-1.5,1,0-2.3,2.5-1.1,1.4-1.6,2.9s-1.6,1.9-1.9,2.1c-.3,0-.7,0-1,0-.7,0-.6-1.1.3-3.1-1.4.8-2,0-1.3-1.4l-.5-1c-.9-.7-2-1.2-3.2-1.3l-.3-1.2Z"
          fill="#012372"
        />
        <path
          d="M299.7,427.2c.5.2.4.6-.4,1.2l.4.8c2.7.7.2,3-2,2-.2,0-2.7.9-3.5-.5l.5,2c-.7.1-1.4-.5-2-.5-.2.9-.5.9-1,0-.4-.1-.4-.3,0-.5-1.4-.2-1.2-.5,0-1,.6-.1.5-.3-.5-.5-.1.4-.3.4-.5,0-1.8.9-.6-3.1,1.7-3,.5,1,1,1.4,1.3,1h.5c.1-.3.3-.3.5,0l.7.3c1.1-2.9,2-3.2,4.3-1.3Z"
          fill="#012372"
        />
        <path d="M321.7,418.2v-.5c0,.3.9,0,0,.5Z" fill="#012779" />
        <path
          d="M309.7,404.7c.8-.8,1.2-.6,1,.5.4.1.4.3,0,.5l-.5.5.4.5c.8-.4,2,0,3.6,1,.4-3.3,1.5-3.8,3.1-1.5-.5,1,.2,1.5,2,1.5.7.7,0,3.1-.8,3-.5.3-.8,1-.8,2,.7.9,1.3,1.1,2,1.8s.2,1.7,1.5.7c0,.9.3,1.7.5,2.5-1.3.3-.8-1.1-1.1-1.4s-.9,0-1.3-.2.2-2.7-.6-.7c.3,1.8.9,3.3,3,2.7-1,.7-1.9.2-2.2,1.5-1.1-1,0-2.5-1.7-3l-1.5,3,2-1.5c-.4,1.5.6,1.1,1,2-2.5-.3-1.3.8-1,2.5h-2s.5-2.5.5-2.5c-2.4,1.4-.6,1.8-.5,4,2.2-.8,2.8-1.2,3.2-3.5.6,0-.6,4.5,1.7,2.9s-.2-1.1.6-.9v2.5s1-2,1-2c1.5,2,1.2,1.1,3.5,1-.4.1-.9.8-1.6,1.1-3.3,1.4-6.6,2.6-9.9,3.9-.3,0-.7,0-1,0-2.5-.2-4.8.7-7,2.5-1.7.5-2.7.7-4.5,1-.2-.5.7-1.9,1.2-2.7,0-1.1.8-1.8,2.3-2.3-.9-1-.7-1.4.5-1l.2-1.3c2.2-.1,2.4-1.3.5-3.6l.3-.6c-.8-.2-1.4-.7-1.5-1.8-2.1-.2-3.2-.7-2-2.7.3-1,1.2-1.1,2.4,0,1.9-1.5,3.4-1.8,4.6-.9.5.5.9,1.4,1.2,2.5.7-.6.9,0,.8,1,.4.3.8.3,1,0-2.3-.6-3.3-2.4-2-4.5-1.3-.7-.9-1.3.5-1,.5-.5.9-.9,1.5-1.3v-.7c-.3-1.1-.7-1.8-1.3-2,3,.4-.2,2.6-2,3.2.5.3,1.2,1.3.8,1.8,0,.4-.3.4-.5,0-1.3.9-5.8,1.3-7.2.2s-.9-3,1-2.8c.3-1.8,1.6-3.6,2.6-4.7-2.7-1.3-1.3-4.2,1-2.5.6-.3,1.1-.4,1.6-.2Z"
          fill="#012779"
        />
        <path
          d="M300.7,425.2c-1.6-.6-2.4-4-1.4-5.1s2.2,0,2.8,0c1.2.1,3.8.7,2.8,1.9,1.2,1.7,1.1,2.4-.2,2.3.6-.8.9-.7,1.1.4,1.7.3,1.5.8.5,2-.8.3-1.3.6-1.5,1-.7,2-1.6,2.2-2.7,0-1.4,0-2.8-1.6-1.3-2.6Z"
          fill="#012779"
        />
        <path
          d="M306.7,431.7c1-.7,3.8-4.4,4.5-4s.5,2,2.5,1.5c-1.8.4-4.8,1.9-7,2.5Z"
          fill="#022884"
        />
        <path
          d="M311.2,414.7c-1.2-1.7-3.8-.9-1.2-3l1,.5-.3-3.5c1.8-.4.8,2,1,3l1.5-1.3-1-.7h2.5c-.5.5-.6,1.5-1,2,1,1-1.1,1.8-2.1,1.6s.5-.6.6.4c0,0-.5.8-.5,1-.1.4-.3.4-.5,0Z"
          fill="#022f86"
        />
        <path
          d="M310.7,405.2l1.7-1-.2,2.5,2,1c-1.8-.2-4.1-1-4.7,1-1.7-1.4,0-1.6.7-2.5l.5-.5v-.5Z"
          fill="#023187"
        />
        <path
          d="M311.7,414.7c0,.5.5,2.8.5,3.5l.2-2c1.5,1,1.1,1.9,1.3,3-.1,1-.6,1-1,0-.4,0-2.4-1.4-2.5-1.5s.7-.8.5-2,0-.7,0-1c.2,0,.3,0,.5,0h.5Z"
          fill="#022d82"
        />
        <path
          d="M313.7,411.7c.5.2,2.6,1,2.5,1.7-.2,1.5-2.1-.3-2.7-.3s-.2.9-.5,1-.7-.5-.8-.4c-3-.7.6-.7,1.5-2Z"
          fill="#01206e"
        />
        <path
          d="M313.5,424.4c.2.2,0,1,.3,1.2.4.4,1.8-.5,1.4,1.1-3.8,1-1.8,0-2.4-.8s-1.6-.4-1.6-1.2l1.5-.3c-2.4-1.1-.7-1.7.8,0Z"
          fill="#011e6e"
        />
        <path d="M313.7,419.2c.2,1.3,1.4,1.2-1,2v-2c.3,0,.7,0,1,0Z" fill="#011e65" />
        <path d="M310.2,406.2l.5-.5c-.1.2-.4.3-.5.5Z" fill="#012c7d" />
        <path d="M309.7,387.2h-.5l-.5-.5c0-.7.5-.8.5-1,.7.4.4,1.1.5,1.5Z" fill="#023290" />
        <path
          d="M283.2,395.7c0-.5.3-.4.5,0,.9-.7,1.2-.4.5.5-.5.4-.5.9-.5,1.5,1.2-.7,1.7-.3,1,1,.1.2-.3,1.1.2,1,1.8-.4,2-2.7,3.4-.5s-.1,1,.3,1.3,2.2-.5,2.5.7c-.4-.5-4.2-.6-3.2,1-1.6-3-3-2-1.8,1-1.9-.8-1.1-.3-2,.5.1-.2-.1-1.3,0-1.5s1,.3,1-.2c-2.5-1.9-.9.1-1,.2s-1.6-.2-1,1.5c-.2.4-.3.4-.5,0-.8-.3-2.3-.8-2.1.4-1.8,1.4-4.7,0-4.4-2.4-2,.2.5-2.1,1.5-3,.4-.2.7-.2,1,0,.1-.4.4-.7.7-.6,1.2.2,2.5,0,1.8-1.4-.4-.1-.4-.3,0-.5.3-1,1.5-1.6,2-.5Z"
          fill="#023ca1"
        />
        <path
          d="M285.7,389.2c4.8-3.3,5.3,1.8,1,3.5l1.5,1.5c.2,0,.9-.7,1-.5,0,.6,0,1.4,0,2l-1.5-.5c.5.7.5.5,1,1.5-.1.4-.3.4-.5,0-1.4-.9-.6-.1-1.2.3s-1,.1-1.2.3c-.4.5.3,1.8-1.1,1.4-.3-.4-.8-.7-1-1-.2-.6-.3-1.4.5-1.5,0-.5-.1-.4-.5-.5-.2-.9-.4-1.6-1-2.5l-.3-.6c1.8-1.2,2.2-2.2,1.3-2.9-.3-.1-.3-.3,0-.5.7-1.4,2.2-2.1,2,0Z"
          fill="#02359e"
        />
        <path
          d="M287.7,385.2c.3-.2,1.5-.7,2-.8l-.5,2.8c1.5-.4,1.3-3.4,2.5-1,.1,1,.5.8-.5,2,1.2-.2,1.7-1.2,1.5.5-.7,1.2-1.9,2.5-3,3,0,.5-.6.9-1.5,1-.3,0-.7,0-1,0-.1.4-.3.4-.5,0,.2-1.8,2.4-1.5,2-3.2s-.8-1-1.3-.3,1.2,1.8-.7,1.5c0-.7-.5-1.2-1-1.5-.9-.5-.7-1.5.5-3,0-1.1.5-1.4,1.5-1Z"
          fill="#023ca7"
        />
        <path
          d="M291.2,392.7c.7-.1,1.1-.6,2,0-.3-1.7.5-1.9,2-1.3-1.4,1.1-2.5,2.9-4.5,1.2h.5Z"
          fill="#0442a5"
        />
        <path
          d="M289.7,391.7l1.5,1c-.2,0-.3,0-.5,0-1.4.2-1,.2-2.5,0,.2-1,1-.8,1.5-1Z"
          fill="#023290"
        />
        <path d="M288.2,394.2c-.9,0-1.6-.6-1.5-1.5h.5l1,1.5Z" fill="#023290" />
        <path d="M297.2,382.7c0,.2-.3.4-.5.5-.1-.1-.9.1-1,0-.2-.3.9-1.4,1.5-.5Z" fill="#022b8a" />
        <path d="M309.2,387.2c-.4,0-.5-.1-.5-.5l.5.5Z" fill="#022b80" />
        <path
          d="M285.2,384.2c.4-.9,1.1-.2,1.5.5.3,0,.7,0,1,0v.5c-.4.2-.6,1.2-1.5,1-.6-.2-1.1-.2-1.5,0,.3.9-1.1,2-2,2.5.5.8.3,1-.5.5-.6.3-.9.6-1,1,.4.1.4.3,0,.5-.1.4-.3.4-.5,0-.1.3-.3.3-.5,0-.9.8-1.6.4-.8-.6-.9-.8-2.7-2.7-.7-2.4.2.2.3.3.5.5.8-.4,1.6-.5,2.5-.5-.4-.9-.4-1.6,0-2,.3,0,.5-1.3,2,1l.5-2.5c.2-.4.3-.4.5,0,.1,0,.3,0,.5,0Z"
          fill="#0246b4"
        />
        <path
          d="M289.7,376.7c.2,0,.5,1.4,1.5,1,.2-.7,0-2.8.5-3.2,1.5-1.1.6.8,1,1s.9.3,1.5.2l-1.5-.5c.1-.9.9-.8,1.5-1,.3,0,.9,0,1,0,.2.2.3,1,1,1.5,0,.3.7.8.5,1-.3,0-.8,0-1,0-.2-.2-.4-.2-.5,0,0,0-.2.6-.7.5s-.2-1-.3-1c-.5-.4-1.8,2.7,0,2l.3.6c-1.5.6-1.4,1.6.2,2.9.1.3.4.7.5,1-.3.9-1.4,1.4-3.1,1.3.4.7.3,1.2-.4,1.7,0,.2,0,.3,0,.5-1.4.3-1.1-.4-.7-.1.8.6-1.8,3.9-3.3-.9-.4-.1-.4-.3,0-.5-1.6-2.2-1.5-2.6,1.4-3.2v-2.2c-1.3.3-1.9,0-1.9-1,.5-.5,1.8-1.7,2.5-1.5Z"
          fill="#0235a2"
        />
        <path
          d="M294.2,378.2c.5-.2,1.9-.3,2.5-.5,1.1,1-2.9,1.8-3,2,.3.7.7,1.3,1,2l-2-1.3c0-.7.9-1.9,1.5-2.2Z"
          fill="#023ca7"
        />
        <path d="M295.7,376.7c-.1,0-.3,0-.5,0l.2-.5.2.5Z" fill="#02309e" />
        <path
          d="M295.2,382.7c.1.4,0,1,.5,1.3-1.4-.1-.7,1.2-2.5.2,1,1.5-.3,1.1-1.5,1.5-.2-1.1-1.5-1.8-.3-2.5s2.7.3,3.8-.5Z"
          fill="#023ca7"
        />
        <path d="M292.2,379.7l-1,1c-.1-1,0-1.1,1-1Z" fill="#023ca7" />
        <path
          d="M269.7,343.7c.6.8.9,2,1,3.5-.6,1-1.4,2.1-2.5,3.2.9.2,1.4.4,2,1.3,0,.2,0,.3,0,.5,0,.4-.3.8-1,1-.4,0-.4.2-1.5,0-.8,1.5-2.5.7-2.5-1-.4.1-.6.2-.7.1-.5-1,.8-3.3,1.7-3.1l.5-.5c-.4-.1-.4-.3,0-.5,1.3,0,2.3-1.1.7-1.6s-.3-.5-.2-.9c-.7,1.5-1.3,1-1-.5-.4-.1-.4-.3,0-.5-.6-1.4,2.9-2.3,3.5-1Z"
          fill="#024adb"
        />
        <path
          d="M271.2,347.2c-.1,1.9-1.4,2-1.5,2.3-.5,1.9,1,1.7,1,1.9s-.5.2-.5.3l-4.5-.3c.8-.3,1.2-1.1,1.6-1.6.9-.8.7-.6,1.5-1.6s1.8-1.1,1.9-1.1c.2-.5.3-.5.5,0Z"
          fill="#0357df"
        />
        <path d="M275.7,346.7c2.9-1.6.8.6.5,1.5-2.2.9-2.6-.4-.5-1.5Z" fill="#022db5" />
        <path
          d="M273.7,362.2c1,.8.6,1.2-1,1-1.4-.6-1.2-.2.5,1,.7.3,1.1,1.3,1,2,.7-.7.9-.4.5.5,2.7,1.4,2.2-1,2.8-1,.8,0,1.4,1,1.7,1,.4.1.4.3,0,.5-.5.3-1.1.4-1.9.4,0,1.2-.8,1.7-2.6,1.6-1.2.2-1.3,0-.5-1-.6,0-1.1-.4-1.5-1-.2.9-.7,1.3-1.3,1.3.3,1.5-1.5,2.7-2.7,1.7-.2.2-.3.2-.5,0-1.1.5-1.8.2-2-1-1.5,1.7-3.2,1.7-5,0-.2.8-.4,1.3-1,.5-.1.5-.3.4-.5,0-1.5-.7.6-3.6,1.9-3.1,1.8.7,0,1.4.1,0l3.1-1.2c.5-1.9,2.5-2,3.3-.2.7-.4,1.1-.3,1.6.4-.2-1,.6-1.6,1.5-1l-.5-.5c-.5.1-.6,0-.5-.5-.9.2-1,.3-.5-.5v-.5c.2-.2.2-.4,0-.5,0-.2,0-.4,0-.5.7-.9,2.3-1.7,2.1-.2,1-.3,1.6,0,1.9.7Z"
          fill="#024ccc"
        />
        <path
          d="M279.2,367.2c.1-.4.3-.4.5,0,0,.2,0,.7,0,1,.2.5,0,.5-1,0q-1,.1,0,0c1.1.2,1.8,1,2,2.5-.1,0-.3.4-.5.5-.1-.2-1.1-.5-1.5-.5-1.1-.2-2.3.3-3.6,1.4l-.4-.4-.5.5c-2.6,2.5-2.5-4.4,0-1.5.5-.5.8-.7,1,0,.4-.5.4-.9,0-1-.1.4-.3.4-.5,0-.4-.2-.4-.3,0-.5,1.6-.7,2.7-3,4.5-2Z"
          fill="#013fbb"
        />
        <path
          d="M277.7,351.2c-.5.6-1.3,1-1.5,2l2.7-2c2.5,2.1.6,2-1.2,3.2l2,.3-1,2.5c.6.1,1.3.7.8,1.2,3.7.7,1.5,4.9-.8,3.3q-.9-.9,0,0c1.5,0,1.4.8.8,2,.8.3,1,.7.7,1,0,.9.2.9.5,0-.7-.3-1-.9,0-1h.5c.3,0,.7,0,1,0,.4.1.4.3,0,.5,0,.3,0,.8,0,1l.5.5c1,1.9,1.1,2.2,3.5,1.5.1,2-2.9.4-1.5,3s.4.3.5.5c1,.7,0,1.5-1,1-.1-.2.3-1-.2-1-2.3,3.7-2.1,1.1-2.5,1-1.2-.4-.5,1.2-1,1-1-.4-.2-1.4-.3-1.5-.8-.4-.7-.6.5-.5l.5-.9c-.4.7-1.8-.9-1.5-1.6-1.3-.3-1.3-.5,0-1,0-.4,0-.6-.5-.5h-1.8c-1.8,1.6-2.7,1.6-2.7,0,.9-2.2.2-4.2-1.5-6-.2.4-.3.4-.5,0v-.5c-.6.4-.9.3-1-.5-1.3-.3-1.1-1.1.5-2.5.1-1,.5-.9,1,0v-.5c-1.6.7-1.7-.5-.5-1.5,1.6-.4,1.4.3,3,1l-1-1.8,1,.2c0-1.4,1.1-2.5-.2-3.5s0,2.1-1.2.2l3.5-.2Z"
          fill="#0241bd"
        />
        <path d="M280.7,363.2v.5c-1.3,1.6-2.3-2.6,0-1v.5Z" fill="#0241bd" />
        <path d="M282.7,365.7c0-.2-.4-.3-.5-.5l.5.5Z" fill="#0239b7" />
        <path
          d="M273.2,360.7c.7-.5,1.2-2.4,3-1.3l-2,1.7,3-.5c0,.8-1.9.9-1.9,1.7s.8,2.8,1.4,2.5l-2,1.8c-.2,0-.3-.3-.5-.5-.4-.8-.4-1.5,0-2-.6-.3-1.1-.7-1.5-1,.3-.3.9-.7,1-1-1.2-.3-1.1-.6-.5-1.5Z"
          fill="#0347c8"
        />
        <path
          d="M279.7,368.2c.9.3,2.8,1.4,2,2.5s-.7,0-1,0c-2.3,0-.6-2.6-2-2.5,0,0,.2-.3,1,0Z"
          fill="#0234b0"
        />
        <path
          d="M282.7,367.2c.1.1,1.1,2.9,1,3-2.6.3-1-.6-1-1.7s-.9,0-1-.5c-.3-.9.8-1,1-.7Z"
          fill="#0234b0"
        />
        <path d="M280.7,364.7c0,.2,1.1.4,1,1h-1.7c-.7-.1.3-.9.2-1h.5Z" fill="#032ba9" />
        <path d="M279.2,366.7c0,0,.8-.8,1-.5.4.5-.5.9-.5,1h-.5v-.5Z" fill="#0234b0" />
        <path
          d="M273.2,356.7c1.1-2.2.8.6,2.5,0-.3,2.1-1.3,1.9-2.8,3-1.6-1.2-.4-2,1.2-2,.2-.9-.8-.3-1-.5s0-.4,0-.5Z"
          fill="#0347c8"
        />
        <path
          d="M272.7,360.2c-.3.6-.3.8,0,.5.1,0,.4,0,.5,0,.6,0,.6,1.1.5,1.5-1.6.3-2.5-1.3-4-.5.1-.3.3-.8.5-1,.1-1.4.3-2.1,1.5-1,.4-.2,1.1,0,1,.5Z"
          fill="#024fd1"
        />
        <path d="M272.7,360.7c-.2,0,0,.8-1,.5l1-1v.5Z" fill="#0347c8" />
        <path
          d="M276.7,331.7c0,1.1,1.5,2.2,1.5,2.3,0,.4,0,1.5,0,2.2s0,.3,0,.5c-1.1-.8-2,.5-3,1-1.3.2-1.4,0-.5-1-1.1-.1-1-1.1,0-1.5l2,.5c-1.8-1.7,0-2,0-4Z"
          fill="#0121af"
        />
        <path d="M275.5,336.2c.3.2.3.3,0,.5v-.5Z" fill="#023fd4" />
        <path
          d="M256.2,244.3c.8-.5,2.1-.2,3,0,4,.8,7.9,2.6,11.3,4.4l.7,1.5c2.6,1.1,3.4,2.3,2.5,3.7-1.7-1.1-1.9-.4-2.5-.5-.2.4-.3.4-.5,0-1.1,1.8-3.9.7-3.6-1.5-1.8-1.1-3.6-2.1-5.4-3l-.4.5c-1.3-.3-2.7-.4-4.3-.3-1.6-1-3-2.1-4.3-3.2-2.1.8-3.3.4-3.5-1-2.8.7-2.7-.5,0-1l1.2-.9c1.8.9,3.8,1.2,5.7,1.4Z"
          fill="#011a92"
        />
        <path
          d="M272.7,247.8c2.3,2.3,3,2.4,2.1.3l.9-.8c-1.3-.2-1.3-.6,0-1,1,1,.7,1.8,1,3s-.4,1.8.5,2c0,1.2,0,2.3,0,3.5-1.2-1-1,.5-1.2.5-1.5.3-1.5-1-2.2-1.5-.5-2-2.4-2.1-3.2-3s0-2.5-2.3-1.5c-.4-3.2-1-1.4-2.2-1.6s-3.1-2.1-4-2.5-2.2-.1-2.9-.9c4.1-.8,8.9.7,12.8,2.4l.7,1.1Z"
          fill="#01095a"
        />
        <path
          d="M261.7,248.8c1.6.6,5.5.8,6.3,2.5s-1.5,1.6,2.7,2c.6.5,1.1,1.2,1.5,2,0,.2,0,.4,0,.5-.2.3-1.3.6-1,1.5l-.5.4c-1-.8-2-1.6-3-2.4-1.3.6-2.5-1.5-1.5-2.5-3.6-.6-5.1-2-4.5-4Z"
          fill="#0222b8"
        />
        <path
          d="M272.2,254.3c.4.1.4.3,0,.5,0,.2,0,.3,0,.5-1.4.4-.9-1-1.5-2,.2,0,.3,0,.5,0,.5,0,.9,1,1,1Z"
          fill="#0219a5"
        />
        <path d="M272.2,254.3c.7.3,3,.1,0,.5v-.5Z" fill="#011a92" />
        <path
          d="M268.7,278.3c.4.3.9.5,1.5.5,1.9,0,1.5,2.2.8,3.3,1.2,1.8,1.4,3.5-1.1,4.1l.3.7c.5.3.9.6,1.3,1,.5-1.9,2-1.1.7.5-.2.4-.3.4-.5,0l-.5.5c.8,1.2-.9,2.4-2,1.5-.6.3-1,.2-1-.5l-.9-.7c.3-1.2.2-2.9-.1-3.3-.3.8-1.1.6-2.5-.5-1.5.1-2.3-.1-1.7-1.8,1.4.6,2,.2,2.2-1.2l.5-.5c0-.4.1-.5.5-.5.4-.8.7-.2,1,.5.8.7.8.5,0-.5-2.4-.3-2.5-4.4,0-3,0-.8,1.3-.7,1.5,0Z"
          fill="#023fef"
        />
        <path
          d="M271.7,276.8h.5s0,.9,0,1l-1,.5q-.2.2,0,0l1-.5c.2.3,1.9.8,1.5,2l-2,.5,2,.5c.2,1-1.4,0-1,1.2s1.2,0,1,.5c-1.9,1.5-.5,3.3-3.5,4.3-.3-.2-1.3.5-1-.7s1.9-1.2,2-1.3c.1-.2-3.1-5-.5-3.5.1-.2-.3-2.2-.5-2.5-.8,0-1.3,0-1.5-.5-.5,0-1.1.1-1.5,0-.5-.5-.7-.8,0-1,.1-.3.3-.3.5,0l.9-.9c1.2,1,1.9,1.1,2.1.4.2-.2.6-.2,1,0Z"
          fill="#0231e3"
        />
        <path
          d="M264.7,285.3c.4-.3,1.9-1.6,2-1.5,0,1.3-1.3,2.2.5,2-.3.5-.3,1.6-1,1.5-.2-2-1-1.2-2.5-1-.3-1.5.7-.8,1-1Z"
          fill="#0458f5"
        />
        <path
          d="M267.2,281.3c.6.3,1.9-.8,2-.2.2.9-1.5,2.8-2,2.2s0-1.1,0-1.5,0-.3,0-.5Z"
          fill="#0454f2"
        />
        <path d="M270.2,278.8l-2.5,1,1-1.5c.6.1,1-.3,1.5.5Z" fill="#0239ea" />
        <path d="M269.5,282.8c.3.2.3.3,0,.5v-.5Z" fill="#0231e3" />
        <path
          d="M261.7,258.8c-1.5-.3-2-3.2-.9-3s2.6,1.4,2.8,1.9c1.2,0,1.2.6,0,2.1,1.8-.7,2.4-.3,2,1,.1.7-.2.7-1,0,.7.7.3,1-.5.5-.3.8-.4,2,0,2.5.3-1.4.4-1.2,1,0,.4.1.4.3,0,.5.2.9.4,1.9.5,3,1.5-.7,1.5-.1,1.5,1,.3,0,.7,0,1,0,1.1.5.9,1-.5,1.5-.9.4-1.7.9-2.5,1.5-1.3-.2-2-.7-2-1.5.1-1.2-.4-1.9-1.5-2.4v-1.1h-1c-.3.9-.7.9-1,0-.7-.6-.5-1.4.5-2.5-1.3-2.7-.8-3.1,1.5-5Z"
          fill="#0249f1"
        />
        <path
          d="M268.2,260.3c0,.5-.3,1-.5,1.5.6-.1,1.2.2,1.6.9,2.1-.8,3.9.6,1.4,1.6,0,0-.8,0-.5,1h1c0,.9-1.5.4-1.5,1.8s2,.3,1,1.2-3.7-2.2-3.5,0c0,0-.1.6-.4.5,0-.9-.6-1-1.1-1.5-.5-.9-.7-1.9-.5-3v-.5c.2-.7,0-1.7-.5-3,0,0,.1.4,1,0-.8-1.3.8-2.6,2-1.5,1.3-.3,1.5,0,.5,1Z"
          fill="#0237e4"
        />
        <path
          d="M273.2,263.8c-.6,1.1-.3,2.1,1,1.7-1.1,1.2,0,2.7,0,3.8l-2-1c0-1.8.2-2.9-1.5-4,.7-1.5,1.6-1.7,2.5-.5Z"
          fill="#011bc2"
        />
        <path
          d="M271.7,296.3c-.4.3-.6.6-.5,1-.1.5-.2,1-.5,1.5,0,0-.3.6-.4.4-.3-.2-.4-1.4-.8-1.4s-.9.8-.7,1,1-.1,1,.3c0,.6-1,2-.5,2.7s2,.1,2,1c-.8,0-1.8.1-2.5,0-.3.5-1,.4-1.9-.3-1.7,1.2-1.3-.2-.5-.3s2,1.2,2.4,1.7c.5,0,1,0,1.5,0-1.9,2.2-.3,1.3.5,2,.3.1.3.3,0,.5,0,.1,0,.3,0,.5-.1.4-.3.4-.5,0h-1c-.2.2-.3.2-.5,0-.6,0-1.1-.8-1.5-1.5-2.4.4-3.7-.4-3.7-2.3-3.1-1.2-4-3-.1-3.6l.4-.5c.9-1.7,2.4-2.7,4.4-3.1.4.2,1,.9,1.3.9.7,0,2.1-1.8,2.2-.4Z"
          fill="#023cee"
        />
        <path
          d="M272.2,288.3c.5,0,1,0,1.5,0,.4,1.7-1.2.7-1.5,1s1.6,4.7-.5,5.7c0,.2,3.3-.8,1.5,2.2.9,1.2-.1,2.3-1.5,2-.9,1-1.1.8-1-.5-.9-1-.9-1.3.5-1.5,0-.4,0-.7.5-1-.5-.2-.9.1-1.2,1.1-1.4.1-2.9.1-2.3-1.6-1.6,0-2.2-.4-2-1-.3-.8.4-1,1-.5l.6-.4c-2.3-1.6-1.6-2.3.9-2.5l.6-1.2c.6-.4,1.5-1.2,2-1.5l.5-.5c.1,0,.3,0,.5,0Z"
          fill="#0231e3"
        />
        <path d="M271.2,288.8l.5-.5c-.1,0-.3.4-.5.5Z" fill="#0247f4" />
        <path d="M270.7,291.8c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#0247f4" />
        <path d="M271.2,297.3c0,0-.8-.6.5-1,0,.4-.3.7-.5,1Z" fill="#0234e3" />
        <path
          d="M267.7,255.3c.7.1,2.7-.8,3-.5s-.4,1-.2,1.6.7.8.7.9c.4,1.8,0,5.6,2.5,6,.1.4-.4.4-.5.5l-2.5.5c.2-.3.5-.6.5-1-.5-.3-2.5,1.9-3.5-1.5.1-.5.3-1,.5-1.5-.1-.4-.5-.9-.5-1-.5-.1-.4-.3,0-.5-.9-.6-1-2.8,0-3.5Z"
          fill="#0129d0"
        />
        <path
          d="M275.2,268.3c.2.3,1.5,2.6,1.5,2.7.3,2-.4.7-1.5,1.3,0,0,.3-.4.3-.7-.4-1.2-1.1-1.7-.3-3.3Z"
          fill="#0312b1"
        />
        <path d="M272.2,277.8c.3.3-.7.8-1,.5s.7-.8,1-.5Z" fill="#0239ea" />
        <path d="M271.2,278.3c.2.2-.5.8-.5.2s.4-.4.5-.2Z" fill="#021bc2" />
        <path
          d="M277.2,275.3c0,1.1.2,6.2,0,6.4-1.9,2-4.8-2.7-.4-2.9.2-.3-1.2-1.2-1.5-1.5-.9-1.5-.1-2.6,1.5-2h.5Z"
          fill="#0312b1"
        />
        <path
          d="M276.7,274.8v.5c-1.7.5-1.2.6-1.5,2-1.9-1.9-.5-1.5-.5-2.5.6-.9,1.7-1.4,2,0Z"
          fill="#0119b7"
        />
        <path d="M276.7,280.8h-.5c-.2-2.1.7-2.1.5,0Z" fill="#021bc2" />
        <path
          d="M270.2,311.3c.5.4,1.3,2,1,2.5-.4,0-.6-.4-1-.5-.6-.7-.7-1.8-1-2.5.6.1.6.1,1,.5Z"
          fill="#0245eb"
        />
        <path
          d="M268.7,302.8v1s-.1.4-.5.3c-1-.5-.9-1.8-3-.8l1-2c1,.6,1.2,1.3,2.5,1.5Z"
          fill="#0351f4"
        />
        <path
          d="M268.7,302.8c-.6-1-.6-2.1-.1-3.2-2.1-2.8,2.8-3.4,1.6-1.1l.6.3c.2.1.9.4,1,.5.7.9,0,2.3,1.5,2.8v.7c-1.8,3.6-.4,1.6.2,3.1s0,1.8-.2,1.9c-.4.3-1.6-1.8-1.5,1-.5,1.4-2.1.6-2.5-.5-1.3-.1-1.2-.6,0-1v-.5c0-1,.8-1,1,0,.3.8.5.8.5,0-.4-.1-.4-.3,0-.5.2-.2.2-.4,0-.5-1.7,1.6-2.7-2.1-1.1-1.8s-.3,1.8-.9-.2c-.9-.1-1-.9,0-1Z"
          fill="#0234e3"
        />
        <path d="M271.7,305.3s-1.1.2-1-.2c.8-1.4,1.6-.3,1,.2Z" fill="#0336e3" />
        <path d="M270.2,306.8h.5c0,.3.3.5.5.8l-1.2.2.3-1Z" fill="#0336e3" />
        <path d="M269.2,307.3c-.2-.1-.4-.3-.5-.5h.5v.5Z" fill="#0336e3" />
        <path d="M270.7,306.3c0-.1,0-.4,0-.5l.5.2-.5.2Z" fill="#0336e3" />
        <path
          d="M266.2,325.7c0,0-2.2-.3-.2,1.5.6-.1,0-1.3.2-1.5s.7,0,1,0c-.7,2.3,1.3,1.8,1.5,3.5-.2,0-.8-.7-1-.5,0,.5,0,1,0,1.5.3.5.7,1,1,1.5,0,.2,0,.4,0,.5.5.6.1,1.1-1,1.5-.2,0-.3,0-.5,0-1.2,1-1.8.2-1-1,.2-.4.5-.7,1-1-1.8-.9-.5-2.1-.3-1.3s-.3.3-.7-.2c-2.3,0-4.8-.4-5.7-2.8-3.1-.7-1-3,1.2-1.9,1.5-1.1,3-1.5,4.5-1.3-.1.4.1,1.3,0,1.5Z"
          fill="#034eed"
        />
        <path
          d="M270.7,329.2c.3.2.3.3,0,.5v.5c-.5-.3-.8-.6-1.5-.5v.5c1.8,0,1.1.8-.5.5-.6.7-.9.4-.5-.5.5-.1.5-.6.5-1,.4,0,1.3-.8,2,0Z"
          fill="#034eed"
        />
        <path
          d="M361.1,297.3l1-.4c.2,1.3,1,1.9,2.5,1.9.5-.4,1.3-.2,1,.5.4.3,0,1-.1.9-.7-.2.7-1.1.6.6.9,1.6.8,2.1-.5,1.5-1.2.1-1.4.3-.5.5.4.1.4.3,0,.5l-.5,2.5-1.2-2c-.6.1.1,1.4-.5,1.5s-.8,0-1.2,0c.4-1.6,1.4-1.8,1.5-3.2-.4-.9-3-.5-4-1.3l-.5-.5c0-.1,0-.3,0-.5l.7-.6c-.7-.9.1-2.2,1.3-1.9.1-.4.3-.4.5,0Z"
          fill="#024cef"
        />
        <path
          d="M360.1,296.8c.6-.1.8,0,.5.5-.4.4-.6,2.2-2,2.5,0-.3.7-.8.5-1h-1.5c-.6-.1-.8-.6-.5-1.5-.4-.2-.4-.3,0-.5l.5-.9c.9.3,1.7.6,2.5.9Z"
          fill="#023eeb"
        />
        <path
          d="M357.7,298.8c.4-2.1,3.3-.6,1,1,.4.1.4.3,0,.5l.5.5c1-1.3,6.3.2,4.1,2,.9.4-.9,1.9-1.6,2.5-.3.7-.8,1-1.5,1h-.5c-1-1.8-1.8-3.5-2-5.5,0-.7,0-1.4,0-2Z"
          fill="#0538e0"
        />
        <path
          d="M357.7,298.8c.1.6,1,1.6,0,2-.3-.8-.7-1.7-1-2.5-.2-1.2,0-1.5.5-1,0,0,.4,1,.5,1.5Z"
          fill="#0831cc"
        />
        <path d="M362.1,302.3l-1.8,2c.3-1.4-.6-.8-.7-1-.9-1.4,1.7-.6,2.5-1Z" fill="#0347eb" />
        <path d="M359.1,300.8l-.5-.5s.4.4.5.5Z" fill="#023eeb" />
        <path
          d="M353.2,287.8c1.1-.2,1.7,1.2,1,2,.8.2,1.3.5,1.5,1,1-1.1,1.2,1.2,0,1.4.8,1.2,1.4,2.6,1.5,4.6,0,.2,0,.3,0,.5l-.5,1c0-.1,0-.4,0-.5l-.5-.5c-.2-.2-.3-.3-.5-.5-.5-2.6-2.4-6.4-3.5-9-.9-2.4.9-2.1,1,0Z"
          fill="#082ec9"
        />
        <path
          d="M372.6,310.8c.2.3.6.5,1,.5.5-.2,1-.3,1.5-.5l.3,1.5c.8-2.6,2.2-.6,1.8,0s-.8,0-1,0c1.5,1.2.9,1.8-1.9,2-.2.7-.6,1.2-1.1,1.5l-.5.5c.4.1.4.3,0,.5-.4,0-1.4.1-1.5,0-.4-.4,1-1.4-1.5-.5-.6.4-1.2.3-1-.5,0-.3-1.1-.5-1-.7.2-.4,1-.7,1-1.8,1.8,0,3.3-.4,5-.5l-3-1.3c-.5-.7,1.9-.7,2-.7Z"
          fill="#0238e7"
        />
        <path
          d="M375.1,326.2c1.1,4-2.1,4.8-3,1,0-.2-.6-.6-.5-1,.4-.2,1.8.7,2,.5.9-1-.9-1.4-1-2h2c-.6-1.3-.3-2-1.8-1-.9-.6.1-.8.3-1l2-.5c-.7,1.6,0,2.9,0,4Z"
          fill="#0228db"
        />
        <path d="M368.1,322.7c0-.3,0-.7,0-1l3,.5c.4,1.7-1.8.5-3,.5Z" fill="#0348e1" />
        <path d="M366.6,318.8l.2-2c.8.5.9,1.1.7,2h-1Z" fill="#0450e8" />
        <path d="M369.6,316.3c0,0-.3.9-1.5.5-.1-.4.5-.9.5-1l1,.5Z" fill="#0219cc" />
        <path
          d="M376.1,327.2c.2.2.4.7.5,1l-2,2.2c1,.3,2.1-.6,2,1.3l-4,.5c1.8-3.7-.2-2.5-1-3.6s.5-.6.4-1.4c.8.1.7,1.2,1.3,1.5,1.9.8.8-1.1.9-1.8s.8-.7.8-.7c.7.3,1,.6,1,1Z"
          fill="#023adf"
        />
        <path
          d="M370.1,299.8c.5.3,1,.5,1.6.7.1,2.2,0,3.1-.6,4.8,2.1.2.5,2.4-1.5,1.9l-.5.6h-.5c0-.2,0-.6-.5-.5l-.5.5c0,0,0,.5,0,.5-.4-.7-.4-1.4-.8-2s-1.4-.2-1.2-1c2.1-1,1.3.4,1.5.5,1.8.8.9-2.3-1.5-1.5l-.5-1v-.5c-.5-.6-.2-.8.5-.5.5-.5.6-.8.5-1.5h1.5c.9-1.1,1.8-1.5,2.5-1Z"
          fill="#0244ef"
        />
        <path
          d="M368.6,308.3c.3.6.6,1.2,1,1.8l-.5.2c-1.2-.3-1.1-1.4-1.5-2,.2,0,.7,0,1,0Z"
          fill="#0244ef"
        />
        <path d="M260.2,440.2c0,.8-1.5.7-1.5,0h1.5Z" fill="#074dcb" />
        <path d="M262.2,440.2s-.3.6-.7.5l-.3-.5h1Z" fill="#074dcb" />
        <path
          d="M263.2,426.7c-1.8-2.6.4-4.2,1.8-1.2,1.2,0,2.1.4,1.9,1.8,1.6.4,2.4,1,1.3,2.4-.3.6-.8,2.2-.5,2.5,1.6,1.6,1.6-2.5,2.1-2.9s5,.4,1.9,1.9c.2-1.8-1.7-1.3-.5,0h-1s.8,1,.8,1l.2-1c.6,0,.7.8,1,1,.4.1.4.3,0,.5h-3.5c-.1,1,1.3,0,1,1.2s-.9.1-1,.3c-1.1-1.6-1.5,1.5-1.5,1.7s1.8.6,1,2.3l1.5-1.5c.4,2.4-1.6,2.1-3.2,1l-.3,1.5c-2-.6.3-1.8,0-2-.7-.4-1.5.9-2,1-.5-.3-1.2-.7-2-1-.3,0-.7-.3-1-.5-1.2-.7-1-1.4-1.5-2,.5.5,1.6-.4,1-1s-1.5.5-1,1c-.3-.4-.4.7-1-1-.3-.6,1-.9,1.1-.8s-1.2.5-1.1-.2c-1.6-.7-1.2-1.9.5-2-.5,2.5,1.2,1.1,2,1.5s-.3.4-.1,1,.6.8.6,1c2.4-.8,4.4-2.2,2-5-.7-.3-.5-1.5,0-2-.1-.2-.4-.4-.5-.5Z"
          fill="#01267e"
        />
        <path
          d="M297.7,431.2c.4-.3.7-.2,1.1.2,2.3-1.7,3-1.5,1.9,1.2h.5c0-.7.7-.6,1,.1-3.8,2.9-12.5,2.5-17,4.5-.2,0-.3,0-.5,0-.9,0-1.7.1-2.5.5-.9.1-1.7.3-2.5.5-3.7,0-7.5.5-11,1.5-.5,0-1,0-1.5,0-1.1.4-2.4.4-3.5,0-.5-.3-.8-.3-1,0-.1.2-.5.4-1,.5-.1.3-.3.3-.5,0-.4-.1-.4-.3,0-.5l-.5-.5c-.6-.5-.5-2.4.5-2.5.9-.9,1-.8,1,.5.4.1.4.3,0,.5q-.2.2,0,0c.7-.2,1.7-.2,2,.5-.4-2,1.5-2.6,3.1-1.1-2.7-1.6.8-6,1.4-2.9.4.1.4.3,0,.5l-.5.5c1.4-.7,2.3-.8,3.7-.5,1.3-1.7,5.9-1.9,6.8.5.5-.8,1.3-1.3,2.5-1.5l.5-.5c1.2-1.9,2.2-2.4,3-1.5,1-.5,1.5-.1,1,1l1-.5c0-1.6,3.3-1,2.8.7-3.4,2.7,3.7,2.2,3.2-.7,1.1-1.8,1.3-2,3.1-1.1,1.1-.3,1.8-.3,1.9.1Z"
          fill="#012682"
        />
        <path d="M284.7,437.2c-.5,0-1.6.4-2.5.5.4-.8,1.7-.5,2.5-.5Z" fill="#1553ce" />
        <path
          d="M267.2,439.7c-.7.9-2.4.4-3.5.5-.4-.1-.4-.3,0-.5,1.2,0,2.3,0,3.5,0Z"
          fill="#074dcb"
        />
        <path
          d="M262.7,439.7c0-.4.4-.4,1,0v.5c-.5,0-1,0-1.5,0h-.5c.1-.5.6-.5,1-.5Z"
          fill="#022b82"
        />
        <path
          d="M279.2,433.2c.3-1.1.6-1.5,2-1.5-.5.7,0,1.6,0,2-.2,1.4-1.1,1.6-2.5,1.5,0-.3,0-.7,0-1,0-.6.1-1,.5-1Z"
          fill="#011b6e"
        />
        <path d="M262.2,437.2c1,.3,2.3-.7,2,1-.7.1-1.4-.2-2-.5v-.5Z" fill="#022b82" />
        <path d="M263.7,439.7c-.3,0-.7,0-1,0l-.2-1,1.2,1Z" fill="#01267e" />
        <path d="M268.2,435.2c0-.4.1-.5.5-.5-.1.2-.2.4-.5.5Z" fill="#01267e" />
        <path d="M262.2,437.7c.2.2-.5.8-.5.2s.4-.4.5-.2Z" fill="#01267e" />
        <path d="M264.5,438.7c.3.2.3.3,0,.5v-.5Z" fill="#01267e" />
        <path d="M261.2,439.7s-.5,0-.5-.5l.5.5Z" fill="#01267e" />
        <path
          d="M130.3,101.4c-.3.7-.9,1.4-2,2-1.5,1.2-3.5,2.3-5,3.5-2.6.3-4.7,1.4-7,2.5,2-3.3,5.7-3.5,8.7-5.1s2.2-1.6,2.8-1.9,1.9-.6,2.5-1Z"
          fill="#3b54db"
        />
        <path
          d="M90.8,145.8c1.2.5,1,3.6.2,4.4-1.6.6-2.7,1.6-2.2,3.1l-1.1.6c.7,2.9.2,4.3-1.2,4.4l-1.4,1c0,2.3-1,4.3-2.9,5.4,1.4,3-2.1,4.4-4.4,4-.9-.1-.9-.8,0-1,.1-1.2.9-5.8,1.6-6.4s1.5.1,1.9-.1.9-5.3,1.6-5.9,1.5.1,1.9-.1.1-1.3.4-1.8c.7-1.2,2.1-2.9,2.9-4.1s-.6-1.2,1.3-2l.5-.5c0-.1,0-.3,0-.5.3-.2.7-.3,1-.5Z"
          fill="#0004b1"
        />
        <path
          d="M77.8,167.8c0,.3,0,.7,0,1,2.5-.4,2.9,1.2,1.2,3l-.4,1.3c.6,6.2-.7,8-3.9,5.6-.7,1.2-1.5,1.8-2.4,1.6.5,1.1-.9.3-.8.2,1.8-.9,2.9,4.2.4,4.2.9,2.4-2.3,2.2-2.1,0,0-.3,0-.7,0-1,.1-.5-.1-1.3.1-2.1.5-1.6,2.2-2.9,1.4-5.4.2-.2,1.4.7,1.5.5.9-1.2-1.8-1.7-1-2.5s2,0,2.4-.6.2-1.7.7-2.6,1.1-1.2,1.7-2.6-.9-1,1.3-.8Z"
          fill="#0004ae"
        />
        <path d="M89.3,147.3c.1,0,.3-.4.5-.5,0,.2-.3.4-.5.5Z" fill="#0109ae" />
        <path
          d="M168.8,80.4c1.3-.3,2.9-1.2,2.5.5-.1.4-.3.4-.5,0l-.5.5c-.1.4-.3.4-.5,0l-.5.5c0,.3,0,.6-.2.8-.2.4-6.8,3.3-7.8,3.2-2.7,1.4-5.4,2.9-8.2,4.4-3,2.9-8.2,5.8-12.2,7.5s-.3-.1-.5-.4c.2-.5.5-1.1,0-1.5-.4-.1-.4-.3,0-.5l6.5-4.5c6.4-3.1,15.4-9,22-10.5Z"
          fill="#0a1dc6"
        />
        <path
          d="M139.3,99.4l-2.5,2c.7,1.1-.5,2-1.5,1.5l-4.1,3.1c.2,1.1-2.2,3-3.3,2.4-1,.4-1.8,1.2-2.5,2-1.4,1.7-3.4,3.8-5.5,4.5-.1.4-.3.4-.5,0l-3.4,2.4-.6-.4c.7-.6,1.3-1.4,2-2,3.3-2.9,8.3-5.6,11.3-8.5s1.2-2.6,3.4-4.2,3.3-1.9,4.9-2.8c.6-.8,1.3-1.2,2-1,.5-.3,1-.7,1.5-1,.3.5,0,1.2-1,2Z"
          fill="#0e24d1"
        />
        <path d="M140.3,95.4v.5l-12,7.5c.6-.5,1.4-1.4,2-2,3.4-1.9,6.4-4.6,10-6Z" fill="#0e24d1" />
        <path d="M138.8,98.4c-.7.4-1.5.7-2,1,.3-.8,1.6-2.2,2-1Z" fill="#0a1dc6" />
        <path
          d="M112.8,124.4c3.4.1,3.9,4.2,1.5,6-.3.1-.3.3,0,.5.2-.4.3-.4.5,0,2.8,2.4-.6,4-2.6,2.2l-.9.3c-.2.4-.3.4-.5,0q-.2-.2,0,0c.6,1.4,0,1.6-1,.5-1.6-.7-1.7-1.9-.4-3.5l-.2-.7c-1.4.3-1.9-1.7-.8-2.3,0-.2,0-.5,0-.5.2-1.3,1.1-3.3,2-1.5.6-.2.8-.4,1-1-.3-.9.2-.9,1.5,0Z"
          fill="#0224d5"
        />
        <path
          d="M108.3,127.4c0,.5-.1,1.9,0,2s2.6-.5,2.5,1.3-2.1-.6-1,3.2l.8.3c.3,1.4-.4,6-2.3,4.2-.2-1.4-.4-1.4-.5,0l.9.6c1.5-1,2,0,1.4,2.9-.9-.2-1.2.2-.9,1.2-1.6-.4-2.9,1.1-3.9,2.4.3.1.2.3,0,.5.3,1.4-.2,1.7-1,.5-1.3-.3-1.8-1.8-.5-2.5l.5-.5c-.1-.5,0-.7.5-.5.3-.4.3-.6,0-.5-1,0-1-1-.9-1.9,1.2-2.2,1.5-4.3.9-6.5l1-.6c-.4-.1-.4-.3,0-.5l.5-.5c-.4-1.1,0-1.5,1-1.9-.4-.8-.5-1.5-.5-2.1.4-.3.5-1.2,1.5-1Z"
          fill="#011dd2"
        />
        <path
          d="M104.3,127.9c.1.8-.3,2.9,1,2s0-.7.4-1,.9-.3,1.1-.5c1.7-.4.3.9,1,1.3s1.7,0,1.5.7c-.8.5-2.3,1.4-3,2l-.5.5c0,.1,0,.3,0,.5,0,.6,0,1.1-.7,1.1.6,1.6-1.9,6.1-3.3,3.9-2.4,0-2-4-1-5.5,1.2-1.5,2.2-3.4,3.5-5Z"
          fill="#0112c6"
        />
        <path
          d="M119.3,114.9c0,1.4-1.2,2.8-3.2,4.1l.2.9c.1-.3.3-.2.5,0,1,1,.4,1.5-.7,1.9,0,1.5-1.2,2.4-3.2,2.6-.8-.3-.8-.3-1.5,0-.1.6-.4.9-1,1,0,0-.6-.2-.9.1s.2,1.7-1.1,1.4c-.2-.1-.9.1-1,0-.7-.8,6.9-9,8-10l4-2Z"
          fill="#112fdc"
        />
        <path
          d="M100.8,132.8c1,1.8-.6,4.4,1,4.8v.7c.4.1.4.3,0,.5.9,1,.4,1.3-1.4,1.2-.5,1.2-.9,2.5-1.1,3.8h-.5c.4.9-.9.8-.8.7,1.8-.2,1.8,1.7,0,1.6.9,2.1.8,3.7-1.9,3.7,1.4,2.5,1.1,3.7-.8,3.6-1.1,1.5-2.3,1.2-3.5-.7-.6-.9-.3-3,1-4.1-1.3-1-1-2.5,0-3.6,1.6-.6,3.7-2.3,1.4-3.4l.5-1.4c.9-.9,3.1-2.3,3.3-2.6.6-.9.8-3.2,1.6-4.5s1-.3,1-.3Z"
          fill="#0108bf"
        />
        <path
          d="M184.8,374.2c2.9,1.6,2.4,1.9-.1,3.6.2,1.4-1.3,2.4-2.6,2,.5.7.8,1.3.8,1.9.4,1-.4,2-1.5,1.5-.5.5-.5.7,0,.5.1-.5,1-1,1.5-.9,2,2.3.7,3.7-3.8,4.1,2.5,2.2,2.8,3.8-1,3.8.8,2.9-2.1,3.9-2.2.5-.4.6-.7.6-1,0-.2.3-.3.3-.5,0-.2,2-1.1,3.3-2.6,3.7,2.3.8.9,3.8-.9,2.3-3.3.6-.9-3.8-1-4s-1.5-.2-1.5-1c.6-.3,4.1-.8,4.2-1s-.2-.7,0-.9.9-.2,1.1-.8-.2-3.9.2-4.3c2,.9,1.2,0,2.5-1.2l-2-.3c-.1,0,.4-.8.5-1,.4-.1,2-.5,2.2-.5.4,0,0,1.7,1.3,1-.7-1.5.2-1.8.5-2.8s-3.1-1.3.4-1c-.7-1.5,1-.7,1.1-1-.4-.3-.4-.8-.5-1.3,1.4.2,1.1,1.3,2.1-1s-.2-1-.1-1c.4-.2,2.5,1.1,3-1Z"
          fill="#021f5c"
        />
        <path
          d="M174.8,382.7c1,1.5-.2.6.3.5,3-.7,2,3.1-.5,3.5.4,2.1-.4,4-2.2,5.6-2.4-.3-3.2,3.3-1.6,4.9,1.1.8,1.8,1.8,2,3-.3,1.4-1,1.8-2.5,2.1.5.7.3,1.6-.5,2.8,1.5,3.8.7,7.1-3.9,6.1-.4-.8-1-2.1-2-2.5.2,1.4.7,2.7,0,4l1.5.2-2,1.7,2,1c-2.1.2-3.3.8-4.2-1.5l-.5,1.5c-.9-.5-1.6-1.9-2.3-2.5l1-1.3c1.9,3.1,1,.5,1.1.3s1.7-.7,1.9-1.3c-2.6.2-4-3-1-2.8l-1-.7c2-.3,2.6-1.3,0-1.2v-.5c0-.9.4-1.2,1.2-1.4-.9-.3-.9-1.6-.2-2.1.2,0,.9.7,1.5.5.2-.8-1.5-1.6-1.5-1.7.2-.6,2-3.2,2.5-3.5s2.1.7,2.8.6c1.5-.2,1.5-4-1.3-1.4l-.5-2.2,3-.5c-3.8,0-3.3-1.9,0-1.3-1-1.4-1.9-1.6-1-3.5.7-.3.5,2.1,1.5,1s-.9-1.3-.2-1.5h2.7s-1.5-.5-1.5-.5c-.4-2.3,2.4-1.3,1-4l3,1c.2-.9-1.5,0-1-1.2s1.7-1,2.5-1.3Z"
          fill="#021a53"
        />
        <path
          d="M161.3,402.2c-.2,2.5,2.3.3,2,1.7s-1.9,1.6-3,1.8-1.8.3-1.5-1c2.7,1.8.6-2.5,2.5-2.5Z"
          fill="#02174d"
        />
        <path d="M162.3,410.2c-.5.5-2-1-1.5-1.5s2,1,1.5,1.5Z" fill="#02174d" />
        <path
          d="M206.2,345.2c2.9-.9,1,3.4-.5,4.5l.2,1-7.1,6.1c-.5,1.2-1.3,1.9-2.4,2.2-.6,1.3-2.5,3.9-3.7,2.7-1.3.3-2.1,1.2-2.5,2.6-1,.1-1.8.6-2.5,1.4-.5,2.1-3.5,5.2-5.5,3-.2.2-.2.3,0,.5.5.2.4.3,0,.5h-2c.2-.3.8-.4.9-.6s-.4-.9-.4-.9c.2-.1,3.3-.4,4-.5.2-.5-.5-1.3-.5-1.5,0-2.4,1.4-1.7,2.2-2.5s2-3,2.3-3.5c1.7-1.4,3-2.7,4.1-4.4h1.9c.6-.9,1.5-1.5,2.5-.6,1-1.1,1.6-2.3,1.6-3.4,1-.6,2.2-1.3,2.2-2.5l2.1-.8c0-1.8,1.6-2.9,3.1-3.2Z"
          fill="#020d39"
        />
        <path
          d="M187.8,365.7c3,1,.8,4.2-1.5,4,.4,1.5.3,2.8-1.5,2.5-.4.4-2.1.5-2,2l-.5-1.5c-3.1.6-3.1,2-2.5,4.5-.8-.1-1.7-.2-2.5-.5.1-.7,0-1.7,0-2.5,2.7,1.3,1-2.1,3.5-1.5.3-.8-1-.3-1-.7,0-2.4,2.2-1.5,2.5-2.3s0-.3,0-.5c-.2-.2-.2-.3,0-.5.8-.3,2.3-.3,2.9-.6s1-2.2,2.6-2.4Z"
          fill="#02134c"
        />
        <path
          d="M222.2,407.2c2.1-2.3,5.7,0,2.8,2.2,3.5,0,5.6.8,6.1,2.6,1,0,1.1.9.5,1.7l2,.5c1.4-.5,1.9,1.1,1,2-.9.2-1.3.7-1.2,1.5-.8-.1-1.6-.1-2.3,0-.1.4-.3.4-.5,0h-.5c.8.3.4,1.7-.5,1.5-.5,1-2.3,1.2-2.5,0-.9.6-1.4.7-1.5,0-.7.2-1.4,0-2-.5-.2,0-.4,0-.5,0l-.5-.5c-.5-.5-.3-.5-.5-1-.4,0-.3-.2,0-.5-.4-.2-.7-.6-1-1-.2-.2-.2-.3,0-.5,0-.4.3-.4,1,0,.1-.4.3-.4.5,0,.9-.4,1.2.3.5,1,.5.9,1.4,1.4,2.5,1.5-1,0-2.5-.4-2.5-1.5.9-1.5.6-2.4-.7-2.7l-.3-1.3c-.4-.4-.4-.9,0-1.5-2-1-1.3-1.8,0-3-.5-.1-.4-.3,0-.5Z"
          fill="#02338c"
        />
        <path
          d="M215.7,410.2c-.4,2.3,3,3.1-2,4l1.5-1c.2-.4-.8-.8-1-1-.3-.1-.3-.3,0-.5l.5-1.5c-.3,0-.7,0-1,0-.4-.6-.2-.8.5-.5.5,0,1,.2,1.5.5Z"
          fill="#023590"
        />
        <path
          d="M212.7,404.7c-2.6.9-2-2.9-.4-2.8,2.6.1,3.3,2.9.4,2.8l1.7-.9c-.4-1.8.4-2.3,1.8-1.1.1-.4.3-.4.5,0,.8-.3,1.3,0,1.1.7,1.7-.1,3.7,1,1.9,2.3,0,.7-.8.8-1,0-1.8.6.4,1.9,1.2.8.6-2.3,4-1.4,2.3.7,0,.1,0,.3,0,.5-.9,1-1.4,1.7,0,3,1.3.4,0,1.3,0,1.5.2.5.2.8,0,1v.5c.4.2.4.3,0,.5.4.8-.7.2-.7.2.2,0,1.2.4.7.8-.3,0-.7,0-1,0-.1.3-.3.2-.5,0,0,.3,0,.6,0,1,.2.1.2.3,0,.5h-.5c0,0-.7-.3-.7-.5-.2-1.1.1-2.2-1-3l-1.2,1c-.3.3,2,1,1,2s-1.5-.5-2-.5c-.2-.8.7-.3.9-.6s.5-2.5.4-2.7c0-.6-1.2-1.9-1.8-2.3,0-.2.8-1.3,1-2-.2-1.5-.9-1.3-2,.5-.1,0-.3.4-.5.5-.2.6-.8.7-1,0,0-.1,0-.4,0-.5v-1.1c0,1.2-2.7,1.9-2.5.6-1.4-.2-.3-3.8,1-3,.6,0,.9-.2,1-.5Z"
          fill="#023590"
        />
        <path
          d="M234.7,416.2c.5.1.4.3,0,.5,0,1.1.3,2.3.5,3.5.7-.7,1-.4.5.5l-.9,1c0,1.6-.9,3.7-2.6,2.5-.7.7-.9-.5-.9-.5.9,2.6-1.4,3.4-2.1,1-.7.6-.9.3-.5-.5,0-.6-.1-.6-.5,0,.5.7.3.9-.5.5.1.4,0,.5-.5.5,1.7.6,0,2.1-1,1h-.5c0,0-.8-.1-.5-1h1.5c-1.2-.9,1.4-1.6.5-2.5s-3.3.5-2-1.5,2.7,0,2-2c-.8-.2-.3.7-.9,1s-2,.7-2.1.5l-.5-2c.2,0,1.3-.6,1.8-.4s.2.9.2.9q-.2.2,0,0c.2.1,3.8-.7,4,0,.4,0,.9-.4,1.5-1.5.3,0,.3-1.5,2-.5l-.5-1h2Z"
          fill="#022e86"
        />
        <path
          d="M190.3,405.2c.6-.4,1-.2,1,.5l1.5-.5c1.1-.5,1.4.3.8,2.6,1.2.7,1.9,1.8,2.2,3.4,0,0,1,.2.2.5-.9-.3-2,.4-2.5.5s.2-1.2-.7-1v2.5c-.8,0-1.3.6-1.5,1.5,0-.1-.6-.2-.8-.7s-.2-2.4-.7-3.3l-1,1.5c-1.3-2.2.7-3.1.5-4.5-2.9-.6-.7-4.5,1-3Z"
          fill="#022b7a"
        />
        <path
          d="M192.8,413.7c1.6.5.7.6,1,1s.8.2,1,.5c.6,2.6-2.7.3-1-.5l-.4.7c1.5.6,1.9,1.4,1.4,2.3-.2,0-.3,0-.5,0-1,0-2,0-3,0,0-.2.5-.4.5-.5,1.1-.3,0-1.1-.5-2,0-1.8,0-1.9,1.5-1.5Z"
          fill="#022270"
        />
        <path
          d="M182.8,381.7c.6-.3,1.1-.2,1.5.5h.5c1.4.2,1.2.3,0,1-.7,0-1.1.4-1,1,.5-.4.9-.4,1,0,2.2,1.8,1.4,2.7-.3,4.3,0,.7.1,1.4.3,2.2,1.2-.1,1.7.5,1,1.5-1,.4-1.6,1.2-1.8,2.3l-1.2-.3c-1.4,0-2.9,1.3-1.2,1.9l-.3.5c-.7.6-.8,1.4-.3,2.6l-.7.4c-1.2.4-1.3.7-.6,1.7l-.9.8c-.3,0-.7,0-1,0s-.2-.2-1,0c0-.1-.5-.7-.5-1,.3-.1.3-.6,0-1.5-.1-.2-.1-.6-.5-1-.5.4-.8,0-1-.5-.2-.2-.3-.3-.5-.5-.6-.6-1.6-.2-1.5-1,1-.3,3.1.9,3.5-.3s-.9,0-1-.5.4-3.9.5-4.7c.3.3.8,1.8,1.5,1s-2-3.3,3-2.5l-3-3c.9,0,.9-.8,1.7-1.1,1.8-.5,4.3.5,3.7-2h-1.5c-.4-.1-.4-.3,0-.5.1,0,.8-1.5,1.5-1.5Z"
          fill="#022870"
        />
        <path
          d="M176.3,399.7c.4.5,2.4,1.4,0,1.5-.3,0-.9,0-1,0-.2.2.5,1.9-1,.2,0-.5.9-.1,1-.2.2-.3-.6-1.9,1-1.5Z"
          fill="#012164"
        />
        <path d="M173.3,410.7c-.8-.2-.9-.7-1-1.5,2.3.2,1,1.3,1,1.5Z" fill="#01164f" />
        <path d="M175.8,398.7l-.3.5c-1.2.3-.5-.7-.7-1,.5,0,.7.2,1,.5Z" fill="#012164" />
        <path d="M176.8,402.2c0,.6-1.4,1-2,1-.7-.3,1.5-.9,2-1Z" fill="#012164" />
        <path d="M173.3,401.2c-.2.2-.3.4-.5.5,0,0-.6,0-.5-.5h1Z" fill="#021a53" />
        <path
          d="M178.8,402.2c.4-3,1.4-3,3-.5,2.5-1.1,2.3,1.9,1.7,3.7,1.9-.5,3.2.8,2.7,2.6,1,1,1.6,1,2.6.1.1-.4.3-.4.5,0,1,.5,1.1,1.2.2,2.4,1.7.2,2.1,2.2,1.4,3.5l.4,1.1c1.4.2,2.7,2.6.5,2,.1-1.3-1.8,0-2,0-.7.2-1.2.2-2,.5-1-.6-.5-1.2.5-1l.5-.5q1.5-1,0,0h-.5c-1.4,1.6-2.2,1.1-2.4-1.5l.4,2c-1.5,3.7-1.5,0-1.7,0-.2,1.9-1.2.2-1.7.5s.3,1.2-.5,1c1.1-1.9-.5-1.4-.5-1.8,0-.7.9-2.2.5-3.2,2,2.3,2.2-.2,1.9-.4-.8-.6-2.4.3-1.4-2.1-1.1,2.2-2.2.9-2.4,1s-1.5,3-1.5.7,3.4-3.2-1-4.6v-5.7c0-1.3.4-1.3,1,0Z"
          fill="#012773"
        />
        <path
          d="M186.3,416.7c-.1-.5-1.7-2.2-1-3s1.2,0,1.3,1-.7,2.8.7,1.5-1-3.8,2.5-3c-1,1.2-2,1-1.5,3v.5c-.2.3-.6.5-.5,1-.5.2-.9.5-1.5.5,0-.5.1-1.1,0-1.5Z"
          fill="#022b7a"
        />
        <path
          d="M180.3,399.7c.3-1.4.9-1.3,1.5,0,.8-.3,1.1.4.5,1-.1,0-.4,0-.5,0-.2,0-.2,0,0,.5v.5c-1.5-.6-3.6-3.1-1.5,0-.6,0-1.1.4-1.5.5,0-.3.6-.7.4-.9s-1,.2-.9-.3c.7-.2.9-1.6,1-1.7s.7.4.9.5Z"
          fill="#01216b"
        />
        <path d="M188.8,416.2c.7-1.1,0-2.4,2-.2l-2,.2Z" fill="#022b7a" />
        <path d="M179.3,406.7c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#01216b" />
        <path d="M188.3,416.7v-.5h.5c-.1.2-.4.3-.5.5Z" fill="#012072" />
        <path
          d="M226.2,426.2c2.1-.7,2.8-.2,2.2,1.5.8.3,1.7.4,2.8.5,0-1.3,4.6,0,4.7.1.3.6.5,2.8-.3,3.4s-.6.2-.7.2c-.6,0,0-.6.2.3,1.7,0,.2,2.9-1,3l-.8,1.4c5.1,3.4-3.4,2.9-5.2.9-1.9.6-4.1.8-6,.2,0,0-1-.5-1-.5,0-.2,1.6-2.9-1.5-2.5,1.8,2,.2,2.1-2,2l1-2c-.8-.2-.7,1.5-1.2,1.5s-.7-1.4-.7-1.5c.1-1.4.2-2.5,0-4,.6,0,1-.4,1-1-.4-.1-.4-.3,0-.5.1,0,.4-.8.7-1l.8,1c2,.7,2.3.6,1-.5l-1-1.5c2.2-1.3,2.9,3.3,3.8,3.5s1.8-1.3,2.7-1c.5,1.4-.9.9-1,1-1.1,1.4,1.8,1.1,1.9-.2s-.6-1-.7-1.6c-.1-.9.2-1.5-.2-2.7.1-.4.3-.4.5,0Z"
          fill="#01257d"
        />
        <path
          d="M220.2,428.7c.8.2,1.4.2,1.5,1.2s-1.8-.8-2,.5,2,1.7-1.5,1.7c-.3-.5.6-2.6,1-3s.8-.1,1-.5Z"
          fill="#022072"
        />
        <path
          d="M228.7,424.2s.5.5.5.5l1.3.8c-.6.5-.4,1.2.7,2.2,0,.2,0,.5,0,.5-.1,0-.7-.1-.9,0s.6,2.5-1.6,2.9c.9-2.1-1.3-3.1-.5-5l-1,1.5-1-1.5c1.3,0,.9-.9,1-1,.9.1,1.1,0,.5-.5.1-.1.2-.4.5-.5.1-.5.3-.5.5,0Z"
          fill="#012c80"
        />
        <path d="M216.7,430.7c0-.5.6-.8,1-1,1.1.7,0,1.9-1,1Z" fill="#012c80" />
        <path d="M228.2,430.2c-.9.2-1.7-.6-1.5-1.5l1.5,1.5Z" fill="#012c80" />
        <path d="M226.7,432.2c-.3-.6.8-1.7,1-1.5.3.6-.8,1.7-1,1.5Z" fill="#012c80" />
        <path
          d="M106.8,332.2c.8-.9,1.6-.6,2.6.8,1.2-1,1.2,2.5.4,2.7-1.2-.5-.9-.4-2-1.5l-.5,2-1-.5c0-.1,0-.3,0-.5-.2-.5-.5-.6-1-.5,0,.1,0,.3,0,.5v.5c-1.2,1-2.1.3-1.5-.5s.8.2,1-.3,0-1,0-1.2c-.8-1.3,1-1.4,2-1.5Z"
          fill="#0223d1"
        />
        <path
          d="M105.8,331.7c.7-.1,1.1,0,1,.5-.4.7-1.7.8-2,1.5h-.5c-.1.3-.3.3-.5,0-.7-3.3.8-.9,2-2Z"
          fill="#0111bc"
        />
        <path d="M106.3,335.2l-1-.5c.2-.5,1-.8,1.5-1,.3.8-.4,1.2-.5,1.5Z" fill="#011dca" />
        <path d="M104.8,337.2c-.2,0-.5,0-.5,0l.2-.5.2.5Z" fill="#0223d1" />
        <path d="M105.3,335.7v-.5c0,.3.8-.1,0,.5Z" fill="#011dca" />
        <path d="M103.8,333.7h.5l-.2.5c-.3,0-.2-.3-.2-.5Z" fill="#0223d1" />
        <path
          d="M111.8,332.7c1.5.1,2.2.7,1.7,2.2.6.8.9,1.4.8,1.8,0,0-1.2-.3-1.5-.2-1.6.4-1,2.4-3.5,1.2l1-2c.2,0,2.2,1.1,1-.5s-1.1,1.2-.5-2c.1-.5.6-.9,1-.5Z"
          fill="#0223d1"
        />
        <path d="M120.3,341.7c1.9-.3,1.5.3,1.5,2l-1.5-.5c0-.5,0-1,0-1.5Z" fill="#0115ba" />
        <path
          d="M139.3,306.8c2.3-.9-.2,4.2-1.5,2.5,1.8.3.3,3.3-.5,4.5,0,1.3-.8,2.2-1.6,2.8.5,0,.6.7.6,1.2.3,1.2-.5,3.6-1.5,4,.3,2-.6,4-2.5,6-.6,1.3-2,3.3-2.5,4.5.4-1.6-.8-.5-.9-.7s.3-.9-.4-1.2c-2.4.6-1.4.8-1.8,2l-.5.5-.5-.3v-1.7c-.3,0-.7,0-1,0-.7.2-.9.8-1,1.5l-.2-2c-.9.9-.3,1.5-1.8,1.5,0-.6,0-1.4,0-2,.1-.4.3-.4.5,0,.2.2.3.2.5,0-.6-.7-.3-1,.5-.5,1.1,0,1.5-.1,1-.5-.4-.1-.4-.3,0-.5l.5-.5c0-.5,0-.9.5-1.1,1.9-.9.7-.8-.8-.5-2.1-.6.9-5.4,2.2-3.9l.9.3c-.9.4,1.2-1,1.6.2,2.2-.8,3.5-2.5,2-4.5-1.1,1-3.1,1.6-2.5-.5v-.5c.6-.5,1.3-.6,2-.5.2-.9,1,.3,1,.3-.8,0-2.1-1.8-.5-2.3-.9-.2-.9-.6,0-1,.2-1.2.7-2,1.5-2.5,1.5-.4,2-1.2,1.5-2.2.2-.3,3-.7,3.5.2-1.3.2-1.9,0-1.5-1.5-.9,0-.7-.6,0-1,.7-.5,1.7-.5,3,0Z"
          fill="#0220ca"
        />
        <path d="M126.3,332.7c0-.2.5-.4.5-.5l-.5.5Z" fill="#0125cf" />
        <path
          d="M259.2,243.8c.4.1.4.3,0,.5-.5.1-.9,1-1.7,1s-.2-.6-1.3-1c-4.1-.8-8.8-1.4-12.5.2l-2-.2c.4,1.3,0,1.3-1,.5-.1.4-.3.4-.5,0-.1.3-.3.3-.5,0-.6.6-1.7.9-3.4.9-1,1.1-2.3,2-3.8,2.5-.5.7-2,1.8-2.8.6-1,1.5-2.4,2.9-4.3,4.2-.2,3.6-2.6,5.6-1.7.8,0-.8,0-1.7,0-2.5.1-.4.3-.4.5,0,.2-1.4,1-1.8,2.1-2.3.4-1.4,1.1-2.2,2.1-2.4.8-1.7,4.6-3.4,6.2-2.3,2.5-.7,5-1.4,7.5-2l.6-1.1c2.8-.7,8.1-.7,10.9-.2s5.3,1.5,5.5,2.8Z"
          fill="#010f5c"
        />
        <path
          d="M230.2,249.8c.4.2.4.3,0,.5.4.5,0,.7-1,.5-.1.4-.3.4-.5,0-.8,1.4-1.7,2.5-2.7,3.3.3,1.3,0,2-.8,2,0,.6-.4,6-.7,6s-.5-.2-.7-.3c-.1-1-.3-2-.5-3,0-1.7,0-3.3,0-5h.5c0,.9-.6,2.3,1,2-.2-.8-.3-2.8.1-3.4s1.2-.3,1.5-.6c.8-.8,2.2-3,3.4-3,.6.3.8.6.5,1Z"
          fill="#03117c"
        />
        <path
          d="M93.3,260.8c.6-.2.8,0,.5.5,1.6-.8,1.4,1,0,1.7.6.7.5,1.5,0,2.2-1.1-.7-1.9.6-.9,1.2-1.6.2-.1-1.8.7-2.1,1.2-.4,2.4,3.9-.7,2.1,1.8-.4,2.5-.2,2.1,2,.8.2,1.1.6.9,1.5,1,.8.5,1.6-1.5,2.5q-1.2,1.9,0,0c.4-.9.9-.6,1.5,1,.5.2.9.8,1.1,1.7,1.6-.6,2.9-.7,4-.3,3.8-1.7,4.9.1,2.1,3,0,1,0,1.6-1.2,1.5-.3.3-.6.6-1,.5-2.6-.5-1.7,1.6-.4,3.3,0,.7-.3,1.1-.9,1.2.8.9.6,1.7-.7,1.5-.6.2-.9.6-1,1h.5c1.1.2,1.4.5,1,1l-.5.5c.2,1.1-.9.2-.8.2s.7.3.7.4c-.2,3-2,4.2-4.4,2.5-1.3-.6-2.6-1.1-4-1.5-.5-.8-.3-2-2-2,2.2-2.9,0-.7-1.5-1,0,.1,1.2,2.2-.2,1.5s-1.6-2.1-1.3-2.5c.6,0,1,.9,1.5,1,0-.5-.1-1.4.5-1.5.1-.4.3-.4.5,0,.6-.1,1.3-.1,2,0v-.8c1.2-.2,1.5-.6,1-1.2l-.5.5c.2,1.2-2.7.9-2.5,0-.4-.1-.4-.3,0-.5.2-1.6.6-2.8,1.5-3.8-.6-1.3-.4-2.1.5-2.2,1.5-1.6,1.9-3.2-.7-3.5-.9,3-2.3,3-3.8.5.3-1.3,4.4-2.5.5-2.2,2-1.7.2-1,0-1.6-.6-2,.9-1.6,1-1.7,1.2-1.7-3.3.2-3.5,0-1-1,1.4-1.9,1.5-2,.6-.6,1-1.4,1.1-1.4.5-.3,1.5.4,2.1.3s1.1-.8,1.3-.9l.9-.6c-.6-1.6,1.7-3.9,3.1-3.4Z"
          fill="#011ad2"
        />
        <path
          d="M85.3,274.3l2.5,1.5c1.1-3-.5,0-1.5-2,.7-.5,2.4-.5,2.8-.6s.3-1.7,1.2-.9-.5.8-.4.9,2.9,1.5,2.9,2.8l-3,1.2c0-.2,0-.3,0-.5l-1-.3c-2,1.4-3.2,1-3.5-1.2,0-.3,0-.8,0-1Z"
          fill="#010eca"
        />
        <path
          d="M78.3,265.3c.7-.6,1.1-.5,1.6,0,0-1.5,1-6,3.2-4.5.2,1.7,1.3,3.3,2.1,4.4l-.4,1.5.2.7c2.2-1.4,4.1,1,1.6,2.3,1.8,2,2.2,2.9-.4,3.7.6,1,0,1-1,.8.7.6.7.9,0,1,1.9,2.1,1.7,2.9-.5,2.5-.6.6-1.4.9-2.5,1,2.5-2.2,3.4,3.3,1.1,3.6s-3.1-3.1-1.1-3.6c0,.9-.5,1-1.4,1,1.6,1.2.9,2.4-.6,3-1-.2.4-1.4-.3-1.5-2.1-.2-1,1.8-2.7,1.5-.3-.8.3-1.4.5-2s.7-.3.5-1.1-1-1-1.2-1.4c-.7-1.4,3.4-3,3.3-3.3l-1.5-1.7v2.5c-1.5,0-5.6-.2-2.7-2.5,2.1.4-1.4.5.2,1.2,2.5,1.1,1.1-1.2,1.5-1.7s2.8.9.4-2.1-.6-.4-1-.4l1-1-3,1c.7.3,1.3-.5,1,1.5,2.2-1.3,1.7.8.7,1s-1.7-1.7-1.7-2.5c-.4-.2-2.6-1-2.5-1.2,1.3-2,2.6-1,4.5-.8.5-.9-1-2.1-1-2.2,0-1.9,2.4,1.3,3,.7s-.8-1.2-1-1.5Z"
          fill="#010fc6"
        />
        <path d="M82.8,268.8c.1.1.6,3.1-.5,3l-.5-2.8c0-.4.9-.3,1-.2Z" fill="#011ad2" />
        <path
          d="M85.8,258.3c1-1.4,2.8,0,2,1.8,1.1-.2,1.9-.1,2,1.2.3.5-.2.8-1.5,1-1,0-1.6,0-2.5-.5l.5,2.5c-.7-.1-1.4-1.5-1.5-2l.5-.5c0-.3,0-.8,0-1,.4-1.1.9-1,.5-2.5Z"
          fill="#021dd5"
        />
        <path
          d="M93.3,260.3c.4.1.4.3,0,.5l-3,2,2,1.5c-1.6-.7-2.1.9-2.2.9-.2,0-.6-.5-.8-.4v-.5l.5-.5c0-.1,0-.3,0-.5v-1c-.2-.6.4-.8,1-1-.7-1.2-.3-1.7,1-1,.1-2.1,2.2-1.9,1.5,0Z"
          fill="#011bd6"
        />
        <path
          d="M76.8,258.8h-.5c0-.2,0-.4,0-.5l-1-1c0-.3,0-.7,0-1l2-1c.3,1.5,0,2.3-.5,3.5Z"
          fill="#0107bc"
        />
        <path d="M89.8,261.3c.3-1,.7-1,1,0-.2.2-.3.8-1,1s-1,0-1.5,0l1.5-1Z" fill="#011ad2" />
        <path d="M89.3,264.3c0-.3.5-.4.5-.5l-.5.5Z" fill="#011ad2" />
        <path d="M89.8,263.3s-.5-.3,0-.5v.5Z" fill="#011ad2" />
        <path d="M84.8,262.3c0-.3.2-.6.5-.5,0,.2-.3.4-.5.5Z" fill="#0113cf" />
        <path
          d="M70.8,244.3c2.5.3,3.7,1.3,3.8,2.9,2.1.3,3,1.1,2.7,2.6.4.1.4.3,0,.5.3.7.2.9-.5.5-.2.4-.3.4-.5,0l-.5.5c1.3,1,.5,2.2-1,1.5-.8-.6-1.5-.3-2,.5.4.1.4.3,0,.5.1,1.1.3,1.3.5.5.1-.4.3-.4.5,0l.5-.5c-1.4-.2.2-1.2.8-1,1,.3,1,2.1-.2,2.1,0,1.2-.7,2-2.1,2.5,1.5-1.7,2.3-1.5,2.5.5.3,0,.7.2,1,.5.4.1.4.3,0,.5q-.2.2,0,0c.1-.4.3-.4.5,0-.2.6-.1,1.2-1,1.5-.5,0-.7.4-.5,1,.1.1.5.5.5.5-.8,1.5-.6.8-1.5.2-2.2-1.5-2.4-1.8-1.5-4.7-.5,0-1.6.3-1.5-.5l1.5-1c-2.7.5-2.4-1.9-3.1-2.4s-.9.6-1.4-1.1c1.2-.9,1.1-1.9-.4-3.1.6-1,1-2,1.1-3.2-2.3-2,.4-3.9,1.8-1.7Z"
          fill="#010bc3"
        />
        <path d="M75.8,260.3l-.5,1c0,0-.7,0-.5-.7.4-1.3.9-.2,1-.3Z" fill="#010abc" />
        <path d="M73.8,249.3l-1.5,1c-1.1-1.6.5-2.7,1.5-1Z" fill="#0110c7" />
        <path d="M73.3,254.3c-.2.1.5,1.5-1.5,1-.3-.8.8-.3,1-.8s0-.6,0-.7l.5.5Z" fill="#0110c7" />
        <path d="M72.8,253.3c.4-.6,1.8-2.5,2.5-2l-.5,1.5c-.1,0-1.4-.6-2,.5Z" fill="#0110c7" />
        <path d="M72.8,247.8c-1,.1-1.1,0-1-1l1,1Z" fill="#0110c7" />
        <path d="M75.8,251.3l.5-.5c-.1.2-.3.3-.5.5Z" fill="#0110c7" />
        <path d="M69.1,245.8c.3.2.3.3,0,.5v-.5Z" fill="#010bc3" />
        <path d="M76.3,258.3c-.5,0-.7-.2-1-.5v-.5c.6.2.7.6,1,1Z" fill="#0112ca" />
        <path d="M75.3,258.8c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#010abc" />
        <path d="M76.3,258.8c.2.2-.5.8-.5.2s.4-.4.5-.2Z" fill="#0112ca" />
        <path d="M73.8,254.3c.2-.2.3-.3.5-.5l-.5.5Z" fill="#0110c7" />
        <path
          d="M91.8,294.3c-3-2.7,1.5-2.3,3.6-1.2,1.1-.5,2.2-.8,3.3-.4-.2,1.3.6,1.6,1.7,1.1,0-1,2.5-1.3,1.3.1s-.2,1.7.2,1.9c2.1,0,2.2,2.4.9,4.1,3.1,2.6,1.3,9.2-2.9,9.9-.3.4-.3.8,0,1,.6.1.8-.4.7-1.5,2.3-1.5,3.6,4.6.3,3-.9-.5-3.4-.8-4.5-2,0-.2,0-.3,0-.5v-1c-1.7-2.6-1.9-.1-2,0-1,.8-1.2-.4-.5-1.5.9,0,1.7,0,2.5-.5.8-.1.2,1.2.2,1.1s.4-1.4.8-1.1c.2-.2.2-.4,0-.5-.4.2-.9,0-1.5-1-.4-.2-1.5-1.4-2-1-1,.8,1,1.1,1,1.3.3,1.4-.7,1.3-1,1.7-3.1,0-1.5-.4-2.1-2.2s-1.7-.3-1.4-1.6,5.9-1.4,4.5-2.8-1,.6-1.6.4c-1.2-.3-1.4-2.9-3.9,0-.1.4-.3.4-.5,0l-1-.5c1.3-.5,5-2.9,3.5-4.5s-2,.8-1.5-1.5c.2-.2,2.1.4,2-.5Z"
          fill="#0218ce"
        />
        <path d="M96.3,309.8l-.5-.3.5-.7c.5.8,0,.8,0,1Z" fill="#021dd1" />
        <path d="M96.7,302.9c.1,0,1.4,2,1.4,2.4-.7,0-3.9-2.3-2.5-2.5s.9,0,1.1.1Z" fill="#021dd1" />
        <path
          d="M92.8,297.3c-.4,0-2,0-1-1s2-.5,2.5-.5c0,.9-1.1.4-1.5,1.5.4.1,1-.2,1,.2,0,.5-.7.1-1,.2.1,1.1,1.1,1.4,1,2.5,0,0-2-1.1-2-1.3-.5-1.6.5-1,1-1.2,0-.1,0-.4,0-.5Z"
          fill="#0112c7"
        />
        <path
          d="M97.3,306.3c.3.2.3.3,0,.5-.1.4-.5,1.5-.7,1.5-.5-.1-.2-1-.2-1.5s-.2-1-.5-1.5c.7.4.8,0,1.5,1Z"
          fill="#021dd1"
        />
        <path d="M99.8,310.8l-.5-.3.5-.7c0,.3,0,.8,0,1Z" fill="#021dca" />
        <path d="M97.3,306.8v-.5c0,0,.4,0,.4.2s-.4.2-.4.3Z" fill="#021dca" />
        <path
          d="M70.8,216.8c.1.5-.2,1.7,0,2s2.1-.3,1.9,2c-.2.1-1.7,2.7-3.5,2.5l1.5-1.5c-1.4,0-1.9-1.8-2-3l-1,2c.2-1.6,0-2.7-1-4,1.2.2,2.8.5,4,0Z"
          fill="#0107ba"
        />
        <path
          d="M68.8,223.3c.6,0,1.1.3,1.5.5.2.5,0,1-.5,1.5.6.1.9.4,1,1,.2-1.2.6-1.2,1,0,.4.1.4.3,0,.5-2.6,2.2-3.1,6.2.1,8.7.9,1.3.7,2.7-.8,3.4,1.5.8,1.2,2.9-.3,3.3,1.1-.5,1.7-.3,2,.6,3.8-1.2,1.1,4.2-2,1.5-.7,0-1.4-.4-2-.3.8,2,.7.9,1.4.9,2.5.3-.3,1.2-.5,1.6-.5,1.7.5,1.2,1,2.2h-2c-.3.2,2.3,3.5-.5,3.5,0-.2-.3-.4-.5-.5.4-.8,1.7,0,.5-1.5-.2-.2-.3-.2-.5,0l-3,.5c-1.2-2.6.7-2,1.3-3.2s.8-2.7.7-2.8-2.6-.8-2.9-1.1,0-1,0-1.4h.5c.9-.8,2.5-3.2,1.3-3.5-.6-1.2-.5-2.2.2-3,0-.3.5-.8.5-1.5,0-1.1-1.8-4.9-1-5.5s1.9.4,2.5,0q.2.2,0,0l-2-.5c-.3-2.2,2.7.3,2-2.5-.4-.5-2.3,1.6-3,1s.1-2.9,0-3c-.3-.3-1.9.7-1.5-1l4.5,1.5c.6-1.6-2.2-1.1-2.5-1.5s.7-1.1.5-1.4-2.7-1-.7-1c.8.7,2.6.7,3.3,1.2s-.2,1.1.5,1.7Z"
          fill="#0107ba"
        />
        <path d="M68.3,250.3h-.5l.3-.4c.2,0,.1.3.2.4Z" fill="#010bc3" />
        <path
          d="M65.8,235.8c-.3,2.6.9,3.5,2.5,1,0,.6.1,1.2,0,1.8-.2,1.2-2.9,2.2-2.5,3l3.5,1.5c-.6,1.5-4-.7-5-.7,2.2-1.9-1.2-6.1,1.5-6.5Z"
          fill="#0106b1"
        />
        <path d="M66.6,249.3c.3.2.3.3,0,.5v-.5Z" fill="#010bc3" />
        <path d="M70.8,225.3c0,.3,0,.7,0,1-.6-.4-.6-.5-1-1h1Z" fill="#010bc4" />
        <path d="M67.8,228.8c.2-.2.8.5.2.5s-.4-.4-.2-.5Z" fill="#010bc4" />
        <path
          d="M241.7,66.9c0,1.9-1.6,1.7-3,1l-1.2.8c-9,1.4-18,2.8-27,4s-1.9.1-2.8-.3c-2.6,1.1-5.3,2.1-8.1,2.9l-.9-.4-17.9,5.4c-1.3-.3-.7-1,.4-1.4l10.1-3.5c0-.5.5-.8,1.5-1,13.2-3.4,26.3-6.4,40-7.5,2.8-.2,6.5-.8,9,0Z"
          fill="#949ee4"
        />
        <path
          d="M192.8,74.4c-.4.6-.9.7-1.5,1-4.1,1.2-7.6,2.5-11.2,4.5s-1.6.2-2.3,0h-1c.7-.9,1.8-.7,2.7-1.1s.8-.9.8-.9c2.3-1.1,5.8-1.8,8.5-2.5.3-.4.6-.5,1-.5.3,0,.7,0,1,0l.5-.5c.2,0,.3,0,.5,0,.3,0,.7,0,1,0Z"
          fill="#2a43d5"
        />
        <path
          d="M174.8,80.4c-1.8,1.5-4,2.7-6.5,3.5-.2,1.4-3.3,2.8-4.5,2-1.1.7-2,.9-2.5.5-.4-.1-.4-.3,0-.5,3-1.5,4.5-2.7,8-4l.5-.5c.1,0,.3,0,.5,0l.5-.5c.2,0,.3,0,.5,0,.9-.2,2.4-.3,3.5-.5Z"
          fill="#1a33d2"
        />
        <path
          d="M177.8,79.9c0,.3,0,.6-.2.8-.2.4-7.8,3.6-8.7,3.7s-.4-.2-.6-.5c2.2-1.1,4.3-2.4,6.5-3.5.8-.1,1.3-.3,2-.5s.7,0,1,0Z"
          fill="#5b72e3"
        />
        <path d="M189.8,74.9c-.3,0-.7.4-1,.5l.8-1,.2.5Z" fill="#2039d6" />
        <path d="M190.8,74.9l.5-.5c-.1,0-.3.5-.5.5Z" fill="#2039d6" />
        <path
          d="M395.1,162.3c0,0,.7.1.9,0s-.5-4.9.4-4.9l.7,5c.5.5.2.9-.5,1q-.6,1.2,0,0c.3-.7.9-.8,1,0,1.5-.2.8.4,1,1,.3,1,.1,2.3,1.5,2-.2.3-.3.7-.5,1s-.4.3-.5.5c-.4.8-1.1.3-1-.5,0-.1.3-.9-.3-1-.8.6-3.1,0-3.2,0-1.9.4-4.6-1.4-2.5-3-.7-1.4.5-1.6,1.6-.6.2-.6.7-.6,1.4-.4Z"
          fill="#022be7"
        />
        <path
          d="M394.6,173.8c0,0,.1-.6.5-.5-.3,2,.3,1.2,1,1.5,1.3.7,1.6,1.4,1,2,.5.3,1,.3,1.5,0-.1-.7.5-.5,1,0,.9.3,3.9,1.7,2.7,2.5s-4,1.1-.2,1.5l-1,2c1.1-.4,2.2.4,1.5,1.5s-2.1,0-2.2-.1c-.9-.2-.3-1.8-1.8-1.4-.6,2.3,1.6,1.6.5,3.5l.9-1c1.2-.2,2.4-.4,3.6-.5.4.1.4.3,0,.5-.3.1-.7.4-1,.5-.1.4-.3.4-.5,0-.3.6-.9.6-1.5.5.6.5.2,1-.5,1l-.5.5c-.2.2-.3.2-.5,0-.8.2-.7-.3-.5-.2s.4.2.3.4c0,2.3-2.8-1.9-1.8-3.7-1.6.5-2.3-1.7-.5-2,.6-.6.9,0,.9,0-.6-.3-1.7-.8-1.4-1.5-.2,0-.4.1-.6.1-1.1-.2-2.1-3.7-2.4-4.6-.6,1.2-2.2,1-1.5-.5-1.2-1-.4-1.6,2.3-1.9h.7Z"
          fill="#0338ef"
        />
        <path
          d="M404.6,179.8c.3,1.5,2.1,3,3.7,2.8l-.2,1.2c-.4.8.3.8,2,0l1,.2c-1.5,2.3-3.2.8-5,.8s-.7.5-1,.5c-.4,0-1-.3-1.5-.5-.9-1.9,1-3.8-1.5-4.7.3-.8,2-.5,2.5-.3Z"
          fill="#032fe9"
        />
        <path
          d="M409.1,179.3c.8.9,1.1,3.9-.5,4.5-.1.4-.3.4-.5,0,0-.8-5.4-2-3.5-4,.9.4,1.9,2.3,3.5,2.5l.5-1.5-2.5-.7c.6-.2,1-1.7,1-1.7.2-.2,1.6.8,2,1Z"
          fill="#021de0"
        />
        <path
          d="M410.1,179.3c.2,1.4,0,2.8,0,4-.3.6-1.1,1.1-1.5.5,1.4-1.8,0-2.9.5-4.5.2,0,.7,0,1,0Z"
          fill="#032fe9"
        />
        <path
          d="M399.6,150.8c-.1.4-.3.4-.5,0v.5c.8-.7,1.1-.5,1,.5.4.2.4.3,0,.5.8.7-.1,1.8-1,2-.2.2-.2.3,0,.5.1-.4.3-.4.5,0-.2.7.6,3.9.5,4s-2.3-.3-2.5,1c1.9.4,2.9-.5,4.5-1v2.5c.7-.2,1.2-.6,2-.5-.4.4-1.2,1-1.3,1.1-.5.7,0,2.6-2.4,2.9.3-1.4.3-2.4-1.2-1,.2.2.2.3,0,.5-.1.4-.3.4-.5,0-.6-.2-1.2-.4-1-1l-.5-1c-1.3.7-2,.7-2,0-2,.3-2.3-1.3-.8-4.8-1.1-1.3,0-2.4,1.5-2,.5-1,1.3-1.6,2.3-1.7.7-.7.5-1.2-.7-1.4l.2-1.1c-1.3-.2-1.3-.6,0-1,0-1.5.4-1.3,1.5-.5.2,0,.3,0,.5,0,.5.1.3.6,0,1Z"
          fill="#0125e1"
        />
        <path
          d="M401.1,152.8c-.2.3-.3.7-.5,1s-.8.3-1,1h-.5c-.3-.1-.3-.3,0-.5.6-.9.6-1.1,1-2,.7-.6,1-.5,1,.5Z"
          fill="#0222dd"
        />
        <path
          d="M397.6,151.3c.3,0,1.4,1.4,1.5,1.8.2,1.1-.9.6-1,.7.2-1.7-.3-.9-1.3,0-.3.1-.4-.7-.7-1-.6-.2-1-.5-.5-1,.2-.1,1.8-.5,2-.5Z"
          fill="#0220dd"
        />
        <path d="M397.1,162.3c1.7-1.2,2.3,0,.5,1s-.9-.1-1,0c0-.1,0-.8.5-1Z" fill="#0111d4" />
        <rect fill="#0220dd" height="1.5" width="1" x="398.1" y="156.8" />
        <path d="M399.1,151.3s-.5,0-.5-.2c0-.3.4-.2.5-.2v.5Z" fill="#0220dd" />
        <path d="M399.1,154.8l-.5-.2c0-.3.5-.2.5-.2v.5Z" fill="#0220dd" />
        <path d="M401.4,159.8c.3.2.3.3,0,.5v-.5Z" fill="#0220dd" />
        <path
          d="M389.6,148.8c.8-1,2.7-.3.5.2.5.3,1,1.6,1.5,1.8,1.6.5,4.4-.3,3.5-2.5l.5,2c-.1.2-.4.3-.5.5-.8.3-1.4.7-2,1-.5.3-.8.3-1,0-2.1,1.1-.9,2.8-1,3l-2,.5c-1.3-.7-2.1-.2-2.3,1.3l-1.2.2c-.5.7-1.3.4-1-.5-1-.6-.9-.8,0-1.5-1.1-.1-2-.6-2.5-1.5-.7-.5-1-.9,0-1,.8-1.6,3-3.3,4-1.5-.2-.7-.1-.9.5-.5.7-.3,1.2-.9,1.5-1.8,1,.8,1.5.9,1.5.3Z"
          fill="#023fed"
        />
        <path
          d="M262.7,68.4c4.3,0,8.3.5,12.5,1,1.1.7,3.7,1.7,5,2l-1,1c-.9,1.3-5,1.2-5.5-.5-.6-.3-1,0-1.4.5l-7.8-1.4c-1.3-.3-4.1-1.5-5.3-2.1-.1-.2-.4-.4-.5-.5,1.3-.4,2.7,0,4,0Z"
          fill="#7c83de"
        />
        <path
          d="M273.7,71.9c.2.8-.1,1.3-1,1.5l-.3.6c-.4-.8-1.4-1-2.2-.6-.6,1.2-2.3.7-3.2,0-1.3.5-2.8-.2-4.3-2.4-.9-.7-1.3-.7-1.4-.1.5.3.9.5.5,1h-.5c-.4-.6-.9-.8-1-1-.2-.3-.3-.8-.5-1s-.3-.8-.5-1c1,.1,2,.6,3,.8,4.2.6,7.7.9,11.5,2.2Z"
          fill="#6c79da"
        />
        <path
          d="M244.7,66.9c-.5.6-1.4,1.6-2,2-.1.5-.6.7-1,.5-.4.3-.7.3-1,0-1.7,0-2.4-.6-2-1.5,1.4-.2,2.3-.9,3-1s2.1.1,3,0Z"
          fill="#7797ea"
        />
        <path
          d="M294.2,74.9c2.5.2,4,1,6.4,1.8,8.6,2.9,17.2,4.8,25.9,8.1l7.1,3.6c-.6-.2-1.3-.3-2-.5-.4.1-.9.2-1.3.3s-.8,0-1.2,0c-4.9-1.5-9.8-3.5-14.4-5.5-2.6.2-5.6-.7-7.6-2.3-2.1.2-4.3-.3-6.7-1.4-1.5,1.1-7.5-1.4-7.7-2s.2-.8.4-1.1c0-.5.4-.8,1-1Z"
          fill="#6d85e7"
        />
        <path
          d="M273.7,71.9c.8.3,3.9.1,5.5.5,2.6.6,1.9,1.1,2.5,1.5,1.1.8.9-.9,1-1,.9-.8.9.8,1.3.9,2.7,1.1,5.7-.3,8.8.6s-.4.3,1.4.5c.1,1.1,0,1.1-1,1-.3,1.1-3.7,1.3-4.8,1.2-1.8-.5-3.8-1-6-1.6l-.2-.6c-2.7.8-6.2.3-9.1-.4l-.4-1.1c.6-1.1-.6-1.7,1-1.5Z"
          fill="#6d84e5"
        />
        <path
          d="M339.7,98.4c.8-1,2.1,0,2.5,1,1.3.5,3.1.4,4.3,1.5l.5-1,4.3,3c-.8,0-1.6.6-2.5.5-.5,0-1.1-.2-.9-.6s1.9,2.2-3.1,0c-.8,1-1.3.8-1-.5-1.4.4-1.8.2-1.3-.6-2-.3-3-.9-3.2-1.9-1.3-.4-.7-1.6.5-1.5Z"
          fill="#326fe8"
        />
        <path
          d="M337.7,94.9c1.5.7,2.7,2.3,4.3,3l.2,1.5c-.7-.3-2-.8-2.5-1-1-.2-2.8-1.4-3.8-2.5-1.1.5-2,.7-2.7.5-1,.8-1.8,0-1-1-2.2-.5-2.7-1-1.5-1.5.2-.4.3-.4.5,0,.7-1.1,2-1.4,4-1,0,0,.4,0,.5,0,.4.8,1,1.4,2,2Z"
          fill="#4074e6"
        />
        <path
          d="M341.7,104.4c1.8-1.8,4.5-.6,3,1.5,0,.5.1.8.5,1,.1-.3.3-.3.5,0,0,2.8-2.5,2.5-3.4,0-1.8,0-3.3-.6-1.6-1.9-.3-1.1,0-1.3,1-.5Z"
          fill="#186aeb"
        />
        <path
          d="M344.7,102.9c.9,0,1.9.3,3,.9,1.2.5,1.8.5,2,0,.8.7,1.7,1.4,2,2.5-.4.1-.4.7-.5,1l-1.5,1-.6.4c-.6-1.5-2.2-2.1-3.9-2.4-.7.6-.9.4-.5-.5.6-1.2.4-1.8-.7-1.9l.7-1.1Z"
          fill="#186aeb"
        />
        <path
          d="M344.7,102.9c0-.4-.2-.9.3-1,1.2-.2.5.9,1.1,1,1.1.3,2.6-.6,2.7-.5s-.1.8,0,1c.3.6.9.4,1,.5,1.1,2.1-.5,2.2-1.2.5-.8.4-.4,2.1-2.3,1.5,1.3-2.4,0-1.8-1.5-3Z"
          fill="#2872ec"
        />
        <path
          d="M365.1,117.4c.5,0,1.6.7,2.5,0l-.5,1.5,2.5-.5c0,.5,0,1,0,1.5q-.8.8,0,0c.2,0,.3,0,.5,0,1.3.2,4.8.4,4.5,2-.1,0-.8-.6-1-.5s-.2,1-.8,1.5-1.1.1-1.3.3c-.8.7-.7,1.9-2,1.7-.2-.2-.2.3,0,1.5,0,2.7-4.5,1.9-2.5-.5-1.4-.4-1.9-.9-1.3-1.6-1.7,0,.2-1.8.3-1.7s-.8,2.2-1.5.7c.2-1.6-.7-1.3-1-2,1.8,0,2-2.6,1.5-4Z"
          fill="#0356eb"
        />
        <path
          d="M355.2,112.9c-1.1-3.2,3.6-1.4,3.5.5.9,1,1.3,1,2.7.6l.3.4c.3,0,.7,0,1,0l-1,1.3c1.6.4.2,1.1,1,2.2,0,0-.9-.5-1-.5-.6-.4-1.3-.4-2,0-1,.2-.5.5,1.5,1,.8.7,4.4,2,0,2.5-.7-.7-2.4-.8-3.7,0-.9-.5-1.7-1.5-2.3-3-1,.6-.8-.2-.5-1-1.2-.4-.8-1.4,0-2.1-.7-.9-.7-1.5.5-1.9Z"
          fill="#0560ed"
        />
        <path
          d="M349.7,108.4c0-.7.8-.7,1,0,.9-.2.3-.6,2-.5.4.2.6.6.5,1,1.1,0,1.6-.3,3,0,.2.5.3,1,.4,1.6,1.9.4,3.5,1.2,4.6,2.4,0,.2,0,.3,0,.5.1,1.1-2.1,1.2-2.5,0-.7-.9-1.4-1.3-2.3-2-.1.7-1.2,1.3-1.2,1.5h-4c0,0-.5-2-.5-2-.6,1.2-1.6.6-2.5,0-.1.4-.3.4-.5,0-1.2-1.1.3-2.6.9-2.2s-.8.9-.9-.3c-.7-.5-1.4-1-2-1.5-.2,0-.3,0-.5,0-.4-.1-.4-.3,0-.5.8.1,1.5-.2,2.5.3s1.2,1.5,2,1.7Z"
          fill="#0f65eb"
        />
        <path
          d="M361.1,113.4c0,.2.5.6.5,1-.7,0-1.8.5-2.2.4-.8-.2-.6-1.3-.8-1.4.9.3,1.7.6,2.5,0Z"
          fill="#0b58e3"
        />
        <path
          d="M402.6,185.8l-1,4c1.8.8,2.1-1,2.2-1,.7.3.8,2.7.8,3.5s-.6.8-.5,1.2.8.2,1,.7,0,.9,0,1.1c.3.8,1,.4,1.5.5.7-.6,1-.3.5.5-2.4.8-2.3.1-4-1.3,2.4-.7-.2-.9-.5-1.3-.8-.9,1-1,1-1.3.2-1.1-.2-2.4-1.5-2.2-.2,1.7.8,3.5-1.5,3,0,.9,1.1.3,1.7,1s.7,1.7.8,1.8c.1.4-.8,0-.9.5-.2.6,0,2.4-.6,3.3-.1,0-2.3,1-2-1,0-1.2,0-2.2.5-3.1-1.3-.3-1.8-.9-1.5-1.9.2-.5.9-.9,1.5-1,0-.5,0-.8-.5-1-.9-1-.5-3.4,1-3.5-.7-.4.2-1.9,1-1.5-.4-.4-.2-.7.5-1,.1,0,.3,0,.5,0Z"
          fill="#0235ee"
        />
        <path
          d="M399.1,191.8c1.3-.4,1.4.1.5,1l-1,1c-.8.7-1.1.4-.5-.5-.8,0-.8-.5,0-1.5,0-1.4.7-1.4,1,0Z"
          fill="#0235ee"
        />
        <path
          d="M412.6,197.8l-2.5-1c0,0,.4-.8.5-1,.6.4,1.9.5,2.3,1,.7.8-.2.9-.3,1Z"
          fill="#0113d5"
        />
        <path d="M407.1,196.3c-.2,0-.4-.5-.5-.5,1.3-1.6,3.2-.5.5.5Z" fill="#011ee2" />
        <path d="M417.6,204.8c0-.2.5-.4.5-.5l-.5.5Z" fill="#021bdb" />
        <path d="M413.1,188.8l-.5-.7c0-.3.4-.2.5-.3v1Z" fill="#011adb" />
        <path
          d="M405.1,185.3l.5,3-2.5-1c.2-.9,2.8,0,1.4-1.9s-.9,0-.9,0c0-.1,0-.4,0-.5,1.2,0,1.4.5,1.5.5Z"
          fill="#0120e3"
        />
        <path
          d="M410.1,183.3c0,.2,0,.3,0,.5-.6.8-1.6,1.1-2.5,1-.1-.4.5-.8.5-1h.5l1.5-.5Z"
          fill="#021bde"
        />
        <path
          d="M383.1,136.3c0,.7.2,1.5,0,2.2s-2,.9-.2,1.3.8-2.5,2.7-1c.4-.8-1.6-2-1-2.5s1.4-.2,1.4.2c0,.7-.4,1.3.6,1.8-1.8,2.3-.2,1.2,0,2s0,1.8-.5,2.5c-1-1.1-1.1-.9-.5.5.5.4.9.5,1.5.5-.5,1.1-1.6-.1-.5,2,.9.2,1.3.3.5,1-.1.4-.3.4-.5,0-.5.7-1,.7-1.5,0-2.8-.6-6.1-2.3-2-4.5q0-.9,0,0c-.2.5-1,.6-1.5.5l-1-.4c.7-1,.2-1.8-.5-2.6-.8.4-1.6.6-2.5.5-3,.9-2.7-1.1-.9-3.3s1-1,1.9-.2c.8,2,2.5.6,3.5-.5,0-.7.9-.8,1,0Z"
          fill="#0246ef"
        />
        <path
          d="M377.6,135.8c.9-.5,2.4-.6,3-.5.1-.4.3-.4.5,0-.9,2.9-1.3,1.3-2.5,1.5s-1.1.9-1.5,1.3l1,.3c-.2,1.5-1.8.3-2,.5-.7.6,1.4,1.4,1.5,1.5,1.2,1,1.2,2-.3,1.2-.5.6-.9,1.1-1.2,1.8,3.4,2.2-3.7,3.2-1.5-1l-1.2-.3c-1.8,1.4-3.1,1.8-3.8,1.3-.2.5-.8.7-2,.5.4.5.6,1,.5,1.5-.9,1.2-1.6,1-1.5-.5-.7-.5-1-.9,0-1-.7-1.6.9-2.6,4.6-3h1.4c-2-1.3,1-3.4,2.2-1.9l.3-.6c-1.4-.9-.8-2.9.5-3.5.4-1.3,2.3,0,2,1Z"
          fill="#0252f2"
        />
        <path d="M382.1,136.3c.1-.1-.3-.8.2-1,2.1-.7.8.9.8,1h-1Z" fill="#075fed" />
        <path d="M381.1,135.3h-.5c-.8.4-1,.2-.5-.5l1-.5c0,.3,0,.8,0,1Z" fill="#0339e0" />
        <path
          d="M387.1,146.8c1.2-1,1.6-.5,1.5,1,.3.3.7.7,1,1-.1.1.1.9,0,1s-.8-.5-1.2-.5-.3.8-.7,1-.9,0-1.2,0c-.1-.6-.4-.7-1-.5-3,2.1-2.9-2.8-.5-2,.4-.4.9-.7,1.5-1,.2,0,.3,0,.5,0Z"
          fill="#034bf1"
        />
        <path d="M386.6,145.8h2.5s-.5,2-.5,2c-.7-.8-.2-.8-1.5-1-.2-.3-.3-.7-.5-1Z" fill="#0325dd" />
        <path d="M385.6,143.3c-.8-.7-1.1-1.4-1-2.5h1s.5,2,.5,2c-.1.2-.3.3-.5.5Z" fill="#0228e0" />
        <path
          d="M369.6,124.9c.4.9,1.4,3.1,2.5,2.3-.3-.3-1.1-1.7-1-1.7,1.1-.9,1.3,2,2.2,2.5,1.1-.3,1.2-2.4,1.3-2.5s1.8.8,2.5.5c-.4,1.1.1,2.3-1.5,1.5-.6.5.9,2.9,1,3,.3.2,1-.9,1.5-1s.9.5,1.5,0c.1,1-.6,1.7-1,2.5-1.1.4-.4-.7-.2-.5s-2.8,4.4-2.3,2c-.5-.4-.6-.4-.5,0,.9.4,1,1.3,0,1.5,0,1-.5,2.1-.5,3.5-3.1,1.2-5.4-2.7-2.9-5.4h-.6c-.5,1.9-1.7,2.7-2.4.9-.1.4-.3.4-.5,0-.8-.9-.8-1.6,0-2,0-.8.4-1.5,1.3-1.3l.2-.7c.5,0,.4-.6-.5-1.5-.3-.6-.3-1.3,0-2-.4-.8-.6-1.6-.5-2.5h.5c0,.3,0,.8,0,1Z"
          fill="#024bec"
        />
        <path
          d="M378.6,131.8c0,.2-.4.3-.5.5-.4.5-.4,1.3-1.5,2,.5,0,1,0,1.5,0s.7,0,1,0l-.5.5c.3.7-.4.9-1,1-.4,0-1.2-1.1-2-1,0-.3,0-1.2,0-1.5.1-.4.3-.4.5,0l.5.5c-.3-1.5,1.1-1.8,1.8-3l.2,1Z"
          fill="#045df2"
        />
        <path
          d="M379.6,126.4c.6-.4,1.6-1.5,2-.2s-.8,0-.9.5c-.5,1.7,0,3.9-.1,5.3s0,1,0,1.5l-.5.7c.1,1.7-1.4,2.5-1.5.8.5-.3.4-.4-.5-.5.2-.7.2-1.4,0-2-.4-.4-.1-.6.5-.5-.2-.8-.4-1.6-.5-2.5,0-1.5.3-2.2,1.5-3Z"
          fill="#0339e0"
        />
        <path
          d="M384.1,130.3c0,.2,1.4.5.5,2,0,2.3-.3,0-1.5,0-.5-.5,2.1-.6,1-1.5s-1.5.4-2,.5c.2.7,1.1,1.9,1,2s-1.3.2-1.2,1c-.4,0-.2-.6-.2-1s.9-.7-1-1.5c.4-1.5,1.3-.5,1.5-.5-.4-1.4-1.2-3.3.2-4,1.1.9,1.5,1.3.5,2.5l1.3.5Z"
          fill="#0339e0"
        />
        <path d="M378.1,132.3c1.1-.3,1.1.7,1.5,1.5l-1.5.5c-2.7,1.7-2-1.1,0-2Z" fill="#022adb" />
        <path
          d="M380.1,134.8c0,.2.2.6.5.5-.7.6-2.1.7-3,.5.1-.4.6-1,1-1s.8.8,1,.5-.1-1.9,1-2c0,.2-.5.9-.5,1.5Z"
          fill="#023fe7"
        />
        <path d="M379.6,128.3c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#0645e2" />
        <path
          d="M394.6,244.3c-.5-2.7.5-3.6,2-.8.4.3,2.4,1.3,2.6.7l.4.7c1.4,1.3,1.7,2.3,1,3,.8.5.5,1.4-.5,1.5-.5,1.3-1.7,1-1-.5-.6-1.2-1.7-1.2-3.2,0-.4-.5-.8-.5-1.3,0q-.9.4,0,0c1.3-1.1,2.5-.7,2.5,1,.3-.2.3-.6,0-1-1.2-1.2,2-1.5,1.5,0,2,.5.1,3-1,2-.5.5-.6,1.2-.5,2.3l-1.5,1.2c-.1.5-.3.4-.5,0-.4.2-.6.6-.5,1,.2-.3.3-.3.5,0,.5,0,.7,0,.5.5.4-.2.6,0,.5.5-.1.5-.7.6-1.6.3v.7c1.7,3-3.1,1.3-4.4,1.5l2,2c-.1,0-.3.4-.5.5-1.7.5-2.6.1-2.5-1,0-.3,0-.7,0-1-.2-1.3-.5-1.6-1-1,0,0-.4.6-1.1.4s-1.4-1.1-2.4-.9c-.2,1.9,2.1,0,1.5,2.5.5-.2,1-.3,1.5-.5.4.1.4.3,0,.5-2.2.7-4.7.5-4,3-.2.7-.6.6-1,0-.4-.1-.4-.3,0-.5-1.4.4-1.5,0-.5-1,.1-.4.3-.4.5,0q.2.2,0,0c-.8-.1-1.7-.1-2.5,0l-.6.5c.5,1.1-.4,1.2-1.4,1-2.6-.8-2.3-1.7-.5-3.5l-.9,1c1.2,2.3-3.9,2.3-3.1.5-4-.4.8-6.3.5-2.5,0,.9,1.2,1,2,.5,1.5-2.5,3.6-1.3,1.5.5l.6-.6c-.4-.8-.4-1.3.4-1.9-.1-1.2.7-1.3,2.6-.3l.8-.3c1.4-1,2.6-1.6,3.6-1.9.6.2.6-.4,0-2,.3-.5.4-.9.5-1.5-.4-.7-.2-1,.5-.5,1.1-1,2.8-1.2,4,0,1.6,0,1.5.6,0,1-.4,1.6,1.4,1.1,2.5.5l-.3-1c-1.3-.3-2-2.4-.8-3.4-.4-1.5,1.2-2.9,2.6-3.1-.3-.1-.2-.3,0-.5Z"
          fill="#0339f0"
        />
        <path
          d="M382.6,251.3c1.6-2.7,4.6-3,3,1,.4,0,.4.3,0,.5-.1.4-.3.4-.5,0,.5,3.2-3.1,4.8-5.8,3.5l-1.2.5c0,1-.7,1.9-2,2.5-.5.8-1.6.4-1.5-.5-.6-.9-1.1-1.9-1.5-3-1.6-1.1.4-3.8,2-3.5,1.8-2,3.7-.5,2,1.5-.4,0-.2.4.5,1,.4-.4.9-.7,1.5-1-1.3-1.6,2-3.2,3.2-2.2s-2.1.2.3-.3Z"
          fill="#0339f0"
        />
        <path
          d="M402.6,253.8c.4.1.4.3,0,.5-.1.6,0,1.4,0,2l2-.5-1.5,1.5c.8,0,1.1.4,1.5,1-.6.1-1.4.5-1.5.5-.2,0-.3,0-.5,0l-.5-.5c-.3,0-.7,0-1,0,0,.5,0,1.1,0,1.5l.5,1c.5.1.4.3,0,.5-.9.7-.7,3.5-2.5,2.5s1-1.6,1-1.7c-.6-1.6-2.4-.7-2.5-.8s.4-1,.5-1.5c.2.1.9.6,1,.5v-1.5c2,1.2.5-.3.5-.5-.4-.2-.4-.7,0-1.5l.5-.5.4-.6c-.9-.2-.6-.9,1.1-1.9-.4.3-1,0-1-.5-.4-.4,0-.6.5-.5,1,0,2-.1,1.5,1Z"
          fill="#022fec"
        />
        <path
          d="M396.1,256.3c0-.7.3-1.2,1-1h2.2c1.1-.8,1.4.1.8,1l-.5.5-.5,1.5c-1-.5-2-.7-3-1-.2.4-.3.4-.5,0-.7-.1-.8,0-1,0-.9,0-1.9-.9-3.5,0,1.4-3.6,2.4-1.1,5-1Z"
          fill="#022fec"
        />
        <path
          d="M407.6,275.8c0-.1-.3-1.5.7-1s1.2,2.2.7,3.1-1.2,0-1,.9l2,.5-1.5.5c.9,1.4,2.3,1.2.5,2.5s-.4.5-.5.5c0,1-.8,1-1,0,0-1.7-.9-1.6-2.4.5h-1.1c1.6-1.8,3.2,1,1,2-1.2-1.3-.8-1.7-1-2s-2,1.8-1.5-1c.2.1.8.6,1,.5.3-.2,2-3.4,2.3-3.4s1.5.7,1.7.4-1.5-2.4.3-2.6l-.3-1.4Z"
          fill="#021ee0"
        />
        <path d="M399.6,256.8c0-.3.2-.5.5-.5,0,.3-.4.4-.5.5Z" fill="#0439ee" />
        <path d="M399.6,258.3h-.5c-.2-.8.2-1,.5-1.5,0,0,0,1.4,0,1.5Z" fill="#0439ee" />
        <path
          d="M401.6,253.8c.9.6-.3.8-1,1-.2.3,1.4,1.2,1,2-.5-.2-1-.3-1.5-.5s0-.4-.3-.5c-.8-.2-2.1,0-2.7-.5-.3-1.4,1.9-1.7,2.5-.5l.5-1c.4-.1.9-.1,1.5,0Z"
          fill="#0439ee"
        />
        <path d="M399.1,270.3c-1.7,1.4-2.9-.7-.5-1,.1-.4.3-.4.5,0,.6.2.8.9,0,1Z" fill="#022be8" />
        <path
          d="M395.6,257.3c0,.5.3.8.5,0,.9-1.3,3.1-.7,3,1,.1-.4.3-.4.5,0,2.9-.4-1,4.4-1.5,1.5q-.7-1.5,0,0c.7,1,1.2,1.1,1.5.4.5.8,1.2,1.1,2,1.1,2.1,2.2,2.3,3.6.7,4.4.5.4.8.9.8,1.6q.4,1.4,0,0c-.9-.7-.8-1.8.4-3.2l-.5-.8c-2.6-.8-.4-2.7,1.1-2,.9-.7,1.4.2,1.4,1.3s-.5-.9.6-.3c.6-.3,2.1-.8,2.5-.5s-1,1.3,0,1.5c-.5.3-.8.7-1.5.8s-2.1-.7-2,.2c3.9,1.6,2.5.3,3.5-.5s.7,1.7,2,.5c.2,2-1.7,2.7-1.6,4.8s1.2,1.5,1.4,1.9,0,.8.1.9c-.6-.4-1.2-1-2-1l-.5.5c-.2.4-.6.3-1,0-1.1.5-1.5,0-1-1.5l-1,.5c-.1.6-.4.9-1,.5-.3.5-.9.7-1.6.6,0,0,0,4.2-.4,3.9s0-2.4,0-2.5,2.8-.2,2.2,1.2c.3-.4,1.7,1,1.8,1.3.4.1.4.3,0,.5l.5.5c-.2-.8.4-1.1,1-.5,1.3,0,1.4.9,0,2.7,1.4,1.3.8,1.8-1.6,1.6-1.9,2.8-3.1,3.5-3.5,2.1-.1,1.7-.7,2.2-1.7,1.6-1.5,1.4-2.4,1.3-2.8,0,.3.8,0,.7-1,0-1.5-.4-1-1.7.5-1.5,1.1-.6,3.1-1.5,4-.5-.4-1,0-1.4,1-1,.2-.2.3-.2.5,0,.9,0,.6-.6-1.1-1.9-.7-.9-1.3-1.6-1.9-2.1-.6.3-1.3.6-2.2.9.5-.8.9-.7,1.2,0,1.2,1.5,1.4,4.4-1.5,4.5-1.8,1.2-4.3.8-4.3-1.9-.4-.7-1.6-.8-1.7,0,.4.1.4.3,0,.5.6.9-1.8,1-2,0-3-1.7-3.3-5.9,1.5-4,1,.2,1.5-.1,1-1-1,.7-.5,0-.5.1.4,1.1-10,1.1-6.5-1.5s3.7-1.7,3.4.3c.2-.2.2-.3,0-.5-1.9-2.5,2.2-8.1,4.2-2.8l.8.3c.8-.6,1.4.3,1.5,1,.9-2,2.4-3.1,4.5-2-.5-.9,1.5-.3,1.4-.3-1.4-.2-1.5-.2-1.9-1.7-.3-.1-.3-.3,0-.5.1-.4.3-.4.5,0,.5-.3,1,0,1,.5,1.5-.8-1.1-1.9-2.5-2,.5.5.2,1.2-1,2,0,2.1-2.4,1.4-3.5.5-2-.7.4-1.6,1.5-1,.7-.4,1-.9,1-1.5-.4,0-.7,0-.5.5.7.3.5.7-.5,1-3.4,1.1-4.3-1.2-1.5-3.3-2.6-2.2.4-4.7,1.5-1.7.5.6.8.6,1,0-.9-.6-1.5-1.5-1.9-2.5h-2.1c-4.5-1.3-2-3.6,1.9-2.7l.6-.8c0-1,.8-.8,1,0Z"
          fill="#022be8"
        />
        <path d="M397.1,268.8c.8-1.9,2.3-1.1,1.5.5-1.1,1.4-2.1,1.3-1.5-.5Z" fill="#022be8" />
        <path d="M399.1,277.8c-.9-.7-.6-1.2.5-.8s.1,1.7-.5.8Z" fill="#022be8" />
        <path
          d="M404.1,270.8c.4.1.4.3,0,.5,0,.4.4.4,1,0-.4-.1-.4-.3,0-.5.1-.4.3-.4.5,0,.5.6.8.9,1.5.5.3,0,.7,0,1,0,.1-.3.3-.3.5,0v1c-.8,2.4-1.6,3.4-2.5,3-1.3-.8-3,0-2.5-2-2-.5-.3,1.8-.5,2-.3.3-4.1,1.2-4-.7,1.6-.1,3.5.6,3-1.7l-2,1c-.4-2.1.6-1.3,1.6-2s.3-.8.5-.9c.2-.1,1.1.1,1.9-.1Z"
          fill="#021ee0"
        />
        <path
          d="M400.1,276.8c1.1.7,3.2,2.9,3,4-.1,0-.4,0-.5,0-.6.1-1,.4-1,1-1.5.9-2.3,1-4,.5.9-1.6,2.4-1.5.5-3.5.7.3,1.5-.4,1-1,.1.1.5,0,.5-.2,0-.5-.7,0-.5.2-.2-.2-1.4.7-1.5.5l.5-2c.8-.3,1.4.3,2,.5Z"
          fill="#0227e6"
        />
        <path
          d="M404.1,261.3l-2,1c2,.3,2.1,1.9,1.5,3.5.8.4,1.8-1.3,2-1,.4.5-1.2,2-1.3,2-.3,0-.9-.6-1.1-.4s0,.8,0,.9c-.5.5-4.4-3.5,0-2.5.6-1.5-1.8-1.2-2-1.5s.6-1.2.5-2,0-.5,0-.5c.5-.4,1-.8,1.5-1,.6.2.7,1.1,1,1.5Z"
          fill="#0221e2"
        />
        <path
          d="M391.6,280.3c0-.3,0-.7,0-1h2c.6,1.5-.5,3.1,1.7,3s.2-1.8,1.3-1-.6.5,1,1c-.2.4-.6,1-.5,1.5-1.1-.1-2-.6-3-1l-.5,1.5c-.7-1.2.6-4.6-2-4Z"
          fill="#0223e4"
        />
        <path
          d="M400.1,276.8c.4,0,1-.2,1.4,0s.3,1.3.7,1.8,2.9,1.4,1.9,2.6-.9-.5-1-.5l-2.3-3-1.2,1.5.5-2.5Z"
          fill="#011ddf"
        />
        <path
          d="M398.1,266.8c.2-.3-.5-1.3.7-1s4.5,3.2,1.8,3l-1-.5h-.5c-.2-.6-.5-1.1-1-1.5Z"
          fill="#021fe1"
        />
        <path d="M391,272.4c.1,0,.8,1.5,1.1,1.9l-2.5.5,1-1c0-.1-2.3-3,.4-1.4Z" fill="#033ef2" />
        <path
          d="M395.2,278.7c.2.1.9-.6,1.4-.4s1.7,2,1.6,2.4l-2-2-.7,1.5c-1.1-1-2.2-1.6-1-3,.5.2.6,1.4.8,1.5Z"
          fill="#0223e4"
        />
        <path d="M403.1,277.8c.8,0,3-.9,3,.2s-2.7,1.2-3-.2Z" fill="#011ddf" />
        <path
          d="M405.1,270.3c0-.5-.8-2.2-.5-2.5,1.1-1.1,1.1,1.7,1.5,2,.4.2.2.5-.5,1h-.5c-.5,0-.4-.2,0-.5Z"
          fill="#0116d1"
        />
        <path
          d="M399.1,268.8c1.3.9.6,2.1,2.5,1,.4,1.7-.9.8-2,1,0-.2-.3-.4-.5-.5v-1c0-.2,0-.3,0-.5Z"
          fill="#0218d9"
        />
        <path d="M396.1,257.3l.5,2.5c-.9-.3-1.3-1.4-1.5-2.2l.5-.3c.2,0,.3,0,.5,0Z" fill="#0439ed" />
        <path d="M403.1,267.3c1.5.5.7,1.4.5,2.5-1.5-.5-.7-1.4-.5-2.5Z" fill="#021ddc" />
        <path d="M402.6,280.8c-.2.5-.6.7-1,1-.6-.6-1.3-1.3-.5-1.8s.9.5,1.5.8Z" fill="#011ddf" />
        <path
          d="M391.6,280.8c0,.3.7.9.5,1-.7,0-1.6.2-2.2,0s-.2-.7-.3-1c.2,0,1.4.8,2,0Z"
          fill="#0223e4"
        />
        <path
          d="M395.1,268.3c0,0,.3-.7.5-1-.1-.5,0-.6.5-.5.1.2,1,.5,1,.7,0,.7-1.5.7-2,.8Z"
          fill="#0119dd"
        />
        <path d="M395.6,267.3l-.5-.3c.4-3.2.8-.6,1-.2-.1.2-.4.3-.5.5Z" fill="#0441ec" />
        <path d="M398.1,259.8c-1.2-.8-1.7-1.6,0-1.5,0,.5,0,1,0,1.5Z" fill="#0439ed" />
        <path
          d="M406.1,269.8c.2.2,1.1-.3,1,.2-1.5.3-1.6,1.4,0,1.2-.2,0-.9,1.1-1.5-.5l.5-1Z"
          fill="#0225e2"
        />
        <path d="M396.1,263.3c0,.3.5.6.5,1-1.2,0-1.7.3-1.5-1,.3,0,.7,0,1,0Z" fill="#0641ee" />
        <path
          d="M405.1,270.8c0,.2,0,.3,0,.5-.4.8-.8.9-1,0v-.5c.3,0,.7-.4,1-.5,0,.2,0,.3,0,.5Z"
          fill="#0225e2"
        />
        <path d="M400.6,268.8c-.4,0-.9,0-1-.5,1-.7,1.1-.8,1,.5Z" fill="#0232ec" />
        <path d="M390.4,279.8c.3.2.3.3,0,.5v-.5Z" fill="#0223e4" />
        <path d="M406.6,276.3c-.5,0-.4-.1-.5-.5l.5.5Z" fill="#021ee0" />
        <path
          d="M408.1,284.3c-.2,1.4,1.5,1.2,2.5,1.5-.4,1.1-2.2.9-2,2.5h-3c-.3-.7.5-1.5.5-2-1.3-1.8-.6-2.2,1.5-2,.1-.4.3-.4.5,0Z"
          fill="#021ee0"
        />
        <path
          d="M410.1,289.3c-.3.1-1.5,2.1-2.4,1.4s.3-1.1-.5-.9c.3,2.1-.5,1.2-1,1.5-.2-3.3.6-1.2,2.5-2.5s1.6-2.5,2-.7-.5,1-.5,1.2Z"
          fill="#021ee0"
        />
        <path
          d="M411.1,282.8c0,.3,1.2,3.4-.5,2s.4-1.5-1-.5c0-.3,0-.7,0-1,.5-.5.4-1.3,1.2-1l.3.5Z"
          fill="#021ee0"
        />
        <path
          d="M408.6,282.8v.5c.3.2.3.3,0,.5-.1.2-.3.4-.5.5h-.5c-1.4-.1-1.4-1.1,0-1.5.3,0,.8,0,1,0Z"
          fill="#0210d0"
        />
        <path d="M408.6,283.8v-.5l.5.3c-.1.2-.4.1-.5.2Z" fill="#021ee0" />
        <path d="M405.1,271.3c-.4,2.5-2.9,1-2.5.5.7.2,1.1-.4,1.5-.5s.7,0,1,0Z" fill="#022be8" />
        <path
          d="M404.1,283.3c-.2-.4,2.5-3.3,3.8-3,1.1,2.5-.1,2-.3,2.5s0,1,0,1.5-.8.7.5,2c-1.7.4-1.4-.5-2.3-1.5-.3.4.3,1,.3,1.5-.6-.2-.7-.7-1-1,.6-2.6-.9-1.9-1-2Z"
          fill="#0227e8"
        />
        <path
          d="M401.1,243.8c-2.6,1.1-2.2-3.5,1-2,.1-.4.3-.4.5,0,2.3-.6,2.6.6,2.9,2.5l2.6.5v.5c-1.5.5-1,1.2-3.5,0,0,.3,0,.7,0,1,.5.2,1.1,0,1.5.8.1.3-.7.4-1,.7.4.4.2,1.1-.5,1-1.9,1.8-2.1-2.9,0-2.5-.4.6-1.1.9-2,1,0,.4,0,.6-.5.5-.4.9-1,.8-1.5,0-.3-1.3-1.5-1.3-1-3,0-.5.3-.4.5,0,.6-.2.9-.5,1-1Z"
          fill="#022feb"
        />
        <path
          d="M400.1,249.3c.4-1.1,1.2-1.2,1.5,0,.3,1,1,.7,2-.7l1,.7c.6-.4.8-.2.5.5-.2.2.5,1.2-1,1-.3.4-.6.5-1,.5-.7.8-2,1.2-3,1.5-.2.4-.8.4-1,0-.5.1-1-.2-1.5-1-.8,0-.8-.8,0-1,.8-.6,1.1-.8,1-2,.2-.4.3-.4.5,0,.2,0-.2.4,1,.5Z"
          fill="#022feb"
        />
        <path
          d="M404.1,250.8l.5,1c0,.6-.2,1.1-.5,1.5-.1,0-.3,0-.5,0,.2.7-.4.8-1,.5l-1.5-1c.2-.5.9-1,2-1.5,0-.2,0-.6,0-.9.2-.2.7.4.9.4Z"
          fill="#011bde"
        />
        <path
          d="M409.6,246.8c.6.7-.3,1.2-1,1.5-.5,0-1,0-1.5,0v-.5c1.7.2.3-2,2-2.5.6.2.1,1.1.5,1.5Z"
          fill="#022feb"
        />
        <path d="M404.6,251.8c2.4-1.3,1.9.2-.5,1.5-.8-.9-.4-1,.5-1.5Z" fill="#022feb" />
        <path
          d="M408.1,255.3c-.4.1-.9.6-1.5.5-.6-.6,2-2.9,2-1.7,0,.5-.4.9-.5,1.2Z"
          fill="#0115da"
        />
        <path
          d="M405.6,248.8c.4,1.9,0,.4-.5,1-.3,0-.4-.2-.5-.5-.5-.2-.5-.3,0-.5,0-.2.3-.8.5-1h.5c.8.3.8.7,0,1Z"
          fill="#0216d9"
        />
        <path d="M405.6,247.8c1.5-.3,1.5,1.3,0,1,0-.3,0-.7,0-1Z" fill="#022feb" />
        <path d="M403.6,253.3l.5,1h-1.5c0-.2,0-.4,0-.5s.8-.4,1-.5Z" fill="#0439ee" />
        <path
          d="M409.1,241.3c.4.9.3,1.2,0,2-.5,1.4-3.7.4-3-1-.5-1.3,1.5-2.4,2.5-1.5.1.2.4.4.5.5Z"
          fill="#0217df"
        />
        <path
          d="M418.6,238.8c.7.6.4.9-.5.5,0,0-1.5-.6-2,0s.5.7.4.9c-.2.4-1.8.3-1.4,1.6,1.7.4.4-1.4,2-1,0,2.1,2.4,2.2,2,4.5-2.5,1.1-2-1-4.5-1.5,0,3.3.3,1.3,1.5,1.8,2,.8,2.2,3.5-1,1.7-.8,2.9,2.7.7,3,1s-.1,3.5,3,2c-.9,1.8-.5,1.2,1,2l-1,1.5-.5-1.5c-.4,1.2-.2,2.9-1.5,3.5-.2.4-.8.4-1,0-.3-.1-.7-.7-1-1q.6-1.9,0,0c-1.4-1-3.8-2.1-2.5-3.5h-1.5c-.1-.5.5-1.2.5-1.5.3-.2.5-.6.5-1-.2-.8.4-2.2-1.2-1.5s-.3,2.5-2.2,1c0-.2-.2-.6-.5-.5.2-.8,0-1.1-.5-1-1.1.1-.9-.8-.5-1.5-.2,0-.8,0-1,0-.4-.1-.4-.3,0-.5-.3-1.1-.1-1.3,1-1.5-1.3-.4-.6-1.3,0-2,0-.3.2-.6.3-.6,1.5,0,1.5,1.4.7.3s0-.4,0-.7l-.5-.5c-1.3-.3-1.3-.7,0-1,.4-1.7,3.9-1.9,5.5-1h1.5c0,0,1.4-.5,1.5-.5.2-.4.3-.4.5,0,.8,0,.8,1.3,0,1.5Z"
          fill="#0224e5"
        />
        <path d="M409.6,246.8c2-2,2.2,0,.5,1s-.6.4-1.5.5c.4-.4.6-1.1,1-1.5Z" fill="#021ddf" />
        <path d="M414.1,248.8c0,.4,1.4,1.2-.5,1,0-.4-1.5-2.3.5-1Z" fill="#030ecc" />
        <path
          d="M409.6,238.8c0-1.2.8-2.2-1.5-2l1.2-2,1,2.5c.3-1.6,4.2-1.1,4.7.5l-5.5,1Z"
          fill="#011dde"
        />
        <path
          d="M417.1,254.8c-1.2-.8.4-3.3,1.2-4,1.3,1.1,1.7,3.1-.5,2-1.2,1.8,1.6.1,1.2,2-.5,0-1.8.2-2,0Z"
          fill="#0117dc"
        />
        <path d="M418.6,237.3c.3,0,.7,0,1,0,.3,2.1-.4,1.2-1,1.5v-1.5Z" fill="#011dde" />
        <path d="M414.1,240.8l.2-1.5c.9.7.8,1.1-.2,1.5Z" fill="#011dde" />
        <path d="M410.1,240.3c-.2,0-.4-.2-.5-.5.2.1.3.4.5.5Z" fill="#011dde" />
        <path
          d="M422.1,224.3c.3,0,.5-1,.8-1,.7,0,1.4,1.4,2.7.5.3,1.6-1.1.7-1.9,1.8s-.7,1.5-.5,1.7c1.7.9,2-.2,3.5-.5.6.6-1.9,3-3,2.5-.4-.1-.9-.6-1.5-.5-.3,2,2.2,0,1.5,2.3s-1.2,0-1,.7c1.4,0,2.2-.5,2,1-2,1.4-1.1,2.3,2.5,2.5,0,.1,0,.3,0,.5.6.3.7.8.5,1.5.9,0,.8.7,0,1-2.5-.2-2.9-1-4.5,1.8.4.9,1.3-.2,1.5-.3.1-.8,1.3-.8,1.5,0,.2,0,.3,0,.5,0,.9,0,.8.7,0,1-.2,0-.4,0-.5,0-.3-.1-.3,0,0,.5,0,.2,0,.3,0,.5-.1.4-.3.4-.5,0h-1c.5,1.7,0,3.6-2,3.5.2.7.4,1.3.5,2,3.3-3.7.6,0,2.5,1.5.4.1.4.3,0,.5l-2.5.5c-.8-.2-.8,0,0,.5,0,.6-.4,1.4-.5,2-.1,0-.4,0-.5,0,0,.6-1.8.2-2,.1-.5-.3-2.4-2.3-2.9-2.9-2.9,1.4-4.1-3.3-1.1-2.8-5-1.2-2-5.7,2-2.1-.8-1.3-1-1.7-2.2-1.8-4.5-.4,1.4-6.5,2.2-3.4v.5c1.1-.8,1.7-.8,2,0,1.6,0,2,1.9.5,1.5-.3.7,0,1.4.8,2-.8.6-1.4,1.2-.3,1.5.9-.2,1.4,0,1.5.5l-1.5-.5c-1.5.4-.2-2,.5-2-.4-.9-.5-2.2,0-3l-1.1-.5c-1.3.6-1-2.4-.8-2.4,2.7.5,3.1-1.6.4-1.1,1.1-1,2.4-.2,1.5,1s-3.9,0-1.5-1c.2,1.2-.4,1.5-1.7.8l-.3.7c.4,1.3-.8,1.5-1.5.5-2.6-1-.2-2.9,1.6-3.3s-.7.8-.1-.2c-1.3-.5-1.1-1.3.7-2.4-.5-1.8-.3-2.9,1.3-3.9.3-1.4.7-3.1,2-3.7Z"
          fill="#011dde"
        />
        <path
          d="M423.1,250.3c-1.9,1.3-.4-1.7-2.3-1.3s-.8,1.1-1.7.8l.2-2.5c.8,1.2,3.4,1.2,3.8,2.5s0,.3,0,.5Z"
          fill="#0224e5"
        />
        <path d="M426.1,240.8v.5c0,0-.8-.2-.5-.7l.3-.3c.3.1.2.5.2.5Z" fill="#021edd" />
        <path
          d="M420.1,235.8c.4-.2,1.4-2,2.5-2l-1,1c2.3,2.7-1,2.5-1.5,3-1.2,1.1,1.8,1.1,2,.7-.3.3-.5.9-.5,1.3.1.7-.4.7-1.5,0-1.7-.2-2.6,1.3-2.5-.2l.5-.3c.2,0,.3-.4.5-.5.6-.5.6-1,0-1.5-.2,0-.4,0-.5,0l-.5-.3v-.7c.7-.1,1.9-.2,2.5-.5v1c.7.2,1-.2,1.5-.7l-1.5-.2Z"
          fill="#0227e6"
        />
        <path
          d="M422.6,245.3c-.9,0-1.1-.4-1.5-.5.2.2,1.3-.7,1.5-.5,0,.3,0,.7,0,1Z"
          fill="#0228e5"
        />
        <path
          d="M420.6,241.3c.8-.5,1,.7,1,1.5.1,0,.7,0,1,0,.6.4-2.3,1.1-1.5,2,0,0-1.1.8-1.5-.3s1.4-.4,1-1.5-1.1-1.1-1.2-1.8h1.3Z"
          fill="#0228e5"
        />
        <path
          d="M421.6,239.8c0,.7.8,1.9,0,3-.4-.3-.9-1-1-1.5s1.3-.7-.5-1.5c.5,0,1,0,1.5,0Z"
          fill="#0113d5"
        />
        <path d="M422.1,247.8c-1,.1-1.1,0-1-1l1,1Z" fill="#0224e5" />
        <path
          d="M412.6,214.8c2.2,0,2.3,1.3.5,2.2l2,1.3c.4.1.4.3,0,.5-.1.1-1-.3-1,.2.6.7,2.3,1.6,2.8,2.2s-2,1.2.7,2.3c0,.9-2.9.2-3,.3s.5,3,.5,3.5c-2.8-1.5-1.8,2.4,1,1l-1,1c.4.1.4.3,0,.5.5,1.8-2.1.8-2.6,0-1.8.5-5.7.7-5.4-1.5-1.7,0-3.6-.4-1.5-1.5-.6-.7-.3-.9.5-.5l.2-.8c1.4,0,2.7.3,3.8.8.7-.8,1.4.1,1.1.6-.5-1.1-.5-2.5,0-4.1-1.4-.2-1.4-1.1,0-1.5-.1-.6-.5-1.3-1-2-.8-2.3-.5-4.2,2.5-4.5Z"
          fill="#022ae9"
        />
        <path
          d="M415.1,213.8c0,0,.6.5,1.2,0s0-1.5.5-1.6c1.6,0,.4,1.3.2,2l2-.5c-1.5,1.2,1.4,2,.5,3s-1.2-1.2-1.5-1c-1.4,3.6,1.4,1.8,1.5,2,.2.3-.7,1.4-.5,1.5.3.2,2.1-.5,2,2l-1,2.5-1.5.2c.8,1.4,2.3-.5,2,1.3l.5-1.5c.4-.1.9.5,1,.5-.4,1.1-.7,3.2-1.1,4.2s-2,.9-1.3,2.6,1.7.3.9,1.2-.7-.8-1-.1.1.8-.1,1.1c-.5.5-1.5-.7-1.4,1.1-.7,1-2,1.7-3,.5-.7,0-1.2.1-1.5.5,1.3,1.7-2.9.9-3.1-1.3s2.7-3.1,3.1-2.7c1,1,2.2.6,3.5-1-.6-.3-1.3-.7-2-1-1-.1,1-1.1,1-1,.1,1.6-6.2.6-2.3-2.6l-.2-1.8c2.5-1.9,2.5-2.2,0-3.9-.7-1.7.3-2.5,1.5-1.2.6-.5,1-.7,2-1-.2-.2-.2-.6,0-1l-.9.5c.3.9-.1,1.2-1.1,1-1.5,1.3-3.6-.9-2-2.4l-.5-1c-1.7-1.5,1.8-2.9,2.5-1Z"
          fill="#0220e2"
        />
        <path
          d="M417.1,230.3c.2.4,1.1,1.4,1,1.5-3.3-1.7-2.1,2.7-4,1.7,1.2-1.7-.7-.9-.5-2.2v-.5c.8-.4,1.6-.5,2.5-.5.3-.8.7-.7,1,0Z"
          fill="#0331e9"
        />
        <path
          d="M417.1,216.8c-.2.4-.2.8,0,1-.1,1.3-.3,1.2-1.7,1.4l-.3-.4c0,0,0-.4,0-.5.5-.7.7-1.1.5-2,.9,0,1.1-.3,1.5.5Z"
          fill="#0213d5"
        />
        <path d="M417.6,225.8c.3,1.6-.2,1.5-1.5,2-.2-1.2.2-2.1,1.5-2Z" fill="#0330ed" />
        <path d="M415.1,234.8c-.8.5-.9.3-1.5.5l-.5-.3v-.7s2,.5,2,.5Z" fill="#010ecc" />
        <path d="M415.1,229.3c2.6-.4,1.6.3,2,1-.3,0-.7,0-1,0-.8,1-1.2.7-1-.5v-.5Z" fill="#0210d9" />
        <path d="M417.1,217.8l-.5-.3.5-.7c0,.1,0,.7,0,1Z" fill="#0e4ee9" />
        <path
          d="M409.1,213.8c.5,0,1.6-.9,2.5-.5l-1.5,1.5c.8,0,1.7,0,2.5,0-2.5,1.6-1.9,1.4-2.5,4.5-.1.3-.3.3-.5,0-1.3,0-.5-1.1-.5-1.1.8.7-.8,1.9-1.5.6-.9.3-1.1.1-.5-.5,0-.2,0-.7,0-1-.4-.6-.1-.8.5-.5l.4-.5c-.6-1.7-.3-2.5,1.1-2.5Z"
          fill="#011ee2"
        />
        <path
          d="M409.1,213.8c-1.2,2.5.2,1.8.4,2,.7.9-1.1,1.6-1.9,1-1-.5-2-1-3-1.5-.4-.1-.4-.3,0-.5-.7-1.6,1.1-1.9,2.5-1.5.5,0,1.4.5,2,.5Z"
          fill="#0230ee"
        />
        <path d="M410.6,206.3c0-.2.3-.4.5-.5l-.5.5Z" fill="#032eeb" />
        <path
          d="M407.1,228.3c1,1.8,4.5.3,5.7.6s.6,1.2.8,1.4,1.1-.5,1.4-.4.6.4,1,.5l-1,1.5c-.9-.3-.1-.6-1.5-1s-1.2.5-2.4,1.5c-3.2,2.8-1.9-1-2.2-1.4s-1.5-.8-1.9-1.1c-.2.4-.3.4-.5,0l-.5-.5c-.4-.1-.4-.3,0-.5l.5-.5c.1-.4.3-.4.5,0Z"
          fill="#0220e2"
        />
        <path
          d="M377.6,312.8l.4.4c0,1.2,0,2.4,0,3.6-.8,2.4-1,1-1.7,1.2s-1.1.9-1.3.8,0-.9,0-1c-.4-.1-.4-.3,0-.5,1.1-2.1.5-3.2-.3-.6l-1.2.6c-.3-.1-.7-.4-1-.5v-.5l.5-.5c.3-.8.3-1.7.8-2.5.7-1.3.8.3.9.3,2.3,1.1.4-1,1.4-1.3l.3.5c.4,0,1.1.1,1.2,0Z"
          fill="#0223dc"
        />
        <path
          d="M406.6,296.3v-.7c.5,1.1,1.6-.7,1.9-1.5,2.3-1.8,2.9-.6,1.7,3.4,3.5,1.1,1.9,2.9-.7,4v.8c.9,1.6.9,4.1,2.1,5l-.5.5c.4.1.4.3,0,.5-1,0-2.2-.2-3.1.1s-.9.8-1.4,1.1-1.4.2-1.4.3q0-1.6,0,0c-1.2,1.1,1.4.9,1.5,1-1.5,1.4.1,1.9-.5,3.5l1.2-1,.2,1c.7,1.6-.8,1-.7.9,1.5-1.5,4.2,1.9,1.7,2.1-1.2-.5-2.3-.3-3.5-.5l1-.7c-1-.9-1.7-2-2.9-2.6s-1.5,0-1.6-.1,0-2.1-1-1,.9.9,1,1c.3.2,1,2.6-.5,2v.5c1.1-.2,1.2-.7,2,0-.6,0-.4.4-.5.5.7.7.4,1-.5.5-.4-.3-.6-.3-1,0-.1,1-.6.9-1,0,0-.2-1.5-2-2-1.5,0,1.1.8,2.1,1,2.7s-1,.1-1,.5c0,.8.8,3,2,2.8.3.7-2,.4-1,1.5s3,.4,2,1.5-1.7,0-2.3-1c-.7-.2-.6.4-.7.5-.3,1.1-2.4,2.8-2,1-.7-.7-.4-1.5.9-2.6l.6-1.4c-.4-.3-.6-.3-.5,0,.6.9-.5,2.5-1.5,2-.7,0-1.4-.4-.5-1-.3-.2-.6-.1-1,0,1.4.5-.8,2.8-1,1-.4-.1-.4-.3,0-.5-.2-1-.7-.8-1.5.5,0,.8-.9.9-1,0-.9-1.3-1.3-3.4.5-4,.2-.3.4-.6.8-.8.7-.4,0-2.2-.3-3.1s0-.3,0-.5c-.4-.1-.4-.3,0-.5.4-2.9,1.6-4,3.5-3.5.3,1.3.6,1.6,1,1,0-1.5,2.6-4.3,3.7-3.3s-1.5.3-.7-.7c0-.7,1.1-1.2,1.5-.5.5-.3.4-.6,0-1-2.2.6-2.7.3-1.5-1,.2-3,2.1-1.5,3,.5,1.7-2.5,3-2,5,0,1.6,1.5,1.9,1.3.9-.8.8-.7.5-1.6-.9-2.7-.3-.3-.4-.8-.3-1.5-2.4-1.3-3.1-2.5,0-2.7l-.3-.3c-1.3-.4-1.3-.6,0-1Z"
          fill="#0223dc"
        />
        <path
          d="M394.1,306.8c1.8-.3,2,1.3,1,2.5-.7-2.6,3.3-4.5,3.7-1.7s-2.7,2.9-3.2,2.7c-.2.4-.3.4-.5,0-.9-.2-.9-.7,0-1-1.6.9-2.6,2.1-3.2,3.8-3-1.7-3.5-4.9.7-4.3,0-.6.3-1.1,1-1.5-.7-.9-.4-1.2.5-.5Z"
          fill="#0223dc"
        />
        <path d="M403.6,316.8c-.7.7-1,.4-.5-.5v-.5c.4.4.3.6.5,1Z" fill="#0223dc" />
        <path
          d="M398.1,324.7l-1.7,1.5c-.6-.6-1.3-1-1.2-2,.6-.8,1-.6,1,.5,0,0,.1.5.2.5s1.2-1.1,1.8-1.5c0,.3,0,.7,0,1Z"
          fill="#0435e0"
        />
        <path
          d="M401.1,316.8c.3-.4.7-.3,1,0-.1.1,0,.6-.5,1s-.7.5-1,.5c-.7,0-.7-.4-.5-1,0-.1,0-.4,0-.5.3,0,.7,0,1,0Z"
          fill="#0117c3"
        />
        <path
          d="M407.6,314.3c3.4-1.4,1.9,1.7,2.5,4-.5,0-1.4-1-1.5-1l.5-1c-.9-.2-1.5-1-2.5-.5-.2-.8.3-1.2,1-1.5Z"
          fill="#0113cd"
        />
        <path
          d="M407.1,301.8c2.5.9,1.6,1.5,2,3.2s1,.3,1,.4c.2.2-1.7,1.3,0,2.5-1.9,0-3-.5-3-2.5-.9-.2-1-.8,0-1-1-1.1-1.2-2-.5-2.5.1-.4.3-.4.5,0Z"
          fill="#0119d6"
        />
        <path
          d="M407.1,304.3c0,0,0,.7,0,1-1,.3-1.6-.9-1.7-.9-1.2-.2-2.4.7-3.3.9v-1c.3,0,.7,0,1,0,0-.1-.3-1.7-.5-2,.2-.5.6-.4,1-.5.1-.4.3-.4.5,0,.7-2.3,1.7-1.2,1.8.8.6.5,1,1,1.2,1.7Z"
          fill="#021ddc"
        />
        <path
          d="M405.1,309.8c-.2.2-1.1-.1-1.5,1.3,1.2-.5,1.6,1.1,1.2,2.2-1.6-.8-1.8-1.9-2.7-3.2.4-1,2.3-.6,2.5-.8s-.7-1.8-.5-2c1.3-1.1,2.1,1.8,2,2s-.6.2-1,.5Z"
          fill="#0116d2"
        />
        <path
          d="M406.6,297.3c.2.2,1.2-.4,1,.5l-2.5.8c1.3.9,2.4,1.3,2,3.3h-.5c-1.2-.5-2.6-1.3-2-2.5,0-.3-.8-1.3-.5-2h2.5Z"
          fill="#021ddc"
        />
        <path d="M397.6,317.2c-.5.6-3.3,0-3.5-1,.8-.6,4.7-.5,3.5,1Z" fill="#022ce5" />
        <path
          d="M397.6,320.8c.2,2.4-1.8,2.1-1.5,4-.3-.1-.7-.4-1-.5,0-.3.5-.7.5-1-.3-.1-.2-.3,0-.5.9-.4,1.4-1,1.5-2,.1-.4.3-.4.5,0Z"
          fill="#022bde"
        />
        <path d="M397.6,320.8h-.5c-3.1-.4.2-3,.5,0Z" fill="#0216cb" />
        <path d="M400.6,305.8c.3.1,1-.3,1,.3,0,1.7-.9.7-1,.7,0-.3,0-.9,0-1Z" fill="#053be6" />
        <path d="M402.1,316.8c-.3,0-.7,0-1,0,.1-1,1.3-.3,1,0Z" fill="#011cd5" />
        <path d="M411.6,307.8h-.5c.1-.2.3-.3.5-.5v.5Z" fill="#011cd5" />
        <path d="M395.1,321.7c-.3,0-.9,0-1,0l.7-.5.3.5Z" fill="#022bde" />
        <path d="M393.1,322.2c-.5,0-1,.3-1.5.5-.2-3.2,2.6-3.3,1.5-.5Z" fill="#0126e1" />
        <path
          d="M387.1,288.3c.7,1.1.1,2.3,0,3.5.3,0,.7,0,1,0h.5c.3,3.2-1.6.3-2.7-.1-1.5-.7-1.9,1.3-1.9,2.4s2,.9,1.1,1.7-1.2-.7-1.5-.5.1.8,0,1l-.5.5v.5c-.5-.1-1.1-1.1-1.7-1-1.5.3-.1,2.4-.3,2.5-.2.1-3.2,0-4,.5-.4-2.1,1-1.8,2.5-1.5-.5-1-.2-1.7-1.5-1.5l-1,.5c-.1,0-.3.6-.7.5l-.3-.5.3-1.2c-1.4-1.3-1.4-2.8.7-2.3.7-2,2.1-1.6,1.5.5.5.3,1,.3,1.5,0,.2-.7,0-.7-.5,0-.1.4-.3.4-.5,0-1.6-1.5-1-2.1,1-2.3v-.7c-.4-.1-.4-.3,0-.5,0,0,.4-.4.5-.5.5-.3.8-.3,1,0,0,.7-.7,1.6-.5,2.5.1.2.8-.5,1-.5.7,0,.7-.1,0-.5.1-.6-.1-1.5,0-2,.9-1,1.8-.7,2.8,0l.2-.4c.1-.4.3-.4.5,0l1-.5c.2-.4.3-.4.5,0Z"
          fill="#0230eb"
        />
        <path
          d="M398.1,291.3l-.5,1.2c-.5-2.3-1.1.3-1.5.5s-1.5.3-2.5.8c-2.6.4-3.6-2.8-.5-1.5,3.3,1.2,1.4-1.2,4-2,.3.3.5.8,1,1Z"
          fill="#021cdd"
        />
        <path
          d="M384.6,287.3c0-.1-.2-1.8,1-1s-.1.8.2.9,2.2-.3,2.8-.4c-.5.8-.7,1-1.5,1.5s-.4,0-.5,0l-1,.5h-.5c-1.5.3-1.5-.7-.5-1.5Z"
          fill="#053eed"
        />
        <path
          d="M402.6,282.3c.3.6.9.8,1.5,1,.6.4.9,1,1,2,.3-.2.6.1,1,1,.9.7,1.7,1.4,2.5,2v.5c.1,1.3-.4,1.5-1.5.7-.3.4-.6.9-1,1.8-.4.2-.6.3-1,.5-1-.2-.8-1.1-1-1.5-3.7-.1-1.5-2.8,0-.9s0,.8,0,.9c.4,0,1,.2,1-.3l-1.5-3.2c.6-.4.6-.6,0-.5-.2,0-.7,0-1,0l.5,1c-2.4-.5-.7,1-1.8,1.5-2.1,0,1.7-1.2-.5-1s-2.7,2-.2,2c.2.3-1,1.3-1.5,1.5,0,1.3-.6,1.3-1,0-1.2.5-1.7.4-1-1l-1,.2c-1.6,2.2-2.8,2.3-3.8.3-1.2-.6-2.6-.2-4.2,1-1.6,1.9-2.3-2.1-1-3.5-.1-.6.4-1.1,1.5-1.5-2.2-2.3-2.3-3.3-.5-3-.1-.5,0-.9.5-1,2.2-2.3,2.6,1.6,2.4,3.8,1.7,1.6,0,.4.1.2,1.1-1.4,2.5,0,3.4,1l.5-.5c-1.1.1-3.9-1.6-3.8-2.2,0-1.6,1.7-2.2,2.2-.6.3-.2.5-.4.7-.3,1,.2,3,.6,3-.4.5,0,1.3-1.4,1.7.5.5-.5,1.1-1.1,1.7-1.3,1.1-.4,1.8,1.3,1.5-1.2.6,0,.5.5.5.5Z"
          fill="#0227e6"
        />
        <path d="M403.6,286.3c2.7-1,2,.8,0,.5v-.5Z" fill="#021ee0" />
        <path
          d="M391.6,280.3c1-1.3,1.8-.6,2.3,1.9l1.2.5c.7-.8,2,0,2,1.1,0,.2.7.3.8.8.7,2.2-1.3,3-1.9.2-.8-.2-.2.9-.7,1-1.4.2-2.7-2.4-3.2-.8s3,2.1,3,2.2l-.5.5c-.3,0-1.5-.5-1.8-.7l-.7-.8c.2,1.3.9,2.5-1,2.5-.2-.2.3-1.5-.3-1.5s.2,1.2-.7,1l-.2-5.5h-1.3c-.2-.7.2-2.9,1-2,.1.6,1.3,1.1,2,0,0-.2,0-.3,0-.5Z"
          fill="#022de8"
        />
        <path
          d="M388.1,291.8l2.3-2.5c1,1.1,3.1-.1,3.2,0s-1,2.5.3,2.5,1.9-2.5,3.2-1.5c-.5,1.5-2.9,4.3-4,2-1,.3-2,0-3-1-.2.2-.4.3-.5.5-.3,0-.7,0-1,0s-.3,0-.5,0Z"
          fill="#0232ea"
        />
        <path d="M399.1,287.3l-1.7,1c.3,2.5-1.1.2-1.7-.7l3.5-.2Z" fill="#0232ea" />
        <path d="M395.6,289.3c-1,.1-1.1,0-1-1l1,1Z" fill="#0232ea" />
        <path d="M394.6,287.8l.5-.5c0,.4-.1.5-.5.5Z" fill="#0232ea" />
        <path
          d="M390.1,291.3c1.5-1.3,1.4.4,3,1-2,0-1.1,1.2.5,1.5-.3.1-.8.4-1,.5-.3-1-2.2-.2-2.5-.5s1-1.8,0-2.5Z"
          fill="#0225e1"
        />
        <path d="M392.6,294.3c.2.5-.1,1.4,0,2-2.7-1.1-1.6-1,0-2Z" fill="#031ad4" />
        <path
          d="M385.6,297.8c.4,0,1.7.3,1.5-.5-2.4-.3-.9-1.5-1-2.7s-1.7-.5-1-1.8c1.4-.3.8.3,1.2,1.1.5,1.1,1,2.3,1.3,3.4s0,.7,0,1c-.7.4-1.1,1.3-2,.5-.4,0-.4-.3,0-.5v-.5Z"
          fill="#0338ea"
        />
        <path d="M383.1,296.8c.1-.2.4-.3.5-.5l-.5.5Z" fill="#022ce5" />
        <path
          d="M385.6,298.3c0,.2,0,.3,0,.5s0,.3,0,.5c-.3,0-.7,0-1,0v-1.5s1,.5,1,.5Z"
          fill="#0211cd"
        />
        <path d="M387.1,316.8c2,.1,1.6,1-.5,1,0-.5.1-.7.5-1Z" fill="#0114d2" />
        <path
          d="M380.1,311.8c.5.7.8,1.3,1,2,1.1-.2,1.9.5,2.5,2-.2.7-.8.9-1.5,1,0,1.1,1.7-.2.5,1.5-.3.1-1.4-.1-1.5,0-.7.8,1.4,1.5,2,1.5l.5-.5c.2-.1.3-.3.5-.5l.5-.5c.2,0,1.6.6,1.5.7-.5,1.1-1.8,0-2,.3-1,1,2,1,1,2s-1.4-1.1-2,.2c1.7,1.5-.4,3.9,3,3.2l-1.3-1c0-2.2,3.4-.2,3.8-.5-1.6-2.4,2.5-2.4,1-.2.6.9.9-.2,1-.3.3,0,.7,0,1,0,.3-1.1.8-1.6,1.5-.5v.5c-.9.5-1.9.8-2.5,1.8l1,.7h-2s1.5,1.5,1.5,1.5c0,0,0,.7,0,1v.5c1.2,1.9-1.5,1.9-2.5,0-1.6.9-1.6,2.1,0,3.4-1.3,1-1.5,1.4-.6,1.1.2-.3.3-.3.5,0,.1-.4.3-.4.5,0,.4-.7.7-.8,1-.5,0,.3,0,.7,0,1-2.6-.6-1.2,3.1-2.3,4-1,.2-.5-.6-.7-1.5-.5-2.1-.4-.5-1.5-.5.3-1,.1-2.8.5-4-2.2.8-5.3-.5-4-3-1.6.9-1.6,1.2-.5,2.5l-1.5.3c.6.6,1.6.7,1.5,1.7h.5c-.3-1.6,1.2-1,2-.2s-.2.8-.5,1.2c.5-.5-.4-1.6-1-1s.5,1.5,1,1c-1.8,2.7.2,4.3,0,4.5-1,1-2.2-4-3.5-1l1.5,1-2.5.5c-.3-1.6,1.4-2.8-.5-3.2l1.5-1.7c-.8.4-2.8,1.2-3.4,1.6s.1.5-.1.9c-.9-1-2.3,1-2-1.2s3.1-.7,3.5-.8c-1.4-1-.4-3.4-.6-3.7s-.9-.2-.9-.5c0-.7.4-.5,0-1.7-1.2.4-1.4,0-.5-1,.8,0,.4-.4-1-1-.9-.3-1.5-1.3-.4-1.6-.8-1.4-.6-2.2.4-2.4-.4-.1-.4-.3,0-.5l1-.5c-.3-1.4,0-1.5,1-.5.2.9.5,1.1,1,.5-.6-.7-.4-1,.5-.5.7.2,1.3.7,2,1.5q.6-.7,0,0c-1.1-.8-2.2-2.1-2-3.5-.8.2-1-.5-.5-2-.7-1.1-1.4-3-.5-4-1.4-.6,0-2.3,2-2,.6,0,.7.5.5,1Z"
          fill="#0232e4"
        />
        <path
          d="M383.1,313.3c-.3.6.5,1.3.5,1.5s0,.8,0,1c-1.5.2-.5-1.7-2.5-2,.6-.2,1.5-.3,2-.5Z"
          fill="#0114cd"
        />
        <path
          d="M388.6,328.2c0,0,1.3-.2,1.2-1l.3,1.5c.7.2.9-.5,1-.5,1-.2,1.1,0,1,1,0,0,.2.7-.3,1-1.3,1-1.3-.6-1.7,2-.3.1-.7.4-1,.5-.7-.6-1-1.2-.8-1.8-1.9-.7-1.2-1.8.3-2.7Z"
          fill="#022bde"
        />
        <path
          d="M388.1,332.7c-.5.8,1,1.2-2,.5l2-2c-4.2-1.4.1-3,0-3.3l-2-1.2c1.7-.1.2-2.2,3-1.5l-.5,3c-.1.3.1,1.1,0,1.5l-1,.2c1,.7,2.4,1.2,1.5,2.8-.2,0-.4,0-.5,0-.2-.2-.4-.2-.5,0Z"
          fill="#0122da"
        />
        <path d="M379.6,329.7c0,1.5,1.3,3.5-1,3.5.3-1.5-1.3-3.5,1-3.5Z" fill="#0227dc" />
        <path
          d="M380.6,322.2c1.2.8,1.3-1.1,0-1.8.7.2,1.9-.3,2-.2.1.1-.1,2.7.5,3.5-.8.2-.3-.6-.6-.8-.5-.3-1.2-.2-1.8-.7Z"
          fill="#0123dc"
        />
        <path d="M383.1,325.2c-1,1.2-3.1-.6-3-.7.7-1.7,3.3.4,3,.7Z" fill="#0220dd" />
        <path d="M382.1,334.2c.8.8-.7,2.3-1.5,1.5s.7-2.3,1.5-1.5Z" fill="#022bde" />
        <path
          d="M378.6,318.8c.6.7,1.3,3,2,3.5-.6-.4-1.4-.5-2-1.5-1-1.7,0-1.6,0-2Z"
          fill="#0124db"
        />
        <path d="M378.1,321.2c0,.4.1,1.4,0,1.5s-2.3-.6-1-2c.2,0,.7.4,1,.5Z" fill="#0228db" />
        <path d="M375.1,326.2c1.5,0,3.1,1.1,1,1-.2-.3-1.1-.4-1-1Z" fill="#022ad8" />
        <path d="M378.6,328.2s.2,1.1-.2,1c-1.4-.8-.3-1.6.2-1Z" fill="#022ad8" />
        <path d="M379.1,322.7c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#0238e5" />
        <path d="M383.1,319.8l.5-.5c-.1,0-.2.5-.5.5Z" fill="#022ce5" />
        <path d="M388.6,332.7c-.1,0-.4,0-.5,0l.2-.5.2.5Z" fill="#022bde" />
        <path d="M384.1,318.8c0-.3.3-.5.5-.5-.2.2-.3.3-.5.5Z" fill="#022ce5" />
        <path
          d="M281.7,417.7s0-.6.5-.5c0,1.2-.2,1.7.8,2.4,1.5,1,2-.4,2.9-.4s.2.7.4.8c.7.3,1.3-.2,2.1,1.2s.1,1.2.3,1.5c.9,0,1.5.2,2,.5,0,.2,0,.4,0,.5-.4.5-.7.6-1,0-1,.3-1.8.6-2.5,1.5,1.5,1.4.2,4.6-1.5,3.5-.1.4-.3.4-.5,0-1.7-1.8-2.5-1.5-4.5-2.3,2.3,0,1.2-1.2,1.5-1.7.3-.4.3-.5,0-.5-2.4,2.3-2.1-.5-4-1.5.2,1,.7,2.8-1,2.5.6-1.5-.3-2.4-.5-4-2.4-1.5,0-5.1,1.5-2,.7-.4,1.7-.9,2.5-.5q.5.4,0,0c-.3-.4,0-.7,1-1Z"
          fill="#022c7f"
        />
        <path
          d="M276.2,409.7c1.7-.3.9,1.9,2,3s1.5.6,2,1.3l-1.5.3c-.2.2.7.4.5,1.5l-1,1c0,.2,0,.3,0,.5,1,.9,1,1.5,0,2-.5-.1-1-.3-1.5-.5,0,.8,0,1.7,0,2.5h-.5c-.5.3-.6.8-.5,1.5,0,.2,0,.3,0,.5,0,1.5-.9,1-2.5-1.5-.6-.6-1.7-.5-3.1.3l-.4-.9c-2.5,0-.3-4,1-4.9-2.1,0,0-2.9,1-1.5,1,.1,1,.6,0,1,.6.4,1.3.3,2-.5-1.2-1.7-.6-4.2,1.9-2.8-1.1-.2,0,3-.1,2.8-.6-1.9-.7-2.9.6-4.2-.6-.7-.6-1.1.1-1.3Z"
          fill="#02348c"
        />
        <path
          d="M273.2,421.7c1,.7,1.1,1.2.5,1.5-.1.7-.5.9-1,.5-4.5.6-2.1-3.7.5-2Z"
          fill="#02348c"
        />
        <path
          d="M294.7,416.7c.9.3,1,.8,0,1,0,.3-.4.7-.5,1-.3.6-1.2.6-1.5,0v-.5c.8-.7,1-1,1.5-2,.4-.3.6,0,.5.5Z"
          fill="#02368d"
        />
        <path d="M289.2,395.7c1.7-1.1,2.2,1.8,0,1.5l-.5-.5c-3.4-.8-.2-3.6.5-1Z" fill="#023290" />
        <path
          d="M308.7,387.7c-.6.3-2.2,3.3-.5,4,.2,1.9-1.5,1.1-2.7.1,1.1,2.3-1.1,3.9-2.8,2.4.6.7-.9,1.2-1.5.5-1.7-.7,1.5,2.1,2.8,2.9l-.3,1.1.7.7c2.1-1.6,3.1,2.5-.4,1.9-.9.8-1.7.9-2.3.4l-2.8.2c-.5-.3-.8,0-.7.8,1.9-.4,3.4-.4,2.9,2.1s-.4,1.8-1.9,1.4c-.4.2,0,.5,1,1,.7-.2,1.4-.2,1.3.5,0,3.2-8.4,2.1-4.3-2-1.4-.4-1.8-1.2-1.3-2.5-1.6,1.2-7.7.7-5.9-1.7s.8-.3,1.2-.3l-1-.5c-1.8.4-2.8,0-2.8-1.2-1.7,1.4-5.2,1.1-2.6-.7-.2-2.1,2.7-4.1,3.5-2-.3.7-.1.9.5.5h.5c1.8-1.3,2.7-.6,2.7,2l.3,1c1.7-1.1,2.5-.9.6.4s-.3-.1-.6-.4c-1.4-1.6-.8-2.6,1.5-2.5.7-.4,1.2,0,1.7.5s-1.5-.3-1.7-1c-1.4-.7,0-3.1,1.3-3.8-.3-2.3,7.5-8.3,5.7-2.7q-.7,1.1,0,0c.7-1.1.5-2.7-1-2.3v-.7c.1,0,.6.2.9,0s.1-1.6.9-1.9,0,.7.4.8c.5.3,1.2,0,1.7.3s.9,2.7,1.1-.6c.8.4,1.1.8,2,.7-.6.7-.2,1.9-1.5,1.8,0,2.4,2.1.5,2.2-.7s-.9-2.1.2-2.8l1,2.5Z"
          fill="#023290"
        />
        <path d="M293.7,397.2c.4.2.4.3,0,.5-2.5,1.4-1.6-3,0-.5Z" fill="#023290" />
        <path
          d="M296.7,385.2c.5,0,1,0,1.5,0-.9,1.3,0,.9,1,1.7-1.9,1.3-1.8,2.3.5.7,1.6.8,3,1.4,1,3,.2-5-2-.2-2.5.2s-3,.8-2,2.3.9-.7,1.5-.8c2-.3,2.9,1.5,1.3,1.3-2.9-.5-1.2.8-1.3,3.1-1.9-.9-1.2-4.5-3.5-1l1.5.5c-2.1-.3-1.6.7-2,1s-1-.3-1,.2.8,0,1,.2c-.3.8.7,1.5-1.5.5v2s-.7.1-1-.3c-.6-.8.2-2.3-.7-2.7l-1.2,1.5c0-.4.1-1.2,0-1.5,1.1-1.1,0-1.1,0-1.5-.9-.4-1.2-.6-1-1.5-.6-.3-1.3-.8-1-1.5,0-1,.8-1,1,0,.6-.5,1.9-.6,2.5,0h.5c-1.3,0-1.8-.4-1.5-1-.3-1.2,1.6-3.3,3-3,.9-1.4-.8-5.3,3-1.2l-1.2.2c1.4,1.4,2.4.1,1.6-1.4s-1.3.2-.9-1.1c.5,0,1,0,1.5,0Z"
          fill="#02389a"
        />
        <path
          d="M293.7,397.2c.2,0,2.3-.2,2.5.3l-1,1.7c-.7-.2-.9-1-1.5-1.5,0-.1,0-.5,0-.5Z"
          fill="#02389a"
        />
        <path d="M289.2,397.2c0,0-.4,0-.5,0-.4-.1-.4-.3,0-.5,0,.2.4.3.5.5Z" fill="#02389a" />
        <path
          d="M301.7,401.7c-1.2.5-2.4.5-3.5,1-1.1-.6-.8-.7-.5-2-1.7,1.4-4.7.8-2.1-.5s2.1.3,2.1-1.5c1,0,.2,1.4,1,2.3s2.3-.2,3,.7Z"
          fill="#023b97"
        />
        <path d="M292.2,400.2l1.5-1c-.1.5-.4,2.4-.5,2.5-1.1,1.2-.9-1.4-1-1.5Z" fill="#053f9c" />
        <path d="M299.2,406.2c1.5-.3.8.5,1,1-1.3,0-2.3.5-2-1,.3,0,.8,0,1,0Z" fill="#012473" />
        <path d="M300.2,399.7c-1.1-.3-1.1-1.6-1-2.5.3-.6,1.2,1.8,1,2.5Z" fill="#022c82" />
        <path d="M300.7,390.7c0,.5,0,1,0,1.5-1.1.5-1.4-.9-1-1.5s.9,0,1,0Z" fill="#054a9f" />
        <path d="M302.7,398.7c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#022c82" />
        <path d="M288.7,397.2c-.9.4-1.4,1.2-.5-.5.1,0,.3,0,.5,0v.5Z" fill="#075daa" />
        <polygon
          fill="#023b97"
          points="301.2 402.7 301.2 404.7 300.7 404.7 300.2 402.7 301.2 402.7"
        />
        <path d="M302.9,401.2c.3.2.3.3,0,.5v-.5Z" fill="#023290" />
        <path
          d="M288.7,425.7c.8,0,3.7-.9,4-.5s-.6,2.6,1,3v1.5c-2,.6.3-2.1-1.2-1.5s-2.2.9-2.3,1c-.3.3.5.9.5,1,0,.3,0,.7,0,1-1.4,0-2.6-.3-4-.5-1-.3-1.2-1.7-1.5-2h.5l1.2-.3c1.8,1.7,2.4,1.3,1.8-1.2,0-.3,0-.5.1-.5.2-.1.8-.2,1.1-.2s-1.4.4-1.3-.3c-.4,0-.4-.3,0-.5Z"
          fill="#012682"
        />
        <path
          d="M296.2,424.7c.9.3,2.6,1.1,3.3,1.7s.1.8.2.8l-3.5-.5,2,.5-2,1c-.5.5,1.9,2.3.2,2.5s-2.2-1.2-1.7-2.5c.6-.8.6-1.1,0-1-.5-.2-1.5-.1-1.5-1,.7-.7,1.3-1.2,2-1.5.3,0,.8,0,1,0Z"
          fill="#012a7b"
        />
        <path
          d="M299.7,427.2c0,0,.7-.1.9,0s-.4.7-.4.9c-.5,0-.5.6-.5,1-2.4.3.2-1.8,0-2Z"
          fill="#012a7b"
        />
        <path
          d="M287.2,425.2c.1-1.2.3-2.3,0-3.5,1.7,1.2,0,2,2.5,2,.4.1.4.3,0,.5-.3,0-.8,0-1,0-.3.1-.6,1.3-1.5,1Z"
          fill="#022f86"
        />
        <path
          d="M296.7,414.7c.6,1.9,2,.2,2.7,1,1.5,1.6-1.3,2.7,1,4l.2-2.5c.4-.3,2.2.8,2.5.5s-.8-1.5.3-2c1.5-.2.2.6.2,1,0,2.4,2.3,1.4,2.4,1.5s1.2,2.4,1.1,3c-.4.5-.9,2,0,1.7,2.8,1.4,0,3.7-1.5,1.8-1.6,0-2.7-.3-.5-1.2l-1-2.3-1,1-1.5-1.5-.2,2c-1.8-.4-.5-1.4-1.7-2-1.1,2.7,1.3,3.2,1.5,3.8s-.5.6-.5.7c-.2,1.1-.6,1.3-1,.5l-.5-.5c-1.6-1.2-2.6-1.4-3-.5-.2.9-.7.9-1,0-.7.7-1.4,1.2-2,1.5.4.6.8.8,1.4.3v.7c.8.2.2.7-.4,1-.1.4-.3.4-.5,0,.1.4-1.3.1-1.7-.1s-.4-1.4-.3-1.9c-1,.2-2,0-3-.5-.4-.2-.4-.7,0-1.5.1-.5.7-.4,1,0l1-.5c-.4-.1-.4-.3,0-.5-.9-.3-1-.7,0-1,.2,0,.4,0,.5,0,.8.4,1.5,0,2-1,1.2-.5,1-.8,1.1-.9.3-.1,1,.5,1.4.2s.3-1.6.5-1.8,2.1.5,2.5,0-.5-1.4-.5-1.8,1.2.2,1-.7l-2.5,1c-.9-.7-1.7-2.3,0-2.5Z"
          fill="#012d81"
        />
        <path
          d="M306.2,426.7c0,0-.2.6-.5,1l-.2-.5c-.2.2-.5.3-.8.5-1.2-.6-.6-3.1,0-2.5s.6,2.4,1.5,1.5Z"
          fill="#012372"
        />
        <path
          d="M307.2,421.2s.1.6.5.5l.5-1c-.7,2.9,1,1.4,1,1.5.2,1.1,0,1.1-1,1,2.1,2.7.6,1.5-.3,2.1s-1.6,1.3-1.7,1.4c.2-.2-.4-1.5-.5-2,.8,0,1.7,0,2.5,0-.8-1.6-3.2,0-2.5-2.5h1.2s-1.7,0-1.7,0c-.4-1.4,1.2-1.1,2-1Z"
          fill="#012372"
        />
        <path d="M293.2,421.2c.5,2.2-1.5,3.6-2,1,.5-.2,1.2-.7,2-1Z" fill="#012578" />
        <path d="M290.7,422.2c0,.3,0,.7,0,1-.8,0-1.7.3-2-.5.7-.2,1.3-.3,2-.5Z" fill="#012578" />
        <path d="M295.2,424.7l-1,2-1-.5c0-.1,1-1.9,1-2,.4-.3.9.5.9.5Z" fill="#021c6a" />
        <path d="M306.7,420.7h-2c-.5-2.2,2.5-.4,2,0Z" fill="#012372" />
        <path d="M294.7,427.2c.2,0,.7,0,1,0,0,.6-1,.9-1,1h-.5l.5-1Z" fill="#012682" />
        <path d="M290.7,423.7c-.5,1.5-.9.5-1,.5v-.5c.3,0,.7,0,1,0Z" fill="#012578" />
        <path d="M299.7,425.7l-.5-.5c.2.1.4.5.5.5Z" fill="#012779" />
        <path
          d="M301.2,394.7c.7.1,1.4.3,2,.5,1.4.6,1.9,1.2,1.5,2,0,.1-.8.7,0,2l-1-.5c-.4-.4-.9-1.3-1.3-1.5-1.6-.7-.8,1-1.7,1l1-2c-.8,0-2,.8-2.5-.3s2.5.5,1-1.7c.6-.2.9.5,1,.5Z"
          fill="#022c82"
        />
        <path
          d="M302.7,394.2c0,0-.8-1,.3-1.5,1.8.1-.9,1.5,1.5,2-.4-2.3.5-1.2.7-1.5s-1.9-1.8-1.4-2.9,1.3.3.4-2.1c1.1.2.9,2.3.5,3l1.7-1,.8,2c.1.2.8-.5,1-.5.9,0,2.4.5,3.5,0l-.5,1c-.1,0-.3,0-.5,0-.6.8-.8.6-1.5,0-1.2,1.7-4.3,4.5-6,2.5-1.1,0-1-.2-.5-1Z"
          fill="#022c82"
        />
        <path
          d="M309.2,392.7l.5.5c-1.4.2-2.1.8-1,2l.5.5c0,.3,0,.7,0,1,0,0-.1.6-.5.3-.8-.7.2-1.7-2-.8l-.2-1-1.8,2c0-.3-1.5-.6-1.8-1s.3-.8.3-1c4.4-.4,3.5-1.6,6-2.5Z"
          fill="#02388d"
        />
        <path d="M303.2,395.2c-.8,0-1.6.9-2-.5.4,0,1.4-.3,1.5-.5.5,0,.5.6.5,1Z" fill="#02388d" />
        <path d="M306.7,391.7c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#023290" />
        <path d="M307.2,393.2c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#023290" />
        <path d="M309.2,395.7c-.2-.1-.3-.3-.5-.5.2,0,.4.3.5.5Z" fill="#022f86" />
        <path
          d="M284.2,403.7c.2-1,.6-1.4,1.3-1.7-1.9-2.3,1.5-3.2,3.2-1.3,1-.2,1.9,0,2.5.5,0,0-1,1.2.8,1.8s5-2.8,5.2,1.2l-1.5.5c1.8-.2,1.2.1,1.5,1-1,.4-4.8-1.2-5-1-1.1,1.2,1.3,2.3,2.5,1.5.6,1.1-1.7,1.7-2,1.5q-1.6-1.2,0,0c1.3.5,1.4,1.5,3,0l1,5-2-3.3-.3,1.8c-1.4-1.1-1.3-3.6-3.4-3s-.6,2.6-1.6,0c-.1.6-2.7,2.3-1.5,2.5s1.1-.9,1.6-1c.7,0,2.1.5,3.2,0v2c-2.4-1.1-1.8.2-3,2-1.1-.3-.5-1.9-2-1.5.9,1.2-1.2,1-.5,3l-.5-2c-1-.2-1.3.9-2.3,1s-1.7-1-1.7-1c-.2-.3,1.3-1.3,1-1.5-1.4-1-2.5,2.8-3.5,2s-.3-1.8-.5-2c-1.3-1.4,0,1.9-1.5,1h-.7c-.1-1.1-.6-2.2-1.3-3-1.8-.3-1-1.4.6-2-.8-1.1-.5-1.9.9-2,.7.2,1.7.5,3,.9,0-1.1.5-1.7,1.5-1.9.4-.5,1.1-.8,2-1-.6.5-.9.5-1,0-2.1-1-.2-3.4,1-1.5-1.8.5-1.7-1.3,0-1.9s1.7,3.6,0,1.9c1.1,0,1.1.4,0,1.5Z"
          fill="#023592"
        />
        <path
          d="M292.7,407.7c-1.3-.5-2.5,0-1.5-1.5-1.3-.9-2.1,2.5-2.5.3,2.6-2.7,3.7,1.1,4,1.2Z"
          fill="#012e85"
        />
        <path
          d="M282.7,403.7c.2,0,.3,0,.5,0,.3,0,1,0,1,0-.5.4-.7,1.3-2,1,0-.2-.4-.7-.5-1,.3,0,.7,0,1,0Z"
          fill="#02257f"
        />
        <path d="M286.2,403.7c.1.9,0,1.7-1,2v-2s1,0,1,0Z" fill="#021e76" />
        <path d="M279.7,408.2s.2,1.1-.2,1c-1.4-.8-.3-1.6.2-1Z" fill="#023ca1" />
        <path d="M281.7,410.2c1,0,.5,1-.3,1.5l.3-1.5Z" fill="#022f86" />
        <path
          d="M281.2,395.7c.4.1.4.3,0,.5v.5c1,1.5-1.2,1.9-2.5,2-.1.3.3,1-.2,1-.4,0-.2-.7-.7-1-.6-1.2-1.3-.8-2,1-1.1,1.3-2.8-1.8-1.6-2.7,1.3.2,1.9-.1,1.7-.9,1.2-.4,2.4-.6,3.8-.5,1.2-1.4,1.7-1.4,1.6.1Z"
          fill="#0242aa"
        />
        <path
          d="M281.2,396.7c0,0,1.4,0,1.5,0,.8,1-2.8,1.5-1,3.5-1.7.5-1.4-1.3-3-1.5,1.1-2.6,1-.8,1.9-1.1s.4-.8.6-.9Z"
          fill="#013198"
        />
        <path
          d="M282.7,393.2c1.5,0,3.3-.6,2.2,1.5l-.5-1-.7,2c-.1,0-.4,0-.5,0-.6-.3-.9-.8-1-1.5-.3-.4,0-.9.5-1Z"
          fill="#044bb2"
        />
        <path
          d="M282.2,394.2c1.3-.2,1,.3,1,1.5-.6,0-1.3.4-2,.5,0-.2,0-.4,0-.5v-.5c.3-.5.6-.9,1-1Z"
          fill="#03217a"
        />
        <path d="M284.2,396.2c0,.5-.3,1.1-.5,1.5-.7-1-1-1.7.5-1.5Z" fill="#044bb2" />
        <path
          d="M277.2,391.2c.2.1.2.8.8.9s1.5-.6,1.7-.4c.5.5-.2,1.3-1,1l1,1.5h-1.5s.8,1.5.8,1.5l3.2-3-1,2.5c0,0,0,.3,0,.5-1.3-1.2-.8.5-1.3.5s-1.2-.4-1.7-.2c-1.3.4-2.7,1.7-3.9,1.2v1.5s1-.5,1-.5c.1.5-.4,1.4.5,1.5.4-1.8-.5-2.8,2.5-2.5-.2.5-.4,1-.5,1.5,0,0-.4,0-.5,0l-.5.5c-.3.1-.3.6-1,.5-.1.6-.4,1.1-.5,1.5h-.5c-.6,0-1.1-.1-1.5-.5-.8,0-.7-.8,0-1,.2-.4.1-.6,0-1-.8-.3-.8-1.2,0-1.5-.2-1,.3-1.3,1-.5.4-.1,1.4.1,1.5,0s-1-1.4.3-2,.8,2.1,1.7,1-1.9-1.9-2-2c-1-.9.9-.9,1-1.2.2-1.1-.7-.6-.9-.9-.3-.4,0-.8-.1-.9.5,0,1.1.2,1.5.5Z"
          fill="#0234a2"
        />
        <path
          d="M274.7,377.7c.5,1.2,2.4.4,2.5.5.1.2,0,.7,0,1s0,.5,0,.5c0,.8-.3,1.3-1,1.5-3.5.3-4.8-6.1-1.5-3.5Z"
          fill="#034ec4"
        />
        <path d="M278.2,389.7c0-1.4,1.9.7,1.4,1.4s-2.4-.2-1.4-1.4Z" fill="#0245b9" />
        <path
          d="M278.7,372.7c1.5-.8,2.1,1.9,2,2s-1.9-.1-2,1c1.9-.3,3-.3,2.5-2.5l2,.5c-2.2,1.6-1,1.1-1,2,0,.6-.7,1.3-2,2,0,.4,1.9,1.1,2,1s-.2-.9.2-1.3,1.4-.7,1.4-1.7c.9-.1.4,1,.5,1.5.4.1.4.3,0,.5l.5.5c0-.5.3-.4.5,0l.5,1c1.5,2.4-3.8,3.4-4,1-.4-.7-.6-.5-.5.5,2.5,1.3.1,2.9-2,2.2v.8c.9.7.8,1.6-.5,1.5,1.9,1.7,2,2.7.5,3-.4.2-.6,0-.5-.5l-1.5.5c0,.5,0,.7.5.5.6,0,1,.6.5,1,1.2.9.3,2-1,1.5-.6.3-1.3.1-1.5-.5-1.6.5-2.7-2.6-1.5-3.5.1-.4.3-.4.5,0,.3.2.3.3,0,.5.5.2.9,0,1-.5-.5,0-.4-.3,0-.5-.6-.9-.4-1.2.5-1,.9-1,1-1.4-.3-2.5.8-1,1.2-2.4,1.3-3.5-.4-.1-.4-.3,0-.5.4-.8,0-1.3-.9-1.2-.4-.3,1.6-4.4,2.4-4.8-.4-.2-.4-.3,0-.5Z"
          fill="#0245b9"
        />
        <path d="M277.7,388.7c-.9.7-1.1.4-.5-.5.9-.7,1.2-.4.5.5Z" fill="#0245b9" />
        <path
          d="M278.7,373.2c-.1,1.6-1.6,2,0,3.5-2.8-.2-1.7,2.1-.5,1.5s0-2.3.5-.2l-1.5,1.2c-1.9-.7-.3-.7-.3-.3,0,.6-3.1.4-2.2-1.2h.5c.1-.4.3-.4.5,0,.9-.4-.2-2-.5-3,0-.6.2-.8.5-.5h.7c.6.4,0,1.2.8,1,.1-.7.4-1.3.5-2,.3,0,.7,0,1,0Z"
          fill="#023ab6"
        />
        <path
          d="M281.7,387.7c-1,1.8-1.5,1.4-2.5.5.6-1-.5-1-.5-3,1-1,3.2,1.1,3,2.5Z"
          fill="#023ca7"
        />
        <path
          d="M277.2,379.7c.2.1.9-.1,1,0,.5.6-1.6,2.2-1.5,3.2s.8.2.9.5c.3.7.4,3-1.4,2.3,0-.2,0-.3,0-.5-.4-.2-.4-.3,0-.5l-.5-.5c-.7.4-1.5-.3-1-1-.4-.8-.3-.9.5-.5.2-.5.5-1,1-1.5,0-.9,0-1.9,1-1.5Z"
          fill="#0339ae"
        />
        <path d="M275.7,387.2c0,0,.9,1.1.5,1.5s-1.3-.4-1.5-1c.2-.6.6-1,1-.5Z" fill="#023bad" />
        <path d="M281.2,380.7c-1.1-.8-.3-2.2.5-1.5s0,.9,0,1c0,.2-.5.4-.5.5Z" fill="#012d9c" />
        <path d="M278.7,381.7c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#0339ae" />
        <path
          d="M287.2,370.2c.4.1.4.3,0,.5,2.6-1.5,3.7-1.4,3.5.5l-2,4.3h1s0,1.2,0,1.2c-.7.8-1.6,1.3-2.5,1.5,0,1-.3,1.2-1,.5.3.1.3.3,0,.5-.1.4-.3.4-.5,0-1.3.6-1.5,0-.5-1-.1-.4-.5-.7-1-1-1,.3-.2-1.2-.2-1.2.1.9-1.7,4.6-2.4,2.8-1.3.6-2,.4-1.4-1.1,1.3-.7,1.9-1.4,2-2-2.7.9-5.2,1.6-2.8-2l-.7-1c-.7-.5-.9-1.6,0-2,0-1,.5-.8,1.5.5,1-.2,1.7-.1,2.2.1.9-1.9,2.9-1.5,1.8.4.8-.1,1.1-.4,1-1-.6.6-.8.4-.5-.5-.2-1.6,2.7-2,2.5,0Z"
          fill="#023fb2"
        />
        <path
          d="M285.2,378.2c-.2,0-.3,0-.5,0l-.5-.5c0-.1,0-.3,0-.5,1.5-.4,2.7-.4,4-1.5.8.8-2.6,2.4-3,2.5Z"
          fill="#0230a2"
        />
        <path d="M284.7,376.2v-.7c2-2.7,3.2,1,0,.7Z" fill="#0230a2" />
        <path d="M282.2,375.7c2.7,0-.6,1.8-2,2-.1-1.5,2-1.6,2-2Z" fill="#012fa6" />
        <path d="M285.2,370.7c.1.2.9.4,1,.8.4,1.1-1.5,1.1-2,.2l1-1Z" fill="#0238a8" />
        <path d="M288.7,374.7h-1.5s.5-1.5.5-1.5c.2-.2,1.3.9,1,1.5Z" fill="#022c9e" />
        <path d="M287.2,370.2c0,0,1-.9,1.5-.5s-1,1.1-1.5,1v-.5Z" fill="#012793" />
        <path d="M284.7,378.2c-.5,0-.4-.2-.5-.5l.5.5Z" fill="#023fb2" />
        <path
          d="M287.2,378.2c1,0,1,.7,2.2-1,.9,0,.6,3.5.8,4.1s1,.4,1,.6c0,.9-1.6,2.3-1.5.3-.8-.2-.2,1.1-.8,1s-1.1-.7-1.7-.5c-.2.2,1.7,1.5.5,2-.4.7-.9.9-1,0-.6-.7-1.1-.9-1.5-.5-.1.4-.3.4-.5,0h-.5c1.6-.5-.4,3-1,3l-1.5-1.5c-1.8.7-2.3-.9-2.1-2.7s.2.9-.4.7c0-.2-.8-.5.3-2s.7,1.7,1.7.5,0-1.1,0-1.5c-.4-.7-.2-.9.5-.5.1,0,2.6.5,2.7.5s.8-1.1,1.3-1.5.4,0,.5,0c.2-.2.2-.4,0-.5.1,0-.1-.5,1-.5Z"
          fill="#023bad"
        />
        <path d="M286.2,379.2c0,0,0-.4,0-.5l.5.2-.5.2Z" fill="#0235a2" />
        <path
          d="M279.2,383.7l.2-1c1.2,1.3,0,2.6,2.3,3,.4.5.3,1.5,0,2-1-1.5-1-1.7-3-2.5,0-.1.4-1,.5-1.5Z"
          fill="#022e9f"
        />
        <path
          d="M284.7,384.2c-.1,0-.4,0-.5,0-.3-.1-.5-.7-.5-1-.8,0-.3,1.8-2,.7.5-1.4,1.7-1.6,3-2.3v2.5Z"
          fill="#0249b8"
        />
        <path d="M286.7,384.7c-.6-.1-1-.3-1.5-.5-.3-1.8,1.4-1.1,1.5.5Z" fill="#022e99" />
        <path d="M289.2,380.2h-1c-.2-.7.2-1,.7-1.5l.2,1.5Z" fill="#0235a2" />
        <path d="M289.4,381.2c.3.2.3.3,0,.5v-.5Z" fill="#0235a2" />
        <path
          d="M265.2,361.7c.3-1.4,1.6-1.2,2-.5.5-.2,1,0,1.5.5.3,2.7.9,1.4,1,1.5.2.2.4.4.5.5.2.9,0,1.5-.5,2-4.1,1.9-2.3-.4-2.5-.5-1.4-.7-1.9.2-1,1.5l-2-.2v.7s-2.5-.5-2.5-.5c-1.2-.4.2-1.9,1-1,.1-.3.5-.4,1-.5-1-1-.9-1.1.5-1-1-1.5-1.1-2.2,1-2.5Z"
          fill="#024fd1"
        />
        <path
          d="M270.7,353.2c0,0,.5.6,1.4.2s.3-1.3,1.1-1.2c0,1.7-1.7,2.4-2.5,3.7,1.2.7.6-.4,2-.8-.2.8.2,1,.5,1.5.5.1.4.3,0,.5-.3,0-.7,0-1,0-.7,1.1-1.4,2.3-2,3.5.7.2.6.5-.5,1,.4.1.4.3,0,.5.3.2.3.3,0,.5.4.1.4.3,0,.5-.4,2.3-2.8,0-1-1.5-.4-.6-.9-.9-1.5-1-.9,0-1.7.4-2.5,1-1.1,2.6-3.3-2.1-2-3.5.3-.1.3-.4,0-.5-.4-.2-2.8-2-2.8-2.2-.4-2.1.9-2.1,2.3-1.2l.9-.8c1.8,1.8,3.1,1,4.6-.2.5-1.1.9-.9,1.5,0,0-.8,1-.6,1.5,0Z"
          fill="#034fd7"
        />
        <path d="M270.2,352.2c0,.3.4.7.5,1-1,.1-.7,0-1.5,0l-.5-1h1.5Z" fill="#0357df" />
        <path
          d="M261.2,352.7c1.1-1.8,3.6-3.7,3.4-.4h.6c.7.5,1.7.7,2.5.9-.5,3.9-3.5,1.5-5.5,1-.7-.2-1-.8-1-1.5Z"
          fill="#0354e3"
        />
        <path
          d="M270.2,360.7l-.5-3.5,1.2,1c.4.2-.2-.9,1.2-1l-.5,2.5c0,0-1.4.9-1.5,1Z"
          fill="#0347c8"
        />
        <path
          d="M264.7,361.7l1.4-2.3,1.1.3c-2.2,0-.1.7,0,1,.4.2.4.3,0,.5.9,2.6-.7,2.1-.5,0-.6-.2-1.2.5-1.5.5s-.3,0-.5,0Z"
          fill="#035bde"
        />
        <path
          d="M267.2,360.7c.3-.7.7-1.2,1.5-1,0,.7,0,1.3,0,2-1.1.8-.8.4-1.5-.5,0-.2,0-.4,0-.5Z"
          fill="#0231b6"
        />
        <path d="M267.2,356.7c.7-.6.9-2.2,2-2.5.2,2.9-1.5,2.2-2,2.5Z" fill="#0763dc" />
        <path d="M267.2,356.7c-.2.1.4,1.8-.2,2l-1.2-1.2c.2-.7,1.3-.6,1.5-.7Z" fill="#035bde" />
        <path d="M269.7,362.7c0-.2,0-.3,0-.5l.5.2-.5.2Z" fill="#024fd1" />
        <path
          d="M265.2,337.2c.9-.6,2.9-.7,2,.5.4.6.6.6.5,0-.4-.8,1-1,1.5-.5.6.4,1.3.4,2,0h.5c1.2.7-1,2.4-.5,3s2.1-.9,2,.3-2,1.3-2.5,1.7c-.1-.4,0-1,0-1.5h-.5c.3.9-.4,1.9-.5,2.5.2.2.2.3,0,.5l-3.5,1c-3.2,4.4-4.5-2.8.5-2.5,0-.4-.1-.6-.5-.5-.8,1.3-2.8,2-3.5.5-.5,1-1.3.6-1-.5-.8-.2-.7-.7.5-1.5,0-.3,0-.6.5-1,1-3.1,1.8-3.8,2.5-2Z"
          fill="#024be2"
        />
        <path
          d="M273.2,335.7c0,.4,0,1,0,1.5l1.5-.5c0,.5.5.6.5,1s-.7.9-.5,1c.4,0,1.3-.1,1.5,0s-.2,3.2-.5,3q-.4-.5,0,0c.6.9,1.9,0,1.5,1.5-.9-.2-1.3,0-2,.5-1.7,1-.5,1.2-.5,1.5s0,1.4,0,1.5-1,0-1.2.5c-1.7-1.5.2-.8.2-1,.6-1.2-.8-1.1-1.5-1-.6,1-2-2.4-1.5-3,.4-.8.3-1.7-.5-2.6.9-.4,1.4-1.2,1.5-2.4-.3-.1-.3-.3,0-.5.1-.6.9-1.3,1.5-1Z"
          fill="#023fd4"
        />
        <path
          d="M270.7,342.2c.2.9.9,1.1,1.7,1-.2-3.3,1.7,1.2,1.3,1.5s-1-.5-1.3-.4c-1.3,0-.2.9-.2,1,0,.7.6,2.9.5,3-.8.8-1.1-.8-1.5-1l-.7-.2c0-1.3-.3-2.6-.8-3.8-2.5-2.6,3.2-4.7,1-1Z"
          fill="#024adb"
        />
        <path d="M271.7,337.2l-.2.5-.2-.5c-.4-.2-.4-.3,0-.5h.5v.5Z" fill="#0358eb" />
        <path d="M275.7,341.7c-.6,0-.6-.5-.5-1h.5c0,.3,0,.9,0,1Z" fill="#0246d3" />
        <path d="M274.7,341.2c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#0246d3" />
        <path
          d="M261.7,341.7c-.5,1-.1,1.2,1,.5,0-.3,0-.7,0-1,1.6,1.7,2.2.6,3.5.5.7-.6,1-.3.5.5-1.1,1-2.4.9-2.5,3.2l2-.7v.5c.6,1,.4,2.4-1,3,.4.7.1.9-.5.5,0,1.2-.9,1-2.5-.5-.5,0-.4-.2,0-.5-.3-.6-.6-1.1-1-1.5,0,0,1.2-1.3-.7-1.5l-.3.5c-1.2,1-1.9-.4-1.7-1.5-1.2,0-.9-.5.2-1-.7-1.8,1.1-3.3,2.1-2.3l1.4-.2c-.1.3-.3,1.4-.5,1.5Z"
          fill="#0357e9"
        />
        <path
          d="M266.7,348.2c0,.1,0,.4,0,.5l-.5.5c-.3.6-1.1,1.4-1.2,2s.2.9.2,1c0,.4.1,2.5-1,1.5s.1-2.3-.3-3c-1,.8-1.6,1.3-2.8,2s-.4,0-.5,0c-.3-1.3.7-3.2,2.5-2.5.3-.6.8-1.1,1.5-1.5,0-.5.3-.4.5-.5.1-.4.3-.4.5,0l.5-.5c.1-.4.3-.4.5,0,.4.2.4.3,0,.5Z"
          fill="#0364e8"
        />
        <path
          d="M271.2,347.2c0,0-.4,0-.5,0l-1,.5c.4-1.2,0-3,0-4s0-.3,0-.5c1.3.6,1.6,2.7,1.5,4Z"
          fill="#023fd4"
        />
        <path
          d="M267.2,345.7c1.3,1.3,1.3,2.9-.5,2h-.5l-.5.5c-.1,0-.4,0-.5,0l1-3c.2.5.8.4,1,.5Z"
          fill="#024be2"
        />
        <path
          d="M266.7,348.2c0-.1,0-.4,0-.5.1,0,1.9.1,1-1s-1.9,1.5-.5-1c2,1.4,1.6,3.3-.5,2.5Z"
          fill="#0357e9"
        />
        <path d="M266.2,349.2l.5-.5c-.2.3-.5.5-.5.5Z" fill="#0357e9" />
        <path
          d="M266.2,369.2c0-.5-1.2-1.3-1-1.5.8.4,2.9-.6,3-.5.9.8-.6,1.8-1.5,1.7l1.5,1.2v.8c-1.4.4-1.4.8-1.5,2.2-.5,0-1.4-.6-2.1-.4s-1.9,2.2-2.8,1.4,1.3-3.2-4-2.5c.5.5,0,1.4,0,1.5.5.3,1.6-.4,1.5.5-.8.8-1.8.7-2.5,1-.2-.5-.9-1.8-1.4-1.8-.7,1.4-1.2.6-1.6-2.2-.8,1.2-1.3.9-1.5-.5-.4-.1-.4-.3,0-.5-.9-1.2,1.1-2.4,2-1-.3-.8,0-.8,1,0,.3-.7.8-.8,1.5-.5.4.1.4.3,0,.5,2-.2,3,.2,3,1,.2,0,.4,0,.5,0l1-.5h.7c.9,1.8,3,1.2,4.3,0Z"
          fill="#034fd0"
        />
        <path
          d="M261.2,361.7c2.3.3.9,1.9,1.2,2,.8-.6,1.5-.4,1.8.5-.1.3-.5,1-.5,1h-.5c-.4-.2-.7-.3-1,0,.3,0,.5.1.5.5-.3.3-1,.5-1,1s.8.3,1,.5v.5c-2.2-.2-2.7-.3-3,2-.5,0-2.5-.6-3-1,1.1-.9,2.1-1.6,3-2.5-.1-.7.5-1,1-.5l.5-.5c0-.5-.2-.8-.5-1v-.5c-.2-.7-.2-1.4,0-2h.5Z"
          fill="#0357d8"
        />
        <path
          d="M261.2,369.2c.1-.1-.1-.9,0-1s3.1,2,3.2,2c.7,0,.3-2.4,1.7-1,.3,1.5-1.1,1.1-1.6,1.5s-.4,2-1.1,0l-1.7,1-.5-2.5v1.5s-.5,0-.5,0l-.5-1c0,0,1-.5,1-.5Z"
          fill="#023ec6"
        />
        <path
          d="M272.7,363.2c.4.1.9,0,1.5.3s0,.7,0,.7c-.2.9-.7.9-1,0-.8,0-2.6-1.5-1.7-1.5.5,0,.9.4,1.2.5Z"
          fill="#024fd1"
        />
        <path
          d="M270.7,364.2l.5.5c-.6.5-.8.7-1.5,1-.3-.9-.7-1.7.5-2,.2.1.3.3.5.5Z"
          fill="#0337b6"
        />
        <path d="M274.2,364.2c.1.7.7,1.2,0,2-.6-.6-1-1.1-1-2,.3,0,.7,0,1,0Z" fill="#0241bd" />
        <path d="M270.7,364.2h1c0,.6-.5.5-.5.5-.2-.2-.3-.3-.5-.5Z" fill="#024fd1" />
        <path d="M275.2,369.7l1.5-.5c-.2.6-1,1.3-1.5,1.5-.7,0-.5-.6,0-1Z" fill="#034ac6" />
        <path d="M278.7,368.2c-.1,0-.8.8-1,.5-1.2-1.6.8-.5,1-.5Z" fill="#034ac6" />
        <path
          d="M274.7,242.8c0,.1,0,.4,0,.5l.5.5c.2.7.4,1.7.5,2.5l-1.1.4c-4.1-3.8-8.5-6.1-13.9-7.1l-.5-1.3c-.4-.1-.4-.3,0-.5l.3-.6c2.5.5,7.3.6,7.7-.4h.5c2.8-.5,5.3,3.7,6,6Z"
          fill="#020749"
        />
        <path
          d="M241.7,244.3c1.7-.8,4.6-.8,6.2-1s1-2.7,1.3,0h.5c.5-2.7,2.1,0,2.3,0,1.5,0,2.3.2,4.2,1-2.5.7-3.9-.7-7-.5-1.9.9-3.1,1.3-5,1.5h-.5c-.9,1.1-2.1.4-2-1Z"
          fill="#021b8d"
        />
        <path
          d="M260.2,238.3c2.8,1.1,6.5,1.7,8.8,2.9s6,4.4,6.7,5.1c0,.3,0,.7,0,1,0,1.7-2.2,2-3,.5-3.2-.4-11-4.1-13.5-3.5v-.5c.7-.7,1.9-1.2,3.7-1.5-3.3.4-5.2.3-7.4-2.6-3.4.4-6.9,0-10.3-1.3l-.4-1.1.7-1.1c.7-.3,13.6,1.3,14.4,1.7s.3.2.4.4Z"
          fill="#02093f"
        />
        <path
          d="M275.7,247.3c.1,1.5,1,2.6-.7,4-1.1-1-2.1-2-2.2-3.5,1,.1,2-.3,3-.5Z"
          fill="#020749"
        />
        <path
          d="M266.2,252.8c.4.6,1.3,1.9,1.5,2.5.7,1.8,0,2.2,0,3.5-1.8,1.8-2.5-.5-1.5-2l-.5-.5c-.1.4-.3.4-.5,0l-1-1.5c-.3,1.3-.4,1.1-1,0,.5,1.2.2,1.3-1,.5-.7.6-.9.4-.5-.5l.5-.5c.2-.4.3-.4.5,0,.8-.2,1.6-.5,2.5-.5l-.5-1h1.5Z"
          fill="#0230d7"
        />
        <path
          d="M250.2,286.3c-1.3-.3.8-2.8,1-2.8.3,0,2.5,1.6,3,2.1,1.2-1,1.1,1.3,0,1.7-.3.2-.5.6-.5,1-.3.9-.7.9-1,0l-.2-.4c.1,2.1-4-.5-2.2-1.6Z"
          fill="#034cf5"
        />
        <path
          d="M256.2,284.8c-.6,1.4-.3,1.7.5,3-.5,0-1.4-.6-1.5-.5v2s1-.5,1-.5c-1.3,3.5.6,1.1,1,1.5s-.1,1.3.5,1.5h.5c0,.2,0,.3,0,.5.2.9-.5,1.7-2,2.5.3.2,0,.4-.5.5,1.1.5.6,1.3-.5,1-.9,0-1.4-1-1.5-3-.3-.3-.5-.7-.5-1.5-.5,1.8-4.5-1.4-4.4-1.7s.4-.4.6-.6c-.9-.4-.7-.9.3-1.2,0-1.3,2.2.3,2,1,.2.7.9.3,2-1,.5,0,.8-.1,1-.5-.5-1.6-.2-2.6,1-3,.1-.4.3-.4.5,0Z"
          fill="#034cf5"
        />
        <path
          d="M264.2,281.3c.4.2.7.5,1,1,0,.6,1.2.2,1,1-.8.9-4.4.2-1.5,2,.6.2,1.4.4,2.5.5.2-.5,0-1.4,1-1.5-1.1,2.6.3,2.4.4,2.7s-.4,2.6-.4,2.8c0,.4.3.6,1,.5.6,1.9-1.1,1.3-2,2.2.8,1.6,1.7-.5,2-.2s-.6,1.6,1.2.5c.9.1-1.3,2.5-1.5,2.5s-1.8-.6-1.8-1c.5-.7-2.1,0-1,.5.6.4,1.3.7,2,1-1.2.5-2.4.8-3.5,1-.5.2-.8.5-1,1,1.3.7.6,1.5-2.2,2.6l-.8-1.1c-.3-.7-.9-.6-1.5-.5-2.6.7-.4-1.6.3-2.2-.7-1.3-.6-1.9.2-1.8.9-.2.4-1.1-1.5-2.5-.4-.1-.4-.3,0-.5.2-.3,0-.3-.5,0-3.9,1-3.4-5.2-1.9-4.9l.9.9c0-.4,0-.8.3-1,.7-.7,4.1,1.1,2.7,2q-1.7.9,0,0l-.2-1.3c.6.4,1.9-1.3,1.9-1.6-1-2.5-.1-5.3,2.8-4.7Z"
          fill="#0247f4"
        />
        <path
          d="M269.2,290.3c-.8.5-.5,1.5-2,1-.5-1.1.9-1.1,1-1.5h.7c.3,0,.2.3.3.5Z"
          fill="#095ff2"
        />
        <path
          d="M266.2,294.8c-.5.2-.8.7-1.5.5.5-1.9,1.2-1.6,3-1.5,0,.2-.5.4-.5.5-.5,0-.7.4-1,.5Z"
          fill="#0a5ff5"
        />
        <path d="M265.7,289.8c.3,2.1-3.8,1-4-.5l4,.5Z" fill="#035cf5" />
        <path
          d="M258.2,292.3c1.4-.2.9.9,1,1s1.9-1.8,2-.3-.6,1.6-1.5,1.8c-1.3-1.5,0-.6,0-.5-.1.3-3.9-.2-1.5-2Z"
          fill="#085af5"
        />
        <path d="M259.7,288.8c-.2.2-.1,1.5-2,1.5-.3-1.9.3-1.5,2-1.5Z" fill="#0759f6" />
        <path d="M260.2,290.3s.2,1.1-.2,1c-1.4-.8-.3-1.6.2-1Z" fill="#0759f6" />
        <path d="M258.2,291.8h-.5l1-1c.3.9-.5.9-.5,1Z" fill="#0759f6" />
        <path
          d="M253.2,273.8l1.5,1c-1.4-.2-1.6,1.4-1,2s2-.9,3,0c.4.5-1.1,2-1.5,2.5,2.2-.7,3.5.5,5.5,0v.5c-.1,0-.3.4-.5.5-.3.2-1.6,0-1.5,1.5.6,1.8-1.8,1.2-1.5,0,0-.6-.5-.9-1.5-1-.9.3-1.2-1-.5-1.5v.9c.6,3.2-2.7,2.5-2.3-1l-.7-.4c-.6.1-.8-.5-.5-1-.4.1-.6,0-.5-.5-1.1-.1-1.4.5-1,2,.4-.5.9-.3,1.5.5.6.3.6.7,0,1,.3.5,0,.6-.5.5-.1,0-.4,0-.5,0-.6.7-1.5.2-1.4-.4l-.6.4h-.5c-.1.4-.3.4-.5,0-1.5.2-1.7.9-2.5-.5-.9.5-1.3-.4-.5-1,.8-.9,1.3-2.5,0-2.9l.5-.6c.3-.3-.9-.9,1.5-1,.2-.3.5-.4,1-.5l.5-.5c.4-1.8,2.4-.5,3.6.4l1.4-.9Z"
          fill="#035ff8"
        />
        <path
          d="M260.2,263.8c1,1.1-.1,1.6-.5,2.5.8.6.6,1-.5,1-.2-.1-.8.1-1,0-.5.2-.7,0-.5-.5-.2-.4,0-.6.5-.5l.5-.5c-3.4-.8,0-4.9,1.5-2Z"
          fill="#023aef"
        />
        <path
          d="M250.2,263.3c0-1.4.6-1.3,1,0,0,.2.5.7.5,1l-.5.5c0,.2,0,.4,0,.5-.3.4-.4.6-1,.5,0-.3.4-.7.5-1l-.5-.5c0-.3,0-.7,0-1-1.2.5-.8,1.1-.7,2s-.8.6-.8.5c-.2-.3,0-2.9.5-3.5.1-2,2.6-.3,1,1Z"
          fill="#045bf6"
        />
        <path
          d="M260.2,254.8c-1.1-1,2.4-1.8,1.3.3,1.3,1.1,1.5,1.4.7.9v-.6c.4-.1.8-.5,1.1-.5.8.7,1.1.7,1,0,.8.2.9.7,1,1.5,1.3,1.6,1.2,4.5-1.5,3.5-1.4-1.3.4-.6.5-1.5-1,.8-3.1-2.9-3.5-1.2s.8.1,1,1.7l-2-.5c-1.8-.5-.1-1.9,0-1.8.3.3-.7,1.4-1,.3-.4-.1-.4-.3,0-.5.4-1,.9-1.4,1.5-1v-.5Z"
          fill="#0239e4"
        />
        <path
          d="M260.7,266.3c.5-.2.8-.2,1,0,1.5.5,3.7,2.5,1.5,3.5-.7-.5-1.7-.5-2.3-2-.5.9-.1,1-1.2,1,0-.8.2-1.2-.5-1.5.1-.3.3-.7.5-1,.3,0,.7,0,1,0Z"
          fill="#0252f6"
        />
        <path
          d="M266.2,256.8c.4.9,0,2.3,1.5,2,0,.2,0,.3,0,.5-.8,0-1.7,1.4-2,1.5-.6-.6-1.4-.4-2-1,1.7-.1,1.6-2.1,1.5-3.5h.5l.5.5Z"
          fill="#0244eb"
        />
        <path
          d="M264.7,260.8c1.1,1.1,2.9,3.2,2.8,4.5-.6-.5-1.5-1.3-2.3-1.5s-.7,0-1,0c-.3-.6-.5-2,0-2.5.1,0,.3-.4.5-.5Z"
          fill="#0244eb"
        />
        <path d="M265.2,264.3c1.6.7.9,1.6.5,3-.7-.6-1.2-1.3-2-1.8l1.5-1.2Z" fill="#0244eb" />
        <path
          d="M264.2,261.3c.3.9.6,1.7,0,2.5-.3,0-.9.9-1,.2.7-.6,0-2.6,0-2.7.1-.2.8,0,1,0Z"
          fill="#0233e5"
        />
        <path d="M261.7,266.3s-.1.2-1,0l.7-.5.3.5Z" fill="#023aef" />
        <path d="M267.7,261.8c-.1-.5-1.1-.8.5-1.5.2.5,1.1.8-.5,1.5Z" fill="#024be9" />
        <path
          d="M263.7,330.7c2.1-.5,2.8,0,2.1,1.6l.4.4c-1.3,0,.2-3.7,1-1,0,.3,0,.7,0,1,0,0-1,0-1,0,0,0,.5.9,1,1,0,0-1,1.2-1.5,1.2,3.8,4.1,3.2-.5,4.3-.7l1.7,1.5c0,0-.3,0-.5,0-.7,2.4-1.4,2.9-2,1.5-.5,0-1.2.5-1.5.5-.2.4-.3.4-.5,0,0,0-.1-.6-.4-.5l-.3,1-1.3-1c-2-1.6-5.4-5.1-1-5.5,0-.2-.5-.7-.5-1Z"
          fill="#0358eb"
        />
        <path
          d="M270.7,330.2c.2.1.4.8.8,1s.1-1.9,1-.5-.9.5-.7,1.5c.3,0,.7,0,1,0,.6.9-1.2,1-1.3.7s1.3-.2.8.8c.5.1.7.6,1.5,0,.2,1-.1,1.3-.5,2-.2-.3-.7-.3-1.5,0-1.3-.8-1.8-1.1-2.1.7-.7.8-3.3,1-3.6.2s-.6-2-.5-2.6,1.3-.8,1.7-.3c.1-.4.3-.4.5,0,1.8-.9,2.2-1.1,1.2-.7l-.2-.8c-.4-.1-.4-.3,0-.5-.7,0-.7-.8,0-1,0-1.7,1.4-2,2-.5Z"
          fill="#0240e2"
        />
        <path
          d="M272.7,332.2c.3,0,1-.2,1,.2l-1.5,1.3c-1-.2-1.2.4-1-1.5l1.2.3.3-.3Z"
          fill="#0253e5"
        />
        <path
          d="M271.7,335.7c.6-.3,1-2.6,1.5,0-.3.6-.7,1.2-1.5,1-.1.4-.3.4-.5,0-.7-.2-.6-.6,0-1h.5Z"
          fill="#024be2"
        />
        <path d="M268.7,332.2c.6.5,2-.4,1.5.7s-1.9.6-2.5.8c-.3-.9,1-1.4,1-1.5Z" fill="#0358eb" />
        <path d="M268.7,330.7c0,.2,0,.8,0,1-1.4.2-1-.3-1-1.5h.5c0,.3.5.4.5.5Z" fill="#0358eb" />
        <path d="M268.2,335.7c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#0358eb" />
        <path
          d="M353.7,281.3c.4.2.4.3,0,.5,1,.1,1,.7,0,1,.4,0,.6.3.5.5l.4.3c-.8.7-1.1,1.5-.9,2.2.4.2.4.3,0,.5,0,.5-.2,1-.5,1.5-.6-1-1.1-1.8-1,0-.4-.8-.6-1.7-1-2.5-.4-1.5.3-2.9,2-4,.1-.4.3-.4.5,0Z"
          fill="#0535de"
        />
        <path
          d="M369.1,286.8c1.6,1.3.7,2.3,3.5.5l-.5,1.5c0,1-.6,1.4-2,1,1.4-1.2,2.8.2,1.7,1.6s-3.9-.9-1.7-1.6c-.2.9-.5,1.6-1,2-.3-1.1,2-.4,2.2-.2,1.2,1.3-1.6,3.5-2.7,1.7-2.6-.7-1.3-1.4.5-1.5-2,0-2,.9,0,2.9-.6,2.8-3.2,1.7-1.9-.4q-3.1-.8,0,0c.2.8,0,1.2-.8,1.2,1.1,1,1.6,2.2-.2,2.3-.4.2-.4.3,0,.5.2-1.5,1.7-1.8,4.5-1,.2-.4.3-.4.5,0,.6,1.1.3,2.2-1,2l-1.2.4c-.5.8-.9,1-1.3.6-.4-.1-.4-.3,0-.5-.7,0-1.4-.2-2-.5-.1,0-.5-.5-1-.5-.8-.3-1.6-.3-2.5,0,.4-1.2.3-1.9-1-1.5,0,0-.4,0-.5,0l-.5-.5c-.2-.8.8-1.1,1.5-1-1.2-.6-1.1-2.1-.5-3,0-1.7,1.9-1.4,2,0,.5-.9,1.2-1.7,2-2.5,0-1.7,1.2-1.7,2.5-1,0-.7.1-1.4.5-2,0-.5.3-.6,1-.5Z"
          fill="#0245f3"
        />
        <path
          d="M361.1,297.3c2.7-2.5,1.4.9,1.5,1s1.7-1,2,.5c-.3,0-1.2.6-2,0v1.5s-1.5-.5-1.5-.5c-.5-.6,2.5-2.7,0-2.5Z"
          fill="#0234eb"
        />
        <path
          d="M367.6,299.8c-.6.4-.6.6,0,.5.6-.5.9-1.4,2.3-1.4l.2.4c.4.2.4.3,0,.5-2.1.7-.8,1-1.3,1.5s-.9,0-1,0c-.4.3-.2.8-.3.9-1.1.8-.9-1-1.5-1.5s-2.7-.3-.5-1.5c.4,0,1.5-1.2,2,.5Z"
          fill="#0234eb"
        />
        <path d="M365.6,302.3c-.2.2-.4.4-.5.5-2.4,1.3-1.9-1.1.2-1l.3.5Z" fill="#023ce3" />
        <path
          d="M359.6,292.8c.7-.6,1-.3.5.5.8.3,1.3,1.2,1.5,2.5-.4.6-.8.9-1.5,1s-2.5.1-3,0c-1.1-2.8-1-4,.5-3.5-.9-2.4,2.3-3.1,2-.5Z"
          fill="#024cef"
        />
        <path
          d="M354.7,287.3c.5,0,.8.3,1,.9,1.7-.6,2.1.2,1.3,2.1.7.6.9,1.6.7,3-1.8,2,0,.4,0,1.3s-.6,1.3-.5,2.2c-.6-.2-2-4.7-1.9-4.9s.9,0,.9-.4-.5-.6-.5-.7l-1.5-1c-.5-.7-.6-1.4-1-2,.1-.4.3-.6.5-.5.6-.7.9-.7,1,0Z"
          fill="#0232de"
        />
        <path d="M354.2,289.8h2c0,.4-.5.8-.5,1-.9,0-1.1-.4-1.5-1Z" fill="#0346e5" />
        <path
          d="M373.6,317.3c.6-2.3.8-3.6,3.5-3-.3,1.3-.9,1.3.5,1.7-.7.9-1.6,1-2.5,1.3l-1,.5c-.2,0-.3,0-.5,0v-.5Z"
          fill="#0238e8"
        />
        <path
          d="M371.1,316.8c0,1.9,1.8,1,2.5,1,0-.4.3-.4.5,0,.3-.5.7-.5,1,0l3-1c0,.3.5.9.5,2,.2.7.2,1.4,0,2,0,.2-.5.4-.5.5-.6.8-1.2.4-1-.5-.2,0-.9.4-1,.5,0,.7-.4.7-1,.5,0,0,0,.4,0,.5-.3,1.3-1,1.4-2,.5,2.1-3.1.2-2.2,0-2.5s1.2-1.5-.2-1-.1.9-.3,1c-2.8,2.2-3-.6-3.2-.5-.3.1-1.1,1.5-1.7,1-1-.8.9-1,1-1.3.1-.7,0-1.5,0-2.2,1.1-.8,1,1.6,1.5,1s.2-1.5,1-1.5Z"
          fill="#0238e5"
        />
        <path d="M373.1,320.3c.3.7-.8,1.7-1,1.5l.5-1.5h.5Z" fill="#0238e5" />
        <path d="M376.1,321.2c-.1.2.1.9,0,1s-.8-.6-1-.5l1-.5Z" fill="#0228db" />
        <path d="M375.1,319.7c-1,.1-1.1,0-1-1l1,1Z" fill="#0230dc" />
        <path d="M375.1,317.3v.5c0,0-.7,0-1,0,.4-1.3.9-.5,1-.5Z" fill="#0230dc" />
        <path d="M373.6,311.3c0,0-.3.9-1.5.5l.5-1c.3,0,.7.3,1,.5Z" fill="#0a52e6" />
        <path d="M372.6,316.3l.5-.5c0,.2-.3.4-.5.5Z" fill="#0230dc" />
        <path
          d="M374.1,304.8c.3.1.3.3,0,.5,0,.1-1.1.4-1,1,3,.1,1.9-2.6,5-.5h-2s1.5,2.5,1.5,2.5c-.9.1-1.1-.6-2-.8s-3.1.9-4.5.8c.6.6.7,3-.5,2s-.2-1.1-.5-1.6-.9-.7-1-.9c-1-3.1.8-1.4,1.7-1.5s.3-1,.3-1c-.6-1.5,2.5-1.9,3-.5Z"
          fill="#0237e9"
        />
        <path
          d="M377.1,292.8c.3.1.3.3,0,.5,0,.4-.8.8-.8,1.3s1.4,1.4-.2,2.2-.7,0-1,0c1.4,1.6.9,1.4-.5,2.5-.6.5-.4.7.5.5.2,0,.3,0,.5,0,.2-.8.6-.7,1,0-.4,1-2.4,2.6-2,3,.8.8,2.6-2.8,3.6-3.1s2.5,0,3.4.4l-2.7-.2-.7,1,1.5,1.5c-1.6-1.2-2.4-2.5-2.5.5l1,.5c-2.7-1.4-1.8,1-4,2,0,0,0-.3,0-.5-2.5-1.4-4.1-3.3-1.6-5.5,0-.6,0-1.1,0-1.5h.5c.5-1.1.4-1.7-.3-2.1-.8-3.2,2.3-6,4.3-2.9Z"
          fill="#033def"
        />
        <path d="M376.6,299.8c-.3,0-.7,0-1,0-.2-1.5.7-1.3,1.5-.2,0,.2-.5.2-.5.2Z" fill="#022ae6" />
        <path
          d="M372.6,297.8c1.5,2.4-1.2,2.5-.5,4.7s2-.3,2,2.3c-.5.1-2.9.4-3,.5-1.5.2-3.3-1.8-3-3,1,.3,1.3,1.8,2.4,1.4s-.3-1.3,1.1-.4l-1.5-2,1.5-.5c-1.3,0-1.5.3-1.5-1l1.5-2c.1-.6.6-.4,1,0Z"
          fill="#022ce5"
        />
        <path
          d="M368.6,307.8c.4.2.4.3,0,.5,0,1-.5.8-1,0v-.5l.5-.5c.6-.4.8-.2.5.5Z"
          fill="#023ce3"
        />
        <path
          d="M365.1,303.3c2.1-.5,3.2.5,3.8,2.5-.8.7-1.2,1.5-1.3,2.5.7.4,1.2,1,1.5,2,.9,0,2,.5,1.2,1.3,1.1.3.5.9-1.7,1.7-.2,0-.8-.6-1-.5-.3.3-1.1,2.2-.5,2.7l-2-.2c.2-1.7,1.2-.4,1-2-1.6.8-1.4.6-2-1,0-.7-.4-.5-1,.5,0,.2,0,.3,0,.5-.9-.7-1-2-1.5-3,1.9-1.9-.9-1.7,0-5l.9-.8c.2-.9,1.1-1.3,2.6-1.2Z"
          fill="#023ce3"
        />
        <path d="M364.1,312.3l-1,.5c0-.6.2-1.1.8-1.5.5,0,.1.7.2,1Z" fill="#0445e5" />
        <path d="M365.6,307.8h-2.2s-.3-1.5-.3-1.5c.7.8,2.1.5,2.5,1.5Z" fill="#0253eb" />
        <path d="M367.6,307.8l.5-.5s-.5.5-.5.5Z" fill="#0237e9" />
        <path d="M258.7,432.7c.4.2,1.5-.3,1.5.2l-1.5.7c-.1-.4-.4-.5,0-1Z" fill="#012275" />
        <path
          d="M276.2,421.2c0,.5-.5,1.1-.5,1.5-.6-.8-1.6-1.5-1.5-2.5.9-.2,1.2.6,2,1Z"
          fill="#022c7f"
        />
        <path d="M282.2,424.2c2,.3-.4-3,2.5-2.7.5,2.9-2.4,3-2.5,3.2v-.5Z" fill="#011f6d" />
        <path
          d="M276.7,421.2c1,.7,2,1.2,3,1.4.5,1.1,1.4,1.7,2.5,1.6.4.1.4.3,0,.5l.9.4c0,1,.6,2.2,2.1,3.6.6.5,1.5,1.3,1.5,2,1.1,1-1.1,1.6-1.8.3-.4-1.6-1-2-1.7-1.3-.3.2-.2.3,0,.5.5-1.5,2-.6,1.5,1.5-2.8.6-.2,3.8-3.5,2-.7-.3-1.3-.5-2-.5-.5-.4-.6,0-.5,1,1,.3,1,.7,0,1-1.5-.1,0-.7-2.9-.6s-1.7-.2-2.4-.2-1.4.5,0,.8c2,.5.1,1.4-1,1.5-.6,0,0-1.2-.3-1.5s-4,.9-4,0l.5-.5c0,0,0-.4,0-.5v-.6c-1.3.2.2-1.6.8-1.9s2.6.6,2.7,1c-.2,1.3.5.5,0-.5-.9.5-1.2.2-1-1,1.5,1.6-1.6,1.4-1.6.6,0-1.5,1-2.3,1.6-.6h-1.4c.7,1-1.5,2.4-2.4,2s-.6-4,.8-3.5c-.9-1.9.3-2.1,2.1-1.9s0,.8-1.1-.1c-.6-1-.9-1.9.5-2,.2-.4.3-.4.5,0l.5.5c.6-.3.8,0,.5.5l.5-.5c-.4-.1-.4-.3,0-.5v-.5c-.4-.4-.1-.6.5-.5,1.2-.3,2.2.2,3,1.5q.7.8,0,0c-1.3-.3-1.1-1.3.5-3-.4,0-.4-.3,0-.5-.5-.9-.7-1.4.5-1.5.1-.4.3-.4.5,0Z"
          fill="#012578"
        />
        <path
          d="M270.7,416.2c0,1.3-1.2,1.1-1.5,2.5,2-.6,4.4-2.1,2.2,1,.5-2.6-2.2.2-2.7,1,1.4.8,3-.3,4.2,0s.3,1,.3,1c-.5-.2-2.8.7-2,1.5s1.9-1.5,1.5.5c-.6.3-2.1,1.3-2.2,1.3-.8,0-3.2-1.5-2.8-2.8,1.4,1.4,2.1-.9,2-1s-.9.2-1.3-.2-.1-.8-.2-.8c-1-.5-1-2.6.5-2,.3-.5,1.1-1,1-2,.3,0,.7,0,1,0Z"
          fill="#022c7f"
        />
        <path
          d="M275.7,423.2c0,.8.1,1.9,1,1.5v.5c-1,0-1.7-.1-1.5,1,0,0,1,0,1.3-.5,2,1.4-.8,2.2-1.8,3s1.9,1.4,1.5,2-1.8.6-2,.5l.5-1-1.5-.3c.7-.6,1.6-3.4,2-3.8l-3,2c-.2-2.2,3.5-2.2,0-3.5.6-.3,1-.3,1.5-.5,1.1-.3,1.1-.5,0-.5,0-.2,0-.3,0-.5,0-.3-.3-1.4-.5-1.5.5.5,1.8.6,2.2,2l.2-.5Z"
          fill="#022c7f"
        />
        <path
          d="M283.2,430.2c-.8,0-1.7,0-2.5,0-.3-.7,2.1-.5,1-1.5s-1.9,1.4-2-1.5c1.9,1.1,5.1-.2,2.5,2.2l1,.2v.5Z"
          fill="#022d84"
        />
        <path
          d="M272.2,432.2c.1,0,.7-.1.9,0s-.2,1.6-.4,1.7c-2,1.1-3.3-.5-.6-1.3v-.5Z"
          fill="#012682"
        />
        <path d="M279.2,429.7c-1-.4-1.8-2.8-.7-3.5l.7,3.5Z" fill="#022d84" />
        <path d="M279.2,433.2c-.1.4,0,.8-.5,1-.3-1.1-1.3-2.1.5-1Z" fill="#012682" />
        <path d="M271.7,425.7s-.5.2,0-.5v.5Z" fill="#022c7f" />
        <path d="M270.7,426.2l-.5-.5c.2.1.3.4.5.5Z" fill="#022c7f" />
        <path d="M271.2,426.7c0-.2.5-.4.5-.5l-.5.5Z" fill="#022c7f" />
        <path
          d="M263.7,429.2c.6.4,1,.7,1,1.5l1-1.5c1.1.3,1,1.5,1,2.5-2.4-1.1-.2.9,0,2-2.5-1-3.4,1.2-5.5,1,0-.3.5-.5.5-.5.3-.7,1.3-1,1.7-1.5s-.2-.9-.1-1c.3-.2,1.3,0,1.5,0s-.8-1.7-1-2.5Z"
          fill="#012275"
        />
        <path d="M263.7,427.2c.4.9,0,1.7,0,2-.1,0-.7.1-.9,0s-.2-2.8.9-1.9Z" fill="#02318a" />
        <path d="M291.2,430.2c1.8-1,2.9,2.3.5.5s-.3-.3-.5-.5Z" fill="#012682" />
        <path
          d="M286.7,430.7c1.4,0,2.8-.2,4-.5h.5c.4-.1.6,0,.5.5v1c-.6.4-.6.6,0,.5.3,0,.7,0,1,0,.9.7,1.2.2.7,1.5-.9,2.5-4.7,1.3-7,2.5-.8-.6.4-.3.7-.9s0-2.2,1.5-2.9c.4-1.1-1.5-.3-2-.2l-1,.5c-.3,0-.8-.7-1-1-.4-.6-.5-1.3-.5-2h-.5s0,1,0,1c-.4,0-.4-.5-.5-.5-.4-.1-.4-.3,0-.5,1.1-2.3,1.4.6,2.5,1.3s.9-.3,1-.3Z"
          fill="#01237b"
        />
        <path d="M286.7,432.2c0,.5-.6.6-1,.5.1-.5.6-.4,1-.5Z" fill="#012578" />
        <path d="M287.7,435.2c.3-.3,1.1-2,1.2-2,1.6.7.4,2.5-1.2,2Z" fill="#012682" />
        <path d="M291.7,431.7v.5c-.5,0-1.6.8-2,.2l2-.7Z" fill="#012682" />
        <path
          d="M300.2,428.2c0,.3,0,.7,0,1l1.3-1c1.5-.2,1.1,2.5.8,3.2s-2.6,0-1,1.3c0,0-.3.7-1,.5l.5-2c-1.7-.5-.6,1.5-1.3,1.5-1.1,0-1.6-1.4-1.7-1.5.3-3.4.9-.6,1.1-.6,1.5,1.1,1-1.3.9-1.4-1-.1-.4-1.5.5-1Z"
          fill="#012779"
        />
        <path d="M301.7,429.7c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#012372" />
        <path
          d="M72.3,180.3c2.6-1.9,2.9.8,2.7,3,2.4,1.3,2.7,2,.9,2.1,0,2.4-2.9,1.3-2.7-.6l-.5,1c1,1.1,1,2.8.1,4.9.3,0,.5,0,.5.1.2,1.5.6,3.3,1.4,4.5,1.4.8,1.1,2.3-.5,2.5-.1-.1-3.3,0-3.7,0-.6,0,0-1.2-.8-1-.3,1.9.9,2.1,2.5,2,.2,1-.8,1.3-.8,2.2s.8,1.2.8,2-2,.4-1,1.2,2-.9,2,.3c0,2.7-2.8-.5-4,1.8q-1.5-2.3,0,0c-.9,1.7,0,2.9-3,1.5-1.4-.1.3-2.6.2-2.5-.6,1.8-1.6,3.7-2.2,1h-.5c-1.6.5-1.5-1.4,0-1.5-.9,2-2.2.2-1.3-1.2s3.6.2,1.3,1.2c.8-.8.3-1.3-1.5-1.5,0-.2,0-.3,0-.5.8-.6,1.2-1.2,1-2,1-.9,2.3-.9,2.4-1.1.3-.4-.2-2.7,0-2.9s2.6.9,2.5-.3-2.9-.7-3-1.7c2.3-.5,1.6-1.8,2-3.1s.9-.3,1-.7c.2-.6-.2-1.8,0-2.1s1.3.1,1.5,0c1-.8-1-1.1-1-1.3,0-1,.8-1.7,1-2.7l2,1c-1-1.9.4-1.3.5-1.8.3-1.2.4-3.2-1-3.4l1-.3Z"
          fill="#0003b5"
        />
        <path
          d="M62.3,203.3c2.6,0,5-.6,2.7,2.5,0-.8-1.1-.9-1.2-1s0-2.1-1-1,.9.9,1,1-.5,1.1,0,1.5c-.7-.1-2.6,1.4-3,1-.9-.8.9-1.1,1-1.4.4-.8.3-1.9.5-2.6Z"
          fill="#0103ad"
        />
        <path
          d="M66.3,207.8c0,.3,0,.7,0,1-.4-.1-1.3.5-1.7.5s-.3-.7-.4-.8c-.4-.2-1,.3-1.4-.5s1-.6,1.3-.9.1-.8.2-.9.7.5,1.3,0,.4-1.6,1.2-1.6c.2,1.1-.3,2-.5,3Z"
          fill="#0103ad"
        />
        <path d="M63.3,200.8l.5.3c.3,1.5-.4,1.2-1.5,1.7.1-.3.9-1.9,1-2Z" fill="#0103ad" />
        <path d="M69.3,206.3c-1.2.2-1.6-1.2-2-2l2-.5v2.5Z" fill="#0001a4" />
        <path d="M73.3,184.8c.2.5-.4.9-.5,1-.8-.9-.7-1.2.5-1Z" fill="#0004ae" />
        <path d="M72.3,193.8c.6.6-.2,1.6-1,.2,0-.4,1-.3,1-.2Z" fill="#0105ba" />
        <path d="M70.8,204.3c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#0105bb" />
        <path
          d="M161.3,85.9v1.1c-3.2,1.4-6.2,3-9,4.9.2,1.4-2.4,3-3.5,2.5-.4,1.5-2,2.6-3.5,1.5-1.8,1.4-3.9,2.7-6,3.5,0-.8.8-1.5,1-2,1.8-1,11.3-5.9,11.7-6.5s-.2-.9-.1-.9c.6-.5,7.8-3.2,9.4-4.1Z"
          fill="#1a30d3"
        />
        <path d="M169.3,81.9c0,0,.2-.4.5-.5l-.5.5Z" fill="#0e25cf" />
        <path d="M170.3,81.4s.1-.4.5-.5l-.5.5Z" fill="#0e25cf" />
        <path
          d="M135.3,102.9c.1.4.2.6,0,.7-4.7,4.1-5.2,2.7-.6.4s.3.1.5.4c.9-.1.9.2,0,1,0,.3,0,.6-.1.8-1,1.4-5.2,3.3-6.9,3.7l-.5.5c-.1.4-.3.4-.5,0-.6.5-1.5,1.1-2,.5-.3-.2-.2-.3,0-.5.7-.8,1.5-1.6,2.5-2,2.4-1.9,4.4-4.6,7.5-5.5Z"
          fill="#5471ec"
        />
        <path
          d="M142.8,97.9c.8.5-.2,1.5-.9,1.4s.3-.4.4.6c-.1.4-.5.7-1,1-.2.4-.3.4-.5,0l-.5.5-1,1c-.1.4-.3.4-.5,0l-1,.5c-.2.9-1.6,1.8-2.5,1.5-1.3.7-2.5,1.8-4,2,1.3-1.1,2.7-2.5,4-3.5s1.1-1.2,1.5-1.5c1.7-1.5,3.9-2.8,6-3.5Z"
          fill="#6580ec"
        />
        <path
          d="M120.8,115.4c.5.1.4.3,0,.5.6,1-.2,1.8-2.5,2.5,0,.6-.8,1.1-2,1.5-.3,0-.7,0-1,0-.7-.8,3.2-4.7,4-5s.3,0,.5,0c.9-1,1.2-.9,1,.5Z"
          fill="#264ce5"
        />
        <path
          d="M125.3,110.4v.5c-.7,1-.7,1.4,0,1,.3.1.3.3,0,.5-.5,1.7-2.6,3-4.5,3,0,0-.9-.5-1-.5.4-.8,1.1-1.4,1.8-2,1.1-1,2.7-1.7,3.7-2.5Z"
          fill="#395ae8"
        />
        <path
          d="M145.3,95.9c.7,1.5-1.2,2.7-2.5,2-1.8,1.1-4.4,2.3-6,3.5.4-1.2,1.6-1.4,2.5-2,2.1-1.4,3.9-2.3,6-3.5Z"
          fill="#213bd4"
        />
        <path d="M127.8,108.4c-.8.6-1.7,1.3-2.5,2,.5-1,1.3-1.9,2.5-2Z" fill="#4666ea" />
        <path
          d="M114.8,130.8c.4-.2,1.5-.5,1.8-.5.4,0,1.6,2.2.8,3.1.5.6,1.3,1.1,2.3,1.4.6.6,1.1,1.1,1.5,1.5.5-.3,1.2,0,1,.5-.2.4-.3.4-.5,0l-1,.5c1.3.3,1.2.5,0,1,0,.6-.5.9-1,.5-.3.2-.4,0-.5-.5-.2-1.3-.5-.9-.8,1.4h-.7c-.1.6-.3.6-.5.1-.4.4-.8.8-.6,1.4-2.2-.5-3.5.6-4.4,2.1h-.5c-.3-.2-.7,0-1,.5-.1.1,0,.6-.5.5,0-.6-.4-1.1-.5-1.5-.3-.1-.3-.3,0-.5.6-.3.5,1.6,1-.5-.2-.3-.3-.7,0-1,1.5.3.9-.7,1-2h.5c0,.3.1,1,.5,1q.7,0,0,0c0-.1,0-.8,0-1l.5-1c0-.1,0-.6.5-.5-.1.5.3.7.5,1,.6,1.5,3.4-1.1,1.5-1.5-1.4.2-1.9-2-2-3-1.4.5-.7,1.5-.5,2.5h-1.5s-.5-3-.5-3c.1,0-.5-1.1.7-1s1.9.6,2.8,1c0-.8,0-1.7,0-2.5Z"
          fill="#012ee0"
        />
        <path d="M111.3,124.4c.1,1.1,0,1.1-1,1,.3-.3.4-.7,1-1Z" fill="#0232d7" />
        <path d="M114.3,130.3v.5c-1.3-.3-1.7-.4,0-.5Z" fill="#0238e1" />
        <path d="M110.8,133.3c-.2.2-.8-.5-.2-.5s.4.4.2.5Z" fill="#012ee0" />
        <path
          d="M105.8,133.3c0,0,0,1.5,0,1.5s1.4,0,1.5,0c-1.4-2.9,1-2.8.7,0s-.9.5-1.5.6c-1.3.3-.3,1.7-.5,2.1-.4,1.2-1.6,2.7-1.3,4.7.4.1.4.3,0,.5-.2.1-.4.3-.5.5l-.5.5c0,.6.6,1.7.5,2.5-.6.5-1.4.9-1.5,1-.9,0-1.5-.8-1.8-2.2-1.2.4-2.1-.2-2.2-1.3.1,0,.4,0,.5,0,.4-1.7,1.3-3.3,2.5-5v-.5l1.5-.5-1-1.5c2.7.8,3.1-2.6.5-2.8l3-.3Z"
          fill="#0115ce"
        />
        <path d="M107.8,138.3c0-.1-1.1-1.4-.2-1.5,1.5-.2,1.6.3.7,1.5h-.5Z" fill="#010dc1" />
        <path d="M104.8,142.3c.7-.5,1.4-.8,1,.2s-.8.1-1,.3v-.5Z" fill="#0121d9" />
        <path d="M105.8,132.8c.1-.5.3-.4.5-.5l-.5.5Z" fill="#0115ce" />
        <path d="M103.8,143.8l.5-.5c-.1.1-.5.4-.5.5Z" fill="#0121d9" />
        <path
          d="M102.8,147.3c-.4,1.4-1.2,2.6-2.5,3.5,0,.3,0,.7,0,1l.3.6c-1.3.7-1.5,2.4-.7,5l-.6.4c-.1,1.2-1.5,3.3-2,1.8-1.2.4-2,.3-2.5-.3v1.5c1.6-.1,2.2.4,2,1.5,1.2,0,1.5.7.5,1.5l-.4,1.1c-2.5-1-3.6.2-2.7,2.5l-.9.9c-.3.6-.6.5-1,0-.4.2-.4.3,0,.5.5-.4.9-.1,1,.5,1.3,0,1.3.6,0,1-1.2.7-2,.6-2.5-.5-3.1.6-3.8-2.9-3.5-5.5.4-.6,1.8-2.1,2.5-2,.6.2.4-.5-.4-2.1,1.3-1.1,2.3-2.4,3.1-3.8-1.2-.7-2.1-2.3-.6-3.1,0-.2,0-.3,0-.5,2.4-3.1,0,1.1,2.5,1-1.5-3,1.4-.2,2-1.7s-.9,0-1-.6c-1-3.9,1.7-2.3,2-2.7,1-1-2.6-4.5,2-3.5l-2-.5c0-.9,1.1-.8,1.5-1l1.5.6c.3-3.4,2.4,1.7,2.5,2.9Z"
          fill="#010cc9"
        />
        <path
          d="M99.3,143.8c-1.3-2-.3-3.9,1.3-5.5l.8.9c.2,0,.4-.4.4-.4.7.2,1.4,2.6,1.5,3.5-2.6-3.2-1.5-.7-2.1-.1s-1.8,1.5-1.9,1.6Z"
          fill="#010dc7"
        />
        <path
          d="M189.8,373.7c.4.1.4.3,0,.5-.1.4-.3.4-.5,0-.7.7-.8,1.4-.3,1.9,0,.2-2.3,2.7-2.5,2.9-.3,2.3-.9,3.1-1.7,2.6,0,.3-.2.5-.5.5-1.3,1-.9,0-1.5-.5s-1.2-.4-1.5-.9c-.8-1.4.4-4.3,1.3-1.6,2-1,1.3-2.9,1.5-3s1.2.9,1.8-.3-2.2-.8-1-1.7c0-.3,0-.5.2-.7s3.5-.5,3.7-.5c.5,0,.8.4,1.1.7Z"
          fill="#012067"
        />
        <path d="M181.3,383.2v.5l-.2,1c-2.2-3,0-1.5.2-1.5Z" fill="#010e49" />
        <path
          d="M175.8,391.2c.8,1.1,1,2.5.5,4.1,1.8,1.9,0,3.2-2.1,1.9v.5c-.7,1.1.6,1.8-.9,2.3v.7c-.1-.1-.4-.5-.5-.5-.9-.4-1.3-.7-2.5-.5.6-.7.3-2,.5-2.5s1-.5,1.5-.5c.1-.8-1.3-.5-1.5-1.3-.4-1.8,1.8-1.6,1.9-1.8.6-.7-1-1.4,1.6-2.4.2.2.4.2.5,0,.4,0,.1-.9,1,0Z"
          fill="#012164"
        />
        <path d="M174.3,391.2c.1,0,.3,0,.5,0l-.2.5-.2-.5Z" fill="#022870" />
        <path d="M171.5,397.7c.3.2.3.3,0,.5v-.5Z" fill="#021a53" />
        <path
          d="M208.2,348.7c2.5.2,1.3,2.4-.8,2.8.2.9.3,1.3-.7,1.7-.5.6-1.2,1.1-2,1.5-2,1.2-3.3,2.6-4.6,4.6-1.4.8-2.7,1.6-3.9,2.4v.6c-1.5,1.6-3,3.3-4.5,4.9.4.6.2.9-.5.5-1.1.5-1.5,1.2-1.6,2.4l-1.2.8c-.8,3.1-3.1,1.2-2.3-1.2.6-.7,2.4-1.9,2.5-2s-.9-.9-1-2c.4-.8,1.2-1.2,2.4-1.4.5-1.8,1.4-2.7,2.6-2.6.2-.2.7-.5,1-.5v-.5s-1.5-.5-1.5-.5c2,.2,3.9-.2,3-2.5,3.1.9,1.4,0,2.6-1.4s7.3-6.6,7.8-6.6c.8-1.2,1.6-1.6,2.5-1Z"
          fill="#011452"
        />
        <path d="M196.2,361.7c1-.9,1.3-.8.7.5s-1.8.6-.7-.5Z" fill="#011452" />
        <path
          d="M213.7,332.2c2.1-1.1,2.2,2.2,1.5,3.5,0,1.2-1,2.3-2,2.8-.5,3-3.9,8.3-7,6.7-.2.1-1.9,2.2-1.9,2.3-.6,1.7.8.7.9,1.7-1.2,0-2.8.2-3.8,1s-.2,1.4-.3,1.4c-.3.2-1.2,0-1.7.5s.7,1.3-2.2,3c-.5-1.8,1.2-2.3,1.3-2.7s-.4-.9-.3-1.2,2.2-.8,2.4-1.9-1.6-3-.4-4.7c1.1-.1,1.7.9,2.7,1s4.3-1.1,3.3-2.5-2.6,2.7-3.5.2c1-.4,3.6-.2,3.9-1.6s-.4-1.1-.4-1.2c.1-.1,1.2,0,1.8-.5s.2-1.8,0-2c-.5-.7-1.5-.5-2.3-.5-.3-1.4,2.1-2.8,3.5-3-.1-1.7,1.5-2.7,3-2,.1-.8,1-1.5,1.5-.5Z"
          fill="#010933"
        />
        <path
          d="M192.8,361.7c-.8,1.2-2.2,2.9-1.5,4-2.2-1-2.1.5-2.2.5-.3,0-.8-.5-1.3-.5-.2-2.8,1.8-2,1.9-2.1.7-.9.1-3.3,3.1-1.9Z"
          fill="#021347"
        />
        <path d="M182.3,369.2c0-.1-1-.1,0-.5v.5Z" fill="#021240" />
        <path
          d="M191.3,367.7c2.5-.9,3.4.5,1,2,0,.5-.2.4-.5,0-.8.2-.7.9-.5,1.5.1-.4.3-.4.5,0,1.8.6.6,2.1-1.4,1.6l-.6.9c-1.3.2-2,.6-2.7.8s-1.9-.5-2.2-.3c0-.3-.6-1.4,0-2,.8-.9.8-1.7,1.5-2.5l1.5,2.5v-2.5s1,.5,1,.5c0-.8.6-2.8,1.3-3s1,.6,1.2.5Z"
          fill="#01195d"
        />
        <path
          d="M205.7,337.7c4-2.4,4.3,2.3,1.7,4.6,0,2.1-2.6,4.4-4.9,4.3l-1.7-.7c1.1,2.8.6,4.7-1.5,5.5-.5,1.3-1.1,2.6-2.1,3.7-.7.4-1.8,1-2.4,1.2s-1.3-.4-1.5-.2.5,2,0,2.5c-1,1.1-.8-1.3-1.5-1,0,2.3-1.2,2.3-3,2.5.1-.2.9-1.7.9-1.8,0-.7-3-2.7-2.4-3.2s2.8,1.2,4.3,1.1.6-.9,1.1-1,1.5.3,2.2,0c.3-.4-2.9-2.4-2.9-2.6,0-.3.4-.8.4-1.1,0-.6-1.9.5,0-2-1-1.4-1.1,0-1.8.2l-1.2-1c-.2-1.1,1.4-2,2.5-2-.1-.5,0-.6.5-.5,1.2-1.1,2.4-1.7,3.5-2,1.2-.2,1.8-.5,2.5-1.5l-.2-.6,3.7-2.4c-.3-1.2,1.9-2.3,3-2,.6-.9,1-.9,1,0Z"
          fill="#02072d"
        />
        <path
          d="M201.7,339.7c-.8,1-2.4,2.3-3.5,3-.8,1.7-1.7,2.2-2.5,1.5-1.1.7-2.3,1.6-3.5,2,1.3-1,2.9-2.9,4.5-4s3.3-1.7,5-2.5Z"
          fill="#1d57ea"
        />
        <path d="M198.2,342.7l-1,3-1.5-1.5c.9-.6,1.8-1,2.5-1.5Z" fill="#010933" />
        <rect fill="#010933" height="2" width="1" x="196.8" y="346.7" />
        <path d="M199.2,344.7l-.2,2c-.8-.5-.9-1.1-.7-2h1Z" fill="#010933" />
        <path d="M191.2,357.7c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#03092a" />
        <path
          d="M222.2,407.7c.1.3.7.9.5,1l-1.5.5,2,.3c-.8,0-.9,1.2-1,1.2-.9.6-4.5.3-3.5-1.5l2,.8c-.4-1.7-1.5-.7-2.5-1.5l4-.7Z"
          fill="#023996"
        />
        <path
          d="M222.2,412.2c1.2,2.3,1.6-.5,1-1.5,2.4.2.8,1.3.8,2.4s1,2.1-.8,3.1c0-.2-.6-.7-.5-1l-.5-1c0,0,0-.4,0-.5v-.5c0,0-.2-.2,0-1Z"
          fill="#023e95"
        />
        <path
          d="M230.7,417.7c-.2.4-.3.4-.5,0-.6.1-1.3,0-1.8.5l-.2-1.7,1.8.7.3-1.5.5,2Z"
          fill="#022e86"
        />
        <path
          d="M231.2,417.7c0,.9-.5,3.3-1.5,2.5s0-.7,0-1l.5-1.5c.2,0,.3,0,.5,0s.3,0,.5,0Z"
          fill="#023e93"
        />
        <path d="M223.2,416.2l2.5,1.5c-.6-.1-2.2.2-2.5,0s0-1.1,0-1.5Z" fill="#022e86" />
        <path
          d="M221.2,415.7c.2,0,.7-.1.9,0s0,.7,0,.9h-.5l-1-.5s-.6-.3-.5-.7l.5-.3.5.5Z"
          fill="#012c80"
        />
        <path d="M222.2,414.2h1.5c0,.6-1,.9-1,1h-.5l-1-.7c0-.5.8-.1,1-.2Z" fill="#022e86" />
        <path d="M221.2,415.7c-.2,0-.4-.3-.5-.5.2,0,.3,0,.5,0v.5Z" fill="#022e86" />
        <path
          d="M214.2,409.2v.5l-.5.5c-.2,0-.5,0-.5,0,.1-.1-.1-.7,0-1,.3,0,.7,0,1,0Z"
          fill="#033b96"
        />
        <path
          d="M213.2,410.2c-.3.7.4,1.3,1,1.5v.5c-.6-.4-1.6-.3-2-1.8,0-.5.9-.1,1-.2Z"
          fill="#033b96"
        />
        <path
          d="M210.7,408.2c1,1.1,1.9,0,2.5-.8l-1-.5c.9-1.1,1.8-2,2.5-.3l-1.5.3c1.9,1.6.3,1.1,0,1.8l-2.5.5h-.5c0-.2-.7-.8-.5-1,.3,0,1,0,1,0Z"
          fill="#033b96"
        />
        <path
          d="M216.7,408.2c-1.2-1.6-1.1.9-1.2.9-.2,0-.6-.5-.8-.4.3-1.7.6-2.9,2.3-1.5.7.6-.2.9-.3,1Z"
          fill="#033b96"
        />
        <path d="M222.2,413.7s0,0,0-.5v.5Z" fill="#022e86" />
        <path
          d="M201.7,404.7c.6-1.5,1.5-.6,1.8.8,4-1,6.8,3,1.5,2.2l-.8.5c2,.3,2.7.9,2,2,1.2.4-.1,2.3-1,2-.2-.5.2-1.5-.7-2-2.5,2.1.3,2.5.2,2.7-.4,1-1.8,1.4-.5,3.2-.3.3-3.5-1.6-1,.8-1,1-1.4-1.1-2-1.5s-.9,1.1-1.5.5c1.8-1.3,3-2.2.5-3.5l1-.7c-1.6.2-3.7.5-5-.8-.1-.4,1.6,0,.5-1.2,1.8-.1,2.6-.6,1-1.8,1.5-.5.8-.4.5-1.7,1.3,0,2.6-.5,3.5-1.5Z"
          fill="#023287"
        />
        <path
          d="M207.2,409.2c0,0-.9.9-1,1l-.7-1.5-1.2,1c0-.5,0-1,0-1.5,1.1,0,2.6-.3,3,1Z"
          fill="#012c80"
        />
        <path
          d="M200.7,409.7c0,0-.6,0-.6,0-1.5-2.2,1.1-1,2.6-1.5l-2,1.5,2.5.7c-1.6,1.7-2.2-.4-2.5-.7Z"
          fill="#02277d"
        />
        <polygon
          fill="#02277d"
          points="200.2 411.2 198.3 411.2 198.3 410.7 200.2 410.2 200.2 411.2"
        />
        <path
          d="M234.7,416.7c.2.1.3.4.5.5.6,1,1.3,2.6,0,3-1.7-.7-2.1,2.6-3.5.7l1.5-.2c.7-.9-2-1.4-1-2.5s1.4,1.9,2.5,1c.5-1.3-.9-.9-1-1.2-.4-1.7.9-1.1,1-1.3Z"
          fill="#02338c"
        />
        <path
          d="M236.2,417.7c0,.3-.1,1.4,0,1.5.3.2,1.8-.4,2,.2-.6.9-1.5,1-2.5,1.3,0-.2-.5-.4-.5-.5-.2-.9.1-2.1,0-3,.3.2.7.3,1,.5Z"
          fill="#012b82"
        />
        <path d="M228.2,424.2c0-1.9,1-2.5,1-.3l-.5.3c0,0-.4,0-.5,0Z" fill="#01257d" />
        <path d="M227.7,424.7l.5.5h-1c.2-.2.3-.3.5-.5Z" fill="#01257d" />
        <path
          d="M196.2,402.2c-1.7,1-1.2-2.1-.2-2.3,2.3-.4,3.4,3.5.2,2.3l1,.2c1.1-1.7,2.4-.9,4,2.3.2-.4.3-.4.5,0,.6,1.1,0,1.9-2,2.3-.1,1.9-.7,3.2-1.9,3.8,3.1-.6,5.9,2.4,4.2,5.4s-1-.8.6-1.4l.5-1.3c-2.6-3.8,3.6-5.4,2-1.2,1.1-.8.5.2.5.1.6-1.3,1.7-3.3,2.5-1.1-2.4-.8.4-1.6,2-2,.1-.4.3-.4.5,0,1.1-.4,2.9,4.4,2.7,4.9-.3,1.5-3.7,1.5-4.2,0,0-1.2-.4-2.2-1-3,.8.1,1.2,1.1,1,3,.4.1.4.3,0,.5.2.9-.6.5-.6.4s1.5.3.6,1.1c3-.6,4.8.1,7.4,1.3,1.3-1.1,2.6-1.9,3-.6l.7-.2c.1-.4.3-.4.5,0,.4.4.7.6,1,.5.1-.3.3-.3.5,0,.6,0,.7.5.5,1l.5.5c.2-.4.3-.4.5,0h1c-.4,1,1.2,1.8,1.4.7,2.1-1,3,.6,1.2,2.2,1.4,1.6-.5,3.7-1.7,4.6,3.3,4.3,1.3,9.2-4.2,4.2,1.2-.8-.8-3.1-1.3-1.7.8.7-.5,1.2-1,.5-.4.3-.9.3-1.5,0-.5.6-1.4,1-1.5,0-1.6-3.3-2.1-4.1-1.6-2.3l-.9.8c.5.1.4.3,0,.5-1.8.2-2.6-.8-3.5-2-.8-.4.2-1,.2-1-1.1,1.1-1.9.9-1.9-.7-1.2-.7-1.3.5-1.3,1.7-1.1-3.8,4.1-.6.5,0,1-1.7,2.4-.2,1,1-1.2.4-.9-.9-1-1s-.4,0-.5,0c0,.2.1.7,0,1-2.2-.7-1.1-.3-1.8.9-1.5,2.3-1.5-1.8-1.1-2.9l1,.5c0-.9.1-1.9-.7-2.5-2.4,2.9-1.3.4-1.3-1.2s-.5-1.1-.5-1.5,2-.4.5-1-2.5-.1-3.5-1.2c-.5,1.7,2.6,2,2.5,2.2-.7,1.8-2.8-1.3-3.5-.7-1.2,1,1.9,1.4,2,1.5s-.5,1.9-.5,2-1.6-.9-2.2.5c-.6-.2.2-1,0-1.5-.6-1.7-1.9-.9-2.4-1s-.7-2.1-1.3-1c-.1-.5-.5-1-.5-1.5-.6-.5-.4-.8.5-1,.1-.3.3-.2.5,0l.7-.4c-.5-.2-1.1-1.4-.7-2.1-.5.1-.9.1-1-.5l-1-1c-1.3,0-1.3-2.3-.6-2.9s3.4.1,3.6.4c-.4-1-.7-2-1-3q.4-.5,0,0c-.5.8-1.1.3-1.8-1.3,1.3-.5.9-1.2-.2-1.7h-.5c-3.3.3-.7-6.2,1-3,.4.1.4.3,0,.5l1.5.5c-.5-.7.9-1.8,1.5-1Z"
          fill="#012c80"
        />
        <path
          d="M210.2,426.7c1.1,1.6,1.1,2.3,0,2,0,1.2-.6,1.1-1,0,0-.2,0-.3,0-.5-.7-2.1-.4-2.8,1-2,.4.1.4.3,0,.5Z"
          fill="#012c80"
        />
        <path
          d="M207.2,426.2c-1-1.3-.9-1.6-1.6-2.7s-2.3-.8-1.2-2.3c.6,2.2,3.4.1,2.3,3,1.8-1.3,2.6,1.1,2.7,1,.4-.2.7-1.1,1.5-1,1.7.3-.5,1.7-.7,2-.7.9-.9.3-1,2-.5-.1-.4-.6-.5-1-.4-1.7-.8-.8-1-1s.6-1.1.5-1.5c-.8,0-.8,1-1,1.5Z"
          fill="#01257d"
        />
        <path
          d="M210.2,426.2c1.3-1,.8,1.5,1.2,1.5l.5-1.5,1.8,2c.4,1.2-1.3,2.3-1.5.7-.8.9-1.5.1-2-2.2,0-.1,0-.5,0-.5Z"
          fill="#01257d"
        />
        <path
          d="M213.2,408.7c.4.2.4.3,0,.5.7,0,.6.7,0,1-.8.4-.4,1,1,2,.5-.8,1-1.5,1.5-2,1.3-1.2,2.4.9,2.8,2.2,1.4.2,2.6,2.4,1.3,3.2l.4,1.2c.2.8-1.4,5-3,3.8.4-.3,2.7-3.7,1.2-3.7s.5.7,0,1c-.9.4-1.2.8-1.3.8-.5.2-1.9-.5-2.6.7,0-1.5.3-2.2-1.7-2-.2.2,1.7,2.8,1.8,3,.2.6-.2.9-.7,1-.3-1.2-1.5-1.6-1.8-3s.6-3.3-1-.5c-.3-1-1.6-.5-1.7-.6-.2-.2,0-.8,0-.9v-1.5c0,0,0-.3,0-.5,1.7.5,1.8.3,3.5-.5.2-.8-.7-.3-.9-.6s.4-.9.2-1.4c-.3-.9-1.3-1.5-1.3-2.5-.3-.5,2-.7,2.5-.5Z"
          fill="#02338a"
        />
        <path
          d="M213.7,410.2c1.7-.9,2.2,1.5.5,1.5-.9.2-2.1-1.1-1-1.5.1-.5.3-.4.5,0Z"
          fill="#02338a"
        />
        <path
          d="M216.7,408.2c1.4.7.4,2.3-1,2-.7.9-1.2.7-1.5-.5-.4-.1-.4-.3,0-.5-.5-.5-.2-.7.5-.5.7-1.3,1.8-2.5,2-.5Z"
          fill="#02338a"
        />
        <path
          d="M213.7,427.7c-.2-2.2-2.4-4.3,1.5-4.5l-2,1.2c.8.9,1.1,1.2,1-.2h.5c1.3,2.9,2.3.8,1.5-1.5,1.1,0,.8,1.8,1,2s1.8-.6,2.5,0l.5-1.5.5,2c-3-.5-1.3.9-2.8,2.5-2.4-.3.9-1.9.3-2.5s-1.7.4-2,.9,0,2.6,0,3.1c0,1.3.3,2.7.3,4-1.8-1.7-1.4-2.9-.8-5-1.4,1-.7-.7-2-.5Z"
          fill="#01257d"
        />
        <path
          d="M210.7,404.7l.5.5c.1-.4.3-.4.5,0-1.7.5-.7,2.6-1,3-.3.2-.5.5-.5,1,.1,2.1-1.8,1-1.9,1.1-.2.2,0,.8,0,.9-.1,0-.9-.2-1.3.1s-1,2.5-1.7.9c.9-.3.8-1.7,1-2-.5-1.4-.3-1.7,1-1,.2-.8.8-1.3,1.5-1.5.9,0,1.1,0,.5-.5-.5-1.7-.1-2.8,1-3.5,1.3-.9,1.3,0,.5,1Z"
          fill="#02338a"
        />
        <path
          d="M193.8,414.7c0,0-.1.7,0,.9s.9-.4.9-.4c.8.3,2.1,2,1,2.8s-.9-.3-1-.3l-3-3.3c0-.5,1.9.2,2,.3Z"
          fill="#022b7a"
        />
        <path d="M199.7,415.2c-2.8-.3.7-3.2-3-1.5-.8-3.1,4.4-.9,3,1.5Z" fill="#023287" />
        <path d="M208.2,411.2h2c-.6.9-.6,2.1-1,3-.3,0-.9,0-1,0s.8-2.1,0-3Z" fill="#013890" />
        <path d="M209.2,414.7c1.3.5,1.6,1.8,0,1.5-.2-.4-1.1-1.4-1-1.5s.9.1,1,0Z" fill="#031c5b" />
        <path
          d="M221.7,416.7c.4.1.4.3,0,.5l-.2,1.5c-.9-.5-.6-1.3-.8-2s0-.3,0-.5c.3-.5,1.2-.2,1,.5Z"
          fill="#02338a"
        />
        <path d="M225.2,429.2l-1.5-.2c.7-.9,1.1-.8,1.5.2Z" fill="#01257d" />
        <path d="M205.7,414.2c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#094c98" />
        <path d="M222.2,417.2h-.5v-.5c.1-.4.3-.4.5,0,.1.5,0,.5,0,.5Z" fill="#022e86" />
        <path d="M223.2,418.7c-.4,0-.4-.3-.5-.5l.5.5Z" fill="#022e86" />
        <path
          d="M192.8,405.2c.5-.1,1.1-.8,2-.5-.2.8-.9,2-.8,2.8s.8.6.8.7c-1.6-1.5,3.2-.9,2,.5-.5-.5-1.9-.4-2-.5.5,1,1.1,1.8,1,3-.9-1.1-.8-3.3-2-2.2l-.2,1.7c-1.4-.6-.2-2.4-.3-2.5-.2-.2-4.6,1.1-3.5-1.5l3.5,1-1.5-1c0-1.2,1.3.2,1.5,0s.1-1.6-.5-1.5Z"
          fill="#023285"
        />
        <path d="M225.7,419.2c.2.2-.5.8-.5.2s.4-.4.5-.2Z" fill="#012c80" />
        <path
          d="M189.8,374.2l1.7.5c1-.9,3.3-2.3,4.3-.5.6-.5.9-.2.5.5.8.4.7.5-.5.5-1,1-1.4,2.1-1.2,3.5l-1.3.3c3.1,1.5,2.5,6.4-.9,4.4l-.4,1.7c.6-1.6,2.6,1.9,2.5,2.2-.2,1.8-2.6,6.4-3.3,2.9-2.2-.2-2.5.3-3.5,2-.3.9-.7,1-1,0-.1.4-.3.4-.5,0-.2-.8-.7-1.3-1.5-1.5-.4-.3-1.3-.4-1.4-.6s.1-2.3.2-2.4c.2-.3,1.7-.9,1.8-1.8s-1.4.6-.5-1.7c0-1.2.3-2.7,1.9-2.3-.3-2.3.3-4.3,1.9-6.2-.2-1,0-1.5.7-1.6h.5Z"
          fill="#01297b"
        />
        <path
          d="M189.3,374.2c-.8,3.5,2,.8,2,3-1.8-.8-3-1.1-3.5,1h3s-3.5.5-3.5.5l.5,1.5,2-1c.4,1.6-1.8,1.3-2,1.5-1,1,1.3.8,1,1.5-1.2-.5-1.7,1-1.8,1-1.4,0-1.2-1.6-2.2,1-.3,0-.8,0-1,0-.5-.6.3-1.1,1-1,0-.3,0-.7,0-1v-.5s.6,0,.5-.5c-3.9-.4-.2-1,.3-1.5s-.4-2-.3-2.5l2,1c.1-1.6,1.4-2.3.5-4h1.5Z"
          fill="#012574"
        />
        <path
          d="M182.8,394.2c1.8-1.2.1-1-.5-3,1.8-.7,1.3.4,3.5,1,.2-.4.3-.4.5,0,.2,0,.3,0,.5,0,1.2.4,2.2.9,3,1.5l-1,2c-.4,0-.9,0-1.5,0-.1.4-.3.4-.5,0l-1,1c-.5.3-1.2.3-1-.5-.1.2-.3.2-.5,0,.1,1-.8.9-1.5.5-2.4.2-3.3-2.8,0-2.5Z"
          fill="#02297b"
        />
        <path
          d="M181.3,396.7c.4.4.3,1.1,0,1.5.6.4,1.1,1,.5,1.5-.5,0-1,0-1.5,0,.2-1.6-1.2-4.2,1-3Z"
          fill="#032e7e"
        />
        <path
          d="M184.8,390.7l.9-.8-.4.8,1.3-.5-.3,2s0,.2-.5,0c.2-.9-.4-1.1-1-1.5Z"
          fill="#023082"
        />
        <path
          d="M182.8,394.2c-.7.5-1.7.7-2,1.5.8,0,1.8.1,2,1-.4.2-.7.6-1,1,0,0,0,.5,0,.5-.1.4-.3.4-.5,0-.1-.4.1-1.1,0-1.5-.2-.7-1.5-1.7-1-3l2.5.5Z"
          fill="#01216b"
        />
        <path d="M184.8,383.2c-.1.3-.7.7-1,1-1.2-.6,0-2,1-1Z" fill="#01297b" />
        <path
          d="M184.3,396.2c.2.2.4.2.5,0,.2,0,.7.4,1,.5.2-.3.3-.3.5,0,1.1,0,1,1.2,0,1.5h-.5c-.4-.2-.7-.6-1-1-.3,0-.7.4-1,.5-.3.2-.8-.2-1-.5-.2,0-1,.5-1,.5-.3-1.5.5-.8,1-1s.9-.5,1.5-.5Z"
          fill="#012773"
        />
        <path d="M181.8,400.7v.5c-1.2-1.7,0-.5,0-.5Z" fill="#012773" />
        <path
          d="M182.8,397.7l.5.5c-.3-.6,0-.8.5-.5-.6-.8.4-1.2,1-.5.7.3.7.7,0,1,.8.8,3.3,2.9,1.8,1.5l.2-.5c1.1-2.4,7.5-3.4,5,.5.6,1.4.1,2.7-1.5,4-2,1.5-2.5,3-1.5,4.5.4,1.9-2,.5-2.5,1.1s1,2.1-3,1.4v-3.5c2-.2-.8,1.5,2,1,.3.7-2.1.5-1,1.5s2.1-2.4.4-3.4-1.5.8-2.2-.6c0-2.9,1.7-2-.7-4-.3-.1-.3-.3,0-.5v-.5c.1-.4.3-.4.5,0,0-.7,0-1.5-.5-2.5-.4-.1-.3-.3,0-.5,0-.6.5-.9,1-.5.4.1.4.3,0,.5Z"
          fill="#022b7a"
        />
        <path
          d="M190.3,403.7c.9.4,1.1,1.3,0,1.5-.3-.1-1.9.9-2,1s.9,1.1,1,2h-.5l-.7-.5c-.1,1.5-1.2.9-1.3.3s1.4-3,1.7-3.3c.6-.9.6-1.1,1.8-.9Z"
          fill="#01246f"
        />
        <path
          d="M185.8,402.7l-1,1.5c2.4-.7,2.4,1.2,1.2,3l.2-2c-3.2,1-4.4-2.2-.5-2.5Z"
          fill="#01246f"
        />
        <path
          d="M186.3,400.7c-.2.3-1.2,1.5-1.2,1.5-1,.3-.7-1.2-1.7-1,.2-1.1,2.3-.7,3-.5Z"
          fill="#012773"
        />
        <path
          d="M185.8,398.7c.3.1.9.4,1,.5.3.3.9,1.3.3,1.5-.9-1.3-2.1-.9-2.3-2.5.6-.7.8-.4,1,.5Z"
          fill="#012773"
        />
        <path
          d="M182.3,400.7c0-.4-.4-.7-.5-1-.2-.4-.4-1-.5-1.5h.5c.2.4,2.3,2.1.5,2.5Z"
          fill="#012773"
        />
        <path
          d="M184.8,397.2c1.1-.1,1.1,0,1,1v.5c-.3-.2-.7-.3-1-.5,0-.3,0-.7,0-1Z"
          fill="#01216b"
        />
        <path d="M183.8,397.7c-.1,0-.1.6-.5.5l-.5-.5v-.5c.3,0,1.1,0,1,.5Z" fill="#01216b" />
        <path d="M186.8,401.7c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#012773" />
        <path d="M184.3,399.7c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#012773" />
        <path d="M183.3,398.2l-.5-.5.5.5Z" fill="#012773" />
        <path
          d="M249.7,429.2c1.6,1.6-2.4.7-1,2s1.3-1,1.5-.2c.3,1.8.5-.2.5-.2,1.4-1.1,2.8,2.2,3.5,2.6s.8.2,1,.3c0,.3.7.9.5,1.5-3.3-1-1.7,2.2-.6,1.4s0-.8.4-.9,1.1.4,1.7.3,1.1-.8,1.2-.8c.9,0,1.8,2.7,1.2,4-1.9-1.2-4.5,1.6-5.5-.5l2.5-1c-3.4-1.8-2.6,2.6-4.5,1.5s.8-2.1-1.5-2c1.4,2.2-3.4,4.1-.5.5-.8-.2-1.6.3-2.3.3-1.6-.2-2.7-.4-4.2-.8-.4,0-.5-.2-.5-.5-1-1.3-1.1-1.3-.5,0,.4.1.4.3,0,.5-1.9,0-.6-.3-1.3-.5-2-.5-2.4,1.2-2.2-2.5l-1.5.5c-.2-.4-.3-.4-.5,0-1.4.4-1.7,2-3,2v-.5c0-.3,0-.7,0-1,0-.5.5-1.5,0-2.5,1.5,1,.8-.3,1-.5,0-1,.8-1,1,0,.2-.6.6-.5,1,0,0-1.1.7-1.1,1,0,.9,0,1.5-.5,2-1.5h.5c.7-.5.9-.3.5.5v1.2c1.1.5.6,1.2-.5,1.8-.2,1.2,0,1.7.5,1.5-.3-.2-.2-.3,0-.5-.7-.6,0-1,1.8-1.3l-.3-1.2-.5-1.5c-.4-.1-.4-.3,0-.5,0,0,.3,0,.5,0h.5c.3,0,.7,0,1,0,.9-.7,1.1-.6,1,.5-.1.4-.5,1.2-.3,1.5l1.8-.5c.6-.6-2.4-2.2,1.5-3,.2-.8,1.4-.9,1.5,0Z"
          fill="#01237c"
        />
        <path
          d="M257.2,430.7c-.4.6,1.3,2-.5,2.2l1,1.7c-.1.1-2.1-.8-2.5-1,0-.6,1.2-1.9,1.5-3,.1-.4.3-.4.5,0Z"
          fill="#01237c"
        />
        <path
          d="M241.2,431.2c0,0,.1-.6.5-.5l-.5,2c1.4.3,1-.4,1-1.5,1.3.3.4,1.4.5,1.5,1.7,1.2-.9,1.8-2,1.5.1-.8,0-2,.5-3Z"
          fill="#01257d"
        />
        <path
          d="M242.7,432.7c0,0,1.5.3,1.5.7s-1,1.1-1.3,1.2c-1.6.4-1.1-1.3-1.6.6-.2.2-.2.3,0,.5,0,.6-.5.6-1,.5-.3-.8.4-1.5.5-2,1-.6,2.4-.1,2-1.5Z"
          fill="#012482"
        />
        <path d="M242.7,436.7c-.6,0-1.5-1.4-.7-1.5h1.7s-.5,1.5-.5,1.5h-.5Z" fill="#012482" />
        <path d="M240.2,430.7c0,.7-1,2.8-1.5,2.5s-.1-.8-.5-1l2-1.5Z" fill="#012482" />
        <path d="M237.2,432.2s-.9,0-1,0c0-.5.2-.7.5-1l.5,1Z" fill="#01257d" />
        <path d="M236.2,434.2c-.6.6-1.6-.2-.2-1,.4,0,.3,1,.2,1Z" fill="#01257d" />
        <path d="M240.7,430.7h-.5c0-.2,0-.3,0-.5.2.1.3.4.5.5Z" fill="#01257d" />
        <path d="M243.2,430.7c-.2,0-.3,0-.5,0h.5Z" fill="#012482" />
        <path
          d="M222.2,437.7c1.3.2,3.1-.2,4.5,0l-1-.7c0-.6,1.7,0,2-.3,1.2-.9-1.3-.9-1-1.5,1.7.5,1-1.2,2.5-1-.9,3.1,0,3.2,3,3l-2.5,1,5,.5c-1.5-1.1-1.7-1.9-2-3.7l1.5.2c1,.1.9.6,0,1-.2.2-.2.4,0,.5.5-1.3,1.6-3.4,3-2,.1-.4.3-.4.5,0,.4-2.6,2.3-1.4,2,1.5s-.3-1.2.8.3.6-.2.8-.7c.3.7.7,1.2,1.4,1.5.3-.4.6-.3,1,0l.9-.8c2.3.6,4.7.8,6.7-.2.8.1,1.4.5,1.7,1.2,1.4-.7,3.9-1.6,4.2.6,1.3-.3,2.5-.5,2.4,1.2.3.5,0,.8-1,1h-.5c-4.6.5-9.3.4-14,0-3.7,0-7.3-.4-11-.5l-3-.5c-.5,0-1,0-1.5,0-1.4-1.5-3.6-.8-5.3-1s-1.1-.5-1.2-.5Z"
          fill="#012482"
        />
        <path
          d="M258.2,440.2c-.5.8-1.9.5-2.7.5-3.6,0-7.8.4-11.3-.5,4.6.1,9.3,0,14,0Z"
          fill="#074dcb"
        />
        <path d="M233.2,439.7c-.9,0-2.5.3-3-.5.9,0,2.4-.4,3,.5Z" fill="#0e51c8" />
        <path d="M245.2,438.7l-3,1c-.4-1.8,2-.1,3-1Z" fill="#01237c" />
        <path d="M237.7,434.7h-.5c-.2-1.4.7-1.4.5,0Z" fill="#01257d" />
        <path d="M243.7,437.2c-.2,0-.7,0-1,0v-.5c.1-.4.3-.4.5,0l.5.5Z" fill="#01257d" />
        <path d="M234.2,436.7l-.5-.2.5-.2c0,.2,0,.3,0,.5Z" fill="#01257d" />
        <path d="M247,438.7c.3.2.3.3,0,.5v-.5Z" fill="#01237c" />
        <path d="M241.2,435.7l-.4-.2c0-.2.4-.2.4-.3v.5Z" fill="#01257d" />
        <path
          d="M246.7,420.2c.2,0,.4,0,.5.3-.3,1.6-.9,2.7,0,4.2-.5,0-1.1-.1-1.5,0,0,0,.5-1,.5-1-.4,0-1.2.1-1.5,0s-.9-.8-1-1c2.2.5,1.2-1,1.6-1.4s1.1,0,1.3-.2,0-.7,0-.9Z"
          fill="#02328c"
        />
        <path
          d="M246.2,417.2l1,1c1.2.3,1.2.7,0,1-.6.1-.4.7-.5,1-1-.1-2.7,1.2-3-.5l1.1-.9c-.3-1.8.1-3.2,1.4-1.6Z"
          fill="#02328c"
        />
        <path d="M244.7,424.2l.3.5c.3,0,.6,0,.7,0-.2,0-.5.4-1,.5l-1-.7,1-.2Z" fill="#02328c" />
        <path
          d="M236.2,413.7c-.2-.1-.4-.2-.4-.4,0-4.3,1.8-4.8,3.3-.7,2.3-.6,2.8.7,2.1,2.5-.2,1.4,0,2.9,1,4.5.5.6,1,1.3,1.5,2,0,.3-.1.8,0,1,1.2.2,1.5.6,1,1v1.5c-.4,0-1.4.5-1.5.5-.3,0-.5,0-.5,0l-.5,1c.6.7-.3,1.5-1,1l-1,1c-.2.4-.3.4-.5,0,.7,2.1-3.1.8-3.2.6-.9-1.3.5-1.7,1.6-1.3l1.1-.9q.4-1.4,0,0l-.9.8c-3,.2-2.1,1.9.3,1.3,1,.7-.8,3-1.9,1.9.1.5,0,.9-.5,1-.3,0-.9,0-1,0-2.4-.2.3-.4.5-1.7s0-1.2,0-1.8c-1.8.9-2.7-.5-4.5-.5-.4-.1-.4-.3,0-.5-2.5-.4-1.1-3.6,1-1.9l.5-.6c1.6-1.2,2-1.9,2.1-4.3l2-.2c2.7,1.8,5.1,1.6,2.3-1.6-1,.3-2.8-.5-2.9-1.9-2-.5-1.9-3.6.4-3.2l-.4-.3Z"
          fill="#022e86"
        />
        <path
          d="M236.2,417.2l2.3,1.5.3-1.3c1.2-1,.9.5,1.3,1.2s1.1,1.4,1.4,2.1-.8,1.7.8,1.5c-.7,1-.9,1.3-.5,2.5-1.6.4-.5-1.6-1-2.5l-1.2,1.5-2-2c-.3.4-.4,1.8-1.2,1s.7-1.9-1-1.5c-.4,2.4.1,3.5-2.5,4-.2.4-.3.4-.5,0-.3-.1-.3-.3,0-.5-.4-.1-.4-.3,0-.5,2.9,0,1.8-3.3,2-3.5s1.1,0,1.5,0c-.2-1.4,0-2.4.5-3,0-.2,0-.4,0-.5Z"
          fill="#02338c"
        />
        <path
          d="M232.2,424.2c0,.1,0,.4,0,.5-.2.2-.2.4,0,.5,0,0,.3,0,.5,0l.5,1c-1,.9-2.4-.6-2.5-.5-.3.3.5,1.5.5,2h-2.5c0-1.5,1.5-1.3.5-3,2.9,1.4,1.4-1.4,1.5-1.5.6-.5,1.2.5,1.5,1Z"
          fill="#01257d"
        />
        <path
          d="M236.7,431.2c.5-.5,1.3-.8,1.5-1.5l-2,.5v-5s.5,1,.5,1l.5-1.5c.9.2,1.1.9,1,1.7s-1.5,0-1,1.2c.3,0,1.9-.4,2-.5.2-.3-.7-1.4-.5-1.5,1.2-.2,2,0,1.5,1.2s-1,.2-1,.2c-1.1,1.4.2,1.5-3,1.2,1.1,1.4,2.3.6,3.5.3,1-.3,1.2.2.5,1.5v.5c-.6,1.3-1.3,1.8-2,1.5-.2,0-.7,0-1,0-.6-.1-.8-.4-.5-1Z"
          fill="#022b82"
        />
        <path
          d="M242.7,413.7c1.9.4,3.3,5.5,1,5.5-1.2-.7-1.6-.9-1.5.5.2,0,.7-.2.9,0s.4,1.4.6,1.9c-1.1.3-1.4-1-1.5-2-2.7-1-1.2-2.5-3-3,.3-.9,1.3-.9,2-1.5-.7-1.8,0-2.7,1.5-1.5Z"
          fill="#02328c"
        />
        <path d="M242.7,425.7c.3.1.3.3,0,.5-.1.2-.3.3-.5.5-1.1-1.5.3-.8.5-1Z" fill="#022b82" />
        <path d="M243.2,425.7v.5h-.5v-.5c0,0-.8-.7-.3-1,.3.1.6.9.8,1Z" fill="#02328c" />
        <path d="M241.2,427.7c-.2.2-.3.7-1,1l.5-1.5.5.5Z" fill="#022b82" />
        <path d="M243,423.7c.3.2.3.3,0,.5v-.5Z" fill="#02328c" />
        <path
          d="M103.8,314.3c-2.5-1.9,1-2.7,2.4.1v2.9q.9,1.2.1,0c-1.1-.2-.4-2.3,1-1.9,0-1.1.9-1.5,2.4-1.4,1.9-1.5,5.8-2.4,4.2.8,1.8-.4,2.4-.2,3,1.5-.5,1.6,1.2,2.7,2.7,2.6,1.4.8,1.2,2.1-.3,2.7,1.5,2.4-1.4,4.3-2.3,1.5l-.7,1.1c-2.8.8-3.6,1.4-.3,2.5l.5,1c2.2,0,2.9,1.8.2,1.9s-1,.6-1.1,1.1c.3,1.6-1.2,2.1-4.3,1.5-1.2.6-2.3-2.9-2-4-.4,0-.8.1-1,.5,1.8,1,3.6,5.6,0,4.3,0-1-.8-1.5-2.6-1.3-2.4-1.9.7-4,.5-2.8l-.5,1.8,2-.5v-.5c-1.7.3-1.1-4.1-2-5-1.6-1.6-.8,3.3-1,3.7-.3.5-1.3.5-1.5.3s1-2.6.5-3.5c-.6,0-1,1.9-2,1s.7-.9.9-1.4.6-1.5.6-1.6c-.2.3.4,1.5,1,1.5.9-2.2,3.6-2.6,0-4,1.2,2.7-.7,2.1-1,2.5.7-2.7,0-2-1-4-.4-.2-.4-.3,0-.5.6-.6,1.3-1.2,2-2-.4-.2-.4-.3,0-.5-.4-.6-.5-1.2-.5-2Z"
          fill="#0223d1"
        />
        <path
          d="M111.3,332.2c-.2.4-.3.8-.5,1,3,1.7.2,5.7-.5,2.5-.2,0-.4,0-.5,0,.2-4.5-1.1-1.2-2-2l.5-1.5c-.5,0-1.1.1-1.5,0s-.8-.3-1-.5c.3-.3,2.9-.6,3-.5.3.3-.7,1.9,1,1.5,0-1.5-1-2.6-1.5-4-.4-.7.5-1.2,1-.5,1,1.4.8,2.9,2,4Z"
          fill="#011bc8"
        />
        <path
          d="M108.3,322.3c-.9,2.1,0,2.1,1.5,3.2-1.2,1.8-4.2,1.3-1.5,0-1.2-1.2-2.5-3.1,0-3.2Z"
          fill="#011ac7"
        />
        <path d="M104.3,316.8c0,.4.8,1.3.5,2h-2.5c-.1-.3-.7-.9-.5-1l2.5-1Z" fill="#021dca" />
        <path d="M104.3,316.3c-1.8.2-.9-.9-.5-2,1.7.5.5,1.7.5,2Z" fill="#021dca" />
        <path d="M106.3,317.3c.3.1,1.5.2,1.5.7s-2.6,2.3-1.5-.7Z" fill="#0113c5" />
        <path d="M109.3,328.2l-1,.5c0-.3-1.2-.5.3-1.5.4.2.5.7.7,1Z" fill="#0310a7" />
        <path
          d="M115.8,303.3c0-3.2,6.1-.8,5.6,1.8-.8.2-1.1.4-.6,1.2.3.3.7.3,1,0-.7-.8-.4-1.1.5-.5,1.9,1.8,1.2,3.2-1.4,4-1.6-1.3-2.2-.4-2.6,1,.7.6.4.9-.5.5-.1.4-.3.4-.5,0-.3,0-.7,0-1,0,0-.1,0-.3,0-.5-.3-.1-.3-.3,0-.5.1,0,.3,0,.5,0q.2.2,0,0c-.5-1-.5-1.5,0-2.5h-2.5c.5-1.4.5-2.3,1.5-3.5.2-.2.2-.3,0-.5,0-.2,0-.3,0-.5Z"
          fill="#0226dd"
        />
        <path
          d="M146.3,293.3c-.9,4.9-2.7,9.6-5.5,14,0,1.9-1.5,5.5-3,6.5-.1.4-.3.4-.5,0,.6-1.3,1.1-3.2.5-4.5,1.1-.6,2.7-1.1,1.5-2.5-2.7.9-2.1-2.8,0-1,0-1.6.8-3.1,2.3-4.7-.3-1-.2-1.8.2-2.3.2-1.1,1.1-2.6,2-3-.4-.5-.7-1.3,0-1.5.3-2,2.6-4.3,2.5-1Z"
          fill="#0517be"
        />
        <path
          d="M127.8,312.3c.2,0,.6.2.5.5.6,2,1.4,2.4,2.5,1.4l.5.6c.1,1.2.3,1.5,1,2.5-.7.3-1.1-.4-1.5-.5-.7,0-1.4,0-2,.5v.5c-.5-.3-.3-1.4-1.5-1l-.2,1.5c-1.1-.7-1.5-1.3-2.8-2-1.9-1.3-1.4-2.7.9-2-.6-.2-.4-.4.6-.5-.4-.2-.4-.3,0-.5.2-.1.2-.3,0-.5-.4-.4-.4-.7,0-1,.7.1,1.4.3,2,.5Z"
          fill="#022fda"
        />
        <path
          d="M137.8,313.8c.4.6.3,1.5-.5,2.5-.2.8-.5,1.3-1,1.5l-3-.7c.6-.9,2-1,2-2.2l1,1c-.4-1.1.9-1.8,1-2h.5Z"
          fill="#031cc1"
        />
        <path
          d="M131.3,318.3c.3-.1,1.1-1.5,1,.5h.5s1-1,1-1c.5,2.3-1,1.1-1.4,1.6-1.1,1.1,1.5,2.5-3.1,3.4-.4-.1-.4-.3,0-.5.5-1.2,1.2-2.4,2-3.5v-.5Z"
          fill="#031cc1"
        />
        <path
          d="M124.3,328.7c1.1-.3,1.9-.2,3,0,0,2.3-2.9,1.7-4,.5.4-.2.4-.3,1-.5Z"
          fill="#0125cf"
        />
        <path
          d="M129.3,322.2v.5c-1.3.3-2.8,1.3-2.5-.5.1,0,.3,0,.5,0,1-1.9,3.4-2.3,2,0Z"
          fill="#0231d6"
        />
        <path d="M130.8,316.8l-2,.5c.7-1,1.3-.6,2-.5Z" fill="#0228d4" />
        <path
          d="M223.7,261.8c.6,1.7.6,3.7,0,6,.6,2.2.3,5.2,0,7.5.4,3.9.4,7.7,0,11.5.4,4.1.5,8.1.4,12.2l-.4.3c.2.2.4.2.5,0-.2-2.4-.2-5,0-7.6l.6-.4c-.5-3.2-.7-6.4-.5-9.5.1-.4.3-.4.5,0,1.8-.6,2.6.4,2.2,3.1l.8,1.7c-2.1,1-1.5,2.1.1,3.7-.7,1.5-.8,2.5-.3,3.2-1.1,1-.4,3,.2,4.3-1,.9-1.3,1.7-.9,2.2.4.1.4.3,0,.5-.3.8-.8,1.3-1.5,1.5-.5-.2-1,0-1.5.5l-.6.4c-.4-9.5-.3-19.9.1-29.8,0-3.8,0-7.7,0-11.5s0-1.7,0-2.5c.8.5.5,2.1.5,3Z"
          fill="#0214bb"
        />
        <path
          d="M239.7,244.8c.2.2.4.2.5,0h.5c1.9,1-1.7,2.1-3.5,1.8-.9,1.8-1.8,2.6-2.9,2.3-.5,1.6-2.9,1.5-4.1.9,0-.3-.5-.6-.5-1,.4,0,1.4.6,1.5.5.1,0,.1-1.4.6-1.9s1.7-.4,2.4-.8,1.5-1.3,2-1.5,2.8-.2,3.5-.3Z"
          fill="#011b92"
        />
        <path d="M239.7,244.8c.2,0,.3,0,.5,0l-.2.5-.2-.5Z" fill="#021f98" />
        <path
          d="M228.7,250.8c.9.6.6,3.3-.8,3.3-.2,1.2-1.8,4.2-2,2.2l-.2.5v.5c.7-.4.9-.2.5.5.3.7.3,2-.5,2.6,1,2.5.7,3.6-1,3.4,0,1.6-.4,3-1,4,0-2,0-4,0-6,1.5-.7.1-4.1.6-5.2s1.1-.6,1.3-.9-.3-1-.1-1.4c.4-.9,2.3-3.3,3.2-3.5Z"
          fill="#02098d"
        />
        <path
          d="M105.3,280.3c.3-.8.7-1.6,1.3-2.1-.9-1.4,3.6-4.7,4.2-4.4,1.4.6,1.2,2.8-.5,2.5.4.2.7.6,1,1,.4.6.1,1.3-1,2.1.6.3,2.4,3.7,2.3,4.1s-.5.6-.8.8c-.2.3-.3.3-.5,0-.6.6-2.3-.1-2.5-1-.2.2-.2.4,0,.5.4.1.4.3,0,.5-1.4,1.3-4.3.7-5.5-1q-1.6-1.1,0,0c2.4,1.2,3.6,3.4,3.5,6.5l-1,1c-1.4,0-1.8-.9-2.5-1.5,0,0,1.1.2,1-.2-.8-1.4-1.6-.3-1,.2,0,0-.6.2-.9-.1s0-1.2-.1-1.4-2.7.5-3.5.5c.1-.2.3-.4.5-.5,0-.5-.3-.8-1-1-.2,0-.4,0-.5,0-.2-.3.1-.6,1-1,1-.5-.4-.5-.3-1.5s1.3-.9,1.3-1.2c-.2-.8-1.7-1.5-1.4-2.9.4-2.3,1.8-2,3.4-.9s1.1,2.2,1.8,2.5.2-.7.6-1,.8-.3,1.1-.5Z"
          fill="#011fda"
        />
        <path
          d="M90.3,289.8c.5,0,1.4.3,1.5-.3.3-2.1-1.8-1-1.5-2.7,1.2.5,1.5.2,2.5-.5,0,1.9-.6,2.5,1.5,2.8l-1.5.5,1.5,1.7c-.4,0-1,0-1.5,0-.9,0-1.6-.4-2-1,0,0-.3-.2-.5-.5Z"
          fill="#010fc8"
        />
        <path d="M98.3,286.8c.8,0,1.7,0,2.5,0,.2.7-.8.6-1.5,1l-1-1Z" fill="#011ed5" />
        <path d="M98.8,285.8l-1,1c-.2,0-.4,0-.5-.2.3-.7,1-.5,1.5-.8Z" fill="#011ed5" />
        <path
          d="M80.3,282.8c0-.1.9-1.6.5-2s-2.1.5-2-.5c1.7-.1,1.3-2.6,2.5-4,2.4,0,.5,1.2.3,1.5-1.1,1.3.2.8.7,1,0,.3.4,3.4,1.5,2.5s-.2-1.9-.2-2c-.4-.6-.9-.4-1.3-.5.2-1.7,1.6-1.3,2.5-1,1-.5,2-.8,3-.9,1.1-.8,1.7-.8,1.9,0,.4,0,.4.3,0,.5,0,1.6,1.2,2.4-1,3.7l2,1.7c-1,.2-2,.3-3,.5-.3.1-.3.3,0,.5.8.5,1.7,0,2.5,0l.5-.5c.5,0,3.5.2,3.5,1-1.9-.5-3.1.5-4.5,1h-2c-.1,0-.4,0-.5,0s.2-.6-.1-.9-1.1,0-1.3-.2c-.6-.6,1.2-2.6-2.1-2-.6,1.3,1,.9,1,1.2s-.5,1.8-.7,1.8c-.2-.6-1.3-2.8-1.7-3-.8-.3-1.7,2-2,.5Z"
          fill="#0117cd"
        />
        <path
          d="M89.8,276.8l-2.5.5,1.5,2.5c-1.4.4-.9-.9-1.5-1.2s-1.9-.6-2.5-.8c1.7-.5.5-1.7.5-2.5,3.6,3.7,4-1.6,4.2-1.5,1.4.6.2,2.3.3,3Z"
          fill="#011ad2"
        />
        <path d="M89.8,285.3c-.9.3-.6.8-2,0,.3-.9,1.4-.4,2,0Z" fill="#0112c7" />
        <path d="M87.8,283.3v.5l-1-.2c0-.5.6-.2,1-.2Z" fill="#0112c7" />
        <path d="M90.3,283.8s0-.5.5-.5l-.5.5Z" fill="#0112c7" />
        <rect fill="#010fc6" height="2.5" width=".5" x="81.3" y="279.3" />
        <path
          d="M103.3,283.3c.2,0,.6-.5.8-.5s.1.9.5,1c1.2.1,2.7,0,4.2.5.9-.8,4.8,2,4.8,2.6,0,1.3-2,2-.7.7l.8.7c.8-.2,1.2.1,1.3,1,4.4,1.4-1.5,5.6-2.3,2-1-.3-1.8.6-3.1,0s-.7-1.2-1.4-1.5c-.8-1,.3-.7.3-.6,0,.2-1.2,2.4-1.8,1.6-.1.2,0,.4.5.5.3-.9.7-.9,1,0,0,.3,1.9.9.2,2.5-.2,0-.2-2.3-2.7-2.5v-.5l-.5-.8c1.8-.3.2-3.4-.5-4.5s-.8.2-1.5-2.2Z"
          fill="#0225df"
        />
        <path
          d="M98.8,288.3c2.4-1.6,3.9-1.7,4.5-.2-.7.3-.7.7,0,1.2-1.1-.2-.7-2,.6-1.8s1.6,3.5-.6,1.8c1.2-.3,2.1.2,2.5,1.5.4.1.3.3,0,.5-.1.5-.6.9-1.5,1h-.5c-.8.2-1.3-.4-1.7-1l-.3.5c-.4.4-.9.8-1.5,1v1l-1.8,3c0-2.9,1-3.8-2.7-3l2,1-1.8,1.5-1.7-3-1.2,1c-.1,0-.5-1.8-1.7-1s.5.8.5,1l-2.5-1.8c2-.7,1.1-1.7-.5-.7.1-1.5.2-1.8,1.5-2,.4,0,.6.2.5.5.4.6,1.1,1,2,1,0-.8.4-.8,1.5,0,.4,0,.9-.7,1.3-1l.5,1c1.5-.5,1.4-.6.8-2l1.5-.3c-.3-.3-1.9-.4-1-1.3s1,.5,1.5.5Z"
          fill="#011ed5"
        />
        <path
          d="M101.8,291.8l-1.5-1.5c1.4,0,3.4.3,3.5,2s-1.7.8,1,1.2l-3,.3c.5.7,0,1.6,0,2l-1.5.7c-.1-1.6,1.6-1.3,1-3.2-.1-.2-.7.5-1,.5s-1.4.2-1.5-.2c0-.4,1.1-.4,1.5-.7.5-.4,1-.7,1.5-1Z"
          fill="#0224da"
        />
        <path d="M92.8,291.3c-2.8,0-1.5,0-2-1l2,1Z" fill="#011ad2" />
        <path d="M101.8,291.8c.3,1.3-.3,1-1.5,1,0,0-.4-1.5,1.5-1Z" fill="#0111c0" />
        <path d="M91.1,292.3c.3.2.3.3,0,.5v-.5Z" fill="#0112c7" />
        <path
          d="M89.8,251.8c.8-.4,1.4,0,2,.5,1.6,0-.8,4.2,3,2.5,0,.4.2,1.2,0,1.5s-1.1-.6-1.5.3c1.2-.3,1.1,3.5.9,3.7-.2.2-.8,0-.9,0l-.3-.5c-.5,0-.8.3-1.2.5-.8-1.4-1.6-1.7-2.4-1-1.4-.6-2.8-1.2-4.1-2-.4.1-.4,1.1-.7,1-2-.8.6-3.2,2.2-2l-1.5-1.2c1.1-1.8,3.4-1.7,4-3.8,0,.3.4.4.5.5Z"
          fill="#0218d2"
        />
        <path
          d="M75.3,239.3c1.3.1,1.2.5,0,1q-.8.3,0,0c.7-1.4,1.4-1.4,2,0-.3.3-.9.5-1,.5,0,.2.7,1.4.5,2l1-.5c.3.7-.8,2.5-.8,2.7.1.8,1.4,1.4.3,2.8l1.5-2c1,0,.5,2.4,0,2.8s-1.8-1.4-1.5,1.2l-1.5-1.5-.5,1.5c.2-1.5-1.8-1.8-2-2s.6-1.3.5-1.4c-.1-.2-2.9-.6-3-2,.4,0,2.9-.4,3-.5v-.5c-.1-.1-1,0-1-.5-1.1-.8-.7-1.2.5-1.5-.5,0-.5-.4,0-1-.9-1.2-.2-1.9,1-1,0,0,.6.5,1,0Z"
          fill="#0110c7"
        />
        <path
          d="M75.3,239.3c0-.1.5-.2.7-.5s-.2-1-.2-1c.8-.6,2,1.8,2,2.3s-.4.2-.5.2c-.6,0-1.4,0-2,0,0-.3,0-.8,0-1Z"
          fill="#0106bc"
        />
        <path d="M75.3,240.3c-.1,0-.5.7-1,.5-.2-.7.3-.5,1-.5Z" fill="#0113cf" />
        <path d="M76.3,244.8c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#0113cf" />
        <path
          d="M76.8,204.8c.7.3.7.7,0,1v1.5c2.9.3,5.5.7,2.5,3.5q-.9.8,0,0c.3-.9.7-.9,1,0,.4.4,0,.6,0,.5,1.8-1.6,4.4-2.8,4.2.9s-1,3-1.9,3.6,0-1.9,1.9.5c-1.3,3.7-.1,4.2,3.2,2.6,2.1.5,4,1.9,1,2.1-.7,2.3-1.7,3.4-3.7,1.3-.1,0-1.4,1.4-.7,1.9,2.7,2,.9,5.5-.6,7.7-3.6,1.4-.6,3.9,2.2,4.6,1.5,1.6-.3,2.8-2,2.8-1,2.5-3.2,1.7-3.2-1-1.6.1-1.4,1-.3,2.1-1,2.3-.8,3.1.7,2.4,1,.5,2.7,2.6,2.3,3.8,1,.3,1.8.7,1.6,1.7h.7c1.4-.7,2.2-.1,2.7,1.4,1.6-.8,2.3,1.8.8,1.6.8,1.3,0,2.5-2.5,3.6,1,1,.3,1.7-2.1,2.1l.6.2c.9.2,1.4.4.5,1,1.3-.1.5,2.7-.5,2.5-1.6-.6-1.4-2.9-1.5-3-.2-.2-1.7.2-2,0-.5-.5,1.3-2.1-2.5-.9.4,1.5,2.9.4,1.6,2s-1-.3-.1,1c-.9.6-4.3-1.8-2-2.7-1.7-.4-.8-2-.5-3.2-3-.4-.4,2.5-3,1-.4.7,0,1.2,0,1.5,1,.2.9.5,0,1,.3.2.3.3,0,.5-1.5-1.6-.6-.6-2.5-.5.5-1.5,1.9-1.7,2-3.7l-.3-.3c-.3.2-.2.5-.2.5l-.5.5c0,0-.4,0-.5,0-.4.8-.6.7-.5-.5,0-.1,0-.4,0-.5.6-.9,2-1.9,2-.5.7-.3.7-1.2,1-1.5l.5-.5c.2,0,.4,0,.5,0,.3,0,.5-.2.5-.5,0-.2,0-.3,0-.5l-.9-1.5c-.1-.8-.1-4.1.2-4.9-1.4-1.5-1.8-2.9.7-3.1-.1-.5-.8-.8-2-1-.3.9-1.3,1.1-1,0-2,.2-2.5-4-.1-3.8l-.4-.5c-3.5.5-3.1-2.7.4-2.5l1.5-.8c-1.1-1.7-2-3.2.7-2.8h.5c-.4-.1-.4-.3,0-.5v-.3c-.9-.6-3.5-5.6-.6-6.4-.6-.8-.9-1.5-.9-2.3-.4.7-1.1.1-1.5-.5-1.7-1.3-1-3,1.2-3.3l.4-.8c-1.5-1.6-3-3.7,0-4.4.2,0,.8.7,1,.5.3-.4-.5-1.3-.5-1.5-1.2-.7-1.6-2.2-.3-2.7-.2-1.5,0-3.8,1.3-1.8Z"
          fill="#0113cf"
        />
        <path d="M77.3,250.3c0,.3.8.8.5,1.5-.6,0-.8-.9-1-1l.5-.5Z" fill="#0110c7" />
        <path
          d="M75.3,210.3c-.2,0-1,1.2-1.5,1.2.4.9,1.9.7,2,.8.1.1-.5.9-.5,1.2s1.3,0,1,1.5-2.2,1.5-2.5,1.8.6,1.6,0,2c.7-.2,1,.3,1.5.5,2.2,3.1-2.6,1.3-1.5-.5-.7,1,.5,1.7,1.5,1.7.9,1-2.5,3-2.5.3-3.2-1.6-3.9-2.9-2-4,3-1.3,2-4.7,2.7-6s1.6-1.4,1.8-.5Z"
          fill="#010ac4"
        />
        <path
          d="M80.8,252.8l2,1v-2.5c.3-.3,2.3.8,2.5,1.3.4.8-.7.6-.8.9-.5.8-.3,3-1.4.3-1.9,2.6-2,.7-3.3-1,.3-.7.7-.7,1,0Z"
          fill="#021cd6"
        />
        <path d="M79.8,252.8c-.1-.2-1.5-.7-.7-1h3.2c.3,1.4-.5,1-1.5,1s-.7,0-1,0Z" fill="#0105bc" />
        <path d="M77.3,252.3l-1,1c-.1-1,0-1.1,1-1Z" fill="#0110c7" />
        <path
          d="M78.8,205.8c.8-.7,1.1-.4.5.5.8.5,1.3,1,1.5,1.5,0,1.2.9.5-.5,3-.3,0-.7,0-1,0,.3-1.9.7-.9,1-2.5-2.3-1.2-1.5,1.4-3.5,1.5,0-.8,0-1.7,0-2.5.3-1,.6-1.9,1-2.5.1-.4.3-.4.5,0,1.1-.3,1,.1.5,1Z"
          fill="#010bc8"
        />
        <path
          d="M79.3,210.8c0,.6,0,1.4,0,2-.8.2-.3-.7-.6-.9s-2.9.9-1.7-1.6c.7.2,1.5.4,2.2.5Z"
          fill="#0106c4"
        />
        <path d="M77.8,204.8c-.2.8.3,2.2-1,2.5v-1.5c0-.3,0-.7,0-1,.3,0,.8,0,1,0Z" fill="#0103b0" />
        <path
          d="M76.8,228.8c1.4.2,2,1.4,1.2,1.5h-1.2c.6-1,.4-1-.5-1.5.1,0,.4,0,.5,0Z"
          fill="#0110c8"
        />
        <path d="M76.8,207.3c0-.6-.5,0,0-1.5v1.5Z" fill="#010ac4" />
        <path
          d="M85.3,191.8c.2-.4.3-.4.5,0,1.1.6,1.4,1.5.5,2.5l.7,1.3c1.3,0,2.2,2.9,1.8,3.7,0,.9-1.3.4-1.2.4,1.8,0,3.9,1.7,1.7,2.6-2.5-.9-2.9.8-2.1,2.9l-1.4,1.6c-.4.3-.4.7,0,1,1.6.9.9,1.5-2,2-1.9-.7-.9-1.4-2.5-2.3l2.5-2.7c-1.5-.1-2.9,1.6-3,3l-2-.5c0-.4.5-.8.5-1,1.1,0,.9-.1-.5-.5-.1-.3-.5-1-.5-1,.2-.8.5-1.5,1-2-.2-.5-.7-.8-.5-1.5l2.5.5c.1-.5-.1-1.8,0-2,.9-1.2.9,1.4,1.5,1,.2-2-.8-3.6,0-5.5-2.3,1.8-1.1.6-1.5,0,.2-3.1,1.2-6.7,4-3.5Z"
          fill="#0112cf"
        />
        <path
          d="M74.8,195.3c.3-2.1-.2-1.3-.5-2.8s.3-2.5-.5-3.7l2.5,2c1.1-1.5-.6-4.1-.5-4.7.2-2,1.6.8,1.7.7.6-.3,1.4-2.9,2.7-2s.3,1.4,1.5,2.5c2.1-1.7,2.9,1,.3,2.2l.5.5c-.8,1.2-2.1,2.6-3.1,3.2,1.6.3,2.1,1,1.7,2,1.3.1.2.4.2.4.3-.2,1.3-.9,1.4-.9.5.1,1.1,5.7.9,5.9-.5.7-3.2,2.7-3.9,1.6l-.6.5c0,.6-.9,1.4-1.5,1q-.9-.5,0,0c.8,0,.6.5,0,1-.3.9-.7.9-1,0-.3,0-.7,0-1,0,.2,1.4,0,3.2,0,4.5l-1.5-.7c.3,2.1-.8,1-2,.7-.2-.9.8-.3,1-.5.9-1-1.4-.4-1.5-.5-.5-.8,1-2.7,1.8-3,1.4-.5,0,2.1,1.7,1.5-.7-1.4.4-3.5.3-4.3s-1.1-.8-.8-1.7l2.5,1-2.5-1.5,1.5-2.5c-2.5,2.2-1.8.1-2,0,.3-.7.4-1.8.5-2.5Z"
          fill="#010ac4"
        />
        <path
          d="M78.3,204.8c0,0-.3,0-.5,0,0-.3,0-.8,0-1s1.2-.7,1.5-1c0,0,.5.1.5.2,0,.3-1.4,1.1-1.5,1.8Z"
          fill="#0118d5"
        />
        <path d="M77.8,203.8c-.3.5-1.2.5-1.5-.3-.5-1.3,2.2-1.1,1.5.3Z" fill="#0103ac" />
        <path d="M80.3,200.3c-1.1-.4-1.2-.8-.2-1.5l.2,1.5Z" fill="#0112cf" />
        <path d="M78.1,200.3c.3.2.3.3,0,.5v-.5Z" fill="#0112cf" />
        <path
          d="M73.8,218.8c-.1,1.5,1.8,2.4,1.5.5.4.2.9.8,1.2.8s1.3-1.5,1.7,0-2.1.8-1,1.7,3.5.3,1,2.5c.9-1.8-1.9-1.9-2.5-1.5-1.2,1,1.3.7,1.5,1.2s-3.4,2.2,1,1.2c.7,2.6-1.7.5-1.5,2.5l2.5-.5c-.1,1-1.8.9-2.5,1-2.2.1-2.7,2.1-.5,2.7-.3,1.2-1.3,1.7-2.9,1.5-2.2,1.8-2.6-1.7-2.1-3.5-1.3-1-1-1.7.4-2.2v-.5q.2-.2,0,0c-.3,0-.8,0-1,0-.4-.5-.6-.8,0-1-.4-.4-.6-.9-.5-1.5-.7-.2-.8.2-1.5-.5h.5l1.8-1.2c-.4-1,.7-1.9,1.7-1.3.3-.2,1.3.7,1.5.5.5-1.6-1.8-.8-1.5-2.5.3,0,.8,0,1,0Z"
          fill="#0110c8"
        />
        <path
          d="M70.3,223.8c.3,0,.7,0,1,0,.1.6-.4,1.1-.5,1.5,0,.6-.3.6-1,0,0-.1-.9-.3-.5-1s.8-.2,1-.5Z"
          fill="#000394"
        />
        <path d="M72.3,225.3c-.2-.2.4-1.8.7-2,1.7.9-.2,2.5-.7,2Z" fill="#0108b0" />
        <path d="M71.8,226.3c-.2-.2.5-.8.5-.2s-.4.4-.5.2Z" fill="#010bc4" />
        <path
          d="M71.8,226.8l-1,1c2.2-.4,1.4.8,1.5,2.5l-1,.2c1.3.4,1.1.9,1,2.3.9-1.7,2.9-.9,3-1,1.1-1.2-3.6-1.7-2-2.8s2.4-1,2.8-1.1.6.4.7.4v.5h-.5c-.7.2-1.2.7-1,1.5.9.7,3.9-.2,3.5,1.5l-3-.3,2.5,1.7c-.5,0-2.2.8-2.5.5s.5-1.7-.5-1.5c.2,2.2-2.1-.4-3,1.3-.2,1.5,1.1.2,1.7.2s3,3.5-.7,2.5l1,3c-.7.4-.6.6-1,1-.2.4-.2.7,0,1,.1,1.2-.5,1-.5,1.5-.6-.1-2.3.7-2.5.5-.6-.4-1-2.8,1-2,.2-1.6-.9-1.5-1.2-2-1.4-2,1-1.3,1.2-1.5,1.1-1.3-1.4-3.4-2.9-2.5,2.3-1.9-.1-3.9.2-5s2.2-4.2,3.3-3.5Z"
          fill="#010bc4"
        />
        <path d="M73.3,241.3c-1.9,0-.7-.3,0-1,0,.3,0,.7,0,1Z" fill="#0113cf" />
        <path d="M73.3,239.3s-1.1.2-1-.2c.8-1.4,1.6-.3,1,.2Z" fill="#0113cf" />
        <path
          d="M238.7,67.9l2,1.5c-.4.6-.9.7-1.5.8-11.4,1.8-22.8,3.5-34.1,5l-.8-.8c-.6-.7.3-1.2,2.8-1.5l.7-.5c10.5-2.4,20.4-3.1,31-4.5Z"
          fill="#7c85e0"
        />
        <path
          d="M207.7,72.4c-.3,1.3-1.8.8-2.6,1.1s-.8.9-.9.9c-.6,1-1.7,1.7-2.8,2.1-12,2.7-23.7,6.3-35.1,10.9-.7,1.6-5.5,4.1-7,3-.4-.1-.4-.3,0-.5.1-.5.3-.4.5,0l1.5-1c.1-.4.3-.7.5-.9,3.7-2.7,14-6.7,18.6-8.2s.9,0,1.4.2l17-5.1c3-.8,5.9-1.8,9-2.5Z"
          fill="#7e8ce7"
        />
        <path
          d="M198.7,74.9c-8.7,3.1-17.8,5.2-26.5,8.8s-7.3,3.7-11,5.2l-1.5,1c-.1,0-.3,0-.5,0,0,.3-.3.6-.6.6-4.1,1.2-.3-1.9,2.1-2.6.2-.9,1.2-1.6,3-2,1.4-.8,3-1.3,4.5-2,3.3-.7,6.4-2.7,9.5-4s8.9-3.4,13.5-4.5c-3.1,1.6-6.6,2.2-9.6,3.6s-1.6.9-.1.9c5.5-2.3,11.5-3.5,17.3-5Z"
          fill="#8a9ae7"
        />
        <path
          d="M163.8,85.9c-1,.5-2.1,1.4-3,2l-3,1.6c-1.2,1.4-3.6,2.7-5.5,2.4,2.1-1.9,6.4-4.4,9-5.5s1.8-.1,2.5-.5Z"
          fill="#2c42d5"
        />
        <path
          d="M389.6,160.8h1.5c-.9,1.9.6,1.8,1,2.5s.1,1.3.5,1.7,1.8.2,2,1.3c0,0,.2.7-1.5,1.5-1-.3-2-.4-3-.5-.3.3-.6.7-1,1-.1,0-.4,0-.5,0-.9,1-1.2.8-1-.5l-1-.5v-.5l-.5-1c-3.4.9.5-2.2.5-1.4,0,1.3-1.6.6,0-.6.4-.3.6-.6.5-1,.3-.6.6-.5,1,0,1.1-2.2,3.1.7,1,1.5.3.2.7.2,1,0-.1-.5-.2-1.1-.2-1.7-1.5-.2-1.5-2.2-.3-1.8Z"
          fill="#0348f0"
        />
        <path
          d="M394.6,166.3c-.5-1.1,3.6-.8,3.8-.7.7.6.9,1.6-.3,1.7.1,1,.7,1.2,1,.5-.6-.8-.3-1,.5-.5.3,1.9,2.6,1.9,3,3.7s-1.1,0-2.2.7-.7,1.4-.8,2c-.2,0-.3.1-.5,0-1.8-.6.7-.3,1,.7s-1.1,1.6-1.5,1.2c-1,.8-2,0-2.5-1-.9,1.4-1.4,1.1-1.5-1-.8.8-5,1.9-4-.5q.6-.7,0,0c-3.1.5-2-4.8,1.2-2.8l.5-.3c-.7-.5-1.7-1.4-.2-1.8-.3-1,.4-1.3,1-.5-.1-1.2.3-1.7,1.5-1.5Z"
          fill="#0232ec"
        />
        <path
          d="M398.6,175.8l.7-1.5-2.2-.7c1.7-2,1.9,0,2.5.2,1.2.7,3.4.9,3.5,1,.3.2-.7,1.5,1.5.5-.9,4.2-3.3-2.3-5,1-.6.4-1.2.2-1-.5Z"
          fill="#0338ef"
        />
        <path
          d="M398.6,175.8c.3.1.5.5,1,.5v.5c-.3,0-.7,0-1,0-.6.7-1.1,1-1.5,0-.4-.1-.4-.9-.8-1-1.3-.3-.3,1.2-1.2,1l1-2c.8.3,1.7.6,2.5,1Z"
          fill="#044af3"
        />
        <path d="M398.1,167.3c.1.2.7.3,1,.5,0,.2,0,.7,0,1-1,.2-1.3-.6-2-1.3l1-.2Z" fill="#011ddb" />
        <path d="M395.6,170.3c-1,.1-1.1,0-1-1l1,1Z" fill="#0350f4" />
        <path d="M396.6,163.3c-.2.2.1,1.5,0,2-2.4-1.9-.2-1.8,0-2Z" fill="#033ff3" />
        <path d="M398.6,176.8l-1.7,3,.2-3c0,0,.6-.2,1.5,0Z" fill="#0126e8" />
        <path
          d="M396.1,180.8l2,1c-.5,3.9-.8,1-1.5.5s-.9.1-1,0c-.2-.3.5-1.3.5-1.5Z"
          fill="#031cdb"
        />
        <path
          d="M401.6,186.8c-.4.5-.7.8-1,1.5-.7,0-1.2.2-1.5-.5h.5l.5-.5c.1-.2,0-.6.5-1,.6-.2,1.2-.2,1,.5Z"
          fill="#021ade"
        />
        <path d="M402.1,185.8c0,.5-.3.7-.5,1l-1-.5c.8-.7.9-.3,1.5-.5Z" fill="#0229e7" />
        <path
          d="M388.6,159.3c.2.2.4.2.5,0,.7.3.4.3.5,1s0,.3,0,.5-.4.1-.3.5c.6,1.3,1.6.5.8,3-.4.7-.9.9-1,0,.2-.5.7-.8.5-1.5-.5,0-1,0-1.5,0-.4-.1-.4-.3,0-.5-.7-.6-.7-1.3,0-2-.8,0-1-.4-.5-1,.3,0,.7,0,1,0Z"
          fill="#0236e8"
        />
        <path
          d="M397.6,150.3v1c0,1.4-1.2,1.6-2,.5,0,.5.2.7.5,1,1.5-1.3,3.3-.2,2,1,0,0,0,.5-.2.8-.8.8-1.8.4-.8,2.2l-2.5-.5c-.2.9,1,.2,1,.8s-.6,1.1-.7,1.7.3,1,.2,1.2c0,.4-1.8.1,0,2.3-.7.8-.3,2.8-2.8.5l-.2.5c-.8.7-1.6-.1-2.5-2.5-.5-.1-.4-.3,0-.5,0-.6,0-1.1.3-1.6-2.3-.3-1.8-1.7-.8-3.4.4-1.2,1-2.5,1.7-3.8l1.3.3h1c.2-.8,1.2-1.1,2-1,.3-.1,1.9-.3,2.5-.5Z"
          fill="#0233ea"
        />
        <path d="M394.1,157.8c.8,1.3-2.8,1.9-2-.5.7.4,1.1,1,2,.5Z" fill="#0322e2" />
        <path
          d="M393.1,159.3c0,0,0,2.6-.5,2.5.2-.7-1-1.6-1-1.7,0-.3,1.2-1,1.5-.7Z"
          fill="#0121db"
        />
        <path d="M396.1,152.8c0,0-2.3,0-.5-1l.5,1Z" fill="#0222dd" />
        <path d="M394.1,154.8c.2.2-.9,1.3-1.5,1-.2-.2.9-1.3,1.5-1Z" fill="#0450ee" />
        <path d="M393.1,151.8l-.7.5-.3-.5c.2-.1.8.1,1,0Z" fill="#0220dd" />
        <path d="M393.9,151.8c.3.2.3.3,0,.5v-.5Z" fill="#0220dd" />
        <path
          d="M374.1,158.8c0-.5.3-.4.5,0,.6.7.4,1-.5.5-.6.6-.9.6-1,0-.3-.8.4-1.1,1-.5Z"
          fill="#0358f4"
        />
        <path
          d="M383.1,142.3c.1.3.6.9.5,1-2.6-1-.9,3-.5,2.5l.3-1.5c.2,1.2,1.3,1.7,1.8,2.5,1.1.1,1,.8,0,1-.8.2-1.4,1.4-1,2s1.8-2.3,1.5,0c.9-.3,1,.2.5,1-.7.2-1.8-.6-1.5,1l2.5.5c-1.7-.2-4.8,1.4-3.5-1-.2-.2-1,1-1.5,1-1.3-.7-1-2,.5-2-.6-.3-.9-1-1-2-1.4-.5-3.1-1.6-.7-1.3s.4.8.2,1.3c.6.8,0,1.3-1.7,1.4l-.8,1.6,1.1.4c1.1-1.2,2.6-1.1,2.4.6,0,.3,0,.7,0,1,.8.5.5,1.2-1,2,.9.2,1.1,1.1.5,2.5.2,2.7-4.6,3.6-2.5,1-.5,0-.8.4-1,1-.3,1-.7,1-1,0-1.2.8-2.8.9-2.5-1-.4-.6.3-1.6,1-2-.4-.1-.4-.3,0-.5-.3-.6.4-.8,1-.5.7.8.5.3-.4-1.4,1.6-1.8,1.3-2.5-.7-2.1-3.8-1-3.6-2.2.6-3.5-.5,0-.7,0-.5-.5,0-.2,0-.4.5-.5l.2-1.2c2,.5,2.8-.2,2.8-.8-1.3-.7,0-2.1,1-2-.1-.3,0-.7.5-1,.2-1.4.4-1.2,1,0,1.1-.5-.5-.6,1.5-.5Z"
          fill="#0358f4"
        />
        <path
          d="M384.6,156.3c.2,0,.7.4,1,.5,0,.2,0,.7,0,1l-1.5-.2c.7,1.6,3.3,1.8,0,2.5.7.6,1.7,1.4,2.5,1.8.5-1,1.8-.7,1.5.5v.5c-.3,0-.7,0-1,0-.3,0-.5.4-.5,1,.2.5.2,1,.5,1.5h-2s0,.5,0,.5c.3,0,.7,0,1,0,.8.7-.5,1.8-1,.5h-.5c-.2.4-.3.4-.5,0-1.2,0,0-2.1,1-1.5.3-.6.2-.9-.5-1-.1.4-.3.4-.5,0-.2.2-.2.4,0,.5.5.6.2.8-.5.5-.1.4-.3.4-.5,0-.8.6-1,.3-.5-.5-.9-.4-.5-1.4.2-2l-.2-.5c-.8.8-1.4,1.4-2,2-.5.4-.8.1-.5-.5l-1.5.5c-.1.3-.3.3-.5,0-2.3-.3.6-3,1.5-2.5q.9.5,0,0c-.5-.5-1.1-.1-1.7,1.3-1.6.8-1.6-1.4-.8-1.8-1.3-.4-1.3-.6,0-1,.3,0,.7,0,1,0,0-1,0-1.6,1-1,0,.1,0,.7,0,1,1.6.3.3-1.6,2.5-2-.8-1.4,2-2.9,3-1.5Z"
          fill="#035ff6"
        />
        <path
          d="M384.6,154.8c.2.6.5.9,0,1.5-.4,0-1.2.5-2,.2l.5,1.8-1.1-.9c-.2,0-.3.4-.4.4-1.2.1-.5-2.3-.5-2.5,0-1.4,2.6-1.5,3.5-.5Z"
          fill="#034af2"
        />
        <path
          d="M381.1,155.3c0-1.1-.8-1.8.3-2.5l.3.9c.3.1.4-.4.4-.4,1.8.2,2,.1,2.5,1.5l-3.5.5Z"
          fill="#0368f7"
        />
        <path d="M385.6,149.8c.3-1.3,3.2-2.9,1,.5,0,0-.1.4-.5.5,0-.3-.5-.8-.5-1Z" fill="#022ce4" />
        <path
          d="M270.2,73.4c2.7-.6,4.3,1.7,1,2.5.5,1.5-1.2,1.3-2,.5l-1.4.4c-.7-.8-1.6-1.3-2.6-1.4-.2.3-.3.3-.5,0,0,.6,0,.8-.5.5h-.5v-1c.3-1.3-1-2.7-2.5-4-.2-.3-2-1-.3-1,1.5,0,4,2.8,4.6,2.9,1.5.3,2.5,0,4.7.6Z"
          fill="#5671d9"
        />
        <path
          d="M263.7,74.9c-.2.1-.4,0-.5-.5-.4-1.3-.9-1.5-1.5-2.5s-.3-.7-.5-1c1.2,0,3.7,2.7,3.3,3.5s-.7.3-.8.5Z"
          fill="#435fb3"
        />
        <path
          d="M272.7,73.4c1.5.3,5.7,1.6,6.7,1.5s.2-1.8,1.3-1-.7.5,1.5,1c1,.4,1,.7,0,1-.7,1.1-1.4,1-2.5.4-1.6.6-5.5,1.2-6.5-.4-.7,1.3-1.5,1.5-2,0l1-1.8c-.5-.9-1.4-.6-2-.7.4-.9,1.7-.2,2.5,0Z"
          fill="#5e7ee2"
        />
        <path
          d="M240.7,69.4c.3,0,.7,0,1,0-.7.5-1.6,1.4-2.5,1.5l-.6.5c-6.4.8-12.8,1.9-19.2,3.2-1.5-.4-2.8-.6-4.1.2l-.6,1.1c-4.3.8-8.7,1.4-12.9,1.4,0,.3-.2.6-.3.6-5.1,1.4-10.6,2.4-15.8,3.2-5.9,2.6-12,4.7-18.3,6.5l-1-.3c5.2-2.7,11-4.8,16.6-6.6s14.4-3.7,21.4-6.4c1.5-.3,3.3-.3,4.7-.5,5-1,9.3-.7,14-1.5s11.1-2.4,17.8-3Z"
          fill="#7080e4"
        />
        <path
          d="M293.2,75.9c.1,0,.7,1.6,1.8.5l-.3,1c2-1.1,1.7.9,2.3,1s2.7-.6,3.8-.4c1.6.4,4.5,1.9,6.3,2.3l-1,1-.3.6c-1.8,0-3.5-.3-5.2-.6-.3,1.5-2.3.3-3.3-.3-2.3,0-5.5-1-6.7-2.7-.3.8-.7.8-1,0,.2.9-.2.9-1,0-2.2-.8-4.5-1.2-6.9-1.3-.1-.5,0-.9.4-1.2v-1c1.2.3,3.7,1.2,4.2,1.3,1.7.2,4.7-.6,6.8-.3Z"
          fill="#6183e9"
        />
        <path
          d="M309.2,84.9c-1.4-4,3.8.2,3.4.3s-.6-.6.1-.8l2.5.5-.5,1.5c1,.1,2.2-.2,3.2,0s.3,1,.5.9c.5,0,1.1-.6,1.9-.5s3.1,2.2,4.4,2.7c2,.8,4,.8,5.7,1.3s3.2,1.5,4.7,2c-2,1.2-1.7.7-4,1-.8-.2-1.6-.5-1.5-1.5-2.2.6-3.5.3-4.1-.9-2.5,0-4.3-1-5.5-2.8-2.2.5-3.4.2-3.4-.8l-.5-.2c0,1.2-.9,1.3-2.9.2-.3,1-.7,1-1,0,0,.4-.3.4-.5,0-1.4.1-2-.5-2-2-.1,1-1.2.8-1.5,0-.5-.7.6-.9,1.3-.7l-.3-.3Z"
          fill="#4a7be7"
        />
        <path
          d="M300.7,81.4c1.2-.8,2.6-1.4,3,.5.8.3.2-1,.8-1s1.2.4,1.7.5c2.2.4,4.1,1.6,6,2l-.5.2,1,.8.2,1-3.5-1.5c-.4,0-.3.7-.3,1-.1.3-.3.3-.5,0-1.2-.4-2.2-1.1-3-2-1.4,1.3-4.3.7-5-1-.4-.2-.4-.3,0-.5Z"
          fill="#567ce7"
        />
        <path
          d="M335.7,92.9c.3.1.4.7.6.8s.7-.4.8-.3c.2.2.3,1.4.6,1.4-.8-.4-2.3.4-2-2Z"
          fill="#4a7be7"
        />
        <path
          d="M307.2,80.4c8.8,2.3,16,4.9,24.5,7.5,1.6,1.6,4.2,1.8,6.2,3.1s.6.8.8.9c-2.4.3-4.6-2.1-6.8-2.5s-4,.5-4.2.4-.3-1.2-1-1.7c-1.8-1.4-6.2-2.1-8.4-2.9s-1.6-2.4-3.6-.8c-.4-.5,0-.9.5-1-.1-1.3-1.4,0-1.5,0-.2.3-.5.3-1,0-.2,0-.3,0-.5,0-1.8.7-5-.4-6-2-1.1-1.1-.2-1.1,1-1Z"
          fill="#637fe4"
        />
        <path d="M315.2,83.4c0,.4-.3.7-.5,1l-.5-.3c-.2-.9.1-.8,1-.7Z" fill="#567ce7" />
        <path d="M313.7,83.4l-.3.5-.7-.5c.3,0,.7,0,1,0Z" fill="#567ce7" />
        <path d="M307.9,80.9c.3.2.3.3,0,.5v-.5Z" fill="#6183e9" />
        <path
          d="M333.2,96.4c.8,0,.8-1.6,1.3-1.5s4,1.8,4.6,2.2.5,1.3.6,1.3l-.5,1.5c-1.4,1.4-2.6.4-3.4-1.5-1.7-.1-2.2-.6-2.6-2Z"
          fill="#3472e6"
        />
        <path
          d="M332.2,95.4c.4,0,1.3-1.2,1.5-1,.5,1.5-2,.7-.5,2,2.3,2,1.9.1,2,0,1.2-1,.8,1.2,1.1,1.4s2.3-.2,1.4,1.1-2,0-1,1,1.5-.2,2.5,0c2.2.5,3,1.4,4.5,2.5l-2,1,1-1.5c-.9.4-1.3.1-2,0-.2-.2-.3-.2-.5,0-2.1,1.3.2-1.2-2-1l-2,1.5c1.8-1.5.1-4.7-2-3,.2.4,0,.6-.5.5-.7.7-1.1.4-1-1-.1-1-.3-.8-.5.5-.4.8-.7.9-1,0-1.1,0-2.8-1.8-2-2.5.3-2.4,1.2-2.6,3-1.5Z"
          fill="#2a75e9"
        />
        <path
          d="M331.2,93.9c-.2,0-.4,0-.5,0-.7.8-1.2,1.8-1.5,3-.2,1.1-.7,1-1,0-.9,0-1.2-.6-1-1.9-2.5,1.3-5.1-1.1-2-1.6.2-.4.6-.3,1,0,.5-.8,1.6-1.2,3.5-1,.8.3,1.6,0,1.5,1.5Z"
          fill="#3572e6"
        />
        <path
          d="M330.7,93.9c-.3,2.2,1.8-.8,1.5,1.5-1.8.3-1.4-1.7-3,1.5.1-2-.2-2.5,1.5-3Z"
          fill="#3a80ed"
        />
        <path
          d="M351.7,106.4c2.8-.9,3.1,1.6,3.6,1.9s3.1.6,3.4.6.9-.7,1.5-.5l-.5,1.5c3-.7,3,1.5,4.5,3q-2.4.7,0,0c.3.3,1.2.4,1.5,1-.4.1-.8.8-1.3.9s-1.3-.4-1.7-.4c-.4.3-.6.5-1,0-1.2.2-1.3-.1-.5-1-.5,0-.4-.3,0-.5-.9-.1-1.4-1.1-.6-.9l-3.9-1.4c0-1-.2-1.6-.4-1.7-.7,1.1-2.4,1.4-3,0l-.5-1c-.6,1.3-1.3,1.5-2,.5-.8-.6-.3-.8.5-1-1.3-.7-.9-1.4.5-1Z"
          fill="#1a62e8"
        />
        <path
          d="M356.2,108.9c.3,0,.7,0,1,0l-.5,1.5c.6-.6,4.3.9,4.4,1.1.3.3,0,1.1,0,1.4-1.6-.2-3.7-1.3-4.9-2.3s-.8-.6-.1-1.7Z"
          fill="#0b58e3"
        />
        <polygon fill="#0855e6" points="364.1 112.9 362.2 113.9 362.2 112.9 364.1 112.9" />
        <path d="M358.9,109.4c.3.2.3.3,0,.5v-.5Z" fill="#0b58e3" />
        <path d="M351.2,107.4c-.2.3-.3.7-.5,1-.2,0-.8,0-1,0-.2-1.3.3-1,1.5-1Z" fill="#2b68ea" />
        <path d="M352.7,107.9c.7,0,1.3,0,2,0,.2.8-.9.3-1.5,1-.3,0-.7,0-1,0l.5-1Z" fill="#247af7" />
        <path
          d="M355.2,117.9c.1-.1,2.9-1.6,3-1.5.9.9-1.2,1.2-1.4,1.8-.8,2.4.9,1.6,2.7,1.7s2-.5,1.7,1c-.6,0-1.3,0-2,0-.6.4-.8.9-.5,1.5.6.3.3,1.4.5,2l-2.8-1-.2.5c-.2,1-1.6.5-1.5-.5-1,.1-.9-.7,0-1-.4-.5,0-1.1,1-2-.4-.8-.7-1.1-1-1-.7-.5-.5-1.7.5-1.5Z"
          fill="#0370f4"
        />
        <path
          d="M355.2,127.4c.4.1.4.3,0,.5-.2.2-.2.4,0,.5,0-.9.8-.9,1,0,.3,0,.6.5,1,.5.4.2.4.3,0,.5-1.3-.8-2.3.2-2.5,1.3s1.7-.5,1,2.2c-.1.4-.3.4-.5,0-.6-.6-.8-.6-.5,0,.6.9-1.1,2.2-2,1.5-.5-.6-.3-1.5.5-2.5q-.5-.3,0,0c-.3.7-.6,1.6-1,2.5-1.5,1.5-3.6-1.1-3.6-2.5,1.8-1.1.2,1.2-.4-.5-.4-.9-.4-1.5.5-1.1l2.5-.9c.7-.4,1.2-.9,1.8-1.5l.2.5c.6.2.5.6,0,1-.4.7-.3.7.5,0-.3-.6,0-1.6.5-2,0,0,.3,0,.5,0s.4,0,.5,0Z"
          fill="#0382f8"
        />
        <path
          d="M350.7,121.9c.9-2.2,4.6-3.3,3,0,.4.1.4.3,0,.5l.5,1c.5.5.6,1,.5,1.5h-2.5c0,0,.5,1,.5,1,0,0-1.2-.4-1,1-1.4,2.4-3.6-1.2-1.4-1.2s-2.8,1.5-2.1-.8c-.5.7-.9,1-1,0-1.4.1-.9-2-.5-3-.7-.7-.4-1,.5-.5.6-2.1,2.4-.5,1.3,1.3,2.3,1,3.2,1,2.7.2-.7-.1-1-.4-.5-1Z"
          fill="#0370f4"
        />
        <path
          d="M364.6,123.4l1.5-.7c-.5.6-.1,3.1,1,2.2s-1.1-2.2,1-2l-1,3c-.5,1-1.1,1.3-2,.5h-.5c.3-.6.5-1.4,1-2h-1.5c-.2-.1.5-.8.5-1Z"
          fill="#0249e8"
        />
        <path
          d="M359.6,117.4c1.7-2.3-1.7-.9-1.5-3,1.6,1.3,3.5.4,3.5,3-.2,0-.3,0-.5,0-.2.9-1.4,1-1.5,0Z"
          fill="#0855e6"
        />
        <path
          d="M359.6,117.4c1,.3,1.3,0,1.5,0,0,.3,0,.9,0,1l-3.5.5c.5-.4.9-1.9,1-2,.2-.2.7.4,1,.5Z"
          fill="#0973f4"
        />
        <path
          d="M362.6,117.9c.6.5,1.1,2.9,2,2s-1.2-2.2.5-2.5c1.6.4,1.3,1.7,1,3.1s-.7,2.4-1.5,2.9c2.1,1,1.9,1.8,0,3-.4,2.3-2.1,4.2-3.1,1.3-1.6-.6-3.2-.8-4.8-.7-.2-.9-.9-.7-2.1.5-.1.4-.3.4-.5,0-.5-.4-1-.9-1.5-1.5.9.3,1.6,2.2.5,2.5-.6.7-1.2,1-2,1-.7.4-1.2.4-1.5,0-2.5-.7-1.4-2.7,1.3-1.8l.7-.7c-1-1.3-.4-2.6,1-1-2.6-1,0-2.6,2-1,.3-1.4,2.9.4,2.7.4s-1.9-.9-1.2-1.4c-1.1-1.5.6-1.6,1.9-.7l.6-.8c-.7-.2-.2-1.4.5-1.5.2-.8,1.6-.7,2,0,.4-.7.4-1.5,0-2.5-1.3-.2-1.3-.6,0-1,.2-.4.3-.4.5,0,.1-.9.4-.7,1,.5Z"
          fill="#0363f3"
        />
        <path
          d="M356.2,123.9c.4.2,1.3,1,1.5,1.5-.9-.1-2.2-.2-3-.5s-.9-.7-1.5-.5v-.5c.5.1.9-.5,1-.5.2-.4.3-.4.5,0,0,0,1.4.5,1.5.5Z"
          fill="#0483f4"
        />
        <path
          d="M354.2,127.4c0,.8-.2,1.3-.5,2-.1.4-.3.4-.5,0,0-.3,0-.7,0-1,.5-1.6-.3-.9-.5-2.5,1.4-.4,1.2,1.2,1.5,1.5Z"
          fill="#0476f5"
        />
        <path
          d="M361.6,123.9c.1-.4.3-.4.5,0,0,.3,1.8.4.2,2l-.2-1c-1.7.3-2.5-.9-.5-1Z"
          fill="#0678f6"
        />
        <path d="M361.6,123.9c-.6.1-.8-.9-.2-1h1.7c0,.6-1,.9-1,1h-.5Z" fill="#023de1" />
        <path d="M359.1,120.9l-.5,1.5c-.2-.1-1,.3-1-.2.4-.2.4-1,.6-1.2s.6,0,.9,0Z" fill="#024fec" />
        <path
          d="M367.1,125.9c.4.5.4,2.2,1.5,1.5s-.1-1.4,1-1c.3.5,2,.4,0,2,.5.7.1.8-1,.5-.1.4-.3.4-.5,0-.9-.3-1-.2-1.5.5.3,1,0,1.4-1,1.5-.1.4-.3.4-.5,0-.2.4-.3.4-.5,0l.5-1h-1.5c-.1-.1,1.3-3.3,1.5-3.5s1.5-1.1,2-.5Z"
          fill="#035cf2"
        />
        <path
          d="M369.6,119.9c.2,1.3,1.1,1.1,1.5,2.5-1.8,1-3.5-.2-3-2.2s1.2-.3,1.5-.3Z"
          fill="#0248e4"
        />
        <path
          d="M347.7,108.4c.4,0,1,0,1.5,0-.5,1.1-1,1.3-1.5,2.5.6.7.5,1.6-.5,1.5-.9.3-1.8-.2-2.5-1.5-1,1.6-1.7.8-1.5-1,.4-.8.8-1,1.6-.9,0-1.8,2-2,2.9-.6Z"
          fill="#0768f0"
        />
        <path
          d="M350.7,110.9v.5c-.2,1-.5,1.7-1,2l-.2,1.2c1.2,3.6-3.1,3-3.3.3-.7-.9-.4-2.6,1-2.5l1-1.5c1-.8,1.6-.3,2.5,0Z"
          fill="#0768f0"
        />
        <path
          d="M344.7,110.9c.3.1.9-.2,1.4.1s.3,1.1,1.1,1.4c-.3.9,0,1.4-1,2.5.3,1.3,0,1.5-1,.5-1.2-.1-1.1-.7,0-1-1.4-1.2-1.8-2.1-.5-3.5Z"
          fill="#0b82f6"
        />
        <path d="M348.2,110.9l.5,1.5c-.5,0-1.1.1-1.5,0,.2-.5.3-1,.5-1.5h.5Z" fill="#0b82f6" />
        <path
          d="M396.1,195.3c0-1.6.6-1,1.3.2s.7,2.4-.6,3.3,0,.8.3,1.1q.5.8,0,0c-1-1.3,1.6-2.6,2.5-1,.8.2,1.5.6,2,1,.7.2,1.7,1.5,3,1l-2,2c-.2,0,0,.2.5.5.1,0,0,.7.5.3s.1-1.8,1.5-.8c0-3.3-2.6-4.9,2.3-4.5s.7.7,1.2,1.5c0,.4-.4.6-1.5.5.2.3.5.5,1,.5.1-.4.3-.4.5,0,.3.2.3.3,0,.5l.6.3c.8-2,3.1,0,1.4,1.2.1.2.4.3.5.5.2.4,1,1.8,1,2-.3,0-.7,0-1,0-.9.8-.5-.1-.5,0-.7,1.9-1.4,1.9-3.7,1.7s-1.7-.6-2.3-1.1c-2.7.5-3.5,2.2-2.5,5,0,.6-.5,1-1,.5-.9-1.1-2.3-1.6-4.1-1.3l-1.4-1.7c-2-.5-.5-3.4,1-1.7-.7-.9-1.1-2-1.3-3.5-1-.8-1.3-1.4-.7-1.8v-.7c-.9-.1-1.7-4.6-1.3-4.8.9.2,1.8,0,2.8-.5Z"
          fill="#032eeb"
        />
        <path
          d="M402.1,210.8c-.7-.6-.7-2.4-1.1-2.9-.7-.8-2.8,0-2.4-1.6.7,0,2,.8,2.5.5s-1.5-1.8.5-1.5l-1.5-.5c1.4-2.6,1.8,1.3,2,1.5s1.9-.4,2.5-.5v.5c-.1.2-.4.3-.5.5-1.2.2-1.4,1.8-1.5,3,0,.2.5.5.4.8s-.4.2-.4.2c-.2.2-.3.2-.5,0Z"
          fill="#033cf3"
        />
        <path
          d="M403.1,203.3c-.6-.1-1.6-.4-2.2-.4s-.8,1-1.3.6c-.9-.7-1.7-3.7.5-2.8l-.2,1c1.2-.8,1.3.2,2.7,1s.4.3.5.5Z"
          fill="#0545f2"
        />
        <path d="M407.6,201.3v1.5c-2,.6-2-2.1,0-1.5Z" fill="#0120e2" />
        <path d="M398.6,203.3c0,0-1.3-.7-2,0,0-2.6,2.7-1,2,0Z" fill="#0348f4" />
        <path
          d="M399.6,191.8c.3,0,.8-.7,1.5-.5v.7c-.1.4-.8.5-1,.8h-.5l-.5-1c.2,0,.3,0,.5,0Z"
          fill="#0120e6"
        />
        <path
          d="M412.1,199.8c0,0,.7.1.4.4-2.3.3,1,2.1-1.9,2.6-.1-.2.2-1.8-1-1s-.3,1.3-1.3,1.5c-.3-.5.3-1.6.3-2,.2-.2.2-.4,0-.5,0,0-.4,0-.5,0l-1-.5c0-.9,1.1-.3,1.5-.5,1.2-.5,1.6-.8,2.2-2,.5,0,.2,2,1.2,2Z"
          fill="#0120e2"
        />
        <path d="M408.1,200.8c-.2-.1-1,.3-1-.5l1,.5Z" fill="#0226e7" />
        <path d="M408.6,201.3c0-.2,0-.5,0-.5l.5.3-.5.2Z" fill="#0226e7" />
        <path d="M410.6,199.8c.2.7-.3,1.3-1,1.5v-1.5s1,0,1,0Z" fill="#0226e7" />
        <path
          d="M377.6,140.3c1.9-3,2-.7,2.5-.5,1.5.5,1.8.9.5,2-1.3.9-2.9,0-3-1.5Z"
          fill="#0355f5"
        />
        <path
          d="M380.1,139.8c.5.1,3.1-.3,2,1s-1.4-.8-.5,2c-.2,0-.7,0-1,0-.3.4-.5.8-1,.5-.4-.1-.4-.3,0-.5-.4-1.3-.3-1.3,1-1,.6-.9-.3-.7-.5-2Z"
          fill="#0232e6"
        />
        <path d="M386.6,146.8c.3,1.6-.6.8-1.5,1,0-.3,0-.8,0-1,.5,0,1,0,1.5,0Z" fill="#0239ea" />
        <path d="M383.1,142.3c-.1-.3-.6-.9-.5-1h1c0,.5,0,1-.5,1Z" fill="#011cdb" />
        <path
          d="M362.6,141.8c-1.6,0-.5-.5-.5-.5-.5.4-2.1.4-2.8,0s-2.4-3.9-2.2-4.6,3.6,0,4.2.6c.8-.1,1.7-.2,2.4,0,.7.5,1.2,1,1.5,1.5l1.1.2c-.3-1.1,1-1.7,1.4-.7.2.3.3.7,0,1,.4.1.4.3,0,.5v.6c-2.1,0-1,0,3.5,0,.5.3,1,.4,1.5.5-1.2.9-5,.8-6,3-1.4,1.2-4.1-1.2-1-2-.5-.4-1-.4-1.5,0-.4,1.4-1.1,1.4-1.5,0Z"
          fill="#0473f5"
        />
        <path
          d="M366.6,144.8c.4.1.6.4,1.5.5.2-.9,1.1-.8,1.5,0,.3.2.3.3,0,.5.6.9-1.8.7-1.8.6s1.8-.2,1.9-.1c.2,0,.5,3.2-1.1,2.6,0,.6-.5.8-1,.5-.3.6-.7.9-1.5.5.2.5-.3.8-1.5,1-2.5,1.4-2.1-2.9-.5-4q1.1-.8,0,0c-2.1,1.9-2.3-2.1-.4-3.3s2.2.5,2.9,1.3Z"
          fill="#0371f6"
        />
        <path
          d="M369.6,143.3c.7-.3,4.6-2.3,5-2,0,.3,0,.8,0,1-.7-.3-1.1.4-1.5.5-.4,1.9-1.3,2.6-2.5,2,.9,1.2.3,1.7-1,1v-.5c-1.2-.1-1.2-.6,0-1-.4-.2-.4-.5,0-1Z"
          fill="#056df9"
        />
        <path
          d="M369.6,143.3l.4.3c0,.4-.4.6-.4.7-.4.9-1.8.4-2-.5.7-.5,1.5-.3,2-.5Z"
          fill="#0382f8"
        />
        <path
          d="M369.6,144.3c0,.3,0,.7,0,1-.5,0-1,0-1.5,0l-1-1.3c0-.3.4-.2.5-.2l2,.5Z"
          fill="#0361f5"
        />
        <path
          d="M368.6,128.9c.8-.3,1.8.1,1.5,1,2.5,1.8.2,1.2-1.5,2s-2.1.9-2.5,2c3.4-1.7,1.8-.5,1,2,1.2-.6,1.1.3,1.5.5.8.4.7,1.3.5,2,.1.3.3.7.5,1,.2,1.1-1.5,1.3-2,.5v-.5c.2-.4.2-.6,0-1-.5-.1-1-.3-1.5-.5-.8-.6-.4-.8.5-1q1.2-.4,0,0c-.4.5-.6.7-1,0,.3.6.1.6-.6,0-.7.9-1,.8-.9,0-.3,0-.7,0-1,0-.8-.3-1.5-.8-2-1.5-.2,0-.3,0-.5,0v-1.2c2.2,0,2.4-1.1,0-1.8-.2-.9,1.9-2.7,2.1-1l2,1c.1-.4-.1-1.2,0-1.5s.3,0,.5,0c1,.9,1.9.9,2.5,0q.6-.9,0,0c-.2,1.1-2,1.2-2,0,0-.9.3-1.1,1-1.5,0-.7.9-.9,1.5-.5.2,0,.4,0,.5,0Z"
          fill="#0469f3"
        />
        <path
          d="M369.6,128.4c1.5.5,2.6,1.5.5,1.5-.2-.1-1.4-1-1.5-1,.2-.4.8-.4,1-.5Z"
          fill="#0241eb"
        />
        <path d="M376.1,133.3h-.5c0-.4-1-1.6-.2-2l.7,2Z" fill="#032bd8" />
        <path
          d="M377.6,259.8c-.5,1.1-1,1.2-1,1.2.2.5,2.1,1.5,1.5,2.3q-3,1.7,0,0c.6-.7,1-1.3,2-1.5.7-.2,1.4-.3,2,0l.5,1c-.2.2-.6.3-1,.5.8,0,1.1.7,1,2.5,0,.7,0,2.8,0,3.2s-.3.2-.5.3c-1.7-1.5.4-3.6-1.5-5-.9-.3-1.6-.1-2,.5,0,.6.7,1.2.5,2l1.5-.5c.2.6-.5,1.2-.5,1.5v1.5c-1,.6-2,.6-1.8,2-1.5,0-1-1.5-1.2-2,.8-.7,0-1.7-1-.5-.3.9-.8.9-1,0-.7-.8-1.4-.6-2,.5-1.7.5-2.4,1.2-4,1.5-.4,1.1,1.4,1.7,1.4,2.2s-1.1,1.7-1.9,1.8c0,.6.5.7,0,2.5-.7,1.3-1.4,2-2.5,2.5.2,1.8-2.4,1.5-2-.5-.9-1-1.4-2.2-1.5-3.5-.6-.7-.4-1,.5-1,.9-2,1.9-2.7,3-2,2,0,2.8.7,2.5,2-.5-.6-1-1.3-1.5-2-3.3-.7-3.8-1.5-1.5-2.5,1-.1,0-1.3-1-1,.6.8.3,1-.5.5-.8,1.2-1.1.9-1-.5-1.3-.3-1.7-1.2-.5-2-.7-.6-1-.8,0-1,0-.3,0-.5,0-.5,1.3-.4,1.2.8.4,0s0-.3,0-.6c.3-.2.6-.2,1,0,.7-1.2,2.3-1.7,2.6.4,1.6-.8,2.8,0,2.9,1.6,1,.1.3,1.3-.5,1.5-1.9.3.3.6,1,0-.7-.5,0-1.1.5-1.5-2.5-.8-4-3.6-.5-3.5,0-.5.2-.4.5,0,.6.6,1.2.2,2-1-1.3.3-1.3,0-.5-1,0-1.6.5-1.8,1.5-.5,0,0,.3.5.7.5s1-2.8,1.3,0c.7-.4,1-1.2,2-2Z"
          fill="#0342f3"
        />
        <path
          d="M388.1,258.3c-.3-1.1,1-1.5,2-1.5.1.1-.9,2.1-1,2.5h-.5c0-.2,0-.5,0-.7,0-.2-.3-.3-.5-.3Z"
          fill="#0229e8"
        />
        <path d="M387.6,260.3v-.5c.3-.1.7-.4,1-.5,0,2-.9,1-1,1Z" fill="#0229e8" />
        <path
          d="M399.1,268.3c0,.1,0,.3,0,.5v.5h-.5c0-.3,0-.7,0-1-.7-.2-1.1.4-1.5.5-.2-.9.7-1.5,1-2,1.2-.7,2,.4,1,1.5Z"
          fill="#0232ec"
        />
        <path
          d="M389.1,260.3c2,.8-.9,3.6-2.5,2.5-.5.8-.7,1.9,0,2.5.5-.3.7-.6.5-1-1.3.7-1.6-.9-.5-1.5,1.4.2,2.5-.2,2.9-1.6h2.1c-.6-.6-.3-.8.5-.4,0,0,.1-.6.5-.7,1.1-.5,3.3-.5,2.5,1.2l2,.2-1.5.8.9.6c0,.3-.4.4-.4.4,0,.8-.7.7-1,0-.7-.1-1.3-.5-2-.5,0,.5,2.1,2.1,2,2.2-.5.8-3.1,1.2-1.7,3.2l1.2-1c.2.1,0,1.2.5,1-1.5.3-1.6-.3-1.5,1,1.5,0,2.1,0,3.5-.5.2.8.8.5,1.5.5,0,.3-.7.8-.5,1,.3,0,.7,0,1,0,.6-.5.8-.2.5.5-.6.1-1.9.5-2.4.6s-.3,1.3-2.1,1.3c-1.6-1.5-2.1-2.7-1.5-3.5-.4,1.1-.8.8-1.5,0-1.7-.3-2.3,0-1.8.8-1.8.2-2.1,1.7-2.1,3.4-1.6.2-2.9.9-4.1,2l-.6-.7c-1.3.9-1.7.6-1.4-1-.4-.4-.7-1.1-1-2-2.7.5-.2-5,1-2.5-.4-1-.2-2.1.5-3.5-.7-1.7-.9-2.3,1.2-2l-.2-.5c-1.5-1.8-.2-3.5,2.3-3.5.2.5.8.6,1.7.5.4-.2.7-.5,1-1,.1-.4.3-.4.5,0,1.2,0,1.2.6,0,1Z"
          fill="#0232ec"
        />
        <path
          d="M388.1,258.3c1.1-.8,1.3,0,.5,1-.2.6-.5,1.1-1,.5-.7,1.5-3.9-.2-3.9-1.1,0-2.7,3-1.5,4.4-.4Z"
          fill="#0232ec"
        />
        <path
          d="M393.6,269.3c0,1.9.9.6,1.5,1v2.5c-1.1,0-.9-.3-1.5-1s-1.1-1.6-1.5-2.5c.5,0,1,0,1.5,0Z"
          fill="#0220e3"
        />
        <path
          d="M391.6,261.3c-.8.5-1.7.5-2.3,1s-.6,1.5-.7,1.5c-.5.4-1.4-.8-2-1,0-.1,2.1-.2,2.5-1.4s0-.9,0-1.1l2.5,1Z"
          fill="#0229e8"
        />
        <path
          d="M386.6,262.8c-.2.8.5,1.1.5,1.5,1.2.6.9,1.3-.5,1-.2.2-1.8.6-2,.5,1-1.6,1.3-2,0-3.5.2-.2,1.6.3,2,.5Z"
          fill="#0125e4"
        />
        <path
          d="M382.6,263.3c.3,0,.7,0,1,0s.5.3,1,0c.5,1.8-1.5.6-2,1s0,.8,0,1.5c-.5-.5-1.1-1.9-1-2.5.3-.4.8-.4,1,0Z"
          fill="#0227e4"
        />
        <path
          d="M384.1,267.3c.4.5-.7,2.8-.5,3l2.5-.7c-.9,1.3-2.5,1.8-4,2.2,1.1-1.5,1.4-2,1.1-3.9s.7-.8.9-.6Z"
          fill="#0342f3"
        />
        <path
          d="M387.1,264.3c2.1-.4,1.5.7,1.5,2.5-1-.3-.7-1.9-2-1.5,0,0,.5-.9.5-1Z"
          fill="#0547f0"
        />
        <path d="M395.1,262.8c-.5-.4-2.4-1.2-2-1.5,1.8-.8,1.7-.4,2,1.5Z" fill="#022be8" />
        <path d="M386.1,272.8c-.5.3-1.2-.3-1.5-.7l1-1.2c.5-.2.6,1.9.5,2Z" fill="#0342f3" />
        <path d="M384.1,273.3c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#0236ef" />
        <path
          d="M380.1,243.8c1.6,1.7-1.1,2.8-1,.5-.4-.1-.4-.3,0-.5.2-1.3.5-1.2,1,0Z"
          fill="#0236ef"
        />
        <path
          d="M385.1,236.3c2.1-.6,3.1.1,3,2l.5.5c.6-.4.6-.6,0-.5-.3-1.3.8-2.5,2-1.5.6.3.6.7,0,1l.5.5c.3-.3.5-.3.5,0,0-.8.8-.8,1,0,1.7,0,3-.3,4-1,0-.8.8-.8,1,0,.8,1,1.6,1.3,2.4,1l.6,1c.9,1,.3,2.4-.9,2.8.6,2.7-.6,3-3.7,1-.8-2.3-1.9-1-1.4,1.1,0,.2,0,.4,0,.5-.8.6-1.2.5-1-.5-.8-.3-1.5-.7-2.2-1.2-.7.7-1.3,1.1-1.8,1.2.3,1.3,0,1.4-1,.5-.9-.4-1.7-.7-2.3-.7.1,0-.3,2.8-.4,3-1.5,2.3-5.5,3.7-4.6,0-.8-.8-1.2-1.8-1.2-3.2-1.5-.2-1.1-2.2.5-1.5.6,0,1.3-.6,2-1.5.3-.6.8-.6,1,0,.2-.2.6-.2,1,0,.4-.2.6-.6.5-1-1.5.3-2.6-2-2.5-2.7s.3,0,.7,0c0-1.3.6-1.5,1.8-.7Z"
          fill="#0236ef"
        />
        <path
          d="M380.6,242.3c-.7.2-.4,1-.5,1.5-.2-.1-.8.1-1,0-.6.5-1.6-.4-1-1-1.8-2.2,2.8-2.8,2.5-.5Z"
          fill="#0344f3"
        />
        <path
          d="M380.1,243.8c2.2,1,.8,2.3,1,2.5.4,0,1.3-.7,1.5-.5,1,.8-1,1.1-1,1.3,0,1.5,1.2,2.1,2.5,1.7l-1.5-.5c1.1-4.1,1.6-1,1.7-1,1.5-.1,1.4-1.8,1.3-3-1.4.8-.4,1.9-2.3,1s.5-.7.8-.8c.6-.2,3.3-2.3,3.5-2.2l1,2.5c.3.1.7.3.8.7,0,.7-.9,2.8-1.3,3.5s.2-.7.5.8c.3-.6.7-.8,1-.5.2-.4.3-.4.5,0,.4.1.4.3,0,.5l.5.5c.4.2.4.3,0,.5-.2,1-.9-.4-1.7-.4-1.6,0-1.1,2.8-2.3.4-1.2-1.3-1.6-1.7-3.4-.5l-.6-.5c-.3.7-3,.7-3.4,0,.9-2.3-.3-2.8-2.1-2-1.3-.5-.8-1.9.5-2,.3-.7.9-1.1,1.5-1.5l1,.5c0-.3,0-.7,0-1Z"
          fill="#0344f3"
        />
        <path
          d="M389.6,244.3c1.3-1.5,2.6-1.5,4,0,.2.2.7.3,1,.5-.6.9-1.7,1.2-2.2,2.8s1.2,2.7.7,4.7c-.1.3-.3.3-.5,0-.5-.4-1-.3-1.5,0-.9.7-1.2.4-.5-.5.4-.5.1-.7,0-1s0-.4,0-.5l-.5-.5v-.5c-.3-.7-.6-1-1-1,.1.7.2,1.1-.5,1.5-2.9,0,.3-2.3-.5-3h-2s.5-2,.5-2c1-.2.3,1.2.5,1.5.9,1,1.2-1.2,1.5-1.5s.8-.3,1-.5Z"
          fill="#0230ec"
        />
        <path
          d="M385.6,254.8l-2.3,3.5.8-1c-.6-1.9-1.5.1-3,.3s-1.9-1.6-2.5-.3c-.7.7-1,.4-.5-.5.2-.2.4-1.1,1.2-1,1.3,0,1.6,1.8,3.8-.7l-1-.7,2.5,1c.1-.2-.8-2.3.5-2.5.7.4,1.4,1.8.5,2Z"
          fill="#022fe9"
        />
        <path
          d="M400.6,239.3c.8-1.6,2.5-.2,1.4.8v1.7c.1,0-.1,1.5-.1,1.5l-1.2-1.5c-.9,2.6-.5,1.5.5,2,.5.7-.1,1.7-1,1-.1,0-.3,0-.5,0-2.6,0-.9-.2-1.8-.5s-2.7,1.3-2.2-2c-1.7-.2-.4.6-1,2-1-1.9-.3-3.6,2-3l-1,.7,3.5,2.2-.5-3c-.8-.2-.3,1.9-1.5,1s.2-1.4.3-1.5c1.2-1.6,2.6,2.7,3.2-1.5Z"
          fill="#0225e6"
        />
        <path
          d="M382.6,249.8c2.4-.2,2.2-2.5,4.5-2.5.6,1.3-1,.8-1,1.3,0,.7.6,1.6.5,2.2s-.5.4-.5.5c.2.6.2,1.1-.5,1v-2.5c-.3-.2-2.7,1.2-3,1.5-.4-.1-.4-.3,0-.5-1.3-.2-1.3-.6,0-1Z"
          fill="#022fe9"
        />
        <path
          d="M399.1,253.3c.3-.4.7-.4,1,0,.1-.4.3-.4.5,0,.2,0,.8.4,1,.5l-.3.3c-.4.1-1.1-.4-1.2-.3l-.5,1c-.8.7-1.4-.5-2.5.5s.8,1.1-1,1c-.2-.2-.3-.3-.5-.5l-.5-.5c-.1,0-.4,0-.5,0-.3-.2-.1-.5.5-1,.1,0,.3,0,.5,0,1.1-1.7,1.9-2,2.5-1,0-1,.5-.8,1,0Z"
          fill="#022feb"
        />
        <path
          d="M394.6,248.8c0,0,.5-.9,1.6-1.2s4.9-.9,2.9,1.2c-.2,0-.4,0-.5,0-.7-.3-1-1-1.5,0,.3.5.3.8,0,1-1,.3-1.4-1.9-2.5-1Z"
          fill="#0223ea"
        />
        <path
          d="M397.6,250.8c0,.3,0,.7,0,1,.6.3,1,.9.5,1.5-.1,0-1.9.8-2.5,1l.7-1.5-1.7-.5c3,0,1.5-.6,2.1-1.4s.8,0,.9,0Z"
          fill="#022fec"
        />
        <path
          d="M390.6,251.8s-.2.4.5.5c.6-.6,1.2-.8,1.5,0h.5c-.5,2.4-6.2.2-5-1,1.1,1.5,2.2.5,2.5.5Z"
          fill="#0123e3"
        />
        <path
          d="M385.6,252.8c.3.2.8,1.5,1.5,1.8s2.2-1,2,.5c-1.5.2-2.9,1.3-3.5-.2s0-1.5-.5-2c.2,0,.4,0,.5,0Z"
          fill="#0344f3"
        />
        <path d="M386.1,251.3c.7,1,.9,1.7-.5,1.5,0-.2,0-.3,0-.5,0-.7.5-.8.5-1Z" fill="#0344f3" />
        <path
          d="M404.6,246.3c-.5,1.4-1.6,2.9,0,2.5,0,.1,0,.4,0,.5-.8.2-2,1-2.7,1s-.2-1-.3-1c0,0-1.1,0-1.5,0,.1-.4.2-1.2.5-1.5s1.1-.3,1.5,0c.5.3.2,1.4-.5,1.5.5-.3.9-1,1-2-.1-.5-.8-1.2-.5-2,.8.9,1.8.7,2.5,1Z"
          fill="#0220e2"
        />
        <path d="M394.6,248.8c-1.1.9,2,1.1,1,2s-2.9-.9-2-2.5c.3,0,.9.5,1,.5Z" fill="#0228eb" />
        <path d="M397.1,249.8c0-.3,0-.8,0-1,.5.5.8.8,0,1Z" fill="#022feb" />
        <path d="M395.6,255.8c-.2-.2-.4-.4-.5-.5l1-.3-.5.8Z" fill="#022fec" />
        <path d="M394.6,255.3c-.1,0-.4,0-.5-.2.3-.4.6-.6,1-.8l-.5,1Z" fill="#022fec" />
        <path
          d="M403.1,259.8c.2,1.3-.3,1-1.5,1-.2,0-.8.2-1,0-.4-.4.5-.9.5-1,.6.1,1.5-.2,2,0Z"
          fill="#022be8"
        />
        <path d="M402.6,258.8l-.5-.5c.4,0,.5.5.5.5Z" fill="#0225e5" />
        <path d="M401.1,243.8c.8.4.4,1.1.5,2-.2.2-1.3-.9-1.5-1l1-1Z" fill="#0339f0" />
        <path d="M402.6,247.3c.2.9.2,3-1,2s.4-1.3.5-1.5.3-.4.5-.5Z" fill="#0239f0" />
        <path
          d="M400.1,252.8c1.3-.7-1.5-.5-1-2,1.4-.6,1.6,1,1.7,1,1.6.4.9-1.6,2.3-.5,0,.2.2.8,0,1s-1.1,0-2,.5-.3.3-.5.5c-.1,0-.3,0-.5,0-.4-.1-.4-.3,0-.5Z"
          fill="#0339f0"
        />
        <path
          d="M397.6,251.8c.9-.3,1.1.8,1.5,1,.4.1.4.3,0,.5-.4,0-1,0-1,0-.3-.5-.4-1-.5-1.5Z"
          fill="#0339f0"
        />
        <path d="M400.1,252.8v.5c-.3,0-.7,0-1,0v-.5c.2,0,.7,0,1,0Z" fill="#022fec" />
        <path
          d="M406.6,224.8c.3-1,.7-1,1,0,.2-.4.3-.4.5,0,0,.4.4.4,1,0,.5-.2.7,0,.5.5,1.1-.1,1.2.1.5,1l.2,1c-1.6-.3-2.6-1.9-4.2-1,0-.1,0-.4,0-.5l-.5-.5c-.1,0-.3,0-.5,0-.2-.2-.4-.2-.5,0-.6.6-.7.3-.5-.5,0-.2,0-.4,0-.5.7-.4,2.4-.4,2.5.5Z"
          fill="#0336f0"
        />
        <path
          d="M411.1,222.8c2.9.8.4.7.3,2.1s.1,1.6.2,2.4c0,0-1.3-.8-1.5-1-.4-.4-.3-.7-.5-1,0-.9.4-2.8,1.5-2.5Z"
          fill="#021fe3"
        />
        <path
          d="M411.1,221.3c0,.5.1,1.1,0,1.5s-1,2-1.5,2.5c-.1-.2-.3-.4-.5-.5-.1-.6-.3-1.3-.5-2-1.2-.2-.2-1.7.4-2.1s1.2,0,1.6.6c.1-.4.3-.4.5,0Z"
          fill="#0230ee"
        />
        <path
          d="M410.1,219.3c.8.8,2.4.7,2,2-.3.1-.7,0-1,0s-.3,0-.5,0c-1.3,0-1.9-.9-1-2h.5Z"
          fill="#0c48eb"
        />
        <path
          d="M404.1,213.3c-.3.4-1.6,1.9-1.5,2,.8.2,1.3-.2,2-.5v.5c1.4.2,1.2.5,0,1-.1.4-.3.4-.5,0-.8,0-.7.4.2,1.2l-.7.3c-.4,0-.9-.4-1.3-.3s-1.3,1.2-1.7.8c-1.5-1.3,1.4-.9,1.5-1,.2-.4,0-2-.5-2.5-.7-.9,1.2-2.2,2-1.5h.5Z"
          fill="#043bee"
        />
        <path d="M401.1,213.3l-.5,1c-.2,0-1,0-1,0,.1-.2,0-.9.5-1.3s.9.3,1,.3Z" fill="#043cf1" />
        <path
          d="M399.6,214.3c-1,1,1.3.8,1,1.5-1.7,0,.3,1.7-2.5,1.5q-.7-.3,0,0c2.4,1,1.7,1.7-.5,2.5-2.7-1.3-3.2-2.3-1.5-3-.7-1.2-.1-1.4,1-1,.5.6,1.2,1.1,2,1-1.3-3.1.3-2.2.5-2.5Z"
          fill="#043cf1"
        />
        <path
          d="M409.6,219.3c.2.6,1,1.2,1,2-1.7.5-1.7.2-2,1.5.9.2.4,2-.5,2,0,0-.3,0-.5,0-.3-.2-.7-.7-1-1.5-.4.2-.9.2-1.5,0v-3c.7-.6,3.5,3.5,3.3,0l-1.2,1c.8-2.2.2-.8-1-1.8-.3-.8.9-1,1-1.2.2,0,.5.5.5.5q-.2.2,0,0c.5,0,1.8-1.2,2-1s-.1,1.2,0,1.5Z"
          fill="#022ae9"
        />
        <path
          d="M407.6,216.8c0,.4,0,.5-.5.5l-1-1c.3,2.4-1.1,1.5-2.5,1.5v-.7c-1.9-.4-.4-1.9.5-.8.4.6.5.6.5,0,0-.3,0-.7,0-1,1.1-.6,3.2,0,3,1.5Z"
          fill="#0223e6"
        />
        <path
          d="M395.6,220.3l1,.6c1-.3,2.2-.1,2.5.9,0,.3,0,.9,0,1,.2,1.1.4,2.3.5,3.5,0,.7-1,1-1.5.5-1.3.5-1.6,1-1,1.5.4.2.6.2,1,0-.6-1,1.5-2.1,2-1,1,.4,1.3,1.4,1,3,.5.8,1.2,1.7,2,2,.1-.3.3-.3.5,0,.4.1.4.3,0,.5-1.3.8-4.4,1.6-4.5,0-.3,0-.4-.4-.5-.5-.3-1-.5-1.8-.5-2.5,0,0-.4-.5-.5-.5-.5.4-1.2.7-1.9.7-3.6-.4-3.8-4.8.4-4.2q.7-.8,0,0c-1,1-4.2,0-2-1.5-.6-.9-.4-1.6.5-2-1-.3-1-.8,0-1-.9-.5-.4-.9.5-1,.1-.4.3-.4.5,0Z"
          fill="#022deb"
        />
        <path d="M397.6,228.3c-.2.2-.3.2-.5,0-.7-.9-.4-1.2.5-.5.4.1.4.3,0,.5Z" fill="#022deb" />
        <path d="M406.1,228.8l.5-.5c0,.3-.5.4-.5.5Z" fill="#022ae9" />
        <path d="M406.6,229.8c-.2-.1-.6,0-.5-.5l.5.5Z" fill="#022ae9" />
        <path
          d="M377.6,290.3c.8,0,1.6.1,2.5.5,0,0,.6.4.5.7-.2.7-2.1.7-1.5,2.3-.1.4-.3.4-.5,0-.6-.9-.5-1.3-1.5-.5,0-.2,0-.3,0-.5-.6-.2-1.5-2.7-1.4-3s2.7-1.7,1.9.5Z"
          fill="#0236ef"
        />
        <path
          d="M384.6,287.3c.4.4.2.8.5,1.5s1.2,1.4,1,1.5c-3.2-1.1-2.1.2-2.5.5-1.9,1.5.4-2.1-1.5-1.5,0-.3,1.6-1.1,1.5-2,.8-.4,1,0,1,0Z"
          fill="#0124e2"
        />
        <path d="M379.6,293.8c.1-.4.3-.4.5,0-.3.6.2,2.7-1.4.9s0-.8,0-.9h1Z" fill="#0216ce" />
        <path d="M379.6,293.8c-.2-1.3.3-1,1.5-1,0,.6-.9.8-1,1h-.5Z" fill="#0236ef" />
        <path d="M382.1,291.3h1.5c-.4,1.5-1.4.5-1.5.5v-.5Z" fill="#0124e2" />
        <path d="M378.1,296.3c0,0-.7.4-1,.5l1-.5Z" fill="#033def" />
        <path d="M386.6,288.3c-.3.1-.6.5-1,.5l1-.5Z" fill="#0227e6" />
        <path
          d="M280.7,418.7c1.9-1.6.1,4.7-2,3.5,0-.7,1.6-1.2,1.8-1.6s0-1.7.2-1.9Z"
          fill="#022f86"
        />
        <path d="M295.2,416.2c0,.2-.5.4-.5.5l-.5-.5c.1-.2.5-.4.5-.5.2.2.3.3.5.5Z" fill="#022f86" />
        <path
          d="M311.7,393.7c.6.1,1.3.3,2,.5.3.3,1,.4,1,1l-3,.7,2,1c-2.4,1-.7,1.5,1,.8.1,1.4-2,1.6-2,1.7,0,1.5,1,.3,1.7.2,1,1.5-2,.9-2.2,3,0-.2,0-.9,0-1-.2-.2-1.5,0-2,0,1.3,2.8-1.6,1.2-2,2.2.3.4.9.4,1.5.7l-1,1.5c-.1.2-1.8-1.2-2-1-.9.9,1,1.2,1.2,1.5s.4,2,.3,2c-.3.3-2.1-.6-1.5,1h3.5s-1.5,2-1.5,2c-.5-2.8-5-.9-2.5,1.5-1.3.4-1.4.3-2.5-.5-.2,3.1,4,1.2,7,2,.8,0,.7.8,0,1-4.3.4-.8,1.2-2.8,3.5.2-4.2-.8-1.5-1.9-1.6s-1.5-1-2.3-.9l-.3-.4c.6,2.2,0,2.8-1.8,2-1.6,4.6-3.6.7-2.2-2.3-2.1.4-3,0-2.7-1.4.2-.9-.4-.7-2,.5-.9-.3-.4-1.8.5-2-1.5-.8-3.2.4-1.5,1.5,1.3,2.3-3.5,4.4-3,1-.6-.4-1.3-.6-2-.5-1,.6-1.2,1.4,0,2q.5,1,0,0c-.4-.1-.4-.3,0-.5.4-1.3.9-1.1,1.5.5.6-.7,2,.2,2.5,1,.4.1.4.3,0,.5,0,.7,1.7.6,1.5,0-.8-.6-.4-1.2.5-1,.5-.6,1-.6,1.5,0,.2-.4.3-.4.5,0q.2.2,0,0c-.4-.1-.4-.3,0-.5-.2-1.4,2.7-1.9,2.8-.4s-.5,3.7-2.4,3c-.3,1.9-2.7,2.2-3.9,1.4-.2,1.2-1.1,2.1-2,1-.1.4-.3.4-.5,0-.1.8-1.3.8-2,.5-.6-1-1.6-1.7-3-2-3.1.5-4,0-4-3-1.5,1-3.5,2.1-3.5-.5-.4,0-.4-.3,0-.5,0-.6.4-.9,1-1-1.3-.3-1.6-1.3-1-3,.2-2.4,1.2-3,2.8-.8,1.6-2.1,4-1.8,3.3,1.1,2.7-.8,3.6-1.6,2.5-2.2-.2-3.6,3.8-3.3,5.8-3.2v-.9c-4.2-4.4,2.5-3.1,4.5-1.1.4,1.3.1,1.3-.5,2.5.3.4,3.7.2,4,0s-.4-.7-.5-1c-.6-.1-.9-.4-1-1,1.3-.7,1-3.1.5-3.5s-.5.6-1.5,0c0-1.2.1-1.5,1.1-.9h2.4c1-.5,1.7-2.3,4-1.1-.1-1.1-1.5-.7-1.9-1.1s0-.8-.1-.9c.7-1.1.8.5.4,0-.8-1.1-.9-1.7.6-1.5-1-2.5,3.6-3.3,4.5-.5l.5-.8c-1-1.4-.6-3.1,1-2.7.3.2.7.3,1,.5Z"
          fill="#022f86"
        />
        <path
          d="M310.7,392.7v.5c-1.6.8-.8,2.4,0,3.5-.5,0-1,0-1.5,0-.6-.1-.6-.8,0-1l-.5-.5c-2,.1-1.8-.7.5-2.5,1-.3,1.2,0,1.5,0Z"
          fill="#022b80"
        />
        <path d="M313.7,394.2c-.4,1.2-1.5-.1-2-.5.4-1.2,1.5,0,2,.5Z" fill="#08438e" />
        <path
          d="M295.2,413.2c-.3,1.1-.4,1.4-.5,2,.4.1.4.3,0,.5.4.4,0,.6-.5.5.4,1-.3,2.5-1.5,2,0,0-.5,0-.9.2s0,1.4-1.1.8c.9-1.9,0-1.3-.5-2-.8-.4-1-.7-.5-1l.5-.5c.1-.5.3-.5.5,0,.3.1.4,1.3,1.7.9s1.1-1.2,1.3-1.9c-.4-.1-.4-.3,0-.5-.2-.2-.2-.3,0-.5-.6-.9,1.3-1.6,1.5-.5Z"
          fill="#012d81"
        />
        <path
          d="M288.7,415.2c1.5-.7,1.3.6,0,1.5,0,.1,0,.4,0,.5-1.1.8-5.1,2.5-5.5.3,6.3,1.1,3.4-1.7,4.5-2.7s.9.5,1,.5Z"
          fill="#02287d"
        />
        <path d="M288.7,417.2c0,.2.9.4,1,.8.4,1.2-1.5,1.3-1-.8Z" fill="#02287d" />
        <path
          d="M303.3,404.6c.2.1,1-.4,1.4.4-2.7.6-1.9,4.2-4,1.5,1.7-.8,1.7-1.4,1.5-3.2.7,0,.7,1.1,1.1,1.3Z"
          fill="#023b91"
        />
        <path
          d="M296.7,414.7c-.3,1.3,0,1.3,0,2.5s0,.4,0,.5-.4,0-.5,0c-.9.2-1.3-.7-1-1.5-.4.2-.6,0-.5-.5,0-.1,0-.3,0-.5,0-1.2,2.1-3,2.5-1.2s-.4.5-.5.7Z"
          fill="#02368d"
        />
        <path
          d="M295.2,413.2c-.8-.2-1,.1-1.5.5-.2.1-.2.3,0,.5,0,.2,0,.3,0,.5l-1,.7-1.5-3c1.6.2,2.7.3,4-.7,0,.5.1,1.1,0,1.5Z"
          fill="#02368d"
        />
        <path
          d="M288.7,415.2c0,0-.1-.8,0-.9s.8.4,1.1.4.5-1.7,1.8-1l-1,2c0,0-.4,0-.5,0l-.5.5c0,.2.3.7.5,1l-1.5-.5c-.3-.6-1.2-1,.5-1l-.5-.5Z"
          fill="#02368d"
        />
        <path
          d="M278.2,417.2c.3,1.2,2.2.7,3.5.5-.3.3-.6.7-1,1s-1,.8-1.4.9c-.9.2-1-.4-1.1-.4-.5-.7,0-1.5,0-2Z"
          fill="#022373"
        />
        <path
          d="M294.2,418.7c.8,0,1.6,0,.7,1-1-.6-2.1.2-2.7-.8l.5-.2c.5,0,1,0,1.5,0Z"
          fill="#012d81"
        />
        <path
          d="M303.6,409.1c-.2.2-1.1-.3-.9.6,1.4,0,1.5,1.4,2,2.5l-2.5-2.8,1-1.7c.8-.2.6,1.1.4,1.4Z"
          fill="#012779"
        />
        <path
          d="M296.2,417.7c-.6.3-.6.7-1.5,0,0-.3,0-.7,0-1-.3-.5,0-.7.5-.5.4.5.8.9,1,1.5Z"
          fill="#012d81"
        />
        <path d="M308.9,399.5c.3.3,1,0,.8.4-2.2,2.4-2-1.9-1-1.2s0,.5.2.8Z" fill="#022878" />
        <path d="M279.2,415.7c-.1.7.3,1.2-1,1,0-.3-1.2-2.1,1-1Z" fill="#022373" />
        <rect fill="#022878" height=".5" width="2.5" x="309.2" y="397.7" />
        <path d="M307.2,401.7c-.2.7-.8,1.1-1.5,1v-1s1.5,0,1.5,0Z" fill="#054696" />
        <path d="M311.4,398.7c.3.2.3.3,0,.5v-.5Z" fill="#022878" />
        <path d="M310.4,399.2c.3.2.3.3,0,.5v-.5Z" fill="#022878" />
        <path d="M310.4,400.7c.3.2.3.3,0,.5v-.5Z" fill="#022878" />
        <path d="M296.7,417.7c.2-.2.8.5.2.5s-.4-.4-.2-.5Z" fill="#012d81" />
        <path d="M293.7,414.2l-.4-.3c0-.3.3-.1.4-.2v.5Z" fill="#022f86" />
        <path d="M289.7,416.2l.5-.5s-.5.5-.5.5Z" fill="#022f86" />
        <path
          d="M288.7,425.7c0,.1,0,.3,0,.5.4.3.4.7,0,1,.3.3.9.4,1,.9.9,3.7-2.2,2.4-4,.6s-1.3-2.3-2.5-3l2,1,1-1.5c-1,4.8.6,3.8,1,0,.4-.9.9-1.3,1.5-1,.6.6.1,1,0,1.5Z"
          fill="#012578"
        />
        <path d="M288.7,426.2h1.5c-.1.7-.9.9-1.5,1-.9-.9,0-.7,0-1Z" fill="#012d81" />
        <path d="M288.7,428.2c.2.2-.9,1.3-1.5,1-.2-.2.9-1.3,1.5-1Z" fill="#012682" />
        <path
          d="M268.7,407.7c.4.6-.7,1,1.5,1s.7,0,1,0l.5,1c0,.1,0,.4,0,.5-.8.9-2,1.9-3,2.5-1.6.6-1.4-1.1,0-1,.3-1,.1-1.7-.5-2-.3.6-1.1,0-1-.5-.4-.2-.4-.3,0-.5l1-1c.2-.4.3-.4.5,0Z"
          fill="#013e9a"
        />
        <path
          d="M275.2,401.2c.3.6.7.8,1,.5,1.4.4,2.1,4,2.7,1.5l1,1c.3-1.3,1.7-1.5,2.7-.5-.2.8-.5.5-1,0,.5,3-2.2,4-3.5,1.7l-.5.3c-1,2.4.2,1.1.5,1.5.9,1.2-1.7.6-.5,2-1.2-.2-1.7-1.2-1.5.5s.8,2.3.5,3.5l-1.5-.5.2,2.5-1-3c-.9.8-.4,1.8-.8,3-1,1.2-1.6,1.4-2,.5,0-.3,0-.7,0-1-2.3.9-1,.6-1,1.5-.3.7-.8.8-1,0-.7,1.7-3.1.1-2.5-1,.2-1,.9-1.4,2.1-1.1.4-3.2,4-2,2.4.6l.4-1.2c-1-.8-1-2.3-.4-3.3-.4-.2-.4-.3,0-.5-.3-.2.5-.8.7-.9s-1.3,1.4-1.2-.1c-.4.3-.8.3-1,0-.8,0-1.1-2.6-1-3.1,1.8-.8,3-1.6,4-2.8-.2-1.5,0-2.4,1.5-1.6.1-.4.3-.4.5,0Z"
          fill="#023899"
        />
        <path
          d="M281.7,403.7c1.1.2,1.3.6.5,1,0,.3-.7,1-.5,1.4s1.9.2,1.5,1.6c-.5.1-1.6-.7-1.9-.5s-.3,1.2-.8,1.5c-.5-.6-.3-1.4-1-2.1s-2.1.9-1.8-.9c.1-.3-.3-1,.2-1,1.4.9,2.3,3,2.3,0l1.5.5-1-1.5c.3,0,.7,0,1,0Z"
          fill="#023ca1"
        />
        <path
          d="M277.7,398.7c-.1.4.1,1.2,0,1.5s-1.2,0-1.7.5.3.9.3,1c-.1,1-.5,1.7-1.5,2,0-.8.3-1.7.5-2.5-.8-1.2-.7-1.7.5-1.5.3-.8.7-.9,1-.5,0-.4.2-.6.5-.5.1-.5.3-.5.5,0Z"
          fill="#0346ab"
        />
        <path d="M273.7,415.2c-.3,1.1-.8,1-1,2-1.5-.4-1-1.2-1-1.5l2-.5Z" fill="#01287b" />
        <path
          d="M271.7,410.2l1,1.5c.3-.5,3.5-1.9,3-.3-.6,0-3.3.5-3.5.8s.8,2.1.5,2.5-.8,0-1,0c0-.5,0-1,0-1.5h-1.5c.5,2.9-.8,1.5-3,2-1.2.4-1.3-1.4-.5-2,0-1,1.4-1.3,2-.5.9-1.8,1.9-2.6,3-2.5Z"
          fill="#02318f"
        />
        <polygon
          fill="#023ea6"
          points="274.2 404.7 274.2 406.7 273.7 406.7 273.2 404.7 274.2 404.7"
        />
        <path
          d="M271.7,409.7c-.8,0-1.7.3-1.5-.5.5.2.8-.5,1-.5s.8.6.9.4c.3-.3-.3-1.1.6-.9.4,1.1-.7,1.1-1,1.5Z"
          fill="#02318f"
        />
        <path d="M277.2,398.7s0,.3-.5.5v-1s.5.5.5.5Z" fill="#023ca1" />
        <path d="M277.7,388.7c-.1.6-1.1,1.3-1.5,1s.9-1.2,1-1.5c-.1.4.5.5.5.5Z" fill="#023dac" />
        <path
          d="M286.2,386.2c0,.3,0,2.6-.5,3-.9-.5-.9-.7-2,0v.5c.5.1,1.8-.1,2,0s-.6,2.3,0,3c-2.1-1.6-1-.7-1.7-.2s-1.1.4-1.3.7-.3.7-.5,1c-.8,1-.7.7-1,1h-1.1c-.5,1-2.9.9-1.9,0-.5-.8-.6-1.5-.2-2.1-1.2-.1-1.2-.8-.8-1.9l1-1.5,1,1c.5-1.5-.8-.8-1-1s-.3-.7-.5-1,0-.6-.5-.5c.1-.3,0-1.1,0-1.5,1.1-.3,1,.5,1.5,1-1.2.4.9,2.3,1.5,3,.2.2.3.2.5,0,.2,0,.3,0,.5,0,.3,0,.6-.4,1-1-.2,0-.2-.2,0-.5,0,0,.4-.4.5-.5,1.2-.9,3.1-2.4,2-2.5,0-.2,0-.7,0-1,.1-.1,1.4.7,1.5,1Z"
          fill="#023dac"
        />
        <path d="M284.7,386.2l1,.2c-.9.8-1.6,2.2-3,2.3.1-.1,1.9-2.3,2-2.5Z" fill="#023ca7" />
        <path
          d="M282.2,389.7c-.1.3,0,.8-.5,1.3s-.4-.3-.5-.3v-.5c-.5-.7.4-.8,1-.5Z"
          fill="#0245b9"
        />
        <path
          d="M282.2,389.2l.5.3c-.1.1-.4.2-.5.2l-1,.5c-.6-.2-.6-.4-.5-1,.5,0,1.2.1,1.5,0Z"
          fill="#023ca7"
        />
        <path d="M280.2,390.7h.5l-.3.5c-.3,0-.2-.4-.2-.5Z" fill="#0245b9" />
        <path d="M283.7,390.2c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#0245b9" />
        <path d="M283.7,389.7c-.2,0-.5,0-.5-.2l.5-.2v.5Z" fill="#023ca7" />
        <path
          d="M254.7,378.2c.1,0,.3,0,.5,0,.1-.4.3-.4.5,0,.4.2.4.3,0,.5q-.8.5,0,0c.8-1.1,2.9,0,2.5,1.5-.5.2-.7-.1-1.5.5,0,.3-.2.5-.5.5-.2.5-1,.5-2.5,0,0,.2,0,.5,0,.6-.4.7-1.6,2.2-2,2.4-1.7,1.1-2-1.7-1.5-3,.5-.7.4-.7-.5,0-.6,2.1-.7,0-.1.2,1.2.3,0,6.7-1.9,2.8-.2.4-.3.4-.5,0,0,.4-.3.4-.5,0-.1.2-.3.2-.5,0-.4-.1-.4-.3,0-.5-.2-.7.5-.9,1-.5.6.1.6,0,0-.5-.5-.7-1.2-1.2-2-1.5,0,1.2,0,1.3-1,.5-.2.6-.5.9-1,.5-.4,0-.6-.3-.5-.5-.4-.1-.4-.3,0-.5.8-.5,1.5-1,2-1.5-1.5-2,1.4-1.6,3-.9l-.5-.6c-.3,0-.3-.3,0-.5.5-1.4,2-.9,2,.5.4.1.4.3,0,.5-.4,1-.3,1.2.5.5-.3-.9.1-1.7,1-1,.3.2.5.5.5,1,.3-.2.4-.5.5-1-.3-1.2,1-1.7,1.2.2s-.7-1.4.3-1.2c.6-.8,1.1-.5,1.5,1Z"
          fill="#0350c7"
        />
        <path
          d="M257.7,381.7c1.7-.5,3.1-1.9,4.2-2s1,1.3.3,1.5c.5,1,.2,1.3-1,1,.8,2.9-2,3.4-4,3-.6-.5-1.1-1.2-1.5-2-.4-.1-.4-.3,0-.5-.2-1.3,0-1.8.5-1.5.1-.2.3-.3.5-.5.3.1.3.3,0,.5.5.6.8.7,1,.5Z"
          fill="#0345be"
        />
        <path
          d="M251.2,367.2c.1-.4.3-.4.5,0,.8-.1,1,.7.5,2.5v.5c.8.6.8,1.6.5,2.5-.4-.8-.4-1.3.5-1l.5-.5c-.4-.1-.4-.3,0-.5.8,0,1.7,0,2.5,0l-2,2,2.5-.5v2.5c-.6.2-1.1.5-1.5,1-.1,0-.3.5-.5.5,0,.6-.6.9-1.5,1,0,.5,0,1,0,1.5-1,.1,0-1.3-1.2-1l-.3.5c-.1.4-.3.4-.5,0-.3-.1-.3-.3,0-.5-.3-.1-.3-.3,0-.5-.5-.7-.2-.9.5-.5h1l-1-.4c.9-1.1,1.3-2.3,1-3.6,1.5.5-1.4,4.8-2,3.5-.1.3-.3.3-.5,0-.3-.4-.6-.5-1-.5-.2.2-.3.4-.5.5-.3.2-.4.2-.7,0s-2.2-1.7-1.8-2.1c-1.2-1.6-1.7-1.6-3.5-1.2v-1.3c.1-.4.3-.4.5,0-.7-1.2-.2-1.8,1.6-2-.3.6,0,1.1.9,1.5,2.6,0,3.4-1.1,2.6-3l.8-.9c-.9-1.9,2.4-1.9,2.1,0Z"
          fill="#0249cc"
        />
        <path d="M254.7,376.2v2c-.5-.2-1-.7-1.5-1,0-.4-.1-1.4,0-1.5s1,.6,1.5.5Z" fill="#022eab" />
        <path
          d="M268.7,370.2c2.3-1.1,2.4-1.1,1-3.5,1.8-.7,2.1,1,2.2,1s.4-.4.8-.5c1,0,1,.8,0,1q-.2.2,0,0c.4-.5.9-.5,1.5,0,.1.3.5.4.5,1s0,.4,0,.5c.4.6.2.9-.5,1,0,0-.9-.2-1,.2-.4,1.2,0,1.3,1,1.3l.5-.5c.4-.2.8-.1,1.3-.5,1.4-1.1,2.5-3.7,2.7-.5s0,1.4,0,2,0,.3,0,.5c-.4.9-.8.9-1,0,.8,2-.8,4.5-2,1-1.7-.8,1.6-3,2-1-1.6-1-2.5-.6-2.5,1.5,1.7.1,2.4,2.9.5,3-1.1-.9-1.8-1.7-2-2.5.7-.2,0-.7-2-1.5-1.6-1.1-3.6,1.2-2.2,2.5-.7,3.2-2.7,3.8-3.8.5-.1-2.5-2.1,2.9-1.4,4.6l-.6.4c-.9,1.6-2,.7-1.5-.5l-.3-.7c-1.8,1.7-3.2,2.1-4.2,1.2-.4,0-.6,0-.5-.5l-.5-.5c-.6-1.4.5-1,1.5-.5-.4-1.2-1.3-2-2.5-2.5-.1-.3-.3-.2-.5.5-.1.3-.3.3-.5,0-.7-.8-1.3-1.7,0-2-.6-.7-.3-1,.5-.5.3-1.3.8-1.6,1.5-1l.6-2.2c-1.1-1.6,1.4-2.2,2.8-1.7s2.7,1.4,2.6,2.2c1.5-1.4,3.2-1.9,4,.2-.1-1.4.7-2.4,2-3Z"
          fill="#034ac6"
        />
        <path
          d="M268.2,370.2c.1,0,.4,0,.5,0-.8.9.2,1.2.5,2-2.9-1.3-1.6.9-2.5,1-.9-2.1-.1-2.2,1.5-3Z"
          fill="#023cc2"
        />
        <path
          d="M274.2,368.2l-.3.5c-.3,0-1.2-.4-1.2-.5,0-.2,0-.7,0-1,.3,0,.7-.5.8-.5.6,0,.6,1.2.7,1.5Z"
          fill="#0137b2"
        />
        <path d="M275.2,370.7c-.3,0-.7,0-1,0,.1-.1.5-.8.5-1h.5v1Z" fill="#0345be" />
        <path d="M274.2,372.2c.1-.2.3-.4.5-.5,0,.2-.2.5-.5.5Z" fill="#0345be" />
        <path
          d="M277.7,373.2c-.7,0-1.3-.1-2,.2s0,.7,0,.8c0,.2-.2.6-.5.5-1-3,.5-1.7,2.3-4,0,.5.3,2.1.2,2.5Z"
          fill="#023fbb"
        />
        <path
          d="M255.7,377.7c.5-.6,2.8.3,2.9.6s-.1,1.8-.4,1.9c-.3-.5-2.3-1.6-2.5-1.5,0,0,0-.3,0-.5-.3-.1-.3-.3,0-.5Z"
          fill="#0241bc"
        />
        <path d="M256.7,374.7c-.3.1-.5.6-1.5,1v-2.5s1.5,1.5,1.5,1.5Z" fill="#023ebb" />
        <path d="M255.7,377.7v.5h-.5c-.3-1.6.6-2.3.5-.5Z" fill="#0366d2" />
        <path
          d="M257.7,381.7c0,0-.1.5-.2.5-.4-.3-.6-.5-.8-1,.1-.3.3-.3.5,0,.1.2.4.3.5.5Z"
          fill="#0350c7"
        />
        <path d="M272.7,368.2c.2.2-.5.8-.5.2s.4-.4.5-.2Z" fill="#024ccc" />
        <path d="M273.5,372.7c.3.2.3.3,0,.5v-.5Z" fill="#0345be" />
        <path d="M257.2,381.2h-.5c0-.2,0-.3,0-.5.6,0,.4.4.5.5Z" fill="#0241bc" />
        <path
          d="M261.2,382.2c1.7-.3.4.6.8,1s1.2.5,1.7,1q-.7,1,0,0c1.8-.4,2.1-.3,3.5-1.5s.4-.3.5-.5c.8-1.2,1.2-.9,1,.5.4.1.4.3,0,.5-1.6,2.6-1.6,2.9,0,1,1.2-1.9,1.4,0,.8,1.5l.2,1c.2-.9.4-1.3,1-.5.1-.4.3-.4.5,0,0,1.6-1.4,1.3,1,3-.5,0-1,0-1.5,0-1.1,1-2.2,1.6-3.5.7-1.1.3-3.9-.3-2.9-1.7-.3.4-.7.3-1.2,0-.6,0-.9-.5-.5-1-.7.2-1.5,0-2.5-.5-1.7.5-4.8-.1-3-1.5.2,0,.8-.7,1.3-.8s1.1.4,1.1.3c.1,0,.4-1.4,1.5-2.5Z"
          fill="#034dbf"
        />
        <path
          d="M263.2,388.2c.6-.9,1.6-1.5,2.5-.5s-1.3.8-1,1.5c2.3.7,3.2-1.8,5.5-1.5l-2.5,2c1-.2,2-.3,3-.5-1.5.2-.3,2.2,0,2.5s1.2-.5,1.7-.5l-.2,1,1.5-.5c.6,2.5-1.7,1.3-3.5,1-.5-1.1-1.2-1.4-2-1-.6.1-.1.4,1.5,1,.2-.4.3-.4.5,0-.1.6-2.5.4-1.5,1.5s.9-.9,2.5,0c-.2,1.1-2.1,1.7-2.5.5l-.5-.5c-.1.4-.3.4-.5,0-.7.4-.9.2-.5-.5-.7.4-1.7.5-1.5-.5-.4-.1-.4-.3,0-.5l.5-.5c-.4-.2-.6-.6-.5-1l-.6-.7c-2.3,0-3.1-.5-2.4-1.8-.4-.6-.2-.9.5-.5Z"
          fill="#0242b3"
        />
        <path
          d="M268.2,394.2l.5.5c1.3.5,1.2-.2,2.5-.5.2.1.3.4.5.5-1.2.9-.4,1.3-2.5,1-1.7,1.2-4-.8-1.5-1.5h.5Z"
          fill="#0134a2"
        />
        <path
          d="M269.7,381.7c1,.3,1.5,2.4.5,3,0,.7-.2,1.4-.5,2-1.5-1,1.1-2.9-1-2.5-.9,0-.7-.6,0-1,0-.2,0-.4,0-.5-.7-.6.2-2.2,1-1.5.4.1.4.3,0,.5Z"
          fill="#0345be"
        />
        <path
          d="M271.2,385.7c0,.2,0,.3,0,.5h-.5c-.8.2-.8-.8-.5-1.5.1-.5.3-.5.5,0,0,0,.5.9.5,1Z"
          fill="#0345be"
        />
        <path
          d="M273.2,382.2c.7.5,1.5,1.7,1.5,2.5q-.6.7,0,0c.4-.7,1,0,1.5.5.5,0,.4.3,0,.5,0,.5-.5.9-.5,1l-1,.5h-.5c-1.2.2-1.6-.4-.5-.5s.3.2.5.5c.5,1.3.7,2.1,1.5,3.5,1.3.7,1.8,1.5,1.6,2.5,2.7,1.9-.6,4.4-3.1,3.5,0-1-.3-.8-1,.5-.3,1.2-.6,2.2-1,3-1.2-.2-1.6-1.4-.5-2-1.1.4-1.6-.1-1.7-1.8,1,0,2.1-1.1,1.7-1.7-.8.6-1,.3-.5-.5-3,.7-5.4-1.1-1-1.5.3-.9-.2-1.9-1.2-2.9l1.7-.6c-.9-1.3-1.2-2.1.5-3-.4,0-.4-.2,0-.5.6-1.6,1.2-2.7,2-3.5Z"
          fill="#023bad"
        />
        <path
          d="M275.7,386.7c0,.2,0,.3,0,.5l-1,.5c0-.1,0-.4,0-.5.1-.5.4-.7.8-1l.2.5Z"
          fill="#0760c7"
        />
        <path
          d="M271.7,394.7c.5-.3,1.4-1.6,2-.7.3,1.4-.8,0-1.2.7s-.3,1.1-.8,1.8-.9.2-1,.3c-.2.2.8,1,1,1.5.4,1.3-.4,1.4-1.5,1l.5.5c.4.1.4.3,0,.5-.2,0-2.4-.5-2.4-.6-.2-.3,0-.8,0-.9.3-.5.3-1.2,0-2-1-.5-.6-.9,1-1,.8-.5,1.6-.9,2.5-1Z"
          fill="#0242af"
        />
        <path
          d="M274.7,383.2c.1.1,1,.9,1,1l.5.5c0,.1,0,.3,0,.5-.5,0-1-.2-1.5-.5-1.1-.6-1.1-1.4-1.5-2.5,1.1-.1,1.1.6,1.5,1Z"
          fill="#034dbf"
        />
        <path d="M274.7,384.7c.5.5-.4,1.6-1,1s.5-1.5,1-1Z" fill="#034dbf" />
        <path
          d="M273.2,397.2c0-.4-.5-1-.4-1.3.3-1.2,3.1-1.2,1.4.8-.2,0-.6.4-1,.5,0,.5,0,1,0,1.5v2c-.3,0-.7,0-1,0,0-.2,0-.3,0-.5,0-.8-.1-2.9,0-3s.7,0,1,0Z"
          fill="#0242af"
        />
        <path
          d="M272.2,400.2c-.5,0-1,0-1.5,0v-.5l-.5-.5c0-.6,1.1-.7,1.5-1,.2.5,0,1.4.5,2Z"
          fill="#01349b"
        />
        <path d="M274.2,387.2c-1.1.5-2.1.6-2-1l.7,1,.5-1.5c.7.4.6,1,.8,1.5Z" fill="#034dbf" />
        <path d="M272.2,390.7s-1.1.2-1-.2c.8-1.4,1.6-.3,1,.2Z" fill="#034dbf" />
        <path d="M276.2,384.7l-.5-.5c0,.1.4.2.5.5Z" fill="#0245b9" />
        <path
          d="M244.2,360.7c1.5-1.3,1.6.5,1.7.5.5,0,0-.7.3-.9s.8.4.9.4c.8.4,1.6.7,2.5,1,.6-1.7,4.3.5,4,2,.4.7.4,1.3-.5,1,.3.2.3.3,0,.5.4,0,.4.3,0,.5-.2,1.4-.7,1.9-1.5,1.5h-.5c-.8-1.3-1.7-1.5-2.5-.5-1.3-1.4-2.5-2.1-4.5-2.3l.3-.8c-1.8-1.2-1.9-2.1-.3-2.9Z"
          fill="#024bd5"
        />
        <path
          d="M255.2,326.2v.5c0,.5.2,1,.5,1.5,0,0,0,.4,0,.5,1,1.6,1,3.4,0,5.5.4.1.4.3,0,.5-.7.2-1.5.4-1.5-.5.8.5,1,.8,0,1-.8,1.4-.6,1.4.5,0-.2-.4.3-.6,1.5-.5.1-.4.7-.3,1,0l.5.4-2.1,2.6c.4,1.3.4,3.4-.9,4.1,0,.2-.1.3-.5.5.7.2.6.6,0,1-.8.2-2-.7-1.5-1.5.1-.1.8-.8,1-1l.5-.5c0-.1,0-.3,0-.5-.2-.1-.2-.3,0-.5,0-.2,0-.3,0-.5.3-.5,0-.3-.5,0-.2,0-1,.4-1,.5,0-.5,0-.8-.5-1-.2.4-.3.4-.5,0,0-.3,0-.7,0-1-.7-1.4-.8-4.7-.1-5.4,2.3-2.7,2.9,0,2.6,2.4l-.6-1.1c1.6-2.1.2-2.9-1.8-1.3-2.5-1.7-1.7-5.2,1-2.7l.9-.4-1-.5c-1.4.4-1.6,0-.5-1l.5-.5c-.1,1.1,1.2.9,1.5,0-.4-.1-.4-.3,0-.5.2-.4.3-.4.5,0,.1-.4.3-.4.5,0Z"
          fill="#024fe9"
        />
        <path
          d="M258.2,341.7c.6,0,.4.6,0,1,.5.6,0,1-1.5,1-.4,0-1.5,0-2,0-.6,1.2-1.6,1-3-.5-.1-.1-1,.3-1-.2.4-.9,1.6-1,2-1.3.6.2,1.1,1.5,1.5,1.5.5-.6.5-.9,0-1,.1-.4.1-.4.5-.5.5-1.3.5-1.3,1,0,.7-.8,2.6-1.9,2.5,0Z"
          fill="#0357e9"
        />
        <path
          d="M262.2,348.2l1.2-1c1.1.8-.5,1.8,1.2,1.5,0,.3.7,1,.5,1.5-.6.1-1.5-.2-2,0-.2-.4-.6-.4-1-.5v-1c-.4,0-.4-.3,0-.5Z"
          fill="#023ed5"
        />
        <path
          d="M248.2,360.2c1.1-.3,1.4,0,1.5,1,0,.2,0,.5,0,.5,0,2.5-1.4-.2-2.5-1,0,0,.6-.4,1-.5Z"
          fill="#0a6fe1"
        />
        <path d="M253.7,338.7c0-.6.9-.8,1-.2l-.5.2c-.2,0-.3,0-.5,0Z" fill="#0357e9" />
        <path
          d="M258.7,358.2c1.4.8,1,1.7-.5,2-1.3.7-2.3-.8-1.5-2-.5-.6-.2-.8.5-.5.6.1,1.1.3,1.5.5Z"
          fill="#035ce7"
        />
        <path
          d="M254.2,338.7c.5,0,.4.3,0,.5-.2.2-.2.4,0,.5.4.2.4.3,0,.5l-.5.5c.6.8-.1,1.7-1,1v.7c-1.1,0-1.5.2-1,.8.8.1,1.5.7,2,1.7l1-1.2c.3-1.4,1.4-1.3,2,0,.4-.2.6,0,.5.5.4-.2.6,0,.5.5-.9.9-.6.9.7,0,.3.8,1.2,1.2,1.8.5-.7-3.1,4.6.4,1,1,.6.2.8,1,.5,1.5l.5,1c1.3.2,1.3.6,0,1-.8.4-1.7.7-2.5,1,.8,0,.5.5,0,1,.3.6.7.9,1,1,.2-.2.3-.2.5,0,1.2,0,1.3.5,1,1.5,0,0-2,0-1.5.7,1.6.9,1.6,2.4,3.5,3.5-.3.7-1.1,0-1.5-.3-.1-.4-.3,0-.6,1.1-.2-.7-1.2-1.4-1.3-1.1-.9,1.8-2.1,2-2.1,0-.4-.1-.4-.3,0-.5-.8-.6-1.3-.8-1.5-.5-1.3,1-2.6,1.5-4,1.5-.9.3-1.8.5-2.5.5-.9,1.2-1.8,1.5-2.5,1,.2,1.4,0,1.2-1,.5-1.5,1.3-.5,0-.3,0,1.1.6-1.5,1.7-2.7,0-1.1-1,.2-.7.1-.6-2.7.4-2.8-1.7-.6-1.4,0-1.5.3-2.1,1-2,.3-.5.3-.8,0-1-.2-1.7-.5-2.2-1-1.5-1,1.7-4.4,1.7-2.6,0-.1-.7,0-1.2.1-1.5.4-1.5.8-1.7,1.3-.8l.6-.2c-.4-.1-.4-.3,0-.5,0-.8,0-1.7,0-2.5v-.8c1.7.3,2.3,0,2-.7-1.5-1.1-2.7-3.5,0-3.5.8-1.1,1.2-.8,1,.5.3-.9,2.5-1.1,2.7-.1s-.6,1.6-.7,1.6c-.2,0,.2-3.8,1-4,1.2-.8,2.3-1.6,3.5-2.5-.6-1.4,0-1.6,1-.5.2-.3.3-.3.5,0Z"
          fill="#035ce7"
        />
        <path
          d="M244.7,355.7c1.5.3,1.7-3.3,1.5-4,4.8.7,2.1,2,2.2,3.2s.8.9.8,1c0,.8-2.2,1.4-1.7-.8s1.4-1,.5-1.5c-1.8-.7-1.3,2.7-.8,3.3s1.6.4,2,1l-3.2.7c-1.8-1.2,0-.4.2-1.7s-1-.7-1.5-.3c-.9,0-.8-.6,0-1Z"
          fill="#0251e1"
        />
        <path
          d="M247.7,341.7c.1-.4-.3-.8.3-1,1.4-.4,1.2.1,1.2,1s.4,1.9.4,2.3-1.6.5-.9,2.2c-2,.4-.1-1.6-.5-2-1,.5-1.2.3-2,0-.8-.6-.3-2.4,1-2h.5c.2-.2.2-.4,0-.5Z"
          fill="#0251e0"
        />
        <path
          d="M258.7,342.7c-.3,1.3,1.3,2.1,1.5,2.5s.7,2.3.3,2.5c-.9-3-3.6.7-2.3-2.5l-2,1c-.3-1.4,1-1.2,1.5-1.5.2-.5,0-.6-.5-.5-.2-.2-.3-.3-.5-.5.2,0,.9-.9,1.5-1,.2-.4.3-.4.5,0Z"
          fill="#0348e5"
        />
        <path
          d="M245.2,347.2c1.1-.2.9.9,1,1,1.1.7,1-1,1.2-1,1.4.3,1.4,1.2,1.3,2.5-.9.3-1.2-.8-1.9-.9s-1.1.3-1.4.3-.3-1.7-2.2-.4c-.2-.2-.3-.3-.5-.5-1,.4-1.4,0-1-1l.3-.5c.9.3,1.4,1,2.5,1s.7-.5.8-.5Z"
          fill="#0348da"
        />
        <path
          d="M262.2,349.7c.5-1.5,1.5-1,1,.5-.9.3-2,1.7-2.5,2.5-.2,0-.4.8-.7,1-1.2-.7-.2-1.2-.3-2,.5-.7.5-1,0-1,0-.5-.4-1-.5-1.5,1,0,2,.2,3,.5Z"
          fill="#0354e3"
        />
        <path
          d="M253.2,348.2c0-1.8,1.3-.7,2.5-1.5-.4,3.2-1,1.5-2.5,1.5,0,2.1,1.8,0,1.5,2-2.2-.9-1.1-.1-2,1,.6-.1,1.9-.6,2-.5.9,1.1-1,1-1.5,1.3-.6.4-.8,1.1-1,1.2,0,1-.5.8-1,0,.5-.4,1.1-1.4,1.5-2-.8.1-1.4.7-2.3,0s-1.3-1.9.3-2.1c.3.6.6.6,1,0,0-.3-.8-.8-.3-1,.5.6,1.2,0,1.8,0Z"
          fill="#0350e3"
        />
        <path
          d="M244.7,355.7c0,.3,0,.7,0,1s-.9.7.5,2h-1.5c0-.1,0-.3,0-.5-.4-.1-.4-.3,0-.5-.4-.6-.6-.3-1-.5-.4-.6.3-1.3,1-1.5.2-.5.8-.7,0-1.5.1,0,.5-1,.7-1,1,0,.3,1.8.3,2.5Z"
          fill="#0241d6"
        />
        <path d="M254.7,343.7l.5,2c-3.3.8-2.3-1.2-3.5-2.5l.2-.5c.9.8,1.6.9,2.8,1Z" fill="#0346db" />
        <polygon fill="#024ddf" points="251.7 344.7 250 347.7 249.7 345.2 251.7 344.7" />
        <path
          d="M253.2,358.7c-1.1.7-1.8,1.8-2.5,1-.4-.2-.4-.3,0-.5-.1-.5-1.2-1.3-1-1.5l3.5,1Z"
          fill="#0253e0"
        />
        <path
          d="M250.7,355.7c.6.7,2.2,1,.8,2-.5-.4-1.5-.7-1.7-1.2-.5-1,.8-.6,1-.7Z"
          fill="#0253e0"
        />
        <path
          d="M250.7,359.2c0,.1,0,.4,0,.5,0,.3-.9.8-1,1.5-.8.2-1.1-.4-1.5-1,.6-.2,1.5-1.1,2.5-1Z"
          fill="#024bd5"
        />
        <path
          d="M258.7,357.7c-.5,0-1.1-.1-1.5,0,0,0,0-.4,0-.5-.1-.2-1-1.7-.3-1.5,1.1.7,1.5.7,1.8,2Z"
          fill="#023ed0"
        />
        <path d="M255.2,355.7c-1,.8-1.6-1.6-1.5-2.5.4-.5,1.6,2.4,1.5,2.5Z" fill="#0248de" />
        <path
          d="M251.2,353.2c.4.1.4.3,0,.5-.7,1.1.4,1.6-.5,2,0,0,0-.5-.2-.8s-1.2,0-.8-.9c.3-.7,1.3-.6,1.5-.8Z"
          fill="#0251e1"
        />
        <path d="M257.7,352.7c-1.8.8-1.7-.4-.7-1.5.5.4.9.8.7,1.5Z" fill="#024adb" />
        <path d="M251.7,349.2c0,.5,0,1,0,1.5-1.4.3-1-.4-1-1.5.3,0,.7,0,1,0Z" fill="#0567ee" />
        <path d="M261.2,346.2c.6.5.7-1,1,1.5-.1.4-.3.4-.5,0,0-.3-.6-1-.5-1.5Z" fill="#0236da" />
        <path d="M257.7,347.2v1.5c0,.2-1.3-1.1-1.5-1.5h1.5Z" fill="#0350e3" />
        <path d="M252.2,353.2l1,3-2-2.5c0-.1,0-.4,0-.5.1-.1.9.1,1,0Z" fill="#0248de" />
        <path d="M259.7,350.7c1.5-.2,1.2.4,0,1,0-.3,0-.9,0-1Z" fill="#0c77ec" />
        <path d="M262.2,347.7c0,.2,0,.3,0,.5s0,.3,0,.5c-2,.2-.5-.7-.5-1h.5Z" fill="#067bef" />
        <path d="M256.7,349.7c0,.4,1.2,1.3-.2,1s-.2-.6-.3-1h.5Z" fill="#077cec" />
        <path
          d="M257.2,344.2l.3-.5c.8-.1.9,0,.7.7-.1.3-.4.2-.5.3-.2-.2-.3-.3-.5-.5Z"
          fill="#0463ec"
        />
        <path d="M256.7,348.2c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#098cee" />
        <path d="M256.2,349.7c1.7-1.2.5,0,.5,0h-.5Z" fill="#0238dc" />
        <path d="M253.7,340.7l.5-.5c-.1.3-.4.3-.5.5Z" fill="#0357e9" />
        <path d="M254.2,339.7l-.5-.2.5-.2c0,.1,0,.4,0,.5Z" fill="#0357e9" />
        <path d="M263.2,365.2h.5c-.5.5-.9.4-1,.5l-.5-.5c0-.8.5-.5,1,0Z" fill="#024ccc" />
        <path
          d="M260.2,329.7c3.9-2.1-1.2,4.6.7,4.5s.7-5.2,3.2-2.5c-.1.6-1.7.8-1.5,1.7l1.7,1.8.7-1v1.7c1.9-.3,1.2.4,0,1.3s-1.3-.4-1,.7,1.8.7,2,1.5-.9.3-1.2.7.3,1,.2,1c-.6.4-2.9-.7-1.5-2-.3,0-.7,0-1,0-1.6,1.9-3.6,2.1-4.8-.2-4,1.4-2.2-3.3.3-3.8-.3-.1-.3-.3,0-.5h.8c-.9-1.2-1-2-.3-2.5-1.3-.6-.8-1.3,1.5-2-.4-.2-.4-.3,0-.5Z"
          fill="#0250ea"
        />
        <path
          d="M266.2,341.7l.2-1.5c1.6-1.7,4.3-1.3,1.7.7s-.8.7-1.4,1.3c-.2,0-.5-.5-.5-.5Z"
          fill="#075bea"
        />
        <path
          d="M271.2,335.7c0,.3,0,.7,0,1s0,.4,0,.5c0,.3-.4,1.9-.5,2s-1.4-.8-2-.5c.3-.4.4-1.4.5-1.5,0-.1,1.6.3,1-2,.1-.2.8.5,1,.5Z"
          fill="#023bd7"
        />
        <path
          d="M261.7,341.7l1,.5c0,.2.1.7,0,.9-.8,1-2.7-.1-2.4-1.4.4,0,1.2.1,1.5,0Z"
          fill="#045fee"
        />
        <path
          d="M258.2,335.2c-.7.4-3.1,2.8-1.2,3.5s-.1-1.2.7-1l1.8,2.5,1-3c.3.4,1.1.9,1.3,1.3.4,1-2.1.8-1,1.7s1.5-.9,2-1c0,.4-.4.7-.5,1-1.5.7-3.2.5-3.5,2.5-.2,0-.3,0-.5,0,0-.3,0-.7,0-1-.8-.8-1.7-.7-2.5,0-.3,0-.8,0-1,0,.8-1.2-.2-4.8,0-5s2.2,0,2.5-2c.3-.8.7-.2,1,.5Z"
          fill="#045fee"
        />
        <path d="M267.7,337.7c1.2,1.4-.8,1.7-.5,0,.2,0,.3,0,.5,0Z" fill="#022fd5" />
        <path d="M265.7,348.2l.5-.5c-.2.1-.3.4-.5.5Z" fill="#0357e9" />
        <path
          d="M254.2,364.2c.2.2.3.2.5,0,.1-.4.3-.4.5,0l.5.5c.1-.4.3-.4.5,0l.5.5c.2.2.2.3,0,.5.5,1-.4.9-.4.8,1.3-1.3,3.5,2.2.4,1.7-.2.2-.4.8-.6.9-.3.1-.8-.4-.9-.4-1-.4-1.6-1.4-2-3,0-.2,0-.3,0-.5.2-.2.2-.4,0-.5,0-.2.4-.8.5-1s.3-.4.5-.5c1.3.1,1.2.6,0,1Z"
          fill="#0357d8"
        />
        <path
          d="M254.2,368.7c-1.1.2-1.9,1-2,1-.2,0-1.4-.4-2,0-.4-1.2,1-1.1,1.4-1.6s0-.8.1-.9c.4-.5.7-1.3,1.5-1.5.6.7.9,1.7,1,3Z"
          fill="#0357d9"
        />
        <path
          d="M253.2,365.7c.3,0,.7,0,1,0-.1,1.2.2,2.1,1,3-.5,0-1,0-1,0-1-1-.9-1.8-1-3Z"
          fill="#0140c9"
        />
        <path
          d="M253.7,370.7v.5l-.5.5c-.1.3-.3.6-.5,1-.7-.7-1.2-1.7-.5-2.5.5.3,1,.5,1.5.5Z"
          fill="#0357d9"
        />
        <path d="M263.2,365.2h-1c-.2-1.5.4-1.2,1,0Z" fill="#0355dd" />
        <path d="M260.7,365.7l.5-.5c-.2.2-.3.3-.5.5Z" fill="#024ccc" />
        <path
          d="M241.2,232.3c4.8,0,10.9.5,15.8,1.7,1.9,1.9,5.4,2.2,8.2,2.3,1.2-.6,2.2-.7,3,.5,1,1.5.3.8-.8,1-2.1.3-5.3.3-7.2,0-2.7-.3-5.5-.6-8.3-.8-2.2-2-3-2.1-5.8-.9l-3.8-.2c0,1.4-.8,2-2.8,2-1.6,2.1-3.7,1.5-6.3-1.5-.2,0-.4,0-.5,0-.2-.2-.2-.3,0-.5.2-.6.6-1,1-.5l.5-.5c.4-1.2,3.4-1.9,4.5-1.5l1-.5c.1-.4.3-.4.5,0l.5-.5c.2-.4.3-.4.5,0Z"
          fill="#020d56"
        />
        <path
          d="M233.2,236.3s.1-.8.5-.5-.1.6.6,1.2,3.2,2.2,4.1.8.2-1.4.2-1.5,1.9.9,2.5.5c1-.8-2.2-1.2-.5-1.8s4,.1,5.3,0,1.6-.8,3-.8c2.3,0,2.1,1.5,3.2,1.8,1.7.5,4,.3,5.9.6s1.9,1,2.2,1.1v.5c-1.7-.7-4.3.1-6.2,0-3.4-.3-5.7-1.5-9.3-1s-1.3,1.5-1.8,1.5-1.5-.6-2.7-.3-.8,1.8-2.7,1.9-3.8-3.2-4.2-4.1Z"
          fill="#040b46"
        />
        <path
          d="M242.7,231.8c5.5-.6,12.6-1.3,17.1,2.5,1.6-.6,3.4-.6,5.4,0,1.6.8,2.2,1.5,3.5,2.5h-.5c-.8-1-1.8.6-3.2.5s-3.8-.6-4.3-.7c-1.3-.3-2.4-1.7-4-1.3l.5-1c-2.1-.9-4.5-.4-6.6-.6-4.3-.6-6.9-2.5-10.9,1.1l2.2-2c.8-.6-.4-.6-.7-.5-.7-.7,1.2-1.4,1.5-.5Z"
          fill="#010b61"
        />
        <path
          d="M259.2,253.8c1.3.2,4-1.3,3.5.5-.2,0-.4,0-.5,0l-.5.5c0,.6.4.4.5.5.4.4,1.1.4,1,1-2.2.2-2.2.2-2-2-.9-.3-.8.4-1,.5v.5c-.4.6-.8.8-1.5,1-1.2,0-.4-2.3.5-2.5Z"
          fill="#024be4"
        />
        <path
          d="M259.2,253.8l-.5,2.5v.5c-.2,1.5-2.5,1.5-3.5.5-.5-.6.3-1.1,1-1,.2-.2.4-.4.5-.5.1-.6.4-.9,1-1,.2-.5.4-.9.5-1.5.4,0,.9.5,1,.5Z"
          fill="#0250f3"
        />
        <path
          d="M239.2,249.3c.9,1.7,1.5,3-.3,4.2-1.4-.4-5.7-.2-5.1,1.6l-1.1.2c-.7.5-.7-1.2-.7-1.2.4,2.4-.7,3.6-2.3,1.7q-.2-.2,0,0c1,.9.8,1.2-.5,1-3.3,0-2.3-4,.7-3.7.4-1.3,1.5-2,3.3-2.3h3.5s.2-1,.2-1c.9,2.3,1.1.4,2.3-.5Z"
          fill="#0231c7"
        />
        <path
          d="M240.7,251.3l.5,1c.4.1.4.3,0,.5-.5.3-.6.7-.5,1,.4.1.4.3,0,.5-.1.4-.3.4-.5,0-.8,2.4-2.6,2.6-5.4.6v.4c.4.1.3.3,0,.5-1.2,1.4-2,1.5-2.5.5-.6-.4-.2-1.1.5-1,.4-1,.7-1.9,2-2l-1-.5c.9-2.1,1.5-.3,2.3,0s0-1,.5-1c1.2,0,1.1,1.9,3.2,0,.2-.8-.4-.3-.7-.5-.7-.5.2-1.4.2-2,0,0,.3,0,.5,0,.5.5,1.2,1.3,1,2Z"
          fill="#034cdf"
        />
        <path
          d="M233.2,250.8c-1.7,1.1-2.7,1.9-2,4-1.2-1.1-2-.6-3.5-.5-.3.2,1.4,2.2,1.5,2.5,1.5,0,1.7.6.5,1.5-1,1.1-1.8.4-1.5-1-.9.7-1.5.9-2,.5-.3,0-.4-.2-.5-.5v-.5c0,0-.6,0-.5-.5,2.3-.1.9-1.9,1-2,.4-.6,3,.2,1.5-2l1-1.5c.1,0,.3,0,.5,0,.7-.2,1,0,1.5.5.6,0,1.8-.8,2.5-1v.5Z"
          fill="#0229ba"
        />
        <path
          d="M249.2,244.8c1.5.2,1.6.7,3.5,1-1.4,0-2.7,2-2.8,2-1.4.3-2.3-1-2.4-1-.5,0-.6,1.5-1,1.5-.9,0-1.4-1.2-1.7-1s-1.2,2.2-2,2.5c-.7,1.1-1.4,1.2-2,0-.2.2-.6,0-1-.5-.2.4-.3.4-.5,0-.6.7-.8,1.4-.5,2.1-.1.3-5.5.5-5.5-.6-.4-.1-.4-.3,0-.5.2-1.1,1.2-1.6,2.9-1.6.4-1.9,1.6-2.6,3.8-2.2,1-3,5.1.2,4.8.2s-2-1.1-1-1.5c.1-.4.3-.4.5,0,.5-.7,1.6-.4,1.5.5h.5c-.3-.8.7-1.1,3-1Z"
          fill="#0232c1"
        />
        <path
          d="M249.2,243.8l-1.5.7c0,.5,1,.2,1.5.2-.8,1-2.8-.2-2.5,1.5-.4.1-.4-.4-.5-.5h-.5c-.5-.2-1.1-.2-1.5-.5l-.5-1c1.8.4,3.4-.4,5.5-.5Z"
          fill="#021f98"
        />
        <path
          d="M243.7,245.3l1,1.5-2-.5.3,1c-2,.5-1-1.2-1.2-1.5-.8-.9-1,.9-1.6,1.2s-2,0-2.5.3-.3,1.4-1.1,2-2.3.7-3.2,1c-.7.7-2,1.8-2.5,1-.6-.3-.9-.5-.5-1,0-.1,0-.4,0-.5l1.5-1,1.5,1c0-3.3,2.2-1.2,2.5-1.5s-.1-.7,0-1c1.5-2.6,2.8-.7,4.2-1.1s.6-1.2.7-1.3.7-.4,1-.5l2,1Z"
          fill="#021f98"
        />
        <path
          d="M240.7,249.8c.3.5.4,1,.5,1.5-.1.4-.3.4-.5,0,0-.2-1.3-1.2-1-2,0,0,.1-.5.2-.5.2,0,.5,1,.8,1Z"
          fill="#0231c7"
        />
        <path d="M249.7,246.8l-1.5-.2c.7-.9,1.1-.8,1.5.2Z" fill="#0237cd" />
        <path d="M246.2,245.8h-.5s-.2-.4.5,0Z" fill="#021b8d" />
        <path d="M264.2,254.8c.5.9,1.1,2.8-.2,2.5l-.8-2.5c.2,0,.8,0,1,0Z" fill="#034de9" />
        <path d="M266.2,256.8l-.5-.5c.3,0,.4.3.5.5Z" fill="#0239e4" />
        <path
          d="M252.7,245.8c1.4.2,1.8,0,2.7,0s0,1.3.3,1.5c.9,1,1.1-2,2-1s-.7,1.8-.3,2c1.7.3,1.9-1,2-1,.4.1,2.1,1.5,2.3,1.5l1.8,2.5v-1.5c.7,1.2,2,2,2.7,3-.1,1.6-1.3,2.1-3.5,1.5-.5-.5-1-.6-1.3.2-.3-.7-.9-.7-1.9,0l-.4-.7c-1,.8-1.1.8-1-.5-1.5-.2-3-1.2-4.3-2.7-.2,1.1-1.8.9-2.8.7-.7-2.1-1.7-1-2.6.4l-.7-.4c-.5.9-.9.7-1.5,0-.9,1.5-3.5.2-3.7-1.3-.7-1.6,2.1-3.9,3.1-2.9,1.6-1,2-1.1,3.5,0,.8-1,1.9-1.4,3.4-1.1Z"
          fill="#0237cd"
        />
        <path
          d="M242.7,249.8c1.4.3,1.5.4,2.8,1.5.2,0,0-1.8.2-2,1.1-.8,1.5,2.4,2.5,1.5s.4-1.9.5-2,.7.4,1.2.4c1.5,0,2.8-.8,1.8,1.6h1.5s-.5-1-.5-1c2.5-1.2,3.8,2.4,4.3,2.5,1.5.5-.7-2.3,1.2-2.5,0,1.1.1,2.4,0,3.5.8.5.5,1.7-.5,1.5l-1,1c.6.7.4.9-.5.5-.7.6-1,.4-.5-.5-.8.4-1.3-.2-1.5-1.6-1.6.6-3.2.7-2.5-1.4.4-.2,0-.4-1-.5,0,1.3-.4,1.3-1,0,0,.8-.7.7-1,0-.3,0-.4.2-.5.5,0,.5-.5,1.4-1,1.5-.5.3-1,.3-1.5,0-1.1-.7-2.4-1-3.9-.9l-.6-1.1c-.7-.1-.5-.5,0-1-.6-.3-.9-1-.5-1.5.2,0,.7-.3,2,0Z"
          fill="#0247e4"
        />
        <path d="M260,249.3c.3.2.3.3,0,.5v-.5Z" fill="#011a92" />
        <path d="M257,248.8c.3.2.3.3,0,.5v-.5Z" fill="#0247e4" />
        <path d="M261.7,254.8c0-.6.3-.4.5-.5l-.5.5Z" fill="#0239e4" />
        <path
          d="M252.2,308.3c.5.7.8,1.7,1,2-.5.9-1.5,1.2-3,1,0,.4-.3.4-.5,0-.4.5-.9.7-1.5.5-.9,0-1-1.3-1-2-1.4-1.5,6.4-3.8,5-1.5Z"
          fill="#0358f6"
        />
        <path
          d="M242.2,301.3l.5.5c-.2.4-.3,1.1-.2,1.3,2.5,0,3.5,1.9,3.7,4.3,1.1-.9,3.9-1.3,5.4-1,.1.2.3.4.5.5h1c-.2.5,0,1.3-1,1.5-.2-.3-.3-.8-.7-1-1.2,1.4-3.5.7-4.3,2.5-.1.4-.3.4-.5,0-.2,1.3-.8,1.6-1.5.5-1-.3.1-1.5.2-1.4s-1,1.7-1.7.9c.2,1.3,0,1.5-1,.5-.2,1-.5.8-1,0-1-.9,0-2.8.1-1.8l.4-.7c-2-.5-2.7-1.5-2-3.2-.5-.2-1.4-1-1.3-1.4,0-.8,1.6-2.7,1.8-.9.2-1,.6-1.5,1.5-1Z"
          fill="#0241f0"
        />
        <path
          d="M253.2,311.3v1c-.8.9-2,1.4-3.5,1.5-1.6.5-1.7-.6-.5-1.5-.6-.6-.3-1.1.5-1,.1,0,.3,0,.5,0,1.1-.2,2.1-.2,3,0Z"
          fill="#045df6"
        />
        <path d="M253.2,310.3c.4.1.4.3,0,.5,0,.2,0,.3,0,.5-1.3.8-2,.2-3,0l3-1Z" fill="#0243f2" />
        <path
          d="M255.7,313.8c.2,0,.4,0,.5,0,.8-.6,1.3.6,1,1.1-1,1.8-5.6.6-2.5-1.6.2,0,.8.5,1,.5Z"
          fill="#0969f9"
        />
        <path
          d="M253.2,312.3c.2,0,.4,0,.5,0v1.5c-.1.4-.3.4-.5,0-.2-.3-.3-.3-.5,0,.5.6.2.9-1,1-.6,1.1-1.3.8-2-1,0,0,.5-1.4.5-1.5.1-.1,1.7.3,3,0Z"
          fill="#0246f0"
        />
        <path
          d="M268.2,295.8c-.3.8-1.3.6-2,1.2-1.3,1.1-2,4-.5,2.8s-.4-1.5,1-1c.1,1.2-1.2,2.2-2.2,2s-.2-.8-.5-.9-2.1.1-2.3.6c-.3,1.4,2.5,1.4,2.9,1.8s-.4,1.3.2,1.8,2,1,2.4,1.1c-2.3,0-2.2,1.2-2.5,1.5-.9.7-1.3-2.3-2.2-.5s2.3.5,1.8,2c.4.1.4.3,0,.5-.6,0-2.8-.4-3-.5l-2.5,1c-.5.4-1.5.9-1.7,1.5s.4,1.4.2,1.5c-.6.6-2.2-1.8-2.5-1.5-.6.6,1.9,1.7,1,3-.7.7-1.3.4-1-.5-.6,0-.6-.5-.5-1-.2-.2-.4-.2-.5,0-.1.4-.3.4-.5,0-1.3,0-1.3-.4,0-1-.5,0-.4-.2,0-.5.5,0,.5,0,0-.5-1.4.5-1.9-1-1-2-.5-.7-.1-1.2,1-1.5-.1-.3,0-.6.5-1-1-.2-.9-1.7,0-2,.2-.5.7-.5,1.8.1,1.8-1.3,2.9-1.3,3.2-.1.2.5.5.5,1,0-.4-.1-.4-.3,0-.5.5-.2.3-.3-.5-.5-2.3,1.9-2.1-2.2.5-2-1.7-1.6,1.5-3.8,1-1.5.9.2,1.7.1,2.7-.5s.3-1,.3-1c-.5-.8-.2-1.1,1-1,1.1-.9,2-1.2,3.5-1Z"
          fill="#0350f6"
        />
        <path
          d="M260.7,299.3c0,0-.5-1.2-1.5.3l1,.3c0,0-.3.7-.5,1-1,.9-1.3.8-1-.5,0-.5.4-1.1.5-1.5l2-1.5-.5,2Z"
          fill="#0236ef"
        />
        <path d="M264.7,296.8c0,0-.6.6-1,1l-1-1.5,2,.5Z" fill="#0132ec" />
        <path
          d="M259.2,302.8l2.5-.5c.9,3,0,3.8-3,4l2.5-2.2c.2-1.3-.9-.5-1.5-.7s-.3-.4-.5-.5Z"
          fill="#023ff2"
        />
        <path d="M258.2,307.3l-1,2c-2.3-1.2-1.4-2.2,1-2Z" fill="#0239ec" />
        <path
          d="M254.7,313.3c-.3.7-.7.9-1,.5-.4-.5-.9-1.6,0-1.5.1-.3.3-.3.5,0,.6.2.5.3.5,1Z"
          fill="#0230e3"
        />
        <path d="M253.2,310.3c.1.1.8-.3,1,.3.4,1-.3.8-1,.2,0-.2,0-.3,0-.5Z" fill="#045df6" />
        <path d="M257.2,305.8s-1.1.2-1-.2c.8-1.4,1.6-.3,1,.2Z" fill="#0136ee" />
        <path d="M259.7,303.8c-.6,1.2-1.2,1.5-1,0,.3,0,.7,0,1,0Z" fill="#023ff2" />
        <path d="M254.2,312.3c-.1,0-.3,0-.5,0,0,0,.1-.4.2-.5l.3.5Z" fill="#0345f1" />
        <path
          d="M252.2,278.8l1.5-1-.5,3.5c2.6.4.9-.7,1.3-1.5s.7-.3.7-.5c-.1.6.2,1,.5,1.5.8-.4,1.5,0,1.5,1,.5.2.6.8,1.5,0,0,.3.9,2,1,2.5.4.1.4.3,0,.5h-2s.5-2,.5-2c-.1-.1-.7.4-1,.5-.6.8-1.1,1-1.5.5,0,0-.2-1.1-1,.5l-1-.5-.2-1c-.3.3-.4,1.9-1.2,1s1.4-1.4,1.5-1.5c.3-.4-.9-.8-1-1-.7-.4-.9-1.9-.5-2.5Z"
          fill="#034cf5"
        />
        <path
          d="M260.7,277.3c1,.4,2.6,2,3,3-1.5-.9-1.5-1-3-.5-.4-.1-.4-.3,0-.5l-1-1.8.5-.2c.1-.3.3-.3.5,0Z"
          fill="#0356f7"
        />
        <path
          d="M260.2,280.3c1.7-.2,3,1.7,3.5,0,0,.2.5.4.5,1,.4,0,1.5,0,2,0-.1.2-.4.3-.5.5l-.5.5c-.3.5-.6.9-.5,1.5l-1.5-.5c.3-.7,1-1,1-2-1.7.4-2.4,2.2-2.4,3.8s.9.3,1,.5c.5,1.7-.8,1-1.5,1.5s-1,1.2-1.5,1.7c-.9-2.2-1.8-1-3-1-1.5-.6-1.5-1.8-.5-3-.2-.5,0-1,1-1.5.1-2.2,1.5-.3,2.2.9l.3.6c.5.2.4-.4,0-.5-1.2.4-1.9-2.1-1-2.5-.7-1.3,0-2.6,1.5-1.5Z"
          fill="#0356f7"
        />
        <path d="M265.2,282.3c.1-.2.4-.3.5-.5-.2.3-.5.5-.5.5Z" fill="#0250f3" />
        <path
          d="M259.7,284.3c.5-1.4.8,1.2.8,1.3-.1,2.5-1.3,1.8-2.3,0,1.2-.3,1.6,1.1,1.5-.8s0-.3,0-.5Z"
          fill="#0247f4"
        />
        <path
          d="M257.2,283.3c0,.6-.9,1.2-1,1.5h-.5c0-.3,0-.7,0-1,.5-.1,1-.3,1.5-.5Z"
          fill="#0337ec"
        />
        <path d="M260.7,282.8c-.1-.9,0-1.7,1-2,.1.9,0,1.7-1,2Z" fill="#012ae6" />
        <path
          d="M253.7,288.3c0,.8-.5,1.6-.5,2.5-.9.2-.3-.7-.5-.9s-1.2.5-1.7.5l.7-1c.2-.4.3-.4.5,0l.5-.5c-.4-.1-.4-.3,0-.5.3,0,.7,0,1,0Z"
          fill="#055df7"
        />
        <path
          d="M254.2,287.3c0,.3.2.6.5.5,0,.3,0,.7,0,1-.2.2-.7-.4-1-.5,0-.4-1.4-1.2.5-1Z"
          fill="#055df7"
        />
        <path d="M256.2,294.8l.5.5h-1c0-.2.5-.4.5-.5Z" fill="#0359f7" />
        <path
          d="M234.7,255.3c.8-1.1,1.7-.1,2.4,1,1-.6,1.2-.1.6,1.5.5.1.4.3,0,.5l-.5.5c-1.8-1.4-4.1,1.2-3,3,.6-.4.8-.1.5.5,1.1-.2,1.3.2.5,1,1.8-.5,4.5,2.9,2.8,4.2,1,1.3,1.1,2.8-.3,3.8-1.8-2.9-1.6.6-2,1s-1.8-1.5-1.5.5c-2-.6-1.6-3.3-1-5h-.7c.5-.6.6-1.4.2-2-1.2,1.2-1.7-.3-1.3-1.8-.8-.4-1-.8-.7-1.7l.2-.6c-2.2.8-2.3-2.3-.2-1.4.7-.2,1.4-.5,2-1-.4-.4.2-2,1-2l.5-.5c-.3-.3-.2-.7.5-1,0-.2,0-.3,0-.5Z"
          fill="#024fef"
        />
        <path
          d="M233.2,267.8c.2.4,1.2.4,1,.7-2.9,1.6-1,1.4-.6,1.9s.6,2.2.6,2.4c0,.3-.8,1.4-.5,2,1.7.5,2.5-.7,4-1l-1,1.7,1,.7c-1.3.6-1.6-1-1.7-1s-1.7.4-1.8.5,0,2.3.1,2.4c.3.3,1.1-.3.9.6-2.3-.7-1.8,1.4-3.5,1.5-.4-1.4.1-3.2,1-4.4-2-1.5-.2-.9,0-.7.5,1,0,2.3-1.4,2.1-.5.1-.6,0-.5-.5-.3,0-.6-.1-.5-.5-.4-.1-.4-.3,0-.5-1.3-.5-.6-2,.5-2.5,1.1-.9.9-1.8-.5-2.5-1.1-.8-.8-2.2.5-2.5.8,0,1.7-.2,2.5-.5Z"
          fill="#023fec"
        />
        <path
          d="M231.2,280.3c0,.3,0,.7,0,1,.3,0,.7,0,1,0l.5-.5c1.6-.8,1.6-2.1,2.5.5-.8.9-.8,1.6,0,2,.2,0,.3,0,.5,0,.4.1.7,0,1-.5.1,0,.4,0,.5,0l.5.5c.3.2.6.5,1,.5v.5c0,.2-.1.4-.5.5.4.1.4.3,0,.5l-1.5-1c-1.6-.5-.3,2-3,.5-.3-.7-.4-1.5-.5-2.5-.9.2-.9.4,0,.5.7.5.4,1.5-.5,1.5,0,.6.9,1.9,0,3-1.4.5-1.5,0-.5-1-.4-.3-.5-.3-.5,0,1.1,1.5.5,1.6-1,1.5-.4-.1-.4-.3,0-.5-.4-.1-.4-.3,0-.5l-1.1-.4c-.3-1.5,0-3,.6-4.5-.7-1.4-.9-3.4,1-2.5.4.3.4.7,0,1Z"
          fill="#0244f2"
        />
        <path
          d="M231.2,277.3c.2-1.7.8-.7,1-1.3.4-1.3-1.2-.3-1-1.2,4.1-.3,1.4,1.8,1.5,2l1.5.8c-1.6.4-2.3,1-2.5,2.7h-.5c0-.3,0-.7,0-1-1.4-.4-1.3-1.5,0-2Z"
          fill="#0252f3"
        />
        <path
          d="M250.2,286.3c0,1.1.9,2.2,2,2v-1s.5,0,.5,0c0,.3,0,.7,0,1s0,.4,0,.5l-.5.5c-.1,0-.4,0-.5,0-.3-.1-1.1-1.2-2-1-1.8-2.5-.6-.9.5-2Z"
          fill="#0236f1"
        />
        <path
          d="M252.2,278.8c.4.7.3,1.9.5,2.5h-.5c-.4.2-.6,0-.5-.5,0-.3,0-.7,0-1-1.2-.2-1.4-2.3,0-2,0,.1.4.8.5,1Z"
          fill="#023beb"
        />
        <path d="M251.2,277.3c-.2,1.1-.6,1.7-1,2-1.1-1.2-1-3.4,1-2Z" fill="#0233ee" />
        <path
          d="M251.7,277.8c-1.1.4,0,1.5,0,2-.7,0-1,0-1.5-.5.4-.9-.4-1.5,1-2,.2.1.4.3.5.5Z"
          fill="#034cf5"
        />
        <path d="M245.2,261.3c-.2.1-.3.4-.5.5h-.5c.2-.4,1-.5,1-.5Z" fill="#023ee9" />
        <path
          d="M245.7,257.3c1.2-1.4,2.3-.4,3.3,2.8,1.4,0,3.1.1,2.2,1.7,0,.4,0,1.1,0,1.5-.3,0-.8,0-1,0,0-.4.1-1.3,0-1.5s-.8.5-1,.5-.9-.7-1-.5l-.3,2.5c-.4,0-.6-1.5-.7-2-.3-1-.4-2-.5-3-1.9-.1.1.6-1.5,2,0-.1-.5-.8-.5-1-1.4-.9-1.1-2.2.5-2.5-.3-.5,0-.8.5-.5Z"
          fill="#023ee9"
        />
        <path d="M250.7,264.8c-.2,0-.5-.3-.5-.5.3,0,.6.2.5.5Z" fill="#0250f3" />
        <path
          d="M250.7,252.3c.4.1.4.3,0,.5.8.1,1.2,1,.5,1.5,0,.2-.1.4-.2.6-.5.7.5,3.9,1.7,4.3v1.1c.4-.2.7-.3,1,0,.7-.6.7-.3.5.5-.1.2-.4.3-.5.5-1.1-.4-2.2-.9-2.5.5-.7-1.4-2.9-.4-3-.5-.2-.1-.8-4.4-2.5-4-.2-.7,0-1.9.5-2,.1-.4.3-.4.5,0,1.3-2.3,2.3-2.9,3-2,.2-.2.2-.4,0-.5-.4-.1-.4-.3,0-.5,0,0,.9,0,1,0Z"
          fill="#0254ef"
        />
        <path
          d="M253.7,261.3c-.6,1.3-1.1,3-.4,4.3s1.3-.6.9.5c-.7,1.7-2.1-1.1-3-.7-.4-.1-.4-.3,0-.5l.5-.5c-.8.1-1.3-.5-.5-1-.8-.2-.7-1.2,0-1.5-1.7-2.1,1.8-1.8,2.5-.5Z"
          fill="#0244ee"
        />
        <path d="M252.7,262.3l-1,1c-.1-1,0-1.1,1-1Z" fill="#0250f3" />
        <path d="M251.2,264.8c0-.2.3-.4.5-.5,0,.3-.2.6-.5.5Z" fill="#0250f3" />
        <path d="M255.7,280.8c2.4-1.3,4.2-1.1,1.5,1-.9-.3-.9,0-1.5-1Z" fill="#0238ee" />
        <path d="M263.7,280.3c.1,2-3,1.9-3.5,0-.6-.6-.3-.7.5-.5.3-2.3,2-.6,3,.5Z" fill="#0250f3" />
        <path
          d="M254.7,259.8c2.3-1.3,2.7,1.1.5,2.2-.1,1.1,0,2.2,0,3.3.6.5.3.9-.5,1,.2.2.5.4,1,.5.8,1,1.6,1.3,2.5,1-.4-.1-.4-.3,0-.5,0-.9.8-1,1,0l.5,1.5c2,1.4,0,4.2-2,3.5-1.1.6-1.4.3-1-1,2.2,2.1-1.3,2.1-1.4.5s.7-1.8,1.4-.5c-.6-.2-.8-.7-.5-1.5-.6.2-1.3-.4-1-1-.8.6-.8-1.2-.7-1.3-.4,2,0,2.9,1.3,3-.9,1.7-.7,2.4.7,2.1l.2.7c-2,.6,3.5,1.2,2.9-.5-1.2-1,1.3-2.3,2.6-2,.5.4.8.6,1.5.5-.1-.8,1.2-.6,1.5,0,.4.2.4.3,0,.5-.2.2-.2.4,0,.5.5-1.5,1.3-2.3,2.5-2.5.3-1,.6-.9,1,.5v.5c.5,2.5-1.6,3.3-3.5,3,0,2.4-.5,3.2-1.7,2.6l-.7.4c-.1.3-.3.5-.4.5-1.1,0,0-.7.9-.5,2.1-.2,2.4-.9,1-2.2,2.4-2.6,3.1-.6,3.5,1.8-1,.2-1.2.8-.5,1.9-.2.3-1,.5-1,.7s.7,1.3,1,2.3c.4.2.4.3,0,.5-.3,0-.7-.5-1-.5-1.1.8-1.8.8-2,0-1.2.2-1.3-.2-.5-1-1.8-.9-2.8-1.9-3-3-.2-.2-.4-.2-.5,0,.8.9,1,1.6.5,2-.6.7-2.3,1.4-2.3.4-1.5.3-2.5.1-3.1-.4-.6-.7-.4-1.2.2-1.8-2.2.6-4.1-1.2-2.2-2.5v-1.2c-.4,0-.4-.3,0-.5.4-.9-.1-2.1-1.1-2.1-1.1-.9.7-2.3.8-2.2s-1,1.8-1.2.3c-1,.5-1.5-.2-1.5-2-.5-.1-.4-.3,0-.5-1.3-.3-1.3-.5,0-1,.3-.4.7-.5,1-.5l1.1-1.1c-.4-1.4-.3-2.9,1.4-2.9-.7-.6-.4-.8.5-.5-.4-.6-.2-1,.5-1Z"
          fill="#0250f3"
        />
        <path
          d="M268.7,270.8c.1.2-.3,1,.2,1,.6,0-.3-1.3,1-1s-2,2.9-2.2,3.5c2.6-2,1.2,4,3,2.5s-.9-.9-.2-1l1.2,1c-.3.4-1,0-1,0,0,0,.2.9-.3,1s-1.7-.6-2.7-.5c-.2-.2-.4-.2-.5,0-.1.2.1.8,0,1-1.6-.4-1.4-2.4.5-2.2l-2-.3.5-2c-1.9-.5-.6,2.6-1,3s-1.6-.2-2,0h-.5c.3-1.5,1.8-.3,2-.5.8-1-1.6-1.3-1.5-2l5-2-1-1c.4.1,1.4-.6,1.5-.5Z"
          fill="#0239ea"
        />
        <path
          d="M268.2,268.3c2.9.1,2.7,2.4.2,1-.5.3.4.9.3,1s-.8-.4-1-.5c-.7,1.8-.5.5-1.4,1s.7,1.7-1.1,1.5c-.3-.1-.3-.3,0-.5,0-.2,0-.3,0-.5.2-1,0-1.4,0-1.5.3-.3,1.9-.2,2.5,0,.2-.5.2-1.1.5-1.5Z"
          fill="#0237e4"
        />
        <path d="M267.7,277.3c-.2,0-.5,0-.5,0l.2-.5.2.5Z" fill="#0250f3" />
        <path
          d="M259.7,268.8c.4-2.7,3.5-1.2,3.5,1,.6.4,1.5,1,2,.5,0,.3,0,.9,0,1s-1.2,0-1.5,0c-.6.2-1.1,0-1.5-.5-.9.3-.4,3.8,1.5,1.5-.9,3.3-2,.7-3.5-.5-1,1.3,1.5,2.4,1,3s-1.3-1.3-1.5-1l-.3,1.5c-1.7-2.1-1.1.1-1.5,0l-2.3-1.8c0-.4.7-.3,1-.2.2-1.1,1.9-.6,1.2-.6l-.2-.4c1.6-.3,1.9-2,2-3.5-.3,0-.7,0-1,0-.2-.7.3-1,.5-1.5,1.7-.9,1.9.5.5,1.5Z"
          fill="#0241f1"
        />
        <path
          d="M255.2,268.8c0,.3,0,.6,0,1l.5.5c-.3-.6,0-.8.5-.5,0,0,.8-.1.9,0s-.5,1.1-.4,1.4c-.5-.5-1.6.4-1,1s1.5-.5,1-1c0,0,.9.9,1,1,.4.3,1.8,0,1.5,1.5-2.2-2-1.2,0-1.8,0s-.6-.5-.7-.5c-2.5-.7-1.5-2-1.8-2.5s-1.2-.3-1.3-.8.8-1.9.5-2.7c.9,0,.8,1.3,1,1.5Z"
          fill="#025df8"
        />
        <path
          d="M250.2,267.3c.2.4,1.3,1.3,1.5,2l-2.5,1c-.4-1.6,1.3-.4,1-1.7s-2.6-.9,0-1.3Z"
          fill="#0245f2"
        />
        <path
          d="M257.7,266.8c.2.2.1.3.5.5v.5c-.7.6-1.5.3-2.5-1-.4-.1-1,0-1.5,0,0-.6.5-.5.5-.5.5-.3,1-.7,1.5-1,1.1-1.6,2.3.1,1.5,1.5Z"
          fill="#0247ef"
        />
        <path d="M258.2,267.8c0,2.4-1.9.5-2.5-1,.9.3,1.6.8,2.5,1Z" fill="#0562f6" />
        <path
          d="M255.2,268.8c0,0,.8.8,1,1,0,.3-.2.6-.5.5l-.5-.5c0,0-.8-.1-.5-.7l.5-.3Z"
          fill="#0236eb"
        />
        <path d="M264.2,279.8c-.2-.9.7-1.6,1.5-2,.2.9-.7,1.6-1.5,2Z" fill="#0356f7" />
        <path d="M263.2,276.8c-.7.3-1.3,2.8-2-1,.9,0,.2,1.4,1.5,1h.5Z" fill="#023cee" />
        <path d="M260.7,277.3c-.1,0-.3,0-.5,0l.2-.5.2.5Z" fill="#023cee" />
        <polygon fill="#0249f1" points="265.2 272.3 264.7 272 265.2 271.8 265.2 272.3" />
        <path d="M263.7,271.3c-.7.6-1.2.4-1.5-.5.3-.1,1.4.5,1.5.5Z" fill="#0249f1" />
        <path d="M255.7,270.3c-.7-.2-.4-.4-.5-.5l.5.5Z" fill="#0250f3" />
        <path
          d="M255.7,265.3c.1,0,.4,0,.5,0,.2,1.3-.3,1-1.5,1,.1-.3,0-.8.5-1,.1-.4.3-.4.5,0Z"
          fill="#086af3"
        />
        <path
          d="M261.7,258.8c.3,2.9-.6,1.3-2,3l2.3-1c.9.3-1.5,2.9-1.8,3-.5.1-1.8-.2-2,0-.4.4.5,1.7.5,2l-.5.5c-.2.2-.3.3-.5.5-.7-.7.4-.7-1.5-1.5-.1.4-.3.4-.5,0-1.2-1-.7-2.3,1.6-3.9.4-1.9,1.2-2.9,2.4-3.1.1-1,.8-.9,2,.5Z"
          fill="#0352f4"
        />
        <path d="M258.2,266.3c.1-.1.5-.5.5-.5l-.5.5Z" fill="#0247ef" />
        <path d="M257,264.3c.3.2.3.3,0,.5v-.5Z" fill="#0247ef" />
        <path d="M260.2,255.3s-.4-.1,0-.5v.5Z" fill="#0250f3" />
        <path
          d="M257.2,330.2c.5.1.5.3,0,.5,1,0,.9.7,0,2,.7,1.8.3,2.3-1.4,1.5-.9-1.6.5-3.4.5-4.2s-.8.7-.5-1.3c.2.6,1.3,1,1.5,1.5Z"
          fill="#045fee"
        />
        <path
          d="M267.2,331.7l-1-.5c0,.4-.1,1.3,0,1.5-.5,0-1.4.6-1.5.5-1-1.1,1.4-.7,1-1.7s-1.5-.5-2-.8c0-.2,0-.4.3-.5.9.2,1.3.3,2.2,0s.9-.7,1-.5c0,.7,0,1.3,0,2Z"
          fill="#0242e8"
        />
        <path
          d="M269.2,313.3c.1.4,0,1,0,1.5l1.5-.5-1,4-1-1.5c-1.1-.3-1.3.5-1,1.2.5,1.1,2.3.6,2.5.8s-.7,1.8.5,2.5c-1.7,0-2.3-.5-2,1.5.8-.5,1.6-.7,2.5-1,0,1.7-1.3.3-.5,1.5s0,.8,0,1c-1.9,2.8,1.1.2,1.6.5l.5,1.7c-.9.5-1.8-.8-2.5.5-.4,1,1.3.3,1,2.2-.2.2-.3.2-.5,0-.8.2-1.4.2-2,0l-.5-.6c-1.3.5-1.9-.5-2-2.9,1,1,1,2.5-1.1,2s.3-3.5,1.1-2c-.8,0-.8-.5,0-1.5-.6-1.1-2-2-3.1-1.1-3.6-.9-3.5-3.6-.2-5.2,0-1.5.8-3.6,1.8-2.3,1-.7,1.5-1.3,2.4-2.5.6.1,1.1-.2,1.6-1,.5-.9,1.1.5.5,1Z"
          fill="#0245eb"
        />
        <path d="M268.7,329.2c.9-.2.3,1.6-.5,1-.1.4-.3.4-.5,0-2-1.5-.3-3,1-1Z" fill="#0245eb" />
        <path d="M270.7,329.7v-.5h.5c0,.2-.3.4-.5.5Z" fill="#0240e2" />
        <path d="M267.2,316.8l-.2,1.5c-.5-.5-.9-.8-.7-1.5h1Z" fill="#0259f9" />
        <path d="M268.2,320.7c-1,.1-1.1,0-1-1l1,1Z" fill="#0223dd" />
        <path d="M263.2,317.3c.5.5-.9,2-1.5,1.5s.7-2.3,1.5-1.5Z" fill="#0245eb" />
        <path
          d="M261.2,314.3c1.5-2,2.7.5,1.5,1.5.2.2.4.2.5,0-.5-.4-.1-1.1.5-1h.5l.5.5v.5c-.5,0-1.2-.2-1,.5l1.5,1-1.5.2.5,1.3,1.5-1c.4,3.4-2.3.8-2.5,1-.9,1,2,1.1,1,2s-2.1-1-2.2-1c-1.7,0,.3,3.1,1.2,2.5s0-1,.2-1c.5,0,2.3,1.4,2.8,1l-1.5-2,2-.5c.4,2.1.1,2.8-.5,4.5-.7,1-1.8,1-1.5,2.5-.8,0-.6-1.1-1.2-1.5s-.3,1.4-2,1.3-1-1.5-1.7.2c1.9,0,2.2,2.2,3.5,2l.5-1-.3,1.5,2.8,1c-.2.5-1.1.7-2.5.5.8.4.9.7.5,1-1.2,0-2.3.3-1.8,2.1-.8,2.6-3.5-.1-2.5-1.7,1.3.2,1.4-1.9.3-2.4-1,.3-2,.5-3,.5-.5.5-1,0-1.5-1.5-.4-.2-.4-.3,0-.5.6.5.5,0-.5-1.5-.4-.1-.4-.3,0-.5.3-1.3.7-1.2,1.7-.6l.3-.4c-1.2-1.4,0-3.5,1.5-2.5q.9,1.2,0,0c-.4-.6-1-.1-1.6.4-2.2-2.9-.3-4.3,2.6-5.3.1-1.1.4-1.8,1-2.1,0-.5,0-1,.5-1.5Z"
          fill="#0259f1"
        />
        <path
          d="M260.7,315.8c-.3.8,0,1.7-.4,2.3-1.3,1.6-4.6.5-3,4.2,1.3.6.9-1.1,1.2-1,1.1.5.2,1.4.3,1.5-1.6,0-1.6,1.2-1.5,2.5-2.5,1.7-1.2-2.9-.7-2.6s-.5.7-.8.1c-1.2.9-1.7,0-.5-1-.5-.6-.3-1,.4-.9-.4-2.5.2-3.3,1.6-2.6.8-1.7,1.6-2.7,2.5-3,.2.2.7.3,1,.5Z"
          fill="#0246f0"
        />
        <path
          d="M257.2,325.2c0,0,.9.6.5,1s-1.7,0-2.5,0-.3,0-.5,0c-1,0-1-.8.2-2.2-.9-.7-.3-1.3.8-1.3.2,0,.8-.7,1-.5-.2,1.2-1.1,2.4.5,3Z"
          fill="#0468f5"
        />
        <path
          d="M257.2,330.2c1.1-.2,1.3-2.4,1.7-2.5,1.5-.5,2,1,.3,1.3.2.4.9.6,1,.8s0,.3,0,.5c.2.5-2.5,1.6-3,.5,0-.2,0-.4,0-.5Z"
          fill="#0147ea"
        />
        <path
          d="M262.7,324.2c-.3-1.4,1.1-1,2.2-1.5.8.6,0,1.2-.2,1.5-.3.3-.6.2-1,0h-.5c-.1.3-.3.3-.5,0Z"
          fill="#023ce7"
        />
        <path d="M258.7,322.7c1.9,0,1.2,1.2,1.5,2.5-1.5.2-1.4-1.5-1.5-2.5Z" fill="#0247ea" />
        <path d="M255.7,328.2c-.3-.5-1.8-.5-.5-1.5l1.5,1.8-1-.3Z" fill="#045fee" />
        <path d="M261.2,319.2c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#0245eb" />
        <path d="M264.7,324.2c-.4.5-.2.7-1,0h1Z" fill="#034eed" />
        <path d="M262.7,324.2h.5l-.2.5c-.3,0-.2-.3-.3-.5Z" fill="#034eed" />
        <path d="M262.7,315.8h.5c0,.2,0,.4-.2.5-.2,0-.2-.5-.3-.5Z" fill="#0245eb" />
        <path
          d="M267.2,305.3c.3.1,1.3-.2,1.5,0s-.3.6,0,1.5l.5.5c0,.3,0,.9,0,1-.2.1-1.1-.3-1,.2s.9,0,1,.3c.3.3-.9.9-1,1.2s.8.4,1,.7c-.4,0-1.1,0-1.5,0-.6.5-.9,1-1,1.5.2.2.3.4.5.5.4,0,.7-.2,1-.5,0,0,0-.5.2-.5l.3.5-.5,1.7c-1.3-.1-1.4,2.2-1.5,2.3-.2.2-1.5-.4-2-.5-.4-.1-.4-.3,0-.5l-.5-.5c-.1.4-.3.4-.5,0,0-.2-.2-.5,0-.6.7-1,.4.7-.4.6s-1.5-1.8-.5-2.5c-.2-.3-.3-.3-.5,0,.4.8.4,1.5-.5,1l-.6.2c.1,1.4-.3,2-1.4,1.8-1.1.4-2.3-.1-3.5-1.5-.2.4-.3.4-.5,0l-.7-1.4c-1.6-1-.8-3.2,1-1.9.6-1.1,1.6-2.2,2.7-1.2.4.1.4.3,0,.5,1,1.1,1.3,1.4.5,0-.5-1,1.1-1.4,2-1.5.4-1.4,2.7-.5,3,.5.4-1,1.1-.9,1.5,0h1q.4-2,0,0c-.5.3-.9,0-1-.5-.5,0-1,0-1.5,0-2-.3-4-2.1-1.6-3.4s3.7.2,4.6.4Z"
          fill="#0345f1"
        />
        <path
          d="M269.2,310.8c.7.6,1.5,1.7,1,2.5-.3,0-.7,0-1,0-.1-.4,0-.9-.5-1-.2-.2-.4-.2-.5,0-.3.5-.7.7-1,.5-.5.2-.7,0-.5-.5-.4-.7.3-1.3,1-1.5-.2-.7.3-.7,1.5,0Z"
          fill="#022fe0"
        />
        <path d="M267.7,310.8c0,.7-.3,1.3-1,1.5-.2-.2-1-.5-1-.7,0-.7,1.5-.7,2-.7Z" fill="#0245eb" />
        <path d="M267.2,312.8l1-.5c-.2.2-.5,1-.8,1s-.2-.5-.2-.5Z" fill="#0245eb" />
        <path
          d="M259.2,309.8h2s-1,1-1,1l1.5,1.5c-2-1.9-4.6,1-3-2.5.1-.4.3-.4.5,0Z"
          fill="#025af9"
        />
        <path
          d="M262.7,312.3c.1,2.7.6.9,2,1.5v.5c-.3,0-.8.3-1,.5-.4.4-.3.7-.5,1-.1.3-.3.3-.5,0-.4,0-1.1.2-1-.2,1.8-.5,1.3-1.5-.5-1.2-.4-.1-.4-.3,0-.5l.5-.5c.4-.4.4-.4.5-1,.1-.4.3-.4.5,0Z"
          fill="#0664f9"
        />
        <path
          d="M261.2,308.3c.3,1.5-1.3.7-2,1.5h-.5v-.5c0,0-.4-1.4,1.5-1-2-3.2,0-.6,1,0Z"
          fill="#0335eb"
        />
        <path
          d="M261.7,313.3l-.5.5c0,.2,0,.3,0,.5s.4.5.3.8c0,.5-.8.6-.8.7-.6,1-.8.6-1-.5.7-1,1.8-.3,0-2.5l1.3-.5c.3.3.7.5.7,1Z"
          fill="#0231e8"
        />
        <path d="M266.7,308.8c-.5-1.2-.4-2.9,1-2.5,0,.9-.3,1.8-1,2.5Z" fill="#0231e8" />
        <path
          d="M265.7,308.3c.2.2.2.3,0,.5-.9,0-.5.2-1.5,0v-.5l.5-1c.4-.2.8.8,1,1Z"
          fill="#0231e8"
        />
        <path d="M262.7,312.3h-.5c.1-.7-.3-2,.2-2.5.5,0,.2,1.9.2,2.5Z" fill="#0128de" />
        <path d="M266.7,313.3c.1.1-.4,1.8-.7,2l-.7-2.3c.3,0,1.4.2,1.5.3Z" fill="#0245eb" />
        <path d="M266.7,308.8c-.8.8-.7,0-1,0v-.5c.2.2.9.6,1,.5Z" fill="#0d6cf2" />
        <path d="M264.7,315.3l-.5-.5.5.5Z" fill="#0664f9" />
        <path d="M264.5,311.8c.3.2.3.3,0,.5v-.5Z" fill="#0245eb" />
        <path d="M261.2,313.8c0-.1.5-.4.5-.5-.2.2-.3.3-.5.5Z" fill="#0259f1" />
        <path
          d="M328.7,226.3c1.2,1,2.4,2.3,3.5,3.9l.5-.4c.3-1,.7-1,1,0,2.6.6,1.5,3.6-1.1,3.8-.2,1.3-.5,2.4-.9,3.2,1.3-.4,1.4-.3,1,1,.4.1.4.3,0,.5.9.2,2.2.7,1,2,1.8,1.2,2.1,2.4,1,3.5.6.7.3.9-.5.5-.2-.6-.3-1.1-.5-1.5l-.5-.5c0-.1,0-.4,0-.5l-.5-1-.5-1c0-.1,0-.4,0-.5l-.5-.5c-.2-.2-.3-.3-.5-.5-.8.3-1.2-.4-.5-1-.4-.1-.7-.3-.9-.6-.4-.6-2.3-6.9-2.8-8.4s0-.6.2-1c0-.7,0-1.4.5-2,.1-.4.3-.4.5,0,1,.2,1.2.6.5,1Z"
          fill="#064fe5"
        />
        <path
          d="M350.2,271.3c1,.8.5,1.5-.8,1.2l.8.3c.8.2,1,.9.5,2.2,2.1,1.2,1.4,3.5-1,3.8,2.1,2.7,2.3,4,.5,4-.1-.3-.8-.7-1-1-.9-2.7-2-5.3-3-8,0-.6.1-.9.5-1-.3-1.2-.2-1.7.5-1.5.6-.6,1.1-.8,1.5-.5.5-1.7,1.2-.8,1.5.5Z"
          fill="#043ddf"
        />
        <path
          d="M335.2,243.8c.9.8,1.9,1.4,3,2,1.2,1,1,1.5-.5,1.5-.3.2-.5.6-.5,1,1.1,0,1,.6.5,1.5.9,0,.6.5,0,1,.8-.2,1.1.3,1,1.5.4,0,.4.3,0,.5.6-.2.6.2.2,1.2.8,1,.7,1.6-.2,1.8v-.5l-.5-.5c-1.6-2.8-2.7-7.3-4-10.5.1-.2.3-.4.5-.5.1-.5.3-.4.5,0Z"
          fill="#093cdc"
        />
        <path
          d="M345.7,256.3c2.5-.2,3.3,2.5.5,2-2.4.6-2.9-1.4-1-2,.2-.3.3-.3.5,0Z"
          fill="#0344e6"
        />
        <path d="M346.2,258.3c.4,1.4-.1,1.6-1,.5-.6-.9.1-.9,1-.5Z" fill="#0344e6" />
        <path
          d="M340.7,253.3c0,1.8.6,3.3,2,4.5,1.3-.6,2.1.3,1.5,1.5.7.9.6,1.1-.5,1,.8-1.4,2.2,1.3,2.1,2-.3,1.4-4.4-.5-2.1-2,.3,1.5-.3,1.5-1.5,1-.7.2-1.1-.7-1.2-1.4l-.3.4c-.7-1.3-1.8-3.1-2-4.5s0-2.5,0-3c.1-.4.3-.4.5,0,.5-.5,1.1,0,1.5.5Z"
          fill="#0344e6"
        />
        <path
          d="M345.2,258.8c1.6-.6,3.6,3.5,2.2,4s-3.9-.3-1.9-1.3c-.3-.9-.7-1.6-1.3-2.3-.3-1.3,0-1.4,1-.5Z"
          fill="#0344e6"
        />
        <path
          d="M342.2,261.3c.4.1.4.3,0,.5l1,2c1.2.4,1.5,1.3,1,2.5,1.8,1.7,2.7,3.9,2.5,6.5,0,.4,0,.9-.5,1-1.3-3.3-2.7-6.6-4-10l-.5-1c0-.1,0-.4,0-.5l-.5-.5c0-.1,0-.3,0-.5l-.5-.5c0-.2,0-.3,0-.5,0-.3,0-.7,0-1h.5c0,.9.7,1.4,1,2Z"
          fill="#0935cc"
        />
        <path d="M342.2,263.8c0-.3-.3-.6-.5-1l.5,1Z" fill="#0344e6" />
        <path d="M333.2,241.8c-.4-.2-.4-.7-.5-1,.1.3.3.6.5,1Z" fill="#185cdd" />
        <path d="M341.7,262.3c0,0-.4-.2-.5-.5l.5.5Z" fill="#0344e6" />
        <path d="M338.7,255.3c-.2-.1-.4-.3-.5-.5l.5.5Z" fill="#0344e6" />
        <path d="M333.7,242.8l-.5-.5s.4.2.5.5Z" fill="#185cdd" />
        <path
          d="M352.7,277.8c.1-.4.3-.4.5,0,2.9-1.2.9,2.1,0,3.5,0,.5,0,2.4,0,2.5s-2-.8-2,1.5c-.4-.9-.6-1.6-1-2.5,1-1.2-.4-2.8-.5-4l1.7-.7c-.1-1.2.5-1.2,1.3-.3Z"
          fill="#0240e6"
        />
        <path
          d="M354.7,281.3l.9-.9c-.3-1.7,2.9,0,.6.9l-1,1c0,.4,0,.6-.5.5-.3,0-.7,0-1,0,0-.1,0-.7,0-1,.3-.5.5-.9,1-.5Z"
          fill="#034df2"
        />
        <path d="M354.2,283.3c.2.1,1-.3,1,.2-.6.9-1.1,1.2-1.5,2.3l-1.5.3,2-2.8Z" fill="#0349ef" />
        <path d="M354.2,286.3c.5.5.1.8-.5,1,0,0,0,.6-.5.5-.3-.8.4-1.2.5-1.5h.5Z" fill="#0349ef" />
        <path
          d="M369.1,291.8v.5s-1.5,0-1.5,0c0,.6.8.7,1,1,.4.5.6,1.1,1,1.5.4.9.7,1.7,1,2.5l-.7,1c-.8-.7-1.4-.2-2,.5.4-2-.5-.7-1.7-.5-.4-.1-.4-.3,0-.5,1-1.3-1.7-1.3-1-3l2-.5c.3.3.6,1.7,1.5,1s-5.3-4.5.5-3.5Z"
          fill="#033def"
        />
        <path d="M367.1,294.3h-3s.5,2.5.5,2.5c-3.2-2.3-.9-5.2,2.5-2.5Z" fill="#0232ee" />
        <path
          d="M361.6,295.8c-.9-1.1-2.9.6-3,.5-.9-.8,1.4-1.4,1.7-2s-.2-1-.2-1,.8-.4,1-.5c.1,1.4,1.2,1.9.5,3Z"
          fill="#0135ec"
        />
        <path
          d="M369.6,294.8c1,1.1,2.1,2.3,3.5,3-.1,0-.3,0-.5,0-.3,0-.7,0-1,0-.5.8-.7.6-.5-.5-.2,0-.4,0-.5,0s-2-1.1-2-1.2.7-1.1,1-1.3Z"
          fill="#0548f5"
        />
        <path
          d="M371.6,297.8c1.3,2.1-.4,1.6-1.5,2,0-.2,0-.4,0-.5.1-.4,1-1.3,1-2,.2,0,.4.5.5.5Z"
          fill="#033def"
        />
        <path d="M367.6,299.8v.5c-1.5,1.2-1.6-.8,0-.5Z" fill="#024ef2" />
        <path d="M366.1,297.8v.5c-1.4.3-1.4-.7,0-.5Z" fill="#0234eb" />
        <path
          d="M354.7,285.8c.3-.2,2.2,0,2.3,0s1.8,2.4,1.8,2.5-.3.3-.7.5c0,.1-1.5.8-1,2,2.1-1.3,1.6.5,3.2.5l-.7,1.5c-.2-.3-.6-1.1-.7-1-.4.5-.8,1-1.3,1.5l-2-.7c1.3,0,1.3-2.4,1-3.5s-1-.1-1.4-.4-.4-1.2-.6-1.4q.2-.2,0,0c-.1,0-.7,0-1,0,.2-.3.4-.7.5-1s.4-.2.5-.5Z"
          fill="#023de8"
        />
        <path
          d="M374.6,299.3c0,.2.3.5.5.5-1,0-1.7,3.8-2.3,2s.6-2.2.9-2.4.8,0,.9,0Z"
          fill="#022ae6"
        />
        <path
          d="M304.7,170.8c.9-.5,2,.8,1.7,1.9.7,0,1.2.2,1.5.7.4,2.1,1.2,4.7,3.3,4.9,1.3-.6,1.8.2,1.6,2.4l.4.6c1.6,0,1.7,1.5,0,1.5-.3.2-.6.2-1,0v.5c-.6,1.6-.2,2.4,1.1,2.3.5.8.3,1.3-.6,1.7.4.1.4.3,0,.5l-.5.5c1.5-.1,2.4,2.7,1.5,3.5.4.2.4.3,0,.5l-.5,1c.4.2.4.3,0,.5-.2.2-.3.2-.5,0-.4-.1-.4-.3,0-.5l-1.5-3.5c-.9-1.8-1.6-3.7-2.5-5.5.5-.5-1.5-5.1-2.2-6s-.3-.6-.3-1c-1.2-.3-2.6-3.4-2-4.5-.1-1,0-1.7.5-2Z"
          fill="#046beb"
        />
        <path
          d="M306.2,177.3c.3.3,1.4.2,1.5.8s-.2,1.5.1,2.3,3.2,5.5.9,3.9c-.9-1.8-1.6-3.7-2.5-5.5-.4-.8-.4-1.3,0-1.5Z"
          fill="#1161d6"
        />
        <path d="M312.7,193.3l-1.5-2.5c0-.3,0-.7,0-1,.8,1.5,1.1.7,1.5,3.5Z" fill="#1368e4" />
        <path
          d="M278.2,109.4c1.4,0,2,0,1.5,1.6h.5c.5-1.2,1.5.7.5.9.1.6.5.9,1,1,.4.1.4.3,0,.5l-.5.5c.4.6.2.8-.5.5l.5.5c.1-.4.3-.4.5,0,2.8-1.6,1.1,2.1-.5,2-.2-.5-.3-.5-.5,0-1.4-1.8-2.6-4.7-3-7-.5-.2-.3-1.1,0-1.5,1-.1,1.4.4.5,1Z"
          fill="#0a72dd"
        />
        <path
          d="M281.2,118.4c-.6-2,.3-2,2.5,0,.4.6,0,1.3-1,2,.4.1.4.3,0,.5-.1.4-.3.4-.5,0-.3-.8-.6-1.2-1-2.5Z"
          fill="#1064d2"
        />
        <path
          d="M283.2,121.9c1.5-.2,1.9.9,1,2l-.5.5c-.5-1.2-1-2.1-1.5-3.5h.5c.9-.4,1.2.3.5,1Z"
          fill="#1b6ccf"
        />
        <path d="M281.2,116.9c0,.3-.2.5-.5.5,0-.2,0-.3,0-.5-.2-2.1.7-2.1.5,0Z" fill="#0350c5" />
        <path
          d="M277.7,108.4c0,.5,0,1,0,1.5h-.5v-1c-.1-.3-.2-.7,0-1,.5-.2.7,0,.5.5Z"
          fill="#186ad5"
        />
        <path
          d="M281.2,108.9c.4.1.4.3,0,.5.2.2.2.6,0,1,.4.1.4.3,0,.5l.5.5c-1-1.2,2.1-.8,2.7-.5s2.3,5-.2,5c-.3.3-.6.7-1,1,1.4-.2,1.4.8.5,1.5-2,1.2-1.1-.1-2.5-1v1c0-.2-.4-.5-.5-1,.2-.2.4-.3.5-.5.4-.7.5-1.6,1.5-1.5.2-.7-.3-.5-1-.5.1-.7.6-1.8,1-2.5q0-.9,0,0c0,.9-.4,1.3-1,.5-.5.2-1,.2-1.5.5-.3-.8.4-1.2.5-1.5q.2.2,0,0c0-.4,0-1-.5-1-.5-.5-.8-1.6,0-2-1-.2-.8-.5,0-1,1.3-.7,1.7-.2,1,1Z"
          fill="#0581ee"
        />
        <path
          d="M322.7,217.3c-1.6-2.9,2.1-4.2,1.5-1,1.3-.2,1.5,0,.5,1v.5c.7-.7,1-.4.5.5.9.7,1.1,1.7.5,3,1.4-.2,2.2,1.7,1,2.5,1.3-.5,1.9.4,1,1.5.5,1.2.7,1.4-.5,2-.6-1.5-2.1-4-3-5.5-.5-1.5-1.3-2.8-1.5-3.5s0-.7,0-1Z"
          fill="#0b4ede"
        />
        <path
          d="M231.2,85.4c1.5-.9,1.9-.6,1.5,1-.7,1.9-1.3,4-2,6s-1.4,2.8-2,4.5c-.2.2-.3.3-.5.5l-1,2c0,.1,0,.4,0,.5-.1.4-.3.4-.5,0-1.2.1-1-1.2,0-1.5-.3-.1-.3-.3,0-.5-.9-1.1-.4-2.1,1-2,0-1.4.7-3.7,2-4-1.2-1.4-1.6-2-1-4-1.6-.8,1.4-3.7,2.5-2.5Z"
          fill="#1e5ec4"
        />
        <path
          d="M230.2,81.9c2.6-.8,3.5-.3,3,1.5-.3.6-2,.3,0,1.5-.1.4-.3.9-.5,1.5-.1-2.3-.5,0-.7,0l-.7-1c-1.8.2-2.3-.3-1.5-1.5-1.4-.6-1.8-.9-.5-2,.2-.3.3-.3.5,0,.2-.4.3-.4.5,0Z"
          fill="#2d61d2"
        />
        <path
          d="M251.7,419.2c-.1.4-.3.4-.5,0,0-.5.2-.9-.5-1h-.5c0-1.2.3-1.1,1.5-1.5.2,1,.3,1.5,0,2.5Z"
          fill="#023694"
        />
        <path
          d="M250.2,406.7c1.9-1.9,5.8,2.5,1.9,2.6v.4c1,1,1.5,1.2,1.6.5.9-1.8,2.6,0,3.4,1.2,1,.2,1.7.4,2.1.8.7.5,1,.8,0,1,0,.1-.9.4-1,.8.3.6.9-.6,1,0,.2,1.2.3,3.8-.8,4.7-.9-.9.1-2.5.2-3.3s-2.2-.9-.9-2.7c-2.1,0-1.6,1.6-.5,2.7l-1.5.3c.7,1.3,1.9.4,1,2.5-.9.2-.3-.8-.5-1-1-.8-1,1-1.3,1-2.5,0-1.1-1.9-1.2-2-.6.5-1.5.3-2,.5-.2-.9.1-2.1-1.5-2,1.8,2.2.6,1-.2,2s-1.1,2.1-1.3,3,.7,2.4-1,2c.8-2-.1-1.8-.5-2.5s.1-.8,0-1-.6,0-.8-.2-.1-.8-.2-.8c-.1,0-.7,0-1,0,0,1.3,0,2.6-1.5,2.5,0-.1,0-.4,0-.5,0-.1.9-.3.9-.7l-1.9-4.8h.5c.6-1.7.8-2.6-1.2-3.2-2.3-4.1,5.4-5.1,3.8-.9.1,1.4.2,2.7-.1,4.1-.1.6-.6.3-.6.3,1.9.5,3.2,2.9,1.1,3.2,1-1.7,1.8-.1,1,1,.3-1.4-.3-2.7-1.4-4l.4-.5c-.5-.1-.6-4.7-.5-4.9,1.5-.4,3-1.1,4.5-2.1Z"
          fill="#023694"
        />
        <path
          d="M265.7,405.7l1.5,1-2,.5c3-.5-.2,1.8,2,1.5,0,.2,0,.3,0,.5.5.6.8,1.2,1,2,.7-.6,1-.4.5.5,0,.1-.7,1,0,1-.9.6-1.9.4-2,.5q-.2-.2,0,0c0,0,.3,1.7.5,2-3.2.7-2,2.1-2.5,2.5-1.7,1.2.1-2.1-1.2-2.5-1.6-.3,0,1.1-.2,1.5-1.3,1.6-4.8-.5-3-3,.2-.4.3-.4.5,0,.6.2,1.1,0,1.5-.5.6-.5,1-.2,1,.8-.9-1.2-.2-2.3,2-3.3q.1-.8,0,0c-1.3,1.4-2.5,1.9-3.5,1.5v1c-.1.4-.3.4-.5,0-.7.4-1.8-.2-2-1-.9-.2-.8-.6,0-1-1.1,2.2-7-3.2-3.5-3.5.2-.8,4,.7,4.1.9.5.9.8,2.9-.6,2.6.9-.6,1.4-2,0-2-1.1-2.3.8-4.5,2.4-2.1.8-.6,1.2-.6,2,.1.2,0,.9.7,1.5.5-.9-1,0-1.8,0-2,.1-.4.3-.4.5,0Z"
          fill="#023597"
        />
        <path
          d="M253.2,406.2c.6.3,1.3.5,2,.5.7-.5.9-.2.5.5.4.1.4.3,0,.5,0,0-.7.5,0,1.6s1.9,2.2,2,2.3c.2.1,1-.4,1.4-.4,0,.3,0,.7,0,1,.9.3,1.2.6,2,1,.7.7.4,1-.5.5-.1,0-.4,0-.5,0-.3-.2-.7-.3-1-.5,0-.2,0-.7,0-1-.7-.2-2-.2-2.7-.5s.1-.7,0-.9-2.3-.5-2.8-.6c-.4.7-1.2,0-1.5-.5-.2-.2-1.2.4-1-.5,3.1-1.3,1.9-2.2-1-2.5-.3,0-.5-.2-.6-.3s.7-2.2.8-2.2c.6-.5,1.1,0,1,.7.8.2,1.7.4,1.8,1.3Z"
          fill="#0343a4"
        />
        <path d="M273.7,423.7c1.9.2.9.2,0,.5v-.5Z" fill="#02348c" />
        <path
          d="M94.8,140.3c.7,1.9.5,1.3,2.2,1.5s-1.9,2.8-2,3c-.5.8,1.7,2.2-1.7,1-.9,2.5-.3,1.7,1.1,2.5s-.9,1-1.4,1.5-1.2,2.9-1.3,3c.4.2.4.3,0,.5-.8,1.6-1.5,3.6-1.9,5.9,0-.7-.5-.8-1.6-.4-.5.9-.8,1.5-.8,2,1.7-.6,3.4-.5,2.3,1.5,0,1.2-1.2,2.5-2.5,2,1.3,1.3-.6,4.7-2.6,4.3-.6.3-.5,2.8,0,3.5l-1.5.3c-1.4-1-2-.3-1.6,2.3-1.5.7-2,1.9-1.3,3.5-.9-.8.4-3.6,1-3.7,2.1-.5,2.7,7.5-1,3.7.5.9,1.2,1.1,2.1.6,1,2.9-1.6,3-4.3,2.8,2.3-.8,2.4-.2,2.1,2,4-2.5,4.3,1.4,1.5,3.5-1,.6-1.7.1-2.2-1.5-.5,1.1-1.3,1.7-2.3,1.8.7,2,.6,4.4-2.1,3.9.7,2.2.6,3.5-.5,3.9h-1.5c-.5-.8.2-3.2,0-3.5-.9-1.1-1,1.9-2,1-1.6-1.5.9-2.6,1-2.8.3-1.2-.1-2.7.5-4.1-.4-.4,0-.9.5-1,.7-.5,1.8,2.6,3,0-1.3,0-2.2-.5-2.4-1.8s1.7-1.9-1.6-2.7l2-3c.3-.2,2.5,2,3.5,1.5-.3-2.3-.6-5.3.3-7.5s2.6-1.6-.8-2c-.1-.4.5-.4.5-.5,1.8-1.7,2.5-.8,2-4l.5,2.5c2.6-.2.6-1.8.5-2.8s.6-.2.9-.6,0-1,0-1.1c.2-.2,1.4.6,1.5.5s-.1-.8,0-1.1c1-1.5,1.3-3.6,3-4.6s1,.2,1,.2c.1-.2-.9-2.8-.4-4.2s1.1-.7,1.5-1.2c.5-.8,0-1.9.2-2.2.4-.5,1.7-.4,2-.9s-.2-2.9.2-3.5c2.6-1.7,1.8-3.3,4-5.5Z"
          fill="#0105ba"
        />
        <path d="M92.3,150.8c-.3.3-1.5-.4-1.5-.7,0-1.4,2.2,0,1.5.7Z" fill="#0108bf" />
        <path
          d="M87.3,164.3c.2.7,1.9,1.4,2,1.5.2.3-1.4,1.3-1,2s2.1,1.3,2.5,2c.5,1.5-2,3.9-3.5,3l-.5.5c-.2.3-.3.3-.5,0q-.8-.6,0,0c.4.1.4.3,0,.5-.4.4-.3,1.8-2,1.8-.6,1.5,3.6-.6,2,1.2s-2.4,0-2.5,0c-.1.1.3,1.1.2,1.6-.2.9-1,.8-1.2,1.3-.4,1,0,2.5,0,2.6-.3.2-1.2,0-1.5,0q-.2-.2,0,0c0,0-.1,1.4-1,1.5-.5-.2-1.1-.1-1.5-.8s1.9,0,.5-1c-2.9-.2-.9-.5-.6-.8s-.6-1.4-.4-1.9l1,2c1,0,0-2.4,1.5-1.5s-.2,1.6,1.5,1c.3-1.5-1-.7-1.8-1.5s-.1-.8-.2-1c.2.5,1.8.7,1.9-.2s-.8-1.9-.4-2.8c-1.1.3-1.9,2-1.5,3-1.7-2.8,0-2.2.4-3.9s-1.3-2,.6-2.4l-1-1.2c1.7-.5,2.5.7,4,1-.4-1.5-1.1-1.8-2.5-2.2,3.3-1.3,1.1-1,1.6-2.9s2.7-1.9,1.9-.4-1.8-.2-.5,1.2,1.9-2.3,2.5-3.2Z"
          fill="#0109c2"
        />
        <path
          d="M160.8,87.9c-1.2.8-2.4,1.4-3.5,2.3.4.7,1.5,0,2-.3v.5c.7.7.4,1-.5.5l-7.8,4.1c-1.9,1.3-5.1,1.4-2.2-.6.8-.5,2.4-1.9,3.5-2.5,2.7-1.5,5.6-2.9,8.5-4Z"
          fill="#7f94ea"
        />
        <path
          d="M158.8,90.9v.8c-5,2.7-10.3,5.6-15.5,7.7l-.5.5c-.2.3-.3.3-.5,0-2.4-.1-.4-1,.5-2,.8-.5,2-1.1,2.5-2,.9-.5,2.5-1,3.5-1.5-.8,1-.6,1.3.6.9,2.9-.9,6-4.2,9.3-4.4Z"
          fill="#778bea"
        />
        <path
          d="M155.3,96.4c.4,1.2-.2,2.2-1.5,2,.1.5,0,.6-.5.5-.6.2-1.1.2-1.5,0,.4.8-1.7,2.4-2.4,2.8-1.8,1.1-4.4,2.5-7.1,2.1-.5.6-1,1.1-1.5,1.5-.8.7-1.6,1.1-2.5,1-3.5,1.8-7.1,3.6-10.7,5.4-.3,1.1-1.2.9-2.3.6v-.5c.3-.6,1-1.1,2-1.5.2,0,.4,0,.5,0l.5-.5c2.1-1.5,4.8-3.2,7-4.5,1.8-1.8,5.1-3.9,7.5-4,3.7-1.9,7.6-3.9,11.6-5.3s.6,0,.9.3Z"
          fill="#345de0"
        />
        <path
          d="M200.2,79.4v1.2c-1.2,1.9-11.2,3.7-13.5,3.3-.2.6-.9,1.1-2,1.5.2,1.1-.2,1.3-1,.5-.2-.8-.9-.5-2.3.6-6.1.5-11.8,2-17.1,4.4.4,1-.2,1.2-1,.5-6.6,3.7-13.5,7-20.5,10-2.4,1.1-5.1,2.6-7.5,4v-1c.8-.5,1.6-1,2.5-1.5l1-.5c.1,0,.4,0,.5,0l1-1,.5-.5c.1,0,.4,0,.5,0,4.9-2.8,10-5.3,15.1-7.8,7.9-3.9,14.5-7,23.2-9.3s.8,0,1.2,0c6.4-1.8,13.2-3.6,19.5-4.5Z"
          fill="#5374e5"
        />
        <path
          d="M125.3,111.9c-.3.1-1,.8-1,.2-.1-.7.5-1,1-1.2s1.4-.3,2-.5c-.4.9-1.2,1.1-2,1.5Z"
          fill="#4666ea"
        />
        <path d="M127.8,110.4c.2-.2.3-.4.5-.5-.1.2-.3.4-.5.5Z" fill="#4666ea" />
        <path
          d="M201.7,77.4c1,0,1.3.5.8,1.4-7.3,1.4-14.6,3-21.8,5.1-15.1,4.2-25.4,10.6-39.5,17,.3-.3.6-.8,1-1s.4,0,.5,0l.5-.5c3.8-2.3,13-6.2,15.5-8.5s.4-.3.5-.5c2.6-.4,4.7-2.1,7-3,4.4-1.7,9.4-2.7,14-4.2s3.5-2.1,5.5-2.6,4.8-.2,7.2-.7.4-.8.7-.9c2.8-1,5.3-.8,8.1-1.5Z"
          fill="#637ce5"
        />
        <path d="M138.8,102.4c-.4.2-.7.4-1,.5l1-.5Z" fill="#637ce5" />
        <path d="M139.3,102.4c.2-.5.6-.7,1-1-.4.5-.4.6-1,1Z" fill="#5471ec" />
        <path d="M140.3,101.4c.2-.1.3-.4.5-.5-.1.2-.4.3-.5.5Z" fill="#637ce5" />
        <path
          d="M120.8,115.9c1.9-1.3,3.8-2.4,5.9-3.5.2.8.6,1.4,1.1,2,.1-.4.3-.4.5,0,1.1-.9,1.6.5.5,1.4-2.3.3-4.2,1-5.9,2.3l-1.1-.2c0,0-.3,0-.5,0-.5,0-2.6.4-3,.5l2.5-2.5Z"
          fill="#1545dc"
        />
        <path
          d="M138.3,106.4c-.2,1.5-1.7,2.6-4.4,3.3l-1.3,1.4c-1.3-.9-4.5,1.8-4.8,3.3-1.2.5-1-1.9-2-1s.2,2-2,1c.4,2.7-1.3.8-3,1.5,0-.2,0-.4,0-.5,1.4-1.1,2.9-2.1,4.5-3,2.9-1.6,6-2.8,9-4.3s1.7-2.4,4-1.7Z"
          fill="#1f4ddd"
        />
        <path
          d="M100.3,151.8c1.2.8,1,2.2,1.8,2.5s3.1-.4,3.2-.5v.8c-1.5,1.6-2.5,3-2.8,5.1-.7.8-4.1-.2-3.2-1.8-.1,0-.4-2.6-1.3-3-.6.7.4,2.8-1.2,1.7-.5-1.9,1.9-3.1,2-3.2s-1.4-1.5-.3-3,.8,1.4,1.3,1.8.5-.3.5-.3Z"
          fill="#0115d3"
        />
        <path
          d="M117.8,143.8c-.2.4-.3.4-.5,0-1.1-.6-1.1-.3,0,1,4.8,1.1-1.1,7.5-1,1-.5,0-1,0-1.5,0l.5-1.5c-.8.2-1.8.3-2.5.5v-.5c-.2-1.9.2-2.9,1.4-2.9,1.6-1.5,5.6.6,3.6,2.4Z"
          fill="#022de3"
        />
        <path
          d="M117.3,139.8c1.9.5,3.5,2.7,2.5,4.5.4,0,.6,0,.5.5,2.1,1-1.6,4.9-1.4,1.1-.8-.8-1.2-1.4-1.1-2.1.6-2.6-3.6-2.7-4.4-1.4s.8,1.6-.6,1.9c0-.4-.5-.8-.5-1,0-.8,0-1.7,0-2.5,2.3,1.5,2.3-1,2.7-1s.5.8,1,.8.9-.7,1.2-.8Z"
          fill="#0236e5"
        />
        <path
          d="M115.8,136.8c.4-1.2,1.2-1.4,2-.2.3.8-2,.8-.5,2.7-.8-.1-1.9.2-2.7,0s-.2-.8-.3-1c2.3.3,1.2-.5,1.5-1.5Z"
          fill="#0236e5"
        />
        <path
          d="M111.3,133.3c2.5-.5,4,.7,4.5,3.5,1.8.6-.2,3.3-1.5,1.5-.4,0-.7-.2-1-.5l-.5,1c1,0,1,.4,0,1,0,1.3-1.6,2.7-2,1-.4-.2-.4,0,0,1,1.5,1-.5,2.1-1,.5-.3,0-.3.1,0,.5,1.3,0,1.5,0,.6.9h.4c.3-.3.7-.5,1-.4.1-.4.3-.4.5,0,.7-.7,1.1.4.5,1,.4.1.4.3,0,.5-.1,2.9-2.2-.5,0,.6s.3,3.9-2,1.9c.2,1.9.2,2.6-1.9,3-1.1-1.4-1.2-1.1-.5,1,.3.1.3.3,0,.5l-.2.7c-1.1-.5-2,0-2.8,1.3-2.6,1.8-5.6,1.6-5-2-.5-.3-.5-.7,0-1,1.3-.9,2.2-2.1,2.5-3.5-.2-1.4.2-1.8,1.5-1,.1-.1.6,0,1-.5.2-.2.2-.4,0-.5,0-.1-.6-.7-.4-1.2.2-.7,1.4-.9,1.9-1.6.7-1-.3-2.4,1-2.7l.5,2.5c1.1-.7,1.8-1.7,1.5-3-.9-.2,0,1.5-1.2,1s-.7-1.7-.8-2c.1-.4.3-.4.5,0,1.7-.4.4-2.3.6-2.4.5-.8,1.7.6.9-2.1.5,0,.7-.2,1-.5s.4,0,.5,0Z"
          fill="#0121d9"
        />
        <path d="M105.3,145.8s0-.2,0-.5l.5.2-.5.2Z" fill="#0115ce" />
        <path
          d="M100.3,150.8c0-2.4.5-1,1.5-1.8s.5-1.3,1-1.7c.2,1.8-.6,3.2-2.5,3.5Z"
          fill="#0115d3"
        />
        <path d="M110.8,140.8c.2.7.2.4,0,1-.8-.3-.5-1.3-.5-2h.5c0,.3,0,.7,0,1Z" fill="#0236e5" />
        <path d="M111.8,143.3l-1,.5c.4-.5.6-1.5,1-.5Z" fill="#0236e5" />
        <path d="M109.8,142.3s0,.4,0,.5c-.6,0-.8-.9-.2-1l.2.5Z" fill="#0236e5" />
        <path d="M112.8,138.8l.5-1c0,.1-.5.9-.5,1Z" fill="#0236e5" />
        <path d="M101.6,151.3c.3.2.3.3,0,.5v-.5Z" fill="#0115d3" />
        <path
          d="M129.8,113.9c.8-.6,1.2-.2,1.6.5,1.7-1.1,4.2,0,2.9,1.5.1-1,.6-1,1,0,1.3,0,1.3.6,0,1-1.1.9-1.8-.1-1-1,0,2.8-.7,3.6-2,2.5-1.3,0-2.7,1.9-3.3,2.9.4.9-.9,1.5-1.7,1-3.4.7-.7-1.5-2.8-2.5l-1.2,1c.4-.5-1.3-2.9-1.5-3,1.6-2,4.5-2.6,7-3,.1-.4-.5-.4-.5-.5-1.4-1.9,1.9-3.1,1.5-.5Z"
          fill="#033ddd"
        />
        <path
          d="M134.3,115.9c.2.6-.2,1.2,1,1,1.8,1.5,1.9,3.3-.5,2.5.4.8.9,1.4,1.5,2,.5.1.4.3,0,.5-.2,1.2-2,1.3-3.1,1.2-.5,1.1-1.4,1.6-2.7,1.6.2,1.2-1,2-3.7,2.2-.3.6-.6.5-1,0-.1,1-2,0-2.5-.5,0-.3-.7-1.2-.5-1.5s.8.1,1,0c1,1.5,1.9.3,1.5-1.5.7-.4,1.3-.5,2-1,2-1.4.8-1.8,1.2-2.5s3-2.2,3.5-3.5c.4,2.7,2.4,2,1.2-.5.3,0,.7,0,1,0Z"
          fill="#0244e2"
        />
        <path d="M125.3,123.4c-1.5.8-.9,1.1-1.5,1.5-1-1.6,1.1-3.4,1.5-1.5Z" fill="#0244e2" />
        <path d="M123.3,128.4c0,.1-1.3-.7-1.5-1,.3,0,.7,0,1,0l1-.3-.5,1.3Z" fill="#0249e7" />
        <path
          d="M131.3,126.4c1,.4,1.1,1.5.5,3.5l.5,1c1.4.3.9,1.2-1.3,2.8l-.2,1.2c1.9,0,.9,1.8-1,1.3.1.7-.3,1-1,1.2.4.1.4.3,0,.5-.7,1.1-1.3.6-1.5-.5l.2-1.3c-1.4-.2-2.2-1-2.2-2.2l-.2-.4c2.1-1.1,1.1-1.9-2.8-2.6.6.9.6,1.6,0,2-.2,0-.3,0-.5,0-2,.5-3.4-1.2-1-2,.9,0,1.3-.5,1-1.7s-1.2,0-1-.8c1-.2,1.3,1,2.2,1s.1-.8.3-1c1.8-2.2,1.4.4,2,0l.5-1c1.2.2,2.1,0,2.5-.5.5-.5,2.8-1.7,3-.5Z"
          fill="#0249e7"
        />
        <path d="M125.3,123.4c3,1.6-1.4,4.4-1.5,1.5,0-1,.5-2.2,1.5-1.5Z" fill="#0232d7" />
        <path
          d="M121.8,117.9c.8-.6,1.4-.3,2,1.1,1.7,0,2.7.9,2.7,2.6l.9.9c0,1.5-.9,2.1-2,1-1.1-.3-1.2,0-1.5,1.5,0,.6-.2,1.1-.5,1.5.8.2.7.6-.5,1-.2.4-.5.4-1,0-1.6.5-2.6.8-4.3.2l-.4,1c1.6,2.8-2.4,2-1.3,2.1l-.9.2c-.2,0-.3,0-.5,0-.4-.1-.4-.3,0-.5.4-1.3-1-.6-1-1.5,2.8,0,1.4-1.4,1-3.3-2.5.4-.6-.2-1.5-1.2s-1.1-.3-1-1c.9-.1,2.4-.3,3-.8s-.2-1.5,0-1.7,1.9,0,2-1c.3-1.1,2.4-1.3,3.1-.3.2-.9.7-1.5,1.4-1.7.1-.5.3-.4.5,0Z"
          fill="#0232d7"
        />
        <path
          d="M121.3,117.9c.5.6-.7,2.8-1,3-1,.6-.9-.8-1.7-1.1s-1.3,0-1.8,0-.3,0-.5,0c.4-1.1,1-1.2,2-1.5,1.6-1.3,2.6-1.4,3-.5Z"
          fill="#0b3edd"
        />
        <path d="M119,125.4c.3.2.3.3,0,.5v-.5Z" fill="#0238e1" />
        <path
          d="M93.3,168.3c0-.4-.3-1.5-.4-1.7-.5-.7-1.7.2-1.6-.8,3.1-.4,2-2.1,2.2-2.5,1-1.8,1.3.3,1.3.4.2.2.8-.4,1.1-.4.7,0-.6,1.2,1.3.5-.5-2.3,2.6-.8,2.5.5.3.4,0,.6-.5.5-1.4.2-1.4,1.1-.2,2.9,0,1.8,0,3.7-.3,5.6l.7.3c2.5-2.1,4,1.5.8,2.7-.7,1.7-3.9,0-3.3-1.5l-1.7-1.5c-.9-1.2-2.1-.8-3.4.2-3.7.4-1.5-3.7,1.4-3.2,0-.2,0-.7,0-1-.5-.4-.7-.8,0-1Z"
          fill="#0118d6"
        />
        <path
          d="M106.8,154.8c-.2.2-.7.1-1,.5-.5.4-.7.7-.5,1,.3,0,.7,0,1,0,2.3.2-.4,4.6-1.6,5s-1.6-1.5-.9-2c.6-1.1.4-1.1-.5,0,1.3,1.5,1.3,4.4-1,2.5-.4.7-1.1.9-2.1.4-1.5-2.4-1.5-2,.1,1.1,1,.6.6,1.3-.5,1-.9-1.2-1.4-.9-2.5-.5-.2-.4-.6-1-.5-1.5l-.8-.8c-1.7-.6-2.1-1.4-1.2-2.2.9-.2,2.3.2,3.2,0s-.3-2.1,1.3-1.5c0,0,.7-.7,1-.3l-.5,1.3h2.5s0-2,0-2c-.6-.3-.6,2.1-1.5,1s0-1.6.2-2c.6-1,1.7.2,2.2,0s.8-1.3,2.1-1.9,1,.5,1.2-1.5c1.1,1.4,1.7,1.5.3,2.5Z"
          fill="#021fdb"
        />
        <path
          d="M90.8,169.8c1.4-1.2.6,1,2.5.5-.1.3-2.5,1.2-2.5,2.5,1.3.7,1.6-1,1.8-1,.3,0,.9.6,1.1.4s-.4-1.2.8-.9.3,1.5,1.7,1c.2.8-1,.4-1,1,1.3-.5,1.9.4,1,1.5.3,1-.2,1-1.5,0-1-.3-2.2-.3-3.5,0-.3-.2-2.6-1.2-3-1.3s-1.9.2-2,.3v-.5c.2,0,.4,0,.5,0l.5-.5c.8-.5,2.7-2.2,3.5-3Z"
          fill="#0112ce"
        />
        <path
          d="M94.8,159.3c-.5,2.1,2.4.4,2.5.5.5,1-.4,2.1-.5,2.5-1.5-.7-1.9-1.4-4-1,.3-.6,1.4-1.9,2-2Z"
          fill="#0115d1"
        />
        <path
          d="M93.3,168.3c0,.3,0,.7,0,1-.3-.1-.7-.4-1-.5-.4-.1-.4-.3,0-.5.3,0,.7,0,1,0Z"
          fill="#0112ce"
        />
        <path d="M92.3,168.3v.5c-.4,0-1,.2-1-.2,0-.4.7-.2,1-.2Z" fill="#0118d6" />
        <path
          d="M88.3,158.8c.6-.2,1.1-.8,2-.5l-1.5-.5c1.1-1.2,1.2-2.7,1-4.3s-3.2-1.4,1.5-2.2l-.7,2h1.3c.2,1.8,1.1,3.2,2.5,1.5.2,1.7-1.7,1.7-1,4l-1.5-.5v2s-1.5-.5-1.5-.5l.5,4c-1.5.3-.9-.5-1-1.5s0-.7,0-1c-1.2.2-2.7,1.1-3.7,0-.8-.9.7-.2.8-.8s-1.1-.2-1.5-.3c-.4-1.3,1.8-1.1,3-1.5h0Z"
          fill="#0108bf"
        />
        <path d="M88.3,158.8h1.5c.2,1.1-1.9.3-1.5,0Z" fill="#010cc9" />
        <path d="M89.8,159.8c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#0105ba" />
        <path d="M184.8,382.2h-.5l.5-.5c0,.2,0,.3,0,.5Z" fill="#01297b" />
        <path
          d="M215.2,339.2c4.7-2.4,2.3,4-.8,5.1,0,1.9-1.8,3.2-3,4.2.5.6.1,1.5-1.3,2.6,1.8,1-1.6,3.4-3.3,2.1,1.5.4-.2,3-1.5,1.5,0,.4-.3.4-.5,0,0-2.7.8-1.5,2-1.5-.2-1.8-.8-1.9,1.3-3.5l.7,1c.3-.7-.5-1.6-.5-2,.2-.4.3-.4.5,0l.5-.5c-.2-.3-.4-.7-.2-1,.7-1.4,4.1-5.5,5.3-6.8.3.5.6,0,.9-1.2Z"
          fill="#01155f"
        />
        <path
          d="M204.7,354.7c.2,0,.3,0,.5,0,1.3.2,1.3.6,0,1l-.2,1.2c-1.4.5-1.8.8-2.3,2.2-.8-.3-1.2,0-1,1.1-.7,1.2-1.9,2.1-3.8,2.6-1,1.6-2,2.4-3.2,2.4-.2,1.7-1.4,3-3,2,.4-.6.6-3.4.7-3.5s.7.5,1.4,0,2.2-1.9,2.3-2c-.1.1,0,.5.2.5.5,0,0-.7-.2-.5,1-1.1,1-1.6.7-3,3.2,1.8,4-3.8,7-4.3s.6.3.7.3Z"
          fill="#011860"
        />
        <path
          d="M195.2,369.2c.5.1.4.3,0,.5-.5,1.8-1.1,2.3-1.9.4.2.7-.1.6-1.1-.4l.5-2h-.5c.3,1.5-1.3,1.6-1,0,0,0,.2-.4.5-.5,1.9-.6,1.7-.7,3-2,1.4-.4,1.6.9.5,4Z"
          fill="#011e6a"
        />
        <path
          d="M218.7,332.2c-1.4.8-2.5,1.5-2.4,3.3l-.6.2h-.5c0-1.3-.5-2.6-1.5-3.5,1.2-.8,2.7-2.1,4-3,2.2-1.1,2.9.3,1.5,2,.8.9.8,1-.5,1Z"
          fill="#010940"
        />
        <path
          d="M222.7,327.7c0,1.2-.8,2.5-1.8,3.3.4,1.1,0,3.9-1.2,2.7-1.1-.2-1.3,1.4-.6,4.7-1.4,0-2.7.3-3.9.8-.2,0-.4,0-.5,0,0-.3,0-.8,0-1l1.4-1.6c0-2.1.5-3.6,2.6-4.4.4-1.2.9-3.1-1-3,1.2-.9,3.3-1.9,4-2.5,1.5-1.7,2.7-.1,1,1Z"
          fill="#010d60"
        />
        <path
          d="M218.7,332.2c-.4,1.1-2,2.2-2,2.3-.3,2.4,2.1,2-2,3.7.3-.8.7-1.5,1-2.5.6-2.1-.2-3.6,3-3.5Z"
          fill="#010d50"
        />
        <path
          d="M215.7,335.7c.7.8.4,1.6-1,2.5.8-.1.5.4,0,1v1.1c-1.5,1.1-2.5,2.1-2.9,4.2-1.4,1-2.6,2.4-3.6,4.2-1,.6-1.5,1.4-1.6,1.4-.3.1-.8-.4-.9-.4-.2-1.6.8-2.9,1.5-4.3l-1-.2c1.5-1.1,2.8.4,1.5-2.5,1.3-.5,1,.9,1.2,1,1.7.5,1-.7,1.5-1.5s1.4-1.2,1.6-1.9,0-2.3.2-2.6,2.3-.8,2.9-2c.1-.4.3-.4.5,0Z"
          fill="#010d44"
        />
        <path
          d="M215.2,339.2c0,.5,1.2,1.1,1,1.5s-1.3.9-1.3,1c-.2,0-.9-.4-1.2-.2s-1.8,3-1,3.5l-1.5-.3c.7.8-1.1,2.8-2,3.5l-.5.5c-.1,0-.4,0-.5,0-.2-3.6,1.3-2.7,2.8-4.5s2.4-4.6,3.7-5c.1-.5.3-.4.5,0Z"
          fill="#010d50"
        />
        <path d="M213.5,338.7c.3.2.3.3,0,.5v-.5Z" fill="#010d50" />
        <path
          d="M192.3,369.7c1.2,0,1.1-1.4,2.3,1l.7-1c.9.7,1.1,2,.5,4,.4.1.4.3,0,.5-1.1-.1-2.3.5-3.5,0l.5,1.5c-.8-.1-2,.2-2.7,0s0-.8-.3-1.5,0-.4,0-.5c0-1,.6-1.2,1.8-.8,1.3-.2,1.1-2.8.2-1.7h-.5c-.4-.6-.2-1.6.5-1.5.2,0,.3,0,.5,0Z"
          fill="#012574"
        />
        <path
          d="M189.8,373.7c-.5-1.4-1.5-1.6-1.5-1.7.1-.3,1.3-1.4,1.5-1.2s.4,1.5,2,1.5c0-.3,0-.8,0-1,.2-.3.5-1.1,1-1,1.5,4.7.6,3-3,3.5Z"
          fill="#011e6a"
        />
        <path d="M191.8,369.7l-.5,1.5c-.8-.1-.5-1.2-.5-2,.7-.2.9.5,1,.5Z" fill="#011e6a" />
        <path
          d="M223.2,399.7c1.1.6,1,.9-.5,1,.7-.7,2.1-1.1,2.2.1h1.1c.8-1.6,1.6-1.2,2.7,0,1.6-1.4,2.4-.8,2.5,1.9.1-.4.3-.4.5,0,1.7.7.9,1.4-.9,1.6l.4.4c1.6.1,1.8,1.8.5,2.5.2.9.3,1.9.5,3-.7,1.3-.5,1.3.8,0,0,.9.3,1.6.7,2,0-.5.2-.4.5,0,.4.3.9.8,1.5,1.5.1-.4.3-.4.5,0,0,0,.5.1.5.3,0,.2-2.6,0,1,2.7l-2.5-1c-.2.2.9,1.1,1,1.5.2.1.2.3,0,.5-.7.8-.8.4-1-.5-.7.7-1,.4-.5-.5,0,0,0-.4,0-.5,0-.2-.7-1.4-1-2-.9,0-1.6-.1-2-.5-.6-.7-1.8-2.6-2-2.8-1.1-.8-5.4,1.1-6-2.2l2-1-1.5-.4c-.5-1.7,0,1.2-2-.1-.2-.5-.7-.8-.5-1.5-1.2,1.5-5.2,2.8-4-.5.6-.2.8.4,1,.5.1.5.4.5,1,0,0-1.9-2-.9-3.5-1.5.7.6.5,3.1-.5,2s-.6-2.4-.5-2.5,1,0,1.5-.3,0-.7,0-.7c0-.3-.4-1.5-.3-1.6.5-.2,3.6-.6,2.8.6.6-.7,1.1-.8,1.5-.5.7,0,1.3-.2,2-.5-.4.8-1.3.4-1-.5-.3-.7,1.2-1.4,1.5-.5Z"
          fill="#023996"
        />
        <path d="M231.7,413.7l2-.5c0,.3,0,.8,0,1-2.6,1.4-1.8-.2-2-.5Z" fill="#01287f" />
        <path d="M219.7,405.7c0,1.6-.5,1.3-1.5.2l.5-.2c.2,0,.7,0,1,0Z" fill="#044da2" />
        <path
          d="M221.7,400.2c.1,0,.5.4,1,.5,0,.1.1.7,0,.9s-1.4-.4-1.7.6l-.2-1c-.8,0-.6-.5,0-1h.5c0-.4.3-.4.5,0Z"
          fill="#0345a5"
        />
        <path d="M220.7,401.2c-.4.2-1,.5-1.5.5.3-.5.7-1,1-1.5.2-.3.3-.3.5,0v1Z" fill="#02399f" />
        <path d="M226.2,410.2c-1,.1-1.1,0-1-1l1,1Z" fill="#02338c" />
        <path d="M225.2,404.7c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#0245a6" />
        <path d="M231.5,412.2c.3.2.3.3,0,.5v-.5Z" fill="#022e86" />
        <path d="M215.2,396.7c.2-.3.3-.7.5-1,.2,0,.4,0,.5,0-.3.5-.4.8-1,1Z" fill="#02399f" />
        <path
          d="M218.2,397.2c-.1,0-.3.4-.5.5.1-.7-1-1.8-1.5-2,.2-.3-.4-1.7,1.2-1s.8,1.7.8,2.5Z"
          fill="#02399f"
        />
        <path
          d="M215.7,395.7c.1.4-.2.7-.5,1,.7.3,1.6.6,2.5,1-.1-.7,0-.8.5-.5,0-1.4.6-1.3,1,0,.1-.4.3-.4.5,0,1.3,1-.3,4.6-2.3,4l-.8.8c0-.8-.3-1.3-.9-.7l.5.5c.6.1.5.7,0,1-1.6-.5-1.2,2.2-1.5,2.5s-1.7-.4-2-.5c.6-1,1.4-.7,1.5-1.5-2.2,1.1-1.3-.3-1.5-.5s-2.8,1.1,0,2c-.1.2.1.9,0,1s-.8-.4-1-.5-.4,0-.5,0l-.5-.5c-.1-.1,0-.8-.5-1-2.2.8-1.1-3.2,1-2l.6-2.2c-1.4-1.8-.3-3.9,1.9-3.3.1-.4.3-.4.5,0l.5-.5c.4-.9.8-.9,1,0Z"
          fill="#023797"
        />
        <path d="M211.2,405.2c-.2-.2-.3-.3-.5-.5l.5.5Z" fill="#023590" />
        <path
          d="M219.7,397.2c-.3-1.8.9-2.9,2.1-1.7,1.5-1.3,2.1,2.6,0,1.7.7.6.4,1.3-.5,1,.4,1.3,0,1.8-1,1.5.3.1.3.3,0,.5.4.6,0,1.1-1,1.5-.5,0-1.7-.7-2-.5s-.3,1.1-.5,1.5h-.5c0-.3,0-.7,0-1-.5.2-.7,0-.5-.5.1-.2-.1-.9,0-1,1-.8,1.1,1,1.2,1,2.4-.2,2.4-2.2,2.8-4Z"
          fill="#0345a5"
        />
        <path
          d="M216.2,395.7c1.1-1.1,2.1.9,1.5,2,0,0-.6.1-.5.5l2,1c-2,.5-2.6-1.6-4.5-1.5-.1,0,.4-.8.5-1l1-1Z"
          fill="#0343a5"
        />
        <path
          d="M219.2,397.2c-.3,0-.8,0-1,0-.6-1.6-1.2-2.1-2-1.5-.1.2-.3.2-.5,0-.3,0-.7,0-1,0l-.5.5c-.2,0-.3,0-.5,0-1.9-.7,1.7-3.6,2.6-3.4s3.1,1.5,3.3,1.6c.8.9.6,2.3-.4,2.8Z"
          fill="#0343a5"
        />
        <path d="M216.2,401.7c-1.6.9-.9.5-.5-.5.2,0,.4.3.5.5Z" fill="#023590" />
        <path d="M214.2,396.2l.5-.5c-.1,0-.3.5-.5.5Z" fill="#02399f" />
        <path d="M211,402.7c.3.2.3.3,0,.5v-.5Z" fill="#023590" />
        <path
          d="M203.7,397.2c-.3-.5-.1-.7.5-.7,2.3,1.4,3.7,1.1,4.2-.9,2.2-2.8,4.7-.3,2.8,2.1.8,1.5.8,2.8,0,3.9-.4.4-1,.5-1.2,1.2s.2.8.2.8c0,.7,0,2.4,0,2.7-.1.4-.8.6-.9.8.2.2,0,.4-.5.5-.1.2.2,1.1,0,1.4s-1.2,0-1.4,0c-1-.4-1.9-.6-2.7-.4l-.3-.6c0-.3,0-.7,0-1l3,.3c-1.2-2.4-3.7.3-4.7-1.8s1-.7-.8-1-.4,0-.5,0c-1.3-1.2-2.1-2.9,0-3.7l.6-1.5c-1.8-1,.2-2.7,1.8-2.3Z"
          fill="#023590"
        />
        <path d="M209.2,407.2l.5.5h-1c.2-.4.5-.5.5-.5Z" fill="#0756a3" />
        <path
          d="M211.2,394.2c1.9-.2,2.6-.2,2.5,2-1.3,1.6-1.2.8-1.8,1.1-1.5.8,2.1,2.6,2.3,3.4-2.1-.9-1.8,0-3,1v-2s-2.5,1.5-2.5,1.5l-.5-2.7,1,1.2c2.5-.3,1.7-3.2,1.5-5l-3.8,3.4c-2,.3-2.5-1.1-2.9-1.3s-.2.4-.3.4c-.9.3-1.3.1-1-.5.1-2.1,3.2-1.8,4.5-.6s0,.2,0,.2c-1.2-1.4,3.1-4.5,4-2.1Z"
          fill="#0240a0"
        />
        <path d="M205.7,398.2l-.5,1.5c-2.4-.7-2.1-1.8.5-1.5Z" fill="#011e78" />
        <path d="M232.2,425.2l-.5-.2.5-.2c0,.1,0,.4,0,.5Z" fill="#022e86" />
        <path
          d="M187.8,392.2c.2.2.3.2.5,0,.1-.4.3-.4.5,0l1,.5c.2-.4.3-.4.5,0v1c-.1,0-.3,0-.5,0-1.1-.2-1.9-.6-3,0v-1.5c.3,0,.7,0,1,0Z"
          fill="#022870"
        />
        <path
          d="M190.8,393.7c.7-.4.9-.2.5.5l.9.3c.5-1.8,2.5-1.4,1.6.2,3.4-.4,2.4,7.2.9,7.9s-1.2-.2-1.4-.4c-.5,0-1,0-1.5,0l-1,1,1.5,2-1,.5c-1.2.1-.6-.4-1-.5,0-.5,0-1.1,0-1.5.2-.9.9-1.6,1-2.2s-.6-1.7-.5-2.5,1.2-.1,1-.6-1.1-1-1.5-.7-.4,4.8-1,5.5c-1.5,1.7-.5-3.4-.5-3.5l-1,1c-.7-2.6,1.7-.5,1.5-2.5l-2.5,1c-.4.5-1,.2-1-.5-.3-.1-.3-.3,0-.5.1-.4.3-.4.5,0,.3-.9.8-1.2,1.5-1,0-.5.4-.8,1-1,.4-.1.4-.3,0-.5-1.3-.8-.4-2.2,1-2,.1-.4.3-.4.5,0,.1-.4.3-.4.5,0Z"
          fill="#022f83"
        />
        <path d="M192.3,405.2c.2,0,.3,0,.5,0-.2.6-1,.4-1.5.5.2-.5.6-.4,1-.5Z" fill="#011961" />
        <path
          d="M191.3,391.7c0,0-.1.8,0,.9.3.3.9-.3,1.2-.4s.8,1.7,2.7.9l-1.5,1.5c0-.3.2-1-.2-1-.7,1.1-.3,3-2.2,3-.6-.8,0-2,0-2.5,0-.4,0-.6-.5-.5-.1,0-.3,0-.5,0-1.3-.2-1.3-.6,0-1-2.1-.8,0-3.1,1-1Z"
          fill="#02297b"
        />
        <path d="M193.8,401.7c-1,.5-2.4-2.1-2-2.5.8-.8,1.9,1.9,2,2.5Z" fill="#01226f" />
        <path
          d="M188.8,395.7c.9.2,1.8-.6,1.5,1-.5-.2-1-.4-1.5-.5-.4.9-1.4.4-1.5-.5,0,0,.2-.4.6-.4s.6.3.9.4Z"
          fill="#01216b"
        />
        <path
          d="M188.8,396.2c.4,1.4-.8.8-1,1-.7,1.1-1.1,0-1-1-.3-.1-.3-.3,0-.5.1,0,.3,0,.5,0,.5.3,1,.4,1.5.5Z"
          fill="#012773"
        />
        <path
          d="M187.8,397.2c-.4.3-.5,1.3-1.5,1,.6-.5,0-1.3,0-1.5-.2-.4,0-.6.5-.5l1,1Z"
          fill="#02297b"
        />
        <path d="M190.8,393.7l.3-.5c.8-.1.9,0,.7.7l-.5.3c0-.6-.3-.4-.5-.5Z" fill="#05428d" />
        <path
          d="M201.7,368.2c1.9,0,2.7.5,2.5,1.5,0,1.2-.8,2.6-2.5,4,.4.9,0,1.3-1.2,1.4.8,3.8-3.5,4-4.3,1.1,0-.2,1.2-1.4-.5-1,.1,0,.3-.4.5-.5v-.5c.7,0,1.2,0,1.5-.5,2.2-1.2,1.8-1.2-1,0,0,.4-.3.4-.5,0-1.1-.4-1-1.8,0-2.3v-1.5c1.7-.7,3.4-1.3,5-1.7,0-.4.3-.4.5,0Z"
          fill="#022c89"
        />
        <path
          d="M202.7,365.2c1-.7,2.8,0,3,.6s-2.5,3-2.5.4c-.6.9-1.2,1.6-2,2-1.4,2.1-2.8-.9-1-1.8-.5-1.7,1.5-2.7,2.5-1.2Z"
          fill="#022c89"
        />
        <path
          d="M187.8,392.2c-.1-.4-.6-2.9-.5-3,3.4,1.2,1.3-.2,1.7-1s1.6.2,1.8,0c1-1-1.3-.8-1-1.5,1.6-.9,2.8,2.6,2.5,3-1,1.1-.8-1.3-1.5-1-.1.5.5,1.1.5,1.5s-.8.9,0,1.5c-.6-.5-1.3.3-1,1-.2,0-.3,0-.5,0l-1-.5c-.2,0-.3,0-.5,0-.2.3-.3.3-.5,0Z"
          fill="#023082"
        />
        <path
          d="M196.7,373.7c.4-.3.7-.4,1,0,.4,1.7-.9.7-1.5,1,0-.3-.3-.5-.5-.5v-.5c.2-.3.3-.3.5,0,.2,0,.3,0,.5,0Z"
          fill="#011762"
        />
        <path d="M186.8,396.2c0,.2-.5.4-.5.5h-.5c.2-.5.5-.7,1-1v.5Z" fill="#01216b" />
        <path d="M184.3,396.2c.2,0,.3,0,.5,0l-.2.5-.2-.5Z" fill="#01216b" />
        <path d="M244.7,423.7c1-2.4,3,.4,1,1-.8.3-1.3.4-1-.5-.4-.1-.4-.3,0-.5Z" fill="#022b82" />
        <path
          d="M257.2,430.7c.4-1,.5-2.2.5-3.5.8,0,1.5-.4,2-1-1.6-.8-2.4-4-.4-4.1s3.3,1.1,3.5,1.3c-.4,1.1-.2,2.2.4,3.3.6-.5.8-.2.5.5-.5.6-.4,1.3,0,2l.8,1.6c2.7.3-1,3.2-2.8,3.4-.4-.1-.9-.3-1.6-.7.4-1-.6-1.4-1.4-.8.7.2.6.6,0,1,.9-.3,1.2,0,1,1-1.3-.3.5-1.9.8-1.9.8.1,1.1,4.4-.8,1.9,1.3.3,2,.6,1.5,2,.1.8-.5,1.8-.5,2.5l.5.5c0,.2,0,.4,0,.5h-1c-.4.4-1.1.4-1.5,0,0-.5.8-.6,1-1-.6-.6-1.1-1.5-1.2-2.7-1,.2-4.6.9-5.1.5-1.9-1.4.6-2.9,1.9-3.3,1-.8,1.6-1.8,2-3Z"
          fill="#022b82"
        />
        <path
          d="M247.2,419.2c1.5-1.2,1.3.7,1.1,1.9s-.2-1.5.4-1.4c1.1-1.7,2.3-1.4,1,.5.7.3,1.5.6,2.5,1,.2-1,1.6-2.1,2-.9l-1.5,2.9c-.3.7-.6,1.2-.9,1.6-1.3-1.1-3.8-.1-2.1.9-1.6-.7-.6-1.4,3-2,.6-3.1,2.7-7.1,3.7-1.8l-.5,1.2c1.6,2.1,3,5.8.8,7.6.5,1.1-.3,3.2-1.5,3-.9,1.2-2.1.5-3.6-2-3.2,1.4-5.9-.9-1.9-2.5,0-.7.5-.4,1,0,.3-.5.3-1,0-1.5-.7,0-1-.8-1-2,.7.3.4,1.3,0,2,.4.1.4.3,0,.5-.4.3-.9.6-1.5,1-.9.9-1,1.9-.5,2.8-.8,3.3-6.3.3-2.5-.8-.2-.4-.5-.6-1-.5-.3,1-.7,1-1,0h-.5c-.1.4-.3.4-.5,0-2.4-.7-2.5-1.7-.3-2.9l1.3-1.6c-.3-.1-.3-.3,0-.5-.5-1.2,0-1.4,1.5-.5-.2-.4.1-.5,1-.5-.2-1.6.2-2.9,1.2-3.9l-.2-.6c-1.5-.4-.9-1.7.5-1Z"
          fill="#022b82"
        />
        <path
          d="M243.7,419.2c.4.1.4.3,0,.5.6.4,1.4.2,2.2-.4l.8.9c.6,1.6-1.4,4-3,2.5-1.1,0-1-.7,0-1-.7-.8-1.2-1.5-1.5-2-2.1-1.9,1.8-3.1,1.5-.5Z"
          fill="#022b82"
        />
        <path
          d="M243.2,426.2c.3,1.4-1.3,2.6-2.5,3-.2.9.9.3,1.4.6s0,.8.1.9v.5c1.2,2.7-1.9,3-1,0-.4,0-.4-.4-.5-.5-.3,0-.5-.2-.5-.5,0-.3-.6-1-.5-1.5.2,0,.4,0,.5,0,.3-.6.6-.9,1-1,.6-.4.6-.6,1-1-.3-.5,0-.8.5-.5.1-.4.3-.4.5,0Z"
          fill="#012482"
        />
        <path d="M244.2,430.7l.5-3c3.3-.1,1.1,1.8.5,3.5-.5.2-.8-.5-1-.5Z" fill="#012482" />
        <path
          d="M249.7,428.2c.8-.5,1.8.2,1,1-.3,0-.7,0-1,0-.7-.1-.6-.2-1.5,0l-.5-1c.6,0,1.5-.1,2,0Z"
          fill="#02378c"
        />
        <path
          d="M252.7,423.7c0,.2-.6.6-.4.9s1.6,1.1,1.9,1.1c.2.8-.7.3-.8.6s.4,1-.4,1.4c-.2,0-1.2-2.5-2-3-1.6-.7-1.1.9-1.2,1-.1.1-1.1.3-1.5.5-.7-3.9,2.6-1.2,4.5-3,0,.2,0,.3,0,.5Z"
          fill="#023389"
        />
        <path
          d="M251.2,420.2c.4-.6.7-.4,1,0,0,.2,0,.7,0,1-1.4.5-1.7.6-2.5-1,1.1-1.8.7-.8,1.5,0Z"
          fill="#023694"
        />
        <path
          d="M250.7,427.7c1.6.4,2.6,1,3,2.7-1.2.9-1-.6-1.8-1.2s-1,0-1.2,0-.4-.8-1-1v-.5c.3-1,.7-.9,1,0Z"
          fill="#01237c"
        />
        <path
          d="M250.7,427.7c-.3,0-.7,0-1,0l-1-.8c-.1-.3,1.5-.2,1-1.2h.5s.5,2,.5,2Z"
          fill="#02378c"
        />
        <path d="M250.2,423.2c-1.1-.4-1.2-.8-.2-1.5l.2,1.5Z" fill="#023694" />
        <path d="M255.2,430.7c-.3.3-.5,1.6-.7,1.5-1.2-.5-.5-1.7.7-1.5Z" fill="#01237c" />
        <path d="M254.7,429.7c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#01237c" />
        <path
          d="M118.3,310.8c-.1-2,2.1-1.8,3.5-1,.6.5.9,1.2,1,2,.9-.3,1.3.3.5,1,2.3,1.6.5,2-1.2,2.3l-.8.5c.4.9-1.4,1.3-2,.6v.2s.5.5.5.5c.6.5,1,1,0,1-.8-.4-1.4-1-1.5-1-1.1-.8-.9-1.9.7-3.3-1.9.6-2.1-.7-1.2-2.2.2-.1.3-.4.5-.5Z"
          fill="#022bdb"
        />
        <path
          d="M117.8,311.3c.1.3,0,1.1,0,1.5,4.6-1.4.5.9,3,1-.5,1.3-3.1.9-2.5,3-.2,0-1,.7-1.5.5.4-.9,1-1.8,0-2.5,0,0-.3,0-.3-.5.1-.8.7-2,.8-3,.2,0,.5,0,.5,0Z"
          fill="#0222d7"
        />
        <path
          d="M121.8,331.7c0,.3,0,.9,0,1l-.5.5.5.5c.6.7.3,1-.5.5l-.5.5c-.2.5-.3.5-.5,0l-1-.5c-.1.4-.3.4-.5,0,.2-.6,0-1.3-.5-2-.4-.1-.4-.3,0-.5l2,.5c.2-.1-.5-.8-.5-1,.5.2,1.5.5,2,.5Z"
          fill="#0228d4"
        />
        <path
          d="M116.8,314.8c1.9-.7,1.3,1.3.4,2.3.3-.9.7-1,1.1-.3.4-.7,1.3.3,1.5,1,.4-.3,1.1-.2,2,.5.9,0,1.3.9,1.2,2.6l.8.9c.5.6.5.4,0-.5-1.3.3-1.2-2.7-1-3.5-3.2-2.6-.8-4.8,1.5-1.5.8-.9,1.4-.5,2.1.3,1.4-1.5,3-.4,2.4,1.2,1.1.8,1.1.9,2.5.5.4.1.4.3,0,.5.1,1.3-2,2.6-3.1,2.5l-.9,1c-.1.5-.3.4-.5,0-2.4,1.1-.6,1.2-1.1,1.9s-1.4.3-1.4,1.1c2.9-.9,2.7-.2,3.5,2.5-.9-.2-2.1-.3-3,0l-.5.5v.5c.3.9-.3.8-1,.5-.2.1-.3.4-.5.5-.2.2-.3.2-.5,0h-.5c0-.4-.7-1.3-.5-2l2,.2c-1.7-.4-.9-1.1-.5-2.5,0-1.2-2.5,1.5-2.7,1.9-.3.9.5,1.2.4,1.9s-.7,1.4-.8,2c-1.8-.6-2.8-2.1-3.7-.5s.2.5.2.5c.6.2.7,1,.5,2.4-.1-.7,2.1,1.1,2,1.5s-3.3,1.1-3.7,1c-1.6-.3-2-.7-1.4-2.3-.2-.7-.8-1.1-1.9-1.2-.2,0-.7.4-1,.5,0-.3-1.1.1.5-1s3-.2,3.5-.5.4-2.9,3-2.5c0-1.1-2-.1-2.5-.5s0-1.3,0-1.4c-.9-1.1-1,1.9-2,1,1-1.3-.5-.9-.5-1.3,0-1,1.8-1.7-1.5-.7l2.7-2.6c3,0,1.6-1.4,1.8-1.4,1-.6,2.6,0,2,1.5,2.1-.8,0-1.8,0-2.3,0-.8,2-.9,1.9-1.7-1.5.7-4.4-1.4-4-2.7s.9-.6,1-.8c-.7-.5-1-1.3,0-1.5Z"
          fill="#0228d4"
        />
        <path
          d="M116.3,331.2l.5-1h.5c0,1-.1,1.7,1,1.5v.5c-.1.6,0,1.3.5,2,.1,0,.3,0,.5,0l1,.5c.2,0,.4,0,.5,0l.5-.5c.1-.1.6,0,.5-.5l-.5-.5s-.6,0-.5-.5c.3,0,.9,0,1,0,3.1.6.6,2.2-1,2.8s-5.3-.6-5,3.2c-1.4-.2-.3-1.7-.5-1.9s-.8,0-1,0c-.5-.3-.8-1.3-2-1-.2-.2,1.2-1.7,1-2s-1.4-1-1.5-1c3.4-.8,1.8,2.5,2.5,3s2.7-.9,3.5-.5c.4-1.7-1.2-.5-1.5-1.3s-.1-1.8,0-2.7Z"
          fill="#011cca"
        />
        <path d="M124.3,328.2l.5-.5c-.1,0-.3.4-.5.5Z" fill="#0125cf" />
        <path
          d="M124.8,313.8c.7-.9,1-.9,1,0-.2,1.5-.2.9-2,1l.5,1.5c-.8-.4-3.8-1.7-2.5,0s.3-.8,1,1.5c-.1.4-.3.4-.5,0-.5-.3-.7-.3-.5,0,.4.1.4.3,0,.5-.9.3-1.3-.2-2-.5,0-.3,0-.7,0-1l-.5-.5s-.6,0-.5-.5c2.9.6,2.1-1.4,2.5-2s1.7.6,2.5,0c.1-.1-.4-.8-.5-1,.1-.4.3-.4.5,0,.8-.4,1.3.1,1,1Z"
          fill="#0222d7"
        />
        <path
          d="M131.3,318.8c1.2,1-1,3.8-2,3.5s-.4-1-.7-1-.8.8-1.2,1c.4-1.7,2.4-2.9,4-3.5Z"
          fill="#0220ca"
        />
        <path d="M119.8,324.3c-1,2.7-3,2.7-5.5,2l1.7-.5-.3-1,2.5,1,1.5-1.5Z" fill="#011dcd" />
        <path
          d="M122.8,317.8c.3,1.2.5,2.5,1,3.5.2.2.2.3,0,.5l-2,.5c0-1.7,1.6-2.6,0-4v-.5c.2-.3.3-.3.5,0h.5Z"
          fill="#021fca"
        />
        <path d="M126.3,325.7c.3,2-1.6.6-2.3.5s.2,1.2-.7,1c0-2.1,1.8-.9,3-1.5Z" fill="#0220ca" />
        <path d="M123.8,321.2c.1.2,1,.2,1,1.2s-1.5.5-1-.7v-.5Z" fill="#0220ca" />
        <path
          d="M116.3,299.3c1.3.1.9.8,0,1.5-.1,1-.6,1-1,0,1.5.2,1.6,1.6.5,2.5.4,0,.4.3,0,.5.3.1.3.3,0,.5.4.6.4,1.4,0,2.5,2.2,0,1.9,2.1,1,3.5-.1.4-.3.4-.5,0l-.5.5c-1.6-.7-2.1-2.3-2.6-2.9s-1.9-.1-2.2-.2,0-1-.5-.9c-1.4.5-.2,3.1.3,3.4.7.4,2.7-1.2,2.9,0l-3.7,1.5.7-.8-1-1.8c-.4.5-1.8.8-2,1-.6.5,2,.5,1,1.5s-2-.6-3,.5c0,1.2,1.8-.2,2,0,1,.9-.9,1-.9,1.1-.1.2.6.8.4.9-.5.4-3.7-2.6-3-3.5l.7,1c3.6-.8.8-1.6.8-1.7,0-1.6.4-4.3,2.5-3.5l-1.5-2.2h2.5s-.5-1.5-.5-1.5l-1.7,1c-.7-1,.6-2.3,1.8-2.5.4.1.4.3,0,.5.9-.2,1.6.2,1,1l2.2.2c.3-.5.9-.2,1.8.8q.7.1,0,0c-1.4-.5-1.9-1.5-1.5-3-.7-.9-.4-1.1.5-.5,0-1.5,2.3-.5,2.5.5-2.2-1.1-2.7-1.9-1.5-2.5.4-2.6,4.7-1,2.5,1Z"
          fill="#0220d7"
        />
        <path d="M116.3,310.3v.5h-.5v-1c.4-.1.4.5.5.5Z" fill="#022bdb" />
        <path
          d="M112.3,300.8c1.8.9.4,1.3.6,1.9s.5-.1.9,1.1c.2,0,.6-.5,1-.5.2.7-.7,2.5-1,2,0-.5.1-1.1,0-1.5-.9,0-1.6-.4-2.5-.5-.7,2,.9,1.9,1,2.3.3.9-.8,1-1,.7s-.3-2.1-.6-2.6-.8-.7-.9-.8v-1.5c.4-.6-.3-1.8,2.5-.5Z"
          fill="#0329de"
        />
        <path d="M109.8,301.3l2.5,1.2-2.5.3c0,0-.8-.8-1-1,.3-.2.9-.3,1-.5Z" fill="#021dd1" />
        <path d="M113.3,304.3c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#0329de" />
        <path d="M115.8,304.3v-.5l.5.3c-.1.2-.4.2-.5.2Z" fill="#022fe6" />
        <path
          d="M106.8,290.8c1.9-1.5.2-.5,0-2.3s.9-2.1,1-3.2c1.3.3-.5,2.9,1.5,2.5l-1.5.5c0,1,2.4,0,1.5,1.5s-1-.6-1,0c0,.5-.1,1.1,0,1.5-.3,0-.7,0-1,0-.3,0-.5-.1-.5-.5Z"
          fill="#011fda"
        />
        <path
          d="M108.3,289.8c.8-.2,1.5,0,2.2.7,1.4-.4,2.2-.2,2.3.8.2.2.2.3,0,.5l-.5,1c-.5.4-.5.7,0,1,.8.4.6,1-.8,1.8l.3.7c.7.2.7.9.1,2.2,1,.4,1.3,1,.9,1.8-.2,0-.6.2-.5.5-.7.3-1.6.5-2.5.5.3,1-.1,1-1,.5,0,0,0-.4,0-.5-.6-.7-1.5-.3-1.5-.7l1.5-1.2c-1.6.7-3.2,1.8-2.8-.8s2.6-2.4.8-3.5-2.2,1.8-3.5,1.3l3-3.7-2-.2c.2-.7.7-1.1,1.5-1,2.2.7,3,.7,2.5,0-1.1-.2-.7-.9,0-1.5Z"
          fill="#0224da"
        />
        <path
          d="M112.8,296.3c.3.3.6.8,1,1.5,0,.2,0,.3,0,.5.3,1.9.8.6,1.4,1.1s0,1.1,0,1.4c-.5,0-1.8-.5-2.5-.5l-2.5-2c1.4-1.8,2,.2,1.5-2-.4-.2-.4-.3,0-.5.3-.5,1-.1,1,.5Z"
          fill="#0329de"
        />
        <path d="M110.3,299.3c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#0329de" />
        <path d="M112.3,292.8l.5-1c0,.6-.2.7-.5,1Z" fill="#0225df" />
        <path
          d="M122.3,305.8c1.5-.4.7.9,1.1,1.3,1,1.1,1,.9,2.1,2.5s1.6.3.8,1.2-1.1-.6-1.7-.5-.3,1-.3,1c-.1.8-1,1.4-1.5.5-.8-.3-.7-.9-.3-1.5l-.7-.5c-.7.3-1.3.7-2,1,0-1.8-.1-.6-1.5,0-1.9-1.6,2.3-3.3,2.5-3-.2,3.5,3.1.2,1.5-2Z"
          fill="#0220d7"
        />
        <path d="M121.8,306.3c-.4.8.7.8-1.3,1l.3-1c.3,0,.7,0,1,0Z" fill="#0220d7" />
        <path d="M116.8,310.3c.2-.2.8.5.2.5s-.4-.4-.2-.5Z" fill="#022bdb" />
        <path d="M118.3,332.2c2.3.3,3,1.2.5,2-1-.5-1.8,0-1.5-2,.5.4.9,0,1,0Z" fill="#0125cf" />
        <path d="M120.3,334.7c-.9,0-.9-.5-1-.5l1,.5Z" fill="#0125cf" />
        <path
          d="M119.8,331.2c-.5-1.1-.8-3.6-.2-4.8s2.6-2.6,3.7-1.8,0,4.7-1.4,5.1c1,.6,1,1.4,0,2,0-.8,1.9-2.8,2.8-1.2s-.7,1.4-.8,1.4c-.1,0-.3-2.7,1-1.2-.7,1.5,0,2.7,0,3.8s-.9.1-.9.4c0,.6.6.9,0,2.2s-.8.5-1,.8c-.3.4-.3,1.2-.7,1.5s-1.6.2-2,.3-.3-.9-1,.3,0,1.7,0,1.7c-1.6.8-2.5-.4-2-2-1.3.1-.8,2.3-1,2.5s-2.3-.5-2.4-.6c-.2-.2,0-1.5-.5-2.2s-2.2-.6-2.1-.9c.6-1.8,2.6.7,3,.2,0-.5.1-1.8,0-2,1.4-.8,4-2,5.8-1.5,1.6-.3,2.5-.7,1.7-2.5-1.3-.2-1.2-.5,0-1-.6,1.1-1.3.9-2-.5Z"
          fill="#0125cf"
        />
        <path
          d="M119.8,331.2c2.4,1.5,0,1.6-1.5.5-1.2,1.1-1.9.8-1.4-.9s.2.7-.6.4c-.4.5-.9.4-.8,0,.3-2.2,4.3-2.5,4.3,0Z"
          fill="#0125cf"
        />
        <path d="M115.8,340.2v.5c-2.1.2-2.1-.7,0-.5Z" fill="#011dca" />
        <path d="M122.3,329.7h.5c-.2.1-.1.9-.5,0Z" fill="#0125cf" />
        <path d="M120.8,334.7l.5-.5c-.1.2-.3.4-.5.5Z" fill="#0125cf" />
        <path d="M121.8,333.7l-.5-.5s.5-.1.5.5Z" fill="#0125cf" />
        <path
          d="M142.8,290.8c2.3.4,2.8,1.7,1,3.5,0,.6.2.6,0,1.5-1.3,2-2.3,2.3-3,1-.2-.2-.3-.4-.5-.5-.9-1.4-1.2-3.2.5-4-.4-.1-.4-.3,0-.5-.2-2,3.3-3.9,2-1Z"
          fill="#0121d2"
        />
        <path
          d="M147.3,290.8c-.4,1.3-.7,1.7-1,2.5l-.2-1-2.3,2c0-.3.5-.7.3-1.5s-1.5-.9-1.3-2c-.4-1.7,1.8-1.5,3-.8.2-.7.7-.8,1.5-.7.7.3.3.9,0,1.5Z"
          fill="#041ecb"
        />
        <path
          d="M136.3,306.8c0,.3,0,.8,0,1,1.2,1,.3,1.8-.9,1.2s-1.2,2-1.3,2.6c-.4-.5-.8-.6-1.2-.3-.4,1.3,1.9,2-1.5,2.5-1,1.1-4,2-2-1.5.4,0,.4-.4,0-1.2.9.8.6.9-.6.7.4.7.4,1.2-.5,1-.6.4-.9.2-.5-.5-.3-.4-.4-.9-.5-1.5-1.1-2,4.3-5.9,5-2.5.3-1.7,1.1-2.1,2-.5.4-.9,1.6-2.3,2-1Z"
          fill="#022cdc"
        />
        <path
          d="M137.8,309.3c-.1,0-.5-.2-.9.1s.3,1-.9.9,0-1.6-1.3-1c1,2.2-.1.9-.5,2,1.6-.2.5.9,1,2-.2,0-1.9-.4-2-.5-.1-.2,1.5-1.9-.5-1.5.1-.4,1.1-.7,1.2-1,.3-.5-.4-1.4-.2-1.5.2-.2,2.2.5,2.5-1,.1.2,1.1.6,1.5,1.5Z"
          fill="#0222d6"
        />
        <path
          d="M129.3,312.3c.5.8.3,1.1,0,2,1.3.5.9-.9,1.2-1s.6.5.8.5c0,.3,0,.7,0,1-.8-.1-2.4,1.4-3,1s1-1.5-1-1.5c-.1-.1.8-1.1,1-1.5s.4-.8.5-1c.5-.2.7,0,.5.5Z"
          fill="#0222d7"
        />
        <path
          d="M127.8,312.3c-.7,0-.9.7-2-.5l.2-.5c1.9,1.2,1-.2,1.3-.5.9.4,1.2.7.5,1.5Z"
          fill="#0222d7"
        />
        <path
          d="M128.8,311.8c.2-.2.6-1.2,1-1-.3.9,1.1,1,1,1.2-.3.7-1,.8-1.5.3-.1-.2-.3-.4-.5-.5Z"
          fill="#022fe6"
        />
        <path d="M133.3,309.3c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#0222d6" />
        <path d="M125.8,313.3c0-.2,0-.3,0-.5l1,.8-1-.3Z" fill="#0222d7" />
        <path
          d="M228.2,257.3c.5.5.5,1.4,0,2.5.4.2.4.3,0,.5v.5c1.6-.8,1.8,1.4.6,2.4.7.9.4,2-.9,3.2.3,1.2.7,2.4,1.4,3.5-.1.8-1.5,3.6-2.5,3.4.5,0,.5.3,0,1,.1.2.2.5.2.7,0,1-.1,3.9,0,4.1.7,1.1.4,2.9-1.2,2.2,0,.2-.3.4-1,.5h-.5c-.5-2-.4-4.5,0-6.5-.5-3.8-.1-7.7.5-11.5,1.4-2.2.3-.8.2-2.5s.5-2.8,1.3-3.5,1.6-.7,2-.5Z"
          fill="#021dc0"
        />
        <path
          d="M230.7,293.8c1.9.1,1.9,1.6.5,2-1.2.4-1.7,1.2-1.5,2.5,3.6,1.2,3.6,3.3,0,4,1.3.3,1.8.7.5,1.5-1.1.4.2,1.6,1,.6,1.4.4,0,4.5-2.3,2.3l-.2.6c.5,1.4-1.1,2.1-2,1-.9-.4-1.3-2-1.5-3-.3-1.3.2-2.5,1.5-3.5-1.1.2-.8-1.2,0-1.5,0-.2,0-.3,0-.5-.4-.4-.2-1.2.8-2.2-.8-1.7-2-6.8.7-4.3.2-.2.2-.4,0-.5-.8.6-1,.3-.5-.5.8-1.8,3.8-.2,3,1.5Z"
          fill="#012adc"
        />
        <path
          d="M223.7,302.3c.3-1.5-.8-2.3,1.5-2-.3.5,0,1.2,0,1.5.4.1.4.3,0,.5,1-.1.2,2.5,0,2.5-.7-.2-.1-1.3,0-.3s0,.5,0,.8l1,3.2c.4,1.6.1,2.4-1.5,2.3l.5.5c.5.1.5.3,0,.5-.6.5-.7,1-.5,1.5.1-.4.3-.4.5,0,.2.3.2.5.2.8,0,.9,0,2.9-.7,3.2,2.4.2,1.5,2.9.4,4.2.7,1.8.4,2.9-.9,3.3-.7.3-1-.7-1-3-.3-.2-.3-.5,0-1,.2-6-.6-12.7.5-18.5Z"
          fill="#04109c"
        />
        <path
          d="M228.2,280.8c2.1-2.4,2.5,2.1.4,3.5l.6,2.5c1.1.1.9.4,0,1,.2.5-.1.8-1,1-1.7-1.9-1.1-.4-.2.2s.8,0,1.2-.2c.1-.4.3-.4.5,0,1.3.8-.6,3.6-2,3.5,0,.2.5.4.5.5.3.1.3.3,0,.5-.2.2-1.2,0-1.5.8,1.1,0,1.6,2.8,1.5,3.4s-1.2.8-1.5,2.3c-2.1-1,.5-1.1.5-2.5l-1.5.3c.6-.9,0-2,.2-3s.7-.9.7-1c0-.2-3.6-1.7.5-2.3.1-.1-1.5-2-1.5-3.3s1.2-1.2,1-2.2h-1.5c.6-1.3,1.8-1.2,0-1.7.9-1.1,2-2.6-.5-2.3.2-.4.8-.4,1-.5.6-.4,1.4-.6,2.5-.5Z"
          fill="#011fce"
        />
        <path
          d="M224.7,291.3c.2,1.7-.3,3.3-.3,4.9s1.6,1.5-.2,3c-.1.3-.3.3-.5,0-.6-2.8,0-9.2,0-12.5h.5c0,0,.5,4.5.5,4.5Z"
          fill="#01088d"
        />
        <path
          d="M224.2,281.8c0,3.1.8,6.3.5,9.5l-1-4.5c0-3.8,0-7.7,0-11.5.1-.4.3-.4.5,0,0,2,0,4.6,0,6.5Z"
          fill="#030c97"
        />
        <path
          d="M224.2,275.3h-.5c0-2.4-.2-5.2,0-7.5s.6-3.4,1-4c0,3.8-.5,7.7-.5,11.5Z"
          fill="#010895"
        />
        <path
          d="M226.7,300.3c0,0,0,1.4,0,1.5.5,1-1,1.2-1.5.5,0-.2,0-.3,0-.5.4-.9.4-1.8,1.5-1.5Z"
          fill="#011fce"
        />
        <path d="M230.2,250.3c.1.3.4.7.5,1-.6,0-1.3-.5-1.5-.5l1-.5Z" fill="#011b92" />
        <path
          d="M233.2,236.3c2.8,3.3,4.9,3.7,6.3,1.4,1.8.3,3.2,0,4.2-1.1l1,.7,7.2,1.7c1.3-.1,2.6-.5,3.9-.2s2.5,2.4,2.7,2.5c1.2.3,3.6.4,3.9-1,.5,1.2,2.6,1.7,1.1,2.9s-3.1.8-4.4.6c-2-.2-5-1.8-6.7-2-2.7-.4-7.4.2-10.3.5-2.5.7-5,1.4-7.5,2-1.9.3-3.7,1-5.5,1.5l1,1c-2.5,0-2.4,2-3.1,2.9s-2.2.9-2.9,1.6c0-.5,0-1,0-1.5s0-.3,0-.5l.5-1.5c0-.3,0-.7,0-1,0-1.3.4-1.8,1-1.5.2-.2.4-.3.6-.4.9-.3,7-2.5,6.7-3.7-1.2-.6-1.5-4.1-.7-4s0,1.6-1,.5c-.4-.1-.4-.3,0-.5l.5-.5c.3-.4.6-.5,1-.5.2-.4.3-.4.5,0Z"
          fill="#030937"
        />
        <path d="M242.2,242.3c-1.3,2.3-5.3,1.6-7.5,2,1.5-2.2,5.2-1.8,7.5-2Z" fill="#060d47" />
        <path
          d="M231.2,237.8c.3-.2,1.4-1.1,1.5-1,0,1,0,2.3.5,3.2s2,.4,2,1.3c-2.3-.4-.9.7-1.5,1.2-1.1,1-3.7,1.8-5,2.6s-.5,1.1-.6,1.1c-.3.2-1.7-1.3-1.4.6l-1-1.5c1.5-3.4,2.3-5.2,5.5-7.5Z"
          fill="#010526"
        />
        <path d="M262.2,242.3c-.6,1.6-2.2.8-3.5.5.2-1.1,2.6-.2,3.5-.5Z" fill="#02093f" />
        <path d="M224.2,251.3h-.5v-1.5h.5c.8.1.8.6,0,1.5Z" fill="#03117c" />
        <path d="M224.2,249.3c0-.5-.2-1.2.5-1.5,0,.5.2,1.3-.5,1.5Z" fill="#010f5c" />
        <path d="M232.7,236.3c-.3.1-.7.3-1,.5.4-.5.5-.6,1-1v.5Z" fill="#0114d0" />
        <path d="M231.2,237.3c.1-.2.4-.3.5-.5-.2.1-.3.4-.5.5Z" fill="#020d56" />
        <path d="M225.7,257.3c0-.1,0-.4,0-.5v.5Z" fill="#021dc0" />
        <path
          d="M223.2,321.7c1.8-.2.5.5.5,1.8s.5,1,.5,1.2c1.9-.3,1.3,3.9,0,4,0,1.2-1.1,6.3-2.3,6.3s-.5-.1-.7-.3c-1-.1-1-.9-.2-2.3-.8-.7,0-2.1,1-2.5l.7-2.1c0-.3-.4-.8,0-1.5l-1,.5c.2-.1.9-1.2,1-1.5.7-1.6.4-1.9.5-3.5Z"
          fill="#031a95"
        />
        <path
          d="M95.8,269.8c-1.2-1.9-1-3.7,1.4-4.1.6-2.2,1.3-2.3,3.3-1.8s.8,3.5-1.7,2.4c.7.2.7,1.1,0,2.5.5.3,1.1.5,1.7.4.2-1,2.3-1,2.8-.9.5-.7,1-1.2,1.5-1.5.2-.2.3-.2.5,0l1.7,1.1c2.6-.6,3.5,3.1,1.5,4.8-.3,1.4-1,4.4-2.6,4.1q-.9-.8,0,0c2,0,.4,2.4-.5,3.5.2,3.3-4.3,1.7-3.5-1,.4-.6,0-1.3.3-2s2.2-2,1.7-2.5-3.8,2.1-3.7,0c-1.2.8-.8,1.8-1,3-1.9-.8-1-.7-.8-2.5-.2-.3-1.3,1.5-2,1,.6-1.5-.6-.5-.5-3-.1-.7.4-1.4.8-1.1s-.3.9-.8,1.1c-.5,0-1.3-1.2-1.5-1-.5.5.5,2.5-.7,2-2.4-1,.6-1.9.7-2s0-.9.5-1.2,1,.2,1,.2c.2-.2-.1-1.2,0-1.5Z"
          fill="#0224de"
        />
        <path
          d="M95.8,273.3c0-1.2-1.3-1.9,1.5-2l-1-1.5,4,1c.3,2.1-1.7-.3-2.5,1.3l1.5.5-1.7,2.3c-1.1-3.1-1-1.4-1.7-1.5Z"
          fill="#0116d4"
        />
        <path d="M102.8,269.8c.3.2-.9,5.5-2.5,4s1.1-2.3,1.3-3,.2-1.7,1.2-.9Z" fill="#0116d4" />
        <path d="M105.8,276.8h-1c-.2-.7.2-1,.7-1.5l.2,1.5Z" fill="#010ac8" />
        <path
          d="M99.3,258.8c1.9-1.8,2.4.2,1.4,2.3,2.1-.6,5.6,1.6,2.8,3.2.2.8.2,1.8-.7,2-.8.3-.9.6-.5,1q-.3.8,0,0c1.4-1.5,3.1,0,1,1-1,0-1.8,1.3-2.8,1.5-2.2.5-1.6-.9-1.7-1,.3-.9.3-1.7,0-2.5.6-.8,2.4-.1,1-1.7s-1.3,1.3-2,1.9-1.2.2-1.5.6c-.9,1.1.6,1.8.5,2.1s-.8.3-1,.6l-2.5-1,1-1.5-1.5-1c1.9.3.9-1.7,0-1s.1.9,0,1-1.4.6-1.5.5c-1-1.4,1.7-1.9,2-2.8-1.1-1.6-2.1-2.5,1-2.3,0-.3-.5-.4-.5-.5-.2-1.1,3.3-.6,3.9-1.1,1.2-1-.6-2.1,1.6-1.4Z"
          fill="#011bd6"
        />
        <path d="M102.3,267.3c.1,1,0,1.1-1,1l1-1Z" fill="#0227e4" />
        <path
          d="M102.8,266.3c2,.2,0-1.8,2-1.5-1,1.2.5,1,.5,1.2s-.4.5-.5.8c-.8,3.1-.6,1.4-1.5,1.5l.5-1c-.5,0-1.1.1-1.5,0s-1.5-.7-1.5-.7c.6-1.3,1.5-.3,2-.3Z"
          fill="#0227e4"
        />
        <path
          d="M98.8,266.3c1.4-.4,1.1,1.2,1.5,2.2l-1.5.3c-.4-.3-1.6,0-1.5-1.2s1,0,1.4-.3,0-.8,0-.9Z"
          fill="#0111ce"
        />
        <path d="M98.8,263.8s-1.1.2-1-.2c.8-1.4,1.6-.3,1,.2Z" fill="#0223e0" />
        <path
          d="M103.3,283.3c-.4,0-1.2-.2-1.4,0s0,2.6-1.1,1.4.5-1.4.2-2-1.6-1.2-1.7-2c.9-.3,1.2.8,1.9.9,1.7.4,1.1-1.7,2.1,1.6Z"
          fill="#011ad2"
        />
        <path d="M107.3,291.3c-.3,0-.7,0-1,0,0-.6.4-.4.5-.5l.5.5Z" fill="#011ed5" />
        <path
          d="M86.8,209.8c.4-1.6,1.3-1.4,2.5-.5.5,1.2,1,1.8,1.5,2l.3-.4c1.1-3.7,2.4-4.7,3.7-3.1,1.5-.5,2.3,1.1,1,2,.5.6,1,.8,1.5.5-.3-2.3,3.1-1.7,1.5.5.9.4,1.5,4,.3,3.4-.2,1.7-2.4,1.8-2.8,0-.4.6-.8.2-1-.5-1.6-.5-1.6-.5-.2.2-.4,1-.3,1.6.2,1.8.4-.8.7-.6,1,.5,0-.4.3-.4.5,0,.2,0,.3,0,.5,0,.4.1.4.3,0,.5,0,0-1.6,0-1.7,0-.4,0-.4,2.4-2.8-.5s.5-1.8-2.5-1c1.3-1.8,2.8,0,1.5-3l-.5,1c-.2,0-3.4-.4-3.5-.5-.9-1,1.1-1,1-1.2-.5-1.3-2.3,0-2.5-.3s.4-1,.5-1.5c-1.3.1-1.6.5-3,0,.3-1.1,1.6-1,2.5-1,.2-.1-.4-.7-.5-1-1-.3-1-.7,0-1,.5-1,.9-.9,1.6-.1s.9,3.2-.6,3.1Z"
          fill="#011fdc"
        />
        <path
          d="M80.8,207.8c-1-.4-1.3-.8-.2-.9.4-4.7,6.2-3.3,2.2.4.5.8.8,1.6,1,2.5.8-.5,2.4-.8,3,0,1.5.4,2.5,1.3,3.1,2.6,2.9-1.3,4,1.6,2.9,3.9.2.7-.4.8-.8.4s4.8,1.8,2.8,2.6c-1.2,1.4-2.9,2.5-5,3.3.8,1.7-.3.8-.3.6.4-1.3,5.5.8,2.4,3.6v2c1.3.3,1.6,1.5.8,2.7.9.6,1.3,1,.5,1.9-2.7,1.2-4.6,3.2-.1,5.1.8,1-.2,3.7-1.3,2.1-.7,0-1.4.2-2.1.3-.2.2-.2.4,0,.5,1.5-1.8,3.5,0,4,2,.7-.5,1.2-.4,1,.5.3,1.3-.4,1.1-1.5,1-.2.7.5.9.5,1,.3.1.3.3,0,.5,0,.5.2,1.4-.3,1.5-1.6.4.4-1.6-1-2s.8,1.4-.5,1c-3.7-1.3-1.8-.6-3.5,2.5l-.3-2c-1.2.6-1.8-.2-2.5,1s-.7,1.4-.5,2.5c-1.8-.6-.1-4.2-2.4-2.8s0,1-.4.8c-1.5-.6-2.7-.9-1-2.5l.7,1,.5-2c-2.1.8-2.3,0-1-1.5-1.4-.2-2.9,1.2-4-.3l1.5-1.2-2-.8c.7,0,2.3-.3,2.5-1.2-2.4.2-1.4-1-1.7-1.4s-1.7-.2-.8-1.1,1,1.3,1.5.8.3-1.2.8-1.3,2.7.5,3.6,0c-.9.2-2.5,3.1-.8,2.5s.3-.9.8-1.2c.7-.5,1.9-.1,2.5-1-1.3-1-3-.8-4.5-.8-.3-.7,2-.4,1-1.5s-2.3-1.1-2.5-1l.2,2c-.9-.4-1.3-2.5-.7-3s1.5.8,2-.3c.2-1.6-1.9-.6-2-.7-.6-1.3,1.6-3.1,3-2.5-1.5,1.2-.6,2.6.7,1.5s.2-.9.5-1.3.8-.2.8-.5c0-.6-.5-1.1-.5-1.5s1-.2,1-.5-.5-2.1-.5-2.2c-1.2-1.1-2.9,2.4-4,1.2.6-.7.5-1.6,1.2-2.3s.5,2.1,1.2.2-.6-.7-1.1-.7c-1.3-.2-.2-2.9,2.1-.5-.4-1.1.6-2.1,1.7-2s1,1.9,2.3.8,0-1.1,0-1.2c.4-.4,1.8,0,1.9-1.1-2.5-.5-2.5,1.5-5.2.8s-1.2-1.9-.8-4.3c-.5,0-1.6.2-2,0s.6-1.9-1-1.5c-.8,2.6,1.4,1.8,1.5,2.3.3,1.3.3,3.3-1.5,3-1.2-1.3,2.9-1.2,0-2.8l-1,1,.5-2-1.8.5c-1-1.5,1.3-.3,1.8-2.3s-1.2,0-1-.5c.5-.7,1.4-.9,2.2-.8s0,1.4,1,1c1.5-1.2,1.1-2.4.8-4-1.2.3-4.4,3-3,.5,0-1,.1-2,.5-3Z"
          fill="#0118d5"
        />
        <path
          d="M93.3,233.3c-.4-.2-.4-1.5-2-.5-.4-.9,1.4-2.5,1-3s-2.6,0-2.5-.8,1.6-.5,1.5-1.2c-2.2-1.2-1.4,1.4-3.5,1,.3,1.1,1.9,0,.2,1.5-4.2-2.6.2-1.6,1.3-3.4s-.1-1.6,0-1.6c1.2-.8.7,1.4,1.7,1,1.3-1.5,2.3-2-.5-2.4s-1.4,1.1-1.2-.6l-1,1c-.7-2,1.4-1.7.5-3,1.8.9,2.1-1.1,4-1,.2-.2-.9-1.3-1.3-1.5-1.3-.8.4,1.5-1,1s-3.1-1.5-3.2-3.2l1.5.3v-1.5s-1-.2-1-.2c1.3-2.1,2.3.6,2,1.9s-1.2.1-1,.6c.6,1.5,1.7-.4,2.7-.2s1.9,3,3.3,1.9c.2.2,1.4-.5,1,1.5-1.9-1.1-2.4,1.3-1.9,2.7s1.3.7,1.4.8c.4.1.4.3,0,.5l-2.5-.5c.7,1.2.2,1.9,1.5,1-.5,1.7.4,1.7,1,2.4s0,1,0,1.1c.2.2,2.7-1.3,3,.5-1.4-.3-.4,1.3-1.3,1.5s-3.3-1.5-3.2-.2,1.9,2.9,2,3.7c-.2.2-2-.8-2.5-1Z"
          fill="#021edc"
        />
        <path
          d="M89.8,241.3c-1.6,1.4.6,3-2,2.5,1.6-1.5-1.9-4.3,1-4.5l-.5,2c.4-.3,1.1-.3,1.5-.5v.5Z"
          fill="#0523db"
        />
        <path d="M85.3,225.3c0,0-2.3-.7-1.5-1.5s2,.9,1.5,1.5Z" fill="#0113cf" />
        <path d="M83.3,247.3l.2-1.5c.9.7.8,1.1-.2,1.5Z" fill="#0113cf" />
        <path d="M84.6,222.3c.3.2.3.3,0,.5v-.5Z" fill="#0113cf" />
        <path
          d="M91.8,260.3c-.4.2-.7.7-1,1-.3,0-.7,0-1,0-2.8-.9-4.2,1.6-2.9-2.1s0-.7-1.1-.9c0-.3-.4-.7-.5-1,1.2-.4,4.2,1.3,4.5,1l.2-1.5c.8.9,2.7,2.1,1.8,3.5Z"
          fill="#0112ca"
        />
        <path d="M89.8,259.8c.4.1.4.3,0,.5-.8,0-2.8-.5-1.8-1.5l1.8,1Z" fill="#0725d3" />
        <path d="M89.8,259.8c1.5-2.7,2.5.5,0,.5v-.5Z" fill="#0218d2" />
        <path d="M78.8,205.8l1.3-1.5.2,2.5-1-.5c0-.3-.4-.4-.5-.5Z" fill="#0118d5" />
        <path
          d="M85.8,206.8c0-.3-.6-.8-.5-1.2s.9-.2,1-.6-.1-2.8-.2-3c-.3-.6-1.1-.6-1.3-.8-.3-.4.5-1.2.5-1.7s-1.6,0-1-1.3l2-.5c-.6.9-.2,3.5.6,4s1.9-1.3,2.4.5c1,1.4.3,1.4-1,.5q-.3,0,0,0h1.4c1.7-2.3,2.7-.8,2.9,1.6-1.6.7-2.1,1.6-2.3,2.9.4.1.4.3,0,.5,0,.5-.3,1-.5,1.5-.1.4-.3.4-.5,0-.7,0-1.6.4-2.5.5.2-.9.3-2.8-1-3,0,.3,0,.7,0,1-1,.3-1.3.8-2-.2.5-.7,1.1-.9,2-.7Z"
          fill="#0219d6"
        />
        <path
          d="M90.8,195.8c.2,0,.6.5,1,.6s.9-.1,1,0c.5.9-.8.7,1,1.4.2-.4.3-.4.5,0,1.2,1.1,1.7,2-.2,2.4-1.1,1.7-1.2,3.2-.3,4.6.4.1.4.3,0,.5-1.1,1.4-2.2,2.1-3.5,2-2.2-1.8,2.7-3.2,1.5-4.5s-1.5-.2-1.7.7.6,1.2-.5.8-.8-1.4-1.3-1.5c.6,0,.8.2,1-.5.5-1.8-1-2.2-2.5-2,.2-2.3.9-.7,2-1s1.9-.5,2-.5c-.5-.6-.3-1,.5-1-.4-.2-.7-.3-1,0-.2.2-.6.2-1,0-.2,0-.7,0-1,0l.5-1.5,1-.5c.1-.3.3-.3.5,0,0-.5.3-.4.5,0Z"
          fill="#011fdc"
        />
        <path
          d="M100.3,176.3c1-1.2,1.9-1.6,2.3.3,2.3.5,2.4,1.8.2,3.7,1.3-.7,1.8-.3,1,1,.5.3.3.5-.5.5.6,1.3,0,1.4-1,.5l-.7.3c-1.5-3.2-4-2-6.3-.3-2.1.8-2.6-1-2.7-1-1.7-.5-1.1.6-1.3,1.5-.6,0-2.4.6-2.5.5-1.2-1.4,1.3-1.5,1.4-1.6.3-.3,0-.7.1-.9.2-.5.8-.2,0-1-4-.3,1-5,1.9-1.6h.6c.8,1.2,1.5.5,2.1-1.8-2.3.1-2-3.2,0-1.6h1.5q.2.2,0,0c.3-.2-1-1-1-1.5,4-2,1.5.5,1.7,1,.5,1.2,2.1,1.8,3.3,2Z"
          fill="#021fdd"
        />
        <path d="M161.3,88.9c-.4.5-.9.8-1.5,1,.2-.9.9-.8,1.5-1Z" fill="#7f94ea" />
        <path d="M387.1,162.8c1.7.6.7,1.9-.5,1-.1-.3-.6-.8-.5-1,.3,0,.7,0,1,0Z" fill="#0232ef" />
        <path d="M390.1,164.3c-.3.9,0,1.1-1.5,1.5-.2-.7.3-1,.5-1.5h1Z" fill="#0c5ff4" />
        <path
          d="M387.6,182.8c.5,0,.9.6,1,1.5.3.1.8.5,1,.5.2-.4.3-.4.5,0,0,.5.2,1,.5,1.5-.8.3-1.8.3-3,0-.1.4-.3.4-.5,0-1,.3-1.3-.4-.5-1-1.3-.5-.8-2.3.5-2.5.1-.4.3-.4.5,0Z"
          fill="#0352f3"
        />
        <path
          d="M390.6,186.3c.3,0,.8.3,1,.5s.3.7.5,1c.2,1.2-.4,1-1.5-.4-2.4.5-3.4,0-3-1.1.4-.5,2.4-.2,3,0Z"
          fill="#055cf7"
        />
        <path
          d="M397.1,184.3c.2.6.5,1.5.7,1.8.4.6,1.4-.6-.2,1.9l1-1.2c.9-.2.3.6.5,1,.9,0,1.4,0,1.5.5-.3.7-.2,2.5-1,3.5-.1.4-.3.4-.5,0-.1,0-.1-.3-1,0-.1.4-.3.4-.5,0-2.6,1.1-1-.6.5-1.5-1,0-1.2-.2-.5-1-.6.4-.8.1-.5-.5-.4-.1-.7,0-.8.3,0,2.2-2.3.9-2.2.1s1.6-4.1,2.2-2.8l.2-.6c0-.5.2-1,.5-1.5Z"
          fill="#0229eb"
        />
        <path d="M399.6,187.8c.1-.2.4-.3.5-.5l-.5.5Z" fill="#0229eb" />
        <path
          d="M398.1,190.3c-.2,1-3,1.4-.5,1.5-.5.2-1,1.4-2,1-.1-1.3,1.4-2,2.5-2.5Z"
          fill="#0235ee"
        />
        <path d="M400.1,188.8l-1,1c-.1-1,0-1.1,1-1Z" fill="#0235ee" />
        <path d="M397.6,189.3l-.3.5c-.8.1-.9,0-.7-.7l.5-.3c.1.2.4.4.5.5Z" fill="#0235ee" />
        <path
          d="M388.1,160.3c.3.7.9.9,0,2-.4-.3-1.1-.3-1.5-.5v-.5c-.2-.9,0-1.2.5-1,.3-.3.6-.3,1,0Z"
          fill="#0348f0"
        />
        <path
          d="M389.1,155.3c.2.4.7.8,1,1.3-2.4,1-.5,1.9,1,.2-.3,1.4.2,2.9-1.5,3.5-.9,0-.9-.3-.5-1-.1.2-.3.2-.5,0,0,1-.4.7-1,0-.2.5-.7.6-1.5.5.6.4.7.8.5,1.5.4.1.4.3,0,.5-2.8,1.4-3.5-2.9-2.6-4.8.7.3,1.2.2,1.6-.2.9-1.9,1.2-3.3,2.5-5,.9,0,.1,1.6.3,2.4s.5.7.7,1.1Z"
          fill="#0351f2"
        />
        <path
          d="M387.6,159.3c.1.3.4.7.5,1l-.2.5c-.2-.2-.5-.4-.8-.5-.4.3-.7.1-1-.5,0-.2,0-.4.3-.5.4,0,.9,0,1.2,0Z"
          fill="#0233ea"
        />
        <path d="M387.1,160.3l-.5,1c-.2-.4-.6-1.1-.5-1.5.5,0,.7.4,1,.5Z" fill="#035ff6" />
        <path d="M388.1,155.3c.2.7-.3,1.3-1,1.5v-1.5s1,0,1,0Z" fill="#0137ee" />
        <path d="M388.6,159.3c.2,0,.4,0,.5,0l-.2.5-.2-.5Z" fill="#0233ea" />
        <path
          d="M381.1,148.3l-1.5-1c1,.2,1.3-1.4,1.8-1.5s2.6,1,2.7,1.2c.7,1.4-2.5-.5-2.5,1.2-.2,0-.4,0-.5,0Z"
          fill="#0246ef"
        />
        <path d="M376.1,147.8l-.5.5c-.1,0-.4,0-.5,0,.2-.4.7-.4,1-.5Z" fill="#046cf7" />
        <path
          d="M375.6,156.8c0,.3-.9,1.9-1,2-.1,0-.3,0-.5,0-1.1,0-.9-.4,0-1-1.1-1.3.3-1.6,1.5-1Z"
          fill="#037bf8"
        />
        <path
          d="M367.6,149.3c.4,0,.7-.1,1-.5.5-1.6,1.8-.8,1.5.5-.5.5,0,1.4,0,1.5,0,0-1.4-.4-1,.7s2.1-.7,1.5,2.3c1.2-.6,1.5-.1,2.5.5.7.1,1.5.3,1.5,1,.3.4.4.7,0,1-1.4.8-2.3,1.6-2.5,2.5,1.2,0,1.3,0,.5,1,.5,0,1-.2,1.5-.5.1-.2.4-.3.5-.5.8.2.9.9,2.5,1v1c-.4-.6-1.3-.4-1.5.3s1.2-.1,1,.7c-1.8,0-2.9-.6-2.5,1.5-2.3-1.1-1.2-.2-1.5.5-.6.7-1,.7-1,0-.4.5-1.2.8-1.5,0-1-.7-.7-1.2,0-2-.9.4-2.2.2-2-1q1-.5,0,0c-.8.8-1.5.4-2-1-.3.3-.6.2-1-.5-1.1.5-1.2-1.4,0-1.5-.3-.5,0-.6.5-.5.5-.2.7,0,.5.5.4,0,.7.4,1,1l.7-1.1c-1.4-1.5-1.2-2.6.8-1.9q1.6.4,0,0c-1.1,0-1.4,0-1-.5,1.5-1.4,1.3-1.4-.5,0-1.2.9-2.8,1.6-3.5,0-.4-.1-.4-.3,0-.5.3-.5.5-1,.5-1.5-1.2.8-1.8.8-2,0-.4-.2-.4-.3,0-.5,0-.8.8-.7,1.5-.5.2,0,.4,0,.5,0s.7.7,1,.5l.5-1c0-.1-.4-.7-.5-1,.7-.2,1.1-.6,1-1,.9-.6-.2-1.3,1.5-.5Z"
          fill="#037bf8"
        />
        <path d="M379.1,158.8c-.3.2-.7.9-1,1-.3-1-1.1-2.2.2-2,.4.2.5.6.8,1Z" fill="#0576f5" />
        <path d="M380.1,163.3c.4.5.1.7-.5.5-.3,0-.7,0-1,0,1-1.2.9-.8,1.5-.5Z" fill="#0370f7" />
        <path d="M384.6,163.8c0,0,.4-1.1,1-.5s-.4,1.3-.5,1.5v-.7s-.5-.3-.5-.3Z" fill="#0239ef" />
        <path d="M384.1,164.3l-.5-.2.5-.2c0,0,0,.4,0,.5Z" fill="#0249f4" />
        <path
          d="M372.1,158.8c0-.3-.6-.8-.5-1.2.3-.8,1.6-.4,1.5-1.3l-2.5-1.5c2.2-.5,1.9,1.2,4,1.5.2-.4.3-.4.5,0,.1-.4.3-.4.5,0v.5c-1-.2-1.2.8-1.5,1-.2.7-1.4,1.3-2,1Z"
          fill="#0364f6"
        />
        <path
          d="M269.2,87.9c0-1.9,1.2-1.5,3.5,1,.7-.8,1.1-.5.5.5-.4,1.3-1,2.6-2,3.5.2.9,0,1.3-.5,1-.6-1.5-1.4-3-2-4.5l.5-1.5Z"
          fill="#1d70d8"
        />
        <path
          d="M274.7,101.9c.5.7,1.2,1.3,2,1.7.5.8,1.4,2.8.5,3.3.4.1.4.3,0,.5.4.2.4.3,0,.5,0,.3,0,.7,0,1-2-3-3.1-6.7-4.5-10,.1-.4.3-.4.5,0,.9.1,2.3,2,1.5,3Z"
          fill="#1872d4"
        />
        <path
          d="M271.7,93.9c1.5.2,1.8,1.2.5,2,1.6.5,1.6,1.7,1,3h-.5c-.7-1.7-1.3-3.3-2-5l.5-1c1.3-.4,1.3,0,.5,1Z"
          fill="#1b69cf"
        />
        <path
          d="M269.2,87.9c.2.7.5,1.3.5,2l-1-.5c0-.1,0-.4,0-.5l-.5-1c-.3-.8-.3-1.3-.5-2l-.5-.5c0-.1,0-.3,0-.5-.3-.5-.3-.8,0-1,1.6-1,3.6,3.2,2,4Z"
          fill="#1b5fbb"
        />
        <path
          d="M265.2,75.4c2.4-1.4,2.3,2.7,0,1,1.4-.2,1.5.2.5,1,1,.3,1,.7,0,1,.2.2.2.3,0,.5,1.5,0,1.7,1.6.5,2.5.3.3.3.7,0,1-.7-1.7-1.8-4.2-2-6,.2-.7.6-.6,1,0-.6,0-.8-.4-.5-1,.1,0,.4,0,.5,0Z"
          fill="#3c5eb7"
        />
        <path
          d="M267.2,82.9c1.4.2,1.2.5,0,1,0,.3,0,.7,0,1-.8-.6-.7-1.7-1-2.5.1-.4.3-.4.5,0,.7-.6,1-.3.5.5Z"
          fill="#3572bf"
        />
        <path
          d="M265.2,76.4c-.3,0-.7,0-1,0,0-.1,0-.4,0-.5.1-.4,0-.4.5-.5.2.3.3.7.5,1Z"
          fill="#2e418f"
        />
        <path
          d="M238.7,71.9c0,.1,0,.4,0,.5-.2.2-.8.3-1,.5-.4.5-1,.5-1.5,1.5l-2.1,2c1.2,1,.2,4.4-1.4,3-.2.4-.3.4-.5,0-2.9,2-3.8-.6-1.8-2.7-.2-.7-.3-1.2.3-1.8v-1.1c-.1,0,4-.9,4-.9,0-1.3,3.1-1.7,4-1Z"
          fill="#4b6ad7"
        />
        <path
          d="M236.2,74.4c-.7,1.4-1.3,4.2-2,6-.8,1.7-2.5.5-1.5-1,1.1,0,1.7-.6,1.5-1.7s-2,.3-1.5-1,2.4-2.2,3.5-2.3Z"
          fill="#425fcd"
        />
        <path
          d="M234.2,80.4c-.4,1-.5,2-1,3-.7-1.7-1.3-.5-2.2-.6s-.6-.8-.8-.9c-2-1.1-.8-2.3,1-2l1-.5c.1,0,.4,0,.5,0,.4.3.5,1.2,1.5,1Z"
          fill="#3e6bdb"
        />
        <path
          d="M239.2,70.9c-.2.3-.3.7-.5,1-1.4,0-2.7.5-4,1-4.6,1.5-9.2,2.5-14,2.9-.8,1.7-2.4,1.4-3.1-.2-1.3.4-2.1.2-2.4-.7.5-.9,1.4-.9,2.2-1,5.7-.7,10.3-1.6,15-2.2s4.9-.5,6.7-.8Z"
          fill="#697ae0"
        />
        <path
          d="M271.2,75.9c1,0,1.3,0,2,0,1.6.9,2.7,2.4.5,2.5.7,1.2-.3,2.2-1.5,1.5-1,1.4-1.8,1.4-2.4,0-1,0-1.6-.1-1.6-.5-1.5.3-1.6-1.2-.5-2-.5-1.1,0-1.4,1.5-1,.1-.2-.1-.9,0-1,.2-.2.8.7,1.2.8s.6-.3.7-.3Z"
          fill="#4b7be4"
        />
        <path
          d="M269.2,76.4c-.1.2-1.3.9-1.5,1,0,1.1-.7,1.1-2,0,0-.1-.4-.7-.5-1,.3,0,1,.2,1-.2,0-.2-.9-.7-1-.7l1.7-1.5c.9,1,.3,2.4,2.2,2.5Z"
          fill="#446cd7"
        />
        <path
          d="M282.2,75.9c0,0,.2.7.7.8,1.2.3,3.8-.7,3.8,1.2l.7-1,1.2,1.5c-.3,1.1-1.2,1.4-2.7.9-2.3-.9-4.1-.7-6.3-.2s-.5-.3-.5-.7l-1.4.4c0,.8-.2.8-.6,0,0,1.6-3.2.8-3.5-.5l.5-1h-1.5s.5-1.5.5-1.5c2.7,0,7-.5,9,0Z"
          fill="#5682e8"
        />
        <path
          d="M279.2,78.4c.3,0,.9.1,1,0s-.7-1.3-.5-1.5c1.6,1.8,2.8.7,3.2.7,2.7.4,2.8,1,5.7.8s.7,0,1,0c.3.3.7.3,1,0,3.3,0,3.2,2,6.1,1.6l3.9,1.4c0,.2,0,.3,0,.5,1.8.8,2.2,2.6,0,2-.6.8-1,.5-1-.5-.1.4-.3.4-.5,0-.1.4-.3.4-.5,0-.7,1.4-1.9.1-2.7-.8-2.1,0-4.6-.6-7-1.6l-.2-1.2q0-.8,0,0c2,1.3-.2,2.3-2.1,2-1.8-1.3-3.4-1.4-5.4-.9-.2-.9-.7-1.3-1.5-1.1-.3.4-.8.2-1.5-.5-1.1,1.5-1.2-1,1-1Z"
          fill="#5287ec"
        />
        <path d="M290.7,78.4c.3,1.6-1.3,1.5-1,0,.3,0,.7,0,1,0Z" fill="#5682e8" />
        <path
          d="M305.7,82.9c.8,1,1.7,1.5,2.6,1.4l.4.6h.5c0,0,.6.1.5.5-.9-.4-1.4.4-1.5.5.5,0,1,0,1.5,0,.8.1.4,1,0,1.5-1.3,1.3-2.7-.2-1.5-1.5.3,1.3,0,1.5-1,.5-.4,1.4-.5,1.3-1,0-3,2.3-2.2-2-1.9-1.4.8,1.8-4.2,1.8-3.6-1.1,1.1-.4,0-1.5,0-2,1.6.5,3.3.6,5,1Z"
          fill="#4684ec"
        />
        <path
          d="M316.7,87.9c.4.4,4.6.6,5.5.5-1.5,2.2,1.9,2.1,3.6,2.6s1.2.9,1.8,1.1.9-.2,2.1.3c-1.1.6-2.2.9-3.5,1l-1-.5c-.5,1.3-.8,1.2-1.5,0-.9-1,1.8-.8,1.7-.7-1,.3-2.8.5-3.2-.8-.4.8-.8.9-1,0-.8.2-1.4-.4-1.9-1.6-1.9,1.5-5.2-.2-2.6-1.9Z"
          fill="#407ae8"
        />
        <path
          d="M313.2,87.9c.9-.1,1.7.1,2.2,0s.1-.9.6-1c1.2-.3.6.9.7,1v2c1.7.5,1.4-1.6,3.2-1s.6,2.1,1.3,2.5c.6,1.5-1.2,2.2-1.7.5-1-.3-2.1-.6-3.3-1-1.1.3-1.6-.4-1.5-2-1,1.1-1.9.4-1.5-1Z"
          fill="#418af2"
        />
        <path
          d="M308.2,85.9c-.3,1.4.6,1,1.5,1.5.7.2,1.4.4,2,.5.2,0,.3,0,.5,0,1.5.4,1,3.4-.5,3.5-1,1.1-2,.4-1.5-1,.6-.7-.2-1.2-2.5-1.5-.9,0-1.1-1.8-.5-2.5.3,0,.7-.4,1-.5Z"
          fill="#3c92f3"
        />
        <path
          d="M313.2,87.9c.4.4,1.1.6,1.5,1,.7,1.8,1.2,4.2-1.5,3-.5.3-1.1,0-1.5-.5l.5-3.5c.3,0,.7,0,1,0Z"
          fill="#3181ed"
        />
        <path
          d="M309.7,85.9c2.1,0,0,1,.5,1.5,1.2-.2,1.7-1.1,1.5.5-.2,0-.6.5-1.2.4s-.7-.8-.8-.9v-1.5Z"
          fill="#397ae3"
        />
        <path d="M305.7,82.9c.3,0,.8-.1,1.2,0s0,1.7,1.8.5v1.5c-1.5.2-2.9-.3-3-2Z" fill="#4a7be7" />
        <path
          d="M333.7,99.9c.5-.3.8,0,1,.5,0,.5-.2.3-.5.5l-1.5,1c-.3.5-.8.3-1.5-.5-.4.8-.6.6-.5-.5-.9.5-1.1-.3-.5-1-.3-1,.2-.8,1-.5.3,0,.7,0,1,0l.5-.5c.4.3.6.7,1,1Z"
          fill="#147cf3"
        />
        <path
          d="M333.7,101.9c.5.2,3.1,1.1,2.5,1.5-.8,0-1.2-.2-1,.7l.5.3c-.2.1-.3.4-.5.5-.4,1.6-2.9-.3-3-1.5-.8-.5-.5-1.6.5-1.5.5-.5.8-.5,1,0Z"
          fill="#147cf3"
        />
        <path d="M334.2,100.9l-.5,1c-.2-.1-.8.1-1,0,.7-1.1.9-.6,1.5-1Z" fill="#2593f8" />
        <path
          d="M332.7,101.9c-.2.3-.2,1.1-.5,1.5.5,3.1-5.5.4-1.4-1.1l.4-.9c.1-.3.6-.5.5-1h.5c0,.5,0,1.2.5,1.5Z"
          fill="#2593f8"
        />
        <path
          d="M334.2,99.4c-.1-2.2,2.3-1.8,2.6.5,1.4.2,4.8,1.4,2.7,1.4l.8.6c.2-.3.3-.3.5,0,.5-.8,1.5-.6,3,.5.4.3.9.4,1,.5.2.8.9,1.8,1,2.7,0,.5-.8.1-1,.3,0-.4,0-1,0-1.5h-1.5c1.1,2.9-1.3,0-1.5,0-1.8.8-2.4.8-3.9-.4-.7.2-1.5.3-2.1.4-.8.5-1.8-1.5-2-2.5-.5-.2-.3-.5.5-1-.6-.5-.5-.7.5-.5-.4-.2-.6-.6-.5-1Z"
          fill="#1d75ef"
        />
        <path d="M345.2,106.4v.5c-.2,0-.9.7-1,.5,0-.9-.2-1.1.5-1.5,0,.4.1.4.5.5Z" fill="#1d75ef" />
        <path
          d="M335.7,104.4c2-1.6,2.6-1.3,4,.5-.2-1.3,0-2.8,1.5-2s-.8,1.3.5,1.5c0,0-.3.4-1,.5.4,2.2-2,1.5-3.4.6-.9.4-1.6.3-2-.1-.4-.1-.4-.3,0-.5-.5-.7-.3-1,.5-.5Z"
          fill="#2386f5"
        />
        <path d="M334.7,100.4c-.5,0-.7-.2-1-.5.1-.2.3-.4.5-.5.5,0,.6.6.5,1Z" fill="#368ff5" />
        <path d="M340.7,101.9h-.5c.1,0,.1-.4.3-.4s.2.4.2.4Z" fill="#326fe8" />
        <path d="M335.9,100.9c.3.2.3.3,0,.5v-.5Z" fill="#2a75e9" />
        <path
          d="M329.2,96.9c.2,0,.5,1.4,2,.5l-1,1.2,1,.7c0,0-.6.4-1,.5.2.3.2.6.5,1,.8,1.2-.8,2.5-1.5,1.5-1.6,1.3-2.7-.1-1.5-1.5-1.4-1.2,1.5-2.6,2.5-1-2.6,0-3.5-.9-2.5-2.5-.7-.7-.4-1,.5-.5.2,0,.8,0,1,0Z"
          fill="#2787f5"
        />
        <path
          d="M332.2,99.4c-1.3-1.8.3-1.9,2-2-.2.7-1.1.9-1.5,1.5s0,.7,0,1c-.4.1-.4-.5-.5-.5Z"
          fill="#378af0"
        />
        <path
          d="M316.2,90.9c3.5-1.2,2.8.6,3.8,1s1.1-.5,1.2-.5c.3,0,.7,0,1,0,.5.5,1,1,1.5,1.5.5,0,1,0,1.5,0,.4.1.4.3,0,.5-1.7,2.6,1.1.3,3,.5v3c-.1,0-.3.4-.5.5,0,.5-.2.4-.5,0-1.2,1.3-3.7,2.5-3.1-.4,1.2,0,1.4-.2.6-.5l-2.7-.6c-1.1,1.1-1.9.8-2.3-.9v-1c-2.2.2-3.4-1.2-3.5-3Z"
          fill="#2f7eed"
        />
        <path d="M326.2,93.4c-.3,0-.7,0-1,0v-.5c.4,0,.9,0,1,.5Z" fill="#3e83f0" />
        <path
          d="M354.7,127.4l.5-1.8c2.8.4,5.8,1.5,8.5.8.2.8-.9.3-1,.7s0,1.7.8,1.2,1-1.5,1.3-2c.1-.3.3-.3.5,0,.7.6.7,1.4-.1,2.6.9.5.5,1.7-.4,1.9,1.8,2.8-1.7,3-2,.5-.4-1.3-2.7.2-1.5,1.3,2.4.7,1.3,1.5-.5,2.2.4.1.4.3,0,.5-.4.9-1.3,1.1-2.7.6-1.6,1.2-5,.9-3.3-1.6-.4-.6-.2-.8.5-.5l.5-.5c-.4-.2-.4-.3,0-.5-.1-1.2-.7-1.8-1.8-2.1.5-2,1.6-2.9,3.3-1.4-.2,1.6,1.4-1.2,0-.5-.4.3-1,0-1-.5-.3-.3-.7-.6-1-1-.1.4-.3.4-.5,0Z"
          fill="#0476f5"
        />
        <path
          d="M362.6,131.3c-.2,0-2.6-.2-1.5,1s2.3.2,1.6,1.9-1.2.6-2.1.7v-1.5s1.5.3,1.5.3c-.3-.8-1.9-.7-2-.8-.5-.5,2-3.5,2.2-3.5.6,0,1,1.7.3,2Z"
          fill="#025af2"
        />
        <path
          d="M357.2,128.9c.1-.6.2-.9.2-1.5l2.8.2-2.8,2.7c-1.4.1-.4-.4-.2-1s0-.3,0-.5Z"
          fill="#0261ef"
        />
        <path
          d="M358.2,132.3c.1-.4.3-.4.5,0,0,.3,0,.7,0,1-3-1.4.1,1-2.2,1.5-.2-1.3.1-3.5,1.7-2.5Z"
          fill="#058cf7"
        />
        <path d="M360.8,129.6c-.3.3-.4,1.9-.7,0l1.3-1.7c1.4,1,.1,1-.6,1.7Z" fill="#025af2" />
        <path
          d="M355.2,127.4c.3,0,.7-.8,1.5-.5l-.5,1.5c-.3,0-.8.1-1,0-.3-.1-.3-.3,0-.5v-.5Z"
          fill="#015cea"
        />
        <path d="M358.2,132.3c-.8-.9-.5-1.9.7-2,.1.5-.1,1.5-.2,2h-.5Z" fill="#0261ef" />
        <path d="M355.2,133.8c.1-.2.4-.4.5-.5l-.5.5Z" fill="#0382f8" />
        <path
          d="M354.7,122.4c0,.7-.8.7-1,0,0-.1,0-.4,0-.5s.7-.7,1-1c-.1-.2,0-.4.5-.5.1-.4.3-.4.5,0-.2,1-.8,1.4-1,2Z"
          fill="#0783f6"
        />
        <path d="M355.7,120.4h-1c0-.3,0-.8,0-1l1-.5c0,.5,0,1,0,1.5Z" fill="#0158ea" />
        <path d="M354.7,122.4c0,.3,0,.7,0,1-.2,0-.3,0-.5,0-1.5,0-1,0-.5-1h1Z" fill="#034fe5" />
        <path
          d="M352.7,134.3c-.1,0-.3,0-.5,0-1.7-2.6,1-1.7,1-2.5,1.3.5-.6,1.4-.5,2.5Z"
          fill="#0495fa"
        />
        <path d="M353.7,129.4c-.1.3.3.9-.3,1s-1.5-.1-2.2,0v-.5s2-.5,2-.5h.5Z" fill="#0262f6" />
        <path d="M355.2,132.8c-.2,0-.4,0-.5,0l-.5-.3v-1.2c.7.1.9.9,1,1.5Z" fill="#0255ef" />
        <path d="M353.2,131.8c-.2,0-.7,0-1,0v-.5c.5,0,1-.1,1,.5Z" fill="#044def" />
        <path d="M355.2,128.4l-.5-.2.5-.2c0,.2,0,.5,0,.5Z" fill="#0476f5" />
        <path
          d="M367.6,130.8c0,0,.2.7,0,.9-1.1.9-2.5.8-2.4-.9.1,0,.3,0,.5,0,.3,0,1.7.5,2,0Z"
          fill="#0250ed"
        />
        <path d="M368.1,128.9c0,0-1.4.4-1.5.5-.2-1.2,0-1.1,1.2-1l.3.5Z" fill="#0241eb" />
        <path
          d="M350.7,110.9c.3,0,.7,0,1,0l-.5,1c1.8.5,2.5-1.1,4,1-.4.7.5,1.3.5,2l.5-1.2c.8-1.3,1.7,1.4,1.5,1.7-.7.6-2.4,0-2.5,0s-.3,1.1-.5,1.4c-.1,1-.3,2-.5,3.1-.1,0-2.3.2-2.5.1-.9-.5-3.4-5-2.1-5.7.4-.7.7-1.7,1-3-.4-.1-.4-.3,0-.5Z"
          fill="#076ef3"
        />
        <polygon fill="#025ceb" points="354.6 114.4 351.2 116.4 351.2 113.9 354.6 114.4" />
        <path d="M350.7,111.4c-.2,1.4.7,3.4-1,3,0-.3,0-.7,0-1,.2-.8.2-1.5,1-2Z" fill="#1484f8" />
        <path
          d="M385.1,196.8c.3,0,.7,0,1,0,.1.1-.4,1.7-.5,2,.9.6.6,1-.5,1,.9.7-.9,2.7-1.5,3,.5.5.2.7-.5.5-.7-.4-.9,0-.9.8-.8-.8-1.6-.7-2.1.2-.4.2-.9.4-1.5.5-.1.3-.3.3-.5,0-.2.8-1,.9-1.6.5-1.8-1.2-.4-1.9-.7-1.3s-.4.2-.7.3c-3.7,1.7-2-5.2,1-3,.2-.4.3-.4.5,0,.6,1.2.7,1.2.5,0-.5-.1-.4-.3,0-.5.4-.6,1.7-1.6,2.5-1,.8.6,1.3.6,1.5,0,.1-.4.3-.4.5,0,.5-.4,1-1.1,1.5-2,0-1,1.2-1.1,2-1Z"
          fill="#035cf5"
        />
        <path
          d="M385.6,185.8c-.2-1.3.2-1.5,1-.5,0,.2.5.7.5,1l1.3,1.2c1.7-.4,4.9.5,2.2,1.3-.3.2.2.4,1.5.5v1c-.2.8-1.4.4-2,0,0,0-.2-.5-.5-.5-1,1.9.5,1.4.5,1.7s-.5.6-.5.8c-.5,1.5-2.2-.9-2-1.9-.7.6-1.6,1-2.5.9-.8-.3-1-.9,0-1-.4-.6-.6-1.2-.5-2l-1,.5c0,.7-.7.7-1,0-.3-.3-.3-.7,0-1-.3-.2-.3-.3,0-.5,1.5-.5,1.9-.8,1-1-.4-.1-.4-.3,0-.5-.3-.1-.3-.3,0-.5.6-.4,1.8-.3,2,.5Z"
          fill="#055cf7"
        />
        <path
          d="M384.1,194.8c-.4-.4-.3-1,.5-1.8-.1-.2-.3-1.5-.2-1.6.2-.1,3.6-1.2,3.9-.6s.6,2.6-.7,2c-.7.6-.4,1.4.5,1.5,0,.3,1.1,1-.5,1.8s-1.6-.5-3.5.2c0,.6-.3,1.1-1,1.5-.7.6-.8,1.2-.9,2.1h-.6c-.4-.2-.4-.4,0-.6-.3-.1-.3-.3,0-.5-1.3,0-1.4-.6-.5-1.5-1.9.7-2.4-1.6,0-1.4l.6-.6c0-.8.9-.9,1.5-.5.1-.4.3-.4.5,0,.4.3.9.3,1.5,0q.9-.4,0,0c-.4.2-.8.2-1,0Z"
          fill="#035df6"
        />
        <path
          d="M385.1,191.3c.6,0,2-2.5,3.2-2.5s-1.5,3.8,1.2,3.5c0,.5.7,1.8.5,2-2.3.5-1.1-.9-1.6-1.4s-.7,0-.9,0c0-.1.6-.9.5-1-.3-.3-2.2-.5-2.7,0s-.3,2.4-1.3,3c-.1.3-.3.3-.5,0-.1,0-.3,0-.5,0-.4-.1-.4-.3,0-.5-.3-.1-.3-.3,0-.5.4-1,0-1.4-1-1.5-.8-2.1,2-3.1,3-1Z"
          fill="#034ff4"
        />
        <path
          d="M387.1,199.3c.3-.6,1.7-1.4,2-.5.4.2.4.5,0,1,1-.8,1.1-.6,1.5.5-.3.2-.6.8-1,1,.3,1.2-.6.2-.5.2,1.6-.1,2.4,3.2-1,1.8-.2,1.3-.6,1.3-1,0-.7-.4-1.4-1.1-1.5-2-.4-.4-.5-.9-.5-1.5.1-.3.4-.7.5-1h.5c.5-.3,1,0,1,.5Z"
          fill="#0552f5"
        />
        <path
          d="M384.1,196.3c.3.1.7.4,1,.5-.4.8-1.3.7-2,1,0-.3-.2-1,0-1.4s.7,0,.9-.1Z"
          fill="#0a71f6"
        />
        <path
          d="M387.6,186.3c1.3,1.7,3.7-.7,4,2l.5-.5c.2.3.5.5.5,1-.6.4-1.4.4-2,0,.1-.2.6-.9.5-1l-4,.5c0-.6,0-1.4,0-2h.5Z"
          fill="#0343f0"
        />
        <path
          d="M394.6,201.3c.7,1,1.2,1.9,2,3.2s2-.2,0,1.6c2.1.2-.2,2.5-.7.2l-.3,2c.2,1,0,1.6-.7.8s2.8,0,.2,1.2h-.5l-.5.5c-.7,0-1.5-.5-2-1-.5,0-.6-.3-.5-1-.8-1.1,0-2.3,2.5-3.5v-1.6c-1.4-.4-1.3-3.8.5-2.4Z"
          fill="#0348f4"
        />
        <path
          d="M394.6,201.3c-.6.4-1.2.5-1,1.5,1.9-1,2,2.8.5,2.5l-2.5,3.5c-.1.4-.3.4-.5,0-3.3.7-4.7-2.3-2-4h.5c.3,1,1,2,1.5,1,.1-.1,2,.6,3-.5.2-.8-.7-.2-1-.9s-.2-2.2,0-3.1c-.7,0-1.3,0-2,0,.9-1.4,2.5-1.4,3.5,0Z"
          fill="#0230ee"
        />
        <path d="M394.6,207.3c-.1.7-1.6,1.9-2,1.5-.8-.7,1.1-1.6,2-1.5Z" fill="#032df0" />
        <path
          d="M392.1,209.8c-.1.2-.5.4-.5.5-1.7.6-2.1-.9-.5-1.5h.5c.8,0,.4.9.5,1Z"
          fill="#0124eb"
        />
        <path d="M394.1,210.8s.3-.5.5-.5l-.5.5Z" fill="#033cf2" />
        <path
          d="M371.1,140.3c-1.2,1.1-3.4.3-5,.5v-.5c.6.2,1.1-.4,1.5-.5s1.9-.5,2-.5c.6,0,1.1.8,1.5,1Z"
          fill="#0351f1"
        />
        <path
          d="M368.6,133.8c.6.5.8.5.5,0h1.5s-1-2-1-2c1,.4,2-.2,3,.2,2.3,1.1-1.3,2.5-.5,3.3l2.5-.8c-.6.2-.9,1.6-1,1.7-.2.2-1.7-1.3-1.4.3l3,1.8s.5.2.5.5c-.5.4-2.3.6-2.5.8-.4.3,0,.9-.5,1.2-1,.4-1.5.2-1.5-.5-.9.3-1.7,0-1.5-1-1.3.1-1.4,0-.5-1,.2-.8,0-1.5-.5-2-.6-.4-1.2-.4-1.8,0-1.7-2.6-1.7-4,.2-4,.8-.9,1.3-1,1.5-.5,0,.6,0,1.4,0,2Z"
          fill="#025df4"
        />
        <path d="M368.6,136.3c.4.3,2.1-.2.5,2-.3-.7-.6-1.2-.5-2Z" fill="#0241e7" />
        <path d="M369.1,133.8l.5.3c-.2,1.5-.8,1.3-1-.3h.5Z" fill="#0f75f3" />
        <path d="M373.6,138.8c-.6.3-1.7-.8-1.5-1,.6-.3,1.7.8,1.5,1Z" fill="#024bec" />
        <path
          d="M365.6,136.8l.5,1c.5,0,1-.3,1.5-.5,0,.3,0,.7,0,1-1-.8-1,1-1.3,1-.8.1-1-.4-1.2-.5q.5-.3,0,0c-.9-.3-1.8-.4-1.5-1.5.2-.1.3-.3.5-.5,0,0,1.4,0,1.5,0Z"
          fill="#0356f1"
        />
        <path d="M365.6,141.8c-.5,0-1,0-1.5,0,0-.8,1.5-.8,1.5,0Z" fill="#0150eb" />
        <path d="M367.6,139.3c0-.3,0-.9,0-1,0,.2.8.5,0,1Z" fill="#0351f1" />
        <path
          d="M372.1,145.8c.3.3.5.5.5,1-.2,0-1.4,0-1.5,0-1.2,0-.2.7.7,1.4l-.2.6-1,.5c-.2,0-.3,0-.5,0s-1-.9-1.5-.5.3,1.3-.7,1-.1-.4-.3-.5c.2-.3.9-.4,1-.5.1-.2.6-1.9.5-2l-1.5-.2c.5-.8,1.3-.4,2-.8s.7-.8,1-1c.8,0,1.9.2,1.5,1Z"
          fill="#0361f5"
        />
        <path d="M366.1,149.8c2.1,1.4,1.2,1.8-1,1s-.4,0-.5,0c.2-.9,1.1-.8,1.5-1Z" fill="#035fee" />
        <path d="M364.1,146.8c-.5-.5.9-2.3,1.5-.7s-1.3.9-1.5.7Z" fill="#098ef7" />
        <path
          d="M376.1,143.3c.5-1.4,1.5-3.4,3.5-.5v.5c.7-.2.8-.2.5.5-.2.4-1,1.9-1,2-.4.4-2.2,2-3.2.6-.7.9-2.5,1-3.3.4-.7-.2-1.1-.4-.5-1-.4-.3-.3-1.8-.2-1.9s1.3-.7,1.6-.9,0,.7-.3-.2c-.3-.9,1.3-1.5,1.5-.5.3.9.4,1.9,1.3,2.5.6-.1,0-1.2.2-1.5Z"
          fill="#0461f7"
        />
        <path
          d="M377.6,140.3c1,.5,2,1.1,3,1.5-.2.4-.7.7-1,1s-1.4-.5-1,1.5l-1-2.5c-.9-.2-.3.9-.6,1.4s-.8,0-.9.1v-2.5c2.3,1.1,1.2,0,1.5-.5Z"
          fill="#0244ef"
        />
        <path
          d="M372.6,146.8c2.8-.1,1.9-1.3,3.7-1.5s.1.9.2,1c1.6.8,1.5-2,2.5-.5,0,.1.6.9.5,1s-2.4.5-3.5,1l-1,.5c0,.5-.2.4-.5,0-1-.2-1.1-.3-.5-.4-1.4.6-3.6.6-3-1.1.1-1,1-.7,1.5,0Z"
          fill="#0252f2"
        />
        <path d="M380.1,143.8l-.5-.5c.3-.1.7-.4,1-.5,0,.5-.4.7-.5,1Z" fill="#0244ef" />
        <path
          d="M373.1,142.8c2.5,0-1,.9-1,3-.4-.4-1.1-.6-1.5-1,.7-.6.8,0,1.5,0l-1-1.5c.7,0,1.3-.3,2-.5Z"
          fill="#0252f2"
        />
        <path d="M373.6,146.3c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#0252f2" />
        <path d="M365.6,136.8c.3,0,.7,0,1,0-.1,0-.3.8-.5,1-2.1.2-2.3-1.1-.5-1Z" fill="#0479f3" />
        <path d="M367.6,130.8c.2-.3-.3-1.4.2-1.5,2,1.9,0,1.3-.2,1.5Z" fill="#034cf2" />
        <path d="M366.6,136.8c0,0,.8-.8,1.5-.5v.5c-.4,0-1.2-.1-1.5,0Z" fill="#0356f1" />
        <path
          d="M364.1,254.3c.7-.6,1.9-.6,2.5.5.4.1.4.3,0,.5.2.5.2,1,0,1.5-.4.3-.4.6,0,1,.5.2.6,0,.5-.5-.1.3-.3.3-.5,0-.4-.2-.4-.3,0-.5.4-.7,2.7-.3,2.5.6l.5.4c-1-4,4.9-2.7,2-.5.1.3.5.3,1,0-.9-1.2-.8-1.7.5-1.5l2.5,1-1,2c-.1.4-.3.4-.5,0,0,0-.6-.8-1-.5s-.8,2.2.5,2.3v.7c-.5,0-1.1.2-1.5.5-1.3.5-2.3-.2-3-2-.4-1.3-1.6,1.4-1,3,.4.1.4.3,0,.5-.2,1.5-1.8,1.8-2.5.5-2,1.1-3-.7-1-1,.2-.5.2-1,0-1.5-1.5-.5-1.2-1.7-.5-2.7-.9-.3-.8-.7.5-1.3-.2,2.1-2,1.3-1.9-.3s3.5-1.7,1.9.3c.2-1.7-.6-1.3-1.8-.3l-.7-1.2c-1.3-.2-.9-2.2.5-2,.8-.8,1.3-.6,1.5.5Z"
          fill="#0348f4"
        />
        <path
          d="M362.1,255.8c.8.2.9.2,1,.8s0,2.2-1,1.7c-.5.2-.8-.1-1-1,.8,1.2,1.2,3.4-.5,4,1.2.1-.1,1.2-.7.9s-1.5-6.3-1-6.3c.8,0,2.2.6,2.2,1.4-1-.7.3-3.6,1-1.5Z"
          fill="#0348f4"
        />
        <path
          d="M364.6,257.3c0-.1.2-1.1-.2-1l-1.3,1.5c.4.1,1.4-.3,1.5-.5-.1,1.2,0,2.7,0,4,.5.2.5.7,0,1.5,0,0-.7.4-.5,1h1.5s.3,1,.3,1c-.6-.6-1.5-.2-1.8.5-.3,0-.7,0-1,0,0,.7-.8.7-1,0,.7-1.8,3.2-3.9,0-4.5-.8-.4-.5-1.8.5-1.5q.9-.4,0,0c-.9,1.1-1.4-.4-.5-1,.7-.4-.3-1.9,0-2.5s.7.3,1.1.2c1.2-.2,2.4-1.5,2.3.6s-.8.7-.8.7Z"
          fill="#0357f7"
        />
        <path
          d="M362.6,253.8c-.5,1-.4,1.9-.5,2s-1-.7-1,1.5c-.2-.1-1.2.3-1-1-1.2-.7-.7,5.4.3,5.5s.2-.4.2-.5c.6-.7.8-1,1,0,0,0,.6.3,0,.7s-2.4,1-2.5.8c0-1.3.2-1.9-.5-3-.5.1-.6,0-.5-.5-1.2-.5-1.3-1.6-.5-3.2-2.1-1.7-.4-2.7,1.4-1.2.7,0,1.2-.5,1.5-1.7-.8-.6,1.9-2.4,2.5-2.2,1.5.5.9,3.1-.5,2.7Z"
          fill="#0357f7"
        />
        <path
          d="M378.1,263.3c-.4.5-1.8,2-1.9,2.1s1.1,1.5-2.1,1.4c-.6-.7.3-3.8.5-4s2.5,1.9,3.5.5Z"
          fill="#0233ee"
        />
        <path
          d="M367.1,272.8c.5,0,1,0,1.5,0l.5-1c.8,1.4-.4,1.9-.5,3-.2,0-.6-.7-1-.3-1,.9.3,4.9-2.5,1.8,2.7-.3-.2-.7,0-2l1.5,1c.4-2,2.1-1.6-.5-2.5.3,0,.7,0,1,0Z"
          fill="#0234ed"
        />
        <path d="M382.6,261.8c.2-.2.8.5.2.5s-.4-.4-.2-.5Z" fill="#0232ec" />
        <path
          d="M380.1,261.8c0-.2-1.5-.7-.5-2,.9,0,.8,1.3,1,1.5.5.6.5-1.9,1.5-1s.5,1.4.5,1.5-.4,0-.5,0c-.8.6-1.5,1.2-2.5,1-.2-.1.5-.8.5-1Z"
          fill="#0232ec"
        />
        <path
          d="M364.6,269.3c.5-.8.7-2.2,2-2-1.3,1.1.9,3.5.5,4-.7.8-1.2-.7-1.5-1s-.9-.4-1-1Z"
          fill="#0232ec"
        />
        <path
          d="M373.1,269.3c0-1.6-.8-.5-1-1.5,1.3-.2,3.5-1.6,3,1-.1,0-1.7.4-2,.5Z"
          fill="#0233ee"
        />
        <path
          d="M376.1,268.8l-.5-1.5c1.8-.3,2.4.1,2.5,2-.3,0-.8,0-1,0-.3-.6-.4-.4-1-.5Z"
          fill="#0233ee"
        />
        <path
          d="M369.1,268.8c.5-.8.8-.9,1,0,0,0,.5.3.5.5-.6.2-2.7.3-3,0-1.6-1.5,1.2-.6,1.5-.5Z"
          fill="#0957f3"
        />
        <path d="M382.6,262.8v.5h-1c.1-.7.5-.5,1-.5Z" fill="#0232ec" />
        <path
          d="M378.1,256.8c.1.2.4.4.5.5.9,2.5-.4,2-1,2.5.1-.3.6-.9.5-1-.8-.4-1.7.5-2,.5.1-.3,1-2.3,1.1-2.3.3-.3.8,0,.9-.2Z"
          fill="#0349f3"
        />
        <path
          d="M374.6,258.8c.5.1.8.5,1.5.5,0,.2.1.9,0,1s-3.2-.6-2.5-1.2l.5-.3c.1,0,.3,0,.5,0Z"
          fill="#0349f3"
        />
        <path
          d="M386.1,234.3l-2.5.5c.2.7,1,.9,1.5,1.5-2.3.3-2.3,3.9.5,3,0,.3-.5.5-.5.5,0,.6-2.6.8-3,0,0-.3-.6-.3-1.5,0-.1.7-.8.5-1.1,0-1.2-1.2-1-2.2.6-2.6-.1-1,0-1.5.5-1.5l1.9-.7c-.7-1.9,3.3-2.7,3.6-.8Z"
          fill="#044bf2"
        />
        <path
          d="M393.6,244.3c-.7.2-.9,1.4-1.3,1.5-1.6.5.5-2.5-1-2.5s-.9,1.9-.8,2.5l-1-1.5c.7-.6.5-1.5,2.2-1.5s1.2.9,1.8,1.5Z"
          fill="#0448f3"
        />
        <path
          d="M385.1,239.8c0,.2.6.9.5,1s-.7,0-1,0c-.4-.2-.8-.2-1,0-.2,0,0,.4-1,0s-.7-.3-1-.5c-.5-.6-.3-.9.5-.5h3Z"
          fill="#0235ef"
        />
        <path d="M388.6,238.3c.7-.5,1.4-.8,1,.2s-.7.1-1,.3v-.5Z" fill="#0a5bf6" />
        <path d="M384.6,240.8c-.3,0-.7,0-1,0l.3-.5.7.5Z" fill="#020cdb" />
        <path
          d="M377.1,247.8c.2-.1.4-.9.9-1,.7-.1,2.1.6,3.1,0l-1.5,3c1.1-.7,2.3,0,3,0v1c-.4.4-1.2.7-2.2.7-1.1,1-1.9,1.2-2.1.5-.6.8-.8.6-.9-.4-.8.4-1.3-.3-1.8-.9-.8-.5-.4-.8.5-1l.2-.4c-1,0-1.3-1.4-.2-1.6.1-1.3.5-1.3,1,0Z"
          fill="#0237ed"
        />
        <path
          d="M375.1,244.3c.7-.8,1.1.8,1.5,1.2s.9.2,1,.3c.2.2-.5,1.5-.5,2-.2,0-.7,0-1,0-1,.4-1.8-.7-1-1.5,0-.5-.1-1.9,0-2Z"
          fill="#0357f7"
        />
        <path
          d="M389.1,248.3c.3-.5,1.8-2.2,2.5-1.5.5,2.3-1.3,1.5-1.4,1.6-.2.2,0,.8,0,.9-.1,0-.4,0-.5,0-.5.4-.7,0-.5-1Z"
          fill="#0339f0"
        />
        <path d="M389.6,249.3c-.3.2-.3.5-1,.5,0-.5.2-1,.5-1.5l.5,1Z" fill="#0f59f3" />
        <path d="M390.6,250.3c0,0-.5-.2-.5-.5l.5.5Z" fill="#0339f0" />
        <path d="M391.1,252.3c.5-1.3,1.8-1.6,1.5,0-.5,0-1,0-1.5,0Z" fill="#0339f0" />
        <path
          d="M382.6,250.8v.5c-.1.1,0,1.3-.8,1.5-.5-.5.9-1.2-.5-1s-1.5.7-2.2,2c-.3.7-.7.7-1,0,.2-.9,0-.9-.5,0-.1.4-.3.4-.5,0v-2c-1.1.4.2,1.5-2,.5-1.4-.4-.9-1.5.5-1.5,1.6-.7,2.1.9,2.2.9,1.4,0,3.4-1.4,4.8-.9Z"
          fill="#0549f4"
        />
        <path d="M399.6,254.8l.5-1c0,0,0,.6-.5,1Z" fill="#022fec" />
        <path
          d="M404.1,224.8c.1.2.3.4.5.5,0,.1,0,.7,0,1-.3,0-.7,0-1,0-.2-.3-.6-.3-1,0-.3.3-.4.9-1,1,0-.2,0-.3,0-.5-.4,0-.4-.3,0-.5-1.5-.9-2-2.3,0-2,.1,0,1.6-.4,2.5.5Z"
          fill="#022ae9"
        />
        <path d="M405.1,226.8c0,0-.3.5-.5.5v-1c.2,0,.4.3.5.5Z" fill="#022ae9" />
        <path
          d="M408.6,222.8c1.6-.3,1,.8.5,2s-.6,1-.7,1c-.5,0-.1-.8-.2-1,.5-.6.3-1.4.5-2Z"
          fill="#021fe3"
        />
        <path
          d="M405.1,223.8c.3-.7,1.1-.5,1.5,0,.7,0,.7.8,0,1-.8-.2-1.6-.5-2.5-.5.3-.7.5-.4,1-.5Z"
          fill="#022ae9"
        />
        <path
          d="M407.6,224.8c-.3,0-.7,0-1,0v-1c-.4-.1-.4-.3,0-.5.2,0,.9-.7,1-.5v2Z"
          fill="#021fe3"
        />
        <path d="M405.1,225.3h-.5s0-.4.2-.5l.2.5Z" fill="#043cf1" />
        <path d="M406.1,225.8l-.5-.5c.4.2.4,0,.5.5Z" fill="#022ae9" />
        <path d="M404.6,216.3c0,.4,1.2,1.5-.2,1s-.2-.6-.3-1h.5Z" fill="#0230ee" />
        <path
          d="M397.1,219.8c2.3,2.6,1.8-1.2,4.5-.5,0,1.1-2,.8-2,1.2,0,1.6,2.3.4,2,2.2-1,.1-1.6-.8-2.5-1s-.5.5-.8.5-.2-1-.5-1c-.4,0-2.4,1.4-2.8,1-.3-.8.5-1.5.5-2,0-1.5.5-1.6,1.5-.5Z"
          fill="#043cf1"
        />
        <path
          d="M399.1,222.8c.2.2,1.5-.5.5,1,.8-.2,1.4.4,2,.5-1.2,1.3.5.9.5,1.2s-.5.5-.5.8c-.5.6-1.6.7-2,0l-2-1.5,1.5-2Z"
          fill="#043cf1"
        />
        <path
          d="M396.1,216.8v1.5c1.5-.2,1.7,0,1.5,1.5-.1,0-.4,0-.5,0-.5.2-1.1.3-1.5.5l-.7-1.3c-3.2,1.5-1.7-4.8,1.2-2.2Z"
          fill="#022eec"
        />
        <path d="M406.6,223.3v.5c-.5,0-1.1,0-1.5,0v-.5c.6-.8,1.4,0,1.5,0Z" fill="#0442f5" />
        <path d="M407.6,218.8c.2.2-.5.8-.5.2s.4-.4.5-.2Z" fill="#0230ee" />
        <path
          d="M392.6,221.3c.8.5.9,1.2,1.1,1.4s.9-.4.9-.4c0,0-.1.7,0,.9l1.9.3c-1,1.5-1.3.9-2.5.8s-1.3.1-1.5,0,.7-2.3,0-3Z"
          fill="#0234ee"
        />
        <path
          d="M399.6,226.3c.6,0,1.3,0,2,0,0,.2,0,.3,0,.5-.5.3-1,.4-1.5.5s-.8,0-1.2,0c-.6.3-.6.7-.8.9h-.5v-.5c-1.4-.3-.8-.9.5-1,.4,0,.9-.4,1.5-.5Z"
          fill="#0225e6"
        />
        <path d="M398.1,228.3c-.9.9-.7,0-1,0h1Z" fill="#033eef" />
        <path
          d="M398.1,226.8c-.6.2-.4.7-.5,1s-.6,0-.5.5c-.6,0-2.4.2-1.5-1s2.4-.5,2.5-.5Z"
          fill="#033eef"
        />
        <path
          d="M258.7,402.2c.5-.7,1-.7,1.5,0,0,.5-1.3,1-.9,1.9s2.3.8,2.4.9c.3.1.6.9,1,1.2.8-.6,1-.5,1,.5v.5c-.1,0-2.1,1-2.5,1.3.8.2,2.7,2,.8,2.2-.3-1.4-1.4-1.7-1.7-2.1s1.1-2,0-1.9c-.9,2.1.7,3.1,1,5-.7-.3-1.2-.5-2-.5,0-.7.6-1.3.5-2-1.6,1.2-2-1.2-4-1.5,0-.2,0-.3,0-.5-.5-.7-.3-1,.5-.5,1.2-.7,0-2.8-1-3-1.6-2.2,1.1-1.1,1.5-2.3s-.9,0-1-.5c-.3-1,.8-.8,1-1.2,1.8-2.7,2.2.8,2,2.5Z"
          fill="#02389f"
        />
        <path
          d="M268.2,396.7c1.7,1,2.9,2,0,2-.3-.5-.7-1-1-1.5s0-.8-.5-1c.1-1.6,1-.5,1.5.5Z"
          fill="#0134a2"
        />
        <path
          d="M268.2,409.7c1.2.2,1.2,1.2,0,1.5l-2,1c.1-.8,1.3-.7,1.5-1.8s-1-.2-1-.5.5-.6.5-.7c.4,0,.9.5,1,.5Z"
          fill="#023ea6"
        />
        <path
          d="M268.2,409.7c.3,0,.9-.7,1.5-.5-1,1.5,1.9.7-1,2.5,0-.1-.5-.3-.5-.5,0-.4,0-1,0-1.5Z"
          fill="#02318f"
        />
        <path d="M273.2,399.7c0-.3,0-.7,0-1l.3.6-.3.4Z" fill="#023ea6" />
        <path
          d="M265.7,376.7l2.5,1.5c.8-1-.1-4.8,0-5,.4-.5,4.5.7,2-2l2,.5c.1.1-.4,1.7-.5,2-1.6.8-2,2,.3,1.9.8.3.7,1-.3,2.1.4.1.4.3,0,.5-.4.4-.9.6-1.5.5-.7.7-1,.4-.5-.5h-.5c1.3.7-.3,3.9-1.5,4,.7.6.4.9-.5.5-2.1,1.2-6.4,1.4-3.5-1-.4-1.2-.7-2.1-.5-3.5l-1.5.5.5-3c1.2.6.7,2,2.5,1.5l.2-2.5c1.3.8,1.6.4.8,2q-.7,2.2,0,0Z"
          fill="#0345be"
        />
        <path
          d="M263.7,381.7c0,0,.9.2.5,1s-1.4-1.3-1,.5l4-.5c.3,1.6-2.2,2.7-3.5,1.5-1.7.7-2.6,0-2.5-2,.2-.2.5-1.2,1-1s.4,1.5,1.5.5Z"
          fill="#033ab3"
        />
        <path
          d="M270.2,378.7c.9-.6,1.7.8,1,1.5-.1.8-.7,1-1.5,1-.2.3-.6.2-1,1.5l-1-.5c1-1.4,1.1-2.4,1.5-4,.1-.4.3-.4.5,0,.2.2.4.4.5.5Z"
          fill="#023db9"
        />
        <path d="M265.7,376.7v2s-1,0-1,0c-.2-.2.4-1.9,1-2Z" fill="#0352cb" />
        <path d="M266.2,379.2s.2,1.1-.2,1c-1.4-.8-.3-1.6.2-1Z" fill="#0352cb" />
        <path d="M269.7,378.2h-.5c0-.4-.2-1,.2-1,.5,0,.1.8.2,1Z" fill="#034cc7" />
        <path
          d="M245.7,382.2c.5.1.4.3,0,.5.2.3.4.7.5,1v.5c0,.3.2.2.5,0,.2,0,.3,0,.5,0-.1,2.2,0,2.2.5,0,.2,0,.8.7,1,.5.8-.9,0-3.3,0-3.5s.8,0,1,0c.2-.2.3-.2.5,0,1.5.7.1,1.9,1.5,3,.6.5.3,1-1,1.5l1.3-1c.7-2.4,1.4-3.2,2.2-2.5.4.1.4.3,0,.5.3.4.8.6,1.5.5.7,0,1.3,0,2,0,.2.2-.4,1.5-.5,2-.3.5-.6,1-1,1.5.1-1,2.2,0,2.3.4.4,2.5-4.4,1.9-2.3-.4.5,1.4-.8,2.4-2,1.5-.1.3-.3.3-.5,0-.2.9-.7.8-1,0-.4-.1-.4-.3,0-.5-.8-.8-.5-1.1.5-.5l.5.5c-.2-1.5-1.3-1-2,0,.4,0,.6.2.5.5.4.1.4.3,0,.5.3,1,.3,1.8,0,2.5-.2.3-.6.3-1,0-.5-.4-.9-.3-1-1.3s.4-4.1.5-4.2c-.1.2-.4.3-.5.5l-2.6,2.1-.4-.6c-2.8.3-6.6.7-4.5-4-.4,0-.4-.3,0-.5.5-.4,1-.9,1.5-1.5.3-.1.7-.4,1-.5.8-.1.9.2.5,1Z"
          fill="#034ec1"
        />
        <path
          d="M246.2,374.2c.8.3,1.9,1.1,3,1.5.7-.7,1.2-.4,1,.5.1,0,.3,0,.5,0,.8.3.2.8-.5,1,.3.7-.2.9-1,1l-2-.5c-.6-1-.6-.9,0,.5,2.5,1.1-.9.5-1.8.7s-.7.8-.7.8c-.1.8-.9.9-1,0-3.1,2.4-5-2.6-1-2,.6,0,.6,0,0-.5-.9-.5-.6-2.1.5-2v-1.2c1.1.8,1.5.8,1.5.2.1-.4.3-.4.5,0,0-1.2.7-1.1,1,0Z"
          fill="#0342c5"
        />
        <path
          d="M254.2,381.7c.4.1.4.3,0,.5-1.1-.5-1.4,1.9-1.5,2.3s1.2-.2,1,.7c-.5.2-2.9.4-3,.5.3-.4.7-1.1,1-1.5.9-1.4-.1-1.2,2-3,.7-.5.9-.2.5.5Z"
          fill="#0240b6"
        />
        <path
          d="M247.2,382.7c.4.1.4.3,0,.5-.2,0-.7.4-1,.5-1.8.2-.5-.5-.5-1,.4-.2.4-.3,0-.5,0,0-.8-.4-.5-1,.9-.3,1.8.8,1.5-1.5h.5c0,1,.7,2.1,0,3Z"
          fill="#0243b8"
        />
        <path
          d="M247.2,377.7c0,.2,0,.3,0,.5l-1.7-.5c.7-.3.6-2,1-2,1.9,0,.8,1.6.7,2Z"
          fill="#0359d0"
        />
        <path
          d="M251.7,378.2c.5,2.1,2.5-.4,2.5,1.2-1.6,1.4-1.9,1.6-3-.2-.2-.5-.2-.8,0-1h.5Z"
          fill="#023bb8"
        />
        <path d="M246.2,384.2c.2,0,.3,0,.5,0-1.6,3-4.6.7-.5,0Z" fill="#013eb9" />
        <path
          d="M250.2,377.2c.2-.3.3-.3.5,0,.3.1.3.3,0,.5.3.1.3.3,0,.5-.3.3-.7.6-1,1-.7.7-1,.4-.5-.5,0-.1,0-.4,0-.5.4-.6-.7-.6,1-1Z"
          fill="#0238b7"
        />
        <path
          d="M244.7,379.7l.5.2c-.7,1.1-1.3,1.2-2.5,1.3-1.4-.9-.3-1.4,1-1.5.3,0,.9,0,1,0Z"
          fill="#0243b8"
        />
        <path
          d="M253.7,381.2c.7-.6.8-2.3,1.8,0h.7c-.2.3-.2,1.1-.5,1.5-.1.4-.3.4-.5,0l-1-1c-.2,0-.4-.3-.5-.5Z"
          fill="#034ec1"
        />
        <path d="M247.7,384.2l.2,2.5c-3.6-1-.3-.3-.7-2.5.2,0,.3,0,.5,0Z" fill="#023eb7" />
        <path
          d="M244.2,381.7c.3,1.1-.6,1.1-1.5,1.5,0,0-.5-.1-.5-.3-.3-1.2.6-.6,1-.7s.7-.4,1-.5Z"
          fill="#0243b8"
        />
        <path d="M249.7,379.2c-.4.5-.7,1.4-1.5,1.5-.5-1.2.9-1.8,1-2l.5.5Z" fill="#0342c5" />
        <path d="M249.7,381.2c.3-.2.4-1.2,1.2-1,.7,0-.2.9-.7,1h-.5Z" fill="#0135b8" />
        <path d="M247.2,382.7c.8,0,1.2-.2,1,.7-.2.7-.9-.2-1-.2v-.5Z" fill="#034ec1" />
        <path
          d="M251.2,378.2v1c-.3-.4-.3-.4-.5-1s0-.3,0-.5c.1-.3.3-.3.5,0,0,.2,0,.3,0,.5Z"
          fill="#0354d0"
        />
        <path d="M255.7,378.7c-.1,0-.4,1.1-1,1-.3-1.5.6-.8,1-1Z" fill="#0366d2" />
        <path
          d="M255.2,382.7h.5v.5c0,0-.6.7-1.2.5-1.3-.4-.3-.9-.3-1,0-.7.8-.7,1,0Z"
          fill="#023cb5"
        />
        <path
          d="M252.7,372.7c.5.5,1.9.9,2,1.3.4,1.2-1.6.8-1.9,1.3s0,1,0,1.4h-1c-.1,0-.3-.2-.5.5-.1.3-.3.3-.5,0-.2,0-.3,0-.5,0l.5-1c1.7,0,.7-.7,1-1.6s.7-1.2,1-1.9Z"
          fill="#0354d0"
        />
        <path d="M253.2,371.7l.5-.5c0,.3-.5.4-.5.5Z" fill="#034fd0" />
        <path d="M252.7,376.7c-.2.8-.4.4-1,0,.2-.1,0-.9,1,0Z" fill="#0350c7" />
        <path d="M251.2,377.7h-.5v-.5h.5c0,.1,0,.3,0,.5Z" fill="#0350c7" />
        <path
          d="M268.7,383.2c0,.3,0,.7,0,1-.2,1,0,1.8-.7,2.3-1.3.8-1.3-.8-1.8-1.8,2.5.5.2-1.4,2.5-1.5Z"
          fill="#033cb8"
        />
        <path
          d="M263.7,384.2c.2.2.3.7.7,1,.6.4,1.6,0,1.8,1-3,.6-2.3.4-3.5-2,.3,0,.7,0,1,0Z"
          fill="#033cb8"
        />
        <path d="M265.2,393.2c.2,0,.4,0,.5,0,.2,0,1.4.5,1.5.5-.3,3.8-7.4-.5-2-.5Z" fill="#0247ba" />
        <path
          d="M268.2,391.7c.3-1.1,1.9.1,1.5,1-1.2-.2-2.4.2-3-1.5.7-.2,1,.3,1.5.5Z"
          fill="#0247ba"
        />
        <path
          d="M270.2,392.7c-.2,0-.3,0-.5,0-.2-.9-.9-.8-1.5-1l.2-1.5c.6.7,2,1.5,1.8,2.5Z"
          fill="#0336a7"
        />
        <path d="M268.7,394.7l-.5-.5c.3,0,.4.5.5.5Z" fill="#023bad" />
        <path
          d="M274.7,377.2v.5c-.3,0-.9-.7-1-.5-.2,1.9,1.4,2.8,2.5,4-.2.5-.5,1-1,1.5-.2,0-.3.4-.5.5-.4.1-.9-.2-1.5-1-1.6.2.4,3.8-2,3.5-.6,0-.7-.5-.5-1,0-.8,0-1.8,0-3,1.1-.2,1.4-.5,1-1-.5-1.2-.5-2,0-2.5,0-.2,0-.4,0-.5-.4-2.8,2.5-2.7,3-.5Z"
          fill="#023db9"
        />
        <path d="M276.2,381.2c0,.2.6.8.5,1s-1.1.3-1.5.5l-.5-1.5h1.5Z" fill="#034dbf" />
        <path
          d="M271.7,378.2c0,.6,1,1.5,0,2.5-.5.1-.7,0-.5-.5,0,0-.7-1.1-1-1.5v-2c.8-.2.5,1.2,1.5,1.5Z"
          fill="#034cc7"
        />
        <path d="M270.7,386.2l-1,.5v-1.7c.1-.3.4-.2.5-.3,0,.5.2,1,.5,1.5Z" fill="#023bad" />
        <path
          d="M270.7,381.7c.1.2,1.8,4,0,3,0,0-.4,0-.5,0-.2-1,0-2-.5-3,.3-1.2.6-1.2,1,0Z"
          fill="#023bad"
        />
        <path
          d="M271.2,380.2c.2.2.3.3.5.5s1.5,0,1.5,1l-1.5,1.3-1-1.3c0,0-.7,0-1,0v-.5c.3-.7,0-1,.2-1.5l1.3.5Z"
          fill="#0350c3"
        />
        <path d="M274.2,380.7c-.2.2-1.3-.9-1-1.5.2-.2,1.3.9,1,1.5Z" fill="#034ec4" />
        <path
          d="M265.2,397.2c-.9-1,1.1-1.2,2,0,.9-.3,1.9.7,1,1.5.5.4,1,.6,1.8.3,0,.5.2.9.7,1.2.5-1.2,1-1.2,1.5,0,.4,0,.4.3,0,.5q-.6.9,0,0c.3-1.3.6-1.3,1,0,.7,0,1.7-1.4,1.5.5-1.3.3-.4,1.5-.8,2-.6.8-1.9.4-1.2,3-1.8-1.1-4.5.7-2.2,1.5s1.3-2.6,2.2-.2-2.4,0-2.5,1.2c-.4.8-3.3.3-1.5-1,.1-.9,0-.9-.5,0,.9.9,0,1.6-1,1-1.5,1.9-2.6-1.3-1.5-3-.2-.3-.3-.3-.5,0,1.5,1.7-.1,3.9-1.5,1.5-.4-.1-.4-.3,0-.5-.5-1-.8-1.2-1-.5-.6.3-3.5-.5-3.9-1.1-1.3-1.7,0-2.4,1.4-2.9-1.7-.3-.7-2.1,1.1-1.2.2-.9.7-1.5,1.4-1.8.2-.7.9-.7,2,0q.7-.8,0,0c-1,.8-1.9-.9-.5-1.5,0-.2.4-.4,1-.5Z"
          fill="#023ea6"
        />
        <path
          d="M262.7,399.2c-1.1.7,0,3.4-3,2-.2.1.5.8.5,1-.7.2-.8.4-1.5,0,1-1.1,1.1-4.2,2.2-1.5.3-1.4,1.7-1.4,1.8-1.5Z"
          fill="#0349b2"
        />
        <path
          d="M265.7,405.7h-.5c0-1-.6-1.9,0-3l-2,.5c-.1-.7,1.4-1,1.8-1,1.8,0,.6,2.5.7,3.5Z"
          fill="#02329c"
        />
        <path d="M269.2,404.7l.5-2h.7c1.6,1.1.4,2.2-1.2,2Z" fill="#01349b" />
        <path
          d="M264.2,397.7c-.7.7-.5,1.2.5,1.5l.2-1c1.7,1.5,0,.8-.2,1s-.1,1.5-1,1.5c.2-.8,0-2.1-1-1.5.7-.6-.3-.9,1.5-1.5Z"
          fill="#0244b5"
        />
        <path d="M272.2,400.7c0,.6.8,2.8-.5,3,0-.7-.8-2.6-.5-3s.8,0,1,0Z" fill="#01349b" />
        <path d="M263.7,406.7c-.5,0-.7-.2-1-.5l-1-2.5c2.2.3,2.7,1,2,3Z" fill="#023597" />
        <path d="M268.7,407.7c0,0-.3,0-.5,0l-.2-2c1,0,1.4.9,1.2,1.7l-.5.3Z" fill="#023597" />
        <path d="M270.7,399.7c-.4,0-.5-.1-.5-.5l.5.5Z" fill="#023ea6" />
        <path
          d="M271.7,373.7c1.9-.2,1.6.4,3,1,.2.7-.3.5-1,.5-1.7,1.6-5.1.1-2-1.5Z"
          fill="#023db9"
        />
        <path
          d="M271.7,373.7c-.5,1.3-.5.7-1,1.5,1.3-.4,1.7-.6,3,0s2,1.6,2,2.5c0,0-.3,0-.5,0-.3,0-.5-.2-.5-.5-1-1.3-2.3-.8-3,.5.5-2.2-1.5-1.3-2.5-2.2,1.7-.5-.5-1.5,2.5-1.7Z"
          fill="#034cc7"
        />
        <path d="M275.2,377.7c-.2,0-.3,0-.5,0v-.5c.1.2.4.3.5.5Z" fill="#034ac6" />
        <path d="M272.7,376.2c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#023db9" />
        <path
          d="M233.2,336.7c-.2.2-.2.4,0,.5.4-.1.8,0,1,.5.5-.3,1.1-.2,1,.5-.4.9-.4,1.6,0,2,1.5.1,2.1.4,2,.8l1.9,2.8c-1,.6-.7,1.3.1,1.9-.1-.7.3-1.5,1-1.5.1-.4.3-.4.5,0-.2.6-.3,1.3-.5,2,2.1,1.8-1,2.8-2,1-.2,0-.9.7-1.5.5-.1-.1.4-.7.5-1,.4-.6-1.6-1-2-.5.5.5.1.8-.5,1-.8.2-1.2.4-2,0-.8-1.4.8-2.5,2.5-2.5.6-.7.4-.7-.5,0l-1.8,1.4c-.2-.5-.6-.9-1.2-1.4v-.5c.5-.8,0-.6-1.5.5-.4-.1-.4-.9-.5-1,0-.4.1-.7.5-1-.6-.2-.7-.8,0-1,0-2.2.6-.7.3-.3s-.4,0-.8-.2c-.2-.2-.3-.4-.5-.5-.7-.4-1-.9-1-1.5v-.5c-.7-.7-.4-.9.5-.5.9-.3,1.4-1.1,1.6-2.6.3.2.5.3.7.3.7-.3,2.1-.4,2.3-.1.6.1.6.8,0,1Z"
          fill="#034be1"
        />
        <path
          d="M243.7,332.7c-1.8-.5,0-2.6.9-1.9s.7,1.6.7,1.7c.2.9,1.4,1.5,2.8.8l1,.4c1.7-2.8,1.7,1.9-.5,2l1.5,1.2c.3-.7.5-.7.5.1,1-.6,1.3-.6,1,.2.9.3,1,.7,0,1-.3.4,0,.4.5,0,1.1-.8,2,0,.5,1,0,0,.6.8,0,1.3s-3.1,2.2-3.6,1.2c-.5-.4-1-.4-1.5,0,.2.1.2.3,0,.5-.1.4-.3.4-.5,0-.7-.4-1.2,0-1.3,1.2l-.7.3c-.3,1.5-1,.8-1,1.2s1.8.5,1,2.2c1.4,1.9-2.4.5-3.5,0-.8.8-1.3.4-1.5-1-.5-.3-.3-.9.5-2-.9-.5-1-1-.5-1.9s3.1-1.8,2.1-1.2-.4,0-.6,0c-1.5-.2-1.7-.7-.5-1.5-.9-1.4-.4-2.9,1.1-2.4s1,0,1.4-.6c-3.1-.2-2.8-3.6,0-4Z"
          fill="#0357e9"
        />
        <path
          d="M245.2,343.7c.2-1-.1-3.4,0-3.5.7-.6,1.3.2.5,1,.9,0,1.7-.1,1.5,1l-1,2c-.3-.1-.7-.4-1-.5Z"
          fill="#0768eb"
        />
        <path
          d="M248.2,337.3c0,0,.1,1.5.5,2h-2.5c-.4-2,1.2-.2,1.5-.5,1-1.1-1.2-.8-1-1.5.4,0,1.3-.1,1.5,0Z"
          fill="#0240e4"
        />
        <path d="M251.7,338.2c.2,0,.4,0,.5,0,.2,1.8-.6.4-2,.5v-.5c.5,0,1,0,1.5,0Z" fill="#0461f0" />
        <path d="M250.7,339.2c-.4,1.1-.8,1.2-1.5.2l1.5-.2Z" fill="#0461f0" />
        <path d="M247.7,342.2c0,0,0-.3,0-.5l.5.2-.5.2Z" fill="#0768eb" />
        <path
          d="M227.7,352.7c.9.3,1.7,0,2.4-.9l.6.4c.3.2.8.3,1,.5.5.4.7,1.3,1.5,1.7s1.2,0,2,.3c1.5,2.2-.4,2.4-2.5,2-.1.4-.3.4-.5,0-.3.5-1,.2-2-1l-1,.5c-.3.9-1.3,2-2,1-1.4-1.1-1.7-2-.8-2.8-.6-.9-.7-1.6.3-2.2.1-.4.3-.4.5,0,0,.2.4.4.5.5Z"
          fill="#024dd3"
        />
        <path
          d="M236.2,355.2c1.7-1,2.5-.7,2.5,1,.5.6.2.9-.5,1,0,0-.3,0-.5,0-.8,1.1-1.6,2-2.5.5-.2,0-.3,0-.5,0-1.4.2-2-.1-2-1-.5-2.1,1.6-2.2.5-.5,1.2.2,2-.2,2-1.5.4.1.6-.1,1,.5Z"
          fill="#035ade"
        />
        <path
          d="M227.2,357.2c.7.5,1.4.1,2-1,.8-1.6,1.9,2.3,1,3,.5.2.8.5,1,1,.6,1.4,1.9,1.8,3.9,1.3v.7c.1,0,.9,1,.9,1,1.5.2,2.5,1.7,1.7,3,0,1.4-.4,2.2-1,2.5,0,.5-.9,1.9-1,1.4s.5-1.2,1-1.4c.5-.7.9-1.5,1-2.5-.4-2,0-3,1-3,.6-.8,1.6-1.1,2.5-.5v.5c.2,1.2,0,1.2-1,.5.4.9.9,1.8,1.5,2.5.4,1.7,0,2-1,1-.7,0-.5.3.5,1,.8.3.8.6,0,1,1.4.6,2.7.4,3.5-.5.3-1.3.9-1.1,1.5,0,.9.6,1.1,1.2.5,2,.1,1.1-.6,1-1,0q-.2-.2,0,0c.4.1.4.3,0,.5-.5-.1-1.9,1.7-1.5-1h-.5s-.5,1.5-.5,1.5c-.2-.3-.4-.3-.5,0,1.3,1.4,2.4.4,4,1l-.5,1.5c-.2,0-.7,0-1,0-.8-.4-1-.4-.5,0,1,.9,1.5,2.1-.3,1.5s0-1.7-1.2-.5c-.4-.1-.4-.3,0-.5-.8-.3-1.5.1-2.1,1.2-.5-1-.8-1.2-.9-.7.2,1.1-.3,3.6-1.5,1.5-.1-.1-1.1,0-1.5,0l.5-1c-2.6-.7-1,2.8-3.5,3-.4-1,0-2.2.8-3.8l-.3-.7-.5-.4c.8-.6.8-.9,0-1.6-2,1.8-3.7-1.8-1-2.5-.3-.5,0-1.1.5-1.5q.4-.8,0,0c-.3.5-.6.9-1,1,.4,2.1-2.2,2.3-1,.5.4-1.3,0-2.1-1.1-2.5.7-1.1.9-1.6.6-1.5l-1,1c-.1.4-.3.4-.5,0-.8-.7-.8-1.5,0-2.5-.4-.4-.8-.8-1-1-1.2.5-.9-1.3,0-1.5l.5-.5c-.5,0-.4-.3,0-.5l-.5-1-.5.4c.8,2.1-1.9,6.6-2.5,1.6-.7-.7-.4-1,.5-.5.3-.4.3-.6,0-1-.7.6-1,.3-.5-.5l-.2-.8c-2,.1-2.9-1.6-.8-1.7-.5-2.8,1.5-1.9,2.5,0Z"
          fill="#0352d2"
        />
        <path
          d="M244.2,360.7c0,0,.1.9,0,1s-1.2-.4-1,.5l2.5.5c.2.9-.8.3-1,.5s.6,1,.8,1c.2,0,.8-1,1-1,.6,0,.7,2.2,1.5,2.4,1.6.5,4.6-2.1,3.2,1.6l-2-1c1.1,1.8-.5,1.5-.5,1.7,0,1.8,1.8,3.5-2,3.3-.3.7,2.1.5,1,1.5s-1.9-1.5-2-1.5v-.5c.5.3.6.2,1,0,0-.9.3-1.7,1-2.5.8-1.6-1-3.5-3.6-2.4l-.4-.6c-.3,0-.5-.1-.5-.5-.1-.2-.2-.4-.1-.5.8-1.4,1.2.1-1.4,1-.9.5-2.2-.6-1.5-1.5.2-.1.8-.4,1-.5s1.5.3,2,0c-1-2.6,0-1.8,1-2.5Z"
          fill="#0357d9"
        />
        <path
          d="M232.7,356.7c.7.4,1.4.5,2,1-.3,0-.9.5-1.5.5-.5.6-1.7.3-1.5-.5-.8-.2-.3-1.5.5-1,.1,0,.4,0,.5,0Z"
          fill="#0442d2"
        />
        <path
          d="M233.2,358.2c-.1.3-.3.7-.5,1l-1-.5c0,.3,0,.7,0,1-.7.5-1.4.4-1-.5-.7-1-.4-1.5,1-1.5.3.1,1.4.5,1.5.5Z"
          fill="#0352d2"
        />
        <path
          d="M242.7,357.2c1.1-1.1,1.5-1,1,.5-.4.2-.4.3,0,.5.5.1.4.3,0,.5,0,.3-.7.9-.5,1h1.5c-.2.2-.4.9-.5,1-1.3.9-1.5,1.6-.5,1.9.2,1.1-2.5,1.5-2.5.6-.4-.1-.4-.3,0-.5-1-.4-1-.7,0-.7l-.6-.8c-.7,0-.7-.4,0-1-.4-.2-.4-.3,0-.5.4-.9.1-.9-1,0,.3.4.1.9-.5,1.5.7-.4.9-.1.5.5.9.8,0,1.2-1,1h-.7c.3,1.1-.6,1.4-2.8.7v-1.2c0-.5-.5-.6-1-.6-2.5-.1-4.1-.4-1.5-2.4-.8-.6-.6-1,.5-1-.2-.7.3-.9,1.5-.5.1-.4.3-.4.5,0,1.1.2,1.6.2,2.5-.5.2-.4.3-.4.5,0,.7-.6,1.4-.8,2-.5.7-.4,2.7-.6,2.5.5Z"
          fill="#0252dd"
        />
        <path
          d="M243.7,355.7c-.2.6,0,1.1-1,1.5-.4-.2-2.2-.6-2.5-.5v-.5c1.1,0,2.6,0,3.3-1l.2.5Z"
          fill="#035ce7"
        />
        <path
          d="M235.2,362.2c0,.1,2,1.1,2.5,1l-2-1.5c-.2-2.5,2.8-.5,3,1,.4.1.4.3,0,.5-.6,1.4,0,2.9,0,3s-.8-.1-1,0c-.5-1.7-1.2-1.2-1.4-1.6s1.8-1.8-2.1,0c-.1-.6,1-2.4,1-2.5Z"
          fill="#0243cf"
        />
        <path
          d="M232.7,359.2c0,.2.1.5,0,.7-.3.6-1.2,0-1,.8.8.7,3.4-.1,3.5,0s-.1,1.2,0,1.5c-.6-1.5-1.2.5-1.3.5-1.1.1-3.3-1.2-2.7-2.5-.5-.6-.3-.6.5-.5-1.2-1.4.9-2.1,1-.5Z"
          fill="#0245ce"
        />
        <path
          d="M241.2,362.7l-2.5.5c0-.1,0-.4,0-.5.2-.2.9-.4,1-1,.3-1.2,1.5,0,.9.1s-.3-.3,0-.6l1-.5-.5,2Z"
          fill="#0357d9"
        />
        <path d="M237.7,357.2c-.5,1.1-.6,2.7-2,2.5l-.5-2c.8-.1,1.9-.5,2.5-.5Z" fill="#0247d9" />
        <path d="M240.7,359.7c-.3.6-.9.7-1,0,.5-1.2.5-2.4,2-.7-.1.4-.9.6-1,.7Z" fill="#023cd0" />
        <path
          d="M240.7,361.2c0,.4.5.6.5,1-.2.1-1.2-.3-1.5-.5s-.4,0-.5-.5c.4-1,.9-1.3,1.5-1,0,.3,0,.7,0,1Z"
          fill="#0352d2"
        />
        <path d="M240.7,359.7c0,.1,0,.3,0,.5l-1.5,1c0-.5.3-1.1.5-1.5h1Z" fill="#086cde" />
        <path d="M235.2,358.7v1s-1.5,0-1.5,0c.2-.7.8-1.1,1.5-1Z" fill="#023eca" />
        <path d="M243.7,357.7c0,0,0,.3,0,.5-1.4.2-1.4-.7,0-.5Z" fill="#0d73f1" />
        <path d="M253.2,365.2c0-.2,0-.4,0-.5l.5.2-.5.2Z" fill="#0360e3" />
        <path
          d="M260.2,330.2c.4,1,.4.9,0,2l-.5-1.5c-.6-.1-1,1.3-1,1.5-.5.2-.7,1,0,2l-.5.5v.5c-.3-.1-.7-.5-1-.5s-.7,0-1,0h-.5v-.5h1.5c-1-1.3,0-2.4,0-3.5l3-.5Z"
          fill="#0259f1"
        />
        <path d="M254.7,335.2l-1.2,2.5c-1.2-1.2.7-2.4.7-2.5.1-.4.3-.4.5,0Z" fill="#0662ef" />
        <path
          d="M255.7,334.7c.1,0,.3,0,.5,0l-1.5.5h-.5c0-.3,0-.7,0-1,.5.3,1,.3,1.5.5Z"
          fill="#045fee"
        />
        <path d="M254.2,342.2c1.7-.4.8,1,0,1,0-.3,0-.7,0-1Z" fill="#045fee" />
        <path
          d="M258.2,341.7c-.8-.7-1.6-.2-2.5,0l.5-2c0,2,1.4,1.1,1-.5,1.2.5,1.1,1.5,1,2.5Z"
          fill="#0247e0"
        />
        <path
          d="M254.2,359.2v1c0,.2,0,.3,0,.5-.3,0-.7,0-1,0-.8,0-.5-.5,0-1,.4-.2.4-.3,1-.5Z"
          fill="#0f73e6"
        />
        <path
          d="M258.7,332.2c.1,2.4,3.8,3.7,3,4.5s-1-1.9-2-1,0,2.5-1.5,2c.3-1.6.5-1.7,0-3s-1.6-1.7.3-3l.2.5Z"
          fill="#045fee"
        />
        <path d="M249.2,375.7c.3-.7.7-1.2,1.5-1l-.5,1.5c-.6-.1-.8-.4-1-.5Z" fill="#0354d0" />
        <path d="M254.2,364.2h.5l-.2.5c-.3,0-.2-.3-.2-.5Z" fill="#0360e3" />
        <path d="M255.7,364.7l-.5-.5c.4.1.4.5.5.5Z" fill="#0247d1" />
        <path d="M256.7,365.2l-.5-.5c.2.1.5.2.5.5Z" fill="#0247d1" />
        <path
          d="M254.7,230.8c.9-.3,2.8-.4,3,.5,2,.4,5.6,2,7.5,3-1.8,1-4.7-.5-5.2,1.5-1.3-1.1-4.4-3.2-6-3.5s-2.6.5-3.8.4c-3-.3-2.6-1.6-7.4-.9,2.7-2.4,8.8-2.3,12-1Z"
          fill="#01096e"
        />
        <path
          d="M256.2,230.3c.1-.3.3-.3.5,0,.3,0,.7,0,1,0l1,.5c.2,0,.3,0,.5,0l-1.5.5c-.7-.2-2.3-.4-3-.5-.5-.9.9-1,1.5-.5Z"
          fill="#044aef"
        />
        <path d="M256.7,231.8v.5c-2.1.2-2.1-.7,0-.5Z" fill="#010b61" />
        <path
          d="M254.7,259.8c-.2.3-.3.7-.5,1-.2,0-.4-.5-.5-.5-.4-.1-.4-.3,0-.5,0-.9.4-1.1,1-.5v.5Z"
          fill="#0244ee"
        />
        <path
          d="M251.2,254.3c.2-.2.7-.1,1.5.3.9-.7,1.9-.3,3,1.2,0,.2.4.3.5.5-.4.4-.7.7-1,1s-.3.3-.5.5l.4.6c-.7.4-1.1.9-1.4,1.4-.2.2-.5.4-1,.5-1.3-.4-1.4-1.5-3.5-1-.2-.8.7-.4,1-.8,1-1.4-.4-1.8-1-3.4.5-.7,1.2-1,2-.7Z"
          fill="#0244ee"
        />
        <path
          d="M241.2,252.3c1.5.4,3.8-.1,4,0s.3,1.6.5,2c.5.1.4.3,0,.5l.5.5c0,.9-.3,1.3-.5,2s-.5.4-.5.5c-.1.4-.3.4-.5,0-.2-.1-.2-.3,0-.5l-2.1-1.3c-1.6.7-2.3-.2-1.9-1.7v-.5c-.3-.3,0-.6.5-1,0-.2,0-.3,0-.5Z"
          fill="#023fdf"
        />
        <path
          d="M251.7,252.8c.3.2.4,1.4.5,1.5.4.3,1.9-2.1,3.5,1.5l-3,2-.3-1.5c1.4-.2,1.7-.4,1.7-2-1.9,1.7-2.2.2-3,0l-.5-1.5c.2-.4.8-.4,1,0Z"
          fill="#0250f3"
        />
        <path
          d="M249.7,252.3v.5c.3.1.3.3,0,.5-.9.2-1.5-.6-1.7,1s.9,1,1.2,2c-.9,0-1.7-.6-2.5-1-.7-.7-.5-1.1.5-1,.4-1,.1-.7,1-1.5,0-.4,0-.5.5-.5.2,0,.7,0,1,0Z"
          fill="#023fdf"
        />
        <path
          d="M250.7,252.3c.9,0,1.6-.5,2.5-.5-.1.7-.9.9-1.5,1-.1,0-.7,0-1,0v-.5Z"
          fill="#0330dd"
        />
        <path
          d="M247.2,254.3c-.1.3-.4.7-.5,1-.1,0-.4,0-.5,0l-.5-.5c0-.1,0-.4,0-.5.3-.2.4-1,.7-1s.4.8.7,1Z"
          fill="#045ded"
        />
        <path d="M257.7,254.8c-.6,1.8-.5.6-1,1l-.5-1h1.5Z" fill="#0220c8" />
        <path d="M248.7,252.3c-.2.2-.3.3-.5.5l-.5-1.5c.6,0,.8.9,1,1Z" fill="#0250f3" />
        <path d="M241.2,252.3c-.3,0-.7,0-1,0,0-.3.5-.9.5-1h.5c0,.3,0,.7,0,1Z" fill="#0254ef" />
        <path
          d="M232.7,255.3c-.1.3-.5.8-.5,1,1.6.1,1.3.9.5,2-.2.3-.3.3-.5,0,.2.6,0,.8-.5.5-.5.3-1.6,0-2-.5-.1-.6-.2-.9-.5-1.5.2-.2.3-.9.5-1,1.2-.9,2.5,1.4,2-2,.8-.2.3.9,1,1.5Z"
          fill="#0337d3"
        />
        <path d="M229.7,255.8c-.2.2-.8-.5-.2-.5s.4.4.2.5Z" fill="#0229ba" />
        <path
          d="M240.7,254.3c.2.1.4,1,.8,1s1-.5,1.4-.5.8,1.9,2.8,1c.2.1-.8,1.1-1,1.5-.2.2-.2.4,0,.5h.5c-.2.8-.5,1.7-.5,2.5-.6,0-1,.3-1.5.5q-1.6-.6,0,0c-.9.5-2.1,1-2.5,2-.3-.4-5.1-.2-5.5.5-.2-.3-.5-.5-.5-1v-2.5c-.3-1.1.5-1.5,1-.5l.5-.5c.3,0,.8,0,1.5-.5,0-.1,0-.3,0-.5.2-.6.1-1-.6-1.3,1.3-.4,2.3-1.2,3.1-2.2.2,0,.4,0,.5,0Z"
          fill="#0254ef"
        />
        <path
          d="M234.7,255.3c0,0-.8-.1-.5-1,1.8,1,2.6-.7,4.5-.5l-1.7,2c1.7.4,2-1.6,3.2-1.5v3s-2-1-2-1l-.5,1.5c0-.3.1-.6,0-.9h-2.2c-.6-.4,1.2-2-.7-1.6Z"
          fill="#0241e4"
        />
        <path
          d="M234.7,255.8c0,.7-.2.6-.5,1l-.5.5c-.4.6-.7,1.3-1,2-.5.8-.8,1-1,0-.4-.2-.4-.3,0-.5.2-.3.5-.5.5-.5.2.2.4.2.5,0,.1-.3-.5-1.4-.5-2l2.5-.5Z"
          fill="#0241e4"
        />
        <path d="M241.2,252.8c0,.3-.4.7-.5,1l-1-.2,1.5-.8Z" fill="#0254ef" />
        <path
          d="M243.7,309.8c.7-.7,1-.4.5.5q-.2.2,0,0c.3-.9.7-.9,1,0,.1.7.6.5,1.5-.5.2,0,.4,0,.5,0,.8.2,1.1,1.3,1,2,1,0,.6.4,0,1q-1.8.5,0,0c.2-.8.4-1.2,1-.5-.1,1,.4,1.2.5,1.5.5.8,2,1.6,2,1,0-.5.8-.8,1-1h.5c.1,0,.3,0,.5,0,.3,0,.8-.5,1-.5,0,.5-.6,1.4-.5,1.5s1.9-.4,2.5,0l-.5-1c.7-.2,1-1.3,2-1-1.1,2.4,0,1,.5,1.3s.6.9,1,1.2c0,.1,0,.7,0,1l-1,.3,1,.5c-.5,1.3-2.1,1-2.5,1.3-.4.2-.6,0-.5-.5,0-.4-.1-.5-.5-.5-.3,1.4-.7,2.9-1,4.5,0,.3.3,1,.5,1l-1,3.5c-.2,0-.4,0-.5,0-.9.6-.9.7,0,.5.3,1.5-.9,1.1-2,.5,0-.8.5-2,0-3,1.6,1.4,1.2.9,2.5-.5-2.4.3-3.6-2.2-4.6-2.6s-1.4.2-1.9.1c1.5.3,1.7,1.7,2,2-2.6,2.1-6.6-1.9-2-2l-1-.2c-.6,1.8-1.1,2.4-1.5.2-.9.9-2.1,1.4-3.5,1.5,3,.7,2.4,3.3,0,2q-.8-.7,0,0c1.3.2,1.2.5,0,1-.1.3-.3.3-.5,0-.2.9-.9,1.4-1.5.5-.1.3-.3.2-.5,0l-.5-1.5c-.7-.5-1-.9,0-1,.6-.2.8-.6.5-1-.4,0-.4-.3,0-.5.8-1.1,1.7-1.6,2.5-1.5.4-.2.9-.3,1.5-.5.6.2,1,0,1-.5-.4-.1-.4-.3,0-.5.8-.7,1.1-1.2,1-1.5-.6-.3.3-1.9,1-2,1-.8.7-.8-1,0-.3.3-.6.3-1,0-.5-1.5.4-.6.2-.5-2.8.4-2.4-.6-1.2-2.5-.9-.4-1.7-1.6-1-2.5,0,0,.9-.5,1-.5Z"
          fill="#0351f4"
        />
        <path
          d="M249.7,311.3c0,.4-.5.9-.5,1-.3.2-.7.3-1,.5,0,0,0-.7,0-1,.9-1.8,1-.6,1.5-.5Z"
          fill="#0243f2"
        />
        <path d="M253.2,313.8c0,0-.1.4-.2.5l-.3-.5c0,0,.2-2.4.5,0Z" fill="#0563f8" />
        <path
          d="M259.7,294.8c0,.9.5,2.3.4,2.4-.1.2-.9.2-1.2.6-.5.5.3.9.3,1,.5,1.1.3,1.6-.5,1.5-.2,2.9-2.5,3.9-5,3.5,0,.9.3.8,0,2-.4.7-.9,1.1-1.5,1-.5.2-.7,0-.5-.5-.7,0-.5-.4.5-1-.8-.3-.8-.7,0-1l.6-1.9c-1.2,0-1-.3,0-1.1.7-.4.7-.6,0-.5-.1.4-.3.4-.5,0-1.5.2-1-1.2,0-1.9-2.7-.8-3.2-4.2,0-2.6,1.2.7,2.2,1.2,3.6.4l.4.6c1.6,1,2.5-1.1.4-1.5.2-2.6,1.8-2.4,3.1-1Z"
          fill="#0457f7"
        />
        <path
          d="M253.7,303.8c0-.4-.1-1.3,0-1.4s2.8-1.2,2.9-1.1c.9.8-1.9,1.7-2,2.3.8.7,1.8-1.2,3-1.5-.4-2.1-1.8-.6-2.5-1.7l2.2-1,.3,1.5c.5.2.9-.5,1-.5.2,0,.7.4,1,.5-.3.5-1.3.9-1.5,1.8-.1.5.7.1,1,.2.5,0,.7,0,.5.5v.5c-.5.5-.8.7-1,0-1.9-.5-3,1.4-5,0Z"
          fill="#0345f3"
        />
        <path d="M253.2,306.8c-1,.8-.8.1-1,0l1.5-1c0,.3-.4.7-.5,1Z" fill="#0354f7" />
        <path
          d="M258.2,292.3c0,2,1.6,1.2,2,1.5s-.5.8-.5,1c-.5,0-1.8-.1-2,0-1.5,1.2.9.7,1,.7,1.4,1.3,0,1-.5,1.6-.8,1-2.9,3.1-2,.1q.8-.6,0,0c-2.9.8-2.3,0-4-1,1,.3,2.3.6,3,0s.3-.6.5-1c.9,0,1-.1.5-.5,0-.2-.7-.7-.5-1s2.3-1.5,2.5-1.5Z"
          fill="#033df2"
        />
        <path
          d="M252.2,296.3c-.7-.5-2.3-.3-2,.7s2.4.3,3,1.6-1.9,1.3-1,2.2c0,0-.3.8-.9.4s-1.3-2-2.1-2.2l1.5-1.2-2-.5c.2,0,.4-.1,1-.5v-.5c2.3-1.9,1.9-.2,2.5,0Z"
          fill="#0345f3"
        />
        <path d="M252.7,300.8c2.7-1,2,.8,0,.5v-.5Z" fill="#0345f3" />
        <path d="M255.7,299.3h-1.5s0-1,0-1c.7-.2,1.3.3,1.5,1Z" fill="#033df2" />
        <path d="M256.2,297.3c.2-.7.8-1.2,1.5-1-.1.8-.9.8-1.5,1Z" fill="#065af5" />
        <path d="M252.2,289.3l.5-.5c-.1.4,0,.4-.5.5Z" fill="#034cf5" />
        <path
          d="M231.2,295.8l.8-.3c-.8-2.4,3.3-1.5,2.6.3-.8.5-1.2,1.3-.9,2.6.6.5,2.5.4,2.5,1.7l-2.5-.7c.2.8.4,1.1,0,2,.5.7.3.9-.5.5-.6,1.3.1,1.3,0,2.2s-1,.3-1.1.6c-.2,1.4,1.7,1.8-1,3l1.5.3c.2.1-.5.8-.5,1,0,.8,0,1.1-.5,1l.5.5c2.9,1.5,1.7,3.8-.5,5-.3.8-2.4,1.3-2.5,0-1.4-.1-1.6-.6-.5-1.5.3-.2.3-.3,0-.5-1.1-.2-1.8-3.5-1.5-3.9s1.8-1.6,1.9-1.6c.2.2-.2.4-.4-.5-.2-.1-1.6-1.9-1.5-2,1.2-.9,2.7,3.3,4,0-.6.4-3.1-1.6-3-1.8.4-1.2,1.7-.2,2,.2.5,0,.3-.6-.5-1.5,0-.8,1.2-.8,1.4-1.1,1.2-2-1.9-1.4-2.4-1.9s0-2.5,0-2.6c.4-1.6,1.4-1.3,2.4-.9Z"
          fill="#0233e8"
        />
        <path
          d="M237.7,258.3c-.1.6-.1,1.1-.8,1.5-.4.1-.2-.8-.7-1l-.5.5c-.3.2-.6,0-1,.5,1,1.3.8,2-.5,2l-1.5-.2c1-2.3,1.9-5,5-3.3Z"
          fill="#023adf"
        />
        <path
          d="M233.2,267.8l-1,3-1.5-2.5c0-.7-1.7-.9,1-1s.1.4.3.4c.8-.1.8-1.2.7-1.9.8.3.3,1.6.5,2Z"
          fill="#024cef"
        />
        <path
          d="M234.7,259.8c.5,2.1,3.3-.9,3,1.5l-3,1c-.5,0-.4-.2-.5-.5s.4-1.9.5-2Z"
          fill="#035ef2"
        />
        <path d="M233.7,257.3c.1-.2.3-.3.5-.5-.2.2-.3.4-.5.5Z" fill="#034cdf" />
        <path
          d="M240.7,262.8c.6,0,.9.3,1,1,.4.1.9,0,1,.5.5,1.1-.3,2.1-2.5,3-.1,0-.3,0-.5,0,.8.8.9,1.4.5,2l-.9.9c1,1.5-.7,2.7-1.6,1.1-.2-.2,1.2-2.3-.3-3l-.5,1.5c-2.8-.5-2.9-.8-1-3l.2,2c3.2-2.5.2-3.7-1-5.5.4-1.3,5.2-2.8,5.5-.5Z"
          fill="#035ef2"
        />
        <path d="M239.7,267.3c1.7.9.8,1,.5,2,.9-1.3-1.4-.9-1.5-1-1.1-1,.7-.9,1-1Z" fill="#0248f1" />
        <path
          d="M240.7,262.8c1,.1,1.7.2,1.5-1h.5c.2,1.1,0,1.5-1,2-.3,0-.9.1-1,0s.1-.9,0-1Z"
          fill="#0143ef"
        />
        <path d="M239.2,266.3l1.5-1.5c.2.9-.5,1.7-1.5,1.5Z" fill="#0339ec" />
        <path
          d="M228.2,274.8c.8-.2.9.4.2,1.8l.7.2c-1,.4,0,.8,1.1.5-.4-.1-.4-.3,0-.5.2-.2.3-.2.5,0,.2.1.3.4.5.5,0,.4.1,1.2,0,2s-.7.1-.5,1.2.8,1.1,1,1.8l-1.5.3c2,.9,2.5,3,0,1.8.1.9.4,1.6.5,2.5-.5.4-1.3.7-1.5,0-1.5-.3-1.8-1.8-1.5-3.1s.8-.4.9-.8c1.3-2.8-.3-1.9-.5-2.1-1.5,0-1.9-1.1-1.2-3.4-.5-1.5-.8-3,1.2-2.6Z"
          fill="#0230df"
        />
        <path
          d="M229.7,271.8c1.7-1.5,3.4,1.2,1,1.5-.2.9-.2,1.7-.5,2.5-.9.2-.9.4,0,.5.2,0,.3.4.5.5h-.5c-.4.2-.4.3,0,.5-2.4,1.7-2.1-.3-2-2.5,0-.5,0-1,.5-1.5-.1-.3-.6-.9-.5-1s.9.1,1.5-.5Z"
          fill="#023ae4"
        />
        <path
          d="M230.2,270.8c1.6.1,2.5.9,2.5,2.5h-2c.1-.5.3-1,.5-1.5h-1.5s.4-.9.5-1Z"
          fill="#024cef"
        />
        <path d="M230.2,275.8v.5c-.5,0-1.3.7-1.5.2.1-1.1.7-1.5,1.5-.7Z" fill="#0230df" />
        <path
          d="M245.2,261.3c0-1.5,0-3.8,1.8-2.3s1.3,3.6.2,3.3c-.6,1.6,1.5,4.6,2.4,3.4l.6,1.1c0,.2,0,.4,0,.5-.8.2-.3.8,1.5,2,1,.5,1.1-1.9,2-1s-.9,1.4-1,1.8c-.3,1.3,1.2.5,1.5.7s-.1,2.5-1,2.5c-.5.1-.8-.8-.8-.7,1.6,3-1.8,2.4-3,.5-1,.6-1.9,1.3-2.7,2.2-.1.8-.6,1.1-1.5,1,1,1.6,1.1,2.4.3,2.2.5,1,.3,1.2-.8,1.3,0,1.3-.3,1.9-1,2,.4.3.7,1.8-.2.8s0-.4.2-.8c.3-.6.8-1,1.5-1,1,0,1.9.1,2.5.5-.2,1,0,1,.5,0,.1-.4.3-.4.5,0,.2,0,.4.2.5.3s-.7-.6,1.2,0,.2-.1.3-.3c.2-.4.3-.4.5,0h1c.1-.4.3-.4.5,0,1-.3,2.9,1.2,1,2.5.4.1.4.3,0,.5.3.3.6.5,1,.5-.2-.1-.2-.3,0-.5-.4-2.2,1-2.3,1-.5.8.2.6.6,0,1-.3,1-.7,2-1,3-.3.9-1.1.2-.5-.5,0-.2.6-.7.4-.9s-1.6-.5-1.4-1.6l-.5,2c-1.1-.3-1-1.6-1-2.5-1,.1-1.1,1.5-1.5,2,0,.8,0,1.3-.5,2-.6,2.6,1.8,2.8,3.5,3.5.3,1,.3,2,0,3,0,.4.1.4.5,0-1.3-.5-1.3-1,0-1.5l1.5,1-1,.5c1.4-.2.6.7,1,1.5.3,1.6-2,.7-3,0-.7-.7-1.5-.7-2.5,0v.5c.3.4,0,.6-1,.5.2,1.5-.7,1.7-1.5.5-1.3.3-1.4,0-.5-1,.2-1.4,1.2-2.4,3-3-.9-.5-.5-1.4.5-1,.2-1.2-.6-1.1-2.2-.9l-.8-1.1c-.4,0-.8-.1-1-.4s1.6-3.5,2-1.1q.8.7,0,0l-.6-.3c-.5-2.5-1.6,1.2-.4,1.8,1.3.6,2,1.2.5,2-1.2,1.6-3.5,2.2-3.4-.6-1.8-.7-2.7-1.7-2.6-2.9,0-.7.4-1,1-1,0-.5-.1-.8-.5-1-.7-.2-1-.8-1-1.5-.4-.1-.4-.3,0-.5l-.5-.5-2-.5c-.4-.1-.4-.3,0-.5v-1.1c3.1-1.5.2-3.8-.7,0l-1.3.2c-.3.5-.7.6-1,.5-.1.4-.3.4-.5,0-.4-.1-.4-.3,0-.5-.3-.1-.3-.3,0-.5-.7-.2-.6-.7,0-1-.9-.1-1.8-.3-2.5-.5l-.5.5c-.4,1.9-1.3.2-1-1,.1-.4.3-.4.5,0,.7-1,1.5-2,2.5-2.7-.6-.5-.8-1.4-.7-2.5-1.6-.7-.5-2,.6-2.2-.6-2.2,3.9-4.9,3.5-1.5l.2.2c2.1-.7,3.5-.6,4.3.3q1.2.4,0,0l-1.3-.9c-1.9,1.6-2.5-.6-.7-1.6-.7-.5-.7-.7.2-.4-.3-.4-.6-.9-.7-1.6.1-.4.3-.4.5,0,2.4-1.4,3.8-3,4.5-5.5l.5-.5Z"
          fill="#0359f7"
        />
        <path
          d="M244.7,260.3c.8-.6.9.3.5,1l-1,.5c.9.9-.5,2.8-1.5,2.5-.7.7-1,.5-1-.5-.3-.3-.6-.6-1-1-1.1-1-.3-1.7,2.5-2,0-1.5.5-1.6,1.5-.5Z"
          fill="#0359f7"
        />
        <path
          d="M249.2,262.3c.3.1.5.2.5.3-.2,1.8-1.3.9-.1.3s.4.1.6.4c.9.1.9.9,0,1l.5.5c.4.4,0,.8-.5,1,0,0,0,1,0,1-2.6-.8-1.8,1.5-2.8,2-1.9.9-.5-2.3-2.7-1.5.6-1.6,1.8-.6,2.2.5,2.1-2.2,1-3-1.7-2l2-3.5c.4-1.1,2.3-1.3,2,0Z"
          fill="#0245f2"
        />
        <path
          d="M253.7,293.3c0,.4,0,1.2,0,1.5-.1.3-.3.3-.5,0,0-1-2.5,0-2.5-.7,1-.7,2.6-.7,2.5-2.2.8.3.4.8.5,1.5Z"
          fill="#023fec"
        />
        <path
          d="M240.2,269.3c-.2.5-.7.8-.5,1.5,2.3-1.1,2.3.9,2.5,1-.4-.2-1.1-.2-1.5-.5-.3,1.3,1.1,1.2,1.5,1.9s1.4,4.6-.5,4.6c.3-.5-.1-3.4-.2-3.5-.4-.5-1.4-.3-1.7-.6s0-1.2,0-1.4-1.2.7-1.5.5-.2-1-.5-1.5c1,.9,1.1-1.2,1.5-1.7s1-.3,1-.3Z"
          fill="#0245f1"
        />
        <path
          d="M248.2,289.3l1,.2c-1.5,1.7-.8,0-1-.2-.9-.8-1.1.9-1,1.5-.1,0-.7.4-1.7,0-3-1.2-1.4-2.6,1.2-1.6l-2-1.5c2.4-.7,3.8-1.8,3.5,1.5Z"
          fill="#0349f5"
        />
        <path
          d="M245.2,276.3c.5,1.9,2.5,0,3,.5s.3,2,1,2.5l-3.5-1,1.5,2c-.9.2-1.7-.4-2.5-.5,0,.7.3.7.5,1,.3,1.6-.5.8-1.5,1,0-.3,1.2-1.3-1-1.5v-.5c.7,0,1.3,0,2,0,0-.7.6-1.6.5-2.2s-1-.3-1-.3c-.9-1.1.9-.9,1-1Z"
          fill="#0345f3"
        />
        <path
          d="M244.7,261.8c1.7,2.8-2.6,2.4,0,3.2-.1.3-1.2,1-1,1.2s1.2-.4,1,.5c-2.2-.6-2.7,0-4.5.5.8-1,1.8-2.1,2.5-3s.8-1.2,1.5-2.5h.5Z"
          fill="#0248f1"
        />
        <path
          d="M250.7,281.3c1.2,1.8-.8.2-1,.5s-.5,1.6-.5,1.8,1.9.2.7,1.2c-2.5.1-1.7-2-1.2-3.5s0-.7,0-1c1.2-.5,1.8.9,2,1Z"
          fill="#034cf5"
        />
        <path
          d="M248.2,281.3c-.2,1-1.3,4.2-2.3,4.5s0-1.6-.7-2c1.9.4,1.7-1.2,2.5-2.5.2,0,.3,0,.5,0Z"
          fill="#0344f4"
        />
        <path d="M243.7,281.8c0,.5,1,.3,1,.7,0,.6-2.3-.5-1,1.2-.8.5-4.1-1.1,0-2Z" fill="#0345f6" />
        <path d="M242.2,271.8c2,1.4-.9-3.6,1.5-3,.1.7.2,4.5-1,3.8s-.3-.7-.5-.8Z" fill="#0246f1" />
        <path
          d="M235.2,281.3c.4,1.1,0,.5,0,1-.2.2-.2.4,0,.5v.5c0,0-.2.6-.5.3-.9-.8-.9-2.7.5-2.3Z"
          fill="#0349f4"
        />
        <path d="M236.2,281.3c-.1-1.1-.9-1.5.5-2,.1,1.1.9,1.5-.5,2Z" fill="#0239ec" />
        <path d="M240.7,274.8v1c-.7.2-1-.2-1.5-.7l1.5-.2Z" fill="#0245f1" />
        <path d="M240.7,284.8c-.8-.1-1.7,0-2.5,0,.1-.4,0-.4.5-.5,1-.2,1.3,0,2,.5Z" fill="#024af5" />
        <path
          d="M254.7,284.3c0,.2,0,.4,0,.5-.2.2-.5,0-1-.5v-.5l1-.5c0,.3,0,.7,0,1Z"
          fill="#0122de"
        />
        <path d="M252.2,281.3c-.4.5-.6.2-1,0,0-.2.5-.4.5-.5l.5.5Z" fill="#034cf5" />
        <path d="M246.2,282.3l-1,1c-.1-1,0-1.1,1-1Z" fill="#0344f4" />
        <path d="M253.7,294.8c-.1.5-.2.6-.7.5l.2-.5h.5Z" fill="#0134ec" />
        <path d="M244.2,274.3c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#0245f1" />
        <path d="M249.7,296.8s-.4-.2,0-.5v.5Z" fill="#0354f7" />
        <path d="M254.7,284.8c0,.2,0,.4-.2.5l-.8-1,1,.5Z" fill="#034cf5" />
        <path d="M241.2,285.3c-.2,0-.4-.5-.5-.5.2.1.4.3.5.5Z" fill="#0349f4" />
        <path d="M235.7,283.3c.3,0,.7-.5,1-.5-.3.4-.5,1.3-1,.5Z" fill="#0349f4" />
        <path d="M235.2,282.8l-.5-.2.5-.2c0,.2,0,.3,0,.5Z" fill="#0244f2" />
        <path d="M232.2,281.3c.1,0,.3-.4.5-.5l-.5.5Z" fill="#0252f3" />
        <path
          d="M246.7,275.3l1.5-3c-.3.2-3.6-1.8-3.5-2l2.5-.5c-1.1,1.8,1.1,1.3.5-.5,1.8.2-.7,2.8.8,3s1.7-1.2,2.7-1c-1.2,1.1,0,3.9,1,3s-1-1.4-1-1.5c-.3-.7,1.8-1.9,2,.5s0,.3,0,.5c0,.3-.6,1-.5,1.5-1.6-.5-2.7-1.8-3,.5l-.5-1.5c-.3,0-.7,0-1,0l-.5.5c-1.1,1.4-.7.5-1,.5Z"
          fill="#0248f3"
        />
        <path d="M247.7,274.8c.1-.2.3-.5.5-.5-.1.2-.4.3-.5.5Z" fill="#0359f7" />
        <path d="M250.2,273.8c-1,.1-1.1,0-1-1l1,1Z" fill="#046afa" />
        <path
          d="M236.7,282.8c.7-1,1.3-2,1-3.5l3,.5-1.5-1.2c1.3-2,3.7,2.1,1.5,1.8v.5s1,0,1,0v1s-3,2-3,2c-.5,1-1.3.5-1-.5l-.5-.5c-.2.4-.3.4-.5,0Z"
          fill="#024af5"
        />
        <path d="M240.2,280.3c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#0359f7" />
        <path d="M237.7,283.3l-.5-.5c.5.1.5.5.5.5Z" fill="#0349f4" />
        <path d="M230.7,286.8c0,.2,0,.3,0,.5-.5,0-1,.2-1.5.5v-1c.4,0,1,0,1.5,0Z" fill="#022ee4" />
        <path d="M233.2,282.3v.5l-1,.2c.2-1.2.4-1.3,1-.7Z" fill="#0349f4" />
        <path d="M232.2,286.3h-.5l-.5-.2c0-.5,1-.4,1,.2Z" fill="#0349f4" />
        <path
          d="M242.2,287.3s.5.9.5,1c.3,1.4-.2.9-1,1s-1,0-1.5,0v.5s1,.3,1,.3c-.2.5-1.5.7-1.5.8-.2.3.3,1.5-.3,1.5-1,0-1.5-.8-.7-1.5,0-1,.6-.9,1,0-.7-1-1.1-1.1-1-.5-.4.7-2.3,0-3,.5v-2c1.5.9,3.9-.4,4-2,.7.2,2.3.4,2.5.5Z"
          fill="#0235ef"
        />
        <path
          d="M240.7,284.8l.5.5v.5c-3.5-.8-1.4-.3-1.5,1-1.1-.4-1.3,0-1.5-1.5s0-.4,0-.5c.8-.5,1.7-.3,2.5,0Z"
          fill="#0235ef"
        />
        <path
          d="M239.7,290.8c0,0-.7,0-1,0v-.5c.1-.2-.3-1,.2-1,.4.3,1.1,1.1.8,1.5Z"
          fill="#0655f9"
        />
        <path d="M241.7,288.3c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#0349f4" />
        <path
          d="M250.2,292.8c-.9-.2-1.1.1-.5,1,0,.1.5,1.6,0,2s-1.3-.6-1.4-.5-.3,1.7-1.6,1.4c-1,.6-1.8.9-2.5,1,0,.9-.6,1.3-1.5,1l-.5.5c1.5.2,1.4,1.6,0,2,.5-1.1,1.2-2.1,2-3,.6-1.2,1.7-1.3,2.3-.2l.7-.3c.1,0,1-.2,1.5-.5,1.2-.6,3.1.3,2.1,1.7.5,1,1,1.6,1.4,1.8.2,0,.4,0,.5,0,.4.1.4.3,0,.5.4,1,.4,2.2-.5,3-1,0-1-1.4,0-1.5q.2-.2,0,0c-.7.9-1.2,1.9,0,2.5,0,.3-.4.9-.5,1-1.2,1-3,1.7-4.5,1l-.2,1.5c-2.7-.7-1.6-3.4-1.8-3.5-.5-.4-2.3,1.1-3-.3.1-.6,1.4.1,1.5-.5.4-1.9-.6-.8-1-1.1-1.6-1-.6-1.5-.5-2.2-1.2.5-.8.5-1.5,1-.7-.4-1-1.4,0-1.5.3-.2.5-.6.5-1-1.4.3-1.7,0-1-1,0-.9.2-1.1,1-.5-.7-2.7-.2-3.7,1.5-3,.2-.4.3-.4.5,0l.4-1.1c1.5-.2,2.9-.7,4.1-1.4,0-1-.3-1-.5-2,.9.2,3.2.3,3.5,1.3s-.4.6-.5.7Z"
          fill="#0354f7"
        />
        <path
          d="M252.2,302.8c0,0,0,.9,0,1.5s.3.1,0,1c-2.3,1.7-.8-1.6-1.5-2.7,0-.3,1.4.2,1.5.2Z"
          fill="#0345f3"
        />
        <path d="M252.2,302.8c-.2-.2.5-.8.5-.2s-.4.4-.5.2Z" fill="#0345f3" />
        <path d="M250.2,292.8c-.2.3-.4.3-.5,1-2.2.4-.5-3.4.5-1Z" fill="#013ae8" />
        <path
          d="M244.2,297.8c0,.1,0,.3,0,.5-.2,2.5.9,1.1,1.5,1.5s-.4,2.4,0,3h-3s2-2.5,2-2.5c-.8.9-1.8.7-2.5,1,0-.7,0-1.9,0-2l.5-.5c.4-.6.6-1,1.5-1Z"
          fill="#0241f1"
        />
        <path d="M249.2,300.8l.5,2-2-1-1,1c0-1.4,1.3-2.2,2.5-2Z" fill="#0243f3" />
        <path d="M249.7,303.8c1.1.7.5,3.9-1.4.2,0-.5,1.3-.3,1.4-.2Z" fill="#0239ec" />
        <path d="M245,298.8c.3.2.3.3,0,.5v-.5Z" fill="#0241f1" />
        <path d="M241.2,299.8l.5.2c.2.9-.1.8-1,.8-.2-.8-1.3-1.1.5-1Z" fill="#022ee9" />
        <path d="M242.2,299.3c0-.2.4-.4.5-.5l-.5.5Z" fill="#0349f4" />
        <path
          d="M244.2,297.8s.6,0,.5-.5h-2c-.1-2.2,2.9-1.4,4-.5s.3.7.5,1c0,0,.2,1-.3,1s-1.8-.8-2.7-.5c-.4,0-.4-.3,0-.5Z"
          fill="#0349f4"
        />
        <path d="M246,297.3c.3.2.3.3,0,.5v-.5Z" fill="#0354f7" />
        <path d="M254.7,257.8c2.2,1.6.9,1.1,0,1.5s-.7.4-1,.5c-1-1.2.5-1.4,1-2Z" fill="#0250f3" />
        <path d="M253.7,259.8v.5c-.3,0-.7,0-1,0,.2-.5.7-.4,1-.5Z" fill="#0250f3" />
        <path d="M249.7,253.3v-.5l.5.2c0,.3-.3.2-.5.2Z" fill="#0250f3" />
        <path
          d="M258.7,256.8c.3,0,.8-.8,1.5-.5-.5.6-.3,1.4-.5,2s-1.4,3.5-1.5,3.7c-.6.9-2.5,1.6-2.5,3.3-.1,0-.4,0-.5,0-.3-.1-1.9-1.6-2-1.8,1.5-.3.7-1.4,1.1-2.1s3.1-1.4.4-1.6c-.4-.1-.4-.3,0-.5v-1.5c-.2-.4,0-.6.5-.5,1.1-.5,2.4-.3,3.5-.5Z"
          fill="#0247ef"
        />
        <path d="M257.2,259.3l-.2,1.5c-.5-.5-.9-.8-.7-1.5h1Z" fill="#0250f3" />
        <path d="M257.7,257.8v.5c-2.1.2-2.1-.7,0-.5Z" fill="#0250f3" />
        <path
          d="M256.7,317.8c.2.2.3.3.5.5-2.5,1.4-.2,2.5-2,3.5s-2.5,1.1-2.5,0c1.5.2,1.7,0,1.5-1.5l1,.5c.3-.7-.7-2.7-.5-3s1.1-.3,1.5-.5c.4-.2.6,0,.5.5Z"
          fill="#0364f9"
        />
        <path d="M254.2,326.2v.5c-1.9,1.2-2.2,0,0-.5Z" fill="#0870f7" />
        <path
          d="M333.7,229.8c-.7-2.2,1.4-.7,2.4,0,1.7-.7,3.2-.7,1.6,1,3.2,1.2,3.2,2.1,0,2.5,1.2-.6,2.4-1.2,3.7-2,1.1.3,1.8-.7,2.1-1.7,3.1.3,3.7,1.7.7,2.7,0,.3.1.3.5,0,.3-2,2.2-.6.5.5,2.3,1.2,2.8,2.2,1.6,3l-.6-1c0,1.5-2.6,1.6-3.4.7-1,.3-1.8.7-2.6,1.3v.5c1.3,0,1.7.3,1.5,2,.4.1.4.3,0,.5.4.8-.2,1.2-1,1,.8.7,1,1.2.5,1.5.4.1.4.3,0,.5.4.1.4.3,0,.5-.2.5-1.5,1.1-2,.5-.6,1.7-1.7,1-1-.5,0-.3,0-.5.1-.6,1.9-1.4.6.3-1.4.7s-.5,0-.7,0c.2,1.4-.2,1.5-1,.5-.1,0-.3,0-.5,0-.3-1.1-.6-2.4-1-3.5,4.6-4.5,2.1-.9,1-.9-2.9,0-.1-3,1-2.1.6-3.9,1.6-1.7,2,1s-.3-2.7-1.2-2.2c0-1.2.4-2.2,1.2-2.8-.1,1.1-.8,2.1-2,3l-2,1.9c.2,1.2-.3,1.1-1,0,0-.2,0-.4,0-.5.1-.4-.2-.7-1-1,0,0,.3-1.4-.2-2,1.1-2.4,3.8-2.1,2.2-5Z"
          fill="#0267f7"
        />
        <path
          d="M333.7,224.8l.5.5c-.4-.8-.2-.9.5-.5.4-1,1.7.3,1.5,1-.5.8-.5.9,0,.5,0-1,.8-1,1,0,.7-.7,1.4-.4,1,.5.7,1-.5,3.5-1.8,3.1-1.3-.7-2.5-1.3-3.7-1.6l-1,.7c-1.1-.9-2.1-1.8-2.9-2.7-.1-.3-.5-.6-.5-1,0-1.2,1.1-1.3,1.9-.7,0-.6,1-.8.9-.2s-.7.3.2-.6c1-.8,1.1-.8,1,.5q.3,1.3,0,0c-1.3-2.1,2.4-1.9,1.5.5Z"
          fill="#026ff6"
        />
        <path
          d="M328.7,226.3c2.7-.2,1.8,1.5,4,2,1.1.5.9.9,0,1.5,0,.6.8,2.2.5,2.5s-.8-.5-1.2-.5-.8,1.9-1.8,1,1.8-2.3,1.5-2.5l-2.5,1c-.6-3,1.4,0,1.5-1.7-1.3-.9-3.5-1-1-2-1.2-.4-.8-.8-1-1.2Z"
          fill="#0261f4"
        />
        <path
          d="M335.7,236.3c.3.2.3.6,0,1-.5.4-1.8.3-2,1.5l3-1.5c.7,3.1-3.5,2,0,4.5l-3-1.5c-.1-.4-1-1.2-1-2,1.4,0,1.8-1.3,2-2.5l1,.5Z"
          fill="#0655ee"
        />
        <path
          d="M331.7,236.8c2.2.3.9-2.9,1-3h2c-.4,1.1-.8,2.3-1.3,3.4s-.7.5-.7.5c-.3-.3-.9-.6-1-1Z"
          fill="#0655ee"
        />
        <path
          d="M350.7,265.8c.2.6.2,1.2.5,2,0,.4,0,.8.5,1,.3-.1.8-1.5,1-2,0,.4.3.4,1,0,.7.7,1.1,2.1-.5,1.5,1.2,1.9-1.9,3.1-2.5,2-.1.4-.3.4-.5,0-.7-.2-1.2,0-1.5.5-.4.2-.7.8-1.3,1l-.2-.5c-1.1-1.3-2.4-3.1-.2-3.6s-.6.3.2-.9c-.5-.1-.4-.3,0-.5.6-3.7,2.9-6.4,4.3-1.4l-.8.9Z"
          fill="#024dee"
        />
        <path
          d="M347.2,266.8c0,.2.7.4.5,1.2s-1.8.3-1,1.3,1.4-.9.5,2-.3.8-.5,1.5c-1-2.1-1.7-4.3-2.5-6.5.8-.3,1.8-.1,3,.5Z"
          fill="#0236dd"
        />
        <path
          d="M351.2,272.3c.4.2.4.3,0,.5-.3,0-.7,0-1,0-.7,0-1.3,0-2,0,.3-1.2,1.1-.7,2-.5,0-.3,0-.7,0-1-.2-.3-.3-.7,0-1,.1,0,.3,0,.5,0,1-.3,1.2.4.5,2Z"
          fill="#035ff5"
        />
        <path
          d="M350.2,270.3c0,.3,0,.7,0,1-.4-.2-.5-1-.5-1-.2,0-.8.4-1,.5.2-3.2.8-.8,1.5-.5Z"
          fill="#023dec"
        />
        <path
          d="M342.7,238.3c-6-1.5,2.6-4.6,2.9-1s-.7,1.1-.8,1.2.3-1.1,1-.7c.4,0,.6,0,.5-.5-1.5-.2-1.4-1,0-1.5.2,0,.6,0,1,.5.1-.4.3-.4.5,0,1.2-.5,2,.2,2.5,2,0,.7.2.8.5.5,1.2.2,1.9,3.2,1.7,4s-3,1.4-2.1.1c-2.2,1-2.8,1.1-1.8.1,1.1-.1.9,1.1.2,1.7-.9.6-1.9.3-3.2-.9.4.4-.9,1.3-1.3,1.4q-.9-.8,0,0c.6.6.3.9-.5,1-.3.3-2.4.6-2.2.5,1-.7,2.3,0,2.9.7,2.5.1,1.6,2.6-1.1,2.2.4.5.7,1.2,0,1.5.1.5,0,.6-.5.5h-.5c-.8,0-1.3-.5-1.5-1.5l-1-.5c-.1.4-.3.4-.5,0-.2.3-.3.3-.5,0-.3.5-.9.6-1,0,.7-1.3.9-2.7.5-4-.5,0-1.8,1.2-2,1l-1-3c.3-.2.7-.3,1-.5.7-.2,1.4-.2,2,0,0,.5.6.6,1,.5.4,0,.6.6.5,1.5.7-.7,1.1-.4,1,.5,1.2-.4,1-1.3,0-1.9l.4-.6c0-.1,0-.3,0-.5.6-.6.6-.7,0-.5,0-.3-.7-.6-.5-1.5.1-.3.3-.3.5,0l.5.5c-.4-.6-.1-.9.5-1,0-.9,0-1.6.5-2Z"
          fill="#035ef8"
        />
        <path
          d="M340.7,251.8l.8.2c-.1,2.2.5,3.9,1.7,5.3.7.7.4,1-.5.5-.3-.2-1.5.1-2,0,1.4-1.8-1.4-3.5-1.5-3.7-.5-1.6,1.5.2,1.5-.7-.5-.6-1-.8-1.5-.5h-.5c0-.2,0-.3,0-.5-.5-.8-.6-1.6.5-1.5.1-.4.3-.4.5,0,1.2,0,1.5.4,1,1Z"
          fill="#0352f3"
        />
        <path
          d="M338.2,245.8c.2,0,2.3,1.6,2.5,1.8.4.5,0,1.1,0,1.2.4.3,1.8-.6,1.4,1-2.2-.3-2.2-.3-2.7-2l-1.7,2c-.2-.5-.3-1-.5-1.5l.5-1c0-.3.5-1,.5-1.5Z"
          fill="#024df4"
        />
        <path
          d="M339.2,250.8c-.1.5-.5.9-.5,1.5-.5-.4-.8-.9-1-1.5.1-.6.5-.9,1-.5.1-.3.3-.3.5,0,.4,0,.4.3,0,.5Z"
          fill="#0344e6"
        />
        <path d="M337.7,247.3c0,.3,1.5,1.2-.5,1-.3-.9-1.2-1.1.5-1Z" fill="#035ef8" />
        <path d="M338.7,249.8c.3.1.3.3,0,.5l-1,.5c0-.3,0-.7,0-1,.3,0,.7,0,1,0Z" fill="#0355f5" />
        <path
          d="M359.1,278.3c0-.5-.4-.8-1.2-.8,1.6-4.4,3.7-3.8,6.2,1.8,0,.3-.9.8-1,1-.2,1.3-.6,1.3-1,0-.5,0-1,0-1.5,0-.2-1.7-1.5-1.2-1.5-2Z"
          fill="#0244f4"
        />
        <path
          d="M362.1,258.3c.1.2-.3,1,.5,1-.3.3-.3,1.1-.5,1.5s-.4.3-.5.5c-.3,0-.7,0-1,0,1-1.8.5-2.5.5-4,.5.4.6.3,1,1Z"
          fill="#0333e5"
        />
        <path
          d="M358.6,259.8l.6.2c.3,2.1,1.3,2.6,2.4,1.3-.5-.7-.2-.9.5-.5,3.4-2.1,1.9,4.5,0,4.5,1.2.2,1.1.6,0,1-.7-.2-.6.1.5,1,.2.7.5,1.1.5,2,.7.5.3,1.7-.5,2q-1.2.3,0,0c.8-.9.7,0,.5,1-.6,1-.7,1.6,0,2.5-1-1-1.5-1.8,0-2.5,0-.9,0-2.5,1-2.5,0-.2.4-.3.5-.5,1-.5,1.4,0,1,1l-.5,1.5h2.5s-.5,1-.5,1h-1c0,0-1.3,1.1-1.3,1.2-.7,1.1.8,1.7-1.7.8,0,.4,0,1-.5,1-.9.6-1.4.6-1-.4-2.4-1.7-4,.8-2.5,2.9,1.5-.7,3,.9,1.5,2-1.6.8-3.9.2-5.2-.8l-.8.3c.4.6-.3,1.4-1,1.5h-.5c0-.3-.7-1-.5-1.4s3-.5.5-2.1c.4-.9.2-.9-.5,0,0,.1-1.6,0-1.5,2.2s1.6,0,1,1.3l-2.5-2.5c-.1-1.8,1-.7,1.5-1s-.7-1.3,0-2l-2,1,1-4c.3-1,.7-1,1,0,.6,0,1.1-.8,1.5-2,.2-.9.7-1.2,1.3-.5l.2-.5c.3-.5.8-.8,1.5-1-.7-.7-1.1-1.6-.5-2.5-.6.3-1.1.3-1.5,0-.2.4-.6.6-1,.5.2,1.5-.2,2.2-1,2-.8-.2-1.2-.4-.5-1-1.5-.2-1.8-1.3-.5-2,.1-.4.3-.4.5,0,.2.2.4.2.5,0-.7-1.3-.3-1.8,1-1l3.7-.3c.4.1,2.1,1.6,1.4,1.5s-.9-1.3,0-1.7c0-.3,0-.3-.5,0-.2,1.2-.7,1.3-1.3.3-1.1.3-2.1.3-3.2.2-.8-1.5,4.5-4.6,5.5-3,.3.1.3.3,0,.5-.5.5-.3.5.5,0-.5-1-.5-1.9,0-2.5Z"
          fill="#034bf5"
        />
        <path
          d="M354.7,279.8c.2-1.7,2.5.3.9.6l-.9.9c-.3.2-.5.5-1,.5,0-.2,0-.4,0-.5.1-.4.8-1,1-1.5Z"
          fill="#0240e6"
        />
        <path
          d="M363.1,274.8c-1.2-.4-1.3-.6-2-2,.4,0,1.9-.4,2-.5-.3,1.3,0,1.5,0,2.5Z"
          fill="#0234ef"
        />
        <path
          d="M364.1,269.8c-.2.4-.9,2.1-1,2.5.2-.4-.5-.9-.5-1,0-.5.5-1.1.5-2l1,.5Z"
          fill="#0234ef"
        />
        <path
          d="M363.1,265.3l1,.5v.5s-1.5,0-1.5,0c-.1.4-.3.4-.5,0,.1-.1,0-.7,0-1h1Z"
          fill="#022ee8"
        />
        <path d="M362.1,266.3h.5c0,.3,0,.7,0,1l-1.5-.8c0-.5.9-.1,1-.2Z" fill="#0a60fa" />
        <path d="M353.2,277.8h-.5c.2-.3-.2-1.9,1-2,.1,1,.8,1.6-.5,2Z" fill="#0237e6" />
        <path
          d="M359.1,278.3l-2.5.5-.5-2c3,1,1.5.2,2.3-1.4s2-1,1.7-2.6c.9-.2.3.9.6,1.3s1.3,1,1.9,1.7.8.4.9.6c.2.4-.2.9-.1,1.4s.7,1.2.7,1.5c-.5-.4-1.5-.9-1.7-1.5-.5-1.3,1.6-2.3-2.3-.5l1.5-2c-1.7-.2-2.9-.2-3,1.8s1,.1,1,.5-.5.6-.5.7Z"
          fill="#0139f0"
        />
        <path
          d="M354.7,279.8c.1-.3-.3-2.4,1-1.5s-.1.8.6,1.2c1.3.6,1.9-.2,2.6-.2s0,.8,1.8,1c0,.2,0,.3,0,.5-1,1.5-3,2.3-4.5,1-.3-.1-.3-.3,0-.5l.2-1c-.7,0-1.2.6-1.7,1,.6-1.1,1.8-1.7,0-1.5Z"
          fill="#023cef"
        />
        <path
          d="M357.2,264.3h.5c.1.7,1.3,1,1,2-1.8,0-2.9.6-2.5-1.5-.1-.1-2.9,1.4-3.5,0,1.5-1,3.1-.4,4.5-.5Z"
          fill="#045cf7"
        />
        <path
          d="M354.2,269.8c1.4,1.4,3.1,1.2,4,3-1.2.6-.9-.8-1.2-.9s-1.6.2-2.4-.1c-1.1-.5.1-1.3-1.9-1-.4,1.5-.9,2-1.5,1.5-.3-.7-.1-1.3-.5-2,1.4.2,2-1,2.5-2,1-.1,1.5.7,1,1.5Z"
          fill="#023dec"
        />
        <path
          d="M352.7,270.8c-.2,1.7,2.3,2.9-.2,3.5-.1,0-1.1-1.2-1.3-1.5s0-.3,0-.5c.5-.5.6-1.4,1-1.8s.5.3.5.3Z"
          fill="#0359f8"
        />
        <path
          d="M355.2,266.3c-.3.9-.2,1.7.5,2.5,0,.4-.6.9-.5,1.5l-1-.5c-.4-.5-.8-.9-1-1.5.3-.5.7-.7.5-1.5-.4-.1-.4-.3,0-.5.6,0,.7-.9,1.5,0Z"
          fill="#0259f8"
        />
        <path d="M358.6,268.8c-.4-1.5.4-.6.8-.8.9-.3,1.6-1.1,2.2,0l-3,.7Z" fill="#0232e6" />
        <path d="M357.6,269.3c0,0-1.1.2-1.5.5v-2.5c1.1-.4,2,1.3,1.5,2Z" fill="#023fef" />
        <path
          d="M361.1,269.8c.4.1.4.3,0,.5-.7.9-.7,2.3-2,2-.3-.2,1.4-1.2.5-1.5-.4-.1-.4-.3,0-.5,0,0,1-.4,1.5-.5Z"
          fill="#055ef9"
        />
        <path d="M355.7,268.8c-1.4-.8-1.9-1.4-.5-2.5.2.2.5,2.2.5,2.5Z" fill="#023fef" />
        <path
          d="M358.6,259.8c0,.8.1,1.7,0,2.5-.1.4-.3.4-.5,0v-.5c0-.2,0-.3,0-.5-.6-.4-.8-.7-.5-1,0-.3,0-.7,0-1,.1-.4.3-.4.5,0,.2.2.4.3.5.5Z"
          fill="#0237eb"
        />
        <path d="M358.2,262.3h.5c0,.4.2.9-.3,1s-1.2,0-1.7,0c.1-.7.9-1,1.5-1Z" fill="#0762f3" />
        <path
          d="M353.7,266.3v.5c-.6,1.1-1.1,1.7-1,0,0-.3-.1-.9,0-1,.3-.3.9.5,1,.5Z"
          fill="#023dec"
        />
        <path d="M351.7,268.8c-.4.2-1.4-.1-2,0-.2-.7.9-.6,1.5-1,.1.3.6.5.5,1Z" fill="#023dec" />
        <path d="M356.6,273.3l-.2,1.5c-.5-.5-.9-.8-.7-1.5h1Z" fill="#0122d8" />
        <path d="M359.6,270.3v.5c-1.3.2-1-.3-1-1.5.6,0,.9,1,1,1Z" fill="#0232e6" />
        <path d="M359.6,263.8c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#0762f3" />
        <path d="M362.6,271.3l-1.5,1c-.2-1.3.3-1,1.5-1Z" fill="#0330ee" />
        <path d="M361.1,269.8c.5,0,1-1,1.5.5h-1.5s0-.5,0-.5Z" fill="#0329e6" />
        <path d="M357.2,264.3c0,0,.3-.6.7-.5l.3.3c0,.1-.5.2-.5.2h-.5Z" fill="#0129e9" />
        <path
          d="M368.6,278.3c-.5.5-.2.8.9.8v.7c-.4.8.8.3-.9,1-.6-.5-1.8-.9-2.5-1l-1.5-2c2.6,1.8,1.9.5,4-.5,0,.3,0,.8,0,1Z"
          fill="#022def"
        />
        <path
          d="M382.1,269.3c-.3.1-1.9,0-1,1s.7-.8,1-.3c-2.3,1.2-1,1-1,1.8.7.8.9,1.3.2,2.1h.8c1.9,1.8,2,0,2.4-.1s3-.3,3.1-.5-.5-.9-.5-1.2,1.7-.1.5-2.3c1.3.6,2-.9,3.3-1s1.1.5,1.2.5c.9.3,2.2,1.7,1.5,2.5l-1,2c0-1.8-.5-4-2.5-4.5l1,2c-3.1-1.3-1.8.8-2.5,3,.3.1.3.3,0,.5-.5,0-.8-.8-1.2-.8l-2.8,1.8c1.8-.9,5,.6,6.2.5s0-1.8,1.3-.5c.9,1.3-.2,2.2-1,1-.2-.1-2.2-.2-2.6.3-1.3,1.8.4,2.2,1.1,3.7-.5.1-.8,1.5-1,2s0,.8-.5,1c-.8.3-1.3.2-1.3-.7,2.1-2.4.5-3.7-2.5-3.2l-.7-2.2c-.7.6-.8-.4-.5-1-.3-.9-.5-.7-.5.5.4,1,.8,2.2,1,3.5,0-.5.2-.4.5,0-1,1.9-.8,1.9.5,0-.8-.7,1.9-1.7,2.1-1.6,2.3,2.4.2,5.1-2.1,6.1-1.8.9-2.1,1.5-1,2,1.5,1.2,0,2.4-1.5,2,.6.3.6,1.6,0,2,.4.1.4.3,0,.5.8,2.1-1.8.8-1.8.7s.6-2.8,1.3-2.7c-.2-.3-.6-.3-1,0,.6.7.3,1-.5.5-.3.8-1.6.3-1.5-.5-1.5,0-1.7-.4-.8-1.8v-1.6c-1.2.7-2.2.9-2.2-.7-.9-1.3-1.9-2.3-3-3,1.6.6,2.7,1.8,3,3.5,2.3.9,2.9,1.7,1.9,2.5.7.9,0,1-1.1.8-.2,2.7-1.3,3.3-3,.7-1.1-.1-1.6-.3-1.3-1.5-2.4.3-3.4-.3-3-2-3.2.9-3.8-2.5-1-2.5,0-.6,1.7-.8,2-.6.3,1.2,1,2.4,2,1.1-.4,0-2.2-2.4-2.1-2.6.8-1.6,2-.6,2.6.6-1.2-.7-1.5-1.5-.9-2.4-1.1-.8-1.5-1.6-.1-2.1,1-.4,1.8-1.1,2.5-2-.2-.8-.7-1.4-1.4-1.9l.9-1.2c-1.6-.8,0-5.3,1.5-2.9q.7,1,0,0c-.6-1.1,1.1-1.3,2-1l1.3.3c0-1.2.8-.9,1.7-.3-.3-.4-.3-.9,0-1.5-1.7-.5-2.9-1.7-1.5-3,.2-.9,1.3-.7,2-.5.8-.4,1.2.8,1.4,1.6v3.4Z"
          fill="#0236ef"
        />
        <path
          d="M373.1,269.3c.9-.1.9.7,0,2.4.6,1.5.8,2.2,0,3.6.9,1.4.5,3.4-1.5,3-.1,1.2-.6,1.2-1.5.5-.3.8-1.4.3-1-.5q1.6-2.4,0,0c-.1.4-.3.4-.5,0-1,0-.6-.4,0-1-.9-.6-1-2.1,0-2.5,1.4-1.1,1.8-2.8-.3-3-.5-1.2.3-1.9,2.2-2,.5-1.2,1.9-1.8,2.6-.5Z"
          fill="#0236ef"
        />
        <path d="M392.1,275.8c1.2,1.2,1.2,2.1-.7,2s-.3-1-.3-1c1.1.1,1.1,0,1-1Z" fill="#0223e4" />
        <path d="M388.6,274.8v-.5l.5.2c0,.2-.3.3-.5.3Z" fill="#033ef2" />
        <path
          d="M383.6,277.8c.3.3,1.2.3,1.5.5s-1.2,1.5.8,1l-.7-2c3.7-.5,1.6,1.8,2.1,2.4s1.2.2,1.4.9-.7,1.7-.8,2.5.4.6.4.7c0,.2-.7.8-.5,1l2-.5c-.3.9-.5,1.7-1,2.5-1.4,1.1-2.8,1.5-4,.5-.3,1-.6,1-1,0-.7.3-1.4.5-2,1,.3-.5.4-2.9.6-2.9.7-.4,2,.4,1.9-2.1l2,1c-1.2-1.9.8-1.1,1-3.2s-2.2-.3-2.5-.2c-.2.4-.3.4-.5,0-.2,0-.3,0-.5,0-1.7.3-.5-2.1,0-3Z"
          fill="#022de8"
        />
        <path
          d="M381.1,271.8l1.5,1.1c0,.2-.3.7-.5.9-.9,1.4-1.8,1.8-3.5,1.5,1.6-1.7,2.5-.7,2.5-3.5Z"
          fill="#044bf5"
        />
        <path
          d="M383.6,277.8v3c-.3,0-2.4.1-2.5,0-.1-.2-.7-3.2.5-3l1,2c0-.8,0-1.7,0-2.5,0-.5,0-.7.5-.5,0,0,.5,1,.5,1Z"
          fill="#0441f1"
        />
        <path d="M383.1,276.8l-.5.5c0-.6-1.2-1.6,1-2.5.3.7-.5,1.6-.5,2Z" fill="#011ee0" />
        <path
          d="M378.6,289.8c.4,0,1,.5,1.5.5,0,.2,0,.3,0,.5-.5,1.1-1.8-.2-2.5-.5-.9-1-.2-2,1-.5Z"
          fill="#0125e5"
        />
        <path d="M381.6,289.8h-1c.3-.2.9-1.1,1,0Z" fill="#0125e5" />
        <path d="M384.6,280.8l-1,3c-1.6-.5-.5-2.5.5-3,.2,0,.3,0,.5,0Z" fill="#0441f1" />
        <path
          d="M375.6,285.8c1.3.9,2.4-1.6,3-1s-.4,4.8,1,3.5.3-1.9,1-2.3l-1.5.3v-2c1.3-.4.7.7,1.4,1s1,0,1.1,0c.2.1-.7,3.1-1.2,3.6s-1.8-.2-2.5,0l.7,1c-.3,0-1,0-1,.5-.5-.2-.8-.7-1.5-.5,1.2,1.6,1.5,1.1,1,3l-3.5-.5,1,.5c.5,1-2,1.4-1,2.5s2.3-1.6,2.5,1c-2.6-1.2-.4.9-3,1.5-1.4-.4-4.1-1.5-3.5-3-.7.4-1.2-.8-1-1.5,4.5-1.4.9-1.2.5-1.5s.3-1.4-1.5-1v-.5c.8-.1,1.8-.2,2.5-.5-.5.5.4,1.6,1,1s-.5-1.5-1-1c.3-.1.6-1,2-1s.9.7,1,.5l1-2c-.6,1.6.1,3,1.5,4l-.5-2c1.7,0,2.3.5,2-1.5l-2,.3c.5-.5.4-1.2.5-1.8v-.5Z"
          fill="#0230eb"
        />
        <path
          d="M371.6,278.3c-.6,1.4,3.5,3,3.5.5l1,.8c.3,1-.7.6-.9.8-.3.4.6,1.2.4,1.4-.9,1-1.1-1-1.3-1-.6,0-1.5.7-2.2.5.2.5.4,1,.5,1.5-.7-.1-1.3-.6-2-.5.8.8,1,1.7,1.5,2.5v.8c-1.4-.7-2.7-1.5-4-2.3.2-2.1-.4-1-1-1-.5.7-1,.3-1-.5,0,0-.1-.7,0-.9s1.2.4,2.4-.1c-.2-.7.1-1.1,1-1-.8-.8-.6-1.2.5-1,.5-.5.8-.6,1.5-.5Z"
          fill="#023ef2"
        />
        <path
          d="M374.1,276.3c0,.6-.5,1.2-.5,1.3,0,.2,1.9.2.5,1s-1.7-.2-2.5-.3c.3-.6,2.2-1.2,1.5-3,.5-.4.8,0,1,1Z"
          fill="#023ef2"
        />
        <path
          d="M376.1,268.8c.2-1.4,1.7-.8,1,.5-.8.3-1.5.8-2,1,1.7-.7,2,1,.7,1.5s-1.3-1.3-.7-1.5c-.3.1-1.4-.1-1.5,0s.2,2.9.2,3c.6,1.7.8-1.3,1.8-.5s-1.5,1.6-2,1c.4,1.5.7,1.1.5,2.5-.3-.3-.7-.8-1-1-.8-.5-2.2-.4-2.5-1.5.5.1,2.1.4,2.5,0,1.1-1.2-1.2-.6-1.5-1.2,1.2-.4,1.5-2.1,1.5-3.2-.2-1.3,1.5-1.6,2-.5.3,0,.7,0,1,0Z"
          fill="#0345f5"
        />
        <path
          d="M377.6,279.8c.3-.2,1.5-.5,2-1,.5,1.8-.9,1.4-1.2,2-.8,1.3.6,1.7-1.3,2,0,.3,0,.7,0,1-1,.1-1.1,0-1-1,.3,0,.7,0,1,0,0-.6-.1-1.2-.4-1.8.8-.1.9-1.2.9-1.2,0,0-1.1.2-1-.2.8-1.4,1.6-.3,1,.2Z"
          fill="#0442ef"
        />
        <path
          d="M372.6,282.8c1.1.2,1.9,0,2,0,.4.5-.4,2,1.5,1.7-.4.3-.4.8-.5,1.3s0,.3,0,.5c-1.6-.9-.6-3.1-3-2,0-.5,0-1.1,0-1.5Z"
          fill="#0442ef"
        />
        <path d="M380.1,267.8c0,.2,1.2.8,0,1.5l-1.5-1.5h1.5Z" fill="#0224e4" />
        <path d="M380.6,264.3l-2,.5c-.2-1.5.9-1.4,2-.5Z" fill="#0223df" />
        <path d="M378.1,275.3h-1c-.2-.7.2-1,.7-1.5l.2,1.5Z" fill="#074bf5" />
        <path
          d="M372.1,284.8c0,.1,2.1,2.1.2,2s-3-3.5-4.2-2.5c0-.2,0-.7,0-1,.7.4,2.4-.6,2.5-.5.3.4-.4,3.4,1.5,2Z"
          fill="#022be8"
        />
        <path
          d="M364.1,279.3c1.5,1.2,1.7.5,2,.5.4-1.4,2.4,0,2.5,1,.2.7-.6,1.1-2.5,1-1,.7,0,.9,1,.5.3-2,3.5-.2,1,1,1.4.3,1.3.5,0,1-.2.4-1.8.5-.3,1.8s.9.3,1.3.7c-.2.5-.6.4-1,.5-.2.4-.3.4-.5,0l-.5.5c.5.3.7.8.5,1.5-.9,0-1.5.9-2.5,1-.5,1.1-1.2,2-2,2.5-.6,0-.7-.6-2,0,.1,1.3,0,1.4-1,.5-.2-.2-.4-.3-.5-.5-.3-1.5-1.5-1.6-2.7-1.3-.3-2.8,0-3.7,1.2-2.7.5-.2,1-.6,1.5-1l-.5-.9c3.2-.7,3.1-1.6.7-3.9l.2-.7c-.5-.6-.1-1.2.5-1.5-.4,0-.4-.2,0-.5.3-1.3.9-1.2,1.5,0,.4.1.4.3,0,.5l-.5.5c.4.4.9,0,1.5-1-.6-1.2-.2-1.6,1-1Z"
          fill="#034cf5"
        />
        <path
          d="M365.1,290.3l.5,2c-.9-.3-1.8.4-2.5.5,1.5-2.2-1.7-1.7-1.5-2.2.4-1,2.5-.1,3.5-.3Z"
          fill="#0235ed"
        />
        <path
          d="M368.1,287.3l1,2.5c-.7.3-1.3-.5-1.5-.5-.9-.7-1.4-.4-.5-1.5l.5-.5c.1,0,.3,0,.5,0Z"
          fill="#0324e4"
        />
        <path
          d="M366.1,281.8c.4,0,.9.5,1,.5v2c-1.3.5-1.9.4-2.5-1l1.5-.3c-2.7-1.2-.1-1.2,0-1.2Z"
          fill="#0236ef"
        />
        <path d="M363.1,280.3c-.1.5.2,1.5,0,2.2-.5,1.5-1.5.5-1.4-1.2l.5-.5v-.5h1Z" fill="#0229e4" />
        <path d="M367.1,285.8c.5.5-1.1,2.3-2,2,.4-.6,1.3-2.8,2-2Z" fill="#0236ef" />
        <path d="M367.1,287.8l.5-.5c-.1,0-.4.4-.5.5Z" fill="#0245f3" />
        <path d="M361.6,281.3c0-.2.3-.5.5-.5l-.5.5Z" fill="#0244f4" />
        <path d="M354.7,287.3c-.2-.2.5-.8.5-.2s-.4.4-.5.2Z" fill="#0349ef" />
        <path
          d="M312.7,183.8c.3.3.6.3,1,0,.1-.3,0-.5.5-.5.8.7,1.4,1.1,2.5,1,.7.6.6,1.1.5,2l-.8,1c-.8,2.4-1.2-.1.8-1,.8,0,1.4.7,2.5-.5l-1,1.8,1.5-.3c.2,1.6-1.8.6-2,2.5-2.3,2.3-4,3.3-4.7-.8,0-.5-.3-1.1-.8-1.7-.3-.5.4-2.4-2-2-.2-.2,1.4-1.7,1.5-2,0,.2.5.5.5.5Z"
          fill="#0389f8"
        />
        <path
          d="M312.7,187.3c0,0,1,0,1.3.5s-.7,2.7,1.5,3.5c1.3-1.1-1.8-1-.7-2s1.9,1.5,2.5,1-.1-1.9,1-2c0,.5,0,1,0,1.5-.3,1.3.2,1.8,1.4,1.8.2.6.4,1.2.6,1.7l-1.3.5c.4.4,0,1-1.2,2-.1.5-.3.4-.5,0l-1-1.3c-1.5-.4-2-1-1.5-1.7-.5-.3-.8-.6-1-1-.1-.7-.4-2.1-.5-2.6s-.9-.5-1-.9c.9,0,1.1-.1.5-.5v-.5Z"
          fill="#036ef3"
        />
        <path
          d="M313.7,193.3c.6.1,1.9.8,2,1.5.2.5-.1,1.5-.5,2,.6,1.3-.1,1.5-1,.5-.4-1.2-.8-1.5-1-3-.2-.1-.2-.3,0-.5,0-.2,0-.3,0-.5.1-.4.3-.4.5,0Z"
          fill="#0760e8"
        />
        <path
          d="M314.7,192.8c0,1.2-.6,1.1-1,0-.2-.1-.2-.3,0-.5,0-.2,0-.3,0-.5,2.3.4.9.9,1,1Z"
          fill="#0252ea"
        />
        <path d="M312.7,187.8l.5.5h-1c0-.4.1-.5.5-.5Z" fill="#0389f8" />
        <path d="M313.7,192.8c.4.1.4.3,0,.5h-.5c0-.4,0-.8.5-1,0,.2,0,.3,0,.5Z" fill="#036ef3" />
        <path
          d="M317.7,204.8c0-1.2,1.5,0,1.5,1,1.4-.3,2.2,1.1,1,2h.7c-.3,1.4.2,2.5,1.3,3.5.1-.4.3-.4.5,0,.2.2.2.6,0,1,.7.4,3.1,2.6-.7,3,0-.7-.3-1.1-.8-1.5-.8-1.8-1.8-3.7-2.5-5.5s-.6-2.4-1-3.5Z"
          fill="#0b4fdf"
        />
        <path
          d="M315.7,197.3c.5,0,.9.5,1,1,.2-.4.3-.4.5,0,.5,0,.7,0,.5.5-.5,1.8-.5.1-.4.2.5,1,.8,2.4-.6,2.3.5.9.5,1.4,0,1.5-.3-.6-.3-.9-.5-1.5l-.5-.5c-.4-.7-1.2-2.2-1.5-3s0-.3,0-.5l1-.5c.1-.4.3-.4.5,0,.4.2.4.3,0,.5Z"
          fill="#0e5fe0"
        />
        <path
          d="M316.7,201.3c.4,0,3.6.7,3.7.8.3.5,0,3.8-1.2,3.7-.4-.6-.7-1.2-1.5-1-.2-.5-.7-1.2-1-2,0-.5,0-1,0-1.5Z"
          fill="#0454e3"
        />
        <path d="M316.2,201.3c-.2-.2-.4-.3-.5-.5.2,0,.4.3.5.5Z" fill="#0368f0" />
        <path
          d="M304.7,169.3c.4.1.4.3,0,.5,0,.3,0,.7,0,1,0,.7.3,1.6-.5,2-.1-.5-.4-.7-.5-1.5-.7-.5-1.1-2.1,0-2,.3,0,.7,0,1,0Z"
          fill="#0c55da"
        />
        <path
          d="M322.7,212.3c.3-1.6,1.5-1.8,3.5-.5.1-2.3,3.2-1.2,1.5.5l.5,2.1c2.5-.4,1.8,3-.5,2.9-.5-.6-.8-.4-.9.6l-1.1.4h-.5c0-.2-.4-.3-.5-.5v-.5c-.1-.2-.5-.9-.5-1q.8-.5,0,0c-1.4-1.8-1.7-1.3-1.5,1-.8-1-1-2.3-1.5-3.5.8-.2,1.1.2,1,1,2.4-1.3,0-1.6,0-1.7s.4-.5.5-.8Z"
          fill="#0363f1"
        />
        <path
          d="M295.7,149.8c1.3.9,1.8,1.9,1.5,3,.3-.6.6-.7,1-.5.3-.7.6-.6,1,.5.1-.4.3-.4.5,0,.4.1.4.3,0,.5-.1.4-.3.4-.5,0l-1,.5-.3.7c1.1.3,1,1,.3,1.8.4.1.4.3,0,.5h-1.1s-2.4-5.5-2.4-5.5c0-.3,0-.7,0-1-1-1.6.2-2.6,1-.5Z"
          fill="#0b65df"
        />
        <path
          d="M292.7,143.8c1.1-.2,1.5.6,1.9,1.5s.7,2.7.6,3l.5.5c.7,0,.5.6,0,1-1-.6-1.1-.8-1,.5-.2,0-.3,0-.5,0,0-2-1.3-2.9-1.5-5-.4-.7-.4-1.2,0-1.5Z"
          fill="#0c6fe3"
        />
        <path
          d="M280.2,108.9c0,.3.4.6.4,1.2s-.3.6-.4.8c-.2.9.3,1.2-1,1v-2s-1,.5-1,.5c0-.3,0-.8,0-1-.4-1.5,1.1-.9,2-.5Z"
          fill="#0487f0"
        />
        <path
          d="M282.7,112.4c.3,1,.2,2.2-1,2.5s-.3,0-.5,0l-.5-.5c0-.5.4-.4.5-.5l.5-.5v-.5c.1,0,1-.5,1-.5Z"
          fill="#0487f0"
        />
        <path
          d="M277.2,107.4c.6-.7,2.5-.4,3,.5,0,.3,0,.7,0,1l-2,.5c-.2-.5-.2-.5-.5-1s-.3-.3-.5-.5c0-.2,0-.4,0-.5Z"
          fill="#0970e2"
        />
        <path d="M281.2,114.9c-.4,0-.5-.1-.5-.5l.5.5Z" fill="#0581ee" />
        <path d="M281.2,113.9c0-.2.4-.3.5-.5l-.5.5Z" fill="#0581ee" />
        <path
          d="M290.7,138.8c.7-.6,1-.3.5.5,1.8-.1,2.5,3.4,1.5,4.5,0,.5,0,1,0,1.5-1.5-1.9-2.3-4.7-3-7,.3.2.8.3,1,.5Z"
          fill="#146fd8"
        />
        <path
          d="M285.2,120.4c2.2.3,2.3,2,1,3.5l.7.3c-.2.9,0,1.6.8,2.2-.7.5-1.2.4-1,1.5,3.4-1.2.4,1.1.4,2.3s.7,1.3,1.1,2.7c-.4,0-1.2-1.1-1.5-1.5-.8-2.7-1.4-4.9-2.5-7.5s-.8-1.3-1-2c-.4-.8.3-1.4,1-1.5.1-.7.7-.6,1,0Z"
          fill="#0578ea"
        />
        <path
          d="M284.2,120.4c0,.7-.3,1.3-1,1.5-.1-.4-.5-.9-.5-1s0-.3,0-.5c.2-.5.5-.8,1-.5.6-.3.9-.1.5.5Z"
          fill="#0589f6"
        />
        <path
          d="M284.2,119.4c.7.6.4.8-.5.5-.3.2-.7.3-1,.5,0-1.6,1.3-.4,1-2,.8-.5,1,.3.5,1Z"
          fill="#0578ea"
        />
        <path
          d="M325.7,218.3c0-1.7,2.1-4.2,2-1,.8.2.7.5,0,1-.2,1.4,0,1.4.5,0-.4-.7.4-1.3,1-1,.4.1.4.3,0,.5l.7-.2c.8,1.5,2.1,1.6,3.8.2.8-.6,1-.4.5.5,2.1,1.2-.2,2.2-1.5,2.6,0,1.8-.7,3.7-1.5,1.4-.7,2.5-1.5,3.1-2.6,1.7-.7.5-1.2.5-1.9-.2-.3-.7-.7-1.7-1-2.5,0-1,0-2,0-3Z"
          fill="#026ff6"
        />
        <path
          d="M331.2,222.3c1.3.6,1.3,1.1,0,1.5,0,.2.6.8.5,1-.3.3-2.8.6-3.5.5h-.5c-.2-.5-.8-1-1-1.5,2.3-.9,1.8-1.7,3.5.5l-.5-2.2,1.5.2Z"
          fill="#035def"
        />
        <path
          d="M325.7,218.3c.5.6,1.3,1.5,1.5,2.2-1,.5-1.7-1.2-1.5.8-.5-1.4-.3-2.3-.5-3l.3-.5c.3,0,.2.4.2.5Z"
          fill="#0455eb"
        />
        <path d="M324.7,217.8v-.5c.2.5,0,.5,0,.5Z" fill="#026ff6" />
        <path
          d="M220.7,115.9c-.3,2.6-1.1,4.3-2.5,5-.7.3-1.5-1.5-.5-2-.5-.1-.4-.3,0-.5v-1c-.4-.2-.4-.3,0-.5.2-1.8.7-2.5,1.5-2l1-.5c.2-.7.5-1.1,1-1,0,.9-.3,1.7-.5,2.5Z"
          fill="#095cd2"
        />
        <path
          d="M222.2,107.4c.4-.4.5,0,.5.5l-.5.5c.5,0,.7.7.5,2-.4.7-.4,1.1-1,2-.6-.2-.9-.7-1-1.5-3.1-1.2,0-5.7,1.5-3.5Z"
          fill="#0d70e5"
        />
        <path
          d="M228.7,87.9c1.7.5.5,1.5.5,2.2s1.2-.6.5,1.8c-1.4.8-1.8,2.4-2,4-.4.7-.3,1-1,2-.3.2-.2.3,0,.5v1.5c-.3.3-.8.7-1,1,.1-1.1,0-1.1-1-1-1-1-.2-1.9,1-2q.2-.2,0,0c-.2,0-.4.1-.6.1-1.7,0,0-6.9.6-8.1-3.2,2-2-4.7.5-2.5,0-.5.3-.4.5,0,.5-1.4,2-1,2,.5Z"
          fill="#216adf"
        />
        <path
          d="M229.7,83.9c.8.6.1,1.6,2,0,.2.7-.2,1-.5,1.5s-.9.3-1,.8c-.1.8,1.3,1.2,1,2.2-.3.4-2.9-2.8-2.5-.5-.3,0-1.9-.5-2-.5-1.9-1.7-.7-2.2,1-2.5-.1-1.4,1-3.3,2-1Z"
          fill="#2f6cdd"
        />
        <path d="M229.7,91.9c-.5,1.7-1.3,2.6-2,4-.9-1.6.3-3.4,1-4.7l1,.7Z" fill="#1d5ed7" />
        <path d="M226.7,98.4l-.5-.3c.1-.2.4-.2.5-.2v.5Z" fill="#1967c8" />
        <path
          d="M230.7,74.9l1.5,2.5c-1.8-.4-1.8,1-2,2.5l1-1.5c.4-.3.8.8,1,1,0,1.5-.8,1.7-2,1v1.5c-.1,0-.3,0-.5,0l-.5-.5c-.2,1.3-.5,2.4-1.4,1.2-1.2-.2-2.4-.7-3.6-1.2-1.3.6-4.9-.9-5-2l-.5.5c-.2.4-.3.4-.5,0-.2.3-.3.3-.5,0-.4-.1-.4-.3,0-.5-.4-.1-.4-.3,0-.5-2-1.5,2.7-2.5,3.9-2.5,3,1.1,6,1.5,7.7-1.6h1.3Z"
          fill="#4e79e5"
        />
        <path
          d="M224.2,81.4c.4-.4,2.1-1.3,2.5-1-1.1,1.7.9.3,1.2,2,1.7,0-.8-1.2,1.2-1,.2.2.2.3,0,.5l.5,2c-.2-.2-.9-.6-1-.5.1.9-.7,1.1-1,1.5-1.9,2.1-3.8-.7-4-2.5-1.1-.7-.9-1.1.5-1Z"
          fill="#3a76e5"
        />
        <path d="M229.7,81.9h-.5v-.5c.3,0,.4.2.5.5Z" fill="#3e6bdb" />
        <path
          d="M217.7,118.9c0,.2.5,1.9.5,2,0,.4,0,1.1,0,1.5-.2.8-1.1,2.6-1.5,4-.1.4-.3.4-.5,0-1.4.4-3.1.8-3-1-1,.1-1.2-.3-.5-1-.4-.2-.4-.3,0-.5.1-.4.3-.4.5,0,.7-1,1.1-2.1,1.3-3.3h1.2c-1-2.1.7-3.4,2-1.7Z"
          fill="#066ae5"
        />
        <path
          d="M216.2,126.4c0,1.7-1.7,3.7-2,5.5s0,.3,0,.5c-.1.4-.3.4-.5,0-.6-.6-1.1-1.5-1.5-2.5-1,.6-.9-2.8-.7-3.2s.4-.6.7-.8c-1.1-1.1.1-1.5,1-.5.8,0,1,1,2.5-.5-.3.7.5,1.4.5,1.5Z"
          fill="#0775e9"
        />
        <path
          d="M246.2,413.7c.4.3.3,1.2,1,1l1-2.5v1.5c4-.9,2.5-.1.7,2l-.7-1.5c-1.4.5.8,5.3-1,4s0-.6-.2-.8-.8-.1-.8-.2c0,0,.7-1.3.5-1.5l-2,.5c-.3-.7,2-.4,1-1.5s-1.3-.2-1.5-.8c.8-1.1.7-.5,1.5-.3s.4,0,.5,0Z"
          fill="#02308c"
        />
        <path
          d="M253.7,410.2l.7,1c-1.5,1.1-1-.9-2.7-.5-.2-.1.6-.9.5-1,.7-.2,1.1.4,1.5.5Z"
          fill="#01288a"
        />
        <path
          d="M265.2,410.7c-.5,1.3-3.9,3.5-.3,3.5s0-1.3.8-1c.5,3.7-2.1,1.9-3.5,0-.5,0-.7-.6-.5-1,1-1.5,1.4-.4,1.9-.7s.4-1.3,1.6-.8Z"
          fill="#012b8b"
        />
        <path
          d="M265.2,410.7c0-.8-1-.4-1.5-.8-1.2-.9-.5-2.6.9-1.5-.9,1,1.1.9,1.6,2l-1,.2Z"
          fill="#0347a5"
        />
        <path
          d="M262.2,413.2c.1.3,0,1.1,0,1.5-1.9.5-1.4-.9-1.5-1l.5-.5c.1,0,.4,0,.5,0,.2-.3.3-.3.5,0Z"
          fill="#02318a"
        />
        <path d="M262.2,413.2c0,0-.4,0-.5,0-.7-.8-.2-.7,0-1,.2.3.3.7.5,1Z" fill="#0343a4" />
        <path d="M266.7,413.2c-.2.2-.8-.5-.2-.5s.4.4.2.5Z" fill="#023ea6" />
        <path
          d="M251.7,416.7c0,.9-.4,1.4-1.5,1.5h.5c.7-1.1,1.2.2.5,1,1,.1,1,.6,0,1-.4.2-.9.2-1.5,0,0-.2,0-.7,0-1l-1,.5c-1.4-.7,1.3-5.4,2.1-6s2.9,2.4.9,3Z"
          fill="#02318a"
        />
        <path
          d="M251.7,416.7c.3-1.7,2.3-1.6,2.8.2l1-2.1c-.8-3.2,1.6-3,3.7-1.5.6-.5,1-.3,1,.5-.2.3,1.2,3.3,1.8,2.6-.3-1.8.7-2,3.1-.6,1.2-1.3,1.9-1.4,2.1-.4.5,1,1.2.7,2.5,1,1.1.2-.2,1.7-1,2-1.1.5-1.5,1.1-.5,2,.5.9.8.9,2.3,1.1v.7c-1.8,1.7-1,2.3,2.2,1.8.3-.2.7-.3,1-.5.4.2.4.3,0,.5.4.1.4.3,0,.5.3.7-.2.8-1.5.5-.2.1-.4.3-.5.5v.5c0,.1,0,.3,0,.5l-.5.5c-.4.1-.4-.4-.5-.5l-.5-.5c-.1,0-.4,0-.5,0-.7,0-.9.7-.5,2,.8,0,1.3-1.6,2,1-.4.3-1.8-1.4-3,1-.7-2.5-1.7-.8-3.5-1.5l1.5-1.2c-.5-.9-1.5-.1-2-.5s.3-1.5-1.2-1.8l.3,2c-.6-.9-1.9-1-1-3-.3-.2-1.3.5-1.7.5s-.5-2-1.3-1,1.6,2.9,2.5,2.7c-.8.6-1.7,1.5-2.5,1.9s-1-.2-1-.2c-.3.6.5,2.1.3,2.5s-1.2.4-1.3.5h-.5c.5-2,.4-4.7-1-6l-.5,2.5v-4c-1.5.9-2.4,0-.7-.7s.6.2.7.1c.4-.6.7-2.4-.4-2.4l-2,3.5c-.3-.1-.3-.3,0-.5.2-1,0-2,1-2.8-.5-.4-1,.6-1.5.8-1.3-.1-1.3-.4,0-1,0-.7-.2-1-.5-1-.9-1.1-.9-1.9,0-2.5Z"
          fill="#02318a"
        />
        <path d="M269.7,425.7l-.5,2c-.1,0-1-1.2-1.5-1.2l1-1.8c.4-.3.8.9,1,1Z" fill="#022c7f" />
        <path
          d="M265.2,421.2c-1.5,2.9,1.6,1.5.5,4-.8.1-.4-.8-1-1.2s-1.4-.2-1.5-.3c-.5-.6.8-2.9,2-2.5Z"
          fill="#012b7c"
        />
        <path
          d="M258.2,422.7c1.1.9-1.3.8-1,1.5l1.5.5c-1.3.6-2.4.1-2.5-1.5.5,0,1.7-.8,2-.5Z"
          fill="#022b82"
        />
        <path
          d="M251.7,419.2l.5-1h.5c.9,1.9,0,1.3-.5,2-1,.7-.6.4-1,0,0-.3,0-.7,0-1h.5Z"
          fill="#022b82"
        />
        <path d="M256.2,422.2c-.2-.2-.3-1.9.7-1.5,1.5.6-.3,2-.7,1.5Z" fill="#022b82" />
        <path
          d="M268.7,418.2c-.4.7-.8,1-.5,2,0,0-1,.6-1,.5.4-1.8-1.2-2.8-.5-4.5l2,2Z"
          fill="#023b94"
        />
        <path d="M267.5,417.2c.3.2.3.3,0,.5v-.5Z" fill="#02318a" />
        <path d="M250.2,418.2h.5c-.2.2-.5.5-.5,0Z" fill="#022b82" />
        <path
          d="M86.3,173.3c-1,.3-1.8.8-2.5-.3-.1-.4,2-.3,2-1s-1.6-.4-1.5-1.2c2.3-.4,2.6.5,2,2.5Z"
          fill="#010dca"
        />
        <path
          d="M91.3,174.8l.3,1.5c-2,.3-3.6,3-1.3,3.5,1.8-.3,1.8,1.4,0,1-1.8.8-2.3,1.8-1.5,3-2.3-.4-2.9.4-2,2.4-.7,1.6-.7,3.3-.5,5l-1,.6s-.3.5-.6.4-1.1-1.1-1.3-.9c-.8.5-.3,3.7-2,4-.3-.5-1.8-1.1-2.2-1s0,1.3-.8,1c-.6-1.5.2-3.3,2-3,.3-.6-2.2-.6-1-1.5s1.4.2,2-.2.5-2.3,2-2.5c-.3-.4-1-.3-1.5-.7-.5-1.8,1.9-2.9.3-4-1,1.3-1.1.7-1.8.5-.5-.7,0-1.6,1-1.5,1.1-1.3,1.3-2.3.6-3l1.1-1.1c-.4-2.3,1.1-4,3.2-4.4,1.7-1.5,4.5-1.4,5,1Z"
          fill="#010dca"
        />
        <path
          d="M91.8,175.8c.6,0,.9.1,1,.5,1.4.2,1.3,1.5,0,2-.2.8-1.5,1.5-2,1s3-3.1-1.5-.5c-.1.6.6.6,1,1-2.4,1.5-3.5-1.1-3.7-1-.5.2-.8,1.3-1.7,1-.2-.8,0-2.1,1.2-1.9s2.3,2.6,2.8,1.9-1.2-1.6-1-2.2,1.1-.5,1.4-.9,0-1.3.1-1.3c.7-.7,1.8,1.7,2-.5,1.4-.3,1.7.1.5,1Z"
          fill="#0113d1"
        />
        <path d="M80.6,193.8c.3.2.3.3,0,.5v-.5Z" fill="#010ac4" />
        <path d="M81.3,182.3c-.2.2-.8-.5-.2-.5s.4.4.2.5Z" fill="#0105ba" />
        <path d="M86.8,173.3c.2,0,.3-.4.5-.5l-.5.5Z" fill="#010dca" />
        <path d="M142.8,99.9l.5-.5c-.1,0-.3.4-.5.5Z" fill="#6580ec" />
        <path
          d="M155.3,99.9c.3.6.1.8-.5.5-1.2,1.9-3.1,3-5.5,3.5-1.3.8-2.8,1.3-4.5,1.5-.2.3-.7.3-1.6.1-1.5,1.1-3.8,2.3-2.4-.1-.2-3.1,4.2-2.2,5-2.8s.4-1.1.5-1.2,1.1.6,1.6.5.5-1.1,1.1-1.5c.9-.6,1.6-.8,2.7-1.6.4-.1.9-.1,1.5,0,.1-.2.3-.3.5-.5,1-1.5,2.6.2,1.5,1.5Z"
          fill="#225be2"
        />
        <path
          d="M163.3,91.4l.4.6c-1,1.4-2.6,2.3-4.9,2.9.4,1.6-2.7,2.8-3.5,1.5-3.9,1.7-8.5,3.1-12.5,5,4.3-3.2,9.4-4.9,14.2-7.1s4.1-2.1,6.3-2.9Z"
          fill="#456de5"
        />
        <path
          d="M144.8,105.4c1.9.9,1.2,1.5-2.3,1.9-1.9,2.1-2.9,2.3-3.2.6,0,.4-.4.7-1,1-.1.5-.4.9-.8.9-2,0-3.2.1-3.1,2.5-.7,1.6-2,1.8-4.1.6l-.5.5c.4.2.4.3,0,.5-1-.7-1.7-.9-1.5.5h-.5c-1.3-3.1,2.4-3.2,4.1-4.1s4.7-2.4,6.4-3.9.6-1.3,1.3-1.4c.5,0,.8.2,1.2.4s.4,1.1,1,1l.8-2,2.3,1Z"
          fill="#154dde"
        />
        <path d="M153.3,98.9c-.2.3-.4.8-.8,1s-.4-.8-.7-1c.5-.3,1.1-1.2,1.5,0Z" fill="#2d67e5" />
        <path
          d="M108.8,156.3c.4.1.4.3,0,.5v1.5c.7.3.5.8-.5,1.5.3,1.1-.4,1.9-2.1,2.4v1.1c4.3,1.9,3.4,4,1.6,7.5.3.1.3.3,0,.5-1.2,1.2-2.7-1-2-.7s.9,2-.5,1.7c-.5.2-1,0-1.5-.5-.9.7-.9.7-1-.5-1.1-.5-1.7-.4-3.6.6.1-1.1-.2-1.8-.9-2l.9-2c-.9-.9-1.7-3.2.2-3.1.2-.2.3-.3.5-.5.3-.3.5-.5.5-1-1.1-1,.3-1.6,1.3-.6l.7-.9,1.5-.5c-1.3-1.3-.6-1.3-.5-2,.1-.4.3-.4.5,0,.3.7.7,1.2,1.5,1-.7-1.5,1.6-2.1,1-4,.7,0,1.9.1,2.5,0Z"
          fill="#0128e2"
        />
        <path
          d="M108.8,156.3c2-.3,2.2-1.8,4-2.5-.7,2.2-2.2,2.5,1,3l1-3c2.3,1.8-1.2,3.8,2.5,4l.2,1c-.9.2-1.8.8-2.7,2,.3,1.1,0,1.4-1,1.5-.1.3-.3.3-.5,0-.3-.8-1-.8-2.1,0l-.4-.5c0,.5-.2.4-.5,0-1.2.3-1.7.2-1.5-.5-.9.2-1.1-.3-.5-1.5l-.5-.2c.3-.4.8-.8,1-1.3-.6-.3-.3-1,0-1.5v-.5Z"
          fill="#023fe8"
        />
        <path d="M108.3,151.8v-.5c-.7-1-.4-1.2.5-.5,1.1,1,.9,1.7-.5,1Z" fill="#0236e5" />
        <path
          d="M112.8,144.8c1.4-2.2,2.8-1.6,3.5,1,.8,1,.1,1.6-1,1l.5,1c1.2.8.9,1.4-.5,1q-.8-.3,0,0c.5.5.3,1.1-.4,1.9,1,.5,1.7,1,.9,2.1.3,1.1-.3,1.3-2,.5q-1.7-1.2,0,0c.7,0,1,0,1,.5.8,3.1-1,5.3-4,2.8-.7.6-1.3.5-2-.3-1.1,1-2,1.7-2.5,0-.1,1-.6,1-1,0-.2-.2,0-.5.5-1-.4-1,.4-1.4,1-.5,2-.2,2.7-.7,1.9-1.7l1.1-1.8q1.4-.9,0,0c-.7,1.3-1.1.9-1-.5-.4,0-.4-.3,0-.5l1.8-2.5.8.7-2.5-1.5c1.1-2,3.4.4,3.5.2,1-1.1-1.4-1.7-1-2,.6,0,1-.4,1.5-.5Z"
          fill="#0236e5"
        />
        <path
          d="M105.3,153.8c.1,0,1.1-2.9,1-3l-1.5-.5c1.5-.8,2.6,1.8,3.5,1.5s.5-.3.5-1c.2,0,.9.6,1,.5s1-3,1.5,0h-1.5c.5,1.3.9,1.3-.5,1.7,2.1,1.4-1,3.6-2.5,1.8-.3-.3-.8-.7-1.5-1Z"
          fill="#022ade"
        />
        <path
          d="M108.3,151.3l-1.5-1.7c1.5-1.5,2-1,2,.7s0,.3,0,.5c-.4,0-.5.1-.5.5Z"
          fill="#022ade"
        />
        <path d="M113.8,153.3c-.5-.3-2.2,0-2.5-1.5,1.8-.5,2.4,1.4,2.5,1.5Z" fill="#0122d1" />
        <path d="M112.8,149.3c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#0551ec" />
        <path d="M115.8,147.8c-1.3-.7-.8-.6-.5-1,.5.1.5.6.5,1Z" fill="#022de3" />
        <path d="M115.3,148.8c-1,.1-1.1,0-1-1l1,1Z" fill="#022de3" />
        <path d="M114,146.8c.3.2.3.3,0,.5v-.5Z" fill="#022de3" />
        <path d="M105.3,156.3l-.5-.2,1-.8c-.2.2-.3.7-.5,1Z" fill="#0128e2" />
        <path
          d="M123.3,135.8c.8-1,.7.8.7.8-1-2,1.7-2,1.3-.3.2.7.9,1,2,1,1.2,1,1.9,3-.5,2.5-.2.6-.7.6-1.5,0,.2.6,0,.9-.5,1-.5.5-1,.7-1.5.5l-.6.3c.6,1.4-.3,3.3-2.9,2.7-1.2-1.6-.9-3.9-3-3.5l.5-1c.2,0,.4,0,.5,0,.3-.7.7-1.3,1.5-1.5.2.1.4.5.5.5.4.2.8,0,1-.5.1-.2-.1-.8,0-1l1-.5c.1,0,.4,0,.5,0,.5-.2.9-.4,1-1Z"
          fill="#0246ec"
        />
        <path
          d="M119.3,138.3c0,.4.1,1.4,0,1.5s-1.1-.1-1.5,0l1-4c1.5.5.7,1.5.5,2.5Z"
          fill="#0236e5"
        />
        <path d="M120.8,138.3c0,.9.2,1.2-.7,1l-.2-.5c0,0,1-.5,1-.5Z" fill="#0236e5" />
        <path d="M112.8,139.8c.2,0,.8-.7,1-.5.3.5,0,1.3-.7,1-.3,0-.2-.4-.3-.5Z" fill="#0236e5" />
        <path d="M121.8,136.8l-1,.5c.4-.7.6-.3,1-.5Z" fill="#0236e5" />
        <path d="M117.3,143.8v1c-.4-.3-3.1-1.1-.7-2s.4.7.7,1Z" fill="#0236e5" />
        <path
          d="M123.3,141.3c1.7.3,1.1,2.8-.5,3-.7.2-2.4.4-2.5.5-.2-.2-.4-.3-.5-.5.7-.1,1.9-.4,2.3-1,.6-.9-1.3-1.9,1-2.5l.2.5Z"
          fill="#023ae7"
        />
        <path
          d="M139.3,113.9c0-1.3.6-1.3,1,0,.7-.8,1-.5.5.5q-.8.9,0,0c.2-.1.4-.2.7-.2.6,0,1.8,2.9,1.8,3.2,2.2-.6,2.7,1.1.5,1.5l-2.1.7c-1.5-1.5-2.2-1.5-2.1.9-1.8,2.1-2.8,2.6-3.2,1.3,0-.2,0-.4,0-.5-.8-.3-1.2-1.3-1.5-2,0-.3.7-.5,1-.5v-.5c-3.4,0-.7-1.1-.5-1.5s0-.7,0-1,0-.4,0-.5c0-1,.8-1.5,2.5-1.5.5-1,1-1,1.5,0Z"
          fill="#0248e8"
        />
        <path
          d="M136.3,121.9c2.4.2,1.9,2.9-.7,3-.6,1.4-1.4,1.9-2.3,1.5-.8,0-.7-.8,0-1-1-.7-1.3-.1-1.5,1h-.5c-.1.2-2.7.5-3,.5-.4.7-1.2.8-1.5,0l.5-2.5c1-.2.2,1.2.5,1.5s1.9,0,2.5,0l-1.5-.7,1.5-1.7h-2.5c1.2-.4,1.8-1.2,3.1-.5s0,1.2.9,1c.8-3.2-.1-2.1-2.5-2.2,1.6-.5,2.3-.9,2.5-2.7,2,.7-.2,1.4,0,2.2.3,1.5,3.4.9,4.5.8Z"
          fill="#0354e9"
        />
        <path
          d="M126.8,126.9c.5,0,1,0,1.5,0l.5.2c-.7,1.1-1.9.9-3,.3v-.5c.3,0,.7,0,1,0Z"
          fill="#0227d6"
        />
        <path d="M136.3,121.4c-1.2.1-1.8-1-1.5-2,1.2.4,1.2,1.1,1.5,2Z" fill="#065dee" />
        <path
          d="M125.3,133.8c.9.7.7-.4,1.5-.5.4.5-1.9,3.3,1,1,0,2.2,1,1.7-.5,3,.4-.3,1.2.4,1.5.5,2.1-.3,5.7.4,6.5,2.5.8-.1.5,1.1,0,1.5-.8,1.1-.6-.2-.6-.1.3.5.6,1.5,0,1.8s-5.2-.5-4.3-1.6c-1.3-.6-2.5-1.3-3.5-2,2.2.5-.7-1.5.5-2.5-.9.7-1.6.6-2.2.8s-.9.9-1.8.7c-.4-.4,1.8-2.5,2-2.5.3-1.2-.6-1.7-1.4-.5l-.6-1c.1-.2.3-.3.5-.5-.1-.7.3-1,1-1,.6-.6,1-.3.5.5Z"
          fill="#0253ec"
        />
        <path
          d="M123.3,134.8c2.3.2,1.5.3,2.5,1.2s.9-.4,1-.2c1.5,1.7-1.4.5-1.5.5.1-1.8-1.4-1.4-1,.5h-.5c0-.4-.4-.7-.5-1-.3-.7-.3-.4,0-1Z"
          fill="#0249e7"
        />
        <path
          d="M98.8,173.3c-1.8-1.4,2.3-2.6,3.4-2.2s.6,1.9-.5.3h1.1c0,0,.9,0,1,.4,0,.2.4.6,1.5,1,1.2-2.1,2.6.7.5.5-.6.6-1.3,1.1-2,1.5.7.2,1.2.5,1.5,1,.2-.8.4-1.3,1-.5h.5c-.6-.7-.4-1,.5-1,.6-.6,1.6.2,1.5,1h1c2.8.3,1.1,4.3-1.5,1.5-.7.9-1,1.9-.5,3v.6c-1.3,0-1.6,0-1,.4.7.1,1.2.6,1.5,1.5v.5c-.2,2.1-4.8.7-5-1,0-.2.3-.4.5-.5.3-.5,0-.8-1-1-.2-.2-1.3-.7-1-1,1.2.5,2.2-.6,1.5-1.5s-2.7.4-1.5-2c-.1-.2-.5.6-1.5.5l1-2.5c-1.3-.5-1.2,1.5-1.7,1.5s-1.2-.4-1.3-.5.6-1.1.5-1.5Z"
          fill="#0227e3"
        />
        <path
          d="M99.3,164.8c-.3.4-1,.4-1,.8,0,1.2,1.7,1,1.8,2.2s-1.3,2.3-.8,3.5c1.2-.8,1.3-2.3,2.3-3.5s1.2-.5,1.2-.5c.2-.2-1.2-1.3-1-2-.6,0-.9,1.6-1.7,1.5s-1-1.2-.7-1.5,2.6-1,2.7-1c.5,0,1.9,2.8,1.8,3.2-.3.8-1.9.7-2,.8-.1.1,1.4,1.8-.5,1.5-.2.9.9.3,1.4.6s0,.8.1.9l-.5,1.2-1-1.2c.3,2.1-2.8-.2-2.5,2,0-.2-1.3-1.3-1.5-1.7.4-.9,1.5-.2,1.5-.2,1.3-2.6-2.1-.2-2.5-2,2.9.2,1.5-2.2,1.8-4.2s.3-.2,1.2-.3Z"
          fill="#011ede"
        />
        <path
          d="M100.3,163.3c-2.4-.2-3.3-4.5-.3-3.5s0,1.1.3,1.4,1.4.2,1.9.6c1.7,1.4-1.6,3-1.6,1.1-.2-.1-.3.4-.4.4Z"
          fill="#0118d6"
        />
        <path d="M103.3,159.3c0-.5,0-1,0-1.5l2,.5c.2.7-.9.6-1.5,1h-.5Z" fill="#010dc7" />
        <path
          d="M91.3,174.8c.2-1.8.2-.4,1-.8s.9-1.3,1.7-1.2c.1,0,.8,1.9.8,2s-.9.4-1,.7l2-.2c.4,1.5-.5,2.3-.8,3.4s.4,1.1.3,1.1c0,0-1.9.4-2,.3-.6-.4-.4-1.2-.5-1.8s0-1.5,0-2c.5-.5.2-.7-1-.5-.1-.2,0-.7-.5-1Z"
          fill="#0118d6"
        />
        <path
          d="M219.7,333.7c.2,2.5-.8.5,0,.3s.8,6-1.1,5.7c.3,1.6.2,2.4-.4,2.5.4.2.4.3,0,.5-1.4,2.2-3,4.3-4.7,5.9-.3,1.8-.9,3.5-1.8,5.1.2.2.2.3,0,.5l-.8.7c-1.4-.3-2.5-.3-3.7.3-.2,1.6-1.3,2-2,.5v-1c.5,0,1,0,1.5,0,0-.5,0-1,0-1.5.8,0,1.7,0,2.5,0l-1-1.5h2s-1-1.3-1-1.3c3.6-.8,1-1.3,1-1.5-.5-1.7,1.1-1.2,2-2s1.1-2.5,2-3.5,2.8-1.4,3-4.2c-.6,0-1.4,0-2,0,0-1.6,3.4-1.3,3.5-1.5.2-.5-1.8-6.1,1-4Z"
          fill="#01197b"
        />
        <path d="M208.7,348.7c.2-.1.3-.4.5-.5l-.5.5Z" fill="#011452" />
        <path
          d="M201.7,360.2c.6,1.8.7,3.6-1.3,4.9.7,1.3,0,2.8-1.6,2.5,1,1.6-3.1,3.3-3.6,1.7-.2-.5-1.5-1-1.5-1.2s2.1-1.4,1-2.7c.8-.8,1.5-2.5,2.6-3.2s3.1-1.2,4.4-1.8Z"
          fill="#012173"
        />
        <path
          d="M207.2,355.2c2.2.6,2.2,1.6,0,3,1.1.7,1.2,1.2.5,1.5,0,1.3-.7,2.2-2,1.5-.8.8-3.5,2.5-4,1.5l.7-3.3c0,0,0,1.3-.7.8,0-.2-.5-.7-.5-1.2s.7-.3.8-.5c.3-.5.4-1.2.7-1.5s1.9-1,2.5-1.3,1.5,0,2-.5Z"
          fill="#01207b"
        />
        <path
          d="M201.7,360.2c.4-.2.3-1.2,1-1l-.5,3.5.6-.9,2.9-.6c.3.7-.4,2.3-1,3-.2.4-.3.4-.5,0-.2-1-.5-.9-1,.5.5.4.3.5-.5.5-2.3.4-1.9,1-2.5,3,.3,0,.7,0,1,0-.2.9-1.2,1.5-.9,2.4s1.8-.2.1,1.1c-1.2-2.7-.9-2-3.7-1.5l1.5,1.5c-.6.4-3.3.7-2,2h-.5c-1.6-1.1-.4-2.5-.5-4s0-.4,0-.5l3-.5-1-2.5,3,.5c-2-2.2.3-2.7,1-3.9s.4-2.1.5-2.6Z"
          fill="#012780"
        />
        <path
          d="M203.2,366.2c2.2,1.4.4,3.7-1.5,2-.2,0-.3,0-.5,0,.4-1.4-1-2.2,2-2Z"
          fill="#012780"
        />
        <path d="M205.2,364.7c-.7.5-1,.3-.5-.5.1-.5.3-.4.5,0,.4.1.4.3,0,.5Z" fill="#012780" />
        <path
          d="M225.7,394.2c1.6-.3,2,2,.5,2.5-.6.3-.7.6-.5,1,1.3.8,2.8,1.1,4.6.8,1.3.1-.5,1.3-.6-.8-.4-1.4-.1-1.6,1-.5-1.3-1.3,1.8-1.7,2.4-1.5s.9,3.7,0,3.5c-.8,1.1-1.5,2.3-2,3.5h-2s1.5-2,1.5-2c-.5.2-2.7,1.3-3,1s.5-1.7-.5-1.5c0,2-1.7,1.5-1.9,1.6-.9.7-.8,2.6-3.6,1.8l3-1-2-.5,1.5-1.2c0-.5-1.1-.1-1.5-.2.2-.3.3-.8.5-1v-2c-1.3-2.4-.5-4.5,2.5-3.5Z"
          fill="#0245a6"
        />
        <path
          d="M233.2,399.2c.8-2.3,2.6.4,1,1.5l-.5,1.6c1.5,1.1,1.6,2.1.5,2.9-.7.1-.8-1.2-3-.5s-1.3.3-1.8,1c-.8-2.5,1.7-1.7,2.2-2.1s0-.8,0-.9c-.1-1.2.5-2.7,1.5-3.5Z"
          fill="#0245a6"
        />
        <path d="M233.2,399.2c0,1.4-.8,2.4-1.5,3.5h-.5c.3-1.5-.1-3.3,2-3.5Z" fill="#02389e" />
        <path
          d="M233.7,395.2c1.1.5,1.4,1.5,1,3,2.4,0,1,4.3-.5,2.5.1-1.4,1.4-1.7-1-1.5,0-.6-.9-2-.5-3-.9-.2-1.3.6-2,1-1.3,0-2.5-2.5-1.1-3.1s3.6.7,4.1,1.1Z"
          fill="#02389e"
        />
        <path
          d="M226.2,396.7c.3-.2,1.1,1,1.2,1,.9,0,.2-2.5,1.7-2,0,.7-.3,1.6.5,2s.9-.2,1.5,1.8c-2.3-.9-1.8.7-2.2.7-1.2.3-.5-.8-1-.9s-4.2.6-2.9-.6.5-.7.7-1c.3-.4.5-1,.5-1Z"
          fill="#023b9f"
        />
        <path d="M231.5,398.2c.3.2.3.3,0,.5v-.5Z" fill="#023b9f" />
        <path
          d="M207.7,387.7c0,.2.6.7.4.9-.6.8-2.8.5-3.4,1.3-.1.4,1.6,0,.5,1.2.4.1,1.2-.1,1.5,0,1.4.8,3,1.5,4.4.9v1.1c.1,0,.1,1,.1,1-.5-.1-1.6-.6-1.9-.4s-1.5,1.4-1.5,1.5c-.2.3,1.3,1.6-.9,1.9s-.6-1.9-4.2-.5-.4,0-.5,0c-.7.7-.9.4-.5-.5.1-.3.8-1.1.5-1.5-.9-1-1,2-2,1s.7-1.2.5-1.5l-2,1.5,1.5-2.5c-1.7,0-1.8-1.7-4-1-.2-1.5,1.4-2.1.5-3.5,2.6-.2-.1,2.9,0,3,.9.3,1.2-.7,1.8-.9s3.6,1.3,2.2-.6c0-1.1.7-1.3,2.2-.4,0-.6.3-1.1.8-1.6.2-.5.3-.5.5,0l.4-.4c1,.5,1.7.5,2.1-.1,0-.8.9-.9,1,0Z"
          fill="#023596"
        />
        <path
          d="M195.7,375.2c1.8-.9,2.7,1.2.5,1-1.6,1.2,0,3.3,1,4.5,1,.3,1,.7,0,1-1.2-.5-2.5,5.1-1.5,3,.8-1.2,1.5-1.6,2-1,.7.4,1.2,1.1,1.5,2,2.2.9,3.7,4.5.5,4-.4.1-.2.3.5.5,0-.4.3-.4.5,0,1.9.4.8,2.6-1.2,1.8.8.2,1.3.7,1.4,1.6,2.6-.4,3.3,2.6.8,2.5,0,.3.2.5.5.5.1-.4.3-.4.5,0,.3.1.7.4,1,.5l-2,1,1.5,1c.2.1-1.1,1.5-1,2.2s1.4,0,1,1-.9,1-1.4.7.3-1.4-1.1-.9l.5,2.5c-2.7-.8-1.8-3.8-5-1.5,0-.3,0-.8,0-1,.3,0,.9.1,1,0,.7-.8-.8-1.2-1.5-1.5-.2.7.3,1,.5,1.5-1.1.4-1.4,1-1.5,1l-1.5-.5v-.5c.7-.1,1.4.2,2-.7l-.9-1.1c-.3-1,.9-.6.9-.9s-.4-3.1-.5-3.4-.6-.1-1-1.3c.4-1,0-1.6-.9-.7-2.2-1-2.7-1.8-1.6-2.3-1.9,0-1.8-1.6,0-1.5,1.4,1.5,1.4-1.4,1.7-1.9s1,0,.8-.4c-.5-1.1-1.2-1.6-1-3.3l-.5,2c-.5.7-2.8-4.9,1.3-4.4s0,1.4,1.2.9c-.1-2.6-.9-2.5-3-3.7,1.3-1.3.5-2.2,2.5-1.3l-1-2.5c1.2.3,1.7-.2,2.5-.5Z"
          fill="#02328d"
        />
        <path d="M194.8,403.2h-1.2s-.3-.5-.3-.5c.8-.4,1.4.5,1.5.5Z" fill="#022f83" />
        <path
          d="M197.2,381.7c-.2,1-1.3,1.7-1.5,3s.5.6.5.8-1.4-.2-1.2.7l-1.3-1.5c2.7.2.9-4.9,3.5-3Z"
          fill="#01257d"
        />
        <path
          d="M197.8,397.2v1.5s-1.5-.5-1.5-.5c-.5,1.7,2.6.9,2.5,3-2.1-.3-3.1-1.9-3.5-3.7l2.5-.2Z"
          fill="#022f83"
        />
        <path d="M195.2,379.7c.8.7-2.2.3-2.5-.3.2-1,1.9-.2,2.5.3Z" fill="#01297b" />
        <path d="M202.2,396.7c-.5.2-.3,1.2-1,1-.4-.8.4-1.2.5-1.5l.5.5Z" fill="#0240a0" />
        <path d="M199.7,389.7l.5.5c-.5,0-1,0-1.5,0v-.5c.3,0,.8,0,1,0Z" fill="#023596" />
        <path d="M189.8,392.7l-1-.5c.8.1.9.5,1,.5Z" fill="#02297b" />
        <path d="M187.8,392.2c.2,0,.3,0,.5,0l-.2.5c-.3,0-.2-.3-.2-.5Z" fill="#02297b" />
        <path
          d="M207.7,359.7c1-.2.6,1.8.5,1.8-.5,0-.2-1.3.5-.3,1.3.8,1,1.9-.5,2-.2-.2-.3-.2-.5,0-.1.4-.3.4-.5,0-.5-.5-.7-.1-.5,1,.4-.1.7-.5,1-1,.2-.3.3-.2.5,0,1.5,1.1,1.2,2.6-.9,4.5,1.7,0,2.7,2.8,1.3,3.3-1.5-.7-2.2,0-1.9,2.2.4-.2.6,0,.5.5.9,2.9-2.2,1.8-2-.5-.2-.1-.3-.4-.5-.5l-1.4-.7c1.2-1.6,1.5-2.4.9-2.3l-.3-.4c-2.9,1-.6-.3-2.2-1.1h1.5s0-2,0-2c.6,0,1,.4,1.5.5v-1.5c-.7.6-1.9,0-2,0,0-.2.5-.4.5-.5.3-.8.6-1,1-.5.2,0,.3,0,.5,0,0,.2.4.3.5.5.4.8.9-.2,0-.5-.2,0-.4,0-.5,0-.2-1.4.2-2.2,1-3s1.4-1,2-1.5Z"
          fill="#022e93"
        />
        <path
          d="M204.2,369.7c.3-.5,0-1,0-1,.4-.2,1.4.4,1.5.8.2,1.1-2.6,1-1,3.2-2-1-1.6.6-2.1.9s-.8,0-.9.1l-.7-1c1.4,0,2.6-1.9,3.2-3Z"
          fill="#0239a0"
        />
        <path
          d="M196.7,373.7c.2-.5,3.4-2.2,3.5-2,1.2,1.6-1.7,1.9-2.5,2s-.7,0-1,0Z"
          fill="#033696"
        />
        <path
          d="M121.8,309.8c.5-.3,2.1-1.3,2.5-1,.3.9-2,2.5-1.5,3,0-.1-1.6.3-1-2Z"
          fill="#022fe6"
        />
        <path
          d="M124.3,311.3c.5.4.6.8,0,1,.6.7.3,1-.5.5h-.5c-.2-.3-.4-.9-.5-1,0,0,1.4-.4,1.5-.5Z"
          fill="#0215cc"
        />
        <path d="M119.8,316.8c-.2-.2-.3-.3-.5-.5.2,0,.4.3.5.5Z" fill="#0228d4" />
        <path d="M122.3,317.8c-.2,0-.3,0-.5,0-2.9-.8-.6-2.4.5,0Z" fill="#0228d4" />
        <path d="M130.8,288.8c0,1.2-.5,1.1-1,0-.2-.2-.2-.3,0-.5.8-.4,1.4-.5,1,.5Z" fill="#0335eb" />
        <path
          d="M128.3,286.8c-1.1-1.3.6-5.1,1.9-2.9l.6.4c.4,0,.4.3,0,.5,1.1,0,1.2.5,1.2,1.4,3,.8,3.7,2.8,3.8,5.6.5.7,1,1.4,1.5,2,1.6,0,2.3.6,2,1.5-.2.1-.3.4-.5.5.2,1-.2,1-1,.5-.1,0-.3,0-.5,0-.3.3-.6.7-1,1-.7,2-1.7-.6-1.8-2-1.1.4-2.2.9-3.2,1.5-1.6-1.6-1.4.6-1.6.9s-.7,0-.9.1c-.1-.6.4-1.1.5-1.5-.4-.1-.4-.3,0-.5,1.3.4,1.5-.6,2-1,1.1-.6,1.1-1.5,0-2.9l.4-.6c-.4-.5-.4-1.4,0-2.5h-.5c-.2-.6-.7-.8-1.5-.5,0,.3-.2.5-.5.5-.9,1-1.2.9-1-.5v-1.5Z"
          fill="#0335eb"
        />
        <path d="M127.8,278.8c.7-2.6,1.7.9,1.2,1.2s-1.8-.6-1.2-1.2Z" fill="#0335eb" />
        <path
          d="M124.3,275.8c.9-2.4,2.5.3,2.8,1.6,1-.3,1.2.5.7,1.4,1,1.1,1.9,2.2,2.9,3.4,0,.1-1.4,1.7-2.1,1.3-.9-1.2-1.9-.9-3.3.8-.3,0-.7-.5-1-.5-.9.1-1.4-.7-1.5-2.5-.5-.2-.8-1-1-1.5,0-.6,2.3-1.3,2.7-1.2.8,0,2.3,3.9.4.4-1,.9-1.7,0-1.1-1.1-.7,0-1.3,0-2,0v-.5c-.6-.8,0-1.1,2-1-.7-.7-.4-1,.5-.5Z"
          fill="#0335eb"
        />
        <path
          d="M123.8,277.8c.1.4,3,1.8,3,3.5-2.5.5-1.1-1.4-2.3-2.5l-.2,1.5-2.5-.5c0-.2,0-.7,0-1-.2-.8,1.3-1.2,2-1Z"
          fill="#0227e4"
        />
        <path
          d="M121.8,277.8c.7-.3,1.5-.4,2.2-.5.7,0-.3.5-.2.5l-2,1c0-.1-.4-.3-.5-.5.2-.1.3-.4.5-.5Z"
          fill="#022de9"
        />
        <path d="M111.8,295.8l.3-.5c.9-.2.8.1.7,1,0,0-.9-.5-1-.5Z" fill="#0224da" />
        <path
          d="M104.3,292.3c1.5-1.1,3.5-.2,2.2,1.6,3.1.9,1.8,3.3.5,5.1,1.8-1.2,2.5.4,1.8,2.3,0,.9.4,1.7,1.2,2.6-.7,1-1.2,2-1.2,3-2.2.4-2.8,3.8,0,1.9.1-2.5,1.3-3.8,2.8-1.7l1.2-.3c.9.2,3,2.8,3,4.1.1-.4.3-.4.5,0,.4.1.4.3,0,.5.2.7.1,4.6-1.2,3.3l-1.3.2c-.4-.5-.6-.9-.5-1.5-2,.5-3.3,2.6-5.5,1.5l2.2,2.5c-.3-2.5,2.5-3.1,1.3-.6s-1.1,0,0,1.6h-3s.5-1.5.5-1.5l-2.2-.5c-.5,0-.1.7-.3,1-.2,0-.9.1-1,0-.1-.2.8-2.8-.5-4s-.9.7-1,1c.2.6.3,1.3.5,2,0,.3,0,.3,0,.5.1.7-.6,1.3-2,2,0,.2,0,.4,0,.5l-1.5-.3.3-1.7c-3.5-.6.4-.9.7-1.8s-.4-2.9-.9-3.2c1.4-.5,1.4-2,0-2.5.3,1.3-.5,2.3-1,1-.3-.2-.3-.5,0-1,0-.9,1.1-1.4-1.5-1.5l1.5-.5-1-2.5,1.5-.5.8,3.5c2.4-1.5,3.1-5.7-.2-3v-1.5s2.5,0,2.5,0c0-.6,0-3.4-1.2-3-2,.7.5,1.2.7,2-2.7.2-3.2-.2-4.5-2.5.9-.4,1.5,1,1.8,1s2.7-3,2.7-3.7-.8-1.3-.9-1.8c-.9-.8,0-4.1,2-3.5.1-.4.3-.4.5,0Z"
          fill="#021dd1"
        />
        <path
          d="M117.3,311.3c.7,1.6.8,2.7-.5,3.5,0,.5.1,1.2,0,1.5-1,.1-1.5-1.3-1.6-1.4-.4-.2-.7.6-1.4-.1.3-.8,1.8-.3,2-.5s-.3-1.1-.2-1.6.5-1,.7-1.4c0-.8.5-.5,1,0Z"
          fill="#022bdb"
        />
        <path d="M111.6,309.3c.3.2.3.3,0,.5v-.5Z" fill="#0220d7" />
        <path
          d="M147.3,286.3c.9-.5,1,.2.5,1-.4.2-.4.3,0,.5.2.2.2.3,0,.5-.2.3-.4.7-.5,1l-1,2c-.9.3-1.2-.7-1.8-.9s-1.4.4-1.7.4-.4-1.1-1-1c.4,1.1-1,1.9-1,2-.6.4-.8.2-.5-.5-.4-.6-.1-.9.5-1-.9-1.3,0-1.8,1.5-1.5.3-1.8.9-2.8,2-3,1.4-1.1,2.4-1,3,.5Z"
          fill="#022cdc"
        />
        <path
          d="M139.8,290.3c.6,0,.6.5,0,1.5.4.1.4.3,0,.5-1.2.5-2,.5-2.5,0l-.5-.5c-.4-.2-.4-.3,0-.5.5-1.6,1.9-2.5,3-1Z"
          fill="#0225df"
        />
        <path
          d="M136.8,291.8l.5.5c1.2,0,1.2.6,0,1.5.3-1,1.3-1.5,3-1.5.1-.4.3-.4.5,0-.3,1,0,2.8-.5,4-.5-.4-.7-.8-1-1-1.5-1.2-2.4,1.1-3,.5s.7-1,.8-1.2c.3-.3.1-.8.2-.8-.2.2-3.1.2-3.5-.8-.2-1.5.9-.2,1.4-.4s.4-.8.6-.9c.3-1.3.7-1.3,1,0Z"
          fill="#0225df"
        />
        <path d="M140.8,291.8c0,.2,0,.3,0,.5h-1v-.5c0-.3.2-.5.5-.5l.5.5Z" fill="#0239e9" />
        <path
          d="M228.7,273.3c.1.3.6.8.5,1s-.6.1-1,.5c-1.3,1.3-.6,1.3-.6,3.2s-1.5,2.1,1.1,1.8c0,0-.5,1-.5,1v2s-2.5-1.5-2.5-1.5c.3-.2.5-1,1-1.3-1.9-.4,0-1.6-.2-3s-.8-.9-.8-1.5c0-.9.9-1.1,1-1.2.1-.6.3-.9,1-1,.2,0,.4-.6,1,0Z"
          fill="#0228d4"
        />
        <path
          d="M229.7,258.3c.4.1.4.3,0,.5,0,1.2-.3,1.1-1.5,1-.2-.3-1.1-.5-1.5-.5l1.5-2c.5.3,1,.8,1.5,1Z"
          fill="#022dd0"
        />
        <path d="M228.2,260.3c0,.1,0,.3,0,.5-.9.3-1.7.7-2-.5h2Z" fill="#022dd0" />
        <path d="M227.7,273.3l-1,1c.1-.2-.1-.8,0-1,.3,0,.7,0,1,0Z" fill="#023ae4" />
        <path
          d="M225.2,305.3c1,1,1.4,1.5,1.5,3l.9.9c-.7.9-.3,2.3,1.1,4.1.4.1.4.3,0,.5-.3,2-1.5,3.1-3,1-.5,0-.6-.5-.5-1.5-.1,0-.4,0-.5,0-.3-.4-.2-.9.5-1.5,0,0,0-.4,0-.5l-.5-.5c0,0-.8,0-.5-1h2c-.5-.9-1.9-4-1-4.5Z"
          fill="#011bbf"
        />
        <path
          d="M228.7,307.3c.1.1.9-.1,1,0,.3.4-1.3,2.1-.5,3l-2-.5c1.2,1.2,1.1,2.1,1.5,3.5-3.1-.4-1.4-.9-1.5-2.2s-1-.2-1-.5c0-.5.5-1.2.5-2.3l2-1Z"
          fill="#022ed8"
        />
        <path
          d="M226.7,301.8c.1.4,1.2,1.3,1,1.5h-2s1,1.3,1,1.3c-.3.7-1.1.5-1.5.8-.4-.4-1-.5-1-.5,0-.1.8-1.3,1-2.5l1.5-.5Z"
          fill="#0214bb"
        />
        <path
          d="M229.7,302.3h2.5s-1.7,2.5-1.7,2.5c-.5,0-.1-.8-.2-1,0-.4-.5-1.3-.5-1.5Z"
          fill="#0343ee"
        />
        <path d="M228.2,293.3s0-.4,0-.5l.5.2-.5.2Z" fill="#022ee4" />
        <path
          d="M225.7,316.8c2.8-.3,4,5.6,1,6,1.9.3,3.3,2.4,0,3,1.7-2.2,3.6,1.3,1,1-.5,2-2.5.3-1-1,0,.5,0,1.6.3,3.4l-.8,1.1c.9.4,0,2.1-1,2,.8.9.7,1.2-.5,1.5-.7.2-1.2,0-1.2-.6l.7-4.4c.4-1.6.4-2.6,0-4,.3-1.6.4-3.6.7-5.2s.7-.8.8-1.1-.7.1-1-1.2c-.2-.9.3-1.2,1-.5Z"
          fill="#0221c0"
        />
        <path
          d="M225.7,314.8c2.5.5,2.2,3.1,0,2-.3.2-.7.3-1,.5-.3-1.3-.9-3.1.5-3.3v-.7c.9.7.3,1,.5,1.5Z"
          fill="#0213ab"
        />
        <path d="M224.7,313.3c-1.4-.8.3-1.1.5-1.5l-.5,1.5Z" fill="#0213ab" />
        <path d="M225.2,311.3c0,0-.4-.3-.5-.5l.5.5Z" fill="#0213ab" />
        <path d="M229.2,288.8l-.3.5c-1.7.4-3.1-2.5-1.5-2s0,1.2.8,1.5.7,0,1,0Z" fill="#022ee4" />
        <path
          d="M155.8,256.3c.6-3.4,5.6-4.9,6.5-1-.1.4-.3.7-.5,1-1.1-.5-1.8,1.7-.5,1l-.5,2-3.5,7.5c-.4-.8-.2-2,.5-3.5-1.5.2-1.6-1.5-1.1-2.6l-.4-1.3c-1.4.4-.9-2.2-.5-3Z"
          fill="#0328da"
        />
        <path
          d="M157.3,266.8c0,.1,0,.3,0,.5l-.5,1c0,.2,0,.4,0,.5l-.5.5c0,.1,0,.4,0,.5l-.5,1c-.3,1-.6,2-1,3l-.5.5c-.1.4-.3.4-.5,0,0-.6-.2-1.1-.5-1.5-.5-.6-1.1-1.1-2-1.5-1-1.1-.2-1.8,1-1,.1-.4.3-.4.5,0l1-.5.5-.5c.1-.4.3-.4.5,0l1-.5c-.4-.2-.4-.3,0-.5l.5-.5c-1.3,0-1.2-.5,0-1-1.3-.4-1.2-1,0-1.5-.5-.1-.4-.3,0-.5.2-.2.3-.2.5,0-.6-.7-.3-1,.5-.5l.5-.5c-.4-.1-.4-.3,0-.5.3,2,0,1.6-.5,3.5Z"
          fill="#0423d5"
        />
        <path d="M156.8,268.3c0-.4,0-.8.5-1,0,.4,0,.8-.5,1Z" fill="#0328da" />
        <path
          d="M169.8,236.8c0,.2,0,.3,0,.5l-1,2c0,.2,0,.3,0,.5l-.5,1c.3.1.3.3,0,.5l-.5.5c.4.2.4.3,0,.5l-.5.5c-.2,2.4-1.1,4.7-2.5,7-.5,1.1-1,2.4-1.5,3.5l-.5.5v.5c-1.3.4-1.7-.7-1.3-3.2-2.1.2-2.5-.6-1.2-2.2,0-.6.6-1.1,1.8-1.6-.5-.9.3-1.8,2.2-2.6.6-2.3,1.2-2.9,1.9-1.8l.5-.5c-.4-.1-.4-.3,0-.5l.5-.5c-.4-.1-.4-.3,0-.5l.5-.5c-.2-.2-.2-.3,0-.5-.4-.1-.4-.3,0-.5l.5-.5c-.4-.1-.4-.3,0-.5-.2-.4-.3-.7,0-1-.9-1-.2-1.6,1-1.5,1.1-1,1.3,0,.5,1Z"
          fill="#042ed9"
        />
        <path
          d="M161.8,256.3c-.2.3-.2.6-.5,1s-.6,1.1-.7,1c-.6-.2-1-1.3-.7-1.9s2.5-1.9,1.9,0Z"
          fill="#041ed0"
        />
        <path
          d="M171.3,233.3c-.4,1-.2,2.7-1.5,3.5,0-.4,0-.8-.5-1-1.3.2-3.1-1.5-1.5-2.5.1-.4.3-.4.5,0,.6-.8,1.1-1.2,2-.5.1,0,.9.6,1,.5Z"
          fill="#0436dc"
        />
        <path d="M171.3,231.3c.2.2-.5.8-.5.2s.4-.4.5-.2Z" fill="#0247eb" />
        <path
          d="M172.3,230.8c-.2.5-.8,1.9-1,2.5.7-.5.2-1.5,0-2-.5-1.3-.8-1.5,1-.5Z"
          fill="#0247eb"
        />
        <path d="M168.8,239.3l1-2c-.2,1.2-1,1.8-1,2Z" fill="#0436dc" />
        <path
          d="M221.2,334.7c-.1,0-.9-.3-1,.3-.3,1.1.5,3.3.3,3.7s-3.7,2-.7,2.5c1.3-.5,1.4,0,.5,1-.5.5-1.9,1.1-2,0,.2-1.8-.9-3.5,1.5-3-.8-1.2.1-2.7,0-3.6s-1.1-1.1-.9-1.3.6,0,1-.5,1.3-.4,1-1.5l-1.5-1c1.2.2.8-1.1,1.1-1.4s1,0,1.2-.3.1-1.6,1.1-1.9c0,0,.5.2.4.6-.2,1.7-2.6,3.8-1.9,6.4Z"
          fill="#011481"
        />
        <path
          d="M118.3,252.3c.3-.3-.9-1.5,1.5-.5.2.8-.7.4-1.5.5l2,1.5,1-2c-.5,1.4.1,2.6.5,4,0,1.9-.9,1.7-2,.5-.4.3-.4.5,0,.5,2-.7,1.7,2.7.5,3.5.5,1.3-.1,3.2-1.5,3.5-.3.7-1.2.8-2.5.5-.2,1-.5,1.1-1.5,1,0,0-.4,0-.8.2s0,.8-.5.8-.6-.5-.7-.5c.6-.5,0-.9,0-1,0-.3,0-.7,0-1,3.6.2,1.9-1.5,0-2.9.2-.9-.7-1.3-1.6-1.3v-.8c-.6-1.3,0-2.2,1.5-1.5,0-.1,0-.4,0-.5-.2-1.4,0-2.3.5-2.5,1-1.2,1.8-1.2,2,.5q.8,3.3,0,0c-.8-.5-.9-.8,0-1h1c1.1,1,1.4,1,1,0,2.4-.3,0-.4,0-.5-1-1.1.9-.9,1-1Z"
          fill="#022de9"
        />
        <path
          d="M95.8,244.3c.4.5.1.9-.5,1l.2.9c1.3-.3,2.1.5,2.4,2.5,3.2-2.4,5.4,1.8,1.8,1.2-.8,1-1,1.8-.5,2.5,1.5-2.9,2.7-3.5,3.6-1.8,3.6.6,2.6,2.4,1.3,4.8s-2.7,3.5-4.9,3.5c-.4,1-1.1.8-.7.4.7-.6.3,1.2-.6,1.9s-3.5.6-4.3.2c-.4,0-.5-.1-.5-.5s0-.5,0-.5c.3-.8.1-2.2-.6-4.2.7-.4,1.4-.8,2.1-1.3q-.5-1.4,0,0c-1.9,2.7-4.2.3-3-2.5-.6-1,0-1.3.7-1.8-.4-.4-.3-.7,0-1.1s1.4-.9,1.8-1.1-2.3,2.1-2.5,2.2c-.4,1.3-.8,2.3-2,1.3-.7.7-1,.4-.5-.5,0-.3,1.3-1.2-.2-1l-1.7,2,.3-3.5-1.8-.5c-1.3-1.6,1.2-2,2.6-1.7.1-.6.5-1,1-1.3.9-.5,4,.5,4.3,1,.3-.4.5-.8,0-.5-1.2.5-2.4-1.5,0-1.7s.7,0,1-.3c.9-1,1.2-.8,1,.5Z"
          fill="#021fdb"
        />
        <path
          d="M89.8,251.8c1.9.3-.2-2.6,0-3.7s1.4,0,.8-1.8l1.7,1.7-1.5,1.7,3.5-1.5-1.5,1.2,1.5.7-2.5,2c-.7,0-.6,1.3-2-.5Z"
          fill="#0113cf"
        />
        <path
          d="M94.8,254.8c0-.2-2.5-1.8-2-3l2-.5c-1.2,2.4.5,1.9.5,2.3.1.6-.5,1-.5,1.2Z"
          fill="#0112d1"
        />
        <path
          d="M99.8,249.8c.6.9-.4,1.6-.5,2.5,0,0-1.2.5-1.5-.2,1.1-.6.4-2.2.5-2.3.2-.1,1.1.1,1.5,0Z"
          fill="#0211d3"
        />
        <path d="M95.8,258.8c-1.3-2.2.9-2.3,1-.5-.2.8-.4,1.2-1,.5Z" fill="#010ec8" />
        <path d="M95.8,244.3s.1-.6.5-.5c0,1.2.3,1.7-1,1.5.2-.3.3-.7.5-1Z" fill="#0118d5" />
        <path d="M96.8,258.3c0,.5,0,1,0,1.5-.6,0-.8-.6-1-1l1-.5Z" fill="#011bd6" />
        <path d="M93.8,246.3c0-.2,0-.3,0-.5l.2-.5c.5,0,.4,1-.2,1Z" fill="#0223e0" />
        <path d="M101.8,258.3c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#011bd6" />
        <path
          d="M114.8,265.3c1-.5,1.5-.3,1.5.5.7,1.5-.1,1.8-1.5,1-.2.4-.3.4-.5,0,0,.6-.5.7-1,.5-.9,1-1.3.8-1-.5-.8-.3-.2-1.2.5-1,.7-1.1,1.4-1.3,2-.5Z"
          fill="#0223e0"
        />
        <path
          d="M99.3,236.8c1.1-2.2,2.4-4.4,3.5-.8,1.2-1.9,3.2,1.8,2.8,3-2.1,1-2.1,5-.9,4.4q.9,1.5,0,0c-1.3-1.2,2.7-3.1,3.3-3.1,1.1,0,4.4,2.3,2.2,2.6,0,.4,0,.9-.3,1.1s0-1,.3-.5c1.1,1.5-1.6,1.7-2.5,1.4.2.2.2.3,0,.5-.3.3-.5.6-.5,1,2.7-1.9,3.6,2.5,1,3.5l.7.6c4.6-1.1,1.9,4.8-.2,1.4,0,.6-.3,1.3-.6,2,1.4,2.9.3,4.2-2.4,4.1l-1,.9c.1,1.2.6,1.8,1.5,2,1.1-1.4,1.4-2.5.9-3.2,1-1.4,2-1.2,3.1.7.7.5.9.8,0,1-.2,2,1,3.9,2.5,4.5.5.4.7.6,0,1-.2.2-.7.4-1.5.5.8,0,.4.5,0,1,.6-.6.9-.4,1,.5,1.6,1.8-1.9,3.3-2.9,1.3-1.2.4-2.6,0-4.1-1.3h-.5c0-1-.4-.9-1,.4l-1-.9c1.6-1.7-2-.4-1-2s2.1-.8,2-1.5c-1.2-.3-2-1.4-3.2-.5s.3,1.9-1.3,1.5c.9-1.6.6-2.6-.5-4,.4,0,1.3.3,1.5-.3.4-1-.7-.6-1-.7.8-.6,1.3-3.7,1.5-4s1.2-.3,1,.7-1.1,1.6-1,1.8c.9.8,2.2-2,1.5-3l1.5,1c-1.1-1.9.5-1.4.5-1.8.5-3-1.8-1.6-2-1.7s-.4-1.4-.8-1.5c-1.1,0-.8,2,.7,2.2l-3,3.2.5-2-1.5-.5,3-.3c0-.2-1.6-.6-2-.7-.7-.6-.3-2,.5-2.5.2,0,1.2-.6,1-1-.9-.4-3,1.3-3.5,1s-.9-2.9-1-3-2.2,1.7-1.5-1.2.4-.2.5-.3c.5-.3,1.1-.7.5-1-.2,0-.7-.4-1-.5s-.7-.4-1-.5c-.2-.5,0-.7.5-.5.8-.8.8-1.8,0-3-2.5-1-.2-3,2-2.5.5-1.1,2.7-2,3-.5Z"
          fill="#0223e0"
        />
        <path
          d="M108.8,251.8c.6.7.3,1.3,0,2,.7.2,1-.3,1.5-.5,1.5-.7,3,2.1,2.5,3.5.5.1.5.3,0,.5-.8.1-1.4.5-2,1-.1.4-.3.4-.5,0-.5.2-1.4,1.4-2,1s2-1.4,0-2c-.2,1.6-1,2.5-2,3.5-.5-.7-1-1.4-1.5-2,.3-.8.4-1.7.5-2.5,1.9,1.7,2.7.9,2.5-1.5h-1.5c2.8-.4.3-1.7.5-2,.8.1,1.5-.9,2-1Z"
          fill="#032be2"
        />
        <path
          d="M110.3,259.3c1.7,0,3.5.4,2.5,2.2,3.2-.4,2.9,3.3,0,2.3-2.2.4-1.8.2-2.5-2.5-1.5,1.3-3.3-.4-2,2l-2-1.5c0-.4,1.6-1.4,1.7-1.5.2,0-.1,2.4,2.2-1Z"
          fill="#032be2"
        />
        <path
          d="M98.8,244.8c1,.9-1,1-1,1.2,3.5,3.3,1.8-1.1,2-1.2.9-1,2.7,2.4,0,3.4s-2.9-.4-3-2.1,1.2-1.9,1.9-1.3Z"
          fill="#021fdb"
        />
        <path
          d="M104.8,258.8l2.5-1-1,3c-.7.7-1.2,1.6-2.5,1.5l1-1c-1.7-1.7-.3-1.7,0-2.5Z"
          fill="#0119d5"
        />
        <path
          d="M104.8,243.3c2.1.9,1.3,2.2,1,4-3.1-.8-.5-1-.5-1.3.1-.8-.8-1.8-.5-2.7Z"
          fill="#022ae5"
        />
        <path d="M108.8,265.3c.1.1.4,1.9-.7,1.5l-2.3-2c.5,0,2.9.4,3,.5Z" fill="#0227e4" />
        <path d="M110.3,263.3c.4,1.2-.9,1.4-2,1.5l.5-2,1.5.5Z" fill="#0227e4" />
        <path d="M101.8,261.3c-.1,0,1.3-2.4,1.5-2,.4.9-.8,2.6-1.5,2Z" fill="#011bd6" />
        <path d="M107.8,245.3c.7.4,0,.7-.5,1,0,0-.4,0-.5-.3-.3-1.2.8-.6,1-.7Z" fill="#0231e9" />
        <path d="M111.3,265.3c1.5-.2,1.2.4,0,1,0-.1,0-.9,0-1Z" fill="#022de9" />
        <path d="M96.3,243.3c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#0118d5" />
        <path d="M110.1,265.3c.3.2.3.3,0,.5v-.5Z" fill="#0227e4" />
        <path d="M101.6,259.8c.3.2.3.3,0,.5v-.5Z" fill="#011bd6" />
        <path
          d="M112.8,264.8c1.6,0,1.5.7,0,1-.7-.1-.4.8-.5,1-.2-.1-.8.2-1-.5.5-.7.5-1,0-1,.3-.7.8-.5,1.5-.5Z"
          fill="#0227e4"
        />
        <path
          d="M105.3,266.8c1.1-.3,1.8.9,2.7.9,1.4,0,1.4-2.9,2.8-.4l-1,.5c1.5.6,1.7.3,2.5-1,.3.2.7.4,1,.5l1-.5c.2,0,.4,0,.5,0,1.2-.6,2.1,0,2.6,2,1.8.2,2.3,1.4,1.9,3,.3.1-.1,2.1-.4,2.4s-1.5.3-2.1,0c-.8-.4-1.3-.2-1,.7-.5-1.7-.2-2,1-.7,1.1-.3,2.2-.4,3,.5,1,.4,1.6,1.3,2,2.5.4.1.4.3,0,.5.4.5.2.7-.5.5-.1,0-.7-.2-.9,0s-.2,3.1-.6,3.4-1.3-.3-1.5-.7,1-.3,1-.7c-.6-.2-1.6-.7-1.3-1.3,1-.3,1.2-1,.8-2.2-.4-1.3-.6-1.1-.5.5,1.5,0,.7,1.5-.1,2.2v.8c-.7,0-1.9-.3-2.4.5.1.3.5.3,1,0,.3.1.9,1,1,1.3s-2.3.4.2,2.7l1.7-2c-.9,2.5,0,3-3,2-.2,1.4.9,3,2.3,2l.2,1-3,.5c1.2-3.4-.9-.6-2.5,0,0,0-.8.6-1.5.3-1.4-.7.5-.8.5-1-.2-1-1-1.5-2-1.3,1.1-1-.8-1.6-2-2v-.5c-.3-.1-.3-.3,0-.5.7.5,1.9.7,2.5,1,.4.2.5.2.5,0-.2-.4-.4-1.9-.5-2s-1.5.7-2,.5c-.2-.8.6-.3.8-.7.3-.6.4-1.3.7-1.8-.2-.2-3.2,1.9-3,2.5-2.8-2.8-.9-2.9,2-3l-1-1,2.5-1.5c2.3.5,2,.2-1-1,0-.5.6-1.4.5-1.5-.9-.8-1.1.8-1.5,1.2s-1.2.1-1.5.6c-1.1,1.6-.4,2.3-2.4,3.7,1-2.2,0-.9-.5-2,2.6.2.9-.5,1-1.5s.9-.9.8-1.7-1.5-1.6-1.3-2.7c1.3-.5,1.2,1.5,1.7,1.5s1-.6.4-1-1.1.3-.7-1l1.5.5c-1-1.3.5-.9.5-1.2,0-.6-.8-1.8-.5-2.8l-1.4.4-1.6-1.9Z"
          fill="#0227e4"
        />
        <path
          d="M118.8,276.8c0,.2,1.1.8,1,1.7s-1,.2-1,.5.5,1,.5,1.2c-.3,0-.7,0-1,0-3.6-1.6-.4-1.2.3-2s-.3-.9-.3-1c-.7-.9-.4-1.2.5-.5Z"
          fill="#0233ed"
        />
        <path
          d="M116.8,280.8l-2,2.8.7,1.3c-.4-.1-1.8-.4-1.8-.8s1.9-3.1,2-3.2.9,0,1,0Z"
          fill="#0335eb"
        />
        <path
          d="M110.3,276.3l3,.5-.7-1.5c2.7.1,3,2.3,2.7,4.5-.7-1.2-2.4-.4-2.5-.5s1.1-.6-1.5-2-1.2.6-1-1Z"
          fill="#0331ec"
        />
        <path
          d="M116.8,274.3c-.3.1-.9-.1-1,0-.3.3,1.3,2-.3,1,.1-1.6-.3-2.3-1.2-3.5l3.5-.3c1.4.7-1.3,1.6-2,1.3,0,0,.8,1.4,1,1.5Z"
          fill="#0331e8"
        />
        <path
          d="M118.3,277.3l-2-.5c.2-1.3,2.3-1.8,3-1s-.5.9-.5,1c-.3-.1-.5.3-.5.5Z"
          fill="#021dd9"
        />
        <path d="M113.8,273.3v.5s-2,0-2,0c.4-1.3.9-.7,2-.5Z" fill="#0211c7" />
        <path d="M114.3,266.8c.1,1.8-.4.8-1,.5.2-.6.6-.4,1-.5Z" fill="#022de9" />
        <path d="M111.8,284.3c0,.1.8,0,.5,1-.6,0-.8-.9-1-1h.5Z" fill="#0225df" />
        <polygon fill="#0225df" points="108.8 283.8 108.3 283.5 108.8 283.3 108.8 283.8" />
        <path d="M107.6,280.8c.3.2.3.3,0,.5v-.5Z" fill="#011fda" />
        <path
          d="M89.8,240.8c.9-.4.7-1.4,3-.5,0-2.3-2-1.2-3-2.2l1-.3-1.5-.5c-1-1.4,1.5-.4.8-1s-6,.3-6.8-2.5c2.5,1.1,1.2-.3,3-.5l-.5,1.5c2.8,1.1.3-3.3,1-4s1.9.2,2,.8-1.7,2.6-.5,4.2c.2.2,2.7-1.7,3.1-2s.5-1.6,1.9-.5,0,.3,0,.5c-.6,1.2-.6,1.4,0,.5,0,0,.9,0,1,0,.6,1.2.6,1.8,0,1.9l1-.4c.2-.2,2.2.9,3-.7,0-.5-1.4.1-1-1s1.9-.7,2-.8c.4.1.4.3,0,.5l.5,1c.7.5.1,1.5-.5,2-.6.1-1.4,0-2,0-.4,2,1.3.2,1.5.5s-.3,1.3-.8,1.4c-1.1.2-4.5-2.2-3.7,1.1-.8-.2-.4.3,1.4,1.7l-1.4,1.3c-.2.1-.3.3-.5.5-.8-.3-1.4-.8-2.2-1-1.5-.4.6,1.3-1,1l1.2-2.2-2,.2c-.4-.1-.4-.3,0-.5Z"
          fill="#011edd"
        />
        <path d="M94.3,239.8c1,1.1,3-.2,2.5,1.7s-1.5.4-2.5,1.3c1-2.2.3-1.6-1-3h1Z" fill="#0118d5" />
        <path
          d="M95.3,235.8c0,0,.1.7-.1.9s-.9-.2-1.1-.1c-.5.1-1.1.9-1.3.7-.9-1,1.6-2,1.5-3,.4.2.6,1.1,1,1.5Z"
          fill="#010fd1"
        />
        <path
          d="M93.3,234.3c-.1.1.1.9,0,1-.3.2-.9-.4-1.3-.5s0,1.5-1.2,1l2.5-2v.5Z"
          fill="#0118d5"
        />
        <path d="M100.3,233.8c0,.5-.4.7-.5,1-1,0-1.7-.3-.5-1,.3,0,.7,0,1,0Z" fill="#0224e0" />
        <path d="M87.8,232.3c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#0118d5" />
        <path
          d="M93.8,205.3c0,.6.2,1,.5,1.5l.5.5c0,.1,0,.4,0,.5-3.1.2-1.4,1.7-1.6,1.9s-.8,0-.9,0,1.7,2,1,3c-1-.5-1.1-1.4-2.5-1.5-1.1,0-1.1-.8,0-1q.5-.3,0,0c-1,.6-1.3-.2-.5-1,.2-.5.2-1,0-1.5v-.5c1.3-1,1.4-2.5,3.5-2Z"
          fill="#021bda"
        />
        <path
          d="M90.3,209.3s.5.9.5,1c0,.3,0,.7,0,1,0,0-.4.5-.7.5s-2.1-1.9-.8-2.5c.2,0,.3,0,.5,0,.1-.4.3-.4.5,0Z"
          fill="#0111d1"
        />
        <path
          d="M95.3,213.8c.6.4.8.8,0,1,.3.1.3.3,0,.5.4.1.4.3,0,.5,0,0-1.1.9-1.5.5s1.4-1.7,1-2.5l-1.5.2c.5-2.1,1.1-.6,2-.2Z"
          fill="#0118d5"
        />
        <path
          d="M96.3,214.3v2c-.3,0-.7-.5-1-.5v-.5c.2-.2.2-.4,0-.5v-1c.5.2.8.4,1,.5Z"
          fill="#0224e0"
        />
        <path
          d="M90.3,207.8c1.7-.2,1.3.9,0,1.5,0,0-.3,0-.5,0l-2-1.5c1.1.4,1.8,0,2.5,0Z"
          fill="#011fdc"
        />
        <path d="M88.3,202.8c-.7-.1-.4,1.2-.5,1.5h-.5c0-.7,0-1.7.7-1.8s.2.4.3.3Z" fill="#0112cf" />
        <path
          d="M94.3,197.8c3.5,1.5.6,2.4,2.5,3.5-2,1,.8,1.9-2,2.5l-.3-2c-2,1.3-.4,1.7-.4,2.3s-.4.6-.4.6c-2.3-1.5-.9-3.6-.5-5.5l-3.2,1.5c-1.4-2.2,2.4-1.7,4.1-1.6s0-.7.2-1.4Z"
          fill="#021bda"
        />
        <path d="M90.3,197.8c-.3-1.4,1.2-1.7,1,0h-1Z" fill="#021bda" />
        <path
          d="M95.3,182.3c.1-.5,4.3-2.4,4.6-2.3,1,.5,2.2,2.5.9,3.3.2.8-.2.8-.6.4s2.5.9.1,1.6c.7-1.2,1.1-1.4,1.3-.5l.2-.5c-.5-.4-.7-.8,0-1,2.5-1.7,5.2,1,1.7,2.9.4,1.2,0,2.3-1.1,1.6-1.4.8-2.4,1-3,.5-1.3-1.3-.4-2.2,1-3-1.1,1.9-2.7,2.1-2.6-.4-.8-.2-1.6-.4-2.4-.6-.6.2-.6.3,0,.5,2-.9,3-.9,2.4,1.7-1.1-.4-2.1-.3-2.9.3.2,1.1.2,1.2-1,1-.3,2.6.2,3.7,1.3,3.2,2.1.4,2,3.3,0,3.9.2,2-.2,3-1.3,2.9-1.4,1.4-2.6-.9-3-2-1-.9-1.6-1-2,.5.6.3.8.8.5,1.5,1.2,0,1.7.4,1.5,1-1.2,1.3-1.8,1.4-2,.5-.2-.8-.6-1.3-.8-2.2s1-.6-1.7-1.3c.2,2.4-.2,1.1-2,1,.8-.9,1.2-1.6,2-2.5.2-.9.2-1.6,0-2.5-.3-.9.3-1.7,1.8-2.2-4.4,1.1-.9-5.5,2-3.1l.8-.7c-.1-.8-.1-1.5,0-2-.3-.7-.1-1,.5-1l.3-.7c1.2.8,2.5.8,3.7.2Z"
          fill="#021bda"
        />
        <path
          d="M90.3,180.8c.5,0,.8.6,1,2h-.6c0-3.1,1.5-3.2,4.6-.5-.7.3-2.5,2.5-2.7,2.5-1.6.1.8-2.1-1.2-2,0,.2,0,.5,0,.7-.1.2-.3.3-.5.3-.3,0-.3.6,0,2,.3.9.5,1.7,1,2.5-1.7.7-2.5-1.7-3.2-1.5s-2.2,2-1.8,2.5c.9-1,3.2-1.4,3,.5l-3.5,2c-.1.4-.3.4-.5,0-.2,0-.3,0-.5,0v-2c-2.8-1.4-1.5,1.4-3-.3l3.5-.8-1.5-1c0-.8,1.5-.8,1.5-1.3.2-1.5-2.3-4.9,2.5-3.2-.4-2.3.2-1.9,2-2.5Z"
          fill="#0113d2"
        />
        <path
          d="M86.3,194.3l-.5-2.5c.2,0,.4,0,.5,0,.6.2,1,.8,1.5,1.3-.4.5-1,.8-1.5,1.2Z"
          fill="#010dca"
        />
        <path
          d="M95.3,182.3l-.5-1c2.5.4,4.6-4.9,4.5-1,1,.2.3-1.2.5-1.5s1-.5.8.6c-.3,2.4,1.4.6,1.7.9s-1.1,1.7,0,2c1.2.7.8,1.2-.5,1,0,.3,0,.7,0,1-.9.9-1.4,0-1-1-.3-.8-.2-1.5-1-2.5-1.2,1.5-3.3,1.1-4.5,1.5Z"
          fill="#0227e2"
        />
        <path
          d="M88.8,196.3c-.5-.4-.6-1.4-2-1l2-.5-.5-1.5c3-.3,1.4.4,1.6.9s1.4.3.9,1.6c-.1,0-.4,0-.5,0-.2-.2-.4-.2-.5,0,0,.1,0,.7,0,1,0,0-.8-.3-1-.5Z"
          fill="#0113d4"
        />
        <polygon fill="#0113d4" points="91.3 189.3 91.8 193.3 89.8 192.8 91.3 189.3" />
        <path
          d="M100.8,183.3c.2.5.5.8,1,1,0,0,.6.1.5.5-.7.1-1.3.3-2,.5.1-.3.5-.6.5-.8s-2.8-.9,0-1.2Z"
          fill="#0229e5"
        />
        <path d="M90.8,183.8l.4,1.7-.4.3c-.2-.7-.9-1.4-.5-2.5.3,0,.4.5.5.5Z" fill="#0108c1" />
        <path d="M95.3,184.3v.5c-.4,0-.8.3-1-.3-.5-1.5.9-.3,1-.2Z" fill="#0113d2" />
        <path d="M90.3,197.8c0-.8.8-.8,1,0,0,.5.1.7-.5,1-.5-.4-1-.7-1.5-1h1Z" fill="#0112cf" />
        <path d="M90.3,195.8c-.2,0-.5,0-.5,0l.2-.5.2.5Z" fill="#021bda" />
        <path d="M96.3,174.8c.2-.2.8.5.2.5s-.4-.4-.2-.5Z" fill="#0118d6" />
        <path d="M91.8,175.8l1.5-.5c.2.1-.5.7-.5,1-.5,0-.7-.1-1-.5Z" fill="#010dca" />
        <path
          d="M234.7,72.9c-1.2.5-3,1.2-4,2s-1.5,2.1-2.2,2.5-2.2.4-2.3.5c-.1.1.8,1.6-.2,2-.7-1.7-2.8-2.1-4.5-2.5s-1-.2-.4.5,1.6,0,.7,1-1.2-1-2.2-1.1-1.6,1-1.7,1.1c-1.7,1.3-3.3,1.1-5-.5-.2.4-.3.4-.5,0,0,.3-.1.5-.2.5-3.5.9-7.4,1.3-11.1,1.4l-.7-.9c-4.4.4-4.4,1.2-8,2.3s-7.9,1.2-11.5,2.2l5.1-2.2c2-.2,15.2-2.8,15.9-3.3s-.1-.9,0-1c1.7-1.9,6-.9,8.2-1.6s2.9-.8,5.3-.9,2.6-.4,2.8-.4c.6.1.6,2.1,1.7,1.4s0-.7.2-.8c.8-.6,6-.5,7.5-.8s1.6-1.1,2.6-1.3,3.2.1,4.7,0Z"
          fill="#5e79e4"
        />
        <path
          d="M380.1,176.3c0,.2,0,.3,0,.5-.8.1-.8.4,0,1,.7.4,1.1.4,1,0,.9-.5,1.6-.5,2,0,.6,1.1,1.1,1.6,1.5,1.5.1.1.8,0,1,.5l-.5.5.3.5c.9.3,2.1-.6,1.7,1,0,.7-.5.4-1,0l-.5.5c.3,1.2-.2,1.3-1.5.5-.2.5-.7.3-1.5-.5-.6-.8.2-1.6,1-1q1.5-.1,0,0c-1,.1-1.5.6-1.5,1.5,1.3-.3,2.4,0,2,2,1.8-1,2.9-1.1,1.5,1-.7,0-1.3-.5-2-.5-.2.2-.2.4,0,.5v.5c.4.4.1.8-1,1,0,.1,0,.3,0,.5-.1.4-.3.4-.5,0-.4-.2-.4-.3,0-.5-1.5.5-2.1.3-3.5-.5-.2.5-.3.5-.5,0-.6.9-1.2.5-1-.5h-.5c.1-.8.5-1.7,1.2-2.5-.8-1.1-.9-1.7-.2-2-3.5.1-2.3-2.2-2.2-2,.7,1.1.7,1.4-.8,1-.9-1.1-.7-3.2,1-2.5,1.1-1.4,3.1-3.3,4.5-2Z"
          fill="#0578f7"
        />
        <path
          d="M376.1,170.8c-.5,1.6-1.3,1.8.5,2,1.5.3.6,2.7-.2,3.6.8.9.4,2.1-.8,1.9-.7.8-1.4.9-1,2.5-.1.5-.3.5-.5,0l-.5-1.5c-1.3-1.1-.4-2.1,1-2.5-1.1-1.2-1.1-1.6.5-2-.8-.6-1.1-1.3-1-2,.6.5.4-1.7.5-2s.5-.3.5-.5c.2-1.1,1.2-.7,1,.5Z"
          fill="#025ff0"
        />
        <path
          d="M384.1,178.8c.2.2.3.3.5.5l-.2.5c-.4-1.2-2.2-.4-2.2-.5-.9-.9,1-.9,1-1.5.2.3.7.7,1,1Z"
          fill="#0350f4"
        />
        <path d="M380.1,176.8c0,.2,0,.3,0,.5.3.1.3.3,0,.5-.1,0-3-.4,0-1Z" fill="#047ff8" />
        <path
          d="M392.1,168.3c0,.1,0,.7,0,1,1.9-1.5,3.3-.7,1,.7l2,1c-.9,1.7-2.3-.4-2.5-.2-.5.4.8,1.7-2.5,0-1.1.9,0,1.9.5,2.5-.5-.5.4-1.6,1-1s-.5,1.5-1,1c1.7,1.8.8,0,2.3-.5,1.3-.2.2,1.2,1.7,1l-.5,2c-1,.3-1.3-.8-1.8-1s-.4.7-.7,1c.1.8,0,1.4-.5,2,.7.7.4,1-.5.5-1.2.2-1.7.8-1.6,1.8-.3.5-2.8.6-2.4-.8-.7.4-1.8-.3-1-1-2.9-2.7-.4-2.9,2.2-2.3-.7,0-2.4-.2-2.7-.7-.3-1.4.2-2.1,1.5-2,.1-.4.3-.4.5,0,.3,0,.5.2.5.5.6.2.6,0,0-.5-.9-.2-1.3-.5-.5-1v-.7c-.9-1.2.3-2.3,1.5-3.3.1-.4.3-.4.5,0,.3-.5.6-.5,1,0,.4-1,2.3-1.4,2,0Z"
          fill="#0350f4"
        />
        <path
          d="M390.1,167.3c1.3-.3,3.4-1.3,3,.5-.3.2-.7.3-1,.5-.4-.6-1.4-.2-2,0-.7-.3-.6-.6,0-1Z"
          fill="#012dea"
        />
        <path
          d="M390.6,178.3c0,0,0,.4,0,.5,0,2.7-.9,3.5-2.5,2.5-.3-.2-.3-.3,0-.5-.2-.2-.4-.2-.5,0,.5.3.4.7,0,1-.1.4-.3.4-.5,0-.5-.5-.7-.7-1.6-.2l-.4-1.3.5-.5c-.2-.7.2-.9,1-.5.7.3,1.2.7,2,.5l-.5-2,2.5.5Z"
          fill="#0352f3"
        />
        <path
          d="M385.1,178.3c.2,0,.4,0,.5,0s.2.7,1,1c0,.7-.8.4-1,.5-.7.6-1.1.4-1-.5-.3,0-.5-.1-.5-.5,0-.2.5-.5.5-.5.1-.4.3-.4.5,0Z"
          fill="#0786f5"
        />
        <path
          d="M390.1,167.3c0,.3,0,.7,0,1s.7.7.3,1c-.4-.2-.9-.8-1.3-1,.2-2.1.9-1,1-1Z"
          fill="#025bf5"
        />
        <path d="M387.6,173.3c.3.2,1.4-.6,1,1.5-.6,0-.7-.6-1-1v-.5Z" fill="#0e7cf3" />
        <path d="M390.1,175.8c-1.3.2-1-.3-1-1.5h.5s.5,1.5.5,1.5Z" fill="#0127e5" />
        <path d="M387.6,173.8c-.1-.2-.4-.3-.5-.5.2,0,.3,0,.5,0v.5Z" fill="#025bf5" />
        <path d="M384.6,178.3c0-.3-1.2-1.5.2-1s.2.6.3,1h-.5Z" fill="#0350f4" />
        <path d="M381.1,177.8c0,.3,1.2,1.4-.2,1s-.5-.8-.8-1v-.5c.3.1.7.5,1,.5Z" fill="#0350f4" />
        <path
          d="M377.1,160.8c.1.2-.1.9,0,1,.9.7,1.5-2,3-1.5l-.5,1h1s-.8,1-.8,1l-.2-1c-.4-.4-1.6,1.9-1.5,2.5-.5.1-.4.3.5.5.6.3.7.9,0,1q-.2.2,0,0c.3-.2.4-.6.5-1,.1-.3.3-.3.5,0,.2-.4.6-.7,1-.5,1.6-1.9-1-2.8,2-2-.3.9-.3,1.7,0,2.5.2,0,.3.4.5.5-.7.9-.7,1.7-.1,2.3l-.9.7c.3,1-.3,1.2-1,.5-.9,1.5-1.2,1.6-1,.1l1,.4c.6-.7,1.1-.5,1,.5.8-.3,1-.2.5.5.6-.6.9-.6,1,0,2-.7,1.4,1.5.8,2.9,1.5,1,1.6,1.7.4,2.2l.3.5c1.1.1,2.3,0,3,.8l-3,.3.5,2c-.1.4-.3.4-.5,0-.2-.4-.4-.4-.5,0,.6.7.3.9-.5.5-1,.1-1.7,0-1-1-.7-.3-1.2-.4-2,0-.4.6-.7,0-1-.5-.5,0-.4-.2,0-.5-.4-.1-.4-.3,0-.5.6-1-.3-1-2.7.1l-.8-3.6c-1.5,1.5-2.5-1.8-.5-2-1.9-2.3,1.9-1.7,3,0,.4-.7.3-1-.5-1-1.3-.3-3-.4-3.5.5.7.7.4,1-.5.5-.2.3-.3.5-.4.5-2.5-.8-4-2.5-.6-3,.2-.2.2-.4,0-.5l-.5-.9c-3.8.9-2.8-1.6-.5-3.1-2.6-.7,3.9-5.4,4.5-3Z"
          fill="#0370f7"
        />
        <path d="M373.6,167.8c.3.1.2.3,0,.5-4.5,2.1-1.7-4,0-.5Z" fill="#0370f7" />
        <path
          d="M382.6,161.8c.8.2,1.8-.5,1.5.7-.2.6-1.7-.5-1.5,1.8-.2-.1-1,.3-1-.3,0-.9.3-1.7,1-2.2Z"
          fill="#0249f4"
        />
        <path
          d="M378.1,163.8h.5c.5-.4.9-.4,1,0,.4.1.4.3,0,.5-.1,0-.3,0-.5,0,0,.5-.3.4-.5,0-.5,0-1,0-1.5,0-.2-.7.3-.5,1-.5Z"
          fill="#0784f9"
        />
        <path d="M380.6,163.8c-.4.5-.5.4-1,.5v-.5c.2,0,.4-.3.5-.5.2,0,.4.3.5.5Z" fill="#0241e1" />
        <path
          d="M376.6,172.8c.8,0,1.4,0,2,.8l-1,.2v2s3-1,3-1c-.2.5-.4.9-.5,1.5l-1.5.2-1.9,2.1-1.1-.4c1-1.2-.7-1.4-.5-2.2s2.5-1,1.5-3.3Z"
          fill="#047ff8"
        />
        <path
          d="M378.6,169.8c.8-.1,1.1.5.5,1,0,.2,0,.7,0,1l.7.5c-1.4,0-1.6-1.9-2.5-2.5s-1,.3-1.2,1c-.2-.5-.7-.4-1-.5s-1.2-.7-1-1c.9-.6,2.3,0,2.7,0s.1-2.4,1.8.5Z"
          fill="#037ef9"
        />
        <path d="M381.1,168.8l-.9.7c1-1.1-1.1-.6-1.1-2l2,.7c.4.1.4.3,0,.5Z" fill="#025cf3" />
        <path d="M378.6,169.8l.3-.5c1-.2,1.9,2.1.2,1.5-.2-.3-.3-.7-.5-1Z" fill="#0352ef" />
        <path d="M379.1,164.3l1,1.5c-.2.2-1.3-.3-1.5-.5s0-.7,0-1c.2,0,.3,0,.5,0Z" fill="#024be3" />
        <path d="M383.1,177.8c-.6,0-1.4,0-2,0,0-.4,1.9-1.1,2-1,.1.1-.1.8,0,1Z" fill="#0d94f5" />
        <path d="M374.1,165.3c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#0385f8" />
        <path d="M376.4,165.3c.3.2.3.3,0,.5v-.5Z" fill="#0385f8" />
        <path d="M378.6,165.3c.2.2-.5.8-.5.2s.4-.4.5-.2Z" fill="#0385f8" />
        <path
          d="M388.1,181.3c.7.7,1.4.9,1.5,1,.1.2-.9,1.5-1,2-.2,0-.8.2-1,0s0-1,0-1.5c-.9-.4-.9-.7,0-1,0-.3,0-.7,0-1,.2-.3.3-.3.5,0,0,0,0,.4,0,.5Z"
          fill="#033fee"
        />
        <path
          d="M387.1,181.8h.5c0,.3,0,.7,0,1h-.5c-.9.9-1.1.7-1-.5-.3-.2-.2-.3,0-.5.3,0,.7,0,1,0Z"
          fill="#0350f4"
        />
        <path d="M385.1,180.3c0-.6.3-.4.5-.5.1.3-.2.6-.5.5Z" fill="#0350f4" />
        <path d="M388.1,180.8c0,0-.3,0-.5,0l.2-.5.2.5Z" fill="#0350f4" />
        <path
          d="M383.6,164.8h.7c-.8,1.1-.8,1.6-.2,1.5.2,0,.3,0,.5,0h.5c.5,0,1,.1,1.5.5,0,0,0,.5,0,.5.6-.2.9-.2,1,.5,0,0,.6.2,1,.5l.5,1.2-2,1.2c2.3-.5,1.9,1.4,0,1.5-.4.2-.6.5-.5,1l-1.5,2c-1-.1-2,0-3,0l3-1c.1-.9-2-.5-2-1.2s1.7-2.1.5-3.2c-.1-.3-.5-.3-1,0-.2,0-.3-.4-.5-.5v-1.5c-.3-.8,0-2.8,1-3h.5Z"
          fill="#025bf5"
        />
        <path
          d="M387.1,172.3c.2.3.3.8.5,1h-.5c-.1,0-.3,0-.5,0-.5,0-.8-.3-1.5,0,0-2.3,1.4-1,2-1Z"
          fill="#036ef6"
        />
        <path
          d="M386.1,165.8c.3,0,.7,0,1,0,.2.2-.4.7-.5,1-.8,1.6-1.1,1-1.5-.5.4,0,1,0,1-.5Z"
          fill="#0374fa"
        />
        <path d="M387.6,167.8l-1-.5c.2,0,.8-.7,1-.5s0,.9,0,1Z" fill="#0228e1" />
        <path
          d="M385.1,164.8c-.3.4-.8.5-1,.9v.6c-.2,0-1,1-1.5-.3s.7-.1.8-.4c.2-.4.1-.8.2-.8.1-.2.3-.3.5-.5-.3-.2-.3-.3,0-.5,0,0,.4,0,.5,0,.9-.6,1,.2.5,1Z"
          fill="#0370f7"
        />
        <path d="M382.6,169.8c.4-.9,2.4-3,3-1.5-1.1-.2-1.8,1.4-2,1.5s-.8,0-1,0Z" fill="#0144ee" />
        <path
          d="M382.1,169.3c-.3-.2-.6-.4-1-.5,0-.2,0-.4,0-.5s.8-.3,1-.5c.1.3,2,.6,0,1.5Z"
          fill="#0485f8"
        />
        <path d="M385.1,170.3c-1-.9,2-2,2-.7s-1.6,1.1-2,.7Z" fill="#033ae9" />
        <path d="M385.1,166.3h-.5c.3,0,.5,0,.5,0Z" fill="#0370f7" />
        <path d="M390.1,184.8c-.2,0-.3,0-.5,0,0-.3,0-.9,0-1h.5c0,.3,0,.7,0,1Z" fill="#033fee" />
        <path
          d="M393.1,176.3c.3,0,.9,0,1,0,.2.2-.1,1.5,0,2,3.1-2,1.2.1,1.2.7s.8,1.2.8,1.8c.4.7.5,1.2.5,1.5-.3,1,.3,1.4.5,2,.2.9,0,1.4-.5,1.5-.1.4-.3.4-.5,0-1.5-1.3-2.9-1.3-4,0,.5.7.2.9-.5.5.3.1.3.3,0,.5-.4.3-.9,0-1-.5-1.6-.5-1.7-1-.5-1.5l1-1c-1.3-.9-1.5-2.6-.5-5-.4-.2-.4-.3,0-.5.2-.1.3-.4.5-.5.4-1.2.7-1.2,1,0l1-.5c-1.3-.2-1.2-.5,0-1Z"
          fill="#0344f3"
        />
        <path
          d="M391.6,175.8c.2.7,1,.4,1.5.5,0,.3,0,.9,0,1l-1,.5c-.2.1-.8-.1-1,0-1.4-2.6.2-1.7.5-2Z"
          fill="#0227db"
        />
        <path
          d="M390.6,178.8l1.5.5c.4,1.4-1.1.7-1.3,2s.1,1.9.3,2.5c-.1.4-.3.4-.5,0-.3-.2-.6-.1-1,0,.4,0,.3.7,0,1-.6,1-1.2.6-1-.5-.4-.8-.6-1.8-.5-3,2.2-.2,1.1-1.8,1.6-2.4s.8,0,.9,0Z"
          fill="#0350f4"
        />
        <path
          d="M393.1,181.8c0,0-1.1,1-1.5-.3s.6-.1,1-.7-.2-1,.3-1.1,1.5.4,2.2,0l-1.5,2c-.1.4-.3.4-.5,0Z"
          fill="#0326e1"
        />
        <path d="M396.1,185.8c-1.4-.1-2.7-1-4,0,1.1-2.4,2.2-2,4,0Z" fill="#0229eb" />
        <path d="M393.6,181.8c.3.1,1.1,1,1.5,1.3-1.2.8-3.1,0-2-1.3.2,0,.4,0,.5,0Z" fill="#022fef" />
        <path
          d="M391.1,183.8c0,0,.7.3.5,1-.5,0-1,0-1.5,0-.4-.3-.4-.7,0-1,.2-.3.3-.3.5,0h.5Z"
          fill="#0227eb"
        />
        <path d="M393.1,177.3l-1,.5c.4-.3,1-.5,1-.5Z" fill="#0338ef" />
        <path d="M391.6,186.8s0-.4,0-.5l.5.2c-.1.2-.3.3-.5.2Z" fill="#0229eb" />
        <path d="M390.6,183.8c-.2,0-.4,0-.5,0s-.4,0-.5,0l.7-.5.3.5Z" fill="#0344f3" />
        <path
          d="M386.1,182.3c.4,0,.7.2,1,.5.1.8-.5,1.8-.5,2.5-.3,0-.8.5-1,.5.2-1.5-.4-.8-1.5-1,0-.6,0-1.3,0-2,.6,0,1.3-.5,1.5-.5h.5Z"
          fill="#046af5"
        />
        <path
          d="M376.1,148.8c.5,0,1,0,1.5,0l-1.4.5.2.9c-4.9-1.5-2.6,1.5.4,1s.4-1.9,1.3-1-.4.9-.3,1.2.8,1,.7,1.4-1.2,1-1.4,1.7,1.1,2.2-.6,2.7c0-.5.1-1.1,0-1.5-.7.2-1,0-1-.5-.8-.3-1.6-.7-2.5-1-.9-.1-1.8,0-2.8,0l-.3-1.5c-2.7-1.3-1.8-4.4,0-2.1.5,0,.5-.3.1-.7,0-.5,4.8-1.7,5.8-1.3Z"
          fill="#046cf7"
        />
        <path
          d="M374.6,148.3c.2,0,.3,0,.5,0h.5c.1,0,.3.4.5.5-1.7.1-3.6,1.5-5.5,1-.2.9,1,.2,1,.7,0,1.3-1.2,1-1.5.2-1.8,0-1.5-1.4,0-1.5.2-.4.3-.4.5,0l1-.5c.4-.6,2.4-1.1,3-.5Z"
          fill="#0258f4"
        />
        <path
          d="M376.6,155.8c-.3.1-.7.5-1,.5s-.3,0-.5,0c-.3-.1-.3-.3,0-.5-.7-.7-.4-1,.5-.5.1.1.8,0,1,.5Z"
          fill="#037bf8"
        />
        <path
          d="M375.6,155.3l-.5.5c-.2.3-.4,0-.5-.5-1.1-.5-1-.7-1.5-1,1.6-.4,1.7.3,2.5,1Z"
          fill="#0355f1"
        />
        <path d="M377.6,152.3c-.8,1.6-1.9,2-2,0h2Z" fill="#0358f4" />
        <path
          d="M371.1,146.8c1.3,3,3.7-1,3.5,1.5-.9,0-2,.4-3,.5,0-.7-2.4-1.1-1.5-2.5s.7.5,1,.5Z"
          fill="#046cf7"
        />
        <path
          d="M381.6,148.3c2.3-.4,1.4.4,1,2l-.6.9c-1.1-.2-2.3-.2-3.4,0,0-.4.3-1.4.5-1.7s1.9-1.3,2-1.3c.1-.5.3-.4.5,0Z"
          fill="#023ef0"
        />
        <path
          d="M382.6,150.3c-.2.7-.4,1.3-.5,2-.2,0-.8-.6-1.2-.5s0,1.1-1,1-1.3-.5-1.3-1.5l1-1.5,3,.5Z"
          fill="#066af6"
        />
        <path d="M381.9,148.8c.3.2.3.3,0,.5v-.5Z" fill="#0358f4" />
        <path d="M371.6,148.8c0,.7-.5.5-1,.5.1-.5.6-.4,1-.5Z" fill="#037bf8" />
        <path
          d="M363.6,155.3c.6-.1,1.4.2,2-.2s-.5-3.4,2.5-2.3l-.2-1.5c3.6,1-3.5,3.3-.8,4h.5c.4,0,.8.5,1,.5-.3,0-1-.2-1,.2l2,1.7c-2.1.6-.6,1.4-2.5,1-.3-.3-.7-.6-1-1-.2-.2-.3-.4-.5-.5l-3.5.5c-1.3,1.5-4.8,1.2-4.5-1-.4-.1-.4-.3,0-.5-.3-.5,0-1.2,1-2,1-1.2,1.5-.9,1,.5.6.6.6.9,0,1v1.5c.7-2.2,1.8-.6,1.1-.6s0-.4.4-.9c.9-.4,1.7-.6,2.5-.5Z"
          fill="#0487f9"
        />
        <path
          d="M362.1,157.8c.1-3.5,1.1-.5,1.3-.5.5,0,1.1-.7,2.2,0,0,.2-.3.5-.5.5-.4,0-1,0-1.5,0-.4.5-1.2.6-1.5,0Z"
          fill="#026cf1"
        />
        <path d="M367.1,155.3l2.2-2.5c1.2,1-1,2.3-1.7,2.5s-.4,0-.5,0Z" fill="#0356f0" />
        <path
          d="M368.1,160.8c.2-1.3,1.7-.5,2-.7.6-.4,0-1.2,0-1.3,1.5-.8,1.8.7,1.5,2h-3.5Z"
          fill="#0263f2"
        />
        <path
          d="M374.1,157.8v1c-.6,0-.6.2-1,.5.2.4,0,.6-.5.5-.4-.4-.4-.5-.5-1,.5-.6,1.5-.7,2-1Z"
          fill="#068ffa"
        />
        <path d="M374.1,159.3c-.6.7-.5,1.5-1.5.5.2-.2.3-.3.5-.5h1Z" fill="#0346e5" />
        <path d="M366.1,157.8c1.1-.1,1.1,0,1,1,0,0-.3.5-.5.3-.5-.4-.4-1.1-.5-1.3Z" fill="#0360ee" />
        <path d="M368.6,155.8c.6,0,1.4,0,2,0v.5c-.9.4-1.6-.4-2-.5Z" fill="#025ff9" />
        <path d="M375.1,155.8v.5c-.2,0-.3,0-.5,0v-1c.2,0,.4.3.5.5Z" fill="#046cf7" />
        <path
          d="M270.2,81.4c1,.1,1,.6,0,1,1.2.4,2.4.9,3.5,1.5,2.7-.4,2,2-.5,2-.5.2-.7.7-.5,1.5,1.3.5,1.3.9,0,1.5-.6,0-1.4.2-1.9-.1s-.3-2-1.6-.9c-.4-1.3-1-3-2-4,0-.3,0-.7,0-1-.6-1.3,0-1.5,1-.5-.1-1.4.2-1.8,1.5-1,.1-.4.3-.4.5,0Z"
          fill="#2777e7"
        />
        <path
          d="M274.7,82.9v.5c.5,1.4.2,1.5-1,.5-1.3-.2-1.3-.6,0-1,.2-1.4.4-1.2,1,0Z"
          fill="#2777e7"
        />
        <path
          d="M275.7,86.4c1.7-.7,2.4,1.4,1,2.5,0,1,.3,1.3,1,2,.5.1.4.3,0,.5.1.5,0,.6-.5.5,0,1.4-.8,3.5-2.5,2.5-1.7.3-1-2.2,0-3-.7-.2-1.2-.8-1.5-2,0-.2-.3-.5-.5-.5,0-.4-.1-1.1,0-1.5-.8-1-.2-1.7,1-1.5.9-1.2,1.5-1,2,.5Z"
          fill="#2287ef"
        />
        <path
          d="M273.2,89.4c.7-.1,1.7,0,2.5,0v.5c-1.5-.2-.8,1.1-1,1.5l-.7.8c0,2.1-.9,4.2-2.3,1.7,0-.2-.4-.5-.5-1-.2-.8-.5-1.6-.5-2.5l1,1c-.2-1.3.3-1.8,1.5-2Z"
          fill="#1a79e7"
        />
        <path
          d="M277.2,106.9c.1-1.5-.6-3.1-2.1-4.7-.3-1.3,2.1-2,2.1-.2,1.3,0,2.3,0,2.9.4.2,2.5-1.2,2.1-.2.7,2.6-3.9,8.3,3.3,4.2,4.8-1.4-.1-.5.5-.4.5l.4-.5c2-1.1,2.1,2.2,0,1.5l-1.7.2c-.2.9-.7.7-1.3-.7-.2,0-.7-1-1-1s-1,.4-1.3.4-.5-1.5-1.7-.9c0-.2,0-.3,0-.5Z"
          fill="#0487f0"
        />
        <path
          d="M272.2,95.9c.9-1.1,2.4-.9,4.5.5,2.2-.3,1.5,2.9-.5,2q-.8-.6,0,0c.3.8.3,2.1-.5,2.5-.4.6-.7.9-1,1-.4-.9-1-1.8-1.5-3s-.7-2-1-3Z"
          fill="#086de1"
        />
        <path
          d="M278.2,99.9c.4.6.8,1.1,1.5,1.5.1-.3.3-.3.5,0,.4.3.4.7,0,1-.5.1-2.6.1-3.2,0s-.4-1.6-1.8-1c.8,3.9,5.8-.7,2,4,2.5-1.2.6.6,2.5,1.3l-2.5.3c-.3-1.2-1.9-3.7-2.5-5,.2-.6.5-.7,1-1,0-2.1,2.3-3.5,2.5-1Z"
          fill="#0970e2"
        />
        <path
          d="M274.7,91.4c-.2,1.5-.7,1.7,0,3,1.1-.5,1.9.5,2,1.5.4.1.4.3,0,.5l-1.3.5c-.3-1.7-1.9,0-3.2-1-.2-.6-.3-1.3-.5-2,2.2.5,1.2-1.1,2-2.2s1-.3,1-.3Z"
          fill="#0f75e8"
        />
        <path
          d="M267.7,77.4l.5,2,.5.4c-.2.8-.3,1.7-.5,2.6-.3.2-.7.2-1,.5,0,0-.4-.3-.5-.5l-.5-1c-.1-1-.3-1.6-.5-2.5,1.2-.9,1.2-1,0-.5,0-.3,0-.7,0-1,.6,0,1.4.1,2,0Z"
          fill="#3469d8"
        />
        <path d="M266.7,82.4h-.5c0-.3,0-.7,0-1,.5.2.4.7.5,1Z" fill="#2d5fb8" />
        <path d="M265.7,78.9c0-.2,0-.3,0-.5l1-.3-1,.8Z" fill="#446cd7" />
        <path
          d="M277.2,78.9c.5.7.8.8,1,.5.5,0,1.2.5,1.5.5,2.4.1,2.6,1.1.5,2.5-.5,1.1-2.1,1-4.6-.3l-.9.8h-1c-.8.4-.8,0,0-1-.9,0-1.8,0-2.8,0-.6-.8-.2-1.4,1.3-1.9.2-.2,1.4-1.5,1.5-1.5.4-.2,2.9.5,3.5.5Z"
          fill="#4687ec"
        />
        <path
          d="M268.2,79.4s.6.1.9-.2c.4-.5-.1-1.4,1.4-1.8,0,1.2-.8,2.5.7,3l1-.5c-.2.3-1.1,1.4-1,1.5,1.1-.2,2.1-1,2.5.5,0,2.1-2.4,1.3-3.5.5,0-.3,0-.7,0-1-.6-.5-.8-.5-.5,0-.5.3-1,.7-1.5,1-.6-.6-.4-2.4,0-3Z"
          fill="#3978e3"
        />
        <path
          d="M279.2,78.4c-.4.2-.8.7-1.5.5,0,.6.5.5.5.5.2.3,1.1,1.4,1,1.5h-2s0-2,0-2c.4,0,1.3-.7,2-.5Z"
          fill="#5490ef"
        />
        <path
          d="M279.7,79.9c0,0,.5-.6,1.1-.4s1.1,1.1,1.4.9,0-.7,0-.9,3.3.5,3.4.6c.4.3.4,1.1.6,1.2s1.6-.7,2.2,0c-.2-.6.2-1.4.2-1.5l5.5,2.3,3-.3c.1.4-.1,1.3,0,1.5s.5-.2,1.5,0c.8,1.1.6,1.6-.5,1.5-.8.5-1.8,0-1.5-1-.7-.2-1.4-.2-2,0-.2.4-.6.8-.9.7-2.2-1-3.6-1.1-6-.9-.9,0-1.3-.3-1.5-1.3-1.7.9-1-.8-.6-.3.9,1.2-2.4.9-2.4-.2-.9,1.3-1.8,1.6-3,.5l-.5-.3c-.4-2.1.9-.6,1-.7.4-.5-.4-1.3-1-1.5Z"
          fill="#4c92f3"
        />
        <path
          d="M299.2,83.4c.2.4.3.4.5,0,.3.1.7.3,1,.5.7.4,1.6,1.4,2.3,2l.3-1.5c.5.5,1.4,0,1.5,0,.6,1.1-1.3,2,1.5,2,1.9,1.3,0,4.1-1,1.5-.9,1.6-2.8-.2-3.5-1-1.3,1.2-2.1.5-2.5-2-.3,1.3-.6,1.3-1,0l.5-1.5c.2,0,.3,0,.5,0Z"
          fill="#4090f4"
        />
        <path d="M288.7,79.9c0-.2-.7-.8-.5-1,.7-.5,1.5.3.5,1Z" fill="#5682e8" />
        <path d="M299.7,83.4c.2,1.4-.7,1.4-.5,0,.2,0,.4,0,.5,0Z" fill="#308df2" />
        <path
          d="M307.2,86.4c0,.9.4,1.7.5,2.5,1-.2,1.6-.7,2.7,0s1.3,1.6-.2,1.4c-.8.9-1.8.2-2.5-.5-1.1-.1-1-.6,0-1-.2.6-1.4,1.1-2,1-.1.4-.3.4-.5,0-1.5,0-1.9-2.3,0-2,.5.1,1,.3,1.5.5l-.5-2c.3,0,.7,0,1,0Z"
          fill="#2d87f0"
        />
        <path d="M322.2,91.4c1.2,0,2.3.6,3.5.5,0,.7-1.2.6-2,1s-1.7.7-2.5,1.5l1-3Z" fill="#3e83f0" />
        <path
          d="M316.2,90.9c1.2,1.4,1.8-.3,1.5,2.5l1.5-1.5c0,.7.4,1.3.5,2,0,.7-.2,1.2-.5,1.5,0,1-.8,1-1,0,0,1.9-2.1,1.2-2.5,0-.3-.1-.3-.3,0-.5-.6-.6-.3-.7,1-.5.4,0-.3-.6-2-1.5-.5.5-1.6-.3-1.5-1,.2,0,.7.2.9,0,.3-.4.2-2.2.6-2.9.7.7,1,1.4,1.5,2Z"
          fill="#348ef4"
        />
        <path
          d="M307.7,89.9c1.5-.6,1.3-.2,2.5.5s.8.6,1.5,1,.7,0,1.5.5c.7.7.3,1-.5.5-.3.2-.6.3-1,.5-.5.9-4.6,1.4-4-.5l-.5-.5c-.1.4-.3.4-.5,0-1,.4-1.3.3-1-.5-.9,0-1.4-1.1-.5-1.5h.5c1.1-.5,1.7-.5,2,0Z"
          fill="#2990f4"
        />
        <path
          d="M331.2,101.4c0,.2.1.7,0,1.1s-1.9.5-1,1.3,1.9-.5,2-.5c.5,0,1.7.8,2.5.5-.5.9-.7,1.1.5,1v.5c-.3.2-.4.7-.5,1-.8.8-1.6,1.6-2.5,2.5,0,1.4-2.1,1.4-2,0-.4-.1-.4-.3,0-.5l.5-.5c-.9,0-1.2-.9-.5-1.5-.1-.4,0-.6.5-.5.2-.2.2-.4,0-.5-.9,1-1.4.8-1-.5l-.5-.5c1.7,2.4-2.1,2.7-2.5,1-1.1-.7-.8-1.2.5-1-.5-1.6.6-2.6,2-2,.2-.2,1.8,0,1.5-1.5.1.2.4.3.5.5Z"
          fill="#0d84f6"
        />
        <path
          d="M327.7,97.4c-.5,2.8,1.2.5,2,1s.3,1,.5,1.5c-.2,0-.8-.1-1,0s.7,1.4-.5,1.5l-1-1.5c0,.3,0,.8,0,1,.7,1.7-.9,2.1-1.5.5-.4-1-.1-2.6,1-3-.9-.2-.8-.6,0-1,.2,0,.3,0,.5,0Z"
          fill="#1875ed"
        />
        <path
          d="M319.7,94.9c1.1-.5,1,1.1,1.2,1s.6-.8,1-.8,2.2,1.3,2.8,1.3c-.3,1.5-.6,2.7-1,4,.2,1.4-1.1,2.8-2.4,1.6-1.6.8-3.1-2.4-1.6-3.6l-.4-.6c-1.1-.3-3.3-1.4-1.1-2.4.3,0,.7,0,1,0,.2.3.4.2.5-.5Z"
          fill="#2a94f7"
        />
        <path
          d="M324.7,96.4c.4,0,1.6-1.3,1,.8s-1.2,0-1,.7c.9.4,1.9-.5,2.5-.5,0,.3,0,.7,0,1-.7,1.5-1.5,2.1-2.5,2-.4,1.3-.6,1.2-1,0l-1.5-2.5,2-.5-2.5-1h3Z"
          fill="#2380f1"
        />
        <path d="M319.7,94.9c0,.3,0,.7,0,1-.4.1-.4-.5-.5-.5l.5-1.5c0,.3,0,.7,0,1Z" fill="#2288f3" />
        <path
          d="M337.2,107.4c.1.1,1.4-.3,1,1-.3,0-.7,0-1,0,0,.1.5,1,.5,1.5-1.1.1-1.2.4-2,1s-1,.5-1,.8c.1.3.3,1,.5,1.2.6.6.3.7-.5.5-.3.4-.7.8-1,1.3.3.7,1.9.6,2,1.2-1.3,1.9-3.5,1.5-2.5-1-.3-.3-.7-.7-.5-1-.3-.6-.5-1.2-.5-2-2.9,1.8-3.4-1.8,0-3,.8-1.7,2.3-2,3.5-.5l.5-.5c-.5-.7.5-1.1,1-.5Z"
          fill="#0586f5"
        />
        <path
          d="M334.7,106.4c0,1.6,0,.9,1,.5.9-.3,1.2.3.5,1,.3.9.4,1,0,2-.7-.3-1.2-1.8-2.2-1.8s-1.1.6-1.7.8c.1-1.9.6-2.2,2.5-2.5Z"
          fill="#0e94f9"
        />
        <path
          d="M356.7,147.8c-1.3.8-.8,2-1,3.5l1.2-1.5c1,1.1,2.2,1.6,3.8,1.5.8.8-2.4,2.6,1.5,1.5,0,.1,0,.4,0,.5.2.5.4,1,.5,1.5.5-.4.9-.4,1,0v.5c-.8.2-1.2.8-2.5.5-.4,1.1-.9.7-1.5-1-.2-.1-.3-.6-1-.5-.4.8-1.4,1.9-2,1-.4-.6-.9-1.5-.5-2,.1-.5.7-.7,1.3-.8,2.5-.4-.7.7-1.8.3-1.2-.2-2.4-.6-3.5-1-1.7.4-1.5-.9-.5-2-.8-.9,0-1.6,1-1,.7-.6,1-.3.5.5,0,.3.1.3.5,0-.5-.9,0-1.4,1.5-1.5.2,0,.3,0,.5,0,.4-.3.8-.3,1,0Z"
          fill="#0491f9"
        />
        <path
          d="M344.7,144.3c.5-1.5,6.1,1.3,6.4,1.8s.1.4,0,.7c1.1-1.1,2.7-.5,3,1,.3,0,.7,0,1,0-.3.4-1.1,1.4-1.5,1.5-.1.3-.3.3-.5,0-.1-.2-.5-.4-.5-.5-.5-.3-.4-.6,0-.8s-1.5,1.9-2,.3c0,.4-.3.4-.5,0-.4.9-.8.3-1-.5-.5,3.3-4.5,1.4-2,0-.4,0-.5-.4-.5-1-.4-.1-.4-.3,0-.5.1-.9-.9-.4-1.5,0l-.5-.4c-1.2-.6-1.3-1.1,0-1.5Z"
          fill="#049afb"
        />
        <path
          d="M355.7,141.3c.8,1-.3,2.1,0,2.5s1.6,0,2,.8c1,2-.9.8-1,.7-.8,0-1.5-.2-2-.5-.6-.1-1.1-.6-1.5-1.5-.5.6-.7,1.1-.4,1.6l-.6.4c0-2,3.3.7,2,1.5,0,.3,0,.7,0,1-.7-.2-2-.7-3-1-.8-.9-.5-1.4,1-1.5-.7,1-3.8-.2-5-.8s0-.3,0-.7c-.4-1.6,1.2-.9,2,0,.1-.4.3-.4.5,0,.6,0,.8-.1.5-.5.2-.6.9-1.1,2-1.5.3-.3.8-.4,1,0,.5-.2,1.2-.4,2-.5h.5Z"
          fill="#0490f8"
        />
        <path
          d="M353.2,143.3c.7.3,1.3,1.2,1.5,2,.7-.3,1.2-.3,1,.5,0,.1.8,1.3-1.5,1-.6-1.9-.8-1.2-2-1.5.1-.7-1.3-1.7,1-2Z"
          fill="#069ff9"
        />
        <path
          d="M348.7,135.3c0-2.3.9-2.2,2.4-.6,1.3,0,2.5-.2,3.6-.4.9,3,2,.7,3.3.6s1.9.3,2.7.4c.2-.3.3-.3.5,0,.6.6,1.3,1.1,2,1.5.2-1,.5-.9,1,0,.2.5,0,.7-.5.5-.8.5-1.7.7-2.3,1.5.2-.8-3.6-1.6-3.7-1.5-.4.3.3,1.4,1.2,1.5s.9-1.2,1.8.8l-1.5.3c1.4,2.6,1.8-1.7,4.5-.5l-2.5,1c-.2.9.9.3,1.4.6s0,.8.1.9q-.6.9,0,0c.1,0,1.1,0,1.5,0,.5-.4,1-.4,1.5,0-1.2,3.1.3,1.5,1,2s0,.7,0,1c-.7-.2-1.7-.9-2-.8s-1.4,1.7-1.4,2.1.8.6.9.7c1,1.7-1.6,2.8.5,4,.1-.3.3-.3.5,0,.8.4,1,.7.5,1,.2.6.2.9-.5,1-.5.5-1.3.3-1-.5q.2-.2,0,0c-.2.4-.3.4-.5,0-.6,0-1,.1-1.5.5-1.6,2.2-2.4,1.5-2.7-.9-3.6-.4-7.3-1.1-2.8-4.1-.3-.2-.6-.2-1,0,0,.4-.3.4-.5,0-.6.5-.9.5-1,0-.9-.4-.9-.8,0-1,.3-.5.8-.8,1.5-1-1-.6.5-1.4,1-.5,1.1-.8-.3-1.4-1.4-1-.7-1.2-.6-2.1.4-3l-1-.5c-.9-1.7.6-2.2,2-2.5-.2-.6-.5-.9-1-1,0,.8-.1,1.2-.9,1.2.2,1.8-1.4,3.1-2.6,1.8-.6,0-1.1-.2-1.5-.5-.7,0-1-.7-.9-2-1.6-1-2-1.9-1.1-2.5Z"
          fill="#0382f8"
        />
        <path d="M363.1,136.8c-1.2,0-2,0-2-1.5,1,.1,1.6.6,2,1.5Z" fill="#025af2" />
        <path
          d="M352.2,140.3c1.3-.1,2.1.3,1.5-1.7s-1.9-1.3-1-3.3c1.2,0,.5,1.9.5,2,.4.5,1.8.2,2.5,0,.4-.5.7-.2,1,1,.2.5,1.4.4,1,1.5-1.8-.9-2-.4-3,1,0,.3-.2.5-.5.5-.1.4-.7.3-1,0-.1.2-.5.4-1,.5-.2.2-.3.2-.5,0-.4-.1-.4-.3,0-.5l-.5-.5c-.7-.7.4-1.3,1-.5Z"
          fill="#0491fa"
        />
        <path
          d="M360.1,143.8c0,.3-.7.9-.5,1l1.5.5-1.5.3,2,1.3,1-1.5c-.2.5-.3,2.2,0,2.5s1-.3,1,.2c-.3.6-1.1.9-1.5,1.3-.4,0-.7,0-1-.5.3,0,.8-.7,1.5-.5v-.5c-3.7-.2-3.3-1.2-3.5-4,0-.8.8-.7,1,0Z"
          fill="#0476f5"
        />
        <path
          d="M362.1,149.3c-.1.1.4.9-.9,1.3s-1.8.5-1.6-.8c.3,0,.8,0,1,0,0-.8.9-.8,1.5-.5Z"
          fill="#0996f9"
        />
        <path d="M361.1,148.8h.7c.2.1.4.4.3.5s-1,.3-1.5.5c-2.5-1.7.3-.9.5-1Z" fill="#025ee9" />
        <path
          d="M356.7,145.3c-.8,0-.7,0-1,.5-.5,0-.7-.4-1-.5-.4-.1-.3-.3,0-.5,1.4.1,2.2-1.3,2,.5Z"
          fill="#045eea"
        />
        <rect
          fill="#035ff0"
          height="1"
          transform="translate(218.9 504.5) rotate(-89.9)"
          width="1.5"
          x="361.4"
          y="142.1"
        />
        <path d="M363.6,152.3c-.5.3-1,.4-1.5.5,0-.3-.1-.9,0-1,.6-.5,1.3.4,1.5.5Z" fill="#046cf8" />
        <path d="M359.1,143.8c0-.2-.7-.9-.5-1,1.2,0,1.8-.3,1.5,1h-1Z" fill="#045fec" />
        <path d="M355.7,137.3c0,0,.1-.8,1-.5,0,.4-.1,1.2,0,1.5l-1-1Z" fill="#035ce9" />
        <path d="M364.6,142.3c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#045ded" />
        <path d="M355.7,141.3h-.5c-.4.2-.7.3-1,0,.1-.2.4-.3.5-.5.5,0,.7.1,1,.5Z" fill="#035fed" />
        <path d="M365.6,151.8c.6,1,.8,1.1-.5,1,0,0,.5-.9.5-1Z" fill="#0358ef" />
        <path d="M356.7,147.8c-.3,0-.7,0-1,0l.7-.5.3.5Z" fill="#10a5fb" />
        <path d="M364.1,152.3c-.2-.2.5-.8.5-.2s-.4.4-.5.2Z" fill="#26acf7" />
        <path
          d="M339.2,127.4c.3-.2,1.2-1,1.2-1s.8.7.7,1-2.1.4-1,1.5,2,.4,2.5.5c.3-.8.7-.8,1,0,.7.4.2,1.6,1,2,.4-.8.8-.9,1,0,.7.3,1.3.8,2,1.5.5.5.3,1.3-.5,2.5.2.2.3.2.5,0-.7-.4-.3-1.1.5-1,.3.3.4.6.5,1,.7,2.3,2.7,1.3,3,2.3s-1.4.4-1,2.2c.8,1.2-1.9,1-1.5-.5-.5-.4-.6-.4-.5,0,.7.9.9,1.2,2,1.5l1,.5v.5c-.6.7-2.3,1.9-3,1,1-.1,1.2.3.5,1-.6-.2-1.6-1-2,0-1.3.3-1.5-.4-1-1.5.3-.3.7-.4,1,0,.3-.3.8,0,1.5.5l-1.5-1c-1.1.9-1.6-.2-1.5-1.5q-.7-.8,0,0c.7.2.2,1.6-.5,1.5-.7.7-1,.4-.5-.5-.3-.2-.6-.1-1,0-.1.3-.3.3-.5,0,0,1-.8,1-1,0,.6-.8.1-2-1.5-3.5-.8-.7-.4-.8.5-1,.2-1.3.4-1.1,1,0l1.2-.7c1.6.7,1.4.4.3-.6-1.3.7-2-.2-2-2.7l-.6-.4c.6-.6.3-1.2-.9-1.6-.2-.3-.4-.3-.5,0,1.1.2,1.2.6.5,1-.4.7-.6.6-1,0-.8.6-1,.3-.5-.5-.6,0-.6-.5-.5-1-.7,0-1,.2-1,.5-.3.7-.7.8-1,0-.6,1.3-1.2.9-2-1-.9-.6-.9-.8,0-1.5.8-1,1.9-1.3,3.5-1h1.5Z"
          fill="#0497f9"
        />
        <path
          d="M349.7,114.4c0,1,0,.5.6,1.5s0,.9.1,1c.6.6,1.6.4,1.7.5s-1.5,2.5,2,2c-.9-1.5,0-1.7.5-2.5l.5,1c-.4.3-.4,1.1-.5,1.5.7,0,.7.7,0,1v.5c.4.6-.3,1.4-1,1,0-1.1.4-1.8-1-1.5.8,1.7-.6,1.5-2,1.5-.4.4-.7.4-1,0,0,.4.2.8.5,1,0-1,.4-.6,1,0,.4.4,1.3.4,1,1.5-.9.3-1.1-.7-1.8-.9s-2.1.6-2.6-.7.6-1.2.4-1.4-.8.1-1,0c-.6.4-.9.1-.5-.5q.2-.2,0,0c-.7-.2-1.4-.2-2,0,.4.4.9.8,1.5,1,.1-.4.3-.4.5,0,.2.7,1.3,1.3,1.5,1.8s-1.4.2-1,1.2c-.1,0-.4.8-.8,1s-1.7-1.2-1.7-1.3c-.4-1.3,1.9-1.5.5-2s-2.1.6-3,.3c-.4-1.8,1.5-.7,2-1-.7-.6,0-1.9,0-2-1.9-1.3-.9,2.4-3,1.5l-.5-1.5c.5-.5,1-1,1.5-1.5-.6-.7-.5-1.5.5-2.5,0-.4.4-.4,1,0,0-.4.3-.4.5,0,.2,1.7.3,1.7.5,0-.7-.7-.4-1,.5-.5.3-.2.8-.3,1-.5,2.2,1.5,4.8,2.2,1.5-.5l2-1c.8.1.7.8,0,1Z"
          fill="#047af5"
        />
        <path d="M350.7,121.9c.2.3.3.8.5,1h-1c-.6-.1-.9-.4-.5-1,.8-.8.7,0,1,0Z" fill="#0264f2" />
        <path
          d="M349.5,117.6c.2,0,.6,1.3,1.7.8l-1.3,2c-.7.3-.9-1.6-2.2-1l1-1c-3.2.4-3.2-2.6.8-.8Z"
          fill="#0264f2"
        />
        <path d="M344.7,115.9c1.3,4.5-1.5,3.8-.5,0,.1-.4.3-.4.5,0Z" fill="#0692f5" />
        <path
          d="M346.7,120.9c.1,0,.3.3.5.5-.2.2-.3.4-.5.5s-.3,0-.5,0c-.6-.2-1.3-.4-1.5-1,.8-2.2,1.7-.2,2,0Z"
          fill="#098ef7"
        />
        <path d="M344.7,120.9c.8-.2,1.1.4,1.5,1-.9.2-2,.2-1.5-1Z" fill="#0370f4" />
        <path d="M350.2,122.9c-1.2,0-1.4,0-.5-1l.5,1Z" fill="#0370f4" />
        <path d="M351.7,120.4c.6.6-.2,1.6-1,.2,0-.4,1-.3,1-.2Z" fill="#0264f2" />
        <path d="M355.2,120.4c-.1.2-.3.3-.5.5l-.4-.2c0-.2.4-.2.4-.3h.5Z" fill="#0370f4" />
        <path d="M346.7,120.9c-.2-.2.5-.8.5-.2s-.4.4-.5.2Z" fill="#0370f4" />
        <path
          d="M330.7,120.9c0,0,.4-.5,1.4-.2s1,1.3,2.1,1.2c0,.2,0,.4,0,.5-.1.2-.9.5-1,1-.3,1.2-1.7-.7-1.6-.7,2.8,1.7,0,4.4-.9,1.2-.4.1-.5,0-.5-.5-.2-.7,0-1.9.5-2.5Z"
          fill="#05a5fa"
        />
        <path
          d="M333.2,123.4c.3.1.4.4,1,.5-.1,1.1,0,1.1.5,0,.3,0,.7,0,1,0,1.3-.5,2.2,1.1,1,2,.1,1.3,0,1.4-1,.5-1.2-.2-2.4-.2-3.5,0-1.2,1.3-2.7-.9-1.5-2-.2-.2-.2-.3,0-.5.3.3.8,1.8,1.5,1s-1.5-2-1-2.5,1.5.8,2,1Z"
          fill="#0388f6"
        />
        <path
          d="M335.2,126.9c.1.5,0,.6-.5.5l-.5.5c.4.2.4.3,0,.5,0,.3.6.9,0,1.5-.1.2-.3.2-.5,0-.2-.2-.3-.2-.5,0-4,2-3.6-2.7-1-3.5,0-.8,3.1-.3,3,.5Z"
          fill="#0388f6"
        />
        <path
          d="M337.7,123.9l.5.5c.1-.4.3-.4.5,0v.5c-.1.4-.3.4-.5,0l-.5.5c.4.1.4.3,0,.5,0,.6-.8.6-1,0-.4-1.5-1-1.9-1-2s.6-.6.5-1.5c.1-.4.3-.4.5,0,.9-.3,1.6.7,1,1.5Z"
          fill="#069ff8"
        />
        <path d="M334.7,123.9l.2,1h-1.2s.5-1,.5-1c.1,0,.3,0,.5,0Z" fill="#026ee6" />
        <path
          d="M337.7,111.4l.6.2c1.5-1.3,3.8,1.7,1.2,2.2.4,1,0,1.5-.8,1.6.3-1.7,1.6-.4,2.6.6s.5,1.9.4,2.4c-.4,1.5-2.3,1.1-2.5-.5-.4-.1-.4-.3,0-.5-.7-.7-1.5-1.5-.5-2-.3.5-.3,1.2,0,2-.8,1.2-.6,1.7.5,1.5.6,0,1.2.3,1.5,1h1.1c1.2-1,2.3-1.1,3.2-.4-1.1,1.6-.9,2.8,1.3,3-.5,1.8-.2,2.6,1,2.4.2,0,.7,0,1,0l.7.8c-.7,1.5-.6,2.9.8,3.7.5,0,1,0,1.5,0-1.2.8-1.8.8-3,2,.5,0,4.2-.9,3,1s-2.4-1.6-2,.5c3-1.1,1.4,1.4,1.5,1.5s1.1,0,1.5,0c.1-.4.3-.4.5,0,1.7-.4,1.3-1,2-1.5.1-.5.3-.4.5,0h.5c0,.2,0,.4,0,.5l-.5.5c-.1.2-.3.4-.5.5-1.9,1.3-1.7.2-3.1.6s-1,1.2-1.9.9v-2s-1,1.5-1,1.5c-.5.3-.7,0-.5-1,0-.6-.2-1.3-.5-2-2,0-1-.7.5-1-1.2.9-2,.9-2.5,0,.4-1.1.1-1.1-1,0-1.4,1.1-2-1-1-2-.1-.7-.5-1.1-1-1.5-.8.7-1.6,0-1-1q-.5-1.1,0,0c.1.6.5,1,1,1,1.6,0,1.5,1.4,0,1.5,0,.7-.2.8-.9.1-1.5.9-3.1-.5-2.6-2.1-.6-.5-.9-1.9-.5-2.5-.4-.1-.4-.3,0-.5-.7-.5-1.1-1.4,0-1.5q.8-.4,0,0c-.6.1-1.3,0-2-.5-.2-.3-.4-.3-.5,0,.9,1.1,1.1,1.8-.5,1.5-.4.8-.8.9-1,0-.1.4-.3.4-.5,0-.6.9-1.4.5-1-.5-.9-1.3-.2-1.9,1-1q1.4.4,0,0c-.4-.2-.4-.3,0-.5l-1.3-1.7c.9-.4,1-1.4.8-2.3,0-.8.7-1.5,2-2-2.4.4-3.2-2.7-1-2.5,1,0,1.2-.2.5-.5-1.1.6-1.7,0-.7-.8-1.4-.6.1-1.8,1.2-1.2.9-.4,1.9-.6,2,.5Z"
          fill="#0590f8"
        />
        <path
          d="M348.2,124.9c.3-.1.8,1.3,1.2-.5,1.8,1.4,2.9,1.3.3,2.7l2-.3c0,.3.7.8.5,1-.4.3-2.6.4-3.2,0l.7,1.5c-.4,0-1.4.6-1.5.5-.1-.1-.3-2.9-1.5-3.3.9.1,1.4-1.7,1.5-1.7Z"
          fill="#0583f7"
        />
        <path
          d="M348.2,134.3c0,.2-.4.7-.5,1-.1.4-.3.4-.5,0l-1-.2c.8-.7,1.4-1.2,1.5-2.3-.4,0-.4-.3,0-.5,1.5.5.6,1.2.5,2Z"
          fill="#037ef6"
        />
        <path
          d="M348.2,131.3c-.3.3-.3.7-1,.5-.1.4.5.4.5.5,0,.2,0,.3,0,.5-1-.3-2.5-.3-2-1.5.8,0,1.7,0,2.5,0Z"
          fill="#0475f7"
        />
        <path
          d="M341.7,118.4h.5c0,.3,1.7,1-1.5,1.5s-1.3,0-1.5-1c-1.3-.2-1.2-.6,0-1,.8.8,1.5,1,2.5.5Z"
          fill="#0da1f7"
        />
        <path
          d="M333.7,117.9c1.8.8,2.4,1,1.5,3l-.5-1.5c-1.8.7,0,1.1-.5,2.5l-.9.7c-.9-.6-1.7-1.2-2.6-1.7-.2.4-.3.4-.5,0,0,0-.5-.5-1-.5-.3-.1-.3-.3,0-.5-.6-.7-.4-1,.5-.5,0-.4.3-.4.5,0,.3,0,.8,1.4,1.7-1,.7,0-.8,2.2,1.7,1l-1.5-2c.7-.2,1,.3,1.5.5Z"
          fill="#0388f6"
        />
        <path
          d="M338.7,124.9c.2,0,.6,1.2,1.5,1l-1,1.5c-.6.5-1.4,2.3-1.5,0,0-.4.2-.7.5-1-.8,0-.9,0-.5-.5v-.5l.5-.5c0,0,.4,0,.5,0Z"
          fill="#0378f2"
        />
        <path
          d="M338.7,117.4c.1-.4.3-.4.5,0,0,.2,0,.3,0,.5,0,.3,0,.7,0,1-.7,1.6-2,.5-3-.3,3.1-.3.4-.9.5-1,.6-1.6,1.5.5,2-.3Z"
          fill="#0481f5"
        />
        <path
          d="M344.7,131.3c.2-1.9,1.6-2.4,3-1.3-.4.7-1.7.6-2,1.3-.3,0-.8,0-1,0Z"
          fill="#0374f4"
        />
        <path
          d="M338.7,122.9c.1-.7.2-1.4,1-1.5-.3,2.1.5,1.2,1.1,1.5s.5,1.3.4,1.5-2.1-1.3-2.5-1.5c0,.4,0,1,0,1.5h-.5l-.5-.5c-.3-.3-.9-1.1-1-1.5,1.7-1.2,1.2,0,2,.5Z"
          fill="#0479f2"
        />
        <path d="M338.7,115.4c0,.6.4,1.2.5,2h-.5l-2-2c.7,0,1.3,0,2,0Z" fill="#027bf5" />
        <path
          d="M342.7,127.9c1.1-.6,1.1-.1,2,.8,0,.1-.8.7-1,.7s0,.4-.2.4-.5-.4-.8-.4c.8-1,.4-.9,0-1.5Z"
          fill="#0374f2"
        />
        <path d="M342.7,127.9c-.4.3-.2,1.3-2,.5-.2-.2.9-1,1-1.5.3.4.8.7,1,1Z" fill="#0374f2" />
        <path d="M336.2,122.4c0-.4-.6-1.9-.5-2,1.7-.4.7,1.1,1,2h-.5Z" fill="#0388f6" />
        <path d="M335.2,112.9c.2.1.9-.1,1,0,.7.9-.6,1.4-1.5.5.2-.2.3-.4.5-.5Z" fill="#0368e4" />
        <path d="M341.7,126.9c-.7-.7-1.2-.2-.5-2h.5c0,.6.1,1.5,0,2Z" fill="#0363e6" />
        <path d="M347.2,128.8c-.6.3-1.7-.8-1.5-1,.6-.3,1.7.8,1.5,1Z" fill="#026cf5" />
        <path d="M334.2,122.4c1.2,0,1.7-.3,1.5,1l-1.5-1Z" fill="#0388f6" />
        <path d="M342.7,110.4c.2-.5,1.1.3,1.2.6,0,.9-2.7.8-1.2-.6Z" fill="#147cf3" />
        <path
          d="M340.7,104.9c-.3,1.8,1.3.3,2.2.9s.9,3.7,2.8,1.1c.8,0,2.5.6,2,1.5-.7-.2-1.3-.5-2-.5.3,2.5-.2,2.1-2.5,2-.1-.3-.3-.2-.5.5-.8,1.5-2,.2-1-1-.9.2-.2-1.2-.2-1.1,0,.7-.5,1.4-1.3,1.6-.5,1.9-2.1,0-2-1.5-.5-.1-.8-.5-1-1-.6,0-1.1-.1-1.5-.5.4,2.3-3.2.5-1-.5-1.3-.6-.9-1.3.5-1,2.6-1.9,2.7-.2,4.3,0s1-.4,1.2-.5Z"
          fill="#147cf3"
        />
        <path d="M341.7,109.4c-.2.6-.9.5-1.5.5l1.3-2c.6.1.1,1.1.2,1.5Z" fill="#0563e9" />
        <path d="M335.7,106.9c2.4-1,1.1.1,1.5.5l-1,.5c0-.2-.6-.6-.5-1Z" fill="#279ef6" />
        <path d="M344.4,108.9c.3.2.3.3,0,.5v-.5Z" fill="#0768f0" />
        <path d="M341.4,106.4c.3.2.3.3,0,.5v-.5Z" fill="#186aeb" />
        <path d="M341.7,110.4c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#0590f8" />
        <path
          d="M338.2,108.4s.1.4.5.3c.5-.2.8-1.2,1.5-1.3l-1,2.5c.3,0,.7,0,1,0,.5-.5,1-.7,1.5-.5,0,.1.8,1.2,1,1-.1.1,0,.5.2.5.5,0,0-.7-.2-.5v-.9c.4-.2.5.4.5.4.2.9.9.8,1.5,1,.1,1.2.3,2.3.5,3.5,0,.9-.9,1-1,0-.2-.4-.4-.4-.5,0,.9.7.6,1.3-.5,1-.4,0-.5.2-.5.5,1.1,1.1-.4,2-.5,2.5-.1.4-.3.4-.5,0-1.6-.5-.8-2.3-1.7-3s-1,0-1.3,0c0-1.2,1.3-2.6,1-3-1-1.1-.8,1.4-1.7,1s-.2-1.5-.3-2c.3-.5.3-1,0-1.5.8.5.8,1,0,1.5-.6,0-1.3-.4-2-.5-.4-1.1-.3-1.6.6-.8.3-1.3.7-1.3,1.4-.2-1.7.4-1-3.3.5-1.5Z"
          fill="#0575f2"
        />
        <path
          d="M345.2,114.4c0,.3,0,.7,0,1-.4.2-.5.5-.5.5-.1,0-.3,0-.5,0s-.3,0-.5,0c-.4,0-.6,0-.5-.5,0-.3.5-.8.5-1,.1-.4.3-.4.5,0h1Z"
          fill="#0264f2"
        />
        <path
          d="M343.2,115.4c.2,0,.3.4.5.5-.4,0-.1.2-1,0-1.4-.3-2.3-.3-3-2,1.1.3,2.4,1,3.5,1.5Z"
          fill="#078bf7"
        />
        <path d="M337.7,109.9c1.6-.2,1.6,1.6,0,1.5,0-.5,0-1,0-1.5Z" fill="#1292fb" />
        <path d="M341.2,113.4c-.9-.3-1.5-1.6-1.5-2.5.2-.4,1.6,1.8,1.5,2.5Z" fill="#0590f8" />
        <path d="M343.7,114.4c0-.2-1.2-1.5.2-1s.2.6.3,1h-.5Z" fill="#0b82f6" />
        <path d="M341.9,116.9c.3.2.3.3,0,.5v-.5Z" fill="#047af5" />
        <path
          d="M375.1,204.3c.2-2.7,1-.3,1.4,0s1.1.2,1.6.5c.6.4.7.4.5,0-.5-3.3,1.3-.5,1.5-.5.4.2.4.3,0,.5.5.6.4,1.5-.5,1.5-.5.9-1,1.9-1.5,3,1.2,2,1,6.7-1.3,2.7-1.1.2-1.8,0-2.2-.7-1.3.5-1.1-1.5,0-1.5.6-.1.9-.5,1-1q-.7-.9,0,0c.6.5.2.8-1,1-.6,1.4-.8,1.3-1.5,0-.2.2-.4,0-.5-.5,0-.5-.2-1.5.1-1.9s.8,0,.9,0c.5-.5,1.1-1.1,2-2-.1-.3-.3-.8-.5-1Z"
          fill="#0369f9"
        />
        <path
          d="M377.6,195.8c.1-.4.3-.4.5,0,1.6.5,2.7,1.6,1,2.5,0-1.6.7-1.7,2-1,.5.8.4.6.5,1.5-.2.2-.2.4,0,.5v.5c-.1,0-.3,0-.5,0-.3,1-.6,1-1,0-1.7,0-2.2,0-1-1.5-.2,1.1-.9,2.1-2,2.5,0,.2,0,.4,0,.5-.1.4-.3.4-.5,0-.2,0-.3,0-.5,0v-2s-.5,0-.5,0c0,.8.2,1.2-.7,1-.5,0-.2-.7-.3-1-.3-.3-.3-.7,0-1,.1-.3.5-1,.5-1l.5-1c-.5-.6-.2-.9.5-.5.7-1.1,1-1.2,1.5,0Z"
          fill="#0367f5"
        />
        <path
          d="M379.1,198.3c0,.3,0,.7,0,1,1-.5,1.1-.8,1,.5-.1.4-.3.4-.5,0-.2,0-1.1,1.4-2.5,1,0-1.2,1.1-1.9,2-2.5Z"
          fill="#047bf8"
        />
        <path
          d="M381.1,199.8l.5,2.5c-2.1.5-1.5-1-2-2.5.1,0,.3,0,.5,0,1.1-.3.6,0,1,0Z"
          fill="#0241ea"
        />
        <path d="M377.1,201.3c0,0,.8.3.8.7.1,1.8-2,2-1.3-.7h.5Z" fill="#0375f8" />
        <path
          d="M383.1,197.8c-.2.8-.7,1.5-.5,2.5-.9.3-.9-.5-1-.5,1.1-1.1-.4-1.3,1.5-2Z"
          fill="#0241ea"
        />
        <path d="M378.6,204.8c0,0,.8.1.5,1-.6,0-.8-.9-1-1h.5Z" fill="#0145f0" />
        <path
          d="M384.6,188.3c0,.6.3,1.3.5,2,0,.3,0,.7,0,1-1.9.2-1-2.5-3,1,.6-.2,1.2-.7,2-.5-.5.9-.7,1.1.5,1l-1.5,1c-.1-.3-.3-.1-.5.5-.3.5-.7.5-1,0-.5,1.1-1.2.7-1-.5-.3-.3.2-.8,1.5-1.5-.3.5-.7.7-1,.5-1-.3-1-.7,0-1-.6-1.8.3-2.8,2.5-3,.3-.4.3-.8,1-.5Z"
          fill="#046af5"
        />
        <path
          d="M382.1,187.3c0,.2,0,.4,0,.5.2.1.4.5.5,1,.2,0,.7,0,1,0,0,.2.1.8,0,1s-2.2-.4-2.5,2c-1.3,0-1.6-.7-.5-1.5-1.3,0-1.4,0-.5-1,0-2.2.7-2.8,2-2Z"
          fill="#067ef8"
        />
        <path d="M383.6,186.3c.5-.1,1.4,0,2,0v1s-3,0-3,0c0-.2.9-1,1-1Z" fill="#046af5" />
        <path d="M385.1,190.3c-1.1-.4-1.2-1.2-.5-2,1,.3.6,1.4.5,2Z" fill="#0247ef" />
        <path d="M382.6,188.8c-.7-.4-.4-.4-.5-1h.5c0,.3,0,.7,0,1Z" fill="#046af5" />
        <polygon fill="#046af5" points="383.6 185.8 383.1 185.6 383.6 185.3 383.6 185.8" />
        <path
          d="M375.6,194.3c-.2-1.1-.2-2.1.2-2.9-2.3-3.4,2.2-2.9,3.3-.6.8.4,1.7,1.1,2,2,.3,0,.7-.4,1-.5-.9,1.5-.7.7-1.5,1.5.2.6.5,1.1,1,1.5-1.3-.1-1.2-.6,0-1,0,0,.6-.4,1,0,.1-.4.3-.4.5,0v.5c-.3,0-1.4.4-1.5.5s.3,1.5-1.5,1c0,.6.8.8,1,1-.5.7-1.4.6-2,1,0-.5.3-1.4-.2-1.5-.5.3-1.7,3-2.7,2s1.5-2.4,2-3c.3-.9.1-.9-.5,0-.4,0-1.2-.1-1.5,0-.4-.1-.4-.3,0-.5.2-.5,0-.8-.5-1Z"
          fill="#0579f7"
        />
        <path d="M385.1,194.8c.2,0,.4-1.1,1-1v1.5c-.1.2-.8-.5-1-.5Z" fill="#034ff4" />
        <path d="M385.1,194.8c-.1,0-1.2,1.1-1.5,0,.2,0,.3,0,.5,0,.3,0,.8,0,1,0Z" fill="#0c82f4" />
        <path d="M381.6,199.3l-.5-.2.5-.2c0,.2,0,.3,0,.5Z" fill="#0579f7" />
        <path d="M389.1,199.8c-.7-.6,0-.5,0-1s0-1,0-1.5h.5c0,1.1.9,2.1-.5,2.5Z" fill="#0344f4" />
        <path
          d="M396.1,185.8h.5s.6.2.4.4-2.4,1.6-1.9,3.1c1.7.4.7-1.3,1-1.5,1.1-1,.9.9,1,1-.1.5,0,.6.5.5,0,.2.6.3.5,1-2,1.2-2.2,1.7-.5,1.5.1,0,.3,0,.5,0l.3.2c0,.4-.4,1-.3,1.3,1.2,2.1,1.7,3.9,1.5,5.5-1,.3-1.9,0-2.5,1,.3,0,.7,0,1,0-.4,2.3-2.4,1.9-1,0-.5,0-1,0-1.5,0l.5-2.5,1,1c-.1-.8.2-1.9,0-2.7s-.9-.2-1-.3l-2,1c-.5,2.4,1.1,1.2,1.5,1.5.9.8-1,1.1-1,1.2-.4,1.5.9,1.2,1,1.3.8,1.2-.8.8-.9,1l-.6.3c-1-1-1.5-1-2.9-.3,1.8-1,3.3-.7,2.2,1.2.6.7,1.6,2.1.8,2.8-1.7,1.9-2.7,2.1-3,.5-.7,1-2-.9-1-1.5.4-.9.3-1.8-.2-2.6l1.2-.4c-.5,1-1,1-1.5,0-.7-.8-.4-1.2,1-1-.6-.5-.3-1.2.5-1v-.7c.7.8,1.1.4,1.5-.3-.6,0-1.1-.5-1.5-1.5-.4-.1-.4-.3,0-.5.7-.8.5-.8-.5,0-.1.4-.3.4-.5,0-.1.4-.6.8-1.4,1.1.1,1.2-1,2-1.6.9,0,.6-.5.6-1,.5-.1.4-.3.4-.5,0-.6-.3-.8-1-.5-2-.7.5-1.3.4-1-.5-.1-.4.2-.7,1-.9,1.4.2,2.4-.2,3-1.1-.8,0-1.3-1-.5-1.5.9-.9,1.6-.3,1.7.9s-.5-1.4.3-1.4c-1.8-1.5.6-5,.5-2,2.4.3,3.8,1.9,4.5,4,.2.6.7,1,1.5,1-1.4,0-1.9-.3-1.5-1-.6-1.3-1.4-2.6-2.5-4-1.3-.2-1.3-.6,0-1,1.4-.2,2.2-.9,2.5-2-.2-.5-.4-.5-.5,0,.7,1.1-.4,1.9-1.5,1.5-.8-.2-1.2-.4-.5-1-.5,0-.7-.6-.5-1,.2-.2.2-.3,0-.5.1-.4.5-.4.5-.5,1.2-1.7,2.5-.9,4,0Z"
          fill="#0344f4"
        />
        <path
          d="M398.1,193.3c0,.4.4.4.5.5.9.8,2.2.8,3,1.8.5,1-1.5.4-1,2s1.2,0,1,.7c-.7,0-1.3.3-2,.5l-2.7-5,1.2-.5Z"
          fill="#0226ea"
        />
        <path d="M399.6,192.8c.1-.4.3-.4.5,0-.3.3-.8,1.6-1.5,1s.3-1.4,1-1Z" fill="#0226ea" />
        <path
          d="M391.1,199.3c0,0,0,.7-.5,1-.8.1-1,0-1.5-.5.5-.9.5-1.3,0-1-.6,0-1.4.5-2,.5-.6-.3-.7-.8,0-1,.2,0,.7.2.9,0,.7-.9-.8-1,2.1-1.9.8.5,1.5,2.7,1,3Z"
          fill="#0237ef"
        />
        <path
          d="M389.6,201.3c.5,0,1,0,1.5,0-1.1,1.7.8.6,1,2.2,0,.4-1.8.8-2,.8,0,1.2-.6,1.1-1,0-1.2.8-1.7.2-1-1,.6-.6-1.1-1.5,2,0l-1.5-1.7c0-.5.8-.1,1-.2Z"
          fill="#0230f0"
        />
        <path
          d="M392.1,190.3c1.7.2.6.6,1.2,1.3,1,1.2,2.5.9,1.3,2.7-1.8-1.3-1.6-2.3-2.1-2.9s-2-.2-2.4-1.1c.6.1,1.4,0,2,0Z"
          fill="#0234ef"
        />
        <path d="M396.1,195.3l-2.5.5c-.5-1.2.6-.9,1-1.5.4.3,1,.7,1.5,1Z" fill="#0234ef" />
        <path
          d="M391.1,196.3v.5c.5.2,1,.7,1.5,1.5,0,1.8-.7.6-1.5,1l-1-3c.1,0,.3,0,.5,0,.2-.4.3-.4.5,0Z"
          fill="#0658f5"
        />
        <path d="M391.1,196.8h1.5c-.5.6,0,1.1,0,1.5l-1,.5-.5-2Z" fill="#0233ea" />
        <path d="M390.6,196.3c-.4-1.2,1.6-1.9,2-.7s-.4.5-1.5.7-.3,0-.5,0Z" fill="#0233ea" />
        <path d="M387.1,198.3v1c-.4,0-.7-.2-1-.5.1-.6.7-.4,1-.5Z" fill="#035cf5" />
        <path
          d="M392.1,189.3c-.7,0-1.3,0-2,0,0-.6.5-.5.5-.5.6,0,1.4,0,2,0s.9-.6,1.5-.5c0-.3,0-.7,0-1,.1-.4.3-.4.5,0-.3,2.3-.4,1.9-2.5,2Z"
          fill="#022eee"
        />
        <path d="M395.6,190.3v1c-.3.3-2.6-.7-2-1h2Z" fill="#0234ef" />
        <path d="M394.6,187.3h-.5c0-.3-1.5-1.8.8-.5.4.4-.3.5-.3.5Z" fill="#011eea" />
        <path
          d="M387.6,192.8c0,.4.4.9.5,1.5l-.3.5c-1.1.2-1.1-1.6-2.2-2.2.3-.6,1.5,0,2,.3Z"
          fill="#0336ea"
        />
        <path
          d="M390.1,204.3c0,.7.3,1.3,1,1.5,0,0,0,.7,0,1-.8.6-1.7-1.3-2-2v-.5c.2,0,.7,0,1,0Z"
          fill="#065df7"
        />
        <path
          d="M387.1,208.3c.4.6.7,1.4,1,2.5.2,0,.7,0,1,0,.4,1.6,1.8,1.2,2.5,1.5s.5.4.5,1c-.5,1.5-1.7,1.3-3.5-.4h-1c-1.5,0-2.5-.3-3-1.1.4-.9,1-1.2,1-1.3,0-.4-.4-1.4-.5-2.2,0-1,.6-1.5,1.5-1.5,0,0,.4.7.5,1.5Z"
          fill="#0650f5"
        />
        <path d="M365.1,138.8c-.3-.2.5-.7,1-.5s-.6.9-1,.5Z" fill="#002ee9" />
        <path d="M369.1,278.3l1,.5s-.3.7-.5,1l-2-.5c0-.6.9-.8,1-1h.5Z" fill="#0551f6" />
        <path
          d="M376.1,249.8c-.1.3-.3.7-.5,1-.2.5-.4,1.4-.5,1.5-1,1.9-1.6,1.4-2,3.5s-.3,1-.5,1.5c-.4,1-.7,1.1-1,0,.1-.3.6-.9.5-1h-2.5s.3,1.2.3,1.2l-.3.3c-1.5-.4-1-2.5,0-3.5-1.3-.1-1.3-.4,0-1,.9-1.3,2.3-2.1,4-2.5-.4-.7.4-.8,1-.5v-.5c.2-.4.3-.4.5,0,.2-.9.7-.9,1,0Z"
          fill="#033ff2"
        />
        <path
          d="M368.1,262.8l-1.5-.2c1.3-1.9-1.1-.9-1-2.8.6-.2,1.4.4,1.8.4s1.5-3.2,1.7-.4c-.2.5,1.3,3.1-1,3Z"
          fill="#044ff5"
        />
        <path
          d="M369.6,257.8l-.2.5c-.9-1.1-1.3-1.4-2.8-1.5-.3-.4-1.1-.4-1-.8s.8-.5,1-.7c.8-.5,1.6-.9,2.5-1,.1-.4.3-.4.5,0,.2,1.5-.7,2.2,0,3.5Z"
          fill="#0353f7"
        />
        <path d="M372.6,257.3c-.4,1.1-.3,2.4-1.5,2-.4-1,.3-1.4.5-2h1Z" fill="#0232f0" />
        <path d="M364.6,261.3l1.2.5c-1.2-.1-1.1,1.3.3,1h-1.5c0-.5,0-1,0-1.5Z" fill="#0232ec" />
        <path
          d="M366.6,256.8c0,.1,0,.4,0,.5.3.2.3.3,0,.5-.5-.2-1.2.5-1-.7,0-.4.7-.3,1-.3Z"
          fill="#031ed7"
        />
        <path d="M367.1,257.3c.9.2.7,1.3-.2,1s-.2-.5-.3-.5l.5-.5Z" fill="#0e71f7" />
        <path d="M366.6,257.8c0,0,0-.4,0-.5h.5c0,.3-.3.6-.5.5Z" fill="#0353f7" />
        <path d="M369.1,278.3c.5-2.7.5-3.4,3-2l-3,2Z" fill="#023ef2" />
        <path d="M362.6,259.3l1-1c.4,1.5-.7.8-1,1Z" fill="#032de4" />
        <path
          d="M370.1,263.8l-1.5,1.5,1.5.2c-1,1.4-.3,1.1.5,1.8-.2.9-.9,1-1,0-.3-.2-.4-1-.9-1-1.7-.2-3.7,2.2-3.1-1.5-.6-.2-1.2.5-1.5.5l-1-.5v-.5c1.4.9,2.1-.4,2.5-.5.6-.1,1.8-.4,2.5-.5,1.5-1.1,2.1-.9,2,.5Z"
          fill="#044ff5"
        />
        <path
          d="M370.6,267.3c.8.7-.3.6-.5,1.5-.3,0-.7,0-1,0l.5-1.5c.2,0,.7,0,1,0Z"
          fill="#022eef"
        />
        <path d="M368.1,264.8c-.2.7-.8,1.1-1.5,1v-1s1.5,0,1.5,0Z" fill="#0133f1" />
        <path
          d="M369.1,259.8c0,0,1.4-1.1,1.5-1-1.1,3.1.3,1.1,1.5,3s.5.8.5,1c-.5.8-1.2,1.8-2,1-.2,0-.3,0-.5,0-.3,0-1.1-.7-2-.5v-.5c0-1.4.4-2.4,1-3Z"
          fill="#0236f0"
        />
        <path d="M372.6,262.8c0,1.4-1.2,2.2-2.5,2l.5-1c.6,0,1.4-.8,2-1Z" fill="#0756f6" />
        <path d="M371.1,261.8c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#075ff0" />
        <path
          d="M354.7,222.3c0-.4.3-.4.5,0,0-.4.3-.4.5,0,1.5-1,4.6-.1,2,1-.2.9-.4,1.7-.5,2.4.4.1.4.3,0,.5-.7-.2-1.4-.2-2,0l.3-.6c1.3.9,3.9,2.5,3.7.6-.7.3-1.5-.2-1-1-.8.3-1.1-.4-.5-1,.7-.3,2.3-.3,2.5.5.2.6.4.8.5.5.5-.5.8-.7,1,0,.5,0,.7.2.5.5v.5c1.4-.4,2,1.2,2,2.5l.5.5c.5.1.4.3,0,.5-.5,1.5-1.1,1.6-1,0-.8.3-1.3.5-2,.6-1.2.2-.7,1.1,0,1.9.2-.4.3-.4.5,0-.6,1.4-2.3,3.2.5,2,.9,2.5.2,1-.8,1.6s-.5.8-.7.9h-.5v-.5c0-.2,0-.3,0-.5.1-.4,0-.8-.5-1-.2,0-.8,0-1,0-.4-.1-.4-.3,0-.5-.3-.5.3-.7.5-.5s-3.6.5-4,0c-1.3,1.1-1.3-.5-.8,0,1.8,1.6-1,4.4-1.2,1.5-.4-.1-.4-.3,0-.5v-.5c-1.9-.4-3.5-1.4-1.5-3-.2-.6-.5-1.1-1-1.5,0,.7-.2,1.2-.5,1.5-.2.3-.3.3-.5,0,.6,2.3-3.2,1.6-1.5-.3l-.5-.7c-.2.4-.3.4-.5,0-.5.1-.6,0-.5-.5-2.3-2.9-.4-3.1,2-2.5-.7.8-2.1-.2-1.5-1-.9-2.4,4,.2,1.5,1,.7-2,2.3-1.2,1.8,1.3s0-2.4.7-1.8c.2.8.5,1.3,1,1.5,0-.5.3-.4.5,0,1,.2,1.8.5,2.5,1q1,1.4,0,0c-1.3,0-1.4-.3-1-1.5-.6.4-.9.2-.5-.5,0-.4.3-.8,1-1-.4.4-.8.6-1,0-.6-.2-.6-.5,0-1-.7.1-1,0-1-.5-.6-1.3-.3-2.2.3-.6s0,.4-.3.6c.5.2.3.6-.5,1,1,.5.6,1.5-.5,1-.2.3-.4.1-.5-.5-.2.4-1.1-1.8-1.1-1.9,0-.3.8-.8,1.1-1.1-.4-.7-.2-.9.5-.5l.5-.5c0-.9.6-.9,2,0Z"
          fill="#0364f6"
        />
        <path
          d="M376.1,228.8c-.8-1.5.5-5.8,2.1-3.1,2.8.3,1.8,3.6-.1,2.1l1,1.5c1.1-.1,1.1.9,0,1-.3.8-1.3,1.9-2,1,0,0-.4-.6-.5-1-1.3-.3-1.5-.6-.5-1.5Z"
          fill="#0659f5"
        />
        <path
          d="M376.6,230.3c-.5.1-.5.6-.5,1-.5.8-1.3.5-2,0-.2,0-.3,0-.5,0l-.5-.5c-.3-.3-.7-.7-1-1,.6-.7,1.7-.4,2.5,0,.5-.1.8-.6,1-1,.1-.4.3-.4.5,0,0,0,.3.2.5,1.5Z"
          fill="#023def"
        />
        <path
          d="M382.1,239.8c0,.1-.4.4-.5.5-.4.3-.4.5-1,.5-1.1-.2-1.1-.7,0-1,.4-.7,1.1-.5.8-2.5,2.1-.3,1.6,1.3.7,2.5Z"
          fill="#0133ee"
        />
        <path d="M384.1,232.3c.8,0,1.2-.1,1,.7s-.9-.3-1-.2v-.5Z" fill="#0856f7" />
        <path d="M369.1,231.8c.5.7.2,1-.5.5-1.2.1-.4-1.1.5-1,.4.1.4.3,0,.5Z" fill="#034ef4" />
        <path
          d="M384.6,228.3c.4.1.4.3,0,.5.3.3.2.6,0,1,1-.3,1.3.3.5,1,.4.8,0,1.3-1,1.5.4.1.4.3,0,.5-.9.8-1.5,1.8-1.8,3.2l-1.7-.2-.5,1.5-1.1,1.2c-1.3-1.5-1.7-.7-1.9.8.4.5.7.5,1,0-1.5-.7-.9-2,.8-1.3.2,1.2.7,2.2,1.7,2.8.1-.6.5-.9,1-.5.5-.4.9-.2,1,.5v3c-1.8.4-1.9-1.4-2-1.5-.3-.3-1.2-1.1-1.5-1l-1,1.5c-.5.3-1,.6-1.5,1l-1.5.5-.4,1.1c-2.6-.9-3.5,1.3-4.3,3.3-.6-.5-1.1-.8-1.8-.9,0,1.2-.7,1.2-2,0-.5.4-.8.1-.5-.5-1.1,0-2-1.9-1.5-2.5-.7-.2-1.1-.5-.5-1-.2-.6-.3-.6-.5,0-.2.2-.6.2-.5,0s.9.2.5,1c-.4,1.9-1,1.2-1.5-.5-.3-.2-.7-.5-1-1-.1.4-.3.4-.5,0l-1-.5c-1.3,0-1.3-.4,0-1,.3-.4,0-.7-1.2-1,.5-.8.4-1.3-.3-1.5-.9-1.7,1.4-3.4,3-2.5-.2-.3-.2-.7,0-1.2-1.5-1.8-1-2.3.9-3.3,1.4-2.7,2.5-.8,3,1.6,1.5-1,4.1,1.2,2.5,2.4.4.3.6.3.5,0,0-1-.5-2-1.4-2.6,1.2-.5,2.1-1.2,2.9-1.9.4-.1.2-.3-.5-.5-.4-.1-.4-.3,0-.5-.6-.7-.3-1,.5-.5,1-1.2,1.9-.3,2,1,.7-.2,1.4-.2,2,0,0-.5.2-.4.5,0,.8.3,1.5.3,2,0-1.6-.6-.9-1.6.5-1,1.3,0,1.4,0,.5,1,.4.3,1,.3,2,0,.4.2.7.6,1,1,2.2.4,2.3-1.3,1.2-2.8l.3-.7c.2-.4.3-.4.5,0,0-1,2.1-1.5,2.5-.5Z"
          fill="#034ef4"
        />
        <path
          d="M376.6,243.8c-.2-.3-1.6-2.9-1.5-3,3.3-.4,1.1.7,1.7,1.5s1.1.3,1.3.5.4.6,1,1v.5c-.3,1.2-.1,2.6-1.5,1.5-.6,1.4-1.4.9-2.5-1.5.8.5,1.3,1.9,0,2-.6-.1-1.2-.2-1.9-.3-.6,1.7-1.5,2.9-2.6,3.8-.9.6-1.3,0-1-1-1,.6-1.6,0-1-1,.3-.9,1.7.2,2,0s.3-1.2.6-1.7c1-1.5,3-2.6,2.9-4.3.8-.2.6,1.4.5,1.7-.2.6-2-.4-1.5,1.2.4,0,1.8-.3,2-.5.5-.4-1.1-1.2,1.5-.5q1.3.7,0,0Z"
          fill="#0235ea"
        />
        <path
          d="M364.6,229.8c0,.2-.4.4,0,1.5.4.4,2,1.9,1.6,1.2s2.1-.8,2.4-.2c.1,0,.4-.4.5-.5.1-.3.3-.3.5,0,0,1.4.8,1.5-2,1.5-.1,1.7,3.2,1.4.5,3-.1.4-.3.4-.5,0-.6-1.5,0-2.4-2-2l1,1.5c-1.3-.1-3.1-.2-2-1.5h-1.5c0-1.3,1.2-.9,1-2.5-.7,0-1.3.4-2,.5s-.3,0-.5,0c-1.2-1.9.1-2.5,2-2.5,0,0,.3.7,1,0Z"
          fill="#045af5"
        />
        <path
          d="M385.1,230.8c1.3,1.3.1.4.7,1.5s2.1,1.3,2.3,2.3c-.3.6-1.4-.1-2-.3-2.6-.7-3.1-1-3,2.5-.8.3-2.3-1.2-2.5-1,.6-.3,1.5-.8,2-1.3l-1.5-.3c.3-1,2-1.4,3-1.5.7-.2.7-.3,0-.5-.9-.4.4-1.2,1-1.5Z"
          fill="#0238ef"
        />
        <path
          d="M373.1,238.8c-.1,0-.2,2.1-2.5,1l.5,1.5c-1.8.6-1.9-.6-2.5-1,0,.7-.8.7-1,0-.2-.2-1.2.4-1-.5,1-.5,2.1,0,3-.2s3.3-.7,3.5-.8Z"
          fill="#023df0"
        />
        <path
          d="M381.6,228.8c1.5,2.5,1-.2,2.5,0-.7,1.3-2.1,5.5-4,3.5,0-.5.3-1,1-1.5-.8.6-1,.4-.5-.5-1,0-1-.8,0-1-.6-1.4.2-1.7,1-.5Z"
          fill="#0239ef"
        />
        <path
          d="M380.1,237.3c-.2.4-1.1,1.3-1,1.5l1.5,1c0,.2,0,.7,0,1-3.1,0-.9-1.9-2.3-2.5s-.3.7-.2,1c0,.8-.8.8-1,0-1.1-3.4,2.4-1.1,3-2Z"
          fill="#0235ef"
        />
        <path
          d="M362.1,244.3c0,.2,0,.3,0,.5,0,.6-.6.4-1,0,.6.2,1.1.5,1.5,1h-3.5c-.3-1.7,1.1-1.2,2-1,0-.3,0-1.1,0-1.5,0-.9.3-3.6,1.3-2s-.5.7-.5,1.2.2,1.2.3,1.8Z"
          fill="#0359f7"
        />
        <path
          d="M375.6,234.3c-.8,1.9-2.7,2.3-4.5,2-.3-1.9,1.1-.3,2.1-.6s1.2-1.7,2.3-1.4Z"
          fill="#085cf5"
        />
        <path
          d="M381.1,230.8q-.2.2,0,0c1.1,1.3.3.7-1,1.5s-1.4,1.1-1.5,1c-.2-.7.4-1.3.5-2,.3-1.4.8-1.8,1.5-1,.6,0,.5.4.5.5Z"
          fill="#0659f5"
        />
        <path d="M374.1,232.8c-.2.7-3.3,2.2-3.5,2-1.1-1,2.9-2.4,3.5-2Z" fill="#045af4" />
        <path d="M379.1,230.3c.8-.2.8.2,0,1-.5.3-.8,1.6-2.5,1-.2-.1.5-.8.5-1l2-1Z" fill="#022ee7" />
        <path d="M376.1,231.3c0,.5.2,2-.2,2l-1.7-2c.4,0,1.1-.7,2,0Z" fill="#045af4" />
        <path d="M361.1,239.3l2-.3-.7,1.2c-1.9-.5-3.5-.2-1.5-2.4l.2,1.5Z" fill="#0660f6" />
        <path d="M376.1,240.3c-1.6-.7-1.8.2-3,1-.1-2.1,1.7-3,3-1Z" fill="#0760f6" />
        <path d="M369.1,243.3c1.2-2.8,3.4-.5,1.7,0s-1.2,0-1.7,0Z" fill="#013bf0" />
        <path d="M378.1,233.3c-.5.5-.4,1.9-.5,2-1,1-2.1-2.8.5-2Z" fill="#032ce4" />
        <path d="M379.1,236.8c-1.2,1.2-1-1.7-.5-2.5,1.2-.1.7,2.3.5,2.5Z" fill="#033bef" />
        <path
          d="M363.6,243.8c.1-.4.3-.4.5,0,0,0,.4.8.5,1-.3,0-.7,0-1,0l-1-1.2c0-.6.9.3,1,.2Z"
          fill="#0359f7"
        />
        <path d="M366.1,241.8c-1-.3-1.1-1.1-1-2,1,.3,1.1,1.1,1,2Z" fill="#0137e9" />
        <path d="M373.1,238.8c.1,0,.9-1.5,2-1,0,1.2-1.7.8-2,1Z" fill="#0133f1" />
        <path d="M368.1,236.3c1.2.4,1.5,1.8.3,1.5s-.6-1.1-.8-1.5h.5Z" fill="#0130e5" />
        <path
          d="M368.6,240.3c0,.3,0,.7,0,1-.4.9-.8,1-1,0-.1-.6,0-1,0-1,.3,0,.8,0,1,0Z"
          fill="#0863f5"
        />
        <path d="M368.6,241.3c0,.4-.6,2-.7,2-.6-.3-.2-1.4-.2-2h1Z" fill="#023df0" />
        <path d="M360.6,243.3l-1,.5c0-.3,0-.7,0-1,1-.6,1.1-.8,1,.5Z" fill="#0359f7" />
        <path d="M366.6,247.8s0,.4-.3.5c-1.7,0-.3-.9-.2-1l.5.5Z" fill="#045bf2" />
        <path d="M378.1,239.3c.1.8,0,1.2-.7,1s-.1-.7-.3-1h1Z" fill="#012be9" />
        <path d="M380.6,235.8c0,0-.1.9-.5,1.5.2-.3-.6-1.4-.5-1.5.3,0,.8,0,1,0Z" fill="#0231ec" />
        <path d="M363.6,243.8c.1-.1-.3-.8.3-1,1.4-.5.2.9.2,1h-.5Z" fill="#0130e5" />
        <path d="M373.6,241.8c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#0235ea" />
        <path
          d="M378.6,223.8c.9-.9,1.7-1.1,1.6.2,2.3-.2,3.1.2,2.4,1.3.4,1.2-.9,1.6,1.5,1.5-.8.4-1.3.8-2.5.5l.5,1.5c-.2,0-.3,0-.5,0-.4,0-.8,0-1,.5-1.2,1.7-1.9-1.4-.7-2.4-2.9-1.8-3.4-2.8-1.3-3.1Z"
          fill="#0659f5"
        />
        <path
          d="M380.6,220.8c.6.2,1.1.5,1.5,1,.3-.8.8-.9,1,0,.6.1,1.3.8,2,1-.9.4-1.2.8-2.5,1-1.4.5-3.6,1.2-2.1-1.1s-.3.5-.9.1c-.4-.1-.4-.3,0-.5-2.2-1.4.9-3.8,1-1.5Z"
          fill="#044ff7"
        />
        <path
          d="M379.6,222.8c.6-.4.4-2,1.5,0l-1,1c.8-.5,2.4,0,2.5,0,1.2.7,1.4.7,0,1.5-.8-2.6-1.6,0-1.7,0-1-.2-1.2-1.7-2.3-1.5-2.6.9-1.3-2.8,1-1Z"
          fill="#0237ed"
        />
        <path
          d="M391.6,232.8c.2,1.3-.9,1.8-2,1.1l-1.2.7c-2.6-3.3.5-5.7,3.3-7.3,2,2.4,3.9,3,5.9,2,.7-.6,1-.4.5.5.4.6.2,1.2-.5,1-.2.4-.5.4-1,0-.3.4-.3.5,0,1,.7.4,1,.4,1,0-.4,0-.4-.3,0-.5.5-.6.8-.3,1,1,.7-.6,1-.3.5.5,1.6.9,3.4.9,5,0,0-.3.2-.5.5-.5,0-.4.3-.4.5,0h.5c.1-.3.3-.3.5,0,0,.7-.7,1.6-1.5,1.5-.3.9,1.2.2,1,.7-.4,1.1-3,3.8,0,3.3,0,.1.1.5-.1.9-.4.6-2.5.6-.4,1.6l1-.3c-1.3,1.7-2.4.3-3.7-.2l.2,2c-.1,0-.3,0-.5,0-2-.8.8-2.5-1.5-2.5s-4.7,1.2-3.7-.5.7.4.7-1.5c-.3-.3-.7-.3-1,0-.8,2.5-2.3.4-3.5,2.2l-.5-1.2c0-.7.5-1.2,1.5-1.5-.5,0-.7,0-.5-.5.2-1.9,0-3-1-3.5.2,1.2-.6.9-1,0Z"
          fill="#022dea"
        />
        <path
          d="M394.1,236.8c.8.3,1.8-.6,1.5,1-2.1-1.2-2.4.3-3,.5s-.7,0-1,0c0-.3,0-.7,0-1,.1-1.1.9-1.2,2.5-.5Z"
          fill="#0548f2"
        />
        <path d="M396.6,237.3c.2-.5-.4-1.3.7-1s.2.6.3,1h-1Z" fill="#0748f1" />
        <path
          d="M392.6,232.8c.3-.2,1-1.8,2-1s-1.6.9-1,1.7c.2.3,2,1.2,2.3,1.2s.6-1.8,2.7-1c-.8,1.3-2.5-.6-2,2-1.1-.2-2.4-1.1-3,.5-1.6,1.2-1.9.6-.7-1.9-.1-.6-.2-1.1-.3-1.6Z"
          fill="#0342f2"
        />
        <path
          d="M403.6,232.8c.1-.3.3-.3.5,0-1.1,1.6-2.2.9-4,1,0,0,.9,2-.2,2s-.2-2.4-.7-3c1,.3,3.4.4,4.5,0Z"
          fill="#023bed"
        />
        <path
          d="M403.6,238.8c-.9.2-.3-.7-.6-.9s-1.4.7-1.9.4l1.5-1c.2-.9-.8-.3-1-.5-.6-.7,1.5-2.7,1.8-.5s-.2,1.6.2,2.4Z"
          fill="#011ee0"
        />
        <path
          d="M400.6,237.3c0,0,0,1.1,0,1.5-2.4-2-.5,0-2.5,0v-2c.6.6,2.4.4,2.5.5Z"
          fill="#0236ef"
        />
        <path
          d="M398.1,229.8c.5,0,1.2-1,2,.3l-1.5.2v2c-.2-.2-.4-.9-1-1-.4-.1-.4-.3,0-.5,0-.2.5-.6.5-1Z"
          fill="#023bed"
        />
        <rect fill="#064cf1" height="1" width="1.5" x="392.1" y="230.3" />
        <path
          d="M397.6,230.8c0,.2,0,.3,0,.5s0,.3,0,.5c0,.8-.5.5-1,0-.4-.3-.4-.7,0-1,.2-.2.6-.2.8-.5l.2.5Z"
          fill="#022deb"
        />
        <path d="M397.6,231.8c0,.3.9.9.2,1-.8.1-.9-.5-1.2-1,0,0,.7,0,1,0Z" fill="#023bed" />
        <path d="M396.6,231.8c0-.1-.7,0-.5-.7,0-.3.4-.2.5-.3,0,.3,0,.9,0,1Z" fill="#0342f2" />
        <path d="M404.6,232.3c-.1.2-.4.3-.5.5h-.5v-.5c.3,0,.7,0,1,0Z" fill="#0225e6" />
        <path d="M390.1,227.8c.5.5-.9,2-1.5,1.5s.7-2.3,1.5-1.5Z" fill="#022dea" />
        <path
          d="M392.6,221.3c.7,1,1.1,1.9,1.5,3-.1,1.1,1,1.4,2,1.5,0-.3,0-.7,0-1,1.5-.2,1.7,1.1,0,1,0,.3,0,.7,0,1l-2-.5c0,2.6.8,4.2,3.5,3-.1,0-.6,1-1.7,1s-3.2-.5-3.5-.5c-1-.3.2-2-1-1.4s0,1.8-.3,2-1.9-.5-2.5,0c1.1,1.5-.4.5-.5,1.5l2-1c.8,3.5-2,.7-2,3,1.3,0,2.3-.6,3.5-1,1.4.7,1.7,1.4.6,3.3.9.5.2.9-.6,1.2,1.1,0,1.1.7,0,1,0,0-.1.4-.3.4s-.2-.3-.2-.4l-.5-.5c-.5-.9,0-.3,0-1-1.2-1.4-1.6-1.4-1.4.2l-1.1,1.3c-1.7-3.1-2.6,1-3.5,0s1.2-1.1.5-2c-3.1.7-2-3,1-2l.3-.6c-.9-.3-2-1.9-1.3-2.9-.1-.1-.4-.8-.5-1,0-.4.2-.6.5-.5-.2-1,.4-.7,1,0l.5.5c.2-.5-.4-1-2-1.5,0,0-2.1.4-2.5.5-3.2-1.1-.3-2.7,2-2q.6-.3,0,0c-1.8.8-3.7-.4-1.5-1.5,0-.5,0-1,0-1.5,0-1.2.9-1.5,2.5-1,.2-.4.3-.4.5,0,.6,2.3.8,2.7.5,1,.5-.7.9-1,1,0,1.1-1,1.4-.3,1,2l.5-.5c.3-.6.9-1.1,1.8-1.4.5-1.2,1-2.1,1.7-2.6.2-.4.3-.4.5,0Z"
          fill="#0342f2"
        />
        <path
          d="M390.6,236.8l-2,1.5c.4.1.4.3,0,.5,0,0,0,.6-.5.5,0-.3,0-.8,0-1,.5-2.2-.7-2.8,1.8-4,1.1,1.1.8,1.5.7,2.5Z"
          fill="#022dea"
        />
        <path d="M391.1,238.3l-.5-.5c0,0,.4.5.5.5Z" fill="#0548f2" />
        <path
          d="M392.6,232.8c1.5,1,.5,2.2,0,3.5.3,0,.8,0,1,0s.3.5.5.5l-2.5.5c-.3-1.7,2-3.2,0-3.8v-.7c.2,0,.2.6,1,0Z"
          fill="#0236ef"
        />
        <path
          d="M384.6,228.3c.1-.1-.3-1,.2-1,.9,2.2,2,1.6,2.5-.5,1.8.7.6,3.2-.7,3l-.5-.5c-.2,0-.7,0-1,0-.2.3-.4.1-.5-.5v-.5Z"
          fill="#0228e6"
        />
        <path d="M385.1,229.3c0,0-.3.4-.5.5,0-.3,0-.7,0-1l.5.5Z" fill="#0238ef" />
        <path
          d="M392.1,221.3c-.4,2.9-.6,4-3.5,4-.8-.8-.7-1.6.5-2.5,1.3,0,2.4-.5,1.5-2,.7-.2,1,.3,1.5.5Z"
          fill="#0234ee"
        />
        <path
          d="M385.6,222.8c.1,0,0-.8,1-.5.2.5-.5,1.2-.5,1.5,0,.5,1.7.2.5,1.2s-1.4,1-2,0l1-2.3Z"
          fill="#044ff7"
        />
        <path
          d="M389.1,222.8c1.1,1.4-.3.7-.5,1.3s0,.9,0,1.2l-.5.5c-.9,0,.4-1.7-1-2,.8-.3.9-1.4,1-1.5.3,0,.7.5,1,.5Z"
          fill="#044ff7"
        />
        <path d="M384.1,226.8c.1,0,0-.8,1-.5v.5c-.3,0-.7,0-1,0Z" fill="#1463f1" />
        <path d="M388.1,225.8c0-.3.3-.5.5-.5,0,.3,0,.5-.5.5Z" fill="#0f7af8" />
        <path d="M386.6,229.8c-.3,0-.4-.2-.5-.5.3,0,.4.2.5.5Z" fill="#0238ef" />
        <path
          d="M375.1,246.3c0,0,.9,1.3,1,1.5s-.1.9,0,1c.9.7,2.2-1.5,3-.7-.1,1.5-1.8,1.7-3,1.7s-.8,0-1,0c-.2-.4-.3-.4-.5,0v.5c-.6.1-1.7,0-2-.5-2.1,1.8-2.7,1.8-2,0,.2-2.1,2.1-5.8,4.5-3.5Z"
          fill="#0348f2"
        />
        <path d="M376.6,243.8c.9.2,1.8-.6,1.5,1-1,.2-1.1-.4-1.5-1Z" fill="#0452f5" />
        <path d="M377.1,253.8h.5v.5c.4.1.4.3,0,.5-3.5-.2-4.2-1.7-.5-1Z" fill="#054cf1" />
        <path d="M379.1,253.8c-.5.8.6,1.1-1.5,1v-.5c0-.4.2-.6.5-.5.3,0,.7,0,1,0Z" fill="#0225e8" />
        <path d="M378.1,253.8c-.1,0-.3.4-.5.5,0-.2,0-.3,0-.5.6-2.2,1.6-1.9.5,0Z" fill="#0339f0" />
        <path
          d="M405.6,225.3l.5.5c.5.1.5.3,0,.5,0,.3-.3.4-.5.5,0,.5-.3.4-.5,0-.2.2-.4,0-.5-.5-.7,0-.6-.7,0-1,.1-.3.3-.3.5,0,.1-.4.3-.4.5,0Z"
          fill="#0225e6"
        />
        <path
          d="M403.6,226.3c.3-1,.7-.9,1,0,.3.3.2.6,0,1-.2.5-.9.8-2,1,1.5.5,2.4,1.1,2.5,2,.6-.6,1.4,0,2,.5.2.2.9.5,1.1,1.1s-.3,1.6,0,1.8,1.1-.3.9.6c-.8.7-2.9,0-3,0-1,1,1.9.9,1,2s-.6-.2-1.5,1.5c.4,0,.9-.7,1.5-.5-.4,1.7.8,2.3,1.5,3.5-1,0-.5,1.5-.7,1.5-.6,0-.8-.9-1.8,0-1.9,1.9,1.1,1.4,2,2.5-4.7,1.1-2.9-1.2-3.6-1.9s-.9,0-1.2-.2-.2-.7-.7-.8c-1.2-.8-1-3.2.9-2.7.6-.6,1.3-1.1,2.1-1.3-3.7,3-2.2-5,.5-5.5-.2-.2-.3-.2-.5,0-.1.4-.3.4-.5,0-.9-.5-1.1-.5-2,0-1.3.8-3.1-.5-2-2v-.5l.5-.5c-.7-.5-1-1.7,0-2,.2-.8.5-1.2,1-1,.5-.3.9-.3,1,0Z"
          fill="#0225e6"
        />
        <path
          d="M409.1,243.3c-.2.7-.1,1.2-1,1.5-2.4.4-4.7-2.5-2-2.5.4,1.3,1.9,1,3,1Z"
          fill="#0536e8"
        />
        <path
          d="M405.6,226.8v1c2.3-1,1.2,0,1.5.5h-.5l-.5.5c0,.1,0,.3,0,.5l.5.5c.1,0,.4,0,.5,0,0,.3,0,.8,0,1-1.8.9-1.3,0-2-.5-.2-1-.7-1.4-1.4-1.3v-.7c-.2.3-.4.3-.6,0-.1.4-.3.4-.5,0,0-.2-.2-.8,0-.9.3-.3,1.4,0,2,0,0-.4.2-.6.5-.5.2,0,.3,0,.5,0Z"
          fill="#0338ef"
        />
        <path
          d="M403.6,228.3c1.1.3,2.4.7,1.5,2-.3-.2-1.4-1.1-1.5-1l-.3,1c-.3-.3-.8-.6-1-1-.2-.5.1-.7.2-1h.5c.2.2.4.2.5,0Z"
          fill="#011ae0"
        />
        <path
          d="M401.6,227.3c0,.6.6,1,0,2l-.5.5v.5c-.6-1-1.1-1.7-1-3-.1-.8.9-.7,1.5-.5.4.1.3.3,0,.5Z"
          fill="#0542ee"
        />
        <path
          d="M405.1,232.3c-.2,0-.3,0-.5,0-.4.2-.7.4-1,0-.2,0-.4,0-.5,0,.5-1.3,1.4-1.4,2,0Z"
          fill="#011ae0"
        />
        <path d="M407.6,233.3s-1.1.2-1-.2c.8-1.4,1.6-.3,1,.2Z" fill="#022de9" />
        <path d="M401.1,229.8l.5-.5c-.1.2-.3.4-.5.5Z" fill="#022deb" />
        <path d="M406.1,232.3h-.5l.2-.5c.3,0,.2.3.3.5Z" fill="#011ae0" />
        <path d="M403.1,228.3c.2,0,.3,0,.5,0l-.2.5-.2-.5Z" fill="#0225e6" />
        <path d="M403.6,226.3h-1c.4-.4.9-.6,1.3-1l-.3,1Z" fill="#043cf1" />
        <path
          d="M404.6,206.3c1.3-.5,2.6,0,3.5,1,.1-.8.5-.3,1,.5v.5c0,.2,0,.3,0,.5-.5.5-1.5.5-3,0,0,.1.1.5-.2.9s-1.1-.2-.8.6c2.4,1,3.6.8,6,0,.3,1.8-1.4.6-2.5,1.3s.1.8-1.5,1.2c-1,.7-1.9,1.1-3,.5h-.5c-.9.2-1.8.2-2.5,0-.5.2-1,.5-1.5,1l-.5.7c.5.7.9,1.1.2,1.9s-3.7,0-2.2-1.1c-1.4-.3-3-.4-4.6-.4.2-1.7,0-2.7-.9-3.1-.8,1.3-3.5-.6-2.5-1.5.3-1.3,2-.7,2.6,0s-.8.3,0-.5c-.4-.7-.2-.9.5-.5.9-1,1.9-.2,2,1l.5-.5c.1-.4.3-.4.5,0,1.1-.3,2.5,0,3.9,1,.4-1.5,1.8-1.5,1.6,0,.6.4,1.3.2,2-.5-.4-.4-.3-.8,0-1-.1-1,.4-2.8,1.5-3-.4-.5-.1-.7.5-.5Z"
          fill="#0230ee"
        />
        <path
          d="M400.6,214.3c.7-1,1.3-.9,1,.5,1.1.1,2,.8.9,1.8l1.1,1.2c.1-.4.6-.4,1.4-.2.4-1,1.8-3.1,2.1-.3,1.3.2,1.3.6,0,1l.2,1.1c3.3.2,1.9,4.2-1.1,2.6.1.5-.2,1-1,1.3.4.1.4.3,0,.5,0,.2-.4.4-1,.5.4.2.4.3,0,.5-.9.8-2,.7-2.5-.5-1,1.4-2.9.3-2.5-1.5-1.3-.1-1.3-.4,0-1,0-.6,1.3,0,1.6.3s-5.1-1.2-3.6-2.3c.2-.4.3-.4.5,0,.5-.8.6-1.7.5-2.5,1.2-.1,1.6-1,1-2.8l.5-.2c.4-.9.9-1,1,0Z"
          fill="#0230ee"
        />
        <path
          d="M407.1,212.8v.5c-1,0-2.1,1.3-2.5,1.5-2,2.4-3.6,0-.5-1.5.3-.5,0-.9,0-1,.6-.3,1.2,1,3,.5Z"
          fill="#0223e6"
        />
        <path
          d="M409.1,208.8c-.1.5-.5.9-.5,1.5-1.4.3-.9-1.4-2.5-1.5.5-.9,2.1-.2,3,0Z"
          fill="#053df0"
        />
        <path
          d="M411.1,205.3v.5l-.5.5c-.3.9,0,1.3-1.5,1.5s-2.8.4-2.5-1c-.6,0-.7,1.1-1.7,1.5-.2-.7.6-1.4-.2-2-.4-.1-.4-.3,0-.5.9-.2,1.2-1.3,1.7.5l1.2-1,.5,1.5c-.1-1.2-.1-1.9,1.3-1.5s.7,2.6.7-.5c.7-.2.9.5,1,.5Z"
          fill="#0221e4"
        />
        <path
          d="M395.6,208.3c.5-.2,1-.2,1.5-.5l.3,1.5c2.3.2,2.3-3,3.7,2-.1.5-.3.4-.5,0,0,0,0-.6-.5-.5l-.3,2c-1.5-.9-3.2-1.1-4.7-2.5s.9-.8-1-1v-.5c.6.1,1.1-.4,1.5-.5Z"
          fill="#033cf2"
        />
        <path
          d="M402.6,210.8c-.7,1.3-2.2,2.5-2,.5.1,0,.3,0,.5,0,.3,0,.7-.4,1-.5h.5Z"
          fill="#011add"
        />
        <path
          d="M404.1,206.8c-.6,1-.7,2.1-1.5,3,0,0-.5-.2-.5-.7,0-1,1.1-3.9,2-2.3Z"
          fill="#0222e5"
        />
        <path
          d="M403.6,213.3l-2,1.5s-.9-.5-1-.5c-.8-.3-.2-1.2.5-1,.9-.3,1.3-1.7,2.5,0Z"
          fill="#0223e6"
        />
        <path d="M407.1,212.3l-3.5-.7c.8-1.3,3-.3,3.5.7Z" fill="#0223e6" />
        <path d="M398.1,217.3c-.5-.2-1.2.4-1-.5.4-.2.9.5,1,.5Z" fill="#1f58ee" />
        <path d="M381.1,217.3c-.4-.2-1.8-.3-2-.5-.6-1,.3-2.6,1.5-.5s.3.7.5,1Z" fill="#0237e7" />
        <path d="M386.6,213.8c2,.2,2.2,2.4,0,1,0-.3,0-.7,0-1Z" fill="#0327ed" />
        <path
          d="M254.2,402.7c.1.2-.1.9,0,1l1,.5c.7-.6,1-.4.5.5l.5,1c.9-.5,1.1,1.2,0,1-.1.2-.4.3-.5.5,0,0-.3,0-.5-.5-.6-1.6-.6-.9-1.5-2s-1-1.3-1-1.5l.5-.5c.2,0,.7,0,1,0Z"
          fill="#023597"
        />
        <path
          d="M251.2,391.2l1.3.4c1.2.9,2.2,1.6,3.2,2.1.1-.4.6-.5,1.5-.5q1.2-.2,0,0c-.4.6-1.4.2-1.5-.5-.5-.4-.3-.8-.3-.8-.3,2.2-1.8,1.6-1.7.3-1-1.7-.5-2.6,1.5-2.5-1-2.1,2.4-1.9,2.1.8,3-2.1,4.7-1.4,5.4,1.7.3-.8.8-.9,1,0l1.5-.5c.5-.3.7,0,.5.5.3.2.3.3,0,.5v.5c-.1.4-.3.4-.5,0-1.5-.9-3.1,2-.6,2,1.3-.7,2.7-.7,2.1,1,.7.3,1.2.5.5,1-1.4,1.2-.8-.5-1.3-.5s-.6.5-.7.5l-2.3.5c-1,1.4-2.6,2.5-3.3.5-1,0-2,.5-2.9,1.5.9,2,.6,2.5-1.5,3,.6-.3.6,0,0,1,0,.3-.4.3-1,0-1-.2-1-.8,0-1-1.2.2-1.6-.1-1-1,1-.9.3-2.2-2-4l.5-.5h-.5c.4-1.1-.1-1.7-1-2.3.6-.6.6-1.3,0-2.2-.9,2.2-1.8,2-2.5-.5-1.2.7-1.6,0-.5-1,0-.4.2-.9.5-1.5-.5-1.1.3-2.3,2.5-3.5-.7-.7-.4-1,.5-.5.8.4.6,3.1-.2,4.4.6.4.8.7.7,1.1Z"
          fill="#0244b5"
        />
        <path
          d="M256.7,399.7c.5-1.1.7-2.3,1-3.5.8-.2.3.7.6.8.6.3,1.3,0,1.9.4s.2,1.6,1.2,1.2c.9-2.2,1.8-1.4,3.8-1.5-.1.5-.6.4-1,.5,0,1.1-.5,1.6-1.5,1.5-.9,1.2-2,1.9-3.2,2.2.3.6-.1.8-.8.8-1.3-.8-1-1.5-1-3l-1,.5Z"
          fill="#023aac"
        />
        <path d="M265.7,392.7c0-.2,0-.4,0-.5h.5c0,.3-.2.6-.5.5Z" fill="#0247ba" />
        <path
          d="M265.2,393.2c-3.6-.5.7,2.7,2,.5.3.2.4,0,.5.5s-.5,1,0,1.4,1,0,1.4,0l-1,1c-1-.6-1.3-.4-1.5-.5-.5-.2-.9-.6-1.3-1-.6.3.6.9,0,1-3.6.5-4.5-3.3-1-3.5s.7.5.7.5Z"
          fill="#023bad"
        />
        <path
          d="M250.2,392.7c.9-.1,1.5.7,2,1.3-3.1,2.6.4,1.1.5,1.2.9.9-1.6,1-1,2-.1,0-.7,0-1,0,1.1-2.4-1.3-1.8-1.5-2s1.2-1.9,1-2.5Z"
          fill="#023fad"
        />
        <path
          d="M250.2,386.2c0,0,.1.6-.1.9-1.4,1.5-1.7,0-2.4,2.6-.1.4-.3.4-.5,0-.5.8-.8,1-1,0-.4-.2-.4-.3,0-.5-.1-.5,0-.6.5-.5-.9-1-.7-1.3.5-1,0,0,.7,0,1-.3.9-.8.9-2.3,2-1.2Z"
          fill="#0237ae"
        />
        <path d="M260.7,392.7c.7,1.7.9,3.8-1.5,4l1.5-1.7-1.5-.3,1.5-2Z" fill="#022e9a" />
        <path
          d="M253.7,392.2c.2.1,0,.8,1,.5l.2-1.5,1.3.5c.2.1-.4.7-.5,1,.5.3.5.7,0,1,0,0-.3.5-.7.4s-.8-.8-1.3-1.1-.9.2-.9,0c-.7-1,.4-.5-1.6-1.9.3,0,.7,0,1,0,.1-.4.3-.5.5-.5,0,.6.4,1.1,1,1.5Z"
          fill="#0247ba"
        />
        <path d="M257.2,393.2c.6-1,1.7-1.9,3-1.5l-2.2,2.5c-.3.1-.4-.7-.7-1Z" fill="#0247ba" />
        <path
          d="M257.2,393.2c-.1.2.1.9,0,1s-1.1-.5-1.5-.5c-.7-.8,0-.8,0-1,.5.1,1.1.2,1.5.5Z"
          fill="#0231a2"
        />
        <path d="M265.2,391.7c-.2.6-.9.5-1.5.5.2-.6,1-.6,1.5-.5Z" fill="#0247ba" />
        <path d="M255.2,403.7c.4.1.4.3,0,.5,0,0-.5,0-1-.5.3,0,.8,0,1,0Z" fill="#023ca2" />
        <path
          d="M255.2,403.7c.2,0,.3-.7.6-.8s.9.5,1.9-1.2c.7,1.8-1,2.1-1,2.3,0,.5,2,4.1-.5,2.7.5-.9.1-.7,0-1l-.5-1c-.2-.2-.4-.3-.5-.5v-.5Z"
          fill="#0345ab"
        />
        <path
          d="M229.7,364.2c.4,1.2,1.1-.6,0,2.5,1.3.2,2.5,1.2,2,3,0,0,0,.4.2.5.4-.2.5-.6.8-1,.4-.6.6-.4.5.5-1,2.9,0,1.7,1,2.5,2.7-1-.8,3.3-.7,3,.1-.5.7-.9,1.2-1,2.2,1.6-.5,2.7-.5,4.5s0,.4,0,.5c-1.7,1.3-2.4,1.8-4,0-.3-.6-.7-.9-1-1-.9-1.2-2.4-2.1-4.5-2.5-.2.8-.6.8-1,0-.7-.8-.5-1.2.8-1.2l.3-1.1c-1.2-2.1,2.6-4.2,2.5-2.1.9.4,1.4.2,1.5-.5-.6-.6-2.8-.4-3.3.8-1-.2-1.8-.6-1.7-1.8-1.3-.3-1.2-1,0-1.5,1-.4,1.6-1.5,1.8-3.3l.7-.2c.2-.9.5-.9,1,0,.4-.7,2.1-1.4,2.5-.5Z"
          fill="#034cca"
        />
        <path
          d="M243.2,375.2c-.5.4-.5,1.9-.5,2,.4.2.4.3,0,.5-.2.3-1.3.7-1.5,1.2,0,.5,2,.8,2.5.7l-1,1.5c-.1,0-2.3,0-2.4-.1-1.4-.5-1.4-4.2-1.6-4.4,1.8.3-.3-.8,1.5-1.5,1-.3,2-.5,3-.5v.5Z"
          fill="#0250c9"
        />
        <path
          d="M221.7,376.2c1-1.4,1.7-.9,2,1.5.9,1.1.9,1.1,1.5,2.5-.2.4-.6.4-1,.5-.5.1-.6,0-.5-.5-.1-.6-.3-.8-.5-.5-.2.4-.3.4-.5,0-.4.2-1,1.7-1,2-.3,0-.7,0-1,0-1.1,0-1-.7,0-1,1.1-1.2,1.1-2.1.2-2.9l.8-1.1c-.2-.1-.2-.3,0-.5Z"
          fill="#023aad"
        />
        <path
          d="M234.2,378.7l1.2-1.6c.6-3,2.3-3.3,3.3-.4.9.3,1.6,1.4,1.9,3.4,1.2,0,1.9.3,2.1,1.1v.5c-.6,1-1.4,1.1-2.5.5,0,.4-.1.9.2,1.1,2,1.9,1.1,4.3-1.5,2.3-.4,1.9-2.1,2.9-3,.8-1.6.6-3.2,0-4.7-1.6-.5.5-1.3.9-1.9.8-.7.7-1,.4-.5-.5-.6-.3-1.2-.7-2-1-.8-.6-1.2-1.2-1-2-1.9,1.3-2-.6-.5-2-.6.3-.9-.2-.9-1.4-.9-.4-1.1-.8-.6-1.1l.5-1c.6-.7,1.4.2,1,1l.5-.5c-1-.2-1-.8,0-1,2.2-.5,3.2.5,3.2,3.1,1,.1,2.7.7,3.8,1.8.6-.6,1.1-1.3,1.5-2-.5-.2-.5-.3,0-.5Z"
          fill="#0248be"
        />
        <path
          d="M224.7,375.7c.4,0,1.7-.1,1.8-.2.5-.2.9-2.2,1.7-1.3s-.7,1.5-.5,2l1.5-.5c-.5,1-.3,1.5,0,2.5.5,0,.8.3,1,1,.5,0,1.1-.5,1.3-.5s.2,1.6,2.7.5c.7.7.5,1.1-.6,1l-.9,1c-2.3.5-1.3,0-3-1.2s-.8.2-.9,0c-.6-.5-.5-2.8-.6-2.9-.9-1.1-.9,1.3-1.5,1,0-.9-.4-1.4-1-2-.2,1.1-1.4.4-1-.5Z"
          fill="#023eb8"
        />
        <path
          d="M224.7,375.7c.2.4.9.4,1,.5,0,.3,0,.7,0,1l-.5.5-1-1c-.1.4-.3.4-.5,0-.9,0-1-.9,0-1,.3,0,.7,0,1,0Z"
          fill="#023aad"
        />
        <path
          d="M234.2,379.2c0,.1.7.5.8,1,.1,1.2-.4,2.4.2,3.5-2.6-.7-1.1-1.1-.7-3-1-1.3-.6.5-1.5.8s-.3-.3-.3-.3c-.4-1.2,1.2-1,1.5-2Z"
          fill="#0356c8"
        />
        <path d="M236.7,379.7c0,0,1-.2,1,.2,0,1.6-1.8,1.2-2,.3.2-.6.6-1,1-.5Z" fill="#0235ae" />
        <path d="M229.7,380.7c.3.3-.4,1.5-.7,1.5-1.4,0,0-2.2.7-1.5Z" fill="#023eb8" />
        <path d="M236.7,379.7l-1,.5c-.2-.7.2-1,.8-1.5.5,0,.1.9.2,1Z" fill="#065fc7" />
        <path d="M223.7,377.7c-.3-.5-.3-.8,0-1h.5v.7c-.1.2-.4.4-.5.3Z" fill="#086bcb" />
        <path d="M225.2,377.7l.5-.5c0,.3,0,.6-.5.5Z" fill="#023eb8" />
        <path d="M245.7,382.2c1.4-.2,1.4.7,0,.5,0-.2,0-.3,0-.5Z" fill="#0a67c0" />
        <path d="M244.7,374.2c-.2-.2-1.5,0-1.5-1,1.2,0,2.3-.5,2,1h-.5Z" fill="#0249cc" />
        <path d="M242.7,377.2c1.3-.2,1,.3,1,1.5l-1-1c0-.1,0-.4,0-.5Z" fill="#0462d0" />
        <path d="M254.2,381.7c.5,0,1,0,1.5,0l-.5,1h-1c0-.2,0-.3,0-.5v-.5Z" fill="#0350c7" />
        <path
          d="M251.7,387.7c-.2-.2-.6-.9-.5-1,.6,0,2.7-.8,3-.5s.2,1.5-.5,1.5l-.5-.5c-.4,0-.5,0-.5.5-.1.5-.6.3-1,0Z"
          fill="#0238a7"
        />
        <path
          d="M252.7,389.2c0,.5,0,1,0,1.5,0,.4-.2.4-.5.5.3-1.3-.4-1.1-1.5-1l1.5-1.5c.3,0,.4.5.5.5Z"
          fill="#0244b5"
        />
        <path d="M252.7,387.7v.5c-.2,0-.4,0-.5,0-.3-.1-.3-.3-.5-.5h1Z" fill="#0244b5" />
        <path d="M253.7,387.7c-.4,0-.5-.1-.5-.5.4,0,.5.1.5.5Z" fill="#0244b5" />
        <path
          d="M257.2,385.2c0,.3,0,.7,0,1,2.3-.3,3.8-1.2,5.5,1v1.5c1.1,1.7,3,1.1,3.5,1.5s-.5.8-.5,1c-1.3-.1-2.3.2-3,1-2.1-.4-1.3-1.8-1.8-2-1.1-.4-.5.9-1,1-1.2.2-.4-.5-1-1-3.1,4.9-2.5-.8-2.8-1-.4-.3-.9.5-1,.5-1.6,1.1-2.4.9-2.5-.5-.7.5-1,.2-.5-.5v-.5c.1-.3.3-.3.5,0,.3,0,.8,0,1,0,.2.2.4.2.5,0,.6-.2,1.7-1.7,2-1.5s-.3,1.5,1.5,1c0-.9-1.3-.8-1.5-1s-.6-1.8-.5-2,1,.6,1.5.5Z"
          fill="#0247ba"
        />
        <path d="M263.2,388.2c-.1.2-.3.3-.5.5-.3-.5-1.1-1,0-1.5.2.3.3.7.5,1Z" fill="#0232a2" />
        <path
          d="M265.7,391.2c0,0,.5.5.5,1-.1.3-.3.3-.5,0-.2-.3,0-.4-.5-.5l-1.5.5c-.3,0-.7,0-1,0,0-2,1.6-1.5,3-1Z"
          fill="#023bad"
        />
        <path d="M253.7,388.2c.2,0,.4,0,.5,0l-.2.5-.3-.5Z" fill="#0244b5" />
        <path d="M260.2,388.2l1-.5v1.5c-2.5-.2-2.2-.9-1.5-3l.5,2Z" fill="#0239b1" />
        <path
          d="M248.2,321.2c.3-1.4,4.2-.9,4.2,1.2,2.8.7,3.7,1.6.9,3.4l-1.1,1.4c0,.8.2.6.5,1l1,.5c.7.6-.6,1.5-.7,1.5-.2,0-1.1-1.2-1.5-1.5-.6,0,.2,1.9.3,2,1.2.9,4.1-3.5,2.5,3.5-.6-.3-1.1-.7-1.5-1.3.8-.1,1.5-1.2,1-1.7s-4,3.9-.5,3.7c-.8.7-1.4,1.1-1.5,2.3l-2.5-.5-.5,1.5c.8-1-1-1.6-1-1.7.1-.4.8-.5,1-.7.8-.8,2.2-3.4.5-2-.3.9-3,.8-4,1.5,1.4-2.3-2-1.2-.5-3.5-1.5-.2-.8.3-1,1-1.4.7-2.9,1.5-4.1.4-1.7-1.7,2.6-2.8,3.1-2.4-2.5-1.9,1.3-3.5,3-2-.2-.9,0-1,.5-.5.2-.4.3-.4.5,0,.4,0,.4.3,0,.5.2.3.5.3,1,0l-1-.5c-.3-.4-.6-1.3,0-1.5,0-.4.3-.4.5,0,.1-.4.3-.4.5,0,0-.8.8-.8,1,0-.4-2.3.2-3.2,1.6-2.7v-.8c-1.2-.6-1.8-1.2-2.1-2Z"
          fill="#0461f0"
        />
        <path
          d="M249.2,333.7s-.4-.2-.4-.4l.9-.3-1.5-1.2c.9-.3,2.6-1,3,.2s-1,0-1,.5c0,.9,1.2,1.4,1,1.7s-1,0-1,.3c0,.7,1.2,2.1,1,2.2-1.8,1.4-1-2.6-2.5-1,0,0,0-.5.1-.8.5-.6,3-2.2.4-1.2Z"
          fill="#024be6"
        />
        <path d="M253.7,328.7c-.5,0-.7-.1-1-.5.6,0,.7.2,1,.5Z" fill="#0351f4" />
        <path
          d="M247.7,328.7l-1,2,1.5.7c-.7,1.4-4,1.3-2.9-.2s.7,0,.7-.1.6-2,.7-2.4h1Z"
          fill="#034be4"
        />
        <path d="M250.7,329.2v1.5s-2,0-2,0c-.4-1.2.9-1.4,2-1.5Z" fill="#024fe9" />
        <path d="M251.2,326.2c.3.4-.1,2-1,2-.8-1.1.3-2.7,1-2Z" fill="#024bec" />
        <path
          d="M233.7,332.7c-.9.1-1.6-.6-2.5-.5,0,.6,2.3,1.9,2.4,2.1,0,.3-.3,1-.4,1.4l-2.5.5.2,1,1.3-.5v3s-2-.5-2-.5l1.5-1.5c-.9.1-2.2.2-3,.5.1-.8-.2-.8-.8-.1l-.7-.4c-1.4-.4-.5-1.9.5-2.5-.7-.8-.4-1.1.5-.5.2-1.4,1.4-1.3,3.5.5l1-.5c-4.8,1.4-5.3-6-1-4,.1-.5.3-.5.5,0,.9,0,1.7,1.2,1.5,2Z"
          fill="#0252e8"
        />
        <path
          d="M234.7,344.7c.5-1.6-1.7-.7-1.5-1.2.5-1.2,2,0,2.5-.3l.2-1c0,.5.3,2.4.2,2.5-.2.2-.8,0-.9,0h-.5Z"
          fill="#0361eb"
        />
        <path
          d="M226.7,334.2c1.1-.3.8,1.2.3,1.2s0-1.3.7-.2c-.2.5-.4,1.9-.5,2.5,1-.5,1.7-1.9,2.5,0l-1,.5c-.2,0-.3.4-.5.5-.2,0-.7,0-1,0-1.4-.2-1.2-.5,0-1-1.5,2.9-3.6,0-1.6-2l-.4-1c-.4-.1-.4-.3,0-.5.4-1.1,1.1-1.1,1.5,0Z"
          fill="#0347e1"
        />
        <path
          d="M229.7,341.2c1-.4-.3-1.3,0-1.5.9-.8,1.5,1.8,1.4,1.9-.2.2-.8,0-.9,0-.4.2-.6,0-.5-.5Z"
          fill="#0337d7"
        />
        <path
          d="M230.2,355.7c.9.2,1.4.9,1.5,2-.3.5-.7,1-1,1.5-.1.4-.3.4-.5,0-.2-1-.8-1.9-.5-3-.2,0-.3,0-.5,0,0,.7,0,1.7-.8,2-1.6.6-1.2-.9-1.2-1,.2.1,1.1-1,2-1,0-.4-1-.7.3-1.5.4.1.6.9.7,1Z"
          fill="#0241c8"
        />
        <path
          d="M232.2,356.7c-.4.2-.4.7-.5,1-.3,0-.7,0-1,0,.3-1.3.8-1.3-.5-2,1.7.6.9.4,2,1Z"
          fill="#035ade"
        />
        <path
          d="M220.2,354.7c.8-1.1,2-1,2,.5.5-1.5,1.6.5,2,1.5.1.2.3.3.5.5s-.7.5,0,.8c1,.4,1.6-.7,2.5,1.5-.7-.2-1.2.2-1.5.2-.2,1-.6,1-1.2.1-.7,1-1.7,1.5-2.8.9-3.7,1.3-2-.9-.5-2.5-.8-.4-1.1-1.7-1-2.5-.4.8-1,.3-1-.5-.5-.7-.2-.8,1-.5Z"
          fill="#0244c4"
        />
        <path
          d="M228.7,359.7c.7.1.8.4.5,1,0,.2,0,.3,0,.5.3.2.1.4-.5.5-.1,0-.2,1-.4,1.3l.4.2c-.1.6-.6,1.1-1.5,1.5-.3,0-.7,0-1,0-.1.2-.3.4-.4.5s-2.5.9-2.6.5c.3.1.3.3,0,.5-.3.4-.3.8,0,1,.1-.4.3-.4.5,0,1,.1.9.5,0,1-.9,1.2-3.8.8-5,.5-1.3-.2-1.3-.6,0-1v-.5c-1-.6-.6-1.4.5-1,5,1.2.8.9.7.7-.4-.8.6-3.8,1.3-4.7-.3,0-.5-.2-.5-.5-.3-.2-.3-.3,0-.5.7,0,1.4.2,2,.5,1.3-.6,1.5-.3,1,1,.8-.8,1.5-1.2,2-1l1.2.5v1.5c1.8-1.1-.6-3.4,1.3-4.2s.2,0,.5.2Z"
          fill="#024bca"
        />
        <path
          d="M241.7,366.2c.1-1,.8-1.1,2-.3,3.5-1.6,6.7,2.6,1.3,2.1l-.3.7c-.6,1.1-2.4,1.1-3.5.5-.7-.6,0-.7,0-1-.8-.4-.9-.7-.5-1,.5-.1.9-.5,1-1Z"
          fill="#0358d9"
        />
        <path
          d="M234.2,372.2l4.2-1.5-.7,1.5c.2.2,2.2-.3,2.6-.5s0-1.2.9-1c.4,2.3-1.9,2.5-3.5,2l.5,2c-2-.7-2.4-3.8-3.5-.5s0,.7,0,1l-1,1c-1.8-.7-.6-2.7,1-3.1,0,0-.3-.8-.5-.9Z"
          fill="#0242c7"
        />
        <path
          d="M225.7,359.7c.1.2.4.3.5.5.3.3.4.7,0,1-.1.2-.3.4-.5.5-.6.5-1.1,1.1-2,1-.2-.8-.8-1.2-1.5-1.5-.4.2-.6,0-.5-.5,2.7,0,2.1-1.2,2.7-1.4s1,.4,1.3.4Z"
          fill="#0235b9"
        />
        <path
          d="M240.2,375.2c-.2-.7-.7-1.2-.5-2l2.3-.5c1.1,1.7-1.7.3-1.3,1.7s1.9-1.2,2.5.3c-2.2.2-1.2,2.2-1.5,2.5-.9,1-.6.2-.9-.5s-.5-1.1-.6-1.5Z"
          fill="#0342c5"
        />
        <path
          d="M237.7,366.2c.3.8,0,1.9.1,2.2.4.9,1.5.5,1.4,1.3-1.6.3-1.1-.7-2.5-1-.1.6,0,1.4,0,2l-2.5-.8,1.5-.5-1-.7c.9-.4,1.2-.2,2,0,.2-.8.3-2,1-2.5Z"
          fill="#0244cd"
        />
        <path
          d="M231.2,365.7c.6-.4,1-1.2,2-1,.5,1.8-3,1-1.9,2.4s1.9.1.4,2.5c-.7-.8.4-2-2.3-2.5-.5-.4.3-.4.3-.5h.5l1-1Z"
          fill="#0242ca"
        />
        <path
          d="M228.7,363.2c.3-.3.7-1.8,1.5-1s-.6,1.6-.5,2c-.6.2-1.9.5-2.5.5-.3-1.2.7-.9,1.5-1.5Z"
          fill="#0241c1"
        />
        <path
          d="M241.7,365.2c1,.3,1,.7,0,1-1-.3-1.6-.8-2.5-1-.1-.2.7-1.2,1-1.5l1.5,1.5Z"
          fill="#023ec6"
        />
        <path
          d="M244.7,368.7c0,.2,0,.7,0,1-1.3.4-2.4.6-3.5-.5,1.2.2,2.4-.4,3.5-.5Z"
          fill="#023dcb"
        />
        <path d="M240.7,367.2c.1.3.5.7.5,1l-2-.5c.5-1.6,1.4-.5,1.5-.5Z" fill="#023dca" />
        <path
          d="M233.7,368.2c.1-.2-1.2-4.1,2.5-.7-1.7,0-3.6-2.2-1.5.7-.3,0-.9,0-1,0s-.3,1.1-.5,1.5l-.5-.5c.8-1.2,1-.9,1-1Z"
          fill="#0242ca"
        />
        <path d="M231.7,359.7c0,.2-.3.4-.5.5l-1,.5c0-.5,0-1.1,0-1.5h.5l1,.5Z" fill="#0568e3" />
        <path d="M228.7,359.7c.2,0,.7,0,1,0,.2.5-.5.9-.5,1l-.5-1Z" fill="#041d8d" />
        <path d="M242.7,371.7c-1.3-1.4.8-1.6.5,0h-.5Z" fill="#033ac6" />
        <path d="M229.2,361.2c0,0,.6.1.5.5-.3,0-.9,0-1,0l.5-.5Z" fill="#187ce7" />
        <path d="M226.2,361.2v-1c0,0,.7,0,.5.7s-.4.1-.5.3Z" fill="#024bca" />
        <path d="M230.2,366.7c.2-.5.6-.7,1-1l-1,1Z" fill="#034cca" />
        <path
          d="M241.7,365.2c0-.4-.1-1.3,0-1.5s.5.3.7.2c2-.8,2.9-.9.8.8l.5.5c3.4-.6,2.1.2,5,1.5,0,0-.8,1.4-1,1.5.4,1.3-.8,1.7-1.5.5-1.1.3-1.3,0-1.5,0-.2-.5-1.2-.2-1-1l1.8-1c.2,1.5,1.7,1.2,2.2,0-.8,0-1.5-1-2.2-.9-1.4.2-3.1,3.7-3.8,1.4l1.5-1c-.5,0-1.1.1-1.5,0,0-.3,0-.7,0-1Z"
          fill="#024ad4"
        />
        <path
          d="M247.7,368.2c.8,1.9.3,2-1,2.5-.5-.7-1.2-1.2-.5-2,.2,0,1.4-.4,1.5-.5Z"
          fill="#0249cc"
        />
        <path d="M243.7,365.2c-.3,0-.7,0-1,0,0-.6.4-.4.5-.5l.5.5Z" fill="#036ce5" />
        <path d="M253.2,360.7c-.3,0-.7,0-1,0-.3-.3.7-.8,1-1v1Z" fill="#0253e0" />
        <path
          d="M258.7,358.2c.3.1,1.1.8,1.5.5s-.6-1.2.7-2l1,2,.5-1c.3.1.2.5.2.5,0,1.7-.4,2.3,1.5,2-.4,1.3-1.1,1.6.5,1.5h.5c-.9.7-.6,1.7-1,2.5-.9.1-1.5,0-2.5-.4.3-.7.1-1.4-.5-2.1q.5-1.8,0,0c-.1.3-.3.3-.5,0-.3.4-.5.2-.5-.5.3.8.6,1.7.5,2.5.4.1.4.3,0,.5.5.8-.7,1.6-1.5,1.5,0,3.3-2.4,2.4-2-.5-.9-.5-1.1-.7,0-1l-1-.5c-1.4.4-1.6-.2-.5-1-1.4-.2-1.2-.4,0-1,1.1-.8,3.3-.3,2,1,.1.5.3.4.5,0,0-1.5,1.3-3.2,2-1.5-1.1.2-1.7-.1-2-1,1.8.4.4,2.4-1.5,1.1l-1,.4c-1.3,2.2-3.7.5-1.5-1-.4-.1-.4-.3,0-.5v-.5c-.4-.1-.4-.3,0-.5.1-1.1,2.2-1.9,2.5-1l1.5,2c0-.6.5-1.4.5-2Z"
          fill="#0355dd"
        />
        <path d="M258.7,357.7c0,.2,0,.3,0,.5-.5-.2-.9.3-1.5-.5,0-1.2,1-.9,1.5,0Z" fill="#0355dd" />
        <path
          d="M258.2,360.2c.1,0,1.7,0,1.9,0s0,.8,0,.9c-1.7-1.5-.4,1.9-.5,2l-1.5-.5c-.1.4-.3.4-.5,0-.5-1-.8-1.1-2-1,.6-1.5,2.4-.4,2.5-.5s-.1-.9,0-1Z"
          fill="#0360e3"
        />
        <path
          d="M257.2,357.2c.4.1.4.3,0,.5-.2,0-.4.5-.5.5-.4.1-1,0-1.5,0-.2,1,1.2,0,1,1-.6.1-1.5-.1-2,0-.2.8-.4,1.2-1,.5-.2.3-.3.6,0,1,.3-.9.7-.9,1,0,.2,2.6.3,1.1,1.5,1,0,.1,0,.7,0,1,0,1.1-.8,1.2-1.5.5,0,.3-.2.5-.5.5l-2-1,.3,1.5c-2.2-.7-.6-1.4-1-2s-1.1-.3-1.3-.5c-.5-.1-.4-.3,0-.5-1.4-.5,0-1.6,1-1.5.5-.9,1.3-1.2,2.5-1,1.7-1.1.8-.5,2.7-1s0-1.6,1.3-.5Z"
          fill="#0360e3"
        />
        <path d="M261.2,361.7c-.1,0-.6-2.9-.5-3,1.5-1.3,2.1,3.6.5,3Z" fill="#0466e5" />
        <path
          d="M257.2,365.2c0,0,.7-.1.9,0s-.7,1.5.3,1.9c.3.1.5-1.1.7-1.5.7-.7,1-.4.5.5-.7.9,0,2.8-3,2.5v-.5c.3-.3.9-.4,1-.7,0-.8-4,.3-1-1.7,0-.5.2-.7.5-.5Z"
          fill="#0247d1"
        />
        <path
          d="M260.7,361.7c.6,1.2,1.6,2.4,0,2-1.3-.4-.4-2.4-.5-2.5,0,.2.4.3.5.5Z"
          fill="#0336c5"
        />
        <path
          d="M260.7,364.2c1.4,0,1.2.1.5,1l-.5.5c-.2.2-.9.3-1,.5l-.5-.5c.4-.5,1.2-.8,1.5-1.5Z"
          fill="#022fba"
        />
        <path
          d="M255.7,362.7c0,.6.1.6.5,1l1,.5c.1.2-.1.9,0,1-.2.2-.3.4-.5.5v-.5l-.5-.5c-.1,0-.4,0-.5,0l-.5-.5c-.1,0-.3,0-.5,0-.1.3-.3.3-.5,0,0-.3,0-.7,0-1,.4-.3,1-.4,1.5-.5Z"
          fill="#024bd5"
        />
        <path d="M258.2,362.7l.2,1c-1.6-.2-.7-.9-.7-1h.5Z" fill="#033bc9" />
        <path d="M257.2,364.2c-.5,0-.7-.2-1-.5.6,0,.7,0,1,.5Z" fill="#0247d1" />
        <path d="M256.2,359.7c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#0360e3" />
        <path d="M254.2,360.2c0-.2,0-.3,0-.5v.5Z" fill="#0360e3" />
        <path d="M244.7,257.8l-.5-.2.5-.2c0,.1,0,.3,0,.5Z" fill="#023ee9" />
        <path d="M246.2,255.3c-.3-.2-.3-.2-.5-.5.3,0,.5.2.5.5Z" fill="#0247e4" />
        <path d="M232.2,258.3c0,0,.5,0,.5,0l-.2.5-.2-.5Z" fill="#024fef" />
        <path d="M243.2,260.8h-2.5s0-.5,0-.5c.4-.4,2.3-.4,2.5.5Z" fill="#0226da" />
        <path d="M235.7,259.3c0-.3.2-.6.5-.5-.1.2-.3.4-.5.5Z" fill="#035ef2" />
        <path
          d="M245.7,317.8c.3-.1.9-.6,1-.5l-.5,1.5c1-.4,2.3.8,2.8.8s1.2-1.7,2.2,0c-1,1.5-2.5.4-3.7.3s-1.1.4-1.4.4,0-1.1-1.3-1c-.9.7-1.7,1.2-2.5,1.5-.7.5-1.2,1.4-2.5,1.5-2.6,1.2-1.2-3.5,1-1.5-.3-1.8.4-2.3,2-1.5-.3-1.5.2-1.7,1.5-1,.2-.6.9-1,1.5-.5Z"
          fill="#055ff4"
        />
        <path
          d="M249.7,313.8c0,0,1.7.9,2,1,.6.3,2,.1,2,1-4.8-1.6-1.5,1.5-1.5,2.3s-1.2,1-1.5.7-.8-4.2-1-5Z"
          fill="#0563f8"
        />
        <path
          d="M243.7,312.8l-.5,2c1.1-.2,1.7-.9,2.5.3.2.5-1,.2-1,.7-.9,1.4-5.4,3.4-4.7.1,1-.5,1.1-.8,1.4-1.8,1,0,1.1-.2,1.3-1.3,0-.8.4-.8,1,0Z"
          fill="#0360f6"
        />
        <path
          d="M242.7,310.3l.5,2,1.5-.5v1.5c-.1.2-.7-.5-1-.5s-.7,0-1,0c-.9-.6-1.4-1.5-1-2.5.3,0,.7,0,1,0Z"
          fill="#0238ec"
        />
        <path
          d="M245.7,315.8c.4-.3.7-.4,1,0l-1,2c-.5.2-1.1.3-1.5.5-2.5.7,0-2.6.6-2s-.8,1,0-.5c.3,0,.7,0,1,0Z"
          fill="#023ced"
        />
        <path d="M245.7,315.8c.6-.9,3.8-2.8,3.5-.5-1.2-.6-.8.4-2.5.5s-.7,0-1,0Z" fill="#0464f8" />
        <path
          d="M245.2,310.3c.6,0,1.2-.5,1.5-.5v2s-2-.5-2-.5c-.1-.1.4-.7.5-1-.3,0-.8,0-1,0s-.3-.4-.5-.5c.7-.5,2.9-3.3,1.5.5Z"
          fill="#0358f6"
        />
        <path d="M248.2,312.8c-.6.5-1,1.2-2,1-.5-1.9,1.9-.9,2-1Z" fill="#0469f9" />
        <path d="M244.2,310.3c.2.2-.5.8-.5.2s.4-.4.5-.2Z" fill="#0241f0" />
        <path
          d="M242.2,307.8c0,0,.6.2.5.7s-1.3.4-1,1.8.7,1.6,1,2.5c-.2.4-.3.4-.5,0-.6.8-1.2-.2-1-1-.5-.1-.4-.3,0-.5-.4-.2-.4-.3,0-.5-3.1-1-3.5-2.3,0-3,0,0,.5-.5,1,0Z"
          fill="#0351f4"
        />
        <path
          d="M232.7,309.3h.7c.2.9,1.3,1.3,3.3,1,.3,0,.7,0,1,0h.5c.1-.4.3-.4.5,0,.6-.6,2.2-.4,2.5.5,0,.2,0,.3,0,.5-.6.6-.8,1-1.1,1.8s-1.2-1.3.6-.8c.7.8,1.2,1,1.5.5,0,0,.3,0,.5,0,.7,2.3,0,1-.5,1.9s-.2,1-.5,1.3c-.4.5-1.2,0-1,.8,1.4.5,2-1.2,2.7-1.3s.9.3,1.3.3c0,.6,1.2.3,1,.7l-2,1.5.5.2c-.3.1-.9.7-1.5,1-1.4-.5-1.9.3-2,1.5-.6.6-1.4.5-1.5.5-.3.3.5.9.5,1,0,.2,0,.3,0,.5.7.5.3,1-.5,1,0,.3,0,.7,0,1,.7,0,.6.7,0,1-1.2-.4-1.3-.7-.5-1-.6-.4-1.4-.4-2,0,2.5.4,4,2.6,1,3.5-.3,0-.6.6-1,.5-3.2-1.9-3.7-3.5-1.5-5-.7-.6-1.6-.3-2.5,0,.3-1.2.1-2-.5-2.5-2.3,1.9-1.8-4.1.5-.5.5-.3.5-.4,0-.5-2.2,0-1.7-3.3-.4-4.4l-.6-.6c0-2,1.3-1.8,1.5-3.5-.4-.3-2.7,1.3-3-.5l1.8-.5c.3-.1.2-.3.2-.5l-.5-.5c-.1-.3-1-.3.5-1,0,.2.4.4.5.5Z"
          fill="#024aee"
        />
        <path
          d="M244.7,319.3v.5c.4.7-.4.9-1,.5-.6.5-.5,1.6-1.5.5.8-.5.8-1.4,2.5-1.5Z"
          fill="#033be8"
        />
        <path d="M239.7,322.7c2-.2.7,2.1-.5,1,0-.5.5-.9.5-1Z" fill="#0354f0" />
        <path d="M244.7,319.8c1.1.6.5,1.3-.7,1l-.3-.5c.2-.2.7-.3,1-.5Z" fill="#055ff4" />
        <path d="M256.2,317.3c.4-.3.4-1.4,1.5-1l-1,1.5c-.2-.2-.3-.3-.5-.5Z" fill="#096bf8" />
        <path d="M239.2,324.7c1.6-.2.7.3.5,1.5-.4,0-.4-.4-.5-.5v-1Z" fill="#0354f0" />
        <path
          d="M228.7,313.8c.1.4.4.9.5,1.5,1.3.2,1.3.6,0,1,.7,1,.7,1.5,0,1.5.8.3.8.7,0,1,1.9.4,2.1.7,2.1,2.7l-1.1.3v.5c.6-.1,1,.2,1.5.5.3.2.5.5.5,1,.5,1.1,0,1.2-1,.5-.1.5-.3.4-.5,0-1.1,1.3-2,1.1-2.6-.6-.5-.2-1.1-.4-1.4-.9-.3-.5-1.4-.3-1-1.5l1.7,1c.2-1.6-.2-4.4-1.8-5.5,1.7-1,.6-.4,0-2,2.1,1.3,1.3-1.3,3-1Z"
          fill="#0230d8"
        />
        <path
          d="M231.7,315.3c1.7,1-.3,3.2-1,1-.3.4-.7.6-1,.5-.2.2-.4,0-.5-.5,0-.6,0-.9,0-1,.7.8,2,0,2.5,0Z"
          fill="#0451ec"
        />
        <path d="M228.7,313.3c.6,0,2.5-.3,2.5.3,0,2.5-2.1.3-2.5.2,0-.2,0-.3,0-.5Z" fill="#0148ee" />
        <path d="M232.2,310.3s-.4-.2-.5-.5l.5.5Z" fill="#0349f4" />
        <path
          d="M231.7,259.3c.4.9-.1,1.3-1,1-.1.2-.8,0-.5,1,1.1,0,1.8-.4,1.5,1-.5,0-.5-.3-1,0,.3,1.8.6,3.5,1,5,0,.6-.3.9-1,1,0,.7-.2,1.8-.5,2.5,1.2.5,1,.8-.5,1,.6.8.2,1.3-1,1.5-.4.7-.6.7-1,0-.6.4-.9.4-1,0,.2-.4,1.4-.4,1-1.5l-2-.8c.9-1.3,3.1,0,2.5-2s-.8-.2-1-.6c-.3-.7,0-1.5-.2-2.3-.2-1.3-2-2.1,1.7-1.3-2.2-2.3,0-2.6,0-2.8,0-.4-.4-.9-.5-1.2-.4-.1-.4-.3,0-.5,0-.1,0-.4,0-.5.1-.7.6-1,1.5-1,.6-.2,1.6,0,2,.5Z"
          fill="#0232db"
        />
        <path
          d="M230.7,262.3l3,2-1.5.5c-.2.6.5.9.5,1,1,1.9-1.3,4-1,1.5l-1.8-1.5-.2,1.5c-2.2-1.1-.1-1.6.3-2.5s-.9-1.6.7-2.5Z"
          fill="#023fec"
        />
        <path d="M232.7,259.3c-.7,1.3-.2,2.1-2,1,.3-.3.7-.6,1-1,.3,0,.7,0,1,0Z" fill="#022dd0" />
        <path
          d="M231.7,258.8c0,.1,0,.4,0,.5-.7-.1-1.3-.4-2-.5,0-.2,0-.4,0-.5.6.3,1.4.3,2,.5Z"
          fill="#024fef"
        />
        <path d="M229.2,269.3c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#021dc0" />
        <path d="M230.2,276.8v.5c-1.4.2-1.4-.7,0-.5Z" fill="#023fec" />
        <path
          d="M232.7,287.3c.4.4.4,1.1,1,1l2-2c0,2.4-2.7,2.2-3,4l-1-2.5c-1.1,4.8,2.6,1.6,3,2-.3,2.3-2.8.8-.5,3s1.1.4,1,1h-4.5c-.7-.7-2-1.7-3-1.5,0-.4,1.6-3,2-3.5-.5-.6.3-1.1,1-1,.4-.5.9-.8,1-1.5.1-.3.3-.3.5,0,0,.4.2.7.5,1Z"
          fill="#022ee4"
        />
        <path
          d="M230.7,287.3v.5c-.7.9-.9.9-1,1h-.5c-.4.3-.7.4-1,0,.2-.5.5-.7,1-1,0-.7,1-.9,1.5-.5Z"
          fill="#0230df"
        />
        <path d="M232.5,291.8c.5.4-.8,1.3-.7.7l.7-.7Z" fill="#023ef2" />
        <path
          d="M347.2,231.8c-.6-.4-.4-1.6.5-1.5.1,0,.4,0,.5,0,1.2,1.5.5,3.2-1,1.5Z"
          fill="#0374f8"
        />
        <path
          d="M344.7,225.3c-1.2-1.4,2.3-2.6,1.9-.6l.6.6.5,1c.4.3.5,1,1.5,1-.2.9-.5.3-1.3,1-.7-2.2-1.4,0-.7,1.5-.3.7-.7.6-1-.5-.2,0-.5,0-.7,0s-1.5-.4-1.4-.5c.2-.3,2.1-.3,2.1.5.8.6.9,1.6,1,2.5.7,1.5-.2,1.7-1.5,1-.2.4-.3.4-.5,0,0-.1,0-.7,0-1-.5-.1-.5.5-.5.5-.1.3-.3.3-.5,0l1.5-2c-2.7-.5-2,1.5-2.6,2s-2.3-.4-2.9,0c-.3.7,2.1.5,1,1.5s-3.1-.9-3.5-.5c.1,0,0-.4.3-.6.5-.4,1.3.4,1.2-.2-.1-1.8-1.9-.6-2-.7-.5-.7.5-.9.5-1,.8-1.3,1.9-1,2,.5l.7-.6c-.1-1.6.6-2.7,2.3-3.4-.2.7-.9.8-1.5.5-1.4.7-1.7-1.5-.5-2,.6-1.7,1.2.4,1.1.3-.5-.4-.8-.8,0-1.3.1-.4.3-.4.5,0,1.2.5,1.8.4,2,0l.5.6c.9,1,.3,1.7-2,2,1.6-.3,2.2-1,2-2Z"
          fill="#0374f8"
        />
        <path
          d="M346.2,234.8c1.2.1,1.1.6,0,1,0,.5,0,1.1,0,1.5.1.5,0,.6-.5.5-1.6,2-1.9.9-.5-.8l-2,.3c.5-2.7-1.7-1.1-2.5,0,.5,0,1.6-.2,1.9,0s0,.7,0,.9c-.2.5-.5.9-1,1l-1.5-2c-.4-.1-.4-.3,0-.5.3-.2.4-.9,1.4-1.4s3.3-.4,4.6-.6Z"
          fill="#0374fa"
        />
        <path
          d="M337.7,233.3c-1.3,1.3,1.8,1.6,2,2.5h-2.5s.5,2.5.5,2.5l-.5-2c-1.2-.4-1,.7-1.5,1,0-.3,0-.7,0-1-.2-1.5-1.1-.9-1-1.2,1.4-.6,2-1,3-1.8Z"
          fill="#0276f8"
        />
        <path
          d="M345.7,232.8c2.8-.6,4.9,1.8,1.5,3.5,0,0-.2.7-.5.5l-.5-1v-1c.3,0,.7,0,1,0v-.5s-2.5,0-2.5,0l.5-1.5c0,0,.4,0,.5,0Z"
          fill="#024df0"
        />
        <path
          d="M341.2,243.3c.2.7,2.2,2.5-.5,2.5-.4-.1-.4-.3,0-.5l.5-.5c-.5,0-1,.2-1.5.5-.2,0-.7,0-1,0l.5-1.5c.4,0,1.2-.9,2-.5Z"
          fill="#0351f4"
        />
        <path
          d="M336.2,243.3c.2,0,.3-.7.6-.8.8-.3,2,0,2.9-.7.3,1.2-.7,1-1.5,1.5s-2.2,2-2,0Z"
          fill="#0348ed"
        />
        <path
          d="M342.7,238.3c.2.8.1,1.2,0,2,1.6-1.2,1.9,1.3-.5,0-.6.6-.8.3-.5-.5,0-.1,0-.4,0-.5.2-.4-.6-1.3,1-1Z"
          fill="#034df3"
        />
        <path d="M340.2,237.3c-.3,1.2-2.3,1.6-2,.3s1.4-.4,2-.8v.5Z" fill="#0153f6" />
        <path
          d="M342.2,240.3v.7c0,.3-.3.2-.5.3l-.5-.5h-.5c.1-.7,1-.9,1-1,.1.2.3.4.5.5Z"
          fill="#0374fa"
        />
        <path d="M341.2,242.3l.3-.5c1.3-.2,1.2,1.3-.3,1,0-.1,0-.3,0-.5Z" fill="#023ff2" />
        <path d="M344.7,232.3c0,.6-.9.8-1,.2l.5-.2c.2,0,.4,0,.5,0Z" fill="#024df0" />
        <path
          d="M339.2,225.8c.2-2.3,3.2-1.5,1.5,0,.2.6,0,1.4.5,2,0,1.6-.5,2.7-1.5,3.5-.7-.2-1.3-.4-2-.5,0-.3,0-.7,0-.9-2.2,1.4-2.6-.6-2.7-.6-.4,0-.9.4-1.2.5s-.7,0-1,0c0-.6-.5,0,0-1.5s1.5-2.3,2-2,0,.7.2.8c.6.4,1.5-.2,1.3.7l-2,.5,3,1.5c-.9-1.7.4-1.4,1-3l1-1Z"
          fill="#027ffa"
        />
        <path
          d="M334.2,218.3c.6-2.7,4.7-.5,4.3,2.2l.7.8c.2.6.4.4.5-.5.8-.4,1.1-.7,1-1-2.6-1.4.8-2.7,3-1,.1-.4.3-.4.5,0,1.3.3,1.2.6,0,1,.1.4,0,.6-.5.5-.3,0-.8.3-1,1,.6.1,1.2-.4,2-1.5.3-1.6,1.9,0,1.5.2s-.3-.4,0-.7c0-1.1.8-1.1,1,0l1,.5c.2-.8.6-.6,1.1.4.1-1.3.4-1.1.9.6-.9.3-1.9.6-3,1,.5.6,1.4.6,2.7.2,2.5,1.6-2.9,3.5-1.4,2.4s2.3-1.5,2.6-1.1c.1-.4.3-.4.5,0-.5,1.1-.1,2,0,3v.5l-.5,2h-.5c.1-3.2,0-1.5-1.5-1.5.3-1.3,0-1.8-1.2-1.5l-.3.5c-.1,0-.7.2-.9,0,0-.4.4-.7.4-.9-1.3-1.9-2.2-2.1-2.7-.4-.9.6-1.9.2-1.3-.6-.4-.6-.8-.7-1-.5.6.4.8.8,0,1h-.5c-1.5-.5-2.3-.2-2.5,1-.1,1.2-1.3.5-1-.5-1.2-.8-1.3-1.1-.3-1.1l-.2-.9c-.2.6-.5.9-1,.5,0,.8-.7.7-1,0-.2.4-.3.4-.5,0-.4-.5-.7-.5-1,0,.9.2,1.2.4.5,1,0,.3-.3.6-.5.5l-.5-.5c-.2-.2,0-1.2-.8-1.5-.4.1-.6.9-.7,1s-.7-.4-1-.5c0-.3,0-1.5,0-1.5.1,0,.7.8,1,.3-2-1.5.4-2,1.5-3s.4-1.1.5-1.3Z"
          fill="#037df9"
        />
        <path
          d="M335.2,223.8c.2,0,.3,0,.5,0,2.2.8,2.7,1.4,1.5,2,.4.1.4.3,0,.5,0,0-1,0-1,0v-.5c-.2-.6-1.3-.8-1.5-1s-.3-.7-.5-1c.2-1.3.6-1.3,1,0Z"
          fill="#0386fb"
        />
        <path
          d="M339.2,225.8c0,.7,0,1.3,0,2h-.5c0-.3-.3-.8-.5-1-.5-.4-.3-.3-1-.5v-.5c.4-.6.7-.8,1-.5,0,0,.5.6,1,.5Z"
          fill="#0253ef"
        />
        <path d="M332.2,224.3c2.1.6.1,2.6-.5,2s.6-1.5.5-2Z" fill="#0156eb" />
        <path d="M336.2,226.3c0,0-.2.8-1,.5l1-1v.5Z" fill="#0151f0" />
        <path d="M334.2,225.3l-.5-.5c0,.1.4.4.5.5Z" fill="#0386fb" />
        <path
          d="M344.2,245.3c.8-1.3,0-2.7,2.2-2s.6,2.1,2.3,1.5c0,1.8-.9,2.2-2.3,1.3-1.2.8-1.9.9-2.2.2,0,0-.3,0-.5,0,.2-.3.3-.7.5-1h-1s0-1.5,0-1.5c.7.2,1.1.8,1,1.5Z"
          fill="#0247f2"
        />
        <path
          d="M340.7,250.3c.4,0,1.3-.1,1.5,0s-.5,1.1,0,1.5h-1.5c-.1-.2-.9-.5-1-1,0-.3.4-.4,1-.5Z"
          fill="#0355f5"
        />
        <path d="M341.2,244.8l-.5.5v.5c-.5,0-.7-.4-1-.5.1-.8,1.4-1.5,1.5-.5Z" fill="#0c76fa" />
        <path
          d="M340.7,250.3c.1.5-.5.6-1,.5h-.5c0-.2,0-.3,0-.5-.3-.1-.3-.3,0-.5.2,0,.3,0,.5,0l1,.5Z"
          fill="#093cdc"
        />
        <path d="M346.2,237.3c0,0,1.4,1.1-.2,1l-.3-.5c.1-.2.3-.3.5-.5Z" fill="#0145f2" />
        <path d="M340.7,250.3c-.4,0-.7-.2-1-.5.3,0,1,.3,1,.5Z" fill="#0352f3" />
        <path d="M341.7,241.3c-.4,0-.5-.1-.5-.5l.5.5Z" fill="#0267f7" />
        <path d="M339.2,250.3h-.5v-.5c.2,0,.3,0,.5,0v.5Z" fill="#0352f3" />
        <path d="M340.7,253.3l-1.5-.5c.3-1.1,1.3-.3,1.5.5Z" fill="#0355f5" />
        <path
          d="M354.2,254.3c0-.6.7-2,1.3-2.5.7.5-.6,2-.2,2.5.8,1,1.1-.9,1.2-.9.3,0,1.4.4,1.8.4,1,.6,1.5.6,1.5,0,.2-.7.5-1.1,1-.5v3c-.8.3-2.5-2-3-1.5s.6,1.4,1,1.7l-1,.3c2.2,2.3-.7.7.5,2.5,0,0-.4,0-.5,0-.2-.1-.3-.6-.7-.8s-1.1,0-1.3-.4c-.5-1.1,1.9-.2,2-1.5l-3.5-2.2Z"
          fill="#034bf5"
        />
        <path
          d="M343.7,246.3c.1-.3.3-.3.5,0h1.2c.9-1.6,3.4,0,1.6,1.7l.7.9c.8-.2,1.3.5,1.3,2.1,1,1.2,3,4.5.8,4.2-.1.4-.3.3-.5,0-.6,1-1.6,1.1-3.1.5l-.9.5c-1,2.3,0,.9,1,2-.5-.1-.7.3-1,.5s-.8.3-1,.5c-.4-.3-1.4-1.4-1.5-1.5.2-.1.4-.5.5-.5-1.1-1.2-1.7-2.9-1.8-5.1l1.3-.4c.2-.2.3-.4.5-.5.2-.5.2-1,0-1.5,0-.2-.2-.8,0-.9.5-.3,1.7.3,1.9-.3-.5-1-1.6-.7-2-.9-.9-.4,0-1-2-.6.8-1,1.3-1.3,2.5-.8Z"
          fill="#0355f5"
        />
        <path
          d="M354.2,254.3c.3-1,.7-.8,1.2.4,2.5-1,2.8,2.7,2.3,4.5.6.2.7.9,0,1-.1.3,0,.7.5,1,.3.2.3.3,0,.5-1.9-.7-2.3,1.2-2.6,1.3-1.9.9-1,0-2.9,1.7s-.5.5-1,1c-.1.3-.3.3-.5,0h-.5c-.4-1-.5-2.6-1.5-3v1.5c-1.1-.5-1.4.9-1,1.5s1.8-1.3,1.5.2l-2.5.3c-2,1.2-1.4-.7-.5-2.2l-.5.2c-.6.6-1.2.4-1-.5-.7,1.1-1.4,1.2-2,0l-1-2c0-.1,0-.4,0-.5.3-.6,1.2-.7,1.5-1-.5.5,1,2,1.5,1.5s-1-2-1.5-1.5c0,0,.1-.7.5-1,.4.3,1,.7,1.2,1,.4.8-.1,2.4,1,2,1.8-.6-1.6-2.8-1.2-3.5s.6,0,1-.5,1.2-1.3,1-1.5l-1.5-.5c0-.5.3-.9.9-1.2.4,1.1,1.3,1.3,2.6.7.1-.3.5-.3,1,0,.3-1.1,1.1-1.1,2-.5,1.1.2,1.8,0,2-.5-.3,0-.3-.2,0-.5Z"
          fill="#0355f5"
        />
        <path
          d="M346.2,264.3c.6-1-.9-1.2-.5-1.5.8-.7,2.2,2,1.9,2.4s-.9,0-.9.3c0,.7.5.6.5.7,0,.1,0,.3,0,.5-1.6,1.5-1.5.5-3-.5-.3-.8-.7-1.7-1-2.5.4,0,.7-.5,2,0,.1.5.4.7,1,.5Z"
          fill="#0245e7"
        />
        <path d="M343.2,263.8c-.7-.1-.6-1.5-1-2,.4.7.5.9,1,2Z" fill="#0344e6" />
        <path d="M351.2,265.8c.2,0,.4,0,.5,0l-.2.5-.2-.5Z" fill="#024dee" />
        <path
          d="M352.2,255.3c-.4-.5-2.3-1.6-1.5-2.5s2,1.2,2.5,1.5.5.5,1,.5c0,.5,1.4.4-1,2h2c-.7.7,0,2.4,0,2.5-1.5,1.1-1-1.8-1.1-1.9s-1.4-1.4-1.9-2.1Z"
          fill="#0243f4"
        />
        <path d="M353.7,262.8c-2.5-.3-1.4-2.6-1-4,1.3.5.6,2.9,1,4Z" fill="#0241ed" />
        <path d="M348.7,257.3l-1.5,3.5c0-.9.3-1.9.7-2.7s-.6-1,.8-.7Z" fill="#023ae8" />
        <path d="M357.7,260.3c0,.2.4.5.5,1l-2.5-1h2Z" fill="#034bf5" />
        <path d="M346.2,264.3c-1,1.8-2.1.2-1-.5.3.1.7.4,1,.5Z" fill="#0328d3" />
        <path d="M350.2,255.8c-.7.2-1,0-1,0v-.5c.2,0,.4,0,.5,0,.2,0,.3.3.5.5Z" fill="#0436ec" />
        <path d="M355.4,255.8c.3.2.3.3,0,.5v-.5Z" fill="#034bf5" />
        <path
          d="M342.2,251.8h.5c-1.5,1.5-.2,1.7-.2,2.2s-.8.8-.7,1,1.9,1.8,2.4,1.8c.2.8-.6.4-1,.5-2.7-.5-1.3-3.7-2.5-5.5-.1-1.1,1.4-1,1.5,0Z"
          fill="#0344e6"
        />
        <path d="M343.2,249.8c2.5,1.7.3,1.3,0,1.5-.4-.7-.2-.9,0-1.5Z" fill="#0138ea" />
        <path
          d="M348.7,244.8c.1,0,.3,0,.5,0,.1-.4.3-.4.5,0,0,.1,0,.4,0,.5-.3.6-1.4.3-.5,2.5.5-.4,1.2-.2,1.5.5-.1.3-.3.8-.5,1-.9,1.4-.7,3.2,2.3,2,.2.5.6.8,1.2,1,0,.3.9,1.3-.5,2-.6.1-.9.5-1,1-.7.2-1.3.3-2,.5-.4,0-.6,0-.5-.5,1.2-1.3-.5-2.2-1.5-2.5-.2-.9.8-.3,1-.5s-1.2-1.8-1-2.5c-1-.2-.3,1.3-.5,1.5s-1.8-.1-2-.8,1-.1,1-.5c0-1.4-2-1.7.5-3.7l-2.7,1c-.5,0-.2-.9-.3-1,1.2.3,1.1-.4,1-1.5.9-.2,1.6.8,2.3.9s.9-.7,1.2-.9Z"
          fill="#0461f9"
        />
        <path
          d="M345.2,256.3c.4-.8,1.2-1.8,1.8-2.5,2.4.4-.3,1.2-.3,1.2.9,1.2,1.3.3,2.5.3.4.1.4.3,0,.5,0,0-.4,1.1-1.2,1s-1.4-1.3-2.3-.5h-.5Z"
          fill="#0461f9"
        />
        <path d="M344.7,251.8c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#0b78fd" />
        <path
          d="M354.7,282.8c3.6-1.5,2.9,4.1,0,3,.6.6.3.9-.5.5-.1.3-.3.3-.5,0,0-.2,0-.4,0-.5-.9-.6,1.4-2.8.8-1.9l-.3-.6c-.3-.2-.3-.1-.5-.5.4-.8.8-.9,1,0Z"
          fill="#0240e6"
        />
        <path
          d="M356.2,281.8c2.6-1.8,1,0,1.8,0s1.9-.8,2.7-1c0,.7.3,1.2-.5,1.5,0,1,.6,2,1.8,3.2,0,.6-3.5,2.3-3.4,1.3s1,.7,1,1l1,1.5-2.5-.5c.2-.7-1-1.7-1-2.5l-1,1.5-1.5-2s-.4-.3-.5-.5c2.6.1,2.5-2.5.5-2.5.1-.2.4-.3.5-.5.3-.3.7-.5,1-.5Z"
          fill="#0349ef"
        />
        <path d="M356.2,281.8c-.3.2-.5.5-1,.5.3-.4.5-.8,1-1v.5Z" fill="#0240e6" />
        <path
          d="M360.1,282.3c.8.8,1.4,2.3,2.3,3s0-2.1,1.2-.3c-.5,1.2-1.8,1.3-1.5,2.8-2.1-2-1.9-.3-2.5,0-2.1.9-1.2-1.6-2-3,.5.4,2.4,0,2.5,0,.3.2-1.4,1.2-1,2l2-1.5c0-1.2-2.3-1.8-2.5-2-1.1-1.2,1.3-.9,1.5-1Z"
          fill="#023cef"
        />
        <path d="M358.1,283.8c-.9.8-2.2-.7-1.5-1.5s2,1,1.5,1.5Z" fill="#023cef" />
        <path
          d="M317.2,175.3c1.4.5,1.9,1.2,1.5,2,0,.4,0,.9,0,1.5-.7,0-.9.3-2.5,0,.7-.5,1.1-.5,1-1.5-.1-1.4-1.5-1.5-1.5-1.7l1.5-.2Z"
          fill="#05abfa"
        />
        <path
          d="M320.2,169.3c2.3.4.8,3.3-.5,1-.1.4-.3.4-.5,0-1.1.3-1,1.5-1,2.5h-.5s-.5-1-.5-1c0-.5-.2-1.8,0-2s.7,0,1,0c.6-.2,1.4-.4,2-.5Z"
          fill="#05affa"
        />
        <path d="M309.2,160.3c0,0,.1-.5.2-.5,1.7,1.5,0,.8-.2,1v-.5Z" fill="#036deb" />
        <path
          d="M305.7,159.3c.6-.8,2-.6,2.1.6.5-.4,1,0,1.4.4.4.1.4.3,0,.5.9,1.1,1.3,2.2,1,3.5,0,1.3.2,1.5.5.5-.8-1.1-.9-2.4.5-1.5.2.6.5,1.1,1,1.5.5-.4.7-.1.5.5.3.4.5.4.5,0-.8-.6-1.5-2.5,0-2,.5-.2,1.5.1,1.8.6.8,1.5,2.1,4.5-.3,4.9-.2.2-.2.4,0,.5,1.6-2,5.9-2,3.5.5-.2.6-.5,1.3-1,2,.9,1.8.7,2.5-.5,2.2.1.7-.9,1.1-1.5,1.3-.2.2-.3.2-.5,0-.3-.2-.7-.2-1,0-.6,1.3,1.2,1.8,2,1,.6.2,1.2.4,1.5,1,1.3.7.4,1.6-1,1.5-.6,1-1.1.9-2,.5-.3.2-.6.2-1,0,.3.2.3.3,0,.5.7-.2.8-.1.5.5.9,1,.8,1-.5,1-3,.6.1-1.8-1.5-2.5l-1.5,3c.3-.6-.5-2.3-.5-2.4.2-.2,1.5-.3,1.4-1.1-2-.2-2.7-.7-1.9-1.6-.9-1.1-3-4.5-.6-3.9.2-.4.2-.7,0-1-.8.5-1.3-.2-1.5-2l-.8-.7c.4-.6.2-1.4-.7-2.3-.8.8-1.7,1.6-2.5,2.6-.3,0-1.7-4.3-1.3-4.8-3-1.2-.3-6,1.3-3.7l.5-.3c0,.9.9.6,1.5.3-.6-.4-.7-1.1,0-1.5.1-.4.3-.4.5,0Z"
          fill="#038ff8"
        />
        <path
          d="M305.7,166.8c1.1.4,1.5-.2,2.5,1.8-.9,0-.9,1.1-1,1.2q-.9.9,0,0c1.2-1.1.8,1.5,1.5,2-.2.3-.2.7,0,1,0,0-.6.9-.5,1,2.8-.5.8,1.8,1,2,.8.9,2-3,3.5-2-2.6,1.2-.3,4-3,3.5-.2,1,1.4.1,1.5,1h-3s.5-1.5.5-1.5l-2,.5c-.3-.7,2.1-.5,1-1.5s-1.9.7-1.5-1l1.5-1c-4.1,0-1-1.5-3-3-.9-.2-.8-.6,0-1,.7-.4.7-.6,0-.5,0,1.4-.6,1.3-1,0,0-.7,1.3-2.3,2-2.5Z"
          fill="#037bf6"
        />
        <path
          d="M305.7,158.8c.2-.3.5-.5.8-.6,1.2-.5,4.1-1.7,3.9-.2,1-.4,1.8.8,1.8,1.8.8,0,1.7,2.3,1,3,.2.1.2.3,0,.5,0,0-.4.2-.4.7s.4.4.4,1.3c-.1.4-.3.4-.5,0,0,0-.4-.2-.5-.5-.5-.2-.8-.7-1-1.5-.8,0-.4.9-.5,1.5-.5.1-.6,0-.5-.5-.7-.6-1.2-.5-.5-1.5h-1.5c.5-.4.9-1.9,1-2,.5-.7.5-.9,0-.5-2.3.8-.7,1.8-2.5,2-.1-.7.2-2.7,0-3s-.8,0-1,0v-.5Z"
          fill="#03a2fb"
        />
        <path
          d="M319.2,170.3c0,.6.2,1.1.5,1.5,1.9.4,2.8,2.1.5,2.5.1.5,0,.6-.5.5q-.7-.6,0,0c.2,2.8-1.3,2.3-2.3,0l-.2.4c.2.9.2,1.6,0,2-1-.9-1.5.8-2.5.3s-1.9-1.2-2-1.3c-.9-1.1.9-.9,1-1,.2-.2-.4-2.2,1,0,0,.7-.6.5-1,0,.5.4,1,.4,1.5,0,0-.1-.1-.6.1-.9.9-1.1,1.5,0,1.9-2.6.4-.5.6-.2.7.7-.3-1.4-.3-3,1.3-2.2Z"
          fill="#039dfb"
        />
        <path
          d="M313.2,170.3c.4,0,1,0,1.5,0l-1.5,2,2.5.5c-2,2.9-2.4-.6-3.1-1.4s-.7.2-.9.2c-1.1-.4,0-.7,0-.8,0-.6.6-.8,1.5-.5Z"
          fill="#039dfb"
        />
        <path
          d="M310.2,164.3c.2.1.3.4.5.5,0,.3,0,.7,0,1l-1.2-1c-1,2.1-2.9,1.4-3.7-.5,1.6.2,2.9.5,4.5,0Z"
          fill="#0274f1"
        />
        <path d="M310.7,170.8c-.2.1-1.1,0-1.5,0l1-1.5-1.5-1.5c1.4-.2,3,2.3,2,3Z" fill="#0271f1" />
        <path d="M308.7,171.8c.5,0,1.3-1.4,2,.5l-2,.5c0-.1-2.9-.5,0-1Z" fill="#0366f1" />
        <path
          d="M312.2,167.8c-.8.1-1.7.8-2-.5l2.5-.5c.2.1-.4.7-.5,1,.5,0,1.8-.7,2-.5.8.8-1.2,1.6-2,1.5,0-.3,0-.7,0-1Z"
          fill="#027bef"
        />
        <path d="M312.2,164.8c-1.2.2-1.1-.4-1-1.5.9,0,.8,1.1,1,1.5Z" fill="#0372eb" />
        <path d="M314.7,168.8c0,.2,0,.3,0,.5l-.3.5h-1.2c.1-.7.9-.9,1.5-1Z" fill="#027bef" />
        <path d="M313.2,170.3l-1.5.5c0-.3-.1-.9,0-1,.3-.3,1.2.4,1.5.5Z" fill="#0277f4" />
        <path d="M306.7,163.3l-1.5-.2c.7-.9,1.1-.8,1.5.2Z" fill="#036ff3" />
        <path d="M314.7,175.3h.5c-.7,1.1-.8,1.4-1.5,0h1Z" fill="#0379f9" />
        <path d="M310.2,166.3c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#027bef" />
        <path d="M313.2,165.3c0,.3.2,1-.2,1-.5,0-.1-.7-.2-1h.5Z" fill="#026ce7" />
        <path
          d="M330.7,187.3c.4.1.4.3,0,.5.6.7,1.2,1.1,2,1.5.4.2.4.3,0,.5-.2,1.2.5,1.5,1.4,1.3v1.2c0,.3,0,.5-.4.5,1.7.5,2.4,1.1,1.9,1.8,1.6,1.6,1.8,2.7.6,3.2-2,0-2,.2,0,.5l.7-.8c-.3-1.3,0-1.6.8-1.2.4-.3.4-.7,0-1-.4,2.5-2.6-.3-2.1-1.4s2.2-1.4,2.6-1.1c.2.2.4.2.5,0,.2-.4.3-.4.5,0l.5-.5c-1.3-.1-1.3-.4,0-1-.4-.1-.4-.3,0-.5.6-1.1,2.5,1.1,1,1.5.4.2.2.4-.5.5,1,1,.3,1.8-1,1.5.9.6,1.2,1.6,1,2.6l.5.4c.3-1.1,1-1.2,1.3-.2l.7-.3c.1-.4.3-.4.5,0,.6.3.4,1,0,1.5.6.2.5.8,0,1-.3,1.4-.5,1.3-1,0h-2.2c.5,3.4-5,2.3-5.8,0-.4,0-.5.2-.5.5.7,0,2.3.4,2,1.5.4.1.4.3,0,.5-.2.5-.5.8-1,1,1.2,2-1.9,1.9-2.1-.4-.3,1.6-2.6,1-2.9-.1v-.5l-.3-.6c.9-.1,1-.6.8-1.4-1.9.8-1.8-2.4.5-1l.3-.2c-.9-.4-1.4-1.5-.3-1.8-.2-.5-.7-1-1.5-1.5.8,0,1.3.7,1,1.5-.1.4-.3.4-.5,0,0,2.8-3.5.8-3.2-.8s2.2-2.5,2.7-.7c-2.7-.4-.8-4.3,1-1.5.9.1.7-.2-.5-1-2.6-.4-3.4-1.4-2.5-3,.2-.1.3-.4.5-.5.9.9,2.1.4,2-1.5-.8,0-.6-1,0-1.5.7-.8,1.5.4,1,1Z"
          fill="#0493f9"
        />
        <path
          d="M343.7,198.3c-.5-2.4-.9-5,2.1-2.1-.4.6-.6,1.1-.6,1.6-.6.4-.4-1.5-.2-1.8s3.5,1.1,1.2,1.8c0,.9-.5.6-1,0,.8.2,1.2.4.5,1,0,1.2-.8,2-2,1.5-.8.6-1.2-.4-.5-1l.5-1Z"
          fill="#0493f9"
        />
        <path
          d="M318.2,189.8c0,.3,0,.7,0,1,.8-.6,1.8-.6,2,.5.3.8.8,1.2,1.5.5.1,0,.5-.7,1.2-.5s.3.8.4.9c.3.1.9-.4,1.4-.1s0,1.5,1.5,1.3q.6.5,0,0c0-.5-.5-1.3-.5-1.7s.7-.3.8-.4c.3-.6-.3-.6.7-1.4-.2,2,2.6,1.7,3,2s-.5.8-.5,1c.7.2,1,.5.5,1-1.8-.9-1.4.2-1,1.5-.5,0-1,0-1.5.2-.9.5.7,1.8.8,1.8.5,0,.9-.5,1.2-.5.4.6.7,1.2,1,2-1.9-.1-.4.6-.5,1v1c-1,.7-1.7,1.2-2.5,2l.7.8c2-1.4,5.1-.4,2.3,1.1,1,.3,1,.7,0,1,0,1.7-1.3,1.3-2.3.2l-.7.3c-.1.4-.3.4-.5,0-.8.9-1.2,1.2-1.5-.1.8-2.2-.5-2.1-2.1-1.1l-.4-.3c-1.8.7-1.5-1.9.5-1,.9-.8,1.1-1.3.5-1.5-.7.4-1.9-.2-2-1-.4-.1-.4-.3,0-.5-.2-1.3.1-1.5,1-.5.7.4.9.4.5,0-.4-.1-.4-.3,0-.5.2-1.1,1.3,0,1.3,0-1.3-.5-2.3-1.3-3.3-2-.4-.1-.4-.3,0-.5-.5-.7-.5-1.6.5-1.5.1-.4.3-.4.5,0,.4-.2,1.6-.5,1.5.5.4,0,.5-.4.5-1-.7.7-1.3.8-2,.5-.8-.6-1.7-1.1-2.5-1.5-.4-.1-.4-.3,0-.5-.4-.1-.4-.3,0-.5-.8-1.4-2.3-.9-2.7.5-3.5-1.8,0-1.4.7-4Z"
          fill="#0389f9"
        />
        <path
          d="M334.7,182.8c.8,1,.3,1.4-1.6,1.3l-.9,1.7c-.3,0-1,.8-1.5.5s.4-.5,0-1c-.7-.7-1.9-.8-2.5-1.8.3-.8,1.1.1,1.5.3.6-.3,1.4-.5,2-.5.3-.1.8-.5,1-.5,0-1,1.6-.8,2,0Z"
          fill="#05a6fb"
        />
        <path
          d="M321.2,191.8c.1,0,.4,0,.5,0l.5.2-.7,1.3c-2.6-1.5-1.2-1.3-1.3-2h.5l.5.5Z"
          fill="#0379f6"
        />
        <path d="M313.7,183.8c-.3,1,.8,1.8-1.5,1.5-.3-.7.4-1.1.5-1.5h1Z" fill="#0362e7" />
        <path d="M319.2,177.8v1c-.2,0-.3,0-.5,0-.8,0-.8-1.4,0-1.5.7-.6,1-.4.5.5Z" fill="#0475f0" />
        <path d="M307.2,169.8c0,0,0,2.1-1,1s.9-.9,1-1Z" fill="#035bf1" />
        <path d="M304.7,169.3c2.2-.7,1.4.6,0,.5v-.5Z" fill="#046beb" />
        <path
          d="M317.2,186.3c0,.6-.8,1.6-.5,2.5-.1.1-1.9-.4-2-.5-.9-1,1.9-1.9,2.5-2Z"
          fill="#0367ec"
        />
        <path
          d="M320.2,193.3c0,.1,0,.3,0,.5-.9.2-.9.3,0,.5.3,0,.8-.6,1.7,0s.7,1.4.8,1.5c-.1,0-.3,0-.5,0-.6.3-.7.8-.5,1.5v.5c1.3.4,2,1.1,2,2v.5h-.5c-.2,0-.9.6-1,.5q-.5-.8,0,0c0,.1,0,.4,0,.5.5.9.9,1.1,2,1,1.2-.4,2.3-.4,3,1-1.1-.4-2.7.6-3.5.5-1,1.1-2,.4-2-1-.5.4-.7.1-.5-.5-.7.9-1.2.9-1-.2-2.2.1-3.4-1.3-2.5-3.3.6-.7,1.3-.4,1,.5.3.2.3.3,0,.5,1,.2,1.2.2.5,0-.4-.1-.3-.6,0-1-.4-.3-1.1-.5-2-.5-.2,0-.4,0-.5,0-.3-.5-.5-.7-1-1,0-.1,0-.3,0-.5-.3-.2-.3-.3,0-.5.2-.2,3.3-.6,3.4-.5.3.3-1.2.8-1.4,0,.4-1.3.8-2.9,2.5-2.5Z"
          fill="#037ff6"
        />
        <path
          d="M315.7,196.3c-.3-.5,0-1.1.5-1,.5-.7.8-.3,1,.5.1,0,.3,0,.5,0,1.5,0,.8-1.4,1.7-1s1,1.7,0,2-2.5-.7-3.7-.5Z"
          fill="#035cec"
        />
        <path
          d="M314.7,192.8c.5.9,3.1,1,2.5,3-.3,0-.7-.4-1-.5-.4.5-.5.4-.5-.5-1.3-.6-1.3.7-2-1.5v-.5h1Z"
          fill="#0480f4"
        />
        <path d="M316.2,195.3c-.5.2-.5.6-.5,1s0,.3,0,.5h-.5l.5-2c.2,0,.4.4.5.5Z" fill="#036ef3" />
        <path
          d="M317.2,198.3c.1,0,1.9-.6,2-.5,0,.3,0,.7,0,1,0,.4-.2.5-.5.5-.3-.1-.7-.5-1-.5.4,2.6,1.5,2.4,3.5,3.5-.3.6-.2.8.5.5.6,0,1.8,1,2,1-1.4.5-.5.9-.5,1,.6,0,.6.6,0,1.5.7.9.7,1.1-.5,1-.2.9-.6.8-1,0-.8,1.2-1.3,1.4-1.5.5-.3-.8-.7-1.4-1-2s.2-.8,0-1.2c-.2-.5-1.2-.2-1-.6.3-.9,1.9-.9,2-1.7-2.3.2-2,.9-3.5-1,.1-.8.6-1.4,0-2.5.3,0,.7,0,1,0,0-.2-.3-.4-.5-.5Z"
          fill="#0368f0"
        />
        <path
          d="M323.7,209.8c.2-1.3.6-1.3,1,0,.6,1.3,0,1.8-2,1.5-.1,0-.4,0-.5,0-.6-.5-.8-.9,0-1,.2-1.4.5-1.7,1.5-.5Z"
          fill="#036ef3"
        />
        <path
          d="M321.2,208.3c.5.3.7.9.5,2,.1-.2.3-.2.5,0v1c-1.7-.4-1.5-2.4-2-3.5.5,0,1-.4,1.5-.5,1.1.7.9,1.1-.5,1Z"
          fill="#035ef1"
        />
        <path
          d="M325.2,209.8c1.4-1.2,1.4.7,1,2-.7.2-1.4.9-2.5.5,1.1-1.5-.4-1.5-1,0,0-.3,0-.7,0-1,.6-.1,1.5-1,2-1.5.1-.4.3-.4.5,0Z"
          fill="#0356ed"
        />
        <path d="M315.7,197.3c1.1-.1,1.1,0,1,1-.5-.2-.8-.5-1-1Z" fill="#0368f0" />
        <path
          d="M302.7,170.3c-.6-1.2-2.2-2.4-2.5-2.9-.6-1.1-.3-2.9-1-4.1l-.5-.5c0-.2,0-.4,0-.5.1-.4.3-.4.5,0,1.1-.2,2.2,2,2.7,3s1.5,4.2.8,5Z"
          fill="#c2f6ed"
        />
        <path
          d="M298.2,156.8c1.4.2,2.9.3,4.4.3.5-1.5,2,1,1.6,2.2.4.1.4.3,0,.5-.4.9-.7,1.2-1,1-.5-.1-1-.2-1.5-.5,1,2.6-.4,1.8-.5,2.3-.2.8,1.5,1.3,2.2,1.3s.3-1.8,1.3-1,0,1.4,0,1.4c-.4.4-1.8.2-1.9.9s.8,2.6.5,3.7c1.9-1.4,1.3-2,0-3.5,2.4-.8,1.8,1.2,2.5,1.5,0,1.4-1.4,1.4-2,2.5s-.1,1.2,0,2h-.5c-.2-.6-.3-.7-.5-1-.4-2.9-2.5-5.5-3.5-8-.8-1.4-2.1-4-1.5-5.5.1-.4.3-.4.5,0Z"
          fill="#076ced"
        />
        <path d="M304.2,159.8l-.5,1h1.5c-1.2,1.1-1.2.2-2,0l1-1Z" fill="#039cf9" />
        <path d="M300.2,158.3c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#039cf9" />
        <path
          d="M328.2,212.8c1.1-.2.4,1.2.4,1.1.5-2.8,1.6-1.2,2.7.6,1.9-.3,1.5,2.8,0,1.8-.7.4-1.4.8-2.1,1-.3.3-.8.7-1,1-.1.4-.3.4-.5,0,0-.3,0-.7,0-1,.6-.3,1.7-1,1.5-1.7s-1.5-1.6-1.6-1.7c-.6-.3-1.6,1.3-1.4-.3l1.5-1.3c0,.2.4.3.5.5Z"
          fill="#0380f7"
        />
        <path d="M324.2,216.3c-.2-.2.9-1.3,1.5-1,.2.2-.9,1.3-1.5,1Z" fill="#026ff6" />
        <path d="M299.2,153.3c-.2.4-1,.5-1,.5.5-.5.6-.3,1-.5Z" fill="#0383f5" />
        <path
          d="M284.2,109.4v.5c2.3-2,5.6-1.5,3.8,1.8-1.9-.4-.2-.4.4-.2,2.7,1,2.4,1.3.2,2.9,0,.7-.2,1.4-.4,2.1,2.9.6.6,3.9-.8,3.2s1.6-1,1.2.2c.1.9.3.9.5,0-.4-2.2,1.4-4.3,2-1.5.1-.4.3-.4.5,0,1.2-.3,1.4.1.5,1-.4,1.5,1.9.4,2.7-.5,2.6-.3,4.2,3,.9,3.8-.2,2.6-1.5,2.2-3.5,1.6-1.2.5-2.2.7-3.1.6-.2.4-.3.4-.5,0-1,.5-.9-.1-.5-1l-.3-.4c-.5.8-1.1,1.3-1.7.4-.1-.9,0-2.4,0-2.5s-1.2.6-1.5-.2c.1-.2.4-.5.5-.7-.4-.1-.4-.3,0-.5-.1-.8-.3-.9-.5-.5-.1.4-.3.4-.5,0,0-.4-.4-.7-.5-1-.2-.5-.3-1-.5-1.5.3-.4.6-.7,1-1,0,0-.6-.9-.5-1l2-1c-2.7,1-1.5-.8-1.9-1.9-.7-1.9-1.4-.7-2.1-.6l-.5-.5c0-.1,0-.3,0-.5.2-.4.2-.8,0-1v-.5c.8.3,2.1.3,3,.5Z"
          fill="#0393f7"
        />
        <path d="M284.2,115.9c.1,1.1,0,1.1-1,1,0,0-1-.1,0-.8s1-.2,1-.2Z" fill="#0364e8" />
        <path d="M282.7,112.4c0-.2-.6-.9-.5-1,.6-.4,1.5,0,.5,1Z" fill="#0a72dd" />
        <path d="M281.2,110.4c0-.3,0-.7,0-1l.5.3-.5.7Z" fill="#0487f0" />
        <path d="M280.7,111.9c.2-.2.8.5.2.5s-.4-.4-.2-.5Z" fill="#0487f0" />
        <path d="M281.7,111.4c-.5,0-.4-.2-.5-.5l.5.5Z" fill="#0487f0" />
        <path
          d="M286.2,123.9c1.1-.6,2.1-.2,1-1.8,2.1-.9,1.6.3,1,1.8.3.4-.2,1.3-.5,1.3s.7-1,1-.3c.1,0,.4,0,.5,0l.5.3c.3,1.2-.6.5-1,.7-.5,0-.7.3-1,.5-1.8-.4-1.3-.9-1.5-2.5Z"
          fill="#0383f3"
        />
        <path
          d="M285.2,119.9c0,.1,0,.3,0,.5-.3,0-.7,0-1,0s-.4-.3-.5-.5c.2-.1.4-.5.5-.5s.3,0,.5,0c.7-.6.7-.4.5.5Z"
          fill="#0250d5"
        />
        <path
          d="M332.7,213.8c0,1,0,2.6.5,3.5-.3,2.1-2.7,2-4,.5v-.5c1.1-1.2,1.1-1.5,3-1.7-.5-.9-1.6-.5-2.2-.8s.5-1.2.2-1.5c-1-1-1,2-2,1s.1-1.2,0-1.5c1.2-3.6,2.3.8,3,1.3s1.1-.3,1.5-.3Z"
          fill="#0363f1"
        />
        <path
          d="M329.2,217.8l2.2-1-.7,1.5,2.5-1c0,.2.3.4.5.5-.3,1.7-2.8,3.1-3.2,1l-.3,1.5c-2,.4,0-1.6-1-2.5Z"
          fill="#037df9"
        />
        <path d="M328.2,218.3c-.2.3.3,1.4-.3,1.5-1.6.4-.3-1.2-.2-1.5h.5Z" fill="#024ce9" />
        <path
          d="M217.2,115.9c.4.1.4.3,0,.5q-.2.2,0,0c.6-.7.8-.4.5.5,0,.1,0,.4,0,.5v1c0,.1,0,.3,0,.5-3.2-.4-.3,1.8-.5,2s-.7,0-.9,0,.7,1.5-.4,1.9.3-2.1-1.2-1.5v2.5s1.5-.5,1.5-.5c.7.7-1,1.6-1.7,1.5s-.3-1.5-1.3-1c-.6-1.3-1.4-2.4-2.4-3.3v-1.2c-1.4-.3-1.4-.6,0-1-.5-.8.4-1.3,1-.5.4.3.6.4,1,0,.2-1.4.5-1.2,1,0,.7,0,1.4-.2,2-.5-1.6-1.2,0-1.6,1.5-1.5Z"
          fill="#0479f0"
        />
        <path
          d="M220.2,110.9c.2.6.3,2.9,0,3.5l-1,.5c-.2.2-1.3.7-1,1,1.9-.1,1.4,1.4-.5,1-.2-.2-.4-.4-.5-.5s0-.4,0-.5c0-.4-.4-.8-1-1-.4-.1-.4-.3,0-.5-.3-1.4,2.1-2.1,2.5-1-1.3,1.5.6.3.5-.5l-1-.5c-1.3-.2-1.2-.5,0-1-.2-.7.3-1,1.5-1,.5-.4.6-.1.5.5Z"
          fill="#066ae5"
        />
        <path d="M217.7,117.4c0,.1,2.9.4,0,1,0-.2-2.2-1.1,0-1Z" fill="#066ae5" />
        <path d="M220.2,114.4c-.2.4-.6.5-1,.5.4-.3.9-.4,1-.5Z" fill="#0476ec" />
        <path
          d="M222.2,107.4c-2.1-.8-2.3,2.6-1.5,3.5h-.5c-.1-.3-.3-.4-.5-.5-2,.9-3.2.5-3.5-1,.9,0,1.3-.4,1.1-1l1.4-.5c-.1-.5,0-.7.5-.5.1,0,.7,0,1,0l-.5-1,2.5-.5c0,.5,0,1.1,0,1.5Z"
          fill="#127eec"
        />
        <path d="M225.7,97.9c-.2-.2.5-.8.5-.2s-.4.4-.5.2Z" fill="#2076e8" />
        <path
          d="M222.7,89.9l1-.9c-.1,1,.5,1.3,2,.9,1.1,1-.3,4.4-.5,5.7s.5,2.2.5,2.3c0,.8-.5,1.4-1,2-.7,0-1.4,0-1.5,0-4.2.8-1.9-2-.2-3.5.7.8.2.6-.3-.4-1.4-1.9-2-3.2-.6-5.5s.4-.4.6-.5Z"
          fill="#2076e8"
        />
        <path
          d="M219.7,82.4c-1.4.4-1.5-1.9-.6-2.2s4.7,1.4,4.6,2.2c1.3.9,1.4,1.8,2.3,3,.2-.4.5-3.4,1.7-2.5s-2.1,1.3,0,2c-.2.2.4,1.4-1.5,1l.5,1.5c-.2,0-.3,0-.5,0-1.8.6-2.1-1.1-2-2.5-3,2.4-8.6.3-4-2v-.5c-.1.4-.3.4-.5,0Z"
          fill="#3d82ed"
        />
        <path
          d="M226.2,87.4c-.8,0-2.6,1.8-2,2.5s.6-.8,1.5,0l-1.2,1.5c-.7-.6-.6-1.8-1.7-1.5-.2-.8-.4-1.7-.5-2.5-.6-1.5,0-2.3,2-2.5.9.9,1.3,1.5,2,2.5Z"
          fill="#2d7ced"
        />
        <path d="M217.7,79.4v.5c-.2.7-.6.5-1,0-.5-1.2.1-1.5,1-.5Z" fill="#4c87ee" />
        <path
          d="M219.2,79.4c.2-.2.4-1.1,1-1v2c2.6-1.4,1.7,1.3,4,1-.2.2-.3.7-.5,1-2.1-1.4-3.4.3-4.2-2l.3,2c.3.7-.4,1.2-1,.5-.2-.2-.5,0-1,.5-.1.4-.3.4-.5,0-.5-.6-.8-.8-1-.5-.1.4-.3.4-.5,0-.3.3-.6.3-1,0l-.9.4c2.2.3-3.5,1-.6-.9-1.1-.4-1.5-.9-1-1.5-.8,0-1.4-1-.5-1.5.1-.5.3-.4.5,0,.7-.6,1-.3.5.5,1.4-.9,2.1-1,2-.3.8,0,1.5,0,2,.3.5.5,1,.5,1.5,0,.2,0,.4,0,.5,0l.5-.5Z"
          fill="#4c87ee"
        />
        <path d="M217.7,79.9c.2,0,.3,0,.5,0-.5,1.2-1,1.2-1.5,0,.3,0,.7,0,1,0Z" fill="#4d7ae7" />
        <path
          d="M212.7,78.4c.4,0,1.5-1,2.5-.5l-.5,1.2c1.1,1.3,1.3-1.2,1.8-1.2s.9,1.1,1.2,1v.5c-.4,0-.7.3-1,.5-.9.5-1.3,1.1-1.7,1s-.9-2.7-1.3,0c-.3.3-.8-.9-1-1,.1-.5.1-1,0-1.5Z"
          fill="#4d7ae7"
        />
        <path d="M218.7,79.9c.1,0,.3-.4.5-.5l-.5.5Z" fill="#4d7ae7" />
        <path
          d="M212.7,123.9c0,.1,0,.3,0,.5-.7,1.5-1,.8-1.5-.5.7.5,1.1,1.2,1,2,0,0,.4.5.3,1-.5,1.9-.3,1.5-.3,3,.5.4.6.7,0,1,.3.2.3.5,0,1,.4.1.4.3,0,.5v.6c-1,.3-1.8.7-2.5,1.4-.1.4-.3.4-.5,0-.7-.5-.4-1.4.5-1.5-2.8-.3-1.9-3.4.5-2.5q1.1.7,0,0c-1.5,0-2.2-.4-2-1.5-1.7.1-3.4-2.6-1-2,.7-.8,1.7-1.3,3-1.5l-.5-.5c-.5,0-.8-2.1-.8-2.2.9-1.6,2.1-.4,2.3,1.2-2.2-2.8,2.4-3.2,1.5,0Z"
          fill="#037ef1"
        />
        <path
          d="M213.7,132.3c0,.5-.4.7-.5,1-.5.1-.6,0-.5-.5-.7.5-1,.2-.5-.5v-.5c.3-.4.3-.8,0-1,0-.3,0-.7,0-1,1.1.5,1.6,1.3,1.5,2.5Z"
          fill="#0356dc"
        />
        <path
          d="M212.7,124.4c.1.3.4.7.5,1-.4,0-.9.1-1,.5l-1.5.5c1.2-1.2.5-1.6.5-2.5.5.2.9.5,1.5.5Z"
          fill="#0592f4"
        />
        <path
          d="M213.2,133.3c0,.1,0,.4,0,.5l-.5.5c-.4,1.7-.9,3.4-1.5,5s-.6,1.3-1,2.5c-.5,1.6-1.2,2.6-2,3-.6-.1-.4-.5,0-1-.6-.3-.7-.9,0-1-.2-.5.1-1.7.5-2-.6-1.1-.1-2.3,1-2,0-.6.2-1.1.5-1.5-1.1-.6-1.3-1.1-.5-1.5.1-.9.2-1.1.4-.4-.5-2.1,1.1-2.5,2.6-2.6.2.1.3.4.5.5Z"
          fill="#0864de"
        />
        <path d="M212.7,134.3c0-.2.3-.4.5-.5,0,.2-.3.4-.5.5Z" fill="#0469e8" />
        <path
          d="M200.2,164.3c-.7,1.8-1.5,4.1-2,6-1.2,2.5-2.4,5-3.5,7.5-1.6,2.6-3.8,1.8-4.5-1-.4-.1-.4-.3,0-.5,0-.9.8-1.5,2.4-1.8-.7-3.2,0-4.3,2.4-3.4-.2-1.1.2-1.7,1.2-1.8.1-.4.3-.4.5,0l.5-.5c-.4-.1-.4-.3,0-.5v-1.5c-.8-1.5,1-3.1,2.5-2.5.1-.4.3-.4.5,0Z"
          fill="#044ee5"
        />
        <path
          d="M189.8,189.3c-.3.9-.5,2.5-1,3.5-.7,1.1-1,2.3-1.5,3.5s0,.4,0,.5l-.5.5c-.9,2.2-1.3,4.7-3,6.5-.8-.1-.7-.6,0-1-1.5.9-2.1.7-2-.5-.6-.3-.2-1.2,1.3-2.7-1.7-2.1-1.5-3.1.7-3.3.1-.4.3-.4.5,0l.7-.6c-.7-1.8-.4-2.1,1.3-2.4-.4-.9,0-1.2.7-1.5-1.8-1-1-3.3.8-2,.2-2.4,2.7-3,2-.5Z"
          fill="#0444df"
        />
        <path
          d="M190.3,176.8c.6,0,1-.3,1.5-.5v2.5s1-1.5,1-1.5l1,1.2,1-.7c-.5,1.1-1,2.4-1.5,3.5-.8-.2-.2-.4-.2-.3-.3.7-2,4.4-2.3,4.4-.6-.4-1.3-.5-1.9-.6,0,.9-1.8-.5-1.7-.6,1.3-.7,2.1-1.9,2.2-3.4-1-.2-1.3-1-1.1-2.3-2.9-2.2-.1-2.8,2.1-1.7Z"
          fill="#0364f2"
        />
        <path
          d="M193.3,181.3c-.8,2-1.7,4-2.5,6-.9,1.5-2.7,1-1.5-.5-.8.5-.7-.3-.5-1-.7,0-.7-.7,0-1,1.2-2.5,1.7,0,1.7,0,1-1,.1-1.4.4-1.9s.7-.2.9-.5,1.5-3.6,1.5-1.1Z"
          fill="#054fdf"
        />
        <path
          d="M189.3,180.8c.1,1.5,1,2.5-1.5,3-.3.4.9.9,1,1s0,.8,0,1c-.3,1-.1,1.3.5,1,.2,0,.5,1.5,1.5.5-.3.8-.8,1.6-1,2l-.2-1c-1,.8-1.6.1-.7,1.5-.3,0-.8,0-1,0-.9,0-1.1-.4-1-1.2-1.6,0-1.7-.9-.5-1.8-1.9.7-2.5-1.5-.4-2.4.6-1.2,1.4-2.4,2.4-3.1-.4-1.4,0-1.6,1-.5Z"
          fill="#0255eb"
        />
        <path
          d="M182.3,207.8c0,.1,0,.4,0,.5l-.5.5c-.5,1.5-.7,3.7-1,4.5-.6,1.5-2.4,3.7-3,5.5-1.6-2.5.4-2.4.9-3.1s.1-1.8.1-2.1c0-.5-1.7-.3-2-1,0-.2.7-.5,1-.7-.1-.8-.5-1.5-1-2,.1-.3.3-.3.5,0l1.5-.5c-.1-1.7.3-2.5,2-1.5,0-1,1.7-1.8,1.5,0Z"
          fill="#0a4ee1"
        />
        <path
          d="M178.3,206.3c1.1-1.3,2.2-1.9,3.4-1.8,0-1.2.7-.8,1.1.3.5-.5.6-.3.5.5-.3,1.1-.7,1.7-1,2.5-.7-.6-1,0-1.5,0l-2-.5c-1.4,1-2.1-.4-.5-1Z"
          fill="#0551e9"
        />
        <path
          d="M183.8,203.8c0,.6-.4,1-.5,1.5-.2,0-.5-.3-.5-.5-1.6-.1-.9-.7,0-1.5l.5-.5h.5c0,.3,0,.7,0,1Z"
          fill="#0a43c8"
        />
        <path d="M181.8,208.8l.5-.5c0,.2-.5.4-.5.5Z" fill="#0551e9" />
        <path
          d="M234.2,405.2c-.8-3.1,3.9-.8,4.7.8,1.6,3.2.2,3.1-2.6,2.9l-1.1.4q-.8.8,0,0c.7-.5,1.7-.6,3.1-.3,2.3-2.9,5,.4,3.4,2.8.6.1.9.6,1,1.5.7-.7,1-.4.5.5-.2,0-.4,0-.5,0-2,.7-1.3,1.3-1.5,1.5l-1-2c-1.1.3-.5,1.9-2,1.5.3-1.5-.5-2.7-1-4-1.1,0,0,1.4,0,1.8s-1.1-.2-1,1.2h-.5c-.5-.4-1-.9-1.5-1.5-.2,0-.3,0-.5,0-1-1.2-1-2,0-2.5-2-.7-2.7-1.5-2-2.5-.2-.7-.1-1.8-.5-2.5.5-1.8,2.4-1,3,.5Z"
          fill="#023495"
        />
        <path
          d="M231.7,407.2c.8,2.2,1.8.8,2,2.5,0,1.1-1.9.6-1.2.2s.6.2-.3.3c-1.4.4-1.8-2.3-.5-3Z"
          fill="#0241a0"
        />
        <path
          d="M233.7,409.7c.1.8,0,1.7,0,2.5-1.3,0-1-.1-1-1.5-.7.2-.7,2.2-1.5.2s.7-.4,1-.7,0-.7,0-1l1.5.5Z"
          fill="#022e86"
        />
        <path
          d="M234.2,412.2c.2,0,.7-.8,1.5-.5-.3.7-.6,1.3,0,2-1.1.3-1.1-.6-1.5-1.5Z"
          fill="#022e86"
        />
        <path
          d="M236.7,406.2c.3,2.7-.6.9-1.7,1s-.8,2.1-2.3.5,1.8-1.1.5-2c1.4,0,2.1,1.4,3.5.5Z"
          fill="#0241a0"
        />
        <path d="M241.7,411.7c.2.1.9-.1,1,0s0,1.1,0,1.5l-1-1.5Z" fill="#02328c" />
        <path
          d="M240.4,407.5c.3.3,1,0,.8.7-1.6.3-2.5-1-2.5-2.5.8.3,1.2,1.2,1.7,1.8Z"
          fill="#023495"
        />
        <path
          d="M149.3,103.9c.2.3.3.6.2.8-.3.4-2.1.1.5-.2s.4.4.3.9c.3.7-.2,1.6-1,1.5-.4.1-.8.6-.9,1.3l-1.5-.8c-.3,1-.7,1-1,0-.7,1.1-1.3,1.6-2,1.5-.7,1.2-1.4,1.5-1.9.9-.7.8-1.2.9-1.6.1-.7,1.3-.8,1.3-1.5,0,0-.3-.5-.7-.5-1,.9-.1,1.2.4,1-1,1-.2,1.4.7,1.5.5-.6-1.2,1.4-2.2,2.4-2.4s1.5.4,1.6.4c.1-.1-.1-.8,0-1,1.5-2.4,2.3-1.3,4.5-1.5Z"
          fill="#0d50e3"
        />
        <path
          d="M161.3,97.9c2.2-1.2,2.7,1.5.5,2.5.3,1.5-.5,1.6-1.5.5-.2.8-2.2-.7-2.1-.9s2.3,1.4,1.6,1.9c.2,1.4-1.4.9-2,0-.8.7-3.1,1.2-3.5,0-.7,0-.5-.5.5-1.5,0,0,.2-.5.5-.5,0,0,.4,0,.5,0l1-.5c.7-.2,4.3-1.3,4.5-1.5Z"
          fill="#1562e5"
        />
        <path
          d="M149.3,103.9c.2-.5-.1-1.4,0-2l1.2,1.5,1.7-1.7-1-.3c1.3-2.6,1.5.8,2.5,0s-.5-.3,1-1l-.5,1.5c1.2.8.1,1.8-1,1.5-.1.4-.3.4-.5,0-.2.3-.3.3-.5,0,0,1.5-2.4,1.6-3,.5Z"
          fill="#1655e2"
        />
        <path
          d="M130.8,148.3c3.6-2.4,4.6-2.6,3.1,2l-.6.5c.8,1,1,1,.5,0-.3-.7-.2-1.2.6-1.3-.5-.7-.7-2.7-.2-2.9s.9.2,1.1.7l.6.6c.9-.4,1.2,0,.9,1.4.3-.2.6,0,1,.5,0-.9.4-1,1-.5,1.4-.5,1.7,0,.5,1-.2.5-.5.8-1,.5l-.2.7c-1-.3-1.8-.2-2.3.3v1.2c-1.7.5-2.9,4.8-.5,3.3-.3-.7-.3-1.1.5-1,.8-.3,1-.2.5.5.2-.3.3-.3.5,0,.5.1.5.3,0,.5,1.3.8.9,1-.5,1,.4.7.3,2-.7,1.2-.9.6-1.7,1.2-1.8,2.3l.4.9c-.1,1.3-.4,2.3-.9,3.1.2,2.9-3.6,2.3-3-.8.9.2,1.4.1,1-.7-1-.1-1-.8,0-1q.8-.5,0,0c-.3.5-1.2.4-2.8-.5-2.3,1.3-2.5.4-.7-2.5-1.1-1.7.5-1.1,0-.5s-.4.3-.6.5c.4.6,0,1.6-.7,2.1.8.7.6,2.1-.3,2.4,2.3,1-1.4,2.2-1.7,1.3s.2-1.4.7-1.3c.2-.2.2-.4,0-.5-.9-.2-1.4-.2-1.5,0,.9.7-.6.9-1.5,1-3,0,.2-5.2,1.5-2.5.2-.4.5-.7,1-1,0-.9-.2-1.7-.5-2.5-.9.3-1,.3-.5-.5.1-.1-.1-.9,0-1s1.1.9,1.7,1c1.3.2.6-.8.8-1,.1-.7,1.7-1.2,2.4-.9-.9-1.2-.5-3.2,1.1-3.1h.5c.7,1,.7.5,0-1.5,0-.9.8-.7,1.5-.5-.4-.9-.7-1.4-1-1.5-1.1,0-1.1-.6,0-1Z"
          fill="#025cef"
        />
        <path
          d="M117.3,157.8c-.3-2.5,3.2-1.2,2.5,1,1.9,1.8,1,.6,2,0,0-.6.4-.8,1-.5.2-.2.8-.3,1-.5.2.1.4.5.5.5.4.5.2.7-.6.7l-1.4,1.3c.7.5.4,1.1-.9,1.9,0,1.1-.1,1.5-.6,1.1-.7.3-1.4.3-2.1,0-2.3,3.2-5.3-1-2.4-2.1q1.4-1.4,0,0c-.8,1.3-1.6,1.1-1.5-.5-.1-.1-1.1-1.4-1-1.5,1.7.4,2.5-.9,3.5-1.5Z"
          fill="#035cf2"
        />
        <path
          d="M126.8,148.3c0,1.4,1,.9,1,1.3,0,.7-.8,1.9-1,2.7-.2.7-1,.4-1.5,0-.4-.1-.4-.3,0-.5,0,0,1.4.4,1-.7s-1.5-1.5-2.2-.8c-1.2-.8,2-1.9,2.8-2Z"
          fill="#035ff4"
        />
        <path
          d="M125.8,142.8c.5-.7.6-.8.5-.2.9-2.9,2.9.1,2.9,2.1l.7-.4c.4-1.5,1.7-1,1.5.5.5.3.8.9,1,2,.7.6-.8,1.4-1.5,1.5,0,.2,0,.7,0,1-.7,1.3-1.2,1.3-1.5,0-.5-1.1-1.3-1.2-2.5-1,0-1.7,1.4-2.6-2-2.5v-.5c.3,0,.8-.3,1-.5-.7-.5-.2-.8.5-1-.6-.1-.9-.4-.5-1Z"
          fill="#035ff4"
        />
        <path
          d="M125.8,144.8c2.1,0,3.4,2.7,1,3.5,0,.5,0,1.1-.5,1.2,1.2,1.2.5,3.3-1,2.3-.8.2-.8.4,0,.5l1.1.4c1.9-.6,2.6.6,1.9,3.5-1.3-.3-1.9,0-2.1.6,1.7.9-.2,2.8-2,.8l-.5.2c0,.5-.6.8-1,.5-.4,0-.7.2-1,.5.8,2.1-2.7,2.7-2,0,.1-.4.3-.4.5,0v-.5c-1.8-.4-1.4-3.6-.7-1.4-1.8-1.1-2.5-.8-2.3.9-2.4,1.2-3.2,0-2.4-2.3v-1.7c-.2,0-.8-.3-1.1-.5,0,0,1.9-.5,2-.5.9-1.4,2.1-2.5,3.4-3.2l.8-1c.2-1.9,1-4.2,3.3-3.8.7-.3,2.2-.8,2.5,0Z"
          fill="#0254ef"
        />
        <path
          d="M126.8,148.3c.4-2.1,3.8-.9,2.5,1,.7.7.4,1-.5.5l-.5.5c1.5-.3,2.4,1.6,2,2.5-.1.4-.3.4-.5,0-.5.8-1.5.6-3-.5-.2,0-.4-.2-.4-.3,0-.9-.2-3.4.4-3.7Z"
          fill="#0254ef"
        />
        <path
          d="M117.8,143.8c.2,0,.3.6.7.8s1.3.1,1.3.2c0,0-.7,1.4-.5,2,.9.1.8-1.9,1-2,.3-.5,2.2-1.4,2.5-.5h.5c.4.1.4.3,0,.5-1.1.3-3,2.3-2,3.5,1.9.4.3-1.3.5-1.5.6-.6,2.9-.6,2.5,1-2.1-.7-2.3,2.3-2.5,2.5-1.4,1.5,0-1.6-1.2-1-.4,1.6-2.4,1.8-2.5,1.9-.4.7-.1,2-.2,2.1-.2.2-1.5-.5-2-.5-1-1.5-2.6-1-1.5-3.1s.8-.6,1-.9c.2-.4.4-.2.5-1l-.5-1c.2-.4.7-.7,1-1,.5,0,1,0,1.5,0l-1,2.5c1.7-1.7,2.8-1.7.5-3.5-.9-.7-.9-1,0-1,.1,0,.4,0,.5,0Z"
          fill="#0246ec"
        />
        <path
          d="M126.8,152.3c.5-.1,1.4-.5,1.7-.5s.3,1.4,1.3,1c.2.7-1.1,1.8-1,2s.7,0,.9.1-.3,2.2,1.1,2.9c-.6.5-3.6-2.2-4.5-1-2.9-.4,1.9-.9,1.5-1.5l-3.5-.5c2.7-2,2.6,0,2.7,0,.4-.1,1-1.2.8-1.5s-2.4,0-2.5-1c.5,0,1.1,0,1.5,0Z"
          fill="#0368f3"
        />
        <path
          d="M117.3,157.8c-1.6-.8-.6-2.6-.3-4,1.2,1,1,2.5,3,2l-.2,1,2-.5c.5,1.6-2.9,1-1.5,2,.4.1.4.3,0,.5h-.5c-1.3-1.2-.8-2-2.5-1Z"
          fill="#023fe7"
        />
        <path
          d="M125.3,151.8c0,0,0,.4,0,.5-.6,1-.1,1,0,2l-1-2-2.5.7c1.5-.8,1.5-2.6,3.5-1.2Z"
          fill="#0245e9"
        />
        <path
          d="M126.3,143.8c0,.1-.4.8-.5,1-.8.1-1.8-.2-2.5,0v-.5c.3-1,.7-1,1,0,.3-.5.7-.7,1-.5.2-.9.5-.7,1,0Z"
          fill="#023ae7"
        />
        <path d="M122.3,151.3c-1,2.1-3-1-2.5,2l-1.5-1.3,4-.7Z" fill="#023de5" />
        <path d="M123.3,149.8c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#0246ec" />
        <path d="M120.3,158.3l.3-.5c1.3-.2,1.2,1.3-.3,1v-.5Z" fill="#0d7cee" />
        <path d="M122.8,158.3c-.2.2-.7.3-1,.5-.1-1.2.1-1.3,1-.5Z" fill="#0236e0" />
        <path
          d="M110.8,166.8c1.7-1,5.7-.2,3.5,2-.4.5-.5.8-.5,1,.7-.6.9-.3.5.5,1,.2,1.4,1.1,1.4,2.4,2.3.9,1.2,4.1-1.4,5,.5-1.5,2.2-.9,2.1.7s-3.6,1.1-2.1-.7v.6c.9.8-2.2,1.9-2-.6h-.5c-.1.7-.3,1.5-.4,2.4,1.7.2,2.4,2.8.4,2.6-.3.9-3.1.3-3.3-1.1-1.1,0-1.7-.2-1.7-.9,0-.1-1.5.4-1-1,.8.6,1.8,0,2,0,.5-.9.6-1.9.5-3,.8,0,1.2.8,1.8,0,.7-.5-.3-1.3-.3-1.5-.2-1.8-1.2-2.7-3-2.5-.6-1.2-.3-1.8,1-1.5v-.5c1-.6,2.1-.3,3.5,1q1.7-1.2,0,0c-.5.3-2.3-1.2-2.4-1.4-.5-1.2,1.1-5.9,1.9-3.6Z"
          fill="#0343ed"
        />
        <path
          d="M110.3,161.8c-.1.3,0,.2.5,0,.7,0,1.6-.7,2.5-.5,0,.3,0,.7,0,1,0,.4-.3.4-.5,0-.2-.3-.4-.3-.5,0h-.5l-.5.5c.4.1.4.3,0,.5l-.5.5c-.2.3-.3.3-.5,0-.2.9,0,1.3.5,1,0-.5.3-.4.5,0,.4.3.3.7,0,1,1.1.8.8,1.2-.5,1-.1,0-.7,0-1,0l1.5.7c-.3.5-2.2,1.9-2,2.2s.7-.1,1,.3.4,1.9,1,1.7c-2.4.5-1.7-.4-3.5-1-1.5-2.5,1.5-2.9.5-5l-1.7,2c-1.3-1.1.1-3-2.3-2.5,1.6-2.8,1.4,1.2,3,.3s-.7-1.9-1-2.3c-1.7-1.3,1.1-1.9,2.5-2,.6-.3,1.3.5,1.5.5Z"
          fill="#022ee3"
        />
        <path
          d="M107.8,171.3c0,0-.6.9-.5,1,3.2-.1,2.5,1,2.5,3-.5,1.3-.8.2-1,0-.1-.5-1-1.9-1.5-1,.1.7,0,.7-.5,1h-.5c-.3,0-.7.5-1,.5-.8-.4-.9-.8,0-1-1.2-.4-1-.9.5-1.5,0,0,.6,0,.5-.5-.3,0-.7,0-1,0-.4-.1-.4-.3,0-.5.9-.3-.7-1.2-.5-1.5s1.7-1,1.8-1,1.2,1.4,1.2,1.5Z"
          fill="#022ee3"
        />
        <path
          d="M108.3,159.8c.6-.1,3.2-.3,3.5,0,1.5,1.6-2.7.3-3,.5s0,.8,0,1c-.7,1.2-1.2,1.3-.5,3-.8.3-1.9-3.6-2-1-.2-.2-1.4,0-1.5-2h2s-.3-1-.3-1c1.1,1,1.7-.5,1.8-.5Z"
          fill="#0122da"
        />
        <path
          d="M105.3,172.3v.5c-.7,0-1.3,0-2,0-.2-.1.5-.7.5-1,.7-.5,1.3-.4,1.5.5Z"
          fill="#011ede"
        />
        <path d="M108.8,158.3c-1.4-.8-1.2-.8,0-1.5.7.5.3.9,0,1.5Z" fill="#0236e5" />
        <path
          d="M124.8,140.8c.3-.5.6-.5,1,0,1.3-1.3,5.2-.2,2.9,1.8s1.2-2.1,1.6-.8c1.6.6,1,2.1-.5,2-.3-.3-.3-.1,0,.5,0,0,0,1.9-1.5,1.5l.5-2.5c-2.8,1.4-.2-.8-1.7-1.5s-.4,2-1.2,1q-.4-1.4,0,0c.1.2.5.8.5,1-.3,0-.7,0-1,0-.4,0-.7,0-1,.5-.3,0-.7,0-1,0s-.3,0-.5,0c1-1,.4-2.5.5-3s.7-.9.5-1.5c.7-.2.5.8,1,1Z"
          fill="#0350ed"
        />
        <path
          d="M116.3,161.3c-1,4.9,1.5,1.2,2.3,1.1s1.5.7,2.2.9c.9,1.7.7,3-.4,3.8v.7c.7-1,1.3-.8.9.5,0,.4-.1.7-.2.7-.6,0-2.8-.4-3.4-.7.3-1.5,0-2.2-.9-2,.3.6-.4,1.3-1,1.5.4.1.4.3,0,.5.6.6.3.8-.5.5.5.4.5,1,0,1.5,0,1.3-.6,1.3-1,0-.1,0-.5-.5-.5-.5l.5-1c-.5-3.9-1.5.2-3.5-2,.2-.1.3-.7.5-1,.3-.4.3-.7,0-1-.1,0-.3,0-.5,0-.5.2-.9-.5-.5-1,.1,0,.4,0,.5,0l.5-.5c0,0,0-.4,0-.5.2-.2.3-.2.5,0,0-.3.2-.5.5-.5.1-.3.3-.3.5,0,.2,0,.3,0,.5,0,.3.1.3.3,0,.5.4.1.4.3,0,.5,0,.4-.4.4-1,0l.5,1,.5-.5c1.5-1.3,1.8,1,.5,2,.1-.3.3-.3.5,0,.5.8.4-2.4-.5-3-.3-.1-.3-.3,0-.5-.2-.8.4-1.1,1-1.5.5.3.9.4,1.5.5Z"
          fill="#024eef"
        />
        <path d="M110.3,161.8c.2,0,.3,0,.5,0,.1,2.5-3.3,0-.5,0Z" fill="#0221d4" />
        <path d="M113.8,162.8c-.1.4-.3.4-.5,0,0-.2,0-.3,0-.5h.5v.5Z" fill="#0343ed" />
        <path
          d="M125.3,139.8c.1-.3-.2-1.1.2-1,.4,1.2.6.8,1.2,1,1.9.7,1.1-.1,3-.5l-1,1.5c.5.4,1.4-.9,1.5,1-.5,0-1.4,1.5-2,1s1.6-1.1.5-1.8c-.9-.5-2.1-.1-3-.2-.7,0-.7-.4-.5-1Z"
          fill="#0362ef"
        />
        <path d="M125.8,140.8c-.3,0-.8,0-1,0,0-.4.4-.8.5-1l.5,1Z" fill="#0331e4" />
        <path
          d="M136.3,111.4c-.2-.4-1.1-1.4-1-1.5,1.5-.2,2.4.8,3.5,1.5-.3-.5,0-1.3,0-1.5.5,0,1,0,1.5,0,.2.5.6.8,1,1h.5c1.2-.5,1.8,1.7,1,2,0,.9-.9,1.3-2.5,1-.2,0-.7,0-1,0-.5-.2-1-.3-1.5,0,.1.9,2.1,1.4-.3,3l.2-2-2.5.5c-.2-1.4-1-1-1-1.2,0-1.5,1.7-1.2,2.5-1.8l-.5-1Z"
          fill="#0341df"
        />
        <path
          d="M139.3,107.9c2.1.6.4,2.3-1,1,1.4-.1,1.4,0,.5,1,1.6.6-.7,3.2-1,1.2s-1.6-.6-1.5.3c.8,0,1.1.4.5,1-.4,1-.9,2-1.5,3,.5.1.4.3,0,.5-.3,0-.7,0-1,0,0-.2.1-.7,0-.9s-1.8,0-1.8,0c-.8.5-.6,3.2-2.6.6l1-.3c.2-.2-.8-1-1-1.5s0-.3,0-.5l.5-.5c.5-.5,1.1-2,1.3-2,1.5,0,.3.9.2,1.5,2.8,1.4,1-1.4,2-2.2s3.1-1,4.5-1.3c-.2-1.4.2-.9,1-1Z"
          fill="#0946e0"
        />
        <path d="M129.8,113.4c0-.3.2-.5.5-.5-.2.2-.3.3-.5.5Z" fill="#033ddd" />
        <path d="M136.3,111.4h1.5c0,.6-.6.8-1,1-.5-.2-.4-.7-.5-1Z" fill="#1858e8" />
        <path d="M131.8,113.4c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#033ddd" />
        <path d="M139.3,113.9c-.5,0-1,0-1.5,0,0-.5.5-1.4.5-2,.9.2,1,1.2,1,2Z" fill="#0d5aec" />
        <path d="M140.8,114.4v1c-.7.2-1-.2-1.5-.7l1.5-.2Z" fill="#0341df" />
        <path
          d="M133.3,130.3c.2,0,.4.7,1,.5.4.1.4.3,0,.5.4.8.3,1.5-.5,2-.4.7-.9,1.4-1.5,2-1.3,1.5-1-.6-.7-1.9,0,0,0,1.8-.8,1.4l-.5-3-1.5,2c-1.8-.2.1-3.2.5-3.5.9-.6,1.1,1.2,2.3,1.5s.7-.3.7-1c-1.2-1.1,1.3-2.4,1-.5Z"
          fill="#035deb"
        />
        <path
          d="M122.3,130.8c1-1.6,2.8-2,4.5-1.5l-3,1.2c.3.7,1.3-.2,1.8-.2s.5,1.5,1.7.9l-2,2.5c-.2-.1-.4-.3-.5-.5s0-.3,0-.5c.1-.4.3-.4.5,0,.5-.4.7-.7.5-1-.3.5-.7.6-1,.5-.2,0-.3,0-.5,0-.2-.4-.9-.4-1-.5-.3-.2-.3-.3,0-.5-.3-.3-.3-.6-1-.5Z"
          fill="#0238e1"
        />
        <path
          d="M121.8,127.4c1.1.1,1.6.5,1.5,1,1.9.2.3,1.1-.9,1.7-.6,1.6-1.1,1.9-1.6.8-1.1,1.2-1.7,1.4-2,.5q-.7-.9,0,0c.3,1.1.5,1.2.6.4.5,1,1.3,1.4,2.4,1.1.2-.4.3-.4.5,0,0-1.2.5-1.4,1.5-.5.7,0,.7.7,0,2,.4.2.2.4-.5.5.7.3.6.7,0,1,.5,1.2,0,1.9-1,1-.2-.5-.7-.4-1-.5-.5-.5-1-1-1.5-1.5-.3.2-2.4,1.1-2.5,1,.5-1.2-.9-1.6-.9-1.7,0-2.3,1.8-2.5-1.6-3.3.2-2.2.8.3,2-1.2-1.7-1.1.1-2.2,0-3.7.8.4,1.3,1.3,2.3.5l.7,1.5c-.3-1.3.4-2.4,1.5-3,.1.7.2,1.9.5,2.5Z"
          fill="#0238e1"
        />
        <path
          d="M125.8,126.9c.4.1.4.3,0,.5,1.9,1.6-1,1.7-2.5,1-1.1-.3-.4-1.2.3-.9s-.6.6-.8-.1c0-.3.5-.8.5-1,1-.5,2,.4,2.5.5Z"
          fill="#0238e1"
        />
        <path
          d="M119.8,134.8c.6-.4-.8-1.4,2-1l-1.5,1.5c.8,0,2.4-1,2.5.7s-1.4-.7-1.5.3c-.8-.3-1.6,0-1.5-1.5Z"
          fill="#0346e8"
        />
        <path
          d="M118.8,131.3c-.5,0-1,0-1.5,0-.4-.5,2.7-4.5,1.5,0,1-.2,1.7-1,1.8-1,.3,0,.2.5.2.5-1.1,1.6-.4,1.4,1,2-.3,0-.5.7-1.6.4s-1.2-.9-1.9-.9c-.1-.2.4-.7.5-1Z"
          fill="#012bdd"
        />
        <path
          d="M123.3,131.3c-.2.2-.2.4,0,.5.2-1,1.4-.5,1,.5-.1.4-.3.4-.5,0-.5.1-.9.4-1.5.5-.4-.5-.3-1.5,0-2,1.1-1,1.6-.9,1,.5Z"
          fill="#034fe9"
        />
        <path d="M119.3,133.4c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#012ee0" />
        <path
          d="M124.8,132.3c.4.1.4.3,0,.5.4.1.4.3,0,.5-.3.3-.7.7-1,1-1.3-1.6,1.3-.4,0-2,.2,0,.3,0,.5,0,.2-.4.3-.4.5,0Z"
          fill="#0249e7"
        />
        <path d="M123.3,131.8l-.5-.2.5-.2c0,0,0,.4,0,.5Z" fill="#0249e7" />
        <path d="M125.8,131.8c.3.2,0,.6-.5,1h-.5v-.5c.2,0,.5-.6,1-.5Z" fill="#034fe9" />
        <path
          d="M103.3,181.8c.5,0,1.3.5,1.7.5s0-1.6,1.3-1l-.5,1.5h2.5c.4.8.9,1.3,1.7,1.3,0,1.8-.7,5.3-3.2,4.2-1.3,1-2.4,2.1-3.5,3.5.4.2.4.3,0,.5-.9-.9-2-1.2-3-.2l1,1.2c-1.2.4-1.9-1-2.7-1s-.2,1.7-1.3,1,.5-1.4-.5-2c1.8.9,5.8.5,3-1.5v-.5c-.4.2-.5,1.6-1.5,1s1-1.9,1-2c2.5-.2,5.8-2.2,1.5-1.7l4-2.5-3-.7c0-.2.4-.9.5-1s.9-.5,1-.5Z"
          fill="#022fe8"
        />
        <path
          d="M106.8,180.8l3.5.5c.2.9-.8.3-1,.5-.6.7,2.1.9,2.5,1l2.1.2c1.4,1.9-.3,3.9-2.6,2.8-3.2,1.1.6-2,0-2.5-2.1,1.3-2-.4-3-1s-1.1.2-1.4,0,0-1.3,0-1.4Z"
          fill="#022fe8"
        />
        <path
          d="M108.3,176.8l1,.5v3c-.5,0-1-.5-1.5-.5-2.5-.4-.8-1.7-1-2s-1.5-.3-1.5-1c1.2-.5,2.1,0,3,0Z"
          fill="#0231e9"
        />
        <path
          d="M102.8,180.3l2-1.5c-.1.6.2,2.1,0,2.5s-.7,0-.9,0c-.1-.6-.7-.7-1-1Z"
          fill="#0238ea"
        />
        <path
          d="M105.3,174.8c0,.9-.9.5-1.5,0-.1-.2-.6-.9-.5-1l2.5-.5c-.1.4-.4,1.1-.5,1.5Z"
          fill="#011ede"
        />
        <path d="M108.8,175.3c-.6-.4-1.1-.7-1.5-1s-1.1-.4-1-1c.8,0,3.9.4,2.5,2Z" fill="#0343ed" />
        <path d="M105.3,174.8c0,.3,0,.7,0,1-1,0-1-.3-1.5-1h1.5Z" fill="#0343ed" />
        <path d="M106.8,175.3h-.5c.5-.1.5,0,.5,0Z" fill="#0343ed" />
        <path
          d="M220.2,342.2c.4.1.4.3,0,.5v.5c1.7-.4,2.1,1.4.5,2,0,.3-.9.8.5,2-.5,0-1.1.5-1.5.5.4,1.7.2,3.9-1.5,2-.3-.7-.5-.4-.5,1-.5,0-.3.2.5,1,2.1.6,1.3,1.5-2.2,2.5.3.8,0,1.2-.8,1.5.7,2.2-1.9,2.8-3.5,1.5-1.5.1-1.1-.9,1.1-3.1l.4-.9-.4-1.3c1-1.2,1.3-1.7.9-3.2,1.6-2,3.1-4,4.5-6,0-.2,0-.3,0-.5h2Z"
          fill="#012ba1"
        />
        <path
          d="M218.2,342.7c-.4,3.6-1.9,2.7-2.8,4.5s1.3,1.8-1.2,1.5l1.5,1.2c-1,.9-1.8,2.1-2.5,3.2-.5,1.7-1.3,2.7-1.5.5,0-.2-.8-.4-1-.8,1.3-.4,1.1-.9,1-2.2l-1.5.3c.6-.6,1.8-1.3,2.3-1.9s-.3-.6-.2-.8c1.3-1.5,3.7-1.8,2.4-4.1,3.1,1.7,1.2-1.3,3.5-1.5Z"
          fill="#012189"
        />
        <path
          d="M213.2,353.2c-.2.4,0,1.4-.5,2.1s-2.2.6-1,1.9c2.7,0,3.4,2.2,1,3,.4,3-2.9,3-1.2-.7,0-.5-.7-1.5-1.3-.3-.5.8-1,1.4-1.5,2l-1,.5c.5-1.1.2-1.3,0-2s-.3-1-.5-1.5c-.3-.9.3-1.1,2-.5.6-.7,1.1-1.3,1.5-2-1.1-.9-.2-1.7,1-1.5,0-.2,0-.4,0-.5,1.1.8.8.4,1.5-.5Z"
          fill="#02278e"
        />
        <path
          d="M211.7,354.2c0,.7-.8,1.1-1,1.5-.3.8-.8,1.4-1.5,2-.7.4.8,1.4-1.5,1,.5-.8.9-1.1-.2-1l-.3.5c0-.1-.8,0-.5-1,1.6.1,2.3-.2.5-.8v-1.2c.2-.2,0-1.2.8-1.4s2.6.2,3.7.4Z"
          fill="#012189"
        />
        <path d="M203.2,364.7c.3-1.5.5-3.1,1-.5-.3,0-.7.4-1,.5Z" fill="#02156a" />
        <path
          d="M212.7,381.2c-1.1,0-1.2-.2-.6-.6-3.3.3-1.7-5.5.5-2.3,1.8,0,2.8,1.1,1.6,2.4.5.1.4.3,0,.5.5,1.3-.5,2.4-3,3.5-1.3-.2-1.1-2.5-1.5-3.5.3,0,.7,0,1,0-.2-1.3,1.4-1,1.5,0,.4.5.6.5.5,0Z"
          fill="#0134a2"
        />
        <path
          d="M238.2,396.7c0,.2,0,.3,0,.5-1-.3-.7-1.7-1.5-1.5,0,.3,0,.9,0,1-.2.5-.5.9-1,.5-.4.2-1.3-.5-1,1-.7-1.6-1.1-.3-1-3s-1-.7.3-1.5c.1,0,.2.5.2.5.8.9,1.8,1,2.5,0,.2,0,.5-1,.7-1,1.1,0,.2,1.6.3,2.2s.4,1,.5,1.3Z"
          fill="#0248b2"
        />
        <path
          d="M209.7,381.2c1.3.4,1.8,1.5,1.5,3.5.8-.7,2.7-1.9,3.5-1.5.2-.7,2.9-2,4-1.6s.4.3.5.6c.1-.8,1-1.2,1.5-.5.3-.9.7-.9,1,0,1.4-.4,1.6.7.5,1.5-.8,0-.3,2.3,0,2.2,1-1.3,5.1-1.3,3,.3,0,.9,0,.9.5,0-.4-1.8,3.2-1.1,1.4.1.5,1.3.3,1.9-.4,1.9,0,1.6.4,2.7,1.2,3.3-2,.4-1.3-1.8-.7-3.3-.6-2.9,0-3.7,1.5-2.5l.5.5c-.4.9,0,1.5,1,2,1.5.1,3,.1,4.3,0,.3,2.5,3.1,2.1,3-.4,3.4-2.2,4-.7,1.7,4.5.8.8,1.3,1.6,1.4,2.3,1.4-.4,1.6,0,.5,1-.2.8-.6.7-1,0l-.5-.5c-.3.2-.4.4,0,.5.1-.3.3-.3.5,0,.5.1.4.3,0,.5v.5c.4.2.4.3,0,.5-.6.2-1.5.3-2,0-1.1-.6-1.4-1.4-.9-2.4h-.6c-.4.9-2.1.8-2.5,0-.4-.1-.6.2-.5,1-1.7.7-2.6.7-4-.5.2,1-.2,2,1,2.5-.3.1-.8,0-1,.5-1.8,1-4,1.3-3.5-1,1,.9.9,1.1-.5,1l-.5-.3c-.4-1,.9-.7,1-.7.2-.2-.3-2.1-.5-2.5-1.9-.5-2.8,0-2.9,1.4-1.3,0-2-.3-2-1-3.2-.4-5.6-1.6-7.4-3.6-2.2-.4-2.4-.7-2.2-2.9-1.1-.6-1.8-1.4-2.1-2.4-2.6,1.7-4.5-3.7-1.4-2.6.5,0,.8-.5,1-1.5-.5-.7.7-1.6,1-.5Z"
          fill="#023fab"
        />
        <path
          d="M226.7,384.2c-.4.9-1.3,1-1.9.3-1.6.9-3.7.8-2.6-1.3,1-.6,2.1-.9,3.5-1,.7.6,1.9.9,1,2Z"
          fill="#023fab"
        />
        <path
          d="M227.2,387.7c0,.1.6,2.3,0,3,2.3.6,1.2-1.2,1.5-1.5s2.2.3,2.5.7c0,1.9-4.2,1.2-4.4,1.4s-.3,1.6-1.3,1.4c-.5-.6,1.2-1.9.7-2.5-.8-1.1-1,.9-1.3,1-1,.2-1-.7-.7-1.2.5-1.4,1.8,1.1,2.5-2.3h.5Z"
          fill="#0247b7"
        />
        <path
          d="M219.2,381.2c1.1,0,.9.5,0,1-1.6.4-2.9.5-4.5,1-.7,0-.7-.6,0-2,1.2-.8,2.2-.9,3-.5.2-.4.3-.4.5,0,.6-.8,1.1-.4,1,.5Z"
          fill="#023eb0"
        />
        <path
          d="M214.7,383.2c-.9.3-2.4,1.6-3.5,1.5,0-2.1,3.2-.5,3-3.5.1-.4.3-.3.5,0v2Z"
          fill="#034cb6"
        />
        <path
          d="M208.7,381.7c.2.4.7,2.3.5,2.5-.8.2-1.2-.3-1.5-1,0,0,0-.4,0-.5-1.2-.4-.4-1.2.5-1.5.1.2.4.3.5.5Z"
          fill="#02339a"
        />
        <path d="M236.7,394.2c.5,1.6-3.1,1.5-2.5,0,.8.1,1.6.5,2.5,0Z" fill="#023396" />
        <path
          d="M229.7,392.7c-2,.3-.8-1.8,0-1s0,.9,0,1,.9-.7,1-.5c.2,1.5-1.3,3-2,1.2s1.1,0,1-.7Z"
          fill="#0450b9"
        />
        <path
          d="M220.2,380.7c.2-.3.3-.3.5,0v1c-.6,0-1.1.4-1.5.5,0-.3,0-.9,0-1-.3-1,.4-1.3,1-.5Z"
          fill="#044db9"
        />
        <path d="M218.2,392.7c0-.1,0-2.5,1-2.5l.5,2.3c-.4-.2-1.4.3-1.5.2Z" fill="#02399f" />
        <path d="M217.2,389.2c-1.2-.5-1.3-1.2-.2-2l.2,2Z" fill="#02399f" />
        <rect fill="#0353bc" height="1" width="1.5" x="222.7" y="387.2" />
        <path d="M225.7,385.7c.4,2.4-1.9,1.9-.5,0,.2,0,.3,0,.5,0Z" fill="#0352bf" />
        <path d="M229.7,388.7c-1,.1-1.1,0-1-1l1,1Z" fill="#0247b7" />
        <path d="M239.7,394.7c.2.2.2.3,0,.5-.5,0-1.3,1.2-1-.2s.7-.3,1-.3Z" fill="#0247b7" />
        <path d="M220,390.2c.3.2.3.3,0,.5v-.5Z" fill="#02399f" />
        <path d="M240.2,395.2c-.2,0-.3,0-.5,0v-.5c.4.1.3.1.5.5Z" fill="#023fad" />
        <path d="M240.7,396.2h-.5c0-.1,0-.4,0-.5.2.2.3.3.5.5Z" fill="#023fad" />
        <path
          d="M208.2,381.2c-.2.5-.3,1.2-.5,1.5h-2c0,0-.7-.3-.5-1,.8,0,1.6.3,2-.5s0-.7,0-1l.7.4.3-1.4c1.8.7.3,1.1,0,2Z"
          fill="#023fab"
        />
        <path
          d="M207.7,382.7c.4.2.4.3,0,.5-.2.1-.9-.1-1,0s1.4,1.5.5,2.5c3.4-2.5,2.6.7,3.6,1.4s1.3,0,1.4.1c.2.2-1.2,2.4.3,3s1.8-2.2,2.3-2.7,1,.4,1,.4c0,.8-2.7,2.1-2,2.7s2-.7,1.5,1.5l2.5-1-1,2c1.6.6,5.7-.5,5,2,.9-.4,1.2-1.7,2.4-1.9s1.2,0,1.6.9c-.6.7-2.4.4-2.5.5-.3.6,1.2,3.3,1,4.7s-.9.2-1,.3l-1.5.5c-.2,0-.3,0-.5,0-.5,0-.9-.2-1-.5.3-.6.8-1.1,1-1.5,1.1.3.8-.3.5-1,.2-.3,1.3-1.3.7-1.5l-2.2.5,1,1.5c-.7.3-1.2-.4-1.5-.5s-.3,0-.5,0c.3-1.6-.7-3.2-2.3-3.5s-3,1.5-3.1,1.6c-.2.3,0,.8,0,.9-1.7,0-.8-.1-.5-1.5-1,.6-1.5-.4-2-.5-.9-.4-1-.8,0-1-.3-1.4,2.2.4,2.1.3-1.7-.9-3-1.6-5-.9-.1-.6-.7-1.1-1.6-1.4-1.7,2.9-4.4-2.8,0-2.3l1.1-1.2c-.6-.3-1.3-.5-2-.5-2.8-.1-2.9-4.4,0-4.5,0-.7,2-1,2,0Z"
          fill="#02399f"
        />
        <path d="M221.7,397.2c2.4-.3-.5,4-.5,1,.2-.3.4-.8.5-1Z" fill="#023996" />
        <path d="M221.2,400.2c-.2,0-.3,0-.5,0h-.5c0-.1,0-.4,0-.5l1,.5Z" fill="#023996" />
        <path
          d="M206.7,391.2l4,1c-1.3-.8-.2-3-1.3-3.5s.3,2.4-1.3,1.2c0-1.4,1.7-2.8,2.5-1.7s-2.1,3.6,2.5,3c0,.6-.8.8-1,1.2s1.3.5,1.5,1c-.5.6-1.8,0-2.5-.3s-1.2-.7-2.2-.5-2.2,3.4-2.8,0l2-.5c-.8.2-1.3-.9-1.5-1Z"
          fill="#0240a0"
        />
        <path
          d="M207.7,387.7c-.3,0-.7,0-1,0-.1.8-.9.9-1,0v-.5c.9,0,2.2-1.7,2.5-.2s-.5.6-.5.7Z"
          fill="#0348aa"
        />
        <path d="M220.7,395.7c-1.1-.4-1.2-.8-.2-1.5l.2,1.5Z" fill="#023fab" />
        <path d="M205.7,387.7c.7.1.3.1,1,0,.3,2.1-1.6.6-2.5.5-.2-1.6.2-.7,1.5-.5Z" fill="#023a9d" />
        <path
          d="M204.7,372.7c.7-.6,1-.3.5.5-.4.2,0,1.1,1.3,2.6-.9,1-.6,2.1.9,3.3,0,3-3.1.5-.8,1.4s.3.3.5.6c.6.4.1.9-1.5,1.5.1,1.5-1,.6-1.1,1.7s.4,1.9,1.1,2.8c.4.1.4.3,0,.5-.2.4-.7.5-1.5.5-.1,0-.4,0-.5,0-.1,2-1.4,2.2-2.8,1,.8-1.2.2-2.4-1.7-3.5-.4-.6-.9-1.3-1.5-2-1.1.4-1,.9-2,1-.6-.7.4-3.1,1.5-3,0-.2,0-.7,0-1-1-1.1-2.6-3.5-1-4.5,0,0,1.3.2,1.2,1l1.2-1,.5,1.5c.5-.8,0-2.7.4-3.2s1.4-.5,2.1-.8c.7-1.2,2-3.2,3-1Z"
          fill="#023294"
        />
        <path
          d="M197.7,383.7c.5-.2.9-.6,1.5-.5v2.5c.3-.3,1.3,1,.8-2,.9,1.3,2.2,4.1,1.8,5.5.9.3,1.3-.8,2-1,.8,2.1-.6,3-1.8,4.5l.3-2.5c-.6-.4-1.3,0-1.5,0s-.3,0-.5,0c-.3,0-.5-.1-.5-.5.3-.2,1.5-1.2,1.5-1.2l-1.7-1.7.3,2c-.4.4-1.9-.9-2-1.2s.8-.4,1.2-.8.2-.9.3-1c-1.4.4-1.1-.9-1.5-2Z"
          fill="#023a9d"
        />
        <path d="M196.2,376.2c-.8,1.8.8,2.8,1,4.5-1.5.2-3.4-5-1-4.5Z" fill="#012883" />
        <path
          d="M205.2,373.2c.4.3,1,1.5,1.3,1.5s.6-.9.7-1c.1-.4.3-.4.5,0,.6.2.7,1.3.5,2,.4.1.4.3,0,.5,0,.5-1.3.4-1.6.2s3.1.3,2.1,1.7c.3.2.4.2.5,0,.3-.9.6-.9,1,0,.3.9.5,1.9.5,3-.2,1.4-.5,1.2-1,0-.4,0-.9,0-1,.5-.4.8-.6.6-.5-.5-.7-.6-1-.6-1,0-3.2.5-4.3-2-.5-1-.3-2.4-1.7-.7-2-1l.5-2c-1-.5-1.8,2.1-1.8,2.3-.1.8.5,1.8.3,2.7-2.5-1.4-.6-2.5-.3-4s-1.5-1.8,2.3-1.5c.1-.1-.7-2-.9-2.5-.3-.8-1.4-1.1.4-1Z"
          fill="#0239a0"
        />
        <path
          d="M201.7,376.2c0,0,.9,1.4,1,1.7-.8,1.6-3.1,1-2.5.3s1,.1,1-.3-1.2-2.7.4-1.7Z"
          fill="#023ca0"
        />
        <path d="M202.2,375.2l1.5-1.5c.2.9-.5,1.7-1.5,1.5Z" fill="#0239a0" />
        <path
          d="M209.7,370.7c2.1.2.5,4.1-.5,2,1.3,1,1.5,3,0,4-.5.9-1.1.4-1-.5v-.5c.1-.7,0-1.6-.5-2-.1,0-.4,0-.5,0-.2-.2-.3-.3-.5-.5,0-.5.3-.7.5-1,.5-.5.8-.8,1,0,.3.7.4.4,1,.5,0-.8-.3-1.3.5-2Z"
          fill="#0344aa"
        />
        <path
          d="M124.8,284.8c.5.1.9.4,1,1,.7.2,1.2.5,1.5,1,.3,0,.7,0,1,0,1.3.3,1.2,1,0,1.5-1.4-.7-.9-.7-3-1v-.7s-1.5-1.6-1.5-1.6c0-.5.7-.2,1-.2Z"
          fill="#0227e4"
        />
        <path
          d="M131.8,291.3c0,.4,1,.8.9,2.1s-1.1,1.2-1.4,1.4c1.2-1.4-.3-1.6-.5-2s-.8-1.1-.5-1.5,1,0,1.3-.5l.2.5Z"
          fill="#011dd9"
        />
        <path d="M129.8,288.3c1.1-.9,1.7-.8,1.5.5-.2,0-.3,0-.5,0l-.3-.5h-.7Z" fill="#0226e5" />
        <path d="M129.8,288.8c-.2,0-.4,0-.5,0,.1-.2.3-.3.5-.5v.5Z" fill="#0226e5" />
        <path
          d="M124.3,283.8c.9-1,1.2-.8,1,.5.4.1.4.3,0,.5-.2.4-.3.4-.5,0l-.3.5c1.3,1.1,1.6,1.8.8,2,0,.9-.8.9-1,0-.6-.2-.9-.7-1-1.5-2.5-.7-1.8-5,1-2Z"
          fill="#022fe6"
        />
        <path
          d="M121.3,278.3c.7-.5,1-.3.5.5,1.3.3,1.3.6,0,1,1,.4,1.3.9,1,1.5l.3.7c-1.8,1.2-1.7,2.7.2,4.3.2.4.6.7,1,1l.6.6c3.9-.7,3.9,3.2,0,1.4-.2,2.4.5,3.1,2.2,2,.8,1.2,1.9,1.7,3.1.7l.8.8c1.4-1.1,2.1,1.4.5,2,.7,1.1-1.9,2.2-2,1-1.7-1.8-1.7-1.6,0,.5.4.5.1,1.3-.5,1.5-1.2-.2-2.3-.2-3.1,0-.4-.7-1.2-1-2.4-1-.4.1-1,1-.8,1.3.5.7,3.1,2,3.4,1.7.2-1,.6-1.4,1.4-1.5-.4-.9.8-.7,1.5-.5.6-1.2,2.9-3.6,2.5-1h.9c3.3-4.4,3.8,2.5,1.3,4.4.3,1.2-.2,1.8-1.4,2.1l-.2,1c.6-.5,1-.3,1,.5.9,1.6.7,2.8-.5,3.5-.4,0-1.8-.7-2-.5v1.5s-1.5-1-1.5-1c.2,1.4-1,1.8-1.5,2.5,1.1,1.4-.2,1.4-1.5,1,0,.3,0,.7,0,1,.2.2.2.3,0,.5,0,.2,0,.3,0,.5-.3,0-.8,0-1,0-.7-.5-.2-1.4.5-1.5-.6-.1-.8-.4-1-1h-.7c1.4-2,1.2-3-.5-3,.2-1.3-.1-2.1-.8-2.5-.4.1-.3.1-.5.5,0,.6-.7.6-1,0-1-.2-1.6-.8-2.5-1l3-1.2-2,.2c1.1-1.7-.9-2.4-2.2-2s-.3,1.3-1.3,1c0-1.1-.2-1.5-.5-2.5.3,0,.7,0,1,0l.7-1.1c1.2,1.4,1.8,1.6,1.8.6h0c-.4,1.7-1.7.1-2.5-1-.2-.4-.4-1.5-.5-1.5s-1.5.7-2,.5c-.4-.2-.4-.3,0-.5l-.7-.2c.2-1.3,0-2.6-.8-3.8-.9-.3-1.7-.4-2-1.5,1.5-.5.6,1.8,2,.5l.5-1v-.5c1.2.9,2.6.3,3.5-.8-2.9.1-2.1-1.9-2.5-2.2-.1-1.1.6-1.9,2-2.5.1-1.6.4-3.3,1-5-.6.6-.9.6-1,0-.6-1.4.2-1.6,2.5-.5,0-.9.4-.9,1,0l.3.2c-.1-1.7.4-4,1.7-2.2Z"
          fill="#022fe6"
        />
        <path
          d="M112.3,293.8c.7.2,1.9-.4,2.5.8l-1.5.2c.3,1,.3,2,.5,3l-1.5.5c-.1-.1.7-1.3.5-2-.3-.6-.6-.8-1-.5,0,.2,0,.3,0,.5-2.2.1-.2-1.4.5-2.5Z"
          fill="#0219d2"
        />
        <path
          d="M132.3,308.3v-2.5c-.9,0-1.7-.5-2.5-.3s-2.3,3-2.5.3l2-.5c0-.2-2.8-2.1-.7-2s2.5,3,4.2,1.5c1.1,0,1.2.8.4.4s1.4-1.2,1.5,0c0,0,.5.3.5.7s-1.7.5-1,1.8c-2.5,0-1.3.4-2,.5Z"
          fill="#0226e0"
        />
        <path
          d="M125.3,312.3c0,.5-.3,1.1-.5,1.5-.5-.2-.8-.5-1-1,.2,0,.4-.5.5-.5.2-.7.5-.5,1,0Z"
          fill="#022fda"
        />
        <path
          d="M131.3,296.8c-.2-1.1,2.6-2.5,3.2-2.4,1.9.4.7,2.7.9,2.8s.9,0,.9,0c1.1.3,1,1.5,0,2v.5c-.5,0-.8.4-.9,1.1,1.6,1.8-1.2,4.2-2.6,3.6s-.7-.2-1-.2c-.7-.7-.5-1.1-.5-2l-2,1,1-2.5-1.5.5v-2.5c.5.3,2.9.9,3,1s-1.4,2.7,1,2.5c-1.2-3.1.2-1.4,1.2-2.5s.7-4.9-.7-3.5-.2,2.5-1.2,2-.7-1.4-.8-1.5Z"
          fill="#0226e0"
        />
        <path
          d="M122.8,281.3c.6.2,1.9-.3,2.5.8.1.4-2.3.5-1,1.7-.3,0-.8.8-2-.5-.3,1.1.6,1.7,1,2.5v.5l-2.5-.3,1.5-.5c-1.9-1.6-1.4-2.6.5-4.3Z"
          fill="#0227e4"
        />
        <path
          d="M119.3,291.3c1.7,1.6-2.6,5.6,2,4l.5-1c.4,2.3-1.5,1.7-.5,4h-2c-.6-1.3,1.1-.8,1-1.2-.4-1.2-1.4-.3-1.7.2l.2-1.7-1.5-.3c-.2-.8.9-.2,1-.8s-.4-4.5,1-3.2Z"
          fill="#0225e0"
        />
        <path
          d="M116.3,299.3l2.5-1c.2.8-.9.3-1,.7-.6,1.6.6,1,1,1.3-.5-.5.9-2,1.5-1.5s-.7,2.3-1.5,1.5c.3.2,1.1.6,1,1-1.5.3-2.9,1.4-2.5-1,0-.1-.7.5-1,.5.3-.7.3-.8,0-1.5Z"
          fill="#0225e0"
        />
        <path d="M129.3,296.3c-1.2,0-1.6-1.1-2-2h2c0,.5,0,1,0,1.5s0,.3,0,.5Z" fill="#011fe1" />
        <path d="M124.3,294.3l-.5,1.5c-.7.2-1-.2-1.5-.7l2-.7Z" fill="#0f42e9" />
        <path d="M115.5,288.3c.7,0,.7,1.5,0,1.5s-.7-1.5,0-1.5Z" fill="#0225df" />
        <path d="M125.3,312.3c-.3,0-.7,0-1,0,0-.3,0-.9,0-1,.2-.2.9.6,1,1Z" fill="#0222d7" />
        <path d="M122.8,292.3c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#0226e5" />
        <path
          d="M123.3,296.8c.4.1.4.3,0,.5-.2.4-.2.8,0,1,.1-.4.3-.5.5-.5l.5-.5c.9-.7,3,0,3,1,1.2.7-1.5.3,0,1.8-2.9.4-2.8,2.6.5,1.2-.6,1.5-.1,2.6-2,3l-.3-1.5-2.7,1,1.5-1c.2-.9-1-.2-1-.7,0-1.5,2.3-.8,1-2-2.1-.7-3.1.9-3,2.8-2.1.2-1.2-2.2-.3-3.1s1.2.1,1.3,0c.1-.3-1-2.2.5-3.3s.5.3.5.3Z"
          fill="#0224e0"
        />
        <path
          d="M128.8,297.8c-.3.1-1.2.5-1.5.5s-.9-.7-1.5-.5c0,1.2.3,1.8-1,1.5-.2-.3.5-2-.5-2l-.5.5c-.1.1,0,.6-.5.5-.2-.2-.2-.6,0-1v-.5c1.7-.4.8-.8,1-.9.8-.5,1.4.9,2,1.2s1.7-.2,2.5.8Z"
          fill="#0538ec"
        />
        <polygon fill="#022fe6" points="123.3 298.3 122.8 298 123.3 297.3 123.3 298.3" />
        <path d="M124,298.8c.3.2.3.3,0,.5v-.5Z" fill="#0538ec" />
        <path d="M123.8,297.8c.1-.1,0-.6.5-.5l-.5.5Z" fill="#022fe6" />
        <path d="M124.3,287.3c-.8-.2-1.2.5-1-1-.4-.1-.4-.3,0-.5.2.4,1,.9,1,1.5Z" fill="#0336ec" />
        <path
          d="M125.3,287.3c.7-.7,3.4-.2,3,1,.3.2.7.4,1,.5h.5c.3,0,.7,0,1,0,.1-.4.3-.4.5,0,.2,0,.4,0,.5,0,.3,1.2-2.6,4.1-3,4.1l-1.6-1.1c-2.3.4-2.8-.1-2.5-2.5.9,0,2.3.5,2-1-.7-.3-2.8.7-3,.5s.5-1.3.5-1.5c.3,0,.7,0,1,0Z"
          fill="#0336ec"
        />
        <path
          d="M131.8,291.3c-.2.3-.6.8-1,1.5-2-.6.3,2.2-1.2,1.5s-2.8-2.6-3.3-2,.5,1.7-.5,1.5c0-1.5-1.2-1.6-2.5-1.5,1.9-1.7-.6-2.9,1.5-3l1.5,1-1,1.5,1.7-2c1.6,4.4,3.1,1.1,4.7-1,1,.5,0,2.1,0,2.5Z"
          fill="#0226e5"
        />
        <path d="M130.3,290.3c0,0-1.9.6-2,.5-1.1-1.2,3.5-1.9,2-.5Z" fill="#0226e5" />
        <path
          d="M148.3,287.3c-.8-.7,1.1-8.5,1.4-8.9,1-.9,2.3-.5,2,.9.2.2.2.6,0,1-.4,1.6-1.1,2.5-1.5,3.5l-.5,1c0,.1,0,.4,0,.5l-1,2c0,.1,0,.3,0,.5h-.5c-.3-.1-.3-.3,0-.5Z"
          fill="#051ec4"
        />
        <path
          d="M153.3,276.8c0,.2,0,.7,0,1-.4.8-1,1.7-1.5,2.5,0-.3,0-.7,0-1-1.9-1-.4-3.4,1.5-2.5Z"
          fill="#0628cd"
        />
        <path d="M148.8,287.3l1-2c-.4.9-.6,1.3-1,2Z" fill="#0827c0" />
        <path d="M149.8,284.8l.5-1c-.2.5-.4.7-.5,1Z" fill="#0827c0" />
        <path
          d="M148.3,287.8c-.1.2-.4.3-.5.5v-.5c-.4-.1-.4-.3,0-.5.1-.4.3-.4.5,0v.5Z"
          fill="#041ecb"
        />
        <path
          d="M152.3,276.3c0-1.1,1.4-.4,1,.5,0,0-.7-.2-1,.3s-.3,1.5-.5,2.2l-1.5-.5c.1,3.2-1.3,5.5-2,8.5h-.5c0-.3-.4-.7-.5-1l-1.2-.6c0-1-.4-2-1.3-2.9-.8.3-.9.2-.5-.5-1.5-1-.8-1.6,2.2-1.7,0-.5-.1-1.1-.2-1.8-.4-1.7.4-2.2,2.4-1.6l1.6-.4c-.5-1.2,1.1-.8,2-.5Z"
          fill="#0227db"
        />
        <path
          d="M142.3,284.3c.1-.1.2-.2.4-.2.8,0,2.9-.3,3.2.2,1,1.3-.4,1.5-1.6,1.6-.6.8-.2,1.9-1,2.7s-1,.3-1,.3c-1.7,1.1-2.5.4-2.5-2-1-1.8,1.9-5.3,2.5-2.5Z"
          fill="#022de9"
        />
        <path
          d="M144.8,282.8c.1,0,2.9.4,3,.5.9.8-1,1.1-1,1.2s.4,1.3.5,1.8l-3-.5c.2-.2.7-.5,1-.5v-.5c-.7-.3-2.5.5-3-.5-.7-.7-.4-1,.5-.5-.2-.7,1.4-1,2-1Z"
          fill="#0234e1"
        />
        <path d="M140.8,290.3c-.2.3-.3.7-.5,1s-.3.3-.5.5v-1.5c.3,0,.7,0,1,0Z" fill="#021aca" />
        <path d="M147.8,287.3c0,.2,0,.3,0,.5-1.4.2-1.4-.7,0-.5Z" fill="#0234e1" />
        <path
          d="M140.3,296.3c.5-.2.7,0,.5.5l.2.7c-.7,0-.8.5-.2,1.3,1.5,1.4.8,5-1.7,3.1l-.8.4c3.1-1.6,1.9,1.4,1,3.5-.1,0-.7,0-1,0-.3.3.8.8,1,1-1.5,1.7-2.1.2-3,0-1.3-.3-.5,1-2,1-1.6-.2-1.5-1,.5-2.5-2.3-1.2,1.4-3.3,3.5-3-3.9,1.4-2.9-2.9-1.6-2s-.8,1.8-.4-.5v-.5c.1-.8.4-1.4,1-2-.9-.3-.8-.7,0-1,.1-.4.3-.4.5,0,.6-.3,1,.1,1.2.7s-1-.7-.2-1.2c-.6-.5-.3-.7.5-.5.6-.6,1-.3,1,1Z"
          fill="#0222d6"
        />
        <path d="M141.8,298.8c-.3,1.3-.6,1.3-1,0-1.7-1.9,2.6-2.4,1,0Z" fill="#0222d6" />
        <path
          d="M143.8,295.8c-.3,1.3-.4,3-2,3,.9,1.8-1,5.9-2.5,7,.6-1.6-2.1-.5-1.5-1.7s1.8-.8,2-1.8c-.5,0-1,0-1.5,0,.1-.1.2-.7.5-.8.8-.4,1.9.8,2.5-.5-.6-.5-.3-2.1-.4-2.3,0,0,.7,0,1,0-.2-.4-.5-1-1-1,0,.3,0,.9,0,1,0-.1-2.6-.6,0-2s2.5.6,1.5-2.5c.8-.2.5,1.2,1.5,1.5Z"
          fill="#0118cd"
        />
        <path
          d="M136.3,299.8c.1.2.9.4,1,.8s-2.8,1.1,1,1.7c-.6.5-.7.7-2,.5l.5,1h-2c0,.5,0,1,0,1.5-.6-.2-1.9.6-2,.5s.1-.8,0-1c-.3-.6-.9-.4-1-.5l1-1.2c-.4,3.1,2.5-.6,2.5-1s-.8-.1-.9-.5c-.2-.7.7-2.5.9-3.3.7,0,.5.8,1,1.5Z"
          fill="#0231e3"
        />
        <path d="M138.8,295.8c1.3,3.2-.5.7-1,.5.3-.2.7-.3,1-.5Z" fill="#0225df" />
        <path d="M137.3,296.3c0,.3,0,.7,0,1-.2,1.1-.7,1.1-1,0-.6-.8.2-1.1,1-1Z" fill="#0225df" />
        <path
          d="M137.3,297.3c.1.4.7,1.2.5,1.5s-1.2.2-1.5.5c-.1-.5.1-1.8,0-2,0,0,.7,0,1,0Z"
          fill="#0231e3"
        />
        <path d="M139.3,299.8l-1.5,1.5c-.2-.9.5-1.7,1.5-1.5Z" fill="#0118cd" />
        <path
          d="M226.7,322.7l2.5-.5c.6.7-1.4,1.9,1.5,2,.1.7.1,1.6,0,2.5,0,1.8-.5,3.3-1.8,4.9.3,1.4,0,2.5-.7,3.1-.4.2-.3,0-.5.5l-1,.5c.3-.6,0-1.1,0-1.5-1.6-.1-1.3-1.5,0-2-.7-.9-.2-1.9,1.5-3,.2-.3,0-.3-.5,0,0,.8-.9,1.9-1.5,1-.2-.7-.5-3.2-.4-3.7s.8-.7.9-.8c-1,.9.5.9,1,1q.9.8,0,0c0-.2.6-.9.5-1-.4,0-1.4-.1-1.5,0,.3-.5,1-1,1-1.7s-.7-.2-.8-.4c-.3-.4-.1-.8-.2-.8Z"
          fill="#023bd8"
        />
        <path
          d="M226.7,332.2c-.2,1.7-2.1,1.8-1.5,0,.2-.4.9-1.9,1-2,.2-.2,1.2-.5,1.5-1h.5c-.5.9-1.3,2.2-1.5,3Z"
          fill="#034cda"
        />
        <path
          d="M226.7,332.2c0,0,0,1.7,0,2-.5,0-1,0-1.5,0,0,.4-.3.4-.5,0v-.5c-.2-.8.3-1.1.5-1.5l.3.5,1.2-.5Z"
          fill="#0238c8"
        />
        <path
          d="M143.8,264.8c.2.2,2.4.6,2.5.5s-1.2-2.6.8-2.5.2.8.4.9.6-.3.8-.2c.4.3.6,1.5,1.6,1.4.2.8-.8.4-1.2,1s.2.9.1.9c-.4.3-1.8,0-1.9,1.1,0,0-.8.1-.9,0s.9-3.2-.6-1.4.9,3.1.5,4c-1.7,1-3.4-1.4-1-2-.7,0-1.7-.3-2-1-.2-.2-.4-.2-.5,0-.1.4-.3.4-.5,0-2.5.2-1.7-3.6,1-3.5,1.8.4.7.7,1,1h-1s0,1.5,0,1.5h1s0-1.5,0-1.5Z"
          fill="#0232e6"
        />
        <path
          d="M154.8,259.3c.2.2,1.3.7,1,1-.3,0-.8,0-1,0q-.5-.3,0,0c-2,1,0,1.8.5,1.5s1-2.1,1-2.5l2,.5c-1.4,1.5-.7,1.9-.5,3.5v.5l-.5.5c-.1.1-.3.4-.5.5-.2-.2-.4-.2-.5,0,0,.2,0,.3,0,.5v1.5c0,.3,0,.8,0,1l-.5.5c0,.1,0,.4,0,.5-.3.4-.6.6-1,.5-.1,0-.4,0-.5,0l-.5.5c-.2.4.2,1.9-1,.5,1-2.3.9-2.3-.5,0,0,0-.7.5-1,1,2.7.8-1.6,2.9-1.5,0-1.2.3-.3-1.1-.2-1.1s-1.1,2-1.7,2.1c.8.1.7.8.3,1.5-.3.4-.1.4.5,0-.7-.5-1-.8,0-1,1.2-1.1,2,.2.5,1,.4.1.4.3,0,.5,1.1.7.9,1.1-.5,1,.9.3.9.7,0,1-1.3-.2-1.2,0,.5.5.3-1,.7-1,1,0-.2,0-.4.6-1,.8-1.1.5-2.5-.3-3,1.2-1.3-1.2-.2.5,1,.7-.6,1-1.5,2.4-2.5,1.3-1,1.4-2.3.4-1.5-1-2.9.2-2-3.3-.5-5l-.5-.5c-.4.2-.6,0-.5-.5l.5-2c0,.4-.2.4-.5,0-3.1-1.4,1.5-2.7,2.9-1.2l1.1.2c.5,0,1.6-.3,2-.5.1-.6-.2-1-.5-1.5-.1.5-1,1.3-1,.8.3-.3.7-1.6.5-1.8,2,1.1,4-1.9,4.3-2,1.5-.4-.3,1.9,1.2,2,.6-.8-.1-3.4,0-3.5s2,.8,2.5-.8c-2.7.4-1-.1-1-1.5s-.6-.2-1-1.3c-.7-2.4,0-3.5,2-1.5Z"
          fill="#0232e6"
        />
        <path
          d="M151.3,271.3c1.2-.5,2.4-.3,3,1-.5-.1-.7.4-1,.5-1,1.3-2.6,1.9-4,1,0-.4,0-.8-.5-1-.9-1.1-.2-1.7,1-1.5,0,0,1.3.2,1.2,1,.5,0,.1-.8.3-1Z"
          fill="#0229dd"
        />
        <path
          d="M153.3,272.8c1.9-.2.6.8.5,1.5.4.1.2.6,0,1,0,.2,0,.3,0,.5-.8.3-3.9-.7-4.5-1.5,0-.2,0-.3,0-.5,1.1,0,3.1-.6,4-1Z"
          fill="#011cd6"
        />
        <path d="M156.3,266.8c-.8-.4-1.8,0-2-1l2-.5c0,.8.2.4,0,1.5Z" fill="#0328da" />
        <path d="M154.8,269.3c.3-.2.8-.3,1-.5l-.7.9-.3-.4Z" fill="#0328da" />
        <path d="M153.8,269.8c.2-.5.2-.3.5-.5l-.5.5Z" fill="#0328da" />
        <path d="M155.8,268.3c.2-.3.5-.5.5-.5l-.5.5Z" fill="#0328da" />
        <path d="M156.8,264.8h-.5c0-.6.3-.5.5,0Z" fill="#0328da" />
        <path d="M157.3,264.3c.2-.1.3-.4.5-.5l-.5.5Z" fill="#0328da" />
        <path
          d="M149.3,274.3c.7.2,2.1.6,2.7.4,1-.3.4-1.9,1.8-1.4l-1.5,1.5,1.5,1c-.1.6.1.5-.5,1-.2-.6-.8-.4-1-.5-1.7.1-2.9-.2-3.5-1,0-.3.5-.7.5-1Z"
          fill="#0229dd"
        />
        <path
          d="M156.8,241.3c1.2,0,1.5.3.4.7.7.5.9,1,.6,1.3l2,1c.2-.7,1.2,0,1.5.5.5-.4,1.2-.6,2.2-.7-.5-2.5,3.2-4.8,2.8-1.8.2.2.2.3,0,.5-.1,0-.7-.2-.9,0s-.6,3.2-1.1,3.9l-2-1c2.7,3.5,1.3,1.6-2,3s-.4.9-.7.9-1.3-.6-1.8-.4.3.6.2,1-.6.7-.6,1c.4.2.4.3,0,.5-.3.9-2.1.5-2-.5-.4-.1-.4-.3,0-.5.3-1,.3-2,0-3-.4-.2-.4-.3,0-.5,0-.5-.2-1-1-1.5-1.3-.1-1.2-.6,0-1-.6-.6-.3-.9.5-1,.4-.3,1-.3,2,0-.7-.5-1.1-1-1-1.5-.5-.5.3-1.5,1-1Z"
          fill="#0247ed"
        />
        <path
          d="M167.3,240.8c0,.2,0,.3,0,.5l-.5.5c0,.2,0,.4,0,.5h-.5l-1-1c-.3.7-1.1,2.8-1.5,3.2s-1.3.3-1.8.8-.2,1.6-1.1,1.9-1.9.4-1.7-.4c1.1,0,1.7-1,2-2-.4-.2-.4-.3,0-.5-1.2-.9-.9-1.9,1-3,1.5,0,2.8-.7,3.8-.8s1,.3,1.1.3Z"
          fill="#0238e1"
        />
        <path d="M166.8,241.8c0-.2.3-.4.5-.5,0,.2-.3.4-.5.5Z" fill="#0436dc" />
        <path d="M166.3,242.8v-.5h.5c-.2.2-.2.3-.5.5Z" fill="#0436dc" />
        <path
          d="M167.3,224.8c1.2.2,2.4.9,4,.5,0,1.1-1.6.4-2,.8s-.5,1.2-1,1.7c0-.7-.3-.5-1,.5-.3.6-.5,1.4-.5,1.5-.2.2-.7-.5-1-.5l-.5,1c.2,2.1-1.2-.3-2.6,0s-1,1.2-1.9.9c.2-.7.9-1.2,1.5-1.5v-.6c-3.4.5-3-2.9-.5-2.9.4-.3,1-.4,1.5-.5.4-.7,1.8.2,2,1,0,.5.2.7.5.5.4-.2.2-.7-.5-1.5-.6.4-1,.2-1-.5-.3-.2-.2-.3,0-.5-.4-.1-.4-.3,0-.5.9.1,2.1.3,3,.5Z"
          fill="#0462f5"
        />
        <path
          d="M176.3,209.3c.4,0,.5.3.5.5l3.5.8c-.7.3-1.9.8-2.5,1.2-.7-1.4-.8-.8-2-.5-.4.4-.9.7-1.5,1,.5,2.1,2.9.2,1,4l-2.5-1.5.5-1c-.7-.1-1.9-.2-2.5-.5-1-1.8-.5-2.5.5-4h1.5c.5-.1.8,0,1,.5,0,0-.1,1.1.2,1,.8-.2,1.5-1.4,2.3-2,.4.1.4.3,0,.5Z"
          fill="#025bf3"
        />
        <path
          d="M177.8,211.8c2.9,1.2,1.8,3.5,0,5.3v1.7c-.3.8-.4,1.3-.6,2-.2.3-.9.7-1,1-.9,1.7-1.9,3.3-3.1,4.8,1.1,2.6-2.6,2.9-2,1.4l-.9.3c-.1.4-.3.4-.5,0-2.3,1.3-2.8,1.1-1.5-.5,0-.9-.3-1.9-1-3-2.2-1.2,1.1-4,2.5-3v-1q-.5-.3,0,0c.4.1.4.3,0,.5-1.4,1.5-4.9-.4-4-2.5.6-.4,1.4-.4,2.5,0,.5-2.3,2.2-4.4,4.5-4,.5-.7,1.2-.7,2.1-.1-1.2-.9-1.4-1.7-.6-2.4.4-.3.9-.6,1.5-1-.6-2,3.4-.9,2,.5Z"
          fill="#024eed"
        />
        <path
          d="M176.3,221.8c0,.3,0,.7,0,1l-2.5,5.5c-.4,1-1.2,1.8-1.5,2.5l-1,.5q-.2.2,0,0c.8-.1.4,1.4,0,2-.5,1.3-1.3.8-1-.5-.4-.1-.4-.3,0-.5l-.5-.5c-1.6,0-1.5-1.3.5-3.5-.4-2.3,2.3.2,2.5,0l-1-2.5,2-.5c-1-1.4-1.9-.4-1-2.5l1.5,2c0-.7.7-1.5.5-2.2s-1.8,0-.5-1.1l2,.3Z"
          fill="#0434dd"
        />
        <path d="M175.8,211.3l.5,1.5-2-.5c0,0-1-.2,0-.8s1.1-.1,1.5-.2Z" fill="#0372f3" />
        <path d="M173.8,217.8l-1.5-.5.5-1.5c1,.3,1.1,1.1,1,2Z" fill="#0460f1" />
        <path d="M176.3,218.8c-.3.3-.5,1.6-.7,1.5-1.2-.5-.5-1.7.7-1.5Z" fill="#0360f1" />
        <path d="M174.3,219.3c-.7.2-2.5-.7-2-1,.9-.1,1.8,0,2,1Z" fill="#0360f1" />
        <path d="M169.8,220.8c1.5.4,2.1.7,0,1v-.5c0-.2,0-.4,0-.5Z" fill="#0c88f6" />
        <path d="M169.8,220.8c-.3,0-.7,0-1,0v-.5c.8-.2.7,0,1,.5Z" fill="#0036dd" />
        <path d="M169.8,231.8h1s-.5.5-.5.5c-.2-.1-.3-.3-.5-.5Z" fill="#0436dc" />
        <path
          d="M225.2,334.7c1.5.5.2,2.2.5,3.5.4-.3,1.1-.3,1.5-.5,0,.3,0,.7,0,1s-.5.3-.4,1.1c.2,1.5,1.8,2.3.9,3.9-1,.1-.1-1-.8-1.5s-1.9-.6-2.2.3c2.7.8,1.5.7,1.5,2.2.1,1-2.1,1.6-2.5.5h-.5c-1.4,0-2.4-1.9-1.8-2.9l-.6-.4c.7-1.1,1.3-2.1,1.8-3.2,0-.6-.3-1-.5-1.5,2.4.6,1.8-.8,2-1,0-.8.3-1.2,1-1.5Z"
          fill="#0238c8"
        />
        <path
          d="M222.7,338.7c.4,2.3-1.1,2.7-1,3.2.2.9,1.3,2.1,1.5,3.3s-.4,1.5-.3,2c-.4-.9-1.7-1-1-1.9h-1.3c0-.6,0-1.1,0-1.6-.9-.2-.3.9-.5,1-.4.3-3.2-.9,0-2,.5-.2.5-.3,0-.5,0,0-.5-.9-.5-1s0-.4,0-.5c.1-.3.3-.3.5,0l1.5-.7-1-1.2h2Z"
          fill="#0228ae"
        />
        <path
          d="M124.8,244.3c1.4-.7,4.4.4,2.1,1.4.3,1.2,0,1.4-1.1.6-.3.6-.9.8-1,0,0-.2,0-.5-.2-.5-.3,0-.2.3-.2.5l-1-1c.4-.6.5-1.1,1.5-1Z"
          fill="#0542ee"
        />
        <path
          d="M130.3,252.3c.7,1.6.5,2.2-.5,2-.7,1-.8.6-1-.5-.2,0-.3,0-.5,0s-.3,0-.5,0v-.5c-.9-.9-.8-1.1.5-1,.1-.2.3-.4.5-.5.2-1,.7-.8,1.5.5Z"
          fill="#0220dc"
        />
        <path d="M117.3,253.8c1.9,1-.1,3.6-1,0,.3,0,.9,0,1,0Z" fill="#0218d1" />
        <path d="M118.8,237.3c.9.2.9.6,0,1-.6,1.1-2-.2-1-1,.3-.9,1.4-1.1,1,0Z" fill="#0336ed" />
        <path
          d="M113.3,232.3c0,0-.2-.7,0-.9s2.7,0,2.9.2c.6.3,3.4,3.4,1,2.8l2,1c.4.2.4.7,0,1-.3.5-1.2.5-1.5,0,1.1.1.8.4,0,1l-.2,1c2.4.6,3.1,1.5,2.2,2.5.8,0,1.4.2,1,1-.1.2-.1,1.2-.7,1.5-1.8.7-1-1.3-1.3-1.5l-1.5.5h-.5l-.4-.7c.5-.3.6-.9.4-1.8-.7-.5-1.2-.5-1.5,0h-1c-.3,0-.8,0-1,0-.3-.1-.4-1.3-1.2-1-1.5.5-.9,1.6-.8,2.5-2.4-.8-1.1-1.1-.3-2.6s.2-1.4.3-1.4c.6-.7,1.7,1.8,2.5,1.5.3-1-.8-1.3-1-1.8s1,.3,1-1.2c.4,0,1,0,1.5,0,.2,1.5,1.7.6,2.5.5-.1-1-1.4-.4-2.5-.5-.2-1.2,1-3.8-2-3.5Z"
          fill="#0336ed"
        />
        <path
          d="M110.8,258.3c.5-1-1.9-1-1-2s2.9,0,3,1c-.1.3-1.3,1-1.5,1.5-.2-.1-.4-.3-.5-.5Z"
          fill="#0221df"
        />
        <path
          d="M103.3,228.8l.5,1c.5,1.1.9,2.4,1,4,1,.2.8,1,0,1.5.9.5,1.8-.2,2.8-2.3.9-.4,5.9,1.3,6.2,2.8l-1.3-1.2c-3.1-.3-.9-4.2.8-2.3,2.4-1.9,4.6,2.2,2,3.5-.2,1.4-1.1,1.3-1.5,0,1.2.2,1.1,3.1-.1,3.5-1.8-1.9-4,.2-2.4,2-1.5-.4,0-3.1.6-3.3s2.4,1.4,1.4,1.8l-1,1.5c-.3,0-.7,0-1,0,0,.5-.1,1.9,0,2,0,0-.8-.4-1-.5.4-.2.9-1.3-.3-1s-1.3,1.1-2.2,1l1-1.5c-2.4-.5-.8,1.2-2.3,2.5.5-3.2-.8-1-1.7-.5s-.8.6-1.5.5c.1-2.3-1.1-4.4,2-5.5l-1.5-.5.5-2-1.2,1.5c-2.1-.6-.7-3-2-2.5s.3,1.6-1.8,2c0-.8.2-1.3.5-2-.5-.6-.1-.8.5-1l.2-.7c1.3,0,1.7-1.2,1.8-2.3.2-.5-.4-1.7.5-2,0-.4.3-.4.5,0Z"
          fill="#0229e6"
        />
        <path d="M115.3,235.8c.1-1.9,3.4-1,2.5.5-.9,1.6-4.1,1.7-2.5-.5Z" fill="#0229e6" />
        <path
          d="M115.3,239.8c1,0,.9.8,0,1,.6.5.6,1,0,1.5.7.7.4,1-.5.5-.2-.1-1.1.1-1.5,0l.5-1c-.6.1-1.1-.5-1.5-.5,1,.2,1.5-.7,2-1.5.1-.3.4-.3,1,0Z"
          fill="#0229e6"
        />
        <path
          d="M102.3,230.8c-.2.8,1.2,3.3,1,3.5-.8,1-1.1-.9-1.2-.9-.4,0-1.3.4-1.8.4-.4.6-.8.7-1,0v-.5c0,0,.2-.6.5-.7,1.2-.4,1.6.7,2.5-1.8Z"
          fill="#0219d9"
        />
        <path d="M106.3,240.8c.6.6-.2,1.6-1,.2,0-.4,1-.3,1-.2Z" fill="#0223e0" />
        <path d="M104.1,240.8c.3.2.3.3,0,.5v-.5Z" fill="#0223e0" />
        <path
          d="M105.3,230.8v.5c.5,1,.4,1.8-.5,2.5-1.2-.1-.9-2.8-1-4,1.2.4,1.2.9,1.5,1Z"
          fill="#011eda"
        />
        <path
          d="M116.3,264.8c0,.3,0,.8,0,1l-1.5-.5c.4-.3,1.4-.9,1.5-1,.4.1.4.3,0,.5Z"
          fill="#0227e4"
        />
        <path
          d="M124.8,219.8c.1-.4.3-.4.5,0,.4.1.4.3,0,.5-.4.8,0,.8.9.6.3,1.9,1,3.4,2.1,4.4.6.8,1.1,1.4,0,2.3l.2,1c-2.3-.6-4.3-.5-5.8.2-.2-.2-.6-.1-.8-.7s.3-4.7-1.2-3.3.7,4-1.5,4.5c-1.1-2.1,1.5-3,1.5-3.2s-.5-1.2-.5-1.3c-.3-.3-.9.5-1,.5-.3,0-1-.7-1.5,0-.5.4-.6.1-.5-.5.7-1.7,1.2-.4,1.5-.5,1.4-.6,2-1.4,1.7-2.4l2.8-1.1c0-.2.5-.6.5-1,.1-.4.3-.4.5,0,.1-.4.3-.4.5,0Z"
          fill="#0341f2"
        />
        <path
          d="M135.3,224.3c.2.2.3.4.2.5s-.6.5-.8.6.9-.8,1.1,0c.4,0,.7,0,1-.5,2.5-2.1,4.4,1,1,2.5l-.5,1c.4.1.4.3,0,.5-.4,1.3-3.3,4-4.5,1.5-.7,2.2-1.5,2.8-2.5,2-.5,0-1-.4-1.5-1q-2-.5,0,0c.7.4,1.5,1.2,1,2l-.5,1.5c1,.3,1,.7,0,1,2.4,1.6-1.1,3.8-2.5,2,.5-.4.8-.9,1-1.5-1.1-1.6-2-1.7-2.8-.3l-.8-.2c-.3-.7-1.2-.8-2.4-.5.1.6-.6.9-1,.5-1.4.1-1-2-.5-3-.2-.4.2-1.1-.5-2,.9-2.6,2.1-2.2,3,0,.3.3.8.5,1.5.5.2,0,.9,0,1,0,.3-.3.3-.6,0-1-.1,0-.4,0-.5,0,.1-1.1,1.7-2.8,3-1.8.4-1.6,1.4-2.2,3-1.7.1-.4.3-.4.5,0,.6,1.3.7,1.3.5,0-1.2-1.4-.6-3.5,1.5-3,.8-.2,1.9-.4,2,.5Z"
          fill="#0347f3"
        />
        <path
          d="M113.3,205.8c0,.7-.6.5-1.1,0s2.5,1,2.6,1.9c.5-.4,1-.6,1.5,0,2.6-4.7,5.5,2.1,0,2-1.7.2-2.1.8-1.4,1.6l-.6.9c-1,0-1.8,1.6-1.5-1-.3-.1-.5-.2-.5-.3s.3-.7.4-1,0,1.1-.4-.2c-.1.2-.3.2-.5,0-.8-1.4-1.1-2.7-1-4-.2-.2-.2-.3,0-.5-1.3-2.1,3.8-1.4,2.5.5Z"
          fill="#033cf1"
        />
        <path
          d="M126.8,220.3c.9.2,1.3.5,1,1,3.5-.2,5.3,6.6,1,3.5l-.5.5c.4-1.5,2.4.4,2.5,1.5-.5.1-2.3.4-2,1.2s.7.1.8.4c.4.9.3,2,1.2,2.9-1.8.4-1.8-2.3-2-2.5s-3.8.5-4,1.5c-.2,0-.3-.4-.5-.5-.2-.5-.7-.8-1.5-1-.3-.3.5-1.5.5-2l.7,1c1-3,1.5,1.9,2.5-1l1,1.5c.5-.2.7-2.5.8-3-2.5,0-3.7,2.3-4.5-1.5,4.8,2.2.8,0,2-2.5l-1.5,1,.3-2c.2,0,.5,0,.7,0,.7-1.7,2.1-1.8,1.5,0Z"
          fill="#0235ed"
        />
        <path
          d="M119.3,234.3c.6-.7.9-.2,1.1,1.5h.4c.3-.1.8-.3,1-.5,1.9-1.1,2.3.3.8,1.7,1.1,1.3-.8,3-1.3,1.8-.5-.2-1-.4-1.5-.5-.1.8-.8.8-1,0,0-.3,0-.7,0-1-.4-.6-.3-1,.5-1,0-.3,0-.7,0-1s0-.7,0-1Z"
          fill="#0222e3"
        />
        <path
          d="M124.3,231.3c-2.7.2-1.3,4.6-3.5.7,0-.2,1.8-1.2,2-1.2.9-.1,1.3.5,1.5.5Z"
          fill="#0235ed"
        />
        <path
          d="M120.3,232.8c0,.2,1.5.6.9,1.4s-1.4-.2-.9,1.3l.5.3c-1.9,1-.3,0-1.5-1.5,0-.5,0-1,0-1.5h1Z"
          fill="#0336ed"
        />
        <path
          d="M101.3,215.3c1.9.4,1.6,1.6,0,1.5l-.5.5c2.5-1.4,2.8,4.4.5,2.5-.8-1.4-1-1.4-.5,0,.6,1,1.9.5,1.9-.7,2.2.6,1.7,2.9,1.2,4.7l.4.5c.9.8-1.1,2.4-2.6,1.6l-.9.9c.2.5.7,1,1.5,1.5.7-.6.9-.3.5.5.3,1.3.1,1.9-.5,2l-.2,2.2c-1,0-1.9.1-2.8.3l-.6.9c1.4,1.5-2.9,4.2-3.4,1.6-1.5.7-1.4-.3-1-1.5-.4.6-.8.8-1,0-.2-.2-.2-.3,0-.5-.4-.2-.4-.3,0-.5l.5-.8c-1.2-1.3-1.3-3.2.8-3.3l-.2-1c-2.8-2.4-2.8-6.3.9-3.3.7.2.6,0,0-.5-3.6.7-3.5-4.3-.3-4.4l-.2-.6c-.4-.4-.6-1.1-1.2-1.5s-3.8-.9-.8-1.5l.6-.2c.8.5,2.1.8,3.9.7.6-.2.6-.4,0-.5-.2.3-.3.3-.5,0,.8-.8,1.8-1.8,2.8-2.9l.8,1.1c.9-.9,1-.3.9.8Z"
          fill="#0224e0"
        />
        <path
          d="M100.8,226.8c.1,0,.3,0,.5,0,.4-.5.7-.2,1,1v.5c-2.4-.5-2.7-.4-3,2.5,1.3-.1.4-1.5.5-1.5,1.7-.9,2,1.1.6,2-2.1,1.5-3.3-3.2.4-4.5Z"
          fill="#011bdd"
        />
        <path
          d="M97.7,222.2c-.2.3-2.6,1.4-2.9,1.1-.5-2.3,1-1,1.6-1.8s-.3-1.7.7-2.2c.9.6,1.1,2.1.6,2.9Z"
          fill="#0219da"
        />
        <path
          d="M101.3,223.3c.5.5-1.4,2.5-2,1.5-.3.5,1.7,1.9-1,1.5-.2-3.7.1-1.9,1.2-2.2s1.4-1.2,1.8-.8Z"
          fill="#011bdd"
        />
        <path d="M95.3,224.3l2-.7-.5,2.7c-1.6-.1-1.4-1.4-1.5-1.5s0-.4,0-.5Z" fill="#0219da" />
        <path
          d="M100.8,219.8c-.1,0-.9-1.4-2-1,.8-2.9,1-.7,1.3-.6.5.2.9-1.1,1.2,1.6-.2,0-.4,0-.5,0Z"
          fill="#022ae5"
        />
        <path d="M97.3,216.3c.4,0,.8-.3,1,.3.5,1.4-.7.3-1,.2v-.5Z" fill="#022ae5" />
        <path d="M100.8,217.3l.5-.5c0,.2-.5.4-.5.5Z" fill="#022ae5" />
        <path d="M101.3,226.8c0,0,.1-.8,1-.5v1.5s-1-1-1-1Z" fill="#0224e0" />
        <path
          d="M96.8,201.3c.7-1.3,2.3-.4,2,1,.6-.2,1.7,0,2,.5.7-.9,4.8-.1,3.5,1.2,1.8,4.8-1.8,4.7-4.5,2.8q-.6-.8,0,0c1.3.7,2.8,1.2,4.4,1.4-.4-.7.2-2.5.9-2.7s.8.3,1.1.7c1.8-.4,3.2.4,2,2.2,2.2.9,2.7,1.6,1.5,2.3-.3.5-.6.5-1,0-.2,0-.8-.6-1.7-.6s-.4,1.4-2.3,1.1c-.1-.5-.3-.7-.5-.5-.2.4-.3.6-.5,1s-.1.5,0,1l-1.5-.5c0,.3,0,.9,0,1,0,0-1.5.2-1-1.5.1-.4.3-.4.5,0,.5-1.1.3-1.6-.5-1.5-.7-.1-1.2,0-1.5.5-.3,0-.9,0-1,0,.2-1.9-.8-.5-1.5-.5-.3.6-.8.4-1.5-.5-.6-1.2,0-.7-1-2-.4-.1-.4-.3,0-.5l-.5-.5c-1.5.3-1.7-.6-.5-1.5,0-.2,0-.3,0-.5-1.7-3.4,0-3.9,3-3.5Z"
          fill="#0226e3"
        />
        <path d="M97.3,210.3l-.2,1.5c-.7-.5-.9-1.3-1.3-2,.5,0,1.2.5,1.5.5Z" fill="#0010cc" />
        <path
          d="M104.3,210.8c.5-.9.2-1.8,1.5-1.5.2.9-.6,1.3-1,2-.2,0-.4-.3-.5-.5Z"
          fill="#022ae5"
        />
        <path
          d="M101.3,210.3c.8-.3,1.3,1.1.5,1.5-.2,0-.4,0-.5,0s-.4,0-.5.3l-.2,2.2c-1.2-1.2,0-1.7-.8-3.5s-.5-.6-.5-1c.7-.6,1.6-.4,2,.5Z"
          fill="#011fdc"
        />
        <path
          d="M99.8,206.8c-1.5-.4-1-1-1.3-1-.5,0-1.1.5-1.5.5-.9,0-.5-1.8-.3-2s2.2,1.2,2.4,1.3c.5.4.7.4.6,1.2Z"
          fill="#0113d5"
        />
        <path
          d="M101.8,201.8c-1.1-.1-1.1,0-1,1-1.3-.1,0,.7-2-.5v-.5c.4-.4,1-.4,1.5,0,.2,0,.5-.4.9-.4s.6.4.6.4Z"
          fill="#0218d7"
        />
        <path d="M101.3,210.3l.2-1c.8.7,1.5,1.3,1.2,2.5-.3,0-.7,0-1,0l-.5-1.5Z" fill="#022ae5" />
        <path d="M95.3,205.3c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#021bda" />
        <path d="M94.8,207.3c-.2-.2-.4-.3-.5-.5.2.1.4.3.5.5Z" fill="#011fdc" />
        <path d="M90.8,210.3c-.3-.2.5-.7,1-.5s-.6.9-1,.5Z" fill="#011fdc" />
        <polygon fill="#022ae5" points="95.3 215.3 95.3 214.8 95.8 215.1 95.3 215.3" />
        <path
          d="M109.3,192.3c.8-.3,1.3,0,1.5.5l.5-.8c.5.6.8.9,1.5.3,1.4-2.3,2.6,1.4,1.8,2.9l.2,1.1c.3.2.1.4-.5.5.9.7-1.3,1-1.2,1,2.3-.5,6.2.4,3.7,2.5-.2.9-.3,1.2-1,.5-.3.8-.7,1-1,.5-.6.8-1.2,1.7-2,2.5-1.1.2-1.7.7-2,1.5,0,.1,0,.4,0,.5l-.6.3c.7.9,1.5,2.5,1.6,3.7.2,0,.3,0,.5,0l-.8,1.5c-.6-1.9-1.1-.5-1.2-.5s-.3,0-.5,0c0-2.5-2.3-.3-3-1.8s2.9-3-.5-1.7c0-.3,0-.8,0-1-.2-2.3.3-4.2,1.5-5.5.4-.8.8-1.6,1-2.5,0-.3.1-.9,0-1-.2-.2-.8.5-1,.5v-.7c-1.4-.6-.8-.5-.5-1.8l-1.5.5-.6-1.3c-3.9-.6,0-2.6,2.6-1.8l1.4-.4Z"
          fill="#0234ea"
        />
        <path
          d="M109.3,191.8c.4.1.4.3,0,.5-.2.5-.7.9-.5,1.5-.8.7-3.3-3.3-1,1.5-1.6-1-1.8-2.6-4-1.5l2.5.5c-.2.5-.3,1-.5,1.5s0,.4,0,.5l-.5.5c-.6,0-.6-.4-.5-1-1-.1-1.5-.5-1.5-1-.6-.6,0-1.1,0-1.5.2-.2.2-.4,0-.5,0-.2,0-.3,0-.5s0-.3,0-.5c-.4-.7,0-1.1,1.5-1,.5,0,1.1.1,1.9.6,1.1-.4,2-.2,2.6.4Z"
          fill="#0228e4"
        />
        <path d="M99.8,189.8v-.5c.8-.5,2-1,3-1.2-.7,3-1.1,1.5-3,1.7Z" fill="#011ddf" />
        <path
          d="M95.3,184.3c2.3.3,1.1-1.4,3-1.5-.4,1.1-.4,1.9,0,3,.7,0,1.3-.3,2-.5-.3.9-.7,2.2-1,3,0,.9.1,1.2.5,1,.4.1.4.3,0,.5,1.9.2,3,1,3.5,2.5.4,0,.4.3,0,.5.2.1.2.3,0,.5,1,.4,1,.9,0,1.5.5.9-.3,1.3-1,.5q-1.7-.9,0,0c.7.2,1.5.4,2.5.5.6,0,.6.5.5,1l.5-.5c-.4-.2-.4-.3,0-.5,1-2.1,4,.4,2,2-1,.5-1.5,1.4-1.7,2.4-1-.7-3.3.7-2.7.9.8.2,1.4,1.9.5,2s-2.2-.9-2-1.3c-.5-.2-1-.2-1.5,0-.5-.3-1-.4-1.5,0,.4.1.4.3,0,.5-.5-.3-1.9-.9-2-1-1.1.5-1.8-.5-2-2.9l-.5-.6c-.1,0-.4,0-.5,0,.7-.8,0-3.8,0-4s1.9.8,2-1.2c.2-1.5-.8-.1-1.7-.2s-1.3-1.3-1.3-1.4c-.2-1.4.5-2.1,1-3.1,2.3.8,2.7.4,1-1,.3-.2-.3-1.7,2.5-1,.3-1.6-.6-.6-2-1-.4-.1-.4-.3,0-.5Z"
          fill="#0222e0"
        />
        <path d="M94.8,186.8c3.4-.6,2.3,2.4,0,3l-1-2c.7-1.5.6-.6,1-1Z" fill="#0212d1" />
        <path
          d="M102.3,195.3c-.8.1-2.9.1-3,.2-1.1.8-.4,4.3-2,3l1-2.8-1.7,1.5-1.2-1.7c.7-.4,1.4.2,2.4,0s3.8-3.4,4.6-.2Z"
          fill="#022de7"
        />
        <path
          d="M103.3,194.8c.2,0,1.4.4,2,0,.2.5-.5.9-.5,1-1.1,0-2.7,1.7-3,.2s.5-.6.5-.7c.5,0,.9-.5,1-.5Z"
          fill="#0234ea"
        />
        <path d="M100.3,201.8c-.5,0-1,0-1.5,0,0-.8,1.4-.8,1.5,0Z" fill="#0226e3" />
        <path d="M99.6,190.8c.3.2.3.3,0,.5v-.5Z" fill="#022fe8" />
        <path d="M103.3,193.3c0-.2,0-.3,0-.5l.5.2-.5.2Z" fill="#0234ea" />
        <path d="M105.3,196.8l.5-.5c0,.2,0,.5-.5.5Z" fill="#0234ea" />
        <path
          d="M212.2,78.4c.8.3,1,.9,0,1-.1,0-.3,0-.5,0,0,1-2.2,1.4-3.5,1.5-1.2,2.1-5,1.9-7,1.3-3.8,1.7-9.4,4-13.5,2.7-1.2-.1-1.6-.5-1-1,.7-.3,2.5-.8,3.3-1,1.8-.4,3.4-.4,4.9-.7,2.2-.3,3.4-1.8,5.3-2.8,1.8-.2,7.6-.3,7.9-.6,1.7-1.3,1.7-.3,4.1-.4Z"
          fill="#4d7ae7"
        />
        <path
          d="M212.7,79.9c-.2-.1-.4-.5-.5-.5v-1c.2,0,.3,0,.5,0,1.2.5,1.2,1,0,1.5Z"
          fill="#5086ee"
        />
        <path
          d="M334.2,156.3c1.9-1.6,2.7,2.7.5,2q-.6-1.2,0,0c1.4-1.5,2.9,1.6.5,1.5l-.4.5c-4.5-2.2-5.5-3.7-3.1-4.5,1.2-.6,1.9-.9,2.5.5Z"
          fill="#038ff9"
        />
        <path
          d="M333.2,150.8c-.7-1.6-1.6-2.5-2.7-2.8.2-4.1,2.3-2.8,4.2-.6l1.1.9c.2,1.1.4,1.9,1.4,1-.6,0-.8-.5-.5-1-.2-.6,0-.8.5-.5.6,0,2.2.3,2,1.5.6.8-.4,1.1-1,.5.4,1.1.1,1.3-1,1.5.4,1.2,1.9,2.4,2.1.8l.9.7c.2-1.4.4-1.2,1,0,.3.3.6,1.2.2,1.4s-.1-1.5.8-1.4c.2-.3.2-.7,0-1-2.3,2-2.5-1.2-1-3,.3-.8.9-1.3,1.5-.5.7,0,.1,1.3,0,1.2s.4-1.3.9-.7c.6.3.4.5,0,1l.6-.2c1.5.8,2.3.9,2.4.2,0-.3-.1-.3-.5,0-1,1.1-2.1.4-1.1-1.2-1.3-.6.6-3.9,1.6-2.3,0,.1,0,.3,0,.5-.2,1,0,1.4.5,1,0,.3-.9.9-.2,1,.8,0,1.6-.9,2.2-1,.5.3.5,1.1.5,1.6s-.2-1.2.5-1.1c.2,0,.3,0,.5,0,1.5-.2,1.5.6.5,1.5.8,2.3-1.7,3.1-3.3,1.7-.6.4-1.2.6-1.7.8.4.3.5.7.5,1,.3,1.4.8,2,1.5,2,0-.7.4-.9,1-.5.5-.1.6,0,.5.5,0,0,0,.4,0,.5-.2.8-.5,1.6-1.5,1.5-.8.3-1.2.8-1,1.5-.2.2-.3.7-.5,1-.3.9-.7,1-1,0-1.1-.7-2-1.2-3,.2-1,0-1.6-.8-1.7-2.3-1-.3-1.6-.8-1.8-1.4-.8-.5-.4-1.2.5-1,.2-.6,0-.9-.5-1,.1.6.1.8-.5.5-1.4.9-2.9,1.1-4.5,1-.8-.3-1.7-.3-2.5,0-.5.8-1.1,1.4-2,.8-1.7-1-1.6-2,.3-2.4s3.3-1.7,3.7-2.9c-.7.7-.9.4-.5-.5Z"
          fill="#038ff9"
        />
        <path
          d="M352.2,151.8c.5-.2,1.2,0,2,.8.8-.7,1.3-.6,1.5.2.6-.1.8,0,.5.5.3.7.6,1.2.5,2-.2.4-.3.4-.5,0-1.2-.6-2.5-.6-4,0,1.5-.7,2.2-.5,2,.5,1.7-.5,2.9-.3,3.5.5,0,.1,0,.4,0,.5.7,1.3.3,1.4-1,1-.1,0-.3,0-.5,0-.7-.5-1.3-.7-2-.5-2-1.6-2.1-1.8-1.5,1-1.8-.7-1.3-1.6-.5-3-.3,0-.7,0-1,0-.4-.1-.4-.3,0-.5l-.6-.7c-1.5.3-2.2,0-1.9-.8l-1.5-.5c-.3.5-.9,0-1-.5.7-2.1,3-.8,4-1.2s.7-1.1,1-1.3c.2-.4.3-.4.5,0,0,.7,0,1.4.5,2Z"
          fill="#059ef9"
        />
        <path
          d="M350.2,160.3c-.6,1.6-.4,1.8.5,3,.7.4.3.8-1,1-.2.1-.9-.1-1,0-.8,1,1,1,1,1.3,0,.5-.7,1.3-.5,1.7.7,1.1,3,.2,3.5,1.6v.5c-.8-.2-2.4.7-3,1.5-1,1.6-1.5,2-1.5,0-1.3-1-1.5-1.6-.8-1.8-.9-.9.4-3.5.7-2.4s-.5,0-.4-.8c-1.1-.3-1.2-.7,0-1l-.6-.4c.4-1,1-2.1,1.6-3.1.3-2,.6-1.4,1.5-1Z"
          fill="#0380f5"
        />
        <path
          d="M346.7,159.8c.3,0,1,0,1,0,.2.3-.6,1.9,1,1.5,0,.3.4.8.2,1.5s-1.1,1.2-1.2,2c-.4.9-2.7,0-2.5-1,0-.7.3-.9,1-.5,0-.2-.2-.4,0-.5,1.2-1.5,1.5-.3.9-.5s-.2-.2-.3-.5c-.8.2-1.3.8-1.5,2-1.4.5-2.3-.5-1-1.5-.4-.4-.1-1.1.5-1,0-.8.2-1.2,1-1.5.3,0,.7,0,1,0Z"
          fill="#0498f9"
        />
        <path d="M348.2,157.3c-.5.8-.2.6-1,1.5l-4.5-2.5c1.9,0,3.7.5,5.5,1Z" fill="#04a2fa" />
        <path
          d="M351.2,155.3c.5-.8.8-1,1,0,1.4.6,2,1.3,2,2,.6-.4,1.2-.2,1,.5-.4,1-1.6,2-2.5,1,0,.7-.6.9-.9.5-.5-.7.7,0,.9,1,.7-1,1.7-1.8,3-2.5.2-.3.3-.3.5,0,.1-.4.3-.4.5,0,.3.5.6.7,1,.5l3.5.5c1.1.3,1.9.1,2.5-.5-.4-.1-.4-.3,0-.5.3-.5,1.2-.6,1.5,0-.5.7-.1,1,0,1.5,1.1,1.1,1.5,2.9-.5,2.5v.6c-1.6-1.1-2-1.1-1.5-.1.7.2.9.9,0,1,0,.8-.4,1.6-1,2.5q-.2.2,0,0c.2-.4.3-.4.5,0,1.5.1,2.5-.4,3-1.5.8-.9,1.2-.5,1.2,1.1.2.6,1,.8,2.3.4-.2-.3-.5-.5-1-.5,0,2.5-3-1.1-1-1.7,2.2-.7,2.7-.8,3,1.7.2-1,.7-1.5,1.5-1.5.3,0,.7,0,1,0-.2.4-1.7,2.4-1.5,2.5,2.7-.2,4.9-.4,7.5.5,0,1.3-2.2,0-2.4,0s.2.9-.3.9c-1.3,0-.4-.3-.2-1-.9-.4-1.8,1-2,1-.5,0-1.8-1.5-1.5.5.5,0,1.1,0,1.5,0-.5.7-.8.8-1.5,1.2l2.5,1.3c1.1,0,.8,3.1-.5,2-1.1-1.1-1.8-1.3-2-.5.3,1.3,0,1.4-1,.5-.1,1-2.2.3-2.5-.5-.4-.2-.4-.3,0-.5v-1.5c-.8-.2-1.7-.8-1-1.5q.6-.9,0,0c-.1,1-2.1.2-2.5-.5-.3-.3-.4-.2-.5.5.4.1.4.3,0,.5.3.7-.5,1.3-1,.5-.8.7-2,0-1.5-1-.4-.4-1.2-.5-2.6-.4v-1.1c-1.3,1.2-2.3,1.4-2.9.5-.5,1.1-1.7,1.5-3,1.5.7.7.4,1-.5.5-.7.6-.9.3-.5-.5-.4-.1-.4-.3,0-.5-.8-1.2-1.5-3,.5-3,.5-.2.8,0,1,.5,1-.9,1.1-.8,1,.5,1.1.8,1.9-1.1,1-2-.5,1.3-1.1,1.8-2,1.5l-1-1c-1.4-.8-2.4-2.5-3-5l-1.5,1c-.3,2.4-3.4-.9-1-1.5q.7-.8,0,0c-.1,1.3-.5,1.2-1,0-1.2-.7-.8-1.2.5-1-1-1-.3-1.8,1-1.5,1.6-.7,2.1-1.2,1.5-1.5-.4-.1-.4-.3,0-.5.4-.7,1-.6,1.5,0Z"
          fill="#0385f8"
        />
        <path d="M373.6,168.3c0,0,0-.5,0-.5l.5.2c0,.3-.5.2-.5.2Z" fill="#0385f8" />
        <path
          d="M371.6,163.8c-.3.5-1,1.6-1.5,1.5,0-.5,0-1,0-1.5.7-.5,1.1,0,1.5,0Z"
          fill="#0347e4"
        />
        <path
          d="M350.2,160.3c1.2.5,2.3,1.2,3.5,1.8l-2,.2c-.3,1.3.7.9,1.4,1.8s0,1,.1,1.2c.4.2.5.4,0,.5-.3,1.5-1.3,1.6,1,1.5.2.8-1.3.5-1.5,1.5-1.4.5-4.8-1.2-3.8-2.5-1.6-1.3,0-4.1.8-2,.4-.5,1.9-.3,1.8-.3-.3.2-1.3-.2-.8-.7-1.8.8-2-2.7-.5-3Z"
          fill="#0393fa"
        />
        <path
          d="M362.1,157.8c.5,0,1,0,1.5,0v.5c0,1.1-.8,1.2-2.5.5-.4.2-.5,1-.5,1-.4.2-1.1-1.4-2-1v1.5c0-.9-.4-1.4-1-2-.5.3-1,0-1-.5.1-.4.8-.7,1-1,1.3,2.3,2.4,1.1,4.5,1Z"
          fill="#0491f9"
        />
        <path
          d="M354.2,166.3l1.5-1.8c-1.5-.4-1-1.3-1-2.7,1.2-.4,1.6.7,2.3,1,1.2.6,0-1.1.5-1,.8.3.6,1.7.3,2-1.1,1-1.4-2.9-2.5-.7,0,0,.9,1.7,1,1.7.9.5.5,3-1,2-.4-.2-.6-.3-1-.5Z"
          fill="#0592fa"
        />
        <path
          d="M349.7,155.8c.3.2,2.4-.4,0,1.8l1.5.3c-2,3.1-1.5.2-2.1-.4s-.7,0-.9,0c.3-.6,0-1.6,1.5-1.5Z"
          fill="#059df9"
        />
        <path
          d="M372.1,172.3c-.3-.1-1.4-1.1-2-1.2,2-2.2,1.1-.8,1.8-.2s2.2.4,2.2,2c-.5-.2-1.1,0-2-.5Z"
          fill="#0368f4"
        />
        <path
          d="M365.1,168.3c1.3-.9.5.6,2.5.5.3.5.7,1,1,1.5-.1.4-.3.4-.5,0-.2,0-.4,0-.5,0-.9.4-1.8,0-2.5-.5-.1-.2-.4-.3-.5-.5s0-.3,0-.5c-.1-.6,0-.8.5-.5Z"
          fill="#0367f1"
        />
        <path
          d="M355.2,157.8c.2-.4.3-.4.5,0-.5,1-1.7,2.9-3,2.5-.6-.6-1.1-1.4,0-1.5.9-.3,1.6-.8,2.5-1Z"
          fill="#0498f8"
        />
        <path d="M363.6,158.3c.7.4-.3,1.7-.8,2s-1-1.6-1.7-1.5c.8-.4,1.7,0,2.5-.5Z" fill="#026cf1" />
        <path d="M357.6,159.3c0,0,.2,1.1.5,1.5l-2,.5c.4-.8.4-2.8,1.5-2Z" fill="#0592fa" />
        <path
          d="M356.2,164.8c0,0,.9-.7,1-.5l-.5,3c-.9.3-1.2-.4-1.5-.5,1.5.3.9-.7,1-2Z"
          fill="#0273f3"
        />
        <path
          d="M351.2,154.8v.5c-.5,0-1,0-1.5,0-.2-.2-.3-.3-.5-.5-.7-1.2,2.1-1.2,2,0Z"
          fill="#059df9"
        />
        <path
          d="M367.6,168.8c-.2-.3-1.1-1.4-1-1.5,1.1.1,2.4.3,2,1.5-.3,0-.7,0-1,0Z"
          fill="#0466f6"
        />
        <path d="M352.7,158.8v1.5c-.5-.2-1.3-.9-1.5-1.5.5,0,1.1.1,1.5,0Z" fill="#059ef7" />
        <path d="M371.6,167.8l-1.5.5c0-1.4,1-2,1.5-.5Z" fill="#0365ee" />
        <path d="M347.7,159.8c-.1-.7.3-1.3,1-1.5v1.5s-1,0-1,0Z" fill="#06a0fb" />
        <path
          d="M356.2,157.8c-.2,0-.3,0-.5,0s-.3,0-.5,0c-.2-.4-.8-.4-1-.5l.3-.5c.8-.2,1.5.2,1.7,1Z"
          fill="#0469f4"
        />
        <path d="M357.7,158.3l-.3.5c-.8.2-1-.2-.7-1,.5.2.5,0,1,.5Z" fill="#036cf2" />
        <path d="M353.2,165.3c0,0,1.3,0,1,1-.3-.2-.7-.3-1-.5,0,0-.6-.5,0-.5Z" fill="#0368f3" />
        <path d="M365.1,168.3l-.5.5c-.2-.6-1-.9.5-1.5v1Z" fill="#0ea9f5" />
        <path d="M362.1,165.8c.2.2-.5.8-.5.2s.4-.4.5-.2Z" fill="#0494fa" />
        <path d="M371.4,168.8c.3.2.3.3,0,.5v-.5Z" fill="#0452f3" />
        <path
          d="M378.6,186.8c.3,0,.9-.8,1.3-1,.7,2.4,2.1-.9,2.2,1.5-2.1-.4,0,2.4-2,2,.1,1.5-2,1.3-1.5-.5-.4.2-.9,0-1.5-.5-.5-.8-.6-1.2,0-2,.2,0,.7.5,1,.5,1.2.7,1.4.7.5,0Z"
          fill="#0368f4"
        />
        <path
          d="M384.1,182.8c1.5.7,1.4,1.3,0,2-2-.3-.2-.3-.7-1.5s-1-.5-.8.5h-.5c0-.3,0-.7,0-1-.2-.4,0-.6.5-.5.5,0,1.2.5,1.5.5Z"
          fill="#025cf3"
        />
        <path
          d="M383.6,181.3c0,0-.8.8-1,1s-.3.3-.5.5c-.2-.6-.9-.5,0-1.8s1.1.2,1.5.3Z"
          fill="#158df7"
        />
        <path d="M378.6,186.8l1,.2-1.5,1.3v-1.5c.2,0,.4,0,.5,0Z" fill="#0785f8" />
        <path d="M383.6,181.3c0,0,.9-.8,1.5-.5.3,2-.9.4-1.5.5Z" fill="#0350f4" />
        <path d="M386.1,182.3c-.2,0-.3,0-.5,0,0-.2.3-.5.5-.5v.5Z" fill="#0352f3" />
        <path
          d="M361.1,155.8l.5,1c-1.1.2-1,.7-2,.5-.5-.5-.6-1.1,0-1.5,0-.3,0-.7,0-1,.5.2,1.1.9,1.5,1Z"
          fill="#0566f2"
        />
        <path
          d="M274.7,83.4c0-2,2.6-1.8,3.1-.3.9,0,1.3.3,1.4.8.3.1.3.3,0,.5-.4.7-.9,1.2-1.5,1.5-.3.5-1,.6-2,.5-.8-.5-1.3-.3-2-.5-.1.4-.3.4-.5,0,2.7-2.1.9-1,.5-2,.8,0,.6-.3,1-.5Z"
          fill="#3286ef"
        />
        <path
          d="M270.2,82.4c2-1,2.8,1.4,3.5-.5,0,.3,0,.7,0,1s0,.8,0,1c-1.4.2-2.7-.5-4,0-.4-.7.5-1.4.5-1.5Z"
          fill="#3286ef"
        />
        <path
          d="M272.7,87.4c-2.1-.6-.5-3.9.5-3s-1,1.1,0,1.5.3,0,.5,0c0,.6-.9,1.2-1,1.5Z"
          fill="#3288f1"
        />
        <path d="M269.7,81.4c-.7-.5-1.3-.4-1-1.5,1.2.5,1.4.3,1.5,1.5h-.5Z" fill="#4b7be4" />
        <path
          d="M278.7,89.9c.6,0,1,.1,1,.5,1-.7,1.2-.4.5.5.3,1.1.9,2,2,2.7l-1,.8c.4.1.4.3,0,.5-.2.4-.6.3-1-.5.3.9-.3,1.3-1,.5-.7,0-1.3.4-2,1-.1.5-.3.4-.5,0-1.1-.1-1.5-.5-2-1.5,1-.8,1.4-1.7,2.5-2.5.2.2.4,0,.5-.5,0-.2,0-.3,0-.5-.4-.1-.4-.3,0-.5-.5-.8.5-1.2,1-.5Z"
          fill="#1991f7"
        />
        <path
          d="M277.7,85.9c.5-.2.7.1.5,1,.6-.5,1.2-1,2-1,.1-.4.3-.4.5,0,1.5.1,1.3,1.1,0,1.5,1,2.4.7,3.4-1,3,0,0-.3.5-.4.4s-.3-.7-.6-.9c-.5,0-1-.2-1.5-.5-.6.6-.8.3-.5-.5-.2-.6-.2-.3-.4-.6-.2-.5.9-1-.6-1.9l-.5-1c.2-.2,2.1.3,2.5.5Z"
          fill="#2b97f8"
        />
        <path
          d="M277.2,89.4c.7-.3,1.1.5.5,1,0,.1,0,.3,0,.5-1.1,0-1.7-.6-1.5-1.7l.5-.3c0,.2.5.4.5.5Z"
          fill="#319bfa"
        />
        <path d="M277.7,91.4c0,.3.6.4.3,1-.5.9-1,.5-.8-.5.2-.1.3-.4.5-.5Z" fill="#0778eb" />
        <path
          d="M280.2,94.4c1.5,1.3,1.6,1.7-.5,2q-1,0,0,0c1.1-.7,1.6-.7,1.5,0,.9.9-.6,2.6-1.5,1-.3,1.2-.8,1.1-.5,0,.8.6.4,1.2-1,1.9.4.2.4.3,0,.5l-1.5-.5c.3,2-.6,1.3-1,1.5.4-1.2-1.8-.8-1-2s.3.6,1.5-.5c-.5.5-2.4-.6-2.5-1.5.9,0,3.4.6,2.5,1.5.6-.6,1.4-1.1.5-2v-.5c.1,0,.3,0,.5,0,.7-.7,1.4-1,2-1,.3-.1.8-.5,1-.5Z"
          fill="#0b87f0"
        />
        <path
          d="M274.7,82.9l-.5-1.5c1.4.9,2.5.1,4,0l-1,1c1.2.3,2,.1,3,0s1.6-.6,3-.5c.5.8,1.4,1.1,2.6.8-.5.7-.4.6.4-.3,1.9.6,5.5.2,7.2.5s.2.7,1.3,1c.5-.5,1.1-.5,2,0,.5.3,1,.7,1.5,1s.8-.1,1,0c1.8,2.4.2,4.1-2.2,2.1-1.9.8-2.7.6-2.3-.6-1.2,1.1-2.7.8-4.5-1-.5,1-1.7,1.4-2.4.5-1.5,1.1-3.1.7-4.9-1.2l-.6.2c-.1.4-.3.4-.5,0-1,.2-.5-1.1-.4-1.1.3,0-1.1,3-2.1.1-3-.5-1.3-.4-2.5-1.2s-1.5.4-2,.7v-.5Z"
          fill="#3d97f5"
        />
        <path
          d="M286.2,82.4c1.3,2.2-1.9.8-2.4.6s-2-.1-.6-1.1c.6,0,1.2.6,1.7.5s.1-1.2.5-1,.6,1,.7,1Z"
          fill="#4aa0fa"
        />
        <path d="M296.7,83.9c-1,.6-1.3.2-2,0,0-2.5,1.4-.4,2,0Z" fill="#3e83ed" />
        <path
          d="M301.7,86.9c.9.4,1,.8,0,1,0,.6-.5.6-1,.5.5.7.3.9-.5.5-.3,2.3-2.4,1.2-3.6,0,.7-1.6-1-1.4-1.4-.6.4.1.4.3,0,.5-.4.5-.7.6-1,0-1.2-.5-1.1-2.5.5-2.5.5.1.8.7,1.5.5v-1.5c1.5-.4.7,1.2,2.3,1.5s.6-1.3.7-2c1,.7.6,1.3,2.5,2Z"
          fill="#308df2"
        />
        <path
          d="M305.2,87.9c-.7.8-.2,1.3,0,2s.2,1,.5,1.5c.1,1.6-1.7,1.6-1.5-.5h-1.2c-.3-1.3-.7-2.3-1.3-3v-1c.6.2,2.5.7,3.5,1Z"
          fill="#329af6"
        />
        <path
          d="M307.7,88.9c0,.3,0,.7,0,1-.1,0-.4,0-.9.1s0,2-1.1-.1c.5-.8,1.2-.8,2-1Z"
          fill="#329af6"
        />
        <path
          d="M315.2,93.4c.6,0,1.1.6,1.5,1,0,0-1,.5-1,.5-.2.2-.2.4,0,.5.5.8,1.9,0,2.5,0-.3,2.7.8.9,1.7,1s.4,1.2,1.3,1l-1.5,1c-.1,1.3-.5,1.2-1,0l-1-.5-.5-.5c-1.8.7-3.7-.5-2.5-2.5-.4-.2-.4-.3,0-.5l.5-.5c-.4-.1-.4-.3,0-.5Z"
          fill="#2288f3"
        />
        <path
          d="M314.7,92.9c.5-.1.6,0,.5.5v.5l-.5.5c0,.2,0,.3,0,.5.2,1.7-.4,2.7-1.1,1-1.1,1-1.5.3-.9-1,.1-.7.1-1.3,0-2-.4-.1-.4-.3,0-.5.1,0,.3-.4.5-.5.4.2,1.1.7,1.5,1Z"
          fill="#319ffa"
        />
        <path
          d="M314.7,92.9l1.5-.7c-1.1,1.9.5,1.1,1.5,2,.2,1.5-.7.2-1,.2-1,.3-1.1-.6-1.5-1s-.3-.4-.5-.5Z"
          fill="#2584f0"
        />
        <path d="M315.7,95.4l-.5-.2.5-.2s0,.5,0,.5Z" fill="#259af9" />
        <path
          d="M301.2,90.9c.6-.5,1.6-.5,3,0,1.3,1.8,1.2.4,1.5.5s.7.4,1,.5c.2.5,0,1-.5,1.5.4.1.4.3,0,.5-.3.9-.7.9-1,0l-1.5-.5c-2.3,3-4,3.2-4.9.5l-.6-1c-.9-1.6,0-1.6,1.5-1,.4-.6.9-.9,1.5-1Z"
          fill="#259bf7"
        />
        <path
          d="M307.7,92.4c1.8,1,1.6.6,4,.5,0-.4.3-.4.5,0,.4.1.4.3,0,.5.4,1.6-.5,2.1-2.9,1.6-.3,1.4-1.4,2-2.1.9-.3,0-.3-.4,0-1-.4-.1-.4-.3,0-.5l-1-1c-.8-1-.4-.9.5-1.5.2,0,.4,0,.5,0l.5.5Z"
          fill="#2fa5fa"
        />
        <path d="M312.7,92.4v.5c0,.4-.3.4-.5,0-.2,0-.3,0-.5,0-.2-1.9.6-.4,1-.5Z" fill="#259af9" />
        <path d="M307.7,92.4l-.5-.5c.3.2.4.5.5.5Z" fill="#259bf7" />
        <path
          d="M317.7,98.4c.3.4.7.4,1,0,.3,0,1,0,1,0,.5.8-1.2,2,3,1.5-.4,1.3-1,.8-1.9.6-1.6-.3-.4,1.3,1.1,1.3s.8-1.3,1.7-1.4,1,0,1,0c.7,0,1.2.2,1.5,1,.7,0,1.2.2,1.5-.5.6.7.3,1.8,1.5,1.5-.6.6-1.7,1.7-2,2-.9-.1-1.7,0-2.5.5-.2,1.4-.4,1.2-1,0-.3-.1-.3-.3,0-.5-.4-.1-.4-.3,0-.5.4-.2.4-.3,0-.5-.2.6-.9,1.1-1.5,1l-.8-.2c-.8,1-2,1-2.2-.3-.4-.1-.4-.3,0-.5,0-.3.1-.6.5-1-2.4.3-3.7-.4-4-2-.6-1.5.4-3.8,2-2Z"
          fill="#1691f8"
        />
        <path
          d="M315.7,100.4c.2,0,.4.8.6.8,1.1.3,2.1-.7,3.4,1.2-.2.5-.6.7-1,.5,0,.4.1.8.5,1,.4,0,1.4,0,1.5,0,.3-.5-.6-1.9,1-1.5,0,.7.3,1.3.5,2,.6-.3,1.1-.3,1.5,0,0,.2,0,.3,0,.5.9.2,1.3,1.4.5,2q-.2.2,0,0c.2-.7.4-1.4.5-2,.2-.9.6-2.3,1.3-3l1.2,2.5c-.2.2-.3.7-.5,1,.3-.3,3.6,1.8,2-.7,0-.2.3-.3.5-.3l.5.5c.3.2.6.5,1,.5.3.1.3.3,0,.5-.1.2-.3.4-.5.5.4,1-.3,1.4-1,.5-.8,1.5-4.1.9-2.5-1.5l-.5,1.1c1.5,1.5.9,2.6-.9,1.2-.8.6-1.3.6-1.6.2-.2,0-.7,0-1.5,0-1.4.3-2-.2-1.7-1.4-1.5,0-2.4-.3-2.8-1.1-.3-.1-.6-.5-1-.5-1.5.8-1.9-.2-1.3-3.2l-1.2-.8c-.2-.4,0-.6.5-.5.4-.7.8-.9,1,0Z"
          fill="#119ff9"
        />
        <path
          d="M330.7,107.9l-.5.5c0,.1,0,.3,0,.5-.4,1.7-.2.5-1,1-.4-.3-1.4-.4-2-.5-1.5-.9-.9-2.2,1-1.9l1-.6c.3,0,.8-.3,1-.5.3.4.5,1,.5,1.5Z"
          fill="#109ffa"
        />
        <path d="M330.2,108.4c.1-.2.3-.4.5-.5,0,.2-.2.6-.5.5Z" fill="#0597f9" />
        <polygon fill="#109ffa" points="330.7 105.9 330.7 105.4 331.2 105.6 330.7 105.9" />
        <path d="M329.7,104.9c-.2-.1-.4-.5-.5-.5l.5.5Z" fill="#109ffa" />
        <path
          d="M327.2,98.4c-.4,1.6.2,2.5-1,3-2.2,0-1.3-.8-1.5-1,1.2-.8,0-1.9,2.5-2Z"
          fill="#2a8efa"
        />
        <path
          d="M352.2,151.8l.7-1.5c.7,1.2,1.1,3.4,2,1,.7.3.5,1.1.8,1.5-1.2.2-2.7,0-3.5-1Z"
          fill="#047ef7"
        />
        <path
          d="M355.7,152.8c1.9-.3,1.8-1.9,4,0-1.3,2.4-1.3-1-3.5.5,0,0-.2,0-.5-.5Z"
          fill="#037bf8"
        />
        <path
          d="M358.6,154.3c.2,1.3-.7,1.5-1,2-1.1-.3-2.3-.3-3.5-.5-.6-1.8,1.1-1.7,2-.5.2,0,.4,0,.5,0,.6-.2,1.5-.9,2-1Z"
          fill="#036ff4"
        />
        <path
          d="M364.1,153.3c.4.7-.1,1.2-1.5,1.5,0,0-.4.6-.7.5-1.5-.4,0-1.4.2-2,.7,0,1.3,0,2,0Z"
          fill="#046cf8"
        />
        <path
          d="M350.7,148.3c.7,0,2.2-.7,2.5-.5s-.5.8-.5,1c-.5.1-.7.7-1,1s-.4,0-.5,0l-.5-1.5Z"
          fill="#037ef3"
        />
        <path d="M364.1,153.3c2.1.1,1,.9-.5,1.5s-.7,0-1,0l1.5-1.5Z" fill="#0487f9" />
        <path d="M353.7,149.3c0,.7-.9.8-1,.2l.5-.2c.2,0,.4,0,.5,0Z" fill="#036df2" />
        <path
          d="M346.7,146.3c-1.7-.4-.7,1.9-1.5,3.2,0,.5.7.1,1,.3.2-.3.3-.3.5,0,0,0,.8,1,.2,1-1-.5-2.9.3-3.2-1,.4-.6.4-.9,0-1-.6.6-.3,1.3-1.5,1,.1-.5.4-.9.5-1.5-.4.2-1.1.2-1.5.5-.5-.1-.4-.3,0-.5,0-.5.2-.9.5-1,.9-1.1,2.6-.5,1,1,.2-.9.9-1.8,2-2.5.7-.7,2.4-.6,2.5.3s-.5.2-.5.2Z"
          fill="#04a3fa"
        />
        <path
          d="M344.7,141.3c.1,0,.3.4.5.5.7-1.2,1.1-.9,1,.5,1.1.9.6,1,1,1.5,1.2,1.4,3.2,1.1,5,1.5,0,.4-.8,1-1,1.5-.7-.2-1.3-.6-2-.5l1-1c-1.7-.1-3.9-.5-5.5-1-.2.6-1.6-.3-1.5-1-.4-.1-.4-.3,0-.5-.6-.5-.6-1,0-1.5.2,0,.3,0,.5,0,.5-.3.8-.3,1,0Z"
          fill="#08a7fa"
        />
        <path
          d="M344.7,144.3c0,.5,0,1.1,0,1.5-.3,1.2-.9,1.9-2,2.5.2-1.6-.3-.8-1-1-.1.3-.3.3-.5,0-.6.3-1.2.2-1-.5-.8-.2-1-1.4,0-1.5.6-.8,1.1-.7,1.8-.1-.1-.3,1.8-1.1,2-1.1.4,0-1.7,1.4-2.2.8-1-1.2,0-2.5,1.4-1.5.5.2,1,.8,1.5,1Z"
          fill="#0388f8"
        />
        <path d="M350.2,148.3c0,2.6-1.3,2-1-.5.5,0,.9.5,1,.5Z" fill="#037ef3" />
        <path d="M347.2,147.8c-1.8,1.1-.8,0-.5-1,.5,0,.6.6.5,1Z" fill="#026cee" />
        <path
          d="M351.7,141.8c.2,0,.3,0,.5,0-1,1.6-.6.5-2,1.5.4.6.1.8-.5.5-.1,0-.3,0-.5,0-.2-.3-.3-.7-.5-1,1,0,1.9-.8,3-1Z"
          fill="#05a5f9"
        />
        <path d="M353.2,143.3c.5,0,1,0,1.5,0v1.5s0,.5,0,.5c-1.1-.5-1.8-.3-1.5-2Z" fill="#0278f2" />
        <path
          d="M354.2,141.3c.3,0,.7,0,1,0-.6.7-1.3.4-2,.5-.4-.1-.4-.3,0-.5.3,0,.7,0,1,0Z"
          fill="#0382f8"
        />
        <path d="M350.2,143.3l.5.3c.1,1.6-.9.3-1,.2.2-.2.3-.4.5-.5Z" fill="#036df0" />
        <path d="M353.2,141.3v.5c-.3,0-.7,0-1,0,.4-.7.5-.4,1-.5Z" fill="#0260ea" />
        <path
          d="M349.2,139.3c.3.1.5,1,.8,1,.6,0,.6-.5.7-.5.8-.3.8-.9,1.5.5-.4,0-.9,0-1,.5h-.5c-1.2-.3-1.6.4-2-1.5.1-.4.3-.4.5,0Z"
          fill="#046af2"
        />
        <path d="M351.7,141.3c-.4,0-.8-.5-1-.5h.5l.5.5Z" fill="#05a5f9" />
        <path
          d="M340.2,131.8c.2-.4.3-.4.5,0,1.3.2-.6,1.5-.6,1.4.2-.5,1.2-1.2,1.6-.4.3.1.4.8.2,2,1.2,0,1.3,1.4.3,2,0,0-.5,0-1,0-.6,1.2-2.7.9-3.5,0,.2-.6.8-.4,1-.5,0-1.3-.6-1.9-2-2.1-1-1.4,1.6-2.8,2.5-2.4.4-.2,0-.6,1,0Z"
          fill="#06a4f9"
        />
        <path
          d="M341.7,132.8c.7-.2,1.3,0,2-.5.2,1.5-.3.8-1.1,1s-.4,1.4-.4,1.5c.3.3,1.6-.5,1.9-.4s3,3.3,1.8,3.4c-1.5,0-2.2-.7-3.7-1-.7-2-.6-2.2-.5-4Z"
          fill="#0283f4"
        />
        <path
          d="M336.7,125.9l1.5.5c.7.8.1.3-.5,1-.9,1-1.7,2.6-2.2.5l-1.3.5c0-.2,0-.4,0-.5l.5-.5c.2-.2.3-.3.5-.5-.7-.7-.4-1,.5-.5.3-.1.8-.5,1-.5Z"
          fill="#07a3fa"
        />
        <path
          d="M340.2,130.8c1.4.3.5-1.4,2-1-.3,1-.4,2-.5,3-.6.1-1.2.7-2,.5l1-1.5q.2-.2,0,0c0,0-.4,0-.5,0-.2-.3-.3-.7-.5-1,.1-.4.3-.4.5,0Z"
          fill="#037cf2"
        />
        <path
          d="M348.7,139.3c-.1,0,0-.6-.7-.5s.2,1.3-1,1,.7-2.4,2-2.5l.3,2c-.1,0-.4,0-.5,0Z"
          fill="#0281f5"
        />
        <path
          d="M345.7,140.3c0,0-1.6-.1-1.5-1,2.2-.5,1.3.8,1.5,1s.9-.1,1,0c.3.4-1.4,1.9.5,1.5.4.1.4.3,0,.5-.3,0-.7,0-1,0,0,0-.8-.4-1-.5,0-.4.5-1.4.5-1.5Z"
          fill="#0384f4"
        />
        <path d="M343.2,141.3c.7.9.3,1,0,1.5-1.1-.1-2-.6-1-1.5h1Z" fill="#0388f8" />
        <path d="M348.7,142.8c-.9,0-1.1-.4-1.5-.5v-.5c.9,0,1.1.4,1.5,1Z" fill="#0daefa" />
        <path d="M347.7,135.3c0,0,.5,1.1-1,1.5l.5-1.5h.5Z" fill="#17acf9" />
        <path d="M339.7,130.8c-1.1-1.8.8-1.5.5,0h-.5Z" fill="#0366ed" />
        <path d="M338.7,131.3c-1.3,0-1.1,0-.5-1,.5.5.3.7.5,1Z" fill="#06a4f9" />
        <path d="M344.7,141.3c-.2,0-.7,0-1,0l.7-.5.3.5Z" fill="#0384f4" />
        <path
          d="M330.2,123.4c.2.2.3.3.5.5v.5c-1.1,1-2,.4-1.5-1,.1-.2.4-.3.5-.5.2.2.3.3.5.5Z"
          fill="#0480f4"
        />
        <path
          d="M328.7,123.4c.2,0,.4,0,.5,0s1.4.9,1.5,1,.8,1.8,1.5,2c-1.2,1.6.5.6,1.5,1.7-1.4,1.7-.8-.1-1-.2-.7-.4-1.5.8-2,1.5.9,0,1.7.3,2.5.5.1-.3.3-.3.5,0,1.8,2.2,0,1.9,0,4l-1,.5c-.7.5-1.3,0-.8-.3s.6.5.4.7-3.1,0-2.6-.4c-1.3-.6-.9-1.8.5-2,.2-.6.6-.5,1,0,.9-1,.9-1.1,0-.5-1.2-.4-2.5-.7-3.9-.9.4,1.9-2.8,1.9-3.2-.1s1.2-3.1,1.5-3.1c.6.5,4.1.7,1.5.1-1.3-.7-1.8-1.8,0-2q.9,0,0,0h-.5c-2.2-.9,0-3.3,2-2.5Z"
          fill="#049df9"
        />
        <path
          d="M332.2,126.4c.8-3.1,1.1-.5,1.3-.5.7,0,1.5-.6,2-1l.2,1.5c-.1,0-.3.3-.5.5l-3-.5Z"
          fill="#049df9"
        />
        <path d="M337.7,125.9c.4,0,.4.4.5.5l-1.5.5c0-.3,0-.7,0-1,.2,0,.8,0,1,0Z" fill="#0590f8" />
        <path d="M337.7,125.4l.5-.5s-.1.5-.5.5Z" fill="#0590f8" />
        <path d="M338.2,124.4l-.5-.5c.1.2.4.3.5.5Z" fill="#0590f8" />
        <path
          d="M373.1,209.8c.4.1.4.3,0,.5.3.2.3.6,0,1-.2.5-.5.8-1,1,.8.9-1.2,1.3-1,0-.7-.9-.6-1.6.5-2,.2,0,.3,0,.5,0,.6,0,.4-.6.5-1,.3,0,.5.5.5.5Z"
          fill="#0346eb"
        />
        <path d="M370.6,198.8c1.6-.3.8.7,1,1.5h-.5c-.9-.2-.8-.8-1-1.5h.5Z" fill="#0263ee" />
        <path
          d="M376.1,195.3v.5s-.5.5-.5.5c-.1.4-.3.4-.5,0,0,0-.5-.5-.5-.5l1-1c.6-.5.8-.2.5.5Z"
          fill="#0353eb"
        />
        <path
          d="M367.1,203.8c-.3,0-.7,0-1,0-.5,0-1,0-1.5,0v-.5c1.8.5,1.8-.5,2.5-1,0,.5,0,1,0,1.5Z"
          fill="#038ef9"
        />
        <path
          d="M385.6,201.3c.2.7.7,1.4,1.5,2,.3,0,.9,0,1,0,.3.2.8.9,1,1,.4.1.4.3,0,.5l-.5,3.5,1.5-1.5c0,.8.8,1.4,1,2s-.2,1.2.5,1.5c0,.3.6.6.5,1-.2.1-2.5-.4-3-.5.2,1-.6.7-1,0-.3-.9-.6-1.7-1-2.5-.6.2-.7-.3-.5-1.5l-.6-.5c-.6.8-1.3.8-1.9,0-1.8.3-2.8-.1-3-1.2l-1-.8c.3-1.8.1-.6,1.6-1s.3-.9.4-1c.8-.6,1.1.3,1,1,0,.5,1.5-.3.5-.5.4-1,1.1-2.1,1.5-3,1.1.6,1.3.6.5,1.5Z"
          fill="#0348f4"
        />
        <path d="M383.6,202.8c2-.2.5,1.3-1,1-.1-.4.5-.4.5-.5.2-.1.4-.3.5-.5Z" fill="#0165f5" />
        <path d="M385.6,201.3l2,.5-.5,1.5c-1,.2-2.5-.2-2.5-1.3s.8-.5,1-.7Z" fill="#0235ed" />
        <path
          d="M386.6,206.8c-.4.9-.4,1.8-1.5,1.5,0-.2-.2-.6-.5-.5,0,0,0-.3,0-.5l-.5-.5c0-.2,0-.3,0-.5.5-.3,1.2-.4,1.5-.8s-.4-1.8.7-1.2.2,2,.3,2.5Z"
          fill="#0338ef"
        />
        <path
          d="M388.1,210.8c-.1,0-1.5-1.7-1.5-1.8,0-.4.5-.6.5-.7,1.1.6,1.9,1.4,1,2.5Z"
          fill="#0236ef"
        />
        <path d="M390.1,209.8h-1c-.2-.7.2-1,.7-1.5l.2,1.5Z" fill="#0230ee" />
        <path
          d="M378.1,209.3c2-3.2,3.4-.3.5.5-.3.4.9.8,1,1s0,.4,0,.5-.6,2.3-.6,2.4c-.1.3-.8.3-1,.6s-.7,3.1-1.8,1c.2-.4.2-.7,0-1,0,0,1.2-2-.2-1.5s0,1.1-.8,1.5c-.1.5-.3.4-.5,0-.4-.1-.4-.3,0-.5-.3-.4-.4-.8,0-1-.4,0-.4-.3,0-.5-1-.1-1-.6,0-1,.7-.2,2-.4,2.7,0s-.3,1.9,1.3,1.5c.2-.9-.7-1.5-.9-2.3s.4-1,.4-1.2Z"
          fill="#024af1"
        />
        <path
          d="M374.6,209.8c-.7,1.2,0,1.3,0,1.5,0,.3,0,.7,0,1-.1.4-.4.4-1,0,0,.4-.3.4-.5,0,0,1-.5.8-1,0-.4-1.4.9-.9,1-1,.2-.4.2-.8,0-1v-.5c.5,0,.7,0,1.5,0Z"
          fill="#0577f7"
        />
        <path d="M375.6,208.8c.4.9,2.4,1.3-1,1,.2-.3.8-.6,1-1Z" fill="#0244f1" />
        <path d="M375.6,208.8c-1.5.2-1.3-.7-.2-1.5.6.1,0,1.2.2,1.5Z" fill="#137ff8" />
        <path
          d="M381.1,191.8c0,.3,0,.7,0,1-1.4.2-2.5-1-2-2,.2-.2.3-.2.5,0-.5-.8.4-1,1-.5,0,.1.4,1.2.5,1.5Z"
          fill="#0259ee"
        />
        <path
          d="M381.6,194.3c0,.3,0,.9,0,1s-1.9.6-2,.5c-.2-.9.4-1.4,1-2,.3.1.7.4,1,.5Z"
          fill="#0262f3"
        />
        <path d="M377.6,195.8c.3-2.1,2.5-2.3.5,0h-.5Z" fill="#025bed" />
        <path d="M375.6,194.3c.9-.4,1.6.5.5,1,0-.3-.5-.5-.5-.5,0-.1,0-.5,0-.5Z" fill="#0367f5" />
        <path d="M383.1,193.8c0,.2,0,.3,0,.5h-.5c0-.8-.3-1.7.5-1.5,0,.3,0,.7,0,1Z" fill="#035df6" />
        <path
          d="M387.6,212.8c.4-.4.4-1.2,1.2-1,.7,1.7,1.5,1.7,3.3,1.5,0,1.5-.5,2-1,3-1.7-.2-3.2-1-1-1.7-.3-.7-1.3-.6-1.5-.8l-.5-.5c-.2-.2-.3-.3-.5-.5Z"
          fill="#0334ef"
        />
        <path
          d="M370.6,249.8c.2.1.1.9.9.4.1-1.8.9-.4,1.1-.4.8.4.4.7-1,1,1.1-.7,1.7-.7,2,0-1.4,1.1-.9,1.9-1,2-1.3,1.4-.2-1.9-1.3-.5.6,2.7-.4,1.1-1.7,1-2.4,2.5-3-2.1.7-1.3s-1.3,0-.7-.7c-.4-.8-1-2,0-2.5.4.3.6.7,1,1Z"
          fill="#0351f4"
        />
        <path
          d="M369.6,251.3c.1.2,1.1.4,1,1-1,0-2.5,0-2.5,1.2.2.7,1.3-.3,1.5-.2,0,.3,0,.7,0,1h-.5c-1.2,1.1-1.9,1.1-2,0-.4-.1-.4-.3,0-.5v-.5c-1.2-1.2,0-2.1,1.5-2,.2,0,.7,0,1,0Z"
          fill="#0138ec"
        />
        <path
          d="M374.6,249.8c-.2-.2.5-1.6-2-1,1.4-.9-.3-2.8,1.5-2.5-.7,1.9,1.3,1.8,1,3.5-.2,0-.4,0-.5,0Z"
          fill="#0237ed"
        />
        <path d="M374.6,250.3c-.1.5-.9.4-1,.5h-2s1-1,1-1c.5,0,1.2-.6,2,.5Z" fill="#0237ed" />
        <path
          d="M369.1,254.3c-1.3.7-.8.7-.5,2-.8.1-1.5-.4-2-1,0,0,0-.4,0-.5-.7-.7-.4-1,.5-.5.5-.1,1.4,0,2,0Z"
          fill="#033ff2"
        />
        <path
          d="M368.1,249.8c0,.4.1.8.5,1v.5c-.6.3-1.2,1.4-1.5,2v1s-.3.4-.5.5c-.8.7-1.5-.2-2.5-.5-.9-.7-.5-1.6.5-2,1.6-.3.9-2-.5-2.5.3,0,.5-.4,1-.5s1.2.5,1.3.5c.3,0,0-1.3,1-1,.4.2.5.7.8,1Z"
          fill="#0351f4"
        />
        <path
          d="M357.2,215.8c.7-.5,1.4-.3,2,.5.6,0,1.6,1.6.5,2,.7,0,1.2.8,1.5,2,.1-.4.3-.4.5,0,.4,2.8,1.6,3.4,3.2,1s.5-.2.8,0c.1-.4.3-.4.5,0,1,0,1.2.3.5,1,0,.9,1.1.4-1,2l-.5.6c-1.7-.5-3-.6-4.5.4,0,0,0,.6-.4.5-.2-.3,0-.8,0-1-.6-.5-1.5-.7-2.5-.5,0,.2.3.8.5,1,.6.9-.3,1.2-1,.5-.4-.7-.3-2,0-2.6s1.2,0,1-.9c-1.2.8-2.2,0-2.5,0,0-.5-.1-.6-.5,0-.2,0-.3,0-.5,0-.4-.1-.4-.3,0-.5-.8,0-.8-.8,0-1-.4-.1-.4-.3,0-.5,1.3,0,2.8.3,4.3,1,.3,0-4.6-.8-4.3-2-.4-.1-.4-.3,0-.5-.1-1.3,0-1.2,1-.5.3,0,.7,0,1,0,.8,1.4-.2.5.2.5s1.6.2,1.6.2c-.7,0-1.9,0-1.8-.8,0-.5-.7-3.1-.5-3.5h.5c0,.4.3.8.5,1Z"
          fill="#0474f7"
        />
        <path
          d="M361.6,232.3c-.4.1-.9.7-1.5.5v-2c-4.1.7-1.3-2.7,1.5-1l-1-1c2.3-2.8,1.3.9,1.5,1s.8,0,1.5,0c-1.1.5-1.6,1.5-2,2.5Z"
          fill="#034ef4"
        />
        <path
          d="M355.7,233.8c.6-.9-2-1.2-1-2s1.7.5,2.2.5,0-1.4,1-1c2.2.8-1.1,1.1-.7,2.5,1.1-.6,2.2-.9,3,.3l-1,.2c-.9,0-1.9.6-2.6.5s-.6-.8-.9-1Z"
          fill="#034df3"
        />
        <path
          d="M355.2,226.3c0-.4-.8-2.6.3-3s.2,1.3.8,2.2.6.6,1,.8c.5-.4,1.2-.4,2,0,.1.2.8,0,.5,1-1.8.9-2.9-.8-4.5-1Z"
          fill="#0475f6"
        />
        <path
          d="M365.6,224.3c0,0,.3.4.5.5.4.1.4.3,0,.5-.2.2-.9.3-1,.5-1.1.1-2.3,0-3.5-.5-.3,0-.7,0-1,0,.7-2.1,3.1-1.3,5-1Z"
          fill="#033de8"
        />
        <path
          d="M354.2,226.3c.3.1.3.5,0,1,.2.2.3.3.5.5.7,1.3-1.1,1.7-1.5.5-.2,0-.3,0-.5,0-.8.4-.8-.9-.5-1.5.5-.2.4-.7.5-1,.4-.6.8-.8,1.5-.5.7.7.1.3,0,1Z"
          fill="#0477f7"
        />
        <path d="M357.7,224.3c0-1.2,2.5-.5,3.5-1l-1,1.5c0-.1-1.8.5-2.5-.5Z" fill="#0353ed" />
        <path d="M354.7,227.8c1.6,1.2.4.4,1,1.5l-2.5.5v-1.5c.5-.1,1.2.2,1.5-.5Z" fill="#0151f3" />
        <path d="M359.1,226.3c-.3.9-1.4.3-2,0v-.5l1-.5c.1.2.6.5,1,1Z" fill="#0144e9" />
        <path d="M355.7,229.3c0,0,1.5.2,1.5,1l-2.5,1,1-2Z" fill="#024ff1" />
        <path
          d="M352.2,226.8c.2.5.2,1.1.5,1.5,0,0-.3.7-1,.5,0-.6,0-1.4,0-2s0-.3,0-.5c.2.1.4.3.5.5Z"
          fill="#023be2"
        />
        <path
          d="M355.2,226.3c0,.5-.6.8-1,1,0,0-.4,0-.4-.2,0-.3.4-.6.4-.8.3,0,.7,0,1,0Z"
          fill="#034af2"
        />
        <path
          d="M383.1,218.8c0,.5-.3.4-.5.5l-.5,1.2c-2.3-.8-3.8-1.1-2.5,1.8v.5c-.7.4-1.4,0-1.5,0-.3.4.5.9.5,1,0,.1-.4.5-.2,1,.6,1.4,2,.3,2.2.5s-.9,3.1-.9,3.3c0,.5.8.6.9.7s0,.7,0,1c0,0-.9.7-1.5,1,0-.3,0-.7,0-1,0-.6.2,0,0-1-1.1,0-1.3-.5-1-1.5.6-.6,1.6-.2,1.5-1-.5-.3-1.6,0-1.8-.1s-.5-1.9-1.2-.9.4,1.1.4,1.7-.9,1.1-.9,1.3h-.5c0-.4-.1-.9-.5-1-1.4,0-1.3-.6.5-2-.3-.7-.4-1.6-.5-2.5,1.1-2.6-.6-1.4-1-1.5-.6.1-1.3.1-2,0-.2.1-.3.4-.5.5-1,0-1.9-1.4-1-2.5-.5-.7-.3-1,.5-.5l3.2,1.5c-.4-2.8,2.9-.7,3.3-1l-.5-1.5,6,.5Z"
          fill="#034df6"
        />
        <path
          d="M375.6,225.8c-.1.4-.3.4-.5,0-.3,0-.5-.3-.5-.5-.9-.5-.8-1.4,0-2,.2,0,.4,0,.5,0,2.3.9,1.2.5.5,2.5Z"
          fill="#0231e8"
        />
        <path d="M368.1,249.8c.2.3.3.7.5,1l-2,.5c.4-.8.4-1.8,1.5-1.5Z" fill="#033aea" />
        <path
          d="M360.1,234.8c.4.3.8.5.5,1,.5,0,.4.2,0,.5-.2.2-.2.4,0,.5.1-.4.3-.4.5,0-1.1.6-1.8.6-1.9.6-.3.2-.7,1.5-1.1,1.9q0,.7,0,0c1.5-.3.6,1.8,2.5,2.3,0,.4-.8.3-1,.2-.4.7-1.2,1.2-2.5,1.5-.4,1,.4,1.6,1.3,1.2.2,1.5,1.7,2.2,4.4,2l.3.8.5.7c1.7-.2,2.2.3,1.5,1.3-.1.2-.4.4-1,.5.1.5-.6.3-.5.3,1.9.3,3.1,1.6,1,1.7-.4,1.4-.9,1.1-1-.4-.6-1-2.9,1-3.4,1.5h-.6c0-.1,0,.4,0,.4.3.2.3.3,0,.5.1.6-.4.6-1.5,0-1,1.3-2.3,1.4-4,.5,0,.2,0,.3,0,.5-.8,1-1.4.6-1-.5-.3-.9-.4-1.5.5-2-.7-.5.4-.8.4-.8-1.5,1.2-6,.2-3.9-2.2-1-.7-.9-1,.5-1,0-.4-.5-.5-1.5-.5-2.3,0-1.4-2.7.5-2.5.9-.8,1.1-1.2.6-1.1,1.1-2.2,2.4-1.9,3.4,0,.3-.5.3-1,0-1.5,0,.4,0,.7,0,.7-3.2.4-1.4-4.1,1.7-4.5,1.1-1.5,2.4-2.9,3.9-4.2,0-.5.8-.5,1,0Z"
          fill="#0359f7"
        />
        <path
          d="M357.2,243.3c.6-.4.2-1.5,0-2,1.7-.4.4,1.5,2,1v-1c.6,0,.5.5.5.5v1l1,.5h.5c.7.1.7,1.3,0,1.5,0,.5-.4.6-.9.4l2.4.6c-.6-.4-.8-.7-.5-1-.4-.1-.4-.3,0-.5.8.8.9.6,1.5.5.2-.7.5-.5,1,0,.4.8,1.6,1.5,1.5,2.5,0,.5.1.7.5.5.6-.7.6-1.1.5-2l1.5.5-1,1.5c.3,0,.8,0,1,0,.4.2.7.7,1,1,.3.6.7,1.8,0,2.5,0,.8-.8.8-1,0-.4-.1-.4-.3,0-.5-1.2.2-1.4-.1-.5-1-.8-.3-1.4,0-2,.8l-1-1.3c-.6-1.4-2.1-.3-2-2q1-.4,0,0c-3.5-1.1-.8.9-3.8,1.5l.3-2c-.7-.3-2.4.6-2.5.5-1-.9,1-1,1-1.2.1-1-1.6-1.1-2-2.5,0-.5.8-.1,1-.2q1.2.6,0,0Z"
          fill="#0244f0"
        />
        <path
          d="M359.6,252.8c.9-1,3.9-3,4.3-1h.7c.4.1.4.3,0,.5-.2.7-.3,1.3-.5,2-.5-.1-1.2.2-1.5-.5,0-.1,2-2.6.3-2.5s-1.8,1.6-2.2,2-.8.3-1,.5c0,0,0-.3,0-.5v-.5Z"
          fill="#033bed"
        />
        <path
          d="M350.2,249.3c.8.2-.3,1.7,0,2,1,1,1.8-1.8,2.5-1s0,1.1,0,1.5l1.5-.5c.2.1-.5.8-.5,1-1.8,0-5.2.2-4.5-2.7s1-.2,1-.3Z"
          fill="#0247f1"
        />
        <path
          d="M364.1,249.8c2.1-.8,2.3,3.5,1.2,4l-.7-1.5c0-.1,0-.3,0-.5s.9-.4.3-1-1.2-.5-1.8-.5v-.5c.3,0,.8,0,1,0Z"
          fill="#0348f4"
        />
        <path
          d="M354.1,247.3c.2.2-.5,1.2.8,1s.3-1.9,1.3-1-1.7,2.1-2,2.3c-.8.3-1.6-.4-2.5-.3.9-1.9,2.8.9,1.5-2,.3,0,.9,0,1,0Z"
          fill="#0344f3"
        />
        <path d="M362.6,248.3c.3,1.9-.9,2.2-2.5,2l.2-1,1.3.5,1-1.5Z" fill="#0241ee" />
        <path d="M359.1,251.3c.5.5-1,2-1.5,1.5s1-2,1.5-1.5Z" fill="#0140ed" />
        <path d="M350.7,248.3c-.6,0-1.2.2-1.5-.5l.7-1,1.2,1.3c0,.1-.4.2-.5.2Z" fill="#0140f2" />
        <path d="M356.7,249.8c-.8-.8,1.4-1.6,1.5-1.5.5.6-1,2-1.5,1.5Z" fill="#0332ea" />
        <path d="M359.6,253.8c0,.1,0,.7,0,1l-1.5-1c.2,0,1.4,0,1.5,0Z" fill="#0e79f2" />
        <path d="M354.6,245.3l-.2,1.5c-.5-.5-.9-.8-.7-1.5h1Z" fill="#0237ea" />
        <path d="M358.2,239.3c1.1,1.4,0,1.4-1,.2,0-.5.9-.1,1-.2Z" fill="#0337ee" />
        <path d="M360.6,235.8l-.5-1c1.6.4.5.9.5,1Z" fill="#034ef4" />
        <path d="M360.6,236.8l-.5-.2.5-.2c0,.2,0,.3,0,.5Z" fill="#034ef4" />
        <path d="M359.6,253.3c0-.2-.5,0,0-.5v.5Z" fill="#034bf5" />
        <path d="M357.2,243.3c.6.2,1.9-.6,2-.5.6.8-1.4,2.5-2,.5Z" fill="#0a60f5" />
        <path d="M363.1,247.3c0-.7.2-1.4,1-1.5l.5,2c-.7.2-1.1-.4-1.5-.5Z" fill="#085bf5" />
        <path d="M362.1,244.8c0,.3.6.6.5,1-.5-.3-1.3-.2-1.5-1,.3,0,.7,0,1,0Z" fill="#034ef4" />
        <path d="M379.1,229.3h-2c0,0,.8-1.3,1-1.5.8.2.8.8,1,1.5Z" fill="#022ce5" />
        <path d="M381.1,230.8c.2.2-.5.8-.5.2s.4-.4.5-.2Z" fill="#388df4" />
        <path
          d="M382.6,219.3l.5,2.5s-.3.2-1,0l-1.5-1c-.3,0-.9-.7-1-.5v2s-3.3-1.5-3.3-1.5c1.1-1.3.6.6,1,.5,1-.2,1.4-1.6,2.1-1.9s2,.4,3.2-.1Z"
          fill="#055bf6"
        />
        <path
          d="M380.6,211.8c-.4,1.5-1.4,1.2-1-.5-.4-.2-.4-.3,0-.5-1.1-.4,1-1.8,1.4-1.4s.3,2.1-.4,2.4Z"
          fill="#0346f4"
        />
        <path
          d="M384.6,207.8c.8-.7,1.1-.4.5.5,2,.9,1.5,2.9-.5,3.5-.3.6.3.7,1.8.3l.2,1.2c.4.1.4.3,0,.5.8.3.8.6,0,1-.5.3-1,.3-1.5,0-.3-.5-.6-.9-1-1,.5.7.5,1.4,0,2.1,1.2.5,2.3,1.1,1.5,2.4,1.5-.4,2.6-.2,3.5.5.3-1.9.9-2.7,2-2.5-1.1-.7,0-2.6,1-3-.9.1-1-.2-.5-1,.4-.5,2.2-1.2,2.5-1,1,.8-1,1-1,1.3s.6.9.4,1.1-1.1-.2-.9.3c.3,1.1,1.3.3,2,.2-.9-1.3-.2-.8,1-1.5v2.5s1.5-3,1.5-3c-.3.9,1.1,1,1,1.2-.1.5-.7,0-.9.3s.4,1,0,1.9-.9,1-1,1c-.9.6-1.8,0-2.5,1.3-.2,1.6,1.2-.2,1.8.7s.3,1,.2,1.5c-.1,0-.4,0-.5,0-.3-.1-.5-.5-.5-1l-.5,1c0,.5-.3.5-1,0-2.4-1.1-1.4-2.5-.5-.6s.3.4.5.6c1.4-.1,1.9.2,1.5,1,0,.3,0,.7,0,1-.2,2.6-1.4.8-2-1-.1,0-.3,0-.5,0-1.2,2.6-2.2,3.1-3,1.5-.8,1.1-1.2.8-1-.5,0-.4,0-.7,0-1-1,.3-1.1-.2-.5-1,.4-.8-1.8.5-1.3,1.5-2.5.9-3.7-.3-3.2-3-1.4-.3-2-.8-2-1.5-.8-.4-1-.7-.5-1-1.3-2-1.3-3.5,0-4.5.6-.8.7-1.7.3-2.6.9-1.1,3.1-3.1,3.7-1.4Z"
          fill="#0346f4"
        />
        <path
          d="M395.1,220.3c0,0-.5.8-.5,1-.7,0-1.1-.7-1.5-1,0,0,.9,0,1,0l.5-1,.5.3v.7Z"
          fill="#0234ee"
        />
        <path
          d="M383.1,218.8c.8.9,2,1,0,1.7,2.1,3,2.5-1.1,5-.7.1.4-.5.4-.5.5.1.5,0,.6-.5.5l-.5.5c.5-.2,1-.2,1.5,0,.7-.2.9-1,1.5.5-.6,0-1,0-1.5.5,1.3.7,0,2.3-1,1.5h-1c-.2-.3-.3-.7-.5-1-.1,0-.4,0-.5,0-1.6.5-2.2.1-2-1-1.5-1.1-1.6-2-.5-2.5,0-.2,0-.4.5-.5Z"
          fill="#0234ee"
        />
        <path
          d="M387.6,212.8c.4-.2.6,0,.5.5l.5.5c1.4-1.3,2.3.7,2.5,2.5-.7,1.4-1.3,1.5-2,2.5-1.1-.4-2.3-.6-3.5-.5-.7-.4-1.1-2.2-3-1-.3-.3,1.1-3,1.5-3.5.3,0,.7.3,1,1,.6,0,.2-1,.7-1,.4,0,.4.7.7,1,.7,0,.7-.3,0-1,0-.2,0-.4,0-.5-.4-1.4.2-1.7,1-.5Z"
          fill="#0453f7"
        />
        <path d="M385.6,218.3l3.7-1.5-.3,2c-.1.2.3,1-.2,1-.9-1.1-2-.9-3.3-1.5Z" fill="#023af1" />
        <path
          d="M393.1,220.3c-.9-.5-3.5-.8-3.5-1.2,0-.7,1.5-.8,2-.2-.5-1.3.8-2.2,1.5-1.5s-1,2.4,0,3Z"
          fill="#0230ee"
        />
        <path
          d="M387.6,212.8c-.1.1-.7,0-1,.5l-2.5-1c-.1-.4.5-.4.5-.5,1.3,1.3,1.4-1.1,1.7-1,.9.3,1,1.8,1.3,2Z"
          fill="#0136f0"
        />
        <path
          d="M388.1,221.3c-.4.1-1.4,1.1-1.5,0l.5-.5c.2-.2.3-.3.5-.5,0,.2.4.7.5,1Z"
          fill="#0964f2"
        />
        <path d="M385.1,214.8c-.5,0-.8-.6-1-1,.7-.7.9,0,1,1Z" fill="#0321e3" />
        <path d="M394.1,220.3l.5-1c0,.3-.3.9-.5,1Z" fill="#022deb" />
        <path d="M392.6,216.8c-.2-.2-.3-1.9.7-1.5,1.5.6-.3,2-.7,1.5Z" fill="#0131f0" />
        <path d="M386.6,221.3c0-.4.1-.5.5-.5-.2.2-.3.4-.5.5Z" fill="#0346f4" />
        <path d="M380.6,220.8c1,.2,1.8-.6,1.5,1-.1,0-1,.6-1.5-1Z" fill="#0234ee" />
        <path
          d="M371.1,212.8c.7.5-.3.8-.3.7,1.2-1.7,4.1.5,1.3.8.8.6,1.3.6,2,0,.1-.4.3-.4.5,0,.2,0,.4,0,.5,0,0,.6.4,1.1.5,1.5,0,.9-.8,1-1,0l-.5.5c1,0,.9.7,0,1l-.5.5c-.1.4-.3.4-.5,0,0-.5-.2-.3-.5-.5-.1.4-.3.4-.5,0-.8.6-1,.2-1.5-.5-.8-.1-1.3-1-1.5-2.5-1-.9-.9-1.1.5-1-.6-.7-.4-1,.5-.5.2-1.3.6-1.3,1,0Z"
          fill="#0463f6"
        />
        <path
          d="M375.6,215.8c.1.6.5.3-.5,1.5l1.5.3c-.5.9-1.5.5-2,.8.4-.4-.5-.9-.5-1,0-.2,0-.8,0-1l.5-.5c.2,0,.7,0,1,0Z"
          fill="#024cf6"
        />
        <path d="M374.6,218.3c0,0-.3.7-.8.9-2,.8-.6-.7-.7-1.4h.5c0,.5.8.7,1,.5Z" fill="#034df6" />
        <path d="M372.6,217.3c.2,1.3-.3,1-1.5,1-.2-.9,0-1.2,1-1,.2,0,.4,0,.5,0Z" fill="#034df6" />
        <path d="M388.6,213.8l-.5-.5c.2.2.3.4.5.5Z" fill="#0346f4" />
        <path
          d="M380.1,204.8c.6-.1,1.1,1.9,1,2-.5.4-1.3-.5-1.5-.5,0-.5.4-1.1.5-1.5Z"
          fill="#0348f4"
        />
        <path d="M383.6,207.3c-.5-.1-1.7.8-2,.5-.6-.6,1.4-2.6,2-.5Z" fill="#0348f4" />
        <path d="M384.6,207.3c-.2-.1-.5-.3-.5-.5.4,0,.5.1.5.5Z" fill="#0348f4" />
        <path
          d="M246.2,391.2c.1-.4.3-.4.5,0,.1-.4.3-.4.5,0,0,0,.4.9.5,1,.6,1,1.1,2.1,1.5,3.4,1.3,0,1.9.6,1,1.6,1.3.8,6.1,4.8,2.2,4.4s.6-.5.8.1c.3.2.8.7,1,1-.3,1.3-.6,1.3-1,0l-.5.5c.9-.6,1.3.8,1,1.5.7,1.1.9,1.7-.5,1.5-.3-1.5.8-1.7-2-1.5,1.3-3-.2-2.1-2-1-.3.8,1,.2,1,.8s-.6,1.1-.5,1.7c-.6.5-2.1-3.8-2-4s1.7.7,2-1c-1.4.2-2.9.3-2.5,2-.9-.5-3,0-3.5,0-.6.6-.8.3-.5-.5-.4-1.5,1.3-2,2-3.3-.3-.7-1.1,0-1.5.3h-.6c.8-.4.3-1.1-1.4-2,0-.3,0-.7,0-1-.6-.5-.7-1-.5-1.5-.1-.2,0-.5-.5-1-.6-2.9,2.1-4.2,4.5-3.5l1,.5Z"
          fill="#023fad"
        />
        <path
          d="M247.7,392.2c0,0,1.4-.4,1,1.5.2.2,1-.9,1.5-1,.7.7,1,1.7.8,2.9,1.5-.2.5,1.1-.3,1.6-.1.4-.3.4-.5,0,0-.3,0-.7,0-1-2.1-.9-2.1.5-3.5,1.2,0-1.7,1.1-1.4,1.4-1.8s-.9-2.6-.4-3.4Z"
          fill="#034eb8"
        />
        <path
          d="M250.7,397.2c.4-1.1.5-1.2,1,0,0,0,.2,1.4,1,1.7s1.6-1.3,2,1.5-.1,1.2-1.5,1.2c-.2-.2-1,.3-1-.2,2.8-.7-1.6-2.8-2.3-3.8s.3-.5.3-.5h.5Z"
          fill="#0233a1"
        />
        <path
          d="M241.7,397.7c.5-.3,3.4-1.6,3.5-1.5s-.2.9.2,1.3,1.1-.1.8.6l-3-.5c-.1.7.4,1.3.5,2s0,.4,0,.5c-.3.4-.7.4-1,0-1.2-.9,1.8-.4.5-1.5s-2.4.1-3,.5c-.2-1.4.8-1.2,1.5-1.5Z"
          fill="#0249b3"
        />
        <path
          d="M241.2,395.2c.2.3.7.7.7,1,.1.4-.2.4-.2.5h-.5c-.4.2-.6,0-.5-.5-.3,0-.5-.2-.5-.5,0-.2,0-.4,0-.5.3,0,.7,0,1,0Z"
          fill="#0452b8"
        />
        <path
          d="M245.2,393.7c-.2-.9.8-.3,1-.5s-.9-1.3-.2-1.5c1.6,1.2,1.5,2.1-.7,2Z"
          fill="#0554b7"
        />
        <path d="M252.7,403.2l.5-.5s-.5.5-.5.5Z" fill="#023ca2" />
        <path d="M256.2,405.7l-.5-1c.4.4.3.5.5,1Z" fill="#023ca2" />
        <path
          d="M255.2,389.7c-.9.7-1.7,1.2-1.5,2.5-.9.4-1.9-.9-1-1.5-1.1-.7-1.1-1.2,0-1.5.1,0,2.4.5,2.5.5Z"
          fill="#034ec1"
        />
        <path d="M253.5,389.7c.3.2.3.3,0,.5v-.5Z" fill="#0247ba" />
        <path
          d="M240.2,382.2c0,.5.2.7.5,1,.5-.4.9,0,1,.5,0,.8-1.1,1.9.2,1.5s.8-1.4.8-1.5c2.3,1.3-.4.7,0,1.7.8,2.1,1.7,1.6,3.5,1.3l1,1c0,0-.2.7-.5,1-.5,0-.6.1-.5.5,0,0,0,.5,0,.5q-.2.2,0,0c.3,0,.7,0,1,0l-.5,1.5c-.2,0-.3,0-.5,0l-1-.5c-.5.1-.6,1.6-3,.5,0,1.3,2.4.5,2,1.7s-1.8-.6-2.5-.2-.2,1.4-1,1.5c-.3-.3-1.3-.5-1.8-1-1.6-1.6.6-4.3,1.3-6-2.9.3-1.5,1-1.7,1.8s-.9.5-1.2.9,0,2.3-1.1,1.3.1-1.9-1-1,.3,1.5-.5.7c-.9-.8-.8-1.7-.5-2.8-.8,0-.9,1.6-1.2,1.5s-.4-.6-.8-.7c-2.6-.8-1.5-.9-1.9-1.3q-.2-1.7,0,0c-1-.8-2.3,0-1-2,2.3-3.6,2.8-.2,6,.5l-.5-1.7c1.6-1,.3,1.5,2.5.2l-.5,1.8c1.4,1.2.8-1.5,1.8-1.8s2.1,1.2,2.2,1c.6-3.2-1.3-1.5-2-2,.4-1.6.6-1.2,1.5-1.5Z"
          fill="#0247b7"
        />
        <path
          d="M242.7,381.7c.2,0,.5.2.5.5-.4.4-.5.7-.5,1,0,.2,0,.3,0,.5.7.9-1,3.5-1.9,2.1s.2-2.7.9-2.1c-.3-.6-.6-.7-1-.5-1.3.5-1.6-.2-.5-1,.7-.3,1.7-.5,2.5-.5Z"
          fill="#0250c9"
        />
        <path
          d="M247.2,391.2h-.5c-1.2-.5-1.1-1,.5-1.5h.5s.3.2.3.6c0,.6-.7.9-.8.9Z"
          fill="#034ec1"
        />
        <path d="M240.7,383.2l.3-.5c.9-.2.8.2.7,1-.3-.1-.8-.3-1-.5Z" fill="#0248be" />
        <path d="M246.2,391.2c-.4,0-.8,0-1-.5.2,0,.5,0,.7,0l.3.5Z" fill="#034ec1" />
        <path d="M246.7,388.7c-.1.2-.4.3-.5.5-.5-.3-2.2.1.2-1l.3.5Z" fill="#034ec1" />
        <polygon fill="#0248be" points="230.2 387.7 229.2 386.5 231.2 385.7 230.2 387.7" />
        <path d="M233.2,386.7v.5c-2.1.2-2.1-.7,0-.5Z" fill="#0248be" />
        <path d="M245.2,389.7c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#034ec1" />
        <path d="M231.5,387.7c.3.2.3.3,0,.5v-.5Z" fill="#0248be" />
        <path d="M246.2,389.7c.2.2-.5.8-.5.2s.4-.4.5-.2Z" fill="#034ec1" />
        <path
          d="M226.2,364.7c-.7,1.7,1.7,0,1,1.2s-1.4.5-1.5,1,1.4,1.9.5,2.7-1.4-1.1-2.5-1.5c0,.5.2.5,0,1.5.8.1,1.4.8,1.8.8.6,0,1.8-1,3-.7s.2.8.2.9c-.2,1-1,1.5-1.5.5,0,0-.6-.7-.9-.5s-.8,1.8-1.1,2.2c.4,1.9.1-.5,1.2-.3,1.6.3-2.5,2.4-2.7,3s0,.7,0,1,0,.9,0,1c-.5-.7-1.2-1.7-2-1.5-.4-.1-.4-.3,0-.5.4-.2.2-.3-.5-.5-.1.4-.3.4-.5,0-2.4,2-1.1-3.2,0-1,1-.5,2-1,3-1.5l-.5-1c-.8-.4-.2-1.6.5-2-.6,1.8-4.1,3.8-3.9,1.5l-1.6-1.5c-1.7-.4-1-2,.5-1,1.9-.4,2.9-1.2,5-.5,0-.3,0-.7,0-1,0-.5-.2-1-.5-1.5,0,0-.6-.1-.5-.5,1.2.5,1.6-1,1.8-1,.9-.2,1.5.5,1.7.5Z"
          fill="#0241c1"
        />
        <path
          d="M229.2,378.2c2.2-2.2-1.1-3.4-.4-5.2l2.2-1.3c0,1.6-3,2.4,0,3.5l.8-1c-1.4,2.2,2.1,1.7,2,4-2.5.6-.2-1.9-3-1.5l-.5,2.5c-.3,0-.7,0-1,0,0-.3,0-.7,0-1Z"
          fill="#023fbe"
        />
        <path
          d="M228.7,370.7c0,.2.5.6.4.7-.1.3-1.1.5-.9,1.3-.7.2-.6-.9-1-1.5.5,0,1-.2,1.5-.5Z"
          fill="#013bbf"
        />
        <path
          d="M224.2,380.7c0-.8.4-1.1,1-.5.3.6,1.3.8-.5,1.2.2.4.7.5,1,.8-.3,1.5-2.7,1.8-3.5,1s-.5-1.4-.5-1.5c-1-.4.2-1.9,1-2,.4.6.9.9,1.5,1Z"
          fill="#0246b6"
        />
        <path
          d="M225.2,385.7l-.2-1c-.8,0-3.1,2.7-3.2,2.5s0-.8-.5-1.2c-1.8-1.6-2.3-.8-2.1,1.2s-1.6-.4-1.3-1.7,2.2-.2,1-2.3l2.2,1.5c1.4-1.5-2.5-.7-1.2-2s1.7,0,2.5.5.2.9,1.3,1,2.6,0,3.2,0c1.6-.1,1.2-1.5,1.7-1.5s1.2.4,1.3.5c.3.3-.7,1.7-1,2-.7.6-2.5-.1-.5,2.3-.1.5-.9.1-1,.2-.1.4-.3.4-.5,0,.1-.7.4-2,0-2.5s-.7.5-1,.5c-.1.4-.3.4-.5,0Z"
          fill="#0246b6"
        />
        <path d="M222,384.2c.3.3,1,.7.5,1-.2-.3-1-.6-.5-1Z" fill="#023fab" />
        <path
          d="M223.7,380.2c.2.2.3.3.5.5-.7.2-1.2,1.1-1.5-1,.2,0,.3,0,.5,0,.6-.6.8-.3.5.5Z"
          fill="#0248be"
        />
        <path
          d="M221.7,376.7c.1,2.2,1.4,2.2-1,4s-.4,0-.5,0l-.5-.4c.9-.7,1.3-1.3,1-1.6-1.2,1-1.9.2-1-1,0-.6.3-1.1,1-1.5.3-.8.8-.2,1,.5Z"
          fill="#024abb"
        />
        <path d="M223.2,379.7c-.2-1.9,1.9-1.2.5.5-.1-.1-.5-.5-.5-.5Z" fill="#0246b6" />
        <path
          d="M221.7,375.7c0,.1,0,.3,0,.5s0,.3,0,.5l-1-.5c-1.3-.1-1.3-.6,0-1h.5c.3,0,.5.1.5.5Z"
          fill="#0d62ce"
        />
        <path
          d="M234.2,332.2c.5-1.5,2.9-2,2,.5.7.7,1,.7,1,0-.6-.7-.3-1,.5-.5.1-.4.3-.4.5,0,1.5-.7,1.7,1,0,1l-.5.5c1.5-1.2,2.1-.4,2,2.5.2-.4.3-.4.5,0,.2.4.4.4.5,0-.9-.2-.5-2.4.5-2h.7c-.9,1.6.5,2.3,1.8,2.5.6,1.7-1.7.7-2,1-1.1.9,1.3.9,1,1.5-.6-.2-1.2.4-1.5.5-.5,1.3-1.1,1.4-1.5,0-.7-.5-1.3,0-1.4.7.3-1.2.6-1.9,1.4-.7.9.3,1.5.8,2,1.5.8,0-.6-1.4.7-1s-1,2.1-1.2,2.3c-.4.6-.4,1.1-.6,1.7h-.5c-.5.3-.8.8-1,1.5-2.4.7-.9-.8-1.1-1.6s-2.1-1.7-1.4-3.4l-1.5.5c0-.3,0-.7,0-1-.7.2-1.5,0-2,.8l1,1.2c-3.3-.8-.6-3.1,1-4,2.4-2.8,2.9,1.1,0,2,1.9-1.3,3.2-2.7-.3-2.5l-.2-.5q0-1.6,0,0c.6.6.3.8-.5.5-.9-.1-.5,1.3-1-.5-.3-.2-.2-.3,0-.5,0-.3,0-.7,0-1-.6-.9-.7-1.4-.2-1.4-3.7-1.2-2.2-4.5.7-1.6-.3-.8-.3-1,.5-.5Z"
          fill="#035ced"
        />
        <path
          d="M242.7,330.7c-.4,2.2-.6-.2-2.3,1-.2.2.2,1.4.3,1.5.5.5,1.7-1.9,3-.5-.6,1.6-.6.8-1.5,1.7-1.7,1.7,1,.8,1.5,2.3-2.5,1.1-1.9-1.2-2.5-2.5-.8,0-1.1.7-1,1.8l-.5.2c-.6-.2-1.1,0-1.5-.8,2.8-1.2-.4-1.2-.5-1.7l.5-.5c.5-.8,0-1,0-1-1.7-1.5.8-2.2,2.4-2.3.3-1.8,2.2-1,2.1.8Z"
          fill="#024be7"
        />
        <path
          d="M239.7,339.7c.5,0,1.1,0,1.5,0l.5,1.5c-1.3-1.1-.9.4-1.2.5-2.1.7-.8-1.1-.8-2-2.1.4,0,1.6-2,1.5l1-4c.9,0,1,1.9,1,2.5Z"
          fill="#0147e2"
        />
        <path
          d="M234.7,337.2c.3,0,.8.1,1.1,0s1-1.9,1.9-1-.3,3.7-.5,4-1.2-.1-1.9,0c0-1.5,1.4-1,1.5-2.2-.2-.5-1,.3-1.5.2s-.9-.5-1-.5c.2,0,.4-.5.5-.5Z"
          fill="#0248e4"
        />
        <path d="M240.2,344.2c0,.7-.3,1.3-1,1.5-1-1.1,0-2.7,1-1.5Z" fill="#0357e9" />
        <path d="M233.2,337.2c0,0-.3,0-.4-.3l.4-.2v.5Z" fill="#0252e8" />
        <path d="M234.7,337.2c-.8.3-1.6-5,1-4.5-.6,1.4-2,2.7,0,3.2l-1,1.3Z" fill="#0243e4" />
        <path
          d="M241.2,334.2c-.8.3-.5,1.3-.5,2-.1.4-.3.4-.5,0-.2,0-.3,0-.5,0l.5-2.5c.7-.1.8,0,1,.5Z"
          fill="#0460ef"
        />
        <path d="M240.7,336.2c0,.2.8,1.4-.2,2-.5,0-.7-1.6-.2-2h.5Z" fill="#024be7" />
        <path d="M239.2,342.2c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#0241e4" />
        <path d="M237.2,332.7c0,.1,0,.7,0,1-.3.3-.8-.8-1-1h1Z" fill="#0354f0" />
        <path d="M237.7,333.7c0-.4.1-.5.5-.5-.1.2-.3.4-.5.5Z" fill="#0354f0" />
        <path
          d="M232.7,329.7c.2.7-.5,1.2,1,1,0,.2,0,.3,0,.5,0,.3.4.7.5,1-.1,0-.3.5-.5.5-.5-.5-.9-1.8-1.5-2-.3-.6-.4-1.4.5-1Z"
          fill="#0347e1"
        />
        <path d="M247.7,328.7c-.7.9-1,.9-1,0,0-.1,0-.3,0-.5.2.1,1.1-.3,1,.5Z" fill="#0354f0" />
        <path
          d="M245.7,321.2c.1,0,.5.4.8.5s.2-.9.5-1c.9-.3,1.2.5,1.2.5-1.1-.2-1.5.7-1,1.5s2.2-.3,3,.5c.2.2,1.3.3,1.4.6s.2,1.8,0,1.9c-1,1-1.6-1.6-2.5-1s.8,1.5-.5,2c-.3-.3-.7-.3-1,0-.2,0-.3,0-.5,0-.5-.3-.8-.3-.5,0,0,.5,0,1.1,0,1.5-.1,0-.4,0-.5,0-.4-.7-.6-.5-.5.5-1.3.7-2.9.4-3,.5s0,1.2,0,1.5c-.9-1.8-3.9-.4-4.5,1.5h-.5c-.5.3-1.2,0-1.8-.9-.2.6-1.8.6-2.2-.1-.5,0-.4-.3,0-.5-1.1-1.6-2.3-4.7,1.1-3.8s1.7,1.5,1.9,1.8c-.1-1.3,0-1.3,1-.5.9-1.2,1.9-1.5,2.5,0q-.4,1.5,0,0c-1.8,0-1.5-1.9,0-2,.2,0,.7-.4,1.5-.5.9.2,1.5.6,1,1.5q-.9.7,0,0c0-.6-.2-1.1-.5-1.5,0-.3,0-.9,0-1l-1.5-.2c.5-.5.8-.9,1.5-.7v1c.2-.2,2.5,0,0-2,1.4-.2,2.5-.7,3.5-1.5Z"
          fill="#0354f0"
        />
        <path d="M246.7,326.7c-.5,0-1,0-1.5,0-.5-.3,2.6-2.1,2,0-.2,0-.3,0-.5,0Z" fill="#0469fa" />
        <path d="M247.7,326.7c-.3-1.5,1.3-1.6,1,0-.2,0-.7,0-1,0Z" fill="#0438e4" />
        <path
          d="M233.7,331.2c1.9,1.3.9-1.4,1.5-1.8,2.2-1.4.7,1.6,2.5,2.8,0,.2-.4.4-.5.5,0,.8-.4.5-1,0-.3-.3-.5-1-.8-1-.5,0-.8.4-1.2.5-.6.1-.9-.6-.5-1Z"
          fill="#0246e9"
        />
        <path
          d="M245.7,328.7c0-.9-2.6-2.4-2-3s2.1,1.3,2.4,1.6,0,.8.1.9c0,.3-.3.4-.5.5Z"
          fill="#0145e8"
        />
        <path
          d="M238.2,324.7c.1-.3.3-.2.5,0,0,0,.1.7.5,1,.4-.4.5-.3.5.5.1,0,.4,0,.5,0-.5.9-.2,1.2,0,2-.8,0-1.7,0-2.5,0,0-.4,1.4-2.2,1-2.5-1.1-.9-.8,1.8-2,1s.4-1.5,0-2c.2-.2.3-.2.5,0,.4.2.8.2,1,0Z"
          fill="#0246e9"
        />
        <path
          d="M245.7,321.2c.3,1.3-.4,1.1-1.5,1l.5,1-2.5-.5c0,0-.6,0-.5-.5,1.5,0,2.7-.6,4-1Z"
          fill="#0564f5"
        />
        <path
          d="M242.2,325.7c.3,0,.7,0,1,0,.4,1.1-.5,1.4-.5,1.5l-1-1.5c.2,0,.3,0,.5,0Z"
          fill="#0b71f2"
        />
        <path
          d="M235.2,323.7c0,.4-.6,2-.2,2.9s1.8.9,1.7,2.1c-.8-.1-2-1.7-4-.5,2.4,1.7,1.1,1.3,1,2.5,0,1.4-1.6.2-1-1-.7-.1-1.4-.8-1-1.5-.5-.1-.5-.3,0-.5l-.5-.5c.7-.2,1-.8,1-2,0-2,1.4-2.4,3-1.5Z"
          fill="#0246e9"
        />
        <path d="M240.2,328.2c0,.2.8.7.5,1.5h-3c-.4-2.2,2,.4,2.5-1.5Z" fill="#0244e6" />
        <path d="M242.7,327.2c-.2.4.4,1.4-.7,1s-.4-2.1.7-1Z" fill="#013de1" />
        <path d="M248.7,323.3c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#0351f4" />
        <path
          d="M228.2,338.7c.4.1.4.3,0,.5.2.5.5,1,1,1.5.5-.2.7,0,.5.5.4,1-.7.6-1,0s1.7.6,1,1.5c-.5.7-.5,1,0,1,.7-.3.8,0,.5,1,.6-.6,1.1-.8,1.5-.5.4.1.4.3,0,.5.9.5.4.8-.5,1-.3,1.2-.8,3.3-.2,1.6-1-.7-1-1.1.2-1.6,1.6-1.1,2.1-.3,1.5,1.5.6-.8,1.5-1,2,0,.4-.2.8-.6,1-1,.3-.4,1.4-.1,1.5.5.2.3.5.4,1,.5.8.5,1,.9,0,1-1.8.6-1.7.8.5.5-.3-.6.2-.8,1.4-.7.1-.8,1-.8,2.6.2.5-.1.6,0,.5.5,1.3,1.5,2.3,2,0,2.5-.5,0-.5.2,0,.5-.2.4-1.9,1.1-2,1q-.5-1.3,0,0c.2.4-.3,3.1,1,2s-.2-.9.2-.9.9.5,1.3.4c1.2-.5,1,1.6,0,1.5-.8.9-1.9,1.1-3.5.5-.6.5-1.4.9-1.5,0-1.1-1.1-.5-1.4,1-1.5.2-.4.2-.6,0-.5-.6,1.1-1.5,1.7-2.4.5-.4.5-.7.7-1,.5-.7.8-1.1.6-1-.5l-.3.6c-1.6,0-4.4-.3-3.2-2.6.5-1.2,1-1.3,1.8-.3l.7-.2c.2-.7,1-.9,1.5-.5.8-1.4,1.5-1.6,2-.5q.3.8,0,0c-.7-.2-1.3-.2-2,0-.6.2-1.1.6-1.5,1l-.4.6c-.5-.7-1.7-1.1-2.1-.1-.7,1.1-1.1.8-1-.5-.9,0-1.7.4-2.4,1.1l-.6-.6c-.5.6-.7.3-.5-.5-.4-.7-.2-.9.5-.5.3-.6.8-1.1,1.5-1.5v-1c-1.5,0-2.5-1.5-3-4.5-2-1.5-3.4-3.3-.2-4-.4-1.3-.3-2.6,1.2-2,0-.9.9-.9,1,0Z"
          fill="#0252dd"
        />
        <path d="M243.2,351.2v.5c-.8,0-1.2.2-1-.7.1-.7,1,.3,1,.2Z" fill="#0245d2" />
        <path
          d="M241.7,347.2c.4.3.7.7,1,1l-1.8,1.5c.5-2.2-.2-1.5-2.2-1-.7,0-.9-.1-.5-.5v-1c.3,0,1.6.8,2,.5s-.1-1.1,0-1.5c.5.4,1,.6,1.5,1Z"
          fill="#035ce7"
        />
        <path
          d="M236.2,355.2l2.3-1.5c-.6,1.4.6,1.3,1.2.5.4.1.4.3,0,.5-1.1.7-.7.7-1,1.5.5,0,1,0,1.5,0,.4.1.4.3,0,.5-.7.1-1.6.6-1.5,1.5h-.5c0-.3,0-.8,0-1,.1-.3.4-.7.5-1-2.1-.2-.2-3.2-2.3,0-.5,0-.1-.8-.2-1Z"
          fill="#0247d9"
        />
        <path
          d="M231.7,352.7c0,0-.5-.9-.5-1,1,.2.9-1,1-1,1.5-1,.2,1.7,2,1.5.2-1.1-.3-1.2,1.5-1,.4.1.4.3,0,.5-.2.2-1.2.5-1.5.5-.1.6.2,2.4-1,1.5s.6-1,.5-1c-.6-.1-1.5.2-2,0Z"
          fill="#0247d7"
        />
        <path
          d="M235.7,351.2c.3-.4.4-1.5.5-1.5.1,0,1.7.3,1.5,1.5.3,0,.7,0,1,0,.2,1.3-.3,1-1.5,1-.2-.1.5-.7.5-1-.3,0-.8-.1-1,0-.2.3,0,1,0,1.5l-1-1c0,0,0-.4,0-.5Z"
          fill="#035fe7"
        />
        <path
          d="M238.2,348.2c.2,0,.6.2.5.5-.7.2-2.9,1.1-3,1-.8-1,1.6-1.4,2.5-1.5Z"
          fill="#034be1"
        />
        <path d="M241.2,352.7c0-.1-1.6-.7-1-2,1.9.5.9,1.9,1,2Z" fill="#0245d2" />
        <path d="M239.7,354.2c0,0,0-2.1,1-1s-.9,1.4-1,1.5v-.5Z" fill="#0238c8" />
        <path d="M235.7,352.7c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#0247d7" />
        <path
          d="M234.7,344.7c.1-.4.3-.4.5,0-1.1.7-2.3,1.3-2.5,2.5-2.4-1.1.7-1.1,0-1.5-.5,0-1,0-1.5,0,.1-.3.4-.7.5-1l1.7.5c-.4-1.4.1-1.3,1.3-.5Z"
          fill="#0245d7"
        />
        <path
          d="M230.2,344.7c.6-1.4,2.8-2.5,2.5-.5-.3,0-.8,0-1,0-.4.2-1.1.6-1.5.5Z"
          fill="#0340d7"
        />
        <path
          d="M237.2,346.7l-1.5-.5c-.1.4-.3.4-.5,0,0,0-.6-.1-.5-.5.8-.1,2.9,0,3,.7s-.5.2-.5.2Z"
          fill="#0478e1"
        />
        <path d="M229.2,340.7c-.5-.4-2.1,0-1-1.5.7.2,1,.8,1,1.5Z" fill="#022cc8" />
        <path
          d="M229.7,341.2c.2.2.3.3.5.5,0,0,0,.7,0,1-.1.4-.3.4-.5,0l-1-1.5c.3,0,.8,0,1,0Z"
          fill="#0668e2"
        />
        <path d="M229.7,343.7c-.3-.2-2.2.4,0-1h.5c0,0,.9.5-.5,1Z" fill="#0340d7" />
        <path
          d="M230.7,352.2c-.8.6-2,.8-2,2-.9,0-.8-1.1-1-1.5,1.8-.2,1.9-1.4,2-1.5.4-.3.8.8,1,1Z"
          fill="#013fcb"
        />
        <path
          d="M231.2,345.7c-.5,1.5.2.8.5,2.5-.5,0-1.7.8-2,.5-1.1-.9,1.3-.8,1-1.5l-2-.5c1.3-.4.9-1,2.5-1Z"
          fill="#0242d3"
        />
        <path
          d="M229.2,349.2c.2.4,1,.4,1,.7,0,.5-.9.1-1,.2-.4.4.3.6-1.5,1.5l-.5-.2c.2-.8,1.9-1.2,2-1.3s-.6-.9,0-1Z"
          fill="#0240c6"
        />
        <path d="M235.7,346.2c.2,1.4-.4.8-1,1,0-.3.5-.8.5-1h.5Z" fill="#0245d7" />
        <path
          d="M231.2,324.7c1.4.9.9,3.6-.5,2,.5.2.8.5,1,1,0,0,0,.4,0,.5.6,1.1.6,2,0,2.5-.5,0-2.4.8-2.5,1.5l1.5-.2-1,1.7,3,1c-.1.5-.5.8-1,.5-2.1,1.1-1.2-.4-1.8-.5s-1.6,0-1.7,0l-.5-2.7c1.4-.7.4-2.5,2.5-3.6-2.1-.7-.8-1.2.5-1.7-.7-1.5-1.5-1.9,0-2.5.2,0,.4,0,.5,0,.4.1.4.3,0,.5Z"
          fill="#0347e1"
        />
        <path d="M232.7,334.7c.1,1.3,0,1.2-1,.5.2,0,.4-.7,1-.5Z" fill="#0139d3" />
        <path
          d="M218.2,351.7c1.2-2.2,4.4-.2,2.3,1.5h.7c2.1-.3,1.3-.9,1.8-1,1.2-.3.6.5.7,1-.3.6-.9,1.8-1.5,2-.1,0-1.4-.3-2-.5-1-.1-1.9.7-1.5,1.7-1.2.7-3.3,1.2-3.5-.7.1-.6-.7-2.3-.5-2.5s1.2.2,1.6,0,.4-.8.5-.9c.4-.2,2.8,1.4,1.4-.6Z"
          fill="#0230af"
        />
        <path
          d="M220.7,345.2c.2-1.5,1.5-1.2,1.8.1h.7c.1-.6.3-.5.5-.1,1.6-.1,2.5.4,2.5,1.5,1.9,1.3,1.5,3.8.5,5.5,0,1.5.8,1.7,1,3l-1.5.2c.7.2.9,1.7,1,1.8-.9-.7-2.2-1.3-2.5,0-.5.1-.6,0-.5-.5-1.4-1.6-1.6-2.8-.5-3.5-1.3.5-2.1.5-2.5,0-.5-.9-.2-2.1.8-3.6-2.5.1-3.3-.5-2.3-1.9-.5-1.9-.2-2.7,1-2.5Z"
          fill="#0240c6"
        />
        <path
          d="M226.2,344.7c.4,0,2.6,3.9,3,4.5.5.2.3.6,0,1-.9.6-1.4,1.1-1.5,1.5-.2,0-.3.4-.5.5h-.5c-.1-1.9-.4-3.6-.5-5.5-1-1.1-1-1.8,0-2Z"
          fill="#0245d0"
        />
        <path
          d="M219.7,347.7c-.4,1.7,2.8.4,3,.5,1.2,1-.8,3.9-1.5,5-.3,0-.6,1.1-1.5-.3l1-.3c-.3-1.3-1.6-.8-2.5-1s-2.1-.6-1.5-1.5.7.5,1,.5c.1-.4.3-.4.5,0q.2.2,0,0c-.5-.3-.6-.8,0-1,0,0,1.5,0,.9-1.3s-1.4,0-1.4-.5c0-1.1,1.6-.2,2-.2Z"
          fill="#0138be"
        />
        <path
          d="M226.2,346.7l-.7-1-1.2,1-.5-1.5c.8.3,2.1-.5,2.5-.5,0,.7,0,1.3,0,2Z"
          fill="#022bb9"
        />
        <path
          d="M223.7,353.2c.8,1.8-.1.5-.5,1-.8,1,1.7.9,1,2.5-.8-1-.7-1.1-2-1.5,0-1,.8-1.4,1.5-2Z"
          fill="#0352d2"
        />
        <path d="M226.2,352.2c-.6.6-1.6-.2-.2-1,.4,0,.3,1,.2,1Z" fill="#024dd3" />
        <path d="M225.7,353.7c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#024dd3" />
        <path
          d="M223.7,362.7c-.3,0-.7-.7-1-1s-.3-.3-.5-.5c1.9.4,1.7-.4,2.5-1,.2,1-.4,1.7-1,2.5Z"
          fill="#0244c4"
        />
        <path
          d="M223.7,367.2h-.5c-.4-.2-.2-.6,0-1,0-.2,0-.3,0-.5,1.5.4.5,1.2.5,1.5Z"
          fill="#0231a4"
        />
        <path d="M220.7,361.7v.5l-.2.5-.3-.2c0-.8-.2-.9.5-1.2v.5Z" fill="#021d97" />
        <path d="M223.2,367.2c-1.1-.1,0-.9,0-1v1Z" fill="#0241c1" />
        <path d="M221.2,362.2h-.5v-.5c.2.2.4.3.5.5Z" fill="#0244c4" />
        <path d="M245.7,370.7c-.2.2-.8-.5-.2-.5s.4.4.2.5Z" fill="#0249cc" />
        <path d="M240.7,320.8l-.5-2.5,2.5,1c-.2.1-.9-.3-1.4.1s-.2,1-.6,1.4Z" fill="#023beb" />
        <path
          d="M241.2,307.8c-.7.7-2.1.6-2,1.7l2-.2c0,.5,0,1,0,1.5-.9.3-1.8-.4-2.5-.5-.4-.2-.7-.6-.5-1,0-.3,0-.7,0-1,.8,0,.8-.6,3-.5Z"
          fill="#0241f0"
        />
        <path
          d="M233.7,284.8c1.6-1,4.2-2.1,4.5.5.5.3,1,.8,1.5,1.5,1.3.9.8,1.8-1.7,2.9l.7.6c.4.1.4.3,0,.5.2.7.6.7,1,0-.4-2.3.8-3.7,2-1.5l4,2.6c.2.3-.7,1.3-.5,1.4,1.2,1,1.4-1.8,2.5-.5,0,.6-.5,1.2,0,2-2-1.1-2.8.5-4.5.5-.3-.2-.5-.3-.5,0-2-.2.5,1.2-1.5,3-.5-.1-.8,0-1,.5.2.3.7.7,1,1-.3.3-.5.7-.5,1,0,.4,0,1,0,1.5-.2.1-1.1-.3-1,.2.4,1.7,1.9,1.2,2,1.3.5.5-1,2.1-1,2.3s1,.5,1.5,1.7c-.3.8-.7.8-1,0-1.4.7-2.4.9-3,.5q-1.4-1.7,0,0c1,0,.9.6,0,1,0,.3-.2.4-.5.5v.5c-.2,1.3-.4,1.2-1,0-1.4.7-2.7.4-4-1-.6.5-.9.2-.5-.5-1.1-1.1,0-1.2-.2-.7-.2,1-2.3-.4-.4-1.7-.3-1.1,0-2.3.8-3.7-.8-.6-.3-.8.8-.9,1-.3,1.8.7,1,1.5.3.3.5.3.5,0-.4-.6-.2-.9.5-.5.9-1.2,2.9-1.6,4-.5.3-.4.4-.6,0-1h-.5c-.3.4-1,.6-1.9.4-.5.7-1.1.9-1.6.6-.7.4-1.3-.3-1.5-1-1.4-.7-.8-1.8,0-3-.5-.8-.2-1,.5-.5.2-1.2,2-.3,2.5.5-.3-1.1-.1-1.7.6-1.9-1.2-1.2-2.2-2.5-.6-3.6l.5-1-.3-.3c-.3,2.5-1.1,2.9-2.7,1.3-1.2.8-1.7,0-1.9-1.3-2.7-.4-2-4.5,0-3.7l.4-.5c-.6-1.5-.6-2.5,0-3,.7-1,1.3-.6,1,.5Z"
          fill="#0349f4"
        />
        <path
          d="M241.2,285.8c.4,0,1.4-.1,1.5,0s-.7,1.2-.5,1.5,1.4-.3,1,.7l-.5.3c-1.3.6-1.4,0-.5-1-.5,1.4-2.5,1-2.5-.5-2.2-1.7,0-2.4,1.5-1Z"
          fill="#0349f4"
        />
        <path
          d="M237.2,291.8c.1.6,0,.7-.5,1,0,0,.5,1.4,0,2,.8.5,2.3-2.3,3,0l-2,.8c-.2.4.9.1,1,.5.5,1.7-.6,1-1.1,1.3s-.9.9-.9.9c-.9-1-1.7-1.2-2.5-.5,0,0-.4.3-.5.5-.7-.6-1.9-3.9,0-2.5.3-.6-.7-1.7-1-1.5l-.5,2c-.9.3-.9-.5-1-.5.7-.7,0-1.4-.5-2,.2-1.7,3.2-1,4.3-.3s-1.2.2-.8-.7c2.4.4,1.7-.5,2.8-2,.5,0,.1.7.2,1Z"
          fill="#023ef2"
        />
        <path
          d="M238.7,301.3c.3,0,.5.2.5.5.3.1.3.3,0,.5h-2.5s.5,1.5.5,1.5l-2-1c-.4-.1-.4-.3,0-.5,1.3-1.7,1.3-1.5,3.5-1Z"
          fill="#0231eb"
        />
        <path
          d="M236.7,298.3c-.5,0-1.8-.6-2.5-.5,0-.4-.3-1.4.2-1.5,1,.6,2.4.5,2.3,2Z"
          fill="#022ef0"
        />
        <path
          d="M233.7,301.3c.6-.3,1.4.5,1.5,1s0,.4,0,.5c0,.3-.1.6-.5.5-.1.4-.3.4-.5,0-.3-.5-.7-1-1-1.5.2-.4.5-.5.5-.5Z"
          fill="#0658f4"
        />
        <path
          d="M243.2,290.8c0,0,.6,1.9.5,2-.6.1-1.2-.5-1.7-.5s0,1.3-.8,1c0-.5,1.2-3.2,2-2.5Z"
          fill="#045af7"
        />
        <path d="M240.7,295.3c.8.9-.7,2.2-1.5,1.5s1-2,1.5-1.5Z" fill="#0231ec" />
        <path d="M241.2,298.3c-.3.3-.5.5-1,.5-1.1-2,0-2.1,1-.5Z" fill="#0231ec" />
        <path
          d="M242.7,295.3c-.3,0-.9-.7-1.5-.5v-.5c1.2,0,2.3-.5,2,1-.2,0-.3,0-.5,0Z"
          fill="#032bee"
        />
        <path d="M237.2,291.8c.8,2,0,.4-.5,1l.5-1Z" fill="#0420e1" />
        <path d="M239.2,302.3v-1c.4.2.7.2.5.7l-.5.3Z" fill="#0354f7" />
        <path d="M239.2,301.8l-.5-.5c.2,0,.4,0,.5,0v.5Z" fill="#0241f0" />
        <path
          d="M233.7,284.8c-.3-.2-.5-.6-1-.5,0-.5.3-1,.5-1.5-.4-.1-.4-.3,0-.5.7.6,1.6,1.8.5,2.5Z"
          fill="#0226e2"
        />
        <path d="M234.7,303.3l1,.5v.5c-2.2.4-1.2-.5-1.5-1h.5Z" fill="#0123e9" />
        <path d="M238.2,287.3c.2.2-.9,1.3-1.5,1-.2-.2.9-1.3,1.5-1Z" fill="#0429e6" />
        <path
          d="M232.7,309.3l1.5-1-.5,1.5c1.5-.7,1.3.2,3,.5l-1,2c1-1.7-.1-2.5-.7-.5-1.3-.9-1.6-1.1-2.3-2.5Z"
          fill="#0233e8"
        />
        <path
          d="M238.2,308.3c-.2,0-1-.6-1.5-.5l.5-2h-1.5c.3-1.2,1.9-.5,3-1,.5,1.3-1,.9-1,1.3s.4,1.6.5,2.2Z"
          fill="#0234ed"
        />
        <path d="M233.7,305.8l1.5-.5c0,1.4-1,2-1.5.5Z" fill="#0230ed" />
        <path d="M237.7,303.3l1.5-.5c0,1.4-1,2-1.5.5Z" fill="#0241f0" />
        <path
          d="M238.2,309.3c0,.2.5.6.5,1-.2,0-.3,0-.5,0-.3,0-.5-.2-.5-.5l-.5-.5h1Z"
          fill="#0233e8"
        />
        <path d="M238.2,310.3c-.2,0-.3,0-.5,0v-.5l.5.5Z" fill="#0241f0" />
        <path
          d="M242.2,312.8c0,.2,0,.7,0,1-1.3.3-1-.6-1.5-1.5-.5-.5-.2-.7.5-.5,0,.3.8.7,1,1Z"
          fill="#032be5"
        />
        <path
          d="M241.2,311.8c-.2.2-.4.3-.5.5-.8,1.4-1.3,3.8-3.5,1.5.5-.2,2.4-.4,2.5-.5,1-1-1.3-.8-1-1.5l2.5-.5c0,.2,0,.4,0,.5Z"
          fill="#0241f0"
        />
        <path
          d="M232.2,321.2c3.5,1,2.4-2,3-2.5,1.1-.7,1.9.3,1.5,1.5l-1.5-.5.5,2.8-2.5-.3c-.4,2,1.6-.3,2,1.5-1.7,0-2.3-.4-2,1.5-.3,0-.7,0-1,0l-.5-.5c-.1.4-.3.4-.5,0v-.5c.6-.1.6.2,1-.5-.2-.4-.2-.7,0-1,.1-.1.4,0,.5-.5l-.5-.5c0-.1,0-.4,0-.5Z"
          fill="#0351f1"
        />
        <path d="M232.7,320.3c1.9-1.4,2.5.9,0,.5v-.5Z" fill="#0124d6" />
        <path
          d="M238.7,324.7c-.1,0-.3,0-.5,0-.2.2-.6.2-1,0-.2,0-.3,0-.5,0,.2-.8,1.8-.7,2,0Z"
          fill="#0354f0"
        />
        <path d="M232.2,323.7l-.5-1c.1,0,.4,0,.5,0,0,.3,0,.8,0,1Z" fill="#024aee" />
        <path
          d="M342.7,227.3c0,.1.2.8,0,1s-1.2-.2-1.4.3c-.5,1.3,2.1.2,1.5,1.5s-1.2.3-1.4.4c-.3.2-.3,1.1-.9,1.3s-.7-.5-.7-.5c.2-1.7-.2-2.6,1.5-3.5s1-.5,1.5-.5Z"
          fill="#0363f5"
        />
        <path
          d="M343.2,224.3c0,0,.4,1,1,.5s-.6-.9-.5-1l3.5-.5c-.5.8,0,1.6,0,2-1.1.2-1.1-.6-1-1.5-1.6.5-1.2.6-1.5,1.5-.6,0-1.4.9-2.5-.5,0-.3,0-.9,0-1,.3-.2.6,0,1,.5Z"
          fill="#035ff4"
        />
        <path
          d="M344.7,225.3c1.1,0,1.1,1.7,1,2.5-1-.5-1.9-.6-3-.5.9-1.3,1.3,0,2-2Z"
          fill="#035ff4"
        />
        <path
          d="M346.2,229.3c-.3-.3-2.7,1.3-3-.5.8.3,1-.9,1.2-.9,1.9,0,1.7,1.4,1.8,1.4Z"
          fill="#035cf5"
        />
        <path d="M340.7,245.3l.5-.5c0,.4-.1.5-.5.5Z" fill="#035ef8" />
        <path
          d="M339.2,225.8c0-.7,0-1.3,0-2l1.3.5.2-1.5c1.5-.3.7.6,1,2s.3,1,.5,1.5l-1.5-.5c0-.3,0-.7,0-1-1.1-.5-1.1.9-1.5,1Z"
          fill="#0260f2"
        />
        <path
          d="M349.2,221.3c1.2,0,2.5.7,2,2l-1.5,1c.1,1,2.5.7.7,2l-2.7-1.7c6.1-3.5-.3-1.3-1-1.8,0-.3.3-.8.5-1h.5c.2.2.4.2.5,0,.2,0,.3,0,.5,0l.5-.5Z"
          fill="#0265f4"
        />
        <path d="M334.2,223.8c-.6-.8-2-2.9-.5-3l.3,1.5,1.2-1,1,1-1,1.5h-1Z" fill="#0361f3" />
        <path
          d="M344.7,219.8c-.9.8-.4,2.9-.5,3-.9.8-1.3-1-1.5-1.5,0-.5.5-1,1-1,.2-.1.5-.5.5-.5.1,0,.4,0,.5,0Z"
          fill="#025bef"
        />
        <path
          d="M338.2,225.3c-.2,0-.7.4-1,.5l.5-1c-1.3,0-2.3.5-2-1,.3,0,.7,0,1,0,.4,0,.8,0,1-.5.8,0,.4,1.3.5,2Z"
          fill="#026ff6"
        />
        <path d="M339.7,220.8c1.1.7-.8,2.2-1,2-.3-.7.5-1.3.5-1.5s0-.3,0-.5h.5Z" fill="#0263f2" />
        <path
          d="M343.7,220.3c-.3.2-.4.9-1,1,0,0-.4-.1-.4-.3,0-.4.8-.9,1.1-1.2l.2.5Z"
          fill="#0484f8"
        />
        <path d="M347.2,219.3c0,0,.7-.8,1-.5s-.1.8,0,1c-1,.6-1.1.8-1-.5Z" fill="#0484f8" />
        <path d="M337.7,223.3c0,2-.8.5-1,.5l1-.5Z" fill="#014fed" />
        <path d="M343.2,224.3c-.3-.1-.9-.6-1-.5l.2-.5.8,1Z" fill="#0374f8" />
        <path
          d="M359.1,234.8c0,.2.6.7.4.9s-1.8.5-1.5,2.1c-1.3-1.1-1.2,1-2.3,2s-4.3,1.5-3.2,3,.8,0,1,0c.8.3,1,1.4,0,1.5-.8-.2-1.7-2-3-.2,2.5-.3,2.5,3.7,1.2,3.7s.8-4.1-2.2-2.5c-.4-.1-.4-.3,0-.5.3-.7,0-.7-.5,0-.1.4-.3.4-.5,0,.4-1.7-1-.4-1-.5-.6-1.5,1.8-1.4.5-3.5.9.6,2.5,3.7,3.5,1.2s-1-.7-.9-1c0-1.3,0-1.5,0-2.3-.4-.5-.2-1.1.5-1,1.8.9,3.3-.9,4.1-2.3,1.3-.4,2.6-.6,3.9-.7Z"
          fill="#034ef4"
        />
        <path d="M353.7,242.8c1.2.2,1,.2,1.5,1.5-.5,0-1.1.1-1.5,0v-1.5Z" fill="#0134e8" />
        <path
          d="M355.7,233.8c.9.2,2,.2,3.1,0l.4.5c0,.2,0,.3,0,.5-1.7.3-1.2,1.2-1.6,1.5s-1.1-.5-1.4-.4-1.2,1.8-1.8,2.2c-1.5,1.1-2.8,2-3.3-.3,0-.2,0-.3,0-.5.2-1.4,1-2,2.5-2,0,0,.9.6,1,.5l-.5-2.5c.7-.1,1,.2,1.5.5Z"
          fill="#035ef8"
        />
        <path d="M349.2,244.8c.5-2,2.3-2.7.5,0h-.5Z" fill="#0137e8" />
        <path d="M353.2,239.8c-.2.7-.8,1.1-1.5,1v-1s1.5,0,1.5,0Z" fill="#035ef8" />
        <path
          d="M351.2,229.8c.6.3,1.1.9,1,1.5.2,3.3.5,1.3,1.4,2s0,.7,0,1h-.5c-.1.4-.3.4-.5,0l-1,.5c.6.2.4,1.1-.5,2.5.4.1.4.3,0,.5,0,.3-.5.8-.5,1l-.3.5c-1.5.1-.3-.4-.2-1-.6-1-1.4-1.7-2.5-2-.1,0-.3,0-.5,0-.4-1.3,1.5-.7,1-1.7s-1.9-1.2-2.5-1.8c.7-.1,1-.7,1.5-1,.7-.4,2.1,0,1-1.5,1.3,1,0,2.3,2,1,.4.3.8.5.5,0,.7-1.5-2.4-1.1-2-2.2.7-2,1.2.3,1.5.5.4.3.8.2,1,.3Z"
          fill="#036af7"
        />
        <path
          d="M347.2,229.8c.2.1.3.4.5.5,0,.3-.4,1.5-.5,1.5-1.1.4-.9-2.4-1-2.5.3.2.7.3,1,.5Z"
          fill="#036af7"
        />
        <path
          d="M347.7,236.3c.9-.3,1.5-1.1,2.5-1,0,1,.1,2,0,3l-2,.2,1-.7-1.5-1.5Z"
          fill="#024df0"
        />
        <path
          d="M353.7,234.8v.5s.1.7-.1.9c-.5.4-2-.2-2.4,1.1,0,0-.5-.3-.4-.6s.8-1.8.9-1.9l1-.5c.1,0,.3,0,.5,0,.3,0,.5.2.5.5Z"
          fill="#024df0"
        />
        <path d="M352.2,231.3c-.7-.2-1-.8-1-1.5.3.2.9,0,1.3.5s-.3.9-.3,1Z" fill="#0346e6" />
        <path d="M350.7,231.3l.5.2c0,.5-1,.4-1-.2.1,0,.5,0,.5,0Z" fill="#0f93fa" />
        <path d="M353.7,234.8l-.5-.5h.5c0,.2,0,.3,0,.5Z" fill="#035ef8" />
        <polygon fill="#0251ec" points="350.7 232.3 348.5 233.8 347.7 232.5 350.7 232.3" />
        <path d="M351.2,234.3c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#024df0" />
        <path d="M352.7,234.3c-.2,0-1,.5-1,.5l1-.5Z" fill="#035ef8" />
        <path
          d="M335.2,167.3c1.4.4.6,2.3-.7,2.8.3,1.3.5,3.1-.5,4.1l.3,1.1c.5.4.7.6,0,1-.8-.2-1.5,0-1.5,0-.2-.3.1-1.5,0-2-.6,0-.8.9-1,1-.1.5-.3.5-.5,0-.2,0-.7-.7-1.4-.8-1.6-.2-2.3,1.4-2.1,2.8-.6-.3-.8-.5-1.5-.5.3-1.1.7-1.1.5-2-.7-.2-1.7-1.4-1-2,0,1.2-3.5,0-3-1.5.2-.7.2-2.4,1-2.5-.3,1.9.4,1.6,2,1.5v2.5c2.6-2.1,1.7-.3,2,0-.3.8,1.8.2,1,0,0-.4,0-1,0-1.5h.5c-.3.7.4,1.6,1,1s-.9-1,0-1c.7-.6.7-.8,0-.5-.3,0-1.2-.7-2,0,0-.5,0-1,0-1.5-.4,0-1,0-1.5,0l.5-1c.2,0,.8.7,1,.5,0-.7-.2-1.1.5-1,.1.6-.4,1.1-.5,1.5,1.9.4,1.7.2,3.3,0s.4,1.9,1.2.9-1-1.6-1-1.7c0-.8,1.6-.4,2-.5s.4-.7.5-.7c.3-1.3.7-1.3,1,0Z"
          fill="#0499f8"
        />
        <path
          d="M325.2,162.8c1-.9,6-2,4.5.5.7.5.9.8,0,1,.7,1.7-1.6.5-1.5,0l-.2-.5c0,.6-.4.7-1.3.5-.8.4-1.1-.5-1.5-1-.4-.1-.4-.3,0-.5Z"
          fill="#0391f6"
        />
        <path
          d="M326.7,164.3c.4-.2.2-1.3,2-.5,0,.2-.5.4-.5.5-.3.5-.9,1.5-1,2l-.5-.5c0-.5,0-1,0-1.5Z"
          fill="#0fb5f9"
        />
        <path d="M328.7,172.8c0,0,.6,0,.5.5-1.7-.6-2,2.5-2-.2l.4-.3c0,0,.7,0,1,0Z" fill="#05b6fd" />
        <path d="M330.2,170.8c0,0,.4-.7,1-.5l-.5,1.5-.5-.5v-.5Z" fill="#0278e8" />
        <path
          d="M321.2,162.8c.3,1.2,1,1.2,2,0,.3-.3.7-.2,1,.5.2-.4.5-.4,1,0,.9-.4,1.4-.1,1.5,1,1,.2.7,1,0,1.5.6,1.4.4,2.2-1.2,2.2s1-.4,1.2.3h.5l1,1c1.2.4,1.9.9,2,1.5.4.1.4.3,0,.5,1.4,1.8.4,2.4-1.5,1.5-.3.4-.8.6-1,0-.7.2-1.4.2-2,0-.9-1.3-1.9-1.8-3-1.5-.7,1.1-1.7,0-1.8-1l-.7-1c.3.9-1.3.8-2,.5.3-1.4-.6-1.2-1.5-.8-1.3.7-.3,2.4-1.5,2.7.5-.9-.5-2.1-.5-2.5-.4-.2-.4-.3,0-.5,0-.4.7-2.3.5-2.5-2,1.1-2.3-.4-.5-1.2-.4-.5-1.5-1.2-1.5-1.8l.5-.5c-.2-.5,0-.7.5-.5.7-.5,1-.2.5.5,1.1-.8,2.8-.4,4,0-.2-1.2,1.2-1.9,2-1,.8.2,1.3.4.5,1Z"
          fill="#04a8fa"
        />
        <path
          d="M327.2,166.3c0,.2.6,1.3-.5,2-.5,0-1.9,1.1-2.5.2,0-1.7,2.2-1,2.5-1.2s-.1-.7,0-1.5c.5-.7.7-.5.5.5Z"
          fill="#038ff6"
        />
        <path
          d="M320.2,169.3c.7,0,1.3,0,2,0l-.5,2c.3,0,.8,0,1,0,2,2.2-2.4,1.8-3,0-.7,0-.5-.7,0-1,.3,0,.9.7,1,.5l-.5-1.5Z"
          fill="#0489f5"
        />
        <path
          d="M318.7,162.8c-1.2.4-1.4.6-2.3,1s0-.8-.6-1-.9,0-1.2,0c.3-1.2,3.7-1.2,4,0Z"
          fill="#0396fa"
        />
        <path d="M320.7,161.8c.3-.1,1,0,1.5,0,.1.5-.5.6-1,1l-.5-1Z" fill="#038bf7" />
        <path d="M325.2,162.8v.5c-.6.7-.7.1-1,0-.3-1.2,1.1-1.7,1-.5Z" fill="#04b1fb" />
        <path d="M317.2,166.8c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#0380f2" />
        <path d="M313.2,163.3c0-.2,0-.3,0-.5h.5c-.2.2-.5.5-.5.5Z" fill="#04b1fb" />
        <path
          d="M319.7,171.3l3,1c0-.3,0-.7,0-1,1.5.5.9.7,1.8,1.4s1,0,1.2.1.9,1.7,1,2h-1c-.3-.6-.8-1.3-1.5-1.5-.2.7.6,1.5.5,2-.4.3-.7.5-1,0-.4-.1-.4-.3,0-.5-.3-.8-.8-1.3-1.5-1.5-.5,1.1-.6,0-.3.2,1.2.6.7,2.5-.7,1.8-1.3.6-1.4.3-1-1,0-.2.5-.8.5-1.2s-1.3-.4-1-1.3c-.4-.1-.4-.3,0-.5Z"
          fill="#05affa"
        />
        <path
          d="M319.7,174.8c-.5.5-1.6-.4-1-1s1.5.5,1,1c.1-.2.4-.3.5-.5,0,0,.7.4,1,1,.1,1.1-.2,2-1,2.5-.1,0-.3,0-.5,0s-.4,0-.5,0-.3-.4-.5-.5c-.8-.6-1-1.1-1.5-2-.8-.9-.3-1.5.5-.8s.2,2.5,2,.3Z"
          fill="#038bf9"
        />
        <path d="M319.7,171.3v.5l-1,.5c-.2-.3.2-1.8.5-2s.3,0,.5,0v1Z" fill="#0282f4" />
        <path
          d="M339.2,185.3c.9-.9,1.5-.4,1.6,1.6,1.5.5,1,2.6-.1,1.9,0,.5,0,.7-.5.5l-.7.8c-3-.2-2.6.1-.8,1.7l.5-.5c.1-.4.3-.4.5,0,0,.3,0,.7,0,1l-.5.5c-.1,0-.4,0-.5,0-.2.3-.3.3-.5,0-.5.4-.4,1.2-.6,1.4s-2.7,0-.9,1.4.8-.2,1-.3c.7,0,.8.9,0,1-.9.5.4,1.7-1.5,2-.4-.1-.4-.3,0-.5.7-.9-.4-1.5-.5-2.5-.9-.2-.2,1-.8,1s-1.1-.6-1.7-.5l2-1.5-2-1c0-.6.4-.4.5-.5.9-.2,1-.4.5-.5-1.2-.6-4.1-2.6-1.5-2.5.8,0,1.1-.8,1-1.5l1-.5,2.1-.6c.3-1.5,1.8-.2,1.8,0s-1.7.2-.4-1c0-.6.5-.8,1-1Z"
          fill="#0380f6"
        />
        <path
          d="M333.2,186.8c0,.3-.7.9-.5,1,.5.1,1.8-.1,2,0s0,.9,0,1c.3.2,1.7-.5,1.5.5-3.1-1-1.4,3.4-3.5.5s0-.4,0-.5c-1.1-.2-1.8-.7-2-1.5,0-.2,0-.3,0-.5.8-.6,1.7-.3,2.5-.5Z"
          fill="#059efa"
        />
        <path
          d="M327.7,202.8c0-.8-.3-1.6,0-2.5-1.1.9-1.1,2.4-2.5.5.9.1.9-1.1,1.7-1.1,1.2,0,3,2.1,3.3,0,1,1.2,0,1.4-.5,2,0,.3-.2.5-.5.5-.7.6-.2,1.5-1.5.5Z"
          fill="#0374f4"
        />
        <path d="M329.7,192.8c1.9-.4,1,1.7,3,.5.2,1.8-1.8,1.4-2.5.5s-.5-.8-.5-1Z" fill="#037af5" />
        <path
          d="M329.2,195.3c1.7,0,3.6.5,1.5,1.5-.1.4-.3.4-.5,0-1-.4-.8-.8-1-1.5Z"
          fill="#0375f6"
        />
        <path d="M336.2,197.8v.5c-1.7.3-2.6.3-3-1.5l3,1Z" fill="#037cf5" />
        <path d="M334.2,199.3l-.5.5c-.2-.2-1.8-.2-1.3-1,.9-1.4,1.3,0,1.8.5Z" fill="#0371f5" />
        <path d="M332.7,189.3h-2c0-.5.1-1.1,0-1.5,1,.3,1.4.8,2,1.5Z" fill="#0389f9" />
        <path
          d="M330.7,196.8c0,.2-.2.8,0,1.1.4.5,1.1.3,1,.6-.5,1.3-.9.3-1,.3-.9-.5-1.2-1-1-2,.1,0,.4,0,.5,0s.5,0,.5,0Z"
          fill="#0366ef"
        />
        <path
          d="M316.2,178.8c1.2-1.2,2.1-1.2,2.5,0,0-.4.3-.4.5,0,.6-.5,1.4-.3,2.5.5.4.5.9,1.2,1.5,2,0-1,.8-1.3,1.5-.6,1.2,1.2-.7,4.5-2.5,3.1,0-.2,0-.5-.2-.7-.7-1.1.7-1.4.2.7,1.3.1,1.6.5,1,1,.2.5,0,.9-.5,1,.1.8.3.8.5,0v-1c0-.5.6-1.2,1.6-1.9-.4-2.2,1-1.8,2.4-1.1,1-.5,2-.3,2,1,.7-.6,1-.3.5.5.4.1.4.3,0,.5-.5.2-.2.5,1.1.8v.7c-.1,0-.3,1.1-.3,1.1-1.4-.9-2.1,0-1.7,1.5,2.1.4,0,3-1,1.4,0,.4-.2.5-.5.5,0,1.5-.2,2.6-1,3.5l-.7,1c-.7-1.5-1.5-2.1-2.4-1.6l-1.3-.9c-.1.5-.3.4-.5,0l-.5-.5c-.1.4-.3.4-.5,0-2.1.5-2.8,0-2-1.5.1-1.2-.2-2.4-1-3.5-1.2-.4-1.2-1.1-.5-2-1.6.6-2.4.3-2.5-1-.1.4-.3.6-.5.5,0,1.1-.8,1-1,0-.7.7-1,.4-.5-.5,0,0,0-.3,0-.5.4.2.7.2,1,0,.7-.8-.2-.7,0-1.5s.3-.7.5-1c-.2-1,0-1.3.5-1,.6,0-.5-1,2-.5Z"
          fill="#0499fa"
        />
        <path d="M313.2,182.8c-.4.4,0,.7-1,0,0,0-.3.1-.5-.2l1.5.2Z" fill="#0389f8" />
        <path
          d="M314.2,179.3c0,.5-.4.7-.5,1-.2-.2-.4-.3-.5-.5.2-.2.2-.4,0-.5,0,0-.4,0-.5-.2-.3-.7,1.4.3,1.5.2Z"
          fill="#046beb"
        />
        <path d="M313.2,179.8c0-.1,0-.4,0-.5l.5.2-.5.2Z" fill="#0156e1" />
        <path
          d="M330.7,185.3c.6-.1,1.1,0,1.5.5.3-2.3,2.3.1,1,1,.7-.8.6-1.2-.4-1.4-.1-.3-.2-.6-.2-.8.9-2.4,9,2.4,2.1,3.3-.6,2.5-4.4,0-1.5-1-.5,1.1-1.3,1.3-2.5.5,0-.2-.7-1-1-1-.6.7-.6,1.2,0,1.5,0,0,.4.3.4.7-.2,1.8-2.7,2.9-2.4.8.6-.3,1.9.7,1.5-1l-2-1-1,2c0-.5-.1-2.4,0-2.5.3-.3,2.1.6,2-.5-.5-.3-2.9-.1-2.5-1.2.6-1.6,1.7.5,2.4.7s1.8-.2,2.6-.4Z"
          fill="#0389f9"
        />
        <path
          d="M322.7,179.8c-.2-.9-.7-1.6.2-2.5,1,1.8,4.2,2.2,2.8,4,3.3-1,1.4-.1,1.5.5l-2,.5c1.1,1.2-1.1,1.5-2,2.5-.2-.3-.7-.8-1-1,1.9.3,2.2-.8,2-2.5-.3,0-.7,0-1,0v-.5l-.5-1Z"
          fill="#05a4fb"
        />
        <path
          d="M323.2,185.8l.2,1,1.3-.4c-.1.7.2,2.7,0,3s-1.5-1-2,.2c3.2,1.7-2.3,1.2-3.5.2l2-1.5.3,1.5c.6-1.5,1.6-1.4,2.7-2.3-1.4,0-2-.2-1.5-1.7.1-.4.3-.4.5,0Z"
          fill="#0389f9"
        />
        <path d="M316.7,184.3l-2.5,1.5v-2.5c.3,0,2.3.9,2.5,1Z" fill="#0178f6" />
        <path
          d="M319.7,182.3c.1.1,1.3-1.2.9.6-1.8-.9-2.7.5-4.5.5,0-.8,1.2-.6,1.9-1.1s.6-1.4.9-1.3.6,1.2.8,1.4Z"
          fill="#038bfb"
        />
        <path
          d="M321.7,179.3c-.8,0-1.8-.5-2.5-.5-.7-.1-.8-.9,0-1,.2-.4.3-.4.5,0,.8.6,1.4.6,2,1.5Z"
          fill="#05a4fb"
        />
        <path d="M322.2,183.8c-.2-.1-.9.1-1,0s.7-1.4.5-2c1.2.8,2.1,1.1.5,2Z" fill="#0382f8" />
        <path d="M320.7,183.8v2c-.3.6-1.3-1.7-1-2h1Z" fill="#027ff7" />
        <path d="M325.7,189.8c.2.7-.3,1.3-1,1.5v-1.5s1,0,1,0Z" fill="#0374f4" />
        <path d="M319.2,184.3c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#027ff7" />
        <path d="M323.2,185.8h-.5c.2-.5.1-.6.5-1,.2.2.3.5.5.8l-.5.2Z" fill="#0372f8" />
        <path d="M321.2,191.8c-.3,0-.5-.1-.5-.5l.5.5Z" fill="#0389f9" />
        <path d="M329.7,187.8c-1.8.5-.9-1.6,0-1.5,0,.5,0,1,0,1.5Z" fill="#09a0f8" />
        <path d="M334.2,192.3c.2,0,.7,0,1,0,.2.8-.7.4-1.5.5.2-.1.3-.4.5-.5Z" fill="#0658ec" />
        <path
          d="M321.7,197.8c.5,0,1.4.6,1.5.5.2-.3-.5-1.7.5-1.5-.4,1.9,1.7,1.8,2,3.2-.3.5-1.5,0-2-.2s-.7.2-.9,0c-.7-.9,1.2-1.9-2.1-.9,0-.4.6-1,1-1Z"
          fill="#0270f6"
        />
        <path
          d="M322.7,195.8c1.1.9,2.3-2.2-.5-2.2l1.8-1.2.7,3c.1.8,0,1.1-.5,1-.5-.2-1-.3-1.5-.5Z"
          fill="#0379f6"
        />
        <path d="M324.2,202.3c-.2,0-.3.7-1.2.5-1.6-.5-.8-1.4-.8-1.5l2,1Z" fill="#0270f6" />
        <path d="M322.2,195.8l-.5,1.5c-.8-.5-1.3-1.8-.2-2s.5.4.7.5Z" fill="#0270f6" />
        <path d="M326.2,193.3c.3,0,.9-.7,1-.5.1.8-.7,2.7-1.5,2s.5-1.3.5-1.5Z" fill="#0370ee" />
        <path d="M324.7,195.3l.5,1.5c-.8.3-.9-.5-1-.5l.5-1Z" fill="#045ae2" />
        <path d="M323.7,200.3l.5.2c-.1.8-.9-.2-1-.2h.5Z" fill="#0270f6" />
        <path
          d="M321.2,175.3c1-.5,1.8-.5,2.5,0,.3,0,.7,0,1,0-.2.8-1.7.8-2.3,1.2s0,1-2.2,1.3c-.3-2.9,0-1.9,1-2.5Z"
          fill="#05a4fb"
        />
        <path d="M323.2,180.8c-.4-.2-.4-.6-.5-1l.5,1Z" fill="#0499fa" />
        <path d="M320.2,193.8v.5c-1.5,0-1.5-.6,0-.5Z" fill="#05a7f9" />
        <path d="M319.2,199.8c3.3-1.7.4,2.8-.5,0,.1-.4.3-.4.5,0Z" fill="#025cf2" />
        <path d="M321.7,202.8c-.1,0-1.7,1.5-.5-.5.2,0,.3.4.5.5Z" fill="#0348e9" />
        <path d="M322.2,200.8c0-.2-1.1-.4-1-1,1.5-.4.8.8,1,1Z" fill="#0270f6" />
        <path d="M319.2,199.8h-.5c0-.1,0-.3,0-.5,0-.3.3-.4.5-.5v1Z" fill="#025bef" />
        <path
          d="M323.2,204.8c1.4-.4,2.1-1.5,3.7-.5s-1.2,2-.7,2.5.7-.4,1-.5c.5.5-.2,1.6-1,1.5-.9.2-1.2-.4-1-2,0-1-.3-.8-.6.7-.3-.4-.6-.4-.9-.2-.1.4-.3.4-.5,0,0-.5,0-1,0-1.5Z"
          fill="#0382f9"
        />
        <path
          d="M323.7,206.3c.5.1.8.6,1,1.5.9-.3,1.2.3.5,1,0,.2,0,.7,0,1h-.5c-.3,0-.7,0-1,0-1.1.4-1.7-2.2-1-2.5,0-.4.5-.9.5-1h.5Z"
          fill="#035ef1"
        />
        <path
          d="M322.7,207.3c0,.9.9,1.6,1,2.5-.6,0-1.1.5-1.5.5s-.4,0-.5,0c0-1-.1-1.6-.5-2,0-.3.4-.7.5-1,.3,0,.7,0,1,0Z"
          fill="#0242e3"
        />
        <path d="M321.2,208.3c1.5-.3,1.1.9.5,2-.7-.4-.6-1.2-.5-2Z" fill="#046df7" />
        <path
          d="M333.7,209.3c.3,0,.7,0,1,0,.3.2.3.3,0,.5.8-.2,1.4.2,1,1,.4.1.4.3,0,.5-.1,0-.4,0-.5,0-.6.7-1,.2-1.5-.5l-.5,1c-.1.4-.3.4-.5,0,0-1.2.3-1.9-1-2.5,1.2-.6.8,0,2,0Z"
          fill="#0272f6"
        />
        <path
          d="M326.2,207.8c.4.1.4.3,0,.5-.3.1-.7.4-1,.5-.1-.3-.4-.7-.5-1-.5-.6-.5-.9,0-1l.5-1c0,.2.8,1.6,1,2Z"
          fill="#0356ed"
        />
        <path
          d="M330.7,205.8c.7-.7,1-.4.5.5l.3.7c2.2-.9,2.3,1.5,0,1.9l.3.3c2.3.1,2.1.9,1,2.5.7.3.9,1.8,0,2,0,1.6-1.2.9-2.3.3.4-1.3-1-1.4-2.2-1.3-.7.7-1,.4-.5-.5,0-.2,0-.7,0-1-.5.3-1,.4-1.5.5l-1.5-1.3.9-.3c.2-.4-.4-.4-.4-.4-1.1,0-1-.7,0-1-.4-1.3,0-1.4,1-.5l1.5-2c.1-3.2,1.1-.8,2.8,0s.2-.5.2-.5Z"
          fill="#0382f9"
        />
        <path
          d="M333.7,211.8c.9,0,.8.6,0,1,.2.5,1.2.3,1,1-.7,0-1.3,0-2,0,0-.8,0-1.2,0-2h.5c.1-.4.3-.4.5,0Z"
          fill="#0370f4"
        />
        <path d="M327.7,206.3c0,1.5,0,1.5-1.5,2v-.5l1-1.5h.5Z" fill="#0254f2" />
        <path d="M331.7,211.8c-1.1-.4-1.2-.8-.2-1.5l.2,1.5Z" fill="#025cef" />
        <path
          d="M290.7,138.3c3.9-.9,1.7,2.3,4.5,3-.1,0-.8.8-1.5.7.9,2.1,2.4,1.6,2.5,1.8,1,.9-.8,1-.9,1.1s0,2,0,2.2c0,.5,1.5.5,1.9.7.8.7.6,1.2.2,1.9,2.7-1.1,3.1,1.3,1.8,3.1-.3-.1-.7-.4-1-.5l-1,.5c-1.1-.7-1.1-2-1.5-3s.1-.8,0-1l-.5-.5c-.8-1.6-1.7-2.6-2.5-4.5s-.8-3.4-1.5-4.5q.2-.2,0,0c0-.1-.3-.3-.5-.5v-.5Z"
          fill="#0383f5"
        />
        <path
          d="M298.2,146.8c1.1-1.3,1.7-1.1,1.3.6s-.2.8.2,1.4c.2-.5.7-.7,1.5-.5,1.8-.9,2.5,1.4,1,2.5-.5.3-1,.7-1.5,1-.3.4-.6.7-1,1h-.5l-.5-3-.5,1c-2.8,0-1.8-1.3-1-3s1-.5,1-1Z"
          fill="#038df8"
        />
        <path d="M298.2,152.3l-.8,1-.2-.5c0-1.6,0-.9,1-.5Z" fill="#038df8" />
        <path d="M295.7,148.8l-.5-.5s.3.1.5.5Z" fill="#038df8" />
        <path d="M294.7,145.3c-1,.1-1.1,0-1-1l1,1Z" fill="#0c6fe3" />
        <path d="M291.2,139.3c-.2-.2.5-.8.5-.2s-.4.4-.5.2Z" fill="#0392fa" />
        <path d="M292.4,139.8c.3.2.3.3,0,.5v-.5Z" fill="#0392fa" />
        <path d="M285.2,119.9c-.2,0-.4-.5-.5-.5.4-.7-.2-3,1-2.3s-.2,1.9-.5,2.8Z" fill="#0578ea" />
        <path d="M289.2,119.9c1.3,2-2,1.5-.5,0,.2,0,.3,0,.5,0Z" fill="#046de7" />
        <path d="M288.7,124.9c-.5.2-.8.7-1.5.5-.2-.1.8-1.1,1-1.5l.5,1Z" fill="#03aafb" />
        <path
          d="M310.2,112.9l.5-.5c.4-.5.8-.1,1,.5-1.5,1.8-1.3,2.9.5,3.5.4.2.4.3,0,.5-.8.6-1.2,1.5,0,1.5-.8,1.7-.8,3,0,4-.1.4-.3.4-.5,0-.3,1.1-1.7.6-2.5,0-.9-.1-1.4-.6-1.5-1.5-.6-.5-1.4-1.4-2-2-1.3-.2-1.1-.5,0-1,.6-.7,1.4-.2,1.1.7s-.2-.7.4-.7c.1-.4.3-.4.5,0l.5-.5c-.3-.2-.7-.2-1,0-4.2.6-5.9-5.3-.8-2.4.6-.7,1.3-1.3,2.1-1.7-.6-2.4,1.7-2.6,1.7-.4Z"
          fill="#04b3fb"
        />
        <path
          d="M305.7,117.9c0,.3,0,.8,0,1s-.4.3-.5.5c-.7-.5-1.7-.5-1.5-1.5.6,0,1.1,1.4,1-.5.4-.7,1.2-.4,1,.5Z"
          fill="#038ff5"
        />
        <path d="M295.2,128.4c.4.4,0,1.7-1,.2,0-.4,1-.3,1-.2Z" fill="#0392fa" />
        <path
          d="M338.7,207.8c0,.4.6,1.4,1,1.5-.3.4-.7.7-1,1s-.7.7-1,1c-.1.7-.9.8-1.5.5-.1-.2-.3-.4-.5-.5v-.5c-.1-.8.3-1,1-.5-.2-.4,0-.9.5-1.5-1-.8-.9-1.1.5-1,.2-.9.4-1.3,1-.5.4,0,.4.2,0,.5Z"
          fill="#048dfa"
        />
        <path
          d="M210.2,117.9c.9-.7,1.2-.4.5.5,0,.3,0,1,0,1q-.9.1,0,0c.2,0,.7.6,1.2.5s1.3-2,2.8-1.5l-2.5,1.8c-.2,1.6,1.4-.3,2,1s-1.8,1.2-1,2.7h-.5c-.3-.6-.8-1.3-1.5-1.5,0,.5,0,1,0,1.5-.2,0-.7,0-1,0,1.1-1.9-1.1-1.4-.5,1-.9.5-2.4,0-2-1.5-.4-.9-.8-2,0-2.8-1.6-.8-1.4-3,.3-2.2.9-1,1.6-1.2,2.2-.5Z"
          fill="#0396f9"
        />
        <path
          d="M215.2,114.9c1.1.2,1.8.5,2,1-.5.4-.8-.3-1.5,1.5-.3.4-1,.6-2,.5-.3,0-.7,0-1,0-.2.4-.7.3-1,0-1.2-.4.2-2.3,1-2.5.1-.4.3-.4.5,0,.9-1.2,1.6-1.4,2-.5Z"
          fill="#0485f4"
        />
        <path
          d="M212.7,115.4c-.4.5-1,2-1,2.5-.3,0-.7.4-1,.5,0-.4-.1-.5-.5-.5-2.1.3-1.1-1.9.8-1.8l.3-.9c-.7-2,2.6-1.1,1.4.2Z"
          fill="#0492f8"
        />
        <path d="M215.7,117.4c0,.2,0,.7,0,1l-2-.5c.4,0,1.2-.9,2-.5Z" fill="#0260ea" />
        <path d="M212.7,117.9c0,.8-1,.7-1,0,.3,0,.7,0,1,0Z" fill="#0255e5" />
        <path d="M217.2,116.4c.2.2-.5.8-.5.2s.4-.4.5-.2Z" fill="#0485f4" />
        <path
          d="M216.7,107.4c2.3.7.4,2.9-.5,1.5h-.5c-.2.4.2.5,1.1.3-.3,1.1.1,1.8,1.4,2.2,0,.1,0,.7,0,1v.5c-1.2,0-2,.1-2,1.5v.5c-.2.7-.7.6-1,0-.5,0-1.1.6-2,.5l-1-1.2c-1.6.9-3-1.6-.9-2.6-.3-.9,0-1.7.6-2.4s1.9-1.1,2.3-1.3c-1.1-.8-.8-1.2.5-1,.4-1.4,1.4-.3,2,.5Z"
          fill="#0492f8"
        />
        <path
          d="M218.7,107.9c0,0,0,.7-.3,1s-2,.5-1.2,1.5,1.4-.7,2.5,0c-.2.5-1.4.8-1.5,1-3.4.7-.8-1.9-3-2,0-.6.4-.4.5-.5h.5c1.4,0,1.3-.2.5-1.5.1-.4.3-.4.5,0,.9-1,1.4-.9,1.5.5Z"
          fill="#0476ec"
        />
        <path
          d="M219.2,112.9c.2.6,0,.8-.5.5-1.2-.1-2-.2-2.5,1-1.1-1.9,1.2-1.7,2-2s1.3-1.2,1.5-1c.2.6-.5,1.2-.5,1.5Z"
          fill="#0476ec"
        />
        <path
          d="M216.2,114.9c.7,0,1.3,0,2,0,0,.6-.6.7-1,1-1.1-1-2.2,1.1-2-1,.3,0,.7,0,1,0Z"
          fill="#0476ec"
        />
        <path d="M219.2,112.9c0,.4,1.7,1.1-1.5,1.5-.1-.5.5-.6,1-1s.3-.4.5-.5Z" fill="#0349d4" />
        <path
          d="M219.7,95.4c.4-2.4,3-2.4,2.5.6s-.3-.8.5,0c.3,0,.7,0,1,0-.4.5-.2,1.9-.4,2.2-.4.6-3.7.2,0,1.8,0,0-.2.7-.8.9-1.2.4-.4-1.2-1.7,1.1l-1.5-1c-1.2-.1-1.5-1.8,0-2.4-.4-1-.2-1.7.6-2.1-.5-.6-.5-1,0-1Z"
          fill="#1479ea"
        />
        <path
          d="M224.7,99.9c1.5-1.5,1.9-.7,1,1,.4.2.4.3,0,.5l-.5,1c.5.1.4.3,0,.5-.2.9-2.5,4-2.5,4.2s.7.7,1,.7c-.4.8-.5,1.5-1,2.5-.7-.3-.5-1.3-.5-2l.5-.5c0-.2-.5-.4-.5-.5-3.4-.8-1-1.1-1.2-.5-.5,1.2-1.6,2.1-1.8.5-1.5.5-1.6-1.4-.7-2.4-1-2-.2-3,2.2-3.1-1.7-1.9,1.1-2.1,2.5-2,0-1.4,1.1-1.3,1.5,0Z"
          fill="#0d69dc"
        />
        <path d="M222.2,108.4l.5-.5c0,.6-.5.5-.5.5Z" fill="#127eec" />
        <path d="M225.7,101.4c-.1.4,0,.8-.5,1,0-.2-1.5-1.2.5-1Z" fill="#2572df" />
        <path
          d="M218.2,100.9l.5,1c0-.4,0-.7.5-1,.7-1.3,2-.3,1.5,1-.3.5-.4,1.5-.5,1.5s-1.3-.7-1.5-.5c1.1,1.6-.1,2.4,2.5,2,0,1-1.3.2-1.9.6s-.9,1.8,0,1.9c-.1.1-.3.3-.5.5-.6,0-1-.3-1.5-.5-.5-.2-.8-.5-.5-1-.6.2-.6-.2,0-1-1.3.9-1.5-3.7-1.1-4.1s2.2-1.3,2.6-.4Z"
          fill="#138ff5"
        />
        <path d="M223.2,103.4c.1-.5-.8-1.7-.5-2,.6-.6,2.6,1.4.5,2Z" fill="#1579e3" />
        <path
          d="M222.2,87.4c0,0,1.2.6,1.5.7.4,1.3-1,1.5-1,1.8,0,.5.5,1.2.5,1.7s-1,0-1.1,1c0,1.5,1.2,2.1.6,3.3,0,0-.3.7-1,.5v-2s-2,1-2,1c-.5,0-.4-.2,0-.5-.4,0-.4-.3,0-.5-.5-.3-.7-.6-.5-1-.5.3-1.1.2-1-.5-.5.1-.6,0-.5-.5,0-1,.6-.7,1,0,.2-1.4,2.3-1.1,1.5,0q0,.5,0,0c.5-1.2-1-1-1.5-.5-.5.3-.8,0-1-1-.2.8-.4,1.2-1,.5-.1.5-.3.4-.5,0-1,.5-1.3,0-1-1l.3-1.1c1.6,1.1,2.9.2,4.2-.9.6-.6,1.1-.8,1.5-.5q.6.5,0,0c-.5-.7.6-1.6,1-.5Z"
          fill="#278af4"
        />
        <path
          d="M220.2,82.4c.3.1.3.3,0,.5-.3.8-1.4,1.6-1,2,1,1,3.5.2,4.3-1,.2,0,.5.7.7,1,.3,1.3-.4,1.1-1.5,1,.4,1.2,1.1,1.7-.5,1.5-.7,0-.9.5-1,.5-.4,0-.9.7-1.5.5l-1-2c-.4.8-.6.9-1,0,0-1-.5-2-1.1-3.1h.6c0,0,.5,0,.5,0,.3-.3.7-.5,1-.5.3-.1.7-.5,1-.5s.4,0,.5,0Z"
          fill="#3c8ef5"
        />
        <path d="M221.2,87.9c.6-.6,1.6.2.2,1-.4,0-.3-1-.2-1Z" fill="#3c8ef5" />
        <path d="M220.2,82.9v-.5c.2,0,.4,0,.5.3,0,.3-.5.2-.5.2Z" fill="#4c87ee" />
        <path
          d="M208.2,80.9l1.6-.2c1-.9,1.4-.8,2.4.2.3.4.9.8,1,1.5-.3,1-1,1.1-2.1.4l-.4.6c1.5.9-.3,2.6-1.5,1.5l-.6,1.3c-1.8-1-3.8-1.4-6.1-1.1-.5-.5-.8-1.1-.8-1.7q-.6-.5,0,0c.3.5-.5.6-1,.5-.5.8-1.4-.6-1.2-.5.5.3,1.4,1.1.7,1.5.2.2.2.3,0,.5-.8,1.4-2.1,1.5-3.5,1-.4.2-.9.2-1.5,0-.1.4-.3.4-.5,0-.3.3-.8.5-1.5.5-.6,1.6-1.6,1.2-2.5,0,.4,1-.7,1.6-1.5,1,.5-1.4.4-1.4-.5,0-.2,1-2.4,1.1-3.2.3-1.3,1.7-4.3,1.2-2.8-.8-.8-1.2-.4-1.8,1-1.5.3-.2.8-.3,1-.5,1.1-.9,2.1-1.1,3-.5,5.8-.8,10.9-2.9,16.1-3.3s2.9-.6,4.4-.7Z"
          fill="#4280ec"
        />
        <path
          d="M213.2,82.4c0,0,0,.7,0,1,.9.2.3-.7.5-1,.4-.4.9.5,1,.5.4.2.8.2,1,0h.5c.8,0,.6.6,0,1,.8,1.5-1.9,3-2.7,1.2-1.6.6-2.8,0-2.8-1.7-.2-.2-1.1-1.4-1-1.5.6.2,3.4.4,3.5.5Z"
          fill="#4892f4"
        />
        <path
          d="M216.2,82.9c.1-2,.8-1.6,1,.5s-.6.1-.3.5c.8.9,1.9,0,.8,2.5-2,2-2.8-.5-1.5-2.5,0-.3,0-.7,0-1Z"
          fill="#3d82ed"
        />
        <path
          d="M211.7,79.4c0,.5.2,1,.5,1.5-.3,0-.7.6-1,.4s.2-1-.3-.9c-1,1.8-2.5.5-2.8.5,1-.7,2.3-1.4,3.5-1.5Z"
          fill="#5086ee"
        />
        <path d="M218.7,82.9c-.2.1-.5.6-1,.5l.8-1,.2.5Z" fill="#3d82ed" />
        <path d="M215.7,82.9l-.3.5-.7-.5c.3,0,.7,0,1,0Z" fill="#3a92f5" />
        <path
          d="M208.2,128.9c1.1.8,1.7-.4,2,1.5-2.6,1.8-.7,1.2-.5,2.5l-1.5,2c.2.7,0,1.2-.5,1.5,1.1,0,.3,2.2-.2,2-.9-1.4-1.8-.7-2.3.5.4,0,.3.2,0,.5-2,2.3-3.1-3.5-.5-4v-.8c-1.7-1.3-2-5.7,0-3.2,1.1.5,1.9,0,1.8-1.6h1.2c-1-.6-.7-1.1.5-.9Z"
          fill="#0289f7"
        />
        <path
          d="M210.2,125.4c0,.2-.5.7-.3,1.5s2,1,1.3,2-2-.3-2.3-.5c-.8-.6-.2-1.5-.2-1.5-.2-.2-1.2.1-1.5,0-2-3.2.9-3,3-1.5Z"
          fill="#0399f8"
        />
        <path
          d="M207.2,126.9c0,.3-.7.9-.5,1,1.8-.5,1.4.9,1.5,1-.2.3-.3.7-.5,1l-1,.9c-.2,0-1.9-3.4-2-3.9-.7-.6-.4-1.3.5-1,.9-1.5,2.2-.6,2,1Z"
          fill="#0492f8"
        />
        <path
          d="M209.7,134.3c.4.5.6,1.2,0,1.5.2,1.4,1,1,1,1.2s-.5.2-.5.3c-.1.4-.3.4-.5,0-.2.4-.3.4-.5,0-1,.6-1.8,0-1.1-.8l-.4-.2c-.2-.7-1.2-.3.5-1.5.2-.9.4-1.3,1-.5h.5Z"
          fill="#037ef4"
        />
        <path
          d="M212.7,132.8c-.8,2.2-2.9-.9-1.5,1.8-2.3-.6.8,1.4-1.5,1.2,0-.4,0-1.2,0-1.5.2-1.1,1.5-2,2.5-2s.4.4.5.5Z"
          fill="#0469e8"
        />
        <path d="M210.2,130.3c.8-.6.9-.6,1.5.3.2,1.1-.5.7-1.5.7,0-.3,0-.7,0-1Z" fill="#0265ed" />
        <path d="M209.7,132.8c0,.4-.3,1.1-.5,1.5-.3.2-.7.3-1,.5v-2s1.5,0,1.5,0Z" fill="#0469e8" />
        <path d="M212.2,131.8c0-.3,0-.7,0-1l.5.3-.5.7Z" fill="#0469e8" />
        <path
          d="M208.7,140.8c-.1.7.4,1.6-.5,2l-.5,1c.6.8-.5,3.5-1.5,2.5l-.4-.2c.3,1.5-1,3.3-1.6,1.2-1.5-.5-1.6-.9,0-1,.2-.5.5-.9,1-1-.4-.1-.4-.3,0-.5l-1-.5c-.1.4-.3.4-.5,0l-.8-.5c-2.8,1.3-4-2.2-1.2-2.5.8-.6,2.1-1.4,3-.5.6-.4,1.4-.4,2.5,0,0-.9.3-1,1-.5.5-.8.6-.6.5.5Z"
          fill="#0370f1"
        />
        <path
          d="M208.2,144.8c0,.2,0,.3,0,.5l-.5,1c-.7,2.2-1.7,4.3-2.5,6.5-.1.3-.3.3-.5,0l-.5-.5c-.9-.7-.9-1,0-1l-.7-.9c.8-1.3,1.7-2.7,2.7-4.1.6,0,1.5-1.9,1.5-2.5.1-.4.3-.4.5,0,0,.3,0,.7,0,1Z"
          fill="#075ee0"
        />
        <path
          d="M209.7,138.8c-.4.8-.6.2-1,2,0-.2-.4-.4-.5-.5-1.9-.5-.7-3.9,1-3,0,0,.3,0,.5,0,.3.2.3.7,0,1.5Z"
          fill="#0379f5"
        />
        <path d="M208.2,142.8v1h-.5c0,0-.8-.8-.5-1s.8,0,1,0Z" fill="#0379f5" />
        <path d="M209.7,138.8v-1.5h.5c-.2.7,0,.7-.5,1.5Z" fill="#0268ee" />
        <path
          d="M204.7,153.8l-.5.5c.3.1.2.3,0,.5,0,.2,0,.3,0,.5l-.5.5c-.7,3.1-2.3,5.6-3.5,8.5h-.5c-1.6,1.2-3.2-.4-1.5-1.5.4-.6.9-1.2,1.4-1.8-1.5-1.6-1.1-3.2,1.3-3.1,0-1.4.3-2.7.9-3.8-.4-1,0-1,.9-.3-.4-1.1.2-1.3,1-.5,0-.5,0-.7.5-.5.2-.3.3-.3.5,0,.2.2.2.5,0,1Z"
          fill="#054edb"
        />
        <path d="M204.7,154.3c-.2.2-.3.2-.5,0,0-.2.5-.4.5-.5,0,.2,0,.3,0,.5Z" fill="#035fe8" />
        <path
          d="M191.8,170.8c.8,1.5.3,3.3-1.5,5.5v.5c-.8,0-1.7,0-2.5,0-.1.9,1.1.4,1.4,1.3s0,2,0,2.7c-.3,0-.9.3-1,.5-.6.7-1.6,1.1-3,1,.4.2.4.3,0,.5-.6,1.5-1,.7-1.5-.5-1.3.6-1.6,0-.5-1,.6-.1.8-.3.5-.5-1.6-.8.1-1.3.2-.6.4,2.4-4.6-2.1-.2-2.9-.1-.6.2-1,.5-1.5,0-1,.6-1.3,2-1-1.2-.5-1.3-2.2,0-2.5.5-.6.8-.8,1,0,.2.7.8.7,2,0,0-.5.4-.8,1.5-1-1.9-1.8,2-3.1,1-.5Z"
          fill="#027df7"
        />
        <path
          d="M198.2,161.8c1.2.1,1.1.7,0,1,.2,1.3.3.8,1.5,1.5-.3.5-1.8,1.5-1.9,1.6-.1.2.4.8.4.9-.1.1-.8-.1-1,0v1.5c0,.2,0,.4,0,.5l-.5.5c-.1,0-.3,0-.5,0-.2,1.5-1.5,1.3-2,0-1.4-.2-1.2-.4,0-1,0-.2,0-.5,0-1-1.5.2-2-.2-1-1.5,1-.6.8-1.3-.5-2,0-1,.9-1.5,3-1.5-.7-1.8,1.7-1.6,2.5-.5Z"
          fill="#026cf0"
        />
        <path
          d="M194.3,169.3c.6-.1,1.4,0,2,0-.4,1.4.4,2.5-1.3,3.5-.4-1.3-.9-1.1-2.2-1l1.5,1-1,1.5c.3.3,1.6-1.5,2,1l-2-.5.5,2c-1.5-1.8-2.7-.4-3.5-.5s-2.6-.5-2.5-1c2.8,1.4,3.7-4.4,4-4.5-.3-2.3.8-2.2,2.5-1.5Z"
          fill="#0364f2"
        />
        <path d="M197.2,168.3c-.5-.5-.5-1.2,0-1.5.5.6.2.9,0,1.5Z" fill="#0364f2" />
        <path d="M196.7,169.3s.4-.4.5-.5l-.5.5Z" fill="#0364f2" />
        <path
          d="M184.3,193.3c.7,0,1.3,0,2,0-.3.2-.6.5-1,.5-.2.9.9.3,1,.5s-1.3,2-.5,3c0,0-1.3-.8-1.5-1-1.7-.3-.4-.5-.5-.5-2.5.6-1.8,0-.3,0s.2.2.3.5l-1.5,1c1.9.8,2.6,2.9.5,4.2s-.9-1-1,.8c1.4.6.4,2.4-1.1,2.8s-1.3-2.3-1.4-2.8c-.3-.8-.5-1.7.5-1.5.5-.2.3-.9-.5-2-2,1.1-.4-3.4,1.2-2.2-.4-1.3-.3-2.2.3-2.8.2-.4.3-.4.5,0l1-.5c.3-.9,1.7-1,2,0Z"
          fill="#0252eb"
        />
        <path d="M179.8,200.8c-.6,1.4-.9.8-1-.5.2-.4.3-.4.5,0,.8-.7,1.1-.4.5.5Z" fill="#0252eb" />
        <path
          d="M179.3,202.3c1.6,0,1.4,1.9,1.8,2,1.2.4.7-1,.7-2l2,.5c-.2,0-.4,0-.5,0l-.5.5c0,.2,0,1.2,0,1.5h-1c-2,.4.2,1.8,0,2-.4.3-2.3-1.7-3.5-.5-.6-1.7-1-3.4,1-4Z"
          fill="#035eed"
        />
        <path d="M183.8,196.3h-2c-.6-.3,1.5-1.2,2.2-1s.2.9.3,1h-.5Z" fill="#0271ee" />
        <path d="M189.3,186.8c-.1,0-.9.7-1,.5-.4-.6.5-1.4.5-1.5l.5,1Z" fill="#0370f0" />
        <path
          d="M185.3,182.3c.2-.7-.1-1.5.8-2,.4,1.6,1.1.3,2.2,1-.1.5.2,1.4-.2,2s-3.6,1.2-1.5,1.4,1.4-.5,1.3,1.1l-2.5-.5c-.2.2,1,1.1,1,1.5l-2.5,1.5c-.4,1.2-1.4.8-1-.5-.3-.4,0-.9.5-1-1.4.3-1.8-.3-1-1.5.1-.4.3-.4.5,0,.7-.8,1.5-1.9.1-2.2l.9-.8,1.5.5c.7.1.5.5,0,1,0,.4.2.4.5,0l-.5-1.5Z"
          fill="#026ef5"
        />
        <path
          d="M180.8,207.8c-.6.1-1.4,0-1.4,0-.6.9.6,1.8-2.1,1.9-.4-.1-.4-.3,0-.5.6-.4,1-.7,1-1-1.3-.6-.8-1.3.5-1,.7-1,1.3-.2,2,.5Z"
          fill="#025bf3"
        />
        <path d="M177.3,209.3v.5c-.2,0-.4,0-.5,0-.3,0-.5-.2-.5-.5.4-.4.7-.5,1,0Z" fill="#0238df" />
        <path
          d="M178.8,200.3c.2.5.7.4,1,.5,0,.1-.4,1.1-.5,1.5-.2.8-.3,1.6-1,2.3,2.5.8.1,1.3,0,1.7s0,.5,0,.7l.5.3c0,0-.5.9-.5,1,0,.7-.8.7-1,0h-.5c-1.4-1.3-2.4-1.3-.5-2.5.2-.2.3-.4,0-.5-.8.2-1.8.4-2.5,0s-.4-1-1-1c-.3-.1-.3-.3,0-.5,1.7.4,1.6-.3,2.4-1s1.7.2,1.1-1c.7-.6,1.3-1.2.3-1.6,1.2-1.8,2.4-2.4,2.2,0Z"
          fill="#026bf3"
        />
        <path
          d="M179.3,198.8c1.4,0,2,2.1,1.8,3-.4-.4-.8-.7-1.3-1,0-.5-.4-.4-.5-.5-.8-.5-1-1.3,0-1.5Z"
          fill="#026bf3"
        />
        <path d="M182.8,203.3l.5-.5s-.5.5-.5.5Z" fill="#0444df" />
        <path d="M236.7,396.7c.2.6-1.5,2.6-1.5,1.7l.5-1.2c.3-.1.9-.4,1-.5Z" fill="#02389e" />
        <path
          d="M241.2,396.7c.1-.4.3-.4.5,0,1,0,.7.4,0,1,.3.5,0,.6-.5.7,2.3-1.2,3,1.1,1.5,1.8.3.3.7.3,1,0-.4-.1-.4-.3,0-.5-.6-1.6,1.8-1.5,2.3-.4s-1.9,3-2.8,3.4c-.6.8-.4,1,.5.5,0-1,.7-1.4,2.3-1.2,1.2-1.6,3.7-2.7,4.5-.4,1.2-.5,3.4,4,3.2,4.2s-.3.3-.5.4l.5-1.5c1-.6,2.5,1.2,1.5,2-.8,1.7-1.6,1.3-2-.5-1.3-.1-1.5-1-2.5-1.5.1.7-.4,1.4-.5,2-.2.9-.4,1.2,0,2.5-1.5-1.3-1.8-1.2-2,1l-2-1v4.5c-.1.4-.3.4-.5,0-2-2.1,0-1.3,0-1.8,0-.8-.3-3.9-1.2-4.1s-2.2.7-2.3,1.1c0,1.4,2,.9,2.3,2.2s-.2,2.4-.3,2.5c-.1.1-.7,0-1,0,0-.2-.5-.4-.5-.5-.2-.7-.4-1.2-1-1.5-.6-.4-.3-2.3-.5-3-2.7.4-3.3.7-6,.5,0,.3,0,.7,0,1-1.5.3-1.7-1.1,0-1,0-.3,0-.7,0-1l3.2.5c1.1-1-.6-.9-.6-1.2,0-.6.8-.9-.4-1.7s-1.9.1-2.2,0,.6-1.2-.3-1.5-.3.9-.7,1c.7-2.1-1.5-1.3-1.5-1.8.2-1,.8-2,1.5-2.7.5.3.8.8,1,1.5q.7.7,0,0c-1.1-.6,1.7-4.7,2.2-4.7s.5,0,.8.2c.2-.7.9-1.1,2-1,.2-.2.5-.2,1,0Z"
          fill="#023ca2"
        />
        <path
          d="M243.7,403.2l-1,1.5c-.1-.4.3-1.4-.2-1.5-2.5,0-1.9,1.2-2.3,1.4-1.1.8-1.9-2.8-3.5-2,0-1.3,2-.3,2.4-.6s-.2-1.2.9-.9l-.3,1h1.8c-.2-1.1-1.5-1.6.5-2,.6,0,0,2,.3,2.5s.8,0,.9,0,.4.5.5.5Z"
          fill="#0245a9"
        />
        <path
          d="M238.2,397.2c.3.1.3.3,0,.5-1.8,1.8-2.1,1.2-1.5,4l-1-1c0,.6-.4,1-.5,1.5.3,0,.7,0,1,0,.3,1.5-1.2,1.6-1,0-.2,0-.9.6-1,.5,0-.7,0-1.3,0-2,.4-.4,1.8.5.5-2.5-1-1.7.2-2.9,1-1,.3.3.7.1,1-.5-2.1-.1,0-2.2.7-1.2l.8,1.7Z"
          fill="#023fab"
        />
        <path
          d="M240.2,396.7c-.4.6-.9.5-1.5.5v.5c1.3-.5,1,2.3.2,3-.1-1-.5-2-.7-3s0-.3,0-.5c-.3-.1-.2-.3,0-.5.8-.5,1.4,0,2,0Z"
          fill="#0247b7"
        />
        <path d="M241.2,396.7c-.3.6-.7,0-1,0,0,0,0-.3,0-.5h.5l.5.5Z" fill="#02278b" />
        <path d="M243.7,400.2c-.6,1.3-.8.1-1,0h1Z" fill="#023fad" />
        <path
          d="M164.3,90.9c.4-.7,2.3-1.8,2.9-1.9,4.4-.9,9.9-2.4,14.7-3.6s.3-.9.7-1c1.9-.6,1.8.1,1.2,1.5s-.7,1-1,1.5c.1,1.1-.2,1.3-1,.5-.2.9-.9.8-2.1-.2l-4.4,1.4c-.7,0-.7-.5-.6-1.2-3,.7-7.5,2-10.5,3Z"
          fill="#4672e5"
        />
        <path d="M186.8,83.9l1,1c-1.6.2-1.9-.3-2.8,1.5l-.2-1c1-.9.5-.8,2-1.5Z" fill="#4672e5" />
        <path
          d="M166.3,94.9c1.9-.7,3.2,3.3.5,2.9v.6c0,1.4-2.3,1.6-3.5,1.5.8,1,0,3.5-1,2-.8,0-1.1-1-.5-1.5-.4-.6-1.4-.3-1-1.5,1.9,1,2.2-.1.5-1,.1-.2-.2-1.3,0-1.5s1.9.6,2.7.5,1.2-1.5,2.3-2Z"
          fill="#1c69e9"
        />
        <path
          d="M174.8,87.9c0,0,.6.5,1.2.4,1.2-.2,3.6-1.4,4.6-1.4s.3,1.4,1.3,1c2.3,2-1.2,2.4-3,1-.9,1.4-2.5,2.1-4.7,2.2,0,.7-.7,1.2-1.3,1.3-.1.4-.3.4-.5,0-1.2-.3-1.9-.8-2-1.5v-.5c1.4-.6,1.2-1.4,2.9-.6l1.6-1.9Z"
          fill="#3872e6"
        />
        <path
          d="M170.3,93.9c1.3,0,1.8.9,1,2,.9,0,1.4,0,1.5.5.6,1.5-.6,2-3.6,1.5l-1.4.5c-.2,1.3-.5,1.2-1,0l-2-1.3c0-.2,1.4-.8,1.7-.8s0,1.6,1.3,1l-1.5-2.5c.5-.2,2.1-.8,2.5-1,.4-.8.9-.8,1.5,0Z"
          fill="#2373ee"
        />
        <path
          d="M170.3,90.4c.4.1.4.3,0,.5.5,1-.4,3.2-1.5,3,.3,1.4-1.7,2.2-2.5,1,.1.3.2.6,0,.7-1.1,1.2-2.9,3.1-4.2,1.9l-.9.4c0,.8-.9,1.4-1.8,1.7s-2.7.4-2.7-.2l-1,.5c-.2.5-.3.5-.5,0-.3-.2-.7-1.4-1.5-1.5.2-.3.5-1.5,1.5-2,1.3-.6,2.2-.8,3.5-1.5,1.9-.3,3.5-1.8,4.8-3.1,2.1,0,4.1-.6,6-1.8l.7.4Z"
          fill="#2d67e5"
        />
        <path
          d="M174.8,87.9c1.6,1.8-3,2.7-4.5,2.5-1,.5-3.8,2.3-4.3,2.3s-2.3-.6-2.7-.3.5.9.4,1.2c-.3,1.4-1.8.2-2.6.3s-.8,1.8-2.3,1c1.7-.9,3.5-1.8,4.5-3.5.3-.1.6-.4,1-.5,3.1-1.8,7.1-2.8,10.5-3Z"
          fill="#396ae5"
        />
        <path
          d="M170.3,90.9c.1,0,1.4.5,2,0,0,.5,0,1,0,1.5-.3.6-.9,1-2,1,.4.1.4.3,0,.5-.6.8-1.4,0-1.5,0,1.3-.8.1-2.7,1.5-3Z"
          fill="#2a72e9"
        />
        <path d="M166.8,93.9c.3-.3.5-1.6.7-1.5,1.2.5.5,1.7-.7,1.5Z" fill="#396ae5" />
        <path d="M156.8,99.4l-1,.5c0,0,.5-.3,1-.5Z" fill="#225be2" />
        <path
          d="M153.8,104.4c.3,1.5,1.2,2.3,2.5,2.5,2-1.4,3.1,1.2.6,2.1-.2,1-.7,2-1.6,2.9-.4.4-.4.7,0,1,.6-.4.8-.2.5.5.4,0,.3.7,0,1-.5,0-.8.2-1,.5-.1.4-.3.4-.5,0-.6-.4-1.1-.6-1.5-.5-.6-.8-2.4-1.1-2.9-1.6s-.4-1.5-.6-1.9c-2.5,0-4.7-1.1-2.5-3.5,0-.5,0-1,0-1.5l1,1.5h.5c-.2-1.7.9-.4,1-.5.6-.2,1.1-.6,1.5-1,.4-.2.9-.4,1.5-.5-1.5-1.2.6-1.9,1.5-1Z"
          fill="#065eeb"
        />
        <path
          d="M145.8,107.4c.7.5.5,1.5.1,2.2,1,1.1,1.9,2.2,2.9,3.3,2.3,1.8,1,.9.7,2.3s.8,2.6-1.1,1.1,0-.8,0-.9l-.8-1.6c-4.8-1.3-6.1-2.9-3.7-4.9.3-.1.8-1.2,2-1.5Z"
          fill="#085cee"
        />
        <path
          d="M146.8,107.4c0,.6,0,1.8,0,1.9.1.2,1.9.7,2.5,1.6-.3,0-.9,0-1,0l.5,1c0,.3,0,.7,0,1-.9-.7-2.8-1-2.9-1.1s0-.8-.3-1.2-.8-.2-.8-.5c-.1-1,1-1.7,1-2.7.3,0,.7,0,1,0Z"
          fill="#0453e6"
        />
        <path
          d="M143.8,108.9c.3.7-.7,2.8-.5,3s4.2,1,4.9,1.6-.4,1.5,0,1.9c-.7-.6-.9-.9-1.5-1.5-1.5-1.4-2.3-.8-4-1,0-.8-.9-1.5-1-2-.1-.2-.3-.2-.5,0-1.3,1.2-2.1.4-1-1,2.1-.2,2.2-1.2,2.8-1.4s.7.4.7.4Z"
          fill="#034be7"
        />
        <path
          d="M150.8,105.4c.4.1.4.3,0,.5,0,.9,0,1.4.8,2s0-2.1,1.2-.2c-.1.6-3.3,2.4-3.5,2.2s-.5-1.6-1-2h1.7s-.7-1-.7-1c0,0,.1-1.4,1-1.5,0-.5.2-.4.5,0Z"
          fill="#0252e0"
        />
        <path
          d="M152.3,103.4c.2.2.4.2.5,0,.2,0,.4,0,.5,0,1.3-.7,1.6,0,.5,1-1-.3-1.1.7-1.5,1-.6.4-1.1.4-1.5,0-.2,0-.3,0-.5,0-.3,0-1-.6-2,0-.5-1.1.9-1.1,1-1.5,1.1,0,2.1-.4,3-.5Z"
          fill="#1763e9"
        />
        <path
          d="M161.8,100.4c.6.8.3.8.5,1.5.4.1.8.5,1,1,1.1,1.1,1.2,2-.5,2l-.9,1.2c.8,2.3-4.7,2.8-4.1-.2v-1.5c-.8-1.5-.9-2.3,0-2.5h2c.5.2.7-.1.5-1l1.5-.5Z"
          fill="#0663e8"
        />
        <path
          d="M154.3,101.9c0,0,.6,0,.8-.1.5-.4.5-1.6,1.4-1.4-.4,1.7.5.8,1.3,1.5s0,.7.3,1,1.3.4,1.2.8-1.4.8-1.5,2.2c-.1.4-.3.4-.5,0,0-.8-.4-.7-1,.5.4.1.4.3,0,.5-3.2,1.3-2.1-.7-2.5-2.5s-.5-1-.5-1c.4-.4.7-1.2,1-1.5Z"
          fill="#146aef"
        />
        <path
          d="M160.3,100.9c1.3,1,.7,1.5,1,3-1-.2-1.1-1.5-1.5-2-.6-.7-1.7-1.1-2-2,.7,0,1.9.6,2.5,1Z"
          fill="#186fed"
        />
        <path d="M152.3,103.4c.2,0,.3,0,.5,0l-.2.5-.2-.5Z" fill="#065eeb" />
        <path
          d="M140.3,159.8c1.9-1.1,1.7.8,1.2,2.3l.2-.3c.8-1.2,1.1-.9,1,.5,1,1.2.1,2.2-1.4,2.4-.6.8-1.3,1.4-2.1,1.6,1.5.4,1.1.9-1,1.5.4.8-.7.2-.7.2.1,0,1.3.3.7.8-.3.4-1,.6-1.5.5-.1.4-.3.4-.5,0v-.5c-.4-.2-.4-.3,0-.5q.2-.2,0,0c-.7.8-2.1.6-4-.5.5,1.3,0,1.4-1,.5-.5.8-2-.1-1.5-1-.4-.4-.3-.6.5-.5-1-.8-1.6-1.5-1.6-2l-.4-1c-1.5,1.9-.7-2.6,1-.5.1-.4.3-.4.5,0l1,.5c-.4-.6-.1-.8.5-.5,0,0,.9,0,1,.2.7,2.2-1.4.6-1.5.8.4,2.8,1.4.9,2.5.5.3-.6.9-.6,1.5-.5v-.5l.5-.5c-.9-1.2.3-3.8,1.3-2.3,1-.8,2.7-1.8,3.7-1.2Z"
          fill="#0371f7"
        />
        <path
          d="M130.3,141.8c.5,0,1.4.6,1.5.5s-.1-.8,0-1.1c.2-.4,1.4-1,1.5-.9.9,1-2,1-1,2s1.5,0,2,.5v-1.5c0,0,.8.4,1,.5.6-4.1,4.9-.7,2.8,1l.2,1c.3.6.8.7,1.5.5.2-.3.3-.3.5,0,1.5-.1.6,2.4.1,2.9-1.3,0-2.2.1-2.6.6.6,0,.7.4.5,1,.5-.1.6,0,.5.5,0,.5-.6.6-1,.5-.5-.6-.8-.7-1-.5-.5-.3-1.7-1.5-1.5-2q.9-.1,0,0c-2.3,0,.4,1.8,1,2.5l-2.5,1c-.1.4-.3.4-.5,0,0-.7-.5-1.5-.5-1.8s1.8-.7,1-1.7-1.8,1.9-3,1c.4-.8,1.2-1,1.5-1.5-.1-2.1-.5-2.8-1-2-.3-.1-1.3-.6-1.5-.5v-.5c.4-.9.5-.9.5-2Z"
          fill="#0365ef"
        />
        <path
          d="M141.3,158.3c.4.1.4.3,0,.5,0,.7-.4.9-1,1-.3.5-1.9.5-2.5.5l.5,2.5,1.5-1.5c.3,1.7-1.8,2.4-1,4-3-.1-2-1.9-1.5-4-2.6-.5-1,1.3-1,3-.5-.3-1-.3-1.5-.5-.3-.2-.3,0,0,.5-.3,1.4-1.4.5-1.5.5-.3-1.3-.4-2.4,0-3.7,0-.3.2-.3.5-.3,0-.5.8-.8.8-.7.2,1.8-2.5-1.2,2.1-1.9,0,1.9,2.2.6,3.2-.4,1.1-.3,1.6-.1,1.5.5Z"
          fill="#0367f5"
        />
        <path
          d="M139.3,151.8c.8.6,1.8,1,2.9,1.2v.8c1.1-1,1.6-.7,1.7,1,1.6.2,1.1,3.1-.7,2.5-.3-.6-.7-.7-1-.5v.5c0,.4-.3.4-.5,0-.2.3-.3.3-.5,0l-.8-.5c-2,1.4-2.4,1-3.7-.5,0-.1,0-.5,0-.5-.2-.2-.4-.2-.5,0-.2-.1-.4-.2-.5-.5,0-.8.7-1.3,1.9-1.5-.4-.1.3-1.3.6-1.5-.3-1.1.1-1,1-.5Z"
          fill="#0373f4"
        />
        <path
          d="M127.8,159.3c-.3.6-.1,1.8-1,2.5,3.6,0,2.3-6.4,4.5-1.2,0,.8-2.2-.2-1.5,1s1.3.6,1.5.8-.1.9,0,1c0,.4-.2.5-.5.5-.4,0-.6-.2-.5-.5l-1.5-1c-.9.4-1.2.9-.9,1.4h-.6c-.1.4-.3.4-.5.1-.1.4-.3.4-.5,0,.3-.7-.5-2.2-.4-2.4s1.5-.4,1.4-2.1c.1-.4.3-.4.5,0Z"
          fill="#036cf5"
        />
        <path
          d="M136.3,157.3c1-.4,2.1-.2,3.5.5-.1,0-.2,1-.6,1.3-.7.5-2.1.5-2.6,1.6-.1-3.4-1.9-2.2-1.8.5-.1.2-.8-.5-1-.5l-2-2c1.9-.4,3.2.5,4.5-1.5Z"
          fill="#0477f5"
        />
        <path
          d="M128.8,162.3c.5.2,1,.5.5,1-.2,0-1.4-.9-1.5.3s.5.2.5.2c.9.3.9.8,0,1-.2,1-.5,1.2-1,.5-.5.8-1.5,1.6-2.5,1l-.3.7c-.9,0-1.8.2-2.7.8.3.5,0,.7-.5.5-.2-.4-.8-.4-1-.5-.2-.4,0-.8.6-1.4-.2-2.2.3-2.9,1.4-2.1l1.5-1c.5-.4,1-.1,1,.5h.5c.2.2-.5,1.3.7,1s.1-.8.3-1,.4,0,.5,0c.2.2.4.2.5,0,.6-.6,0-1.6,1.5-1.5Z"
          fill="#0250ec"
        />
        <path
          d="M124.8,160.8c-.2.4-.5.7-1,1-.9.1-2.4-.3-2.5,1.3s1.3,0,1,1.2-.8.1-.5,1c.5-1.1,3.7-1.3,2.5,0s-3.7.8-4,2.5c-.1,0-.5,0-.5-.2,1.5-1.9,1.2-2.4-1-3,.5-.7,1.5-.6,2-1.3s.2-1.3,1.5-3c1.4-1.7,2.9-2.2,2.5.5Z"
          fill="#0366f3"
        />
        <path
          d="M141.3,157.3c0,.5-.6.6-1.5.5-1,.3-2,.5-3,1,.2-1.2,1.2-1.7-.5-1.5,0-.1.5-.9.5-1,1.4-.4,1.6,1,1.7,1,1.3-.3,1.6-2.3,2.5-2s.5,1.4.3,2Z"
          fill="#0264f1"
        />
        <path
          d="M131.8,150.8l-1.5.5c.4,1,2.1.2,2,.7s-1.8-.3-.5,1.7c-2.1.3-1.2-.2-1.5-1-1-2.4-2.4-1.1-2-2.5l.5-.5c.1-.1.4-.5.5-.5.3-.1,1,0,1.5,0s.9-.6,1-.5c.5.5.4,1.6,0,2Z"
          fill="#0368f3"
        />
        <path
          d="M139.3,148.3c1.8-.5,4.9,0,3,2-.1.4-.3.4-.5,0-.9.9-1.2.8-1-.5-.1.6-.4.7-1,.5.6.7.3,1-.5.5-.3-.1-.3-.3,0-.5,0-.5-.3-.7-.5-1s-.4-.3-.5-.5c-.8-.7.3-1.1,1-.5Z"
          fill="#0482f5"
        />
        <path
          d="M124.3,158.3c1.8.6,1.2.7.5,2.5.1-.2-.7-.9-.5-1.5l-2,1c.4-.5.4-1.6,2-2Z"
          fill="#0254ef"
        />
        <path
          d="M138.3,150.8c.6-.1.8,0,.5.5h.5c.3.1.3.3,0,.5-.2.2-1,.4-1,.5-.5-.3-1-.4-1.5-.5s-.7,0-1,0c0,0-.3-.7.4-1s1.6,0,2.1,0Z"
          fill="#0482f5"
        />
        <path d="M127.3,159.3c0-.9-1.2-1.7.2-1.5,2.6.4.3,1.3.2,1.5h-.5Z" fill="#0254ef" />
        <path d="M133.8,150.8c1.3.7,1.3,1.1-.2,1.5-.8-.3-.2-1.4-.3-1.5h.5Z" fill="#0772f6" />
        <path d="M131.8,150.8c-.5.5-.8.6-1.5.5-.1-.3,0-1,0-1.5l1.5,1Z" fill="#0247e0" />
        <path
          d="M125.3,163.3c.2.2,0,.4-.5.5-.3-.2-.7-.4-1-.5s-.7,0-1,0v-.5c1,0,1.6-.2,2.5.5Z"
          fill="#0366f3"
        />
        <path d="M137.8,149.8c-.8-.1-.6-.3-1-.5,0-1.9.6-.8,1,.5Z" fill="#0482f5" />
        <path d="M124.8,160.8c-.3.9.6.8-1,1-.4-1.2.9-.9,1-1Z" fill="#0340e9" />
        <path d="M131.3,162.3c-.2-.2.9-1.3,1.5-1,.2.2-.9,1.3-1.5,1Z" fill="#0877f5" />
        <path d="M125.3,163.8c0,0-.4,0-.5,0l.5-.5c0,0,.4,0,.5.2l-.5.2Z" fill="#0581f5" />
        <path d="M139.3,150.8c0,.3-.2.5-.5.5-.2,0-.4-.3-.5-.5.3,0,.7-.4,1-.5v.5Z" fill="#0267ee" />
        <path d="M136.8,155.8c0,0-.4,0-.5,0l.2-.5.2.5Z" fill="#0264f1" />
        <path d="M116.3,161.3c.2-.9.2-2.4,1.5-2l.5,2c-.8-.7-1.8,0-2,0Z" fill="#0249ec" />
        <path
          d="M131.3,144.8c.2-1.8,1.4-1.4,3-1l-1.5.5c0,.9,0,1.7-.5,2.5-1.1.5-1.1-1-1-2Z"
          fill="#0251eb"
        />
        <path d="M125.3,143.8c-.3,0-.7.4-1,.5l.8-1.5.2,1Z" fill="#066ff0" />
        <path d="M111.3,171.8c.1-.7,1.6-1.9,2-1.5,1,.9-1.4,1.4-2,1.5Z" fill="#035af1" />
        <path d="M113.8,169.8l-.5-.2,1-.8c.1,1-.5.9-.5,1Z" fill="#035af1" />
        <path d="M112.3,177.8h-.5c0,0-1-1.5.5,0Z" fill="#011edc" />
        <path d="M110.8,164.8c0,0-.2.5-.2.5-.6-.6-1.2-.9-.3-1.5l.5,1Z" fill="#0343ed" />
        <path d="M111.3,165.8v-1c1.3.3,0,.9,0,1Z" fill="#0343ed" />
        <path d="M112.8,162.3c-.2,0-.4,0-.5,0,0,0,0-.4.2-.5l.3.5Z" fill="#023fe8" />
        <path d="M111.8,162.8h-.5c.2-.2,0-.3.5-.5v.5Z" fill="#023fe8" />
        <path d="M111.8,162.8v-.5c.1,0,.3,0,.5,0-.2.1-.3.4-.5.5Z" fill="#0343ed" />
        <path d="M110.8,163.8l.5-.5c-.1.1-.2.3-.5.5Z" fill="#0343ed" />
        <path d="M125.8,142.8c-.5-.8-2.5-1.6.5-1.5.2.2-.7,1.3-.5,1.5Z" fill="#023ae7" />
        <path d="M129.8,143.8c0,.1,0,.3,0,.5-1.2-1.2,0-2.5,0-.5Z" fill="#0031d8" />
        <path
          d="M113.8,162.8c2.1.8.9,2.3,1,4h-.5c0-.3,0-.8,0-1-.2-.2-.4-.2-.5,0h-1c-.2-.8.9-.5,1.3-1,1.1-1.3-.6-.9-.8-1-.4-.1-.4-.3,0-.5,0-.1,0-.3,0-.5h.5Z"
          fill="#023fe8"
        />
        <path d="M117.3,167.3l-.5.5c-.4.2-.7.3-1,0,0-.7.3-1.3,1-1.5.3.3.6.2.5,1Z" fill="#023fe8" />
        <path d="M112.8,163.8c.3.1.3.3,0,.5-1.1.3-1.5-.5-.5-1,.3,0,.5.1.5.5Z" fill="#023fe8" />
        <path d="M116.8,167.8c-.4.4-.9.4-1,.5v-.5c.3,0,.7,0,1,0Z" fill="#0343ed" />
        <path d="M113.3,163.3c0,.2,0,.5,0,.5-.1.3-.3.3-.5,0l-.5-.5c.2,0,.7,0,1,0Z" fill="#011bd5" />
        <path d="M112.8,164.3v-.5h.5c0,.5-.2.4-.5.5Z" fill="#0343ed" />
        <path d="M114.3,165.8h-.5l.2-.5c.3,0,.2.3.2.5Z" fill="#0343ed" />
        <path d="M143.8,143.3c-.4-.1-.4-.3,0-.5.1-.4.3-.4.5,0,.6.7.3,1-.5.5Z" fill="#036aef" />
        <path
          d="M146.3,127.4c.2,0,.3,0,.5,0,.1.6.1,1.3,0,2,1.1.8.9,1-.5,1.5.4.1.4.3,0,.5.3.9-.9.9-.8.3s1.6.2,1.8.7c1.3.2,1.3.6,0,1-.2,1-.9,2-2,3-.5.3-1,.6-1.5,1,.8.3.6.8-.5,1.5.2.8.5,1.6,1,2.5.4.2.4.3,0,.5-.8.5-.8-.4-.8-.4.4.4.8,1.1.3,1.4-.2,1.1-.5,1.5-1.1.5-.8,1.1-1.7,1.2-2.5.4-1,1.1-1.6,1.1-1.9.1l-2.5-.7,3-1.8c-1.9,1.1-1.3-.4-2.5-1l-.5,2c-.5.1-.5-.5-.5-.5v-1.5c0,0-.2-.7.1-.9.5-.4,1.5.3,1.4-.6-1.5,0-2.6-.6-3.5-1.8l1.8-1.2-2-1.5c-.5,0-.1.8-.2,1h-.5l.5-2.5c.2.3.8.4,1,.5.5-.4,1-.7,1.5-1,2.3,0,1.2.6,1.5,1,.9-.9,2.1.9,1,1.5-.5.8-.5,1.1,0,1,1-.9.4.6.2.2-.2-.8,1.8-2.5,2.2-1.2.4.1.4.3,0,.5,0,.4.1.6.5.5l-.5-1c0-2.4,2.9-2.1,2,.5h.5c-1.1-1.2-1.3-2.1-.5-2.7-.3-1.6.1-2.5,1.1-2.7l.4-1.1c0-.5,0-1.2,0-2,.4-1.5,2-.4,2.5.5Z"
          fill="#036aef"
        />
        <path d="M141.8,110.9h-.5l.8-1c.5.3-.3.7-.3,1Z" fill="#0d50e3" />
        <path
          d="M141.8,127.9c.9.2,1.6.6,2,1l2.5,1.5c-.7.4-2.4-.6-2.5-.5-.1.2-1.2,3.4-1.5,4l2,.5c-1,0-1.7-.1-1.5,1-.1.4-.3.4-.5,0-.8-3-1.4-.8-2-.5s-2.2,0-2,1.5l-.5-.5c-.8-.2-.7-.5,0-1,.1-.8.3-1.4.5-2v-.5c0-.2,0-.3,0-.5.8-.3,1.5-1.2,2.5-1q.2,1.8,0,0c.2-.9-.2-2.1.5-3,.1-.4.3-.4.5,0Z"
          fill="#0374f2"
        />
        <path d="M140.3,134.8c1-.4,1.4.1.5,1-.5.4-.8.2-.5-.5,0,0,0-.5,0-.5Z" fill="#0374f2" />
        <path
          d="M136.3,129.4c-1.3-.4.6-1.4,1.2-.9s-1,2.8-1.7,3.4c0,.2-.4.3-.5.5-.3.7-.3,1.3,0,2-1.1.4-1.1-.7-1.5-1,0-.4-.7-1.1-.5-1.5s.6-.2,1-.5c.3-.2.7-.5,1-1,.2-.3.9-.5,1-1Z"
          fill="#0351e5"
        />
        <path
          d="M138.3,132.8c0,.4.9,1.1.5,2-.3,0-.7,0-1,0,0-1.3-.5-.9-1-1.5l1-1c.3,0,.5.2.5.5Z"
          fill="#0158e5"
        />
        <path
          d="M143.8,118.9c-.5.6-1.5.6-2,1.3l1.5.2c.2.9-1,.2-1,.7s.8.3,1,.7c-.5,1.4-1.5,1.9-3,1.5-.2,0-.3,0-.5,0q-.7-.3,0,0c0,0,0,.7,0,1l-2,1.5c-.1.2.7,1.1,1,1.5.4.2.7.5,1,1,.1.5.9,1.1.5,2l-1.2-1.5c-1.4,1-.9,1.7-.7,3,.4.1.4.3,0,.5h-.5c.8,1.1.2,1.7-1,1-.8.1-1.2,0-1.5-1-.6-.6-.3-.8.5-.5.4-.3,1.8-2.4,1.8-2.6-.2-1.3-2.5-.8-1.3.1.3.7-.4,1.6-1,1-.1.6-.5.9-1,.5-1,1.1-1.5.9-1-.5.1-.4.5-.9,1-1.5-.5-.3-1-.2-1.5,0,.8.7.4,1-1,1,0-.3-.9-.4-.9-.7,0-.6.8-1.9.4-2.8.1-.2.9-3,2-1-.6.3-.6.7,0,1,0,0,1.3-1.7,1.4-2,.6-.9-.7-1.4,2.1-.5.2-.8-.3-1.4-.5-2,.3,0,.7,0,1,0-1-1.3.2-1.1,1.5-1.5l-1-2c1.6.3,1.8-.5,2-2,1.5,1.1,1.6,3,4,2.5Z"
          fill="#035aed"
        />
        <path d="M133.3,125.4c0,.2,0,.7,0,1-.1.1-1,.6-1,.5,0-1.2-.3-1.7,1-1.5Z" fill="#033ad9" />
        <path
          d="M134.3,128.9c.1.2.8,0,.5,1l-1.5.5c-.3-.1-.9-.6-1-.5,0,.3,0,.7,0,1-1.9.2-.5-.6-.5-1,.3-.3.8-.6,1-1,.2-.7.7-.7,1.5,0Z"
          fill="#036aef"
        />
        <path
          d="M143.3,121.9c.7,1.8-1.7,2.4-3,1.5.1,0,.9-.9,2,0,0-1.1-.3-1.8,1-1.5Z"
          fill="#024fe5"
        />
        <path d="M139.8,128.4c-1.5.3-.8-.7-1-1l1-.5c0,.5,0,1.1,0,1.5Z" fill="#0e7cf3" />
        <path
          d="M136.3,129.4c-.9.3-1.2,0-1-1,.7-.3,2.9-.9,3,.2s-1.5,3.6-2.5,3.3c.4-1,.7-2,1.5-2.8-.6-.9-.9.2-1,.3Z"
          fill="#036aef"
        />
        <path d="M139.3,121.4l1.2-.5c1.6,1.1-.6,2.4-1.2.5Z" fill="#024fe5" />
        <path d="M134.3,128.9h-1.5c.3-.4-.2-2.5,1.5,0Z" fill="#0240e0" />
        <path d="M135.3,130.3c0,0,.1.7-.1.9s-.8,0-.9.1v-.5l1-.5Z" fill="#036aef" />
        <path d="M139.8,123.4c0,0-.7,0-1,0-.2-.8.6-.7,1,0Z" fill="#024fe5" />
        <path d="M138.3,132.8l-.5-.5h.5c0,.2,0,.3,0,.5Z" fill="#036aef" />
        <path d="M137.5,131.3c.3.2.3.3,0,.5v-.5Z" fill="#036aef" />
        <path
          d="M142.8,112.9c.6-.9,3.9-.3,4,1-.9.2.4,1.3-.4,1.5s-.9-.1-1.1,0c-.3.3,0,1.5,0,2-1-.9-1.7,0-2,0-.5,0-.7-1.2-1.2.5-1-1,0-2.1-1.3-3.5s-.3-.4-.5-.5v-1.5c1,.9,1.9.4,2.5.5Z"
          fill="#0355ef"
        />
        <path d="M144.8,113.4c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#034be7" />
        <path
          d="M132.8,135.3c-.4,0-.2-1.4.1-1.7s4.4,2.5,1.9,3.6c3.3,1.7,3.4,2.7.4,3.1-.3.3-2.6-1-3-1.5l-.3,1.5c-1.1-1.6-1.5-1.9-3.3-2.5v-.5c.3-1,1.1-1.4,2.6-1.4,0-.8.5-1.1,1.4-.6Z"
          fill="#035deb"
        />
        <path
          d="M132.3,135.3c.1-.4.3-.4.5,0-.9,1.4-2.3,2-4,2v-3c.6.3,1,.7,1.7,1,1.4.5.2-.5.3-.5.1-.4.8-2,1-1.5,0,.8-.3,1.9.5,2Z"
          fill="#0253ec"
        />
        <path d="M134.5,138.8c.3.2.3.3,0,.5v-.5Z" fill="#0253ec" />
        <path d="M125.3,132.8l.5-1c.9,0,.2.7-.5,1Z" fill="#0249e7" />
        <path
          d="M106.8,188.3v.5c.5.5.2.8-.5.5-.2.2-.3.3-.5.5.5,1.3.3,1.5-1,1-.5.4-.8.8-1.5,1,0-.4-.8-1.3-.5-2,.9-.3.2,1.2.7,1,1.2-.5.2-1.9.2-2s2.2-.1,3-.5Z"
          fill="#021ad8"
        />
        <path
          d="M112.8,190.8c.6-.6,1.8-1,2.5-.5.2-.1.9-.6,1-.5-.6,2.5,2.2.2,1,3-.7,1.5-1,2.3-1.2,3.6h-1.3c0,0-1.5-.6-1.5-.6.2-.6,1.2-3.3,1-3.5s-1.1.1-1.5,0c-1,.9-2.6-1.5-1.5-2,0,0,.2-.5.4-.4.6,2,1,.9,1.1.9Z"
          fill="#034ef2"
        />
        <path
          d="M113.3,189.3c.6-.2,1.8.5,2,.5v.5c-1.2.8-.2,1.1-2.5.5-1.4-1.9.4-1.4.5-1.5Z"
          fill="#022be3"
        />
        <path
          d="M111.3,190.3c0,.9.6,1.7,1.5,2,.2,1.7-.6.5-2,.5-.5-.4-.8-.9-1-1.5,0,0-.3-1.1.5-1.5.2,0,.7.4,1,.5Z"
          fill="#0228e4"
        />
        <path
          d="M108.3,182.3c.2-.4.8-.1,1.6.8,2.1-.5,2.8,1.1,1,2.2l.4.5c.8,0,1.1.3,1,1,2.4-.8,2.9,1,1,2.5,0,.6-.2,1-.5,1.5.4,1.6-.8.6-1.5-.5-.6.9-1.3.5-1-.5-1.2,1-5.2,3.2-4.5,0-.6-.7-.4-.9.5-.5.5,0,.6,0,.5-.5-.4-.1-.4-.3,0-.5,1-.4,2.8-2.6,2.4-3.7s-1.4-.4-.9-1.8v-.5Z"
          fill="#023aeb"
        />
        <path
          d="M110.3,189.8c.6.7.4,1.2-.5,1.5.7.8.4,1.1-.5.5-1.6.8-3.6.7-4.5-1,.3-.3.7-.7,1-1,.9,2.2,2-.2,3.3-.4s.9.4,1.2.4Z"
          fill="#022fe8"
        />
        <path d="M106.8,188.8c1.1.5.5,1.6-.5.5.2-.2.4-.2.5-.5Z" fill="#022fe8" />
        <path d="M108.3,189.3c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#022fe8" />
        <path d="M218.2,349.7c-.1.1.1.8,0,1s-.4,0-.5,0c-1.2-1.3.8-3.1.5-1Z" fill="#01219d" />
        <path d="M220.2,342.2c.1,0,.7,0,1,0-.3,1.3-.9.5-1,.5v-.5Z" fill="#053fb8" />
        <path d="M210.7,355.7c-.7,1.3.6.7-1.5,2l-.5-1h1.5c-.6-1-.8-1.1.5-1Z" fill="#01207b" />
        <path d="M206.7,364.2c-2-1.4.7-3.3.5-1l-.5,1Z" fill="#011e83" />
        <path d="M205.2,364.2c0,0,.2-.5.2-.5,1,.7,1,1.2,0,2-.5,0-.1-.7-.2-1v-.5Z" fill="#02319e" />
        <path d="M218.7,378.7c2.5,1.1-3.6,2.2-.5,0,.2-.4.3-.4.5,0Z" fill="#023eb0" />
        <path
          d="M210.7,368.7c-.6-1.3.8-2.1,1.5-1.5s-.5.8-.5,1.2,1.3.5,1,1.3l1.5-1.5c0,0,.8-1,1-.2-.8,1.6.3,3-1,4.2,1.9-.4,1.4.8,1.5,1,.8,1.9,1.9,3.4,3.2,4.6l-.7.9c-.3.6-.8.9-1.5,1-.1.4-.3.4-.5,0-.3-.4-.5-.2-.5.5.2,1.3-.6,1.5-1.5.5-.5-2.7-2.1-.6-2.5-1s.7-1.9-1-1.5c-.5,2.1,1.2,1.6,1.9,2.1s0,.7.1.9c-.1.4-.3.4-.5,0-.5-.6-1,0-1.5,0-1.4-.5-.7-1.8-.5-3-.8-.9-1.5-3,.5-2.8-1.1-1.7-.9-3.7.6-5.9l-.6-.8c1.9,1,.6,3.8-1,2-.4-1.7-1.6-3,.5-3-1,1.7,0,.7.5,1Z"
          fill="#023eb0"
        />
        <path
          d="M208.2,376.2c.2,0,.6.5,1,.5.8.6,1.1,1.5,0,1.5h-.5c-.8-.8-.9-1.7-2.5-1.5v-.5c.6,0,1.4-.1,2,0Z"
          fill="#012d90"
        />
        <path d="M208.2,375.7l-.5-2s0-.6.5-.5c0,.9.8,1.9,0,2.5Z" fill="#022c90" />
        <path
          d="M210.7,368.7c.2.5,2,0,1.5,1.8s-1.6,0-.5,1.5,1-.4,1.5-.2c-1,1.8-4.5-.9-1.7,3s1.3-.4,2.5-.5.8.2.8,1c-1.6-.7-2.3.5-3.7,1.1s-1.3-.2-1.3-.1c-.4.7.8,1.3.8,1.7s-.3.2-.4.3c-.3,0-.7,0-1,0,.6-.6,0-1.2,0-1.5,0-1.4,0-2.7,0-4,1.4.1.9-.4.5-2,.4-.3,1.5-.4,1.5-.5s-.4-1.4-.5-1.5Z"
          fill="#0233a6"
        />
        <path d="M208.7,378.2h.5c-.2,0,.2.8-.5,0Z" fill="#023eb0" />
        <path
          d="M217.7,380.7c-.6,0-2.4.7-2,1.5h-.5s-.5-1-.5-1h-.5c0-.2,0-.3,0-.5.5,0,1-.3,1.5-.5-.3-.5,0-.7.5-.5,0,0,.4,0,.5,0,.9-.4,1,0,1,1Z"
          fill="#023fab"
        />
        <path d="M212.7,381.2c1,2-.7,1.4-.5,0h.5Z" fill="#0751b8" />
        <path
          d="M216.2,373.2c1.6.2,3.7,3.1,3,4,.1-.3.3-.3.5,0,.4.1.4.3,0,.5.5,1.8.2.3,1,1,.2.6-.4,1.5-1,1h-.5c.4.7-.3,1.2-1,1-.2,0-.3,0-.5,0-.3-.3-.7-.6-1-1-.2-1.2.5-1.1,1.5-1,0,.3-.7.8-.5,1,.8.3,1.4-.3,1-1q.2-.2,0,0s-.3,0-.5,0c.2-1.4-1.5-.9-1.2-2.5l-1.3.5,1,1.5c-3.3.5.4-2.8-1-5,0,0,.4,0,.5,0Z"
          fill="#0347b9"
        />
        <path
          d="M220.2,380.7c-.2.2-.7.1-1,.5-.4.1-.9-.5-1-.5.2-.5.6-.7,1-1h.5c.5-.2.8-.4,1-1,0,0,.4,0,.5.2l-1,1.8Z"
          fill="#023fab"
        />
        <path d="M208.2,363.2s-.5,0-.5,0c0,0,.3-1,.5,0Z" fill="#02319e" />
        <path
          d="M207.7,363.2c0,.4,0,1,0,1.5-.9.3-.8-.4-1-.5-.5-.7-.4-1.3.5-1,.2,0,.3,0,.5,0Z"
          fill="#02319e"
        />
        <path
          d="M210.2,359.2c.1,0,.4-2.6,1.8,0s-1.6,2,0,2.5.7-1.3.7-1.5c2.7.3,2,2.1-.1,3.2.8,1.4,1.4,3.2,1.6,4.8.3,3.4-1.8,1.6-3,0l-.5.5c-.2.8-.6,1.4-1,2,0,1-.1,1.6-.5,2-.2,1.7-1.4.7-1-.5-.1-.4-.5-.4-1,0,.6.6.3,1-.5,1-.6-.6-1.1-1.2-1-2.2s1.1-1.2,1.1-1.2c.1,0,3.6.8,1.9-.6s-3.4-.3-2-2.5l-2,.3c.7-1.6,2.8-.7,3-.8.4-.3.4-2.4.5-3s.4-1.3.5-2,0-1.9,0-2c.2-.2,1.3.1,1.5,0q.4.6,0,0Z"
          fill="#02319e"
        />
        <path d="M210.2,359.2c1.6-1,.3,1.5.5,2.5-1.5.7-1.1-2.1-.5-2.5Z" fill="#01268c" />
        <path d="M208.2,372.2h-1c.2-.3.4-.8.7-1,.9.5.2.9.3,1Z" fill="#022e93" />
        <path d="M206.5,371.2c.3.2.3.3,0,.5v-.5Z" fill="#022e93" />
        <path
          d="M146.3,278.8c0,.1,0,.5.3.5l1.7-.3-2.7,3.2c-1-2.2-.7-1-1.2,0,0,.9-1.6,1.4-2,.5-1-3.4.4-.8,1-3,1.2,1.5,1,.4,3,.5.4-1.7-1.3-.6-1.5-1.3-.3-1,.9-.7,1.3-1.2.5,0,.1.7.2,1Z"
          fill="#023ae8"
        />
        <path
          d="M152.3,276.3c-1-.3-1.3.2-2,.5-.3,0-.7,0-1,0-.4,0-.5-.2-.5-.5,0-.3,0-.7,0-1,1.3,0,2.4.4,3.5,1Z"
          fill="#0215c7"
        />
        <path
          d="M144.8,282.8c-.1,0-1.5.8-2,1-.5-.2-.4-.6-.5-1,.8,0,1.6.3,2-.5l.5.5Z"
          fill="#022de9"
        />
        <path d="M227.7,326.7c1.8.2,1.5,1,0,1,0-.3,0-.7,0-1Z" fill="#0856e9" />
        <path d="M228.2,329.2h-.5l1-1c.3.9-.4.9-.5,1Z" fill="#0b60ec" />
        <path
          d="M145.8,237.3c-2.6-3.1,2.3-3.4,3,0,.5,0,.7.4.5,1.5.7-.5.9-.3.5.5.3.6.4,1.4.4,2.5,1.5-.3,2.6-.1,3.1.5,0,.3.8,1.2,1,1,0-.6.2-1,.5-1.5.3,0,.5.2.5.5.1-.4.3-.4.5,0,.3.2.6,1.2,1.5,1,0,.6-.4.4-.5.5h-2l-.5,1c0,.2,0,.7,0,1,1.4.6,1.2.8,0,1.5l.5,1c.9-.2,1.2,2.1.5,2.5,0,.2,0,.3,0,.5.6,1,1.2,1.1,2,.5,0-.1,0-.4,0-.5l3,1c-1.5-.9-3.6,2.2-5,1.5s-1-2-2.5-1.5c.6-1.3,2.6-.2,2-2.5-.8-.2-.3,1.9-1.5,1s0-.5-.4-1-1.1-.4-1.1-.8,1.3-1.4,1-2.3c-3,1.6-1.2,1.9-1.1,3.3s-1.4,2-.9,3.2c-.1.2-.8-.5-1-.5,0-.3,0-.7,0-1-2.4,2-4.3.1-2.5-2.5.3-1,.7-1,1,0,.3-.4.7-.6,1-.5,1.2-.7,1-.9-.5-.5-.1.4-.3.4-.5,0-1.2-.6-2-1.6-2.5-3-.4-.1-.4-.3,0-.5,0-.6,0-1.2.2-1.8,1.3-.6,2.4-1.8,2.3-3.2-.8.4-1.7.6-1.5-.5-1.2,1.4-1.9,3.3-2,5.5-.7.9-1,.6-1-.5-.2.1-.4,0-.5-.5-.8.2-1.2-.3-1.4-1.4-1.1.3-1.4,0-1.1-1.1-.4-.2-.4-.3,0-.5l.5-.5c.2-.4.3-.4.5,0,.2-.5.5-.8,1-1,.8-1,1.2-1,1,0,.5.1.8,0,1-.5-.5-.1-.5-.3,0-.5,0-.3.3-.7,1-1Z"
          fill="#044ff4"
        />
        <path
          d="M149.8,271.3c-.3.5-.8,1-1,1.5s0,.7,0,1c-.1.3-.3.3-.5,0,0-.6-.7-.7-1-.5s.3,1.3-.7,1l-2.8-2c.9-.5,2.3,1.1,2.5,1,.4-.2,1.2-1.9.5-2.5,1.4.8,1.8,0,2.7-1,.6.1,0,1.2.2,1.5Z"
          fill="#0241ed"
        />
        <path d="M152.3,270.3c.2-.5,0-2.3.7-2.5s1.6,0,1.2,1l-1.5,1.5h-.5Z" fill="#0328da" />
        <path d="M147.3,268.8l3.5-.2c.2,1.3-.8.2-1.8.6s-.9,1-1.1,1.2l-.5-1.5Z" fill="#023dee" />
        <path
          d="M160.3,248.8c-.5,2.8,1.4,0,2.1,2.1s-.1,1.7-.1,2.5.5.8.5.8c0,.7-.5.9-.5,1l-3.5-2c0,1.6.6,1.4,1.5,2.5-2.2.6-1.9-.8-2-.9-1-.7-1.1,1.5-2.5,1.4-1.4.1-2.9-2.7-.5-2.5,1.9-.6,2.6-1.4,2-2.5-.9-2.3.3-3.5,3-2.5Z"
          fill="#0235e7"
        />
        <path d="M156.8,255.3c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#044ff4" />
        <path
          d="M162.3,241.3l1,2.5c-1,.3-1.2-.7-2-1,0,.5,0,1.1,0,1.5-.4,0-.9,0-1.5,0-.3.7-1.8.7-2,.5s.1-1.2,0-1.5c.7,0,1.3-.3,1.5-1,.6,0,.2-1.2.7.5,1.2-.6.2-1.9.3-2,.5-.4,1.7.5,2,.5Z"
          fill="#0250f0"
        />
        <path
          d="M155.3,247.8c0,0,.6.2.7.5.2.8-.2,1.6.8,2.5h-1.5c0-.4-.4-2.4-.5-2.5-.5-.6-.2-.8.5-.5Z"
          fill="#0235e7"
        />
        <path
          d="M154.3,245.8c1.7-.3,3.1,1.7,1,1.5-.4.4-.7.4-1,0,0-.3,0-1.4,0-1.5Z"
          fill="#0235e9"
        />
        <path d="M157.3,251.8c0,.2,0,.7,0,1-.8,0-2.2.1-2.5-.7s.5-.6.5-.7l2,.5Z" fill="#0235e7" />
        <path
          d="M155.3,247.3c0,.2,0,.4,0,.5l-.5.5c0,0-.7.1-.9,0s.4-.8.4-.9l.3-.5.7.5Z"
          fill="#0b66f5"
        />
        <path
          d="M156.8,243.8c-1.2.9-1.8,0-2,0s0,.8-.5,1c0-.2-1.1-.4-1-1,.4,0,1.3.1,1.5,0s-.3-1,.2-1l1.8,1Z"
          fill="#0333ec"
        />
        <path d="M161.3,244.3c0,.2,0,.3,0,.5l-1.5-.5c0-.2,0-.7,0-1l1.5,1Z" fill="#0568f6" />
        <path
          d="M167.8,200.3c.5-.4,1.1,0,2,1,.6,0,.9.5.5,1,.9-1.1,2.1-.9,2.5.5l-2,1.5c-1.3.1-2.3.6-3,1.5.4,1.4-2.2,1.7-2.5.2-.7.3-1.3,0-2-.7-.1-.5-.5-.8-.5-1-.4-.1-.4-.3,0-.5-.2-.7.6-1.2-1-1-1.2-.6-.7-1.4.5-1l2.5-.5c2.2-2.4,3.2-2.7,3-1Z"
          fill="#0375f6"
        />
        <path
          d="M176.8,196.8c1.1-.4,1.2.2.5,2,.7-.1.6.2-.1,1,.5,1.3.6,2.3-.9,2,0,0-.3,0-.5,0-1.8.1-2.6-.2-2.5-1-.9-1.4-1.1-5.3,1.7-3.4-.1-1,1.1-1.4,1.8-.6Z"
          fill="#0385f8"
        />
        <path
          d="M169.8,198.3c1.9-1.8,3.1-1,3.5,2.5,1.3.3.7,1.4,0,2-.1,0-.3,0-.5,0-1-.2-1.9,0-2.5-.5,0-.5-.2-.7-.5-1-.5.2-.9,1.5-1.2,1.5-1.1,0-.3-1.5-.3-1.8,0-.5-.4-.7-.4-.7-.8-.7-.5-1.1.5-.5,0-1.3.4-2.3,1.5-1.5Z"
          fill="#0385f8"
        />
        <path
          d="M175.8,201.8c-1,0-2,.3-2,1.5-.4.1-.4-.5-.5-.5-.5-.7,0-1.3,0-2,.9.3,2,0,2.5,1Z"
          fill="#0375f6"
        />
        <path
          d="M170.8,186.3c.4.1.4.3,0,.5l.5.5c.1-1.3.5-1.3,1,0,1.2-1.7,3.5.9,2.7,2.7,1.8.3,1,2.6-.6,2.1-2.2,2.4.2,1,1.8,0,.8,1.4,1.5.7,2.2-.2.8-.7,1.1-.5.5.5-1.7,1.3,1.1,3.6,0,1,.7-.1,1.3.4,2,.5,0,.3,0,.7,0,1l2-.3c-2.6,1-.3,1.9-2,3.7-.9-.2-.4-2.1-1.8-.5s.2.9.3,1c0,.4,0,1,0,1.5,0,0-.4,0-.5,0-.2-.1-1.1-1.8-1.5-.2s2.1,1,1.5,2.2c-1.6-1-.5.3-1.5.5.2-1.1-1-.9-1-1s.6-.9.5-1l-2-1c2.9.4,1.9-.1,2.5-1,.2-1,.3-3.1-.5-2l-1.5,1c1.5-.4,1.1,1.3.2,1.5-1.3.3-.8-2-2.2-1.5.6,1.2.1,1.9,0,3-.2,0-.8.2-1,0-.3-.4,0-1.8,0-2.5-2,1.4-.9-1.2-2.5,0-.3-.7.5-2.4,1.5-2,1.8,1.2,1.8,1,0-.5-.4.7-.9.9-1,0,.2-1.6-.2-2.3-1-2-.2-1.9.5-2.9,2-3,.7-1,.7-1.8,0-2.5,1.3,0,1.3.8,0,2.5-2.5.7-3.3-3.2,0-2.5-.7-.2-1.6-.1-1.5.7-.9,1.2-1.9-4.6,0-3.7.7-1,1.1.1,1,1Z"
          fill="#0375f6"
        />
        <path d="M178.3,208.3c0,.7,1.6,1-1,1s-.7,0-1,0v-.5c0,0,.3,0,.5,0l.5-.5h1Z" fill="#0244df" />
        <path d="M176.3,205.3c.3,0,.7-.8,1.5-.5,0,1-1.2.8-1.5,1v-.5Z" fill="#034ceb" />
        <path d="M168.3,227.8c-.2.2-.7.3-1,.5.2-.4,0-1.2.8-1.5.5,0,.2.7.2,1Z" fill="#0675f8" />
        <path
          d="M164.8,236.8c.1-.9-.4-1.6-1.6-2.1-2.1-3.2,4-3.9,4.6-1.4.2.2,0,1.7,2,1.2-1.1.6-.5,1.2-.5,1.3-.5,1.4-.3.6-1,1.5-.3.4-.2.6,0,1,0,.2,0,.3,0,.5l-.5.5c0,.2,0,.3,0,.5l-.5.5c.3.1.3.3,0,.5-.4.7-1.1.8-2.1.3-.8,1.2-2.1,1.8-2.9.2-.7,2.2-3.8,2.3-2.5,1.4s.2,0,.2,0c-.2-.2-.4-.3-.7-.4-1.2,1.2-2.8,0-1.9-1.5,1.5,0,4.3-2.4,1.9-1.5-.3-.1-.3-.3,0-.5-6-2.7,2-6.4,2.9-3-.5.8-.8,1.6.1,2,.9-.2,1.8-.6,2.5-1Z"
          fill="#0247eb"
        />
        <path d="M168.3,238.3c-.9-.7-.3-.7,0-1,0,.3,0,.7,0,1Z" fill="#0436dc" />
        <path d="M167.8,239.3c0-.2.3-.4.5-.5,0,.3,0,.6-.5.5Z" fill="#0436dc" />
        <path d="M167.8,240.3c-.1.3-.3.3-.5,0,0-.2.3-.4.5-.5,0,.2,0,.4,0,.5Z" fill="#0238e1" />
        <path d="M167.3,240.8c0-.1,0-.3,0-.5h.5c0,.2,0,.5-.5.5Z" fill="#0436dc" />
        <path
          d="M164.3,236.8c.2,0,.3,0,.5,0l.5,1.5c-1,0-1.9-.4-3-.5v-.5c.1-.6.5-.8,1-.5.2,0,.3,0,.5,0,.1-.3.3-.3.5,0Z"
          fill="#0137e4"
        />
        <path d="M167.3,237.8c.8.9-.7,2.2-1.5,1.5s1-2,1.5-1.5Z" fill="#0436dc" />
        <path d="M164.8,235.3c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#0247eb" />
        <path
          d="M168.3,227.8c0,.3,0,.7,0,1,.8-.9,1.4-.5,1.5-.5,0,.6-.3,1.3-1,2.2.2,1.2,0,2.1-.5,2.8h-.5c-1.8-1.6-2.4-.4-4.5,0,1,1.8,5.3,2.2,1.5,3.5-.1.4-.3.4-.5,0-.2-.2-.4-.2-.5,0-.1.4-.3.4-.5,0l-1,.5c.4.1.4.3,0,.5-.2,0-.8,1-1.3,0s.3-1.1.2-1.7c-.3-1.2-3.2-.7-3.5.7l3,.3-2.5.8,1,1c-.4.5-.4.7,0,.5.3-.2.4-1,.8-1,1.7,0,3.4,1.8,1.9,2s-.7-.8-1.7-1c0,2.1-1.2,2.2-3,2.5-.1.9,1.4.5,2,.5,1.4.9-.7,2.5-1.5,1-.4-.8-.6,0-1-2-.5,0-.9-.5-1-1-1.4.3-1.4.4,0,.5.5.7.2.9-.5.5,0,.3-.2.5-.5.5l.6.9c-1,.8-3.5,1.8-2.1-.4-.7,0-1.1-.3-1.1-.9-2.2,2-3.5-.5-1.4-1.6-.4-.5-.1-.7.5-.5.4-.6,2-1,2,0,.4-.8.5-2.2-.8-1.8-.4-.7.2-1.2,1.8-1.6-.4-.5-.3-1.1,0-1.5-1.1.5-1.7-.2-1.2-1.3s3.5-.3,3.7,1.3c0-2.4.3-3.2.9-2.3l.6-.7c-1,0-1-.7,0-1,.2-.5.9-.7,1,0,.5.1,1-.2,1.5-1,.8-.6,2.2-.7,1.5.5l-.3.6c1.6-.8,1.9-.9,3.3,0,.2-.3.3-.6.5-1,.5-.7,1-1,1.5-1,.3-.7.7-.9,1-.5Z"
          fill="#0359f4"
        />
        <path
          d="M170.3,228.3c1.2,1.1-1.9,1.8-.5,3.5.4,0,.6.2.5.5v.5c-.4,0-1,1.4-2,.5-.9-1.9-.1-3.8,1.5-5,.2,0,.5,0,.5,0Z"
          fill="#0247eb"
        />
        <path
          d="M155.8,240.3c.3,0,.9,0,1,0s0,.7,0,1l-1,1c-.1,0-.4,0-.5,0-.3-.3-.3-.6,0-1,.1-.2.4-.3.5-.5-.4-.1-.4-.3,0-.5Z"
          fill="#0230e3"
        />
        <path d="M159.3,238.8v.5c-1.1.9-2.6-.3-2-1,.8.3,1.1,1.3,2,.5Z" fill="#0245ee" />
        <path
          d="M150.8,239.8c0,.5-.6,1.4-.5,1.5,1.5.5.5-1.1,1.7-1,1.8.3,1.1,1.3,1.3,2l-2,.5c-.5,1.6,1.3.3,1,2-1.7-.3-2.5-.3-1.5-2h-2s1-3.5,1-3.5c.1-.4.3-.4.5,0,0,0,.5.5.5.5Z"
          fill="#0246f3"
        />
        <path
          d="M155.3,228.8c-.1-.5,0-1.1.2-1.2,3.4-.4,3.1.9,1.3,3.2.5-.2,1,0,1.5.5.1.4.8.7.5,1.5-1.6-1-2.5.1-.5.7-.4.5-.8.9-1.5.8-.4-4.4-1.1-1.4-1.2-1.5-.3,0-.5-.7-1.3-.5.5-.7.7-1.2,1-2-.5-.4-.5-1.1,0-1.5Z"
          fill="#0462f5"
        />
        <path
          d="M154.8,237.8c.5-1.7.3-3.6,2-1.7-1.8.5-.5.9-.6,2-.1,2.2-2.1,2.6-1.9.7l.5-1Z"
          fill="#023ae8"
        />
        <path
          d="M165.8,229.3c-.3.8,2.2,1.9,1.5,2.5s-1.7-.8-2-1.5-.7-.9-.5-1c.3,0,.7,0,1,0Z"
          fill="#0242e9"
        />
        <path
          d="M160.8,229.3c-.9.9.1,2.9,0,3-1,.9-1.1-1.3-1.5-2,.3,0,.8-.8,1.5-1Z"
          fill="#0462f5"
        />
        <path
          d="M158.3,230.3c0,.3,0,.7,0,1-1,.8-1,.4-1.5-.5-.3-.7-.2-.9.5-.5h.5c.2,0,.3,0,.5,0Z"
          fill="#0249e9"
        />
        <path d="M155.8,240.3v.5l-2,.5c-.4-1.4.9-1.1,2-1Z" fill="#047df7" />
        <path d="M163.3,236.8c-.2,0-.6.6-1,.5,0-.8-.2-1.2.7-1l.3.5Z" fill="#0247eb" />
        <path d="M154.3,238.8c0-.9.5-.9.5-1l-.5,1Z" fill="#0251f5" />
        <path d="M155.3,242.3c-.2-.1-.3-.3-.5-.5.1-.2.4-.3.5-.5v1Z" fill="#0247ed" />
        <path d="M164.3,236.8c-.1,0-.3,0-.5,0l.2-.5.2.5Z" fill="#0247eb" />
        <path
          d="M165.3,225.8c.9.5,1.8,0,1.5,2l-1-.5c-.7.6-.9.4-.5-.5,0-.3,0-.7,0-1Z"
          fill="#0675f8"
        />
        <path
          d="M165.8,227.3c0,0,.4,1.3.3,1.5l-1.8-.5c-.2-.2.9-1.1,1-1.5.2.2.3.2.5.5Z"
          fill="#0359f4"
        />
        <path
          d="M224.7,333.7c.4.1.4.3,0,.5-.3.7-.4,1.3-.5,2,1.7,1.1,0,2-1.5,2.5-.3,1.3-1.4,3.4-2.5,2,.4-1.2.2-1.2-.5,0,.4.1.4.3,0,.5-2.3,1.1-1.4-1.6,0-2.5-.1-4.1.4-5.4,1.5-4,2.1-2,.8-3.1,1.1-3.4.4-.5,1.7-1.7,1.9-2.6,1.3,2.2-.3,3.4.5,5Z"
          fill="#0121a5"
        />
        <path
          d="M225.2,334.2v.5c.5,1.8-.9,1.4-1,1.5-1.8-.8-1.2-1.6.5-2s.3,0,.5,0Z"
          fill="#022ab9"
        />
        <path d="M221.2,337.2l-.5-2c1.2.6,2.1,1.5.5,2Z" fill="#011481" />
        <path d="M220.2,340.7h-.5c.1-.4.4-.7.8-1l-.3,1Z" fill="#01197b" />
        <path d="M115.3,254.8c.5.3,2.6,3.2,1.2,3.5-2.6.6-1.3-2.4-1.2-3.5Z" fill="#021adc" />
        <path d="M119.8,256.3v.5l-1.8,2c-.9-2,0-2.2,1.8-2.5Z" fill="#021ede" />
        <path
          d="M123.3,243.8c-.4-1.1,1.4-2.7,2.6-1.9,1.2-3.1,7.7.5,3.9,1.4l.5.5c.1-.4.3-.4.5,0,.4,0,.8-.2,1-.5-.7-.7-.4-1,.5-.5,1.4,0,1.8,1.2,0,1.5,1,.1.9.5,0,1-.2.3-.3.3-.5,0,0,1.8-.7,2.6-2.5,2,.4.8-.1,1-.8.5l-.2.5c0,.1,0,.3,0,.5-1.7.4-.5-2.1-2.5-2-.4-.1-.4-.3,0-.5.3-.2,1.4-1.1,1.5-1.5-1.6.7-1.1,0-2.5-.5s-.9-.3-1.5-.5Z"
          fill="#022feb"
        />
        <path
          d="M128.3,252.3c-.2.3-.2.7-.5,1-.5-.5-2.5-1.2-2.5-1.7s.5-1,1-.4c.8.9.5,1,2,1.2Z"
          fill="#022fed"
        />
        <path d="M125.8,246.3v.5c0,0-.7.8-1,.5s0-.7,0-1c.3,0,.8,0,1,0Z" fill="#2854e8" />
        <path
          d="M114.3,239.8c.7,1.3-.2,2.5-2,1.5-1.1-.6-.3-2,1-1.5.1-.7.9-.9,1,0Z"
          fill="#0231e9"
        />
        <path
          d="M112.3,241.3c1.5-.2,2.3.3,2.5,1.5.8.4,1.6.9,2.5,1.5.9.6-.9.8-.8.7.9-.9,2-.5,2.8.3l-1.8-.5c.4-.7.3-1.5-.2-2.5.4-1.6,1.3-1.7,2.8-.4h.7c.2-.6.3-.6.5-.1,1,.2.8,1-.4,2.4.4,1.5-1,2.6-1.6,1.1l1.4.3c.4-1.2,1.6.2,1.1,1.2.6-.4,1.1-.9,1.5-1.5.8-1,1.7-.1,1,1,1,2.3.7,2.5-1.8,3.2l.3.3q.7,1,0,0c.4-2,3.7-1.8,3.3,1-2.5,1,.4,2.4,1.7,3,.2-.4.3-.4.5,0-.2.8-.6,2.6-1,2.9l-1.4-.2c-.2,2.1-1.8,2.7-1.7.8,0-.6-.7-.6-2,0-1.5-.1-1.6-.5-.5-1.5-.9.1-1.3-.3-1.4-1.2-1.4-.1-2.2-1-2.1-2.3q1-.6,0,0v.6c1,.4.4,2.6-1,.9,0,1-.6.8-1,0,0,1.1-.7,1.1-1,0-.7.2-.9-.7-.5-.9.7-.2-1,1.2-1.5,1.4,0,.8-1,.5-3-1,.2,3.2-3.7.7-1.5-1.5.7-.1,1.4.3,2,.5-.4-3.1-2.8-.3-4.5-.5l2-2c2.2,0,1-4.5.3-4.1-.3.9-.5.6-.8-.9.6-.5.4-1.4,2-.5-.9-2.3-.3-1.1.5-1.5.4-.8.8-.6,1,.5.7.3.9.4,1.7.7,1.3.5-1,.5-1.7-.7-.5-.5-.7-2,0-2,0-1.3.5-1.2,1,0Z"
          fill="#0231e9"
        />
        <path
          d="M107.8,244.8l2.4,1.6c.5,1.8.4,3.7-1.9,3.4,1.7-1.5,0-1.7,0-2.7s2,.2.3-1.2c-1.3,1-1.3,2.6-.8,4-1.2.2-3.4-.6-2.5-2s2.3,0,2-1.5c-.2-.3,0-.7.5-1,0,0,0-.4,0-.5Z"
          fill="#022ae5"
        />
        <path
          d="M124.8,246.3c.2.4.5.6,1,.5.7-1,3,.7,1.8,1.4l.7.6c1.3,0,1.5,1,.5,3,.1.4,0,.6-.5.5l-.5,1c.4.1.4.3,0,.5-.4-.1-1,.1-1.6-.1-2.5-.9-.7-3.6-.9-3.9s-2.8-1-2.5,0c1.9-.3.9,2.4,0,1.5s.1-1.3,0-1.5-1,.3-1-.2c2.6-.9,1.7-1.4,2.5-3.3-1.1-1.7,1.8-1.6.5,0Z"
          fill="#033bef"
        />
        <path
          d="M128.3,256.8c-.3.7-.7.8-1,.5-.6,1.1-1,.6-1-.5-.2.2-.2.4,0,.5.3.2.3.6.1,1.4,1.4.6,0,1.1-1.1.6-1.4.8-2.9,1.3-4.5,1.5-.2.3-.4.2-.5-.5.1-1.7-.5-1.4-.5-2.2s2.2,0,0-1.3c-.4-.1-.4-.3,0-.5.2,0,1.2.7,2-.5.1.5.2,1,.5,1.5.7-1,1.4-1,2,0,0,0,.2.5.2.5.8,0,.7-1.3.3-2l2.5.5-1.5-1.5,2.5-1c.2-.4.3-.4.5,0,.6,1.1,1.5,3-.5,3Z"
          fill="#0338ed"
        />
        <path
          d="M111.3,243.3c.1.1,2.1-.5,3,.5-1.8,2.4-.3,2.1,0,2.5.9,1.4-2.3,1.3-3,1.5.3-1.3.9-1.3-.5-1.7.6-.8,1.7-.4,1.5-1.5s-.7-.1-.9-.4c-.3-.4,0-.8-.1-.9Z"
          fill="#0126e4"
        />
        <path
          d="M121.3,241.8c1.5-2.1,4.4.9,1,1.5.8,1.4,1.2,2.8-.5,3.5-.6-.1-.2-1.2-1-1l-1.5,2c-1.1-1.9,1-1.1,0-2.5,2.4.2,1-.3,1.2-1.1s1-1.4.8-2.4Z"
          fill="#0336ed"
        />
        <path
          d="M122.3,257.3c1.2-1.9-1.6-4.6,1-5.5,1.7,1.8,0,3.9,0,4.2.1.6,2.4.7,1,1.3-1.4.2-1.6.5-2.7,1-.9,0,.7-.9.7-1Z"
          fill="#0227e5"
        />
        <path
          d="M113.3,254.3c-.9-.9.9-.9,1-1.3.3-1.3-1.4-.1-1-1.7,2,.1,2,.7,2,2.5s0,.7,0,1c-.6-.4-1.9-.4-2-.5.2.3-.3,2.2.5,2.8l-1-.3c-.1-1.2-1.6-2.7-2.5-3.5,1.1-.4,1.6-.8,2.5-1.5-1.1,3.2.4,2.3.5,2.5Z"
          fill="#0221df"
        />
        <path
          d="M123.3,243.8c1.2-.5,1.7-.4,1.5.5,0,1.1-.5,1.3-1.5,1-.3.4,0,1.9-1.5,1.5l1-1.5h-1.5c-.4-1.4.7-1.6,1-2,1-.9,1.2-.8,1,.5Z"
          fill="#0224e2"
        />
        <path
          d="M117.3,242.3c1.6.5.3,2.7,2,2.5v.5s-3,0-3,0v-.5c.4,0,.7-.3,1-.5-.4-.2-.6-.5-.5-1-.6-.5-.9-.8,0-1,.2-.2.3-.2.5,0Z"
          fill="#0943ee"
        />
        <path
          d="M115.3,242.3c1.2-.9,1.5-.3,1.5,1,1,.6,1.1.5.5,1-2,.3-2.4-1.4-2.5-1.5l.5-.5Z"
          fill="#0220e4"
        />
        <polygon
          fill="#0946eb"
          points="118.8 247.3 118.8 247.8 115.8 248.3 115.8 247.3 118.8 247.3"
        />
        <path d="M113.8,249.8c.7.8-1.5,2.1-2,.7s1.9-.8,2-.7Z" fill="#0223e0" />
        <path d="M113.8,248.3c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#0223e0" />
        <path d="M116.3,250.3v.5c-2.1.2-2.1-.7,0-.5Z" fill="#0223e0" />
        <path d="M114.5,249.3c.3.2.3.3,0,.5v-.5Z" fill="#0223e0" />
        <path d="M126.3,257.3l-.5-.2.5-.2c0,0,0,.4,0,.5Z" fill="#0231e9" />
        <path
          d="M116.8,242.3c0,.2,0,.7,0,1-.7-.4-.5,0-1.5-1s-1.3-.7-1-1,.7.2,1-.5c.2-.7.7-1.1,1.5-1,.1.3.9.7.9,1.2s-.7.9-.9,1.3Z"
          fill="#0231e9"
        />
        <path
          d="M115.3,239.8c-.1-.3-.7-.5-1-.5-.3-.7,2.4-1.1,2.5-1,.2.3-.1,1.2,0,1.5l-.5,1.5-1-.5c0-.1,0-.9,0-1Z"
          fill="#0743f1"
        />
        <path
          d="M119.3,236.3c0,.5-.4.8-.5,1l-.2-.5c-.2.4-.7.4-.8.5,0,0,0-.8,0-1,.5,0,1,0,1.5,0Z"
          fill="#022fec"
        />
        <path
          d="M121.8,235.3c1-.7,1.6-2.2,3-2.5.1.1-.8,2.5.5,2.5-.5-.9.4-4.6,1.5-3.5s-.6,1.2-.4,1.4,1.3-.5.4,1.6h1.5c.1,0-.5,1.1-.5,1.5-.3.5-1.6,1.3-2,1-1.1-1,2.1-.9.7-2-1.8.8-.7,2.1-3.2,1l1.5,1-3,2.2,1.5.7-3.5.5c-.7-.4-1.8.8,0-1.5-1.5.2-3.1.2-3-1.7s1-.3,1-.3c-.2.4.7.8,1,1s.8-.1,1,0c.7-.3,1.2-.1,1.5.5.3,0,.7,0,1,0,.1-.2-1-1.9-1-2.3,0-.5,2.9-1.1.5-1.2Z"
          fill="#022fec"
        />
        <path
          d="M111.3,258.8c.9.7,1.3,0,2.5,0-1.1,2,.9,1.5,1.3,3s0,1.9-.3,3l-2-1c.8-.2,2.3-.2,2-1.5-5.7,1.3-2.2-1.7-2.5-2-1-1-1,1.1-1.2,1-.6-.5-.7-1.3-.8-2s0-.7,0-1h.5c.7-.6,1-.3.5.5Z"
          fill="#021bd7"
        />
        <path d="M113.3,261.8c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#032be2" />
        <path
          d="M106.3,232.8l-.5.5c-.2.1-.9.5-1,.5,0-.8,0-1.8.5-2.5.4.3,1,1,1,1.5Z"
          fill="#0230ea"
        />
        <path
          d="M108.8,210.8c-.3.4-.3.7,0,1l1-.5c-.3-.2-.1-.4.5-.5.8.5,1.6.6,2.5.5.6.1,1.1.5,1.5,1,3.2-.2,2.8,2.4,0,2.7l.8,1.2c2.7,2.3,2.9,4.8,1.6,7.6-1.7,0-3,0-.4.5,0,1.9,1.9,3.2,2.3,1h.8c0-.1-.4-.7-.4-.7,3.2-2.1,4.5-.8,3.9,4,1.3,0,1.8.4,1.5,1,.8-.6,1-.3.5.5.2-.2.3-.2.5,0,.3.3.4.7,0,1-.2,1.4-.6,1.3-1,0-1,.2-1.5,0-1.5-.5-1-.6-2-.6-3,0q-1.3.5,0,0c1.5-.3,1.7.4.5,2-.1.7-.4,1.2-1,1.5.2.4.2.7,0,1,0,.9-2.2-.2-2.3-.3.4-2-1.9-3.7-3.6-2.7-.5.5-1.9,0-1.5,1.5l2-.5c-.7,1,0,1.8,0,2.5-1-.2-3-1.7-4.7-1l.3-1c-3.5.1-2,1.4-2.5,2.5s-1.9-.2-2-.2c-1-.4,0-.7,0-.8,1.2-1.2,1.7-2.4,1.7-3.5l.8-.5c.4-.4,0-.9-1-1.5,1.3.5,1.6,1,1,1.5-.6,1.2-1.3.4-2-.5-.6.8-1.1.5-1.5-1-.7-.1-.5-.5,0-1-.2-1.8,1.7-1.5,1.6.4,0-.7.2-.5.9.6l-.7-.2c-.8-1.6-1.4-2.8-1.8-.8-.1.5-.3.4-.5,0-.2,0-.3,0-.5,0s-.3-.5-.5-.5c-.4-.1-.4-.3,0-.5-.2-.6-.5-.9-1-1-.1.4-.3.4-.5,0l-.5-.2c.9-1.5,2.5-1.4,3.9-1.8s0-.4,0-.4c-1.6,1.3,0-1.9-1.5-1.8.5-1.1,1-1.4.5-2.7-1.4.6-1.3,2.3-1,3.5l-2-.5,1-1.7-1.3-.2.7-1c.1-.4.3-.4.5,0,.3,0,.7,0,1,0,.7-1.5-1.5-2-1.5-2.5l.5-.5c.1-.3.9-.5,0-1.5,0-.8,1.1-.9,3-.2.1,1.4.9,5.2,2,4.7,1-1.9,2.4.4,1.9,1.8s-3,2.3-3.9,2.7c3.5-1.8,4.5-3.7,2.8-5.6.6-.9,1.4,1.2-.8,1.1-.7.8-1.2.2-1.3-1.7-1.4-.6-1.3-3,.5-3.6s2,.2,1.9.3c-.7.2-5.2.4-5.5.2-.9-.5-.5-1.4.5-1.7,1.5-.4,2-.9,1.5-1.5-.8-.6-.5-1.2.5-1,.7-.5.9-.2.5.5l1-.5c.3-1.7,2.9-1.2,3,0Z"
          fill="#0230ea"
        />
        <path
          d="M106.3,219.8c.3-.7.6-1.5,1.3-2,.4,1,.6,1.1,1.7,1-1.2,1.3-.8,1.9-.5,3.5l-1-.5v2c-2-1.4-1.4.7-2.2.9s-1-.5-1.3-.4c0,0,.2-1.5,1.5-1.7-.8-1-2.2.2-.7-1.3.4,0,2.2,1.8,2.7-.3s-1-1-1.5-1.2Z"
          fill="#022ae5"
        />
        <path
          d="M99.8,210.8c1.6-.5.6,2,.6,1.8-.3-.6.3-2,.9-.8.5.3.8.8,1,1.5-1.8-1.5,2.3-2.3,1.1-1s-.9-.4.4-.5l.5.3c.2,1-1.6,1.6-2,1.2.4.6-1,2.3,1.6.9s.4-.9.6-.9c1.2.1,2.6,1.8,4.3.5,1,2.7-3.4.2-4,2.8s1.3,1,1.5,1.3c.3.5-1,1.4,0,1.9,0,.2.1.8,0,1s-1.9,0-2,0,.8-1.4.5-2c-.7-.1-1.5,1.3-1.5-.2s1.2.2,1-.7l-2-.8,1.5-1c-.6-1.1-1.8-.5-2.5-.8-1.1-.3-2.8-2.5-2,1h-2.5c-.1,0-.3,0-.5,0-.6-.5-.7-1.7,0-2,2.7,1.1,3.5-1.6,2.7-1.5-2.4,1.1-3.2.3-1.1-1.3s.6.3.8.2c.2-.1,0-.8,0-.9.1-1.3.4-1.3,1,0Z"
          fill="#022ae5"
        />
        <path
          d="M106.3,229.8c3,.7,1.3,0,2.8-.9,2.7-1.8,3.3,2.6.9,3.9-.5-1.7-.8-.7-2.2-.5,1-1.7-.3-.7-.5-1,.4.5-1.3,4.4-2.5,4,0-.5,0-1,0-1.5.3-1,.6-1.2,1-.5l.5-.5c-.9.4-1-.7-1-1.5-.4-.1-.4-.3,0-.5.5.3,1.4.3,2,.5-.3-.3-.8-1.1-1-1.5Z"
          fill="#0226e3"
        />
        <path d="M103.8,229.8c-.2,0-.7,0-1,0l.5-1c.2,0,.3,0,.5,0,0,.3,0,.7,0,1Z" fill="#0224e0" />
        <path
          d="M103.8,228.8c0-.2-.6-.8-.5-1.2.4-1.2,2.5,0,.5-2.3l3.8-.5c1.1-.1.7.1.3.8l1.5-.8c0,2.9-3.8,1.4-4,1.5s.7,3,1,3.5c-1.2-.3-1.8.7-1.5-1.5-.1-.2-.7.5-1,.5Z"
          fill="#0224e0"
        />
        <path d="M119.8,230.8c-.2.7.2,1.5-1.7.7l-2.8-1.7c1.1-.4,3.9.2,4.5,1Z" fill="#053bf0" />
        <path
          d="M112.3,209.8c.3,0,.7,0,1,0-.2.5-.4.9-.5,1.5-.6.5-.3,1.3-1.2,1-.5-.2-.7-1.4-1.3-1.5-1-.9-.3-1.3,2-1Z"
          fill="#0226e3"
        />
        <path d="M122.8,228.8c.3.3,2.3-.7,3-.5l-1.5,1.5c-.6-.4-.6-.1-1.5-1Z" fill="#0448f1" />
        <path
          d="M108.8,210.8c.3,0,.7,0,1,0,0-.4.3-.4.5,0,0,0-.1.3-.5.5-.2.9-.4,1.3-1,.5,0,0-.9.6-1,.5,0-1.2-.3-1.7,1-1.5Z"
          fill="#0345ef"
        />
        <path d="M118.8,227.3c-.5,1.9-5,.7-4-.5s1,1,1.8,1,1.4-.6,2.2-.5Z" fill="#043ff1" />
        <path d="M109.8,211.3v2.5s-.5,0-.5,0c0-.4-.4-2-.5-2,.3-.2.7-.3,1-.5Z" fill="#0226e3" />
        <path d="M114.8,229.3c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#043ff1" />
        <path d="M118.8,228.8c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#0341f2" />
        <path d="M125.3,231.3v-1c.8.5.9.6,0,1Z" fill="#0235ed" />
        <path d="M106.8,212.3c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#022ae5" />
        <path d="M105.8,233.3l.5-.5c0,.5-.3.4-.5.5Z" fill="#0229e6" />
        <path
          d="M133.3,259.8c.4.1.4.3,0,.5q-.6,1.4,0,0c.4-.9,1.3-.5,1,.5.5-.5,1-.7,1.5-.5v.7c1.3.4,1.3.9,0,1.3,0,2.4-.9,5.3-2,1.5l-1,.5c-1.6.4-.4-1.4-1.5-1.5-.2,2.4.3,2.9-2.5,3,.2-.8,1-2.3,1-2.7s-1.7-.4-1-1.8c.6-.4,2.9,0,3,0s-.7-2.6,1.5-1.5Z"
          fill="#033eef"
        />
        <path d="M122.3,266.3h-1.5c-.2-.8.6-.3.8-.6s.1-.8.1-.9c.2-.2,0-.4.5-.5v2Z" fill="#022de9" />
        <path
          d="M135.3,272.8c1.1-4.2,5.4-.6.5,1,.5.1.7.3.5.5.5.7-.2.9-2,.5-.3,0-.7,0-1,0v-.5c.6-.7,0-1.4,0-2,.1-.4.3-.4.5,0,.5-.6,1-.4,1.5.5Z"
          fill="#033ef1"
        />
        <path
          d="M134.3,274.8c.3-2.7,1.1,0,1.3,0,.5,0,.6-.5.7-.5.5-.5,2-1.2,2.5-.5,1.1.2,1.1.6,0,1-.2,0-2.7.4-3,.5-.5,0-1.2-.5-1.5-.5Z"
          fill="#022de9"
        />
        <path
          d="M119.8,203.3c.4,1.5-.8.8-1,1s1.4,2.2,1.8,2.4c1.7.9.7-.9,1.2-1.2s1-.2,1-.2c.4.1.4.3,0,.5-.6.2-.6.4-.5,1,1.2-.7,2.5-.8,2.5,1l-.4.4c-1.6-.6-2.8.1-3.6,2.1-1,.6-1.1.9-1-.5-1-.2,0,1.1-1,1l-.3-1.5c-.3,0-.2.5-.2.5-.2.4-.3.4-.5,0l-.5.5c0,.8-.7.7-1,0-.4-.1-.4-.3,0-.5,1.8-.4,3.5-3.4,1.2-2.6s-.8.4-1.2.6c-.9-.2-.9-.7,0-1-.6-.4-.3-1.9.5-2,.2-1.1.6-1.3,1-.5.4-1.3.6-1.3,1,0-.7-1.3-.3-1.8,1-1Z"
          fill="#0235ec"
        />
        <path
          d="M124.8,207.8c0,.2-.5.7-.5,1-.2.5-.5.8-1,1,0,.2-.3.4-.5.5.2-2.1-1.1-.5-2,0,0-3.5,1-3.5,4-2.5Z"
          fill="#0347f1"
        />
        <path
          d="M127.8,221.3c-.3-.3-.9-.4-1-1,.5,0,1,0,1.5,0v-2.5h.5c.5,1,0,2.1,1,2.7l-2,.7Z"
          fill="#034ef2"
        />
        <path
          d="M118.3,209.8v.6c-.2.3-1,.6-1,.9h-.5c-.4-.2-.8-.2-1,0-1.8-.8-.1-.8.5-1s.7,0,1,0l.5-.5c.1,0,.4,0,.5,0Z"
          fill="#0653f1"
        />
        <path
          d="M118.3,209.8c-1.4-1.6,2.9-.7,2,.2s-.9-.8.5.3c.6-2.5,2.9-2.7,2,0,.4.1.4.3,0,.5.6,1.2-1.1,1.3-2,1-2.4.8-2.2,3.6-.5,1.5-.5.1-.6,0-.5-.5,0-.6.5-.8,1-.5,2.2-1.6,5.2-.3,3.2,2.7l.8.8c-1.8.2-.7-2,.5-2.5.1-.4.3-.4.5,0,.6.9,1.4,1.4,2.5,1.5.8,0,1.1-.4.8-1.4,3.2-1.6,4,2.3.9,3.4s-4.8-.2-5.3-1c1,.7,2.3,1,3.7.9l.3.6c.4.1.4.3,0,.5-.1.4-.3.4-.5,0,0,1.5-1.9,2-2.5.5-.5,1-1,1-1.5,0,0,1.1-1.5.1-1.5,0s1.7.7,1,1.5c.6.6.3,1.3-.5,1-.6.9-1.4.8-2.3-.3h-.8c1.6,1.1,1.1,2.4-1.4,3.8-.4.2-.9.4-1.5.5-.4-.2.3,1.2.5.5-.4-1.2,1.8-1,1.5,0-.8,2.8-3.1,1.9-3.7-.5-.9.5-1.4,1.5-2.2.2.9-3.3,2.4-1.7,3.5-2.3s0-1.4,0-1.5c-.7-.4-2.8,0-3.5-1.8,1.1-.8,2.6,2.7,3.5.5s-.6-.1-1-.7,0-.8-.1-1-1.3-.9-2.4-2.7-2-.5-.7-1.4,2.5.3,3.2-1.2c0,0-1.4-.7-1.5-.7-.3-1.2.6-1.3,2.8-.3l.2-.7c-.3-.3,0-.8,1-1.5Z"
          fill="#033bef"
        />
        <path
          d="M123.8,210.8c1-1.6,3.3-2.1,4.8.1s1.7,4.1-.3,3.9c-1.4,0-2.1-.6-2-1.5.3-.2.3-.4,0-.5-.3.2-.7.3-1,0-.6.3-2.7-1.2-1.5-2Z"
          fill="#033bef"
        />
        <path
          d="M118.8,224.3l2-1.7c-.5-.4-1-1.4-1.7-1.2s-.9,1.9-1.8,2c-.5-2.8,1.1-1.9,1.4-2.2.5-.4.4-1.5,1.9-1.6s1.5,1.3,2.8,1.3c-.9,3.1-.6,1.1-2,1.8s-1.4,1.4-2.5,1.7Z"
          fill="#022eea"
        />
        <path
          d="M123.8,210.8c.2.7,1.4,1.6,1.5,2,.5.1.4.3,0,.5,0,0-.2,1.3-.2,1.4-.2.6-1-.7-.3,1.1-.8,0-2.1,1.2-1.8-.8s1.9-1.9.8-2.5-2.8-.3-3-.2c-.4-.1-.4-.3,0-.5.6-.2,1.7-.9,2-1s.7,0,1,0Z"
          fill="#0347f1"
        />
        <path
          d="M116.3,209.8v.5c-.4.3-.6.7-.5,1,.3-.2.6-.2,1,0,.1-.4.3-.4.5,0,0,0,.5.5.5.7-.3,1.4-2.1-.8-3.5.3-.4-1.6-.5-2.5,1.3-2.8s.6.3.7.3Z"
          fill="#022aea"
        />
        <path
          d="M120.8,211.8v.5c-.7,0-.6.1-1,.5,0,.4.1.5.5.5.6.4,1.2.5,1,1.5-1.4-.9-4,.8-3.9-1.3s2.9-1.5,3.5-1.7Z"
          fill="#022aea"
        />
        <path
          d="M128.3,217.8c.8,1.5.8,4-1.5,2.5-.2,0-.9-1.4-1.1.4-.3.3-.3-.4-.4-.4v-.5c-.7-.5-.5-1.4.5-1.5.9,0,1.7-.3,2.5-.5Z"
          fill="#0241f3"
        />
        <path d="M117.3,215.3c-.3,1.2-1.1,2.1-2.5,2l-.3-2c1.2,1.7,1.3,0,2.8,0Z" fill="#022ae8" />
        <path d="M122.3,216.3c-.4,1-1.4,1.7-2.5,1.5.5-1.6.8-1.7,2.5-1.5Z" fill="#044ef0" />
        <path
          d="M124.3,218.3c.4.1.4.3,0,.5.2.4.2.8,0,1-.2,0-.4,0-.5,0-.3-.1-.8-1.1-1.5-1.2.6-1.1,1.4-.2,2-.3Z"
          fill="#0550f3"
        />
        <path d="M125.8,218.3l-.5,1.5h-.5c-.3-.2-.5-.5-.5-1v-.5c.7,0,1.1,0,1.5,0Z" fill="#0127e0" />
        <path d="M118.3,217.8c-.3.4-2,.6-2-.5.8-.1,3.2-.9,2,.5Z" fill="#032de8" />
        <path d="M118.8,219.3l-1.5-.2c.7-.9,1.1-.8,1.5.2Z" fill="#032de8" />
        <path d="M120.3,213.3c-1.1.8-1.5.4-.5-.5.2.1.3.4.5.5Z" fill="#054ff3" />
        <path d="M117.3,224.8l.5.5.5.2c-1.7,2.4-1.5-2.7-1-1.7v1Z" fill="#0230ea" />
        <path d="M124.8,219.8c-.2,0-.3,0-.5,0v-1l.5,1Z" fill="#033bef" />
        <path
          d="M137.8,227.3c1.3.2,2.3.7,2.5,2-.7,1-1.6,2-2.5,3,.3,1.1.3,1.9-1,2,0,.3,0,.7,0,1-.7,1.1-.7-.3-.6-.2,1.1,1-.2,4-1.9,2.7-.9,1-1.2.8-1-.5-1,0-1-.8,0-1q.9-.6,0,0c-.5.5-1.3.4-2.5-.5-.4,1.3-.8.9-1.5,0,0-.3,0-.7,0-1l.5-.5c-.7-.1-.7-.8,0-1,0-.1-.9-1.9-1-2,.4.2.8-.2,1.5,1,1,.7,1.8,0,2.5-2,.4-.1,1.4.1,2.1-.1s1.7-1.3,2.4-1.4c.9,0,.9,0,0-.5-.4-.1-.5-.2-1,0v-1c.5,0,1,0,1.5,0Z"
          fill="#0240f1"
        />
        <path
          d="M130.8,235.8c1.1.2,2.2.9,2.5,2,1,1.8-1,2-2.5,1.4l-1,.6c-.5,0-1.4.6-1.5.5,1.4-2.9-1.2-.6-1.5-1s0-1.5,0-1.5c.8-.4,2.6.8,2.5-2,.6-.6,1.1,0,1.5,0Z"
          fill="#0336ee"
        />
        <path d="M128.8,231.3c-.1,0-2.7,1-2.5-1.5,1,.3,1.7.9,2.5,1.5Z" fill="#0235ed" />
        <path d="M129.8,233.3c0,.2,0,.8,0,1l-.5.5c0-.5-1.5-1.7.5-1.5Z" fill="#021de0" />
        <path
          d="M115.8,200.8c1.2.7.7,7.1-1.5,5.5-.5.7-1.2.3-1-.5-.4-.2-1.2-2.1-2.5-.5-.1-.2-1.7-2.3-1.5-2.5,1.4.2,2,.9,3.5,1,.4-1.1,1.1-2,2-2.5.3-.2.6-.3,1-.5Z"
          fill="#022ce7"
        />
        <path
          d="M110.8,205.8c.4.7.5,1.5.8,2,.4.7,2.7.6.2,2-1.4-.3-1.2-1.5-3-1l2-.5c.1,0-2.3-4.1,0-2.5Z"
          fill="#0226e3"
        />
        <path
          d="M113.3,205.8c.3.2.7.3,1,.5l1,.5c.9.4.3,1.2-.5,1-.8-.3-3.7-1.6-3-2.5l1.5.5Z"
          fill="#0350f5"
        />
        <path
          d="M116.3,206.8c0,.3,0,.7,0,1-.3.1-.5.4-.9.4-.5,0-.5-.4-.6-.4l.5-1c.4-1.3.5-1.3,1,0Z"
          fill="#022ce7"
        />
        <path d="M121.3,238.8c-1.8.5-1-.3-1.5-.5l.7-1.5.8,2Z" fill="#0644f1" />
        <path
          d="M101.8,201.8c.7,0,1.3.5,2,.5.2-.8-.6-.2-1-.9s.8-1.5-1.5-.6l1.8-3.5.2,1.5,1.5-.5-1,1.5c3,.5,1.3-2.3,1.5-2.5s1.8.5,2.5.5c-.2-2.8,3.4-.4,1,.5.2,1.5-.3,2.3-1.5,2.5l.3.7c-.9,1-1,1.7-.3,2.1-.6.8-.9,1.7-1,2.7-.6.2-1.4,0-1.5,1.3s1.8.3,1,1.2c-1.6,1.8-5-2-7-1l1-1c1.3.4,6.9.8,3.5-.8s-2-.1-2-.2c-1.5-2.9,2.3-.3,2.5-.5s0-1.6-.2-2-2.3-.4-2.8-.5c-2-.3-.3-1.5,1-1Z"
          fill="#022fe6"
        />
        <path
          d="M107.3,200.8h.5l.2,2-1.2.2c1.7.7,3.9,2.3,1,2.8l-.2-1.5c-1.1.5,0,1.8-.3,2s-.7,0-1,0c-.4-1.2-1-1.2-1.5-2.5l2-.2c-.4-.7-3-2-3-2.5,0-1.7,2.7.1,2.9.2.4.1.6-.4.6-.4Z"
          fill="#0123e2"
        />
        <path
          d="M108.8,198.3c.2.5.8,1.5.5,2s-1.2.4-1.5.5-.3,0-.5,0l1-.7c-.6-1-3.4-.8.5-1.8Z"
          fill="#0222e0"
        />
        <path d="M104.3,207.8c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#0226e3" />
        <path
          d="M122.3,200.3c.2-.4.3-.4.5,0,.3,1.5-.7.9-2,1,0,.3.5.5.5.5.7.7.4,1-.5.5-.1.1-.9.9-1,1-1,.8-.4.4-1,1s-.7,0-1,0c-.4-.2-.7,0-1,.5-.1,1-.2,1.2-.5,2-.3,0-.7,0-1,0-.6,0-.7-.3-1-.5,1.5,0,1.2.7,1.3-.8s-.2-3.2.2-4.7c.3-.1.7-.3,1-.5.5.4.7.1.8-.8,1-1.3,4.4-.5,4.7.8Z"
          fill="#0242ef"
        />
        <path
          d="M116.8,197.8c1.1-1.5,1.9-2.2,2.5,0,0,.5-.3,1.4.2,1.5.4-1.9,1-.4,1.9-.5s.3-.9.8-1c1-.7,1.2-.4.5.5.6.4,0,1.9-.5,2-2.7-.6-3.3-1.7-4.8,1-1.2.2-.6-.4-.7-1-.3-1.6.2-2.2-2-1.5l.3-1-2.3.5c-.4-1.4.8-1,1.5-1.5,1.3-1.2,2.8-.8,2.5,1Z"
          fill="#034ef2"
        />
        <path
          d="M114.8,196.3c.9-.9.8-1.5,1.5-2.5-2.4.4-.8-.7-1.5-2.5l1,2c.6.1,1.1-.4,1.5-.5s.6.2.5.5c1,1.1,1,3.9-1,4.5-.4,0-1.5-1.4-2.5-1,.2-.1.3-.3.5-.5Z"
          fill="#0235e7"
        />
        <path
          d="M114.8,201.3c-.7.8-.1,1.6,0,2.5-.7,0-1.3,0-2,0-.9-2.3,1.2-2.1,2-2.5Z"
          fill="#0348f1"
        />
        <path
          d="M110.8,192.8c-1.1,0-1.7,1.3-1.5-.5,0-.1,0-.4,0-.5s.4-.3.5-.5c1.2,0,1.8.6,1,1.5Z"
          fill="#0845ea"
        />
        <path
          d="M341.2,147.8v.5c0,.2,0,.4,0,.5.2.5,1.1,1.3,1,1.5s-3.1.6-.5,2c0-1.8.1-.5.5-.5,1,0,1,.8,0,1-.4,1.1-.6,1.1-1,0-.3,0-.7,0-1,0-.9.4-1.2,0-1-1.5l.3-.3c-1.7.3-2.2,0-1.3-1.2.2-.1.9-.5,1-.5s.8.8,1,.5c.9-1.2-1.9-.6-.5-2,.4-.7.9-.6,1.5,0Z"
          fill="#0385f4"
        />
        <path
          d="M348.2,155.3c0,0-.1.6-.6.4s-1.1-1.1-1.3-.9.3,1.4-1.3,1-.5-1.6-1.8-1l1.5-2.5c1.5.2.3,1.9.5,2,.7.6,1.3-.9,1.5-1,.1-.4.3-.4.5,0,.6-1.4,1.7,0,1,1,.6-.3.3.3,0,1Z"
          fill="#06a0fa"
        />
        <path d="M337.2,151.3c.6-.5,1.5-.5,2,0l1,1.5c-1.5.3-4.4,2.6-3-1.5Z" fill="#08a7fc" />
        <path
          d="M348.7,153.3c.8.7,4.4,0,2.5,1.5-1.1-.9-1.3-.3-2,0s-.7.4-1,.5l-1-1c.3,0,.8,0,1,0l.5-1Z"
          fill="#0374f3"
        />
        <path
          d="M338.2,149.8c-.3,1.5.8.5,2,1v.5c-.3,0-.7,0-1,0s-.7,0-1,0l1,1.2-.3.3-1.7-1.5c.2-.6.5-1.1,1-1.5Z"
          fill="#0398fa"
        />
        <path d="M342.2,152.8c0,.7-.5,1.3-.5,2l-1.5-1.3,1-.7c.3,0,.7,0,1,0Z" fill="#04a6fc" />
        <path d="M342.2,151.8c.6,0,1.3-.9,1.5.7,0,.5-1,.2-1.5.3,0-.3,0-.7,0-1Z" fill="#08a7fa" />
        <path d="M343.7,148.8c1.4-1.4,1.4.5,0,1,0-.3,0-.7,0-1Z" fill="#0465e3" />
        <path d="M347.2,152.8c.4.1.4.3,0,.5-.2,0-.4,0-.5,0-.5,0-.6-.7-.5-1l1,.5Z" fill="#0475f8" />
        <path d="M339.7,155.3c0-.1-.4-1-.5-1l.2-.5c.6.4,1.3,1.2.3,1.5Z" fill="#08a8fb" />
        <path d="M346.2,149.8c0-.7.9-.8,1-.2l-.5.2c-.1,0-.4,0-.5,0Z" fill="#025eea" />
        <path
          d="M368.6,175.8c.3-.2.6,0,1,.5.4.3.2,1,1.2,1s.3-.9.3-1c.3.7.3.9.5,1.5v1.4c.4.6.1,1.3-.9,2.1-1.2-.6-1.9-.1-2.1,1.6.2,1.2-.1,1.4-1,.5-.7.7-1,.4-.5-.5-.2-.4-.5-.6-1-.5-.5,1.4-2.6,0-1-1,1.4-1.5,1.7-2.5,1-3,0,.5-.2.4-.5,0v-1.5c.1-.1.7.4,1,.5,1.2,0,1.2,0,0-.5l1-2.5h.5c0,.6.1,1,.5,1.5Z"
          fill="#0387f7"
        />
        <path
          d="M371.6,177.8c.3,1,.1,2.3,1.5,2,0,.2-.4.7-.5,1-.9,2-5.6,5.2-4,2-.9-4,1.9-1.9,2.5-2.5v-1.5s-2,0-2,0l2.5-1Z"
          fill="#0368f6"
        />
        <path d="M366.6,176.8h2c-.7,1.7-1.2.8-2,.5v-.5Z" fill="#035fec" />
        <path
          d="M354.2,180.3c0,.2,0,.3,0,.5s0,.3,0,.5c0,.7-.8.7-1,0-.5,0-1,0-1.5,0,.1-.2.3-.4.5-.5.6-.4,1.3-.5,2-.5Z"
          fill="#08a1f7"
        />
        <path
          d="M348.2,182.8c.3.1.6.6,1,.5.4.6-1.4.8-2,1,0-.2,0-.3,0-.5-.6,0-.7-.5-.5-1,0-.2,0-.3,0-.5.1,0,1.3.4,1.5.5Z"
          fill="#0796fb"
        />
        <path
          d="M352.7,169.3c.4.1.4.5.5.5.1,0,.2.6.5.7s2.4.8,2.5.8c.2-.3.4-.1.5.5,0,.2,0,.3,0,.5.9.3.8.7,0,1-.3-.3-.8-1.7-1.3-.5s.3,1.5.3,2.2-2,.4-1,1.3,1.3-.7,1.5-.5c-.6,1.9.3,4-2,5-.4-.1-.4-.3,0-.5-.4-.1-.4-.3,0-.5.2-.2.2-.4,0-.5,0,.8-.8.7-1,0-.5,0-1,0-1.5.5,1.4-.3,1.5,0,.5,1,0,.3-.2.5-.5.5,0,.5-.2.4-.5,0-.6,0-1-.6-1-2q-.9-1.2,0,0c.9.7.3,1.7-.7,2,.4,1.3.3,1.9-1.3,1.5-.3.8-.8.6-1.5-.5-1-.1-1-.6,0-1,.1-.3.3-.3.5,0,.5-.8-1.1-1.9-2.1-.8l-.4-.7c-3.8,1.9-1.8-3.6-.7-5.5l.2-.5c-2.1-2.4,3.3-3.2,1.5,0,.4.4.9.8,1.5,1,.6-.3,1-.3,1,.5s-.9-.3-1-1c-.5.5-1.2.2-1-.5-.7-.5-.6-1.7,0-2.5.1-.4.3-.4.5,0,1.1,0,2.1-.2,3-.5-.8-1.1,2.3-3.1,3-1.5Z"
          fill="#048df7"
        />
        <path d="M344.2,173.8c.4,1.2-1.4,3.2-2.2,1.9s1.7-4.5,2.2-1.9Z" fill="#048df7" />
        <path d="M356.7,171.8l-.5-.5s.2-.6.5-.5c0,.3,0,.7,0,1Z" fill="#0350e6" />
        <path
          d="M344.7,179.8c.9,0,2.9-.6,3-.5s-.4.9-.3,1.2c.2.7,1,.9.8,1.7-.6,0-.7-.8-1-1-1.2-.4-2.1-.2-.5,0,0,.3,0,.7,0,1-1.9-.2-1.4.7-2,1-.7-1.1-.7-2.4,0-3.5Z"
          fill="#037df6"
        />
        <path
          d="M348.2,170.8c.3,0,.7.8,1.5,0-.9,1.3-1.2,2.3,0,3.5l-2.5-1,1-1.5c-.5,0-1.1-.1-1.5-.5-.4-.2-.4-.3,0-.5.5,0,1,0,1.5,0Z"
          fill="#0272ed"
        />
        <path d="M353.1,175.8c0,1.4,2.7,1.7.8,2.5s-3.2-2.8-.8-2.5Z" fill="#026aea" />
        <path d="M350.2,179.3c-.3,0-.7,0-1,0v-3.5c.9,0,1-.3.9.7s.1,2.6,0,2.8Z" fill="#0479f3" />
        <path
          d="M354.6,171.9c.2.3,0,1,0,1.4-.7-.2-.8-1-1.7-1s-.4,1.9-1.2,1,1.8-3.3,2.9-1.4Z"
          fill="#0374f5"
        />
        <path
          d="M354.2,179.3c.3.2.3.3,0,.5,0,.2,0,.3,0,.5-.1.8-1.2.7-2,.5l-.5-1c.5-.5,1-.7,1.5-.5.3,0,.7,0,1,0Z"
          fill="#0660ef"
        />
        <path d="M347.2,181.3h-.5c-2.7,1.3-1.4-1.2-.3-1s.5.8.8,1Z" fill="#0996f9" />
        <path
          d="M347.2,174.3c.4.1,1,0,1.5,0l-.5,2h-.5s-.5-1.5-.5-1.5c-.4-.1-.4-.3,0-.5Z"
          fill="#026deb"
        />
        <path
          d="M347.2,174.3v.5l-.2.5c-.3-.4-1.1-.4-1.2-.6s0-.7,0-.9h.5c.3.1.7.4,1,.5Z"
          fill="#0aa4fa"
        />
        <path d="M353.2,179.3c-.3,0-.9.8-1.5.5.2-.8,1.2-1.6,1.5-.5Z" fill="#07a7f7" />
        <path d="M350.7,171.8l.2-1.5c.9.7.8,1.1-.2,1.5Z" fill="#0571e9" />
        <path d="M354.2,179.8v-.5c1,.2,0,.4,0,.5Z" fill="#037bf7" />
        <path d="M350.7,163.3c.1.2,1.3.7,1,1h-2c.4-.2.7-.7,1-1Z" fill="#0165f2" />
        <path
          d="M352.2,155.3c.4-.7.4-.6,1.5-.5l-1.2-1.5c1.6.4,3.4,0,3.7,2-.6.1-1.6-.3-2,.5-.6,0-1.2-.4-2-.5Z"
          fill="#0485f8"
        />
        <path
          d="M348.7,153.3c0,.6,0,.7-.5,1,.1-1.1,0-1.1-1-1v-.5c1.2-2.3,1.1.1,1.5.5Z"
          fill="#038ff9"
        />
        <path
          d="M338.7,159.8c0,.6,0,1.1.5,1.5,0,0,.7,0,1,.5l.5.5c.4.7.3,1.7.5,2.5-.2,0-.7,0-1.2-.1s-.7-.8-.8-.9c1.5,1,.7-.5.5-1-.4-.2-.4-.3,0-.5l-.5-.5c-.1.4-.3.4-.5,0-.2,0-.3,0-.5,0-.4,0-.6-.2-.5-.5v-1c-.4-.1-.4-.3,0-.5.3,0,.8,0,1,0Z"
          fill="#038ef7"
        />
        <path d="M339.2,163.3c0,.2,0,.5,0,.5-.3-.2-1.2.6-1-1,.4-.9,1.3-.4,1,.5Z" fill="#038ef7" />
        <path
          d="M345.7,159.8c.1,1.4.3,1.6-1,1.5-.5,0-.7.3-.5,1,.3.8.4,1,1,1.5v-2c.5,0,1,0,1.5,0-.2.5-.4,1-.5,1.5-.2,0,0,.8-1,.5.9.7,1.4.8,2.5,1,0,.2,0,1,0,1h-.5l-4-1.5.5,2.2c-.2.7-.5-.2-.5-.2-.2-.5-.5-1.3-1-1.5,0-1.3-.4-1.9-1-3l1.8.5c-.2-2.6.7-2.6,2.7-2.5Z"
          fill="#038ef7"
        />
        <path d="M342.2,164.8c0,.5,0,1,0,1.5-.9-.1-.8-.9-1-1.5.3,0,.7,0,1,0Z" fill="#038ef7" />
        <path
          d="M334.2,167.3c-.2-.9-2.4-.7-2-1.7s1.6-1.1,1.7.2c3.2-4.2,4.1,0,6.8.8s1.4-.3,1.5-.3c.2,0,.3,0,.5,0-1.1,1.4-.8,3.3-2,4-.6.7-.9.4-.5-.5,0-1.2-.2-2.1-.8-2.6-1.3,0-2.6-.2-3.7-.4q-.1-.8,0,0c.6.7.3,1-.5.5-.3,0-.8,0-1,0Z"
          fill="#038ef7"
        />
        <path
          d="M346.7,161.8c.3,0,1-.2,1,.2-.4.5-.9.9-1.5,1.3l-.5-.3c-.3-.9.4-.7,1-1.2Z"
          fill="#0175f2"
        />
        <path d="M344.7,161.3l-.5,1s-.7-.2-.5-.7c.4-1.3.9-.3,1-.3Z" fill="#04a3f9" />
        <path
          d="M363.1,162.3c-.5.4-1.2,1-1-.2,2.7-2.7,1.5-.3,1.8-.3s.5,0,.7,0c1-1,1.7-.8,2,.5.6-.7,1.8-.9,3.5-.5.8.7.2,1,0,2,1,0,.6.9,0,1.5-.7-.1-.3-1.2-.5-1.5s-1.6.6-2.2,0l-.3,2c.1.2.8-.5,1-.5l1,.5c0,.7-1.3.9-1.9.7-1.2-.6-1-1.9-1.6-2.2-.1,1-.7,1-1,0,1.7.7-.8,1.8-2,1.5-.1,0-.4,0-.5,0-.6-.2-.8-1.5-3-.5-.5-1.3,1-.8,1-1.3,0-1-1.1-1.9,1-2.7v3s2-1,2-1c.5-.4,1-.1,1.5,1-.8-1.5-1.3-2.1-1.5-2Z"
          fill="#0377f7"
        />
        <path
          d="M368.1,160.8c.7.4,1.5.5,2,1-1.2,1.7-3.3-.4-3,1.5-.9.2-.3-.8-.5-1-1-.3-1.1-1.2-.5-2.5.8.4,1.2.6,2,1Z"
          fill="#038dfa"
        />
        <path
          d="M366.1,159.8l.5,2.5c0,0-1.4-.3-2-.5,1.6-.7.8-1.2.5-2.5.4,0,.7.4,1,.5Z"
          fill="#0366f1"
        />
        <path
          d="M365.6,164.3c.5,2-1.5,2.1-3,1.5h.7c.4-1.4,1-.5,1.2-.6s0-.8,0-.9.9,0,1,0Z"
          fill="#0494fa"
        />
        <path
          d="M364.6,164.3c0,0-1.5-.9-1.5-1,0-.2,0-.7,0-1,0,0,0-.5.2-.5.7.6,1.3,1.5,1.3,2.5Z"
          fill="#0590f7"
        />
        <path d="M369.1,165.8l-1-.5c.2,0,.5,0,.7,0,.3,0,.3.3.3.5Z" fill="#0249e6" />
        <path d="M363.1,164.8s-1.1.2-1-.2c.8-1.4,1.6-.3,1,.2Z" fill="#0595fa" />
        <path d="M359.6,157.3c-1.7-.3-1.5-.5,0-1.5,0,.4.8.7,0,1.5Z" fill="#0491f9" />
        <path
          d="M279.2,83.9c.3,0,.7.6,1.2.5s1-3,1.3.5c1.1,1.1.3,1.8-1,1-.1,0-.3,0-.5,0-.9.6-1.6.6-1-.5-.9,0-.8-.7,0-1v-.5Z"
          fill="#2b88ed"
        />
        <path
          d="M279.2,84.4c0,.3,0,.8,0,1,.3.6,0,1.1-1,1.5-.5-.1-.4-1-.5-1,.4-.9.4-1.8,1.5-1.5Z"
          fill="#3d97f5"
        />
        <path
          d="M280.7,87.4c2.4-.4,3.7-.1,4,1,.4,1.1-.7.4-.7.4,1.5.4,3,.9,1.2,2.1,1.5.5,2.2,1.1,2,2-.3,0-.9,0-1,0-.8.4-1.7.4-2.9.2-1.2,1.8-2.7-.9-3.1-2.2,0-.4,0-.5-.5-.5,2.1-2.4.2-1.8,0-2-.5-.7.1-1.2,1-1Z"
          fill="#1793f7"
        />
        <path
          d="M280.2,90.9l1.5,2c1.3.5.9-1,1.3-1,1.2,0,2,1.3,3.2,1-.2.1-.3.8-.8.9s-1.1-.3-1.4-.3-.8,1.7-2.7.9c.4-2.1-1.2-2.2-1.4-2.7s.4-.6.4-.8Z"
          fill="#1ba9fb"
        />
        <path d="M279.2,94.9c-.6.2-1,.9-2,1l1.8-2,.2,1Z" fill="#1ba9fb" />
        <path d="M278.7,89.9l-1,.5c0-.2-.4-.6-.5-1,1.1-.9,1,0,1.5.5Z" fill="#2287ef" />
        <path
          d="M282.2,84.9c.1-1,2.6.4,2.4,1.3.9,0,2.1.2,2.1,1.2,1.8,2.1-1.1,3.2-2,1-.2,0-.4-.6-1.5-.3s-.6,1.2-1.5,1.3c0-.8-.8-1.4-1-2s0-1.1,0-1.5c.6-.2.9-.9,1-1s.3,0,.5,0Z"
          fill="#2da4fa"
        />
        <path d="M280.2,85.9c-.4.6-1.4,1.2-2,1,0-.6.9-1.2,1-1.5.2.5.6.5,1,.5Z" fill="#2da4fa" />
        <path
          d="M282.2,96.9c-.2.9-1.2,1.5-1,2.5l1.5.2-1,1.3c-.8,0-1.7,0-2.5,0l.5.5c-.7.1-1.2.7-2.5,0-.1-.2.8-1.1,1-1.5s0-.4,0-.5c.7-.5,1.2-1.1,1.5-2,.6-.2,1.3,0,1.5-1h.5c.3,0,.5.2.5.5Z"
          fill="#0b92f2"
        />
        <path
          d="M289.7,103.4c1.6,0,1.5,1-.5,3-.3,1.1-1.1,0-1-.3s1.5.6,0,1.3c0-.2,0-.4,0-.6.2-.5,4.8.3,5.4.6.2.2.2.3,0,.5-.4,0-1.9.4-2,.5-.6.7,3.1,2.4-.5,2.5-.3.3-.6.4-1,.5-3,.4,0-1.7-2-4s-.9.2-1-.3c-.7-2.5.6-1.8,1.5-2.7-1.2-.3,0-1.5,1-1Z"
          fill="#04aefb"
        />
        <path
          d="M285.7,101.9c0-7.4,6.5-3.8,4.5,1-1.1.6-2,.8-2.5.5-.7-.4-1.2-.6-2-.5-1.1-.3-1.1-.6,0-1Z"
          fill="#05a3f9"
        />
        <path
          d="M281.7,100.9c.8-.8,1.3-.8,1.5,0,.4.1.4.3,0,.5.6.5,1.3.9,2.3,1l.2.5c.7-.2,1.4.1,2,.5.5,0,.8.4,1,1l.2.5c-1.7.7-1.9,1.5-.7,2.5,1.7-.2,2,.7.9,2.8.3.4.7.8,1.1,1.2.9.2,1.9.7,3,1.5,1.4.6,1,1.7-.5,1.5-.9,0-.9.1,0,.5,4.2-.8,4.6,1.3,1,4-.1,0-.2.6-.5.7-.5.2-.9-.3-1-.2,0-.3-.5-.7-.5-1,0-1.4-.2-1.4-.5,0l-1.5-.5,1.5,2c-.8-.4-1.4,0-2,0,0,.5-.3.4-.5,0-.4,0-.9-.3-1.5,0,1.6-1.2,2.7-3.1,0-2-.3-.4.5-3.4.8-4s2.1-.7,1.2-1.5-2.4,1.9-2.5-1.8l1.2.2c.7-2.7-3.9.3-5.8-.5,0-.9,1-.2,2-1s0-1.4,0-1.5c.4.8-.2,1.3-1,1v-1.5s1,.5,1,.5c0-.5.7-1.8.5-2-.9-1.1-1,1.1-1.2,1l-1.8-2.7,2.5,1.2c1.1-1.6-2.3-3.1-2.5-3s0,.7-.1.8c-.3.2-.9-.3-1.2.2s.6,1.8-.7,2c.3-.7-.5-2.3-.5-2.5s.8-.2,1-.5c.3-.4.3-.6,0-1-.2,0-.3,0-.5,0-2.3-.7,0-1.2,2-.5Z"
          fill="#05a3f9"
        />
        <path
          d="M290.2,111.4c0-.2.7-.9.5-1h-1.5c2.3-3.8,1.5-2.1,2,.5s-.1.9,0,1,1.8-1.1,2,1c-.7,0-2.9-1-3-1.5Z"
          fill="#0394f5"
        />
        <path d="M287.7,103.4c-1.2,0-1.2-.3-2-.5.2.1,1-1.2,2,.5Z" fill="#048ff8" />
        <path
          d="M290.2,102.9v.5c-.1.4-.3.4-.5,0-1.8.6-.6.7-1,1-1.5.3-.8-.7-1-1,.5,0,1.7-.8,2.5-.5Z"
          fill="#048ff8"
        />
        <path
          d="M284.2,100.9c.5,0,.8.4,1,1,.1,0,.3,0,.5,0,0,.3,0,.9,0,1-1-.3-2,0-2.5-1.5,0-.7.4-.8,1-.5Z"
          fill="#048ff8"
        />
        <path d="M292.7,114.4v.5c-.3,0-.6,1.2-2-1l-1.5,1.2c.4-1.6,2.5-2.3,3.5-.7Z" fill="#028cf4" />
        <path d="M291.7,118.4h-.5c0-.9-.1-2.2,1-2.5.2.3-.5,2.1-.5,2.5Z" fill="#04b6fc" />
        <path d="M286.7,104.9v1s-1.5,0-1.5,0c.2-.7.8-1.1,1.5-1Z" fill="#04aefb" />
        <path d="M280.2,102.4c0-.2,0-.7,0-1,.8.2.8.8,0,1Z" fill="#0b92f2" />
        <path
          d="M279.7,97.4c1.1,1.9,2.7,3.5-.5,3-.1-1,1.3,0,1-1.2s-1.5.2-2,.2c.5-1.2.8-1,.9-1.1.1-.2-.4-.8-.4-.9,0-.1.7,0,1,0Z"
          fill="#0371e5"
        />
        <path d="M279.7,96.4c-.7.4-1.1,1.2-1-.5.1-.2.7.5,1,.5Z" fill="#10acfa" />
        <path
          d="M282.2,84.9c.2-2.6,1.2-.1,1.2-.1,1.4.5,1.1-.9,1.7-.9.3,3.6,1.7,1,3.5,0v2c.4-.3,1.1-.3,1.5-.5,1.3.4,1.3.6,0,1-.3.6-.9,1.3-1.5,1-.2,1-.7,1-1,0-.2.4-.3.4-.5,0-.1.4-.3.4-.5,0-.7-.1-2.4-.3-2.7-.4-.7-.5,0-2-1.8-2.1Z"
          fill="#3096f6"
        />
        <path
          d="M290.2,85.4c.4-.2.4-1.2.7-1,.8,1.9,1.8,1.4,3.7,2l-.5,2.5c.4.1.4.3,0,.5-.7.8-1.8,0-2.2-.8-1.3.5-1.9-.2-1.8-2.2,0,0,0-.7,0-1Z"
          fill="#37a7fa"
        />
        <path
          d="M300.2,88.9c1.3-.5.6,2.8-.5,2.5-1.2.9-3.7,1.3-3.5-.5-2.6-.1.4-2.9.4-2.6s-1.3,1-1.4.1c.2-.6-.5-1.2.8-1s2,2.9,4.2,1.5Z"
          fill="#259bf7"
        />
        <path
          d="M301.7,87.9c1.6,0,1.6,1.7,2.5,3l-.3,1.5-2.7-1.5c-.6-.3-.7-1.2-.5-2.5.3-.3.3-.5,1-.5Z"
          fill="#2484ef"
        />
        <path
          d="M300.7,88.4c.5.7,1.7.2,1.5,1-1.5-.2-.8,1.1-1,1.5-1.1,2.6-.9,1-1.5,1-.4-.1-.4-.3,0-.5.8-.8.5-2.4.5-2.5.1-.4.3-.4.5-.5Z"
          fill="#32a4f8"
        />
        <path
          d="M296.2,90.9c2.5,2.7-3.5,1.9-1.5-.5-.5,0-.4-.2,0-.5-.4-.5-.1-.9.5-1,0-.2,0-.4,0-.5l1.5-.5c.5.6-2.1,2.4-.5,3Z"
          fill="#2fb0fa"
        />
        <path d="M295.2,88.9c0,.3-.5.7-.5,1-.7.7-1,.4-.5-.5v-.5h1Z" fill="#21abfb" />
        <path
          d="M312.7,94.9c.9,1.1,1.4,1.3,2,0,.3,2.2,1.5,1.4,1.9,1.7s.4.6.6.8l.5.5c.1.1.8-.2,1,.5,0,.8-.7.7-1,0-1.5.3-1.1.8-2,2-.2,0-.7,0-1,0-.8-1-1.7-2-2.5-3-.4.4-1.6.4-2,0h-.5l-.5-.5c-.1.4-.3.4-.5,0-1,1.1-3.3.5-1.5-1,1.5.4.7-1.1,1.3-1.5,1.5-1.1,2.9.8,3.7-1,1,.1,1.1.7.5,1.5Z"
          fill="#259af9"
        />
        <path d="M317.7,97.9c-.1-.1-.4-.4-.5-.5l.5.5Z" fill="#1691f8" />
        <path d="M314.7,94.4c0-.2.3-.4.5-.5l-.5.5Z" fill="#259af9" />
        <path
          d="M312.7,92.9c1.8.1,1.3,1.2,0,2-.4-.5-.7-.7-.5-1.5v-.5c.2,0,.3,0,.5,0Z"
          fill="#2990f4"
        />
        <path
          d="M298.2,92.9h2.5s-1,2-1,2c2.1.8,1.6-1.7,2-2s1.3.5,2,.5c.6-.2,1.1,0,1.5.5.6.7,1.2,1,2,1,0,.3,0,.7,0,1s0,.9,0,1,.8-.1,1.5,0c1.4.6-.5,2.6-1,1-.8.2-1.7.5-2,1.3l-1-.3c-.4.3-.5.6-.5,1,.7.8.4,1.1-.5.5-1.2-.7-2.2-.8-3.1-.3l-1.2-1.5c-.8.5-1,.2-.6-.6l-.2-.6c1-.5.9-1.2.2-1.9-1.3-1.2-1.4-2-.5-2.5Z"
          fill="#169ef8"
        />
        <path
          d="M303.7,93.4c.3,0,1.5-1.6,1.5.5.3,0,.7,0,1,0,.3-.5.8,0,1,.5,0,.2,0,.3,0,.5l-1,1.8c-1.8-.8-.2,1.5-1.7,1.2s-2.3-1.5-1.8-2c1.9,0,2.5,0,2.5-2-.6.1-1.3.6-1.8,1l.7-1.2-.5-.2Z"
          fill="#22a7fa"
        />
        <path d="M306.2,93.4c1.4-.2.9,0,1,1-.4,0-.8-.5-1-.5v-.5Z" fill="#169ef8" />
        <path
          d="M323.2,108.9c0,.3,0,.7,0,1h2s-.5,1.5-.5,1.5c1.1-.5,2.5-.5,2.5,1,1.1-.6.6-1.6,2-2.5-.4-.9.1-1,1-1,.8.3,1.2.2,2,0,0,.5,0,1,0,1.5l2.5-1.5.5,1.5c-1.7-.8-2.1,1-2.3,1-.9,0-1.2-1.2-2.2-1-.3,1.1.8,1.3,1.5,1.5.4.5.5,1.2.5,2,.2.1.9-.1,1,0s-.5.8-.5,1l-1,1.8c-1.2,1-.9-.5-1.3-1.2-1.2-1.9-1.4-2-3.7-2.6,0,.5,0,1,0,1.5-.1.4-.3.4-.5,0-.2-.3-.3-.7-.5-1,.1-.9,0-1.1-.5-.5-.7-.4-1.3,0-2,0l.5-1c-.5,0-1,0-1.5,0,.4-.4,1-.6,1-.7,0-.5-.8,0-1-.6s0-1.2,0-1.6c.2-.2.3-.2.5,0Z"
          fill="#0597f9"
        />
        <path
          d="M332.2,111.9c.5.1,1.4-.1,2,0,0,.9-1.7.5-1.5,2-1.1-.6-1.3-.9-.5-2Z"
          fill="#0473eb"
        />
        <polygon fill="#027ff1" points="330.7 112.9 328.7 112.6 330.2 111.4 330.7 112.9" />
        <path d="M326.2,113.4c0-.1-.4-.5-.5-.5l.5-.5v1Z" fill="#0388f3" />
        <path
          d="M323.7,103.4c.4.1.4.3,0,.5,0,.2,0,.3,0,.5l-1.5,1c0-.3,0-.8,0-1,.2-.9.8-.9,1.5-1Z"
          fill="#0683f4"
        />
        <path d="M324.2,106.9c.2.2-.5.8-.5.2s.4-.4.5-.2Z" fill="#078df6" />
        <path d="M324.7,104.9c0,.2,1.2,1.6-.5,2,.2-.8-.4-1.4-.5-2h1Z" fill="#078df6" />
        <path d="M319.7,102.4c.3.4.9.2-.5,1-.6.4-.8.2-.5-.5.3-.3.5-.5,1-.5Z" fill="#2eb1f8" />
        <path d="M318.7,98.4c.5,1.3-1.4,1.6-1,0,.3,0,.7,0,1,0Z" fill="#34a3fa" />
        <path d="M323.7,103.4c1.4-.3,1.4.7,0,.5v-.5Z" fill="#119ff9" />
        <path
          d="M326.7,105.4v2c.8-1.1,2.4-.5,2.5-.5v2s-2-1-2-1v1.5c-2.7-.4-.4-.3-1.8-1.5s-.5,2.4-1.7,0c1,0,1.8-.5,3,0-1.6-2-.9-1.4,0-2.5Z"
          fill="#078ef7"
        />
        <path d="M341.2,148.3c0-.2,0-.3,0-.5v-.5c.2,0,.4,0,.5,0l-.5,1Z" fill="#0398fa" />
        <path
          d="M330.2,132.3c-.2.6-.2,1.4-.5,2,.5,0,1.2.2,1.7,0s.1-.9.6-1,.4.7.7,1c.5-.1.6,0,.5.5.4.4,1.1.3,1,1-2.1,1-1.2-.3-2.5-1,0,.5,0,1,0,1.5.4.4.7.8,0,1,0,.2,0,.4,0,.5-.3-.1-.7-.3-1-.5-1.4,0-1.5-.5-.5-1.5q.5-.7,0,0c-.3,3-3.7-.5-.5-1.5-1.3,1.6-3.3,1-3-1-.5-2.6,2.4-3.5,3.5-1Z"
          fill="#038af4"
        />
        <path
          d="M337.2,130.8c.3-.6,1.2,1,1,1.3-3,.4-1.4,2,.6,3.2l-.2,1c-.1.2-.4.4-1,.5.9.5,1.5.7,2.6.5,0,.8-.2,1.6.4,1,1.8.6,2.5,2.6.3,3.9,1.5.9.6,3-.9,2.8l.2.4v1.5c-.5.5-.7.9-.5,1,2.4,1.6.7,3.9-.7,2.2s0-.4.2-.7c-.6-.6-1.3-1.1-2-1.5-.4-.1-.7,0-1,.5-3-.2-4.1-5-.5-3.5q1,.6,0,0c-.4,0-.6-.2-.5-.5-1.2-.5-1.2-1,0-1.5-.7-.6-.3-.9.5-.5.8,0,.7-.4-.5-1,.5.8-.8,1.5-1.5,1-.4,1-.9,1.4-1.5,1-.5-.1-.9-.5-1-1-.2.2-.3.2-.5,0-1.1-1.4.6-1.1.6-1-.3.7-2.6.9-2.4-.3-2.1.4-2.2-2.5.4-1.9l1-.7.5-.5c-.4-.2-.4-.3,0-.5.3-.8.7-.6,1,.5.7.3.9.7.5,1q-.4,1.1,0,0c.1-.4,0-.7-.5-1-.3-.2-.3-.3,0-.5.5,0,.5-.3,0-1-.9.2-.2-2.1.2-2.1,1.1,1.3,1.5,1.5,1.3.6l.5-1c1-1,1.4-2,1.3-3.2l1.2.2c.3,0,.7,0,1,0Z"
          fill="#0398fa"
        />
        <path d="M337.2,149.3c-.8,1.1-1.8-.2-1-1,.1-.4.3-.4.5,0,0,.3.5.8.5,1Z" fill="#0398fa" />
        <path
          d="M340.7,137.8c1-.3,2.8,2.5,2.5,3s-.6.2-1,.5c.5.5.8,1,1,1.5,0,.1,0,.4,0,.5-.1.2-1.1.4-1,1h2s-1.5.5-1.5.5c-.3.6,2.2.6,1,1.5s-2.5-.6-3.5-1-1.2.4-1-.5l2-1.5-2-.7c.8-1,1.6-1.8,3-1.8l-1.5-2.5c-.4-.2-.4-.3,0-.5Z"
          fill="#05a3fa"
        />
        <path
          d="M338.2,130.3l.5,1c0,.2.4.3.5.5,0,0-.2.5-.5.7s-2.7.4-1.1,1.3,3.4.8,1.2,2.5c-1.1-1-1.1-1.9-3-1.5.5-1.6,0-3.5,2-3,0,0-.4-.8-.5-1-.3-.3-1.8-.8-1-1.5s1.6.6,2,1Z"
          fill="#0385f2"
        />
        <path
          d="M341.2,136.8c-.1.3-.4.7-.5,1s0,.3,0,.5c-.1.7-.2,1.2-.2,2l-.8-2.5-2,.5c0-.5-.1-1.1,0-1.5,1.2,0,2.3,0,3.5,0Z"
          fill="#0285f1"
        />
        <path
          d="M334.2,129.8c1.3.4.8.9,2,1-1.3.8-.4,2.4-.5,2.5s-1.9.5-2,.5l-.5-1.2c.6-.7.8-1.6.5-2.8.2,0,.3,0,.5,0Z"
          fill="#0388f5"
        />
        <path
          d="M339.7,147.8c-.7,0-1.3,0-2,0,.3-1.3.9-1.3-.5-1.7,1.6-1.9,1.5.2,2.1.6s.7,0,.9.1c.3.1.9.5,1,.5.3.2.3.3,0,.5-.5,0-1,0-1.5,0Z"
          fill="#04a3fa"
        />
        <path
          d="M333.7,142.3c.6,0,1.1.2,1.5.5,0,.5-.1,1.1,0,1.5-2.1-1.5-1.3,1.4-3,1,.7-.8,0-1.7,0-2,.3-1,1.1-.8,1.5-1Z"
          fill="#028bf6"
        />
        <path
          d="M335.2,141.3c.7-.1,2.1.5,3,0-.6,2.1-2.3.9-2.5,1-1.3.6-1.5-.1-.5-1Z"
          fill="#0286f2"
        />
        <path
          d="M335.7,142.3c-.1,0-.3.5-.5.5-.7.2-1.3.6-2,.5l.5-1c.5-.2,1.1-.9,1.5-1l.5,1Z"
          fill="#04a7fb"
        />
        <path
          d="M333.7,133.8c0,.5,1.4,1.2-.5,1-.2-.2-.3-.3-.5-.5,0-.8-.3-1.7.5-1.5,0,.3.2.9.5,1Z"
          fill="#0cb4fc"
        />
        <path d="M332.2,138.8c1,1.3.2.8-1,1.5-.4-1,.9-1.3,1-1.5Z" fill="#0384f1" />
        <path d="M331.7,136.3c1.2.6,1.5,1.2,0,1,0-.4-.1,0,0-1Z" fill="#026ae7" />
        <path d="M331.7,137.8c.5.2,1.1,0,1.5.8l-1,.2c0,0-.4-.7-.5-1Z" fill="#10baf9" />
        <path d="M333.7,140.3c.2.2-.9,1.3-1.5,1-.2-.2.9-1.3,1.5-1Z" fill="#027ef0" />
        <path d="M330.2,138.3c0-.3.2-.6.5-.5-.1.4-.2.4-.5.5Z" fill="#038af4" />
        <path d="M335.9,143.3c.3.2.3.3,0,.5v-.5Z" fill="#04a7fb" />
        <path d="M333.7,129.8c-.2,0-.3,0-.5,0l.3-.5c.3,0,.2.4.2.5Z" fill="#0497f9" />
        <path d="M334.2,127.9c0-.2.3-.4.5-.5-.2.2-.3.4-.5.5Z" fill="#0497f9" />
        <path d="M340.7,131.8c-.2-.2.5-.8.5-.2s-.4.4-.5.2Z" fill="#0497f9" />
        <path
          d="M315.2,123.4c.5-.1.7.4.5,1.5,1-1,2-1.2,3-.5.6,0,.6-.2,0-.5-2.2-.6-.3-3.3,1-1.5,1,.2,2,.3,3,.5-.1.3-.5.8-.5,1,.6,0,1.6.4,2,1,1.1-.3,1.2-2.8,4.5-1.5-1.9-.4-1.9,1-2,2.5-.1.7-.2,1.6.5,2,.8,0,2.4-1,2.5,0-1.6,1.3-1.5.5-2.7.6-2.5.2-1.3.8-1.5,1.6s-.8.7-.5,1.3,1.6.7,1.8.5-.8-2,1.8-1.4,1.7,1,2.7,1.4c.4.1.4.3,0,.5-.3,0-.7,0-1,0-.7-.2-2.6-2.6-3,.5l2,.5c-.7.1-1.9-.2-2.5,0-.2-.2-.3-.4-.5-.5-1.8,1.2-3,0-3.6-3.2,1.5-.4,2-1.3,1.6-2.8-1-1.4-2.2-1-3.5,1q-1.1,1.6,0,0c1.9-2.4,2.9-2.5,3-.5,1.1.8.8,1.7-1.2,2.8.4.6.5,1.1-.3,1.2q-.8.9,0,0c.4-2.3,2.8,2.2.5,2h-.5c-.2.5-.8.5-1.8.1-1.2,2-2.8,3-4.7,2.9,0-.3,0-.7,0-1-.5-.8-1.2-.8-2,0l-2.5.5.7-1.5-1.2,1.5c-.2,0-.3,0-.5,0-.8.3-1.5-.2-1-1-.6-.4-1.3-.8-1-1.5l.2-.5c1.8.4,2.2.1,2.8-1.5,2.4,1.9,1.5-1.4.9-3.1-1.1-1.6-.2-3.2.6-4.5.1-.2.1-.6,0-1-2-1.8-2.3-2.8-.8-3,.3-5.3,3.3,1,3.3,3.5Z"
          fill="#04b0fb"
        />
        <path
          d="M313.2,107.9c.6,1.5,2.4.4,2.5.5.3.4-.9,2,1.5,1.5l1-1c-.2.6-.9,1.3-1,2-.5.8-.5,1.1,0,1,.3,0,.7-.5,1-.5.3.2.6.4.5.4-1,2.1-3,1.7-.6.6s.3.2.5.4c1.2.3.5.9.5,1,.7,1.7,0,3.4-1.8,3.3l.3.7v.5c-1.4,2.2-2.6,1.8-3-.5-.3-.9-.6-1.9-1-3,0-1.4-1.5-1.2-2-.5,1.1,1.4,0,.5,0,.5.7,0,1.4.3,1,1,.6.7.3,1-.5.5l-2.5.5c.4-.6-.2-3.4,0-3.5.4-.2,1.8.4,2-.5-.6-.6-.9-1.1-1-1.5-.6-.7-.4-1,.5-.5.2-.9.4-1.3.7-1.4-1.1-1.3-.5-2.5.8-1.6.1-.3.3-.3.5,0Z"
          fill="#07acfa"
        />
        <path d="M331.2,132.3v-.5c-.3-1.9,1.1.4,1-1.5.6-.2,2.6,2.7-1,2Z" fill="#028af3" />
        <path
          d="M326.7,125.9c.1,0,.3,0,.5,0-.5.7-.5,1.4,0,2-1.1,0-2.1-.9-2-2,.5,0,1.1.1,1.5,0Z"
          fill="#0389f5"
        />
        <path d="M327.2,125.9s0-.7.7-.5,1.4,2.6-.7.5Z" fill="#04b0fb" />
        <path
          d="M355.2,189.3l.5-.5c.2,0,.4,0,.5,0,0,.7-1,4-1.3,4.1-.6,0-1.1,0-1.7.4-.2.2-.3.4-.5.5-1.2-.7-1.7-1.3,0-1.5.1-.7.1-1.4,0-2h-.5c-.4-.1-.4-.3,0-.5.1,0,.4-.5.5-.5s.3,0,.5,0c.2.2.4.2.5,0,.9-.1,1.4,0,1.5,0Z"
          fill="#0374f5"
        />
        <path
          d="M366.1,178.3c.5,0,1,0,1.5,0,0,2.2-2.5,2.5-2.5,4,.3,0,.8,0,1,0,.4.2.4.3,0,.5,0,.1,0,.3,0,.5l-2,.5.5-1.5h-1.5c1.1-.9,1.6-.3,2-2-.9-.2-.8-.6,0-1,.5-.2,1.3.6,1-1Z"
          fill="#0371f4"
        />
        <path
          d="M350.7,195.3c.7.3.6.7,0,1,.4.6-.4.8-1,.5-.1,0-.5-.5-.5-.5-1.4-.1-1.2-.4,0-1,.2,0,.3,0,.5,0,.3,0,.7,0,1,0Z"
          fill="#0282f7"
        />
        <path
          d="M363.1,182.3l1.9-.5c-.3.5,0,1,1.1,1.5,1.7,0,.6,2.4,0,3.5.4.1.4.3,0,.5.9,1-1.3.8-1.2.7.7-.3,2-.4,2.7-.2-.1-.5,0-.6.5-.5h.5l.5.5c.8,1.3,1.7,1.6,2.7.8l.8.7c.7.3.8.9.2,1.8,1.3.9,1.7,1.8,1.3,2.7-.6.3-1.5.4-2,0-.5,0-1.7-.2-1.9,0s0,.9-.2,1.3-.8,0-.9.1c-1.4-.5-1.4-.4,0,.5,0,.3.1.9,0,1-.2.2-4-1-5.3-.9s-.2.9-.5.9c-.6,0-2.1-1.4-1,1s3.1,1.5,4.7,2.5c1.6,1.2-3.1,4.4-3.7,2.1-1.1,1.9-4.2.5-2.3-.7-.3-.6-.4-1.5.5-1.8q.9-.9,0,0c-.1,1.3-.4,2.7-1.3,3.1-2.3-1.3-3.6,1.4-1.2,2.4,2.7-.2.5,3.4-1.5,1.5-.8,0-2-2.3-1-3-1.3.2-1.4,0-.5-1l-.5-.2c.5-2,.2-3.4-1-4.3-1-.3-.7-.8,0-1.5.2-.8,1.1-1.4,1.5-.5.1-1.1,1.8-.2,2,.5,0,.2.1.4,0,.7-.1,1.2,1.6,1.6,0-.7-.8-.3-1.9-1-1.5-2l-.4-.2c-1.1,2-1.9,2.4-2.5,1.2q-.5-.4,0,0c.3,2.3-3.9,2.5-1.5-.5-.5,0-1,0-1.5,0,0,.8-.9.9-1,0-1-.3-1-.7,0-1,.8-1.2,1.3-1.4,2,0,.1-.4.3-.4.5,0-.2-.8-.2-1,.5-.5-.1-.5,0-.7.5-.5.5-.2,1-.6,1.7-1.1.6-1.6,1.3-2.7,2.3-3.4-.5-.9-.3-1.3.5-1-.4-.8-.5-1.2.5-1,.2-.4.3-.4.5,0,.9-.3,1.8,1.2,2,2,.3,0,.6,0,1,0,.1-.4.3-.4.5,0,1.3.2,1.2.4,0,1l-.5,1c1.2,1.6,2.7-5,0-3.5.6.3.5.7,0,1-.1.4-.3.4-.5,0-.7.2-2-1.3-1.5-2-1.3-2.1,1-5,3.5-4Z"
          fill="#0481f7"
        />
        <path
          d="M361.6,199.8c0,.1.4.9.3,1.2-.1.5-.9,1.1-.8,1.2,1,.9,1.7-1,1.8-1,1.7,0,1.6,1.5,1.7,1.5s2.8-1.5,2.5-2.5c.2.1.8-.3,1,.3.5,1.9-.8,1.6-1,1.7-.2.8-.6,1.3-1,1.5v.5c.3.1.3.3,0,.5-1.1,1.8-1.9,1.3-1-.5-2.6.3-3.3,1.3-4.3-1.5l-.2,1.5c-.9-1-1.7-2.4-2.5-.2s.5.1,1,1.2c-1.6-.1-2.3-1.3-1.5-2.6s2.7-.7,3-.9c1.1-.9-1.3-.9-1-1.5.4-.1,1.9-.4,2-.5Z"
          fill="#036cf2"
        />
        <path d="M374.1,193.8c.4.1.4.3,0,.5-1.4.2-1.5,0-2,0v-.5c.7,0,1.2-.3,2,0Z" fill="#035df1" />
        <path d="M369.1,195.3c0,0,0,.3,0,.5-1,0-2.6-1.2-1.8-2l1.8,1.5Z" fill="#0361f0" />
        <path
          d="M358.2,196.8c-.2.2-1.5-.5-2-.5v-.5c-.3-.5-.3-.8,0-1,.2,0,.4,0,.5,0,.5.3.3,1.2,2,.7-.6.3-.4,1.2-.5,1.3Z"
          fill="#026cf5"
        />
        <path
          d="M358.2,196.8c3.6-.4,1.3-.7,2-1.5s1.7-.5,1.5.7-2.1,1.2-2.5,2l1.5,1.2c-.6-.2-1.2.6-1.4.4s-.2-1.9-1.1-.9,1.4,3.1-.5,2.5c-.2-2.1-.3-3.3-2-4.5,1.3.7,1.9,0,2.5,0Z"
          fill="#026cf5"
        />
        <path
          d="M361.6,187.3c.1-.7-.5-1.7.7-1.5,1.6,1.7,2.6,3.4.6,5.3s-1.2.5-1.3-.3l.5-1c0-.3,0-.7,0-1l-.5-1.5Z"
          fill="#0373f4"
        />
        <path
          d="M357.2,188.8c-.4.8-1.4,1.9-1.5,2.8s2,.8,1,1.7-1.9.5-2,.5c-.2-.2.2-.7-.3-1s.2,1.8-1.2.5c1.4-1.4,2.2-2.7,3-4.5.1,0,.3-.6.7-.5l.3.5Z"
          fill="#0487f8"
        />
        <path
          d="M357.7,206.8c-.4.2-1.4,1.2-1.5,1,1.6-2.8-2.7-2.1.5-4,.5,1,.5,2,1,3Z"
          fill="#0361f1"
        />
        <path
          d="M367.1,182.8c0,.1.5.4.5.5,0,.4-.9,1.7,0,3-1-.6-.9-.5-1.5.5l-1-1.5c2.3.2,1.5-.4,1-2-.4-.1-.4-.3,0-.5.1-.7.9-.8,1,0Z"
          fill="#0894fa"
        />
        <path
          d="M369.2,190.8c.3.2,1.3-.7,1.4-.5.3,1.5-.1,1.9-1.7,1.5s-.2-1.2-.6-1-.8,1.3-1.8,1c.6-1.1,1.9-.8,1.5-2.5.8,0,.8,1.3,1.1,1.5Z"
          fill="#0363f5"
        />
        <path
          d="M365.1,192.2c-.3.2-1.6.4-1.4-.4,1.5.2.8-1,1-1.6s1.4-1,1.5-.9c.3.3-.8,2.8-1.1,2.9Z"
          fill="#0271f5"
        />
        <path
          d="M359.6,186.3l1.5,2c.3.5,0,.7-.5.5-.7-.5-1.4-1.4-2-2,0,0,1-.5,1-.5Z"
          fill="#0270f2"
        />
        <path
          d="M367.6,187.8c-.2.2-.8.4-1,.8,1.8.1.9,2,0,1.2s-.1-1.9-2-1.5c-.2-.5,1.4-1,1.5-1,.4,0,1.4-.1,1.5.5Z"
          fill="#0271f5"
        />
        <path d="M365.1,201.3c-.3.3-2.7-.5-2-1.5,1-.5,2.6.9,2,1.5Z" fill="#0262f0" />
        <path d="M359.6,190.3c.1.8,1.1,1.7-.7,2l.2-2c.1-.4.3-.4.5,0Z" fill="#026af1" />
        <path
          d="M361.6,187.3c2-.2.6.8.5,1.5h-.5c-.4-.1-.4-.3,0-.5-.5-.5,0-.8,0-1Z"
          fill="#0892f8"
        />
        <path
          d="M359.6,190.3h-.5c-.4,0-1.9-.5-1.2-1,.5.2,1.4,0,1.8.3.6.4,0,.7,0,.7Z"
          fill="#0696f8"
        />
        <path d="M361.6,199.8c0,0,0-2,1-1s-.9.9-1,1Z" fill="#0264f0" />
        <path d="M361.6,190.8c0-.1-.9-.5.5-1,0,.4,0,.9-.5,1Z" fill="#0892f8" />
        <path d="M361.6,188.8c-.6.9-.7.2-1,0l.5-.5h.5v.5Z" fill="#0463e9" />
        <path d="M359.1,188.3c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#0256f0" />
        <path d="M361.1,193.3c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#0356f9" />
        <path d="M369.1,187.8l-.5-.5c.2,0,.4.3.5.5Z" fill="#037bf7" />
        <path d="M352.2,194.3c-.1,0-.3,0-.5,0l-.2-1.5.7,1.5Z" fill="#048ffa" />
        <path
          d="M370.1,209.8c.3,0,.9.5,1.5.5-.2.7-.3,1.3-.5,2,.2.2.2.3,0,.5-.3,0-.8,0-1,0-.5.4-.7.1-.5-.5-.4-.1-.4-.3,0-.5.1-.6,0-.6-.5,0h-.5c-.7.1-1.2-.6-.5-1,0-.3,0-.7,0-1,.3-.5,1-.5,2,0Z"
          fill="#0375f8"
        />
        <path
          d="M372.1,193.8c.4.1.4.3,0,.5,0,.6.2,1.1.5,1.5,1,.2.9.5,0,1,1.1,0,.3,1.5-.5,1.5-.7-.2-.7-.9,0-1-.1-.5-.4-.5-1,0,.4.1.4.3,0,.5,1,.7.8,1.1-.5,1-.1.4-.3.4-.5,0-.7-.5-.8,0-.4,1.1l-.6.4c.3.7.4,1.4.5,2,.5-1,1-1.6,1.5-2,.1-.4.3-.4.5,0,.3-.1.5-.2.7,0,.4.3.3,2.2-.5-1.7.8-.5,1.6-1.3,2.3-2.2-.4-.1-.4-.3,0-.5.2-.4.3-.4.5,0,.7-.6,1-.4.5.5.5.3.5.7,0,1,.6.6.4,1.3-.5,1-.3.4-.2.6,0,1l.5.3c.4-2.5,2.8.2,1,1.7-2.3.2-.9.1-1.7,1.3s-.8.2-.8.2c-.3.4,1.3,1.2,1.5,1.5.8-.3,1.3.4.5,1-.6,1.9-1.4,1.5-2.7.6l.2.4.5.5c.5.1.5.3,0,.5,0,.8-.3,1.4-1,2,.5.8.3,1.8-.5,1-1.1-.5-2.9-1.7-3.8-3.8h-.4c-1.8,4.6-5.8,1.7-1.4-1.1,0-.7.3-1.2.6-1.7-.8,0-.8-.5,0-1.5.4-.7.4-1.4,0-2-1.2.9-4.3,0-4.1-1.5-4.3-1.6.7-5,3.9-3.5.7.6,1.4,1.1,2.2.5-.4-.2-.4-.3,0-.5-.3-2.3,1.9-3.8,3-1.5Z"
          fill="#0375f8"
        />
        <path
          d="M369.1,200.3c0-.3-.3-2.4-.3-2.5,1.2-2.1,1.1.4,1.3,1,.8,0,1.2.9,1,1.5,1.2,1.5-1.1.5,0,2-.5,0-1.1,0-1.5,0-.2-.6-.3-1.2-.5-2Z"
          fill="#0481f7"
        />
        <path
          d="M374.1,194.3c.4-1.4,1.1-1.3,1.5,0,.4.2.4.3,0,.5.5.5-.3,1.4-1,1,0,0-.3,0-.5,0-.5.3-1.2.6-1.5,0-.6,0-1.9.6-2,.5-.5-.5,1.4-2,1.5-2,.4-.5,1.5-.4,2,0Z"
          fill="#0481f7"
        />
        <path
          d="M375.6,205.3c.4,1.1-.8,2.2-1.7,2.5l-.3-.5s0-.4,0-.5l-.5-.5c-.3-.1-1.1,0-1.5,0-.4-2.3,2.7.7,4-1Z"
          fill="#0359f1"
        />
        <path
          d="M374.1,196.3c.3,1.1-1.1.9-1.3,2s.5,2.3-.2,3.5c-.5.1-.9-1.1-1-1.5-.5-.3-.9-.8-1-1.5,0-.5.4-.8.5-1,.5-.3.9,0,1,.5.8-.2.5-.7.5-1.5,0-.8,1-1,1.5-.5Z"
          fill="#0481f7"
        />
        <path d="M369.6,202.3c0,0-.3.7-1,.5l.5-2.5c0,.1,1.7.7.5,2Z" fill="#0364f3" />
        <path d="M374.1,195.8v.5l-1.5.5c0-.3,0-.7,0-1,.8-.1.5-.3,1.5,0Z" fill="#0353eb" />
        <path d="M375.6,196.3c0,.1.6.8.4.9s-.8,0-.9,0c-.6,0,0-.9,0-1h.5Z" fill="#0481f7" />
        <path
          d="M372.1,197.3c0,0,0,.7,0,1-.2,0-.5,0-.7,0l-.3-.5c0-.2,0-.4,0-.5.6-.6.9-.6,1,0Z"
          fill="#045af5"
        />
        <path d="M369.6,205.3c-.6.3-1.7-.8-1.5-1,.6-.3,1.7.8,1.5,1Z" fill="#0990fa" />
        <path d="M374.1,204.3v.5c-2.1.2-2.1-.7,0-.5Z" fill="#034ef4" />
        <path d="M372.1,197.3c0,0-.7,0-1,0,.7-1.1,1.1-1.6,1,0Z" fill="#0481f7" />
        <path d="M374.6,199.3c0-.1-.5-.2-.4-.6s.3-.3.4-.4v1Z" fill="#0481f7" />
        <path d="M373.6,206.8s-.5-.5-.5-.5l.5.5Z" fill="#0369f9" />
        <path d="M366.1,204.8c0-.1,0-.3,0-.5l.5.3-.5.2Z" fill="#0375f8" />
        <path
          d="M372.1,212.3c.3,0,.7,0,1,0l1,1c.2-.2.4,0,.5.5v.5c-.1,0-.3,0-.5,0-.9,1-1.6,1.5-2,0,.1-.3.6-.9.5-1l-2,.5c-.2-.1.4-.7.5-1s0-.3,0-.5c.5.6.9,0,1,0Z"
          fill="#055bf6"
        />
        <path d="M373.1,211.3c0,0,0-.7,0-1l.5.3-.5.7Z" fill="#0369f9" />
        <path d="M376.1,214.3h1s-1,1-1,1c0-.2,0-.7,0-1Z" fill="#1b6beb" />
        <path d="M374.6,212.3c0,.2,0,.3,0,.5-.1.4-.3.4-.5,0-.6.6-.8.4-.5-.5h1Z" fill="#055bf6" />
        <path d="M374.6,213.8c-.2,0-.5-.5-.5-.5-.4-.1-.4-.3,0-.5h.5v1Z" fill="#0577f7" />
        <path d="M374.1,212.8v.5c-.3,0-.9.7-1,.5v-1.5c.2,0,.3,0,.5,0l.5.5Z" fill="#0339e8" />
        <path
          d="M374.1,188.3c0,.2,0,.3,0,.5.4,1,.6,1,.5,0,.8,0,1.8-.5,2.5-.5.5.5,1,.7,1.5.5.7.3,1.1-.5.7,1,.2,0,.6-.5.8-.5s.4.8.5,1c-.3.2-.7.3-1,.5-.2-.2-.4-.2-.5,0-2.1,0-1.4-1.5-3.5-1.5-.2.2,2,2.2,1.4,3s-1.2-.3-.9.5l2,.5c-.2.8-1.8.9-2.5,1s-1,0-1.5,0v-.5c-.6-.8-2.3-1.8-2.5-2.8s.9-1.6,1-1.7l.5-1c0-.4.7-.3,1,0Z"
          fill="#0370f6"
        />
        <path d="M378.6,188.8c-.4,1.1-1.1.1-1.5-.5.6,0,1,.3,1.5.5Z" fill="#067ef8" />
        <path d="M374.6,188.8c.7.9.6,1.7-.5,2,0-.7,0-1.3,0-2h.5Z" fill="#0156ec" />
        <path d="M379.6,190.8c-.1,0-.5,0-.5,0,0,0,.1-.3.3-.4l.2.4Z" fill="#067ef8" />
        <path d="M374.6,191.3c.6.6-.2,1.6-1,.2,0-.4,1-.3,1-.2Z" fill="#0c90fb" />
        <path d="M373.1,188.3c1.1,1.6-.2.8-.5,1,0,0,0-.7.5-1Z" fill="#0581f8" />
        <path d="M367.1,253.8c-.7-.3,0-.3,0-.5v.5Z" fill="#033ff2" />
        <path d="M356.7,218.3c.5,0,1.3.7,2,.5v.5s-2.5,0-2.5,0c-.2-.1.5-.8.5-1Z" fill="#0250f0" />
        <path
          d="M362.6,219.8v1c-.1.4-.3.4-.5,0-.2-.2,0-.3-.5-.5s-.3,0-.5,0c-.2-1.9.5-.4,1.5-.5Z"
          fill="#024ff3"
        />
        <path d="M355.7,222.3c-.2,0-.3,0-.5,0-.1-1.4.1-1.2,1-.2l-.5.2Z" fill="#0484f8" />
        <path
          d="M366.6,222.3c-.3-2,.8-2.1,2.1-1.2.9-1.1,1.8-.6,2.6,1.6l.3-.5c-.6-.8-.3-1,.5-.5h2c.6-2.8,4.2.9,1,1.5-.1.4-.3.4-.5,0-.4.8-.9,1.2-1.5,1,.4.5.4.8,0,1-.6.2-.4.4.5.5-.2-.4,0-.6.5-.5.1-.4.3-.4.5,0,.7-.3.9-.1.5.5-.2.7-.2,1.4,0,2,1.1-1.1,1.6,0,.5,1,.9.9,0,2.1-1,1-1.1-.6-1.9-.6-2.5,0,.9.1,1.2.4,1,1-.1.4-.6.6-1.5.5-.6-.2-1.3-.8-2-1-.2-.2-.3-.4-.3-.5,1.1-1.8,1.3-.6-.7,1-.2,1.9-2.9,2.5-4,.5-1.6-.3-1.4-.8,0-1.5,0-.2,0-.4,0-.5l-.5-.5c-.4-.3-1.4-.4-1.5-.6s.8-1.9-.3-1.9-1.3,1.5-2.2,1l2-1.5c1,0,2,0,3,0-.3-1,.4-1.3,1-.5l.7.6c.4-2.7,3.1-.1,1.8.9q-.1,1.8,0,0c0-.8.8-.8,1,0,.4-.8.7-1,1,0,.2-.2.2-.3,0-.5-.5-.9-.7-1.6-.5-2-.6-.3-1.3-.5-2-.5.3,1-1.2,1.5-2,1-.7.7-1,.4-.5-.5-.4-.8,0-1.5,1-2Z"
          fill="#0352f4"
        />
        <path
          d="M368.6,230.8c-1.2-1.1-1.2-1-2.5,0l1.7-2.5.3,1.5,2.5-1c.1.1-.8,1.1-1,1.5s-.4.3-.5.5c-.1.4-.3.4-.5,0Z"
          fill="#0761f6"
        />
        <path d="M373.1,230.8c.2.2.3.3.5.5-.8,0-.8.3-2,0l1.5-.5Z" fill="#086ff5" />
        <path d="M369.1,231.3c.2,0,.7,0,1,0,0,.4-.5.4-.5.5h-.5c0-.1,0-.4,0-.5Z" fill="#0242f1" />
        <path
          d="M369.1,231.3c-.6.2-.5.5-.5,1-.7.4-1-.1-1.4.1s0,1-.8.8c-1.3-.3-1.5-1-1.8-2,1.5.8,2.8,1.3,4-.5h.5c0,.1,0,.4,0,.5Z"
          fill="#0242f1"
        />
        <path
          d="M365.1,225.8c-.1.2.3,1-.3,1s-2.1-.8-2.7-1-.4-.3-.5-.5c1.4-.2,2-.5,3.5.5Z"
          fill="#0470f2"
        />
        <path d="M364.6,229.3l-.5-.5c.2.2.4.1.5.5Z" fill="#045af5" />
        <path
          d="M368.1,223.8c.5,0,1-.1,1,.5v.5c1.6,0,1.8,1.3.5,2-.3,0-.9,0-1,0s-.2-1.5-1-1.5c0,2.6-2.5,2.8-1.5,0s0-.4,0-.5c.6-.9,1.2-.7,2-1Z"
          fill="#0361f7"
        />
        <path d="M368.6,226.8l.5,1.5c-1.4,0-2-1-.5-1.5Z" fill="#0361f7" />
        <path
          d="M370.6,226.3c.4.1.4.3,0,.5-.3,0-.7,0-1,0l.5-1.5-1.5.5c0-.6,0-.8.5-1,0-.3.2-.5.5-.5.1-.4.3-.4.5,0,.4.7,1.1,1.1.5,2Z"
          fill="#023eef"
        />
        <path
          d="M374.6,223.3c.7.8,0,1.6,0,2h-.5c-.5.6-.9-.4-1-1,.1-.4.7-1.1,1-1.3s.4.3.5.3Z"
          fill="#065ff7"
        />
        <path
          d="M375.6,225.8s.4.2.4.3c0,.2-1.4.5-.9,1.7-.9-.2-2.4.5-2-.7s1.9-.2,2-1.3h.5Z"
          fill="#065ff7"
        />
        <path d="M368.1,223.8c.5-.2,1.1-.9,2-.5.1.3,0,.8,0,1h-1c-.4,0-.8,0-1-.5Z" fill="#077bf4" />
        <path
          d="M374.6,229.8c-.7.2-1.7-.1-2.5,0,0,0-.6,0-.5-.5,1.2-.3,2.2-.8,3,.5Z"
          fill="#046bf8"
        />
        <path d="M374.1,221.8c-.3.9-1.4.4-2,0,1.4-.8,1-.1,2,0Z" fill="#0b6bf9" />
        <path d="M373.1,225.3c.4-.2.6,0,.5.5-1.5,1.3-2.4-2-.5-.5Z" fill="#065ff7" />
        <path d="M374.1,225.3c-.2.2-.3.3-.5.5-.2,0-.4-.3-.5-.5s0-.8,0-1l1,1Z" fill="#0231e8" />
        <path d="M370.6,226.3c1.5,0,1.5.3,0,.5v-.5Z" fill="#1473fa" />
        <path d="M366.1,227.8c0,0,0,.3,0,.5-.9.1-1.8,0-2-1,.4,0,1.9.4,2,.5Z" fill="#0470f2" />
        <path d="M354.2,225.3l-1.5.5c.1-.3.4-.9.5-1,0,0,.6,0,1,.5Z" fill="#023be8" />
        <path
          d="M363.1,220.8l1,.5c0,0,.2.9-.2,1-1.9,0-1.6-1.2-1.8-1.5h.5c.2,0,.3,0,.5,0Z"
          fill="#0474f7"
        />
        <path
          d="M362.1,220.8c.8.7,1.4.9,2,.5-.2-.3.1-.5,1-.5.9-.4,1.1-.3.5.5-1.3,0-.3,2.5-1.2,2.5s-4.1-1.5-4.2-1.7l1.5-1.7c.6-.4.9-.2.5.5Z"
          fill="#0464f7"
        />
        <path
          d="M364.6,217.3c1.1-.2,0,1.1,0,1-.2-.3.8-1.7,1.5-1l.5.2c.6-.7,3.8-2.2,4-.7.8.4,1.1.7.5,1.5,0,.1,0,.8,0,1s-.4.4-.5.5c-1.1.3-3.7.9-1.6-.4s1.1,0,1.6.4c1.9,2-.2.4,0,1.2s.8.9,1,1.3c.3.7.5,1.4,1,2-2.4.9-1,0-1.9-1.9s-.9-1.1-1.4-1.6c0,1.9-2.7-.3-2.7,1.5-.5,0-.6-.6-.5-1,.4-.5,0-.7-1-.5-.7.2-1.3.2-2,0-.1.4-.3.4-.5,0-.7-.4-1-.9,0-1-.6-.7-.3-1,.5-.5.4-.6.4-1,0-1-.8.9-2.5,1.6-2.5,0-.9-.7-.7-1.2.5-1,0-1.7,3.5-1.9,3.5,0Z"
          fill="#0464f7"
        />
        <path
          d="M363.1,218.3c.8,0,.4.5,0,1-.2.1-.3.5-.5.5-.2.2-.7.4-1.5.5-.4,0-1.4.1-1.5,0-.1-.2,0-1.5,0-2,.3-.9.7-.9,1,0,2,.5.5-.4,1.3-.5s.9.4,1.2.5Z"
          fill="#036ef7"
        />
        <path d="M365.1,220.8c0,0-1,.5-1,.5-.4.8-1.3.4-1-.5,1.3-.2,1.3,0,2,0Z" fill="#0355f3" />
        <path
          d="M365.1,220.8c.2,0,.8-.8,1.5-.5.2.1-.5.7-.5,1h-.5c0-.4-.1-.5-.5-.5Z"
          fill="#0355f3"
        />
        <path
          d="M369.1,214.3c1.2.5,1.2,1.5,1.5,2.5.6,0,1,.3,1.5.5l-1,1c-.4-1-.3-.8-.5-1.5-.7,0-2.4.6-3.5,0l.3,2.5c-1.1-.6-1.5-.5-1.3-2-.4-.1-.4-.3,0-.5.5,0,2.2-.4,2.5-.5.2-.5,0-.6-.5-.5-3.2-.7.4-1.1,1-1.5Z"
          fill="#0354f4"
        />
        <path
          d="M370.6,219.8c-.8.6-1.6.6-2.5,1,0-1.1,1.1-1.4.5-2.5,1-.2,1.4.9,2,1.5Z"
          fill="#0354f4"
        />
        <path
          d="M365.6,216.8c.2,0,.3,0,.5,0v.5l-1.5,1c0-.3,0-.8,0-1v-.5c.2-.7.6-.7,1,0Z"
          fill="#0e8af1"
        />
        <path d="M363.1,219.3v-1s.2-.4.3-.4c1.3.6.5.8-.3,1.4Z" fill="#0245e9" />
        <path d="M365.6,218.8c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#0355f3" />
        <path d="M369.1,224.8v-.5c.2,0,.3,0,.5,0l-.5.5Z" fill="#0352f4" />
        <path d="M374.1,214.3l-1.5,2.5c.1-2.2-1.2-.8-.5-2.5.8.5,1.3.1,2,0Z" fill="#024aec" />
        <path d="M374.1,216.3l.5-.5s-.5.5-.5.5Z" fill="#055bf6" />
        <path
          d="M216.2,372.2c1.2.3,1.9.2,2.9-.9,0-1.6.8-.4,1.4.7,1.2-.4,2.1-.5,2.7-.4,1.6.2.4.6.5,1l-.2.7c-1.2-.2-2.2,0-2.8.8-.1.1-.9-.1-1,0-.3.3.9.8,1,1s0,.7,0,1c.2.9.9,1.3-1,1.5,0-.2,0-.3,0-.5-.2-.2-.3-.2-.5,0l-.5.5c-.1-2-1.4-2.5-2.2-3.5s-.2-.9-.3-1c0-.3,0-.8,0-1Z"
          fill="#023eb0"
        />
        <path
          d="M218.2,369.7c1.7.9,3.2-1.9,3.5,1-2-1.2-2.5,1-.7,1s1.2-2.2,2.7-2c-.1.6,0,1.5-.5,2s-3,.8-3.2.9c-.6.5-.3,1.6-1.1,2.1-1-1.3.8-2.3.7-3.5-1.5.7-1.7,2.9-3.5,1,.3-.9,1,0,1.9-.4,2.1-.8.3-1.3.1-2.1Z"
          fill="#034dc1"
        />
        <path
          d="M223.7,372.7c0,.2.8.8.5,1.5-1.2-.1-2.3-.6-3.5,0,0,0-.2-.7.4-1s1.9-.4,2.6-.5Z"
          fill="#0450c5"
        />
        <path d="M221.2,375.2h1c.1.4-.5.4-.5.5l-.5-.5Z" fill="#023aad" />
        <path
          d="M232.2,325.2c.8,2-.1,1.8-.5,2.5-1.6.3-.8-.5-1-1,.3,0,.9.1,1,0,.2-.2-.4-1.5-.5-2h.5l.5.5Z"
          fill="#0237de"
        />
        <path
          d="M231.7,328.2c.1.2.6.2,1,1.5l-.5,1c-.1,0-.4,0-.5,0,.6-2-2.2-1.2,0-2.5Z"
          fill="#0237de"
        />
        <path d="M218.2,350.7c.2-.2.8.5.2.5s-.4-.4-.2-.5Z" fill="#012ba1" />
        <path
          d="M220.2,354.7c-.6,0-.7.2-1,.5.2.6.6.8,1,.5.9.9.9,1.2,1,2.5-.2,1-.8,1-1,0-.5-.8-.6-.5-.5,1,.5.1.4.6-.2,1.2.6,0,.4,1.6.3,2.1s-3.9,1.8-3.6.6q-.8-1.1,0,0c.8.6.5,1.1-.5,1,.2,1,.7,1.7,1.5,2,.4-.6.4-.8,0-.5-.8.9-1.3-.2-1-1,.9-3.3,6.5.3,3,1.5-.4.2-.4.6-.5,1v.5c0,.3,0,.7,0,1s-.7,0-.5,1c2.4.6,1.3,1.5-.4,2.7l-1.6-.2c.5.7.5,1,0,1-.1.4-.3.4-.5,0-2.9,0-2.1-2.9-1.2-4.7l-.3-.3c-1.5-.2-1.6-2.6-2-3.6s-2.1-.2,0-2.1,1.4-.6,1.5-.7c.5-.4-1.6-.5-1-1.5,1-3.3,0-2-1-3,1.7.6,3.3-1.5,3.5-1.5s2,.7,3,0l-.5-1.5c1.1-.4,1.8.3,2.5.5Z"
          fill="#0238af"
        />
        <path
          d="M221.2,358.2c0,1.8-1.1,1.5-1.5,2.5.7,0,1.3,0,2,0,.2.2.3.3.5.5l.5.5c-1,1.6-.9-1-2-.5-.4.5-.4.9,0,1,.2-.2.3-.2.5,0,.9,1.4,0,1.9,0,2.7s1.2,0,1,.8l-2,.2,2,1.3-3,.5c.3-.6,0-1.1,0-1.5s.5-.6.4-.7c-.2-1-2.5-1.5-3.4-.8-.4.1-.6,0-.5-.5.1-.3.4-.9.5-1h-1s0-2,0-2c1,.3,1.1,1.1,1,2,.4-.3,1.5.9.5-1.5l2.5.5c-.2-1.4,0-1.9.5-3,0-1,.1-1.3.5-1,0,0,.7,0,1,0Z"
          fill="#0240bb"
        />
        <path d="M220.2,355.7c.3,2.2-2.1.5-1-.5.3.2.8.3,1,.5Z" fill="#012da6" />
        <path
          d="M216.2,364.7c.3.4.4.9,1,1,.3.2.3.3,0,.5-.5.6-.5,1.2-1.5,1,.9-1.6-.7-1.5,0-3,.1.2.4.3.5.5Z"
          fill="#0452be"
        />
        <path d="M219.7,359.2c.4-1.2-1.2-1-1.5-2,2.4-.5,1.8.7,2,1,0,.5-.4.7-.5,1Z" fill="#0244c4" />
        <rect fill="#00208d" height="1" width="2" x="214.7" y="357.2" />
        <path d="M217.2,366.2v-.5c0,0,.1-.4.2-.5.9.6,0,.8-.2,1Z" fill="#0240bb" />
        <path d="M218.7,367.7s-.1,0,0-.5v.5Z" fill="#0241c1" />
        <path
          d="M231.7,315.3c.5,0,1.3,1.1,2,1,.2,1-1.2.3-1.5.5-1.1.9,1.8.9,1,2s-1.8-.4-.5,1.5c.4.1.4.3,0,.5-.4,0-.9-.6-1.5-.5-.2.7.6.5,1,1,.4.2.4.3,0,.5l.5.5c.7.9.4,1.2-.5.5-.2.3-.3.3-.5,0-.4.3-.4,1.1-.7,1-.4-.3-.7-1.1-.8-1.5v-.5c0-.6.5-1.2.5-1.3,0-.1-1-.3-1.5-1.7.1-.4.3-.4.5,0,.2.3.4.3.5,0-.5-.2-.8-.5-1-1,0-.5,0-1,0-1.5.2,0,.4.5.5.5l1-.5c.4,0,1.3.1,1.5,0s-.5-.8-.5-1Z"
          fill="#012ee0"
        />
        <path
          d="M229.2,317.8h1.5c0,0-.4.8-.5,1-.1.3-.3.3-.5,0h-.5c-.3-.9,0-.8,0-1Z"
          fill="#024aee"
        />
        <path d="M230.2,322.2c-.1-.7,0-.2,0-.5v.5Z" fill="#024aee" />
        <path d="M229.7,316.8c.2,0,.7-.4,1-.5l-.7,1-.3-.5Z" fill="#024aee" />
        <path d="M232.7,322.2c-.2-.1-.4-.3-.5-.5.4,0,.5.1.5.5Z" fill="#024aee" />
        <path d="M231,321.2c.3.2.3.3,0,.5v-.5Z" fill="#024aee" />
        <path d="M231,318.8c.3.2.3.3,0,.5v-.5Z" fill="#024aee" />
        <path d="M229.7,318.8h.5c0,.1,0,.4-.2.5l-.3-.5Z" fill="#0230d8" />
        <path d="M232.2,325.2c-.3,0-.4-.2-.5-.5.3,0,.4.2.5.5Z" fill="#0347e1" />
        <path d="M238.2,324.7l-.3.5-.7-.5c.2,0,.8,0,1,0Z" fill="#024aee" />
        <path
          d="M345.2,211.3c1.6.3,1.7,0,1.5-1.5l-1.5.5,1-2c-1.7.2-2,0-2.5-1.5.9-.4,1.5,1,1.8,1s2.3-2.4,1.8-3l2.5,2c-.7-.7,0-1.9,0-2-.4-.3-2.1.6-2-.5l2.5-.5v2.5s1.5-1.5,1.5-1.5c-.3.7.5,2.5,1,3,.7,1,.7,1.7,0,2,.2.3.7.7,1,1-.3.8-1.3,1-3,.5,0,.2,0,.4,0,.5.6,1,.3,1.3-.5.5q-.5-.8,0,0c.6-.2,1.1.4,1,1,.1,0,.4,0,.5,0,.9,1.1.3,3.3-.3,4.5l.8,1.5c1.1.1,1.9.4,2.5,1v.5c-.3.3-.3.7,0,1v.5c-.6,0-1.8,0-2,0l-.5.5c-.1,0-.5.4-.5.5h-.5c-.4-.9-1-1.4-1.8-1.4l-.2-.6-.5.5c-.1.4-.3.4-.5,0-.1.3-.3.3-.5,0-.1.4-.3.4-.5,0,.8-1,1.7-1.1,3-1l-1.7-1c.3-1.7-1.6-1.9-2.3-.5.1.3.6.9.5,1-.7.1-1.4-.4-2-.5h-.5c0-.3,0-.8,0-1,.2-.6.3-1.3.3-2.1-1.1-.3-1.3-2-.8-2.9-1.2-.7.2-3.1,1.5-2q.4.7,0,0c-.4-.1-.4-.3,0-.5Z"
          fill="#0484f8"
        />
        <path
          d="M346.2,219.3c-.2-.5-.7-.8-.5-1.5.8.2,1.7-.5,2.2-.5s.2,1.8,1.3,1-.8-2,.2-2.5c1.3,1.7.8,2.9-.7,4l1.5,1c-.1-.9-1.6,0-2-1l-1-.5c-.2,0-.7,0-1,0Z"
          fill="#0368f6"
        />
        <path
          d="M350.7,211.3c1.3-2.4,1.6,0,1.7,0l1.3-.5s.6,0,.5.5c-1.7.9-1.8.9-3.5,0Z"
          fill="#0368f5"
        />
        <path d="M352.7,207.8c1,1,.8,1,2.5,1.2l-2.5.7c-.3-.5-.4-1.5,0-2Z" fill="#1291fa" />
        <path d="M351.2,213.3c-.6-.1-.7-.5-1-1,.4,0,.6-.1.5-.5.1.3,1.5.4.5,1.5Z" fill="#034fe9" />
        <path
          d="M345.2,216.8c-.4-2.8,1-.9,2.2-1s.2-1,.3-1c.3-.2,1.7.9,0,1.7s-1.8,0-2.5.3Z"
          fill="#0367f6"
        />
        <path d="M349.7,209.8c-.8,2.3-2.6,2.6-2.5,0h2.5Z" fill="#0268ee" />
        <path d="M350.6,208.8c-.4.3-2,.1-1.5-.7l1.2-1.2c.9.1.5,1.8.2,2Z" fill="#0271f6" />
        <path d="M347.2,213.3c.8.8-.6,2.2-1.5,1.5s1-2,1.5-1.5Z" fill="#0367f8" />
        <path d="M350.7,213.8c-.2.7-.8,1.1-1.5,1v-1s1.5,0,1.5,0Z" fill="#036cf6" />
        <path d="M354.7,220.8v1c-1.5.3-1.6-1.3,0-1Z" fill="#0364f6" />
        <path d="M345.2,211.8c0,0,1.1.6,1,1-1,.5-1.3-.8-1-1Z" fill="#035df4" />
        <path d="M350.2,212.3c-.5,0-1-.5-1-1,1.6-.3.8.6,1,1Z" fill="#0ea3f8" />
        <path d="M348.2,206.8l-1,1c-.1-1,0-1.1,1-1Z" fill="#0163f2" />
        <path d="M348.4,208.8c.3.2.3.3,0,.5v-.5Z" fill="#0268ee" />
        <path d="M348.7,221.8l.5-.5c0,0-.3.5-.5.5Z" fill="#037df9" />
        <path d="M347.7,221.8c.2,0,.3,0,.5,0l-.2.5-.2-.5Z" fill="#037df9" />
        <path d="M352.2,222.8l.5-.5s-.3.4-.5.5Z" fill="#037df9" />
        <path
          d="M353.2,224.8c-.2-.2-1.2-1.4-1-1.5.9,0,1.9-.1,2.5.7.1.3-1,.3-1.5.7Z"
          fill="#037df9"
        />
        <path
          d="M320.7,153.8c1.1,0,.9.3,1.5,1,.6,0,1.3,0,2,0,1-1.4,1.3,1,1,2,.4.1,1.5.4,2,.5.6.4.6,1.1,0,1.5-.1,2.4-1.2,1.7-1.9,0-.6.9-2.1-1-1.6-1.2.7-.3.2,3.2-2,2.7-2.5,1.8-.7.3-2.5-.5-.1.8-.8.8-1,0,0-.5,1.2-1.2-.5-1-.5-1.1-1.1-3.5,0-4,.6-.3,1.3.5,1.5.5.4.7,1.3.5.5,0v-1c-.2-.8.4-1.3,1-.5Z"
          fill="#05abfa"
        />
        <path
          d="M321.7,160.3c.2-.2,1.5-1.2,1.5-1.2-.4-1.6-2.7,1.3-2-.5s1.6-.8,1.7-.9c.4-.3,0-1.6,1.2-.6s2.4,3.9,3,1.7c1.7.2,1,1.8.1.4.9.5,1.4.3,1.4-.4l.3-.5c1.2-.3.5.6.7,1,1.4.6,1.4,1.4.4,2.5s-4.9.7-5.4,0l2-.5c.2-1.9-2.1,0-1.5-2.5-1,1-1.8,2.4-3.5,1.5Z"
          fill="#039af8"
        />
        <path
          d="M330.2,159.3c1.7-.3,2.7.7,3,3,.1.7.8.3,0,1-1.2.3-2.3.3-3.5,0-.3-.2-.4-.9-.9-1-.7-.1-2.7.3-3.6.5s0-1.1-1,.5l-.5-1.5c.3,0,.7,0,1,0,1.9,0,6.6-.1,5-2.5,0,0,.4,0,.5,0Z"
          fill="#04aafa"
        />
        <path
          d="M319.7,155.3c.4,0,2.7-.5,2.5,1.3s-1.3-.5-1.5-.5c-.4-.3-3.2,1.1-1.5-.7.2,0,.3,0,.5,0Z"
          fill="#0293fa"
        />
        <path
          d="M315.7,147.8c-.5,0-1,.2-1.5.5-1.1.4-1.4.2-1-.5.4-.3.9-.4,1-.5-.1-.5,0-.6.5-.5.1-.2.4-.3.5-.5.6.3.4,1.3.5,1.5Z"
          fill="#0392fa"
        />
        <path
          d="M315.7,147.8c1.9-1.6,3.5,1.2.7,2.2-1.3,1.2-.2,2,1.2,2.2v.6c1.2-.1,1.7.4,1.6,1.5.1-.4.3-.4.5,0,1.3.2,1.3.6,0,1-.1.4-.3.4-.5,0-.6,1-1.3.5-1.5-.5-.7.4-1.6,0-1.1-.8l1.1,4.8c1.3-2.1,2.9,1,.5,1,.3.3.7.3,1,0,.4-.7,1.3-.5,2.5.5l1.6-.5c.5-1.7,1.9-2,2.3,0,3.6,1.1,1.7,2-1,2.1-.2.9-.6.8-1,0-.5-.4-.7-.1-.5,1,0,2.8-1.8,2.1-3.5.7-.1-.2,1.1-.4,1.5-.7.7-.4.6-.7-.5-1-.3,0-.6.6-2,1-1.5-.2-2.8-.2-4,0-.4-.1-.3-.3-.5-.5-.7-.2-1.3-1-2-2.5-1.6-.5-1.7-1.4-2.8-2.5.8,3-1.5.1-3.7,1.5.3-1.2,2.9-1.5,3.5-2,1.6-1.5-.9-.5-.9-.6-1.6-1.8.5-3.6-2.1-2.4l.5-1.5c1.9,2,3.5-1.3,5,1.5-.3.8-1.1.7-1.5,0-.6,0-1.8,0-2,1,2.1,0,2.2,1.2,2.5,3,3.2-1.2,2.9-4.4,0-5.7l1.5-1.7c0,0,.4,0,.5,0,.1-.7,1.2,0,1.5.5s-3.3-2.4,0-2.5c.2-1,1-1.5,1.5-.5Z"
          fill="#04b1fb"
        />
        <path
          d="M312.2,159.8c.4.1,1,0,1.5,0-.9,1.9.1,1.3.3,1.6s.2.8.2.8c-.2.2-.4.3-.5.5h-.5c-.1-1-.7-2.1-1-3Z"
          fill="#0393f8"
        />
        <path
          d="M323.7,161.8c1.5.1,1.6.6.5,1.5-.3-.1-.7-.4-1-.5,0-.2-.7-.9-.5-1.5.1-.2.7.5,1,.5Z"
          fill="#0394f6"
        />
        <path
          d="M316.7,144.8l1.1.7c1.5-.4,2.3-.1,2.4.8.9,1-1.8,3.5-3.1,4,0,.7,0,1.2.6,1.5.4.1.4.3,0,.5.4.1.4.3,0,.5-.4-.3-1.4-.2-2-.7s.6-2.2-1.5-2.3c.4-1.9,2.1.6,3-.5s-1.4-1.4-1.5-1.5c-1.1,0-1.2-.6-.5-1.5.2-.4.4-1.9.5-2s.8.5,1,.5Z"
          fill="#039efa"
        />
        <path
          d="M317.7,154.8c0,.2,0,.8,0,1.2.3,1.3,1.4,1.2,0,2.8-.3,0-.8.8-1.5.5-.2-1.6,1.4-4.4-.5-4.7l1.5-1.3c-.2.7.4,1.1.5,1.5Z"
          fill="#0391f5"
        />
        <path
          d="M314.2,148.3c-.3.2-.5.6-1,.5.1,1.3,1.5,1.9,1.5,3.5h-2s1.5-1.5,1.5-1.5c-.5,0-1.1-.2-1.5-.5-.3-1.7-.6-1.5.5-2.5l1,.5Z"
          fill="#039cf9"
        />
        <path
          d="M319.7,152.8c-.3.5-.5,1-.5,1.5-.4-.2-.8-1.1-1.5-1.5v-.5c.5-.3,1.7,0,2,.5Z"
          fill="#05abfa"
        />
        <path d="M319.2,159.8c.3,1.5-1.3,1.6-1,0,.3,0,.8,0,1,0Z" fill="#0581ea" />
        <path
          d="M331.2,164.8c0,.2,0,.3,0,.5.2.2.2.3,0,.5-.2.2-1.2,1-1.2,1-1.8,0,0-1.2.2-1.5.3-.4.3-.7,0-1h-.5c0-.3,0-.8,0-1,1.6-.3,2.9,0,1.5,1.5Z"
          fill="#037cee"
        />
        <path d="M337.2,161.3c.4.1.4.3,0,.5-.6,3.2-4.1,0,0-.5Z" fill="#0488f3" />
        <path
          d="M333.2,163.3c-.6.6-1.6.6-2,1.5-.4-1.8-.9-1-1.5-1.5.3-.7,2.7-.5,3.5,0Z"
          fill="#039af8"
        />
        <path
          d="M339.7,162.3c0,0,0,.3,0,.5-.4,0-.5.1-.5.5l-1-.5c0-.3.4-.7.5-1,.2,0,.4,0,.5,0l.5.5Z"
          fill="#038ff9"
        />
        <path d="M330.2,165.3v-1c1.1.4.4.6,0,1Z" fill="#0391f6" />
        <path d="M338.2,161.8h-1v-.5c.2,0,.3,0,.5,0,.2,0,.4.3.5.5Z" fill="#038ff9" />
        <path d="M331.2,165.8v-.5l.4.3c0,.2-.3.1-.4.2Z" fill="#039af8" />
        <path
          d="M305.7,131.3c.3,0,.9,0,1,0,0,.2,0,.4,0,.5.5.3.6.6.5,1,0,.1,0,.3,0,.5.8.3,1.4.8,2,1.5.8,1.2.3,1.5-1,1-.1.4-.3.4-.5,0-.2,0-.3,0-.5,0-.5.1-.6,0-.5-.5l-.5-.5c-.6-.7-.6-1.3-2-1,.7-.6,1-1.1,1-1.5-2.2.9-.8-3.3.5-1Z"
          fill="#06befc"
        />
        <path
          d="M322.2,173.3c.8.2,1.3.7,1.5,1.5v.5c-1,0-2.4,1.1-2.5,1s.1-.8,0-1c1.5-1,.8-.6,0-2,.3,0,.7,0,1,0Z"
          fill="#038df9"
        />
        <path d="M322.2,173.3c1.6,0,1.6-.2,1.5,1.5-1.7.2.2-.9-1.5-1.5Z" fill="#05a4fb" />
        <path
          d="M340.2,189.3c.5.7.5,1.6-.5,1.5,0,.2,0,.3,0,.5h-.5l-.5.5c-.9.1-2,0-3,0,.6-2.8,1.9-3.2,4.5-2.5Z"
          fill="#0592fa"
        />
        <path
          d="M340.7,188.8c.5-.3.7,0,.6.8,1.3.2,2.1,1,1.4,2.2.5.6.2.8-.5.5-.6.4-1.1.4-1.5,0,0-.7-.3-1.3-1-1.5.2-.5.2-1,.5-1.5s.3-.3.5-.5Z"
          fill="#0487f8"
        />
        <path d="M337.7,195.3c.4,0,.9-.2,1,.3.4,1.2-.7.6-1,.7v-1Z" fill="#0267f0" />
        <path d="M338.7,191.8l.5-.5c0,.2-.3.5-.5.5Z" fill="#0487f8" />
        <path d="M339.2,192.8c0,0,.5-.5.5-.5l-.5.5Z" fill="#0592fa" />
        <path d="M338.2,192.8c.1,0,.4,0,.5,0l-.2.5-.2-.5Z" fill="#0487f8" />
        <path
          d="M329.7,202.3c.7.1,1.3.5,2,.5-.7-2.4.7-2.7,1.8-.8s.1,1.2.2,1.3c.2.3.9-.5,1-.5.4-1.2,2.3.4,2,1.5,2.1-1.4,3.2,1.6.5,1.5q-1.1.3,0,0c.8-.3,1-.2.5.5,1,.2.6.9,0,1.5-.6.4-1.4.6-2.5.5.8.4.3.8-.5,1-.2.9-.6.8-1,0l-1.1-.4c.3-1.4.2-2.4-.4-3.1-1-.1-1-.8,0-1q.7-.3,0,0c-.3,1.3-1.1,1.1-1.5,0,0-.6-.3-.5.5-1.5l-3.2,1c-1.2-.7-.2-1.2-.3-1.5.4-.5.9-.9,1.5-.5h.5Z"
          fill="#0382f9"
        />
        <path
          d="M335.7,201.8c.6-.1,1.2.4,1,1,.2.1.3.4.5.5,1.2.7.8,1.3-.5,1-.6-.4-.6-1.6-2-1.5-.1-1.1,0-1.1,1-1Z"
          fill="#0470f0"
        />
        <path d="M329.7,202.3s-.5.6-.5,0c.2-.1.4-.3.5-.5v.5Z" fill="#0389f9" />
        <path
          d="M333.7,209.3c-.1.7-.8.7-2,0-.6.3-1.1,1.1-1-.2l2-1.7c-3.9,1.6-2-1.1-1.5-1,.3-.2.6-.3,1-.5,0,0,1-.6,1-.5l.5,4Z"
          fill="#048dfa"
        />
        <path
          d="M332.2,204.8c0,0,0,.7,0,1-.1.2.1.9,0,1-.3.3-.9-.5-1-.5-.2-.1-.4-.5-.5-.5,0-.3,0-.7,0-1,.5,0,1.1,0,1.5,0Z"
          fill="#0262f0"
        />
        <path
          d="M339.2,205.8c.6.5.3,1.7-.5,1.5-.3.2-.8.3-1,.5,0-.5,0-1,0-1.5.5-.3,1-.5,1.5-.5Z"
          fill="#0472f3"
        />
        <path
          d="M336.7,208.8c.5.9-.2,1-1,.5.2.9-.2,1-1,.5,0-.1,0-.3,0-.5s.4-.7.5-1c.2-.7,1.5-.2,1.5.5Z"
          fill="#048dfa"
        />
        <path
          d="M337.7,207.8s-.5.9-.5,1c-.1.4-.3.4-.5,0l-1.5-.5c0-.3-.1-.9,0-1s1.8.8,2.5.5Z"
          fill="#0270f7"
        />
        <path d="M337.2,205.8c-.8,0-.4.9-.5,1-.6.7-1.5-2.5.5-1Z" fill="#026af5" />
        <path d="M334.7,205.8l-1,1c-.1-1,0-1.1,1-1Z" fill="#048dfa" />
        <path d="M332.2,204.8c.1,0,.6-.7,1-.5.8.5-.9.4-1,.5Z" fill="#048dfa" />
        <path
          d="M340.7,172.3c1.5-.3,1.9.3,1,1.5.5-.5.7-.1.5,1.2,1.5,1.6.6,4.9-1,2.8l-.7.2c-.1,1.5-.8,2.1-1.8.8-.6,0-.7-.6-.5-1.5-.4-.3-.9-.5-1.5-.5.9,0,1.4.1,1.5.5.4,1.3,0,2-1.2,2.6.5.3.8.7.7,1.4.6.7.4,1-.5.5-.3.6-.8.7-1,0-.6,1.4-1.2,1.5-1.5,0-.8.3-1.4.6-2,1,0,.5-.6.7-1,.5-.6.3-1.4.6-2,0-.2,0-.4-.5-.5-.5-.7-.2-.8-.7-.4-1.5-1.6-.4-2.7-1.4-3.8-2.8.5-.2.9-.7,1.2-1.6-1,4-4,.1-.5-2,0-1,.5-.8,1,0,1.1.3.6,2.1-.5,2,.9-1.3,1.4-1.1,1.5.5q1.4,1.5,0,0c-2.5-2.3,3.5-5.8,3.5-2,0,.4.2.3.5,0-1.1-.7-.6-1.4.4-1.8.6,1.1,1.3,2,2.1,2.8.5-.3,1.4-.1,2.5.5-.9-.1-1.4-.4-1.5-1,.3-1.6.9-2.8,1.9-3.7,1,.4,2,.5,3.1.2.2-.4.3-.4.5,0Z"
          fill="#05a4fa"
        />
        <path
          d="M325.7,174.8c.9,1.6.3.6-.5,1.3-1.4,1.2.3,2.5.5,2.2-.2-1.2-1.1-1.6.5-1.5-.2.6,0,1.3-.5,2l2-.5c.3.6-2.1.6-1,1.5s3.5.9,4,.5l-1.5,2.5c-.6-.2-1.9-.3-2-1,.4-.7-.2-.7-1.7,0-.1-1.3-1.8-3.1-2.8-2l.5,1c.4.1.4.3,0,.5-1.7-.3-.7-.7-1.5-2-1.2-.3-1.9-.8-2-1.5.1-.4.3-.4.5,0,.6-1.3,2.1-2.1,4.5-2.5-2.4-2.6,1-3.5,1-.5Z"
          fill="#0391f7"
        />
        <path
          d="M336.7,176.8c1.9-.1,1.9-4,4-.5-2,.5-1.9-.7-2.5,1-.4-.1-1,.1-1.5,0s0-.4,0-.5Z"
          fill="#038cf7"
        />
        <path d="M333.7,177.3c.5.6-.2,1.6-1,1.7l1,1.2-2,.5c-.2-.6,1.1-4.5,2-3.5Z" fill="#0289f8" />
        <path
          d="M334.7,181.8c0,.3,0,.8,0,1-.6,0-1.4-.1-2,0-.5-.7-1.7-.2-1.5-1,1.3-.6,2.3,0,3.5,0Z"
          fill="#0385f3"
        />
        <path d="M327.7,177.3c1.2.6,2,.7,2,2.5-.8-.3-1.9-1.8-2-2.5Z" fill="#048ef7" />
        <path d="M331.7,183.3c-.9.5.3,1.3-2,.5v-.5c.3,0,1.2-.5,1.7-.4l.3.4Z" fill="#0385f3" />
        <path
          d="M335.2,175.8c.5.3,1.1.8,1.5,1-1.2,0-1.6-.3-2.5-.5,0-.3,0-.7,0-1,.7-.7,1.1-.5,1,.5Z"
          fill="#036be8"
        />
        <path d="M331.7,175.3c.3,1.4-1.2,1.5-1,.3l.5-.3c.1,0,.4,0,.5,0Z" fill="#0188f8" />
        <path
          d="M337.2,181.8c-.1.3,0,.8-.5,1-.1.4-.3.4-.5,0,0-.3,0-.7,0-1,.3,0,.7,0,1,0Z"
          fill="#0462ea"
        />
        <path d="M331.7,179.3c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#0289f8" />
        <path
          d="M341.2,177.8c-.9.7.2,2.2,0,2.5-1.7-.7-2,.5-2.5-1.5,1.6.2,1.1-1.8,2.2-1.5l.3.5Z"
          fill="#037af0"
        />
        <path
          d="M323.7,206.3c-.3-1.6.8-.5.9-.6s0-1.6,1.1-.9-.5.8-.5,1l-.5,1c0,.2,0,.7,0,1-.1-.2-1.2-.6-1-1.5Z"
          fill="#0389f9"
        />
        <path
          d="M336.7,210.3c-.3.2-.4.7-1,.5-.2-.4-.9-.6-1-1,.3-.2.7-.3,1-.5.9-.2,1.6,0,1,1Z"
          fill="#0484f8"
        />
        <path d="M333.7,211.8h-.5c0-.5.2-.7.5-1,0,.3,0,.7,0,1Z" fill="#0382f9" />
        <path d="M324.7,206.8v-.7c.1-.2.4-.4.5-.3.5.6-.5.9-.5,1Z" fill="#035ef1" />
        <path
          d="M298.7,97.9c1.4,1.6,3.4,1,5,2.5l-.2.6c-3.2-.6-2.6-.6,1.7-.1l1-.2c0,.6.2,1.1,1,1.7.7,1,1.3,3.5-.9,2.5-.4,1.1-.9,1-1.6-.5-.2-.9-.4-.9-.5,0-1.2-1.3-3.8,0-3,2-.3.2-1,2.8-2,2s-.2-1.4-.5-1.5c-1,0-1.2-.8-.5-1.5.4-.1,1,0,1.5,0,.2-.9-1.5-.6-2-1-.9.6-1.4.5-.8-.3-2.9-1.6-.4-3,1.3-1.7,2.4,1.4,2.6-1.2,0-1.5,0,.4-.7.4-1,0-.9-1.4-.1-4.9,1.5-3Z"
          fill="#09a8fa"
        />
        <path
          d="M292.7,96.4c.8.5.3.8-.5,1l1.5-1c3-2.1,1.6,3.1-.5,3.5v.7c1.7-.3,1.9.5.8,2.4.9,1.2,1,1.8.2,1.9l.2-.9c-1.4.4,0-2.9,0-3s3.5.2,4.2.4c0-1.9,2,.7,2,.8,0,1-1.7.9-2.5.2-.7,0-1.3,0-2,0,.3.4,1.2,1.8,1.5,2-.8.5-1.2,1.1-1.5,2-.1,1.8-3,1-3.5,0,.2-.6.7-1.1,1.5-1.5-.7,1-2.8,1.3-4,1,.3.7-.4.9-1,.5-.7-2.2,1.6-1.7.5-3,.2,0,.4,0,.5,0,1.4-.5,1-4.1.5-5,0-1,.4-1.4,1.5-1-2.3,1.5-1.9-2.4.5-1Z"
          fill="#05a3f9"
        />
        <path
          d="M289.2,106.4c.2,0,.7-.4,1-.5,1.1-.1,1.9,0,2.5.5.8,0,2.1,1.2,3.5,0-.1.3.2,1.3,0,1.5s-1.5,0-2,0l-.5-.5c-1.3-.1-2.1.4-2.8.5s-.2-.9-.5-1c-.6,0-2,.7-2.2.5s-.1-1.1-.5-1.5c.6-.2,1.3.5,1.5.5Z"
          fill="#0299f8"
        />
        <path
          d="M303.7,105.4c0,.8-.4,1.1-1,.5-.4.2-1.4.4-1.5.5,0-.3,0-.7,0-1l.5-.5c.6-.2.9.2,1.2-1,.7.4.6,1,.8,1.5Z"
          fill="#0497f6"
        />
        <path
          d="M303.7,105.4c.2.6.5.9,0,1.5-.1.8-.6.6-1,0,0-.3,0-.7,0-1,.3-.1.5-.6,1-.5Z"
          fill="#18c2f9"
        />
        <path
          d="M297.7,104.4c2.7-2.6,3.7,4.1.5,1,0,.6.1,1.1.5,1.5.8-.3,1.6-.4,2.5-.5.1-.8,1-1.4,1.5-.5.9.3.9.7,0,1-.6,1-.7,1.8-.5,2.5.4.1.4.3,0,.5.6,1.1-1.9.5-1.8.5,1.4-.9,4.3,1.9,1.3,2-.3.1-.4.3,0,.5,1.3-1.3,1.9.5.8,2,1.1.5,1.7,1.6,2.2,2.5,1.2,1.4,0,2-1,.5l-.4,1.1c-1.3-.3-3.2-.4-4.1.4-.2,0-1.7.3-2.4-.2-1.4-.8.3-1.9-3.1-.3l-.5-2.5c1.7.3,2.2,1.3,2-1-1.8,1.1-2.2-.4-2.5-.5-.4-.1-.4-.3,0-.5.2-.3.5-1.2.5-1.5-2-.9-2.7-1.5-2-2-.2-2.6.7-3.6,2.5-3,.1-.3.3-.3.5,0,.6-.4,1.3-.9,2-1.5-1.5-.7.7-2.2,1.5-2Z"
          fill="#04b6fc"
        />
        <path
          d="M298.2,113.4c1,.9-1.1,1-1,1.2.5.8,2.8,1.7,1.2,2.7-.9-2.4-1.5-.5-2.7-1.7.3-.5,1.7-2.9,2.5-2.2Z"
          fill="#03a5fc"
        />
        <path d="M303.2,107.9l-1,1.5c-2.6.1-.6-2,.5-2.5.6.1,1,.5.5,1Z" fill="#03a4fa" />
        <path d="M297.7,109.9c0,0,0,.7,0,1-4.2-.9-1-2.2,0-1Z" fill="#02a1fb" />
        <path d="M298.7,106.9c-.3-.1-1.1,0-1.5,0-.2-.7.3-1.3,1-1.5l.5,1.5Z" fill="#038ff7" />
        <path d="M295.2,110.4v1c-.7.2-1-.2-1.5-.7l1.5-.2Z" fill="#049cfb" />
        <path d="M294.7,114.4h-.5c-.2-1.1-.8-1.3.2-2l.2,2Z" fill="#04a0f8" />
        <path d="M301.7,112.4c0,.2,0,.3,0,.5-1.7.3-1.4-1.7,0-.5Z" fill="#24c5f8" />
        <path d="M294.2,107.9c-.2,0-.3,0-.5,0v-.5c.2,0,.4.3.5.5Z" fill="#05a3f9" />
        <path
          d="M312.7,123.9c.2.3,0,2.6,0,2.7-.2.4-1,.3-1,.6.6,2.5,3.7,2.1,1.5-.2l1.3-.5c0,2.4,1.2.7,3,1,.9.1-.9,2.1-1,2-.7-.4-.4-1.6-1.2-1.5v2.3s1,.7,1,.7c-5.4-2-1.7,0-2,.5s-.5,0-.8.2-.7,1.3-.9,1.3-1-1.3-1.2-1c.4,2.4-1.5,1.7-3,1.5.8.5.8,1.2,1,1.5-.9,0-1.8-.7-2-1.5.3,0,.7,0,1,0-.3-1.9,1-.2,1.8-.9s.7-1.5.7-1.6c.3-.2,1.1,1.4,2,1-2.4-2.1-.7-2.3-.7-3.2s-1.2-1.2-.3-2.2c-2.2-.2-.4,2.1-2,2.5l.5-3.5-1.5-.2c.9-1.6,2.5-.2,3-.3l.5-1c.1-.4.3-.4.5,0Z"
          fill="#03a3f8"
        />
        <path
          d="M312.2,116.9c.5.8-.4.8-.4.8.4-.6,1.1-1.2,1.4-.3.7-.5.9-.3.5.5.7,1.8,2.6,2.6,2.9,3.1s-.6.8-.4.9c.6.4,2.4-1.4,3-1s.2,1.1.5,1.5c-1.3-.2-1,.3-1,1.5.4.1.4.3,0,.5-.9.2-1.8.9-2.7,1-.3,0-.2-.4-.3-.5.1-.8,0-1.3-.5-1.5-1.5,0-2.1-4.4-2-5.5l-1.5,2.8,1,2.2c-.7.7-.9.4-.5-.5-1.5-1.1-5.8-2.6-3.7-4,.8,1.7,1.4,1.7,3.2,1.5-.5-2.6-1.7-.3-2.5-2l3-1Z"
          fill="#03a6fa"
        />
        <path
          d="M312.7,122.9c.1.1,3.3,1.8,2.5,2.5s-1.5-1.2-2.5-1.5-.3,0-.5,0c-.1.4-.3.4-.5,0-1.3-.8-1.8-1.3,0-1.5h.5c.2.1.3.4.5.5Z"
          fill="#0296f9"
        />
        <path
          d="M312.7,115.9c.9-1.9,3,1.5.5,1.5l-1.5.5c-.1-.1.4-.7.5-1s0-.4,0-.5.4-.3.5-.5Z"
          fill="#0293f7"
        />
        <path
          d="M307.2,117.4c0-.9.7-2,1.7-2,0,.4-.6,1.8-.7,2l-.5.5c0,0-.4,0-.5,0v-.5Z"
          fill="#038ef2"
        />
        <path d="M307.7,117.9l.5-.5c-.1.2-.4.3-.5.5Z" fill="#03a4fa" />
        <path
          d="M307.7,122.9c0-1.2.6-1.2,1,0,1.1-.3,2.6-.1,3,1,.4.3.3.7,0,1-1,1.3-1.4,2.4-2,4-1.5.3-.6-1.1-1.5-1,.5,2-1.4,2.1-1,.5-.5-.3.3-.6.3-.5-2,.9-2.9,0-4.3-1.5-.7-.1-.7-.9,0-1,0-.4.3-.4.5,0,.4.1.7,0,1-.5-.4-.1-.4-.3,0-.5.3,0,.4-1.5,2-.5l-.5-1.5c.7-.2,1.1.4,1.5.5Z"
          fill="#08b9fc"
        />
        <path
          d="M303.2,126.4c2.4,0,1.4,2.5,4.5,1,.3.8-.5.9-.5,1-1.3,1.1-2.2-.2-3.5-.5.1,1.4-.1,1.2-1,.2l1-.2c0-.4-.3-.7-.5-1v-.5Z"
          fill="#039ef8"
        />
        <path d="M303.2,125.4v1.5c-.2-.3-1.2-.5-1-1.5.3,0,.7,0,1,0Z" fill="#03aafb" />
        <path
          d="M311.7,122.4c-.6.6,0,1,0,1.5-1.2-.3-2-.7-3-1,.2,0,.4-.5.5-.5.7-.1,1.7,0,2.5,0Z"
          fill="#03a6fa"
        />
        <path
          d="M308.7,124.3c0,0-1.3-.2-.7,1-.4.8-1.2.1-1.3-.3-.3-1.5,2.5-2,2-.8Z"
          fill="#02a5fa"
        />
        <path d="M311.7,124.9c0-.3,0-.7,0-1,.2,0,.3,0,.5,0v.7c0,.3-.3.2-.5.3Z" fill="#04b0fb" />
        <path d="M303.7,125.4l1-.5c-.6,1.5-.9.5-1,.5Z" fill="#03aafb" />
        <path
          d="M293.7,118.9c.1-1.7,1.7-1.8,4.8-.5l.7,1c.6-1.1,1.5-.8,1.5.5-.8,1.1-.8,2.8,0,2.5-.2-1.3,1-1.7,2.1-1.9-.1-1.2,1-1.4,1.9-.6-.1-.4,0-.6.5-.5-.7-.6-.4-.9.5-.5,1.5-.1,2.1.4,2,2,1,.5,1.1,1.7,0,2-.7,1.3-1.1-.4-1-.4,1.9,1.4-.4,2.6-2,1.9-.4.5-1.2.7-1.5,0-.4-.4-1.2-.4-1.5,0,1.3.2,1.3.6,0,1,0,1.7-2,3-3.5,2.5-.7.5-1,.3-.5-.5-.4-.2-.4-.3,0-.5.6-.8-2-1.2-2,0,.7.3.9.8.5,1.5-.2,1.3-.6,1.3-1,0l-.5-.5c-.5,0-1,0-1.5,0-1.2,0-1.2-.4,0-1,0-.8-.6-1.5-1.5-2-.1.4-.3.4-.5,0-.8.8-.3,1.1-.5,1.5,0,.3-.2.5-.5.5-.1,1.2-1.2,1.4-1.5,0,0,0-.7-.6,0-1,.4-.2.5-.6.5-1,.2,0,.6-.8,1.3-.9,1.4-.3,2.8,0,4.2-.1.5-2.4-3.4,1.1-3-1.5,1.9.9,2.5-1.5,2.7-1.5.5,0,1.5,1.8,2.2.2s-.1-1.4-.4-1.5c-1.6-.9-1.5.5-1.7.6-.6.3-1.3,0-1.7.3-.8.5-.9,2.2-3.6,1.4.3-1.7,2.3-.3,2.5-.5s-1-1.7.5-2c.3-.6.8-.8,1.5-.5Z"
          fill="#03aafb"
        />
        <path
          d="M303.7,117.9c1.1.5,1.6,1,1.5,1.5-.1.2-.3.4-.5.5q-.2-.2,0,0c-1.6,1-2.1.5-4,2.5-1-.5-1-1.4,0-2.5-.5,0-1.1-.5-1.5-.5-1.8-2.3,1-.6,1.8-1.9,1.4,1,1.8.4,2.7.4Z"
          fill="#03a1fa"
        />
        <path
          d="M291.7,124.9c1.7-.8.4.7,2.5.5.3,1.1-.7,1.1-1,1.5l-1,.5c1-2.2-.2-1.2-.5-1.5-.4-.1-.2-.7,0-1Z"
          fill="#0392fa"
        />
        <path
          d="M295.7,126.9c-.2-.5-1.5-1.8-.7-2.5.5,1.5,2.4,1.2,3.7,2,.2.9-.7.3-1,.5l-1.7-.4-.3.4Z"
          fill="#0392fa"
        />
        <path
          d="M304.7,124.4v.5c-.3.5-.6.6-1,.5-.2,0-.3,0-.5,0-.2.9-.6.8-1,0-.2,0-.3,0-.5,0,0-.3,0-.8,0-1,1-.7,1.5-.7,1.5,0,.9-.1,1.4,0,1.5,0Z"
          fill="#0390f3"
        />
        <path d="M309.2,122.4c.7.5.5.6-.5.5-.3,0-.7,0-1,0v-2c.4.3,1.7,0,1.5,1.5Z" fill="#0291f7" />
        <path d="M299.2,124.8c-.4.3-2-.1-2-1,1.1-.8,2.7.3,2,1Z" fill="#0391f6" />
        <path
          d="M303.2,124.4c-.5,0-1,0-1.5,0,0,0-.6,0-.5-.5,1.5.2,1.7,0,1.5-1.5,1.2.4.8,1.1.5,2Z"
          fill="#07befc"
        />
        <path
          d="M300.7,119.9c.9-.5,2.3-1.2,2,.5-1.4-.4-3.1.4-2,2,0,0,0,.5-.2.5l-1.2-1.7c0-.2,1.2-1.1,1.5-1.3Z"
          fill="#05bdfc"
        />
        <path d="M307.2,120.9v1s-2,0-2,0c.3-1,1.1-1.1,2-1Z" fill="#04b3fb" />
        <path
          d="M294.7,127.9h-.7c-.5,1.3-.8,1.4-1.8.2,0-.5.9-.1,1-.2.9-.9,1.2-.1,1.5,0Z"
          fill="#0392fa"
        />
        <path d="M291.7,125.9h-.5c0-.3,0-.7,0-1,0,0,.4,0,.5,0,.6.2,0,1,0,1Z" fill="#036cec" />
        <path d="M290.7,126.9h-.5l.5-.5c0,.1,0,.4,0,.5Z" fill="#039ef9" />
        <path d="M304.7,119.9c-.2.2-.8-.5-.2-.5s.4.4.2.5Z" fill="#038ff5" />
        <path d="M292.7,130.3c-.1.4-.3.4-.5,0-.8,0-.6-.6,0-1,1.5-.5,1.8.2.5,1Z" fill="#0392fa" />
        <path
          d="M291.2,125.9c1,.5,1.2,2.9.5,3.5.5.4,0,.9-.5,1,1.4.2,1.6,2.1.5,2.5.4.3.6.3,1,0,.1-.4.3-.4.5,0,.3.4.7.4,1,0,.6-.5.5-.8-.5-1-.4.7-.7.4-1-1-.5,0-.4-.2,0-.5l.2-.7c3.2-1.2,4.4,1.8,5.3,4.7.9.2,1.2,1,1,2.4,1.1.3.3,3.1-.7,2.9-1,1.7-1.6,1.8-3.3,1.7l2-.5c1.4-1.6,2.1-1.6,2,0l.5.5c-.5.9-.1,1.7,1,2.5,1,.9.8,1.2-.5,1,.3,1.5,0,2.3-1.3,1.4l-.7.6c1,1,.3,2.1-1,1-1.3,3-4.2-5.4-4.2-5.9.2-1.2,1.4-.9,2.2-.6l-1.6.3c-.7-1.7-1.6-2.8-2.9-3.3l-.5-1.5,1.5-.5-2.5-.8c-.2-1.6,1.7,0,2-.2.7-.7-.7-1.2-1-1.5.8-.2.8-.5,0-1-.2-.1-.3-.9-.7-.9s-.9.9-1.3.9c-1.3-1.6-3.6-7.7-.5-6.5-.8-.6.4-1,1-.5.7.3.7.7,0,1,1.1,0,1.2.9.5,2.5,1.2-.3,1.4,0,.5,1-.2.2-.2.3,0,.5.6.4.7.4.5,0-.5-.1-.5-.3,0-.5-.2-.3-.4-.7-.5-1-.7-.6-.6-2,.5-1.5q.2.2,0,0c-.8-.7-.4-.8.5-1v-.5c-1-.2-.8-2.1.5-1.5.6.2.4.6,0,1Z"
          fill="#0392fa"
        />
        <path
          d="M290.2,132.8c.6.3.4.6,0,1,3-.4,2.3,2.9.5,4.5.4.1.4.3,0,.5-.2.6-.5.4-1-.5-.3-.3-.6-.7-1-1,0-.3,0-.7,0-1-.8-1.4-1-2.6-.5-3.5-.9-2.3,3.5-1.6,2,0Z"
          fill="#0972e8"
        />
        <path d="M290.2,132.8c.2.1,3,.5,0,1-.4-.4-.7,0,0-1Z" fill="#059bfa" />
        <path
          d="M292.2,130.3c.2,0,.3,0,.5,0,0,.2,0,.3,0,.5.7,1,.7,1.6,0,2-.2.4-.7.4-1,0,0-.3.4-.9.3-1.2s-.7-1-.8-1.3c.3-.6.7-.7,1,0Z"
          fill="#039ef9"
        />
        <path
          d="M291.7,125.9c1.2-1.3,2.3,0,.5,1.5s.7-1.2,1-.5c-.1.2.1.9,0,1-1,.5-.5.5,1.5,0,.7.2.5.5.5.5q-.5.6,0,0c.2,0,.7,0,1,0,1.7.2,2.4,1.2.5,1-.2.2-.2.4,0,.5,1.4-.1,1.7.2,1,1.5.6.3,1.3.8,1,1.5-.3.5-.4,1-.5,1.5-2.9-2.4-.5-4.8-5.5-4,0-.4,0-.9-.5-1-.1.4-.3.4-.5,0-.1-1.2-.4-2.2-.5-3.5.1-.4.3-.4.5,0Z"
          fill="#039ef9"
        />
        <path
          d="M294.2,132.8c0,.4.2,2.5-.3,2.5l-1.7-.5,1-.5c0-.5-.1-1.1,0-1.5-.4-.6-.2-.9.5-.5.8-.7,1-.5.5.5Z"
          fill="#059bfa"
        />
        <path
          d="M293.7,131.8c.2,0,1.4-1.2,2,.3s-.7.8-1.5.7c0-.2-.3-.4-.5-.5-.4-.1-.4-.3,0-.5Z"
          fill="#07adfc"
        />
        <path
          d="M290.2,126.9h.5c-.1.3-.3.7-.5,1s-.7.7-.5,1.5c-.1.4-.3.4-.5,0-.2-.7-.4-1.8-.5-2.5h1.5Z"
          fill="#0376f2"
        />
        <path
          d="M289.7,129.4l1.5-.5c.2.2-.9,1.3-1,1.5-.1.3-.3.3-.5,0-.1-.3-.4-.7-.5-1h.5Z"
          fill="#039ef9"
        />
        <path d="M293.7,131.8v.5c-.1.2-.5.4-.5.5h-.5c0,0,0-1.6,0-2,.2.2.7,1,1,1Z" fill="#027bf1" />
        <path
          d="M289.7,130.3h.5c0,.1,0,.4,0,.5-.2.3-.3.3-.5,0-.9-.2-1.8.6-1.5-1l1.5.5Z"
          fill="#016af1"
        />
        <path d="M295.7,137.3l-.2,1.5c-.5-.5-.9-.8-.7-1.5h1Z" fill="#0269ea" />
        <path d="M292.2,129.4v1c-.3,0-.7,0-1,0,0-.5.5-.9.5-1h.5Z" fill="#0475f8" />
        <path d="M290.2,130.8c0,0,.4,0,.5.2l-.3.3c-.5.2-.6-.5-.7-.5h.5Z" fill="#0264f0" />
        <path d="M292.7,132.8c-.1.7-1,.8-1,0,.3,0,.9,0,1,0Z" fill="#059bfa" />
        <path d="M290.2,127.9c.2-.2.8.5.2.5s-.4-.4-.2-.5Z" fill="#039ef9" />
        <path
          d="M300.2,133.3c.4-.5.8,0,1,.5-.6.9-.8,1.5-.5,2-1.4-1.7,1.2-2.7,1.6-.8,2.2-1.3,3.5-.8,3.9,1.3.1-.6.4-.8,1-.5,0-.5.3-.4.5,0l1,1h.5c-.4-.1-.4-.3,0-.5.3,0,.6-.2,1-.5.1-.4.3-.4.5,0,1.4,0,3.1,0,1.5,1.5.3.1.3.3,0,.5-.2.6-.2.8,0,.5.2-.6.6-.6,1,0l.5.5c1.3-1,2-.5,2,1.5,1.1,1.1-1.1,3-2.5,3.5-.4,1.3-.2,2.3.5,3,.6-.5.7-.2.5.5.2.5-.2.7-1,.5-.1.8-.3,1.6-.5,2.5-.2.4-.3.4-.5,0-.1,0-.4-2.2-1.5-1.5s0,.8-.3,1c-.7.4-2.8.9-3.7,1-.6-.4-.9-.4-1,0,.3.3.6.5,1,.5,0,.4-.2.4-.5.5-.3.3-.5.6-.5,1-.7.5-1.8,2.6-2.5,2s.1-.9,0-1c-.3-.7-.6-1.4-1-2,.2-.4.7-.7,1-1,.3-.4.3-.6,0-.5-.3.2-.7.3-1,.5,0-1.1-.2-1.8-1-2.5-.5.3-1.1.2-1-.5-.2-.2-.4-.2-.5,0,.9.2,1,.8,0,1-1.8-.4.5-2.4-1.5-2,0-.1-.8-.7-.5-1s2.3.3,2.5-1c.7-.1,1.1.2,1.4,1.1.4-.1,2.5-1.3,2.6-2.1-.3-1-.1-1.2.7-1.4-.9-2.1,1.8-3.3,2.8-1.6.2-.3.2-.7,0-1-1.3,1-2.4-.4-2-1.8-.2.6-.4.4-.5-.7-.5.4-1,.7-1.5,1,.7.7.4,1-.5.5.1.5,0,.6-.5.5-1.1-.1-1.9-1-.6-1.5.4-1-.4-1.5-1.4-2,1.7.2,1.8,3.2,1.7,4.7s-4.1,2.3-2.8.7l-.5-.4c-1.3-1.5-2,2-2.5,1.5.2-1.5-.8-.8-1.5-1,.7-.3,1.8-.5,1.9-.6.3-.2.2-1.5.7-1.8s2.3.1,1.4-1.1-.7.1-.8,0-.2-2.8-.1-3.4c-.6-.9-.7-1.5.5-1.5.4-.8,1.1-.1,1.5.5Z"
          fill="#03abfb"
        />
        <path d="M303.2,150.3c.2,0,0-.8,1-.5,0,.6-.7.7-1,1v-.5Z" fill="#058bfa" />
        <path
          d="M301.2,148.3c-.2.6-1,.6-1.5.5,0-.3,0-.9,0-1,.2-.3.3-.3.5,0,.2,0,.8.3,1,.5Z"
          fill="#026be4"
        />
        <path
          d="M300.7,135.8c0,0,.8-.2,1.1,0,2.7,1.9-.2,1.2.9,3.4.3.1.4,0,.5-.5.1-.1.5-.5.5-.5l1.5-1c1.6.2.6.5,1.3,1.4s1,.7,1.2,1.1c1.3.3,1.3.7,0,1-.1,0-1.5.4-2,.3-.5,2.4,2.4-.6,2,2.7l-1.2-1-2.2,1c-1,2.5-2.4,1.7-3.1-.5s1.1-1.6,0,0c1.2.5.8,1-.4.6-1.9-1.2-1,2.6-3,.2l1.5-3.2c1.4-1.3,0,1.3,1.2.5s1.8-1.7,1-2.5l-.2,1c-2,1-2.6-3,.5-2,.1-.8-.6-1.4-1-2Z"
          fill="#04b4fc"
        />
        <path
          d="M300.7,143.8s.4,0,.4-.3c0-.8-2.6-2.1,1.1-1.7l-1,1.5c2.3-.5.9,1,2,1.5l.3-3c.4,0,.7,1.6.7,2s.6.6.3,1-2.7,2.4-3,2.4c-.7,0-1.3-2-1.2-2.4s.4-.7.5-1Z"
          fill="#039ff9"
        />
        <path
          d="M315.7,140.3c.3,0,.7-.5.7-.5,2.1.5-.2,1.7-.2,1.8-.7.9-1.2,2.5-2,3.1-.6-.2-1-.5-1-1,.1-.2-.2-1.1,0-1.4,1-.8,1.5,1.2,2.4-2.1Z"
          fill="#039efa"
        />
        <path
          d="M312.2,137.3c1,.6,3.9.9,4,1s-.4,1.6-.5,2c-.3,0-.9.7-1,.5l.5-2c-.5,0-1.1.1-1.5,0l-.5-.5c-.3,0-.7,0-1,0v-1Z"
          fill="#0295f8"
        />
        <path d="M307.7,139.8l3-.5v1.7c0,.4-2.3-.2-3-.2,0-.3,0-.8,0-1Z" fill="#039afa" />
        <path
          d="M313.2,143.8c1.5-.2.8.4,1,1,0,.7-.2,1.4-.5,2-.6-.4-.9-.4-1.3-1.2-1-2.1.7-1.7.8-1.8Z"
          fill="#0392fa"
        />
        <path
          d="M309.2,136.8c.9.7,1.8.1,1.5,1.5l-1.7.5c-.6,0,0-1.6-.3-2,.1-.4.3-.4.5,0Z"
          fill="#04a7fb"
        />
        <path d="M305.2,137.3c.2,1.6,0,2-1.5,1,0-.4-1.7-1.5,1.5-1Z" fill="#028ef4" />
        <path d="M312.2,142.8c-.7,2.2-3.3,1.3-2,.2s1.6-.1,2-.2Z" fill="#0396f8" />
        <path d="M308.2,149.3c-.4-1.9.6-1.3,2-2,.2,1.2-1.1,1.6-2,2Z" fill="#0394fa" />
        <path d="M310.2,135.8c0,1.3,0,1.1-1,.5-.5.4-1,.2-1-.5l1-1c.3.4.7.7,1,1Z" fill="#04a7fb" />
        <path d="M309.2,136.3v.5h-.5c0,0-1.4.2-1-1,.2,0,.4,0,.5,0,.3,0,.7.4,1,.5Z" fill="#0490f5" />
        <path d="M312.2,138.3s0,.4-.2.5l-.3-.3.5-.7v.5Z" fill="#04a7fb" />
        <path d="M313.7,138.8c-.4-.1-.5-.5-.5-.5l.5.5Z" fill="#04a7fb" />
        <path d="M300.2,147.8c-.1,0-.5,0-.5,0l.2-.5.2.5Z" fill="#038df8" />
        <path d="M303.2,138.8l.5,1.5c-.5,0-.8-.6-1-1,.2-.2.3-.3.5-.5Z" fill="#0390f7" />
        <path
          d="M355.2,201.8c1,0,.5,1.8.3.9s.3-.4.7.1c0,0,.4.8.5,1,.2.3,0,4.6-.3,3.9s.8-2,1.3-.9c.6-.3,1.3-.5,2-.5.1-.1-.4-.7-.5-1-3.7-2.4,1.7-4.5,3.3-1.6,1.2-.3,3-.2,3.1,1.1h.6c.2-.2.2-.4,0-.5-.4-.1-.4-.3,0-.5.5-.7.8-.8,1,0,0,.5.7,1.6.5,1.9s-2.6.7-2,2.6c1.7.3.5-1.4,2.1-2.1s2,.3,2.9.2c.2,1-2.1,0-1.5,1.2s1.4.3,1.4.3c.2.3,0,1,.3,1.4.4.7,1.6-.8,1.2,1,0,.4-.3.4-.5,0-.5,1.4-1.5,1-1.5-.5-.4-.1-.4-.3,0-.5-.5,0-.9-.2-1-.5-.7.4-1.1-.3-1-2l-.5.5c.8-.1,1,.7.5,2.5,1.3.2,1.3.6,0,1-.5.1-1.4.1-2.5,0-.6,1.8-5,5.8-5.5,2.5-.8.8-1.4,1.8-2,3l-1-.5h-.5c-1-1.8,2,2,0,2.5-.7.8-1,.8-1,0-.4-.1-.4-.3,0-.5l-.5-.5c-.5.1-.6,0-.5-.5-.8-.4-.6-1.1.5-2h-.5c.2.5-.1,1-1,1.5-2.2.8-2-1.2-1.6-2.9h-.4c0,.4-.3.4-.5,0-.3-.5-.4-1-.5-1.5-.3-.2-.3-.3,0-.5l.7-.4c.9.7,1.6,1.1,2.3,0-.9.2-1.4-.1-1-1v-2c-.7.6-1.3.3-1.7-.9-1-.2-3.9-.2-4.1.9,1.1,2.4,1.4,6-1.7,3.5-.2.6-.6.8-1.3.6-.6,1.7-1.3,2-2.2.4v-1.5c-1.1-.9-1.4-.3-2.7-.1l-.3-.4c-.8-1.1-.3-1.6,1-1q1.2-.7,0,0c-1.3,1.2-2.1-.6-1-1.5.6-.8.8-1.4.5-2-2.5-2.1,1.5-3.1,2,0,.4-.7,1.2-.7,2.3,0l.2-1c-.9-.9-.9-1.4,0-1.5-.2-1,.2-1,.5,0,.9-.3,1-.3.5.5.4,0,.7,0,1-.5.5-1,1.7-1.2,3.5-.5.5-.7,2.2-.7,2.7,0,1.2-.8,2.3-1.1,3.3-.9Z"
          fill="#047af7"
        />
        <path
          d="M345.2,211.3v.5c-.6.5-1.6,1.1-1.5,2-.3,0-.8,0-1,0-.4-.2-.8-.8-1.5-1,.1-.1,0-.5.5-.5s.9.6,1,.5.2-1.9.8-2,1.4.5,1.7.5Z"
          fill="#0993fa"
        />
        <path
          d="M360.1,213.3c-.1.3-.4.7-.5,1,1.2.7.8,1.8-.5,2l-.2,1c-.6-.5-1.2-1-1.8-1.5,1.2-.8,2.3-1.4.5-1.7l.5-1.3c0,0,1.7.4,2,.5Z"
          fill="#0366f2"
        />
        <path
          d="M369.1,208.8c0,.3.3.5,1,.5v.5c-.6,0-1.1,0-2,0s-1.7,0-2.5,0c.1-.7,2.1-.9,2.4-1.6s-.4-.8-.4-.9l.5-.5c.4,0,1,1.7,1,2Z"
          fill="#0366f6"
        />
        <path
          d="M360.1,212.3c-.2-.2-.5-.6-.5-1-.9-.2-.3.8-.5.9s-1.1-.5-1.7-.5c-1,0-2,.7-2.7.3.8-1.4,1.5-2.1,3.3-1.6s0,1.5,2.2.4l-1-1.7,1-1.3c1.4-1.5.7,3,.5,3.5.6.7.4,1.1-.5,1Z"
          fill="#0366f2"
        />
        <path
          d="M354.7,214.8l-1.5-2c1.9.4,2.5.7,4.2-.5,1,.9-2.1,2.1-2.2,1.6-.2.2-.1.7,0,.9-.1.4-.3.4-.5,0Z"
          fill="#0367f3"
        />
        <path d="M360.6,211.3c3.1-.4,1,2.3-.5,1,0-.4.4-.7.5-1Z" fill="#0354ed" />
        <path d="M357.6,208.3c.8.7-1.1,1.6-2,1.5.1-.7,1.6-1.9,2-1.5Z" fill="#0366f2" />
        <path d="M365.1,210.3c-.3.4-2,.6-2-.5.8-.1,3.2-.9,2,.5Z" fill="#0366f6" />
        <path d="M364.6,206.3l-.7,2.5c-1.8-1.6,1.5-.2-.8-2.5h1.5Z" fill="#035fec" />
        <path d="M345.7,203.3l-.8,1.5c-.5,0-.1-.8-.2-1,.3-.1.7-.4,1-.5Z" fill="#0360f2" />
        <path d="M355.2,207.3c.2.2-.9,1.3-1.5,1-.2-.2.9-1.3,1.5-1Z" fill="#0259f2" />
        <path d="M370.1,209.3h-1.5c0-.4.5-.5.5-.5l1,.5Z" fill="#0375f8" />
        <path d="M367.6,207.3c0-.1.4-.3.5-.5l-.5.5Z" fill="#0375f8" />
        <path
          d="M339.2,205.8c2-.2.2,1.1.5,1.5s1.2-.3,1,.5h-2c0-.2,0-.3,0-.5s.4-1,.5-1.5Z"
          fill="#0791fa"
        />
        <path
          d="M339.7,209.3c.2-.3-.5-1.6,1.7-1s.3.9.4.9c.6.3,1.8-1.6,1.4,1.1-.9.2-1.2-.6-1.9-.9s-1.3,0-1.6-.1Z"
          fill="#068ef7"
        />
        <path d="M344.4,209.3c.3.2.3.3,0,.5v-.5Z" fill="#068ef7" />
        <path d="M337.2,208.8c-.1.3,1.1.3-.5,1.5l-1-1c.3-.2.7-.2,1-.5h.5Z" fill="#0272f6" />
        <path
          d="M341.7,210.8c.2.2.2.5,0,1,.4.1.4.3,0,.5.5.6.2.8-.5.5-1,.8-1.5.8-1.5,0-.6-.8-.7-.8-.5,0,.4.2.6,1,.5,2.5q1.6.4,0,0c-1-.8.2-2.4,1.5-2.5.7-.2,2,.3,1.5,1,1,1.2,3,3.9,1,5-2.2,2.2-1.9.2-2,0-1.2-.8-.9.9-1,1-.3.3-.8.7-1.5,1,.4,0,.4.3,0,.5l-3-1c-.3-.7,1.9-.4,1-1.5s-2.4-1.2-3-.5c0-.2-.3-.3-.5-.5-.7.7-.9.4-.5-.5-1.3-.2-2-1.3-.7-1.8-1-.8-.9-1,.2-1.7.2-.5.4-1.1,1-1,.3-.9.8-1.4,1.5-1.5.2-.4.3-.4.5,0,.5-.2.7,0,.5.5-.5.9,1.2,0,1.5-.5-.8-.6.3-1.6,1-1,1.7-.8,2.7-.6,3,.5Z"
          fill="#0484f8"
        />
        <path
          d="M343.7,213.8c0,1.3,1.4,2.8,1.4,3.9s-.8.9-.9,1.1h-.5l.5-2h-1.5c.6-1.1.4-1.9,0-3,.2-1.3.5-1.2,1,0Z"
          fill="#0367f6"
        />
        <path
          d="M340.7,219.8l.5,1h-1.5c-.1.4-.3.4-.5,0,0,0-.7-.3-.5-1,.5-.1,1.8.1,2,0Z"
          fill="#025cee"
        />
        <path
          d="M335.2,216.8c-3.9-3.3,1-1.9,3-2,.1.8-.8.3-1.2,1.1s-.3,1.3-.3,1.9c0,0-.8-.4-1-.5v-.5c0-1.5-.2-1.5-.5,0Z"
          fill="#0373f6"
        />
        <path
          d="M341.2,212.8c-.4.4-1.8,2.2-1.5,2.5-.1,0-.7.1-.9,0s.6-2.2.4-2.4c.1-.4.3-.4.5,0,.5,0,1.1-.1,1.5,0Z"
          fill="#026bf6"
        />
        <path d="M338.7,218.8c-3.1-.6-.3-1.3-.5-3l.5,3Z" fill="#0373f6" />
        <path
          d="M337.7,211.3c0,0,.2.7-.1.9-.5.4-1.8-.5-1.4,1.6-1.8.3-.8-1.4,0-2s1-.4,1.5-.5Z"
          fill="#026bf6"
        />
        <path d="M339.2,212.8c0,0-1.9.2-.7-1.5l2,.5-.7,1h-.5Z" fill="#0993fa" />
        <path
          d="M335.2,211.3c-.4.9-.4,1.8-1.5,1.5,0-.2,0-.7,0-1-.4-.2-.2-.6,0-1,1.2-1,.9,0,1.5.5Z"
          fill="#0496fb"
        />
        <path d="M339.7,215.3c1.1,0,2.1-.9,2.5.5-2,.9-1.7,0-2.5-.5Z" fill="#0466f4" />
        <path d="M341.7,211.8l-.5-.3.5-.7c.5.4.8.4,0,1Z" fill="#0993fa" />
        <path d="M335.7,217.3c-.2-.1-.3-.4-.5-.5.1-.4.3-.4.5,0v.5Z" fill="#037df9" />
        <path d="M335.2,216.8c-.3-1.5-1.2-1.6,1-1.5l-.5,1.5h-.5Z" fill="#0598f8" />
        <path
          d="M214.2,107.9c-.7,1.8,0,.5.3,1.1s-.2.7-.2,1.1c.2.8,1.5,1.5-.2,1.6-.6-.3-.3-1.5-.5-1.7s-1.9.2-2,.2c-.7.5,0,2.1,0,2.5s-1.1,0-.9.7c1.2,0,2.1,1.2,3.2.5l-.7,1.5c-.2,0-.4,0-.5,0-.2-.1-.4-1.1-1-1,.7,1.8-1.9,3-2,3.2s.5.2.5.2c0,.2-2.6,1.5-3,1-.1.8,1.3.6,1.5,1.3.4,1.2-1.8,2.1-.7,2.7l-.3.5c-.6-.3-.9-1-1-1-.2-.6-.8-1.1-2-1.5-1,.6-1.2.2-.5-1,1.1-.6,1,0,2,.5-.2-1.2-.3-2.3-.5-3.5-.4-1.6,1.9-2.2,1.5-.5.8.6,1.2,0,1-2v-.5l.5-1.5c-.3-.4-.4-1.5-1-2-.2-1,1.8-1.5,2.4-.7.5-2.8,3.3-5.5,4.1-1.8Z"
          fill="#04a2fa"
        />
        <path d="M210.7,119.4c0,0,0,.8-1,.5-.3-1.9.9-.4,1-.5Z" fill="#04a2fa" />
        <path d="M216.2,108.9h-.5c.6-.5.2,0,.5,0Z" fill="#0eacfb" />
        <path
          d="M219.7,94.4c0,.1,0,.3,0,.5-.2.5-.3,1,0,1.5.3.5.1,1.8,1,2.5-.3,0-1.9,1-1.9,1.1-.2.3.4.7.4.9,0,.7.1.8-.5,1-.4,0-.6-.3-.5-1,0-.3-.3-.7-.5-1-1.2.9-1.5-1.2-1.5-2.5.3-1.9,1-3,2-3.5.2-.4.3-.4.5,0,.4-.2.7,0,1,.5Z"
          fill="#1887f2"
        />
        <path d="M216.7,106.4c-.2,0-.7,0-1,0l1-1c0,.2,0,.7,0,1Z" fill="#0eacfb" />
        <path d="M218.7,101.9c-1.6.6-.5-.5-.5-1,.2,0,.4.7.5,1Z" fill="#066ce4" />
        <path d="M219.7,94.9c0,.2,0,.3,0,.5v1c-.2-.3-2.5-1.4,0-1.5Z" fill="#1f94f7" />
        <path
          d="M214.7,91.9c.6-1,1.1-1.1,1.5-.5.1,0,.3,0,.5,0,.4-.3.8,0,1,1,.2.1.3.4.5.5.5.8-.3.6-1,.5-.8.8-.7-.7-.7-.6.5.9,1.1,2.3-.3,2.6-.5.6-1,.9-1.5,1l-1.3-.4c-1.8.8-2.7.5-3.7-1.1-.8,1.1-1.2.8-1-.5-1.5-1.4-.4-3.1,1.5-1,.9-1.3,1.6-1.7,2-1,.8.8,1.5,1,2,.5l-1-.5c0,.9-.7.8-1,0-.4-.9.8-1.6,1.5-1,.6,0,1-.2,1,.5Z"
          fill="#24a0f9"
        />
        <path
          d="M219.7,88.4c0,.2.7,1.2.5,1.5s-4.1.1-5,.5c.7.7.4,1-.5.5-1,.2-1.8.2-2.5,0-1.1-.4-1.3-1.4-.5-3-.2-.2-.2-.3,0-.5,1.6-.9,3.5-.3,5.6,1.7,0-1,.3-1.4.9-1.2-.5-1.1-.4-1.4.5-1,1.5-.4,1.6.3,1,1.5Z"
          fill="#309af9"
        />
        <path d="M214.7,90.9c.9,0,.9.7,0,1,0,0-.8-.2-1-.5-.2-1.4,0-1.5,1-.5Z" fill="#309af9" />
        <path
          d="M216.2,91.4c-1.4.7-.8.6-.5,2-.9,0-.8-1.2-1-1.5,0-.3,0-.8,0-1,.2,0,.3-.4.5-.5.3.2.7.9,1,1Z"
          fill="#1f94f7"
        />
        <path
          d="M214.7,90.9c-.4.2-.6.3-1,.5-.6.4-.9.6-1.5,1,0,0,.8,0,1,0l1,.5c1.2,1.8-3.1.8-2-.5-1.3.9-1.4,2.4-3.5.5,0,.5.1,1.2,0,1.5.6.8.3,1-.5.5-1.2,1.1-1.7.4-1.5-2q-.2-.2,0,0c.6,1.2.2,1.7-1,1-.2-.3-.4-.2-.5.5,1,.9.8,1.2-.5,1,.1,1.4-.4,1.4-1.5,0-.4-.1-.4-.3,0-.5.3-.5.3-.9,0-1.5-.8-1.1-.3-2,1.2-2.3,0-.7.8-.7,2.3-.2,1-2.5,2.7-.2,3.5,1.7s-.6-1,0-1.2c-.6-1.2,1.6-1.9,2-.5,1.3-.5.7-2,1.2-2,.4.6,1,1.5,1.2,2Z"
          fill="#1f94f7"
        />
        <path
          d="M218.7,91.9c-.8-1.7,3.4-.5,2.5.5s-.9-.1-1,0l-.3-.5c-.5-.1-1,.5-1.2.5-.4-.1-.4-.3,0-.5Z"
          fill="#1a7aef"
        />
        <path
          d="M218.2,92.9c.2.1.6,0,1,.5.3.6.1.8-.5.5-.2,0-.4,0-.5,0-.9,1-1.3.9-1-.5l1-.5Z"
          fill="#309af9"
        />
        <path d="M218.7,91.9v.5c-.2,0-1,0-1,0-.5-.6-.6-1,0-1.5.4,0,.7.7,1,1Z" fill="#309af9" />
        <path d="M217.7,92.4c-.4-.3-.8-.5-1-1,.2,0,.8-.5,1-.5,0,.4-.1,1.4,0,1.5Z" fill="#1f94f7" />
        <path d="M219.7,94.4c-.4,0-.8-.4-1-.5l.5-.5c.4.5.4.4.5,1Z" fill="#1f94f7" />
        <path d="M220.2,92.4c0,0,.8.7.3,1-.5-.4-.7-.5-.3-1Z" fill="#309af9" />
        <path
          d="M210.7,83.4s.5,0,.8.2.2.8.5.8c1.2.1,2.4-1.6,2.4,1l1.8-1.5c.2,1.2,2.3,1.9,0,2v.5c.5,0,1,0,1.5,0s.7,0,1,0c.4.1.4.3,0,.5-.3.3-.3.7-.5,1-.5,0-.9.6-1.2,1.5-1.2-1.5-3.6-3.3-5.3-2,0,.1,0,.3,0,.5-.5,0-1,0-1.5,0-.6,1-.8,1-1.5,0-1.7,1.6-3.9,1.8-4.5-.5-2.4-1.8.3-2.8,2.5-2.3,1.1,1.1,1.6,1.3,2.5-.2,0,0,1.5-.8,1.5-1.5Z"
          fill="#3a92f5"
        />
        <path
          d="M218.7,86.4c.8,0,1.7,0,2.5,0-.1.7-1.5,1.3-1.5,2-.5-.2-.6-1.1-1-1.5v-.5Z"
          fill="#2d83f2"
        />
        <path
          d="M200.2,85.4c1.6.3,1.4,1-.5,2,.4.1.4.3,0,.5.4.1.4.3,0,.5-.2.4-.3.3-.5,0-.2.7-.4,1.1-1,.5-.2.3-.5.5-1,.5h-2c-.1.4-.3.4-.5,0,0,.8-.7.9-2.2,0-1.7,1-3.6,1.8-5.5,2.4l-.3-.5c-.7.2-.8.2-.5-.5-1.4-1.6,0-2.5,3.8-2.9l.7-1.1c.2,0,1.8,0,2.5,0,.4-.3.9-.4,1.5-.5.2,0,.3,0,.5,0,.9.4,1.4.4,1.5,0,.7-.8,1.6-1,2.5-.5l-.3-1.5,1.3,1Z"
          fill="#378bf4"
        />
        <path d="M196.7,86.4c-.1.2.2,2.5-1.5,0-.2-1.8.4-.6,1.5,0Z" fill="#307ce8" />
        <path d="M188.8,87.9c0-1,1.2-2.6,2-1.8l-1.5,1.8c-.1,0-.3,0-.5,0Z" fill="#4a91f5" />
        <path d="M194.8,86.4c-.5,1.6-1.4.5-1.5.5.8-1.6.8-.6,1.5-.5Z" fill="#307ce8" />
        <path d="M201.7,83.4c-1,.1-1.1,0-1-1h1.5c.3.2-.6.6-.5,1Z" fill="#4188f4" />
        <path
          d="M200.7,134.3c.3-.5,1.8-1.7,2-1.5.7.8-1.5,1.4-1.5,2.3s1.1.9,1.7.7c.9-.3.5-2.8,1.8-.5-.1.2-.2,2-1,2.5,2.2-.1-.7,1.9,1.5,1.5.9,1.1,1,1.3-.5,1.5-.5,0-1.6,1.6-3,.5-.4,0-.8,0-1.1-.3s.2-3.9.6-4.6c0,0-.4,0-.5,0-.5-.6-.3-1.3,0-2Z"
          fill="#038df8"
        />
        <path
          d="M209.2,137.3c-1.3.5-.5,1-.7,1.4s-1.3-.4-.3,1.6l-.3.5h-.7c-1.6-.4-.8-1.2,0,0s-2.9.5-1.4-1.9q1-.5,0,0c-.1.4-.3.4-.5,0,0-.6-.4-1-.5-1.5,1.3-.2,3.4.7,3-1l.2-.5c.6.2.9,1.3,1.3,1.5Z"
          fill="#0268ee"
        />
        <path
          d="M198.7,145.8c.3,0,.8.1,1,0,.2-.3,0-1,0-1.5.8,0,.8,1.3,1.1,1.5.4.2,1.1-.4,1.4-.5h1c.6,0,.4-.7.5-1h.5l1,.5c0,0,0,.4,0,.5-.4.2-.8.5-1,1-.1.3-.6.4,0,1,0,.8-.2,1.4-.5,2-.4.3-.7.4-1,0-.7,0-1.1,0-1,.5,1-.2,1,1.1,0,1,0,.8-.8.8-1,0-.7.7-1,.4-.5-.5-.2-.4-.2-.7,0-1-.5-.1-.4-.3,0-.5l-.4-.6c-1.7,1.1-2-.6-1.1-2.4Z"
          fill="#038af6"
        />
        <path
          d="M206.2,146.3l-1.1,3.7c-.9.5-.7.4-.9,1.3-.1.4-.3.4-.5,0-1.8-1.1-1.8-1.8,0-2,0-.2,0-.4-.3-.5-.7-.5-2.1-.2-1.7-1.2s1.7-.3,2.5-.3c1.6.1,1.6.1,1.5-1.5.3,0,.4.5.5.5Z"
          fill="#035fe8"
        />
        <path
          d="M205.7,138.8c-.1,2.9,1,.5,1.5,1s-.1.9,0,1c.4.5,1.2.3,1,1-1.2.6-3.1-1-3.5-1,0-.5.5-1.1.5-1.5s0-.3,0-.5h.5Z"
          fill="#0379f5"
        />
        <path d="M205.2,145.3c-.1.5-.5.8-1,1,.2-.5-.4-1.2,1-1Z" fill="#0457e5" />
        <path d="M205.2,144.8l-1-.5c.5,0,.8,0,1,.5Z" fill="#049ffa" />
        <path
          d="M203.7,151.3h.5c0,.3,0,.7,0,1,.2.2.2.3,0,.5-.2,0-.3.4-.5.5-.6,0-.9-.4-1-1.5-1.3-1.6,0-2.1,1-.5Z"
          fill="#0367ef"
        />
        <path d="M204.7,152.8c-.2,0-.4,0-.5,0v-.5c.2,0,.5.3.5.5Z" fill="#035fe8" />
        <path
          d="M202.7,153.8c-.4.3-1,.4-1,1l1.5.5-2,.5,1.5.7c-1.1,1.6-.6,2.8-3,2.3-.3.9.8,1.2.9,1.8.2,1.1-1.1,2.5-2.4,2.2,0-.3,0-.7,0-1-1.6-.6-4.4-2.2-1.5-3,.3-2.1.8-2.9,1.4-2.3l.6-.2c-1.2-.6-.1-1.8,1-1,.6-.3.6-.9,0-2v-.5c.5-1.4.8-1.3,2-.5,1.2-.6,1.7.7,1,1.5Z"
          fill="#0367ef"
        />
        <path
          d="M202.7,151.8c1.8-.3.3.6,1,1.5-.3.2-.9.4-1,.5l-1-1.5c.4-.7.8-.9,1-.5Z"
          fill="#035fe8"
        />
        <path d="M187.3,161.3c-.1.6-.6,1-1,.5-.9-.3-.9-.7,0-1,.6-.6,1.4-.3,1,.5Z" fill="#0284f7" />
        <path
          d="M188.3,161.3c.8.9,1.6,1.4,2.6,1.4l.4,1.1c.1-.9.5-.9,1,0,.1-.4.3-.4.5,0,1.2.2,3.8.1,2.8,1.5-1.3-.9-.9,0-2.3.5q-.4-.9,0,0c0,.3.7,1.2,1,1.5-.3.4-.3.7,0,1v1c-3.2.5-1.3,1.3-1.5,1.5-.3,0-.8,0-1,0l-.3-.5c-1.2-.3-.5.7-.7,1-.5.5-.9.5-1,0-.5-.9-1.9-1.2-3.4-.1,0-1-.9-1.4-1.7-1.1.3-1-.1-1.4-1.4-1.3,0,.2-1.1.5-1.4.5s-2.1-3.8-1.1-4c.5-1.2,1.7-.6,2,.5,0-.4.2-.5.5-.5.4-1.1,1.6-1.2,3.5-.2v-.8c-.4-.1-.4-.3,0-.5.1-.2,0-.5-.5-1,.2-.5.5-1,1-1.5.2-.9.7-.9,1,0Z"
          fill="#0284f7"
        />
        <path
          d="M186.3,174.8c0,.6-1.4,1-2,1-1.3-1.1-1.6-1.6-1-1.5-2,.4-2.1-1.6-1.5-3,1-.1,1.9-.4,2.7-1-.7-1.7,2.3.2,2.3.5-1.2,1.4-2.1,2.6-.6,3.9Z"
          fill="#038bf8"
        />
        <path
          d="M189.3,172.3c-.2.2-.3,1.5-1,1.8l.7.2c.9.4.1.6-.4.5-1.9-.3-2.2-.8-1.2-2.5-.4-1.3,2.2-1.2,2,0Z"
          fill="#0398fa"
        />
        <path
          d="M189.8,171.3c.3,0,.7,0,1,0-.8,1.2-1.4.9-1.5,1-.9-.7-1.3-.2-2,0s-.7,0-1,0c-.7-2.1,2.8-2.5,3.5-1Z"
          fill="#046ef5"
        />
        <path
          d="M183.3,168.8c1.9-1.4,1.4.9,3.4,1.4s3.6-1.4,3.1,1.1c-1.9-.5-2.7-1.1-3.5,1s0,2,0,2.5c-1.2,0-1.6-.6-1.5-1.7s2.4-2.1.8-2.8-.6,1.3-.7,1.5-2.3-.8-3-.5c-.4-.1-.4-.3,0-.5l.3-.7c1,.4,2.1-.2,1.2-.8-.4-.1-.4-.3,0-.5Z"
          fill="#0398fa"
        />
        <path
          d="M185.3,182.3c1.8-.2.9.5.5,1.5-.1.4-.3.4-.5,0,0-.3,0-.7,0-1s0-.3,0-.5Z"
          fill="#0352e8"
        />
        <path
          d="M195.7,162.3c-1.5,1.1-2.9,0-1.8-2-5.5-1.9,1.7-5.2,2.3-1.5.1-.4.3-.4.5,0-.9,1.3.8,1.5,1.6,2.3s0,.7,0,.7c-.7.4-2-.1-2.5.5Z"
          fill="#037ef6"
        />
        <path
          d="M189.3,160.8c.8-.6.7-1.9,0-2.7.8,0,.9-.8.2-2l1.9-1c.7,1.4,2.3,1.6,4.8.7,1.6-.2,1.6,2.9.1,3.1-1-.3-1.7-2.2-2.2,0l-1.7-1,3,3.2-1.5.3,2,1c-.6.7.3,1.4-2.7,1.1l-.3.4c-.2,0-.3,0-.5,0-1,.1-.9-.9,0-1,.2-.7,0-.8-.5-.5.4.4-.1,1.1-.5,1.5-1.6-.4-3.2-.2-3-2.5-.5-1,.5-1.5,1-.5Z"
          fill="#0398f9"
        />
        <path
          d="M194.3,167.3c.3.4,1.4.7,1.5,1.5-.7.3-1.3-.5-1.5-.5-.5,0-1.3.8-1.5.2,0-.9.8-1.2,1.5-1.2Z"
          fill="#0364f2"
        />
        <path
          d="M180.8,182.8c.2.3.4.7.5,1,.6.4.9.9,1,1.5.2.2,1,1.3,1,1.5-.5.3-.6.6-.5,1,0,.3,1,.5,1,.5.2.3.5.8.5,1-.1.7-.5,1.2-1,.5-1.3,0-2.3-1-3,1,.6-.1,1.1.4,1.5.5-1.1.7-2.6.7-3,1,0-.5-.5-.5-.5-.5-.3-.8.1-1.8-1-2.5-.3.5-.9.6-1,0,0-.3,0-.7,0-1-.1-1.3.4-2.6,1.2-1.3.3.2,1.9-1,1.3-1.2.1-1.6.3-2.3,1.5-3.5.5-.6.8-.3.5.5Z"
          fill="#037df9"
        />
        <path
          d="M186.3,186.8c0,.8-1.6,1.4,1.5.5v2.5c-.4.2-1,.4-1,1h1.5c.2,1.9-1.2,1.9-2,2.5-1.3,1.2-2,1.2-2,0-.7-.9-2.1-.7-3.5.5-2.2,2.8-5.3.3-2-1.5-.3-1.3.7-1.6,3-1q.8-.4,0,0c-4.8.5-.5-5.1,1.5-1.5.4.3.7.1,1-.5-1.2.3-1.3-.1-.5-1-.7-1.3,1.5-2.6,2.5-1.5Z"
          fill="#025ef1"
        />
        <path
          d="M180.8,193.8c0-2.4.2-1.1,1.2-1.3s2.4-1.2,2.3.8c-.9,0-1-.3-2,0l-1,.5c-.2,0-.3,0-.5,0Z"
          fill="#0372f3"
        />
        <path d="M184.3,189.3c.4,2-1.1,2.3-1,.5.1,0,.6-.6,1-.5Z" fill="#014ce5" />
        <path d="M186.3,191.8c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#0147e3" />
        <path d="M181.8,191.3c.2-.2.4-1.1,1-1,.2,1,0,1.2-1,1Z" fill="#0381f6" />
        <path d="M182.3,193.3c-.2.5-.6.5-1,.5.2-.4.6-.4,1-.5Z" fill="#025ef1" />
        <path d="M183.3,186.8c.2,1-.5.9-.5,1l-.5-.3c-.2-.9.1-.8,1-.7Z" fill="#0355ed" />
        <path d="M185.8,183.8c0,.2,0,.7,0,1-1.5-.7-.5-.9-.5-1h.5Z" fill="#058ff5" />
        <path
          d="M166.8,98.4s.9,0,1,0c.5-.4.8-.6,1,0,1.4.6,2.2,1.5,2.4,2.6,2.3,0-.7,3.4-1.9,1.4-.3.5-.8.5-1.2.4,1.6,3.8-4.8,2.9-4.8,0l-.5-.3c.8-.9,1-1.5.5-2.7.3-1.2,2.4-1.3,3.5-1.5Z"
          fill="#0b6bea"
        />
        <path
          d="M163.3,99.9l2.5,2.2c-.6,2.2-.8-2.2-2-1.2.2.8-.4,1.4-.5,2-.3,0-.9.1-1,0s0-.7,0-1c1.7.3.7-.9,1-2Z"
          fill="#1e79f3"
        />
        <path
          d="M178.8,88.9c.3,1.1,1.6,1,2.5,1,0,.3-.5.4-.5.5-.7.5-1,1-1,1.5l-.2.7c-2.3-.4-4.4-.3-6.3.3-.6.5-.8.2-.5-.5.8-.6,0-1.9,0-2,.1-.1,2.5-.3,3.1-.6,1-.4.2-.7,2.9-1Z"
          fill="#2a72e9"
        />
        <path
          d="M173.3,92.9c1.5-.5,1.2.6.5,1.5-.5.3-.7.4-1,1-.2.4-.3.4-.5,0l-.5.5h-.5c-.4-.4-.9-1.5-1-2s0-.4,0-.5c.7-.2,1.4-.6,2-1,.2,0,.4,0,.5,0,.3,0,.4.3.5.5Z"
          fill="#186be9"
        />
        <path d="M172.3,92.4c0,.5,0,1,0,1.5l-2-.5c.3-1,1.1-1,2-1Z" fill="#2373ee" />
        <path
          d="M162.8,104.9c1.3.2,1.3.6,0,1l.5.5c.4.2.5.6.5,1,.4.1.4.3,0,.5-.4.5-.9,1-1.5,1.5,1.1,0,1.5.4,1,1,0,.5,0,1,0,1.5.3,1.7-1.6,1.7-1.5,0-.9,0-1.8-1.1-1.5-2,0-1.2-1.6-1.1-2.5-.7-.2,0,3.8-1.4,2.5.7-.3.2-.5.6-.5,1-.1.7-.5,1.2-1,1.5-.2,1.4-.7,1.4-1.5,0q-.6-.6,0,0c2.6.8,0,3.1-1,1,0,.4-.3.4-.5,0-.1,0-.4-.5-.5-.5-.9,0-.9-.8,0-1-.2-1.1,0-1.9,0-2s-3-.5-2-1.5,4.1,2.3,4-1.2-.9-.2-1-.3,0-.5,0-.5c-.2-1.4.2-1.5,1-.5.2,0,.3,0,.5,0s.4.5.7.5,0-1.2.5-1c1.3.4-.7,2.5,1.3,2l1-1c0-1.1-1.5-2.3,1.5-1.5Z"
          fill="#0473f2"
        />
        <path d="M155.3,111.9c0,.3,0,.7,0,1-.7,0-.7,1.7-1.5-1.5l1.5.5Z" fill="#0155e7" />
        <path d="M152.3,105.4c-.5.4-.7.7-1.5.5v-.5c.5,0,1,0,1.5,0Z" fill="#0d50e3" />
        <path
          d="M157.3,105.9c0,0-1,.5-1,.5.5-1.9-1.7.2-2-1.3-.4-2.4,4.9-2.4,3,.8Z"
          fill="#0663e8"
        />
        <path
          d="M128.3,164.8c.7.5,1.4,1.1,2,2,0,.3-.2.5-.5.5-.6.5-1.3.5-2,.5-.6,1.2-1.5,2.2-2.5,1-.6-.5-1.3-.8-2-1,.1.5,0,.6-.5.5h-.5l-.5-.5c.1-.2-.2-.7.3-1,.8-.5,2.1-.2,2.7-.5,1,.2,1.8-.1,2.5-1,.2,0,.6-.5,1-.5Z"
          fill="#0472f5"
        />
        <path
          d="M129.8,167.3c.3.1.9,1,1.5,1,0,0,0,.4,0,.5.2.6-.6.9-2.2.9-.7,1-1.3,1.4-1.8,1.1-.2-.1-.3-.4-.5-.5-.9.2-1.4,0-1.5-.5-1.3.4-1.4,0-.5-1,.1-.3.3-.3.5,0,2.2-.4,1.1-2.8,4.5-1.5Z"
          fill="#035af0"
        />
        <path
          d="M143.8,157.8l1,2.5c-1.6-2.6-1.9-.9-3,1.5s0,.7,0,1h-.5c0-1.1.3-2.6-1-3,.3-.5-.8-.8,1-1,.6-.1,1.2-.3,2-.5-.7-.6-.4-.8.5-.5Z"
          fill="#037cf7"
        />
        <path
          d="M136.3,168.3c0,0,0,.3,0,.5-.1.5-.6.8-1,1,.4.1.4.3,0,.5-.1.4-.3.4-.5,0-.2-.5-.2-.5-.5-1-.5.1-.6,0-.5-.5l-.5-.5c-.1.4-.3.4-.5,0,0-.1-.4-.3-.5-.5.6,0,3.7.1,4,.5Z"
          fill="#024ee8"
        />
        <path
          d="M128.3,163.8c2.2,0,1,1.5,1.1,1.9s.8-.3.9,1.1c-.4-.4-1.9-.4-2-.5s0-.9,0-1.5,0-.7,0-1Z"
          fill="#035af0"
        />
        <path
          d="M130.3,163.3c-.1.3-.3.3-.5,0-.2,0-.3,0-.5,0l-.5-1c1.1.1,1,.4,1.5,1Z"
          fill="#0231d8"
        />
        <path d="M138.3,168.8c0,.6-.4.4-.5.5-.7.5-.9,0-1,0l1.5-.5Z" fill="#0375f3" />
        <path d="M134.8,163.8v.5l-1-1c.9-.3.9.4,1,.5Z" fill="#025cef" />
        <path d="M136.3,169.3c-.2,0-.6.6-1,.5l1-1v.5Z" fill="#0375f3" />
        <path d="M130.8,163.8c-.4,0-1,0-1-.5h.5c.2.2.4.3.5.5Z" fill="#025cef" />
        <path d="M136.3,168.3c-.2-.2.5-.8.5-.2s-.4.4-.5.2Z" fill="#0375f3" />
        <path
          d="M143.8,142.8v.5c1.4,1.3,0,2.4-2,2,0,1.1,0,1.6-.3,1.3,2,2.3-.4,2.2-2.2,1.2-.6.4-1.2.7-1.5,0,0-.2-.2-.7,0-.9.7-.5,3.5.1,2.4-2.6,0-.3-.1-.3-.5,0-.7.6.2,1.6-2.5,1.5-.2-.9.6-1.3,1-2,1.1,0,4.8-1.1,5.5-1Z"
          fill="#0482f5"
        />
        <path
          d="M143.3,138.8c.9-1.6,1.6-1.2,2,0,1-.9,1.9-.6,2.7.9l1.3-.9c.8-1.3,4,1.1,2,2.5,1.2,1.1,1.1,1.5-.5,1.5s-2.3,0-1.7-.3.4.3.2.8c1.3.7,2.1.7,2.5,0,.8-1.6,2.4.2.5,1,.7.1,1,.5,1,1,1.7,1.2-1.2,1.7-2,.5-1.9.2-3.6-.3-5-1.5-.4,0-1,.9-1.5,1-1.1.3-1.5,0-.6-.6v-1.9s-.2,0-.4,0l-.5-1.5c0-.1.7.4,1,.5q.7.4,0,0s0-.3,0-.5q1.2-1,0,0c-.6,0-3.1-1.3-2.5-2s1.1-.3,1.5-.5Z"
          fill="#0482f5"
        />
        <path
          d="M139.3,147.8c.4.1.4.3,0,.5-.3,0-1,0-1,.5-.4-.6-.8.1-.5-1,.5,0,1,0,1.5,0Z"
          fill="#024dee"
        />
        <path d="M135.3,147.3c.2-.6.3-.6,1-.5.2,1.9-.5.5-1,.5Z" fill="#0482f5" />
        <path d="M139.8,144.3c0-.7.9-.8,1-.2l-.5.2c-.2,0-.4,0-.5,0Z" fill="#20aff2" />
        <path
          d="M142.3,158.3c.2-.3.3-.3.5,0,.1-.4.3-.4.5,0-.3.1-.6.6-1.1.7s-.8-.2-.9-.2v-.5c.5-.5.8-.7,1,0Z"
          fill="#0460f8"
        />
        <path
          d="M141.3,157.3c.2,0,.3,0,.5,0,1,.3.2.7-.5,1-.3,0-1.1-.7-1.5-.5.4-.1.8-.3,1.5-.5Z"
          fill="#037cf7"
        />
        <path
          d="M139.3,151.3c.7-.7,1.8-.6,1.9.6,1.6,0,2.2.4,1.6,1.4-.1.2,0,.5-.5.5-1.8-.8-.6.1-1,.5-1.1.9-1.2-1.9-2-2.5v-.5Z"
          fill="#0267ee"
        />
        <path
          d="M142.3,156.8c-.1-1.8,1.4-1.4,1,.5-.1,0-.3,0-.5,0-.3,0-.5-.2-.5-.5Z"
          fill="#0264f1"
        />
        <path d="M142.8,157.3c-.2,0-.3,0-.5,0v-.5l.5.5Z" fill="#037cf7" />
        <path
          d="M136.8,151.8c.9.4,1.6,1.2,1,2-1.2.3-2.9.9-2.5,2.5,0,0,.6.3,0,.7-.8.8-1.5.9-2.6.7l.5-1.5-2,.3c.7-1.8,1.7-1.4,2.4-1.8s-.5-1.3.2-1.9.8,0,1.9-1.1c.2-.7.9-.8,1,0Z"
          fill="#0476f5"
        />
        <path
          d="M138.3,152.3c-.1.4.2,1.5,0,1.9s-1.6.4-2.4,1.1-.3.7-.5,1c-1.6-1.5,1.3-2.9,2.5-3l-1-1.5c.6-.9,1.5-.6,1.5.5Z"
          fill="#0264f1"
        />
        <path d="M134.3,155.3s.2,1.1-.2,1c-1.4-.8-.3-1.6.2-1Z" fill="#025cef" />
        <path d="M126.8,163.8c0,0,.4,0,.5,0l-.2.5-.2-.5Z" fill="#025cef" />
        <path d="M127.3,165.3c-.4,1.9-1.1,2.4-2.5,1,.8-.3.5-.6,2.5-1Z" fill="#0361f1" />
        <path d="M128.3,150.3c0-.3.3-.4.5-.5l-.5.5Z" fill="#035ff4" />
        <path
          d="M141.8,150.3v.5l.5,1c.2.2,1.8-.7.5,1.5.3-1.7-.9-.7-2.1-1s-.1-.6-1.3-1-.3,0-.5,0c.1-.2.3-.3.5-.5s.5-.5.5-.5c.5,0,.7-.1,1-.5.1-.1.7.4,1,.5Z"
          fill="#0373f4"
        />
        <path d="M140.8,149.8c0,0,.1.7,0,.9s-.8-.4-.9-.4l1-.5Z" fill="#0267ee" />
        <path
          d="M124.3,168.8c-.3.7-.7.8-1,0h-.5c0-.1,0-.4,0-.5.1-.2.3-.4.5-.5.7-.2,1.4.3,1,1Z"
          fill="#0544e0"
        />
        <path
          d="M119.3,181.8v1.5c0-2.8-1.4,2.3-2.5.5-.5-.7.3-1.5,1-2,.7-.4,1.2-.4,1.5,0Z"
          fill="#034bee"
        />
        <path
          d="M112.3,177.8l-.5,2c2.6-.6,4.5-.5,6.5,1.5.4.5,0,.5-.5.5-1.2,1.1-1.8,2.1-2,3,.1.1-.3.9.2,1s.3-2,1.2-1-.7,2.7,0,4.5c-.3,0-1-.7-1.5-.5s-.2.9-.5,1c-.5,1-1.8.6-2-.5,0,0-.7-1.2-.5-1.5s1.2.3,1-.5l-2.5,1v-2.5c.8-1,3.4-.6,2.2-2-1.2.1-1,1.3-1.7-1s.4-.4.2-1c-.4-.9-1.4-1.8-2.2-2.3.3-.7,1.9-1.3,2-1.8h.5Z"
          fill="#034bee"
        />
        <path d="M116.3,186.8c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#035af1" />
        <path d="M115.8,181.8c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#0362f3" />
        <path d="M116.3,180.8c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#0362f3" />
        <path d="M116.8,167.8c.1,0,.3-.4.5-.5,0,.4-.4.4-.5.5Z" fill="#024eef" />
        <polygon fill="#047cf3" points="142.8 135.3 142.8 138.3 142.3 135.3 142.8 135.3" />
        <path
          d="M145.3,137.3c1.3-.3,1.2,0,.5,1,.3.2,0,.4-.5.5,0,0-.1.7-.4.4-.2-1.6-.7-.8-1.6-.4-.3-.5.5-1.4.5-1.5-.2-1.1,1.3-.8,1.5,0Z"
          fill="#0357e8"
        />
        <path
          d="M137.8,134.8c0,.3,0,.7,0,1-.1.5-1.1,1.4-.7,2.5-1.7-1-1-3.2.7-3.5Z"
          fill="#0255e5"
        />
        <path d="M140.8,135.8c-1,1-1.4.7-.5-.5l.5.5Z" fill="#014adc" />
        <path
          d="M143.8,128.9c-.2,0-.7,0-1,0,1.3,1.9-1.4,1-1-1,.6.1,1.4,0,2,0l-.5-1c.2,0,.3,0,.5,0,1,.9,1.4,1.5,0,2Z"
          fill="#0364f0"
        />
        <path
          d="M140.8,130.8c.7.1,1.2,1,1,1.7-.5,0-2.2,1.6-2.5,1.3-.9-1,1.3-1.7,1.5-3Z"
          fill="#0252e5"
        />
        <path d="M216.2,379.7c-.2.2-.3.4-.5.5-.9-.6.2-1.7.5-1.5s-.1.9,0,1Z" fill="#0347b9" />
        <path d="M219.7,379.7h-.5c.5-.3.5,0,.5,0Z" fill="#024abb" />
        <path
          d="M141.8,271.8c.2,0,.3,0,.5,0,1.1.9.8,1.6-1,2,0,.3,0,.7,0,1-.7.4-1.9-.4-2.5-1-.8-.2-.6-.5.5-1,0-.5.2-.4.5,0l.5.5c-.5-.9-.6-1.1.5-1.5.3-1,.7-1,1,0Z"
          fill="#0447f2"
        />
        <path
          d="M142.3,271.8l3,2.5c-2.7,1.6-1.8-1.6-3.5-.5h-.5c.2-.5,1.1-1.2,1-2Z"
          fill="#0235ee"
        />
        <path
          d="M139.3,272.8c-.1.3-.4.7-.5,1,1.1,0,1.7.3,2.5,1,0,0,.2,0,0,.5-.3.2-.7.3-1,.5-.6,0-1.4-.4-1.5-1,0-.3,0-.7,0-1-.5,0-1.8.4-2.5.5-.3,0-.6-.2-.5-.5,1.7-1.6,2.9-1.9,3.5-1Z"
          fill="#0235ee"
        />
        <path d="M142.8,274.8l-.5-.5c.2.2.3.3.5.5Z" fill="#0235ee" />
        <path d="M149.3,276.8c-2.5,0-1.6-1.3-3.5-.5.4-2.7,1.7-.5,3,0s.4.3.5.5Z" fill="#0221d8" />
        <path d="M148.8,273.8c-.2.5-.2.6-.7.5-.7-.1.2-.5.2-.5h.5Z" fill="#0229dd" />
        <path
          d="M146.8,239.3c.4.6.3,1,0,1.5-1,1.5-.7,1.3,1-.5-.6-.4-.4-.6.5-.5.1,0,.4,0,.5.3.2,2.8-2.9,2.1-1.5,4.7-.7-.6-1.3,0-1.5,0-.3,0-.7,0-1,0-2.4-3.5,1.5-3,1-6,.9-.3.9.4,1,.5Z"
          fill="#0347f3"
        />
        <path
          d="M148.8,236.8c1.5-.3,1.1.9.5,2-1-.3-2.4.7-2-1l1.5.5c0-.3,0-.7,0-1s0-.3,0-.5Z"
          fill="#0234ea"
        />
        <path
          d="M148.3,239.8c0,.2-.4.4-.5.5-.4.6-.7.8-1,.5-.8,0-.8-1.4,0-1.5.5.2,1.3.4,1.5.5Z"
          fill="#022eee"
        />
        <path
          d="M149.3,248.8c-.2.1-.2.6-.5.8s-.5-.3-.5-.3c0-.3,0-.8,0-1h.5c.5,0,.7,0,.5.5Z"
          fill="#0331e9"
        />
        <path d="M148.8,248.3l1.5-.5c.2.6-.5.6-1,1l-.5-.5Z" fill="#0347f3" />
        <path
          d="M138.8,256.8c.4.3.4.6.5,1-.1,0-.7,0-1,0s-1-.4-1.5.5c-.3.7-1,1-2,1-.5.8-.8,1-1,0-1.7-1-1.3-1.5,0-2.5-.9-.9,1.5-1.4,2.5-1.3s2.1.3,2.5,1.3Z"
          fill="#033ff4"
        />
        <path
          d="M132.8,255.8c-.2,0-.7,0-1,0-.4-1.1.6-1.3,1.7-1s-.5,1.1,1.3.5,3.2-.4,4,1v.5c-1.5-1.2-3.5-1.1-5,0-.2-.6-.5-.7-1-1Z"
          fill="#0346f3"
        />
        <path
          d="M143.3,253.8c.5-.4.8-.4,1,0,.2.2.4.2.5,0,.1-1,.6-1,1,0,0,.3.5.8.5,1,0,1.2.7,1.8,2,2-.1,1,.5,2.6,1.8,1.5,1,1.9-1.7.9-2.8,0v3c-.3,0-.5-.5-.5-.5-.9.5-2.2-.5-1.8-.4s.8.7.3.9c-.3.8-.7.7-1,0-.2,0-.4,0-.5,0-.3,1.7-1.6,2.5-2.5.8-1.3.6-1.8-.5-1.6-3.4l-.5-.9c1.5.7.8,3.9,0,3.9-3.8,0-3.5-1.2-1.1-3.9,0-.9.6-.7,1,0-.7-.2-1.1-.4-.5-1-.2-.2-.2-.3,0-.5-.2-.4,0-.6.5-.5.7-.2,2,1.4,2.5,1,1.1-1-1.3-.8-1-1.5l1.3-.5c.6,0,.2,2.7,2.2.3l-2-.8c-.1-.4.5-.4.5-.5h.5Z"
          fill="#0234ed"
        />
        <path
          d="M138.3,257.8c1.4,1.9-.8,1.8-1,2-1,1.5,3.4,2.4,2-2,.6.3.7,1,1,1.2.5.3,1.5-.4,2,.6-1.5.3-1.9.6-2,2.2l1.3-1.5,1,2c.8.3.9-.9,1.2-1,.1,1.1-.5,1.7-1,2.5-2.1,1.3-3,1.2-4.3-1-.6,3.1-3.9,1.9-2.7-.5-.7-.3-.7-.9,0-2-.5-.8,0-2.2,1-2-1.1-1.5,1-2.1,1.5-.5Z"
          fill="#0346f3"
        />
        <path
          d="M146.3,254.8c.5,1.2,1.3,1.1,2.5,1,.2.1-.5.7-.5,1-.8.6-1.6.3-2.5,0-.5-.9.4-1.9.5-2Z"
          fill="#034ef4"
        />
        <path
          d="M146.8,260.8c-.4,0-.9.4-1.5.5.1.3.6.9.5,1-1.2,0-1.7.3-1.5-1,.3,0,.7,0,1,0-.1-.3-.6-.9-.5-1l2,.5Z"
          fill="#0346f3"
        />
        <path d="M144.3,260.8c-1.5-.6-1.7-2.6-2-4,3.1,0,2.1,1.9,2,4Z" fill="#034af4" />
        <path d="M144.3,253.8c.2,0,.3,0,.5,0l-.2.5-.2-.5Z" fill="#023fef" />
        <path
          d="M145.8,270.3c-.5-.6-1.7-4.4-1.2-4.7s1.7-.4,1.8-.4c.9.2.8,2,0,2.1s-.4-1.1.3.5c1.1.4,1.3.7.5,1,1.2-.2,1.3.3.5,1.5-.6.3-1,.8-1.2,1.3l-.8-.8c-.4-.1-.4-.3,0-.5Z"
          fill="#023fef"
        />
        <path
          d="M149.8,252.8c.1-.9.4-1.8.9-2.7-1.9-3.5,3.7-6.4,2.4-1.3,2.1.9,2.2,1.3,1.4,3.6.9.6,1.1,1,.7,1.4-.8.8,0,1.7.5,2.5s0,1.1.8,1.5.5-1.7,1.7-1c.5,1.7-2.1,1.2-2.5,1.5s.5.8.5,1c1.4.4.1,3.2-1.1,3.5s-2.7-2.7-.4-2.5v-1c-.7-.4-.9-.7-.5-1,.1-.5.1-1.2,0-2-.2-.2-.4-.2-.5,0,1.2.8.8,2-.5,1q-.3-.6,0,0c.4.1.4.3,0,.5-.1.8-2.9-.7-2.5-1.5q1.7-1.1,0,0v.5c2.2,1.2,2.3,1.3,2,4,1.8.4,4.2,3.9.7,4.7.6,1.9-1.7,4.2-2.8,2.1-1.2.5-3.8,1.5-3.9.2l-.3-.7c2.3-1.8.4-3.7.5-3.4.2,1.3.3,3.1-1.1,1.8-1.1,1-1.9.8-2-.7,2,.9.6,2.7-1.3,2s-.3-3.6,1.3-2c-.6,0-1-.4-1-1-.5-.5-.1-1.3,1-2.5.1-.4.3-.4.5,0,.4.6.8.6,1,0,.1-.5.6-.6,1.5-.5.4-.2.3.3.3.3-1.8-1.1-.6-3.5,1.2-4.3-1.3-.9,0-.6,0-.5-.7.8-2.9-.2-2-1.5-1.3.3-1.4,0-.5-1,1.6-.3-1.1-.9-2.5,0-.1.4-.3.4-.5,0-5.1-.6-6.4-1.7-3.8-3.2.9-1.6,1.9-2.1,2.8-1.3q.7.8,0,0c-1.3-.2-1.2-.5,0-1,.6-.6,1.6-1.2,2.4-1.1s3.2,1.2,3.1,2c.3.6.5,1.4.3,2.3,2.8-.7,3.5-.3,2.2,1.2l-.2,1.1c.7,1.8-1.5-.3.2-1.1Z"
          fill="#023fef"
        />
        <path
          d="M149.8,252.8c.1.6.5,1.2,0,1.8h1.5s-2,1.2-2,1.2c.7-2.8-2.2-.3-2-2.5.9.3,2-.5,2.5-.5Z"
          fill="#054cf5"
        />
        <path
          d="M150.8,256.3c.3,1,1.9,1.1,2.5,1.5.6-1,1.2-.7,1,.5,0,0,.3.8.5,1l-1.5-.5-.5,2c-.5-1.1,0-1.6-2-1.5-.2-1,1.2-.3,1.5-.5,1.1-.9-2.2-1.4-2.5-2.2,0-.5.8-.1,1-.2Z"
          fill="#044bf2"
        />
        <path
          d="M143.3,253.8l2.2-2,1.2,1.8c.2,1.5-.5.3-1,.2s-.7,0-1,0c-.2.3-.3.3-.5,0-.3,0-.7,0-1,0Z"
          fill="#034ef4"
        />
        <path
          d="M154.3,256.3c1,.7,1.7,2.3,0,2-.1-.1-.6-.3-1-.5v-.5c.8,0,.4-.8.5-1,.1-.3.3-.3.5,0Z"
          fill="#022de2"
        />
        <path d="M150.8,256.3c.6-.5.8-1.8,2-1.5.4,1.3-.9,1.2-2,1.5Z" fill="#0654f4" />
        <path d="M153.3,257.3c-.8-.3-.7-1.2,0-1v1Z" fill="#044bf2" />
        <polygon fill="#044bf2" points="154.3 256.3 153.8 256.3 154 255.8 154.3 256.3" />
        <path d="M152.5,250.8c.3.2.3.3,0,.5v-.5Z" fill="#044ff4" />
        <path d="M154.8,260.3c-.4.4-1.5-.3-1-.5s1.3.3,1,.5Z" fill="#0117c8" />
        <path d="M142.8,267.3c-.2,0-.3,0-.5,0l.2-.5.2.5Z" fill="#0235ee" />
        <path
          d="M134.8,259.3c.2-.7.6-1.3.5-2,.8-.2.3.6.8,1h.7c-.3.5,0,.7-1,2s-.5,1-.8,1c-.6,0-.7-.5-.7-.5-.9-.5-.4-1.3.5-1.5Z"
          fill="#0235ee"
        />
        <path
          d="M145.8,245.3c.5,0,1,0,1.5,0l.2,2c1.2-.6,0-3.8.3-4,1.1.5,1.9,1.2,2.5,2.3l-1.5-.3c.9,1.7-.2,2-.5,3,.6.2.7.8,0,1-.3,0-.7,0-1,0s-.8-.5-1.6,0-.1,1.2-.9,1c.4-2.8-.7-1.9-3-2,0-.2,0-.3,0-.5,0-2.6,2-3.1,4-2.5Z"
          fill="#0347f3"
        />
        <path d="M145.5,248.3c.3.2.3.3,0,.5v-.5Z" fill="#023fef" />
        <path
          d="M150.8,216.8c.8.4,1,.8,0,1-.1,2.1.5,2.5,2.5,3,.5.7-.5,1.8,2,0,0,0,1,.3.5,1s-1-.1-1,.3.8,1.5.5,1.7-.9-1.2-2.5,1c.1.5,0,.6-.5.5-.2.4-.3.4-.5,0-1.5.4-3,.2-4.4-.6-2,1-3.6.3-4.1-1.4,0-.4.1-.8.5-1,2.1.1,1.8-.2-.9-1-3.5,1.3-1-4.9.4-1.9l1-.5c.2-.7.7-1.1,1.5,0,.7-.4.6-.7.5-1.5-.4-.2-.4-.3,0-.5l1.5-.5c-.2,2.6,1.5,2,1-.5,1.2,2,1.3.9,2,1Z"
          fill="#035af1"
        />
        <path
          d="M152.8,224.8l.2.5c.6-.6.9-1.2,1.8-1-.1.9,0,1.6,0,2.5,1.3.4,1.3.9,0,1.5.3.8.3,1.4,0,2-.7,1.2-1.4-.5-1.5-.5h-.7c-.4-.6-1.1-1.4-1.8-2.5-.8-1.2.4-1.7,1.6-1.4v-.6c0-.2.3-.3.4-.5Z"
          fill="#0462f5"
        />
        <path
          d="M151.3,210.8c.4.4.9.4,1.5,0,.5,0,1.3.7,2,.5.1-.4.3-.4.5,0,0,.7,0,.6,0,1.5-.7-.2-2.1-.9-2.5,0,.3.4.6.3,1,0,.5.2.8,1,1,1.5q-.4,1.7,0,0c.2,0,1,.1,1-.2-.3-.4-.4-.8-.5-1.3,2.7.9.3,1.7.5,3.2s1,.2,1,.3c.9,0,.9.9,0,1,1,2.2,1.7,1.6,2,2,.8,1-1,1-1,1.2s.5.6.5.8c.8.2.7,1.1,0,1.5-.4.9-.4,1.4.5,1-.4-.3-.4-.7,0-1-.4-.6-.2-.9.5-.5,0,0,.3,0,.5,0,.7.2,1.1.5.5,1-.2.1-1.2,2.1-1,2.5s1.9-.7,2.5.5c-.1.1-1.3,2.2-1,2.5s1.9-.6,2-.5.6,1.4.5,1.5c-.1.1-.8-.1-1,0-.1-.6-1.1-.6-1.5-.5-.6,1.1-1.1,1.5-1.5,1-.2,0-.7,0-1,0,0,.4-.3.4-.5,0v-.5c.2-.4.3-.4.5,0,0-.5.5-.8,1-1-.6.3-1.1,0-1.4-.8-1.8.1-2.8-.3-3.1-1.2-.7-.7-1.4-1.3-2-2-.5-1.1.3-2.3,2.3-3.4l.2-.6q.5-1.1,0,0c-.6,2.5-3.5,2.3-2,0,.8-.3.6-.8-.4-1.5,1.9-1,1.3-1.7-1.7-1.9l-.4-.6c-1.3,1.9-1.7,1-2-1,0-.2-.5-.9-.5-1-.5-.1-.6-.8,0-1,.5-.2.6-.2,1-.5,0-.8.1-1.5,1-1.5,0-.1,0-.3,0-.5-.3-.2,0-.4.5-.5,0-.4.3-.4.5,0Z"
          fill="#036cf4"
        />
        <path d="M152.8,210.8c-.1,1.3-.9,1.3-2,2-.2-.8.4-1.3.5-2,.5,0,1,0,1.5,0Z" fill="#047df6" />
        <path d="M150.3,211.8c-.4.8,0,.8-1,1.5l-.5-1.5h1.5Z" fill="#024df0" />
        <path d="M150.8,210.8c0,.2-.5.4-.5.5-.2-.2-.4-.3-.5-.5h1Z" fill="#047df6" />
        <path
          d="M154.8,226.8c.5,0,2.4.6,2.5.5.3-.3-.6-2.1,1-1.5-.3.9,1,2.7,1,3-.5.2-.8.5-1,1-.1,0-.4,0-.5,0,0,.3-.2.5-.5.5-.2.2-.3.4-.5.5-.3-.5-.6-.8-.5-1.5l1.5-.2c-.7-.9-1.7-1.1-2.5-.3-.3,1.1-.9.5-.5-.5,0-.5,0-1,0-1.5Z"
          fill="#0256f1"
        />
        <path
          d="M150.8,216.8c.4,0,1.4.5,1.5.5.2-.2-.3-1.2.5-1-.4,2.1,2.2.2,2.5.5s-1.4,2.8-2,2.5l1.5.7c-.4.7-1.1.5-1.5.8-1.6.3-2.2,0-1.8-1.9-.4-.1-.7-.5-.7-1.1v-1Z"
          fill="#0252ea"
        />
        <path
          d="M158.3,222.8c.2.2.3.6.5,1,0,1.2.4,1.7-1,1.5l-.4-2.3c0-.4.7-.1.9-.2Z"
          fill="#025ced"
        />
        <path d="M154.8,214.3c.2.4.6,1.3.5,1.5-2.4.1-2.7-.7-.5-1.5Z" fill="#025af1" />
        <path
          d="M158.3,221.3c1.3-.4.9.9,1,1-.2.1-.4.5-.5.5-.1.4-.3.4-.5,0,0-.5,0-1,0-1.5Z"
          fill="#0256ec"
        />
        <path d="M149.8,215.3c-.8-.8,1.4-1.6,1.5-1.5.5.6-1,2-1.5,1.5Z" fill="#024ff1" />
        <path d="M156.8,225.3h-1c-.2-.7.2-1,.7-1.5l.2,1.5Z" fill="#0155e9" />
        <path
          d="M155.3,220.8c0-.1-.5-.1-.5-.2,0-.2,1.5-1.6,2-1.8.2.9-.8,1.5-1.5,2Z"
          fill="#0787f8"
        />
        <path d="M153.8,212.8c.3,2-1.8.8-1,0s.8,0,1,0Z" fill="#0252f2" />
        <path d="M159.3,228.8c0,.6-.6.7-1,1-.1-1.1,0-1.1,1-1Z" fill="#0462f5" />
        <path d="M158.8,223.8l-.5-.3c0-.2,0-.5,0-.7.1,0,.3,0,.5,0,0,.3,0,.7,0,1Z" fill="#037bf8" />
        <path d="M157.8,230.3h-.5c.2-.2.3-.4.5-.5v.5Z" fill="#0462f5" />
        <path d="M169.8,201.3c.2,0,.7,0,1,0,0,.5,0,1-.5,1l-.5-1Z" fill="#0259f3" />
        <path
          d="M171.3,195.8c.4.1.4.3,0,.5-.7.5-1,1.4-1.5,2s-1,.4-1,1c1.3-.9,3.5.4,2.5,1.5s-2.1-1.5-3-1c.2-.7-.4-1.5-.5-2,.3-1.5.7-1.8,1.3-.7.5,0,.8-.3.7-.8-.6-.6-.3-.9.5-.5.2,0,.7,0,1,0Z"
          fill="#026aef"
        />
        <path
          d="M153.3,199.3c.2-1.7,7.5-2.4,7.9-2.1s.3,4.3,0,4.8l.6.7c.9-1.2,3,.3,1,1-1.4.6-1.4.7,0,.5,1.3-.4,1.5,0,.5,1,.8,0,1.2.4,1,1.5.2.4.3,1.8.5,2-1.9-.3-2.9-1-4.5.5-.3-1.2.3-1.9,1.5-2q.8.2,0,0c1.4-1.6-1.6-1.5-2.5-.5-1.2,0-1.1-.6,0-1-1.4,1.9-4-2.8-.5-1.5.8.1,1.3,1,.5,1.5.5-1-1.1-3.3-2-2.5-.5,2,.4,2.7,2,3.5,0,0-1,1.4-1,1.5.2-2.6-2.5.5-3,0-.2-.6,1.2-2.4,0-2.5-.4,2.8-2.4,0-3.3,2.5s1,.4.8,2.5c-.4.8-1.2,1-1.5,0-.5-.3-.8-.6-1-1-.7-.4-.8-.6,0-1-.2-.2-.2-.3,0-.5l-.5-1v.7c-1.1-.2-1.7.4-1,1.3.7-.7,1-.4.5.5.8.2,1.3.4.5,1,.4,0,.6.2.5.5.4.1.4.3,0,.5-.5.4-.7.9-1,1.5.4,1.4,0,1.5-1,.5.4.9-1.5,1.9-1.5,1.7s1.7-1.4,1.5-.7c1.2-.6,1.5,0,.5,1,2,1.9-.3,4.1-1.4,1.7l-1.1-.7c-.8.6-1,.3-.5-.5-1.8-.7-1.3-3.5.5-4,0-.6-.2-.8-.5-.5.3,1.7-.8,2-3.5.8-.1.9-.6,1.1-1.5.7h-.5c-1.5-.1-1.7-.5-.7-1.7-.6-.5-.5-1.1.2-1.8-.5-.1-.4-.3,0-.5l.5-.5c1.3.4,2.8.5,1.9-1.1s3.2,1.1-1,1.6-2.4-.5-1.9-.9c-3.6-1.1-1-3.5,1.6-4.3l.7-2.1c.3.8,1.3,1.1,1.3.3-1.3-1.2-.6-2.3,1-1,.3.6.6,1,1,1,.1-.4.3-.4.5,0,.8-.1,1.3,0,1.5.5,1.2,0,1.1.6,0,1,0,.9,0,1.7,0,2.5.9,0,1.7,0,2.5,0,1.1,0,.2-1-.5-1.5.7.3.8.6.5,1-.5.5-1.9,1.1-2,0-.7-.1-.6-1.3-.5-2,.6-1.3,1.2-1,2,1-1-1-1.9-2.2,0-2,.4-.9.8-.3,1,.5.5.1,1,.1,1.5,0,.3,0,.5-.4.5-1-.7.7-1,.3-.5-.5-1.6-1.1,1.3-3.9,2-2.5Z"
          fill="#0367f4"
        />
        <path
          d="M158.3,208.3c0,.2,0,.7,0,1-.7.2-1.2,1.1-1.8,1.5-1.4-.7.6-3.5,1.8-2.5Z"
          fill="#0367f4"
        />
        <path
          d="M159.3,206.8c-1.5,1.1-2.7-2.1-4.2-2s-.3,1.1-1.2,1.3c-3.1.7-.2-1.7-.2-2,.1-1-1.4-1.3-1.4-1.5s1-1.7,1.3-1.8.5,1.8,2.3,1c.4,2-1.3.2-1.5.5-.9,1.2,2.3,1.9,3,1,1-1,1.5-.7,1.5,1-2.3-.3-.2,2.1.5,1.5-.1.2.1.9,0,1Z"
          fill="#0373f7"
        />
        <path
          d="M139.3,208.3l3,.5-.5-2c.7-.2,3.8,1.1,3,2-1.5-1.1-2.6,1.1-3.7,1s-.3-1-.8-1l-.5.5c0,0,0,.3,0,.5l-.3.5c-1.4.4-.2-1.2-.2-2Z"
          fill="#024eec"
        />
        <path
          d="M157.3,203.3c-.4-.4-.6-.9-.5-1.5,1.2,1,1-.5,1.2-.4s1.7.4,1.8.5c1.1,1-1.4.8-1,1.7s1.4,1.2,1.5,1.5-.8.6-1,.7c.2-.2-.2-1.2-.5-1.5-.5-.6-1.3-.8-1.5-1Z"
          fill="#037bf9"
        />
        <path d="M162.8,203.8c0,.1,0,.3,0,.5-2.9,3-3-1.8,0-.5Z" fill="#037df8" />
        <path
          d="M150.3,208.8s.5.6,0,1c-.2.7-.6.6-1,0-.2-.2-.4-.4-.5-.5-1.3-.8,1-2.4,1.5-.5Z"
          fill="#067ef5"
        />
        <path
          d="M150.3,208.3c0,.2,0,.3,0,.5-1-.7-1.7-.9-1.5.5-.2-.1-1.1.3-1-.2.2-.8,1.2-1.6,2-1.8.7,0,.7.4.5,1Z"
          fill="#0253ed"
        />
        <path
          d="M149.3,205.8c.4.1.4.3,0,.5-1.2.1-1.6,1.9-2.5,0,.3,0,.5-.3.5-.5h2Z"
          fill="#014ced"
        />
        <path
          d="M150.3,209.8c.3,0,.7,0,1,0,0,.3,0,.7,0,1-.2,0-.3,0-.5,0-.3.3-.6.2-1,0-.3-.3-.5-1-.5-1,.3,0,.7,0,1,0Z"
          fill="#0251ed"
        />
        <path
          d="M148.8,204.8c.6.2,1.2-.2,1.5,1.3s-.9.2-1,.2v-.5c-.1-.3-.4-.7-.5-1Z"
          fill="#0577f6"
        />
        <path
          d="M145.8,211.8c-.4-.5-.6-.9-.5-1.5l2,1c.3.4-.9.8-1,1-.1-.2-.4-.3-.5-.5Z"
          fill="#097cf2"
        />
        <path
          d="M151.8,202.3c.1.2.6,1.9.5,2-.7.1-.2-.4-1-1-.2.6-.1,1.4-1,1.5l-.5-1.5c-.3-.1-.3-.3,0-.5.3.4,1.3.3,1.5.5.1-.4,0-.8.5-1Z"
          fill="#0373f7"
        />
        <path
          d="M148.3,213.8c0,.3,0,.7,0,1l-1.5.7c1.5-.4,1-.4.5-1.7.3,0,.8,0,1,0Z"
          fill="#0151ea"
        />
        <path d="M148.8,202.8c.2-.5-.4-1.3.7-1s0,.8.3,1v.5l-1-.5Z" fill="#0980f8" />
        <path d="M145.3,203.8c-.2.7-.8,1.1-1.5,1v-1s1.5,0,1.5,0Z" fill="#034df3" />
        <path d="M157.8,200.8h-1c-.2-.7.2-1,.7-1.5l.2,1.5Z" fill="#0786fa" />
        <path d="M149.8,207.3c1.9-.3.5.7.5,1l-.5-1Z" fill="#0577f6" />
        <path d="M143.8,210.8c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#035af1" />
        <path d="M139.8,209.3l.5-.5s-.5.4-.5.5Z" fill="#035af1" />
        <path d="M161.8,207.3c.7,0,1.2-.2,1,.5-.3.2-.9-.5-1-.5Z" fill="#033ee2" />
        <path
          d="M176.8,196.8c-.7-.8-1.9-1,0-2.5-.7,1.6,2,2.1,2,2.7s-1.2,1.3-1.5,1.8c-.8-.5.3-1.1-.5-2Z"
          fill="#035ef0"
        />
        <path
          d="M170.8,204.3c.2.1.6,0,.5.5l-.5.5c-1.6,1.4-1.7.5-3,.5,0-.8,0-1.7,0-2.5,1.1.4,2,0,3,1Z"
          fill="#0361f5"
        />
        <path d="M170.8,205.3l.5-.5c.1.4-.3.4-.5.5Z" fill="#0375f6" />
        <path d="M169.8,204.3v1s-1.5,0-1.5,0c.2-.7.8-1.1,1.5-1Z" fill="#037ef6" />
        <path
          d="M175.8,201.8c.2-.4.3-.4.5,0,1.8,1.2-2.4,4-3.5,2-.3.4-.5.8,0,.5,1.4-.3,2-.3,1,1q-.7,1,0,0c.7-1.1,1.8-1.2,2.5,0,.4.1.4.3,0,.5.4.8.6,1.7.5,2.5.2.2.2.3,0,.5-.2.3-.3.3-.5,0,.8,2.7-5,3.4-2.5,1,.8-.9.5-1-1-.5-.2,1.5-1.1,1.3-1.5,0-.4-1.1-1.1,3-.3,3l-.2,1c2.5-1.4,4.8,1.2,2,1.5-.5,1-2.2,1.5-2.5,1.8s-1.8,3.5-.2,2.3c1.4,1.1-2.3.9-3,.8s-.2-.5-1.2-.9q-2.3-1.8,0,0c1.2,1.8,2.1,1.9,4,2.5.4.1.4.3,0,.5-2,.3,0,1.8-2.5,1.5l.3,1.2-.3.3c-.4,1.2-2.7.4-3-.5-.8-.3-1.1.2-1,1.5.2,1.4-.7,1.5-1.5.5-.5.4-2.5.6-2.9.1s.3-3.9,1.4-3.1c-.6-.6.4-.8,1-.5.7-1.7.2-2.8-.5-.5,0,.7-.6.6-1,0-.1.4-.3.4-.5,0-.5-.2-.8-.5-1-1-1.1.8-1.5,0-1.1-2.4-1.1.2-1-.7-.4-1.6.1-.4.3-.4.5,0l.5.5c.1-.4.3-.4.5,0,1.1.9,1.1.7,0-.5-.6-.2-1.1-.5-1.5-1-2.2,2.3-2-.8-.7-2.5l-.8-1c1.4,1,.6,3.5-.5,1.5-1.3.2-1.6-.3-1-1.5,0,.7-.8.7-1,0-.4-1.7,2.2-1.3,2.5,0-1.3-.7-1.5-1,0-1.5-.3-.3-.5-.3-.5,0,0,1-2.4.8-2-.5-2.6-1.8-2.3-4.7,1.6-4.3.5-2.2,4.4.5,3.9,1.8-.5.3-.5.7,0,1,.2,0,.4.2.5.4.7,1.2-.4,2.3-.5-.4-1.2,0-1.2-.6,0-1-.4-1,0-1.5,1-1.5.3-1.3,1.7-1.6,2.6-1.3s1.2,1.5-.1,1.8c-.2.9.8,1.1,1,.1.9.2,1.6.6,1.9,1.4q.5.5,0,0c-1.3-.5-1.7-1.1-.5-2-1-1.4,0-1.4,2.7-.1l.8-.9c.5-.9,1.5-1.1,3-.5l.5-.5c-.6.4-.8.2-.5-.5-.7-.9,0-1.4,2-1.5.1-.4.3-.4.5,0,.3-1.4,1.2-1.6,2.5-1Z"
          fill="#037bf8"
        />
        <path
          d="M170.8,213.3c-.9-.4-.9-1.5-1.3-1.5-1.4,0-1.9.8-1.2,2-1.2-.7-1.5-.2-2.5.5-.5-2.3-1.9-1.9.7-4,.5,2.1,2.6,0,4.2.5.2-.2-1.3-2.4.3-3s1.5-.2,1.2.7-.8-.5-1,0,0,.5,0,.7c-.2.8-.4,1.6-.5,2.5l2.5-.3-2.5,1.8Z"
          fill="#0268f5"
        />
        <path
          d="M160.8,222.3l-1-1.8,2-1.2-2-.5c.7.5,3.9-.2,4,0,1.1,1.9-1.4,1.4-1.5,1.5-.5.5,1,2,1,2.3,0,1.2-1.8.2-2,.2-.7.2-.9.1-.5-.5Z"
          fill="#0268f6"
        />
        <path
          d="M167.8,205.8c0,.6.6,1.3.5,2-1.4-.2-1.8-1.2-2.2.5-.8-.3-.7-1.9-.8-2-.6-.5-.9.5-1,.5-.4.1-.8.7-1,.3.1-.3,0-1.5,0-1.8,1.6-1,1.9.7,2.8.9s1.2-.4,1.7-.4Z"
          fill="#035df1"
        />
        <path
          d="M165.8,218.8c-.4-.1-5.2-1.4-4-2.5.6-.1,2.1.8,2.5.5s-.9-2,.3-2,.3,2.2.4,2.7.6.9.9,1.3Z"
          fill="#0268f6"
        />
        <path
          d="M158.3,209.3c1.3-.3,1.2.3.5,1.3,1.4,0,1.5.3,1.5,1.7,1.6-.8-.3-3.6,2.5-3-1.4,1.1,0,2.8-1.5,2.5l1,.7c-2.7,3.1-1.7-.6-3.3-1.2-.8-.2-1.2,1.9-2.2,1s2.1-1.9,1.5-3Z"
          fill="#036bf6"
        />
        <path
          d="M164.3,224.3v.5c-.2.1-.2.3,0,.5.3.2.7.3,1,.5.8.5,1,.8,0,1,0,0-1.7-.8-2-1s-.2-.6-.5-.7c-.9-.3-2.4,1.1-2-.8.9.2,2-.5,2.8-.4s.6.4.7.4Z"
          fill="#036cf4"
        />
        <path d="M154.8,211.3l-1.5-1c2,.2.2-1,.8-2,2.5.2,1.3,1.4,1.2,3h-.5Z" fill="#0164f3" />
        <path
          d="M164.8,208.8c0,0,1.1-.2,1,.2l-2.5,3.3c-.1-.7-.4-2,0-2.6s1.4,0,1.5-.9Z"
          fill="#036bf6"
        />
        <path
          d="M163.8,214.8c-.7.5-1.9,0-2.3.1s-.2,2.1-1,0l-2.2,1c-.2-1.4.3-.8,1.2-1.1s3.1-.3,3.3-.4-.7-1.1.3-1.5l.7,2Z"
          fill="#036bf6"
        />
        <path
          d="M172.8,209.3c.5-.8,1.4-1.6,2.5-1.5.3,1.6-.2,1.5-1.5,2-.2-.1-1,.3-1.3.5l.3-1Z"
          fill="#0268f5"
        />
        <path
          d="M158.3,217.3c.3.2.3.3,0,.5h-.5l-.5-.5h-.5c-.1-.2.1-.9,0-1l.2-1c.7.4.9,1.5,1.3,2Z"
          fill="#024fe4"
        />
        <path d="M158.3,217.3c.3.4,1.5.3,1.5.8,0,1.6-1.6,1.5-1.5-.3v-.5Z" fill="#026bf7" />
        <path d="M173.8,205.3c.7.8-.6,2.3-1.5,1.5s1-2,1.5-1.5Z" fill="#0268f5" />
        <path d="M160.8,222.3c.1,0,.3.4.5.5,0,0-.9.4-1,.5l-.5-1c.2,0,.7,0,1,0Z" fill="#0539e2" />
        <path d="M172.8,204.3l-.2.5c-.5,0-.4-1,.2-1v.5Z" fill="#0375f6" />
        <path d="M170.5,206.8c.3.2.3.3,0,.5v-.5Z" fill="#0268f5" />
        <path d="M176.8,208.8v-.5h.5c-.1.2-.3.4-.5.5Z" fill="#025bf3" />
        <path d="M159.5,216.8c.3.2.3.3,0,.5v-.5Z" fill="#026bf7" />
        <path d="M165,219.8c.3.2.3.3,0,.5v-.5Z" fill="#0268f6" />
        <path d="M164.3,224.8v.5c-.4-.2-.8-.4-1-.8l1,.3Z" fill="#037bf8" />
        <path d="M157.8,217.8l-.5-.5.5.5Z" fill="#036cf4" />
        <path
          d="M150.8,227.3c2.8.2,1,1.1,2.5,1.8v.7c-.1,0-.3,0-.5,0-.9-.2-2.1.1-3,0-.3-.8,1.3-.5,1.4-1.2s-.4-.6-.4-.8v-.5Z"
          fill="#0245eb"
        />
        <path d="M155.3,228.8c.7,1.1.2.9,0,1.5h-.5c-1-.9,0-1.6,0-2-.1.5.5.4.5.5Z" fill="#0340e5" />
        <path
          d="M154.8,230.3c.1-.4.3-.4.5,0,1.6,1.1,2.2,1.9,1.6,2.6.7.7.7,1.2-.1,1.4-.6-.1-1.7-1.6-3-1-.2.1.4.8.5,1-.9,1.6-1.1,2-.6,1.1l.6.4c-.2.3-1,.4-1,.8,0,.7,1.2,2.2,0,2.7-.7-.3-1.4-.3-2,0,0,.1-.4.3-.5.5-.7.6-1,.3-.5-.5l-.4-.4c.7-1.2.4-1.8-.6-2.6-1.4-.6-3.5-3.1-1.5-3.5-2.8-2.6-.2-3.5,2.3-1.8,1-.4,1.9-.8,2.7-1.2,0-.4.3-.4.5,0,.4,0,.9.1,1.5.5Z"
          fill="#0251f5"
        />
        <path
          d="M153.3,239.3c-.4.2-1.4-.1-2,0,.3-.8-.5-1.5,1.3-.5.2-.7-.3-1.3.7-1.5v2Z"
          fill="#042ae6"
        />
        <path d="M154.3,235.8c-2.7,1-1.4-.4,0-1.5,0,.2.9.2,0,1.5Z" fill="#013dea" />
        <path
          d="M150.3,239.3c0,0-.4,0-.5,0-.5-.2-.5-.5-.5-.5,0-1-.1-1.7-.5-2,0-.2.3-.4.5-.5.2.3,2.5.1,1,3Z"
          fill="#0359f4"
        />
        <path d="M153.3,232.3l-1,1c-.1-1,0-1.1,1-1Z" fill="#126ef1" />
        <path
          d="M129.3,247.3c-1-.6-2.1-.5-2.5-1.5.8,0,2.1.8,2.5-.3s-1.2.1-1-.7c.4,0,1.4-.1,1.5,0,.5.4-1.3,2.3.2,2,.8,0,1.4-1.4,1.8-1.5.3.1.5.5.5,1,.8.4,0,3.4-1,3.5-.3-.1-.7-.3-1-.5-.5-.6-.8-1.3-1-2Z"
          fill="#0339f2"
        />
        <path
          d="M133.3,245.8c.5,0,1,0,1.5,0,.1.4-.5.5-.5.5-1.5.8-1.6,2.5-1.5,4-.7.2-1-.3-1.5-.5.3-1.3.8-2.4,1-3.5v-.5c.1-.3.3-.3.5,0,0-.4.3-.4.5,0Z"
          fill="#0649f2"
        />
        <path
          d="M129.3,247.3c.8.5,1.9,1.4,1,2-.7-.4-1.2-.9-2-1,0,0-.6,0-.5-.5l1.5-.5Z"
          fill="#0649f2"
        />
        <path
          d="M134.8,259.3c-.2.5-.5.9-.5,1.5-.3-.1-.7-.5-1-.5,0-.2,0-.4,0-.5s.5-.5.5-.5c.2,0,.7,0,1,0Z"
          fill="#1155f2"
        />
        <path
          d="M129.8,254.3l.5,1c.4.1.4.3,0,.5l1.5,1c-.5-1-.2-1.3,1-1,.6-.7,1.9.2,1,1,.2.8.2,1.6,0,2.5.5.7.2.9-.5.5-1.4.2-1.4.8-1.3,2.2h-1.8c.8,1.4.2,3.3-1.4,3.8v1c-1.1,1.4-2.8-.4-3.5-1.5-.5.4-1.3.2-1.5-.5-.1,0-.3,0-.5,0-.3.7-.7.5-1-.5-.1.4-.3.5-.5.5,0,.7-.9.7-1,0,0-.1,0-.3,0-.5-1.7-.8-1-2.4,0-3.5.4-2,1.2-.9,2.6-1.5s.2-1.4,1.4-1c0,.4.2.7.5,1l.7.2c.3-.7.6-1.1,1.3-.2,1.3.5,1.3.6,0,1q-.2.2,0,0l.4-.4c1,.8,2.9-.3,2.1-1.1-.3-.2-.3-.3,0-.5-.8.2-1.7-.6-1.5-1.5.9.9.8,1.6-.5,1.5,1.3.7-1.3,1.1-1.4,1-.2-.2,0-2.5.9-2,.2-.2.7-.6,1-.5.3-1,.6-2,.5-3,.3,0,.7.4,1,.5Z"
          fill="#0231e9"
        />
        <path
          d="M120.8,260.8c-.4,1.8,0,2.2,0,3.5-.3,0-.7-.5-1-.5,0,.7-.8.7-1,0,.2-.8.2-1.1,0-2,1.7.2,1.4,0,1.5-1.5l.5.5Z"
          fill="#0124e3"
        />
        <path
          d="M123.3,264.8c-.2.4-.6,1.1-.5,1.5h-.5c-.8.2-.8-.5,0-2,.6,0,.9.5,1,.5Z"
          fill="#021fe0"
        />
        <path d="M125.3,265.3c-.1,0-.3.4-.5.5-.1-.1-1.4.3-1-1,.5.2.9.5,1.5.5Z" fill="#021fe0" />
        <path
          d="M127.3,257.3c0,0-.8,1-.5,1.5s.9-.5,1-.5c.2-1,1.4-.4,2,0v.5c.7,1.8-1.9,1.9-2.5.5-.6,0-.9,1-2,0,1.6.3.3-.5,1-2-.3-.1-.3-.3,0-.5,0,0,1,.4,1,.5Z"
          fill="#0227e3"
        />
        <path
          d="M129.8,258.8c.4-.3,1.5-2.4,2-.7s-.8.7-1.2,1.3-.2,1.2-.3,1.4c-.4.4-2.5,0-2.9-.4s0-.7,0-1c1.5,0,.9,1,2.5-.5Z"
          fill="#0340f1"
        />
        <path d="M124.8,260.3c0,0,0,.7,0,1-1,.5-2.6-.9-2-1.5s1.9.4,2,.5Z" fill="#021fdd" />
        <path d="M128.8,266.3c-.5-.3,0-.4,0-.5v.5Z" fill="#023cef" />
        <path d="M127.3,260.3c.2.2-.5.8-.5.2s.4-.4.5-.2Z" fill="#0227e3" />
        <path d="M129.8,258.3c-.7.8-1.6,0-2,0,.3-.5.4-1,.5-1.5.6.1,1.2.9,1.5,1.5Z" fill="#0340f1" />
        <path d="M129.8,254.3c.2,0,.9-.1,1,0,.4.4-.5.9-.5,1-1.7,0-.7-.2-.5-1Z" fill="#0346f3" />
        <path d="M131.8,256.8c-.4,0-1.3-.6-1.5-1,.7,0,1.3.3,1.5,1Z" fill="#0346f3" />
        <path
          d="M134.3,237.8c.8-.1,1.3.2,1.5,1,0,.4.5,1.2.4,1.8-.1,1-1.2,1.4-.4,2.7-.8,0-1.7,0-2.5-.2l1.5-.5c-.6-.4-1.2-1.4-1.7-1.8s-2.6-.9-2.8-1-.3,0-.5,0v-2c.8,1,2.9,1.2,3.5,0-.4-.1-.4-.3,0-.5.2.2.9.3,1,.5Z"
          fill="#0445f4"
        />
        <path
          d="M119.8,240.8c.3-.9,1.2-1.5,2.6-2,0-1.9,1.3-3.5,3.1-3.3.3-1.7,1-1.4,2.3.8,0,0,.7.5.5,1l-1.5.5c1.4.2,2.2.6,2.5,1.2l.5.8c.1-.4.3-.4.5,0,1.8,1.1,2.4,2.1,2,3-.1.2-.5.4-.5.5-.2.8-.4,1.3-1,.5-.1,0-.4,0-.5,0l-.5-.5c0-.3,1.3-1.8-.2-1.5s-1.3,2.1-2.8,2c-.7-.6,2.5-1.9.5-2.5-.7,1.5-2.2,4.4-1.8,1l-2.2,1.5c-.3,0-.7-.4-1-.5.2-.3,1.1-1.4,1-1.5-.6.4-1.8,0-2,0s-.4,0-.5,0c-.5,0-.8-.9-1-1Z"
          fill="#0442f1"
        />
        <rect fill="#0336ee" height="2" width="1" x="125.3" y="238.3" />
        <path d="M131.8,243.3c0,.5,0,1,0,1.5-.6,0-.8-.8-1-1l1-.5Z" fill="#0339f2" />
        <path d="M130.3,243.8l-.5-.5s.4.3.5.5Z" fill="#0339f2" />
        <path
          d="M132.3,244.3c1.6-.2,2,0,1,1.5-.2,0-.3,0-.5,0l-.5-.5c0-.3,0-.7,0-1Z"
          fill="#0213ce"
        />
        <path d="M132.3,245.8c0,.2,0,.3,0,.5l-.5-1c.1,0,.3,0,.5,0v.5Z" fill="#1963f2" />
        <path d="M133.3,260.3c0,.8.2,1.3.5,2-2,.8-2.3-2.2-.5-2Z" fill="#0231e9" />
        <path
          d="M133.8,263.8c0,.5,0,1,0,1.5-.2.9-.9.2-1-.5,0,0,0-.3,0-.5-.2-1.2.2-1.2,1-.5Z"
          fill="#0225e5"
        />
        <path
          d="M137.8,270.8c.7.1,1.2.5,1.5,1,1.3.4,1.2,0,1.5,0,0,.5.2,1.6-.5,1.5l-.5-.5c-.2,0-.3,0-.5,0-1.4,0-2.1.9-3.5,1,.1-.6,2.5-1.4,1.5-2.5s-1,.5-1.2,1,.8.6-.8.5c-.8-.4-1.4-1-.5-1.5.5-.2,2.1-1,2.5-1l.5.5Z"
          fill="#022de9"
        />
        <path d="M134.8,271.3l.5,1.5c-.5,0-1-.3-1.5-.5-.3-1.5.5-.8,1-1Z" fill="#021edd" />
        <path
          d="M139.8,292.3c.2,0,.3,0,.5,0-.7.5-2.4.9-3,1.5,0,0,0-1.3,0-1.5,1.2,0,.7-.5,2.5,0Z"
          fill="#022de9"
        />
        <path d="M137.3,292.3c-.5,0-.4-.2-.5-.5.4.1.4,0,.5.5Z" fill="#022de9" />
        <path
          d="M128.8,265.8c1.3-.7,1.8-1.7,1.6-2.9,1.1-1.4,2-.9,2.4,1.4.4.2.4.3,0,.5.2.6-.8.3-.7.2,1.1-.7,2.4,3.3,1.5,4.2,1,.6.9,1.6-.3,3.1,1.5.6,1.4,1.5,0,2-2.8.3-4.3-2.8-1-3.5-.4-.9-.9-1.8-1.5-2.5.7.2,1.3,1.7,1,2.5-.8,1.2-1.3,1.2-1.5,0q-.9-.5,0,0c1.4.7-.4,3.9-2,4.5q-.7.7,0,0c2.1-2.4,3.5-2.8,4.5,0,0,.7-.2,1.2-.9,1.2,1.5,2.7-2.5,3-2.2,2.6s2.2.7,1.6,1.6q-.7.9,0,0c-.2-1.4.7-1.5,1.5-.5l1-2.5c-.4-.2-.4-.3,0-.5.7-1.3,3.6-2.2,5-1.5.3-.5,1.1-.4,1.5,0-.1-1,.3-1.2,1-.5,1.3.6.2,2.6-1.1,2.3-1.3.8-2.5,1.8-3.4,2.7l1,.5c.6-.5,1.3-.9,2-1-.3-.8.5-1.2,1-.5l1.1.2c-.5,1.4-.6,2.8-.4,4.2-1.6.4-2.3,2.7-1.6,4.1,2.1,1.3-.2,2.4-1.9,1.4.3,1-.4,1.5-1.1,2.1,0,.2,0,.4,0,.5-.2,0-.9,0-1,0-2.3-1.1-.8-2.6-1-2.9s-2.2-.6-2-2.1l-.7,1c-1.5-.8-1-1.9-1.3-3,.6-1,.6-1.1,0-.5-1.7,1.2-.4-.5-1.5-.5l-1,3c-.2.9-.6.9-1,0-.5-.4-1-.7-1.5-1l-.5-1v-.5c0-1,.8-1.8,1.7-2.1s2.4,1.3,2.8-.1-2.3-3.1-3-1.7c-.2-.6.4-1.5,1-1.5s1.1,1.2,1,0c-.3,0-.8,0-1,0-1.4-.9-.6-2.1-3-1l1-2.5c-.5.8-1.4.5-1.5.5-1-.6-1.2-.4-.5.5-.9.4-1.6.8-2,1s-1-.2-1.5.5c1-2-.3-1.3-.5-1.8s0-.9,0-1.2c-3-1,1-3.8,1.3-3.2.9,1.5,1.5,1.3,1.5-.6.8-.5,1.5-.1,2.2.3-.3-.8-.7-1.2-1.5-1.5l-.4.5c1.3,2.6-1.5,2.5-3.5,1.5-1.2-.2-.9-1.9-1-2-.1-.1-1.2.7-1.5.5s-.7-3.2-2-3.5c.3-.1,1.4-.8,1.5-1-.8-.4-1-.7,0-1,0-.7.8-.9,2.5-.5l1-.5c.5-1,.7-.4,1,.5.4.2.4.3,0,.5l.3.5c-1.7.8.5,2.2,1.7,1-.5-.5-.3-1.7.5-1.5.1-.4.3-.4.5,0l1,1c.9,0,1.3.6,1.2,1.9,1.4-.6,3-.4,4.8.6-1.7,0-2.4-.5-2-1.5-.3-.2-.3-.3,0-.5v-.5Z"
          fill="#022de9"
        />
        <path
          d="M119.3,271.8c0-.1.6-.2.9-.9.7-1.6-.1-3.7,2.1-3.1.5,1.3-.9.8-1,1.3-.2.9.1,2.2,0,3.2,2.1.3.5-1.7.5-2.3,0-1.2,1.3-.2,1.5-.2,1.6.3,2.1.8,1.5,1.5-1.1.8-2.3,0-2,1.5,2.1.6,3.3-1,3.5,2-1.3.5-.9-.7-1.1-.9s-.8.4-1.4.1-1.6-1.4-2.8-1.5c-3.2,0-1.2,1-1,1.9s-.3.3-.3.3c-1,.7-2.1.3-3-.5,1.6-.6,1.6-1.1,2.5-2.5Z"
          fill="#0337ed"
        />
        <path d="M130.8,284.3c0-.5-1-1.6-.3-2,.8.8,2.2,2.8.3,2.5,0-.1,0-.3,0-.5Z" fill="#053fef" />
        <path
          d="M123.8,276.3c-.7-.6-1.3-.3-2,0-.9-1.1,3-2.7,2.5-.5-.2,0-.4.4-.5.5Z"
          fill="#083eee"
        />
        <path
          d="M139.8,286.8c.5,1.8,1.1,1.3,2.5,2-.6.5-1,.8-1.5,1.5-.4.5-.6.7-1,0-1.3,0-1.9.7-3,1,0-1.2.8-3.2-1-2-.5-2.9,2-1.1,3.7-.5.5,0,.2-.6.3-1-.3-.4-.5-.7,0-1Z"
          fill="#0239e9"
        />
        <path
          d="M128.3,275.3c-1.3-1.7-3.7-4-1.2-5.5l.3,2c.6.3.6-2.1,1.5-1s0,1.4-.7,2,.2,1.5.4,1.5c.3,0,2-3.2,1.7-3.5.3.1,1.1,0,1.5,0,.1-.4.3-.4.5,0,0,.2-1.6.8-1,2l1-.2c-.9,1.6-.1,1.1,1,1.7.4.1.4.3,0,.5.7.7.4,1-.5.5-.1-1-2.2-1.3-2.5-1-.6.5.6,3.1-.8,3-.2-1.1-.8-1.4-1.3-2,.3.3,0,2-1,2,1.2-1.7-.6-1.5-.5-1.7.1-.4,1.4-.3,1.5-.2Z"
          fill="#033aef"
        />
        <path
          d="M134.3,274.8c.3-.6.8-.5,1.5.5.6.9-2.8,1.7-2.8,1.3s1.5-.1.8.7c0,.1,0,.3,0,.5l-1,2.5c-.7.5-1.4.4-1.5.5-.1,0,.1.9,0,1-.9.7-1.9-1.3,0-1l-2.3-1,.3-2,2,.5c.2-.7-.7-2.2-.5-2.5s1.6-.4,2-.5.5-.5.5-.5c.3-1.3.5-1.3,1,0Z"
          fill="#0335ed"
        />
        <path
          d="M128.8,266.8c.4.3.4,1.3,1.5,1l1.5-1.5c-.5.4-.9,1.9-1,2-.1.1-2,.2-2.5,1-.2-.3.7-1.3.5-1.5-1-.9-1,.8-1.1.9-.2.2-.8-.4-1.1-.4s-.4,2-1.3,1-.4-3.4-.5-3.5c-.6-.4-.5-.6.5-.5.8-.1,1.6.4,1.5-1h.5c-.4,2.5.7,1.9,1.5,2.5Z"
          fill="#023cef"
        />
        <path
          d="M121.8,264.8c.2.3.4.8.5,1.5.1-.4.3-.4.5,0,0,.2,1.1.4,1,1-1.5.2-3.7,0-4-1.8s.9-.5,1-.7h1Z"
          fill="#0438ef"
        />
        <path
          d="M118.8,263.8c.4.1.4.3,0,.5-.2.6-1.2,1.5-1,2.5h-.5c0-1.3.5-2.3-1-2v-.5c0-.1-.1-.8,0-1s1.8.4,2.5.5Z"
          fill="#021fe0"
        />
        <path d="M130.8,268.3c.9-.9,1.7,1.6,1.5,2.5h-.5c-.2-.5-1.3-2.1-1-2.5Z" fill="#0345f1" />
        <path d="M123.3,269.8c.8,0,1.7,0,2.5,0,0,0-.8,1.4-1,1.5l-1.5-1.5Z" fill="#094bed" />
        <path d="M119.8,263.8c0,.8.2,1.2-.7,1l-.3-.5c0-.2,0-.3,0-.5.3,0,.7,0,1,0Z" fill="#0c48ea" />
        <path d="M130.3,270.8c-.1-.1-1.5.4-1-1,.6,0,.8.9,1,1Z" fill="#135bea" />
        <path
          d="M142.3,274.3l.5.5c.5.6.8,1.3,1.5,1.8-2.9-.3-2.3,1.5-1,3.2.6.8.3,1.8-1,3,.7.2,1.1.4.5,1-.1,0-.3.4-.5.5s-.7-.6-1-.3-1.4,2.4-1.5,2.8,0,.7,0,1c-1.4-.8-.4-3.4-.5-3.5-.3-.3-1.9.7-1.5-1h3c.5-.5-2.9-3.7.5-2.7-.4-.3-.4-.8-.5-1.3-.5-.2-.8,0-1,.5-.2,1.2-1.1,2.2-2,1-.3-.2-.6-.4-1-.5l-.5-1.2c1.5.6,1.1-1,1.5-2.3,2.1,1.8,1.2.4,1.6.2.8-.5,1.1.7,1.9-1.7-.3-.2-.3-.3,0-.5-.6-.6-.6-1,0-1,.2-.3.3-.3.5,0,.2.2.3.3.5.5Z"
          fill="#0241f0"
        />
        <path
          d="M137.8,280.8l-1.5,1.8c1.9,0,.3,3.7-.7,3.2s-1.2-2.4-1.3-2.5c-.4-.3-2.8,1.8-2-1.2s.9-.5,1.2-.9.2-1.4.3-1.5c1-1.1,1.4,1.9,1.5,2,1.6-.2,1.2-1.1,1.5-1.5s0-.4.3-.5c1.2-.3.5.7.7,1Z"
          fill="#033bef"
        />
        <path d="M132.8,280.3c0-1-.1-2.2,1-2.5.2,1.3,0,1.8-1,2.5Z" fill="#033ef1" />
        <path d="M138.3,287.3c-.5.5-2-1-1.5-1.5s2,1,1.5,1.5Z" fill="#0241f0" />
        <path
          d="M125.3,284.8c1.9-.5,1.3-2.6,3-.7-.9.5-2.2.5-2.5,1.7h2s-.5,1-.5,1c-2.4-.5-1-.6-1.5-1s-1.4.3-1-1c.2,0,.3,0,.5,0Z"
          fill="#0335eb"
        />
        <path d="M135.3,286.8v1s-1.5,0-1.5,0c.2-.7.8-1.1,1.5-1Z" fill="#0345ed" />
        <path
          d="M138.8,274.8c.9.4.9.8,0,1-1.5.3-3.9.8-5,1.5,0-.2-1.1-.4-1-1,1.2.3,2.2-.8,3-1,.4-.7,2.5-1.3,3-.5Z"
          fill="#033ef1"
        />
        <path d="M139.8,279.8c0-.1-1-1,.3-1.5s.6.6.7,1l-1,.5Z" fill="#0120d5" />
        <path d="M140.3,275.8c-1.2.6-1.3,0-1.5,0,0-.3,0-.7,0-1,.8,0,1.2.2,1.5,1Z" fill="#0345f0" />
        <path d="M135.8,278.8h-1s0-1.5,0-1.5c.7.2,1.1.8,1,1.5Z" fill="#0447ef" />
        <path
          d="M128.3,195.3c-1.6.4.2-2.6,1.2-1.9l.9,1.1c2.4-.7,2.2.7.9,1.8.6.9,1.7,1.2,2.5.5-1-.5-.5-.7.5-1-3.2,1.8-3.7-2.5,0-1,1.3,0,1.3.4,0,1,.3-1.1.6-1.3,1-.5.6.3.4.7-.5,1,3.7.6,1.9,3.3-1,4l-1.1,1.9c.2,2.1-1.8,2.5-2.4.6-.3,0-.7.5-1,.5l-.5-3.5c.2,0,.3,0,.5,0,.3-1,.6-2.2-.5-1.5-.2-.1-.4-.5-.5-.5-.8-1-1.3-2,0-2.5Z"
          fill="#0368f6"
        />
        <path
          d="M143.3,218.8v.5c-1.1,0-2.1.1-2,1.5,1.4-.6,2.3-1.1,2.7.5,1.2-2,1.6.3,3.2,1.3-1.8-.7-1.2.6-2.2.8s-1.2-.1-1.8,0c-1-.4-1.4-.4-1,0,1.7.2.7,1.5-.5,1.5-.8.3-1.7-.2-2.5-1.5-.3-.4-.3-.7-.5-1-1.1.6-1.6-1-1-1.9s2.4-.1,2.7,1.1-.8-1.5-.3-1.6c.6-.2,1.5-2.4.1-2.7l.9-.7c.3,0,.8-.6,1.2-.5,1.2.7-.1,1.9.8,3Z"
          fill="#024ef1"
        />
        <path
          d="M141.8,224.8c1-.1.8.6,0,1,.7-2,2.2-2.3,4.3-.7,1.1-.9,2-.8,2.9.3,1.3-.6,1.7-.3,1.3.9.3.1.3.3,0,.5-1.7.5-1.9,1.2-2.2-1-1.8.7-2.6.2-3.8,2-.6,0-.7,0-1-.5-1,.4-1.7.4-2,0,.2-.5.3-1,.5-1.5-1.5,0-1.1-1.4-2.5-2v-.5c.6.6,1.7,1.1,2.5,1.5Z"
          fill="#0462f5"
        />
        <path
          d="M123.3,199.3c1.1-1.1,2.1-.5,1.5,1,0,.3,1.4,0,1.7-.3-.3-1.6,1.9-2.2,2.3-.2,1.6,0,1.8,2.9.5,3.5-1.1.4-1.4.9-.8,1.6l-.7.4q-.4.5,0,0c.1-.3.3-.6.4-.6.7,0,3.6.4,4.1.6,1.2.3-.2,1.5-.1,1.4,1.9-2.6,2.4-1.5,1.6,1.1l1.5-.5c.9-1.1,1.4-1,1.5.5.3.2.3.3,0,.5l-2.8,2.8c.4.8.7,1.5.8,2.2-.2,1.7.1,4.4,2.5,3,0-.8.8-.7,1,0l.8.4c2.1,0,2.9,1.3,1.2,3.1-.2.4-1,.6-2.4.7.3,2-.7,4.3-.2,1.5l1.1.3c1.3-.1,1.4,0,.5,1v.5q-.2.2,0,0c1,.2,2,1.2,2.5,2,.9.4.2,1-.5,1.5.1.4.8.4,2,0,.7-.5,1-.4,1,.5,2.5.9-.2,2.3-2,1.5-.9,1.1-1.5,1.5-2,0-1,0-1.9-.8-2.5-2-.4-1.6.9-1.4,1.5-2.5-1.3.3-1.4.4-2.5,0-.3.2-.7.3-1,.5-.3.2-1.4.6-1.5.5-.7-.8.6-1.1,1-1.5l-.2-.5c1.5.2,1.2,0-.8-.5,0-.6,0-1.1,0-1.5-.2-.9.2-1.9,1-2.5q1-.7,0,0c-.8.5-1.3,1.4-1.5,2.5,1.2.3-.6,1.8-1.1,1.9-1.9.3-2-3-1.6-4.3-1.1-.4-1.9-1-2.3-2.1-2.6-.6-3.2.8-4-1.5,2.7,0,4.8,1.4,6.5-1.5-2.2-1-1.2,0-2,.8s-.9-.3-1-.3c1.6-1.1-.3-1.5-.4-1.6-.3-.5.7-1-.6-2.2s-2.2-.5-3.5-.2c-.3,1-.7,1-1,0v-.5c0-.5.2-.6.5-.5,0-.4.3-.7,1-1-1-.9-.8-1.2.5-1l-1-.9c-2.1.4-3.3-.4-1-1.1.4-.8,1.3-1.3,2.5-1.5.2-.2.2-.3,0-.5-.7.8-1.5,1.3-2.5,1.5l-.8.5c-.3,3.8-4.7.9-3.2-1.5.5-.2.9-.5,1-1-.7-1.2-.2-1.7,1-1,.9-.4,1.1,0,.6,1.3l.9.2c-.4-.3-.4-.7,0-1-.7-.6-.4-.8.5-.5.7-.1.3-.3-1-.5-.1.4-.3.4-.5,0-2.6.7-.5-1.8.6-1.1l.9-.4c-.3-.5-.1-.9.5-1Z"
          fill="#034ef2"
        />
        <path
          d="M126.3,213.3c1.3,1.7,2-.2,2,1.5-1.5.2-2.5,1.3-2.5-1.5-.3-.4,0-.5.5-.5.4.1.4.3,0,.5Z"
          fill="#034ef2"
        />
        <path
          d="M135.8,213.3c1.2-1.2,2.4,0,3.2.9,2.9.3,3.7,1,2.3,2.1,0,.9-2.5.8-3,0-.9-.6-1.6-.6-2,0-1.5.9-2.4-2.6-.5-3Z"
          fill="#034ef2"
        />
        <path
          d="M128.8,217.3c1.7.4,1.3.6,2.5,1.2s1-.2,1-.2c0,.2-.8,3.3-.3,4,1.1,1.4,1.5-.4,1.8-.5.1-.5.3-.4.5,0,2.7-.6,1.1.6,0,1.5.1.4-.2.6-1,.5-.6.5-1.2,1.3-1.5,2l1.5.3c-.4.7-.9.6-1.5.8-.1.4-.3.4-.5,0-.2,0-.3,0-.5,0l-2-.5.5-1c-.3,0-.7,0-1,0,0-.7-1-1.3.3-2,.4,0,.8,2.5,2.2,1.2-1.1-.9-2-2.2-3-3.3.7-.9,1-2,1-3.5v-.5Z"
          fill="#0241f3"
        />
        <path
          d="M135.8,213.3c-.4,1.2-1,2.5.5,3,0-.7.8-.8,1,0-1.3,3.1-4.7-2.1-2.5-3,.2.1.8-.1,1,0Z"
          fill="#0240ec"
        />
        <path
          d="M135.3,219.3c-.3-2,2.4-.9,1.5,0-.5,0-1,0-1.5,0,.2,1.4.9,1.3-1,2.5-.2,0-.4,0-.5,0-.8-.3-.7-1.9-.3-2.5.6-1,1.3,0,1.8,0Z"
          fill="#0239ee"
        />
        <path
          d="M136.3,216.3c-.3-1.5.8-.9,2-1,0,.3,0,.7,0,1-.3,0-.7,0-1,0s-.7,0-1,0Z"
          fill="#045ff5"
        />
        <path
          d="M141.3,216.3c.4,1.3.3,4.8-1,3.5s.7-1.9.5-2.5c-2-.2-2.3.7-2.5-1,1.3.1,1.7.1,3,0Z"
          fill="#045ff5"
        />
        <path
          d="M138.8,222.3l-1.5,1.5v-2s-1-.2-1-.2c1.6-.5,1.1-1.4,1.3-1.7,1.3-2.1.9-.4,1.5,0s.9,0,1.1,0c.4.2.6,1.5.5,2l-1.5-1.5c-2.2.3-1.2.9-.5,2Z"
          fill="#0244ef"
        />
        <path
          d="M122.8,205.3c.4-.5.5-2.2,1.3-2.5s0,.6,1.2,1c.4.1.4.3,0,.5v1.5s-2.5,0-2.5,0v-.5Z"
          fill="#0242ef"
        />
        <path
          d="M122.8,202.3s-.4.4-.5.5c-.3.4-.3.6,0,1-.1.4-.5,1-1,1l-.5-2.5c0,0,.4,0,.5-.5h.5c.5,0,.9.2,1,.5Z"
          fill="#0231e7"
        />
        <path
          d="M143.3,227.3c-.8.6-1.5,1.2-2.5,1-.3-.9.5-.9.5-1,.7.2,1.8-1.2,2-1s-.1.8,0,1Z"
          fill="#0235ec"
        />
        <path
          d="M123.8,198.3c.9.6.6,1-.5,1-.7,1.2.3,0,1,1.5-.7.3-1.1-.4-1.5-.5s-.3,0-.5,0c-.2-.7.5-1.6.5-2h1Z"
          fill="#035af1"
        />
        <path d="M134.3,223.3h2c.2.6-.5.5-1,1l-2-.5c.4-.3.8-.4,1-.5Z" fill="#022ee5" />
        <path d="M127.8,209.3c-.4.4-2-1-2-1.2,0-1.3,2.3,0,2,1.2Z" fill="#0434e2" />
        <path d="M124.3,208.8c0,.2.7.8.5,1h-1.5c.1-.4,0-1,0-1.5l1,.5Z" fill="#022cea" />
        <path d="M127.8,205.3c0,.3,0,.7,0,1-2-.7-2.7-1.7,0-1Z" fill="#0964f3" />
        <path d="M136.8,224.8c.1,1.2-.1,1.3-1,.5.1,0,.4-1,.8-1s.1.5.2.5Z" fill="#022fe7" />
        <path d="M121.8,201.8h2s0,.5,0,.5c-.3,0-.8,0-1,0l-1-.5Z" fill="#0242ef" />
        <path d="M122.3,203.8l-.5-.3c-.3-.6.4-.6.5-.7,0,.3,0,.7,0,1Z" fill="#0242ef" />
        <path d="M125.3,203.8c1.1.3,1.9.3,0,.5v-.5Z" fill="#206af8" />
        <path d="M139.3,223.8c.2.2-.5.8-.5.2s.4-.4.5-.2Z" fill="#0244ef" />
        <path
          d="M131.8,226.8c1.7.7.2,1.5.5,2s1.4-.7,1.5.5l-2.7,1c-1.5-2.1.4-1.6.2-3.5.2,0,.4,0,.5,0Z"
          fill="#0234ec"
        />
        <path d="M117.8,204.3c-.3,0-.7.4-1,.5,0-.6,0-1.3,0-2,.7.1.9.9,1,1.5Z" fill="#0220dc" />
        <path d="M117.3,210.3l.5-.5c-.1,0-.3.4-.5.5Z" fill="#033cf1" />
        <path d="M126.3,212.8l-.5.5h-.5c0-.2,0-.4,0-.5.4-.5,1,0,1,0Z" fill="#055df6" />
        <path d="M116.8,211.3c-.3,0-.8,0-1,0l.3-.5.7.5Z" fill="#033bef" />
        <path d="M132.8,230.3c0,1.4-.6,4.3-2.4,2.9s0-.8,0-.9c.8,0,2.2-1.9,2.5-2Z" fill="#0229e5" />
        <path
          d="M140.3,229.3c.3,1.9-.6,1.2-1.5,2s-.1.8-.5,1c0,0-.4,0-.5,0l-1.5-1.7c.8-1.5,2.1.5,2.5.2s-.1-1.2,1.5-1.5Z"
          fill="#0552f4"
        />
        <path
          d="M133.3,236.3c0-.3,0-.7,0-1h1s0,1.5,0,1.5c-.3-.1-.7-.3-1-.5,0,.3,0,.7,0,1s0,.4,0,.5c-1.2.2-1.4-1.5-2.5-2,1.2,0,.8-.3,2.5.5Z"
          fill="#0226e4"
        />
        <path d="M137.3,228.3c.3,0,1-.3,1,.3.2,1.6-.8.2-1,.2v-.5Z" fill="#125ef5" />
        <path d="M129.3,234.8l.5-.5c0,.3,0,.5-.5.5Z" fill="#0336ee" />
        <path d="M313.7,135.3c.3-3.4,3-4.6,2,0l-1.7,2c-.4,0-.3-1.5-.2-2Z" fill="#039bf8" />
        <path
          d="M317.7,144.3c.2.3.6.4,1,.5.5,0,1.1,0,1.5,0,.7.3.9,1.4,0,1.5-.6-.2-2.2-.6-2.7-.5s.1,1.2-1.1,1,0-1.6.2-2c0,0,.7-.8,1-.5Z"
          fill="#05b4fa"
        />
        <path
          d="M343.2,166.3c-.1.4-.3.4-.5,0-.2.2-.3.2-.5,0-.5-.5-.7-1.3,0-1.5.9-.5,1.1.7,1,1.5Z"
          fill="#04a3f9"
        />
        <path
          d="M339.7,162.8c1.6.2,1,2.6-.5,1-.5-.1-.4-.3,0-.5-.6-.9-.3-1.2.5-.5Z"
          fill="#04a3f9"
        />
        <path
          d="M338.7,154.8c.5.4.4.9-.4,1.4h.9c2.2-.2,3.2.9,3,3.1,1.4-.9,3.3-1.6,3.5.5-.4.5-1.1.8-2.1.9-.1,1.6-.6,3-1.4,4.1,0,1-.7.9-1,0-.9,0-1-1.9-.5-2.5l-.5-.5c-.4.3-.8,0-1-.5-.5-.3-.6-.9-.5-1.5-.4,1.3-.5,1.2-1,0-.9.5-1.8.7-2.5.5-.4-.1-.4-.3,0-.5.9-1.1.1-.9-.5-1.5,1.3-1.2-.4-1.7-.5-2-.4-.1-.4-.3,0-.5,1.6-2.1,2.7-.5,4.5-1Z"
          fill="#04a3f9"
        />
        <path
          d="M337.7,160.3c.5.2.7.9,0,1,0,.3-.2.3-.5,0v.5c.1-.5.7-.3,1,0,0-.5.2-.4.5,0,.8.5.3,1.1-.5,1,.2.4.6.7,1,1l.5.4c.8-.8,1.2-.5,1.5.6.4.2.8.7,1,1.5,0,.6-.6,1.6-1.3,1.4-1.7-1.9-6-4.7-6.7-.4.9.6.2,1.3-.9,1.1-.2,2.8-1,3.3-2.3,1.4-1,.3-2.6.6-2.8-.5-1.3-.8.1-.4,0-.4-.7.2-1.3.2-1.1-.6-.2,0-.3,0-.5,0,0-.5.1-1.2.5-2-.3-.8,0-2.4,1-2,.8,0,1.3,0,1.5,0,.1-.4.3-.4.5,0,.4.3.3.6,0,1,0,.4.3.6,1,.5.2-.2.2-.3,0-.5-.5,0-.4-.3,0-.5-.4-1.2.2-1.7,2-1.5-.5-.3-.5-.6,0-1-2.3-.8.3-2.7,1.5-.5.3-1.1,2-2.1,3-1.5Z"
          fill="#04a3f9"
        />
        <path
          d="M339.7,155.3c0,.2-.4.8-.5,1-.3.4-1.7,2.2-2.5,2-.2-2.8.7-1.8,2-3.5s0-.7.5-.5c.5-.3.9.5.5,1Z"
          fill="#047ef3"
        />
        <path
          d="M337.7,159.8v.5c-1.1-.2-2.4,1.5-3,1.5,0-.3,0-.8,0-1s.4-.5.5-.5c.7-.5,1.8-.5,2.5-.5Z"
          fill="#038ff9"
        />
        <rect fill="#037ef5" height="1.5" width="1" x="340.2" y="157.8" />
        <path d="M341.7,160.3c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#0279f0" />
        <path d="M339.7,157.8c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#037ef5" />
        <path d="M339.2,161.3c-1-.4-1.2-.7-.5-1.5.7.3,0,1.1.5,1.5Z" fill="#038ff9" />
        <path d="M340.7,162.3l-.5-.5c.1.2.4.3.5.5Z" fill="#038ff9" />
        <path d="M329.7,151.8v.5c-.3,0-2.5.7-2.5-1.2s1.8.6,2.5.7Z" fill="#02a7fb" />
        <path d="M366.1,182.3l.3-.5c2.2-.2.8.4.7,1h-1c0-.1,0-.5,0-.5Z" fill="#0350e7" />
        <path
          d="M351.2,181.3c.2,0,.3,0,.5,0,.8-.5,1.3-.5,1.5,0,.4.3.8.6,1,1,.3.2.9,1,1,1,.2.3.5.6,1,1-.5.9-1.1,1.8-1.5,2.8l1.5.5c-.9,1.5-1.7.3-2,.3-.5-.2-.9-.5-1-1-.2-.5-.6-.8-1-1-.7,0-.7.3,0,1,.9-.2,1,.5.5,2v.5c.6.7.3.8-.5.5,0,.5-.3.4-.5,0-.9,0-1.9-.1-3-.5-.7,0-1.4-.3-2-2-.3-.3-.5-.3-.5,0,2.5,1.9,2.6,3-.4,4.2,3.2,3.1-3.8,3.6-1.6.8l-1-.5c-.3-1.6-.8-2.1-1.5-1.5-.2-1.5-.6-3.1-1.2-4.7-1.1-.6.3-1.4,1.2-.8.2-.2.2-.3,0-.5,0,.2-.3.3-.8.3,0,1-.6,1.2-1.7.7,0,.2.7,1,.5,1.5l-1.5-.5c-.3-.8-.6-1.7-1-2.5.5.2.9.7,1.5.5s-1.1-1.3.8-1.5c1.5-.3,0,.9.2,1,.8.4,1.2-.8,1.7-.8s1.4,1.3,3.3.3c-.3-2.1.6-1.8,2-1,.4.1.4.3,0,.5l.5,1c.4.2.4.3,0,.5-.5.2-1.2.4-2,.5-.2.6,0,.6.5,0,.3-.4,1.2-.3,1.5,0,.4.1.4.3,0,.5,1.2.5,2.6-.3,3.5-1.5-2.5-.9-1.1-4.7.5-2.5Z"
          fill="#0487f8"
        />
        <path
          d="M350.2,179.3c.3,0,.7,0,1,0v2c-.5,0-1,0-1.5,0-.3,1.7,1.3.3,1,2.5-.9,1.1-2.1,2-3.5,1.5,0-.1,0-.3,0-.5-.4-.2-.4-.3,0-.5-.4-1,1.2-1.2,1.3-.9s-.8.3-.3-.6c.4-.2,2-3.3,2-3.5Z"
          fill="#037df6"
        />
        <path
          d="M341.7,184.3c.4.1.4.3,0,.5-1.7-.3-.4.8-.5,2l2-.5c.2.8-.9.5-1.2,1s-.3,2.1-.3,2.3,2.2-.3,1.5,2.3c-.2.4-.3.4-.5,0l-.5-1.8-1,1.3-.5-2.5c.2-.2,1.3-.6,1-1-2.4,0-.6-2.9-2.5-2.5,0-.8,1.8-1,2.5-1Z"
          fill="#0592fa"
        />
        <path
          d="M350.7,183.8c-.3,2-2.3,2.1-4,2-.1-.4.5-.5.5-.5,1.1-.6,2.3-.1,2.8-1.5h.7Z"
          fill="#0697fb"
        />
        <path
          d="M353.2,186.8c-.3,0-.7,0-1,0-.8-.3-.9-.8,0-1,.3,0,.5-.7.5-1,1.1.4,1.2,1.1.5,2Z"
          fill="#099dfa"
        />
        <path d="M341.7,184.3c.5,0,3.5.6,2.3,1.5l-2.3-1v-.5Z" fill="#07a1fa" />
        <path d="M352.2,185.8c0,.3,0,.7,0,1-1,0-1.7-.4-1-1.5.4-.2.9.5,1,.5Z" fill="#036df4" />
        <path d="M354.2,181.3v1c-.3-.2-1.3.4-1-1h1Z" fill="#036cee" />
        <path d="M347.2,183.8c-2,.2-.6-.7-.5-1,.5.2.4.6.5,1Z" fill="#037df6" />
        <path
          d="M347.2,184.3c0,.2,0,.3,0,.5h-1.5c-.1.4-.3.4-.5,0,.9-.8,1.3-.3,2-.5Z"
          fill="#0697fb"
        />
        <path d="M345.7,184.8c.3,1.8-1.9,1.2-.5,0h.5Z" fill="#0264ed" />
        <path d="M352.2,181.8c.6.6-.2,1.6-1,.2,0-.4,1-.3,1-.2Z" fill="#15a9f8" />
        <path d="M353.7,182.8l-1,1c-.1-1,0-1.1,1-1Z" fill="#036cee" />
        <path d="M346.7,187.3h-.5c0-.2-.1-1,.2-1,.5,0,0,.8.2,1Z" fill="#025ff0" />
        <path d="M351.1,188.3c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#0264ee" />
        <path
          d="M359.6,167.3c.4.9,1.4,1.6,2.2.7l.3.8c2.1,2.3,2.1,3.8,0,4.5q-.8.8,0,0c.8-.7,1.4-1.5,1.7-2.4h.8c-.9,1.3-2.3-.7-1-1.1l1-.5c.6-.7.9-.4.5.5.9.7.7,1.2-.5,1,.5-.7,2.2-.8,3-.5.2-.4.3-.4.5,0,.6.3.7,1,.5,1.5,0,.2,0,.4,0,.5.7.6.4.9-.5.5q-1.4.4,0,0c1.1.3,2.1.3,3,0,.1-.2.7-.3,1-.5.4-.9,1.6-.3,2,.5,3.3,1.5,1.4,1.2,1,2l-1.5,2c-.2,1-.4,2-.5,3-1.2,1.5-2.5-1.2-1.5-2-1.2.2-1.6-.4-.4-.9v-.6q-1.1-.9-.1,0c.8,2.2-3,2.1-1.5,0-.4-.4-.7-.6-1-.5-.9.6-1.2-.8-.9-.7.6,0,.3,2-1.1,1.7.4.1.4.3,0,.5-.4.7-.8.5-1-.5q-.9-.7,0,0c1.2.8,1.2,1.3,0,1.5v.5c-2.4.5-4.7,1.2-6.9,2.2-1.5,2-2.4,2-2.5,0-.5,1-1,1.5-2.1.7-.4-.1-.4-.3,0-.5-.5,0-.4-.2,0-.5.5-1.1,1.4-3.2-.2-4-.6-2.1,1.3-7.8,2.7-3.5,1.1.8,2.1,1.6,3,2.5l-.5-1c0,1.1-1.1.2-1-.8s.4-.3.4-.3c-1.5.5-1.5,0-1.1-1.5h-.7c-.4,0-.4-.2,0-.4l-.5-.5c-.5,1.6-4.5,0-3-1.5.2-.2.3-.3.5-.5,1.1-.5,2.1-1,3-1.5.9-.2,2.1-.7,3-.5Z"
          fill="#037bf7"
        />
        <path
          d="M362.1,168.8c0,0,1.4.9,1.5,1,.4.6-.8.5,1,1-1.6,2.5-1.1,3.8,1,1,1.5,2.2-2.1,2.4-3.5,1.5s-1.3-1.7-1-2l2,1c1-2.3-3-1.7-3-2.2,1-.5,1.3-.2,2-1.2Z"
          fill="#0691fa"
        />
        <path
          d="M356.7,167.8c-.6,1.2-.1,1.5.5,2.5l-3.5-1c.4-.4,1.2-1.4,1.4-1.5.5-.2,1.2,0,1.6,0Z"
          fill="#0593fa"
        />
        <path
          d="M359.6,167.3c.6.1.9,1,1.8,1s.3-1.8,1.2-1-.5,1.4-.5,1.5c-2.5-.6-2.4.1-4.5,1l2-2.5Z"
          fill="#0492f9"
        />
        <path
          d="M371.1,172.8c-.1.1.3.9-.3,1-1,.2-1.9-.7-2.7-1,.1-.1.4-.2.5-.5l2.5.5Z"
          fill="#0265f7"
        />
        <path d="M368.6,171.8l-.5-1.5h.5c.7,1.4.3.7,0,1.5Z" fill="#0356e9" />
        <path
          d="M373.6,176.8l-.9-2.3c1.4-1.9.8,1.7,2.4.3-.4.8-.3,1.6-.5,2-.7-.7-.8,0-1,0Z"
          fill="#036cf6"
        />
        <path
          d="M356.7,172.3c1.3-3.1,1.8-1.2,1,1l3-1c-1.1,1.3,0,2.4-2,2,0,.6.5.5.5.5.6,0,.8.5.5,1-1.3,1.3-1.1-1.9-3.5-1,.2-.5.4-.9.5-1.5s0-.7,0-1Z"
          fill="#0492f9"
        />
        <path
          d="M365.6,176.8c-.2.2-1.6.3-2.1.5s-.2,1.1-.6,1c-1.1-.4-.5-3.3-.2-3.5.9-.9,1.1,1,1.3,1,1.2.1,2-1.3,3.2-1,.1.7-.7.6-1.2,1s-.2.9-.3,1Z"
          fill="#0493fa"
        />
        <path d="M367.6,170.3c-1.5.7-.8,1.1-3,.5.2-.3.3-.9.5-1,1-.9,1.7-.2,2.5.5Z" fill="#0495fa" />
        <path d="M362.1,173.3c.4.4-.8,1.9-1.5,2-.5-1,.9-2.6,1.5-2Z" fill="#0391f9" />
        <path d="M368.1,172.8c-1.1,1.3-1.5,1.9-1.5-.5.9-.3,1.2.3,1.5.5Z" fill="#0b95f9" />
        <path d="M369.6,176.3c-.2-.1-.6,0-1-.5l.2-1,.8,1.5Z" fill="#0264f0" />
        <path d="M359.1,174.8c1.3-.1,1.3.2.5,1-.4-.2-.4-.7-.5-1Z" fill="#0359e6" />
        <path d="M371.1,176.3c0,0-2.1,0-1-1s.9.8,1,1Z" fill="#1494f7" />
        <path d="M358.1,178.3v1s-1.5,0-1.5,0c.2-.7.8-1.1,1.5-1Z" fill="#10a2f3" />
        <path
          d="M347.2,165.8q-.9.9,0,0c.1-.4.3-.4.5,0,.6.6,1.5-1.1,0,2,.5,0,2.3.3,2.5.5,1.6,1.6-2.4.4-2.5.5-1.1,1,2.2,1,.5,2,0,.8-1.1.6-1.5,0-.6-.6-.7-.5-.5.5.6,1.2,1.8,1.2,0,1.8v.7c-.1.4-.3.4-.5,0-.4-3.1-1.4-.1-1.5,0s-2-.5-2,.7,1.6,0,2-.7c1.2.3-.3,2.2,0,2.5,1.1,1,1.7-1.8,2.5-1s-.8,1.4-.8,1.7,1.2,1.3.8,2.3c-.8-.4-1.7-1.6-1.5-2.5-2.2-.3-1.6,1-1.9,2.4.5-.1,1.3.5,1.4.6.4,1.3.4,2.4,0,3.5l-.4,1.3c-2.3-1.3-4-.6-6.1.6l-1-1.3c1.6.8,2,1.6,1,2.5.2.5.7.8.5,1.5-1.9-1.1-1.4.5-1.8.5s-1.5-.7-2.2-.5c1-1.3,3.2-.6,1.2-2.5-.2-.1-.3,1.9-1.2,1s.8-2.1-1.5-1.5c.3.8,1.9.6.7,2-.2,0-.5,0-.7,0,0-.3,0-.7,0-1-.3,0-.7,0-1,0-1.5-3.4,2-2,2.5-3-1.3-.3-1.3-.6,0-1,.7,0,.5.2,1.5,0,.6.3.6.7,0,1l1,1c-.8-.3-.9-.7-.5-1-.3-.5-.1-1,.5-1,0-.2.4-.3.5-.5q.3-.5,0,0c-.8-.1-1.3-.8-2.5,0-.3-2.3,2.3-2.1,3-4,.9.3.3.8.5,1.5.7,0,1.7.2,2.1.7.7,1.2-2.4-.4.4-1.7.5-.4,2.1.5,0-2.3,0-.4,1.5.3.5-1.7.7-1.3.5-2.3-.6-3.1-.6.5-.7.3-.4-.4.4-1,.5-2.1.5-3.2l1.5-.8c.1,0,.4,0,.5,0-1.4-4.5,2.1-2.2,4-.5Z"
          fill="#0498f9"
        />
        <path
          d="M337.7,181.3c.1-.2-.3-1,.2-1,.8,1.9,3.1-.5,2.7,1.5-1.1.4-2.1-.4-3-.5Z"
          fill="#027ef9"
        />
        <path d="M343.7,182.8c-2-.3-2.2-.2-1.5-2l1.5,2Z" fill="#0180f8" />
        <path d="M336.7,182.8c.2.3.3.7.5,1-.4-.2-.9,0-1.3-.5s.3-.4.3-.5h.5Z" fill="#05a4fa" />
        <path
          d="M346.2,171.3c-.4-.8-.6-1.7-1-2.5.5,0,1.7-.8,2-.5,1,.8-1,1.1-1,1.3,0,.4.3.9.5,1.2s0,.4,0,.5h-.5Z"
          fill="#0380f5"
        />
        <path
          d="M340.2,169.8c.1,0,.3.4.5.5,1.5,1,3.5,1.6,1,3.5,0,0-.9-1.4-1-1.5q.7-.8,0,0c0,0-.3,0-.5,0l-1-2.3.5-.2c.2,0,.4,0,.5,0Z"
          fill="#0381f3"
        />
        <path d="M347.2,165.8c.5.5-1,2-1.5,1.5s1-2,1.5-1.5Z" fill="#0277ed" />
        <path
          d="M374.6,176.8c-.7,1.4-1.3.6-1,2.5l.5,1.5s.5,0,.5,0c.6-.4.5-.9.5-1.5l1,1.5c.8.2.3-.7.6-.9,2.1-1.5.8,1,.9,1.9-.2,1-.2,1.5.3,2.4,0,.2-1.9,1.9-2.3,2.1.1-1,.5-.9,1,0,.2,0,.3,0,.5,0,.5.5.5,1.5,0,2,0,.3,0,.6,0,.7-.6.3-2.7.8-2.5-.2-.1.4-.3.4-.5,0-.4-.2-.4-.3,0-.5-.4-.1-.4-.3,0-.5,0-.7.7-1.4,1.5-1.5l-1.5,1.5c-1.1.5-2.4,1-3.7,1.5-.7-.7-1.3-1.7-1.8-2.5-.4-.2-.4-.3,0-.5-.4-1,0-1.3,1-1.5-2.3-.3,0-1.9,1.6-2-.1-1.6,1.1-2.1,1.9-1,1.2,1.3,1.4,1.2.5-.5-.5.3-1,.2-1-.5-1-.8-.8-1.2.5-1-.1-2.1-2.3-1.9.5-3-.7-1.7,1-1.6,1,0Z"
          fill="#0581f8"
        />
        <path
          d="M377.6,181.8c0,1.4,1.2,2.5.5,4l-1.5.5c-.3,0-.7,0-1,0,.6-2.2-1-2.9,2-2.2l-1.5-2,1.5-.2Z"
          fill="#0266f3"
        />
        <path d="M374.1,180.8c-.7-.4-.4-.9-.5-1.5l.5,1.5Z" fill="#0578f7" />
        <path
          d="M372.6,180.8c.7.1.6.3,1,.5.4.6.2.8-.5.5h-1.3s1.3,1.5,1.3,1.5c-1.6-.7-2.2,1-2.3,1-.3,0-.9-.6-1.1-.4s0,.9,0,.9c-.6.4-.9.8-1,1.5,0,.1,0,.4,0,.5.8.5.6.6-.5.5-.2.2-.3.3-.5.5-.7.4-1.2.2-1.5-.5v-.5c-.4-.7-.2-1.2.8-1.7-.3-1.3,0-1.9.7-1.8.3,0,.9-.7,1-.5s-.3,1,.2,1c1.1-.7.4-1.4.3-2.5l2,1c.3-.4-1.9-2.1,1.5-1.5Z"
          fill="#037bf7"
        />
        <path
          d="M373.6,181.3c.5.3.7.6,1.6,1.1,2.3,1.2-1.4,1.2-2.1,1.4.6-.9,0-1.4,0-2s.2-.6.5-.5Z"
          fill="#036ef7"
        />
        <path
          d="M368.6,186.8l2,2v-2c1.3-.5.8.9,1.3,1s1.6,0,2.2,0c0,.2,0,.3,0,.5-.3,0-.9,0-1,0,.2.5.1.9-.5,1-3.4,1.4-2.6.2-3.5-1.5l-.5-.5h-.5c.2-.2.5-.5.5-.5Z"
          fill="#0266f3"
        />
        <path d="M375.6,186.3c-.2.9,0,1.3-1.5,1.5,0-.6-.3-1-.5-1.5.7,0,1.3,0,2,0Z" fill="#0366f6" />
        <path d="M369.6,184.8l-1,1.5c0,0-.9-1.1-.5-1.5s1.3.1,1.5,0Z" fill="#0266f3" />
        <path d="M375.1,184.3c0,2.2-1.7.9-3,1-.4-1.8,2-.2,3-1Z" fill="#0366f6" />
        <path
          d="M295.7,94.9c1.5,1,2.5,1.3,3,1v-.5c2.2.2,1.1,1.4,0,2.5s-.9,0-.9,0c-.4.6-.4,2.1-.6,2.9-.5.5-1.2.3-1-.5l-1.5-.5c.6,1.7-2,1.2-1.5,0,.4-.4,1.8-3.1,1.5-3.5-.3,0-.7,0-1,0-.3.7-.7.7-1,0-2.8,0-1.4,1.5-.5,1-.2.1-.6,1.2-1.5,1,0,0-.3-.3-.5-.5-1.3-.8-.9-2.3.5-2.5.5-.5,1.1-.5,2,0-.7-.7-.4-1,.5-.5-.2-1,.4-1.3,1-.5.9-.2,1.4,0,1.5.5Z"
          fill="#18b3fb"
        />
        <path
          d="M287.7,90.9c.8-.4,1-.3.5.5.1,1.3.2,1.8-1,2.3v.7c0-.2-.7-.9,0-1.5-.2-.9-1.6-.7-1.9-1.1s0-.8,0-.9c.4-1.5,1.9-1.4,2.5,0Z"
          fill="#1ba9fb"
        />
        <path
          d="M287.2,92.9c0,.4,0,.9,0,1.5.3.4.7,0,1.2-1.3,1,1.4,1.5,3,1.8,4.8.7-.6.9-.3.5.5,1.6,0,1.8,1,.7,2.8,1.2,1.2.3,3.3-1.2,2.2-.4-.1-.4-.3,0-.5,0-.4,0-2.8,0-2.9-.2-.2-1.2-.2-1.6-.5s-.5-2-1.3-.8.7,3.1-1.6,3.3c-.1.5-.3.4-.5,0-.5,0-.7-.6-.5-1.5h-1.5c.4.1.4.3,0,.5-.5,0-1,0-1.5,0-.8-1.5-1.9-3.5.5-4v-.5c-1.1,0-1.1-.5-1-1.5v-.5c.9-.4,1.7-1,2.5-1.7,1,.6,1.6.6,2.5.2,0-.6.5-.3,1,0Z"
          fill="#10acfa"
        />
        <path
          d="M281.2,94.9c.7.5.9.5,1,1.5h-.5c-.1.4-.3.4-.5,0-.5,0-1.1,0-1.5,0,1.2-.7,1-.7.5-2,.1,0,.8.4,1,.5Z"
          fill="#1ba9fb"
        />
        <path
          d="M284.2,100.4c.1,0,.3,0,.5,0,.2.5,0,.7-.5.5-.3.2-.7.3-1,.5,0-.1,0-.3,0-.5,0-.2,0-.5,0-.5.4-.3.8-.3,1,0Z"
          fill="#0383f5"
        />
        <path
          d="M290.7,95.4l-.5,2.5c0-.1-1.5-.4-2-1.8,1.7-.4.2-1.2.5-2.7l-1,2.5c-1.9.3-.5-.9-.5-1.5-.1-1.2-.1-2.5,1-3,0-.4.3-.4.5,0,.9-.1,1.2.4,1,1.6.9.3,1.2,1.5,1,2.4Z"
          fill="#0c98f5"
        />
        <rect fill="#1ba9fb" height="2" width="1" x="285.2" y="94.4" />
        <path d="M285.2,101.9c-.9-.1-1.2.4-1-1,.2-.1.3-.3.5-.5,0,0,0-.6.5-.5v2Z" fill="#05a3f9" />
        <path d="M284.2,100.4c-.3,0-.8-.1-1,0l.7-.5.3.5Z" fill="#05a3f9" />
        <path d="M282.2,96.9l-.5-.5h.5c0,.1,0,.4,0,.5Z" fill="#0b87f0" />
        <path
          d="M290.2,86.4c.3.3,1.5-.7.5,1.5,3.1-1.1,1.5.8,3.5,1.5s.3.4.5.5c0,.2,0,.3,0,.5,0,1.3,0,1.4-1,.5-1-.4-1.8-.4-2.5,0-.5-1-1.7-1-3.5,0-.8-.1-1.7,0-2.5,0,0-.2,0-.6-.2-1-.4-.5-3-1.1-.3-1.5.6,0,1.3,0,1.8.5l.2-1.5c.2,0,.3,0,.5,0,.2.4.3.4.5,0,.3,0,.7,0,1,0,.6-.1,1-.2,1.5-1Z"
          fill="#229bf7"
        />
        <path
          d="M288.7,87.4c.2-.3,1.4-1.1,1.5-1,.2.3-.1,1-.5,1.3-.7.5-.9-.3-1-.3Z"
          fill="#41aff9"
        />
        <path d="M287.7,87.4c.2,1.4-.7,1.4-.5,0,.2,0,.3,0,.5,0Z" fill="#2da4fa" />
        <path
          d="M294.7,90.4c0,1.8,1.1-.3,1,1.5h.5c0-.3,0-.9,0-1s.7.6.9.4,0-1.6,1.1-.9-.2,1.5,1.5,1v.5c-.3,0-1.4.5-1.5,1s.6.9.5,2.5,0,.4,0,.5c-.7.4-2.4-.2-3-1-.2-.1-1.2.1-1.5-.5l-.2-.7c-3,.5-3.3-1.3-.8-2.3-.7-.7-.4-1,.5-.5.1-.1.7-.4,1-.5Z"
          fill="#21abfb"
        />
        <path
          d="M312.2,97.4c0-.1,1.2-1.4,1.5-1.5l-.5,2.5,2.5.8c-1,0-.9,1.1-1,1.2-.2.2-.3.3-.5.5-.4.2-.7.6-1,1-.7,1.5-1.2,1.3-2,0-.7-.2-.5-.6,0-1-.2-1.4.3-1.8,1.5-1,0-.6-.1-1-.5-1.5-1.4-.3-1.3-.5,0-1Z"
          fill="#158ef2"
        />
        <path
          d="M309.7,97.4c.2,0,.3,0,.5,0v.6c.8-.6,1.9-.6,2,.4.7.4,1.2.9.5,1.5-.5.4-1,.7-1.5,1-.2.9-.4,1.3-1,.5.2.5-.3.8-1.5,1-.5,0-1.1,0-1.5,0-.7-.2-1.7-.8-2-1.5-.6-1.2,1.1-2.9,2.5-3,.2-.2,1.3.4,1-1,.2,0,.4,0,.5,0l.5.5Z"
          fill="#0b99f8"
        />
        <path
          d="M312.2,97.4c0,.2,0,.7,0,1,.5.2,1.1,0,1.5.7-.2.4-.7.5-1,.7-.2-.5-.5-1-.5-1.5-1.9-.8-.9,0-2.5.5-.2.9.8.3,1,.5.9,1-4.7,1.3-.5-2,.5,0,1.2-.8,2,0Z"
          fill="#1ea6fa"
        />
        <path d="M309.7,97.4c-.3,0-.5-.2-.5-.5.2,0,.4.3.5.5Z" fill="#169ef8" />
        <path
          d="M307.7,97.9c-.3.2-1.4,1.1-1.5,1.5,2.9.2,3.3,2.3,0,2l1.5-1.2c-1.3-.9-1.8.2-2.5.8s-.4,1-.8,1-3.1-.9-3.2-1c-1.6-1.5,2.2-.5,2.5-.5s.4-.4.5-.5c-.7-.7-.4-1,.5-1,.2,0,1.8-1.6,3-1Z"
          fill="#17affa"
        />
        <path d="M304.7,98.9c0,.5-.2.7-.5,1-.7-.3-1.2-.7-1-1.5.5-.2,1.3.5,1.5.5Z" fill="#0886ef" />
        <path
          d="M314.2,100.9c2.8-.5,1.2,1.8,1.6,3.1s.9.8.9.9c0,.3,0,.7,0,1-.2.9-.7.9-1,0-2.3-.4-2.9-1.5-1.7-3.3l-.8-.7c-.4-1.4.9-.9,1-1Z"
          fill="#1aabfa"
        />
        <path
          d="M317.2,111.9s-.2.4-.7.5c-.8,0-3.4-.3-4.3-.7l3.2-.8c.5,0-.3,2,1.8,0,0,.3,0,.7,0,1Z"
          fill="#0499f8"
        />
        <path d="M319.2,106.9c1.6.3,2.5.3,0,.5v-.5Z" fill="#025ee2" />
        <path
          d="M317.7,105.4c.2.5.7,1,1.5,1.5.4.1.4.3,0,.5l1.5.3c0-.2.4-.2,1.5.2.2-1.1,1.3-1.2,1.5,0,1.9-.4,3.1,0,3.5,1.5.3-1,2.2-.4,2,.5.6,2.3-1.9,4-3.2,2-1.5.6-3.7-1.8-2.8-3,.6-.6,0-.3-.5,0,.5.9,1,1.8,1.7,2.7l-1.7.3.9-.3c.1-1.3,1.9.6,2.1,1.3.2-.3.4,0,.5.5.7-.2.8.4.5,1-.1.3-.3.5-.4.5-2.4-.1-.3-.4.9-.5-1.9-3.6,3.6-2.3,4.6.6h1.4c0,1.7,1.1,1.5,2.5.9,0,.3-1.3,2.5-2,2-.3.7-1.2-.4-1.1-.4.1-.2,2.8,2.2.8,3.2s-4-.4-3.1-1.2c0-.4-.3-.5-.5-.5-.7,0-.9.3-1,1l.5.5c.5-.9,1.3-.5,1,.5.3.5,0,1.7-.5,2,.6.7.3.9-.5.5-.2.4-.3.4-.5,0-1.3,0-2.6.6-3.9,1.9l-.6-.4c-.6-.4-1.3-.7-2-1-.4-.2-.3-.5.5-1l-2.2-.2c-1-1.9-1.9-2.4-2.8-1.4-1.6.4-2.3-1.9,0-2.8-.4-.1-.4-.3,0-.5.1-1.7,1.8.6,1.7.5s-1.3-.8-1.3-.9c-.4-.9,1.8-2.1,2.6-1.1.5-.2.7,0,.5.5l1,1c.5.3,1,.3,1.5,0,.3-.3,1-.3,2,0v-.5c-.3.9-1.7.5-1.5-.5.5-1.4.3-1.4-.5,0,.8.3.9.8,0,1-.3.9-.9.5-1.5,0-1,.3-1.1-.3-.5-1,.8-.6.8-.8,0-.5-.4.4-.8,0-1-.5-1.1,1.1-1.6.4-1.5-2-.4-.1-.7-.4-.5-1-1.1-1.5,2.2-1.1,2.5.5.4,0,.8,0,1-.5-.7-.6-.3-.8.5-1-.6.7-1.9,1.2-2,0-.3-.6,0-1.1,1-1.5-.9-.9-1.8-1.1-2.5-.5,1.1.7.9.8,0,1.5-.1.9-.7.9-1,0-.3.5-.7.6-1,.5-.5-.1-.5-.4,0-1-1-.2,1-2.2,1-2,0,.3-1.6,2.1-2.2,1.9s-3.9-2.3-2.8-2.9c.2-.7,1.1-1,2.5-1,.6-.7.8-.4,1,.5q.2.9,0,0c-1.2-.7-1.2-1.2,0-1.5-.9-.3-.9-.8,0-1,.9-1.1,1.3-.9,1,.5Z"
          fill="#05a5fa"
        />
        <path
          d="M328.7,119.9c0,0-.4-.7-1-.5l-.5,1.5c.2-1.4-2.2-1.4-1.4-2.4s1.4,0,.9-1.6l2,1.5c.1-.6-.5-1.6-.3-2,1.1-1.8,2.2-.4,2.8,1-1,0-2.8.6-1.5,1.5.4.1.4.3,0,.5-.1,0-.4.5-.5.5,0,.4-.3.4-.5,0Z"
          fill="#038ff7"
        />
        <path d="M329.7,118.9l.3-.5h1.2s-1,1-1,1c-.2,0-.3,0-.5,0v-.5Z" fill="#027bed" />
        <path
          d="M330.2,123.4c-.5.1-.6,0-.5-.5.4-.6.2-1.4.5-2,.2,0,.3,0,.5,0l-.5,2.5Z"
          fill="#0181f4"
        />
        <path d="M329.2,120.4c0,0-.1.6-.5.5v-1c.2,0,.3,0,.5,0v.5Z" fill="#027bed" />
        <path d="M326.7,114.4h.5c0,.5,0,1,0,1.5-2.4-.7-4.2-2.7-.5-1.5Z" fill="#0388f3" />
        <path d="M322.7,108.9c0,0-.4,0-.5-.2l1.5-.2c.1.4-.5.4-.5.5h-.5Z" fill="#119ff9" />
        <path
          d="M314.7,117.9c1.5.5,0,2.5,3,.5-.7.5-1.1,2-.5,2.5,1,.9.8-1.5,1.7-1l1.8,2.5c1.2.4.8-.6,1.4-1,1.7-1,3.1,1,2.6,1.5s-1.8-1.2-2-1,.1.9,0,1c-.6.7-2.3.4-3-.5-1-.2-2.1,0-3.2.5-.6-.3-2.8-3.4-2.9-4.4s0-.4.2-.6c.3-1,.7-1,1,0Z"
          fill="#0394f8"
        />
        <path
          d="M319.2,113.9c.1.2.8.4.9.6.1.4-.6,1.1-.3,1.4s.8,0,1,0c.3.1.3.3,0,.5l-2,.5,1,1.5c-.8.3-1.4-.4-2-.5-.8-.2-2,.1-2-.5,1.9.2,1.1-2.2,1.5-2.5s1.3,0,1,.7l-1,.7c.7,0,1.3.2,1.7-.5.8-1.2-2.1-2.1.2-2Z"
          fill="#0499f8"
        />
        <path
          d="M327.2,121.4c0,.1,0,.7,0,1-.2.2-3.9-1.9-3.5-3,.1-.1,3.4,1.8,3.5,2Z"
          fill="#048ff7"
        />
        <path d="M322.2,123.9c.9-.6,2.3-.2,2,1-.7.2-1.9-.2-2-1Z" fill="#047ef0" />
        <path
          d="M322.2,117.9c-.3,0-.9.7-1.5.5-.2-.5.5-1.2.5-1.5.1-.4.3-.4.5,0,.2.3.3.7.5,1Z"
          fill="#0397f9"
        />
        <path
          d="M325.7,117.4c.3.1.3.3,0,.5-.3,1.1-1.7,0-2,0,0-.3,0-.7,0-1,.1-.4.3-.4.5,0,.4.6,1.1.4,1.5.5Z"
          fill="#0397f9"
        />
        <path d="M323.7,117.9c-.3,1.7-.5,1.5-1.5,0,.5,0,1,0,1.5,0Z" fill="#0397f9" />
        <path d="M321.7,116.4c.4.2.4.3,0,.5h-.5s-.4-.3-.5-.5v-.5c.3.1.9.3,1,.5Z" fill="#047be8" />
        <path
          d="M317.7,105.4c2,.8,3.6.3,5.5.5,0,.9-1.4.3-2,1.3s1,.3,1,.7c-.7,0-1.9,1-3-.5,1.8,0,1.8-.3,0-.5-.8-.1-2.1,0-2-1.2l.5-.3Z"
          fill="#0784f5"
        />
        <path
          d="M321.7,110.4c.1.3.7.9.5,1l-1.5.5c0,1.2-2,.3-1.5-.5-.6-.5,0-1.3,0-1.5.2-1,2-.3,2.5.5Z"
          fill="#07acfa"
        />
        <path
          d="M313.7,105.9c.7,0,1.9.2,2,1-.5.9-1.6,1-2.5,1h-.5c-.9-.5-.3-1.6.5-2,.1-.4.3-.4.5,0Z"
          fill="#15b1f9"
        />
        <path
          d="M319.2,111.4c.5.2-.3.4,1.5.5s1.3,0,2,0c0,.1,0,.6-.5,1,.3,1.2,0,1.3-1,.5-1.9,1-.6-.6-1.8-1s-.6.5-.7.5c-.9.3-1.5,1.5-2,1s1.3-1.8,1.5-2.5c.2,0,.8,0,1,0Z"
          fill="#0398f7"
        />
        <path
          d="M315.7,105.9c.3,0,.7,0,1,0,0,.4,0,1.1,0,1.5-.3-.2-.7-.4-1-.5-1.1-.4-1.5.2-2-1-.7-1.4,0-1.4,2,0Z"
          fill="#058ff7"
        />
        <path d="M319.2,109.9c0-.2-.7-.9-.5-1,2,0,2.4-.2,3,1.5l-2.5-.5Z" fill="#0486f6" />
        <path d="M316.7,107.4c.2,0,.7,0,1,0,.2,1.3-.3,1-1.5,1,0-.4.5-.7.5-1Z" fill="#058bf7" />
        <path d="M324.2,116.9h-.5c.1-.7.4-1.3.5-2,1.4.5.9,1.2,0,2Z" fill="#08b3fc" />
        <path d="M325.7,117.9v-.5c.2,0,.4,0,.5.2l-.5.2Z" fill="#28caee" />
        <path
          d="M321.7,116.4c0-2.1,1.4-.9,1.5.7,0,.6-1.2,0-1.5-.2,0-.1,0-.4,0-.5Z"
          fill="#08b3fc"
        />
        <path d="M322.2,112.9l.5,2-1.5-1.5c.3-.2,1-.5,1-.5Z" fill="#0ab8fc" />
        <path d="M319.2,103.4v.5c-.3,0-.7,0-1,0v-.7c.1-.3.5-.2.5-.3l.5.5Z" fill="#0b6eea" />
        <path
          d="M324.2,126.9c.7,1.8.7,2.9-1.5,3.2,1.1.2,1.3,2.4,1.5,2.5.7.4,1.1-.4,2,.2-1.2,2.4-1.6.5-3.5.5,1.2-2.6-.4-1.8-.5-2-.2-.3.1-2.4,0-3l2,.5c-.1-.5-.4-.9-.5-1.5-.6-.9-.4-1.2.5-.5Z"
          fill="#0398f8"
        />
        <path
          d="M320.7,127.9c.9-2,2.6-3.6,3.5-1-.3,0-.5.3-.5.5-1.5-2.5-1.4-.2-2,.2s-.9.2-1,.3Z"
          fill="#0388f3"
        />
        <path
          d="M320.7,127.9c-.1.3.1,1.4,0,1.5s-1.4,0-1.5,0c-.9-.8,1.1-1.2,1.5-1.5Z"
          fill="#048ff2"
        />
        <path d="M315.2,123.4c.1,0,.6-.7,1-.5l-.5,2c-.2-.3-.2-1.1-.5-1.5Z" fill="#028ef5" />
        <path d="M322.2,131.3v1c-.7.2-1-.2-1.5-.7l1.5-.2Z" fill="#0387f3" />
        <path d="M318.7,123.9c.8,0,1.2-.2,1,.7-.1.7-1-.3-1-.2v-.5Z" fill="#0680f2" />
        <path
          d="M313.2,105.9c0,.7-.2,1.4-.5,2s-1.1.4-1,.7l2,1.2c-.8.3-1.7.6-2.5,1,1.1-1.3-.6-2-.5-3.2s3.2-2.6.5-2.8c.3-3.1,3.6-1.2,2,1Z"
          fill="#05a5fa"
        />
        <path
          d="M313.7,114.9c1.4.8,1.6,1.6,1,3-.3,0-.7,0-1,0,0,0-.5-.1-.5-.5s.8-1.1.5-1.5-.8,0-1,0c-.4-.2-.8-.7-1.5-.5-.2-.6.4-.8.5-1,.6-.9,2.1-.7,2,.5Z"
          fill="#04b3fb"
        />
        <path
          d="M311.7,114.4c0-.2-.3-.9.3-1,.9-.2,2.9-.1,3.2,1l-1.5.5c-.7-.3-1.3-.5-2-.5Z"
          fill="#0398f7"
        />
        <path
          d="M365.6,178.3c.2,0,.3,0,.5,0,1.7.3-.3,2.9-1,1-.6.9-1.7,1.3-3.3,1.2-2.3.5-3.2,1.4-2.7,2.8q.2.2,0,0c-1.6-2.1,4.2-3.3,6-3,.4.6-.3,2.7-.8,1.7l-1.2.3c-1.3,1-2.9,1.4-3,1.5s.7,1.4-.5,2.5c.6,1.3,0,1.4-1,.5-.1,0-.4,0-.5,0-.3.1-.5.5-.5,1-.2.4-.3.7-.5,1-.4.3-.7.3-1,0-.1.3-.3.3-.5,0l-.5.5c-.5,1.4-.8,1.1-1.5,0-.1.3-.3.3-.5,0-.1.4-.3.4-.5,0-.4-.1-.4-.3,0-.5-.2-.2-.2-.3,0-.5l.5-.5c-.1-.8.8-.7,1,0,0-.2.2-.4.3-.4.9,0,.5.9.2,0-.6-1.7-.7-3,1.5-3.2.3-.5,0-.9-1-1-1.3.3-1.7,0-1-1-.4-.1-.4-.3,0-.5,2-1.2.8-2.5,3.5-1.5l-.7,1.5c2.6-.8-1-2.9,2.7-1.5v-1.5s2,1,2,1c-.9-1.3-1.8-2.3-1.5-4,1.1.3,1.2,3.2,2.3,3.5s2.2-.8,3.2-1Z"
          fill="#0591f8"
        />
        <path d="M358.2,186.8c-.2.3-.3.7-.5,1,0-.6-2-1.6-2-1.7.8-2.1,2.2.6,2.5.7Z" fill="#0270f2" />
        <path
          d="M365.1,179.3c0,.3,0,.7,0,1-.9,1-2.6.4-3.2.5s-2,.9-2.2,1.1c-.4.2-.4,1.3-.6,1.4s-1.2-.4-1.5-.2c1.4-3,4.9-2.6,7.5-3.8Z"
          fill="#027ff3"
        />
        <path
          d="M353.2,186.8c.9.1,1.2-.4,1,1-.3,0-.8,0-1,0l-.5.5c0,0,0,.3,0,.5-.7-.3-.5-1.3-.5-2,.3-1,.7-1,1,0Z"
          fill="#0374f5"
        />
        <path d="M356.2,184.3c-1.5-.2-3.7-.4-1-1,.9.2,2.3-1.6,1,1Z" fill="#036cee" />
        <path d="M360.4,182.8c.3.2.3.3,0,.5v-.5Z" fill="#0481f7" />
        <path d="M359.1,183.3c.2-.2.8.5.2.5s-.4-.4-.2-.5Z" fill="#0481f7" />
        <path d="M358.4,185.3c.3.2.3.3,0,.5v-.5Z" fill="#0270f2" />
        <path d="M352.7,188.3l.5-.5s-.4.4-.5.5Z" fill="#0487f8" />
        <path d="M355.2,189.3c.1,0,.3-.5.5-.5l-.5.5Z" fill="#0487f8" />
        <path d="M353.2,189.3c.2,0,.3,0,.5,0l-.2.5-.2-.5Z" fill="#0487f8" />
        <path
          d="M341.7,194.3c0,.2.5,1.4.5,1.5.2.4.3.7.5,1-.7,1.3-1.6.5-2,.5-.4-.2-.6-.8-.5-1.6l-1-1.4c0-.2.8-1.3,1-1.5h.5c0,.6.8,1.1,1,1.5Z"
          fill="#0487f8"
        />
        <path
          d="M352.7,190.3h1.5c.3,1.4-.8.8-1.5,2-1.7.1-.5-.5-.5-1v-.5c0-.3.2-.5.5-.5Z"
          fill="#0397f8"
        />
        <path d="M352.2,190.8c0-.2,0-.3,0-.5h.5l-.5.5Z" fill="#0487f8" />
        <path
          d="M346.7,187.3c1.1,1.7,1.9,1,2,1.1.2.2,0,.8,0,.9.9.1,2,.3,2.5,1,1.2.4.4,2.2-1,1.5,0,.4-.4.8-1,1,2.2,0,2.4.8.5,1.5,0,.3,0,.7,0,1-.1.4-.3.4-.5,0-.7,1.2-2.1.9-4.2-.7l-1.3.2c-.4,0-.8.6-1,1-.1.4-.3.4-.5,0-.8.4-1.2-1-.5-1.5-.8-.9.5-1.7,1.5-1.5l.5-.5c.1-.4.3-.4.5,0,.2,1,.8,1.7,1.5,1,1-.9-1.1-.7-1-1.7.3-1.7,2.2-1.3,2.5-2.1s-.8-1.6-1-2.2c.1-.4.3-.4.5,0Z"
          fill="#048ffa"
        />
        <path
          d="M352.2,190.3c.3,0,.2.3,0,.5v.5l.5,1c-.3.5-.3,1,0,1.5-.1,0-.3.4-.5.5-.8-1.9-1-1.9-.5,0-.7,0-1.3,0-2,0,.3-.9,1-.7-.5-1.5l1-1c.2-.1-.5-1.5,1-.5.1-.3,0-.7,0-1-.7-.7-.4-.7.5-.5.1,0,.3,0,.5,0v.5Z"
          fill="#0282f7"
        />
        <path
          d="M349.2,195.3c0,.3,0,.8,0,1-2.2,1.4-2.8-1.9-5.5-1.5,1.3-1.6,2.8.6,3.8.9s1.2-.3,1.7-.4Z"
          fill="#027af6"
        />
        <path
          d="M344.2,192.3h-.5l-.5.5c-.5.5-1.1.9-1.5,1.5-1,.4-2.3-.7-1-1.5l1.5-.5c.2,0,.3-.4.5-.5s.4,0,.5,0c.3-.2.5-.6.5-1h.5c0,.5,0,1.1,0,1.5Z"
          fill="#0371f1"
        />
        <path
          d="M351.7,189.8c-.1.2-.5.4-.5.5-1.1,0-1.8-.1-2.5-1,1.5-.8,2.3.3,3,.5Z"
          fill="#0374f5"
        />
        <path
          d="M350.2,191.8l.5,1c-.5,0-1,0-1.5,0-2.3.2.3,2-2,2-.9-3.1,2.5-2.5,3-3Z"
          fill="#0369ef"
        />
        <path d="M348.7,190.3c.4,1.5-1.7,1.3-2.5,2,0-1.3,1.2-2.2,2.5-2Z" fill="#0375f4" />
        <path d="M343.2,192.8l.5-.5c-.2.2-.3.3-.5.5Z" fill="#0487f8" />
        <path d="M352.2,191.3c0,0,0-.2,0-.5v.5Z" fill="#0374f5" />
        <path
          d="M351.7,213.3c0,0,.1-.8,1-.5-.7,1.7-.2,2.3,1,3.5.7-1,1.2-.8,1,.5.2.2.3.3.5.5l.5.5v.5c-.2,0-.6.5-1,.5-1.3-.5-2.1-.4-2.5.5-.1-1.7,1.8-1.3,2.5,0,1.1.3,2.5,1.1,3.1,1.3s1.2.2,1.9.2c.2,2.3-1.8.2-2.3.2s-.7.7-1,.7c-.5,0-1.1-1.2-1.7-1.4-1-.2-2.4.6-2.5.5-.2-.2.1-1.4,0-1.5s-1.1,0-1.5,0c1.1-1.3-.1-2.7,0-3.7s1.5-.8,1-2.3Z"
          fill="#0364f6"
        />
        <path
          d="M355.2,214.8c0,.2,1.4.7-.5,1.3v.7c-.2-.2-.8-.3-1-.5-.2-.8.4-1.1,1-1.5h.5Z"
          fill="#0d8afa"
        />
        <path d="M355.7,217.8l-.5-.5c.2.2.4.3.5.5Z" fill="#0474f7" />
        <path d="M354.7,218.8v.5c-1.3-.4-2.4,0-2.5,0s-.1-1.1-.5-1.5l1.5-1,1.5,2Z" fill="#0785f9" />
        <path d="M352.7,217.3h-1s0-1.5,0-1.5c.7.2,1.1.8,1,1.5Z" fill="#0587f8" />
        <path d="M369.1,211.8c-.4-1.8,2-1.1.5,0-.2.3-.3.3-.5,0Z" fill="#0555f0" />
        <path
          d="M369.6,213.3c-.2.2-.3.9-.5,1v.7c-.7-.3-1.4,0-1,.8.5-.5.8-.2.5.5-.8.3-1.4.8-1.8,1.4l-.7-.9c-.1.4-.3.4-.5,0-.3-.5-.6-.5-1,0,.4.1.4.3,0,.5-.2-.4-3.1-.3-3.5,0-1,1.1-1.5,0-1.5-3-.7-.7-.5-1.1.5-1,.4.2.4,1.1.7,1,1-.4,2.5-3.1,4.7-3.5,1.6-.1,3,.7,4,2.5Z"
          fill="#036ef7"
        />
        <path
          d="M368.1,210.8c0,.3.3.8.5,1,.5,0,.8.2,1,.5.2,0,.4.3.5.5,0,0-.3.3-.5.5-1.4-.5-2.5-2.8-4-2.5.8-.6,1.6-.3,2.5,0Z"
          fill="#045df3"
        />
        <path
          d="M359.6,214.3l2,.5c.3,1.4-3.4,2-.5,2.5-.2.1-.3.8-.5,1-.3,0-.7,0-1,0,0-.4-.5-1.7-.5-2s.3-1.6.5-2Z"
          fill="#0681fa"
        />
        <path d="M365.1,213.8c-.1,2.5-2.4,1.4-2.5-.5l2.5.5Z" fill="#0257ef" />
        <path d="M364.6,216.8c-.2-1.3.3-1,1.5-1l-.5,1c-.3,0-.7,0-1,0Z" fill="#0453ed" />
        <path
          d="M368.1,215.8l.3-.5c.8-.1.9,0,.7.7,0,.3-.4.2-.5.3,0-.2-.3-.5-.5-.5Z"
          fill="#067bf4"
        />
        <path d="M369.6,211.8v.5c-.3-.2-.6,0-1-.5h1Z" fill="#0463f6" />
        <path d="M346.7,201.8c-.3.3-.5.6-1,.5l1-.5Z" fill="#0487f8" />
        <path d="M219.7,377.2h-.5l.2-.5c.3,0,.2.3.2.5Z" fill="#024abb" />
        <path d="M218.7,378.7c-.2-.2.5-.8.5-.2s-.4.4-.5.2Z" fill="#024abb" />
        <path
          d="M312.2,150.3c0,1.4.6,2.7,1.7,4,.9,3.8-4.6,6.1-3.9,1.6-3.3-.7-2.2-3.7.3-2.1.4.4,1.5,1,1.5,0-2.7-1.7-5.7.8-1.7,2.2.2,1.1.1,2.1-.7,1.1v.6c-1.5,0-2.6.4-3.6,1.1.4.1.4.3,0,.5-.1,0-.3,0-.5,0-.1,1-.7,1-1,0,0,0-.3-.5-.7-.5s-1.4,2-2.8,1.5l2.5-3c-1.6.6-3.6.5-5-.5v-.5l.3-.6c2.8.8,3.9.3,3.2-1.4-1.3.4-2-.4-1-1.5-.7,0-.7-.8,0-1-.5-1.3.5-2,1.5-1-.2-1.4.2-1.5,1-.5.3.1.3.3,0,.5.3.5,0,.8-1,1,1.1.5,1.4,1.2,1,2,.7.2,1.2-.2,1.8-1.3l.7.3c-.5-.5,0-.7.5-1-.7-.3-.9-.6-.5-1,.2-.6.5-.4,1,0,.1-1,1.1-1.6,3-1.8,1.4-2.5,3-1.2,2.5,1.3Z"
          fill="#039cf9"
        />
        <path d="M305.2,159.3c.2.9.6,1,0,1.5-1.3.5-2.2.2-1-1v-.5c.3,0,.3-.2,1,0Z" fill="#03a2fb" />
        <path
          d="M298.2,153.8c1.1.3,2.3.5,3.5.5.1.2,1.7-.2,1,2.5l-4.5-.5c-.6-1-.8-1.6,0-2.5Z"
          fill="#0275ef"
        />
        <path
          d="M300.7,152.8c0,0,.9,1.4,1,1.5-1.3,3.3-1.4.6-1.8.5s-2.4.4-1.6-1l1-.5c.1,0,.3,0,.5,0,.2-.7.4-1.1,1-.5Z"
          fill="#038df8"
        />
        <path d="M300.7,151.8c0,.3,0,.8,0,1-.3.1-.7.4-1,.5v-.5c0-1.9.9-1,1-1Z" fill="#0383f5" />
        <path d="M302.2,151.8h2c.1.8-.4,1.5-1,2-.6-.7-1.7-.9-1-2Z" fill="#038df8" />
        <path d="M306.7,150.8c-.3,0-.7,0-1,0-1.3-1.4.5-1.4,1,0Z" fill="#0186f8" />
        <path d="M306.2,151.8l-.5,1c-1.6-1.1,0-.8.5-1Z" fill="#0282f1" />
        <path d="M311.7,153.8s.5,0,.5.2c-.1.8-2.5,1.5-2-.2.5,0,1,0,1.5,0Z" fill="#04b9fc" />
        <path d="M312.7,158.8s-1.1.2-1-.2c.8-1.4,1.6-.3,1,.2Z" fill="#0493f4" />
        <path d="M312.2,155.8l-1,1c-.1-1,0-1.1,1-1Z" fill="#04b1fb" />
        <path d="M335.7,166.8c-.8.3-.5-1.5.5-1.5.2.3-.4,1.5-.5,1.5Z" fill="#0270e2" />
        <path d="M339.7,162.3l-.5-.5c.3.1.3.3.5.5Z" fill="#04a3f9" />
        <path
          d="M340.2,169.8c-.1.4-.3.4-.5,0-1.1,1.2-2.2,1.1-2.3-1l-.2.9c2,1.8.6,3.1-1.5,3.1q-.7-.6,0,0c1,1.2-.1,2.4-1.5,2.5-.2-.1-1.4,0-1.5-1.3s2.5-1.2,1.5-2.2-.8,1.8-2,1-1.2-1.7-1-2,1.8.9,2.5.5l-.5-2.5c2.9.3,1.6-.3,2-1.5s.5-.5.5-.5c2.1-1.3,6.5,0,4.5,3Z"
          fill="#04a6fa"
        />
        <path
          d="M335.7,172.8c.6-.7,1.2-1.2,2-1.8l-1.5-.3c.6-1.3.9-1.3-.5-1.7,1-1.2,3.1-2.8,4-.8l-2,1.5c1.1-.5,1.3-.2,2,0,.7.9.8,1.7.5,2.5-.9.4.3,2.7-3.5.5-.7,1.3,1.1,1.6,1,1.7-.6,1.3-1.7.7-2.5,1.3-.3-.2-.7-.3-1-.5,0-1.3.7-.9.8-1.1.2-.5-.6,0,.7-1.4-.5.5-1.6-.4-1-1s1.5.5,1,1Z"
          fill="#038ef7"
        />
        <path d="M335.7,170.8h-1.5s0-1,0-1c.7-.2,1.3.3,1.5,1Z" fill="#047ff3" />
        <path
          d="M339.2,194.3c1.8.4,2.1,1.4,1.5,3-.2,0-.8.8-1.5.5.8-1.2,0-2.7,0-3.5Z"
          fill="#0376f1"
        />
        <path d="M342.2,192.3c-.4.2-.7.8-1.5.5h-.5c.2-.1.2-.4.5-.5s1.1,0,1.5,0Z" fill="#0592fa" />
        <path
          d="M356.7,194.8c-.1.4-.3.4-.5,0-.2.3-.1.6,0,1,.4.1.4.3,0,.5-.1,0-1.2.4-1.5.5-.2.9-.6,1.4-1.5,1-.4,1.3.9,2.5,1.8,1.2,1.2-.2,1.2,2.1.2,2.8-.5,1.1-3.9,2.4-4.5,2l.5-1c-.7,0-1.3,0-2,0-1.6,0-2.2-.3-2-1,.2-.3.2-.6,0-1l-2,1.5c1,.4-.2,1.3-1,1-.3-.3-.5,0-.5,0-.4.3-.4.8,0,1.5.4.4,1.7.7,1,1.5-1,1.2-2.7,0-3.5-.5-1.3-1-2.2-2-2.5-3l-1,.5c-.1.4-.3.4-.5,0-.6.4-.8.2-.5-.5-.2-.6-.5-1.1-1-1.5-2-.9-1.2-.8-2-1.5-.7-.7-.4-1,.5-.5.9.8,1.3,0,2.5,0l-.7,1.5c1.6-.6,2.3.2,3.7-1h-2c-1.3-1.3,3.5-1.7,4.2-1.5s.3,1,.3,1c.4.5.9.8,1.5,1,.1-.3,1.5-1.9,2-1.5.7-.1.8-.4.5-1,.3-1.9-1.7-.9-1,0-.9-1.7.3-2.9-2-2.5,1.1,1.5.7,1.7.5,3-.1.4-.3.4-.5,0,0-.5,0-1,0-1.5-.8,0-1-.4-.5-1-.8-1,0-1.9,1-1l1.1-.3c1.4,1,2.9,1.6,4.3,1.8.7-.6,1-.3.5.5h1.5c-.4-.9,0-2,1-1.5,0,.2-.5.6-.4.7.4,1.6,1.6,0,1.9-.2-.1,0-1.1.2-1-.2.5-.5.8-.9,1.5-.7,0,0-.5,1-.5,1,.6-.3,1.9.8,1.5-1.5h1.2s.3.5.3.5Z"
          fill="#0487f8"
        />
        <path d="M335.7,201.3c.8.4,1.8.3,1.5,1.2l-.5.3c-.4-.3-.9-.4-1-1v-.5Z" fill="#10a5f8" />
        <path
          d="M353.2,198.3c.5.3,1,.3,1.5,0,3.3-.5,1.8,2.4,1.5,4.5-.1,0-.9.6-1,.5,0-.5,0-1.1,0-1.5-.3-1.6-1-.8-1-1.2s1.2.2,1-.7h-3c.3-.7.5-1.4,1-2,.4.1.4.3,0,.5Z"
          fill="#026af1"
        />
        <path
          d="M352.2,195.3c-.9.1-.6,1.1-1,1.5-.6.4-.9.2-.5-.5,0-.3,0-.7,0-1,0,0,1.6-1.2,1.5,0Z"
          fill="#048ffa"
        />
        <path
          d="M347.2,201.8c.5.7,1.5.3,2,1-.8,0-2.9.3-3.5.5-.3.5-.7.7-1,.5,0-.1-.3-.4-.5-.5.6-.2.7-.5,1-1,.1-.3.3-.3.5,0l1-.5c-.5-.6-.3-.8.5-.5.4.2.4.3,0,.5Z"
          fill="#0895f8"
        />
        <path d="M343.7,203.3v1.5c-.5-.5-1.6-.7-1.5-1.7.1-.4,1.1.1,1.5.2Z" fill="#0266ee" />
        <path
          d="M338.7,202.8c1.2-1,.5,2.3,2.5,0v3c-.8-.5-1.3-.3-1.7-1.5-.5,0-.1,1-.2,1.5-.6,1-1.1,1.1-1.5.5,0,0-.6-.4-.5-.5s1-.5,1-.7c0-.5-1.1-.5-1.5-.8l.5-1c.1,0,.3,0,.5,0,.3-.3.6-.4,1-.5Z"
          fill="#0595fb"
        />
        <path d="M343.2,199.3c0-.3,0-.7,0-1h.5c0,0,.9.8-.5,1Z" fill="#0377f2" />
        <path
          d="M343.2,199.3c0,.3.4.7.5,1,0,0,0,.4-.4,1.1s1.5,1.5-1.6.4c-.2-.3.6-.7.8-1,.3-.7-1.4-1.3-.3-1.5,0,0,.8,0,1,0Z"
          fill="#0377f2"
        />
        <path
          d="M346.2,197.8c.8.3.8.5,2,.2-.5,1.4-1.1,1.6-2.5.8s-.4-.7-.5-1c0,.1.7,0,1,0Z"
          fill="#046ff3"
        />
        <path d="M347.2,200.8v.5c-.2.1-.3.3-.5.5l-1,.5h-.5c.6-1.2-.2-1.4,2-1.5Z" fill="#0260e9" />
        <path
          d="M354.7,198.3c-.3.9-.8.5-1.5,0v-.5c.2-.2,1.2-.9,1.5-1,0,.5,0,1,0,1.5Z"
          fill="#0363f2"
        />
        <path d="M353.7,201.8c-.3.3-1.5-.4-1.5-.7,0-1.4,2.2,0,1.5.7Z" fill="#035fed" />
        <path d="M338.7,202.8c-.5.5.9,1.1-1,.5,0-.8-.2-1.2.7-1l.3.5Z" fill="#0363eb" />
        <path d="M351.2,196.8c0,0,.1.6-.8.5s-.6-.4-.7-.5l1-.5c0,.1.4.3.5.5Z" fill="#027af6" />
        <polygon fill="#0481f7" points="356.2 195.8 355.7 195.1 356.2 194.8 356.2 195.8" />
        <path d="M342.4,205.3c.3.2.3.3,0,.5v-.5Z" fill="#047af7" />
        <path d="M342.7,195.8c.5.1.4.6.5,1h-.5c-2,.2-.5-.7-.5-1h.5Z" fill="#026df2" />
        <path d="M354.7,198.3c0,1.7-.7,1.3-1.5,0,.5,0,1,0,1.5,0Z" fill="#0487f8" />
        <path
          d="M347.2,200.8c.2,0,.6.7,1,.3s1.3-2.8,1.7-2.8c1.7.2,1.3,2.1,1.3,3.5h-4c0,0,0-.3,0-.5-.4-.1-.4-.3,0-.5Z"
          fill="#0367f2"
        />
        <path d="M350.1,200.8c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#0c94fa" />
        <path
          d="M298.2,100.9l1-1-.3-1.5c1.5.7.8,2.4,1.2,3.2s1.5,0,1.5.6c0,1.5-.8.2-1.5.2v1.5s-2-1.5-2-1.5c.6,0,1,.4,1.5.5.3-2.1-.4-1.2-1-1.5-.4,0-.6-.1-.5-.5Z"
          fill="#13b4fb"
        />
        <path d="M304.7,104.4c-.1,0-.4,0-.5,0-.2-2.1.7-2.1.5,0Z" fill="#0286ef" />
        <path
          d="M303.7,106.9s.3.4.5.5c.6.7.3,1-.5.5-.1,0-.4,0-.5,0-.3-.4-.4-.3-.5-1,.1,0,.8,0,1,0Z"
          fill="#0484f3"
        />
        <path
          d="M307.2,111.9l.2-.6c-1.6-1.5-2.7-2.7-2.7-5.3s2.2-1.6,2.6-1.6c.5,0,1.9,3.2,1.8,4,.9.6,2.2,1.9,1.6,3,.6.5,1.2.5,1,1.5-.3-.1-.7-.5-1-.5l-.5.5c-.2,0-1.3-.8-1.5-.5s.2,1.2-.1,1.9-1.6,1.6-1.7,1.6c-2,.7-1.1-1.2-2.6-1-.6,2.3,1.8,1.1,3,2.5.4.1.4.3,0,.5-.1.1.1.9,0,1s-1.1-.8-1.5-1-.7-.3-1-.5c-1.8-1-3.6-2.9-5.5-2-.2-2.3,2.9-1.3,3-1.5.3-.5-.5-.9-.5-1-.5,0-.4-.2,0-.5,0-.2,1.3-1.2-1-1.7s-1.6.7-2.2,1.2c-.5-2.4,2.4-1.6,3.8-2l1.1-1.5c.3,0,4.9,2.5,3.4,3.5.6.7.8.7.5,0Z"
          fill="#03a4fa"
        />
        <path
          d="M304.2,104.4c.1-.4.3-.4.5,0,.7,0,.7-1.2,1.2.5,2-.7.5-1,1.3-2.5.1-.8,1.4-.9,1.5,0h.5c.4.1.4.3,0,.5-.4.4-.1.6,1,.5,1-.5,1.1.1.5,1l.5.5c2.1-.9,1.8,2.1.2,3.1.9,1.5.8,2.5-.2,2.9-.2,0-.3.4-.5.5-1-.8-.5-1.3-2.5-.5l1.5-1.5c-2.3.5-1.2-1.3-1.9-2.9s-1-1.4-1.6-1.6c.5,1.3-1.2,1.5-1,2.2.3,1.4,1.8,2.1,2.3,2.9s1.2,2.6-.3,1.9c-.2.4-.3.4-.5,0-.2-.1-.7-1.3-1-1l-.5,1c-.1-1.2-.8-2.2-1.8-3-.4,1.1-.5.8-1.2,1v-.5c-1.1-.4,0-2,1-1.5.1-.4.3-.4.5,0,.5.4.7.3.5-.5-.6.4-.9.2-.5-.5-.6-.3-.6-1.1,0-1.5-1,.2-1.7,0-2-.5l-.5.5c1.1.2.9.6,0,1-2.1-1.2,2.3-4.2,2.5-4,0,.8-.2,1.6.5,2Z"
          fill="#09b3fb"
        />
        <path d="M310.2,112.9s-.1-.5.5-.5l-.5.5Z" fill="#07acfa" />
        <path
          d="M307.2,111.9c.7.6,1.3.4,1,1.5-.8-.4-1.8-.4-1.5-1.5.1,0,.4,0,.5,0Z"
          fill="#028af6"
        />
        <path d="M306.7,107.9c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#09b3fb" />
        <path d="M304.2,107.4c.3.2,1.2,1.4,1,1.5-1.1.3-1.1-.6-1.5-1l.5-.5Z" fill="#03a4fa" />
        <path
          d="M293.2,99.9l.3.3c.4.1,1.1-.4,1.2-.3.6,0,1.1.1,1.5.5.3,0,.7.4,1,.5s.8,0,1,0,.3.4.5.5c-.8,0-3.5.2-4,.5s-.1,1.9,0,1.9,2.9,0,1.5,1-1.5,0-2,0c0-.3,0-.7,0-1-.2-.2-1.8.7-2,.5-.6-.6,2.5-2.8,2-3.5s-1.7,1.5-2.5.5,1.4-1.4,1.5-1.5Z"
          fill="#09b4fa"
        />
        <path
          d="M294.2,104.9c-.1,1-.3,1.5-1.5,1.5-.5,0-1.5.9-2.5-.5,1.7-.9,1.9-.7,4-1Z"
          fill="#04aefb"
        />
        <path d="M301.2,105.4c0-.2.3-.4.5-.5-.1,0-.3.4-.5.5Z" fill="#09a8fa" />
        <path
          d="M301.7,125.4c.2-.4.3-.4.5,0,.5.2.8.7,1,1.5.9-.2,1.4.5.5,1q-.6.7,0,0l.5-.5c1,.9,1.7,1,3,1l.5.2c.9-2.5,1.6-.9,2,.3.6-2.9,1.4-3.9,2.5-2.8-1.1,1.3-.6,2,.7,3l-.5,1c1.1,1.4.6,2.9-.9,1.6-1,1.2-1.7,1.4-3.3,1.7-.2.7-.5.5-1,0-.4-.1-.4-.3,0-.5,0-.4,0-.7-.5-1-.4-.1-.4-.3,0-.5q-.2-.5,0,0c-.2,1.4-.4,1.2-1,0-.6-.3-1.3-.8-2-1.5-1,.7-2.2-.4-1.9-1.5-.3-1.1-1.2-.4-.6.5.7.6,1.5,1.1,2.5,1.5,1.7-.6,1.5,1.2,0,1.5l-.5.5c-.2.4-.3.4-.5,0l-.5.5c.6-.2.9,0,1,.5-.2.4,0,.5,1,.5,1.1-.3,3-.3,2,1v.5c.7.2.5.7,0,1-1.6.1-.9-.5-1-2-.8-.2-.2.9-.8,1-1,.3-2.4-.2-3.4-.5-.4,0-.3,1-.3,1-.2-.3-2.2-2.3-2-2.5l2.5.5c-.4-.2-.7-.5-1-1-.9-.2-1.7-.7-2.5-1.5-.3-.5-.7-1-1-1.5-.3-.1-.3-.3,0-.5,1.1-.4,0-.5-.5-1-1.5-1.6-.3-1-.5-1.5-.9-1.5,1.5-1,2,0,0,0,0,.4,0,.5-.5.5-.4.7.5.5,1.4-1,.5-1.9,2.5-1l-.5-1.5c.5,0,1,0,1.5,0Z"
          fill="#04b2fc"
        />
        <path d="M297.7,127.4l.5.5c-.4.3-1,1-1.5.5-1.1-1,.9-.9,1-1Z" fill="#0392fa" />
        <path
          d="M297.7,131.3c1.4,0,1.7.9,2.5,1.5.4.1.4.3,0,.5-.4-.2-1.4-.4-1.5-.5-1.1-.8-.7-1.1-1-1.5Z"
          fill="#0392fa"
        />
        <path d="M296.7,129.8c0,0-.4,0-.5-.2l.5-.3v.5Z" fill="#0392fa" />
        <path d="M306.7,135.3c.2.2.3.3.5.5,0,0-.5.5-1,.5v-1h.5Z" fill="#0490f5" />
        <path
          d="M303.7,129.8c.4,0,1.3-.8,2-.5v2c-.8,0-1.8.3-.5,1,1,.7-1.3,1.4-2,1h-.7c-.3,0-.2-.3-.3-.5l.5-.5c.1,0,.4,0,.5,0l.5-.5c.5-.6.6-.6,0-1.5-.4-.1-.4-.3,0-.5Z"
          fill="#039af9"
        />
        <path
          d="M305.2,132.3c.6.3,1.3-.7,1,1.5-1.2-.8-1.3-.3-2,0s-1.9,1.1-2,1c-.6-.7.5-1.2,1-1.5.8-.4,1.7-.3,2-1Z"
          fill="#03abfb"
        />
        <path d="M300.2,128.4c.6.5-1.7,2.6-2.5,2s1.7-2.6,2.5-2Z" fill="#0395fb" />
        <path
          d="M301.2,128.9c0-.2-1-1-.5-1.5,1-1,1.3,2.5,3,2.5v.5c-2,.2-1.9,0-2.5-1.5q.3-.5,0,0Z"
          fill="#039ef8"
        />
        <path d="M300.2,132.8c.1,0,.7,0,1,0,0,.3,0,.9,0,1-.5.5-.9-.5-1-.5v-.5Z" fill="#0679e9" />
        <path d="M307.2,132.8l-.5-1c0,.1.7.2.8.5.1.4-.3.5-.3.5Z" fill="#039af9" />
        <path d="M302.2,132.8c0-.6.4-.4.5-.5l-.5.5Z" fill="#03abfb" />
        <path d="M303.2,132.3c.1,0,.4-.4.5-.5l-.5.5Z" fill="#03abfb" />
        <path d="M306.7,131.3c0,0-.8-.7-.3-1,1.3.9.2.9.3,1Z" fill="#039af9" />
        <path d="M306.7,135.3h-.5v-.5c.2.2.3.3.5.5Z" fill="#03abfb" />
        <path d="M301.2,128.9c-.4-.4.3-1.5.5-1s-.3,1.3-.5,1Z" fill="#0372e4" />
        <path
          d="M188.3,99.9c1.1-.4,2.1.9,1.5,2q-1.2,1.4,0,0c-.4-1.3,0-1.3,1-.5.1-.4.3-.4.5,0,.5.1.9.5,1,1,.5.2.8.6,1,1,.4,0,.4.3,0,.5.2.8.6.8,1,0-2.1-2.8,3.3-3.4,1.5-1l.3,1.6c2.1-.9,3-.6,2.7.9-.4.2-.4.3,0,.5-1,1.4-1.8,1.2,0,3.5l-1.8-1c-1,2.6-.9-1.1-3.2.5l2.5,2c1.2.4.8.7-1,1,.8.2-.5,2.5-1,3,.3-1.7-.6-.2-2-1-.2-.7-.8-1.3-1.5-1-.7.3-1.3.8-2,1v.5c2.2.4,1.1.9,1,1.5-.3.8-.6,1-1,.5-.3,0-.7,0-1,0-.7.5-1.2-.3-1.4-2.3-2,1.1-2-1.7-.6-1.2.3-.8.7-1.6,1.1-2.4-2.4-.1-2-3,0-3.1q.7-.5,0,0c-.6,1.8-2.4,0-1.5-1,.2-.4.3-.4.5,0,.4-1,.9-1.4,1.5-1,.3-.3.3-.5,0-.5-.3.5-.9.6-1,0-.5-.4-.8-.9-1-1.5l-.4-.5c1.4-.9,2.2-1.8,2.9-3,.1-.4.3-.4.5,0Z"
          fill="#04a4fa"
        />
        <path
          d="M198.2,101.4c1.1.4,2.1,2.1,1,3,0,.3,0,.8,0,1h-.5c-1.4-1.5-1.6.5-1.7.5-1.6,0-3.2-1.6-1.3-3,.2-.7.3-1.3.5-2,.6-.4,1.9-.4,2,.5Z"
          fill="#09b1fa"
        />
        <path d="M208.2,114.4c1.4,1.8-1.1,5.8-1,2,1.1,0,.5-.9.5-1,0-.4,0-1,.5-1Z" fill="#0390f9" />
        <path
          d="M206.7,92.9c1.8-.7-.2,1.6,1.5,2,.3.6.8.6,1.5,0,.5,0,1.1-.2,1.6,0s.4,1,.6,1c1.7-.1.8-3.5,2.8.5-.1.7-.6,1.4-1.5,2,1.8.8-.7,2.3-1.5,1.5-.3-.4-1.3-.4-1.5-.5-1.2.4-1.6.3-1.5-1-.3,0-.9,0-1,0-.2-.3-.5-.4-1-.5-2.3-1-2.9-1.9-2-2.5.2-.3.3-.7.5-1,0-.4.1-.5.5-.5.3-.3.9-1,1-1Z"
          fill="#179dfa"
        />
        <path
          d="M216.2,97.4l2,1.3c-2,.5-.5,1.1-.5,1.2,0,.3-2,1.1-2.5,1,.3-.9,1.8-.4.7-2-.9,1.9-3.8.5-3.8,2.5-.7-.7-.4-1.3-.5-1.5,1.4,0,1.4-1.4,1.5-1.5-.3-1.2,1.9-1.7,2.5-1,.2-.4.3-.4.5,0Z"
          fill="#23aafb"
        />
        <path
          d="M203.2,95.4c.8.2,1.4,0,1.5,0s-.1.6.2.8c1.1.7,1.4-.1,1.8,1.7-.2,0-.3,0-.5,0s-.2-.3-.7-.3-1.1.5-1.3.3,0-1.3-.5-1.8-1,.3-1,.3-.5-.9-.5-1c.2-1.3.5-1.2,1,0Z"
          fill="#0e8ff5"
        />
        <path
          d="M206.7,97.9c.3,0,.5,0,.5,0,0,.2-.1.9-.2,1.2s-.1-1.4.7-.8c.2-1.4.4-1.2,1,0,.2.5.7.8,1.5,1,.5-1.4,1.9-1,1.5.5.6-.1.8.4.5,1.5,2.8-2.3,5.2,3.9,2.5,5.5-.1.3-.4.7-.5,1l-2-1c-.3,1.7-2,3.2-1,5-2.3.4-1.9-1.8-2-2-.3-.3-1.3.5-1.5.5s-.8,0-1,0c-.1-.5,0-.6.5-.5v-.5c-.4-.1-.4-.3,0-.5.1-.3.3-.3.5,0,.8-.3,2-2.7-.5-2.5-.8-.7-2.1-.4-3,0-.2-.5-.2-.6-.5-1-1.3-1-2.2-.9-3,.3-.8.2-2.9-5.6-.5-5.8.5-1.7,1.7-.1,2.5,1,.2-.2.2-.3,0-.5-.4-.1-.4-.3,0-.5l-.6-1c1.2-.5,2.6-.8,4.1-1,0-.4.3-.4.5,0Z"
          fill="#0eacfb"
        />
        <path
          d="M212.2,101.4c-.7-1.7,4.2-4,4.6-2.2l.9.7c.9-.6,1.1.2.5,1-.2,0-1.4,0-1.5,0-.1.1-.6,3.5-.4,3.9s.9,0,.9.3-.5.2-.5.3c-.2.4-.3.7,0,1,.5.3.6.4.5,1-.1,0-.3,0-.5,0-.7-.2-1.3-.4-2-.5.6-2-.7-2.2-.5-2.5s1.5.4,1-1c-1.7.7-1.7.9-2.5-.8l1.5-.5c-.4-.9-1.5-.3-2-.8Z"
          fill="#159ef8"
        />
        <path
          d="M207.2,106.4s.3-.2.2-.5c-.3-.7-1.6-1.1-1.2-2.5l3,1.2-1.5,1.2c2.1-1.8,2.4,3,.6,3.4s-.6-.4-.6-.4c-.4-.3-.8-.5-.5,0,0,0,0,.3,0,.5v.5c-.2.2-.3.3-.5.5-.4-.1-.4-1.4-1.7-1s.3,1.5-1.3.5c-.8-.5-.3-.8.5-1,.3,0,.7.1,1.1,0s1.3-2,2.6-1c.3-.5-.5-1-.8-1.5Z"
          fill="#079bf9"
        />
        <path
          d="M199.2,99.9c.3-1,.7-1,1,0-.3,1.4-.6,2.8,1.5,3l.5-1.5.5,2-3,.7c2.1,2,2-1.8,4,1.3-1.3,1.3-.6-1.3-2.5,0-.6.6,2.4,1.7.2,2.5s0-1.2-.5-1-1.1,1.4-2.2,1c-.4-1.7,1.2-.7,1.5-1,.7-.7-.9-2.4-1-2.5-.5-1.2-.9-1.4-1-3-.8-.6-.9-.7,0-1-.2-.7.5-1.2,1-.5Z"
          fill="#0498f9"
        />
        <path
          d="M202.2,95.4c.8.2,1.3.4.5,1q-.7.9,0,0c0-1.7,3.2.5,3.5,1.5l-1.5,1.5c2.6-.3,2.1,2.4.2,3.5l.8-1.5c-.3-.2-.9.3-1-.3-.3-1.3,1-.2,1-1.2-1.3,0-2.2-1.9-3,0-1-.3-1.8-.3-2.5,0-.3,0-.7,0-1,0-.6-.3-.6-.7,0-1-1.4,0-1.3-.5,0-1-.4-.1-.4-.3,0-.5-.9-2,2.4-4.6,3-2Z"
          fill="#15aafb"
        />
        <path
          d="M202.7,99.9c0,.1,0,.3,0,.5.4.1.4.3,0,.5-.8,0-1.3.2-2,.5l.5-1.5c-.3,0-.7,0-1,0,0-.5-.3-1.5.3-1.5,1,0,1.7.7,2.2,1.5Z"
          fill="#0794f9"
        />
        <path
          d="M208.7,98.4c.7-.7-.1-.7-.5-1.3,1.8-.9.4,1.1,2,2.3l-3,1.5c-.1-1.3.8-1.8,1.5-2.5Z"
          fill="#19abfb"
        />
        <path d="M211.2,105.4c0,.5.1,1.8,0,2-.8.9-2.5-2.2,0-2Z" fill="#079bf9" />
        <path d="M207.7,98.4c-.5.4-.3,1.2-1,1,0-.5,0-1.1,0-1.5.5,0,1.2-1.4,1,.5Z" fill="#15aafb" />
        <path d="M202.7,100.4c1.1,0,1.8-.4,1.5,1,0,.1-1-.5-1.5-.5v-.5Z" fill="#15aafb" />
        <path d="M207.2,109.9v-.5c0,.2.8-.3,0,.5Z" fill="#05aafa" />
        <path d="M208.5,102.9c.3.2.3.3,0,.5v-.5Z" fill="#079bf9" />
        <path
          d="M217.2,93.4c.5.3.7.3,1,.5.1.7-.5,1.7-.5,2.2s1.3,0,1,.8c-.9,0-1.7.2-2.5.5s-.4,0-.5,0c-2.1.4-.6-1.2.5-2,0-.8-.5-2,0-3h.5c0,.3.3.8.5,1Z"
          fill="#1f94f7"
        />
        <path
          d="M216.2,95.4c0,1.6-1.6.5-.5,2-.4.2-2.3.9-2.5,1l-1-2c1.1.2,1.5.6,2.5,0s.5-1.3,1.5-1Z"
          fill="#148bf2"
        />
        <path
          d="M209.7,94.9c0,1.1-.6,1.7-1.7,1.5-.4,0,.1-1.2.2-1.5s.5-.4.5-.5c.3.1.7.5,1,.5Z"
          fill="#1183ef"
        />
        <path d="M214.2,92.9s-.9-.5-1-.5l1,.5Z" fill="#309af9" />
        <path
          d="M211.7,87.9c.2,1,.8,1.8.5,3-.5.2-1.4,0-2,.5-1.8-.5-2.1-1.9,0-2.8v-.7c-.1-1.8.5-.6,1.6,0Z"
          fill="#2386f2"
        />
        <path
          d="M211.7,87.4c0-.3-.7-.9-.5-1,2.4-.5,4.5.4,5.7,2.5,0-1.7-.5-3.4,1.2-1-.3.7-.3,1.5-1.2,2-1.8-2.6-1.1-1.4-2.4-1.5s-.2-1-.6-1-1.5.8-2.2,0Z"
          fill="#2d86f2"
        />
        <path
          d="M208.7,87.9c1,1.9-.9,2.7-2.5,2,.5.7-3.2,2.1-3.4,2-.4-1-1.3-1.3-2.6-1-.5.6-.8.8-1,0-.5,0-.8-.2-1-.5-.3-.2-.3-.3,0-.5,0-.6.5-.9,1-.5.3-.2.3-.4,0-.5-.4-.1-.3-.3,0-.5.2,0,.3,0,.5,0,1.6-.1,1.6-.3,0-.5,0-.2,0-.3,0-.5,1.6-.7,3-.4,4.5,0s1.1.9,2,.5l-1-1.5c2.1-.2,2.1.7,1.7,2.5.7-1.3,1.4-.9,1.8-1Z"
          fill="#2a8ff6"
        />
        <path
          d="M210.2,87.9c2.5,1.4-.2,1.6-.5,2.1s.3,1.1.5,1.4c1,3.1-.9,1.4-1-.5l-1.7,1.5.2-2c-.1-.2-.8.5-1,.5-1.1.5-2.1-.3-.5-1,1-.4,2-.9,2.5-2,.5-.1.9-.5,1.5,0Z"
          fill="#2e9ef9"
        />
        <path
          d="M195.2,89.4c.5.1,1,.6,1.5,1.5.6-1.2.9-1.3,1.1-.4l1.4.4h1c.5.1.3.4-.5,1-.2.1,0,.3.5.5.6,0,.9.4,1,1,1.8.5-.7,2.4-2.2,1.2l-.9.9c-1.3-.5-2.5-.5-3.5,0-.2.9-.8,1-1,0-2-.9-1.6-2.1,0-3,.7-.7.4-1.7,0-2.5l1-.5h.5Z"
          fill="#2199f9"
        />
        <path
          d="M186.8,91.4c.3-.1,1.1,0,1.5,0l-.5-1c1.1.5,1.5-.8,1.8-.9,1.3-.3,2.3.8,4-1.6,0,1.7,1.2,1.4,1.2,1.5.1.2-.4,2.8,0,3.5l-1-.5c-.5,0-.4-.3,0-.5-1.2-.1-2.2-.1-3,0,.7,1.2.3,1.6-1,1-.4.3-.7.4-1,0-1-.6.8-.8.8-.7-.4.2-1.5.6-1.8.7s-.3-.2-.5-.4c-.6,1.5-1.3,2-2,1.5-.9-1.4,0-1.9,1.5-2.5Z"
          fill="#2786f1"
        />
        <path
          d="M195.2,89.4c.7-1.4,1.4-1.3,2,0,1,.9.8,1.4-.5,1.5-.3,0-.9.7-1.5.5v-2Z"
          fill="#2786f1"
        />
        <path
          d="M198.2,88.9c.6.4.1.7-.5,1l.5.5c.2.1.8,0,1,.5-.8,0-1.7,0-2.5,0,0-.5.3-1,.5-1.5s-.1-.9,0-1c.3-.3.9.5,1,.5Z"
          fill="#369efb"
        />
        <path
          d="M199.2,88.9c.4.1.4.3,0,.5-.3.1-.6.5-1,.5-.2.3-.3.3-.5,0,0-.3.4-.7.5-1,.3,0,.7-.5,1-.5v.5Z"
          fill="#3080ed"
        />
        <path d="M199.7,87.9l1.5.2c0,.5-1,.2-1.5.2v-.5Z" fill="#3080ed" />
        <path
          d="M182.8,87.4c0,0,.4.9.7,1,1.1,0,1.9-2.3,2.3-2,0,1.6,2,1.7,3,1.5.1-.4.3-.4.5,0,.4-.1,1.1-.9,1.5-1l.7,1.5c-1.2.4-3.4.5-4.4,1s-.6,1.2-.9,1.5c.4.4-.6.8-1,.5-.3-.2-.3-.3,0-.5-1.8.9-3.1.9-4,0-.9.7-1.2.4-.5-.5v-.3c-2.4.4-3.1,0-2-1.2.3,0,.8-.6,1.2-.5s.3,1,.5,1c1.3,0,1.2-1.4,1.3-1.5.2-.3.7-.6,1-.5Z"
          fill="#2f7dec"
        />
        <path d="M185.8,89.4c0,0,0,.3,0,.5h-2s0-1,0-1c.1-.1,1.9.4,2,.5Z" fill="#378bf4" />
        <path d="M185.8,88.9c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#4280ec" />
        <path d="M185.3,91.4l-.5-.2.5-.2c0,0,0,.5,0,.5Z" fill="#378bf4" />
        <path
          d="M201.7,83.4c.4,1.2,2.7.9,3.5,0v1.5c.1.1,1.1-.7,1.7-.5,1.1.3,0,2.6,2.3.5-.2.4.1,1.4,0,2-.2.2-5.3-3.4-5,.5-1,.9-2.5.9-4.5,0,0,0-.5-.1-.5-.3s1.6-.4,1-1.7v-.5c.2-.7,1-.2,1.6.1s-1.4.2-1.1-1.1l1-.5Z"
          fill="#3080ed"
        />
        <path d="M200.7,83.9c.3,0,.5.7,1.5,0l-.5,2-1.5-1-1-1.5c.7-.3,1.1.4,1.5.5Z" fill="#4188f4" />
        <path d="M203.7,84.9v1s-1.5,0-1.5,0c.2-.7.8-1.1,1.5-1Z" fill="#4188f4" />
        <path
          d="M203.7,125.9c.8-.6,1.3.1,1,1,.4.2,1.2.3,1.4.6.5.8-.3,2.6,1.6,2.4-1,1.4-2,3.8-3,1.5q.8-1.3,0,0c0,0-.7,0-1,0l1.5,1.7-1,.7,2.5-.7c.3,1.5-1.9,2.1-2,2.2-1.7,2.1-3.8,1.9-3.6-1h-.4c-.3.7-.3,1.4,0,2,.1-.4.3-.4.5,0,.5,2.8-2.2,1.9-3.3-.2-4.5,1.7-4-1.8-1-4.1l-.7-1.1c.4-2.1,0-3-1.5-4.6-.2-.5,0-.7.5-.5.1-.8.9-1,1,0,1.3.3,2.1.7,3.3-.5.9,2.7,1.2-.3,2.5-.5,0,2.5,1.6.9,1.7,1Z"
          fill="#04a7fb"
        />
        <path d="M202.2,129.3l-2,.8,1,.7h-2s1-1.2,1-1.2l-2-2.2c1.2.3,3.3.8,4,2Z" fill="#0390f7" />
        <path d="M202.7,131.4c.3,1.3-2.2,1.6-3,2l3-2Z" fill="#0291f9" />
        <path d="M204.7,131.3c.2-.3-.4-2.1.2-2.5,1.4.9,1.5,2.4-.2,2.5Z" fill="#018df9" />
        <path d="M200.7,136.3c-1.1-.7-.5-1.2,0-2v2Z" fill="#049ffa" />
        <path d="M205.7,138.8c.1-2.1,2.5-.9,1,.3s-.7,0-1-.3Z" fill="#0289f7" />
        <path
          d="M189.8,127.9c1.2-.8,1.9,2.1,0,1-.1.4-.3.4-.5,0-.3.3-.2.6,0,1,0-.6.5-.6,1-.5.1-2,2.7,1,1.5,1.5-.8,0-1.6-.4-2.8,0s-.3,1.5-2.5.6c-.7.2.2.5.2.5.4.2.4.3,0,.5-.9.8,0,2.1.7,3l-.2.5c-.1.4-.3.4-.5,0-.5.6-1.2.7-2,.5l-.7.9c1.2,1.6-1.9,1.4-2.3-.4-.2.4-.3.4-.5,0-.4-.1-.4-.3,0-.5-.7-.7-.5-1.1.5-1-.4-.1-.4-.3,0-.5.6-.3.9-.1,1,.5.5-.2.5-.6,0-1-.5,0-.4-.3,0-.5-.3-.1-.3-.3,0-.5h.5l.5.5c.3-.6,0-.9-.5-1-1.2.2-1.3-.1-.5-1-.4-.1-.4-.3,0-.5-.2-.6.2-1.1,1-1.5.3-1,1.4-1.2,3.3-.6-.4-1.6,1.5-1.8,2.7-1.4Z"
          fill="#04a7fa"
        />
        <path
          d="M190.8,132.3c.3.8.7,1.6,1,2.5v.5c-.4,0-1.7.7-3,1-.8.2-3.1-2.8-2-3.5.1-.4.3-.4.5,0,.2.4.8.4,1,.5.6.1,1.2-.2,2-1h.5Z"
          fill="#05a9fa"
        />
        <path
          d="M189.3,126.4c.4-.1.9-.6,1.5-.5l.5,3c.9.1.2-1.1,1-1.5l.5,1.5c-.3.2-.6.5-1,.5v.5s2.5.3,2.5.3c-.5.8-1.2.7-2,.8s-.3,0-.5,0c0-1.9-1-1.3-1.5-1.5-.6.4-.8.2-.5-.5,1.2-.5.3-.7,0-1l-1-.2c-1.9,1.6-2.7-1-.5-1.3.6-.8,1-.8,1,0Z"
          fill="#038df7"
        />
        <path
          d="M194.8,126.4c4,1.1.5,5.3,4.5,5.5l-1.3,2-.7-1c-1.1,1-.4,1.9-.5,2-.3.2-1.7-.5-1.5.5,2.3.9,1.7-.2,3.5-1,0,.9.6,1.8,1,2.6s1.1-.4,1.5-.6c1.6,1.3-.4,2.6,1.5,2.5v.5c-1.9,0-.9,1.4-1,2s-.8,1.2-.5,2l3-1c-.2.5-.4,1.6-.5,2,1.3.4.5,1.3-.5,1-.2,0-.5,0-1,0,.7,1.6-3.1,2-3.5.5-1-.9.2-.5.1-.5-1.5.3-2.4-.7-2.9-1.8s-.2-.5-.2-.7c-1,0-.9-.6,0-1-.6-1.1,0-1.4,1-1.5-.8-.1-.1-1.1,0-1.1,1.1.5-4.9,1.3-2.9-1.9.1-.7,0-1.2-.5-1.5-.5.1-1.3,0-1.5-.5-.4-.1-.4-.3,0-.5-.7.2-.9-.4-.5-1.8l-.5-.7c-.1.4-.3.4-.5,0-1.3-.4-.3-.7-.3-.6-.2.9-.7,2.4-1.7,1.6-.3,1.2-1.4.6-1-.5,0-.4,0-.7-.5-1-2.1.8-1.2-1.7.9-.8.8-1,3.2-1.5,4.1-.2,0-.5.2-.4.5,0,1.4-.2,1.4,0,.5,1,1,.2,2.1.9,1,1.5q-.6.6,0,0c.3-.4.3-.9,0-1.5l-.5-.4c1.3-.7,2.1-3.7.7-2.3l-1.1-.4c-.9.5-1.1,0-.5-1.5.2-.1.7,0,1,0,.2-.6.9-1.1,1.5-1Z"
          fill="#049ffa"
        />
        <path
          d="M195.2,125.9c0,.4-.4.4-.5.5-.2.2-.4.8-.6.9-.4.2-.7,0-.9.1,0-.3,0-.7,0-1,.3,0,1.2-.7,1.5-1,.6,0,.5.5.5.5Z"
          fill="#0386f5"
        />
        <path
          d="M192.8,128.9c1.2-1,1.7-1.9,3.5-.2-1.9.5-.7,1,0,2.2l-1.5-.5-1,1.5c.2.5-.2.5-1,0-.2-.2-.3-.7-.5-1-1.3-1.8-1.2-2.4.5-2Z"
          fill="#05aafa"
        />
        <path d="M190.8,132.3l1-.5v3s-2,.5-2,.5c.6-1,1.3-1.7,1-3Z" fill="#0493f9" />
        <path d="M198.3,139.8c-1-1.1,2.1-2.2,3-.2l-3,.2Z" fill="#0384f4" />
        <path d="M188.3,133.3c1.1-.6,1.5-3.9,2-1l-.5,2c-1.9.5-1.4-.9-1.5-1Z" fill="#0388f6" />
        <path d="M195.7,141.8v1c-.5,0-1,0-1.5,0,0-.9,1.2-.8,1.5-1Z" fill="#0487f4" />
        <path
          d="M193.8,131.8c.1,0,1,.6,1,.8.2,1.1-.2.6-1,.7,0,.3,0,.7,0,1-1,.1-1.1,0-1-1,.3,0,.7,0,1,0,0-1.2-.5-.9-1-1.5.3,0,.7,0,1,0Z"
          fill="#028ff7"
        />
        <path
          d="M186.8,131.8c.8,0,1.2-.2,1,.7l-.5.3h-.5c-.4-.2-.4-.3,0-.5,0-.2,0-.4,0-.5Z"
          fill="#0380f1"
        />
        <path d="M196.2,136.8c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#027df4" />
        <path d="M203.2,145.3l-.3.4-.7-.4s0-.4.2-.5.6.5.8.5Z" fill="#026cee" />
        <path
          d="M200.2,148.8c0,.2,0,.3,0,.5-.2.3-.1.6,0,1,0,.1.4.3.5.5.8.7,1.2.7,1,0,0,0,.3-.1,0-1-.4-.6,0-.7,1-.5.3,0,.7,0,1,0,0,.6-1,.2-1,.7,0,.4,1.4,0,1,1.2-1.6-1.1-.7,0-1,.5s-.7.4-1,.5c-.7.3-1.2.6-2,.5-.3-.2-.3,0,0,.5.4.2,1.9.4,2,.5s-1,1.9-1,2c-.2.1-.7-.4-1-.5-.4-.1-.4-.3,0-.5-.2-.2-.4-.2-.5,0-.5.8-1,.9-1.5.5-.6.8-1.2.5-1-.5l-.5-1.3,1-.5-1-1.3c.5-.3.8-.3,1,0,0,0,0,.4.2.5.5-1.4.4-.8,1.8-.5-.4-.8-.6-3.3,1-3Z"
          fill="#0373f0"
        />
        <path d="M201.7,150.8c0,.2.7.9.5,1-2.1.3-1.2-.4-1.5-1h1Z" fill="#0361ef" />
        <path d="M202.7,149.3l-1,.5c0,0-.8,0-.5-1,.6-.2,1.1.4,1.5.5Z" fill="#065ae8" />
        <path d="M200.2,150.3l-.5-.7.5-.3c0,.3,0,.7,0,1Z" fill="#0255de" />
        <path d="M199.7,152.8v.5l-1-1c.8-.3.9.5,1,.5Z" fill="#025ae9" />
        <path
          d="M181.8,170.8v.5c-.2,2.9,1.2,2,1.9,2.5s.2,1.1.6,1.9c-.3,0-1,0-1,0-.1-.1.1-.9,0-1-.3-.2-1.3.5-1.5.5s-.4-1.1-1-1c.3,2.4-2,2.4-2,.5.2-1.3.8-1.8,2-1.5-.6-.2-.5-.4.2-.7-1.2-2.6-.8-5.1,1.8-2.4l-1,.6Z"
          fill="#049cfa"
        />
        <path
          d="M181.8,175.3c-.5-2.3,3-1,1.5.5.7.1,1.2,1,.5,1.5-.5.5-1.7,3.6.5,2.5l-.5,1c.4.5.1.6-.5.5,0,.6.5.9.5,1,.2,1.1.3,2.4.5,3.5l-1.5-.5c-.6-.3-1.1-.8-1.5-1.5-1.2.5-1.3,0-.5-1,.8.9-.6-4.1-1-2.5-.5.5-.5,1,0,1.5.7-.7,1-.4.5.5.2,1.2-.2,3.1-1.5,3.5-.7.9-1.5,1.7-2.5,2.5,1,.3,1,.7,0,1,.8.1.6.5,0,1,.3.2.6,0,1-.5-.4-.1-.4-.3,0-.5,1.6-1.2,2.7,1.7,1,2.5-.6,2.1-.6,1.4-2.5,1l.5,1c-.8-.2-2.7.5-3.3.4s.1-1.1-.7-.9c0,2.3-1.7.4-1.5-.7s2.3,0,2.5-.3v-1.5s2.5.5,2.5.5l-3-1c-.2-.8,1.5-.7,1.5-1.2s-1.4-1.5-2-1.8c-1.4-.6-1.2-1.7.7-3.4-.3-1.2.5-1.7,2.3-1.5l.5-1.1c-1.8-1.4,2.3-4.8,4-4,.1-.9.9-1,1,0,.9-.2.9-.3,0-.5-.8-.2.3-1.7,1-1.5Z"
          fill="#0387f9"
        />
        <path d="M184.3,175.8c1,2.4-.1,1.1-.5,1.5l-.5-1.5c.3-1.3.4-1.1,1,0Z" fill="#0262e6" />
        <path d="M183.8,180.8c1.9-.2,1.2,1.9-.5.5,0-.3.2-.6.5-.5Z" fill="#026ef5" />
        <path d="M181.3,183.8l2-.5-.5,2h-.5c-.1-.1-.9,0-1.3-.5s.3-1,.3-1Z" fill="#0365f1" />
        <path
          d="M176.3,188.3c-.3-2.4-2.2-2.5,1-3v1.5c.2.2,1.1-.9,1.5-1s1,0,1.5,0c0,2.8-2.1,4-1,.5-1.2.5-.6,2.1-2,1l-1,1Z"
          fill="#036df6"
        />
        <path
          d="M179.8,180.3c-.3-.4-1.2-.3-1-1,2.6-.4,1.9.5,2.4,2.5s1.6,1.1-.4,1c0-.2-.3-.4-.5-.5s-.3-.4-.5-.5c-.7-.3-.6-1.1,0-1.5Z"
          fill="#0592f9"
        />
        <path
          d="M177.3,189.8c-.6,1.2-.1,1.6.5,2.5-2,.3-1.5-.3-1.5-2,.1-.6.5-.9,1-.5Z"
          fill="#037df9"
        />
        <path d="M179.8,180.3c.4.6.4.9,0,1.5-.2-.1-.8.3-1-.2-.3-1,0-1.5,1-1.3Z" fill="#0370f4" />
        <path d="M175.8,188.3c-.9.2-1.7-.5-1.5-1.5l1.5,1.5Z" fill="#0370f2" />
        <path d="M180.8,176.8l1-.5v1.2c0,.7-.7-.2-1-.2v-.5Z" fill="#049cfa" />
        <path d="M177.3,189.3v.5l-1,.5c0-.3,0-.7,0-1,.3,0,.8,0,1,0Z" fill="#0257eb" />
        <path
          d="M180.8,165.3c.3,1,1.1,1.7,1.7,2.5s-.1.8,0,.9c.2.2.7,0,.9,0s0,.4,0,.5q-.5.3,0,0c.2.1.9-.1,1,0,.8,1-1.6,1.6-2.5,1.5v-1c-1.9.5.2,3-.5,4s-1.4-.2-2.5,1-.4.3-.5.5c-1,.5-2.1-1.4-.5-2,.5,0,.8,0,1-.5.1-1.7,1.4-1.2.4-.6-1.7.9-2.6-1.1-1.4-1.9.8-1.3.5-1.3-1,0-.4,0-.9-.2-1.5-.5-1.8.3-2.9-3.3-.5-2.5,1.6-.3,2-.5,1-.5-.5-.3-.5-.7,0-1-.4-.5,0-.7,1-.5-.6-.7-.3-.9.5-.5.2-.4.3-.4.5,0,.5,0,1.7.5,3,.5Z"
          fill="#038bf8"
        />
        <path
          d="M193.3,165.8c-1.5.5-3.5,0-2.5,2.5-3.6-2.1-2.1-1.4.1-2.5s.8-1.6,2.9-1c.2.1-.5.8-.5,1Z"
          fill="#0397f9"
        />
        <path
          d="M192.3,162.8c0,.2-.7.9,0,1,0,0,0,.2-1,0-.2-.7.3-1.1.5-1.5.9-.7,1.1-.4.5.5Z"
          fill="#0371f3"
        />
        <path d="M192.3,162.8c0-.2-.2-.6-.5-.5,1.4-3.2,3.3-2.1.5.5Z" fill="#027bf8" />
        <path
          d="M170.3,183.3c1.1,0,.5,2.2-.5,2-.3.7-1.2.7.5,1.2l-1.5,1.7c1.5-.8,2.1,0,2.5,0-.2,0-.5,0-.7,0l-.7.7,1.5,1.8c0,0,0,.5-.1.8s-1.3.5-1.4.9c-.1.6,1.9,2,.5,3.2-.4.2-.3,0-.5.5-.8,1.9-2,0-2-1.5-.6.6-1,.6-1,0-1-.3-1-.7,0-1,.8,0,2.3.2,2.5-1-.9-1.2-2-1.8-3.5-1.5-.2-.1-.4-.3-.5-.5-1-.4-.5-1.2.5-1,0-.4.3-.4.5,0,.4-.3.6-.7.5-1-.3,0-.5-.2-.5-.5-1.1-1,1.6-1.3,1.4-1.2-1,.8-1.9,1.5-1.4-.3.3-.3.6-.7,1-1-.8-1.3.9-2.1.9-1.2s-1.2.2-.9-.8c.9-1.6,2.2-.5,3-.5Z"
          fill="#0487f8"
        />
        <path d="M171.3,195.8c.1,0,0-1,.5-.1s-.3,1.1,1,1.4l-1.5-.8v-.5Z" fill="#0385f8" />
        <path d="M180.8,90.4c0,.2.2.6.5.5-.5.4-.2.8-1.5,1-2-1.1-1.1-1.8,1-1.5Z" fill="#348af3" />
        <path d="M173.8,94.4c0,.6-.6.7-1,1-.1-1.1,0-1.1,1-1Z" fill="#1677ee" />
        <path d="M171.8,95.9l.5-.5c0,0-.2.5-.5.5Z" fill="#1677ee" />
        <path
          d="M190.8,91.9c.4-.2,2.6-.8,2.7-.7.2.2.2.4.3.7,0,.2,0,.3,0,.5s-1,1.9,0,3c0,.4-.3.4-.5,0q-.9-.3,0,0c1.3.5,0,2.1-1,2.5-.6,1.3-1.3.9-1-.5.8-.4,0-.9-2-1.5-.3-.3-.4-.3-.5,0,.4.6.1.8-1,.5,0,.4-.2.4-.5,0-.3,1.2-.6,1.2-1,0l-.2.5c-1.3-.4-1.9-.2-1.8.5.8.8-.3,1.1-1,1,.6-.7,1.3-.5,1,.5,1.2,0,1.1.7,0,1-.4,1-.8.5-1-.5-1.3-.4-1.2-.5,0-1-1,2.1-2.6-.3-1.5-2l-.5-1h1c.6.3.7.3.5,0,0-.2,0-.7,0-1,.2,0,.7-.6.9-.4s.3.8.6.9q1.2,0,0,0c0-.6.7-.7,1-1,.9-.9.7-1,2-1.5l1.5.5c.3.3.7.3,1,0,.1-.1,1-.9,1-1Z"
          fill="#1a8ef6"
        />
        <path
          d="M181.8,96.4c.2,0,.7-.1,1,0-1.1,2.8.2,1.7.5,2s0,.7,0,1c1.3.7,1.2,1.3.5,2.5.1.4,0,.5-.5.5-.8,0-2.6-1.2-3-2.5-.4-.2-.4-.3,0-.5.2-.4,0-.6-.5-.5,0,.5-.2,1.2-.5,2,3.2.3.3,2.1-2,1-.4-.3-.5-1.1-.7-1-.9.4-.6,2.1-1,2-1.3-.4,0-1.4-.3-2.5s-.4-.7-.5-1c.4-.3.9-.7,1.5-1,1.9-1.5,3.1-2.7,5.5-2Z"
          fill="#0b83f3"
        />
        <path
          d="M172.8,96.4c0-.5.5-1,1.3-1.6-.9-4,5.1-2.9,6.9-1.1,1.2-.8,1.9-.7,1.8.7,1,0,1,.8,0,1h-.5l-.5,1c-.4.7-1.2,1-2.4,1-1.3,1.2-2.3,1.5-3.1,1-.6.6-1.1.8-1.5.5-.5.2-.4-.7-.4-.4.3,2.3-.9,2.7-3,3.2-.1-1.5-1-2.6-2.6-3.4-.3,0-.7,0-1,0,.9-2,3.9-.5,5-2Z"
          fill="#1677ee"
        />
        <path
          d="M185.3,90.9c-.2.2-.2.4,0,.5.1,0,.9-.4,1-.5l.5.5c-.7.7-1.2,1.5-1.5,2.5,0,.3-.3.6-1,1-.6.3-1.1,0-1.5-.5-.3,0-1-.3-1.3-.5l.3,1c-1.7.5-1.4-.9-2.3-1.4s-2.2-.3-2.9-1.1c-.5.4.5,1.2.3,1.5-1,1-1.1-2-2-1s-.2,3.7-.5,4.5l-.7-1.5c-.2.2-.5.5-.8.5-.8,0-.9.1-1.5-.5h.5l.5-.5c.1,0,.4,0,.5,0,0-.6.5-.8,1-1,0-.4-.3-1.2-.5-1.5,1.3-2.2,4.3-.7,6.5-1,0-.8.7-1.4,1.5-1,.6-.5.6-.1,1.5,0l-.2-1c1,.1,1.8.5,2.7,1Z"
          fill="#207eef"
        />
        <path
          d="M174.8,98.9c.4.1.4.3,0,.5,1.3-.2,1.5,0,.5,1-1.7,1.1-2.9,1.3-2,3.5l-.5-1.5c-2-.4-.8,2.1-1.8,2.5-.3-1.1-1.5-1.4-2-2s.2-.5.2-.5c4.6-.7-.1-2-.5-4,1.6.3,3.7.6,2.5,2.5.3.2,2.5-.6,2.8-1s-.5-1.6.5-2l.2,1Z"
          fill="#138af6"
        />
        <path d="M178.3,94.9c.2,2.1-1.4-.8-1,2l-1.5-1.3,2.5-.7Z" fill="#2287f4" />
        <path d="M176.3,98.4c-.4.3-.5,1.2-1.5,1v-.5l1.5-.5Z" fill="#0380f4" />
        <path d="M182.8,95.4c0,.2,1.2,1.2-.5,0h.5Z" fill="#0b83f3" />
        <path
          d="M160.3,109.9c-.3-.3-.7-.9-1.2-.8s-2.1,1.8-2.3.3c2-2,3.2.7,4.2-2,1.6,1.6.8,2-.7,2.5Z"
          fill="#0162ea"
        />
        <path d="M157.3,112.4c-.6,0-1.6.3-1.5-.5.8.1,1.6-1.8,2.5-1s-1,1.1-1,1.5Z" fill="#035ee9" />
        <path
          d="M125.3,168.8c-.2,0-.3,0-.5,0s-.3,0-.5,0c-.1-.3-.7-.7-1-1,1.1-.8,1.3-.1,2,1Z"
          fill="#0329cb"
        />
        <path
          d="M144.8,145.3c-.8.2-.6.1-1.5.5-.2.8-1.1.7-1.5,0v-.5c.6-1.1,1.1-3.1,1.5-.5h.5c0-.5,0-1,0-1.5s.4-.3.5-.5c2,.6-.5,1.3.5,2.5Z"
          fill="#0363e4"
        />
        <path d="M142.8,158.3c-.2,0-.3,0-.5,0l.2-.5.2.5Z" fill="#037cf7" />
        <path d="M142.3,151.8c-1,.3-1.6-.4-.5-1,.4.2.4.8.5,1Z" fill="#0267ee" />
        <path d="M124.3,168.8c.5,1.4-.9,1-2,1v-.5s1-.5,1-.5c.3,0,.7,0,1,0Z" fill="#058af4" />
        <path
          d="M128.8,183.3c1.3,0,2.1.4,2.5,1,1.1,0,1.6,2.7.4,2.7.7.9.4,1.5-.9,1.8-.4.4-.5,1.1-.2,2.1-1.5,1.3-2.4,1.2-2.7-.5h-.6c-.6-.2-2,0-3,0-1.3-.7-.7-1.3,2-2,0-1.1-1.1-1.2-1,0-.7.7-1.5,1.2-2.5,1.5-.1.4-.3.4-.5,0-1.6-.6-.4-1.3-.5-1.5-1.2-1-.1-1.7,1-2,.2-.7.5-.9,0-2l3.5,2c-.6-.8.1-2.9,0-3,.5.5,1.9,0,2.5,0Z"
          fill="#0468f4"
        />
        <path
          d="M150.3,137.3c.6.2.5.4-.3.7,2.3-1.3,4.7,1,6.3,2.8,2.2.4.8,1.4-1,1.5-.6,0-1.9,1.3-1-1.5l-3,.5c-.2-1.1-.8-2.6-2-2.5-.1.4-.3.4-.5,0-1.1-.4-.8-1.7.5-1.5.3-.6.7-.6,1,0Z"
          fill="#0374f1"
        />
        <path
          d="M147.3,137.3c.6-.3,1.1.2,1.5,1.5.2,0,.3,0,.5,0l.7,2c-1.6-.4-2.3-1.4-3.7,0l.5-2c-.5,0-1,0-1.5,0,.1-.2.4-.3.5-.5-.4-1.4.4-1.6,1.5-1Z"
          fill="#0376f3"
        />
        <path
          d="M147.3,133.3c0-.6,2.6-.7,2.8-.5,1.1,1.3,0,2.4-1.8,2-.9.6-.8.6.5,0,1-1,1.8-.7,1.4.4s-1.2-.4.6-.9c0-1,1.5-1.1,2-.5,1.7.2,1.2,1.2,0,2,0,.3,0,.7,0,1,0,1.2-.9,1.4-2.5.5,0-.3-.3-.5-1-.5-.5,1.3-1.1,1.7-2,.5-1,.5-1.7,0-2-1,.9.3.9.7,0,1h-1.5c0-1.2-1.8-2,1.5-1,0-.4-.5-1.2-.4-1.4s1.9-1.5,2.4-1.6Z"
          fill="#0376f3"
        />
        <path
          d="M151.3,145.8c-.2,0-.3,0-.5,0-1.3.2-1.9.8-1.8,1.8l-.7-.3-.5-.5c-.3-.8-.8-1.5-1.5-2v-.5c.5,0,4.5.9,5,1.5Z"
          fill="#036deb"
        />
        <path d="M144.3,141.3c.3-.3.4-1.4.5-1.5,1.2-1,1.5,1.8-.5,1.5Z" fill="#036cee" />
        <path d="M144.3,141.8c.4.2,1.2-.4,1,.5-.9.3-.9-.4-1-.5Z" fill="#27ade7" />
        <path
          d="M147.3,137.3c-.9.4-.7,0-1.5,1,0-.4-.5-.8-.5-1,0-.3,0-.7,0-1,.8.2,1.5.2,2,1Z"
          fill="#0482f5"
        />
        <path
          d="M149.3,136.8c.4.1.4.3,0,.5l-.5,1.5c0,0-.6.8-1,.5s-.3-1.6-.5-2c.5-.2,1.4-.4,2-.5Z"
          fill="#0482f5"
        />
        <path
          d="M160.8,145.3c0-1,.7-1.9,1.3-1s-.9,1.6,1.2,1c-.6-1,0-1.3,1-1,.2,0,.9,0,1,0,.3,0,.5.3.5,1q.6.4,0,0c-.5-.6-.2-1.2.5-1,.8-.6,1.3-.6,1.5,0,.6.2.9.5.5,1,0,.7-.1,1.5-.5,2.5q-1.5-.1,0,0c0-3,4.6-2.2,5,0,1.5,0,.9.7,1.5,2.2-.2.6-1.2-.5-1.5-.2s1.1,1.4,0,1.5c-.8-.5-1.2-1-1-1.5-.7,0-1.1,0-1,.5,1-.2,1.3.3.5,1,.4.1.4.3,0,.5-.3.5-1,.4-1.5,0,.1.8-1.2.7-1.5,0-1.2.6-2.3.6-2-1-.4-.1-.4-.3,0-.5.1-1,.9-.4,1.5.2-.8-.9-1.5-.7-2.5-.2-.2.4-.3.4-.5,0-.1.4-.3.4-.5,0l-1-.4c-.3-1-.6-2-1-3-.5.4-1-.1-1.5-1.5Z"
          fill="#0490f9"
        />
        <path
          d="M171.8,143.3c.9.7-.1,1.6-1,2-.2.4-.3.4-.5,0-.2-.2-.4-.2-.5,0,0,.4-.3.4-.5,0-.5,0-1-.4-1.5-1,0-1.3,1.1-1.3,2-.5.4,0,.8-.1,1-.5.2-.8.9-1,1,0Z"
          fill="#0490f9"
        />
        <path
          d="M149.8,128.4c1.2.2,2.4.3,3.5.5.2.3.3.7.5,1,1,1.1,2.1,2.2,3.3,3.5-.5,0-.8.4-.8,1-1.3,1-2,.6-3.5,1.5.1-1.2,0-1.1,0-2-.8.4-.2-1.9-.2-1.8-.3,1.6-.8,2.6-1.8.8l-.8-.7c.5-.7.6-1.5.3-2.3-.5-.1-.4-.3,0-.5l-.5-.5c-.3-.1-.3-.3,0-.5Z"
          fill="#0480f5"
        />
        <path d="M169.3,145.3c-.2,0-.1.9-1,0s-.6-1-.5-1c.8-.2,1.2.3,1.5,1Z" fill="#069df8" />
        <path
          d="M171.8,143.3c.6,0,2.6.6,2,1-1.3-.4-2.1,1.1-2.7,1.3s-.3-.3-.3-.3c.3-.7.8-1.3,1-2-.3,0-1,0-1,0-.1.6-.5.9-1,.5-1.3-.1-1.3.3-2,.5s-.9.2-1.3.5l-.2-.5c-.2-.4,0-.7.5-1,.6-.3,1.3-.3,1.8-1,.6,2.1,1.9.2,3.2-.5,0,0,.3.5,0,1.5Z"
          fill="#069df8"
        />
        <path
          d="M152.8,127.9c.6.4.4.7.5,1-2.3,1.5-2.3-.2-2.8-.5s-.5,0-.7,0c-.1.4-.3.4-.5,0-.6.4-.9.2-.5-.5,1-.3,2.3-.3,4,0Z"
          fill="#036aef"
        />
        <path
          d="M174.3,126.9c.2.2.5.3,1,.5-.1-1,.6-.9,1,0,.7-.6,1-.4.5.5l.5.5c.6.8.4,1-.5.5-.1.4-.3.4-.5,0-.5-.8-1.3,0-1.5,0-.1.7-.6.6-1.5-.5-.4-.6-.6-1.9.5-1.5.1-.3.3-.3.5,0Z"
          fill="#04a2f9"
        />
        <path
          d="M154.3,114.9c.7.6,1,.6,1,0-.5-.7-.3-.7.5-.5.1-.4.3-.4.5,0,1.6-.7,2.1,1.1,1.8,2.5,3.2,3-1.1,3.6-2.8,1.5-.6.6-.4,2,.5,2,.7-.9,1.3-.8.8.2.7.2,1.5.3,2.2.3.1-.5.8-.6,1,0,.8,0,.7.7,0,1,.9,0,1.4.2,1.5.5,3,4.1-1,3.2-3.8,1.9,2,2.9-3.2,7.9-3.9,3.4.8-.3,1.3-.8,1.2-1.3-.6.2-1.6-.3-1.5-1-.7-.6-1.4-.7-2-.5.5.6.2.9-.5,1-.4-.6-.5-1.4-.5-1.5-.1,0-2.1.5-3,.5,0-.2,0-.5,0-.7-.2-.5-1.3,0-1-.8.6,0,1.4-.5,2-.5.9-.4,1.9-.5,3-.5,1.5.1,1.5,0,0-.5-.6-.7,0-1.6,1.9-2.6l-.4-.9c-.2.9-1.7.4-1.5-.5-.4-1,1-1.1,1.1-.5s-.8.3,0-.5c-.3-1.3,1-.9,1-1.3s-.5-1-.5-1.2c0-.9.2-2.6,1-2.5-.3,1.3.2,2,.5,3Z"
          fill="#0373f3"
        />
        <path
          d="M150.3,117.4c.8.8,1.6,1.5,2.5,2-1.3.8-1.8,1.6-1.5,2.5.5.1.5.3,0,.5-.7.7-2.2.7-3,0l.5-.8c-2.9-1.6.2-.9.5-1,1.3-.5.5-1.3.5-1.7-1.2-.5-1.2-1,0-1.5.2,0,.3,0,.5,0Z"
          fill="#0373f3"
        />
        <path
          d="M151.3,122.4c0,.3-.6,1-.5,1.5-.1.1-1.9-1-2.5-1v-.5h.7c.5-1.7.7-.5,2.3,0Z"
          fill="#0365f1"
        />
        <path
          d="M152.8,118.4c2.6,1.5-1.4,1.7-1.5,3.5,0-.1-1.5-.5-.5-1.7s1.6,0,2-.8c-1-.3-1-.7,0-1Z"
          fill="#0365f1"
        />
        <path d="M151.3,121.9c1,0,2.2,0,2.5,1-1,.2-1.7-.2-2.5-.5,0-.2,0-.4,0-.5Z" fill="#0365f1" />
        <path
          d="M151.3,117.4c-.9-2.1,0-2.2,1-.5,0,0,.7.4.5,1h-1.5c-.5-.1-.4-.3,0-.5Z"
          fill="#0150ed"
        />
        <path
          d="M151.3,117.4c0,.2,0,.4,0,.5.7.8,1.2.3,1.5.5,0,.3,0,.8,0,1-1.4-.1-2.2-.6-2.5-2,.3,0,.7,0,1,0Z"
          fill="#0a84f3"
        />
        <path
          d="M153.3,125.4c.7.2,1,.4,1.5,1,0,.5-.3.4-.5.5-1.4.2-2.6-.1-3.5-1-.2-.3,0-1,.5-1,.6-.3,1.3-.1,2,.5Z"
          fill="#0363ee"
        />
        <path d="M155.3,118.4l.5,2s0,.6-.2.5c-1-.4-2.3-2.7-.3-2.5Z" fill="#025ee5" />
        <path d="M155.3,114.9c1.1,2-.2,2.3-1,0h.5c.1-.4.3-.4.5,0Z" fill="#0251e1" />
        <path d="M159.8,120.9c.3,0,.9-.7,1-.5,0,1.2.3,1.7-1,1.5,0-.2,0-.7,0-1Z" fill="#025aeb" />
        <path d="M153.3,125.4c-.3,0-1.9-.5-2-.5.2-1,1.6-.1,2,.5Z" fill="#138ef5" />
        <path d="M155.8,114.4c-.2.4-.2.3-.5.5s-.3,0-.5,0c-1-1.3-.2-1.3,1-.5Z" fill="#0380f4" />
        <path d="M155.3,122.4c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#025ee5" />
        <path d="M158.3,128.8c-.2.2-1.9.3-1.5-.7.6-1.5,2,.3,1.5.7Z" fill="#036def" />
        <path
          d="M148.8,127.9c0,.4.2.4.5.5.7.9.6,1.5-.5,1-.4-.2-.7-.5-1-1,0,.9,0,1.4-1,1-.8-1.3-1.6-1.2,0-2,.7.1,1.3.4,2,.5Z"
          fill="#087ff5"
        />
        <path
          d="M149.3,110.9c.8-.4,1.2,0,1.3,1.2,1.5.4,2.2,1.1,2.2,2.3,1.8.2,1.6,2.5-.5,2.5l-1,.5c-.2.9-.5.8-1,0,0,.5-.2.4-.5,0l-.4.9c-2.2-.8-2.9,1.3-.6,1.1-.7.9-2-.4-1.9-.9.2-.8,3.8-.9,1.9.9,0-1.2.1-1.3,1-.5,2-.2.7,2.3-.5,2.3.3.2-.5,1.1-1,1.2.4.1.4.3,0,.5,0,1.2-.3,1.8-1,2,.4-1.9,4.8-1.1,3.4.5v.5c3.5,1.6-.3,2.7-1.9,1q-.5-.8,0,0c1.3.4,1.3.5,0,1-.8.3-2.2.8-2-.5h-.5c-1.8-.5-1.8-1.5,0-1.5-.4-.6-.1-.9,1-1l-.7.4c-2.2-1.2-3.1-1.2-2.8,0,.2.9-.1,1.5-1,1.5l-1.5,1c.6,1.8.5,2.8-.5,3-1.1,1.1-1.9,1.5-2.5,1-2-.2.2-3.4,1.5-3.5-.4,0-.7-.4-1-1-3.4.2-1.4-3.3,1-4,0-.4.3-.4.5,0,2,.2,2.1.1,3-1.5-2,.1-2.7-1.1-1.6-3,.7.4,1.4.3,2.1,0,.8-.9.8-1.8-.5-1.5-.3-.8,1.9-3.2,2.6-3.5s.5,0,.9,0c.6-.4,1.1.1,1.5,1.5.6-.4.7-1.2.5-2.5-.8-.7-.8-1,0-1-.5-.4-.6-.7-.5-1,0-.5.3-.5,1,0Z"
          fill="#0364f0"
        />
        <path
          d="M149.8,117.4c0,.5,0,1,0,1.5-.3.2-.7.3-1,.5.5-.5-.4-1.6-1-1s.5,1.5,1,1c-2.6,1.9-.9.2-2.3-.5s-.8,2.8-2.2.7c0-1,4.4-2.1,5.5-2.2Z"
          fill="#034feb"
        />
        <path
          d="M147.3,124.9c-.2.8-.9.9-1,1-.7.9-1.5.7-2.5-.5-.5,0-1.2.2-1-.5l1-2c2,.3,1,1.9,3.5,2Z"
          fill="#0473f3"
        />
        <path
          d="M143.8,125.4c0,0,.3-.6.7-.5s.5,1.2,1.8,1c-.3.6-.4.9,0,1.5-1-.2-1.3-.4-2.5-.5-.2.3-.3.3-.5,0,0,.5-.2.4-.5,0-.2-.8.4-1.1,1-1.5Z"
          fill="#0356ea"
        />
        <path
          d="M142.8,126.9c.2,0,.3,0,.5,0,2.1,1.2-.9,2.7-1.5,1-.2,0-.4,0-.5,0s-1.3-1.6-1.5-2c1.3.2,1.5.8,3,1Z"
          fill="#0474f0"
        />
        <path d="M145.8,121.4c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#033fd9" />
        <path d="M148.8,111.9l-1-.8.5-.2c-.2.2.4.7.5,1Z" fill="#065eeb" />
        <path
          d="M154.3,126.9c-1.2.5-2.1-.3-2.5,1,.3,0,.8,0,1,0-.6.6-3,.2-4,0,0-.3,0-.8,0-1,1,.2,2,.4,3,.5.1-.1-.8-1.2-1-1.5.1.1,2.9.8,3.5,1Z"
          fill="#0480f5"
        />
        <path d="M148.8,126.9c-.5,0-1.4.3-1.5-.2.6-1.6,2.9-1.2,2.5-.3s-.8.1-1,.5Z" fill="#047af2" />
        <path
          d="M146.3,131.3c.8-.4,2.4-.7,3,0,1,.9.8,1-.5,1,0,.8-1.2.7-1.5,0-.8.2-1.6,1.4-1.5-.5h-.5s-1,1-1,1c.6-1.7.6-1.4,2-1.5Z"
          fill="#0376f3"
        />
        <path
          d="M149.8,130.3c1.5-.2.9,2.4-.5,1-1,0-2,0-3,0v-.5c.9-1.4,1.4-1.5,1.6-.4,1.1-.8,1.7-.8,1.8-.1Z"
          fill="#087ff5"
        />
        <path
          d="M148.8,132.3c.8-1,2.1-1,2,.5,1.2.7,1.3.9,0,1.5-.4,3.1-.4.8-2,.5-.1.4-.3.4-.5,0,1.2-.5,1.8-.5,1.5-2-1,1.1-2.1.4-2.5.5v-1c1-.2.6-.1,1.5,0Z"
          fill="#0584f6"
        />
        <path
          d="M148.3,129.8q-.2.2,0,0c0-.7.2-.8.5-.5.3-.3.6-.5.5-1,.1,0,.4,0,.5,0v.5l.5.5c0,.1,0,.4,0,.5.4.6.2.8-.5.5l-3.5.5c.3-.4.3-1.1.5-1.5s.7-1,1-1c.5.4.9,1,.5,1.5Z"
          fill="#0376f3"
        />
        <path d="M140.3,273.3l-.5-.5c.3,0,.5.5.5.5Z" fill="#0235ee" />
        <path
          d="M141.3,231.3c-2.5-.8,2.4-3,1,0,.3,0,.5.1.7.2s1.6,2.7.8,3.3c0,1.3.4,2.4,1,3.5,0,0,0,.4,0,.5.2.8-.5,1.2-1,.5-.2-.3-.7-.2-1,0-1.2.7-.8-.2,0-1-.5.1-.6,0-.5-.5-.1-.8-.4-1.4-1-2-.6.2-1,.6-1,1,.4.1.4.3,0,.5,0,.6.2,1,.5,1.5,1,.6-.7,3.6-1.5,4,2.8,1.4,3.6,2.9,2.5,4.5-.5.5-.5.7,0,.5.4.2.4.3,0,.5,0,.3,0,.7,0,1l2.5-.5-1,2.5,1.5.5c-1.4.5-2.1.5-3.2-.5s0-.3.2-2l-4,2.5c1.1-.1,1.4,0,1.7,1,.7-.5.5-1.7,1.2-1.5,0,2,2.3.6,2,2.5l.3.6c5.1.3-2.7,6.1-3.8,1.4-1.1-.9.7-1.1.7-1,0,.7-4.7.2-3.7-1l.3-.9c-1.6.4-2.5,0-2.8-1.1,1.5-.2,1.1,2.6.3,2.8-1.9.5-1.9-.7-1.8-1.8l.7,1.5c-2,.7-2.6.2-2.7-2-2.9-1.9-.4-3.3,1.9-1.4-.8.3-.8,1,0,1.9-2-1.7.2-3.3,1.5-1-1.6-.9-1.8-1.4-.7-1.5,0-1.5.4-2.5,1.2-3,2.3-3.2,3.8-4.1,4,1q.8,1.1,0,0c-.3-.8-.4-1.8-.3-3.2-2.3.2-3-.4-2.2-1.8.9-1.9.9-3.4,0-4.5-.8-.5,1-3.5.9-2.9s-.4,0,.1-.6c-.5-.4-.7-.6,0-1,.4-.7.9-1.4,1.5-2-.9-.8-.7-1,.5-1,.9-.3,1.3-.1,1,.5.4.5.9.3,1.5-.5Z"
          fill="#0346f3"
        />
        <path
          d="M134.3,247.3c-.2,2-1,3-1,3.2s.4.8.5,1.3c-.6,0-1.3-.6-2-.5.2.5.4.9.5,1.5-.2,0-.9.2-1,0-.5-.7,1-2.6-1.5-2-.2.5.5,1.3.5,1.5,0,0-.9-.2-1.5-.5s-.9-.6-1.5-.5c-.4-1.3,1.2-1.2,1.5-1.5s-.4-.7-.5-1c-.4-.1-.4-.3,0-.5.7-.8,1.9,0,2,1,.7-.7,1.1-.5,1,.5l.9-1c.2-2,.9-2.9,2.1-2.5.9.2.9.7,0,1Z"
          fill="#022fed"
        />
        <path
          d="M133.8,251.8c1.2.1,2.2.3,3.5,0-.6.7,0,1.9,0,2-.1.1-.8-.1-1,0,.2.5-.3,1-1.5,1.5,0,.9-.7.9-2.1,0v.6c0,.4-.4,1-.9,1l-1.5-1c0,0,0-.4,0-.5,0-.5-.2-.9-.5-1,0-.4.5-1.9.5-2,.8.5,0,2,2,1.5,0-.3,0-.7,0-1,.8.3.4.9.5,1,1.2.8,1-1.2,1-2Z"
          fill="#0235ef"
        />
        <path
          d="M141.8,238.8c.7-.1.8,1.3,0,1.5-.1,0-.4,0-.5,0l-.5.5c0,.1,0,.4,0,.5-.3.7-.6,1.3-.5,2,0,0-.9-.5-1-.5,1.6-2-1.6-1.9-1.5-2.2.9-2.2,2.8,2.3,3-1.8.2-1.3.4-1.2,1,0Z"
          fill="#0330ee"
        />
        <path d="M144.8,238.8c.1.7,1,1.4-1,1.5,0-.3,0-.8,0-1l1-.5Z" fill="#023fef" />
        <path
          d="M142.8,238.3s.6,0,.5.5l-1,.2c.1.1.5.2.5.3.2,1.6-.3.8-1,1v-1.5c-.4-1.3,0-1.4,1-.5Z"
          fill="#023fef"
        />
        <path d="M140.8,240.8l.5-.5s-.4.4-.5.5Z" fill="#023fef" />
        <path
          d="M135.8,238.8c2,.1.6.9,1,2.6s2,1.1,2,1.6-.8.9-1,.7.1-1-.3-1-1.2.5-1.7.5c1.2,2.2,3.6,0,2.5,5,.3,0,.7,0,1,0,.2,1.2-.7,2.6-2,2.5l-.2-1-1.2,1.5c-.5-2.9,2.4-1.8,2.5-2s0-.7,0-1c-.3,0-.7,0-1,0-.3-.7.7-2.8.5-3-.8-.9-2.1,2.9-3.5,2,0-.3,0-.7,0-1,.1,0-.2-.2-1-.5l-1-1.5c0-.7.6-.6,0-1.5s-1.7-1.9-2.5-2l.5-1c0-.3.1-.6.2-.6,2.4-.5,4.9,2.1,5.3,4.1l-1.2-.4c-.1-.2.7-3.8,1.2-4.1Z"
          fill="#0339f2"
        />
        <path
          d="M136.3,253.8c1.4,1.7,1.4-.2,3,.7s.1-.9.7-.7c1.6.5-.3,1.6-.7,2s-.3.3-.5.5c-1.3-.6-2.6-1-4-1,.3-.7.8-1.1,1.5-1.5Z"
          fill="#033ff4"
        />
        <path d="M141.8,247.3c0,.2,0,.3,0,.5-1.9,1.3-2-.2,0-.5Z" fill="#0323e8" />
        <path
          d="M142.3,229.3c1.3.6.9.7.5,2-.1.4-.3.4-.5,0-.1-.6.3-1.3-.7-1s-.1.7-.3,1c-.2.7-1,1.1-1.5.5-.2,0-.7-.4-1-.5.4-.7.9-1.3,1.5-2,.6-.1,1.4.1,2,0Z"
          fill="#0235ec"
        />
        <path
          d="M136.8,235.3c0,.2,1.4.7-.5,1.2,2.1,1.5-.4,1.4-.5,2.3-2.3-.2-1-.3-1.5-1,1.7-.7,2-1.1,1.5-3l1,.5Z"
          fill="#0233eb"
        />
        <path
          d="M138.3,232.3c.3.7-.4,1.5,1.5,2.3l-3-.3c0-.6.3-1.8,1-2,.1-.5.3-.5.5,0Z"
          fill="#0233ec"
        />
        <path
          d="M142.3,237.8c.1.2.3.3.5.5-.3,0-.7.5-1,.5s-.7,0-1,0c-.6-.3-1.1-1-.5-1.5,0-.1,0-.4,0-.5-.6-.8.3-1,1-.5.8-.3,1.1.2,1,1.5Z"
          fill="#0556f4"
        />
        <path d="M141.3,235.8c.4.1.4.3,0,.5l-1,.5c0-.1-1.3-.7-1-1,1-.6,1.5,0,2,0Z" fill="#032ee8" />
        <path d="M141.3,235.8c.5,0,1,0,1.5,0l-.5,2c-.4-.5-.7-1-1-1.5v-.5Z" fill="#023fef" />
        <path d="M141.3,231.3c0,.2.2.6,0,.9-.5.7-2.9,1.1-1.4-.4.3,0,1-.6,1.5-.5Z" fill="#0552f4" />
        <path d="M140.8,238.8c-1.5-.2-2-.8-.5-1.5.2.5.6.4.5,1.5Z" fill="#0235ef" />
        <rect fill="#0235ef" height="1.5" width="1" x="137.8" y="237.3" />
        <path
          d="M140.8,241.3l.8.5c1.2-2.8,1.4.3,1.7,2,.3,1.7.4,1.8.5.5.2.2.8.5,1,.5.3-.9.7-.9,1,0v.5c-2.6.3-2.5,1.5-4,2.5-.4-.1-.4-.3,0-.5-.3-1.4-2-4.3-2.2-2l-1.3-.5c.5-.4.9-1.9,1-2,.5-.8,1-1.3,1.5-1.5Z"
          fill="#023fef"
        />
        <path d="M143.8,244.3c-.3,2.2-.3.7-.5-.5.2.1.3.4.5.5Z" fill="#021ae2" />
        <path d="M142.8,245.3c-1-.3-1.1-1.1-1-2,1,.3,1.1,1.1,1,2Z" fill="#044ff4" />
        <path d="M147.8,240.3c-.3.6-1.2,2.7-2,2s.6-1.3,1-1.5.7-.3,1-.5Z" fill="#044ff4" />
        <path
          d="M135.8,262.3l1,1.5c.9.1.4-1,.8-1.5,1.4-2,2.3,1.1,2.9,1.4s1.5,0,2.4.1c-.3.5-1.3,1-1.5,1.8s1.1,0,1,.5-.7,0-.9.3.4.7.4.9c.6.4,1.6.7,3,1,0,.5-.9,2.3,1,2v.5c-.7.1-.6.8-2-.5l.5,1.5c-.4.3-3.9-2.5-2.5,0-.3,0-.7,0-1,0,0,1.2-1.2.9-1.5,0-.1-.4-.3-.7-.5-1l-1.8-.8c-4,2.2-3.9-2.3-3.2-4.7-.6-.5-.8-1.1,0-1.5.2.2.5.7.5,1h.5c.2-.4-.6-2.4-.5-2.5.2-.1,1.1.1,1.5,0Z"
          fill="#0235ee"
        />
        <path
          d="M142.3,267.3c.1-.3.3-.3.5,0,.8,0,1.8.2,2,1-1.2,1-2.1-.6-3.5-.5,0-.3.5-.4.5-.4h.5Z"
          fill="#0551f5"
        />
        <path
          d="M132.8,264.8l1,.5c.1,1.4-.2,2,1,2.2l-1,1.7c.1.1,1.9-.4,2-.5.3-.3-1.5-1.8.5-1.5.5,1.9-1.1,1.4-1.5,2.5,1.9,1,1.9-1,3.5-1-.4.9,0,1.3.5,2,0,.5-.3.5-1,0l-.5-.5c.4.6.1.8-.7.5-.8,1.1-1.4,1.3-1.8.5,0,.5-.3.8-1,1h-.5c0-1,.1-3.2,0-3.7s-.8-.1-1-.6c-.7-1.4,1.3.4,1-1s-.4-1.8-1.5-1.8c-.2-.9.8-.3,1-.5Z"
          fill="#033eef"
        />
        <path
          d="M139.3,263.3c-1.2,1.2,1.4,1,.5,2s-2.3.4-2.2,2.5l-.8-2.5-1.5-.2c1.2-1.7,1.7.4,3,.2l1-2Z"
          fill="#033eef"
        />
        <path
          d="M138.8,270.8c.2.2.8.3,1,.7l-.5.3c-1.3-.4-.9-.5-1.5-1,.3,0,.7,0,1,0Z"
          fill="#074aec"
        />
        <path
          d="M138.8,187.8c.4-.8,2.2-1,1.7.3l.3-.3c.2,0,.4,0,.5,0,.9-.3,1,1.4.5,2v1.5c-.1.2-.8-.5-1-.5,0,.3,0,.7,0,1,1.6.2.5.9,1.5,1,.6-2.3,1.9-2.1,2.5,0s0,.7,0,1c-.1,0-.3,0-.5,0h-.5c-.1.4-.3.4-.5,0-.6.8-1.1.4-1-.5l-1.5,1.5c.9.4.9.7,0,1,0,.2-.2.6-.5.5-.5.1-.6,0-.5-.5-1-.3-2-.5-3-.5-1.3-.1-1.8-.5-1.5-1,.4-.2.4-.3,0-.5.1.9-.3.9-1,.5-1.5.7-2.5,1-3.6.2-1.1,1.5-2-3-1.8-3.2,1.8-.1,1.9-.3,1.5-2l.5-.4c.9-1.3.9-.9,1,.5,2.3,0,3.4.7,3.5,2,.4.5.1.7-.5.5q-1,.5,0,0c.6-.3.9-.1.5.5l1,.5c.2-.3.6-.3,1,0,.4.1.3.8.3.8-.6-1-.2-1.8.7-.8l.5.5c.5-.7,1.1-1.2,2-1.5-3.9,2.8-3.8-2.8,0-1-1-.1-.9-.6,0-1-.2-.2-.3-.2-.5,0,0,.7-.7.7-1,0-.7,0-1.7-1.8-.5-2Z"
          fill="#0368f6"
        />
        <path
          d="M139.8,195.8c.2.1.3.3.5.5.6.5,1.3.9,1.7,1.7s-.2,1.3-.2,1.3h-.5c-.8,0-1.6-.2-2.5-.6l-1,.6c-.8.5-1.6.9-2.5.5-.3.1-.7.4-1,.5h-.5c1.1-1,3.5-1.4,1-2.2,2.5-.8.1-1.3,0-1.7,1.1-.8,3.8-1.2,5-.5Z"
          fill="#035eee"
        />
        <path
          d="M144.8,193.8h.6c0-2.6,3.4-.1,2.9,1.5.8.3,3.4.7,3,1q-3,.6,0,0c.5-.2.9-.4,1.5-.5,0,.1,0,.3,0,.5l-1,1.5c-.7,1.2-2.1,1.7-4.2,1.4l-.8.6c-.3.7-1.2.7-2.5,0q-1.5-.4,0,0c.8,0,1.7,0,2.5,0,0-1,.4-1.2,1.4-.6,1.6,0,2.8-.2,3.6-1.4.3-.7.6-.8,1-.5h.5c.8.3.5.9,0,1.5,0,.2,0,.4,0,.5-1.9.3-.9,1.3-2,2.5-.3.4-1.1.2-2.2-.6-1.1,2-1.9,2.6-2.3,1.6-.5-.2-1-.3-1.5-.5-.1,0-.3,0-.5,0-.4-.1-.8-.5-1-1-.3,0-.7,0-1,0,0,.3,0,.7,0,1-1.3.4-1-.7-1-2-.8-.5-.9-.7,0-1-.7-.9-1.2-1.9-1.5-3-.4-.6-.2-.8.5-.5.2-.8,1.2-.7,1.5,0,.2-.6.4-.9,1-1-.1-.4.1-.8.5-1h.5c.1-.4.3-.4.5,0Z"
          fill="#0371f6"
        />
        <path d="M153.8,195.8c-.3,0-.7,0-1,0,.1-.6,0-.6.5-1,.7-.2,1.1.5.5,1Z" fill="#0371f6" />
        <path
          d="M146.8,202.8c0-.1,1.7,0,.5-2.5.1,0,2.2.4,2.6.5s1.3.9,1.4.9c.1.2.3.2.5.5,0,.6-.1.9-.5,1-.7,1.1-1.1.6-1.5-.5-.3-.3-.7-.3-1,0,0,.1-.4.2-.3.7s.2.9.3,1.3c-1.5-.5-.6-1.1-2-1,0-.3-.1-.8,0-1h-1.2s-.3-.5-.3-.5c.5-.2.9-.6,1.5-.5v1Z"
          fill="#035af1"
        />
        <path d="M147.3,205.8c.6.9.3,1.2-.5.5-.6-1.3-.3-1.5,0-2.5-.2.2.5,1.5.5,2Z" fill="#035af1" />
        <path d="M143.8,201.3c1,0,1.1-.2,1,1,0,0,0,.8-1,.5v-1.5Z" fill="#035af1" />
        <path
          d="M144.8,192.8c0-1.5,3.1,0,4.1.5s.3,1,.4,1l-1,1c-.5-.2-.9-.7-1.3-1-1.5,2.7-1,0-.7-1.5l-1,1.5c-.6,0-.5-.5-.5-.5-1.3-.1-1.3-.6,0-1Z"
          fill="#035eee"
        />
        <path
          d="M152.8,197.3c-.3.3-.7.4-1,.5-.1.3.2,1.2,0,1.4s-4.2.5-4.9.6c0-1.5-1-.9-1.5-2,1.9-1,2.2.6,2.6.8,1,.5,2.9-.4,3.9-.8.2-.7,0-1.3,1-1.5,0,.3,0,.7,0,1Z"
          fill="#0367f4"
        />
        <path d="M144.3,199.8c-.2,0-.6.9-1.5.5v-2.5c.9.3.9,1.3,1.5,2Z" fill="#0258f2" />
        <path
          d="M146.8,199.8c0,1.2-.4,1-1.5,1.5.5-1.9-.9-1.4-1-1.5,1.7-.5,1.5,0,2.5,0Z"
          fill="#035bf4"
        />
        <path
          d="M141.3,194.8c.6-.6.9-.6,1,0,.7,0,.4.5,0,1-.4.1-1,0-1.5,0,0-.3-.4,0,0-1,.1-.4.3-.4.5,0Z"
          fill="#0254ef"
        />
        <path d="M143.8,197.8c-.8-.8,1.4-1.6,1.5-1.5.5.6-1,2-1.5,1.5Z" fill="#0659ec" />
        <path d="M151.3,196.3c-.4.1-2.4,1.1-2.5,1v-1s2.5,0,2.5,0Z" fill="#024ce7" />
        <path
          d="M143.8,193.8c0,.4-.2.7-.5,1-.2.2-.3.2-.5,0-.9-.3-.3-1.2.5-1,.2,0,.3,0,.5,0Z"
          fill="#0581fb"
        />
        <path d="M143.3,194.8c-.3.3-.3.8-1,1v-1c.1-.4.3-.4.5,0h.5Z" fill="#0368f6" />
        <path d="M144.3,193.8h-.5s0-.1.5,0Z" fill="#035eee" />
        <path
          d="M150.8,217.8c.5,0,2.1.6,3,0-.2.8-1.2,1.1-1.5,1.8s.7.8,1,1.2c-.1,0-.5-.2-.9.1s.3,1.1-.9.9-.4-1.8-2.3-1l1-1.5-1.5-.5c.7,0,1.5-.9,2-1Z"
          fill="#056df2"
        />
        <path
          d="M143.3,223.3c1.6,1.1,2.2.5,2.4.7s0,.9.3.8c.9-.2,1.4-1.5,1.5-1.5.9.4,1.1,2.4,2,2s1-1.7-.2-1.7l2-.7-1,.7,1.5,1.8c.1.4-.4.8-1.5,1-2.8-1.9-3.3-1.3-6.2,0l-.3-2c-1.2.5-.5,1.5-2,1.5,0-.3,0-.7,0-1s.7-.8.5-1.5c0-.4.3-.4,1,0Z"
          fill="#024af0"
        />
        <path
          d="M146.3,217.3c1.4.7,1.5,1.1,1,2.5l-1.5-1c0,0-.5-.5-.3-.9s.7-.4.8-.6Z"
          fill="#0367f4"
        />
        <path
          d="M152.3,225.3c.6,0,2.1.8,1.5,1.5s-2.3-.8-3-.5c0,.3,0,.7,0,1s0,.3,0,.5c-.2,0-.4-.3-.5-.5s0-.4,0-.5,0-.4,0-.5c.2-.4,1-.9,1.5-1s.3,0,.5,0Z"
          fill="#036cf4"
        />
        <path d="M132.8,245.8h-.5c0-.2,0-.3,0-.5.3,0,.5.2.5.5Z" fill="#0339f2" />
        <path d="M137.8,270.8c-.2,0-.4-.3-.5-.5.4,0,.4.4.5.5Z" fill="#0235ee" />
        <path
          d="M132.3,184.3c.1-.4.3-.4.5,0,1,.6,1.5,1.7,1.6,3.2,1.5-.7,2.1-.6,1.9.3l.5.5c-.2-1.4,1.2-1.5,2-.5l.5,2c0,.6-1.3,2.1-1.7,2-1.9-1.2-3.8-2-5.8-2.5-.2-.1-.9-.6-1-.5,0,.7.2,1.5,0,2.2s-2,.5-1,1.3,1.7-1.7,2.5-.8l-2.5,2.7c.5-.2,2.3,0,2.4-.1s-.1-.7.3-.9.4,1.7,1.7,1c.4.2.4.3,0,.5-.8,0-1.8,0-2,1,.6,0,1.4,0,2,0,0,.3-.4.7-.5,1,0,1-.9.6-1.5,0l-.5-.5c-.1.4-.3.4-.5,0,0-.3,0-1.4,0-1.5-.9-1-1.1,2-2,1s.3-2.5-1-1.5.1.8,0,1l-.4,1.2c-2.8-1.1-2.8-2-.1-2.7-1.4-.6-.8-1.8.5-2,0-.3-.6-1.4-1-1.5l1-1.5v2s2,0,2,0c-1.1-2.8.3-1.7.5-2,.4-.5,1.1-3.7.5-4.5,0-.9.4-.7,1,0Z"
          fill="#0256ee"
        />
        <path
          d="M128.8,198.3c0-.7.5-1.3.5-2,1.3.4.7,2.3,1,3.5-.3,0-.7,0-1,0-.2-.4-.5-1-.5-1.5Z"
          fill="#034ae9"
        />
        <path
          d="M125.3,188.3c.3-1,.7-1,1,0,0,.1.2.8,0,1-.6.5-2.4-.8-2,1-.6,0-1.2-.5-1.5-.5.1-1.7.9-1.1,2.5-1.5Z"
          fill="#0243e2"
        />
        <path
          d="M124.3,190.3c.9-.6,2.9-1.4,3,0,.6-.6,1.9,1.1,1,1.5-.9.9-1.7,1.7-2.5,2.5.5,1.2-.5.9-.3.6.5-.6,1-.3.9.6,1,.3,1.7,1.1,2,2.3.4-.6.5-.4.5.5.9-.2,1.1,1,.5,1.5,0,.4-.3.4-.5,0-.4,0-1.1-.5-1.4-.4s0,.5-.3.7c-.6.3-4.1,2.2-2.3.2v-.5c.5,0,.9-.2,1-.5-.4-.1-.4-.3,0-.5l-.5-.5c-.4,1.2-.9,1.1-1.5,0-.7.9-1,.9-1,0,0-.4-.1-.6-.5-.5v-.5c.2-.4.3-.4.5,0l.5-.5c-2.6,0-2.3-.4-.6-2.1-.1-.4-.1-.9.1-1.4-.1-.6-.3-1.3-.5-2-.3-.9,1.4,0,1.7.2s-2.8-.8-1.2-1.7c.4-1.1,1.5-.7,1.5.5Z"
          fill="#0361f3"
        />
        <path
          d="M122.8,189.8c-.1,1.5,1,.9,1.5,2l-2-.5c0-.2-.3-.4-.5-.5-.2-.2-.2-.3,0-.5.1-.1.2-.4.5-.5s.3,0,.5,0Z"
          fill="#0249e8"
        />
        <path
          d="M122.8,193.3c.1.5.3,1,.5,1.5l-1.5,1.5,2-.5c0,0-.4.8-.5,1l-.5.5c-.1,0-.3,0-.5,0-.6.2-1.2.7-2,.5l-.5-2.5,1.5.5,1.5-2.5Z"
          fill="#0241ea"
        />
        <path
          d="M127.8,193.8c0,.2.2.8,0,1-.4.2-1.3-.3-1.5.3.2.8,1.7.6,2,.3v2.5c-1.5-.5-.9-1.6-2.8-2.5l-.7,1.5c-.2-1.4-.1-1.8,1-2.5,0-1.7,1.5-2.2,2-.5Z"
          fill="#0349ee"
        />
        <path
          d="M128.3,191.8c0,.1-.4,1.7-.5,2-.9-.2-1.3,0-2,.5l-.3-3c1,1.7,1.5-.3,2.8.5Z"
          fill="#0474f6"
        />
        <path
          d="M125.3,198.3l.5.5c0,0,0,.4,0,.5.1.3-.2.4-1,.5,0,0,0,.4,0,.5-.6-.5-.5-1.3-1.5-1,.2-.3.3-.7.5-1,.4,0,1.2,0,1.5,0Z"
          fill="#0334e6"
        />
        <path d="M126.8,196.8c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#0349ee" />
        <path d="M125.8,199.3s.6,0,.5.5c-.4,0-1.2-.1-1.5,0l1-.5Z" fill="#034ef2" />
        <path d="M122.8,197.3l.5-.5c-.1.2-.3.4-.5.5Z" fill="#035af1" />
        <path d="M125.8,198.8l-.5-.5c.3,0,.4.4.5.5Z" fill="#034ef2" />
        <path
          d="M139.8,195.8l-5,.5c0-.3.4-.7.5-1,.2-.4.7-.4,1.5,0,.7,0,1.7-.5,2.2-.4s.6.7.8.9Z"
          fill="#0578f8"
        />
        <path
          d="M132.3,196.8c.4.1,1,0,1.5,0,0,0,.5,1.2-.2,1.5-.7-.9-1.7-1.1-2.8-1-.2-.1.5-.7.5-1h.5l.5.5Z"
          fill="#0a7ef7"
        />
        <path
          d="M135.3,193.8c.4.1.4.3,0,.5l1.5,1c-.5,0-1,0-1.5,0s-.7.5-1,.5c0-.3,0-.7,0-1s0-.4,0-.5c.3-.7.5-.4,1-.5Z"
          fill="#0257f3"
        />
        <path
          d="M144.3,227.8c-1.5-.8,2.1-2.3,2.9-2.2,1.2.1,2,.5,3.1,1.2.3.1.3.3,0,.5v.8c-1.1,1.8-1.6,2.8-1.6,2.8-2-1.8-2.8.7-.9,2,0,.3-.1.9,0,1,.2.2,1.5-.8,2,.2-2.6,1-.4,1-.1,1.3s-.4.9-.4.9c.2.2,0,.4-.5.5.4.1.4.3,0,.5l-2-.5.5-1c-1.8,0-2,.1-1.5,1.5-1.6,1.5-2.3-1.1-1.5-2.5-.4-1.2-.9-2.3-1.5-3.5-.3-.7-.4-1.3-.5-2,.2,0,.4-.8.6-.9.4-.1,1.1.6,1.4.4s0-.8,0-1Z"
          fill="#0346f3"
        />
        <path
          d="M144.3,234.8c0,1,.2,2.9,1.5,2.5,0,.1.8,0,.3.5-.4.4-1.2.4-1.3.5-2.3.1-.8-2.3-1-3.5.1-.4.3-.4.5,0Z"
          fill="#023fef"
        />
        <path
          d="M150.8,227.8c.8,0,1.5.6,2,2,.3,1.5-1.1.8-2,1.8s2.1,0,.3,1.2c-.6-.7-1.5-.8-2.2-1.3s.1-1.6-2-.7c.5.7.7,1.2,1,2-2.3-.1-1.3-2.1-1-3.5l2,1c-.7-1.6.2-2.2,1.5-3,.2-.3.3,0,.5.5Z"
          fill="#0462f5"
        />
        <path
          d="M142.8,231.3l1.5-1.5-.5,3c1-.7,1.2-1,2.5-.5.2.9-1,.2-1.4.6s-.6,1.7-.6,1.9h-.5c-.2-1.2-1.2-1.9-1.5-3.5h.5Z"
          fill="#045bf7"
        />
        <path d="M147.3,228.8h-1c-.2-.7.2-1,.7-1.5l.2,1.5Z" fill="#045ff8" />
        <path d="M143.3,223.3c-.3,0-.7,0-1,0s-2.9,1.1-1.5-.5,2,.2,2.5.5Z" fill="#0462f5" />
        <path d="M126.3,212.8c.3,0,.9-.7,1-.5v1.2s-1-.2-1-.2c0-.1,0-.5,0-.5Z" fill="#0221df" />
        <path
          d="M323.2,135.8c.4.2.8.2,1,0h.5c.1.4,1.3.4,1,1-1.1-.2-1.4,1.5-1.8,1.5-1.7,0,0-1.3-.2-1.5s-1.1.2-1.4,0,0-.8,0-.9h1Z"
          fill="#0382f1"
        />
        <path
          d="M322.2,134.8c-.2,0-.3,0-.5,0-1.6,0-.7,1-1.3,1-1.4.2-.8-1.5-.2-1.8s1.5.4,2,.8Z"
          fill="#08acf9"
        />
        <path d="M334.7,158.3c-.4-.4-1.3-.4-1-1.5h1s0,1.5,0,1.5Z" fill="#0baaf9" />
        <path d="M340.7,172.3l.2-1.5c.5.5.9.8.7,1.5h-1Z" fill="#09acf7" />
        <path
          d="M288.7,91.4c-.5-2.4,3.9-1.4,4.5,0,0,.1,0,.5,0,.6s-2.3,1.4-.2,1.3.7-1.1.8-1.5l.5,1.3,1.5-.3c.3,1.3-.7.9-1.5,1.5s-.7.3-1,.5c-.8-.7-.9-.5-.5.5-.7.3-.9.6-2,0-1.6-.9-1.3-2.6-2-4Z"
          fill="#17a2f8"
        />
        <path
          d="M295.7,94.9l1.5.3.5-.8,1,1.5c0,.2,0,.7,0,1-.4.3-2.3-.8-2.8-1.2s-.1-.8-.2-.8Z"
          fill="#169ef8"
        />
        <path d="M294.7,99.9l2-3-.5,3.5c0,0-.6.6-1.2.5s-.3-1-.3-1Z" fill="#09a8fa" />
        <path d="M292.7,95.4c-2.6-1.8,0-3,.5-.5-.2,0-.3.4-.5.5Z" fill="#21abfb" />
        <path d="M293.7,96.4c.4,1.6-1,.7-1.5,1,.1,0,.3-.8.5-1,.3,0,.7,0,1,0Z" fill="#0988f4" />
        <path
          d="M287.7,90.9l.7-2.5c.5,1.9,1,.6,2,.6s.2.7.6.9c.8.3,2,0,2.6,1-.2.2-.4.3-.5.5-2.4-1.7-1.2,1.3-1.5,1.5s-1.4,0-1.5,0c-.2-.2.7-1.9.5-2.5,0-.1-1.5,1-2,1s-.3,0-.5,0c-.6,0-.5-.5-.5-.5Z"
          fill="#2ab1fa"
        />
        <path
          d="M313.2,101.9c.3,0,1.2-.8,1.5-.5,1.2,1-.8,3.2-.5,3.5l1.5,1c-.7-.2-1.3-.9-2,0h-.5c-.2-1.2-1.3-2.8-2-1s.2,1,0,1.4c-.6.9-2.8.7-2.4-.9,1.2.2,1.4-.3,2-1-.4-.9-.2-1.8.5-2.5.6,0,1.4.1,2,0Z"
          fill="#0ca3f8"
        />
        <path
          d="M311.2,100.9c0,.3,0,.7,0,1s.5.6.4,1.2-.5.9-.9,1.3c0-.5-.1-.7-.5-1-.6.1-1.1.2-1-.5v-.5l1-1c.3-.2.7-.3,1-.5Z"
          fill="#1ab1fa"
        />
        <path d="M310.2,101.4l.5,1c-.5,0-1,0-1.5,0s-.3,0-.5,0c.4-.6,1-.7,1.5-1Z" fill="#0ca3f8" />
        <path d="M309.2,102.9c.3.2.8.3,1,.5-1.7,1.2-3.4-.4-1-.5Z" fill="#0ca3f8" />
        <path
          d="M192.8,99.4c.9-.5,2.1,0,3.5,1.5,2.4,1.4.4,1.3-.5,2-.4-2.4-1.2-.7-1.5,1-.3,1.3-.6,1.3-1,0,0-.2,0-.3,0-.5-.4-.3-.7-.6-1-1-1,.2-1.1,0-1-1,.8-.6.9-.9.5-1-.8-.9-.2-1.8,1-1Z"
          fill="#0692f7"
        />
        <path
          d="M187.3,96.4c.9.4,1.5,1,.5,1.5,1.3.5,1.4,1,.5,1.5.5.1.4.3,0,.5h-.5c-.4-.6-.3-1.7-1-1.5v1.5c-.9.2-.3-.6-.5-1-.9.4-1.5.4-2,0,0,0-1-.5-1-.5,0,0,0-.3,0-.5.5.1.8-.5,1-.5,0-.3,0-.6.1-.6,2.6-.6,1.4.8,1.4.2s.2-.4.5-.5c.3,0,.2-.2,1,0Z"
          fill="#159cf8"
        />
        <path
          d="M187.8,96.4c1.9-.4,3.1,0,3.5,1,.1,1.3-1.1,0-1,.1,1.6.7,2.3,1.5,1,2.9-.2.6-.6.4-1-.5.9.7,1.1,1.2.5,1.5-.2,0-.6.4-1,.5,1.1,1.3-1.2,2.3-2.5,1.5-.4-1.4,1.6-1.2,2.5-1.5-.5-.5-.4-.6-1.5-.5v-.5c2.2,0,.1-.7,0-1s0-.4,0-.5c.1-1.2,2-.6,2,.5-.6-.6-1.4-1.3-2.5-2-.2-.5-.2-1-.5-1.5,0,0-.2-.4.5,0Z"
          fill="#0692f7"
        />
        <path
          d="M192.3,102.4c0,0,.4-.7,1-.5,0,.5,0,1,0,1.5-1.2-.4-.9.9-1,1-1.3.9-1.1-1.2,0-2Z"
          fill="#11b5fb"
        />
        <path
          d="M191.3,100.4c.1-.4.3-.4.5,0,.3,0,.9-.1,1,0,1,1.2-1,.9-1.5,1s-.3,0-.5,0c-.3-.5-.4-1-.5-1.5.3.1.7.4,1,.5Z"
          fill="#0bb0f9"
        />
        <path d="M194.3,103.9c-.2.9-.3,1.5,0,2.5-1.9-.7-1-1.4-1-2.5h1Z" fill="#09b1fa" />
        <path
          d="M187.3,104.9c.4.1.4.3,0,.5-1.1.4-1.4.9-1.5,1,.1-.4.3-1.4.5-1.5s.7,0,1,0Z"
          fill="#0594f8"
        />
        <path d="M187.3,104.9c.3,0,1-.2,1,.2,0,.5-.7.1-1,.2v-.5Z" fill="#0382f0" />
        <path
          d="M192.8,117.4c-.9-.6-.7-1.1.5-1.5.3-.1.7-.4,1-.5,0,.8,1.5,2-1.5,2Z"
          fill="#04a4fa"
        />
        <path
          d="M199.2,97.9c0,.3,0,.7,0,1,0,.6-.9,1-1.5,1-1.1,0-1.1,0,0,.5.1-.4.3-.4.5,0,0,.3,0,.7,0,1-.6-.4-1.3-.5-2-.5s-1.6.7-1.9.5c0-1.1-1.4-1.7-1.6-2-1.4-.3-1.3-1.1,0-1.5,1.2-3.1,2.5-2.3,4.8-.6l1.7.6Z"
          fill="#0aa0f8"
        />
        <path d="M207.7,108.9c-.2,0-.5,0-.5,0l-.5-.2c0-.5,1-.4,1,.2Z" fill="#05aafa" />
        <path
          d="M199.2,98.9c0,.1.6.5,0,1-.5,0-.9.5-1,.5-.2,0-.3,0-.5,0-.4-.1-.4-.3,0-.5,0,0,.6-1.3,1.5-1Z"
          fill="#09b1fa"
        />
        <path d="M205.7,93.9c-.2.1-.4.3-.5.5-.3-1.6.6-2.3.5-.5Z" fill="#33abfb" />
        <path
          d="M194.8,95.4c1.8.7,2.7,1.7,4.5,2,0,.1,0,.3,0,.5-1.4.8-4-2-4.3-2s-1,1.8-2.2,2c-.1.5-.3.4-.5,0l1-2.5c.2,0,.3,0,.5,0,.6,0,1,0,1,0Z"
          fill="#0b85f1"
        />
        <path d="M202.7,96.4v1.5c-1.2.3-1-.5-1.5-1.5h1.5Z" fill="#0a90f9" />
        <path
          d="M200.2,90.9c.4-.4,1.8-1.5,2.2-1.5.5,1.4-.2,1.8,1.8,1.5l-1-2h2s-.5,1.5-.5,1.5c.7.2,1-.3,1.5-.5v.7c.1.2.3.3.5.3-1.5,2.3-.3-.8-2.1.5s-1.3,1.1-1.4,2c.9.7.9.8,0,1.5v.5c-.3,0-.7,0-1,0-.3-2.2,1.8-5.6-2.5-3.5.2-.3.3-.8.5-1Z"
          fill="#2a9ffa"
        />
        <path d="M203.2,93.4l1.5.7-1.5.7c0-.5,0-1,0-1.5Z" fill="#0e8ff5" />
        <path d="M206.7,92.9c-.2.2-.8-.5-.2-.5s.4.4.2.5Z" fill="#2e9ef9" />
        <path d="M199.2,88.9c2.1.3.7.2,0,.5v-.5Z" fill="#378bf4" />
        <path d="M198.2,90.4c-.3-.2-.5,0-.5-.5h.5v.5Z" fill="#2199f9" />
        <path
          d="M190.8,91.9c.3-.5-.9-1.5,1.5-.5-.2-3,1.5-1.3,1.5.5-1.2-.4-1,1.2-2,1.5,0-1.1.3-1.8-1-1.5Z"
          fill="#2b94f9"
        />
        <path
          d="M187.3,92.4c.8-.3,1.7-.5,2.5-.5v.5c-.6-.2-.9.4-1,.5-.6.4-1.4.6-2,1l.5-1.5Z"
          fill="#2f97f8"
        />
        <path
          d="M184.8,136.8c1-1.5,1.8-.5,2,1,.4-1.3.8-.8,1.5,0,.3-1.1,2.3-1.4,3-.5.6.9,1,1.5,1.5,2.5h.5c-.3-1.6.4-1.6,2.1.2.8-.4,1.2-.3,1.4.3-.2.6.4.5-1,1.5,0,.7-1.2,1-.8.6s.6,0,.8.4c.8.1,1.9,0,2,0s-.5,1.1,0,1.7,1.3.1,1.6.3-.5.7-.5,1c0,.9-.3.9-1,0-.8,0-.6.3.5,1,1.2,1.3.5,2.4-1,1.5-1.2.7-1.9.7-2,0-1.6,2.8-6.7-2.2-2.5-1.5.3-.5.3-.8,0-1-.6.7-1.2,1.5-1.8,2.2l-.7-.3c-.7,1.8-2.6.8-3.6-.4-.6.7-1,.7-1,0-.7,1.2-2.2-.5-1.5-1.2s3.7-.8,4,.2c.3-.2.3-.4,0-.5-.7.2-2,0-2.5-.5-.5-1,0-1.5,1-1-.3-.4-.3-.9,0-1.5-.3,0-.5-.1-.5-.5-.7.7-1.2.4-1.5-1-.2.3-.3.3-.5,0l-.5,1.3c.9.5.5.7-.5.7-.1.4-.3.4-.5,0-.5-.3-1-.5-1.5-.5-.4.2-.6,0-.5-.5-2.5-.4-.7-1.7.5-2.5-.5-.4-.8-.9-.5-1.5-.6-1.2.5-1.5,1-.5.5.1,1.1.2,1.9.3,0-1,.4-1.4,1.1-1.3Z"
          fill="#04a7fa"
        />
        <path
          d="M188.3,145.8l1.5-1c0-.9-1.6-.1-1-1.7s1.7-1.1,2.2-1.8l.8,2.2-1.5-.7c-.5.6,2.3,2.6-2,3.5v-.5Z"
          fill="#028ef8"
        />
        <path
          d="M184.8,136.3c.4.1.4.3,0,.5-1.3.7,1.5.5,1,2-1.3-1-2.4,0-3.3,0s-.4-.8-.7-.9c-1,0-1-.8,0-1,1.3.2,1.1,1.5,2,1s-.5-1.6,0-2,.9.5,1,.5Z"
          fill="#028cf6"
        />
        <path
          d="M186.8,135.8c.6.5,1,1.9,0,2-.3,0-.8-1.6-2-1v-.5c.3,0,.4-1.6,2-.5Z"
          fill="#049ffa"
        />
        <path d="M194.2,141.8c-.8.8-4.2-.6,0-1.5,0,.4.1,1.4,0,1.5Z" fill="#038cf5" />
        <path d="M187.8,136.8c.2.3.3.7.5,1-.4,0-1.2,0-1.5,0v-2h.5c.9,0,1.1.4.5,1Z" fill="#027fed" />
        <path
          d="M180.8,138.3c1.6,1.1.6.5.5,1.5-1,.2-1-.6-1.5-1-.2-.2-.2-.3,0-.5v-.5c.2-.4.3-.4.5,0,.7-.6.9-.3.5.5Z"
          fill="#0380f4"
        />
        <path d="M182.8,143.3c-.5.8-1,0-1.5-.5.7-1.5,1.2-1.1,1.5.5Z" fill="#059df9" />
        <path
          d="M181.3,136.8c.2,0,.3,0,.5,0v1c-.2,0-.5,0-.7,0l-.3.5c-.2-.1-.4-.3-.5-.5-.8-.3-1-.9,0-1,0-.5.6-.3,1,0Z"
          fill="#049bfa"
        />
        <path d="M189.3,141.8c-.6.3-1.7-.8-1.5-1l1.5-.5v1.5Z" fill="#047ef1" />
        <path d="M192.8,145.8c.5-.2,1.6-.9,2-.2-.6.4-1.3.9-2,1.2v-1Z" fill="#0287f4" />
        <path d="M188.3,138.9c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#037cf7" />
        <path d="M186,139.3c.3.2.3.3,0,.5v-.5Z" fill="#028cf6" />
        <path
          d="M199.2,104.4c.2-.4.5-.2,1.1.6,1.7-.4,2.4-.2,3.4.4,1.3-.3,1.5,0,.5,1,.1.5.1,1.7-.3,1.8s-.5-1.7.3-1.8c.1-2.1,2.3-1.6,3,0,2.2-.6,2.2,2.7-.4,1.6.4,1.2-2.2,1.6-2.3,1.5s-.2-.3-.3-.7c-1,.3-1.2.7-.5,1,1.4-1.1,3.4-1.9,3,.5.5-.4.8-.4,1,0,1-.6,1.8,1.5,1,2,.8,1.1-.2,1.5-1,.5q-.8-.7,0,0c.9.1,1.2.3.5,1,.4.1.4.3,0,.5.1.4,0,.9-.5,1-1.4,0-2,.5-2,1.5,2.5,2.3,1.3,5-1.5,3-.1.5-.3.4-.5,0-.4,0-.6,0-.5-.5-.6.9-1.2.7-2-.5q-.8-1.1,0,0l1.2.8c.1,1.5.2,2.2,1.7,1l.6.8c.6-.5,2.1,0,2,1,.6-.5.9-.1,1,1,.5.3.6.6,1.3,0,.5.2-.5,1.2-.3,1.5s.8-.1,1,0,.5,0,.5.5c-.6.1-2.2-.7-2.5-.5s-.4,1.6-.5,2c-.6-.3-1.2-1-2-1h-1.5c.3,1.5-1,1.7-2.1.9-1.5.4-5.1,1.1-5.4-.9,0-1.1-.2-2-1-2.5-.2.2-.2.4,0,.5,2.1-.2,1.6,2-.5,1.5,0,.7-.9,1.7-1.5,1q-1.3-1.3,0,0c1,0,.8.7,0,1-.2,1.1-.5.9-1,0,0,2.7-1,2.3-3-1-.2-1.2-.7-2.6-1.5-4-.1-.9,1.6-3.1,1.1-1.5-.9,3-5.3-.6-1.6-2-1.3-1.4-1.7-3.9.5-2.5.3-1,.7-1,1,0,.4,0,.7,0,1-.5-2.9-1.5-1.4-4,1-3,1.1-.8,1.7-.3,1.5,1,1-1.4,2.6-1,2,1,.4.2.4.3,0,.5.2,1.1-.2,1.3-1,.5-.6,1-1.2,1.3-1,0l-.5-.5c-1.1.2.2.9.9,1.1l-.4.9c1.2,1.4,0,.5,0,.5.5-.2,1.4.3,1,1l1-.2c2.8,2.4,3.4,2.4,2,.2-1-.5-.8-1-.4-1.9-.8-.3-1-.8-.6-1.6.5-.7.3-1.3,0-2-.2-.6.5-1.3,1-1.5.9-.3,3.1,1.7,2,2.5.4.2.9.4,1.5.5-.2-.8.1-1.4,1-1.5v-.5c3-.7,2.5-1.9.5-3.5,0,2.2-2.2,3.5-2,1-1.1,0-2.1.2-3,.5-2.4-.2-5.2-2.1-1.3-3.4l1.7.3c.2-1.3.9-1.9,2.2-1.9-.2-.2,0-.4.5-.5-.7-.4-1-.9,0-1Z"
          fill="#05aafa"
        />
        <path
          d="M203.7,125.9c.7-.2-.4-1.3.3-1.5s1.2,0,1.7,0c-.9.7-.5,1.4-.5,1.5,0,.3-.4.7-.5,1-1.2-.8-.9-1-1-1Z"
          fill="#047ef3"
        />
        <path
          d="M193.3,118.9c.1-2.2,2.8-1.6,3,0,0,0,1.8-.6,2-.5l-.8,2c.9-.2,1.3-2.6,1.5-2.5,1.3.5,0,2.3.3,2.5l1.3-.5.2,1c-2.2-.5-4.2,2.2-5.2-.5-1.9,5.2-3.1,2.1-.8-1-.6.1-1-.2-1.5-.5Z"
          fill="#039df8"
        />
        <path
          d="M196.2,111.9c.4.9-.9,1.2-1,1.5.6,1,.6,1.6,0,2,.3.8,1.3.5,2,.5l-1,3c0,0,0,.7,0,1-1.6-1.1-1-2.9-3-1-.6-.3-1.4-.5-1.5-.5-.2-.2.5-.7.5-1,.1-.4.3-.4.5,0,.6-.6,1.1-1.3,1.5-2,0-.2,0-.3,0-.5,0-1.1,1-2.8,1-3-.1-.9.4-.5,1,0Z"
          fill="#06b7fb"
        />
        <path
          d="M199.2,110.4c1.4,1,1.9,2,1.5,3-.5,1.3.8.9-1,1.5-.5,0-1-.2-1.5-.5-.5-.7-1.1-2.1-2-2.5s-.7,0-1,0c0-.5-1.5-2.7.8-.5.3,0,.2-.4.2-.5,1.1-1.5,1.2-.7,3-.5Z"
          fill="#039af9"
        />
        <path
          d="M201.2,109.4c2.6,2,2.5,3.2-.5,3.5,0,.1,0,.3,0,.5l-1.5-1.5c0,.3.2.9-.3,1-.7.2-2.5-2.1-1.5-2,2.2.2,1.4-.4,1.7-.5s.9.6,1,.5c0-1.4-.3-1.5,1-1.5Z"
          fill="#06b3fb"
        />
        <path
          d="M201.2,109.4c.4,0,.8-.2,1,.3.3,1.5,2.5,1.3,2.5,3.2h-4c.3-.7,1.3-.9,2-1l-1.5-2.5Z"
          fill="#0391f6"
        />
        <path
          d="M195.2,123.4c1.7-.7.5.1,1.4.5s2-.1,2.6.8l-3,1.2c-.3,0-.7,0-1,0-.8.4-1,.3-.5-.5.7-.5,1.6-.6.5-1.5-.4-.1-.4-.3,0-.5Z"
          fill="#039bf9"
        />
        <path
          d="M203.2,119.4c0,1.2.2,1.3.5.5,0,0,.4,0,.5,0l.5,1c.4.1.4.3,0,.5-.6-.2-1.7.3-2.4-.1s-.8-1.9-1.1-2.4c.2.1,1-.1,2,.5Z"
          fill="#0285f4"
        />
        <path
          d="M207.7,112.9c-.3,0-.7,0-1,0-.1-1,0-1.1,1-1,0,.3,0,.8,0,1,.2,0,.5,0,.7,0l.3-.5c1,1.4,2.6,1.4,2,3.5-1.6.4-.9-1.3-1.6-1.9s-.8,0-.9,0c-.4-.3-.3-.7-.5-1Z"
          fill="#0294f9"
        />
        <path
          d="M205.7,116.9c0-.3-.6-.8-.5-1.2s1.8,0,.5-1.8l2,1.5c1.1-.1.5,2.3-.5,1-.1,0-.6-1.4-1.5.5Z"
          fill="#0392f8"
        />
        <path d="M206.7,122.4c-.5-.3-1.7-.9-2-1v-.5c1.4-.2,3.1.2,2,1.5Z" fill="#0396f9" />
        <path d="M204.7,116.9c0,0,.6,1.9.5,2h-1.5s0-2,0-2c.3,0,.9,0,1,0Z" fill="#04a2fa" />
        <path d="M204.2,106.4c.2.4.6,1.8.5,2-2.5.2-2.8-.9-.5-2Z" fill="#0492f7" />
        <path d="M204.7,122.8c-.5-.1-1.7.8-2,.5-.6-.6,1.4-2.6,2-.5Z" fill="#0287f4" />
        <path d="M205.2,113.4c-.3,1-1.1,1.1-2,1,.3-1,1.1-1.1,2-1Z" fill="#0191f7" />
        <path d="M195.2,113.4c.9.8,1.8,2.3,0,2,0-.2,0-1.8,0-2Z" fill="#0292f6" />
        <path d="M204.2,108.9l-.5,1c-.4-.2-1-.4-1-1,.5,0,1,0,1.5,0Z" fill="#0492f7" />
        <path d="M199.7,114.9c-.3,0-.6.5-1,.2s-.3-.6-.5-.7l.2-.5,1.3,1Z" fill="#0282ec" />
        <path d="M195.2,123.4v.5l-1.3,1c-.9-1.1.5-1.2,1.3-1.5Z" fill="#0491f6" />
        <path d="M203.7,119.9c0,0,.1,1.9-1,1s.6-1.1.5-1.5c.2.1.3.3.5.5Z" fill="#04a2fa" />
        <path d="M201.2,118.9c-.2-.3-1.4-.4-1-1.5.8,0,.9,1.5,1,1.5Z" fill="#0278ea" />
        <path d="M198.7,105.4h.5c-.1.3-.4.4-.5.5-1.4.2-1.4-.7,0-.5Z" fill="#047bef" />
        <path d="M190.8,112.9c.4-.2.3-1.3,2-.5l-.5,1.5c-.4-.2-.5-1.3-1.5-1Z" fill="#038ff7" />
        <path d="M189.8,115.9c-.2.7,0,1.5-.8,2l-.2-1.5c.2,0,.6-.5,1-.5Z" fill="#0390f7" />
        <path
          d="M191.8,115.4l.5.5c0,0,0,.4.2.4s.5-.3.8-.4l-.5,1.5h-.5c.2-1.6-2.3-.2-1.5-3,.6,0,.7.6,1,1Z"
          fill="#0290f7"
        />
        <path d="M193.2,119.9c.4,1.8-2,.1-3,1l3-1Z" fill="#039df8" />
        <path d="M193.3,126.4c-.4,0-1,0-1.5,0l.5-2.5c.6,0,.9,1.9,1,2.5Z" fill="#0391fa" />
        <rect fill="#048df7" height="1.5" width="1" x="190.3" y="123.4" />
        <path d="M191.2,121.9c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#0280f7" />
        <path d="M192.3,115.9c-.2-.2-.4-.3-.5-.5.1.2.4.3.5.5Z" fill="#04a4fa" />
        <path
          d="M182.8,134.3c.6,0,1.7.5,2.5,0-.7,1.2-1.3,1.6-2.5,1-.5-.4-.7-.7,0-1Z"
          fill="#0389f7"
        />
        <path
          d="M186.8,132.3c0,.2,0,.4,0,.5,0,.3-.1.8,0,1.1s1.8,1.7,2,2.4c-.2,0-.6.5-1,.5-.2-.3-.3-.7-.5-1-.6-1.2-2.6-3.9-.5-3.5Z"
          fill="#049ffa"
        />
        <path d="M183.3,132.8c2.1-1.5,2.2,1.3.5,1l-.5-.5h-.5c.1-.3.3-.4.5-.5Z" fill="#0487f4" />
        <path
          d="M190.3,129.4l-.3.5c-.3,0-.7,0-.7,0-.3-.5-.3-.8,0-1,0,0,.4,0,.5,0s.3.4.5.5Z"
          fill="#0470f0"
        />
        <path d="M189.3,129.8l-.5-.7.5-.3c0,.1,0,1,0,1Z" fill="#039ff9" />
        <path
          d="M182.3,129.8c-1.2-1.3.7-1.5,1-.1s-.8-1.1.5.1c0,.5-.6,1.2-1,1.5l-.5-1.5Z"
          fill="#049bfa"
        />
        <path d="M183.8,133.8c-.3,0-.4-.2-.5-.5l.5.5Z" fill="#049bfa" />
        <path
          d="M193.3,135.8c.5-.3.7.2.5,1.5.2.4,1.5,2.5,1.7,2.5s.9-1.3,1.7-1c.1.6-.4,1-.5,1.5-1.1.4-2-.6-2.8-.8s-.6.3-.7.3h-.5c-1-.2-2-.4-3-.5.3-.8,1.4-.7,1.5-2q.5-.9,0,0c-1.1.2-1.8.5-3,.5-.9-.2-1.2-.4-.5-1-.2-1.3,0-1.2,1-.5,0-.9,1-1.3,3-1,.5,0,1.2.5,1.5.5Z"
          fill="#0493f9"
        />
        <path d="M193.3,135.8c0,0,.5-.7,1-.5l-.5,2c-.2-.4-.2-1.1-.5-1.5Z" fill="#037bf3" />
        <path d="M193.3,139.8h-.5s.2,0,.5,0Z" fill="#0260f0" />
        <path d="M191.3,137.3c0-.2-.6-.9-.5-1,.2-.3,2.2-.8,2.5.3.3.9-1.2.6-2,.7Z" fill="#06affa" />
        <path d="M193.2,137.8c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#03b1fa" />
        <path d="M186.3,162.8c-.7-.6-.1-.4,0-1,.3,0,.9-.7,1-.5.4.5-.4,1.3-1,1.5Z" fill="#05a6f9" />
        <path
          d="M185.3,158.8c.1-.4.3-.4.5,0,.1.3-.2.5.5,1,1.1-.3,1.4-.6,1-1,.1-.1.1-.7.5-1,1.9.4,1.6,1.2,1.5,3-.5-.2-.9.5-1,.5-.3,0-.7,0-1,0s-.5-.4-1-.5c-3-.6-1.7-.9-3.5-2-1.4-.6-.4-2.8,1-2.5.2-.4.3-.4.5,0,.5.9-.4,2.2,1,2.5Z"
          fill="#05a6f9"
        />
        <path
          d="M192.8,146.8c-.5.3-1,0-1,0-.9,1.6,2.8,1.2,3.5,1.5.5.7,1.2.6.8-.2l1.2.2c.6-.6.9-.3,1-1.5-.5-.3-.7-.7-.5-1,.3,0,.7,0,1,0,0,.6,0,1.3,0,2,.3-.8,1.9.5,1.9.6.1.3-.4.4-.4.4l-.8.7c1.3,2.6-1.7,4.4-2.2,2.3-.3-.2-.6-.2-1,0,2.2.7,2.2,1.3.5,3,.2,1-4.6,2-4.8,1.9-.7-1.3-1.7-1.6-2,0-.5-.2-.9-.4-1.1-.8q-.6-.8,0,0c1.5.3,1.5,1.1,1,2.9-.5-.7-1.1-1.1-2-.9.9.9.8,1-.5,1,0,.5-.3.9-1,1-1.4.4-1.8-.3-.5-1-.3-.4-.4-.4-.5,0-1.4,1.5-2-1.2-1-2.5-.2-.5,0-.7.5-.5,1.3,0,2-1,2.1-3,1.9.2,2.8-.1,2.4-1l-.5.5c-.7,1.4-2.9,1.4-1.5-.5.4-.5,1-.9,1.5-.5,1-1.7.5-1.8-1.5-.5-.7.6-.9.3-.5-.5-1.6-1.3-1.6-2.3,0-3,1,0,3-.2,2.5,1h.5c0-1,2.1-2.1,3-2.5.9-.1.9.2,0,1Z"
          fill="#039bfa"
        />
        <path
          d="M197.2,148.3c-.8.8-1.3,1.2-2.5,1.5-.2-.2.3-1.3.5-1.5s.7,0,1,0l-1.5-1c.8-2,1.5,0,2.5,1Z"
          fill="#037aef"
        />
        <path d="M197.7,145.8c0,.3.5.8.5,1l-1.5-.8c0-.5.7-.2,1-.2Z" fill="#038af6" />
        <path
          d="M186.8,147.3l-1,1.5c2.1.1,1,1.4,1,1.5h-1c.1.7-.2.7-1,0-.9-1.3,1.1.3,1-1l-1.5-1c1.7.5,1.4-.9,1.5-1s.7,0,1,0Z"
          fill="#0389f6"
        />
        <path
          d="M188.8,152.3l.5-.5c.9,0,2,.9,1.5,1.5s-2.7-.6-3.4,0,.6,4.1-2.6,2.4c-.4-.1-.4-.3,0-.5.1-.3.3-.3.5,0-.6-.8-.4-1.1.5-1,.6-1.9-.9-1.5,1.5-2.5.6,1.1.6,1.3,1.5.5Z"
          fill="#0389f6"
        />
        <path
          d="M187.3,150.8c1.4-2.1,2.1-1.2,4-.5-.6-1.2-2.4-1.7-.5-2.5-.3,1.3,1.4.8,1.5,1.3.7,2.4-1.6,1.7-3.5,2.2,1.3-2.4-1,0-1.3,0s-.2-.4-.2-.5Z"
          fill="#0389f6"
        />
        <path d="M194.2,150.8c-.9,1.2,1.6,2.4,1,3s-3.9-3-1-3Z" fill="#0281f8" />
        <path d="M188.8,155.8c0,0-1.4.3-1-.7s1.6-1.6,2-1.3c1,1-2,1.1-1,2Z" fill="#0285f2" />
        <path d="M187.3,158.8c1.9.8.3,1.9-1,1-.4-1.3.9-.9,1-1Z" fill="#0371f0" />
        <path
          d="M184.8,155.3v.5c0,.3-.2.4-.5.5s-.3,0-.5,0v-.5c-.3-.6,0-.8.5-.5h.5Z"
          fill="#027eed"
        />
        <path d="M185.3,158.8c-.5-.7-.8-1.3.2-1s.1.7.3,1h-.5Z" fill="#027aef" />
        <path d="M197.2,151.8h-1l.7-.5c.1,0,.1.4.3.5Z" fill="#07a5fa" />
        <path d="M188.8,152.3c0-.3.2-.5.5-.5-.1.2-.3.3-.5.5Z" fill="#059df9" />
        <path d="M199.7,154.8c-.2,0-.3,0-.5,0l.2-.5.2.5Z" fill="#0367ef" />
        <path
          d="M188.8,155.8c0,0,1.8-.3,2.1-.5.6-.3,0-1.4,1.4-1l-.5,1.5c.4.3,4.1-1,5-1s.9.4,1,.5c.5.2.8.5,1,1-.2.2-.8.4-.9.6-.3.7,1,1.7-1.1,1.9s-.4,0-.5,0l.5-2.5c-2,.7-4.4,0-5.7,2-.2-1,1.2-2.8-.7-2.5,0,1.6-.8,2.7.5,4l-1,1c1.7.6,1.4-1,1.5-1,1.1-.4,1.1,2-.8,2s-1.1-1-1.2-1l-.6-.4c.2-.9-.1-1.8-.9-2.6.9-.9,1.7.3,2,0,.9-.8-.6-1-.8-1.2-.3-.3-.1-.8-.2-.8Z"
          fill="#0285f9"
        />
        <path
          d="M199.2,154.8c.1-.2.3-.2.5,0v.5c-1.6-.2-.8.7-1,1-1.4.4-.9-.9-1-1,.3-.6.9-.5,1.5-.5Z"
          fill="#0254ea"
        />
        <path d="M195.2,155.8v.5c-2.1.2-2.1-.7,0-.5Z" fill="#005ded" />
        <path
          d="M168.8,157.8c.4.1.4.3,0,.5l.5.5c0-.7,1-1,1.5-.5,1.3-1.8,3.7.5,2.5,2.5,0,.6.1,1.2.5,1.6,2.2,0,1.7.8-1.5,2.4.5.1.5.3,0,.5.6,1.5.3,2.4-1,2.5-1.6.9-2,1-4,1,.3-.5.2-1,0-1.5-2.1,0-2.5-1.5-1-3,.1-.4.3-.4.5,0l.5-1.1c-.8-1.4-.9-2.7-.9-4.2s.1-1.6,1.1-1.3c-.4-1.5,1.3-1.5,1.3,0Z"
          fill="#0490f9"
        />
        <path
          d="M171.8,168.8c2-1.1,5.1,2.4,2.7,3.3s-2.5-.5-2.6-.6-.2-.4-.2-.8c0,0-.5-1.7-.5-2,.1-.4.3-.4.5,0Z"
          fill="#0796f9"
        />
        <path d="M171.8,168.8h-.5c0-.3,0-.7,0-1,1.3-2.5,3.3,1.1.5,1Z" fill="#0365e7" />
        <path
          d="M155.3,186.3c.7-1.5,1.2-1.2,2,0,0-1,.7-.9,1,0,.9.6.4.8-.5,1,1.3,0,1.1,1.9,0,2,0,.3.1.5.5.5.9-.7,1.3-.4,1,1,.4-.4.7-.2,1,0q.6,1.1,0,0c-1.3-1.5,2.6-1.8,2.6-.4,1,0,1.8.1,2.4.4.4-.1.6,0,.5.5,1.2-.6,2.9.4,3.5,1.5,1,1-1.7,2.3-2.5,1l-.7.8c.3,1.1-.2,1.7-1.8,1.7-.3.6-1.3.8-1.3.3s.9-.2,1.3.2c.1-1.8,2-1,2,1,.2-.7.5-1.2,1-1.5,1.5-1.4,2,.7.5,1.5.4-.1.8-.2,1.1,0s-.3,1.9-.6,1.9c-.2,0-.5.2-.5.5l-1-.7c.8,1.2-.9,2-.5,3.7-.6-.2-1.1-1.4-1.5-2-1.2.3-.5-1-.2-1,.5,0-1.1,2.1-2.3,1.5-.3.3-.5.5-.5,1-.6,0-1,.3-1.5.5l.5-5.5-1.5.5c-.4.8,1.2,1.8,1,2-.4.3-1.5.1-1.7-.8s.3-.6.2-.7c-.4-.5-3.1,0-3.9-.6l1,2.5c-.3.4-2.3-1.1-2.5-1.5-.5-.1-.4-.3,0-.5.8-1.7,1.7-3.5,0-4,0,.6.1,1-.5,1-.6.7-1.1.9-1.5.5l-2.2-.4c-.5.9-.8.4-.8-.6-1.1-.9-.2-1.7,1-1,.3-1.3.6-1.2,1,0,.1-.8.6-1.4,1.5-2-1.4,0-1.3-.6,0-1-.2-.7-.2-.8.5-.5.1-.4.3-.4.5,0,.7-.7,1-.4.5.5l-.5.5c.8.4.9-.5.5-2.5-1.4.4-3,.3-2.5-1.5-.4-.1-.4-.3,0-.5.1-.3.4-.3,1,0,.5-.1.6,0,.5.5.4,0,.8-.3,1-1,0-1.3.7-1.5,2-.5Z"
          fill="#037bf8"
        />
        <path
          d="M153.8,195.8c.8.5.5,1.7-.5,1.5-.1.4-.3.4-.5,0-.6-.3-.5-.6,0-1-.5,0-.4-.3,0-.5.3-.7.6-.5,1,0Z"
          fill="#037bf8"
        />
        <path
          d="M164.8,201.3c.5,1.6-1.5.8-2.5.5,1.2-1,2.1-1,2.8-3,.8,1.4-.9,1.5-.3,2.5Z"
          fill="#0367f4"
        />
        <path
          d="M166.8,193.8c0,.3,0,.7,0,1,.2.3.5.3,1,0,.2,0,.8.2,1.1,0,.6-.4,0-1.2.8-1,.6,1.4-.9,1.5-1,1.7-.3.8.2,2.1,1,.8,0,0,.6.3,0,.7s-1.4.4-2,.8c0-.2,1-1.2-.5-1.5-.4.4-.7.9-1,1.5-.3,0-.8-1.6-2-1-.4-.1-.4-.3,0-.5,0-.5-.8-1.2-.5-2l1.7,1.5-.8-1.5c1.7-1.3,1.4-.5,2-.5Z"
          fill="#0375f6"
        />
        <path
          d="M164.3,196.3c0,.1,0,.4,0,.5-.2.3-1.4.4-1,1.5,3.1-2.6.7,1.8-1.5,2-.3-.2.8-5.3.8-5.7,0-1-1.6-1.6.2-2.2.4,1.5-.3,3.3,1.5,4Z"
          fill="#0265f2"
        />
        <path
          d="M159.3,190.8l.8-2c1.1-.3.6,1.1,1,1,1.3-.3,1-1.8,2.3-1.5.2.1-.5,1-.5,1,.6.1,1,.4,1,1,.9-1.8,1.3-.5,2-.5,0,.1-.4,1-.5,1-1.1.5-3.9.9-3-1-2.8.2-1.5.3-2,1,1-.9,1.2,1.1,1,2-1.4.4-1.6-1.4-1-2,0,.1-.6.2-.8.5-.3,0-.2-.5-.2-.5Z"
          fill="#046cf3"
        />
        <path
          d="M157.8,189.3c.7-.7,1-.4.5.5-.5.5-1.3.4-1.7,1.1-.7,1.4,0,2.6,0,3.9s0,1.8-1.3,1.5c-.8-1.7,1-2.1,1-2.2,0-1.2-1.6-1.9-1.4-2.4.5-1.6,1.1-2.8,2.9-2.4Z"
          fill="#0263f1"
        />
        <path
          d="M153.3,189.3c1.4,1.1.5,2.5.5,4h-1c0-.5,0-1,0-1.5l.5-.5c0-.3-.5-.4-.5-.5-.4-1.2-.9-1.7.5-1.5Z"
          fill="#0263f2"
        />
        <path
          d="M153.3,198.8c0-.5,0-1,0-1.5s.6-.6.5-1.5-.4-.7-.5-1c1.7-1.6,2.1,3.3,0,4Z"
          fill="#0367f4"
        />
        <path d="M169.3,192.8c-.8-.6-3-1.1-3.5-1.5.9-1.8,3.7.3,3.5,1.5Z" fill="#0366f2" />
        <path
          d="M151.8,192.3c.2.8,1.7,2,.2,2.5s0-1-.5-1-.9.5-1.2.5c-.6-1.4-.2-2.3,1.2-1.7l.3-.3Z"
          fill="#0366f0"
        />
        <path
          d="M159.3,187.3c0,1.1-.3,1.7-1,2.5-.2-.1-.4-.5-.5-.5.8-.7,0-1.7,0-2,.7-.9,1.2-1.2,1.5,0Z"
          fill="#035beb"
        />
        <path d="M160.8,194.3v1.8c-.1,1.1-2.5-1.2-2-1.7s1.4.6,2,0Z" fill="#0351ec" />
        <path
          d="M158.3,185.3c0,.1,0,.4,0,.5.4.1.4.3,0,.5-.3,0-.7,0-1,0-1.1-1.5-.5-2,1-1Z"
          fill="#0252e9"
        />
        <path d="M167.3,196.3c0,.6-.4,1.5-1,1.5,0-1.2-.3-1.7,1-1.5Z" fill="#0255d8" />
        <path d="M152.3,190.8l-.5.5c-.2-.6-1.3-1.8.5-.5Z" fill="#0257f2" />
        <path d="M152.8,191.8c0-.2.3-.4.5-.5,0,.3-.1.6-.5.5Z" fill="#0376f7" />
        <path d="M162.8,189.3c.2.2,1.3-.6,1,1l-1-1Z" fill="#119af7" />
        <path
          d="M156.8,167.8c.1-.4.3-.4.5,0,.7.6.2,1-.4,1.3s0-.8.4.2c.9.2,1.4,0,1.5-.5,0-1.4.7-1.7,1.5-.5l2-.5c2.2-1.3,1.4,2.7.5,3.5,1.2.1,1.6.6,1.1,1.5h.4c.2-.3.3-.3.5,0l.4.6c-2.3,1.2-1.7.8,1.6-1.1.6.2.6,0,0-.5-.4,1.4-1.1,1.7-2,1l-.5-.5c-.7-.3-.4-1.6.5-1.5l.6-.4c-.6-1.9.3-2.8,1.9-1.6,1.4-1.3,2.7-1.6,4-1,.6.3.5.6,0,1,1.2.9,1.4,1.6.5,2l-.3.8c1.2,1.6-1.4,3.5-2.7,2.7-.5.3-.6.6-.5,1l1,1,1-1c-.5-1.4,2.1-3,3-2.1s-.4,2.8-1,3.1c-.4,1.2-.6,2.3-.5,3.5.6.1.6,0,0-.5-1.3-2.9,1.6-1.8,2.4.1,1.4,0,1.6.6,1.6,1.9l2,3.5c-.8-.4-2.2-.3-2-1.5h-.5s-.3,1-.3,1l-1.7-1.5c1.2,2.8-2.7,1.6-1,4.5-.3,0-.7,0-1,0l-.5-.5c0-.1,0-.4,0-.5-.5-.7-.6-1.5.5-1.5,0-.4.5-.8,1-1-.1-.8-.9-.4-1.4.1l-.6-.6c-.5,1.3-1,1-1.7.2l-1.3.3c-1.5.5-1.2-1.2,0-2,.1-.6.3-1.1.5-1.5-.4-.3-.8-.6-1-1-1.5.5-1.7-1.8,0-1.5.2-.4-.2-.6-1-.5-.2.5-.3.5-.5,0-1.1-1.4-1.6,1.9.3,3.1-.8,1-1.2,1.8-1.3,2.4.2.3.4.3.5,0-.7-.2-.6-.9.5-2.1-.5-.8,0-.7,1-.4,1,0,1.8.6,1,1.5-1,.6-1,1.9,0,4-.1.9-.5,1.2-1,1-.2,1-.4,2-.5,3-.4.5-1.1.7-2,.5-.1-.7-.4-.8-1-1-.3-.6-.5-.4,0,.3-1.4.1-2.4.2-3.5,1.2-.4-.3-.7-.8-1-1,0-1.2.3-2,1-2.5-.4-.4-.7-.9-1-1.5-.4-.2-.4-.3,0-.5-.8-.5-.7-.6.5-.5-3.5.8-1.7-2.8.2-1.9s1.1,1.7-.2,1.9l.4-1c1.4.7.7-4.3.1-3.2.2,1.6-2.2,3.4-3.5,3.2-1.2.6-2.4,1.2-2-.5-.5-1.5-.3-2.5.5-3-.6-.9.8-1.7,1.5-.5q.7,1,0,0c-1.4.2-2.4-.1-3-1-1.6-.6-.6-2.8.5-1.5.3,0,.3-.3,0-.5-.8.5-1,.3-.5-.5-.4-.8-.7-1.8-.7-2.9-3.1-.6-.3-6.2,1.2-3.1.6-.5.8-.2,1,.5.2-.6.5-1.2,1-2-.9-.6.8-2.4,1.5-1Z"
          fill="#037ff7"
        />
        <path
          d="M155.8,183.8c1.1-1,1.7-2.2,3-2.5l-1-.5c0-2.3,2.1-.7,3.7-1s.4-1.9,1.3-1-1.1,1.2-1.3,1.5-.7,1.7-.7,1.9c-.1.3.4,2.2,0,2.6s-1.5,0-2,0c.5-.5-.4-1.6-1-1s.5,1.5,1,1c0,0-.4.4-.5.5-.5.2-.8.5-1,1-1,.1-1.4,0-2,0-2.9,0-2.2-2.4.5-2.5Z"
          fill="#0376f7"
        />
        <path d="M158.3,185.8c1.3-.2,1.1.3,1,1.5h-1.5c0-.3.4-.7.5-1s0-.4,0-.5Z" fill="#0376f7" />
        <path
          d="M157.8,171.8c.4,0,2.1,0,2.2,0,.5,0,0-1.6,1.3-1-1.2,2.2,1.3,2.2,1.5,2.5s-1.4,2.7-2,2,1.4-2.7-1-2.5l-.5,3c-.1.4-.3.4-.5,0,.7-2.2-.3-3.9-1.5-1-1.9,1.4-1.8-2.9.5-3Z"
          fill="#068df9"
        />
        <path
          d="M164.3,182.8c0,0-.8.1-1,0-.8-1,1.2-1.1,1.5-1.7.7-1.7-.7-.9-.9-1s.2-.4,0-.6c-.8-1.1-2.2-2.1-1.7-3.7l1.7,1.5c1.2-2.6.9-.6,1.2,0,.4.9.7,1.9,1,3-.5.4-1.5,2-1.5,2.5-.1.4-.3.4-.5,0Z"
          fill="#0376f7"
        />
        <path
          d="M167.3,181.8c0,0,.4.5.4.8s-1.7,0-.4,1.2.8-.2,1.5.3c0,.8-.9,1.2-1.5,1.7-1.9.3-2.2-5.3,0-4Z"
          fill="#036cf5"
        />
        <path
          d="M153.3,176.8c1.7.8,4.1-.3,6,.5-.2.9-1,1-1.7,1s-3.9-.2-4.3-1c-.4-.1-.4-.3,0-.5Z"
          fill="#036ef4"
        />
        <path
          d="M165.8,167.3c.7.3,1.2.3,1.5,0,.4.3,2.5-.1,0,1.5-1.9,0-2.4.5-.5,1.2-.5.6-1.6,1.9-2,.8-.7-.5-.6-1.8,0-2.5.2-.9.5-1.2,1-1Z"
          fill="#0a91f8"
        />
        <path
          d="M157.8,171.8c-.7,1.2-2.7,3.3-.5,3-.2.5,0,2.2-1.2.5s-.2-2.4-.8-3.5c1.9,1.1,1.4-.5,1.8-.5s.6.5.7.5Z"
          fill="#0268f2"
        />
        <path
          d="M166.8,177.8c-.3.4-.8.8,0,1.5.4.3.7.6,1,1,.2,1.8-.3,1-.5,1.5.3-1.2-.4-1-1-1.5-1.3-1.3-1.9-.9-1-3,0,0,.4,0,.5,0,.9-.2,1.2,0,1,.5Z"
          fill="#058af8"
        />
        <path
          d="M170.3,183.3c.9,0,1.6-.4,2.5-.5.3.9-.4.9-.5,1l-1,1c0,0-.5,1.4-.5,1.5l-1-1c.3-.7.6-1.2.5-2Z"
          fill="#0264eb"
        />
        <path d="M164.8,172.8c0,0-.4,0-.5,0v-.5c.3,0,.6.3.5.5Z" fill="#0a91f8" />
        <path
          d="M166.8,171.8c.4.1.4.3,0,.5-.7.4,0,1.4,0,1.5-.1.1-2.9.5-3.5.5,0-.4,1.2-1.3,1.5-1.5.7-.5,1.1-.9,2-1Z"
          fill="#0a91f8"
        />
        <path
          d="M166.3,186.8c.2,0,.7.6.9.4s0-.8,0-.9c.3-.3,1.3-.2,1,.7s-1.5.3-2,1.3v.5c1.3.2,1.2.6,0,1-.2,0-.3,0-.5,0,.1-2-1.4-1.9-1.5-2-.7-1.1,1.1-1,2-1Z"
          fill="#036ff3"
        />
        <path
          d="M159.3,175.8c1.8.4,3.1,1.7.7,2.5,0-1.4-.3-1.5-1.7-1.5-.3-.9.5-.9.5-1h.5Z"
          fill="#0260ea"
        />
        <path
          d="M155.8,179.8c-1.2,0-1.4.5-1.5.5-1.4,0-1.4-1.4-1.5-1.5,0,0,1.2.5,1.3.5.2,0,.4-2.5,1.7.5Z"
          fill="#035ceb"
        />
        <path
          d="M153.3,176.8v.5c-1.3-.6-.9,1.1-.5,1.5,0,0-.6,0-.8-.1-1.2-1.4,0-1.6.8-2.4.2.2.3.4.5.5Z"
          fill="#0263eb"
        />
        <path d="M155.3,168.8l.3.2c-.4,1.2,0,1.9-1.3,1.8-.3-3.8.5-1.9,1-2Z" fill="#0367ee" />
        <path d="M164.8,182.8c0,.9,1.8,2.4-1,2-.1,0,.8-1.6.5-2h.5Z" fill="#0365f4" />
        <rect fill="#0360ec" height="1.5" width="1" x="160.8" y="185.3" />
        <path d="M165.8,177.3c.4,0,1.1-.9,2-.5,0,.6-.8.7-1,1l-1-.5Z" fill="#0376f7" />
        <path d="M167.8,180.3c-.9.2-1.2,0-1-1,0,0,.6,0,1,.2.7.5,0,.7,0,.7Z" fill="#0359ec" />
        <path d="M155.8,179.8c1.5,0,1.4.5.2,1.5-.6-.1,0-1.1-.2-1.5Z" fill="#0559f1" />
        <path d="M163.3,183.3v1c-.7.2-1-.2-1.5-.7l1.5-.2Z" fill="#0259ed" />
        <path d="M172.3,183.8c-.7,1.7-.8.7-1,1-.9-.5.2-1.1,1-1Z" fill="#0387f9" />
        <path d="M166.8,171.8c1.6-.2,1.5,1.2.3,1l-.3-.5v-.5Z" fill="#0362f2" />
        <path d="M154.3,171.3s.2,1.1-.2,1c-1.4-.8-.3-1.6.2-1Z" fill="#025df4" />
        <path d="M171.8,179.3c1.7-.3,1.3,1.8,0,.5v-.5Z" fill="#0464e9" />
        <path d="M163,180.8c.3.2.3.3,0,.5v-.5Z" fill="#0376f7" />
        <path d="M171.3,187.3l-.5-.5s.5.5.5.5Z" fill="#0387f9" />
        <path
          d="M177.8,170.3c0,.4-.2,2,1,1.5l.5-4.5.2,2.4,1.3,3.1c-1.1-.4-1.1-.3-2,0,.2.8-.4,1-1,.5-.1.5-.1,1.8.5,2-.3.3-.4,2-1.5,2-.4-.6-.4-1.4,0-2.5l-1,1.5c-2.5-1.8,1-2.2,1.5-3-.4-.1-.4-.3,0-.5-.5-.4-.7-.8,0-1-2.1,0-2.8-.7-2-2l.5-1h.5c0,.7.1,1,.5,1.5.3-.2.6-.1,1,0Z"
          fill="#049cfa"
        />
        <path d="M171.3,188.3c1.1.2,2.2-.5,2,.7s-1.6,1.3-2,1.8c0-.4.6-2.3,0-2.5Z" fill="#038af8" />
        <path
          d="M180.8,153.3c1.3,1.1,1.2,1.5,2,2.5.7-.6,1-.3.5.5h.5l-1,2.5c-1.3-.8-2.2.5-1.7-2-.6,1.6-2.2.9-2.2,1s0,1.7,0,2c-.1.4-.3.4-.5,0-.8.3-.7-.8-.5-1.5-1.5-1.7-2.1-2.9.2-3.7-.2-1,0-1.5.8-1.3,0,0,.9-1,1-1,.6-.7.8.3,1,1Z"
          fill="#0492f8"
        />
        <path
          d="M178.8,159.8c-1.8-3.2,3.5-4.7,4-1,.1-1,2.3.5,2.9,1s.5.6.6,1c0,.3,0,.7,0,1,.4.2.4.5,0,1,.7.6,2.3.2,2.5.5.9,1.1-1.7.5-2,.5-.7,0-.7.2,0,.5.9.2,1.6,1,2.8,0,1,1.4-1,.9-1.9,1.5s-.7,1.7-1.6,1.9-2.8-.2-2.7-.9c4-.1,5.1-1.3,0-1.5-.2-.2-.3,0-.5.5-.5,0-.4-.5-2-.5-.5,1.5-2.8,1-3-.5.2-.6.5-1.1,1-1.5-.7-.8-.4-2.5,0-3.5Z"
          fill="#049afa"
        />
        <path
          d="M182.8,165.8c.3-2.6-2-.9-2-3.3l1.5-.5h-2.5c.7-1.4,2.1-1.2,1-2.7h1.5c-1,2.1.3,1.1.7,2.1s0,2.9.3,3.9c0,0-.4.5-.5.5Z"
          fill="#0387f5"
        />
        <path d="M186.8,163.8v.5c-.4,0-1,0-1.5,0,.5-1.5,1-.5,1.5-.5Z" fill="#05a6f9" />
        <path
          d="M178.8,163.3c.3.8-1.1,1.2-1.5.5-.3-.4,0-1.2.5-1.5-.9-1.1-1.2-2.2.5-2.5h.5c0,1.8.3,1.5,0,3.5Z"
          fill="#0389f7"
        />
        <path
          d="M178.8,163.3c0,.5,1.5.8-1,1.5-.2,0-.3,0-.5,0-.9.2-1.4-.4-.5-1,.1-.4.3-.4.5,0l1.5-.5Z"
          fill="#0377f3"
        />
        <path d="M180,158.8c.3.2.3.3,0,.5v-.5Z" fill="#0492f8" />
        <path
          d="M172.3,165.3c1.5.2,2.5.7,3,1.5.3.2.2.4-.5.5,0,0-.6,0-.4.6s.7,1.5.9,1.9c.8,1.5,1.9,1.7,2,2,0,.7-.5.5-1,0-.4.5-.4.7,0,.5.5-.4.9-.1,1,.5,0,.2,0,.4,0,.5-3.2,1.4-2.9-2.5-5.5-1v-1.5c.2.2,1.4.2,1.9.2s1.6.7,1.1-.4-2.6-.7-3-1.8c.8-1.5.9-1.8-.5-1,.1-1.1.9-1.9,1-2.5Z"
          fill="#0382f6"
        />
        <path
          d="M173.8,160.8c.4.1.4.3,0,.5l1.1.5c2.6-1.6,3.4-1.5,2.4.5.2.5,0,1.2-.5,1.5,0,.3.4.7.5,1-.1,0-.3.5-.5.5-1,.3-1.5.1-1.5-.5v-.6c-1.9,1.5-2.9,1.7-3,.6,0-.2-1.1-.4-1-1,.7.1,2.9,0,3-.8,0-1.3-1.8.4-2.6-.2s-.9-1.5-.9-1.5l2.5-.5c.1-.4.3-.4.5,0Z"
          fill="#0389f7"
        />
        <path
          d="M172.3,164.8c1.5.4,2.7-1.5,3.7-1.5.9.7-.2,1.1-.7,1.5l.5,1,.5.2-.5.8c-.1.4-.3.4-.5,0,0,0-.3-.4-.7-.4-1.5,0-1.4,1.4-2.3-1.1,0-.1,0-.4,0-.5Z"
          fill="#069df9"
        />
        <path
          d="M175.3,164.8l1.5.5c-.5,0-.9.5-1,.5-.6.1-1.4,0-2,0,0-.9,1.2-.8,1.5-1Z"
          fill="#0377f3"
        />
        <path
          d="M177.8,170.3c-.3,0-.6.5-.8.5-.3,0-.2-.4-.2-.5l1.5-1.5c.2.7-.4,1.1-.5,1.5Z"
          fill="#0564f4"
        />
        <path
          d="M175.8,166.8c.2,0,.8-.7,1-.5.8,1.1-1,1.1-2,1,.1-.2.3-.3.5-.5.2,0,.3,0,.5,0Z"
          fill="#0368f2"
        />
        <path d="M178.8,172.8c.9,1.2-.4,2.2-1,.5.2-.6.7-.4,1-.5Z" fill="#026ce8" />
        <path d="M183.3,169.3c.3.2-.5.7-1,.5s.6-.9,1-.5Z" fill="#0cb4ed" />
        <path d="M166.8,188.8h2c.1.8-1.6,1-2.5,1,0-.3,0-.7,0-1h.5Z" fill="#0361ef" />
        <path d="M167.8,194.8c-.1,0-.7,1.3-1,1,0-.3,0-.7,0-1h1Z" fill="#037bf8" />
        <path d="M166.8,188.8h-.5c0-.2,0-.4,0-.5l.5.5Z" fill="#037ff7" />
        <path
          d="M189.3,95.9c.6-.4,1-.4,1-1.2s-1.2.2-1-.7c1.7-.3,3,1.3,1,1.7l2,.8c.2,1.4-.1.8-1,1-2-.6-1.5.2-3.5-1,.3-.1.7-.4,1-.5.2-.4.3-.4.5,0Z"
          fill="#1e9ff9"
        />
        <path
          d="M186.3,96.4l.5,1c-.8.1-1.8-.1-2.5,0-.7,0-1.2.2-1-.5,1.8-1.5,1.8-.5,3-.5Z"
          fill="#0a7eef"
        />
        <path d="M184.3,94.9c.9-.5,1.7-.7,2,.5-1,.2-1.3,0-2-.5Z" fill="#2ea5fa" />
        <path d="M189.3,95.9c-.1,0-.3,0-.5,0-2.5-1.3.1-2.7.5,0Z" fill="#1178f2" />
        <path d="M189.8,92.9c-.2.2-.5,1.3-1,0h1Z" fill="#1068eb" />
        <path d="M193.3,95.4h-1c0-1.2.9,0,1,0Z" fill="#2199f9" />
        <path
          d="M180.3,99.4c0,.2,0,.4,0,.5-.1.3-.8.6-1,1-.1-.2-1.3-.6-1-1l1.5-1c.4-.2.5,0,.5.5Z"
          fill="#1a9ff7"
        />
        <path d="M180.3,99.4l-.5-.5c.1-.9.6-.2,1,.3l-.5.2Z" fill="#0594f8" />
        <path
          d="M173.3,123.9c2-.9,2-.9,2,1,1.1,0,1.1.6,0,1,.7.6,1,1.3,0,1.5,0,0-.6.9-1,.5s0-.8,0-1c-.2-.2-.4-.2-.5,0-.1,0-.5,1.2-.5,1.5-.2,0-.3,0-.5,0-.1-.2.1-.8,0-1-.5-1.1-2.6.4-2-2,.1,0,.4,0,.5,0,.9,0,1.6-.5,2-1.5Z"
          fill="#038cf6"
        />
        <path
          d="M179.8,111.4c.6.2,2.2.4,2.5.5s.2,2.1-.7,2-1.7-1.7-2.7-2.5v-.5h.5l.5.5Z"
          fill="#04a2f9"
        />
        <path
          d="M187.8,99.9c.4,2-1.8,2.4-2.5,3.5,1.1,1.2.4,2.4-2,3.5.2,1,.5,3.6-1.5,2.7-.4.4-.9.7-1.5.8,0,.4-.5.5-1.5.5.4.1.4.3,0,.5-.2.9-2.1-.9-2-.9,1.3.7,2,1.5,2,2.4q-1.9.4,0,0c1.5.6,2.8,1.3,3,3l.5.5c-1.4,1.3-2.1,3-2,5-1.9,1-3,2.1-3.3,3.4h-.7c0,1.1-.7,1-1,0l-2-1c0-.3,0-.7,0-1,0-.5-.4-.8-1-.7l.3-.8c-1.6,0,.3-1.8,1.3-1,.2-.5.9-.7,1,0q.8.3,0,0l-1-.5c-.5.4-1.2.6-1.5,0-.2,0-.3,0-.5,0l-.5.5c-.3,0-.7,0-1,0,1-.9,1.1-4.2-.5-4,.2-.1.9-1.4,1-1.5.5-.3,1.4,2.4,2-.5,1.7-.2,1.5,1.9,0,2,1.1-2.9,2,1.5,1.4,1.9s-2.8-1.3-1.4-1.9c-1.5,1.3,1.9,3.3,1.4.2-.5-.7-1.3-3.1-.4-3.7-.4-.1-.4-.3,0-.5-.4-2-.1-2.9.9-2.8,0-.8.7-1.4,2.1-1.7-.3-.8.3-1.7,1-1,.2-.4.5-.4,1,0,.6.4.2,1-.5,1v.5c.2-.5.5-.9,1-.5.4-.5.7-1.1.9-1.9,1.5-.4,1.8-.9,1.1-1.6.6,0,1,.4.7.7-1.2,1.3-3.1,1.1-4.2.8-.6.4-1.1.9-1.5,1.5-1.8,3.8-4.4,1-.5-1-.4.1-.6-.2-.5-1,.1-.4,0-1,0-1.5.9.3,1.9,1,2.8,1s-.1-1.2,3.2-.5c0-.7-.5-1.3-.5-2,.2,0,.4,0,.5,0,.4.2.4,1.8,1.5.2-.1-.5-1.1-.2-1.5-.2s-.3-.4-.5,0c-1.3,0-.9,1.1-1.2,1s-1.8-1.2-2.3-1.5c.3-1.1,2.2.2,2.5,0,0-.4-.3-.7-.5-1-.9-.6.1-1.4,1-1,1.9-.2,2.6,2.4,3,2.5,1.5-.8,3-1.8.5-.5-.7-1.2-.5-1.5-.5-2.5.3.1.7.5,1,.5.4-.6,1.3-1,2-1,0-2.4,1.9-.9,1.5,1Z"
          fill="#0594f8"
        />
        <path
          d="M173.8,112.9c.6.3.1.6,0,1,2.5-.5,2.3.4,3.5,2.2-.1.6-1.4,2.5-2,1.8s1.5-3.1-.2-3c-1.2.6.6,3.7-1,4s-2-.8-2.2-1.3c-.6-1.5.9-1.1,1-1.2-.1.7.3,1.3,1,1.5v-1.5s-1,0-1,0c.6-.7,0-1.7,0-2,0-.5,0-1,0-1.5,0-.9.7-.8,1,0Z"
          fill="#0387f3"
        />
        <path d="M175.8,106.4c-.5.5-.9.8-1,0,0-.2.5-.9.5-1,.5,0,.6.7.5,1Z" fill="#026dee" />
        <path d="M171.3,120.4c0,0,.3-.4.5-.5l-.5.5Z" fill="#038cf6" />
        <path
          d="M185.3,103.4c1.3-.2,1,.3,1,1.5.5.1.3.6-.5,1.5-.1,0-.4,0-.5,0-.3.1-1.1-.1-1.5.5-.1.4-.3.4-.5,0,0-.1-.2-.7.3-1s1.5-.3,1.7-.5-.5-1.1,0-2Z"
          fill="#0382f0"
        />
        <path
          d="M183.8,101.9c.8-.7,1.9-2.7,3-1-1.2.1-2.2,1.9-3.5,1.5.2-.2.3-.3.5-.5Z"
          fill="#11a9fa"
        />
        <path
          d="M175.8,106.4c-.2.8-1.3,1.2-1.5,2,.3.3,1.8-.7,2-1,.7-.7,1-.4.5.5-.4.5-.6,1-1.5,1,1.4,1.5,1,2.4-1,1.5l-.5,2c0-.2,0-.3,0-.5-.5-2.2-2-1-2.5-1.5s.6-1.5,0-2c.2,0,.3,0,.5,0,1.1-.1,2.4-1.1,3-2h1Z"
          fill="#0387f3"
        />
        <path d="M178.3,120.4c0,0,0,.7,0,1h-2s0-1.5,0-1.5c.1-.1,1.9.4,2,.5Z" fill="#038cf6" />
        <path d="M178.8,112.9c-1.2,1.3-2.4,1.6-2-.5l2,.5Z" fill="#06abfa" />
        <path
          d="M173.8,119.9c.5-.1,1.5-1.5,2-1,.9.9-1.3,1.1-1,1.5-.2,0-.7,0-1,0v-.5Z"
          fill="#0279ea"
        />
        <path d="M174.8,120.4h1c0,1.2-.7.1-1,0Z" fill="#14b7f5" />
        <path
          d="M181.3,104.4c.4,0,.9-.1,1.2,0,1.5.5-.8,1.3-1,1.5-1.1,1.2-.6,1.2-2.2,2,0-.9,0-1.3-.5-1-.3.1-.5.3-.8.5l-.2-.5c-.9,0-.9-.8,0-1,.6,0,1.9-1.4,3.5-.5,0-.3,0-.7,0-1Z"
          fill="#0383f5"
        />
        <path
          d="M177.8,105.9c0,.3,0,.8,0,1s-.7.7-1,1l-.5-.5c.2-.3.4-1.9.5-2,.3-.3.9.5,1,.5Z"
          fill="#0370ea"
        />
        <path d="M186.3,98.9c-.5,1-.9,1.2-2,1v-1c.6,0,1.5-1.2,2,0Z" fill="#0681f4" />
        <path
          d="M178.8,106.9c.1,0,.1-.4.3-.5,1.1-.4.9.7.2,1.5-.3.1-.6.5-1,.5-.4-.1-.4-.3,0-.5.2-.1.3-.7.5-1Z"
          fill="#0ea7f9"
        />
        <path d="M178.3,107.9v2s-1.5-.5-1.5-.5c.1-1.4,1.2-1.3,1.5-1.5Z" fill="#027bf2" />
        <path d="M157.8,161.3c-.2.2-.4.3-.5.5-1.8-1-.4-1.8,0-3l.5,2.5Z" fill="#0380f7" />
        <path d="M159.8,161.3c1.8.1.9,2-.5,1.5h-.5c0-.3,0-.7,0-1-.3-.6.5-.9,1-.5Z" fill="#0596fa" />
        <path
          d="M159.8,161.3l-1,.5c0,0-.4-.3-.5-.5.1-.2.4-.3.5-.5.5-.7,1.8-.3,1,.5Z"
          fill="#0380f7"
        />
        <path
          d="M130.3,182.8c.2.2.4.2.5,0h.5c.8-.6,1.2.7,1,1.5-.3,0-.7,0-1,0-1.5,0-1.7-.7-3,.5l.5-1.5c.3,0,.7-.4,1-.5.2-.4.3-.4.5,0Z"
          fill="#0472f5"
        />
        <path
          d="M122.8,168.3c.4.2.4.3,0,.5-1.4,1.2,0,1.4,1.5,1.3v.7c.5.5.2.7-.5.5-1,.5-1.4,1.4-1.4,2.7-1.3.3-1.2,1.8-.6,2.8-1.4-1.7,1.1-4.7,1-2,.6.6.8.6.5,0-2.2-.9-.4-3.4,1.5-1.5.4-.2.7-.4,1,0,.4.1.4.3,0,.5l.2.6c1.3-.3,1.6.3,1.7,1.6-2.3.8-.4,2,1.1,2.8,1.1.2.9.6,0,1,3.5-.3,4.3.2,2.5,1.5-1.6,0-2.1.2-1.5.5.7.3.9.9,0,1,.4.9-.4,1.2-1,.5-.7,1.5-2.3,1.9-2.5,0,2,1.5.3,4.1-2.3,2.8l-1.2.2c-1.2.2-1.2,1-1,2,.5.3.7.8.5,1.5.6.7.3,1-.5.5,0,.3-.2.5-.5.5-.5.5-1.2.7-1.5,0-.3-.5-.5-1-.5-1.5-1,.7-1.7.7-2,0l1.2.4c-.2,1.3.8,1.8,2.8,1.6l.5-.5c.7-.6.9-.3.5.5,1.2.7,1.7,1,.5,2,.1,1.1-1.4,3.7-1.9,3.9s0-1.5,1.4,0c.4.1.4.3,0,.5.4,2.6-2.7,1.1-1.7,1.4-1.8.8-3.6-.3-1.3-1.4-1.2-.9-1.7-2.4-1.5-4.5-.6.4-.8.1-.5-.5-1.2-.7-1.8-1.5-2-2.5-.4-.1-.4-.3,0-.5-1.6-1.6,1.2-3,2-.5-1.2-.3-1.6-1.3-1.2-2.8-1.5-.4-1.8-1.4-.3-1.7-.4-.6.4-1.4,1-1,.6-.4,1.4-1.1,2.5-2-.1-.1-.2-.3-.2-.4,0-.3,4.9-1.5,4.2.4,0,.9,0,1.7.5,2.5.6-.9,2-2.4,2.5-1-.4-.7-.9-.6-1.7.2l-.8-.7c-.7-.2-.6-.6,0-1-1.6-.8-2.9-3.1-.2-3.4s-.5,1.5-1.8-1.6c2.9,2.1-.2,2.9-1.5.5-.7.3-.8-.2-.3-1.4-.5,1.2-.4,2,.3,2.4,1-.4,3.4,0,1.8,1.4.6,1.2-.7,1.7-3.8,1.6-1,.1-2.2-.2-3.5-.8-2.5.3-5.3,0-2.5-2.7.6.6,1.3,2.4,1.5,0h.5c-.4,1.9,1.8.9,1,0s-.7,0-1,0l-1-1.5c2.5,1.1,1.4-.9,1.6-1,.2-.2.7,0,1,0,.7-.1.5-1.4.4-1.5s-1.9.5-2.1.5c-1.3.6-1.1,2.7-3.4.2.6-.8,2.6-2.3,3.4-1.7s-.3,1.1.6.9l-.5-3.5c.3,0,.7,0,1,0,.5-.3,1-.6,1.5-1-.6-1.8,2.4-1,3.9-.5l1.6-.5c.1-.4.3-.4.5,0Z"
          fill="#035af1"
        />
        <path
          d="M116.8,166.3c-.4-.4-1.1-.3-1-1,1.3.5,2.2.4,3.5,0l-1,2.5c1,.2,2,.7,3,.5s.3-.2.5-.5c.7-.7,1-.4.5.5-1.6,1.3-.6,2.1-2.8.5-1.4-.3-.2.9-.2,1-1.3.7-1.6-1-1.7-1-.2,0-.6.5-.8.5-.5,1.2-1.8.7-1.5-.5.2-.2.3-.3.5-.5,0-.3.4-.4,1-.5l.5-.5c-.8,0-1-.3-.5-1Z"
          fill="#0366f3"
        />
        <path
          d="M116.8,169.3l-.5,1.5c-.4,0-.7-.5-1-.5-.7-.9-.5-.9,0-1.5.1.6,1,.5,1.5.5Z"
          fill="#0343ed"
        />
        <path
          d="M123.8,171.3c.7-.4,1-.2.5.5.3,0,.6.4,1,1,.3.2.1.4-.5.5-1.3.2-1.8-.6-1.5,1.5-.2.4-.3.4-.5,0,0,0-.1-.5-.2-.5l-.5.5c-.4.6-.2,1.3-.2,2-2.3-1.6.6-3.9,0-4.5s-1.4-.3-1.5.4.1.8,0,1-3.3-.2-2,1.6c-2.9-.6-.9-1.3-.7-1.7s.1-1.1.5-1.3c.7-.6,2.1.1,1.7-2,1.3,1.4,2.5,0,4,1Z"
          fill="#0366f3"
        />
        <path
          d="M117.8,181.8c-.2.3-.5,1.3-1,2s-.9.4-1,1c-.3-.2-1.6.5-1.5-.5,2.2.4,1.1-2,3.5-2.5Z"
          fill="#0362f3"
        />
        <path
          d="M121.8,176.8c1.2.8,1.9.5,2,.5s.7,1.8.5,2-1.7,0-2,.8c1.3-.4,1.3.5,1.5,1.7-.1.4-.3.4-.5,0-1-.6-2.6-.8-2.7.5-.5-1.9-.8-.6-1.2-.5-1.2.4-1.4,0-1.5,0,.2-.2.3-.3.5-.5,1.4-1.2,2.9-.4,3-.5s.6-1.9.5-2-1.3-.2-1.5-.5c-1,0-1-.9,0-1l1.8,1c.3-.4-.3-.9-.3-1.5Z"
          fill="#0362f3"
        />
        <path
          d="M120.3,178.3l-1.5,1c.4-.7,0-1.9.1-2.3s1.5-.5.4-2.7c1.4-.4.8,2.1,1,3s0,.8,0,1Z"
          fill="#0469f5"
        />
        <path
          d="M123.3,168.8c.3.6.6.6,1,0,0-.4.3-.4.5,0,.2.2.3.9.5,1,.3.4,0,.9-.5,1,0,.5-.2.4-.5,0-.4,0-1.5-1-2.5-.5-.4-1.1.8-1.1,1-1.5.1-.4.3-.4.5,0Z"
          fill="#0366f3"
        />
        <path
          d="M117.8,193.3c0,0,1.1.7,1.5-.3s-1.3.1-1-.7c1.6.3,1.5,1.5,3,0,.6.6-2.3,3-3,2.5,1.1,1.1.8,1.8,1,3-.8-1-2.1,0-2.5,0l1-2.5-1.5-.3c1.2-.2,1.4-1.7,1.5-1.8Z"
          fill="#0247eb"
        />
        <path
          d="M125.8,173.8c3.8,0,1.8,1.8,2,2,.7-.5,1.4-.3,2-.5.4.1.4.3,0,.5,1.3,2.8.9,3.8-1,3-1.6,0-2.9-.7-3.5-2.3s2.9-.5,1.5-1.7-2.1,1.2-2.5-.5c.5.1,1.2-.5,1.5-.5Z"
          fill="#036ff6"
        />
        <path d="M125.8,172.8c0,.2,0,.3,0,.5h-1c.1,0,.3-.4.5-.5h.5Z" fill="#0335d7" />
        <path d="M123.3,174.8c2.4,1.6-.2,2.4-.5,0,.2,0,.4,0,.5,0Z" fill="#0479f7" />
        <path
          d="M123.8,181.8c0,.3,0,.7,0,1,1,.5,1,1,0,1.5-1-.6-1.6-1.5-.5-2.5h.5Z"
          fill="#024ae8"
        />
        <path
          d="M119.3,189.3c1.3.3.2,1.4.1,1.3-.1-.1.2-1.1.4.2.5,0,1,0,1.5,0,.2.2.2.3,0,.5-2.2,1-3.1.2-4-2,.3,0,.7,0,1,0l-.7-2.5c1.1,0,1.7,1.6,1.7,2.5Z"
          fill="#0243e7"
        />
        <path d="M122.8,186.3c-.3,1.3-1,.9-1,2,0-.1-1.6-.8-1.5-1.5l2.3-1,.2.5Z" fill="#0244e6" />
        <path
          d="M119.3,189.3l1.5.5v.5s-1,.5-1,.5c-.3,0-.7,0-1,0-.1-.1.5-1,.5-1.5Z"
          fill="#0468f4"
        />
        <path d="M121.8,190.8c-.1.2-.3.4-.5.5v-.5c.1-.2.3-.3.5-.5v.5Z" fill="#0468f4" />
        <path
          d="M123.8,182.8c.5-.1,1.9-.6,2.2-.5.6.2.2.9.3,1-1.2-1.1-.7,2-2.5,1,0-.5,0-1,0-1.5Z"
          fill="#066ef5"
        />
        <path
          d="M131.3,181.3c.2,0,.3,0,.5,0,.6,1.4.1,1.6-1.5.5-.2.4-.3.4-.5,0-.4,0-.8.8-1.5.5,1-2.3,2-1,3-1Z"
          fill="#0379f5"
        />
        <path d="M128.3,179.8c.9.9-1.7,1.8-2,1.5-.9-.9,1.7-1.8,2-1.5Z" fill="#036cf7" />
        <path
          d="M131.3,182.8h-.5c-.1.3-.3.3-.5,0-.2,0-.4,0-.5,0v-1c.2,0,.3,0,.5,0,1.2.1,1.6.4,1,1Z"
          fill="#0240ec"
        />
        <path
          d="M155.8,157.8c1.1,0,1,.7,0,1-.4-.2-.7-.4-1-.5.1-.2.3-.4.5-.5s.3,0,.5,0Z"
          fill="#0163ec"
        />
        <path
          d="M125.3,188.3c-3.1-1.9,1.7-1.6,3.2-2,.6,2-1.2.5-2.2,2-.3,0-.7,0-1,0Z"
          fill="#0356f0"
        />
        <path d="M149.3,136.8c.4,0,1.1-.9,2-.5.2.6-.6.5-1,1-.3,0-.7,0-1,0v-.5Z" fill="#0356da" />
        <path
          d="M146.3,144.8l.9.7c.5,1.9,1.9,3,4.1,3.3,1-.3.8.7.5,1.5-.4.5-.9.8-1.5,1-.4.4-.2,1,.5,1.7-.7.8-.4,2.4.5,1.8.2-.3.3-.3.5,0,.8-1.3,1.6-.9,2,.5l1,1c.2.3.3.6.2.6-.7.7-.8-1.1.3,0s0,.4,0,.8c.4.5.1.7-.5.5-1.4.4-2,.6-2.9,1.8l-1.1-.3c-.1,1.6.4,2.7,1.5,3.3-.2.9-3.2,1.4-3.6.7l-1.4.9c.4.1.4.3,0,.5-2.5.8-2.9,1.7-1.5,2.6.8.8,1.7,1.7.5,2.4.3.2.3.3,0,.5.7,0,.7.4,0,1-.1.5-.3.4-.5,0-.3-.2-.6-.5-1-1l-.8,1.6c-1.1,1.1-3.7-.4-3.6-1.1l-.6-.5c-.1.4-.3.4-.5,0-1-1.4-1-3.2,1-2.5,0-1.3.4-1.6,1-1,.2.2.4.2.5,0-1.9.2-1.7-1.2,0-1.5.3-.4.4-.7,0-1-.8,2.5-1.7,3-2.5,1.5,1.4-1.6,2.9-2.2,3.5-4-1.4-3.5,3.7-1.9,1.5.5-.2,1.5,0,2.2.5,2-.7-2.4,0-3.3,2-2.5,0-.5.5-.6,1.3-.3l.7-.7-.3-.4c-2.6.9-5.5-2.1-2.7-3.6,0-1.1,1.4-1.2,2-.5.2,1.2.7-.8,0-1.5-1.3.3-1.4,0-.5-1-.2-.6-.4-.6-.5,0-1.3,2.7-5,.1-2.5-2,.4-.6,1.1-.7,2.3-.4l.2-.6c.5-1.3,1.1-.8.9.2-.8-1.1-1.7-2.7-2.9-4.7q-.2-.7,0,0c2,2.1,2.1,3.1.5,3-2,.4-3.7-.7-3-3,.2-.4.5-.8,1-1,.4-.8,1-1.5,1.5-.5,0-.8.9-1.9,1.5-1,.4.1.4.3,0,.5Z"
          fill="#037cf7"
        />
        <path
          d="M147.8,155.8c1.3.1,1.3.6,0,1-.7.2-1.3.4-2,.5.3,1.5-.9.5-1,1.5,2.5,2,.9-.9,3.5-.5.1,0-1.6,1.8-1,2.5s1-.5,1.3-.4c1.4,0,.3.9.2,1-.1.4-.3.4-.5,0-.2.2-.6.2-1,0,.4.6.2,1-.5,1,0,.3.8.8.5,1.5l-2.5-1v2c-.7.1-.8-.6-.5-2-.3-.9-.4-1.4-1.3-2-.4.3,0,.7-.2,1.5l-1-.5c-.6-1.4,0-2.7,2-4,.5-1.4,1.1-1.9,2-.5-3.2-.6.3-3.7,2-1.5Z"
          fill="#0370f3"
        />
        <path
          d="M140.3,168.3c-.1.2-.7.2-.9.8s0,1.2,0,1.7c.4.1.4.3,0,.5-.1.3-.3.3-.5,0-1.4-.1-1.3-.5,0-1l-1-.5c-.4-.1-.4-.3,0-.5l.5-.5-1-.7c0-.5.8,0,1-.2,1.5-1,3.4-1.8,2,.5Z"
          fill="#0351e7"
        />
        <path
          d="M141.8,165.8c0,.1-.4.3-.4.7s.3.6.4.8c-.1.4-.3.4-.5,0-.3.3-.7.6-1,1,.2-1.8-.6-.4-2-.5,1.2-.8.8-1.3,1-1.5,1.7.6,1.5-1.2,2.5-1.5.8.3.8.7,0,1Z"
          fill="#0365ed"
        />
        <path
          d="M144.8,146.8c2,1.5,2.1,3.2,5,3,.1,1-1.7.2-2,.5s.7,1.2.5,1.5l-1.5-.5c-.4.7-1.6.6-2.5.5s.8-.4,0,.5c0,.5-.4,1.7,0,2.5l2.5-.5c.1-.4.3-.4.5,0,.1.3.5.8.5,1,.5,0,.4.3,0,.5h-2.5c-.2.6.4,1.1.5,1.5-.8.2-1.2.2-2,.5s-.3.4-.5.5h-.5c-.2-.2-.4-.2-.5,0-.3,0-.7,0-1,0l.5-1c.2,0,.3,0,.5,0,.1-.2.3-.2.5,0,.1-.4.3-.4.5,0,.4-.2.7-.3.9-.7-1.1-2,.2-1.8-1.9-2.8-.4-.6-.2-.9.5-.5.3-.7.2-1.2-.5-1.5-.6,0-.9-.5-.5-1-.4-.1-.4-.3,0-.5.1,0,.3,0,.5,0,.4-.8,1.4-1,3-.5.9-.6,0-2.2-.5-3Z"
          fill="#0584f7"
        />
        <path
          d="M141.8,145.8c.7.2,1,.4.5,1,.5.4.9.5,1.5.5l-1,1,2.5,1.5c-1.5.9-1.7.7-3,.5.3-1.3-1.9-1.8-3-2v-.5c.9,0,1.5.3,2.5,0-1.4-1.7-.7-1.3,0-2.5.4.1.4.3,0,.5Z"
          fill="#036eef"
        />
        <path d="M146.3,167.8c-.2-.2.5-.8.5-.2s-.4.4-.5.2Z" fill="#0267f5" />
        <path
          d="M147.3,165.3c.4.1.4.3,0,.5-.7.3-1.1.7-2,.5-.3,1.1.5,1,1,1.5s1.3,1,1.4,1.1c.1.2-.3,2-.4,2.4-.2,1-.6,1.2-1,.5,0-.3,0-.7,0-1,.2-.2.2-.4,0-.5-.1-.7-.4-1.3-.5-2l-.5,1.5c-1.7-.5-.3-2.3-.5-3.7l2.5-.8Z"
          fill="#0267f5"
        />
        <path d="M144.3,162.8c0,.3.5,1.9.5,2,0,.2-1.1,2.5-2,2l1.5-4Z" fill="#035eef" />
        <path d="M141.8,167.3c0,.3.8.7.5,1.5-.7-.1-.9-.9-1-1.5h.5Z" fill="#0257ee" />
        <path d="M145.8,171.8c-.3,0-.7,0-1,0,0-.2,0-.7,0-1,.8-.6.8-.2,1,1Z" fill="#0447d8" />
        <path d="M141.8,164.8c1.4-.4,1.6,1.3,0,1,0-.3,0-.7,0-1Z" fill="#0644dc" />
        <path d="M146.3,170.8c0-.2,0-.3,0-.5l.5.2-.5.3Z" fill="#0376f7" />
        <path
          d="M148.3,161.3h.5c0,.2.2.7,0,.9-.4.3-1.4,0-1.9,0,0-.2,0-.5,0-.7,0-.3.3-.2.5-.3.4.2.8.2,1,0Z"
          fill="#0695f9"
        />
        <path d="M148.3,161.3l-.3.5-.7-.5c.2,0,.7,0,1,0Z" fill="#037cf7" />
        <path
          d="M147.8,155.3c3,0,1.5.8,2.1,1.4s2.3-.5,1.2,1.6c-.6-.5-1.4-1.3-2-1.5-1.1-.3-.3,1.5-1.7,1-.2-.2.4-.7.5-1s0-.7,0-1,0-.3,0-.5Z"
          fill="#048dfa"
        />
        <path
          d="M146.8,151.3c.3,0,2.4,1.1,2.5,1.5l-5-.5c0-.2-.7-.9-.5-1,1.2,0,1.8-.3,3,0Z"
          fill="#036bf1"
        />
        <path d="M147.3,154.3h-.5l-.5-.2c.4-.8,1.2-.9,1.4,0s-.4.2-.4.3Z" fill="#045ae7" />
        <path d="M143.3,145.8c.1,1.1,0,1.1-1,1-.4-.3-.5-.5-.5-1,.4,0,1.2.1,1.5,0Z" fill="#0482f5" />
        <path
          d="M146.3,144.8c2,.4,1.2.9,1.5,2l.5.5c.6,0,.3-1.4,2.5-1.5-.4.4-1.3.5-1.5,1,.8.5,1.4,1,2,1.5,0,.2,0,.3,0,.5-.3.2-2.5,0-2.7,0-.4-.1-.3-.8-.7-.9-.8-.3-3.4.1-.6-1.3l-1-1.8Z"
          fill="#0482f5"
        />
        <path d="M149.3,153.8c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#0251d9" />
        <path d="M144.8,146.8c-.2-.3-1.1-.4-1-1h2s0,.5,0,.5l-1,.5Z" fill="#0482f5" />
        <path d="M148.3,147.3c-.5,0-.4-.2-.5-.5l.5.5Z" fill="#037cf7" />
        <path
          d="M182.3,127.9c.1,0,.3.3.5.5l.5.5c.3.3.6.3.5,1-.4,0-1,1.3-1.1-.4-.3-.2-.4.4-.4.4-.8-.2-1.6-.5-2.5-.5v-.5c.2,0,.4,0,.5,0-.3-.5.4-.9,1-1,.4-.3.6-.3,1,0Z"
          fill="#0aaaf9"
        />
        <path
          d="M172.8,151.3c-.2,0-.3,0-.5,0-.2.7-.6.4-1,0,0,0-.4-.9-.5-1-.5-.8.3-.7,1-.5.7.4,1,.6,1,1.5Z"
          fill="#0388f7"
        />
        <path
          d="M172.3,151.3v.5c0,.3-.3.4-.5.5-.1.5-.3.4-.5,0-.4-.1-.4-.3,0-.5,0-.2,0-.4,0-.5l.2-.4c.3,0,.6.4.8.4Z"
          fill="#0178f3"
        />
        <path
          d="M166.3,150.8c.6.2,1.4.9,2,1,.4.1.4.3,0,.5-.7.7-.9,1.2-.5,1.5,1.3-.3,1.7.7.5,1.5,0,1.2-.8,1.1-1.5,0-.2.2-.5.2-1,0-.6.3-1.3.1-2-.5-1.4-2.4.3-1.1.4-1.1,1.5-1.3,1-1.6,1.1-2.9.3-.2.7-.3,1,0Z"
          fill="#037af4"
        />
        <path
          d="M165.3,150.3c0-.3.7-.8.5-1h-.8s0-.5,0-.5c.9,0,3.5,1.1,2.7,2-.8-.8-.9-.4-1.5-.5-.2.5-.6.5-1,0Z"
          fill="#037af4"
        />
        <path
          d="M169.8,151.8c.7,0,1.4.3,1,1,.3.3.7.4,1,.5v1c.2.8-.5,1.1-2,1,0,.7-.5.4-1,0,0,.5-.3.4-.5,0l-.5-1.5c-.5-.9.3-1.2,1-.5.3-.2.3-.3,0-.5-.7.6-1,.3-.5-.5v-.5c0,0,1.3,0,1.5,0Z"
          fill="#0386f6"
        />
        <path d="M167.8,147.8c-.4.1-.7.8-1.5.5-1.3-3.3,1.3-.3,1.5-.5Z" fill="#0571ed" />
        <path d="M171.8,149.8l-1,.5c-.3-.5-1.2-.3-1-1,1-.2,1.3,0,2,.5Z" fill="#0178f3" />
        <path d="M171.3,151.8v.5c.5.5.2.8-.5.5-.1-.2-.9-.5-1-1,.3,0,.9-.6,1.5,0Z" fill="#0da5f9" />
        <path d="M165.8,145.3c.2,0,.7,0,1,0,.2.7-.9.8-1,0Z" fill="#0569f4" />
        <path d="M170.3,145.3c-.2,0-.3,0-.5,0l.2-.5.2.5Z" fill="#069df8" />
        <path
          d="M152.8,133.8l-2,.5c0-.5,0-1,0-1.5.3,0,1.4.9,1.5-.3s-.9-1.5-.2-1.7c1.7,1,.7,1.8.8,3Z"
          fill="#0265ee"
        />
        <path d="M148.3,134.8h.5c0,.6-.3,1.4-1,1.5.2-.6-.6-1.3-.5-1.5s.7,0,1,0Z" fill="#0d8ef3" />
        <path
          d="M150.3,129.8c.1.2.8.3,1,.9s-.4,1.6-.5,2.1c-.7-.1-1.3-.4-2-.5.2-.3.3-.8.5-1s.6-.2.7-.5-.2-.5-.2-.5c0-.2.2-.6.5-.5Z"
          fill="#036aef"
        />
        <path d="M150.3,129.4c0-.1-.5-.2-.5-.5l.5.5Z" fill="#036aef" />
        <path
          d="M155.8,151.3c.5,0,1.8.7,2,.5.8-.7-1.7-1.4-1.8-2.8s1-1.7,1.6-1.7.6,1.3,3.2,1.5c1.5.7.6,2.5-.6,3.3,1.4,2,.2,3-1.9,1.8l-.6.4c-1.9,1-3.5-1.6-2-3Z"
          fill="#0378f4"
        />
        <path d="M160.3,150.3c-.5-.1-1.7.8-2,.5-.6-.6,1.4-2.6,2-.5Z" fill="#038af7" />
        <path d="M157,149.3c.3.2.3.3,0,.5v-.5Z" fill="#038af7" />
        <path d="M181.3,102.4c-.2-2,2.3,0,2.2.8-.1,1.3-2.7.9-2.2-.8Z" fill="#0380f4" />
        <path d="M181.3,102.4c-.1.4-.3.4-.5,0-.2-1.1.2-1.1.5,0Z" fill="#0380f4" />
        <path
          d="M175.3,100.4c1.7-.6,3.1,0,2,1.5,1.2.4,2.2.3,3-.1l.5.6c1.3,1,1.5,1.7.5,2-2,.6-4.1.8-6,1,.5.4.1.9-.5,1h-.5c-.5-.4-.8-.4-1,0l-.4.6c-1.4-.4-2.2-.2-2.6.4.4.1.4.3,0,.5,1.1.7.3,2.5-.7,3.3.7,1.6-.7,2.8-.2.8s2.5-2.1,2.9-.6c.7,1.2-.4,1-.2.7s1.7,0,.7.8c.9.1.9,1.2,0,1.5.2,1-.3,1.9-1.5,2.7,1.6,1.8-.8,4.1-.3,2.6l.3.6.5-.5c.2-.4.3-.4.5,0,.4,0,.6,1.4.5,1.5s-3.5.2-4,0c-.6-.2-1,0-1.5.5.4.1.4.3,0,.5-1.7.8,1.1,1.4,2.5-.5.3-.3.9-.5,1.7-.5,2.1-1.6,1.1,1.9.5,1.7s1.1-1.8,1.3-.2c1,.2.7.4,0,1-.5,1.5-1.2,2-2,1.5-.1.4-.3.4-.5,0-.9,0-.7.3-.4,1.1h-1.1c0,0-1-.6-1-.6-2.2,1.3-3.4,1.3-3-1.3l-1-.2c-.1.4-.3.4-.5,0-2,0-2.4-1.2-1.5-3-.1.4-.3.4-.5,0-.6-.5-1.3-1.6-.2-1.7v-2.3c.7-.3,1-.8.7-1.5-2.8.4-3.1,1.4-1,3,.7,1.3.3,2.1-1,1.1-.5.6-1,.7-1.5.4q-.8-.4,0,0c.4.1.4.3,0,.5-1.6.5-.8.8-1,1-1,.7-1-1.2-2-1.5-.8,0-1.4-1.6-.5-2,1,0,2.4.6,3.5.5,0-.6-1.8-1.4-1.9-1.6,0-.4.4-1,.3-1.6s-.8-1-.9-1.4c-.4,0-.3-.7,0-1,.4,0,.9-.3,1.5,0,.2-.1-.5-.8-.5-1,.5,0,1,0,1.5,0,.2-.6.5-1.1,1-1.5.8.2,1.5.6,2,1,.3,0,.9.6,1.5,0,.2-.3.5,0,.9.7,3.7-.9,1.8,3.6-.4,4.3,0,.3.2.5.5.5.6-.2,1.2-.2,2,0q2.9-1.1,0,0c-2.9,1.3-1.5-2.4.7-3.1.1-.2-1-1.3-1.2-1.4-1.9.3-2.6-1-2.5-2.5,0,0-1-.9-1-1,0-.7.5-1,1.6-.9v-.6c0,0,0-.5,0-.5v-1c.4-.4.7-.6,1,0q1.1-.3,0,0c-.4-.2-.7-.2-1,0-.1.4-.3.4-.5,0-.4,0-.5-.2-.5-.5,0-.3,0-.8,0-1,.6-1.5.3-.9.5-2,1.2.4,1.2,1,1.3,1,.6,0,1.1-.5,1.5-.5s.4,2,1.2,1-1.2-2.4-1-2.5c1.2.1,2.4-.5,3,.5.6.7,1.3.3,2.1-.1.6-.8,2.9-2.2,3.9-1.9Z"
          fill="#0380f4"
        />
        <path
          d="M161.8,121.4c.6.3,0,.9-.5,1-.5.2-1.3,0-1.5-.5.8-.8.8-1.1,0-1-.3,0-.8,0-1,0v-.5c1.4-.1.7-1.7,2.5-.5,0-.3,0-.7,0-1-.8-.4-.9-.8,0-1-.6-.2-1-.5-.5-1,0-.5.5-.8,1.5-1,1.9.8.2,1.2-.3,2.5s0,2.2-.2,3Z"
          fill="#048af6"
        />
        <path d="M156.3,114.4h-.5c0-.2,0-.7,0-1,.2,0,.3,0,.5,0,0,.3,0,.8,0,1Z" fill="#0155e7" />
        <path d="M163.8,107.9c.6,0,2.5-.2,2,1l-3.5.5c-.5-1.7.2-1.5,1.5-1.5Z" fill="#068cf8" />
        <path
          d="M160.3,109.9c.5.5,1,1.4,1.5,2-.8,0-.3,1.3-2-1,.1,0-.7-.8-.5-1,.3,0,.8,0,1,0Z"
          fill="#068df6"
        />
        <path
          d="M163.3,110.4c.2,0,.9-.7,1-.5-1.3,4.4,1.5,2.6,1-.5l1.5,1.5,1-1.5v3c-.2.2-2.1-2.2-2-.3,2.1.9,2,1.1,2.5,3.3-1.4-.4-4.7,2-2,2-.7.5-.8.9-1.2,1.5-.3,0-.5-1-.7-1.5-.7.7-1,.4-.5-.5.6-1.3,1.1-2.4,2-3.5-1.6.2-1.8-.8-2.5-1.5s-1.8-.4,0-1.5Z"
          fill="#068df6"
        />
        <path d="M159.8,110.9l.5,1.5c-.5,0-1,0-1.5,0-.4-2.2.7-1.3,1-1.5Z" fill="#025ee9" />
        <path d="M163.8,107.4c-.4-.2-.4-.7-.5-1,.2,0,.3,0,.5,0,0,0,.5.7,0,1Z" fill="#068cf8" />
        <path d="M163.3,106.4c-.3,0-.7,0-1,0-.1-.5.5-.5.5-.5.2.1.4.3.5.5Z" fill="#0663e8" />
        <path
          d="M171.3,108.4c1.4.6,3.3,1.7,2.5,3.5-.5.9-1.7.3-1.5-.5,0,0-.3-.8-1-.4s-2.2,3.1-1,3.9c-2.5-.1-1.1-1.8-1-2.8s-1.3,0-1-1c.3-.4,1.7-1.5,1.5-1.8s-2.1,0-2-1c3,1.2,2,0,2.5-.5.3-.7,1.2-.4,1,.5Z"
          fill="#0594f8"
        />
        <path
          d="M173.8,119.9c.4.1.4.3,0,.5-2.8.3,0,1.6,0,1.8,0,.4-.5.6-.5.7-1-.6-1.1,1.9-2,1s1.3-1.7,1-2.5c-.9.6-1.6.4-2.5.5-.3,1.4-1.7,1.8-2.5.5v-.5c0-1.4.5-1.6,1.5-.5,1.3-.3,3.8.2,3.5-1.5.8-.2,1.4,0,1.5,0Z"
          fill="#038cf6"
        />
        <path
          d="M169.8,121.9l-.3,1.9,1.3.5c-2.5-.6-4.1.9-5-2,.5,0,1.1,0,1.5,0,.9-.2,1.6-.4,2.5-.5Z"
          fill="#0394fa"
        />
        <path
          d="M170.3,107.4c-.3.2-.8.6-1,.5s0-.5-.2-.8-1.9-1,0-1.7.5,1.3,1,1.5c.5,0,.1-.7.3-.9s.9.4,1.2.4c-.5-2.4.9-.2,1.8,0,.3-.9.7-.9,1,0,.2,0,.3,0,.5,0,0,1.4-1.5,3.8-3,2l-1.5-1Z"
          fill="#0594f8"
        />
        <path
          d="M161.3,118.9c-2.8-.8-2.9-2.3-.7-4,.4,1.5,1.2.8,1.7,1-.2,1-1.2.8-1.5,1l.5,1c0,0,0,.7,0,1Z"
          fill="#026ff0"
        />
        <path
          d="M167.3,121.9c.3-.9-1.1-3.4-1-3.5.9-1,1,1.1,1.2,1l2.3-1.5c-.4,1.5-2.4,1.1-2,2.5l1,1c-.5.1-1,.2-1.5.5Z"
          fill="#0394fa"
        />
        <path
          d="M173.8,111.9v1c-.2,0-.7,0-1,0s0-.6-.5-.5v1.5s-.5,0-.5,0c-.3-1-.6-1.8.5-2.5.5.2.9.5,1.5.5Z"
          fill="#0172ec"
        />
        <path d="M163.3,112.9v1.5s-3,0-3,0c.6-1.1,1.7-1.8,3-1.5Z" fill="#068df6" />
        <path d="M173.3,106.4c-.5-1.7-.8-2.2,1.2-2.5l-.2,2.5c-.3,0-.7,0-1,0Z" fill="#026dee" />
        <path d="M166.3,117.4c.5-.4,2.5-1.9,3-1.5,1.3,1.1-2.5,1.5-3,1.5Z" fill="#0592f5" />
        <path d="M164.3,117.4c.2.6-1.4,2.2-1.5,2-.3-1.1.6-1.7,1-2.5.2.2.4.3.5.5Z" fill="#048af6" />
        <path
          d="M171.8,108.4c-.2.4-.3.4-.5,0-.2,0-.9-.7-1-.5v-.5c1.1-.6,1.2-.6,1.5,1Z"
          fill="#0270ef"
        />
        <path d="M166.3,119.4l-1.5,1.5c-.2-1.6-.1-1.7,1.5-1.5Z" fill="#0698fb" />
        <path d="M164.8,106.4l.7-1c1.8,2.4.3,1.2-.7,1Z" fill="#0f93f4" />
        <path d="M162.3,121.4c.3,1.6-.8.8-1,1,0,0,.5-.9.5-1h.5Z" fill="#0367ed" />
        <path d="M158.8,120.4h-2s0-.5,0-.5c.8,0,1.9-.3,2,.5Z" fill="#0164f3" />
        <path d="M167.3,108.4c-.6.6-1.6-.2-.2-1,.4,0,.3,1,.2,1Z" fill="#068cf8" />
        <path d="M164.8,106.4c-.3,0-.7,0-1,0,.2-.4.4-.7.8-1l.2,1Z" fill="#0663e8" />
        <path d="M161.3,117.9c0,0-2.1.1-.5-1l.5,1Z" fill="#0380f4" />
        <path
          d="M171.3,125.4c.7-.4,1.3-1.1,2-1.5-.1.4,0,.9-.3,1.5-1,2-1.4.2-1.7,0Z"
          fill="#069af7"
        />
        <path d="M164.8,135.8c0-.3,0-.7,0-1,.3,0,.7-.4,1-.5,0,.9,1.7,1.7-1,1.5Z" fill="#049bfa" />
        <path
          d="M165.8,132.3c.2-.3,1.6-1.4,1.7-1.4,2.6,1.5-.6,4-.4,3.6s.6-.2.6.3c1.9-.3,0,4.6-.9,2.7-1.2,1-2.1,0-2.6-1.2-.7-.9-.4-1.2.5-.5l1-1.5c-.7-.7-1.4-1.7,0-2Z"
          fill="#038af7"
        />
        <path
          d="M154.8,126.4c.9,1.2-.5,1-.5,2.5,1.8-.6,2.5-1.8,3-3.5l-1.5-.3c.6-.3.8-1.5,1.1-1.6,1.1-.7,2.3,1,1.9-2.1,1.1.1,0,2.1,1,2.8s1.8.2,2.5.2l-2-.5c0,0,.8-1.3,1-1.5.4-.3.8-.6,1-1,.4,1.7.3,1.6,1.5,3,.6.7.8.7.5,0,1.7,1-.1-3,1.5-1.5s0,2.3,0,3c1.3-.1,2-1.4,3.5-1-.2.7-.2.8,0,1.5.7,0,1.5.8,2,1.5,1-.2,1.5,0,1.5.5,1,.3,2.3.9,1,1.5q-.7.8,0,0c0-.5.4-.8,1-1,0-1.2,1.8-1.4,1.5,0,.4.1.4.3,0,.5-.2,1.3-1.6,3.8-3,3-.5.6-.5.7-.5,1.5-.2,1.6-.6,2.4-2.1,3-.1,2.8-2.5,3.5-3.3.6,1.2-.2,1-1.7.4-2.6,1.1-2.8.4-3.8-2-3l-1.8.6c-.8,0-1.9-2.2-1.7-2.5,2.4-.9-1.6-2.7-1-.2,2.5.5,2.5,3.8,2,5.5.3.4.4.6,0,1-.2.4-.3.6,0,1,2.8-1.1,3.9,1.9.4,2.2,1.1.1,1.9,2.5,1.7,3-.9,1.9-2.2-.4,1.4-.6l1-.6c.3-.8.7-.7,1,0,.5-.2,1.1-.4,1.5,0,.3-.4.3-.7,0-1-.2.7-.4,1-1,.5-1.1.2-1.9,0-2.5-.5-.4.1-.9.2-1,0-.9-2.4.7-4.3,2.1-1.5s2.7-.2,2.8-1.9c1.8-2.9,4.7-.7,2.1,1.5.3,1.3,0,2.2-1,2.6v.5c.4.1.4.3,0,.5-.3,1.7-3.9,2.3-5,1.5-.5.7-1,1.1-1.5,1-.2,1.4-.6,1.3-1,0l-1,1c-.2,1.4-1.4.8-1.9-.2l-.6.2c-.1.3-.3.3-.5,0q-1.1-1.4,0,0c1.5.8,1.9,1.8.5,3,.4.1.4.3,0,.5l-.7.9c-3.6-1.7-4.1-1.3-1.4,1.2-.6,2.1-1.7,2.4-2.9.4-.5-.1-.9-.7-1.4-1.6-2-.2-2.4-.9-.7-2.1.5,1.1,1,.3.6-.8-.2.4-.3.4-.5,0-.5-.3-.6.7,0,1.3l-.9.5c1.1,1,0,1.4-1.2,1.7,0-.5-.4-1.1-.5-1.5-.5-.1-.4-.3,0-.5-.9-.2-.9-.6,0-1,1-.1.7-.3-1-.5,0,.9-.7.8-1,0,0-.5.5-.8,1.5-1h.5c.7,0,1.6,1,2-.5-.3-.3-.7-.6-1-1,0-.2,0-.5,0-.7,0-.3-.3-.2-.5-.3-.5.8-1.3.8-2.5,0-.2-.2-1.3-.7-1-1,1.3-.5,2.2-.2,3.5,0l-1-.5c0-.3.5-.4.5-.5.4-2.5,3.8-1.1,4,1h.5c.9,1.3,1.6,1.4,2,.5,0-.5.4-.8,1-1-1-1.4-2.1-2.7-3.4-3.9l.4-1.1c-.6-.6-1.6-.6-3,0-1-.3-1-.7,0-1,.4-1.5,1.5-2,3.5-1.5.2-.4.3-.4.5,0q.9.9,0,0c-.6-1.6-1.6-3.1-3-4.5-1.3.2-1.4,0-.5-1-1,0-1.2-.2-.5-1-3.3.2-.9-1.7,1.5-1-.3-.6,0-.8.5-.5Z"
          fill="#038af7"
        />
        <path d="M164.3,124.4l1,.5v.5c-2.1.4-1.3-.8-1.5-1h.5Z" fill="#12abf9" />
        <path
          d="M152.3,144.3c1.9-.8,2.2-.7,2.5,1.5-1.3.6-.9-1.1-1.2-1s-.2.5-.3.5c-1.4.2-.8-.2-1-1Z"
          fill="#046eed"
        />
        <path d="M151.8,143.3c0,2.2-1.5.9-2.5,0l.2-.5c.7,1.3,1.7.4,2.3.5Z" fill="#0465ec" />
        <path
          d="M152.8,136.8c1.3-.6,2.3-.6,3,0,.4.6,1.2,1,1.3,2l.7-2c.7,1,0,2.1,0,2.7s.7.2,1,2.3c-1.1.1-1.9-.2-2.5-1-2.9.2-1.1,0-2.6-1.4s-1-.3-1.5-.6c-.8-.5.2-1.5-2.4-.5,0,0,.4-.8.5-1,.9,0,1.7-.4,2.5-.5Z"
          fill="#0484f5"
        />
        <path
          d="M161.3,129.8c0-.1-1-.5-1-.7,0-.6,3.7-1.3,4.2-2.2.9.4.2,1.4.2,1.5.5.3,2.1-.5,2,.5-2.9-1.4-4.6,1-2.7,3s.2-2,1.7,0c0,.2,0,.3,0,.5,0,.6,0,1.4,0,2,.4.9-.4,1.3-1,.5q-.8-.9,0,0c1,.3,1,.7,0,1-.2,0-.6.2-.5.5-.3-.2-.6-.7-1-1-.1-1.7-1.7-2.8-.5-4.5-2.5,1-1.1,0-1.5-1q1.1-.8,0,0Z"
          fill="#027cf3"
        />
        <path
          d="M153.8,129.8c.5.4,2.9.9,3,1s-.9,1,.3,2,.5-2.1,1.2-.2-1,.6-1.4.9,0,.9-.1.9c-.1,0-.4,0-.5,0-.5-.4.2-1.4-.3-1.5-2.2-.3-.5.9-.7,1-1.4.5-2.8-2.7,0-1.7l-2.5-2,1-.2Z"
          fill="#0273f1"
        />
        <path
          d="M162.3,127.3c-.1.1-1.2-.1-1.6,0s0,2.3-2.4-.2c1.7-3.8,5.1-.8,4,.2Z"
          fill="#0373f3"
        />
        <path
          d="M153.8,146.8c.2.4.3.4.5,0,.3.3,1.1,1.4,1,1.5l-2.5.5c2.9,0,2.3.8,3,2.5,0,1.1-.5,1.4-1.5,1-.8-.3-.8-.7,0-1l-.4-.5c-.6,1.5-3.2,2.6-3.6.5,0,0-.1-.7.1-.9.4-.4,1.1,0,1.4-.1.5-.2,1.4-3.2,1.5-4,.5,0,.5.5.5.5Z"
          fill="#0482f5"
        />
        <path
          d="M157.8,142.8s.4.6.2,1c-.3.7-1.3.9-1.2,1.7l1,.7-2,.5v-4.5c1-1,1.9-1.1,2,.5Z"
          fill="#0374f1"
        />
        <path
          d="M156.3,140.8c1.1,0,1.5-.7,2.5,1,0,.3.7.9.5,1s-1.2-.1-1.5,0c-.6-.4-1.3-.5-2-.5s-.3,0-.5,0l1.5-1.3-.5-.2Z"
          fill="#0697f8"
        />
        <path
          d="M170.8,125.4c.3.7.7,1.1,1.3,1.2.8-.9,1.1-.4.7.8,0,.6-.6.7-1.5.5-1.3-.5-1.4.5-2-1.5l1-1.5c.5,0,.5.5.5.5Z"
          fill="#069af7"
        />
        <path
          d="M161.8,137.3c0,.5-2.6.4-2.8.4-.4,0-.7-1.2-.7-1.6.8-.9,1.3.8,2.2.8s0-2.2,1.3,0c.2.1.2.3,0,.5Z"
          fill="#0278f5"
        />
        <path d="M161.8,134.8l-3.5.5c0-1.2,3.3-1.6,3.4-1.4.2.2,0,.7,0,.9Z" fill="#0278f1" />
        <path
          d="M162.3,146.8c.7.8.5,1.6-.5,1,.3.7-.4.7-1,.5,0-.5.3-1.6.3-1.7,0-.4-.7-.9-.8-1.2.1,0,.4,0,.5,0,1,.6,1,1,1.5,1.5Z"
          fill="#0378f4"
        />
        <path d="M152.8,136.8c.8-.4,1.2-1,2.3-1s.6.8.7,1c-.9.2-2.3,0-3,0Z" fill="#036cef" />
        <path d="M160.3,145.3c-.7-.4-1.6,0-1.5-2,1.7-.2,1.2,1.3,1.5,2Z" fill="#0172f2" />
        <path d="M160.3,130.4c.3.4-.1,2-1,2-.8-1.1.3-2.7,1-2Z" fill="#026bee" />
        <path
          d="M174.8,128.9c.4,1.5-.8.8-1,1s.7,1.4-1.5,1c0-.9,1.4-.9,1.5-1,.5-.5-.8-1.3-1-1.5.2-.4.3-.4.5,0,.6.1,1.4.5,1.5.5Z"
          fill="#049bfa"
        />
        <path
          d="M150.3,146.8c.5,0,.9.2,1,.5,0,.3,0,.7,0,1-1-.3-2.5-.3-2-1.5.3,0,.7,0,1,0Z"
          fill="#046cec"
        />
        <path d="M150.3,146.8c.9-.1,1.5-.4,2.5,0-.5,1.4-.9.6-1.5.5s-.8,0-1-.5Z" fill="#0482f5" />
        <path d="M164.3,144.3c-.3.2-.7.9-1,1l-1-1.5c.8-.4,1.7.5,2,.5Z" fill="#0375f2" />
        <rect
          fill="#0367ea"
          height="1"
          transform="translate(21.8 292) rotate(-89.9)"
          width="1.5"
          x="156.5"
          y="134.6"
        />
        <path
          d="M166.8,143.3c-.2.3-.3.7-.5,1s-.6.3-.5,1c-.5-.3-.6-.4-.5-1,0,0,.6-.6,1.5-1Z"
          fill="#036ef3"
        />
        <path
          d="M170.3,141.3c-1,.7-1.4,0-1.5,0,.2-.1.3-.4.5-.5.3-.2.7-.5,1-.5.4.3.3.6,0,1Z"
          fill="#03a0f9"
        />
        <path d="M172.8,127.4c.5.1.4.7,0,1-.8-.2-.9-.3-1.5-.5l1.5-.5Z" fill="#0174e8" />
        <path d="M161.8,137.3c0-.2,0-.3,0-.5,0-.6,0-1.4,0-2,.2.7,1.2,1.8,0,2.5Z" fill="#049bfa" />
        <path d="M158.8,129.9c.2.2-.9,1.3-1.5,1-.2-.2.9-1.3,1.5-1Z" fill="#026bee" />
        <path d="M156.8,129.4c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#026df0" />
        <path d="M154.3,146.8c.2,1.4-.7,1.4-.5,0,.1,0,.4,0,.5,0Z" fill="#0248dc" />
        <path d="M170.3,141.3v-1c1.1.4.5.6,0,1Z" fill="#049bfa" />
        <path d="M163.5,125.9c.3.2.3.3,0,.5v-.5Z" fill="#0373f3" />
        <path d="M161.3,129.8v-1c.9-.1,1.5,0,2,.7l-2,.2Z" fill="#0594f8" />
        <path d="M164.8,134.8c-.3,0-.7,0-1,0,0-1.2-.3-1.7,1-1.5,0,.5,0,1,0,1.5Z" fill="#038af7" />
        <path d="M170.8,143.3c0,0,.1.7,0,.9-.4.4-.9-.4-.9-.4l1-.5Z" fill="#0274f0" />
        <path d="M174.3,126.9s-.5,0-.5,0l.2-.5.2.5Z" fill="#049bfa" />
        <path d="M148.3,129.8c.2.2-.5.8-.5.2s.4-.4.5-.2Z" fill="#036aef" />
        <path d="M148.8,129.4c0,0,0,.6-.5.5l-.5-1.5c.5,0,.8.6,1,1Z" fill="#036aef" />
        <path
          d="M137.8,199.3c.8-.7,1.8-1.1,1.1-1.7,1.9-1.2.9,1.2,2.4,1.7-.8-.2-1,.2-1.5.5.5.6-.4.9-1,.5l.5-1.5c-.5.2-.9.4-1.5.5Z"
          fill="#0371f6"
        />
        <path
          d="M136.8,200.3c1.6.2,2.2,1.2.5,2l-.2-1.5-2.3.5c-.2-.4.9-1,1-1,.3-.6.7-.6,1,0Z"
          fill="#024bec"
        />
        <path
          d="M137.8,199.3c-.3.3-.7.7-1,1-.3,0-.8,0-1,0l-.5-.5c1.1-.3,1.5-.3,2.5-.5Z"
          fill="#0c81f6"
        />
        <path d="M139.8,199.8c3.8-.2-1,1.8-1,.5.5,0,.7-.3,1-.5Z" fill="#035af1" />
        <path
          d="M141.8,200.3c2,.2.2,2,.7,1.2l.3.8c0,0,.8,0,.5,1-3.2-1.1-1.3,0-1.9.8s-2.4.6-2.8,2.2.7,1.4.7,2c.9-.2.5.7.1,1.3s-.2.4.4.2c0,.6,1,1.6,1,2.2s-1.7,0-.5,1.3h.5c1.1-.9.2-2.2,1.3-3l1,2c1.2-3.1,1.6,2.3,2.7-.5.5-.1.6,0,.5.5-.7,1.4-.5,2.5-.5,4-.8,2.5-1.6,3.3-2.5,2.5-.9.2-1.3-.3-1.1-1.7l-.9-.8c-.6-2.1-.2-.4-1.7-.5s-.4-1-.8-1.2c-.8-.5-1.9-.7-3-1.3-.5.9-.7,1-1,0-.1,0-2-1.6-2-1.7,0-.8,3-2.8,4-3.3.6.5.2,1.1-.5,1,0,.9,0,1.2.5,1,.3-1.1.3-2,0-2.5-.5-.3-1-.4-1.5-.5-.5,0-1,.2-1.5.5-.4-1,0-1.4,0-1.5-.6-.6-1.4,1.2-2,.8.3-.5.3-1.1.5-1.8-1.8.3-2.7.5-4.5,0,0-2-.5-1-1-2,.9-.7,2.3,0,2.5,0,0-1,.3-1.3,1-.5.8.2,1,.9,0,1-.2.4-.2.7,0,1,.3-2,2.9-1.6,2,.5-.6-1.3-.4-1.8.5-1.5.4-1.2.9-1.1,1.9-.6.3,1.4,1.5,1.7,2.1.6-1.1-.2-1.2-.6-.5-1,0-.7.5-.8,1.7-.3,1.1-.9,2.4-1.6,3.8-2.2Z"
          fill="#035af1"
        />
        <path
          d="M145.8,216.3c0,.1.5.4.5.5s0,.4,0,.5c.3.7.1,1.2-.5,1.5,0,0-1.1.2-1.3,1-.6,0-1-.5-1.2-.5-.4-.1-.4-.3,0-.5,1.8.3.6-.7.5-2l2-.5Z"
          fill="#0345eb"
        />
        <path d="M140.3,213.3h.5c-.7.6-1,.6-2,.5v-.5s1.5,0,1.5,0Z" fill="#023cec" />
        <path d="M133.8,207.8c0-1.2,2.4-2.8,1.5-.5s0,1.1-.8,1.5c0,0-.7-.9-.7-1Z" fill="#0669f4" />
        <path
          d="M136.8,210.3c-.7.5-.9.2-.5-1,.1-.3.6-.5.5-1v-.5c.3.2.8.3.9.7-.3.6-.7,1.1-.9,1.8Z"
          fill="#0234de"
        />
        <path
          d="M138.8,200.3c1.1,0,2.6,0,1-.5-.5-1.8.2-1.4,1.5-.5.1-.4.3-.4.5,0,0,.3,0,.7,0,1-1.1.7-.6,2.9-1.1,3.4s-.9.2-1.3.4-1.2,1.2-1.3,1.2c-.2,0-1.1-.6-.3-1.2,1.5-1.1,3.1.2,2-2.2-2.2,1.8-1.5,1-3.5,1-.3.4-.7.7-1,1,.4.3.6.2,1,0,.1-.4.3-.4.5,0,0,.3,0,.7,0,1-1.6.4-2.5-1.1-4-1-.6-1.3.3-2.8,1.5-3.5.2-.4.6-.6,1-.5.5,0,.7,0,.5.5-1.5.9.3.7,1.3.3s-.1-.1-.3-.3c0-.5.3-.8,1-1,2.1-1.6,2.8-.7,1,1Z"
          fill="#046af5"
        />
        <path
          d="M134.3,200.3c-1,1-1.1,2.2-1.5,3.5s-.3.9-.5,1.5c.3-2-1.3-.5-2-.5-1-.3-1.1-.7,0-1v-1c1.1-.3.5.2,1.3.5,1.2.5.4-.7.6-1.4s1.4-1.4,1.7-1.6h.5Z"
          fill="#0249ec"
        />
        <path
          d="M136.8,210.3c-.3.8-.7,1.6-.5,2.5-.9-.4-.5-1.4-2-1,.9-.9,1.4-1.3,2-2.5l.5,1Z"
          fill="#0349f1"
        />
        <path d="M138.3,211.8c.2.2.3,1.9-.7,1.5-1.5-.6.3-2,.7-1.5Z" fill="#0349f1" />
        <path d="M136.3,202.8c.1.3.5.7.5,1h-.5c-.3.2-.7.3-1,0-.7-.7,0-1,1-1Z" fill="#033fe1" />
        <path d="M130.3,203.8v1c-.4,0-2-.4-2-.7l2-.2Z" fill="#0c6df5" />
        <path d="M136.3,203.8c-.7.8-.6.4-1,0h1Z" fill="#035af1" />
        <path
          d="M131.8,189.3c-.2-2.2,1.3.4,2.3.3s2-2.4,1.5.7c.7.2,2.3-2,2.7-1.5s-1.2,1.8-1,2c.9.2,1.3-.7,2-1s.7,0,1,0c.1-.4.3-.4.5,0,0,.3,0,.7,0,1-.9,0-2.2-.1-2.5,1,.8,0,1.7,0,2.5,0-.5,2.3-.9,1.4-2,1.5-.2.3-.4.1-.5-.5-.7-.8,0,1.4-.3,1.5-1.7,0-.7-1.4-.7-1.5-.4-.3-.8-.3-1,0-.2,0-.8.7-1,.5s0-.7,0-1c.2-.3.2-.6,0-1-.5-.4-2.6-1.4-3.5-2Z"
          fill="#0572f3"
        />
        <path d="M143.3,193.8l-.5,1h-1.5c-.4-.4.4-1.2,1-1.5.7,0,.9.5,1,.5Z" fill="#0371f6" />
        <path d="M142.3,193.3l-1,1.5h-.5c.3-.7.1-1.4,1.5-1.5Z" fill="#0581fb" />
        <path d="M134.8,191.8c0,1.6-.3.6-1.5.5v-.5c.5,0,1,0,1.5,0Z" fill="#0572f3" />
        <path d="M137.3,192.8s-.8,0-1,0l.3-.5.7.5Z" fill="#014bec" />
        <path d="M135.3,192.3c0-.3,0-.6-.5-.5,0,0,.3-.4.5-.5.4.4,1.1.6,0,1Z" fill="#033edb" />
        <path d="M138.8,193.3s-.1.6-.5.5c0-.3,0-.9,0-1l.5.5Z" fill="#0446e9" />
        <path d="M135.3,193.8c1.4-.2,1.4.7,0,.5v-.5Z" fill="#1191f7" />
        <path d="M132.3,196.8l-.5-.5c.3,0,.4.5.5.5Z" fill="#0368f6" />
        <path d="M335.7,144.8c.8-.1,1.4-1.1,2,.5l-2,1c0-.5.1-1.1,0-1.5Z" fill="#04a7fb" />
        <path
          d="M337.2,147.8c0,.4-.1.5-.5.5s-.5,0-.5,0c0-.1,0-.7,0-1,.9-.3.8.4,1,.5Z"
          fill="#04a7fb"
        />
        <path
          d="M334.2,155.8c0,.1,0,.4,0,.5-.8-.3-1.7-.3-2.5-.5.2-.3,1.9-1.6,2-1.5-.1.6.2,1,.5,1.5Z"
          fill="#04a7fb"
        />
        <path
          d="M326.7,133.3c-.3,1.4.7,1.9,2.1,1.8-.4.9-.2,1.4.8,1.5-.5.6-.3,1.2.6,1.7,0,.7.6,1.3.5,2-4.5-2.5-2.5,1.2,1,.5,0,0-.8,1.2-1,1.5-.2.8-.6,2-1.5,1.5-1,.2-.7.8,0,1.5.4-1.2,1.1-2.2,2-3l1.5-.5c-.1.5-.5.9-.5,1.5.8.3,1.7.3,2.7,0l.3.9c0,.1.4.3.5.5-.5,0-1.5-.3-1.5.3,0,1.8,1.3,2.3,2,3.2s-.4,1.4,1,1c-.3,1.4-1.6,1-1.7-.5s-.9,0-1.7-.6.4-2.3-2.6-1.9c-.6,2.2,2,1.7,3,2.5s-2.9,0-1,2c-.8.6-1.6.2-2.3-1.2-2.6,0-3.6-1.8-.7-2.3-.3-.6-.6-.4-1,0l-.7,1.1c-1.2,0-1.6.7-1,2.2-2.3.9,2.5,4,2.2,1.7-.4-.1-.4-.3,0-.5-.2-1.4,1.1-1.5,4-.5.4.5,0,1.6.8,2l.5-2,1.2,2c-1.9,1.7-1.9.1-3.3,0s-.2.8-.3.8c-.7.2-2.5.1-3.4.7.3,1.3,1.7.8,2.5,1-.4.6-.6,1.3-.5,2,1.5-1.2,3-1.6,1,.2l3,1.7v.5c.4.6.2.8-.5.5-1.3.8-2.3.3-3.1-1.5h-1.4c-.1.4-.3.4-.5,0l-1-.5c-.9,1.7-1.3-.1-1.5-1.5-.6,1.4-1.8.8-2-.5.1-.9,0-2.2-1-2-1.3.9-1.8-1-1-2,1.5-1.2,1.7-2.3.6-3.3l.9-.7c0-.4-.1-.8-.5-1,0,.5-.2,1-.8,1.1,2.3,1.7,1.1,2.7-.7,3.9.4,1,.6,1.7-.5,2-.8.5-1.3-.3-1.5-1-.5,0-.6-.6-.5-1.5-.8.3-1.9,0-2.5-.5-1.5-.8-1.2-1.6,1-2.4.5-1.5,1.3-2.4,2.5-2.6-.5-.6.7-.9.7-.9,0,1.3-1.5-.5-1.7-1.1-.1,1-1.3.9-1.5,0-.3-.4-.3-1,0-1.5h-.5c.7.6.4,1.5-.5,1,0,.9-.2,1.1-1,.5-.4.6-.9,1.1-1.5,1.5.4.6.1.9-.5.5-.8-.1-1.2-1.5-.5-2,0-1.4.7-2.8,2.3-4.2l-.8-.3c0-1.4-1.1-2.2-3.1-2.4l-.4-.6c-.1,0,0-1.2-1.5-1.5-1.4-2.4,1.9-2.1,3-.5.6,0,1.3,0,2,0,.3.2.3.5,0,1,.4.4.2.6-.5.5.2.3.5.5,1,.5-.3-2.5,6,.3,4,1.4s.3-1.2.5.1c.6,0,.9,2.1.5,2.5l.5.5c-.7-1.6-.7-2.6,0-3,.9-.8,1.4.1,1.5,1,.3-.3,1.1,0,1.1,0-.2.7-.7.7-1.1,0-1.3-.8-.9-2.2.4-1.2,2.5-.5,3.3-2.8,1.1-3.8,1.6.2,1.5,1.5,0,1-.1.4-.3.4-.5,0-.2.2-.6.2-1,0,0,.8-.8.7-1,0-1,.1-1.2-.3-.5-1h.5c.4-.3,1.3-.3,2.5,0-1.1,0-2.9-.2-2.5-1.5.1-.4.3-.4.5,0l.8-.9c.7,1,1.6,1.1,2.7.4.7-.7.9-.4.5.5Z"
          fill="#04a7fb"
        />
        <path
          d="M329.2,147.3c.3-.8.7-.8,1,0-.3.4-1.1.5-1,.7.5.9,1.9.3,2.4.8s.7,1,1.6,1.9.3.2.5.5c-.8,1.9-1.7.4-3,.2s-.9.3-1,.3c-1.9-.2-1.9,0,0,.5.5.1,1.5.5,2,.7-2.1,1.9-4.6.7-5.3-1.7s.2-1.1.2-1.3c0-.3-1-.2-.9-.5s1.5-2.1,1.6-2.1c.3,0,.8.1,1.9-.1Z"
          fill="#0395f8"
        />
        <path
          d="M326.7,133.3c.3.4.4,1.4.5,1.5s1.9-.4,2.5-.5c-.3.7-1.2,1.1-1,2,.5-.3,1-.3,1.5-.5,0-.3,0-.7,0-1,1-.1,1.1,0,1,1-.3,0-.8,0-1,0,0,.4.5.9.5,1.5s0,.4,0,.5l-.5.5c-.2,0-2.4.6-2.5.5s-.5-1.4-.5-1.4c.1-.2,1.4-.4,1.4-.8,0-.7-4.1-2.6-2-3.3Z"
          fill="#039df7"
        />
        <path
          d="M331.2,142.3c-1.1,1.6-.2,2.4-2,3-1.5-.1-1.3-1.1,0-1.5.3-.6,1.1-1,1.5-1.5h.5Z"
          fill="#028bf5"
        />
        <path
          d="M320.2,152.3c.3,0,.7,0,1,0l-.5,1.5c-.3,0-.7.5-1,.5s-.4,0-.5,0c-.7-.9-.7-1.5.5-1.5-.4-.4-.2-.5.5-.5Z"
          fill="#027bed"
        />
        <path
          d="M330.2,159.3c.3,0,.8-.8,1.7-.5s1.5,2.2,2.8,2c1-.1.6.4,0,1-.4,0-1.8-1.4-1.5.5-5.3.2-1-1.5-1-1.7,0-.4-1.6-.8-2-1.2Z"
          fill="#039af8"
        />
        <path
          d="M314.2,144.8c.2.6.3,1.3.5,2-.2.2-.3.3-.5.5-.2-.2-.3-.4-.5-.5-1.1-2.9,0-1.6.5-2Z"
          fill="#05b7fc"
        />
        <path
          d="M322.2,133.3c.9.7.5.8,2.5,1.5-.3,0-1.1.4-1.7.3s-.7-.3-.8-.3c-.7-.3-.9-.3-.5,0,.2.3.3.7.5,1,.6.5,2.2,1.4,2.5,0,0,0,1-.7,0-1,.5.2,1.7-.1,1.9.7.3,1.5-1.3,4.4-3.4,3.3,0,.3,0,.7,0,1-1.1,0-1.1-.8-1.5-1-.3,1.3-.6,1.3-1,0-.1,0-.7.1-1,0l.5-1c-1.4.5-2.4-.6-3.3-.8s-.6.3-.7.3l-1-.5c-.1-.4.4-.4.5-.5,1.7-2.2,3.9-.9,3.5-4,.5.3,2.9.9,3,1Z"
          fill="#039bf8"
        />
        <path
          d="M329.2,143.8c.1.4,0,1.1,0,1.5-1,.4-1.9.2-2,.2-.5.3-.1,1.6-1.2,1.3-1.9-.6.5-.9.2-1.7-.5-1.6-2.5,1.5-3-.8,1.6.2,1.4-1.3,0-1,1.1-2.6,3.7,1,4.2,1,1.2,0,0-2.9,1.2-3-.8,1.5.3,1.9.5,2.5Z"
          fill="#039cf9"
        />
        <path
          d="M324.2,147.8c.6.1.8.4.5,1,.1,1.6,1,3.7-1.5,4-.1.4-.3.4-.5,0,0,0-.4-.2-.3-.5.4-.7,2.5-1,1.8-2s-.8.5-.9.4-.2-1.8-1.1-.9.6,1.6-1,1.7-1.1-.3-1-1,1.2-.4,1.3-.5c.7-.9,0-2.2,2.7-2.2Z"
          fill="#0390f6"
        />
        <path
          d="M321.2,146.8c-.7.7-1.7,2.5-2.3,3s-1.7.5-1.7.5c-.3.3.4,1.2.5,1.5-3.7-1.2.2-1.6.8-3s-1.8-2.4,1.7-1.5c0-.3,0-.7,0-1,.5-1.5,1.2-.7,1,.5Z"
          fill="#08b3fb"
        />
        <path
          d="M327.2,157.3c0,0,1-.4,1.5,0l-1,1.5c.3,0,.8,0,1,0,.6.2.6.3.5,1l-2,.5c0-.5,0-1,0-1.5s-.6-.9,0-1.5Z"
          fill="#0389f7"
        />
        <path
          d="M320.2,144.8c0,0,.3-.7,1-.5v1.5c.7-.3,1.1-2,1.5-.2s-1.3,1-1.5,1.2c-.2-.4-.6-.4-1-.5,0-.5,0-1,0-1.5Z"
          fill="#028ff8"
        />
        <path
          d="M323.2,152.8c-.1,1.1.7,1.5,1,2,.3-.8-.6-1.3,1.5-1l-.5,1.5,3.5.3c-2.2.4-2-.8-3.5,1.2-.7-.2,0-.9-.2-1.5s-.7-.4-.8-.5c-1.2,2.9-1.1,1.2-2,0,.2-.7.3-1.3.5-2h.5Z"
          fill="#0393f8"
        />
        <path
          d="M321.7,141.8c.3.2.6.5,1,.5.4.5-1.3,1-2,1-.4-.8.5-1.7.5-2,.5-.4.7-.1.5.5Z"
          fill="#0290f5"
        />
        <path d="M326.7,140.3c.5.5-1,2-1.5,1.5-.8-.8.6-2.2,1.5-1.5Z" fill="#0492f9" />
        <path
          d="M318.7,144.8c-.2,0-.7.6-.9.4s0-.8,0-.9c.5-.1.4-.6.5-1,.1-.4.3-.4.5,0,.1.4.8.7,0,1.5Z"
          fill="#027fe6"
        />
        <path
          d="M321.7,138.8c-1.3,1.8,2.4,3.1,0,3-.2-.1-.3-.4-.5-.5,0-.1-.4-2.4-.5-2.5.3,0,.8,0,1,0Z"
          fill="#0db5fb"
        />
        <path d="M323.2,139.8c.6,0,1-.4,1.5-.5.1.7-.6,2.4-1,2,0-.5-.4-1.1-.5-1.5Z" fill="#0492f9" />
        <path
          d="M320.2,152.3c-.1.2-.4.3-.5.5l-2-.5c0-.2,0-.3,0-.5.7.2,1.7.3,2.5.5Z"
          fill="#04b1fb"
        />
        <path d="M329.2,147.3c-.2-1.3.3-1,1.5-1,0,0-.4.8-.5,1-.3,0-.7,0-1,0Z" fill="#038ff9" />
        <path d="M318.2,139.8c-.2.2-1.3-.9-1-1.5.2-.2,1.3.9,1,1.5Z" fill="#0375ec" />
        <path d="M324.2,147.8c2,0,.5.7.5,1l-.5-1Z" fill="#0271e6" />
        <path d="M326.2,153.3c-1,.1-1.1,0-1-1l1,1Z" fill="#0286f6" />
        <path d="M318.7,143.3h-.5c0-.4-.2-1,.2-1,.5,0,.2.7.2,1Z" fill="#06b5fc" />
        <path d="M316.2,137.3c-.4,0-1,.2-1-.5l1,.5Z" fill="#026ee7" />
        <polygon fill="#039bf8" points="324.2 135.8 323.9 136.3 323.2 135.8 324.2 135.8" />
        <path
          d="M186.8,107.4c.1-.4,0-1,0-1.5,1.1.9,2,1.2,3.5,1,.3-.2-1.3-1.3-1-1.5.8-.7,2.4,1.3.6,2.5s-2,0-3.1-.5c-.3.9-.5,1.3-1,2h2.5s-1,3-1,3c2.6-3.7,3.8-1.1.9.1s-1.7-.2-2.4.4c.4-1.5-.8-.8-1-1-1.4,1.1-1.8-2.9-1.6-3.8l.6-1.2c-.3-.9,1.1-1.3,1.5-.5.2,1,1,.8,1.5,1Z"
          fill="#0594f8"
        />
        <path d="M186.8,110.4c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#04a4fa" />
        <path
          d="M191.3,97.4c.2,0,.3.4,1,.5s.4,0,.5,0c0,.4-.1,1.3,0,1.5l-1,1c-.2,0-.4,0-.5,0-.6-1.1,0-2.4-1.5-2.7,0-.5,1.1-.2,1.5-.3Z"
          fill="#0584f2"
        />
        <path
          d="M187.8,97.9c.5.3,2.2.3,2.4.6s0,1.1,0,1.4c-.7-.2-1.2-.6-2-.5-.2-.4-.4-1-.5-1.5Z"
          fill="#04a4fa"
        />
        <path d="M197.7,99.9v.5c-1,0-1.7.3-1.5-.7s1.3.3,1.5.2Z" fill="#0287f2" />
        <path
          d="M202.2,95.4c-.3,0-1.2-.8-1.5-.5s-.2,1.1-.5,1.6-.9.6-1,.9c-1.6,0-3.1-.6-4.5-2-.4-2.7.9-.7,1.4-1.1s.5-1.7,1.6-.9-.9,1.3-.2,1.5l1.2-1.5c.3-.2,3.4,2.2,2.5,0-.1-.7-.4-.8-1-1-.1,0-.7,0-1,0,0-.6.5-.5.5-.5,3.7-3.6,4,.9,2.5,3.5Z"
          fill="#1494f9"
        />
        <path d="M200.2,92.4c1.1-.1,1.1,0,1,1,0,0-.9-1-1-1Z" fill="#1276f3" />
        <path d="M199.7,95.4c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#28a7f9" />
        <path
          d="M178.8,153.3c-.5.8-.3,2.5-2,3.3l2.5-.2-1.5,2-.4.2c1.1,1.6-.3,3.3-1.1,1.3-.9.7-.9.6-1-.5-1.8,1.3-2.9-.8-2-2.5-.5-.6-.6-1.1-.5-1.5-1.1.4-1.4-.1-.5-1,.4-.2,1.3-1.2,1.5-1l.8,2,.5-1.5,2.8,1-.5-2.2,1.5.7Z"
          fill="#0386f6"
        />
        <path
          d="M171.8,154.3c.1,0,.4,0,.5,0,.2.3.3.7.5,1,.4.3-1.8,1.3-1.9,1.4s-1.2-1-1.1-1.4c.6-.5,1.3-.7,2-1Z"
          fill="#049bf9"
        />
        <path
          d="M180.3,136.8v1c-.2,0-.4,0-.5,0-.6-.6-1.3-.3-1-1.5.6-.2,1.1.4,1.5.5Z"
          fill="#04a7fa"
        />
        <path
          d="M165.8,131.8c0,0,.4,0,.5-.3.2-.5-1.2.1-1-.7l2,.5c-1.3-2.6,1-.5,1-2.5.8-.2.3.7.6.8.8.4,1.8,0,2.4.9-1.4,1.1-2.2,0-3.5-.2.4,1.6,1.9,2.1,3,3.2-2.2,2-.6-.1-2-.7l-1,2c0,0-.7,0-1,0,1.8-1.7,2-3.8-1-2.5-.4,0-.4-.3,0-.5Z"
          fill="#049bfa"
        />
        <path
          d="M179.8,128.9c.4.1.4.3,0,.5.5.7,1.2,1,2.3.9.1,1,.4,1.6.7,1.6.1,0,.5.7.5,1,.7.5.5.6-.5.5,0,.1,0,.3,0,.5-1,.3-1.9.6-1,1.5-.2.3-.3.7-.5,1-.8.4-1.6,0-2.5-.8l-2,1.3c-.6,1.2-.4,1.2.5,0-.3-1.5,1.2-1.3,1.2.6.6.4,1.1.9,1.3,1.4.6-.6,1.3.4,1.5,1,0,.1.6.6.3,1s-1.8.2-.8,1.5c-.6.1-.2.8,1,2.1-1.2.3-2.1.6-3,1.4.4.1.4.3,0,.5h-1.3c.9,1.5.9,2.2-.4,3.2,0,2.8-2.4,3.2-4.7,2.3-.4-.1-.4-.3,0-.5.1-.4.3-.4.5,0-.3-1.3-.2-2.2.2-2.6l-.2-.9c-1.6-2.1-1.8-2.4,1.4-3.6-.9-1.3-1.7-2.4-2.4-3.4,0-.8,0-2.8,0-3.2s1.9-.5,1-1.3-1.9.4-2,.5c-.3.5,1.2,2.6-.3,2.9s-3-.5-3.1-.6c-.4-.3.6-1.8-1.1-1.4l.5,2.5c-.2.4-.4.7-.5,1h1c0-.4.3-.4.5,0,.2,1.7-2.7,1.7-3.7,2l.7-1c-1.5-.1-3.8,0-4-2l-.7,1.5-.7-2c1.7-1.2,4.4,2.5,5,2,.9-.8-1.2-1.2-1.4-1.8s-.1-1.6,0-1.7c.3-.3,2.5.6,2.5-.5-.7,0-1.4-.1-2-.5-.3-.3-.2-.7,0-1,0-.3,0-.7,0-1,.9-.4,1.4.2,1,1,1.2.8,2.1.8,3.5,1-.1-.6.2-2.3,0-2.5h2c.3,1.3-.6.6-1,1.7s-1,2.7.3,2.3c.3-1.2,1.8-2.1,2.1-2.6s0-1.3.4-1.9.9,0,1.3-.5c-.4-.5,0-1.3.5-1.5,1-.8,1.7-3.1,3-3,.4.1.4.3,0,.5.7-.6,1.2-.7,1.6-.2-.6-1.7,1.4-2.6,1.9-.8Z"
          fill="#049bfa"
        />
        <path
          d="M171.8,140.8c2.8-1.6,3,.8,4.3.9,2.4.2,2.3-1.8,3.1,1.9-1.5,1.1-.8-1.4-1.7-1.8s-.1,1-.5,1c-1.2,0-2.8-1.8-4.2-1.5,1.6.6,2.4,3.9,1.5,5s-1.1-2-2-1,1.5,1.6.5,2.5c-1.4,0-.5-.6-1.1-1s-.9.6-1.3.4.3-1.6-2.1-.4l.5,1c-.3.1-.8,0-1,0-.5-1-.5-1.9.5-2.5.4-.3.7-.3,1,0,.2,0,.3,0,.5,0,.1-.3.3-.2.5,0,.2,0,.3,0,.5,0,.4-.1,1.5-.8,1-2-.9-.3-.5-.9,0-1.5,0-.2,0-.3,0-.5v-.5Z"
          fill="#0385f6"
        />
        <path
          d="M169.3,140.8c.1.5,0,.6-.5.5-.3,0-.7,0-1,0s-.3,0-.5,0h-1c-.3,0-.7,0-1,0-.5-.3,1.1-.9,1.5-1,.7,0,2.1-.2,2.5.5Z"
          fill="#0271f3"
        />
        <path d="M173.3,132.3c.1.8,0,1-.5,1.5l-.5-.3c-.4-1.8.7-1,1-1.2Z" fill="#0375ee" />
        <path d="M163.3,137.3c-1-.7,0-.8,0-1v1Z" fill="#0360eb" />
        <path d="M171.8,141.3s0-.2,0-.5v.5Z" fill="#03a0f9" />
        <path
          d="M182.3,129.8c.9.4,1,.6.5,1.5v.5c0,0,0,.8-1,.5-.2-.2.9-1.5-.3-2s0,1.5-1.5,1-.5-1.4-.3-2c1.7-1,2.5-.9,2.5.5Z"
          fill="#038cf6"
        />
        <path
          d="M182.8,133.8c0,.1,0,.3,0,.5,0,.5-.3.6-1,.5,0,.1,0,.4,0,.5-2.2.4-.4-2.6,1-1.5Z"
          fill="#038bf9"
        />
        <path
          d="M176.8,136.8c.1-.2-.2-1,0-1.4s2.3-1,2.7-1.1c1.4-.4-.7,2,1.7,2v.5c-.3,0-.7,0-1,0l-.5,1v1c-.6-.5-1.7-.4-2-2.3l-.5.3c-.1.3-.3.3-.5,0Z"
          fill="#038bf9"
        />
        <path
          d="M174.9,136.2c.3.4,1.1-.2.9.6-1.5-.6-1.4,4.1-3,2.5s1.4-4.3,2-4.5c0,.4-.1,1,.1,1.4Z"
          fill="#038af7"
        />
        <path d="M176.3,132.4c.7.9-1.7,1.8-2,1.5-.6-.6,1-2,2-1.5Z" fill="#0185f8" />
        <path d="M165.8,139.4c.5.3-1.9,1.7-2.5.2l2.5-.2Z" fill="#038af7" />
        <path d="M177.3,136.8c-.6,1.2-.3,2.2-1.5.7.1-.4.9-.6,1-.7h.5Z" fill="#0283f8" />
        <path d="M173.3,134.9c-.4,1.1-.8,1.2-1.5.2l1.5-.2Z" fill="#038af7" />
        <path d="M167.3,141.3c-.1,0,0,.3-1,0h1Z" fill="#038af7" />
        <path d="M179.8,138.3c-.5,0,0-.5,0-.5,0,0,0,.3,0,.5Z" fill="#049bfa" />
        <path
          d="M184.8,111.9c.5-2.1,3-.1,1,1,0,0-.8.1-.5,1,1.8-1.2,1.1.8,3,.5v.5c-2-.2-.5,1.3-.5,1.5s-1.1.6-1.5.5c.2.9,1.2,1,2,1,0,.6-.9.8-1,1-1.5.4-3.3.6-5.3.6-3.2,1.2-.5-4,1.3-2.6q.7.6,0,0c0-.3.5-4.6.7-4.7s.5-.2.8-.3Z"
          fill="#0390f7"
        />
        <path
          d="M183.8,106.9l1.5,1.5c-2.6-1.2-.9,3.2-.5,3.5-1,3,1.1,2.5-1.5,5,.5-.5,1.6.4,1,1s-1.5-.5-1-1c-.4.3-2.3.9-2,2.5l3.3-1,1.4-4c1.4,1-.4,1.5,0,3s.8,1.1,1.3,1.5c0,.1-.8,3,.2,2.5l2.2-3c.4,1.8-2.1,2.3,0,2.7-.5.7-1.4.7-2,1.3,2.8,2.5-2.1,2.9-3.5,1.5-1.7,0-1-.8,0-1.5q.4-.8,0,0c-.6.5-.8,1.4-.4,2.8l-.6.2-1.8.6c-.3,1-.7.9-1.2-.1-1.3,1.2-3.5,2.1-2.7-.3-1.5-2.2,0-3.1,2.2-3.2l.5-.5c-.4-.1-.4-.3,0-.5.1-2-1-1.4-1-1.8-.2-1.4,1.7-2.1,2.5-3.7l-.7-1.7c2.9-.4,1.7-2.6-.7-3.2v-.6c-.5-2,2.3-.9,2.4-1-.9-2,0-1.7.5-2.5h.5Z"
          fill="#04a4fa"
        />
        <path d="M184.8,125.4c-1.5,1-1.7,0-.5-1,1.4-.4,1.7.2.5,1Z" fill="#04a4fa" />
        <path d="M184.3,124.4c-1,.2-1-.2,0-.5.4.1.4.3,0,.5Z" fill="#04a4fa" />
        <path
          d="M180.3,110.4c.9,0,1.8,1.5,1.3-.5,3.6.7.7,1.6.7,1.7.1.3.8.6.9,1.1.4,1.6-1.1,1.3-1.3,1.7s.3.5-.1,1.4c-1-1-2-2-3-3s-1.9-1.5-2.5-2.5c1-.2,1.7.4,2.5,1,1.2.5,1.5.5,1,0l-.5-.5c-.1.4-.3.4-.5,0,0-.7.9-.6,1.5-.5Z"
          fill="#027ff3"
        />
        <path
          d="M184.3,122.4c0-1.7-.9-1.8-1.8-.5-.5-1.4-.4-1.1-1.7-.5-1.2-2.3,3.3-1.5,3.9-.9s.7,1.8.6,1.8c-.1.2-.8,0-1,0Z"
          fill="#038ef7"
        />
        <path d="M186.8,119.4c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#0064eb" />
        <path
          d="M184.3,122.4c-.6.4-.1,1.1,0,1.5-.3.2,0,.4,0,.5,0,.7-.3,1.1.5,1,.2-.5-.5-.8-.5-1s0-.3,0-.5c.8-.1,3.3.2,3.5,0s-.6-.8,0-1.5c2.1-.3,2.3,2.3,1.5,4-.3,0-.7,0-1,0-.4-.1-.4-.3,0-.5.2-.2.2-.4,0-.5-.5,2.3-2.2,1.2-3.5,0,1.6,1.2-1,4.1-2.5,2.5-.3.9-.6.9-1,0-.9-1.2-.3-2,2-2.5.6-1.7-.8-.5-1.2-.5s-1.3-1.2-1.3-1.2c.5-1.2,1.6-.3,2.2-.3s.4-1.3,1.3-1Z"
          fill="#0391f7"
        />
        <path
          d="M183.3,125.4c-.3.9-1.6.7-1.9,1.1s0,1.2,0,1.4c-.2.5-.4.8-1,1-1.2-1.3.5-.8.5-1.3s-.4-1.2-.5-1.7l3-.5Z"
          fill="#037ff2"
        />
        <path d="M188.5,124.4c.3.2.3.3,0,.5v-.5Z" fill="#05aafa" />
        <path
          d="M184.8,125.4c0,0,1.8-.6,2-.5l-.2,1,1.7-.5c.3.1.3.3,0,.5,0,.2,0,.4,0,.5-1,3,0,.1,1.5,1.5-2.6-.7-1.4,2.4-1.5,2.5s-3.6-.5-4.5-.5c-.6,0-.8-.5-.5-1l-.5-.5c-.7.7-.9.4-.5-.5,1.8-.1,2.1-2.1,2.5-2.5Z"
          fill="#039ff9"
        />
        <polygon fill="#038df7" points="188.3 125.9 188.3 125.4 188.7 125.6 188.3 125.9" />
        <rect fill="#037af1" height=".5" width="2" x="184.3" y="128.9" />
        <path d="M183.3,128.9c-.2-.1-.3-.3-.5-.5.2.2.3.3.5.5Z" fill="#0391f7" />
        <path d="M182.8,134.3v1c-.3-.2-.7-.3-1-.5.4-.6.3-.4,1-.5Z" fill="#049bfa" />
        <path d="M185.3,155.3c-.1,0-.4,0-.5,0s-.4,0-.5,0l.7-.5.3.5Z" fill="#039bfa" />
        <path d="M183.8,156.3c-.2,0-.4,0-.5,0,.1-.2.3-.3.5-.5v.5Z" fill="#039bfa" />
        <path
          d="M160.3,156.8c1.4-.3,1.8.3,1,1.5.9.6,1.2,0,1.5-1h.5c.2-.6.6-1.1,1-1.5.5-.8,1.1-.4,1,.5.3.2.4.5.4.6-.2.7-1.2-.1.1-.1s.3.2.5.5c.6-.2.6-.4,0-.5-.8.7-1.1.4-.5-.5.2-.4.3-.4.5,0l.5-.5c-.4-.1-.4-.3,0-.5.2,0,.5-.5.8-.4.6,0-.5.8.7.4s.3,0,.5,0c2.9.6,2.7,3.8,0,2.5-1.1,0-1.1-1.3-1.5,2,.3-.4,3.8-.8,2.5.5s-3.9-.9-1.5,4h-1.5c-.7-.8-1.2-1.8-1.5-3-.7-.8-1.2-2.2-2.5-2-.2.1.5.7.5,1-1.8,1.9-3,2-3.4.3l-1.1-.3c0-.4,0-1.1,0-1.5,0-.6.4-.9,1-1-.1-1-.6-1.3-1-2-.4-.8-.5-1.3.5-1,1,.7.7,1.4,1,2Z"
          fill="#0380f7"
        />
        <path
          d="M173.3,156.8c0,0,0,.5.7.5s0-1.6,1.2-1c-.7,1.9-3.1,1.8,0,3,.4,1-.5,2-1.5,1.5h-.5l-1.5-1,1.5-.3c-.4-.4-2.1-1.2-2.5-1.3-.4-.1-.4-.5.1-1.2-1.7-1.6,2-1.8,2.4-.3Z"
          fill="#059efa"
        />
        <path
          d="M169.8,155.3c.5,0,1.7.9,3,0,.3.4.8.7,1,1.3l-.5.2c-.5-.2-1.6-.9-2-.5s0,1.6-.5,2c-.2,0-1,.5-1.5.5l-.5-.5v-.5c.9,0,1.8,0,2-1-.9,0-1.7-.7-2-1.5.9-.2.6,0,1,0Z"
          fill="#037af4"
        />
        <path
          d="M165.3,161.3c1,1.1,1.9,1.2,1.5,3h-.5c-.2-.4-1.3-.5-1-1.5,0-.5,0-1,0-1.5Z"
          fill="#035fed"
        />
        <path d="M169.3,158.8c-.4,0-.5,0-.5-.5l.5.5Z" fill="#0380f7" />
        <path
          d="M165.3,161.3c.7.9.7,1.4,0,1.5.8,1.9.1,4.8-1.5,2-.4-.1-.4-.3,0-.5-.2-.5-.3-1,0-1.5,0-.2.1-.4.5-.5-.2-.2-.4-.2-.5,0-.7.6-1.1,1.4-1,2.5.9.3,2,1,2,2,.9.1.5.9,0,1.5-.4,2.7-1,3.7-2,3,.3-1.1.6-2.8-.5-3.5-.5.4-1.1.5-2,.5,0,0-1,.3-1.5.5-.2.8-1.1,1.3-1.5.5-.1-.1-.9.1-1,0s.8-1.1,1-1.5c.4-.6,1.5-.9,1-2.5l1,.5c-.3-1-.3-2-.5-3,.1-.4.3-.4.5,0,1.3-.6,2.7-1.5,4-2.5-2.2.4-1.1-1.5.3-1.9s3,2.2,1.7,2.9Z"
          fill="#058af9"
        />
        <path
          d="M164.8,170.8c0,.3-.8.8-.5,1.5.3.1.3.3,0,.5,0,0,0,.8-1,.5l.5-1.5-1.5.5c-.3-.8.5-.9.5-1,1.6.4.7-.9,1.1-2.2s.8-.6.9-.8c.1,1.1.3,1.2,0,2.5Z"
          fill="#0371f1"
        />
        <path d="M162.3,167.8c.3,1.4-.9.8-1.8,1.5l-.2-1c.1,0-.3-2,2-.5Z" fill="#0265ee" />
        <path d="M158.8,168.8l.5.2c-2.3,2.7-1.8.4-2,.3.6,0,1-.3,1.5-.5Z" fill="#036cf1" />
        <path
          d="M165.3,162.8c.7.2,1.5.7,1,1.5.9,1.5-1.6,1.3,1,3,.4,1.6-.7.8-1.5,0-.3-.3-.7-.5-1-.5-1.3-.3-1.5-1-2-2,.2-1.4.4-1.2,1,0,.6,0,1,.3,1.5.5-.4-1.1,0-1.8,0-2.5Z"
          fill="#037af8"
        />
        <path
          d="M158.8,160.3c1.7-.8,2.1,1.1,2.2,1,.6-.3,1.1-1.4,2.3-1,0,1.3-2.6,2.3-3.2,4l-.7-1.5c.6-.2.6-1.1.5-1.5s0-.4-.3-.5h-.7c0-.1,0-.3,0-.5Z"
          fill="#0376f7"
        />
        <path
          d="M163.8,162.3c.1-.2.3-.2.5,0,.2.3-.4.4-.5.5-.3.5-.2,1,0,1.5v.5c-.3,0-.7,0-1,0-.6-1.3-.8-2.4,1-2.5Z"
          fill="#0367f4"
        />
        <path
          d="M165.8,167.3c0,.6-.8.7-1,1,0-.5,0-1,0-1.5.1,0,.8-.6,1-.5s0,.9,0,1Z"
          fill="#0660e9"
        />
        <path d="M163.8,168.3h-.5c-.2-2.1.7-2.1.5,0Z" fill="#037af8" />
        <path d="M163.8,164.3c-.8-1-.3-1,0-1.5v1.5Z" fill="#037af8" />
        <path d="M164.3,162.3c-.2,0-.3,0-.5,0l.2-.5.2.5Z" fill="#037af8" />
        <path
          d="M177.3,171.8c0,.1,0,.8,0,1-.3,0-.8-.5-1-.5-.4-.1-.4-.3,0-.5.3,0,.7,0,1,0Z"
          fill="#0592f9"
        />
        <path
          d="M177.8,158.3c.3.4.5,1,.5,1.5s-.4,2-.5,2.5c-.1.4-.3.4-.5,0,.6-1.8-1.9.2-3.5,0,0-.3,0-.7,0-1,.8-.7,1.6-1.2,2.5-1.5.2-.2,1.3.5,1-.7l-1.5-1.8c.6-.1,1.7.6,2,1Z"
          fill="#069efa"
        />
        <path d="M177.8,162.3c0,.1.4.9-.5,1.5h-.5c0-.5-.1-1.4.5-1.5h.5Z" fill="#03a0fb" />
        <path
          d="M168.8,174.3c.8-.3,1.6-1.1,2.5-1.2-.7-1.4-2.6.1-3-.3s.9-1.7-.5-2.2l3-1.2v2s1-.5,1-.5c.9.5,2,.9,3.1,1.2-.5.8.3,1.3,2.3,1.3l.2,1.1c-1.3,0-1.5,0-.7.4-.3.9-.3,1.8,0,2.5.5-1.1,1-1.8,1.5-2-.4-.7-.2-1,.5-.5h1c1.1-1.5,3.2-1.3,2,.5l-1,1.5c.4.1.4.3,0,.5-.3,0-.8,0-1,0q-.2-.2,0,0c-.3.1-1,1.6-2.5,1l1,1-2.5.8,1.5,1.7-1.1-.9c-.2,0-.4.4-.4.4-.4-.2-1.3-1.1-1.5-1s-.2,1.5-1.5,1.5c1.2-2-.5-5.3-1-2.5.4.1.4.3,0,.5-.6-.6-.7-1.8-1.3-2s-1.5.6-1.7.5c-1-1.1,2.6-1.7,3.5-2q.4.2,0,0c-.1-.6.7-1.7.5-2.5-1.3-.3-1.8,1-2.5,1.5-.2.4-.5.8-1,1-.5,0-1,0-1.5,0l.5-1c-.8-.2-.7-.5.5-1Z"
          fill="#0592f9"
        />
        <path d="M168.8,174.3l-.5,1c-3.2-.8,0-.8.5-1Z" fill="#0369ee" />
        <path d="M170.3,175.3l.5,1c-.5,0-1,0-1.5,0-.4-1.4.8-.8,1-1Z" fill="#0466f0" />
        <path
          d="M172.3,176.3c.3,0,.9.1,1,0,.3-.4-.4-1.7.3-2,1.9.5,1,5.2-.2,4s.6-1.4.5-1.5c-.2-.1-1.4.2-1.5-.5Z"
          fill="#0277f5"
        />
        <path d="M176.8,177.3c-1.3,0-.8-1.8,0-2.5.9.3,0,1.7,0,2.5Z" fill="#0281f2" />
        <path d="M175.8,178.3c.5.5-1,2-1.5,1.5s1-2,1.5-1.5Z" fill="#037ff7" />
        <path d="M179.8,177.3c-.2.2-.8-.5-.2-.5s.4.4.2.5Z" fill="#049cfa" />
        <path d="M169.5,171.3c.3.2.3.3,0,.5v-.5Z" fill="#037ff7" />
        <path d="M176.3,171.8v.5c-.2,0-.7.8-1.5.5.1-.8.8-.9,1.5-1Z" fill="#06a3fa" />
        <path
          d="M180.3,121.4c0,.2,0,.4,0,.5l-.5.5c-1.8,1.8-3,.3-1.5,4,1.2,0-.3-2.2,0-2.5,1.3-1.1,1.8,1.2,2,2,1.7-.6.7,2,0,3-.1.3-.3.3-.5,0-.4,0-1.3-.1-1.5,0s1.2,1.7-1.5,1.5l2.5,1c.2.9-.8.3-1,.5-.2.3,1.4,1.2,1,2h-2.5c.9-1.5-.2-2.3-.5-4,1.9.2.5-.5.5-1s.5-.4.5-.5l-.5-.5c-.2-.1-.5-.5-.5-.5-.5-.3-.6-.7,0-1,0-.5,0-1,0-1.5,0-.3.7-1.7.5-2s-2.4,0-2-1.5c1.8,1.5,3.6.9,5.5,0Z"
          fill="#038cf6"
        />
        <path d="M176.8,128.9c2.3-.8.7,2.4-.5,1,0-.2,0-.3,0-.5v-.5h.5Z" fill="#0272f6" />
        <path
          d="M176.3,124.9c0,0,.8.3,1,.8s-.9.3-1,.7c-.4.9-.8.3-1-.5,0-.5,0-.7,0-1h1Z"
          fill="#04a2f9"
        />
        <path d="M176.3,126.4c0,0,.7,1,0,1-.3,0-.7,0-1,0,0-.5,0-1,0-1.5l1,.5Z" fill="#049bfa" />
        <path d="M177.3,128.4l-.5-.5c.1,0,.4,0,.5.5Z" fill="#049bfa" />
        <path d="M179.8,122.4l.5-.5c0,.3-.3.3-.5.5Z" fill="#0594f8" />
        <path d="M179.5,126.4c.3.2.3.3,0,.5v-.5Z" fill="#037ff2" />
        <path d="M179.8,111.4c-.2,0-.4-.3-.5-.5l.5.5Z" fill="#0594f8" />
        <path
          d="M132.8,176.3c.4.3.6,1.5,1.7,1.5s2.5-1.3,2.8-1.5c.2.1.3.4.5.5.7,1.3,0,2.4-2,3.2,0,1.1-.2,1.9-.5,2.3-1.2,1.2-1.4,1.7-.5,1.5,0,.2,0,.7,0,1,.4,0,.4.4,0,1,0,.3-.7.9-.5,1.5.1.1,1.5-.9,2-1,1.1.2,1.6.8.5,1.5-.1.3-.3.3-.5,0-1.1-1-1.6.8-2.2.9-1.3.1-4-3.7-.3-.9.6-1.5-.9-1.4-1-1.8s0-1.2,0-1.7c-.8-.9-1.1-1.9-1-3h-.5c.5-1.9-1.9-.3-2.5-1.5,1.1-.8,1.7-1.5,2-3.1l1-.4c.3-.6.8-.7,1,0Z"
          fill="#0472f5"
        />
        <path
          d="M137.8,176.8c.4.3,1,.5,1.5.5-1.7,1.6,0,1.6,0,2.7s-2,1.8-2.5,1.3l1-2c-2.9,1.3-1.4,1.4-1.6,2.7s-.9.7-.9.8c-.4-.1-.4-.3,0-.5.7-2.8-2.2-.3-2-2.5,3.2,0,3.2-.5,4.5-3Z"
          fill="#0364f4"
        />
        <path d="M135.3,182.3v.5c-.2.3-.4.7-.5,1l-1,.5v-2.5s1.5.5,1.5.5Z" fill="#0153ee" />
        <path
          d="M131.8,175.8c.4.1.4.3,0,.5,0,2.2-1,3-3,3.5,0-.3,0-.9,0-1s2,0,1-1-2.2.9-2.5-1c1,.3,1.9-.9,2.5-1s.6.6,2,0Z"
          fill="#0364f4"
        />
        <path
          d="M131.8,181.3c0,0,1.1-.4,1.5,0s-.9.8-.9,1.3.3,1.1.4,1.7h-.5c-.1-.7-.6-1-1-1.5s-.7-.6-1-1c.5-.1,1.2.2,1.5-.5Z"
          fill="#035af1"
        />
        <path d="M133.8,178.3c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#023ee6" />
        <path d="M136.8,188.3c-.2,0-.6-.2-.5-.5h.5v.5Z" fill="#0376f7" />
        <path
          d="M132.8,168.3c.5.7,1,1,1.5,1,1.3-.2,1.2,0,.5,1,1.4,1,1.6,1.9.5,2.5.2-1.2.6-1.2,1,0q.1,1.4,0,0c-1.9-1.4,2.2-3,2.2-.4,1.5-.4,3,.9,1.1,1.9-.1.8-.4,1.1-.8,1-.6,0-.9.3-1,.5.7.7.4,1-.5.5-.4,2.9-5.7,3.5-4.5,0-.4-.3-.6-.6,0-1-1-.3-.2-1.6.5-2,.4-.5,1-.6,2-.5-.5.4-1.1.6-2,.5-.3,1.1-.6,1.1-1,0q-1-.6,0,0c1.1,1.2-1.3,2.8-2.5,2-1.3,1.2-3.5,1.3-2.3-.6-.9-.2-1.5-.5-1.7-.9v-.5c-.5,0-.4-.2,0-.5-.8-.3-1.4-.9-.5-1.5-.7.2-.9.2-.5-.5.3-.6,1-.7,2-.5.5-.1.6,0,.5.5.8-.3,1.4-.9,2-1.5,1.1.5,1.7.3,2-.5-.5-.2-.5-.3,0-.5,0,0,.9-.5,1-.5.5,0,.6.2.5.5Z"
          fill="#0364f4"
        />
        <path
          d="M124.8,170.8c.1.3.5.4.5.5.5.9-.3,1.2-1,.5-.1-.6-.3-.4-.5-.5l.5-.5c.2,0,.3,0,.5,0Z"
          fill="#0243dd"
        />
        <path
          d="M131.3,168.8c0,.1.7.5.5,1-2.1.4-3.5,0-3,2.5-.7-.2-.7-.9-1.5-1.5.9-.5,1-1.6,1-2.5,1.2-.1,2,1.4,3,.5Z"
          fill="#0371f7"
        />
        <path
          d="M133.3,173.3c0-.8-1.3-2.1.8-1.5s0,.5,1.2,1c0,.3-.6,1-.5,1.5-.2.2-1-.9-1.5-1,0,.9-.4,1.4-.5,2,0,.7-.4.8-1,.5-.2,1.7-2.1,1.8-2,0v-.5c1.1-.4,2.4-.8,2.5-2-1.1,0-2.6.9-3-.5l3-.5c0,.3,0,.7,0,1,.3,0,.7,0,1,0Z"
          fill="#0575f6"
        />
        <path d="M133.8,168.8c.2.1.4.3.5.5-1.8,3.8-1,.4-1.5-1h.5l.5.5Z" fill="#057af6" />
        <path d="M126.8,170.3c-.6.4-1.3.5-2,.5-.1-.3,0-1.1.5-1,.2.1.7,0,1.5.5Z" fill="#027af7" />
        <path
          d="M125.8,172.8c-.1.3-.3.3-.5,0l-1.5-.5c0-.2.5-.4.5-.5l1-.5c.2.5.4.5.5,1.5Z"
          fill="#035af1"
        />
        <path d="M131.3,171.8l-1-.5v-.5s2,0,2,0c0,.5-.6.8-1,1Z" fill="#057af6" />
        <path d="M128.8,173.8s-1.1.2-1-.2c.8-1.4,1.6-.3,1,.2Z" fill="#0575f6" />
        <path d="M131.3,171.8c0,.6-.5.6-1,.5v-.5c.3,0,.8,0,1,0Z" fill="#013be9" />
        <path d="M133.8,168.8l-.5-.5c.2.1.3.4.5.5Z" fill="#0364f4" />
        <path d="M138.8,175.3c0,.4,1.4,1.9-1,.5,0-.1,0-.7,0-1l1,.5Z" fill="#0350e9" />
        <path d="M132.8,175.3c0,.1.7.9,0,1-.1,0-.7,0-1,0v-.5c.2,0,.5-.6,1-.5Z" fill="#0349ef" />
        <path d="M136.3,172.8c.5.2.6,1,.5,1.5h-1c-.1-.1.4-1.1.5-1.5Z" fill="#057cf5" />
        <path d="M136.3,174.8l-1,1c-.1-1,0-1.1,1-1Z" fill="#1283ef" />
        <path
          d="M153.3,186.8v1.5s-.7,0-.7,0c-.2,0-.2-.5-.2-.5-.8-.8-.7-1,.5-1,.1-.2.3-.2.5,0Z"
          fill="#0376f7"
        />
        <path d="M151.8,187.3h-1c-.4-.2-.4-.3,0-.5.4-.5,1-.1,1,.5Z" fill="#0376f7" />
        <path
          d="M150.8,159.8c1.7.3,3.4.5,5.1.5,0,.9.4,2,1.4,1.5-.1-.5,0-.6.5-.5.1-.4.3-.4.5,0,.6-.4.9-.2.5.5.8,0,.6.7,0,1,2.1,1.7,1.2,5.5-1.5,5h-.5l-.9-.3c-1.5,1.2-2,1.6-3.6.3-.5,0-.4-.2,0-.5l-1.5-1q-.9-1.1,0,0c1.1,0,1.1.6,0,1.5.6.2,1.1.3,1.5.5,1.6-1.2,2.4,2.2,1,2-1.6-.3-1.8,0-1,1.2h-1c.6,1.5,1.4,1.7,3,1.8-.7,1-3,1.8-.5,2,.3.3-.8.8-1,1-1,1.1-1,1.9,0,2.5.8.5,1.3,1,1.5,1.5l.4.3c-.8,1.7.5,1,1.1,2.2l-2,.5-.5.5c.3-.9-.4-.9-1-.5l.4.8c1.7-.3,1.8,2.4,0,2.7-.2.3-.3.5-.4.4-.8-.1-3.7-2.7-2.3-3.3-1.3-.1-1.9-.5-1.8-1.1-.5-1.3-.9-2.7-1.3-4.1,1-.6,1.8-1.4,2.3-2.4-1.2,2.3-2.6,3.4-4.2,3.3l-.3-.3c-.2-1.3-1,.8,0,.5,3-1.3,3.5.2,3,3l.7.5c1.6-1.4,2.4,2.4,2.3,3.5-.4.3-.4.7,0,1,1,.8,1.8,1,2.5,1.5-.1.6-.3,1.1-.5,1.5h-.5c-.7-.4-.8-.2-.5.5,0,.3,0,.7,0,1,.4,1,.1,1.4-.7,1.1l-.8.9c-.2,0-.9,0-1,0-1.6-.7-3.1-1.2-4.5-1.5-1.1-.3-2.3-.1-3.7.4l-.3-1.4c-1.3-.4-1.3-.6,0-1,.4,0,.8-.3,1-1,.7-1.2.7.6.4,0-.4-1.1-.4-2,.3-3-.9-.8.8-1.7,1.8-1,1.7,1.6,2.1,2.6,1,3,.2,1.2,1.4,1.1,1.5,0-.6-.2-1.1-.7-1.2-1.6-1.7.8-1.5-1.6-.3-2.4-.9-.5-1.2-.5-1,0-.4.8-2.3,2.1-2.5,1-1,0-1.2.1-.5.5.6-.3.9.5.5,1,.6.7.3,1-.5.5-.1.5-.3.4-.5,0-.8-.4-2.1-.6-3.8-.5l-.6-1c.8.5-2.1,1.7-2.3,1.6s-.8-3,.8-2.1c.3-.7.3-1,0-1-1.3,0-1.3-.3,0-1-.7-.6-.5-1.3.5-1,.6-.8.9-1.7-.3-2.2,2-1,2.9-2.3,2.8-3.8-.8.6-1,.3-.5-.5.1-.1.4-.4.5-.5l1-.5c0-1.1,1.2-1.4,1-2.5-1.6.8-2.2,0-2.2-1.5-1.7.7-.9.6-1.3,1.5-.2,0-.7,0-1,0,0-.3-.4-2.2-.5-2.5h.5c.6,1.7,1.5.3,2.5,0,.3-.4.6-.3,1,0,0,.2,0,.7,0,1h.5c0-.1,0-.3,0-.5h.5c.6-.4,1,.1,1.3,1.4,1.9-.2,2.4.4,1.7,1.6.8,0,1.1.7,1,2l.6-.5c0-1.2.2-2.2.4-3-.4-.1-.4-.3,0-.5.2-.9.6-.9,1,0,.2,0,.4,0,.5,0,.7-.2.7.9.5,1.5.7-.4,1.7,0,3,1,1.3-.5,1.4,0,.5,1,.8.5.4.8-1,1,1.8-.6,2.3-1.1,1.5-1.5-.2-.3-.3-.5-.2-.5,1.2-1.1,1.1.4-.4.1s-.3-.3-.4-.6c-1.6.6-2.4-1-2.5-2.5-.4-1-.8-2.1-1-3.5q.2-.2,0,0c-2.3,1.5-1.7-2.6,1-2,0-.3,0-.5.1-.5,1.1-.7,1.7.2.2,0s-.2-.2-.3-.4c.1-.7.4-1.3.5-2l3.5,1c.6-1.3-1-.8-1-1.3s.3-2.1.5-2.7Z"
          fill="#0376f7"
        />
        <path
          d="M137.8,169.3v.5c.4.1.4.3,0,.5.3.9.2,1.4-.5.7-1.4,1-2.1,1.4-2-.7v-.5l1-.5c.2,0,.3,0,.5,0h1Z"
          fill="#0364f4"
        />
        <path
          d="M139.8,170.8c3.4-.9-.5-.9.5-2s4,1.1.5,3c3.4.7,2.2.5,4-1,.7,0,.7.8,0,1,0,.2,0,.5,0,.5.5.8-.2,1.3-2,1.5,2.1-1.1,2.4-.2,1.6,1.9s-.3,0-.6,0c0,.1-.8.2-.8.7-.1,1.6,1.5,1.5-1.7,2.3-.6-1.3,1-1.6.9-1.7,0-.4-.6-.9-.4-1.3s1.2.6,1.5-.3l-.5-1.7c-.9.7-1.2,1.9-3,1.5-.5-1.6,2.4-1.3,2.5-2.2s-1.4-.3-1.7-.3c-.5,0-.6-1.5-.8-2Z"
          fill="#0467f3"
        />
        <path d="M147.3,165.8v-.5c0-.2,0-.3,0-.5l1.5-.2c.1,1.1-.9,1-1.5,1.2Z" fill="#0d90f9" />
        <path d="M138.8,170.3c-.3,0-.7,0-1,0v-.5c.5,0,.8,0,1,.5Z" fill="#032ed8" />
        <path d="M138.8,171.3h.5c0,.2,0,.4-.2.5-.3,0-.2-.3-.2-.5Z" fill="#0467f3" />
        <path
          d="M148.3,182.8l1,.5c0-1.3-.1-2.9.8-4,1.3.8.2,1.5.2,2.2s1.2.1,1,.5-.6.5-.7,1c-.3,1.9,0,3.4,2.2,3.7-.1.3,0,.8-.5,1-.2-.1-.3-.3-.5-.5-.4-.3-.9-.4-1-.5s0-1-.5-1.3-1.9.8-2.5-.5l2-1c-.2-.7-1.3.4-1.5.2s-.4-1.2-.5-1.5c.1-.4.3-.4.5,0Z"
          fill="#0360f2"
        />
        <path
          d="M153.8,183.3c.5.2,1,.9,2,.5-.6.5-1.1,1-2,1l1.5,1.5c-.6,0-1.5.5-2,.5s-.3,0-.5,0c.2-.4.6-.7.5-1.2l-1.5.2,1.5-1c-.2-1.1-2.6.1-1-1.5q.5.3,0,0c1.1-1,1-.2,1.5,0Z"
          fill="#0360f2"
        />
        <path d="M150.8,186.8c0,0,0,.3,0,.5v.5c-.2-.2-.9.3-1-.3s.4-1.1,1-.7Z" fill="#0360f2" />
        <path
          d="M152.3,167.8h2.8c-.9-1.4,2-1.7,1.7,0-.9-.3-1.4,1-1.5,1-1.2,1-.4.1-.4.2.1.5,0,1.7-.6,1.8-.9,0-.9-.5-1-.5l.5-.2c-.7-.8-.1-1.9-1.5-1.8-.4-.1-.4-.3,0-.5Z"
          fill="#058af9"
        />
        <path
          d="M149.3,176.3c-.1.2.2,2.2-1.5,2v.5c2.1-.3-.5,2.2.5,4h-.5c-.4-1.4,0-1.9,0-2,0-.1-2.5-.9-3-1-.4,0-.4-.2,0-.5h.7c1.1-1.2,2.5-2,3.8-3Z"
          fill="#0363f1"
        />
        <path
          d="M134.8,184.8c1-.4,1.4-2,2.3-2.5s.2,1.9,1.5,2,1-1.4,1.3-.7c-.1,1.3-1.6,2-2.7,1.8s0-1.2-.8-1l-1.5,1.5c0-.2-.3.1,0-1Z"
          fill="#025ff3"
        />
        <path
          d="M146.8,188.8c.3,0,.7,0,1,0,.2-.9-1-.2-1-.8,0-1.5,1.4-2.7,1.9-.7s-1.2,2,1.2,3.5c-1,.2-1.3-.9-2.3-1s-2,1.1-3.2,1l1-2c.6-.4.9-.1.5.5l.5-.5c.2-.4.3-.4.5,0Z"
          fill="#0260f1"
        />
        <path
          d="M147.3,171.3c.2,0,.8,2,2.5,2.5.4.1.4.3,0,.5l-2.5,1c-.2.9.8.3,1,.5,1,1.1-3.4,1-2-1s2.1.2,2.5-.3c-.5-.7-1.5-.6-2-1.3-.1-.9,0-1.5.5-2Z"
          fill="#0269f0"
        />
        <path
          d="M145.3,184.8c0,.2-.7,1-.4,1.4s2,.9,1.9,2.6c-.2,0-.3,0-.5,0l-.5.5c-.5,0-.4-.1-.5-.5s0-1,0-1.5l-1,1.5c-2-.8-.3-1.8,0-3-.4-.2-.4-.3,0-.5-.4-1.4,0-1.5,1-.5Z"
          fill="#0268f4"
        />
        <path
          d="M144.3,184.8c.4.1.4.3,0,.5,0,.1,0,.4,0,.5-2.1.2-2.1,2.8-1.5,4.5l-1-.5-.5-2c.2-.1.4-.3.5-.5.2-.6,0-.9-.5-1-.4,0-.8-.4-1.3-.1-1.4.4-.2-.8.2-.8.8,0,1.9.4,2.1.3s0-.7.2-.7c.6-.1,1.3.5,1.9-.2Z"
          fill="#035ef3"
        />
        <path
          d="M144.8,172.3c.2,0,.7,0,1,0,.5,1.2-.7.8-.9,1.1-.5.8.6,4.1-1.1,2.4.3-.7.8-1,.5-2h-1.5c.8-.6,1.6-.6,2-1.5Z"
          fill="#0686f8"
        />
        <path
          d="M136.3,186.3c1.6-.2,2,.7,2.8.9s1.9-1.2,1.7.6c0,0,0,.4-.3.5-.5-1.5-.5-.7-1.7-.5s-1.6.5-2,.5c-.3-.1-.3-.3,0-.5l-.5-1.5Z"
          fill="#035ef3"
        />
        <path
          d="M150.8,174.8c2.5-.5,1,1.2.3,2-1.2,1.3-.6-1.8-1.8-.5.3-.2.7-.7,1-1-.1-.5,0-.6.5-.5Z"
          fill="#0269f0"
        />
        <path
          d="M144.3,184.8c-.1-.3-.9-.3-1-1.2s-.2-1.6.8-1.3,1.2,2.2,1.3,2.5l-1,.5c0-.2,0-.4,0-.5Z"
          fill="#0250e8"
        />
        <path d="M144.8,179.3c0,.2,0,.3,0,.5-.2,2.6-2.1,0-.2-1.5.5,0,.2.7.2,1Z" fill="#045ff5" />
        <path
          d="M149.8,173.8c.5.2,1.4-.1,2,0v.5c-.4,0-.7.3-1,.5s-.3.3-.5.5l-.5-1v-.5Z"
          fill="#0887f8"
        />
        <path d="M147.3,183.3c.4.6-.7,1.8-1.5,1.5v-1.5c.5.6,1.5,0,1.5,0Z" fill="#0268f4" />
        <path d="M149.3,191.8c.8.9-.9,1.6-1.5.2s1.4-.3,1.5-.2Z" fill="#025ff1" />
        <path d="M146.8,173.3c-.3-.4-.4-1-.5-1.5.3,0,.7-.6,1-.5,0,.6.3,1.6-.5,2Z" fill="#0250e5" />
        <path d="M141.8,187.3l-.5-1c0,0,.7-.9,1,.3s-.5.7-.5.7Z" fill="#0247e3" />
        <path d="M142.8,180.8h-.5c-.2-2.1.7-2.1.5,0Z" fill="#011fc2" />
        <path
          d="M154.8,158.3c.5-.4.9,0,1,.5.6-.7,1.6-1.4,2.5-1,.8-.4,1.3.4.5,1,1.4.3,1.4,1.1,0,1.5.4.1.4.3,0,.5.5.5.2.7-.5.5,0,0-.4,0-.5,0-.7-.5-.9-.4-.5.5-.2.2,0,1.2-.8,1.5l-1.3-2.5-2.5,1.5.3-2-1,2.5-1.3-3c.2-.4,1.8-1.2,1.5-2.5.8.3,1.7.6,2.5,1Z"
          fill="#0489f8"
        />
        <path
          d="M150.8,166.3c.1-.2.9-.3.9-.7s-1.1-.9-.9-1.3,3.8-1.7,4-1.5c-.7,1.8,1.2,4.1-1.5,3.5l-.2-2c-.9.7-.7,1.9-.8,3-.1.7-1.1,1-1.5.5-1.3.4-2.6.4-4,.5.5-2.1,3.4-.6,3.9-1.1s0-.8,0-.9h-1s0-2,0-2c.3-.6,1.3,1.7,1,2Z"
          fill="#058af9"
        />
        <path
          d="M152.3,167.3c0,.2,0,.3,0,.5v.5c-1.2.1-1.7,1.2-1.5-.5.5-.2.9-.5,1.5-.5Z"
          fill="#0461f3"
        />
        <path d="M156.5,165.1c.4.4,1,0,.8.7-.9.1-1.5,0-2-.7,1.3-1.5.7-.4,1.2,0Z" fill="#068cfa" />
        <path d="M152.3,183.3c.4-.4,1.5.3,1,.5s-1.3-.3-1-.5Z" fill="#0035de" />
        <path
          d="M149.7,171.5c0,0,1.5,1.4,1.1,1.8s-2.1-1.4-2.5-1.7c.1-.5,1-.3,1.4,0Z"
          fill="#0364ef"
        />
        <path d="M145.8,189.3c0-.2.3-.4.5-.5,0,.4-.1.6-.5.5Z" fill="#0376f7" />
        <path d="M140.8,189.8h-.5c0-1.5.3-1.5.5,0Z" fill="#0256ee" />
        <path d="M130.3,182.8c.2,0,.3,0,.5,0l-.2.5-.2-.5Z" fill="#035af1" />
        <path
          d="M184.3,141.3c.4.7.5.7.5,0,1.2.4.9.5,1.5,1l.5.5c.5.4,2.1-.5,0,1.5-.9.2-2.3,1.6-1,1,1.2-.4,1.6-.4,2.5.5.4.1.4.3,0,.5-1.3.3-2.2,0-3.5,0l1,1c.5.2.4.8,0,1.7,1.1.4.8.8-.9,1.3.6.4.9.4,1,0,0-1,.8-1,1,0,0,0,.4.4.5.5,1.4-1.1,4.1-1.2,1.5.5-.5.2-1,.3-1.5.5-.2,1.2-.7,2.1-1.5,2.5-.3.6-1.8.5-1.5-.5.8-2.2-.3-.5-.5.5.8.4-.2,1.7-1,1.5-1.3.8-2.5-1.3-2-2.5-.1-.7-.4-1-1-1,.7,1.2.3,1.6-1,1-.8,2.1-1.8,2.7-3,1.8-.8.8-2,.5-3.5-.8-.2.4-.3.4-.5,0-1.3,0-1.3-.4,0-1l.2-.8c3.6-.5,5-1.5,4.3-3.1,1.3.2,1.6-1.4,1.5-2.4l1-.7c0-.2,0-.3,0-.5.6-.7,1.3-1.1,2.4-1.2,0-.5.8-.9,2.1-1.3,0-.4.5-1.6,1-2Z"
          fill="#059df9"
        />
        <path
          d="M180.8,142.3c.2.2.3.3.5.5.5-.3,1-.1,1.5.5h.5c0,.5,1.4,1.2.5,2.5l-1-1.5c-1.6.7-2.3,1.5-4,1.5.3-1.6,1-1.7,2.5-1.5-.4-.8-3.1-1.8-.5-2Z"
          fill="#0388f7"
        />
        <path d="M186.8,144.3c-.3.3-.7.6-1,1,0,0,0,.8-1,.5l.5-2.5,1.5,1Z" fill="#0384f1" />
        <path d="M184.8,141.3c.7.8.4,1.4-.7,1.5l.2-1.5c0,0,0-.4.2-.4.2.1.2.4.3.4Z" fill="#0286f4" />
        <path d="M186.8,142.8h-1s.5-.5.5-.5c.2.2.3.4.5.5Z" fill="#0272f1" />
        <path
          d="M172.3,151.8l4.5-1c.3-.3-2.5-1.3-1.5-2.5s1,1.1,1.2,1c2.4-1.1-1.6-3.3-1.7-3.8-.5-2.4,4.4-3,.4-.4,1.1,1.5,2.8-.7,3.5,1.3,0,.8,0,1.6.5,2.3-1.8-.2-3.2,2.8-2.5,4.2-2.1-1-1.2.2-1.5.4-.6.5-1.5-1.1-2.6-1s-.6.8-.8,1c-.7,0-.6-.7,0-1-.4-.6-.2-.9.5-.5Z"
          fill="#0388f7"
        />
        <path
          d="M183.8,154.3c-2.5-.3-1.4-2.2-1.6-2.4s-1.1.3-.9-.6l3-.5c.1.1-1.7,2.3-1.5,2.5,1.8,1.3,1-2,2.5-1.5.1.9-.6,1.3-1,2,.7.7.4.9-.5.5Z"
          fill="#038cf9"
        />
        <path
          d="M180.3,147.8c.6,0,2.4-2,2.5-.3s-2.7.7-.5,2.7c-1.9.4-1.9-2.3-2-2.5s-2.2.3-.2-1.5l.2,1.5Z"
          fill="#0388f7"
        />
        <path
          d="M185.8,154.3c-.1.5.1.6-.5,1-.3-.2-.6-.1-1,0-.2,0-.3.3-.5.5,0,.3-.2.5-.5.5-.3-.1-.3-.3-.5-.5.6-.3.7-1.1,1-1.5s.4-.3.5-.5l1.5.5Z"
          fill="#04adfb"
        />
        <path d="M185.8,150.3l.5,1.5c-.7-.2-1.1-.9-1.5-1.5h1Z" fill="#036cec" />
        <path d="M179.8,152.3l.3-.5h.7s0,1.5,0,1.5c-.3-.3-.7-1.1-1-1Z" fill="#046feb" />
        <path d="M171.8,153.3c-1.5,1.2-.8-.2-1-.5.2-.1.3-.4.5-.5s.4,0,.5,0v1Z" fill="#0267ee" />
        <path
          d="M165.8,155.3c.4-.3.6,0,.5.5.4.1.4.3,0,.5-.2,0-.3,0-.5,0,0,.4-.3.4-.5,0-.3,0-.7-.4-1-.5-.3.1-.7.6-1,1.5-.6.5-.6,2.4-2,2,0-.3,0-.9,0-1,1.7.2.4-1.2,2-3s.4-.4.5-.5c1-.5,1-.3,2,.5Z"
          fill="#0590fa"
        />
        <path
          d="M162.3,146.8c0,0,.8-.2.9,0s-.4.6-.3.8c.4.6,1.4.8,1.3,2.6,0,1.1.1,1.1.5,0,.2,0,.3,0,.5,0,.4.2.4.3,0,.5,1.5.9,1,2.2-1.5,4,.8.4.6.6-.5.5-1.5,1.8-2.5,2.3-3,1.5-.7,0-1.1-1.3-1-2-.3.5-.8.4-1.5-.5.8.4,1.2.9,1,1.5.9-.3,1.6,1.4,1,2-.5.6-1.2.1-1.5-.5-1.1.9-1.9,1.1-2.5.5-.1.5-.3.4-.5,0-.5-.7-1.7-.2-1.5-1l1-.5c.5,0,.1-.3-1-1-.9-.1-1.4-.4-2-.5-.7-.7-.8-.7-.5,0-.2.3.5,1.4-1,1,.3-1.3-1-3.7-1-4.2s.9-.2,1-.3l2.5.5c-1.2-2.2.1-1.4,2-1.5.2.1-.4.7-.5,1-.5.6-.5.9,0,1,.6-.6.3-1.1,1.5-1,.8,2,.2,2,2,3-.2-.5-.2-1-.5-1.5.9-.4,1.9,1.5,2.5,1s-1.6-1.6-1.5-1.7c.6-1.3,2.1.5,2.5-3.3.7,0,1.3,0,2,0v-.5s-1-.5-1-.5c.4-.3.6-.5.5-1Z"
          fill="#0389f8"
        />
        <path d="M161.8,147.8c2.8-.6,1.1,4.1-1,1,0-.2,0-.3,0-.5.2-.4.8-.4,1-.5Z" fill="#0490f9" />
        <path
          d="M153.8,155.3c.7.1,1.6.6,2.2.5s0-2.4,1.8.5c-1.1.3-1.9.2-3,0s-1,0-1.5,0l.5-1Z"
          fill="#036ff2"
        />
        <path
          d="M151.3,154.8l-.5-.3c-.7-1.5,1.8-2.1,1.5-1.5-.7.6-1.2,1-.5,1.8-.1,0-.5,0-.5,0Z"
          fill="#0369ea"
        />
        <path d="M166.3,150.3v.5s-.6.5-1,0c0-.2,0-.3,0-.5.3,0,.7,0,1,0Z" fill="#0352ed" />
        <path d="M154.3,151.3c0,.3,0,.7,0,1-1.5,1.5-1.6-1.4,0-1Z" fill="#0264e8" />
        <path
          d="M158.3,157.3c.4.1.4.3,0,.5-2.1.6-.7,1.7-2.5,1v-1c1-.3,1.4-.4,2.5-.5Z"
          fill="#0380f7"
        />
        <path
          d="M159.8,157.8c.1,1.1,0,1.1-1,1,0-.3-.4-.7-.5-1v-.5c.6,0,.7-.4,1.5.5Z"
          fill="#0367ef"
        />
        <path d="M159.3,154.8l-.5,1c-.2-.3-.6-.4-1-1.5.3.2,1,.1,1.5.5Z" fill="#026ff1" />
        <path
          d="M163.3,155.3c-.5,2.6-1.2,3.6-2,3-.4-.6-.5-.6-1-1.5.9.3,1.3-.6,1.5-1.3.2-1.2-1.1-.2-1-1.2l2.5,1Z"
          fill="#026ff1"
        />
        <path d="M164.8,150.3c0,1,.4,1.7-.7,1.5s.2-1.4.2-1.5h.5Z" fill="#037af4" />
        <path d="M161.8,151.8c.3.3-.7,2.6-1,2v-2s1,0,1,0Z" fill="#025de2" />
        <path
          d="M168.3,152.3c.1,0,.4.5.5.5.4.1.4.3,0,.5-.3,0-.7.4-1,.5-.7.1-1.9.9-2.5.3,1.1-.7,1.6-1.9,3-1.8Z"
          fill="#0398f9"
        />
        <path
          d="M166.8,155.3v.5c-.1.3-.3.3-.5,0-.1-.2-.3-.3-.5-.5l.3-.4c.3,0,.6.4.7.4Z"
          fill="#0256e3"
        />
        <path d="M168.8,152.8c.4.1,1,0,1.5,0-.5,1.6-1.4.5-1.5.5v-.5Z" fill="#0261ec" />
        <path
          d="M176.3,159.8c-.8.6,0,2.1-2.5,1.5,0-.2,0-.4,0-.5.1-.4,1.1-1.1,1.5-1.5.3.1.8,0,1,.5Z"
          fill="#14aafa"
        />
        <path d="M164.3,155.8c.4,2.2-.8,1.3-1,1.5-1,0,.4-1.9.5-2,.3-.2.5.5.5.5Z" fill="#036eed" />
        <path
          d="M166.3,156.8c.4.1.4.3,0,.5-.8,0-2.3,1.6-1-1,.1,0,.3,0,.5,0,0,.2.3.4.5.5Z"
          fill="#036eed"
        />
        <path d="M166.3,156.8c.4,0,.8-.3,1,.3.5,1.5-.9.2-1,.2v-.5Z" fill="#0a9bf9" />
        <path d="M166.8,155.8l.5.5c-.3,0-.7,0-1,0v-.5h.5Z" fill="#037af4" />
        <path
          d="M290.2,331.2c1-.9,2.1-.3,2,1,1.3,0,3.8,1,3.5,2.5.9.6,1.6,1.2,2,2-.1.4-.5.9-.7.8-1.3-.5-2.5-1.1-3.8-1.8-.1,0-.4,0-.5,0-2-.9-5.9-4.1-8-5.5l-1-1c-.1,0-.4,0-.5,0-.5-.3-.6-.7-.5-1,.3-.4.8-.7,1.2-.5,2.2,1,4.4,2,6.3,3.5Z"
          fill="#2b76f4"
        />
        <path
          d="M365.1,383.7q-.5.3,0,0c.6-.9,2.6.6,2.5,1.5-.7,0-1.5.4-1.8.4s-.6-1.7-2.2-.9c-.2-.2-.4-.2-.5-.5-.9-1.7,0-1.6-2.5-4,1.3-.5,4.4,2.1,4.5,3.5Z"
          fill="#3177eb"
        />
        <path
          d="M386.6,379.2c-.2.6-.3,1.5-.5,2s-.9.8-1,1h-.5c-.4-.1-.4-.3,0-.5,0-1.1.5-3.3,1.5-3.5.4-.3.6,0,.5,1Z"
          fill="#296fd3"
        />
        <path
          d="M117.3,383.2c1.1.9,2.1,1.7,3,2.5.1.6-.5.2-.5.2.3,0,1.7.5,1.9.6s.1.3,0,.6h.5l.5.5c.9-.7,3.2-1.2,3.5.5-.2.7-1.3.8-2,.5-.2,0-.3,0-.5,0l-1.5-.5c-.2,0-.3,0-.5,0-.9-.3-1.8-.8-2.5-1.5-.2,0-.3,0-.5,0-.1-.2-.4-.3-.5-.5l-1-1c-.6-.7-1-1.3-1.5-2-.6-.7-.3-1,.5-.5.8-1,1.2-.8,1,.5Z"
          fill="#4f93ee"
        />
        <path
          d="M121.8,388.2c-.3,0-.8,0-1,0-.4-.1-1.2-1.1-1.5-1.5.7.1,2,.9,2.5,1.5Z"
          fill="#4679d8"
        />
        <path
          d="M279.7,294.8l.7,2.2c.5,9.2.1,17.9-1.2,26.3,1,1.7,2.7,2.7,4.5,3.5,1.1,0,6.8,3,6.7,3.8s-.1.5-.2.7c-2.3-1.2-5-2.4-7.5-3-.2.3-.3.3-.5,0-.2,0-.3,0-.5,0l-.5-.5h-.5c0-.4-.4-.4-.5-.5-1.3.6-2.2,0-2.5-1.5-.4-.1-.4-.3,0-.5-.2-.3-.4-.8,0-1,.4-8.2.6-16.5.5-24.9l.5-1.6c-.7-.3-.7-1.2,0-1.5-.4-1.3-1-3.1,0-4-.1-1.8.2-3.1,1-4,.3,2.1.3,4.3,0,6.5Z"
          fill="#1069fb"
        />
        <path d="M284.7,330.2c-.6-.4-.8-.9-1-1l1,1Z" fill="#0637e2" />
        <path d="M283.2,329.2c-.4-.3-.9-.4-1-1,.2,0,.3,0,.5,0l.5,1Z" fill="#0637e2" />
        <path d="M281.7,328.2l-.5-.5c.3,0,.4.5.5.5Z" fill="#0637e2" />
        <path
          d="M295.7,334.7l.5-.5c1.7,1.4,3.4,2.3,5,2.5.9-.9,2.8.4,3,1.5,6.5,3.4,12.5,7.5,18,12.5,2.9.3,6.1,3.1,7.8,5.4l2.7,2.1c1.6-.5,4.7,1.3,4.5,3,.4.6,0,1.1-1,1.5h-.5c-.3-.6-10.1-6.9-11.5-7.5-2.9-2.1-5.6-4.4-8.5-6.5.1-.4.4-.6.5-.4.2.4-6.2-4.2-7-4.8s-.3-.2-.5.3c-2.2-1.5-4.7-3.1-7-4.5s-2.7-2-4-2.5l-2-2Z"
          fill="#0b48e4"
        />
        <path
          d="M308.7,343.7c-1.2-1.8.4-.9,1.2-.4,1.8,1.1,4.4,3.1,6.1,4.4s1.3,1.1-.2,1c-2.3-1.7-4.6-3.4-7-5Z"
          fill="#0739dd"
        />
        <path
          d="M348.7,369.2c1.2-.3,1.9.2,2,1.5,2,1,3.9,2.3,5.5,4,.5-.2,1-.3,1.4,0,1.5.8,11.6,7.6,11.9,8.3s.2.5.2.8c.9,0,5.7.9,5.7,1.2s0,.5-.2.8c-.5,1-3.1.5-4,0-.3,0-1.2-.9-2-.5l3,1.5c-.3,1.3-2.7,0-3.2-.5s-.2-.9-.3-1c-3.1-2.1-6.2-4.3-9.2-6.6l-.8.2c-.6-.5-1.4-1-2-1.5-1.2-1-2.3-2-3.5-3l-5.9-4.2c-.8-1.6,0-1.5,1.4-.8Z"
          fill="#0c4ddf"
        />
        <path
          d="M348.7,369.2c-1.6-.2-1,.3-.3,1,1.4,1.3,3.6,3,4.8,4-2.8-1.5-5.5-3.3-8.2-5.1s-3.6-3.2-5.3-4.4c-1.5-1.5-1.5-2,0-1.5,3.4.3,7.2,3.2,9,6Z"
          fill="#0b44de"
        />
        <path
          d="M337.2,361.2c1.2-1,3.2.7,2.5,2l-.5.2,1,1-.5.2c-.8-.6-2.3-1.1-3.5-2s-2.6-1.8-3.5-3c1.7-.6,3,2.8,4.5,1.5Z"
          fill="#0739dd"
        />
        <path
          d="M280.7,323.7h1.3c4.1,2.4,8.2,4.8,12.3,7.2v.8c.3,1.1-.4,1.3-2.1.5-.6-.4-1.3-.7-2-1-1.7-2-4.4-3-6.5-4.5-1.5-.6-2.7-1.4-3.5-2.5-.2-.5,0-.7.5-.5Z"
          fill="#0637e2"
        />
        <path
          d="M294.2,331.7c2.8.5,5.8,2.3,7,5-.5,0,.6,1.4-.7,1s-3.6-2.3-4.8-3-2.6-2-3.5-2.5l2-.5Z"
          fill="#083ee6"
        />
        <path
          d="M379.6,383.7c1.1,0,1.4.8,1,2.5-.6.5-1.2,1.2-2,1.5-1.2.4-3.2.5-4.5.5.6-1,2.4-.5,3.5-1.2s.7-.6.5-.7c-.3,0-.7,0-1,0-.4.2-.7.2-1,0-.2-.2-.2-.3,0-.5-.2-1.4,2.4-2.2,3.5-2Z"
          fill="#2161cc"
        />
        <path
          d="M368.6,385.2c-.3,0-.7,0-1,0-.5-1-2-1.1-2.5-1.5-1.3-1-2.6-3-4.5-3.5-.2-.2-.3-.3-.5-.5l-1-1c0,0-.4,0-.5,0v-1.2c2.9,2.5,7.6,4.9,10,7.7Z"
          fill="#0836cd"
        />
        <path
          d="M375.1,385.7c.1-.4.3-.4.5,0l.5.5c.3,0,.7,0,1,0-1.8,1.2-4.5.2-6.5,0l.5-.5c1.2,0,2.8.1,4,0Z"
          fill="#3389e5"
        />
        <path d="M360.1,379.7c-.4-.3-.7-.8-1-1l1,1Z" fill="#0c4ddf" />
        <path d="M365.1,383.7c.3.2-.5.7-1,.5s.6-.9,1-.5Z" fill="#3678e2" />
        <path
          d="M380.1,382.7c.3-1.5,1.4-1.9,3.3-1.1h.7c.1-.3.3-.3.5.1v.5c-1.1.6-1.6,2.2-2.5,3s-1,.7-1.5,1l-1.5-.5c1.3-1.2.5-1.7.5-2-.7-.5-.2-.8.5-1Z"
          fill="#2257bb"
        />
        <path
          d="M386.1,374.7c0,1.1.2,2.5,0,3.5s-1.2,2.6-1.5,3.5h-.5c-1-.4-.8-1.1.5-2-1.3-.8-.8-2.8.5-3.5-1.3-.5-1-1.4,0-2,.5-.9.8-.4,1,.5Z"
          fill="#175fc1"
        />
        <path
          d="M136.3,385.2c.5.7,0,1.2-1.5,1.5-1.4.3-2.9,1-4,2l-6.5.5v-.5c1,0,1.6-.4,2-.5l.4-1.1c2.8,0,5.3-.7,7.6-1.9.5-.6,1.8-1,2,0Z"
          fill="#3171dc"
        />
        <path d="M123.8,388.7c-.5,0-1,0-1.5,0v-.5c.5,0,1.2-.2,1.5.5Z" fill="#4679d8" />
        <path
          d="M116.3,382.7l-.5.5c-.5-.7-1.1-1.2-1.5-2-.6-1.2-.9-2.2-1-3.5,0-1.2.4-1.7,1-1.5.8.4,1.3,1.6,1.4,3.3.8,1.3,1,2.3.6,3.2Z"
          fill="#6eaaef"
        />
        <path d="M118.3,386.2c-.5-.2-.7-.6-1-1,.6.1.7.6,1,1Z" fill="#4679d8" />
        <path
          d="M121.8,385.2l.5-.6c3.3.2,6.4,0,9.5-.9.5-.8.8-1,1-.5l1.5,1.5c.4.1.4.3,0,.5,0,0-.5.9-1,1.2-3.3,1.7-3.7,1.3-7,1.8-1.1,0-2.5-.2-3.5-.5l-.5-.5h-.5c-.5-.5-1-1-1.5-1.5-.7-.2-2.6-1.7-3-2.5,1.4,0,2.9.6,4.5,2Z"
          fill="#1969df"
        />
        <path
          d="M118.8,370.2c1.2.4.5,2.2-.5,2.5l.2.3c-2.9,4.7-.4,7.8,2.8,11.1,1.3-.2,1.5.1.5,1-1.8-.2-3.1-.9-4.5-2s-.8-.3-1-.5c-1-1.2-2-4.9-2-6.5-.8,0-.7-.8,0-1l2-3c-.8-.6.5-2.5,1.5-2,.6-.7.9-1,1,0Z"
          fill="#1646d1"
        />
        <path
          d="M120.3,385.7c.9.3,2.9.3,4,.5v.5c-.8-.5-2.3.5-2.5.5-.8,0-4.1-1.8-1.5-1.5Z"
          fill="#4679d8"
        />
        <path d="M122.8,387.7c-.2,0-.4-.3-.5-.5l.5.5Z" fill="#4679d8" />
        <path
          d="M282.2,290.3c.4,2.3.5,4.6.5,7,.5,1.9.8,4.3.5,6.2,1,3.4,1.3,7.2,1,11.3l-1,.7c1.6.2,2.2,5.6,1,6.7-.6.1-1.1-.4-1.5-1.5-1.5-.4-1.4-1.5,0-2l-.5-4.2c0-2-.3-4.1-.5-6.1-.7,3.5-1.2,7.2-1.5,10.9,1.4.4,1.3,1.4,0,2l-.5,1.5c.4.1.4.3,0,.5-.1.4-.3.4-.5,0-.2-1.5.5-2.8.5-4.2.1-8.1,0-16.2,0-24.3l.5-9.9c1.8-2.4,1.8,2.5,1.7,4.1l.3,1.2Z"
          fill="#0350f6"
        />
        <path
          d="M281.7,254.8c.2,11.7.4,23.5.5,35.5,0,0-.4-.6-.5-1.2-.2-1.4.7-3.6-1-4.3l-1,10c0-2.2,0-4.3,0-6.5-.8-1-.8-3,0-4-.3-.8-.3-1.4,0-2l.5-1c-.5-.4-.4-1,0-1.5-.4-2.1-.4-4.4,0-6.5-.7-1-.7-2,0-3-.2-.1-.2-.3,0-.5-.7-.5-.7-1,0-1.5-.2-.1-.2-.3,0-.5-.4,0-.4-.3,0-.5.4-2.5.5-5,0-7.5-.4-.3-.3-.6,0-1-.2-1.5-.5-3-1-4.5-.6.7-.8.2-1-.5-1-3.6,2.5-.8,3.5,1Z"
          fill="#0161f5"
        />
        <path
          d="M280.2,259.8c.5,2.5.4,5,0,7.5,0,.2,0,.3,0,.5-.2.2-.2.4,0,.5,0,.5,0,1,0,1.5-.2.2-.2.4,0,.5,0,1,0,2,0,3-.2,2.2-.4,4.4-.5,6.5-.2,1.4-.2,2.9,0,4.5,0,1.3,0,2.7,0,4-.7,1-.9,2.8-1,4-.3,0-.5,0-.5-.2-.2-2.2,0-4.9,0-7.2.1-4,.5-8.1,1-12.2-.7-1-.7-2.3,0-4l-.5-.5c.6-3.3.7-6.3.3-9l.6-.5c.1-.4.3-.4.5,0,0,.3,0,.7,0,1Z"
          fill="#1277fc"
        />
        <path
          d="M277.7,294.8c.7,1.5.7,3,0,4.5.7.5.7,1,0,1.5.4,3.2.4,6.3,0,9.5.4,4.6.4,9.2,0,14,0,.3,0,.7,0,1-1.3.9-1.6-.2-.5-1-1.5-.6-1.4-2.4,0-3-1.1-3.9-1.2-8,0-12-1-1.1-1-2.4,0-3.5-.8-1.5-.9-3.1-.2-4.7-1.4-4.6-.6-9.6.2-14.2.1-.4.3-.4.5,0,.8,2.4.8,5.6,0,8Z"
          fill="#0f57e2"
        />
        <path
          d="M278.7,292.3c0,1.3,0,2.7,0,4-.4.5-.8,0-1-1.5,0-2.7,0-5.3,0-8-.4-.5-.4-1.5,0-2,.2-3.9.4-7.8.7-11.8l.8-.2c0,2.3,0,4.4-.5,6.7v12.8Z"
          fill="#278dfc"
        />
        <path
          d="M277.7,324.2c.3-4.5,0-9.4,0-14,.4-3.1.4-6.4,0-9.5,0-.5,0-1,0-1.5.1-1.2.4-1.7,1-1.5,0,3.7,0,7.5,0,11.3l-1,15.2Z"
          fill="#2384fd"
        />
        <path d="M278.7,296.3c0,.5,0,1,0,1.5l-1,1.5c0-1.5,0-3,0-4.5l1,1.5Z" fill="#328cfd" />
        <path
          d="M280.2,324.2c.6.5,2.6,1.9,3.5,2.5-1.5-.3-4.3-2-4.5-3.5h.5c1.2,0,1.2,0,.5,1Z"
          fill="#0245f1"
        />
        <path
          d="M333.2,356.7c1,0,2,.4,3,1.5,5.8,3.3,11.8,7.3,16.5,12l.5.5c.7.7.4,1-.5.5-.5.3-1.2.1-2-.5-.7-.5-1.3-1-2-1.5-2.9-2.1-6.1-3.9-9-6s-1.6-1.4-2.5-2c-1.4-1-3.1-1.9-4.5-3-4.4-2.9-4.3-4.8.5-1.5Z"
          fill="#041dc2"
        />
        <path
          d="M282.7,323.2l.5.5c.6-.9,1.3-.5,1,.5l1,1c.1-.4.3-.4.5,0l.5.5c1.4-.5,2.9.1,4.5,2,1.6.8,3.1,1.8,4.5,3,2.2.3,4.4,2,6,3.5,1.8,1,3.1,2.2,4,3.5.5,1-.1.8-1,.5-.9-.6-2.3-1-3-1.5-2.3-1.6-4.6-3.4-7-5-4.7-3.3-4.7-3.1-9.9-5.4s-2.1-2.1-3.6-2.6c-.5-1.7,1.6-2.2,2-.5Z"
          fill="#0521d2"
        />
        <path
          d="M305.2,337.7c.8-.4,2.3.8,3,1.5,4.8,2.9,9.5,6,14.2,9.3l.3,1.2c2,.8,1.5,2.1-.5,1-6-4.1-12-8.4-18-12.5l1-.5Z"
          fill="#031cc6"
        />
        <path
          d="M323.7,349.7c3.8,1.8,6.9,4.1,9.5,7-1.1-.5-2.3-1.3-3.5-1.5.8,1.1,2,2.1,3,3-3.6-2.3-7-5.1-10.5-7.5,1.3,0,1.1,0,.5-1,.2-1.3.6-1.2,1,0Z"
          fill="#0524cd"
        />
        <path
          d="M357.2,373.2c2.6.7,5.4,2.2,7,4.5,1.3-1.1,3,1.1,3.5,2.3l2,1.7c1.2-.7,1.8.4,1.5,1.5.5.9,0,1-1.5.5-4.3-2-9.7-6-13.5-9-1.5-1-2.6-2.2-3.5-3.5l.5-.5,4,2.5Z"
          fill="#0420c6"
        />
        <path
          d="M380.1,382.7c0,.3-.5.7-.5,1-.9.5-2.6,1.8-3.5,2-.2.3-.3.3-.5,0-.2,0-.3,0-.5,0l-.3-.4c-2.4.4-3.4-.8-5.2-1.6.5.3,1.4-.5,1.5-.5.6-1.6,4.4-.5,5.5.5,0-.9,1.6-1.4,2-.5l.5-.5c.2-.4.3-.4.5,0,.1-.4.3-.4.5,0Z"
          fill="#103bb3"
        />
        <path
          d="M352.7,371.2c1.4.7,2.5,2.7,3.5,3.5-2-1.1-3.7-2.6-5.5-4,.6.2,1.5.2,2,.5Z"
          fill="#092dcc"
        />
        <path d="M376.1,386.2c-.2,0-.4-.3-.5-.5.2,0,.4,0,.5,0v.5Z" fill="#3678e2" />
        <path
          d="M367.1,323.2c1,.7,2,3.4,1.5,4.5l.5.5c.4.2.4.3,0,.5l.5.5c2.4,3.9,4.2,8.4,5,13l.5.5c.4,0,.4.3,0,.5l.5.5c2.9,5.6,5.4,11.4,7.5,17.5-.1.4,0,1,0,1.5h-.5c-.4-.9,1,1.1,0,1.5v.5c-1.8.6-2.2-2.7-2-4l-1-1v-.5c-1.1-.1-2-3-1.5-4-2.8-3.4-4.3-7-4.5-11,.1-.4.3-.4.5,0q.2.2,0,0c-2.1-4.8-4.2-9.6-6-14.5-.1.4-.3.4-.5,0-1.1-.2-1.3-.7-.5-1.5l-1.5-3c-.4-.1-.4-.3,0-.5-1.3-1.4-2-2.8-2-4.4-1.3-.5-1.6-1.7-.5-2.6q.2-.2,0,0c-1,.2-1.2-.3-.5-1-.4-1.4,0-1.7,1-1,.9,0,1.8,2.1,2.2,3.2s1.3,3,1.3,4.3Z"
          fill="#a5ecf6"
        />
        <path
          d="M383.1,362.7c1.4,2,1.7,3.9,2.5,6l.5,1c0,.2,0,.3,0,.5l.5,1c0,.2,0,.3,0,.5.3.9,0,1.2-.5,1-1.3.3-1.1-1.6-.8-1.6s.2,1.6-.7.6c-1.1-1.5-1.5-2.8-1-4,0-.3,0-.6,0-1-.4-.6-.8-1.4-1-2.5-.1-.8-.6-1.6-.5-2.5.5-.1.6.5,1,1Z"
          fill="#b7e6f5"
        />
        <path
          d="M380.1,364.2c2,.8,3.5,4.9,3.5,7,.8.5,1.6,1,2.5,1.5,0,.3,0,.7,0,1s0,.7,0,1c-.3-.2-.7-.3-1-.5-.8.7-1.3.6-1.2-.4l-1.2-1.6c-1.6-.2-3.1-3-2.5-4.5-1.4-1.4-1.7-2.6-1-3.5-.2-.7-.2-.8.5-.5.2-.3.4,0,.5.5Z"
          fill="#246eef"
        />
        <path
          d="M384.1,381.7c-1.1,2-4.7,4.4-2,0-.9-.2-1.3.7-2,1s-.3,0-.5,0c-1-.7,0-3.2,1.5-2.5,1.5-1,2.7-1.2,3.5-.5-.2.6-.3,1.6-.5,2Z"
          fill="#1947ac"
        />
        <path
          d="M379.1,370.2c1.4,0,2.4.9,3,2.8l.5-.8c.9.6,1.6,1.4,2.5,2,.5.8,0,1.4,0,2-.4,1.2-.7,1.7-2,1.5-.3,1.4-1,2.1-2,2-2-.3-.5-4.5-.3-3.3s-.3.3-.7-.2c-.9-.5-1.3-1.5-1.4-2.9-1-1.7-1.2-3-.6-4.1.5-.4.8,0,1,1Z"
          fill="#173bcb"
        />
        <path
          d="M381.1,379.7l1.8-4c.4,1.5,1.1,1.1,2.2.5-.1,1.5,0,2-.5,3.5l-3.3,1.5-.2-1c-.4-.2-.4-.3,0-.5Z"
          fill="#133bb2"
        />
        <path
          d="M148.3,376.7c-1.5,1.5-3.3,2.8-5,4s-4.7,3-7,4.5c-.6.1-1.6-.2-2,0v-.5c-.6-1.4,1.2-1.6,2-1,3.6-2.9,7.4-5.4,11.5-7.5l.5.5Z"
          fill="#3065e7"
        />
        <path
          d="M118.8,363.2c.3.2.3.3,0,.5l-.5.5c.4.2.4.3,0,.5l-.5,1c.4.5,0,1.3-.5,1.5.4,1.9-.3,3.7-2,4.5l-.5.5c.3.8-.4,1.8-1,2.5-.1.3-.3.3-.5,0,0-.8.3-2.2.5-3,.8-2.6,3.1-6.3,4-9,.9-.9,1-.8,1,.5Z"
          fill="#3aa2eb"
        />
        <path
          d="M114.3,375.2c0,.3,0,.7,0,1l-1,1.5c0-.7,0-1.7,0-2.5.1-.3.3-.3.5,0,.2-.4.3-.4.5,0Z"
          fill="#97cbf7"
        />
        <path d="M113.8,375.2h-.5c0-.2,0-.3,0-.5h.5c.4.1.4.3,0,.5Z" fill="#95c8f2" />
        <path
          d="M155.8,365.2c.8-.7,1.4-.2.8.7-3,2.6-6.3,4.8-9.6,6.9,0,0,1.3-1.1,1.8-.6,1-.4,1.4-.3,1,.5v.7c-2.5,1.4-4.8,3-7,4.8-.2,1.5-2,2.8-3.5,2.5l-4.8,3.2-1.7-.7c-.3.2-.7.3-1,.5-.4-.1-.4-.4,0-1-.6-1.2,1.2-3.3,2.5-2.5l.2-1.4,8.4-6.1h1.4c2.3-1.6,4.7-3.3,7-4.9.1-.4.3-.4.5,0l1-1c.4-.9,2.2-2.2,3-1.5Z"
          fill="#042ecf"
        />
        <path
          d="M131.8,383.7c-3.1,1.8-6.4,1.9-10,1.5-.2-.2-.3-.9-.5-1-.7-.9-.4-1.1.5-.5.4-1.4,1.8-1.3,2,0l1.9-.2c1.1-.8,2.1-.7,3.1.2,0-1.3,1.3-1.6,2-.5l.5-.5c.1-.4.3-.4.5,0l.5.2-.5.8Z"
          fill="#0a2db5"
        />
        <path
          d="M139.3,380.7l.2.7c-1.2.7-2.2,1.4-3.2,2.3-.3.2-1.5.7-2,1-1,.5-1.6,1.4-3,1l1.5-2.5c.7-.5,1-2.3,1.7,0,1.3-1.4,3-1.9,4.8-2.5Z"
          fill="#0637d4"
        />
        <path
          d="M127.8,353.2c.4.1.4.3,0,.5-.1.6,0,1,.7,1.3.2.4-2.3,7.2-3.7,6.7-.8,3.7-3,8-5,11.5s-.6.4-1,.5c-.6.1-.7-.2-.5-1,.6-1,.3-2.1.5-2.5-.5-.5-.2-1.1.5-1l.5-.5c1.5-6,4.5-11.6,7.5-17,1.1-.7.8.6.5,1.5Z"
          fill="#0537df"
        />
        <path
          d="M118.8,373.7c.4.1.4.3,0,.5.2,1,0,1.7-.5,2.5,1.2.6,1.8,2.9,1,4,1.3.5,3.1,1.6,2.5,3-.2,0-.6.2-.5.5-1.8-1.3-4.3-2.8-4.9-5.4-.9-4.1.6-3.8,1.9-6.1.5.1.5.5.5,1Z"
          fill="#0d31c3"
        />
        <path
          d="M119.3,366.7c.8,1-.6,3-1.5,3.5,0,.2-1.1,1.4-1.5,2l-2,3c0,0-.3,0-.5,0v-.5c0-.9.6-1.7,1-2.5l.5-.5c.7-1.5,1.4-3,2-4.5.7-1.2,1.4-2.5,2-4l.5-.5c.2-.3.3-.3.5,0,.1,1.2-.2,2.5-1,4Z"
          fill="#97dafa"
        />
        <path
          d="M127.3,351.7c-2.5,5.7-5,11.3-7.5,17l-.5.5c-.1.3-.3.7-.5,1h-1c.4-.9,1.1-2.5,1.5-3.5,1.9-4.8,4-9.5,6.1-14.2,0-2.4,2-3.9,1.9-.8Z"
          fill="#1562ea"
        />
        <path d="M114.3,375.2c.2-1.2,1-2.4,2-3-.6,1-1,2.3-2,3Z" fill="#95c8f2" />
        <path
          d="M286.2,295.8c-.5,7.8-.6,15.6-.5,23.5,1.1.2,1.5,1,1,2-.6.5-.4,1,.4,1.5l-.4,1c-.6,1.3-2.4.2-2-1l-.5-.5-1-6.7v-12c0-1.4-.4-4.5-.5-6.2-.2-2.2-.2-4.4,0-6.5,1.1,1,1.5,2.6,1.4,4.7.7-7.2,1.3-14.4,1.6-21.7-1.3-2.6-1.4-5.4,0-8v-1c-1-2.7-1-5.3,0-8,1.1-.9,1.5,0,1.6,1.3.5,12.5.1,25.1-1.1,37.7Z"
          fill="#1995fc"
        />
        <path
          d="M284.7,248.3l-1.6,1.4c-.2,6.2-.5,12.4-.8,18.6.9,7,1.2,14.1,1.1,21.1l-.6,1.4v6.5c-.2-2.2-.3-4.7-.5-7-.3-6.5-.5-13.1-.5-19.6s-.3-10.6,0-15.8c-1.1-.6-1.3-1.9,0-2.3.5-4.1.9-8,1.1-11.7,2.1.3,3.6,6.2,2,7.5Z"
          fill="#046ef5"
        />
        <path
          d="M282.7,318.8c.1.6-.1,1.4,0,2,.4,1.1.9,1.6,2,2,.6.3,1.2,1,2,1,.5-.1.6,0,.5.5l.5.5c.1-.4.3-.4.5,0,1.5.8,2.3,1.6,2.5,2.5v.5c-1.8-1.1-2.9-1.2-4.5-2l-.5-.5c-.1,0-.4,0-.5,0l-1-1c-.3-.2-.7-.4-1-.5l-.5-.5c-1-.2-1.2,0-2,.5s-.3.3-.5.5c-.5-.4-.4-.4-.5-1s0-.3,0-.5l.5-1.5c0-.6,0-1.4,0-2l.5-5.4c-.6-5.2,2.4-4.2,1.5.5l.5,4.4Z"
          fill="#0136e8"
        />
        <path
          d="M282.7,318.8c-.2-1.3-.8-2.9-1-4.3s1.3-3.1-1-3.2c1,2.5-.2,5.5-.5,8,0-6.2.6-12.4,1.5-18.5l1,5.2v12.7Z"
          fill="#0245f1"
        />
        <path d="M284.2,322.2c.2.2.3.3.5.5-1.2-.5-1.3.9-2-2,.4.6,1,1,1.5,1.5Z" fill="#0245f1" />
        <path d="M279.7,322.7c0-1.1.5-1.4.5-1.5l-.5,1.5Z" fill="#0245f1" />
        <path
          d="M276.7,231.8l.5.5c1.5-.7,4,2.1,3,3.5.2.6.5,1.1,1,1.5,1.5-.5,2.6,2.4,1.5,3.5,0,1.6.7,3.1.5,4.8-.2,2.6-1.3,6.3-1.5,9.2-1.1,1.5-3.3-4.3-3.5-1,.7.5.9,1.7,0,2,.9,1.3,1.2,3.4,0,4.5.7.5.7,1,0,1.5-2.1-.7-2.1-5.7-.8-7.2,0-1.2,0-2.3.3-3.3-.4-.1-.3-1.1,0-1.5.8-.1,1.8.3,3,1.4.1-1.7.4-3.4,1-4.9,0-2.2,0-4.6-.9-6.7l-6.3-7.8.2-1c.1-.4.3-.4.5,0,1.3-.7,1.7-.4,1.5,1Z"
          fill="#0254f7"
        />
        <path d="M280.2,267.3c0-2.5,0-5,0-7.5.8,1.8.8,5.5,0,7.5Z" fill="#046ef5" />
        <path
          d="M280.2,279.8c-.1.4-.3.4-.5,0,0-2.1-.5-4.8.5-6.5,0,2.2,0,4.3,0,6.5Z"
          fill="#046ef5"
        />
        <path
          d="M280.2,281.3l-.5,1c.2,1.5,0,1.2,0,2-1.2-1.5,0-3.1,0-4.5h.5c0,.5,0,1,0,1.5Z"
          fill="#1069fb"
        />
        <path
          d="M280.2,258.8h-.5c-.4-.1-.4-.3,0-.5-.7-1.8-.8-3.1-.5-4,1.5,1.6.9,2.6,1,4.5Z"
          fill="#046ef5"
        />
        <path
          d="M279.2,254.3l.5,4c-.6-.3-1.1-1.1-1.5-2.5,0-.7,0-1.3,0-2,.5,0,.7.2,1,.5Z"
          fill="#1277fc"
        />
        <path d="M279.7,282.3c0-.3,0-1,.5-1,0,.4,0,.9-.5,1Z" fill="#046ef5" />
        <path d="M280.2,270.3l-.5-.2.5-.2c0,.2,0,.3,0,.5Z" fill="#046ef5" />
        <path d="M280.2,268.3l-.5-.2.5-.2c0,.2,0,.3,0,.5Z" fill="#046ef5" />
        <path
          d="M278.2,255.8c.9-.6,1.4,1.5,1.5,2.5s0,.3,0,.5c.3,3,.1,7.1-.5,10-.6,5.7-1.9,1.3-1-3-1.3-1.2-1.3-2.3,0-3.5.9-2.3,1.1-2.8.6-1.6l-.6-.4c0-1.5,0-3,0-4.5Z"
          fill="#2895fa"
        />
        <path
          d="M278.2,265.8c0,1.8,0,3.7,0,5.5.5,0,.9-2,1-2.5,0,1.3,0,2.7,0,4-1.3,3.5-.8,7.2-1,10.8s-.5,1.1-.5,1.2c-.5-4-.3-8,0-12-.4-2.3-.4-4.7,0-7,.1-.4.3-.4.5,0Z"
          fill="#2f8af8"
        />
        <path d="M277.7,310.3c0-3.2,0-6.3,0-9.5.8,2.7.8,6.8,0,9.5Z" fill="#328cfd" />
        <path
          d="M341.2,360.7c1.5-.2,2.6.5,3,2,5.5,3,10.7,6.4,15.6,10.2,2.1.2,6.2,2.8,4.3,4.8-2.2-1.6-4.8-2.9-7-4.5l-4.5-3c-5.3-3.7-11.2-8.6-16.5-12h.5l.6-.3,3.9,2.8Z"
          fill="#3083f7"
        />
        <path
          d="M336.7,358.2h-.5c-.7-.4-2.2-1.1-3-1.5l-9.5-7c.3-.3.6-.5.7-.4,2.7,1.1,10.5,6,12.2,8.1s.1.5,0,.8Z"
          fill="#2b8dfa"
        />
        <path d="M357.2,373.2c-1.2-.8-2.7-1.6-4-2.5s-.3-.4-.5-.5l4.5,3Z" fill="#092dcc" />
        <path
          d="M290.7,325.7c2.6.9,5.1,2.4,7.3,4.4,2.1,1,3.7,2.4,4.7,4.1.6.4.7.7.5,1-.7,0-1.4-.3-2-1-2-1.2-4-2.3-6-3.5-1.6-1.1-3.1-2.3-4.5-3.5-.9-.7-1.9-1.4-2.5-2.5.8-1.2,2.5-.3,2.5,1Z"
          fill="#2c97fa"
        />
        <path
          d="M303.2,335.2c1.8.4,4,2,5,3.5.2.2.2.3,0,.5-.6-.5-2.2-.9-3-1.5-1.2-.9-3-2.3-4-3.5.5.3,1.3.6,2,1Z"
          fill="#268bfa"
        />
        <path d="M295.2,330.7c-1.6-1-3-2.1-4.5-3v-.5c1.5,1.2,3.3,2.1,4.5,3.5Z" fill="#0637e2" />
        <path d="M284.2,324.2c1.5.8.9,1,1,1l-1-1Z" fill="#0637e2" />
        <path d="M286.2,325.7l-.5-.5c.2.2.5.5.5.5Z" fill="#0637e2" />
        <path d="M283.2,323.7l-.5-.5c.4,0,.5.5.5.5Z" fill="#0637e2" />
        <path
          d="M314.2,342.2c5.4,2.5,10.7,5.3,15.6,8.7s1.5,1.4,1.9,2.3c.6-1.1,3,.4,3,1.5l6.7,5.3-.2.7c-1.2-.8-3.2-1.6-4.5-2.5-4.7-3.3-7.3-6.7-13-8.5s-.8,0-1,0c-2.7-1-11.4-8.3-14.5-10.5v-.5c2.2.7,4.2,1.9,6,3.5Z"
          fill="#3296fc"
        />
        <path
          d="M368.6,376.2c1.8-.8,4.3.2,5,2,1.1.4,2.3.6,3.5.5.1-.4.3-.4.5,0,1.8-1.6,2.4,2,1.5,3.3-1.1.4-2,.9-2.5,1.7-2.7.5-3.6-.5-5.5-.5-.8-.3-1-1-1.5-1.5-2.3-1.2-3.1-2.6-2.4-4.1-2.6-1.1-3.8-2.5-3.6-4.1,1.7.5,3.4,1.4,4.9,2.6Z"
          fill="#4c9bf4"
        />
        <path
          d="M344.2,362.7c.4-.3.8-.6,1.3-.6,1.1,0,13.3,7.6,14.6,9s.6,1.4.5,1.4c-.2,0-.9-1.9,0-1.8,3.1.2,6.7,2.6,8,5.5-1.3-.6-2-1.2-3-1.7s-1.6-.7-1.5.2c1,.3,4.6,2.3,4.4,3.2s-1,.9-.9,1.5,1.6,1.8,2,2.3c-2.2-.6-3.8-2.8-5.5-4-1.1-3.6-3.4-3.3-5.9-4.8-4.3-2.6-9.9-7.4-14.1-10.2Z"
          fill="#3996f7"
        />
        <path
          d="M381.1,379.7c0,.2,0,.4,0,.5,0,.4-1.4,1.7-1.5,2.5-.1,0-.4,0-.5,0l-.5.5c-.6.2-1.4.4-2,.5l-.7-1c5.7-1.8,1.9-2.2,1.8-2.7s2.2-1.4,0-1.2c-.2-1.4,1-3.1,2.5-2.5.1-.1.9-.6,1-.5-.1,1.3.2,2.8,0,4Z"
          fill="#4294ef"
        />
        <path d="M378.6,383.2l.5-.5c-.2,0-.3.5-.5.5Z" fill="#1947ac" />
        <path
          d="M356.2,301.3c.2-3.4,2.7,2.2,2.8,3.8l.7,1.2c.1-.4.3-.4.5,0,1,.1.9,1.1,0,1.5.8,2.8,1.8,5.4,2.8,8.1l-.3.9c.2.4.4.7.5,1,.2.6.3,1.4.5,2l1-1.5c.2,1.5,1.4,2.7-.5,2.2,1,1.2,1.1,2.8,1.5,4.3-.6.7-1.3-.8-1.5-1.5s2.4,4.3,1,4.5c-1-.5-1.6-1.6-2-3.5-1.7-4.1-3.5-8.3-5.2-12.4l.2-1.1c.6-.4.6-.8.4-1.4l-3.1-7.2.8-.9Z"
          fill="#bbf6fb"
        />
        <path
          d="M379.6,359.7l1,1c.8,1.3,1.1,2.8,2,4,.6.6.8,1.8.5,2.5.5-.3.7,0,.5.5.5,1.3,1.4,2.3,1,4-.3.3-.6.2-1-.5-1.4-2.2-2.3-4.7-3.5-7-.5-.7-.5-1.2,0-1.5-.9-1.5-1.1-2.7-.5-3.5v.5Z"
          fill="#d4edfc"
        />
        <path
          d="M372.6,341.7c.4.2.4.3,0,.5l.5.5c.5.3.7,1,.5,1.5,1.4,3.8,2.8,7.4,4.5,11-.7.7-1.3-1.4-1.2-1.4s1,1.9.2,1.9c-.9,0-1.4-.9-1.5-2.5-.2,0-.4-.1-.4-.2-.9-1.7-3.4-6.7-3.6-8.2s.2-.3.6-.5c-.8-1.7-1.7-5.2.5-2.5Z"
          fill="#bbf6fd"
        />
        <path
          d="M365.6,324.7c0,.2,0,.3,0,.5l1.5,3c.2.5.3,1,.5,1.5.2.2.4.5.5,1,.4.1.4.3,0,.5l.5,1c.4.2.4.3,0,.5l.5,1.5c.3.1.3.3,0,.5l.5.5c1,1.5,0,3.1-.5,1-1.1-1.5-1.9-3.2-2.5-5-1.3.2-2.4-2.7-1.5-3.5l-1-4.5,1.5,1.5Z"
          fill="#c4f8fc"
        />
        <path
          d="M374.1,344.2h-.5c-.2-.5-.2-1-.5-1.5l-.5-.5c0-.2,0-.4,0-.5-1.9-1.1-2.8-4.1-2.8-6.2l-.7-1.8c-.2-.2-.4-.5-.5-1,0-.2,0-.3,0-.5l-.5-1c0-.2,0-.3,0-.5-.2-.3-.3-.7,0-1,2.5,4.5,4.3,9.7,6,14.5Z"
          fill="#9becf8"
        />
        <path d="M374.1,344.2c.2-.2.8.5.2.5s-.4-.4-.2-.5Z" fill="#9becf8" />
        <path
          d="M378.1,355.2c.5,1,1.2,2.9,1.5,4s.3,2.4.5,3.5c-1.6-1.2-3-5-3-7-.2-.8-.5-1.6-.5-2.5h.5c-.1.9.8,1.5,1,2Z"
          fill="#c8f1fb"
        />
        <path d="M367.1,328.2c-.8-.7-1.2-2-1.5-3,1.2.5,1.1,2,1.5,3Z" fill="#bbf6fb" />
        <path d="M368.1,330.7c-.5-.2-.4-.6-.5-1h.5c0,.3,0,.7,0,1Z" fill="#b4f7fc" />
        <path d="M380.6,360.7l-1-1c.5.2.7.6,1,1Z" fill="#c8f1fb" />
        <path
          d="M386.1,372.7c0,0-1.2.5-1.3.5-.5,0-1-1.5-1.2-2,.3.1.7.6,1,.5.6-.1.2-1.2,1-1,0,.5.7,1.7.5,2Z"
          fill="#a4ddf4"
        />
        <path
          d="M383.6,366.7c.4.5.1.7-.5.5-.3-.8-.3-1.7-.5-2.5s0-.3,0-.5c.8.6.7,1.6,1,2.5Z"
          fill="#97e0f6"
        />
        <path d="M383.6,367.7c0-.2-.4-.3-.5-.5l.5-.5c0,.1.5.3.5.7l-.5.3Z" fill="#a4ddf4" />
        <path
          d="M369.6,346.7c-.4-1.2.3-1.8,1.1-.8l2.4,5.3c2.5,3.9,4.6,8.5,6,13,.5,1,.9,2.4,1,3.5-.5,0-1-.2-1.5-.5-.4,0-.7,0-.7,0-1.5-2.6-4.9-9.2-5.6-11.8s.1-.4.4-.6v-.5l-.5-.5c-.8-.1-.9-.9,0-1l-.5-.5c-.4-.2-.4-.3,0-.5l-.5-.5c-1.1-.1-1.1-.8,0-1l-.5-.5c-.4-.2-.4-.3,0-.5l-.5-.5c-.4-.1-.4-.3,0-.5l-.5-1v-.5Z"
          fill="#0c3ae2"
        />
        <path
          d="M378.6,367.2l.3-.5c.8-.2.8.4,1.2,1,1.1,1.4,1.8,2.9,2.5,4.5s1.2,2.2,1,2.5c-2.8,0-1.4-.1-2.5-1.8s-1.3-1.9-2-2.7c-.6-.8-.6-1.3,0-1.5l-.5-.5c-.8,0-.9-.8,0-1Z"
          fill="#0e35d0"
        />
        <path
          d="M375.6,354.7c.6,0,.7.4.5,1l.5,1c1.3,2,2.5,4.7,3,7l-.5.5c-2-4.3-4.3-8.5-6-13-1-1.4-1.4-2.5-1-3.5.3,0,.5,0,.7.1.9.8,2.4,5.5,2.8,6.9Z"
          fill="#1157ee"
        />
        <path
          d="M377.1,355.7c.6,2.2,1.6,5.2,3,7,0,.4,0,1,0,1.5,0-.2-.4-.3-.5-.5-1.2-2.3-1.9-4.7-3-7l-.5-1c-.1-.3-.3-.7-.5-1-.3-.7-.3-1.2,0-1.5.4.8.9,1.9,1.5,2.5Z"
          fill="#2476f5"
        />
        <path
          d="M237.7,105.4c.6-1,1.7-1.6,3.2-1.8.4-3.2,4.4-3.9,7.1-4.3,2.1.8,4.1,1.8,6,3.1,4.4-2.8,7.8-.7,8.8,3.9,2.9,3.1,4.8,6.6,5.6,10.4l3,3c.3,1.5.7,2.7,1.3,3.7.3-.2.5-.3.7-.2.7.3,3.6,8.4,3.8,9.7,5.8,13.6,12.3,28.4,18.5,42.5,4.2,6.1,7.4,13.3,9,20.5.3.7.3,1.2,0,1.5l.5,1c2.7,5.4,5.2,10.9,7.5,16.5,1.2,1.6,2.2,3.5,2.5,5.5,3.2,6.7,6.4,13.5,9,20.5,1.6.1,2.1,1.3,1,2.5l1.9,3.4-.4.6c.8,1.3,1.3,2.4,1.5,3.5l2.8,6.4c1.4,0,2.2,1.9,1.2,3,2.5,2.6,4.4,6.8,4.5,10.5.9,2.7,2.4,5,3.9,7.3l-.5,1.2c.5,1.1.9,2.1,1,3l2.9,6.3c1,.8,1.8,1.9,1.1,3.2l1.8,3.9c1.6,2.3,3.4,5.3,3.2,8.1,1.9,3.5,3.7,7.2,5.2,10.9l-.2,2.1c2.6,3.2,4.1,6.7,4.5,10.5,2.6,3.4,4.7,8.1,5,12.5l.5,1c1.6,1.4,2.7,3.4,3.2,5.9,1.4,2.1,2.1,4.1,2.3,6.1,2.9,5,5.5,10.3,7.6,15.7v.8c.8,2.2,2,4.5,1.9,7-.7.6-1.4,1.9-2.5,2.5s-.3,0-.5,0c-1.2.1-2.4,0-3.5-.5-1.6-.6-3.4-1.3-5-2-2.6-1.9-5.3-3.7-8-5.5-6-3.1-12.3-6.6-17-11.5l-.5-.5c-.4,0-.9,0-1.5-.5-2.6-.9-6-3.2-8.3-5.1s-.2-.5-.2-.9c-2.5-.9-7.6-3.4-9.7-5.3l-.3-1.2c-9.4-5.2-18.4-11.3-27.2-17.4-.6-.4-1-.9-1.5-1.4s-.9-1.1-1.3-1.7l-.5-.5c0,.4-.2.4-1,0-1.5.3-5.4-1.6-5-3.5-1.3-1.1-.7-.7-1-2,0-7.5,0-15.7.5-23.5,0-12.1.2-24.2,0-36.2,0-.8.3-2.2-.5-2.7-1.5-.3-1.3-4.2-.2-4.7l-.3-2.3c-.8.3-.9-.4-.5-1-.3-.1-.3-.3,0-.5-.5-3.3-.8-4.4-2-7.5s-1-2.7-1.5-3.5c-.5-.4-.8-.9-1-1.5-.6-.8-2.2-2.7-3-3.5l-.5-.5c-.4-.4-1-.6-1.5-1-.4-.1-.4-.3,0-.5l-.5-.5c-3.2-1.2-6.4-2.4-9.5-3.5-.8-.6-1.8-1-3-1-.3,1.2-.7,1.2-1,0l1.1-1.4,9.2-4.4,1.7.3.5-.5c.1-.4.3-.4.5,0l.5-.5c1-1.9,2.3-3.8,4-5.7,2-2.2,2.6-4.2,1.7-6,1.7-3.4,2.4-6.8,2.4-10.2-.4-.2-.4-.3,0-.5.7-7.8-1.1-14.9-5.5-21.5-1-.2-2.8-2-2-3l-2.5-2.5h-1.1c-10.4-8.1-24.8-10.1-36.8-4.3l-1.1-.2-2,1c.4.9-.8,1.7-1.5,1l-2,1.5c.2.3.3.5.2.6-.9,1.1-2.6,2.5-3.7,3.4-.1.4-.3.4-.5,0l-.5.5c-1.8,3.2-3.4,6.7-4.7,10.3l-.8.2-.5,1.5c.5.3.6.6.6,1.1,0,5,.4,9.1,3,13.6l-.6,1.3c.7,1,.7,1.5,0,1.5-1.1.5-1.5,0-1.8-1-.3-2.1-1-3.6-2.1-4.5-.1,1-.4,1.6-1,2-3.5.4-1.8-5-1-7.3-2.6-2-3-4.8-3.2-7.8-1.8-.2-2.2-1.7-1.3-4.6-.8-.3-1.3-.8-1.5-1.6-1.7.6-3,0-3.5-1.7-.2-.4-.3-.8-.2-1.1,1-3,2.4-6.4,4.2-8.9.9-2.2,1.9-4.4,3-6.5,1-4.9,3.5-9.6,6-14l1-2c-.4-.9.3-1.9,1-2.5l1-2.5c-.4-2.3,8-19.6,7.8-18.6s-.5.5-.8.6c-1.9-1.2.4-5.4,2.5-5l1.8-2.2c.4-3,1.5-8.3,5.2-7.8Z"
          fill="url(#d)"
        />
        <path
          d="M372.6,354.7c1,1.1,5.1,10.4,6,12.5s0,.7,0,1l.5.5c.1.4,0,1,0,1.5-.3-.4-.7-.7-1-1-2.3-5.4-6-10.7-7.5-16.5.7,0,1.4.7,2,2Z"
          fill="#1749ec"
        />
        <path
          d="M158.3,368.7c-.5,1.2-1.5,2.2-3,3-2.5,2.2-4.3,3.3-7,5s-1.8.5-2.7,1.1c-2.6,1.6-5,4.8-8.3,4.9l-1,1c.7-.5,2.1-2.4,3-3s2.3-1.7,3.5-2.5c5-3.4,9.9-7,14.7-10.6.9-.6,1.2,0,.8,1.1Z"
          fill="#215cee"
        />
        <path
          d="M160.8,366.7c.4-.8,4.5-3.9,5.1-3.9,1.4,0,1.3,1.4,0,1.9-2.1,1-7.1,4.9-9.5,6.5l-.5.5h-.5c.5-.5,2-2.1,3-3-.2-.4,0-.6.5-.5l2-1.5Z"
          fill="#2563ed"
        />
        <path d="M155.8,371.7c.2-.2.3-.4.5-.5l-.5.5Z" fill="#215cee" />
        <path
          d="M124.8,346.2c.9.4,1,1.3.5,2.9h.5c.2.4.4.7.4,1,0,2.2-3.9,9.6-5.4,11.6-.2-.1-.2-.3,0-.5-.4-.5-.9.1-1.5,2-.1.4-.3.4-.5,0-.2,0-.8-.3-1-.5.3-.8.4-1.6.5-2.5,1.1-5,3.3-9.8,6-14,.1-.4.3-.4.5,0Z"
          fill="#94e6fa"
        />
        <path
          d="M119.3,363.2c-.6,1.7-1.2,3.5-1.5,5.2l-.5-1.2c.2-.4.3-1,.5-1.5l.5-1c0-.1,0-.4,0-.5l.5-.5v-.5c.2,0,.4,0,.5,0Z"
          fill="#b0ebfa"
        />
        <path d="M117.8,365.7c.2-.4.4-.7.5-1l-.5,1Z" fill="#94e6fa" />
        <path d="M118.3,364.2c.1-.2.2-.4.5-.5l-.5.5Z" fill="#94e6fa" />
        <path d="M114.8,372.2c.1-.2.4-.4.5-.5l-.5.5Z" fill="#95c8f2" />
        <path
          d="M153.3,362.2l.4.8c1-.7,2.1-1.2,3.1-.3-1.5,2.2-3.7,3.9-6.5,5-1.6,2-3.6,3.6-6,5-2.7,2.6-6.9,5.2-10,7.5-3.3-.8-2.1-3.4-.5-4.5l.5-1.5,14.9-10.9c1.6-1.5,3-1.9,4.1-1.1Z"
          fill="#389afa"
        />
        <path
          d="M185.3,345.7c-.2,1.9-2.8,2.9-4.5,3.5-1.1,2.1-3.7,4.1-6,4.5-7.7,6.1-16.1,12.4-24.4,18s-1,.4-1.6.5c-2.1,1.4-4.4,2.7-6.3,4.5-1.4.1-.4-.6,0-1,3.7-3.5,10.1-6.3,13.5-10s-.2-.5-.2-.5c-.4-.5-.3-.7,0-.9,1.3-1,2.6-1.8,4-2.6,0-1.4,3.3-4,4.5-3,3.3-2.8,6.8-5.3,10.5-7.5,1.3-2.7,6.1-5.6,9-6,1.2-.7,1.7-.5,1.5.5Z"
          fill="#0448e4"
        />
        <path
          d="M174.3,355.2c.4.4.3.5,0,.8-4.3,3-8.6,5.9-13,8.7-3.1,2.8-7.2,5.8-10.9,8.2s-.3,0-.6-.2l-1-.5c5.7-3.9,11-8.2,16.5-12.2,3.1-2.2,6.4-4.1,9.5-6.3,2.1-.5.8.9-.5,1.5Z"
          fill="#0228cb"
        />
        <path
          d="M133.8,375.7l.5.2c-2.2,1.5-.9,2.3,0,4.3-.7.5-1.4,1.8-2.5,2.5s-.4,0-.5,0l-.5.5c-.5.2-1.4.4-2,.5-2.5.1-1.5-1.4-.4-2.8-.8-.6-1.7-1.2-2.1-2.2-.3,1.7-3.2,1.3-3-.5,1.3-.9,3.1-1.3,5.2-1.4,2-1,3.7-1.4,5.3-1.1Z"
          fill="#449df8"
        />
        <path
          d="M160.3,366.7c-.1.7-.8,1.3-1.5,1.5-.2.2-.3.3-.5.5-.4-1.2-1.3.2-1.8.5-3.1,2.2-4.7,3.6-8,5.5s-4,2.3-5.7,3.5c1.8-2.4,4.6-3.8,7-5.5s8.5-6.9,11.5-8c.5-.3,1-.5,1.5-.5-.8.6-1.8,1.9-2.5,2.5Z"
          fill="#0c4eeb"
        />
        <path
          d="M159.8,361.7c-1.3,1.4-2.6,2-4,3.5-.9.6-2.1,1-3,1.5l-1,1c-.1,0-.3,0-.5,0-.5.4-.9.4-1,0,2.2-1.6,4.3-3.4,6.5-5-.2-1.5,2.3-2.2,3-1Z"
          fill="#2f96fa"
        />
        <path
          d="M150.3,367.7c.3,0,.7,0,1,0-1.8,2.1-4.5,3.9-7,5,1.7-1.7,3.8-3.3,6-5Z"
          fill="#308df4"
        />
        <path d="M151.8,367.7c0,0,.4-.7,1-1l-1,1Z" fill="#308df4" />
        <path
          d="M126.3,378.7c1,0,2,0,3,0l-1.5.5,2.5,1.7c.1.3-4,2-1.5,2.7-3.5.7-4.2,0-7,0-1.3-.9-1.8-1.6-2.5-3,1.3-2.1,4.6.2,5.9,1.5l.6-.3c-.8-1.7-.6-2.7.5-3.2Z"
          fill="#4f9ff8"
        />
        <path d="M130.8,383.2l.5-.5c-.2,0-.3.4-.5.5Z" fill="#042ecf" />
        <path
          d="M135.3,334.7c.4.1.4.3,0,.5l-.5,1c.4,0,.4.3,0,.5l-1,2c.4.2.4.3,0,.5l-1,2c-.2,2.2-1,4.4-2.5,6,.5,1.6-.8,5.4-2.5,6,0-1-.2-.9-.5-1.5-.9-1.7-.7-1.9,1-2.5-.8-.4-.5-1.6.5-1.5l2.6-7.6.9-.4c-.9-1.6,2.5-8.3,3-5Z"
          fill="#1069e3"
        />
        <path d="M119.3,369.2c0-.2.4-.4.5-.5l-.5.5Z" fill="#1646d1" />
        <path
          d="M119.8,375.7c.9.2,2.6,2,3.5,2.5,1.4.7,1.6.4,3,.5-.2,1.2.7,2.7.5,3.7s-2.7,1.5-3,1.3.7-1.3.5-1.5c-1.9-.3-2.5-1.7-5-1.5-.9-1.7-1-2-1-4,.2-1,.5-1.3,1-1,.1,0,.4,0,.5,0Z"
          fill="#53a4f8"
        />
        <path d="M119.3,375.7c-.3,0-.7.7-1,1,0-1.4.4-1.7.5-2.5l.5,1.5Z" fill="#1646d1" />
        <path
          d="M126.3,348.7c.7-2.7,2.1-2.4,1.4.5s-.2-1,.6,0c-.4.8-.6,1.7-1,2.5-.2-.4-.5-1.1-1-1l-.2,2-6.8,14c.5-1.3.6-2.7,1-4-.2-.4,0-.8.5-1,2.2-3.7,3.7-8.3,5-12.5-.6-.7-.4-1,.5-.5Z"
          fill="#0f68e8"
        />
        <path
          d="M120.8,361.2c-.2.7-.5,1.2-1,1.5-.1.2,0,.3-.5.5.4-1.3.4-3.3,2-4,.2.8-.3,1.4-.5,2Z"
          fill="#c6f3fb"
        />
        <path
          d="M120.8,361.7c-.1.5-.4.8-.5,1h-.5c.3-.3.4-1.2,1-1.5,0,.2,0,.3,0,.5Z"
          fill="#b0ebfa"
        />
        <path
          d="M284.2,248.8c.3,1.2.7,1.6,1,1,.9,1.9.5,4.8.5,7s0,5.3,0,8c-.2.4-.1.6,0,1,0,2.7,0,5.3,0,8-.3,2.6-.4,5.2-.2,7.8.3,1.4-.7,4.7-2.2,3.6-.4-6-.6-12-.6-17.9-.4-1.6-.4-3.4,0-5,.3-2.1.5-4.3.5-6.5-.2-1-.4-5.6.2-6.5s.5-.4.8-.5Z"
          fill="#38d0fc"
        />
        <path
          d="M282.7,267.3c.2,5.8,1.9,11.7,1,17.5,3.3-2.1.2-7.9,2-11,0,5.1.2,10.2,0,15.3s-1.7,11.4-1,17.2c-.7,0-.9-1.8-.9-2.3-.4-3.9-.8-9.2-1.1-13.2-.5-7.3-.5-15.2-.5-22.5,0-.5.2-.9.5-1Z"
          fill="#2bbcfc"
        />
        <path
          d="M285.7,319.3c-1.1-4.7-.2-9.9-.5-14.8l1-8.7c0,6.4.1,12.9,0,19.2s-.5,2.8-.5,4.2Z"
          fill="#0059fd"
        />
        <path
          d="M286.7,321.2c1.5,1.3,3.3,2,5,3.5,3.6,1.6,1.9,3.2-1,1-.9-.3-1.7-.7-2.5-1s-.3,0-.5,0l-.5-.5c-.2-.2-.3-.3-.5-.5-1.1-1.2-2.8-2.9,0-2.5Z"
          fill="#49bafc"
        />
        <path d="M285.7,265.8l-.3-.6.3-.4c0,.3,0,.7,0,1Z" fill="#2bbcfc" />
        <path
          d="M284.7,248.3c0,.2,0,.3,0,.5-.1.4-.3.4-.5,0-1.6,1-.4,2.5-.5,3.7s-.4,2.1-.5,3.3c0,2.2-.2,4.4-.5,6.5,0,1.7,0,3.3,0,5l-.5,1c0-6.3.1-12.5.5-18.7l2-1.2Z"
          fill="#019ffe"
        />
        <path d="M287.7,324.7c-.2,0-.4-.3-.5-.5.2.2.4.3.5.5Z" fill="#0637e2" />
        <path
          d="M265.7,227.3c2.3.5,3.6,1.5,3.8,2.8,2.8.5,4,.9,6,2.8,3.4,3.3,7,8.4,6.1,13.4-.1.7-.5,1.4-.5,2.2,0,1.4,1.3,3.1-.2,4.3l-3.2-3c-.1.4-.3.4-.5,0-.3-.2-.3-.3,0-.5-2.2-4.8-1.6-7.7,2-1.1,2.9,1.7,0-6.4-.7-7.6-2-3.8-4.8-6.1-8.8-7.4-.8,0-1.6-.3-2-1-1.5-2-3.1-3.3-4.7-3.9-2,.5-3.6.3-4.8-.6-.3-.1-.3-.3,0-.5,0-.4.3-.4.5,0,2.7-1.2,5-1.2,7,0Z"
          fill="#023bf3"
        />
        <path
          d="M274.7,230.8c1.5,1.3,2.8,4.1,4,5.7s2.4,2,2.7,2.8c.8,2,.6,5,.3,7-.2-2.6-1-5.7-2.3-8s-4.8-5.6-5.5-6-4.4-1.1-5-1.5-.3-1.2-.4-1.4c-.7-.9-2-1.3-2.8-2.1,2.6-.5,7.4,1.3,9,3.5Z"
          fill="#0446f9"
        />
        <path
          d="M262.2,225.3c1.3,0,2.3.3,3,1,3.7.7,6.1,1.5,9.5,3.5l.5.5v.5h-.5c-2.3-2-6.1-3.1-9-3.5s-4.2,0-7,0c.5-.7,1.3-1.4,2.5-2,0,0,.7,0,1,0Z"
          fill="#055afa"
        />
        <path d="M278.2,260.3l1-.7v4s-1-1.2-1-1.2c0-.2,0-.3,0-.5,0-.5,0-1,0-1.5Z" fill="#4fb6fc" />
        <path d="M277.7,251.3h-.5c-.4-.4-.3-1,0-1.5h.5v1.5Z" fill="#002ce8" />
        <path d="M281.2,237.3c-.7-.2-1-.8-1-1.5.4.5.7.9,1,1.5Z" fill="#05a7fe" />
        <path d="M277.2,232.3l-.5-.5c.2.2.3.3.5.5Z" fill="#0bb0fe" />
        <path
          d="M334.7,354.7l.6-.3,7.4,5.1c0,0-1.6-.8-1.1-1.3.5,0,1,.2,1.5.5l.5.5c5.7,3.8,11.3,7.7,17,11.5l.3,2c-1-.1-1.4-1.5-1.8-1.7-1.2-.7-1.3-.7-2.8-1.7-3.7-2.5-7.9-5.4-12.2-6.6-1-.7-2-1.3-3-2l-6.5-6Z"
          fill="#409efc"
        />
        <path
          d="M292.7,324.7l.5.5c10,6.8,20.3,13.3,30,20.5-.2.2-.4.4-.6.5-.5.3-7.4-3.5-8.4-4.5-4.1-1.9-7.9-4.8-11.5-7.5-4.4-2.2-8.1-5.5-12-8.5.8.2,1.5.7,2.5.5.3-.1-1-1.1-1.5-1.5.3,0,.7,0,1,0Z"
          fill="#47b0fc"
        />
        <path
          d="M314.2,341.7c.3.2.3.3,0,.5-2-1.2-4-2.3-6-3.5s-3.3-2.5-5-3.5l-.5-1c4.5,2.3,7.6,5.3,11.5,7.5Z"
          fill="#359efb"
        />
        <path
          d="M323.2,345.7c3.2,1.2,7.1,4.5,10,6.5-.3.4-.8.7-1.5,1-5.6-3.5-11.6-7.4-17.5-11v-.5c2.6,1.4,6.5,3,9,4Z"
          fill="#3ca4fb"
        />
        <path d="M377.1,378.7c-2,.6-1.8.1-3.5-.5l3.5.5Z" fill="#4294ef" />
        <path
          d="M350.7,294.8c.4.2.8.5,1.2.8,1.4,1.3,6.4,11.9,6.5,13.8s0,.9-.1,1.4c1.8,4.3,3.7,9,5,13.5-2-2-4.1-4.5-4-7.5l-1-2.8c-3.3-4.6-6.4-10.2-7-15.7-.2-.3-3.2-5.3-2.6-4.6s.3,1.1-.4,1.2c-1.3-.6-2.8-3.9-3.3-5.5l.8-1c-.8-2.3-.5-3.1.9-2.4,1.5,2.9,2.9,5.9,4.1,8.9Z"
          fill="#1aa2fc"
        />
        <path
          d="M351.7,292.3l1.2.2c1.4,2.3,2.5,4.5,2.8,7.3,1.1-.2,1.4.9.5,1.5.8,4.2,3.5,6,3.5,10.2l-1.5-.7c-2.2-5.4-4.8-10.9-7.5-16-.4-.7-.4-1.2,0-1.5.2-.5.6-.8,1-1Z"
          fill="#c8fafc"
        />
        <path
          d="M365.1,327.7c.5.9.8,2.2,1.5,3.5.8,1.7,1.4,3.4,2,5,1.9,2,3.1,4.7,3.5,8,.6,2.7,2.3,6.4,3.5,9v1.5c-1.1-2.4-1.9-4.9-3.5-7-.4-.1-.4-.3,0-.5l-.5-.5c-.5-.1-.4-.3,0-.5l-1-1.5-1.4-1c-.9-1.6-5.7-12.9-5.5-13.7s.2-.6.4-.8l-1.5-4.6.5-.4c.6,1.2,1.4,2.4,2,3.5Z"
          fill="#157afa"
        />
        <path
          d="M361.6,310.3c1.1,0,1.6,1,1.5,3,0,.8.2,1.8.5,2.5l-1,1c-1.6-3.7-2.6-4.8-2.5-9,1.1-.7,2,1.4,1.5,2.5Z"
          fill="#a2ebf2"
        />
        <path
          d="M356.2,297.3l.5.5v.5c.8.5,1.2,1.5,1,2.5.7,1.8,1.7,3.6,2,5.5-2.1-1-.8-2-1-2.5s-3.1.5-.5-.7c-.9-.5-.5-3.1-2-1.8,0-.4-.4-.9-.5-1.5-.6-1.4-.6-2.4,0-3,.4-.2.6,0,.5.5Z"
          fill="#a9ecf2"
        />
        <path
          d="M372.6,341.7l-1-.5c-.1.2.4,2.5.5,3-1.4-2.5-2.3-5.3-3.5-8,.1-.4.3-.4.5,0l.5.5c0-.5,0-1.1,0-1.5l-.5-.5c0-.1,0-.3,0-.5-.2-.2-.2-.3,0-.5,1.1,1.9,2.4,5.7,3.5,8Z"
          fill="#aaf4fc"
        />
        <path d="M373.1,342.7c-.2-.1-.4-.3-.5-.5.2.1.4.3.5.5Z" fill="#aaf4fc" />
        <path d="M369.1,336.2h-.5c-.7-1.6-2-3.1-2-5,.8,1.6,1.9,3.2,2.5,5Z" fill="#b4f7fc" />
        <path d="M369.1,333.7v.5c-.7-.3-.4-1-.5-1.5.4.2.4.8.5,1Z" fill="#b4f7fc" />
        <path d="M368.6,332.2c0,0-.3-.2-.5-1l.5,1Z" fill="#b4f7fc" />
        <path d="M369.6,335.2s-.4-.1-.5-.5l.5.5Z" fill="#b4f7fc" />
        <path
          d="M364.1,329.2c1.5,5.1,4.7,10.2,6.5,15.5l1,1.5c0,.1,0,.3,0,.5l.5.5c0,.2,0,.3,0,.5.3,1.1.6,2.4,1,3.5-1.2-1.3-2.2-3.2-2.5-5l-1,.5h-.5c-1.8-.9-2.3-4.6-2.5-6.5-.4-.1-.4-.3,0-.5l-.5-.5c-.6,0-1-.4-1.2-.9-1.7-4.3-3.1-8.3-4.3-12.6-.4-.2-.4-.3,0-.5l-.5-1c-.4,0-.4-.3,0-.5-2.2-5.5,1.2-2.8,2.4.8l1.5,4.7Z"
          fill="#0d53f4"
        />
        <path
          d="M365.1,340.2c1.1-.9,1.2,1.2,1.1,1.1-.3-.4-.3-1.1.4-1.1,1.4,1.9,1.7,4.4,2.5,6.5l.5.5.5,1c0,.1,0,.3,0,.5l.5.5c0,.1,0,.4,0,.5l.5.5c0,.3,0,.8,0,1l.5.5c0,.1,0,.4,0,.5l.5.5c0,.2,0,.7,0,1l.5.5v.5c-.1-.1-1.2-.7-2-2-2-3.3-3.9-8.3-5.5-12v-.5Z"
          fill="#1f5af6"
        />
        <path d="M370.1,348.2l-.5-1c.1.3.3.6.5,1Z" fill="#0d53f4" />
        <path d="M372.6,354.2c-.3,0-.4-.3-.5-.5l.5.5Z" fill="#1749ec" />
        <path d="M372.1,352.7c0,0-.4-.2-.5-.5l.5.5Z" fill="#1749ec" />
        <path d="M371.6,351.7s-.4-.1-.5-.5l.5.5Z" fill="#1157ee" />
        <path d="M371.1,350.2c0,0-.4-.2-.5-.5l.5.5Z" fill="#0d53f4" />
        <path d="M370.6,349.2c-.2,0-.4-.3-.5-.5.2.1.4.3.5.5Z" fill="#1157ee" />
        <path d="M369.6,347.2c0-.2-.4-.3-.5-.5h.5v.5Z" fill="#1157ee" />
        <path d="M379.1,368.7s-.4-.1-.5-.5l.5.5Z" fill="#173bcb" />
        <path d="M376.6,356.7c-.2-.3-.3-.6-.5-1l.5,1Z" fill="#157afa" />
        <path
          d="M269.7,105.4c.8-.9,1.3-.1,1.8.7l3.6,8.3c2.7,7.8,5.9,15.1,9.6,22,.4.2.4.3,0,.5,4.7,11.8,9.4,23.6,14,35.5.9,0,1.3.6,1.4,1.8l1.1,2.7c.7.2,1,.7,1.3,1.3,1.3,3.3,2.6,6.6,3.9,9.9s.2,1.2-.2,1.8c2.3,5.1,4.7,10.2,7.1,15.3v1.7c0,0,1,1.7,1,1.7,1.5,2,3.2,4.8,2.4,7.2.7,1.1,1.2,2.8,1,4,2.3,4.3,1.4,7.9-1.3,2.1l-3.7-7.6c-3-6-5.7-12.2-8-18.5-3.1-6.8-6.1-13.6-9-20.5-6.4-14-12.4-28.2-18-42.5-2.1-4.8-4.1-9.6-6-14.5-1.7-1.6-3.5-4.5-3-6.5l-1.1-4.5c-.7-2.2.4-4.1,2.1-2Z"
          fill="#fcfdfc"
        />
        <path
          d="M240.2,79.9l.9.6c3.7-7,6.4-8.2,13.4-4,1.2,1.8,1.4,3.9.7,6.2l3.5,3.6-.4,1.1c-1.4,2-5.8-2.3-5.9-4.3,1.4-3.2-1-6.3-4.3-4.9-2.2,5-4.6,10.4-8.2,14.5.2.3.3.6.2.7-1.5,3-2.2,4.7-2.2,8.1-3,3.3-4.7,7.3-5.3,11.7l-1.8,2.2c-1.2,1.4-2.7,3.1-2.5,5-2.7,7-5.9,14.2-9,21-2.8,7.9-6.3,15.7-10.5,23,.3.2.3.3,0,.5l-1,2c-1.8,6.8-4.8,13.5-8.5,19.5l-.5,1c.4.2.4.3,0,.5l-.5.5c.4.2.4.3,0,.5l-.5.5c.4.2.4.3,0,.5l-1,1.5c.4.2.4.3,0,.5l-.5.5c.4.2.4.3,0,.5l-.5.5c.4.2.4.3,0,.5-.5,1.2-4,9.5-4.6,9.6s-.6,0-.8-.3,1.3-4,1.9-4.3c-.3-.2-.3-.3,0-.5l.5-.5c-.4-.2-.4-.3,0-.5l.5-.5c-.4-.2-.4-.3,0-.5l.5-.5c-.4-.2-.4-.3,0-.5l.5-1c-.4-.2-.4-.3,0-.5l.5-1c-.4-.2-.4-.3,0-.5l.5-.5c-.4-.2-.4-.3,0-.5l.5-.5c-.4-.2-.4-.3,0-.5l.5-.5c-.4-.2-.4-.3,0-.5l.5-1c-.4-.2-.4-.3,0-.5l.5-1c3-8.5,6.3-16.8,10-25,1.8-5.4,3.9-10.7,6.4-16,1.1-3.7,2.4-7.2,4.6-10.5-.1-3.1,1.4-6.8,3.5-9v-.5l.5-.5c-1,0-.9-.8,0-1l.5-.5c-.3-.3-.4-.6-.4-.8.8-2.3,6.4-16.7,7.1-17.3s.5-.3.8-.4c3-8.4,6.2-16.7,9.5-25-.3-.2-.3-.3,0-.5.2-.2.3-.2.5,0Z"
          fill="#fafdfb"
        />
        <path
          d="M230.7,115.4c0-1,1.2-1.6,1.4-2.4.7-2.4,1.1-6,2.1-8.4s2.5-2.4,2.8-3.7-.5-2.3.6-4.9c1.7-4.1,5.7-10.1,7.8-14.2s1-3.6,2-4.5c2.1-1.7,5.9.3,6.2,2.8s-.7,2.6-.3,3.7,3.8,3.9,4.8,3.5c1.4,0,2.2,1.2,2.5,3.3l1.2,5.5c3,4.7,5.8,10,6.8,15.6,0,3.1,2.7,4.5,3.9,6.9,1.9,3.9,3.4,10,5.1,14.1-.1.4-.3.4-.5,0-1.1-2.5-2.8-7.6-4.5-9.5-.6-.8-1-1.9-1.2-3.5-2.4-2.1-3.9-4.8-4.6-8-2-2.1-3.3-4.4-3.7-6.8-1.3-1.1-2.3-2.6-2.9-4.5-2.1-.2-3.5-1.8-4.2-4.8-4.2,1.3-5.9.7-5.2-1.9-.6-.1-1.3,0-1.9,0-.2,4.4-3,1.7-4.3-.6l-1,.8c-2.7-.6-2.7,1.4-2.2,3.5-.5,2.5-1.8,6.4-3.9,7.8-.2.1-3.5,3.2-3.7,3.5-1.2,1.6-.4,3.1-1,4.5s-1.8,1.4-2.2,2Z"
          fill="#f2fdf9"
        />
        <path
          d="M216.7,196.8c.4-.1,1.2-.7,1.5-.5s1.4,5.4,2.5,6c1.8.3,2.4,3.5,2.5,5,1.6.4,1.9,1,1,2,2.7,2.1,5.1,4.6,7,7.5,2.3.7,4.7,1.8,7.1,3.2l.4,1.3c1.3-.5,2.8-.3,4.5.6,1.7.1,2.7.6,3,1.5,3.2.2,6.4.1,9.5-.1,1-1.4,3.8-2.1,5.5-1.5-.1-1.7,2.6-2,3.5-1.5.7-1.3,1.4-1.7,2-1,3-2.9,6-5.7,9-8.5-.9-1.2,1.1-3.2,2.5-2.5,2.4-2.6,3.3-2.1,2.4,1.5s-5.4,7.9-7.4,9.5c.2.2.2.3,0,.5-4,1.8-7.7,4.1-12,5.5-.9.9-2.6,2-3.5,1,0,.9-.9,1.1-2.5.5-.2.4-.3.4-.5,0-2.4.6-4.8.6-7,0-.1.2-.2.4-.4.5-.4.1-6.6-1.6-7.1-2-1.8-1.3-4.6-1.6-6.5-2.5l-1-.5c-1-.5-2.6-1.7-3.5-2.5-3-2-5.6-4.6-7-8-1.7-.5-2.7-2.2-3-5-.4.2-.7.1-.8-.3-.9-3-1.9-6.2-2.2-9.3s.2-.3.5-.5Z"
          fill="#fafdfc"
        />
        <path
          d="M237.7,105.4c.5-2.1,2.7-6,2.9-7.9s-.4-1.4-.3-1.9c0-1.2,1.5-1.2,0-2.7,1-.4,2.7.5,3.3.4s.3-1.8,1.4-1.4l2.5,3.5c1.6.2.2-1.3.3-1.8.1-.9,6.4-1.6,3.4,1.8,1.3.5,4.6-.9,5.4-.4s1.8,3.8,2.2,4.3,1.6,0,2.2.5c1,.9,1.1,3,1.7,3.7s1.3.2,1.5.3c.2.3,0,1.8.2,2.6.5,1.9,3.9,5.8,4.6,7.9s-.3,1.4,0,2,2.9,2.8,3.2,3.4c.5.9.5,2.6.5,3.6,0,0-1,0-1.3-.5-.5-.8,0-2-.5-3s-2.9-2.4-3.5-3.5-.4-3-1.1-4.4-3.6-3.1-4.9-6.1.1-1.6-.2-2.1-2.7-1.7-2.9-1.7c-1.5-.4-3.5,1.4-4.3,1.3s-2-1.6-3-2-1.3,0-1.9-.1-1.4-1.3-2.2-1.2-1.5,1-2.2,1.3-1.6,0-2.1.4-.3,1.5-.7,2.1c-.8,1.6-3,1.1-4.3,1.7Z"
          fill="#ecfdf9"
        />
        <path
          d="M272.7,169.3l2.5,2.5c.7.9,1.3,2,2,3,.3.5.3.8,0,1h-.7c-3.3-3.6-6.9-6.7-10.8-9.5-.2.4-.3.4-.5,0-1.1-.7-2.2-1.2-3.5-1.5l-.9.2c-10-4.4-19.6-1.8-29.1,2.3l-1,1c-.2.4-.3.4-.5,0l-4.9,4.6h-.6c-.4-.3-.4-.5,0-.6.9-1.2,2.4-2.9,3.5-4l2-1.5c.2-.1,1.4-1,1.5-1l2-1c13.7-6.4,27.1-4.8,39,4.5Z"
          fill="#1582fd"
        />
        <path
          d="M224.7,172.8c.1.3.2.6.1.8-1,2-2.7,5.6-3.8,7.4s-.4.3-.8.3c-.9,5.5-1.5,10.1,1.4,14.9h1.1c.2.8.3,1.7.5,2.6.4.6.5,1.5,0,2,.5,3.9-1.8,2.9-2.5,0-1.8-5.5-4.1-10-3-16l.5-1.5c.9-3.5,3.4-7.6,5.5-10.5l.5-.5h.5c0,.1,0,.4,0,.5Z"
          fill="#26acfb"
        />
        <path
          d="M274.7,218.8l-.5.5c-.1,0-.3,0-.5,0h-.5c1.3-2.1,8.5-9.8,7-12l-2,1c-.3-.6,0-1.4,1-2.5l1.5-4c-.4-.7.3-3,.7-4.2s.2-.2.3-.3c.1-.6.5-.9,1-.5,0,0,.7.2.9.8.9,3.3-1.4,6.2-2.2,9.2s.3,1.7,0,2.5c-.5,2.1-5,7.8-6.8,9.5Z"
          fill="#d4f7f9"
        />
        <path
          d="M277.2,174.8c3.6,5.2,6,9.1,6.5,15.7.1,1.4.6,6.2-1,5.7-.2.5-.8.6-1,0l-1.1,4.5c-.2.6-.3.9-.9.5-1-.3-1-.7,0-1-.4-.2-.7-.5-.9-.9s1.4-5.7,1.7-5.9.4-.2.7-.3c.1-5.9-.5-12.1-4.2-16.8l.2-.6c0-.3,0-.7,0-1Z"
          fill="#108dfd"
        />
        <path
          d="M295.7,175.3c-6.2-13.6-12.4-27.2-18.3-41s-.1-1.2-.2-1.5h.5c5.9,14.2,12.1,28.3,18,42.5Z"
          fill="#e4fdf9"
        />
        <path
          d="M334.2,258.8c1,2.5,2,5,3,7.5.5,1.3,1,2.6,1.5,4,.4.1.4.3,0,.5l.5.5c.5.1.4.3,0,.5l.5.5c.4.2.4.3,0,.5l.5,1c.5,0,.4.3,0,.5.8,1.2,1.8,2.9-.3,2.7s-2.9-5.2-3.2-6.2c-1.9-3.4-3-6.9-4.5-10.5.4-.9.9-1.5,1.5-2,.1-.4.3-.4.5,0,.4.1.4.3,0,.5Z"
          fill="#63ddfd"
        />
        <path
          d="M366.1,339.2l.5.5c0,.1,0,.3,0,.5,0,.5,0,1,0,1.5-.6-.2-1-1-1.5-1.5l-.5-.5c-1.8-4.1-3.6-8.3-5-12.5.4,0,.7-.5,1-1.5,2.5,4.2,3.6,9,5.5,13.5Z"
          fill="#1b69f7"
        />
        <path
          d="M352.7,307.3c1.6-.6,2.8,2.2,2.5,3.5v.5l.5.5c.4.2.4.3,0,.5l.5,1c1,.3,1.7,2,.5,2.5l.5,1.5c.5,0,.4.3,0,.5.9,3.3,0,2.9-1.2.1s-.5-.8-.8-1.1c-1.8-4.3-3.7-8.5-5-13,1.1.5,1.9,1.7,2.5,3.5Z"
          fill="#1c87fc"
        />
        <path
          d="M345.2,291.8h.7c.7,1.5,1.5,2.7,2.3,3.5.8-.6,1.5.2,1,1,.6.6.6,1,0,1l.5.5c1.9,1.9,2.9,4.8,2.5,7.5l.5,1c1.4,0,1.3.6,0,1-.9-.8-1.7-1.9-2.5-3.5-2-3.7-3.8-7.9-5-12Z"
          fill="#2094fc"
        />
        <path
          d="M209.2,165.8c-1.3,3.3-2.6,6.8-4,10s-2,4.4-3,6.5c-.6,1.7-5,12-5.8,12.3s-.4-.1-.7-.3v-.5c0-.1,0-.4,0-.5l.5-.5c0-.1,0-.4,0-.5l.5-.5c0-.1,0-.4,0-.5l1-1.5c0-.1,0-.4,0-.5l.5-.5c0-.1,0-.4,0-.5l.5-.5c0-.1,0-.4,0-.5l.5-1c2.9-6.5,5.6-13,8.5-19.5l1-2c0-.1,0-.4,0-.5.1-.3.3-.3.5,0,.6,0,.6.5,0,1.5Z"
          fill="#e0f7f6"
        />
        <path
          d="M355.2,316.8c1,.4,1.4,1.5,1.5,2.5h.5c0-.5,0-1,0-1.5,1.5-.4,3,2.9,2.3,3.9l.7,2c0,.2,0,.3,0,.5l.5,1c0,.2,0,.3,0,.5.2.7,1,2.6,1,2.8-.1,1.9-1.5-.5-2-1.3-1.9-3.3-3-7-4.5-10.5Z"
          fill="#1b76fc"
        />
        <path
          d="M221.2,138.3l-1,2.5c-.3.6-.7.8-1,.5,3-6.8,5.1-14.5,9-21,.2-.4.5-1.1,1-1-1.3,5.3-4.6,10-6.7,15s-.8,2.8-1.3,4Z"
          fill="#ebfefa"
        />
        <path
          d="M336.7,270.8c.3.5,3.6,6,4,5.5.1-.7-.3-1.3-.5-2,1.3-.6,1.6-.2,1,1,.8.1.9.9,0,1l.5.5c1.1.3,2.4,3.3,1,4l.5.5c.4.2.4.3,0,.5.8,4.3-2.4-.2-3-2.5-1.4-2.5-3.1-5.6-3.5-8.5Z"
          fill="#4ccbfc"
        />
        <path
          d="M328.2,250.8c1.5,1.1,2.3,1.3,2.5.5,2.2-.2,3.1,3.7,2.5,5.5.2.2.4.5.5,1,.3.1.3.3,0,.5,0,1,0,2,0,3l-1.5-1c-1.3-3.1-3.4-6.1-4-9.5Z"
          fill="#75e6fd"
        />
        <path
          d="M345.2,288.3c.1-.4.3-.4.5,0,.3,1.8,1.7,4.8,2.5,6.5.4.1.4.3,0,.5,0,.8.2,1.7-.6.4s-1.7-2.7-2.4-3.9c-1.9-3.4-2.8-5.8-4-9.5,1.9,1.5,3.3,3.5,4,6Z"
          fill="#28a8fd"
        />
        <path
          d="M333.2,352.2c2.8,1.9,5.9,3.7,8.5,6s1.3.9,1.5,1.5c-3.4-.5-5.8-3.3-8.5-5s-2.5-1.2-3-1.5l-.5-1.5,2,.5Z"
          fill="#43a7fa"
        />
        <path
          d="M319.2,228.3l1.5,3c.4.1.4.3,0,.5l.5.5c1.2,0,1.8,2.2,1,3,.7,1.8,1.3,3.7,2,5.5l-9-20.5c1.9,2.2,3.3,4.6,4.3,7l-.3,1Z"
          fill="#aef3fb"
        />
        <path
          d="M329.2,246.3c.4.1.4.3,0,.5l1.3,4.8c-.8,1-3.6-3.3-3.8-4.3-1-1.7-.9-2.5-1.5-4l2.5,3c-.1-1.6-.5-3.5-1-5,1.2-.2,1.8.7,1.7,2.6l.8,2.4Z"
          fill="#98eefc"
        />
        <path
          d="M220.7,200.8l2,2,.5-2c1.1,0,1.7,2.7,1,3.5l-.3.6c1.2,1.8,1.4,5-.7,2.4-1.1-1.8-1.8-2.9-2.5-5s.1-1.1,0-1.5Z"
          fill="#39c8f9"
        />
        <path
          d="M330.7,251.3c.3,1.4.7,3,.9,4.4s.6,1.7-.4,1.6c-.3-2.5-1.8-4.4-3-6.5s-1.4-2-1.5-3.5c.8,1.4,2.3,2.9,3.5,4-.5-1.6-.8-2.9-1-4.5,1.5-.2,3,3.8,1.5,4.5Z"
          fill="#7fe6fc"
        />
        <path
          d="M312.7,214.3c.2.2.2.3,0,.5-3-5.2-4.9-11-7.5-16.5l-.5-1c0-.4,0-1,0-1.5,2.8,6.1,5.3,12.3,8,18.5Z"
          fill="#d6f5fa"
        />
        <path
          d="M219.2,143.3l-1,2c-2,4.7-4.1,9.4-6,14-.7,2.1-1.7,3.7-3,5h-.5c3.4-7.7,7.1-15.3,10.5-23,.2-.2.9-.4,1-.5-.4.8-.7,1.7-1,2.5Z"
          fill="#e1f9f7"
        />
        <path
          d="M312.7,214.3c1,.1,5.1,11.2,6,10-.2-1.5-.6-3-1-4.5.2-.3.6,0,1,1,.4.1.4.3,0,.5.8,1.4,1.6,2.9,2,4.5.6.4.6.8,0,1l1.5,4.5c.6.6,1.2,1.6,1,2.5,0,.6,0,1.4,0,2l-1-.5c-.4-1-.6-2-1-3l-.5-.5c0-.2,0-.4,0-.5l-1.5-3c-1.2-2.7-2.8-5.3-4-8s-1.7-3.6-2.5-5.5,0-.4,0-.5Z"
          fill="#ddfafb"
        />
        <path
          d="M209.2,165.8c.1-.3-.1-1.2,0-1.5.5-1.3,2.2-3.6,3-5-.8,2-1.3,4.7-3,6.5Z"
          fill="#b8f3fa"
        />
        <path
          d="M285.2,249.8c0,.8,0,1.7,0,2.5-1.3-.5-1.5-2.3-1-3.5h.5c0,.1.4.5.5,1Z"
          fill="#6fdcfa"
        />
        <path
          d="M340.2,279.3c.8,1.4,1.6,2.9,2.8,4l.2-1.5c.8.8,1.3,1.9,1.5,3.5,1.2-.1,1.3.9.5,3,0,.2-.2.5-.2.5-.8-.1-2.6-5.7-3.8-6.5-.3-.9-1.2-1.8-1-3Z"
          fill="#3abefd"
        />
        <path d="M262.2,225.3c1.3-.1,3.5-.4,3,1-.8-.2-2.3-.5-3-1Z" fill="#1c72f8" />
        <path d="M230.2,166.8c-.4.9-1,1.5-2,1.5,1.1-1.1,1.1-.9,2-1.5Z" fill="#6df4fe" />
        <path d="M220.2,140.8c.3-.7.1-1.9,1-2.5-.3.8-.7,1.7-1,2.5Z" fill="#d1fdf8" />
        <path
          d="M282.7,196.3c0,.2,0,.4,0,.5l-1,.5c-.3-.2-.3-.5,0-1,.2,0,.7,0,1,0Z"
          fill="#46dffe"
        />
        <path d="M217.7,184.8c.2-.8.4-1.1.5-1.5l-.5,1.5Z" fill="#54e8fe" />
        <path d="M233.7,164.8l-2,1c.7-.4,1.2-.6,2-1Z" fill="#6df4fe" />
        <path d="M305.2,198.3c-.1-.3-.4-.3-.5-1l.5,1Z" fill="#73eafc" />
        <path d="M365.1,340.2v.5c-.1-.3-.3-.6-.5-1,.2.2.3.3.5.5Z" fill="#0025e2" />
        <path d="M218.2,145.3l1-2c-.3.8-.8,1.5-1,2Z" fill="#bdfef9" />
        <path d="M343.7,359.2l-.5-.5c.2.1.3.4.5.5Z" fill="#0425e1" />
        <path d="M293.2,325.2l-.5-.5c.2,0,.3.4.5.5Z" fill="#0032f8" />
        <path d="M275.2,171.8l-2.5-2.5c1.2.9,1.6,1.4,2.5,2.5Z" fill="#8afdfd" />
        <path d="M223.7,172.8l.5-.5c-.1.2-.4.3-.5.5Z" fill="#64f0fe" />
        <path d="M274.2,219.3l.5-.5c-.2.2-.2.3-.5.5Z" fill="#1cc3fe" />
        <path d="M273.2,219.8v-.5h.5c-.1.2-.3.4-.5.5Z" fill="#1cc3fe" />
        <path d="M275.2,230.3l-.5-.5c.2.1.4.2.5.5Z" fill="#15b2fd" />
        <path d="M160.8,366.7c-.5.3-.8,1.7-2,1.5.5-.5.8-.9,1.5-1.5h.5Z" fill="#215cee" />
        <path
          d="M127.8,343.7c.1.5,0,1-.5,1.5,1.2.7.5,2.6-.7,2.7l-.3.8c-.2.2-.3.3-.5.5-.2.3-.5.6-.5,1h-.5c-.3-1.5-.2-2.5,0-4-.3-.1-.3-.3,0-.5.8-2.1,1.8-3.1,3-3,.7,0,.5.6,0,1Z"
          fill="#a1ebfb"
        />
        <path
          d="M172.8,348.7l.5.4c-.5,1.1-1,2.3-1.5,3.6-2.4,1.9-4.9,3.9-7.5,6-1.6,1-2.6,2.1-4.5,3s-2.1.7-3,1c-1.6.6-3.1,1.1-4.5,2-.7-1.9,0-1.4,1-2.5s1.4-1.5,2-2l2-1.5c5-3.5,10.4-6.6,15.5-10Z"
          fill="#38aafc"
        />
        <path
          d="M185.8,343.2c1,1.1-.7,2.2-2,2-2.6,2.1-6.1,4.2-9,6-1,1-2,1.5-3,1.5l-1-1.2,2-2.8c2.5-1.7,5-3.3,7.5-5l.4.6c1.6-1.3,3.3-1.7,5.1-1.1Z"
          fill="#32b0fb"
        />
        <path
          d="M194.8,337.2c3-.8.8,1.2-.8,2l-.2.5c.1,1.2-.7,2.3-2,2-.7.9-5,4.3-5.7,4.2s-.5-.1-.8-.2l-1.5-.5c.7-.6,1.6-1.1,2-2l.2-1.2c1.9-1.1,3.6-2.4,5.1-4.1l1.2.3c.8-.7,1.7-1,2.5-1Z"
          fill="#0c6ef1"
        />
        <path
          d="M191.8,341.7c2.3-.5-1.3,2.5-2.5,3-.7,1.3-3.7,4-5,3.5-1,.7-2,1.2-3,1.7s-.6-.1-.5-.7c1.5-1.1,3-2.4,4.5-3.5s4.2-3,6.5-4Z"
          fill="#0224cb"
        />
        <path
          d="M184.3,348.2l.3.6c-2.8,2.1-5.8,4.1-8.8,5.9-.2.8-.9,1.2-1.5.5l1-1.3-.5-.2c2-1.4,4-3,6-4.5.4.6,2.7-.6,3.5-1Z"
          fill="#012ad8"
        />
        <path
          d="M164.3,358.7c1.5-3.1,4.8-4.3,7.5-6s2.2-1,3-1.5c-3,2.9-6.9,5.2-10.5,7.5Z"
          fill="#2d9bfc"
        />
        <path
          d="M176.3,354.7c.2.3.4.5.4.6-.9,1.3-4.2,3.1-5.9,3.4-2.4,1.7-5.8,3.8-8,5.5-.4.3-1,.3-1.5.5l13-9.5c.5,0,1-.3,1.5-.5h.5Z"
          fill="#0c48ea"
        />
        <path
          d="M205.7,328.2c.3.8-1.6,2.5-2.5,2.5-1.8,1.3-3.7,2.6-5.5,4-.1.3-.3.3-.5,0l-1,1c-.1.4-.3.4-.5,0l-1,.5c-.4.8-1.2,1.5-2.5,2-2.4,2.1-3.2,3.5-6.5,5s-3.1,1.3-4.8,1.5-1.6.2-.7-1c3.8-2.5,7.3-5.4,11.5-7.5.6-.7,1.3-1,2-1h.5c-.2-.8.9-1.5,1.5-1l.5-.5c-.3-.3-.1-.6.5-1l7-4.5c.5-.4,1-.6,1.5-.5.8-.4,1-.3.5.5Z"
          fill="#3cb9fb"
        />
        <path
          d="M216.7,283.3c.8,2.4.8,5.1,0,8,.4.8.4,1.7,0,2.5,1,.3,1,.7,0,1l-.5,6.3c-.2.7-.8.8-1.1,0l-.5-3.8v-5c.2-4,.3-8,.5-12,.2-.5.4-.9,0-.5-.1.4-.3.4-.5,0,0-2.3,0-4.7,0-7,.4-.6.4-1.4,0-2,0-.8.5-1.9.5-3h.7c0,0,.2-5.4.2-5.4l1.1-.6c1.1,7.1.9,14.5-.5,21.5Z"
          fill="#2cbffd"
        />
        <path
          d="M178.3,236.3c-.3,1-.8,1.8-1,2.5-1.6,3.4-3.3,6.7-5,10,.3.2.3.3,0,.5l-.5.5c.5,0,.2.6,0,1l-.5.5c.3.2.3.3,0,.5l-.5.5c.4.2.4.3,0,.5l-.5.5c.6,0,.4.7,0,1l-.5.5c.4.2.4.3,0,.5l-.5.5c.4.2.4.3,0,.5-.2.8-1,1.6-1.9,1l3.4-8.5c0-3.5,1-6.2,3-8,.4-1.7,1-3,2-4,.5.7,1,.7,1.5,0-.4-.1-.4-.3,0-.5l.5-.5c-.4-.1-.4-.3,0-.5.1-.4.3-.4.5,0,.3,0,.3.3,0,1Z"
          fill="#81e8fb"
        />
        <path
          d="M154.8,290.8v.5c-1.2,2.8-2.4,5.6-3.5,8.5l-.5.5c.2.3.2.6,0,1l-.5.5c.3.1.3.3,0,.5l-.5.5c.2.2.2.6,0,1,0,.3-.2.5-.5.5,0,.8-.3,2.2-1,2.5l-.5.5c.7,0,.5.6,0,1l-.5.5c.4.2.4.3,0,.5l-.5.5c.4.2.4.3,0,.5l-.5.5c.4.2.4.3,0,.5l-.5.5c.4.2.4.3,0,.5l-.5,1c.1.5,0,1-.5,1.5-.6.7-.8.4-.5-.5-.3-.1-.3-.3,0-.5-.4-.1-.4-.3,0-.5l.5-1c-.4-.1-.4-.3,0-.5l1.5-3c-.4-.2-.4-.3,0-.5l.5-.5c-.4-.2-.4-.3,0-.5l1-2c-.4-.1-.4-.3,0-.5l.5-1c-.9-.3-.9-.7,0-1,0-1.9.5-3.3,1.4-5.1.7-3,1.9-5.2,3.6-6.9.3-1.4.8-3.3,2-4l.4.4c-.6,1.2-.9,2.3-.9,3.6Z"
          fill="#38c1fc"
        />
        <path
          d="M216.7,297.8c1.3,1.2,1.3,2.3,0,3.5.9,1.4,2,4-.5,3.5l-.5-.2c.1,1.5-.2,2.4-1,2.7v-10l1,4,1-6.5c1,1,1,2,0,3Z"
          fill="#1b9cfb"
        />
        <path
          d="M159.8,278.3v.5c0,.2,0,.4,0,.5l-.5.5c0,.1,0,.3,0,.5l-.5.5c0,.1,0,.4,0,.5l-.5,1c0,.1,0,.4,0,.5l-1,2c0,.1,0,.4,0,.5l-.5.5c0,.1,0,.4,0,.5l-.5.5c0,.1,0,.4,0,.5l-.5,1c0,.1,0,.4,0,.5l-.5.5c.2.1.2.3,0,.5l-.5.5c.3.2.3.3,0,.5-1-.7.2-2.8.5-4-.4-.1-.4-.3,0-.5l.5-.5c-.4-.1-.4-.3,0-.5l.5-1c-.4-.2-.4-.3,0-.5l.5-.5c-.4-.2-.4-.3,0-.5l.5-1c-.4-.2-.4-.3,0-.5l.5-.5c-1.6-.8-.2-4.1,1.5-3.5.3-.2.4.2.5,1Z"
          fill="#47cdfc"
        />
        <path
          d="M162.8,271.8c.2.1.2.3,0,.5l-.5.5c.2.2.2.3,0,.5,0,.1,0,.4,0,.5l-.5.5c.2.2.2.3,0,.5,0,.3-.2.5-.5.5,0,.7-.3,1.7-1,2l-.5.5c.4.2.4.3,0,.5-.5-.2-.5-.6-.5-1-.5,0-.4-.2,0-.5l1-2c-.9.1-.7-.5,0-1l1.5-3c-.4-.1-.4-.3,0-.5.3-.7.6-1,1-1,0,.7,0,1.5,0,2.5Z"
          fill="#5ddafc"
        />
        <path
          d="M142.3,322.2c-1.4,1.7-1.7,3.1-2.5,5s-1.4,3.1-2,4.5c-.4.7-.7.8-1,.5-1.3,0-1.3-.6,0-1l.5-.5c-1-1.2.5-6.6,2-5,.8-1,1.6-2.5,2.4-4.5h.6c0,.3,0,.6,0,1Z"
          fill="#2ba8fc"
        />
        <path
          d="M213.2,323.2c.7,1.1-1.8,3.4-3,3-1.4,2-4.2,4.4-6.5,5h-.5c-.3-.2-.3-.3,0-.5,1.2-.8,1.8-1.9,2.5-2.5,3-2.5,2.8-2.7-.5-.5-.5.3-1.2.3-1.5.5,2-1.5,4.7-3.8,7-5l1-.5c.1,0,.3,0,.5,0,.4,0,.9,0,1,.5Z"
          fill="#2da7f9"
        />
        <path
          d="M247.7,226.8c1.2,0,1.8.4,2,1-1.1.4-2.4.4-3.5,0-3.6-1.2-8.1-1.7-11.8-.6l-.7-.4c1.6-.7,4.8-1.5,6.5-1.5s5,1.3,7.5,1.5Z"
          fill="#1a68f9"
        />
        <path
          d="M216.2,304.8c1.5.6,1.4,2.3,0,3-.3,1.4-.7,2.6-1.5,1,0-.5,0-1,0-1.5s.6-3.3.7-3.5.6-.6.8-.5c0,.5,0,1,0,1.5Z"
          fill="#209afd"
        />
        <path
          d="M216.2,309.3l-.5,1.5-1-.5c0-.5,0-1,0-1.5.8.2,1.1-.4,1.5-1,1,.5,1,1,0,1.5Z"
          fill="#1b9cfb"
        />
        <path
          d="M148.8,307.3c-.4,1.1-3.3,7.4-4,7.5.2-.5.3-1,.5-1.5l.5-1c0-.1,0-.4,0-.5l.5-.5c0-.1,0-.4,0-.5l.5-.5c0-.1,0-.4,0-.5l.5-.5c0-.1,0-.4,0-.5l.5-.5c0-.2,0-.7,0-1l.5-.5c.3-.9.5-1.6,1-2.5h.5c-.2.8-.7,2.3-1,3Z"
          fill="#2ba8fc"
        />
        <path
          d="M140.3,322.2c.3,0,.3.3,0,.5.4,0,.4.3,0,.5l-.5.5c.4.1.4.3,0,.5l-.5.5c.9-.1.7.6,0,1-.2,0-.4,0-.5.3-.3,1.6-.9,3.2-1.5,4.7l-.5.5c0,.3,0,.7,0,1,0,.9-.6,2.5-1.5,2.5l-.6-.4c-1,1.7-1.6,3.5-2.4,5.4-.8,1.1-1.1,1.4-1.5,0,0-.2,0-.4,0-.6.6-2.1,4.7-12.4,5.8-13.7s.4-.2.8-.3c.1-3.8,4.7-8.6,3-3Z"
          fill="#0f7cf0"
        />
        <path
          d="M131.3,347.7c0-1.3,0-1.1-1-.5.8-2,1.7-4,2.5-6l1-2c0-.1,0-.4,0-.5l1-2c0-.1,0-.3,0-.5l.5-1c0-.2,0-.4,0-.5.3-.7.9-1.9,1.5-2.5s.7-.3,1-.5c-2,4.8-4.9,11.2-6.5,16Z"
          fill="#31a0fa"
        />
        <path
          d="M130.8,339.7l.5.6-2.5,7.4c-.3.6-.3,1.2-.5,1.5l-1,.5v-2s-.5,0-.5,0c0,.4-.3.7-.5,1,0-1.3.6-2.3,1-3.5.3-.6.6-1.1,1-1.5,0-1.4.2-4.4,2-4,.1-.4.3-.4.5,0Z"
          fill="#2c9bf3"
        />
        <path d="M132.3,339.7c-1.2,2.9-2.3,5.2-3.5,8,.6-2.4,1.1-5.7,2-8h1.5Z" fill="#1d74e6" />
        <path d="M134.8,336.2c0-.4,0-.8.5-1-.1.4,0,.8-.5,1Z" fill="#0f7cf0" />
        <path d="M133.8,338.7l1-2c-.3,1.2-.8,1.5-1,2Z" fill="#0f7cf0" />
        <path d="M132.8,341.2l1-2c-.4.9-.8,1.5-1,2Z" fill="#0f7cf0" />
        <path
          d="M248.7,67.4c3.8.2,6.8.5,9.8,3l1.6.4c.6-.2,1.1.4,1,1,.8,1.3,1.6,2.7,2.5,4,.1-.4.3-.4.5,0,.4.2.4.3,0,.5,1,1.6,1.7,3.6,2,6,.5.6.9,1.4,1,2.5.4.1.4.3,0,.5l.5.5c.7.3,1,1.4.5,2v.5c.4.6.2.9-.5.5-2.1-2.4-3.7-5.3-4.8-8.7l3,8.6-.7,1.1c.2.2.2.3,0,.5-1.1-1.1-1.9-2.6-2.5-4.5l-3-9.2c-1.8-4.3-6.1-7.6-10.9-6.5l-1.1-.8v-.5c-4.1,1.8-5.2,1.6-3.5-.5.2-.9.9-1.3,1.5-.5,1.1-.3,1.9-.4,3-.5Z"
          fill="#b3f6fa"
        />
        <path
          d="M254.2,67.4c1.8-.4,4.1,1.3,5.5,2.5.6-.6.7-.2.5,1-1.6,2.1-3.7-1.4-5.6-2.1s-4.2-.3-5.9-1.4c2.1-.3,3.2-.6,5.5,0Z"
          fill="#bef5fa"
        />
        <path
          d="M255.7,66.9c.2,0,2.8,1.4,3,1.5.4,0,.6,0,.5.5.8.3,1,.7.5,1-1.8-.5-3.7-2-5.5-2.5v-.5c.1-.8,1.1-.6,1.5,0Z"
          fill="#5f86d7"
        />
        <path
          d="M246.2,66.9l-.5,1c-.5.2-1,.3-1.5.5-.4,1.5-.9,1.8-1.5,1-.4-.1-.4-.3,0-.5-.5-1,.2-1.7,2-2,.5,0,1,0,1.5,0Z"
          fill="#5a95e9"
        />
        <path d="M282.7,262.3c0-2.3.3-4.4.5-6.5-.3,2.1.6,4.8-.5,6.5Z" fill="#2bbcfc" />
        <path
          d="M269.7,233.3c.2.1,1.2,0,2,.3,6.5,2.9,10.3,9.6,9,16.7-1.2.2-.8-.1-1.1-.6-1-1.5-1.9-3.3-2.9-4.9-.9-.1-.4,1-.3,1.5.2,1,.7,1.7.8,3-.1.4-.3.4-.5,0-.5-.9-.8-1.9-1-3-1.1-1.2-1.2-2-.5-2.5l-.5-.5c-.4-.2-.4-.3,0-.5-1.2-1.6-1.5-3.3.5-1.5,1.1-.2,1.6.6,1,1.5,3.2,2.7,1.5-1.8.2-3.7s-3.7-4-6.2-5.3c-.2.4-.3.4-.5,0-.3-.1-.3-.3,0-.5Z"
          fill="#002ce8"
        />
        <path
          d="M267.7,232.3c-.2,0-.3.1-.5,0-2.8-.9-5.3-1.6-8.3-2.3s-.7-.3-.7-.8c-1.5-.2-2.6-.5-3.5-1-.2-.5,0-.7.5-.5,1.2-.8,2-.8,2.5,0,.1-.3.3-.3.5,0,2,0,4.8-.8,6.4-.1s1.5,3.2,3.1,4.6Z"
          fill="#0027ef"
        />
        <path
          d="M277.2,249.8c0,.5,0,1,0,1.5-1.9,1.1-1.3-.8-.5-2h.5c0,.2,0,.3,0,.5Z"
          fill="#011a92"
        />
        <path
          d="M258.2,229.3c4.4.4,5.8,1.1,9.5,3s1.3.7,2,1v.5c-1.2.3-2.5-.2-4.1-1.3l-.4.3c-1.8.4-4.4-.9-6-2h-.5l-1-.5c-.3.7-.7.6-1,0l-.5-.5c-.9.5-1.5.5-2,0-.8-1.7,2.8-.9,4-.5Z"
          fill="#0116de"
        />
        <path
          d="M261.2,225.3c-.4.4-.4,1.7-2.5,2-.2,0-.3,0-.5,0-.1.3-.3.3-.5,0-1.1,0-1-.7,0-1,1-.3,2.5-.7,3.5-1Z"
          fill="#1c72f8"
        />
        <path
          d="M359.1,316.8c1.3,2.5,2.7,5,4,7.5.4,1.3.6,3.5,1,5-.5-.5-3.8-8.9-4.5-8,0,.8.3,1.7.5,2.5l-3-6c0-.2,0-.3,0-.5l-.5-1.5c-.1-.9-.3-1.7-.5-2.5l-.5-1c0-.1,0-.4,0-.5l-.5-.5v-.5c1.8.3,3.5,3.9,4,6Z"
          fill="#0f6dfb"
        />
        <path
          d="M351.2,298.3c2,3.7,3.3,8.3,5.1,12.1s3.2,3.9,2.9,6.4c-1.7-3.1-1.8-3.9-4-6s-1.1-2.2-2.5-3.5c0-.3,0-.7,0-1l-.5-1c-.9-2.5-1.7-5-2.5-7.5l-.5-.5c0-.2,0-.7,0-1,.9-.8,1.7,1,2,2Z"
          fill="#1480fc"
        />
        <path
          d="M346.2,283.8h1.3c1.4,1.7,3.9,7.6,3.2,9.5.1.3,0,1.1,0,1.5-.8-1.6-2.1-3.2-2.9-4.8s-.4-3.2-2-3.7c0,.6-.1,1.4,0,2h-.5c.3-1.1-.3-2.1-.5-3-1.6-3.7-.6-6,1.5-1.5Z"
          fill="#24b7fc"
        />
        <path
          d="M351.2,298.3c-.7-1.3-1.7-1.8-2-2s-.9-.7-1-1,0-.3,0-.5c0-.5,0-1,0-1.5.4-.4,3.4,4,3,5Z"
          fill="#1392fd"
        />
        <path
          d="M344.2,272.3c.4.2.4.3,0,.5l.5,1c.4.1.4.3,0,.5.4,1.8,1.1,3.5,2,5l.7-.2c1,2.3,2,4.6,2.8,6.7,1.7.3,3.2,5.5,1.5,6.5v1.5s-1-.5-1-.5c-.8-2-3.4-7.9-4.5-9.5-.3-1.2-1-2-1.9-2.3l.4-1.2-2.4-5.6.4-.9-.5-.5c-.4-.1-.4-.3,0-.5-3.2-5.7.5-6.1,2-.5Z"
          fill="#cffcfc"
        />
        <path
          d="M350.2,282.8c1.3-.2,1.6.6,1,2.5,1.3.7,1.5,1.1,1,2.5.7.7,2.5,3.1,2.9,4.1s1,4.4.6,4.9c.2,1.2,0,2.8,0,3-.8-.8-.8-2-1.4-2.9-.8-1.4-2.1-2.9-2.6-4.6s0-2.8-1-3.8c2.5.6-.3-2.1-.5-2.7-.7-.8-1.6-3.1-1-4,.7-.9,1.2,0,1,1Z"
          fill="#adf3f9"
        />
        <path d="M371.6,346.2c-.9-.2-.8-.9-1-1.5.6.4.7.9,1,1.5Z" fill="#1157ee" />
        <path d="M372.1,347.2c-.2-.1-.4-.3-.5-.5.2,0,.4.3.5.5Z" fill="#1157ee" />
        <path d="M356.7,297.8l-.5-.5c.1.1.4.2.5.5Z" fill="#0831cc" />
        <path d="M363.1,317.8c-.2-.2.5-.8.5-.2s-.4.4-.5.2Z" fill="#a2ebf2" />
        <path d="M360.6,325.2c-.5-.2-.4-.6-.5-1,.5.2.4.6.5,1Z" fill="#0f6dfb" />
        <path d="M366.6,339.7c-.2-.1-.4-.3-.5-.5.2.1.5.3.5.5Z" fill="#1f5af6" />
        <path
          d="M240.7,76.4c4.1-8.8,16.9-7.9,19.5,1.5l2.5,7.9c2.7,6.2,5.2,12.6,7.5,18.9l-.5.6c-1.3,0-1.6-.6-1.3,1,.5,2.7.2,3.3.3,5.5-2.2-3.9-3.6-8.1-5.6-12.1s-1.2-1.3-1.6-1.9c-1.9-3.6-.8-6.5-3.3-10.5s-3.9-4.1-4-4.3c-.4-1.1,1.1-3.7-.5-5.9s-5.1-2.2-5.9-2.3c-4.6-.2-3.5,6.2-7.7,6.9,0-.7,0-1.3,0-2-.3-.1-.3-.3,0-.5-.4-.7-.1-2.4.5-3Z"
          fill="#fcfcfa"
        />
        <path
          d="M265.2,90.4c2.8,3.1,5.3,8,5.3,12.1l1.1,2.4c.4.1.8.3.9.5,1.6,3.4,3.3,7.4,4.1,10.9,3.2,6.2,6.4,13.2,8,20-.4-1.3-1.4-.3-1.9-1.3-4.6-8.3-7.5-19.5-11.7-28.3-.4-.9-1.3-1.2-1.4-1.4-2.1-4-5.5-14.7-7-19.5.7,1.4,1.8,2.9,2.5,4.5Z"
          fill="#f1f8f7"
        />
        <path
          d="M300.7,172.8l.5.5c.4.1.4.3,0,.5l.5.5c1.6.9,2.3,2.5,2.9,4.2l6.3,16.3c1.1,2,1.7,3.8,1.8,6,1.3.2,1.2.5,0,1,.2,1.1,0,1.4-.7.8-1.9-4.3-3.8-8.6-5.8-12.8-1.7-4.3-3.8-8.5-5-13-.7-1.3-1.2-2.7-1.6-4.2s.6-.4,1.1-.3c.4.1.4.3,0,.5Z"
          fill="#6eddfa"
        />
        <path
          d="M286.7,140.3c1.1,1.4,2.1,3.2,2,5,2.5,4.8,4.5,9.8,6,15,1.7,2.2,2.9,5.2,3,8l1.5,3.4-.5.6c-5-11.7-10.7-23.2-14-35.5,1.1-.3,2.1,2.3,2,3.5Z"
          fill="#f1f8f7"
        />
        <path
          d="M281.7,126.4c2.2,3.7,4.4,7.8,5,12l.5,1.5c.2.7.2.8-.5.5-.4-1.1-1.2-2.6-2-3.5,0-.1,0-.4,0-.5-2.3-6.5-5.4-13.5-8-20-.2-.9,0-1.2.5-1,2.7,3.1,4.3,6.8,4.5,11Z"
          fill="#90f4f7"
        />
        <path
          d="M312.7,201.8c1.6.2,3.6,4.8,2.5,6,.4,3.1-1.2.6-2-1-2.2-5.7-4.8-11.3-7-17,2.2,1.5,2.5,5,3.6,7.7s1.1,2.3,1.7,3.3.9,2.1,1.3,1Z"
          fill="#7be6fa"
        />
        <path
          d="M313.2,206.8l1.8,2,.2-1c1.6-.1,4,4.7,3,6,.6,1.1.7,1.9.5,2.5-.1.4-.3.4-.5,0-.4-.2-.4-.3,0-.5-.6-.7-1-.9-1.5,0-1-2.9-2.4-6.1-3.5-9Z"
          fill="#85eafb"
        />
        <path
          d="M297.7,168.3l.5-.3c.4,1,.9,1.8,1.5,2.3.6,0,.9.5,1,1.5.4,0,.4.3,0,.5-.7.9.1,3.2.5,4.5-.8-1.1-2-3.3-2.5-4.5s-.5-2.8-1-4Z"
          fill="#7ae5f9"
        />
        <path
          d="M318.2,215.8c-.3.5-.6.6-.7.2s2,4.2,1.2,4.8l-1-1c-.3-1.3-.5-2.7-1-4-.1-.5.6-1.8,1-1.5,0,.6.3,1,.5,1.5Z"
          fill="#79dbfa"
        />
        <path
          d="M230.2,105.4c-1.4,5.6-5.2,12.8-7.5,18.5l-.5.5c0,.2,0,.8,0,1l-.5.5c0,.1,0,.4,0,.5-1.1,1.1-1.3.3-1-1,0-3.6,1.9-7.5,4-10.5,0-1.6.8-4.1,2-5,.4-1.3.6-2.7.7-4.1.8-3.1,2.8-7.6,4.8-9.9.2-.9.6-1.2,1-1,.3.7.4,1.5.1,2.2l-3.1,8.3Z"
          fill="#dff7f8"
        />
        <path
          d="M230.2,105.4c.9-3.4,1.7-6.9,3-10.5-.2-1-.1-2.8,1-3l1-2.5c-.9-1.9.1-4.2,2-5l1.3-4h.7c.1-.4.3-.4.5,0-1.7,7.1-3.5,11.8-6.3,18.5-.9,2.2-2.4,4.3-3.2,6.5Z"
          fill="#e4f9fa"
        />
        <path
          d="M218.2,135.3c-3.6,8.9-7.4,17.7-11,26.5-.4.6-.6.5-.5-.5-.7-.6-.3-1.7.5-2,2.1-5.6,4.3-11.1,6.6-16.5v-1c-.9-1.1.4-3.3,1.4-4,.1-.4.3-.4.5,0,1.7-3.3,2.6-4.1,2.5-2.5Z"
          fill="#d6eff2"
        />
        <path
          d="M221.7,126.4c-1.2,3-2.3,6.1-3.5,9-.5-1.2-.7.5-.9.8-.4.9-1,1.7-1.1,2.7l-.5-1c-.3-.1-.3-.3,0-.5l.5-.5c-.3-.3-.5-.6-.5-.8.6-2.8,2.7-7.8,4.1-10.3s.5-.3.9-.4l1,1Z"
          fill="#e0f6f9"
        />
        <path
          d="M195.7,194.3c-2.3,5.9-5,11.1-7.5,17-.6,1.6-1.4,3.1-2.5,4.5v.5l-.6-.4,2.1-6.1c-1-.3-.3-2.3.5-2.5l3.2-8.3.8-.2c.1-.4.3-.4.5,0,0,.2-2.6,4.9-.8,3.5l4.3-8.5c0,.1,0,.4,0,.5Z"
          fill="#e8fafb"
        />
        <path
          d="M207.2,161.8c-3.4,8.3-6.6,16.7-10,25l-.5,1c0,.1,0,.4,0,.5l-.5,1c0,.1,0,.4,0,.5l-.5.5c0,.1,0,.4,0,.5l-.5.5c0,.1,0,.4,0,.5l-.5.5c0,.1,0,.4,0,.5l-.5,1c0,.1,0,.4,0,.5l-.5,1c0,.1,0,.4,0,.5l-.5.5c0,.1,0,.4,0,.5l-.5.5c0,.1,0,.4,0,.5l-.5.5c0,.1,0,.4,0,.5h-.5l-.5-.5c.4-1.6.9-3.1,1.5-4.5v-.5c-.9-.6.3-3,1.5-2.5,4-9.4,8-19.1,11.6-28.8l.9-.7.5.5Z"
          fill="#ceeded"
        />
        <path
          d="M244.7,70.9l.3.7c-1.7,1.3-3.4,2.9-4.3,4.8-.3,1.1-.4,1.9-.5,3l-.5.5c0,.2,0,.3,0,.5h-.5c-.7-.9.3-6,.9-7s3.3-3.7,4.6-2.5Z"
          fill="#dff9f6"
        />
        <path d="M198.7,187.3c.2-.4.4-.7.5-1l-.5,1Z" fill="#e8fafb" />
        <path d="M196.7,187.8l.5-1c-.2.4-.4.8-.5,1Z" fill="#e8fafb" />
        <path d="M196.2,189.3l.5-1c-.2.5-.4.8-.5,1Z" fill="#e8fafb" />
        <path d="M196.7,191.3c.3-.7.9-1.2,1-1.5,0,.7-.3,1.3-1,1.5Z" fill="#e8fafb" />
        <path d="M194.3,193.8l.5-1c-.2.5-.4.8-.5,1Z" fill="#e8fafb" />
        <path d="M207.7,166.8c.3-.8.8-1.5,1-2l-1,2Z" fill="#e1f9f7" />
        <path d="M193.8,195.3l.5-1c-.2.4-.4.8-.5,1Z" fill="#e8fafb" />
        <path d="M221.7,125.9l.5-.5c-.1.4-.5.5-.5.5Z" fill="#e0f6f9" />
        <path d="M222.2,124.4l.5-.5c-.1.3-.5.4-.5.5Z" fill="#e0f6f9" />
        <path d="M240.2,79.9h-.5c0-.2.3-.4.5-.5,0,.2,0,.3,0,.5Z" fill="#e4f9fa" />
        <path d="M198.2,188.3c.1-.3.5-.4.5-.5l-.5.5Z" fill="#e8fafb" />
        <path d="M197.7,189.3c.1-.3.5-.5.5-.5l-.5.5Z" fill="#e8fafb" />
        <path d="M195.7,190.3l.5-.5c-.1.4-.5.5-.5.5Z" fill="#e8fafb" />
        <path d="M195.2,191.3l.5-.5c-.1.3-.5.4-.5.5Z" fill="#e8fafb" />
        <path d="M194.8,192.3l.5-.5c-.1.3-.5.4-.5.5Z" fill="#e8fafb" />
        <path d="M196.2,192.3c.1-.3.5-.4.5-.5l-.5.5Z" fill="#e8fafb" />
        <path d="M195.7,193.3c.1-.4.5-.5.5-.5l-.5.5Z" fill="#e8fafb" />
        <path d="M193.3,196.3l.5-.5c-.1.4-.5.5-.5.5Z" fill="#e8fafb" />
        <path d="M192.8,197.3l.5-.5c-.1.3-.5.4-.5.5Z" fill="#e8fafb" />
        <path d="M192.3,198.3l.5-.5c-.1.3-.5.4-.5.5Z" fill="#e8fafb" />
        <path
          d="M261.7,216.8c-1.3-.5-1.2-1.3,0-1.8s3.8,2.4,1.4,2.3c-.5.1-1.3.2-1.5-.5Z"
          fill="#043cf4"
        />
        <path
          d="M261.7,216.8c.4.4.9.5,1.5.5,1.1-.3,1.3-.2,1,1,.9,1.2-.5,2.2-1.8,2.2-1-1.1-1.4-.6-1.2,1.3-2.3.8-2.7,1.3-5.5,1.5s-3.1-.4-4.5-.5c-.4,0-.5-.2-.5-.5l-.5-1.5c0-1.3.4-1.3,1,0,1.1-1.8,3.6,1.2,2.3,1.9-.7-1.4,1.7-2.1,3.4-2.4,0-1.8.6-2.7,1.7-2.5,0-.3.3-.4,1-.5-.4-.1-.4-.3,0-.5-.2-1.6,1.7-1.5,2,0Z"
          fill="#043cf4"
        />
        <path
          d="M233.2,213.3c2-1.2,3.4.7,3.5,2.5q-1.1.8,0,0c.4-1.3,1.5-.9,1,.5.4.1.4.3,0,.5,0,.2.5.5.5.8,0,.3-.9.2-1,.2-.9,1.1,1.2.9,1.7,1.5s1.5,2.5-.2,2c-3-1.3-4.9-2.4-7.5-4.5-.5-.6-.7-1.1-.5-1.5,0-1.5,1-1.1,1.9-.3s-.3,1.4.2.3.3-.3.5-.5c.3-.3.2-.7,0-1-.4-.1-.4-.3,0-.5Z"
          fill="#0740ee"
        />
        <path
          d="M278.2,208.3c-.5.6-1.8,1.6-2.5,2.5-1.2,1.7-2.2,2.2-3,1.5-1.3-.7-.9-1.6.5-1.5-.1-1.2,1-2.1,2-2.5.2-1.4,1.1-1.9,2.3-2.4.9-1.8,1.9-3.2,3.2-4.1-.8,3-.4,3.8-2.5,6.5Z"
          fill="#25b4fb"
        />
        <path
          d="M266.7,219.3c-.5-.6,0-1.3,1.5-2-.7-1-.2-2,.9-1.5l1.1-1c-.6-1.3,1.1-3.5,2.5-2.5.5-.3,2.3-.3,3-1.5-3.5,4.5-3.7,5.5-9,8.5Z"
          fill="#56c9f9"
        />
        <path
          d="M265.2,218.3c1,.5.9,1.1-.5,2-1.4.7-2,1-3.5,1.5l-2-1.2c.7,0,1.7-1.8,1.8-1.8,1.9-.1,2,2.6,3.2-.5-.7-.8-.4-1,.5-.5.6-.4.9-.1.5.5Z"
          fill="#0b33f5"
        />
        <path
          d="M226.7,210.3c.5-.2.7,0,.5.5.8.7,1.5,1.5,2.1,2.5,1.1-.5,2.4,1,1.4,2,.3.4.4,1,.5,1.5-2.4-2-5.2-5-7-7.5.5-1.5,1.3-1.2,2.5,1Z"
          fill="#80e2fa"
        />
        <path
          d="M224.2,204.3c.9-.2,1.7,1.3,1,2,1.2.8,2.3,2.8,1.5,4-.7-.6-1.5-1.1-2.5-1-.7-.9-.7-1.4-1-2,2.3,1.5-.1-1.8,0-3.2l1,.2Z"
          fill="#4dc8f7"
        />
        <path
          d="M255.2,226.8c2.5-.4,2.3.6,0,1-.2.1-.3.3-.5.5-.1.8-1,.7-2.6-.3l-.9.3c-.2.5-.6.4-1,0-.4-.1-.4-.3,0-.5,1-.7,2.5-1,4.5-1,.2,0,.3,0,.5,0Z"
          fill="#3971f8"
        />
        <path
          d="M254.7,226.8c-1.2.2-3.4.9-4.5,1-.2.3-.3.3-.5,0l-2-1c2.3.2,4.7-.1,7,0Z"
          fill="#5955ef"
        />
        <path
          d="M266.7,219.3c-.8.5-1.2.6-2,1,.4-.6.5-1.3.5-2,0-1.5,2.2-2.3,3-1-.5.6-1,1.4-1.5,2Z"
          fill="#0d4cf8"
        />
        <path
          d="M257.7,226.3v1c.3.1.3.3,0,.5-.8,0-1.7,0-2.5,0,.8-.6,1.9-1,0-1,.8-.2,1.9-.3,2.5-.5Z"
          fill="#4582f0"
        />
        <path
          d="M265.2,166.3c.1,0,.4,0,.5,0,9.7,6.5,16.8,14.5,15.5,27-.3,2.2-1.2,5-1.5,7-.3,1.5-1.8,1.8-2.5.5-1.3-.2-1.3-.6,0-1,0-2.2,1-4.4,1.9-6.3.3-6.3-1.6-12.8-6-17.5v-.7c-2.4-3.9-6.2-6.6-10-9-.4-.1-.4-.3,0-.5.3-.8,1.4,0,2,.5Z"
          fill="#0565fa"
        />
        <path
          d="M230.2,168.3v.8c-6.3,4.7-8.9,12.9-8.3,20.4,1.7-.3,2.1.8,1.3,3.4.4,1.3.8,3.4,0,4.5v1.5c-.8-.4-.5-1.7-.5-2.5l-.9-.6c.3-1.1-.2-1.8-1.4-2-1.1-4-1.1-8.1-.1-12.4,1-3.3,2.6-5.7,4.5-8.5,1.9-1.4,3.5-3.3,5.5-4.5Z"
          fill="#0b7bfb"
        />
        <path
          d="M261.7,164.8c1,.1,1.5.4,1.5,1v.5h-.5c-.2.4-.3.4-.5,0l-.5-.5c-.1.4-.3.4-.5,0l-1-.5c-.1.4-.3.4-.5,0l-3.5-1.5c-.3,1.3-.9,1.2-1.5,0-4-.6-8.5-.7-12.5.5,0,.5-.3.4-.5,0l-1.5.5c-.1.4-.3.4-.5,0l-.5.5c-2.5,1.8-5,2.8-7.5,3-.3-.2-.3-.3,0-.5-.3-.1-.3-.3,0-.5,9.7-5.9,19.5-6.3,30-2.5Z"
          fill="#0351fd"
        />
        <path
          d="M277.2,175.8c.4,1.4,1.9,2.7,2.5,4.2,2,4.7,2.2,8.4,1.5,13.3-.5-4-1.1-10.3-2.8-13.9s-9.2-10-12.7-13c4.7,2,7.7,6.4,11.5,9.5Z"
          fill="#1077fa"
        />
        <path
          d="M231.7,168.3c.4.1.4.3,0,.5l-3.7,3.2c-2.5,4-4.3,8.4-5.2,13.3.5.5,1.2.8,2,1,.4,0,.4.4,0,1,1.2,0,1.2.6,0,1l-.5,1.5c.4.1.4.3,0,.5.1,1.2,0,2-.5,2.5-.1.4-.3.4-.5,0-.2-4.2-.3-1.5-2-2.7s-.1-5.4,0-6.5c1.1-6.7,4.3-10.7,8.9-15.3.1,0,.3,0,.5,0,.3-.3.6-.6,1-.5,0,.2,0,.3,0,.5Z"
          fill="#0155f8"
        />
        <path
          d="M265.2,166.3c-.8-.4-1.6-.3-2-.5-.6-.3-1.3-.9-1.5-1,1.4,0,2.9.2,3.5,1.5Z"
          fill="#1077fa"
        />
        <path d="M231.7,167.8c-.3.1-.7.4-1,.5.2-.5.6-.7,1-1v.5Z" fill="#0b7bfb" />
        <path
          d="M220.2,181.3c.5,2.2-1.3,10.5.5,11.8s1.9-.5,2-.3c-.1,1.1.2,2.5,0,3.5s-.6,1.9-1.5,1.5c-2.6-5.8-2.9-10.5-1-16.5Z"
          fill="#0d88fd"
        />
        <path
          d="M223.2,197.3h1.5c2-2.4,1.7,1.9,0,3,1,.3,1.7,2.5.5,3,.4.1.4.3,0,.5l.5,1c.7-.6.9-.3.5.5.8,1.5.4,3.2-1,1-.3-.7-.8-1.3-1-2s-.9-3-1-3.5,0-1.3,0-2,0-1,0-1.5Z"
          fill="#031485"
        />
        <path
          d="M281.7,197.3c0,1.9-.6,2.8-1,4.5-1,1.1-1.6,3.8-2.5,4.8s-1.7.3-3,1.7c-.4,0-.4-.5,0-1.5,0-.4.2-.9.5-1.5.1-.4.3-.4.5,0,.3-1.5,1.8-4,3.5-4,.1-.2.5-.5.8-1,.4-1,.5-3.6,1.2-4,0,.3,0,.7,0,1Z"
          fill="#139ffb"
        />
        <path
          d="M279.7,200.3c0,.3,0,.7,0,1-1.8,3.7-2.7,2.3-2.9,2.6s0,.9-.6,1.4c-1.1-.3-1.1-2.2,0-2.4l.4-1.6c-.7-.8-.4-1.1.5-.5.7-.5,1.8,0,2.5-.5Z"
          fill="#0487fa"
        />
        <path
          d="M337.2,263.3c1.4,2.7,2.8,5.5,4,8.5.5,0,.8.4,1,1,0,.2,0,.3,0,.5l.5.5c.7,2.2,1.5,4.3,2,6.5l-1.2-.2c-.4-1.8-1.2-3.4-2.3-4.8-.4-.2-.7-.7-1-1,0-.2,0-.3,0-.5l-.5-1c0-.2,0-.4,0-.5l-.5-.5c0-.1,0-.3,0-.5l-.5-.5c0-.2,0-.3,0-.5-.6-1.4-1.1-2.9-1.5-4.5-.3-.4-.5-.8,0-1l-.5-.5c-.4-.1-.4-.3,0-.5-.5-1.3-.3-1.6.5-1,.3.2.3.3,0,.5Z"
          fill="#45cffb"
        />
        <path
          d="M337.2,262.8c-.4.2-.5.6-.5,1-1.1-1.3-2-2.9-2.5-5,0-.2,0-.3,0-.5l-.5-1c-.3,0-.3-.3,0-.5-.9-1.1-.9-3,.7-1.7l2.8,7.7Z"
          fill="#4dd4fc"
        />
        <path d="M338.7,270.3c-1.2-1-1.2-2.6-1.5-4v-.5c1.1,1.2,1.1,3.1,1.5,4.5Z" fill="#4dd4fc" />
        <path
          d="M336.7,263.8c0,.2,0,.3,0,.5l.5.5c0,.3,0,.7,0,1s0,.3,0,.5c-1.3-2.4-2.5-4.9-3-7.5l2.5,5Z"
          fill="#52d7fc"
        />
        <path d="M334.2,258.3h-.5c0-.2,0-.3,0-.5v-.5c.5.2.4.6.5,1Z" fill="#52d7fc" />
        <path d="M340.2,273.8c-.5-.2-.4-.6-.5-1,.5.2.4.6.5,1Z" fill="#4dd4fc" />
        <path d="M339.7,272.3c0,0-.4-.2-.5-.5l.5.5Z" fill="#4dd4fc" />
        <path d="M339.2,271.3s-.4-.1-.5-.5l.5.5Z" fill="#4dd4fc" />
        <path d="M357.2,317.3c-.7-.2-.4-1-.5-1.5.7.3.5.9.5,1.5Z" fill="#1b76fc" />
        <path d="M356.2,313.3c0,0-.3-.5-.5-1l.5,1Z" fill="#1480fc" />
        <path d="M355.7,311.8c0,0-.5-.2-.5-.5l.5.5Z" fill="#1480fc" />
        <path d="M352.7,306.3c0-.1-.3-.5-.5-1l.5,1Z" fill="#1c87fc" />
        <path d="M349.7,297.8s-.4-.1-.5-.5l.5.5Z" fill="#1392fd" />
        <path
          d="M320.7,224.3c-.6-1.3,0-1.9.8-.8l2.7,6.3c.3,0,.2.3,0,.5.4,1.3.9,2.4,1.5,3.5.1-.4.3-.4.5,0l.5,1.5c1.7,1.2,3.5,4.9,2.5,7,0,1.2.2,2.4.6,3.5l-.6.5-2.5-5c-.2-.8-.7-1.7-1-2.5l-.5-1c0-.2,0-.3,0-.5-.6-.7-.7-1.4-.5-2-1.4-3.4-2.9-7-4-10.5-.4-.1-.4-.3,0-.5Z"
          fill="#5de2fc"
        />
        <path
          d="M324.7,235.3c-.2.3-.6,0-1-1,0-.2,0-.4,0-.5-.8-.9-1.2-2.3-1.5-3.5-.5-1.1-1-2.3-1.5-3.5,0-.3,0-.7,0-1-.3-.5-.3-.8,0-1,1.7,3,3.1,7.1,4,10.5Z"
          fill="#68dffc"
        />
        <path d="M323.7,233.8h-.5c-.1-.7-.7-1.7-1-2.5v-1c.5,1.3,1,2,1.5,3.5Z" fill="#aef3fb" />
        <path
          d="M323.7,234.3l1.5,3c.4.2.4.3,0,.5l.5,1c1.4-.3,2.3,1.8,1,2.5,2.4,4.7,1.4,8.2-1.5,2-.3-.8-.7-1.7-1-2.5-.8-1.8-1.5-3.6-2-5.5.2-.8.5-1.3,1-1.5.1-.4.3-.4.5,0,.4.1.4.3,0,.5Z"
          fill="#b1f5fa"
        />
        <path d="M324.7,235.3c.2.7.4,1.3.5,2-1-.8-1.2-1.9-1.5-3l1,1Z" fill="#aef3fb" />
        <path d="M325.7,238.8c-.5-.2-.4-.6-.5-1,.5.2.4.7.5,1Z" fill="#aef3fb" />
        <path d="M323.4,236.3c.3.2.3.3,0,.5v-.5Z" fill="#ddfafb" />
        <path
          d="M344.7,280.3c.6,1.1,1.4,2,1.5,3.5-.5-.7-1.3-1.6-2-2,.2,1.1.3,2.4.5,3.5-.6-1.1-1-2.3-1.5-3.5s0-.4,0-.5l-.5-.5c-.3-1.2-.6-2.8-1-4l-.5-.5c0-.2,0-.7,0-1,0,0,.4-.6,1,.2s1.7,3.4,2.5,4.8Z"
          fill="#2cb9fc"
        />
        <path d="M343.2,281.3c-.2,0-.4-.3-.5-.5.3,0,.4.3.5.5Z" fill="#3abefd" />
        <path d="M341.7,276.8s-.4-.1-.5-.5l.5.5Z" fill="#45cffb" />
        <path
          d="M334.7,255.3c2.2,1.6,3.6,5.3,3,8-.1.4-.3.4-.5,0,0-.1,0-.4,0-.5-1-2.5-2.4-4.9-3-7.5-.9-.1-.4.9-.5,1.5-.1.4-.3.4-.5,0-.7-1.8-1.3-4-2.5-5.5-.3-1.4-.8-3.2-1.5-4.5,0-.2,0-.3,0-.5-.2-1.3-.8-3,0-4,3,3.3,5.4,8.6,5.5,13Z"
          fill="#52d7fc"
        />
        <path d="M333.7,257.3c0,.2,0,.3,0,.5-.5-.2-.4-.7-.5-1h.5c0,.2,0,.3,0,.5Z" fill="#63ddfd" />
        <path d="M320.7,231.3c-1.1-.7-1.1-2-1.5-3,1,.8,1.2,1.9,1.5,3Z" fill="#cff9fb" />
        <path d="M321.2,232.3c-.2,0-.4-.3-.5-.5.2.1.4.3.5.5Z" fill="#cff9fb" />
        <path
          d="M191.8,346.7c-.8.6-1.7,1.4-2.5,2-3.2,2.4-7.2,4.6-10.5,7-.3-1-1.5,0-2,.2-1.8,1-3.9,3.5-6,2.8,1.9-1.3,4.3-1.9,5.5-4l8.2-5.8.8.3,5.8-3.8c.9-.2,1.1.4.7,1.3Z"
          fill="#165af0"
        />
        <path
          d="M132.3,327.7l.5.2c.5-2.8,2.2-5.9,2.5-1.2.5,1.4-1.1,5.4-2.5,6-1-.7-2.7,4.1-1.5,3.5.4,1-.3,2.6-1,3.5-.5,1.1-1.4,2.8-2,4-.1.3-.3.3-.5,0,0-.3,0-.7,0-1-.6-.7-.7-1.7-.5-3,.9-2.3,1.6-5.2,2.5-7.5-.6-1.7.6-4.3,2.5-4.5Z"
          fill="#7de5f9"
        />
        <path d="M127.8,342.7l-3,3c.5-2.2,1.8-4.1,2.5-6,1.1,1,.6,2.1.5,3Z" fill="#82ddfa" />
        <path d="M127.3,345.2c.1-.5.4-1.1.5-1.5h.5c-.3.6-.4,1.1-1,1.5Z" fill="#82ddfa" />
        <path
          d="M203.7,331.2c.2.7-.3,1.3-1.5,2-.5,2.7-4.8,5.9-7.5,6-.3.5-.7.6-1,.5-1.1-.5,1.7-1.5,2-2.3l-1-.2c.8-1.1,1.9-1.9,3.5-2.5,1-1.7,3.2-2.8,5-3.5h.5Z"
          fill="#0c82f5"
        />
        <path
          d="M194.8,339.2c1.1-.1,2,0,2.5.5l.2.5c-2.4,1.5-4.8,3-7.2,4.5-.4.5-.9.6-1,0,.8-.7,3.5-2.6,2.5-3,.5-.8,1.3-1.4,2-2s.7-.3,1-.5Z"
          fill="#032ad6"
        />
        <path
          d="M198.2,334.7c-1.1.7-2.3,1.9-3.5,2.5s-1.7.7-2.5,1c.9-.8,1.4-1.3,2.5-2l1-.5c.1,0,.4,0,.5,0l1-1c.1,0,.3,0,.5,0,.2-.3.3-.3.5,0Z"
          fill="#32b2fb"
        />
        <path
          d="M190.3,344.7c.2-.2.3-.2.5,0v.8c-1.8,1.2-3.7,2.4-5.5,3.7-3.6,2-5.3,3.7-9,5.5s-.4,0-.5,0l8.5-6.5c1.6-.9,3.6-2.4,5-3.5h1Z"
          fill="#0747e9"
        />
        <path d="M205.2,327.7c1.3-.7,3-3.1,5-3-.9,1.7-3.3,2.6-4.5,3.5l-.5-.5Z" fill="#35b6f8" />
        <path d="M203.2,331.2c-1.8,1-3.3,2.4-5,3.5h-.5c1.1-2.2,3.8-2.8,5.5-4v.5Z" fill="#35b6f8" />
        <path d="M195.7,335.7l-1,.5c.4-.3.7-.3,1-.5Z" fill="#35b6f8" />
        <path d="M196.2,335.7l1-1c-.2.1-.4.7-1,1Z" fill="#35b6f8" />
        <path d="M193.8,335.2h.5c-.3.3-.2.4-.5,0Z" fill="#35b6f8" />
        <path d="M195.7,334.2l.5-.5c-.2.2-.3.3-.5.5Z" fill="#35b6f8" />
        <path
          d="M222.7,291.3c.4,2.9.4,6.1,0,9l-1.1-.3c-.2-2.1-.9-3.8-2.2-5.2.2,1.7-.8,4.1-2.7,3,0-1,0-2,0-3s0-.7,0-1c.2-.9.3-1.7.5-2.5,0-.2,0-.3,0-.5.5-.6,1.4-.9,2.6-.8.8-1.1,1.6-1.5,2.4-1.2.3.7.5,1.5.5,2.5Z"
          fill="#069cfe"
        />
        <path d="M216.7,293.8c0-.8,0-1.7,0-2.5h.5c0,.8.3,2.1-.5,2.5Z" fill="#06a5fe" />
        <path d="M215.2,280.3c0-.2,0-.3,0-.5,0-.5,0-1,0-1.5h.5c0,.7.3,1.7-.5,2Z" fill="#46ddfe" />
        <path
          d="M185.8,216.3c0,.6-.4,1.4-.5,2-.9,1.5-1.3,3-2,4.5s0,.4,0,.5l-.5.5-.5.5v.5l-.5.5c.3.2.3.3,0,.5-.5.7-.6.5-.5-.5-.6,0-.4-.6,0-1,.3-.9.6-1.8,1-2.5.6-4.1,2.1-9.1,5-12-.7,2.6-1.4,4.1-1.5,6.5Z"
          fill="#e2fafd"
        />
        <path d="M185.8,215.8l2.5-4.5c-.6,1.5-1,3.6-2.5,4.5Z" fill="#e2fafd" />
        <path
          d="M246.2,227.8c-2.8.3-5.6.3-8.6,0-5.2.6-10.5,6.3-13.7,10.1h-.7c-.7,1.6-1.6,3.1-2.5,4.4-.8.7-.7-.2-.6-1.1l1.6-3.9c2.7-4.7,7-8.2,12-10.5,3.6-.8,6.7-.6,10.3,0s1.9-.2,2.2,1Z"
          fill="#0252fb"
        />
        <path
          d="M218.2,248.8c1.5,1.2,2.8,2.8,5,2,0,1,0,2,0,3,.7,1.9.7,3.6,0,5,.4.8.4,1.7,0,2.5-1.1-1.7-.3-4.4-.5-6.5-1.9-.2-4.6-2.1-4.5-4,0-.6,0-1.4,0-2Z"
          fill="#0590fb"
        />
        <path
          d="M220.7,242.3h.5c-.2,2.7.2,6,3,3.5-1.9-1.3,2.2-2.1.5,1,1,.3,1,.7,0,1l-.5,1.5c.4,0,.4.3,0,.5-.1.4-.3.4-.5,0-.2-2.3-3.5.9-3.9-2.8s0-6.2,1.9-9.7c0,1.3-1.3,2.8-1.4,3.9s.4,1,.4,1.1Z"
          fill="#0259f4"
        />
        <path d="M217.7,247.8h-.5c0-.3,0-.7,0-1,.7,0,.4.5.5,1Z" fill="#09abfc" />
        <path
          d="M170.8,248.8c-.9,2.8-1.6,5.7-2.9,8.4l1.4-.9c0,.1,0,.4,0,.5s0,.4,0,.5l-.5.5c0,.1,0,.4,0,.5l-.5.5c0,.1,0,.4,0,.5l-.5,1c0,.1,0,.3,0,.5-.6.8-1.1,1.7-1.5,2.5v.5l-.5.5c.2.2.2.3,0,.5l-.5.5v.5l-.5.5c.2.1.2.5,0,1l-.5.5v.5l-.5.5c.2.1.2.3,0,.5,0,.1,0,.4,0,.5l-.5.5c0,.1,0,.3,0,.5l-.5.5c0,.1,0,.3,0,.5-.9-.7-.1-1.6,0-2.5-.4,0-.4-.3,0-.5l2.5-6.5c-1.2-.9.2-4.3,1.5-4.5.9-3.1,1.9-6.5,4-9Z"
          fill="#6ee2fb"
        />
        <path
          d="M173.8,240.8c-.9,2.7-2.1,5.3-3,8l-4,9-.9-.9c.8-3.2,2-6.3,3.8-9.1h-.9c-.9-1.6,1.2-7,3-7l.8-.7c.4-1.8,1-2.4,1.7-1.8.2.8,0,1.6-.5,2.5Z"
          fill="#28bcf6"
        />
        <path
          d="M181.8,225.8c.2.2.2.3,0,.5,0,.1,0,.4,0,.5l-.5.5-.5.5c0,.1,0,.4,0,.5l-.5.5c0,.1,0,.4,0,.5l-.5.5c0,.2,0,.8,0,1l-.5.5c0,.1,0,.3,0,.5l-.5,1c0,.2,0,.3,0,.5l-.5.5c0,.2,0,.3,0,.5l-.5,1c0,.2,0,.3,0,.5l-.5.5c0,.2,0,.4,0,.5l-1.2,1.2c-.9,0,4.1-12,5.2-12.7l.5.5Z"
          fill="#c2f2fb"
        />
        <path
          d="M181.8,221.8c.3.6,0,1.5-.5,2-1.6,4.4-3.4,8.8-5.5,13-.6,1.3-1.3,2.7-2,4,.2-.7.2-1.7.5-2.5l-.5-.5c1.6-4.1,3.2-8.4,5-12.4s.3.8-.5,0c-.5-1.4.1-2.9,1.5-3.5h.5c.4-1.8,1-3,2-3.5,1,.4,0,2.6-.5,3.5Z"
          fill="#36bff7"
        />
        <path
          d="M181.3,224.3c0,.3,0,.7,0,1-1.1,3.4-3.7,7.3-4.8,10.9s0,1.1.8.6c-.5,1-1.3,1.9-1.7,3l.2-3c1.9-4.3,3.1-8.9,5.5-13v.5Z"
          fill="#bdf3fc"
        />
        <path d="M178.3,235.3h-.5c.1-.4,0-.8.5-1,0,.3,0,.7,0,1Z" fill="#bdf3fc" />
        <path d="M169.3,255.8c.1-.4.5-.5.5-.5l-.5.5Z" fill="#6ee2fb" />
        <path d="M177.3,236.3c0-.2.3-.4.5-.5,0,.2-.3.4-.5.5Z" fill="#bdf3fc" />
        <path
          d="M148.3,302.8c0,.3,0,.7,0,1l-.5,1c0,.2,0,.3,0,.5l-1,2c0,.1,0,.4,0,.5l-.5.5c0,.1,0,.4,0,.5l-1.5,3c0,.1,0,.3,0,.5l-.5,1c0,.2,0,.3,0,.5l-.5.5c.6.2.7.9,0,1-.1.3-.3.3-.5,0-.8-.3-.8-1.3-.1-2.8l-.4-.7c-.7.1-.7-.5,0-2-.7-1.7-.1-3.5,1.5-4.5.2-1.2.7-2,1.5-2.5l2.5-1.5c0,.5,0,1,0,1.5Z"
          fill="#0f94fb"
        />
        <path
          d="M144.8,314.8c0,.2,0,.3,0,.5l-1.5,3c0,.1,0,.3,0,.5l-1,2c0,.1,0,.3,0,.5l-2.5,5c-.2,0-.4-.5-.5-.5,0-.3,0-.8,0-1l.5-.5c0-.1,0-.3,0-.5l.5-.5c0-.2,0-.3,0-.5l.5-.5c-.3-.1-.3-.3,0-.5l.5-1c-.4-.2-.4-.3,0-.5l.5-.5c-.4-.2-.4-.3,0-.5l.5-1c-.4-.1-.4-.3,0-.5l.5-.5c-.4-.1-.4-.3,0-.5l1-1.5c0-.2,0-.7,0-1,.2-.2.3-.2.5,0l.5.5Z"
          fill="#2eacfc"
        />
        <path
          d="M155.8,278.8c2.7-3.9,4.5-7.9,5.3-12.6,3-3.1,2.1,2.2.7,4.1,0,.2,0,.3,0,.5l-1.5,3c0,.3,0,.7,0,1l-1,2c0,.2,0,.3,0,.5-1.1.8-1.1,2.4-1.5,3.5l-.5.5c0,.1,0,.4,0,.5l-.5,1c0,.1,0,.4,0,.5l-.5.5c0,.1,0,.4,0,.5l-.5,1c0,.1,0,.3,0,.5l-.5.5c0,.2,0,.3,0,.5-.9,1.1-1.5,2.7-2,4-.4-2.5,3.7-5.7,1-7.5-1.1,2.4-1.5,5.2-2.6,7.6s-2,2.7-2.4,3.4c-.3-2.9,1-5.9,3-8,.8-2.6,1.8-5.1,3-7.5.1-.4.3-.4.5,0Z"
          fill="#18acf9"
        />
        <path d="M147.8,304.8l.5-1c-.1.8-.5.9-.5,1Z" fill="#2eacfc" />
        <path d="M146.8,307.3l1-2c-.3,1.1-.8,1.6-1,2Z" fill="#2eacfc" />
        <path d="M144.8,311.8c.3-1.1.5-2.2,1.5-3-.4,1-.4,2.3-1.5,3Z" fill="#2eacfc" />
        <path d="M144.3,313.3l.5-1c-.2.7-.5.9-.5,1Z" fill="#2eacfc" />
        <path d="M145.3,313.3c.2-.5.4-.8.5-1l-.5,1Z" fill="#2eacfc" />
        <path d="M144.3,314.3h-.5c0-.2.3-.4.5-.5,0,.2,0,.3,0,.5Z" fill="#2ba8fc" />
        <path d="M145.8,311.8c.1-.4.5-.5.5-.5l-.5.5Z" fill="#2eacfc" />
        <path d="M146.3,310.8c.1-.3.5-.4.5-.5l-.5.5Z" fill="#2eacfc" />
        <path d="M146.8,309.8c.1-.3.5-.4.5-.5l-.5.5Z" fill="#2eacfc" />
        <path d="M147.3,308.8c.1-.3.5-.4.5-.5l-.5.5Z" fill="#2eacfc" />
        <path d="M146.3,308.3l.5-.5c-.1.3-.5.5-.5.5Z" fill="#2eacfc" />
        <path d="M147.8,307.3c0-.2.3-.4.5-.5,0,.2-.3.4-.5.5Z" fill="#2eacfc" />
        <path
          d="M216.7,301.3c1.2-.3,2.4.5,3.6,2.3,1.9,0,1.6,1.5,1.2,3,1,1.8,1.5,3.9.8,6.1.8,2.8.7,7.6-1,10-3.1-.5-3.8-4.4-3.3-7-.1,1.5-.7,2.3-1.7,2.5,0-3,0-6,0-9s0-1,0-1.5c0-1,0-2,0-3,.9-.7.5-2.4.5-3.5Z"
          fill="#018bfe"
        />
        <path
          d="M221.2,324.2c.7-.2.8.4.5,1-.3,1.2-7.1,5.8-7.7,5.8s-.6-.4-.8-.8c-.7.7-1,.4-.5-.5v-1.2s5.9-3.6,5.9-3.6c-1.9-.9-4.2.1-6.9,3.3-1.1,1.1-2.1,1.3-3,.6.2-.7.7-1.5,1.5-2.5,1-.8,2.2-2.4,3-3s1.7-1.4,2-1.5c1.8-2.5,5.4.1,6,2.5Z"
          fill="#0550f2"
        />
        <path
          d="M216.2,318.3c.2-1.2.9-2.4.5-4,.3-.3,2.9,1.4,3,1.5.1.2-1.1,1-1,2.2s1.5,4,2.5,4.8c.8.2.7,1.2,0,1.5-1.3-1.7-3.8-3-6-2.5.9-1.1.8-2.3,1-3.5Z"
          fill="#017efd"
        />
        <path d="M181.8,226.3c0-.1,0-.4,0-.5s0-.4,0-.5h.5c0,.4,0,.8-.5,1Z" fill="#8edcf6" />
        <path d="M178.8,232.8l.5-1c-.2.6-.5.9-.5,1Z" fill="#bdf3fc" />
        <path d="M182.8,223.8c0-.2.4-.3.5-.5-.1.2-.4.3-.5.5Z" fill="#8edcf6" />
        <path d="M182.8,224.3h-.5c0-.2.5-.4.5-.5,0,.1,0,.4,0,.5Z" fill="#c2f2fb" />
        <path d="M182.3,224.8c0-.2,0-.4,0-.5h.5c-.1.2-.4.4-.5.5Z" fill="#8edcf6" />
        <path d="M182.3,225.3h-.5c.1-.2.4-.4.5-.5,0,.1,0,.3,0,.5Z" fill="#c2f2fb" />
        <path d="M181.3,227.3c.2-.2.3-.3.5-.5,0,.2-.3.3-.5.5Z" fill="#8edcf6" />
        <path d="M180.8,227.8c.1-.2.3-.3.5-.5-.2.2-.3.3-.5.5Z" fill="#bdf3fc" />
        <path d="M180.3,228.8l.5-.5c-.1.3-.5.4-.5.5Z" fill="#bdf3fc" />
        <path d="M179.8,229.8l.5-.5c-.1.3-.5.4-.5.5Z" fill="#bdf3fc" />
        <path d="M179.3,231.3l.5-.5c-.1.4-.5.5-.5.5Z" fill="#bdf3fc" />
        <path d="M178.3,233.8l.5-.5c-.1.4-.5.5-.5.5Z" fill="#bdf3fc" />
        <path d="M143.3,318.3c.4-1.1.5-2.2,1.5-3-.3,1.1-.5,2.2-1.5,3Z" fill="#2ba8fc" />
        <path d="M142.3,320.8l1-2c-.3,1.1-.8,1.5-1,2Z" fill="#2ba8fc" />
        <path d="M155.8,285.3c.2-.6.5-.9.5-1l-.5,1Z" fill="#38c1fc" />
        <path d="M156.8,282.8c.2-.5.4-.8.5-1l-.5,1Z" fill="#38c1fc" />
        <path d="M155.3,286.3c.1-.3.5-.5.5-.5l-.5.5Z" fill="#38c1fc" />
        <path d="M156.3,283.8c.1-.4.5-.5.5-.5l-.5.5Z" fill="#38c1fc" />
        <path d="M157.3,281.3c.1-.4.5-.5.5-.5l-.5.5Z" fill="#38c1fc" />
        <path d="M159.3,276.8c.2-1.3.9-1.7,1-2l-1,2Z" fill="#47cdfc" />
        <path d="M160.3,273.8c.4-1.1.5-2.2,1.5-3-.3,1.1-.5,2.2-1.5,3Z" fill="#23b1fa" />
        <path
          d="M166.8,257.8c-.2,1.6-.9,3-1.5,4.5l-2.5,6.5c0,.2,0,.3,0,.5l-1,1c.2-.7,1.3-3.7,1-4h-1.5s.5,1.8.5,1.8c-1.9-.5-.3.6-.7,2.2-.7,3-3.2,6.3-5.3,8.5-.7-1.9.8-5,2.5-6,0-.7.2-1.2.5-1.5,1.3-5.7,3.8-11.6,6.2-17,.6-2.3,1.7-4.1,3.3-5.5l.5-.5c-.4-.1-.4-.3,0-.5.5-.9,1.6-1.7,1.5-3,2.3,1.7-1.7,6.1-2.5,8.2s-.7,3.2-1,4.8Z"
          fill="#23b1fa"
        />
        <path d="M136.8,331.2c.1-.4.5-.5.5-.5l-.5.5Z" fill="#31a0fa" />
        <path
          d="M210.2,326.2c.4,1.3-.6,1.6-1.5,2.5,0,2.4-4.2,5.3-6.5,4.5.5-.5,1-1.5,1.5-2,2.2-2,4.3-3.3,6.5-5Z"
          fill="#0459fa"
        />
        <path
          d="M167.8,261.3l-.5.5c0,.1,0,.4,0,.5l-.5.5c0,.1,0,.4,0,.5h-.5c.4-.9.3-2.1,1.5-2.5,0,.2,0,.3,0,.5Z"
          fill="#5ddafc"
        />
        <path d="M164.8,267.3c0-.2,0-.8,0-1h.5c-.2.4-.4.8-.5,1Z" fill="#47cdfc" />
        <path d="M163.8,269.3c0-.1,0-.4,0-.5h.5c0,.2-.3.4-.5.5Z" fill="#47cdfc" />
        <path d="M164.3,268.8h-.5c0-.2.5-.4.5-.5,0,.2,0,.3,0,.5Z" fill="#5ddafc" />
        <path d="M164.3,268.3c0-.2,0-.4,0-.5h.5c0,.2-.5.4-.5.5Z" fill="#47cdfc" />
        <path d="M164.8,267.8h-.5c.1-.2.5-.4.5-.5,0,.1,0,.4,0,.5Z" fill="#5ddafc" />
        <path d="M165.3,266.3h-.5c0-.2.4-.4.5-.5,0,.1,0,.4,0,.5Z" fill="#5ddafc" />
        <path d="M165.8,265.3h-.5c0-.2.4-.4.5-.5,0,.1,0,.4,0,.5Z" fill="#5ddafc" />
        <path d="M166.3,264.3h-.5c.1-.2.4-.4.5-.5,0,.1,0,.4,0,.5Z" fill="#5ddafc" />
        <path d="M166.8,262.8c0-.2.3-.4.5-.5,0,.2-.3.4-.5.5Z" fill="#47cdfc" />
        <path d="M167.3,261.8c.1-.3.5-.5.5-.5l-.5.5Z" fill="#47cdfc" />
        <path
          d="M205.2,175.8c1-.4,1.9,1.5,2.5,1s1.2-3.8,1.8-2,0,1.9.2,2.7,1.4.4,1.5,1.6-.8,2.5-.5,3.7c.7,0,1.2-.8,1.8,0,0,1.6.3,4.1.9,5.6s2.4,2.5,2.4,2.7c0,1.9-2.6,5.6,0,7.7l.7.4c.9,3.5,1.8,7.1,2.8,10.6l1,.3,3,4.7h.6c1.5,1.9,3.3,3.6,5.4,5,1.2-.9,3.6,1,3.5,2.5l1,.5c1.2-1.2,6.9.5,6.5,2.5l-.2.5c-2.1,0-4.3.4-6.3,1-6.3,2.2-11.5,7.3-14.2,13.4h-.8c-.3,2.5-.8,4.6-1.5,6.6-.2,1-.6,1.7-1,2,.2,1,.2,3-1,3,.4.4.8.8.9,1.3.2,1.8.2,13.5-.2,14.1s-.4.4-.7.6c.2,1.4,0,2.4-.5,3,.4.6.4,1.4,0,2,1.7,2.4,1.1,4.6,0,7,.4,4.1.4,8.3,0,12.5,1.6.3,1.3,4.4,0,5,.2,2,.6,3.8,1,5.4-.7,1.3-1,2.8-1,4.6,1,.3.9,1.1,0,1.5,1.1.1,1,1.1,0,1.5l.7.5c.2,3.1.7,11.8-3.2,12-.1.4-.3.4-.5,0l-1,.5-.2,1.2c-2.2.6-4.5,1.9-6.8,3.8l-7,4.5c-1.6,1.3-3.2,2.4-5,3.5l-.9,1.6c-1.5,1.2-8.3,5.8-9.6,6s-.7,0-1-.1c-1.7,2.8-4.3,4.5-7.5,5-4.2,4.3-9.8,8.3-15.5,10l-2,1.5c.8,1.2-.7,2.6-2,2-1.8.7-3.6,2-5.2,3.1-4.4,3.1-9.9,7.8-14.3,10.4s-6.8,2.9-10.5,2.5c-.9,1.3-3.8-1.1-3.5-2.5l-.3-.7c1.6-4.4,3.5-8.7,5.7-12.9l-.3-.4c.8-1.9,2.7-6.3,3-8,1-.3.3.3.3.3.3-.7,1.1-2.4,1.5-2.9s.4,0,.7,0l1-2c3.3-7.2,6.1-14.5,8.5-22l-.5-.5c1-1.4,1.9-2.9,3-4.5,1-2.3,2-4.5,3.2-6.8l.8-.2.5-.5v-.5c-.9,0-.8-.6,0-1l.5-.5c-.4-.2-.4-.3,0-.5l.5-.5c-.4-.2-.4-.3,0-.5l.5-.5c-.7,0-.6-.7,0-1l.5-.5c-.4-.1-.4-.3,0-.5.2-.4.3-.6,0-1v-.5c-.2-.9.3-2.3,1-3v-.5c.1-.7.5-1.4,1-2v-.5c0-.5.2-.8.5-1v-.5c.1-3.1,1.3-6.3,3.5-8.5,0-.5.2-.9.5-1-.2-.1-.2-.3,0-.5l.5-.5c-.2-.2-.2-.3,0-.5-.4-.2-.4-.3,0-.5l.5-1c-.4-.2-.4-.3,0-.5l.5-.5c-.4-.2-.4-.3,0-.5l.5-.5c-.4-.2-.4-.3,0-.5l1-2c-.4-.2-.4-.3,0-.5l.5-1c-.4-.2-.4-.3,0-.5l.5-.5c-.4-.1-.4-.3,0-.5l.5-.5c-.4-.1-.4-.3,0-.5.5-1.2,1.2-2.6,2-3.5v-.5l.5-.5c-.2-.2-.2-.3,0-.5-.4-.2-.4-.3,0-.5l.5-.5v-.5l.5-.5c-.3-.2-.3-.3,0-.5l.5-.5c-.3-.1-.3-.3,0-.5,1.5-3.2,3-6.3,4.5-9.5,0-1.3.7-2.9,1.5-4,.6-2.8,1.6-5.4,3-8,1.2-3.4,2.7-6.7,4.5-10-.6-.5.3-2.3,1-2.5,1.6-4.3,3.3-8.5,5.3-12.6l.7-.4c.8-3.4,2.3-6.7,4.5-10,2.2-7.8,5.8-15.5,10-22.5l.5-.5c-.6-.3,0-1.3.5-1.5l.5-.5c.3-1.9,1-3.9,2-6,0-2.3,1.2-5,3-6.5Z"
          fill="url(#e)"
        />
        <path
          d="M119.8,375.7c-.1.4-.3.4-.5,0-.5.2-.7-.3-.5-1.5,0-.2,0-.3,0-.5,2.1-3.8,4.3-7.9,6-12,.9-.6,1.3-.9.8.5-1.6,4.4-4.7,8.7-5.8,13.5Z"
          fill="#0f42e9"
        />
        <path
          d="M131.3,347.7c.4.1.4.3,0,.5-.2,1-.5,2-1,3-.6,1-2.4,5.2-2.5,2.5,0-.2,0-.3,0-.5,1.1-1.9,1.7-4,2.5-6,1-1.7,1.5-1.2,1,.5Z"
          fill="#48aff9"
        />
        <path
          d="M216.7,196.8l2.5,10c.8,1.4.8,2.4,0,3-1.8-3-3.3-7.5-3.5-11s-.1-1.7,0-2,.8,0,.9,0Z"
          fill="#83f7fd"
        />
        <path
          d="M200.2,188.3l-.5.5c-.3.5-.3,1.1-.5,1.5l-.5.5c-3.5,7.4-6.7,15-10,22.5l-2.5,4.8c-.3.6-.5.8-1,.2-1.1-.4-.5-1.9.5-2v-.5c1.1-1.4,1.9-2.9,2.5-4.5.1-3.5,1.5-6.7,4-9.7l3.5-7.3c.9-.3,1-1.1,1.4-1.8,1.6-3,3.6-7,5.1-10.2-.4,2.2-1.4,3.7-2,6Z"
          fill="#a1e5f6"
        />
        <path
          d="M233.7,226.8l-8.4,7.1c-1,1.6-2.2,2.8-3.6,3.4-1.5,1.7-2.6,10.2-.5,10.8,2.5-.2,3.4.3,2.5,1.7.4.1.4,1.2,0,1.5,1.2.4.5,1.8,0,2.5-.1.4-.3.4-.5,0-.6-.4-1.1-1-1.4-1.8-2-.2-3.3-1.2-3.6-3.2-.6-2.8-.5-5.6.5-8.5,2.2-5.7,8.9-12.2,15-13.5Z"
          fill="#0472fa"
        />
        <path
          d="M217.2,247.8c0,4.3.4,8.3,1,12.5l-1,1.5-1,12-1-6c.1-5-.5-11.2,0-16,.9-.9,1.2-1.6,1-3,.2-.6.2-2,1-2,.4.3.4.7,0,1Z"
          fill="#46ddfe"
        />
        <path
          d="M216.2,318.3c1.7.7.9,3.4-1,3.5.6,1.2-1,2.3-2,1.5-.7.6-.9.5-1-.5.4-.6,1.5-.9,1.8-1.5.5-1.1.6-8.9.7-11,.4-.7.9-1,1.5-1,.9,2.9.9,5.9,0,9Z"
          fill="#209afd"
        />
        <path
          d="M131.3,349.2v-1c0-.2,0-.4,0-.5,1-5.3,3.7-11.3,6.5-16,0-1.5.7-3.8,2-4.5,0,1.4.1,2.7-.2,4-1,4-6.2,13.9-8.3,18Z"
          fill="#1b77f5"
        />
        <path
          d="M184.3,223.3c-1.9,4.3-3.3,9.1-6,13,0-.3,0-.7,0-1-.4,0-.3-.6,0-1-.4-.1-.4-.3,0-.5l.5-.5c-.4-.1-.4-.3,0-.5l.5-1c-.4-.1-.4-.3,0-.5l.5-.5c-.7,0-.5-.6,0-1l.5-.5c-.4-.2-.4-.3,0-.5l.5-.5c-.4-.1-.4-.3,0-.5l.5-.5.5-.5c-.4-.2-.4-.3,0-.5l.5-1c-.2-.1-.2-.3,0-.5l.5-.5c-.2-.1-.2-.3,0-.5l.5-.5c-.4-.2-.4-.3,0-.5.7-1.2,1.3-.8,1,.5Z"
          fill="#7bd9f6"
        />
        <path
          d="M148.8,307.8c.3.3.2.6,0,1,0,.2,0,.3,0,.5l-.5.5c0,.3,0,.8,0,1l-.5.5c0,.1,0,.4,0,.5l-.5.5c0,.1,0,.4,0,.5l-.5.5c-.1.2.1.8,0,1,0,.3-.2.5-.5.5.2.2.2.3,0,.5-1.2,2.6-2.5,5.1-4,7-.3-.1-.3-.4,0-1-.4-.1-.4-.3,0-.5l1-2c-.4-.1-.4-.3,0-.5l1.5-3c-.4-.1-.4-.3,0-.5,1.3-2.7,2.6-5.2,4-7.5v.5Z"
          fill="#1269f5"
        />
        <path
          d="M184.3,223.3l-1-.5c-.6-1.2.5-4.4,2-4.5,0-.1.9-.5,1.2-1,.8-1.3,1.2-2.9,2.3-4-1.4,3.3-3,6.7-4.5,10Z"
          fill="#8edcf6"
        />
        <path
          d="M222.2,211.8c.9,1.2,1.2,2.2,1,3-1.7-1.3-3.6-2.8-4-5s.1-2.1,0-3c1.2,1.6,1.8,3.3,3,5Z"
          fill="#96f5fc"
        />
        <path
          d="M172.8,248.8c-.1.4-.3.4-.5,0,1.5-3.3,2.9-7,5-10-1.3,3.9-3.2,6.6-4.5,10Z"
          fill="#6ee2fb"
        />
        <path d="M229.2,219.8c-2.1-.9-4.8-3.1-6-5s-.7-2.2-1-3c1.8,2.6,4.7,6,7,8Z" fill="#e6fafb" />
        <path
          d="M163.8,270.3c-.2-.2-.2-.3,0-.5-.4-.1-.4-.3,0-.5l.5-.5c-.2-.2-.2-.3,0-.5l.5-.5v-.5c0-.6.2-.9.5-1v-.5l.5-.5c-.2-.2-.2-.3,0-.5l.5-.5v-.5l.5-.5c-.3-.1-.3-.3,0-.5l.5-.5c-.4-.1-.4-.3,0-.5l.5-.5c-.4-.1-.3-.3,0-.5.1-.4.3-.4.5,0-1.3,3.2-1.9,6.9-4.5,9.5Z"
          fill="#38c1fc"
        />
        <path
          d="M218.2,248.8c.9,1.1.9,1.7,0,2-.1.4-.3.4-.5,0-.6-.6-.4-2.2,0-3l-.5-1c.3-2.5.6-4.2,1.5-6.5-.3,2.9-.6,5.6-.5,8.5Z"
          fill="#0d90fb"
        />
        <path
          d="M215.2,280.3c0,3.9.5,8.3-.5,12,0-4.2,0-8.3,0-12.5h.5c.3.1.3.3,0,.5Z"
          fill="#1b9cfb"
        />
        <path
          d="M169.8,256.8c-.1.4-.3.4-.5,0-.3-.2-.3-.3,0-.5,0-.1,0-.4,0-.5l.5-.5c0-.1,0-.4,0-.5l.5-.5c0-.2,0-.8,0-1l.5-.5c0-.1,0-.4,0-.5l.5-.5c0-.1,0-.4,0-.5l.5-.5c.1-.2-.1-.8,0-1l.5-.5c0-.1,0-.4,0-.5h.5c-1,2.6-1.9,5.3-3,8Z"
          fill="#5ddafc"
        />
        <path d="M203.7,328.2c-3.2,2.5-3.5,2.6-7,4.5,2.2-1.8,4.5-3.1,7-4.5Z" fill="#35b6f8" />
        <path d="M216.2,248.8c1,.7.4,2.4.5,3.5l-1.5-.5c.1-1.1.6-2,1-3Z" fill="#6ee7fc" />
        <path
          d="M168.3,260.8h-.5c-.4-.1-.4-.3,0-.5l.5-1c-.4-.2-.4-.3,0-.5l.5-.5c-.4-.2-.4-.3,0-.5l.5-.5c-.4-.2-.4-.3,0-.5h.5c-.5,1.2-.9,2.6-1.5,4Z"
          fill="#47cdfc"
        />
        <path
          d="M196.7,332.7c-.2.2-.3.8-.5,1l-.5.5c-.2.1-.7.2-1.5,1h-.5c-.7.3-1.3.7-2,1,1.3-1.7,3.2-2.5,5-3.5Z"
          fill="#32b2fb"
        />
        <path d="M131.3,349.2c-.4.7-.5,1.2-1,2l1-3c0,.3,0,.7,0,1Z" fill="#31a0fa" />
        <path d="M214.7,272.8c0-.7,0-1.3,0-2,.7.2.8,1.8,0,2Z" fill="#029efe" />
        <path d="M150.8,301.3c0-.3,0-.7,0-1h.5c-.2.5-.4.7-.5,1Z" fill="#25a6fb" />
        <path
          d="M149.8,303.8c0-.3,0-.7,0-1l.5-.5c0-.1,0-.4,0-.5h.5c-.3,1.2-.7,1.3-1,2Z"
          fill="#25a6fb"
        />
        <path d="M154.8,291.3v-.5c0-.2,0-.4,0-.5h.5c-.2.5-.4.7-.5,1Z" fill="#28b0fb" />
        <path d="M233.7,222.8c-.4-.2-.6-.3-1-.5l1,.5Z" fill="#47d0fa" />
        <path d="M148.8,308.8v-1c.8.5,0,.8,0,1Z" fill="#0044fb" />
        <path d="M155.8,288.3l.5-1c-.2.4-.4.8-.5,1Z" fill="#38c1fc" />
        <path d="M157.3,284.8l1-2c-.3.9-.8,1.5-1,2Z" fill="#38c1fc" />
        <path d="M211.7,322.7c-.1,0-.8.4-1,.5l1-.5Z" fill="#0034f8" />
        <path d="M158.3,282.3l.5-1c-.2.5-.4.8-.5,1Z" fill="#38c1fc" />
        <path
          d="M159.8,278.8c0-.1,0-.3,0-.5s0-.4,0-.5l.5-.5c.4-.6.6-1.4,1-2h.5c-.4,1.1-1.2,2.6-2,3.5Z"
          fill="#38c1fc"
        />
        <path d="M155.3,360.2c.7-.6,1.2-1,2-1.5l-2,1.5Z" fill="#0028e3" />
        <path d="M146.3,315.3v-.5h.5c-.1.2-.4.4-.5.5Z" fill="#0338ef" />
        <path d="M146.8,314.8h-.5l.5-.5c0,.1,0,.4,0,.5Z" fill="#003bf9" />
        <path d="M146.8,313.3l.5-.5c-.1.3-.5.4-.5.5Z" fill="#003bf9" />
        <path d="M147.3,312.3l.5-.5c-.1.3-.5.4-.5.5Z" fill="#003bf9" />
        <path d="M147.8,311.3l.5-.5c-.1.4-.5.5-.5.5Z" fill="#003bf9" />
        <path d="M148.3,309.8l.5-.5c0,.2-.5.4-.5.5Z" fill="#003bf9" />
        <path d="M149.5,306.8c.3.2.3.3,0,.5v-.5Z" fill="#0044fb" />
        <path d="M149.8,304.3h-.5c.1-.2.4-.3.5-.5,0,.2,0,.4,0,.5Z" fill="#2eacfc" />
        <path d="M150.8,301.8h-.5c.1-.2.4-.4.5-.5,0,.2,0,.4,0,.5Z" fill="#2eacfc" />
        <path d="M151.3,300.3h-.5c0-.1.4-.3.5-.5,0,.1,0,.4,0,.5Z" fill="#2eacfc" />
        <path d="M199.7,188.8c.1-.2.3-.4.5-.5,0,.2-.3.4-.5.5Z" fill="#54e8fe" />
        <path d="M155.3,290.3h-.5c.1-.2.4-.4.5-.5,0,.2,0,.4,0,.5Z" fill="#38c1fc" />
        <path d="M155.3,289.8c0-.2,0-.4,0-.5.2-.2.3-.2.5,0,0,.2-.4.4-.5.5Z" fill="#28b0fb" />
        <path d="M155.8,289.3h-.5c0-.2.3-.4.5-.5,0,.1,0,.4,0,.5Z" fill="#38c1fc" />
        <path d="M198.7,190.8l.5-.5c-.1.3-.5.4-.5.5Z" fill="#4ce5fe" />
        <path d="M156.3,286.8l.5-.5c-.1.3-.5.4-.5.5Z" fill="#38c1fc" />
        <path d="M156.8,285.8l.5-.5c-.1.3-.5.5-.5.5Z" fill="#38c1fc" />
        <path d="M158.8,280.8l.5-.5c0,.3-.5.4-.5.5Z" fill="#38c1fc" />
        <path d="M159.3,279.8l.5-.5c-.1.4-.5.5-.5.5Z" fill="#38c1fc" />
        <path d="M161.8,275.3h-.5c.1-.2.4-.3.5-.5,0,.2,0,.4,0,.5Z" fill="#47cdfc" />
        <path d="M161.8,274.8c0-.2,0-.3,0-.5.2-.2.3-.2.5,0-.1.2-.4.4-.5.5Z" fill="#38c1fc" />
        <path d="M162.3,274.3h-.5c0-.2.3-.4.5-.5,0,.1,0,.4,0,.5Z" fill="#47cdfc" />
        <path d="M162.3,273.3c0-.1,0-.4,0-.5h.5c0,.2-.3.4-.5.5Z" fill="#38c1fc" />
        <path d="M162.8,272.8h-.5c0-.2.5-.4.5-.5,0,.2,0,.3,0,.5Z" fill="#47cdfc" />
        <path d="M162.8,272.3c0-.2,0-.4,0-.5.1-.3.3-.3.5,0,0,.2-.5.4-.5.5Z" fill="#38c1fc" />
        <path d="M163.3,271.8h-.5v-.5c.1-.3.3-.3.5,0,0,.2,0,.4,0,.5Z" fill="#47cdfc" />
        <path d="M163.3,271.3c-.3-.1-.3-.3,0-.5.1-.3.3-.3.5,0,0,.3-.2.5-.5.5Z" fill="#38c1fc" />
        <path d="M163.8,270.8h-.5c-.4-.1-.4-.3,0-.5.2-.2.3-.2.5,0,0,.2,0,.4,0,.5Z" fill="#47cdfc" />
        <path d="M169.8,254.8c.1-.3.5-.4.5-.5l-.5.5Z" fill="#6ee2fb" />
        <path d="M170.3,253.3c.2-.4.5-.5.5-.5l-.5.5Z" fill="#6ee2fb" />
        <path d="M170.8,252.3c.1-.3.5-.4.5-.5l-.5.5Z" fill="#6ee2fb" />
        <path d="M171.3,251.3c.1-.3.5-.4.5-.5l-.5.5Z" fill="#6ee2fb" />
        <path d="M171.8,249.8c.2-.4.5-.5.5-.5l-.5.5Z" fill="#6ee2fb" />
        <path d="M149.8,302.8c0-.2.3-.4.5-.5,0,.2-.3.4-.5.5Z" fill="#2eacfc" />
        <path d="M159.8,277.8c0-.2.3-.4.5-.5-.1.2-.3.3-.5.5Z" fill="#47cdfc" />
        <path d="M165.3,265.8c0-.1,0-.4,0-.5h.5c-.1.2-.4.4-.5.5Z" fill="#47cdfc" />
        <path d="M165.8,264.8c0-.1,0-.4,0-.5h.5c0,.2-.4.4-.5.5Z" fill="#47cdfc" />
        <path d="M166.3,263.8c0-.1,0-.4,0-.5h.5c-.1.2-.4.4-.5.5Z" fill="#47cdfc" />
        <path d="M167.8,260.3c.2-.5.5-.9.5-1l-.5,1Z" fill="#5ddafc" />
        <path d="M168.3,258.8c.1-.4.5-.5.5-.5l-.5.5Z" fill="#5ddafc" />
        <path d="M168.8,257.8c.1-.3.5-.4.5-.5l-.5.5Z" fill="#5ddafc" />
        <path d="M163.8,270.3h-.5c0-.2.3-.4.5-.5,0,.1,0,.3,0,.5Z" fill="#5ddafc" />
        <path d="M163.3,271.3h-.5c0-.2,0-.6.5-.5,0,.2,0,.4,0,.5Z" fill="#5ddafc" />
        <path
          d="M143.3,315.3c.2.5,0,1-.5,1.5,0,.2,0,.3,0,.5l-.5.5c0,.1,0,.3,0,.5l-.5,1c0,.1,0,.4,0,.5l-.5.5c0,.1,0,.4,0,.5l-.5,1c0,.1,0,.3,0,.5-.2.2-.3.2-.5,0,0-.3.3-2.5-.5-1.8-.9,1.5-1.8,3.2-2.5,4.8-.6-.2-.6-1,0-2.5,1.6-3.5,3.2-7.1,4.8-10.6l.7-.4,1-.5c.1.2-.4,3.4-.5,4Z"
          fill="#0b85f9"
        />
        <path
          d="M137.3,325.2c-2,4.3-4.9,10.2-6.5,14.5h-.5c.3-.8.6-2.5,1-3.5-.7-.8.4-3.5,1.5-3.5,1.5-1.6,1.7-4.1,2.5-6-.6-1.7,0-3.1,2-4v2.5Z"
          fill="#2ca1f7"
        />
        <path d="M139.3,324.7l.5-.5c-.1.3-.5.4-.5.5Z" fill="#2ba8fc" />
        <path d="M139.8,323.7l.5-.5c0,.3-.5.5-.5.5Z" fill="#2ba8fc" />
        <path d="M140.3,322.7c0-.2,0-.3,0-.5h.5c0,.2-.3.4-.5.5Z" fill="#2ba8fc" />
        <path
          d="M262.7,85.9c-1.9-3.7-2.2-7.3-3.9-10.4s-5.6-4-7.9-4.1c-5.2-.3-7.1,1-10.2,5,.9-2.7,2.4-3.3,4-5.5-.4-1.1,2.2-2.2,3-1.5,11.7-2.6,12.6,8.9,15,16.5Z"
          fill="#eff8f7"
        />
        <path
          d="M267.7,88.9c1,1.1,2.4,3.8,1.5,5h-1.1c0,.1-2.9-4-2.9-4-.6-1.6-1.4-3.5-1.8-4.9s-2.3-7.2-2.2-7.8,1-.3,1.3-.8c1.6,4.2,3.7,8.3,5.2,12.5Z"
          fill="#a4f8fd"
        />
        <path
          d="M244.2,68.4c-.8,1.1-.7,1.2.6.9s3.3-1.3,5.3-.9l-2.5,1c-1.3.3-2,1-3,1.5-5.8,3.1-3.7,4.5-5.5,9.5s-1.5,2.9-2,4l-.4-1.1c.6-2.7,1.2-5.3,1.9-7.9-.8-.3-1.4-.5-1-1.5-.4-.1-.4-.3,0-.5l1-1c.7-1.4,2.5-2.6,4-3,.5-.3,1-.8,1.5-1Z"
          fill="#99f4f9"
        />
        <path
          d="M261.7,71.9c1,0,2.4,1.7,1.5,2.5l.5,1c.4.1.4.3,0,.5l-.5,1c-.3-1.7-1.4-3-2.2-4.5s.2-.5.2-.5c.1-.4.3-.4.5,0Z"
          fill="#c9f6fa"
        />
        <path
          d="M242.7,68.9v.5c-1.4.9-2.8,1.9-4,3-.4-.1-.4-.3,0-.5-.6-.4-.4-.7.5-1,.2-.8,1-1.3,2.5-1.5.3-.2.8-.4,1-.5Z"
          fill="#5489de"
        />
        <path
          d="M265.2,232.8c.2-.4.3-.4.5,0l1,1c3.2-.3,8.8,4.2,8.5,7.5-1.6,0-.9.3-.5,1.5-1.9-2.8-3.4-4-6-6-2.5-.3-3.6-1.2-3.5-2.5-2.4-.2-6.5-.8-7.5-3-.3-.5.2-.7,1.5-.5,2,.5,4,1.3,6,2Z"
          fill="#062fe6"
        />
        <path
          d="M269.7,233.8c.1,0,.4,0,.5,0,3.1,1.6,6.7,4.6,7.5,8s.4,2.8-1.5,1c-.3-.5-.7-1-1-1.5-3-4.4-3.6-5.2-8.5-7.5l-1-1c-.1,0-.4,0-.5,0l-.7-1c1.8.4,3.5,1.3,5.2,2Z"
          fill="#0114d0"
        />
        <path
          d="M270.2,233.8c2.7,1.2,5.3,2.7,6.9,5.3s3.4,8.3,3.1,8.7c-.8.9-1.1-.7-1.3-.9-1-1.3-1.8-2.7-2.7-4.1l1.5.7c-1.2-4.3-3.6-7.3-7.5-9.7Z"
          fill="#011edf"
        />
        <path d="M275.2,243.8c-.2-.1-.4-.3-.5-.5.2,0,.4.3.5.5Z" fill="#062fe6" />
        <path
          d="M254.7,228.3c1.2.2,2.6.2,3.5,1-1.2,0-3.2-.3-4,.5-1.5.6-5.2.5-6.5-.5.8-.6,2.1-.8,3.9-.7l-.4-.3c.6-.9,2.4-.2,3.5,0Z"
          fill="#0523d9"
        />
        <path d="M258.2,227.8c-.2,0-.3,0-.5,0v-.5h.5v.5Z" fill="#055afa" />
        <path
          d="M331.7,238.8l.5.5c.4.1.4.3,0,.5l.5,1,.5,1c.4.2.4.3,0,.5l.5.5c.6.2.8.9.5,1.5.3,0,.6,0,.7.2,1.5,2.6,2.7,7.1,3.3,10.3l.5.5v.5c1.3-.1,1.6,1.2,1.5,2.3.7,0,.9.8.5,2.2.4.1.4.3,0,.5l.5.5c.4.1.4.3,0,.5l.5.5c.4.2.4.3,0,.5l.5,1c2,2.9,3.3,6.5,4,10,2.4,1.8,3.3,5.1,3,8,.4,1.1.5,2.8,1,4-.4,1.2-.8-.5-.9-.8-.7-1.7-1.3-4.4-2.6-5.7-.9-1.5-1.6-3.2-2-5,0-.2,0-.3,0-.5l-.5-1c0-.2,0-.4,0-.5-1.1-2.5-2.4-5-4-7.4-2.2-3.7-3.5-7.6-4-11.6-2.9-3-4.7-8.8-4.5-13-.9-.2-1.1-1.5-.5-2,.4-.2.6,0,.5.5Z"
          fill="#b3eff0"
        />
        <path
          d="M336.2,253.3c2,5.1,4.5,11.1,7.3,15.6l.7,3.4c-.5-1.1-1.9-2.9-3-3.5.2,1.3.6,2.7,1,4-.3-.3-.7-.7-1-1-1.4-2.8-2.6-5.6-3.5-8.5-1.1-2.6-1.9-5.4-3-8,.2-1,.7-1.7,1.5-2Z"
          fill="#c9f9fb"
        />
        <path d="M346.7,279.3c-1.9-1.9-1.2-2.4-2-5l2,5Z" fill="#c9f9fb" />
        <path d="M344.7,273.8l-.5-1c0,.1.3.4.5,1Z" fill="#c9f9fb" />
        <path d="M342.7,273.8s-.4-.2-.5-.5l.5.5Z" fill="#c9f9fb" />
        <path
          d="M269.2,93.9c.3,0,.5,0,.8,0,.4.2,3.1,7.4,1.7,8,.2,1.2.2,2.2,0,3-1.7-1-1.5-3.3-2.3-5-1.4-3.3-3-5.9-4.2-9.5s0-.4,0-.5c1.3,1,3.2,2.6,4,4Z"
          fill="#b1fbfb"
        />
        <path
          d="M271.7,101.9c1.9.4,3.2,3.8,2.5,5.5,2.3,2.5,3.3,5.1,3,8l-.5,1c-1.6-3.8-3.6-7.6-5-11.5s-.6-2.2-1-3.2l1,.2Z"
          fill="#9cfafa"
        />
        <path
          d="M303.2,172.8c1.2,1.8,2.2,3.8,3,6,1.4.8,2.4,3.7,2.5,5.5,1.9.7,3.2,3.6,2.5,5.5.2.4.2.8,0,1,1,2.5,1.8,5,2.5,7.5.8.5,1.9,2.3,1,3-.6.2-1.3,0-2-.5-4.2-8.5-7-17.9-11-26.5l-.5-.5c0-.1,0-.4,0-.5l-.5-.5c0-.1,0-.3,0-.5s0-.3,0-.5c-1.7-4.9,2.4-2.2,2.5,1Z"
          fill="#e7fcf9"
        />
        <path
          d="M314.7,201.3c2,1.3,3,4.5,3.5,7,1.4,2,2.1,4,2,6,.8,4.1-1.4,2.3-2-.5-.9-1.5-2.3-4.3-3-6s-2.3-5.1-2.5-6,0-.7,0-1c0-.8,0-1.7,0-2.5h.5c-.2,1.5,1,2.1,1.5,3Z"
          fill="#f4fdfc"
        />
        <path d="M301.2,173.3c-.2-.1-.4-.3-.5-.5.2.1.4.3.5.5Z" fill="#7ae5f9" />
        <path d="M301.7,174.3l-.5-.5c0,.1.4.3.5.5Z" fill="#7ae5f9" />
        <path
          d="M295.2,159.3c.2.9,0,1.2-.5,1-2-5-4-10-6-15-.2-.9,0-1.2.5-1,.3,0,.5,0,.7.1.6.4,5.4,12.2,5.9,13.8l-.6,1Z"
          fill="#67e8f9"
        />
        <path
          d="M297.2,163.3c1.6.4,2.1,2.3,1,3.5l.5,1c.4.2.4.3,0,.5l.5.5c.4.1.4.3,0,.5l.5.5c.4.1.4.3,0,.5-.2,2.7-.8-1.1-2-2-1-2.6-2-5.4-3-8l.5-1c1.2-.2,1.8.5.8,1.3l1.2,2.7Z"
          fill="#61dbf8"
        />
        <path
          d="M289.2,143.8c.4.1.4.3,0,.5l-.5,1c-.6-1.7-1.3-3.3-2-5l.5-.5c1.4.7,2.1,2,2,4Z"
          fill="#7cf1f7"
        />
        <path
          d="M274.2,107.4c-.4-1.4,0-2,1-1.8.3,1.7,1,3.1,2,4.3.1-.4.3-.4.5,0,1.6,2,2.6,4.5,3,7,.2.1.2.3,0,.5.4-.6.6-.3.5,1,1.5.8,1.6.9,1,2.5.7.8,1.7,2.5,1.5,3.5,1.1,2.2,2.1,4.5,3,7,.8,1.6,1.5,3.2,2,5,1.2.1,1.1.5,0,1,.3.4.5.7,0,1-.5.3-.9.2-1.2-.3-2-3.8-3.7-7.7-5.3-11.6s-.2-.3-.5,0c-1.5-3.7-3-7.3-4.5-11s-2-5.4-3-8Z"
          fill="#befafa"
        />
        <path
          d="M288.7,138.3c.4.2.4.3,0,.5.8,4-1.1,1.9-2-.5-1.7-4-3.4-8-5-12-.2-1.6.4-1.1.9-.2,1,1.7,1.4,3.6,2.2,5.3l3.9,6.9Z"
          fill="#cdfcfd"
        />
        <path
          d="M286.7,138.3c1.1,1.6,2,3.7,2,.5,1,0,1.9,3,1.5,4-.3.5-.6.8-1,1-.7-1.3-1.4-2.7-2-4s-.3-1.1-.5-1.5Z"
          fill="#befafa"
        />
        <path
          d="M318.2,215.8c0,.1,0,.4,0,.5,1.1,2.3,2.3,4.6,3.5,7,2,1,3.3,3.8,2.5,6v.5c-1-1.5-1.5-3.3-2.3-5s-.4-1.9-1.2-.5c-.8-.6-1.5-1.6-2-3,0-.2,0-.3,0-.5-.3-.9-1.7-5.2-1.5-5.5l1,.5Z"
          fill="#68dffc"
        />
        <path
          d="M320.7,224.3c0,.1,0,.3,0,.5,0,.3,0,.7,0,1-1.1-1.2-1.5-3-2-4.5.6.7,1.8,2.2,2,3Z"
          fill="#79dbfa"
        />
        <path d="M322.2,230.3v1c-.5-1.6-1.1-2.6-1.5-4.5.9,1,1,2.4,1.5,3.5Z" fill="#cff9fb" />
        <path
          d="M318.2,213.8c1,1.7,2,3.6,2,.5.9,1,1.8,2.4,2.5,4,1.6-.3,2.6,2.6,1.5,3.5l4.4,10.6c.8,2,.7,3.1-.4,3.4-.5,1.4-1.2,0-1.5-1l-.5-1c-.1,0-.4,0-.5,0-.4-.5-.4-.9,0-1l-1-2c-.3-.1-.3-.3,0-.5-.3-.1-.5-.5-.5-1-.8-2-1.7-4-2.5-6-1.4-2.2-2.4-4.5-3-7-.3-.8-.4-1.7-.5-2.5Z"
          fill="#e8fcfa"
        />
        <path
          d="M297.2,163.3c-2.2-4.2-1-5,1.5-1,.4.1.4.3,0,.5l.5.5c1.1,2.4,2.2,4.7,3.5,7,.6-.1.7.5.5,1,.5.4.6,1.3,0,1.5-.8-1.1-.6-3.1-2.5-3,0,.7,0,1.3,0,2-.4-.5-.7-1-1-1.5s0-.4,0-.5l-.5-.5c0-.1,0-.4,0-.5l-.5-.5c0-.1,0-.4,0-.5l-.5-1c-.4-1.2-.7-2.3-1-3.5Z"
          fill="#d9fbf9"
        />
        <path
          d="M230.7,92.4c3.2-4.1,3.4.9,1.5,3.5-1.4,4.8-3.6,9.4-5.5,14l-.5-.2c1.4-2.8.7-1.4-2,4.2.1,1-.4,3-1.5,3l-.9-.8c2.2-6.4,4.6-12.8,6.9-19.2-.7-1.1.9-4,2-4.5Z"
          fill="#6cecfa"
        />
        <path
          d="M237.2,84.4c-.7,1.6-1.4,3.3-2,5l-1,2.5c-.4,1-.7,2-1,3l-1,1c.3-.9,0-2,1-2.8h-1s1-1.5,1-1.5l-2.5.8c-.4-1.5-.5-3.4.9-4.1-.4-1,0-1.6,1.1-1.9-.2-1.3,0-1.8.5-1.5-.4-.4.9-3.2,1.4-3.9s.3-.1.6,0l.9.2c.4-2,1.1-3.9,1.9-5.8h.7c-.5,3.1-1.1,6.1-1.5,9.1Z"
          fill="#7af1fc"
        />
        <path
          d="M224.7,114.9c-1.3,3.5-2.6,7-4,10.5s-3.5,7.3-4.5,11.5l-.5.5v.5h-.5c-.4,0-.6-.3-.5-1-.4-2.5.5-4.8,2.5-7,0-.5.2-.8.5-1-.4-3.7,1.9-7.1,4-10-.8-1.6-.4-2.2,1-2,.4-.9,1-1.8,1.5-3,.5-.5.7-.2.5,1Z"
          fill="#4eddf3"
        />
        <path
          d="M226.7,109.9c-.5,1.8-1.4,3.3-2,5l-.5-1c.8-2,1.3-4.1,2.2-6,1.3-1.5.3,1.7.2,2Z"
          fill="#56e3f2"
        />
        <path d="M234.2,91.9c.3-.8.7-1.8,1-2.5l-1,2.5Z" fill="#acf5f8" />
        <path
          d="M207.2,159.3c-.1.7-.3,1.4-.5,2-2.8,8.6-7.6,19-11.3,27.5s-.5,1.5-1.2,2c-1.1-1.4.7-5.7,2-6.5.8-2.4,1.8-4.7,3-7-.8-.2-.7-.6,0-1,.6-2.6,1.6-4.9,3-7,.7-3.5,1.9-7.2,4-10-.2-1.1.3-2.7,1.5-2.5.2.7,0,1.5-.5,2.5Z"
          fill="#ccf8fa"
        />
        <path
          d="M207.2,159.3c.2-.8.5-1.6.5-2.5-1,0-.8-.6,0-1,.6-2.9,1.6-6.3,3.5-8.5l1-2c-.4-.1-.4-.3,0-.5,0-.4.2-.5.5-.5l.5-.5c-1.1-.4-.6-1.9.5-2,1,.5.3,1.6.1,2.4-1.6,4.9-4.3,10.6-6.6,15.1Z"
          fill="#d6f9fb"
        />
        <path
          d="M215.2,137.8c0,1.5-1,2.7-1.5,4s-.3,1.4-.5,2l-.5.5c-.2.2-.3.4-.5.5,0-.4-.2-.4-1,0-.4-.1-.4-.3,0-.5v-.5l.5-.5c-.5-1.2.5-3.2,1.5-4,.4-1.7.9-2.5,1.5-2.5.5,0,.5.6.5,1Z"
          fill="#4dd3f2"
        />
        <path d="M215.7,137.3l.5-.5c0,.2-.3.4-.5.5Z" fill="#d6eff2" />
        <path
          d="M187.8,207.3c-.2.9-.3,1.7-.5,2.5-1.8,3.9-3.7,7.9-5,12-.1.4-.3.4-.5,0,.2-1.3.5-2.1.5-3.5-.7-.2-.6-.6,0-1,.3-1.4.8-2.6,1.5-3.5-.1-.2-.2-.3-.2-.5.7-1.7,4.4-10.7,4.9-11.1s.4,0,.8,0c0,1.6-.5,3.3-1.5,5Z"
          fill="#4dcdf7"
        />
        <path
          d="M191.8,198.8c-.9,2.6-2.5,6.1-4,8.5.5-1.7,1-3.3,1.5-5-.7-1.2-.1-2.7,1-3.5l1-2c-.4-.2-.4-.3,0-.5l.5-1c-.3-.1-.3-.3,0-.5l.5-.5c-.4-.1-.4-.3,0-.5h.5c-.1,1.5-.5,3.6-1,5Z"
          fill="#63d3fa"
        />
        <path
          d="M197.2,180.3c.1,1.3-.2,2.6-1,4-.5,1.9-1.3,4.7-2,6.5s-1.1,1.8-1.5,2.5l-.5.5c0,.1,0,.4,0,.5l-.5.5c0,.2,0,.3,0,.5-.1.4-.3.4-.5,0v-.5c-.5-.3-.3-.6,0-1-.4-.2-.4-.3,0-.5l.5-1c-1-1.5.6-4.6,2-5.5l.5-1c-.4-.1-.4-.3,0-.5,0-1.2.4-1.9,1-2l.5-.5c-.4-.2-.4-.3,0-.5l.5-.5c-.4-.2-.4-.3,0-.5l.5-1c-.4-.1-.4-.3,0-.5.2-.2.3-.2.5,0v.5Z"
          fill="#40c1f4"
        />
        <path d="M192.8,193.8h-.5c.1-.2.4-.3.5-.5v.5Z" fill="#4ec6f6" />
        <path
          d="M253.2,216.3c.4.2.7.6,1,1,1,.5.4.7-.5,1-1.1.6-1.8,1.5-2.5,2.5-.2-.1-.8,0-1,0-.8-.3-2.1-1.3-3.5-1.5l.7-1.5c.9,1.2,2.4,1.6,1.2,0,.1-1.3,2-1.7,2.9-1.2.5-.9.7-1.3,1.6-.3Z"
          fill="#0261f9"
        />
        <path
          d="M239.7,215.3c.7-1.9,2-.8,1.5,1.5.7-.7,1-.4.5.5l.3.6c1.4-2.3,5.1-.8,2.1.7s1.2-1.2,1.1.1c1.2-.1,1.1.1.5,1l.5-.5c.1-.4.3-.4.5,0,.8-.8,3.9-.2,3.5,1.5,1.1.3,1.6.8.5,1.5-.9.3-4.1.6-3.5-.5.3-.5.4-.9,0-.5-.1.5-.3,1-.5,1.5-.3.5,2.8.3,4,0,.2-.2.3-.2.5,0,.1-.9.9-.8,2.4.2,1.3-.7,2-.6,2,.3-.5.8-1.9.5-2.7.5-6,0-8.7-.1-14.2-2.5l.2-.8c-3.3-1.5-3.7-2.7-1.2-3.7.5-.4,1.2-.7,1.5,0,.4-.3.6-.8.5-1.5Z"
          fill="#0350f7"
        />
        <path
          d="M241.2,211.8c0,.4-.6,1-.3,1.5.6.9.9,0,1.3,0,.5,1.6,1.1,2.2,1.8,1.9.6.4,3.1,2.2,2.2,2.6-.1.2.4,1.4-1,1-.3-.1-1.3.1-1.5,0-.3-.2,1.3-1.3,1-1.5-1-.7-2.7,2.4-4.5,1.5.2-.7,1-1,1.5-1.5,0-.4-.1-.6-.5-.5-.4-.7-.7-1.1-.5-2-1-.3-.8.4-1,.5.1.5,0,.6-.5.5-.3-.1-.3-.3,0-.5-1-.1-.9-.6,0-1,4,0,.5-.2.5-2.5.3-.5.5-.9,1-.5.7-.2.8-.1.5.5Z"
          fill="#0261f9"
        />
        <path
          d="M247.2,221.8c.7,1.5,1.2-.7,2.3-1,.5.4-.5,1.2-.3,1.5s1.1,0,1.5,0,.4.3.5.5c-.2,0-.3,0-.5,0-1.3.3-2.8.5-4,0,0-.3-.6-.8-.5-1.2s1-.2,1-.3c.2.2.2.3,0,.5Z"
          fill="#0368fb"
        />
        <path d="M250.7,222.8c-1.1,1-3.1.3-4.5.5,0-.4.5-.5.5-.5,1.3,0,2.7-.1,4,0Z" fill="#043cf4" />
        <path d="M242.2,219.3c-1,1.4-2.3,2.6-2,0h2Z" fill="#0235eb" />
        <path
          d="M239.2,215.8c.8,0,.7.8,0,1-.5,0-.9.5-1.5,0,0-.2,0-.4,0-.5-.6-1.3.5-1.7,1.5-1,0,.2,0,.3,0,.5Z"
          fill="#0369f9"
        />
        <path d="M241.7,217.3c-.2-.2-.4-.3-.5-.5l.5-1.5c1.5.6.8,1.2,0,2Z" fill="#0141ef" />
        <path d="M239.2,216.8v-1c.2-.2.3-.3.5-.5l.5.3c.2,2.1-.9,1.2-1,1.2Z" fill="#0136ee" />
        <path d="M243.2,220.8v1s-1.5,0-1.5,0c.2-.7.8-1.1,1.5-1Z" fill="#0236f5" />
        <path d="M247.2,221.8v-.5c.2-.4-.5-1.7.5-1.5,0,.7.3,1.7-.5,2Z" fill="#0335f1" />
        <path d="M244.7,221.8c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#022cec" />
        <path d="M245.7,219.8s.2-.5.5-.5l-.5.5Z" fill="#0261f9" />
        <path
          d="M257.2,207.8c1.1-.6,1.6-.4,1.5.5.6-.6,1.9-.2,2.5.5,1.6.7,1.9,1.7,1,3.2.8-.2,2.2,1,2,1.8,2.2,2.4,2.3,3.7.5,4-.2.1-.4.3-.5.5-.4-.1-1-.6-1-1,0-.7,1.5-1-1.5-1.5,0,.3,0,.7,0,1-1.1-.2-1.9,0-2,0-2.1.3-3.1,0-3-1-.1.4-.3.4-.5,0-.4-.5,0-.8,1.5-1,.1-.2.3-.2.5,0l-.2-.7c-1.4,0-1.3-.8.2-2.3l2-2c-2.4.6-3.1-.6-5-1-.5-1.3,1.3-1.2,2-1Z"
          fill="#034df5"
        />
        <path d="M263.2,217.3c0,.2-1.5,1.4-1.5-.5.4,0,1.7-.2,1.5.5Z" fill="#034df5" />
        <path
          d="M238.2,212.8q-.6.9,0,0c.2,0,.7-.2.9,0s0,1,0,1.4,0,.7,0,1c-.3.3-1.4.8-1.5,1-.2-.4-.7-.4-1-.5-2.2-1-1.2-2.7-3.5-2.5-.6-.6-.3-.9.5-.5.3-.9,1-1.5,1.5-.5.7-.1,2.2.2,3,.5Z"
          fill="#0350f7"
        />
        <path
          d="M227.7,210.8c.6-.5,1-.2,1.4,1l1.6.5h1.1c.8-1.6,2.4-2.1,1.9,0,.4.1.4.3,0,.5-.3.2-.4.4-.5.5s0,.4,0,.5c-.6,0-.6.3,0,1,.8,2.6-1.8,2.7-1,.5h-1.5c-1-1.3-2.5-3.4-3.5-4.5.1-.4.3-.4.5,0Z"
          fill="#053bdc"
        />
        <path d="M233.2,213.8c2.1.2,2.1,2.5,0,1,0-.1-.9-.4-1-.8s.6,0,1-.2Z" fill="#0350f7" />
        <path d="M236.7,215.8c-.6,1.9-1.1,2-1.5,0h1.5Z" fill="#0353f2" />
        <path
          d="M270.7,197.3c.1-.2.2-.4.4-.6,1.8-1.4,3,8.2,3.1,9.7l1,.4v1.5c-.8.9-1,2-2,2.5-1.4,1-1.3-.1-1-1.5-.6-.4-1.1-1.1-.5-1.5-2.2-.1-1.6-3.1-.6-4.4-.1-.9-.2-1.7,0-2.6-.4-.2-.4-.3,0-.5-1.5-.3-1.1-1.9-.5-3Z"
          fill="#0115b4"
        />
        <path
          d="M271.7,207.8s0,.5.3.5,1.1-.7,1.2-.5c.2.3-.4,1.6-.4,2.2s.4.7.4.7c0,.3-.5,1-.5,1.5-.6.3-1.9,1.9-2.5,2.5-3.1,3.6-2.4-2-.5-3,0-.7.3-1.5.8-2.1-.9-1.7-.4-3.8,1.2-1.9Z"
          fill="#0217c2"
        />
        <path
          d="M268.7,208.8c1.7-.3,2.3,2.1,1,3,0,1.6-.5,2.6-1,4l1.5-1c-.5.6-1.1,1.5-2,2.5l-3,1s-.5.2-.5-.5.6-.8.5-1.2-1.6-.4-1-2.8c-.4-.8-.5-1.3.5-1,.3-.2.7-.2,1,0,.1-.4.3-.4.5,0,.6,0,.5-.6-.2-1.7l1.3-1.1c-1.3-2,1.9-3.3,1.4-1.3Z"
          fill="#0227df"
        />
        <path
          d="M226.7,205.3c.8.1,1.1,1.1.9,2.9,1.1,1.1,2,2.5,0,2.6h-.5c-.2-.2-.3-.4-.5-.5-.4-1.4-1-2.7-1.5-4l1,.5v-1.5c.1-.4.3-.4.5,0Z"
          fill="#041ea6"
        />
        <path
          d="M246.2,227.8c1.2,0,2.4,0,3.5,0s.3,0,.5,0v.5c-.9.6-2.7.8-3.5,0-1.4,0-2.7.1-4,.5-.1,1-.6,1-1,0-4.5.9-8.9,2-12.5,5,0,.9-1.5,2.3-2.5,2l-3.7,6.4h-1.3c-.3-1.1.2-2.6,1.5-4.4,2.9-4.2,9.4-10.9,14.7-10.9s5.9.9,8.3.9Z"
          fill="#0131f6"
        />
        <path
          d="M250.2,228.3c.3,0,.7,0,1,0,.6,0,2.1-.4,2,.5l-5.5.5c0,.4-.3.4-.5,0l-1,.5c0,.3-.2.5-.4.6-1.9.7-9.2,3.4-10.6,3.4s-.3-.2-.5-.5c-3,.5-5.5,2.2-7.5,5l-1-.5c-.6-.2-.5-.9.5-2,.7-.7,1.7-1.4,2.5-2,3.6-3,8-4.1,12.5-5,.3,0,.7,0,1,0,1.3-.4,2.6-.6,4-.5,1.2,0,2.3,0,3.5,0Z"
          fill="#0117e0"
        />
        <path
          d="M254.7,163.8c.5,0,1,0,1.5,0l3.5,1.5c.2,0,.3,0,.5,0l1,.5c.2,0,.4,0,.5,0l.5.5c.1,0,.4,0,.5,0,4.2,2,7.9,5.1,10.5,9,5.4,5.6,8,15.5,5.5,23l-1-1-.5,2.5c-.4-1.4-.3-3.1,0-4.5-.1-.7-.8-4.9-.7-5.1s.4-.3.7-.4c.4.1.4.3,0,.5,2.2,1.9,1-2.6.5-4-1.1-.3-1.1-1.3,0-1.5l-.5-1c-2.3-4.2-5.7-8-9-11.5h-.4c-3.1-3.5-7.2-4.2-11.6-3.5-.2.4-.3.4-.5,0-1.3-.3-2-.8-2-1.5,1.8-1.4-3.2-3.1-3.5-.5-2.6.5-4.2.2-4.8-1.1l-1.5.2c-1.3,1.1-3.5,2.7-4.5.9-5.3,2.1-9.5,6.2-13.2,10-.5,0-.7-.2-.6-.6,1.4-3.7,2.9-5.1,6.1-7.4,0-.1,0-.3,0-.5,2.5-1.2,4.9-2.1,7.5-3l.5-.5c.2,0,.3,0,.5,0l1.5-.5c.2,0,.3,0,.5,0,4-1.2,8.4-1,12.5-.5Z"
          fill="#013ff5"
        />
        <path
          d="M273.2,196.8c.8-1.9,1.8-2.5,3-1.9.2,1.6.4,3.2.5,4.9s-.8-4.3,0-4.5c.1-.4.3-.4.5,0,0,1.5,0,3,0,4.5v1c-.2.1-.4.2-.5.5-.7,3.5-1.4,3.6-2.5.2,0-1.4-.4-3-1-4.7Z"
          fill="#010980"
        />
        <path
          d="M273.2,175.3c-3.2-3.3-6.6-6.5-10.5-9,.1,0,.4,0,.5,0,4.1,1.7,8.4,4.8,10,9Z"
          fill="#024df6"
        />
        <path
          d="M227.2,190.3c.6.6.3,1.3-1,2,.7,1.7-.3,3.8-1.5,5-.2.7-.6,3.5-.7,3.5l-.7-3.5c0-1.5,0-3,0-4.5h.5l.7.2c.5-1.2,1.7-4,2.8-2.6Z"
          fill="#030a6b"
        />
        <path
          d="M254.7,163.8c-4.1-.2-8.5-.1-12.5.5,2.3-1.7,6.8-1,9.8-1s2.2-.3,2.7.5Z"
          fill="#024df6"
        />
        <path d="M259.7,165.3c-1.2-.4-2.6-.4-3.5-1.5,1.3.2,2.6.4,3.5,1.5Z" fill="#024df6" />
        <path d="M241.7,164.3l-1.5.5c.4-.1.7-.3,1.5-.5Z" fill="#024df6" />
        <path d="M261.2,165.8l-1-.5c.6.2.9.5,1,.5Z" fill="#024df6" />
        <path d="M239.2,165.3s.1-.4.5-.5l-.5.5Z" fill="#024df6" />
        <path d="M262.2,166.3l-.5-.5c.4.1.5.5.5.5Z" fill="#024df6" />
        <path
          d="M231.7,168.8c-1,1.9-3.7,3.3-4.7,5s-.5,2.2-.8,3c-.7,2.8-2.2,6-3.5,8.5,0-2.3,1.9-9,3.1-11.2s3.4-4.4,5.9-5.3Z"
          fill="#0351fd"
        />
        <path
          d="M230.2,190.3c1.4,0,1.8,1.3,1,4,1.3.3,1.2.5,0,1-1.2,0-2,.5-2.5,1.5.8,2.8,0,6.5-2,8.5h-.5c-.1-.2-.4-.3-.5-.5l-.5-1c0-.1,0-.3,0-.5.4-.8.6-1.8.5-3-.6-.6-.3-1.8.3-2.4-.7-1.1-.4-3.4.9-4.1-.8-1.5,1.8-2.8,2.3-2.5-.5.6-.7.3-.5-.5-.3-.6,0-.8.5-.5.3-.6.6-.6,1,0Z"
          fill="#0223b9"
        />
        <path
          d="M228.7,190.8c.2.3,1,.4,1,1l-2.5.5c2.4,4-.7,1.3-1,3.3s1.2,1.4,1,1.7-.9-.2-1,.3c-.2.8.4,2.2-.5,2.7-.1,1.3-.5,1.2-1,0,0-.5-.1-1.2,0-1.7s2.7-1.1,0-1.3c.5-1.7,1-3.3,1.5-5,.9-1.9,1.9-3.2,3-4,.9.5.9,1.1-.2,1.1l-.3,1.4Z"
          fill="#011791"
        />
        <path d="M225.7,200.3c.8.5,1.9,4-.5,3-.2-1.1-.5-1.8-.5-3,.3,0,.9,0,1,0Z" fill="#0220aa" />
        <path d="M225.7,204.8l-.5-1c0,0,.4.8.5,1Z" fill="#0220aa" />
        <path
          d="M269.2,190.8c1.7-3.4,4.2,4.3,3.5,6,1.1,1.6,1.7,3.4,1.8,5.4.7,1,1,2,1.2,3.1.2.8-.3,1-.5,1.5-.4.7-.8,1.8-1.5,2,.8-1.5-.1-2.2-.3-3.3-.4-2.4.1-7.8-2.7-8.2-.4-.2-.4-.3,0-.5,0-.8.1-1.3.5-1.5l-1.1-2.2c-1.4-.4-2.6-1.8-.9-2.3Z"
          fill="#011099"
        />
        <path
          d="M273.2,196.8c0,.4.9,1.3,1.1,2.2.5,1.9-.2,3.7,1.7,4.3l.7-2c-.3.9-.3,2.9-.5,4,0,0-.4,0-.5,0-.4.4-.4,1.1-1,1-.1-1.4.3-5-1.5-5l1-.5c-.5-1.3-1-2.6-1.5-4,.1-.4.3-.4.5,0Z"
          fill="#010e91"
        />
        <path d="M341.2,271.8c-1.3-1.3-3.1-6.3-4-8.5h.5c1.2,2.8,2.8,5.5,3.5,8.5Z" fill="#4dd4fc" />
        <path d="M337.2,264.8s-.4-.1-.5-.5l.5.5Z" fill="#4dd4fc" />
        <path
          d="M326.7,234.8c.4,1.1.8.8,1.5,1,.4-1.6,1.2-.9,2.1,2.1l1.4,2.4c1.5,4.2,2.8,8.7,4.5,13v2.5s-1.5-.5-1.5-.5c-1.7-4.3-3.8-8.7-5.5-13s-1.6-4.7-2.5-7v-.5Z"
          fill="#d4fcfb"
        />
        <path
          d="M324.7,230.8l1,2c0,.3,0,.7,0,1-1.2-1.3-1.3-1.6-1.5-3.5.1-.4.3-.4.5,0,0,.2,0,.3,0,.5Z"
          fill="#68dffc"
        />
        <path d="M326.7,234.8c0,.2,0,.4,0,.5l-.5-1.5c.7.5.3.5.5,1Z" fill="#d3f7f2" />
        <path d="M324.7,230.3h-.5c0-.2,0-.3,0-.5v-.5c0,.3.3.5.5,1Z" fill="#aef3fb" />
        <path
          d="M205.7,335.7c1.1.5-.1,1.7-1,2-1.1,1.4-1.6,1.3-3,2-1.7,1.5-3.3,2.4-5,2.5-.9.5-1.4.5-1.5,0,3.3-3,7-5.6,11-7.5.4.4,0,.8-.5,1Z"
          fill="#094cf1"
        />
        <path
          d="M196.7,342.2v.7c0,0-4.5,3.3-4.5,3.3-.2.1-.3.4-.5.5-.3-1-1.5,0-2,.2-1.4.7-3.2,1.5-4.5,2.3,1.5-1.7,3.7-3.3,5.5-4.5.8-1.3,3-2.6,4.5-2.5h1.5Z"
          fill="#1550f1"
        />
        <path
          d="M209.2,334.7c-1.1.8-2.5,2.1-3.5,3-.3,0-.7,0-1,0,.2-.2.6-1.4,1-2,1.8-2.2,3-2.5,3.5-1Z"
          fill="#1756e5"
        />
        <path
          d="M135.8,322.2c.4-.2.9-.3,1.5-.5.3,0,.3.4,0,1-.7,1.3-1.4,2.6-2,4l-1,.7.3-2.7c-.6-.2-1.9,6-2.3,3,.8-1.9,1.6-4,2.5-6,.8-1.3,1-.8,1,.5Z"
          fill="#93e7f7"
        />
        <path
          d="M132.8,332.7c-.4,1.4-1,2.3-1.5,3.5-1.2.8-1.2.5-1-.7.3-1.9,1.3-4,2.7-5.3.4.5,0,1.9-.3,2.5Z"
          fill="#8fe9fc"
        />
        <path
          d="M136.3,320.8l-.5,1c.4.2.4.3,0,.5l-1-.5c.5-1.1.7-2.5,1.5-4s.6-1,1-1.5c1.4.9.5,4.4-1,4.5Z"
          fill="#8bdff8"
        />
        <path
          d="M208.7,328.7c3.1-.8,6.1-6,9.2-5.5s2.6,1,2.3,1.7-6.4,4-7.5,4.8c-1.1,2-2.8,3.1-5,3.5-3.4,2.6-6.9,4.8-10.5,6.5l-3.5,1,1-1.5c2.7-2,5-3.7,7.5-6,2.3-1.1,4.6-2.7,6.5-4.5Z"
          fill="#0122d6"
        />
        <path
          d="M207.7,333.2c1.1.9-.4,1.3-1.5,1.5-3.6,2.5-7.3,5.1-11,7.5s-3,1.5-4.5,2.5h-.5c1.3-2.4,4.4-2.9,6.2-4.1s.6-.8.8-.9c3.5-2.2,6.8-4.8,10.5-6.5Z"
          fill="#073fea"
        />
        <path
          d="M223.7,302.3c.3.8.5,1.7.5,2.8-.3,5-.4,10-.3,15l-.7.7c-.3,1.6-.6,3.1-1,4.5-.1.4-.3.4-.5,0-.2-.3-.3-.7-.5-1,0-.5,0-1,0-1.5.2-3.4,1-5.9,1-10,1.4-1.8,0-4.5,0-6.3s.7-4.2.5-6.2c-.1-3,.1-6,0-9-.4-2.4-.4-4.7,0-7-1-.3-1-.7,0-1,0-3.4-.4-7.3.5-10.5,0,8.9-.1,17.8,0,26.7s-.3,2.2.5,2.7Z"
          fill="#0f8ff8"
        />
        <path
          d="M217.7,251.8l.4-.3c1.3,2.1,2.8,3.2,4.6,3.3.2,2.1.3,4.3.5,6.5.4,3.8.3,7.7,0,11.5-.2,3.5-.4,7-.5,10.5-2.2-.6-4.3,4.2-4.5,6.6l-1,.9c.4.1.3.3,0,.5-.1.4-.3.4-.5,0,0-2.7,0-5.3,0-8,.8-3.6,1.2-7.5,1.1-11.6.8-1.2.8-1.9-.1-2.2,0-1.9.5-3.8,1.4-5.8-1.2-4.2-1.7-8.1-1.5-11.9Z"
          fill="#0aa9fc"
        />
        <path
          d="M217.7,250.8c.5.3.4.6,0,1,0,1.3-.2,3,0,4.1s.8.4.9.7c.8,2,1.7,5.2,1.5,7.3s-2,4-1.9,4.6,1.9,1.1,1.9,1.5-1.3.9-1.5,2c-.3,1.8-.2,5.1-.5,7.5s.5,1.6.5,1.9-2.1.3-2,1.8c.1-7.2.4-14.3.5-21.5s-.5-9.1,0-14c.1-.4.3-.4.5,0,.1.9,0,2,0,3Z"
          fill="#12b9fe"
        />
        <path
          d="M218.2,250.8c.4,2.4,4.3,1.9,4.5,4l-1,2c.5-2.5-1-.7-1.9-1.6s-1.1-3-2.1-3.4c0-.3,0-.7,0-1h.5Z"
          fill="#07a4fd"
        />
        <path d="M221.5,265.8c.3.2.3.3,0,.5v-.5Z" fill="#12b9fe" />
        <path
          d="M222.7,291.3c0-.3-.4-1.5-.5-2.5s0-.3,0-.5c-.5-1.1-.3-2.3,0-3.5.1-.2.3-.3.5-.5v7Z"
          fill="#0aa9fc"
        />
        <path
          d="M181.3,224.3c0-.2,0-.3,0-.5.2-.7.4-1.3.5-2h.5c-.3.9-.2,1.9-1,2.5Z"
          fill="#c2f2fb"
        />
        <path
          d="M221.7,242.3l1,.6c-.2,1.7.1,2.3,1.5,2.9-.4.4-.3,2-.8,2s-2.6-.4-2.7-.5c-.2-.2,0-4.1,0-5,.5-1.7,1.5-3.1,2.5-4.5-.4,1.7-1.3,2.6-1.5,4.5Z"
          fill="#0146ee"
        />
        <path
          d="M232.7,235.3c.3.2.3.3,0,.5l-1,1-.5.5v1.7c-2.1,1.5-3.3,3.7-4.3,6l-1.2.3c-.2.5-.7,1-1,1.5,0-.5,0-1,0-1.5-.5,0-.5.5-.5.5-2.5,1.1-2.7-1.4-2.5-3.5,1.9-2.7,2.7-4.2,5-6.5-.5.6-.3,1.5-.5,2l.6.8,2.6-2.8c1.1-1.3,2-1.5,2.7-.5.2-.3.3-.3.5,0Z"
          fill="#022be5"
        />
        <path d="M162.8,268.8c.5-2.5,1.7-4.3,2.5-6.5-.3,2.2-1.2,4.7-2.5,6.5Z" fill="#5ddafc" />
        <path
          d="M175.3,231.3l.5,1.1c-.9,2.7-2.1,5.2-3.5,7.4l-.5.5c.4.1.4.3,0,.5-1.3,1.8-2.1,4.9-3,7,0,.1,0,.4,0,.5l-.5.5c-3.4,7.1-6.4,15.2-9.5,22.5-.1.4-.3.4-.5,0-.2.9-.4,1.3-1,.5,1-5.8,3.2-11.3,6.5-16.5,1.9-6.7,4.9-13.2,8-19.5-.5-1.6,1.2-5.6,3-6,.7-.4.8,0,.5,1.5Z"
          fill="#b1f4fb"
        />
        <path
          d="M174.3,238.3c-1,.4-.9,1.5-1.5,2.2s-.9.2-1,.3v-.5l.5-.5c.7-2.6,2-6,3-8.5.1-2,1-5.4,3-6,1.2-.9,1.2-.5,1,.8-.4,3-3.8,8.6-5,12.2Z"
          fill="#2daef6"
        />
        <path
          d="M153.8,281.8l-1.5,4.5c-1,2.7-2,5.3-3,8-.5,1-1,2-1.5,3-1,2.5-2.1,4.9-3.5,7-.7.7-1,.4-.5-.5,0-.9.4-1.7,1-2.5-.4-.2-.4-.3,0-.5l2-5.5-.3-.8c1.2-3,2.8-5.9,4.3-8.7.7-1.7,1.5-3.2,2.5-4.5.5-.7.7-.5.5.5Z"
          fill="#adf0f8"
        />
        <path
          d="M153.3,290.8c-1.6,4-2.7,8.4-5,12-.7-.2-1-.4-.5-.9.8-.8-.2,2.6-2,.9.2-1.8.9-3.6,2-5.5-.6-1.5,0-2.6,1.5-3,1.9-3.7,3.5-7.5,4.8-11.5,2.2-.1,1.8,1.3,1.3,2.9-1,1.6-1.7,3.3-2.2,5.1Z"
          fill="#13a2fb"
        />
        <path
          d="M145.8,302.8c-.3.8-.9,1.9-1.5,2.5-1,0-.9-.7,0-1,.7-2.1,2.3-5,3.5-7-.8,1.6-1.3,3.8-2,5.5Z"
          fill="#8de3f9"
        />
        <path d="M154.5,284.8c.3.2.3.3,0,.5v-.5Z" fill="#18acf9" />
        <path
          d="M144.3,304.3c0,.3,0,.7,0,1-.5,1.5-1,3-1.5,4.5-1.3,4.2-3.1,8.4-5.5,12-.3.5-1.1,1.1-1,2h-.5c0-.5,0-1,0-1.5s0-.3,0-.5l.5-1c.8-1.9.6-2.9,1-4.5l.5-.5.5-.5c-.4-.1-.4-.3,0-.5l.5-.5c-.2-.3-.3-.6-.3-.7.9-2.6,2.4-5.4,3.8-7.7.3-1,.8-1.6,1.5-2l.5.5Z"
          fill="#b1edfb"
        />
        <path
          d="M142.8,311.8c-1.1,4.1-3.7,7.4-5.5,11v-1c2.1-3.8,3-8.4,5.5-12-.3.8,0,1.9,0,2Z"
          fill="#2aa8fb"
        />
        <path d="M142.8,316.8c.1-.5.4-1.1.5-1.5h.5c-.2.6-.5,1.1-1,1.5Z" fill="#2ba8fc" />
        <path d="M141.8,319.3c.2-.4.5-.9.5-1l-.5,1Z" fill="#2ba8fc" />
        <path d="M140.8,321.7c.2-.6.5-.9.5-1l-.5,1Z" fill="#2ba8fc" />
        <path d="M141.3,320.3c.1-.4.5-.5.5-.5l-.5.5Z" fill="#2ba8fc" />
        <path d="M142.3,317.8c.1-.2.2-.4.5-.5,0,.2-.3.4-.5.5Z" fill="#2ba8fc" />
        <path
          d="M213.2,330.2c.6.8.3,1.6-1,2.5-1,.7-2,1.3-3,2-1.4,0-2.3-.4-2.8,1h-.7c.2-.3.3-.7.5-1,.8-.5,1.2-1.3,1.5-1.5,1.7-1.2,3.3-2.3,5-3.5l.5.5Z"
          fill="#0f4dee"
        />
        <path
          d="M222.7,325.2c1,.4.6.9-1,1.5.2,1.8-2.4,3.1-4,2.5.3,1.6-2.6,3.9-4,3-.2.2-1,.2-1.5.5l-.5-.2c.7-.3,1.2-2.1,1.5-2.3s1.6-.2,2.1-.5c2-1.4,4.1-3.2,6.4-4.5s.3,0,.5,0c.1-.4.3-.4.5,0Z"
          fill="#1952ee"
        />
        <path
          d="M216.7,297.8c2.9-1.4,1.3-3.8,1.5-4,1.3-1.3,3.3,1.7,3.7,3s.7,2.9.8,3.5c.2,4,.2,8.1,0,12.3l-.6.2c0-1.5,0-3,0-4.5l-1,.5c.3-.8-.8-1.9-.8-2.3,0-.6,2.1-2-.5-1.9l-3.1-3.3c0-1.2,0-2.3,0-3.5Z"
          fill="#0295fe"
        />
        <path d="M218,297.3c.3.2.3.3,0,.5v-.5Z" fill="#069cfe" />
        <path
          d="M158.3,272.8c-.8,2-1.8,4-2.5,6,0,0-.4,0-.5,0l-1.5,3-.5-.5c-.4-.9,0-1.9,1-3-.4-.1-.4-.3,0-.5l.5-.5c-.4-.1-.4-.3,0-.5l.5-1c-.5-1.1.6-4.1,2-4l1-.5c.3.2.3.7,0,1.5Z"
          fill="#bdf5fc"
        />
        <path d="M152.3,286.3c.5-1.5.8-2.9,1.5-4.5s.6-2.2,1.5-3l-3,7.5Z" fill="#99e9fa" />
        <path
          d="M268.7,88.9c.4.2.4.3,0,.5,1.5.7,2.1,2.2,2,4.5,1.1,1.4,1.8,3,2,5,1.7,3.1,3.5,6.5,4.5,10,.4.1.3.7,0,1-2.3.2-1.8-1.7-2-3.7l-1,1.2c-.7-1.9-1.8-3.7-2.5-5.5-1-2.6-1.1-5.7-2.5-8-.3-1.7-.9-3.4-1.5-5l.5-.5.5.5Z"
          fill="#b7f8fa"
        />
        <path
          d="M238.7,75.4c-1.9,2.5-.8,5.9-3,8.5l-.5-3c0-2.4.8-5.4,2.5-7l.2.5,1.2-1c.3.8-.4,1.4-.5,2Z"
          fill="#64eaf9"
        />
        <path
          d="M237.7,73.4c0,.2,0,.4,0,.5-.9,2.3-1.6,4.7-2.5,7s-1.6,2.9-2,4c-1.9,1.3-2.1-2.7,0-1.5-.7-1.2-.7-3.1,1-3-.7-.2-.6-.8.3-1.8-.5-1.7-.2-3.1,1.7-4.2-1.2-1,.4-1.9,1.5-1.5.3.1.3.3,0,.5Z"
          fill="#2c61c6"
        />
        <path d="M237.7,73.4v-.5c-.3-.6.4-.7,1-.5-.3.3-.4.9-1,1Z" fill="#2f88cb" />
        <path d="M263.7,74.9c0,.1,0,.3,0,.5-.5-.2-.4-.6-.5-1l.5.5Z" fill="#b3f6fa" />
        <path d="M266.7,233.8c-.5-.2-.8-.5-1-1,.5.2.8.5,1,1Z" fill="#0116de" />
        <path
          d="M254.2,229.8c.7,0,1.4,0,2,0,.2.2.2.3,0,.5-.5,0-1.2-.2-1.5.5-3.5-.5-8.8-.6-12,1-.5,0-1.3-.2-1.5.5-.2,0-.3,0-.5,0l-.5.5c-.2,0-.3,0-.5,0l-1,.5c-1.4.5-3.2.9-4.5,1.5l-.5.5c-.3.2-.7.3-1,.5,0-.2,0-.4,0-.5,0-.8.8-1.2,1.5-1.5-.6-.3-.4-.5.5-.5,3.7-.3,7.4-2.8,11.5-3.5l1-.5c.2,0,.3,0,.5,0,1.6,0,4.4.5,6.5.5Z"
          fill="#0328d9"
        />
        <path d="M258.7,230.8l-1-.5c.8.1.9.5,1,.5Z" fill="#062fe6" />
        <path d="M256.7,230.3c-.2,0-.3,0-.5,0v-.5c.2,0,.4.3.5.5Z" fill="#0523d9" />
        <path
          d="M327.2,227.3c1.3,3.2,2.3,6.7,3.5,10q-.2.2,0,0c0,.3.3.6.5,1s.2,1.2.5,2h-1.3c.7-1.4-1.1-2.2-1.4-3s.4-1.3.2-1.5-.7,0-1,0c1.1-3.5-1.8-6.8-3-10.2s-.6-2.5-1-3.8c1.3,0,3.6,4.3,3,5.5Z"
          fill="#d3f7f2"
        />
        <path d="M332.7,240.8c-.1-.3-.5-.6-.5-1,.2.4.3.6.5,1Z" fill="#0655ee" />
        <path d="M341.2,261.3s-.4-.2-.5-.5l.5.5Z" fill="#0344e6" />
        <path d="M332.2,239.3l-.5-.5c.1.1.3.2.5.5Z" fill="#0655ee" />
        <path
          d="M315.7,200.8l.5.5c.3.3.5.8.5,1.5,1.6-.2,1.6.7,1,2,1,.6,1.9,2.7,1,3.5-.1.4-.3.4-.5,0-1-2.4-2.1-4.8-3.5-7,0-1.2-.5-2-1-3-.3-.8-.3-.9.5-.5,1.3,0,2.5,1.9,1.5,3Z"
          fill="#c3f0e8"
        />
        <path
          d="M312.7,193.3c0,.2,0,.3,0,.5l.5.5c1.4.4,2,1.9,1,3,.5.1.4.3,0,.5l-.5.5c-1.5-3-2.4-3.8-2.5-7.5.7.4,1.2,1.2,1.5,2.5Z"
          fill="#c5efe0"
        />
        <path
          d="M304.2,172.8c.5,1.6.7,3.3,2,4.5v1.5c-1.4-2.7-1.9-2.3-3-6s.1-1.1,0-1.5c.1-.4.3-.4.5,0,.8,0,.8.9.5,1.5Z"
          fill="#b9f0ea"
        />
        <path
          d="M321.2,213.8c1,.5,1.5,1.7,1.5,3.5.9.3.9.8,0,1-1.5-.7-1.9-2.5-2.5-4s-1.2-4.1-2-6h.5c1.4,1,3.4,3.8,2.5,5.5Z"
          fill="#cbf0eb"
        />
        <path
          d="M290.2,142.8c.5.1.4.3,0,.5l.5.5c.4.1.4.3,0,.5l.5.5h.6c.7,1.9,1.5,3.7,2.4,5.5.1-.4.3-.4.5,0,1,.2.9.6,0,1,1.7,3.6,3.1,7.3,4,11-2,0-.8-2.2-2.5-2,.5,1,.7,2,1,3-.9-1.1-1.5-2.7-2-4-1.6-3.9-5.3-11.3-6-15s0-.3,0-.5c0-.5,0-1,0-1.5l1,.5Z"
          fill="#d4fcfb"
        />
        <path d="M298.7,167.8c0-.2-.3-.5-.5-1l.5,1Z" fill="#7ae5f9" />
        <path d="M299.2,168.8s-.4-.1-.5-.5l.5.5Z" fill="#7ae5f9" />
        <path d="M299.7,169.8c0,0-.4-.2-.5-.5l.5.5Z" fill="#7ae5f9" />
        <path
          d="M289.7,138.3c1.3,2.1,2.3,4.4,3,7,1,1.3,2.7,3.6,1.5,5-1-.3-2.5-4.4-3-5.5l-.5-.5c0-.1,0-.4,0-.5l-.5-.5c0-.1,0-.3,0-.5-.3-1-1.4-3.7-1.5-4s0-.3,0-.5c0-.3,0-.7,0-1,1.1-.9,1.4-.2,1,1Z"
          fill="#b0f4f3"
        />
        <path
          d="M286.7,131.3c-1.8-2.3-2-4.6-3-7-.2-.7-.2-.8.5-.5,2.1,1.3,2.8,5,2.5,7.5Z"
          fill="#156bc7"
        />
        <path
          d="M288.2,132.8c.3,1.1.3,2.4.5,3.5-1.3-1.3-1.5-3.3-2-5,.5,0,1,.5,1.5,1.5Z"
          fill="#1873d2"
        />
        <path d="M321.7,223.3c-1.6-1.9-2.6-4.7-3.5-7h.5c.8,2.3,2.1,4.7,3,7Z" fill="#79dbfa" />
        <path d="M325.7,232.8c-.8-.5-.8-1.3-1-2,.8.5.9,1.2,1,2Z" fill="#aef3fb" />
        <path d="M299.2,163.3c-.2,0-.4-.3-.5-.5.2.1.4.3.5.5Z" fill="#d4fcfb" />
        <path
          d="M221.7,118.9c-1.4,3.3-2.7,6.7-4,10-.1.3-.3.3-.5,0-1.3,1.1-.3-.2-.2,0,.2.3-.2,1.4-.8,1.1-1.4.3,0-2.6.5-3.5-.8-.8.1-4.1,1.5-4l2.2-4.4h.8c.4.2.5.3.5.9Z"
          fill="#96f0fc"
        />
        <path
          d="M217.2,128.9c.3,0,.3.4,0,1-.9,2.3-1.6,4.7-2.5,7s-.9,1.9-1.5,2.5l-.3-.3c1.2-3.4-.9,3.8-2.2,3.8-.6-1,.2-2.7,1-3.5.5-2.3,1.5-4.9,2.5-7-.3-.2-.3-.3,0-.5.7-.7,1.3-1.4,2-2,.2-.5.6-.9.5-1.5l.5.5Z"
          fill="#9cf2fc"
        />
        <path d="M217.2,129.8v-1h.5c-.2.4-.4.7-.5,1Z" fill="#88edfb" />
        <path
          d="M206.2,159.3c-1.4,3.3-2.6,6.7-4,10-.3.6-.6,1-1,1-.4-.3-.3-.6,0-1-.4-.1-.4-.3,0-.5l.5-.5c0-3.4,1.5-6.7,3.5-9.5l.5-.5c.8-.6.9-.2.5,1Z"
          fill="#3dc5ee"
        />
        <path
          d="M199.2,176.3c0,.3,0,.7,0,1-.4,1.5-1.1,2.5-2,3,0-.2,0-.3,0-.5-.3-.1-.2-.3,0-.5-.4-.1-.4-.3,0-.5l.5-.5c-.4-.1-.4-.3,0-.5l.5-1c-1-.2-.4-1.8.5-2l.5-.5c-.4-.2-.4-.3,0-.5,1.5-.6.5,1.5,0,2.5Z"
          fill="#34c3ef"
        />
        <path
          d="M199.2,176.3c.1-.9.8-1.8,0-2.5-.6-.9,0-2.2,1-2.5l.5-.5c-.4-.1-.4-.3,0-.5.1-.4.3-.4.5,0l1-1c-.9,2.3-1.5,5-3,7Z"
          fill="#3dd1ed"
        />
        <path
          d="M207.7,155.8c0,.3,0,.7,0,1-.3.7-1.3,1.9-1.5,2.5,0-.3-.3-.9-.5-1-.4-.1-.4-.3,0-.5-.2-1,.4-3.2,1.5-3,.5-.2.7.1.5,1Z"
          fill="#44c9ea"
        />
        <path d="M196.2,184.3c.4-1.3.7-2.7,1-4l2-3c-.6,2.3-1.9,4.9-3,7Z" fill="#4bcaf2" />
        <path
          d="M212.2,144.8c0,.2,0,.3,0,.5l-1,2c-1,2.9-2.2,5.7-3.5,8.5,0-.2-.5-.6-.5-1-.2-.3-.4-.6-.4-.9,0-.7,2.6-7.5,3-7.8s.5-.3.9-.3l.5-.5c-.4-.2-.4-.3,0-.5l.7-1c.4,0,.3.7.2,1Z"
          fill="#38c7f0"
        />
        <path d="M211.2,147.3c.2-.7.1-1.5,1-2-.1.8-.3,1.5-1,2Z" fill="#4dd3f2" />
        <path d="M212.7,144.3c.2-.2.3-.3.5-.5,0,.2-.3.4-.5.5Z" fill="#d6eff2" />
        <path
          d="M213.2,139.3c-.4,1.4-1,2.7-1.5,4l-.5.5c0,.1,0,.3,0,.5-1.2.9-1.6-.9-.5-1.5l2.3-5c1.4-1.4.4,1.1.2,1.5Z"
          fill="#aff3fc"
        />
        <path d="M211.2,143.8l.5-.5c0,.2-.5.4-.5.5Z" fill="#8beefc" />
        <path
          d="M191.3,195.3c.3.3.3.6,0,1,0,.2,0,.3,0,.5l-1,2c-.3,1.2-.7,2.3-1,3.5-1.5,1.9-2.2,4.4-3.1,6.6s-1.5,2.9-2.4,4.8c-.7.7-.6.4-.5-.5,1.1-5.6,3.4-11.2,6.5-16l.5-1c-.4-.2-.4-.3,0-.5.2-.8.6-1.1,1-1,0,.2,0,.3,0,.5Z"
          fill="#3eb4f3"
        />
        <path
          d="M182.3,217.3c0,.3,0,.7,0,1-.8,1-2.2,6.5-2.5,3.5-.7-1,.3-3.7,1.5-4l.5-.5c-.4-.2-.4-.3,0-.5.8-.7,1-.5.5.5Z"
          fill="#2fadf7"
        />
        <path
          d="M183.8,213.8c-.4.9-.2,2.7-1.5,3.5,0-.2-.3-.4-.5-.5-.6-1.5,0-2.8,1.5-3.5l.5.5Z"
          fill="#3db2f2"
        />
        <path d="M191.3,196.3c0-.3,0-.7,0-1h.5c0,.4,0,.8-.5,1Z" fill="#4ec6f6" />
        <path d="M190.3,198.8l1-2c-.2,1.2-.9,1.8-1,2Z" fill="#4ec6f6" />
        <path d="M191.8,194.8c0-.2.3-.4.5-.5,0,.2-.3.4-.5.5Z" fill="#4ec6f6" />
        <path
          d="M194.3,185.3c0,.2,0,.3,0,.5l-.5,1c-.6,1.9-1.5,3.6-2,5.5l-.5,1c0,.2,0,.3,0,.5l-1,2c0,.1,0,.4,0,.5l-.5,1c-2.1,5.3-4.3,10.7-6.5,16s-1,2.3-1.5,3.5,0,.4,0,.5l-.5.5c-.6,1.4-1,2.8-1.5,4s-1,2.3-1.5,3.5c-.9,2-2.1,4-3,6l-.5-1.5c-1-.9.6-3.8,1.5-4.5l.5-.5c-.4-.1-.4-.3,0-.5,1.1-3.8,2.6-7.4,4.5-11-.3-.1-.3-.3,0-.5l.5-.5c-.4-.2-.4-.3,0-.5l.5-.5c-.2-.2-.4-.3-.4-.5,0-.6,4.2-10.3,4.7-11.3s.4-.2.7-.3c.6-2.8,1.6-5.5,3-8-.8-.5,1.5-5,1.8-5s.5,0,.7,0c.7-1.5,2.4-4,1.5-1Z"
          fill="#b9f5fb"
        />
        <path
          d="M200.7,169.8c.3.1.3.3,0,.5,0,.2,0,.3,0,.5l-.5.5c-.3.9-.6,1.7-1,2.5s0,.4,0,.5l-.5.5c-.3.8-.3,1.4-.5,2l-.5,1c0,.1,0,.3,0,.5l-.5.5c0,.1,0,.3,0,.5l-.5.5c0,.1,0,.3,0,.5l-.5,1c0,.1,0,.4,0,.5l-.5.5c0,.1,0,.4,0,.5l-.5.5c-.3.6-.1,1.6-1,2,0-.3,0-.7,0-1h-.5c.1.9-.7,1.4-1,2,0-.5-.2-.9,0-1.4.3-2.2,5.4-13.6,6.9-15.8s.3,0,.7.1c.6-.7.8-.4.5.5Z"
          fill="#9ff3fb"
        />
        <path d="M193.8,186.8l.5-1c0,.5-.4.8-.5,1Z" fill="#9ff3fb" />
        <path d="M196.2,181.3c.2-.4.5-.9.5-1l-.5,1Z" fill="#4bcaf2" />
        <path d="M191.3,193.3l.5-1c-.2.6-.5.9-.5,1Z" fill="#4ec6f6" />
        <path d="M191.3,194.8l-1,1c.3-.7.1-1.5,1-2,0,.3,0,.7,0,1Z" fill="#4ec6f6" />
        <path d="M197.2,179.8h-.5c.1-.2.2-.4.5-.5,0,.2,0,.3,0,.5Z" fill="#4bcaf2" />
        <path d="M195.7,182.3c.1-.3.5-.4.5-.5l-.5.5Z" fill="#4bcaf2" />
        <path d="M195.2,183.3c.1-.3.5-.4.5-.5l-.5.5Z" fill="#4bcaf2" />
        <path
          d="M242.2,204.8c.4.2.9.5,1,1,1.5-.2,2.9.4,4,2,.4.1.4.3,0,.5l-.5,1h-5.5c-.1-1,1.1-.3,1.5-.5s-.5-.8-.5-1,.5-.5.4-.7c-.2-1.2-1.3-.2-1.9-.2-1.5-1.2,0-1.9,1.5-2Z"
          fill="#0273fa"
        />
        <path
          d="M254.7,203.8c-.4-1.1,1.9,0,2.5.5-.5-.9-.3-1.1.5-.5.5.5.7,1.1,0,1.5,1.5,1.3,1.4,2.6-.5,2.5-.7.5-.4,1,1,1.2,3.7-.1,2.8,3.4,0,2.8-.4,0-.4-.3,0-.5-.6-.6-.9-.6-1,0,.7.3.7.7,0,1-.1.3-.3.3-.5,0l-.6.3c-.8-1.1-1.9-1.5-3.4-1.3-.6,1.7-1.4,2.7-2.5,3,.8,1.5.5,2.4-.8,2.5l-.7,1c3.1,1.1.1,1.8-2,1.5-.2,0-.3,0-.5,0l-.5.5c-.5,0-.4-1-.5-1,0-.6.4-1,1-1l-.3-1.1c-2.1-.6-3.3-1.7-3.7-3.4-.2,3.2-3.1-1.2-1-1.5.3-.4.6-.7,1-1,.6-1.1-1.8-.2-2.5,1,.7-.2,1,.3.9,1.4,2.1,1.6.1,1.9-1.4,1.1-.4-.5-.7-1-1-1.5h-.9c-.5,1.1-1.8.7-2.1-.5-.4-1.3,1.9-2.4,2.5-1,.3-.5.7-1,1-1.5-.4-.1-.4-.3,0-.5,2.3.2,2.1,0-.5-.5-1.8-1.5-.3-1.7,1.5-1,.2-.4.3-.4.5,0h1.5c.1-.4.3-.4.5,0,.4-.3,3.3.6,3.7.8s.3.4.3.7c.1.5,0,.6-.5.5,0,.6.1,1.1.5,1.5.2-1.2,1.5-1,2,0,.9.2,1.7.1,2.5-.5-3.6.6-3.3-1.9-.9-2.8.2-2.4,3.6-1.2,1.9.8.8.1,1.6,0,2.5-.5-.5-1.1-.3-1.7,1-1.5.6-.2.8-.3.5-.5-1.8-1.2-2.1-2-1-2.5Z"
          fill="#0369f9"
        />
        <path
          d="M252.7,211.3c0,0,.5-.4,0-1,.9.4,2.4.2,3.1.5s.3,1.2.8,1.5c.2.2.4.2.5,0,0-.3,0-.7,0-1,0-.8.8-.8,1,0,0,.2,0,.3,0,.5,0,.9,0,1.6-1,1.7,1,.2,2.6.5,1,1.2l-2-.5c-1.3.1-2.2.5-2.5,1,.4.2.4.3,0,.5.3.7.2.9-.5.5-1.6.8-2.6,1.4-4.5,1.5l-.4-.3c.2-3.6,1.2-1.4,1.9-1.7-.3-.7-.2-.8,0-1.5.9-1.1,1.4-.9,1,.5,0,1.2.2,1.4.5.5-1-1.1.1-3.1,1-4Z"
          fill="#0257f9"
        />
        <path
          d="M242.2,213.3c2.9-.2.6,1,1,1.5,1,1.1.8-1.3,1.5-1-.5,2.7.9,1.9,3,2.5.2.3-1.2,1.1-1.5,1.5-.7-1.6-5.5-2-4-4.5Z"
          fill="#024ff9"
        />
        <path
          d="M252.7,211.3c0,1-.5,2.4-1,4-.4.2-.6,0-.5-.5-.3-.3-.5-.5-1-.5.7-1.8,1.9-2,1-4l1.5,1Z"
          fill="#024bf3"
        />
        <path d="M247.7,213.3c.3,1.7-1.5.4-.5,2l-2-.5,2.5-1.5Z" fill="#024ff9" />
        <path
          d="M239.7,211.8c0-1.5,1.7-2.1,3-2,.3.8-.5.9-.5,1-.2.7-.9.8-1.5.5-.3.2-.6.4-1,.5Z"
          fill="#024df4"
        />
        <path
          d="M245.7,209.8l.5,1.5c-.3,0-.9-.7-1.5-.5.3,1.6,1.3,2.3-1,2l1-.7c-2.1-1.6,0-1.5,1-2.3Z"
          fill="#024df5"
        />
        <path
          d="M253.7,208.3h.5c-.8.6-1.2,1.2-2.3,1.5-.5.1-.1-.7-.2-1,.3-.1.7-.4,1-.5.4-.2.7-.2,1,0Z"
          fill="#024df3"
        />
        <path d="M238.2,208.8h2.5s0,1,0,1c0,0-1.7-.3-2-.5s-.4,0-.5-.5Z" fill="#024cf2" />
        <path d="M257.2,211.3c0,0-1.1-.7-.2-1,1.3-.4,1.3,0,1.2,1h-1Z" fill="#034df5" />
        <path d="M242.2,210.8c-.2.5.4,1.3-1,1,0,0-.4-.3-.5-.5.5-.2.9-.5,1.5-.5Z" fill="#0380f9" />
        <path d="M247.5,211.8c.3.2.3.3,0,.5v-.5Z" fill="#024ff9" />
        <path d="M256.7,212.3c.1,0,.3,0,.5,0l-.2.5-.2-.5Z" fill="#034df5" />
        <path
          d="M261.2,208.8c.2-1.6,2.6,0,2.9.5-.4,1.2-.1,2.4.6,3.5,0,0-.5.8-.5,1l-1.2-1.5-.3,2c-4.1-1.5-.4-2.8-.5-4.2s-.6,0-1-1.3Z"
          fill="#0234eb"
        />
        <path
          d="M258.7,207.3c1.4-.8,4.2-.2,2.5,1.5-2.5-.1-1.7-.4-2.5-.5,0-.3,0-.8,0-1Z"
          fill="#0369f9"
        />
        <path
          d="M258.2,214.8c-.1,0-.3,0-.5,0-.8.4-1.3.4-1.5,0-.4-.1-.4-.3,0-.5.3,0,1.4-.6,2,.5Z"
          fill="#046bf9"
        />
        <path
          d="M257.7,214.8l-1.5,1c-.2,0-.3,0-.5,0v-1c0-.3.2-.3.5,0,.5,0,1,0,1.5,0Z"
          fill="#0257f9"
        />
        <path
          d="M259.7,216.8v.5c-.5.1-.8.3-1,.5-.6.8-.5,2.5-1,3.2s-.9.2-1.4.5.5,1.6-1.7-.2c.3,1.9-.3,1.6-2,1.5.9-1.1-.6-1.6-1.5-2-1.3-.6.8-2.8,1.3-2.9s1,.4,1.2.4c.9-.9,1.9-1.7,3-2.5,1.1.2,2.2.8,3,1Z"
          fill="#0350f7"
        />
        <path d="M259.7,217.3c0,.8-.9.4-1,.5-.4-.6-1.2-.3-1-1l2,.5Z" fill="#034df5" />
        <path d="M254.7,218.8c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#0124e8" />
        <rect
          fill="#0367f6"
          height="1"
          transform="translate(23.8 450.9) rotate(-89.9)"
          width="1.5"
          x="237"
          y="213.1"
        />
        <path
          d="M271.2,200.8c0,0,.7.2.7.5s.3,2.6.3,2.7c0,.6-1.2,0-1,.8l1.5.8-2,.3,1,2c-2.5-.3.1,1.3,0,1.7s-1.1,2.7-2,2.3c0-.7-.6-2.3-1-3,.4-1.7.2-3-.6-4.1.9-.6,1.1-1.1.6-1.4-.9,0,.3-3.1.7-3.1l1.8.7Z"
          fill="#011ecb"
        />
        <path
          d="M267.2,190.3c1.3-.3,1.5.7,1.4,1.8,1.2.5,1.5,1.1,1.1,1.7.9,1,1.2,2,1,3,0,.2,0,.3,0,.5.2,1,.3,2,.5,3-2.1,1.1-3.4.3-2.1-1.9l-.4-1.1h-.5c.3.5,0,.7-.5.5-.1.4-.3.4-.5,0-.7-.7.2-3,1-4-.7,0-3.2-2.2-3.4-2.5s.2-1.5.9-1.5c.1-.6.6-.4,1.5.5Z"
          fill="#0122c3"
        />
        <path
          d="M268.7,197.3c2.6.4.8,1,.7,1.7-.2,1.1.9,1.6,1.8,1.3,0,.2,0,.3,0,.5-2.1-.1-1.5.9-2.5,2.5-.9.3-1.6.2-2-.5-2.2-2.5-2.2-4.5,2-4.5-.4-.2-.4-.3,0-.5v-.5Z"
          fill="#022bda"
        />
        <path
          d="M268.7,203.3c.2,0,.7,0,1,0,.3,1.3-.3.7-1,1.2,2,1,1.5,1.1.5,3,1.7.2.9,1.2-.5,1.2s-.7-.8-1-.3l1,2.2-2,.8c-.4.7,1.9,1.1,1,2.2s-1.2-.7-1.5-1c-2.2-.9-2.7-1.6-1.5-2,1.2-1.9,1.2-3.1-.2-3.6,1-1.4,1.6-2.9,2.2-4.4.8,0,1.3.3,2,.5Z"
          fill="#0236e5"
        />
        <path
          d="M263.2,207.3c1.2.7,0,.4.1.4,3.2-1.6,2.7.8,1.4,3.1,0,1.7.8.6,1.4,1.1s0,.8.1.9h-.5c-.3-.2-.6-.2-1,0-2.6-.2-1.3-3.3-1.5-3.5s-1.9-.5-2-.5c-.6-1.6-.5-1-2.5-1.5.7-1.8,4.3-.6,4.5,0Z"
          fill="#0251f4"
        />
        <path d="M265.7,212.8c-.3,0-.8,0-1,0,0,0,.6-.8,1,0Z" fill="#0236e5" />
        <path d="M241.7,228.8c-4.2,2-8.6,2.2-12.5,5,5.3-4.2,5.6-4.5,12.5-5Z" fill="#0021f0" />
        <path d="M246.7,228.3c-.8,0-2.7.4-4,.5.9-1,2.7-.3,4-.5Z" fill="#0523d9" />
        <path
          d="M234.7,233.3c-.1.2-.3.3-.5.5-.8.4-1.4.9-2,1.5-2.9.2-5.8,6.3-7.3,7s-.8-.3-.5-1c.5-1.1,1.4-2.3,1.8-3.5,2.4-1.4,3.7-4.8,6.8-4.9s1.4.4,1.7.4Z"
          fill="#0114d0"
        />
        <path d="M247.2,229.3c0,0-.5.4-1,.5l1-.5Z" fill="#0523d9" />
        <path
          d="M255.7,168.8c.2,0,.3,0,.5,0,2-.6,8.7-.2,9.7,1.9s0,.7-.2,1.1c-.2.4-.6.7-1,.6-1.8-.9-3.5-1.3-5-1.1-.4.5-1.2.2-2.5-1l-.4.6c-2.2-.2-4.4-.6-6.6-1.1-.5.7-1.5.8-2,0,1.7-.7-1.9-.6-3.1-.5-2.8.1-5.7.2-8.4,1.1l-3,1.4-.2,1.3c-2,1.5-5.4,4.3-5.3,6.7.9.4-.2,1.9-1,2-.1.4-.3.4-.5,0-2.4,2.6-2.3.3-1-2-.4-.1-.4-.3,0-.5l.5-.5c-.4-.1-.4-.3,0-.5l.5-.5c1.8-5,8.3-9.6,13.6-10.8s.5.2.8.6c1.5-1,3.8-2,5.1-.8,3.2.2,6.6.6,9.5,2.1Z"
          fill="#0127e9"
        />
        <path
          d="M226.2,176.8c1.1-2.9,11.3-11.4,13.7-11s.5,1.8,1.6,1.5c1.5-2.7,2.8-2.8,5.8-2.5l-1,1.5c1.3.1,2.7.3,4,.5,1.3-.8,2.5-.6,3.5.5l2,1.5c-4.2-.8-6.6-2-11.3-1.5-7.6.8-13.7,4.1-17.7,10.5l-.5.5c0,.1,0,.4,0,.5l-.5.5c0,.1,0,.3,0,.5-1,1.7-1.2,3.7,1,2h.5c.4.2.2.7-.5,1.5.4.2.4.3,0,.5-.6,1.1-1.2,1.9-2,2.5-.7.4-1.1,1.2-2,1,0-.7,0-1.3,0-2,.9-2.9,2.3-5.7,3.5-8.5Z"
          fill="#0035f5"
        />
        <path
          d="M268.2,172.3c4.2,3.6,7.2,5.6,9,11.5l.5,1c0,.4,0,1,0,1.5.7,1.8,1.5,6.7-.5,4v-.5c-1.1-.4-1.8-1.6-2-3.5-.8-.8-2.7-3-1.5-3.5,1.9.6,1.9.2.1-1.2-1.1-2.5-2.4-4.8-4.1-6.8-1,1.1-2.8-.8-2-2-.7-.7-.4-1,.5-.5Z"
          fill="#0134ec"
        />
        <path
          d="M256.2,168.8c1.9.4,2.5-.9,3.7-1.9,1.9,1.5,4.2,1.2,6.1,2.7s1.4,2,2.1,2.7l-.5.5c-.9,1.1-2.3.4-2-1-2.1-2.6-6.4-2.4-9.5-3Z"
          fill="#0133ee"
        />
        <path
          d="M250.2,166.8l-2-1.5c1.3.4,2.8-1,3.7-1s4.5,1.8,4.7,2c1.3,2-1.6,1.1-2.9.9s-2.3-.3-3.5-.5Z"
          fill="#024df6"
        />
        <path
          d="M277.2,189.8c0,1.6,0,3.6,0,5.5h-.5c-.5,0-.4-.2,0-.5,0-.9-.1-1.7-.5-2.5-1.5-.3-2.5-3.8-1-4.5-.3-.6-.3-1.1,0-1.5.4.8,2,2.7,2,3.5Z"
          fill="#023df3"
        />
        <path d="M277.7,186.3c1.4,2.2.9,5,1,7.5l-1.5-3.5,1,.5c0-1.5-.3-3-.5-4.5Z" fill="#023df3" />
        <path d="M277.7,184.8l-.5-1c0,.2.4.5.5,1Z" fill="#023df3" />
        <path
          d="M271.7,182.3c1.7,0,3,3.8,3.5,5.5.2,1.5.8,2.8,1,4.5.4.8.5,1.6.5,2.5,0,.2,0,.3,0,.5,0,1.5,0,3,0,4.5l-1-4.5-2.5,1.5c-.8-.8-.8-2.1.5-1.5.1-1,0-1.8-.5-2.5-.5.2-.7,0-.5-.5-.7-3-2.1-5.9-4.2-8.7-.5-1.8-1.8-3.4-3.9-4.8-.8-4.6,6.6,1.5,7.1,3.5Z"
          fill="#030465"
        />
        <path
          d="M226.7,187.3c.7,1.8.3,2.8-1.1,3.2-.8,2.2-1.8,2.6-1.4-.2,0-.2,0-.3,0-.5l.5-1.5c0-.3,0-.7,0-1,.5-1.3,1.1-2.4,2-3.5,0-.1,0-.4,0-.5.6-1.3,1.2-2,2-2,.7-.9,2-1.6,2.3-.2s-3.2,5.6-4.3,6.2Z"
          fill="#01043e"
        />
        <path
          d="M227.7,187.3c.2.7,0,1.5-.5,2.5.4.2.4.3,0,.5-1.5-.2-1.3-.2-1.6,1.1-.6,1.9-.7,4-1.4,5.9l-.5-4.5c-.5-.9.5-2.3.5-2.5l.5,2c-.5-2,1.7-2.2,2-2.6s-.7-1,0-2.4c.3-.3.7-.3,1,0Z"
          fill="#020651"
        />
        <path d="M224.2,189.8c.1-.9.4-1.2.5-1.5l-.5,1.5Z" fill="#020651" />
        <path
          d="M224.7,187.3c0-.3,0-.7,0-1,.2-.5,1.4-2.2,2-2.5-.5,1.2-1.1,2.6-2,3.5Z"
          fill="#0330eb"
        />
        <path
          d="M236.7,186.3c1.2-1.2,3.8-3.2,3.5-.5,1.9,2.6-2.3,5-4.2,3.6s-.6,0-.8.4c.7,3.3,0,4.4-2,3.1l-1.5.3c1.1.8.8,1.1-.5,1-.5-1.9-2.3-.2-2.5-.5-.9-1.1.8-2,2-1.5l-.5-2c-.4-.1-.4-.3,0-.5-.5-1,0-1.3,1-1,0-.4.7-.3,1,0l.3-.8c-1.6-1.3.4-2.4,2-2.2,1.1-1.9,3-1.8,2.2.5Z"
          fill="#0235ce"
        />
        <path
          d="M246.2,181.8l-.4,1.1c-3.2.4-6.6,1.3-9.1,3.4-.5-.1-.3-1.2-1-1-.1,1.8-1.6,1.6-3,1.5l1,2c-.5,0-1.1,0-1.5,0l-1-.5c-.3.2-.3.4,0,.5,0,0-.5,1-1,1-.4,0-.7.2-1,.5,0,.1-.4.3-.5.5-.9-1,0-1.4.5-2.5.5-.8,1-1.8,1.3-2.9,2.6-1.2,5.4-2.2,8.2-3.1l.3-.7c2.1-.1,4.2-.4,6.2-.8.2-.4.3-.4.5,0,1.3,0,1.5,0,.5,1Z"
          fill="#011f99"
        />
        <path d="M230.2,189.8v.5h-1c.5-1.9.2-.6,1-.5Z" fill="#011791" />
        <path
          d="M238.7,182.3l-2,.7,1.5.7c-1-.8-7.3,1.7-7.5,2s.5,1,.4,1.4-1.8,1-1.9,1.1c-2.3,1.9-.8,3.3-1,3.5s-1.6,0-2,.5c.4-1.4.9-1.7,1-2s0-.4,0-.5c.5-1.9,1.7-3.5,3-5,.3-.7,1-1.4,1.5-.5.2-1.3,6.2-2.8,6.6-2.6s.3.4.4.6Z"
          fill="#011275"
        />
        <path
          d="M261.7,184.8c.4-.2.8-.5,1.2-.5s6.9,4.8,6.3,6c.4.1.4.3,0,.5-.1.5-.3,1-.5,1.5,2.5-.5,2.4.9,2.5,3-.6,0-1.1-.5-1.5-1.5-.9-.9-1.6-2.1-2.5-3.5l-5.5-4.5c-.4-.2-.4-.3,0-.5-.4-.1-.4-.3,0-.5Z"
          fill="#0118a3"
        />
        <path
          d="M269.7,188.3c1.6-1.3,3.4,2.4,3,4,.2.2.3.3.5.5.6.3.8,1.2.5,2.5,0,.3-.7.5-.5,1.5h-.5c-.5-1.4-1.6-3.7-1.6-5.4s-1.1-.4-1.9-.6c0-.1,0-.3,0-.5-.8-1.1-.6-1.8.5-2Z"
          fill="#010b7a"
        />
        <path d="M271.2,195.3c0,.5.1,1.3-.5,1.5-.2-1-.8-2-1-3,.5.5,1.1.9,1.5,1.5Z" fill="#0115b4" />
        <path
          d="M150.8,285.8c-.8,3.4-2.7,6.3-4,9.5l-2,5.5c0,.1,0,.4,0,.5-.3.6-.6,1.1-1,1.5l-.5.5c0,.7-.3,1.6-1,2.5-.4,1.1-.9,1.6-1.5,1.5,1.8-4.7,3.8-9.3,5.5-14-.8-1.2-.4-2,1-2.5.2-1.3.7-2.1,1.5-2.5.4-1.1,1-2.5,2-3v.5Z"
          fill="#7ee0f6"
        />
        <path
          d="M138.8,314.3l-.5.5c0,.1,0,.4,0,.5l-.5.5c-.1.2-.4.3-.5.5.2-.8.2-1.6.5-2.5.4-1.3,2.2-5.3,3-6.5s1.1-.9,1.5-1.5c-1.1,3-1.7,5.5-3.5,8.5Z"
          fill="#82ddf9"
        />
        <path d="M135.8,321.7c0-.4,0-.8.5-1-.1.3,0,.8-.5,1Z" fill="#93e7f7" />
        <path d="M223.7,299.3h.5l-.2.5c-.3,0-.2-.3-.2-.5Z" fill="#030c97" />
        <path
          d="M223.2,321.7c.4.8.7,3.6-.5,3.5h-.5c0-1.5-.1-3.3,1-4.5,0,.3,0,.7,0,1Z"
          fill="#2d91f5"
        />
        <path
          d="M222.7,283.3c0,.3,0,.7,0,1,0,.3-.1.6-.5.5-.3,1.2-.5,2.4,0,3.5.3.1.3.3,0,.5-1.5,2.1-2.4,2.9-5,2,0-.9-.1-1.7.1-2.6s3.7-6.9,4.1-6.9l1.2,2Z"
          fill="#06a5fe"
        />
        <path d="M222.2,288.3c-1-1-.6-2.4,0-3.5,0,1.2,0,2.3,0,3.5Z" fill="#069cfe" />
        <path d="M220.7,285.8c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#0aa9fc" />
        <path d="M234.2,233.8c-.5.4-1.2.9-1.5,1.5h-.5c.4-.9,1-1.4,2-1.5Z" fill="#0117e0" />
        <path d="M168.3,248.8c.1-.2.4-.4.5-.5l-.5.5Z" fill="#28bcf6" />
        <path
          d="M157.3,271.8c-.6,1.3-1.4,2.5-2,4l-.5,1c0,.1,0,.3,0,.5l-.5.5c0,.2,0,.4,0,.5-.7,1.7-1.2,2.1-1.5,1,0-.4.2-.9.5-1.5.4-1.4.9-2.7,1.5-4-.4-1.3-.6-2.8,1-3l.5-1c-.4-.2-.4-.3,0-.5l.5-.5c-.4-.1-.4-.3,0-.5l.5-1c-.4,0-.4-.3,0-.5l.8-2.1c0-3,.9-4.8,2.7-5.4.7-2.1,1.7-3.5,3-4-2.3,5.4-4.2,11.1-6.5,16.5Z"
          fill="#7de2f9"
        />
        <path
          d="M163.8,255.3l-3,4c-1.1,0-1-.7.5-2-.9-.6-.6-1.1.5-1-.2-1.2,0-1.6.5-1-.7-.9-.7-1,.5-1v-.5l.5-.5c-.5-1.3-.3-3.5,1.5-3.5,1.4-3,2.7-6,4-9-.3-.1-.3-.3,0-.5.7-2.1,1.7-3.6,3-4.5-2.6,6.5-5.3,13-8,19.5Z"
          fill="#79e4f7"
        />
        <path
          d="M176.8,224.3c0,.2,0,.3,0,.5l-.5.5c-.4,1.3-1,3.2-1.5,4.5-.7,1.8-2.2,4.1-3,6l-3,4.5c-.2-.1-.2-.3,0-.5-.4-.1-.4-.3,0-.5l1-2c-.4-.2-.4-.3,0-.5-.1-2,.4-3.2,1.5-3.5.1-1.5.5-2.4,1-2.5-1.1-1,.1-2.8,1.5-2.5l2.5-5.5c-1.1,0-1.1-.7,0-1-1-1.1-.2-1.7,1-1,.6.8.5,1.9-.5,3.5Z"
          fill="#6cd8f6"
        />
        <path d="M158.3,272.8v-1.5h.5c-.2.4-.2.9-.5,1.5Z" fill="#7de2f9" />
        <path d="M171.8,240.3l.5-.5c0,.2-.3.4-.5.5Z" fill="#28bcf6" />
        <path
          d="M153.3,281.3c-.6,1.5-1.5,3.2-2.5,4.5,0-.2,0-.3,0-.5-.4-.2-.4-.3,0-.5l.5-.5c0-1.6.5-3.3,1.5-5,.8.2,1.1-.4,1.5-1-.3,1-.6,2.1-1,3Z"
          fill="#99e9fa"
        />
        <path d="M144.8,300.8c.7-2,1.2-3.5,2-5.5l-2,5.5Z" fill="#8de3f9" />
        <path
          d="M143.8,303.8c-.3.6-1.1,1.4-1.5,2,.4-1.1.5-1.4,1-2.5l.5-.5c.3-.4.4-1.2,1-1.5-.3.9-.5,1.6-1,2.5Z"
          fill="#8de3f9"
        />
        <path d="M137.8,315.8l.5-.5c-.1.2-.4.3-.5.5Z" fill="#8bdff8" />
        <path d="M138.3,314.8c0-.2.3-.4.5-.5-.1.2-.3.3-.5.5Z" fill="#8bdff8" />
        <path d="M154.8,276.8c.1-.4.2-.7.5-1-.1.3,0,.8-.5,1Z" fill="#99e9fa" />
        <path d="M154.3,277.8c0-.2.3-.4.5-.5,0,.2-.3.4-.5.5Z" fill="#99e9fa" />
        <path d="M268.7,88.9l-.5-.5v-.5c0,.1.3.5.5,1Z" fill="#1d70d8" />
        <path d="M267.7,85.9c-.2,0-.4-.3-.5-.5.2,0,.4.3.5.5Z" fill="#3572bf" />
        <path d="M239.7,232.8l-1,.5c.1,0,.4-.3,1-.5Z" fill="#010b61" />
        <path d="M240.2,232.8l.5-.5c-.1,0-.3.4-.5.5Z" fill="#010b61" />
        <path d="M233.7,235.3c.1,0,.2-.4.5-.5l-.5.5Z" fill="#0117e0" />
        <path d="M330.7,237.3c.2.2-.5.8-.5.2s.4-.4.5-.2Z" fill="#d4fcfb" />
        <path d="M313.2,194.3c-.2,0-.5-.3-.5-.5h.5c0,.2,0,.3,0,.5Z" fill="#036ef3" />
        <path
          d="M297.7,156.8c.6,1.5.9,4.1,1.5,5.5h-.5c-1.1-3-3.7-8.1-4-11,.9,1.5,2.4,4,3,5.5Z"
          fill="#b9f4f0"
        />
        <path d="M290.7,143.8c-.2-.1-.4-.3-.5-.5.2.1.4.3.5.5Z" fill="#befafa" />
        <path d="M291.2,144.8l-.5-.5c0,.1.4.3.5.5Z" fill="#befafa" />
        <path
          d="M220.7,115.9c-.1.5-.7,1.7-.5,2s.5-.4,1,0c-.9,1.7-1.1,3.6-3,4.5-1.2-.1-1.2-1.2,0-1.5l2.5-5Z"
          fill="#66def8"
        />
        <path
          d="M222.7,116.9c-.3.7-.7,1.4-1,2-.5,0-.6-.3-.5-1-2.1,1.9-1.3-.4-.5-2-.7-.3-.6-1.2.5-2.5-.6-.6-.4-1.3.5-1-.3-1.8,0-2.5,1-2-.4-.9,0-2.2,1-2.5-.5-1.4,1-3.3,2-4.5-.1-1.2.5-2.7,1.5-3.5-.3-.2-.3-.3,0-.5l1-2c-.2-.4,0-.6.5-.5-1.3,3.8-2.4,9.3-3.7,13.5s-2.2,3.9-2.3,6.5Z"
          fill="#7ee9fb"
        />
        <path
          d="M225.7,103.4c-.6,1.6-1.3,3-2,4.5-.7,1.7-1.5-1.2-1.4-2s2-3.7,2.9-3c.7-.7.6-.4.5.5Z"
          fill="#1464c6"
        />
        <path
          d="M220.7,110.9c0,0,1.5-.3,1,1.5-.2.2-.2.6-.5,1s-.7.7-1,1c-.5-1.1-.4-3,0-3.5.1-.4.3-.4.5,0Z"
          fill="#0855d4"
        />
        <path
          d="M227.2,99.9c-.5,1.2-1,2.3-1.5,3.5l-.5-.5c0-.1,0-.3,0-.5-.2-.5,0-.9.5-1,0-.2,0-.4,0-.5,0-1.3.3-1.6,1-1h.5Z"
          fill="#1967c8"
        />
        <path d="M227.2,99.4c.3-1,.2-1.1,1-2l-1,2Z" fill="#1967c8" />
        <path d="M221.7,116.9c-.2.3-.8-.3-.5-1s.8.3.5,1Z" fill="#66def8" />
        <path
          d="M216.2,129.8c-.4,1-.8,1.9-1,3h-.5s-.5-1-.5-1c-1.1-1.6.5-4.6,2-5.5h.5c-.3,1.1-1.1,2.5-.5,3.5Z"
          fill="#88edfb"
        />
        <path
          d="M211.7,139.3c-.1.3-.3.3-.5,0-.8-1.8-.3-4,1.5-5l.5-.5c-.4-.1-.4-.3,0-.5-.5-.7-.5-1.1.5-1h.5c-.8,4-.9,3.4-2.5,7Z"
          fill="#88edfb"
        />
        <path
          d="M205.7,157.8c0,.1,0,.3,0,.5l-.5.5c-1.1,3.2-2.3,6.4-3.5,9.5l-.5.5c0,.2,0,.3,0,.5,0,.4-.3.6-.5.5l-.5-.5-.5-.5,2-4.5c-.6-1.2-.2-2,1-2.5.2-1.5,1.1-2.9,2-4,.8-1.4,1.5-1.8,1,0Z"
          fill="#a1f1fa"
        />
        <path d="M201.2,170.3h-.5c0-.1,0-.3,0-.5s.3-.4.5-.5c0,.3,0,.7,0,1Z" fill="#76e8fb" />
        <path d="M205.2,158.8c0-.2,0-.6.5-.5,0,.3,0,.6-.5.5Z" fill="#8beefc" />
        <path d="M201.2,168.8c0-.2.3-.4.5-.5,0,.2-.3.4-.5.5Z" fill="#3dd1ed" />
        <path d="M197.7,177.8c.2-.5.5-.9.5-1l-.5,1Z" fill="#4bcaf2" />
        <path d="M198.7,174.8c0-.2.4-.4.5-.5l-.5.5Z" fill="#3dd1ed" />
        <path d="M197.2,178.8c0-.2.3-.4.5-.5,0,.2-.3.4-.5.5Z" fill="#4bcaf2" />
        <path d="M200.2,171.3c0-.2.3-.4.5-.5,0,.2-.3.4-.5.5Z" fill="#76e8fb" />
        <path
          d="M211.7,139.3c-.7,1.5-.9,1.8-1,3.5s-.1,1.3.5,1.5c0,.1,0,.3,0,.5s0,.3,0,.5l-.5.5c-1.4,2.8-2.3,6.1-3.5,9s-1.1,2.1-1.5,3l-.2-.5-.8.5c0-1.8.3-4.8,1.7-5.9,1-3.6,2.3-7,3.8-10.1-1-1.1-.4-2.6,1-2.5h.5Z"
          fill="#8beefc"
        />
        <path d="M210.7,145.8c0-.2.3-.4.5-.5,0,.2-.3.4-.5.5Z" fill="#4dd3f2" />
        <path d="M189.8,197.3c.2-.4.4-.8.5-1l-.5,1Z" fill="#4ec6f6" />
        <path d="M181.3,217.8c0-.2.4-.4.5-.5l-.5.5Z" fill="#3db2f2" />
        <path
          d="M200.2,169.3c-.1.3-.8.9-1.1,1.6-2.1,5.1-4,10.4-6.4,15.4-.8,1.4-1.9,3.5-2.5,5-.4,1-.9,1.5-1.5,1.5-.6-1.8-.3-3,1-3.5-.6-1.5-.2-2.1,1-2-.2-2.3,1.1-4.3,2.5-6-.7-2-.4-2.7,1.5-3.5.2-2.1.9-4.8,2.3-6.6s.7-.7,1.2-.9l2.7-6h.8c-.6,1.6-1,3.7-1.5,5Z"
          fill="#76e8fb"
        />
        <path
          d="M187.3,199.3c-.6,2.6-3.6,9.6-5,12l-.5.5c0,.1,0,.4,0,.5l-.5.5c0,.2,0,.3,0,.5-.1.4-.3.4-.5,0-1.4-.7-.6-4.3,1-4.5l.5-.5c-.4-.1-.4-.3,0-.5-.5-.9-.7-2.6,1-2.5-.4-.5-.2-1.5.5-1.5,0-1.3,0-2,.9-3.3.1-2,.8-3,2.1-3.2l.5-.5c-.4-.2-.4-.3,0-.5,1.8-.7.5,2,0,3Z"
          fill="#85e9f9"
        />
        <path
          d="M181.3,213.3c-.7,2.7-1.7,5.1-2.6,7.6s-1,2.5-1.9,3.4c.3-1.2.3-2.6.5-3.5-1.4-.6-1-1.8.5-2-.2-.6,1.5-4.8,1.7-5.1l1.3-.4h.5Z"
          fill="#92ecfb"
        />
        <path
          d="M187.3,199.3c.2-1,.9-2.1,0-3-1-1.1,0-3.5,1.5-3.5.3-.5,1-1.1,1.5-1.5-1,2.4-1.3,5.8-3,8Z"
          fill="#87e5f8"
        />
        <path d="M181.8,211.8c0-.2.3-.4.5-.5-.1.2-.3.3-.5.5Z" fill="#92ecfb" />
        <path d="M181.3,212.8l.5-.5c-.1.3-.5.5-.5.5Z" fill="#92ecfb" />
        <path d="M176.3,225.3l.5-.5c0,.3-.5.5-.5.5Z" fill="#92ecfb" />
        <path
          d="M249.2,187.8c1.9-1.1,3.8-1.8,5.6.2-1.3.3-1.5.4-.6.3.4.1.4.3,0,.5.3.2.3.3,0,.5l-.5.5c-.4.4-.4.7,0,1-.1,1.8.4,2.2,2,1.5.7-.7,1.1-.5,1,.5-1,.4-2.3.7-3,1.5-.2.4-.3.4-.5,0-.6,0-.9,0-1,.5.6,1.9,1.1.6,1.5,1,.6.6-.9,1.4-1,1.7s2.6,1,0,2.7c.2-2-.3-1.7-2-1-.3-1.8,2.6-1,.7-2.5-.9.4-1.2,2.4-1.3,2.5-.9,1.1-1-1.3-1-1.5-.4-.2-.4-.3,0-.5l-.2-.7c.8-.4,1.2-.8.2-1.8-.6-1.2-1.1-1.5-1.5-.8l-.5-1.2c-1.1-.4.1-1.8,1-1.5.6-.6.8-.3.5.5,1.3-.9,1.5-1.2.5-1-.4.7-1.4-.3-1-1v-.5c-.3-.3-.3-.6,0-1-.4-.1-.4-.3,0-.5.2-.5.7-.3,1,0Z"
          fill="#036bf7"
        />
        <path
          d="M239.7,193.8c-1.2-1.1.1-3.5,1.3-3.2s2.2,2.8,2.2,3.7c.6-.4,1,.5.5,1-.6.1-.3.5,1,1,.3-.3.6-.3,1,0,.2-.4.3-.4.5,0,.3-1,.9-.3,1,.5.5.5-1.4,1-1.3.9,2.3-1.6,3.6,0,1.3,2.1v.5c.6,1.5-.1,1.2-1,0-.4,0-.6-.3-.5-1-1.1-1.8-2-1.1-3.9-1.8s-1.5-.9-2.1-1.2c-.4-.1-.4-.3,0-.5-1.3-.9-1.4-1.6-.5-2h.5Z"
          fill="#047bf8"
        />
        <path
          d="M247.2,196.8c.3-.7,2.4-.4,2,.5,0,.1,0,.3,0,.5-1,.6-.6,2.4-2,2-1.5-1,1.1-1.4,1-1.7-.4-1.1-1.8-.4-2.5-.3l1.5-1Z"
          fill="#0263f6"
        />
        <path d="M253.2,194.3l-.5.5h-.5c0,0-.6-.4-.5-.7l.8-.8c.4.1.6.9.7,1Z" fill="#035ef6" />
        <path d="M247.2,209.8c-.4,0-.5-.1-.5-.5s0-1,.5-1v1.5Z" fill="#0369f9" />
        <path
          d="M252.7,194.8c1.5-.4,3.8,2,1.5,2.5.9.3.9.8,0,1l.5.5c.1-.4.3-.4.5,0,.3-.4.7-.4,1,0,1.7,1.4,2.1,2.6,1,3.5.5.8.5,1.5,0,2-2.2,1.1-1.4-1.6-2.5-.5.2-1.4-.2-1.7-.6-.1s.2,0,.6.1c-.2.2.8,2,1,2.5-.1.3-.3.3-.5,0l-.5-.5c-.9-.3-.9-.1,0,.5.3,0,.5.1.5.5-.2.2,0,.7-1,1.5h-.5c-.3-.2-.6-.1-1,0,.4.7-.4,1-1,.5-.2-.4-.6-.9-.5-1.5l-2,1.4c-.8,1.7,0,2.8.7.6.6.4.7.8.8,1.5-.2.8-1,1-2.5.5-.6,0-1.4,0-2,0-1.3-.6-1.5-1.1-.5-1.5.2-.1.3-.4.5-.5.1-.4.3-.4.5,0l.5.5c.2-1,.5-1.7,1-2,.2-.4.6-.7,1-1-.2-1-.7-1.5-1.5-1.3.6-2.1.4-3.2-.5-5.2-.4-.1-.4-.3,0-.5.6-.7,1-1.4,1.2-2.2l.8.2h.7c.7-1.1,1.5-2,2.3-3,.1-.4.3-.4.5,0Z"
          fill="#0374f9"
        />
        <path d="M250.7,210.8c0,.5,0,1,0,1.5l-2.5-1c.9,0,1.7-.3,2.5-.5Z" fill="#0246f1" />
        <path
          d="M254.7,203.8c-.7.5-1.7.6-2.5,1-.2-1.3,1.1-1.5,2-1.5v-.5c-1.9.3-.7-2.1.3-3-.1,2.1.9,2.1,1.2,3.5-.5,0-.7.3-1,.5Z"
          fill="#035ef6"
        />
        <path d="M251.2,200.3v1c-1.3,0-2.3.5-2-1h2Z" fill="#0263f6" />
        <path d="M254.7,205.8v.5c-2.2-.9-1.8-1.5,0-.5Z" fill="#0147ef" />
        <path d="M253.2,206.3v1s-1.5,0-1.5,0c.2-.7.8-1.1,1.5-1Z" fill="#024cf1" />
        <path
          d="M255.7,206.3s.6,0,.5.5c-.3.1-.9,0-1,0-.2-.1-.4-.4-.5-.5.2-.2.3-.2.5,0h.5Z"
          fill="#0245f4"
        />
        <path d="M253.7,208.3c-.3,0-.7,0-1,0l.7-.5.3.5Z" fill="#0369f9" />
        <path d="M254.7,198.8c-.4-.1-.4,0-.5-.5l.5.5Z" fill="#0268f8" />
        <path d="M255.2,206.3h-.5v-.5c.2.1.3.3.5.5Z" fill="#0369f9" />
        <path
          d="M235.2,189.8c1.1-1.1,2.2-.2,1.5,1.5l1,1c1.6-.9,2.5.6,1,1.5-.6,0-.3.8,1,2v.5c-.1,0-.3,0-.5,0-.5.2-1,.2-1.5,0,0,.1.1.6-.1.9-.6.7-2.4,1.1-1.9-.4-.3-.3-.4-.3-.5,0,0,0-1,.5-1,.5-.9,1,2.2,1.1.5,1.8s-1.8-.5-2-.3-.1,1.9-1,2.3c0,.5.9.1,1,.2s-.5.8-.5,1c.6.5,2.9,0,3,0s-1.5,1.7-.5,2.5,1.5-2.4,3-1.5c-.4,2.3-.9,1.7-2.5,2.5s-.8.8-1,1-.5-.1-.8.2-.2,1.1-.7,1.3c-.6-.4-.8-.5-1,0,0,.3,0,.7,0,1-.2.3-.5.5-1,.5-.1.4-.3.4-.5,0v-.5c-.6-1.2-.9-2.5-.8-3.8.6.5.8.3.7-.4.9.5,1.9.4,3.1-.3q1.1-.2,0,0c-.4.5-1.3.7-1.5,0l-.7-.2c-.3.9-.7.6-1.3-.8,1.5-1.1,1-1.2.5-3,2.5-.6.8-1,1-2.7.4-3.1,3.2-1.3,2.5-4.3l-2-.5c.9-1.5,1.4-1.2,3-.5.3-1.5-1-1.6-1.5-2.5l2-.5Z"
          fill="#024dee"
        />
        <path
          d="M237.7,196.3c.5-.7,2.1,1.5,2,1.5s-1.2-1.3-.5-1.5c.1-.4.3-.4.5,0,.2-.8,5.8,1.1,6,1.4.3.5.5,1,0,1.6l.6,2.9c-2.2,2.4-6.4,2.6-3.8-1.9-.3.9-.9,1.2-1.8,1-.3-.5-.8-.5-1.5,0,.9.7-1.9.7-1.8.7,2.3-.3,2.5,0,2.3,2.3l1,2.5c1.4-2.4,4.4,1.1,1.5,1h-.5c-.5.2-1.1.2-1.5,0-.2,0-.4,0-.5,0-1.3,0-2.3-.2-3-.9-.9.5-1.3-.1-1.5-1.1-.7-1.4-1.7-2.4-3.1-2.5-1.1-1.2-1.2-2.3.6-2q1.7-1.1,0,0c-1.2,1.8-2.5.2-.8-1,0-1.8,1.6-5,3.3-3.5.2-.4.3-.4.5,0,.6.6,1.3.8,2-.5Z"
          fill="#0263f6"
        />
        <path
          d="M240.2,201.8c1.7-1.3,2.4,1.4.5,1-1.1.9-1.6-.6-1.5-1.5.6-1.1,1.4-.6,1,.5Z"
          fill="#0263f6"
        />
        <path d="M241.7,207.8c0,.8-1.4.8-1.5,0,0,0,.8-.8,1.5,0Z" fill="#0273fa" />
        <path
          d="M240.7,201.3c1.3-1.4-.4-1.8-1-3,2.4-1.4,2.3,1,2.8,1s1.5-.7,1.7-.6c1.1,1-1.3.8-1,1.5l1.5.3c-.6.6-1.6,1.2-2.2,1.8-1,1.1,1.9,1.1,2.9-.5s-.2-1.8.3-2.5c.3.4.3.7.5,1,.9,1.5,1,1.6,1,3,.5,0,.4.2,0,.5,0,.5,0,1,0,1.5l-1.7-2,.3,1.5c-.7.3-1.2-.5-1.5-.5-.4.1-.9.3-1.5.5.4.2.8.2,1,0,.1-.3.3-.3.5,0,.1,1.1,0,1.1-1,1-.4-.4-.2.5-1-1-2.4,1.4-4-.4-1.5-2,.1-.3,1.2,0-.5-1-.1-.5,0-.6.5-.5Z"
          fill="#0379f8"
        />
        <path
          d="M239.2,201.3l1.5,1.5c-1.3,3.8.7.5,1.5,2-.4.9-1.7.9-1.5,2-.6,0-1.3-.3-2-.2l1-1.3c-.3-.2-1.3.7-1.5.5-.9-.8,1-1,1-1.3,0-.5-.6-1.4,0-2.2h-2c.1-1.2,1.7-.8,2-1Z"
          fill="#025af3"
        />
        <path d="M239.2,201.3c.1,0,1-3,1.5,0-.2.2-.3.4-.5.5-.2-.1,0-.8-1-.5Z" fill="#025af3" />
        <path d="M232.7,201.3l.5-1.5c.7-.2,1,.2,1.5.8v.7s-2,0-2,0Z" fill="#0248f1" />
        <path d="M238.2,200.8c-.9.8-2.2-.7-1.5-1.5s2,1,1.5,1.5Z" fill="#024eef" />
        <path d="M239.2,196.3l.5,1.5-2-1.5c.5-1,.8-.2,1.5,0Z" fill="#047bf8" />
        <path d="M235.7,196.8c-.2,0-.3,0-.5,0-2.4-1.5.2-2.6.5,0Z" fill="#066bf4" />
        <path
          d="M253.7,215.3c0,0-.9-.3.5-1.3l-1.5-.2c-.3-1.6.5-.8,1.2-1s-.4-.8-.2-1c.8-.7,1.4,1.8,2.5,1l-1.5,1.2c0,.5,1,.2,1.5.2v.5c-.2,0-.3,0-.5,0-.7,0-1.4,0-2,.5Z"
          fill="#0368f9"
        />
        <path d="M251.7,215.3c-.3,1,0,1.9-1-.2l.5-.3c.2.2.3.3.5.5Z" fill="#0369f9" />
        <path
          d="M235.2,205.8c1.6.1,3.2,1.7,4.5,2-1.1,0-1.8-.3-1.5,1,.4.1.6.3.5.5v.5c0,1-.4,1.5-1,1.5-.9.2-1.8.3-2.5,1-.1,0-1.4.5-1.5.5v-.5c-1.4-1-.2-2.7,1-1.9.8-.5,1.3-1.2,1.5-2.1q.5-.5,0,0c-1,4.3-4.3,1.9-2-1.5-1.6-.7-.4-1.7,1-1Z"
          fill="#025ff8"
        />
        <path d="M238.7,209.8l.5,1.5c-.5,0-1.1,0-1.5,0,.6-1.1-.6-1.7,1-1.5Z" fill="#024cf2" />
        <path
          d="M234.2,206.8c.6.4-.5,4.7,1,3s-.8-.8,1-1.5c0,.4.7,1,.3,1.5s-2.5.6-2.8,2.5l-.3-.5c-1.3-.1-1.2,3.1-2.7.5.2-.2.3-.3.5-.5-1.1-.6-1-1.2.5-2-.4-.1-.4-.3,0-.5-1,0-.9-.6,0-1,.1-.7.8-.7,1,0-.1-1.7-.1-3.4,1.5-1.5Z"
          fill="#0246ed"
        />
        <path d="M236.2,208.3c-.2-1.4.2-1.2,1-.2,0,.5-.7.1-1,.2Z" fill="#0263f6" />
        <path d="M235.5,206.8c.3.2.3.3,0,.5v-.5Z" fill="#0246ed" />
        <path
          d="M255.7,214.8c.4.1.4.3,0,.5,0,.3-.2.5-.5.5-.1.3,0,.3.5,0,0-.4.3-.4.5,0,.2,0,.3,0,.5,0-.4,2.2-.9,2.5-3,2.5,0-.3.5-.7.5-1-.7-.2-.8-1-.5-1.5,0-.2,0-.3,0-.5.3-1.3.9-1.4,2-.5Z"
          fill="#046bf9"
        />
        <path d="M254.2,217.3c-1.1.1-1.1,0-1-1,.2,0,.3-.4.5-.5,0,.2.6.5.5,1.5Z" fill="#043eee" />
        <path d="M255.7,216.8c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#0350f7" />
        <path d="M255.7,215.8c-.2.3-.2.7-.7.5l-.3-.3c.2-.3.5-.2.5-.2h.5Z" fill="#0350f7" />
        <path d="M255.7,215.8h-.5c.2-.1.3-.4.5-.5,0,.2,0,.4,0,.5Z" fill="#0368f9" />
        <path
          d="M265.7,195.8c1.9-2.1,2.5-.2,1,1.6s.2-1.1.5.4c.1,0,.3,0,.5,0,.3-.4.8,0,1,.5-.4,2-.7,0-1,.5-.3.7.7,2.8.5,3-1.2,1.4-1.2-2.9-2-2.5,0,1.1.2,2.5.5,3.5s.1,1.3.8,1.5-.1-1.3.7-1c.5,2.3-.9,1.2-2.2,2s-.9,1.5-.8,1.5c1.1,1,1.7-1.4,2-1s.5,1.5,1,2c-2.6-1.2-1.4,1.9-3.5,3,0-1.1.3-1.9.5-3-3.9,1.1-1.9,0-2-.5,1.2.2,2.7-3.2,2.5-3.5l-3,.2c.9-1,2.3-1.4,3.5-.7v-1.5c-.3,0-.8,0-1,0-4.8,1.1-3-5.3.5-5,.2-.2.2-.4,0-.5-.4-.1-.4-.3,0-.5Z"
          fill="#0243ef"
        />
        <path
          d="M231.7,204.8q-.7.3,0,0c.5,0,1.1,0,1.5,0,0,0-.2.6-.5.7-.8.2-2.7.3-3,1,1.6.4,1.1,1.5.5,2.7-1,.2-1.5-.1-2-1v-1c0-.8-.2-2.1,0-2.7s.9-.2,1-.3q.3.8,0,0c.2-.1.3-.4.5-.5l2,1Z"
          fill="#023edf"
        />
        <path d="M231.7,208.3c0,0-.6,0-.3-.5.8-1,1.5-.7,1.3.5-.2,0-.7,0-1,0Z" fill="#0263f6" />
        <path d="M231.7,209.3c0,.2,0,.3,0,.5-.3,0-.7,0-1,0l1-.5Z" fill="#0263f6" />
        <path
          d="M261.7,185.3c0,.2,0,.4,0,.5,1.4,1.1,2.7,2.2,4,3.3s.3.4,0,.7c0,.1-.2.8.2,1.3.5.8,1.8.9,2.3,2.7-.5,1.4-2.6,2.4-2.5.5-1.5-.8,1.5-1.3,0-1.8s-3.3,1.2-3-.7c.1,0,.4,0,.5,0l-.2-1.2c-4-2-4.9-3.5-2.8-4.8-.5-1.4.6-1.3,1.5-.5Z"
          fill="#0232cb"
        />
        <path
          d="M268.2,193.8c1,3.2-1.2,1.4-1,4-.3,0-.7,0-1,0l1-2c-.5,0-1,0-1.5,0s-.7,0-1,0v-.6c.2-.2.9-.8,1-.9.2,0,.6.5.8.5s.4-1.6,1.7-1Z"
          fill="#023ae1"
        />
        <path
          d="M261.7,185.8c1.4.3,2.7,2,3.6,2.8s.5-.5,1.9,1.7l-1.5-.5c-1.4-2.4-3.1-2.2-4-4Z"
          fill="#022bbb"
        />
        <path
          d="M268.7,197.8c0,.2,0,.3,0,.5-.4,0-.8-.5-1-.5,0-.3.2-.5.5-.5.3,0,.5.2.5.5Z"
          fill="#023ae1"
        />
        <path d="M268.7,197.8l-.5-.5c.1,0,.4,0,.5,0v.5Z" fill="#0243ef" />
        <path
          d="M233.7,171.8c.9-.9,7.6-3,8-2.5s.2.5.2.8l-3.7,1.7c.4.9-.7,1.3-1.5,1.5.6-.5.9-.5,1,0,1.1,1.5-2.3,3.2-3.5,2,.3-.9,1.1-1.5,2.5-2-3.1,1.5-5.8,3.8-7.8,6.6h-.7c0-.1-1.5-.4-1.5-.4,1.8-3,3.7-6.2,7-7.8Z"
          fill="#0218db"
        />
        <path
          d="M265.7,171.8c.5.3,1.6.7,2,1s1.5,1.5,2,2c1.2,1.1,4.2,5.1,1.5,4-.3,0-.5.2-.8.1-.4,0-5.5-4-6.2-4.6s-.7-.6-1-1c-1,.2-3.4-.9-3.5-2-.9-1.3-.5-1.1.8-1s3.9.9,5.2,1.5Z"
          fill="#0122df"
        />
        <path
          d="M233.7,171.8c2.4-2.3,8-3.1,11.4-3.4s2.2.4,3.4.4,2.7-1.2,3.2.4l-3.5.5c-.1.3-.3.5-.5.6-2.4.6-6.3,1.4-8.8,1.8s-.4-.1-.7-.4c1-.8,1.2-.9,2.3-1.4s1.1-.7,0-.6-5.2,1.3-6.7,2Z"
          fill="#011be1"
        />
        <path
          d="M248.2,169.8c.7,0,1.3,0,2,0,1.2,0,1.9.4,2,1-2.1,1.1-4.5,1.3-7,.5h-.5c-.1.4-.6.6-1.5.5,0,1.2-.6,1.4-2,.5-.4,1.5-1.4,1.5-2.5.5l-.5.5c0,.4-.3.4-.5,0-.3,0-.7,0-1,0,.5-.4.9-1,1.5-1.5,3.5-1.2,6.2-1.9,10-2Z"
          fill="#1625e0"
        />
        <path
          d="M236.7,173.3c-.8.7-1.7,1.2-2.5,2,0,1.2-.7,2.3-2.1,3.3-1,1.6-2.1,2.5-3.4,2.7-.5.6-1.4,1.5-2,2,.2-.5.3-1.1.5-1.5s.7-1.6,1-2c1.8-2.6,5.4-5.9,8.5-6.5Z"
          fill="#0330eb"
        />
        <path
          d="M257.2,170.3c3.8,2.2,1,1.7-1.5,1-.6,1.4-3,.7-3.5-.5l-2-1c2,0,5.1,0,7,.5Z"
          fill="#2941ef"
        />
        <path
          d="M259.7,171.3c1,.4,2.5,1.5,3.5,2,.6.4.7.7.5,1-1.1.8-2.6.4-4.5-1-1.9,0-3-.8-3.5-2l3,.5-1.5-1.5c1.1.2,1.6.6,2.5,1Z"
          fill="#1530ea"
        />
        <path d="M225.7,179.8c-.2.8-.6,1.6-.5,2.5l1.5-.5-2,4c-2-.8,0-4.6,1-6Z" fill="#0330eb" />
        <path d="M226.2,178.3c.1-.3.4-.4.5-.5l-.5.5Z" fill="#0330eb" />
        <path d="M225.7,179.3c.1-.3.5-.4.5-.5l-.5.5Z" fill="#0330eb" />
        <path
          d="M271.2,178.8c1.2-.4,3.4,3.1,2.5,4,0,1.4.9,2.4,1.5,3.5,0,.5,0,1,0,1.5-1-2.4-2-3.6-3.5-5.5-1.3-2-3.7-5.2-6.2-4.9l.2-1.1c-1.5.1-2.7-.4-2-2-.2-.3-.3-.7-.5-1,3.5,1.8,5.2,2.2,8,5.5Z"
          fill="#0d36e8"
        />
        <path
          d="M269.7,174.8c3.3,2.9,2.6,3.2,4.6,6.4s1.3.5,1.6,1.1c.5,1,.2,2.4.2,3.5-1-.7-1.8-2-2.5-3s-1.2-2.5-2.5-4l.5-.3c0-1.5-1.4-2.4-2-3.7Z"
          fill="#012be6"
        />
        <path d="M276.7,194.8c0-.2-.4-1.7-.5-2.5.8.4.5,1.7.5,2.5Z" fill="#010980" />
        <path
          d="M247.7,172.3c1.2-1.2,6.5-1.1,7.2,1,3.4-.9,5.6.4,8.4,2.2l2.4.8c1.9,1.6,5.1,3.2,6,6-1-1.2-3.7-4.3-5-4.7s-1.6,0-1.5.7c1.6.2,1.1,2,3,1l-1,1.5c2.7,0,1.6,1.3,2.2,2.3,1.4,2.4,2.2,3.3,3.2,6.2s1.7.6.2,3c-1.5-1.8,0-2.1-3-4-2.5-1.5-3.4-2.3-4.8-5l-.8-.4c-3,0-5.5-.7-7.4-2.1l-.7-.9c2-.9-1.4-3.7-1.7-3.7-1,1.4-4.8.5-5-1.2-2.4-.9-2.9-1.9-1.5-2.8Z"
          fill="#040b67"
        />
        <path d="M273.2,192.8c.2.2,1.3,0,1.5.8-1.1.3-.7.5-1,1.7l-.5-2.5Z" fill="#040b67" />
        <path
          d="M240.2,185.8c-.8-2.2,4.9-3.1,5.4-2.1s-1.5,2.8-.1.6.4,0,.7,0c.9-.5,1.5-.5,1,.5v.5c.7.6,0,2.4-1,2.5,2.4,2.1-2,2.4-4,2.3-.3,1.1-.6.9-.9-.7-.5,1.4-2.4,4.4-3.6,2.5l-1-.5-1.5-.8,1-.3c.2-.7-.3-.5-1-.5l-.5-1c.9,0,1.6.5,2.5.3,1.3-.3.4-1.9,2.5-.8,0-.8,0-1.9.5-2.5Z"
          fill="#0251e5"
        />
        <path
          d="M246.2,181.8c.3-.9.7-.9,1,0,1.5-.1,2.1.2,2,1v.7c-1.2.5-2.1.8-3,.8-.3.4-.4,1.4-.5,1.5-1.4,1.3-.7-1.7-.7-2l-2,1.5c-1-2.5-1-.5-1.6,0s-1,.3-1.1.5c-1.3-1.3-2.6.7-3.5.5,1.2-3.1,6.5-4.1,9.5-4.5Z"
          fill="#0233c0"
        />
        <path d="M232.2,188.8c-.3,0-.7,0-1,0-.3-.1-.3-.3,0-.5.2,0,.5,0,.7,0l.3.5Z" fill="#011183" />
        <path
          d="M245.2,180.8c-2.2.4-3.6,1.1-6.5,1.5s-4,1.1-7,2c-1.1.3-.4-1.8,0-2.2,2.2-.3,4.2-.9,5.9-2.3,1.2-.4,6.8.1,7.7,1Z"
          fill="#02136f"
        />
        <path d="M231.2,188.8c-.6,0-.7-.4,0-.5v.5Z" fill="#011791" />
        <path
          d="M258.7,182.8c1.8.4,2.8,1.1,3,2v.5c-.5,0-1.1.4-1.5.5-.1.3-.3.3-.5,0-1.3-.7-2.9-1-4.6-1.3-1.2.7-4.1,0-4.4-1.2l-1-.5c0,.4-.3.4-.5,0l-2-1c.9-1.8,4.3-1.3,6.4-.7,2.4,0,4.1.5,5.1,1.7Z"
          fill="#022bbb"
        />
        <path
          d="M258.7,182.8c3.5-1.4,6.8,0,8.4,4,1.1.3,2,.8,2.6,1.5,0,1.2-.4,1.4-.5,2-2.2-2.7-4.5-3.8-7.5-5.5s-2.4-1.1-3-2Z"
          fill="#021578"
        />
        <path
          d="M152.8,279.3c-.3,1.8-.5,3.3-1.5,5l-.5.5c0,.2,0,.3,0,.5-.4,1.3-1.5,2.2-2,3-.4-.1-.4-.3,0-.5-.3-.1-.3-.3,0-.5l1-2c-.4-.2-.4-.3,0-.5l.5-1c-.3-.9.3-3.5,1.5-3.5.2-1.6.7-2.5,1.5-2.5,0,.6-.4,1.1-.5,1.5Z"
          fill="#77ddf7"
        />
        <path
          d="M148.8,288.3c-.5.8-.7,1.9-1.5,2.5.1-.4,0-1.1,0-1.5-1.2-.6-.9-1.2.5-1,0-.3.1-.5.5-.5.1-.4.3-.4.5,0v.5Z"
          fill="#0827c0"
        />
        <path d="M143.3,303.3c0-.2.4-.3.5-.5l-.5.5Z" fill="#82ddf9" />
        <path
          d="M153.3,277.8c-.9,0-.8-.6,0-1-.7-.7-.5-1.1.5-1-.2-.2-.2-.3,0-.5,0-.5.3-.8.5-1,.1-.2.3-.4.5-.5-.6,1.6-.5,2.2-1.5,4Z"
          fill="#60d8f5"
        />
        <path d="M155.8,270.8l.5-1c-.2.4-.4.8-.5,1Z" fill="#0328da" />
        <path d="M156.3,269.3l.5-.5c-.1.4-.5.5-.5.5Z" fill="#0328da" />
        <path
          d="M164.8,249.8c.9-2.3,1.6-4.7,2.5-7l.5-.5c0-.1,0-.4,0-.5l.5-.5c0-.1,0-.3,0-.5.1-.4.3-.4.5,0-.9,2.9-2.1,6.8-4,9Z"
          fill="#6cd8f6"
        />
        <path d="M168.8,240.3c0,.2,0,.3,0,.5h-.5c.1-.3,0-.9.5-1,0,.2,0,.3,0,.5Z" fill="#0436dc" />
        <path d="M162.8,253.8c0-.3.5-.4.5-.5l-.5.5Z" fill="#0235e7" />
        <path d="M173.8,228.3c.4-1.9,1.2-4,2.5-5.5-.8,2.8-1.5,3.3-2.5,5.5Z" fill="#3ec3f2" />
        <path d="M150.8,284.8c0-.2.3-.4.5-.5-.1.2-.3.3-.5.5Z" fill="#7ee0f6" />
        <path
          d="M210.2,141.8c-.3,1.1-1,2.1-.5,3.2l-1-.2c1.1,2.3-.3,1.9-.4,2.2-.3,1-1.1,5.9-1.6,6.3l-1-.5c.4,2.1-.3,3.3-1,5s-1.5,2.7-2,4c-.7,0-.8,0-.6-.6.8-2,1.2-3.2,1.8-5.2s.2-.2.3-.3c-.2-.2-.2-.3,0-.5-.4-.2-.4-.3,0-.5l.5-.5c-.2-.1-.2-.3,0-.5,0-.5.2-.9.5-1-.5-1.8,1.1-5.3,2.5-6.5l.5-1c-.4-.1-.4-.3,0-.5l2-3Z"
          fill="#77e7fb"
        />
        <path
          d="M202.7,161.8c-.3.8-.7,1.7-1,2.5-1.2,1.7-2.6,4.1-3.5,6-1.1-1.6.5-4.6,2-6-.3-1.5,1-4.4,2-5.8.4-1.3.8-2.2,1.4-2.7.2-.2.3-.2.5,0-.1.6.1,1.4-.1,2.1-.4,1.3-1.8,2.2-1.4,3.9Z"
          fill="#59defb"
        />
        <path d="M186.8,197.3c.1-.3.5-.4.5-.5l-.5.5Z" fill="#87e5f8" />
        <path
          d="M237.7,191.8c2.3-.3,1.7-1.1,2.5-2.2s.9-.8,1.2-1.2.1-1.8.3-2c1.1-.9.6,1.6,1.4,1.4l.6,1.6-2,.5c.9,0,1.7,0,2.5-.2,1.7-.6-1.5-.8-.5-1.8s2.6,3.9,2.5,0c.6-.9,1-.6,1,.5.3-.1.6-.1,1,0,.5.3.5.7,0,1l-.5.5c.6.7.3,1-.5.5-1.2.8-2.4,1-3.5.5q-1.5,0,0,0c1.9-.9,2.9,2,1,1.5-.1.3-.3.3-.5,0-.1.4-.3.4-.5,0-.3,0-.5.3-.5,1,.7.3.7.7,0,1-.8-.8-2.2-1.7-2.5-3-3,1.7,4,3,0,4v-2c-.1-.2-.7.4-1,.5h-.5c0,.4-.3.4-.5,0,.4-.9-.9-1.2-1-1.5-.4-.1-.4-.3,0-.5Z"
          fill="#0361f1"
        />
        <path
          d="M247.2,192.8c3,.9,1.4.7,2,2q-.6.7,0,0c0,.1.9.3,1,1.3s-.8.8-1,1.2c-.6-.5-1.4-.3-2-.5s-.5-.4-1-.5c-.6-.3-1.1-1-.5-1.5-.4,0-.6-.2-.5-.5-.9-.4-.3-.8.5-1-.6-.7-.3-.9.5-.5.4-.9.6-.9,1,0Z"
          fill="#0374f9"
        />
        <path
          d="M248.2,185.3c0,.3,0,.7,0,1,0,.4.1.8.5,1,.2,0,.4.3.5.5-.2,0-.7,0-1,0,0,.5-.6.7-1,.5-.3-.1-.7-.4-1-.5,0-1.8.6-.9,1-2.5h.5c.1-.4.3-.4.5,0Z"
          fill="#0367f3"
        />
        <path d="M249.2,190.8c.4-4,1.7.8,1.5,1-.3.5-1.5.4-2,0-.7-.7-.6-1,.5-1Z" fill="#0356f1" />
        <path
          d="M254.7,190.3c-.2.1-.7.3-1,.5-1.4.7-.9.9-1,1-.6.4-1.2-1.3-.4-1.9s1.1,0,1.4,0l.5-.5c0,0,0-.3,0-.5,1.5,0,2.1.6.5,1.5Z"
          fill="#024def"
        />
        <path
          d="M248.2,191.3l-1,1.5s-.3.4-1,0l-.5-.5c-.9-1.2.3-2.3,1.5-1.5.5-.9,1.4-.4,1,.5Z"
          fill="#0361f1"
        />
        <path
          d="M248.2,189.8l1,1c0,.4,0,.9-.5,1-.2-.1-.3-.4-.5-.5s-.2-.7-1-.5c-.4-.1-.4-.3,0-.5.1-.2.4-.3.5-.5h.5Z"
          fill="#047ff8"
        />
        <path d="M248.2,187.8v.5l-.3.5c-.4.1-.6-.5-.7-.5.1-.5.6-.5,1-.5Z" fill="#0248e6" />
        <path d="M248.2,189.8h-.5c.2-.2.3-.3.5-.5v.5Z" fill="#0248e6" />
        <path d="M253.7,189.8l.5-.5c-.1.2,0,.4-.5.5Z" fill="#035ef6" />
        <path
          d="M247.2,190.3v.5c-.1,0-1.5,1.4-1.5,1.5l.5.5c0,0-.4.5-.5.5-.6.3-1.1.6-1.5,1,.4,0,.6.2.5.5.4.1.4.3,0,.5-.2.3-.3.3-.5,0-.2.4-.3.4-.5,0-.2-.3-.3-.8-.5-1,0-.3,0-.7,0-1,0-.5.2-.9.5-1,.1,0,.3,0,.5,0,.2.2.4.2.5,0,.3,0,.6,0,.5-.5-.8.2-1.4-1-1.5-1,.5,0,1.9-1.8,3.5-.5Z"
          fill="#037ef9"
        />
        <path
          d="M238.7,193.8c.2,0,.3,0,.5,0l.5,2-3-1.5c-.3.3,1.6,3-.5,2.5.3-1.7,0-2-1.5-2.8,1.1.3,2-.7,2.7-.7s1.1.5,1.3.5Z"
          fill="#0365f5"
        />
        <path
          d="M245.7,194.8c.5.5.6.8.5,1.5-.2,0-.3,0-.5,0-.4-.2-.8-.2-1,0-.7-.1-1.5.1-2-.8.4,0,.6-.1,1-.2s.4,0,.5,0c.2.2.4.2.5,0,0-.2,0-.3,0-.5.1-.5.6-.3,1,0Z"
          fill="#035ef3"
        />
        <path d="M245.7,196.3c-.3,0-.7,0-1,0l.3-.5.7.5Z" fill="#0374f9" />
        <path d="M239.7,193.8h-.5c.1,0,.5,0,.5,0Z" fill="#024dee" />
        <path d="M244.2,204.3v.5h-.5c-.2.2-.6.2-1,0,0-.7.9-.6,1.5-.5Z" fill="#025af3" />
        <path
          d="M247.2,200.3c2.5.7.4,2.7,3,1.5l-2,2.3c-.4.8,1.9,1.6,2,1.8.2.4-1,.9-1,1q-1.2-.6,0,0c0,0,.6.9.5,1-.4.1-1.3-.1-1.5,0-.3,1-.7,1-1,0-2.9,0-1.9-1.1-2.8-1.4s-1,.4-1.1.3,0-.8,0-.9c.4-.2.7-.6,1-1-.4-.1-.4-.3,0-.5,1.2-2.5,2.4-1.6,2.9.5s-.9-.9.1-1c.4-.2.4-.3,0-.5-1.5,0-1.3-1.8-1-3,.4.5,1,0,1,0Z"
          fill="#0263f6"
        />
        <path
          d="M248.2,207.8c-.1,0-.1,2-1,2-.4-.3-.3-1.1,0-1.5v-.5c.3,0,.7,0,1,0Z"
          fill="#024ce8"
        />
        <path d="M249.2,206.8l-2-.2c.5-1,1.4-.6,2,.2Z" fill="#0280f4" />
        <path d="M246.7,206.3c-1,.1-1.1,0-1-1l1,1Z" fill="#0783fa" />
        <path d="M247.2,203.3c1.4-.2,1.4.7,0,.5,0-.2,0-.3,0-.5Z" fill="#033ce7" />
        <path
          d="M237.7,191.8c0,.2,0,.4,0,.5l-1.5.5c.2-.5.3-1.1.5-1.5s.6-.6.5-1h.5c0,.5-.1,1.1,0,1.5Z"
          fill="#033ae3"
        />
        <path d="M233.2,204.8c0,0,.7-.8,1-.5,1.4,1.7-.9.5-1,.5Z" fill="#0263f6" />
        <polygon fill="#0263f6" points="243.7 204.8 243.5 205.3 242.7 204.8 243.7 204.8" />
        <path d="M265.7,196.8c0,0,0-.3,0-.5l.5.3-.5.2Z" fill="#023ae1" />
        <path d="M260.7,200.8c0-.3.2-.5.5-.5,0,.2-.3.3-.5.5Z" fill="#035ef6" />
        <path
          d="M251.7,184.8c2.3-.2,6-.4,8,1,.2,0,.3,0,.5,0-1.2,2.9,0,1.5,1,2.3s1,2.4,3,.7c.2,1.8,0,2-1,3l-2-.5.5-1c-2.4-.6-1.8.9-2,1s-.4,0-.5,0l-.5,1c-1.4-.6.5-2.1.5-2.3,0-.3-2-1.4-2.5-1.7-.9-.7-.9-1.4-1-1.5-.3-.2-1.1,1.2-1.5,1s.2-.7-.4-1-1.8-.2-2.6-.5c-1.2-.5-.4-1,.5-1.5Z"
          fill="#0248e6"
        />
        <path
          d="M262.7,191.8l.6.2c1.9-1.1,4.8.2,2.4,2.3.4.8,0,1.3-1,1.5,0,0-.5.5-1,.5.3-.9-.7-1.2-1.5-1.5.3-.3.4-.7.5-1,0,0,.6-.1.5-.5h-1.5c-.2-.1.7-1.3,1-1.5Z"
          fill="#0248e6"
        />
        <path
          d="M262.7,193.8c0,.6,1.3,1.2-.5,1-.4-.1-1.2.2-1.5-.5.6-.4,1.3-.5,2-.5Z"
          fill="#012fe5"
        />
        <path d="M264.5,193.3c.5.4-.8,1.3-.7.7l.7-.7Z" fill="#0232cb" />
        <path
          d="M231.2,195.3c.3.6,0,1.5-1,2.7.5,1.2.5,2.2,0,2.8,2,.4,2,3.9-.5,3,.7.7.4,1-.5.5.1,1.5-.2,2.5-1,3v1c1-.3,1.6,0,2,1,.4.1.4.3,0,.5-.4.3,0,1,1,2,.1.5,0,.6-.5.5-.2.2-1.2,0-1.2,1l-1.8-2.5c1.2-1.5-.4-2.2-.5-2.4-.1-.5-.5-2.7-.5-3.1,0-2.6,1.8-5,2-7.3s-1.9,0-.4-2.4,1.8-1.5,2.9-.4Z"
          fill="#0232d5"
        />
        <path
          d="M231.7,193.3c4.3-1.4,3.3,2.5.7,4.2-.3,3.5-1.1,4.6-2.2,3.3-.3-1.1-1.2-2-1-3.2s1.8-1.9,2-2.3-.1-.8,0-1c.2-.3.2-.6.5-1Z"
          fill="#0242e4"
        />
        <path
          d="M230.2,209.8c.1,0,.3,0,.5,0,.4-.2.7-.2,1,0,0,0,.6.3.5.7s-.8.3-.8.4c-.1.3,0,.6-.2.9-1.6-.2-1.6.1-2-1.7,0-.5.7-.2,1-.3Z"
          fill="#053bdc"
        />
        <path d="M228.7,203.8c-1,.1-1.1,0-1-1l1,1Z" fill="#0223b9" />
        <path d="M228.2,208.3c-.6-1.1,0-.6,0-1v1Z" fill="#053bdc" />
        <path d="M229.2,204.3l1,1c-1,.1-1.1,0-1-1Z" fill="#024dee" />
        <path d="M231.7,204.8c-.1,0-.4.7-1,.5v-.5s1,0,1,0Z" fill="#011ec8" />
        <path
          d="M241.2,172.3c1.1-.3,1.4,0,2,.6,2.6.1,4.9.5,5.8,3.2l1.1-.3c1.6,1,3.4,1.4,5.7,1.2,3,4.1-2.1,3.4-5,2.8-1.2,1.2-3.5,1.7-5,1-.2,0-.3,0-.5,0-2.4.9-5.4-.5-7.7,0s-.3.9-.7,1c-1,.3-5.6-.3-5.2,2.5-.5.2-.9.5-1.5.5h-.5c1.5-1.4,1.4-3.4,1.5-3.5s1.7.7,3.1,0,2.7-3.6,3.5-4.3c1.1-.9,2.6,0,2.9-2.6l-2.3.5,1.3-1-1-.5c-.2-.2-.2-.3,0-.5.8-.3,1.7-.3,2.5-.5Z"
          fill="#040d56"
        />
        <path
          d="M252.2,170.8c1,0,2.5.3,3.5.5,2.6.6,5.4,2.3,8,3,.5.7,1.4,1.5,2,2-3,1.6-5.1-2-6.8-2.3s-3.7.5-4.4.3-.6-1.4-1.1-1.5-4.4-.3-5.7-.5c.7,2.2-4.3,1.2-4.5-.5.4,0,.7-.4,1.5-.5.8.3,1,.3.5,0,2.4-.3,4.4-.7,7-.5Z"
          fill="#050975"
        />
        <path
          d="M243.2,171.8c1,0,2,.8,2.9.9s1.5-.4,1.6-.4c0,2.2,2.3,1.3,2.5,1.5s-.8,3.1,2.7,2.5.3-.9.7-1c2.3-.6,4.3,3.4,3.2,5.5-.6,1.3-5.6.2-6-1,.8-.1,5.2-.2,5.5-.5s0-1.1,0-1.5c-2,1-4.5-.9-5.8-1s-1.5.5-2,.5-.5-2.2-1.5-2.4l-1.2,1,.5-2c-1.2,0-2.1.4-3.3,0-1.9-.6.1-1.8-1.7-1.6.7-.2,1.2-.3,2-.5Z"
          fill="#060c5f"
        />
        <path d="M245.2,171.3c2.1-.2.5,1.3-.5,0,.2,0,.3,0,.5,0Z" fill="#060c5f" />
        <path
          d="M250.7,179.8c1.8,1.2,4.1,1.1,6,1s2-.3,3-.5c-.5,3.7.6.8,2.2,1s.2.9.6,1c.8.2,1.7-.2,2.7.3,1.8.8,1.6,3.6,2.1,4.1.7.7,2.2-.4,2.4,1.6-1.1-.7-2.9-1.3-3.8-2.2s-1.1-2.4-2-2.8-3.5-.2-5.2-.6c-2.9-.6-5.7-1.7-8.7-2l.2,1c-1.5-.8-2.3,0-3,0s-.7,0-1,0l-.5-1c1.7-.3,3.3-.7,5-1Z"
          fill="#02136f"
        />
        <path
          d="M238.7,173.3c4.1-.4,3.6,3.7-.3,4.4-1.6,3.2-3.3,3.9-6.6,4.6-.4,1.3-1.1,2.1-2.1,2.4,0,1-1.1,2.3-2,2.5l-.8.5-.2-.5c.6-1.2,3.3-4.7,3.5-5.3s-.7-1.5-1.5-.7c1.6-2.1,3.2-4.4,5.5-6s2.7-.9,3.5-2c.2,0,.3,0,.5,0h.5Z"
          fill="#020948"
        />
        <path
          d="M229.7,184.8h.5c.1,2.1-2.3,3-3,5,.2-.5.2-1.5.5-2.5.5-1.5,1.2-1.7,2-2.5Z"
          fill="#010f5d"
        />
        <path d="M238.7,173.3h-.5c.1-.2.3-.4.5-.5v.5Z" fill="#0218db" />
        <path d="M239.7,175.3c.3.2-.3.8-1,.5s.3-.8,1-.5Z" fill="#040d56" />
        <path d="M236,177.8c.3.2.3.3,0,.5v-.5Z" fill="#040d56" />
        <path
          d="M250.2,183.3c.7.4,1.2.9,1.5,1.5-.6,1-1.1,1.1-2,.5-.1-.1.2-1.4-1.7-1.5l-.3.3c1.2.8.5,1,.5,1.3h-.5l-.5-.5c-.3-.3-.5-.5-1-.5.5-.6,2.3-1.3,3-1.5s.3,0,.5,0c.3,0,.5.2.5.5Z"
          fill="#0242d5"
        />
        <path d="M247.7,185.3h-.5v-.5c.2.2.3.3.5.5Z" fill="#0248e6" />
        <path
          d="M250.7,183.3c1.6.9,4.2.8,6.2,1s2.2-1.1,2.8,1.5c-.4,0-1,0-1.5,0l-.2,1.5c-.5-1.1-1.9-2.1-3-2.5s.3,1.8-3.2,0l-.5,1.5c-.2,0-.4,0-.5,0l-.5-.5c-.2-.2-.3-.3-.5-.5l2-.5c-.4-.2-1.3-.6-1.4-.6-.3-.3,0-.7-.1-.9.2-.2.3-.2.5,0Z"
          fill="#0232cb"
        />
        <path d="M250.7,183.3h-.5c0-.1-.4-.3-.5-.5.4,0,.9,0,1,.5Z" fill="#0233c0" />
        <path d="M153.8,275.3c0-.3,0-.7,0-1h.5c-.1.3,0,.8-.5,1Z" fill="#0933ce" />
        <path d="M167.8,241.8c.1-.3.5-.4.5-.5l-.5.5Z" fill="#0436dc" />
        <path d="M167.3,242.8c.1-.3.5-.5.5-.5l-.5.5Z" fill="#0436dc" />
        <path d="M204.7,153.8c0-.3,0-.7,0-1h.5c-.2.4-.4.8-.5,1Z" fill="#0373f0" />
        <path d="M207.7,146.3l.5-1c-.1.5-.4.8-.5,1Z" fill="#0864de" />
        <path d="M204.2,154.8c0-.2,0-.4,0-.5h.5c0,.2-.3.4-.5.5Z" fill="#0367ef" />
        <path d="M204.2,155.8h-.5c0-.2.3-.4.5-.5,0,.2,0,.3,0,.5Z" fill="#0367ef" />
        <path d="M243.7,190.8c-.5-.1-1.8,1.5-1.5-.5.6-.3,1.4.5,1.5.5Z" fill="#057ef9" />
        <path d="M243.7,192.3l-.5,1c0-.5,0-1,0-1.5.4-.1.4.5.5.5Z" fill="#047bf8" />
        <path d="M244.2,192.3c.2,0,.4,0,.5,0l-.2.5-.2-.5Z" fill="#047bf8" />
        <path
          d="M258.7,192.3c.2-.2.4-.5.5-1,.1-.4.3-.4.5,0,1.8,0,1.9,2.2.4,2.9h.6c.8,0,1.3.2,1.5.6,1.8-1,2.8,0,1.5,1.5-.4.5-.9,1-1.5,1.6.9,1.4.5,3.1-1,1.9-.6,1-2.5,1.3-3,0q-1-.6,0,0c.8.4,1.7.9,2.5,1.5,1.5.2,3,.4,4.5.5,1.1-2.8,2.2,3,.2,3.8-.3,2-1,2.5-2.2,1.7l-.8.5c-1.2-.8-2.5-1-3.7-.5,1.2.3,1.1.6,0,1-1.6-.3-.8-.3-1.5-.5l1-.5c.3-.9-1-.2-1-.8s.5-1,.5-1.2c.2-.9.4-1.2,1-.5q1.2.8,0,0c-.4.2-.8-.1-1-1-.3,0-.4.5-.5.5-.6-.6-1.1-1.9-1-2.7s3.1-1.2-.5-1.3c-.1-.1.5-1,.5-1.5-.4-.3-.6-.3-1,0-.2,0-.4,0-.5,0l-.5-.5c0-.3,0-.7,0-1,.5-.7,1.3-1,2.4-.8v-1.2c-1.2-.2-1.1-.6.1-1q1.2-.2,0,0c-.6.5-1.2.7-2,.5-.4.5-1.1.2-1-.5-.6-1.2.4-1.7,3-1.5,0-1.1-.6-1.5-2-1.2.7-.3,1-.1,1,.7-1.5,2.1-4,.7-2-1.5-.2-.7.5-.9,1-.5.3-.7,1-1.2,2-1.5-.4-.1-.4-.3,0-.5,1.8-1.3,4.6,1.4,1.9,3.1v.9Z"
          fill="#035ef6"
        />
        <path
          d="M254.7,194.8c1-.3,1.6,0,2,.5.2,0,2.4,2.2,3,2.5-.9-.3-2.1.6-2.7.5s-.2-.9-.6-1-1.6.5-2.2,0c-.1-1.3.8-1.7-1.5-2.5-.6-.7-.3-.9.5-.5.1,0,.4,0,.5,0,.4.3.9.4,1,.5Z"
          fill="#0268f8"
        />
        <path d="M256.2,198.8c-.3,0-.7,0-1,0,.2-.7.9-.7,1,0Z" fill="#0268f8" />
        <path
          d="M263.7,196.3c-.2-1.2.1-1.3,1-.5.3-.7.6-.7,1,0v.5c.3.2.3.3,0,.5-1.3,1.8-4.8,3.3-.5,5-1.2,1.3-3.7,1.3-4.5-.5-.5-.1-.4-.3,0-.5l.5-.5c-.4-.1-.4-.3,0-.5.2-.2.8-.4,1-.8l-1.5-.3c.1-1.5,1.8-1.9,1-3,.7-.2,1.4.5,2,.5Z"
          fill="#0252f2"
        />
        <path
          d="M259.7,191.3c-.9.5-.4-1.5-.1-1.8,1.1-1.3,3.6,1,3.6,2.3-.1.4-.3.4-.5,0,1.2,2.1,1.2,2.8,0,2-.2.6-.9.8-2,.5-.6.3-.7,1.6-2.5,1,1.4-1.9,2.8-1.2,1.5-4Z"
          fill="#0253f1"
        />
        <path
          d="M258.2,199.8c-2.5,0-2.2-1.2,0-1,0,.3,0,.7,0,1,1,0,2.3-.5,3,0,0,0,0,.4,0,.5l-.5.5c0,.2,0,.4,0,.5-2.1.5-2.4.4-2.5-1.5Z"
          fill="#0373f7"
        />
        <path
          d="M258.7,204.8c.7-.9.4-2.1,1.5-2.5,0,.4.5,2.8.4,2.9-.2.2-1.8.7-1.9.6s.1-.8,0-1Z"
          fill="#0345f3"
        />
        <path
          d="M256.7,194.3c0,.2,0,.7,0,1-.4,0-1.3.6-1.7.5s-.2-1-.3-1c-.3-1.8.8-.7,2-.5Z"
          fill="#0374f9"
        />
        <path d="M256.7,194.3c.4-.8,1.1-.5,2-.5-.6,1.6-1.3.6-2,.5Z" fill="#0374f9" />
        <path d="M258.7,204.8c-.1.2-.8.3-1,.5.1-.4,0-1,0-1.5.6,0,.8.6,1,1Z" fill="#0374f9" />
        <path d="M264.2,205.3c.5.5-.4,1.5-1,1s.4-1.5,1-1Z" fill="#0339ee" />
        <path
          d="M255.7,192.3c-.6-.3-2.5.1-1.5-1s3.3-1.7,3.5-1.5c-1,.9.1,2.9,0,3s-.8,0-1,0c-.3-.2-.7-.3-1-.5Z"
          fill="#024df4"
        />
        <path d="M259.2,191.3v1.5s-.5-.5-.5-.5c0-.5.2-.7.5-1Z" fill="#0253f1" />
        <path
          d="M248.2,185.3c-2.6-2.7,3.2-2.4,1.5,0,.3,0,.5.1.5.5l.5.5c.2-.4.3-.4.5,0,.3-.7,3.8-.4,4.6-.2s1.4,1.6.9,2.2v.5c-.6.9-1.5.7-2.5-.5-.3,0-1,.7-1.5.5-.3-.6,2.2-.6,1-1.5-1.8-1.3-3.1,1.4-3.3,1.5-.8.2-1.1-.9-1.2-1-.3,0-.5-.3-.5-.5-.6,0-.9-.4-.5-1-.9-.2-.8-.6,0-1Z"
          fill="#0251e5"
        />
        <path
          d="M256.7,188.8c-.3,1-1.3,1.1-2,1.5.7-.8.4-1.1-.5-1.5v-.5c1,0,1.6,1.3,2.5.5Z"
          fill="#0248e6"
        />
        <path d="M248.7,187.3c-.3,0-.7,0-1,0-.2-.6.5-.9.5-1l.5,1Z" fill="#0248e6" />
        <path d="M250.7,187.8c-1,.1-1.1,0-1-1l1,1Z" fill="#0248e6" />
        <path d="M250.7,186.3l-.5-.5c.1.2.4.4.5.5Z" fill="#0248e6" />
        <path
          d="M249.2,194.8c1,2.2-1.1.9-2.5,1,.5-1.1,1.6-.5,1.2-2,.2.4,1.2.9,1.3,1Z"
          fill="#035cf2"
        />
        <path d="M245.7,193.3l-.5,1c-.2.5-.6.2-1,0-.3-1.6.6-.7,1.5-1Z" fill="#0355f7" />
        <path d="M245.2,194.3c.3.1.3.3.5.5h-1c0-.1-.5-.3-.5-.5.3,0,.8,0,1,0Z" fill="#047bf8" />
        <path d="M246.2,192.8c-.1,0-.6,0-.5-.5.3,0,.6.2.5.5Z" fill="#047bf8" />
        <path d="M244.2,195.3c.1,0,.4,0,.5,0l-.2.5-.2-.5Z" fill="#047bf8" />
        <path
          d="M-15.6,164.3c4.6,1.2,3.6,5,0,4.5,1.4,6,1.4,12,0,18v2c1,4.7,1,9.3,0,14,1,1.5,1,3,0,4.5.4,0,.4.3,0,.5v1.5c1,.3,1,.7,0,1,.4.8.4,1.7,0,2.5.7,1.7.8,4.4,0,6l1,.7c0,1.6,0,2.4,1.8,2.3-.3-3.5,4-5.3,5.6-2.5.7.3.9.8.7,1.4,3.5,0,3.2,2.6.4,3.9l1.4,2.4c-2,2.9-1.7,3,.8.3l2.8-1.1c-1-2.1-.9-4.4,2-4.3,6-6.3,5.1,12.1.3,11.4v1.6c.5,3.1,1,8.1-3.4,5.5,1.7,5.1,1.5,11.9,0,17,1.6,2.1,2.3,4.1,2,5.9-4,1.3-.9,1.3,1.4.5,0,3.4,0,6.9.2,10.4,2.5,9-6,5.2-4.4-2.2l-1.6,1.3c.4,3.2-1.7,6.9-5,5.9,0-.3,0-.7,0-1-.7-.4-4.3,2.4-4.4,2.6-1,1.7,2.9,7.4-.6,7.9v-8h-1v19.7c0,0,.7.8,1,.7v-8.5c1.3-.4,1.4,1.3,1.5,2.2.5,6,0,13.1-.5,19s1.4,2.7-1,2.7v-8c-1.9-.4-.4,2.1-1.5,3v-149.4c.1-.4.3-.4.5,0,.9.2.7,1.6,0,2Z"
          fill="#fefefd"
        />
      </g>
    </svg>
  );
};

export const PathfinderOnlyIcon: React.FC<IconSvgProps> = ({ size, width, height, ...props }) => {
  return (
    <svg
      height={size || height}
      viewBox="277.89 327.24 425.49 425.53"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M698.66,495.58c-11.86-55.56-44.66-103.17-92.33-134.07-47.68-30.9-104.52-41.37-160.09-29.51-55.56,11.87-103.18,44.65-134.08,92.33-30.89,47.68-41.38,104.53-29.51,160.09,11.86,55.56,44.66,103.17,92.33,134.07,34.88,22.6,74.65,34.28,115.25,34.28,14.91,0,29.92-1.58,44.84-4.76,114.7-24.49,188.08-137.73,163.59-252.43ZM540.85,703.96c-.12.12-.26.24-.39.35-1.75,1.42-4.23,1.51-6.08.23l-43.74-30.28-43.74,30.28c-1.85,1.28-4.33,1.19-6.08-.23-1.75-1.42-2.36-3.82-1.49-5.9l46.63-111.19c.8-1.88,2.63-3.11,4.68-3.11,2.04,0,3.89,1.23,4.68,3.11l46.63,111.19c.8,1.92.35,4.11-1.09,5.55ZM632.66,650.8c-1.22-2.28-2.41-4.26-3.46-5.88-23.65-36.48-57.02-42.22-113.37-77.03-69.29-42.81,49.84-70.12,80.74-89.07,65.91-41.18-85.7-27.38-104.45-30.35-10.09-.36-21.04-1.78-22.3-6.59-3.2-12.21,59.45-33.34,56.6-46.35-1.78-8.13-25.74-10.59-40.91-9.01-8.48.89-17.09,3.34-16.97,4.75.07.83,3.1,1.12,14.92,3.12,10.3,1.74,11.7,2.13,11.99,3.11,1.13,3.79-13.45,11.19-19.96,14.57-38.43,19.89-65.16,33.73-64.52,41.89.48,6.06,16.41,13.42,87.94,18.27,20.67,3.58,1.46,12.08-7.03,16.02-225.77,76.94-86.61,103.74-89.66,142.03-1.21,15.12-19.09,26.5-40.97,35.05-22.81-23.47-39.53-53.38-46.86-87.68-20.75-97.19,41.43-193.13,138.62-213.89,12.64-2.7,25.25-3.99,37.67-3.99,83.19,0,158.16,58.06,176.21,142.61,11.56,54.13-2.63,107.85-34.25,148.44Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const AppsLogo: React.FC<IconSvgProps> = ({ size, width, height, ...props }) => {
  return (
    <svg
      height={size || height}
      viewBox="0 0 1254.1 425.5"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="M528.9,182.6c-8.9-6.6-13.6-16-14.3-28.2h35.2c.3,4.2,1.6,7.2,3.7,9.1,2.1,1.9,4.9,2.9,8.2,2.9s5.5-.8,7.5-2.3c2-1.5,2.9-3.6,2.9-6.3s-1.6-6.2-4.9-8.1c-3.3-1.9-8.5-4-15.8-6.4-7.7-2.6-14-5.1-18.8-7.5-4.8-2.4-8.9-5.9-12.5-10.6-3.5-4.7-5.3-10.7-5.3-18.3s1.9-14.2,5.7-19.6c3.8-5.4,9.1-9.6,15.8-12.4,6.7-2.8,14.4-4.2,22.9-4.2,13.8,0,24.8,3.2,33.1,9.7,8.2,6.5,12.6,15.5,13.2,27.2h-35.9c-.1-3.6-1.2-6.3-3.3-8.1-2.1-1.8-4.7-2.7-8-2.7s-4.5.7-6.1,2.2c-1.6,1.5-2.4,3.5-2.4,6.2s.9,4.2,2.6,5.8c1.7,1.6,3.9,3,6.5,4.2,2.6,1.2,6.4,2.7,11.4,4.5,7.5,2.6,13.7,5.1,18.6,7.7,4.9,2.5,9.1,6.1,12.6,10.6,3.5,4.5,5.3,10.3,5.3,17.3s-1.8,13.4-5.3,19c-3.5,5.6-8.6,10-15.3,13.3-6.7,3.3-14.6,4.9-23.6,4.9-13.8,0-25.1-3.3-34-9.8Z"
          fill="currentColor"
        />
        <path
          d="M632.6,186.6c-7.5-3.9-13.3-9.5-17.6-16.8-4.3-7.3-6.4-15.9-6.4-25.8s2.2-18.3,6.5-25.6c4.3-7.3,10.2-12.9,17.7-16.8,7.5-3.9,15.9-5.9,25.3-5.9s17.9,2,25.3,5.9c7.5,3.9,13.4,9.5,17.7,16.8,4.3,7.3,6.5,15.8,6.5,25.6s-2.2,18.3-6.5,25.7c-4.3,7.4-10.2,13-17.8,16.9-7.5,3.9-16,5.9-25.4,5.9s-17.9-2-25.3-5.9ZM669.5,158.7c3.1-3.4,4.6-8.3,4.6-14.7s-1.5-11.3-4.6-14.6c-3.1-3.4-6.9-5-11.4-5s-8.2,1.7-11.3,5c-3,3.4-4.5,8.2-4.5,14.6s1.5,11.4,4.4,14.8c2.9,3.4,6.7,5,11.3,5s8.4-1.7,11.5-5.1Z"
          fill="currentColor"
        />
        <path d="M745.7,66.7v124.6h-33v-124.6h33Z" fill="currentColor" />
        <path
          d="M852.7,96.9v94.4h-33.2v-13.5c-2.8,4.3-6.7,7.7-11.6,10.4-4.9,2.6-10.6,4-17,4-11,0-19.7-3.6-26-10.9-6.3-7.2-9.5-17.1-9.5-29.5v-54.9h32.8v50.7c0,5.4,1.4,9.6,4.3,12.7,2.9,3.1,6.6,4.6,11.4,4.6s8.6-1.5,11.4-4.6c2.8-3.1,4.2-7.3,4.2-12.7v-50.7h33.2Z"
          fill="currentColor"
        />
        <path
          d="M918.9,163.2v28.1h-14.3c-24.1,0-36.2-12-36.2-35.9v-31.1h-11.6v-27.4h11.6v-22.9h33.2v22.9h17.2v27.4h-17.2v31.6c0,2.6.6,4.4,1.8,5.6,1.2,1.1,3.2,1.7,6,1.7h9.6Z"
          fill="currentColor"
        />
        <path
          d="M928.2,83.3c-3.5-3.2-5.3-7.2-5.3-12s1.8-9,5.3-12.3c3.5-3.3,8.2-4.9,14.1-4.9s10.4,1.6,13.9,4.9c3.5,3.3,5.3,7.4,5.3,12.3s-1.8,8.8-5.3,12c-3.5,3.2-8.2,4.8-13.9,4.8s-10.5-1.6-14.1-4.8ZM958.6,96.9v94.4h-33v-94.4h33Z"
          fill="currentColor"
        />
        <path
          d="M987.6,186.6c-7.5-3.9-13.3-9.5-17.6-16.8-4.3-7.3-6.4-15.9-6.4-25.8s2.2-18.3,6.5-25.6c4.3-7.3,10.2-12.9,17.7-16.8,7.5-3.9,15.9-5.9,25.3-5.9s17.9,2,25.3,5.9c7.5,3.9,13.4,9.5,17.7,16.8,4.3,7.3,6.5,15.8,6.5,25.6s-2.2,18.3-6.5,25.7c-4.3,7.4-10.2,13-17.8,16.9-7.5,3.9-16,5.9-25.4,5.9s-17.9-2-25.3-5.9ZM1024.5,158.7c3.1-3.4,4.6-8.3,4.6-14.7s-1.5-11.3-4.6-14.6c-3.1-3.4-6.9-5-11.4-5s-8.2,1.7-11.3,5c-3,3.4-4.5,8.2-4.5,14.6s1.5,11.4,4.4,14.8c2.9,3.4,6.7,5,11.3,5s8.4-1.7,11.5-5.1Z"
          fill="currentColor"
        />
        <path
          d="M1155.3,106.9c6.4,7.2,9.6,17,9.6,29.4v55h-33v-50.7c0-5.4-1.4-9.6-4.2-12.7-2.8-3.1-6.6-4.6-11.3-4.6s-8.8,1.5-11.6,4.6c-2.8,3.1-4.2,7.3-4.2,12.7v50.7h-33v-94.4h33v13.5c2.9-4.3,6.8-7.7,11.8-10.4,4.9-2.6,10.6-4,17-4,10.9,0,19.5,3.6,25.9,10.9Z"
          fill="currentColor"
        />
        <path
          d="M1192.1,188.2c-6.7-2.9-12-6.8-15.8-11.8-3.9-5-6-10.6-6.5-16.9h32c.4,3,1.9,5.4,4.2,7.1s5.3,2.5,8.8,2.5,4.8-.6,6.4-1.7c1.6-1.1,2.4-2.6,2.4-4.4s-1.3-4.1-3.9-5.2c-2.6-1.1-6.8-2.4-12.8-3.7-6.7-1.3-12.3-2.9-16.8-4.5-4.5-1.7-8.4-4.4-11.7-8.2-3.3-3.8-5-9-5-15.5s1.5-10.7,4.5-15.2c3-4.5,7.5-8.2,13.4-10.9,5.9-2.7,13-4,21.3-4,12.3,0,22,3,29.1,9.1,7.1,6.1,11.2,14,12.3,23.9h-29.8c-.6-3-1.9-5.4-4-7-2.1-1.6-4.9-2.4-8.3-2.4s-4.7.5-6.1,1.5c-1.4,1-2.1,2.4-2.1,4.2s1.3,4,3.9,5.1c2.6,1.2,6.7,2.4,12.5,3.6,6.8,1.5,12.5,3.1,17.1,4.9,4.5,1.8,8.5,4.7,12,8.7,3.4,4,5.1,9.4,5.1,16.2s-1.6,10.4-4.8,14.8c-3.2,4.4-7.7,7.8-13.6,10.4-5.9,2.5-12.8,3.8-20.8,3.8s-16.1-1.4-22.8-4.3Z"
          fill="currentColor"
        />
        <path
          d="M606.9,310.7c-3.3,5.9-8.3,10.6-15,14.1-6.7,3.5-14.8,5.3-24.5,5.3h-16.3v40.1h-33v-118.7h49.3c9.5,0,17.6,1.7,24.3,5,6.7,3.4,11.7,8,15.1,14,3.4,5.9,5,12.8,5,20.5s-1.7,13.7-5,19.6ZM578.2,291.1c0-8.6-4.7-13-14-13h-13.1v25.8h13.1c9.3,0,14-4.3,14-12.8Z"
          fill="currentColor"
        />
        <path
          d="M635.3,365.5c-7.5-3.9-13.3-9.5-17.6-16.8-4.3-7.3-6.4-15.9-6.4-25.8s2.2-18.3,6.5-25.6c4.3-7.3,10.2-12.9,17.7-16.8,7.5-3.9,15.9-5.9,25.3-5.9s17.9,2,25.3,5.9c7.5,3.9,13.4,9.5,17.7,16.8,4.3,7.3,6.5,15.8,6.5,25.6s-2.2,18.3-6.5,25.7c-4.3,7.4-10.2,13-17.8,16.9-7.5,3.9-16,5.9-25.4,5.9s-17.9-2-25.3-5.9ZM672.2,337.6c3.1-3.4,4.6-8.3,4.6-14.7s-1.5-11.3-4.6-14.6c-3.1-3.4-6.9-5-11.4-5s-8.2,1.7-11.3,5c-3,3.4-4.5,8.2-4.5,14.6s1.5,11.4,4.4,14.8c2.9,3.4,6.7,5,11.3,5s8.4-1.7,11.5-5.1Z"
          fill="currentColor"
        />
        <path
          d="M761.8,279.6c5.3-3.1,10.9-4.7,17-4.7v35.2h-9.3c-7.2,0-12.5,1.4-16,4.2-3.5,2.8-5.2,7.7-5.2,14.6v41.2h-33v-94.4h33v16.7c3.7-5.4,8.2-9.6,13.5-12.8Z"
          fill="currentColor"
        />
        <path
          d="M837.9,342.1v28.1h-14.3c-24.1,0-36.2-12-36.2-35.9v-31.1h-11.6v-27.4h11.6v-22.9h33.2v22.9h17.2v27.4h-17.2v31.6c0,2.6.6,4.4,1.8,5.6,1.2,1.1,3.2,1.7,6,1.7h9.6Z"
          fill="currentColor"
        />
        <path
          d="M844.6,297.3c3.5-7.3,8.4-12.9,14.5-16.8,6.1-3.9,12.9-5.9,20.4-5.9s12.1,1.3,16.8,3.9c4.7,2.6,8.4,6.1,10.9,10.4v-13.1h33v94.4h-33v-13.1c-2.6,4.4-6.3,7.9-11,10.4-4.8,2.6-10.4,3.9-16.7,3.9s-14.3-2-20.4-5.9c-6.1-3.9-10.9-9.6-14.5-16.9-3.5-7.3-5.3-15.9-5.3-25.7s1.8-18.3,5.3-25.6ZM902.3,308.6c-3.3-3.5-7.4-5.2-12.2-5.2s-9,1.7-12.3,5.1c-3.3,3.4-4.9,8.2-4.9,14.4s1.6,10.9,4.9,14.4c3.3,3.5,7.3,5.3,12.3,5.3s8.9-1.7,12.2-5.2c3.3-3.5,5-8.3,5-14.5s-1.7-10.8-5-14.3Z"
          fill="currentColor"
        />
        <path d="M983.7,245.6v124.6h-33v-124.6h33Z" fill="currentColor" />
        <path
          d="M343.1,44.6C250.3-27.4,116.6-10.5,44.6,82.4-27.4,175.2-10.5,308.9,82.4,380.9c92.8,72,226.5,55.1,298.5-37.7,72-92.8,55.1-226.5-37.7-298.5ZM336,74.4c3.9,3.4,7.8,7,11.5,10.9,27.8,28.9,42.8,65.6,45.2,102.7h0s0,0,0,0c0,0,0,0,0,0-6.7-25.2-20.7-48.8-42-67.5-48.9-43.1-123.2-45.3-174.4-4.9-26.7,21-43.3,49.4-49.6,79.7.4-42.3,17.3-84.4,50.3-116,.3-.3.4-.4.7-.6,43.6-41.4,112.6-43.4,158.3-4.2ZM253.9,159.6c29.3,22.7,34.7,65,11.9,94.3-22.7,29.3-65,34.7-94.3,11.9-29.3-22.7-34.7-65-11.9-94.3,22.7-29.3,65-34.7,94.3-11.9ZM113.2,59.8c4.3-2.9,8.8-5.8,13.5-8.3,35.1-19.5,74.5-24.7,111-17.5-26,0-52.4,7.6-76.1,23.4-54.2,36.3-75.2,107.5-49.3,167.3,13.5,31.2,36.7,54.5,64.4,68.3-40.8-11.3-77.2-38.3-99.4-78.3-.1-.3-.3-.6-.4-.8-28.9-52.7-13.2-120,36.4-154.1ZM38.7,260c-1.4-5-2.6-10.2-3.6-15.4-7.3-39.4.3-78.3,18.8-110.7,0,0,0,0,0-.1h0c0,0,0,.1,0,.1-8.2,24.6-9.5,52-2.1,79.4,17.1,62.9,77.9,105.6,142.9,100.1,33.9-2.8,63.4-17.4,85.3-39.3-23.7,35.1-60.9,60.9-105.9,69.2-.3,0-.6.1-.9.2-59.2,10.6-117.9-25.8-134.4-83.6ZM206.4,394.5c-5.2-.2-10.5-.6-15.8-1.3-39.8-5.3-74.5-24.5-99.5-52.2h0c20.9,15.4,46.6,25.1,75,26.5,65.1,3.3,124.5-41.5,139.4-104.9,7.8-33.1,3-65.6-11-93.2,26,33.3,39.1,76.8,33.1,122.1,0,.3,0,.6-.1.9-8.3,59.5-61,104.2-121.1,102ZM379.8,291.8c-17.5,36.1-46.6,63-80.7,78.2h0c21.2-15.1,38.5-36.4,48.7-63,23.4-60.9-.4-131.2-56-165.2-29-17.7-61.4-23.4-92-18.7,39.8-14.3,85.2-13.1,126.3,6.8.3.1.6.3.9.4,54,26.5,79.8,90.5,59,146.9-1.8,4.9-3.9,9.8-6.2,14.6Z"
          fill="currentColor"
        />
        <path
          d="M179.1,258.7l33.6-23.3,33.6,23.3c1.4,1,3.3.9,4.7-.2.1,0,.2-.2.3-.3,1.1-1.1,1.5-2.8.8-4.3l-35.8-85.4c-.6-1.4-2-2.4-3.6-2.4-1.6,0-3,.9-3.6,2.4l-35.8,85.4c-.7,1.6-.2,3.4,1.1,4.5,1.3,1.1,3.2,1.2,4.7.2Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const SolutionsLogo: React.FC<IconSvgProps> = ({ size, width, height, ...props }) => {
  return (
    <svg
      height={size || height}
      viewBox="0 0 1364.2 425.5"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="M551.3,134.6v39.9h-33.2V55.3h49.5c14.4,0,25.3,3.6,32.9,10.9s11.4,16.9,11.4,29-1.7,14.3-5,20.2c-3.4,5.9-8.4,10.6-15.1,14.1-6.7,3.4-14.7,5.1-24.2,5.1h-16.3ZM578.4,95.2c0-8.8-4.8-13.1-14.5-13.1h-12.6v26.4h12.6c9.6,0,14.5-4.4,14.5-13.3Z"
          fill="currentColor"
        />
        <path
          d="M668.7,83.2c4.9,2.9,8.5,6.8,10.9,11.9v-15h33v94.4h-33v-15c-2.4,5-6,9-10.9,11.9s-10.6,4.3-17.3,4.3-14.3-1.9-20.4-5.8c-6.1-3.9-10.8-9.5-14.3-16.8-3.5-7.3-5.2-16-5.2-25.8s1.7-18.5,5.2-25.8c3.5-7.3,8.2-12.9,14.3-16.7,6.1-3.9,12.8-5.8,20.4-5.8s12.4,1.4,17.3,4.3ZM649.8,113c-3.2,3.4-4.8,8.2-4.8,14.2s1.6,11,4.8,14.4c3.2,3.4,7.4,5.1,12.5,5.1s9-1.7,12.3-5.2c3.3-3.5,4.9-8.2,4.9-14.3s-1.6-10.7-4.9-14.1c-3.3-3.5-7.4-5.2-12.3-5.2s-9.3,1.7-12.5,5.1Z"
          fill="currentColor"
        />
        <path
          d="M778.5,146.2v28.3h-13.6c-11.6,0-20.6-2.9-27.1-8.6-6.5-5.7-9.8-15.2-9.8-28.4v-29.8h-12.1v-27.6h12.1v-22.9h33.2v22.9h17v27.6h-17v30.5c0,2.9.6,5,1.9,6.2,1.3,1.2,3.5,1.9,6.5,1.9h8.9Z"
          fill="currentColor"
        />
        <path
          d="M873.9,90.1c6.2,7.2,9.3,17.1,9.3,29.5v54.9h-32.8v-50.7c0-5.5-1.4-9.8-4.3-12.9-2.9-3.1-6.7-4.6-11.5-4.6s-8.9,1.6-11.8,4.8c-2.9,3.2-4.4,7.6-4.4,13.2v50.2h-33.2V49.9h33.2v45.9c2.7-5,6.6-9.1,11.8-12.1,5.2-3,11.2-4.5,18.2-4.5,10.9,0,19.4,3.6,25.6,10.9Z"
          fill="currentColor"
        />
        <path
          d="M941.1,70.1c-3.9,0-6.8.8-8.6,2.3-1.8,1.5-2.9,4.1-3.2,7.7h15.3v27.6h-15.5v66.8h-33.2v-66.8h-10.8v-27.6h10.8c0-12.1,3.6-21.5,10.8-28.2,7.2-6.7,17.5-10,31-10s3.8.1,6.9.3v28.1c-.8-.1-2-.2-3.5-.2Z"
          fill="currentColor"
        />
        <path
          d="M950.2,41.8c3.6-3.2,8.3-4.8,14.1-4.8s10.5,1.6,14,4.8c3.5,3.2,5.2,7.3,5.2,12.2s-1.8,8.6-5.3,11.8c-3.5,3.1-8.2,4.7-13.9,4.7s-10.5-1.6-14.1-4.7c-3.6-3.1-5.4-7.1-5.4-11.8s1.8-9,5.4-12.2ZM980.6,80.1v94.4h-33.2v-94.4h33.2Z"
          fill="currentColor"
        />
        <path
          d="M1079.3,90.1c6.2,7.2,9.3,17.1,9.3,29.5v54.9h-32.8v-50.7c0-5.5-1.4-9.8-4.3-12.9-2.9-3.1-6.7-4.6-11.5-4.6s-8.9,1.6-11.8,4.8c-2.9,3.2-4.4,7.6-4.4,13.2v50.2h-33.2v-94.4h33.2v15.8c2.7-5,6.6-9.1,11.8-12.1,5.2-3,11.2-4.5,18.2-4.5,10.9,0,19.4,3.6,25.6,10.9Z"
          fill="currentColor"
        />
        <path
          d="M1150,83.2c4.8,2.9,8.4,6.8,10.8,11.9v-45.1h33.2v124.6h-33.2v-15c-2.4,5-5.9,9-10.8,11.9-4.8,2.9-10.5,4.3-17.2,4.3s-14.3-1.9-20.4-5.8c-6.1-3.9-10.8-9.5-14.3-16.8-3.5-7.3-5.2-16-5.2-25.8s1.7-18.5,5.2-25.8c3.5-7.3,8.2-12.9,14.3-16.7,6.1-3.9,12.8-5.8,20.4-5.8s12.3,1.4,17.2,4.3ZM1131.2,113c-3.2,3.4-4.8,8.2-4.8,14.2s1.6,11,4.8,14.4c3.2,3.4,7.4,5.1,12.5,5.1s9-1.7,12.3-5.2c3.3-3.5,4.9-8.2,4.9-14.3s-1.6-10.7-4.9-14.1c-3.3-3.5-7.4-5.2-12.3-5.2s-9.3,1.7-12.5,5.1Z"
          fill="currentColor"
        />
        <path
          d="M1293.5,133.3h-62.4c.6,10.7,5.2,16,14,16s5.9-.8,8.1-2.4c2.1-1.6,3.6-3.6,4.4-6.2h35c-1.2,6.6-4,12.6-8.2,17.9-4.3,5.3-9.7,9.5-16.2,12.5-6.5,3-13.6,4.5-21.4,4.5s-17.8-1.9-25-5.8c-7.2-3.9-12.9-9.5-16.9-16.8-4-7.3-6.1-16-6.1-25.8s2-18.5,6.1-25.8c4-7.3,9.7-12.9,17-16.7,7.3-3.9,15.6-5.8,24.9-5.8s17.7,1.9,24.9,5.7c7.2,3.8,12.8,9.3,16.7,16.3,4,7.1,6,15.3,6,24.6s-.3,4.9-.8,7.7ZM1256.8,108.5c-2.7-2.5-6.1-3.7-10.1-3.7s-7.9,1.2-10.7,3.7c-2.8,2.5-4.4,6.1-4.8,10.9h29.5c.1-4.8-1.2-8.5-3.9-10.9Z"
          fill="currentColor"
        />
        <path
          d="M1346.4,84.3c5.6-3.4,11.6-5,17.8-5v35.3h-9.6c-7.4,0-13,1.4-16.7,4.3s-5.6,7.8-5.6,14.9v40.7h-33.2v-94.4h33.2v17.7c3.7-5.6,8.4-10.1,14-13.5Z"
          fill="currentColor"
        />
        <path
          d="M551.3,303.5v39.9h-33.2v-119.2h49.5c14.4,0,25.3,3.6,32.9,10.9s11.4,16.9,11.4,29-1.7,14.3-5,20.2c-3.4,5.9-8.4,10.6-15.1,14.1-6.7,3.4-14.7,5.1-24.2,5.1h-16.3ZM578.4,264.1c0-8.8-4.8-13.1-14.5-13.1h-12.6v26.4h12.6c9.6,0,14.5-4.4,14.5-13.3Z"
          fill="currentColor"
        />
        <path d="M649.6,218.8v124.6h-33.2v-124.6h33.2Z" fill="currentColor" />
        <path
          d="M711.8,252.1c4.9,2.9,8.5,6.8,10.9,11.9v-15h33v94.4h-33v-15c-2.4,5-6,9-10.9,11.9s-10.6,4.3-17.3,4.3-14.3-1.9-20.4-5.8c-6.1-3.9-10.8-9.5-14.3-16.8-3.5-7.3-5.2-16-5.2-25.8s1.7-18.5,5.2-25.8c3.5-7.3,8.2-12.9,14.3-16.7,6.1-3.9,12.8-5.8,20.4-5.8s12.4,1.4,17.3,4.3ZM692.9,281.9c-3.2,3.4-4.8,8.2-4.8,14.2s1.6,11,4.8,14.4c3.2,3.4,7.4,5.1,12.5,5.1s9-1.7,12.3-5.2c3.3-3.5,4.9-8.2,4.9-14.3s-1.6-10.7-4.9-14.1c-3.3-3.5-7.4-5.2-12.3-5.2s-9.3,1.7-12.5,5.1Z"
          fill="currentColor"
        />
        <path
          d="M792.1,249l20.2,52.8,18.7-52.8h36.7l-59.8,139.5h-36.4l23.1-49.1-39.4-90.4h36.9Z"
          fill="currentColor"
        />
        <path
          d="M948.7,253.6c6.1,3.9,10.8,9.5,14.3,16.7,3.5,7.3,5.2,15.9,5.2,25.8s-1.7,18.5-5.2,25.8c-3.5,7.4-8.2,13-14.3,16.8-6.1,3.9-12.8,5.8-20.4,5.8s-12.3-1.4-17.2-4.3c-4.8-2.9-8.4-6.8-10.8-11.9v15h-33.2v-124.6h33.2v45.1c2.4-5,5.9-9,10.8-11.9,4.8-2.9,10.5-4.3,17.2-4.3s14.3,1.9,20.4,5.8ZM905.1,282c-3.3,3.5-4.9,8.2-4.9,14.1s1.6,10.8,4.9,14.3c3.3,3.5,7.3,5.2,12.3,5.2s9.3-1.7,12.5-5.1c3.2-3.4,4.8-8.2,4.8-14.4s-1.6-10.8-4.8-14.2c-3.2-3.4-7.4-5.1-12.5-5.1s-9,1.7-12.3,5.2Z"
          fill="currentColor"
        />
        <path
          d="M1043,253.6c7.5,3.9,13.3,9.5,17.6,16.8,4.3,7.4,6.4,15.9,6.4,25.7s-2.1,18.5-6.4,25.8c-4.3,7.3-10.1,12.9-17.6,16.8-7.5,3.9-15.9,5.9-25.3,5.9s-17.9-2-25.4-5.9c-7.5-3.9-13.4-9.5-17.7-16.8-4.3-7.3-6.4-15.9-6.4-25.8s2.1-18.5,6.4-25.8c4.3-7.3,10.2-12.9,17.7-16.7,7.5-3.9,16-5.8,25.4-5.8s17.9,1.9,25.3,5.8ZM1006.2,281.5c-3,3.4-4.5,8.2-4.5,14.6s1.5,11.4,4.5,14.8c3,3.4,6.8,5,11.4,5s8.2-1.7,11.3-5.1c3-3.4,4.5-8.3,4.5-14.7s-1.5-11.3-4.5-14.6c-3-3.4-6.8-5-11.3-5s-8.4,1.7-11.4,5Z"
          fill="currentColor"
        />
        <path
          d="M1141.8,253.6c7.5,3.9,13.3,9.5,17.6,16.8,4.3,7.4,6.4,15.9,6.4,25.7s-2.1,18.5-6.4,25.8c-4.3,7.3-10.1,12.9-17.6,16.8-7.5,3.9-15.9,5.9-25.3,5.9s-17.9-2-25.4-5.9c-7.5-3.9-13.4-9.5-17.7-16.8-4.3-7.3-6.4-15.9-6.4-25.8s2.1-18.5,6.4-25.8c4.3-7.3,10.2-12.9,17.7-16.7,7.5-3.9,16-5.8,25.4-5.8s17.9,1.9,25.3,5.8ZM1105,281.5c-3,3.4-4.5,8.2-4.5,14.6s1.5,11.4,4.5,14.8c3,3.4,6.8,5,11.4,5s8.2-1.7,11.3-5.1c3-3.4,4.5-8.3,4.5-14.7s-1.5-11.3-4.5-14.6c-3-3.4-6.8-5-11.3-5s-8.4,1.7-11.4,5Z"
          fill="currentColor"
        />
        <path
          d="M1229.6,343.4l-25.8-39v39h-33.2v-124.6h33.2v66.8l25.9-36.7h38.5l-36.7,47.3,37.7,47.1h-39.7Z"
          fill="currentColor"
        />
        <path
          d="M212.7,0C95.3,0,0,95.2,0,212.7c0,117.5,95.3,212.7,212.7,212.7,117.5,0,212.7-95.3,212.7-212.7C425.5,95.2,330.2,0,212.7,0ZM212.7,393c-99.5,0-180.3-80.7-180.3-180.2,0-99.5,80.7-180.2,180.3-180.2,99.5,0,180.2,80.7,180.2,180.2,0,99.5-80.7,180.2-180.2,180.2Z"
          fill="currentColor"
        />
        <path
          d="M190.9,194.7l12.5,18-8.8,12.7-18.4,26.6c-4.6,6.6-11,11.8-18.4,14.9l-50.4,21.2c-2.8,1.2-6,.5-8.2-1.6-.2-.2-.4-.4-.5-.6-2.1-2.6-2.2-6.2-.3-8.9l35.7-51.6,8.8-12.7-12.5-18h0l-32-46.2c-1.9-2.7-1.7-6.4.4-8.9,2.1-2.6,5.6-3.5,8.7-2.2l50.4,21.1h0c7.4,3.1,13.8,8.3,18.4,14.9l14.7,21.3h0Z"
          fill="currentColor"
        />
        <path
          d="M356.4,212.7h0c0,1.6-.5,3-1.3,4.2-.8,1.2-1.9,2.1-3.3,2.7l-163.4,68.5c-2.8,1.2-6,.5-8.2-1.6-.2-.2-.4-.4-.5-.6-1.8-2.3-2.2-5.4-.9-8,.2-.3.4-.7.6-1l24-34.7,11.7-16.8,8.8-12.7-12.5-18h0l-7.9-11.5-24.1-34.8c-.2-.3-.4-.7-.6-1-1.3-2.6-.9-5.7.9-7.9,2.1-2.6,5.6-3.5,8.7-2.2l50.4,21.1,35.4,14.8h0s77.5,32.5,77.5,32.5c.1,0,.2.2.4.2,2.5,1.3,4.2,3.8,4.2,6.6Z"
          fill="currentColor"
        />{" "}
      </g>
    </svg>
  );
};

export const Logo: React.FC<IconSvgProps> = ({ size = 60, height, ...props }) => (
  <svg
    height={size || height}
    viewBox="277.89 324.28 1153.53 425.48"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        d="M490.63,324.28c-117.51,0-212.74,95.24-212.74,212.74,0,117.51,95.24,212.74,212.74,212.74,117.51,0,212.74-95.24,212.74-212.74,0-117.5-95.24-212.74-212.74-212.74ZM490.63,717.22c-99.56,0-180.27-80.7-180.27-180.2,0-99.56,80.7-180.26,180.27-180.26,99.56,0,180.26,80.7,180.26,180.26,0,99.5-80.7,180.2-180.26,180.2Z"
        fill="currentColor"
      />
      <path
        d="M608.56,639.22l-107.15-255.58c-1.84-4.32-6.1-7.16-10.78-7.16-4.68,0-8.94,2.84-10.78,7.16l-107.15,255.58c-1.99,4.82-.64,10.35,3.4,13.62,4.04,3.26,9.72,3.47,13.97.5l76.66-53.04v-58.79c0-1.7.21-3.47.64-5.25,1.99-8.65,8.72-15.03,16.81-17.16,3.48-.85,12.99-.12,13.55,0,5.44,1.17,15.74,7.09,15.74,15.74v64.74s77.72,53.75,77.72,53.75c4.25,2.98,9.93,2.76,13.97-.5.28-.28.64-.57.92-.85,3.26-3.33,4.33-8.37,2.48-12.76ZM489.99,513.06c-12.91-.07-23.33-10.57-23.26-23.47.07-12.91,10.57-23.33,23.47-23.26,12.91.07,23.33,10.56,23.26,23.47-.07,12.91-10.57,23.33-23.47,23.26Z"
        fill="currentColor"
      />
    </g>
    <text
      fill="currentColor"
      style={{
        color: "currentColor",
        fontFamily: "Poppins",
        fontSize: "130px",
        fontWeight: "300",
      }}
      transform="translate(786.58 493.14)"
    >
      <tspan x="0" y="40">
        Pathway
      </tspan>
      <tspan fill="currentColor" style={{ fontSize: "90px", fontWeight: "400" }} x="0" y="180">
        WeBuild-AI
      </tspan>
    </text>
  </svg>
);

export const TwitterIcon: React.FC<IconSvgProps> = ({ size = 24, width, height, ...props }) => {
  return (
    <svg height={size || height} viewBox="0 0 24 24" width={size || width} {...props}>
      <path
        d="M19.633 7.997c.013.175.013.349.013.523 0 5.325-4.053 11.461-11.46 11.461-2.282 0-4.402-.661-6.186-1.809.324.037.636.05.973.05a8.07 8.07 0 0 0 5.001-1.721 4.036 4.036 0 0 1-3.767-2.793c.249.037.499.062.761.062.361 0 .724-.05 1.061-.137a4.027 4.027 0 0 1-3.23-3.953v-.05c.537.299 1.16.486 1.82.511a4.022 4.022 0 0 1-1.796-3.354c0-.748.199-1.434.548-2.032a11.457 11.457 0 0 0 8.306 4.215c-.062-.3-.1-.611-.1-.923a4.026 4.026 0 0 1 4.028-4.028c1.16 0 2.207.486 2.943 1.272a7.957 7.957 0 0 0 2.556-.973 4.02 4.02 0 0 1-1.771 2.22 8.073 8.073 0 0 0 2.319-.624 8.645 8.645 0 0 1-2.019 2.083z"
        fill="currentColor"
      />
    </svg>
  );
};

export const GithubIcon: React.FC<IconSvgProps> = ({ size = 24, width, height, ...props }) => {
  return (
    <svg height={size || height} viewBox="0 0 24 24" width={size || width} {...props}>
      <path
        clipRule="evenodd"
        d="M12.026 2c-5.509 0-9.974 4.465-9.974 9.974 0 4.406 2.857 8.145 6.821 9.465.499.09.679-.217.679-.481 0-.237-.008-.865-.011-1.696-2.775.602-3.361-1.338-3.361-1.338-.452-1.152-1.107-1.459-1.107-1.459-.905-.619.069-.605.069-.605 1.002.07 1.527 1.028 1.527 1.028.89 1.524 2.336 1.084 2.902.829.091-.645.351-1.085.635-1.334-2.214-.251-4.542-1.107-4.542-4.93 0-1.087.389-1.979 1.024-2.675-.101-.253-.446-1.268.099-2.64 0 0 .837-.269 2.742 1.021a9.582 9.582 0 0 1 2.496-.336 9.554 9.554 0 0 1 2.496.336c1.906-1.291 2.742-1.021 2.742-1.021.545 1.372.203 2.387.099 2.64.64.696 1.024 1.587 1.024 2.675 0 3.833-2.33 4.675-4.552 4.922.355.308.675.916.675 1.846 0 1.334-.012 2.41-.012 2.737 0 .267.178.577.687.479C19.146 20.115 22 16.379 22 11.974 22 6.465 17.535 2 12.026 2z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

export const MoonFilledIcon = ({ size = 24, width, height, ...props }: IconSvgProps) => (
  <svg
    aria-hidden="true"
    focusable="false"
    height={size || height}
    role="presentation"
    viewBox="0 0 24 24"
    width={size || width}
    {...props}
  >
    <path
      d="M21.53 15.93c-.16-.27-.61-.69-1.73-.49a8.46 8.46 0 01-1.88.13 8.409 8.409 0 01-5.91-2.82 8.068 8.068 0 01-1.44-8.66c.44-1.01.13-1.54-.09-1.76s-.77-.55-1.83-.11a10.318 10.318 0 00-6.32 10.21 10.475 10.475 0 007.04 8.99 10 10 0 002.89.55c.16.01.32.02.48.02a10.5 10.5 0 008.47-4.27c.67-.93.49-1.519.32-1.79z"
      fill="currentColor"
    />
  </svg>
);

export const SunFilledIcon = ({ size = 24, width, height, ...props }: IconSvgProps) => (
  <svg
    aria-hidden="true"
    focusable="false"
    height={size || height}
    role="presentation"
    viewBox="0 0 24 24"
    width={size || width}
    {...props}
  >
    <g fill="currentColor">
      <path d="M19 12a7 7 0 11-7-7 7 7 0 017 7z" />
      <path d="M12 22.96a.969.969 0 01-1-.96v-.08a1 1 0 012 0 1.038 1.038 0 01-1 1.04zm7.14-2.82a1.024 1.024 0 01-.71-.29l-.13-.13a1 1 0 011.41-1.41l.13.13a1 1 0 010 1.41.984.984 0 01-.7.29zm-14.28 0a1.024 1.024 0 01-.71-.29 1 1 0 010-1.41l.13-.13a1 1 0 011.41 1.41l-.13.13a1 1 0 01-.7.29zM22 13h-.08a1 1 0 010-2 1.038 1.038 0 011.04 1 .969.969 0 01-.96 1zM2.08 13H2a1 1 0 010-2 1.038 1.038 0 011.04 1 .969.969 0 01-.96 1zm16.93-7.01a1.024 1.024 0 01-.71-.29 1 1 0 010-1.41l.13-.13a1 1 0 011.41 1.41l-.13.13a.984.984 0 01-.7.29zm-14.02 0a1.024 1.024 0 01-.71-.29l-.13-.14a1 1 0 011.41-1.41l.13.13a1 1 0 010 1.41.97.97 0 01-.7.3zM12 3.04a.969.969 0 01-1-.96V2a1 1 0 012 0 1.038 1.038 0 01-1 1.04z" />
    </g>
  </svg>
);

export const ModelInfoIcon = ({ size = 24, width, height, ...props }: IconSvgProps) => (
  <svg
    aria-hidden="true"
    focusable="false"
    height={size || height}
    role="presentation"
    viewBox="0 0 24 24"
    width={size || width}
    {...props}
  >
    <path
      d="M4 4C4 3.45 4.45 3 5 3H19C19.55 3 20 3.45 20 4V8C20 8.55 19.55 9 19 9H5C4.45 9 4 8.55 4 8V4Z"
      fill="currentColor"
    />
    <path
      d="M4 10C4 9.45 4.45 9 5 9H19C19.55 9 20 9.45 20 10V14C20 14.55 19.55 15 19 15H5C4.45 15 4 14.55 4 14V10Z"
      fill="currentColor"
      opacity="0.7"
    />
    <path
      d="M4 16C4 15.45 4.45 15 5 15H19C19.55 15 20 15.45 20 16V20C20 20.55 19.55 21 19 21H5C4.45 21 4 20.55 4 20V16Z"
      fill="currentColor"
      opacity="0.4"
    />
    <circle cx="7" cy="6" fill="white" r="1" />
    <circle cx="10" cy="6" fill="white" r="1" />
    <circle cx="13" cy="6" fill="white" r="1" />
    <path d="M16 5H18V7H16V5Z" fill="white" />
  </svg>
);

export const HeartFilledIcon = ({ size = 24, width, height, ...props }: IconSvgProps) => (
  <svg
    aria-hidden="true"
    focusable="false"
    height={size || height}
    role="presentation"
    viewBox="0 0 24 24"
    width={size || width}
    {...props}
  >
    <path
      d="M12.62 20.81c-.34.12-.9.12-1.24 0C8.48 19.82 2 15.69 2 8.69 2 5.6 4.49 3.1 7.56 3.1c1.82 0 3.43.88 4.44 2.24a5.53 5.53 0 0 1 4.44-2.24C19.51 3.1 22 5.6 22 8.69c0 7-6.48 11.13-9.38 12.12Z"
      fill="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
  </svg>
);

export const SearchIcon = (props: IconSvgProps) => (
  <svg
    aria-hidden="true"
    fill="none"
    focusable="false"
    height="1em"
    role="presentation"
    viewBox="0 0 24 24"
    width="1em"
    {...props}
  >
    <path
      d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path
      d="M22 22L20 20"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

export const PathwayAgentIcon: React.FC<IconSvgProps> = ({ size = 40, height, ...props }) => (
  <svg
    height={size || height}
    viewBox="277.89 324.28 1153.53 425.48"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        d="M490.63,324.28c-117.51,0-212.74,95.24-212.74,212.74,0,117.51,95.24,212.74,212.74,212.74,117.51,0,212.74-95.24,212.74-212.74,0-117.5-95.24-212.74-212.74-212.74ZM490.63,717.22c-99.56,0-180.27-80.7-180.27-180.2,0-99.56,80.7-180.26,180.27-180.26,99.56,0,180.26,80.7,180.26,180.26,0,99.5-80.7,180.2-180.26,180.2Z"
        fill="currentColor"
      />
      <path
        d="M608.56,639.22l-107.15-255.58c-1.84-4.32-6.1-7.16-10.78-7.16-4.68,0-8.94,2.84-10.78,7.16l-107.15,255.58c-1.99,4.82-.64,10.35,3.4,13.62,4.04,3.26,9.72,3.47,13.97.5l76.66-53.04v-58.79c0-1.7.21-3.47.64-5.25,1.99-8.65,8.72-15.03,16.81-17.16,3.48-.85,12.99-.12,13.55,0,5.44,1.17,15.74,7.09,15.74,15.74v64.74s77.72,53.75,77.72,53.75c4.25,2.98,9.93,2.76,13.97-.5.28-.28.64-.57.92-.85,3.26-3.33,4.33-8.37,2.48-12.76ZM489.99,513.06c-12.91-.07-23.33-10.57-23.26-23.47.07-12.91,10.57-23.33,23.47-23.26,12.91.07,23.33,10.56,23.26,23.47-.07,12.91-10.57,23.33-23.47,23.26Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
